// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"5PPdg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _runtime = require("regenerator-runtime/runtime");
var _client = require("react-dom/client");
var _launchdarklyReactClientSdk = require("launchdarkly-react-client-sdk");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
var _helpers = require("./utils/helpers");
var _opentelemetry = require("./utils/opentelemetry");
const DEV_PORT = "3021";
const isDevelopment = location.host.includes(DEV_PORT);
const isOutdatedBrowser = !window.hasOwnProperty("fetch");
const container = document.getElementById("root");
const root = (0, _client.createRoot)(container);
const renderDom = async (configData)=>{
    const LDProvider = await (0, _launchdarklyReactClientSdk.asyncWithLDProvider)({
        clientSideID: configData.launchDarkly.clientSideID,
        options: {
            streaming: true,
            privateAttributes: [
                "email"
            ]
        },
        context: {
            kind: "multi",
            environment: {
                key: "environment",
                environment: configData.environment || "local",
                // Keep null when getNamespace has no segment (localhost / unmatched host).
                // LD treats null/absent attributes differently from '' (empty string can
                // match targeting rules); do not normalize null → '' here.
                namespace: (0, _helpers.getNamespace)(window.location.hostname),
                hostname: window.location.hostname,
                // Hardcoded app-state/Helm chart name for this repo, matching the
                // `app` attribute cb_pos sets on its equivalent "environment"
                // context (see config/initializers/launch_darkly_client.rb) so LD
                // targeting rules built against that shape apply consistently here.
                app: "pos-frontend"
            }
        },
        reactOptions: {
            useCamelCaseFlagKeys: false
        },
        timeout: 5
    });
    root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)(LDProvider, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _opentelemetry.OpenTelemetryGate), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {
                configData: configData
            })
        })
    }));
};
const localHostStartup = ()=>{
    const configData = require("dc19d0446d9ff948");
    renderDom(configData);
};
const k8sStartup = ()=>{
    try {
        fetch("/config.json").then((response)=>response.json()).then((configData)=>renderDom(configData));
    } catch (error) {
        console.error("Config was not fetched, cannot render app.");
        console.log(`Error: ${error}`);
    }
};
if (isOutdatedBrowser) // POS stations should all be running the app in same Chromium browser using a boot script.
// If a POS cashier is seeing this message, they have booted their machine
// incorrectly, and should reboot with the correct process.
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: "Your Cashiering station is running a browser than cannot support the Cashiering application."
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: "Please reboot your Cashiering station and consult a manager or IT support if the problem persists."
        })
    ]
}));
else if (isDevelopment) localHostStartup();
else k8sStartup();

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","regenerator-runtime/runtime":"51p5Y","react-dom/client":"adGzT","launchdarkly-react-client-sdk":"3xmjG","./App":"b7s8B","./utils/helpers":"epomp","./utils/opentelemetry":"imHyE","dc19d0446d9ff948":"78RhV","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gHQIF":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"i0eXO"}],"i0eXO":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"d8NEQ"}],"d8NEQ":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"a7DyG"}],"a7DyG":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.2.0";

},{}],"51p5Y":[function(require,module,exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
    else Function("r", "regeneratorRuntime = r")(runtime);
}

},{}],"adGzT":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"cy9SD"}],"cy9SD":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"8vQsm"}],"8vQsm":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var Mg = Uf(null), Ng = null, Og = null, Pg = null;
function Qg() {
    Pg = Og = Ng = null;
}
function Rg(a) {
    var b = Mg.current;
    E(Mg);
    a._currentValue = b;
}
function Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function Tg(a, b) {
    Ng = a;
    Pg = Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (Ug = !0), a.firstContext = null);
}
function Vg(a) {
    var b = a._currentValue;
    if (Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Og) {
            if (null === Ng) throw Error(p(308));
            Og = a;
            Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Og = Og.next = a;
    }
    return b;
}
var Wg = null;
function Xg(a) {
    null === Wg ? Wg = [
        a
    ] : Wg.push(a);
}
function Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return Zg(a, d);
}
function Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $g = !1;
function ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return Zg(a, c);
}
function eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function gh(a, b, c, d) {
    var e = a.updateQueue;
    $g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            $g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var jh = (new aa.Component).refs;
function kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = L(), e = lh(a), f = ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = dh(a, f, e);
        null !== b && (mh(b, a, e, d), eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = L(), d = lh(a), e = ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = dh(a, e, d);
        null !== b && (mh(b, a, d, c), eh(b, a, d));
    }
};
function oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function ph(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = Vg(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && nh.enqueueReplaceState(b, b.state, null);
}
function rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = jh;
    ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = Vg(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && nh.enqueueReplaceState(e, e.state, null), gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function uh(a) {
    var b = a._init;
    return b(a._payload);
}
function vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && uh(f) === b.type)) return d = e(b, c.props), d.ref = sh(a, b, c), d.return = a, d;
        d = yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = yh(b.type, b.key, b.props, null, a.mode, c), c.ref = sh(a, null, b), c.return = a, c;
                case wa:
                    return b = zh(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Ah(b, a.mode, c, null), b.return = a, b;
            th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = yh(f.type, f.key, f.props, null, a.mode, h), h.ref = sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Bh = vh(!0), Ch = vh(!1), Dh = {}, Eh = Uf(Dh), Fh = Uf(Dh), Gh = Uf(Dh);
function Hh(a) {
    if (a === Dh) throw Error(p(174));
    return a;
}
function Ih(a, b) {
    G(Gh, b);
    G(Fh, a);
    G(Eh, Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(Eh);
    G(Eh, b);
}
function Jh() {
    E(Eh);
    E(Fh);
    E(Gh);
}
function Kh(a) {
    Hh(Gh.current);
    var b = Hh(Eh.current);
    var c = lb(b, a.type);
    b !== c && (G(Fh, a), G(Eh, c));
}
function Lh(a) {
    Fh.current === a && (E(Eh), E(Fh));
}
var M = Uf(0);
function Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Nh = [];
function Oh() {
    for(var a = 0; a < Nh.length; a++)Nh[a]._workInProgressVersionPrimary = null;
    Nh.length = 0;
}
var Ph = ua.ReactCurrentDispatcher, Qh = ua.ReactCurrentBatchConfig, Rh = 0, N = null, O = null, P = null, Sh = !1, Th = !1, Uh = 0, Vh = 0;
function Q() {
    throw Error(p(321));
}
function Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Xh(a, b, c, d, e, f) {
    Rh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Ph.current = null === a || null === a.memoizedState ? Yh : Zh;
    a = c(d, e);
    if (Th) {
        f = 0;
        do {
            Th = !1;
            Uh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            Ph.current = $h;
            a = c(d, e);
        }while (Th);
    }
    Ph.current = ai;
    b = null !== O && null !== O.next;
    Rh = 0;
    P = O = N = null;
    Sh = !1;
    if (b) throw Error(p(300));
    return a;
}
function bi() {
    var a = 0 !== Uh;
    Uh = 0;
    return a;
}
function ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function di() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(p(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function fi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                N.lanes |= m;
                hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, N.lanes |= f, hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function gi(a) {
    var b = di(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function hi() {}
function ii(a, b) {
    var c = N, d = di(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, Ug = !0);
    d = d.queue;
    ji(ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== P && P.memoizedState.tag & 1) {
        c.flags |= 2048;
        li(9, mi.bind(null, c, d, e, b), void 0, null);
        if (null === R) throw Error(p(349));
        0 !== (Rh & 30) || ni(c, b, e);
    }
    return e;
}
function ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    oi(b) && pi(a);
}
function ki(a, b, c) {
    return c(function() {
        oi(b) && pi(a);
    });
}
function oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function pi(a) {
    var b = Zg(a, 1);
    null !== b && mh(b, a, 1, -1);
}
function qi(a) {
    var b = ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ri.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function si() {
    return di().memoizedState;
}
function ti(a, b, c, d) {
    var e = ci();
    N.flags |= a;
    e.memoizedState = li(1 | b, c, void 0, void 0 === d ? null : d);
}
function ui(a, b, c, d) {
    var e = di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && Wh(d, g.deps)) {
            e.memoizedState = li(b, c, f, d);
            return;
        }
    }
    N.flags |= a;
    e.memoizedState = li(1 | b, c, f, d);
}
function vi(a, b) {
    return ti(8390656, 8, a, b);
}
function ji(a, b) {
    return ui(2048, 8, a, b);
}
function wi(a, b) {
    return ui(4, 2, a, b);
}
function xi(a, b) {
    return ui(4, 4, a, b);
}
function yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return ui(4, 4, yi.bind(null, b, a), c);
}
function Ai() {}
function Bi(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Ci(a, b) {
    var c = di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Di(a, b, c) {
    if (0 === (Rh & 21)) return a.baseState && (a.baseState = !1, Ug = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), N.lanes |= c, hh |= c, a.baseState = !0);
    return b;
}
function Ei(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Qh.transition;
    Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Qh.transition = d;
    }
}
function Fi() {
    return di().memoizedState;
}
function Gi(a, b, c) {
    var d = lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, c);
    else if (c = Yg(a, b, c, d), null !== c) {
        var e = L();
        mh(c, a, d, e);
        Ji(c, b, d);
    }
}
function ri(a, b, c) {
    var d = lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (Hi(a)) Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = Yg(a, b, e, d);
        null !== c && (e = L(), mh(c, a, d, e), Ji(c, b, d));
    }
}
function Hi(a) {
    var b = a.alternate;
    return a === N || null !== b && b === N;
}
function Ii(a, b) {
    Th = Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var ai = {
    readContext: Vg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useInsertionEffect: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useDeferredValue: Q,
    useTransition: Q,
    useMutableSource: Q,
    useSyncExternalStore: Q,
    useId: Q,
    unstable_isNewReconciler: !1
}, Yh = {
    readContext: Vg,
    useCallback: function(a, b) {
        ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: Vg,
    useEffect: vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ti(4194308, 4, yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = Gi.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: qi,
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        return ci().memoizedState = a;
    },
    useTransition: function() {
        var a = qi(!1), b = a[0];
        a = Ei.bind(null, a[1]);
        ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = N, e = ci();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === R) throw Error(p(349));
            0 !== (Rh & 30) || ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        vi(ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        li(9, mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = ci(), b = R.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Zh = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: fi,
    useRef: si,
    useState: function() {
        return fi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = fi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
}, $h = {
    readContext: Vg,
    useCallback: Bi,
    useContext: Vg,
    useEffect: ji,
    useImperativeHandle: zi,
    useInsertionEffect: wi,
    useLayoutEffect: xi,
    useMemo: Ci,
    useReducer: gi,
    useRef: si,
    useState: function() {
        return gi(ei);
    },
    useDebugValue: Ai,
    useDeferredValue: function(a) {
        var b = di();
        return null === O ? b.memoizedState = a : Di(b, O.memoizedState, a);
    },
    useTransition: function() {
        var a = gi(ei)[0], b = di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: hi,
    useSyncExternalStore: ii,
    useId: Fi,
    unstable_isNewReconciler: !1
};
function Ki(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Ni = "function" === typeof WeakMap ? WeakMap : Map;
function Oi(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Pi || (Pi = !0, Qi = d);
        Mi(a, b);
    };
    return c;
}
function Ri(a, b, c) {
    c = ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Mi(a, b);
        "function" !== typeof d && (null === Si ? Si = new Set([
            this
        ]) : Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ui.bind(null, a, b, c), b.then(a, a));
}
function Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = ch(-1, 1), b.tag = 2, dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Xi = ua.ReactCurrentOwner, Ug = !1;
function Yi(a, b, c, d) {
    b.child = null === a ? Ch(b, null, c, d) : Bh(b, a.child, c, d);
}
function Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    Tg(b, e);
    d = Xh(a, b, c, d, f, e);
    c = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Yi(a, b, d, e);
    return b.child;
}
function aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, cj(a, b, f, d, e);
        a = yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return $i(a, b, e);
    }
    b.flags |= 1;
    a = wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (Ug = !0);
            else return b.lanes = a.lanes, $i(a, b, e);
        }
    }
    return dj(a, b, c, d, e);
}
function ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(fj, gj), gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(fj, gj), gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(fj, gj);
            gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(fj, gj), gj |= d;
    Yi(a, b, e, c);
    return b.child;
}
function hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function dj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    Tg(b, e);
    c = Xh(a, b, c, d, f, e);
    d = bi();
    if (null !== a && !Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $i(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Yi(a, b, c, e);
    return b.child;
}
function ij(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    Tg(b, e);
    if (null === b.stateNode) jj(a, b), ph(b, c, d), rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = Vg(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && qh(b, g, d, l);
        $g = !1;
        var r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || $g ? ("function" === typeof m && (kh(b, c, m, d), k = b.memoizedState), (h = $g || oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = Vg(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && qh(b, g, d, k);
        $g = !1;
        r = b.memoizedState;
        g.state = r;
        gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || $g ? ("function" === typeof y && (kh(b, c, y, d), n = b.memoizedState), (l = $g || oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return kj(a, b, c, d, f, e);
}
function kj(a, b, c, d, e, f) {
    hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), $i(a, b, f);
    d = b.stateNode;
    Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Bh(b, a.child, null, f), b.child = Bh(b, null, h, f)) : Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function lj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    Ih(a, b.containerInfo);
}
function mj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Yi(a, b, c, d);
    return b.child;
}
var nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function pj(a, b, c) {
    var d = b.pendingProps, e = M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(M, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = qj(g, d, 0, null), a = Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = oj(c), b.memoizedState = nj, a) : rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = wh(h, f) : (f = Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function rj(a, b) {
    b = qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function tj(a, b, c, d) {
    null !== d && Jg(d);
    Bh(b, a.child, null, c);
    a = rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Li(Error(p(422))), tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Bh(b, a.child, null, g);
        b.child.memoizedState = oj(g);
        b.memoizedState = nj;
        return f;
    }
    if (0 === (b.mode & 1)) return tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Li(f, d, void 0);
        return tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (Ug || h) {
        d = R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, Zg(a, e), mh(d, a, e, -1));
        }
        uj();
        d = Li(Error(p(421)));
        return tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    Sg(a.return, b, c);
}
function xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Yi(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && wj(a, c, b);
            else if (19 === a.tag) wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            xj(b, !0, c, null, f);
            break;
        case "together":
            xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function zj(a, b, c) {
    switch(b.tag){
        case 3:
            lj(b);
            Ig();
            break;
        case 5:
            Kh(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(M, M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return pj(a, b, c);
                G(M, M.current & 1);
                a = $i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(M, M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(M, M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, ej(a, b, c);
    }
    return $i(a, b, c);
}
var Aj, Bj, Cj, Dj;
Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Bj = function() {};
Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        Hh(Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Ej(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Fj(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            Jh();
            E(Wf);
            E(H);
            Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Gj(zg), zg = null));
            Bj(a, b);
            S(b);
            return null;
        case 5:
            Lh(b);
            var e = Hh(Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = Hh(Gh.current);
                Hh(Eh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Gj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (M.current & 1) ? 0 === T && (T = 3) : uj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return Jh(), Bj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return Rg(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(M);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Ej(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(M, M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Hj && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Hj && 1073741824 !== c && (b.flags |= 128, d = !0, Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = M.current, G(M, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (gj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Jj(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return Jh(), E(Wf), E(H), Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Lh(b), null;
        case 13:
            E(M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(M), null;
        case 4:
            return Jh(), null;
        case 10:
            return Rg(b.type._context), null;
        case 22:
        case 23:
            return Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Kj = !1, U = !1, Lj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Oj = !1;
function Pj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Oj;
    Oj = !1;
    return n;
}
function Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
function Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Xj(a, b, c), a = a.sibling; null !== a;)Xj(a, b, c), a = a.sibling;
}
var X = null, Yj = !1;
function Zj(a, b, c) {
    for(c = c.child; null !== c;)ak(a, b, c), c = c.sibling;
}
function ak(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Mj(c, b);
        case 6:
            var d = X, e = Yj;
            X = null;
            Zj(a, b, c);
            X = d;
            Yj = e;
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Yj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Yj;
            X = c.stateNode.containerInfo;
            Yj = !0;
            Zj(a, b, c);
            X = d;
            Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Nj(c, b, g) : 0 !== (f & 4) && Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Zj(a, b, c);
            break;
        case 1:
            if (!U && (Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Zj(a, b, c);
            break;
        case 21:
            Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Zj(a, b, c), U = d) : Zj(a, b, c);
            break;
        default:
            Zj(a, b, c);
    }
}
function bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Lj);
        b.forEach(function(b) {
            var d = ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Yj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            ak(f, g, e);
            X = null;
            Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)ek(b, a), b = b.sibling;
}
function ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            dk(b, a);
            fk(a);
            if (d & 4) {
                try {
                    Qj(3, a, a.return), Rj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Qj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            break;
        case 5:
            dk(b, a);
            fk(a);
            d & 512 && null !== c && Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            dk(b, a);
            fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            dk(b, a);
            fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            dk(b, a);
            fk(a);
            break;
        case 13:
            dk(b, a);
            fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (gk = B()));
            d & 4 && bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, dk(b, a), U = l) : dk(b, a);
            fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Qj(4, r, r.return);
                                break;
                            case 1:
                                Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            dk(b, a);
            fk(a);
            d & 4 && bk(a);
            break;
        case 21:
            break;
        default:
            dk(b, a), fk(a);
    }
}
function fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Vj(a);
                    Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Vj(a);
                    Wj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function ik(a, b, c) {
    V = a;
    jk(a, b, c);
}
function jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Kj;
                var l = U;
                Kj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? kk(e) : null !== k ? (k.return = g, V = k) : kk(e);
                for(; null !== f;)V = f, jk(f, b, c), f = f.sibling;
                V = e;
                Kj = h;
                U = l;
            }
            lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : lk(a, b, c);
    }
}
function lk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Sj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function hk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Rj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Sj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var mk = Math.ceil, nk = ua.ReactCurrentDispatcher, ok = ua.ReactCurrentOwner, pk = ua.ReactCurrentBatchConfig, K = 0, R = null, Y = null, Z = 0, gj = 0, fj = Uf(0), T = 0, qk = null, hh = 0, rk = 0, sk = 0, tk = null, uk = null, gk = 0, Hj = Infinity, vk = null, Pi = !1, Qi = null, Si = null, wk = !1, xk = null, yk = 0, zk = 0, Ak = null, Bk = -1, Ck = 0;
function L() {
    return 0 !== (K & 6) ? B() : -1 !== Bk ? Bk : Bk = B();
}
function lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Ck && (Ck = yc()), Ck;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function mh(a, b, c, d) {
    if (50 < zk) throw zk = 0, Ak = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== R) a === R && (0 === (K & 2) && (rk |= c), 4 === T && Dk(a, Z)), Ek(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Hj = B() + 500, fg && jg());
}
function Ek(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Fk.bind(null, a)) : hg(Fk.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Gk(c, Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Hk(a, b) {
    Bk = -1;
    Ck = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Ik() && a.callbackNode !== c) return null;
    var d = uc(a, a === R ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Jk(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Kk();
        if (R !== a || Z !== b) vk = null, Hj = B() + 500, Lk(a, b);
        for(;;)try {
            Mk();
            break;
        } catch (h) {
            Nk(a, h);
        }
        Qg();
        nk.current = f;
        K = e;
        null !== Y ? b = 0 : (R = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Ok(a, e)));
        if (1 === b) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
        if (6 === b) Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Pk(e) && (b = Jk(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Ok(a, f))), 1 === b)) throw c = qk, Lk(a, 0), Dk(a, d), Ek(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Qk(a, uk, vk);
                    break;
                case 3:
                    Dk(a, d);
                    if ((d & 130023424) === d && (b = gk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), b);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 4:
                    Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Qk.bind(null, a, uk, vk), d);
                        break;
                    }
                    Qk(a, uk, vk);
                    break;
                case 5:
                    Qk(a, uk, vk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Ek(a, B());
    return a.callbackNode === c ? Hk.bind(null, a) : null;
}
function Ok(a, b) {
    var c = tk;
    a.current.memoizedState.isDehydrated && (Lk(a, b).flags |= 256);
    a = Jk(a, b);
    2 !== a && (b = uk, uk = c, null !== b && Gj(b));
    return a;
}
function Gj(a) {
    null === uk ? uk = a : uk.push.apply(uk, a);
}
function Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Dk(a, b) {
    b &= ~sk;
    b &= ~rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Fk(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Ik();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Ek(a, B()), null;
    var c = Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Ok(a, d));
    }
    if (1 === c) throw c = qk, Lk(a, 0), Dk(a, b), Ek(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Qk(a, uk, vk);
    Ek(a, B());
    return null;
}
function Rk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Hj = B() + 500, fg && jg());
    }
}
function Sk(a) {
    null !== xk && 0 === xk.tag && 0 === (K & 6) && Ik();
    var b = K;
    K |= 1;
    var c = pk.transition, d = C;
    try {
        if (pk.transition = null, C = 1, a) return a();
    } finally{
        C = d, pk.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Ij() {
    gj = fj.current;
    E(fj);
}
function Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                Jh();
                E(Wf);
                E(H);
                Oh();
                break;
            case 5:
                Lh(d);
                break;
            case 4:
                Jh();
                break;
            case 13:
                E(M);
                break;
            case 19:
                E(M);
                break;
            case 10:
                Rg(d.type._context);
                break;
            case 22:
            case 23:
                Ij();
        }
        c = c.return;
    }
    R = a;
    Y = a = wh(a.current, null);
    Z = gj = b;
    T = 0;
    qk = null;
    sk = rk = hh = 0;
    uk = tk = null;
    if (null !== Wg) {
        for(b = 0; b < Wg.length; b++)if (c = Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        Wg = null;
    }
    return a;
}
function Nk(a, b) {
    do {
        var c = Y;
        try {
            Qg();
            Ph.current = ai;
            if (Sh) {
                for(var d = N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Sh = !1;
            }
            Rh = 0;
            P = O = N = null;
            Th = !1;
            Uh = 0;
            ok.current = null;
            if (null === c || null === c.return) {
                T = 1;
                qk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Wi(y, g, h, f, b);
                        y.mode & 1 && Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Ti(f, l, b);
                            uj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Wi(J, g, h, f, b);
                        Jg(Ki(k, h));
                        break a;
                    }
                }
                f = k = Ki(k, h);
                4 !== T && (T = 2);
                null === tk ? tk = [
                    f
                ] : tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Oi(f, k, b);
                            fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Si || !Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Ri(f, h, b);
                                fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Tk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Kk() {
    var a = nk.current;
    nk.current = ai;
    return null === a ? ai : a;
}
function uj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === R || 0 === (hh & 268435455) && 0 === (rk & 268435455) || Dk(R, Z);
}
function Jk(a, b) {
    var c = K;
    K |= 2;
    var d = Kk();
    if (R !== a || Z !== b) vk = null, Lk(a, b);
    for(;;)try {
        Uk();
        break;
    } catch (e) {
        Nk(a, e);
    }
    Qg();
    K = c;
    nk.current = d;
    if (null !== Y) throw Error(p(261));
    R = null;
    Z = 0;
    return T;
}
function Uk() {
    for(; null !== Y;)Vk(Y);
}
function Mk() {
    for(; null !== Y && !cc();)Vk(Y);
}
function Vk(a) {
    var b = Wk(a.alternate, a, gj);
    a.memoizedProps = a.pendingProps;
    null === b ? Tk(a) : Y = b;
    ok.current = null;
}
function Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Fj(c, b, gj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Qk(a, b, c) {
    var d = C, e = pk.transition;
    try {
        pk.transition = null, C = 1, Xk(a, b, c, d);
    } finally{
        pk.transition = e, C = d;
    }
    return null;
}
function Xk(a, b, c, d) {
    do Ik();
    while (null !== xk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === R && (Y = R = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || wk || (wk = !0, Gk(hc, function() {
        Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = pk.transition;
        pk.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        ok.current = null;
        Pj(a, c);
        ek(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        ik(c, a, e);
        dc();
        K = h;
        C = g;
        pk.transition = f;
    } else a.current = c;
    wk && (wk = !1, xk = a, yk = e);
    f = a.pendingLanes;
    0 === f && (Si = null);
    mc(c.stateNode, d);
    Ek(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Pi) throw Pi = !1, a = Qi, Qi = null, a;
    0 !== (yk & 1) && 0 !== a.tag && Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === Ak ? zk++ : (zk = 0, Ak = a) : zk = 0;
    jg();
    return null;
}
function Ik() {
    if (null !== xk) {
        var a = Dc(yk), b = pk.transition, c = C;
        try {
            pk.transition = null;
            C = 16 > a ? 16 : a;
            if (null === xk) var d = !1;
            else {
                a = xk;
                xk = null;
                yk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Tj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Rj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, pk.transition = b;
        }
    }
    return !1;
}
function Yk(a, b, c) {
    b = Ki(c, b);
    b = Oi(a, b, 1);
    a = dh(a, b, 1);
    b = L();
    null !== a && (Ac(a, 1, b), Ek(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Si || !Si.has(d))) {
                a = Ki(c, a);
                a = Ri(b, a, 1);
                b = dh(b, a, 1);
                a = L();
                null !== b && (Ac(b, 1, a), Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = L();
    a.pingedLanes |= a.suspendedLanes & c;
    R === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - gk ? Lk(a, 0) : sk |= c);
    Ek(a, b);
}
function Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = L();
    a = Zg(a, b);
    null !== a && (Ac(a, b, c), Ek(a, c));
}
function vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Zk(a, c);
}
function ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Zk(a, c);
}
var Wk;
Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return Ug = !1, zj(a, b, c);
            Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else Ug = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            jj(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            Tg(b, c);
            e = Xh(null, b, d, a, e, c);
            var f = bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, ah(b), e.updater = nh, b.stateNode = e, e._reactInternals = b, rh(b, d, a, c), b = kj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $k(d);
                a = Lg(d, a);
                switch(e){
                    case 0:
                        b = dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = aj(null, b, d, Lg(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), ij(a, b, d, e, c);
        case 3:
            a: {
                lj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                bh(a, b);
                gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ki(Error(p(423)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ki(Error(p(424)), b);
                        b = mj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = $i(a, b, c);
                        break a;
                    }
                    Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Kh(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), hj(a, b), Yi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return pj(a, b, c);
        case 4:
            return Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Bh(b, null, d, c) : Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), Zi(a, b, d, e, c);
        case 7:
            return Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = $i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, Tg(b, c), e = Vg(e), d = d(e), b.flags |= 1, Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Lg(d, b.pendingProps), e = Lg(d.type, e), aj(a, b, d, e, c);
        case 15:
            return cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Lg(d, e), jj(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, Tg(b, c), ph(b, d, e), rh(b, d, e, c), kj(null, b, d, !0, a, c);
        case 19:
            return yj(a, b, c);
        case 22:
            return ej(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Gk(a, b) {
    return ac(a, b);
}
function al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new al(a, b, c, d);
}
function bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $k(a) {
    if ("function" === typeof a) return bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function wh(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Ah(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Ah(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function qj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function xh(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function zh(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function cl(a, b, c, d, e, f, g, h, k) {
    a = new bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    ah(f);
    return a;
}
function dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function el(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function fl(a, b, c, d, e, f, g, h, k) {
    a = cl(c, d, !0, a, e, f, g, h, k);
    a.context = el(null);
    c = a.current;
    d = L();
    e = lh(c);
    f = ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    dh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Ek(a, d);
    return a;
}
function gl(a, b, c, d) {
    var e = b.current, f = L(), g = lh(e);
    c = el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = dh(e, b, g);
    null !== a && (mh(a, e, g, f), eh(a, e, g));
    return g;
}
function hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function jl(a, b) {
    il(a, b);
    (a = a.alternate) && il(a, b);
}
function kl() {
    return null;
}
var ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ml(a) {
    this._internalRoot = a;
}
nl.prototype.render = ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    gl(a, b, null, null);
};
nl.prototype.unmount = ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Sk(function() {
            gl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function nl(a) {
    this._internalRoot = a;
}
nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function ql() {}
function rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = hl(g);
                f.call(a);
            };
        }
        var g = fl(b, d, a, 0, null, !1, !1, "", ql);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = hl(k);
            h.call(a);
        };
    }
    var k = cl(a, 0, !1, null, null, !1, !1, "", ql);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Sk(function() {
        gl(b, k, c, d);
    });
    return k;
}
function sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = hl(g);
                h.call(a);
            };
        }
        gl(b, g, a, e);
    } else g = rl(c, b, a, e, d);
    return hl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Ek(b, B()), 0 === (K & 6) && (Hj = B() + 500, jg()));
            }
            break;
        case 13:
            Sk(function() {
                var b = Zg(a, 1);
                if (null !== b) {
                    var c = L();
                    mh(b, a, 1, c);
                }
            }), jl(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = Zg(a, 134217728);
        if (null !== b) {
            var c = L();
            mh(b, a, 134217728, c);
        }
        jl(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = lh(a), c = Zg(a, b);
        if (null !== c) {
            var d = L();
            mh(c, a, b, d);
        }
        jl(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Rk;
Hb = Sk;
var tl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Rk
    ]
}, ul = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var vl = {
    bundleType: ul.bundleType,
    version: ul.version,
    rendererPackageName: ul.rendererPackageName,
    rendererConfig: ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: ul.findFiberByHostInstance || kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!wl.isDisabled && wl.supportsFiber) try {
        kc = wl.inject(vl), lc = wl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = tl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!ol(b)) throw Error(p(200));
    return dl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!ol(a)) throw Error(p(299));
    var c = !1, d = "", e = ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = cl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ml(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Sk(a);
};
exports.hydrate = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!ol(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new nl(b);
};
exports.render = function(a, b, c) {
    if (!pl(b)) throw Error(p(200));
    return sl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!pl(a)) throw Error(p(40));
    return a._reactRootContainer ? (Sk(function() {
        sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Rk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!pl(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return sl(a, b, c, !1, d);
};
exports.version = "18.2.0-next-9e3b772b8-20220608";

},{"5393afc8c463ef07":"d8NEQ","ece50e903283a22f":"gO1cF"}],"gO1cF":[function(require,module,exports) {
"use strict";
module.exports = require("62f08acde0c8aa34");

},{"62f08acde0c8aa34":"3fTCr"}],"3fTCr":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"3xmjG":[function(require,module,exports) {
"use strict";
var e = require("807fb3c5a616296"), t = require("954c229c705f1a08"), r = require("d2f2bb64b3e6125c"), n = require("956970adf2150af9");
function o(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(r) {
        if ("default" !== r) {
            var n = Object.getOwnPropertyDescriptor(e, r);
            Object.defineProperty(t, r, n.get ? n : {
                enumerable: !0,
                get: function() {
                    return e[r];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var s = o(e);
const i = ()=>e.createContext({
        flags: {},
        flagKeyMap: {},
        ldClient: void 0
    }), a = {
    useCamelCaseFlagKeys: !0,
    sendEventsOnFlagRead: !0,
    reactContext: i()
}, l = (e)=>{
    var t;
    return null != (t = e.context) ? t : e.user;
}, c = (e)=>{
    const t = {};
    for(const n in e)0 !== n.indexOf("$") && (t[r(n)] = e[n]);
    return t;
}, u = (e, t)=>{
    const r = {};
    for(const n in e)t && void 0 === t[n] || (r[n] = e[n].current);
    return r;
}, p = (e, t)=>{
    const r = e.allFlags();
    return t ? Object.keys(t).reduce((e, n)=>(e[n] = Object.prototype.hasOwnProperty.call(r, n) ? r[n] : t[n], e), {}) : r;
};
function f(e, t, n = a, o) {
    const s = function(e, t) {
        if (void 0 === t) return e;
        return Object.keys(t).reduce((t, r)=>(d(e, r) && (t[r] = e[r]), t), {});
    }(t, o), { useCamelCaseFlagKeys: i = !0 } = n, [l, c = {}] = i ? function(e) {
        const t = {}, n = {};
        for(const o in e){
            if (0 === o.indexOf("$")) continue;
            const s = r(o);
            t[s] = e[o], n[s] = o;
        }
        return [
            t,
            n
        ];
    }(s) : [
        s
    ];
    return {
        flags: n.sendEventsOnFlagRead ? y(e, l, c, i) : l,
        flagKeyMap: c
    };
}
function d(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
function y(e, t, r, n) {
    return new Proxy(t, {
        get (t, o, s) {
            const i = Reflect.get(t, o, s), a = n && d(r, o) || d(t, o);
            if ("symbol" == typeof o || !a) return i;
            if (void 0 === i) return;
            const l = n ? r[o] : o;
            return e.variation(l, i);
        }
    });
}
c.camelCaseKeys = c;
const h = {
    wrapperName: "react-client-sdk",
    wrapperVersion: "3.6.0",
    sendEventsOnlyForVariation: !0
};
var O = Object.defineProperty, g = Object.defineProperties, b = Object.getOwnPropertyDescriptors, v = Object.getOwnPropertySymbols, x = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable, C = (e, t, r)=>t in e ? O(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, j = (e, t)=>{
    for(var r in t || (t = {}))x.call(t, r) && C(e, r, t[r]);
    if (v) for (var r of v(t))m.call(t, r) && C(e, r, t[r]);
    return e;
}, P = (e, t)=>g(e, b(t)), w = (e, t, r)=>new Promise((n, o)=>{
        var s = (e)=>{
            try {
                a(r.next(e));
            } catch (e) {
                o(e);
            }
        }, i = (e)=>{
            try {
                a(r.throw(e));
            } catch (e) {
                o(e);
            }
        }, a = (e)=>e.done ? n(e.value) : Promise.resolve(e.value).then(s, i);
        a((r = r.apply(e, t)).next());
    });
class F extends e.Component {
    constructor(e){
        super(e), this.getReactOptions = ()=>j(j({}, a), this.props.reactOptions), this.subscribeToChanges = (e)=>{
            const { flags: t } = this.props;
            e.on("change", (r)=>{
                const n = this.getReactOptions(), o = u(r, t), s = j(j({}, this.state.unproxiedFlags), o);
                Object.keys(o).length > 0 && this.setState((r)=>j(P(j({}, r), {
                        unproxiedFlags: s
                    }), f(e, s, n, t)));
            });
        }, this.onFailed = (e, t)=>{
            this.setState((e)=>P(j({}, e), {
                    error: t
                }));
        }, this.onReady = (e, t, r)=>{
            const n = p(e, r);
            this.setState((o)=>j(P(j({}, o), {
                    unproxiedFlags: n
                }), f(e, n, t, r)));
        }, this.prepareLDClient = ()=>w(this, null, function*() {
                var e;
                const { clientSideID: r, flags: n, options: o } = this.props;
                let s = yield this.props.ldClient;
                const i = this.getReactOptions();
                let a, c = this.state.unproxiedFlags;
                if (s) c = p(s, n);
                else {
                    const u = null != (e = l(this.props)) ? e : {
                        anonymous: !0,
                        kind: "user"
                    };
                    s = t.initialize(r, u, j(j({}, h), o));
                    try {
                        yield s.waitForInitialization(this.props.timeout), c = p(s, n);
                    } catch (e) {
                        a = e, (null == a ? void 0 : a.name.toLowerCase().includes("timeout")) && (s.on("failed", this.onFailed), s.on("ready", ()=>{
                            this.onReady(s, i, n);
                        }));
                    }
                }
                this.setState((e)=>P(j(P(j({}, e), {
                        unproxiedFlags: c
                    }), f(s, c, i, n)), {
                        ldClient: s,
                        error: a
                    })), this.subscribeToChanges(s);
            });
        const { options: r } = e;
        if (this.state = {
            flags: {},
            unproxiedFlags: {},
            flagKeyMap: {}
        }, r) {
            const { bootstrap: e } = r;
            if (e && "localStorage" !== e) {
                const { useCamelCaseFlagKeys: t } = this.getReactOptions();
                this.state = {
                    flags: t ? c(e) : e,
                    unproxiedFlags: e,
                    flagKeyMap: {}
                };
            }
        }
    }
    componentDidMount() {
        return w(this, null, function*() {
            const { deferInitialization: e } = this.props;
            e && !l(this.props) || (yield this.prepareLDClient());
        });
    }
    componentDidUpdate(e) {
        return w(this, null, function*() {
            const { deferInitialization: t } = this.props, r = !l(e) && l(this.props);
            t && r && (yield this.prepareLDClient());
        });
    }
    render() {
        const { flags: t, flagKeyMap: r, ldClient: n, error: o } = this.state, { reactContext: s } = this.getReactOptions();
        return e.createElement(s.Provider, {
            value: {
                flags: t,
                flagKeyMap: r,
                ldClient: n,
                error: o
            }
        }, this.props.children);
    }
}
var E = Object.defineProperty, D = Object.defineProperties, S = Object.getOwnPropertyDescriptors, k = Object.getOwnPropertySymbols, K = Object.prototype.hasOwnProperty, L = Object.prototype.propertyIsEnumerable, R = (e, t, r)=>t in e ? E(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, I = (e, t)=>{
    for(var r in t || (t = {}))K.call(t, r) && R(e, r, t[r]);
    if (k) for (var r of k(t))L.call(t, r) && R(e, r, t[r]);
    return e;
};
var z = Object.defineProperty, M = Object.defineProperties, q = Object.getOwnPropertyDescriptors, T = Object.getOwnPropertySymbols, V = Object.prototype.hasOwnProperty, $ = Object.prototype.propertyIsEnumerable, N = (e, t, r)=>t in e ? z(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, U = (e, t)=>{
    for(var r in t || (t = {}))V.call(t, r) && N(e, r, t[r]);
    if (T) for (var r of T(t))$.call(t, r) && N(e, r, t[r]);
    return e;
}, W = (e, t)=>M(e, q(t));
var A = Object.defineProperty, B = Object.getOwnPropertySymbols, G = Object.prototype.hasOwnProperty, H = Object.prototype.propertyIsEnumerable, J = (e, t, r)=>t in e ? A(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, Q = (e, t)=>{
    for(var r in t || (t = {}))G.call(t, r) && J(e, r, t[r]);
    if (B) for (var r of B(t))H.call(t, r) && J(e, r, t[r]);
    return e;
};
exports.LDProvider = F, exports.asyncWithLDProvider = function(r) {
    var n, o, s;
    return n = this, o = null, s = function*() {
        var n, o;
        const { clientSideID: s, flags: i, options: c, reactOptions: d } = r, y = U(U({}, a), d), O = null != (n = l(r)) ? n : {
            anonymous: !0,
            kind: "user"
        };
        let g, b = {};
        const v = null != (o = yield r.ldClient) ? o : t.initialize(s, O, U(U({}, h), c));
        try {
            yield v.waitForInitialization(r.timeout), b = p(v, i);
        } catch (e) {
            g = e;
        }
        const x = (null == c ? void 0 : c.bootstrap) && "localStorage" !== c.bootstrap ? c.bootstrap : b;
        return ({ children: t })=>{
            const [r, n] = e.useState(()=>W(U({
                    unproxiedFlags: x
                }, f(v, x, y, i)), {
                    ldClient: v,
                    error: g
                }));
            e.useEffect(()=>{
                function e(e) {
                    const t = u(e, i);
                    Object.keys(t).length > 0 && n((e)=>{
                        const r = U(U({}, e.unproxiedFlags), t);
                        return U(W(U({}, e), {
                            unproxiedFlags: r
                        }), f(v, r, y, i));
                    });
                }
                function t() {
                    const e = p(v, i);
                    n((t)=>U(W(U({}, t), {
                            unproxiedFlags: e
                        }), f(v, e, y, i)));
                }
                function r(e) {
                    n((t)=>W(U({}, t), {
                            error: e
                        }));
                }
                return v.on("change", e), (null == g ? void 0 : g.name.toLowerCase().includes("timeout")) && (v.on("failed", r), v.on("ready", t)), function() {
                    v.off("change", e), v.off("failed", r), v.off("ready", t);
                };
            }, []);
            const o = ((e, t)=>{
                var r = {};
                for(var n in e)V.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                if (null != e && T) for (var n of T(e))t.indexOf(n) < 0 && $.call(e, n) && (r[n] = e[n]);
                return r;
            })(r, [
                "unproxiedFlags"
            ]), { reactContext: s } = y;
            return e.createElement(s.Provider, {
                value: o
            }, t);
        };
    }, new Promise((e, t)=>{
        var r = (e)=>{
            try {
                a(s.next(e));
            } catch (e) {
                t(e);
            }
        }, i = (e)=>{
            try {
                a(s.throw(e));
            } catch (e) {
                t(e);
            }
        }, a = (t)=>t.done ? e(t.value) : Promise.resolve(t.value).then(r, i);
        a((s = s.apply(n, o)).next());
    });
}, exports.camelCaseKeys = c, exports.defaultReactOptions = a, exports.reactSdkContextFactory = i, exports.useFlags = (t)=>{
    const { flags: r } = e.useContext(null != t ? t : a.reactContext);
    return r;
}, exports.useLDClient = (t)=>{
    const { ldClient: r } = e.useContext(null != t ? t : a.reactContext);
    return r;
}, exports.useLDClientError = function(t) {
    const { error: r } = e.useContext(null != t ? t : a.reactContext);
    return r;
}, exports.withLDConsumer = function(e = {
    clientOnly: !1
}) {
    return function(t) {
        var r;
        const n = null != (r = e.reactContext) ? r : a.reactContext;
        return (r)=>s.createElement(n.Consumer, null, ({ flags: n, ldClient: o })=>e.clientOnly ? s.createElement(t, Q({
                    ldClient: o
                }, r)) : s.createElement(t, Q({
                    flags: n,
                    ldClient: o
                }, r)));
    };
}, exports.withLDProvider = function(e) {
    return function(t) {
        const { reactOptions: r } = e, o = I(I({}, a), r), i = (l = I({}, e), D(l, S({
            reactOptions: o
        })));
        var l;
        function c(e) {
            return s.createElement(F, I({}, i), s.createElement(t, I({}, e)));
        }
        return n(c, t), c;
    };
}, Object.keys(t).forEach(function(e) {
    "default" === e || Object.prototype.hasOwnProperty.call(exports, e) || Object.defineProperty(exports, e, {
        enumerable: !0,
        get: function() {
            return t[e];
        }
    });
});

},{"807fb3c5a616296":"d8NEQ","954c229c705f1a08":"dlvGG","d2f2bb64b3e6125c":"4WV97","956970adf2150af9":"3xfN4"}],"dlvGG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basicLogger", ()=>Nt);
parcelHelpers.export(exports, "createConsoleLogger", ()=>$t);
parcelHelpers.export(exports, "default", ()=>Mt);
parcelHelpers.export(exports, "initialize", ()=>Ft);
parcelHelpers.export(exports, "version", ()=>Vt);
function e(e) {
    function t(e, t) {
        Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = t;
    }
    return t.prototype = new Error, t.prototype.name = e, t.prototype.constructor = t, t;
}
const t = e("LaunchDarklyUnexpectedResponseError"), n = e("LaunchDarklyInvalidEnvironmentIdError"), r = e("LaunchDarklyInvalidUserError"), o = e("LaunchDarklyInvalidEventKeyError"), i = e("LaunchDarklyInvalidArgumentError"), a = e("LaunchDarklyFlagFetchError");
for(var s = {
    LDUnexpectedResponseError: t,
    LDInvalidEnvironmentIdError: n,
    LDInvalidUserError: r,
    LDInvalidEventKeyError: o,
    LDInvalidArgumentError: i,
    LDInvalidDataError: e("LaunchDarklyInvalidDataError"),
    LDFlagFetchError: a,
    LDTimeoutError: e("LaunchDarklyTimeoutError"),
    isHttpErrorRecoverable: function(e) {
        return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
    }
}, c = function(e) {
    var t = m(e), n = t[0], r = t[1];
    return 3 * (n + r) / 4 - r;
}, u = function(e) {
    var t, n, r = m(e), o = r[0], i = r[1], a = new g(function(e, t, n) {
        return 3 * (t + n) / 4 - n;
    }(0, o, i)), s = 0, c = i > 0 ? o - 4 : o;
    for(n = 0; n < c; n += 4)t = f[e.charCodeAt(n)] << 18 | f[e.charCodeAt(n + 1)] << 12 | f[e.charCodeAt(n + 2)] << 6 | f[e.charCodeAt(n + 3)], a[s++] = t >> 16 & 255, a[s++] = t >> 8 & 255, a[s++] = 255 & t;
    2 === i && (t = f[e.charCodeAt(n)] << 2 | f[e.charCodeAt(n + 1)] >> 4, a[s++] = 255 & t);
    1 === i && (t = f[e.charCodeAt(n)] << 10 | f[e.charCodeAt(n + 1)] << 4 | f[e.charCodeAt(n + 2)] >> 2, a[s++] = t >> 8 & 255, a[s++] = 255 & t);
    return a;
}, l = function(e) {
    for(var t, n = e.length, r = n % 3, o = [], i = 16383, a = 0, s = n - r; a < s; a += i)o.push(h(e, a, a + i > s ? s : a + i));
    1 === r ? (t = e[n - 1], o.push(d[t >> 2] + d[t << 4 & 63] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], o.push(d[t >> 10] + d[t >> 4 & 63] + d[t << 2 & 63] + "="));
    return o.join("");
}, d = [], f = [], g = "undefined" != typeof Uint8Array ? Uint8Array : Array, v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = 0; p < 64; ++p)d[p] = v[p], f[v.charCodeAt(p)] = p;
function m(e) {
    var t = e.length;
    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var n = e.indexOf("=");
    return -1 === n && (n = t), [
        n,
        n === t ? 0 : 4 - n % 4
    ];
}
function h(e, t, n) {
    for(var r, o, i = [], a = t; a < n; a += 3)r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(d[(o = r) >> 18 & 63] + d[o >> 12 & 63] + d[o >> 6 & 63] + d[63 & o]);
    return i.join("");
}
f["-".charCodeAt(0)] = 62, f["_".charCodeAt(0)] = 63;
var y = {
    byteLength: c,
    toByteArray: u,
    fromByteArray: l
}, w = Array.isArray, b = Object.keys, k = Object.prototype.hasOwnProperty, E = function e(t, n) {
    if (t === n) return !0;
    if (t && n && "object" == typeof t && "object" == typeof n) {
        var r, o, i, a = w(t), s = w(n);
        if (a && s) {
            if ((o = t.length) != n.length) return !1;
            for(r = o; 0 != r--;)if (!e(t[r], n[r])) return !1;
            return !0;
        }
        if (a != s) return !1;
        var c = t instanceof Date, u = n instanceof Date;
        if (c != u) return !1;
        if (c && u) return t.getTime() == n.getTime();
        var l = t instanceof RegExp, d = n instanceof RegExp;
        if (l != d) return !1;
        if (l && d) return t.toString() == n.toString();
        var f = b(t);
        if ((o = f.length) !== b(n).length) return !1;
        for(r = o; 0 != r--;)if (!k.call(n, f[r])) return !1;
        for(r = o; 0 != r--;)if (!e(t[i = f[r]], n[i])) return !1;
        return !0;
    }
    return t != t && n != n;
};
const D = [
    "key",
    "ip",
    "country",
    "email",
    "firstName",
    "lastName",
    "avatar",
    "name"
];
function x(e) {
    const t = unescape(encodeURIComponent(e));
    return y.fromByteArray(function(e) {
        const t = [];
        for(let n = 0; n < e.length; n++)t.push(e.charCodeAt(n));
        return t;
    }(t));
}
function C(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
var P, S = {
    appendUrlPath: function(e, t) {
        return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
    },
    base64URLEncode: function(e) {
        return x(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    },
    btoa: x,
    clone: function(e) {
        return JSON.parse(JSON.stringify(e));
    },
    deepEquals: function(e, t) {
        return E(e, t);
    },
    extend: function(...e) {
        return e.reduce((e, t)=>({
                ...e,
                ...t
            }), {});
    },
    getLDUserAgentString: function(e) {
        const t = e.version || "?";
        return e.userAgent + "/" + t;
    },
    objectHasOwnProperty: C,
    onNextTick: function(e) {
        setTimeout(e, 0);
    },
    sanitizeContext: function(e) {
        if (!e) return e;
        let t;
        return null !== e.kind && void 0 !== e.kind || D.forEach((n)=>{
            const r = e[n];
            void 0 !== r && "string" != typeof r && (t = t || {
                ...e
            }, t[n] = String(r));
        }), t || e;
    },
    transformValuesToVersionedValues: function(e) {
        const t = {};
        for(const n in e)C(e, n) && (t[n] = {
            value: e[n],
            version: 0
        });
        return t;
    },
    transformVersionedValuesToValues: function(e) {
        const t = {};
        for(const n in e)C(e, n) && (t[n] = e[n].value);
        return t;
    },
    wrapPromiseCallback: function(e, t) {
        const n = e.then((e)=>(t && setTimeout(()=>{
                t(null, e);
            }, 0), e), (e)=>{
            if (!t) return Promise.reject(e);
            setTimeout(()=>{
                t(e, null);
            }, 0);
        });
        return t ? void 0 : n;
    }
}, I = new Uint8Array(16);
function O() {
    if (!P && !(P = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return P(I);
}
var T = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function L(e) {
    return "string" == typeof e && T.test(e);
}
for(var U, R, A = [], j = 0; j < 256; ++j)A.push((j + 256).toString(16).substr(1));
function F(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = (A[e[t + 0]] + A[e[t + 1]] + A[e[t + 2]] + A[e[t + 3]] + "-" + A[e[t + 4]] + A[e[t + 5]] + "-" + A[e[t + 6]] + A[e[t + 7]] + "-" + A[e[t + 8]] + A[e[t + 9]] + "-" + A[e[t + 10]] + A[e[t + 11]] + A[e[t + 12]] + A[e[t + 13]] + A[e[t + 14]] + A[e[t + 15]]).toLowerCase();
    if (!L(n)) throw TypeError("Stringified UUID is invalid");
    return n;
}
var N = 0, $ = 0;
function V(e) {
    if (!L(e)) throw TypeError("Invalid UUID");
    var t, n = new Uint8Array(16);
    return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
}
function M(e, t, n) {
    function r(e, r, o, i) {
        if ("string" == typeof e && (e = function(e) {
            e = unescape(encodeURIComponent(e));
            for(var t = [], n = 0; n < e.length; ++n)t.push(e.charCodeAt(n));
            return t;
        }(e)), "string" == typeof r && (r = V(r)), 16 !== r.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
        var a = new Uint8Array(16 + e.length);
        if (a.set(r), a.set(e, r.length), (a = n(a))[6] = 15 & a[6] | t, a[8] = 63 & a[8] | 128, o) {
            i = i || 0;
            for(var s = 0; s < 16; ++s)o[i + s] = a[s];
            return o;
        }
        return F(a);
    }
    try {
        r.name = e;
    } catch (e) {}
    return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
}
function q(e) {
    return 14 + (e + 64 >>> 9 << 4) + 1;
}
function H(e, t) {
    var n = (65535 & e) + (65535 & t);
    return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
}
function z(e, t, n, r, o, i) {
    var a, s;
    return H((a = H(H(t, e), H(r, i))) << (s = o) | a >>> 32 - s, n);
}
function K(e, t, n, r, o, i, a) {
    return z(t & n | ~t & r, e, t, o, i, a);
}
function _(e, t, n, r, o, i, a) {
    return z(t & r | n & ~r, e, t, o, i, a);
}
function J(e, t, n, r, o, i, a) {
    return z(t ^ n ^ r, e, t, o, i, a);
}
function B(e, t, n, r, o, i, a) {
    return z(n ^ (t | ~r), e, t, o, i, a);
}
var G = M("v3", 48, function(e) {
    if ("string" == typeof e) {
        var t = unescape(encodeURIComponent(e));
        e = new Uint8Array(t.length);
        for(var n = 0; n < t.length; ++n)e[n] = t.charCodeAt(n);
    }
    return function(e) {
        for(var t = [], n = 32 * e.length, r = "0123456789abcdef", o = 0; o < n; o += 8){
            var i = e[o >> 5] >>> o % 32 & 255, a = parseInt(r.charAt(i >>> 4 & 15) + r.charAt(15 & i), 16);
            t.push(a);
        }
        return t;
    }(function(e, t) {
        e[t >> 5] |= 128 << t % 32, e[q(t) - 1] = t;
        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, a = 0; a < e.length; a += 16){
            var s = n, c = r, u = o, l = i;
            n = K(n, r, o, i, e[a], 7, -680876936), i = K(i, n, r, o, e[a + 1], 12, -389564586), o = K(o, i, n, r, e[a + 2], 17, 606105819), r = K(r, o, i, n, e[a + 3], 22, -1044525330), n = K(n, r, o, i, e[a + 4], 7, -176418897), i = K(i, n, r, o, e[a + 5], 12, 1200080426), o = K(o, i, n, r, e[a + 6], 17, -1473231341), r = K(r, o, i, n, e[a + 7], 22, -45705983), n = K(n, r, o, i, e[a + 8], 7, 1770035416), i = K(i, n, r, o, e[a + 9], 12, -1958414417), o = K(o, i, n, r, e[a + 10], 17, -42063), r = K(r, o, i, n, e[a + 11], 22, -1990404162), n = K(n, r, o, i, e[a + 12], 7, 1804603682), i = K(i, n, r, o, e[a + 13], 12, -40341101), o = K(o, i, n, r, e[a + 14], 17, -1502002290), n = _(n, r = K(r, o, i, n, e[a + 15], 22, 1236535329), o, i, e[a + 1], 5, -165796510), i = _(i, n, r, o, e[a + 6], 9, -1069501632), o = _(o, i, n, r, e[a + 11], 14, 643717713), r = _(r, o, i, n, e[a], 20, -373897302), n = _(n, r, o, i, e[a + 5], 5, -701558691), i = _(i, n, r, o, e[a + 10], 9, 38016083), o = _(o, i, n, r, e[a + 15], 14, -660478335), r = _(r, o, i, n, e[a + 4], 20, -405537848), n = _(n, r, o, i, e[a + 9], 5, 568446438), i = _(i, n, r, o, e[a + 14], 9, -1019803690), o = _(o, i, n, r, e[a + 3], 14, -187363961), r = _(r, o, i, n, e[a + 8], 20, 1163531501), n = _(n, r, o, i, e[a + 13], 5, -1444681467), i = _(i, n, r, o, e[a + 2], 9, -51403784), o = _(o, i, n, r, e[a + 7], 14, 1735328473), n = J(n, r = _(r, o, i, n, e[a + 12], 20, -1926607734), o, i, e[a + 5], 4, -378558), i = J(i, n, r, o, e[a + 8], 11, -2022574463), o = J(o, i, n, r, e[a + 11], 16, 1839030562), r = J(r, o, i, n, e[a + 14], 23, -35309556), n = J(n, r, o, i, e[a + 1], 4, -1530992060), i = J(i, n, r, o, e[a + 4], 11, 1272893353), o = J(o, i, n, r, e[a + 7], 16, -155497632), r = J(r, o, i, n, e[a + 10], 23, -1094730640), n = J(n, r, o, i, e[a + 13], 4, 681279174), i = J(i, n, r, o, e[a], 11, -358537222), o = J(o, i, n, r, e[a + 3], 16, -722521979), r = J(r, o, i, n, e[a + 6], 23, 76029189), n = J(n, r, o, i, e[a + 9], 4, -640364487), i = J(i, n, r, o, e[a + 12], 11, -421815835), o = J(o, i, n, r, e[a + 15], 16, 530742520), n = B(n, r = J(r, o, i, n, e[a + 2], 23, -995338651), o, i, e[a], 6, -198630844), i = B(i, n, r, o, e[a + 7], 10, 1126891415), o = B(o, i, n, r, e[a + 14], 15, -1416354905), r = B(r, o, i, n, e[a + 5], 21, -57434055), n = B(n, r, o, i, e[a + 12], 6, 1700485571), i = B(i, n, r, o, e[a + 3], 10, -1894986606), o = B(o, i, n, r, e[a + 10], 15, -1051523), r = B(r, o, i, n, e[a + 1], 21, -2054922799), n = B(n, r, o, i, e[a + 8], 6, 1873313359), i = B(i, n, r, o, e[a + 15], 10, -30611744), o = B(o, i, n, r, e[a + 6], 15, -1560198380), r = B(r, o, i, n, e[a + 13], 21, 1309151649), n = B(n, r, o, i, e[a + 4], 6, -145523070), i = B(i, n, r, o, e[a + 11], 10, -1120210379), o = B(o, i, n, r, e[a + 2], 15, 718787259), r = B(r, o, i, n, e[a + 9], 21, -343485551), n = H(n, s), r = H(r, c), o = H(o, u), i = H(i, l);
        }
        return [
            n,
            r,
            o,
            i
        ];
    }(function(e) {
        if (0 === e.length) return [];
        for(var t = 8 * e.length, n = new Uint32Array(q(t)), r = 0; r < t; r += 8)n[r >> 5] |= (255 & e[r / 8]) << r % 32;
        return n;
    }(e), 8 * e.length));
}), W = G;
function X(e, t, n, r) {
    switch(e){
        case 0:
            return t & n ^ ~t & r;
        case 1:
        case 3:
            return t ^ n ^ r;
        case 2:
            return t & n ^ t & r ^ n & r;
    }
}
function Q(e, t) {
    return e << t | e >>> 32 - t;
}
var Y = M("v5", 80, function(e) {
    var t = [
        1518500249,
        1859775393,
        2400959708,
        3395469782
    ], n = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ];
    if ("string" == typeof e) {
        var r = unescape(encodeURIComponent(e));
        e = [];
        for(var o = 0; o < r.length; ++o)e.push(r.charCodeAt(o));
    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
    e.push(128);
    for(var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), c = 0; c < a; ++c){
        for(var u = new Uint32Array(16), l = 0; l < 16; ++l)u[l] = e[64 * c + 4 * l] << 24 | e[64 * c + 4 * l + 1] << 16 | e[64 * c + 4 * l + 2] << 8 | e[64 * c + 4 * l + 3];
        s[c] = u;
    }
    s[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = 8 * (e.length - 1) & 4294967295;
    for(var d = 0; d < a; ++d){
        for(var f = new Uint32Array(80), g = 0; g < 16; ++g)f[g] = s[d][g];
        for(var v = 16; v < 80; ++v)f[v] = Q(f[v - 3] ^ f[v - 8] ^ f[v - 14] ^ f[v - 16], 1);
        for(var p = n[0], m = n[1], h = n[2], y = n[3], w = n[4], b = 0; b < 80; ++b){
            var k = Math.floor(b / 20), E = Q(p, 5) + X(k, m, h, y) + w + t[k] + f[b] >>> 0;
            w = y, y = h, h = Q(m, 30) >>> 0, m = p, p = E;
        }
        n[0] = n[0] + p >>> 0, n[1] = n[1] + m >>> 0, n[2] = n[2] + h >>> 0, n[3] = n[3] + y >>> 0, n[4] = n[4] + w >>> 0;
    }
    return [
        n[0] >> 24 & 255,
        n[0] >> 16 & 255,
        n[0] >> 8 & 255,
        255 & n[0],
        n[1] >> 24 & 255,
        n[1] >> 16 & 255,
        n[1] >> 8 & 255,
        255 & n[1],
        n[2] >> 24 & 255,
        n[2] >> 16 & 255,
        n[2] >> 8 & 255,
        255 & n[2],
        n[3] >> 24 & 255,
        n[3] >> 16 & 255,
        n[3] >> 8 & 255,
        255 & n[3],
        n[4] >> 24 & 255,
        n[4] >> 16 & 255,
        n[4] >> 8 & 255,
        255 & n[4]
    ];
}), Z = Y;
var ee = Object.freeze({
    __proto__: null,
    v1: function(e, t, n) {
        var r = t && n || 0, o = t || new Array(16), i = (e = e || {}).node || U, a = void 0 !== e.clockseq ? e.clockseq : R;
        if (null == i || null == a) {
            var s = e.random || (e.rng || O)();
            null == i && (i = U = [
                1 | s[0],
                s[1],
                s[2],
                s[3],
                s[4],
                s[5]
            ]), null == a && (a = R = 16383 & (s[6] << 8 | s[7]));
        }
        var c = void 0 !== e.msecs ? e.msecs : Date.now(), u = void 0 !== e.nsecs ? e.nsecs : $ + 1, l = c - N + (u - $) / 1e4;
        if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || c > N) && void 0 === e.nsecs && (u = 0), u >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
        N = c, $ = u, R = a;
        var d = (1e4 * (268435455 & (c += 122192928e5)) + u) % 4294967296;
        o[r++] = d >>> 24 & 255, o[r++] = d >>> 16 & 255, o[r++] = d >>> 8 & 255, o[r++] = 255 & d;
        var f = c / 4294967296 * 1e4 & 268435455;
        o[r++] = f >>> 8 & 255, o[r++] = 255 & f, o[r++] = f >>> 24 & 15 | 16, o[r++] = f >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
        for(var g = 0; g < 6; ++g)o[r + g] = i[g];
        return t || F(o);
    },
    v3: W,
    v4: function(e, t, n) {
        var r = (e = e || {}).random || (e.rng || O)();
        if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
            n = n || 0;
            for(var o = 0; o < 16; ++o)t[n + o] = r[o];
            return t;
        }
        return F(r);
    },
    v5: Z,
    NIL: "00000000-0000-0000-0000-000000000000",
    version: function(e) {
        if (!L(e)) throw TypeError("Invalid UUID");
        return parseInt(e.substr(14, 1), 16);
    },
    validate: L,
    stringify: F,
    parse: V
});
const te = [
    "debug",
    "info",
    "warn",
    "error",
    "none"
];
var ne = {
    commonBasicLogger: function(e, t) {
        if (e && e.destination && "function" != typeof e.destination) throw new Error("destination for basicLogger was set to a non-function");
        function n(e) {
            return function(t) {
                console && console[e] && console[e].call(console, t);
            };
        }
        const r = e && e.destination ? [
            e.destination,
            e.destination,
            e.destination,
            e.destination
        ] : [
            n("log"),
            n("info"),
            n("warn"),
            n("error")
        ], o = !(!e || !e.destination), i = e && void 0 !== e.prefix && null !== e.prefix ? e.prefix : "[LaunchDarkly] ";
        let a = 1;
        if (e && e.level) for(let t = 0; t < te.length; t++)te[t] === e.level && (a = t);
        function s(e, n, a) {
            if (a.length < 1) return;
            let s;
            const c = o ? n + ": " + i : i;
            if (1 !== a.length && t) {
                const e = [
                    ...a
                ];
                e[0] = c + e[0], s = t(...e);
            } else s = c + a[0];
            try {
                r[e](s);
            } catch (e) {
                console && console.log && console.log("[LaunchDarkly] Configured logger's " + n + " method threw an exception: " + e);
            }
        }
        const c = {};
        for(let e = 0; e < te.length; e++){
            const t = te[e];
            if ("none" !== t) {
                if (e < a) c[t] = ()=>{};
                else {
                    const n = e;
                    c[t] = function() {
                        s(n, t, arguments);
                    };
                }
            }
        }
        return c;
    },
    validateLogger: function(e) {
        te.forEach((t)=>{
            if ("none" !== t && (!e[t] || "function" != typeof e[t])) throw new Error("Provided logger instance must support logger." + t + "(...) method");
        });
    }
};
function re(e) {
    return e && e.message ? e.message : "string" == typeof e || e instanceof String ? e : JSON.stringify(e);
}
const oe = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var ie = {
    bootstrapInvalid: function() {
        return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
    },
    bootstrapOldFormat: function() {
        return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + oe;
    },
    clientInitialized: function() {
        return "LaunchDarkly client initialized";
    },
    clientNotReady: function() {
        return "LaunchDarkly client is not ready";
    },
    debugEnqueueingEvent: function(e) {
        return 'enqueueing "' + e + '" event';
    },
    debugPostingDiagnosticEvent: function(e) {
        return "sending diagnostic event (" + e.kind + ")";
    },
    debugPostingEvents: function(e) {
        return "sending " + e + " events";
    },
    debugStreamDelete: function(e) {
        return 'received streaming deletion for flag "' + e + '"';
    },
    debugStreamDeleteIgnored: function(e) {
        return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
    },
    debugStreamPatch: function(e) {
        return 'received streaming update for flag "' + e + '"';
    },
    debugStreamPatchIgnored: function(e) {
        return 'received streaming update for flag "' + e + '" but ignored due to version check';
    },
    debugStreamPing: function() {
        return "received ping message from stream";
    },
    debugPolling: function(e) {
        return "polling for feature flags at " + e;
    },
    debugStreamPut: function() {
        return "received streaming update for all flags";
    },
    deprecated: function(e, t) {
        return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
    },
    environmentNotFound: function() {
        return "Environment not found. Double check that you specified a valid environment/client-side ID." + oe;
    },
    environmentNotSpecified: function() {
        return "No environment/client-side ID was specified." + oe;
    },
    errorFetchingFlags: function(e) {
        return "Error fetching flag settings: " + re(e);
    },
    eventCapacityExceeded: function() {
        return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
    },
    eventWithoutContext: function() {
        return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
    },
    httpErrorMessage: function(e, t, n) {
        return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + t + " - " + (s.isHttpErrorRecoverable(e) ? n : "giving up permanently");
    },
    httpUnavailable: function() {
        return "Cannot make HTTP requests in this environment." + oe;
    },
    identifyDisabled: function() {
        return "identify() has no effect here; it must be called on the main client instance";
    },
    inspectorMethodError: (e, t)=>`an inspector: "${t}" of type: "${e}" generated an exception`,
    invalidContentType: function(e) {
        return 'Expected application/json content type but got "' + e + '"';
    },
    invalidData: function() {
        return "Invalid data received from LaunchDarkly; connection may have been interrupted";
    },
    invalidInspector: (e, t)=>`an inspector: "${t}" of an invalid type (${e}) was configured`,
    invalidKey: function() {
        return "Event key must be a string";
    },
    invalidMetricValue: (e)=>`The track function was called with a non-numeric "metricValue" (${e}), only numeric metric values are supported.`,
    invalidContext: function() {
        return "Invalid context specified." + oe;
    },
    invalidTagValue: (e)=>`Config option "${e}" must only contain letters, numbers, ., _ or -.`,
    localStorageUnavailable: function(e) {
        return "local storage is unavailable: " + re(e);
    },
    networkError: (e)=>"network error" + (e ? " (" + e + ")" : ""),
    optionBelowMinimum: (e, t, n)=>'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + n,
    streamClosing: function() {
        return "Closing stream connection";
    },
    streamConnecting: function(e) {
        return "Opening stream connection to " + e;
    },
    streamError: function(e, t) {
        return "Error on stream connection: " + re(e) + ", will continue retrying after " + t + " milliseconds.";
    },
    tagValueTooLong: (e)=>`Value of "${e}" was longer than 64 characters and was discarded.`,
    unknownCustomEventKey: function(e) {
        return 'Custom event "' + e + '" does not exist';
    },
    unknownOption: (e)=>'Ignoring unknown config option "' + e + '"',
    contextNotSpecified: function() {
        return "No context specified." + oe;
    },
    unrecoverableStreamError: (e)=>`Error on stream connection ${re(e)}, giving up permanently`,
    wrongOptionType: (e, t, n)=>'Config option "' + e + '" should be of type ' + t + ", got " + n + ", using default value",
    wrongOptionTypeBoolean: (e, t)=>'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean"
};
const { validateLogger: ae } = ne, se = {
    baseUrl: {
        default: "https://app.launchdarkly.com"
    },
    streamUrl: {
        default: "https://clientstream.launchdarkly.com"
    },
    eventsUrl: {
        default: "https://events.launchdarkly.com"
    },
    sendEvents: {
        default: !0
    },
    streaming: {
        type: "boolean"
    },
    sendLDHeaders: {
        default: !0
    },
    requestHeaderTransform: {
        type: "function"
    },
    sendEventsOnlyForVariation: {
        default: !1
    },
    useReport: {
        default: !1
    },
    evaluationReasons: {
        default: !1
    },
    eventCapacity: {
        default: 100,
        minimum: 1
    },
    flushInterval: {
        default: 2e3,
        minimum: 2e3
    },
    samplingInterval: {
        default: 0,
        minimum: 0
    },
    streamReconnectDelay: {
        default: 1e3,
        minimum: 0
    },
    allAttributesPrivate: {
        default: !1
    },
    privateAttributes: {
        default: []
    },
    bootstrap: {
        type: "string|object"
    },
    diagnosticRecordingInterval: {
        default: 9e5,
        minimum: 2e3
    },
    diagnosticOptOut: {
        default: !1
    },
    wrapperName: {
        type: "string"
    },
    wrapperVersion: {
        type: "string"
    },
    stateProvider: {
        type: "object"
    },
    application: {
        validator: function(e, t, n) {
            const r = {};
            t.id && (r.id = le(`${e}.id`, t.id, n));
            t.version && (r.version = le(`${e}.version`, t.version, n));
            return r;
        }
    },
    inspectors: {
        default: []
    }
}, ce = /^(\w|\.|-)+$/;
function ue(e) {
    return e && e.replace(/\/+$/, "");
}
function le(e, t, n) {
    if ("string" == typeof t && t.match(ce)) {
        if (!(t.length > 64)) return t;
        n.warn(ie.tagValueTooLong(e));
    } else n.warn(ie.invalidTagValue(e));
}
var de = {
    baseOptionDefs: se,
    validate: function(e, t, n, r) {
        const o = S.extend({
            logger: {
                default: r
            }
        }, se, n), i = {};
        function a(e) {
            S.onNextTick(()=>{
                t && t.maybeReportError(new s.LDInvalidArgumentError(e));
            });
        }
        let c = S.extend({}, e || {});
        return function(e) {
            const t = e;
            Object.keys(i).forEach((e)=>{
                if (void 0 !== t[e]) {
                    const n = i[e];
                    r && r.warn(ie.deprecated(e, n)), n && (void 0 === t[n] && (t[n] = t[e]), delete t[e]);
                }
            });
        }(c), c = function(e) {
            const t = S.extend({}, e);
            return Object.keys(o).forEach((e)=>{
                void 0 !== t[e] && null !== t[e] || (t[e] = o[e] && o[e].default);
            }), t;
        }(c), c = function(e) {
            const t = S.extend({}, e), n = (e)=>{
                if (null === e) return "any";
                if (void 0 === e) return;
                if (Array.isArray(e)) return "array";
                const t = typeof e;
                return "boolean" === t || "string" === t || "number" === t || "function" === t ? t : "object";
            };
            return Object.keys(e).forEach((i)=>{
                const s = e[i];
                if (null != s) {
                    const c = o[i];
                    if (void 0 === c) a(ie.unknownOption(i));
                    else {
                        const o = c.type || n(c.default), u = c.validator;
                        if (u) {
                            const n = u(i, e[i], r);
                            void 0 !== n ? t[i] = n : delete t[i];
                        } else if ("any" !== o) {
                            const e = o.split("|"), r = n(s);
                            e.indexOf(r) < 0 ? "boolean" === o ? (t[i] = !!s, a(ie.wrongOptionTypeBoolean(i, r))) : (a(ie.wrongOptionType(i, o, r)), t[i] = c.default) : "number" === r && void 0 !== c.minimum && s < c.minimum && (a(ie.optionBelowMinimum(i, s, c.minimum)), t[i] = c.minimum);
                        }
                    }
                }
            }), t.baseUrl = ue(t.baseUrl), t.streamUrl = ue(t.streamUrl), t.eventsUrl = ue(t.eventsUrl), t;
        }(c), ae(c.logger), c;
    },
    getTags: function(e) {
        const t = {};
        return e && (e.application && void 0 !== e.application.id && null !== e.application.id && (t["application-id"] = [
            e.application.id
        ]), e.application && void 0 !== e.application.version && null !== e.application.id && (t["application-version"] = [
            e.application.version
        ])), t;
    }
};
const { getLDUserAgentString: fe } = S;
var ge = {
    getLDHeaders: function(e, t) {
        if (t && !t.sendLDHeaders) return {};
        const n = {};
        n[e.userAgentHeaderName || "User-Agent"] = fe(e), t && t.wrapperName && (n["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
        const r = de.getTags(t), o = Object.keys(r);
        return o.length && (n["x-launchdarkly-tags"] = o.sort().map((e)=>Array.isArray(r[e]) ? r[e].sort().map((t)=>`${e}/${t}`) : [
                `${e}/${r[e]}`
            ]).reduce((e, t)=>e.concat(t), []).join(" ")), n;
    },
    transformHeaders: function(e, t) {
        return t && t.requestHeaderTransform ? t.requestHeaderTransform({
            ...e
        }) : e;
    }
};
const { v1: ve } = ee, { getLDHeaders: pe, transformHeaders: me } = ge;
var he = function(e, t, n) {
    const r = S.extend({
        "Content-Type": "application/json"
    }, pe(e, n)), o = {};
    return o.sendEvents = (t, o, i)=>{
        if (!e.httpRequest) return Promise.resolve();
        const a = JSON.stringify(t), c = i ? null : ve();
        return (function t(u) {
            const l = i ? r : S.extend({}, r, {
                "X-LaunchDarkly-Event-Schema": "4",
                "X-LaunchDarkly-Payload-ID": c
            });
            return e.httpRequest("POST", o, me(l, n), a).promise.then((e)=>{
                if (e) return e.status >= 400 && s.isHttpErrorRecoverable(e.status) && u ? t(!1) : function(e) {
                    const t = {
                        status: e.status
                    }, n = e.header("date");
                    if (n) {
                        const e = Date.parse(n);
                        e && (t.serverTime = e);
                    }
                    return t;
                }(e);
            }).catch(()=>u ? t(!1) : Promise.reject());
        })(!0).catch(()=>{});
    }, o;
};
const { commonBasicLogger: ye } = ne;
function we(e) {
    return "string" == typeof e && "kind" !== e && e.match(/^(\w|\.|-)+$/);
}
function be(e) {
    return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var ke = {
    checkContext: function(e, t) {
        if (e) {
            if (t && (void 0 === e.kind || null === e.kind)) return void 0 !== e.key && null !== e.key;
            const n = e.key, r = void 0 === e.kind ? "user" : e.kind, o = we(r), i = "multi" === r || null != n && "" !== n;
            if ("multi" === r) {
                const t = Object.keys(e).filter((e)=>"kind" !== e);
                return i && t.every((e)=>we(e)) && t.every((t)=>{
                    const n = e[t].key;
                    return null != n && "" !== n;
                });
            }
            return i && o;
        }
        return !1;
    },
    getContextKeys: function(e, t = ye()) {
        if (!e) return;
        const n = {}, { kind: r, key: o } = e;
        switch(r){
            case void 0:
                n.user = `${o}`;
                break;
            case "multi":
                Object.entries(e).filter(([e])=>"kind" !== e).forEach(([e, t])=>{
                    t && t.key && (n[e] = t.key);
                });
                break;
            case null:
                t.warn(`null is not a valid context kind: ${e}`);
                break;
            case "":
                t.warn(`'' is not a valid context kind: ${e}`);
                break;
            default:
                n[r] = `${o}`;
        }
        return n;
    },
    getContextKinds: function(e) {
        return e ? null === e.kind || void 0 === e.kind ? [
            "user"
        ] : "multi" !== e.kind ? [
            e.kind
        ] : Object.keys(e).filter((e)=>"kind" !== e) : [];
    },
    getCanonicalKey: function(e) {
        if (e) {
            if ((void 0 === e.kind || null === e.kind || "user" === e.kind) && e.key) return e.key;
            if ("multi" !== e.kind && e.key) return `${e.kind}:${be(e.key)}`;
            if ("multi" === e.kind) return Object.keys(e).sort().filter((e)=>"kind" !== e).map((t)=>`${t}:${be(e[t].key)}`).join(":");
        }
    }
};
const { getContextKinds: Ee } = ke;
var De = function() {
    const e = {};
    let t = 0, n = 0, r = {}, o = {};
    return e.summarizeEvent = (e)=>{
        if ("feature" === e.kind) {
            const i = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""), a = r[i];
            let s = o[e.key];
            s || (s = new Set, o[e.key] = s), (function(e) {
                return e.context ? Ee(e.context) : e.contextKeys ? Object.keys(e.contextKeys) : [];
            })(e).forEach((e)=>s.add(e)), a ? a.count = a.count + 1 : r[i] = {
                count: 1,
                key: e.key,
                version: e.version,
                variation: e.variation,
                value: e.value,
                default: e.default
            }, (0 === t || e.creationDate < t) && (t = e.creationDate), e.creationDate > n && (n = e.creationDate);
        }
    }, e.getSummary = ()=>{
        const e = {};
        let i = !0;
        for (const t of Object.values(r)){
            let n = e[t.key];
            n || (n = {
                default: t.default,
                counters: [],
                contextKinds: [
                    ...o[t.key]
                ]
            }, e[t.key] = n);
            const r = {
                value: t.value,
                count: t.count
            };
            void 0 !== t.variation && null !== t.variation && (r.variation = t.variation), void 0 !== t.version && null !== t.version ? r.version = t.version : r.unknown = !0, n.counters.push(r), i = !1;
        }
        return i ? null : {
            startDate: t,
            endDate: n,
            features: e
        };
    }, e.clearSummary = ()=>{
        t = 0, n = 0, r = {}, o = {};
    }, e;
};
function xe(e) {
    return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Ce(e) {
    return (e.startsWith("/") ? e.substring(1) : e).split("/").map((e)=>e.indexOf("~") >= 0 ? e.replace(/~1/g, "/").replace(/~0/g, "~") : e);
}
function Pe(e) {
    return !e.startsWith("/");
}
function Se(e, t) {
    const n = Pe(e), r = Pe(t);
    if (n && r) return e === t;
    if (n) {
        const n = Ce(t);
        return 1 === n.length && e === n[0];
    }
    if (r) {
        const n = Ce(e);
        return 1 === n.length && t === n[0];
    }
    return e === t;
}
function Ie(e) {
    return `/${xe(e)}`;
}
var Oe = {
    cloneExcluding: function(e, t) {
        const n = [], r = {}, o = [];
        for(n.push(...Object.keys(e).map((t)=>({
                key: t,
                ptr: Ie(t),
                source: e,
                parent: r,
                visited: [
                    e
                ]
            }))); n.length;){
            const e = n.pop();
            if (t.some((t)=>Se(t, e.ptr))) o.push(e.ptr);
            else {
                const t = e.source[e.key];
                if (null === t) e.parent[e.key] = t;
                else if (Array.isArray(t)) e.parent[e.key] = [
                    ...t
                ];
                else if ("object" == typeof t) {
                    if (e.visited.includes(t)) continue;
                    e.parent[e.key] = {}, n.push(...Object.keys(t).map((n)=>{
                        var r, o;
                        return {
                            key: n,
                            ptr: (r = e.ptr, o = xe(n), `${r}/${o}`),
                            source: t,
                            parent: e.parent[e.key],
                            visited: [
                                ...e.visited,
                                t
                            ]
                        };
                    }));
                } else e.parent[e.key] = t;
            }
        }
        return {
            cloned: r,
            excluded: o.sort()
        };
    },
    compare: Se,
    literalToReference: Ie
};
var Te = function(e) {
    const t = {}, n = e.allAttributesPrivate, r = e.privateAttributes || [], o = [
        "key",
        "kind",
        "_meta",
        "anonymous"
    ], i = [
        "name",
        "ip",
        "firstName",
        "lastName",
        "email",
        "avatar",
        "country"
    ], a = (e, t)=>{
        if ("object" != typeof e || null === e || Array.isArray(e)) return;
        const { cloned: i, excluded: a } = Oe.cloneExcluding(e, ((e, t)=>(n || t && e.anonymous ? Object.keys(e) : [
                ...r,
                ...e._meta && e._meta.privateAttributes || []
            ]).filter((e)=>!o.some((t)=>Oe.compare(e, t))))(e, t));
        return i.key = String(i.key), a.length && (i._meta || (i._meta = {}), i._meta.redactedAttributes = a), i._meta && (delete i._meta.privateAttributes, 0 === Object.keys(i._meta).length && delete i._meta), void 0 !== i.anonymous && (i.anonymous = !!i.anonymous), i;
    };
    return t.filter = (e, t = !1)=>void 0 === e.kind || null === e.kind ? a(((e)=>{
            const t = {
                ...e.custom || {},
                kind: "user",
                key: e.key
            };
            void 0 !== e.anonymous && (t.anonymous = !!e.anonymous);
            for (const n of i)delete t[n], void 0 !== e[n] && null !== e[n] && (t[n] = String(e[n]));
            return void 0 !== e.privateAttributeNames && null !== e.privateAttributeNames && (t._meta = t._meta || {}, t._meta.privateAttributes = e.privateAttributeNames.map((e)=>e.startsWith("/") ? Oe.literalToReference(e) : e)), t;
        })(e), t) : "multi" === e.kind ? ((e, t)=>{
            const n = {
                kind: e.kind
            }, r = Object.keys(e);
            for (const o of r)if ("kind" !== o) {
                const r = a(e[o], t);
                r && (n[o] = r);
            }
            return n;
        })(e, t) : a(e, t), t;
};
const { getContextKeys: Le } = ke;
var Ue = function(e, t, n, r = null, o = null, i = null) {
    const a = {}, c = i || he(e, n, t), u = S.appendUrlPath(t.eventsUrl, "/events/bulk/" + n), l = De(), d = Te(t), f = t.samplingInterval, g = t.eventCapacity, v = t.flushInterval, p = t.logger;
    let m, h = [], y = 0, w = !1, b = !1;
    function k() {
        return 0 === f || 0 === Math.floor(Math.random() * f);
    }
    function E(e) {
        const t = S.extend({}, e);
        return "identify" === e.kind ? t.context = d.filter(e.context) : "feature" === e.kind ? t.context = d.filter(e.context, !0) : (t.contextKeys = Le(e.context, p), delete t.context), "feature" === e.kind && (delete t.trackEvents, delete t.debugEventsUntilDate), t;
    }
    function D(e) {
        h.length < g ? (h.push(e), b = !1) : (b || (b = !0, p.warn(ie.eventCapacityExceeded())), r && r.incrementDroppedEvents());
    }
    return a.enqueue = function(e) {
        if (w) return;
        let t = !1, n = !1;
        var r;
        if (l.summarizeEvent(e), "feature" === e.kind ? k() && (t = !!e.trackEvents, n = !!(r = e).debugEventsUntilDate && r.debugEventsUntilDate > y && r.debugEventsUntilDate > (new Date).getTime()) : t = k(), t && D(E(e)), n) {
            const t = S.extend({}, e, {
                kind: "debug"
            });
            t.context = d.filter(t.context), delete t.trackEvents, delete t.debugEventsUntilDate, D(t);
        }
    }, a.flush = function() {
        if (w) return Promise.resolve();
        const e = h, t = l.getSummary();
        return l.clearSummary(), t && (t.kind = "summary", e.push(t)), r && r.setEventsInLastBatch(e.length), 0 === e.length ? Promise.resolve() : (h = [], p.debug(ie.debugPostingEvents(e.length)), c.sendEvents(e, u).then((e)=>{
            e && (e.serverTime && (y = e.serverTime), s.isHttpErrorRecoverable(e.status) || (w = !0), e.status >= 400 && S.onNextTick(()=>{
                o.maybeReportError(new s.LDUnexpectedResponseError(ie.httpErrorMessage(e.status, "event posting", "some events were dropped")));
            }));
        }));
    }, a.start = function() {
        const e = ()=>{
            a.flush(), m = setTimeout(e, v);
        };
        m = setTimeout(e, v);
    }, a.stop = function() {
        clearTimeout(m);
    }, a;
};
var Re = function(e) {
    const t = {}, n = {};
    return t.on = function(e, t, r) {
        n[e] = n[e] || [], n[e] = n[e].concat({
            handler: t,
            context: r
        });
    }, t.off = function(e, t, r) {
        if (n[e]) for(let o = 0; o < n[e].length; o++)n[e][o].handler === t && n[e][o].context === r && (n[e] = n[e].slice(0, o).concat(n[e].slice(o + 1)));
    }, t.emit = function(e) {
        if (!n[e]) return;
        const t = n[e].slice(0);
        for(let e = 0; e < t.length; e++)t[e].handler.apply(t[e].context, Array.prototype.slice.call(arguments, 1));
    }, t.getEvents = function() {
        return Object.keys(n);
    }, t.getEventListenerCount = function(e) {
        return n[e] ? n[e].length : 0;
    }, t.maybeReportError = function(t) {
        t && (n["error"] ? this.emit("error", t) : (e || console).error(t.message));
    }, t;
};
const Ae = "ready", je = "initialized", Fe = "failed";
var Ne = function(e) {
    let t = !1, n = !1, r = null, o = null;
    const i = new Promise((t)=>{
        const n = ()=>{
            e.off(Ae, n), t();
        };
        e.on(Ae, n);
    }).catch(()=>{});
    return {
        getInitializationPromise: ()=>o || (t ? Promise.resolve() : n ? Promise.reject(r) : (o = new Promise((t, n)=>{
                const r = ()=>{
                    e.off(je, r), t();
                }, o = (t)=>{
                    e.off(Fe, o), n(t);
                };
                e.on(je, r), e.on(Fe, o);
            }), o)),
        getReadyPromise: ()=>i,
        signalSuccess: ()=>{
            t || n || (t = !0, e.emit(je), e.emit(Ae));
        },
        signalFailure: (o)=>{
            t || n || (n = !0, r = o, e.emit(Fe, o), e.emit(Ae)), e.maybeReportError(o);
        }
    };
};
var $e = function(e, t, n, r) {
    const o = {};
    function i() {
        let e = "";
        const o = r.getContext();
        return o && (e = n || S.btoa(JSON.stringify(o))), "ld:" + t + ":" + e;
    }
    return o.loadFlags = ()=>e.get(i()).then((e)=>{
            if (null == e) return null;
            try {
                let t = JSON.parse(e);
                if (t) {
                    const e = t.$schema;
                    void 0 === e || e < 1 ? t = S.transformValuesToVersionedValues(t) : delete t.$schema;
                }
                return t;
            } catch (e) {
                return o.clearFlags().then(()=>null);
            }
        }), o.saveFlags = (t)=>{
        const n = S.extend({}, t, {
            $schema: 1
        });
        return e.set(i(), JSON.stringify(n));
    }, o.clearFlags = ()=>e.clear(i()), o;
};
var Ve = function(e, t) {
    const n = {};
    let r = !1;
    const o = (e)=>{
        r || (r = !0, t.warn(ie.localStorageUnavailable(e)));
    };
    return n.isEnabled = ()=>!!e, n.get = (t)=>new Promise((n)=>{
            e ? e.get(t).then(n).catch((e)=>{
                o(e), n(void 0);
            }) : n(void 0);
        }), n.set = (t, n)=>new Promise((r)=>{
            e ? e.set(t, n).then(()=>r(!0)).catch((e)=>{
                o(e), r(!1);
            }) : r(!1);
        }), n.clear = (t)=>new Promise((n)=>{
            e ? e.clear(t).then(()=>n(!0)).catch((e)=>{
                o(e), n(!1);
            }) : n(!1);
        }), n;
};
const { appendUrlPath: Me, base64URLEncode: qe, objectHasOwnProperty: He } = S, { getLDHeaders: ze, transformHeaders: Ke } = ge, { isHttpErrorRecoverable: _e } = s;
var Je = function(e, t, n, r) {
    const o = t.streamUrl, i = t.logger, a = {}, s = Me(o, "/eval/" + n), c = t.useReport, u = t.evaluationReasons, l = t.streamReconnectDelay, d = ze(e, t);
    let f, g = !1, v = null, p = null, m = null, h = null, y = null, w = 0;
    function b() {
        const e = (t = function() {
            const e = l * Math.pow(2, w);
            return e > 3e4 ? 3e4 : e;
        }(), t - Math.trunc(.5 * Math.random() * t));
        var t;
        return w += 1, e;
    }
    function k(e) {
        if (e.status && "number" == typeof e.status && !_e(e.status)) return x(), i.error(ie.unrecoverableStreamError(e)), void (p && (clearTimeout(p), p = null));
        const t = b();
        g || (i.warn(ie.streamError(e, t)), g = !0), C(!1), x(), E(t);
    }
    function E(e) {
        p || (e ? p = setTimeout(D, e) : D());
    }
    function D() {
        let r;
        p = null;
        let a = "";
        const l = {
            headers: d,
            readTimeoutMillis: 3e5
        };
        if (e.eventSourceFactory) {
            null != h && (a = "h=" + h), c ? e.eventSourceAllowsReport ? (r = s, l.method = "REPORT", l.headers["Content-Type"] = "application/json", l.body = JSON.stringify(m)) : (r = Me(o, "/ping/" + n), a = "") : r = s + "/" + qe(JSON.stringify(m)), l.headers = Ke(l.headers, t), u && (a = a + (a ? "&" : "") + "withReasons=true"), r = r + (a ? "?" : "") + a, x(), i.info(ie.streamConnecting(r)), f = (new Date).getTime(), v = e.eventSourceFactory(r, l);
            for(const e in y)He(y, e) && v.addEventListener(e, y[e]);
            v.onerror = k, v.onopen = ()=>{
                w = 0;
            };
        }
    }
    function x() {
        v && (i.info(ie.streamClosing()), v.close(), v = null);
    }
    function C(e) {
        f && r && r.recordStreamInit(f, !e, (new Date).getTime() - f), f = null;
    }
    return a.connect = function(e, t, n) {
        m = e, h = t, y = {};
        for(const e in n || {})y[e] = function(t) {
            g = !1, C(!0), n[e] && n[e](t);
        };
        E();
    }, a.disconnect = function() {
        clearTimeout(p), p = null, x();
    }, a.isConnected = function() {
        return !!(v && e.eventSourceIsActive && e.eventSourceIsActive(v));
    }, a;
};
var Be = function(e) {
    let t, n, r, o;
    const i = {
        addPromise: (i, a)=>{
            t = i, n && n(), n = a, i.then((n)=>{
                t === i && (r(n), e && e());
            }, (n)=>{
                t === i && (o(n), e && e());
            });
        }
    };
    return i.resultPromise = new Promise((e, t)=>{
        r = e, o = t;
    }), i;
};
const { transformHeaders: Ge, getLDHeaders: We } = ge, Xe = "application/json";
var Qe = function(e, t, n) {
    const r = t.baseUrl, o = t.useReport, i = t.evaluationReasons, a = t.logger, c = {}, u = {};
    function l(n, r) {
        if (!e.httpRequest) return new Promise((e, t)=>{
            t(new s.LDFlagFetchError(ie.httpUnavailable()));
        });
        const o = r ? "REPORT" : "GET", i = We(e, t);
        r && (i["Content-Type"] = Xe);
        let a = u[n];
        a || (a = Be(()=>{
            delete u[n];
        }), u[n] = a);
        const c = e.httpRequest(o, n, Ge(i, t), r), l = c.promise.then((e)=>{
            if (200 === e.status) {
                if (e.header("content-type") && e.header("content-type").substring(0, 16) === Xe) return JSON.parse(e.body);
                {
                    const t = ie.invalidContentType(e.header("content-type") || "");
                    return Promise.reject(new s.LDFlagFetchError(t));
                }
            }
            return Promise.reject(function(e) {
                return 404 === e.status ? new s.LDInvalidEnvironmentIdError(ie.environmentNotFound()) : new s.LDFlagFetchError(ie.errorFetchingFlags(e.statusText || String(e.status)));
            }(e));
        }, (e)=>Promise.reject(new s.LDFlagFetchError(ie.networkError(e))));
        return a.addPromise(l, ()=>{
            c.cancel && c.cancel();
        }), a.resultPromise;
    }
    return c.fetchJSON = function(e) {
        return l(S.appendUrlPath(r, e), null);
    }, c.fetchFlagSettings = function(e, t) {
        let s, c, u, d = "";
        return o ? (c = [
            r,
            "/sdk/evalx/",
            n,
            "/context"
        ].join(""), u = JSON.stringify(e)) : (s = S.base64URLEncode(JSON.stringify(e)), c = [
            r,
            "/sdk/evalx/",
            n,
            "/contexts/",
            s
        ].join("")), t && (d = "h=" + t), i && (d = d + (d ? "&" : "") + "withReasons=true"), c = c + (d ? "?" : "") + d, a.debug(ie.debugPolling(c)), l(c, u);
    }, c;
};
var Ye = function(e, t) {
    const n = {};
    let r;
    return n.setContext = function(e) {
        r = S.sanitizeContext(e), r && t && t(S.clone(r));
    }, n.getContext = function() {
        return r ? S.clone(r) : null;
    }, e && n.setContext(e), n;
};
const { v1: Ze } = ee, { getContextKinds: et } = ke;
var tt = function(e) {
    function t(e) {
        return null == e || "user" === e ? "ld:$anonUserId" : `ld:$contextKey:${e}`;
    }
    function n(n, r) {
        return null !== r.key && void 0 !== r.key ? (r.key = r.key.toString(), Promise.resolve(r)) : r.anonymous ? (function(n) {
            return e.get(t(n));
        })(n).then((o)=>{
            if (o) return r.key = o, r;
            {
                const o = Ze();
                return r.key = o, (function(n, r) {
                    return e.set(t(r), n);
                })(o, n).then(()=>r);
            }
        }) : Promise.reject(new s.LDInvalidUserError(ie.invalidContext()));
    }
    this.processContext = (e)=>{
        if (!e) return Promise.reject(new s.LDInvalidUserError(ie.contextNotSpecified()));
        const t = S.clone(e);
        if ("multi" === e.kind) {
            const e = et(t);
            return Promise.all(e.map((e)=>n(e, t[e]))).then(()=>t);
        }
        return n(e.kind, t);
    };
};
const { v1: nt } = ee, { baseOptionDefs: rt } = de, { appendUrlPath: ot } = S;
var it = {
    DiagnosticId: function(e) {
        const t = {
            diagnosticId: nt()
        };
        return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
    },
    DiagnosticsAccumulator: function(e) {
        let t, n, r, o;
        function i(e) {
            t = e, n = 0, r = 0, o = [];
        }
        return i(e), {
            getProps: ()=>({
                    dataSinceDate: t,
                    droppedEvents: n,
                    eventsInLastBatch: r,
                    streamInits: o
                }),
            setProps: (e)=>{
                t = e.dataSinceDate, n = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
            },
            incrementDroppedEvents: ()=>{
                n++;
            },
            setEventsInLastBatch: (e)=>{
                r = e;
            },
            recordStreamInit: (e, t, n)=>{
                const r = {
                    timestamp: e,
                    failed: t,
                    durationMillis: n
                };
                o.push(r);
            },
            reset: i
        };
    },
    DiagnosticsManager: function(e, t, n, r, o, i, a) {
        const s = !!e.diagnosticUseCombinedEvent, c = "ld:" + o + ":$diagnostics", u = ot(i.eventsUrl, "/events/diagnostic/" + o), l = i.diagnosticRecordingInterval, d = n;
        let f, g, v = !!i.streaming;
        const p = {};
        function m() {
            return {
                sdk: w(),
                configuration: b(),
                platform: e.diagnosticPlatformData
            };
        }
        function h(e) {
            i.logger && i.logger.debug(ie.debugPostingDiagnosticEvent(e)), r.sendEvents(e, u, !0).then(()=>{}).catch(()=>{});
        }
        function y() {
            h(function() {
                const e = (new Date).getTime();
                let t = {
                    kind: s ? "diagnostic-combined" : "diagnostic",
                    id: a,
                    creationDate: e,
                    ...d.getProps()
                };
                return s && (t = {
                    ...t,
                    ...m()
                }), d.reset(e), t;
            }()), g = setTimeout(y, l), f = (new Date).getTime(), s && function() {
                if (t.isEnabled()) {
                    const e = {
                        ...d.getProps()
                    };
                    t.set(c, JSON.stringify(e));
                }
            }();
        }
        function w() {
            const t = {
                ...e.diagnosticSdkData
            };
            return i.wrapperName && (t.wrapperName = i.wrapperName), i.wrapperVersion && (t.wrapperVersion = i.wrapperVersion), t;
        }
        function b() {
            return {
                customBaseURI: i.baseUrl !== rt.baseUrl.default,
                customStreamURI: i.streamUrl !== rt.streamUrl.default,
                customEventsURI: i.eventsUrl !== rt.eventsUrl.default,
                eventsCapacity: i.eventCapacity,
                eventsFlushIntervalMillis: i.flushInterval,
                reconnectTimeMillis: i.streamReconnectDelay,
                streamingDisabled: !v,
                allAttributesPrivate: !!i.allAttributesPrivate,
                diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval,
                usingSecureMode: !!i.hash,
                bootstrapMode: !!i.bootstrap,
                fetchGoalsDisabled: !i.fetchGoals,
                sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation
            };
        }
        return p.start = ()=>{
            s ? function(e) {
                if (!t.isEnabled()) return e(!1);
                t.get(c).then((t)=>{
                    if (t) try {
                        const e = JSON.parse(t);
                        d.setProps(e), f = e.dataSinceDate;
                    } catch (e) {}
                    e(!0);
                }).catch(()=>{
                    e(!1);
                });
            }((e)=>{
                if (e) {
                    const e = (f || 0) + l, t = (new Date).getTime();
                    t >= e ? y() : g = setTimeout(y, e - t);
                } else 0 === Math.floor(4 * Math.random()) ? y() : g = setTimeout(y, l);
            }) : (h({
                kind: "diagnostic-init",
                id: a,
                creationDate: d.getProps().dataSinceDate,
                ...m()
            }), g = setTimeout(y, l));
        }, p.stop = ()=>{
            g && clearTimeout(g);
        }, p.setStreaming = (e)=>{
            v = e;
        }, p;
    }
};
var at = function(e, t) {
    let n = !1;
    const r = {
        type: e.type,
        name: e.name,
        synchronous: e.synchronous,
        method: (...o)=>{
            try {
                e.method(...o);
            } catch  {
                n || (n = !0, t.warn(ie.inspectorMethodError(r.type, r.name)));
            }
        }
    };
    return r;
};
const { onNextTick: st } = S, ct = {
    flagUsed: "flag-used",
    flagDetailsChanged: "flag-details-changed",
    flagDetailChanged: "flag-detail-changed",
    clientIdentityChanged: "client-identity-changed"
};
Object.freeze(ct);
var ut = {
    InspectorTypes: ct,
    InspectorManager: function(e, t) {
        const n = {}, r = {
            [ct.flagUsed]: [],
            [ct.flagDetailsChanged]: [],
            [ct.flagDetailChanged]: [],
            [ct.clientIdentityChanged]: []
        }, o = {
            [ct.flagUsed]: [],
            [ct.flagDetailsChanged]: [],
            [ct.flagDetailChanged]: [],
            [ct.clientIdentityChanged]: []
        }, i = e && e.map((e)=>at(e, t));
        return i && i.forEach((e)=>{
            Object.prototype.hasOwnProperty.call(r, e.type) && !e.synchronous ? r[e.type].push(e) : Object.prototype.hasOwnProperty.call(o, e.type) && e.synchronous ? o[e.type].push(e) : t.warn(ie.invalidInspector(e.type, e.name));
        }), n.hasListeners = (e)=>r[e] && r[e].length || o[e] && o[e].length, n.onFlagUsed = (e, t, n)=>{
            const i = ct.flagUsed;
            o[i].length && o[i].forEach((r)=>r.method(e, t, n)), r[i].length && st(()=>{
                r[i].forEach((r)=>r.method(e, t, n));
            });
        }, n.onFlags = (e)=>{
            const t = ct.flagDetailsChanged;
            o[t].length && o[t].forEach((t)=>t.method(e)), r[t].length && st(()=>{
                r[t].forEach((t)=>t.method(e));
            });
        }, n.onFlagChanged = (e, t)=>{
            const n = ct.flagDetailChanged;
            o[n].length && o[n].forEach((n)=>n.method(e, t)), r[n].length && st(()=>{
                r[n].forEach((n)=>n.method(e, t));
            });
        }, n.onIdentityChanged = (e)=>{
            const t = ct.clientIdentityChanged;
            o[t].length && o[t].forEach((t)=>t.method(e)), r[t].length && st(()=>{
                r[t].forEach((t)=>t.method(e));
            });
        }, n;
    }
};
const { LDTimeoutError: lt } = s;
var dt = function(e, t) {
    return new Promise((n, r)=>{
        setTimeout(()=>{
            r(new lt(`${t} timed out after ${e} seconds.`));
        }, 1e3 * e);
    });
};
const { commonBasicLogger: ft } = ne, { checkContext: gt, getContextKeys: vt } = ke, { InspectorTypes: pt, InspectorManager: mt } = ut, ht = "change", yt = "internal-change";
var wt = {
    initialize: function(e, t, n, r, o) {
        const i = function() {
            if (n && n.logger) return n.logger;
            return o && o.logger && o.logger.default || ft("warn");
        }(), a = Re(i), c = Ne(a), u = de.validate(n, a, o, i), l = mt(u.inspectors, i), d = u.sendEvents;
        let f = e, g = u.hash;
        const v = Ve(r.localStorage, i), p = he(r, f, u), m = u.sendEvents && !u.diagnosticOptOut, h = m ? it.DiagnosticId(f) : null, y = m ? it.DiagnosticsAccumulator((new Date).getTime()) : null, w = m ? it.DiagnosticsManager(r, v, y, p, f, u, h) : null, b = Je(r, u, f, y), k = u.eventProcessor || Ue(r, u, f, y, a, p), E = Qe(r, u, f);
        let D, x, C, P = {}, I = u.streaming, O = !1, T = !1, L = !0;
        const U = u.stateProvider, R = Ye(null, function(e) {
            (function(e) {
                if (U) return;
                e && F({
                    kind: "identify",
                    context: e,
                    creationDate: (new Date).getTime()
                });
            })(e), l.hasListeners(pt.clientIdentityChanged) && l.onIdentityChanged(R.getContext());
        }), A = new tt(v), j = v.isEnabled() ? $e(v, f, g, R) : null;
        function F(e) {
            f && (U && U.enqueueEvent && U.enqueueEvent(e) || (e.context ? (L = !1, !d || T || r.isDoNotTrack() || (i.debug(ie.debugEnqueueingEvent(e.kind)), k.enqueue(e))) : L && (i.warn(ie.eventWithoutContext()), L = !1)));
        }
        function N(e, t) {
            l.hasListeners(pt.flagDetailChanged) && l.onFlagChanged(e.key, H(t));
        }
        function $() {
            l.hasListeners(pt.flagDetailsChanged) && l.onFlags(Object.entries(P).map(([e, t])=>({
                    key: e,
                    detail: H(t)
                })).reduce((e, t)=>(e[t.key] = t.detail, e), {}));
        }
        function V(e, t, n, r) {
            const o = R.getContext(), i = new Date, a = {
                kind: "feature",
                key: e,
                context: o,
                value: t ? t.value : null,
                variation: t ? t.variationIndex : null,
                default: n,
                creationDate: i.getTime()
            }, s = P[e];
            s && (a.version = s.flagVersion ? s.flagVersion : s.version, a.trackEvents = s.trackEvents, a.debugEventsUntilDate = s.debugEventsUntilDate), (r || s && s.trackReason) && t && (a.reason = t.reason), F(a);
        }
        function M(e) {
            return gt(e, !1) ? Promise.resolve(e) : Promise.reject(new s.LDInvalidUserError(ie.invalidContext()));
        }
        function q(e, t, n, r, o, i) {
            let a, s;
            return P && S.objectHasOwnProperty(P, e) && P[e] && !P[e].deleted ? (s = P[e], a = H(s), null !== s.value && void 0 !== s.value || (a.value = t)) : a = {
                value: t,
                variationIndex: null,
                reason: {
                    kind: "ERROR",
                    errorKind: "FLAG_NOT_FOUND"
                }
            }, n && (o || s?.prerequisites?.forEach((e)=>{
                q(e, void 0, n, !1, !1, !1);
            }), V(e, a, t, r)), !o && i && function(e, t) {
                l.hasListeners(pt.flagUsed) && l.onFlagUsed(e, t, R.getContext());
            }(e, a), a;
        }
        function H(e) {
            return {
                value: e.value,
                variationIndex: void 0 === e.variation ? null : e.variation,
                reason: e.reason || null
            };
        }
        function z() {
            if (x = !0, !R.getContext()) return;
            const e = (e)=>{
                try {
                    return JSON.parse(e);
                } catch (e) {
                    return void a.maybeReportError(new s.LDInvalidDataError(ie.invalidData()));
                }
            };
            b.connect(R.getContext(), g, {
                ping: function() {
                    i.debug(ie.debugStreamPing());
                    const e = R.getContext();
                    E.fetchFlagSettings(e, g).then((t)=>{
                        S.deepEquals(e, R.getContext()) && _(t || {});
                    }).catch((e)=>{
                        a.maybeReportError(new s.LDFlagFetchError(ie.errorFetchingFlags(e)));
                    });
                },
                put: function(t) {
                    const n = e(t.data);
                    n && (i.debug(ie.debugStreamPut()), _(n));
                },
                patch: function(t) {
                    const n = e(t.data);
                    if (!n) return;
                    const r = P[n.key];
                    if (!r || !r.version || !n.version || r.version < n.version) {
                        i.debug(ie.debugStreamPatch(n.key));
                        const e = {}, t = S.extend({}, n);
                        delete t.key, P[n.key] = t;
                        const o = H(t);
                        e[n.key] = r ? {
                            previous: r.value,
                            current: o
                        } : {
                            current: o
                        }, N(n, t), J(e);
                    } else i.debug(ie.debugStreamPatchIgnored(n.key));
                },
                delete: function(t) {
                    const n = e(t.data);
                    if (n) {
                        if (!P[n.key] || P[n.key].version < n.version) {
                            i.debug(ie.debugStreamDelete(n.key));
                            const e = {};
                            P[n.key] && !P[n.key].deleted && (e[n.key] = {
                                previous: P[n.key].value
                            }), P[n.key] = {
                                version: n.version,
                                deleted: !0
                            }, N(n, P[n.key]), J(e);
                        } else i.debug(ie.debugStreamDeleteIgnored(n.key));
                    }
                }
            });
        }
        function K() {
            x && (b.disconnect(), x = !1);
        }
        function _(e) {
            const t = {};
            if (!e) return Promise.resolve();
            for(const n in P)S.objectHasOwnProperty(P, n) && P[n] && (e[n] && !S.deepEquals(e[n].value, P[n].value) ? t[n] = {
                previous: P[n].value,
                current: H(e[n])
            } : e[n] && !e[n].deleted || (t[n] = {
                previous: P[n].value
            }));
            for(const n in e)S.objectHasOwnProperty(e, n) && e[n] && (!P[n] || P[n].deleted) && (t[n] = {
                current: H(e[n])
            });
            return P = {
                ...e
            }, $(), J(t).catch(()=>{});
        }
        function J(e) {
            const t = Object.keys(e);
            if (t.length > 0) {
                const n = {};
                t.forEach((t)=>{
                    const r = e[t].current, o = r ? r.value : void 0, i = e[t].previous;
                    a.emit(ht + ":" + t, o, i), n[t] = r ? {
                        current: o,
                        previous: i
                    } : {
                        previous: i
                    };
                }), a.emit(ht, n), a.emit(yt, P), u.sendEventsOnlyForVariation || U || t.forEach((t)=>{
                    V(t, e[t].current);
                });
            }
            return D && j ? j.saveFlags(P) : Promise.resolve();
        }
        function B() {
            const e = I || C && void 0 === I;
            e && !x ? z() : !e && x && K(), w && w.setStreaming(e);
        }
        function G(e) {
            return e === ht || e.substr(0, 7) === ht + ":";
        }
        if ("string" == typeof u.bootstrap && "LOCALSTORAGE" === u.bootstrap.toUpperCase() && (j ? D = !0 : i.warn(ie.localStorageUnavailable())), "object" == typeof u.bootstrap && (P = function(e) {
            const t = Object.keys(e), n = "$flagsState", r = "$valid", o = e[n];
            !o && t.length && i.warn(ie.bootstrapOldFormat()), !1 === e[r] && i.warn(ie.bootstrapInvalid());
            const a = {};
            return t.forEach((t)=>{
                if (t !== n && t !== r) {
                    let n = {
                        value: e[t]
                    };
                    o && o[t] ? n = S.extend(n, o[t]) : n.version = 0, a[t] = n;
                }
            }), a;
        }(u.bootstrap)), U) {
            const e = U.getInitialState();
            e ? W(e) : U.on("init", W), U.on("update", function(e) {
                e.context && R.setContext(e.context);
                e.flags && _(e.flags);
            });
        } else (function() {
            if (!e) return Promise.reject(new s.LDInvalidEnvironmentIdError(ie.environmentNotSpecified()));
            return A.processContext(t).then(M).then((e)=>(R.setContext(e), "object" == typeof u.bootstrap ? X() : D ? j.loadFlags().then((e)=>null == e ? (P = {}, E.fetchFlagSettings(R.getContext(), g).then((e)=>_(e || {})).then(X).catch((e)=>{
                        Q(new s.LDFlagFetchError(ie.errorFetchingFlags(e)));
                    })) : (P = e, S.onNextTick(X), E.fetchFlagSettings(R.getContext(), g).then((e)=>_(e)).catch((e)=>a.maybeReportError(e)))) : E.fetchFlagSettings(R.getContext(), g).then((e)=>{
                    P = e || {}, $(), X();
                }).catch((e)=>{
                    P = {}, Q(e);
                })));
        })().catch(Q);
        function W(e) {
            f = e.environment, R.setContext(e.context), P = {
                ...e.flags
            }, S.onNextTick(X);
        }
        function X() {
            i.info(ie.clientInitialized()), O = !0, B(), c.signalSuccess();
        }
        function Q(e) {
            c.signalFailure(e);
        }
        const Y = {
            waitForInitialization: function(e) {
                if (null != e) {
                    if ("number" == typeof e) return function(e) {
                        e > 5 && i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
                        const t = c.getInitializationPromise(), n = dt(e, "waitForInitialization");
                        return Promise.race([
                            n,
                            t
                        ]).catch((e)=>{
                            throw e instanceof s.LDTimeoutError && i.error(`waitForInitialization error: ${e}`), e;
                        });
                    }(e);
                    i.warn("The waitForInitialization method was provided with a non-numeric timeout.");
                }
                return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), c.getInitializationPromise();
            },
            waitUntilReady: ()=>c.getReadyPromise(),
            identify: function(e, t, n) {
                if (T) return S.wrapPromiseCallback(Promise.resolve({}), n);
                if (U) return i.warn(ie.identifyDisabled()), S.wrapPromiseCallback(Promise.resolve(S.transformVersionedValuesToValues(P)), n);
                const r = D && j ? j.clearFlags() : Promise.resolve();
                return S.wrapPromiseCallback(r.then(()=>A.processContext(e)).then(M).then((e)=>E.fetchFlagSettings(e, t).then((n)=>{
                        const r = S.transformVersionedValuesToValues(n);
                        return R.setContext(e), g = t, n ? _(n).then(()=>r) : r;
                    })).then((e)=>(x && z(), e)).catch((e)=>(a.maybeReportError(e), Promise.reject(e))), n);
            },
            getContext: function() {
                return R.getContext();
            },
            variation: function(e, t) {
                return q(e, t, !0, !1, !1, !0).value;
            },
            variationDetail: function(e, t) {
                return q(e, t, !0, !0, !1, !0);
            },
            track: function(e, t, n) {
                if ("string" != typeof e) return void a.maybeReportError(new s.LDInvalidEventKeyError(ie.unknownCustomEventKey(e)));
                void 0 !== n && "number" != typeof n && i.warn(ie.invalidMetricValue(typeof n)), r.customEventFilter && !r.customEventFilter(e) && i.warn(ie.unknownCustomEventKey(e));
                const o = R.getContext(), c = {
                    kind: "custom",
                    key: e,
                    context: o,
                    url: r.getCurrentUrl(),
                    creationDate: (new Date).getTime()
                };
                o && o.anonymous && (c.contextKind = o.anonymous ? "anonymousUser" : "user"), null != t && (c.data = t), null != n && (c.metricValue = n), F(c);
            },
            on: function(e, t, n) {
                G(e) ? (C = !0, O && B(), a.on(e, t, n)) : a.on(...arguments);
            },
            off: function(e) {
                if (a.off(...arguments), G(e)) {
                    let e = !1;
                    a.getEvents().forEach((t)=>{
                        G(t) && a.getEventListenerCount(t) > 0 && (e = !0);
                    }), e || (C = !1, x && void 0 === I && K());
                }
            },
            setStreaming: function(e) {
                const t = null === e ? void 0 : e;
                t !== I && (I = t, B());
            },
            flush: function(e) {
                return S.wrapPromiseCallback(d ? k.flush() : Promise.resolve(), e);
            },
            allFlags: function() {
                const e = {};
                if (!P) return e;
                for(const t in P)S.objectHasOwnProperty(P, t) && !P[t].deleted && (e[t] = q(t, null, !u.sendEventsOnlyForVariation, !1, !0, !1).value);
                return e;
            },
            close: function(e) {
                if (T) return S.wrapPromiseCallback(Promise.resolve(), e);
                const t = ()=>{
                    T = !0, P = {};
                }, n = Promise.resolve().then(()=>{
                    if (K(), w && w.stop(), d) return k.stop(), k.flush();
                }).then(t).catch(t);
                return S.wrapPromiseCallback(n, e);
            }
        };
        return {
            client: Y,
            options: u,
            emitter: a,
            ident: R,
            logger: i,
            requestor: E,
            start: function() {
                d && (w && w.start(), k.start());
            },
            enqueueEvent: F,
            getFlagsInternal: function() {
                return P;
            },
            getEnvironmentId: ()=>f,
            internalChangeEventName: yt
        };
    },
    commonBasicLogger: ft,
    errors: s,
    messages: ie,
    utils: S,
    getContextKeys: vt
}, bt = wt.initialize, kt = wt.errors, Et = wt.messages;
function Dt(e, t, n) {
    return (t = function(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var r = n.call(e, t || "default");
                if ("object" != typeof r) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function xt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function Ct(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? xt(Object(n), !0).forEach(function(t) {
            Dt(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xt(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
var Pt = wt.commonBasicLogger;
var St = function(e) {
    return Pt(Ct({
        destination: console.log
    }, e));
};
var It = {
    promise: Promise.resolve({
        status: 200,
        header: function() {
            return null;
        },
        body: null
    })
};
function Ot(e, t, n, r, o) {
    if (o && !function() {
        var e = window.navigator && window.navigator.userAgent;
        if (e) {
            var t = e.match(/Chrom(e|ium)\/([0-9]+)\./);
            if (t) return parseInt(t[2], 10) < 73;
        }
        return !0;
    }()) return It;
    var i = new window.XMLHttpRequest;
    for(var a in i.open(e, t, !o), n || {})Object.prototype.hasOwnProperty.call(n, a) && i.setRequestHeader(a, n[a]);
    if (o) {
        try {
            i.send(r);
        } catch (e) {}
        return It;
    }
    var s, c = new Promise(function(e, t) {
        i.addEventListener("load", function() {
            s || e({
                status: i.status,
                header: function(e) {
                    return i.getResponseHeader(e);
                },
                body: i.responseText
            });
        }), i.addEventListener("error", function() {
            s || t(new Error);
        }), i.send(r);
    });
    return {
        promise: c,
        cancel: function() {
            s = !0, i.abort();
        }
    };
}
var Tt = (e)=>{
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function Lt(e, t, n, r) {
    var o, i, a = (("substring" === e.kind || "regex" === e.kind) && r.includes("/") ? t : t.replace(r, "")).replace(n, "");
    switch(e.kind){
        case "exact":
            i = t, o = new RegExp("^" + Tt(e.url) + "/?$");
            break;
        case "canonical":
            i = a, o = new RegExp("^" + Tt(e.url) + "/?$");
            break;
        case "substring":
            i = a, o = new RegExp(".*" + Tt(e.substring) + ".*$");
            break;
        case "regex":
            i = a, o = new RegExp(e.pattern);
            break;
        default:
            return !1;
    }
    return o.test(i);
}
function Ut(e, t) {
    for(var n = {}, r = null, o = [], i = 0; i < e.length; i++)for(var a = e[i], s = a.urls || [], c = 0; c < s.length; c++)if (Lt(s[c], window.location.href, window.location.search, window.location.hash)) {
        "pageview" === a.kind ? t("pageview", a) : (o.push(a), t("click_pageview", a));
        break;
    }
    return o.length > 0 && (r = function(e) {
        for(var n = function(e, t) {
            for(var n = [], r = 0; r < t.length; r++)for(var o = e.target, i = t[r], a = i.selector, s = document.querySelectorAll(a); o && s.length > 0;){
                for(var c = 0; c < s.length; c++)o === s[c] && n.push(i);
                o = o.parentNode;
            }
            return n;
        }(e, o), r = 0; r < n.length; r++)t("click", n[r]);
    }, document.addEventListener("click", r)), n.dispose = function() {
        document.removeEventListener("click", r);
    }, n;
}
function Rt(e, t) {
    var n, r;
    function o() {
        r && r.dispose(), n && n.length && (r = Ut(n, i));
    }
    function i(t, n) {
        var r = e.ident.getContext(), o = {
            kind: t,
            key: n.key,
            data: null,
            url: window.location.href,
            creationDate: (new Date).getTime(),
            context: r
        };
        return "click" === t && (o.selector = n.selector), e.enqueueEvent(o);
    }
    return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function(e) {
        e && e.length > 0 && (r = Ut(n = e, i), function(e, t) {
            var n, r = window.location.href;
            function o() {
                (n = window.location.href) !== r && (r = n, t());
            }
            !function e(t, n) {
                t(), setTimeout(function() {
                    e(t, n);
                }, n);
            }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
        }(300, o)), t();
    }).catch(function(n) {
        e.emitter.maybeReportError(new kt.LDUnexpectedResponseError((n && n.message, n.message))), t();
    }), {};
}
var At = "goalsReady", jt = {
    fetchGoals: {
        default: !0
    },
    hash: {
        type: "string"
    },
    eventProcessor: {
        type: "object"
    },
    eventUrlTransformer: {
        type: "function"
    },
    disableSyncEventPost: {
        default: !1
    }
};
function Ft(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = function(e) {
        var t, n = {
            userAgentHeaderName: "X-LaunchDarkly-User-Agent",
            synchronousFlush: !1
        };
        if (window.XMLHttpRequest) {
            var r = e && e.disableSyncEventPost;
            n.httpRequest = function(e, t, o, i) {
                var a = n.synchronousFlush & !r;
                return n.synchronousFlush = !1, Ot(e, t, o, i, a);
            };
        }
        n.httpAllowsPost = function() {
            return void 0 === t && (t = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest), t;
        }, n.httpFallbackPing = function(e) {
            (new window.Image).src = e;
        };
        var o, i = e && e.eventUrlTransformer;
        n.getCurrentUrl = function() {
            return i ? i(window.location.href) : window.location.href;
        }, n.isDoNotTrack = function() {
            var e;
            return 1 === (e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === e || "1" === e || "yes" === e;
        };
        try {
            window.localStorage && (n.localStorage = {
                get: function(e) {
                    return new Promise(function(t) {
                        t(window.localStorage.getItem(e));
                    });
                },
                set: function(e, t) {
                    return new Promise(function(n) {
                        window.localStorage.setItem(e, t), n();
                    });
                },
                clear: function(e) {
                    return new Promise(function(t) {
                        window.localStorage.removeItem(e), t();
                    });
                }
            });
        } catch (e) {
            n.localStorage = null;
        }
        if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (n.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (n.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
            var a = 3e5;
            n.eventSourceFactory = function(e, t) {
                var n = Ct(Ct({}, {
                    heartbeatTimeout: a,
                    silentTimeout: a,
                    skipDefaultHeaders: !0
                }), t);
                return new o(e, n);
            }, n.eventSourceIsActive = function(e) {
                return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
            };
        }
        return n.userAgent = "JSClient", n.version = "3.5.0", n.diagnosticSdkData = {
            name: "js-client-sdk",
            version: "3.5.0"
        }, n.diagnosticPlatformData = {
            name: "JS"
        }, n.diagnosticUseCombinedEvent = !0, n;
    }(n), o = bt(e, t, n, r, jt), i = o.client, a = o.options, s = o.emitter, c = new Promise(function(e) {
        var t = s.on(At, function() {
            s.off(At, t), e();
        });
    });
    i.waitUntilGoalsReady = function() {
        return c;
    }, a.fetchGoals ? Rt(o, function() {
        return s.emit(At);
    }) : s.emit(At), "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();
    var u = function() {
        r.synchronousFlush = !0, i.flush().catch(function() {}), r.synchronousFlush = !1;
    };
    return document.addEventListener("visibilitychange", function() {
        "hidden" === document.visibilityState && u();
    }), window.addEventListener("pagehide", u), i;
}
var Nt = St, $t = void 0, Vt = "3.5.0";
var Mt = {
    initialize: function(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return console && console.warn && console.warn(Et.deprecated("default export", "named LDClient export")), Ft(e, t, n);
    },
    version: Vt
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f99mC":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"4WV97":[function(require,module,exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var global = arguments[3];
var INFINITY = 1 / 0;
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f\\ufe20-\\ufe23", rsComboSymbolsRange = "\\u20d0-\\u20f0", rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
/** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboMarksRange + rsComboSymbolsRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var rsLowerMisc = "(?:" + rsLower + "|" + rsMisc + ")", rsUpperMisc = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptLowerContr = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptUpperContr = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
    rsDingbat,
    rsRegional,
    rsSurrPair
].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
    rsNonAstral + rsCombo + "?",
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join("|") + ")";
/** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var reComboMark = RegExp(rsCombo, "g");
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
/** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
    rsUpper + "?" + rsLower + "+" + rsOptLowerContr + "(?=" + [
        rsBreak,
        rsUpper,
        "$"
    ].join("|") + ")",
    rsUpperMisc + "+" + rsOptUpperContr + "(?=" + [
        rsBreak,
        rsUpper + rsLowerMisc,
        "$"
    ].join("|") + ")",
    rsUpper + "?" + rsLowerMisc + "+" + rsOptLowerContr,
    rsUpper + "+" + rsOptUpperContr,
    rsDigits,
    rsEmoji
].join("|"), "g");
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + "]");
/** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "ss"
};
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split("");
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function asciiWords(string) {
    return string.match(reAsciiWord) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var deburrLetter = basePropertyOf(deburredLetters);
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
}
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Built-in value references. */ var Symbol = root.Symbol;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function createCaseFirst(methodName) {
    return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function createCompounder(callback) {
    return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
    };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var camelCase = createCompounder(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? capitalize(word) : word);
});
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function capitalize(string) {
    return upperFirst(toString(string).toLowerCase());
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function deburr(string) {
    string = toString(string);
    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var upperFirst = createCaseFirst("toUpperCase");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function words(string, pattern, guard) {
    string = toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
    return string.match(pattern) || [];
}
module.exports = camelCase;

},{}],"3xfN4":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"j0bVX"}],"j0bVX":[function(require,module,exports) {
"use strict";
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"ib5mk"}],"ib5mk":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"b7s8B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfigContext", ()=>ConfigContext);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _styledComponents = require("styled-components");
var _ramda = require("ramda");
var _reactRouterDom = require("react-router-dom");
var _launchdarklyReactClientSdk = require("launchdarkly-react-client-sdk");
var _state = require("./state");
var _cartState = require("./pages/cart/Cart.state");
var _routes = require("./components/routes");
var _routesDefault = parcelHelpers.interopDefault(_routes);
var _state1 = require("./utils/state");
const App = ({ clientMetadata, theme, isLoggedIn, hasTerminalSession, getOrder, order, terminalSession })=>{
    const ldClient = (0, _launchdarklyReactClientSdk.useLDClient)();
    (0, _react.useEffect)(()=>{
        if (!order.order_id && hasTerminalSession && isLoggedIn) getOrder();
    }, [
        isLoggedIn,
        hasTerminalSession
    ]);
    (0, _react.useEffect)(()=>{
        const { email, client_slug, uid } = (0, _state1.getDecodedAccessToken)();
        const userContext = terminalSession && uid ? {
            user: {
                kind: "user",
                key: `user-${uid}`,
                _meta: {
                    privateAttributes: [
                        "email"
                    ]
                },
                email: email,
                client: client_slug,
                terminal: terminalSession?.terminal,
                location: terminalSession?.location
            }
        } : {};
        const currentContext = ldClient.getContext();
        const context = {
            ...currentContext,
            ...userContext
        };
        ldClient.identify(context);
    }, [
        terminalSession
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "data-testid": "app",
        className: "app",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledComponents.ThemeProvider), {
            theme: {
                name: "default",
                values: theme.data,
                metadata: clientMetadata
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routesDefault.default), {
                    isLoggedIn: isLoggedIn,
                    hasTerminalSession: hasTerminalSession
                })
            })
        })
    });
};
const mapStateToProps = (state)=>({
        clientMetadata: _ramda.path([
            "global",
            "clientMetadata"
        ], state),
        theme: _ramda.path([
            "global",
            "theme"
        ], state),
        isLoggedIn: Boolean((0, _state1.getRefreshToken)()) && Boolean((0, _state1.getAccessToken)()),
        hasTerminalSession: Boolean(state.terminalLogin.terminalSession),
        order: _ramda.pathOr({}, [
            "cart",
            "order"
        ], state),
        terminalSession: state.terminalLogin.terminalSession
    });
const mapDispatchToProps = {
    getOrder: (0, _cartState.getOrderRequest)
};
const ConnectedApp = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);
const ConfigContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});
exports.default = ({ configData })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfigContext.Provider, {
        config: configData,
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRedux.Provider), {
            store: (0, _state.createPosStore)(configData),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConnectedApp, {})
        })
    });

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-redux":"k6jol","styled-components":"bkusY","ramda":"JPp0Z","react-router-dom":"hNarb","launchdarkly-react-client-sdk":"3xmjG","./state":"dFzXj","./pages/cart/Cart.state":"bgoZn","./components/routes":"3zOiI","./utils/state":"8UPqD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k6jol":[function(require,module,exports) {
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", ()=>(0, _reactBatchedUpdates.unstable_batchedUpdates));
var _shim = require("use-sync-external-store/shim");
var _withSelector = require("use-sync-external-store/shim/with-selector");
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _batch = require("./utils/batch");
var _useSelector = require("./hooks/useSelector");
var _connect = require("./components/connect");
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
(0, _useSelector.initializeUseSelector)((0, _withSelector.useSyncExternalStoreWithSelector));
(0, _connect.initializeConnect)((0, _shim.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"use-sync-external-store/shim":"k4pQz","use-sync-external-store/shim/with-selector":"4f5IO","./utils/reactBatchedUpdates":"1EnDk","./utils/batch":"1bpek","./hooks/useSelector":"NHfmY","./components/connect":"9HwCx","./exports":"DnxWa","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k4pQz":[function(require,module,exports) {
"use strict";
module.exports = require("8b974a2950a0796c");

},{"8b974a2950a0796c":"1lD04"}],"1lD04":[function(require,module,exports) {
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var e = require("2f7d03d9688f598f");
function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
function q(a, b) {
    var d = b(), f = l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    n(function() {
        c.value = d;
        c.getSnapshot = b;
        r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    m(function() {
        r(c) && g({
            inst: c
        });
        return a(function() {
            r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    p(d);
    return d;
}
function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !k(a, d);
    } catch (f) {
        return !0;
    }
}
function t(a, b) {
    return b();
}
var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
exports.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;

},{"2f7d03d9688f598f":"d8NEQ"}],"4f5IO":[function(require,module,exports) {
"use strict";
module.exports = require("646f3adc157912dd");

},{"646f3adc157912dd":"59mND"}],"59mND":[function(require,module,exports) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var h = require("2c99ce9e3cb5debf"), n = require("969be431eae4eb00");
function p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var q = "function" === typeof Object.is ? Object.is : p, r = n.useSyncExternalStore, t = h.useRef, u = h.useEffect, v = h.useMemo, w = h.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(a, b, e, l, g) {
    var c = t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if (q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = r(a, c[0], c[1]);
    u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    w(d);
    return d;
};

},{"2c99ce9e3cb5debf":"d8NEQ","969be431eae4eb00":"k4pQz"}],"1EnDk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>(0, _reactDom.unstable_batchedUpdates));
var _reactDom = require("react-dom");

},{"react-dom":"cy9SD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1bpek":[function(require,module,exports) {
// Default to a dummy "batch" implementation that just runs the callback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBatch", ()=>setBatch);
parcelHelpers.export(exports, "getBatch", ()=>getBatch);
function defaultNoopBatch(callback) {
    callback();
}
let batch = defaultNoopBatch; // Allow injecting another batching function later
const setBatch = (newBatch)=>batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const getBatch = ()=>batch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"NHfmY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeUseSelector", ()=>initializeUseSelector);
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
var _react = require("react");
var _useReduxContext = require("./useReduxContext");
var _context = require("../components/Context");
var _useSyncExternalStore = require("../utils/useSyncExternalStore");
let useSyncExternalStoreWithSelector = (0, _useSyncExternalStore.notInitialized);
const initializeUseSelector = (fn)=>{
    useSyncExternalStoreWithSelector = fn;
};
const refEquality = (a, b)=>a === b;
function createSelectorHook(context = (0, _context.ReactReduxContext)) {
    const useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : ()=>(0, _react.useContext)(context);
    return function useSelector(selector, equalityFn = refEquality) {
        const { store, subscription, getServerState } = useReduxContext();
        const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, selector, equalityFn);
        (0, _react.useDebugValue)(selectedState);
        return selectedState;
    };
}
const useSelector = /*#__PURE__*/ createSelectorHook();

},{"react":"d8NEQ","./useReduxContext":"akvZx","../components/Context":"lcrHj","../utils/useSyncExternalStore":"eNJWN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"akvZx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */ parcelHelpers.export(exports, "useReduxContext", ()=>useReduxContext);
var _react = require("react");
var _context = require("../components/Context");
function useReduxContext() {
    const contextValue = (0, _react.useContext)((0, _context.ReactReduxContext));
    return contextValue;
}

},{"react":"d8NEQ","../components/Context":"lcrHj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lcrHj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
var _react = require("react");
const ReactReduxContext = /*#__PURE__*/ (0, _react.createContext)(null);
exports.default = ReactReduxContext;

},{"react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eNJWN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notInitialized", ()=>notInitialized);
const notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9HwCx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeConnect", ()=>initializeConnect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */ var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIs = require("react-is");
var _selectorFactory = require("../connect/selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
var _mapDispatchToProps = require("../connect/mapDispatchToProps");
var _mapStateToProps = require("../connect/mapStateToProps");
var _mergeProps = require("../connect/mergeProps");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _context = require("./Context");
var _useSyncExternalStore = require("../utils/useSyncExternalStore");
const _excluded = [
    "reactReduxForwardedRef"
];
let useSyncExternalStore = (0, _useSyncExternalStore.notInitialized);
const initializeConnect = (fn)=>{
    useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const EMPTY_ARRAY = [
    null,
    0
];
const NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const initStateUpdates = ()=>EMPTY_ARRAY;
function strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function connect(mapStateToProps, mapDispatchToProps, mergeProps, { // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual = strictEqual, areOwnPropsEqual = (0, _shallowEqualDefault.default), areStatePropsEqual = (0, _shallowEqualDefault.default), areMergedPropsEqual = (0, _shallowEqualDefault.default), // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, // the context consumer to use
context = (0, _context.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, _mapStateToProps.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, _mapDispatchToProps.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, _mergeProps.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges,
            displayName,
            wrappedComponentName,
            WrappedComponent,
            // @ts-ignore
            initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps,
            initMergeProps,
            areStatesEqual,
            areStatePropsEqual,
            areOwnPropsEqual,
            areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = (0, _react.useMemo)(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef } = props, wrapperProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = (0, _react.useMemo)(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, _reactIs.isContextConsumer)(/*#__PURE__*/ (0, _reactDefault.default).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = (0, _react.useMemo)(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, _selectorFactoryDefault.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = (0, _react.useMemo)(()=>{
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, _subscription.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = (0, _react.useMemo)(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, _extendsDefault.default)({}, contextValue, {
                    subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = (0, _react.useRef)();
            const lastWrapperProps = (0, _react.useRef)(wrapperProps);
            const childPropsFromStoreUpdate = (0, _react.useRef)();
            const renderIsScheduled = (0, _react.useRef)(false);
            const isProcessingDispatch = (0, _react.useRef)(false);
            const isMounted = (0, _react.useRef)(false);
            const latestSubscriptionCallbackError = (0, _react.useRef)();
            (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = (0, _react.useMemo)(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = (0, _react.useMemo)(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = (0, _react.useMemo)(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                (0, _reactDefault.default).createElement(WrappedComponent, (0, _extendsDefault.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = (0, _react.useMemo)(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = (0, _reactDefault.default).memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = (0, _reactDefault.default).forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(Connect, (0, _extendsDefault.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, _hoistNonReactStaticsDefault.default)(forwarded, WrappedComponent);
        }
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
exports.default = connect;

},{"@babel/runtime/helpers/esm/extends":"gQbb0","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ju8Ia","hoist-non-react-statics":"3xfN4","react":"d8NEQ","react-is":"l4dfd","../connect/selectorFactory":"1CJqM","../connect/mapDispatchToProps":"47Cdp","../connect/mapStateToProps":"5C1jD","../connect/mergeProps":"9J21K","../utils/Subscription":"Z8fOl","../utils/useIsomorphicLayoutEffect":"iNFO1","../utils/shallowEqual":"7HzsP","../utils/warning":"8NkBY","./Context":"lcrHj","../utils/useSyncExternalStore":"eNJWN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gQbb0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ju8Ia":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l4dfd":[function(require,module,exports) {
"use strict";
module.exports = require("c09df6e873313925");

},{"c09df6e873313925":"4idM0"}],"4idM0":[function(require,module,exports) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"1CJqM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", ()=>pureFinalPropsSelectorFactory);
parcelHelpers.export(exports, "default", ()=>finalPropsSelectorFactory);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
const _excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual, areOwnPropsEqual, areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref) {
    let { initMapStateToProps, initMapDispatchToProps, initMergeProps } = _ref, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"ju8Ia","./verifySubselectors":"gj7vB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gj7vB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifySubselectors);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, _warningDefault.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    verify(mapStateToProps, "mapStateToProps");
    verify(mapDispatchToProps, "mapDispatchToProps");
    verify(mergeProps, "mergeProps");
}

},{"../utils/warning":"8NkBY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8NkBY":[function(require,module,exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warning);
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"47Cdp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToPropsFactory", ()=>mapDispatchToPropsFactory);
var _bindActionCreators = require("../utils/bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _wrapMapToProps = require("./wrapMapToProps");
var _invalidArgFactory = require("./invalidArgFactory");
function mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, _wrapMapToProps.wrapMapToPropsConstant)((dispatch)=>(0, _bindActionCreatorsDefault.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)((dispatch)=>({
            dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, _invalidArgFactory.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

},{"../utils/bindActionCreators":"ii9Zn","./wrapMapToProps":"4aFAy","./invalidArgFactory":"kBMoB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ii9Zn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bindActionCreators);
function bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4aFAy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", ()=>wrapMapToPropsConstant) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
// TODO Can this get pulled out so that we can subscribe directly to the store if we don't need ownProps?
parcelHelpers.export(exports, "getDependsOnOwnProps", ()=>getDependsOnOwnProps) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//
parcelHelpers.export(exports, "wrapMapToPropsFunc", ()=>wrapMapToPropsFunc);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"XEUK8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"XEUK8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifyPlainObject);
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

},{"./isPlainObject":"1Kgtr","./warning":"8NkBY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1Kgtr":[function(require,module,exports) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPlainObject);
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kBMoB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvalidArgFactory", ()=>createInvalidArgFactory);
function createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5C1jD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToPropsFactory", ()=>mapStateToPropsFactory);
var _wrapMapToProps = require("./wrapMapToProps");
var _invalidArgFactory = require("./invalidArgFactory");
function mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === "function" ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, _invalidArgFactory.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

},{"./wrapMapToProps":"4aFAy","./invalidArgFactory":"kBMoB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9J21K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", ()=>defaultMergeProps);
parcelHelpers.export(exports, "wrapMergePropsFunc", ()=>wrapMergePropsFunc);
parcelHelpers.export(exports, "mergePropsFactory", ()=>mergePropsFactory);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
var _invalidArgFactory = require("./invalidArgFactory");
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName, areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>defaultMergeProps : typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : (0, _invalidArgFactory.createInvalidArgFactory)(mergeProps, "mergeProps");
}

},{"@babel/runtime/helpers/esm/extends":"gQbb0","../utils/verifyPlainObject":"XEUK8","./invalidArgFactory":"kBMoB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"Z8fOl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscription", ()=>createSubscription);
var _batch = require("./batch"); // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
    const batch = (0, _batch.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const nullListeners = {
    notify () {},
    get: ()=>[]
};
function createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    const subscription = {
        addNestedSub,
        notifyNestedSubs,
        handleChangeWrapper,
        isSubscribed,
        trySubscribe,
        tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}

},{"./batch":"1bpek","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iNFO1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react"); // React currently throws a warning when using useLayoutEffect on the server.
const canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const useIsomorphicLayoutEffect = canUseDOM ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7HzsP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowEqual);
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"DnxWa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "ReactReduxContext", ()=>(0, _context.ReactReduxContext));
parcelHelpers.export(exports, "connect", ()=>(0, _connectDefault.default));
parcelHelpers.export(exports, "useDispatch", ()=>(0, _useDispatch.useDispatch));
parcelHelpers.export(exports, "createDispatchHook", ()=>(0, _useDispatch.createDispatchHook));
parcelHelpers.export(exports, "useSelector", ()=>(0, _useSelector.useSelector));
parcelHelpers.export(exports, "createSelectorHook", ()=>(0, _useSelector.createSelectorHook));
parcelHelpers.export(exports, "useStore", ()=>(0, _useStore.useStore));
parcelHelpers.export(exports, "createStoreHook", ()=>(0, _useStore.createStoreHook));
parcelHelpers.export(exports, "shallowEqual", ()=>(0, _shallowEqualDefault.default));
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connect = require("./components/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _context = require("./components/Context");
var _useDispatch = require("./hooks/useDispatch");
var _useSelector = require("./hooks/useSelector");
var _useStore = require("./hooks/useStore");
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./components/Provider":"dj1tM","./components/connect":"9HwCx","./components/Context":"lcrHj","./hooks/useDispatch":"rasNy","./hooks/useSelector":"NHfmY","./hooks/useStore":"6ePPR","./utils/shallowEqual":"7HzsP","./types":"6Os45","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dj1tM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("./Context");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
function Provider({ store, context, children, serverState }) {
    const contextValue = (0, _react.useMemo)(()=>{
        const subscription = (0, _subscription.createSubscription)(store);
        return {
            store,
            subscription,
            getServerState: serverState ? ()=>serverState : undefined
        };
    }, [
        store,
        serverState
    ]);
    const previousState = (0, _react.useMemo)(()=>store.getState(), [
        store
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(()=>{
        const { subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, _context.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
exports.default = Provider;

},{"react":"d8NEQ","./Context":"lcrHj","../utils/Subscription":"Z8fOl","../utils/useIsomorphicLayoutEffect":"iNFO1","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"rasNy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
var _context = require("../components/Context");
var _useStore = require("./useStore");
function createDispatchHook(context = (0, _context.ReactReduxContext)) {
    const useStore = context === (0, _context.ReactReduxContext) ? (0, _useStore.useStore) : (0, _useStore.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const useDispatch = /*#__PURE__*/ createDispatchHook();

},{"../components/Context":"lcrHj","./useStore":"6ePPR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6ePPR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "useStore", ()=>useStore);
var _react = require("react");
var _context = require("../components/Context");
var _useReduxContext = require("./useReduxContext");
function createStoreHook(context = (0, _context.ReactReduxContext)) {
    const useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : ()=>(0, _react.useContext)(context);
    return function useStore() {
        const { store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const useStore = /*#__PURE__*/ createStoreHook();

},{"react":"d8NEQ","../components/Context":"lcrHj","./useReduxContext":"akvZx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6Os45":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bkusY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerStyleSheet", ()=>Ue);
parcelHelpers.export(exports, "StyleSheetConsumer", ()=>ue);
parcelHelpers.export(exports, "StyleSheetContext", ()=>ce);
parcelHelpers.export(exports, "StyleSheetManager", ()=>me);
parcelHelpers.export(exports, "ThemeConsumer", ()=>Ge);
parcelHelpers.export(exports, "ThemeContext", ()=>Me);
parcelHelpers.export(exports, "ThemeProvider", ()=>Le);
parcelHelpers.export(exports, "__PRIVATE__", ()=>Ze);
parcelHelpers.export(exports, "createGlobalStyle", ()=>$e);
parcelHelpers.export(exports, "css", ()=>Ae);
parcelHelpers.export(exports, "isStyledComponent", ()=>_);
parcelHelpers.export(exports, "keyframes", ()=>We);
parcelHelpers.export(exports, "useTheme", ()=>Xe);
parcelHelpers.export(exports, "version", ()=>A);
parcelHelpers.export(exports, "withTheme", ()=>Je);
var _reactIs = require("react-is");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
var _stylis = require("@emotion/stylis");
var _stylisDefault = parcelHelpers.interopDefault(_stylis);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var process = require("50571207bc3cae02");
function y() {
    return (y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, _reactIs.typeOf)(t);
}, S = Object.freeze([]), w = Object.freeze({});
function E(e) {
    return "function" == typeof e;
}
function b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function _(e) {
    return e && "string" == typeof e.styledComponentId;
}
var N = ("undefined" != typeof process && void 0 !== process.env && undefined, "data-styled"), A = "5.3.11", C = "undefined" != typeof window && "HTMLElement" in window, I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && false), P = {}, O = {};
function R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), T = new Map, x = new Map, k = 1, V = function(e) {
    if (T.has(e)) return T.get(e);
    for(; x.has(k);)k++;
    var t = k++;
    return T.set(e, t), x.set(t, e), t;
}, B = function(e) {
    return x.get(e);
}, z = function(e, t) {
    t >= k && (k = t + 1), T.set(e, t), x.set(t, e);
}, M = "style[" + N + '][data-styled-version="5.3.11"]', G = new RegExp("^" + N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match(G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && (z(u, c), L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute(N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute(N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, H = function() {
    function e(e) {
        var t = this.element = q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $ = function() {
    function e(e) {
        var t = this.element = q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), U = C, J = {
    isServer: !C,
    useCSSOMInjection: !I
}, X = function() {
    function e(e, t, n) {
        void 0 === e && (e = w), void 0 === t && (t = {}), this.options = y({}, J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && C && U && (U = !1, function(e) {
            for(var t = document.querySelectorAll(M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute(N) && (F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e(y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new W(o) : r ? new H(o) : new $(o), new j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if (V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules(V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup(V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), Z = /(a)(d)/gi, K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = K(t % 52) + n;
    return (K(t % 52) + n).replace(Z, "$1-$2");
}
var ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, te = function(e) {
    return ee(5381, e);
};
function ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if (E(n) && !_(n)) return !1;
    }
    return !0;
}
var re = te("5.3.11"), oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && ne(e), this.componentId = t, this.baseHash = ee(re, t), this.baseStyle = n, X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = _e(this.rules, e, t, n).join(""), i = Q(ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = _e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), se = /^\s*\/\/.*$/gm, ie = [
    ":",
    "[",
    ".",
    "#"
];
function ae(e) {
    var t, n, r, o, s = void 0 === e ? w : e, i = s.options, a = void 0 === i ? w : i, c = s.plugins, u = void 0 === c ? S : c, l = new (0, _stylisDefault.default)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace(se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || D(15), ee(e, t.name);
    }, 5381).toString() : "", m;
}
var ce = (0, _reactDefault.default).createContext(), ue = ce.Consumer, le = (0, _reactDefault.default).createContext(), de = (le.Consumer, new X), he = ae();
function pe() {
    return (0, _react.useContext)(ce) || de;
}
function fe() {
    return (0, _react.useContext)(le) || he;
}
function me(e) {
    var t = (0, _react.useState)(e.stylisPlugins), n = t[0], s = t[1], c = pe(), u = (0, _react.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, _react.useMemo)(function() {
        return ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, _react.useEffect)(function() {
        (0, _shallowequalDefault.default)(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, _reactDefault.default).createElement(ce.Provider, {
        value: u
    }, (0, _reactDefault.default).createElement(le.Provider, {
        value: l
    }, (0, e.children)));
}
var ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = he), this.name + e.hash;
    }, e;
}(), ve = /([A-Z])/, ge = /([A-Z])/g, Se = /^ms-/, we = function(e) {
    return "-" + e.toLowerCase();
};
function Ee(e) {
    return ve.test(e) ? e.replace(ge, we).replace(Se, "-ms-") : e;
}
var be = function(e) {
    return null == e || !1 === e || "" === e;
};
function _e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = _e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if (be(e)) return "";
    if (_(e)) return "." + e.styledComponentId;
    if (E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return _e(u, n, r, o);
    }
    var l;
    return e instanceof ye ? r ? (e.inject(r, o), e.getName(o)) : e : g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || E(t[i]) ? s.push(Ee(i) + ":", t[i], ";") : g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push(Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, _unitlessDefault.default) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function Ae(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return E(e) || g(e) ? Ne(_e(v(S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : Ne(_e(v(e, n)));
}
var Ce = /invalid hook call/i, Ie = new Set, Pe = function(e, t) {
    var n, r, o, e1;
}, Oe = function(e, t, n) {
    return void 0 === n && (n = w), e.theme !== n.theme && e.theme || t || n.theme;
}, Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, De = /(^-|-$)/g;
function je(e) {
    return e.replace(Re, "-").replace(De, "");
}
var Te = function(e) {
    return Q(te(e) >>> 0);
};
function xe(e) {
    return "string" == typeof e && true;
}
var ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function Be(e, t, n) {
    var r = e[n];
    ke(t) && ke(r) ? ze(r, t) : e[n] = t;
}
function ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if (ke(i)) for(var a in i)Ve(a) && Be(e, i[a], a);
    }
    return e;
}
var Me = (0, _reactDefault.default).createContext(), Ge = Me.Consumer;
function Le(e) {
    var t = (0, _react.useContext)(Me), n = (0, _react.useMemo)(function() {
        return function(e, t) {
            if (!e) return D(14);
            if (E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? D(8) : t ? y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, _reactDefault.default).createElement(Me.Provider, {
        value: n
    }, e.children) : null;
}
var Fe = {};
function Ye(e, t, n) {
    var o = _(e), i = !xe(e), a = t.attrs, c = void 0 === a ? S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : je(e);
        Fe[n] = (Fe[n] || 0) + 1;
        var r = n + "-" + Te("5.3.11" + n + Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return xe(e) ? "styled." + e : "Styled(" + b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = w);
                var r = y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }(Oe(t, (0, _react.useContext)(Me), a) || w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = pe(), s = fe(), i = t ? e.generateAndInjectStyles(w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = xe(b), N = v !== t ? y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, _isPropValidDefault.default), b) : !_ || (0, _isPropValidDefault.default)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, _react.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, _reactDefault.default).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + (xe(e) ? e : je(b(e)));
        return Ye(e, y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, _hoistNonReactStaticsDefault.default)(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = w), !(0, _reactIs.isValidElementType)(r)) return D(1, String(r));
        var s = function() {
            return t(r, o, Ae.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }(Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    qe[e] = qe(e);
});
var He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = ne(e), X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r(_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = Ae.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + Te(JSON.stringify(i)), u = new He(i, a);
    function d(e) {
        var t = pe(), n = fe(), o = (0, _react.useContext)(Me), d = (0, _react.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, _react.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, P, n, o);
        else {
            var s = y({}, t, {
                theme: Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, _reactDefault.default).memo(d);
}
function We(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = Ae.apply(void 0, [
        e
    ].concat(n)).join(""), s = Te(o);
    return new ye(s, o);
}
var Ue = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return D(2);
            var n = ((t = {})[N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = Y();
            return o && (n.nonce = o), [
                (0, _reactDefault.default).createElement("style", y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? D(2) : (0, _reactDefault.default).createElement(me, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return D(3);
    }, e;
}(), Je = function(e) {
    var t = (0, _reactDefault.default).forwardRef(function(t, n) {
        var o = (0, _react.useContext)(Me), i = e.defaultProps, a = Oe(t, o, i);
        return (0, _reactDefault.default).createElement(e, y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, _hoistNonReactStaticsDefault.default)(t, e), t.displayName = "WithTheme(" + b(e) + ")", t;
}, Xe = function() {
    return (0, _react.useContext)(Me);
}, Ze = {
    StyleSheet: X,
    masterSheet: de
};
exports.default = qe;

},{"50571207bc3cae02":"h0XoY","react-is":"j0bVX","react":"d8NEQ","shallowequal":"iqAWt","@emotion/stylis":"c4sEL","@emotion/unitless":"cSKmu","@emotion/is-prop-valid":"o9rJl","hoist-non-react-statics":"3xfN4","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h0XoY":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"iqAWt":[function(require,module,exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"c4sEL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
exports.default = stylis_min;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cSKmu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"o9rJl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
exports.default = isPropValid;

},{"@emotion/memoize":"eadMB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eadMB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
exports.default = memoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"JPp0Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "F", ()=>(0, _fJsDefault.default));
parcelHelpers.export(exports, "T", ()=>(0, _tJsDefault.default));
parcelHelpers.export(exports, "__", ()=>(0, _jsDefault.default));
parcelHelpers.export(exports, "add", ()=>(0, _addJsDefault.default));
parcelHelpers.export(exports, "addIndex", ()=>(0, _addIndexJsDefault.default));
parcelHelpers.export(exports, "adjust", ()=>(0, _adjustJsDefault.default));
parcelHelpers.export(exports, "all", ()=>(0, _allJsDefault.default));
parcelHelpers.export(exports, "allPass", ()=>(0, _allPassJsDefault.default));
parcelHelpers.export(exports, "always", ()=>(0, _alwaysJsDefault.default));
parcelHelpers.export(exports, "and", ()=>(0, _andJsDefault.default));
parcelHelpers.export(exports, "any", ()=>(0, _anyJsDefault.default));
parcelHelpers.export(exports, "anyPass", ()=>(0, _anyPassJsDefault.default));
parcelHelpers.export(exports, "ap", ()=>(0, _apJsDefault.default));
parcelHelpers.export(exports, "aperture", ()=>(0, _apertureJsDefault.default));
parcelHelpers.export(exports, "append", ()=>(0, _appendJsDefault.default));
parcelHelpers.export(exports, "apply", ()=>(0, _applyJsDefault.default));
parcelHelpers.export(exports, "applySpec", ()=>(0, _applySpecJsDefault.default));
parcelHelpers.export(exports, "applyTo", ()=>(0, _applyToJsDefault.default));
parcelHelpers.export(exports, "ascend", ()=>(0, _ascendJsDefault.default));
parcelHelpers.export(exports, "assoc", ()=>(0, _assocJsDefault.default));
parcelHelpers.export(exports, "assocPath", ()=>(0, _assocPathJsDefault.default));
parcelHelpers.export(exports, "binary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "bind", ()=>(0, _bindJsDefault.default));
parcelHelpers.export(exports, "both", ()=>(0, _bothJsDefault.default));
parcelHelpers.export(exports, "call", ()=>(0, _callJsDefault.default));
parcelHelpers.export(exports, "chain", ()=>(0, _chainJsDefault.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampJsDefault.default));
parcelHelpers.export(exports, "clone", ()=>(0, _cloneJsDefault.default));
parcelHelpers.export(exports, "comparator", ()=>(0, _comparatorJsDefault.default));
parcelHelpers.export(exports, "complement", ()=>(0, _complementJsDefault.default));
parcelHelpers.export(exports, "compose", ()=>(0, _composeJsDefault.default));
parcelHelpers.export(exports, "composeK", ()=>(0, _composeKJsDefault.default));
parcelHelpers.export(exports, "composeP", ()=>(0, _composePJsDefault.default));
parcelHelpers.export(exports, "composeWith", ()=>(0, _composeWithJsDefault.default));
parcelHelpers.export(exports, "concat", ()=>(0, _concatJsDefault.default));
parcelHelpers.export(exports, "cond", ()=>(0, _condJsDefault.default));
parcelHelpers.export(exports, "construct", ()=>(0, _constructJsDefault.default));
parcelHelpers.export(exports, "constructN", ()=>(0, _constructNJsDefault.default));
parcelHelpers.export(exports, "contains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "converge", ()=>(0, _convergeJsDefault.default));
parcelHelpers.export(exports, "countBy", ()=>(0, _countByJsDefault.default));
parcelHelpers.export(exports, "curry", ()=>(0, _curryJsDefault.default));
parcelHelpers.export(exports, "curryN", ()=>(0, _curryNJsDefault.default));
parcelHelpers.export(exports, "dec", ()=>(0, _decJsDefault.default));
parcelHelpers.export(exports, "defaultTo", ()=>(0, _defaultToJsDefault.default));
parcelHelpers.export(exports, "descend", ()=>(0, _descendJsDefault.default));
parcelHelpers.export(exports, "difference", ()=>(0, _differenceJsDefault.default));
parcelHelpers.export(exports, "differenceWith", ()=>(0, _differenceWithJsDefault.default));
parcelHelpers.export(exports, "dissoc", ()=>(0, _dissocJsDefault.default));
parcelHelpers.export(exports, "dissocPath", ()=>(0, _dissocPathJsDefault.default));
parcelHelpers.export(exports, "divide", ()=>(0, _divideJsDefault.default));
parcelHelpers.export(exports, "drop", ()=>(0, _dropJsDefault.default));
parcelHelpers.export(exports, "dropLast", ()=>(0, _dropLastJsDefault.default));
parcelHelpers.export(exports, "dropLastWhile", ()=>(0, _dropLastWhileJsDefault.default));
parcelHelpers.export(exports, "dropRepeats", ()=>(0, _dropRepeatsJsDefault.default));
parcelHelpers.export(exports, "dropRepeatsWith", ()=>(0, _dropRepeatsWithJsDefault.default));
parcelHelpers.export(exports, "dropWhile", ()=>(0, _dropWhileJsDefault.default));
parcelHelpers.export(exports, "either", ()=>(0, _eitherJsDefault.default));
parcelHelpers.export(exports, "empty", ()=>(0, _emptyJsDefault.default));
parcelHelpers.export(exports, "endsWith", ()=>(0, _endsWithJsDefault.default));
parcelHelpers.export(exports, "eqBy", ()=>(0, _eqByJsDefault.default));
parcelHelpers.export(exports, "eqProps", ()=>(0, _eqPropsJsDefault.default));
parcelHelpers.export(exports, "equals", ()=>(0, _equalsJsDefault.default));
parcelHelpers.export(exports, "evolve", ()=>(0, _evolveJsDefault.default));
parcelHelpers.export(exports, "filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "find", ()=>(0, _findJsDefault.default));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndexJsDefault.default));
parcelHelpers.export(exports, "findLast", ()=>(0, _findLastJsDefault.default));
parcelHelpers.export(exports, "findLastIndex", ()=>(0, _findLastIndexJsDefault.default));
parcelHelpers.export(exports, "flatten", ()=>(0, _flattenJsDefault.default));
parcelHelpers.export(exports, "flip", ()=>(0, _flipJsDefault.default));
parcelHelpers.export(exports, "forEach", ()=>(0, _forEachJsDefault.default));
parcelHelpers.export(exports, "forEachObjIndexed", ()=>(0, _forEachObjIndexedJsDefault.default));
parcelHelpers.export(exports, "fromPairs", ()=>(0, _fromPairsJsDefault.default));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupByJsDefault.default));
parcelHelpers.export(exports, "groupWith", ()=>(0, _groupWithJsDefault.default));
parcelHelpers.export(exports, "gt", ()=>(0, _gtJsDefault.default));
parcelHelpers.export(exports, "gte", ()=>(0, _gteJsDefault.default));
parcelHelpers.export(exports, "has", ()=>(0, _hasJsDefault.default));
parcelHelpers.export(exports, "hasIn", ()=>(0, _hasInJsDefault.default));
parcelHelpers.export(exports, "hasPath", ()=>(0, _hasPathJsDefault.default));
parcelHelpers.export(exports, "head", ()=>(0, _headJsDefault.default));
parcelHelpers.export(exports, "identical", ()=>(0, _identicalJsDefault.default));
parcelHelpers.export(exports, "identity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "ifElse", ()=>(0, _ifElseJsDefault.default));
parcelHelpers.export(exports, "inc", ()=>(0, _incJsDefault.default));
parcelHelpers.export(exports, "includes", ()=>(0, _includesJsDefault.default));
parcelHelpers.export(exports, "indexBy", ()=>(0, _indexByJsDefault.default));
parcelHelpers.export(exports, "indexOf", ()=>(0, _indexOfJsDefault.default));
parcelHelpers.export(exports, "init", ()=>(0, _initJsDefault.default));
parcelHelpers.export(exports, "innerJoin", ()=>(0, _innerJoinJsDefault.default));
parcelHelpers.export(exports, "insert", ()=>(0, _insertJsDefault.default));
parcelHelpers.export(exports, "insertAll", ()=>(0, _insertAllJsDefault.default));
parcelHelpers.export(exports, "intersection", ()=>(0, _intersectionJsDefault.default));
parcelHelpers.export(exports, "intersperse", ()=>(0, _intersperseJsDefault.default));
parcelHelpers.export(exports, "into", ()=>(0, _intoJsDefault.default));
parcelHelpers.export(exports, "invert", ()=>(0, _invertJsDefault.default));
parcelHelpers.export(exports, "invertObj", ()=>(0, _invertObjJsDefault.default));
parcelHelpers.export(exports, "invoker", ()=>(0, _invokerJsDefault.default));
parcelHelpers.export(exports, "is", ()=>(0, _isJsDefault.default));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmptyJsDefault.default));
parcelHelpers.export(exports, "isNil", ()=>(0, _isNilJsDefault.default));
parcelHelpers.export(exports, "join", ()=>(0, _joinJsDefault.default));
parcelHelpers.export(exports, "juxt", ()=>(0, _juxtJsDefault.default));
parcelHelpers.export(exports, "keys", ()=>(0, _keysJsDefault.default));
parcelHelpers.export(exports, "keysIn", ()=>(0, _keysInJsDefault.default));
parcelHelpers.export(exports, "last", ()=>(0, _lastJsDefault.default));
parcelHelpers.export(exports, "lastIndexOf", ()=>(0, _lastIndexOfJsDefault.default));
parcelHelpers.export(exports, "length", ()=>(0, _lengthJsDefault.default));
parcelHelpers.export(exports, "lens", ()=>(0, _lensJsDefault.default));
parcelHelpers.export(exports, "lensIndex", ()=>(0, _lensIndexJsDefault.default));
parcelHelpers.export(exports, "lensPath", ()=>(0, _lensPathJsDefault.default));
parcelHelpers.export(exports, "lensProp", ()=>(0, _lensPropJsDefault.default));
parcelHelpers.export(exports, "lift", ()=>(0, _liftJsDefault.default));
parcelHelpers.export(exports, "liftN", ()=>(0, _liftNJsDefault.default));
parcelHelpers.export(exports, "lt", ()=>(0, _ltJsDefault.default));
parcelHelpers.export(exports, "lte", ()=>(0, _lteJsDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "mapAccum", ()=>(0, _mapAccumJsDefault.default));
parcelHelpers.export(exports, "mapAccumRight", ()=>(0, _mapAccumRightJsDefault.default));
parcelHelpers.export(exports, "mapObjIndexed", ()=>(0, _mapObjIndexedJsDefault.default));
parcelHelpers.export(exports, "match", ()=>(0, _matchJsDefault.default));
parcelHelpers.export(exports, "mathMod", ()=>(0, _mathModJsDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "maxBy", ()=>(0, _maxByJsDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanJsDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianJsDefault.default));
parcelHelpers.export(exports, "memoizeWith", ()=>(0, _memoizeWithJsDefault.default));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAllJsDefault.default));
parcelHelpers.export(exports, "mergeDeepLeft", ()=>(0, _mergeDeepLeftJsDefault.default));
parcelHelpers.export(exports, "mergeDeepRight", ()=>(0, _mergeDeepRightJsDefault.default));
parcelHelpers.export(exports, "mergeDeepWith", ()=>(0, _mergeDeepWithJsDefault.default));
parcelHelpers.export(exports, "mergeDeepWithKey", ()=>(0, _mergeDeepWithKeyJsDefault.default));
parcelHelpers.export(exports, "mergeLeft", ()=>(0, _mergeLeftJsDefault.default));
parcelHelpers.export(exports, "mergeRight", ()=>(0, _mergeRightJsDefault.default));
parcelHelpers.export(exports, "mergeWith", ()=>(0, _mergeWithJsDefault.default));
parcelHelpers.export(exports, "mergeWithKey", ()=>(0, _mergeWithKeyJsDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minJsDefault.default));
parcelHelpers.export(exports, "minBy", ()=>(0, _minByJsDefault.default));
parcelHelpers.export(exports, "modulo", ()=>(0, _moduloJsDefault.default));
parcelHelpers.export(exports, "move", ()=>(0, _moveJsDefault.default));
parcelHelpers.export(exports, "multiply", ()=>(0, _multiplyJsDefault.default));
parcelHelpers.export(exports, "nAry", ()=>(0, _nAryJsDefault.default));
parcelHelpers.export(exports, "negate", ()=>(0, _negateJsDefault.default));
parcelHelpers.export(exports, "none", ()=>(0, _noneJsDefault.default));
parcelHelpers.export(exports, "not", ()=>(0, _notJsDefault.default));
parcelHelpers.export(exports, "nth", ()=>(0, _nthJsDefault.default));
parcelHelpers.export(exports, "nthArg", ()=>(0, _nthArgJsDefault.default));
parcelHelpers.export(exports, "o", ()=>(0, _oJsDefault.default));
parcelHelpers.export(exports, "objOf", ()=>(0, _objOfJsDefault.default));
parcelHelpers.export(exports, "of", ()=>(0, _ofJsDefault.default));
parcelHelpers.export(exports, "omit", ()=>(0, _omitJsDefault.default));
parcelHelpers.export(exports, "once", ()=>(0, _onceJsDefault.default));
parcelHelpers.export(exports, "or", ()=>(0, _orJsDefault.default));
parcelHelpers.export(exports, "otherwise", ()=>(0, _otherwiseJsDefault.default));
parcelHelpers.export(exports, "over", ()=>(0, _overJsDefault.default));
parcelHelpers.export(exports, "pair", ()=>(0, _pairJsDefault.default));
parcelHelpers.export(exports, "partial", ()=>(0, _partialJsDefault.default));
parcelHelpers.export(exports, "partialRight", ()=>(0, _partialRightJsDefault.default));
parcelHelpers.export(exports, "partition", ()=>(0, _partitionJsDefault.default));
parcelHelpers.export(exports, "path", ()=>(0, _pathJsDefault.default));
parcelHelpers.export(exports, "paths", ()=>(0, _pathsJsDefault.default));
parcelHelpers.export(exports, "pathEq", ()=>(0, _pathEqJsDefault.default));
parcelHelpers.export(exports, "pathOr", ()=>(0, _pathOrJsDefault.default));
parcelHelpers.export(exports, "pathSatisfies", ()=>(0, _pathSatisfiesJsDefault.default));
parcelHelpers.export(exports, "pick", ()=>(0, _pickJsDefault.default));
parcelHelpers.export(exports, "pickAll", ()=>(0, _pickAllJsDefault.default));
parcelHelpers.export(exports, "pickBy", ()=>(0, _pickByJsDefault.default));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipeJsDefault.default));
parcelHelpers.export(exports, "pipeK", ()=>(0, _pipeKJsDefault.default));
parcelHelpers.export(exports, "pipeP", ()=>(0, _pipePJsDefault.default));
parcelHelpers.export(exports, "pipeWith", ()=>(0, _pipeWithJsDefault.default));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluckJsDefault.default));
parcelHelpers.export(exports, "prepend", ()=>(0, _prependJsDefault.default));
parcelHelpers.export(exports, "product", ()=>(0, _productJsDefault.default));
parcelHelpers.export(exports, "project", ()=>(0, _projectJsDefault.default));
parcelHelpers.export(exports, "prop", ()=>(0, _propJsDefault.default));
parcelHelpers.export(exports, "propEq", ()=>(0, _propEqJsDefault.default));
parcelHelpers.export(exports, "propIs", ()=>(0, _propIsJsDefault.default));
parcelHelpers.export(exports, "propOr", ()=>(0, _propOrJsDefault.default));
parcelHelpers.export(exports, "propSatisfies", ()=>(0, _propSatisfiesJsDefault.default));
parcelHelpers.export(exports, "props", ()=>(0, _propsJsDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeJsDefault.default));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduceJsDefault.default));
parcelHelpers.export(exports, "reduceBy", ()=>(0, _reduceByJsDefault.default));
parcelHelpers.export(exports, "reduceRight", ()=>(0, _reduceRightJsDefault.default));
parcelHelpers.export(exports, "reduceWhile", ()=>(0, _reduceWhileJsDefault.default));
parcelHelpers.export(exports, "reduced", ()=>(0, _reducedJsDefault.default));
parcelHelpers.export(exports, "reject", ()=>(0, _rejectJsDefault.default));
parcelHelpers.export(exports, "remove", ()=>(0, _removeJsDefault.default));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeatJsDefault.default));
parcelHelpers.export(exports, "replace", ()=>(0, _replaceJsDefault.default));
parcelHelpers.export(exports, "reverse", ()=>(0, _reverseJsDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanJsDefault.default));
parcelHelpers.export(exports, "sequence", ()=>(0, _sequenceJsDefault.default));
parcelHelpers.export(exports, "set", ()=>(0, _setJsDefault.default));
parcelHelpers.export(exports, "slice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "sort", ()=>(0, _sortJsDefault.default));
parcelHelpers.export(exports, "sortBy", ()=>(0, _sortByJsDefault.default));
parcelHelpers.export(exports, "sortWith", ()=>(0, _sortWithJsDefault.default));
parcelHelpers.export(exports, "split", ()=>(0, _splitJsDefault.default));
parcelHelpers.export(exports, "splitAt", ()=>(0, _splitAtJsDefault.default));
parcelHelpers.export(exports, "splitEvery", ()=>(0, _splitEveryJsDefault.default));
parcelHelpers.export(exports, "splitWhen", ()=>(0, _splitWhenJsDefault.default));
parcelHelpers.export(exports, "startsWith", ()=>(0, _startsWithJsDefault.default));
parcelHelpers.export(exports, "subtract", ()=>(0, _subtractJsDefault.default));
parcelHelpers.export(exports, "sum", ()=>(0, _sumJsDefault.default));
parcelHelpers.export(exports, "symmetricDifference", ()=>(0, _symmetricDifferenceJsDefault.default));
parcelHelpers.export(exports, "symmetricDifferenceWith", ()=>(0, _symmetricDifferenceWithJsDefault.default));
parcelHelpers.export(exports, "tail", ()=>(0, _tailJsDefault.default));
parcelHelpers.export(exports, "take", ()=>(0, _takeJsDefault.default));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLastJsDefault.default));
parcelHelpers.export(exports, "takeLastWhile", ()=>(0, _takeLastWhileJsDefault.default));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhileJsDefault.default));
parcelHelpers.export(exports, "tap", ()=>(0, _tapJsDefault.default));
parcelHelpers.export(exports, "test", ()=>(0, _testJsDefault.default));
parcelHelpers.export(exports, "andThen", ()=>(0, _andThenJsDefault.default));
parcelHelpers.export(exports, "times", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "toLower", ()=>(0, _toLowerJsDefault.default));
parcelHelpers.export(exports, "toPairs", ()=>(0, _toPairsJsDefault.default));
parcelHelpers.export(exports, "toPairsIn", ()=>(0, _toPairsInJsDefault.default));
parcelHelpers.export(exports, "toString", ()=>(0, _toStringJsDefault.default));
parcelHelpers.export(exports, "toUpper", ()=>(0, _toUpperJsDefault.default));
parcelHelpers.export(exports, "transduce", ()=>(0, _transduceJsDefault.default));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeJsDefault.default));
parcelHelpers.export(exports, "traverse", ()=>(0, _traverseJsDefault.default));
parcelHelpers.export(exports, "trim", ()=>(0, _trimJsDefault.default));
parcelHelpers.export(exports, "tryCatch", ()=>(0, _tryCatchJsDefault.default));
parcelHelpers.export(exports, "type", ()=>(0, _typeJsDefault.default));
parcelHelpers.export(exports, "unapply", ()=>(0, _unapplyJsDefault.default));
parcelHelpers.export(exports, "unary", ()=>(0, _unaryJsDefault.default));
parcelHelpers.export(exports, "uncurryN", ()=>(0, _uncurryNJsDefault.default));
parcelHelpers.export(exports, "unfold", ()=>(0, _unfoldJsDefault.default));
parcelHelpers.export(exports, "union", ()=>(0, _unionJsDefault.default));
parcelHelpers.export(exports, "unionWith", ()=>(0, _unionWithJsDefault.default));
parcelHelpers.export(exports, "uniq", ()=>(0, _uniqJsDefault.default));
parcelHelpers.export(exports, "uniqBy", ()=>(0, _uniqByJsDefault.default));
parcelHelpers.export(exports, "uniqWith", ()=>(0, _uniqWithJsDefault.default));
parcelHelpers.export(exports, "unless", ()=>(0, _unlessJsDefault.default));
parcelHelpers.export(exports, "unnest", ()=>(0, _unnestJsDefault.default));
parcelHelpers.export(exports, "until", ()=>(0, _untilJsDefault.default));
parcelHelpers.export(exports, "update", ()=>(0, _updateJsDefault.default));
parcelHelpers.export(exports, "useWith", ()=>(0, _useWithJsDefault.default));
parcelHelpers.export(exports, "values", ()=>(0, _valuesJsDefault.default));
parcelHelpers.export(exports, "valuesIn", ()=>(0, _valuesInJsDefault.default));
parcelHelpers.export(exports, "view", ()=>(0, _viewJsDefault.default));
parcelHelpers.export(exports, "when", ()=>(0, _whenJsDefault.default));
parcelHelpers.export(exports, "where", ()=>(0, _whereJsDefault.default));
parcelHelpers.export(exports, "whereEq", ()=>(0, _whereEqJsDefault.default));
parcelHelpers.export(exports, "without", ()=>(0, _withoutJsDefault.default));
parcelHelpers.export(exports, "xor", ()=>(0, _xorJsDefault.default));
parcelHelpers.export(exports, "xprod", ()=>(0, _xprodJsDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipJsDefault.default));
parcelHelpers.export(exports, "zipObj", ()=>(0, _zipObjJsDefault.default));
parcelHelpers.export(exports, "zipWith", ()=>(0, _zipWithJsDefault.default));
parcelHelpers.export(exports, "thunkify", ()=>(0, _thunkifyJsDefault.default));
var _fJs = require("./F.js");
var _fJsDefault = parcelHelpers.interopDefault(_fJs);
var _tJs = require("./T.js");
var _tJsDefault = parcelHelpers.interopDefault(_tJs);
var _js = require("./__.js");
var _jsDefault = parcelHelpers.interopDefault(_js);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _addIndexJs = require("./addIndex.js");
var _addIndexJsDefault = parcelHelpers.interopDefault(_addIndexJs);
var _adjustJs = require("./adjust.js");
var _adjustJsDefault = parcelHelpers.interopDefault(_adjustJs);
var _allJs = require("./all.js");
var _allJsDefault = parcelHelpers.interopDefault(_allJs);
var _allPassJs = require("./allPass.js");
var _allPassJsDefault = parcelHelpers.interopDefault(_allPassJs);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
var _andJs = require("./and.js");
var _andJsDefault = parcelHelpers.interopDefault(_andJs);
var _anyJs = require("./any.js");
var _anyJsDefault = parcelHelpers.interopDefault(_anyJs);
var _anyPassJs = require("./anyPass.js");
var _anyPassJsDefault = parcelHelpers.interopDefault(_anyPassJs);
var _apJs = require("./ap.js");
var _apJsDefault = parcelHelpers.interopDefault(_apJs);
var _apertureJs = require("./aperture.js");
var _apertureJsDefault = parcelHelpers.interopDefault(_apertureJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _applyJs = require("./apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
var _applySpecJs = require("./applySpec.js");
var _applySpecJsDefault = parcelHelpers.interopDefault(_applySpecJs);
var _applyToJs = require("./applyTo.js");
var _applyToJsDefault = parcelHelpers.interopDefault(_applyToJs);
var _ascendJs = require("./ascend.js");
var _ascendJsDefault = parcelHelpers.interopDefault(_ascendJs);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _assocPathJs = require("./assocPath.js");
var _assocPathJsDefault = parcelHelpers.interopDefault(_assocPathJs);
var _binaryJs = require("./binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _bindJs = require("./bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _bothJs = require("./both.js");
var _bothJsDefault = parcelHelpers.interopDefault(_bothJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _chainJs = require("./chain.js");
var _chainJsDefault = parcelHelpers.interopDefault(_chainJs);
var _clampJs = require("./clamp.js");
var _clampJsDefault = parcelHelpers.interopDefault(_clampJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _comparatorJs = require("./comparator.js");
var _comparatorJsDefault = parcelHelpers.interopDefault(_comparatorJs);
var _complementJs = require("./complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _composeKJs = require("./composeK.js");
var _composeKJsDefault = parcelHelpers.interopDefault(_composeKJs);
var _composePJs = require("./composeP.js");
var _composePJsDefault = parcelHelpers.interopDefault(_composePJs);
var _composeWithJs = require("./composeWith.js");
var _composeWithJsDefault = parcelHelpers.interopDefault(_composeWithJs);
var _concatJs = require("./concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _condJs = require("./cond.js");
var _condJsDefault = parcelHelpers.interopDefault(_condJs);
var _constructJs = require("./construct.js");
var _constructJsDefault = parcelHelpers.interopDefault(_constructJs);
var _constructNJs = require("./constructN.js");
var _constructNJsDefault = parcelHelpers.interopDefault(_constructNJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _convergeJs = require("./converge.js");
var _convergeJsDefault = parcelHelpers.interopDefault(_convergeJs);
var _countByJs = require("./countBy.js");
var _countByJsDefault = parcelHelpers.interopDefault(_countByJs);
var _curryJs = require("./curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _decJs = require("./dec.js");
var _decJsDefault = parcelHelpers.interopDefault(_decJs);
var _defaultToJs = require("./defaultTo.js");
var _defaultToJsDefault = parcelHelpers.interopDefault(_defaultToJs);
var _descendJs = require("./descend.js");
var _descendJsDefault = parcelHelpers.interopDefault(_descendJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _differenceWithJs = require("./differenceWith.js");
var _differenceWithJsDefault = parcelHelpers.interopDefault(_differenceWithJs);
var _dissocJs = require("./dissoc.js");
var _dissocJsDefault = parcelHelpers.interopDefault(_dissocJs);
var _dissocPathJs = require("./dissocPath.js");
var _dissocPathJsDefault = parcelHelpers.interopDefault(_dissocPathJs);
var _divideJs = require("./divide.js");
var _divideJsDefault = parcelHelpers.interopDefault(_divideJs);
var _dropJs = require("./drop.js");
var _dropJsDefault = parcelHelpers.interopDefault(_dropJs);
var _dropLastJs = require("./dropLast.js");
var _dropLastJsDefault = parcelHelpers.interopDefault(_dropLastJs);
var _dropLastWhileJs = require("./dropLastWhile.js");
var _dropLastWhileJsDefault = parcelHelpers.interopDefault(_dropLastWhileJs);
var _dropRepeatsJs = require("./dropRepeats.js");
var _dropRepeatsJsDefault = parcelHelpers.interopDefault(_dropRepeatsJs);
var _dropRepeatsWithJs = require("./dropRepeatsWith.js");
var _dropRepeatsWithJsDefault = parcelHelpers.interopDefault(_dropRepeatsWithJs);
var _dropWhileJs = require("./dropWhile.js");
var _dropWhileJsDefault = parcelHelpers.interopDefault(_dropWhileJs);
var _eitherJs = require("./either.js");
var _eitherJsDefault = parcelHelpers.interopDefault(_eitherJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _endsWithJs = require("./endsWith.js");
var _endsWithJsDefault = parcelHelpers.interopDefault(_endsWithJs);
var _eqByJs = require("./eqBy.js");
var _eqByJsDefault = parcelHelpers.interopDefault(_eqByJs);
var _eqPropsJs = require("./eqProps.js");
var _eqPropsJsDefault = parcelHelpers.interopDefault(_eqPropsJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _evolveJs = require("./evolve.js");
var _evolveJsDefault = parcelHelpers.interopDefault(_evolveJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _findIndexJs = require("./findIndex.js");
var _findIndexJsDefault = parcelHelpers.interopDefault(_findIndexJs);
var _findLastJs = require("./findLast.js");
var _findLastJsDefault = parcelHelpers.interopDefault(_findLastJs);
var _findLastIndexJs = require("./findLastIndex.js");
var _findLastIndexJsDefault = parcelHelpers.interopDefault(_findLastIndexJs);
var _flattenJs = require("./flatten.js");
var _flattenJsDefault = parcelHelpers.interopDefault(_flattenJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _forEachJs = require("./forEach.js");
var _forEachJsDefault = parcelHelpers.interopDefault(_forEachJs);
var _forEachObjIndexedJs = require("./forEachObjIndexed.js");
var _forEachObjIndexedJsDefault = parcelHelpers.interopDefault(_forEachObjIndexedJs);
var _fromPairsJs = require("./fromPairs.js");
var _fromPairsJsDefault = parcelHelpers.interopDefault(_fromPairsJs);
var _groupByJs = require("./groupBy.js");
var _groupByJsDefault = parcelHelpers.interopDefault(_groupByJs);
var _groupWithJs = require("./groupWith.js");
var _groupWithJsDefault = parcelHelpers.interopDefault(_groupWithJs);
var _gtJs = require("./gt.js");
var _gtJsDefault = parcelHelpers.interopDefault(_gtJs);
var _gteJs = require("./gte.js");
var _gteJsDefault = parcelHelpers.interopDefault(_gteJs);
var _hasJs = require("./has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _hasInJs = require("./hasIn.js");
var _hasInJsDefault = parcelHelpers.interopDefault(_hasInJs);
var _hasPathJs = require("./hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
var _headJs = require("./head.js");
var _headJsDefault = parcelHelpers.interopDefault(_headJs);
var _identicalJs = require("./identical.js");
var _identicalJsDefault = parcelHelpers.interopDefault(_identicalJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _ifElseJs = require("./ifElse.js");
var _ifElseJsDefault = parcelHelpers.interopDefault(_ifElseJs);
var _incJs = require("./inc.js");
var _incJsDefault = parcelHelpers.interopDefault(_incJs);
var _includesJs = require("./includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _indexByJs = require("./indexBy.js");
var _indexByJsDefault = parcelHelpers.interopDefault(_indexByJs);
var _indexOfJs = require("./indexOf.js");
var _indexOfJsDefault = parcelHelpers.interopDefault(_indexOfJs);
var _initJs = require("./init.js");
var _initJsDefault = parcelHelpers.interopDefault(_initJs);
var _innerJoinJs = require("./innerJoin.js");
var _innerJoinJsDefault = parcelHelpers.interopDefault(_innerJoinJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _insertAllJs = require("./insertAll.js");
var _insertAllJsDefault = parcelHelpers.interopDefault(_insertAllJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _intersperseJs = require("./intersperse.js");
var _intersperseJsDefault = parcelHelpers.interopDefault(_intersperseJs);
var _intoJs = require("./into.js");
var _intoJsDefault = parcelHelpers.interopDefault(_intoJs);
var _invertJs = require("./invert.js");
var _invertJsDefault = parcelHelpers.interopDefault(_invertJs);
var _invertObjJs = require("./invertObj.js");
var _invertObjJsDefault = parcelHelpers.interopDefault(_invertObjJs);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
var _isJs = require("./is.js");
var _isJsDefault = parcelHelpers.interopDefault(_isJs);
var _isEmptyJs = require("./isEmpty.js");
var _isEmptyJsDefault = parcelHelpers.interopDefault(_isEmptyJs);
var _isNilJs = require("./isNil.js");
var _isNilJsDefault = parcelHelpers.interopDefault(_isNilJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _juxtJs = require("./juxt.js");
var _juxtJsDefault = parcelHelpers.interopDefault(_juxtJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
var _lastJs = require("./last.js");
var _lastJsDefault = parcelHelpers.interopDefault(_lastJs);
var _lastIndexOfJs = require("./lastIndexOf.js");
var _lastIndexOfJsDefault = parcelHelpers.interopDefault(_lastIndexOfJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _lensIndexJs = require("./lensIndex.js");
var _lensIndexJsDefault = parcelHelpers.interopDefault(_lensIndexJs);
var _lensPathJs = require("./lensPath.js");
var _lensPathJsDefault = parcelHelpers.interopDefault(_lensPathJs);
var _lensPropJs = require("./lensProp.js");
var _lensPropJsDefault = parcelHelpers.interopDefault(_lensPropJs);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
var _liftNJs = require("./liftN.js");
var _liftNJsDefault = parcelHelpers.interopDefault(_liftNJs);
var _ltJs = require("./lt.js");
var _ltJsDefault = parcelHelpers.interopDefault(_ltJs);
var _lteJs = require("./lte.js");
var _lteJsDefault = parcelHelpers.interopDefault(_lteJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapAccumJs = require("./mapAccum.js");
var _mapAccumJsDefault = parcelHelpers.interopDefault(_mapAccumJs);
var _mapAccumRightJs = require("./mapAccumRight.js");
var _mapAccumRightJsDefault = parcelHelpers.interopDefault(_mapAccumRightJs);
var _mapObjIndexedJs = require("./mapObjIndexed.js");
var _mapObjIndexedJsDefault = parcelHelpers.interopDefault(_mapObjIndexedJs);
var _matchJs = require("./match.js");
var _matchJsDefault = parcelHelpers.interopDefault(_matchJs);
var _mathModJs = require("./mathMod.js");
var _mathModJsDefault = parcelHelpers.interopDefault(_mathModJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxByJs = require("./maxBy.js");
var _maxByJsDefault = parcelHelpers.interopDefault(_maxByJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _memoizeWithJs = require("./memoizeWith.js");
var _memoizeWithJsDefault = parcelHelpers.interopDefault(_memoizeWithJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _mergeAllJs = require("./mergeAll.js");
var _mergeAllJsDefault = parcelHelpers.interopDefault(_mergeAllJs);
var _mergeDeepLeftJs = require("./mergeDeepLeft.js");
var _mergeDeepLeftJsDefault = parcelHelpers.interopDefault(_mergeDeepLeftJs);
var _mergeDeepRightJs = require("./mergeDeepRight.js");
var _mergeDeepRightJsDefault = parcelHelpers.interopDefault(_mergeDeepRightJs);
var _mergeDeepWithJs = require("./mergeDeepWith.js");
var _mergeDeepWithJsDefault = parcelHelpers.interopDefault(_mergeDeepWithJs);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
var _mergeLeftJs = require("./mergeLeft.js");
var _mergeLeftJsDefault = parcelHelpers.interopDefault(_mergeLeftJs);
var _mergeRightJs = require("./mergeRight.js");
var _mergeRightJsDefault = parcelHelpers.interopDefault(_mergeRightJs);
var _mergeWithJs = require("./mergeWith.js");
var _mergeWithJsDefault = parcelHelpers.interopDefault(_mergeWithJs);
var _mergeWithKeyJs = require("./mergeWithKey.js");
var _mergeWithKeyJsDefault = parcelHelpers.interopDefault(_mergeWithKeyJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minByJs = require("./minBy.js");
var _minByJsDefault = parcelHelpers.interopDefault(_minByJs);
var _moduloJs = require("./modulo.js");
var _moduloJsDefault = parcelHelpers.interopDefault(_moduloJs);
var _moveJs = require("./move.js");
var _moveJsDefault = parcelHelpers.interopDefault(_moveJs);
var _multiplyJs = require("./multiply.js");
var _multiplyJsDefault = parcelHelpers.interopDefault(_multiplyJs);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
var _negateJs = require("./negate.js");
var _negateJsDefault = parcelHelpers.interopDefault(_negateJs);
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _notJs = require("./not.js");
var _notJsDefault = parcelHelpers.interopDefault(_notJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
var _nthArgJs = require("./nthArg.js");
var _nthArgJsDefault = parcelHelpers.interopDefault(_nthArgJs);
var _oJs = require("./o.js");
var _oJsDefault = parcelHelpers.interopDefault(_oJs);
var _objOfJs = require("./objOf.js");
var _objOfJsDefault = parcelHelpers.interopDefault(_objOfJs);
var _ofJs = require("./of.js");
var _ofJsDefault = parcelHelpers.interopDefault(_ofJs);
var _omitJs = require("./omit.js");
var _omitJsDefault = parcelHelpers.interopDefault(_omitJs);
var _onceJs = require("./once.js");
var _onceJsDefault = parcelHelpers.interopDefault(_onceJs);
var _orJs = require("./or.js");
var _orJsDefault = parcelHelpers.interopDefault(_orJs);
var _otherwiseJs = require("./otherwise.js");
var _otherwiseJsDefault = parcelHelpers.interopDefault(_otherwiseJs);
var _overJs = require("./over.js");
var _overJsDefault = parcelHelpers.interopDefault(_overJs);
var _pairJs = require("./pair.js");
var _pairJsDefault = parcelHelpers.interopDefault(_pairJs);
var _partialJs = require("./partial.js");
var _partialJsDefault = parcelHelpers.interopDefault(_partialJs);
var _partialRightJs = require("./partialRight.js");
var _partialRightJsDefault = parcelHelpers.interopDefault(_partialRightJs);
var _partitionJs = require("./partition.js");
var _partitionJsDefault = parcelHelpers.interopDefault(_partitionJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _pathsJs = require("./paths.js");
var _pathsJsDefault = parcelHelpers.interopDefault(_pathsJs);
var _pathEqJs = require("./pathEq.js");
var _pathEqJsDefault = parcelHelpers.interopDefault(_pathEqJs);
var _pathOrJs = require("./pathOr.js");
var _pathOrJsDefault = parcelHelpers.interopDefault(_pathOrJs);
var _pathSatisfiesJs = require("./pathSatisfies.js");
var _pathSatisfiesJsDefault = parcelHelpers.interopDefault(_pathSatisfiesJs);
var _pickJs = require("./pick.js");
var _pickJsDefault = parcelHelpers.interopDefault(_pickJs);
var _pickAllJs = require("./pickAll.js");
var _pickAllJsDefault = parcelHelpers.interopDefault(_pickAllJs);
var _pickByJs = require("./pickBy.js");
var _pickByJsDefault = parcelHelpers.interopDefault(_pickByJs);
var _pipeJs = require("./pipe.js");
var _pipeJsDefault = parcelHelpers.interopDefault(_pipeJs);
var _pipeKJs = require("./pipeK.js");
var _pipeKJsDefault = parcelHelpers.interopDefault(_pipeKJs);
var _pipePJs = require("./pipeP.js");
var _pipePJsDefault = parcelHelpers.interopDefault(_pipePJs);
var _pipeWithJs = require("./pipeWith.js");
var _pipeWithJsDefault = parcelHelpers.interopDefault(_pipeWithJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _prependJs = require("./prepend.js");
var _prependJsDefault = parcelHelpers.interopDefault(_prependJs);
var _productJs = require("./product.js");
var _productJsDefault = parcelHelpers.interopDefault(_productJs);
var _projectJs = require("./project.js");
var _projectJsDefault = parcelHelpers.interopDefault(_projectJs);
var _propJs = require("./prop.js");
var _propJsDefault = parcelHelpers.interopDefault(_propJs);
var _propEqJs = require("./propEq.js");
var _propEqJsDefault = parcelHelpers.interopDefault(_propEqJs);
var _propIsJs = require("./propIs.js");
var _propIsJsDefault = parcelHelpers.interopDefault(_propIsJs);
var _propOrJs = require("./propOr.js");
var _propOrJsDefault = parcelHelpers.interopDefault(_propOrJs);
var _propSatisfiesJs = require("./propSatisfies.js");
var _propSatisfiesJsDefault = parcelHelpers.interopDefault(_propSatisfiesJs);
var _propsJs = require("./props.js");
var _propsJsDefault = parcelHelpers.interopDefault(_propsJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
var _reduceRightJs = require("./reduceRight.js");
var _reduceRightJsDefault = parcelHelpers.interopDefault(_reduceRightJs);
var _reduceWhileJs = require("./reduceWhile.js");
var _reduceWhileJsDefault = parcelHelpers.interopDefault(_reduceWhileJs);
var _reducedJs = require("./reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _rejectJs = require("./reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _repeatJs = require("./repeat.js");
var _repeatJsDefault = parcelHelpers.interopDefault(_repeatJs);
var _replaceJs = require("./replace.js");
var _replaceJsDefault = parcelHelpers.interopDefault(_replaceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _sequenceJs = require("./sequence.js");
var _sequenceJsDefault = parcelHelpers.interopDefault(_sequenceJs);
var _setJs = require("./set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _sortByJs = require("./sortBy.js");
var _sortByJsDefault = parcelHelpers.interopDefault(_sortByJs);
var _sortWithJs = require("./sortWith.js");
var _sortWithJsDefault = parcelHelpers.interopDefault(_sortWithJs);
var _splitJs = require("./split.js");
var _splitJsDefault = parcelHelpers.interopDefault(_splitJs);
var _splitAtJs = require("./splitAt.js");
var _splitAtJsDefault = parcelHelpers.interopDefault(_splitAtJs);
var _splitEveryJs = require("./splitEvery.js");
var _splitEveryJsDefault = parcelHelpers.interopDefault(_splitEveryJs);
var _splitWhenJs = require("./splitWhen.js");
var _splitWhenJsDefault = parcelHelpers.interopDefault(_splitWhenJs);
var _startsWithJs = require("./startsWith.js");
var _startsWithJsDefault = parcelHelpers.interopDefault(_startsWithJs);
var _subtractJs = require("./subtract.js");
var _subtractJsDefault = parcelHelpers.interopDefault(_subtractJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _symmetricDifferenceJs = require("./symmetricDifference.js");
var _symmetricDifferenceJsDefault = parcelHelpers.interopDefault(_symmetricDifferenceJs);
var _symmetricDifferenceWithJs = require("./symmetricDifferenceWith.js");
var _symmetricDifferenceWithJsDefault = parcelHelpers.interopDefault(_symmetricDifferenceWithJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
var _takeJs = require("./take.js");
var _takeJsDefault = parcelHelpers.interopDefault(_takeJs);
var _takeLastJs = require("./takeLast.js");
var _takeLastJsDefault = parcelHelpers.interopDefault(_takeLastJs);
var _takeLastWhileJs = require("./takeLastWhile.js");
var _takeLastWhileJsDefault = parcelHelpers.interopDefault(_takeLastWhileJs);
var _takeWhileJs = require("./takeWhile.js");
var _takeWhileJsDefault = parcelHelpers.interopDefault(_takeWhileJs);
var _tapJs = require("./tap.js");
var _tapJsDefault = parcelHelpers.interopDefault(_tapJs);
var _testJs = require("./test.js");
var _testJsDefault = parcelHelpers.interopDefault(_testJs);
var _andThenJs = require("./andThen.js");
var _andThenJsDefault = parcelHelpers.interopDefault(_andThenJs);
var _timesJs = require("./times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
var _toLowerJs = require("./toLower.js");
var _toLowerJsDefault = parcelHelpers.interopDefault(_toLowerJs);
var _toPairsJs = require("./toPairs.js");
var _toPairsJsDefault = parcelHelpers.interopDefault(_toPairsJs);
var _toPairsInJs = require("./toPairsIn.js");
var _toPairsInJsDefault = parcelHelpers.interopDefault(_toPairsInJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
var _toUpperJs = require("./toUpper.js");
var _toUpperJsDefault = parcelHelpers.interopDefault(_toUpperJs);
var _transduceJs = require("./transduce.js");
var _transduceJsDefault = parcelHelpers.interopDefault(_transduceJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _traverseJs = require("./traverse.js");
var _traverseJsDefault = parcelHelpers.interopDefault(_traverseJs);
var _trimJs = require("./trim.js");
var _trimJsDefault = parcelHelpers.interopDefault(_trimJs);
var _tryCatchJs = require("./tryCatch.js");
var _tryCatchJsDefault = parcelHelpers.interopDefault(_tryCatchJs);
var _typeJs = require("./type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
var _unapplyJs = require("./unapply.js");
var _unapplyJsDefault = parcelHelpers.interopDefault(_unapplyJs);
var _unaryJs = require("./unary.js");
var _unaryJsDefault = parcelHelpers.interopDefault(_unaryJs);
var _uncurryNJs = require("./uncurryN.js");
var _uncurryNJsDefault = parcelHelpers.interopDefault(_uncurryNJs);
var _unfoldJs = require("./unfold.js");
var _unfoldJsDefault = parcelHelpers.interopDefault(_unfoldJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _unionWithJs = require("./unionWith.js");
var _unionWithJsDefault = parcelHelpers.interopDefault(_unionWithJs);
var _uniqJs = require("./uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
var _uniqByJs = require("./uniqBy.js");
var _uniqByJsDefault = parcelHelpers.interopDefault(_uniqByJs);
var _uniqWithJs = require("./uniqWith.js");
var _uniqWithJsDefault = parcelHelpers.interopDefault(_uniqWithJs);
var _unlessJs = require("./unless.js");
var _unlessJsDefault = parcelHelpers.interopDefault(_unlessJs);
var _unnestJs = require("./unnest.js");
var _unnestJsDefault = parcelHelpers.interopDefault(_unnestJs);
var _untilJs = require("./until.js");
var _untilJsDefault = parcelHelpers.interopDefault(_untilJs);
var _updateJs = require("./update.js");
var _updateJsDefault = parcelHelpers.interopDefault(_updateJs);
var _useWithJs = require("./useWith.js");
var _useWithJsDefault = parcelHelpers.interopDefault(_useWithJs);
var _valuesJs = require("./values.js");
var _valuesJsDefault = parcelHelpers.interopDefault(_valuesJs);
var _valuesInJs = require("./valuesIn.js");
var _valuesInJsDefault = parcelHelpers.interopDefault(_valuesInJs);
var _viewJs = require("./view.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _whenJs = require("./when.js");
var _whenJsDefault = parcelHelpers.interopDefault(_whenJs);
var _whereJs = require("./where.js");
var _whereJsDefault = parcelHelpers.interopDefault(_whereJs);
var _whereEqJs = require("./whereEq.js");
var _whereEqJsDefault = parcelHelpers.interopDefault(_whereEqJs);
var _withoutJs = require("./without.js");
var _withoutJsDefault = parcelHelpers.interopDefault(_withoutJs);
var _xorJs = require("./xor.js");
var _xorJsDefault = parcelHelpers.interopDefault(_xorJs);
var _xprodJs = require("./xprod.js");
var _xprodJsDefault = parcelHelpers.interopDefault(_xprodJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _zipObjJs = require("./zipObj.js");
var _zipObjJsDefault = parcelHelpers.interopDefault(_zipObjJs);
var _zipWithJs = require("./zipWith.js");
var _zipWithJsDefault = parcelHelpers.interopDefault(_zipWithJs);
var _thunkifyJs = require("./thunkify.js");
var _thunkifyJsDefault = parcelHelpers.interopDefault(_thunkifyJs);

},{"./F.js":"e7YRZ","./T.js":"9fPv3","./__.js":"9mMJl","./add.js":"eK5zq","./addIndex.js":"9ra5h","./adjust.js":"iBS73","./all.js":"6tXYM","./allPass.js":"bfeqk","./always.js":"ilsuC","./and.js":"8hhH5","./any.js":"aCMmX","./anyPass.js":"ervqU","./ap.js":"k2b5D","./aperture.js":"e2JtI","./append.js":"fQ2Tl","./apply.js":"4Tyh4","./applySpec.js":"ad7bt","./applyTo.js":"aMzt0","./ascend.js":"cLWr7","./assoc.js":"6qBlU","./assocPath.js":"14UyM","./binary.js":"jsYcN","./bind.js":"9PB9Y","./both.js":"2M8J9","./call.js":"3UUCC","./chain.js":"8spep","./clamp.js":"6mJWk","./clone.js":"8ISUl","./comparator.js":"4NZAL","./complement.js":"41GkG","./compose.js":"3d9gX","./composeK.js":"9Xpvs","./composeP.js":"9j5mb","./composeWith.js":"gZjIH","./concat.js":"giSF9","./cond.js":"9ZUUA","./construct.js":"2Z9e0","./constructN.js":"crHkj","./contains.js":"eKlsV","./converge.js":"eY55M","./countBy.js":"5czs0","./curry.js":"jcz4t","./curryN.js":"757ou","./dec.js":"awjH7","./defaultTo.js":"4Ad0O","./descend.js":"JaHMX","./difference.js":"lJWRb","./differenceWith.js":"hkTEI","./dissoc.js":"4m6XK","./dissocPath.js":"j6az2","./divide.js":"INp3H","./drop.js":"2ymqB","./dropLast.js":"1I8Mg","./dropLastWhile.js":"80qiv","./dropRepeats.js":"iHXfe","./dropRepeatsWith.js":"gGTk3","./dropWhile.js":"gISrh","./either.js":"gRAYT","./empty.js":"k7YHl","./endsWith.js":"6o0eY","./eqBy.js":"czp0D","./eqProps.js":"gRkda","./equals.js":"lVaDh","./evolve.js":"aK2gh","./filter.js":"4D8wM","./find.js":"jxGb6","./findIndex.js":"h8TAc","./findLast.js":"fx2eJ","./findLastIndex.js":"f8rz3","./flatten.js":"hr83s","./flip.js":"dG058","./forEach.js":"NkaK7","./forEachObjIndexed.js":"cjohL","./fromPairs.js":"6krRf","./groupBy.js":"1cHwK","./groupWith.js":"k4GMQ","./gt.js":"2VJD7","./gte.js":"BP6Rl","./has.js":"5f1cX","./hasIn.js":"k1nwP","./hasPath.js":"8snUh","./head.js":"hlNyr","./identical.js":"1v5pZ","./identity.js":"gC6lG","./ifElse.js":"6byot","./inc.js":"dqY19","./includes.js":"35Miw","./indexBy.js":"gCEfs","./indexOf.js":"jGl0p","./init.js":"6ykqm","./innerJoin.js":"3jPCI","./insert.js":"cI2nK","./insertAll.js":"e4Wlq","./intersection.js":"4PZEK","./intersperse.js":"3ocaP","./into.js":"cKaCB","./invert.js":"8qpfn","./invertObj.js":"gHUaK","./invoker.js":"bz0c6","./is.js":"fEFU8","./isEmpty.js":"dFitx","./isNil.js":"5ZnbR","./join.js":"lBtlT","./juxt.js":"7fJJS","./keys.js":"f6WyD","./keysIn.js":"k1Vcr","./last.js":"bDRve","./lastIndexOf.js":"9Jj53","./length.js":"5Jxp9","./lens.js":"49B96","./lensIndex.js":"1vwzV","./lensPath.js":"6hRb5","./lensProp.js":"1RTn3","./lift.js":"c8mnU","./liftN.js":"ceNvi","./lt.js":"33ra9","./lte.js":"9H8Yp","./map.js":"2D7vt","./mapAccum.js":"95mUD","./mapAccumRight.js":"cyGBk","./mapObjIndexed.js":"d6S3N","./match.js":"jbA6E","./mathMod.js":"att0i","./max.js":"k5zmW","./maxBy.js":"1qgeJ","./mean.js":"5VbDm","./median.js":"4fbGy","./memoizeWith.js":"iQLl3","./merge.js":"Iw41T","./mergeAll.js":"8jcID","./mergeDeepLeft.js":"emk08","./mergeDeepRight.js":"6JatN","./mergeDeepWith.js":"eKX20","./mergeDeepWithKey.js":"hX1mB","./mergeLeft.js":"1ICOX","./mergeRight.js":"iSwIj","./mergeWith.js":"hhpGh","./mergeWithKey.js":"68lFR","./min.js":"cqzkq","./minBy.js":"5rC9Z","./modulo.js":"82uWH","./move.js":"2YUeM","./multiply.js":"gCYNI","./nAry.js":"2DwrZ","./negate.js":"3zrTZ","./none.js":"fiB9n","./not.js":"bZ9fS","./nth.js":"ba0ga","./nthArg.js":"3YpP6","./o.js":"56qNR","./objOf.js":"d8yHN","./of.js":"f1aIw","./omit.js":"gRT62","./once.js":"1RhsY","./or.js":"9WCxL","./otherwise.js":"4cUZV","./over.js":"hZ10z","./pair.js":"3N1A1","./partial.js":"iktjz","./partialRight.js":"25QTT","./partition.js":"dmVbs","./path.js":"bMM1c","./paths.js":"eC1f0","./pathEq.js":"d8EtI","./pathOr.js":"97HB8","./pathSatisfies.js":"84De7","./pick.js":"79ZOt","./pickAll.js":"aQDpI","./pickBy.js":"SBsGw","./pipe.js":"dU0Hd","./pipeK.js":"bLEqU","./pipeP.js":"6Xnli","./pipeWith.js":"j7eA2","./pluck.js":"aXEN0","./prepend.js":"7Fq9r","./product.js":"gEFo4","./project.js":"i6Cxy","./prop.js":"bt3mo","./propEq.js":"uJnZv","./propIs.js":"g4mxI","./propOr.js":"35XHx","./propSatisfies.js":"dwURq","./props.js":"gpgqt","./range.js":"85gum","./reduce.js":"aTmLb","./reduceBy.js":"b4AqF","./reduceRight.js":"90z19","./reduceWhile.js":"hpc52","./reduced.js":"2wG2H","./reject.js":"frSvm","./remove.js":"5Noe7","./repeat.js":"1AaST","./replace.js":"jxPzh","./reverse.js":"2h77c","./scan.js":"ktdXN","./sequence.js":"3T3YF","./set.js":"1MotT","./slice.js":"4Vv0F","./sort.js":"jSbOu","./sortBy.js":"8Fdcb","./sortWith.js":"jD4cx","./split.js":"6rRC1","./splitAt.js":"cXihd","./splitEvery.js":"idWWa","./splitWhen.js":"frrTI","./startsWith.js":"kDsOF","./subtract.js":"lozDD","./sum.js":"dFKgN","./symmetricDifference.js":"6DQ1f","./symmetricDifferenceWith.js":"fWyNV","./tail.js":"emrkp","./take.js":"nrooI","./takeLast.js":"cniuF","./takeLastWhile.js":"gFbl1","./takeWhile.js":"7dAd1","./tap.js":"02scP","./test.js":"k0ozT","./andThen.js":"iSHPG","./times.js":"fUiWH","./toLower.js":"hkx6o","./toPairs.js":"8A4Cj","./toPairsIn.js":"dY2Pl","./toString.js":"7ui8E","./toUpper.js":"k5Xx6","./transduce.js":"3gJLt","./transpose.js":"flvoj","./traverse.js":"gEVor","./trim.js":"6eTuy","./tryCatch.js":"dum8U","./type.js":"iuljW","./unapply.js":"eY57o","./unary.js":"3eC5X","./uncurryN.js":"1zsmv","./unfold.js":"i1XIB","./union.js":"1bwjt","./unionWith.js":"fsTe6","./uniq.js":"3p6a8","./uniqBy.js":"1x4J2","./uniqWith.js":"iXZUi","./unless.js":"i2VxU","./unnest.js":"i7Dv4","./until.js":"l7qCz","./update.js":"is5js","./useWith.js":"22342","./values.js":"hS7jf","./valuesIn.js":"26EfK","./view.js":"ge4NW","./when.js":"l7Pa4","./where.js":"ir5oI","./whereEq.js":"aGCyE","./without.js":"gIaSk","./xor.js":"g2387","./xprod.js":"1k1AO","./zip.js":"c0Dd6","./zipObj.js":"9XoUe","./zipWith.js":"7bym0","./thunkify.js":"4OUUh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e7YRZ":[function(require,module,exports) {
/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.T
 * @example
 *
 *      R.F(); //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var F = function() {
    return false;
};
exports.default = F;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9fPv3":[function(require,module,exports) {
/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var T = function() {
    return true;
};
exports.default = T;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9mMJl":[function(require,module,exports) {
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    "@@functional/placeholder": true
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eK5zq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var add = /*#__PURE__*/ (0, _curry2JsDefault.default)(function add(a, b) {
    return Number(a) + Number(b);
});
exports.default = add;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4x4SN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_curry2);
var _curry1Js = require("./_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, _isPlaceholderJsDefault.default)(a) ? f2 : (0, _curry1JsDefault.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) ? f2 : (0, _isPlaceholderJsDefault.default)(a) ? (0, _curry1JsDefault.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry1JsDefault.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

},{"./_curry1.js":"eEHcl","./_isPlaceholder.js":"civfn","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eEHcl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_curry1);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, _isPlaceholderJsDefault.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

},{"./_isPlaceholder.js":"civfn","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"civfn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isPlaceholder);
function _isPlaceholder(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9ra5h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> ((a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var addIndex = /*#__PURE__*/ (0, _curry1JsDefault.default)(function addIndex(fn) {
    return (0, _curryNJsDefault.default)(fn.length, function() {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, _concatJsDefault.default)(arguments, [
                idx,
                list
            ]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
exports.default = addIndex;

},{"./internal/_concat.js":"8tD7U","./internal/_curry1.js":"eEHcl","./curryN.js":"757ou","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8tD7U":[function(require,module,exports) {
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_concat);
function _concat(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"757ou":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryNJs = require("./internal/_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var curryN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function curryN(length, fn) {
    if (length === 1) return (0, _curry1JsDefault.default)(fn);
    return (0, _arityJsDefault.default)(length, (0, _curryNJsDefault.default)(length, [], fn));
});
exports.default = curryN;

},{"./internal/_arity.js":"473XR","./internal/_curry1.js":"eEHcl","./internal/_curry2.js":"4x4SN","./internal/_curryN.js":"i0t26","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"473XR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arity);
function _arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"i0t26":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_curryN);
var _arityJs = require("./_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, _isPlaceholderJsDefault.default)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, _isPlaceholderJsDefault.default)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, _arityJsDefault.default)(left, _curryN(length, combined, fn));
    };
}

},{"./_arity.js":"473XR","./_isPlaceholder.js":"civfn","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iBS73":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */ var adjust = /*#__PURE__*/ (0, _curry3JsDefault.default)(function adjust(idx, fn, list) {
    if (idx >= list.length || idx < -list.length) return list;
    var start = idx < 0 ? list.length : 0;
    var _idx = start + idx;
    var _list = (0, _concatJsDefault.default)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
exports.default = adjust;

},{"./internal/_concat.js":"8tD7U","./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2gLD0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_curry3);
var _curry1Js = require("./_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curry3(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, _isPlaceholderJsDefault.default)(a) ? f3 : (0, _curry2JsDefault.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) ? f3 : (0, _isPlaceholderJsDefault.default)(a) ? (0, _curry2JsDefault.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry2JsDefault.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, _curry1JsDefault.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) && (0, _isPlaceholderJsDefault.default)(c) ? f3 : (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry2JsDefault.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(c) ? (0, _curry2JsDefault.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, _isPlaceholderJsDefault.default)(b) && (0, _isPlaceholderJsDefault.default)(c) ? (0, _curry2JsDefault.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, _isPlaceholderJsDefault.default)(a) ? (0, _curry1JsDefault.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry1JsDefault.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, _isPlaceholderJsDefault.default)(c) ? (0, _curry1JsDefault.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

},{"./_curry1.js":"eEHcl","./_curry2.js":"4x4SN","./_isPlaceholder.js":"civfn","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6tXYM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xallJs = require("./internal/_xall.js");
var _xallJsDefault = parcelHelpers.interopDefault(_xallJs);
/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var all = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "all"
], (0, _xallJsDefault.default), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
exports.default = all;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xall.js":"gPu3a","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c9mel":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_dispatchable);
var _isArrayJs = require("./_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isTransformerJs = require("./_isTransformer.js");
var _isTransformerJsDefault = parcelHelpers.interopDefault(_isTransformerJs);
function _dispatchable(methodNames, xf, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!(0, _isArrayJsDefault.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, args);
                idx += 1;
            }
            if ((0, _isTransformerJsDefault.default)(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

},{"./_isArray.js":"a2KsU","./_isTransformer.js":"336qj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a2KsU":[function(require,module,exports) {
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"336qj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isTransformer);
function _isTransformer(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gPu3a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XAll.prototype["@@transducer/result"] = function(result) {
        if (this.all) result = this.xf["@@transducer/step"](result, true);
        return this.xf["@@transducer/result"](result);
    };
    XAll.prototype["@@transducer/step"] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, _reducedJsDefault.default)(this.xf["@@transducer/step"](result, false));
        }
        return result;
    };
    return XAll;
}();
var _xall = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xall(f, xf) {
    return new XAll(f, xf);
});
exports.default = _xall;

},{"./_curry2.js":"4x4SN","./_reduced.js":"g5Cqb","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g5Cqb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_reduced);
function _reduced(x) {
    return x && x["@@transducer/reduced"] ? x : {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gdV4K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bfeqk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var allPass = /*#__PURE__*/ (0, _curry1JsDefault.default)(function allPass(preds) {
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
exports.default = allPass;

},{"./internal/_curry1.js":"eEHcl","./curryN.js":"757ou","./max.js":"k5zmW","./pluck.js":"aXEN0","./reduce.js":"aTmLb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k5zmW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var max = /*#__PURE__*/ (0, _curry2JsDefault.default)(function max(a, b) {
    return b > a ? b : a;
});
exports.default = max;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aXEN0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _propJs = require("./prop.js");
var _propJsDefault = parcelHelpers.interopDefault(_propJs);
/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var pluck = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pluck(p, list) {
    return (0, _mapJsDefault.default)((0, _propJsDefault.default)(p), list);
});
exports.default = pluck;

},{"./internal/_curry2.js":"4x4SN","./map.js":"2D7vt","./prop.js":"bt3mo","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2D7vt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _mapJs = require("./internal/_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xmapJs = require("./internal/_xmap.js");
var _xmapJsDefault = parcelHelpers.interopDefault(_xmapJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var map = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "fantasy-land/map",
    "map"
], (0, _xmapJsDefault.default), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case "[object Function]":
            return (0, _curryNJsDefault.default)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case "[object Object]":
            return (0, _reduceJsDefault.default)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, _keysJsDefault.default)(functor));
        default:
            return (0, _mapJsDefault.default)(fn, functor);
    }
}));
exports.default = map;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_map.js":"aibsD","./internal/_reduce.js":"81EKw","./internal/_xmap.js":"eDUtc","./curryN.js":"757ou","./keys.js":"f6WyD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aibsD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_map);
function _map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"81EKw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_reduce);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _xwrapJs = require("./_xwrap.js");
var _xwrapJsDefault = parcelHelpers.interopDefault(_xwrapJs);
var _bindJs = require("../bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}
function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]((0, _bindJsDefault.default)(xf["@@transducer/step"], xf), acc));
}
var symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function _reduce(fn, acc, list) {
    if (typeof fn === "function") fn = (0, _xwrapJsDefault.default)(fn);
    if ((0, _isArrayLikeJsDefault.default)(list)) return _arrayReduce(fn, acc, list);
    if (typeof list["fantasy-land/reduce"] === "function") return _methodReduce(fn, acc, list, "fantasy-land/reduce");
    if (list[symIterator] != null) return _iterableReduce(fn, acc, list[symIterator]());
    if (typeof list.next === "function") return _iterableReduce(fn, acc, list);
    if (typeof list.reduce === "function") return _methodReduce(fn, acc, list, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
}

},{"./_isArrayLike.js":"8KOTs","./_xwrap.js":"cG2gX","../bind.js":"9PB9Y","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8KOTs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isArrayJs = require("./_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isStringJs = require("./_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */ var _isArrayLike = /*#__PURE__*/ (0, _curry1JsDefault.default)(function isArrayLike(x) {
    if ((0, _isArrayJsDefault.default)(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ((0, _isStringJsDefault.default)(x)) return false;
    if (x.nodeType === 1) return !!x.length;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
exports.default = _isArrayLike;

},{"./_curry1.js":"eEHcl","./_isArray.js":"a2KsU","./_isString.js":"53k10","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"53k10":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isString);
function _isString(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cG2gX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_xwrap);
var XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function _xwrap(fn) {
    return new XWrap(fn);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9PB9Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var bind = /*#__PURE__*/ (0, _curry2JsDefault.default)(function bind(fn, thisObj) {
    return (0, _arityJsDefault.default)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
exports.default = bind;

},{"./internal/_arity.js":"473XR","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eDUtc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XMap.prototype["@@transducer/result"] = (0, _xfBaseJsDefault.default).result;
    XMap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, this.f(input));
    };
    return XMap;
}();
var _xmap = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xmap(f, xf) {
    return new XMap(f, xf);
});
exports.default = _xmap;

},{"./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f6WyD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _isArgumentsJs = require("./internal/_isArguments.js"); // cover IE < 9 keys issues
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
]; // Safari bug
var hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var keys = typeof Object.keys === "function" && !hasArgsEnumBug ? /*#__PURE__*/ (0, _curry1JsDefault.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, _curry1JsDefault.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = hasArgsEnumBug && (0, _isArgumentsJsDefault.default)(obj);
    for(prop in obj)if ((0, _hasJsDefault.default)(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = nonEnumerableProps[nIdx];
            if ((0, _hasJsDefault.default)(prop, obj) && !contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
exports.default = keys;

},{"./internal/_curry1.js":"eEHcl","./internal/_has.js":"k6FAr","./internal/_isArguments.js":"aW0qk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k6FAr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_has);
function _has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aW0qk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var toString = Object.prototype.toString;
var _isArguments = /*#__PURE__*/ function() {
    return toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return (0, _hasJsDefault.default)("callee", x);
    };
}();
exports.default = _isArguments;

},{"./_has.js":"k6FAr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bt3mo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig Idx -> {s: a} -> a | Undefined
 * @param {String|Number} p The property name or array index
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path, R.nth
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.prop(0, [100]); //=> 100
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var prop = /*#__PURE__*/ (0, _curry2JsDefault.default)(function prop(p, obj) {
    return (0, _pathJsDefault.default)([
        p
    ], obj);
});
exports.default = prop;

},{"./internal/_curry2.js":"4x4SN","./path.js":"bMM1c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bMM1c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pathsJs = require("./paths.js");
var _pathsJsDefault = parcelHelpers.interopDefault(_pathsJs);
/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 */ var path = /*#__PURE__*/ (0, _curry2JsDefault.default)(function path(pathAr, obj) {
    return (0, _pathsJsDefault.default)([
        pathAr
    ], obj)[0];
});
exports.default = path;

},{"./internal/_curry2.js":"4x4SN","./paths.js":"eC1f0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eC1f0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */ var paths = /*#__PURE__*/ (0, _curry2JsDefault.default)(function paths(pathsArray, obj) {
    return pathsArray.map(function(paths) {
        var val = obj;
        var idx = 0;
        var p;
        while(idx < paths.length){
            if (val == null) return;
            p = paths[idx];
            val = (0, _isIntegerJsDefault.default)(p) ? (0, _nthJsDefault.default)(p, val) : val[p];
            idx += 1;
        }
        return val;
    });
});
exports.default = paths;

},{"./internal/_curry2.js":"4x4SN","./internal/_isInteger.js":"hayZl","./nth.js":"ba0ga","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hayZl":[function(require,module,exports) {
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ba0ga":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var nth = /*#__PURE__*/ (0, _curry2JsDefault.default)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, _isStringJsDefault.default)(list) ? list.charAt(idx) : list[idx];
});
exports.default = nth;

},{"./internal/_curry2.js":"4x4SN","./internal/_isString.js":"53k10","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aTmLb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var reduce = /*#__PURE__*/ (0, _curry3JsDefault.default)((0, _reduceJsDefault.default));
exports.default = reduce;

},{"./internal/_curry3.js":"2gLD0","./internal/_reduce.js":"81EKw","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ilsuC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var always = /*#__PURE__*/ (0, _curry1JsDefault.default)(function always(val) {
    return function() {
        return val;
    };
});
exports.default = always;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8hhH5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both, R.xor
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */ var and = /*#__PURE__*/ (0, _curry2JsDefault.default)(function and(a, b) {
    return a && b;
});
exports.default = and;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aCMmX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xanyJs = require("./internal/_xany.js");
var _xanyJsDefault = parcelHelpers.interopDefault(_xanyJs);
/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var any = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "any"
], (0, _xanyJsDefault.default), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
exports.default = any;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xany.js":"iFA2R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iFA2R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XAny.prototype["@@transducer/result"] = function(result) {
        if (!this.any) result = this.xf["@@transducer/step"](result, false);
        return this.xf["@@transducer/result"](result);
    };
    XAny.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, _reducedJsDefault.default)(this.xf["@@transducer/step"](result, true));
        }
        return result;
    };
    return XAny;
}();
var _xany = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xany(f, xf) {
    return new XAny(f, xf);
});
exports.default = _xany;

},{"./_curry2.js":"4x4SN","./_reduced.js":"g5Cqb","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ervqU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var anyPass = /*#__PURE__*/ (0, _curry1JsDefault.default)(function anyPass(preds) {
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
exports.default = anyPass;

},{"./internal/_curry1.js":"eEHcl","./curryN.js":"757ou","./max.js":"k5zmW","./pluck.js":"aXEN0","./reduce.js":"aTmLb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k2b5D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var ap = /*#__PURE__*/ (0, _curry2JsDefault.default)(function ap(applyF, applyX) {
    return typeof applyX["fantasy-land/ap"] === "function" ? applyX["fantasy-land/ap"](applyF) : typeof applyF.ap === "function" ? applyF.ap(applyX) : typeof applyF === "function" ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, _reduceJsDefault.default)(function(acc, f) {
        return (0, _concatJsDefault.default)(acc, (0, _mapJsDefault.default)(f, applyX));
    }, [], applyF);
});
exports.default = ap;

},{"./internal/_concat.js":"8tD7U","./internal/_curry2.js":"4x4SN","./internal/_reduce.js":"81EKw","./map.js":"2D7vt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e2JtI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _apertureJs = require("./internal/_aperture.js");
var _apertureJsDefault = parcelHelpers.interopDefault(_apertureJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xapertureJs = require("./internal/_xaperture.js");
var _xapertureJsDefault = parcelHelpers.interopDefault(_xapertureJs);
/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */ var aperture = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xapertureJsDefault.default), (0, _apertureJsDefault.default)));
exports.default = aperture;

},{"./internal/_aperture.js":"8Hci0","./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xaperture.js":"3roaC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8Hci0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_aperture);
function _aperture(n, list) {
    var idx = 0;
    var limit = list.length - (n - 1);
    var acc = new Array(limit >= 0 ? limit : 0);
    while(idx < limit){
        acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
        idx += 1;
    }
    return acc;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3roaC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XAperture = /*#__PURE__*/ function() {
    function XAperture(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XAperture.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XAperture.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XAperture.prototype["@@transducer/step"] = function(result, input) {
        this.store(input);
        return this.full ? this.xf["@@transducer/step"](result, this.getCopy()) : result;
    };
    XAperture.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    XAperture.prototype.getCopy = function() {
        return (0, _concatJsDefault.default)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
    };
    return XAperture;
}();
var _xaperture = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xaperture(n, xf) {
    return new XAperture(n, xf);
});
exports.default = _xaperture;

},{"./_concat.js":"8tD7U","./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fQ2Tl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var append = /*#__PURE__*/ (0, _curry2JsDefault.default)(function append(el, list) {
    return (0, _concatJsDefault.default)(list, [
        el
    ]);
});
exports.default = append;

},{"./internal/_concat.js":"8tD7U","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4Tyh4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var apply = /*#__PURE__*/ (0, _curry2JsDefault.default)(function apply(fn, args) {
    return fn.apply(this, args);
});
exports.default = apply;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ad7bt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _applyJs = require("./apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _valuesJs = require("./values.js"); // Use custom mapValues function to avoid issues with specs that include a "map" key and R.map
var _valuesJsDefault = parcelHelpers.interopDefault(_valuesJs);
// delegating calls to .map
function mapValues(fn, obj) {
    return (0, _keysJsDefault.default)(obj).reduce(function(acc, key) {
        acc[key] = fn(obj[key]);
        return acc;
    }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var applySpec = /*#__PURE__*/ (0, _curry1JsDefault.default)(function applySpec(spec) {
    spec = mapValues(function(v) {
        return typeof v == "function" ? v : applySpec(v);
    }, spec);
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)("length", (0, _valuesJsDefault.default)(spec))), function() {
        var args = arguments;
        return mapValues(function(f) {
            return (0, _applyJsDefault.default)(f, args);
        }, spec);
    });
});
exports.default = applySpec;

},{"./internal/_curry1.js":"eEHcl","./apply.js":"4Tyh4","./curryN.js":"757ou","./max.js":"k5zmW","./pluck.js":"aXEN0","./reduce.js":"aTmLb","./keys.js":"f6WyD","./values.js":"hS7jf","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hS7jf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var values = /*#__PURE__*/ (0, _curry1JsDefault.default)(function values(obj) {
    var props = (0, _keysJsDefault.default)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
exports.default = values;

},{"./internal/_curry1.js":"eEHcl","./keys.js":"f6WyD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aMzt0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes a value and applies a function to it.
 *
 * This function is also known as the `thrush` combinator.
 *
 * @func
 * @memberOf R
 * @since v0.25.0
 * @category Function
 * @sig a -> (a -> b) -> b
 * @param {*} x The value
 * @param {Function} f The function to apply
 * @return {*} The result of applying `f` to `x`
 * @example
 *
 *      const t42 = R.applyTo(42);
 *      t42(R.identity); //=> 42
 *      t42(R.add(1)); //=> 43
 */ var applyTo = /*#__PURE__*/ (0, _curry2JsDefault.default)(function applyTo(x, f) {
    return f(x);
});
exports.default = applyTo;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cLWr7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      const byAge = R.ascend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByYoungestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var ascend = /*#__PURE__*/ (0, _curry3JsDefault.default)(function ascend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
});
exports.default = ascend;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6qBlU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var assoc = /*#__PURE__*/ (0, _curry3JsDefault.default)(function assoc(prop, val, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
});
exports.default = assoc;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"14UyM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _isNilJs = require("./isNil.js");
var _isNilJsDefault = parcelHelpers.interopDefault(_isNilJs);
/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var assocPath = /*#__PURE__*/ (0, _curry3JsDefault.default)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, _isNilJsDefault.default)(obj) && (0, _hasJsDefault.default)(idx, obj) ? obj[idx] : (0, _isIntegerJsDefault.default)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    if ((0, _isIntegerJsDefault.default)(idx) && (0, _isArrayJsDefault.default)(obj)) {
        var arr = [].concat(obj);
        arr[idx] = val;
        return arr;
    } else return (0, _assocJsDefault.default)(idx, val, obj);
});
exports.default = assocPath;

},{"./internal/_curry3.js":"2gLD0","./internal/_has.js":"k6FAr","./internal/_isArray.js":"a2KsU","./internal/_isInteger.js":"hayZl","./assoc.js":"6qBlU","./isNil.js":"5ZnbR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5ZnbR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var isNil = /*#__PURE__*/ (0, _curry1JsDefault.default)(function isNil(x) {
    return x == null;
});
exports.default = isNil;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jsYcN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      const takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      const takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */ var binary = /*#__PURE__*/ (0, _curry1JsDefault.default)(function binary(fn) {
    return (0, _nAryJsDefault.default)(2, fn);
});
exports.default = binary;

},{"./internal/_curry1.js":"eEHcl","./nAry.js":"2DwrZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2DwrZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      const takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */ var nAry = /*#__PURE__*/ (0, _curry2JsDefault.default)(function nAry(n, fn) {
    switch(n){
        case 0:
            return function() {
                return fn.call(this);
            };
        case 1:
            return function(a0) {
                return fn.call(this, a0);
            };
        case 2:
            return function(a0, a1) {
                return fn.call(this, a0, a1);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.call(this, a0, a1, a2);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.call(this, a0, a1, a2, a3);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.call(this, a0, a1, a2, a3, a4);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.call(this, a0, a1, a2, a3, a4, a5);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            };
        default:
            throw new Error("First argument to nAry must be a non-negative integer no greater than ten");
    }
});
exports.default = nAry;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2M8J9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _andJs = require("./and.js");
var _andJsDefault = parcelHelpers.interopDefault(_andJs);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */ var both = /*#__PURE__*/ (0, _curry2JsDefault.default)(function both(f, g) {
    return (0, _isFunctionJsDefault.default)(f) ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
    } : (0, _liftJsDefault.default)((0, _andJsDefault.default))(f, g);
});
exports.default = both;

},{"./internal/_curry2.js":"4x4SN","./internal/_isFunction.js":"j5B2J","./and.js":"8hhH5","./lift.js":"c8mnU","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j5B2J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isFunction);
function _isFunction(x) {
    var type = Object.prototype.toString.call(x);
    return type === "[object Function]" || type === "[object AsyncFunction]" || type === "[object GeneratorFunction]" || type === "[object AsyncGeneratorFunction]";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c8mnU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _liftNJs = require("./liftN.js");
var _liftNJsDefault = parcelHelpers.interopDefault(_liftNJs);
/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */ var lift = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lift(fn) {
    return (0, _liftNJsDefault.default)(fn.length, fn);
});
exports.default = lift;

},{"./internal/_curry1.js":"eEHcl","./liftN.js":"ceNvi","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ceNvi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _apJs = require("./ap.js");
var _apJsDefault = parcelHelpers.interopDefault(_apJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var liftN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function liftN(arity, fn) {
    var lifted = (0, _curryNJsDefault.default)(arity, fn);
    return (0, _curryNJsDefault.default)(arity, function() {
        return (0, _reduceJsDefault.default)((0, _apJsDefault.default), (0, _mapJsDefault.default)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
exports.default = liftN;

},{"./internal/_curry2.js":"4x4SN","./internal/_reduce.js":"81EKw","./ap.js":"k2b5D","./curryN.js":"757ou","./map.js":"2D7vt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3UUCC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryJs = require("./curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      const format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var call = /*#__PURE__*/ (0, _curryJsDefault.default)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
exports.default = call;

},{"./curry.js":"jcz4t","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jcz4t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var curry = /*#__PURE__*/ (0, _curry1JsDefault.default)(function curry(fn) {
    return (0, _curryNJsDefault.default)(fn.length, fn);
});
exports.default = curry;

},{"./internal/_curry1.js":"eEHcl","./curryN.js":"757ou","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8spep":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _makeFlatJs = require("./internal/_makeFlat.js");
var _makeFlatJsDefault = parcelHelpers.interopDefault(_makeFlatJs);
var _xchainJs = require("./internal/_xchain.js");
var _xchainJsDefault = parcelHelpers.interopDefault(_xchainJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var chain = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "fantasy-land/chain",
    "chain"
], (0, _xchainJsDefault.default), function chain(fn, monad) {
    if (typeof monad === "function") return function(x) {
        return fn(monad(x))(x);
    };
    return (0, _makeFlatJsDefault.default)(false)((0, _mapJsDefault.default)(fn, monad));
}));
exports.default = chain;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_makeFlat.js":"ajl9o","./internal/_xchain.js":"dEG31","./map.js":"2D7vt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ajl9o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_makeFlat);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
function _makeFlat(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, _isArrayLikeJsDefault.default)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}

},{"./_isArrayLike.js":"8KOTs","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dEG31":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _flatCatJs = require("./_flatCat.js");
var _flatCatJsDefault = parcelHelpers.interopDefault(_flatCatJs);
var _mapJs = require("../map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _xchain = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xchain(f, xf) {
    return (0, _mapJsDefault.default)(f, (0, _flatCatJsDefault.default)(xf));
});
exports.default = _xchain;

},{"./_curry2.js":"4x4SN","./_flatCat.js":"9gBda","../map.js":"2D7vt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9gBda":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _forceReducedJs = require("./_forceReduced.js");
var _forceReducedJsDefault = parcelHelpers.interopDefault(_forceReducedJs);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _reduceJs = require("./_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var preservingReduced = function(xf) {
    return {
        "@@transducer/init": (0, _xfBaseJsDefault.default).init,
        "@@transducer/result": function(result) {
            return xf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            var ret = xf["@@transducer/step"](result, input);
            return ret["@@transducer/reduced"] ? (0, _forceReducedJsDefault.default)(ret) : ret;
        }
    };
};
var _flatCat = function _xcat(xf) {
    var rxf = preservingReduced(xf);
    return {
        "@@transducer/init": (0, _xfBaseJsDefault.default).init,
        "@@transducer/result": function(result) {
            return rxf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            return !(0, _isArrayLikeJsDefault.default)(input) ? (0, _reduceJsDefault.default)(rxf, result, [
                input
            ]) : (0, _reduceJsDefault.default)(rxf, result, input);
        }
    };
};
exports.default = _flatCat;

},{"./_forceReduced.js":"aJCOP","./_isArrayLike.js":"8KOTs","./_reduce.js":"81EKw","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aJCOP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_forceReduced);
function _forceReduced(x) {
    return {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6mJWk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */ var clamp = /*#__PURE__*/ (0, _curry3JsDefault.default)(function clamp(min, max, value) {
    if (min > max) throw new Error("min must not be greater than max in clamp(min, max, value)");
    return value < min ? min : value > max ? max : value;
});
exports.default = clamp;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8ISUl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneJs = require("./internal/_clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var clone = /*#__PURE__*/ (0, _curry1JsDefault.default)(function clone(value) {
    return value != null && typeof value.clone === "function" ? value.clone() : (0, _cloneJsDefault.default)(value, [], [], true);
});
exports.default = clone;

},{"./internal/_clone.js":"bjetO","./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bjetO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_clone);
var _cloneRegExpJs = require("./_cloneRegExp.js");
var _cloneRegExpJsDefault = parcelHelpers.interopDefault(_cloneRegExpJs);
var _typeJs = require("../type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
function _clone(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
        var len = refFrom.length;
        var idx = 0;
        while(idx < len){
            if (value === refFrom[idx]) return refTo[idx];
            idx += 1;
        }
        refFrom[idx + 1] = value;
        refTo[idx + 1] = copiedValue;
        for(var key in value)copiedValue[key] = deep ? _clone(value[key], refFrom, refTo, true) : value[key];
        return copiedValue;
    };
    switch((0, _typeJsDefault.default)(value)){
        case "Object":
            return copy({});
        case "Array":
            return copy([]);
        case "Date":
            return new Date(value.valueOf());
        case "RegExp":
            return (0, _cloneRegExpJsDefault.default)(value);
        default:
            return value;
    }
}

},{"./_cloneRegExp.js":"29A6W","../type.js":"iuljW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"29A6W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_cloneRegExp);
function _cloneRegExp(pattern) {
    return new RegExp(pattern.source, (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : ""));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iuljW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var type = /*#__PURE__*/ (0, _curry1JsDefault.default)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
exports.default = type;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4NZAL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var comparator = /*#__PURE__*/ (0, _curry1JsDefault.default)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
exports.default = comparator;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"41GkG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
var _notJs = require("./not.js");
var _notJsDefault = parcelHelpers.interopDefault(_notJs);
/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var complement = /*#__PURE__*/ (0, _liftJsDefault.default)((0, _notJsDefault.default));
exports.default = complement;

},{"./lift.js":"c8mnU","./not.js":"bZ9fS","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bZ9fS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var not = /*#__PURE__*/ (0, _curry1JsDefault.default)(function not(a) {
    return !a;
});
exports.default = not;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3d9gX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compose);
var _pipeJs = require("./pipe.js");
var _pipeJsDefault = parcelHelpers.interopDefault(_pipeJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
function compose() {
    if (arguments.length === 0) throw new Error("compose requires at least one argument");
    return (0, _pipeJsDefault.default).apply(this, (0, _reverseJsDefault.default)(arguments));
}

},{"./pipe.js":"dU0Hd","./reverse.js":"2h77c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dU0Hd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pipe);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _pipeJs = require("./internal/_pipe.js");
var _pipeJsDefault = parcelHelpers.interopDefault(_pipeJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
function pipe() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return (0, _arityJsDefault.default)(arguments[0].length, (0, _reduceJsDefault.default)((0, _pipeJsDefault.default), arguments[0], (0, _tailJsDefault.default)(arguments)));
}

},{"./internal/_arity.js":"473XR","./internal/_pipe.js":"faiFB","./reduce.js":"aTmLb","./tail.js":"emrkp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"faiFB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_pipe);
function _pipe(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"emrkp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var tail = /*#__PURE__*/ (0, _curry1JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)("tail", /*#__PURE__*/ (0, _sliceJsDefault.default)(1, Infinity)));
exports.default = tail;

},{"./internal/_checkForMethod.js":"kHD0w","./internal/_curry1.js":"eEHcl","./slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kHD0w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_checkForMethod);
var _isArrayJs = require("./_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
function _checkForMethod(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, _isArrayJsDefault.default)(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

},{"./_isArray.js":"a2KsU","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4Vv0F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var slice = /*#__PURE__*/ (0, _curry3JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
exports.default = slice;

},{"./internal/_checkForMethod.js":"kHD0w","./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2h77c":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var reverse = /*#__PURE__*/ (0, _curry1JsDefault.default)(function reverse(list) {
    return (0, _isStringJsDefault.default)(list) ? list.split("").reverse().join("") : Array.prototype.slice.call(list, 0).reverse();
});
exports.default = reverse;

},{"./internal/_curry1.js":"eEHcl","./internal/_isString.js":"53k10","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9Xpvs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>composeK);
var _chainJs = require("./chain.js");
var _chainJsDefault = parcelHelpers.interopDefault(_chainJs);
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
function composeK() {
    if (arguments.length === 0) throw new Error("composeK requires at least one argument");
    var init = Array.prototype.slice.call(arguments);
    var last = init.pop();
    return (0, _composeJsDefault.default)((0, _composeJsDefault.default).apply(this, (0, _mapJsDefault.default)((0, _chainJsDefault.default), init)), last);
}

},{"./chain.js":"8spep","./compose.js":"3d9gX","./map.js":"2D7vt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9j5mb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>composeP);
var _pipePJs = require("./pipeP.js");
var _pipePJsDefault = parcelHelpers.interopDefault(_pipePJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
function composeP() {
    if (arguments.length === 0) throw new Error("composeP requires at least one argument");
    return (0, _pipePJsDefault.default).apply(this, (0, _reverseJsDefault.default)(arguments));
}

},{"./pipeP.js":"6Xnli","./reverse.js":"2h77c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6Xnli":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pipeP);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _pipePJs = require("./internal/_pipeP.js");
var _pipePJsDefault = parcelHelpers.interopDefault(_pipePJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
function pipeP() {
    if (arguments.length === 0) throw new Error("pipeP requires at least one argument");
    return (0, _arityJsDefault.default)(arguments[0].length, (0, _reduceJsDefault.default)((0, _pipePJsDefault.default), arguments[0], (0, _tailJsDefault.default)(arguments)));
}

},{"./internal/_arity.js":"473XR","./internal/_pipeP.js":"jxUmK","./reduce.js":"aTmLb","./tail.js":"emrkp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jxUmK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_pipeP);
function _pipeP(f, g) {
    return function() {
        var ctx = this;
        return f.apply(ctx, arguments).then(function(x) {
            return g.call(ctx, x);
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gZjIH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pipeWithJs = require("./pipeWith.js");
var _pipeWithJsDefault = parcelHelpers.interopDefault(_pipeWithJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
/**
 * Performs right-to-left function composition using transforming function. The last argument may have
 * any arity; the remaining arguments must be unary.
 *
 * **Note:** The result of compose is not automatically curried. Transforming function is not used on the
 * last argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, i(...args)))
 */ var composeWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function composeWith(xf, list) {
    return (0, _pipeWithJsDefault.default).apply(this, [
        xf,
        (0, _reverseJsDefault.default)(list)
    ]);
});
exports.default = composeWith;

},{"./internal/_curry2.js":"4x4SN","./pipeWith.js":"j7eA2","./reverse.js":"2h77c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j7eA2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _headJs = require("./head.js");
var _headJsDefault = parcelHelpers.interopDefault(_headJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * Performs left-to-right function composition using transforming function. The first argument may have
 * any arity; the remaining arguments must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried. Transforming function is not used on the
 * first argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, g(...args)))
 */ var pipeWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pipeWith(xf, list) {
    if (list.length <= 0) return 0, _identityJsDefault.default;
    var headList = (0, _headJsDefault.default)(list);
    var tailList = (0, _tailJsDefault.default)(list);
    return (0, _arityJsDefault.default)(headList.length, function() {
        return (0, _reduceJsDefault.default)(function(result, f) {
            return xf.call(this, f, result);
        }, headList.apply(this, arguments), tailList);
    });
});
exports.default = pipeWith;

},{"./internal/_arity.js":"473XR","./internal/_curry2.js":"4x4SN","./head.js":"hlNyr","./internal/_reduce.js":"81EKw","./tail.js":"emrkp","./identity.js":"gC6lG","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hlNyr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var head = /*#__PURE__*/ (0, _nthJsDefault.default)(0);
exports.default = head;

},{"./nth.js":"ba0ga","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gC6lG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _identityJs = require("./internal/_identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var identity = /*#__PURE__*/ (0, _curry1JsDefault.default)((0, _identityJsDefault.default));
exports.default = identity;

},{"./internal/_curry1.js":"eEHcl","./internal/_identity.js":"gz29Y","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gz29Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_identity);
function _identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"giSF9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var concat = /*#__PURE__*/ (0, _curry2JsDefault.default)(function concat(a, b) {
    if ((0, _isArrayJsDefault.default)(a)) {
        if ((0, _isArrayJsDefault.default)(b)) return a.concat(b);
        throw new TypeError((0, _toStringJsDefault.default)(b) + " is not an array");
    }
    if ((0, _isStringJsDefault.default)(a)) {
        if ((0, _isStringJsDefault.default)(b)) return a + b;
        throw new TypeError((0, _toStringJsDefault.default)(b) + " is not a string");
    }
    if (a != null && (0, _isFunctionJsDefault.default)(a["fantasy-land/concat"])) return a["fantasy-land/concat"](b);
    if (a != null && (0, _isFunctionJsDefault.default)(a.concat)) return a.concat(b);
    throw new TypeError((0, _toStringJsDefault.default)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
exports.default = concat;

},{"./internal/_curry2.js":"4x4SN","./internal/_isArray.js":"a2KsU","./internal/_isFunction.js":"j5B2J","./internal/_isString.js":"53k10","./toString.js":"7ui8E","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7ui8E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _toStringJs = require("./internal/_toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var toString = /*#__PURE__*/ (0, _curry1JsDefault.default)(function toString(val) {
    return (0, _toStringJsDefault.default)(val, []);
});
exports.default = toString;

},{"./internal/_curry1.js":"eEHcl","./internal/_toString.js":"bdayP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bdayP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toString);
var _includesJs = require("./_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _mapJs = require("./_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _quoteJs = require("./_quote.js");
var _quoteJsDefault = parcelHelpers.interopDefault(_quoteJs);
var _toISOStringJs = require("./_toISOString.js");
var _toISOStringJsDefault = parcelHelpers.interopDefault(_toISOStringJs);
var _keysJs = require("../keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _rejectJs = require("../reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
function _toString(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, _includesJsDefault.default)(y, xs) ? "<Circular>" : _toString(y, xs);
    }; //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, _mapJsDefault.default)(function(k) {
            return (0, _quoteJsDefault.default)(k) + ": " + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + (0, _mapJsDefault.default)(recur, x).join(", ") + "))";
        case "[object Array]":
            return "[" + (0, _mapJsDefault.default)(recur, x).concat(mapPairs(x, (0, _rejectJsDefault.default)(function(k) {
                return /^\d+$/.test(k);
            }, (0, _keysJsDefault.default)(x)))).join(", ") + "]";
        case "[object Boolean]":
            return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : (0, _quoteJsDefault.default)((0, _toISOStringJsDefault.default)(x))) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
        case "[object String]":
            return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : (0, _quoteJsDefault.default)(x);
        case "[object Undefined]":
            return "undefined";
        default:
            if (typeof x.toString === "function") {
                var repr = x.toString();
                if (repr !== "[object Object]") return repr;
            }
            return "{" + mapPairs(x, (0, _keysJsDefault.default)(x)).join(", ") + "}";
    }
}

},{"./_includes.js":"6lW2G","./_map.js":"aibsD","./_quote.js":"cbLMN","./_toISOString.js":"bFvBw","../keys.js":"f6WyD","../reject.js":"frSvm","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6lW2G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_includes);
var _indexOfJs = require("./_indexOf.js");
var _indexOfJsDefault = parcelHelpers.interopDefault(_indexOfJs);
function _includes(a, list) {
    return (0, _indexOfJsDefault.default)(list, a, 0) >= 0;
}

},{"./_indexOf.js":"6dZRb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6dZRb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_indexOf);
var _equalsJs = require("../equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
function _indexOf(list, a, idx) {
    var inf, item; // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === "function") switch(typeof a){
        case "number":
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === "number" && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            } // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case "string":
        case "boolean":
        case "function":
        case "undefined":
            return list.indexOf(a, idx);
        case "object":
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
     // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, _equalsJsDefault.default)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}

},{"../equals.js":"lVaDh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lVaDh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./internal/_equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var equals = /*#__PURE__*/ (0, _curry2JsDefault.default)(function equals(a, b) {
    return (0, _equalsJsDefault.default)(a, b, [], []);
});
exports.default = equals;

},{"./internal/_curry2.js":"4x4SN","./internal/_equals.js":"f5CKg","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f5CKg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_equals);
var _arrayFromIteratorJs = require("./_arrayFromIterator.js");
var _arrayFromIteratorJsDefault = parcelHelpers.interopDefault(_arrayFromIteratorJs);
var _includesWithJs = require("./_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _functionNameJs = require("./_functionName.js");
var _functionNameJsDefault = parcelHelpers.interopDefault(_functionNameJs);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _objectIsJs = require("./_objectIs.js");
var _objectIsJsDefault = parcelHelpers.interopDefault(_objectIsJs);
var _keysJs = require("../keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _typeJs = require("../type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, _arrayFromIteratorJsDefault.default)(aIterator);
    var b = (0, _arrayFromIteratorJsDefault.default)(bIterator);
    function eq(_a, _b) {
        return _equals(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*
    return !(0, _includesWithJsDefault.default)(function(b, aItem) {
        return !(0, _includesWithJsDefault.default)(eq, aItem, b);
    }, b, a);
}
function _equals(a, b, stackA, stackB) {
    if ((0, _objectIsJsDefault.default)(a, b)) return true;
    var typeA = (0, _typeJsDefault.default)(a);
    if (typeA !== (0, _typeJsDefault.default)(b)) return false;
    if (a == null || b == null) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && (0, _functionNameJsDefault.default)(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && (0, _objectIsJsDefault.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!(0, _objectIsJsDefault.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return _uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, _keysJsDefault.default)(a);
    if (keysA.length !== (0, _keysJsDefault.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, _hasJsDefault.default)(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

},{"./_arrayFromIterator.js":"gxWst","./_includesWith.js":"guGfi","./_functionName.js":"dFM4Y","./_has.js":"k6FAr","./_objectIs.js":"dOQSV","../keys.js":"f6WyD","../type.js":"iuljW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gxWst":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayFromIterator);
function _arrayFromIterator(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"guGfi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_includesWith);
function _includesWith(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dFM4Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_functionName);
function _functionName(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dOQSV":[function(require,module,exports) {
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
exports.default = typeof Object.is === "function" ? Object.is : _objectIs;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cbLMN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_quote);
function _quote(s) {
    var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b") // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bFvBw":[function(require,module,exports) {
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var pad = function pad(n) {
    return (n < 10 ? "0" : "") + n;
};
var _toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()) + "T" + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + "Z";
};
exports.default = _toISOString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"frSvm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _complementJs = require("./internal/_complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var reject = /*#__PURE__*/ (0, _curry2JsDefault.default)(function reject(pred, filterable) {
    return (0, _filterJsDefault.default)((0, _complementJsDefault.default)(pred), filterable);
});
exports.default = reject;

},{"./internal/_complement.js":"6he84","./internal/_curry2.js":"4x4SN","./filter.js":"4D8wM","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6he84":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_complement);
function _complement(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4D8wM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _filterJs = require("./internal/_filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _isObjectJs = require("./internal/_isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xfilterJs = require("./internal/_xfilter.js");
var _xfilterJsDefault = parcelHelpers.interopDefault(_xfilterJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var filter = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "filter"
], (0, _xfilterJsDefault.default), function(pred, filterable) {
    return (0, _isObjectJsDefault.default)(filterable) ? (0, _reduceJsDefault.default)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, _keysJsDefault.default)(filterable)) : (0, _filterJsDefault.default)(pred, filterable);
}));
exports.default = filter;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_filter.js":"kUiqY","./internal/_isObject.js":"bcg1p","./internal/_reduce.js":"81EKw","./internal/_xfilter.js":"7L7Lg","./keys.js":"f6WyD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kUiqY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_filter);
function _filter(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bcg1p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isObject);
function _isObject(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7L7Lg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XFilter.prototype["@@transducer/result"] = (0, _xfBaseJsDefault.default).result;
    XFilter.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XFilter;
}();
var _xfilter = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfilter(f, xf) {
    return new XFilter(f, xf);
});
exports.default = _xfilter;

},{"./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9ZUUA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var cond = /*#__PURE__*/ (0, _curry1JsDefault.default)(function cond(pairs) {
    var arity = (0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _mapJsDefault.default)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, _arityJsDefault.default)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
exports.default = cond;

},{"./internal/_arity.js":"473XR","./internal/_curry1.js":"eEHcl","./map.js":"2D7vt","./max.js":"k5zmW","./reduce.js":"aTmLb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2Z9e0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _constructNJs = require("./constructN.js");
var _constructNJsDefault = parcelHelpers.interopDefault(_constructNJs);
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      const AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      const animalTypes = ["Lion", "Tiger", "Bear"];
 *      const animalSighting = R.invoker(0, 'sighting');
 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */ var construct = /*#__PURE__*/ (0, _curry1JsDefault.default)(function construct(Fn) {
    return (0, _constructNJsDefault.default)(Fn.length, Fn);
});
exports.default = construct;

},{"./internal/_curry1.js":"eEHcl","./constructN.js":"crHkj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"crHkj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryJs = require("./curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      const ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */ var constructN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function constructN(n, Fn) {
    if (n > 10) throw new Error("Constructor with greater than ten arguments");
    if (n === 0) return function() {
        return new Fn();
    };
    return (0, _curryJsDefault.default)((0, _nAryJsDefault.default)(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
        switch(arguments.length){
            case 1:
                return new Fn($0);
            case 2:
                return new Fn($0, $1);
            case 3:
                return new Fn($0, $1, $2);
            case 4:
                return new Fn($0, $1, $2, $3);
            case 5:
                return new Fn($0, $1, $2, $3, $4);
            case 6:
                return new Fn($0, $1, $2, $3, $4, $5);
            case 7:
                return new Fn($0, $1, $2, $3, $4, $5, $6);
            case 8:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
            case 9:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
            case 10:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
        }
    }));
});
exports.default = constructN;

},{"./internal/_curry2.js":"4x4SN","./curry.js":"jcz4t","./nAry.js":"2DwrZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eKlsV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.includes
 * @deprecated since v0.26.0
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 *      R.contains('ba', 'banana'); //=>true
 */ var contains = /*#__PURE__*/ (0, _curry2JsDefault.default)((0, _includesJsDefault.default));
exports.default = contains;

},{"./internal/_includes.js":"6lW2G","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eY55M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mapJs = require("./internal/_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var converge = /*#__PURE__*/ (0, _curry2JsDefault.default)(function converge(after, fns) {
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)("length", fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, _mapJsDefault.default)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
exports.default = converge;

},{"./internal/_curry2.js":"4x4SN","./internal/_map.js":"aibsD","./curryN.js":"757ou","./max.js":"k5zmW","./pluck.js":"aXEN0","./reduce.js":"aTmLb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5czs0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var countBy = /*#__PURE__*/ (0, _reduceByJsDefault.default)(function(acc, elem) {
    return acc + 1;
}, 0);
exports.default = countBy;

},{"./reduceBy.js":"b4AqF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"b4AqF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneJs = require("./internal/_clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _curryNJs = require("./internal/_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xreduceByJs = require("./internal/_xreduceBy.js");
var _xreduceByJsDefault = parcelHelpers.interopDefault(_xreduceByJs);
/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */ var reduceBy = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, [], /*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xreduceByJsDefault.default), function reduceBy(valueFn, valueAcc, keyFn, list) {
    return (0, _reduceJsDefault.default)(function(acc, elt) {
        var key = keyFn(elt);
        acc[key] = valueFn((0, _hasJsDefault.default)(key, acc) ? acc[key] : (0, _cloneJsDefault.default)(valueAcc, [], [], false), elt);
        return acc;
    }, {}, list);
}));
exports.default = reduceBy;

},{"./internal/_clone.js":"bjetO","./internal/_curryN.js":"i0t26","./internal/_dispatchable.js":"c9mel","./internal/_has.js":"k6FAr","./internal/_reduce.js":"81EKw","./internal/_xreduceBy.js":"lb2MX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lb2MX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XReduceBy.prototype["@@transducer/result"] = function(result) {
        var key;
        for(key in this.inputs)if ((0, _hasJsDefault.default)(key, this.inputs)) {
            result = this.xf["@@transducer/step"](result, this.inputs[key]);
            if (result["@@transducer/reduced"]) {
                result = result["@@transducer/value"];
                break;
            }
        }
        this.inputs = null;
        return this.xf["@@transducer/result"](result);
    };
    XReduceBy.prototype["@@transducer/step"] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            this.valueAcc
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
var _xreduceBy = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
    return new XReduceBy(valueFn, valueAcc, keyFn, xf);
});
exports.default = _xreduceBy;

},{"./_curryN.js":"i0t26","./_has.js":"k6FAr","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"awjH7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */ var dec = /*#__PURE__*/ (0, _addJsDefault.default)(-1);
exports.default = dec;

},{"./add.js":"eK5zq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4Ad0O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var defaultTo = /*#__PURE__*/ (0, _curry2JsDefault.default)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
exports.default = defaultTo;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"JaHMX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */ var descend = /*#__PURE__*/ (0, _curry3JsDefault.default)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
exports.default = descend;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lJWRb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _setJs = require("./internal/_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var difference = /*#__PURE__*/ (0, _curry2JsDefault.default)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new (0, _setJsDefault.default)();
    for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
    while(idx < firstLen){
        if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
exports.default = difference;

},{"./internal/_curry2.js":"4x4SN","./internal/_Set.js":"6MZh9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6MZh9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === "function" ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !hasOrAdd(item, true, this);
    }; //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return hasOrAdd(item, false, this);
    }; //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch(type){
        case "string":
        case "number":
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items["-0"]) return true;
                else {
                    if (shouldAdd) set._items["-0"] = true;
                    return false;
                }
            } // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case "boolean":
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case "function":
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, _includesJsDefault.default)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case "undefined":
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case "object":
            if (item === null) {
                if (!set._items["null"]) {
                    if (shouldAdd) set._items["null"] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            } // scan through all previously applied items
            if (!(0, _includesJsDefault.default)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
} // A simple Set type that honours R.equals semantics
exports.default = _Set;

},{"./_includes.js":"6lW2G","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hkTEI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesWithJs = require("./internal/_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */ var differenceWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, _includesWithJsDefault.default)(pred, first[idx], second) && !(0, _includesWithJsDefault.default)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
exports.default = differenceWith;

},{"./internal/_includesWith.js":"guGfi","./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4m6XK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var dissoc = /*#__PURE__*/ (0, _curry2JsDefault.default)(function dissoc(prop, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
});
exports.default = dissoc;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j6az2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _dissocJs = require("./dissoc.js");
var _dissocJsDefault = parcelHelpers.interopDefault(_dissocJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _updateJs = require("./update.js");
var _updateJsDefault = parcelHelpers.interopDefault(_updateJs);
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var dissocPath = /*#__PURE__*/ (0, _curry2JsDefault.default)(function dissocPath(path, obj) {
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, _isIntegerJsDefault.default)(path[0]) && (0, _isArrayJsDefault.default)(obj) ? (0, _removeJsDefault.default)(path[0], 1, obj) : (0, _dissocJsDefault.default)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return obj;
            else if ((0, _isIntegerJsDefault.default)(head) && (0, _isArrayJsDefault.default)(obj)) return (0, _updateJsDefault.default)(head, dissocPath(tail, obj[head]), obj);
            else return (0, _assocJsDefault.default)(head, dissocPath(tail, obj[head]), obj);
    }
});
exports.default = dissocPath;

},{"./internal/_curry2.js":"4x4SN","./internal/_isInteger.js":"hayZl","./internal/_isArray.js":"a2KsU","./assoc.js":"6qBlU","./dissoc.js":"4m6XK","./remove.js":"5Noe7","./update.js":"is5js","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5Noe7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var remove = /*#__PURE__*/ (0, _curry3JsDefault.default)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
exports.default = remove;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"is5js":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _adjustJs = require("./adjust.js");
var _adjustJsDefault = parcelHelpers.interopDefault(_adjustJs);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var update = /*#__PURE__*/ (0, _curry3JsDefault.default)(function update(idx, x, list) {
    return (0, _adjustJsDefault.default)(idx, (0, _alwaysJsDefault.default)(x), list);
});
exports.default = update;

},{"./internal/_curry3.js":"2gLD0","./adjust.js":"iBS73","./always.js":"ilsuC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"INp3H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var divide = /*#__PURE__*/ (0, _curry2JsDefault.default)(function divide(a, b) {
    return a / b;
});
exports.default = divide;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2ymqB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropJs = require("./internal/_xdrop.js");
var _xdropJsDefault = parcelHelpers.interopDefault(_xdropJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var drop = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "drop"
], (0, _xdropJsDefault.default), function drop(n, xs) {
    return (0, _sliceJsDefault.default)(Math.max(0, n), Infinity, xs);
}));
exports.default = drop;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xdrop.js":"f0a7p","./slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f0a7p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XDrop.prototype["@@transducer/result"] = (0, _xfBaseJsDefault.default).result;
    XDrop.prototype["@@transducer/step"] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDrop;
}();
var _xdrop = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdrop(n, xf) {
    return new XDrop(n, xf);
});
exports.default = _xdrop;

},{"./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1I8Mg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _dropLastJs = require("./internal/_dropLast.js");
var _dropLastJsDefault = parcelHelpers.interopDefault(_dropLastJs);
var _xdropLastJs = require("./internal/_xdropLast.js");
var _xdropLastJsDefault = parcelHelpers.interopDefault(_xdropLastJs);
/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */ var dropLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xdropLastJsDefault.default), (0, _dropLastJsDefault.default)));
exports.default = dropLast;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_dropLast.js":"aj28E","./internal/_xdropLast.js":"2uYKg","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aj28E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dropLast);
var _takeJs = require("../take.js");
var _takeJsDefault = parcelHelpers.interopDefault(_takeJs);
function dropLast(n, xs) {
    return (0, _takeJsDefault.default)(n < xs.length ? xs.length - n : 0, xs);
}

},{"../take.js":"nrooI","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"nrooI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xtakeJs = require("./internal/_xtake.js");
var _xtakeJsDefault = parcelHelpers.interopDefault(_xtakeJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var take = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "take"
], (0, _xtakeJsDefault.default), function take(n, xs) {
    return (0, _sliceJsDefault.default)(0, n < 0 ? Infinity : n, xs);
}));
exports.default = take;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xtake.js":"5huJ7","./slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5huJ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XTake.prototype["@@transducer/result"] = (0, _xfBaseJsDefault.default).result;
    XTake.prototype["@@transducer/step"] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf["@@transducer/step"](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, _reducedJsDefault.default)(ret) : ret;
    };
    return XTake;
}();
var _xtake = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xtake(n, xf) {
    return new XTake(n, xf);
});
exports.default = _xtake;

},{"./_curry2.js":"4x4SN","./_reduced.js":"g5Cqb","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2uYKg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropLast = /*#__PURE__*/ function() {
    function XDropLast(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XDropLast.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XDropLast.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.full) result = this.xf["@@transducer/step"](result, this.acc[this.pos]);
        this.store(input);
        return result;
    };
    XDropLast.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    return XDropLast;
}();
var _xdropLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropLast(n, xf) {
    return new XDropLast(n, xf);
});
exports.default = _xdropLast;

},{"./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"80qiv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _dropLastWhileJs = require("./internal/_dropLastWhile.js");
var _dropLastWhileJsDefault = parcelHelpers.interopDefault(_dropLastWhileJs);
var _xdropLastWhileJs = require("./internal/_xdropLastWhile.js");
var _xdropLastWhileJsDefault = parcelHelpers.interopDefault(_xdropLastWhileJs);
/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */ var dropLastWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xdropLastWhileJsDefault.default), (0, _dropLastWhileJsDefault.default)));
exports.default = dropLastWhile;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_dropLastWhile.js":"kDGO5","./internal/_xdropLastWhile.js":"7D9ir","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kDGO5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dropLastWhile);
var _sliceJs = require("../slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
function dropLastWhile(pred, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && pred(xs[idx]))idx -= 1;
    return (0, _sliceJsDefault.default)(0, idx + 1, xs);
}

},{"../slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7D9ir":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropLastWhile = /*#__PURE__*/ function() {
    function XDropLastWhile(fn, xf) {
        this.f = fn;
        this.retained = [];
        this.xf = xf;
    }
    XDropLastWhile.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XDropLastWhile.prototype["@@transducer/result"] = function(result) {
        this.retained = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLastWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.retain(result, input) : this.flush(result, input);
    };
    XDropLastWhile.prototype.flush = function(result, input) {
        result = (0, _reduceJsDefault.default)(this.xf["@@transducer/step"], result, this.retained);
        this.retained = [];
        return this.xf["@@transducer/step"](result, input);
    };
    XDropLastWhile.prototype.retain = function(result, input) {
        this.retained.push(input);
        return result;
    };
    return XDropLastWhile;
}();
var _xdropLastWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropLastWhile(fn, xf) {
    return new XDropLastWhile(fn, xf);
});
exports.default = _xdropLastWhile;

},{"./_curry2.js":"4x4SN","./_reduce.js":"81EKw","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iHXfe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropRepeatsWithJs = require("./internal/_xdropRepeatsWith.js");
var _xdropRepeatsWithJsDefault = parcelHelpers.interopDefault(_xdropRepeatsWithJs);
var _dropRepeatsWithJs = require("./dropRepeatsWith.js");
var _dropRepeatsWithJsDefault = parcelHelpers.interopDefault(_dropRepeatsWithJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */ var dropRepeats = /*#__PURE__*/ (0, _curry1JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], /*#__PURE__*/ (0, _xdropRepeatsWithJsDefault.default)((0, _equalsJsDefault.default)), /*#__PURE__*/ (0, _dropRepeatsWithJsDefault.default)((0, _equalsJsDefault.default))));
exports.default = dropRepeats;

},{"./internal/_curry1.js":"eEHcl","./internal/_dispatchable.js":"c9mel","./internal/_xdropRepeatsWith.js":"gF7tc","./dropRepeatsWith.js":"gGTk3","./equals.js":"lVaDh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gF7tc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropRepeatsWith = /*#__PURE__*/ function() {
    function XDropRepeatsWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.lastValue = undefined;
        this.seenFirstValue = false;
    }
    XDropRepeatsWith.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XDropRepeatsWith.prototype["@@transducer/result"] = (0, _xfBaseJsDefault.default).result;
    XDropRepeatsWith.prototype["@@transducer/step"] = function(result, input) {
        var sameAsLast = false;
        if (!this.seenFirstValue) this.seenFirstValue = true;
        else if (this.pred(this.lastValue, input)) sameAsLast = true;
        this.lastValue = input;
        return sameAsLast ? result : this.xf["@@transducer/step"](result, input);
    };
    return XDropRepeatsWith;
}();
var _xdropRepeatsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropRepeatsWith(pred, xf) {
    return new XDropRepeatsWith(pred, xf);
});
exports.default = _xdropRepeatsWith;

},{"./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gGTk3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropRepeatsWithJs = require("./internal/_xdropRepeatsWith.js");
var _xdropRepeatsWithJsDefault = parcelHelpers.interopDefault(_xdropRepeatsWithJs);
var _lastJs = require("./last.js");
var _lastJsDefault = parcelHelpers.interopDefault(_lastJs);
/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */ var dropRepeatsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xdropRepeatsWithJsDefault.default), function dropRepeatsWith(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
        result[0] = list[0];
        while(idx < len){
            if (!pred((0, _lastJsDefault.default)(result), list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
    }
    return result;
}));
exports.default = dropRepeatsWith;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xdropRepeatsWith.js":"gF7tc","./last.js":"bDRve","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bDRve":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var last = /*#__PURE__*/ (0, _nthJsDefault.default)(-1);
exports.default = last;

},{"./nth.js":"ba0ga","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gISrh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropWhileJs = require("./internal/_xdropWhile.js");
var _xdropWhileJsDefault = parcelHelpers.interopDefault(_xdropWhileJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */ var dropWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "dropWhile"
], (0, _xdropWhileJsDefault.default), function dropWhile(pred, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && pred(xs[idx]))idx += 1;
    return (0, _sliceJsDefault.default)(idx, Infinity, xs);
}));
exports.default = dropWhile;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xdropWhile.js":"fbnrc","./slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fbnrc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropWhile = /*#__PURE__*/ function() {
    function XDropWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XDropWhile.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XDropWhile.prototype["@@transducer/result"] = (0, _xfBaseJsDefault.default).result;
    XDropWhile.prototype["@@transducer/step"] = function(result, input) {
        if (this.f) {
            if (this.f(input)) return result;
            this.f = null;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDropWhile;
}();
var _xdropWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropWhile(f, xf) {
    return new XDropWhile(f, xf);
});
exports.default = _xdropWhile;

},{"./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gRAYT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
var _orJs = require("./or.js");
var _orJsDefault = parcelHelpers.interopDefault(_orJs);
/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */ var either = /*#__PURE__*/ (0, _curry2JsDefault.default)(function either(f, g) {
    return (0, _isFunctionJsDefault.default)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, _liftJsDefault.default)((0, _orJsDefault.default))(f, g);
});
exports.default = either;

},{"./internal/_curry2.js":"4x4SN","./internal/_isFunction.js":"j5B2J","./lift.js":"c8mnU","./or.js":"9WCxL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9WCxL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either, R.xor
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var or = /*#__PURE__*/ (0, _curry2JsDefault.default)(function or(a, b) {
    return a || b;
});
exports.default = or;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k7YHl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isArgumentsJs = require("./internal/_isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isObjectJs = require("./internal/_isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */ var empty = /*#__PURE__*/ (0, _curry1JsDefault.default)(function empty(x) {
    return x != null && typeof x["fantasy-land/empty"] === "function" ? x["fantasy-land/empty"]() : x != null && x.constructor != null && typeof x.constructor["fantasy-land/empty"] === "function" ? x.constructor["fantasy-land/empty"]() : x != null && typeof x.empty === "function" ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === "function" ? x.constructor.empty() : (0, _isArrayJsDefault.default)(x) ? [] : (0, _isStringJsDefault.default)(x) ? "" : (0, _isObjectJsDefault.default)(x) ? {} : (0, _isArgumentsJsDefault.default)(x) ? function() {
        return arguments;
    }() : void 0 // else
    ;
});
exports.default = empty;

},{"./internal/_curry1.js":"eEHcl","./internal/_isArguments.js":"aW0qk","./internal/_isArray.js":"a2KsU","./internal/_isObject.js":"bcg1p","./internal/_isString.js":"53k10","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6o0eY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _takeLastJs = require("./takeLast.js");
var _takeLastJsDefault = parcelHelpers.interopDefault(_takeLastJs);
/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var endsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(suffix, list) {
    return (0, _equalsJsDefault.default)((0, _takeLastJsDefault.default)(suffix.length, list), suffix);
});
exports.default = endsWith;

},{"./internal/_curry2.js":"4x4SN","./equals.js":"lVaDh","./takeLast.js":"cniuF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cniuF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dropJs = require("./drop.js");
var _dropJsDefault = parcelHelpers.interopDefault(_dropJs);
/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var takeLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(function takeLast(n, xs) {
    return (0, _dropJsDefault.default)(n >= 0 ? xs.length - n : 0, xs);
});
exports.default = takeLast;

},{"./internal/_curry2.js":"4x4SN","./drop.js":"2ymqB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"czp0D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */ var eqBy = /*#__PURE__*/ (0, _curry3JsDefault.default)(function eqBy(f, x, y) {
    return (0, _equalsJsDefault.default)(f(x), f(y));
});
exports.default = eqBy;

},{"./internal/_curry3.js":"2gLD0","./equals.js":"lVaDh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gRkda":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var eqProps = /*#__PURE__*/ (0, _curry3JsDefault.default)(function eqProps(prop, obj1, obj2) {
    return (0, _equalsJsDefault.default)(obj1[prop], obj2[prop]);
});
exports.default = eqProps;

},{"./internal/_curry3.js":"2gLD0","./equals.js":"lVaDh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aK2gh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var evolve = /*#__PURE__*/ (0, _curry2JsDefault.default)(function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === "function" ? transformation(object[key]) : transformation && type === "object" ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
exports.default = evolve;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jxGb6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindJs = require("./internal/_xfind.js");
var _xfindJsDefault = parcelHelpers.interopDefault(_xfindJs);
/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var find = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "find"
], (0, _xfindJsDefault.default), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
exports.default = find;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xfind.js":"1OjMj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1OjMj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XFind.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, void 0);
        return this.xf["@@transducer/result"](result);
    };
    XFind.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, _reducedJsDefault.default)(this.xf["@@transducer/step"](result, input));
        }
        return result;
    };
    return XFind;
}();
var _xfind = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfind(f, xf) {
    return new XFind(f, xf);
});
exports.default = _xfind;

},{"./_curry2.js":"4x4SN","./_reduced.js":"g5Cqb","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h8TAc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindIndexJs = require("./internal/_xfindIndex.js");
var _xfindIndexJsDefault = parcelHelpers.interopDefault(_xfindIndexJs);
/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var findIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xfindIndexJsDefault.default), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
exports.default = findIndex;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xfindIndex.js":"c6KcX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c6KcX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XFindIndex.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, -1);
        return this.xf["@@transducer/result"](result);
    };
    XFindIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, _reducedJsDefault.default)(this.xf["@@transducer/step"](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
var _xfindIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfindIndex(f, xf) {
    return new XFindIndex(f, xf);
});
exports.default = _xfindIndex;

},{"./_curry2.js":"4x4SN","./_reduced.js":"g5Cqb","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fx2eJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindLastJs = require("./internal/_xfindLast.js");
var _xfindLastJsDefault = parcelHelpers.interopDefault(_xfindLastJs);
/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var findLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xfindLastJsDefault.default), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
exports.default = findLast;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xfindLast.js":"1StSw","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1StSw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XFindLast.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.last));
    };
    XFindLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
var _xfindLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfindLast(f, xf) {
    return new XFindLast(f, xf);
});
exports.default = _xfindLast;

},{"./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f8rz3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindLastIndexJs = require("./internal/_xfindLastIndex.js");
var _xfindLastIndexJsDefault = parcelHelpers.interopDefault(_xfindLastIndexJs);
/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */ var findLastIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xfindLastIndexJsDefault.default), function findLastIndex(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return idx;
        idx -= 1;
    }
    return -1;
}));
exports.default = findLastIndex;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xfindLastIndex.js":"99tmE","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"99tmE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFindLastIndex = /*#__PURE__*/ function() {
    function XFindLastIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.lastIdx = -1;
    }
    XFindLastIndex.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XFindLastIndex.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.lastIdx));
    };
    XFindLastIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) this.lastIdx = this.idx;
        return result;
    };
    return XFindLastIndex;
}();
var _xfindLastIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfindLastIndex(f, xf) {
    return new XFindLastIndex(f, xf);
});
exports.default = _xfindLastIndex;

},{"./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hr83s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _makeFlatJs = require("./internal/_makeFlat.js");
var _makeFlatJsDefault = parcelHelpers.interopDefault(_makeFlatJs);
/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var flatten = /*#__PURE__*/ (0, _curry1JsDefault.default)(/*#__PURE__*/ (0, _makeFlatJsDefault.default)(true));
exports.default = flatten;

},{"./internal/_curry1.js":"eEHcl","./internal/_makeFlat.js":"ajl9o","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dG058":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var flip = /*#__PURE__*/ (0, _curry1JsDefault.default)(function flip(fn) {
    return (0, _curryNJsDefault.default)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
exports.default = flip;

},{"./internal/_curry1.js":"eEHcl","./curryN.js":"757ou","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"NkaK7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */ var forEach = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)("forEach", function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while(idx < len){
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
exports.default = forEach;

},{"./internal/_checkForMethod.js":"kHD0w","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cjohL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var forEachObjIndexed = /*#__PURE__*/ (0, _curry2JsDefault.default)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, _keysJsDefault.default)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
exports.default = forEachObjIndexed;

},{"./internal/_curry2.js":"4x4SN","./keys.js":"f6WyD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6krRf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var fromPairs = /*#__PURE__*/ (0, _curry1JsDefault.default)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
exports.default = fromPairs;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1cHwK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var groupBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)("groupBy", /*#__PURE__*/ (0, _reduceByJsDefault.default)(function(acc, item) {
    if (acc == null) acc = [];
    acc.push(item);
    return acc;
}, null)));
exports.default = groupBy;

},{"./internal/_checkForMethod.js":"kHD0w","./internal/_curry2.js":"4x4SN","./reduceBy.js":"b4AqF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k4GMQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */ var groupWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(fn, list) {
    var res = [];
    var idx = 0;
    var len = list.length;
    while(idx < len){
        var nextidx = idx + 1;
        while(nextidx < len && fn(list[nextidx - 1], list[nextidx]))nextidx += 1;
        res.push(list.slice(idx, nextidx));
        idx = nextidx;
    }
    return res;
});
exports.default = groupWith;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2VJD7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var gt = /*#__PURE__*/ (0, _curry2JsDefault.default)(function gt(a, b) {
    return a > b;
});
exports.default = gt;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"BP6Rl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */ var gte = /*#__PURE__*/ (0, _curry2JsDefault.default)(function gte(a, b) {
    return a >= b;
});
exports.default = gte;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5f1cX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasPathJs = require("./hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var has = /*#__PURE__*/ (0, _curry2JsDefault.default)(function has(prop, obj) {
    return (0, _hasPathJsDefault.default)([
        prop
    ], obj);
});
exports.default = has;

},{"./internal/_curry2.js":"4x4SN","./hasPath.js":"8snUh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8snUh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _isNilJs = require("./isNil.js");
var _isNilJsDefault = parcelHelpers.interopDefault(_isNilJs);
/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var hasPath = /*#__PURE__*/ (0, _curry2JsDefault.default)(function hasPath(_path, obj) {
    if (_path.length === 0 || (0, _isNilJsDefault.default)(obj)) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if (!(0, _isNilJsDefault.default)(val) && (0, _hasJsDefault.default)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
exports.default = hasPath;

},{"./internal/_curry2.js":"4x4SN","./internal/_has.js":"k6FAr","./isNil.js":"5ZnbR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k1nwP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      const square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */ var hasIn = /*#__PURE__*/ (0, _curry2JsDefault.default)(function hasIn(prop, obj) {
    return prop in obj;
});
exports.default = hasIn;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1v5pZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectIsJs = require("./internal/_objectIs.js");
var _objectIsJsDefault = parcelHelpers.interopDefault(_objectIsJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var identical = /*#__PURE__*/ (0, _curry2JsDefault.default)((0, _objectIsJsDefault.default));
exports.default = identical;

},{"./internal/_objectIs.js":"dOQSV","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6byot":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */ var ifElse = /*#__PURE__*/ (0, _curry3JsDefault.default)(function ifElse(condition, onTrue, onFalse) {
    return (0, _curryNJsDefault.default)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
exports.default = ifElse;

},{"./internal/_curry3.js":"2gLD0","./curryN.js":"757ou","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dqY19":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */ var inc = /*#__PURE__*/ (0, _addJsDefault.default)(1);
exports.default = inc;

},{"./add.js":"eK5zq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"35Miw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */ var includes = /*#__PURE__*/ (0, _curry2JsDefault.default)((0, _includesJsDefault.default));
exports.default = includes;

},{"./internal/_includes.js":"6lW2G","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gCEfs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var indexBy = /*#__PURE__*/ (0, _reduceByJsDefault.default)(function(acc, elem) {
    return elem;
}, null);
exports.default = indexBy;

},{"./reduceBy.js":"b4AqF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jGl0p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _indexOfJs = require("./internal/_indexOf.js");
var _indexOfJsDefault = parcelHelpers.interopDefault(_indexOfJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */ var indexOf = /*#__PURE__*/ (0, _curry2JsDefault.default)(function indexOf(target, xs) {
    return typeof xs.indexOf === "function" && !(0, _isArrayJsDefault.default)(xs) ? xs.indexOf(target) : (0, _indexOfJsDefault.default)(xs, target, 0);
});
exports.default = indexOf;

},{"./internal/_curry2.js":"4x4SN","./internal/_indexOf.js":"6dZRb","./internal/_isArray.js":"a2KsU","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6ykqm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */ var init = /*#__PURE__*/ (0, _sliceJsDefault.default)(0, -1);
exports.default = init;

},{"./slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3jPCI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesWithJs = require("./internal/_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _filterJs = require("./internal/_filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */ var innerJoin = /*#__PURE__*/ (0, _curry3JsDefault.default)(function innerJoin(pred, xs, ys) {
    return (0, _filterJsDefault.default)(function(x) {
        return (0, _includesWithJsDefault.default)(pred, x, ys);
    }, xs);
});
exports.default = innerJoin;

},{"./internal/_includesWith.js":"guGfi","./internal/_curry3.js":"2gLD0","./internal/_filter.js":"kUiqY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cI2nK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var insert = /*#__PURE__*/ (0, _curry3JsDefault.default)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
exports.default = insert;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e4Wlq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var insertAll = /*#__PURE__*/ (0, _curry3JsDefault.default)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
exports.default = insertAll;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4PZEK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _filterJs = require("./internal/_filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _uniqJs = require("./uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var intersection = /*#__PURE__*/ (0, _curry2JsDefault.default)(function intersection(list1, list2) {
    var lookupList, filteredList;
    if (list1.length > list2.length) {
        lookupList = list1;
        filteredList = list2;
    } else {
        lookupList = list2;
        filteredList = list1;
    }
    return (0, _uniqJsDefault.default)((0, _filterJsDefault.default)((0, _flipJsDefault.default)((0, _includesJsDefault.default))(lookupList), filteredList));
});
exports.default = intersection;

},{"./internal/_includes.js":"6lW2G","./internal/_curry2.js":"4x4SN","./internal/_filter.js":"kUiqY","./flip.js":"dG058","./uniq.js":"3p6a8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3p6a8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _uniqByJs = require("./uniqBy.js");
var _uniqByJsDefault = parcelHelpers.interopDefault(_uniqByJs);
/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var uniq = /*#__PURE__*/ (0, _uniqByJsDefault.default)((0, _identityJsDefault.default));
exports.default = uniq;

},{"./identity.js":"gC6lG","./uniqBy.js":"1x4J2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1x4J2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setJs = require("./internal/_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var uniqBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(function uniqBy(fn, list) {
    var set = new (0, _setJsDefault.default)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
});
exports.default = uniqBy;

},{"./internal/_Set.js":"6MZh9","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3ocaP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var intersperse = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)("intersperse", function intersperse(separator, list) {
    var out = [];
    var idx = 0;
    var length = list.length;
    while(idx < length){
        if (idx === length - 1) out.push(list[idx]);
        else out.push(list[idx], separator);
        idx += 1;
    }
    return out;
}));
exports.default = intersperse;

},{"./internal/_checkForMethod.js":"kHD0w","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cKaCB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneJs = require("./internal/_clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _isTransformerJs = require("./internal/_isTransformer.js");
var _isTransformerJsDefault = parcelHelpers.interopDefault(_isTransformerJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _stepCatJs = require("./internal/_stepCat.js");
var _stepCatJsDefault = parcelHelpers.interopDefault(_stepCatJs);
/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */ var into = /*#__PURE__*/ (0, _curry3JsDefault.default)(function into(acc, xf, list) {
    return (0, _isTransformerJsDefault.default)(acc) ? (0, _reduceJsDefault.default)(xf(acc), acc["@@transducer/init"](), list) : (0, _reduceJsDefault.default)(xf((0, _stepCatJsDefault.default)(acc)), (0, _cloneJsDefault.default)(acc, [], [], false), list);
});
exports.default = into;

},{"./internal/_clone.js":"bjetO","./internal/_curry3.js":"2gLD0","./internal/_isTransformer.js":"336qj","./internal/_reduce.js":"81EKw","./internal/_stepCat.js":"lLGwM","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lLGwM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_stepCat);
var _objectAssignJs = require("./_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _identityJs = require("./_identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isTransformerJs = require("./_isTransformer.js");
var _isTransformerJsDefault = parcelHelpers.interopDefault(_isTransformerJs);
var _objOfJs = require("../objOf.js");
var _objOfJsDefault = parcelHelpers.interopDefault(_objOfJs);
var _stepCatArray = {
    "@@transducer/init": Array,
    "@@transducer/step": function(xs, x) {
        xs.push(x);
        return xs;
    },
    "@@transducer/result": (0, _identityJsDefault.default)
};
var _stepCatString = {
    "@@transducer/init": String,
    "@@transducer/step": function(a, b) {
        return a + b;
    },
    "@@transducer/result": (0, _identityJsDefault.default)
};
var _stepCatObject = {
    "@@transducer/init": Object,
    "@@transducer/step": function(result, input) {
        return (0, _objectAssignJsDefault.default)(result, (0, _isArrayLikeJsDefault.default)(input) ? (0, _objOfJsDefault.default)(input[0], input[1]) : input);
    },
    "@@transducer/result": (0, _identityJsDefault.default)
};
function _stepCat(obj) {
    if ((0, _isTransformerJsDefault.default)(obj)) return obj;
    if ((0, _isArrayLikeJsDefault.default)(obj)) return _stepCatArray;
    if (typeof obj === "string") return _stepCatString;
    if (typeof obj === "object") return _stepCatObject;
    throw new Error("Cannot create transformer for " + obj);
}

},{"./_objectAssign.js":"dfPJi","./_identity.js":"gz29Y","./_isArrayLike.js":"8KOTs","./_isTransformer.js":"336qj","../objOf.js":"d8yHN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dfPJi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hasJs = require("./_has.js"); // Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
function _objectAssign(target) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, _hasJsDefault.default)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}
exports.default = typeof Object.assign === "function" ? Object.assign : _objectAssign;

},{"./_has.js":"k6FAr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d8yHN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */ var objOf = /*#__PURE__*/ (0, _curry2JsDefault.default)(function objOf(key, val) {
    var obj = {};
    obj[key] = val;
    return obj;
});
exports.default = objOf;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8qpfn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */ var invert = /*#__PURE__*/ (0, _curry1JsDefault.default)(function invert(obj) {
    var props = (0, _keysJsDefault.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        var val = obj[key];
        var list = (0, _hasJsDefault.default)(val, out) ? out[val] : out[val] = [];
        list[list.length] = key;
        idx += 1;
    }
    return out;
});
exports.default = invert;

},{"./internal/_curry1.js":"eEHcl","./internal/_has.js":"k6FAr","./keys.js":"f6WyD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gHUaK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var invertObj = /*#__PURE__*/ (0, _curry1JsDefault.default)(function invertObj(obj) {
    var props = (0, _keysJsDefault.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
exports.default = invertObj;

},{"./internal/_curry1.js":"eEHcl","./keys.js":"f6WyD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bz0c6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of any of the target object's methods to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 *
 *      const dog = {
 *        speak: async () => 'Woof!'
 *      };
 *      const speak = R.invoker(0, 'speak');
 *      speak(dog).then(console.log) //~> 'Woof!'
 *
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var invoker = /*#__PURE__*/ (0, _curry2JsDefault.default)(function invoker(arity, method) {
    return (0, _curryNJsDefault.default)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, _isFunctionJsDefault.default)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, _toStringJsDefault.default)(target) + ' does not have a method named "' + method + '"');
    });
});
exports.default = invoker;

},{"./internal/_curry2.js":"4x4SN","./internal/_isFunction.js":"j5B2J","./curryN.js":"757ou","./toString.js":"7ui8E","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fEFU8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var is = /*#__PURE__*/ (0, _curry2JsDefault.default)(function is(Ctor, val) {
    return val != null && val.constructor === Ctor || val instanceof Ctor;
});
exports.default = is;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dFitx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */ var isEmpty = /*#__PURE__*/ (0, _curry1JsDefault.default)(function isEmpty(x) {
    return x != null && (0, _equalsJsDefault.default)(x, (0, _emptyJsDefault.default)(x));
});
exports.default = isEmpty;

},{"./internal/_curry1.js":"eEHcl","./empty.js":"k7YHl","./equals.js":"lVaDh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lBtlT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var join = /*#__PURE__*/ (0, _invokerJsDefault.default)(1, "join");
exports.default = join;

},{"./invoker.js":"bz0c6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7fJJS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _convergeJs = require("./converge.js");
var _convergeJsDefault = parcelHelpers.interopDefault(_convergeJs);
/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var juxt = /*#__PURE__*/ (0, _curry1JsDefault.default)(function juxt(fns) {
    return (0, _convergeJsDefault.default)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
exports.default = juxt;

},{"./internal/_curry1.js":"eEHcl","./converge.js":"eY55M","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k1Vcr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */ var keysIn = /*#__PURE__*/ (0, _curry1JsDefault.default)(function keysIn(obj) {
    var prop;
    var ks = [];
    for(prop in obj)ks[ks.length] = prop;
    return ks;
});
exports.default = keysIn;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9Jj53":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */ var lastIndexOf = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lastIndexOf(target, xs) {
    if (typeof xs.lastIndexOf === "function" && !(0, _isArrayJsDefault.default)(xs)) return xs.lastIndexOf(target);
    else {
        var idx = xs.length - 1;
        while(idx >= 0){
            if ((0, _equalsJsDefault.default)(xs[idx], target)) return idx;
            idx -= 1;
        }
        return -1;
    }
});
exports.default = lastIndexOf;

},{"./internal/_curry2.js":"4x4SN","./internal/_isArray.js":"a2KsU","./equals.js":"lVaDh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5Jxp9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isNumberJs = require("./internal/_isNumber.js");
var _isNumberJsDefault = parcelHelpers.interopDefault(_isNumberJs);
/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var length = /*#__PURE__*/ (0, _curry1JsDefault.default)(function length(list) {
    return list != null && (0, _isNumberJsDefault.default)(list.length) ? list.length : NaN;
});
exports.default = length;

},{"./internal/_curry1.js":"eEHcl","./internal/_isNumber.js":"dnt2V","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dnt2V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNumber);
function _isNumber(x) {
    return Object.prototype.toString.call(x) === "[object Number]";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"49B96":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var lens = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, _mapJsDefault.default)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
exports.default = lens;

},{"./internal/_curry2.js":"4x4SN","./map.js":"2D7vt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1vwzV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
var _updateJs = require("./update.js");
var _updateJsDefault = parcelHelpers.interopDefault(_updateJs);
/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over, R.nth
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var lensIndex = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lensIndex(n) {
    return (0, _lensJsDefault.default)((0, _nthJsDefault.default)(n), (0, _updateJsDefault.default)(n));
});
exports.default = lensIndex;

},{"./internal/_curry1.js":"eEHcl","./lens.js":"49B96","./nth.js":"ba0ga","./update.js":"is5js","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6hRb5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _assocPathJs = require("./assocPath.js");
var _assocPathJsDefault = parcelHelpers.interopDefault(_assocPathJs);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */ var lensPath = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lensPath(p) {
    return (0, _lensJsDefault.default)((0, _pathJsDefault.default)(p), (0, _assocPathJsDefault.default)(p));
});
exports.default = lensPath;

},{"./internal/_curry1.js":"eEHcl","./assocPath.js":"14UyM","./lens.js":"49B96","./path.js":"bMM1c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1RTn3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _propJs = require("./prop.js");
var _propJsDefault = parcelHelpers.interopDefault(_propJs);
/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var lensProp = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lensProp(k) {
    return (0, _lensJsDefault.default)((0, _propJsDefault.default)(k), (0, _assocJsDefault.default)(k));
});
exports.default = lensProp;

},{"./internal/_curry1.js":"eEHcl","./assoc.js":"6qBlU","./lens.js":"49B96","./prop.js":"bt3mo","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"33ra9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var lt = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lt(a, b) {
    return a < b;
});
exports.default = lt;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9H8Yp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var lte = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lte(a, b) {
    return a <= b;
});
exports.default = lte;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"95mUD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.scan, R.addIndex, R.mapAccumRight
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */ var mapAccum = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mapAccum(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx < len){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx += 1;
    }
    return [
        tuple[0],
        result
    ];
});
exports.default = mapAccum;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cyGBk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [b + a, b + a];
 *
 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   f(f(f(a, d)[0], c)[0], b)[0],
 *   [
 *     f(a, d)[1],
 *     f(f(a, d)[0], c)[1],
 *     f(f(f(a, d)[0], c)[0], b)[1]
 *   ]
 * ]
 */ var mapAccumRight = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mapAccumRight(fn, acc, list) {
    var idx = list.length - 1;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx >= 0){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx -= 1;
    }
    return [
        tuple[0],
        result
    ];
});
exports.default = mapAccumRight;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d6S3N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var mapObjIndexed = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mapObjIndexed(fn, obj) {
    return (0, _reduceJsDefault.default)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, _keysJsDefault.default)(obj));
});
exports.default = mapObjIndexed;

},{"./internal/_curry2.js":"4x4SN","./internal/_reduce.js":"81EKw","./keys.js":"f6WyD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jbA6E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */ var match = /*#__PURE__*/ (0, _curry2JsDefault.default)(function match(rx, str) {
    return str.match(rx) || [];
});
exports.default = match;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"att0i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */ var mathMod = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mathMod(m, p) {
    if (!(0, _isIntegerJsDefault.default)(m)) return NaN;
    if (!(0, _isIntegerJsDefault.default)(p) || p < 1) return NaN;
    return (m % p + p) % p;
});
exports.default = mathMod;

},{"./internal/_curry2.js":"4x4SN","./internal/_isInteger.js":"hayZl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1qgeJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */ var maxBy = /*#__PURE__*/ (0, _curry3JsDefault.default)(function maxBy(f, a, b) {
    return f(b) > f(a) ? b : a;
});
exports.default = maxBy;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5VbDm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */ var mean = /*#__PURE__*/ (0, _curry1JsDefault.default)(function mean(list) {
    return (0, _sumJsDefault.default)(list) / list.length;
});
exports.default = mean;

},{"./internal/_curry1.js":"eEHcl","./sum.js":"dFKgN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dFKgN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var sum = /*#__PURE__*/ (0, _reduceJsDefault.default)((0, _addJsDefault.default), 0);
exports.default = sum;

},{"./add.js":"eK5zq","./reduce.js":"aTmLb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4fbGy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */ var median = /*#__PURE__*/ (0, _curry1JsDefault.default)(function median(list) {
    var len = list.length;
    if (len === 0) return NaN;
    var width = 2 - len % 2;
    var idx = (len - width) / 2;
    return (0, _meanJsDefault.default)(Array.prototype.slice.call(list, 0).sort(function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }).slice(idx, idx + width));
});
exports.default = median;

},{"./internal/_curry1.js":"eEHcl","./mean.js":"5VbDm","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iQLl3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */ var memoizeWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function memoizeWith(mFn, fn) {
    var cache = {};
    return (0, _arityJsDefault.default)(fn.length, function() {
        var key = mFn.apply(this, arguments);
        if (!(0, _hasJsDefault.default)(key, cache)) cache[key] = fn.apply(this, arguments);
        return cache[key];
    });
});
exports.default = memoizeWith;

},{"./internal/_arity.js":"473XR","./internal/_curry2.js":"4x4SN","./internal/_has.js":"k6FAr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"Iw41T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @deprecated since v0.26.0
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.merge({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge(a, b) = {...a, ...b}
 */ var merge = /*#__PURE__*/ (0, _curry2JsDefault.default)(function merge(l, r) {
    return (0, _objectAssignJsDefault.default)({}, l, r);
});
exports.default = merge;

},{"./internal/_objectAssign.js":"dfPJi","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8jcID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */ var mergeAll = /*#__PURE__*/ (0, _curry1JsDefault.default)(function mergeAll(list) {
    return (0, _objectAssignJsDefault.default).apply(null, [
        {}
    ].concat(list));
});
exports.default = mergeAll;

},{"./internal/_objectAssign.js":"dfPJi","./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"emk08":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var mergeDeepLeft = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeDeepLeft(lObj, rObj) {
    return (0, _mergeDeepWithKeyJsDefault.default)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
exports.default = mergeDeepLeft;

},{"./internal/_curry2.js":"4x4SN","./mergeDeepWithKey.js":"hX1mB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hX1mB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _isObjectJs = require("./internal/_isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _mergeWithKeyJs = require("./mergeWithKey.js");
var _mergeWithKeyJsDefault = parcelHelpers.interopDefault(_mergeWithKeyJs);
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var mergeDeepWithKey = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, _mergeWithKeyJsDefault.default)(function(k, lVal, rVal) {
        if ((0, _isObjectJsDefault.default)(lVal) && (0, _isObjectJsDefault.default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
exports.default = mergeDeepWithKey;

},{"./internal/_curry3.js":"2gLD0","./internal/_isObject.js":"bcg1p","./mergeWithKey.js":"68lFR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"68lFR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var mergeWithKey = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    for(k in l)if ((0, _hasJsDefault.default)(k, l)) result[k] = (0, _hasJsDefault.default)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, _hasJsDefault.default)(k, r) && !(0, _hasJsDefault.default)(k, result)) result[k] = r[k];
    return result;
});
exports.default = mergeWithKey;

},{"./internal/_curry3.js":"2gLD0","./internal/_has.js":"k6FAr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6JatN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var mergeDeepRight = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeDeepRight(lObj, rObj) {
    return (0, _mergeDeepWithKeyJsDefault.default)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
exports.default = mergeDeepRight;

},{"./internal/_curry2.js":"4x4SN","./mergeDeepWithKey.js":"hX1mB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eKX20":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var mergeDeepWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, _mergeDeepWithKeyJsDefault.default)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
exports.default = mergeDeepWith;

},{"./internal/_curry3.js":"2gLD0","./mergeDeepWithKey.js":"hX1mB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1ICOX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */ var mergeLeft = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeLeft(l, r) {
    return (0, _objectAssignJsDefault.default)({}, r, l);
});
exports.default = mergeLeft;

},{"./internal/_objectAssign.js":"dfPJi","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iSwIj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */ var mergeRight = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeRight(l, r) {
    return (0, _objectAssignJsDefault.default)({}, l, r);
});
exports.default = mergeRight;

},{"./internal/_objectAssign.js":"dfPJi","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hhpGh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _mergeWithKeyJs = require("./mergeWithKey.js");
var _mergeWithKeyJsDefault = parcelHelpers.interopDefault(_mergeWithKeyJs);
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */ var mergeWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeWith(fn, l, r) {
    return (0, _mergeWithKeyJsDefault.default)(function(_, _l, _r) {
        return fn(_l, _r);
    }, l, r);
});
exports.default = mergeWith;

},{"./internal/_curry3.js":"2gLD0","./mergeWithKey.js":"68lFR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cqzkq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var min = /*#__PURE__*/ (0, _curry2JsDefault.default)(function min(a, b) {
    return b < a ? b : a;
});
exports.default = min;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5rC9Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var minBy = /*#__PURE__*/ (0, _curry3JsDefault.default)(function minBy(f, a, b) {
    return f(b) < f(a) ? b : a;
});
exports.default = minBy;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"82uWH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      const isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */ var modulo = /*#__PURE__*/ (0, _curry2JsDefault.default)(function modulo(a, b) {
    return a % b;
});
exports.default = modulo;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2YUeM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var move = /*#__PURE__*/ (0, _curry3JsDefault.default)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
exports.default = move;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gCYNI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var multiply = /*#__PURE__*/ (0, _curry2JsDefault.default)(function multiply(a, b) {
    return a * b;
});
exports.default = multiply;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3zrTZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */ var negate = /*#__PURE__*/ (0, _curry1JsDefault.default)(function negate(n) {
    return -n;
});
exports.default = negate;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fiB9n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _complementJs = require("./internal/_complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _allJs = require("./all.js");
var _allJsDefault = parcelHelpers.interopDefault(_allJs);
/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 === 1;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */ var none = /*#__PURE__*/ (0, _curry2JsDefault.default)(function none(fn, input) {
    return (0, _allJsDefault.default)((0, _complementJsDefault.default)(fn), input);
});
exports.default = none;

},{"./internal/_complement.js":"6he84","./internal/_curry2.js":"4x4SN","./all.js":"6tXYM","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3YpP6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */ var nthArg = /*#__PURE__*/ (0, _curry1JsDefault.default)(function nthArg(n) {
    var arity = n < 0 ? 1 : n + 1;
    return (0, _curryNJsDefault.default)(arity, function() {
        return (0, _nthJsDefault.default)(n, arguments);
    });
});
exports.default = nthArg;

},{"./internal/_curry1.js":"eEHcl","./curryN.js":"757ou","./nth.js":"ba0ga","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"56qNR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
 * limited to accepting only 2 unary functions. The name o was chosen because
 * of its similarity to the mathematical composition operator ∘.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */ var o = /*#__PURE__*/ (0, _curry3JsDefault.default)(function o(f, g, x) {
    return f(g(x));
});
exports.default = o;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f1aIw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _ofJs = require("./internal/_of.js");
var _ofJsDefault = parcelHelpers.interopDefault(_ofJs);
/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */ var of = /*#__PURE__*/ (0, _curry1JsDefault.default)((0, _ofJsDefault.default));
exports.default = of;

},{"./internal/_curry1.js":"eEHcl","./internal/_of.js":"5cL4U","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5cL4U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_of);
function _of(x) {
    return [
        x
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gRT62":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var omit = /*#__PURE__*/ (0, _curry2JsDefault.default)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
exports.default = omit;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1RhsY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      const addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */ var once = /*#__PURE__*/ (0, _curry1JsDefault.default)(function once(fn) {
    var called = false;
    var result;
    return (0, _arityJsDefault.default)(fn.length, function() {
        if (called) return result;
        called = true;
        result = fn.apply(this, arguments);
        return result;
    });
});
exports.default = once;

},{"./internal/_arity.js":"473XR","./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4cUZV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _assertPromiseJs = require("./internal/_assertPromise.js");
var _assertPromiseJsDefault = parcelHelpers.interopDefault(_assertPromiseJs);
/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.then
 * @example
 *
 *      var failedFetch = (id) => Promise.reject('bad ID');
 *      var useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' })
 *
 *      //recoverFromFailure :: String -> Promise ({firstName, lastName})
 *      var recoverFromFailure = R.pipe(
 *        failedFetch,
 *        R.otherwise(useDefault),
 *        R.then(R.pick(['firstName', 'lastName'])),
 *      );
 *      recoverFromFailure(12345).then(console.log)
 */ var otherwise = /*#__PURE__*/ (0, _curry2JsDefault.default)(function otherwise(f, p) {
    (0, _assertPromiseJsDefault.default)("otherwise", p);
    return p.then(null, f);
});
exports.default = otherwise;

},{"./internal/_curry2.js":"4x4SN","./internal/_assertPromise.js":"jV7sA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jV7sA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertPromise);
var _isFunctionJs = require("./_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _toStringJs = require("./_toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
function _assertPromise(name, p) {
    if (p == null || !(0, _isFunctionJsDefault.default)(p.then)) throw new TypeError("`" + name + "` expected a Promise, received " + (0, _toStringJsDefault.default)(p, []));
}

},{"./_isFunction.js":"j5B2J","./_toString.js":"bdayP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hZ10z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js"); // `Identity` is a functor that holds a single value, where `map` simply
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
// transforms the held value with the provided function.
var Identity = function(x) {
    return {
        value: x,
        map: function(f) {
            return Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var over = /*#__PURE__*/ (0, _curry3JsDefault.default)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return Identity(f(y));
    })(x).value;
});
exports.default = over;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3N1A1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */ var pair = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pair(fst, snd) {
    return [
        fst,
        snd
    ];
});
exports.default = pair;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iktjz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _createPartialApplicatorJs = require("./internal/_createPartialApplicator.js");
var _createPartialApplicatorJsDefault = parcelHelpers.interopDefault(_createPartialApplicatorJs);
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight, R.curry
 * @example
 *
 *      const multiply2 = (a, b) => a * b;
 *      const double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partial(greet, ['Hello']);
 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */ var partial = /*#__PURE__*/ (0, _createPartialApplicatorJsDefault.default)((0, _concatJsDefault.default));
exports.default = partial;

},{"./internal/_concat.js":"8tD7U","./internal/_createPartialApplicator.js":"c1vMg","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c1vMg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createPartialApplicator);
var _arityJs = require("./_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
function _createPartialApplicator(concat) {
    return (0, _curry2JsDefault.default)(function(fn, args) {
        return (0, _arityJsDefault.default)(Math.max(0, fn.length - args.length), function() {
            return fn.apply(this, concat(args, arguments));
        });
    });
}

},{"./_arity.js":"473XR","./_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"25QTT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _createPartialApplicatorJs = require("./internal/_createPartialApplicator.js");
var _createPartialApplicatorJsDefault = parcelHelpers.interopDefault(_createPartialApplicatorJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */ var partialRight = /*#__PURE__*/ (0, _createPartialApplicatorJsDefault.default)(/*#__PURE__*/ (0, _flipJsDefault.default)((0, _concatJsDefault.default)));
exports.default = partialRight;

},{"./internal/_concat.js":"8tD7U","./internal/_createPartialApplicator.js":"c1vMg","./flip.js":"dG058","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dmVbs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _juxtJs = require("./juxt.js");
var _juxtJsDefault = parcelHelpers.interopDefault(_juxtJs);
var _rejectJs = require("./reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var partition = /*#__PURE__*/ (0, _juxtJsDefault.default)([
    (0, _filterJsDefault.default),
    (0, _rejectJsDefault.default)
]);
exports.default = partition;

},{"./filter.js":"4D8wM","./juxt.js":"7fJJS","./reject.js":"frSvm","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d8EtI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var pathEq = /*#__PURE__*/ (0, _curry3JsDefault.default)(function pathEq(_path, val, obj) {
    return (0, _equalsJsDefault.default)((0, _pathJsDefault.default)(_path, obj), val);
});
exports.default = pathEq;

},{"./internal/_curry3.js":"2gLD0","./equals.js":"lVaDh","./path.js":"bMM1c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"97HB8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _defaultToJs = require("./defaultTo.js");
var _defaultToJsDefault = parcelHelpers.interopDefault(_defaultToJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var pathOr = /*#__PURE__*/ (0, _curry3JsDefault.default)(function pathOr(d, p, obj) {
    return (0, _defaultToJsDefault.default)(d, (0, _pathJsDefault.default)(p, obj));
});
exports.default = pathOr;

},{"./internal/_curry3.js":"2gLD0","./defaultTo.js":"4Ad0O","./path.js":"bMM1c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"84De7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 *      R.pathSatisfies(R.is(Object), [], {x: {y: 2}}); //=> true
 */ var pathSatisfies = /*#__PURE__*/ (0, _curry3JsDefault.default)(function pathSatisfies(pred, propPath, obj) {
    return pred((0, _pathJsDefault.default)(propPath, obj));
});
exports.default = pathSatisfies;

},{"./internal/_curry3.js":"2gLD0","./path.js":"bMM1c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"79ZOt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var pick = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
exports.default = pick;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aQDpI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */ var pickAll = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        var name = names[idx];
        result[name] = obj[name];
        idx += 1;
    }
    return result;
});
exports.default = pickAll;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"SBsGw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var pickBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
exports.default = pickBy;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bLEqU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pipeK);
var _composeKJs = require("./composeK.js");
var _composeKJsDefault = parcelHelpers.interopDefault(_composeKJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
function pipeK() {
    if (arguments.length === 0) throw new Error("pipeK requires at least one argument");
    return (0, _composeKJsDefault.default).apply(this, (0, _reverseJsDefault.default)(arguments));
}

},{"./composeK.js":"9Xpvs","./reverse.js":"2h77c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7Fq9r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */ var prepend = /*#__PURE__*/ (0, _curry2JsDefault.default)(function prepend(el, list) {
    return (0, _concatJsDefault.default)([
        el
    ], list);
});
exports.default = prepend;

},{"./internal/_concat.js":"8tD7U","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gEFo4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _multiplyJs = require("./multiply.js");
var _multiplyJsDefault = parcelHelpers.interopDefault(_multiplyJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */ var product = /*#__PURE__*/ (0, _reduceJsDefault.default)((0, _multiplyJsDefault.default), 1);
exports.default = product;

},{"./multiply.js":"gCYNI","./reduce.js":"aTmLb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"i6Cxy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapJs = require("./internal/_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _pickAllJs = require("./pickAll.js");
var _pickAllJsDefault = parcelHelpers.interopDefault(_pickAllJs);
var _useWithJs = require("./useWith.js");
var _useWithJsDefault = parcelHelpers.interopDefault(_useWithJs);
/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */ var project = /*#__PURE__*/ (0, _useWithJsDefault.default)((0, _mapJsDefault.default), [
    (0, _pickAllJsDefault.default),
    (0, _identityJsDefault.default)
]); // passing `identity` gives correct arity
exports.default = project;

},{"./internal/_map.js":"aibsD","./identity.js":"gC6lG","./pickAll.js":"aQDpI","./useWith.js":"22342","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"22342":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */ var useWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function useWith(fn, transformers) {
    return (0, _curryNJsDefault.default)(transformers.length, function() {
        var args = [];
        var idx = 0;
        while(idx < transformers.length){
            args.push(transformers[idx].call(this, arguments[idx]));
            idx += 1;
        }
        return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
    });
});
exports.default = useWith;

},{"./internal/_curry2.js":"4x4SN","./curryN.js":"757ou","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"uJnZv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var propEq = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propEq(name, val, obj) {
    return (0, _equalsJsDefault.default)(val, obj[name]);
});
exports.default = propEq;

},{"./internal/_curry3.js":"2gLD0","./equals.js":"lVaDh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g4mxI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _isJs = require("./is.js");
var _isJsDefault = parcelHelpers.interopDefault(_isJs);
/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */ var propIs = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propIs(type, name, obj) {
    return (0, _isJsDefault.default)(type, obj[name]);
});
exports.default = propIs;

},{"./internal/_curry3.js":"2gLD0","./is.js":"fEFU8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"35XHx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _pathOrJs = require("./pathOr.js");
var _pathOrJsDefault = parcelHelpers.interopDefault(_pathOrJs);
/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var propOr = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propOr(val, p, obj) {
    return (0, _pathOrJsDefault.default)(val, [
        p
    ], obj);
});
exports.default = propOr;

},{"./internal/_curry3.js":"2gLD0","./pathOr.js":"97HB8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dwURq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */ var propSatisfies = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propSatisfies(pred, name, obj) {
    return pred(obj[name]);
});
exports.default = propSatisfies;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gpgqt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var props = /*#__PURE__*/ (0, _curry2JsDefault.default)(function props(ps, obj) {
    return ps.map(function(p) {
        return (0, _pathJsDefault.default)([
            p
        ], obj);
    });
});
exports.default = props;

},{"./internal/_curry2.js":"4x4SN","./path.js":"bMM1c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"85gum":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isNumberJs = require("./internal/_isNumber.js");
var _isNumberJsDefault = parcelHelpers.interopDefault(_isNumberJs);
/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var range = /*#__PURE__*/ (0, _curry2JsDefault.default)(function range(from, to) {
    if (!((0, _isNumberJsDefault.default)(from) && (0, _isNumberJsDefault.default)(to))) throw new TypeError("Both arguments to range must be numbers");
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
exports.default = range;

},{"./internal/_curry2.js":"4x4SN","./internal/_isNumber.js":"dnt2V","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"90z19":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */ var reduceRight = /*#__PURE__*/ (0, _curry3JsDefault.default)(function reduceRight(fn, acc, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        acc = fn(list[idx], acc);
        idx -= 1;
    }
    return acc;
});
exports.default = reduceRight;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hpc52":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./internal/_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reducedJs = require("./internal/_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 === 1;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */ var reduceWhile = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, [], function _reduceWhile(pred, fn, a, list) {
    return (0, _reduceJsDefault.default)(function(acc, x) {
        return pred(acc, x) ? fn(acc, x) : (0, _reducedJsDefault.default)(acc);
    }, a, list);
});
exports.default = reduceWhile;

},{"./internal/_curryN.js":"i0t26","./internal/_reduce.js":"81EKw","./internal/_reduced.js":"g5Cqb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2wG2H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _reducedJs = require("./internal/_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is only available to the below functions:
 * - [`reduce`](#reduce)
 * - [`reduceWhile`](#reduceWhile)
 * - [`transduce`](#transduce)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.reduceWhile, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */ var reduced = /*#__PURE__*/ (0, _curry1JsDefault.default)((0, _reducedJsDefault.default));
exports.default = reduced;

},{"./internal/_curry1.js":"eEHcl","./internal/_reduced.js":"g5Cqb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1AaST":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
var _timesJs = require("./times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var repeat = /*#__PURE__*/ (0, _curry2JsDefault.default)(function repeat(value, n) {
    return (0, _timesJsDefault.default)((0, _alwaysJsDefault.default)(value), n);
});
exports.default = repeat;

},{"./internal/_curry2.js":"4x4SN","./always.js":"ilsuC","./times.js":"fUiWH","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fUiWH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var times = /*#__PURE__*/ (0, _curry2JsDefault.default)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError("n must be a non-negative number");
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
exports.default = times;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jxPzh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var replace = /*#__PURE__*/ (0, _curry3JsDefault.default)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
exports.default = replace;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ktdXN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce, R.mapAccum
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */ var scan = /*#__PURE__*/ (0, _curry3JsDefault.default)(function scan(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [
        acc
    ];
    while(idx < len){
        acc = fn(acc, list[idx]);
        result[idx + 1] = acc;
        idx += 1;
    }
    return result;
});
exports.default = scan;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3T3YF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _apJs = require("./ap.js");
var _apJsDefault = parcelHelpers.interopDefault(_apJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _prependJs = require("./prepend.js");
var _prependJsDefault = parcelHelpers.interopDefault(_prependJs);
var _reduceRightJs = require("./reduceRight.js");
var _reduceRightJsDefault = parcelHelpers.interopDefault(_reduceRightJs);
/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */ var sequence = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sequence(of, traversable) {
    return typeof traversable.sequence === "function" ? traversable.sequence(of) : (0, _reduceRightJsDefault.default)(function(x, acc) {
        return (0, _apJsDefault.default)((0, _mapJsDefault.default)((0, _prependJsDefault.default), x), acc);
    }, of([]), traversable);
});
exports.default = sequence;

},{"./internal/_curry2.js":"4x4SN","./ap.js":"k2b5D","./map.js":"2D7vt","./prepend.js":"7Fq9r","./reduceRight.js":"90z19","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1MotT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
var _overJs = require("./over.js");
var _overJsDefault = parcelHelpers.interopDefault(_overJs);
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */ var set = /*#__PURE__*/ (0, _curry3JsDefault.default)(function set(lens, v, x) {
    return (0, _overJsDefault.default)(lens, (0, _alwaysJsDefault.default)(v), x);
});
exports.default = set;

},{"./internal/_curry3.js":"2gLD0","./always.js":"ilsuC","./over.js":"hZ10z","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jSbOu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var sort = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
exports.default = sort;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8Fdcb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var sortBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
exports.default = sortBy;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jD4cx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var sortWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
exports.default = sortWith;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6rRC1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `sep`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var split = /*#__PURE__*/ (0, _invokerJsDefault.default)(1, "split");
exports.default = split;

},{"./invoker.js":"bz0c6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cXihd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */ var splitAt = /*#__PURE__*/ (0, _curry2JsDefault.default)(function splitAt(index, array) {
    return [
        (0, _sliceJsDefault.default)(0, index, array),
        (0, _sliceJsDefault.default)(index, (0, _lengthJsDefault.default)(array), array)
    ];
});
exports.default = splitAt;

},{"./internal/_curry2.js":"4x4SN","./length.js":"5Jxp9","./slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"idWWa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */ var splitEvery = /*#__PURE__*/ (0, _curry2JsDefault.default)(function splitEvery(n, list) {
    if (n <= 0) throw new Error("First argument to splitEvery must be a positive integer");
    var result = [];
    var idx = 0;
    while(idx < list.length)result.push((0, _sliceJsDefault.default)(idx, idx += n, list));
    return result;
});
exports.default = splitEvery;

},{"./internal/_curry2.js":"4x4SN","./slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"frrTI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */ var splitWhen = /*#__PURE__*/ (0, _curry2JsDefault.default)(function splitWhen(pred, list) {
    var idx = 0;
    var len = list.length;
    var prefix = [];
    while(idx < len && !pred(list[idx])){
        prefix.push(list[idx]);
        idx += 1;
    }
    return [
        prefix,
        Array.prototype.slice.call(list, idx)
    ];
});
exports.default = splitWhen;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kDsOF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _takeJs = require("./take.js");
var _takeJsDefault = parcelHelpers.interopDefault(_takeJs);
/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var startsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(prefix, list) {
    return (0, _equalsJsDefault.default)((0, _takeJsDefault.default)(prefix.length, list), prefix);
});
exports.default = startsWith;

},{"./internal/_curry2.js":"4x4SN","./equals.js":"lVaDh","./take.js":"nrooI","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lozDD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var subtract = /*#__PURE__*/ (0, _curry2JsDefault.default)(function subtract(a, b) {
    return Number(a) - Number(b);
});
exports.default = subtract;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6DQ1f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _concatJs = require("./concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var symmetricDifference = /*#__PURE__*/ (0, _curry2JsDefault.default)(function symmetricDifference(list1, list2) {
    return (0, _concatJsDefault.default)((0, _differenceJsDefault.default)(list1, list2), (0, _differenceJsDefault.default)(list2, list1));
});
exports.default = symmetricDifference;

},{"./internal/_curry2.js":"4x4SN","./concat.js":"giSF9","./difference.js":"lJWRb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fWyNV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _concatJs = require("./concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _differenceWithJs = require("./differenceWith.js");
var _differenceWithJsDefault = parcelHelpers.interopDefault(_differenceWithJs);
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */ var symmetricDifferenceWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function symmetricDifferenceWith(pred, list1, list2) {
    return (0, _concatJsDefault.default)((0, _differenceWithJsDefault.default)(pred, list1, list2), (0, _differenceWithJsDefault.default)(pred, list2, list1));
});
exports.default = symmetricDifferenceWith;

},{"./internal/_curry3.js":"2gLD0","./concat.js":"giSF9","./differenceWith.js":"hkTEI","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gFbl1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */ var takeLastWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function takeLastWhile(fn, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && fn(xs[idx]))idx -= 1;
    return (0, _sliceJsDefault.default)(idx + 1, Infinity, xs);
});
exports.default = takeLastWhile;

},{"./internal/_curry2.js":"4x4SN","./slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7dAd1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xtakeWhileJs = require("./internal/_xtakeWhile.js");
var _xtakeWhileJsDefault = parcelHelpers.interopDefault(_xtakeWhileJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var takeWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    "takeWhile"
], (0, _xtakeWhileJsDefault.default), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, _sliceJsDefault.default)(0, idx, xs);
}));
exports.default = takeWhile;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xtakeWhile.js":"dZRs2","./slice.js":"4Vv0F","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dZRs2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XTakeWhile.prototype["@@transducer/result"] = (0, _xfBaseJsDefault.default).result;
    XTakeWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : (0, _reducedJsDefault.default)(result);
    };
    return XTakeWhile;
}();
var _xtakeWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xtakeWhile(f, xf) {
    return new XTakeWhile(f, xf);
});
exports.default = _xtakeWhile;

},{"./_curry2.js":"4x4SN","./_reduced.js":"g5Cqb","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"02scP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xtapJs = require("./internal/_xtap.js");
var _xtapJsDefault = parcelHelpers.interopDefault(_xtapJs);
/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */ var tap = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xtapJsDefault.default), function tap(fn, x) {
    fn(x);
    return x;
}));
exports.default = tap;

},{"./internal/_curry2.js":"4x4SN","./internal/_dispatchable.js":"c9mel","./internal/_xtap.js":"ggGYP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ggGYP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype["@@transducer/init"] = (0, _xfBaseJsDefault.default).init;
    XTap.prototype["@@transducer/result"] = (0, _xfBaseJsDefault.default).result;
    XTap.prototype["@@transducer/step"] = function(result, input) {
        this.f(input);
        return this.xf["@@transducer/step"](result, input);
    };
    return XTap;
}();
var _xtap = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xtap(f, xf) {
    return new XTap(f, xf);
});
exports.default = _xtap;

},{"./_curry2.js":"4x4SN","./_xfBase.js":"gdV4K","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k0ozT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneRegExpJs = require("./internal/_cloneRegExp.js");
var _cloneRegExpJsDefault = parcelHelpers.interopDefault(_cloneRegExpJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isRegExpJs = require("./internal/_isRegExp.js");
var _isRegExpJsDefault = parcelHelpers.interopDefault(_isRegExpJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var test = /*#__PURE__*/ (0, _curry2JsDefault.default)(function test(pattern, str) {
    if (!(0, _isRegExpJsDefault.default)(pattern)) throw new TypeError("\u2018test\u2019 requires a value of type RegExp as its first argument; received " + (0, _toStringJsDefault.default)(pattern));
    return (0, _cloneRegExpJsDefault.default)(pattern).test(str);
});
exports.default = test;

},{"./internal/_cloneRegExp.js":"29A6W","./internal/_curry2.js":"4x4SN","./internal/_isRegExp.js":"lTB3M","./toString.js":"7ui8E","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lTB3M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isRegExp);
function _isRegExp(x) {
    return Object.prototype.toString.call(x) === "[object RegExp]";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iSHPG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _assertPromiseJs = require("./internal/_assertPromise.js");
var _assertPromiseJsDefault = parcelHelpers.interopDefault(_assertPromiseJs);
/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      var makeQuery = (email) => ({ query: { email }});
 *
 *      //getMemberName :: String -> Promise ({firstName, lastName})
 *      var getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.andThen(R.pick(['firstName', 'lastName']))
 *      );
 */ var andThen = /*#__PURE__*/ (0, _curry2JsDefault.default)(function andThen(f, p) {
    (0, _assertPromiseJsDefault.default)("andThen", p);
    return p.then(f);
});
exports.default = andThen;

},{"./internal/_curry2.js":"4x4SN","./internal/_assertPromise.js":"jV7sA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hkx6o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var toLower = /*#__PURE__*/ (0, _invokerJsDefault.default)(0, "toLowerCase");
exports.default = toLower;

},{"./invoker.js":"bz0c6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8A4Cj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var toPairs = /*#__PURE__*/ (0, _curry1JsDefault.default)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, _hasJsDefault.default)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
exports.default = toPairs;

},{"./internal/_curry1.js":"eEHcl","./internal/_has.js":"k6FAr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dY2Pl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */ var toPairsIn = /*#__PURE__*/ (0, _curry1JsDefault.default)(function toPairsIn(obj) {
    var pairs = [];
    for(var prop in obj)pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
exports.default = toPairsIn;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k5Xx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var toUpper = /*#__PURE__*/ (0, _invokerJsDefault.default)(0, "toUpperCase");
exports.default = toUpper;

},{"./invoker.js":"bz0c6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3gJLt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xwrapJs = require("./internal/_xwrap.js");
var _xwrapJsDefault = parcelHelpers.interopDefault(_xwrapJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 === 1;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */ var transduce = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, function transduce(xf, fn, acc, list) {
    return (0, _reduceJsDefault.default)(xf(typeof fn === "function" ? (0, _xwrapJsDefault.default)(fn) : fn), acc, list);
});
exports.default = transduce;

},{"./internal/_reduce.js":"81EKw","./internal/_xwrap.js":"cG2gX","./curryN.js":"757ou","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"flvoj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */ var transpose = /*#__PURE__*/ (0, _curry1JsDefault.default)(function transpose(outerlist) {
    var i = 0;
    var result = [];
    while(i < outerlist.length){
        var innerlist = outerlist[i];
        var j = 0;
        while(j < innerlist.length){
            if (typeof result[j] === "undefined") result[j] = [];
            result[j].push(innerlist[j]);
            j += 1;
        }
        i += 1;
    }
    return result;
});
exports.default = transpose;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gEVor":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _sequenceJs = require("./sequence.js");
var _sequenceJsDefault = parcelHelpers.interopDefault(_sequenceJs);
/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 */ var traverse = /*#__PURE__*/ (0, _curry3JsDefault.default)(function traverse(of, f, traversable) {
    return typeof traversable["fantasy-land/traverse"] === "function" ? traversable["fantasy-land/traverse"](f, of) : (0, _sequenceJsDefault.default)(of, (0, _mapJsDefault.default)(f, traversable));
});
exports.default = traverse;

},{"./internal/_curry3.js":"2gLD0","./map.js":"2D7vt","./sequence.js":"3T3YF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6eTuy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var ws = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var zeroWidth = "\u200B";
var hasProtoTrim = typeof String.prototype.trim === "function";
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var trim = !hasProtoTrim || /*#__PURE__*/ ws.trim() || !/*#__PURE__*/ zeroWidth.trim() ? /*#__PURE__*/ (0, _curry1JsDefault.default)(function trim(str) {
    var beginRx = new RegExp("^[" + ws + "][" + ws + "]*");
    var endRx = new RegExp("[" + ws + "][" + ws + "]*$");
    return str.replace(beginRx, "").replace(endRx, "");
}) : /*#__PURE__*/ (0, _curry1JsDefault.default)(function trim(str) {
    return str.trim();
});
exports.default = trim;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dum8U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(() => { throw 'foo'}, R.always('catched'))('bar') // => 'catched'
 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
 *      R.tryCatch(() => { throw 'this is not a valid value'}, (err, value)=>({error : err,  value }))('bar') // => {'error': 'this is not a valid value', 'value': 'bar'}
 */ var tryCatch = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _tryCatch(tryer, catcher) {
    return (0, _arityJsDefault.default)(tryer.length, function() {
        try {
            return tryer.apply(this, arguments);
        } catch (e) {
            return catcher.apply(this, (0, _concatJsDefault.default)([
                e
            ], arguments));
        }
    });
});
exports.default = tryCatch;

},{"./internal/_arity.js":"473XR","./internal/_concat.js":"8tD7U","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eY57o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */ var unapply = /*#__PURE__*/ (0, _curry1JsDefault.default)(function unapply(fn) {
    return function() {
        return fn(Array.prototype.slice.call(arguments, 0));
    };
});
exports.default = unapply;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3eC5X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      const takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */ var unary = /*#__PURE__*/ (0, _curry1JsDefault.default)(function unary(fn) {
    return (0, _nAryJsDefault.default)(1, fn);
});
exports.default = unary;

},{"./internal/_curry1.js":"eEHcl","./nAry.js":"2DwrZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1zsmv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      const addFour = a => b => c => d => a + b + c + d;
 *
 *      const uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */ var uncurryN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function uncurryN(depth, fn) {
    return (0, _curryNJsDefault.default)(depth, function() {
        var currentDepth = 1;
        var value = fn;
        var idx = 0;
        var endIdx;
        while(currentDepth <= depth && typeof value === "function"){
            endIdx = currentDepth === depth ? arguments.length : idx + value.length;
            value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
            currentDepth += 1;
            idx = endIdx;
        }
        return value;
    });
});
exports.default = uncurryN;

},{"./internal/_curry2.js":"4x4SN","./curryN.js":"757ou","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"i1XIB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      const f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */ var unfold = /*#__PURE__*/ (0, _curry2JsDefault.default)(function unfold(fn, seed) {
    var pair = fn(seed);
    var result = [];
    while(pair && pair.length){
        result[result.length] = pair[0];
        pair = fn(pair[1]);
    }
    return result;
});
exports.default = unfold;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1bwjt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _uniqJs = require("./uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var union = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _composeJsDefault.default)((0, _uniqJsDefault.default), (0, _concatJsDefault.default)));
exports.default = union;

},{"./internal/_concat.js":"8tD7U","./internal/_curry2.js":"4x4SN","./compose.js":"3d9gX","./uniq.js":"3p6a8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fsTe6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _uniqWithJs = require("./uniqWith.js");
var _uniqWithJsDefault = parcelHelpers.interopDefault(_uniqWithJs);
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */ var unionWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function unionWith(pred, list1, list2) {
    return (0, _uniqWithJsDefault.default)(pred, (0, _concatJsDefault.default)(list1, list2));
});
exports.default = unionWith;

},{"./internal/_concat.js":"8tD7U","./internal/_curry3.js":"2gLD0","./uniqWith.js":"iXZUi","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iXZUi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesWithJs = require("./internal/_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */ var uniqWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function uniqWith(pred, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var item;
    while(idx < len){
        item = list[idx];
        if (!(0, _includesWithJsDefault.default)(pred, item, result)) result[result.length] = item;
        idx += 1;
    }
    return result;
});
exports.default = uniqWith;

},{"./internal/_includesWith.js":"guGfi","./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"i2VxU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when, R.cond
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */ var unless = /*#__PURE__*/ (0, _curry3JsDefault.default)(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
});
exports.default = unless;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"i7Dv4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./internal/_identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _chainJs = require("./chain.js");
var _chainJsDefault = parcelHelpers.interopDefault(_chainJs);
/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var unnest = /*#__PURE__*/ (0, _chainJsDefault.default)((0, _identityJsDefault.default));
exports.default = unnest;

},{"./internal/_identity.js":"gz29Y","./chain.js":"8spep","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l7qCz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */ var until = /*#__PURE__*/ (0, _curry3JsDefault.default)(function until(pred, fn, init) {
    var val = init;
    while(!pred(val))val = fn(val);
    return val;
});
exports.default = until;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"26EfK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var valuesIn = /*#__PURE__*/ (0, _curry1JsDefault.default)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
exports.default = valuesIn;

},{"./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ge4NW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js"); // `Const` is a functor that effectively ignores the function given to `map`.
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var Const = function(x) {
    return {
        value: x,
        "fantasy-land/map": function() {
            return this;
        }
    };
};
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */ var view = /*#__PURE__*/ (0, _curry2JsDefault.default)(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens(Const)(x).value;
});
exports.default = view;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l7Pa4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var when = /*#__PURE__*/ (0, _curry3JsDefault.default)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
exports.default = when;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ir5oI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */ var where = /*#__PURE__*/ (0, _curry2JsDefault.default)(function where(spec, testObj) {
    for(var prop in spec){
        if ((0, _hasJsDefault.default)(prop, spec) && !spec[prop](testObj[prop])) return false;
    }
    return true;
});
exports.default = where;

},{"./internal/_curry2.js":"4x4SN","./internal/_has.js":"k6FAr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aGCyE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _whereJs = require("./where.js");
var _whereJsDefault = parcelHelpers.interopDefault(_whereJs);
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */ var whereEq = /*#__PURE__*/ (0, _curry2JsDefault.default)(function whereEq(spec, testObj) {
    return (0, _whereJsDefault.default)((0, _mapJsDefault.default)((0, _equalsJsDefault.default), spec), testObj);
});
exports.default = whereEq;

},{"./internal/_curry2.js":"4x4SN","./equals.js":"lVaDh","./map.js":"2D7vt","./where.js":"ir5oI","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gIaSk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _rejectJs = require("./reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var without = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(xs, list) {
    return (0, _rejectJsDefault.default)((0, _flipJsDefault.default)((0, _includesJsDefault.default))(xs), list);
});
exports.default = without;

},{"./internal/_includes.js":"6lW2G","./internal/_curry2.js":"4x4SN","./flip.js":"dG058","./reject.js":"frSvm","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g2387":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Exclusive disjunction logical operation.
 * Returns `true` if one of the arguments is truthy and the other is falsy.
 * Otherwise, it returns `false`.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Logic
 * @sig a -> b -> Boolean
 * @param {Any} a
 * @param {Any} b
 * @return {Boolean} true if one of the arguments is truthy and the other is falsy
 * @see R.or, R.and
 * @example
 *
 *      R.xor(true, true); //=> false
 *      R.xor(true, false); //=> true
 *      R.xor(false, true); //=> true
 *      R.xor(false, false); //=> false
 */ var xor = /*#__PURE__*/ (0, _curry2JsDefault.default)(function xor(a, b) {
    return Boolean(!a ^ !b);
});
exports.default = xor;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1k1AO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */ var xprod = /*#__PURE__*/ (0, _curry2JsDefault.default)(function xprod(a, b) {
    // = xprodWith(prepend); (takes about 3 times as long...)
    var idx = 0;
    var ilen = a.length;
    var j;
    var jlen = b.length;
    var result = [];
    while(idx < ilen){
        j = 0;
        while(j < jlen){
            result[result.length] = [
                a[idx],
                b[j]
            ];
            j += 1;
        }
        idx += 1;
    }
    return result;
});
exports.default = xprod;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c0Dd6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */ var zip = /*#__PURE__*/ (0, _curry2JsDefault.default)(function zip(a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = [
            a[idx],
            b[idx]
        ];
        idx += 1;
    }
    return rv;
});
exports.default = zip;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9XoUe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */ var zipObj = /*#__PURE__*/ (0, _curry2JsDefault.default)(function zipObj(keys, values) {
    var idx = 0;
    var len = Math.min(keys.length, values.length);
    var out = {};
    while(idx < len){
        out[keys[idx]] = values[idx];
        idx += 1;
    }
    return out;
});
exports.default = zipObj;

},{"./internal/_curry2.js":"4x4SN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7bym0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      const f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */ var zipWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function zipWith(fn, a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = fn(a[idx], b[idx]);
        idx += 1;
    }
    return rv;
});
exports.default = zipWith;

},{"./internal/_curry3.js":"2gLD0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4OUUh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Creates a thunk out of a function. A thunk delays a calculation until
 * its result is needed, providing lazy evaluation of arguments.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
 * @param {Function} fn A function to wrap in a thunk
 * @return {Function} Expects arguments for `fn` and returns a new function
 *  that, when called, applies those arguments to `fn`.
 * @see R.partial, R.partialRight
 * @example
 *
 *      R.thunkify(R.identity)(42)(); //=> 42
 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
 */ var thunkify = /*#__PURE__*/ (0, _curry1JsDefault.default)(function thunkify(fn) {
    return (0, _curryNJsDefault.default)(fn.length, function createThunk() {
        var fnArgs = arguments;
        return function invokeThunk() {
            return fn.apply(this, fnArgs);
        };
    });
});
exports.default = thunkify;

},{"./curryN.js":"757ou","./internal/_curry1.js":"eEHcl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hNarb":[function(require,module,exports) {
/**
 * React Router DOM v6.7.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "RouterProvider", ()=>(0, _reactRouter.RouterProvider));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_enhanceManualRouteObjects", ()=>(0, _reactRouter.UNSAFE_enhanceManualRouteObjects));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "unstable_useBlocker", ()=>(0, _reactRouter.unstable_useBlocker));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
var _react = require("react");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
        searchParams.append(key, value);
    });
    return searchParams;
}
function getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if (isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol, host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url,
        method: method.toLowerCase(),
        encType,
        formData
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], _excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
//#region Routers
////////////////////////////////////////////////////////////////////////////////
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: (0, _reactRouter.UNSAFE_enhanceManualRouteObjects)(routes)
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: (0, _reactRouter.UNSAFE_enhanceManualRouteObjects)(routes)
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref) {
    let { basename, children, window: window1 } = _ref;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = _react.useState({
        action: history.action,
        location: history.location
    });
    _react.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref2) {
    let { basename, children, window: window1 } = _ref2;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = _react.useState({
        action: history.action,
        location: history.location
    });
    _react.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref3) {
    let { basename, children, history } = _ref3;
    const [state, setState] = _react.useState({
        action: history.action,
        location: history.location
    });
    _react.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * The public API for rendering a history-aware <a>.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset } = _ref4, rest = _objectWithoutPropertiesLoose(_ref4, _excluded);
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: href,
        onClick: reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, children } = _ref5, rest = _objectWithoutPropertiesLoose(_ref5, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive,
        isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive,
        isPending
    }) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive,
        isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    return /*#__PURE__*/ _react.createElement(FormImpl, _extends({}, props, {
        ref: ref
    }));
});
const FormImpl = /*#__PURE__*/ _react.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument, replace, method = defaultMethod, action, onSubmit, fetcherKey, routeId, relative, preventScrollReset } = _ref6, props = _objectWithoutPropertiesLoose(_ref6, _excluded3);
    let submit = useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = useFormAction(action, {
        relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace,
            relative,
            preventScrollReset
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref7) {
    let { getKey, storageKey } = _ref7;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>getSearchParamsForLocation(location.search, defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    return useSubmitImpl();
}
function useSubmitImpl(fetcherKey, routeId) {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmitImpl);
    let defaultAction = useFormAction();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method, encType, formData, url } = getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            preventScrollReset: options.preventScrollReset,
            formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, _router.invariant)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.invariant)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
function createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
        return /*#__PURE__*/ _react.createElement(FormImpl, _extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher() {
    var _route$matches;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !route && (0, _router.invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, _router.invariant)(false);
    let [fetcherKey] = _react.useState(()=>String(++fetcherId));
    let [Form] = _react.useState(()=>{
        !routeId && (0, _router.invariant)(false);
        return createFetcherForm(fetcherKey, routeId);
    });
    let [load] = _react.useState(()=>(href)=>{
            !router && (0, _router.invariant)(false);
            !routeId && (0, _router.invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form,
            submit,
            load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    _react.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp3) {
    let { getKey, storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)(); // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on unload
    useBeforeUnload(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref8) {
    let { when, message } = _ref8;
    let blocker = (0, _reactRouter.unstable_useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}
////////////////////////////////////////////////////////////////////////////////
//#region Utils
////////////////////////////////////////////////////////////////////////////////
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} //#endregion

},{"react":"d8NEQ","react-router":"dhKrz","@remix-run/router":"8cjRs","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dhKrz":[function(require,module,exports) {
/**
 * React Router v6.7.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_enhanceManualRouteObjects", ()=>enhanceManualRouteObjects);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "unstable_useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _router = require("@remix-run/router");
var _react = require("react");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const is = typeof Object.is === "function" ? Object.is : isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState, useEffect, useLayoutEffect, useDebugValue } = _react;
let didWarnOld18Alpha = false;
let didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst }, forceUpdate] = useState({
        inst: {
            value,
            getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const isServerEnvironment = !canUseDOM;
const shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore$2;
const useSyncExternalStore = "useSyncExternalStore" in _react ? ((module)=>module.useSyncExternalStore)(_react) : shim;
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: []
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function useNavigate() {
    !useInRouterContext() && (0, _router.invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = _react.useRef(false);
    _react.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    !useInRouterContext() && (0, _router.invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let dataRouterStateContext = _react.useContext(DataRouterStateContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorElement() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unhandled Thrown Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, /*#__PURE__*/ _react.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ _react.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own\xa0", /*#__PURE__*/ _react.createElement("code", {
        style: codeStyles
    }, "errorElement"), " props on\xa0", /*#__PURE__*/ _react.createElement("code", {
        style: codeStyles
    }, "<Route>")));
}
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && match.route.errorElement) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, _router.invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = dataRouterState ? match.route.errorElement || /*#__PURE__*/ _react.createElement(DefaultErrorElement, null) : null;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>/*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches
                }
            }, error ? errorElement : match.route.element !== undefined ? match.route.element : outlet); // Only wrap in an error boundary within data router usages when we have an
        // errorElement on this route.  Otherwise let it bubble up to an ancestor
        // errorElement
        return dataRouterState && (match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})(DataRouterStateHook || (DataRouterStateHook = {}));
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.invariant)(false);
    return route;
}
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((match)=>{
            let { pathname, params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname,
                params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let route = _react.useContext(RouteContext);
    !route && (0, _router.invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
} // useBlocker() is a singleton for now since we don't have any compelling use
// cases for multi-blocker yet
let blockerKey = "blocker-singleton";
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router } = useDataRouterContext(DataRouterHook.UseBlocker);
    let blockerFunction = _react.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    _react.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router
    ]);
    return blocker;
}
const alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router } = _ref;
    // Sync router state to our component state to force re-renders
    let state = useSyncExternalStore(router.subscribe, ()=>router.state, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    ()=>router.state);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/"; // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: {
            router,
            navigator,
            static: false,
            // Do we need this?
            basename
        }
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ _react.createElement(Routes, null) : fallbackElement))), null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function MemoryRouter(_ref2) {
    let { basename, children, initialEntries, initialIndex } = _ref2;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = _react.useState({
        action: history.action,
        location: history.location
    });
    _react.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function Navigate(_ref3) {
    let { to, replace, state, relative } = _ref3;
    !useInRouterContext() && (0, _router.invariant)(false);
    let dataRouterState = _react.useContext(DataRouterStateContext);
    let navigate = useNavigate();
    _react.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace,
            state,
            relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function Route(_props) {
    (0, _router.invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function Router(_ref4) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false } = _ref4;
    !!useInRouterContext() && (0, _router.invariant)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let location = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search,
            hash,
            state,
            key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: {
            location,
            navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function Routes(_ref5) {
    let { children, location } = _ref5;
    let dataRouterContext = _react.useContext(DataRouterContext); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : createRoutesFromChildren(children);
    return useRoutes(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref6) {
    let { children, errorElement, resolve } = _ref6;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})(AwaitRenderStatus || (AwaitRenderStatus = {}));
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? AwaitRenderStatus.error : promise._data !== undefined ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function ResolveAwait(_ref7) {
    let { children } = _ref7;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, parentPath));
            return;
        }
        !(element.type === Route) && (0, _router.invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.invariant)(false);
        let treePath = [
            ...parentPath,
            index
        ];
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            hasErrorBoundary: element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
/**
 * @private
 * Walk the route tree and add hasErrorBoundary if it's not provided, so that
 * users providing manual route arrays can just specify errorElement
 */ function enhanceManualRouteObjects(routes) {
    return routes.map((route)=>{
        let routeClone = _extends({}, route);
        if (routeClone.hasErrorBoundary == null) routeClone.hasErrorBoundary = routeClone.errorElement != null;
        if (routeClone.children) routeClone.children = enhanceManualRouteObjects(routeClone.children);
        return routeClone;
    });
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: enhanceManualRouteObjects(routes)
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////

},{"@remix-run/router":"8cjRs","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8cjRs":[function(require,module,exports) {
/**
 * @remix-run/router v1.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "ErrorResponse", ()=>ErrorResponse);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_getPathContributingMatches", ()=>getPathContributingMatches);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
parcelHelpers.export(exports, "warning", ()=>warning);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        return createLocation("", {
            pathname,
            search,
            hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning$1(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning$1(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        let nextAction = Action.Pop;
        let nextIndex = getIndex();
        if (nextIndex != null) {
            let delta = nextIndex - index;
            action = nextAction;
            index = nextIndex;
            if (listener) listener({
                action,
                location: history.location,
                delta
            });
        } else warning$1(false, // and link to it here so people can understand better what is going on
        // and how to avoid it.
        "You are trying to block a POP navigation to a location that was not created by @remix-run/router. The block will fail silently in production, but in general you should do all navigation with the router (instead of using window.history.pushState directly) to avoid this situation.");
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
function isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, parentPath, allIds) {
    if (parentPath === void 0) parentPath = [];
    if (allIds === void 0) allIds = new Set();
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!allIds.has(id), 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        allIds.add(id);
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, {
                id
            });
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, {
                id,
                children: route.children ? convertRoutesToDataRoutes(route.children, treePath, allIds) : undefined
            });
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    safelyDecodeURI(pathname));
    return matches;
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:\w+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    return path.replace(/^:(\w+)(\??)/g, (_, key, optional)=>{
        let param = params[key];
        if (optional === "?") return param == null ? "" : param;
        if (param == null) invariant(false, 'Missing ":' + key + '" param');
        return param;
    }).replace(/\/:(\w+)(\??)/g, (_, key, optional)=>{
        let param = params[key];
        if (optional === "?") return param == null ? "" : "/" + param;
        if (param == null) invariant(false, 'Missing ":' + key + '" param');
        return "/" + param;
    }) // Remove any optional markers from optional static segments
    .replace(/\?/g, "").replace(/(\/?)\*/, (_, prefix, __, str)=>{
        const star = "*";
        if (params[star] == null) // If no splat was provided, trim the trailing slash _unless_ it's
        // the entire path
        return str === "/*" ? "/" : "";
         // Apply the splat
        return "" + prefix + params[star];
    });
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        warning(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        warning(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * @private
 */ function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging @remix-run/router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class ErrorResponse {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response throw from an action/loader
 */ function isRouteErrorResponse(e) {
    return e instanceof ErrorResponse;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const isServer = !isBrowser; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let dataRoutes = convertRoutesToDataRoutes(init.routes); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = !initialMatches.some((m)=>m.route.loader) || init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // We ony support a single active blocker at the moment since we don't have
    // any compelling use cases for multi-blocker yet
    let activeBlocker = null; // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        if (!state.initialized) startNavigation(Action.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = _extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(to, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = matchRoutes(dataRoutes, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change
        if (isHashChangeOnly(state.location, location)) {
            completeNavigation(location, {
                matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = _extends({
                state: "loading",
                location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited, loaderData, errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData,
            errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = _extends({
            state: "submitting",
            location
        }, submission);
        updateState({
            navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await callLoaderOrAction("action", request, actionMatch, matches, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = _extends({
                state: "loading",
                location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission ? submission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((_ref2)=>{
                let [key] = _ref2;
                let fetcher = state.fetchers.get(key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState(_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((_ref3)=>{
            let [key] = _ref3;
            return fetchControllers.set(key, pendingNavigationController);
        });
        let { results, loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((_ref4)=>{
            let [key] = _ref4;
            return fetchControllers.delete(key);
        }); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return _extends({
            loaderData,
            errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || IDLE_FETCHER;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let matches = matchRoutes(dataRoutes, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path, submission } = normalizeNavigateOptions(href, opts, true);
        let match = getTargetMatch(matches, path);
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, [
            path,
            match,
            matches
        ]);
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action) {
            let error = getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = _extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await callLoaderOrAction("action", fetchRequest, match, requestMatches, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = _extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if (isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? matchRoutes(dataRoutes, state.navigation.location, init.basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = _extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, {
            [match.route.id]: actionResult.data
        }, undefined, fetchLoadMatches); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((_ref5)=>{
            let [staleKey] = _ref5;
            return staleKey !== key;
        }).forEach((_ref6)=>{
            let [staleKey] = _ref6;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results, loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((_ref7)=>{
            let [staleKey] = _ref7;
            return fetchControllers.delete(staleKey);
        });
        let redirect = findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState(_extends({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = _extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await callLoaderOrAction("loader", fetchRequest, match, matches, router.basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission, replace, isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = createLocation(state.location, redirect.location, _extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        invariant(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an external redirect that goes to a new origin
        if (isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let newOrigin = init.history.createURL(redirect.location).origin;
            if (window.location.origin !== newOrigin) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? Action.Replace : Action.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType, formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod,
            formAction,
            formEncType,
            formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if (redirectPreserveMethodStatusCodes.has(redirect.status) && submission && isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>callLoaderOrAction("loader", request, match, matches, router.basename)),
            ...fetchersToLoad.map((_ref8)=>{
                let [, href, match, fetchMatches] = _ref8;
                return callLoaderOrAction("loader", createClientSideRequest(init.history, href, request.signal), match, fetchMatches, router.basename);
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            resolveDeferredResults(currentMatches, fetchersToLoad.map((_ref9)=>{
                let [, , match] = _ref9;
                return match;
            }), fetcherResults, request.signal, true)
        ]);
        return {
            results,
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        invariant(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) {
            blockerFunctions.set(key, fn);
            if (activeBlocker == null) // This is now the active blocker
            activeBlocker = key;
            else if (key !== activeBlocker) warning(false, "A router only supports one blocker at a time");
        }
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
        if (activeBlocker === key) activeBlocker = null;
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref10) {
        let { currentLocation, nextLocation, historyAction } = _ref10;
        if (activeBlocker == null) return;
         // We only allow a single blocker at the moment.  This will need to be
        // updated if we enhance to support multiple blockers in the future
        let blockerFunction = blockerFunctions.get(activeBlocker);
        invariant(blockerFunction, "Could not find a function for the active blocker");
        let blocker = state.blockers.get(activeBlocker);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return activeBlocker;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher,
        dispose,
        getBlocker,
        deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let dataRoutes = convertRoutesToDataRoutes(routes);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "head") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if (isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId, requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method.toLowerCase();
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "head" && method !== "options") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if (isQueryRouteResponse(e)) {
                if (e.type === ResultType.error && !isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            result = await callLoaderOrAction("action", request, actionMatch, matches, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return _extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: _extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>callLoaderOrAction("loader", request, match, matches, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(to, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : createPath(to); // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        submission = {
            formMethod: opts.formMethod || "get",
            formAction: stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if (isMutationMethod(submission.formMethod)) return {
            path,
            submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    try {
        let searchParams = convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
        // navigation GET submissions which run all loaders), we need to preserve
        // any incoming ?index params
        if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
        parsedPath.search = "?" + searchParams;
    } catch (e) {
        return {
            path,
            error: getInternalRouterError(400)
        };
    }
    return {
        path: createPath(parsedPath),
        submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, pendingActionData, pendingError, fetchLoadMatches) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>match.route.loader != null && (isNewLoader(state.loaderData, state.matches[index], match) || // If this route had a pending deferred cancelled it must be revalidated
        cancelledDeferredRoutes.some((id)=>id === match.route.id) || shouldRevalidateLoader(history, state.location, state.matches[index], submission, location, match, isRevalidationRequired, actionResult))); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches && fetchLoadMatches.forEach((_ref11, key)=>{
        let [href, match, fetchMatches] = _ref11;
        // This fetcher was cancelled from a prior action submission - force reload
        if (cancelledFetcherLoads.includes(key)) revalidatingFetchers.push([
            key,
            href,
            match,
            fetchMatches
        ]);
        else if (isRevalidationRequired) {
            let shouldRevalidate = shouldRevalidateLoader(history, href, match, submission, href, match, isRevalidationRequired, actionResult);
            if (shouldRevalidate) revalidatingFetchers.push([
                key,
                href,
                match,
                fetchMatches
            ]);
        }
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function shouldRevalidateLoader(history, currentLocation, currentMatch, submission, location, match, isRevalidationRequired, actionResult) {
    let currentUrl = history.createURL(currentLocation);
    let currentParams = currentMatch.params;
    let nextUrl = history.createURL(location);
    let nextParams = match.params; // This is the default implementation as to when we revalidate.  If the route
    // provides it's own implementation, then we give them full control but
    // provide this value so they can leverage it if needed after they check
    // their own specific use cases
    // Note that fetchers always provide the same current/next locations so the
    // URL-based checks here don't apply to fetcher shouldRevalidate calls
    let defaultShouldRevalidate = isNewRouteInstance(currentMatch, match) || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search || // Forced revalidation due to submission, useRevalidate, or X-Remix-Revalidate
    isRevalidationRequired;
    if (match.route.shouldRevalidate) {
        let routeChoice = match.route.shouldRevalidate(_extends({
            currentUrl,
            currentParams,
            nextUrl,
            nextParams
        }, submission, {
            actionResult,
            defaultShouldRevalidate
        }));
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return defaultShouldRevalidate;
}
async function callLoaderOrAction(type, request, match, matches, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result; // Setup a promise we can race against so that abort signals short circuit
    let reject;
    let abortPromise = new Promise((_, r)=>reject = r);
    let onReject = ()=>reject();
    request.signal.addEventListener("abort", onReject);
    try {
        let handler = match.route[type];
        invariant(handler, "Could not find the " + type + ' to run on the "' + match.route.id + '" route');
        result = await Promise.race([
            handler({
                request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
        invariant(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = ResultType.error;
        result = e;
    } finally{
        request.signal.removeEventListener("abort", onReject);
    }
    if (isResponse(result)) {
        let status = result.status; // Process redirects
        if (redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            let isAbsolute = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(location); // Support relative routing in internal redirects
            if (!isAbsolute) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = getPathContributingMatches(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = resolveTo(location, routePathnames, new URL(request.url).pathname);
                invariant(createPath(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : joinPaths([
                        basename,
                        path
                    ]);
                }
                location = createPath(resolvedLocation);
            } else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin absolute redirects.
                // If this is a static reques, we can let it go back to the browser
                // as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                if (url.origin === currentUrl.origin) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: ResultType.redirect,
                status,
                location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === ResultType.error) return {
            type: resultType,
            error: new ErrorResponse(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === ResultType.error) return {
        type: resultType,
        error: result
    };
    if (result instanceof DeferredData) return {
        type: ResultType.deferred,
        deferredData: result
    };
    return {
        type: ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType, formData } = submission;
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries()){
        invariant(typeof value === "string", 'File inputs are not supported with encType "application/x-www-form-urlencoded", please use "multipart/form-data" instead.');
        searchParams.append(key, value);
    }
    return searchParams;
}
function processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if (isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let [key, , match] = revalidatingFetchers[index];
        invariant(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp4) {
    let { pathname, routeId, method, type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else errorMessage = "Cannot submit binary form data using GET";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new ErrorResponse(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if (isRedirectResult(result)) return result;
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isQueryRouteResponse(obj) {
    return obj && isResponse(obj.response) && (obj.type === ResultType.data || ResultType.error);
}
function isValidMethod(method) {
    return validRequestMethods.has(method);
}
function isMutationMethod(method) {
    return validMutationMethods.has(method);
}
async function resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function createUseMatchesMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dFzXj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epicMiddleware", ()=>epicMiddleware);
parcelHelpers.export(exports, "EMPTY_ACTION", ()=>EMPTY_ACTION);
parcelHelpers.export(exports, "getEnhancer", ()=>getEnhancer);
parcelHelpers.export(exports, "combinedReducer", ()=>combinedReducer);
parcelHelpers.export(exports, "rootReducer", ()=>rootReducer);
parcelHelpers.export(exports, "rootEpic", ()=>rootEpic);
parcelHelpers.export(exports, "createPosStore", ()=>createPosStore);
var _redux = require("redux");
var _reduxObservable = require("redux-observable");
var _reducer = require("./reducer");
var _reducerDefault = parcelHelpers.interopDefault(_reducer);
// utility epics
var _auth = require("./auth");
var _themeRequests = require("../state/epics/themeRequests");
// end utility epics
// page reducers
var _loginState = require("../pages/login/Login.state");
var _terminalLoginState = require("../pages/terminal-login/TerminalLogin.state");
var _checkoutState = require("../pages/checkout/Checkout.state");
var _productsState = require("../pages/products/Products.state");
var _searchState = require("../pages/search/Search.state");
var _lookupState = require("../pages/lookup/Lookup.state");
var _searchResultsState = require("../pages/search-results/SearchResults.state");
var _cartState = require("../pages/cart/Cart.state");
var _orderDetailsState = require("../pages/order-details/OrderDetails.state");
var _ordersIndexState = require("../pages/orders-index/OrdersIndex.state");
var _closeoutState = require("../pages/closeout/Closeout.state");
var _cashDropState = require("../pages/cash-drop/CashDrop.state");
var _cashActionDetailsState = require("../pages/cash-action-details/CashActionDetails.state");
var _drawerHistoryIndexState = require("../pages/drawer-history-index/DrawerHistoryIndex.state");
var _shared = require("./shared");
var _visitExpirationState = require("../pages/cart/VisitExpiration.state");
var _reportingState = require("../pages/reporting/Reporting.state");
var _paymentDetailsState = require("../components/payment-details/PaymentDetails.state");
// end page reducers
var _reduxAirbrakeMiddleware = require("../utils/reduxAirbrakeMiddleware");
var _reduxAirbrakeMiddlewareDefault = parcelHelpers.interopDefault(_reduxAirbrakeMiddleware);
// page epics
var _loginEpic = require("../pages/login/Login.epic");
var _terminalLoginEpic = require("../pages/terminal-login/TerminalLogin.epic");
var _checkoutEpic = require("../pages/checkout/Checkout.epic");
var _productsEpics = require("../pages/products/Products.epics");
var _orderDetailsEpic = require("../pages/order-details/OrderDetails.epic");
var _lookupEpic = require("../pages/lookup/Lookup.epic");
var _cartEpic = require("../pages/cart/Cart.epic");
var _visitExpirationEpic = require("../pages/cart/VisitExpiration.epic");
var _searchEpic = require("../pages/search/Search.epic");
var _ordersEpic = require("../pages/orders-index/Orders.epic");
var _closeoutEpic = require("../pages/closeout/Closeout.epic");
var _cashActionDetailsEpics = require("../pages/cash-action-details/CashActionDetails.epics");
var _cashDropEpics = require("../pages/cash-drop/CashDrop.epics");
var _peripheralDevicesEpic = require("./epics/peripheralDevicesEpic");
var _drawerHistoryIndexEpics = require("../pages/drawer-history-index/DrawerHistoryIndex.epics");
var _sharedEpic = require("./epics/sharedEpic");
var _reportingEpic = require("../pages/reporting/Reporting.epic");
var _reportingEpicDefault = parcelHelpers.interopDefault(_reportingEpic);
var _constants = require("../utils/constants");
// end page epics
var _browser = require("@airbrake/browser");
const epicMiddleware = (0, _reduxObservable.createEpicMiddleware)();
const EMPTY_ACTION = {
    type: "EMPTY"
};
// Allow for multiple enhancers (middleware and dev tools) to be initialized with the store
// https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
const composeEnhancers = typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    actionsDenylist: [
        EMPTY_ACTION.type
    ]
}) : (0, _redux.compose);
const LOGOUT_WORTHY_ACTIONS = [
    (0, _terminalLoginState.FETCH_LOCATIONS_FAILURE)
];
const logoutWorthyActionMiddleware = (storeAPI)=>(next)=>(action)=>{
            if (LOGOUT_WORTHY_ACTIONS.includes(action?.type)) {
                // Any logout worthy action must pass navigate from react-router-dom as the LOGOUT action navigates the user to the landing page
                const navigate = action.payload.navigate;
                localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), action.payload.err);
                storeAPI.dispatch((0, _reducer.logout)({
                    navigate
                }));
            }
            return next(action);
        };
const getEnhancer = ({ airbrakeErrorMiddleware })=>{
    const middlewares = [
        epicMiddleware,
        logoutWorthyActionMiddleware
    ];
    if (airbrakeErrorMiddleware) middlewares.push(airbrakeErrorMiddleware);
    return composeEnhancers((0, _redux.applyMiddleware)(...middlewares));
};
const appReducers = {
    global: (0, _reducerDefault.default),
    login: (0, _loginState.reducer),
    products: (0, _productsState.reducer),
    search: (0, _searchState.reducer),
    lookup: (0, _lookupState.reducer),
    cart: (0, _cartState.reducer),
    searchResults: (0, _searchResultsState.reducer),
    terminalLogin: (0, _terminalLoginState.reducer),
    checkout: (0, _checkoutState.reducer),
    orderDetails: (0, _orderDetailsState.reducer),
    ordersIndex: (0, _ordersIndexState.reducer),
    closeout: (0, _closeoutState.reducer),
    cashDrop: (0, _cashDropState.reducer),
    cashActionDetails: (0, _cashActionDetailsState.reducer),
    drawerHistoryIndex: (0, _drawerHistoryIndexState.reducer),
    shared: (0, _shared.reducer),
    visitExpiration: (0, _visitExpirationState.reducer),
    reporting: (0, _reportingState.reducer),
    paymentDetails: (0, _paymentDetailsState.reducer),
    // single token auth system reducer
    config: (defaultConfig = null)=>defaultConfig
};
const combinedReducer = (0, _redux.combineReducers)(appReducers);
const rootReducer = (state, action)=>{
    if (action.type === (0, _reducer.LOGOUT)) /* this resets the entire store to its initial state on logout (except for client config).
     other pieces of the state tree can be persisted on logout by appending to the object below.
     this is due to each reducer being undefined except for config, defaulting them to their respective initialStates.
    */ state = {
        config: state.config
    };
    return combinedReducer(state, action);
};
const rootEpic = (0, _reduxObservable.combineEpics)((0, _terminalLoginEpic.submitTerminalLoginFormEpic), (0, _themeRequests.fetchThemeEpic), (0, _terminalLoginEpic.fetchLocationsEpic), (0, _terminalLoginEpic.fetchTerminalsEpic), (0, _themeRequests.initializeTenantEpic), (0, _loginEpic.logoutEpic), (0, _auth.locallyStoreSessionsEpic), (0, _productsEpics.fetchLookupByIdEpic), (0, _productsEpics.fetchSearchByIdEpic), (0, _productsEpics.fetchProductsEpic), (0, _productsEpics.fetchAgenciesEpic), (0, _lookupEpic.addToCartEpic), (0, _cartEpic.getCurrentOrderEpic), (0, _cartEpic.getUpdatedCartEpic), (0, _cartEpic.holdOrderEpic), (0, _cartEpic.cancelOrderByIdEpic), (0, _searchEpic.searchForItemEpic), (0, _cartEpic.removeItemEpic), (0, _orderDetailsEpic.voidByIdEpic), (0, _orderDetailsEpic.returnByIdEpic), (0, _orderDetailsEpic.reopenByIdEpic), (0, _orderDetailsEpic.getOrderDetailsEpic), (0, _ordersEpic.fetchOrdersEpic), (0, _checkoutEpic.makePaymentEpic), (0, _checkoutEpic.sendPayLinkEpic), (0, _orderDetailsEpic.printReceiptEpic), (0, _orderDetailsEpic.sendReceiptEpic), (0, _ordersEpic.fetchBatchesEpic), (0, _ordersEpic.fetchUsersEpic), (0, _checkoutEpic.postVisitIdEpic), (0, _checkoutEpic.retryPostVisitIdEpic), (0, _checkoutEpic.orderStatusResponseEpic), (0, _closeoutEpic.createCloseoutEpic), (0, _peripheralDevicesEpic.openCashDrawerEpic), (0, _closeoutEpic.fetchCurrentBatchEpic), (0, _closeoutEpic.fetchCloseoutReportEpic), (0, _cashActionDetailsEpics.getCashActionDetailsEpic), (0, _cashActionDetailsEpics.getCloseoutDetailsEpic), (0, _cashDropEpics.postCashDropEpic), (0, _drawerHistoryIndexEpics.fetchDrawerHistoriesEpic), (0, _cashActionDetailsEpics.reprintCloseoutDetailsEpic), (0, _checkoutEpic.cancelTransactionEpic), (0, _cashActionDetailsEpics.printReceiptEpic), (0, _sharedEpic.fetchDenominationsEpic), (0, _cartEpic.voidTransactionByIdEpic), (0, _checkoutEpic.scanCheckEpic), (0, _checkoutEpic.checkScanPollingEpic), (0, _checkoutEpic.awaitCustomerCreditCardEpic), (0, _checkoutEpic.creditCardCountdownEpic), (0, _reportingEpicDefault.default), (0, _sharedEpic.fetchCurrentAbilitiesEpic), (0, _sharedEpic.fetchClientConfigEpic), (0, _loginEpic.logInOktaUserEpic), (0, _checkoutEpic.getServiceFeeEpic), (0, _checkoutEpic.getConvenienceFeeEpic), (0, _ordersEpic.fetchOrdersFilterOptionsEpic), (0, _drawerHistoryIndexEpics.fetchDrawerHistoriesFilterOptionsEpic), (0, _sharedEpic.resetPinPadEpic), (0, _orderDetailsEpic.cancelPaylinkByIdEpic), (0, _checkoutEpic.creditCardReadPollingEpic), (0, _visitExpirationEpic.trackVisitExpiresAtEpic), (0, _visitExpirationEpic.visitExpirationWarningTimerEpic), (0, _visitExpirationEpic.visitExpirationCountdownEpic), (0, _visitExpirationEpic.visitExpiredActionEpic), (0, _visitExpirationEpic.clearVisitExpirationOnCartClearEpic));
const createPosStore = (config)=>{
    const AIRBRAKE_EXCLUDED_ENVIRONMENTS = [
        (0, _constants.ENVIRONMENTS).LOCAL
    ];
    let airbrake, airbrakeErrorMiddleware;
    if (!AIRBRAKE_EXCLUDED_ENVIRONMENTS.includes(config.environment)) {
        airbrake = new (0, _browser.Notifier)({
            projectId: config.airbrakeProjectId,
            projectKey: config.airbrakeProjectKey,
            environment: config.environment
        });
        airbrakeErrorMiddleware = (0, _reduxAirbrakeMiddlewareDefault.default)(airbrake, {
            noticeAnnotations: {
                context: {
                    environment: config.environment
                }
            }
        });
    }
    const store = (0, _redux.createStore)(rootReducer, {
        config
    }, getEnhancer({
        airbrakeErrorMiddleware
    }));
    epicMiddleware.run(rootEpic);
    return store;
};

},{"redux":"lozc2","redux-observable":"c7mDq","./reducer":"aTwKq","./auth":"hoeE4","../state/epics/themeRequests":"6lCJi","../pages/login/Login.state":"eq6dI","../pages/terminal-login/TerminalLogin.state":"7GhEX","../pages/checkout/Checkout.state":"4E8nR","../pages/products/Products.state":"9SdM7","../pages/search/Search.state":"lcTto","../pages/lookup/Lookup.state":"bEN0h","../pages/search-results/SearchResults.state":"04CNM","../pages/cart/Cart.state":"bgoZn","../pages/order-details/OrderDetails.state":"3yj5u","../pages/orders-index/OrdersIndex.state":"cB6HN","../pages/closeout/Closeout.state":"eCCPO","../pages/cash-drop/CashDrop.state":"esqw8","../pages/cash-action-details/CashActionDetails.state":"dI29X","../pages/drawer-history-index/DrawerHistoryIndex.state":"d4FVh","./shared":"h0jLC","../pages/cart/VisitExpiration.state":"6xsNt","../pages/reporting/Reporting.state":"5xRzg","../components/payment-details/PaymentDetails.state":"9ORuF","../utils/reduxAirbrakeMiddleware":"dChnr","../pages/login/Login.epic":"1PiFF","../pages/terminal-login/TerminalLogin.epic":"bl4Aq","../pages/checkout/Checkout.epic":"ciyUa","../pages/products/Products.epics":"lyYeG","../pages/order-details/OrderDetails.epic":"eIg9g","../pages/lookup/Lookup.epic":"buY4p","../pages/cart/Cart.epic":"gIEOn","../pages/cart/VisitExpiration.epic":"c1ZL3","../pages/search/Search.epic":"2HZvf","../pages/orders-index/Orders.epic":"3sr26","../pages/closeout/Closeout.epic":"7XoGt","../pages/cash-action-details/CashActionDetails.epics":"lvaMo","../pages/cash-drop/CashDrop.epics":"7mcKd","./epics/peripheralDevicesEpic":"lDOOq","../pages/drawer-history-index/DrawerHistoryIndex.epics":"bcm5d","./epics/sharedEpic":"jPMG4","../pages/reporting/Reporting.epic":"efPi9","../utils/constants":"f3A1R","@airbrake/browser":"1cMw2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lozc2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    var constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}

},{"@babel/runtime/helpers/esm/objectSpread2":"hFmsh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hFmsh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _defineProperty = require("./defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

},{"./defineProperty":"3KkMx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3KkMx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c7mDq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEpicMiddleware", ()=>(0, _createEpicMiddleware.createEpicMiddleware));
parcelHelpers.export(exports, "ActionsObservable", ()=>(0, _actionsObservable.ActionsObservable));
parcelHelpers.export(exports, "StateObservable", ()=>(0, _stateObservable.StateObservable));
parcelHelpers.export(exports, "combineEpics", ()=>(0, _combineEpics.combineEpics));
parcelHelpers.export(exports, "ofType", ()=>(0, _operators.ofType));
var _createEpicMiddleware = require("./createEpicMiddleware");
var _actionsObservable = require("./ActionsObservable");
var _stateObservable = require("./StateObservable");
var _combineEpics = require("./combineEpics");
var _operators = require("./operators");

},{"./createEpicMiddleware":"hGzlf","./ActionsObservable":false,"./StateObservable":false,"./combineEpics":"5WbNW","./operators":false,"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hGzlf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEpicMiddleware", ()=>createEpicMiddleware);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _actionsObservable = require("./ActionsObservable");
var _stateObservable = require("./StateObservable");
var _console = require("./utils/console");
function createEpicMiddleware() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // This isn't great. RxJS doesn't publicly export the constructor for
    // QueueScheduler nor QueueAction, so we reach in. We need to do this because
    // we don't want our internal queuing mechanism to be on the same queue as any
    // other RxJS code outside of redux-observable internals.
    var QueueScheduler = (0, _rxjs.queueScheduler).constructor;
    var uniqueQueueScheduler = new QueueScheduler((0, _rxjs.queueScheduler).SchedulerAction);
    var epic$ = new (0, _rxjs.Subject)();
    var store = void 0;
    var epicMiddleware = function epicMiddleware(_store) {
        store = _store;
        var actionSubject$ = new (0, _rxjs.Subject)().pipe((0, _operators.observeOn)(uniqueQueueScheduler));
        var stateSubject$ = new (0, _rxjs.Subject)().pipe((0, _operators.observeOn)(uniqueQueueScheduler));
        var action$ = new (0, _actionsObservable.ActionsObservable)(actionSubject$);
        var state$ = new (0, _stateObservable.StateObservable)(stateSubject$, store.getState());
        var result$ = epic$.pipe((0, _operators.map)(function(epic) {
            var output$ = "dependencies" in options ? epic(action$, state$, options.dependencies) : epic(action$, state$);
            if (!output$) throw new TypeError('Your root Epic "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        }), (0, _operators.mergeMap)(function(output$) {
            return (0, _rxjs.from)(output$).pipe((0, _operators.subscribeOn)(uniqueQueueScheduler), (0, _operators.observeOn)(uniqueQueueScheduler));
        }));
        result$.subscribe(store.dispatch);
        return function(next) {
            return function(action) {
                // Downstream middleware gets the action first,
                // which includes their reducers, so state is
                // updated before epics receive the action
                var result = next(action);
                // It's important to update the state$ before we emit
                // the action because otherwise it would be stale
                stateSubject$.next(store.getState());
                actionSubject$.next(action);
                return result;
            };
        };
    };
    epicMiddleware.run = function(rootEpic) {
        epic$.next(rootEpic);
    };
    return epicMiddleware;
}

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","./ActionsObservable":"ciRSf","./StateObservable":"9JzaA","./utils/console":"7suGa","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kbxjh":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "GroupedObservable", ()=>(0, _groupBy.GroupedObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeoutError.TimeoutError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _groupBy = require("./internal/operators/groupBy");
var _observable1 = require("./internal/symbol/observable");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _timeoutError = require("./internal/util/TimeoutError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _config = require("./internal/config");

},{"./internal/Observable":"h2K5g","./internal/observable/ConnectableObservable":"dhOs3","./internal/operators/groupBy":"hJLCA","./internal/symbol/observable":"e76vK","./internal/Subject":"inyPN","./internal/BehaviorSubject":"kJBa4","./internal/ReplaySubject":"l8z3l","./internal/AsyncSubject":"2yZ36","./internal/scheduler/asap":"5k8ix","./internal/scheduler/async":"7s84y","./internal/scheduler/queue":"j5RRb","./internal/scheduler/animationFrame":"YRvM5","./internal/scheduler/VirtualTimeScheduler":"e9KRA","./internal/Scheduler":"aMGhW","./internal/Subscription":"3awdk","./internal/Subscriber":"dcQ4T","./internal/Notification":"cMrt4","./internal/util/pipe":"4SsWQ","./internal/util/noop":"imgcq","./internal/util/identity":"1yHSj","./internal/util/isObservable":"8wluJ","./internal/util/ArgumentOutOfRangeError":"4XnVL","./internal/util/EmptyError":"kS4dn","./internal/util/ObjectUnsubscribedError":"1XI03","./internal/util/UnsubscriptionError":"g8d5E","./internal/util/TimeoutError":"4ByPn","./internal/observable/bindCallback":"xDgHH","./internal/observable/bindNodeCallback":"inXUX","./internal/observable/combineLatest":"k43Wc","./internal/observable/concat":"ir4TZ","./internal/observable/defer":"gV56M","./internal/observable/empty":"dQ7pX","./internal/observable/forkJoin":"hW3LX","./internal/observable/from":"eOpwS","./internal/observable/fromEvent":"d068Y","./internal/observable/fromEventPattern":"ljqEC","./internal/observable/generate":"6vhfM","./internal/observable/iif":"f9IPI","./internal/observable/interval":"5OOkQ","./internal/observable/merge":"4VOM1","./internal/observable/never":"htrvU","./internal/observable/of":"c99As","./internal/observable/onErrorResumeNext":"9iqiO","./internal/observable/pairs":"4ryJ6","./internal/observable/partition":"8bTur","./internal/observable/race":"20v8G","./internal/observable/range":"eHNX5","./internal/observable/throwError":"lHftZ","./internal/observable/timer":"bWaEN","./internal/observable/using":"h1rgw","./internal/observable/zip":"9vE03","./internal/scheduled/scheduled":"6CsLR","./internal/config":"5JCJu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h2K5g":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _canReportError = require("./util/canReportError");
var _toSubscriber = require("./util/toSubscriber");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var Observable = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, _toSubscriber.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, _config.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, _canReportError.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, _config.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

},{"./util/canReportError":"7pl6W","./util/toSubscriber":"bHaCE","./symbol/observable":"e76vK","./util/pipe":"4SsWQ","./config":"5JCJu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7pl6W":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canReportError", ()=>canReportError);
var _subscriber = require("../Subscriber");
function canReportError(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, _subscriber.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

},{"../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dcQ4T":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _observer = require("./Observer");
var _subscription = require("./Subscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var Subscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, _observer.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, _observer.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, _subscription.Subscription));
var SafeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, _isFunction.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, _observer.empty)) {
                context = Object.create(observerOrNext);
                if ((0, _isFunction.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, _config.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, _hostReportError.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, _hostReportError.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, _config.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, _hostReportError.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, _config.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, _hostReportError.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber);

},{"tslib":"63kEc","./util/isFunction":"1D5el","./Observer":"iusUP","./Subscription":"3awdk","../internal/symbol/rxSubscriber":"72iun","./config":"5JCJu","./util/hostReportError":"8u9Zr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"63kEc":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1D5el":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(x) {
    return typeof x === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iusUP":[function(require,module,exports) {
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "empty", ()=>empty);
var _config = require("./config");
var _hostReportError = require("./util/hostReportError");
var empty = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, _config.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, _hostReportError.hostReportError)(err);
    },
    complete: function() {}
};

},{"./config":"5JCJu","./util/hostReportError":"8u9Zr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5JCJu":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if (_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8u9Zr":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hostReportError", ()=>hostReportError);
function hostReportError(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3awdk":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
var _isArray = require("./util/isArray");
var _isObject = require("./util/isObject");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var Subscription = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, _isFunction.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, _isArray.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, _isObject.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, _unsubscriptionError.UnsubscriptionError) ? err.errors : err);
    }, []);
}

},{"./util/isArray":"kB1Jq","./util/isObject":"9AQRY","./util/isFunction":"1D5el","./util/UnsubscriptionError":"g8d5E","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kB1Jq":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArray", ()=>isArray);
var isArray = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9AQRY":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
function isObject(x) {
    return x !== null && typeof x === "object";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g8d5E":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var UnsubscriptionError = UnsubscriptionErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"72iun":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rxSubscriber", ()=>rxSubscriber);
parcelHelpers.export(exports, "$$rxSubscriber", ()=>$$rxSubscriber);
var rxSubscriber = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $$rxSubscriber = rxSubscriber;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bHaCE":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toSubscriber", ()=>toSubscriber);
var _subscriber = require("../Subscriber");
var _rxSubscriber = require("../symbol/rxSubscriber");
var _observer = require("../Observer");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, _subscriber.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, _rxSubscriber.rxSubscriber]) return nextOrObserver[0, _rxSubscriber.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, _subscriber.Subscriber)((0, _observer.empty));
    return new (0, _subscriber.Subscriber)(nextOrObserver, error, complete);
}

},{"../Subscriber":"dcQ4T","../symbol/rxSubscriber":"72iun","../Observer":"iusUP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e76vK":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4SsWQ":[function(require,module,exports) {
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"1yHSj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1yHSj":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dhOs3":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectableObservable", ()=>ConnectableObservable);
parcelHelpers.export(exports, "connectableObservableDescriptor", ()=>connectableObservableDescriptor);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _observable = require("../Observable");
var _subscriber = require("../Subscriber");
var _subscription = require("../Subscription");
var _refCount = require("../operators/refCount");
var ConnectableObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new (0, _subscription.Subscription)();
            connection.add(this.source.subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = (0, _subscription.Subscription).EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return (0, _refCount.refCount)()(this);
    };
    return ConnectableObservable;
}((0, _observable.Observable));
var connectableObservableDescriptor = /*@__PURE__*/ function() {
    var connectableProto = ConnectableObservable.prototype;
    return {
        operator: {
            value: null
        },
        _refCount: {
            value: 0,
            writable: true
        },
        _subject: {
            value: null,
            writable: true
        },
        _connection: {
            value: null,
            writable: true
        },
        _subscribe: {
            value: connectableProto._subscribe
        },
        _isComplete: {
            value: connectableProto._isComplete,
            writable: true
        },
        getSubject: {
            value: connectableProto.getSubject
        },
        connect: {
            value: connectableProto.connect
        },
        refCount: {
            value: connectableProto.refCount
        }
    };
}();
var ConnectableSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}((0, _subject.SubjectSubscriber));
var RefCountOperator = /*@__PURE__*/ function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var RefCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subject":"inyPN","../Observable":"h2K5g","../Subscriber":"dcQ4T","../Subscription":"3awdk","../operators/refCount":"lTFZw","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"inyPN":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscriber", ()=>SubjectSubscriber);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var _rxSubscriber = require("../internal/symbol/rxSubscriber");
var SubjectSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, _subscriber.Subscriber));
var Subject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, _rxSubscriber.rxSubscriber] = function() {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, _subscription.Subscription).EMPTY;
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"63kEc","./Observable":"h2K5g","./Subscriber":"dcQ4T","./Subscription":"3awdk","./util/ObjectUnsubscribedError":"1XI03","./SubjectSubscription":"lA4EL","../internal/symbol/rxSubscriber":"72iun","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1XI03":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lA4EL":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubjectSubscription", ()=>SubjectSubscription);
var _tslib = require("tslib");
var _subscription = require("./Subscription");
var SubjectSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, _subscription.Subscription));

},{"tslib":"63kEc","./Subscription":"3awdk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lTFZw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "refCount", ()=>refCount);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var RefCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hJLCA":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "groupBy", ()=>groupBy);
parcelHelpers.export(exports, "GroupedObservable", ()=>GroupedObservable);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _subscription = require("../Subscription");
var _observable = require("../Observable");
var _subject = require("../Subject");
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function(source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
var GroupByOperator = /*@__PURE__*/ function() {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}();
var GroupBySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
    }
    GroupBySubscriber.prototype._next = function(value) {
        var key;
        try {
            key = this.keySelector(value);
        } catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) groups = this.groups = new Map();
        var group = groups.get(key);
        var element;
        if (this.elementSelector) try {
            element = this.elementSelector(value);
        } catch (err) {
            this.error(err);
        }
        else element = value;
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new (0, _subject.Subject)();
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                } catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) group.next(element);
    };
    GroupBySubscriber.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function(key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) _super.prototype.unsubscribe.call(this);
        }
    };
    return GroupBySubscriber;
}((0, _subscriber.Subscriber));
var GroupDurationSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
    }
    GroupDurationSubscriber.prototype._next = function(value) {
        this.complete();
    };
    GroupDurationSubscriber.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) parent.removeGroup(key);
    };
    return GroupDurationSubscriber;
}((0, _subscriber.Subscriber));
var GroupedObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function(subscriber) {
        var subscription = new (0, _subscription.Subscription)();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) subscription.add(new InnerRefCountSubscription(refCountSubscription));
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}((0, _observable.Observable));
var InnerRefCountSubscription = /*@__PURE__*/ function(_super) {
    _tslib.__extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) parent.unsubscribe();
        }
    };
    return InnerRefCountSubscription;
}((0, _subscription.Subscription));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../Subscription":"3awdk","../Observable":"h2K5g","../Subject":"inyPN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kJBa4":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BehaviorSubject", ()=>BehaviorSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var BehaviorSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, _subject.Subject));

},{"tslib":"63kEc","./Subject":"inyPN","./util/ObjectUnsubscribedError":"1XI03","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l8z3l":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaySubject", ()=>ReplaySubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _queue = require("./scheduler/queue");
var _subscription = require("./Subscription");
var _observeOn = require("./operators/observeOn");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _subjectSubscription = require("./SubjectSubscription");
var ReplaySubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        } else _this.next = _this.nextTimeWindow;
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function(value) {
        var _events = this._events;
        _events.push(value);
        if (_events.length > this._bufferSize) _events.shift();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function(value) {
        this._events.push(new ReplayEvent(this._getNow(), value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
        else if (this.isStopped || this.hasError) subscription = (0, _subscription.Subscription).EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new (0, _subjectSubscription.SubjectSubscription)(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new (0, _observeOn.ObserveOnSubscriber)(subscriber, scheduler));
        if (_infiniteTimeWindow) for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i]);
        else for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || (0, _queue.queue)).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}((0, _subject.Subject));
var ReplayEvent = /*@__PURE__*/ function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

},{"tslib":"63kEc","./Subject":"inyPN","./scheduler/queue":"j5RRb","./Subscription":"3awdk","./operators/observeOn":"lN5AD","./util/ObjectUnsubscribedError":"1XI03","./SubjectSubscription":"lA4EL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j5RRb":[function(require,module,exports) {
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueScheduler", ()=>queueScheduler);
parcelHelpers.export(exports, "queue", ()=>queue);
var _queueAction = require("./QueueAction");
var _queueScheduler = require("./QueueScheduler");
var queueScheduler = /*@__PURE__*/ new (0, _queueScheduler.QueueScheduler)((0, _queueAction.QueueAction));
var queue = queueScheduler;

},{"./QueueAction":"cWs4H","./QueueScheduler":"lqwSQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cWs4H":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueAction", ()=>QueueAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var QueueAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        return scheduler.flush(this);
    };
    return QueueAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"63kEc","./AsyncAction":"4uoOT","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4uoOT":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", ()=>AsyncAction);
var _tslib = require("tslib");
var _action = require("./Action");
var AsyncAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"63kEc","./Action":"cDPt0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cDPt0":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = /*@__PURE__*/ function(_super) {
    _tslib.__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"63kEc","../Subscription":"3awdk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lqwSQ":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueScheduler", ()=>QueueScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var QueueScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"63kEc","./AsyncScheduler":"7xug6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7xug6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", ()=>AsyncScheduler);
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, function() {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) return AsyncScheduler.delegate.now();
            else return now();
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) return AsyncScheduler.delegate.schedule(work, delay, state);
        else return _super.prototype.schedule.call(this, work, delay, state);
    };
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"63kEc","../Scheduler":"aMGhW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aMGhW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var Scheduler = /*@__PURE__*/ function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function() {
        return Date.now();
    };
    return Scheduler;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lN5AD":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", ()=>observeOn);
parcelHelpers.export(exports, "ObserveOnOperator", ()=>ObserveOnOperator);
parcelHelpers.export(exports, "ObserveOnSubscriber", ()=>ObserveOnSubscriber);
parcelHelpers.export(exports, "ObserveOnMessage", ()=>ObserveOnMessage);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
var ObserveOnSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage((0, _notification.Notification).createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage((0, _notification.Notification).createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}((0, _subscriber.Subscriber));
var ObserveOnMessage = /*@__PURE__*/ function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../Notification":"cMrt4","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cMrt4":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationKind", ()=>NotificationKind);
parcelHelpers.export(exports, "Notification", ()=>Notification);
var _empty = require("./observable/empty");
var _of = require("./observable/of");
var _throwError = require("./observable/throwError");
var NotificationKind;
/*@__PURE__*/ (function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return (0, _of.of)(this.value);
            case "E":
                return (0, _throwError.throwError)(this.error);
            case "C":
                return (0, _empty.empty)();
        }
        throw new Error("unexpected notification kind value");
    };
    Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();

},{"./observable/empty":"dQ7pX","./observable/of":"c99As","./observable/throwError":"lHftZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dQ7pX":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "empty", ()=>empty);
var _observable = require("../Observable");
var EMPTY = /*@__PURE__*/ new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"h2K5g","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c99As":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "of", ()=>of);
var _isScheduler = require("../util/isScheduler");
var _fromArray = require("./fromArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = args[args.length - 1];
    if ((0, _isScheduler.isScheduler)(scheduler)) {
        args.pop();
        return (0, _scheduleArray.scheduleArray)(args, scheduler);
    } else return (0, _fromArray.fromArray)(args);
}

},{"../util/isScheduler":"gX9xK","./fromArray":"oYz8C","../scheduled/scheduleArray":"7hWcX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gX9xK":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", ()=>isScheduler);
function isScheduler(value) {
    return value && typeof value.schedule === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"oYz8C":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromArray", ()=>fromArray);
var _observable = require("../Observable");
var _subscribeToArray = require("../util/subscribeToArray");
var _scheduleArray = require("../scheduled/scheduleArray");
function fromArray(input, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)((0, _subscribeToArray.subscribeToArray)(input));
    else return (0, _scheduleArray.scheduleArray)(input, scheduler);
}

},{"../Observable":"h2K5g","../util/subscribeToArray":"6OHUd","../scheduled/scheduleArray":"7hWcX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6OHUd":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToArray", ()=>subscribeToArray);
var subscribeToArray = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7hWcX":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

},{"../Observable":"h2K5g","../Subscription":"3awdk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lHftZ":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwError", ()=>throwError);
var _observable = require("../Observable");
function throwError(error, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)(function(subscriber) {
        return subscriber.error(error);
    });
    else return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
    });
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

},{"../Observable":"h2K5g","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2yZ36":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncSubject", ()=>AsyncSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _subscription = require("./Subscription");
var AsyncSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, _subscription.Subscription).EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return (0, _subscription.Subscription).EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}((0, _subject.Subject));

},{"tslib":"63kEc","./Subject":"inyPN","./Subscription":"3awdk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5k8ix":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asapScheduler", ()=>asapScheduler);
parcelHelpers.export(exports, "asap", ()=>asap);
var _asapAction = require("./AsapAction");
var _asapScheduler = require("./AsapScheduler");
var asapScheduler = /*@__PURE__*/ new (0, _asapScheduler.AsapScheduler)((0, _asapAction.AsapAction));
var asap = asapScheduler;

},{"./AsapAction":"5SiuY","./AsapScheduler":"5PJ4O","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5SiuY":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapAction", ()=>AsapAction);
var _tslib = require("tslib");
var _immediate = require("../util/Immediate");
var _asyncAction = require("./AsyncAction");
var AsapAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = (0, _immediate.Immediate).setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            (0, _immediate.Immediate).clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"63kEc","../util/Immediate":"lgfST","./AsyncAction":"4uoOT","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lgfST":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immediate", ()=>Immediate);
parcelHelpers.export(exports, "TestTools", ()=>TestTools);
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ function() {
    return /*@__PURE__*/ Promise.resolve();
}();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function() {
            return findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        findAndClearHandle(handle);
    }
};
var TestTools = {
    pending: function() {
        return Object.keys(activeHandles).length;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5PJ4O":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapScheduler", ()=>AsapScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AsapScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"63kEc","./AsyncScheduler":"7xug6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7s84y":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asyncScheduler", ()=>asyncScheduler);
parcelHelpers.export(exports, "async", ()=>async);
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var asyncScheduler = /*@__PURE__*/ new (0, _asyncScheduler.AsyncScheduler)((0, _asyncAction.AsyncAction));
var async = asyncScheduler;

},{"./AsyncAction":"4uoOT","./AsyncScheduler":"7xug6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"YRvM5":[function(require,module,exports) {
/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationFrameScheduler", ()=>animationFrameScheduler);
parcelHelpers.export(exports, "animationFrame", ()=>animationFrame);
var _animationFrameAction = require("./AnimationFrameAction");
var _animationFrameScheduler = require("./AnimationFrameScheduler");
var animationFrameScheduler = /*@__PURE__*/ new (0, _animationFrameScheduler.AnimationFrameScheduler)((0, _animationFrameAction.AnimationFrameAction));
var animationFrame = animationFrameScheduler;

},{"./AnimationFrameAction":"eASda","./AnimationFrameScheduler":"9zXql","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eASda":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameAction", ()=>AnimationFrameAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var AnimationFrameAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function() {
            return scheduler.flush(null);
        }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"63kEc","./AsyncAction":"4uoOT","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9zXql":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameScheduler", ()=>AnimationFrameScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AnimationFrameScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"63kEc","./AsyncScheduler":"7xug6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e9KRA":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>VirtualTimeScheduler);
parcelHelpers.export(exports, "VirtualAction", ()=>VirtualAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var VirtualTimeScheduler = /*@__PURE__*/ function(_super) {
    _tslib.__extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) SchedulerAction = VirtualAction;
        if (maxFrames === void 0) maxFrames = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, SchedulerAction, function() {
            return _this.frame;
        }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while((action = actions[0]) && action.delay <= maxFrames){
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}((0, _asyncScheduler.AsyncScheduler));
var VirtualAction = /*@__PURE__*/ function(_super) {
    _tslib.__extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (!this.id) return _super.prototype.schedule.call(this, state, delay);
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"63kEc","./AsyncAction":"4uoOT","./AsyncScheduler":"7xug6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"imgcq":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8wluJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObservable", ()=>isObservable);
var _observable = require("../Observable");
function isObservable(obj) {
    return !!obj && (obj instanceof (0, _observable.Observable) || typeof obj.lift === "function" && typeof obj.subscribe === "function");
}

},{"../Observable":"h2K5g","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4XnVL":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>ArgumentOutOfRangeError);
var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ function() {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = "argument out of range";
        this.name = "ArgumentOutOfRangeError";
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
}();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kS4dn":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyError", ()=>EmptyError);
var EmptyErrorImpl = /*@__PURE__*/ function() {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = "no elements in sequence";
        this.name = "EmptyError";
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
}();
var EmptyError = EmptyErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4ByPn":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutError", ()=>TimeoutError);
var TimeoutErrorImpl = /*@__PURE__*/ function() {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = "Timeout has occurred";
        this.name = "TimeoutError";
        return this;
    }
    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return TimeoutErrorImpl;
}();
var TimeoutError = TimeoutErrorImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"xDgHH":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindCallback", ()=>bindCallback);
var _observable = require("../Observable");
var _asyncSubject = require("../AsyncSubject");
var _map = require("../operators/map");
var _canReportError = require("../util/canReportError");
var _isArray = require("../util/isArray");
var _isScheduler = require("../util/isScheduler");
function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if ((0, _isScheduler.isScheduler)(resultSelector)) scheduler = resultSelector;
        else return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe((0, _map.map)(function(args) {
                return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
            }));
        };
    }
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler
        };
        return new (0, _observable.Observable)(function(subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new (0, _asyncSubject.AsyncSubject)();
                    var handler = function() {
                        var innerArgs = [];
                        for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([
                            handler
                        ]));
                    } catch (err) {
                        if ((0, _canReportError.canReportError)(subject)) subject.error(err);
                        else console.warn(err);
                    }
                }
                return subject.subscribe(subscriber);
            } else {
                var state = {
                    args: args,
                    subscriber: subscriber,
                    params: params
                };
                return scheduler.schedule(dispatch, 0, state);
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var self = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new (0, _asyncSubject.AsyncSubject)();
        var handler = function() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, {
                value: value,
                subject: subject
            }));
        };
        try {
            callbackFunc.apply(context, args.concat([
                handler
            ]));
        } catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(state) {
    var err = state.err, subject = state.subject;
    subject.error(err);
}

},{"../Observable":"h2K5g","../AsyncSubject":"2yZ36","../operators/map":"jeswA","../util/canReportError":"7pl6W","../util/isArray":"kB1Jq","../util/isScheduler":"gX9xK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jeswA":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "MapOperator", ()=>MapOperator);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var MapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"inXUX":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindNodeCallback", ()=>bindNodeCallback);
var _observable = require("../Observable");
var _asyncSubject = require("../AsyncSubject");
var _map = require("../operators/map");
var _canReportError = require("../util/canReportError");
var _isScheduler = require("../util/isScheduler");
var _isArray = require("../util/isArray");
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if ((0, _isScheduler.isScheduler)(resultSelector)) scheduler = resultSelector;
        else return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe((0, _map.map)(function(args) {
                return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
            }));
        };
    }
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this
        };
        return new (0, _observable.Observable)(function(subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new (0, _asyncSubject.AsyncSubject)();
                    var handler = function() {
                        var innerArgs = [];
                        for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([
                            handler
                        ]));
                    } catch (err) {
                        if ((0, _canReportError.canReportError)(subject)) subject.error(err);
                        else console.warn(err);
                    }
                }
                return subject.subscribe(subscriber);
            } else return scheduler.schedule(dispatch, 0, {
                params: params,
                subscriber: subscriber,
                context: context
            });
        });
    };
}
function dispatch(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new (0, _asyncSubject.AsyncSubject)();
        var handler = function() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i] = arguments[_i];
            var err = innerArgs.shift();
            if (err) _this.add(scheduler.schedule(dispatchError, 0, {
                err: err,
                subject: subject
            }));
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(dispatchNext, 0, {
                    value: value,
                    subject: subject
                }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([
                handler
            ]));
        } catch (err) {
            this.add(scheduler.schedule(dispatchError, 0, {
                err: err,
                subject: subject
            }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

},{"../Observable":"h2K5g","../AsyncSubject":"2yZ36","../operators/map":"jeswA","../util/canReportError":"7pl6W","../util/isScheduler":"gX9xK","../util/isArray":"kB1Jq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k43Wc":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
parcelHelpers.export(exports, "CombineLatestOperator", ()=>CombineLatestOperator);
parcelHelpers.export(exports, "CombineLatestSubscriber", ()=>CombineLatestSubscriber);
var _tslib = require("tslib");
var _isScheduler = require("../util/isScheduler");
var _isArray = require("../util/isArray");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
var _fromArray = require("./fromArray");
var NONE = {};
function combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var resultSelector = undefined;
    var scheduler = undefined;
    if ((0, _isScheduler.isScheduler)(observables[observables.length - 1])) scheduler = observables.pop();
    if (typeof observables[observables.length - 1] === "function") resultSelector = observables.pop();
    if (observables.length === 1 && (0, _isArray.isArray)(observables[0])) observables = observables[0];
    return (0, _fromArray.fromArray)(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ function() {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}();
var CombineLatestSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add((0, _subscribeToResult.subscribeToResult)(this, observable, undefined, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) this._tryResultSelector(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function(values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"63kEc","../util/isScheduler":"gX9xK","../util/isArray":"kB1Jq","../OuterSubscriber":"lTBHd","../util/subscribeToResult":"l3R6B","./fromArray":"oYz8C","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lTBHd":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OuterSubscriber", ()=>OuterSubscriber);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var OuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","./Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l3R6B":[function(require,module,exports) {
/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToResult", ()=>subscribeToResult);
var _innerSubscriber = require("../InnerSubscriber");
var _subscribeTo = require("./subscribeTo");
var _observable = require("../Observable");
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) innerSubscriber = new (0, _innerSubscriber.InnerSubscriber)(outerSubscriber, outerValue, outerIndex);
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    return (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
}

},{"../InnerSubscriber":"4auqW","./subscribeTo":"e84Bl","../Observable":"h2K5g","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4auqW":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InnerSubscriber", ()=>InnerSubscriber);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var InnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","./Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e84Bl":[function(require,module,exports) {
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeTo", ()=>subscribeTo);
var _subscribeToArray = require("./subscribeToArray");
var _subscribeToPromise = require("./subscribeToPromise");
var _subscribeToIterable = require("./subscribeToIterable");
var _subscribeToObservable = require("./subscribeToObservable");
var _isArrayLike = require("./isArrayLike");
var _isPromise = require("./isPromise");
var _isObject = require("./isObject");
var _iterator = require("../symbol/iterator");
var _observable = require("../symbol/observable");
var subscribeTo = function(result) {
    if (!!result && typeof result[0, _observable.observable] === "function") return (0, _subscribeToObservable.subscribeToObservable)(result);
    else if ((0, _isArrayLike.isArrayLike)(result)) return (0, _subscribeToArray.subscribeToArray)(result);
    else if ((0, _isPromise.isPromise)(result)) return (0, _subscribeToPromise.subscribeToPromise)(result);
    else if (!!result && typeof result[0, _iterator.iterator] === "function") return (0, _subscribeToIterable.subscribeToIterable)(result);
    else {
        var value = (0, _isObject.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};

},{"./subscribeToArray":"6OHUd","./subscribeToPromise":"6buL9","./subscribeToIterable":"8yAL5","./subscribeToObservable":"tQ5DL","./isArrayLike":"1d2Nn","./isPromise":"6pYW3","./isObject":"9AQRY","../symbol/iterator":"8jPFQ","../symbol/observable":"e76vK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6buL9":[function(require,module,exports) {
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToPromise", ()=>subscribeToPromise);
var _hostReportError = require("./hostReportError");
var subscribeToPromise = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _hostReportError.hostReportError));
        return subscriber;
    };
};

},{"./hostReportError":"8u9Zr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8yAL5":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToIterable", ()=>subscribeToIterable);
var _iterator = require("../symbol/iterator");
var subscribeToIterable = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, _iterator.iterator]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};

},{"../symbol/iterator":"8jPFQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8jPFQ":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
parcelHelpers.export(exports, "$$iterator", ()=>$$iterator);
function getSymbolIterator() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
var $$iterator = iterator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"tQ5DL":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeToObservable", ()=>subscribeToObservable);
var _observable = require("../symbol/observable");
var subscribeToObservable = function(obj) {
    return function(subscriber) {
        var obs = obj[0, _observable.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};

},{"../symbol/observable":"e76vK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1d2Nn":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6pYW3":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
function isPromise(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ir4TZ":[function(require,module,exports) {
/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _of = require("./of");
var _concatAll = require("../operators/concatAll");
function concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return (0, _concatAll.concatAll)()((0, _of.of).apply(void 0, observables));
}

},{"./of":"c99As","../operators/concatAll":"k2ek8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k2ek8":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatAll", ()=>concatAll);
var _mergeAll = require("./mergeAll");
function concatAll() {
    return (0, _mergeAll.mergeAll)(1);
}

},{"./mergeAll":"5iYPq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5iYPq":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", ()=>mergeAll);
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"1AMXt","../util/identity":"1yHSj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1AMXt":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", ()=>mergeMap);
parcelHelpers.export(exports, "MergeMapOperator", ()=>MergeMapOperator);
parcelHelpers.export(exports, "MergeMapSubscriber", ()=>MergeMapSubscriber);
parcelHelpers.export(exports, "flatMap", ()=>flatMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(mergeMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new MergeMapOperator(project, concurrent));
    };
}
var MergeMapOperator = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var MergeMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));
var flatMap = mergeMap;

},{"tslib":"63kEc","./map":"jeswA","../observable/from":"eOpwS","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eOpwS":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _observable = require("../Observable");
var _subscribeTo = require("../util/subscribeTo");
var _scheduled = require("../scheduled/scheduled");
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, _observable.Observable)) return input;
        return new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(input));
    } else return (0, _scheduled.scheduled)(input, scheduler);
}

},{"../Observable":"h2K5g","../util/subscribeTo":"e84Bl","../scheduled/scheduled":"6CsLR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6CsLR":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        else if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        else if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        else if ((0, _isIterable.isIterable)(input) || typeof input === "string") return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

},{"./scheduleObservable":"hxd4G","./schedulePromise":"2P09F","./scheduleArray":"7hWcX","./scheduleIterable":"64dcW","../util/isInteropObservable":"ffETl","../util/isPromise":"6pYW3","../util/isArrayLike":"1d2Nn","../util/isIterable":"dCARk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hxd4G":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _observable1 = require("../symbol/observable");
function scheduleObservable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, _observable1.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"h2K5g","../Subscription":"3awdk","../symbol/observable":"e76vK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2P09F":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function schedulePromise(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}

},{"../Observable":"h2K5g","../Subscription":"3awdk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"64dcW":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _iterator = require("../symbol/iterator");
function scheduleIterable(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, _observable.Observable)(function(subscriber) {
        var sub = new (0, _subscription.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, _iterator.iterator]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

},{"../Observable":"h2K5g","../Subscription":"3awdk","../symbol/iterator":"8jPFQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ffETl":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
function isInteropObservable(input) {
    return input && typeof input[0, _observable.observable] === "function";
}

},{"../symbol/observable":"e76vK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dCARk":[function(require,module,exports) {
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
function isIterable(input) {
    return input && typeof input[0, _iterator.iterator] === "function";
}

},{"../symbol/iterator":"8jPFQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7BFPF":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleInnerSubscriber", ()=>SimpleInnerSubscriber);
parcelHelpers.export(exports, "ComplexInnerSubscriber", ()=>ComplexInnerSubscriber);
parcelHelpers.export(exports, "SimpleOuterSubscriber", ()=>SimpleOuterSubscriber);
parcelHelpers.export(exports, "ComplexOuterSubscriber", ()=>ComplexOuterSubscriber);
parcelHelpers.export(exports, "innerSubscribe", ()=>innerSubscribe);
var _tslib = require("tslib");
var _subscriber = require("./Subscriber");
var _observable = require("./Observable");
var _subscribeTo = require("./util/subscribeTo");
var SimpleInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, _subscriber.Subscriber));
var ComplexInnerSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, _subscriber.Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, _subscriber.Subscriber));
var ComplexOuterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, _subscriber.Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, _observable.Observable)) return result.subscribe(innerSubscriber);
    return (0, _subscribeTo.subscribeTo)(result)(innerSubscriber);
}

},{"tslib":"63kEc","./Subscriber":"dcQ4T","./Observable":"h2K5g","./util/subscribeTo":"e84Bl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gV56M":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defer", ()=>defer);
var _observable = require("../Observable");
var _from = require("./from");
var _empty = require("./empty");
function defer(observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        var input;
        try {
            input = observableFactory();
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? (0, _from.from)(input) : (0, _empty.empty)();
        return source.subscribe(subscriber);
    });
}

},{"../Observable":"h2K5g","./from":"eOpwS","./empty":"dQ7pX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hW3LX":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forkJoin", ()=>forkJoin);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _map = require("../operators/map");
var _isObject = require("../util/isObject");
var _from = require("./from");
function forkJoin() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    if (sources.length === 1) {
        var first_1 = sources[0];
        if ((0, _isArray.isArray)(first_1)) return forkJoinInternal(first_1, null);
        if ((0, _isObject.isObject)(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function(key) {
                return first_1[key];
            }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === "function") {
        var resultSelector_1 = sources.pop();
        sources = sources.length === 1 && (0, _isArray.isArray)(sources[0]) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe((0, _map.map)(function(args) {
            return resultSelector_1.apply(void 0, args);
        }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new (0, _observable.Observable)(function(subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function(i) {
            var source = (0, _from.from)(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function(value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function(err) {
                    return subscriber.error(err);
                },
                complete: function() {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) subscriber.next(keys ? keys.reduce(function(result, key, i) {
                            return result[key] = values[i], result;
                        }, {}) : values);
                        subscriber.complete();
                    }
                }
            }));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
    });
}

},{"../Observable":"h2K5g","../util/isArray":"kB1Jq","../operators/map":"jeswA","../util/isObject":"9AQRY","./from":"eOpwS","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d068Y":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEvent", ()=>fromEvent);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _isFunction = require("../util/isFunction");
var _map = require("../operators/map");
var toString = /*@__PURE__*/ function() {
    return Object.prototype.toString;
}();
function fromEvent(target, eventName, options, resultSelector) {
    if ((0, _isFunction.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return fromEvent(target, eventName, options).pipe((0, _map.map)(function(args) {
        return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
    }));
    return new (0, _observable.Observable)(function(subscriber) {
        function handler(e) {
            if (arguments.length > 1) subscriber.next(Array.prototype.slice.call(arguments));
            else subscriber.next(e);
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function() {
            return source_1.removeEventListener(eventName, handler, options);
        };
    } else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function() {
            return source_2.off(eventName, handler);
        };
    } else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function() {
            return source_3.removeListener(eventName, handler);
        };
    } else if (sourceObj && sourceObj.length) for(var i = 0, len = sourceObj.length; i < len; i++)setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
    else throw new TypeError("Invalid event target");
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === "function" && typeof sourceObj.removeListener === "function";
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === "function" && typeof sourceObj.off === "function";
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === "function" && typeof sourceObj.removeEventListener === "function";
}

},{"../Observable":"h2K5g","../util/isArray":"kB1Jq","../util/isFunction":"1D5el","../operators/map":"jeswA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ljqEC":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEventPattern", ()=>fromEventPattern);
var _observable = require("../Observable");
var _isArray = require("../util/isArray");
var _isFunction = require("../util/isFunction");
var _map = require("../operators/map");
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return fromEventPattern(addHandler, removeHandler).pipe((0, _map.map)(function(args) {
        return (0, _isArray.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
    }));
    return new (0, _observable.Observable)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!(0, _isFunction.isFunction)(removeHandler)) return undefined;
        return function() {
            return removeHandler(handler, retValue);
        };
    });
}

},{"../Observable":"h2K5g","../util/isArray":"kB1Jq","../util/isFunction":"1D5el","../operators/map":"jeswA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6vhfM":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generate", ()=>generate);
var _observable = require("../Observable");
var _identity = require("../util/identity");
var _isScheduler = require("../util/isScheduler");
function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || (0, _identity.identity);
        scheduler = options.scheduler;
    } else if (resultSelectorOrObservable === undefined || (0, _isScheduler.isScheduler)(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = (0, _identity.identity);
        scheduler = resultSelectorOrObservable;
    } else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new (0, _observable.Observable)(function(subscriber) {
        var state = initialState;
        if (scheduler) return scheduler.schedule(dispatch, 0, {
            subscriber: subscriber,
            iterate: iterate,
            condition: condition,
            resultSelector: resultSelector,
            state: state
        });
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                } catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            } catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) break;
            try {
                state = iterate(state);
            } catch (err) {
                subscriber.error(err);
                return undefined;
            }
        }while (true);
        return undefined;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) return undefined;
    if (state.needIterate) try {
        state.state = state.iterate(state.state);
    } catch (err) {
        subscriber.error(err);
        return undefined;
    }
    else state.needIterate = true;
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) return undefined;
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    } catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) return undefined;
    subscriber.next(value);
    if (subscriber.closed) return undefined;
    return this.schedule(state);
}

},{"../Observable":"h2K5g","../util/identity":"1yHSj","../util/isScheduler":"gX9xK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f9IPI":[function(require,module,exports) {
/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iif", ()=>iif);
var _defer = require("./defer");
var _empty = require("./empty");
function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) trueResult = (0, _empty.EMPTY);
    if (falseResult === void 0) falseResult = (0, _empty.EMPTY);
    return (0, _defer.defer)(function() {
        return condition() ? trueResult : falseResult;
    });
}

},{"./defer":"gV56M","./empty":"dQ7pX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5OOkQ":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interval", ()=>interval);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isNumeric = require("../util/isNumeric");
function interval(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, _async.async);
    if (!(0, _isNumeric.isNumeric)(period) || period < 0) period = 0;
    if (!scheduler || typeof scheduler.schedule !== "function") scheduler = (0, _async.async);
    return new (0, _observable.Observable)(function(subscriber) {
        subscriber.add(scheduler.schedule(dispatch, period, {
            subscriber: subscriber,
            counter: 0,
            period: period
        }));
        return subscriber;
    });
}
function dispatch(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({
        subscriber: subscriber,
        counter: counter + 1,
        period: period
    }, period);
}

},{"../Observable":"h2K5g","../scheduler/async":"7s84y","../util/isNumeric":"kEf57","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kEf57":[function(require,module,exports) {
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumeric", ()=>isNumeric);
var _isArray = require("./isArray");
function isNumeric(val) {
    return !(0, _isArray.isArray)(val) && val - parseFloat(val) + 1 >= 0;
}

},{"./isArray":"kB1Jq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4VOM1":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _observable = require("../Observable");
var _isScheduler = require("../util/isScheduler");
var _mergeAll = require("../operators/mergeAll");
var _fromArray = require("./fromArray");
function merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ((0, _isScheduler.isScheduler)(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") concurrent = observables.pop();
    } else if (typeof last === "number") concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof (0, _observable.Observable)) return observables[0];
    return (0, _mergeAll.mergeAll)(concurrent)((0, _fromArray.fromArray)(observables, scheduler));
}

},{"../Observable":"h2K5g","../util/isScheduler":"gX9xK","../operators/mergeAll":"5iYPq","./fromArray":"oYz8C","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"htrvU":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
parcelHelpers.export(exports, "never", ()=>never);
var _observable = require("../Observable");
var _noop = require("../util/noop");
var NEVER = /*@__PURE__*/ new (0, _observable.Observable)((0, _noop.noop));
function never() {
    return NEVER;
}

},{"../Observable":"h2K5g","../util/noop":"imgcq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9iqiO":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
var _observable = require("../Observable");
var _from = require("./from");
var _isArray = require("../util/isArray");
var _empty = require("./empty");
function onErrorResumeNext() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    if (sources.length === 0) return 0, _empty.EMPTY;
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && (0, _isArray.isArray)(first)) return onErrorResumeNext.apply(void 0, first);
    return new (0, _observable.Observable)(function(subscriber) {
        var subNext = function() {
            return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber));
        };
        return (0, _from.from)(first).subscribe({
            next: function(value) {
                subscriber.next(value);
            },
            error: subNext,
            complete: subNext
        });
    });
}

},{"../Observable":"h2K5g","./from":"eOpwS","../util/isArray":"kB1Jq","./empty":"dQ7pX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4ryJ6":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairs", ()=>pairs);
parcelHelpers.export(exports, "dispatch", ()=>dispatch);
var _observable = require("../Observable");
var _subscription = require("../Subscription");
function pairs(obj, scheduler) {
    if (!scheduler) return new (0, _observable.Observable)(function(subscriber) {
        var keys = Object.keys(obj);
        for(var i = 0; i < keys.length && !subscriber.closed; i++){
            var key = keys[i];
            if (obj.hasOwnProperty(key)) subscriber.next([
                key,
                obj[key]
            ]);
        }
        subscriber.complete();
    });
    else return new (0, _observable.Observable)(function(subscriber) {
        var keys = Object.keys(obj);
        var subscription = new (0, _subscription.Subscription)();
        subscription.add(scheduler.schedule(dispatch, 0, {
            keys: keys,
            index: 0,
            subscriber: subscriber,
            subscription: subscription,
            obj: obj
        }));
        return subscription;
    });
}
function dispatch(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([
                key,
                obj[key]
            ]);
            subscription.add(this.schedule({
                keys: keys,
                index: index + 1,
                subscriber: subscriber,
                subscription: subscription,
                obj: obj
            }));
        } else subscriber.complete();
    }
}

},{"../Observable":"h2K5g","../Subscription":"3awdk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8bTur":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
var _not = require("../util/not");
var _subscribeTo = require("../util/subscribeTo");
var _filter = require("../operators/filter");
var _observable = require("../Observable");
function partition(source, predicate, thisArg) {
    return [
        (0, _filter.filter)(predicate, thisArg)(new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(source))),
        (0, _filter.filter)((0, _not.not)(predicate, thisArg))(new (0, _observable.Observable)((0, _subscribeTo.subscribeTo)(source)))
    ];
}

},{"../util/not":"h12eH","../util/subscribeTo":"e84Bl","../operators/filter":"1YsDt","../Observable":"h2K5g","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h12eH":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "not", ()=>not);
function not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1YsDt":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var FilterSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"20v8G":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "race", ()=>race);
parcelHelpers.export(exports, "RaceOperator", ()=>RaceOperator);
parcelHelpers.export(exports, "RaceSubscriber", ()=>RaceSubscriber);
var _tslib = require("tslib");
var _isArray = require("../util/isArray");
var _fromArray = require("./fromArray");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    if (observables.length === 1) {
        if ((0, _isArray.isArray)(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return (0, _fromArray.fromArray)(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
var RaceSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = (0, _subscribeToResult.subscribeToResult)(this, observable, undefined, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"63kEc","../util/isArray":"kB1Jq","./fromArray":"oYz8C","../OuterSubscriber":"lTBHd","../util/subscribeToResult":"l3R6B","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eHNX5":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "dispatch", ()=>dispatch);
var _observable = require("../Observable");
function range(start, count, scheduler) {
    if (start === void 0) start = 0;
    return new (0, _observable.Observable)(function(subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) return scheduler.schedule(dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(current++);
            if (subscriber.closed) break;
        }while (true);
        return undefined;
    });
}
function dispatch(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) return;
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}

},{"../Observable":"h2K5g","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bWaEN":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timer", ()=>timer);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isNumeric = require("../util/isNumeric");
var _isScheduler = require("../util/isScheduler");
function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    var period = -1;
    if ((0, _isNumeric.isNumeric)(periodOrScheduler)) period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    else if ((0, _isScheduler.isScheduler)(periodOrScheduler)) scheduler = periodOrScheduler;
    if (!(0, _isScheduler.isScheduler)(scheduler)) scheduler = (0, _async.async);
    return new (0, _observable.Observable)(function(subscriber) {
        var due = (0, _isNumeric.isNumeric)(dueTime) ? dueTime : +dueTime - scheduler.now();
        return scheduler.schedule(dispatch, due, {
            index: 0,
            period: period,
            subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) return;
    else if (period === -1) return subscriber.complete();
    state.index = index + 1;
    this.schedule(state, period);
}

},{"../Observable":"h2K5g","../scheduler/async":"7s84y","../util/isNumeric":"kEf57","../util/isScheduler":"gX9xK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h1rgw":[function(require,module,exports) {
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "using", ()=>using);
var _observable = require("../Observable");
var _from = require("./from");
var _empty = require("./empty");
function using(resourceFactory, observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? (0, _from.from)(result) : (0, _empty.EMPTY);
        var subscription = source.subscribe(subscriber);
        return function() {
            subscription.unsubscribe();
            if (resource) resource.unsubscribe();
        };
    });
}

},{"../Observable":"h2K5g","./from":"eOpwS","./empty":"dQ7pX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9vE03":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_.._internal_symbol_iterator,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
parcelHelpers.export(exports, "ZipOperator", ()=>ZipOperator);
parcelHelpers.export(exports, "ZipSubscriber", ()=>ZipSubscriber);
var _tslib = require("tslib");
var _fromArray = require("./fromArray");
var _isArray = require("../util/isArray");
var _subscriber = require("../Subscriber");
var _iterator = require("../../internal/symbol/iterator");
var _innerSubscribe = require("../innerSubscribe");
function zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === "function") observables.pop();
    return (0, _fromArray.fromArray)(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ function() {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}();
var ZipSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) values = Object.create(null);
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = typeof resultSelector === "function" ? resultSelector : undefined;
        return _this;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ((0, _isArray.isArray)(value)) iterators.push(new StaticArrayIterator(value));
        else if (typeof value[0, _iterator.iterator] === "function") iterators.push(new StaticIterator(value[0, _iterator.iterator]()));
        else iterators.push(new ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe());
            } else this.active--;
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === "function" && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) this._tryresultSelector(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryresultSelector = function(args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}((0, _subscriber.Subscriber));
var StaticIterator = /*@__PURE__*/ function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
    };
    return StaticIterator;
}();
var StaticArrayIterator = /*@__PURE__*/ function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[0, _iterator.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
var ZipBufferIterator = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[0, _iterator.iterator] = function() {
        return this;
    };
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function() {
        return (0, _innerSubscribe.innerSubscribe)(this.observable, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
    };
    return ZipBufferIterator;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","./fromArray":"oYz8C","../util/isArray":"kB1Jq","../Subscriber":"dcQ4T","../../internal/symbol/iterator":"8jPFQ","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4sw1o":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "flatMap", ()=>(0, _mergeMap.flatMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
var _audit = require("../internal/operators/audit");
var _auditTime = require("../internal/operators/auditTime");
var _buffer = require("../internal/operators/buffer");
var _bufferCount = require("../internal/operators/bufferCount");
var _bufferTime = require("../internal/operators/bufferTime");
var _bufferToggle = require("../internal/operators/bufferToggle");
var _bufferWhen = require("../internal/operators/bufferWhen");
var _catchError = require("../internal/operators/catchError");
var _combineAll = require("../internal/operators/combineAll");
var _combineLatest = require("../internal/operators/combineLatest");
var _concat = require("../internal/operators/concat");
var _concatAll = require("../internal/operators/concatAll");
var _concatMap = require("../internal/operators/concatMap");
var _concatMapTo = require("../internal/operators/concatMapTo");
var _count = require("../internal/operators/count");
var _debounce = require("../internal/operators/debounce");
var _debounceTime = require("../internal/operators/debounceTime");
var _defaultIfEmpty = require("../internal/operators/defaultIfEmpty");
var _delay = require("../internal/operators/delay");
var _delayWhen = require("../internal/operators/delayWhen");
var _dematerialize = require("../internal/operators/dematerialize");
var _distinct = require("../internal/operators/distinct");
var _distinctUntilChanged = require("../internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("../internal/operators/distinctUntilKeyChanged");
var _elementAt = require("../internal/operators/elementAt");
var _endWith = require("../internal/operators/endWith");
var _every = require("../internal/operators/every");
var _exhaust = require("../internal/operators/exhaust");
var _exhaustMap = require("../internal/operators/exhaustMap");
var _expand = require("../internal/operators/expand");
var _filter = require("../internal/operators/filter");
var _finalize = require("../internal/operators/finalize");
var _find = require("../internal/operators/find");
var _findIndex = require("../internal/operators/findIndex");
var _first = require("../internal/operators/first");
var _groupBy = require("../internal/operators/groupBy");
var _ignoreElements = require("../internal/operators/ignoreElements");
var _isEmpty = require("../internal/operators/isEmpty");
var _last = require("../internal/operators/last");
var _map = require("../internal/operators/map");
var _mapTo = require("../internal/operators/mapTo");
var _materialize = require("../internal/operators/materialize");
var _max = require("../internal/operators/max");
var _merge = require("../internal/operators/merge");
var _mergeAll = require("../internal/operators/mergeAll");
var _mergeMap = require("../internal/operators/mergeMap");
var _mergeMapTo = require("../internal/operators/mergeMapTo");
var _mergeScan = require("../internal/operators/mergeScan");
var _min = require("../internal/operators/min");
var _multicast = require("../internal/operators/multicast");
var _observeOn = require("../internal/operators/observeOn");
var _onErrorResumeNext = require("../internal/operators/onErrorResumeNext");
var _pairwise = require("../internal/operators/pairwise");
var _partition = require("../internal/operators/partition");
var _pluck = require("../internal/operators/pluck");
var _publish = require("../internal/operators/publish");
var _publishBehavior = require("../internal/operators/publishBehavior");
var _publishLast = require("../internal/operators/publishLast");
var _publishReplay = require("../internal/operators/publishReplay");
var _race = require("../internal/operators/race");
var _reduce = require("../internal/operators/reduce");
var _repeat = require("../internal/operators/repeat");
var _repeatWhen = require("../internal/operators/repeatWhen");
var _retry = require("../internal/operators/retry");
var _retryWhen = require("../internal/operators/retryWhen");
var _refCount = require("../internal/operators/refCount");
var _sample = require("../internal/operators/sample");
var _sampleTime = require("../internal/operators/sampleTime");
var _scan = require("../internal/operators/scan");
var _sequenceEqual = require("../internal/operators/sequenceEqual");
var _share = require("../internal/operators/share");
var _shareReplay = require("../internal/operators/shareReplay");
var _single = require("../internal/operators/single");
var _skip = require("../internal/operators/skip");
var _skipLast = require("../internal/operators/skipLast");
var _skipUntil = require("../internal/operators/skipUntil");
var _skipWhile = require("../internal/operators/skipWhile");
var _startWith = require("../internal/operators/startWith");
var _subscribeOn = require("../internal/operators/subscribeOn");
var _switchAll = require("../internal/operators/switchAll");
var _switchMap = require("../internal/operators/switchMap");
var _switchMapTo = require("../internal/operators/switchMapTo");
var _take = require("../internal/operators/take");
var _takeLast = require("../internal/operators/takeLast");
var _takeUntil = require("../internal/operators/takeUntil");
var _takeWhile = require("../internal/operators/takeWhile");
var _tap = require("../internal/operators/tap");
var _throttle = require("../internal/operators/throttle");
var _throttleTime = require("../internal/operators/throttleTime");
var _throwIfEmpty = require("../internal/operators/throwIfEmpty");
var _timeInterval = require("../internal/operators/timeInterval");
var _timeout = require("../internal/operators/timeout");
var _timeoutWith = require("../internal/operators/timeoutWith");
var _timestamp = require("../internal/operators/timestamp");
var _toArray = require("../internal/operators/toArray");
var _window = require("../internal/operators/window");
var _windowCount = require("../internal/operators/windowCount");
var _windowTime = require("../internal/operators/windowTime");
var _windowToggle = require("../internal/operators/windowToggle");
var _windowWhen = require("../internal/operators/windowWhen");
var _withLatestFrom = require("../internal/operators/withLatestFrom");
var _zip = require("../internal/operators/zip");
var _zipAll = require("../internal/operators/zipAll");

},{"../internal/operators/audit":"9WWjR","../internal/operators/auditTime":"9ze7I","../internal/operators/buffer":"aO2VE","../internal/operators/bufferCount":"2EuRJ","../internal/operators/bufferTime":"9jFv9","../internal/operators/bufferToggle":"9nqnn","../internal/operators/bufferWhen":"4B9Fx","../internal/operators/catchError":"er5S1","../internal/operators/combineAll":"iOD9R","../internal/operators/combineLatest":"49sYA","../internal/operators/concat":"84pFp","../internal/operators/concatAll":"k2ek8","../internal/operators/concatMap":"fhNq1","../internal/operators/concatMapTo":"18o5S","../internal/operators/count":"dFuH6","../internal/operators/debounce":"erh2o","../internal/operators/debounceTime":"6jQdU","../internal/operators/defaultIfEmpty":"bwCcI","../internal/operators/delay":"78cA9","../internal/operators/delayWhen":"fwC8E","../internal/operators/dematerialize":"bufQK","../internal/operators/distinct":"94nxM","../internal/operators/distinctUntilChanged":"eVNYh","../internal/operators/distinctUntilKeyChanged":"hKRYs","../internal/operators/elementAt":"15Fh6","../internal/operators/endWith":"1fzH5","../internal/operators/every":"1bU0P","../internal/operators/exhaust":"CbycH","../internal/operators/exhaustMap":"hrD1y","../internal/operators/expand":"aCPNC","../internal/operators/filter":"1YsDt","../internal/operators/finalize":"arB3i","../internal/operators/find":"9qOz7","../internal/operators/findIndex":"1K8NE","../internal/operators/first":"ft84A","../internal/operators/groupBy":"hJLCA","../internal/operators/ignoreElements":"2DXEh","../internal/operators/isEmpty":"l3SYJ","../internal/operators/last":"bIKc0","../internal/operators/map":"jeswA","../internal/operators/mapTo":"hr6Zp","../internal/operators/materialize":"341SO","../internal/operators/max":"7yre6","../internal/operators/merge":"a75pc","../internal/operators/mergeAll":"5iYPq","../internal/operators/mergeMap":"1AMXt","../internal/operators/mergeMapTo":"gTnud","../internal/operators/mergeScan":"4ZdbB","../internal/operators/min":"6n1g4","../internal/operators/multicast":"3nDwd","../internal/operators/observeOn":"lN5AD","../internal/operators/onErrorResumeNext":"d1Txg","../internal/operators/pairwise":"hQSgi","../internal/operators/partition":"7HeEq","../internal/operators/pluck":"f2zkp","../internal/operators/publish":"htLKx","../internal/operators/publishBehavior":"i7qtD","../internal/operators/publishLast":"e6Agi","../internal/operators/publishReplay":"jII7P","../internal/operators/race":"eIb29","../internal/operators/reduce":"45fy9","../internal/operators/repeat":"julWP","../internal/operators/repeatWhen":"djP3T","../internal/operators/retry":"k35tj","../internal/operators/retryWhen":"iWfHm","../internal/operators/refCount":"lTFZw","../internal/operators/sample":"797c0","../internal/operators/sampleTime":"eJI1H","../internal/operators/scan":"ajr9m","../internal/operators/sequenceEqual":"3lKpW","../internal/operators/share":"hFPYz","../internal/operators/shareReplay":"3jYOT","../internal/operators/single":"agDXo","../internal/operators/skip":"3X3cx","../internal/operators/skipLast":"7xtYf","../internal/operators/skipUntil":"1VEwS","../internal/operators/skipWhile":"1nDIH","../internal/operators/startWith":"8Ybpz","../internal/operators/subscribeOn":"iO9j5","../internal/operators/switchAll":"4LDZt","../internal/operators/switchMap":"3LtgC","../internal/operators/switchMapTo":"2qL7Y","../internal/operators/take":"9o7mB","../internal/operators/takeLast":"YxyNV","../internal/operators/takeUntil":"5Gdue","../internal/operators/takeWhile":"7P9DO","../internal/operators/tap":"7xwjw","../internal/operators/throttle":"horc0","../internal/operators/throttleTime":"fbtnl","../internal/operators/throwIfEmpty":"6rzEQ","../internal/operators/timeInterval":"2dhZJ","../internal/operators/timeout":"7XnTq","../internal/operators/timeoutWith":"75gBd","../internal/operators/timestamp":"6LPLc","../internal/operators/toArray":"7xQzf","../internal/operators/window":"h8Bjn","../internal/operators/windowCount":"gVPFg","../internal/operators/windowTime":"i3XEk","../internal/operators/windowToggle":"8iAF4","../internal/operators/windowWhen":"2NTLt","../internal/operators/withLatestFrom":"7iiqG","../internal/operators/zip":"dJwrb","../internal/operators/zipAll":"khHbj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9WWjR":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>audit);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
var AuditOperator = /*@__PURE__*/ function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
var AuditSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = void 0;
            try {
                var durationSelector = this.durationSelector;
                duration = durationSelector(value);
            } catch (err) {
                return this.destination.error(err);
            }
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(duration, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
            if (!innerSubscription || innerSubscription.closed) this.clearThrottle();
            else this.add(this.throttled = innerSubscription);
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = undefined;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = undefined;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function() {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9ze7I":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auditTime", ()=>auditTime);
var _async = require("../scheduler/async");
var _audit = require("./audit");
var _timer = require("../observable/timer");
function auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return (0, _audit.audit)(function() {
        return (0, _timer.timer)(duration, scheduler);
    });
}

},{"../scheduler/async":"7s84y","./audit":"9WWjR","../observable/timer":"bWaEN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aO2VE":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buffer", ()=>buffer);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
var BufferOperator = /*@__PURE__*/ function() {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}();
var BufferSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        var _this = _super.call(this, destination) || this;
        _this.buffer = [];
        _this.add((0, _innerSubscribe.innerSubscribe)(closingNotifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(_this)));
        return _this;
    }
    BufferSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function() {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2EuRJ":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferCount", ()=>bufferCount);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
var BufferCountOperator = /*@__PURE__*/ function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = BufferCountSubscriber;
        else this.subscriberClass = BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
var BufferCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.buffer = [];
        return _this;
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}((0, _subscriber.Subscriber));
var BufferSkipCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.startBufferEvery = startBufferEvery;
        _this.buffers = [];
        _this.count = 0;
        return _this;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9jFv9":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferTime", ()=>bufferTime);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _subscriber = require("../Subscriber");
var _isScheduler = require("../util/isScheduler");
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = (0, _async.async);
    if ((0, _isScheduler.isScheduler)(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
var BufferTimeOperator = /*@__PURE__*/ function() {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}();
var Context = /*@__PURE__*/ function() {
    function Context() {
        this.buffer = [];
    }
    return Context;
}();
var BufferTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.bufferTimeSpan = bufferTimeSpan;
        _this.bufferCreationInterval = bufferCreationInterval;
        _this.maxBufferSize = maxBufferSize;
        _this.scheduler = scheduler;
        _this.contexts = [];
        var context = _this.openContext();
        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (_this.timespanOnly) {
            var timeSpanOnlyState = {
                subscriber: _this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        } else {
            var closeState = {
                subscriber: _this,
                context: context
            };
            var creationState = {
                bufferTimeSpan: bufferTimeSpan,
                bufferCreationInterval: bufferCreationInterval,
                subscriber: _this,
                scheduler: scheduler
            };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
        return _this;
    }
    BufferTimeSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for(var i = 0; i < len; i++){
            var context_1 = contexts[i];
            var buffer = context_1.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) filledBufferContext = context_1;
        }
        if (filledBufferContext) this.onBufferFull(filledBufferContext);
    };
    BufferTimeSubscriber.prototype._error = function(err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function() {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while(contexts.length > 0){
            var context_2 = contexts.shift();
            destination.next(context_2.buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferTimeSubscriber.prototype._unsubscribe = function() {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function(context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function() {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function(context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) contexts.splice(contexts.indexOf(context), 1);
    };
    return BufferTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) subscriber.closeContext(prevContext);
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, {
            subscriber: subscriber,
            context: context
        }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}

},{"tslib":"63kEc","../scheduler/async":"7s84y","../Subscriber":"dcQ4T","../util/isScheduler":"gX9xK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9nqnn":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferToggle", ()=>bufferToggle);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _subscribeToResult = require("../util/subscribeToResult");
var _outerSubscriber = require("../OuterSubscriber");
function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
var BufferToggleOperator = /*@__PURE__*/ function() {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}();
var BufferToggleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add((0, _subscribeToResult.subscribeToResult)(_this, openings));
        return _this;
    }
    BufferToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for(var i = 0; i < len; i++)contexts[i].buffer.push(value);
    };
    BufferToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context_1 = contexts.shift();
            context_1.subscription.unsubscribe();
            context_1.buffer = null;
            context_1.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context_2 = contexts.shift();
            this.destination.next(context_2.buffer);
            context_2.subscription.unsubscribe();
            context_2.buffer = null;
            context_2.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function(innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function(value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) this.trySubscribe(closingNotifier);
        } catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function(context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function(closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new (0, _subscription.Subscription)();
        var context = {
            buffer: buffer,
            subscription: subscription
        };
        contexts.push(context);
        var innerSubscription = (0, _subscribeToResult.subscribeToResult)(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) this.closeBuffer(context);
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"63kEc","../Subscription":"3awdk","../util/subscribeToResult":"l3R6B","../OuterSubscriber":"lTBHd","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4B9Fx":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscription,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferWhen", ()=>bufferWhen);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _innerSubscribe = require("../innerSubscribe");
function bufferWhen(closingSelector) {
    return function(source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
var BufferWhenOperator = /*@__PURE__*/ function() {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}();
var BufferWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.subscribing = false;
        _this.openBuffer();
        return _this;
    }
    BufferWhenSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function() {
        this.buffer = undefined;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function() {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function() {
        if (this.subscribing) this.complete();
        else this.openBuffer();
    };
    BufferWhenSubscriber.prototype.openBuffer = function() {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) this.destination.next(buffer);
        this.buffer = [];
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        } catch (err) {
            return this.error(err);
        }
        closingSubscription = new (0, _subscription.Subscription)();
        this.closingSubscription = closingSubscription;
        this.add(closingSubscription);
        this.subscribing = true;
        closingSubscription.add((0, _innerSubscribe.innerSubscribe)(closingNotifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
        this.subscribing = false;
    };
    return BufferWhenSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../Subscription":"3awdk","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"er5S1":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
var CatchOperator = /*@__PURE__*/ function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
var CatchSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            this.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) this.add(innerSubscription);
        }
    };
    return CatchSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iOD9R":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineAll", ()=>combineAll);
var _combineLatest = require("../observable/combineLatest");
function combineAll(project) {
    return function(source) {
        return source.lift(new (0, _combineLatest.CombineLatestOperator)(project));
    };
}

},{"../observable/combineLatest":"k43Wc","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"49sYA":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
var _isArray = require("../util/isArray");
var _combineLatest = require("../observable/combineLatest");
var _from = require("../observable/from");
var none = {};
function combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === "function") project = observables.pop();
    if (observables.length === 1 && (0, _isArray.isArray)(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call((0, _from.from)([
            source
        ].concat(observables)), new (0, _combineLatest.CombineLatestOperator)(project));
    };
}

},{"../util/isArray":"kB1Jq","../observable/combineLatest":"k43Wc","../observable/from":"eOpwS","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"84pFp":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _concat = require("../observable/concat");
function concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function(source) {
        return source.lift.call((0, _concat.concat).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../observable/concat":"ir4TZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fhNq1":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMap", ()=>concatMap);
var _mergeMap = require("./mergeMap");
function concatMap(project, resultSelector) {
    return (0, _mergeMap.mergeMap)(project, resultSelector, 1);
}

},{"./mergeMap":"1AMXt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"18o5S":[function(require,module,exports) {
/** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMapTo", ()=>concatMapTo);
var _concatMap = require("./concatMap");
function concatMapTo(innerObservable, resultSelector) {
    return (0, _concatMap.concatMap)(function() {
        return innerObservable;
    }, resultSelector);
}

},{"./concatMap":"fhNq1","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dFuH6":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "count", ()=>count);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
var CountOperator = /*@__PURE__*/ function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
var CountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.count = 0;
        _this.index = 0;
        return _this;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"erh2o":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function debounce(durationSelector) {
    return function(source) {
        return source.lift(new DebounceOperator(durationSelector));
    };
}
var DebounceOperator = /*@__PURE__*/ function() {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}();
var DebounceSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    DebounceSubscriber.prototype._next = function(value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) this._tryNext(value, result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function() {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function(value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = (0, _innerSubscribe.innerSubscribe)(duration, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
        if (subscription && !subscription.closed) this.add(this.durationSubscription = subscription);
    };
    DebounceSubscriber.prototype.notifyNext = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = undefined;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = undefined;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6jQdU":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounceTime", ()=>debounceTime);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _async = require("../scheduler/async");
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        return source.lift(new DebounceTimeOperator(dueTime, scheduler));
    };
}
var DebounceTimeOperator = /*@__PURE__*/ function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
var DebounceTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.dueTime = dueTime;
        _this.scheduler = scheduler;
        _this.debouncedSubscription = null;
        _this.lastValue = null;
        _this.hasValue = false;
        return _this;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            var lastValue = this.lastValue;
            this.lastValue = null;
            this.hasValue = false;
            this.destination.next(lastValue);
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../scheduler/async":"7s84y","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bwCcI":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultIfEmpty", ()=>defaultIfEmpty);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new DefaultIfEmptyOperator(defaultValue));
    };
}
var DefaultIfEmptyOperator = /*@__PURE__*/ function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
var DefaultIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"78cA9":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    var absoluteDelay = (0, _isDate.isDate)(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
var DelayOperator = /*@__PURE__*/ function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
var DelaySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification((0, _notification.Notification).createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification((0, _notification.Notification).createComplete());
        this.unsubscribe();
    };
    return DelaySubscriber;
}((0, _subscriber.Subscriber));
var DelayMessage = /*@__PURE__*/ function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

},{"tslib":"63kEc","../scheduler/async":"7s84y","../util/isDate":"jvPSV","../Subscriber":"dcQ4T","../Notification":"cMrt4","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jvPSV":[function(require,module,exports) {
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", ()=>isDate);
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fwC8E":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delayWhen", ()=>delayWhen);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _observable = require("../Observable");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new SubscriptionDelayObservable(source, subscriptionDelay).lift(new DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new DelayWhenOperator(delayDurationSelector));
    };
}
var DelayWhenOperator = /*@__PURE__*/ function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
var DelayWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.delayDurationSelector = delayDurationSelector;
        _this.completed = false;
        _this.delayNotifierSubscriptions = [];
        _this.index = 0;
        return _this;
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        var index = this.index++;
        try {
            var delayNotifier = this.delayDurationSelector(value, index);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
        this.unsubscribe();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        if (subscriptionIdx !== -1) this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
        return subscription.outerValue;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = (0, _subscribeToResult.subscribeToResult)(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            var destination = this.destination;
            destination.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}((0, _outerSubscriber.OuterSubscriber));
var SubscriptionDelayObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subscriptionDelay = subscriptionDelay;
        return _this;
    }
    SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}((0, _observable.Observable));
var SubscriptionDelaySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.source = source;
        _this.sourceSubscribed = false;
        return _this;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.unsubscribe();
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../Observable":"h2K5g","../OuterSubscriber":"lTBHd","../util/subscribeToResult":"l3R6B","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bufQK":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dematerialize", ()=>dematerialize);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
var DeMaterializeOperator = /*@__PURE__*/ function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
var DeMaterializeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"94nxM":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinct", ()=>distinct);
parcelHelpers.export(exports, "DistinctSubscriber", ()=>DistinctSubscriber);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new DistinctOperator(keySelector, flushes));
    };
}
var DistinctOperator = /*@__PURE__*/ function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
var DistinctSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.values = new Set();
        if (flushes) _this.add((0, _innerSubscribe.innerSubscribe)(flushes, new (0, _innerSubscribe.SimpleInnerSubscriber)(_this)));
        return _this;
    }
    DistinctSubscriber.prototype.notifyNext = function() {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eVNYh":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilChanged", ()=>distinctUntilChanged);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new DistinctUntilChangedOperator(compare, keySelector));
    };
}
var DistinctUntilChangedOperator = /*@__PURE__*/ function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
var DistinctUntilChangedSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === "function") _this.compare = compare;
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var key;
        try {
            var keySelector = this.keySelector;
            key = keySelector ? keySelector(value) : value;
        } catch (err) {
            return this.destination.error(err);
        }
        var result = false;
        if (this.hasKey) try {
            var compare = this.compare;
            result = compare(this.key, key);
        } catch (err) {
            return this.destination.error(err);
        }
        else this.hasKey = true;
        if (!result) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hKRYs":[function(require,module,exports) {
/** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>distinctUntilKeyChanged);
var _distinctUntilChanged = require("./distinctUntilChanged");
function distinctUntilKeyChanged(key, compare) {
    return (0, _distinctUntilChanged.distinctUntilChanged)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}

},{"./distinctUntilChanged":"eVNYh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"15Fh6":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elementAt", ()=>elementAt);
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _filter = require("./filter");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _take = require("./take");
function elementAt(index, defaultValue) {
    if (index < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe((0, _filter.filter)(function(v, i) {
            return i === index;
        }), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
        }));
    };
}

},{"../util/ArgumentOutOfRangeError":"4XnVL","./filter":"1YsDt","./throwIfEmpty":"6rzEQ","./defaultIfEmpty":"bwCcI","./take":"9o7mB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6rzEQ":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwIfEmpty", ()=>throwIfEmpty);
var _tslib = require("tslib");
var _emptyError = require("../util/EmptyError");
var _subscriber = require("../Subscriber");
function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) errorFactory = defaultErrorFactory;
    return function(source) {
        return source.lift(new ThrowIfEmptyOperator(errorFactory));
    };
}
var ThrowIfEmptyOperator = /*@__PURE__*/ function() {
    function ThrowIfEmptyOperator(errorFactory) {
        this.errorFactory = errorFactory;
    }
    ThrowIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ThrowIfEmptySubscriber(subscriber, this.errorFactory));
    };
    return ThrowIfEmptyOperator;
}();
var ThrowIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ThrowIfEmptySubscriber, _super);
    function ThrowIfEmptySubscriber(destination, errorFactory) {
        var _this = _super.call(this, destination) || this;
        _this.errorFactory = errorFactory;
        _this.hasValue = false;
        return _this;
    }
    ThrowIfEmptySubscriber.prototype._next = function(value) {
        this.hasValue = true;
        this.destination.next(value);
    };
    ThrowIfEmptySubscriber.prototype._complete = function() {
        if (!this.hasValue) {
            var err = void 0;
            try {
                err = this.errorFactory();
            } catch (e) {
                err = e;
            }
            this.destination.error(err);
        } else return this.destination.complete();
    };
    return ThrowIfEmptySubscriber;
}((0, _subscriber.Subscriber));
function defaultErrorFactory() {
    return new (0, _emptyError.EmptyError)();
}

},{"tslib":"63kEc","../util/EmptyError":"kS4dn","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9o7mB":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "take", ()=>take);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _empty = require("../observable/empty");
function take(count) {
    return function(source) {
        if (count === 0) return (0, _empty.empty)();
        else return source.lift(new TakeOperator(count));
    };
}
var TakeOperator = /*@__PURE__*/ function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
var TakeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../util/ArgumentOutOfRangeError":"4XnVL","../observable/empty":"dQ7pX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1fzH5":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_concat,_observable_of PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "endWith", ()=>endWith);
var _concat = require("../observable/concat");
var _of = require("../observable/of");
function endWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
    return function(source) {
        return (0, _concat.concat)(source, (0, _of.of).apply(void 0, array));
    };
}

},{"../observable/concat":"ir4TZ","../observable/of":"c99As","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1bU0P":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "every", ()=>every);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function every(predicate, thisArg) {
    return function(source) {
        return source.lift(new EveryOperator(predicate, thisArg, source));
    };
}
var EveryOperator = /*@__PURE__*/ function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
var EverySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.source = source;
        _this.index = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"CbycH":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaust", ()=>exhaust);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function exhaust() {
    return function(source) {
        return source.lift(new SwitchFirstOperator());
    };
}
var SwitchFirstOperator = /*@__PURE__*/ function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
var SwitchFirstSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasCompleted = false;
        _this.hasSubscription = false;
        return _this;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add((0, _innerSubscribe.innerSubscribe)(value, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function() {
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hrD1y":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaustMap", ()=>exhaustMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function exhaustMap(project, resultSelector) {
    if (resultSelector) return function(source) {
        return source.pipe(exhaustMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new ExhaustMapOperator(project));
    };
}
var ExhaustMapOperator = /*@__PURE__*/ function() {
    function ExhaustMapOperator(project) {
        this.project = project;
    }
    ExhaustMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ExhaustMapSubscriber(subscriber, this.project));
    };
    return ExhaustMapOperator;
}();
var ExhaustMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ExhaustMapSubscriber, _super);
    function ExhaustMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.hasSubscription = false;
        _this.hasCompleted = false;
        _this.index = 0;
        return _this;
    }
    ExhaustMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    ExhaustMapSubscriber.prototype.tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.hasSubscription = true;
        this._innerSub(result);
    };
    ExhaustMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    ExhaustMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
        this.unsubscribe();
    };
    ExhaustMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    ExhaustMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    ExhaustMapSubscriber.prototype.notifyComplete = function() {
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return ExhaustMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","./map":"jeswA","../observable/from":"eOpwS","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aCPNC":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expand", ()=>expand);
parcelHelpers.export(exports, "ExpandOperator", ()=>ExpandOperator);
parcelHelpers.export(exports, "ExpandSubscriber", ()=>ExpandSubscriber);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new ExpandOperator(project, concurrent, scheduler));
    };
}
var ExpandOperator = /*@__PURE__*/ function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
var ExpandSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.scheduler = scheduler;
        _this.index = 0;
        _this.active = 0;
        _this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) _this.buffer = [];
        return _this;
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            try {
                var project = this.project;
                var result = project(value, index);
                if (!this.scheduler) this.subscribeToProjection(result, value, index);
                else {
                    var state = {
                        subscriber: this,
                        result: result,
                        value: value,
                        index: index
                    };
                    var destination_1 = this.destination;
                    destination_1.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
                }
            } catch (e) {
                destination.error(e);
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        var destination = this.destination;
        destination.add((0, _innerSubscribe.innerSubscribe)(result, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
        this.unsubscribe();
    };
    ExpandSubscriber.prototype.notifyNext = function(innerValue) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"arB3i":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "finalize", ()=>finalize);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _subscription = require("../Subscription");
function finalize(callback) {
    return function(source) {
        return source.lift(new FinallyOperator(callback));
    };
}
var FinallyOperator = /*@__PURE__*/ function() {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}();
var FinallySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        var _this = _super.call(this, destination) || this;
        _this.add(new (0, _subscription.Subscription)(callback));
        return _this;
    }
    return FinallySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../Subscription":"3awdk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9qOz7":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "find", ()=>find);
parcelHelpers.export(exports, "FindValueOperator", ()=>FindValueOperator);
parcelHelpers.export(exports, "FindValueSubscriber", ()=>FindValueSubscriber);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function find(predicate, thisArg) {
    if (typeof predicate !== "function") throw new TypeError("predicate is not a function");
    return function(source) {
        return source.lift(new FindValueOperator(predicate, source, false, thisArg));
    };
}
var FindValueOperator = /*@__PURE__*/ function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
var FindValueSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.yieldIndex = yieldIndex;
        _this.thisArg = thisArg;
        _this.index = 0;
        return _this;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
        this.unsubscribe();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1K8NE":[function(require,module,exports) {
/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findIndex", ()=>findIndex);
var _find = require("../operators/find");
function findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new (0, _find.FindValueOperator)(predicate, source, true, thisArg));
    };
}

},{"../operators/find":"9qOz7","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ft84A":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "first", ()=>first);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _take = require("./take");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _throwIfEmpty = require("./throwIfEmpty");
var _identity = require("../util/identity");
function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"kS4dn","./filter":"1YsDt","./take":"9o7mB","./defaultIfEmpty":"bwCcI","./throwIfEmpty":"6rzEQ","../util/identity":"1yHSj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2DXEh":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ignoreElements", ()=>ignoreElements);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
var IgnoreElementsOperator = /*@__PURE__*/ function() {
    function IgnoreElementsOperator() {}
    IgnoreElementsOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}();
var IgnoreElementsSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IgnoreElementsSubscriber.prototype._next = function(unused) {};
    return IgnoreElementsSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l3SYJ":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function isEmpty() {
    return function(source) {
        return source.lift(new IsEmptyOperator());
    };
}
var IsEmptyOperator = /*@__PURE__*/ function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
var IsEmptySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bIKc0":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "last", ()=>last);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _takeLast = require("./takeLast");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _identity = require("../util/identity");
function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _takeLast.takeLast)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"kS4dn","./filter":"1YsDt","./takeLast":"YxyNV","./throwIfEmpty":"6rzEQ","./defaultIfEmpty":"bwCcI","../util/identity":"1yHSj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"YxyNV":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeLast", ()=>takeLast);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _empty = require("../observable/empty");
function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return (0, _empty.empty)();
        else return source.lift(new TakeLastOperator(count));
    };
}
var TakeLastOperator = /*@__PURE__*/ function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
var TakeLastSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.ring = new Array();
        _this.count = 0;
        return _this;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../util/ArgumentOutOfRangeError":"4XnVL","../observable/empty":"dQ7pX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hr6Zp":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapTo", ()=>mapTo);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function mapTo(value) {
    return function(source) {
        return source.lift(new MapToOperator(value));
    };
}
var MapToOperator = /*@__PURE__*/ function() {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}();
var MapToSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        var _this = _super.call(this, destination) || this;
        _this.value = value;
        return _this;
    }
    MapToSubscriber.prototype._next = function(x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"341SO":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "materialize", ()=>materialize);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _notification = require("../Notification");
function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
var MaterializeOperator = /*@__PURE__*/ function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
var MaterializeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next((0, _notification.Notification).createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next((0, _notification.Notification).createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next((0, _notification.Notification).createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../Notification":"cMrt4","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7yre6":[function(require,module,exports) {
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
var _reduce = require("./reduce");
function max(comparer) {
    var max = typeof comparer === "function" ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return (0, _reduce.reduce)(max);
}

},{"./reduce":"45fy9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"45fy9":[function(require,module,exports) {
/** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _scan = require("./scan");
var _takeLast = require("./takeLast");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _pipe = require("../util/pipe");
function reduce(accumulator, seed) {
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return (0, _pipe.pipe)((0, _scan.scan)(accumulator, seed), (0, _takeLast.takeLast)(1), (0, _defaultIfEmpty.defaultIfEmpty)(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return (0, _pipe.pipe)((0, _scan.scan)(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), (0, _takeLast.takeLast)(1))(source);
    };
}

},{"./scan":"ajr9m","./takeLast":"YxyNV","./defaultIfEmpty":"bwCcI","../util/pipe":"4SsWQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ajr9m":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scan", ()=>scan);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function scan(accumulator, seed) {
    var hasSeed = false;
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
var ScanOperator = /*@__PURE__*/ function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
var ScanSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this._seed = _seed;
        _this.hasSeed = hasSeed;
        _this.index = 0;
        return _this;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a75pc":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _merge = require("../observable/merge");
function merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function(source) {
        return source.lift.call((0, _merge.merge).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../observable/merge":"4VOM1","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gTnud":[function(require,module,exports) {
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMapTo", ()=>mergeMapTo);
var _mergeMap = require("./mergeMap");
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, resultSelector, concurrent);
    if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, concurrent);
}

},{"./mergeMap":"1AMXt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4ZdbB":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeScan", ()=>mergeScan);
parcelHelpers.export(exports, "MergeScanOperator", ()=>MergeScanOperator);
parcelHelpers.export(exports, "MergeScanSubscriber", ()=>MergeScanSubscriber);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new MergeScanOperator(accumulator, seed, concurrent));
    };
}
var MergeScanOperator = /*@__PURE__*/ function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
var MergeScanSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this.acc = acc;
        _this.concurrent = concurrent;
        _this.hasValue = false;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var destination = this.destination;
            var ish = void 0;
            try {
                var accumulator = this.accumulator;
                ish = accumulator(this.acc, value, index);
            } catch (e) {
                return destination.error(e);
            }
            this.active++;
            this._innerSub(ish);
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeScanSubscriber.prototype.notifyNext = function(innerValue) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6n1g4":[function(require,module,exports) {
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "min", ()=>min);
var _reduce = require("./reduce");
function min(comparer) {
    var min = typeof comparer === "function" ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return (0, _reduce.reduce)(min);
}

},{"./reduce":"45fy9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3nDwd":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multicast", ()=>multicast);
parcelHelpers.export(exports, "MulticastOperator", ()=>MulticastOperator);
var _connectableObservable = require("../observable/ConnectableObservable");
function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === "function") subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === "function") return source.lift(new MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, (0, _connectableObservable.connectableObservableDescriptor));
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
var MulticastOperator = /*@__PURE__*/ function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();

},{"../observable/ConnectableObservable":"dhOs3","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d1Txg":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
parcelHelpers.export(exports, "onErrorResumeNextStatic", ()=>onErrorResumeNextStatic);
var _tslib = require("tslib");
var _from = require("../observable/from");
var _isArray = require("../util/isArray");
var _innerSubscribe = require("../innerSubscribe");
function onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i] = arguments[_i];
    if (nextSources.length === 1 && (0, _isArray.isArray)(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new OnErrorResumeNextOperator(nextSources));
    };
}
function onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i] = arguments[_i];
    var source = undefined;
    if (nextSources.length === 1 && (0, _isArray.isArray)(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return (0, _from.from)(source).lift(new OnErrorResumeNextOperator(nextSources));
}
var OnErrorResumeNextOperator = /*@__PURE__*/ function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var OnErrorResumeNextSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.nextSources = nextSources;
        return _this;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
        this.unsubscribe();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (!!next) {
            var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
            var destination = this.destination;
            destination.add(innerSubscriber);
            var innerSubscription = (0, _innerSubscribe.innerSubscribe)(next, innerSubscriber);
            if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
        } else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../observable/from":"eOpwS","../util/isArray":"kB1Jq","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hQSgi":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairwise", ()=>pairwise);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function pairwise() {
    return function(source) {
        return source.lift(new PairwiseOperator());
    };
}
var PairwiseOperator = /*@__PURE__*/ function() {
    function PairwiseOperator() {}
    PairwiseOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}();
var PairwiseSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasPrev = false;
        return _this;
    }
    PairwiseSubscriber.prototype._next = function(value) {
        var pair;
        if (this.hasPrev) pair = [
            this.prev,
            value
        ];
        else this.hasPrev = true;
        this.prev = value;
        if (pair) this.destination.next(pair);
    };
    return PairwiseSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7HeEq":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
var _not = require("../util/not");
var _filter = require("./filter");
function partition(predicate, thisArg) {
    return function(source) {
        return [
            (0, _filter.filter)(predicate, thisArg)(source),
            (0, _filter.filter)((0, _not.not)(predicate, thisArg))(source)
        ];
    };
}

},{"../util/not":"h12eH","./filter":"1YsDt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f2zkp":[function(require,module,exports) {
/** PURE_IMPORTS_START _map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pluck", ()=>pluck);
var _map = require("./map");
function pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error("list of properties cannot be empty.");
    return function(source) {
        return (0, _map.map)(plucker(properties, length))(source);
    };
}
function plucker(props, length) {
    var mapper = function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp != null ? currentProp[props[i]] : undefined;
            if (p !== void 0) currentProp = p;
            else return undefined;
        }
        return currentProp;
    };
    return mapper;
}

},{"./map":"jeswA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"htLKx":[function(require,module,exports) {
/** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publish", ()=>publish);
var _subject = require("../Subject");
var _multicast = require("./multicast");
function publish(selector) {
    return selector ? (0, _multicast.multicast)(function() {
        return new (0, _subject.Subject)();
    }, selector) : (0, _multicast.multicast)(new (0, _subject.Subject)());
}

},{"../Subject":"inyPN","./multicast":"3nDwd","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"i7qtD":[function(require,module,exports) {
/** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishBehavior", ()=>publishBehavior);
var _behaviorSubject = require("../BehaviorSubject");
var _multicast = require("./multicast");
function publishBehavior(value) {
    return function(source) {
        return (0, _multicast.multicast)(new (0, _behaviorSubject.BehaviorSubject)(value))(source);
    };
}

},{"../BehaviorSubject":"kJBa4","./multicast":"3nDwd","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e6Agi":[function(require,module,exports) {
/** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishLast", ()=>publishLast);
var _asyncSubject = require("../AsyncSubject");
var _multicast = require("./multicast");
function publishLast() {
    return function(source) {
        return (0, _multicast.multicast)(new (0, _asyncSubject.AsyncSubject)())(source);
    };
}

},{"../AsyncSubject":"2yZ36","./multicast":"3nDwd","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jII7P":[function(require,module,exports) {
/** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishReplay", ()=>publishReplay);
var _replaySubject = require("../ReplaySubject");
var _multicast = require("./multicast");
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== "function") scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === "function" ? selectorOrScheduler : undefined;
    var subject = new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, scheduler);
    return function(source) {
        return (0, _multicast.multicast)(function() {
            return subject;
        }, selector)(source);
    };
}

},{"../ReplaySubject":"l8z3l","./multicast":"3nDwd","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eIb29":[function(require,module,exports) {
/** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "race", ()=>race);
var _isArray = require("../util/isArray");
var _race = require("../observable/race");
function race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function raceOperatorFunction(source) {
        if (observables.length === 1 && (0, _isArray.isArray)(observables[0])) observables = observables[0];
        return source.lift.call((0, _race.race).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../util/isArray":"kB1Jq","../observable/race":"20v8G","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"julWP":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeat", ()=>repeat);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _empty = require("../observable/empty");
function repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return (0, _empty.empty)();
        else if (count < 0) return source.lift(new RepeatOperator(-1, source));
        else return source.lift(new RepeatOperator(count - 1, source));
    };
}
var RepeatOperator = /*@__PURE__*/ function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
var RepeatSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../observable/empty":"dQ7pX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"djP3T":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeatWhen", ()=>repeatWhen);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _innerSubscribe = require("../innerSubscribe");
function repeatWhen(notifier) {
    return function(source) {
        return source.lift(new RepeatWhenOperator(notifier));
    };
}
var RepeatWhenOperator = /*@__PURE__*/ function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
var RepeatWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        _this.sourceIsBeingSubscribedTo = true;
        return _this;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function() {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function() {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next(undefined);
        }
    };
    RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = undefined;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = undefined;
        }
        this.retries = undefined;
    };
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this._unsubscribe = _unsubscribe;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new (0, _subject.Subject)();
        var retries;
        try {
            var notifier = this.notifier;
            retries = notifier(this.notifications);
        } catch (e) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = (0, _innerSubscribe.innerSubscribe)(retries, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
    };
    return RepeatWhenSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../Subject":"inyPN","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k35tj":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retry", ()=>retry);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function retry(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new RetryOperator(count, source));
    };
}
var RetryOperator = /*@__PURE__*/ function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
var RetrySubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iWfHm":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryWhen", ()=>retryWhen);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _innerSubscribe = require("../innerSubscribe");
function retryWhen(notifier) {
    return function(source) {
        return source.lift(new RetryWhenOperator(notifier, source));
    };
}
var RetryWhenOperator = /*@__PURE__*/ function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
var RetryWhenSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        return _this;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new (0, _subject.Subject)();
                try {
                    var notifier = this.notifier;
                    retries = notifier(errors);
                } catch (e) {
                    return _super.prototype.error.call(this, e);
                }
                retriesSubscription = (0, _innerSubscribe.innerSubscribe)(retries, new (0, _innerSubscribe.SimpleInnerSubscriber)(this));
            } else {
                this.errors = undefined;
                this.retriesSubscription = undefined;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = undefined;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = undefined;
        }
        this.retries = undefined;
    };
    RetryWhenSubscriber.prototype.notifyNext = function() {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        this._unsubscribeAndRecycle();
        this._unsubscribe = _unsubscribe;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../Subject":"inyPN","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"797c0":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sample", ()=>sample);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function sample(notifier) {
    return function(source) {
        return source.lift(new SampleOperator(notifier));
    };
}
var SampleOperator = /*@__PURE__*/ function() {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function(subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add((0, _innerSubscribe.innerSubscribe)(this.notifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(sampleSubscriber)));
        return subscription;
    };
    return SampleOperator;
}();
var SampleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasValue = false;
        return _this;
    }
    SampleSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eJI1H":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sampleTime", ()=>sampleTime);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _async = require("../scheduler/async");
function sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        return source.lift(new SampleTimeOperator(period, scheduler));
    };
}
var SampleTimeOperator = /*@__PURE__*/ function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
var SampleTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.period = period;
        _this.scheduler = scheduler;
        _this.hasValue = false;
        _this.add(scheduler.schedule(dispatchNotification, period, {
            subscriber: _this,
            period: period
        }));
        return _this;
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../scheduler/async":"7s84y","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3lKpW":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sequenceEqual", ()=>sequenceEqual);
parcelHelpers.export(exports, "SequenceEqualOperator", ()=>SequenceEqualOperator);
parcelHelpers.export(exports, "SequenceEqualSubscriber", ()=>SequenceEqualSubscriber);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function sequenceEqual(compareTo, comparator) {
    return function(source) {
        return source.lift(new SequenceEqualOperator(compareTo, comparator));
    };
}
var SequenceEqualOperator = /*@__PURE__*/ function() {
    function SequenceEqualOperator(compareTo, comparator) {
        this.compareTo = compareTo;
        this.comparator = comparator;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparator));
    };
    return SequenceEqualOperator;
}();
var SequenceEqualSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparator) {
        var _this = _super.call(this, destination) || this;
        _this.compareTo = compareTo;
        _this.comparator = comparator;
        _this._a = [];
        _this._b = [];
        _this._oneComplete = false;
        _this.destination.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, _this)));
        return _this;
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
        this.unsubscribe();
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparator = _c.comparator;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            try {
                areEqual = comparator ? comparator(a, b) : a === b;
            } catch (e) {
                this.destination.error(e);
            }
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype.completeB = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    return SequenceEqualSubscriber;
}((0, _subscriber.Subscriber));
var SequenceEqualCompareToSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        return _this;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
        this.unsubscribe();
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent.completeB();
        this.unsubscribe();
    };
    return SequenceEqualCompareToSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hFPYz":[function(require,module,exports) {
/** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "share", ()=>share);
var _multicast = require("./multicast");
var _refCount = require("./refCount");
var _subject = require("../Subject");
function shareSubjectFactory() {
    return new (0, _subject.Subject)();
}
function share() {
    return function(source) {
        return (0, _refCount.refCount)()((0, _multicast.multicast)(shareSubjectFactory)(source));
    };
}

},{"./multicast":"3nDwd","./refCount":"lTFZw","../Subject":"inyPN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3jYOT":[function(require,module,exports) {
/** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shareReplay", ()=>shareReplay);
var _replaySubject = require("../ReplaySubject");
function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var config;
    if (configOrBufferSize && typeof configOrBufferSize === "object") config = configOrBufferSize;
    else config = {
        bufferSize: configOrBufferSize,
        windowTime: windowTime,
        refCount: false,
        scheduler: scheduler
    };
    return function(source) {
        return source.lift(shareReplayOperator(config));
    };
}
function shareReplayOperator(_a) {
    var _b = _a.bufferSize, bufferSize = _b === void 0 ? Number.POSITIVE_INFINITY : _b, _c = _a.windowTime, windowTime = _c === void 0 ? Number.POSITIVE_INFINITY : _c, useRefCount = _a.refCount, scheduler = _a.scheduler;
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        var innerSub;
        if (!subject || hasError) {
            hasError = false;
            subject = new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, scheduler);
            innerSub = subject.subscribe(this);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subscription = undefined;
                    subject.complete();
                }
            });
        } else innerSub = subject.subscribe(this);
        this.add(function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && !isComplete && useRefCount && refCount === 0) {
                subscription.unsubscribe();
                subscription = undefined;
                subject = undefined;
            }
        });
    };
}

},{"../ReplaySubject":"l8z3l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"agDXo":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "single", ()=>single);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _emptyError = require("../util/EmptyError");
function single(predicate) {
    return function(source) {
        return source.lift(new SingleOperator(predicate, source));
    };
}
var SingleOperator = /*@__PURE__*/ function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
var SingleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.seenValue = false;
        _this.index = 0;
        return _this;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error("Sequence contains more than one element");
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new (0, _emptyError.EmptyError));
    };
    return SingleSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../util/EmptyError":"kS4dn","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3X3cx":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skip", ()=>skip);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function skip(count) {
    return function(source) {
        return source.lift(new SkipOperator(count));
    };
}
var SkipOperator = /*@__PURE__*/ function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
var SkipSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7xtYf":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipLast", ()=>skipLast);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
function skipLast(count) {
    return function(source) {
        return source.lift(new SkipLastOperator(count));
    };
}
var SkipLastOperator = /*@__PURE__*/ function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError);
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) return source.subscribe(new (0, _subscriber.Subscriber)(subscriber));
        else return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
var SkipLastSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        var _this = _super.call(this, destination) || this;
        _this._skipCount = _skipCount;
        _this._count = 0;
        _this._ring = new Array(_skipCount);
        return _this;
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../util/ArgumentOutOfRangeError":"4XnVL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1VEwS":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipUntil", ()=>skipUntil);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function skipUntil(notifier) {
    return function(source) {
        return source.lift(new SkipUntilOperator(notifier));
    };
}
var SkipUntilOperator = /*@__PURE__*/ function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(destination, source) {
        return source.subscribe(new SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}();
var SkipUntilSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(_this);
        _this.add(innerSubscriber);
        _this.innerSubscription = innerSubscriber;
        var innerSubscription = (0, _innerSubscribe.innerSubscribe)(notifier, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            _this.add(innerSubscription);
            _this.innerSubscription = innerSubscription;
        }
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype.notifyNext = function() {
        this.hasValue = true;
        if (this.innerSubscription) this.innerSubscription.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {};
    return SkipUntilSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1nDIH":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipWhile", ()=>skipWhile);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function skipWhile(predicate) {
    return function(source) {
        return source.lift(new SkipWhileOperator(predicate));
    };
}
var SkipWhileOperator = /*@__PURE__*/ function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
var SkipWhileSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.skipping = true;
        _this.index = 0;
        return _this;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8Ybpz":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_concat,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startWith", ()=>startWith);
var _concat = require("../observable/concat");
var _isScheduler = require("../util/isScheduler");
function startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
    var scheduler = array[array.length - 1];
    if ((0, _isScheduler.isScheduler)(scheduler)) {
        array.pop();
        return function(source) {
            return (0, _concat.concat)(array, source, scheduler);
        };
    } else return function(source) {
        return (0, _concat.concat)(array, source);
    };
}

},{"../observable/concat":"ir4TZ","../util/isScheduler":"gX9xK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iO9j5":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", ()=>subscribeOn);
var _subscribeOnObservable = require("../observable/SubscribeOnObservable");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new SubscribeOnOperator(scheduler, delay));
    };
}
var SubscribeOnOperator = /*@__PURE__*/ function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new (0, _subscribeOnObservable.SubscribeOnObservable)(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

},{"../observable/SubscribeOnObservable":"9WJYk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9WJYk":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscribeOnObservable", ()=>SubscribeOnObservable);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _asap = require("../scheduler/asap");
var _isNumeric = require("../util/isNumeric");
var SubscribeOnObservable = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!(0, _isNumeric.isNumeric)(delayTime) || delayTime < 0) _this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== "function") _this.scheduler = (0, _asap.asap);
        return _this;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = (0, _asap.asap);
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}((0, _observable.Observable));

},{"tslib":"63kEc","../Observable":"h2K5g","../scheduler/asap":"5k8ix","../util/isNumeric":"kEf57","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4LDZt":[function(require,module,exports) {
/** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchAll", ()=>switchAll);
var _switchMap = require("./switchMap");
var _identity = require("../util/identity");
function switchAll() {
    return (0, _switchMap.switchMap)((0, _identity.identity));
}

},{"./switchMap":"3LtgC","../util/identity":"1yHSj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3LtgC":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _tslib = require("tslib");
var _map = require("./map");
var _from = require("../observable/from");
var _innerSubscribe = require("../innerSubscribe");
function switchMap(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe(switchMap(function(a, i) {
            return (0, _from.from)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new SwitchMapOperator(project));
    };
}
var SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, _innerSubscribe.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, _innerSubscribe.innerSubscribe)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","./map":"jeswA","../observable/from":"eOpwS","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2qL7Y":[function(require,module,exports) {
/** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMapTo", ()=>switchMapTo);
var _switchMap = require("./switchMap");
function switchMapTo(innerObservable, resultSelector) {
    return resultSelector ? (0, _switchMap.switchMap)(function() {
        return innerObservable;
    }, resultSelector) : (0, _switchMap.switchMap)(function() {
        return innerObservable;
    });
}

},{"./switchMap":"3LtgC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5Gdue":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeUntil", ()=>takeUntil);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
function takeUntil(notifier) {
    return function(source) {
        return source.lift(new TakeUntilOperator(notifier));
    };
}
var TakeUntilOperator = /*@__PURE__*/ function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        var takeUntilSubscriber = new TakeUntilSubscriber(subscriber);
        var notifierSubscription = (0, _innerSubscribe.innerSubscribe)(this.notifier, new (0, _innerSubscribe.SimpleInnerSubscriber)(takeUntilSubscriber));
        if (notifierSubscription && !takeUntilSubscriber.seenValue) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}();
var TakeUntilSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.seenValue = false;
        return _this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function() {
        this.seenValue = true;
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {};
    return TakeUntilSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7P9DO":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeWhile", ()=>takeWhile);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) inclusive = false;
    return function(source) {
        return source.lift(new TakeWhileOperator(predicate, inclusive));
    };
}
var TakeWhileOperator = /*@__PURE__*/ function() {
    function TakeWhileOperator(predicate, inclusive) {
        this.predicate = predicate;
        this.inclusive = inclusive;
    }
    TakeWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate, this.inclusive));
    };
    return TakeWhileOperator;
}();
var TakeWhileSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate, inclusive) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.inclusive = inclusive;
        _this.index = 0;
        return _this;
    }
    TakeWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        } catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function(value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) destination.next(value);
        else {
            if (this.inclusive) destination.next(value);
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7xwjw":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tap", ()=>tap);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _noop = require("../util/noop");
var _isFunction = require("../util/isFunction");
function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
var DoOperator = /*@__PURE__*/ function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
var TapSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = (0, _noop.noop);
        _this._tapError = (0, _noop.noop);
        _this._tapComplete = (0, _noop.noop);
        _this._tapError = error || (0, _noop.noop);
        _this._tapComplete = complete || (0, _noop.noop);
        if ((0, _isFunction.isFunction)(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        } else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || (0, _noop.noop);
            _this._tapError = observerOrNext.error || (0, _noop.noop);
            _this._tapComplete = observerOrNext.complete || (0, _noop.noop);
        }
        return _this;
    }
    TapSubscriber.prototype._next = function(value) {
        try {
            this._tapNext.call(this._context, value);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function(err) {
        try {
            this._tapError.call(this._context, err);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function() {
        try {
            this._tapComplete.call(this._context);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../util/noop":"imgcq","../util/isFunction":"1D5el","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"horc0":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultThrottleConfig", ()=>defaultThrottleConfig);
parcelHelpers.export(exports, "throttle", ()=>throttle);
var _tslib = require("tslib");
var _innerSubscribe = require("../innerSubscribe");
var defaultThrottleConfig = {
    leading: true,
    trailing: false
};
function throttle(durationSelector, config) {
    if (config === void 0) config = defaultThrottleConfig;
    return function(source) {
        return source.lift(new ThrottleOperator(durationSelector, !!config.leading, !!config.trailing));
    };
}
var ThrottleOperator = /*@__PURE__*/ function() {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}();
var ThrottleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.durationSelector = durationSelector;
        _this._leading = _leading;
        _this._trailing = _trailing;
        _this._hasValue = false;
        return _this;
    }
    ThrottleSubscriber.prototype._next = function(value) {
        this._hasValue = true;
        this._sendValue = value;
        if (!this._throttled) {
            if (this._leading) this.send();
            else this.throttle(value);
        }
    };
    ThrottleSubscriber.prototype.send = function() {
        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
        if (_hasValue) {
            this.destination.next(_sendValue);
            this.throttle(_sendValue);
        }
        this._hasValue = false;
        this._sendValue = undefined;
    };
    ThrottleSubscriber.prototype.throttle = function(value) {
        var duration = this.tryDurationSelector(value);
        if (!!duration) this.add(this._throttled = (0, _innerSubscribe.innerSubscribe)(duration, new (0, _innerSubscribe.SimpleInnerSubscriber)(this)));
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function(value) {
        try {
            return this.durationSelector(value);
        } catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    ThrottleSubscriber.prototype.throttlingDone = function() {
        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
        if (_throttled) _throttled.unsubscribe();
        this._throttled = undefined;
        if (_trailing) this.send();
    };
    ThrottleSubscriber.prototype.notifyNext = function() {
        this.throttlingDone();
    };
    ThrottleSubscriber.prototype.notifyComplete = function() {
        this.throttlingDone();
    };
    return ThrottleSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fbtnl":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throttleTime", ()=>throttleTime);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _async = require("../scheduler/async");
var _throttle = require("./throttle");
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    if (config === void 0) config = (0, _throttle.defaultThrottleConfig);
    return function(source) {
        return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
    };
}
var ThrottleTimeOperator = /*@__PURE__*/ function() {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}();
var ThrottleTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        var _this = _super.call(this, destination) || this;
        _this.duration = duration;
        _this.scheduler = scheduler;
        _this.leading = leading;
        _this.trailing = trailing;
        _this._hasTrailingValue = false;
        _this._trailingValue = null;
        return _this;
    }
    ThrottleTimeSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        } else {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, {
                subscriber: this
            }));
            if (this.leading) this.destination.next(value);
            else if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
    };
    ThrottleTimeSubscriber.prototype._complete = function() {
        if (this._hasTrailingValue) {
            this.destination.next(this._trailingValue);
            this.destination.complete();
        } else this.destination.complete();
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function() {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../scheduler/async":"7s84y","./throttle":"horc0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2dhZJ":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
parcelHelpers.export(exports, "TimeInterval", ()=>TimeInterval);
var _async = require("../scheduler/async");
var _scan = require("./scan");
var _defer = require("../observable/defer");
var _map = require("./map");
function timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        return (0, _defer.defer)(function() {
            return source.pipe((0, _scan.scan)(function(_a, value) {
                var current = _a.current;
                return {
                    value: value,
                    current: scheduler.now(),
                    last: current
                };
            }, {
                current: scheduler.now(),
                value: undefined,
                last: undefined
            }), (0, _map.map)(function(_a) {
                var current = _a.current, last = _a.last, value = _a.value;
                return new TimeInterval(value, current - last);
            }));
        });
    };
}
var TimeInterval = /*@__PURE__*/ function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();

},{"../scheduler/async":"7s84y","./scan":"ajr9m","../observable/defer":"gV56M","./map":"jeswA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7XnTq":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeout", ()=>timeout);
var _async = require("../scheduler/async");
var _timeoutError = require("../util/TimeoutError");
var _timeoutWith = require("./timeoutWith");
var _throwError = require("../observable/throwError");
function timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return (0, _timeoutWith.timeoutWith)(due, (0, _throwError.throwError)(new (0, _timeoutError.TimeoutError)()), scheduler);
}

},{"../scheduler/async":"7s84y","../util/TimeoutError":"4ByPn","./timeoutWith":"75gBd","../observable/throwError":"lHftZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"75gBd":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutWith", ()=>timeoutWith);
var _tslib = require("tslib");
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _innerSubscribe = require("../innerSubscribe");
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return function(source) {
        var absoluteTimeout = (0, _isDate.isDate)(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
var TimeoutWithOperator = /*@__PURE__*/ function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
var TimeoutWithSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.absoluteTimeout = absoluteTimeout;
        _this.waitFor = waitFor;
        _this.withObservable = withObservable;
        _this.scheduler = scheduler;
        _this.scheduleTimeout();
        return _this;
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add((0, _innerSubscribe.innerSubscribe)(withObservable, new (0, _innerSubscribe.SimpleInnerSubscriber)(subscriber)));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = undefined;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../scheduler/async":"7s84y","../util/isDate":"jvPSV","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6LPLc":[function(require,module,exports) {
/** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timestamp", ()=>timestamp);
parcelHelpers.export(exports, "Timestamp", ()=>Timestamp);
var _async = require("../scheduler/async");
var _map = require("./map");
function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.async);
    return (0, _map.map)(function(value) {
        return new Timestamp(value, scheduler.now());
    });
}
var Timestamp = /*@__PURE__*/ function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();

},{"../scheduler/async":"7s84y","./map":"jeswA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7xQzf":[function(require,module,exports) {
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArray", ()=>toArray);
var _reduce = require("./reduce");
function toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function toArray() {
    return (0, _reduce.reduce)(toArrayReducer, []);
}

},{"./reduce":"45fy9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h8Bjn":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_innerSubscribe PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "window", ()=>window);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _innerSubscribe = require("../innerSubscribe");
function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
var WindowOperator = /*@__PURE__*/ function() {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) windowSubscriber.add((0, _innerSubscribe.innerSubscribe)(this.windowBoundaries, new (0, _innerSubscribe.SimpleInnerSubscriber)(windowSubscriber)));
        return sourceSubscription;
    };
    return WindowOperator;
}();
var WindowSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.window = new (0, _subject.Subject)();
        destination.next(_this.window);
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function() {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function(error) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function() {
        this._complete();
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
    };
    WindowSubscriber.prototype._unsubscribe = function() {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function() {
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var destination = this.destination;
        var newWindow = this.window = new (0, _subject.Subject)();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}((0, _innerSubscribe.SimpleOuterSubscriber));

},{"tslib":"63kEc","../Subject":"inyPN","../innerSubscribe":"7BFPF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gVPFg":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowCount", ()=>windowCount);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
var _subject = require("../Subject");
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
var WindowCountOperator = /*@__PURE__*/ function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
var WindowCountSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowSize = windowSize;
        _this.startWindowEvery = startWindowEvery;
        _this.windows = [
            new (0, _subject.Subject)()
        ];
        _this.count = 0;
        destination.next(_this.windows[0]);
        return _this;
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new (0, _subject.Subject)();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"63kEc","../Subscriber":"dcQ4T","../Subject":"inyPN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"i3XEk":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowTime", ()=>windowTime);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _async = require("../scheduler/async");
var _subscriber = require("../Subscriber");
var _isNumeric = require("../util/isNumeric");
var _isScheduler = require("../util/isScheduler");
function windowTime(windowTimeSpan) {
    var scheduler = (0, _async.async);
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ((0, _isScheduler.isScheduler)(arguments[3])) scheduler = arguments[3];
    if ((0, _isScheduler.isScheduler)(arguments[2])) scheduler = arguments[2];
    else if ((0, _isNumeric.isNumeric)(arguments[2])) maxWindowSize = Number(arguments[2]);
    if ((0, _isScheduler.isScheduler)(arguments[1])) scheduler = arguments[1];
    else if ((0, _isNumeric.isNumeric)(arguments[1])) windowCreationInterval = Number(arguments[1]);
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
var WindowTimeOperator = /*@__PURE__*/ function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var CountedSubject = /*@__PURE__*/ function(_super) {
    _tslib.__extends(CountedSubject, _super);
    function CountedSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._numberOfNextedValues = 0;
        return _this;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}((0, _subject.Subject));
var WindowTimeSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowTimeSpan = windowTimeSpan;
        _this.windowCreationInterval = windowCreationInterval;
        _this.maxWindowSize = maxWindowSize;
        _this.scheduler = scheduler;
        _this.windows = [];
        var window = _this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: _this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: _this,
                scheduler: scheduler
            };
            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: _this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
        return _this;
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}((0, _subscriber.Subscriber));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

},{"tslib":"63kEc","../Subject":"inyPN","../scheduler/async":"7s84y","../Subscriber":"dcQ4T","../util/isNumeric":"kEf57","../util/isScheduler":"gX9xK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8iAF4":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowToggle", ()=>windowToggle);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _subscription = require("../Subscription");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new WindowToggleOperator(openings, closingSelector));
    };
}
var WindowToggleOperator = /*@__PURE__*/ function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
var WindowToggleSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(_this.openSubscription = (0, _subscribeToResult.subscribeToResult)(_this, openings, openings));
        return _this;
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context_1 = contexts[index];
                context_1.window.error(err);
                context_1.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context_2 = contexts[index];
                context_2.window.complete();
                context_2.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context_3 = contexts[index];
                context_3.window.unsubscribe();
                context_3.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingNotifier = void 0;
            try {
                var closingSelector = this.closingSelector;
                closingNotifier = closingSelector(innerValue);
            } catch (e) {
                return this.error(e);
            }
            var window_1 = new (0, _subject.Subject)();
            var subscription = new (0, _subscription.Subscription)();
            var context_4 = {
                window: window_1,
                subscription: subscription
            };
            this.contexts.push(context_4);
            var innerSubscription = (0, _subscribeToResult.subscribeToResult)(this, closingNotifier, context_4);
            if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
            else {
                innerSubscription.context = context_4;
                subscription.add(innerSubscription);
            }
            this.destination.next(window_1);
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"63kEc","../Subject":"inyPN","../Subscription":"3awdk","../OuterSubscriber":"lTBHd","../util/subscribeToResult":"l3R6B","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2NTLt":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowWhen", ()=>windowWhen);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new WindowOperator(closingSelector));
    };
}
var WindowOperator = /*@__PURE__*/ function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
var WindowSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.closingSelector = closingSelector;
        _this.openWindow();
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function(_outerValue, _innerValue, _outerIndex, _innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new (0, _subject.Subject)();
        this.destination.next(window);
        var closingNotifier;
        try {
            var closingSelector = this.closingSelector;
            closingNotifier = closingSelector();
        } catch (e) {
            this.destination.error(e);
            this.window.error(e);
            return;
        }
        this.add(this.closingNotification = (0, _subscribeToResult.subscribeToResult)(this, closingNotifier));
    };
    return WindowSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"63kEc","../Subject":"inyPN","../OuterSubscriber":"lTBHd","../util/subscribeToResult":"l3R6B","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7iiqG":[function(require,module,exports) {
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withLatestFrom", ()=>withLatestFrom);
var _tslib = require("tslib");
var _outerSubscriber = require("../OuterSubscriber");
var _subscribeToResult = require("../util/subscribeToResult");
function withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === "function") project = args.pop();
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
var WithLatestFromOperator = /*@__PURE__*/ function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
var WithLatestFromSubscriber = /*@__PURE__*/ function(_super) {
    _tslib.__extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        var _this = _super.call(this, destination) || this;
        _this.observables = observables;
        _this.project = project;
        _this.toRespond = [];
        var len = observables.length;
        _this.values = new Array(len);
        for(var i = 0; i < len; i++)_this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            _this.add((0, _subscribeToResult.subscribeToResult)(_this, observable, undefined, i));
        }
        return _this;
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {};
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}((0, _outerSubscriber.OuterSubscriber));

},{"tslib":"63kEc","../OuterSubscriber":"lTBHd","../util/subscribeToResult":"l3R6B","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dJwrb":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
var _zip = require("../observable/zip");
function zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    return function zipOperatorFunction(source) {
        return source.lift.call((0, _zip.zip).apply(void 0, [
            source
        ].concat(observables)));
    };
}

},{"../observable/zip":"9vE03","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"khHbj":[function(require,module,exports) {
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zipAll", ()=>zipAll);
var _zip = require("../observable/zip");
function zipAll(project) {
    return function(source) {
        return source.lift(new (0, _zip.ZipOperator)(project));
    };
}

},{"../observable/zip":"9vE03","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ciRSf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionsObservable", ()=>ActionsObservable);
var _rxjs = require("rxjs");
var _operators = require("./operators");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ActionsObservable = function(_Observable) {
    _inherits(ActionsObservable, _Observable);
    _createClass(ActionsObservable, null, [
        {
            key: "of",
            value: function of() {
                return new this((0, _rxjs.of).apply(undefined, arguments));
            }
        },
        {
            key: "from",
            value: function from(actions, scheduler) {
                return new this((0, _rxjs.from)(actions, scheduler));
            }
        }
    ]);
    function ActionsObservable(actionsSubject) {
        _classCallCheck(this, ActionsObservable);
        var _this = _possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        _this.source = actionsSubject;
        return _this;
    }
    _createClass(ActionsObservable, [
        {
            key: "lift",
            value: function lift(operator) {
                var observable = new ActionsObservable(this);
                observable.operator = operator;
                return observable;
            }
        },
        {
            key: "ofType",
            value: function ofType() {
                return (0, _operators.ofType).apply(undefined, arguments)(this);
            }
        }
    ]);
    return ActionsObservable;
}((0, _rxjs.Observable));

},{"rxjs":"kbxjh","./operators":"eZkkN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eZkkN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ofType", ()=>ofType);
var _operators = require("rxjs/operators");
var keyHasType = function keyHasType(type, key) {
    return type === key || typeof key === "function" && type === key.toString();
};
var ofType = function ofType() {
    for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
    return function(source) {
        return source.pipe((0, _operators.filter)(function(_ref) {
            var type = _ref.type;
            var len = keys.length;
            if (len === 1) return keyHasType(type, keys[0]);
            else for(var i = 0; i < len; i++){
                if (keyHasType(type, keys[i])) return true;
            }
            return false;
        }));
    };
};

},{"rxjs/operators":"4sw1o","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9JzaA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StateObservable", ()=>StateObservable);
var _rxjs = require("rxjs");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var StateObservable = function(_Observable) {
    _inherits(StateObservable, _Observable);
    function StateObservable(stateSubject, initialState) {
        _classCallCheck(this, StateObservable);
        var _this = _possibleConstructorReturn(this, (StateObservable.__proto__ || Object.getPrototypeOf(StateObservable)).call(this, function(subscriber) {
            var subscription = _this.__notifier.subscribe(subscriber);
            if (subscription && !subscription.closed) subscriber.next(_this.value);
            return subscription;
        }));
        _this.value = initialState;
        _this.__notifier = new (0, _rxjs.Subject)();
        _this.__subscription = stateSubject.subscribe(function(value) {
            // We only want to update state$ if it has actually changed since
            // redux requires reducers use immutability patterns.
            // This is basically what distinctUntilChanged() does but it's so simple
            // we don't need to pull that code in
            if (value !== _this.value) {
                _this.value = value;
                _this.__notifier.next(value);
            }
        });
        return _this;
    }
    return StateObservable;
}((0, _rxjs.Observable));

},{"rxjs":"kbxjh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7suGa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resetDeprecationsSeen", ()=>resetDeprecationsSeen);
parcelHelpers.export(exports, "deprecate", ()=>deprecate);
parcelHelpers.export(exports, "warn", ()=>warn);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var deprecationsSeen = {};
var resetDeprecationsSeen = function resetDeprecationsSeen() {
    deprecationsSeen = {};
};
var consoleWarn = (typeof console === "undefined" ? "undefined" : _typeof(console)) === "object" && typeof console.warn === "function" ? function() {
    var _console;
    return (_console = console).warn.apply(_console, arguments);
} : function() {};
var deprecate = function deprecate(msg) {
    if (!deprecationsSeen[msg]) {
        deprecationsSeen[msg] = true;
        consoleWarn("redux-observable | DEPRECATION: " + msg);
    }
};
var warn = function warn(msg) {
    consoleWarn("redux-observable | WARNING: " + msg);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5WbNW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineEpics", ()=>combineEpics);
var _rxjs = require("rxjs");
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var combineEpics = function combineEpics() {
    for(var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++)epics[_key] = arguments[_key];
    var merger = function merger() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return (0, _rxjs.merge).apply(undefined, _toConsumableArray(epics.map(function(epic) {
            var output$ = epic.apply(undefined, args);
            if (!output$) throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return output$;
        })));
    };
    // Technically the `name` property on Function's are supposed to be read-only.
    // While some JS runtimes allow it anyway (so this is useful in debugging)
    // some actually throw an exception when you attempt to do so.
    try {
        Object.defineProperty(merger, "name", {
            value: "combineEpics(" + epics.map(function(epic) {
                return epic.name || "<anonymous>";
            }).join(", ") + ")"
        });
    } catch (e) {}
    return merger;
};

},{"rxjs":"kbxjh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aTwKq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setLocalStorage", ()=>setLocalStorage);
parcelHelpers.export(exports, "SET_TENANT_SLUG", ()=>SET_TENANT_SLUG);
parcelHelpers.export(exports, "setTenantSlug", ()=>setTenantSlug);
parcelHelpers.export(exports, "FETCH_TENANT_CONFIGURATION", ()=>FETCH_TENANT_CONFIGURATION);
parcelHelpers.export(exports, "fetchTenantConfiguration", ()=>fetchTenantConfiguration);
parcelHelpers.export(exports, "FETCH_TENANT_CONFIGURATION_SUCCESS", ()=>FETCH_TENANT_CONFIGURATION_SUCCESS);
parcelHelpers.export(exports, "fetchTenantConfigurationSuccess", ()=>fetchTenantConfigurationSuccess);
parcelHelpers.export(exports, "FETCH_TENANT_CONFIGURATION_ERROR", ()=>FETCH_TENANT_CONFIGURATION_ERROR);
parcelHelpers.export(exports, "fetchTenantConfigurationError", ()=>fetchTenantConfigurationError);
parcelHelpers.export(exports, "LOGOUT", ()=>LOGOUT);
parcelHelpers.export(exports, "logout", ()=>logout);
parcelHelpers.export(exports, "ACCESS_TOKEN_EXPIRED", ()=>ACCESS_TOKEN_EXPIRED);
parcelHelpers.export(exports, "accessTokenExpired", ()=>accessTokenExpired);
parcelHelpers.export(exports, "DELETE_ACCESS_TOKEN", ()=>DELETE_ACCESS_TOKEN);
parcelHelpers.export(exports, "deleteAccessToken", ()=>deleteAccessToken);
parcelHelpers.export(exports, "fetchTheme", ()=>fetchTheme);
parcelHelpers.export(exports, "fetchThemeSuccess", ()=>fetchThemeSuccess);
parcelHelpers.export(exports, "fetchThemeError", ()=>fetchThemeError);
parcelHelpers.export(exports, "FETCH_WORKFLOW", ()=>FETCH_WORKFLOW);
parcelHelpers.export(exports, "fetchWorkflow", ()=>fetchWorkflow);
parcelHelpers.export(exports, "fetchWorkflowSuccess", ()=>fetchWorkflowSuccess);
parcelHelpers.export(exports, "fetchWorkflowError", ()=>fetchWorkflowError);
parcelHelpers.export(exports, "CLEAR_STATE", ()=>CLEAR_STATE);
parcelHelpers.export(exports, "clearState", ()=>clearState);
var _remoteData = require("../utils/remoteData");
const SET_LOCAL_STORAGE = "SET_LOCAL_STORAGE";
const setLocalStorage = (payload)=>({
        type: SET_LOCAL_STORAGE,
        payload
    });
const SET_TENANT_SLUG = "SET_TENANT_SLUG";
const setTenantSlug = (tenantSlug)=>({
        type: SET_TENANT_SLUG,
        payload: {
            tenantSlug
        }
    });
const FETCH_TENANT_CONFIGURATION = "FETCH_TENANT_CONFIGURATION";
const fetchTenantConfiguration = ()=>({
        type: FETCH_TENANT_CONFIGURATION
    });
const FETCH_TENANT_CONFIGURATION_SUCCESS = "FETCH_TENANT_CONFIGURATION_SUCCESS";
const fetchTenantConfigurationSuccess = (data)=>({
        type: FETCH_TENANT_CONFIGURATION_SUCCESS,
        payload: {
            data
        }
    });
const FETCH_TENANT_CONFIGURATION_ERROR = "FETCH_TENANT_CONFIGURATION_ERROR";
const fetchTenantConfigurationError = (error)=>({
        type: FETCH_TENANT_CONFIGURATION_ERROR,
        payload: {
            error
        }
    });
const LOGOUT = "LOGOUT";
const logout = (data)=>({
        type: LOGOUT,
        payload: data
    });
const ACCESS_TOKEN_EXPIRED = "ACCESS_TOKEN_EXPIRED";
const accessTokenExpired = ()=>({
        type: ACCESS_TOKEN_EXPIRED
    });
const DELETE_ACCESS_TOKEN = "DELETE_ACCESS_TOKEN";
const deleteAccessToken = ()=>({
        type: DELETE_ACCESS_TOKEN
    });
const FETCH_THEME = "FETCH_THEME";
const fetchTheme = ()=>({
        type: FETCH_THEME
    });
const FETCH_THEME_SUCCESS = "FETCH_THEME_SUCCESS";
const fetchThemeSuccess = (payload)=>({
        type: FETCH_THEME_SUCCESS,
        payload
    });
const FETCH_THEME_ERROR = "FETCH_THEME_ERROR";
const fetchThemeError = (error)=>({
        type: FETCH_THEME_ERROR,
        payload: {
            error
        }
    });
const FETCH_WORKFLOW = "FETCH_WORKFLOW";
const fetchWorkflow = (payload)=>({
        type: FETCH_WORKFLOW,
        payload
    });
const FETCH_WORKFLOW_SUCCESS = "FETCH_WORKFLOW_SUCCESS";
const fetchWorkflowSuccess = (payload)=>({
        type: FETCH_WORKFLOW_SUCCESS,
        payload
    });
const FETCH_WORKFLOW_ERROR = "FETCH_WORKFLOW_ERROR";
const fetchWorkflowError = (error)=>({
        type: FETCH_WORKFLOW_ERROR,
        payload: {
            error
        }
    });
const CLEAR_STATE = "CLEAR_STATE";
const clearState = ()=>({
        type: CLEAR_STATE
    });
const initialState = {
    tenantSlug: null,
    theme: _remoteData.notAsked(),
    clientMetadata: _remoteData.notAsked(),
    routesConfig: _remoteData.notAsked(),
    landingPage: _remoteData.notAsked(),
    localStorage: {}
};
const reducer = (state = initialState, { type, payload })=>{
    switch(type){
        case SET_LOCAL_STORAGE:
            return {
                ...state,
                localStorage: {
                    ...state.localStorage,
                    ...payload
                }
            };
        case SET_TENANT_SLUG:
            return {
                ...state,
                tenantSlug: payload.tenantSlug
            };
        case FETCH_TENANT_CONFIGURATION:
            return {
                ...state,
                clientMetadata: _remoteData.loading(),
                settings: _remoteData.loading(),
                subClientPath: _remoteData.loading(),
                subClientSlug: _remoteData.loading(),
                payment: _remoteData.loading()
            };
        case FETCH_TENANT_CONFIGURATION_SUCCESS:
            return {
                ...state,
                clientMetadata: _remoteData.success(payload.data.meta),
                settings: _remoteData.success(payload.data.settings),
                subClientPath: _remoteData.success(payload.data.subClientPath),
                subClientSlug: _remoteData.success(payload.data.subClientSlug),
                payment: _remoteData.success(payload.data.payment)
            };
        case FETCH_TENANT_CONFIGURATION_ERROR:
            return {
                ...state,
                clientMetadata: _remoteData.error(payload.error),
                settings: _remoteData.error(payload.error),
                subClientPath: _remoteData.error(payload.error),
                subClientSlug: _remoteData.error(payload.error),
                payment: _remoteData.error(payload.error)
            };
        case FETCH_THEME:
            return {
                ...state,
                theme: _remoteData.loading()
            };
        case FETCH_THEME_SUCCESS:
            return {
                ...state,
                theme: _remoteData.success(payload)
            };
        case FETCH_THEME_ERROR:
            return {
                ...state,
                theme: _remoteData.error(payload.error)
            };
        case FETCH_WORKFLOW:
            return {
                ...state,
                workflows: _remoteData.loading()
            };
        case FETCH_WORKFLOW_SUCCESS:
            return {
                ...state,
                workflows: _remoteData.success(payload)
            };
        case FETCH_WORKFLOW_ERROR:
            return {
                ...state,
                workflows: _remoteData.error(payload.error)
            };
        default:
            return state;
    }
};
exports.default = reducer;

},{"../utils/remoteData":"7N6mn","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7N6mn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NOT_ASKED", ()=>NOT_ASKED);
parcelHelpers.export(exports, "LOADING", ()=>LOADING);
parcelHelpers.export(exports, "ERROR", ()=>ERROR);
parcelHelpers.export(exports, "SUCCESS", ()=>SUCCESS);
parcelHelpers.export(exports, "isSuccess", ()=>isSuccess);
parcelHelpers.export(exports, "success", ()=>success);
parcelHelpers.export(exports, "error", ()=>error);
parcelHelpers.export(exports, "notAsked", ()=>notAsked);
parcelHelpers.export(exports, "loading", ()=>loading);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "withDefault", ()=>withDefault);
const NOT_ASKED = "NOT_ASKED";
const LOADING = "LOADING";
const ERROR = "ERROR";
const SUCCESS = "SUCCESS";
const isSuccess = (x)=>x.phase === SUCCESS;
const success = (data)=>({
        phase: SUCCESS,
        data
    });
const error = (error)=>({
        phase: ERROR,
        error
    });
const notAsked = ()=>({
        phase: NOT_ASKED
    });
const loading = ()=>({
        phase: LOADING
    });
const map = (f)=>(remoteData)=>isSuccess(remoteData) ? {
            ...remoteData,
            data: f(remoteData.data)
        } : remoteData;
const withDefault = (x)=>(remoteData)=>isSuccess(remoteData) ? remoteData.data : x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hoeE4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "locallyStoreSessionsEpic", ()=>locallyStoreSessionsEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ = require(".");
var _loginState = require("../pages/login/Login.state");
var _terminalLoginState = require("../pages/terminal-login/TerminalLogin.state");
const locallyStoreSessionsEpic = (action$, state$)=>action$.pipe(_operators.filter((action)=>[
            (0, _loginState.LOGIN_SUCCESS),
            (0, _terminalLoginState.TERMINAL_LOGIN_SUCCESS)
        ].includes(action.type)), _operators.flatMap(()=>{
        const serializedTerminalSession = JSON.stringify(state$.value.terminalLogin);
        const serializedSession = JSON.stringify(state$.value.login);
        localStorage.setItem("terminalSession", serializedTerminalSession);
        localStorage.setItem("session", serializedSession);
        return _rxjs.of((0, _.EMPTY_ACTION));
    }));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o",".":"dFzXj","../pages/login/Login.state":"eq6dI","../pages/terminal-login/TerminalLogin.state":"7GhEX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eq6dI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUBMIT_LOGIN_FORM", ()=>SUBMIT_LOGIN_FORM);
parcelHelpers.export(exports, "submitLoginForm", ()=>submitLoginForm);
parcelHelpers.export(exports, "LOGIN_SUCCESS", ()=>LOGIN_SUCCESS);
parcelHelpers.export(exports, "loginSuccess", ()=>loginSuccess);
parcelHelpers.export(exports, "setIsLoggingOut", ()=>setIsLoggingOut);
parcelHelpers.export(exports, "loginError", ()=>loginError);
parcelHelpers.export(exports, "_reducer", ()=>_reducer1);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "loginAlertBarAction", ()=>loginAlertBarAction);
parcelHelpers.export(exports, "LOGIN_FORM_ACTION", ()=>LOGIN_FORM_ACTION);
parcelHelpers.export(exports, "loginFormAction", ()=>loginFormAction);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _reducer = require("../../state/reducer");
var _nested = require("../../utils/Nested");
var _login = require("./Login");
const SUBMIT_LOGIN_FORM = "login/SUBMIT_LOGIN_FORM";
const submitLoginForm = ()=>({
        type: SUBMIT_LOGIN_FORM
    });
const LOGIN_SUCCESS = "login/LOGIN_SUCCESS";
const loginSuccess = (payload)=>({
        type: LOGIN_SUCCESS,
        payload
    });
const SET_IS_LOGGING_OUT = "login/SET_IS_LOGGING_OUT";
const setIsLoggingOut = (payload)=>({
        type: SET_IS_LOGGING_OUT,
        payload
    });
const LOGIN_ERROR = "login/LOGIN_ERROR";
const loginError = (error)=>({
        type: LOGIN_ERROR,
        payload: {
            error
        }
    });
const initialState = {
    isLoggingOut: false,
    submitting: false,
    error: false,
    cashier: {
        first_name: "",
        last_name: "",
        email: ""
    }
};
const loadInitialState = ()=>{
    try {
        const sessionState = localStorage.getItem("session");
        if (!sessionState) return initialState;
        else return JSON.parse(localStorage.getItem("session"));
    } catch (err) {
        return initialState;
    }
};
const _reducer1 = (state = loadInitialState(), { type, payload })=>{
    switch(type){
        case 0, _reducer.LOGOUT:
            return {
                ...state,
                isLoggingOut: true
            };
        case SET_IS_LOGGING_OUT:
            return {
                ...state,
                isLoggingOut: payload
            };
        case SUBMIT_LOGIN_FORM:
            return {
                ...state,
                submitting: true
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                submitting: false,
                error: false,
                cashier: payload.cashier
            };
        case LOGIN_ERROR:
            return {
                ...state,
                submitting: false,
                error: payload
            };
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>({
        ...state.login
    });
const _mapDispatchToProps = (dispatch)=>({
        submitLoginForm: ()=>dispatch(submitLoginForm())
    });
const ALERT_BAR_ACTION = "login/ALERT_BAR_ACTION";
const loginAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const LOGIN_FORM_ACTION = "login/LOGIN_FORM_ACTION";
const loginFormAction = _nested.nestedAction(LOGIN_FORM_ACTION);
// What does this state tree actually look like here? so hard to tell
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer1,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    forms: {
        loginForm: {
            ...(0, _login.LoginFormBody),
            actionType: LOGIN_FORM_ACTION
        }
    },
    alertBars: {
        loginAlertBar: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    }
}, "login");
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../state/reducer":"aTwKq","../../utils/Nested":"gDQL4","./Login":"kDpB6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"HHSfQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAlert", ()=>addAlert);
parcelHelpers.export(exports, "deleteAlert", ()=>deleteAlert);
parcelHelpers.export(exports, "clearAlerts", ()=>clearAlerts);
parcelHelpers.export(exports, "replaceAlerts", ()=>replaceAlerts);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _ramda = require("ramda");
const ADD_ALERT = "ADD_ALERT";
const addAlert = (alert)=>({
        type: ADD_ALERT,
        payload: {
            alert
        }
    });
const DELETE_ALERT = "DELETE_ALERT";
const deleteAlert = (index)=>({
        type: DELETE_ALERT,
        payload: {
            index
        }
    });
const CLEAR_ALERTS = "CLEAR_ALERTS";
const clearAlerts = ()=>({
        type: CLEAR_ALERTS
    });
const REPLACE_ALERTS = "REPLACE_ALERTS";
const replaceAlerts = (alert)=>({
        type: REPLACE_ALERTS,
        payload: {
            alert
        }
    });
const initialState = {
    alerts: []
};
const reducer = (state = initialState, { type, payload })=>{
    switch(type){
        case ADD_ALERT:
            return {
                ...state,
                alerts: [
                    ...state.alerts,
                    payload.alert
                ]
            };
        case DELETE_ALERT:
            return {
                ...state,
                alerts: _ramda.remove(payload.index, payload.index + 1, state.alerts)
            };
        case CLEAR_ALERTS:
            return initialState;
        case REPLACE_ALERTS:
            return {
                ...state,
                alerts: [
                    payload.alert
                ]
            };
        default:
            return state;
    }
};
const mapStateToProps = (state)=>state;
const mapDispatchToProps = (dispatch)=>({
        addAlert: (alert)=>dispatch(addAlert(alert)),
        deleteAlert: (index)=>dispatch(deleteAlert(index)),
        clearAlerts: ()=>dispatch(clearAlerts()),
        replaceAlerts: (alert)=>dispatch(replaceAlerts(alert))
    });

},{"ramda":"JPp0Z","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gDQL4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "nestedAction", ()=>nestedAction);
parcelHelpers.export(exports, "nestStates", ()=>nestStates);
var _ramda = require("ramda");
const init = (reducer)=>reducer(undefined, {
        type: "@@INIT"
    });
// Redundant function call to get scoping rules to work
// properly
const initializeNestedStates = (0, _ramda.map)((0, _ramda.ifElse)((0, _ramda.has)("reducer"), (0, _ramda.pipe)((0, _ramda.prop)("reducer"), init), (o)=>initializeNestedStates(o)));
const mapNestedStateToProps = (nestedConfig, state)=>(0, _ramda.mapObjIndexed)((value, key)=>{
        return (0, _ramda.has)("mapStateToProps", value) ? value.mapStateToProps(state[key]) : mapNestedStateToProps(value, state[key]);
    }, nestedConfig);
const wrapActionFn = (actionFn, actionType, dispatch)=>(...args)=>dispatch({
            type: actionType,
            payload: {
                action: actionFn(...args)
            }
        });
const wrapActionFnsRecursively = (actionFnsObj, actionType, dispatch)=>(0, _ramda.map)((value)=>typeof value === "function" ? wrapActionFn(value, actionType, dispatch) : wrapActionFnsRecursively(value, actionType, dispatch), actionFnsObj);
const mapNestedDispatchToProps = (nestedConfig, dispatch)=>(0, _ramda.map)((value)=>(0, _ramda.has)("mapDispatchToProps", value) ? wrapActionFnsRecursively(value.mapDispatchToProps((0, _ramda.identity)), value.actionType, dispatch) : mapNestedDispatchToProps(value, dispatch), nestedConfig);
const evaluateNestedReducers = (nestedConfig, state, action)=>{
    return (0, _ramda.mapObjIndexed)((value, key)=>(0, _ramda.cond)([
            [
                (0, _ramda.both)((0, _ramda.has)("reducer"), (0, _ramda.has)("actionType")),
                (0, _ramda.cond)([
                    [
                        (v)=>v.actionType === action.type,
                        (v)=>v.reducer(state[key], action.payload.action)
                    ],
                    [
                        (0, _ramda.T),
                        (0, _ramda.always)(state[key])
                    ]
                ])
            ],
            [
                (0, _ramda.T),
                (v)=>evaluateNestedReducers(v, state[key], action)
            ]
        ])(value), nestedConfig);
};
const nestedAction = (actionType)=>(action)=>({
            type: actionType,
            payload: {
                action
            }
        });
const nestStates = ({ reducer, mapStateToProps, mapDispatchToProps }, nestedConfig, stateKey)=>({
        reducer: (state = {
            ...init(reducer),
            ...initializeNestedStates(nestedConfig)
        }, action)=>{
            const stateWithNestedUpdated = evaluateNestedReducers(nestedConfig, state, action);
            return reducer({
                ...state,
                ...stateWithNestedUpdated
            }, action);
        },
        mapStateToProps: (state)=>({
                ...mapStateToProps(state),
                ...mapNestedStateToProps(nestedConfig, state[stateKey])
            }),
        mapDispatchToProps: (dispatch)=>({
                ...mapDispatchToProps(dispatch),
                actions: mapNestedDispatchToProps(nestedConfig, dispatch)
            })
    });

},{"ramda":"JPp0Z","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kDpB6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoginFormBody", ()=>LoginFormBody);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _welcomeHeader = require("../../components/welcome-header");
var _welcomeHeaderDefault = parcelHelpers.interopDefault(_welcomeHeader);
var _oktaReact = require("@okta/okta-react");
var _reduxFreeform = require("redux-freeform");
var _loginFormState = require("./LoginForm.state");
var _loginState = require("./Login.state");
var _reactRedux = require("react-redux");
var _constants = require("../../utils/constants");
var _shared = require("../../state/shared");
var _sharedAlertBar = require("../../components/alert-bar/SharedAlertBar");
var _sharedAlertBarDefault = parcelHelpers.interopDefault(_sharedAlertBar);
const emailErrorMessages = {
    [(0, _reduxFreeform.required).error]: "Email address is required",
    [(0, _reduxFreeform.isProbablyEmail).error]: "Invalid email address"
};
const LoginFormBody = ({ actions, fields, showErrors, submitLoginForm, handleOktaLogin })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
        as: "form",
        id: "login-form",
        width: "576px",
        padding: "24px",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                form: "login-form",
                labelTextWhenNoError: "Email Address",
                errorMessages: emailErrorMessages,
                type: "email",
                name: "email",
                field: fields.email,
                fieldActions: actions.fields.email,
                showErrors: showErrors,
                isEmail: true,
                labelTextVariant: "p",
                errorTextVariant: "p"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                form: "login-form",
                type: "submit",
                disabled: false,
                text: "Log In",
                extraStyles: "width: 100%; margin: 0px;",
                action: (e)=>{
                    e.preventDefault();
                    dispatch(submitLoginForm());
                    handleOktaLogin();
                },
                textExtraStyles: "font-size: 1rem;"
            })
        ]
    }, "item2");
};
// for redux-freeform validation mapping
LoginFormBody.reducer = (0, _loginFormState.reducer);
LoginFormBody.mapStateToProps = (0, _loginFormState.mapStateToProps);
LoginFormBody.mapDispatchToProps = (0, _loginFormState.mapDispatchToProps);
const Login = ({ actions, forms, isLoading = true })=>{
    const [isLoadingOkta, setIsLoadingOkta] = (0, _react.useState)(isLoading);
    const [errors] = (0, _react.useState)(false);
    const dispatch = (0, _reactRedux.useDispatch)();
    const { oktaAuth, authState } = (0, _oktaReact.useOktaAuth)();
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    const handleOktaLogin = async ()=>{
        try {
            let exists = await oktaAuth.session.exists();
            let isAuthenticated = await oktaAuth.isAuthenticated();
            if (exists && !isAuthenticated) {
                await oktaAuth.signInWithRedirect();
                localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), "");
            } else setIsLoadingOkta(false);
        } catch (err) {
            console.warn(`%cWarning: Okta sign in error: ${err}`, `background-color: ${(0, _constants.consoleWarningStyle)}`);
            setIsLoadingOkta(false);
        }
    };
    (0, _react.useEffect)(()=>{
        handleOktaLogin();
    }, [
        authState
    ]);
    (0, _react.useEffect)(()=>{
        const logoutReason = localStorage.getItem((0, _constants.OKTA_LOGOUT_REASON_KEY));
        let timeout;
        if (!!logoutReason) {
            dispatch((0, _shared.replaceSharedAlerts)({
                heading: (0, _constants.LOGOUT_REASONS)[logoutReason]?.value ?? logoutReason,
                variant: (0, _constants.LOGOUT_REASONS)[logoutReason]?.variant ?? "error"
            }));
            timeout = setTimeout(()=>{
                dispatch((0, _shared.clearSharedAlerts)());
                localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), "");
            }, 10000);
        }
        return ()=>{
            dispatch((0, _shared.clearSharedAlerts)());
            localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), "");
            if (timeout) clearTimeout(timeout);
        };
    }, []);
    return isLoadingOkta ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CenterStack), {
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
            padding: "32px 0 64px",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                size: "100"
            })
        })
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CenterStack), {
        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
            padding: "32px 0 64px",
            children: [
                sharedAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharedAlertBarDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                    padding: "0",
                    borderRadius: "8px",
                    boxShadow: "0px 1px 2px 0px rgba(41, 42, 51, 0.1), 0px 2px 6px 0px rgba(41, 42, 51, 0.2), 0px 1px 0px 0px rgba(41, 42, 51, 0.1) inset",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _welcomeHeaderDefault.default), {
                            actionText: "Please log in to continue"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginFormBody, {
                            handleOktaLogin: handleOktaLogin,
                            handleSubmit: handleOktaLogin,
                            showErrors: errors,
                            fields: forms.loginForm.fields,
                            actions: actions.forms.loginForm.actions,
                            submitLoginForm: (0, _loginState.submitLoginForm)
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = (0, _components.withWindowSize)(Login);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../components/welcome-header":"iyfz3","@okta/okta-react":"3286W","redux-freeform":"1Yc5v","./LoginForm.state":"8Zp0b","./Login.state":"eq6dI","react-redux":"k6jol","../../utils/constants":"f3A1R","../../state/shared":"h0jLC","../../components/alert-bar/SharedAlertBar":"gk2Ni","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g98ma":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountNumberImage", ()=>AccountNumberImage);
parcelHelpers.export(exports, "AccountsAddIcon", ()=>AccountsAddIcon$1);
parcelHelpers.export(exports, "AccountsIcon", ()=>AccountsIcon$1);
parcelHelpers.export(exports, "AccountsIconSmall", ()=>AccountsIconSmall$1);
parcelHelpers.export(exports, "AchReturnIcon", ()=>AchReturnIcon);
parcelHelpers.export(exports, "AddressForm", ()=>AddressForm);
parcelHelpers.export(exports, "AgencyIcon", ()=>AgencyIcon);
parcelHelpers.export(exports, "Alert", ()=>Alert$1);
parcelHelpers.export(exports, "AllocatedIcon", ()=>AllocatedIcon);
parcelHelpers.export(exports, "AmExLargeIcon", ()=>AmExLargeIcon);
parcelHelpers.export(exports, "AmExSmallIcon", ()=>AmExSmallIcon);
parcelHelpers.export(exports, "AmountCallout", ()=>AmountCallout$1);
parcelHelpers.export(exports, "ArrowDownCircleIconSmall", ()=>ArrowDownCircleIconSmall);
parcelHelpers.export(exports, "ArrowLeftCircleIconMedium", ()=>ArrowLeftCircleIconMedium);
parcelHelpers.export(exports, "ArrowLeftCircleIconSmall", ()=>ArrowLeftCircleIconSmall);
parcelHelpers.export(exports, "ArrowRightCircleIconSmall", ()=>ArrowRightCircleIconSmall);
parcelHelpers.export(exports, "ArrowRightIcon", ()=>ArrowRightIcon);
parcelHelpers.export(exports, "ArrowUpCircleIconSmall", ()=>ArrowUpCircleIconSmall);
parcelHelpers.export(exports, "AutopayIcon", ()=>AutopayIcon);
parcelHelpers.export(exports, "AutopayOnIcon", ()=>AutopayOnIcon);
parcelHelpers.export(exports, "AutopayWalletIcon", ()=>AutopayWalletIcon);
parcelHelpers.export(exports, "Badge", ()=>Badge$1);
parcelHelpers.export(exports, "BankGenericSmallIcon", ()=>BankGenericSmallIcon);
parcelHelpers.export(exports, "BankIcon", ()=>BankIcon);
parcelHelpers.export(exports, "BankIconLarge", ()=>BankIconLarge);
parcelHelpers.export(exports, "Banner", ()=>Banner$1);
parcelHelpers.export(exports, "Box", ()=>Box);
parcelHelpers.export(exports, "BoxWithShadow", ()=>BoxWithShadow$1);
parcelHelpers.export(exports, "Breadcrumb", ()=>Breadcrumbs);
parcelHelpers.export(exports, "ButtonWithAction", ()=>ButtonWithAction);
parcelHelpers.export(exports, "ButtonWithLink", ()=>ButtonWithLink);
parcelHelpers.export(exports, "CalendarIcon", ()=>CalendarIcon);
parcelHelpers.export(exports, "Card", ()=>Card$1);
parcelHelpers.export(exports, "CardType", ()=>CardType);
parcelHelpers.export(exports, "CaretArrowDown", ()=>CaretArrowDown$1);
parcelHelpers.export(exports, "CaretArrowUp", ()=>CaretArrowUp$1);
parcelHelpers.export(exports, "CarrotIcon", ()=>CarrotIcon$1);
parcelHelpers.export(exports, "CashIcon", ()=>CashIcon);
parcelHelpers.export(exports, "CashSmallIcon", ()=>CashSmallIcon);
parcelHelpers.export(exports, "CashieringImage", ()=>CashieringImage);
parcelHelpers.export(exports, "Center", ()=>Center);
parcelHelpers.export(exports, "CenterSingle", ()=>CenterSingle$1);
parcelHelpers.export(exports, "CenterStack", ()=>CenterStack$1);
parcelHelpers.export(exports, "ChangePasswordForm", ()=>ChangePasswordForm);
parcelHelpers.export(exports, "ChargebackIcon", ()=>ChargebackIcon);
parcelHelpers.export(exports, "ChargebackIconMedium", ()=>ChargebackIconMedium);
parcelHelpers.export(exports, "ChargebackIconSmall", ()=>ChargebackIconSmall);
parcelHelpers.export(exports, "ChargebackReversalIcon", ()=>ChargebackReversalIcon);
parcelHelpers.export(exports, "ChargebackReversalIconMedium", ()=>ChargebackReversalIconMedium);
parcelHelpers.export(exports, "ChargebackReversalIconSmall", ()=>ChargebackReversalIconSmall);
parcelHelpers.export(exports, "CheckIcon", ()=>CheckIcon);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox$1);
parcelHelpers.export(exports, "CheckboxList", ()=>CheckboxList$1);
parcelHelpers.export(exports, "CheckmarkIcon", ()=>CheckmarkIcon);
parcelHelpers.export(exports, "ChevronIcon", ()=>ChevronIcon$1);
parcelHelpers.export(exports, "CloseIcon", ()=>CloseIcon);
parcelHelpers.export(exports, "Cluster", ()=>Cluster);
parcelHelpers.export(exports, "CollapsibleSection", ()=>CollapsibleSection$1);
parcelHelpers.export(exports, "Copyable", ()=>Copyable);
parcelHelpers.export(exports, "CountryDropdown", ()=>CountryDropdown);
parcelHelpers.export(exports, "Cover", ()=>Cover);
parcelHelpers.export(exports, "CustomerSearchIcon", ()=>CustomerSearchIcon);
parcelHelpers.export(exports, "DefaultPageTemplate", ()=>DefaultPageTemplate);
parcelHelpers.export(exports, "Detail", ()=>Detail$1);
parcelHelpers.export(exports, "DisabledAccountsAddIcon", ()=>DisabledAccountsAddIcon);
parcelHelpers.export(exports, "DisabledPaymentMethodsAddIcon", ()=>DisabledPaymentMethodsAddIcon);
parcelHelpers.export(exports, "DisabledPropertiesAddIcon", ()=>DisabledPropertiesAddIcon);
parcelHelpers.export(exports, "DiscoverLargeIcon", ()=>DiscoverLargeIcon);
parcelHelpers.export(exports, "DiscoverSmallIcon", ()=>DiscoverSmallIcon);
parcelHelpers.export(exports, "DisplayBox", ()=>DisplayBox$1);
parcelHelpers.export(exports, "Dropdown", ()=>Dropdown$1);
parcelHelpers.export(exports, "DuplicateIcon", ()=>DuplicateIcon);
parcelHelpers.export(exports, "EditNameForm", ()=>EditNameForm);
parcelHelpers.export(exports, "EditableList", ()=>EditableList);
parcelHelpers.export(exports, "EditableTable", ()=>EditableTable);
parcelHelpers.export(exports, "EmailForm", ()=>EmailForm);
parcelHelpers.export(exports, "EmptyCartIcon", ()=>EmptyCartIcon$1);
parcelHelpers.export(exports, "EmptyCartIconV2", ()=>EmptyCartIconV2$1);
parcelHelpers.export(exports, "ErroredIcon", ()=>ErroredIcon);
parcelHelpers.export(exports, "ExternalLink", ()=>ExternalLink);
parcelHelpers.export(exports, "ExternalLinkIcon", ()=>ExternalLinkIcon);
parcelHelpers.export(exports, "FailedIcon", ()=>FailedIcon);
parcelHelpers.export(exports, "FindIconSmall", ()=>FindIconSmall$1);
parcelHelpers.export(exports, "FooterWithSubfooter", ()=>FooterWithSubfooter$1);
parcelHelpers.export(exports, "ForgotPasswordForm", ()=>ForgotPasswordForm);
parcelHelpers.export(exports, "ForgotPasswordIcon", ()=>ForgotPasswordIcon$1);
parcelHelpers.export(exports, "FormContainer", ()=>FormContainer$1);
parcelHelpers.export(exports, "FormFooterPanel", ()=>FormFooterPanel$1);
parcelHelpers.export(exports, "FormInput", ()=>FormInput$1);
parcelHelpers.export(exports, "FormInputColumn", ()=>FormInputColumn);
parcelHelpers.export(exports, "FormInputRow", ()=>FormInputRow);
parcelHelpers.export(exports, "FormSelect", ()=>FormSelect$1);
parcelHelpers.export(exports, "FormTextarea", ()=>FormTextarea$1);
parcelHelpers.export(exports, "FormattedAddress", ()=>FormattedAddress$1);
parcelHelpers.export(exports, "Frame", ()=>Frame);
parcelHelpers.export(exports, "GenericCard", ()=>GenericCard);
parcelHelpers.export(exports, "GenericCardLarge", ()=>GenericCardLarge);
parcelHelpers.export(exports, "GenericErrorIcon", ()=>GenericErrorIcon);
parcelHelpers.export(exports, "GenericSmallIcon", ()=>GenericSmallIcon);
parcelHelpers.export(exports, "GoToEmailIcon", ()=>GoToEmailIcon$1);
parcelHelpers.export(exports, "Grid", ()=>Grid);
parcelHelpers.export(exports, "GuidedCheckoutImage", ()=>GuidedCheckoutImage);
parcelHelpers.export(exports, "HamburgerButton", ()=>HamburgerButton);
parcelHelpers.export(exports, "Heading", ()=>Heading$1);
parcelHelpers.export(exports, "HighlightTabRow", ()=>HighlightTabRow$1);
parcelHelpers.export(exports, "HistoryIconSmall", ()=>HistoryIconSmall$1);
parcelHelpers.export(exports, "IconAdd", ()=>IconAdd);
parcelHelpers.export(exports, "IconQuitLarge", ()=>IconQuitLarge);
parcelHelpers.export(exports, "IdleModal", ()=>IdleModal);
parcelHelpers.export(exports, "ImageBox", ()=>ImageBox);
parcelHelpers.export(exports, "Imposter", ()=>Imposter);
parcelHelpers.export(exports, "InternalLink", ()=>InternalLink);
parcelHelpers.export(exports, "Jumbo", ()=>Jumbo$1);
parcelHelpers.export(exports, "KebabMenuIcon", ()=>KebabMenuIcon);
parcelHelpers.export(exports, "KioskImage", ()=>KioskImage);
parcelHelpers.export(exports, "LabeledAmount", ()=>LabeledAmount$1);
parcelHelpers.export(exports, "LineItem", ()=>LineItem$1);
parcelHelpers.export(exports, "Loading", ()=>Loading);
parcelHelpers.export(exports, "LoadingLine", ()=>LoadingLine);
parcelHelpers.export(exports, "LoginForm", ()=>LoginForm);
parcelHelpers.export(exports, "MasterCardLargeIcon", ()=>MasterCardLargeIcon);
parcelHelpers.export(exports, "MasterCardSmallIcon", ()=>MasterCardSmallIcon);
parcelHelpers.export(exports, "Modal", ()=>Modal$3);
parcelHelpers.export(exports, "Module", ()=>Module$1);
parcelHelpers.export(exports, "Motion", ()=>Motion);
parcelHelpers.export(exports, "MultiCartIcon", ()=>MultiCartIcon);
parcelHelpers.export(exports, "MultipleSelectFilter", ()=>MultipleSelectFilter$1);
parcelHelpers.export(exports, "NavFooter", ()=>NavFooter);
parcelHelpers.export(exports, "NavHeader", ()=>NavHeader);
parcelHelpers.export(exports, "NavMenuDesktop", ()=>NavMenuDesktop$1);
parcelHelpers.export(exports, "NavMenuMobile", ()=>NavMenuMobile$1);
parcelHelpers.export(exports, "NavTabs", ()=>NavTabs);
parcelHelpers.export(exports, "NoResultsIcon", ()=>NoResultsIcon);
parcelHelpers.export(exports, "NotFoundIcon", ()=>NotFoundIcon);
parcelHelpers.export(exports, "OverageIcon", ()=>OverageIcon);
parcelHelpers.export(exports, "Pagination", ()=>Pagination$1);
parcelHelpers.export(exports, "Paragraph", ()=>Paragraph$1);
parcelHelpers.export(exports, "PasswordRequirements", ()=>PasswordRequirements);
parcelHelpers.export(exports, "PaydotImage", ()=>PaydotImage);
parcelHelpers.export(exports, "PaymentDetails", ()=>PaymentDetails$1);
parcelHelpers.export(exports, "PaymentMethodAddIcon", ()=>PaymentMethodAddIcon$1);
parcelHelpers.export(exports, "PaymentMethodIcon", ()=>PaymentMethodIcon$1);
parcelHelpers.export(exports, "PaymentSearchIcon", ()=>PaymentSearchIcon);
parcelHelpers.export(exports, "PaymentStatusIcon", ()=>PaymentStatusIcon);
parcelHelpers.export(exports, "PaymentsIconSmall", ()=>PaymentsIconSmall$1);
parcelHelpers.export(exports, "PencilIcon", ()=>PencilIcon$1);
parcelHelpers.export(exports, "PendingIcon", ()=>PendingIcon);
parcelHelpers.export(exports, "PeriscopeDashboardIframe", ()=>PeriscopeDashboardIframe);
parcelHelpers.export(exports, "PeriscopeFailedIcon", ()=>PeriscopeFailedIcon);
parcelHelpers.export(exports, "PersonIcon", ()=>PersonIcon);
parcelHelpers.export(exports, "PhoneForm", ()=>PhoneForm);
parcelHelpers.export(exports, "Placeholder", ()=>Placeholder$1);
parcelHelpers.export(exports, "PlusCircleIcon", ()=>PlusCircleIcon);
parcelHelpers.export(exports, "Popover", ()=>Popover$1);
parcelHelpers.export(exports, "PopupMenu", ()=>PopupMenu$1);
parcelHelpers.export(exports, "ProcessingFee", ()=>ProcessingFee$1);
parcelHelpers.export(exports, "ProfileIcon", ()=>ProfileIcon$1);
parcelHelpers.export(exports, "ProfileIconSmall", ()=>ProfileIconSmall$1);
parcelHelpers.export(exports, "ProfileImage", ()=>ProfileImage);
parcelHelpers.export(exports, "PropertiesAddIcon", ()=>PropertiesAddIcon$1);
parcelHelpers.export(exports, "PropertiesIconSmall", ()=>PropertiesIconSmall$1);
parcelHelpers.export(exports, "RadioButton", ()=>RadioButton$2);
parcelHelpers.export(exports, "RadioButtonWithLabel", ()=>RadioButtonWithLabel$1);
parcelHelpers.export(exports, "RadioGroup", ()=>RadioGroup);
parcelHelpers.export(exports, "Reel", ()=>Reel);
parcelHelpers.export(exports, "RefundIcon", ()=>RefundIcon);
parcelHelpers.export(exports, "RefundIconMedium", ()=>RefundIconMedium);
parcelHelpers.export(exports, "RefundIconSmall", ()=>RefundIconSmall);
parcelHelpers.export(exports, "RegistrationForm", ()=>RegistrationForm);
parcelHelpers.export(exports, "RejectedIcon", ()=>RejectedIcon);
parcelHelpers.export(exports, "RejectedVelocityIcon", ()=>RejectedVelocityIcon);
parcelHelpers.export(exports, "ResetConfirmationForm", ()=>ResetConfirmationForm$1);
parcelHelpers.export(exports, "ResetPasswordForm", ()=>ResetPasswordForm);
parcelHelpers.export(exports, "ResetPasswordIcon", ()=>ResetPasswordIcon);
parcelHelpers.export(exports, "ResetPasswordSuccess", ()=>ResetPasswordSuccess$1);
parcelHelpers.export(exports, "RevenueManagementImage", ()=>RevenueManagementImage);
parcelHelpers.export(exports, "ReversalNeededIcon", ()=>ReversalNeededIcon);
parcelHelpers.export(exports, "RoutingNumberImage", ()=>RoutingNumberImage);
parcelHelpers.export(exports, "Search", ()=>Search$1);
parcelHelpers.export(exports, "SearchIcon", ()=>SearchIcon);
parcelHelpers.export(exports, "SearchableSelect", ()=>SearchableSelect$1);
parcelHelpers.export(exports, "SettingsIconSmall", ()=>SettingsIconSmall$1);
parcelHelpers.export(exports, "ShoppingCartIcon", ()=>ShoppingCartIcon);
parcelHelpers.export(exports, "ShortageIcon", ()=>ShortageIcon);
parcelHelpers.export(exports, "Sidebar", ()=>Sidebar);
parcelHelpers.export(exports, "SidebarSingleContent", ()=>SidebarSingleContent$1);
parcelHelpers.export(exports, "SidebarStackContent", ()=>SidebarStackContent$1);
parcelHelpers.export(exports, "SolidDivider", ()=>SolidDivider$1);
parcelHelpers.export(exports, "SortableTableHeading", ()=>SortableTableHeading$1);
parcelHelpers.export(exports, "Spinner", ()=>Spinner$2);
parcelHelpers.export(exports, "Stack", ()=>Stack);
parcelHelpers.export(exports, "StandardCheckoutImage", ()=>StandardCheckoutImage);
parcelHelpers.export(exports, "StateProvinceDropdown", ()=>FormStateDropdown);
parcelHelpers.export(exports, "StatusUnknownIcon", ()=>StatusUnknownIcon);
parcelHelpers.export(exports, "SuccessfulIcon", ()=>SuccessfulIcon);
parcelHelpers.export(exports, "SuccessfulIconMedium", ()=>SuccessfulIconMedium);
parcelHelpers.export(exports, "SuccessfulIconSmall", ()=>SuccessfulIconSmall);
parcelHelpers.export(exports, "Switcher", ()=>Switcher);
parcelHelpers.export(exports, "TabSidebar", ()=>TabSidebar$1);
parcelHelpers.export(exports, "Table", ()=>Table_styled);
parcelHelpers.export(exports, "TableBody", ()=>TableBody_styled);
parcelHelpers.export(exports, "TableCell", ()=>TableCell_styled);
parcelHelpers.export(exports, "TableHead", ()=>TableHead$1);
parcelHelpers.export(exports, "TableHeading", ()=>TableHeading);
parcelHelpers.export(exports, "TableListItem", ()=>TableListItem);
parcelHelpers.export(exports, "TableRow", ()=>TableRow$1);
parcelHelpers.export(exports, "Tabs", ()=>Tabs$1);
parcelHelpers.export(exports, "Text", ()=>Text$1);
parcelHelpers.export(exports, "Timeout", ()=>Timeout$1);
parcelHelpers.export(exports, "TimeoutImage", ()=>TimeoutImage);
parcelHelpers.export(exports, "Title", ()=>Title$1);
parcelHelpers.export(exports, "ToastNotification", ()=>ToastNotification);
parcelHelpers.export(exports, "ToggleSwitch", ()=>ToggleSwitch$1);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
parcelHelpers.export(exports, "TrashIcon", ()=>TrashIcon$1);
parcelHelpers.export(exports, "TrashIconV2", ()=>TrashIconV2$1);
parcelHelpers.export(exports, "TypeaheadInput", ()=>TypeaheadInput);
parcelHelpers.export(exports, "VerifiedEmailIcon", ()=>VerifiedEmailIcon$1);
parcelHelpers.export(exports, "VisaLargeIcon", ()=>VisaLargeIcon);
parcelHelpers.export(exports, "VisaSmallIcon", ()=>VisaSmallIcon);
parcelHelpers.export(exports, "VoidedIcon", ()=>VoidedIcon);
parcelHelpers.export(exports, "WalletBadgeIcon", ()=>WalletBadgeIcon);
parcelHelpers.export(exports, "WalletBannerIcon", ()=>WalletBannerIcon$1);
parcelHelpers.export(exports, "WalletIcon", ()=>WalletIcon$1);
parcelHelpers.export(exports, "WalletIconSmall", ()=>WalletIconSmall$1);
parcelHelpers.export(exports, "WalletName", ()=>WalletName);
parcelHelpers.export(exports, "WarningIconXS", ()=>WarningIconXS);
parcelHelpers.export(exports, "WelcomeModule", ()=>WelcomeModule$1);
parcelHelpers.export(exports, "WireSmallIcon", ()=>WireSmallIcon);
parcelHelpers.export(exports, "WorkflowTile", ()=>WorkflowTile);
parcelHelpers.export(exports, "XCircleIconMedium", ()=>XCircleIconMedium);
parcelHelpers.export(exports, "XCircleIconSmall", ()=>XCircleIconSmall);
parcelHelpers.export(exports, "cardRegistry", ()=>cardRegistry);
parcelHelpers.export(exports, "constants", ()=>index);
parcelHelpers.export(exports, "hooks", ()=>index$1);
parcelHelpers.export(exports, "util", ()=>index$2);
parcelHelpers.export(exports, "withWindowSize", ()=>withWindowSize);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styledTheming = require("styled-theming");
var _styledThemingDefault = parcelHelpers.interopDefault(_styledTheming);
var _reactRouterDom = require("react-router-dom");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var global = arguments[3];
var process = require("2eecbd38bdd28a8f");
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/*
Need to add a new color? Visit http://chir.ag/projects/name-that-color to generate a color name.

Name already taken? If you can't use the existing color, then use thesaurus.com to pick a similar name
to the one generated by name-that-color.
*/ var BLACK = "#000000";
var TRANSPARENT = "transparent";
var LINK_WATER = "#FEFEFE";
var WHITE = "#FFFFFF";
var SOLITUDE_WHITE = "#EBEDF1";
var SEASHELL_WHITE = "#F1F1F1";
var ALABASTER_WHITE = "#F7F7F7";
var AQUA_HAZE_WHITE = "#F7F9FA";
var BLEACH_WHITE = "#FEF4d7";
var CATSKILL_WHITE = "#EAF2F6";
var HALF_COLONIAL_WHITE = "#FDF4D2";
// GREY
var ATHENS_GREY = "#F6F6F9"; // CBS-100
var ALTO_GREY = "#d1d1d1";
var SILVER_GREY = "#cdcdcd";
var PEWTER_GREY = "#DFE1E4";
var ASH_GREY = "#979797";
var IRON_GREY = "#d5d8dc";
var GHOST_GREY = "#CACED8"; // CBS-300
var DUSTY_GREY = "#9B9B9B";
var REGENT_GREY = "#959EA7";
var STORM_GREY = "#6D717E"; // CBS-700
var TROUT_GREY = "#515660";
var MINESHAFT_GREY = "#333333";
var SOOT_GREY = "#999999";
var FIREFLY_GREY = "#091325";
var BRIGHT_GREY = "#3B414D"; // CBS-800
var CHARADE_GREY = "#292A33"; // CBS-900
var GRECIAN_GREY = "#E5E7EC"; // CBS-200
var BLACK_SQUEEZE = "#EAF2F7";
var GREY_CHATEAU = "#959CA8"; // CBS-500
var COOL_GREY_05 = "#fbfcfd"; // CBS-050
var MANATEE_GREY = "#878E9B"; // CB-60 (cool)
// BLUE
var CLOUDBURST_BLUE = "#26395c";
var ZODIAC_BLUE = "#14284b";
var CONGRESS_BLUE = "#005095";
var SCIENCE_BLUE = "#0074D9";
var MARINER_BLUE = "#2E75D2";
var CURIOUS_BLUE = "#27A9E1";
var SELAGO_BLUE = "#F2F8FD";
var ONAHAU_BLUE = "#D1ECFF";
var MOON_RAKER = "#C4CEF4";
var PICKLED_BLUE = "#2C3E50";
var CERULEAN_BLUE = "#0D8DC4";
var FOAM_BLUE = "#EFF4FD";
var CELLO_BLUE = "#214566";
var BOSTON_BLUE = "#357fb8";
var INFO_BLUE = "#E4F4FD";
var CORNFLOWER_BLUE = "#EBEFFB";
var HOVER_LIGHT_BLUE = "#EFFAFF";
var MATISSE_BLUE = "#15749D";
var MATISSE_BLUE_DARK = "#105C7D";
var ROYAL_BLUE = "#3181E3";
var ROYAL_BLUE_VIVID = "#3B5BDB";
var ASTRAL_BLUE = "#3176AA";
var SAPPHIRE_BLUE = "#116285";
var PEACOCK_BLUE = "#0E506D";
var HAWKES_BLUE = "#D9D9FB";
// GREEN
var FOREST_GREEN = "#19b03F";
var MEADOW_GREEN = "#16C98D";
var POLAR_GREEN = "#DCF7EE";
var ICE_GREEN = "#A4F6DF";
var HAZE_GREEN = "#05A670";
var EMERALD_GREEN = "#47B872";
var HINT_GREEN = "#E8FFEF";
var SEA_GREEN = "#317D4F";
// YELLOW
var SELECTIVE_YELLOW = "#F8B700";
var MUSTARD_YELLOW = "#FFD459";
var FIRE_YELLOW = "#B34A00";
// ORANGE
var CARROT_ORANGE = "#ED9620";
var ZEST_ORANGE = "#B84A00";
var APRICOT_ORANGE = "#FFE8D8";
// RED
var RED = "#FF0000";
var CRIMSON_RED = "#ED1C24";
var THUNDERBIRD_RED = "#C3191F";
var RAZZMATAZZ_RED = "#D11053";
var RASPBERRY = "#ED125F";
var FANTASY_RED = "#FCF4F4";
var COSMOS_RED = "#FFD0D3";
var BLUSH_RED = "#FFF0F5";
// PURPLE
var LUCKY_POINT = "#281978";
var LUCKY_POINT_DARK = "#201460";
// Second level color constants
var ERROR_COLOR = RAZZMATAZZ_RED;
var ERROR_BACKGROUND_COLOR = "#FFF4F8";
// These colors are sequestered so that the alert component can reference them // by type of alert
var ALERT_COLORS = {
    warn: {
        background: APRICOT_ORANGE,
        border: ZEST_ORANGE,
        iconBackground: MUSTARD_YELLOW,
        iconFill: CARROT_ORANGE
    },
    info: {
        background: INFO_BLUE,
        border: CURIOUS_BLUE,
        iconBackground: ONAHAU_BLUE,
        iconFill: CONGRESS_BLUE
    },
    error: {
        background: BLUSH_RED,
        border: RAZZMATAZZ_RED,
        iconBackground: COSMOS_RED,
        iconFill: THUNDERBIRD_RED
    },
    success: {
        background: HINT_GREEN,
        border: EMERALD_GREEN,
        iconBackground: ICE_GREEN,
        iconFill: HAZE_GREEN
    },
    text: ZODIAC_BLUE,
    link: SCIENCE_BLUE
};
// These colors match the pill components seen in CityBase UI designs.
var PILL_COLORS = {
    danger: {
        background: BLUSH_RED,
        text: RAZZMATAZZ_RED
    },
    neutral: {
        background: GRECIAN_GREY,
        text: CHARADE_GREY
    },
    success: {
        background: HINT_GREEN,
        text: SEA_GREEN
    },
    warning: {
        background: HALF_COLONIAL_WHITE,
        text: ZEST_ORANGE
    }
};
var colors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BLACK: BLACK,
    TRANSPARENT: TRANSPARENT,
    WHITE: WHITE,
    LINK_WATER: LINK_WATER,
    SOLITUDE_WHITE: SOLITUDE_WHITE,
    SEASHELL_WHITE: SEASHELL_WHITE,
    ALABASTER_WHITE: ALABASTER_WHITE,
    AQUA_HAZE_WHITE: AQUA_HAZE_WHITE,
    BLEACH_WHITE: BLEACH_WHITE,
    CATSKILL_WHITE: CATSKILL_WHITE,
    CORNFLOWER_BLUE: CORNFLOWER_BLUE,
    HALF_COLONIAL_WHITE: HALF_COLONIAL_WHITE,
    ATHENS_GREY: ATHENS_GREY,
    ALTO_GREY: ALTO_GREY,
    SILVER_GREY: SILVER_GREY,
    PEWTER_GREY: PEWTER_GREY,
    ASH_GREY: ASH_GREY,
    IRON_GREY: IRON_GREY,
    GHOST_GREY: GHOST_GREY,
    DUSTY_GREY: DUSTY_GREY,
    REGENT_GREY: REGENT_GREY,
    STORM_GREY: STORM_GREY,
    TROUT_GREY: TROUT_GREY,
    MINESHAFT_GREY: MINESHAFT_GREY,
    FIREFLY_GREY: FIREFLY_GREY,
    SOOT_GREY: SOOT_GREY,
    BRIGHT_GREY: BRIGHT_GREY,
    CHARADE_GREY: CHARADE_GREY,
    GRECIAN_GREY: GRECIAN_GREY,
    COOL_GREY_05: COOL_GREY_05,
    MANATEE_GREY: MANATEE_GREY,
    BLACK_SQUEEZE: BLACK_SQUEEZE,
    GREY_CHATEAU: GREY_CHATEAU,
    CLOUDBURST_BLUE: CLOUDBURST_BLUE,
    INFO_BLUE: INFO_BLUE,
    ZODIAC_BLUE: ZODIAC_BLUE,
    CONGRESS_BLUE: CONGRESS_BLUE,
    SCIENCE_BLUE: SCIENCE_BLUE,
    MARINER_BLUE: MARINER_BLUE,
    CURIOUS_BLUE: CURIOUS_BLUE,
    SELAGO_BLUE: SELAGO_BLUE,
    ONAHAU_BLUE: ONAHAU_BLUE,
    MOON_RAKER: MOON_RAKER,
    PICKLED_BLUE: PICKLED_BLUE,
    CERULEAN_BLUE: CERULEAN_BLUE,
    FOAM_BLUE: FOAM_BLUE,
    CELLO_BLUE: CELLO_BLUE,
    BOSTON_BLUE: BOSTON_BLUE,
    HOVER_LIGHT_BLUE: HOVER_LIGHT_BLUE,
    MATISSE_BLUE: MATISSE_BLUE,
    MATISSE_BLUE_DARK: MATISSE_BLUE_DARK,
    ROYAL_BLUE: ROYAL_BLUE,
    ROYAL_BLUE_VIVID: ROYAL_BLUE_VIVID,
    ASTRAL_BLUE: ASTRAL_BLUE,
    SAPPHIRE_BLUE: SAPPHIRE_BLUE,
    PEACOCK_BLUE: PEACOCK_BLUE,
    HAWKES_BLUE: HAWKES_BLUE,
    FOREST_GREEN: FOREST_GREEN,
    MEADOW_GREEN: MEADOW_GREEN,
    POLAR_GREEN: POLAR_GREEN,
    ICE_GREEN: ICE_GREEN,
    HAZE_GREEN: HAZE_GREEN,
    EMERALD_GREEN: EMERALD_GREEN,
    HINT_GREEN: HINT_GREEN,
    SEA_GREEN: SEA_GREEN,
    SELECTIVE_YELLOW: SELECTIVE_YELLOW,
    MUSTARD_YELLOW: MUSTARD_YELLOW,
    FIRE_YELLOW: FIRE_YELLOW,
    CARROT_ORANGE: CARROT_ORANGE,
    ZEST_ORANGE: ZEST_ORANGE,
    APRICOT_ORANGE: APRICOT_ORANGE,
    RED: RED,
    CRIMSON_RED: CRIMSON_RED,
    THUNDERBIRD_RED: THUNDERBIRD_RED,
    RAZZMATAZZ_RED: RAZZMATAZZ_RED,
    FANTASY_RED: FANTASY_RED,
    COSMOS_RED: COSMOS_RED,
    BLUSH_RED: BLUSH_RED,
    RASPBERRY: RASPBERRY,
    ALERT_COLORS: ALERT_COLORS,
    PILL_COLORS: PILL_COLORS,
    ERROR_COLOR: ERROR_COLOR,
    ERROR_BACKGROUND_COLOR: ERROR_BACKGROUND_COLOR,
    LUCKY_POINT: LUCKY_POINT,
    LUCKY_POINT_DARK: LUCKY_POINT_DARK
});
var IconChevron = function IconChevron(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? STORM_GREY : _ref$fill;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        id: "icon-chevron"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        id: "icon-chevron-path-1",
        points: "10.4099998 6 9 7.40999976 13.5799996 11.9999996 9 16.5899995 10.4099998 17.9999993 16.4099994 11.9999996"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "icon-chevron-Icon/Chevron-Down",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "icon-chevron-mask-2",
        fill: WHITE
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#icon-chevron-path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        id: "icon-chevron-Fill-2",
        fill: PICKLED_BLUE,
        xlinkHref: "#icon-chevron-path-1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Colors/Blue-Dark",
        mask: "url(#icon-chevron-mask-2)",
        fill: fill
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        id: "icon-chevron-rect",
        width: "24",
        height: "24"
    }))));
};
var IconNeutral = function IconNeutral(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? ALTO_GREY : _ref$fill, _ref$width = _ref.width, width = _ref$width === void 0 ? "18" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "18" : _ref$height, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? "0" : _ref$margin;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            margin: margin
        },
        "aria-label": "Neutral"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: fill,
        fillRule: "nonzero",
        stroke: fill
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "9",
        cy: "9",
        r: "8.5"
    })))));
};
var IconValid = function IconValid(_ref) {
    var _ref$bgFill = _ref.bgFill, bgFill = _ref$bgFill === void 0 ? FOREST_GREEN : _ref$bgFill, _ref$iconFill = _ref.iconFill, iconFill = _ref$iconFill === void 0 ? WHITE : _ref$iconFill, _ref$width = _ref.width, width = _ref$width === void 0 ? "18" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "18" : _ref$height, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? "0" : _ref$margin;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            margin: margin
        },
        "aria-label": "Valid"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-538.000000, -996.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(457.000000, 938.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(81.000000, 20.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(0.000000, 38.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        stroke: bgFill,
        fill: bgFill,
        fillRule: "nonzero",
        cx: "9",
        cy: "9",
        r: "8.5"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(2.000000, 2.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        points: "0 0 14 0 14 14 0 14"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        fill: iconFill,
        points: "5.25 9.4325 2.8175 7 1.98916667 7.8225 5.25 11.0833333 12.25 4.08333333 11.4275 3.26083333"
    }))))))));
};
var IconInvalid = function IconInvalid(_ref) {
    var _ref$bgFill = _ref.bgFill, bgFill = _ref$bgFill === void 0 ? RAZZMATAZZ_RED : _ref$bgFill, _ref$iconFill = _ref.iconFill, iconFill = _ref$iconFill === void 0 ? WHITE : _ref$iconFill, _ref$width = _ref.width, width = _ref$width === void 0 ? "18" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "18" : _ref$height, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? "0" : _ref$margin;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 18",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            margin: margin
        },
        "aria-label": "Invalid"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-538.000000, -1064.000000)",
        fillRule: "nonzero"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(457.000000, 938.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(81.000000, 20.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(0.000000, 106.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        stroke: bgFill,
        fill: bgFill,
        cx: "9",
        cy: "9",
        r: "8.5"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(2.000000, 2.000000)",
        fill: iconFill
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7.58333333,7.58333333 L7.58333333,11.6666667 L6.41666667,11.6666667 L6.41666667,7.58333333 L2.33333333,7.58333333 L2.33333333,6.41666667 L6.41666667,6.41666667 L6.41666667,2.33333333 L7.58333333,2.33333333 L7.58333333,6.41666667 L11.6666667,6.41666667 L11.6666667,7.58333333 L7.58333333,7.58333333 Z",
        transform: "translate(7.000000, 7.000000) rotate(45.000000) translate(-7.000000, -7.000000) "
    }))))))));
};
var AlertInfoIcon = function AlertInfoIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,0 12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 Z M13,10 L13,16 L14,16 L14,18 L10,18 L10,16 L11,16 L11,12 L10,12 L10,10 L13,10 Z M13,6 L13,8 L11,8 L11,6 L13,6 Z",
        id: "path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Alert/Informational",
        transform: "translate(-24.000000, -34.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icon/Information-Container",
        transform: "translate(24.000000, 34.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        id: "background-2",
        fill: "#15749d",
        fillRule: "nonzero",
        xlinkHref: "#path-1"
    })))));
};
var AlertErrorIcon = function AlertErrorIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M15.5714286,7 L12,10.572 L8.42857143,7 L7,8.42857143 L10.571,12 L7,15.5714286 L8.42857143,17 L11.999,13.428 L15.5714286,17 L17,15.5714286 L13.428,12 L17,8.42857143 L15.5714286,7 Z",
        id: "path-1-error-icon"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Alert/Error",
        transform: "translate(-24.000000, -32.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icon/Error-Container",
        transform: "translate(24.000000, 32.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#path-1-error-icon"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        id: "icon---error",
        fill: "#ED125F",
        fillRule: "nonzero",
        xlinkHref: "#path-1-error-icon"
    })))));
};
var AlertSuccessIcon = function AlertSuccessIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,0 12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 Z M16.9497475,7.46446609 L18.363961,8.87867966 L9.87867966,17.363961 L5.63603897,13.1213203 L7.05025253,11.7071068 L9.87803897,14.5354661 L16.9497475,7.46446609 Z",
        id: "alertSuccess"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Alert/Success",
        transform: "translate(-24.000000, -34.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icon/Success-Container",
        transform: "translate(24.000000, 34.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#alertSuccess"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        id: "background-2",
        fill: "#47B872",
        fillRule: "nonzero",
        xlinkHref: "#alertSuccess"
    })))));
};
var AlertWarningIcon = function AlertWarningIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24px",
        height: "21px",
        viewBox: "0 0 24 21",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Symbols",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Alert/Warning",
        transform: "translate(-24.000000, -36.000000)",
        fill: "#F47820",
        fillRule: "nonzero"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icon/Warning-Container",
        transform: "translate(24.000000, 34.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M13.0106463,2.58294345 C13.3063934,2.75612993 13.5526739,3.00241046 13.7258604,3.29815753 L23.0814452,19.2745017 C23.6396097,20.2276681 23.3193975,21.4528439 22.3662311,22.0110084 C22.0596748,22.1905246 21.7108352,22.285148 21.3555848,22.285148 L2.64441521,22.285148 C1.53984571,22.285148 0.64441521,21.3897175 0.64441521,20.285148 C0.64441521,19.9298976 0.739038571,19.581058 0.918554829,19.2745017 L10.2741396,3.29815753 C10.8323042,2.34499116 12.0574799,2.02477891 13.0106463,2.58294345 Z M13,17 L11,17 L11,19 L13,19 L13,17 Z M13,7 L11,7 L11,15 L13,15 L13,7 Z",
        id: "icon---warning"
    })))));
};
var IconQuit = function IconQuit(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? MINESHAFT_GREY : _ref$fill, _ref$width = _ref.width, width = _ref$width === void 0 ? "24px" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "24px" : _ref$height;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "quit",
        d: "M18.9999989 6.40999946L17.589999 4.9999997 11.9999993 10.5899995 6.40999946 4.9999997 4.9999997 6.40999946 10.5899995 11.9999993 4.9999997 17.589999 6.40999946 18.9999989 11.9999993 13.409999 17.589999 18.9999989 18.9999989 17.589999 13.409999 11.9999993z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "quitMask",
        fill: "#fff"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#quit"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: fill,
        xlinkHref: "#quit"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: fill,
        mask: "url(#quitMask)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 0H24V24H0z"
    }))));
};
var AlertIcons = {
    error: AlertErrorIcon,
    info: AlertInfoIcon,
    success: AlertSuccessIcon,
    warn: AlertWarningIcon
};
var _excluded = [
    "activeStyles",
    "focusStyles",
    "hoverStyles",
    "disabledStyles",
    "extraStyles",
    "borderSize",
    "borderColor",
    "borderWidthOverride",
    "borderRadius",
    "textAlign",
    "boxShadow",
    "minHeight",
    "minWidth",
    "maxWidth",
    "padding",
    "hiddenStyles",
    "ariaControls",
    "ariaLabel"
];
/*
  The child span selector on hover styles targets the text inside of buttons when a button is hovered,
  as long as the box wrapper has an "as" prop equal to "button"

  The extracting of props and the disabling of the eslint rule is to stop React from complaining about
  unrecognized DOM attributes.
*/ /* eslint-disable no-unused-vars */ var BoxWrapper = (0, _styledComponentsDefault.default)(/*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var activeStyles = _ref.activeStyles, focusStyles = _ref.focusStyles, hoverStyles = _ref.hoverStyles, disabledStyles = _ref.disabledStyles, extraStyles = _ref.extraStyles, borderSize = _ref.borderSize, borderColor = _ref.borderColor, borderWidthOverride = _ref.borderWidthOverride, borderRadius = _ref.borderRadius, textAlign = _ref.textAlign, boxShadow = _ref.boxShadow, minHeight = _ref.minHeight, minWidth = _ref.minWidth, maxWidth = _ref.maxWidth, padding = _ref.padding, hiddenStyles = _ref.hiddenStyles, ariaControls = _ref.ariaControls, ariaLabel = _ref.ariaLabel, props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        ref: ref,
        "aria-controls": ariaControls,
        "aria-label": ariaLabel
    }, props));
})).withConfig({
    displayName: "Boxstyled__BoxWrapper",
    componentId: "sc-1f9ij0d-0"
})([
    "position:relative;box-sizing:border-box;padding:",
    ";border:",
    ";box-shadow:",
    ";background-color:",
    ";min-height:",
    ";",
    " min-width:",
    ";max-width:",
    ";color:",
    ";border-radius:",
    ";border-width:",
    ";text-align:",
    ";&:hover{",
    "}&:focus{",
    "}&:active{",
    "}&:disabled{",
    '}&[aria-disabled="true"]{',
    "}& *{color:",
    ";}",
    " ",
    ""
], function(_ref2) {
    var padding = _ref2.padding;
    return padding;
}, function(_ref3) {
    var border = _ref3.border, borderSize = _ref3.borderSize, borderColor = _ref3.borderColor;
    return border ? border : "".concat(borderSize, " solid ").concat(borderColor);
}, function(_ref4) {
    var boxShadow = _ref4.boxShadow;
    return boxShadow;
}, function(_ref5) {
    var background = _ref5.background;
    return background;
}, function(_ref6) {
    var minHeight = _ref6.minHeight;
    return minHeight ? minHeight : "auto";
}, function(_ref7) {
    var width = _ref7.width;
    return width && "width: ".concat(width, ";");
}, function(_ref8) {
    var minWidth = _ref8.minWidth;
    return minWidth ? minWidth : "auto";
}, function(_ref9) {
    var maxWidth = _ref9.maxWidth;
    return maxWidth ? maxWidth : "auto";
}, function(_ref10) {
    var color = _ref10.color;
    return color;
}, function(_ref11) {
    var borderRadius = _ref11.borderRadius;
    return borderRadius;
}, function(_ref12) {
    var borderWidthOverride = _ref12.borderWidthOverride;
    return borderWidthOverride;
}, function(_ref13) {
    var textAlign = _ref13.textAlign;
    return textAlign;
}, function(_ref14) {
    var hoverStyles = _ref14.hoverStyles, as = _ref14.as, disabled = _ref14.disabled;
    return (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], hoverStyles, as === "button" && !disabled ? "> * > span {\n          ".concat(hoverStyles, "\n          border: none;\n          outline: none;\n          box-shadow: none;\n        }") : "");
}, function(_ref15) {
    var focusStyles = _ref15.focusStyles, as = _ref15.as;
    return (0, _styledComponents.css)([
        "",
        " outline:3px solid ",
        ";outline-offset:2px;",
        ""
    ], focusStyles, ROYAL_BLUE, as === "button" && "\n          > * > span {\n          border: none;\n          outline: none;\n          box-shadow: none;\n        }");
}, function(_ref16) {
    var activeStyles = _ref16.activeStyles, as = _ref16.as;
    return (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], activeStyles, as === "button" ? "        > * > span {\n          ".concat(activeStyles, "\n          border: none;\n          outline: none;\n          box-shadow: none;\n        }") : "");
}, function(_ref17) {
    var disabledStyles = _ref17.disabledStyles, as = _ref17.as;
    return (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], disabledStyles, as === "button" ? "        > * > span {\n          ".concat(disabledStyles, "\n          border: none;\n          outline: none;\n          box-shadow: none;\n        }") : "");
}, function(_ref18) {
    var disabledStyles = _ref18.disabledStyles, as = _ref18.as;
    return (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], disabledStyles, as === "button" ? "        > * > span {\n          ".concat(disabledStyles, "\n          border: none;\n          outline: none;\n          box-shadow: none;\n        }") : "");
}, function(_ref19) {
    var color = _ref19.color;
    return color;
}, function(_ref20) {
    var hiddenStyles = _ref20.hiddenStyles;
    return hiddenStyles && (0, _styledComponents.css)([
        "display:none;"
    ]);
}, function(_ref21) {
    var extraStyles = _ref21.extraStyles;
    return (0, _styledComponents.css)([
        "",
        ""
    ], extraStyles);
});
/* eslint-enable no-unused-vars */ var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var numeral = createCommonjsModule(function(module) {
    /*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
        if (module.exports) module.exports = factory();
        else global.numeral = factory();
    })(commonjsGlobal, function() {
        /************************************
        Variables
    ************************************/ var numeral, _, VERSION = "2.0.6", formats = {}, locales = {}, defaults = {
            currentLocale: "en",
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: "0,0",
            scalePercentBy100: true
        }, options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };
        /************************************
        Constructors
    ************************************/ // Numeral prototype object
        function Numeral(input, number) {
            this._input = input;
            this._value = number;
        }
        numeral = function(input) {
            var value, kind, unformatFunction, regexp;
            if (numeral.isNumeral(input)) value = input.value();
            else if (input === 0 || typeof input === "undefined") value = 0;
            else if (input === null || _.isNaN(input)) value = null;
            else if (typeof input === "string") {
                if (options.zeroFormat && input === options.zeroFormat) value = 0;
                else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, "").length) value = null;
                else {
                    for(kind in formats){
                        regexp = typeof formats[kind].regexps.unformat === "function" ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                        if (regexp && input.match(regexp)) {
                            unformatFunction = formats[kind].unformat;
                            break;
                        }
                    }
                    unformatFunction = unformatFunction || numeral._.stringToNumber;
                    value = unformatFunction(input);
                }
            } else value = Number(input) || null;
            return new Numeral(input, value);
        };
        // version number
        numeral.version = VERSION;
        // compare numeral object
        numeral.isNumeral = function(obj) {
            return obj instanceof Numeral;
        };
        // helper functions
        numeral._ = _ = {
            // formats numbers separators, decimals places, signs, abbreviations
            numberToFormat: function(value, format, roundingFunction) {
                var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = "", neg = false, abbrForce, abs, int, precision, signed, thousands, output;
                // make sure we never format a null value
                value = value || 0;
                abs = Math.abs(value);
                // see if we should use parentheses for negative number or if we should prefix with a sign
                // if both are present we default to parentheses
                if (numeral._.includes(format, "(")) {
                    negP = true;
                    format = format.replace(/[\(|\)]/g, "");
                } else if (numeral._.includes(format, "+") || numeral._.includes(format, "-")) {
                    signed = numeral._.includes(format, "+") ? format.indexOf("+") : value < 0 ? format.indexOf("-") : -1;
                    format = format.replace(/[\+|\-]/g, "");
                }
                // see if abbreviation is wanted
                if (numeral._.includes(format, "a")) {
                    abbrForce = format.match(/a(k|m|b|t)?/);
                    abbrForce = abbrForce ? abbrForce[1] : false;
                    // check for space before abbreviation
                    if (numeral._.includes(format, " a")) abbr = " ";
                    format = format.replace(new RegExp(abbr + "a[kmbt]?"), "");
                    if (abs >= trillion && !abbrForce || abbrForce === "t") {
                        // trillion
                        abbr += locale.abbreviations.trillion;
                        value = value / trillion;
                    } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === "b") {
                        // billion
                        abbr += locale.abbreviations.billion;
                        value = value / billion;
                    } else if (abs < billion && abs >= million && !abbrForce || abbrForce === "m") {
                        // million
                        abbr += locale.abbreviations.million;
                        value = value / million;
                    } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === "k") {
                        // thousand
                        abbr += locale.abbreviations.thousand;
                        value = value / thousand;
                    }
                }
                // check for optional decimals
                if (numeral._.includes(format, "[.]")) {
                    optDec = true;
                    format = format.replace("[.]", ".");
                }
                // break number and format
                int = value.toString().split(".")[0];
                precision = format.split(".")[1];
                thousands = format.indexOf(",");
                leadingCount = (format.split(".")[0].split(",")[0].match(/0/g) || []).length;
                if (precision) {
                    if (numeral._.includes(precision, "[")) {
                        precision = precision.replace("]", "");
                        precision = precision.split("[");
                        decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                    } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                    int = decimal.split(".")[0];
                    if (numeral._.includes(decimal, ".")) decimal = locale.delimiters.decimal + decimal.split(".")[1];
                    else decimal = "";
                    if (optDec && Number(decimal.slice(1)) === 0) decimal = "";
                } else int = numeral._.toFixed(value, 0, roundingFunction);
                // check abbreviation again after rounding
                if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                    int = String(Number(int) / 1000);
                    switch(abbr){
                        case locale.abbreviations.thousand:
                            abbr = locale.abbreviations.million;
                            break;
                        case locale.abbreviations.million:
                            abbr = locale.abbreviations.billion;
                            break;
                        case locale.abbreviations.billion:
                            abbr = locale.abbreviations.trillion;
                            break;
                    }
                }
                // format number
                if (numeral._.includes(int, "-")) {
                    int = int.slice(1);
                    neg = true;
                }
                if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = "0" + int;
                if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale.delimiters.thousands);
                if (format.indexOf(".") === 0) int = "";
                output = int + decimal + (abbr ? abbr : "");
                if (negP) output = (negP && neg ? "(" : "") + output + (negP && neg ? ")" : "");
                else {
                    if (signed >= 0) output = signed === 0 ? (neg ? "-" : "+") + output : output + (neg ? "-" : "+");
                    else if (neg) output = "-" + output;
                }
                return output;
            },
            // unformats numbers separators, decimals places, signs, abbreviations
            stringToNumber: function(string) {
                var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                }, abbreviation, value, regexp;
                if (options.zeroFormat && string === options.zeroFormat) value = 0;
                else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, "").length) value = null;
                else {
                    value = 1;
                    if (locale.delimiters.decimal !== ".") string = string.replace(/\./g, "").replace(locale.delimiters.decimal, ".");
                    for(abbreviation in abbreviations){
                        regexp = new RegExp("[^a-zA-Z]" + locale.abbreviations[abbreviation] + "(?:\\)|(\\" + locale.currency.symbol + ")?(?:\\))?)?$");
                        if (stringOriginal.match(regexp)) {
                            value *= Math.pow(10, abbreviations[abbreviation]);
                            break;
                        }
                    }
                    // check for negative number
                    value *= (string.split("-").length + Math.min(string.split("(").length - 1, string.split(")").length - 1)) % 2 ? 1 : -1;
                    // remove non numbers
                    string = string.replace(/[^0-9\.]+/g, "");
                    value *= Number(string);
                }
                return value;
            },
            isNaN: function(value) {
                return typeof value === "number" && isNaN(value);
            },
            includes: function(string, search) {
                return string.indexOf(search) !== -1;
            },
            insert: function(string, subString, start) {
                return string.slice(0, start) + subString + string.slice(start);
            },
            reduce: function(array, callback /*, initialValue*/ ) {
                if (this === null) throw new TypeError("Array.prototype.reduce called on null or undefined");
                if (typeof callback !== "function") throw new TypeError(callback + " is not a function");
                var t = Object(array), len = t.length >>> 0, k = 0, value;
                if (arguments.length === 3) value = arguments[2];
                else {
                    while(k < len && !(k in t))k++;
                    if (k >= len) throw new TypeError("Reduce of empty array with no initial value");
                    value = t[k++];
                }
                for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
                return value;
            },
            /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
                var parts = x.toString().split(".");
                return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
            },
            /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
                var args = Array.prototype.slice.call(arguments);
                return args.reduce(function(accum, next) {
                    var mn = _.multiplier(next);
                    return accum > mn ? accum : mn;
                }, 1);
            },
            /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
                var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
                // Use the smallest precision value possible to avoid errors from floating point representation
                if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
                else boundedPrecision = minDecimals;
                power = Math.pow(10, boundedPrecision);
                // Multiply up by precision, round accurately, then divide and use native toFixed():
                output = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
                if (optionals > maxDecimals - boundedPrecision) {
                    optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
                    output = output.replace(optionalsRegExp, "");
                }
                return output;
            }
        };
        // avaliable options
        numeral.options = options;
        // avaliable formats
        numeral.formats = formats;
        // avaliable formats
        numeral.locales = locales;
        // This function sets the current locale.  If
        // no arguments are passed in, it will simply return the current global
        // locale key.
        numeral.locale = function(key) {
            if (key) options.currentLocale = key.toLowerCase();
            return options.currentLocale;
        };
        // This function provides access to the loaded locale data.  If
        // no arguments are passed in, it will simply return the current
        // global locale object.
        numeral.localeData = function(key) {
            if (!key) return locales[options.currentLocale];
            key = key.toLowerCase();
            if (!locales[key]) throw new Error("Unknown locale : " + key);
            return locales[key];
        };
        numeral.reset = function() {
            for(var property in defaults)options[property] = defaults[property];
        };
        numeral.zeroFormat = function(format) {
            options.zeroFormat = typeof format === "string" ? format : null;
        };
        numeral.nullFormat = function(format) {
            options.nullFormat = typeof format === "string" ? format : null;
        };
        numeral.defaultFormat = function(format) {
            options.defaultFormat = typeof format === "string" ? format : "0.0";
        };
        numeral.register = function(type, name, format) {
            name = name.toLowerCase();
            if (this[type + "s"][name]) throw new TypeError(name + " " + type + " already registered.");
            this[type + "s"][name] = format;
            return format;
        };
        numeral.validate = function(val, culture) {
            var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
            //coerce val to string
            if (typeof val !== "string") {
                val += "";
                if (console.warn) console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
            }
            //trim whitespaces from either sides
            val = val.trim();
            //if val is just digits return true
            if (!!val.match(/^\d+$/)) return true;
            //if val is empty return false
            if (val === "") return false;
            //get the decimal and thousands separator from numeral.localeData
            try {
                //check if the culture is understood by numeral. if not, default it to current locale
                localeData = numeral.localeData(culture);
            } catch (e) {
                localeData = numeral.localeData(numeral.locale());
            }
            //setup the delimiters and currency symbol based on culture/locale
            _currSymbol = localeData.currency.symbol;
            _abbrObj = localeData.abbreviations;
            _decimalSep = localeData.delimiters.decimal;
            if (localeData.delimiters.thousands === ".") _thousandSep = "\\.";
            else _thousandSep = localeData.delimiters.thousands;
            // validating currency symbol
            temp = val.match(/^[^\d]+/);
            if (temp !== null) {
                val = val.substr(1);
                if (temp[0] !== _currSymbol) return false;
            }
            //validating abbreviation symbol
            temp = val.match(/[^\d]+$/);
            if (temp !== null) {
                val = val.slice(0, -1);
                if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
            }
            _thousandRegEx = new RegExp(_thousandSep + "{2}");
            if (!val.match(/[^\d.,]/g)) {
                _valArray = val.split(_decimalSep);
                if (_valArray.length > 2) return false;
                else {
                    if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                    else {
                        if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                        else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    }
                }
            }
            return false;
        };
        /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
            clone: function() {
                return numeral(this);
            },
            format: function(inputString, roundingFunction) {
                var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
                // make sure we have a roundingFunction
                roundingFunction = roundingFunction || Math.round;
                // format based on value
                if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
                else if (value === null && options.nullFormat !== null) output = options.nullFormat;
                else {
                    for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;
                        break;
                    }
                    formatFunction = formatFunction || numeral._.numberToFormat;
                    output = formatFunction(value, format, roundingFunction);
                }
                return output;
            },
            value: function() {
                return this._value;
            },
            input: function() {
                return this._input;
            },
            set: function(value) {
                this._value = Number(value);
                return this;
            },
            add: function(value) {
                var corrFactor = _.correctionFactor.call(null, this._value, value);
                function cback(accum, curr, currI, O) {
                    return accum + Math.round(corrFactor * curr);
                }
                this._value = _.reduce([
                    this._value,
                    value
                ], cback, 0) / corrFactor;
                return this;
            },
            subtract: function(value) {
                var corrFactor = _.correctionFactor.call(null, this._value, value);
                function cback(accum, curr, currI, O) {
                    return accum - Math.round(corrFactor * curr);
                }
                this._value = _.reduce([
                    value
                ], cback, Math.round(this._value * corrFactor)) / corrFactor;
                return this;
            },
            multiply: function(value) {
                function cback(accum, curr, currI, O) {
                    var corrFactor = _.correctionFactor(accum, curr);
                    return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
                }
                this._value = _.reduce([
                    this._value,
                    value
                ], cback, 1);
                return this;
            },
            divide: function(value) {
                function cback(accum, curr, currI, O) {
                    var corrFactor = _.correctionFactor(accum, curr);
                    return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
                }
                this._value = _.reduce([
                    this._value,
                    value
                ], cback);
                return this;
            },
            difference: function(value) {
                return Math.abs(numeral(this._value).subtract(value).value());
            }
        };
        /************************************
        Default Locale && Format
    ************************************/ numeral.register("locale", "en", {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                var b = number % 10;
                return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            },
            currency: {
                symbol: "$"
            }
        });
        (function() {
            numeral.register("format", "bps", {
                regexps: {
                    format: /(BPS)/,
                    unformat: /(BPS)/
                },
                format: function(value, format, roundingFunction) {
                    var space = numeral._.includes(format, " BPS") ? " " : "", output;
                    value = value * 10000;
                    // check for space before BPS
                    format = format.replace(/\s?BPS/, "");
                    output = numeral._.numberToFormat(value, format, roundingFunction);
                    if (numeral._.includes(output, ")")) {
                        output = output.split("");
                        output.splice(-1, 0, space + "BPS");
                        output = output.join("");
                    } else output = output + space + "BPS";
                    return output;
                },
                unformat: function(string) {
                    return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
                }
            });
        })();
        (function() {
            var decimal = {
                base: 1000,
                suffixes: [
                    "B",
                    "KB",
                    "MB",
                    "GB",
                    "TB",
                    "PB",
                    "EB",
                    "ZB",
                    "YB"
                ]
            }, binary = {
                base: 1024,
                suffixes: [
                    "B",
                    "KiB",
                    "MiB",
                    "GiB",
                    "TiB",
                    "PiB",
                    "EiB",
                    "ZiB",
                    "YiB"
                ]
            };
            var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
                return decimal.suffixes.indexOf(item) < 0;
            }));
            var unformatRegex = allSuffixes.join("|");
            // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
            unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
            numeral.register("format", "bytes", {
                regexps: {
                    format: /([0\s]i?b)/,
                    unformat: new RegExp(unformatRegex)
                },
                format: function(value, format, roundingFunction) {
                    var output, bytes = numeral._.includes(format, "ib") ? binary : decimal, suffix = numeral._.includes(format, " b") || numeral._.includes(format, " ib") ? " " : "", power, min, max;
                    // check for space before
                    format = format.replace(/\s?i?b/, "");
                    for(power = 0; power <= bytes.suffixes.length; power++){
                        min = Math.pow(bytes.base, power);
                        max = Math.pow(bytes.base, power + 1);
                        if (value === null || value === 0 || value >= min && value < max) {
                            suffix += bytes.suffixes[power];
                            if (min > 0) value = value / min;
                            break;
                        }
                    }
                    output = numeral._.numberToFormat(value, format, roundingFunction);
                    return output + suffix;
                },
                unformat: function(string) {
                    var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                    if (value) {
                        for(power = decimal.suffixes.length - 1; power >= 0; power--){
                            if (numeral._.includes(string, decimal.suffixes[power])) {
                                bytesMultiplier = Math.pow(decimal.base, power);
                                break;
                            }
                            if (numeral._.includes(string, binary.suffixes[power])) {
                                bytesMultiplier = Math.pow(binary.base, power);
                                break;
                            }
                        }
                        value *= bytesMultiplier || 1;
                    }
                    return value;
                }
            });
        })();
        (function() {
            numeral.register("format", "currency", {
                regexps: {
                    format: /(\$)/
                },
                format: function(value, format, roundingFunction) {
                    var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                        before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                        after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                    }, output, symbol, i;
                    // strip format of spaces and $
                    format = format.replace(/\s?\$\s?/, "");
                    // format the number
                    output = numeral._.numberToFormat(value, format, roundingFunction);
                    // update the before and after based on value
                    if (value >= 0) {
                        symbols.before = symbols.before.replace(/[\-\(]/, "");
                        symbols.after = symbols.after.replace(/[\-\)]/, "");
                    } else if (value < 0 && !numeral._.includes(symbols.before, "-") && !numeral._.includes(symbols.before, "(")) symbols.before = "-" + symbols.before;
                    // loop through each before symbol
                    for(i = 0; i < symbols.before.length; i++){
                        symbol = symbols.before[i];
                        switch(symbol){
                            case "$":
                                output = numeral._.insert(output, locale.currency.symbol, i);
                                break;
                            case " ":
                                output = numeral._.insert(output, " ", i + locale.currency.symbol.length - 1);
                                break;
                        }
                    }
                    // loop through each after symbol
                    for(i = symbols.after.length - 1; i >= 0; i--){
                        symbol = symbols.after[i];
                        switch(symbol){
                            case "$":
                                output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                                break;
                            case " ":
                                output = i === symbols.after.length - 1 ? output + " " : numeral._.insert(output, " ", -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                                break;
                        }
                    }
                    return output;
                }
            });
        })();
        (function() {
            numeral.register("format", "exponential", {
                regexps: {
                    format: /(e\+|e-)/,
                    unformat: /(e\+|e-)/
                },
                format: function(value, format, roundingFunction) {
                    var output, exponential = typeof value === "number" && !numeral._.isNaN(value) ? value.toExponential() : "0e+0", parts = exponential.split("e");
                    format = format.replace(/e[\+|\-]{1}0/, "");
                    output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                    return output + "e" + parts[1];
                },
                unformat: function(string) {
                    var parts = numeral._.includes(string, "e+") ? string.split("e+") : string.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
                    power = numeral._.includes(string, "e-") ? power *= -1 : power;
                    function cback(accum, curr, currI, O) {
                        var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                        return num;
                    }
                    return numeral._.reduce([
                        value,
                        Math.pow(10, power)
                    ], cback, 1);
                }
            });
        })();
        (function() {
            numeral.register("format", "ordinal", {
                regexps: {
                    format: /(o)/
                },
                format: function(value, format, roundingFunction) {
                    var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, " o") ? " " : "";
                    // check for space before
                    format = format.replace(/\s?o/, "");
                    ordinal += locale.ordinal(value);
                    output = numeral._.numberToFormat(value, format, roundingFunction);
                    return output + ordinal;
                }
            });
        })();
        (function() {
            numeral.register("format", "percentage", {
                regexps: {
                    format: /(%)/,
                    unformat: /(%)/
                },
                format: function(value, format, roundingFunction) {
                    var space = numeral._.includes(format, " %") ? " " : "", output;
                    if (numeral.options.scalePercentBy100) value = value * 100;
                    // check for space before %
                    format = format.replace(/\s?\%/, "");
                    output = numeral._.numberToFormat(value, format, roundingFunction);
                    if (numeral._.includes(output, ")")) {
                        output = output.split("");
                        output.splice(-1, 0, space + "%");
                        output = output.join("");
                    } else output = output + space + "%";
                    return output;
                },
                unformat: function(string) {
                    var number = numeral._.stringToNumber(string);
                    if (numeral.options.scalePercentBy100) return number * 0.01;
                    return number;
                }
            });
        })();
        (function() {
            numeral.register("format", "time", {
                regexps: {
                    format: /(:)/,
                    unformat: /(:)/
                },
                format: function(value, format, roundingFunction) {
                    var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                    return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
                },
                unformat: function(string) {
                    var timeArray = string.split(":"), seconds = 0;
                    // turn hours and minutes into seconds and add them all up
                    if (timeArray.length === 3) {
                        // hours
                        seconds = seconds + Number(timeArray[0]) * 3600;
                        // minutes
                        seconds = seconds + Number(timeArray[1]) * 60;
                        // seconds
                        seconds = seconds + Number(timeArray[2]);
                    } else if (timeArray.length === 2) {
                        // minutes
                        seconds = seconds + Number(timeArray[0]) * 60;
                        // seconds
                        seconds = seconds + Number(timeArray[1]);
                    }
                    return Number(seconds);
                }
            });
        })();
        return numeral;
    });
});
var noop$1 = function noop1() {};
var round = function round(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return Number(Math.round(Number("".concat(value, "e").concat(decimals))) + "e-".concat(decimals));
};
var formatMoneyString = function formatMoneyString(s) {
    return numeral(s).format("$0,0.00");
};
var convertCentsToMoneyDecimal = function convertCentsToMoneyDecimal(n) {
    return round(n / 100, 2);
};
var displayCurrency = function displayCurrency(cents) {
    return formatMoneyString(convertCentsToMoneyDecimal(cents));
};
var convertCentsToMoneyInt = function convertCentsToMoneyInt(n) {
    return (n / 100).toFixed(0);
};
var formatPercent = function formatPercent(decimal) {
    return Number.parseFloat(decimal).toFixed(2);
};
var createUniqueId = function createUniqueId() {
    return "_" + Math.random().toString(36).substr(2, 9);
};
var createIdFromString = function createIdFromString(text, postscript) {
    var unique = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (text === undefined) return createUniqueId();
    else {
        // "first name", undefined, false -> "first-name"
        // "email address", "error message", false -> "email-address-error-message"
        // "shopping cart", "order item", true -> "shopping-cart-order-item_2ahtlz608"
        var formatIdString = function formatIdString(str) {
            return str && typeof str === "string" ? str.trim().replace(/\s+/g, "-") : "";
        };
        var textIdSegment = formatIdString(text === null || text === void 0 ? void 0 : text.toString());
        var postscriptId = formatIdString(postscript === null || postscript === void 0 ? void 0 : postscript.toString());
        var postscriptIdSegment = postscriptId ? "-".concat(postscriptId) : "";
        var uniqueIdSegment = unique ? createUniqueId() : "";
        return "".concat(textIdSegment).concat(postscriptIdSegment).concat(uniqueIdSegment);
    }
};
var safeChildren = function safeChildren(children) {
    var replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsafeValues = [
        false,
        undefined,
        NaN,
        null
    ];
    if (children && children instanceof Array) return children.map(function(child) {
        return unsafeValues.includes(child) ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), {
            key: createUniqueId()
        }, replacement) : child;
    });
    return unsafeValues.includes(children) ? replacement : children;
};
var generateClickHandler = function generateClickHandler(form, handleErrors, submitForm) {
    return function(e) {
        e.preventDefault();
        var formHasError = Object.values(form.fields).reduce(function(acc, curr) {
            return acc || curr.hasErrors;
        }, false);
        return formHasError ? handleErrors() : submitForm();
    };
};
var checkCardBrand = function checkCardBrand(number) {
    if (/^6011/.test(number)) return "DISCOVER";
    else if (/^5[1-5]/.test(number)) return "MASTERCARD";
    else if (/^4/.test(number)) return "VISA";
    else if (/^3[4,7]/.test(number)) return "AMEX";
    else return "UNKNOWN";
};
var displayCardBrand = function displayCardBrand(number) {
    if (/^6011/.test(number)) return "Discover";
    else if (/^5[1-5]/.test(number)) return "Mastercard";
    else if (/^4/.test(number)) return "Visa";
    else if (/^3[4,7]\d{13}$/.test(number)) return "American Express";
    else return "Unknown";
};
var checkDeniedCards = function checkDeniedCards(name) {
    switch(name){
        case "DISCOVER":
            return /^(?!6011)/;
        case "MASTERCARD":
            return /^(?!5[1-5])/;
        case "VISA":
            return /^(?!4)/;
        case "AMEX":
            return /^(?!3[4,7])/;
        default:
            return "";
    }
};
/*
  An optional style for layout atoms that positions the atom completely off screen
  This will *not* be visible or accessible to sighted users
  Use to contain text content or a11y interactive content (skip links when not visible)
  that is only for users of assistive technologies (screen readers)

  Currently implemented on the Box atom via the srOnly prop
*/ var screenReaderOnlyStyle = "\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n";
var inputPlaceholderTextStyle = "\n  ::-webkit-input-placeholder {\n    color: ".concat(CHARADE_GREY, ";\n  }\n  ::-moz-placeholder {\n    color: ").concat(CHARADE_GREY, ";\n  }\n  ::-ms-placeholder {\n    color: ").concat(CHARADE_GREY, ";\n  }\n  ::placeholder {\n    color: ").concat(CHARADE_GREY, ";\n  }\n");
var inputDisabledStyle = "\n  color: #6e727e;\n  background-color: #f7f7f7;\n  pointer-events: none;\n";
var MOBILE_WIDTH = 768;
var throttle = function throttle(delay, fn) {
    var lastCall = 0;
    return function() {
        var now = new Date().getTime();
        if (now - lastCall < delay) return;
        lastCall = now;
        return fn.apply(void 0, arguments);
    };
};
var titleCaseWord = function titleCaseWord(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
var titleCaseString = function titleCaseString(string) {
    return string.split(" ").map(function(word, index, string) {
        return index === 0 || index === string.length - 1 || word.length > 3 ? titleCaseWord(word.toLowerCase()) : word;
    }).join(" ");
};
var kebabCaseString = function kebabCaseString(string) {
    return string === null || string === void 0 ? void 0 : string.replaceAll(" ", "-").toLowerCase();
};
var wrapIndex = function wrapIndex(index, length) {
    if (index <= -1) return length - 1;
    else if (index >= length) return 0;
    else return index;
};
/**
 * Adjusts a hex color by lightening or darkening it.
 *
 * Intended for use when a satisfactory color is not available in the design system.
 *
 * @param {string} hex - The original hex color (e.g., "#3498db").
 * @param {number} percent - The percentage to adjust the color (0-100).
 * @param {string} action - The action to perform: 'lighten' or 'darken'.
 * @returns {string} - The adjusted hex color.
 * @throws {Error} - Throws an error if the action is not 'lighten' or 'darken'.
 */ var adjustHexColor = function adjustHexColor(hex, percent, action) {
    // Remove hash at the start if present
    hex = hex.replace(/^\s*#/, "");
    // Parse r, g, b values
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    // Adjust RGB values based on the action
    if (action === "darken") {
        r = Math.max(0, Math.floor(r * (1 - percent / 100)));
        g = Math.max(0, Math.floor(g * (1 - percent / 100)));
        b = Math.max(0, Math.floor(b * (1 - percent / 100)));
    } else if (action === "lighten") {
        r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
        g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
        b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));
    } else throw new Error("Action must be either 'lighten' or 'darken'");
    // Convert back to hex
    return "#".concat((16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1).padStart(6, "0"));
};
var arrowBorder = function arrowBorder(borderColor, direction) {
    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "8px";
    var angle = "".concat(width, " solid transparent");
    var straight = "".concat(width, " solid ").concat(borderColor);
    if (direction == "down") return "border-left: ".concat(angle, "; border-right: ").concat(angle, "; border-top: ").concat(straight);
    else if (direction == "up") return "border-left: ".concat(angle, "; border-right: ").concat(angle, "; border-bottom: ").concat(straight);
    else if (direction == "left") return "border-top: ".concat(angle, "; border-bottom: ").concat(angle, "; border-right: ").concat(straight);
    else if (direction == "right") return "border-top: ".concat(angle, "; border-bottom: ").concat(angle, "; border-left: ").concat(straight);
};
var general = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    noop: noop$1,
    round: round,
    displayCurrency: displayCurrency,
    convertCentsToMoneyInt: convertCentsToMoneyInt,
    formatPercent: formatPercent,
    createIdFromString: createIdFromString,
    safeChildren: safeChildren,
    generateClickHandler: generateClickHandler,
    checkCardBrand: checkCardBrand,
    displayCardBrand: displayCardBrand,
    checkDeniedCards: checkDeniedCards,
    screenReaderOnlyStyle: screenReaderOnlyStyle,
    inputPlaceholderTextStyle: inputPlaceholderTextStyle,
    inputDisabledStyle: inputDisabledStyle,
    MOBILE_WIDTH: MOBILE_WIDTH,
    throttle: throttle,
    titleCaseWord: titleCaseWord,
    titleCaseString: titleCaseString,
    kebabCaseString: kebabCaseString,
    wrapIndex: wrapIndex,
    adjustHexColor: adjustHexColor,
    arrowBorder: arrowBorder
});
var _excluded$1 = [
    "autocompleteValue",
    "padding",
    "borderSize",
    "borderColor",
    "borderRadius",
    "boxShadow",
    "background",
    "color",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "borderWidthOverride",
    "border",
    "textAlign",
    "hoverStyles",
    "activeStyles",
    "disabledStyles",
    "focusStyles",
    "variant",
    "as",
    "onClick",
    "onKeyDown",
    "onMouseEnter",
    "onMouseLeave",
    "onFocus",
    "onBlur",
    "onTouchEnd",
    "theme",
    "hiddenStyles",
    "extraStyles",
    "srOnly",
    "dataQa",
    "children"
];
/*
  Box component to create generic boxes
  Supply padding, border, background, and color values

  srOnly prop enables special screen-reader style that is used to position content
  completely off screen (only for users of screen readers)
*/ var Box = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var autocompleteValue = _ref.autocompleteValue, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "16px" : _ref$padding, _ref$borderSize = _ref.borderSize, borderSize = _ref$borderSize === void 0 ? "0px" : _ref$borderSize, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "transparent" : _ref$borderColor, borderRadius = _ref.borderRadius, _ref$boxShadow = _ref.boxShadow, boxShadow = _ref$boxShadow === void 0 ? "none" : _ref$boxShadow, background = _ref.background, color = _ref.color, minHeight = _ref.minHeight, width = _ref.width, minWidth = _ref.minWidth, maxWidth = _ref.maxWidth, borderWidthOverride = _ref.borderWidthOverride, border = _ref.border, textAlign = _ref.textAlign, hoverStyles = _ref.hoverStyles, activeStyles = _ref.activeStyles, disabledStyles = _ref.disabledStyles, focusStyles = _ref.focusStyles, variant = _ref.variant, as = _ref.as, onClick = _ref.onClick, onKeyDown = _ref.onKeyDown, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onTouchEnd = _ref.onTouchEnd, theme = _ref.theme, hiddenStyles = _ref.hiddenStyles, extraStyles = _ref.extraStyles, _ref$srOnly = _ref.srOnly, srOnly = _ref$srOnly === void 0 ? false : _ref$srOnly, dataQa = _ref.dataQa, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$1);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(BoxWrapper, _extends({
        autoComplete: autocompleteValue,
        padding: padding,
        borderSize: borderSize,
        borderColor: borderColor,
        boxShadow: boxShadow,
        color: color,
        minHeight: minHeight,
        width: width,
        minWidth: minWidth,
        maxWidth: maxWidth,
        background: background,
        borderRadius: borderRadius,
        borderWidthOverride: borderWidthOverride,
        border: border,
        hoverStyles: hoverStyles,
        activeStyles: activeStyles,
        disabledStyles: disabledStyles,
        focusStyles: focusStyles,
        variant: variant,
        as: as,
        onClick: onClick,
        hiddenStyles: hiddenStyles,
        onKeyDown: onKeyDown,
        extraStyles: srOnly ? "".concat(screenReaderOnlyStyle).concat(extraStyles) : extraStyles,
        theme: theme,
        textAlign: textAlign,
        "data-qa": dataQa,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        onTouchEnd: onTouchEnd,
        ref: ref
    }, rest), children && safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)));
});
var CenterWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Centerstyled__CenterWrapper",
    componentId: "sc-vawqfc-0"
})([
    "box-sizing:content-box;margin-left:auto;margin-right:auto;width:",
    ";max-width:",
    ";padding-left:",
    ";padding-right:",
    ";",
    ";",
    ""
], function(_ref) {
    var width = _ref.width;
    return width || "auto";
}, function(_ref2) {
    var maxWidth = _ref2.maxWidth;
    return maxWidth;
}, function(_ref3) {
    var gutters = _ref3.gutters;
    return gutters;
}, function(_ref4) {
    var gutters = _ref4.gutters;
    return gutters;
}, function(_ref5) {
    var intrinsic = _ref5.intrinsic;
    return intrinsic ? "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  " : "";
}, function(_ref6) {
    var extraStyles = _ref6.extraStyles;
    return extraStyles;
});
var _excluded$2 = [
    "maxWidth",
    "gutters",
    "intrinsic",
    "children"
];
/*
  Component to horizontally center itself (with auto right and left margins)
  Use intrinsic prop if you want its children that are narrower than the max-width
  to also be centered within the center wrapper itself
*/ var Center = function Center(_ref) {
    var maxWidth = _ref.maxWidth, gutters = _ref.gutters, _ref$intrinsic = _ref.intrinsic, intrinsic = _ref$intrinsic === void 0 ? false : _ref$intrinsic, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$2);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(CenterWrapper, _extends({
        maxWidth: maxWidth,
        gutters: gutters,
        intrinsic: intrinsic
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)));
};
var _excluded$3 = [
    "overflow"
];
/* eslint-disable no-unused-vars */ var ClusterWrapper = (0, _styledComponentsDefault.default)(function(_ref) {
    var overflow = _ref.overflow, props = _objectWithoutProperties(_ref, _excluded$3);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", props);
}).withConfig({
    displayName: "Clusterstyled__ClusterWrapper",
    componentId: "sc-1dkqsm7-0"
})([
    "overflow:",
    ";box-sizing:border-box;justify-self:",
    ";align-self:",
    ";flex-grow:",
    ";",
    ";"
], function(_ref2) {
    var overflow = _ref2.overflow;
    return overflow ? "visible" : "hidden";
}, function(_ref3) {
    var $justifySelf = _ref3.$justifySelf;
    return $justifySelf;
}, function(_ref4) {
    var $alignSelf = _ref4.$alignSelf;
    return $alignSelf;
}, function(_ref5) {
    var $flexGrow = _ref5.$flexGrow;
    return $flexGrow;
}, function(_ref6) {
    var $extraStyles = _ref6.$extraStyles;
    return $extraStyles;
});
var ClusterInnerWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Clusterstyled__ClusterInnerWrapper",
    componentId: "sc-1dkqsm7-1"
})([
    "box-sizing:border-box;display:flex;flex-wrap:",
    ";justify-content:",
    ";align-items:",
    ";margin:calc(",
    " / 2 * -1);min-height:",
    ";min-width:",
    ";> *{margin:calc(",
    " / 2);}"
], function(_ref7) {
    var $nowrap = _ref7.$nowrap;
    return $nowrap ? "nowrap" : "wrap";
}, function(_ref8) {
    var justify = _ref8.justify;
    return justify;
}, function(_ref9) {
    var align = _ref9.align;
    return align;
}, function(_ref10) {
    var childGap = _ref10.childGap;
    return childGap;
}, function(_ref11) {
    var minHeight = _ref11.minHeight;
    return minHeight;
}, function(_ref12) {
    var minWidth = _ref12.minWidth;
    return minWidth;
}, function(_ref13) {
    var childGap = _ref13.childGap;
    return childGap;
});
var _excluded$4 = [
    "justify",
    "align",
    "childGap",
    "minHeight",
    "minWidth",
    "nowrap",
    "overflow",
    "justifySelf",
    "alignSelf",
    "flexGrow",
    "extraStyles",
    "children",
    "innerWrapperAs"
];
/*
  Cluster components suit any groups of elements that differ in
  length and are liable to wrap. Buttons that appear together at the
  end of forms are ideal candidates, as well as lists of tags
  keywords, or other meta information. Use the Cluster to align any
  groups of horizontally laid out elements to the left or right, or
  in the center.
*/ var Cluster = function Cluster(_ref) {
    var justify = _ref.justify, align = _ref.align, childGap = _ref.childGap, minHeight = _ref.minHeight, minWidth = _ref.minWidth, nowrap = _ref.nowrap, _ref$overflow = _ref.overflow, overflow = _ref$overflow === void 0 ? false : _ref$overflow, justifySelf = _ref.justifySelf, alignSelf = _ref.alignSelf, flexGrow = _ref.flexGrow, extraStyles = _ref.extraStyles, children = _ref.children, _ref$innerWrapperAs = _ref.innerWrapperAs, innerWrapperAs = _ref$innerWrapperAs === void 0 ? "div" : _ref$innerWrapperAs, rest = _objectWithoutProperties(_ref, _excluded$4);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ClusterWrapper, _extends({
        overflow: overflow
    }, rest, {
        $justifySelf: justifySelf,
        $alignSelf: alignSelf,
        $flexGrow: flexGrow,
        $extraStyles: extraStyles
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ClusterInnerWrapper, {
        justify: justify,
        align: align,
        childGap: childGap,
        minHeight: minHeight,
        minWidth: minWidth,
        $nowrap: nowrap,
        as: innerWrapperAs
    }, safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null))));
};
var GridWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Gridstyled__GridWrapper",
    componentId: "sc-8iakdj-0"
})([
    "display:grid;grid-gap:",
    ";grid-template-columns:",
    ";@supports (width:min(",
    ",100%)){&{grid-template-columns:repeat( auto-fill,minmax( ",
    ",",
    " ) );}}"
], function(_ref) {
    var columnGap = _ref.columnGap;
    return columnGap;
}, function(_ref2) {
    var aboveMin = _ref2.aboveMin, minColWidth = _ref2.minColWidth, maxColWidth = _ref2.maxColWidth;
    return aboveMin ? "repeat(auto-fill, minmax(".concat(minColWidth, ", ").concat(maxColWidth, "))") : "100%";
}, function(_ref3) {
    var minColWidth = _ref3.minColWidth;
    return minColWidth;
}, function(_ref4) {
    var minColWidth = _ref4.minColWidth;
    return minColWidth;
}, function(_ref5) {
    var maxColWidth = _ref5.maxColWidth;
    return maxColWidth;
});
var _excluded$5 = [
    "columnGap",
    "minColWidth",
    "maxColWidth",
    "children"
];
var Grid = function Grid(_ref) {
    var columnGap = _ref.columnGap, _ref$minColWidth = _ref.minColWidth, minColWidth = _ref$minColWidth === void 0 ? 20 : _ref$minColWidth, _ref$maxColWidth = _ref.maxColWidth, maxColWidth = _ref$maxColWidth === void 0 ? "1fr" : _ref$maxColWidth, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$5);
    var ref = (0, _react.useRef)();
    var _useState = (0, _react.useState)(0), _useState2 = _slicedToArray(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var _useState3 = (0, _react.useState)(true), _useState4 = _slicedToArray(_useState3, 2), aboveMin = _useState4[0], setAboveMin = _useState4[1];
    (0, _react.useLayoutEffect)(function() {
        var currentWidth = ref.current.getBoundingClientRect().width;
        setWidth(currentWidth);
        setAboveMin(currentWidth >= minColWidth * 16);
    }, [
        ref.current,
        width
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(GridWrapper, _extends({
        ref: ref,
        columnGap: columnGap,
        aboveMin: aboveMin,
        minColWidth: typeof minColWidth === "number" ? "".concat(minColWidth, "rem") : minColWidth,
        maxColWidth: typeof maxColWidth === "number" ? "".concat(maxColWidth, "rem") : maxColWidth
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)));
};
var _excluded$6 = [
    "onRight",
    "childGap",
    "contentMinWidth",
    "minHeight",
    "fullHeight"
];
var SidebarWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Sidebarstyled__SidebarWrapper",
    componentId: "sc-1bbn2or-0"
})([
    "overflow:visible;box-sizing:border-box;",
    ""
], function(_ref) {
    var fullHeight = _ref.fullHeight;
    return fullHeight ? "height: 100%;" : "";
});
var SidebarInnerWrapper = (0, _styledComponentsDefault.default)(// eslint-disable-next-line no-unused-vars
function(_ref2) {
    var onRight = _ref2.onRight, childGap = _ref2.childGap, contentMinWidth = _ref2.contentMinWidth, minHeight = _ref2.minHeight, fullHeight = _ref2.fullHeight, props = _objectWithoutProperties(_ref2, _excluded$6);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", props);
}).withConfig({
    displayName: "Sidebarstyled__SidebarInnerWrapper",
    componentId: "sc-1bbn2or-1"
})([
    "display:flex;flex-wrap:wrap;box-sizing:border-box;margin:calc(",
    " / 2 * -1);> *{margin:calc(",
    " / 2);flex-grow:1;",
    ";",
    "}",
    " ",
    ""
], function(_ref3) {
    var childGap = _ref3.childGap;
    return childGap;
}, function(_ref4) {
    var childGap = _ref4.childGap;
    return childGap;
}, function(_ref5) {
    var width = _ref5.width;
    return width ? "flex-basis: ".concat(width) : "";
}, function(_ref6) {
    var minHeight = _ref6.minHeight;
    return minHeight ? "margin-top: 0; margin-bottom: 0;" : "";
}, function(_ref7) {
    var $sidebarOnRight = _ref7.$sidebarOnRight, contentMinWidth = _ref7.contentMinWidth, childGap = _ref7.childGap;
    return $sidebarOnRight ? "> :first-child {\n      flex-basis: 0;\n      flex-grow: 999;\n      min-width: calc(".concat(contentMinWidth, " - ").concat(childGap, ");\n    }\n    ") : "> :last-child {\n      flex-basis: 0;\n      flex-grow: 999;\n      min-width: calc(".concat(contentMinWidth, " - ").concat(childGap, ");\n    }");
}, function(_ref8) {
    var fullHeight = _ref8.fullHeight;
    return fullHeight ? "min-height: 100%;" : "";
});
var _excluded$7 = [
    "childGap",
    "width",
    "sidebarOnRight",
    "contentMinWidth",
    "fullHeight",
    "minHeight",
    "children"
];
/*
  Component to assist in creating layouts with some element and a sidebar next to it
  Sidebar takes a width value, this is the ideal target with, and what the sidebar
  will be sized to on larger/medium screens

  The component also takes a content minimum width, this should be a percentage
  it represents the narrowest the content piece can get before the sidebar wraps to
  the top of the layout. If not supplied, the sidebar will size to the width of its content.

  This can be used for many use cases beyond the typical content/sidebar layout
  Such as for pinning a button/icon next to a form input
*/ var Sidebar = function Sidebar(_ref) {
    var _ref$childGap = _ref.childGap, childGap = _ref$childGap === void 0 ? "1rem" : _ref$childGap, width = _ref.width, _ref$sidebarOnRight = _ref.sidebarOnRight, sidebarOnRight = _ref$sidebarOnRight === void 0 ? false : _ref$sidebarOnRight, _ref$contentMinWidth = _ref.contentMinWidth, contentMinWidth = _ref$contentMinWidth === void 0 ? "50%" : _ref$contentMinWidth, _ref$fullHeight = _ref.fullHeight, fullHeight = _ref$fullHeight === void 0 ? false : _ref$fullHeight, minHeight = _ref.minHeight, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$7);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SidebarWrapper, _extends({
        fullHeight: fullHeight,
        minHeight: minHeight
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement(SidebarInnerWrapper, {
        childGap: childGap,
        width: width,
        $sidebarOnRight: sidebarOnRight,
        contentMinWidth: contentMinWidth,
        fullHeight: fullHeight,
        minHeight: minHeight
    }, safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null))));
};
var StackWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Stackstyled__StackWrapper",
    componentId: "sc-ejhezz-0"
})([
    "box-sizing:border-box;display:flex;flex-direction:",
    ";justify-content:",
    ";height:",
    ";> *{margin-top:0;margin-bottom:0;}> * + *{",
    "}",
    ";",
    ""
], function(_ref) {
    var direction = _ref.direction;
    return direction;
}, function(_ref2) {
    var justify = _ref2.justify;
    return justify ? justify : "flex-start";
}, function(_ref3) {
    var fullHeight = _ref3.fullHeight;
    return fullHeight ? "100%" : "auto";
}, function(_ref4) {
    var direction = _ref4.direction, childGap = _ref4.childGap;
    return direction === "row" ? "margin-left: ".concat(childGap, ";") : "margin-top: ".concat(childGap, ";");
}, function(_ref5) {
    var bottomItem = _ref5.bottomItem, direction = _ref5.direction;
    return bottomItem ? "\n    > :nth-child(".concat(bottomItem, ") {\n        ").concat(direction === "row" ? "margin-left: auto;" : "margin-top: auto;", "\n    }\n  ") : "";
}, function(_ref6) {
    var extraStyles = _ref6.extraStyles;
    return extraStyles;
});
var _excluded$8 = [
    "childGap",
    "bottomItem",
    "fullHeight",
    "children",
    "direction",
    "justify",
    "extraStyles"
];
/*
  Component to impose margin-top between a list of child elements
  Useful for things like sidebars and button lists
  Avoids common pitfalls like having to manually adjust the margin
  on first/last children

  For more information and diagrams:
  https://every-layout.dev/layouts/stack/
*/ var Stack = function Stack(_ref) {
    var _ref$childGap = _ref.childGap, childGap = _ref$childGap === void 0 ? "1rem" : _ref$childGap, bottomItem = _ref.bottomItem, _ref$fullHeight = _ref.fullHeight, fullHeight = _ref$fullHeight === void 0 ? false : _ref$fullHeight, children = _ref.children, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? "column" : _ref$direction, justify = _ref.justify, extraStyles = _ref.extraStyles, rest = _objectWithoutProperties(_ref, _excluded$8);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StackWrapper, _extends({
        childGap: childGap,
        bottomItem: bottomItem,
        fullHeight: fullHeight,
        direction: direction,
        justify: justify,
        extraStyles: extraStyles
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)));
};
var CoverOuterContainer = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Coverstyled__CoverOuterContainer",
    componentId: "sc-1jhq379-0"
})([
    "box-sizing:border-box;display:flex;flex-direction:column;min-height:",
    ";padding:",
    ";min-width:",
    ";> *{margin-top:",
    ";margin-bottom:",
    ";}> :first-child{margin-top:0;}",
    " ",
    " > :last-child{margin-bottom:0;}"
], function(_ref) {
    var minHeight = _ref.minHeight;
    return minHeight;
}, function(_ref2) {
    var padding = _ref2.padding;
    return padding;
}, function(_ref3) {
    var fillCenter = _ref3.fillCenter;
    return fillCenter ? "100%" : "auto";
}, function(_ref4) {
    var childGap = _ref4.childGap;
    return childGap;
}, function(_ref5) {
    var childGap = _ref5.childGap;
    return childGap;
}, function(_ref6) {
    var fillCenter = _ref6.fillCenter;
    return fillCenter ? "> :nth-child(2) {flex-grow: 1;}" : "";
}, function(_ref7) {
    var centerOverride = _ref7.centerOverride;
    return centerOverride ? "> :nth-child(2) {margin-top: 0; margin-bottom: auto;}" : "> :nth-child(2) {margin-top: auto; margin-bottom: auto;}";
});
var _excluded$9 = [
    "minHeight",
    "childGap",
    "padding",
    "fillCenter",
    "singleChild",
    "centerOverride",
    "children"
];
/*
  The Cover component is used when you want to have one center element
  and an optional top/header element and/or an optional bottom/footer element.
  The classic use case is for an "above the fold" page layout in which you have a header, footer, and center content of variable size. When the center content is smaller than
  minHeight, the cover expands to minHeight and centers the content, while anchoring
  the optional top element to the top, and the optional bottom element to the bottom.

  If the center content is taller than minHeight, then the entire cover exapnds, while
  still anchorhing the top and bottom elements where they belong.

  Note: This component is only concerned with vertical centering. To also
  horizontally center your content, combine it with the Center component.
  Therefore childGap only sets vertical margins in this component.

  Props:
  fillCenter: 
      If true instead of centering the middle content it will grow to fill the space
      WARNING: May act unexpectedly if children have flex-grow property on them
*/ var Cover = function Cover(_ref) {
    var _ref$minHeight = _ref.minHeight, minHeight = _ref$minHeight === void 0 ? "100%" : _ref$minHeight, childGap = _ref.childGap, padding = _ref.padding, fillCenter = _ref.fillCenter, singleChild = _ref.singleChild, centerOverride = _ref.centerOverride, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$9);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(CoverOuterContainer, _extends({
        minHeight: minHeight,
        padding: padding,
        childGap: childGap,
        centerOverride: centerOverride,
        fillCenter: fillCenter
    }, rest), singleChild ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)), singleChild ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null));
};
var FrameOuterContainer = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Framestyled__FrameOuterContainer",
    componentId: "sc-1syfnuv-0"
})([
    "box-sizing:border-box;padding-bottom:",
    ";position:relative;> *{overflow:hidden;position:absolute;top:0;right:0;bottom:0;left:0;display:flex;justify-content:center;align-items:center;}> img,> video{width:100%;height:100%;object-fit:cover;}"
], function(_ref) {
    var numerator = _ref.numerator, denominator = _ref.denominator;
    return "calc((".concat(numerator, " / ").concat(denominator, ") * 100%)");
});
var _excluded$a = [
    "numerator",
    "denominator",
    "children"
];
/*
  The Frame component is used for cropping content to a specific aspect ratio.
  The aspect ratio is supplied by the numerator and denominator props.
  (The numerator is the left-hand number and denominator the right-hand number
  in class aspect-ratio notation, e.g., 16:9 or 4:3).

  This component should mostly be used with images or video content.
  However, the CSS makes it possible to use with _any_ type of element.
  This is useful for a situation where your child may be an image, or may be
  a different type of element. A good example is having textual fallback
  content when an image is not available.
*/ var Frame = function Frame(_ref) {
    var _ref$numerator = _ref.numerator, numerator = _ref$numerator === void 0 ? 1 : _ref$numerator, _ref$denominator = _ref.denominator, denominator = _ref$denominator === void 0 ? 1 : _ref$denominator, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$a);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FrameOuterContainer, _extends({
        numerator: numerator,
        denominator: denominator
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)));
};
var SwitcherOuterContainer = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Switcherstyled__SwitcherOuterContainer",
    componentId: "sc-1ym61kc-0"
})([
    "box-sizing:border-box;display:block;"
]);
var SwitcherInnerContainer = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Switcherstyled__SwitcherInnerContainer",
    componentId: "sc-1ym61kc-1"
})([
    "box-sizing:border-box;display:flex;flex-wrap:wrap;overflow:hidden;padding:",
    ";margin:",
    ";",
    " > *{flex-grow:1;",
    ";",
    " ",
    "}",
    " ",
    " ",
    ""
], function(_ref) {
    var padding = _ref.padding;
    return padding;
}, function(_ref2) {
    var childGap = _ref2.childGap;
    return "calc((".concat(childGap, " / 2) * -1)");
}, function(_ref3) {
    var constrainMobile = _ref3.constrainMobile;
    return constrainMobile && "max-width: 100%; margin-left: 0; margin-right: 0;";
}, function(_ref4) {
    var maxChildrenOnly = _ref4.maxChildrenOnly, breakpoint = _ref4.breakpoint, childGap = _ref4.childGap;
    return !maxChildrenOnly ? "flex-basis: calc((".concat(breakpoint, " - (100% - ").concat(childGap, ")) * 999);") : "";
}, function(_ref5) {
    var childGap = _ref5.childGap;
    return "margin: calc(".concat(childGap, " / 2);");
}, function(_ref6) {
    var constrainMobile = _ref6.constrainMobile;
    return constrainMobile && "margin-left: 0; margin-right: 0;";
}, function(_ref7) {
    var largeChild = _ref7.largeChild, largeChildSize = _ref7.largeChildSize;
    return largeChild && largeChildSize ? "> :nth-child(".concat(largeChild, ") {\n      flex-grow: ").concat(largeChildSize, ";\n    }") : "";
}, function(_ref8) {
    var maxChildren = _ref8.maxChildren;
    return maxChildren ? "> :nth-last-child(".concat(maxChildren + 1, "), > :nth-last-child(").concat(maxChildren + 1, ") ~ * {\n      flex-basis: 100%;\n    }") : "";
}, function(_ref9) {
    var extraStyles = _ref9.extraStyles;
    return (0, _styledComponents.css)([
        "",
        ""
    ], extraStyles);
});
var _excluded$b = [
    "breakpoint",
    "childGap",
    "largeChild",
    "largeChildSize",
    "maxChildren",
    "maxChildrenOnly",
    "padding",
    "children",
    "extraStyles",
    "constrainMobile"
];
/*
  The Switcher is a component that is used to toggle between wide and narrow
  layouts based on the size of the surrounding container. In the wide layout,
  the children of the Switcher will be sized to the value specified by childSize.
  The point at which the layout switches is specified by the breakpoint prop.
  The space between child elements is specified with 

  In the wide layout, it is possible to specify that a particular child take up
  more space than its siblings. The largeChild prop takes a child number and
  applies the largeChildSize to its flex-grow property.

  This component also accepts an optional maxChildren prop. This prop specifies the max
  number of children allowed before the component toggles to a vertical list
  layout.

  In the narrow layout, the children of the Switcher will render as a vertical list
  of width: 100%. This component is best used for scenarios when you want to bypass
  intermediate layouts where children may size differently depending on the number of
  children present in a given row.

  Use cases for this component include any situation "in which each child element
  should be considered equal, or part of a continuum. E.g., card components listing
  products/services should share the same width no matter the orientation, otherwise
  one or more cards could be perceived as highlighted or featured in some way. Or
  a set of numbered steps in, for example, a list of items to complete or tasks to do."

  New: Set the "constrainMobile" prop to true in order to prevent switcher content from
  overflowing the mobile viewport:

    <Switcher constrainMobile={isMobile} />
*/ var Switcher = function Switcher(_ref) {
    var _ref$breakpoint = _ref.breakpoint, breakpoint = _ref$breakpoint === void 0 ? "30rem" : _ref$breakpoint, _ref$childGap = _ref.childGap, childGap = _ref$childGap === void 0 ? "1rem" : _ref$childGap, largeChild = _ref.largeChild, largeChildSize = _ref.largeChildSize, maxChildren = _ref.maxChildren, _ref$maxChildrenOnly = _ref.maxChildrenOnly, maxChildrenOnly = _ref$maxChildrenOnly === void 0 ? false : _ref$maxChildrenOnly, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "0" : _ref$padding, children = _ref.children, extraStyles = _ref.extraStyles, _ref$constrainMobile = _ref.constrainMobile, constrainMobile = _ref$constrainMobile === void 0 ? false : _ref$constrainMobile, rest = _objectWithoutProperties(_ref, _excluded$b);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SwitcherOuterContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(SwitcherInnerContainer, _extends({
        breakpoint: breakpoint,
        childGap: childGap,
        largeChild: largeChild,
        largeChildSize: largeChildSize,
        maxChildren: maxChildren,
        maxChildrenOnly: maxChildrenOnly,
        padding: padding,
        extraStyles: extraStyles,
        constrainMobile: constrainMobile
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null))));
};
var ImposterWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Imposterstyled__ImposterWrapper",
    componentId: "sc-1q0gj35-0"
})([
    "position:",
    ";top:",
    ";left:",
    ";display:",
    ";",
    " ",
    " ",
    ";"
], function(_ref) {
    var fixed = _ref.fixed;
    return fixed ? "fixed" : "absolute";
}, function(_ref2) {
    var top = _ref2.top;
    return top;
}, function(_ref3) {
    var left = _ref3.left;
    return left;
}, function(_ref4) {
    var visible = _ref4.visible;
    return visible ? "block" : "none";
}, function(_ref5) {
    var centered = _ref5.centered;
    return centered ? "transform: translate(-50%, -50%);" : "";
}, function(_ref6) {
    var breakout = _ref6.breakout, verticalMargin = _ref6.verticalMargin, horizontalMargin = _ref6.horizontalMargin;
    return breakout ? "" : "\n    overflow: auto;\n    max-width: calc(100% - (".concat(horizontalMargin, " * 2));\n    max-height: calc(100% - (").concat(verticalMargin, " * 2));\n  ");
}, function(_ref7) {
    var extraStyles = _ref7.extraStyles;
    return extraStyles;
});
var _excluded$c = [
    "fixed",
    "verticalMargin",
    "horizontalMargin",
    "breakout",
    "top",
    "left",
    "centered",
    "visible",
    "children"
];
/*
  The imposter is used to position content over a parent node.
  Great for tooltips, modals, dialogs, etc.
  For this to work, the parent *must* have position: relative in it styles.
  If using a <Box /> component, this can be specified using the extraStyles prop.

  Imposter takes a few props:
    -fixed (defaults to false): if true, position imposter relative to the viewport, not its parent
    -verticalMargin (defaults to "0px"): space between edge of imposter and edge of its parent
    -horizontalMargin (defaults to "0px"): space between edge of imposter and edge of its parent
    -breakout (defaults to true): if false, contain imposter within parent. margins do not apply if      breakout is true.
    -top (defaults to 50%): position from top of parent element
    -left (defaults to 50%): position from left of parent element
    -centered (defaults to false): if true, applies a transform such that the center of the imposter is
     over the center of the parent element
  
  NOTE: Imposter is not accessible by default. If building a modal/dialog/tooltip, make sure your content has the appropriate aria-roles and is focusable via keyboard.

*/ var Imposter = function Imposter(_ref) {
    var _ref$fixed = _ref.fixed, fixed = _ref$fixed === void 0 ? false : _ref$fixed, _ref$verticalMargin = _ref.verticalMargin, verticalMargin = _ref$verticalMargin === void 0 ? "0px" : _ref$verticalMargin, _ref$horizontalMargin = _ref.horizontalMargin, horizontalMargin = _ref$horizontalMargin === void 0 ? "0px" : _ref$horizontalMargin, _ref$breakout = _ref.breakout, breakout = _ref$breakout === void 0 ? true : _ref$breakout, _ref$top = _ref.top, top = _ref$top === void 0 ? "50%" : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? "50%" : _ref$left, _ref$centered = _ref.centered, centered = _ref$centered === void 0 ? false : _ref$centered, _ref$visible = _ref.visible, visible = _ref$visible === void 0 ? true : _ref$visible, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$c);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ImposterWrapper, _extends({
        fixed: fixed,
        verticalMargin: verticalMargin,
        horizontalMargin: horizontalMargin,
        breakout: breakout,
        top: top,
        left: left,
        centered: centered,
        visible: visible
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)));
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
/**
 * Browser-safe usage of process
 */ var defaultEnvironment = "production";
var env = typeof process === "undefined" || process.env === undefined ? defaultEnvironment : "production";
var createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var featureDefinitions = {
    measureLayout: createDefinition([
        "layout",
        "layoutId",
        "drag"
    ]),
    animation: createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView"
    ]),
    exit: createDefinition([
        "exit"
    ]),
    drag: createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: createDefinition([
        "whileFocus"
    ]),
    hover: createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    inView: createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ])
};
function loadFeatures(features) {
    for(var key in features){
        if (features[key] === null) continue;
        if (key === "projectionNodeConstructor") featureDefinitions.projectionNodeConstructor = features[key];
        else featureDefinitions[key].Component = features[key];
    }
}
var warning = function() {};
var invariant = function() {};
var LazyContext = (0, _react.createContext)({
    strict: false
});
var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function useFeatures(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, _react.useContext)(LazyContext);
    if (!visualElement) return null;
    /**
     * If we're in development mode, check to make sure we're not rendering a motion component
     * as a child of LazyMotion, as this will break the file-size benefits of using it.
     */ if (env !== "production" && preloadedFeatures && lazyContext.strict) invariant(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
    for(var i = 0; i < numFeatures; i++){
        var name_1 = featureNames[i];
        var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push((0, _react.createElement)(Component, __assign({
            key: name_1
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}
/**
 * @public
 */ var MotionConfigContext = (0, _react.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false,
    reducedMotion: "never"
});
var MotionContext = (0, _react.createContext)({});
function useVisualElementContext() {
    return (0, _react.useContext)(MotionContext).visualElement;
}
/**
 * @public
 */ var PresenceContext = (0, _react.createContext)(null);
var isBrowser = typeof document !== "undefined";
var useIsomorphicLayoutEffect = isBrowser ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
// Does this device prefer reduced motion? Returns `null` server-side.
var prefersReducedMotion = {
    current: null
};
var hasDetected = false;
function initPrefersReducedMotion() {
    hasDetected = true;
    if (!isBrowser) return;
    if (window.matchMedia) {
        var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return prefersReducedMotion.current = motionMediaQuery_1.matches;
        };
        motionMediaQuery_1.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else prefersReducedMotion.current = false;
}
/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function useReducedMotion() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !hasDetected && initPrefersReducedMotion();
    var _a = __read((0, _react.useState)(prefersReducedMotion.current), 1), shouldReduceMotion = _a[0];
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}
function useReducedMotionConfig() {
    var reducedMotionPreference = useReducedMotion();
    var reducedMotion = (0, _react.useContext)(MotionConfigContext).reducedMotion;
    if (reducedMotion === "never") return false;
    else if (reducedMotion === "always") return true;
    else return reducedMotionPreference;
}
function useVisualElement(Component, visualState, props, createVisualElement) {
    var lazyContext = (0, _react.useContext)(LazyContext);
    var parent = useVisualElementContext();
    var presenceContext = (0, _react.useContext)(PresenceContext);
    var shouldReduceMotion = useReducedMotionConfig();
    var visualElementRef = (0, _react.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        shouldReduceMotion: shouldReduceMotion
    });
    var visualElement = visualElementRef.current;
    useIsomorphicLayoutEffect(function() {
        visualElement === null || visualElement === void 0 || visualElement.syncRender();
    });
    (0, _react.useEffect)(function() {
        var _a;
        (_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    useIsomorphicLayoutEffect(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}
function isRefObject(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function useMotionRef(visualState, visualElement, externalRef) {
    return (0, _react.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if (isRefObject(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}
/**
 * Decides if the supplied variable is an array of variant labels
 */ function isVariantLabels(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function isVariantLabel(v) {
    return typeof v === "string" || isVariantLabels(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function resolveVariantFromProps(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}
function resolveVariant(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity(visualElement));
}
function checkIfControllingVariants(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || isVariantLabel(props.initial) || isVariantLabel(props.animate) || isVariantLabel(props.whileHover) || isVariantLabel(props.whileDrag) || isVariantLabel(props.whileTap) || isVariantLabel(props.whileFocus) || isVariantLabel(props.exit);
}
function checkIfVariantNode(props) {
    return Boolean(checkIfControllingVariants(props) || props.variants);
}
function getCurrentTreeVariants(props, context) {
    if (checkIfControllingVariants(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || isVariantLabel(initial) ? initial : undefined,
            animate: isVariantLabel(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}
function useCreateMotionContext(props) {
    var _a = getCurrentTreeVariants(props, (0, _react.useContext)(MotionContext)), initial = _a.initial, animate = _a.animate;
    return (0, _react.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, [
        variantLabelsAsDependency(initial),
        variantLabelsAsDependency(animate)
    ]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function useConstant(init) {
    var ref = (0, _react.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};
var id = 1;
function useProjectionId() {
    return useConstant(function() {
        if (globalProjectionState.hasEverUpdated) return id++;
    });
}
var LayoutGroupContext = (0, _react.createContext)({});
/**
 * Internal, exported only for usage in Framer
 */ var SwitchLayoutGroupContext = (0, _react.createContext)({});
function useProjection(projectionId, _a, visualElement, ProjectionNodeConstructor) {
    var _b;
    var layoutId = _a.layoutId, layout = _a.layout, drag = _a.drag, dragConstraints = _a.dragConstraints, layoutScroll = _a.layoutScroll;
    var initialPromotionConfig = (0, _react.useContext)(SwitchLayoutGroupContext);
    if (!ProjectionNodeConstructor || !visualElement || (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection)) return;
    visualElement.projection = new ProjectionNodeConstructor(projectionId, visualElement.getLatestValues(), (_b = visualElement.parent) === null || _b === void 0 ? void 0 : _b.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && isRefObject(dragConstraints),
        visualElement: visualElement,
        scheduleRender: function() {
            return visualElement.scheduleRender();
        },
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll
    });
}
var VisualElementHandler = /** @class */ function(_super) {
    __extends(VisualElementHandler, _super);
    function VisualElementHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */ VisualElementHandler.prototype.getSnapshotBeforeUpdate = function() {
        this.updateProps();
        return null;
    };
    VisualElementHandler.prototype.componentDidUpdate = function() {};
    VisualElementHandler.prototype.updateProps = function() {
        var _a = this.props, visualElement = _a.visualElement, props = _a.props;
        if (visualElement) visualElement.setProps(props);
    };
    VisualElementHandler.prototype.render = function() {
        return this.props.children;
    };
    return VisualElementHandler;
}((0, _reactDefault.default).Component);
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function createMotionComponent(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, projectionNodeConstructor = _a.projectionNodeConstructor, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        var layoutId = useLayoutId(props);
        props = __assign(__assign({}, props), {
            layoutId: layoutId
        });
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var config = (0, _react.useContext)(MotionConfigContext);
        var features = null;
        var context = useCreateMotionContext(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */ var projectionId = config.isStatic ? undefined : useProjectionId();
        /**
         *
         */ var visualState = useVisualState(props, config.isStatic);
        if (!config.isStatic && isBrowser) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = useVisualElement(Component, visualState, __assign(__assign({}, config), props), createVisualElement);
            useProjection(projectionId, props, context.visualElement, projectionNodeConstructor || featureDefinitions.projectionNodeConstructor);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ features = useFeatures(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, _react.createElement)(VisualElementHandler, {
            visualElement: context.visualElement,
            props: __assign(__assign({}, config), props)
        }, features, (0, _react.createElement)(MotionContext.Provider, {
            value: context
        }, useRender(Component, props, projectionId, useMotionRef(visualState, context.visualElement, externalRef), visualState, config.isStatic, context.visualElement)));
    }
    return (0, _react.forwardRef)(MotionComponent);
}
function useLayoutId(_a) {
    var _b;
    var layoutId = _a.layoutId;
    var layoutGroupId = (_b = (0, _react.useContext)(LayoutGroupContext)) === null || _b === void 0 ? void 0 : _b.id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];
function isSVGComponent(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ lowercaseSVGElements.indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}
var scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var transformProps = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
order.forEach(function(operationKey) {
    return transformAxes.forEach(function(axesKey) {
        return transformProps.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function sortTransformProps(a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var transformPropSet = new Set(transformProps);
function isTransformProp(key) {
    return transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function isTransformOriginProp(key) {
    return transformOriginProps.has(key);
}
function isForcedMotionValue(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return isTransformProp(key) || isTransformOriginProp(key) || (layout || layoutId !== undefined) && (!!scaleCorrectors[key] || key === "opacity");
}
var isMotionValue = function(value) {
    return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};
var translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort(sortTransformProps);
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += "".concat(translateAlias[key] || key, "(").concat(transform[key], ") ");
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function buildTransformOrigin(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return "".concat(originX, " ").concat(originY, " ").concat(originZ);
}
/**
 * Returns true if the provided key is a CSS variable
 */ function isCSSVariable(key) {
    return key.startsWith("--");
}
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var getValueAsType = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};
const clamp = (min, max)=>(v)=>Math.max(Math.min(v, max), min);
const sanitize = (v)=>v % 1 ? Number(v.toFixed(5)) : v;
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString(v) {
    return typeof v === "string";
}
const number = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const alpha = Object.assign(Object.assign({}, number), {
    transform: clamp(0, 1)
});
const scale = Object.assign(Object.assign({}, number), {
    default: 1
});
const createUnitType = (unit)=>({
        test: (v)=>isString(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const degrees = createUnitType("deg");
const percent = createUnitType("%");
const px = createUnitType("px");
const vh = createUnitType("vh");
const vw = createUnitType("vw");
const progressPercentage = Object.assign(Object.assign({}, percent), {
    parse: (v)=>percent.parse(v) / 100,
    transform: (v)=>percent.transform(v * 100)
});
const isColorString = (type, testProp)=>(v)=>{
        return Boolean(isString(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const splitColor = (aName, bName, cName)=>(v)=>{
        if (!isString(v)) return v;
        const [a, b, c, alpha] = v.match(floatRegex);
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };
const hsla = {
    test: isColorString("hsl", "hue"),
    parse: splitColor("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
    }
};
const clampRgbUnit = clamp(0, 255);
const rgbUnit = Object.assign(Object.assign({}, number), {
    transform: (v)=>Math.round(clampRgbUnit(v))
});
const rgba = {
    test: isColorString("rgb", "red"),
    parse: splitColor("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 })=>"rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")"
};
function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const hex = {
    test: isColorString("#"),
    parse: parseHex,
    transform: rgba.transform
};
const color = {
    test: (v)=>rgba.test(v) || hex.test(v) || hsla.test(v),
    parse: (v)=>{
        if (rgba.test(v)) return rgba.parse(v);
        else if (hsla.test(v)) return hsla.parse(v);
        else return hex.parse(v);
    },
    transform: (v)=>{
        return isString(v) ? v : v.hasOwnProperty("red") ? rgba.transform(v) : hsla.transform(v);
    }
};
const colorToken = "${c}";
const numberToken = "${n}";
function test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && isString(v) && ((_b = (_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match(colorRegex)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function analyse(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match(colorRegex);
    if (colors) {
        numColors = colors.length;
        v = v.replace(colorRegex, colorToken);
        values.push(...colors.map(color.parse));
    }
    const numbers = v.match(floatRegex);
    if (numbers) {
        v = v.replace(floatRegex, numberToken);
        values.push(...numbers.map(number.parse));
    }
    return {
        values,
        numColors,
        tokenised: v
    };
}
function parse(v) {
    return analyse(v).values;
}
function createTransformer(v) {
    const { values, numColors, tokenised } = analyse(v);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? colorToken : numberToken, i < numColors ? color.transform(v[i]) : sanitize(v[i]));
        return output;
    };
}
const convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function getAnimatableNone(v) {
    const parsed = parse(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = {
    test,
    parse,
    createTransformer,
    getAnimatableNone
};
const maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function applyDefaultFilter(v) {
    let [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match(floatRegex) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter = Object.assign(Object.assign({}, complex), {
    getAnimatableNone: (v)=>{
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    }
});
var int = __assign(__assign({}, number), {
    transform: Math.round
});
var numberValueTypes = {
    // Border props
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    // Positioning props
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    // Spacing props
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    // Transform props
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale: scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    // Misc
    zIndex: int,
    // SVG
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int
};
function buildHTMLStyles(state, latestValues, options, transformTemplate) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if (isCSSVariable(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = numberValueTypes[key];
        var valueAsType = getValueAsType(value, valueType);
        if (isTransformProp(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if (isTransformOriginProp(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else style[key] = valueAsType;
    }
    if (hasTransform) style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
    else if (transformTemplate) style.transform = transformTemplate({}, "");
    else if (!latestValues.transform && style.transform) style.transform = "none";
    if (hasTransformOrigin) style.transformOrigin = buildTransformOrigin(transformOrigin);
}
var createHtmlRenderState = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};
function copyRawValuesOnly(target, source, props) {
    for(var key in source)if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) target[key] = source[key];
}
function useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, _react.useMemo)(function() {
        var state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return __assign(__assign({}, vars), style);
    }, [
        visualState
    ]);
}
function useStyle(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function useHTMLProps(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = useStyle(props, visualState, isStatic);
    if (Boolean(props.drag) && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
    "layoutScroll"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function isValidMotionProp(key) {
    return validMotionProps.has(key);
}
var shouldForward = function(key) {
    return !isValidMotionProp(key);
};
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    shouldForward = function(key) {
        return key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
    };
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ loadExternalIsValidProp(require("461728f6d476ab8").default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if (shouldForward(key) || forwardMotionProps === true && isValidMotionProp(key) || !isDom && !isValidMotionProp(key) || // If trying to use native HTML drag events, forward drag listeners
    props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    return filteredProps;
}
function calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function calcSVGTransformOrigin(dimensions, originX, originY) {
    var pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
    return "".concat(pxOriginX, " ").concat(pxOriginY);
}
var dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function buildSVGPath(attrs, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = px.transform(-offset);
    // Build the dash array
    var pathLength = px.transform(length);
    var pathSpacing = px.transform(spacing);
    attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function buildSVGAttrs(state, _a, options, transformTemplate) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = __rest(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    buildHTMLStyles(state, latest, options, transformTemplate);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
}
var createSvgRenderState = function() {
    return __assign(__assign({}, createHtmlRenderState()), {
        attrs: {}
    });
};
function useSVGProps(props, visualState) {
    var visualProps = (0, _react.useMemo)(function() {
        var state = createSvgRenderState();
        buildSVGAttrs(state, visualState, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return __assign(__assign({}, state.attrs), {
            style: __assign({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = __assign(__assign({}, rawStyles), visualProps.style);
    }
    return visualProps;
}
function createUseRender(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, projectionId, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = isSVGComponent(Component) ? useSVGProps : useHTMLProps;
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        var elementProps = __assign(__assign(__assign({}, filteredProps), visualProps), {
            ref: ref
        });
        if (projectionId) elementProps["data-projection-id"] = projectionId;
        return (0, _react.createElement)(Component, elementProps);
    };
    return useRender;
}
var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var camelToDash = function(str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};
function renderHTML(element, _a, styleProp, projection) {
    var style = _a.style, vars = _a.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}
/**
 * A set of attribute names that are always read/written as camel case.
 */ var camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength"
]);
function renderSVG(element, renderState, _styleProp, projection) {
    renderHTML(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
}
function scrapeMotionValuesFromProps(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) newValues[key] = style[key];
    return newValues;
}
function scrapeMotionValuesFromProps$1(props) {
    var newValues = scrapeMotionValuesFromProps(props);
    for(var key in props)if (isMotionValue(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}
function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}
var isKeyframesTarget = function(v) {
    return Array.isArray(v);
};
var isCustomValue = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function resolveMotionValue(value) {
    var unwrappedValue = isMotionValue(value) ? value.get() : value;
    return isCustomValue(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}
function makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var makeUseVisualState = function(config) {
    return function(props, isStatic) {
        var context = (0, _react.useContext)(MotionContext);
        var presenceContext = (0, _react.useContext)(PresenceContext);
        return isStatic ? makeState(config, props, context, presenceContext) : useConstant(function() {
            return makeState(config, props, context, presenceContext);
        });
    };
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = resolveMotionValue(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = checkIfControllingVariants(props);
    var isVariantNode = checkIfVariantNode(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var initialAnimationIsBlocked = blockInitialAnimation || initial === false;
    var variantToSet = initialAnimationIsBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = resolveVariantFromProps(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = __rest(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target){
                var valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ var index = initialAnimationIsBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}
var svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
        createRenderState: createSvgRenderState,
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            buildSVGAttrs(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            renderSVG(instance, renderState);
        }
    })
};
var htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createHtmlRenderState
    })
};
function createDomMotionConfig(Component, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = isSVGComponent(Component) ? svgMotionConfig : htmlMotionConfig;
    return __assign(__assign({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: createUseRender(forwardMotionProps),
        createVisualElement: createVisualElement,
        projectionNodeConstructor: projectionNodeConstructor,
        Component: Component
    });
}
var AnimationType;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));
function addDomEvent(target, eventName, handler, options) {
    if (options === void 0) options = {
        passive: true
    };
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function useDomEvent(ref, eventName, handler, options) {
    (0, _react.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return addDomEvent(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}
/**
 *
 * @param props
 * @param ref
 * @internal
 */ function useFocusGesture(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive(AnimationType.Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive(AnimationType.Focus, false);
    };
    useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
    useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}
function isMouseEvent(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function extractEventInfo(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: isTouchEvent(event) ? pointFromTouch(event, pointType) : pointFromMouse(event, pointType)
    };
}
var wrapHandler = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, extractEventInfo(event));
    };
    return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
};
// We check for event support via functions in case they've been mocked by a testing suite.
var supportsPointerEvents = function() {
    return isBrowser && window.onpointerdown === null;
};
var supportsTouchEvents = function() {
    return isBrowser && window.ontouchstart === null;
};
var supportsMouseEvents = function() {
    return isBrowser && window.onmousedown === null;
};
var mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function getPointerEventName(name) {
    if (supportsPointerEvents()) return name;
    else if (supportsTouchEvents()) return touchEventNames[name];
    else if (supportsMouseEvents()) return mouseEventNames[name];
    return name;
}
function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}
function createLock(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    var lock = false;
    if (drag === "y") lock = globalVerticalLock();
    else if (drag === "x") lock = globalHorizontalLock();
    else {
        var openHorizontal_1 = globalHorizontalLock();
        var openVertical_1 = globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = getGlobalLock(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}
function createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!isMouseEvent(event) || isDragActive()) return;
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive(AnimationType.Hover, isActive);
        callback === null || callback === void 0 || callback(event, info);
    };
}
function useHoverGesture(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover ? createHoverEvent(visualElement, true, onHoverStart) : undefined, {
        passive: !onHoverStart
    });
    usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover ? createHoverEvent(visualElement, false, onHoverEnd) : undefined, {
        passive: !onHoverEnd
    });
}
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var isNodeOrChild = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return isNodeOrChild(parent, child.parentElement);
};
function useUnmountEffect(callback) {
    return (0, _react.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}
const clamp$1 = (min, max, v)=>Math.min(Math.max(v, min), max);
const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1 }) {
    let envelope;
    let derivative;
    warning(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    dampingRatio = clamp$1(minDamping, maxDamping, dampingRatio);
    duration = clamp$1(minDuration, maxDuration, duration / 1000);
    if (dampingRatio < 1) {
        envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const durationKeys = [
    "duration",
    "bounce"
];
const physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = Object.assign({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
        const derived = findSpring(options);
        springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring(_a) {
    var { from = 0.0, to = 1.0, restSpeed = 2, restDelta } = _a, options = __rest(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    const state = {
        done: false,
        value: from
    };
    let { stiffness, damping, mass, velocity, duration, isResolvedFromDuration } = getSpringOptions(options);
    let resolveSpring = zero;
    let resolveVelocity = zero;
    function createSpring() {
        const initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        const initialDelta = to - from;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        if (restDelta === undefined) restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
        if (dampingRatio < 1) {
            const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
            };
            resolveVelocity = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq + initialDelta * Math.cos(angularFreq * t)) - envelope * (Math.cos(angularFreq * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq * initialDelta * Math.sin(angularFreq * t));
            };
        } else if (dampingRatio === 1) resolveSpring = (t)=>to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        else {
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t)=>{
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
            };
        }
    }
    createSpring();
    return {
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = resolveVelocity(t) * 1000;
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: ()=>{
            velocity = -velocity;
            [from, to] = [
                to,
                from
            ];
            createSpring();
        }
    };
}
spring.needsInterpolation = (a, b)=>typeof a === "string" || typeof b === "string";
const zero = (_t)=>0;
const progress = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};
const mix = (from, to, progress)=>-progress * from + progress * to + from;
const clamp$2 = (min, max)=>(v)=>Math.max(Math.min(v, max), min);
const sanitize$1 = (v)=>v % 1 ? Number(v.toFixed(5)) : v;
const floatRegex$1 = /(-)?([\d]*\.?[\d])+/g;
const colorRegex$1 = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const singleColorRegex$1 = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString$1(v) {
    return typeof v === "string";
}
const number$1 = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const alpha$1 = Object.assign(Object.assign({}, number$1), {
    transform: clamp$2(0, 1)
});
const scale$1 = Object.assign(Object.assign({}, number$1), {
    default: 1
});
const createUnitType$1 = (unit)=>({
        test: (v)=>isString$1(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const percent$1 = createUnitType$1("%");
const progressPercentage$1 = Object.assign(Object.assign({}, percent$1), {
    parse: (v)=>percent$1.parse(v) / 100,
    transform: (v)=>percent$1.transform(v * 100)
});
const isColorString$1 = (type, testProp)=>(v)=>{
        return Boolean(isString$1(v) && singleColorRegex$1.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const splitColor$1 = (aName, bName, cName)=>(v)=>{
        if (!isString$1(v)) return v;
        const [a, b, c, alpha] = v.match(floatRegex$1);
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };
const hsla$1 = {
    test: isColorString$1("hsl", "hue"),
    parse: splitColor$1("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + percent$1.transform(sanitize$1(saturation)) + ", " + percent$1.transform(sanitize$1(lightness)) + ", " + sanitize$1(alpha$1.transform(alpha$1$1)) + ")";
    }
};
const clampRgbUnit$1 = clamp$2(0, 255);
const rgbUnit$1 = Object.assign(Object.assign({}, number$1), {
    transform: (v)=>Math.round(clampRgbUnit$1(v))
});
const rgba$1 = {
    test: isColorString$1("rgb", "red"),
    parse: splitColor$1("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1$1 = 1 })=>"rgba(" + rgbUnit$1.transform(red) + ", " + rgbUnit$1.transform(green) + ", " + rgbUnit$1.transform(blue) + ", " + sanitize$1(alpha$1.transform(alpha$1$1)) + ")"
};
function parseHex$1(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const hex$1 = {
    test: isColorString$1("#"),
    parse: parseHex$1,
    transform: rgba$1.transform
};
const color$1 = {
    test: (v)=>rgba$1.test(v) || hex$1.test(v) || hsla$1.test(v),
    parse: (v)=>{
        if (rgba$1.test(v)) return rgba$1.parse(v);
        else if (hsla$1.test(v)) return hsla$1.parse(v);
        else return hex$1.parse(v);
    },
    transform: (v)=>{
        return isString$1(v) ? v : v.hasOwnProperty("red") ? rgba$1.transform(v) : hsla$1.transform(v);
    }
};
const colorToken$1 = "${c}";
const numberToken$1 = "${n}";
function test$1(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && isString$1(v) && ((_b = (_a = v.match(floatRegex$1)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match(colorRegex$1)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function analyse$1(v) {
    if (typeof v === "number") v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match(colorRegex$1);
    if (colors) {
        numColors = colors.length;
        v = v.replace(colorRegex$1, colorToken$1);
        values.push(...colors.map(color$1.parse));
    }
    const numbers = v.match(floatRegex$1);
    if (numbers) {
        v = v.replace(floatRegex$1, numberToken$1);
        values.push(...numbers.map(number$1.parse));
    }
    return {
        values,
        numColors,
        tokenised: v
    };
}
function parse$1(v) {
    return analyse$1(v).values;
}
function createTransformer$1(v) {
    const { values, numColors, tokenised } = analyse$1(v);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++)output = output.replace(i < numColors ? colorToken$1 : numberToken$1, i < numColors ? color$1.transform(v[i]) : sanitize$1(v[i]));
        return output;
    };
}
const convertNumbersToZero$1 = (v)=>typeof v === "number" ? 0 : v;
function getAnimatableNone$1(v) {
    const parsed = parse$1(v);
    const transformer = createTransformer$1(v);
    return transformer(parsed.map(convertNumbersToZero$1));
}
const complex$1 = {
    test: test$1,
    parse: parse$1,
    createTransformer: createTransformer$1,
    getAnimatableNone: getAnimatableNone$1
};
function hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha
    };
}
const mixLinearColor = (from, to, v)=>{
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const colorTypes = [
    hex$1,
    rgba$1,
    hsla$1
];
const getColorType = (v)=>colorTypes.find((type)=>type.test(v));
const notAnimatable = (color)=>`'${color}' is not an animatable color. Use the equivalent color code instead.`;
const mixColor = (from, to)=>{
    let fromColorType = getColorType(from);
    let toColorType = getColorType(to);
    invariant(!!fromColorType, notAnimatable(from));
    invariant(!!toColorType, notAnimatable(to));
    let fromColor = fromColorType.parse(from);
    let toColor = toColorType.parse(to);
    if (fromColorType === hsla$1) {
        fromColor = hslaToRgba(fromColor);
        fromColorType = rgba$1;
    }
    if (toColorType === hsla$1) {
        toColor = hslaToRgba(toColor);
        toColorType = rgba$1;
    }
    const blended = Object.assign({}, fromColor);
    return (v)=>{
        for(const key in blended)if (key !== "alpha") blended[key] = mixLinearColor(fromColor[key], toColor[key], v);
        blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};
const isNum = (v)=>typeof v === "number";
const combineFunctions = (a, b)=>(v)=>b(a(v));
const pipe = (...transformers)=>transformers.reduce(combineFunctions);
function getMixer(origin, target) {
    if (isNum(origin)) return (v)=>mix(origin, target, v);
    else if (color$1.test(origin)) return mixColor(origin, target);
    else return mixComplex(origin, target);
}
const mixArray = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const mixObject = (origin, target)=>{
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function analyse$2(value) {
    const parsed = complex$1.parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for(let i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed,
        numNumbers,
        numRGB,
        numHSL
    };
}
const mixComplex = (origin, target)=>{
    const template = complex$1.createTransformer(target);
    const originStats = analyse$2(origin);
    const targetStats = analyse$2(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
    else {
        warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p)=>`${p > 0 ? target : origin}`;
    }
};
const mixNumber = (from, to)=>(p)=>mix(from, to, p);
function detectMixerFactory(v) {
    if (typeof v === "number") return mixNumber;
    else if (typeof v === "string") {
        if (color$1.test(v)) return mixColor;
        else return mixComplex;
    } else if (Array.isArray(v)) return mixArray;
    else if (typeof v === "object") return mixObject;
}
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function fastInterpolate([from, to], [mixer]) {
    return (v)=>mixer(progress(from, to, v));
}
function slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v)=>{
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        const progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    invariant(inputLength === output.length, "Both input and output ranges must be the same length");
    invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const interpolator = inputLength === 2 ? fastInterpolate(input, mixers) : slowInterpolate(input, mixers);
    return isClamp ? (v)=>interpolator(clamp$1(input[0], input[inputLength - 1], v)) : interpolator;
}
const reverseEasing = (easing)=>(p)=>1 - easing(1 - p);
const mirrorEasing = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
const createExpoIn = (power)=>(p)=>Math.pow(p, power);
const createBackIn = (power)=>(p)=>p * p * ((power + 1) * p - power);
const createAnticipate = (power)=>{
    const backEasing = createBackIn(power);
    return (p)=>(p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};
const DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
const BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
const BOUNCE_THIRD_THRESHOLD = 0.9;
const linear = (p)=>p;
const easeIn = createExpoIn(2);
const easeOut = reverseEasing(easeIn);
const easeInOut = mirrorEasing(easeIn);
const circIn = (p)=>1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circOut);
const backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
const backOut = reverseEasing(backIn);
const backInOut = mirrorEasing(backIn);
const anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
const ca = 4356.0 / 361.0;
const cb = 35442.0 / 1805.0;
const cc = 16061.0 / 1805.0;
const bounceOut = (p)=>{
    if (p === 1 || p === 0) return p;
    const p2 = p * p;
    return p < BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < BOUNCE_THIRD_THRESHOLD ? ca * p2 - cb * p + cc : 10.8 * p * p - 20.52 * p + 10.72;
};
const bounceIn = reverseEasing(bounceOut);
const bounceInOut = (p)=>p < 0.5 ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0)) : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
function defaultEasing(values, easing) {
    return values.map(()=>easing || easeInOut).splice(0, values.length - 1);
}
function defaultOffset(values) {
    const numValues = values.length;
    return values.map((_value, i)=>i !== 0 ? i / (numValues - 1) : 0);
}
function convertOffsetToTimes(offset, duration) {
    return offset.map((o)=>o * duration);
}
function keyframes({ from = 0, to = 1, ease, offset, duration = 300 }) {
    const state = {
        done: false,
        value: from
    };
    const values = Array.isArray(to) ? to : [
        from,
        to
    ];
    const times = convertOffsetToTimes(offset && offset.length === values.length ? offset : defaultOffset(values), duration);
    function createInterpolator() {
        return interpolate(times, values, {
            ease: Array.isArray(ease) ? ease : defaultEasing(values, ease)
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t)=>{
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: ()=>{
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}
function decay({ velocity = 0, from = 0, power = 0.8, timeConstant = 350, restDelta = 0.5, modifyTarget }) {
    const state = {
        done: false,
        value: from
    };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: (t)=>{
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: ()=>{}
    };
}
const types = {
    keyframes,
    spring,
    decay
};
function detectAnimationFromOptions(config) {
    if (Array.isArray(config.to)) return keyframes;
    else if (types[config.type]) return types[config.type];
    const keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return keyframes;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return spring;
    return keyframes;
}
const defaultTimestep = 1 / 60 * 1000;
const getCurrentTime = typeof performance !== "undefined" ? ()=>performance.now() : ()=>Date.now();
const onNextFrame = typeof window !== "undefined" ? (callback)=>window.requestAnimationFrame(callback) : (callback)=>setTimeout(()=>callback(getCurrentTime()), defaultTimestep);
function createRenderStep(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData)=>{
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}
const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const frame = {
    delta: 0,
    timestamp: 0
};
const stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const steps = stepsOrder.reduce((acc, key)=>{
    acc[key] = createRenderStep(()=>runNextFrame = true);
    return acc;
}, {});
const sync = stepsOrder.reduce((acc, key)=>{
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!runNextFrame) startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key)=>{
    acc[key] = steps[key].cancel;
    return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key)=>{
    acc[key] = ()=>steps[key].process(frame);
    return acc;
}, {});
const processStep = (stepId)=>steps[stepId].process(frame);
const processFrame = (timestamp)=>{
    runNextFrame = false;
    frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
    frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
const startLoop = ()=>{
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing) onNextFrame(processFrame);
};
const getFrameData = ()=>frame;
function loopElapsed(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback ? loopElapsed(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
const framesync = (update)=>{
    const passTimestamp = ({ delta })=>update(delta);
    return {
        start: ()=>sync.update(passTimestamp, true),
        stop: ()=>cancelSync.update(passTimestamp)
    };
};
function animate(_a) {
    var _b, _c;
    var { from, autoplay = true, driver = framesync, elapsed = 0, repeat: repeatMax = 0, repeatType = "loop", repeatDelay = 0, onPlay, onStop, onComplete, onRepeat, onUpdate } = _a, options = __rest(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    let { to } = options;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = options.duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = detectAnimationFromOptions(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = interpolate([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    const animation = animator(Object.assign(Object.assign({}, options), {
        from,
        to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: ()=>{
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}
function inertia({ from = 0, velocity = 0, min, max, power = 0.8, timeConstant = 750, bounceStiffness = 500, bounceDamping = 10, restDelta = 1, modifyTarget, driver, onUpdate, onComplete, onStop }) {
    let currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = animate(Object.assign(Object.assign({}, options), {
            driver,
            onUpdate: (v)=>{
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete,
            onStop
        }));
    }
    function startSpring(options) {
        startAnimation(Object.assign({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from,
        velocity,
        to: boundaryNearest(from)
    });
    else {
        let target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        const boundary = boundaryNearest(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v)=>{
            prev = current;
            current = v;
            velocity = velocityPerSecond(v - prev, getFrameData().delta);
            if (heading === 1 && v > boundary || heading === -1 && v < boundary) startSpring({
                from: v,
                to: boundary,
                velocity
            });
        };
        startAnimation({
            type: "decay",
            from,
            velocity,
            timeConstant,
            power,
            restDelta,
            modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: ()=>currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop()
    };
}
const isPoint = (point)=>point.hasOwnProperty("x") && point.hasOwnProperty("y");
const isPoint3D = (point)=>isPoint(point) && point.hasOwnProperty("z");
const distance1D = (a, b)=>Math.abs(a - b);
function distance(a, b) {
    if (isNum(a) && isNum(b)) return distance1D(a, b);
    else if (isPoint(a) && isPoint(b)) {
        const xDelta = distance1D(a.x, b.x);
        const yDelta = distance1D(a.y, b.y);
        const zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}
const a = (a1, a2)=>1.0 - 3.0 * a2 + 3.0 * a1;
const b = (a1, a2)=>3.0 * a2 - 6.0 * a1;
const c = (a1)=>3.0 * a1;
const calcBezier = (t, a1, a2)=>((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
const getSlope = (t, a1, a2)=>3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 10;
function binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
    return currentT;
}
const newtonIterations = 8;
const newtonMinSlope = 0.001;
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(let i = 0; i < newtonIterations; ++i){
        const currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        const currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
const kSplineTableSize = 11;
const kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
function cubicBezier(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return linear;
    const sampleValues = new Float32Array(kSplineTableSize);
    for(let i = 0; i < kSplineTableSize; ++i)sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        let intervalStart = 0.0;
        let currentSample = 1;
        const lastSample = kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * kSampleStepSize;
        const initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= newtonMinSlope) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
    return (t)=>t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}
/**
 * @param handlers -
 * @internal
 */ function useTapGesture(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, _react.useRef)(false);
    var cancelPointerEndListeners = (0, _react.useRef)(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */ var eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown)
    };
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive(AnimationType.Tap, false);
        return !isDragActive();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !isNodeOrChild(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = pipe(addPointerEvent(window, "pointerup", onPointerUp, eventOptions), addPointerEvent(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive(AnimationType.Tap, true);
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
    }
    usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    useUnmountEffect(removePointerEndListener);
}
var warned = new Set();
function warnOnce(condition, message, element) {
    if (condition || warned.has(message)) return;
    console.warn(message);
    if (element) console.warn(element);
    warned.add(message);
}
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ var observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ var observers = new WeakMap();
var fireObserverCallback = function(entry) {
    var _a;
    (_a = observerCallbacks.get(entry.target)) === null || _a === void 0 || _a(entry);
};
var fireAllObserverCallbacks = function(entries) {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver(_a) {
    var root = _a.root, options = __rest(_a, [
        "root"
    ]);
    var lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!observers.has(lookupRoot)) observers.set(lookupRoot, {});
    var rootObservers = observers.get(lookupRoot);
    var key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, __assign({
        root: root
    }, options));
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    var rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function() {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}
function useViewport(_a) {
    var visualElement = _a.visualElement, whileInView = _a.whileInView, onViewportEnter = _a.onViewportEnter, onViewportLeave = _a.onViewportLeave, _b = _a.viewport, viewport = _b === void 0 ? {} : _b;
    var state = (0, _react.useRef)({
        hasEnteredView: false,
        isInView: false
    });
    var shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView) shouldObserve = false;
    var useObserver = typeof IntersectionObserver === "undefined" ? useMissingIntersectionObserver : useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
var thresholdNames = {
    some: 0,
    all: 1
};
function useIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var root = _a.root, rootMargin = _a.margin, _b = _a.amount, amount = _b === void 0 ? "some" : _b, once = _a.once;
    (0, _react.useEffect)(function() {
        if (!shouldObserve) return;
        var options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount]
        };
        var intersectionCallback = function(entry) {
            var _a;
            var isIntersecting = entry.isIntersecting;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (state.isInView === isIntersecting) return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && state.hasEnteredView) return;
            else if (isIntersecting) state.hasEnteredView = true;
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive(AnimationType.InView, isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ var props = visualElement.getProps();
            var callback = isIntersecting ? props.onViewportEnter : props.onViewportLeave;
            callback === null || callback === void 0 || callback(entry);
        };
        return observeIntersection(visualElement.getInstance(), options, intersectionCallback);
    }, [
        shouldObserve,
        root,
        rootMargin,
        amount
    ]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */ function useMissingIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var _b = _a.fallback, fallback = _b === void 0 ? true : _b;
    (0, _react.useEffect)(function() {
        if (!shouldObserve || !fallback) return;
        if (env !== "production") warnOnce(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */ requestAnimationFrame(function() {
            var _a;
            state.hasEnteredView = true;
            var onViewportEnter = visualElement.getProps().onViewportEnter;
            onViewportEnter === null || onViewportEnter === void 0 || onViewportEnter(null);
            (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive(AnimationType.InView, true);
        });
    }, [
        shouldObserve
    ]);
}
var makeRenderlessComponent = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};
var gestureAnimations = {
    inView: makeRenderlessComponent(useViewport),
    tap: makeRenderlessComponent(useTapGesture),
    focus: makeRenderlessComponent(useFocusGesture),
    hover: makeRenderlessComponent(useHoverGesture)
};
var counter = 0;
var incrementId = function() {
    return counter++;
};
var useId = function() {
    return useConstant(incrementId);
};
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function usePresence() {
    var context = (0, _react.useContext)(PresenceContext);
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    var id = useId();
    (0, _react.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
function shallowCompare(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var secondsToMilliseconds = function(seconds) {
    return seconds * 1000;
};
var easingLookup = {
    linear: linear,
    easeIn: easeIn,
    easeInOut: easeInOut,
    easeOut: easeOut,
    circIn: circIn,
    circInOut: circInOut,
    circOut: circOut,
    backIn: backIn,
    backInOut: backInOut,
    backOut: backOut,
    anticipate: anticipate,
    bounceIn: bounceIn,
    bounceInOut: bounceInOut,
    bounceOut: bounceOut
};
var easingDefinitionToFunction = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = __read(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return cubicBezier(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        invariant(easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
        return easingLookup[definition];
    }
    return definition;
};
var isEasingArray = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var isAnimatable = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    complex.test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};
var underDampedSpring = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restSpeed: 10
    };
};
var criticallyDampedSpring = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var linearTween = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var keyframes$1 = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: criticallyDampedSpring,
    scaleY: criticallyDampedSpring,
    scale: criticallyDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: criticallyDampedSpring
};
var getDefaultTransition = function(valueKey, to) {
    var transitionFactory;
    if (isKeyframesTarget(to)) transitionFactory = keyframes$1;
    else transitionFactory = defaultTransitions[valueKey] || defaultTransitions.default;
    return __assign({
        to: to
    }, transitionFactory(to));
};
/**
 * A map of default value types for common values
 */ var defaultValueTypes = __assign(__assign({}, numberValueTypes), {
    // Color props
    color: color,
    backgroundColor: color,
    outlineColor: color,
    fill: color,
    stroke: color,
    // Border props
    borderColor: color,
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: color,
    filter: filter,
    WebkitFilter: filter
});
/**
 * Gets the default ValueType for the provided value key
 */ var getDefaultValueType = function(key) {
    return defaultValueTypes[key];
};
function getAnimatableNone$2(key, value) {
    var _a;
    var defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter) defaultValueType = complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function isTransitionDefined(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = __rest(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function convertTransitionToAnimationOptions(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = __rest(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = __assign({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = secondsToMilliseconds(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = isEasingArray(ease) ? ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        warning(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function getDelayFromTransition(transition, key) {
    var _a, _b;
    var valueTransition = getValueTransition(transition, key) || {};
    return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function hydrateKeyframes(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = __spreadArray([], __read(options.to), false);
        options.to[0] = options.from;
    }
    return options;
}
function getPopmotionAnimationOptions(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    hydrateKeyframes(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!isTransitionDefined(transition)) transition = __assign(__assign({}, transition), getDefaultTransition(key, options.to));
    return __assign(__assign({}, options), convertTransitionToAnimationOptions(transition));
}
/**
 *
 */ function getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = getValueTransition(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = isAnimatable(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = getAnimatableNone$2(key, target);
    else if (isZero(origin) && typeof target === "string") origin = getZeroUnit(target);
    else if (!Array.isArray(target) && isZero(target) && typeof origin === "string") target = getZeroUnit(origin);
    var isOriginAnimatable = isAnimatable(key, origin);
    warning(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(key, ' from "').concat(origin, '" to "').concat(target, '". ').concat(origin, " is not an animatable value - to enable this animation set ").concat(origin, " to a value animatable to ").concat(target, " via the `style` property."));
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? inertia(__assign(__assign({}, options), valueTransition)) : animate(__assign(__assign({}, getPopmotionAnimationOptions(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a, _b;
        var finalTarget = resolveFinalValueInKeyframes(target);
        value.set(finalTarget);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, finalTarget);
        (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 || _b.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function isZero(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function getZeroUnit(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : getAnimatableNone$2("", potentialUnitType);
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 */ function startAnimation(key, value, target, transition) {
    if (transition === void 0) transition = {};
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = getAnimation(key, value, target, transition, onComplete);
        var delay = getDelayFromTransition(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = window.setTimeout(start, secondsToMilliseconds(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var isNumericalString = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var isZeroValueString = function(v) {
    return /^0[^.\s]+$/.test(v);
};
function addUniqueItem(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function removeItem(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}
var SubscriptionManager = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        addUniqueItem(this.subscriptions, handler);
        return function() {
            return removeItem(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();
var isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var MotionValue = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "7.0.0";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new SubscriptionManager();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new SubscriptionManager();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new SubscriptionManager();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = getFrameData(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                sync.postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return sync.postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
function motionValue(init) {
    return new MotionValue(init);
}
/**
 * Tests a provided value against a ValueType
 */ var testValueType = function(v) {
    return function(type) {
        return type.test(v);
    };
};
/**
 * ValueType for "auto"
 */ var auto = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};
/**
 * A list of value types commonly used for dimensions
 */ var dimensionValueTypes = [
    number,
    px,
    percent,
    degrees,
    vw,
    vh,
    auto
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var findDimensionValueType = function(v) {
    return dimensionValueTypes.find(testValueType(v));
};
/**
 * A list of all ValueTypes
 */ var valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes), false), [
    color,
    complex
], false);
/**
 * Tests a value against the list of ValueTypes
 */ var findValueType = function(v) {
    return valueTypes.find(testValueType(v));
};
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, motionValue(value));
}
function setTarget(visualElement, definition) {
    var resolved = resolveVariant(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = __rest(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = __assign(__assign({}, target), transitionEnd);
    for(var key in target){
        var value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!findValueType(value) && complex.test(targetValue)) value = getAnimatableNone$2(key, targetValue);
        visualElement.addValue(key, motionValue(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}
function animateVisualElement(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart(definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? resolveVariant(visualElement, definition, options.custom) : definition;
        animation = animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = resolveVariant(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = __read(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = __rest(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && shouldBlockAnimation(animationTypeState, key)) continue;
        var valueTransition = __assign({
            delay: delay
        }, transition);
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */ if (visualElement.shouldReduceMotion && isTransformProp(key)) valueTransition = __assign(__assign({}, valueTransition), {
            type: false,
            delay: 0
        });
        var animation = startAnimation(key, value, valueTarget, valueTransition);
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && setTarget(visualElement, transitionEnd);
    });
}
function animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort(sortByTreeOrder).forEach(function(child, i) {
        animations.push(animateVariant(child, variant, __assign(__assign({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
var variantPriorityOrder = [
    AnimationType.Animate,
    AnimationType.InView,
    AnimationType.Focus,
    AnimationType.Hover,
    AnimationType.Tap,
    AnimationType.Drag,
    AnimationType.Exit
];
var reversePriorityOrder = __spreadArray([], __read(variantPriorityOrder), false).reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return animateVisualElement(visualElement, animation, options);
        }));
    };
}
function createAnimationState(visualElement) {
    var animate = animateList(visualElement);
    var state = createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = resolveVariant(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = __rest(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = __assign(__assign(__assign({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = isVariantLabel(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = __assign({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            isAnimationControls(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = __assign(__assign({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                        if (!shallowCompare(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = __assign(__assign({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, __spreadArray([], __read(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: __assign({
                        type: type
                    }, options)
                };
            })), false));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = __assign({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        var animations = animateChanges(options, type);
        for(var key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (isVariantLabels(next)) return !shallowCompare(next, prev);
    return false;
}
function createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function createState() {
    var _a;
    return _a = {}, _a[AnimationType.Animate] = createTypeState(true), _a[AnimationType.InView] = createTypeState(), _a[AnimationType.Hover] = createTypeState(), _a[AnimationType.Tap] = createTypeState(), _a[AnimationType.Drag] = createTypeState(), _a[AnimationType.Focus] = createTypeState(), _a[AnimationType.Exit] = createTypeState(), _a;
}
var animations = {
    animation: makeRenderlessComponent(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if (isAnimationControls(animate)) (0, _react.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: makeRenderlessComponent(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
        var presenceContext = (0, _react.useContext)(PresenceContext);
        (0, _react.useEffect)(function() {
            var _a, _b;
            visualElement.isPresent = isPresent;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(safeToRemove));
        }, [
            isPresent
        ]);
    })
};
/**
 * @internal
 */ var PanSession = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        var _this = this;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = distance(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = getFrameData().timestamp;
            _this.history.push(__assign(__assign({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if (isMouseEvent(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            sync.update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = getPanInfo(transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (isTouchEvent(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = extractEventInfo(event);
        var initialInfo = transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = getFrameData().timestamp;
        this.history = [
            __assign(__assign({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        cancelSync.update(this.updatePoint);
    };
    return PanSession;
}();
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity$1(history, 0.1)
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity$1(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}
function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return distance(value, target) < maxDistance;
}
function calcAxisDelta(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = mix(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = mix(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    calcAxisDelta(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function applyConstraints(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function calcRelativeConstraints(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = __read([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function calcOrigin$1(source, target) {
    var origin = 0.5;
    var sourceLength = calcLength(source);
    var targetLength = calcLength(target);
    if (targetLength > sourceLength) origin = progress(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = progress(source.min, source.max - targetLength, target.min);
    return clamp$1(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function rebaseAxisConstraints(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function resolveDragElastic(dragElastic) {
    if (dragElastic === void 0) dragElastic = defaultElastic;
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = defaultElastic;
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom")
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel)
    };
}
function resolvePointElastic(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}
var createAxisDelta = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var createDelta = function() {
    return {
        x: createAxisDelta(),
        y: createAxisDelta()
    };
};
var createAxis = function() {
    return {
        min: 0,
        max: 0
    };
};
var createBox = function() {
    return {
        x: createAxis(),
        y: createAxis()
    };
};
function eachAxis(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function convertBoundingBoxToBox(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function convertBoxToBoundingBox(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function transformBoxPoints(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}
function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale(_a) {
    var scale = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
    return !isIdentityScale(scale) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
    return hasScale(values) || hasTranslate(values.x) || hasTranslate(values.y) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function hasTranslate(value) {
    return value && value !== "0%";
}
/**
 * Scales a point based on a factor and an originPoint
 */ function scalePoint(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = scalePoint(point, boxScale, originPoint);
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function applyAxisDelta(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function applyBoxDelta(box, _a) {
    var x = _a.x, y = _a.y;
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function applyTreeDeltas(box, treeScale, treePath, isSharedTransition) {
    var _a, _b;
    if (isSharedTransition === void 0) isSharedTransition = false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) transformBox(box, {
            x: -node.scroll.x,
            y: -node.scroll.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && hasTransform(node.latestValues)) transformBox(box, node.latestValues);
    }
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function transformAxis(axis, transforms, _a) {
    var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = mix(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var xKeys = [
    "x",
    "scaleX",
    "originX"
];
var yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function transformBox(box, transform) {
    transformAxis(box.x, transform, xKeys);
    transformAxis(box.y, transform, yKeys);
}
function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = measureViewportBox(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        translateAxis(viewportBox.x, scroll.x);
        translateAxis(viewportBox.y, scroll.y);
    }
    return viewportBox;
}
var elementDragControls = new WeakMap();
/**
 *
 */ // let latestPointerEvent: AnyPointerEvent
var VisualElementDragControls = /** @class */ function() {
    function VisualElementDragControls(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = createBox();
        this.visualElement = visualElement;
    }
    VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
        /**
         * Don't start dragging if this component is exiting
         */ if (this.visualElement.isPresent === false) return;
        var onSessionStart = function(event) {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopAnimation();
            if (snapToCursor) _this.snapToCursor(extractEventInfo(event, "page").point);
        };
        var onStart = function(event, info) {
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _b = _this.getProps(), drag = _b.drag, dragPropagation = _b.dragPropagation, onDragStart = _b.onDragStart;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            _this.isDragging = true;
            _this.currentDirection = null;
            _this.resolveConstraints();
            if (_this.visualElement.projection) {
                _this.visualElement.projection.isAnimationBlocked = true;
                _this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ eachAxis(function(axis) {
                var _a, _b;
                var current = _this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if (percent.test(current)) {
                    var measuredAxis = (_b = (_a = _this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.actual[axis];
                    if (measuredAxis) {
                        var length_1 = calcLength(measuredAxis);
                        current = length_1 * (parseFloat(current) / 100);
                    }
                }
                _this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 || onDragStart(event, info);
            (_a = _this.visualElement.animationState) === null || _a === void 0 || _a.setActive(AnimationType.Drag, true);
        };
        var onMove = function(event, info) {
            // latestPointerEvent = event
            var _a = _this.getProps(), dragPropagation = _a.dragPropagation, dragDirectionLock = _a.dragDirectionLock, onDirectionLock = _a.onDirectionLock, onDrag = _a.onDrag;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) onDirectionLock === null || onDirectionLock === void 0 || onDirectionLock(_this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ _this.visualElement.syncRender();
            /**
             * This must fire after the syncRender call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag === null || onDrag === void 0 || onDrag(event, info);
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        this.panSession = new PanSession(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.startAnimation(velocity);
        var onDragEnd = this.getProps().onDragEnd;
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(event, info);
    };
    VisualElementDragControls.prototype.cancel = function() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) this.visualElement.projection.isAnimationBlocked = false;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = undefined;
        var dragPropagation = this.getProps().dragPropagation;
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive(AnimationType.Drag, false);
    };
    VisualElementDragControls.prototype.updateAxis = function(axis, _point, offset) {
        var drag = this.getProps().drag;
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection)) return;
        var axisValue = this.getAxisMotionValue(axis);
        var next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    };
    VisualElementDragControls.prototype.resolveConstraints = function() {
        var _this = this;
        var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = (this.visualElement.projection || {}).layout;
        var prevConstraints = this.constraints;
        if (dragConstraints && isRefObject(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = calcRelativeConstraints(layout.actual, dragConstraints);
        else this.constraints = false;
        this.elastic = resolveDragElastic(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) eachAxis(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = rebaseAxisConstraints(layout.actual[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function() {
        var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
        if (!constraints || !isRefObject(constraints)) return false;
        var constraintsElement = constraints.current;
        invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        var projection = this.visualElement.projection;
        // TODO
        if (!projection || !projection.layout) return false;
        var constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        var measuredConstraints = calcViewportConstraints(projection.layout.actual, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = convertBoundingBoxToBox(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.startAnimation = function(velocity) {
        var _this = this;
        var _a = this.getProps(), drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
        var constraints = this.constraints || {};
        var momentumAnimations = eachAxis(function(axis) {
            var _a;
            if (!shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = __assign(__assign({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        return startAnimation(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.stopAnimation = function() {
        var _this = this;
        eachAxis(function(axis) {
            return _this.getAxisMotionValue(axis).stop();
        });
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a, _b;
        var dragKey = "_drag" + axis.toUpperCase();
        var externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    };
    VisualElementDragControls.prototype.snapToCursor = function(point) {
        var _this = this;
        eachAxis(function(axis) {
            var drag = _this.getProps().drag;
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, _this.currentDirection)) return;
            var projection = _this.visualElement.projection;
            var axisValue = _this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                var _a = projection.layout.actual[axis], min = _a.min, max = _a.max;
                axisValue.set(point[axis] - mix(min, max, 0.5));
            }
        });
    };
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ VisualElementDragControls.prototype.scalePositionWithinConstraints = function() {
        var _this = this;
        var _a;
        var _b = this.getProps(), drag = _b.drag, dragConstraints = _b.dragConstraints;
        var projection = this.visualElement.projection;
        if (!isRefObject(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ var boxProgress = {
            x: 0,
            y: 0
        };
        eachAxis(function(axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var latest = axisValue.get();
                boxProgress[axis] = calcOrigin$1({
                    min: latest,
                    max: latest
                }, _this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ var transformTemplate = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ eachAxis(function(axis) {
            if (!shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ var axisValue = _this.getAxisMotionValue(axis);
            var _a = _this.constraints[axis], min = _a.min, max = _a.max;
            axisValue.set(mix(min, max, boxProgress[axis]));
        });
    };
    VisualElementDragControls.prototype.addListeners = function() {
        var _this = this;
        var _a;
        elementDragControls.set(this.visualElement, this);
        var element = this.visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = addPointerEvent(element, "pointerdown", function(event) {
            var _a = _this.getProps(), drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        var measureDragConstraints = function() {
            var dragConstraints = _this.getProps().dragConstraints;
            if (isRefObject(dragConstraints)) _this.constraints = _this.resolveRefConstraints();
        };
        var projection = this.visualElement.projection;
        var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 || _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = addDomEvent(window, "resize", function() {
            return _this.scalePositionWithinConstraints();
        });
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ var stopLayoutUpdateListener = projection.addEventListener("didUpdate", function(_a) {
            var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged;
            if (_this.isDragging && hasLayoutChanged) {
                eachAxis(function(axis) {
                    var motionValue = _this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    _this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                _this.visualElement.syncRender();
            }
        });
        return function() {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 || stopLayoutUpdateListener();
        };
    };
    VisualElementDragControls.prototype.getProps = function() {
        var props = this.visualElement.getProps();
        var _a = props.drag, drag = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e = props.dragElastic, dragElastic = _e === void 0 ? defaultElastic : _e, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
        return __assign(__assign({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    };
    return VisualElementDragControls;
}();
function shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}
/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function useDrag(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var dragControls = useConstant(function() {
        return new VisualElementDragControls(visualElement);
    });
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, _react.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls,
        groupDragControls
    ]);
    // Apply the event listeners to the element
    (0, _react.useEffect)(function() {
        return dragControls.addListeners();
    }, [
        dragControls
    ]);
}
/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function usePanGesture(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, _react.useRef)(null);
    var transformPagePoint = (0, _react.useContext)(MotionConfigContext).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, _react.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new PanSession(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    useUnmountEffect(function() {
        return panSession.current && panSession.current.end();
    });
}
var drag = {
    pan: makeRenderlessComponent(usePanGesture),
    drag: makeRenderlessComponent(useDrag)
};
var names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "LayoutAnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function createLifecycles() {
    var managers = names.map(function() {
        return new SubscriptionManager();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            names.forEach(function(name) {
                var _a;
                var on = "on" + name;
                var propListener = props[on];
                // Unsubscribe existing subscription
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                // Add new subscription
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, __spreadArray([], __read(args), false));
        };
    });
    return lifecycles;
}
function updateMotionValuesFromProps(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if (isMotionValue(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if (isMotionValue(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, motionValue(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, motionValue((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}
var visualElement = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState, shouldReduceMotion = _a.shouldReduceMotion;
        if (options === void 0) options = {};
        var isMounted = false;
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender
         */ var lifecycles = createLifecycles();
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = __assign({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         * Render the element with the latest styles outside of the React
         * render lifecycle
         */ function render() {
            if (!instance || !isMounted) return;
            triggerBuild();
            renderInstance(instance, renderState, props.style, element.projection);
        }
        function triggerBuild() {
            build(element, renderState, latestValues, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && sync.update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = checkIfControllingVariants(props);
        var isVariantNode = checkIfVariantNode(props);
        var element = __assign(__assign({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             *
             */ presenceId: presenceId,
            shouldReduceMotion: shouldReduceMotion,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by the projection tree, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                isMounted = true;
                instance = element.current = newInstance;
                if (element.projection) element.projection.mount(newInstance);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                values.forEach(function(value, key) {
                    return bindToMotionValue(key, value);
                });
                parent === null || parent === void 0 || parent.children.add(element);
                element.setProps(props);
            },
            /**
             *
             */ unmount: function() {
                var _a;
                (_a = element.projection) === null || _a === void 0 || _a.unmount();
                cancelSync.update(update);
                cancelSync.render(render);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                lifecycles.clearAllListeners();
                instance = undefined;
                isMounted = false;
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function() {
                return measureViewportBox(instance, props);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = motionValue(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !isMotionValue(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                sync.render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                if (newProps.transformTemplate || props.transformTemplate) element.scheduleRender();
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            getTransformPagePoint: function() {
                return props.transformPagePoint;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < numVariantProps; i++){
                    var name_1 = variantProps[i];
                    var prop = props[name_1];
                    if (isVariantLabel(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            }
        });
        return element;
    };
};
var variantProps = __spreadArray([
    "initial"
], __read(variantPriorityOrder), false);
var numVariantProps = variantProps.length;
function isCSSVariable$1(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    var match = cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    var _a = __read(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var maxDepth = 4;
function getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    invariant(depth <= maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'));
    var _a = __read(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if (isCSSVariable$1(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function resolveCSSVariables(visualElement, _a, transitionEnd) {
    var _b;
    var target = __rest(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = __assign({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!isCSSVariable$1(current)) return;
        var resolved = getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!isCSSVariable$1(current)) continue;
        var resolved = getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}
var positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var isPositionalKey = function(key) {
    return positionalKeys.has(key);
};
var hasPositionalKey = function(target) {
    return Object.keys(target).some(isPositionalKey);
};
var setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var isNumOrPxType = function(v) {
    return v === number || v === px;
};
var BoundingBoxDimension;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var nonTranslationalTransformKeys = transformProps.filter(function(key) {
    return !transformKeys.has(key);
});
function removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var positionalValues = {
    // Dimensions
    width: function(_a, _b) {
        var x = _a.x;
        var _c = _b.paddingLeft, paddingLeft = _c === void 0 ? "0" : _c, _d = _b.paddingRight, paddingRight = _d === void 0 ? "0" : _d;
        return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(_a, _b) {
        var y = _a.y;
        var _c = _b.paddingTop, paddingTop = _c === void 0 ? "0" : _c, _d = _b.paddingBottom, paddingBottom = _d === void 0 ? "0" : _d;
        return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14)
};
var convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display;
    var origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach(function(key) {
        origin[key] = positionalValues[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        setAndResetVelocity(value, origin[key]);
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = __assign({}, target);
    transitionEnd = __assign({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var fromType = findDimensionValueType(from);
        var to = target[key];
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if (isKeyframesTarget(to)) {
            var numKeyframes = to.length;
            var fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = findDimensionValueType(from);
            for(var i = fromIndex; i < numKeyframes; i++)if (!toType) {
                toType = findDimensionValueType(to[i]);
                invariant(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = findDimensionValueType(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === px) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var scrollY_1 = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        // Restore scroll position
        if (scrollY_1 !== null) window.scrollTo({
            top: scrollY_1
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}
/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var parseDomVariant = function(visualElement, target, origin, transitionEnd) {
    var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};
function getComputedStyle$1(element) {
    return window.getComputedStyle(element);
}
var htmlConfig = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if (isTransformProp(key)) {
            var defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = getComputedStyle$1(domElement);
            return (isCSSVariable(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return measureViewportBox(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest(_a, [
            "transition",
            "transitionEnd"
        ]);
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var origin = getOrigin(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            checkTargetForNewValues(element, target, origin);
            var parsed = parseDomVariant(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return __assign({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
    build: function(element, renderState, latestValues, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    },
    render: renderHTML
};
var htmlVisualElement = visualElement(htmlConfig);
var svgVisualElement = visualElement(__assign(__assign({}, htmlConfig), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if (isTransformProp(key)) return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    build: function(_element, renderState, latestValues, options, props) {
        buildSVGAttrs(renderState, latestValues, options, props.transformTemplate);
    },
    render: renderSVG
}));
var createDomVisualElement = function(Component, options) {
    return isSVGComponent(Component) ? svgVisualElement(options, {
        enableHardwareAcceleration: false
    }) : htmlVisualElement(options, {
        enableHardwareAcceleration: true
    });
};
function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var correctBorderRadius = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if (px.test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = pixelsToPercent(latest, node.target.x);
        var y = pixelsToPercent(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};
var varToken = "_$css";
var correctBoxShadow = {
    correct: function(latest, _a) {
        var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
        var original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */ var containsCSSVariables = latest.includes("var(");
        var cssVariables = [];
        if (containsCSSVariables) latest = latest.replace(cssVariableRegex, function(match) {
            cssVariables.push(match);
            return varToken;
        });
        var shadow = complex.parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = complex.createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = mix(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        var output = template(shadow);
        if (containsCSSVariables) {
            var i_1 = 0;
            output = output.replace(varToken, function() {
                var cssVariable = cssVariables[i_1];
                i_1++;
                return cssVariable;
            });
        }
        return output;
    }
};
var MeasureLayoutWithContext = /** @class */ function(_super) {
    __extends(MeasureLayoutWithContext, _super);
    function MeasureLayoutWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ MeasureLayoutWithContext.prototype.componentDidMount = function() {
        var _this = this;
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
        var projection = visualElement.projection;
        addScaleCorrector(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.add(projection);
            if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", function() {
                _this.safeToRemove();
            });
            projection.setOptions(__assign(__assign({}, projection.options), {
                onExitComplete: function() {
                    return _this.safeToRemove();
                }
            }));
        }
        globalProjectionState.hasEverUpdated = true;
    };
    MeasureLayoutWithContext.prototype.getSnapshotBeforeUpdate = function(prevProps) {
        var _this = this;
        var _a = this.props, layoutDependency = _a.layoutDependency, visualElement = _a.visualElement, drag = _a.drag, isPresent = _a.isPresent;
        var projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ sync.postRender(function() {
                var _a;
                if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) _this.safeToRemove();
            });
        }
        return null;
    };
    MeasureLayoutWithContext.prototype.componentDidUpdate = function() {
        var projection = this.props.visualElement.projection;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
        }
    };
    MeasureLayoutWithContext.prototype.componentWillUnmount = function() {
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
        var projection = visualElement.projection;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister) promoteContext.deregister(projection);
        }
    };
    MeasureLayoutWithContext.prototype.safeToRemove = function() {
        var safeToRemove = this.props.safeToRemove;
        safeToRemove === null || safeToRemove === void 0 || safeToRemove();
    };
    MeasureLayoutWithContext.prototype.render = function() {
        return null;
    };
    return MeasureLayoutWithContext;
}((0, _reactDefault.default).Component);
function MeasureLayout(props) {
    var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var layoutGroup = (0, _react.useContext)(LayoutGroupContext);
    return (0, _reactDefault.default).createElement(MeasureLayoutWithContext, __assign({}, props, {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, _react.useContext)(SwitchLayoutGroupContext),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}
var defaultScaleCorrectors = {
    borderRadius: __assign(__assign({}, correctBorderRadius), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: correctBorderRadius,
    borderTopRightRadius: correctBorderRadius,
    borderBottomLeftRadius: correctBorderRadius,
    borderBottomRightRadius: correctBorderRadius,
    boxShadow: correctBoxShadow
};
var layoutFeatures = {
    measureLayout: MeasureLayout
};
/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */ function animate$1(from, to, transition) {
    if (transition === void 0) transition = {};
    var value = isMotionValue(from) ? from : motionValue(from);
    startAnimation("", value, to, transition);
    return {
        stop: function() {
            return value.stop();
        },
        isAnimating: function() {
            return value.isAnimating();
        }
    };
}
var borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
var numBorders = borders.length;
var asNumber = function(value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var isPx = function(value) {
    return typeof value === "number" || px.test(value);
};
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _a, _b, _c, _d;
    if (shouldCrossfadeOpacity) {
        target.opacity = mix(0, // (follow?.opacity as number) ?? 0,
        // TODO Reinstate this if only child
        (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, easeCrossfadeIn(progress));
        target.opacityExit = mix((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = mix((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress);
    /**
     * Mix border radius
     */ for(var i = 0; i < numBorders; i++){
        var borderLabel = "border".concat(borders[i], "Radius");
        var followRadius = getRadius(follow, borderLabel);
        var leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if (percent.test(leadRadius) || percent.test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress);
}
function getRadius(values, radiusName) {
    var _a;
    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, linear);
function compress(min, max, easing) {
    return function(p) {
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing(progress(min, max, p));
    };
}
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = scalePoint(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function removeAxisDelta(axis, translate, scale, origin, boxScale, originAxis, sourceAxis) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    if (originAxis === void 0) originAxis = axis;
    if (sourceAxis === void 0) sourceAxis = axis;
    if (percent.test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    var originPoint = mix(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeAxisTransforms(axis, transforms, _a, origin, sourceAxis) {
    var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var xKeys$1 = [
    "x",
    "scaleX",
    "originX"
];
var yKeys$1 = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys$1, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    removeAxisTransforms(box.y, transforms, yKeys$1, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}
function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
var NodeStack = /** @class */ function() {
    function NodeStack() {
        this.members = [];
    }
    NodeStack.prototype.add = function(node) {
        addUniqueItem(this.members, node);
        node.scheduleRender();
    };
    NodeStack.prototype.remove = function(node) {
        removeItem(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            var prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    };
    NodeStack.prototype.relegate = function(node) {
        var indexOfNode = this.members.findIndex(function(member) {
            return node === member;
        });
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ var prevLead;
        for(var i = indexOfNode; i >= 0; i--){
            var member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    };
    NodeStack.prototype.promote = function(node, preserveFollowOpacity) {
        var _a;
        var prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                node.snapshot.isShared = true;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) node.isLayoutDirty = true;
            var crossfade = node.options.crossfade;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    };
    NodeStack.prototype.exitAnimationComplete = function() {
        this.members.forEach(function(node) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 || _e.call(_d);
        });
    };
    NodeStack.prototype.scheduleRender = function() {
        this.members.forEach(function(node) {
            node.instance && node.scheduleRender(false);
        });
    };
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ NodeStack.prototype.removeLeadSnapshot = function() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    };
    return NodeStack;
}();
var identityProjection = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function buildProjectionTransform(delta, treeScale, latestTransform) {
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ transform += "scale(".concat(1 / treeScale.x, ", ").concat(1 / treeScale.y, ") ");
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX) transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY) transform += "rotateY(".concat(rotateY, "deg) ");
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ var elementScaleX = delta.x.scale * treeScale.x;
    var elementScaleY = delta.y.scale * treeScale.y;
    transform += "scale(".concat(elementScaleX, ", ").concat(elementScaleY, ")");
    return transform === identityProjection ? "none" : transform;
}
var compareByDepth = function(a, b) {
    return a.depth - b.depth;
};
var FlatTree = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        addUniqueItem(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        removeItem(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort(compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ var animationTarget = 1000;
function createProjectionNode(_a) {
    var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, checkIsScrollRoot = _a.checkIsScrollRoot, resetTransform = _a.resetTransform;
    return /** @class */ function() {
        function ProjectionNode(id, latestValues, parent) {
            if (latestValues === void 0) latestValues = {};
            if (parent === void 0) parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent();
            var _this = this;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to actually
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = function() {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            this.updateProjection = function() {
                _this.nodes.forEach(resolveTargetDelta);
                _this.nodes.forEach(calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.id = id;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? __spreadArray(__spreadArray([], __read(parent.path), false), [
                parent
            ], false) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            id && this.root.registerPotentialNode(id, this);
            for(var i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new FlatTree();
        }
        ProjectionNode.prototype.addEventListener = function(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new SubscriptionManager());
            return this.eventHandlers.get(name).add(handler);
        };
        ProjectionNode.prototype.notifyListeners = function(name) {
            var args = [];
            for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
            var subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 || subscriptionManager.notify.apply(subscriptionManager, __spreadArray([], __read(args), false));
        };
        ProjectionNode.prototype.hasListeners = function(name) {
            return this.eventHandlers.has(name);
        };
        ProjectionNode.prototype.registerPotentialNode = function(id, node) {
            this.potentialNodes.set(id, node);
        };
        /**
         * Lifecycles
         */ ProjectionNode.prototype.mount = function(instance, isLayoutDirty) {
            var _this = this;
            var _a;
            if (isLayoutDirty === void 0) isLayoutDirty = false;
            if (this.instance) return;
            this.isSVG = instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement = _b.visualElement;
            if (visualElement && !visualElement.getInstance()) visualElement.mount(instance);
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 || _a.children.add(this);
            this.id && this.root.potentialNodes.delete(this.id);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                var unblockTimeout_1;
                var resizeUnblockUpdate_1 = function() {
                    return _this.root.updateBlockedByResize = false;
                };
                attachResizeListener(instance, function() {
                    _this.root.updateBlockedByResize = true;
                    clearTimeout(unblockTimeout_1);
                    unblockTimeout_1 = window.setTimeout(resizeUnblockUpdate_1, 250);
                    if (globalProjectionState.hasAnimatedSinceResize) {
                        globalProjectionState.hasAnimatedSinceResize = false;
                        _this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", function(_a) {
                var _b, _c, _d, _e, _f;
                var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged, hasRelativeTargetChanged = _a.hasRelativeTargetChanged, newLayout = _a.layout;
                if (_this.isTreeAnimationBlocked()) {
                    _this.target = undefined;
                    _this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                var layoutTransition = (_c = (_b = _this.options.transition) !== null && _b !== void 0 ? _b : visualElement.getDefaultTransition()) !== null && _c !== void 0 ? _c : defaultLayoutTransition;
                var _g = visualElement.getProps(), onLayoutAnimationStart = _g.onLayoutAnimationStart, onLayoutAnimationComplete = _g.onLayoutAnimationComplete;
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ var targetChanged = !_this.targetLayout || !boxEquals(_this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !_this.currentAnimation)) {
                    if (_this.resumeFrom) {
                        _this.resumingFrom = _this.resumeFrom;
                        _this.resumingFrom.resumingFrom = undefined;
                    }
                    _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    var animationOptions = __assign(__assign({}, getValueTransition(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    _this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged && _this.animationProgress === 0) _this.finishAnimation();
                    _this.isLead() && ((_f = (_e = _this.options).onExitComplete) === null || _f === void 0 || _f.call(_e));
                }
                _this.targetLayout = newLayout;
            });
        };
        ProjectionNode.prototype.unmount = function() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 || _a.remove(this);
            (_b = this.parent) === null || _b === void 0 || _b.children.delete(this);
            this.instance = undefined;
            cancelSync.preRender(this.updateProjection);
        };
        // only on the root
        ProjectionNode.prototype.blockUpdate = function() {
            this.updateManuallyBlocked = true;
        };
        ProjectionNode.prototype.unblockUpdate = function() {
            this.updateManuallyBlocked = false;
        };
        ProjectionNode.prototype.isUpdateBlocked = function() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        };
        ProjectionNode.prototype.isTreeAnimationBlocked = function() {
            var _a;
            return this.isAnimationBlocked || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) || false;
        };
        // Note: currently only running on root node
        ProjectionNode.prototype.startUpdate = function() {
            var _a;
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 || _a.forEach(resetRotation);
        };
        ProjectionNode.prototype.willUpdate = function(shouldNotifyListeners) {
            var _a, _b, _c;
            if (shouldNotifyListeners === void 0) shouldNotifyListeners = true;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 || _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * TODO: Check we haven't updated the scroll
                 * since the last didUpdate
                 */ node.updateScroll();
            }
            var _d = this.options, layoutId = _d.layoutId, layout = _d.layout;
            if (layoutId === undefined && !layout) return;
            var transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        };
        // Note: Currently only running on root node
        ProjectionNode.prototype.didUpdate = function() {
            var updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */ if (this.potentialNodes.size) {
                this.potentialNodes.forEach(mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */ this.nodes.forEach(resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach(updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            flushSync.update();
            flushSync.preRender();
            flushSync.render();
        };
        ProjectionNode.prototype.clearAllSnapshots = function() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        };
        ProjectionNode.prototype.scheduleUpdateProjection = function() {
            sync.preRender(this.updateProjection, false, true);
        };
        ProjectionNode.prototype.scheduleCheckAfterUnmount = function() {
            var _this = this;
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ sync.postRender(function() {
                if (_this.isLayoutDirty) _this.root.didUpdate();
                else _this.root.checkUpdateFailed();
            });
        };
        /**
         * Update measurements
         */ ProjectionNode.prototype.updateSnapshot = function() {
            if (this.snapshot || !this.instance) return;
            var measured = this.measure();
            var layout = this.removeTransform(this.removeElementScroll(measured));
            roundBox(layout);
            this.snapshot = {
                measured: measured,
                layout: layout,
                latestValues: {}
            };
        };
        ProjectionNode.prototype.updateLayout = function() {
            var _a;
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                node.updateScroll();
            }
            var measured = this.measure();
            roundBox(measured);
            var prevLayout = this.layout;
            this.layout = {
                measured: measured,
                actual: this.removeElementScroll(measured)
            };
            this.layoutCorrected = createBox();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.actual);
            (_a = this.options.visualElement) === null || _a === void 0 || _a.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
        };
        ProjectionNode.prototype.updateScroll = function() {
            if (this.options.layoutScroll && this.instance) {
                this.isScrollRoot = checkIsScrollRoot(this.instance);
                this.scroll = measureScroll(this.instance);
            }
        };
        ProjectionNode.prototype.resetTransform = function() {
            var _a;
            if (!resetTransform) return;
            var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            var hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || hasTransform(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        };
        ProjectionNode.prototype.measure = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return createBox();
            var box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            var scroll = this.root.scroll;
            if (scroll) {
                translateAxis(box.x, scroll.x);
                translateAxis(box.y, scroll.y);
            }
            return box;
        };
        ProjectionNode.prototype.removeElementScroll = function(box) {
            var boxWithoutScroll = createBox();
            copyBoxInto(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                var scroll_1 = node.scroll, options = node.options, isScrollRoot = node.isScrollRoot;
                if (node !== this.root && scroll_1 && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (isScrollRoot) {
                        copyBoxInto(boxWithoutScroll, box);
                        var rootScroll = this.root.scroll;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            translateAxis(boxWithoutScroll.x, -rootScroll.x);
                            translateAxis(boxWithoutScroll.y, -rootScroll.y);
                        }
                    }
                    translateAxis(boxWithoutScroll.x, scroll_1.x);
                    translateAxis(boxWithoutScroll.y, scroll_1.y);
                }
            }
            return boxWithoutScroll;
        };
        ProjectionNode.prototype.applyTransform = function(box, transformOnly) {
            if (transformOnly === void 0) transformOnly = false;
            var withTransforms = createBox();
            copyBoxInto(withTransforms, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) transformBox(withTransforms, {
                    x: -node.scroll.x,
                    y: -node.scroll.y
                });
                if (!hasTransform(node.latestValues)) continue;
                transformBox(withTransforms, node.latestValues);
            }
            if (hasTransform(this.latestValues)) transformBox(withTransforms, this.latestValues);
            return withTransforms;
        };
        ProjectionNode.prototype.removeTransform = function(box) {
            var _a;
            var boxWithoutTransform = createBox();
            copyBoxInto(boxWithoutTransform, box);
            for(var i = 0; i < this.path.length; i++){
                var node = this.path[i];
                if (!node.instance) continue;
                if (!hasTransform(node.latestValues)) continue;
                hasScale(node.latestValues) && node.updateSnapshot();
                var sourceBox = createBox();
                var nodeBox = node.measure();
                copyBoxInto(sourceBox, nodeBox);
                removeBoxTransforms(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layout, sourceBox);
            }
            if (hasTransform(this.latestValues)) removeBoxTransforms(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        };
        /**
         *
         */ ProjectionNode.prototype.setTargetDelta = function(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
        };
        ProjectionNode.prototype.setOptions = function(options) {
            var _a;
            this.options = __assign(__assign(__assign({}, this.options), options), {
                crossfade: (_a = options.crossfade) !== null && _a !== void 0 ? _a : true
            });
        };
        ProjectionNode.prototype.clearMeasurements = function() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        };
        /**
         * Frame calculations
         */ ProjectionNode.prototype.resolveTargetDelta = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.layout) {
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = createBox();
                this.targetWithTransforms = createBox();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.actual);
                else copyBoxInto(this.target, this.layout.actual);
                applyBoxDelta(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ copyBoxInto(this.target, this.layout.actual);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && Boolean(this.relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !this.relativeParent.options.layoutScroll && this.relativeParent.target) {
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.target, this.relativeParent.target);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
        };
        ProjectionNode.prototype.getClosestProjectingParent = function() {
            if (!this.parent || hasTransform(this.parent.latestValues)) return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout) return this.parent;
            else return this.parent.getClosestProjectingParent();
        };
        ProjectionNode.prototype.calcProjection = function() {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            var lead = this.getLead();
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ copyBoxInto(this.layoutCorrected, this.layout.actual);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
            var target = lead.target;
            if (!target) return;
            if (!this.projectionDelta) {
                this.projectionDelta = createDelta();
                this.projectionDeltaWithTransform = createDelta();
            }
            var prevTreeScaleX = this.treeScale.x;
            var prevTreeScaleY = this.treeScale.y;
            var prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        };
        ProjectionNode.prototype.hide = function() {
            this.isVisible = false;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.show = function() {
            this.isVisible = true;
        // TODO: Schedule render
        };
        ProjectionNode.prototype.scheduleRender = function(notifyAll) {
            var _a, _b, _c;
            if (notifyAll === void 0) notifyAll = true;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 || _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 || _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        };
        ProjectionNode.prototype.setAnimationOrigin = function(delta, hasOnlyRelativeTargetChanged) {
            var _this = this;
            var _a;
            if (hasOnlyRelativeTargetChanged === void 0) hasOnlyRelativeTargetChanged = false;
            var snapshot = this.snapshot;
            var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            var mixedValues = __assign({}, this.latestValues);
            var targetDelta = createDelta();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            var relativeLayout = createBox();
            var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
            var isOnlyMember = (((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.members.length) || 0) <= 1;
            var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = function(latest) {
                var _a;
                var progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                _this.setTargetDelta(targetDelta);
                if (_this.relativeTarget && _this.relativeTargetOrigin && _this.layout && ((_a = _this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    calcRelativePosition(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
                    mixBox(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    _this.animationValues = mixedValues;
                    mixValues(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                _this.root.scheduleUpdateProjection();
                _this.scheduleRender();
                _this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        };
        ProjectionNode.prototype.startAnimation = function(options) {
            var _this = this;
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 || _a.stop();
            if (this.resumingFrom) (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 || _b.stop();
            if (this.pendingAnimation) {
                cancelSync.update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = sync.update(function() {
                globalProjectionState.hasAnimatedSinceResize = true;
                _this.currentAnimation = animate$1(0, animationTarget, __assign(__assign({}, options), {
                    onUpdate: function(latest) {
                        var _a;
                        _this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, latest);
                    },
                    onComplete: function() {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 || _a.call(options);
                        _this.completeAnimation();
                    }
                }));
                if (_this.resumingFrom) _this.resumingFrom.currentAnimation = _this.currentAnimation;
                _this.pendingAnimation = undefined;
            });
        };
        ProjectionNode.prototype.completeAnimation = function() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 || _a.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        };
        ProjectionNode.prototype.finishAnimation = function() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 || _a.call(this, animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        };
        ProjectionNode.prototype.applyTransformsToTarget = function() {
            var _a = this.getLead(), targetWithTransforms = _a.targetWithTransforms, target = _a.target, layout = _a.layout, latestValues = _a.latestValues;
            if (!targetWithTransforms || !target || !layout) return;
            copyBoxInto(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ transformBox(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its actual layout
             * into the desired bounding box.
             */ calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        };
        ProjectionNode.prototype.registerSharedNode = function(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new NodeStack());
            var stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node)
            });
        };
        ProjectionNode.prototype.isLead = function() {
            var stack = this.getStack();
            return stack ? stack.lead === this : true;
        };
        ProjectionNode.prototype.getLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        };
        ProjectionNode.prototype.getPrevLead = function() {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        };
        ProjectionNode.prototype.getStack = function() {
            var layoutId = this.options.layoutId;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        };
        ProjectionNode.prototype.promote = function(_a) {
            var _b = _a === void 0 ? {} : _a, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
            var stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        };
        ProjectionNode.prototype.relegate = function() {
            var stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        };
        ProjectionNode.prototype.resetRotation = function() {
            var visualElement = this.options.visualElement;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            var hasRotate = false;
            // Keep a record of all the values we've reset
            var resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(var i = 0; i < transformAxes.length; i++){
                var axis = transformAxes[i];
                var key = "rotate" + axis;
                // If this rotation doesn't exist as a motion value, then we don't
                // need to reset it
                if (!visualElement.getStaticValue(key)) continue;
                hasRotate = true;
                // Record the rotation and then temporarily set it to 0
                resetValues[key] = visualElement.getStaticValue(key);
                visualElement.setStaticValue(key, 0);
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 || visualElement.syncRender();
            // Put back all the values we reset
            for(var key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        };
        ProjectionNode.prototype.getProjectionStyles = function(styleProp) {
            var _a, _b, _c, _d, _e, _f;
            if (styleProp === void 0) styleProp = {};
            // TODO: Return lifecycle-persistent object
            var styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = resolveMotionValue(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            var lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                var emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
                    emptyStyles.pointerEvents = resolveMotionValue(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !hasTransform(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            var valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            var _g = this.projectionDelta, x = _g.x, y = _g.y;
            styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its actual
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : "" : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
            /**
             * Apply scale correction
             */ for(var key in scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                var _h = scaleCorrectors[key], correct = _h.correct, applyTo = _h.applyTo;
                var corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    var num = applyTo.length;
                    for(var i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? resolveMotionValue(styleProp.pointerEvents) || "" : "none";
            return styles;
        };
        ProjectionNode.prototype.clearSnapshot = function() {
            this.resumeFrom = this.snapshot = undefined;
        };
        // Only run on root
        ProjectionNode.prototype.resetTree = function() {
            this.root.nodes.forEach(function(node) {
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        };
        return ProjectionNode;
    }();
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a, _b, _c, _d;
    var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        var _e = node.layout, layout_1 = _e.actual, measuredLayout = _e.measured;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (node.options.animationType === "size") eachAxis(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = calcLength(axisSnapshot);
            axisSnapshot.min = layout_1[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (node.options.animationType === "position") eachAxis(function(axis) {
            var axisSnapshot = snapshot.isShared ? snapshot.measured[axis] : snapshot.layout[axis];
            var length = calcLength(layout_1[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
        });
        var layoutDelta = createDelta();
        calcBoxDelta(layoutDelta, layout_1, snapshot.layout);
        var visualDelta = createDelta();
        if (snapshot.isShared) calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
        else calcBoxDelta(visualDelta, layout_1, snapshot.layout);
        var hasLayoutChanged = !isDeltaZero(layoutDelta);
        var hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            node.relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (node.relativeParent && !node.relativeParent.resumeFrom) {
                var _f = node.relativeParent, parentSnapshot = _f.snapshot, parentLayout = _f.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = createBox();
                    calcRelativePosition(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
                    var relativeLayout = createBox();
                    calcRelativePosition(relativeLayout, layout_1, parentLayout.actual);
                    if (!boxEquals(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout_1,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) (_d = (_c = node.options).onExitComplete) === null || _d === void 0 || _d.call(_c);
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function resetTransformStyle(node) {
    var visualElement = node.options.visualElement;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) visualElement.notifyBeforeLayoutMeasure();
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetRotation(node) {
    node.resetRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = mix(delta.translate, 0, p);
    output.scale = mix(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = mix(from.min, to.min, p);
    output.max = mix(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
var defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function mountNodeEarly(node, id) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */ var searchNode = node.root;
    for(var i = node.path.length - 1; i >= 0; i--)if (Boolean(node.path[i].instance)) {
        searchNode = node.path[i];
        break;
    }
    var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    var element = searchElement.querySelector('[data-projection-id="'.concat(id, '"]'));
    if (element) node.mount(element, true);
}
function roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
var DocumentProjectionNode = createProjectionNode({
    attachResizeListener: function(ref, notify) {
        return addDomEvent(ref, "resize", notify);
    },
    measureScroll: function() {
        return {
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        };
    },
    checkIsScrollRoot: function() {
        return true;
    }
});
var rootProjectionNode = {
    current: undefined
};
var HTMLProjectionNode = createProjectionNode({
    measureScroll: function(instance) {
        return {
            x: instance.scrollLeft,
            y: instance.scrollTop
        };
    },
    defaultParent: function() {
        if (!rootProjectionNode.current) {
            var documentNode = new DocumentProjectionNode(0, {});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: function(instance, value) {
        instance.style.transform = value !== null && value !== void 0 ? value : "none";
    },
    checkIsScrollRoot: function(instance) {
        return Boolean(window.getComputedStyle(instance).position === "fixed");
    }
});
var featureBundle = __assign(__assign(__assign(__assign({}, animations), gestureAnimations), drag), layoutFeatures);
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var motion = /*@__PURE__*/ createMotionProxy(function(Component, config) {
    return createDomMotionConfig(Component, config, featureBundle, createDomVisualElement, HTMLProjectionNode);
});
function useIsMounted() {
    var isMounted = (0, _react.useRef)(false);
    useIsomorphicLayoutEffect(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}
function useForceUpdate() {
    var isMounted = useIsMounted();
    var _a = __read((0, _react.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    var forceRender = (0, _react.useCallback)(function() {
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ var deferredForceRender = (0, _react.useCallback)(function() {
        return sync.postRender(forceRender);
    }, [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}
var PresenceChild = function(_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = useConstant(newChildrenMap);
    var id = useId();
    var context = (0, _react.useMemo)(function() {
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                var e_1, _a;
                presenceChildren.set(childId, true);
                try {
                    for(var _b = __values(presenceChildren.values()), _c = _b.next(); !_c.done; _c = _b.next()){
                        var isComplete = _c.value;
                        if (!isComplete) return; // can stop searching when any is incomplete
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                onExitComplete === null || onExitComplete === void 0 || onExitComplete();
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    return presenceChildren.delete(childId);
                };
            }
        };
    }, /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, _react.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ (0, _react.useEffect)(function() {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
    }, [
        isPresent
    ]);
    return (0, _react.createElement)(PresenceContext.Provider, {
        value: context
    }, children);
};
function newChildrenMap() {
    return new Map();
}
var getChildKey = function(child) {
    return child.key || "";
};
function updateChildLookup(children, allChildren) {
    children.forEach(function(child) {
        var key = getChildKey(child);
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, _react.Children).forEach(children, function(child) {
        if ((0, _react.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var AnimatePresence = function(_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var _d = __read(useForceUpdate(), 1), forceRender = _d[0];
    var forceRenderLayoutGroup = (0, _react.useContext)(LayoutGroupContext).forceRender;
    if (forceRenderLayoutGroup) forceRender = forceRenderLayoutGroup;
    var isMounted = useIsMounted();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = onlyElements(children);
    var childrenToRender = filteredChildren;
    var exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0, _react.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    var allChildren = (0, _react.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    var isInitialRender = (0, _react.useRef)(true);
    useIsomorphicLayoutEffect(function() {
        isInitialRender.current = false;
        updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    useUnmountEffect(function() {
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) return (0, _react.createElement)((0, _react.Fragment), null, childrenToRender.map(function(child) {
        return (0, _react.createElement)(PresenceChild, {
            key: getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    }));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = __spreadArray([], __read(childrenToRender), false);
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map(getChildKey);
    var targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for(var i = 0; i < numPresent; i++){
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function(key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        var child = allChildren.get(key);
        if (!child) return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function() {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function(presentChild) {
                return presentChild.key === key;
            });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false) return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, (0, _react.createElement)(PresenceChild, {
            key: getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function(child) {
        var key = child.key;
        return exiting.has(key) ? child : (0, _react.createElement)(PresenceChild, {
            key: getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    });
    if (env !== "production" && exitBeforeEnter && childrenToRender.length > 1) console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
    return (0, _react.createElement)((0, _react.Fragment), null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
        return (0, _react.cloneElement)(child);
    }));
};
var MotionWrapper = (0, _styledComponentsDefault.default)(motion.div).withConfig({
    displayName: "Motionstyled__MotionWrapper",
    componentId: "sc-1m6r1io-0"
})([
    "position:",
    ";display:",
    ";box-sizing:border-box;padding:",
    ";border:",
    ";border-color:",
    ";border-size:",
    ";border-style:",
    ";border-width:",
    ";border-radius:",
    ";background-color:",
    ";box-shadow:",
    ";min-height:",
    ";min-width:",
    ";height:",
    ";width:",
    ";text-align:",
    ";margin:",
    ";&:hover,&:focus{",
    ";}&:active{",
    ";}&:disabled{",
    ";}",
    ";@media (prefers-reduced-motion:reduce){animation:none !important;transition:none !important;}"
], function(_ref) {
    var position = _ref.position;
    return position;
}, function(_ref2) {
    var display = _ref2.display;
    return display;
}, function(_ref3) {
    var padding = _ref3.padding;
    return padding;
}, function(_ref4) {
    var borderShorthand = _ref4.borderShorthand;
    return borderShorthand;
}, function(_ref5) {
    var borderColor = _ref5.borderColor;
    return borderColor;
}, function(_ref6) {
    var borderSize = _ref6.borderSize;
    return borderSize;
}, function(_ref7) {
    var borderStyle = _ref7.borderStyle;
    return borderStyle;
}, function(_ref8) {
    var borderWidth = _ref8.borderWidth;
    return borderWidth;
}, function(_ref9) {
    var borderRadius = _ref9.borderRadius;
    return borderRadius;
}, function(_ref10) {
    var backgroundColor = _ref10.backgroundColor;
    return backgroundColor;
}, function(_ref11) {
    var boxShadow = _ref11.boxShadow;
    return boxShadow;
}, function(_ref12) {
    var minHeight = _ref12.minHeight;
    return minHeight;
}, function(_ref13) {
    var minWidth = _ref13.minWidth;
    return minWidth;
}, function(_ref14) {
    var height = _ref14.height;
    return height;
}, function(_ref15) {
    var width = _ref15.width;
    return width;
}, function(_ref16) {
    var textAlign = _ref16.textAlign;
    return textAlign;
}, function(_ref17) {
    var margin = _ref17.margin;
    return margin;
}, function(_ref18) {
    var hoverStyles = _ref18.hoverStyles;
    return hoverStyles;
}, function(_ref19) {
    var activeStyles = _ref19.activeStyles;
    return activeStyles;
}, function(_ref20) {
    var disabledStyles = _ref20.disabledStyles;
    return disabledStyles;
}, function(_ref21) {
    var extraStyles = _ref21.extraStyles;
    return extraStyles;
});
var MotionSpanWrapper = (0, _styledComponentsDefault.default)(motion.span).withConfig({
    displayName: "Motionstyled__MotionSpanWrapper",
    componentId: "sc-1m6r1io-1"
})([
    "position:",
    ";display:",
    ";box-sizing:border-box;padding:",
    ";border:",
    ";border-color:",
    ";border-size:",
    ";border-style:",
    ";border-width:",
    ";border-radius:",
    ";background-color:",
    ";box-shadow:",
    ";min-height:",
    ";min-width:",
    ";height:",
    ";width:",
    ";text-align:",
    ";margin:",
    ";&:hover,&:focus{",
    ";}&:active{",
    ";}&:disabled{",
    ";}",
    ";@media (prefers-reduced-motion:reduce){animation:none !important;transition:none !important;}"
], function(_ref22) {
    var position = _ref22.position;
    return position;
}, function(_ref23) {
    var display = _ref23.display;
    return display;
}, function(_ref24) {
    var padding = _ref24.padding;
    return padding;
}, function(_ref25) {
    var borderShorthand = _ref25.borderShorthand;
    return borderShorthand;
}, function(_ref26) {
    var borderColor = _ref26.borderColor;
    return borderColor;
}, function(_ref27) {
    var borderSize = _ref27.borderSize;
    return borderSize;
}, function(_ref28) {
    var borderStyle = _ref28.borderStyle;
    return borderStyle;
}, function(_ref29) {
    var borderWidth = _ref29.borderWidth;
    return borderWidth;
}, function(_ref30) {
    var borderRadius = _ref30.borderRadius;
    return borderRadius;
}, function(_ref31) {
    var backgroundColor = _ref31.backgroundColor;
    return backgroundColor;
}, function(_ref32) {
    var boxShadow = _ref32.boxShadow;
    return boxShadow;
}, function(_ref33) {
    var minHeight = _ref33.minHeight;
    return minHeight;
}, function(_ref34) {
    var minWidth = _ref34.minWidth;
    return minWidth;
}, function(_ref35) {
    var height = _ref35.height;
    return height;
}, function(_ref36) {
    var width = _ref36.width;
    return width;
}, function(_ref37) {
    var textAlign = _ref37.textAlign;
    return textAlign;
}, function(_ref38) {
    var margin = _ref38.margin;
    return margin;
}, function(_ref39) {
    var hoverStyles = _ref39.hoverStyles;
    return hoverStyles;
}, function(_ref40) {
    var activeStyles = _ref40.activeStyles;
    return activeStyles;
}, function(_ref41) {
    var disabledStyles = _ref41.disabledStyles;
    return disabledStyles;
}, function(_ref42) {
    var extraStyles = _ref42.extraStyles;
    return extraStyles;
});
var _excluded$d = [
    "position",
    "padding",
    "children",
    "useSpan"
];
/*
  Catch-all component for creating animations with Framer Motion library
  Wraps the framer motion "motion.div" with styled components and allows for passing
  of style props, like with all the other layout primitives.

  Compatible with other layout primitives, you can wrap non-animating primitives in a Motion
  to animate items. See the construction of the Collapsible Section and Radio Section for examples.

  Motion is intentionally more flexible than our other layout primitives - this was done to avoid
  creating motion versions of each primitive. Usually, the correct approach will be to wrap
  other layout primitives with a Motion in order to animate: 

    <Motion>
      <Cluster>
        stuff...
      </Cluster>
    </Motion>

    Motion components can be nested in order to animate both a primitive container as well as its
    children:

    <Motion>
      <Stack>
        <Motion>
          <Box>cool stuff</Box>
        </Motion>
        <Motion>
          <Box>other stuff</Box>
        </Motion>
      </Stack>
    </Motion>
  
  This should be sufficient for most scenarios, but if you need to, you have the ability to make Motion act like all of the other primitives using the props provided.
*/ var Motion = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$position = _ref.position, position = _ref$position === void 0 ? "relative" : _ref$position, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "0" : _ref$padding, children = _ref.children, _ref$useSpan = _ref.useSpan, useSpan = _ref$useSpan === void 0 ? false : _ref$useSpan, rest = _objectWithoutProperties(_ref, _excluded$d);
    return useSpan ? /*#__PURE__*/ (0, _reactDefault.default).createElement(MotionSpanWrapper, _extends({
        position: position,
        padding: padding,
        ref: ref
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null))) : /*#__PURE__*/ (0, _reactDefault.default).createElement(MotionWrapper, _extends({
        position: position,
        padding: padding,
        ref: ref
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)));
});
var ReelStyled = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Reelstyled__ReelStyled",
    componentId: "sc-bhf05j-0"
})([
    "display:flex;overflow-x:",
    ";padding:",
    ";height:",
    ";justify-content:",
    ";> * + *{margin-left:",
    ";}> *{flex:0 0 ",
    ";}",
    ""
], function(_ref) {
    var disableScroll = _ref.disableScroll;
    return disableScroll ? "hidden" : "auto";
}, function(_ref2) {
    var padding = _ref2.padding;
    return padding;
}, function(_ref3) {
    var height = _ref3.height;
    return height;
}, function(_ref4) {
    var justifyContent = _ref4.justifyContent;
    return justifyContent;
}, function(_ref5) {
    var childGap = _ref5.childGap;
    return childGap;
}, function(_ref6) {
    var childWidth = _ref6.childWidth;
    return childWidth;
}, function(_ref7) {
    var useOrderedList = _ref7.useOrderedList, useUnorderedList = _ref7.useUnorderedList;
    return useOrderedList || useUnorderedList ? "\n      margin: 0;\n      margin-block-start: 0;\n      margin-block-end: 0;\n      padding-inline-start: 0;\n      list-style-type: none;\n    " : "";
});
var _excluded$e = [
    "childGap",
    "height",
    "childWidth",
    "padding",
    "justifyContent",
    "disableScroll",
    "useOrderedList",
    "useUnorderedList",
    "children"
];
/*
  Safari has a bug where it refuses to recognize <ul /> tags as lists when list-style: none is used
  This affects the apple voice over (mainly used on iOS devices)
  The solution is to explicitly include "role=List"
*/ var Reel = function Reel(_ref) {
    var _ref$childGap = _ref.childGap, childGap = _ref$childGap === void 0 ? "1rem" : _ref$childGap, _ref$height = _ref.height, height = _ref$height === void 0 ? "auto" : _ref$height, _ref$childWidth = _ref.childWidth, childWidth = _ref$childWidth === void 0 ? "auto" : _ref$childWidth, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "1rem" : _ref$padding, _ref$justifyContent = _ref.justifyContent, justifyContent = _ref$justifyContent === void 0 ? "flex-start" : _ref$justifyContent, _ref$disableScroll = _ref.disableScroll, disableScroll = _ref$disableScroll === void 0 ? false : _ref$disableScroll, _ref$useOrderedList = _ref.useOrderedList, useOrderedList = _ref$useOrderedList === void 0 ? false : _ref$useOrderedList, _ref$useUnorderedList = _ref.useUnorderedList, useUnorderedList = _ref$useUnorderedList === void 0 ? false : _ref$useUnorderedList, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$e);
    var elementType = useOrderedList ? "ol" : useUnorderedList ? "ul" : "div";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ReelStyled, _extends({
        childGap: childGap,
        height: height,
        childWidth: childWidth,
        padding: padding,
        justifyContent: justifyContent,
        disableScroll: disableScroll,
        as: elementType,
        useOrderedList: useOrderedList,
        useUnorderedList: useUnorderedList
    }, rest, {
        role: useOrderedList || useUnorderedList ? "list" : "section"
    }), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)));
};
var fontFamily = {
    p: "Public Sans",
    pL: "Public Sans",
    pS: "Public Sans",
    pXS: "Public Sans",
    pXXS: "Public Sans",
    pXL: "Public Sans"
};
// Text uses the same variants as paragraph
// Use a Paragraph if you want a block level element
// Use a Text if you want an inline element
// Comments assume base font size of 16px
var fontSize = {
    p: "1rem",
    // 16px
    pL: "1.125rem",
    // 18px
    pS: "0.875rem",
    // 14px
    pXS: "0.75rem",
    // 12px
    pXXS: "0.65rem",
    // 10px
    pXL: "1.5rem" // 24px
};
var fallbackValues = {
    fontFamily: fontFamily,
    fontSize: fontSize
};
var _excluded$f = [
    "variant"
];
/*
themeContext: { name: "default", values: {JSON_THEME_VALUES_HERE} }

fallbackValues: {
  padding: {
    primary: "2rem 1rem",
    secondary: "1rem 0.5rem"
  },
  fontWeight: "600"
}

componentName: "Button"

Iterates over a component's fallback values, checks to see if any of those values
are present in the theme values available in the app's theme context.
If they are, those values override the fallback value.

We use the resuting values as an argument to the styled-theming lib functions
to create new functions that can be called with theme props to produce values.
Typically, those functions are passed back to components and used in styled-component files.
We do things a bit differently...

Before returning, we call the styled-theming functions with relevant theme props (name, variant...)
The styled-theming API then returns the value
Ultimately, an object of property values ({ color: "red", fontWeight: "600" })
is returned to the component, which can be passed
to whatever layout atoms / other atoms the component is using to build itself

Why do things this way? It's powerful. Right now we're always using "default" as our theme name
And only expecting one set of theme value in our context (one theme per client)

However, this function can easily be modified to allow for multiple themes per client and
allow for toggling those themes on the fly via state values

Future use cases for the above: 
  -Different themes per agency/sub-division of client
  -Extra themes designed for accessibility (high contrast / color blindness)
  -Superfluous extra themes (dark mode)
  -Toggling between many client themes / proposed client themes in a live demo

The above functionality is not available right now, but it is trivial to enable it with this approach.
*/ var createThemeValues = function createThemeValues(themeContext, fallbackValues, componentName, variant) {
    var themeValues = themeContext.values;
    var themeProps = {
        theme: _objectSpread2({
            name: "default"
        }, themeContext),
        variant: variant
    };
    var mergedValues = Object.entries(fallbackValues).reduce(function(acc, _ref) {
        var _themeValues$componen3, _themeValues$componen4;
        var _ref2 = _slicedToArray(_ref, 2), propName = _ref2[0], propValue = _ref2[1];
        if (_typeof(propValue) === "object") {
            var mergedPropValues = Object.entries(propValue).reduce(function(innerAcc, _ref3) {
                var _themeValues$componen, _themeValues$componen2;
                var _ref4 = _slicedToArray(_ref3, 2), variantName = _ref4[0], defaultVariantValue = _ref4[1];
                var variantValue = (_themeValues$componen = themeValues === null || themeValues === void 0 || (_themeValues$componen2 = themeValues[componentName]) === null || _themeValues$componen2 === void 0 || (_themeValues$componen2 = _themeValues$componen2[propName]) === null || _themeValues$componen2 === void 0 ? void 0 : _themeValues$componen2[variantName]) !== null && _themeValues$componen !== void 0 ? _themeValues$componen : defaultVariantValue;
                return _objectSpread2(_objectSpread2({}, innerAcc), {}, _defineProperty({}, variantName, {
                    "default": variantValue
                }));
            }, {});
            // Always using "default" as our theme name right now
            // In the future if we want to toggle themes on the fly, change this
            return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, propName, mergedPropValues));
        }
        var mergedSinglePropValue = (_themeValues$componen3 = themeValues === null || themeValues === void 0 || (_themeValues$componen4 = themeValues[componentName]) === null || _themeValues$componen4 === void 0 ? void 0 : _themeValues$componen4[propName]) !== null && _themeValues$componen3 !== void 0 ? _themeValues$componen3 : propValue;
        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, propName, {
            "default": mergedSinglePropValue
        }));
    }, {});
    var createdTheme = Object.entries(mergedValues).reduce(function(acc, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 2), propName = _ref6[0], propValue = _ref6[1];
        if (propValue[variant]) return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, propName, (0, _styledThemingDefault.default).variants("name", "variant", propValue)(themeProps)));
        return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, propName, (0, _styledThemingDefault.default)("name", propValue)(themeProps)));
    }, {});
    return createdTheme;
};
var themeComponent = function themeComponent(Component, componentThemeId, fallbackValues, defaultVariant) {
    return /*#__PURE__*/ (0, _react.forwardRef)(function(_ref7, ref) {
        var _themeContext$metadat;
        var _ref7$variant = _ref7.variant, variant = _ref7$variant === void 0 ? defaultVariant : _ref7$variant, props = _objectWithoutProperties(_ref7, _excluded$f);
        var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
        var metadata = (_themeContext$metadat = themeContext === null || themeContext === void 0 ? void 0 : themeContext.metadata) !== null && _themeContext$metadat !== void 0 ? _themeContext$metadat : {};
        var themeValues = themeContext ? createThemeValues(themeContext, fallbackValues, componentThemeId, variant) : fallbackValues;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, _extends({}, props, {
            themeValues: themeValues,
            variant: variant,
            metadata: metadata,
            ref: ref
        }));
    });
};
/*
Keeping this around for now in case we need it later...

export const generateImgSrc = (
  configAssetsEndpoint,
  clientSlug,
  agency = ""
) => filename => {
  if (configAssetsEndpoint === "http://localhost:8080/assets") {
    return agency !== ""
      ? `${configAssetsEndpoint}/${clientSlug}/${agency}/${filename}`
      : `${configAssetsEndpoint}/${clientSlug}/${filename}`;
  }
  return agency !== ""
    ? `${configAssetsEndpoint}/${agency}/${filename}`
    : `${configAssetsEndpoint}/${filename}`;
};
*/ var themeUtils = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createThemeValues: createThemeValues,
    themeComponent: themeComponent
});
/* These are constants used by nav frontend components */ var BORDER_RADIUS = {
    MD: "4px" // Figma: Corners/Standard Corner
};
var BORDER_THIN = "1px";
var FONT_SIZE = {
    XXS: "0.625rem",
    // 10px
    XS: "0.750rem",
    // 12px
    SM: "0.875rem",
    // 14px
    MD: "1.000rem",
    // 16px
    LG: "1.125rem",
    // 18px
    XL: "1.250rem" //20px
};
var FONT_WEIGHT_REGULAR = "400";
var FONT_WEIGHT_SEMIBOLD = "600";
var FONT_WEIGHT_BOLD = "700";
var FOOTER_HEIGHT = "100px";
var HEADER_HEIGHT = "104px";
var COMPACT_JUMBO_HEIGHT = "65px";
var JUMBO_HEIGHT = "300px";
var SPACER_HEIGHT = "65px";
var LINK_TEXT_DECORATION = "underline solid 1px";
var SPACING = {
    XS: "1.0rem",
    // Figma: Spacing/XS
    MD: "1.5rem" // Figma: Spacing/Normal
};
var SCREEN_READER_ONLY = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
var style_constants = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BORDER_RADIUS: BORDER_RADIUS,
    BORDER_THIN: BORDER_THIN,
    FONT_SIZE: FONT_SIZE,
    FONT_WEIGHT_REGULAR: FONT_WEIGHT_REGULAR,
    FONT_WEIGHT_SEMIBOLD: FONT_WEIGHT_SEMIBOLD,
    FONT_WEIGHT_BOLD: FONT_WEIGHT_BOLD,
    FOOTER_HEIGHT: FOOTER_HEIGHT,
    HEADER_HEIGHT: HEADER_HEIGHT,
    COMPACT_JUMBO_HEIGHT: COMPACT_JUMBO_HEIGHT,
    JUMBO_HEIGHT: JUMBO_HEIGHT,
    SPACER_HEIGHT: SPACER_HEIGHT,
    LINK_TEXT_DECORATION: LINK_TEXT_DECORATION,
    SPACING: SPACING,
    SCREEN_READER_ONLY: SCREEN_READER_ONLY
});
var TextSpan = (0, _styledComponentsDefault.default).span.withConfig({
    displayName: "Textstyled__TextSpan",
    componentId: "sc-1oy97we-0"
})([
    "--font-size:",
    ";font-size:var(--font-size);line-height:calc(1.5 * var(--font-size));font-weight:",
    ";font-family:",
    ";color:",
    ";text-decoration:",
    ";white-space:",
    ";&:hover{",
    "}&:focus{outline:3px solid ",
    ";outline-offset:2px;}",
    " ",
    ""
], function(_ref) {
    var fontSize = _ref.fontSize;
    return fontSize;
}, function(_ref2) {
    var weight = _ref2.weight;
    return weight;
}, function(_ref3) {
    var fontFamily = _ref3.fontFamily;
    return fontFamily;
}, function(_ref4) {
    var color = _ref4.color;
    return color;
}, function(_ref5) {
    var textDecoration = _ref5.textDecoration;
    return textDecoration;
}, function(_ref6) {
    var $textWrap = _ref6.$textWrap;
    return $textWrap ? "initial" : "nowrap";
}, function(_ref7) {
    var hoverStyles = _ref7.hoverStyles;
    return (0, _styledComponents.css)([
        "",
        ""
    ], hoverStyles);
}, ROYAL_BLUE, function(_ref8) {
    var disabled = _ref8.disabled, disabledStyles = _ref8.disabledStyles;
    return disabled && (0, _styledComponents.css)([
        "",
        ""
    ], disabledStyles);
}, function(_ref9) {
    var extraStyles = _ref9.extraStyles;
    return extraStyles;
});
var _excluded$g = [
    "themeValues",
    "weight",
    "color",
    "textWrap",
    "extraStyles",
    "hoverStyles",
    "onClick",
    "onKeyPress",
    "as",
    "dataQa",
    "children",
    "variant"
];
var Text = function Text(_ref) {
    var themeValues = _ref.themeValues, _ref$weight = _ref.weight, weight = _ref$weight === void 0 ? FONT_WEIGHT_REGULAR : _ref$weight, _ref$color = _ref.color, color = _ref$color === void 0 ? FIREFLY_GREY : _ref$color, _ref$textWrap = _ref.textWrap, textWrap = _ref$textWrap === void 0 ? true : _ref$textWrap, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, hoverStyles = _ref.hoverStyles, onClick = _ref.onClick, onKeyPress = _ref.onKeyPress, as = _ref.as, dataQa = _ref.dataQa, children = _ref.children, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "p" : _ref$variant, rest = _objectWithoutProperties(_ref, _excluded$g);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TextSpan, _extends({
        fontSize: themeValues.fontSize,
        weight: weight,
        color: color,
        fontFamily: themeValues.fontFamily,
        as: as,
        extraStyles: extraStyles,
        hoverStyles: hoverStyles,
        onClick: onClick,
        onKeyPress: onKeyPress,
        "data-qa": dataQa,
        $textWrap: textWrap,
        $variant: variant
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null)));
};
var Text$1 = themeComponent(Text, "Text", fallbackValues, "p");
var background = {
    info: "".concat(INFO_BLUE),
    warn: "".concat(APRICOT_ORANGE),
    error: "".concat(BLUSH_RED),
    success: "".concat(HINT_GREEN)
};
var border = {
    info: "".concat(MATISSE_BLUE),
    warn: "".concat(ZEST_ORANGE),
    error: "".concat(RAZZMATAZZ_RED),
    success: "".concat(EMERALD_GREEN)
};
var iconBackground = {
    info: "".concat(ONAHAU_BLUE),
    warn: "".concat(MUSTARD_YELLOW),
    error: "".concat(COSMOS_RED),
    success: "".concat(ICE_GREEN)
};
var iconFill = {
    info: "".concat(CONGRESS_BLUE),
    warn: "".concat(CARROT_ORANGE),
    error: "".concat(THUNDERBIRD_RED),
    success: "".concat(HAZE_GREEN)
};
var text = {
    info: "".concat(ZODIAC_BLUE),
    warn: "".concat(ZODIAC_BLUE),
    error: "".concat(ZODIAC_BLUE),
    success: "".concat(ZODIAC_BLUE)
};
var link = {
    info: "".concat(SCIENCE_BLUE),
    warn: "".concat(SCIENCE_BLUE),
    error: "".concat(SCIENCE_BLUE),
    success: "".concat(SCIENCE_BLUE)
};
var fallbackValues$1 = {
    background: background,
    border: border,
    iconBackground: iconBackground,
    iconFill: iconFill,
    text: text,
    link: link
};
/* 

A utility function that can generate box-shadow values for components
Takes a string representing an rgb color value and returns an object
with values for standard, inset, and overlay shadows.

The objects for standard and inset shadows contain versions approiate
for base, hover, and active interaction states.

*/ /* 
  Function to convert string representing rgb color to rgba value with provided opacity
  ("rgb(41, 42, 51)", "0.1") => "rgba(41, 42, 51, 0.1)"

*/ var rgbToRgba = function rgbToRgba() {
    var rgbValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (typeof rgbValue !== "string" || typeof opacity !== "string" || rgbValue.charAt(0) === "#") return "";
    return "".concat(rgbValue.slice(0, 3), "a").concat(rgbValue.slice(3, -1), ", ").concat(opacity).concat(rgbValue.slice(-1));
};
var generateShadows = function generateShadows() {
    var baseColorRGB = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "rgb(41, 42, 51)";
    var colorTen = rgbToRgba(baseColorRGB, "0.1") || "rgba(41, 42, 51, 0.1)";
    var colorTwenty = rgbToRgba(baseColorRGB, "0.2") || "rgba(41, 42, 51, 0.2)";
    var colorTwentyFive = rgbToRgba(baseColorRGB, "0.25") || "rgba(41, 42, 51, 0.25)";
    var colorThirty = rgbToRgba(baseColorRGB, "0.3") || "rgba(41, 42, 51, 0.3)";
    var blackTwentyFive = "rgba(0, 0, 0, 0.25)";
    var standard = {
        base: "0px 1px 2px 0px ".concat(colorTen, ", 0px 2px 6px 0px ").concat(colorTwenty, ", inset 0px 1px 0px 0px ").concat(colorTen),
        hover: "0px 1px 2px 0px ".concat(colorTwenty, ", 0px 4px 8px 0px ").concat(blackTwentyFive, ", 0px 6px 12px 0px ").concat(colorTen),
        active: "0px 2px 8px 0px ".concat(colorTwenty, ", 0px 4px 8px 0px ").concat(colorThirty, ", 0px 6px 12px 0px ").concat(colorTwentyFive)
    };
    var inset = {
        base: "0px 1px 2px 0px ".concat(colorTen, ", 0px 2px 4px 0px ").concat(colorTwenty, ", inset 0px 1px 0px 0px ").concat(colorTen),
        hover: "0px 1px 2px 0px ".concat(colorTen, ", 0px 2px 4px 0px ").concat(colorTwentyFive, ", 0px 4px 8px 0px ").concat(colorTen),
        active: "0px 1px 2px 2px ".concat(colorTwenty, ", 0px 3px 6px 0px ").concat(colorThirty, ", 0px 4px 8px 0px ").concat(colorTwenty)
    };
    var overlay = {
        base: "0px 7px 32px 0px ".concat(colorTwenty, ", 0px 1px 4px 0px ").concat(colorTwenty, ", 0px 1px 8px -1px ").concat(colorThirty)
    };
    return {
        standard: standard,
        inset: inset,
        overlay: overlay
    };
};
var Alert = function Alert(_ref) {
    var _generateShadows;
    var heading = _ref.heading, text = _ref.text, textOverride = _ref.textOverride, variant = _ref.variant, children = _ref.children, height = _ref.height, onLinkClick = _ref.onLinkClick, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "0.5rem" : _ref$padding, _ref$showQuitLink = _ref.showQuitLink, showQuitLink = _ref$showQuitLink === void 0 ? true : _ref$showQuitLink, themeValues = _ref.themeValues, extraStyles = _ref.extraStyles, maxContentWidth = _ref.maxContentWidth, _ref$noBorder = _ref.noBorder, noBorder = _ref$noBorder === void 0 ? false : _ref$noBorder, _ref$enableBoxShadow = _ref.enableBoxShadow, enableBoxShadow = _ref$enableBoxShadow === void 0 ? false : _ref$enableBoxShadow, _ref$enableSmallText = _ref.enableSmallText, enableSmallText = _ref$enableSmallText === void 0 ? false : _ref$enableSmallText, _ref$innerContentPadd = _ref.innerContentPadding, innerContentPadding = _ref$innerContentPadd === void 0 ? "1rem" : _ref$innerContentPadd, _ref$iconPadding = _ref.iconPadding, iconPadding = _ref$iconPadding === void 0 ? "0 0 0 1rem" : _ref$iconPadding, _ref$contentFullHeigh = _ref.contentFullHeight, contentFullHeight = _ref$contentFullHeigh === void 0 ? false : _ref$contentFullHeigh, _ref$ariaRole = _ref.ariaRole, ariaRole = _ref$ariaRole === void 0 ? null : _ref$ariaRole, _ref$ariaAtomic = _ref.ariaAtomic, ariaAtomic = _ref$ariaAtomic === void 0 ? true : _ref$ariaAtomic, _ref$ariaLive = _ref.ariaLive, ariaLive = _ref$ariaLive === void 0 ? "polite" : _ref$ariaLive, _ref$ariaLabelledBy = _ref.ariaLabelledBy, ariaLabelledBy = _ref$ariaLabelledBy === void 0 ? null : _ref$ariaLabelledBy, _ref$headingAs = _ref.headingAs, headingAs = _ref$headingAs === void 0 ? null : _ref$headingAs, _ref$headingId = _ref.headingId, headingId = _ref$headingId === void 0 ? null : _ref$headingId;
    var Icon = AlertIcons[variant];
    var contentPadding = maxContentWidth ? "".concat(padding, " 1rem") : innerContentPadding;
    var content = /*#__PURE__*/ (0, _reactDefault.default).createElement(Sidebar, {
        width: "24px",
        childGap: "0rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: iconPadding,
        minHeight: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        minHeight: "100%",
        singleChild: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        width: "1.5rem",
        minHeight: "1.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, null)))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Sidebar, {
        sidebarOnRight: true,
        width: "24px",
        childGap: "0rem",
        fullHeight: contentFullHeight
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: contentPadding
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "flex-start",
        align: "center"
    }, textOverride ? textOverride : /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        fullHeight: true,
        childGap: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, _extends({
        variant: enableSmallText ? "pS" : "p",
        color: themeValues.text,
        weight: "600"
    }, headingAs ? {
        as: headingAs
    } : {}, headingId ? {
        id: headingId
    } : {}), heading), /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pS",
        color: themeValues.text
    }, text), children))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "flex-end",
        align: "flex-start"
    }, showQuitLink && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minHeight: "100%",
        onClick: onLinkClick,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && onLinkClick();
        },
        role: "button",
        tabIndex: 0,
        "aria-label": "Close Alert: ".concat(heading),
        extraStyles: "cursor: pointer;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(IconQuit, null))))));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        padding: padding,
        width: "100%",
        minHeight: height && parseInt(height) < 100 ? height : "100px",
        height: height ? height : "auto",
        background: themeValues.background,
        borderRadius: "4px",
        borderColor: themeValues.border,
        borderSize: noBorder ? "0px" : "1px",
        boxShadow: enableBoxShadow ? (_generateShadows = generateShadows()) === null || _generateShadows === void 0 || (_generateShadows = _generateShadows.inset) === null || _generateShadows === void 0 ? void 0 : _generateShadows.base : "",
        extraStyles: extraStyles,
        "aria-live": ariaLive
    }, ariaAtomic !== null ? {
        "aria-atomic": ariaAtomic
    } : {}, ariaRole !== null ? {
        role: ariaRole
    } : {}, ariaLabelledBy !== null ? {
        "aria-labelledby": ariaLabelledBy
    } : {}), maxContentWidth ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: maxContentWidth
    }, content) : content);
};
var Alert$1 = themeComponent(Alert, "Alert", fallbackValues$1, "info");
var TitleText = (0, _styledComponentsDefault.default).h1.withConfig({
    displayName: "Titlestyled__TitleText",
    componentId: "sc-11lhluq-0"
})([
    "font-size:",
    ";line-height:1.5;color:",
    ";font-weight:",
    ";margin:",
    ";text-align:",
    ";font-family:",
    ";",
    ";"
], function(_ref) {
    var fontSize = _ref.fontSize;
    return fontSize;
}, function(_ref2) {
    var color = _ref2.color;
    return color;
}, function(_ref3) {
    var weight = _ref3.weight;
    return weight;
}, function(_ref4) {
    var margin = _ref4.margin;
    return margin;
}, function(_ref5) {
    var textAlign = _ref5.textAlign;
    return textAlign;
}, function(_ref6) {
    var fontFamily = _ref6.fontFamily;
    return fontFamily;
}, function(_ref7) {
    var extraStyles = _ref7.extraStyles;
    return extraStyles;
});
// Comments assume desktop base font size of 16px, mobile base font size of 14px
var fontSize$1 = {
    hero: "3.5rem",
    // 56px
    large: "1.5rem",
    // 24px (at base font size of 16px)
    small: "1.25rem" // 20px
};
var fontFamily$1 = {
    hero: "Public Sans",
    large: "Public Sans",
    small: "Public Sans"
};
var mobileFontSize = {
    hero: "3rem",
    // 48px
    large: "1.5rem",
    // 21px (at base font size of 14px)
    small: "1.2142rem" // 17px
};
var fallbackValues$2 = {
    fontFamily: fontFamily$1,
    fontSize: fontSize$1
};
var mobileFallbackValues = {
    fontFamily: fontFamily$1,
    fontSize: mobileFontSize
};
var MOBILE_BREAKPOINT = 768;
var _excluded$h = [
    "themeValues",
    "weight",
    "color",
    "margin",
    "textAlign",
    "extraStyles",
    "className",
    "variant",
    "as",
    "dataQa",
    "children"
];
var isBelowBreakpoint = window.innerWidth < MOBILE_BREAKPOINT;
var isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 1;
var mobileDeviceDetected = isBelowBreakpoint && isTouchDevice;
var fallbacks = mobileDeviceDetected ? mobileFallbackValues : fallbackValues$2;
var Title = function Title(_ref) {
    var themeValues = _ref.themeValues, _ref$weight = _ref.weight, weight = _ref$weight === void 0 ? FONT_WEIGHT_REGULAR : _ref$weight, _ref$color = _ref.color, color = _ref$color === void 0 ? FIREFLY_GREY : _ref$color, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? 0 : _ref$margin, textAlign = _ref.textAlign, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, className = _ref.className, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "large" : _ref$variant, _ref$as = _ref.as, as = _ref$as === void 0 ? "h1" : _ref$as, dataQa = _ref.dataQa, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$h);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TitleText, _extends({
        variant: variant,
        as: as,
        weight: weight,
        color: color,
        margin: margin,
        textAlign: textAlign,
        extraStyles: extraStyles,
        className: className,
        fontFamily: themeValues.fontFamily,
        fontSize: themeValues.fontSize,
        "data-qa": dataQa
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null)));
};
var Title$1 = themeComponent(Title, "Title", fallbacks, "large");
var color$2 = "#292A33";
var fallbackValues$3 = {
    color: color$2
};
var AmountCallout = function AmountCallout(_ref) {
    var amount = _ref.amount, textAlign = _ref.textAlign, themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        textAlign: textAlign
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        variant: "small",
        weight: FONT_WEIGHT_SEMIBOLD,
        color: themeValues.color,
        as: "p"
    }, amount));
};
var AmountCallout$1 = themeComponent(AmountCallout, "AmountCallout", fallbackValues$3);
var background$1 = {
    info: "".concat(INFO_BLUE),
    warn: "".concat(HALF_COLONIAL_WHITE),
    primary: "".concat(CORNFLOWER_BLUE),
    primaryHeadline: "".concat(CORNFLOWER_BLUE),
    secondary: "".concat(ROYAL_BLUE_VIVID),
    secondaryHeadline: "".concat(ROYAL_BLUE_VIVID),
    success: "".concat(HINT_GREEN),
    disabled: "".concat(GRECIAN_GREY)
};
var color$3 = {
    info: "".concat(MATISSE_BLUE),
    warn: "".concat(ZEST_ORANGE),
    primary: "".concat(ROYAL_BLUE_VIVID),
    primaryHeadline: "".concat(ROYAL_BLUE_VIVID),
    secondary: "".concat(CORNFLOWER_BLUE),
    secondaryHeadline: "".concat(CORNFLOWER_BLUE),
    success: "".concat(SEA_GREEN),
    disabled: "".concat(MANATEE_GREY)
};
var fontWeight = {
    info: FONT_WEIGHT_REGULAR,
    warn: FONT_WEIGHT_REGULAR,
    primary: FONT_WEIGHT_REGULAR,
    primaryHeadline: FONT_WEIGHT_SEMIBOLD,
    secondary: FONT_WEIGHT_REGULAR,
    secondaryHeadline: FONT_WEIGHT_SEMIBOLD,
    success: FONT_WEIGHT_REGULAR,
    disabled: FONT_WEIGHT_REGULAR
};
var fontSizeMobile = {
    info: fallbackValues.fontSize.pXXS,
    warn: fallbackValues.fontSize.pXXS,
    primary: fallbackValues.fontSize.pXXS,
    primaryHeadline: fallbackValues.fontSize.pXS,
    secondary: fallbackValues.fontSize.pXXS,
    secondaryHeadline: fallbackValues.fontSize.pXS,
    success: fallbackValues.fontSize.pXXS,
    disabled: fallbackValues.fontSize.pXXS
};
var fontSizeDesktop = {
    info: fallbackValues.fontSize.pXS,
    warn: fallbackValues.fontSize.pXS,
    primary: fallbackValues.fontSize.pXS,
    primaryHeadline: fallbackValues.fontSize.pS,
    secondary: fallbackValues.fontSize.pXS,
    secondaryHeadline: fallbackValues.fontSize.pS,
    success: fallbackValues.fontSize.pXS,
    disabled: fallbackValues.fontSize.pXS
};
var fallbackValues$4 = {
    background: background$1,
    color: color$3,
    fontWeight: fontWeight,
    fontSizeMobile: fontSizeMobile,
    fontSizeDesktop: fontSizeDesktop
};
var StyledBadgeContainer = (0, _styledComponentsDefault.default)(Box).withConfig({
    displayName: "Badge__StyledBadgeContainer",
    componentId: "sc-1g438j-0"
})([
    "display:inline-flex;padding:2px 8px;align-items:center;align-self:flex-start;gap:4px;border-radius:4px;"
]);
var StyledBadge = (0, _styledComponentsDefault.default)(Text$1).withConfig({
    displayName: "Badge__StyledBadge",
    componentId: "sc-1g438j-1"
})([
    "line-height:150%;letter-spacing:",
    ";white-space:nowrap;"
], function(props) {
    return props.isMobile ? "0.2px" : "0.24px";
});
var Badge = function Badge(_ref) {
    var label = _ref.label, Icon = _ref.Icon, themeValues = _ref.themeValues, _ref$iconOnLeft = _ref.iconOnLeft, iconOnLeft = _ref$iconOnLeft === void 0 ? true : _ref$iconOnLeft, id = _ref.id, extraStyles = _ref.extraStyles;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledBadgeContainer, {
        background: themeValues.background,
        id: id,
        extraStyles: extraStyles
    }, iconOnLeft && Icon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        color: themeValues.color,
        fill: themeValues.color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledBadge, {
        color: themeValues.color,
        weight: themeValues.fontWeight,
        fontSize: isMobile ? themeValues.fontSizeMobile : themeValues.fontSizeDesktop,
        isMobile: isMobile
    }, label), !iconOnLeft && Icon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        color: themeValues.color,
        fill: themeValues.color
    }));
};
var Badge$1 = themeComponent(Badge, "Badge", fallbackValues$4, "success");
function _extends$1() {
    _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": 'Invalid value passed as base to modularScale, expected number or em string but got "%s"\n\n',
    "12": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.\n\n',
    "13": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.\n\n',
    "14": 'Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
    "15": 'Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.\n\n',
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": 'borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.\n\n',
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": 'Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.\n\n',
    "70": 'Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.\n\n',
    "71": 'Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.\n\n',
    "72": 'Passed invalid base value %s to %s(), please pass a value like "12px" or 12.\n\n',
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": 'remToPx expects a value in "rem" but you provided it in "%s".\n\n',
    "78": 'base must be set in "px" or "%" but you set it in "%s".\n'
};
/**
 * super basic version of sprintf
 * @private
 */ function format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var PolishedError = /*#__PURE__*/ function(_Error) {
    _inheritsLoose(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        var _len2, args, _key2;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return _assertThisInitialized(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function colorToInt(color) {
    return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
    return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "639",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function nameToHex(color) {
    if (typeof color !== "string") return color;
    var normalizedColorName = color.toLowerCase();
    return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function parseToRgb(color) {
    if (typeof color !== "string") throw new PolishedError(3);
    var normalizedColor = nameToHex(color);
    if (normalizedColor.match(hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match(hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match(reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match(reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new PolishedError(5);
}
function rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function parseToHsl(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return rgbToHsl(parseToRgb(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color) {
    return numberToHex(Math.round(color * 255));
}
function convertToHex(red, green, blue) {
    return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
    return hslToRgb(hue, saturation, lightness, convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function hsl(value, saturation, lightness) {
    if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number") return hslToHex(value, saturation, lightness);
    else if (typeof value === "object" && saturation === undefined && lightness === undefined) return hslToHex(value.hue, value.saturation, value.lightness);
    throw new PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function hsla$2(value, saturation, lightness, alpha) {
    if (typeof value === "number" && typeof saturation === "number" && typeof lightness === "number" && typeof alpha === "number") return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === "object" && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function rgb(value, green, blue) {
    if (typeof value === "number" && typeof green === "number" && typeof blue === "number") return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
    else if (typeof value === "object" && green === undefined && blue === undefined) return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
    throw new PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function rgba$2(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === "string" && typeof secondValue === "number") {
        var rgbValue = parseToRgb(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === "object" && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new PolishedError(7);
}
var isRgb = function isRgb(color) {
    return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var isRgba = function isRgba(color) {
    return typeof color.red === "number" && typeof color.green === "number" && typeof color.blue === "number" && typeof color.alpha === "number";
};
var isHsl = function isHsl(color) {
    return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && (typeof color.alpha !== "number" || typeof color.alpha === "undefined");
};
var isHsla = function isHsla(color) {
    return typeof color.hue === "number" && typeof color.saturation === "number" && typeof color.lightness === "number" && typeof color.alpha === "number";
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function toColorString(color) {
    if (typeof color !== "object") throw new PolishedError(8);
    if (isRgba(color)) return rgba$2(color);
    if (isRgb(color)) return rgb(color);
    if (isHsla(color)) return hsla$2(color);
    if (isHsl(color)) return hsl(color);
    throw new PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function curry(f) {
    // eslint-disable-line no-redeclare
    return curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function adjustHue(degree, color) {
    if (color === "transparent") return color;
    var hslColor = parseToHsl(color);
    return toColorString(_extends$1({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
}
// prettier-ignore
var curriedAdjustHue = curry /* ::<number | string, string, string> */ (adjustHue);
function guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function darken(amount, color) {
    if (color === "transparent") return color;
    var hslColor = parseToHsl(color);
    return toColorString(_extends$1({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
// prettier-ignore
var curriedDarken = curry /* ::<number | string, string, string> */ (darken);
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function desaturate(amount, color) {
    if (color === "transparent") return color;
    var hslColor = parseToHsl(color);
    return toColorString(_extends$1({}, hslColor, {
        saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
}
// prettier-ignore
var curriedDesaturate = curry /* ::<number | string, string, string> */ (desaturate);
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function lighten(amount, color) {
    if (color === "transparent") return color;
    var hslColor = parseToHsl(color);
    return toColorString(_extends$1({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
// prettier-ignore
var curriedLighten = curry /* ::<number | string, string, string> */ (lighten);
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function mix$1(weight, color, otherColor) {
    if (color === "transparent") return otherColor;
    if (otherColor === "transparent") return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = parseToRgb(color);
    var color1 = _extends$1({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === "number" ? parsedColor1.alpha : 1
    });
    var parsedColor2 = parseToRgb(otherColor);
    var color2 = _extends$1({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === "number" ? parsedColor2.alpha : 1
    });
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return rgba$2(mixedColor);
}
// prettier-ignore
var curriedMix = curry /* ::<number | string, string, string, string> */ (mix$1);
var mix$1$1 = curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function opacify(amount, color) {
    if (color === "transparent") return color;
    var parsedColor = parseToRgb(color);
    var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
    var colorWithAlpha = _extends$1({}, parsedColor, {
        alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return rgba$2(colorWithAlpha);
}
// prettier-ignore
var curriedOpacify = curry /* ::<number | string, string, string> */ (opacify);
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function saturate(amount, color) {
    if (color === "transparent") return color;
    var hslColor = parseToHsl(color);
    return toColorString(_extends$1({}, hslColor, {
        saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
}
// prettier-ignore
var curriedSaturate = curry /* ::<number | string, string, string> */ (saturate);
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function setHue(hue, color) {
    if (color === "transparent") return color;
    return toColorString(_extends$1({}, parseToHsl(color), {
        hue: parseFloat(hue)
    }));
}
// prettier-ignore
var curriedSetHue = curry /* ::<number | string, string, string> */ (setHue);
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function setLightness(lightness, color) {
    if (color === "transparent") return color;
    return toColorString(_extends$1({}, parseToHsl(color), {
        lightness: parseFloat(lightness)
    }));
}
// prettier-ignore
var curriedSetLightness = curry /* ::<number | string, string, string> */ (setLightness);
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function setSaturation(saturation, color) {
    if (color === "transparent") return color;
    return toColorString(_extends$1({}, parseToHsl(color), {
        saturation: parseFloat(saturation)
    }));
}
// prettier-ignore
var curriedSetSaturation = curry /* ::<number | string, string, string> */ (setSaturation);
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function shade(percentage, color) {
    if (color === "transparent") return color;
    return mix$1$1(parseFloat(percentage), "rgb(0, 0, 0)", color);
}
// prettier-ignore
var curriedShade = curry /* ::<number | string, string, string> */ (shade);
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function tint(percentage, color) {
    if (color === "transparent") return color;
    return mix$1$1(parseFloat(percentage), "rgb(255, 255, 255)", color);
}
// prettier-ignore
var curriedTint = curry /* ::<number | string, string, string> */ (tint);
var curriedTint$1 = curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function transparentize(amount, color) {
    if (color === "transparent") return color;
    var parsedColor = parseToRgb(color);
    var alpha = typeof parsedColor.alpha === "number" ? parsedColor.alpha : 1;
    var colorWithAlpha = _extends$1({}, parsedColor, {
        alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return rgba$2(colorWithAlpha);
}
// prettier-ignore
var curriedTransparentize = curry /* ::<number | string, string, string> */ (transparentize);
var linkColor = MATISSE_BLUE;
var fallbackValues$5 = {
    linkColor: linkColor
};
var _excluded$i = [
    "variant",
    "themeValues",
    "children"
];
var BoxWithShadow = function BoxWithShadow(_ref) {
    var variant = _ref.variant, themeValues = _ref.themeValues, children = _ref.children, props = _objectWithoutProperties(_ref, _excluded$i);
    var shadowRegistry = {
        baseStandard: "0px 3px 7px 2px ".concat(rgba$2(BLACK, 0.1), ", 0px 1px 2px 1px ").concat(rgba$2(BLACK, 0.1), ";"),
        baseHover: "0px 1px 7px 0px ".concat(rgba$2(BLACK, 0.3), ", 0px 1px 4px 0px ").concat(rgba$2(BLACK, 0.2), ", 0px 7px 12px 0px ").concat(rgba$2(BLACK, 0.2), ";"),
        baseClick: "0px 4px 7px 0px ".concat(rgba$2(BLACK, 0.3), ", 0px 1px 4px 0px ").concat(rgba$2(BLACK, 0.2), ", 0px 7px 12px 0px ").concat(rgba$2(BLACK, 0.2), ";"),
        insetStandard: "0px 1px 4px 2px ".concat(rgba$2(BLACK, 0.1), ", 0px 2px 1px 0px ").concat(rgba$2(BLACK, 0.15), ";"),
        insetHover: "0px 1px 4px 0px ".concat(rgba$2(BLACK, 0.3), ", 0px 1px 2px 2px ").concat(rgba$2(BLACK, 0.2), ", 0px 4px 8px 0px ").concat(rgba$2(BLACK, 0.2), ";"),
        insetClick: "0px 4px 4px 0px ".concat(rgba$2(BLACK, 0.3), ", 0px 1px 2px 2px ").concat(rgba$2(BLACK, 0.2), ", 0px 4px 8px 0px ").concat(rgba$2(BLACK, 0.2), ";"),
        linkShadowFocus: "0px 0px 5px 2px ".concat(rgba$2(themeValues.linkColor, 0.3), ", 0px 1px 2px 0px ").concat(rgba$2(themeValues.linkColor, 0.3), ", 0px 4px 8px 0px ").concat(rgba$2(themeValues.linkColor, 0.2), ";"),
        overlayShadow: "0px 1px 8px -1px ".concat(rgba$2(BLACK, 0.3), ", 0px 1px 4px 0px ").concat(rgba$2(BLACK, 0.2), ", 0px 7px 32px 0px ").concat(rgba$2(BLACK, 0.2), ";")
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        boxShadow: shadowRegistry[variant]
    }, props), children);
};
var BoxWithShadow$1 = themeComponent(BoxWithShadow, "BoxWithShadow", fallbackValues$5);
var ACH_METHOD = "BANK_ACCOUNT";
var CC_METHOD = "CREDIT_CARD";
var CASH_METHOD = "CASH";
var general$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ACH_METHOD: ACH_METHOD,
    CC_METHOD: CC_METHOD,
    CASH_METHOD: CASH_METHOD
});
var URL_TEST = /(([a-z]{3,6}:\/\/)|(^|\s))((\d{1,3}\.){3}\d{1,3}|([a-zA-Z0-9\-]+\.)+[a-z]{2,13})[\.\?\=\&\%\/\w\-]*\b([^@]|$)/;
var regex_constants = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    URL_TEST: URL_TEST
});
var index = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    colors: colors,
    general: general$1,
    regexConstants: regex_constants,
    styleConstants: style_constants,
    fontWeights: style_constants
});
// import theme from "styled-theming";
var MATISSE_BLUE$1 = MATISSE_BLUE, STORM_GREY$1 = STORM_GREY;
var LINK_TEXT_DECORATION$1 = LINK_TEXT_DECORATION;
/*
  For now I'm using string values, eventually shared components library will have its own constants file
  for colors/values that should be used here instead
*/ var color$4 = "".concat(MATISSE_BLUE$1);
var activeColor = "".concat(STORM_GREY$1);
var activeBreadcrumbColor = "".concat(STORM_GREY$1);
var fontSize$2 = "0.875rem";
var lineHeight = "1.25rem";
var fontWeight$1 = "400";
var margin = "0.5rem";
var hover = "text-decoration: ".concat(LINK_TEXT_DECORATION$1, ";");
var fallbackValues$6 = {
    color: color$4,
    activeColor: activeColor,
    activeBreadcrumbColor: activeBreadcrumbColor,
    fontSize: fontSize$2,
    lineHeight: lineHeight,
    fontWeight: fontWeight$1,
    margin: margin,
    hover: hover
};
var fontFamily$2 = {
    primary: "Public Sans",
    secondary: "Open Sans"
};
var hoverColor = SAPPHIRE_BLUE;
var activeColor$1 = PEACOCK_BLUE;
var externalLinkColor = MATISSE_BLUE;
var fallbackValues$7 = {
    fontFamily: fontFamily$2,
    hoverColor: hoverColor,
    activeColor: activeColor$1,
    externalLinkColor: externalLinkColor
};
var _excluded$j = [
    "hoverColor",
    "activeColor",
    "extrastyles"
];
var ROYAL_BLUE$1 = ROYAL_BLUE;
var LINK_TEXT_DECORATION$2 = LINK_TEXT_DECORATION;
/*
  The extracting of props and the disabling of the eslint rule is to stop React from complaining about
  unrecognized DOM attributes.
*/ /* eslint-disable no-unused-vars */ var StyledExternalLink = (0, _styledComponentsDefault.default)(/*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var hoverColor = _ref.hoverColor, activeColor = _ref.activeColor, extrastyles = _ref.extrastyles, props = _objectWithoutProperties(_ref, _excluded$j);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", _extends({}, props, {
        ref: ref
    }));
})).withConfig({
    displayName: "ExternalLinkstyled__StyledExternalLink",
    componentId: "sc-m1q2m2-0"
})([
    "display:flex;font-size:",
    ";color:",
    ";font-weight:",
    ";font-family:",
    ";line-height:",
    ";text-decoration:",
    ";&:hover{color:",
    ";text-decoration:",
    ";}&:focus{outline:3px solid ",
    ";outline-offset:2px;text-decoration:",
    ";}&:active{color:",
    ";}",
    ""
], function(_ref2) {
    var size = _ref2.size;
    return size;
}, function(_ref3) {
    var color = _ref3.color;
    return color;
}, function(_ref4) {
    var weight = _ref4.weight;
    return weight;
}, function(_ref5) {
    var fontFamily = _ref5.fontFamily;
    return fontFamily;
}, function(_ref6) {
    var lineheight = _ref6.lineheight;
    return lineheight;
}, LINK_TEXT_DECORATION$2, function(_ref7) {
    var hoverColor = _ref7.hoverColor;
    return hoverColor;
}, LINK_TEXT_DECORATION$2, ROYAL_BLUE$1, LINK_TEXT_DECORATION$2, function(_ref8) {
    var activeColor = _ref8.activeColor;
    return activeColor;
}, function(_ref9) {
    var extrastyles = _ref9.extrastyles;
    return extrastyles;
});
/* eslint-enable no-unused-vars */ var ExternalLink = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$href = _ref.href, href = _ref$href === void 0 ? "" : _ref$href, _ref$newTab = _ref.newTab, newTab = _ref$newTab === void 0 ? false : _ref$newTab, _ref$size = _ref.size, size = _ref$size === void 0 ? "1rem" : _ref$size, _ref$lineHeight = _ref.lineHeight, lineHeight = _ref$lineHeight === void 0 ? "1.5rem" : _ref$lineHeight, _ref$weight = _ref.weight, weight = _ref$weight === void 0 ? FONT_WEIGHT_REGULAR : _ref$weight, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "primary" : _ref$variant, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? "0" : _ref$tabIndex, dataQa = _ref.dataQa, ariaLabel = _ref.ariaLabel, _ref$isUnderlined = _ref.isUnderlined, isUnderlined = _ref$isUnderlined === void 0 ? true : _ref$isUnderlined, children = _ref.children;
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var themeValues = createThemeValues(themeContext, fallbackValues$7, "Link", variant);
    var handleKeyDown = function handleKeyDown(event) {
        // This is to address an issue on Safari where the link's tab order and Enter key were not being recognized
        if (event.key === "Enter" || event.keyCode === 13) {
            if (newTab) window.open(href, "_blank");
            else window.location.href = href;
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledExternalLink, {
        href: href,
        target: newTab ? "_blank" : "",
        color: themeValues.externalLinkColor,
        size: size,
        lineheight: lineHeight,
        weight: weight,
        hovercolor: themeValues.hoverColor,
        activeColor: themeValues.activeColor,
        fontFamily: themeValues.fontFamily,
        tabIndex: tabIndex,
        extrastyles: "text-decoration: ".concat(isUnderlined ? LINK_TEXT_DECORATION : "none", "; ").concat(extraStyles),
        rel: newTab ? "noopener" : "",
        "data-qa": dataQa,
        "aria-label": ariaLabel,
        onKeyDown: handleKeyDown,
        ref: ref
    }, safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null)));
});
var _excluded$k = [
    "hoverColor",
    "activeColor",
    "active",
    "color",
    "extrastyles",
    "underlined",
    "hoverUnderline",
    "extraHoverStyles",
    "extraActiveStyles",
    "extraFocusStyles"
];
var ROYAL_BLUE$2 = ROYAL_BLUE;
var LINK_TEXT_DECORATION$3 = LINK_TEXT_DECORATION;
/*
  The extracting of props and the disabling of the eslint rule is to stop React from complaining about
  unrecognized DOM attributes.
*/ /* eslint-disable no-unused-vars */ var StyledInternalLink = (0, _styledComponentsDefault.default)(/*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var hoverColor = _ref.hoverColor, activeColor = _ref.activeColor, active = _ref.active, color = _ref.color, extrastyles = _ref.extrastyles, underlined = _ref.underlined, hoverUnderline = _ref.hoverUnderline, extraHoverStyles = _ref.extraHoverStyles, extraActiveStyles = _ref.extraActiveStyles, extraFocusStyles = _ref.extraFocusStyles, props = _objectWithoutProperties(_ref, _excluded$k);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Link), _extends({}, props, {
        ref: ref
    }));
})).withConfig({
    displayName: "InternalLinkstyled__StyledInternalLink",
    componentId: "sc-cuqxud-0"
})([
    "display:flex;color:",
    ";font-weight:",
    ";line-height:",
    ";font-size:",
    ";font-family:",
    ";margin:",
    ";text-decoration:",
    ";&:hover{color:",
    ";text-decoration:",
    ";",
    "}&:focus{outline:3px solid ",
    ";outline-offset:2px;text-decoration:",
    ";",
    "}&:active{color:",
    ";",
    "}",
    ""
], function(_ref2) {
    var color = _ref2.color, active = _ref2.active, activeColor = _ref2.activeColor;
    return active === "true" ? activeColor : color;
}, function(_ref3) {
    var fontWeight = _ref3.fontWeight;
    return fontWeight;
}, function(_ref4) {
    var lineheight = _ref4.lineheight;
    return lineheight;
}, function(_ref5) {
    var fontSize = _ref5.fontSize;
    return fontSize;
}, function(_ref6) {
    var fontFamily = _ref6.fontFamily;
    return fontFamily;
}, function(_ref7) {
    var margin = _ref7.margin;
    return margin;
}, function(_ref8) {
    var underlined = _ref8.underlined;
    return underlined ? LINK_TEXT_DECORATION$3 : "none";
}, function(_ref9) {
    var hoverColor = _ref9.hoverColor;
    return hoverColor;
}, function(_ref10) {
    var hoverUnderline = _ref10.hoverUnderline;
    return hoverUnderline ? LINK_TEXT_DECORATION$3 : "none";
}, function(_ref11) {
    var extraHoverStyles = _ref11.extraHoverStyles;
    return extraHoverStyles;
}, ROYAL_BLUE$2, function(_ref12) {
    var hoverUnderline = _ref12.hoverUnderline;
    return hoverUnderline ? LINK_TEXT_DECORATION$3 : "none";
}, function(_ref13) {
    var extraFocusStyles = _ref13.extraFocusStyles;
    return extraFocusStyles;
}, function(_ref14) {
    var activeColor = _ref14.activeColor;
    return activeColor;
}, function(_ref15) {
    var extraActiveStyles = _ref15.extraActiveStyles;
    return extraActiveStyles;
}, function(_ref16) {
    var extrastyles = _ref16.extrastyles;
    return extrastyles;
});
/* eslint-enable no-unused-vars */ var _excluded$l = [
    "to",
    "color",
    "children",
    "active",
    "fontSize",
    "lineheight",
    "fontWeight",
    "variant",
    "margin",
    "tabIndex",
    "dataQa",
    "extraStyles",
    "isUnderlined",
    "hoverUnderline",
    "extraHoverStyles",
    "extraActiveStyles",
    "extraFocusStyles"
];
var InternalLink = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$to = _ref.to, to = _ref$to === void 0 ? "" : _ref$to, color = _ref.color, children = _ref.children, active = _ref.active, fontSize = _ref.fontSize, lineheight = _ref.lineheight, fontWeight = _ref.fontWeight, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "primary" : _ref$variant, margin = _ref.margin, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? "0" : _ref$tabIndex, dataQa = _ref.dataQa, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, _ref$isUnderlined = _ref.isUnderlined, isUnderlined = _ref$isUnderlined === void 0 ? true : _ref$isUnderlined, _ref$hoverUnderline = _ref.hoverUnderline, hoverUnderline = _ref$hoverUnderline === void 0 ? true : _ref$hoverUnderline, _ref$extraHoverStyles = _ref.extraHoverStyles, extraHoverStyles = _ref$extraHoverStyles === void 0 ? "" : _ref$extraHoverStyles, _ref$extraActiveStyle = _ref.extraActiveStyles, extraActiveStyles = _ref$extraActiveStyle === void 0 ? "" : _ref$extraActiveStyle, _ref$extraFocusStyles = _ref.extraFocusStyles, extraFocusStyles = _ref$extraFocusStyles === void 0 ? "" : _ref$extraFocusStyles, rest = _objectWithoutProperties(_ref, _excluded$l);
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var themeValues = createThemeValues(themeContext, fallbackValues$7, "Link", variant);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledInternalLink, _extends({
        to: to,
        color: color,
        lineheight: lineheight,
        active: active,
        fontWeight: fontWeight,
        fontSize: fontSize,
        fontFamily: themeValues.fontFamily,
        margin: margin,
        hoverColor: themeValues.hoverColor,
        activeColor: themeValues.activeColor,
        tabIndex: tabIndex,
        underlined: isUnderlined,
        hoverUnderline: hoverUnderline,
        extrastyles: extraStyles,
        extraHoverStyles: extraHoverStyles,
        extraActiveStyles: extraActiveStyles,
        extraFocusStyles: extraFocusStyles,
        "data-qa": dataQa,
        ref: ref
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null)));
});
var Breadcrumbs = function Breadcrumbs(_ref) {
    var _ref$breadcrumbsList = _ref.breadcrumbsList, breadcrumbsList = _ref$breadcrumbsList === void 0 ? [] : _ref$breadcrumbsList;
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var themeValues = createThemeValues(themeContext, fallbackValues$6, "Breadcrumb");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        as: "nav",
        "aria-label": "Breadcrumb navigation"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "flex-start",
        align: "center"
    }, breadcrumbsList.map(function(_ref2, index) {
        var linkText = _ref2.linkText, linkDestination = _ref2.linkDestination, isActive = _ref2.isActive;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), {
            key: "breadcrumb-".concat(linkText)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(InternalLink, {
            "aria-current": index === breadcrumbsList.length - 1 ? "location" : "",
            to: linkDestination,
            active: isActive.toString(),
            color: themeValues.color,
            fontSize: themeValues.fontSize,
            lineheight: themeValues.lineHeight,
            fontWeight: themeValues.fontWeight,
            margin: themeValues.margin,
            extraStyles: "\n                          text-transform: uppercase;\n                          text-decoration: none;\n                          ".concat(isActive.toString() === "true" && "color: ".concat(themeValues.activeBreadcrumbColor, ";\n                             pointer-events: none;\n                            "), "\n                          &:first-child {\n                            margin-left: 0;\n                          }\n                          &:active {\n                            color: ").concat(themeValues.activeColor, ";\n                          }")
        }, linkText), index < breadcrumbsList.length - 1 ? /*#__PURE__*/ (0, _reactDefault.default).createElement(IconChevron, null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null));
    })));
};
var WHITE$1 = WHITE, TRANSPARENT$1 = TRANSPARENT, PEACOCK_BLUE$1 = PEACOCK_BLUE, MANATEE_GREY$1 = MANATEE_GREY, LUCKY_POINT$1 = LUCKY_POINT, HINT_GREEN$1 = HINT_GREEN, SEA_GREEN$1 = SEA_GREEN, RASPBERRY$1 = RASPBERRY, ERROR_COLOR$1 = ERROR_COLOR, LUCKY_POINT_DARK$1 = LUCKY_POINT_DARK, HAWKES_BLUE$1 = HAWKES_BLUE;
var LINK_TEXT_DECORATION$4 = LINK_TEXT_DECORATION;
var disabledBorderColor = {
    primary: MANATEE_GREY$1,
    secondary: MANATEE_GREY$1,
    back: TRANSPARENT$1,
    smallPrimary: MANATEE_GREY$1,
    smallSecondary: MANATEE_GREY$1,
    smallGhost: TRANSPARENT$1,
    ghost: TRANSPARENT$1,
    tertiary: TRANSPARENT$1,
    danger: MANATEE_GREY$1,
    dangerSecondary: MANATEE_GREY$1,
    whitePrimary: MANATEE_GREY$1,
    whiteSecondary: MANATEE_GREY$1,
    greenPrimary: SEA_GREEN$1,
    greenSecondary: SEA_GREEN$1
};
var disabledColor = {
    primary: WHITE$1,
    secondary: MANATEE_GREY$1,
    back: MANATEE_GREY$1,
    smallPrimary: WHITE$1,
    smallSecondary: MANATEE_GREY$1,
    smallGhost: MANATEE_GREY$1,
    ghost: MANATEE_GREY$1,
    tertiary: MANATEE_GREY$1,
    danger: WHITE$1,
    dangerSecondary: MANATEE_GREY$1,
    whitePrimary: MANATEE_GREY$1,
    whiteSecondary: MANATEE_GREY$1,
    greenPrimary: WHITE$1,
    greenSecondary: SEA_GREEN$1
};
var disabledBackgroundColor = {
    primary: MANATEE_GREY$1,
    secondary: TRANSPARENT$1,
    back: TRANSPARENT$1,
    smallPrimary: MANATEE_GREY$1,
    smallSecondary: TRANSPARENT$1,
    smallGhost: TRANSPARENT$1,
    ghost: TRANSPARENT$1,
    tertiary: TRANSPARENT$1,
    danger: MANATEE_GREY$1,
    dangerSecondary: TRANSPARENT$1,
    whitePrimary: TRANSPARENT$1,
    whiteSecondary: TRANSPARENT$1,
    greenPrimary: SEA_GREEN$1,
    greenSecondary: TRANSPARENT$1
};
var padding = {
    primary: "0.75rem 1.5rem",
    secondary: "0.75rem 1.5rem",
    back: "0.75rem 1.5rem",
    smallPrimary: "0.75rem 1rem",
    smallSecondary: "0.75rem 1rem",
    smallGhost: "0",
    tertiary: "0.75rem 1.5rem",
    ghost: "0.65rem 0",
    danger: "0.75rem 1.5rem",
    dangerSecondary: "0.75rem 1.5rem",
    whitePrimary: "1.125rem 0.75rem",
    whiteSecondary: "0.75rem 2rem",
    greenPrimary: "0.75rem 1.5rem",
    greenSecondary: "0.75rem 1.5rem"
};
var color$5 = {
    primary: WHITE$1,
    secondary: LUCKY_POINT$1,
    back: LUCKY_POINT$1,
    smallPrimary: WHITE$1,
    smallSecondary: LUCKY_POINT$1,
    smallGhost: LUCKY_POINT$1,
    ghost: LUCKY_POINT$1,
    tertiary: LUCKY_POINT$1,
    danger: WHITE$1,
    dangerSecondary: ERROR_COLOR$1,
    whitePrimary: WHITE$1,
    whiteSecondary: WHITE$1,
    greenPrimary: WHITE$1,
    greenSecondary: SEA_GREEN$1
};
var fontSizeVariant = {
    primary: "pS",
    secondary: "pS",
    back: "pS",
    smallPrimary: "pS",
    smallSecondary: "pS",
    smallGhost: "p",
    ghost: "pL",
    tertiary: "pS",
    danger: "pS",
    dangerSecondary: "pS",
    whiteSecondary: "pS",
    whitePrimary: "pS",
    greenPrimary: "pS",
    greenSecondary: "pS"
};
var fontWeight$2 = {
    primary: "600",
    secondary: "600",
    back: "600",
    smallPrimary: "600",
    smallSecondary: "600",
    smallGhost: "400",
    ghost: "600",
    tertiary: "600",
    danger: "600",
    dangerSecondary: "600",
    whiteSecondary: "600",
    whitePrimary: "600",
    greenPrimary: "600",
    greenSecondary: "600"
};
var height = {
    primary: "3rem",
    secondary: "3rem",
    back: "3rem",
    smallPrimary: "2.5rem",
    smallSecondary: "2.5rem",
    smallGhost: "1.5rem",
    ghost: "3rem",
    tertiary: "3rem",
    danger: "3rem",
    dangerSecondary: "3rem",
    whitePrimary: "auto",
    whiteSecondary: "3rem",
    greenPrimary: "3rem",
    greenSecondary: "3rem"
};
var minWidth = {
    primary: "130px",
    secondary: "130px",
    back: "130px",
    smallPrimary: "100px",
    smallSecondary: "100px",
    smallGhost: "100px",
    ghost: "130px",
    tertiary: "130px",
    danger: "130px",
    dangerSecondary: "157px",
    whitePrimary: "130px",
    whiteSecondary: "160px",
    greenPrimary: "130px",
    greenSecondary: "130px"
};
var textDecoration = {
    primary: "none",
    secondary: "none",
    back: "none",
    smallPrimary: "none",
    smallSecondary: "none",
    smallGhost: LINK_TEXT_DECORATION$4,
    ghost: LINK_TEXT_DECORATION$4,
    tertiary: "none",
    danger: "none",
    dangerSecondary: "none",
    whitePrimary: "none",
    whiteSecondary: "none",
    greenPrimary: "none",
    greenSecondary: "none"
};
var backgroundColor = {
    primary: LUCKY_POINT$1,
    secondary: TRANSPARENT$1,
    back: TRANSPARENT$1,
    smallPrimary: LUCKY_POINT$1,
    smallSecondary: TRANSPARENT$1,
    smallGhost: TRANSPARENT$1,
    ghost: TRANSPARENT$1,
    tertiary: TRANSPARENT$1,
    danger: RASPBERRY$1,
    dangerSecondary: TRANSPARENT$1,
    whitePrimary: TRANSPARENT$1,
    whiteSecondary: TRANSPARENT$1,
    greenPrimary: SEA_GREEN$1,
    greenSecondary: TRANSPARENT$1
};
var border$1 = {
    primary: "2px solid " + LUCKY_POINT$1,
    secondary: "2px solid " + LUCKY_POINT$1,
    back: "2px solid " + LUCKY_POINT$1,
    smallPrimary: "2px solid " + LUCKY_POINT$1,
    smallSecondary: "2px solid " + LUCKY_POINT$1,
    smallGhost: "none",
    ghost: "none",
    tertiary: "none",
    danger: "2px solid " + RASPBERRY$1,
    dangerSecondary: "2px solid " + ERROR_COLOR$1,
    whitePrimary: "2px solid " + TRANSPARENT$1,
    whiteSecondary: "2px solid " + WHITE$1,
    greenPrimary: "2px solid " + SEA_GREEN$1,
    greenSecondary: "2px solid " + SEA_GREEN$1
};
var hoverBackgroundColor = {
    primary: LUCKY_POINT_DARK$1,
    secondary: HAWKES_BLUE$1,
    back: TRANSPARENT$1,
    smallPrimary: LUCKY_POINT_DARK$1,
    smallSecondary: HAWKES_BLUE$1,
    smallGhost: TRANSPARENT$1,
    ghost: TRANSPARENT$1,
    tertiary: TRANSPARENT$1,
    danger: "#BA002C",
    dangerSecondary: "#FAE7EE",
    whitePrimary: TRANSPARENT$1,
    whiteSecondary: TRANSPARENT$1,
    greenPrimary: adjustHexColor(SEA_GREEN$1, 10, "darken"),
    greenSecondary: HINT_GREEN$1
};
var hoverBorderColor = {
    primary: LUCKY_POINT_DARK$1,
    secondary: LUCKY_POINT$1,
    back: "#DCEAF1",
    smallPrimary: LUCKY_POINT_DARK$1,
    smallSecondary: LUCKY_POINT$1,
    smallGhost: TRANSPARENT$1,
    ghost: TRANSPARENT$1,
    tertiary: TRANSPARENT$1,
    danger: "#BA002C",
    dangerSecondary: "#B10541",
    whitePrimary: "2px solid " + TRANSPARENT$1,
    whiteSecondary: "2px solid " + TRANSPARENT$1,
    greenPrimary: SEA_GREEN$1,
    greenSecondary: SEA_GREEN$1
};
var hoverColor$1 = {
    primary: WHITE$1,
    secondary: LUCKY_POINT$1,
    back: LUCKY_POINT$1,
    smallPrimary: WHITE$1,
    smallSecondary: LUCKY_POINT$1,
    smallGhost: LUCKY_POINT$1,
    ghost: LUCKY_POINT$1,
    tertiary: LUCKY_POINT$1,
    danger: WHITE$1,
    dangerSecondary: "#B10541",
    whitePrimary: WHITE$1,
    whiteSecondary: WHITE$1,
    greenPrimary: WHITE$1,
    greenSecondary: SEA_GREEN$1
};
var activeBackgroundColor = {
    primary: LUCKY_POINT_DARK$1,
    secondary: adjustHexColor(HAWKES_BLUE$1, 10, "darken"),
    back: TRANSPARENT$1,
    smallPrimary: LUCKY_POINT_DARK$1,
    smallSecondary: adjustHexColor(HAWKES_BLUE$1, 10, "darken"),
    smallGhost: TRANSPARENT$1,
    ghost: TRANSPARENT$1,
    tertiary: TRANSPARENT$1,
    danger: "#870000",
    dangerSecondary: "#FAE7EE",
    whitePrimary: TRANSPARENT$1,
    whiteSecondary: TRANSPARENT$1,
    greenPrimary: adjustHexColor(SEA_GREEN$1, 20, "darken"),
    greenSecondary: adjustHexColor(HINT_GREEN$1, 5, "darken")
};
var activeBorderColor = {
    primary: adjustHexColor(LUCKY_POINT_DARK$1, 10, "darken"),
    secondary: LUCKY_POINT$1,
    back: PEACOCK_BLUE$1,
    smallPrimary: adjustHexColor(LUCKY_POINT_DARK$1, 10, "darken"),
    smallSecondary: LUCKY_POINT$1,
    smallGhost: TRANSPARENT$1,
    ghost: TRANSPARENT$1,
    tertiary: TRANSPARENT$1,
    danger: "#870000",
    dangerSecondary: "#910029",
    whitePrimary: "2px solid " + TRANSPARENT$1,
    whiteSecondary: "2px solid " + TRANSPARENT$1,
    greenPrimary: SEA_GREEN$1,
    greenSecondary: SEA_GREEN$1
};
var activeColor$2 = {
    primary: WHITE$1,
    secondary: LUCKY_POINT$1,
    back: PEACOCK_BLUE$1,
    smallPrimary: WHITE$1,
    smallSecondary: PEACOCK_BLUE$1,
    smallGhost: PEACOCK_BLUE$1,
    ghost: PEACOCK_BLUE$1,
    tertiary: PEACOCK_BLUE$1,
    danger: WHITE$1,
    dangerSecondary: "#910029",
    whitePrimary: WHITE$1,
    whiteSecondary: WHITE$1,
    greenPrimary: WHITE$1,
    greenSecondary: SEA_GREEN$1
};
var fallbackValues$8 = {
    padding: padding,
    color: color$5,
    fontSizeVariant: fontSizeVariant,
    fontWeight: fontWeight$2,
    height: height,
    minWidth: minWidth,
    textDecoration: textDecoration,
    backgroundColor: backgroundColor,
    border: border$1,
    hoverBackgroundColor: hoverBackgroundColor,
    hoverBorderColor: hoverBorderColor,
    hoverColor: hoverColor$1,
    activeBackgroundColor: activeBackgroundColor,
    activeBorderColor: activeBorderColor,
    activeColor: activeColor$2,
    disabledColor: disabledColor,
    disabledBackgroundColor: disabledBackgroundColor,
    disabledBorderColor: disabledBorderColor
};
var SpinnerContainer = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Spinner__SpinnerContainer",
    componentId: "sc-jphte-0"
})([
    "width:100%;display:flex;flex-direction:row;align-items:center;justify-content:center;"
]);
var SpinnerIconWrapper = (0, _styledComponentsDefault.default)(Motion).withConfig({
    displayName: "Spinner__SpinnerIconWrapper",
    componentId: "sc-jphte-1"
})([
    "width:",
    "px;height:",
    "px;"
], function(_ref) {
    var isMobile = _ref.isMobile;
    return isMobile ? "18" : "21";
}, function(_ref2) {
    var isMobile = _ref2.isMobile;
    return isMobile ? "18" : "21";
});
var SpinnerIcon = function SpinnerIcon(_ref3) {
    var color = _ref3.color, isMobile = _ref3.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SpinnerContainer, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(SpinnerIconWrapper, {
        initial: {
            rotate: 0
        },
        animate: {
            rotate: 360
        },
        transition: {
            duration: 1,
            ease: "linear",
            repeat: Infinity
        },
        isMobile: isMobile
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 24 24",
        height: "100%",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M72.1558149,36 C72.0733136,36 72.0151877,35.9981252 71.9829372,35.9970003 C66.1928468,35.9876262 60,31.1685779 60,23.9985001 C60,16.821298 66.204847,12 71.9998125,12 C78.2804106,12 84,17.7189638 84,23.9985001 C84,24.4124613 83.6639947,24.7484298 83.2499883,24.7484298 C82.8356068,24.7484298 82.4999766,24.4124613 82.4999766,23.9985001 C82.4999766,18.5041402 77.4951484,13.4998594 71.9998125,13.4998594 C66.9289833,13.4998594 61.5000234,17.7185889 61.5000234,23.9985001 C61.5000234,30.2784114 66.9289833,34.4971409 71.9998125,34.4971409 C72.0129377,34.4971409 72.0260629,34.4975159 72.0391881,34.4982658 C72.0789387,34.4990157 76.2268785,34.6471268 79.907186,30.9675968 C80.2000656,30.6747492 80.675198,30.6747492 80.9677026,30.9675968 C81.2605822,31.2604443 81.2605822,31.7351498 80.9677026,32.0279974 C77.2236441,35.7716464 73.1034547,36 72.1558149,36 L72.1558149,36 Z",
        id: "spinner-path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Symbols",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Button/Primary/Standard/Loading",
        transform: "translate(-60 -12)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask-2",
        fill: color || "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#spinner-path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        id: "loader",
        fill: color || "white",
        xlinkHref: "#spinner-path-1"
    }))))));
};
var _excluded$m = [
    "action",
    "variant",
    "text",
    "textWrap",
    "isLoading",
    "disabled",
    "loadingColor",
    "dataQa",
    "textExtraStyles",
    "contentOverride",
    "extraStyles",
    "tabIndex",
    "children",
    "extraDisabledStyles"
];
var SpinnerContainer$1 = (0, _styledComponentsDefault.default)(Motion).withConfig({
    displayName: "ButtonWithAction__SpinnerContainer",
    componentId: "sc-1ffs4ga-0"
})([
    "width:100%;display:flex;flex-direction:row;align-items:center;justify-content:center;"
]);
var Spinner = function Spinner(_ref) {
    var color = _ref.color, isMobile = _ref.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SpinnerContainer$1, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(SpinnerIcon, {
        color: color,
        isMobile: isMobile
    }));
};
/* Most of the time, to use this button you'll only need to specify:
  - A variant (if different than primary)
  - An action
  - Text

  Optionally, you can also pass:
  - isLoading to show a spinner
  - dataQa for use with test cafe
  - contentOverride to use the button as a wrapper around arbitrary content
  - extraStyles if you need an escape hatch. Extra styles should be used sparingly.

  Note: the children prop is only used if contentOverride is set to true, in which case
  the text prop is ignored.

*/ var ButtonWithAction = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref2, ref) {
    var _ref2$action = _ref2.action, action = _ref2$action === void 0 ? noop$1 : _ref2$action, _ref2$variant = _ref2.variant, variant = _ref2$variant === void 0 ? "primary" : _ref2$variant, text = _ref2.text, _ref2$textWrap = _ref2.textWrap, textWrap = _ref2$textWrap === void 0 ? false : _ref2$textWrap, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, _ref2$disabled = _ref2.disabled, disabled = _ref2$disabled === void 0 ? false : _ref2$disabled, _ref2$loadingColor = _ref2.loadingColor, loadingColor = _ref2$loadingColor === void 0 ? "white" : _ref2$loadingColor, _ref2$dataQa = _ref2.dataQa, dataQa = _ref2$dataQa === void 0 ? null : _ref2$dataQa, textExtraStyles = _ref2.textExtraStyles, _ref2$contentOverride = _ref2.contentOverride, contentOverride = _ref2$contentOverride === void 0 ? false : _ref2$contentOverride, _ref2$extraStyles = _ref2.extraStyles, extraStyles = _ref2$extraStyles === void 0 ? "" : _ref2$extraStyles, tabIndex = _ref2.tabIndex, children = _ref2.children, extraDisabledStyles = _ref2.extraDisabledStyles, rest = _objectWithoutProperties(_ref2, _excluded$m);
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var themeValues = createThemeValues(themeContext, fallbackValues$8, "Button", variant);
    var isMobile = themeContext.isMobile;
    var hoverStyles = "\n      outline: none;\n      background-color: ".concat(themeValues.hoverBackgroundColor, ";\n      border-color: ").concat(themeValues.hoverBorderColor, ";\n      color: ").concat(themeValues.hoverColor, ";\n      text-decoration: ").concat(variant === "ghost" || variant === "smallGhost" ? "underline" : "none", ";\n      cursor: pointer;\n    ");
    var activeStyles = "\n      outline: none;\n      background-color: ".concat(themeValues.activeBackgroundColor, ";\n      border-color: ").concat(themeValues.activeBorderColor, ";\n      color: ").concat(themeValues.activeColor, ";\n      text-decoration: ").concat(variant === "ghost" || variant === "smallGhost" ? "underline" : "none", ";\n  ");
    var disabledStyles = "\n      background-color: ".concat(themeValues.disabledBackgroundColor, ";\n      border-color: ").concat(themeValues.disabledBorderColor, ";\n      color: ").concat(themeValues.disabledColor, ";\n      cursor: default;\n      &:focus {\n        outline: 3px solid ").concat(themeValues.disabledBorderColor, ";\n        outline-offset: 2px;\n      }\n      ").concat(extraDisabledStyles, "\n    ");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        ref: ref,
        variant: variant,
        padding: themeValues.padding,
        minHeight: themeValues.height,
        minWidth: themeValues.minWidth,
        background: themeValues.backgroundColor,
        border: themeValues.border,
        hoverStyles: disabled ? disabledStyles : hoverStyles,
        activeStyles: disabled ? disabledStyles : activeStyles,
        disabledStyles: disabledStyles,
        "aria-disabled": disabled,
        as: "button",
        onClick: isLoading || disabled ? noop$1 : action,
        borderRadius: "2px",
        theme: themeContext,
        extraStyles: "margin: 0.5rem; ".concat(extraStyles),
        dataQa: dataQa,
        tabIndex: tabIndex
    }, rest), contentOverride ? children : /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        as: "span",
        intrinsic: true
    }, isLoading ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Spinner, {
        color: loadingColor,
        isMobile: isMobile
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        weight: themeValues.fontWeight,
        variant: themeValues.fontSizeVariant,
        color: disabled ? themeValues.disabledColor : themeValues.color,
        textDecoration: themeValues.textDecoration,
        textWrap: textWrap,
        extraStyles: textExtraStyles
    }, text)));
});
function _isPlaceholder(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function _curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || _isPlaceholder(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function _curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return _isPlaceholder(a) ? f2 : _curry1(function(_b) {
                    return fn(a, _b);
                });
            default:
                return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function(_a) {
                    return fn(_a, b);
                }) : _isPlaceholder(b) ? _curry1(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
function _arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function _curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!_isPlaceholder(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
    };
}
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var curryN = /*#__PURE__*/ _curry2(function curryN(length, fn) {
    if (length === 1) return _curry1(fn);
    return _arity(length, _curryN(length, [], fn));
});
/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function _curry3(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return _isPlaceholder(a) ? f3 : _curry2(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : _isPlaceholder(b) ? _curry2(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : _curry1(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : _isPlaceholder(a) ? _curry1(function(_a) {
                    return fn(_a, b, c);
                }) : _isPlaceholder(b) ? _curry1(function(_b) {
                    return fn(a, _b, c);
                }) : _isPlaceholder(c) ? _curry1(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var _isArray = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};
function _isTransformer(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}
/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */ function _dispatchable(methodNames, xf, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!_isArray(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, args);
                idx += 1;
            }
            if (_isTransformer(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}
var _xfBase = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};
function _map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}
function _isString(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */ var _isArrayLike = /*#__PURE__*/ _curry1(function isArrayLike(x) {
    if (_isArray(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if (_isString(x)) return false;
    if (x.nodeType === 1) return !!x.length;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function _xwrap(fn) {
    return new XWrap(fn);
}
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var bind = /*#__PURE__*/ _curry2(function bind(fn, thisObj) {
    return _arity(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}
function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName](bind(xf["@@transducer/step"], xf), acc));
}
var symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function _reduce(fn, acc, list) {
    if (typeof fn === "function") fn = _xwrap(fn);
    if (_isArrayLike(list)) return _arrayReduce(fn, acc, list);
    if (typeof list["fantasy-land/reduce"] === "function") return _methodReduce(fn, acc, list, "fantasy-land/reduce");
    if (list[symIterator] != null) return _iterableReduce(fn, acc, list[symIterator]());
    if (typeof list.next === "function") return _iterableReduce(fn, acc, list);
    if (typeof list.reduce === "function") return _methodReduce(fn, acc, list, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
}
function _has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var toString = Object.prototype.toString;
var _isArguments = /*#__PURE__*/ function() {
    return toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return _has("callee", x);
    };
}();
var hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
]; // Safari bug
var hasArgsEnumBug = /*#__PURE__*/ function() {
    return arguments.propertyIsEnumerable("length");
}();
var contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var keys = typeof Object.keys === "function" && !hasArgsEnumBug ? /*#__PURE__*/ _curry1(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ _curry1(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
    for(prop in obj)if (_has(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = nonEnumerableProps[nIdx];
            if (_has(prop, obj) && !contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var _isInteger = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var nth = /*#__PURE__*/ _curry2(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return _isString(list) ? list.charAt(idx) : list[idx];
});
/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */ var paths = /*#__PURE__*/ _curry2(function paths(pathsArray, obj) {
    return pathsArray.map(function(paths) {
        var val = obj;
        var idx = 0;
        var p;
        while(idx < paths.length){
            if (val == null) return;
            p = paths[idx];
            val = _isInteger(p) ? nth(p, val) : val[p];
            idx += 1;
        }
        return val;
    });
});
/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 */ var path = /*#__PURE__*/ _curry2(function path(pathAr, obj) {
    return paths([
        pathAr
    ], obj)[0];
});
/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var always = /*#__PURE__*/ _curry1(function always(val) {
    return function() {
        return val;
    };
});
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var isNil = /*#__PURE__*/ _curry1(function isNil(x) {
    return x == null;
});
function _cloneRegExp(pattern) {
    return new RegExp(pattern.source, (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : ""));
}
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var type = /*#__PURE__*/ _curry1(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
function _arrayFromIterator(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}
function _includesWith(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}
function _functionName(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function _objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var _objectIs$1 = typeof Object.is === "function" ? Object.is : _objectIs;
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = _arrayFromIterator(aIterator);
    var b = _arrayFromIterator(bIterator);
    function eq(_a, _b) {
        return _equals(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*
    return !_includesWith(function(b, aItem) {
        return !_includesWith(eq, aItem, b);
    }, b, a);
}
function _equals(a, b, stackA, stackB) {
    if (_objectIs$1(a, b)) return true;
    var typeA = type(a);
    if (typeA !== type(b)) return false;
    if (a == null || b == null) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && _functionName(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && _objectIs$1(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!_objectIs$1(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return _uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = keys(a);
    if (keysA.length !== keys(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var equals = /*#__PURE__*/ _curry2(function equals(a, b) {
    return _equals(a, b, [], []);
});
function _indexOf(list, a, idx) {
    var inf, item; // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === "function") switch(typeof a){
        case "number":
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === "number" && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            } // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case "string":
        case "boolean":
        case "function":
        case "undefined":
            return list.indexOf(a, idx);
        case "object":
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
     // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if (equals(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}
function _includes(a, list) {
    return _indexOf(list, a, 0) >= 0;
}
function _quote(s) {
    var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b") // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var pad = function pad(n) {
    return (n < 10 ? "0" : "") + n;
};
var _toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + "-" + pad(d.getUTCMonth() + 1) + "-" + pad(d.getUTCDate()) + "T" + pad(d.getUTCHours()) + ":" + pad(d.getUTCMinutes()) + ":" + pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + "Z";
};
function _complement(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}
function _filter(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}
function _isObject(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}
var XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype["@@transducer/init"] = _xfBase.init;
    XFilter.prototype["@@transducer/result"] = _xfBase.result;
    XFilter.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XFilter;
}();
var _xfilter = /*#__PURE__*/ _curry2(function _xfilter(f, xf) {
    return new XFilter(f, xf);
});
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var filter$1 = /*#__PURE__*/ _curry2(/*#__PURE__*/ _dispatchable([
    "filter"
], _xfilter, function(pred, filterable) {
    return _isObject(filterable) ? _reduce(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, keys(filterable)) : _filter(pred, filterable);
}));
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var reject = /*#__PURE__*/ _curry2(function reject(pred, filterable) {
    return filter$1(_complement(pred), filterable);
});
function _toString(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return _includes(y, xs) ? "<Circular>" : _toString(y, xs);
    }; //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return _map(function(k) {
            return _quote(k) + ": " + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + _map(recur, x).join(", ") + "))";
        case "[object Array]":
            return "[" + _map(recur, x).concat(mapPairs(x, reject(function(k) {
                return /^\d+$/.test(k);
            }, keys(x)))).join(", ") + "]";
        case "[object Boolean]":
            return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
        case "[object String]":
            return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : _quote(x);
        case "[object Undefined]":
            return "undefined";
        default:
            if (typeof x.toString === "function") {
                var repr = x.toString();
                if (repr !== "[object Object]") return repr;
            }
            return "{" + mapPairs(x, keys(x)).join(", ") + "}";
    }
}
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var toString$1 = /*#__PURE__*/ _curry1(function toString(val) {
    return _toString(val, []);
});
/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var defaultTo = /*#__PURE__*/ _curry2(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */ var ifElse = /*#__PURE__*/ _curry3(function ifElse(condition, onTrue, onFalse) {
    return curryN(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var pathOr = /*#__PURE__*/ _curry3(function pathOr(d, p, obj) {
    return defaultTo(d, path(p, obj));
});
/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var times = /*#__PURE__*/ _curry2(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError("n must be a non-negative number");
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var repeat = /*#__PURE__*/ _curry2(function repeat(value, n) {
    return times(always(value), n);
});
function _isRegExp(x) {
    return Object.prototype.toString.call(x) === "[object RegExp]";
}
/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var test$2 = /*#__PURE__*/ _curry2(function test(pattern, str) {
    if (!_isRegExp(pattern)) throw new TypeError("\u2018test\u2019 requires a value of type RegExp as its first argument; received " + toString$1(pattern));
    return _cloneRegExp(pattern).test(str);
});
var _excluded$n = [
    "url",
    "disabled",
    "fileLink",
    "extraStyles",
    "linkExtraStyles",
    "newTab",
    "dataQa"
];
var ButtonWithLink = function ButtonWithLink(_ref) {
    var _ref$url = _ref.url, url = _ref$url === void 0 ? "/" : _ref$url, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$fileLink = _ref.fileLink, fileLink = _ref$fileLink === void 0 ? false : _ref$fileLink, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, _ref$linkExtraStyles = _ref.linkExtraStyles, linkExtraStyles = _ref$linkExtraStyles === void 0 ? "" : _ref$linkExtraStyles, _ref$newTab = _ref.newTab, newTab = _ref$newTab === void 0 ? false : _ref$newTab, dataQa = _ref.dataQa, otherProps = _objectWithoutProperties(_ref, _excluded$n);
    var ButtonWithLinkWrapper = function ButtonWithLinkWrapper(_ref2) {
        var children = _ref2.children, url = _ref2.url, disabled = _ref2.disabled, newTab = _ref2.newTab, dataQa = _ref2.dataQa, extraStyles = _ref2.extraStyles;
        if (disabled) return safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null));
        return test$2(URL_TEST, url) || fileLink ? /*#__PURE__*/ (0, _reactDefault.default).createElement(ExternalLink, {
            href: url,
            tabIndex: "-1",
            newTab: newTab,
            extraStyles: extraStyles,
            dataQa: dataQa
        }, safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null))) : /*#__PURE__*/ (0, _reactDefault.default).createElement(InternalLink, {
            to: url,
            tabIndex: "-1",
            dataQa: dataQa,
            extraStyles: extraStyles
        }, safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null)));
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithLinkWrapper, {
        url: url,
        disabled: disabled,
        newTab: newTab,
        extraStyles: "".concat(linkExtraStyles, " text-decoration: none; &:hover {\n        text-decoration: none; }"),
        dataQa: dataQa
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, _extends({}, otherProps, {
        disabled: disabled,
        extraStyles: extraStyles
    })));
};
var fontFamily$3 = {
    p: "Public Sans",
    pL: "Public Sans",
    pS: "Public Sans",
    pXS: "Public Sans",
    pXXS: "Public Sans",
    pXL: "Public Sans"
};
// Comments assume base font size of 16px
var fontSize$3 = {
    p: "1rem",
    // 16px
    pL: "1.125rem",
    // 18px
    pS: "0.875rem",
    // 14px
    pXS: "0.75rem",
    // 12px
    pXXS: "0.65rem",
    // 10px
    pXL: "1.5rem" // 24px
};
var fallbackValues$9 = {
    fontFamily: fontFamily$3,
    fontSize: fontSize$3
};
var ParagraphText = (0, _styledComponentsDefault.default).p.withConfig({
    displayName: "Paragraphstyled__ParagraphText",
    componentId: "sc-17g98kx-0"
})([
    "--font-size:",
    ";font-size:var(--font-size);line-height:calc(1.5 * var(--font-size));font-weight:",
    ";font-family:",
    ";color:",
    ";margin:",
    ";",
    ""
], function(_ref) {
    var fontSize = _ref.fontSize;
    return fontSize;
}, function(_ref2) {
    var weight = _ref2.weight;
    return weight;
}, function(_ref3) {
    var fontFamily = _ref3.fontFamily;
    return fontFamily;
}, function(_ref4) {
    var color = _ref4.color;
    return color;
}, function(_ref5) {
    var margin = _ref5.margin;
    return margin;
}, function(_ref6) {
    var extraStyles = _ref6.extraStyles;
    return extraStyles;
});
var _excluded$o = [
    "themeValues",
    "weight",
    "color",
    "margin",
    "extraStyles",
    "dataQa",
    "children",
    "as"
];
var Paragraph = function Paragraph(_ref) {
    var themeValues = _ref.themeValues, _ref$weight = _ref.weight, weight = _ref$weight === void 0 ? FONT_WEIGHT_REGULAR : _ref$weight, _ref$color = _ref.color, color = _ref$color === void 0 ? FIREFLY_GREY : _ref$color, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? 0 : _ref$margin, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, dataQa = _ref.dataQa, children = _ref.children, as = _ref.as, rest = _objectWithoutProperties(_ref, _excluded$o);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ParagraphText, _extends({
        weight: weight,
        color: color,
        margin: margin,
        fontFamily: themeValues.fontFamily,
        fontSize: themeValues.fontSize,
        as: as,
        extraStyles: extraStyles,
        "data-qa": dataQa
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null)));
};
var Paragraph$1 = themeComponent(Paragraph, "Paragraph", fallbackValues$9, "p");
var backgroundColor$1 = WHITE;
var iconBackgroundColor = GRECIAN_GREY;
var fallbackValues$a = {
    backgroundColor: backgroundColor$1,
    iconBackgroundColor: iconBackgroundColor
};
var primaryColor = {
    info: "".concat(WHITE),
    success: "".concat(WHITE),
    error: "".concat(WHITE)
};
var accentColor = {
    info: "".concat(BRIGHT_GREY),
    success: "".concat(BRIGHT_GREY),
    error: "".concat(BRIGHT_GREY)
};
var subIconColor = {
    info: "".concat(ROYAL_BLUE_VIVID),
    success: "".concat(SEA_GREEN),
    error: "".concat(BLUSH_RED)
};
var singleIconColor = {
    primary: "".concat(ROYAL_BLUE_VIVID),
    secondary: "".concat(BRIGHT_GREY),
    darkMode: "".concat(WHITE)
};
var fallbackValues$b = {
    primaryColor: primaryColor,
    accentColor: accentColor,
    subIconColor: subIconColor,
    singleIconColor: singleIconColor
};
var AccountsIcon = function AccountsIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "a",
        d: "M0 0H100V100H0z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "b",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#a"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.primaryColor,
        d: "M66.728 11.967c.566 0 1.024.466 1.024 1.042v18.508h6.362c.527 0 .962.406 1.018.928l.006.114v42.7c-2.433 2.351-4.911 4.22-7.386 5.687v.024s-.311.19-.898.49c-17.526 9.718-34.635-.176-34.635-.176v-1.02c-4.533-2.49-7.386-5.006-7.386-5.006V13.01c0-.576.459-1.042 1.025-1.042h40.87z",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.accentColor,
        fillRule: "nonzero",
        d: "M66.728 11a2 2 0 011.986 1.86l.006.15v8.085L68.746 18a37.09 37.09 0 014.464 3.095A36.994 36.994 0 0187 49.95C87 70.412 70.435 87 50 87S13 70.412 13 49.95a36.96 36.96 0 0110.865-26.227V13.01c0-1.056.81-1.927 1.843-2.004l.15-.005h40.87zm.057 9.19H25.8v53.82C31.978 80.24 40.539 84.1 50 84.1c6.102 0 11.83-1.605 16.786-4.417l-.001-59.492zm-5.106 56.19v3.723H48.254V76.38H61.68zM74.17 39.74h-5.451l.001 38.758a34.276 34.276 0 005.45-4.458v-34.3zM68.72 21.4l-.001 9.536c.185-.227.477-.387.89-.387h4.505c1.053 0 1.91.822 1.986 1.86l.005.149.001 39.364a34.039 34.039 0 007.997-21.973A34.09 34.09 0 0071.39 23.353a34.268 34.268 0 00-2.67-1.952zm-52.823 28.55a34.039 34.039 0 007.968 21.938v-43.88a34.047 34.047 0 00-7.968 21.941zM61.68 64.1c.534 0 .967.432.967.966v4.865a.967.967 0 01-.967.968H30.906a.967.967 0 01-.967-.968v-4.865c0-.534.433-.967.967-.967zm-.968 1.933H31.873v2.931h28.838v-2.931zm.968-10.668c.534 0 .967.433.967.967v4.865a.967.967 0 01-.967.968H30.906a.967.967 0 01-.967-.968v-4.865c0-.534.433-.967.967-.967zM60.71 57.3H31.873v2.931h28.838V57.3zm-14.418-6.751a.967.967 0 01.113 1.928l-.113.006H30.906a.967.967 0 01-.113-1.928l.113-.006h15.387zm15.386-11.266c.534 0 .967.433.967.968v4.865a.967.967 0 01-.967.967H30.906a.967.967 0 01-.967-.967V40.25c0-.535.433-.968.967-.968zm-.968 1.934H31.873v2.931h28.838v-2.931zm.968-10.667c.534 0 .967.433.967.967v4.865a.967.967 0 01-.967.968H30.906a.967.967 0 01-.967-.968v-4.865c0-.534.433-.967.967-.967zm-.968 1.934H31.873v2.931h28.838v-2.931zm-14.418-6.752a.967.967 0 01.113 1.928l-.113.007H30.906a.967.967 0 01-.113-1.928l.113-.007h15.387z",
        mask: "url(#b)"
    })));
};
var AccountsIcon$1 = themeComponent(AccountsIcon, "Icons", fallbackValues$b, "info");
var _excluded$p = [
    "fill",
    "color",
    "ariaLabel"
];
// Fill color based on default "success" variant color
var AutopayIcon = function AutopayIcon(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "#317D4F" : _ref$fill, _ref$color = _ref.color, color = _ref$color === void 0 ? "#317D4F" : _ref$color, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "Autopay" : _ref$ariaLabel, props = _objectWithoutProperties(_ref, _excluded$p);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": ariaLabel
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_5560_39870",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "3",
        width: "10",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4.81368 7.38351C4.87789 7.38351 4.92927 7.36745 4.9678 7.33535C5.00633 7.30324 5.03202 7.2615 5.04486 7.21012C5.22467 6.49089 5.60677 5.9033 6.19114 5.44736C6.77552 4.99142 7.44018 4.76344 8.1851 4.76344C8.59609 4.76344 8.99103 4.83729 9.36991 4.98499C9.74879 5.13269 10.0924 5.34782 10.4006 5.63038L9.59146 6.43951C9.50155 6.52942 9.45661 6.63859 9.45661 6.76702C9.45661 6.89546 9.50155 7.00463 9.59146 7.09453C9.68136 7.18443 9.79054 7.22939 9.91897 7.22939L12.5005 7.22939C12.629 7.22939 12.7381 7.18443 12.828 7.09453C12.9179 7.00463 12.9629 6.89546 12.9629 6.76702L12.9629 4.18548C12.9629 4.05705 12.9179 3.94788 12.828 3.85797C12.7381 3.76807 12.629 3.72312 12.5005 3.72312C12.3721 3.72312 12.2629 3.76807 12.173 3.85797L11.4795 4.55152C11.0428 4.12769 10.5419 3.80018 9.97677 3.569C9.41166 3.33781 8.81443 3.22222 8.1851 3.22222C7.41449 3.22222 6.69846 3.3924 6.03702 3.73275C5.37558 4.0731 4.82009 4.53868 4.37057 5.12948C3.92105 5.72028 3.62565 6.38172 3.48437 7.1138C3.47153 7.17801 3.48759 7.23902 3.53253 7.29682C3.57749 7.35461 3.63849 7.38351 3.71555 7.38351L4.81368 7.38351ZM8.1851 12.7778C8.95571 12.7778 9.67173 12.6076 10.3332 12.2672C10.9946 11.9269 11.5501 11.4613 11.9996 10.8705C12.4491 10.2797 12.7445 9.61827 12.8858 8.88619C12.8987 8.82197 12.8826 8.76097 12.8377 8.70317C12.7927 8.64537 12.7317 8.61648 12.6546 8.61648H11.5565C11.4923 8.61648 11.4409 8.63253 11.4024 8.66464C11.3639 8.69675 11.3382 8.73849 11.3253 8.78986C11.1455 9.5091 10.7634 10.0967 10.1791 10.5526C9.59467 11.0086 8.93002 11.2366 8.1851 11.2366C7.77411 11.2366 7.37916 11.1627 7.00028 11.015C6.6214 10.8673 6.27784 10.6522 5.96959 10.3696L6.77873 9.56048C6.86864 9.47057 6.91359 9.3614 6.91359 9.23297C6.91359 9.10453 6.86864 8.99536 6.77873 8.90546C6.68882 8.81555 6.57966 8.7706 6.45122 8.7706H3.86968C3.74124 8.7706 3.63207 8.81555 3.54217 8.90546C3.45227 8.99536 3.40731 9.10453 3.40731 9.23297L3.40731 11.8145C3.40731 11.9429 3.45226 12.0521 3.54217 12.142C3.63207 12.2319 3.74124 12.2769 3.86968 12.2769C3.99811 12.2769 4.10728 12.2319 4.19719 12.142L4.89074 11.4485C5.32742 11.8723 5.82831 12.1998 6.39343 12.431C6.95854 12.6622 7.55577 12.7778 8.1851 12.7778Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_5560_39870)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 0H16V16H0V0Z",
        fill: fill || color
    })));
};
var AccountsAddIcon = function AccountsAddIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "a",
        d: "M0 0H100V100H0z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "b",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#a"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.primaryColor,
        d: "M66.728 11.967c.566 0 1.024.466 1.024 1.042v18.508h6.362c.527 0 .962.406 1.018.928l.006.114v42.7c-2.433 2.351-4.911 4.22-7.386 5.687v.024s-.311.19-.898.49c-17.526 9.718-34.635-.176-34.635-.176v-1.02c-4.533-2.49-7.386-5.006-7.386-5.006V13.01c0-.576.459-1.042 1.025-1.042h40.87z",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.accentColor,
        fillRule: "nonzero",
        d: "M63.551 84.435l-.22.087A36.867 36.867 0 0150 87c-20.435 0-37-16.588-37-37.05a36.96 36.96 0 0110.865-26.227V13.01c0-1.056.81-1.927 1.843-2.004l.15-.005h40.87a2 2 0 011.986 1.86l.006.15v8.085L68.746 18a37.09 37.09 0 014.464 3.095A36.994 36.994 0 0187 49.95a36.915 36.915 0 01-5.216 18.978 12.433 12.433 0 00-1.743-2.803 34.02 34.02 0 004.062-16.175A34.09 34.09 0 0071.39 23.353a34.268 34.268 0 00-2.67-1.952l-.002 9.536c.185-.227.477-.387.89-.387h4.505c1.053 0 1.91.822 1.986 1.86l.005.149.002 30.394a12.38 12.38 0 00-1.936-.796L74.17 39.74h-5.451l.001 21.957c-.663.09-1.31.233-1.935.424V20.19H25.8v53.82C31.978 80.24 40.539 84.1 50 84.1c3.871 0 7.592-.646 11.06-1.837.73.83 1.567 1.562 2.491 2.173zm-4.016-4.331l-11.28-.001V76.38h9.926a12.374 12.374 0 001.354 3.724zm-35.67-52.095a34.047 34.047 0 00-7.968 21.941 34.039 34.039 0 007.968 21.939v-43.88zM61.68 64.1c.31 0 .586.146.763.373a12.463 12.463 0 00-1.731 1.76v-.199H31.873v2.931h27.166c-.276.62-.504 1.266-.677 1.934H30.906a.967.967 0 01-.96-.854l-.007-.113v-4.865c0-.496.373-.904.854-.96l.113-.007h30.773zm0-8.734c.496 0 .905.373.96.855l.007.112v4.865a.967.967 0 01-.854.961l-.113.007H30.906a.967.967 0 01-.96-.855l-.007-.113v-4.865c0-.496.373-.905.854-.96l.113-.007h30.773zM60.71 57.3H31.873v2.931h28.838V57.3zm-14.418-6.751a.967.967 0 01.113 1.928l-.113.006H30.906a.967.967 0 01-.113-1.928l.113-.006h15.387zm15.386-11.266c.496 0 .905.374.96.855l.007.113v4.865a.967.967 0 01-.854.96l-.113.007H30.906a.967.967 0 01-.96-.855l-.007-.112V40.25c0-.496.373-.905.854-.961l.113-.007h30.773zm-.968 1.934H31.873v2.931h28.838v-2.931zm.968-10.667c.496 0 .905.374.96.855l.007.112v4.865a.967.967 0 01-.854.961l-.113.007H30.906a.967.967 0 01-.96-.855l-.007-.113v-4.865c0-.496.373-.904.854-.96l.113-.007h30.773zm-.968 1.934H31.873v2.931h28.838v-2.931zm-14.418-6.752a.967.967 0 01.113 1.928l-.113.007H30.906a.967.967 0 01-.113-1.928l.113-.007h15.387z",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.subIconColor,
        d: "M70.42 61.582c6.88 0 12.458 5.578 12.458 12.459 0 6.88-5.577 12.458-12.458 12.458-6.88 0-12.458-5.578-12.458-12.458 0-6.881 5.578-12.459 12.458-12.459zm.82 6.721H69.6v4.918h-4.917v1.64H69.6v4.917h1.639V74.86h4.918v-1.64H71.24v-4.917z",
        mask: "url(#b)"
    })));
};
var AccountsAddIcon$1 = themeComponent(AccountsAddIcon, "Icons", fallbackValues$b, "info");
var ForgotPasswordIcon = function ForgotPasswordIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "prefix__a",
        d: "M0 0h100v100H0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M72.432 59.997l.305.004c6.587.162 11.878 5.552 11.878 12.178l-.004.305c-.162 6.587-5.553 11.878-12.179 11.878l-.304-.003c-6.588-.162-11.878-5.554-11.878-12.18 0-6.728 5.454-12.182 12.182-12.182zm-.092 16.098c-.85 0-1.482.578-1.482 1.36 0 .765.632 1.343 1.482 1.343s1.502-.578 1.502-1.343c0-.782-.652-1.36-1.502-1.36zM72.597 67c-1.502 0-2.708.612-3.597 1.479l1.304 1.02c.573-.51 1.206-.867 1.996-.867 1.008 0 1.601.544 1.601 1.326 0 1.513-3.004 2.482-2.589 4.947h2.036c-.257-2.176 2.806-2.924 2.806-5.083 0-1.853-1.482-2.822-3.557-2.822z",
        id: "prefix__c"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "prefix__b",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#prefix__a"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M63 46a7 7 0 017 7v7.24c.786-.16 1.6-.243 2.432-.243l.305.004c6.587.162 11.878 5.552 11.878 12.178l-.004.305c-.162 6.587-5.553 11.878-12.179 11.878l-.304-.003a12.136 12.136 0 01-7.944-3.215L60.229 84H37.62L24 74.764V53a7 7 0 017-7h32z",
        fill: themeValues.primaryColor,
        mask: "url(#prefix__b)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50 13c20.435 0 37 16.565 37 37 0 5.896-1.38 11.47-3.833 16.418A12.178 12.178 0 0072.737 60l-.305-.004c-1.708 0-3.334.352-4.81.987v-8.33a5.276 5.276 0 00-5.058-5.272l-.217-.004H31.653a5.276 5.276 0 00-5.271 5.058l-.004.217V59h24.14a1.5 1.5 0 01.145 2.993l-.144.007H26.377v8H46.52a1.5 1.5 0 01.145 2.993l-.145.007H26.377v1.453C32.494 80.363 40.822 84 50 84c4.997 0 9.742-1.078 14.015-3.014.823.787 1.757 1.46 2.775 1.993A36.835 36.835 0 0150 87c-20.435 0-37-16.565-37-37s16.565-37 37-37zm0 3c-18.778 0-34 15.222-34 34 0 1.699.125 3.368.365 5H23.5l.001-2.347a8.153 8.153 0 017.904-8.15l.25-.003 1.345-.001L33 34c0-7.732 6.268-14 14-14 7.628 0 13.83 6.1 13.997 13.687L61 34v10.499l1.347.001a8.153 8.153 0 018.15 7.904l.003.25V55H83c.216 0 .425.034.62.098.25-1.662.38-3.365.38-5.098 0-18.778-15.222-34-34-34zm-3 8c-5.43 0-9.848 4.327-9.996 9.72L37 34v10.499h20V34c0-5.523-4.477-10-10-10z",
        fill: themeValues.accentColor,
        mask: "url(#prefix__b)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: themeValues.subIconColor,
        xlinkHref: "#prefix__c"
    })));
};
var ForgotPasswordIcon$1 = themeComponent(ForgotPasswordIcon, "Icons", fallbackValues$b, "info");
var GoToEmailIcon = function GoToEmailIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, "Large Icons/Email - Go to"), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "prefix__a",
        d: "M0 0h100v100H0z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "prefix__b",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#prefix__a"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M75.21 27c1.474 0 4.14 3.11 7.994 9.332 0 0 1.162 4.471 1.618 10.353H60.557a1.94 1.94 0 00-1.073.322l-.114.08a1.99 1.99 0 00-.207.184l-.093.101a2.005 2.005 0 00-.484 1.313v.376c0 .251.045.492.129.713l.054.13c.06.129.13.25.214.361l.086.108a2 2 0 00.094.102l.101.096a1.977 1.977 0 00.38.263l.082.041.128.055c.13.05.268.088.411.11l.145.016.147.005H85a45.807 45.807 0 01-.256 5.057H60.557a1.95 1.95 0 00-1.394.586l-.093.101c-.03.036-.06.072-.087.109l-.08.115c-.2.313-.317.687-.317 1.089v.376c0 .251.045.491.129.712l.054.13a1.97 1.97 0 001.788 1.158h23.44c-.433 1.77-1.03 3.475-1.825 5.055H60.557c-.095 0-.187.007-.278.02l-.036.006-.118.023-.138.037a1.945 1.945 0 00-.43.19l-.073.047-.114.08a1.99 1.99 0 00-.207.184l-.093.101a2.006 2.006 0 00-.484 1.312v.378c0 .25.045.49.129.712l.054.13c.06.129.13.25.214.361l.086.108c.304.355.73.6 1.21.669l.13.014.148.006h18.938a37.834 37.834 0 01-4.285 5.056H60.556a1.95 1.95 0 00-1.393.586l-.093.101c-.03.036-.06.072-.087.109l-.08.115c-.2.313-.317.687-.317 1.088v.377a2.008 2.008 0 00.785 1.597l.112.08c.039.026.078.05.119.072l.124.065c.252.12.534.186.83.186h9.322c-9.313 6.286-18.815 6.622-19.679 6.64l-.064.001.108-16.602H14.497c-1.379 0-2.497-1.133-2.497-2.531V44.049c0-.105.006-.208.018-.31l.001-.417a.42.42 0 01.23-.38 2.506 2.506 0 011.8-1.385V38.22a.41.41 0 00-.401-.42h-.988a.411.411 0 01-.402-.418v-.895a.42.42 0 01.32-.407c.4-.096.752-.202 1.053-.317a5.652 5.652 0 001.01-.515.383.383 0 01.204-.06h1.37a.41.41 0 01.401.418v5.91h33.809L50.52 27z",
        fill: themeValues.primaryColor,
        mask: "url(#prefix__b)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50.295 13a36.365 36.365 0 0123.033 8.19C81.912 28.173 87 38.667 87 50c0 20.43-16.429 37-36.705 37-12.763 0-24.002-6.566-30.579-16.527h-5.043a3.704 3.704 0 01-3.695-3.513l-.005-.196V49.787A10.34 10.34 0 015 40.392C5 34.685 9.586 30.06 15.245 30.06c1.303 0 2.55.246 3.697.693C25.386 20.108 37.015 13 50.295 13zm31.459 23.331H51.423v4.044h1.776a3.704 3.704 0 013.694 3.514l.005.196v22.679a3.704 3.704 0 01-3.502 3.704l-.197.005-1.776-.001v14.069c18.196-.595 32.812-15.522 33.109-33.97l.004-.571c0-4.795-.973-9.429-2.782-13.669zM49.166 70.472l-26.46.001c6.027 8.259 15.607 13.713 26.46 14.068V70.472zm5.323-23.776L35.526 58.583a2.942 2.942 0 01-3.004.103l-.177-.103-13.552-8.494a10.22 10.22 0 01-5.413.466l.001 16.209c0 .69.513 1.25 1.16 1.317l.132.006h38.526c.664 0 1.218-.516 1.284-1.187l.007-.136V46.696zm-1.29-3.935H25.22a10.346 10.346 0 01-4 6.026l12.413 7.78c.177.11.345.126.52.047l.087-.047 20.236-12.682A1.303 1.303 0 0053.2 42.76zm-36.81-7.483h-1.368a.384.384 0 00-.204.06c-.328.209-.665.38-1.01.512-.3.115-.652.22-1.052.315a.417.417 0 00-.32.404v.89c0 .23.18.417.402.417h.987c.222 0 .402.185.402.416v4.238c0 .23-.18.416-.402.416h-1.226a.41.41 0 00-.402.416v1.302c0 .23.18.417.402.417h5.493a.41.41 0 00.402-.417v-1.302a.41.41 0 00-.402-.416h-.898a.41.41 0 01-.402-.416v-6.836c0-.229-.18-.416-.401-.416zm33.906-19.837c-12.34 0-23.16 6.59-29.186 16.477a10.346 10.346 0 014.38 8.457h23.677V26.169c0-.579.445-1.055 1.014-1.112l.115-.006h23.694a34.712 34.712 0 00-2.225-1.974 33.882 33.882 0 00-20.391-7.62l-.538-.012-.54-.004zm6.39 13.599a2.024 2.024 0 00-1.97 2.073 2.021 2.021 0 002.056 1.988 2.023 2.023 0 001.97-2.073 2.02 2.02 0 00-2.055-1.988zm7.023 0a2.023 2.023 0 00-1.971 2.073 2.021 2.021 0 002.056 1.988 2.023 2.023 0 001.97-2.073 2.02 2.02 0 00-2.055-1.988zm7.022 0a2.024 2.024 0 00-1.972 2.073 2.023 2.023 0 002.057 1.988 2.023 2.023 0 001.97-2.073 2.02 2.02 0 00-2.055-1.988z",
        fill: themeValues.accentColor,
        mask: "url(#prefix__b)"
    })));
};
var GoToEmailIcon$1 = themeComponent(GoToEmailIcon, "Icons", fallbackValues$b, "info");
var VerifiedEmailIcon = function VerifiedEmailIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "prefix__a",
        d: "M0 0h100v100H0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M58.462.577c6.37 0 11.533 5.164 11.533 11.533 0 6.37-5.163 11.534-11.533 11.534-1.146 0-2.253-.167-3.298-.479v21.598a3.347 3.347 0 01-3.348 3.348H6.87A34.073 34.073 0 01.192 27.799a34.073 34.073 0 014.26-16.55H46.96C47.4 5.281 52.382.577 58.46.577z",
        id: "prefix__c"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M61.716 33.11c0 6.728 5.454 12.184 12.182 12.184 6.728 0 12.183-5.456 12.183-12.183 0-6.728-5.455-12.182-12.183-12.182s-12.182 5.454-12.182 12.182zm17.206-4.604l1.436 1.436-7.178 7.179-1.436 1.435-4.307-4.307 1.436-1.435 2.87 2.87 7.18-7.178z",
        id: "prefix__d"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "prefix__b",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#prefix__a"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#prefix__b)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: themeValues.primaryColor,
        xlinkHref: "#prefix__c",
        transform: "translate(15.687 21.252)"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50.109 12.788a36.58 36.58 0 0124.135 9.041h-.095c-1.259 0-2.47.2-3.604.574a33.797 33.797 0 00-20.436-6.836c-11.968 0-22.49 6.19-28.538 15.544h41.265a11.59 11.59 0 00-.208 2.778H19.956a33.771 33.771 0 00-1.667 3.745l-.235.645.134.083 22.932 14.25c.315.196.639.217.956.065l.118-.065L64.09 39.007c.459.815 1.013 1.57 1.649 2.246L43.66 54.972c-1.19.739-2.604.776-3.817.11l-.19-.11-22.432-13.94a34 34 0 00-1.071 8.493 33.8 33.8 0 005.444 18.45l45.91-.001a1.958 1.958 0 001.953-1.813l.005-.146V43.903c.874.39 1.805.673 2.778.835v21.277a4.737 4.737 0 01-4.52 4.732l-.217.005H23.6c6.224 7.762 15.786 12.731 26.509 12.731 18.754 0 33.958-15.204 33.958-33.958 0-2.982-.387-5.901-1.126-8.698a11.537 11.537 0 001.93-3.208 36.737 36.737 0 011.974 11.906c0 20.289-16.448 36.736-36.736 36.736-20.29 0-36.738-16.447-36.738-36.736 0-20.29 16.448-36.737 36.738-36.737z",
        fill: themeValues.accentColor,
        fillRule: "nonzero",
        mask: "url(#prefix__b)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: themeValues.subIconColor,
        xlinkHref: "#prefix__d"
    })));
};
var VerifiedEmailIcon$1 = themeComponent(VerifiedEmailIcon, "Icons", fallbackValues$b, "info");
var PaymentMethodIcon = function PaymentMethodIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "a",
        d: "M0 0H100V100H0z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "b",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#a"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.primaryColor,
        d: "M91.744 23.436v36.051H50v13.52c0 .869-.665 1.581-1.513 1.654l-.142.006H23.098c-12.52-18.823-8.552-28.462-8.552-28.462h12.685v-22.77h64.513z",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.accentColor,
        fillRule: "nonzero",
        d: "M50 12.725l-.001.275.377.004a36.649 36.649 0 0122.522 8.137c.517.417 1.022.846 1.513 1.288h17.333c.519 0 .946.393 1 .897l.006.11v36.051c0 .52-.392.946-.897 1.001l-.11.006h-6.7C80.464 75.612 66.42 86.617 49.809 86.617c-12.773 0-24.027-6.506-30.628-16.384a36.74 36.74 0 01-1.671-2.656h-.266l-.001-.475a36.268 36.268 0 01-4.518-17.576c0-20.125 16.36-36.471 36.659-36.796l.616-.005zm32.496 47.769l-32.438-.001v12.515a2.66 2.66 0 01-2.482 2.66l-.167.006H27.41c5.945 5.002 13.617 8.066 22.013 8.2l.576.005-.001.308.278-.001c15.053-.201 27.771-10.077 32.22-23.692zm-34.452-1.956H16.546c.38 1.455.854 2.872 1.414 4.245h24.95v4.794H20.37c.065.108.13.216.197.323a34.607 34.607 0 004.647 5.76H47.41c.317 0 .583-.24.628-.556l.007-.096v-14.47zm-6.134 5.244H18.386c.426.955.893 1.887 1.4 2.794H41.91v-2.794zm48.826-39.34H28.237l-.001 20.756h19.173a2.657 2.657 0 012.644 2.499l.005.168V58.48l40.678.001V24.442zM67.18 48.726l.227.144c.832.548 3.055 2.145 2.967 2.087l-.017-.012.327.227c.429.294.821.55 1.197.782 1.432.882 2.54 1.326 3.24 1.278.647-.044 1.111-.13 1.577-.288l.2-.072c.22-.083 2.384-1.103 3.538-1.559 1.708-.675 3.21.02 4.406 1.48.492.6.832 1.194 1.018 1.612a.83.83 0 11-1.515.677l-.092-.185a6.632 6.632 0 00-.694-1.053c-.79-.963-1.612-1.343-2.513-.987l-.306.124c-1.143.475-2.982 1.34-3.252 1.442-.694.264-1.356.404-2.254.465-1.15.079-2.513-.467-4.224-1.52-.4-.247-.813-.518-1.262-.826l-.502-.353c-.543-.391-2.195-1.572-2.768-1.945l-.137-.086c-1.814-1.063-4.339 1.324-6.108 4.95a.83.83 0 11-1.492-.728c2.172-4.451 5.356-7.46 8.44-5.654zM15.53 47.161l-.036.523a34.912 34.912 0 00-.003 4.214l32.554-.001v-4.032c0-.33-.237-.6-.542-.646l-.093-.007H15.846c-.11 0-.217-.018-.317-.051zm.205-1.957h.002l.11-.006h10.377V24.793c-5.594 5.277-9.418 12.408-10.49 20.411zM84.248 28.18v1.61c1.291.235 2.394.705 3.347 1.404l-1.808 2.331c-1.193-.783-2.497-1.174-3.652-1.174-.876 0-1.305.323-1.305.766v.034c0 .544.448.782 2.274 1.157 2.981.595 4.845 1.48 4.845 3.709v.034c0 2.002-1.43 3.335-3.701 3.744v1.565h-3.442v-1.586c-1.598-.263-3.068-.868-4.242-1.817l2.012-2.195c1.304.935 2.72 1.43 4.229 1.43.988 0 1.51-.308 1.51-.818v-.034c0-.51-.429-.766-2.217-1.157-2.777-.578-4.92-1.293-4.92-3.727v-.033c0-1.852 1.35-3.272 3.628-3.686V28.18h3.442zm-25.71 11.978a.83.83 0 01.105 1.654l-.105.006H31.026a.83.83 0 01-.104-1.653l.104-.007h27.512zm-11.384-5.692a.83.83 0 01.104 1.653l-.104.007H31.026a.83.83 0 01-.104-1.654l.104-.006h16.128zm10.436-5.692a.83.83 0 01.104 1.653l-.104.006H45.256a.83.83 0 01-.104-1.653l.104-.006H57.59zm-16.128 0a.83.83 0 01.104 1.653l-.104.006H31.026a.83.83 0 01-.104-1.653l.104-.006h10.436zm8.347-13.345a34.23 34.23 0 00-20.796 7l41.593.001a34.223 34.223 0 00-20.797-7z",
        mask: "url(#b)"
    })));
};
var PaymentMethodIcon$1 = themeComponent(PaymentMethodIcon, "Icons", fallbackValues$b, "info");
// When ariaHidden is true, aria-hidden="true" is added to the SVG, which tells
// screen readers to skip this element. Use this when the icon is purely decorative
// and adjacent text already conveys its meaning (e.g. an icon inside a labeled nav link).
var AccountsIconSmall = function AccountsIconSmall(_ref) {
    var themeValues = _ref.themeValues, _ref$ariaHidden = _ref.ariaHidden, ariaHidden = _ref$ariaHidden === void 0 ? true : _ref$ariaHidden;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "22px",
        height: "22px",
        viewBox: "1 0 22 25",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            display: "inline-block",
            verticalAlign: "text-bottom"
        },
        "aria-hidden": ariaHidden ? "true" : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        id: "path-1-accountssmall",
        x: "0",
        y: "0",
        width: "29",
        height: "27"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask-2-accountssmall",
        fill: "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#path-1-accountssmall"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M1.875,17.9609424 L4.30077547,13.8125148 C4.60546242,13.2968908 5.01561733,12.8867359 5.53124128,12.5820489 C6.04686523,12.277362 6.60936389,12.1250188 7.21873726,12.1250188 L7.21873726,12.1250188 L18.7499598,12.1250188 L18.7499598,10.4375228 C18.7499598,9.9687741 18.5858975,9.57033719 18.2577734,9.24221315 C17.9296494,8.91408911 17.5312125,8.75002682 17.0624638,8.75002682 L17.0624638,8.75002682 L11.4374772,8.75002682 L9.18748257,6.50003219 L3.56249598,6.50003219 C3.09374727,6.50003219 2.69531037,6.66409447 2.36718633,6.99221851 C2.03906229,7.32034255 1.875,7.71877946 1.875,8.18752816 L1.875,8.18752816 L1.875,17.9609424 Z M17.519494,20 C17.9179303,20 18.2929296,19.900391 18.6444913,19.7011726 C18.9960529,19.5019541 19.2655837,19.2265643 19.4530831,18.8750027 L19.4530831,18.8750027 L22.0194832,14.5156381 C22.1835455,14.2343887 22.1835455,13.9531394 22.0194832,13.6718901 C21.8554209,13.3906408 21.6093278,13.2500161 21.2812037,13.2500161 L21.2812037,13.2500161 L7.21873726,13.2500161 C6.82030089,13.2500161 6.4453016,13.3496251 6.09373994,13.5488435 C5.74217828,13.748062 5.47264749,14.0234517 5.28514812,14.3750134 L5.28514812,14.3750134 L2.71874799,18.734378 C2.5546857,19.0156273 2.5546857,19.2968767 2.71874799,19.578126 C2.88281028,19.8593753 3.12890344,20 3.45702748,20 L3.45702748,20 L17.519494,20 Z",
        fill: themeValues.singleIconColor,
        fillRule: "nonzero",
        mask: "url(#mask-2-accountssmall)"
    }))))))));
};
var AccountsIconSmall$1 = themeComponent(AccountsIconSmall, "Icons", fallbackValues$b, "primary");
var PaymentsIconSmall = function PaymentsIconSmall(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20px",
        height: "22px",
        viewBox: "0 0 20 22",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            display: "inline-block",
            verticalAlign: "text-bottom"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        id: "path-1-paymentssmall",
        x: "0",
        y: "0",
        width: "29",
        height: "27"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Random-Icon-Work",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Header/Desktop/Menu"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Header/Desktop/Menu/Payments-Tab"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Payments"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "file-invoice"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask-2-paymentssmall",
        fill: "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#path-1-paymentssmall"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Mask-paymentssmall"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M18.7499678,8.75002682 L18.7499678,8.53908983 C18.7499678,8.3047152 18.6679369,8.10549729 18.5038747,7.941435 L18.5038747,7.941435 L15.0585704,4.49613071 C14.8945081,4.33206843 14.6952902,4.25003755 14.4609155,4.25003755 L14.4609155,4.25003755 L14.2499785,4.25003755 L14.2499785,8.75002682 L18.7499678,8.75002682 Z M17.9062198,22.2499946 C18.1405944,22.2499946 18.3398124,22.1679638 18.5038747,22.0039015 C18.6679369,21.8398392 18.7499678,21.6406213 18.7499678,21.4062466 L18.7499678,21.4062466 L18.7499678,9.87502414 L13.9687292,9.87502414 C13.7343546,9.87502414 13.5351367,9.79299326 13.3710744,9.62893098 C13.2070121,9.46486869 13.1249812,9.26565077 13.1249812,9.03127615 L13.1249812,9.03127615 L13.1249812,4.25003755 L6.09374799,4.25003755 C5.85937337,4.25003755 5.66015545,4.33206843 5.49609316,4.49613071 C5.33203088,4.660193 5.25,4.85941092 5.25,5.09378554 L5.25,5.09378554 L5.25,21.4062466 C5.25,21.6406213 5.33203088,21.8398392 5.49609316,22.0039015 C5.66015545,22.1679638 5.85937337,22.2499946 6.09374799,22.2499946 L6.09374799,22.2499946 L17.9062198,22.2499946 Z M10.5937373,7.6250295 L7.78124397,7.6250295 C7.71093163,7.6250295 7.64647884,7.59573288 7.58788505,7.53713909 C7.52929126,7.4785453 7.49999464,7.41409251 7.49999464,7.34378017 L7.49999464,7.34378017 L7.49999464,6.78128152 C7.49999464,6.71096918 7.52929126,6.64651639 7.58788505,6.5879226 C7.64647884,6.52932881 7.71093163,6.50003219 7.78124397,6.50003219 L7.78124397,6.50003219 L10.5937373,6.50003219 C10.6640496,6.50003219 10.7285024,6.52932881 10.7870962,6.5879226 C10.84569,6.64651639 10.8749866,6.71096918 10.8749866,6.78128152 L10.8749866,6.78128152 L10.8749866,7.34378017 C10.8749866,7.41409251 10.84569,7.4785453 10.7870962,7.53713909 C10.7285024,7.59573288 10.6640496,7.6250295 10.5937373,7.6250295 L10.5937373,7.6250295 Z M10.5937373,9.87502414 L7.78124397,9.87502414 C7.71093163,9.87502414 7.64647884,9.84572751 7.58788505,9.78713372 C7.52929126,9.72853994 7.49999464,9.66408714 7.49999464,9.59377481 L7.49999464,9.59377481 L7.49999464,9.03127615 C7.49999464,8.96096382 7.52929126,8.89651103 7.58788505,8.83791724 C7.64647884,8.77932345 7.71093163,8.75002682 7.78124397,8.75002682 L7.78124397,8.75002682 L10.5937373,8.75002682 C10.6640496,8.75002682 10.7285024,8.77932345 10.7870962,8.83791724 C10.84569,8.89651103 10.8749866,8.96096382 10.8749866,9.03127615 L10.8749866,9.03127615 L10.8749866,9.59377481 C10.8749866,9.66408714 10.84569,9.72853994 10.7870962,9.78713372 C10.7285024,9.84572751 10.6640496,9.87502414 10.5937373,9.87502414 L10.5937373,9.87502414 Z M15.9374745,16.625008 L8.06249329,16.625008 C7.89843101,16.625008 7.76366588,16.5722738 7.65819738,16.4668053 C7.55272888,16.3613368 7.49999464,16.2265717 7.49999464,16.0625094 L7.49999464,16.0625094 L7.49999464,12.6875174 C7.49999464,12.5234551 7.55272888,12.38869 7.65819738,12.2832215 C7.76366588,12.177753 7.89843101,12.1250188 8.06249329,12.1250188 L8.06249329,12.1250188 L15.9374745,12.1250188 C16.1015368,12.1250188 16.2363019,12.177753 16.3417704,12.2832215 C16.4472389,12.38869 16.4999732,12.5234551 16.4999732,12.6875174 L16.4999732,12.6875174 L16.4999732,16.0625094 C16.4999732,16.2265717 16.4472389,16.3613368 16.3417704,16.4668053 C16.2363019,16.5722738 16.1015368,16.625008 15.9374745,16.625008 L15.9374745,16.625008 Z M15.3749759,15.5000107 L15.3749759,13.2500161 L8.62499195,13.2500161 L8.62499195,15.5000107 L15.3749759,15.5000107 Z M16.2187238,20 L13.4062306,20 C13.3359182,20 13.2714654,19.9707034 13.2128716,19.9121096 C13.1542779,19.8535158 13.1249812,19.789063 13.1249812,19.7187507 L13.1249812,19.7187507 L13.1249812,19.156252 C13.1249812,19.0859397 13.1542779,19.0214869 13.2128716,18.9628931 C13.2714654,18.9042993 13.3359182,18.8750027 13.4062306,18.8750027 L13.4062306,18.8750027 L16.2187238,18.8750027 C16.2890362,18.8750027 16.353489,18.9042993 16.4120828,18.9628931 C16.4706766,19.0214869 16.4999732,19.0859397 16.4999732,19.156252 L16.4999732,19.156252 L16.4999732,19.7187507 C16.4999732,19.789063 16.4706766,19.8535158 16.4120828,19.9121096 C16.353489,19.9707034 16.2890362,20 16.2187238,20 L16.2187238,20 Z",
        id: "f",
        fill: themeValues.singleIconColor,
        fillRule: "nonzero",
        mask: "url(#mask-2-paymentssmall)"
    }))))))));
};
var PaymentsIconSmall$1 = themeComponent(PaymentsIconSmall, "Icons", fallbackValues$b, "primary");
var PaymentMethodAddIcon = function PaymentMethodAddIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "path-1-payment-method-add",
        d: "M0 0H103V100H0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "path-3-payment-method-add",
        d: "M16.624999 11.3749994L11.3749994 11.3749994 11.3749994 16.624999 9.62499952 16.624999 9.62499952 11.3749994 4.37499993 11.3749994 4.37499993 9.62499952 9.62499952 9.62499952 9.62499952 4.37499993 11.3749994 4.37499993 11.3749994 9.62499952 16.624999 9.62499952z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1",
        transform: "translate(-1)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask-2-payment-method-add",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#path-1-payment-method-add"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask-2-payment-method-add)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(11.33 11)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.primaryColor,
        fillRule: "evenodd",
        d: "M85.49 9v38H40.17v16.251c0 .918-.726 1.67-1.65 1.743l-.147.006h-27.41c-1.966-2.87-3.557-5.537-4.842-8H31.93v-4H5.15v2.055C-1.194 41.772 1.678 35 1.678 35H15.45V9h70.04z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.accentColor,
        fillRule: "nonzero",
        d: "M39.963 0c8.67 0 16.925 2.695 23.741 7.603l.461.336H85.49c.547 0 .997.414 1.055.945l.006.116v38c0 .547-.414.997-.945 1.055l-.116.006h-6.75l-.01.04c-4.35 17.186-20.282 29.496-38.767 29.496C17.92 77.597.038 60.235.038 38.799c0-11.976 5.58-22.68 14.35-29.795V9c0-.547.415-.997.946-1.055l.116-.006h.31c6.716-4.981 15.105-7.94 24.203-7.94zM76.095 48.06H40.201v15.19c0 1.5-1.185 2.717-2.672 2.805l-.172.005H15.346c6.573 5.588 15.185 8.976 24.617 8.976 17.105 0 31.859-11.237 36.132-26.976zM13.053 63.94l24.304-.001c.37 0 .668-.263.715-.595l.007-.093L38.078 48H3.813c1.642 6.084 4.874 11.545 9.24 15.94zM84.428 10.06H17.197c-.231.172-.46.347-.687.524l.001 23.354h20.846c1.508 0 2.75 1.163 2.84 2.64l.004.17v9.19l44.227-.001V10.061zm-25.629 25.59l.226.14.334.217.869.584 2.017 1.396c.608.413 1.147.76 1.657 1.066 1.562.934 2.772 1.404 3.545 1.353.706-.047 1.215-.139 1.724-.306l.257-.092 2.175-.952.957-.407.352-.143.32-.126c1.831-.702 3.446.022 4.737 1.553.534.632.903 1.26 1.106 1.7a.875.875 0 01-1.538.828l-.15-.29-.113-.198a6.64 6.64 0 00-.642-.912c-.863-1.023-1.773-1.432-2.774-1.048l-.456.182-.798.335-2.562 1.116-.046.018c-.749.277-1.463.424-2.434.487-1.234.082-2.708-.49-4.558-1.597-.433-.259-.882-.545-1.369-.869l-2.409-1.66-.857-.577-.377-.243a2.382 2.382 0 00-.057-.034c-2.004-1.14-4.756 1.386-6.683 5.22a.875.875 0 11-1.564-.785c.088-.173.176-.344.266-.513l.275-.5c.464-.821.962-1.582 1.488-2.258l.318-.396c2.035-2.442 4.432-3.615 6.764-2.288zm-56.09.34l-.032.426A35.67 35.67 0 002.666 41L38.078 41v-4.25a.701.701 0 00-.623-.682l-.098-.007H3.09c-.134 0-.263-.025-.381-.07zm.22-2.04l.045-.006.116-.006h11.298V12.377C8.276 17.947 4.097 25.487 2.93 33.952zM77.352 14v1.697c1.402.247 2.599.742 3.634 1.48l-1.963 2.457c-1.295-.826-2.71-1.238-3.965-1.238-.95 0-1.417.34-1.417.807v.036c0 .574.487.824 2.47 1.22 3.236.627 5.259 1.56 5.259 3.91v.035c0 2.11-1.551 3.515-4.018 3.947V30h-3.737v-1.671c-1.735-.278-3.33-.916-4.605-1.916l2.184-2.314c1.416.986 2.954 1.507 4.592 1.507 1.072 0 1.639-.324 1.639-.862v-.035c0-.538-.465-.808-2.407-1.22-3.015-.61-5.341-1.363-5.341-3.928v-.035c0-1.953 1.466-3.45 3.938-3.885V14h3.737zM49.44 26.625a.875.875 0 01.11 1.743l-.11.007H19.57a.875.875 0 01-.11-1.743l.11-.007h29.87zm-12.36-6a.875.875 0 01.11 1.743l-.11.007H19.57a.875.875 0 01-.11-1.743l.11-.007h17.51zm11.33-6a.875.875 0 01.11 1.743l-.11.007H35.02a.875.875 0 01-.11-1.743l.11-.007h13.39zm-17.51 0a.875.875 0 01.11 1.743l-.11.007H19.57a.875.875 0 01-.11-1.743l.11-.007H30.9zM39.963 2.56c-7.19 0-13.902 1.969-19.599 5.38h39.197c-5.824-3.489-12.562-5.38-19.598-5.38z"
    })))), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(59 61)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "13.3",
        cy: "13.3",
        r: "13.3",
        fill: themeValues.subIconColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(2.8 2.8)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask-4-payment-method-add",
        fill: "#fff"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#path-3-payment-method-add"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#000",
        xlinkHref: "#path-3-payment-method-add"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: themeValues.primaryColor,
        mask: "url(#mask-4-payment-method-add)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 0H21V21H0z"
    })))))));
};
var PaymentMethodAddIcon$1 = themeComponent(PaymentMethodAddIcon, "Icons", fallbackValues$b, "info");
var ProfileIconSmall = function ProfileIconSmall(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "31px",
        height: "31px",
        viewBox: "0 0 31 31",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Random-Icon-Work",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Header/Desktop/Menu",
        fill: themeValues.singleIconColor,
        fillRule: "nonzero"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "My-profile"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15.0155892,30.3906169 C17.7200101,30.3906169 20.222608,29.7145114 22.5233838,28.3623014 C24.8241596,27.0100914 26.6506529,25.1835981 28.0028629,22.8828223 C29.3550729,20.5820466 30.0311784,18.0794487 30.0311784,15.3750277 C30.0311784,12.6706068 29.3550729,10.1680089 28.0028629,7.86723312 C26.6506529,5.56645735 24.8241596,3.739964 22.5233838,2.38775399 C20.222608,1.03554398 17.7200101,0.359438516 15.0155892,0.359438516 C12.3111683,0.359438516 9.80857036,1.03554398 7.5077946,2.38775399 C5.20701884,3.739964 3.38052549,5.56645735 2.02831548,7.86723312 C0.676105467,10.1680089 0,12.6706068 0,15.3750277 C0,18.0794487 0.676105467,20.5820466 2.02831548,22.8828223 C3.38052549,25.1835981 5.20701884,27.0100914 7.5077946,28.3623014 C9.80857036,29.7145114 12.3111683,30.3906169 15.0155892,30.3906169 Z M15.0155892,16.8281493 C13.5624677,16.8281493 12.3111683,16.3034106 11.2616919,15.2539343 C10.2122155,14.2044579 9.6874769,12.9531585 9.6874769,11.500037 C9.6874769,10.0469154 10.2122155,8.79561601 11.2616919,7.74613965 C12.3111683,6.6966633 13.5624677,6.17192466 15.0155892,6.17192466 C16.4687107,6.17192466 17.7200101,6.6966633 18.7694865,7.74613965 C19.8189629,8.79561601 20.3437015,10.0469154 20.3437015,11.500037 C20.3437015,12.9531585 19.8189629,14.2044579 18.7694865,15.2539343 C17.7200101,16.3034106 16.4687107,16.8281493 15.0155892,16.8281493 Z M15.0155892,27 C13.2799159,27 11.6350637,26.6367196 10.0810307,25.9101588 C8.52699759,25.1835981 7.20506095,24.1744856 6.1152198,22.8828223 C6.7206871,21.7929812 7.5481594,20.9150536 8.59763575,20.2490395 C9.64711211,19.5830255 10.8176828,19.2500185 12.1093461,19.2500185 C12.2304396,19.2500185 12.371715,19.2702004 12.5331732,19.3105652 C13.3808275,19.5931169 14.2082998,19.7343923 15.0155892,19.7343923 C15.8228786,19.7343923 16.6503509,19.5931169 17.4980052,19.3105652 C17.6594634,19.2702004 17.8007388,19.2500185 17.9218323,19.2500185 C19.2134956,19.2500185 20.3840663,19.5830255 21.4335426,20.2490395 C22.483019,20.9150536 23.3104913,21.7929812 23.9159586,22.8828223 C22.8261175,24.1744856 21.5041808,25.1835981 19.9501477,25.9101588 C18.3961147,26.6367196 16.7512625,27 15.0155892,27 Z",
        id: "user-circle"
    })))));
};
var ProfileIconSmall$1 = themeComponent(ProfileIconSmall, "Icons", fallbackValues$b, "primary");
// When ariaHidden is true, aria-hidden="true" is added to the SVG, which tells
// screen readers to skip this element. Use this when the icon is purely decorative
// and adjacent text already conveys its meaning (e.g. an icon inside a labeled nav link).
var SettingsIconSmall = function SettingsIconSmall(_ref) {
    var themeValues = _ref.themeValues, _ref$ariaHidden = _ref.ariaHidden, ariaHidden = _ref$ariaHidden === void 0 ? true : _ref$ariaHidden;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "22px",
        height: "22px",
        viewBox: "0 2 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            display: "inline-block",
            verticalAlign: "text-bottom"
        },
        "aria-hidden": ariaHidden ? "true" : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        id: "path-1-paymentssmall",
        x: "0",
        y: "0",
        width: "29",
        height: "27"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Random-Icon-Work",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Header/Desktop/Menu"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Header/Desktop/Menu/Settings-Tab"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Payments"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "cog"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask-2-paymentssmall",
        fill: "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#path-1-paymentssmall"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Mask"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M13.9335677,21.7578083 C14.0273176,21.7343707 14.103489,21.6816364 14.1620828,21.5996056 C14.2206766,21.5175747 14.2499732,21.4296843 14.2499732,21.3359343 L14.2499732,19.6132822 C15.0468465,19.3320328 15.7616883,18.9218774 16.3944993,18.3828164 L17.8710583,19.2617205 C17.9648082,19.3085952 18.0585577,19.3203143 18.1523076,19.2968767 C18.2460576,19.2734391 18.3280885,19.2265643 18.3984008,19.156252 C19.2890235,18.195317 19.9335536,17.0937568 20.3319899,15.8515724 C20.3554276,15.7578224 20.349568,15.664073 20.3144118,15.5703231 C20.2792557,15.4765731 20.2148029,15.4062608 20.1210529,15.3593861 L18.644494,14.4804819 C18.7851186,13.6601715 18.7851186,12.8398606 18.644494,12.0195503 L20.1210529,11.1406461 C20.2148029,11.0937714 20.2792557,11.0234591 20.3144118,10.9297091 C20.349568,10.8359592 20.3554276,10.7422098 20.3319899,10.6484598 C19.9335536,9.40627544 19.2890235,8.3047152 18.3984008,7.34378017 C18.3280885,7.27346784 18.2460576,7.22659313 18.1523076,7.20315551 C18.0585577,7.17971789 17.9648082,7.19143697 17.8710583,7.23831168 L16.3944993,8.11721583 C15.7616883,7.57815479 15.0468465,7.16799934 14.2499732,6.88675001 L14.2499732,5.16409787 C14.2499732,5.07034792 14.2206766,4.9824575 14.1620828,4.90042663 C14.103489,4.81839575 14.0273176,4.7656615 13.9335677,4.74222388 C12.6445081,4.46097455 11.355449,4.46097455 10.0663894,4.74222388 C9.97263945,4.7656615 9.89646811,4.81839575 9.83787432,4.90042663 C9.77928053,4.9824575 9.74998391,5.07034792 9.74998391,5.16409787 L9.74998391,6.88675001 C8.95311063,7.16799934 8.23826876,7.57815479 7.60545777,8.11721583 L6.12889879,7.23831168 C6.03514883,7.19143697 5.94139942,7.17971789 5.84764946,7.20315551 C5.75389951,7.22659313 5.67186863,7.27346784 5.6015563,7.34378017 C4.7109336,8.3047152 4.06640353,9.40627544 3.66796716,10.6484598 C3.64452953,10.7422098 3.65038907,10.8359592 3.68554524,10.9297091 C3.72070141,11.0234591 3.7851542,11.0937714 3.87890415,11.1406461 L5.35546313,12.0195503 C5.21483847,12.8398606 5.21483847,13.6601715 5.35546313,14.4804819 L3.87890415,15.3593861 C3.7851542,15.4062608 3.72070141,15.4765731 3.68554524,15.5703231 C3.65038907,15.664073 3.64452953,15.7578224 3.66796716,15.8515724 C4.06640353,17.0937568 4.7109336,18.195317 5.6015563,19.156252 C5.67186863,19.2265643 5.75389951,19.2734391 5.84764946,19.2968767 C5.94139942,19.3203143 6.03514883,19.3085952 6.12889879,19.2617205 L7.60545777,18.3828164 C8.23826876,18.9218774 8.95311063,19.3320328 9.74998391,19.6132822 L9.74998391,21.3359343 C9.74998391,21.4296843 9.77928053,21.5175747 9.83787432,21.5996056 C9.89646811,21.6816364 9.97263945,21.7343707 10.0663894,21.7578083 C11.355449,22.0390576 12.6445081,22.0390576 13.9335677,21.7578083 Z M11.9999785,16.0625094 C11.2265429,16.0625094 10.5644353,15.7871196 10.0136552,15.2363395 C9.46287504,14.6855594 9.18748525,14.0234517 9.18748525,13.2500161 C9.18748525,12.4765804 9.46287504,11.8144728 10.0136552,11.2636927 C10.5644353,10.7129126 11.2265429,10.4375228 11.9999785,10.4375228 C12.7734142,10.4375228 13.4355218,10.7129126 13.9863019,11.2636927 C14.537082,11.8144728 14.8124718,12.4765804 14.8124718,13.2500161 C14.8124718,14.0234517 14.537082,14.6855594 13.9863019,15.2363395 C13.4355218,15.7871196 12.7734142,16.0625094 11.9999785,16.0625094 Z",
        id: "c",
        fill: themeValues.singleIconColor,
        fillRule: "nonzero",
        mask: "url(#mask-2-paymentssmall)"
    }))))))));
};
var SettingsIconSmall$1 = themeComponent(SettingsIconSmall, "Icons", fallbackValues$b, "primary");
// When ariaHidden is true, aria-hidden="true" is added to the SVG, which tells
// screen readers to skip this element. Use this when the icon is purely decorative
// and adjacent text already conveys its meaning (e.g. an icon inside a labeled nav link).
var WalletIconSmall = function WalletIconSmall(_ref) {
    var themeValues = _ref.themeValues, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex, colorOverride = _ref.colorOverride, _ref$ariaHidden = _ref.ariaHidden, ariaHidden = _ref$ariaHidden === void 0 ? true : _ref$ariaHidden;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": ariaHidden ? "true" : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3125 6.94643C16.0446 6.70536 15.7232 6.57143 15.3482 6.57143L5.14283 6.57143C5.0089 6.57143 4.90176 6.54464 4.8214 6.46429C4.74104 6.38393 4.71426 6.27678 4.71426 6.14286C4.71426 6.03571 4.74104 5.92857 4.8214 5.84821C4.90176 5.76786 5.0089 5.71428 5.14283 5.71428L15.4285 5.71428C15.5357 5.71428 15.6428 5.6875 15.7232 5.60714C15.8035 5.52678 15.8571 5.41964 15.8571 5.28571C15.8571 4.9375 15.7232 4.64286 15.4821 4.375C15.2143 4.13393 14.9196 4 14.5714 4L4.71426 4C4.23211 4 3.80354 4.1875 3.48211 4.50893C3.16068 4.83036 2.99997 5.23214 2.99997 5.71428V14.2857C2.99997 14.7679 3.16068 15.1964 3.48211 15.5179C3.80354 15.8393 4.23211 16 4.71426 16L15.3482 16C15.7232 16 16.0446 15.8929 16.3125 15.625C16.5803 15.3839 16.7143 15.0893 16.7143 14.7143V7.85714C16.7143 7.50893 16.5803 7.21428 16.3125 6.94643ZM12.7142 13.143C13.661 13.143 14.4285 12.3755 14.4285 11.4288C14.4285 10.482 13.661 9.71447 12.7142 9.71447C11.7674 9.71447 10.9999 10.482 10.9999 11.4288C10.9999 12.3755 11.7674 13.143 12.7142 13.143Z",
        fill: colorOverride || themeValues.singleIconColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_503_574-".concat(iconIndex),
        style: {
            maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "4",
        width: "14",
        height: "12"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3125 6.94643C16.0446 6.70536 15.7232 6.57143 15.3482 6.57143L5.14283 6.57143C5.0089 6.57143 4.90176 6.54464 4.8214 6.46429C4.74104 6.38393 4.71426 6.27678 4.71426 6.14286C4.71426 6.03571 4.74104 5.92857 4.8214 5.84821C4.90176 5.76786 5.0089 5.71428 5.14283 5.71428L15.4285 5.71428C15.5357 5.71428 15.6428 5.6875 15.7232 5.60714C15.8035 5.52678 15.8571 5.41964 15.8571 5.28571C15.8571 4.9375 15.7232 4.64286 15.4821 4.375C15.2143 4.13393 14.9196 4 14.5714 4L4.71426 4C4.23211 4 3.80354 4.1875 3.48211 4.50893C3.16068 4.83036 2.99997 5.23214 2.99997 5.71428V14.2857C2.99997 14.7679 3.16068 15.1964 3.48211 15.5179C3.80354 15.8393 4.23211 16 4.71426 16L15.3482 16C15.7232 16 16.0446 15.8929 16.3125 15.625C16.5803 15.3839 16.7143 15.0893 16.7143 14.7143V7.85714C16.7143 7.50893 16.5803 7.21428 16.3125 6.94643ZM12.7142 13.143C13.661 13.143 14.4285 12.3755 14.4285 11.4288C14.4285 10.482 13.661 9.71447 12.7142 9.71447C11.7674 9.71447 10.9999 10.482 10.9999 11.4288C10.9999 12.3755 11.7674 13.143 12.7142 13.143Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_503_574-".concat(iconIndex, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "20",
        height: "20",
        fill: colorOverride || themeValues.singleIconColor
    })));
};
var WalletIconSmall$1 = themeComponent(WalletIconSmall, "Icons", fallbackValues$b, "primary");
var ChevronIcon = function ChevronIcon(_ref) {
    var themeValues = _ref.themeValues, iconFill = _ref.iconFill;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            display: "inline-block",
            verticalAlign: "text-bottom"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        id: "icon-chevron-path-1",
        points: "10.4099998 6 9 7.40999976 13.5799996 11.9999996 9 16.5899995 10.4099998 17.9999993 16.4099994 11.9999996"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "icon-chevron-Icon/Chevron-Down",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "icon-chevron-mask-2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: iconFill !== null && iconFill !== void 0 ? iconFill : themeValues.singleIconColor,
        xlinkHref: "#icon-chevron-path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: iconFill !== null && iconFill !== void 0 ? iconFill : themeValues.singleIconColor,
        id: "icon-chevron-Fill-2",
        xlinkHref: "#icon-chevron-path-1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Colors/Blue-Dark",
        mask: "url(#icon-chevron-mask-2)",
        fill: iconFill !== null && iconFill !== void 0 ? iconFill : themeValues.singleIconColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        id: "icon-chevron-rect",
        width: "24",
        height: "24"
    }))));
};
var ChevronIcon$1 = themeComponent(ChevronIcon, "Icons", fallbackValues$b, "secondary");
var PropertiesAddIcon = function PropertiesAddIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: 100,
        height: 100,
        viewBox: "0 0 84 100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, "8330C897-662E-49C5-B716-3661563AA1FB@1.00x"), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "prefix__a",
        d: "M0 0h100v100H0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "prefix__c",
        d: "M.926.555h81v83h-81z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "prefix__e",
        d: "M16.625 11.375h-5.25v5.25h-1.75v-5.25h-5.25v-1.75h5.25v-5.25h1.75v5.25h5.25z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-10 -5)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "prefix__b",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#prefix__a"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#prefix__b)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M81.262 37.752a.51.51 0 01-.51.511h-19.62a.51.51 0 01-.51-.51v-1.078a.51.51 0 01.51-.51h19.62a.51.51 0 01.51.51v1.077zM72.078 49.1v-9.016c0-.54.437-.976.976-.976h6.234c.54 0 .976.436.976.976v8.126c0 .54-.437.977-.976.977h-7.124a.086.086 0 01-.086-.087zm7.35 1.954c.461 0 .836.375.836.837v8.405a.836.836 0 01-.836.836h-6.514a.836.836 0 01-.836-.836v-9.242h7.35zM61.652 48.29v-8.287c0-.495.4-.896.896-.896h6.393c.496 0 .896.4.896.896v9.176c0 .004-.003.007-.005.007h-7.284a.896.896 0 01-.896-.896zm.992 2.763h7.091c.056 0 .102.046.102.103v8.983a.992.992 0 01-.991.992h-6.202a.992.992 0 01-.992-.992v-8.093c0-.549.444-.993.992-.993zm18.618 12.792a.512.512 0 01-.51.512h-19.62a.51.51 0 01-.51-.512v-1.077a.51.51 0 01.51-.51h19.62a.51.51 0 01.51.51v1.077zm-17.345-46.17l-1.864-1.252-21.399 14.39v42.63h3.388V36.798c0-.351.285-.635.635-.635h12.69c.35 0 .635.284.635.635v36.643H78.22a34.494 34.494 0 005.243-8.285V30.81L63.917 17.676zm-17.755-4.948v5.888l4.626-3.141V8.283h-4.626v4.444zm42.13 15.646l-25.076-16.85a2.098 2.098 0 00-2.328 0L40.8 25.02l-4.96 3.333a.439.439 0 00-.12.61l.839 1.262a.443.443 0 00.614.122l1.079-.725 23.8-15.99 24.91 16.735a.406.406 0 00.565-.113l.878-1.32a.405.405 0 00-.112-.561zm-50.04 31.33v13.739h-9.527c-.094-.06-.18-.132-.269-.198a5.425 5.425 0 01-.398-.33c-.082-.075-.166-.149-.244-.23a5.18 5.18 0 01-.478-.58c-.054-.075-.1-.154-.15-.231a4.874 4.874 0 01-.319-.589c-.027-.058-.058-.113-.082-.17a4.912 4.912 0 01-.253-.812c-.015-.07-.028-.14-.041-.21a5.032 5.032 0 01-.092-.909c.001-3.173 2.94-5.695 6.217-4.953a.957.957 0 001.055-.465c.186-.33.398-.641.619-.943.048-.064.096-.13.145-.193.223-.287.458-.562.711-.82.042-.042.085-.08.128-.121.234-.23.48-.45.736-.653l.15-.12c.283-.217.58-.416.887-.6.066-.04.134-.076.201-.115.307-.173.621-.334.946-.473.015-.006.028-.014.044-.02a.08.08 0 00.014-.004zm9.815-4.466a1.377 1.377 0 010 2.752 1.376 1.376 0 010-2.752z",
        fill: "#FFF"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(8.862 5.41)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "prefix__d",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#prefix__c"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M34.984 4.96v2.655C17.308 10.446 3.759 25.799 3.759 44.259a36.997 36.997 0 008.639 23.773 37.648 37.648 0 002.19 2.402c6.724 6.755 16.027 10.943 26.29 10.943 10.263 0 19.565-4.188 26.29-10.943a37.226 37.226 0 007.433-10.697 36.887 36.887 0 002.403-6.984c.642-2.73.992-5.571.992-8.494a37.36 37.36 0 00-.983-8.532l-.008-5-.001-.512v-2.398c.034.074.573 1.154.59 1.196a39.725 39.725 0 013.023 15.246c0 5.895-1.3 11.489-3.613 16.525a39.357 39.357 0 01-2.402 4.461 40.194 40.194 0 01-1.898 2.787 40.05 40.05 0 01-1.962 2.402c-7.29 8.306-17.971 13.564-29.864 13.564-21.913 0-39.74-17.827-39.74-39.739 0-19.91 14.718-36.443 33.846-39.3zm36.905 51.887a.51.51 0 01.51.51v1.079a.51.51 0 01-.51.51H52.271a.51.51 0 01-.51-.51v-1.079a.51.51 0 01.51-.51zM44.243 4.676c1.59.137 3.17.356 4.726.68l-1.127.791L45.86 7.48l-.23-.031c-.46-.06-.924-.093-1.387-.136zm27.646 26.079H52.271a.51.51 0 00-.51.51v1.077c0 .282.228.51.51.51H71.89a.51.51 0 00.51-.51v-1.077a.51.51 0 00-.51-.51zM52.791 54.729c0 .548.444.992.991.992h6.201a.992.992 0 00.992-.992v-8.983a.102.102 0 00-.102-.102h-7.09a.991.991 0 00-.992.991v8.094zm10.426.156c0 .461.374.836.836.836h6.512a.836.836 0 00.836-.836V46.48a.836.836 0 00-.836-.836h-7.348v9.24zm-2.248-11.11c.003 0 .006-.002.006-.006v-9.176c0-.495-.4-.896-.895-.896h-6.394a.896.896 0 00-.895.896v8.287c0 .494.4.896.895.896h7.283zm9.456 0c.54 0 .976-.437.976-.976v-8.126a.976.976 0 00-.976-.976h-6.233a.976.976 0 00-.975.976v9.016c0 .047.038.087.085.087h7.123zm9.007-20.813L54.354 6.112a2.093 2.093 0 00-2.327.001l-20.09 13.498-4.96 3.332a.44.44 0 00-.12.61l.84 1.262a.44.44 0 00.613.122l1.08-.725 23.8-15.99L78.1 24.956a.405.405 0 00.565-.112l.879-1.322a.405.405 0 00-.112-.56zM37.3 2.873v4.443l.001 5.889 4.625-3.142V2.873H37.3zm.53 48.33a1.375 1.375 0 102.75.002 1.375 1.375 0 00-2.75-.002zm-8.44-15.71l-19.902-.034.055 23.686 7.837-.018a7.09 7.09 0 01.593-.6V54.94c0-.143.116-.26.26-.26h6.418c.144 0 .26.117.26.26v.105a11.378 11.378 0 012.762-2.048v-2.73c0-.142.116-.258.26-.258h1.457v-.831h-1.457a.26.26 0 01-.26-.26v-3.16c0-.143.116-.259.26-.259h1.457v-.831h-1.457a.26.26 0 01-.26-.26v-3.16a.26.26 0 01.26-.26h1.457v-.83h-1.457a.26.26 0 01-.26-.26v-3.16a.26.26 0 01.26-.26h1.457v-.984zm0 32.539V54.29a9.455 9.455 0 00-4.582 4.064.957.957 0 01-1.054.465c-3.277-.743-6.216 1.78-6.217 4.953 0 1.784.93 3.352 2.325 4.259h9.528zm52.083-43.226l-.879 1.323a2.721 2.721 0 01-2.268 1.214c-.468 0-.92-.125-1.326-.353l.004 3.225v22.538a36.91 36.91 0 01-2.402 6.984V25.398L53.19 11.012 32.615 24.837l-.822.567v42.628h3.387V31.389c0-.35.285-.634.636-.634h12.689c.351 0 .635.284.635.634v36.643h20.218a37.648 37.648 0 01-2.19 2.402H14.587a37.633 37.633 0 01-2.19-2.402h4.67a6.959 6.959 0 01-1.46-4.259 6.96 6.96 0 01.805-3.235H9.487a1.394 1.394 0 01-1.392-1.393v-1.734h-1.92c-.3-.788-.576-1.589-.822-2.402h2.742V35.46h-.49v-2.51h2.301l-.001-2.433c0-.2.082-.39.226-.526l3.062-2.896a.723.723 0 011.222.526v5.33h1.125l-.001-2.434c0-.2.082-.39.226-.526l3.061-2.896a.723.723 0 011.223.526v5.33h1.123v-2.434c0-.2.081-.39.225-.526l3.062-2.896a.718.718 0 01.363-.185c.133-.025.276-.033.521.137.239.165.299.371.313.412.016.04.025.106.025.162l.001 5.33h1.124v-2.434c0-.2.081-.39.225-.526l2.359-2.232v-.776a2.735 2.735 0 01-1.326.347c-.926 0-1.784-.46-2.297-1.23l-.84-1.263a2.764 2.764 0 01.76-3.816l9.297-6.248-.001-7.157V4.96l-.001-2.484c0-1.059.862-1.92 1.921-1.92h5.42c1.059 0 1.92.861 1.92 1.92V8.552l6.497-4.365a4.4 4.4 0 014.906.003l25.077 16.848a2.728 2.728 0 01.75 3.768zm-70.585 15.35h4.063a.26.26 0 00.26-.259v-3.16a.26.26 0 00-.26-.26h-4.063a.26.26 0 00-.259.26v3.16c0 .144.117.26.259.26zm5.682 0h4.063a.26.26 0 00.26-.259v-3.16a.26.26 0 00-.26-.26H16.57a.259.259 0 00-.259.26v3.16c0 .144.116.26.259.26zm5.68 0h4.064a.259.259 0 00.258-.259v-3.16a.259.259 0 00-.258-.26H22.25a.26.26 0 00-.26.26v3.16c0 .144.116.26.26.26zm-11.362 13.53h4.063a.26.26 0 00.26-.26v-3.16a.259.259 0 00-.26-.258h-4.063a.26.26 0 00-.259.259v3.16c0 .143.117.26.259.26zm5.682 0h4.063a.26.26 0 00.26-.26v-3.16a.259.259 0 00-.26-.258H16.57a.259.259 0 00-.259.259v3.16c0 .143.116.26.259.26zm5.68 0h4.064a.26.26 0 00.258-.26v-3.16a.259.259 0 00-.258-.258H22.25a.259.259 0 00-.26.259v3.16c0 .143.116.26.26.26zm-11.362-4.51h4.063a.26.26 0 00.26-.26v-3.16a.259.259 0 00-.26-.258h-4.063a.26.26 0 00-.259.259v3.16c0 .144.117.26.259.26zm5.682 0h4.063a.26.26 0 00.26-.26v-3.16a.259.259 0 00-.26-.258H16.57a.259.259 0 00-.259.259v3.16c0 .144.116.26.259.26zm5.68 0h4.064a.259.259 0 00.258-.26v-3.16a.259.259 0 00-.258-.258H22.25a.259.259 0 00-.26.259v3.16c0 .144.116.26.26.26zm-11.362-4.51h4.063a.26.26 0 00.26-.259v-3.16a.26.26 0 00-.26-.26h-4.063a.26.26 0 00-.259.26v3.16c0 .144.117.26.259.26zm5.682 0h4.063a.26.26 0 00.26-.259v-3.16a.26.26 0 00-.26-.26H16.57a.259.259 0 00-.259.26v3.16c0 .144.116.26.259.26zm5.421-.259v-3.16a.26.26 0 01.26-.26h4.063c.143 0 .258.116.258.26v3.16c0 .144-.115.26-.258.26H22.25a.26.26 0 01-.26-.26z",
        fill: themeValues.accentColor,
        mask: "url(#prefix__d)"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#prefix__b)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(59 61)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        fill: themeValues.subIconColor,
        cx: 13.3,
        cy: 13.3,
        r: 13.3
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(3 3)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "prefix__f",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#prefix__e"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#000",
        xlinkHref: "#prefix__e"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#prefix__f)",
        fill: themeValues.primaryColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 0h21v21H0z"
    })))))));
};
var PropertiesAddIcon$1 = themeComponent(PropertiesAddIcon, "Icons", fallbackValues$b, "info");
// When ariaHidden is true, aria-hidden="true" is added to the SVG, which tells
// screen readers to skip this element. Use this when the icon is purely decorative
// and adjacent text already conveys its meaning (e.g. an icon inside a labeled nav link).
var PropertiesIconSmall = function PropertiesIconSmall(_ref) {
    var themeValues = _ref.themeValues, _ref$ariaHidden = _ref.ariaHidden, ariaHidden = _ref$ariaHidden === void 0 ? true : _ref$ariaHidden;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22px",
        height: "22px",
        viewBox: "-1 0 22 15",
        version: "1.1",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            display: "inline-block",
            verticalAlign: "text-bottom"
        },
        "aria-hidden": ariaHidden ? "true" : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.singleIconColor,
        fillRule: "nonzero",
        d: "M16.875 8.5a.297.297 0 00.25-.125l.781-.969a.389.389 0 00.078-.281.397.397 0 00-.109-.25L15.25 4.719V.375a.362.362 0 00-.11-.266.362.362 0 00-.265-.109h-1.75a.362.362 0 00-.266.11.362.362 0 00-.109.265v2.281L9.969.344A1.531 1.531 0 009 0c-.354 0-.667.115-.938.344L.125 6.875a.397.397 0 00-.11.25.389.389 0 00.079.281l.781.969a.297.297 0 00.25.125.457.457 0 00.281-.094L8.75 2.375A.416.416 0 019 2.281c.083 0 .167.032.25.094l7.344 6.031a.457.457 0 00.281.094zM7.125 14a.362.362 0 00.266-.11.362.362 0 00.109-.265v-3.5c0-.104.036-.193.11-.266a.362.362 0 01.265-.109h2.25c.104 0 .193.036.266.11.073.072.109.16.109.265v3.5c0 .104.036.193.11.266.072.073.16.109.265.109H14.5a.723.723 0 00.531-.219.723.723 0 00.219-.531V8.781a.424.424 0 00-.125-.312L9.25 3.656A.416.416 0 009 3.563a.416.416 0 00-.25.093L2.875 8.47a.424.424 0 00-.125.312v4.469c0 .208.073.385.219.531A.723.723 0 003.5 14h3.625z"
    })));
};
var PropertiesIconSmall$1 = themeComponent(PropertiesIconSmall, "Icons", fallbackValues$b, "primary");
var AccountNumberImage = function AccountNumberImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "371",
        height: "164",
        viewBox: "0 0 371 164",
        role: "img",
        "aria-label": "A check with the account number highlighted in the bottom center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-364 -546)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(332 360)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(32 186)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "370.8",
        height: "163.2",
        x: "0",
        y: "0",
        fill: "#E1E1E1",
        rx: "2.4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "104.4",
        height: "14.4",
        x: "14.4",
        y: "14.4",
        fill: "#BBB",
        rx: "1.2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "69.6",
        height: "14.4",
        x: "286.8",
        y: "14.4",
        fill: "#BBB",
        rx: "2.4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "87.6",
        height: "14.4",
        x: "14.4",
        y: "33.6",
        fill: "#BBB",
        rx: "1.2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#BBB",
        d: "M14.4000006 96.0000038L356.400014 96.0000038 356.400014 98.4000039 14.4000006 98.4000039z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#BBB",
        d: "M267.600011 140.400006L356.400014 140.400006 356.400014 142.800006 267.600011 142.800006z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#BBB",
        d: "M14.4000006 76.8000031L208.800008 76.8000031 208.800008 79.2000031 14.4000006 79.2000031z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "112.8",
        height: "25.2",
        x: "243",
        y: "53.4",
        fill: "#FFF",
        stroke: "#BBB",
        strokeWidth: "1.2",
        rx: "2.4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "117.6",
        height: "27.6",
        x: "145.2",
        y: "120.6",
        fill: "#B3D1E8",
        stroke: "#357FB8",
        strokeWidth: "1.2",
        rx: "2.4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#000",
        d: "M25.863 137.872a.363.363 0 01-.145-.03.333.333 0 01-.124-.08.343.343 0 01-.08-.12.4.4 0 01-.03-.149v-5.374c0-.046.01-.094.03-.144a.365.365 0 01.08-.125.365.365 0 01.124-.08.53.53 0 01.072-.024.28.28 0 01.073-.01h1.06c.05 0 .1.011.15.035a.395.395 0 01.234.349v5.373c0 .03-.004.06-.012.087a.377.377 0 01-.242.271 1.03 1.03 0 00-.062.013.298.298 0 01-.067.008h-1.061zm4.238 1.613a.473.473 0 01-.16-.03.514.514 0 01-.129-.084.398.398 0 01-.12-.289v-2.122c0-.026.004-.053.01-.08a.493.493 0 01.026-.074.38.38 0 01.146-.182.383.383 0 01.145-.062.358.358 0 01.082-.01h2.112c.026 0 .053.003.08.01a.734.734 0 01.08.025.45.45 0 01.218.219c.02.05.03.101.03.154v2.122c0 .053-.01.106-.03.16a.417.417 0 01-.379.244h-2.11zm0-6.385a.473.473 0 01-.16-.03.383.383 0 01-.129-.089.414.414 0 01-.09-.13.425.425 0 01-.03-.159v-2.117a.468.468 0 01.12-.289c.02-.02.04-.037.062-.052a.228.228 0 01.068-.032.237.237 0 01.077-.028.473.473 0 01.082-.007h2.112c.026 0 .053.002.08.007a.303.303 0 01.08.028c.049.02.092.048.129.085.04.036.07.08.09.129.02.053.03.106.03.16v2.116c0 .057-.01.11-.03.16a.414.414 0 01-.09.129.35.35 0 01-.13.09.425.425 0 01-.16.03h-2.11zm10.618-2.46v4.308a.522.522 0 00.06.244.734.734 0 00.14.204.553.553 0 00.094.075.891.891 0 00.11.06c.036.013.073.025.11.035.036.01.07.015.099.015h1.126c.03 0 .058 0 .084.002a.275.275 0 01.08.018.443.443 0 01.164.15.973.973 0 01.038.049c.011.017.02.033.027.05.013.036.02.076.02.12v3.247a.368.368 0 01-.007.072.185.185 0 01-.028.067.394.394 0 01-.08.115.498.498 0 01-.129.094.323.323 0 01-.135.035H39.22a.292.292 0 01-.11-.03 3.315 3.315 0 00-.059-.035.217.217 0 01-.06-.05.19.19 0 01-.045-.054l-.04-.07a.374.374 0 01-.034-.125v-3.277a.354.354 0 01.035-.134.383.383 0 01.08-.12.374.374 0 01.125-.09.323.323 0 01.133-.034h.18c.01 0 .025-.004.047-.013l.067-.027a.639.639 0 00.13-.09l.044-.055c.017-.02.03-.04.04-.06a.24.24 0 00.03-.104v-3.267a.227.227 0 00-.04-.13.393.393 0 00-.144-.156.476.476 0 00-.135-.063.158.158 0 00-.044-.01h-.175a.223.223 0 01-.06-.01.585.585 0 01-.07-.025.7.7 0 01-.064-.037.358.358 0 01-.107-.107.7.7 0 01-.037-.065.585.585 0 01-.025-.07.237.237 0 01-.01-.064v-.578a.34.34 0 01.035-.154c.01-.02.023-.04.04-.06a.511.511 0 01.154-.134.354.354 0 01.144-.035h1.09a.354.354 0 01.134.035c.025.01.048.021.071.034a.281.281 0 01.06.045c.02.02.036.04.05.062a.813.813 0 01.035.063.3.3 0 01.034.134zm8.741-.503h3.218c.05 0 .096.01.139.03a.583.583 0 01.22.207c.02.035.03.064.034.087a.218.218 0 010 .08v4.323a.176.176 0 01-.012.054.584.584 0 01-.028.065.404.404 0 01-.09.12.818.818 0 01-.054.05.312.312 0 01-.06.04.23.23 0 01-.065.03.27.27 0 01-.074.01H50.57a.62.62 0 00-.438.194.715.715 0 00-.15.204.693.693 0 00-.04.112.443.443 0 00-.015.112v2.136c0 .034.004.07.013.107.008.039.019.076.032.112.017.034.036.069.057.105a.553.553 0 00.271.244c.04.017.079.03.115.042.037.012.07.018.1.018h2.172c.05 0 .097.012.144.037a.442.442 0 01.12.092c.036.04.066.085.09.135.022.05.034.101.034.154a.488.488 0 01-.105.299.423.423 0 01-.122.1.33.33 0 01-.161.04h-3.213a.299.299 0 01-.14-.04.374.374 0 01-.07-.04 1.098 1.098 0 01-.064-.05 1.099 1.099 0 01-.05-.065.374.374 0 01-.04-.07.323.323 0 01-.034-.134l-.005-2.147v-2.146a.34.34 0 01.04-.155.243.243 0 01.042-.072.513.513 0 01.117-.112.229.229 0 01.07-.035.31.31 0 01.124-.035h2.127a.4.4 0 00.117-.017c.038-.012.077-.026.117-.042a.584.584 0 00.204-.155.434.434 0 00.07-.092.821.821 0 00.087-.216.585.585 0 00.012-.12v-2.097a.527.527 0 00-.012-.112 1.128 1.128 0 00-.032-.117.739.739 0 00-.217-.286.494.494 0 00-.102-.062.55.55 0 00-.11-.05.362.362 0 00-.114-.02h-2.157a.305.305 0 01-.12-.035.513.513 0 01-.187-.157.384.384 0 01-.042-.396.507.507 0 01.1-.144.36.36 0 01.254-.12zm9.124-.005h3.248a.378.378 0 01.134.03c.047.02.09.048.13.085a.427.427 0 01.094.114.271.271 0 01.035.13l-.005 1.922v1.923a.727.727 0 00.134.393c.02.027.044.052.07.077a.341.341 0 00.08.058c.03.016.06.03.092.042a.293.293 0 00.102.017h.15l.15.005a.182.182 0 01.095.035c.032.02.06.047.083.08.024.03.042.066.055.11a.81.81 0 01.018.06c.005.02.007.037.007.054v3.815c0 .02-.002.04-.007.06a.81.81 0 01-.018.06.562.562 0 01-.065.11.49.49 0 01-.154.119.391.391 0 01-.075.037.183.183 0 01-.06.012h-4.273a.335.335 0 01-.12-.024.443.443 0 01-.124-.075.5.5 0 01-.1-.132.405.405 0 01-.044-.197c0-.086.015-.158.045-.214.03-.056.066-.1.11-.13a.424.424 0 01.23-.08h1.084l1.09-.004a.35.35 0 00.075-.015.946.946 0 00.115-.04.816.816 0 00.127-.062.347.347 0 00.097-.082.414.414 0 00.077-.093.95.95 0 00.058-.107.462.462 0 00.05-.209v-2.141a.667.667 0 00-.055-.234.63.63 0 00-.14-.215.561.561 0 00-.19-.14.527.527 0 00-.238-.054h-2.142a.337.337 0 01-.189-.052.416.416 0 01-.124-.122.516.516 0 01-.085-.26.49.49 0 01.125-.299.462.462 0 01.126-.089.335.335 0 01.147-.035h2.137a.533.533 0 00.244-.054.604.604 0 00.334-.349.724.724 0 00.05-.259l.004-1.03.01-1.037a.635.635 0 00-.044-.239.502.502 0 00-.053-.097.71.71 0 00-.192-.197 1.028 1.028 0 00-.124-.074.78.78 0 00-.24-.05h-2.14a.38.38 0 01-.24-.1.39.39 0 01-.1-.132.447.447 0 01-.04-.197c0-.076.014-.141.04-.196a.39.39 0 01.1-.132.346.346 0 01.23-.1zm10.255 0c.04 0 .083.012.13.035a.7.7 0 01.064.037.388.388 0 01.115.112l.045.065a.302.302 0 01.04.145v5.349a.598.598 0 00.05.239.663.663 0 00.149.224.475.475 0 00.2.134c.072.033.143.05.213.05h1.16c.03 0 .065-.004.103-.012a2.21 2.21 0 00.112-.028.657.657 0 00.204-.12.662.662 0 00.13-.2.59.59 0 00.044-.213v-.164a.298.298 0 01.03-.13.273.273 0 01.08-.11.138.138 0 01.055-.039.55.55 0 01.19-.045h1.17c.033 0 .07.01.109.03a.512.512 0 01.12.09.36.36 0 01.054.057.216.216 0 01.035.062c.027.047.04.09.04.13l-.005 1.628v1.624a.33.33 0 01-.03.13.47.47 0 01-.14.176 1.037 1.037 0 01-.064.048.302.302 0 01-.145.04h-1.095a.374.374 0 01-.15-.035.374.374 0 01-.07-.04 1.098 1.098 0 01-.064-.05.45.45 0 01-.125-.249v-1.126a.345.345 0 00-.017-.104 2.844 2.844 0 00-.037-.11.506.506 0 00-.063-.11 1.469 1.469 0 00-.077-.094 1.04 1.04 0 00-.095-.075.45.45 0 00-.104-.054.527.527 0 00-.21-.045l-1.623-.005h-1.624a.365.365 0 01-.221-.082.451.451 0 01-.11-.115 2.343 2.343 0 01-.032-.052.484.484 0 01-.04-.13v-6.37c0-.036.003-.071.01-.104l.02-.095c.02-.06.05-.11.09-.15.023-.02.048-.04.074-.06a.37.37 0 01.075-.044.493.493 0 01.067-.032.155.155 0 01.053-.013h1.11zm14.419.005c.046 0 .094.008.144.023.05.014.093.04.13.077.04.033.072.077.097.132a.46.46 0 01.037.191.37.37 0 01-.04.197.449.449 0 01-.353.237h-1.584l-1.579-.005a.455.455 0 00-.11.015.667.667 0 00-.221.1.636.636 0 00-.097.079.606.606 0 00-.16.21.855.855 0 00-.042.114.409.409 0 00-.017.114l.004 1.056v1.056c0 .063.015.131.045.204.03.073.072.14.125.2.03.033.062.064.097.094s.07.055.107.075c.04.023.081.041.125.055.043.013.088.02.134.02h3.183a.3.3 0 01.134.034c.023.01.046.024.07.043a.452.452 0 01.112.115.25.25 0 01.032.061.243.243 0 01.028.07.332.332 0 01.007.07v4.308a.327.327 0 01-.035.144.32.32 0 01-.035.063.444.444 0 01-.18.162.34.34 0 01-.143.034h-4.284a.285.285 0 01-.134-.037.635.635 0 01-.13-.092.585.585 0 01-.092-.135.341.341 0 01-.037-.154c0-.063 0-.122-.003-.177a.266.266 0 01.028-.137c.02-.04.059-.071.117-.094a.762.762 0 01.266-.035h3.183a.472.472 0 00.114-.015.667.667 0 00.115-.04 1.89 1.89 0 00.11-.065.583.583 0 00.1-.08.54.54 0 00.134-.184.534.534 0 00.054-.229v-2.176a.508.508 0 00-.06-.21.557.557 0 00-.067-.109 1.04 1.04 0 00-.087-.1 1.04 1.04 0 00-.194-.134.496.496 0 00-.194-.045h-3.208a.215.215 0 01-.067-.012.545.545 0 01-.212-.122.474.474 0 01-.09-.125.332.332 0 01-.034-.14v-4.307a.357.357 0 01.017-.07.436.436 0 01.17-.237l.062-.042a.645.645 0 01.154-.05h2.127l2.127.005zm8.088-.005a.348.348 0 01.16.045c.03.013.056.03.079.05a.596.596 0 01.15.189.34.34 0 01.03.134v1.614a.336.336 0 01-.038.157.454.454 0 01-.097.127.486.486 0 01-.294.11.878.878 0 01-.167-.015.371.371 0 01-.137-.055.283.283 0 01-.097-.12.483.483 0 01-.037-.204v-.264l-.005-.259a.455.455 0 00-.015-.11 1.154 1.154 0 00-.035-.114.823.823 0 00-.062-.12.587.587 0 00-.083-.104.848.848 0 00-.204-.144.583.583 0 00-.234-.055h-1.02a.657.657 0 00-.528.291.717.717 0 00-.11.234.503.503 0 00-.015.117l.005 1.599v1.594a.44.44 0 00.012.102.693.693 0 00.157.306c.06.067.13.118.21.155.04.02.08.035.124.047a.515.515 0 00.134.017h4.244c.043 0 .088.013.137.038a.509.509 0 01.219.214.27.27 0 01.037.132v3.232c0 .02-.004.042-.012.067a1.742 1.742 0 00-.023.073.374.374 0 01-.04.07 1.098 1.098 0 01-.05.064.64.64 0 01-.062.055.312.312 0 01-.067.04.28.28 0 01-.14.04h-5.339a.238.238 0 01-.07-.013.376.376 0 01-.074-.032.58.58 0 01-.14-.1.399.399 0 01-.102-.187.298.298 0 01-.007-.067v-4.268l-.005-4.273c0-.024.004-.049.013-.075a.565.565 0 01.117-.2.47.47 0 01.134-.094.323.323 0 01.134-.035l1.61-.005h1.603zm-2.127 8.497h3.148a.607.607 0 00.438-.2.707.707 0 00.19-.478v-.966a.707.707 0 00-.19-.478.577.577 0 00-.438-.194h-3.148a.58.58 0 00-.244.052.632.632 0 00-.199.142.723.723 0 00-.18.478v.966a.723.723 0 00.18.478c.056.06.123.109.2.145a.558.558 0 00.243.055zm14.429-8.497a.47.47 0 01.261.08.787.787 0 01.067.05c.024.02.043.041.058.064a.7.7 0 01.037.065.493.493 0 01.035.15v1.773l-.005 1.773c0 .013 0 .03-.003.05a.72.72 0 00-.002.06.386.386 0 01-.065.164.168.168 0 01-.045.04.454.454 0 01-.042.037.195.195 0 01-.047.027l-.384.18-.383.174-.767.358a.472.472 0 00-.077.038.749.749 0 00-.192.152 4.29 4.29 0 01-.043.062.25.25 0 00-.032.062l-.02.062a.211.211 0 00-.01.063l.005 1.733v1.733a.426.426 0 01-.037.187.374.374 0 01-.234.194.578.578 0 01-.162.022.354.354 0 01-.16-.04.606.606 0 01-.139-.094.415.415 0 01-.102-.127.307.307 0 01-.037-.142v-4.094c0-.023.003-.046.01-.067.006-.022.013-.042.02-.062l.04-.068a.311.311 0 01.044-.057 1.75 1.75 0 01.11-.1 1.176 1.176 0 01.11-.064l.702-.314.697-.309.082-.035a.944.944 0 00.092-.045.438.438 0 00.087-.064.285.285 0 00.067-.1.221.221 0 00.02-.04.56.56 0 00.02-.154v-1.843a.527.527 0 00-.012-.112 1.128 1.128 0 00-.033-.117.462.462 0 00-.057-.115.984.984 0 00-.177-.194.46.46 0 00-.114-.07.527.527 0 00-.244-.064H100.5a.5.5 0 00-.214.055.639.639 0 00-.2.134.957.957 0 00-.149.224.76.76 0 00-.05.25v1.05c0 .05-.01.099-.032.147a.422.422 0 01-.087.127.417.417 0 01-.284.134.385.385 0 01-.197-.04.456.456 0 01-.142-.109.464.464 0 01-.09-.137.332.332 0 01-.03-.122v-1.05l.006-1.047c0-.05.003-.093.01-.13a.284.284 0 01.03-.089.303.303 0 01.047-.07l.057-.064c.043-.04.09-.07.14-.09a.372.372 0 01.159-.035h4.174zm5.921 4.164h2.197a.55.55 0 00.518-.356.594.594 0 00.045-.232v-2.112a.594.594 0 00-.165-.418.558.558 0 00-.398-.174h-2.197a.52.52 0 00-.221.047.566.566 0 00-.177.127.66.66 0 00-.122.187.567.567 0 00-.047.231v2.112c0 .083.015.16.047.232a.66.66 0 00.122.186.534.534 0 00.398.17zm.03 4.248h2.137c.08 0 .156-.016.229-.047a.651.651 0 00.19-.122.57.57 0 00.179-.414v-2.226a.555.555 0 00-.18-.413.651.651 0 00-.189-.122.572.572 0 00-.23-.048H109.6a.567.567 0 00-.231.048.74.74 0 00-.192.122.572.572 0 00-.174.413v2.226c0 .08.015.156.047.227a.61.61 0 00.127.187c.056.05.12.09.192.122a.567.567 0 00.231.047zm-2.56.448v-3.934a.21.21 0 01.035-.115.251.251 0 01.08-.09l.075-.05a.446.446 0 01.239-.069h.289a.157.157 0 00.06-.015l.064-.03a.763.763 0 00.14-.104.895.895 0 00.1-.12.226.226 0 00.039-.114v-3.81a.451.451 0 01.045-.18.963.963 0 01.045-.08.268.268 0 01.054-.064.318.318 0 01.065-.057.603.603 0 01.174-.083h2.122l2.122-.005c.05 0 .103.017.16.05l.084.055a.4.4 0 01.08.07c.04.036.07.074.09.112.02.038.034.072.044.102a.555.555 0 01.015.134v3.76c0 .024.004.048.012.073a.514.514 0 00.028.067.23.23 0 00.042.065l.052.055a.783.783 0 00.12.08l.08.027a.266.266 0 00.08.012h.253a.28.28 0 01.144.045c.02.01.04.023.06.04a.7.7 0 00.06.045.292.292 0 01.08.12c.02.049.03.095.03.139l-.005 1.085v2.794a.29.29 0 01-.013.083 1.191 1.191 0 01-.027.082.963.963 0 01-.1.154.423.423 0 01-.139.11.535.535 0 01-.08.032.266.266 0 01-.08.012h-6.33a.282.282 0 01-.09-.014.997.997 0 01-.089-.035.436.436 0 01-.085-.05.696.696 0 01-.136-.14.67.67 0 01-.048-.08.409.409 0 01-.04-.164zm11.76-8.87h5.244a.43.43 0 01.318.135.58.58 0 01.058.067c.018.025.032.05.042.077.01.023.02.05.027.08.009.03.013.061.013.094v8.467a.393.393 0 01-.065.22.408.408 0 01-.2.17.418.418 0 01-.188.043h-1.051a.302.302 0 01-.14-.04 1.86 1.86 0 01-.067-.047.54.54 0 01-.152-.167.265.265 0 01-.03-.119v-3.212a.63.63 0 00-.05-.244.602.602 0 00-.13-.2.753.753 0 00-.099-.092.557.557 0 00-.231-.11.451.451 0 00-.122-.017h-3.178a.483.483 0 01-.184-.04.396.396 0 01-.15-.11.322.322 0 01-.08-.139.734.734 0 01-.024-.08.309.309 0 01-.01-.074v-4.214a.451.451 0 01.045-.184.399.399 0 01.105-.144.388.388 0 01.064-.053.672.672 0 01.152-.057.358.358 0 01.082-.01zm1.05 4.244h3.118a.607.607 0 00.254-.055.568.568 0 00.112-.063.642.642 0 00.237-.291.778.778 0 00.04-.124.596.596 0 00.014-.135v-2.042a.756.756 0 00-.112-.376.77.77 0 00-.179-.18.568.568 0 00-.234-.099.724.724 0 00-.132-.012h-3.118a.624.624 0 00-.326.087.816.816 0 00-.092.062.957.957 0 00-.097.102.559.559 0 00-.078.122.725.725 0 00-.064.294v2.042a.678.678 0 00.112.369.697.697 0 00.286.244c.04.013.081.025.125.037a.515.515 0 00.134.018zm8.014 3.506a.363.363 0 01-.145-.03.333.333 0 01-.124-.08.343.343 0 01-.08-.12.4.4 0 01-.03-.149v-5.374c0-.046.01-.094.03-.144a.365.365 0 01.08-.125.365.365 0 01.124-.08.53.53 0 01.072-.024.28.28 0 01.073-.01h1.06c.05 0 .1.011.15.035a.395.395 0 01.234.349v5.373c0 .03-.004.06-.012.087a.377.377 0 01-.242.271 1.03 1.03 0 00-.062.013.298.298 0 01-.067.008h-1.061zm4.238 1.613a.473.473 0 01-.16-.03.514.514 0 01-.129-.084.398.398 0 01-.12-.289v-2.122c0-.026.004-.053.01-.08a.493.493 0 01.026-.074.381.381 0 01.146-.182.383.383 0 01.145-.062.358.358 0 01.082-.01h2.112c.026 0 .053.003.08.01a.734.734 0 01.08.025.45.45 0 01.218.219c.02.05.03.101.03.154v2.122c0 .053-.01.106-.03.16a.417.417 0 01-.379.244h-2.11zm0-6.385a.473.473 0 01-.16-.03.383.383 0 01-.129-.089.414.414 0 01-.09-.13.425.425 0 01-.03-.159v-2.117a.468.468 0 01.12-.289c.02-.02.04-.037.062-.052a.228.228 0 01.068-.032.237.237 0 01.077-.028.473.473 0 01.082-.007h2.112c.026 0 .053.002.08.007a.303.303 0 01.08.028c.049.02.092.048.129.085.04.036.07.08.09.129.02.053.03.106.03.16v2.116c0 .057-.01.11-.03.16a.414.414 0 01-.09.129.35.35 0 01-.13.09.425.425 0 01-.16.03h-2.11z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#000",
        d: "M164.258 130.137c.046 0 .094.008.144.023.05.014.093.04.13.077.04.033.072.077.097.132a.46.46 0 01.037.191.37.37 0 01-.04.197.449.449 0 01-.353.237h-1.584l-1.579-.005a.455.455 0 00-.11.015.667.667 0 00-.221.1.636.636 0 00-.097.079.606.606 0 00-.16.21.855.855 0 00-.042.114.409.409 0 00-.017.114l.004 1.056v1.056c0 .063.015.131.045.204.03.073.072.14.125.2.03.033.062.064.097.094s.07.055.107.075c.04.023.081.041.125.055.043.013.088.02.134.02h3.183a.3.3 0 01.134.034c.023.01.046.024.07.043a.452.452 0 01.112.115.25.25 0 01.032.061.243.243 0 01.028.07.332.332 0 01.007.07v4.308a.327.327 0 01-.035.144.32.32 0 01-.035.063.444.444 0 01-.18.162.34.34 0 01-.143.034h-4.284a.285.285 0 01-.134-.037.635.635 0 01-.13-.092.585.585 0 01-.092-.135.341.341 0 01-.037-.154c0-.063 0-.122-.003-.177a.266.266 0 01.028-.137c.02-.04.059-.071.117-.094a.762.762 0 01.266-.035h3.183a.472.472 0 00.114-.015.667.667 0 00.115-.04 1.89 1.89 0 00.11-.065.583.583 0 00.1-.08.54.54 0 00.134-.184.534.534 0 00.054-.229v-2.176a.508.508 0 00-.06-.21.557.557 0 00-.067-.109 1.04 1.04 0 00-.087-.1 1.04 1.04 0 00-.194-.134.496.496 0 00-.194-.045h-3.208a.215.215 0 01-.067-.012.545.545 0 01-.212-.122.474.474 0 01-.09-.125.332.332 0 01-.034-.14v-4.307a.357.357 0 01.017-.07.436.436 0 01.17-.237l.062-.042a.645.645 0 01.154-.05h2.127l2.127.005zm10.2 0c.046 0 .094.008.144.023.05.014.093.04.13.077.04.033.072.077.097.132a.46.46 0 01.037.191.37.37 0 01-.04.197.449.449 0 01-.353.237h-1.584l-1.579-.005a.455.455 0 00-.11.015.667.667 0 00-.221.1.636.636 0 00-.097.079.606.606 0 00-.16.21.855.855 0 00-.042.114.409.409 0 00-.017.114l.004 1.056v1.056c0 .063.015.131.045.204.03.073.072.14.125.2.03.033.062.064.097.094s.07.055.107.075c.04.023.081.041.125.055.043.013.088.02.134.02h3.183a.3.3 0 01.134.034c.023.01.046.024.07.043a.452.452 0 01.112.115.25.25 0 01.032.061.243.243 0 01.028.07.332.332 0 01.007.07v4.308a.328.328 0 01-.035.144.32.32 0 01-.035.063.444.444 0 01-.18.162.34.34 0 01-.143.034h-4.284a.285.285 0 01-.134-.037.635.635 0 01-.13-.092.585.585 0 01-.092-.135.341.341 0 01-.037-.154c0-.063 0-.122-.003-.177a.266.266 0 01.028-.137c.02-.04.059-.071.117-.094a.762.762 0 01.266-.035h3.183a.472.472 0 00.114-.015.667.667 0 00.115-.04 1.89 1.89 0 00.11-.065.583.583 0 00.1-.08.54.54 0 00.134-.184.534.534 0 00.054-.229v-2.176a.508.508 0 00-.06-.21.557.557 0 00-.067-.109 1.039 1.039 0 00-.087-.1 1.04 1.04 0 00-.194-.134.496.496 0 00-.194-.045h-3.208a.215.215 0 01-.067-.012.545.545 0 01-.212-.122.474.474 0 01-.09-.125.332.332 0 01-.034-.14v-4.307a.357.357 0 01.017-.07.436.436 0 01.17-.237l.062-.042a.645.645 0 01.154-.05h2.127l2.127.005zm5.911 4.159h2.197a.55.55 0 00.518-.356.594.594 0 00.045-.232v-2.112a.594.594 0 00-.165-.418.558.558 0 00-.398-.174h-2.197a.52.52 0 00-.221.047.566.566 0 00-.177.127.66.66 0 00-.122.187.567.567 0 00-.047.231v2.112c0 .083.015.16.047.232a.66.66 0 00.122.186.534.534 0 00.398.17zm.03 4.248h2.137c.08 0 .156-.016.229-.047a.651.651 0 00.19-.122.57.57 0 00.179-.414v-2.226a.555.555 0 00-.18-.413.651.651 0 00-.189-.122.572.572 0 00-.23-.048H180.4a.567.567 0 00-.231.048.74.74 0 00-.192.122.572.572 0 00-.174.413v2.226c0 .08.015.156.047.227a.61.61 0 00.127.187c.056.05.12.09.192.122a.567.567 0 00.231.047zm-2.56.448v-3.934a.21.21 0 01.035-.115.251.251 0 01.08-.09 1.46 1.46 0 01.075-.05.446.446 0 01.239-.069h.289a.157.157 0 00.06-.015l.064-.03a.763.763 0 00.14-.104.895.895 0 00.1-.12.226.226 0 00.039-.114v-3.81a.451.451 0 01.045-.18.964.964 0 01.045-.08.268.268 0 01.054-.064.318.318 0 01.065-.057.603.603 0 01.174-.083h2.122l2.122-.005c.05 0 .103.017.16.05l.084.055a.4.4 0 01.08.07c.04.036.07.074.09.112.02.038.034.072.044.102a.555.555 0 01.015.134v3.76c0 .024.004.048.012.073a.514.514 0 00.028.067.23.23 0 00.042.065l.052.055a.783.783 0 00.12.08l.08.027a.266.266 0 00.08.012h.253a.28.28 0 01.144.045c.02.01.04.023.06.04a.7.7 0 00.06.045.292.292 0 01.08.12c.02.049.03.095.03.139l-.005 1.085v2.794a.29.29 0 01-.013.083 1.191 1.191 0 01-.027.082.963.963 0 01-.1.154.423.423 0 01-.139.11.535.535 0 01-.08.032.266.266 0 01-.08.012h-6.33a.282.282 0 01-.09-.014.997.997 0 01-.089-.035.436.436 0 01-.085-.05.696.696 0 01-.136-.14.67.67 0 01-.048-.08.409.409 0 01-.04-.164zm11.76-8.87h5.244a.43.43 0 01.318.135.58.58 0 01.058.067c.018.025.032.05.042.077.01.023.02.05.027.08.009.03.013.061.013.094v8.467a.393.393 0 01-.065.22.408.408 0 01-.2.17.418.418 0 01-.188.043h-1.051a.302.302 0 01-.14-.04 1.86 1.86 0 01-.067-.047.54.54 0 01-.152-.167.265.265 0 01-.03-.119v-3.212a.63.63 0 00-.05-.244.602.602 0 00-.13-.2.753.753 0 00-.099-.092.557.557 0 00-.231-.11.451.451 0 00-.122-.017h-3.178a.483.483 0 01-.184-.04.396.396 0 01-.15-.11.321.321 0 01-.08-.139.734.734 0 01-.024-.08.309.309 0 01-.01-.074v-4.214a.45.45 0 01.045-.184.399.399 0 01.105-.144.388.388 0 01.064-.053.672.672 0 01.152-.057.358.358 0 01.082-.01zm1.05 4.244h3.118a.607.607 0 00.254-.055.568.568 0 00.112-.063.642.642 0 00.237-.291.778.778 0 00.04-.124.596.596 0 00.014-.135v-2.042a.756.756 0 00-.112-.376.77.77 0 00-.179-.18.568.568 0 00-.234-.099.724.724 0 00-.132-.012h-3.118a.624.624 0 00-.326.087.816.816 0 00-.092.062.957.957 0 00-.097.102.559.559 0 00-.078.122.725.725 0 00-.064.294v2.042a.678.678 0 00.112.369.697.697 0 00.286.244c.04.013.081.025.125.037a.515.515 0 00.134.018zm12.67-3.726v4.308a.522.522 0 00.06.244.734.734 0 00.14.204.553.553 0 00.094.075.891.891 0 00.11.06c.036.013.073.025.11.035.036.01.07.015.099.015h1.126c.03 0 .058 0 .084.002a.275.275 0 01.08.018.443.443 0 01.164.15.972.972 0 01.038.049c.011.017.02.033.027.05.013.036.02.076.02.12v3.247a.368.368 0 01-.007.072.185.185 0 01-.028.067.394.394 0 01-.08.115.498.498 0 01-.129.094.323.323 0 01-.135.035h-3.272a.292.292 0 01-.11-.03 3.314 3.314 0 00-.059-.035.217.217 0 01-.06-.05.19.19 0 01-.045-.054l-.04-.07a.374.374 0 01-.034-.125v-3.277a.354.354 0 01.035-.134.383.383 0 01.08-.12.374.374 0 01.125-.09.323.323 0 01.133-.034h.18c.01 0 .025-.004.047-.013l.067-.027a.639.639 0 00.13-.09 3.56 3.56 0 01.044-.055c.017-.02.03-.04.04-.06a.24.24 0 00.03-.104v-3.267a.227.227 0 00-.04-.13.392.392 0 00-.144-.156.476.476 0 00-.135-.063.158.158 0 00-.044-.01h-.175a.223.223 0 01-.06-.01.585.585 0 01-.07-.025.7.7 0 01-.064-.037.358.358 0 01-.107-.107.7.7 0 01-.037-.065.585.585 0 01-.025-.07.237.237 0 01-.01-.064v-.578a.34.34 0 01.035-.154c.01-.02.023-.04.04-.06a.511.511 0 01.154-.134.354.354 0 01.144-.035h1.09a.354.354 0 01.134.035c.025.01.048.021.071.034a.281.281 0 01.06.045c.02.02.036.04.05.062a.813.813 0 01.035.063.3.3 0 01.034.134zm8.741-.503h3.218c.05 0 .096.01.139.03a.583.583 0 01.22.207c.02.035.03.064.034.087a.218.218 0 010 .08v4.323a.176.176 0 01-.012.054.584.584 0 01-.028.065.404.404 0 01-.09.12.818.818 0 01-.054.05.312.312 0 01-.06.04.23.23 0 01-.065.03.27.27 0 01-.074.01h-2.117a.62.62 0 00-.438.194.715.715 0 00-.15.204.693.693 0 00-.04.112.443.443 0 00-.015.112v2.136c0 .034.004.07.013.107.008.039.019.076.032.112.017.034.036.069.057.105a.553.553 0 00.271.244c.04.017.079.03.115.042.037.012.07.018.1.018h2.172c.05 0 .097.012.144.037a.442.442 0 01.12.092c.036.04.066.085.09.135.022.05.034.101.034.154a.488.488 0 01-.105.299.423.423 0 01-.122.1.33.33 0 01-.161.04h-3.213a.299.299 0 01-.14-.04.374.374 0 01-.07-.04 1.099 1.099 0 01-.064-.05 1.099 1.099 0 01-.05-.065.374.374 0 01-.04-.07.323.323 0 01-.034-.134l-.005-2.147v-2.146a.34.34 0 01.04-.155.243.243 0 01.042-.072.513.513 0 01.117-.112.229.229 0 01.07-.035.31.31 0 01.124-.035h2.127a.4.4 0 00.117-.017c.038-.012.077-.026.117-.042a.584.584 0 00.204-.155.434.434 0 00.07-.092.821.821 0 00.087-.216.585.585 0 00.012-.12v-2.097a.527.527 0 00-.012-.112 1.128 1.128 0 00-.032-.117.739.739 0 00-.217-.286.494.494 0 00-.102-.062.55.55 0 00-.11-.05.362.362 0 00-.114-.02h-2.157a.305.305 0 01-.12-.035.513.513 0 01-.187-.157.384.384 0 01-.042-.396.507.507 0 01.1-.144.36.36 0 01.254-.12zm9.11 4.159h2.196a.55.55 0 00.518-.356.594.594 0 00.045-.232v-2.112a.594.594 0 00-.165-.418.558.558 0 00-.398-.174h-2.197a.52.52 0 00-.221.047.566.566 0 00-.177.127.66.66 0 00-.122.187.567.567 0 00-.047.231v2.112c0 .083.015.16.047.232a.66.66 0 00.122.186.534.534 0 00.398.17zm.03 4.248h2.136c.08 0 .156-.016.229-.047a.651.651 0 00.19-.122.57.57 0 00.179-.414v-2.226a.555.555 0 00-.18-.413.651.651 0 00-.189-.122.572.572 0 00-.23-.048H221.2a.567.567 0 00-.231.048.74.74 0 00-.192.122.572.572 0 00-.174.413v2.226c0 .08.015.156.047.227a.61.61 0 00.127.187c.056.05.12.09.192.122a.567.567 0 00.231.047zm-2.56.448v-3.934a.21.21 0 01.034-.115.251.251 0 01.08-.09l.075-.05a.446.446 0 01.239-.069h.289a.157.157 0 00.06-.015l.064-.03a.763.763 0 00.14-.104.895.895 0 00.1-.12.226.226 0 00.039-.114v-3.81a.451.451 0 01.045-.18.963.963 0 01.045-.08.268.268 0 01.054-.064.318.318 0 01.065-.057.603.603 0 01.174-.083h2.122l2.122-.005c.05 0 .103.017.16.05l.084.055a.4.4 0 01.08.07c.04.036.07.074.09.112.02.038.034.072.044.102a.555.555 0 01.015.134v3.76c0 .024.004.048.012.073a.514.514 0 00.028.067.23.23 0 00.042.065l.052.055a.783.783 0 00.12.08l.08.027a.266.266 0 00.08.012h.253a.28.28 0 01.144.045c.02.01.04.023.06.04a.7.7 0 00.06.045.292.292 0 01.08.12c.02.049.03.095.03.139l-.005 1.085v2.794a.29.29 0 01-.013.083 1.191 1.191 0 01-.027.082.963.963 0 01-.1.154.423.423 0 01-.139.11.535.535 0 01-.08.032.266.266 0 01-.08.012h-6.33a.282.282 0 01-.09-.014.997.997 0 01-.089-.035.436.436 0 01-.085-.05.697.697 0 01-.136-.14.67.67 0 01-.048-.08.409.409 0 01-.04-.164zm17.018-8.855c.046 0 .094.008.144.023.05.014.093.04.13.077.04.033.072.077.097.132a.46.46 0 01.037.191.37.37 0 01-.04.197.449.449 0 01-.353.237h-1.584l-1.579-.005a.455.455 0 00-.11.015.667.667 0 00-.221.1.636.636 0 00-.097.079.606.606 0 00-.16.21.855.855 0 00-.042.114.409.409 0 00-.017.114l.004 1.056v1.056c0 .063.015.131.045.204.03.073.072.14.125.2.03.033.062.064.097.094s.07.055.107.075c.04.023.081.041.125.055.043.013.088.02.134.02h3.183a.3.3 0 01.134.034c.023.01.046.024.07.043a.452.452 0 01.112.115.25.25 0 01.032.061.243.243 0 01.028.07.332.332 0 01.007.07v4.308a.327.327 0 01-.035.144.32.32 0 01-.035.063.444.444 0 01-.18.162.34.34 0 01-.143.034h-4.284a.285.285 0 01-.134-.037.635.635 0 01-.13-.092.585.585 0 01-.092-.135.341.341 0 01-.037-.154c0-.063 0-.122-.003-.177a.266.266 0 01.028-.137c.02-.04.059-.071.117-.094a.762.762 0 01.266-.035h3.183a.472.472 0 00.114-.015.667.667 0 00.115-.04 1.89 1.89 0 00.11-.065.583.583 0 00.1-.08.54.54 0 00.134-.184.534.534 0 00.054-.229v-2.176a.508.508 0 00-.06-.21.557.557 0 00-.067-.109 1.04 1.04 0 00-.087-.1 1.04 1.04 0 00-.194-.134.496.496 0 00-.194-.045h-3.208a.215.215 0 01-.067-.012.545.545 0 01-.212-.122.474.474 0 01-.09-.125.332.332 0 01-.034-.14v-4.307a.357.357 0 01.017-.07.436.436 0 01.17-.237l.062-.042a.645.645 0 01.154-.05h2.127l2.127.005zm8.088 4.517a.432.432 0 01-.08-.007.827.827 0 01-.074-.018.228.228 0 01-.068-.032.414.414 0 01-.057-.047.296.296 0 01-.085-.115.374.374 0 01-.025-.064.27.27 0 01-.01-.075v-3.277a.27.27 0 01.01-.075.374.374 0 01.025-.065.355.355 0 01.085-.114.365.365 0 01.279-.105h2.122a.393.393 0 01.149.03c.053.02.096.045.13.075.033.03.06.068.084.114a.31.31 0 01.035.14v3.277a.29.29 0 01-.035.14.28.28 0 01-.085.114.358.358 0 01-.129.08.919.919 0 01-.072.017.393.393 0 01-.077.007h-2.122zm-2.107 3.213a.439.439 0 01-.299-.115.37.37 0 01-.12-.269v-5.374a.37.37 0 01.12-.269.438.438 0 01.593 0 .404.404 0 01.09.12.33.33 0 01.035.15v5.373a.33.33 0 01-.035.15.404.404 0 01-.09.12.376.376 0 01-.132.084.444.444 0 01-.162.03zm-2.131 0a.439.439 0 01-.165-.03.381.381 0 01-.13-.085.34.34 0 01-.124-.269v-5.374a.35.35 0 01.125-.269.381.381 0 01.13-.084c.049-.02.104-.03.164-.03.06 0 .114.01.164.03.05.02.093.048.13.084a.34.34 0 01.124.27v5.373a.35.35 0 01-.125.27.381.381 0 01-.13.084.439.439 0 01-.163.03z"
    }))))));
};
var RoutingNumberImage = function RoutingNumberImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "371",
        height: "164",
        viewBox: "0 0 371 164",
        role: "img",
        "aria-label": "A check with the routing number highlighted in the lower left hand corner"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-365 -522)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(333 360)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(32 162)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "370.8",
        height: "163.2",
        x: "0",
        y: "0",
        fill: "#E1E1E1",
        rx: "2.4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "104.4",
        height: "14.4",
        x: "14.4",
        y: "14.4",
        fill: "#BBB",
        rx: "1.2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "69.6",
        height: "14.4",
        x: "286.8",
        y: "14.4",
        fill: "#BBB",
        rx: "2.4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "87.6",
        height: "14.4",
        x: "14.4",
        y: "33.6",
        fill: "#BBB",
        rx: "1.2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#BBB",
        d: "M14.4000006 96.0000038L356.400014 96.0000038 356.400014 98.4000039 14.4000006 98.4000039z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#BBB",
        d: "M267.600011 140.400006L356.400014 140.400006 356.400014 142.800006 267.600011 142.800006z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#BBB",
        d: "M14.4000006 76.8000031L208.800008 76.8000031 208.800008 79.2000031 14.4000006 79.2000031z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "112.8",
        height: "25.2",
        x: "243",
        y: "53.4",
        fill: "#FFF",
        stroke: "#BBB",
        strokeWidth: "1.2",
        rx: "2.4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "129.6",
        height: "27.6",
        x: "16.2",
        y: "120.6",
        fill: "#B3D1E8",
        stroke: "#357FB8",
        strokeWidth: "1.2",
        rx: "2.4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#000",
        d: "M25.863 137.872a.363.363 0 01-.145-.03.333.333 0 01-.124-.08.343.343 0 01-.08-.12.4.4 0 01-.03-.149v-5.374c0-.046.01-.094.03-.144a.365.365 0 01.08-.125.365.365 0 01.124-.08.53.53 0 01.072-.024.28.28 0 01.073-.01h1.06c.05 0 .1.011.15.035a.395.395 0 01.234.349v5.373c0 .03-.004.06-.012.087a.377.377 0 01-.242.271 1.03 1.03 0 00-.062.013.298.298 0 01-.067.008h-1.061zm4.238 1.613a.473.473 0 01-.16-.03.514.514 0 01-.129-.084.398.398 0 01-.12-.289v-2.122c0-.026.004-.053.01-.08a.493.493 0 01.026-.074.38.38 0 01.146-.182.383.383 0 01.145-.062.358.358 0 01.082-.01h2.112c.026 0 .053.003.08.01a.734.734 0 01.08.025.45.45 0 01.218.219c.02.05.03.101.03.154v2.122c0 .053-.01.106-.03.16a.417.417 0 01-.379.244h-2.11zm0-6.385a.473.473 0 01-.16-.03.383.383 0 01-.129-.089.414.414 0 01-.09-.13.425.425 0 01-.03-.159v-2.117a.468.468 0 01.12-.289c.02-.02.04-.037.062-.052a.228.228 0 01.068-.032.237.237 0 01.077-.028.473.473 0 01.082-.007h2.112c.026 0 .053.002.08.007a.303.303 0 01.08.028c.049.02.092.048.129.085.04.036.07.08.09.129.02.053.03.106.03.16v2.116c0 .057-.01.11-.03.16a.414.414 0 01-.09.129.35.35 0 01-.13.09.425.425 0 01-.16.03h-2.11zm10.618-2.46v4.308a.522.522 0 00.06.244.734.734 0 00.14.204.553.553 0 00.094.075.891.891 0 00.11.06c.036.013.073.025.11.035.036.01.07.015.099.015h1.126c.03 0 .058 0 .084.002a.275.275 0 01.08.018.443.443 0 01.164.15.973.973 0 01.038.049c.011.017.02.033.027.05.013.036.02.076.02.12v3.247a.368.368 0 01-.007.072.185.185 0 01-.028.067.394.394 0 01-.08.115.498.498 0 01-.129.094.323.323 0 01-.135.035H39.22a.292.292 0 01-.11-.03 3.315 3.315 0 00-.059-.035.217.217 0 01-.06-.05.19.19 0 01-.045-.054l-.04-.07a.374.374 0 01-.034-.125v-3.277a.354.354 0 01.035-.134.383.383 0 01.08-.12.374.374 0 01.125-.09.323.323 0 01.133-.034h.18c.01 0 .025-.004.047-.013l.067-.027a.639.639 0 00.13-.09l.044-.055c.017-.02.03-.04.04-.06a.24.24 0 00.03-.104v-3.267a.227.227 0 00-.04-.13.393.393 0 00-.144-.156.476.476 0 00-.135-.063.158.158 0 00-.044-.01h-.175a.223.223 0 01-.06-.01.585.585 0 01-.07-.025.7.7 0 01-.064-.037.358.358 0 01-.107-.107.7.7 0 01-.037-.065.585.585 0 01-.025-.07.237.237 0 01-.01-.064v-.578a.34.34 0 01.035-.154c.01-.02.023-.04.04-.06a.511.511 0 01.154-.134.354.354 0 01.144-.035h1.09a.354.354 0 01.134.035c.025.01.048.021.071.034a.281.281 0 01.06.045c.02.02.036.04.05.062a.813.813 0 01.035.063.3.3 0 01.034.134zm8.741-.503h3.218c.05 0 .096.01.139.03a.583.583 0 01.22.207c.02.035.03.064.034.087a.218.218 0 010 .08v4.323a.176.176 0 01-.012.054.584.584 0 01-.028.065.404.404 0 01-.09.12.818.818 0 01-.054.05.312.312 0 01-.06.04.23.23 0 01-.065.03.27.27 0 01-.074.01H50.57a.62.62 0 00-.438.194.715.715 0 00-.15.204.693.693 0 00-.04.112.443.443 0 00-.015.112v2.136c0 .034.004.07.013.107.008.039.019.076.032.112.017.034.036.069.057.105a.553.553 0 00.271.244c.04.017.079.03.115.042.037.012.07.018.1.018h2.172c.05 0 .097.012.144.037a.442.442 0 01.12.092c.036.04.066.085.09.135.022.05.034.101.034.154a.488.488 0 01-.105.299.423.423 0 01-.122.1.33.33 0 01-.161.04h-3.213a.299.299 0 01-.14-.04.374.374 0 01-.07-.04 1.098 1.098 0 01-.064-.05 1.099 1.099 0 01-.05-.065.374.374 0 01-.04-.07.323.323 0 01-.034-.134l-.005-2.147v-2.146a.34.34 0 01.04-.155.243.243 0 01.042-.072.513.513 0 01.117-.112.229.229 0 01.07-.035.31.31 0 01.124-.035h2.127a.4.4 0 00.117-.017c.038-.012.077-.026.117-.042a.584.584 0 00.204-.155.434.434 0 00.07-.092.821.821 0 00.087-.216.585.585 0 00.012-.12v-2.097a.527.527 0 00-.012-.112 1.128 1.128 0 00-.032-.117.739.739 0 00-.217-.286.494.494 0 00-.102-.062.55.55 0 00-.11-.05.362.362 0 00-.114-.02h-2.157a.305.305 0 01-.12-.035.513.513 0 01-.187-.157.384.384 0 01-.042-.396.507.507 0 01.1-.144.36.36 0 01.254-.12zm9.124-.005h3.248a.378.378 0 01.134.03c.047.02.09.048.13.085a.427.427 0 01.094.114.271.271 0 01.035.13l-.005 1.922v1.923a.727.727 0 00.134.393c.02.027.044.052.07.077a.341.341 0 00.08.058c.03.016.06.03.092.042a.293.293 0 00.102.017h.15l.15.005a.182.182 0 01.095.035c.032.02.06.047.083.08.024.03.042.066.055.11a.81.81 0 01.018.06c.005.02.007.037.007.054v3.815c0 .02-.002.04-.007.06a.81.81 0 01-.018.06.562.562 0 01-.065.11.49.49 0 01-.154.119.391.391 0 01-.075.037.183.183 0 01-.06.012h-4.273a.335.335 0 01-.12-.024.443.443 0 01-.124-.075.5.5 0 01-.1-.132.405.405 0 01-.044-.197c0-.086.015-.158.045-.214.03-.056.066-.1.11-.13a.424.424 0 01.23-.08h1.084l1.09-.004a.35.35 0 00.075-.015.946.946 0 00.115-.04.816.816 0 00.127-.062.347.347 0 00.097-.082.414.414 0 00.077-.093.95.95 0 00.058-.107.462.462 0 00.05-.209v-2.141a.667.667 0 00-.055-.234.63.63 0 00-.14-.215.561.561 0 00-.19-.14.527.527 0 00-.238-.054h-2.142a.337.337 0 01-.189-.052.416.416 0 01-.124-.122.516.516 0 01-.085-.26.49.49 0 01.125-.299.462.462 0 01.126-.089.335.335 0 01.147-.035h2.137a.533.533 0 00.244-.054.604.604 0 00.334-.349.724.724 0 00.05-.259l.004-1.03.01-1.037a.635.635 0 00-.044-.239.502.502 0 00-.053-.097.71.71 0 00-.192-.197 1.028 1.028 0 00-.124-.074.78.78 0 00-.24-.05h-2.14a.38.38 0 01-.24-.1.39.39 0 01-.1-.132.447.447 0 01-.04-.197c0-.076.014-.141.04-.196a.39.39 0 01.1-.132.346.346 0 01.23-.1zm10.255 0c.04 0 .083.012.13.035a.7.7 0 01.064.037.388.388 0 01.115.112l.045.065a.302.302 0 01.04.145v5.349a.598.598 0 00.05.239.663.663 0 00.149.224.475.475 0 00.2.134c.072.033.143.05.213.05h1.16c.03 0 .065-.004.103-.012a2.21 2.21 0 00.112-.028.657.657 0 00.204-.12.662.662 0 00.13-.2.59.59 0 00.044-.213v-.164a.298.298 0 01.03-.13.273.273 0 01.08-.11.138.138 0 01.055-.039.55.55 0 01.19-.045h1.17c.033 0 .07.01.109.03a.512.512 0 01.12.09.36.36 0 01.054.057.216.216 0 01.035.062c.027.047.04.09.04.13l-.005 1.628v1.624a.33.33 0 01-.03.13.47.47 0 01-.14.176 1.037 1.037 0 01-.064.048.302.302 0 01-.145.04h-1.095a.374.374 0 01-.15-.035.374.374 0 01-.07-.04 1.098 1.098 0 01-.064-.05.45.45 0 01-.125-.249v-1.126a.345.345 0 00-.017-.104 2.844 2.844 0 00-.037-.11.506.506 0 00-.063-.11 1.469 1.469 0 00-.077-.094 1.04 1.04 0 00-.095-.075.45.45 0 00-.104-.054.527.527 0 00-.21-.045l-1.623-.005h-1.624a.365.365 0 01-.221-.082.451.451 0 01-.11-.115 2.343 2.343 0 01-.032-.052.484.484 0 01-.04-.13v-6.37c0-.036.003-.071.01-.104l.02-.095c.02-.06.05-.11.09-.15.023-.02.048-.04.074-.06a.37.37 0 01.075-.044.493.493 0 01.067-.032.155.155 0 01.053-.013h1.11zm14.419.005c.046 0 .094.008.144.023.05.014.093.04.13.077.04.033.072.077.097.132a.46.46 0 01.037.191.37.37 0 01-.04.197.449.449 0 01-.353.237h-1.584l-1.579-.005a.455.455 0 00-.11.015.667.667 0 00-.221.1.636.636 0 00-.097.079.606.606 0 00-.16.21.855.855 0 00-.042.114.409.409 0 00-.017.114l.004 1.056v1.056c0 .063.015.131.045.204.03.073.072.14.125.2.03.033.062.064.097.094s.07.055.107.075c.04.023.081.041.125.055.043.013.088.02.134.02h3.183a.3.3 0 01.134.034c.023.01.046.024.07.043a.452.452 0 01.112.115.25.25 0 01.032.061.243.243 0 01.028.07.332.332 0 01.007.07v4.308a.327.327 0 01-.035.144.32.32 0 01-.035.063.444.444 0 01-.18.162.34.34 0 01-.143.034h-4.284a.285.285 0 01-.134-.037.635.635 0 01-.13-.092.585.585 0 01-.092-.135.341.341 0 01-.037-.154c0-.063 0-.122-.003-.177a.266.266 0 01.028-.137c.02-.04.059-.071.117-.094a.762.762 0 01.266-.035h3.183a.472.472 0 00.114-.015.667.667 0 00.115-.04 1.89 1.89 0 00.11-.065.583.583 0 00.1-.08.54.54 0 00.134-.184.534.534 0 00.054-.229v-2.176a.508.508 0 00-.06-.21.557.557 0 00-.067-.109 1.04 1.04 0 00-.087-.1 1.04 1.04 0 00-.194-.134.496.496 0 00-.194-.045h-3.208a.215.215 0 01-.067-.012.545.545 0 01-.212-.122.474.474 0 01-.09-.125.332.332 0 01-.034-.14v-4.307a.357.357 0 01.017-.07.436.436 0 01.17-.237l.062-.042a.645.645 0 01.154-.05h2.127l2.127.005zm8.088-.005a.348.348 0 01.16.045c.03.013.056.03.079.05a.596.596 0 01.15.189.34.34 0 01.03.134v1.614a.336.336 0 01-.038.157.454.454 0 01-.097.127.486.486 0 01-.294.11.878.878 0 01-.167-.015.371.371 0 01-.137-.055.283.283 0 01-.097-.12.483.483 0 01-.037-.204v-.264l-.005-.259a.455.455 0 00-.015-.11 1.154 1.154 0 00-.035-.114.823.823 0 00-.062-.12.587.587 0 00-.083-.104.848.848 0 00-.204-.144.583.583 0 00-.234-.055h-1.02a.657.657 0 00-.528.291.717.717 0 00-.11.234.503.503 0 00-.015.117l.005 1.599v1.594a.44.44 0 00.012.102.693.693 0 00.157.306c.06.067.13.118.21.155.04.02.08.035.124.047a.515.515 0 00.134.017h4.244c.043 0 .088.013.137.038a.509.509 0 01.219.214.27.27 0 01.037.132v3.232c0 .02-.004.042-.012.067a1.742 1.742 0 00-.023.073.374.374 0 01-.04.07 1.098 1.098 0 01-.05.064.64.64 0 01-.062.055.312.312 0 01-.067.04.28.28 0 01-.14.04h-5.339a.238.238 0 01-.07-.013.376.376 0 01-.074-.032.58.58 0 01-.14-.1.399.399 0 01-.102-.187.298.298 0 01-.007-.067v-4.268l-.005-4.273c0-.024.004-.049.013-.075a.565.565 0 01.117-.2.47.47 0 01.134-.094.323.323 0 01.134-.035l1.61-.005h1.603zm-2.127 8.497h3.148a.607.607 0 00.438-.2.707.707 0 00.19-.478v-.966a.707.707 0 00-.19-.478.577.577 0 00-.438-.194h-3.148a.58.58 0 00-.244.052.632.632 0 00-.199.142.723.723 0 00-.18.478v.966a.723.723 0 00.18.478c.056.06.123.109.2.145a.558.558 0 00.243.055zm14.429-8.497a.47.47 0 01.261.08.787.787 0 01.067.05c.024.02.043.041.058.064a.7.7 0 01.037.065.493.493 0 01.035.15v1.773l-.005 1.773c0 .013 0 .03-.003.05a.72.72 0 00-.002.06.386.386 0 01-.065.164.168.168 0 01-.045.04.454.454 0 01-.042.037.195.195 0 01-.047.027l-.384.18-.383.174-.767.358a.472.472 0 00-.077.038.749.749 0 00-.192.152 4.29 4.29 0 01-.043.062.25.25 0 00-.032.062l-.02.062a.211.211 0 00-.01.063l.005 1.733v1.733a.426.426 0 01-.037.187.374.374 0 01-.234.194.578.578 0 01-.162.022.354.354 0 01-.16-.04.606.606 0 01-.139-.094.415.415 0 01-.102-.127.307.307 0 01-.037-.142v-4.094c0-.023.003-.046.01-.067.006-.022.013-.042.02-.062l.04-.068a.311.311 0 01.044-.057 1.75 1.75 0 01.11-.1 1.176 1.176 0 01.11-.064l.702-.314.697-.309.082-.035a.944.944 0 00.092-.045.438.438 0 00.087-.064.285.285 0 00.067-.1.221.221 0 00.02-.04.56.56 0 00.02-.154v-1.843a.527.527 0 00-.012-.112 1.128 1.128 0 00-.033-.117.462.462 0 00-.057-.115.984.984 0 00-.177-.194.46.46 0 00-.114-.07.527.527 0 00-.244-.064H100.5a.5.5 0 00-.214.055.639.639 0 00-.2.134.957.957 0 00-.149.224.76.76 0 00-.05.25v1.05c0 .05-.01.099-.032.147a.422.422 0 01-.087.127.417.417 0 01-.284.134.385.385 0 01-.197-.04.456.456 0 01-.142-.109.464.464 0 01-.09-.137.332.332 0 01-.03-.122v-1.05l.006-1.047c0-.05.003-.093.01-.13a.284.284 0 01.03-.089.303.303 0 01.047-.07l.057-.064c.043-.04.09-.07.14-.09a.372.372 0 01.159-.035h4.174zm5.921 4.164h2.197a.55.55 0 00.518-.356.594.594 0 00.045-.232v-2.112a.594.594 0 00-.165-.418.558.558 0 00-.398-.174h-2.197a.52.52 0 00-.221.047.566.566 0 00-.177.127.66.66 0 00-.122.187.567.567 0 00-.047.231v2.112c0 .083.015.16.047.232a.66.66 0 00.122.186.534.534 0 00.398.17zm.03 4.248h2.137c.08 0 .156-.016.229-.047a.651.651 0 00.19-.122.57.57 0 00.179-.414v-2.226a.555.555 0 00-.18-.413.651.651 0 00-.189-.122.572.572 0 00-.23-.048H109.6a.567.567 0 00-.231.048.74.74 0 00-.192.122.572.572 0 00-.174.413v2.226c0 .08.015.156.047.227a.61.61 0 00.127.187c.056.05.12.09.192.122a.567.567 0 00.231.047zm-2.56.448v-3.934a.21.21 0 01.035-.115.251.251 0 01.08-.09l.075-.05a.446.446 0 01.239-.069h.289a.157.157 0 00.06-.015l.064-.03a.763.763 0 00.14-.104.895.895 0 00.1-.12.226.226 0 00.039-.114v-3.81a.451.451 0 01.045-.18.963.963 0 01.045-.08.268.268 0 01.054-.064.318.318 0 01.065-.057.603.603 0 01.174-.083h2.122l2.122-.005c.05 0 .103.017.16.05l.084.055a.4.4 0 01.08.07c.04.036.07.074.09.112.02.038.034.072.044.102a.555.555 0 01.015.134v3.76c0 .024.004.048.012.073a.514.514 0 00.028.067.23.23 0 00.042.065l.052.055a.783.783 0 00.12.08l.08.027a.266.266 0 00.08.012h.253a.28.28 0 01.144.045c.02.01.04.023.06.04a.7.7 0 00.06.045.292.292 0 01.08.12c.02.049.03.095.03.139l-.005 1.085v2.794a.29.29 0 01-.013.083 1.191 1.191 0 01-.027.082.963.963 0 01-.1.154.423.423 0 01-.139.11.535.535 0 01-.08.032.266.266 0 01-.08.012h-6.33a.282.282 0 01-.09-.014.997.997 0 01-.089-.035.436.436 0 01-.085-.05.696.696 0 01-.136-.14.67.67 0 01-.048-.08.409.409 0 01-.04-.164zm11.76-8.87h5.244a.43.43 0 01.318.135.58.58 0 01.058.067c.018.025.032.05.042.077.01.023.02.05.027.08.009.03.013.061.013.094v8.467a.393.393 0 01-.065.22.408.408 0 01-.2.17.418.418 0 01-.188.043h-1.051a.302.302 0 01-.14-.04 1.86 1.86 0 01-.067-.047.54.54 0 01-.152-.167.265.265 0 01-.03-.119v-3.212a.63.63 0 00-.05-.244.602.602 0 00-.13-.2.753.753 0 00-.099-.092.557.557 0 00-.231-.11.451.451 0 00-.122-.017h-3.178a.483.483 0 01-.184-.04.396.396 0 01-.15-.11.322.322 0 01-.08-.139.734.734 0 01-.024-.08.309.309 0 01-.01-.074v-4.214a.451.451 0 01.045-.184.399.399 0 01.105-.144.388.388 0 01.064-.053.672.672 0 01.152-.057.358.358 0 01.082-.01zm1.05 4.244h3.118a.607.607 0 00.254-.055.568.568 0 00.112-.063.642.642 0 00.237-.291.778.778 0 00.04-.124.596.596 0 00.014-.135v-2.042a.756.756 0 00-.112-.376.77.77 0 00-.179-.18.568.568 0 00-.234-.099.724.724 0 00-.132-.012h-3.118a.624.624 0 00-.326.087.816.816 0 00-.092.062.957.957 0 00-.097.102.559.559 0 00-.078.122.725.725 0 00-.064.294v2.042a.678.678 0 00.112.369.697.697 0 00.286.244c.04.013.081.025.125.037a.515.515 0 00.134.018zm8.014 3.506a.363.363 0 01-.145-.03.333.333 0 01-.124-.08.343.343 0 01-.08-.12.4.4 0 01-.03-.149v-5.374c0-.046.01-.094.03-.144a.365.365 0 01.08-.125.365.365 0 01.124-.08.53.53 0 01.072-.024.28.28 0 01.073-.01h1.06c.05 0 .1.011.15.035a.395.395 0 01.234.349v5.373c0 .03-.004.06-.012.087a.377.377 0 01-.242.271 1.03 1.03 0 00-.062.013.298.298 0 01-.067.008h-1.061zm4.238 1.613a.473.473 0 01-.16-.03.514.514 0 01-.129-.084.398.398 0 01-.12-.289v-2.122c0-.026.004-.053.01-.08a.493.493 0 01.026-.074.381.381 0 01.146-.182.383.383 0 01.145-.062.358.358 0 01.082-.01h2.112c.026 0 .053.003.08.01a.734.734 0 01.08.025.45.45 0 01.218.219c.02.05.03.101.03.154v2.122c0 .053-.01.106-.03.16a.417.417 0 01-.379.244h-2.11zm0-6.385a.473.473 0 01-.16-.03.383.383 0 01-.129-.089.414.414 0 01-.09-.13.425.425 0 01-.03-.159v-2.117a.468.468 0 01.12-.289c.02-.02.04-.037.062-.052a.228.228 0 01.068-.032.237.237 0 01.077-.028.473.473 0 01.082-.007h2.112c.026 0 .053.002.08.007a.303.303 0 01.08.028c.049.02.092.048.129.085.04.036.07.08.09.129.02.053.03.106.03.16v2.116c0 .057-.01.11-.03.16a.414.414 0 01-.09.129.35.35 0 01-.13.09.425.425 0 01-.16.03h-2.11z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#000",
        d: "M164.258 130.137c.046 0 .094.008.144.023.05.014.093.04.13.077.04.033.072.077.097.132a.46.46 0 01.037.191.37.37 0 01-.04.197.449.449 0 01-.353.237h-1.584l-1.579-.005a.455.455 0 00-.11.015.667.667 0 00-.221.1.636.636 0 00-.097.079.606.606 0 00-.16.21.855.855 0 00-.042.114.409.409 0 00-.017.114l.004 1.056v1.056c0 .063.015.131.045.204.03.073.072.14.125.2.03.033.062.064.097.094s.07.055.107.075c.04.023.081.041.125.055.043.013.088.02.134.02h3.183a.3.3 0 01.134.034c.023.01.046.024.07.043a.452.452 0 01.112.115.25.25 0 01.032.061.243.243 0 01.028.07.332.332 0 01.007.07v4.308a.327.327 0 01-.035.144.32.32 0 01-.035.063.444.444 0 01-.18.162.34.34 0 01-.143.034h-4.284a.285.285 0 01-.134-.037.635.635 0 01-.13-.092.585.585 0 01-.092-.135.341.341 0 01-.037-.154c0-.063 0-.122-.003-.177a.266.266 0 01.028-.137c.02-.04.059-.071.117-.094a.762.762 0 01.266-.035h3.183a.472.472 0 00.114-.015.667.667 0 00.115-.04 1.89 1.89 0 00.11-.065.583.583 0 00.1-.08.54.54 0 00.134-.184.534.534 0 00.054-.229v-2.176a.508.508 0 00-.06-.21.557.557 0 00-.067-.109 1.04 1.04 0 00-.087-.1 1.04 1.04 0 00-.194-.134.496.496 0 00-.194-.045h-3.208a.215.215 0 01-.067-.012.545.545 0 01-.212-.122.474.474 0 01-.09-.125.332.332 0 01-.034-.14v-4.307a.357.357 0 01.017-.07.436.436 0 01.17-.237l.062-.042a.645.645 0 01.154-.05h2.127l2.127.005zm10.2 0c.046 0 .094.008.144.023.05.014.093.04.13.077.04.033.072.077.097.132a.46.46 0 01.037.191.37.37 0 01-.04.197.449.449 0 01-.353.237h-1.584l-1.579-.005a.455.455 0 00-.11.015.667.667 0 00-.221.1.636.636 0 00-.097.079.606.606 0 00-.16.21.855.855 0 00-.042.114.409.409 0 00-.017.114l.004 1.056v1.056c0 .063.015.131.045.204.03.073.072.14.125.2.03.033.062.064.097.094s.07.055.107.075c.04.023.081.041.125.055.043.013.088.02.134.02h3.183a.3.3 0 01.134.034c.023.01.046.024.07.043a.452.452 0 01.112.115.25.25 0 01.032.061.243.243 0 01.028.07.332.332 0 01.007.07v4.308a.328.328 0 01-.035.144.32.32 0 01-.035.063.444.444 0 01-.18.162.34.34 0 01-.143.034h-4.284a.285.285 0 01-.134-.037.635.635 0 01-.13-.092.585.585 0 01-.092-.135.341.341 0 01-.037-.154c0-.063 0-.122-.003-.177a.266.266 0 01.028-.137c.02-.04.059-.071.117-.094a.762.762 0 01.266-.035h3.183a.472.472 0 00.114-.015.667.667 0 00.115-.04 1.89 1.89 0 00.11-.065.583.583 0 00.1-.08.54.54 0 00.134-.184.534.534 0 00.054-.229v-2.176a.508.508 0 00-.06-.21.557.557 0 00-.067-.109 1.039 1.039 0 00-.087-.1 1.04 1.04 0 00-.194-.134.496.496 0 00-.194-.045h-3.208a.215.215 0 01-.067-.012.545.545 0 01-.212-.122.474.474 0 01-.09-.125.332.332 0 01-.034-.14v-4.307a.357.357 0 01.017-.07.436.436 0 01.17-.237l.062-.042a.645.645 0 01.154-.05h2.127l2.127.005zm5.911 4.159h2.197a.55.55 0 00.518-.356.594.594 0 00.045-.232v-2.112a.594.594 0 00-.165-.418.558.558 0 00-.398-.174h-2.197a.52.52 0 00-.221.047.566.566 0 00-.177.127.66.66 0 00-.122.187.567.567 0 00-.047.231v2.112c0 .083.015.16.047.232a.66.66 0 00.122.186.534.534 0 00.398.17zm.03 4.248h2.137c.08 0 .156-.016.229-.047a.651.651 0 00.19-.122.57.57 0 00.179-.414v-2.226a.555.555 0 00-.18-.413.651.651 0 00-.189-.122.572.572 0 00-.23-.048H180.4a.567.567 0 00-.231.048.74.74 0 00-.192.122.572.572 0 00-.174.413v2.226c0 .08.015.156.047.227a.61.61 0 00.127.187c.056.05.12.09.192.122a.567.567 0 00.231.047zm-2.56.448v-3.934a.21.21 0 01.035-.115.251.251 0 01.08-.09 1.46 1.46 0 01.075-.05.446.446 0 01.239-.069h.289a.157.157 0 00.06-.015l.064-.03a.763.763 0 00.14-.104.895.895 0 00.1-.12.226.226 0 00.039-.114v-3.81a.451.451 0 01.045-.18.964.964 0 01.045-.08.268.268 0 01.054-.064.318.318 0 01.065-.057.603.603 0 01.174-.083h2.122l2.122-.005c.05 0 .103.017.16.05l.084.055a.4.4 0 01.08.07c.04.036.07.074.09.112.02.038.034.072.044.102a.555.555 0 01.015.134v3.76c0 .024.004.048.012.073a.514.514 0 00.028.067.23.23 0 00.042.065l.052.055a.783.783 0 00.12.08l.08.027a.266.266 0 00.08.012h.253a.28.28 0 01.144.045c.02.01.04.023.06.04a.7.7 0 00.06.045.292.292 0 01.08.12c.02.049.03.095.03.139l-.005 1.085v2.794a.29.29 0 01-.013.083 1.191 1.191 0 01-.027.082.963.963 0 01-.1.154.423.423 0 01-.139.11.535.535 0 01-.08.032.266.266 0 01-.08.012h-6.33a.282.282 0 01-.09-.014.997.997 0 01-.089-.035.436.436 0 01-.085-.05.696.696 0 01-.136-.14.67.67 0 01-.048-.08.409.409 0 01-.04-.164zm11.76-8.87h5.244a.43.43 0 01.318.135.58.58 0 01.058.067c.018.025.032.05.042.077.01.023.02.05.027.08.009.03.013.061.013.094v8.467a.393.393 0 01-.065.22.408.408 0 01-.2.17.418.418 0 01-.188.043h-1.051a.302.302 0 01-.14-.04 1.86 1.86 0 01-.067-.047.54.54 0 01-.152-.167.265.265 0 01-.03-.119v-3.212a.63.63 0 00-.05-.244.602.602 0 00-.13-.2.753.753 0 00-.099-.092.557.557 0 00-.231-.11.451.451 0 00-.122-.017h-3.178a.483.483 0 01-.184-.04.396.396 0 01-.15-.11.321.321 0 01-.08-.139.734.734 0 01-.024-.08.309.309 0 01-.01-.074v-4.214a.45.45 0 01.045-.184.399.399 0 01.105-.144.388.388 0 01.064-.053.672.672 0 01.152-.057.358.358 0 01.082-.01zm1.05 4.244h3.118a.607.607 0 00.254-.055.568.568 0 00.112-.063.642.642 0 00.237-.291.778.778 0 00.04-.124.596.596 0 00.014-.135v-2.042a.756.756 0 00-.112-.376.77.77 0 00-.179-.18.568.568 0 00-.234-.099.724.724 0 00-.132-.012h-3.118a.624.624 0 00-.326.087.816.816 0 00-.092.062.957.957 0 00-.097.102.559.559 0 00-.078.122.725.725 0 00-.064.294v2.042a.678.678 0 00.112.369.697.697 0 00.286.244c.04.013.081.025.125.037a.515.515 0 00.134.018zm12.67-3.726v4.308a.522.522 0 00.06.244.734.734 0 00.14.204.553.553 0 00.094.075.891.891 0 00.11.06c.036.013.073.025.11.035.036.01.07.015.099.015h1.126c.03 0 .058 0 .084.002a.275.275 0 01.08.018.443.443 0 01.164.15.972.972 0 01.038.049c.011.017.02.033.027.05.013.036.02.076.02.12v3.247a.368.368 0 01-.007.072.185.185 0 01-.028.067.394.394 0 01-.08.115.498.498 0 01-.129.094.323.323 0 01-.135.035h-3.272a.292.292 0 01-.11-.03 3.314 3.314 0 00-.059-.035.217.217 0 01-.06-.05.19.19 0 01-.045-.054l-.04-.07a.374.374 0 01-.034-.125v-3.277a.354.354 0 01.035-.134.383.383 0 01.08-.12.374.374 0 01.125-.09.323.323 0 01.133-.034h.18c.01 0 .025-.004.047-.013l.067-.027a.639.639 0 00.13-.09 3.56 3.56 0 01.044-.055c.017-.02.03-.04.04-.06a.24.24 0 00.03-.104v-3.267a.227.227 0 00-.04-.13.392.392 0 00-.144-.156.476.476 0 00-.135-.063.158.158 0 00-.044-.01h-.175a.223.223 0 01-.06-.01.585.585 0 01-.07-.025.7.7 0 01-.064-.037.358.358 0 01-.107-.107.7.7 0 01-.037-.065.585.585 0 01-.025-.07.237.237 0 01-.01-.064v-.578a.34.34 0 01.035-.154c.01-.02.023-.04.04-.06a.511.511 0 01.154-.134.354.354 0 01.144-.035h1.09a.354.354 0 01.134.035c.025.01.048.021.071.034a.281.281 0 01.06.045c.02.02.036.04.05.062a.813.813 0 01.035.063.3.3 0 01.034.134zm8.741-.503h3.218c.05 0 .096.01.139.03a.583.583 0 01.22.207c.02.035.03.064.034.087a.218.218 0 010 .08v4.323a.176.176 0 01-.012.054.584.584 0 01-.028.065.404.404 0 01-.09.12.818.818 0 01-.054.05.312.312 0 01-.06.04.23.23 0 01-.065.03.27.27 0 01-.074.01h-2.117a.62.62 0 00-.438.194.715.715 0 00-.15.204.693.693 0 00-.04.112.443.443 0 00-.015.112v2.136c0 .034.004.07.013.107.008.039.019.076.032.112.017.034.036.069.057.105a.553.553 0 00.271.244c.04.017.079.03.115.042.037.012.07.018.1.018h2.172c.05 0 .097.012.144.037a.442.442 0 01.12.092c.036.04.066.085.09.135.022.05.034.101.034.154a.488.488 0 01-.105.299.423.423 0 01-.122.1.33.33 0 01-.161.04h-3.213a.299.299 0 01-.14-.04.374.374 0 01-.07-.04 1.099 1.099 0 01-.064-.05 1.099 1.099 0 01-.05-.065.374.374 0 01-.04-.07.323.323 0 01-.034-.134l-.005-2.147v-2.146a.34.34 0 01.04-.155.243.243 0 01.042-.072.513.513 0 01.117-.112.229.229 0 01.07-.035.31.31 0 01.124-.035h2.127a.4.4 0 00.117-.017c.038-.012.077-.026.117-.042a.584.584 0 00.204-.155.434.434 0 00.07-.092.821.821 0 00.087-.216.585.585 0 00.012-.12v-2.097a.527.527 0 00-.012-.112 1.128 1.128 0 00-.032-.117.739.739 0 00-.217-.286.494.494 0 00-.102-.062.55.55 0 00-.11-.05.362.362 0 00-.114-.02h-2.157a.305.305 0 01-.12-.035.513.513 0 01-.187-.157.384.384 0 01-.042-.396.507.507 0 01.1-.144.36.36 0 01.254-.12zm9.11 4.159h2.196a.55.55 0 00.518-.356.594.594 0 00.045-.232v-2.112a.594.594 0 00-.165-.418.558.558 0 00-.398-.174h-2.197a.52.52 0 00-.221.047.566.566 0 00-.177.127.66.66 0 00-.122.187.567.567 0 00-.047.231v2.112c0 .083.015.16.047.232a.66.66 0 00.122.186.534.534 0 00.398.17zm.03 4.248h2.136c.08 0 .156-.016.229-.047a.651.651 0 00.19-.122.57.57 0 00.179-.414v-2.226a.555.555 0 00-.18-.413.651.651 0 00-.189-.122.572.572 0 00-.23-.048H221.2a.567.567 0 00-.231.048.74.74 0 00-.192.122.572.572 0 00-.174.413v2.226c0 .08.015.156.047.227a.61.61 0 00.127.187c.056.05.12.09.192.122a.567.567 0 00.231.047zm-2.56.448v-3.934a.21.21 0 01.034-.115.251.251 0 01.08-.09l.075-.05a.446.446 0 01.239-.069h.289a.157.157 0 00.06-.015l.064-.03a.763.763 0 00.14-.104.895.895 0 00.1-.12.226.226 0 00.039-.114v-3.81a.451.451 0 01.045-.18.963.963 0 01.045-.08.268.268 0 01.054-.064.318.318 0 01.065-.057.603.603 0 01.174-.083h2.122l2.122-.005c.05 0 .103.017.16.05l.084.055a.4.4 0 01.08.07c.04.036.07.074.09.112.02.038.034.072.044.102a.555.555 0 01.015.134v3.76c0 .024.004.048.012.073a.514.514 0 00.028.067.23.23 0 00.042.065l.052.055a.783.783 0 00.12.08l.08.027a.266.266 0 00.08.012h.253a.28.28 0 01.144.045c.02.01.04.023.06.04a.7.7 0 00.06.045.292.292 0 01.08.12c.02.049.03.095.03.139l-.005 1.085v2.794a.29.29 0 01-.013.083 1.191 1.191 0 01-.027.082.963.963 0 01-.1.154.423.423 0 01-.139.11.535.535 0 01-.08.032.266.266 0 01-.08.012h-6.33a.282.282 0 01-.09-.014.997.997 0 01-.089-.035.436.436 0 01-.085-.05.697.697 0 01-.136-.14.67.67 0 01-.048-.08.409.409 0 01-.04-.164zm17.018-8.855c.046 0 .094.008.144.023.05.014.093.04.13.077.04.033.072.077.097.132a.46.46 0 01.037.191.37.37 0 01-.04.197.449.449 0 01-.353.237h-1.584l-1.579-.005a.455.455 0 00-.11.015.667.667 0 00-.221.1.636.636 0 00-.097.079.606.606 0 00-.16.21.855.855 0 00-.042.114.409.409 0 00-.017.114l.004 1.056v1.056c0 .063.015.131.045.204.03.073.072.14.125.2.03.033.062.064.097.094s.07.055.107.075c.04.023.081.041.125.055.043.013.088.02.134.02h3.183a.3.3 0 01.134.034c.023.01.046.024.07.043a.452.452 0 01.112.115.25.25 0 01.032.061.243.243 0 01.028.07.332.332 0 01.007.07v4.308a.327.327 0 01-.035.144.32.32 0 01-.035.063.444.444 0 01-.18.162.34.34 0 01-.143.034h-4.284a.285.285 0 01-.134-.037.635.635 0 01-.13-.092.585.585 0 01-.092-.135.341.341 0 01-.037-.154c0-.063 0-.122-.003-.177a.266.266 0 01.028-.137c.02-.04.059-.071.117-.094a.762.762 0 01.266-.035h3.183a.472.472 0 00.114-.015.667.667 0 00.115-.04 1.89 1.89 0 00.11-.065.583.583 0 00.1-.08.54.54 0 00.134-.184.534.534 0 00.054-.229v-2.176a.508.508 0 00-.06-.21.557.557 0 00-.067-.109 1.04 1.04 0 00-.087-.1 1.04 1.04 0 00-.194-.134.496.496 0 00-.194-.045h-3.208a.215.215 0 01-.067-.012.545.545 0 01-.212-.122.474.474 0 01-.09-.125.332.332 0 01-.034-.14v-4.307a.357.357 0 01.017-.07.436.436 0 01.17-.237l.062-.042a.645.645 0 01.154-.05h2.127l2.127.005zm8.088 4.517a.432.432 0 01-.08-.007.827.827 0 01-.074-.018.228.228 0 01-.068-.032.414.414 0 01-.057-.047.296.296 0 01-.085-.115.374.374 0 01-.025-.064.27.27 0 01-.01-.075v-3.277a.27.27 0 01.01-.075.374.374 0 01.025-.065.355.355 0 01.085-.114.365.365 0 01.279-.105h2.122a.393.393 0 01.149.03c.053.02.096.045.13.075.033.03.06.068.084.114a.31.31 0 01.035.14v3.277a.29.29 0 01-.035.14.28.28 0 01-.085.114.358.358 0 01-.129.08.919.919 0 01-.072.017.393.393 0 01-.077.007h-2.122zm-2.107 3.213a.439.439 0 01-.299-.115.37.37 0 01-.12-.269v-5.374a.37.37 0 01.12-.269.438.438 0 01.593 0 .404.404 0 01.09.12.33.33 0 01.035.15v5.373a.33.33 0 01-.035.15.404.404 0 01-.09.12.376.376 0 01-.132.084.444.444 0 01-.162.03zm-2.131 0a.439.439 0 01-.165-.03.381.381 0 01-.13-.085.34.34 0 01-.124-.269v-5.374a.35.35 0 01.125-.269.381.381 0 01.13-.084c.049-.02.104-.03.164-.03.06 0 .114.01.164.03.05.02.093.048.13.084a.34.34 0 01.124.27v5.373a.35.35 0 01-.125.27.381.381 0 01-.13.084.439.439 0 01-.163.03z"
    }))))));
};
var CheckmarkIcon = function CheckmarkIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "98px",
        height: "98px",
        viewBox: "0 0 98 98",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        role: "img",
        "aria-label": "Successful payment, green checkmark"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Cityville-Checkout---Desktop---Logged-In",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Confirmation",
        transform: "translate(-672.000000, -167.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "hero---thank-you",
        transform: "translate(1.000000, 104.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "icon---checkmark",
        transform: "translate(672.000000, 64.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        id: "Oval-2",
        stroke: SEA_GREEN,
        strokeWidth: "2",
        fill: HINT_GREEN,
        cx: "48",
        cy: "48",
        r: "48"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Group-2",
        transform: "translate(20.800000, 28.400000)",
        fill: SEA_GREEN
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        id: "Rectangle-2",
        transform: "translate(12.800000, 30.000000) rotate(-45.000000) translate(-12.800000, -30.000000) ",
        points: "8 18 17.6 18 17.6 42 8 42"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        id: "Rectangle-2-Copy-2",
        transform: "translate(32.036753, 20.922035) rotate(45.000000) translate(-32.036753, -20.922035) ",
        points: "27.2367532 -3.74558441 36.8367532 -3.74558441 36.8367532 45.5896536 27.2367532 45.5896536"
    })))))));
};
var BankIcon = function BankIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "28",
        height: "18",
        viewBox: "0 0 28 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Check Payment"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 2.25C0 1.00736 1.04467 0 2.33333 0H25.6667C26.9553 0 28 1.00736 28 2.25V15.75C28 16.9926 26.9553 18 25.6667 18H2.33333C1.04467 18 0 16.9926 0 15.75V2.25Z",
        fill: "#E4F4FD"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.6667 1.125H2.33333C1.689 1.125 1.16667 1.62868 1.16667 2.25V15.75C1.16667 16.3713 1.689 16.875 2.33333 16.875H25.6667C26.311 16.875 26.8333 16.3713 26.8333 15.75V2.25C26.8333 1.62868 26.311 1.125 25.6667 1.125ZM2.33333 0C1.04467 0 0 1.00736 0 2.25V15.75C0 16.9926 1.04467 18 2.33333 18H25.6667C26.9553 18 28 16.9926 28 15.75V2.25C28 1.00736 26.9553 0 25.6667 0H2.33333ZM18.4756 11.1252C18.4104 11.2172 18.3718 11.347 18.3718 11.4999C18.3718 11.5505 18.3658 11.5998 18.3544 11.6469C18.3311 11.7436 18.2853 11.8316 18.2229 11.9049C18.1656 11.9723 18.0967 12.0248 18.0213 12.0615C17.9536 12.0947 17.879 12.116 17.8003 12.1226C17.6813 12.1329 17.559 12.1093 17.4489 12.0495C17.4231 12.0354 17.3983 12.0196 17.3748 12.0022C16.6524 11.4672 16.0958 11.1625 15.6779 11.0075C15.2573 10.8515 15.0222 10.8633 14.91 10.8937C14.7685 10.932 14.6218 11.0893 14.6218 11.4999C14.6218 11.8451 14.342 12.1249 13.9968 12.1249C13.6516 12.1249 13.3718 11.8451 13.3718 11.4999C13.3718 10.9066 13.6002 9.95314 14.5836 9.68706C15.0339 9.56522 15.5488 9.62644 16.1126 9.83555C16.4942 9.9771 16.9192 10.194 17.3936 10.4965C17.413 10.4649 17.4336 10.4336 17.4555 10.4027C17.7111 10.0418 18.1047 9.78289 18.6225 9.67782C19.6045 9.47855 21.0261 9.82934 23.0502 10.9535C23.352 11.1211 23.4607 11.5016 23.2931 11.8033C23.1256 12.1051 22.7451 12.2139 22.4433 12.0463C20.4675 10.9489 19.3891 10.7977 18.8711 10.9028C18.6389 10.95 18.5325 11.0448 18.4756 11.1252ZM20.8718 6.49995C20.8718 6.84512 20.5919 7.12494 20.2468 7.12494H13.9968C13.6517 7.12494 13.3718 6.84512 13.3718 6.49995C13.3718 6.15477 13.6517 5.87495 13.9968 5.87495H20.2468C20.5919 5.87495 20.8718 6.15477 20.8718 6.49995ZM6.85743 4H8.42975C8.50197 4 8.57124 4.02869 8.62231 4.07976C8.67338 4.13083 8.70207 4.20009 8.70207 4.27232V5.07732C9.29939 5.22246 9.86896 5.47643 10.3809 5.83049C10.4374 5.87252 10.475 5.93511 10.4857 6.0047C10.4963 6.07429 10.4791 6.14527 10.4377 6.20226L9.64447 7.3223C9.60537 7.38038 9.54524 7.421 9.47676 7.43558C9.40828 7.45016 9.33681 7.43756 9.27744 7.40044C8.68465 7.00636 7.99283 6.78724 7.28125 6.7682C6.74846 6.7682 6.48798 6.98368 6.48798 7.27731V7.30099C6.48798 7.66329 6.7603 7.82194 7.8685 8.07058C9.67762 8.46602 10.8095 9.05328 10.8095 10.5356V10.5569C10.8095 11.8417 10.0025 12.7126 8.70674 13.0164V13.7631C8.70676 13.7948 8.7004 13.8262 8.68806 13.8554C8.67572 13.8846 8.65763 13.911 8.63488 13.9331C8.61214 13.9552 8.58519 13.9725 8.55564 13.984C8.52609 13.9954 8.49453 14.0008 8.46284 13.9999H6.82659C6.76378 13.9999 6.70354 13.9749 6.65913 13.9305C6.61473 13.8861 6.58979 13.8259 6.58979 13.7631V13.0623C5.69326 12.9149 4.84051 12.5514 4.10818 11.9967C4.07832 11.9745 4.05341 11.9464 4.03502 11.9141C4.01664 11.8818 4.00518 11.846 4.00139 11.809C3.9976 11.772 4.00157 11.7346 4.01303 11.6993C4.02448 11.6639 4.04318 11.6313 4.06793 11.6036L4.94881 10.5546C4.9921 10.5011 5.05402 10.4661 5.1221 10.4564C5.19018 10.4468 5.2594 10.4632 5.31585 10.5025C6.00025 11.0138 6.82956 11.2941 7.68381 11.3028C8.2829 11.3028 8.59784 11.0992 8.59784 10.7606V10.7369C8.59784 10.3983 8.33973 10.2278 7.25284 9.96968C5.56922 9.5837 4.2692 9.11011 4.2692 7.49279V7.46911C4.2692 6.20484 5.1314 5.24085 6.58511 4.99751V4.27232C6.58511 4.20009 6.6138 4.13083 6.66487 4.07976C6.71594 4.02869 6.7852 4 6.85743 4Z",
        fill: "#15749D"
    }));
};
var BankIconLarge = function BankIconLarge(_ref) {
    var _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "BankIconLarge-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "36",
        height: "24",
        viewBox: "0 0 36 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        clipPath: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 3C0 1.34315 1.34315 0 3 0H33C34.6569 0 36 1.34315 36 3V21C36 22.6569 34.6569 24 33 24H3C1.34315 24 0 22.6569 0 21V3Z",
        fill: "#E4F4FD"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V21C1.5 21.8284 2.17157 22.5 3 22.5H33C33.8284 22.5 34.5 21.8284 34.5 21V3C34.5 2.17157 33.8284 1.5 33 1.5ZM3 0C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H33C34.6569 24 36 22.6569 36 21V3C36 1.34315 34.6569 0 33 0H3ZM23.7544 14.8335C23.6706 14.9563 23.6209 15.1293 23.6209 15.3332C23.6209 15.5465 23.5436 15.7411 23.4165 15.8885C23.349 15.9671 23.2696 16.0296 23.1834 16.0752C23.0922 16.1237 22.9909 16.1546 22.8836 16.1637C22.6961 16.1799 22.5022 16.1282 22.3391 16.0029C21.4102 15.2896 20.6945 14.8834 20.1572 14.6767C19.6165 14.4687 19.3143 14.4844 19.17 14.5249C18.988 14.576 18.7994 14.7857 18.7994 15.3332C18.7994 15.7935 18.4397 16.1665 17.9959 16.1665C17.5521 16.1665 17.1923 15.7935 17.1923 15.3332C17.1923 14.5422 17.4859 13.2709 18.7503 12.9161C19.3292 12.7536 19.9913 12.8352 20.7162 13.1141C21.2068 13.3028 21.7532 13.592 22.3632 13.9954C22.3882 13.9532 22.4147 13.9115 22.4428 13.8703C22.7715 13.3891 23.2775 13.0439 23.9432 12.9038C25.2058 12.6381 27.0336 13.1058 29.636 14.6047C30.024 14.8281 30.1638 15.3354 29.9483 15.7378C29.7329 16.1401 29.2437 16.2852 28.8557 16.0617C26.3153 14.5986 24.9289 14.397 24.2629 14.5371C23.9643 14.5999 23.8275 14.7265 23.7544 14.8335ZM26.8351 8.66659C26.8351 9.12683 26.4754 9.49992 26.0316 9.49992H17.996C17.5522 9.49992 17.1924 9.12683 17.1924 8.66659C17.1924 8.20636 17.5522 7.83327 17.996 7.83327H26.0316C26.4754 7.83327 26.8351 8.20636 26.8351 8.66659ZM8.81666 5.33333H10.8382C10.9311 5.33333 11.0201 5.37159 11.0858 5.43968C11.1514 5.50777 11.1883 5.60012 11.1883 5.69642V6.76975C11.9563 6.96326 12.6887 7.3019 13.3469 7.77398C13.4195 7.83002 13.4679 7.91348 13.4816 8.00627C13.4953 8.09906 13.4731 8.1937 13.42 8.26967L12.4001 9.76307C12.3498 9.84051 12.2725 9.89466 12.1844 9.9141C12.0964 9.93354 12.0045 9.91674 11.9282 9.86726C11.166 9.34181 10.2765 9.04965 9.36164 9.02426C8.67662 9.02426 8.34171 9.31157 8.34171 9.70308V9.73465C8.34171 10.2177 8.69184 10.4293 10.1167 10.7608C12.4427 11.288 13.898 12.071 13.898 14.0475V14.0759C13.898 15.789 12.8604 16.9502 11.1944 17.3552V18.3508C11.1944 18.3931 11.1862 18.4349 11.1704 18.4739C11.1545 18.5128 11.1312 18.548 11.102 18.5775C11.0728 18.6069 11.0381 18.63 11.0001 18.6453C10.9621 18.6606 10.9215 18.6678 10.8808 18.6665H8.77705C8.6963 18.6665 8.61885 18.6333 8.56175 18.5741C8.50466 18.5148 8.4726 18.4345 8.4726 18.3508V17.4163C7.31992 17.2199 6.22353 16.7352 5.28198 15.9955C5.24358 15.966 5.21155 15.9285 5.18791 15.8854C5.16427 15.8423 5.14954 15.7946 5.14467 15.7453C5.1398 15.696 5.1449 15.6462 5.15963 15.599C5.17436 15.5519 5.1984 15.5084 5.23023 15.4714L6.36278 14.0728C6.41845 14.0015 6.49805 13.9548 6.58558 13.9419C6.67311 13.929 6.76211 13.9509 6.83469 14.0033C7.71463 14.685 8.78089 15.0588 9.87921 15.0704C10.6495 15.0704 11.0544 14.7989 11.0544 14.3474V14.3159C11.0544 13.8644 10.7225 13.637 9.32511 13.2929C7.16045 12.7783 5.489 12.1468 5.489 9.99039V9.95881C5.489 8.27314 6.59751 6.98782 8.46654 6.66335V5.69642C8.46654 5.60012 8.50342 5.50777 8.56908 5.43968C8.63474 5.37159 8.7238 5.33333 8.81666 5.33333Z",
        fill: "#15749D"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "36",
        height: "24",
        fill: "white"
    }))));
};
var GenericCard = function GenericCard() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "28",
        height: "18",
        viewBox: "0 0 28 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Card Payment"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "28",
        height: "18",
        rx: "2",
        fill: "#15749D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.86108 13C3.44687 13 3.11108 13.3358 3.11108 13.75C3.11108 14.1642 3.44687 14.5 3.86108 14.5H7.80553C8.21974 14.5 8.55553 14.1642 8.55553 13.75C8.55553 13.3358 8.21974 13 7.80553 13H3.86108ZM10.8611 13C10.4469 13 10.1111 13.3358 10.1111 13.75C10.1111 14.1642 10.4469 14.5 10.8611 14.5H17.9166C18.3309 14.5 18.6666 14.1642 18.6666 13.75C18.6666 13.3358 18.3309 13 17.9166 13H10.8611Z",
        fill: "#E4F4FD"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.2223 5.25V6.75H18.6667V6.25C18.6667 5.69772 19.1145 5.25 19.6667 5.25H20.2223ZM20.4723 5.25V6.75H22.3056V5.25H22.5556V6.75H24.1109V7H22.5556V8.25L24.1109 8.25V8.5L22.5556 8.5V9.74999L23.1111 9.74999C23.6634 9.74999 24.1111 9.30228 24.1111 8.74999V6.25C24.1111 5.69772 23.6634 5.25 23.1111 5.25H20.4723ZM22.3056 9.74999V8.5L20.4723 8.49999V9.74999L22.3056 9.74999ZM20.2223 9.74999V8.49999L18.6667 8.49999V8.74999C18.6667 9.30228 19.1145 9.74999 19.6667 9.74999H20.2223ZM18.6667 8.24999L20.2223 8.24999V7H18.6667V8.24999ZM20.4723 8.24999V7H22.3056V8.25L20.4723 8.24999Z",
        fill: "#F4C932"
    }));
};
var GenericErrorIcon = function GenericErrorIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "474",
        height: "308",
        viewBox: "0 0 474 308",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M107.968 73H347.689C351.538 73 354.658 76.12 354.658 79.968V258.366C354.658 262.214 351.538 265.334 347.689 265.334H107.968C104.119 265.334 101 262.214 101 258.366V79.968C101 76.12 104.119 73 107.968 73",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M200.435 148.429C201.244 146.174 203.256 144.701 205.477 144.701C207.698 144.701 209.71 146.174 210.518 148.429C211.038 149.878 212.634 150.632 214.083 150.112C215.532 149.593 216.286 147.997 215.766 146.547C214.239 142.287 210.267 139.126 205.477 139.126C200.687 139.126 196.715 142.286 195.187 146.547C194.668 147.997 195.422 149.593 196.871 150.112C198.32 150.632 199.916 149.878 200.435 148.429ZM246.435 148.429C247.244 146.174 249.256 144.701 251.477 144.701C253.698 144.701 255.71 146.174 256.518 148.429C257.038 149.878 258.634 150.632 260.083 150.112C261.532 149.593 262.286 147.997 261.766 146.547C260.239 142.287 256.267 139.126 251.477 139.126C246.687 139.126 242.715 142.286 241.187 146.547C240.668 147.997 241.422 149.593 242.871 150.112C244.32 150.632 245.916 149.878 246.435 148.429ZM208 195.674C209.54 195.674 210.788 194.426 210.788 192.886C210.788 190.622 212.623 188.788 214.885 188.788H241.305C243.569 188.788 245.404 190.623 245.404 192.886C245.404 194.426 246.652 195.674 248.191 195.674C249.731 195.674 250.979 194.426 250.979 192.886C250.979 187.544 246.648 183.213 241.305 183.213H214.885C209.543 183.213 205.213 187.544 205.213 192.886C205.213 194.426 206.461 195.674 208 195.674ZM31.6619 247.285C31.7125 249.493 29.9631 251.325 27.7546 251.375L12.5756 251.723C10.367 251.774 8.53559 250.024 8.48496 247.816C8.43432 245.607 10.1837 243.776 12.3922 243.725L27.5712 243.377C29.7798 243.327 31.6112 245.076 31.6619 247.285ZM99.6215 251.376C101.831 251.361 103.609 249.559 103.595 247.35C103.58 245.141 101.777 243.362 99.5683 243.376L47.1963 243.724C44.9872 243.739 43.2083 245.542 43.223 247.751C43.2377 249.96 45.0404 251.739 47.2495 251.724L99.6215 251.376ZM423.796 247.354C423.808 249.563 422.027 251.364 419.818 251.376L356.062 251.724C353.853 251.736 352.052 249.955 352.04 247.746C352.028 245.537 353.809 243.736 356.018 243.724L419.774 243.376C421.984 243.364 423.784 245.145 423.796 247.354ZM473.424 247.33C473.45 249.539 471.68 251.35 469.471 251.376L439.636 251.724C437.427 251.75 435.615 249.98 435.589 247.771C435.564 245.562 437.333 243.75 439.542 243.724L469.377 243.376C471.586 243.351 473.398 245.121 473.424 247.33Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M101 99H355V73H101V99Z",
        fill: "#CACED8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M117 86C117 87.6569 115.657 89 114 89C112.343 89 111 87.6569 111 86C111 84.3431 112.343 83 114 83C115.657 83 117 84.3431 117 86Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M127 86C127 87.6569 125.657 89 124 89C122.343 89 121 87.6569 121 86C121 84.3431 122.343 83 124 83C125.657 83 127 84.3431 127 86Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M137 86C137 87.6569 135.657 89 134 89C132.343 89 131 87.6569 131 86C131 84.3431 132.343 83 134 83C135.657 83 137 84.3431 137 86Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M352 102H104V96H352V102Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M223.998 268C223.998 265.691 222.126 263.819 219.817 263.819C217.508 263.819 215.636 265.691 215.636 268V288.614H204C201.691 288.614 199.819 290.486 199.819 292.795C199.819 295.104 201.691 296.976 204 296.976H219.817C222.126 296.976 223.998 295.104 223.998 292.795V268ZM239.491 268C239.491 265.691 237.619 263.819 235.31 263.819C233.001 263.819 231.129 265.691 231.129 268V293.574C231.129 295.883 233.001 297.755 235.31 297.755H251.127C253.436 297.755 255.308 295.883 255.308 293.574C255.308 291.265 253.436 289.393 251.127 289.393H239.491V268Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M102.461 202.558C103.91 204.226 103.732 206.753 102.064 208.201L79.804 227.532C78.136 228.981 75.6096 228.803 74.1611 227.135C72.7126 225.467 72.8905 222.94 74.5585 221.492L96.8185 202.161C98.4864 200.712 101.013 200.89 102.461 202.558Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M396.5 185.5C394.291 185.5 392.5 187.291 392.5 189.5C392.5 191.709 394.291 193.5 396.5 193.5H404.869L380.696 219.39L358.454 202.109C356.71 200.754 354.197 201.069 352.842 202.814C351.486 204.558 351.802 207.071 353.546 208.427L378.673 227.949C380.307 229.218 382.639 229.032 384.051 227.52L415.814 193.5H429.5C431.709 193.5 433.5 191.709 433.5 189.5C433.5 187.291 431.709 185.5 429.5 185.5H396.5Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M107.969 76C105.777 76 104 77.7769 104 79.969V258.366C104 260.557 105.777 262.334 107.969 262.334H347.69C349.881 262.334 351.658 260.557 351.658 258.366V79.969C351.658 77.7766 349.881 76 347.69 76H107.969ZM98 79.969C98 74.4631 102.463 70 107.969 70H347.69C353.195 70 357.658 74.4634 357.658 79.969V258.366C357.658 263.871 353.195 268.334 347.69 268.334H107.969C102.463 268.334 98 263.871 98 258.366V79.969Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M78.0922 220.617C75.9411 220.114 73.7895 221.45 73.2864 223.601C72.7833 225.752 74.1193 227.904 76.2704 228.407L125.537 239.929C126.148 245.765 131.082 250.314 137.079 250.314H143.723C145.932 250.314 147.723 248.523 147.723 246.314C147.723 244.105 145.932 242.314 143.723 242.314H137.079C135.088 242.314 133.474 240.7 133.474 238.708C133.474 236.717 135.088 235.103 137.079 235.103C139.288 235.103 141.079 233.312 141.079 231.103C141.079 228.894 139.288 227.103 137.079 227.103C133.095 227.103 129.579 229.111 127.49 232.17L78.0922 220.617Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M452.68 155.302C450.663 157.996 448.259 160.384 445.551 162.382C444.575 163.102 443.215 162.995 442.358 162.138L439.438 159.218C438.636 158.416 437.423 158.218 436.397 158.698C435.931 158.916 435.458 159.12 434.979 159.312C434.678 159.431 434.375 159.545 434.071 159.655C432.987 160.039 432.245 161.041 432.245 162.192L432.244 166.276C432.244 167.493 431.354 168.533 430.15 168.706C428.54 168.939 426.895 169.059 425.221 169.059C423.513 169.059 421.835 168.934 420.195 168.693C418.992 168.516 418.104 167.478 418.104 166.262V162.151C418.104 161.024 417.395 160.02 416.333 159.641C415.469 159.331 414.625 158.979 413.805 158.584C412.782 158.093 411.564 158.298 410.761 159.1L407.877 161.985C407.015 162.847 405.646 162.949 404.67 162.218C402.004 160.218 399.64 157.839 397.656 155.16C396.934 154.185 397.039 152.823 397.897 151.966L400.811 149.05C401.609 148.251 401.814 147.041 401.332 146.021C400.973 145.257 400.649 144.474 400.362 143.672C399.981 142.609 398.979 141.896 397.849 141.897H393.739C392.523 141.897 391.485 141.008 391.308 139.806C391.067 138.165 390.942 136.487 390.942 134.78C390.942 133.072 391.067 131.394 391.308 129.753C391.485 128.551 392.523 127.662 393.738 127.662H397.849C398.979 127.662 399.982 126.949 400.363 125.885C400.642 125.103 400.958 124.337 401.308 123.59C401.786 122.569 401.581 121.361 400.784 120.564L397.862 117.643C397.004 116.785 396.898 115.426 397.617 114.45C399.617 111.741 402.004 109.337 404.698 107.32C405.673 106.59 407.042 106.693 407.904 107.554L410.792 110.444C411.594 111.245 412.811 111.45 413.833 110.961C414.645 110.572 415.479 110.224 416.333 109.918C417.396 109.539 418.104 108.535 418.104 107.407V103.297C418.104 102.082 418.992 101.043 420.195 100.866C421.835 100.625 423.513 100.5 425.221 100.5C426.92 100.5 428.59 100.624 430.223 100.863C431.436 101.04 432.327 102.095 432.314 103.322L432.267 107.351C432.254 108.494 432.97 109.514 434.047 109.897C434.889 110.195 435.71 110.535 436.51 110.914C437.538 111.401 438.76 111.189 439.558 110.377L442.406 107.481C443.262 106.61 444.634 106.497 445.616 107.225C448.288 109.206 450.662 111.568 452.659 114.229C453.391 115.204 453.288 116.573 452.426 117.435L449.541 120.32C448.74 121.122 448.534 122.34 449.026 123.364C449.42 124.184 449.773 125.028 450.082 125.893C450.462 126.954 451.465 127.662 452.593 127.662H456.703C457.918 127.662 458.957 128.551 459.134 129.753C459.375 131.394 459.5 133.072 459.5 134.78C459.5 136.49 459.374 138.171 459.133 139.815C458.956 141.013 457.924 141.9 456.713 141.906L452.572 141.923C451.449 141.928 450.452 142.635 450.073 143.692C449.77 144.537 449.425 145.363 449.04 146.165C448.55 147.189 448.754 148.406 449.557 149.208L452.447 152.096C453.308 152.958 453.41 154.326 452.68 155.302Z",
        fill: "#CACED8",
        stroke: "#292A33",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M382.155 168.156C380.905 169.826 379.414 171.306 377.734 172.546C377.13 172.992 376.287 172.927 375.755 172.395L373.944 170.584C373.447 170.087 372.695 169.964 372.058 170.261C371.77 170.396 371.476 170.523 371.178 170.642C370.993 170.717 370.805 170.787 370.616 170.854C369.944 171.094 369.484 171.715 369.484 172.427V174.961C369.484 175.715 368.931 176.36 368.184 176.468C367.186 176.611 366.166 176.685 365.129 176.685C364.07 176.685 363.029 176.608 362.011 176.459C361.266 176.349 360.716 175.706 360.716 174.952L360.715 172.402C360.715 171.704 360.276 171.081 359.618 170.846C359.082 170.654 358.558 170.435 358.05 170.191C357.415 169.886 356.66 170.013 356.162 170.51L354.374 172.3C353.84 172.834 352.99 172.898 352.385 172.444C350.732 171.204 349.266 169.728 348.036 168.068C347.588 167.463 347.653 166.619 348.185 166.087L349.992 164.279C350.487 163.784 350.614 163.034 350.316 162.4C350.092 161.927 349.891 161.441 349.714 160.944C349.477 160.285 348.856 159.843 348.155 159.843H345.606C344.853 159.843 344.209 159.293 344.099 158.547C343.95 157.529 343.873 156.489 343.873 155.43C343.873 154.371 343.95 153.331 344.099 152.313C344.209 151.568 344.853 151.017 345.606 151.017H348.155C348.856 151.017 349.478 150.575 349.714 149.915C349.887 149.429 350.084 148.955 350.301 148.492C350.597 147.858 350.469 147.109 349.975 146.615L348.164 144.803C347.632 144.272 347.566 143.429 348.012 142.824C349.252 141.144 350.732 139.654 352.402 138.403C353.008 137.95 353.856 138.013 354.39 138.549L356.181 140.34C356.678 140.837 357.433 140.964 358.067 140.66C358.57 140.42 359.088 140.204 359.617 140.014C360.276 139.779 360.716 139.156 360.716 138.457V135.908C360.716 135.155 361.266 134.51 362.011 134.401C363.029 134.252 364.07 134.175 365.129 134.175C366.182 134.175 367.217 134.251 368.23 134.399C368.982 134.509 369.535 135.164 369.526 135.924L369.498 138.423C369.489 139.131 369.933 139.763 370.601 140.001C371.123 140.185 371.633 140.396 372.129 140.632C372.766 140.933 373.523 140.802 374.018 140.299L375.785 138.503C376.315 137.963 377.167 137.892 377.775 138.344C379.432 139.573 380.904 141.037 382.142 142.687C382.596 143.292 382.533 144.14 381.998 144.676L380.209 146.464C379.712 146.962 379.585 147.717 379.889 148.351C380.134 148.86 380.352 149.384 380.545 149.92C380.78 150.578 381.402 151.017 382.101 151.017L384.65 151.016C385.404 151.016 386.048 151.568 386.157 152.313C386.306 153.331 386.384 154.371 386.384 155.43C386.384 156.491 386.306 157.533 386.156 158.552C386.047 159.295 385.407 159.845 384.656 159.848L382.088 159.86C381.391 159.863 380.774 160.302 380.539 160.957C380.35 161.48 380.136 161.992 379.898 162.49C379.594 163.125 379.721 163.88 380.218 164.377L382.01 166.168C382.545 166.702 382.608 167.551 382.155 168.156Z",
        fill: "#CACED8",
        stroke: "#292A33",
        strokeWidth: "3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M415.001 134.779C415.001 140.424 419.577 145 425.222 145C430.866 145 435.442 140.424 435.442 134.779C435.442 129.134 430.866 124.558 425.222 124.558C419.577 124.558 415.001 129.134 415.001 134.779Z",
        fill: "#F6F6F9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M425.222 126.058C430.037 126.058 433.942 129.963 433.942 134.779C433.942 139.596 430.037 143.5 425.222 143.5C420.405 143.5 416.501 139.596 416.501 134.779C416.501 129.963 420.405 126.058 425.222 126.058ZM436.942 134.779C436.942 128.306 431.694 123.058 425.222 123.058C418.748 123.058 413.501 128.306 413.501 134.779C413.501 141.253 418.748 146.5 425.222 146.5C431.694 146.5 436.942 141.253 436.942 134.779Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M358.791 155.431C358.791 158.931 361.628 161.768 365.129 161.768C368.629 161.768 371.467 158.931 371.467 155.431C371.467 151.93 368.629 149.093 365.129 149.093C361.628 149.093 358.791 151.93 358.791 155.431Z",
        fill: "#F6F6F9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M365.129 150.593C367.8 150.593 369.967 152.758 369.967 155.431C369.967 158.102 367.8 160.268 365.129 160.268C362.456 160.268 360.291 158.102 360.291 155.431C360.291 152.758 362.456 150.593 365.129 150.593ZM372.967 155.431C372.967 151.101 369.457 147.593 365.129 147.593C360.799 147.593 357.291 151.101 357.291 155.431C357.291 159.759 360.799 163.268 365.129 163.268C369.457 163.268 372.967 159.759 372.967 155.431Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M159.146 27.899C161.226 26.41 163.766 25.524 166.518 25.524C173.522 25.524 179.201 31.203 179.201 38.208C179.201 45.212 173.522 50.891 166.518 50.891H109.108C100.911 50.891 94.2649 44.245 94.2649 36.047C94.2649 27.85 100.911 21.204 109.108 21.204C112.441 21.204 115.506 22.316 117.984 24.17C120.469 15.329 128.583 8.84497 138.219 8.84497C149.165 8.84497 158.154 17.212 159.146 27.899ZM415.354 42.963C417.095 41.716 419.223 40.973 421.529 40.973C427.397 40.973 432.154 45.73 432.154 51.598C432.154 57.467 427.397 62.223 421.529 62.223H373.435C366.567 62.223 361 56.657 361 49.789C361 42.921 366.567 37.354 373.435 37.354C376.226 37.354 378.795 38.285 380.87 39.838C382.952 32.432 389.75 27 397.822 27C406.992 27 414.522 34.01 415.354 42.963ZM69.491 141.356C68.241 141.356 67.056 141.631 65.985 142.113C64.929 140.771 63.293 139.906 61.453 139.906C60.912 139.906 60.391 139.985 59.894 140.125C57.947 135.058 53.048 131.456 47.296 131.456C41.027 131.456 35.77 135.733 34.247 141.525C33.701 141.415 33.136 141.356 32.557 141.356C27.831 141.356 24 145.187 24 149.913C24 154.639 27.831 158.47 32.557 158.47H69.491C74.217 158.47 78.048 154.639 78.048 149.913C78.048 145.187 74.217 141.356 69.491 141.356ZM228.163 307.832C260.286 307.832 286.327 302.049 286.327 294.916C286.327 287.783 260.286 282 228.163 282C196.04 282 170 287.783 170 294.916C170 302.049 196.04 307.832 228.163 307.832Z",
        fill: "#3B5BDB",
        fillOpacity: "0.2"
    }));
};
var IconAdd = function IconAdd(_ref) {
    var _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? "none" : _ref$stroke, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        className: "icon"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "path-1",
        d: "M7.91666623 4.78508747L4.78508747 4.78508747 4.78508747 7.91666623 3.74122788 7.91666623 3.74122788 4.78508747 0.609649123 4.78508747 0.609649123 3.74122788 3.74122788 3.74122788 3.74122788 0.609649123 4.78508747 0.609649123 4.78508747 3.74122788 7.91666623 3.74122788z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: stroke,
        strokeWidth: strokeWidth
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-407 -563)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(408 562)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(0 2)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(3.94 3.858)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        fill: "#fff"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        className: "fill",
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        className: "stroke",
        strokeWidth: strokeWidth,
        cx: "8.155",
        cy: "8.072",
        r: "8"
    }))))));
};
var IconQuitLarge = function IconQuitLarge(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "#091325" : _ref$fill;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "14px",
        height: "14px",
        viewBox: "0 0 14 14",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        id: "quit-large-path-1",
        points: "18.9999989 6.40999946 17.589999 4.9999997 11.9999993 10.5899995 6.40999946 4.9999997 4.9999997 6.40999946 10.5899995 11.9999993 4.9999997 17.589999 6.40999946 18.9999989 11.9999993 13.409999 17.589999 18.9999989 18.9999989 17.589999 13.409999 11.9999993"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "quit-large-[D]-Cart---Slideout",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "quit-large-[D]-Cart-Slideout---Standard",
        transform: "translate(-741.000000, -34.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "quit-large-Close-Icon",
        transform: "translate(724.000000, 17.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "quit-large-Group",
        transform: "translate(12.000000, 12.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "quit-large-mask-2",
        fill: "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#quit-large-path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        id: "quit-large-Fill-2",
        fill: fill,
        xlinkHref: "#quit-large-path-1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#quit-large-mask-2)",
        fill: fill,
        id: "quit-large-\u2B91\uD83C\uDFA8"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        id: "quit-large-\u279D\u270F\uFE0F",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }))))))));
};
var TimeoutImage = function TimeoutImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 458 308"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-492 -168)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(492 168)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#EAF4EB",
        d: "M286.327 294.916c0 7.133-26.041 12.916-58.164 12.916-32.123 0-58.163-5.783-58.163-12.916S196.04 282 228.163 282s58.164 5.783 58.164 12.916"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        stroke: "#45B770",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "8.362",
        transform: "translate(204 268)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15.817 -2.13162821e-14L15.817 24.795 3.55271368e-15 24.795"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M31.3102 -2.30926389e-14L31.3102 25.574 47.1272 25.574"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FEFEFE",
        d: "M107.968 73h239.721a6.969 6.969 0 016.969 6.968v178.398a6.969 6.969 0 01-6.969 6.968H107.968a6.968 6.968 0 01-6.968-6.968V79.968A6.968 6.968 0 01107.968 73"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#E4E6EB",
        d: "M101 99L355 99 355 73 101 73z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        stroke: "#3B414D",
        strokeLinecap: "round",
        strokeWidth: "5.575",
        transform: "translate(197.811 141.913)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        strokeLinejoin: "round",
        d: "M0 5.575C1.168 2.317 4.16 0 7.666 0c3.505 0 6.497 2.317 7.665 5.575"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        strokeLinejoin: "round",
        d: "M46 5.575C47.168 2.317 50.16 0 53.666 0c3.505 0 6.497 2.317 7.665 5.575"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50.38 44.087h0a6.886 6.886 0 01-6.886 6.886h-26.42a6.886 6.886 0 01-6.885-6.886",
        transform: "matrix(1 0 0 -1 0 95.06)"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#3B414D",
        d: "M124 83a3 3 0 110 6 3 3 0 010-6zm-10 0a3 3 0 110 6 3 3 0 010-6zm20 0a3 3 0 110 6 3 3 0 010-6z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#45B770",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "8",
        d: "M99.441 205.181L77.181 224.512"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#45B770",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "8",
        d: "M412.8955 190.764648L381.126953 224.790039 356 205.267859"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#45B770",
        strokeLinecap: "round",
        strokeWidth: "8",
        d: "M396.5 189.5L429.5 189.5"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#45B770",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "8",
        d: "M137.079 231.103a7.605 7.605 0 000 15.211h6.644"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(377 63)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M66.669 116.462H5.122a5.122 5.122 0 110-10.243h61.547a5.122 5.122 0 110 10.243"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#E4F4FD",
        d: "M15.126 71.521l20.77-13.29 20.769 13.29a19.123 19.123 0 018.815 16.106v18.591H6.311v-18.59c0-6.52 3.323-12.592 8.815-16.107z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#E4F4FD",
        d: "M56.665 44.94l-20.77 13.292L15.126 44.94a19.12 19.12 0 01-8.815-16.106V10.244H65.48v18.59a19.12 19.12 0 01-8.815 16.107z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M66.669 10.244H5.122A5.122 5.122 0 115.122 0h61.547a5.122 5.122 0 110 10.244z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        stroke: "#3B414D",
        strokeLinecap: "round",
        strokeWidth: "6"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M66.669 116.462H5.122a5.122 5.122 0 110-10.243h61.547a5.122 5.122 0 110 10.243z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15.126 71.521l20.77-13.29 20.769 13.29a19.123 19.123 0 018.815 16.106v18.591H6.311v-18.59c0-6.52 3.323-12.592 8.815-16.107z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M56.665 44.94l-20.77 13.292L15.126 44.94a19.12 19.12 0 01-8.815-16.106V10.244H65.48v18.59a19.12 19.12 0 01-8.815 16.107z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M66.669 10.244H5.122A5.122 5.122 0 115.122 0h61.547a5.122 5.122 0 110 10.244z"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#3B414D",
        strokeLinecap: "round",
        strokeWidth: "8",
        d: "M27.663 247.376l-15.18.348M401 248l-44.96-.276m-256.445-.348l-52.372.348M454 248h-34"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#3B414D",
        strokeWidth: "6",
        d: "M107.969 73H347.69a6.969 6.969 0 016.968 6.969v178.397a6.968 6.968 0 01-6.968 6.968H107.969a6.969 6.969 0 01-6.969-6.968V79.969A6.969 6.969 0 01107.969 73zM104 99h248"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#45B770",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "8",
        d: "M77.181 224.512L127.905 236.375"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#B8E4F4",
        d: "M95.74 141.218c5.753 0 10.652 3.602 12.599 8.67a5.733 5.733 0 016.092 1.987 8.512 8.512 0 013.505-.757 8.557 8.557 0 110 17.114H81.002a8.557 8.557 0 111.69-16.945c1.523-5.792 6.78-10.069 13.049-10.069zM365.823 82c9.17 0 16.7 7.01 17.532 15.963a10.567 10.567 0 016.175-1.99c5.868 0 10.625 4.757 10.625 10.625 0 5.869-4.757 10.625-10.625 10.625h-48.094c-6.868 0-12.435-5.566-12.435-12.434 0-6.868 5.567-12.435 12.435-12.435 2.791 0 5.36.931 7.435 2.484C350.952 87.432 357.75 82 365.822 82zM23.296 75.456c5.752 0 10.651 3.602 12.598 8.669a5.733 5.733 0 011.559-.22c1.84 0 3.476.866 4.532 2.208a8.52 8.52 0 013.506-.757 8.557 8.557 0 110 17.114H8.557a8.557 8.557 0 111.69-16.945c1.523-5.792 6.78-10.07 13.049-10.07zM170.219 8.845c10.946 0 19.935 8.367 20.927 19.054a12.618 12.618 0 017.372-2.375c7.004 0 12.683 5.679 12.683 12.684 0 7.004-5.68 12.683-12.683 12.683h-57.41c-8.197 0-14.843-6.646-14.843-14.844 0-8.197 6.646-14.843 14.843-14.843 3.333 0 6.398 1.112 8.876 2.966 2.485-8.841 10.599-15.325 20.235-15.325zM297.892 0c5.752 0 10.651 3.602 12.598 8.669a5.728 5.728 0 011.56-.219c1.84 0 3.475.865 4.531 2.207a8.516 8.516 0 013.506-.757 8.557 8.557 0 110 17.114h-36.935a8.557 8.557 0 01-8.556-8.557 8.557 8.557 0 0110.248-8.388C286.366 4.277 291.622 0 297.892 0z"
    })))));
};
var AutopayOnIcon = function AutopayOnIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? SEA_GREEN : _ref$color;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "13",
        viewBox: "0 0 12 13",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        className: "autopayIcon",
        fill: color,
        fillRule: "nonzero",
        d: "M1.898 5.75c.079 0 .141-.02.188-.059a.281.281 0 00.094-.152 3.825 3.825 0 011.394-2.144A3.838 3.838 0 016 2.563c.5 0 .98.09 1.441.27.461.179.88.44 1.254.784l-.984.985A.542.542 0 007.547 5c0 .156.055.29.164.398.11.11.242.165.398.165h3.141c.156 0 .289-.055.398-.165A.542.542 0 0011.812 5V1.86a.542.542 0 00-.164-.399.542.542 0 00-.398-.164.542.542 0 00-.398.164l-.844.844A5.699 5.699 0 006 .688c-.938 0-1.809.207-2.613.62-.805.415-1.48.981-2.028 1.7A5.726 5.726 0 00.281 5.422a.265.265 0 00.059.223c.055.07.129.105.222.105h1.336zM6 12.312c.937 0 1.809-.207 2.613-.62a5.919 5.919 0 002.028-1.7 5.726 5.726 0 001.078-2.414.265.265 0 00-.059-.223.267.267 0 00-.223-.105h-1.335c-.079 0-.141.02-.188.059a.281.281 0 00-.094.152 3.825 3.825 0 01-1.394 2.144c-.711.555-1.52.833-2.426.833-.5 0-.98-.09-1.441-.27a3.985 3.985 0 01-1.254-.785l.984-.985A.542.542 0 004.453 8a.542.542 0 00-.164-.398.542.542 0 00-.398-.164H.75a.542.542 0 00-.398.164A.542.542 0 00.187 8v3.14c0 .157.055.29.165.4.109.108.242.163.398.163.156 0 .29-.055.398-.164l.844-.844A5.699 5.699 0 006 12.312z"
    })));
};
var NotFoundIcon = function NotFoundIcon(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: "400",
        height: "211",
        viewBox: "0 0 400 211",
        fill: "none",
        "aria-label": "Error: Not Found"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        opacity: "0.301503"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M243.877 189.762C243.877 185.147 227.027 181.405 206.243 181.405C185.458 181.405 168.609 185.147 168.609 189.762C168.609 194.377 185.458 198.119 206.243 198.119C227.027 198.119 243.877 194.377 243.877 189.762Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M161.882 35.8821C161.675 33.247 159.477 31.214 156.834 31.214H128.841C128.709 31.214 128.577 31.2191 128.446 31.2294C125.658 31.4477 123.575 33.8846 123.793 36.6724L124.003 39.3645C123.917 39.7848 123.882 40.2256 123.906 40.6798L124.108 44.6075H121.513C117.213 44.6075 113.909 48.1244 114.132 52.4627L119.589 158.508C119.813 162.847 123.479 166.364 127.778 166.364H276.988C281.287 166.364 284.592 162.847 284.369 158.508L278.911 52.4627C278.688 48.1244 275.022 44.6075 270.722 44.6075L162.564 44.6064L161.882 35.8821Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M334.997 104.08C334.672 100.54 331.725 97.7696 328.136 97.7696C324.976 97.7696 322.316 99.9169 321.501 102.845C320.689 102.231 319.684 101.862 318.591 101.862C315.904 101.862 313.725 104.063 313.725 106.778C313.725 109.493 315.904 111.694 318.591 111.694H337.414C339.711 111.694 341.573 109.813 341.573 107.494C341.573 105.174 339.711 103.293 337.414 103.293C336.512 103.293 335.679 103.587 334.997 104.08Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M94.1431 61.1875C94.1431 60.5649 93.7639 60.0615 93.2973 60.0615H59.5459C59.0785 60.0615 58.7001 60.5649 58.7001 61.1875V110.694H94.1431V61.1875Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M48.6024 31.2272C47.2344 27.6658 43.7924 25.134 39.7509 25.134C35.3463 25.134 31.6527 28.1402 30.5826 32.2112C30.199 32.1339 29.802 32.0924 29.3952 32.0924C26.0746 32.0924 23.3829 34.7851 23.3829 38.1069C23.3829 41.4287 26.0746 44.1214 29.3952 44.1214H55.3454C58.6659 44.1214 61.3576 41.4287 61.3576 38.1069C61.3576 34.7851 58.6659 32.0924 55.3454 32.0924C54.4671 32.0924 53.6345 32.2857 52.8827 32.6245C52.1401 31.6813 50.9906 31.0733 49.6978 31.0733C49.3177 31.0733 48.9516 31.1288 48.6024 31.2272Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M309.54 17.8918C308.081 14.0929 304.41 11.3924 300.099 11.3924C295.4 11.3924 291.461 14.599 290.32 18.9414C289.91 18.8589 289.487 18.8147 289.052 18.8147C285.511 18.8147 282.64 21.6869 282.64 25.2301C282.64 28.7733 285.511 31.6456 289.052 31.6456H316.733C320.275 31.6456 323.146 28.7733 323.146 25.2301C323.146 21.6869 320.275 18.8147 316.733 18.8147C315.795 18.8147 314.908 19.0209 314.105 19.3823C313.314 18.3761 312.089 17.7276 310.709 17.7276C310.303 17.7276 309.912 17.7868 309.54 17.8918Z",
        fill: "#3B5BDB"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M181.134 41.3406C183.931 41.3406 186.198 43.6075 186.198 46.4039C186.198 46.5503 186.191 46.6966 186.179 46.8425L186.059 48.233C186.132 48.5976 186.164 48.9772 186.15 49.3671L186.018 53.1646H286.146C290.445 53.1646 293.812 56.5649 293.666 60.7595L290.1 163.291C289.954 167.486 286.351 170.886 282.051 170.886H132.842C128.542 170.886 125.175 167.486 125.321 163.291L128.887 60.7595C129.033 56.5649 132.636 53.1646 136.936 53.1646L142.591 53.1634L143.217 45.9652C143.444 43.3487 145.635 41.3406 148.261 41.3406H181.134Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M102.337 67.4261C102.804 67.4261 103.183 67.7214 103.183 68.0859V114.262H67.7397V68.0859C67.7397 67.7214 68.1182 67.4261 68.5856 67.4261H102.337Z",
        fill: "#CACED8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M156.073 30.3798C160.292 30.3798 163.843 33.7855 164.063 38.069L164.085 38.8089L182.156 38.8089C184.742 38.8089 187.026 40.1014 188.398 42.0755L270.722 42.0758C275.798 42.0758 280.165 45.7678 281.214 50.6334L286.146 50.6329C291.758 50.6329 296.224 55.0388 296.202 60.5352L296.196 60.8475L292.838 157.414L330.416 157.423C331.777 157.408 332.894 158.427 332.911 159.7C332.927 160.915 331.935 161.923 330.661 162.025L330.477 162.034L292.677 162.024L292.63 163.379C292.44 168.845 287.879 173.249 282.37 173.413L282.051 173.418H132.842C128.946 173.418 125.603 171.295 123.929 168.159C121.254 167.103 119.085 164.99 117.937 162.355L89.1371 162.355C87.711 162.338 86.569 161.168 86.5863 159.742C86.6027 158.381 87.6696 157.278 89.0068 157.196L89.1996 157.191L116.986 157.19L111.604 52.5928C111.312 46.9184 115.597 42.2485 121.2 42.0805L121.496 42.0747L121.377 38.2783C121.159 34.0413 124.357 30.5386 128.539 30.385L128.826 30.3798H156.073ZM182.156 43.8722H149.331C148.059 43.8722 146.985 44.8155 146.82 46.0763L145.566 55.6946L136.936 55.6962C133.988 55.6962 131.515 58.0292 131.417 60.8475L127.851 163.379C127.755 166.127 129.961 168.354 132.842 168.354H282.051C285 168.354 287.472 166.021 287.57 163.203L291.136 60.6715C291.232 57.9233 289.026 55.6962 286.145 55.6962L183.496 55.695L184.667 46.7313C184.681 46.6227 184.688 46.5134 184.688 46.4039C184.688 45.0057 183.554 43.8722 182.156 43.8722ZM362.279 157.192C363.704 157.154 364.891 158.28 364.928 159.705C364.964 161.066 363.94 161.702 362.607 161.835L362.414 161.848L343.11 162.354C341.684 162.392 340.498 161.267 340.461 159.841C340.425 158.48 341.449 157.337 342.782 157.204L342.975 157.192H362.279ZM79.0911 159.64C79.1613 161 78.1668 162.168 76.8375 162.335L76.6454 162.352H66.8241C65.3998 162.425 64.1856 161.33 64.1121 159.906C64.042 158.547 65.0365 157.379 66.3658 157.211L66.5579 157.194H76.3792C77.8035 157.121 79.0176 158.216 79.0911 159.64ZM156.073 35.4431H128.826C127.477 35.4431 126.452 36.4714 126.432 37.8753L126.436 38.069L126.72 47.1391H121.513C118.755 47.1391 116.643 49.2984 116.653 52.0709L116.66 52.3326L122.118 158.378C122.164 159.286 122.433 160.148 122.869 160.908L126.357 60.6715C126.551 55.1006 131.285 50.6329 136.935 50.6329L141.119 50.6317L141.799 45.4215C142.28 41.7383 145.348 38.9585 149.031 38.8148L149.331 38.8089L159.02 38.8089L159.004 38.2783C158.928 36.794 157.7 35.5552 156.269 35.4502L156.073 35.4431ZM223.253 116.891L223.44 116.895C224.763 116.981 225.766 118.122 225.68 119.444C225.447 123.071 222.431 125.991 218.829 126.139L218.543 126.145H201.449C197.602 126.145 194.639 122.978 194.887 119.135C194.972 117.813 196.113 116.81 197.435 116.895C198.695 116.977 199.665 118.015 199.68 119.257L199.676 119.444C199.61 120.463 200.293 121.254 201.273 121.338L201.449 121.346H218.543C219.675 121.346 220.701 120.438 220.871 119.323L220.892 119.135C220.973 117.876 222.012 116.906 223.253 116.891ZM103.183 65.8452L103.183 66.3191C103.908 66.6033 104.449 67.2481 104.449 68.086V114.262C104.449 114.961 103.882 115.527 103.183 115.527H67.7398C67.0407 115.527 66.474 114.961 66.474 114.262V68.086C66.474 67.2481 67.0145 66.6033 67.7396 66.3191L67.7398 65.8452H103.183ZM101.916 71.9304H69.0048L69.005 112.995H101.916L101.916 71.9304ZM85.0096 104.616C85.7315 104.616 86.3167 105.201 86.3167 105.923V108.678C86.3167 109.4 85.7315 109.985 85.0096 109.985H75.0279C74.306 109.985 73.7207 109.4 73.7207 108.678V105.923C73.7207 105.201 74.306 104.616 75.0279 104.616H85.0096ZM83.7012 107.229H76.3341V107.37H83.7012V107.229ZM97.4683 92.7215C98.1674 92.7215 98.7341 93.2883 98.7341 93.9874V100.316C98.7341 101.016 98.1674 101.582 97.4683 101.582H73.4176C72.7185 101.582 72.1518 101.016 72.1518 100.316V93.9874C72.1518 93.2883 72.7185 92.7215 73.4176 92.7215H97.4683ZM96.2025 95.2532H74.6835V99.0506H96.2025V95.2532ZM197.487 88.3647C200.794 88.3647 203.588 90.5375 204.516 93.6944C204.89 94.9657 204.163 96.2994 202.891 96.6732C201.681 97.0292 200.413 96.3863 199.972 95.226L199.913 95.0482C199.575 93.8998 198.628 93.1634 197.487 93.1634C196.329 93.1634 195.192 93.9189 194.608 95.083L194.505 95.3059C193.988 96.5264 192.581 97.0973 191.36 96.5811C190.14 96.0649 189.569 94.6571 190.085 93.4366C191.36 90.4209 194.27 88.3647 197.487 88.3647ZM227.251 88.3647C230.558 88.3647 233.352 90.5375 234.28 93.6944C234.654 94.9657 233.926 96.2994 232.655 96.6732C231.444 97.0292 230.177 96.3863 229.736 95.226L229.676 95.0482C229.338 93.8998 228.392 93.1634 227.251 93.1634C226.093 93.1634 224.956 93.9189 224.371 95.083L224.268 95.3059C223.752 96.5264 222.344 97.0973 221.124 96.5811C219.903 96.0649 219.332 94.6571 219.848 93.4366C221.124 90.4209 224.033 88.3647 227.251 88.3647ZM97.4683 81.3291C98.1674 81.3291 98.7341 81.8959 98.7341 82.595V88.9241C98.7341 89.6232 98.1674 90.1899 97.4683 90.1899H73.4176C72.7185 90.1899 72.1518 89.6232 72.1518 88.9241V82.595C72.1518 81.8959 72.7185 81.3291 73.4176 81.3291H97.4683ZM96.2025 83.8608H74.6835V87.6582H96.2025V83.8608ZM84.9621 75.7452C85.684 75.7452 86.2692 76.3305 86.2692 77.0524C86.2692 77.7262 85.7594 78.2809 85.1045 78.3519L84.9621 78.3595H73.5214C72.7995 78.3595 72.2143 77.7743 72.2143 77.0524C72.2143 76.3786 72.7241 75.8239 73.379 75.7529L73.5214 75.7452H84.9621ZM270.722 47.1391L189.714 47.138L189.687 47.3866L189.263 50.6317L275.919 50.6332C275.065 48.6752 273.15 47.2546 270.989 47.1458L270.722 47.1391Z",
        fill: "#3B414D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M213.449 173.34L213.449 186.311L221.101 186.311C222.463 186.311 223.578 187.365 223.676 188.701L223.684 188.894C223.684 190.255 222.63 191.37 221.294 191.469L221.101 191.476H210.867C209.506 191.476 208.391 190.423 208.292 189.086L208.285 188.894V173.34H213.449ZM203.425 173.34V188.39C203.425 189.751 202.371 190.866 201.035 190.965L200.843 190.972H190.608C189.182 190.972 188.026 189.816 188.026 188.39C188.026 187.028 189.08 185.913 190.416 185.814L190.608 185.807L198.259 185.806L198.26 173.34H203.425ZM101.899 120.835C103.325 120.835 104.481 121.992 104.481 123.418C104.481 124.779 103.428 125.894 102.091 125.993L101.899 126L96.7188 126L111.219 140.67L123.794 129.751C123.846 129.705 123.971 129.614 124.036 129.568L124.055 129.553L124.054 129.571C124.047 129.692 124.044 130.316 124.042 131.14L124.042 133.914C124.042 134.017 124.042 134.119 124.041 134.219L124.04 135.062C124.039 135.839 124.035 136.381 124.027 136.389C121.527 138.56 117.777 141.816 112.777 146.158L112.755 146.175L112.734 146.195C112.709 146.216 112.684 146.236 112.658 146.256L112.777 146.158C112.717 146.21 112.656 146.259 112.593 146.304C112.56 146.328 112.526 146.351 112.492 146.373C112.466 146.39 112.439 146.407 112.412 146.423C112.379 146.443 112.346 146.462 112.312 146.481C112.282 146.497 112.252 146.512 112.222 146.527C112.195 146.541 112.167 146.554 112.139 146.566C112.105 146.581 112.071 146.596 112.037 146.609C112 146.624 111.962 146.638 111.924 146.651C111.898 146.66 111.873 146.668 111.848 146.676C111.816 146.686 111.783 146.695 111.751 146.704C111.704 146.716 111.657 146.727 111.61 146.737C111.598 146.739 111.585 146.742 111.573 146.744C111.519 146.755 111.466 146.763 111.412 146.77C111.394 146.772 111.376 146.774 111.357 146.776C111.311 146.781 111.265 146.785 111.218 146.787C111.192 146.789 111.165 146.789 111.139 146.79C111.105 146.791 111.07 146.791 111.035 146.79C111 146.789 110.965 146.788 110.93 146.786C110.901 146.784 110.871 146.782 110.842 146.779C110.801 146.775 110.76 146.771 110.72 146.765C110.698 146.762 110.677 146.758 110.656 146.755C110.613 146.748 110.57 146.74 110.527 146.73C110.491 146.722 110.456 146.714 110.421 146.704C110.392 146.697 110.362 146.688 110.333 146.679C110.211 146.642 110.091 146.596 109.974 146.541C109.912 146.511 109.851 146.479 109.792 146.445C109.723 146.405 109.655 146.361 109.589 146.314C109.573 146.303 109.557 146.291 109.541 146.279C109.5 146.249 109.46 146.218 109.421 146.185C109.418 146.182 109.414 146.178 109.411 146.175L109.358 146.13C109.325 146.1 109.293 146.069 109.261 146.038L109.247 146.024L91.2013 127.765C90.7168 127.274 90.4687 126.639 90.4562 126L79.1139 126C77.6877 126 76.5316 124.844 76.5316 123.418C76.5316 122.056 77.585 120.941 78.9212 120.843L79.1139 120.835H101.899ZM93.2973 58.7957C94.4918 58.7957 95.3225 59.8212 95.4026 61.0002L95.409 61.1875V65.846C95.409 65.846 94.7763 65.8673 94.1435 65.8781L94.1431 65.968H67.2122V68.3806L59.9656 68.3805L59.9663 90.5845C60.9638 90.2603 62.0224 90.0716 63.1203 90.0398L63.4526 90.035C69.6779 90.035 74.7245 95.0815 74.7245 101.307C74.7245 107.532 69.6779 112.579 63.4526 112.579C62.161 112.579 60.9202 112.361 59.7646 111.961L58.7001 111.96C58.0518 111.96 57.5174 111.473 57.4431 110.845C54.2809 108.848 52.1808 105.323 52.1808 101.307C52.1808 97.2947 54.277 93.7722 57.4339 91.7747L57.4343 61.1875C57.4343 59.9946 58.2047 58.9096 59.3603 58.8041L59.5459 58.7957H93.2973ZM67.7397 80.2265V81.4923L63.4987 81.4911V85.0785L67.7397 85.0794V86.3452H62.2329V80.2265H67.7397ZM67.0836 72.6006V73.8664L63.4987 73.8658V77.4532L67.0836 77.4534V78.7193H62.2329V72.6006H67.0836Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M293.671 131.646C293.814 129.658 293.824 129.91 293.814 129.9L293.463 129.568L293.472 129.575C293.539 129.623 294.254 130.336 294.304 130.38L308.107 142.259L308.262 142.404C309.117 143.278 309.237 144.635 308.561 145.642C308.337 146.419 307.754 147.079 306.933 147.367L283.243 155.68C282.59 159.159 279.537 161.791 275.869 161.791H271.57L271.377 161.784C270.041 161.686 268.987 160.57 268.987 159.209C268.987 157.783 270.144 156.627 271.57 156.627H275.869L276.051 156.62C277.257 156.527 278.207 155.518 278.207 154.288C278.207 152.996 277.16 151.949 275.869 151.949L275.676 151.942C274.34 151.844 273.286 150.728 273.286 149.367C273.286 147.941 274.442 146.785 275.869 146.785C278.638 146.785 281.058 148.286 282.357 150.519L301.859 143.673L293.471 136.389C293.56 136.466 293.46 135.953 293.458 135.312L293.457 134.795L293.457 134.513L293.671 131.646Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "63.5",
        cy: "101.5",
        r: "11.5",
        fill: "#D11053"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M68.5537 98.1186L65.3663 101.306L68.5537 104.495L66.6408 106.408L63.4526 103.22L60.2645 106.408L58.3516 104.495L61.539 101.306L58.3516 98.1186L60.2645 96.2057L63.4526 99.3923L66.6408 96.2057L68.5537 98.1186Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "189",
        y: "112",
        width: "47",
        height: "21",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M226 125V125C226 122.239 223.761 120 221 120L202 120C199.239 120 197 122.239 197 125V125",
        stroke: "#3B414D",
        strokeWidth: "5",
        strokeLinecap: "round"
    }));
};
var SearchIcon = function SearchIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? CHARADE_GREY : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? "22px" : _ref$size;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 ".concat(size, " ").concat(size),
        version: "1.1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Debt-Search",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Debt-Search---Expanded",
        transform: "translate(-155.000000, -258.000000)",
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "debt-search",
        transform: "translate(132.000000, 189.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "search",
        transform: "translate(0.000000, 44.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "search_icon",
        transform: "translate(24.000000, 26.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        id: "Oval-2",
        transform: "translate(7.407407, 7.407407) scale(-1, 1) translate(-7.407407, -7.407407) ",
        cx: "7.40740741",
        cy: "7.40740741",
        r: "7.40740741"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", {
        x1: "19.6296296",
        y1: "12.962963",
        x2: "12.9219369",
        y2: "19.6706557",
        id: "Line",
        strokeLinecap: "round",
        transform: "translate(16.296296, 16.296296) scale(-1, 1) translate(-16.296296, -16.296296) "
    })))))));
};
var WalletIcon = function WalletIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 299 160"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.subIconColor,
        d: "M154.932 144.31c16.42 0 29.73 2.956 29.73 6.602 0 3.646-13.31 6.602-29.73 6.602s-29.73-2.956-29.73-6.602c0-3.646 13.31-6.602 29.73-6.602zM38.894 88.746c5.595 0 10.19 4.277 10.697 9.74a6.45 6.45 0 013.768-1.214 6.484 6.484 0 010 12.966H24.014a7.588 7.588 0 010-15.175c1.704 0 3.27.569 4.537 1.516 1.27-4.519 5.418-7.833 10.343-7.833zM287.055 55.73a2.72 2.72 0 012.72 2.72v21.63a2.72 2.72 0 01-2.72 2.72h-37.303a2.72 2.72 0 01-2.72-2.72V58.45a2.72 2.72 0 012.72-2.72h37.303zM61.817 54.048c2.554 0 4.73 1.6 5.594 3.85a2.545 2.545 0 012.705.883 3.778 3.778 0 011.557-.336 3.8 3.8 0 010 7.603h-16.4a3.8 3.8 0 11.75-7.528 5.995 5.995 0 015.794-4.472zM191.964 28c6.009 0 10.88 4.871 10.88 10.88v1.48L91 42.324V35.48A7.48 7.48 0 0198.48 28h93.484zM38.38 22.048a6.9 6.9 0 016.44 4.43 2.93 2.93 0 013.114 1.017 4.35 4.35 0 011.792-.387 4.374 4.374 0 110 8.748h-18.88a4.374 4.374 0 11.864-8.662c.779-2.96 3.466-5.146 6.67-5.146zM242.193 8a6.9 6.9 0 016.44 4.431 2.928 2.928 0 013.113 1.016 4.353 4.353 0 011.792-.387 4.374 4.374 0 110 8.748h-18.88a4.374 4.374 0 11.866-8.661c.778-2.96 3.464-5.147 6.67-5.147z",
        opacity: "0.302"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "132",
        height: "97",
        x: "91",
        y: "40.398",
        fill: "#FFF",
        rx: "10.88"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "42.743",
        height: "27.07",
        x: "241.333",
        y: "62.141",
        fill: "#CACED8",
        rx: "2.72"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#3B414D",
        fillRule: "nonzero",
        d: "M278.2 125.181a2.04 2.04 0 012.093 1.986c.028 1.075-.78 1.577-1.834 1.683l-.152.01-15.25.4a2.04 2.04 0 01-.26-4.069l.153-.01h15.25zm-192.675 0a2.04 2.04 0 01.103 4.076l-.153.004H62.418a2.04 2.04 0 01-.103-4.076l.153-.004h23.057zm-31.043 1.935a2.04 2.04 0 01-1.78 2.129l-.152.013H44.79a2.04 2.04 0 01-.362-4.061l.152-.014h7.759a2.04 2.04 0 012.142 1.933zm167.441-1.758l31.106.006c1.075-.012 1.958.793 1.971 1.799.012.96-.771 1.756-1.778 1.837l-.145.007L221.97 129c-1.075.012-1.958-.793-1.971-1.799-.012-.96.771-1.756 1.778-1.837l.145-.006zm62.153-56.806v5.7h-42.743v-5.7h42.743zM145.815 71c2.575 0 4.828 1.668 5.702 4.106a1.896 1.896 0 01-3.51 1.423l-.059-.144c-.345-.964-1.196-1.594-2.133-1.594-.883 0-1.689.558-2.069 1.427l-.066.167a1.896 1.896 0 01-3.568-1.28c.874-2.437 3.126-4.105 5.703-4.105zm23.513 0c2.576 0 4.828 1.668 5.702 4.106a1.896 1.896 0 01-3.51 1.423l-.059-.144c-.345-.964-1.196-1.594-2.133-1.594-.883 0-1.689.558-2.068 1.427l-.066.167a1.895 1.895 0 11-3.57-1.28c.875-2.437 3.128-4.105 5.704-4.105zm23.636-45.04c7.032 0 12.752 5.618 12.916 12.61l.004.31-.001 1.12h7.165c6.008 0 10.88 4.871 10.88 10.88v76.549c0 6.008-4.872 10.88-10.88 10.88H100.88c-6.009 0-10.88-4.872-10.88-10.88V45.325h-.04V35.48a9.52 9.52 0 019.249-9.516l.271-.004h93.484zm20.084 18.12l-118.968.001v83.348a6.8 6.8 0 006.561 6.795l.239.005h112.168a6.8 6.8 0 006.796-6.562l.004-.238V50.88a6.8 6.8 0 00-6.562-6.796l-.238-.004zm-45.4 49.455c1.047 0 1.895.849 1.895 1.896a5.415 5.415 0 01-5.197 5.41l-.218.005h-13.505a5.415 5.415 0 01-5.414-5.415 1.896 1.896 0 013.785-.148l.006.148c0 .847.648 1.543 1.476 1.617l.147.007h13.505c.847 0 1.543-.649 1.618-1.476l.006-.148c0-1.047.85-1.896 1.896-1.896zm113.708-31.394a2.72 2.72 0 012.72 2.72v21.63a2.72 2.72 0 01-2.72 2.72h-37.303a2.72 2.72 0 01-2.72-2.72v-21.63a2.72 2.72 0 012.72-2.72h37.303zm0 2.04h-37.303a.68.68 0 00-.672.58l-.008.1v21.63a.68.68 0 00.58.673l.1.007h37.303a.68.68 0 00.673-.58l.007-.1v-21.63a.68.68 0 00-.58-.673l-.1-.007zm-4.246 16.327c.751 0 1.36.609 1.36 1.36v.13a1.36 1.36 0 01-1.36 1.36h-7.253a1.36 1.36 0 01-1.36-1.36v-.13c0-.751.609-1.36 1.36-1.36h7.253zM192.964 30.04H99.48a5.44 5.44 0 00-5.436 5.221l-.004.219V40h107.763v-1.12a8.84 8.84 0 00-8.579-8.836l-.26-.004z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.subIconColor,
        fillRule: "nonzero",
        d: "M160.625 137.938v10.248h6.045a2.04 2.04 0 012.034 1.888l.006.152a2.04 2.04 0 01-1.888 2.034l-.152.006h-8.085a2.04 2.04 0 01-2.034-1.888l-.006-.152v-12.288h4.08zm-7.92 0v11.89a2.04 2.04 0 01-1.887 2.034l-.152.006h-8.085a2.04 2.04 0 01-.153-4.075l.153-.005 6.044-.001v-9.849h4.08zm-62.7-34.592c-.008.004-.01.642-.012 1.477v2.665l-.002.408c-.001.507-.004.846-.01.851l-6.626 5.754 15.406 5.409a5.925 5.925 0 015.126-2.95 2.04 2.04 0 01.153 4.074l-.153.006a1.847 1.847 0 00-.144 3.69l.144.005h3.396a2.04 2.04 0 01.153 4.075l-.153.005h-3.396a5.93 5.93 0 01-5.825-4.828l-18.716-6.567a2.037 2.037 0 01-1.286-1.363 2.04 2.04 0 01.237-2.558l.122-.115 11.378-9.88c.042-.037.14-.109.191-.145l.016-.013zm176.39-8.358a2.04 2.04 0 01.152 4.074l-.152.006h-5.572a2.036 2.036 0 01-.233.213l-.13.093-26.212 17.393a2.04 2.04 0 01-2.238.011l-.141-.1-7.84-6.091c-.01-.007-.015-.415-.018-1.224v-.344V107.728v-.789l.004-1.53 9.198 7.147 20.328-13.488h-4.014a2.04 2.04 0 01-.152-4.074l.152-.006h16.868zm-28.267-27.86a8.905 8.905 0 110 17.81 8.905 8.905 0 010-17.81zm48.927-12.398a3.72 3.72 0 013.715 3.522l.005.198v21.63a3.72 3.72 0 01-3.522 3.715l-.198.005-3.306-.005v-2l3.306.005c.9 0 1.639-.691 1.714-1.572l.006-.148V68.84h-5v-5.699h5V58.45c0-.9-.69-1.639-1.571-1.714l-.149-.006h-37.303c-.9 0-1.638.69-1.713 1.571l-.007.149v3.691h-2V58.45a3.72 3.72 0 013.523-3.715l.197-.005h37.303z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M239.196 71.402v3.56l3.562.002V77.1h-3.562v3.562h-2.137V77.1h-3.562v-2.137l3.561-.001.001-3.561h2.137z"
    }))));
};
var WalletIcon$1 = themeComponent(WalletIcon, "Icons", fallbackValues$b, "info");
// Stable ID per component instance. Use for SVG <defs> references
// (linearGradient, clipPath, filter, mask) so multiple instances on a page
// don't share the same id and collide.
var counter$1 = 0;
var useUniqueId = function useUniqueId() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "uid";
    var idRef = (0, _react.useRef)(null);
    if (idRef.current === null) idRef.current = "".concat(prefix, "-").concat(++counter$1);
    return idRef.current;
};
var WalletBadgeIcon = function WalletBadgeIcon(_ref) {
    var title = _ref.title;
    var gradientId = useUniqueId("wallet-badge-gradient");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        role: title ? "img" : undefined,
        "aria-hidden": title ? undefined : "true",
        "aria-label": title || undefined,
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, title && /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        y: "16",
        width: "64",
        height: "48",
        rx: "6",
        fill: "#317D4F"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 22C0 18.6863 2.68629 16 6 16H58C61.3137 16 64 18.6863 64 22V29H0V22Z",
        fill: "url(#".concat(gradientId, ")"),
        fillOpacity: "0.2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10 4C10 1.79086 11.7909 0 14 0H50C52.2091 0 54 1.79086 54 4V29H10V4Z",
        fill: "#D0C7FD"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "37",
        width: "8",
        height: "29",
        fill: "#3B414D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16 7.5C16 6.39543 16.8954 5.5 18 5.5C19.1046 5.5 20 6.39543 20 7.5V13.5C20 14.6046 19.1046 15.5 18 15.5C16.8954 15.5 16 14.6046 16 13.5V7.5Z",
        fill: "#3B414D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("linearGradient", {
        id: gradientId,
        x1: "0",
        y1: "29",
        x2: "0",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        offset: "1",
        stopOpacity: "0.05"
    }))));
};
var AutopayWalletIcon = function AutopayWalletIcon(_ref) {
    var title = _ref.title;
    var gradientId = useUniqueId("autopay-wallet-gradient");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        role: title ? "img" : undefined,
        "aria-hidden": title ? undefined : "true",
        "aria-label": title || undefined,
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, title && /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        y: "16",
        width: "64",
        height: "48",
        rx: "6",
        fill: "#317D4F"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M40.3857 48C40.6834 48.0001 40.916 48.2595 40.8652 48.5527C40.1294 52.783 36.4407 55.9998 32 56C29.2599 55.9999 26.8065 54.7748 25.1562 52.8428L23.8535 54.1465C23.5385 54.4614 23.0001 54.2384 23 53.793V49.5C23 49.2239 23.2239 49 23.5 49H27.793C28.2384 49.0001 28.4614 49.5385 28.1465 49.8535L26.5762 51.4229C27.8597 52.9951 29.8122 53.9999 32 54C35.3765 53.9998 38.1943 51.6089 38.8535 48.4277C38.904 48.1843 39.1127 48.0002 39.3613 48H40.3857ZM32 38C34.7397 38.0001 37.1917 39.2258 38.8418 41.1572L40.1465 39.8535C40.4615 39.5386 40.9999 39.7616 41 40.207V44.5C41 44.7761 40.7761 45 40.5 45H36.207C35.7616 44.9999 35.5386 44.4615 35.8535 44.1465L37.4238 42.5752C36.1404 41.0036 34.1873 40.0001 32 40C28.6235 40.0002 25.8057 42.3911 25.1465 45.5723C25.096 45.8157 24.8873 45.9998 24.6387 46H23.6143C23.3166 45.9999 23.084 45.7406 23.1348 45.4473C23.8706 41.217 27.5593 38.0002 32 38Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 22C0 18.6863 2.68629 16 6 16H58C61.3137 16 64 18.6863 64 22V29H0V22Z",
        fill: "url(#".concat(gradientId, ")"),
        fillOpacity: "0.2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10 4C10 1.79086 11.7909 0 14 0H50C52.2091 0 54 1.79086 54 4V29H10V4Z",
        fill: "#D0C7FD"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "37",
        width: "8",
        height: "29",
        fill: "#3B414D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16 7.5C16 6.39543 16.8954 5.5 18 5.5C19.1046 5.5 20 6.39543 20 7.5V13.5C20 14.6046 19.1046 15.5 18 15.5C16.8954 15.5 16 14.6046 16 13.5V7.5Z",
        fill: "#3B414D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("linearGradient", {
        id: gradientId,
        x1: "0",
        y1: "29",
        x2: "0",
        y2: "16",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        offset: "1",
        stopOpacity: "0.05"
    }))));
};
var AchReturnIcon = function AchReturnIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -64.000000)",
        fill: "#B34A00"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,64 C88.836556,64 96,71.163444 96,80 C96,88.836556 88.836556,96 80,96 C71.163444,96 64,88.836556 64,80 C64,71.163444 71.163444,64 80,64 Z M77.4246212,73.2824856 C77.2293591,73.0872234 76.9127766,73.0872234 76.7175144,73.2824856 L76.7175144,73.2824856 L70.3535534,79.6464466 C70.1582912,79.8417088 70.1582912,80.1582912 70.3535534,80.3535534 L70.3535534,80.3535534 L76.7175144,86.7175144 C76.9127766,86.9127766 77.2293591,86.9127766 77.4246212,86.7175144 L77.4246212,86.7175144 L78.131728,86.0104076 C78.3269901,85.8151455 78.3269901,85.498563 78.131728,85.3033009 L78.131728,85.3033009 L73.8271068,80.999039 L89.5,81 C89.7761424,81 90,80.7761424 90,80.5 L90,80.5 L90,79.5 C90,79.2238576 89.7761424,79 89.5,79 L89.5,79 L73.8281068,78.999039 L78.131728,74.6966991 C78.3269901,74.501437 78.3269901,74.1848545 78.131728,73.9895924 L78.131728,73.9895924 Z",
        id: "status-icon---ach-return"
    }))));
};
var AllocatedIcon = function AllocatedIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -112.000000)",
        fill: "#D11053"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,112 C88.836556,112 96,119.163444 96,128 C96,136.836556 88.836556,144 80,144 C71.163444,144 64,136.836556 64,128 C64,119.163444 71.163444,112 80,112 Z M83,120 L73,120 C72.4477153,120 72,120.447715 72,121 L72,121 L72,131 C72,131.552285 72.4477153,132 73,132 L73,132 L76,132 L76,135 C76,135.552285 76.4477153,136 77,136 L77,136 L87,136 C87.5522847,136 88,135.552285 88,135 L88,135 L88,125 C88,124.447715 87.5522847,124 87,124 L87,124 L84,124 L84,121 C84,120.447715 83.5522847,120 83,120 L83,120 Z M86.5,126.56 L86.5,134.5 L78.56,134.5 L86.5,126.56 Z M85.438,125.5 L77.5,133.438 L77.5,125.5 L85.438,125.5 Z M82.5,121.5 L82.5,124 L77,124 C76.4477153,124 76,124.447715 76,125 L76,125 L76,130.5 L73.5,130.5 L73.5,121.5 L82.5,121.5 Z",
        id: "status-icon---allocated"
    }))));
};
var CalendarIcon = function CalendarIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -352.000000)",
        fill: "#6D717E"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,384 C88.836556,384 96,376.836556 96,368 C96,359.163444 88.836556,352 80,352 C71.163444,352 64,359.163444 64,368 C64,376.836556 71.163444,384 80,384 Z M73,362 L87,362 C87.5522847,362 88,362.447715 88,363 L88,375 C88,375.552285 87.5522847,376 87,376 L73,376 C72.4477153,376 72,375.552285 72,375 L72,363 C72,362.447715 72.4477153,362 73,362 Z M86.5,366 L86.5,374.5 L73.5,374.5 L73.5,366 L86.5,366 Z M76.25,360.5 C76.3880712,360.5 76.5,360.611929 76.5,360.75 L76.5,362 L75,362 L75,360.75 C75,360.611929 75.1119288,360.5 75.25,360.5 L76.25,360.5 Z M84.75,360.5 C84.8880712,360.5 85,360.611929 85,360.75 L85,362 L83.5,362 L83.5,360.75 C83.5,360.611929 83.6119288,360.5 83.75,360.5 L84.75,360.5 Z",
        id: "status-icon---calendar"
    }))));
};
var ChargebackIcon = function ChargebackIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -160.000000)",
        fill: "#B34A00"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,192 C88.836556,192 96,184.836556 96,176 C96,167.163444 88.836556,160 80,160 C71.163444,160 64,167.163444 64,176 C64,184.836556 71.163444,192 80,192 Z M89,170 C89.5522847,170 90,170.447715 90,171 L90,181 C90,181.552285 89.5522847,182 89,182 L75,182 C74.4477153,182 74,181.552285 74,181 L74,171 C74,170.447715 74.4477153,170 75,170 L89,170 Z M89,176 L75,176 L75,181 L89,181 L89,176 Z M71.8535534,172.853553 C71.9473216,172.947322 72,173.074499 72,173.207107 L72,178.792893 C72,179.069036 71.7761424,179.292893 71.5,179.292893 C71.3673918,179.292893 71.2402148,179.240215 71.1464466,179.146447 L68.3535534,176.353553 C68.1582912,176.158291 68.1582912,175.841709 68.3535534,175.646447 L71.1464466,172.853553 C71.3417088,172.658291 71.6582912,172.658291 71.8535534,172.853553 Z M86.75,177.75 C87.0261424,177.75 87.25,177.973858 87.25,178.25 L87.25,178.75 C87.25,179.026142 87.0261424,179.25 86.75,179.25 L84.75,179.25 C84.4738576,179.25 84.25,179.026142 84.25,178.75 L84.25,178.25 C84.25,177.973858 84.4738576,177.75 84.75,177.75 L86.75,177.75 Z M89,171 L75,171 L75,173.5 L89,173.5 L89,171 Z",
        id: "status-icon---chargeback"
    }))));
};
var ChargebackReversalIcon = function ChargebackReversalIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -208.000000)",
        fill: "#B34A00"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,240 C88.836556,240 96,232.836556 96,224 C96,215.163444 88.836556,208 80,208 C71.163444,208 64,215.163444 64,224 C64,232.836556 71.163444,240 80,240 Z M85,218 C85.5522847,218 86,218.447715 86,219 L86,229 C86,229.552285 85.5522847,230 85,230 L71,230 C70.4477153,230 70,229.552285 70,229 L70,219 C70,218.447715 70.4477153,218 71,218 L85,218 Z M85,224 L71,224 L71,229 L85,229 L85,224 Z M88.1464466,220.853553 C88.3417088,220.658291 88.6582912,220.658291 88.8535534,220.853553 L88.8535534,220.853553 L91.6464466,223.646447 C91.8417088,223.841709 91.8417088,224.158291 91.6464466,224.353553 L91.6464466,224.353553 L88.8535534,227.146447 C88.7597852,227.240215 88.6326082,227.292893 88.5,227.292893 C88.2238576,227.292893 88,227.069036 88,226.792893 L88,226.792893 L88,221.207107 C88,221.074499 88.0526784,220.947322 88.1464466,220.853553 Z M82.75,225.75 C83.0261424,225.75 83.25,225.973858 83.25,226.25 L83.25,226.75 C83.25,227.026142 83.0261424,227.25 82.75,227.25 L80.75,227.25 C80.4738576,227.25 80.25,227.026142 80.25,226.75 L80.25,226.25 C80.25,225.973858 80.4738576,225.75 80.75,225.75 L82.75,225.75 Z M85,219 L71,219 L71,221.5 L85,221.5 L85,219 Z",
        id: "status-icon---chargeback-reversal"
    }))));
};
var DuplicateIcon = function DuplicateIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -256.000000)",
        fill: "#6D717E"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,288 C88.836556,288 96,280.836556 96,272 C96,263.163444 88.836556,256 80,256 C71.163444,256 64,263.163444 64,272 C64,280.836556 71.163444,288 80,288 Z M83,264 C83.5522847,264 84,264.447715 84,265 L84,268 L87,268 C87.5522847,268 88,268.447715 88,269 L88,279 C88,279.552285 87.5522847,280 87,280 L77,280 C76.4477153,280 76,279.552285 76,279 L76,276 L73,276 C72.4477153,276 72,275.552285 72,275 L72,265 C72,264.447715 72.4477153,264 73,264 L83,264 Z M82.5,265.5 L73.5,265.5 L73.5,274.5 L76,274.5 L76,269 C76,268.447715 76.4477153,268 77,268 L82.5,268 L82.5,265.5 Z M77.5,269.5 L86.5,269.5 L86.5,278.5 L77.5,278.5 L77.5,269.5 Z",
        id: "status-icon---duplicate"
    }))));
};
var ErroredIcon = function ErroredIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -304.000000)",
        fill: "#D11053"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,336 C88.836556,336 96,328.836556 96,320 C96,311.163444 88.836556,304 80,304 C71.163444,304 64,311.163444 64,320 C64,328.836556 71.163444,336 80,336 Z M72.5492717,327 L87.4507283,327 C88.2791554,327 88.9507283,326.328427 88.9507283,325.5 C88.9507283,325.245084 88.8857626,324.994373 88.7619642,324.771536 L81.3112359,311.360225 C80.9089161,310.636049 79.9957112,310.375133 79.2715356,310.777453 C79.0266755,310.913487 78.8247975,311.115365 78.6887641,311.360225 L71.2380358,324.771536 C70.835716,325.495711 71.0966317,326.408916 71.8208073,326.811236 C72.0436443,326.935034 72.2943553,327 72.5492717,327 Z M72.5,325.5 L87.5,325.5 L80,312.087006 L72.5,325.5 Z M79.5,322.5 L80.5,322.5 C80.6380712,322.5 80.75,322.611929 80.75,322.75 L80.75,323.75 C80.75,323.888071 80.6380712,324 80.5,324 L79.5,324 C79.3619288,324 79.25,323.888071 79.25,323.75 L79.25,322.75 C79.25,322.611929 79.3619288,322.5 79.5,322.5 Z M79.5,315.5 L80.5,315.5 C80.6380712,315.5 80.75,315.611929 80.75,315.75 L80.75,321.25 C80.75,321.388071 80.6380712,321.5 80.5,321.5 L79.5,321.5 C79.3619288,321.5 79.25,321.388071 79.25,321.25 L79.25,315.75 C79.25,315.611929 79.3619288,315.5 79.5,315.5 Z",
        id: "status-icon---errored"
    }))));
};
var _excluded$q = [
    "linkColor",
    "text",
    "ariaLabel"
];
var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
    var _ref$linkColor = _ref.linkColor, linkColor = _ref$linkColor === void 0 ? MATISSE_BLUE : _ref$linkColor, text = _ref.text, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "External Link" : _ref$ariaLabel, rest = _objectWithoutProperties(_ref, _excluded$q);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": ariaLabel
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.86092 1.59483C1.92074 1.56953 1.98651 1.55554 2.05554 1.55554H2.6111H4.94443C5.22057 1.55554 5.44443 1.7794 5.44443 2.05554V2.6111C5.44443 2.88724 5.22057 3.1111 4.94443 3.1111H3.1111V10.8889H10.8889V9.05554C10.8889 8.7794 11.1127 8.55554 11.3889 8.55554H11.9444C12.2206 8.55554 12.4444 8.7794 12.4444 9.05554V11.9444C12.4444 12.2206 12.2206 12.4444 11.9444 12.4444H11.3889C11.3507 12.4444 11.3135 12.4401 11.2778 12.432C11.242 12.4401 11.2048 12.4444 11.1667 12.4444H2.6111H2.05554C1.7794 12.4444 1.55554 12.2206 1.55554 11.9444V11.3889V2.6111V2.05554C1.55554 2.05554 1.55554 2.05554 1.55554 2.05554C1.55554 2.01307 1.56084 1.97183 1.57081 1.93246C1.60944 1.77983 1.71826 1.65517 1.86092 1.59483ZM7.77776 2.05554C7.77776 1.7794 8.00162 1.55554 8.27776 1.55554H11.3889H11.9444C12.2206 1.55554 12.4444 1.7794 12.4444 2.05554V2.6111V5.72221C12.4444 5.99835 12.2206 6.22221 11.9444 6.22221H11.3889C11.1127 6.22221 10.8889 5.99835 10.8889 5.72221V4.26638L6.89793 8.25733C6.70267 8.45259 6.38608 8.45259 6.19082 8.25733L5.79798 7.8645C5.60272 7.66923 5.60272 7.35265 5.79798 7.15739L9.84428 3.1111H8.27776C8.00162 3.1111 7.77776 2.88724 7.77776 2.6111V2.05554Z",
        fill: linkColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_902_435-".concat(text),
        style: {
            maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "1",
        y: "1",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.86092 1.59483C1.92074 1.56953 1.98651 1.55554 2.05554 1.55554H2.6111H4.94443C5.22057 1.55554 5.44443 1.7794 5.44443 2.05554V2.6111C5.44443 2.88724 5.22057 3.1111 4.94443 3.1111H3.1111V10.8889H10.8889V9.05554C10.8889 8.7794 11.1127 8.55554 11.3889 8.55554H11.9444C12.2206 8.55554 12.4444 8.7794 12.4444 9.05554V11.9444C12.4444 12.2206 12.2206 12.4444 11.9444 12.4444H11.3889C11.3507 12.4444 11.3135 12.4401 11.2778 12.432C11.242 12.4401 11.2048 12.4444 11.1667 12.4444H2.6111H2.05554C1.7794 12.4444 1.55554 12.2206 1.55554 11.9444V11.3889V2.6111V2.05554C1.55554 2.05554 1.55554 2.05554 1.55554 2.05554C1.55554 2.01307 1.56084 1.97183 1.57081 1.93246C1.60944 1.77983 1.71826 1.65517 1.86092 1.59483ZM7.77776 2.05554C7.77776 1.7794 8.00162 1.55554 8.27776 1.55554H11.3889H11.9444C12.2206 1.55554 12.4444 1.7794 12.4444 2.05554V2.6111V5.72221C12.4444 5.99835 12.2206 6.22221 11.9444 6.22221H11.3889C11.1127 6.22221 10.8889 5.99835 10.8889 5.72221V4.26638L6.89793 8.25733C6.70267 8.45259 6.38608 8.45259 6.19082 8.25733L5.79798 7.8645C5.60272 7.66923 5.60272 7.35265 5.79798 7.15739L9.84428 3.1111H8.27776C8.00162 3.1111 7.77776 2.88724 7.77776 2.6111V2.05554Z",
        fill: linkColor
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_902_435-".concat(text, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "-0.0864258",
        width: "14",
        height: "14",
        fill: "none"
    })));
};
var FailedIcon = function FailedIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -400.000000)",
        fill: "#D11053"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,432 C88.836556,432 96,424.836556 96,416 C96,407.163444 88.836556,400 80,400 C71.163444,400 64,407.163444 64,416 C64,424.836556 71.163444,432 80,432 Z M75.4038059,409.989592 L80.0001458,414.586146 L84.5961941,409.989592 C84.7914562,409.79433 85.1080387,409.79433 85.3033009,409.989592 L86.0104076,410.696699 C86.2056698,410.891961 86.2056698,411.208544 86.0104076,411.403806 L81.4141458,416.000146 L86.0104076,420.596194 C86.2056698,420.791456 86.2056698,421.108039 86.0104076,421.303301 L85.3033009,422.010408 C85.1080387,422.20567 84.7914562,422.20567 84.5961941,422.010408 L80.0001458,417.414146 L75.4038059,422.010408 C75.2085438,422.20567 74.8919613,422.20567 74.6966991,422.010408 L73.9895924,421.303301 C73.7943302,421.108039 73.7943302,420.791456 73.9895924,420.596194 L78.5861458,416.000146 L73.9895924,411.403806 C73.7943302,411.208544 73.7943302,410.891961 73.9895924,410.696699 L74.6966991,409.989592 C74.8919613,409.79433 75.2085438,409.79433 75.4038059,409.989592 Z",
        id: "status-icon---failed"
    }))));
};
var PencilIcon = function PencilIcon(_ref) {
    var _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "Edit" : _ref$ariaLabel, themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        "aria-label": ariaLabel,
        width: "24px",
        height: "24px",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.74 6.84a.885.885 0 0 1 0 1.253l-1.626 1.626-3.333-3.333 1.626-1.626a.885.885 0 0 1 1.253 0l2.08 2.08ZM4 20.5v-3.333l9.83-9.83 3.333 3.333-9.83 9.83H4Z",
        fill: themeValues.subIconColor
    }));
};
var PencilIcon$1 = themeComponent(PencilIcon, "Icons", fallbackValues$b, "info");
var PendingIcon = function PendingIcon(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? STORM_GREY : _ref$fill;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -448.000000)",
        fill: fill
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,480 C88.836556,480 96,472.836556 96,464 C96,455.163444 88.836556,448 80,448 C71.163444,448 64,455.163444 64,464 C64,472.836556 71.163444,480 80,480 Z M87,466 C88.1045695,466 89,465.104569 89,464 C89,462.895431 88.1045695,462 87,462 C85.8954305,462 85,462.895431 85,464 C85,465.104569 85.8954305,466 87,466 Z M80,462 C81.1045695,462 82,462.895431 82,464 C82,465.104569 81.1045695,466 80,466 C78.8954305,466 78,465.104569 78,464 C78,462.895431 78.8954305,462 80,462 Z M73,462 C74.1045695,462 75,462.895431 75,464 C75,465.104569 74.1045695,466 73,466 C71.8954305,466 71,465.104569 71,464 C71,462.895431 71.8954305,462 73,462 Z",
        id: "status-icon---pending"
    }))));
};
var RefundIcon = function RefundIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -496.000000)",
        fill: "#317D4F",
        fillRule: "nonzero"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,528 C88.836556,528 96,520.836556 96,512 C96,503.163444 88.836556,496 80,496 C71.163444,496 64,503.163444 64,512 C64,520.836556 71.163444,528 80,528 Z M82.3230241,504.25 L82.3230241,505.928718 C84.4879725,506.299892 85.8024055,507.750844 85.7766323,509.497047 L85.7766323,509.497047 L83.242268,509.539226 C83.0876289,508.459448 82.5893471,507.801458 81.266323,507.801458 C79.9003436,507.801458 79.0584192,508.408833 79.0584192,509.294589 C79.0584192,510.003194 79.4536082,510.357496 80.8024055,510.703362 L80.8024055,510.703362 L82.8041237,511.184201 C85.0635739,511.715654 86,513.048506 86,514.879067 C86,516.718065 84.5652921,518.000301 82.2714777,518.295553 L82.2714777,518.295553 L82.2714777,519.805556 L80.1065292,519.805556 L80.1065292,518.303989 C77.7525773,518.04248 76.2319588,516.895216 76,514.760966 L76,514.760966 L78.6116838,514.710352 C78.8780069,515.823873 79.8402062,516.414377 81.2147766,516.414377 C82.45189,516.414377 83.3367698,515.764823 83.3367698,514.895939 C83.3367698,513.993312 82.7611684,513.622138 81.5498282,513.352193 L81.5498282,513.352193 L79.5137457,512.921969 C77.6151203,512.54236 76.395189,511.454146 76.3694158,509.581405 C76.3522337,507.590564 77.9329897,506.249277 80.1494845,505.920282 L80.1494845,505.920282 L80.1494845,504.25 L82.3230241,504.25 Z M73.5,508.540312 C73.7761424,508.540312 74,508.76417 74,509.040312 L74,509.040312 L74,514.959688 C74,515.073223 73.9613596,515.183379 73.8904344,515.272035 C73.7179296,515.487666 73.4032834,515.522627 73.1876525,515.350122 L73.1876525,515.350122 L69.488043,512.390434 C69.4592107,512.367369 69.433022,512.34118 69.4099561,512.312348 C69.2374514,512.096717 69.272412,511.78207 69.488043,511.609566 L69.488043,511.609566 L73.1876525,508.649878 C73.276309,508.578953 73.3864643,508.540312 73.5,508.540312 Z",
        id: "status-icon---refund"
    }))));
};
var RejectedIcon = function RejectedIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fillRule: "none",
        fillule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -544.000000)",
        fill: "#D11053"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,576 C88.836556,576 96,568.836556 96,560 C96,551.163444 88.836556,544 80,544 C71.163444,544 64,551.163444 64,560 C64,568.836556 71.163444,576 80,576 Z M76.7175144,553.282486 C76.9127766,553.087223 77.2293591,553.087223 77.4246212,553.282486 L78.131728,553.989592 C78.3269901,554.184855 78.3269901,554.501437 78.131728,554.696699 L73.8281068,558.999039 L89.5,559 C89.7761424,559 90,559.223858 90,559.5 L90,560.5 C90,560.776142 89.7761424,561 89.5,561 L73.8271068,560.999039 L78.131728,565.303301 C78.3269901,565.498563 78.3269901,565.815145 78.131728,566.010408 L77.4246212,566.717514 C77.2293591,566.912777 76.9127766,566.912777 76.7175144,566.717514 L70.3535534,560.353553 C70.1582912,560.158291 70.1582912,559.841709 70.3535534,559.646447 L76.7175144,553.282486 Z",
        id: "status-icon---rejected"
    }))));
};
var RejectedVelocityIcon = function RejectedVelocityIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -592.000000)",
        fill: "#D11053"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,624 C88.836556,624 96,616.836556 96,608 C96,599.163444 88.836556,592 80,592 C71.163444,592 64,599.163444 64,608 C64,616.836556 71.163444,624 80,624 Z M77.4246212,601.282486 L78.131728,601.989592 C78.3269901,602.184855 78.3269901,602.501437 78.131728,602.696699 L73.8281068,606.999039 L81.5,607 C81.7761424,607 82,607.223858 82,607.5 L82,608.5 C82,608.776142 81.7761424,609 81.5,609 L73.8271068,608.999039 L78.131728,613.303301 C78.3269901,613.498563 78.3269901,613.815145 78.131728,614.010408 L77.4246212,614.717514 C77.2293591,614.912777 76.9127766,614.912777 76.7175144,614.717514 L70.3535534,608.353553 C70.1582912,608.158291 70.1582912,607.841709 70.3535534,607.646447 L76.7175144,601.282486 C76.9127766,601.087223 77.2293591,601.087223 77.4246212,601.282486 Z M89.75,607 C89.8880712,607 90,607.111929 90,607.25 L90,608.75 C90,608.888071 89.8880712,609 89.75,609 L88.25,609 C88.1119288,609 88,608.888071 88,608.75 L88,607.25 C88,607.111929 88.1119288,607 88.25,607 L89.75,607 Z M85.75,607 C85.8880712,607 86,607.111929 86,607.25 L86,608.75 C86,608.888071 85.8880712,609 85.75,609 L84.25,609 C84.1119288,609 84,608.888071 84,608.75 L84,607.25 C84,607.111929 84.1119288,607 84.25,607 L85.75,607 Z",
        id: "status-icon---rejected-velocity"
    }))));
};
var SuccessfulIcon = function SuccessfulIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -640.000000)",
        fill: "#317D4F"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,672 C88.836556,672 96,664.836556 96,656 C96,647.163444 88.836556,640 80,640 C71.163444,640 64,647.163444 64,656 C64,664.836556 71.163444,672 80,672 Z M89.6923882,650.464466 C89.8876503,650.659728 89.8876503,650.976311 89.6923882,651.171573 L78.3859015,662.477912 C78.3835247,662.480387 78.3811174,662.482844 78.3786797,662.485281 L77.6715729,663.192388 C77.4763107,663.38765 77.1597282,663.38765 76.9644661,663.192388 L76.2573593,662.485281 L76.2502882,662.476796 L71.3076118,657.535534 C71.1123497,657.340272 71.1123497,657.023689 71.3076118,656.828427 L72.0147186,656.12132 C72.2099808,655.926058 72.5265633,655.926058 72.7218254,656.12132 L77.3180195,660.7161 L88.2781746,649.757359 C88.4734367,649.562097 88.7900192,649.562097 88.9852814,649.757359 L89.6923882,650.464466 Z",
        id: "status-icon---successful"
    }))));
};
var VoidedIcon = function VoidedIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -688.000000)",
        fill: "#317D4F"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,720 C88.836556,720 96,712.836556 96,704 C96,695.163444 88.836556,688 80,688 C71.163444,688 64,695.163444 64,704 C64,712.836556 71.163444,720 80,720 Z M75.4038059,697.989592 L80.0001458,702.586146 L84.5961941,697.989592 C84.7914562,697.79433 85.1080387,697.79433 85.3033009,697.989592 L86.0104076,698.696699 C86.2056698,698.891961 86.2056698,699.208544 86.0104076,699.403806 L81.4141458,704.000146 L86.0104076,708.596194 C86.2056698,708.791456 86.2056698,709.108039 86.0104076,709.303301 L85.3033009,710.010408 C85.1080387,710.20567 84.7914562,710.20567 84.5961941,710.010408 L80.0001458,705.414146 L75.4038059,710.010408 C75.2085438,710.20567 74.8919613,710.20567 74.6966991,710.010408 L73.9895924,709.303301 C73.7943302,709.108039 73.7943302,708.791456 73.9895924,708.596194 L78.5861458,704.000146 L73.9895924,699.403806 C73.7943302,699.208544 73.7943302,698.891961 73.9895924,698.696699 L74.6966991,697.989592 C74.8919613,697.79433 75.2085438,697.79433 75.4038059,697.989592 Z",
        id: "status-icon---voided"
    }))));
};
var StatusUnknownIcon = function StatusUnknownIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "STOR-3203",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Icons",
        transform: "translate(-64.000000, -736.000000)",
        fill: "#6D717E"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,736 C88.836556,736 96,743.163444 96,752 C96,760.836556 88.836556,768 80,768 C71.163444,768 64,760.836556 64,752 C64,743.163444 71.163444,736 80,736 Z M80.85,757 L78.85,757 L78.85,759 L80.85,759 L80.85,757 Z M80.1460007,745 C78.0670004,745 76.4650001,746.017 75.7,747.799 L75.7,747.799 L77.5900003,748.294001 L77.6622133,748.125985 C78.1059448,747.191195 79.1250006,746.557 80.1280007,746.557 C81.2800009,746.557 82.099001,747.187 82.099001,748.195001 C82.099001,750.301001 78.9670005,751.093001 78.9670005,754.459002 L78.9670005,754.459002 L80.7670008,754.459002 L80.7792965,754.169347 C81.0061162,751.541289 84.2950014,750.971966 84.2950014,748.087001 C84.2950014,746.341 82.6480011,745 80.1460007,745 Z",
        id: "status-icon---default-/-unknown"
    }))));
};
var CaretArrowDown = function CaretArrowDown(_ref) {
    var color = _ref.color;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "10",
        height: "7",
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.01563 1.11612C8.82037 0.920857 8.50379 0.920857 8.30853 1.11612L4.94977 4.47488L1.59101 1.11612C1.39575 0.920857 1.07917 0.920856 0.883904 1.11612L0.353574 1.64645C0.158312 1.84171 0.158312 2.15829 0.353574 2.35356L4.06588 6.06587L4.59621 6.5962C4.79148 6.79146 5.10806 6.79146 5.30332 6.5962L5.83365 6.06587L9.54596 2.35356C9.74122 2.15829 9.74122 1.84171 9.54596 1.64645L9.01563 1.11612Z",
        fill: color
    }));
};
var CaretArrowDown$1 = themeComponent(CaretArrowDown, "Icons", fallbackValues$b);
var CaretArrowUp = function CaretArrowUp(_ref) {
    var color = _ref.color;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "10",
        height: "7",
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.883904 5.88388C1.07917 6.07914 1.39575 6.07914 1.59101 5.88388L4.94977 2.52512L8.30853 5.88388C8.50379 6.07914 8.82037 6.07914 9.01563 5.88388L9.54596 5.35355C9.74122 5.15829 9.74122 4.84171 9.54596 4.64644L5.83365 0.934134L5.30332 0.403804C5.10806 0.208542 4.79148 0.208542 4.59621 0.403804L4.06588 0.934134L0.353574 4.64644C0.158312 4.84171 0.158312 5.15829 0.353574 5.35355L0.883904 5.88388Z",
        fill: color
    }));
};
var CaretArrowUp$1 = themeComponent(CaretArrowUp, "Icons", fallbackValues$b);
// This differs from CaretArrowUp and CaretArrowDown in that it completes a triangular shape. It is used in the header on Navigate.
var CarrotIcon = function CarrotIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "10",
        height: "5",
        viewBox: "0 0 10 5"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "carrot-path-1",
        d: "M6.99999958 9.9999994L11.9999993 14.9999991 16.999999 9.9999994z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-423 -974)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(372 958)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(44 6)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "carrot-mask-2",
        fill: "#fff"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#carrot-path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#000",
        xlinkHref: "#carrot-path-1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: themeValues.singleIconColor,
        fillRule: "nonzero",
        mask: "url(#carrot-mask-2)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 0H24V24H0z"
    }))))))));
};
var CarrotIcon$1 = themeComponent(CarrotIcon, "Icons", fallbackValues$b, "darkMode");
var ProfileIcon = function ProfileIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "299",
        height: "151",
        viewBox: "0 0 299 151"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.subIconColor,
        d: "M162.932 144.31c16.42 0 29.73 2.956 29.73 6.602 0 3.646-13.31 6.602-29.73 6.602s-29.73-2.956-29.73-6.602c0-3.646 13.31-6.602 29.73-6.602zM123.899 25.659a4 4 0 013.988 3.688l.539 6.892h85.445c3.396 0 6.293 2.78 6.47 6.207l4.31 83.776c.177 3.427-2.434 6.205-5.83 6.205H100.945c-3.397 0-6.293-2.778-6.47-6.205l-4.31-83.776c-.177-3.428 2.434-6.206 5.83-6.206h2.05l-.16-3.103a4.117 4.117 0 01.077-1.039l-.165-2.127a4 4 0 013.987-4.312H123.9zm-80.672 76.579c2.836 0 5.164 2.189 5.42 4.985a3.247 3.247 0 011.91-.621c1.814 0 3.285 1.485 3.285 3.318 0 1.832-1.47 3.318-3.285 3.318h-14.87c-2.123 0-3.845-1.739-3.845-3.883 0-2.145 1.722-3.884 3.845-3.884.863 0 1.657.291 2.3.776.643-2.313 2.744-4.009 5.24-4.009zm30.478-53.79c.369 0 .668.398.668.89v39.11h-28v-39.11c0-.492.3-.89.668-.89zm221.35 7.282a2.72 2.72 0 012.72 2.72v21.63a2.72 2.72 0 01-2.72 2.72h-37.303a2.72 2.72 0 01-2.72-2.72V58.45a2.72 2.72 0 012.72-2.72h37.303zM31.403 20.856c3.193 0 5.912 2 6.993 4.814a3.181 3.181 0 013.381 1.103 4.723 4.723 0 011.946-.42 4.75 4.75 0 014.75 4.751 4.75 4.75 0 01-4.75 4.752h-20.5a4.75 4.75 0 01-4.75-4.752 4.75 4.75 0 015.687-4.657c.846-3.216 3.764-5.591 7.243-5.591zM237.078 10c3.406 0 6.306 2.133 7.46 5.135a3.39 3.39 0 013.605 1.177 5.04 5.04 0 012.076-.448 5.067 5.067 0 015.066 5.068c0 2.799-2.268 5.068-5.066 5.068h-21.868a5.067 5.067 0 01-5.066-5.068 5.067 5.067 0 016.068-4.968c.901-3.43 4.013-5.964 7.725-5.964z",
        opacity: "0.302"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M143.096 33.659a4 4 0 013.985 4.347l-.094 1.098c.057.288.083.588.072.896l-.104 3h79.1c3.397 0 6.057 2.686 5.941 6l-2.817 81c-.115 3.314-2.962 6-6.358 6H104.945c-3.397 0-6.057-2.686-5.941-6l2.817-81c.115-3.314 2.962-6 6.358-6l4.468-.001.494-5.686a4 4 0 013.985-3.654h25.97z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#CACED8",
        d: "M80.846 54.267c.369 0 .668.233.668.52v36.48h-28v-36.48c0-.287.3-.52.669-.52zm208.51 7.874a2.72 2.72 0 012.72 2.72v21.63a2.72 2.72 0 01-2.72 2.72h-37.303a2.72 2.72 0 01-2.72-2.72v-21.63a2.72 2.72 0 012.72-2.72h37.303z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#3B414D",
        fillRule: "nonzero",
        d: "M123.298 25c3.333 0 6.138 2.69 6.312 6.075l.017.584h14.276a5.993 5.993 0 014.931 2.58h65.037c4.01 0 7.46 2.918 8.288 6.761h3.896c4.434 0 7.962 3.48 7.945 7.823l-.005.247-2.653 76.287 29.687.007c1.075-.012 1.958.793 1.971 1.799.012.96-.771 1.756-1.778 1.837l-.145.007-29.862-.008-.037 1.07c-.15 4.318-3.754 7.798-8.106 7.927l-.251.004H104.945c-3.077 0-5.719-1.677-7.04-4.155a8.665 8.665 0 01-4.734-4.585H70.418a2.04 2.04 0 01-.103-4.075l.153-.004 21.95-.001-4.25-82.632c-.232-4.482 3.154-8.172 7.58-8.304l.234-.005-.094-3c-.172-3.346 2.354-6.114 5.658-6.235l.227-.004h21.525zm20.605 10.659h-25.932a2 2 0 00-1.983 1.741l-.99 7.599-6.819.001c-2.329 0-4.282 1.843-4.36 4.07l-2.817 81c-.075 2.17 1.667 3.93 3.943 3.93h117.876c2.329 0 4.282-1.843 4.36-4.07l2.817-81c.075-2.17-1.667-3.93-3.943-3.93l-81.093-.001.925-7.081a2 2 0 00-1.984-2.259zM286.2 125.181a2.04 2.04 0 012.093 1.986c.028 1.075-.78 1.577-1.834 1.683l-.152.01-15.25.4a2.04 2.04 0 01-.26-4.069l.153-.01h15.25zm-223.718 1.935a2.04 2.04 0 01-1.78 2.129l-.152.013H52.79a2.04 2.04 0 01-.362-4.061l.152-.014h7.759a2.04 2.04 0 012.142 1.933zM123.298 29h-21.525c-1.066 0-1.876.812-1.891 1.922l.002.153.225 7.165h-4.114c-2.178 0-3.847 1.706-3.839 3.896l.006.207 4.31 83.776c.038.717.25 1.398.595 1.998l2.755-79.187c.153-4.4 3.893-7.93 8.357-7.93l3.305-.001.538-4.116a6 6 0 015.712-5.22l.237-.004h7.655l-.013-.42c-.06-1.172-1.03-2.15-2.16-2.233l-.155-.006zm53.072 64.344l.148.003a1.895 1.895 0 011.77 2.014c-.185 2.865-2.567 5.172-5.413 5.289l-.226.004h-13.504c-3.04 0-5.38-2.502-5.184-5.537a1.896 1.896 0 013.787.096l-.004.148c-.052.805.487 1.43 1.262 1.496l.139.006h13.504c.894 0 1.705-.717 1.84-1.598l.015-.148a1.896 1.896 0 011.866-1.773zM81.514 53.018v.374c.573.225 1 .734 1 1.396v36.479a1 1 0 01-1 1h-28a1 1 0 01-1-1v-36.48c0-.661.427-1.17 1-1.395v-.374h28zm-1 4.807h-26v32.441h26V57.825zm211.562 28.666a2.72 2.72 0 01-2.72 2.72h-37.303a2.72 2.72 0 01-2.72-2.72v-21.63a2.72 2.72 0 012.72-2.72h37.303a2.72 2.72 0 012.72 2.72v21.63zM67.158 83.647c.57 0 1.032.462 1.032 1.032v2.177c0 .57-.462 1.032-1.032 1.032h-7.886c-.57 0-1.033-.462-1.033-1.032v-2.177c0-.57.463-1.032 1.033-1.032zm222.878-9.396h-38.663v12.24a.68.68 0 00.58.673l.1.007h37.303a.68.68 0 00.673-.58l.007-.1v-12.24zM66.124 85.711h-5.82v.111h5.82v-.111zm218.986-5.203c.751 0 1.36.609 1.36 1.36v.13a1.36 1.36 0 01-1.36 1.36h-7.253a1.36 1.36 0 01-1.36-1.36v-.13c0-.751.609-1.36 1.36-1.36h7.253zM77 74.25a1 1 0 011 1v5a1 1 0 01-1 1H58a1 1 0 01-1-1v-5a1 1 0 011-1zm-1 2H59v3h17v-3zm80.015-5.442c2.612 0 4.82 1.717 5.553 4.21a1.895 1.895 0 01-3.59 1.21l-.047-.14c-.267-.907-1.015-1.489-1.916-1.489-.915 0-1.813.597-2.275 1.517l-.081.176a1.896 1.896 0 11-3.492-1.477c1.008-2.383 3.306-4.007 5.848-4.007zm23.513 0c2.613 0 4.82 1.717 5.553 4.21a1.896 1.896 0 01-3.59 1.21l-.047-.14c-.267-.907-1.015-1.489-1.916-1.489-.915 0-1.813.597-2.275 1.517l-.081.176a1.896 1.896 0 01-3.492-1.477c1.008-2.383 3.306-4.007 5.848-4.007zM77 65.25a1 1 0 011 1v5a1 1 0 01-1 1H58a1 1 0 01-1-1v-5a1 1 0 011-1zm-1 2H59v3h17v-3zm213.356-3.069h-37.303a.68.68 0 00-.672.58l-.008.1v3.691h38.663v-3.691a.68.68 0 00-.58-.673l-.1-.007zM67.12 60.839a1.033 1.033 0 01.113 2.059l-.113.006h-9.038a1.033 1.033 0 01-.113-2.06l.113-.005h9.038zm146.75-22.6h-63.996l-.021.196-.335 2.564 68.458.001c-.674-1.547-2.188-2.669-3.895-2.755l-.21-.005z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: themeValues.subIconColor,
        fillRule: "nonzero",
        d: "M168.625 137.938v10.248h6.045a2.04 2.04 0 012.034 1.888l.006.152a2.04 2.04 0 01-1.888 2.034l-.152.006h-8.085a2.04 2.04 0 01-2.034-1.888l-.006-.152v-12.288h4.08zm-7.92 0v11.89a2.04 2.04 0 01-1.887 2.034l-.152.006h-8.085a2.04 2.04 0 01-.153-4.075l.153-.005 6.044-.001v-9.849h4.08zm113.69-42.95a2.04 2.04 0 01.152 4.074l-.152.006h-5.572a2.036 2.036 0 01-.233.213l-.13.093-26.212 17.393a2.04 2.04 0 01-2.238.011l-.141-.1-7.84-6.091c-.01-.008-.017-.531-.018-1.568v-1.543c0-.602.002-1.29.004-2.067l9.198 7.147 20.328-13.488h-4.014a2.04 2.04 0 01-.152-4.074l.152-.006h16.868zM80.5 96.46a2.04 2.04 0 01.152 4.074l-.152.006h-4.092l11.455 11.59 9.934-8.627c.042-.036.14-.108.191-.144l.016-.012-.001.014c-.006.096-.008.588-.01 1.24v2.431l-.001.667a25.458 25.458 0 01-.01 1.048l-8.888 7.718-.017.014-.017.015-.06.048.094-.077a2.066 2.066 0 01-.811.43c-.037.01-.074.02-.111.027l-.03.006a1.966 1.966 0 01-.577.028 2 2 0 01-.686-.189 2.032 2.032 0 01-.304-.179l-.037-.027a1.865 1.865 0 01-.095-.075l-.008-.007-.042-.036a2.05 2.05 0 01-.077-.073l-.01-.011-14.257-14.425a2.033 2.033 0 01-.589-1.394H62.5a2.04 2.04 0 01-.152-4.074l.152-.006h18zm-6.795-49.011c.944 0 1.6.81 1.663 1.741l.005.148v3.68s-.5.017-1 .026v.07H53.098v1.907h-5.725v17.54a8.885 8.885 0 012.492-.43l.263-.003a8.905 8.905 0 11-2.914 17.322l-.84-.001a1 1 0 01-.994-.882 8.898 8.898 0 01-4.157-7.535 8.898 8.898 0 014.15-7.53V49.338c0-.942.609-1.8 1.522-1.883l.146-.006h26.664zm172.423 19.679a8.905 8.905 0 110 17.81 8.905 8.905 0 010-17.81zm48.927-12.398a3.72 3.72 0 013.715 3.522l.005.198v21.63a3.72 3.72 0 01-3.522 3.715l-.198.005h-3.818v-2h3.818c.9 0 1.639-.691 1.714-1.572l.006-.148V68.84h-5v-5.699h5V58.45c0-.9-.69-1.639-1.571-1.714l-.149-.006h-37.303c-.9 0-1.638.69-1.713 1.571l-.007.149v4.728h-2V58.45a3.72 3.72 0 013.523-3.715l.197-.005h37.303zm-241.54 9.649v1l-3.351-.001v2.834h3.35v1h-4.35V64.38h4.35zm-.519-6.025v1h-2.832v2.834h2.832v1h-3.832v-4.834h3.832z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M51.196 76.402v3.56l3.562.002V82.1h-3.562v3.562H49.06V82.1h-3.562v-2.137l3.561-.001.001-3.561h2.137zm196-5v3.56l3.562.002V77.1h-3.562v3.562h-2.137V77.1h-3.562v-2.137l3.561-.001.001-3.561h2.137z"
    }))));
};
var ProfileIcon$1 = themeComponent(ProfileIcon, "Icons", fallbackValues$b, "info");
var GenericCardLarge = function GenericCardLarge() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "36",
        height: "24",
        viewBox: "0 0 36 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Credit card"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "36",
        height: "24",
        rx: "2",
        fill: "#15749D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 17.3333C4.44772 17.3333 4 17.781 4 18.3333C4 18.8856 4.44772 19.3333 5 19.3333H10C10.5523 19.3333 11 18.8856 11 18.3333C11 17.781 10.5523 17.3333 10 17.3333H5ZM14 17.3333C13.4477 17.3333 13 17.781 13 18.3333C13 18.8856 13.4477 19.3333 14 19.3333H23C23.5523 19.3333 24 18.8856 24 18.3333C24 17.781 23.5523 17.3333 23 17.3333H14Z",
        fill: "#E4F4FD"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.0357 7V9.04167H24V8C24 7.44771 24.4477 7 25 7H26.0357ZM26.2857 7V9.04167H28.7142V7H28.9642V9.04167H30.9997V9.29167H28.9642V11.0417L30.9997 11.0417L30.9997 11.2917L28.9642 11.2917V13L29.9999 13C30.5522 13 30.9999 12.5523 30.9999 12V8C30.9999 7.44772 30.5522 7 29.9999 7H26.2857ZM28.7142 13V11.2917L26.2857 11.2917V13L28.7142 13ZM26.0357 13V11.2917L24 11.2917V12C24 12.5523 24.4477 13 25 13L26.0357 13ZM24 11.0417L26.0357 11.0417V9.29167H24V11.0417ZM26.2857 11.0417V9.29167H28.7142V11.0417L26.2857 11.0417Z",
        fill: "#F4C932"
    }));
};
var EmptyCartIcon = function EmptyCartIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "440px",
        height: "214px",
        viewBox: "0 0 440 214",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, "Cart-Empty-Illustration"), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "cart-Cart-Empty-Illustration",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M217.6664,189.8762 C246.6414,189.8762 270.1304,195.0922 270.1304,201.5262 C270.1304,207.9602 246.6414,213.1762 217.6664,213.1762 C188.6924,213.1762 165.2024,207.9602 165.2024,201.5262 C165.2024,195.0922 188.6924,189.8762 217.6664,189.8762 Z M422.490595,40 C424.699734,40 426.490595,41.790861 426.490595,44 C426.490595,44.1594939 426.481056,44.318845 426.462028,44.4771999 L420.814597,91.4771999 C420.573067,93.4873075 418.867731,95 416.843164,95 L361.156836,95 C359.132269,95 357.426933,93.4873075 357.185403,91.4771999 L351.537972,44.4771999 C351.274422,42.283838 352.838843,40.2921172 355.032205,40.028567 C355.19056,40.0095394 355.349911,40 355.509405,40 L422.490595,40 Z M325.7753,2.768 L326.005703,2.77214523 C329.369977,2.8933916 332.0603,5.65915556 332.0603,9.054 L332.0603,9.054 L332.0603,22.883 L103.2593,22.883 L103.2593,9.054 L103.263445,8.82353181 C103.384692,5.45832296 106.150456,2.768 109.5453,2.768 L109.5453,2.768 L325.7753,2.768 Z",
        id: "cart----Theme-Color-Light",
        fill: themeValues.subIconColor,
        fillRule: "nonzero",
        opacity: "0.1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M210.6793,175.3431 C212.69715,175.3431 214.34488,176.927772 214.445893,178.920519 L214.4508,179.1146 L214.4508,201.4796 C214.4508,203.49745 212.866128,205.14518 210.873381,205.246193 L210.6793,205.2511 L196.4113,205.2511 C194.328358,205.2511 192.6398,203.562542 192.6398,201.4796 C192.6398,199.46175 194.224472,197.81402 196.217219,197.713007 L196.4113,197.7081 L206.9074,197.7079 L206.9078,179.1146 C206.9078,177.09675 208.492472,175.44902 210.485219,175.348007 L210.6793,175.3431 Z M224.6539,174.6414 C226.67175,174.6414 228.31948,176.226072 228.420493,178.218819 L228.4254,178.4129 L228.4244,197.7079 L238.9219,197.7084 C240.93975,197.7084 242.58748,199.293072 242.688493,201.285819 L242.6934,201.4799 C242.6934,203.49775 241.108728,205.14548 239.115981,205.246493 L238.9219,205.2514 L224.6539,205.2514 C222.63605,205.2514 220.98832,203.666728 220.887307,201.673981 L220.8824,201.4799 L220.8824,178.4129 C220.8824,176.329958 222.570958,174.6414 224.6539,174.6414 Z M102.36805,122.940779 C99.362801,125.550594 95.2124082,129.154872 89.9168719,133.753615 L132.215161,143.70593 C134.302233,140.853132 137.670278,139 141.472103,139 C143.681242,139 145.472103,140.790861 145.472103,143 C145.472103,145.142195 143.788135,146.891079 141.671744,146.995105 L141.472103,147 C139.557921,147 138,148.563635 138,150.499507 C138,152.371734 139.455725,153.895338 141.281911,153.994832 L141.472103,154 L148,154 C150.209139,154 152,155.790861 152,158 C152,160.142195 150.316032,161.891079 148.19964,161.995105 L148,162 L141.472103,162 C135.439524,162 130.499461,157.334313 130.035595,151.412031 L81.0838427,139.893669 C79.1350301,139.435125 77.8574872,137.623546 78.0116734,135.687366 L78.0136174,135.664052 C77.917747,134.505273 78.3266228,133.319554 79.2154318,132.459235 L79.3772574,132.310864 L101.637257,112.979864 C103.305233,111.531363 103.872948,121.633898 102.36805,122.940779 Z M405.5,102.5 C407.709139,102.5 409.5,104.290861 409.5,106.5 C409.5,108.642195 407.816032,110.391079 405.69964,110.495105 L405.5,110.5 L391.813099,110.5 L360.050681,144.519841 C358.68743,145.979937 356.46635,146.203668 354.844272,145.074853 L354.672836,144.948727 C344.86609,137.329456 337.511029,131.615002 332.607656,127.805367 C331.587065,127.012427 332.543378,117.776418 334.277177,118.979195 L334.454117,119.109171 L356.696,136.39 L380.868099,110.5 L372.5,110.5 C370.290861,110.5 368.5,108.709139 368.5,106.5 C368.5,104.357805 370.183968,102.608921 372.30036,102.504895 L372.5,102.5 L405.5,102.5 Z M422.490595,40 C424.699734,40 426.490595,41.790861 426.490595,44 C426.490595,44.1594939 426.481056,44.318845 426.462028,44.4771999 L420.814597,91.4771999 C420.573067,93.4873075 418.867731,95 416.843164,95 L361.156836,95 C359.132269,95 357.426933,93.4873075 357.185403,91.4771999 L351.537972,44.4771999 C351.274422,42.283838 352.838843,40.2921172 355.032205,40.028567 C355.19056,40.0095394 355.349911,40 355.509405,40 L422.490595,40 Z M362.361008,84.275 L362.93,89 L367.086008,89 L362.361008,84.275 Z M378.999008,80.914 L370.913008,89 L387.085008,89 L378.999008,80.914 Z M398.999008,80.914 L390.913008,89 L407.085008,89 L398.999008,80.914 Z M415.635008,84.278 L410.913008,89 L415.069,89 L415.635008,84.278 Z M409.000008,70.914 L400.414008,79.499 L409.000008,88.085 L416.021008,81.064 L416.357008,78.271 L409.000008,70.914 Z M378.999008,60.914 L370.414008,69.499 L379.000008,78.085 L384.660325,72.4254616 C385.050849,72.0349373 385.684014,72.0349373 386.074538,72.4254616 C386.435022,72.7859455 386.462752,73.3531766 386.157727,73.7454678 L386.074538,73.8396751 L380.414008,79.499 L389.000008,88.085 L397.585008,79.5 L378.999008,60.914 Z M368.999008,70.914 L361.640008,78.273 L361.975008,81.06 L369.000008,88.085 L377.585008,79.5 L368.999008,70.914 Z M389.000008,50.914 L380.414008,59.499 L399.000008,78.085 L407.586008,69.5 L398.968008,60.882 L396.288221,63.5758479 C395.898655,63.9673274 395.265492,63.968878 394.874012,63.5793112 C394.482533,63.1897445 394.480982,62.5565814 394.870549,62.1651019 L397.554008,59.468 L389.000008,50.914 Z M369.000008,50.914 L359.495008,60.418 L361.337008,75.747 L367.585008,69.499 L364.834153,66.7483665 L364.750964,66.6541592 C364.445939,66.261868 364.473669,65.6946369 364.834153,65.334153 C365.194637,64.973669 365.761868,64.9459395 366.154159,65.2509644 L366.248367,65.334153 L368.999008,68.085 L377.585008,59.499 L369.000008,50.914 Z M408.944008,50.858 L400.379008,59.465 L409.000008,68.086 L411.263596,65.8221901 C411.654121,65.4316658 412.287286,65.4316658 412.67781,65.8221901 C413.038294,66.1826741 413.066023,66.7499051 412.760999,67.1421963 L412.67781,67.2364037 L410.414008,69.5 L416.660008,75.746 L418.502008,60.416 L408.944008,50.858 Z M385.084008,46 L372.915008,46 L373.414214,46.5 L370.414008,49.5 L378.999008,58.085 L387.585008,49.499 L384.585786,46.5 L385.084008,46 Z M405.084008,46 L392.915008,46 L393.414214,46.5 L390.414008,49.5 L398.964008,58.05 L407.529008,49.443 L404.585786,46.5 L405.084008,46 Z M365.084008,46 L357.764,46 L359.192008,57.893 L367.585008,49.499 L364.585786,46.5 L365.084008,46 Z M420.235,46 L413.367432,46.000554 C413.367295,46.2554755 413.270289,46.5103988 413.076268,46.705373 L410.354008,49.44 L418.805008,57.891 L420.235,46 Z M371.084008,46 L366.914008,46 L368.999008,48.085 L371.084008,46 Z M391.084008,46 L386.914008,46 L388.999008,48.085 L391.084008,46 Z M410.956008,46 L406.914008,46 L408.940008,48.026 L410.956008,46 Z",
        id: "cart----Theme-Color-Dark",
        fill: themeValues.subIconColor,
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M323.380341,0 C329.691966,0 334.839426,4.99682545 334.996316,11.2352504 L335,11.5285717 L334.999983,160.827 L353.061045,160.540795 C354.796658,160.513261 356.22597,161.897933 356.253505,163.633545 C356.280089,165.309309 354.990183,166.699533 353.339006,166.818201 L353.160755,166.826005 L334.999983,167.114 L335,167.471428 C335,173.747737 329.949641,178.841121 323.675331,178.996355 L323.380341,179 L111.61868,179 C105.307163,179 100.160547,174.003277 100.003684,167.764754 L100,167.471428 L99.9999833,166.844 L67.3629661,167.140271 C65.6272063,167.155992 64.2073503,165.761626 64.1914973,164.025866 C64.1764497,162.34996 65.4757876,160.968547 67.1277342,160.861119 L67.3060339,160.854529 L99.9999833,160.558 L100,144.445958 L106,145.445958 L106,167.471428 C106,170.445465 108.390203,172.88149 111.397554,172.995805 L111.61868,173 L323.380341,173 C326.417039,173 328.880188,170.634496 328.995759,167.688034 L329,167.471428 L329,25.082 L106,25.082 L106,137.623848 L100,136.623848 L100,11.5285717 C100,5.2521597 105.049516,0.158876258 111.323695,0.00364538552 L111.61868,0 L323.380341,0 Z M397.839831,160.540614 C399.575544,160.520362 400.999034,161.911018 401.019504,163.646731 C401.038839,165.322592 399.743111,166.707391 398.091451,166.81913 L397.913169,166.826186 L371.001169,167.140186 C369.265456,167.160438 367.841966,165.769782 367.821496,164.034069 C367.802161,162.358208 369.097889,160.973409 370.749549,160.86167 L370.927831,160.854614 L397.839831,160.540614 Z M49.618935,160.541226 C51.3543096,160.501426 52.7933733,161.87596 52.8331737,163.611335 C52.8716017,165.286869 51.5915534,166.686175 49.9412562,166.81651 L49.763065,166.825574 L36.072065,167.139574 C34.3366904,167.179374 32.8976267,165.80484 32.8578263,164.069465 C32.8193983,162.393931 34.0994466,160.994625 35.7497438,160.86429 L35.927935,160.855226 L49.618935,160.541226 Z M235.6568,99.6108 C237.04552,99.6108 238.1713,100.73658 238.1713,102.1253 C238.1713,106.857111 234.405566,110.708459 229.707732,110.846944 L229.4458,110.8508 L205.6148,110.8508 C200.795797,110.8508 196.8893,106.944737 196.8893,102.1253 C196.8893,100.73658 198.01508,99.6108 199.4038,99.6108 C200.736971,99.6108 201.827817,100.648319 201.912951,101.959971 L201.9183,102.1253 C201.9183,104.101305 203.468072,105.714647 205.418468,105.816677 L205.6148,105.8218 L229.4458,105.8218 C231.421627,105.8218 233.035135,104.2722 233.137177,102.321649 L233.1423,102.1253 C233.1423,100.73658 234.26808,99.6108 235.6568,99.6108 Z M194.231,60.5965 C198.416987,60.5965 202.08429,63.3127378 203.512549,67.2902012 C203.98188,68.5972099 203.302807,70.0372177 201.995799,70.5065486 C200.74107,70.9571063 199.36377,70.3492958 198.84036,69.1435924 L198.779451,68.9897988 C198.052367,66.9649887 196.243869,65.6255 194.231,65.6255 C192.218156,65.6255 190.40998,66.9648896 189.683805,68.9890852 C189.214868,70.2962353 187.775065,70.9757415 186.467915,70.5068047 C185.160765,70.037868 184.481258,68.598065 184.950195,67.2909148 C186.377205,63.3131587 190.044694,60.5965 194.231,60.5965 Z M242.174978,60.611 C246.752761,60.611 250.841163,63.228796 252.48308,67.1808345 C253.012812,68.4558831 252.408614,69.9189471 251.133565,70.4486796 C249.911644,70.9563399 248.517048,70.4225952 247.936717,69.255019 L247.86572,69.0991655 C247.013741,67.0484782 244.768727,65.611 242.174978,65.611 C239.670355,65.611 237.490237,66.9513467 236.576132,68.8892772 L236.48308,69.0991655 C235.953347,70.374214 234.490283,70.9784121 233.215235,70.4486796 C231.940186,69.9189471 231.335988,68.4558831 231.86572,67.1808345 C233.507581,63.2289312 237.597045,60.611 242.174978,60.611 Z M392,25 C393.104569,25 394,25.8954305 394,27 L394,40 L428,40 C429.656854,40 431,41.3431458 431,43 L431,47 C431,48.6568542 429.656854,50 428,50 L350,50 C348.343146,50 347,48.6568542 347,47 L347,43 C347,41.3431458 348.343146,40 350,40 L384,40 L384,27 C384,25.8954305 384.895431,25 386,25 L392,25 Z M323.380341,6 L111.61868,6 C108.582279,6 106.11978,8.36521389 106.00424,11.3119453 L106,11.5285717 L106,21.311 L329,21.311 L329,11.5285717 C329,8.55483183 326.609153,6.11852455 323.601489,6.00419571 L323.380341,6 Z M122.1173,10.311 L122.282437,10.316345 C123.538064,10.397879 124.544275,11.402497 124.625946,12.660527 L124.6313,12.826 L124.625946,12.9912424 C124.544275,14.2475768 123.538064,15.252124 122.282437,15.3336552 L122.1173,15.339 L121.951938,15.3336552 C120.640022,15.2485792 119.6023,14.15848 119.6023,12.826 C119.6023,11.436 120.7283,10.311 122.1173,10.311 Z M113.3163,10.311 L113.481547,10.316345 C114.737952,10.397879 115.743349,11.402497 115.82495,12.660527 L115.8303,12.826 L115.82495,12.9912424 C115.743349,14.2475768 114.737952,15.252124 113.481547,15.3336552 L113.3163,15.339 L113.151053,15.3336552 C111.840022,15.2485792 110.8023,14.15848 110.8023,12.826 C110.8023,11.436 111.9283,10.311 113.3163,10.311 Z M130.9173,10.311 L131.082437,10.316345 C132.338064,10.397879 133.344275,11.402497 133.425946,12.660527 L133.4313,12.826 L133.425946,12.9912424 C133.344275,14.2475768 132.338064,15.252124 131.082437,15.3336552 L130.9173,15.339 L130.751942,15.3336552 C129.4401,15.2485792 128.4033,14.15848 128.4033,12.826 C128.4033,11.436 129.5283,10.311 130.9173,10.311 Z",
        id: "cart-Dark-Grey",
        fill: "#3B414D",
        fillRule: "nonzero"
    })));
};
var EmptyCartIcon$1 = themeComponent(EmptyCartIcon, "Icons", fallbackValues$b, "info");
var _excluded$r = [
    "themeValues",
    "color",
    "height"
];
var EmptyCartIconV2 = function EmptyCartIconV2(_ref) {
    var themeValues = _ref.themeValues, color = _ref.color, _ref$height = _ref.height, height = _ref$height === void 0 ? "auto" : _ref$height, rest = _objectWithoutProperties(_ref, _excluded$r);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: "126",
        height: "113",
        viewBox: "0 0 126 113",
        style: {
            height: height,
            width: "auto"
        }
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, "Cart-Empty-Illustration"), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Empty Shopping Cart Icon"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "Empty-shopping-cart",
        d: "M115.523 66.3438C115.086 67.6562 114.43 68.75 113.555 69.4062C112.68 70.2812 111.586 70.5 110.492 70.5H46.3984L47.7109 77.5H106.555C108.086 77.5 109.398 78.1562 110.492 79.4688C111.367 80.7812 111.805 82.3125 111.586 83.8438L110.273 89.3125C112.461 90.4062 113.992 91.9375 115.305 93.9062C116.617 95.875 117.273 98.0625 117.273 100.25C117.273 103.75 115.961 106.594 113.555 109C111.148 111.406 108.305 112.5 105.023 112.5C101.523 112.5 98.6797 111.406 96.2734 109C93.8672 106.594 92.7734 103.75 92.7734 100.25C92.7734 96.75 93.8672 93.9062 96.4922 91.5H50.5547C52.9609 93.9062 54.2734 96.75 54.2734 100.25C54.2734 103.75 52.9609 106.594 50.5547 109C48.1484 111.406 45.3047 112.5 42.0234 112.5C38.5234 112.5 35.6797 111.406 33.2734 109C30.8672 106.594 29.7734 103.75 29.7734 100.25C29.7734 98.0625 30.2109 96.0938 31.3047 94.125C32.3984 92.375 33.9297 90.8438 35.8984 89.5312L20.5859 14.5H5.27344C3.74219 14.5 2.42969 14.0625 1.55469 12.9688C0.460938 12.0938 0.0234375 10.7812 0.0234375 9.25V5.75C0.0234375 4.4375 0.460938 3.125 1.55469 2.03125C2.42969 1.15625 3.74219 0.5 5.27344 0.5H27.8047C28.8984 0.5 29.9922 0.9375 30.8672 1.8125C31.7422 2.6875 32.3984 3.5625 32.8359 4.65625L34.8047 14.5H120.773C122.523 14.5 123.836 15.1562 124.93 16.4688C125.805 17.7812 126.242 19.3125 125.805 20.8438L115.523 66.3438Z",
        fill: color !== null && color !== void 0 ? color : themeValues.subIconColor
    })));
};
var EmptyCartIconV2$1 = themeComponent(EmptyCartIconV2, "Icons", fallbackValues$b, "info");
var ShoppingCartIcon = function ShoppingCartIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32px",
        height: "32px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, "Icon - Cart-Empty"), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("filter", {
        id: "cart-badge-filter-1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        "in": "SourceGraphic",
        type: "matrix",
        values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "cart-badge-Icon---Cart-Empty",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        filter: "url(#cart-badge-filter-1)",
        id: "cart-badge-Group"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(3.000000, 7.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M18.7499553,20.499994 C19.348912,20.499994 19.8632339,20.2851508 20.2929204,19.8554643 C20.7226068,19.4257779 20.9374501,18.911456 20.9374501,18.3124993 C20.9374501,17.8958334 20.8267735,17.5117199 20.6054196,17.1601583 C20.3840658,16.8085966 20.0780771,16.5416703 19.6874531,16.3593789 L19.6874531,16.3593789 L19.9218275,15.3828187 C19.9739105,15.0963613 19.9088069,14.835945 19.7265155,14.6015706 C19.544224,14.3671962 19.3098496,14.2500089 19.0233921,14.2500089 L19.0233921,14.2500089 L8.5156047,14.2500089 L8.28123026,13.0000119 L19.7265155,13.0000119 C19.9348481,13.0000119 20.1236501,12.9349077 20.2929204,12.8046999 C20.4621906,12.6744921 20.5728678,12.4922006 20.6249508,12.2578262 L20.6249508,12.2578262 L22.4608839,4.13284556 C22.5390088,3.84638811 22.4869258,3.58597187 22.3046343,3.35159742 C22.1223429,3.11722298 21.8749478,3.00004172 21.5624486,3.00004172 L21.5624486,3.00004172 L6.21092269,3.00004172 L5.85936103,1.24222745 C5.80727802,1.03389482 5.6966008,0.858113985 5.52733057,0.714884961 C5.35806034,0.571655937 5.16925831,0.500041723 4.96092567,0.500041723 L4.96092567,0.500041723 L0.937497765,0.500041723 C0.67708152,0.500041723 0.455728279,0.591187141 0.273436848,0.773478571 C0.0911454173,0.955770002 0,1.17712324 0,1.43753949 L0,1.43753949 L0,2.062538 C0,2.32295424 0.0911454173,2.54430748 0.273436848,2.72659891 C0.455728279,2.90889035 0.67708152,3.00004172 0.937497765,3.00004172 L0.937497765,3.00004172 L3.67186625,3.00004172 L6.40623473,16.3984413 C6.06769367,16.606774 5.80076742,16.8802108 5.60545539,17.2187519 C5.41014335,17.5572929 5.31248733,17.9218752 5.31248733,18.3124993 C5.31248733,18.911456 5.52733057,19.4257779 5.95701705,19.8554643 C6.38670352,20.2851508 6.90102541,20.499994 7.49998212,20.499994 C8.09893883,20.499994 8.61326071,20.2851508 9.04294719,19.8554643 C9.47263367,19.4257779 9.6874769,18.904946 9.6874769,18.2929681 C9.6874769,17.6809901 9.46612307,17.1666689 9.02341599,16.750003 L9.02341599,16.750003 L17.2265214,16.750003 C16.7838143,17.1666689 16.5624605,17.6809901 16.5624605,18.2929681 C16.5624605,18.904946 16.7773037,19.4257779 17.2069902,19.8554643 C17.6366767,20.2851508 18.1509986,20.499994 18.7499553,20.499994 Z",
        id: "cart-badge-shopping-cart",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    })))));
};
var TrashIcon = function TrashIcon(_ref) {
    var themeValues = _ref.themeValues, iconFill = _ref.iconFill;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15,7 L14,15.5714286 C14,16.3571429 13.25,17 12.3333333,17 L12.3333333,17 L7.66666667,17 C6.75,17 6,16.3571429 6,15.5714286 L6,15.5714286 L5,7 L15,7 Z M12.1428571,3 L13,4 L16,4 L16,6 L4,6 L4,4 L7,4 L7.85714286,3 L12.1428571,3 Z",
        id: "trash-path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "trash-Icons-/-Small-/-20px-S-/-Trash---Mobile---20px",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "trash-mask-2",
        fill: "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#trash-path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        id: "trash-Mask",
        fill: iconFill !== null && iconFill !== void 0 ? iconFill : themeValues.singleIconColor,
        fillRule: "nonzero",
        xlinkHref: "#trash-path-1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        id: "trash-Path",
        fill: iconFill !== null && iconFill !== void 0 ? iconFill : themeValues.singleIconColor,
        fillRule: "nonzero",
        mask: "url(#trash-mask-2)",
        points: "0 0 20 0 20 20 0 20"
    })));
};
var TrashIcon$1 = themeComponent(TrashIcon, "Icons", fallbackValues$b, "primary");
var CustomerSearchIcon = function CustomerSearchIcon(_ref) {
    var _ref$fillPrimary = _ref.fillPrimary, fillPrimary = _ref$fillPrimary === void 0 ? MATISSE_BLUE : _ref$fillPrimary, _ref$fillSecondary = _ref.fillSecondary, fillSecondary = _ref$fillSecondary === void 0 ? INFO_BLUE : _ref$fillSecondary;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "366",
        height: "208",
        viewBox: "0 0 366 208",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M295.309 0.0078125C298.479 0.168432 301 2.78979 301 6V157H321C322.105 157 323 157.895 323 159V161C323 162.105 322.105 163 321 163H301V170L300.992 170.309C300.837 173.377 298.377 175.837 295.309 175.992L295 176H75C71.7898 176 69.1684 173.479 69.0078 170.309L69 170V163H32C30.8954 163 30 162.105 30 161V159C30 157.895 30.8954 157 32 157H69V6C69 2.68629 71.6863 1.04692e-07 75 0H295L295.309 0.0078125ZM73 170C73 171.105 73.8954 172 75 172H295C296.105 172 297 171.105 297 170V25H73V170ZM18 157C19.1046 157 20 157.895 20 159V163H2C0.895431 163 3.22133e-08 162.105 0 161V159C0 157.895 0.895431 157 2 157H18ZM364 157C365.105 157 366 157.895 366 159V163H336C334.895 163 334 162.105 334 161V159C334 157.895 334.895 157 336 157H364ZM203 103.5C204.381 103.5 205.5 104.619 205.5 106V107C205.5 111.694 201.694 115.5 197 115.5H173C168.306 115.5 164.5 111.694 164.5 107V106C164.5 104.619 165.619 103.5 167 103.5C168.381 103.5 169.5 104.619 169.5 106V107C169.5 108.933 171.067 110.5 173 110.5H197C198.933 110.5 200.5 108.933 200.5 107V106C200.5 104.619 201.619 103.5 203 103.5ZM216 38C229.255 38 240 48.7452 240 62C240 67.8895 237.877 73.2819 234.356 77.458L243.938 87.0391C245.471 86.133 247.481 86.3392 248.799 87.6572L270.013 108.872L265.771 113.114C264.208 114.676 261.675 114.676 260.113 113.114L241.728 94.7285C240.41 93.4106 240.203 91.4011 241.109 89.8672L231.534 80.292C227.348 83.8509 221.925 86 216 86C202.745 86 192 75.2548 192 62C192 48.7452 202.745 38 216 38ZM216 43C205.507 43 197 51.5066 197 62C197 72.4934 205.507 81 216 81C226.493 81 235 72.4934 235 62C235 51.5066 226.493 43 216 43ZM154 57C158.266 57 162.087 59.6083 163.307 63.4795L163.416 63.8584L163.47 64.1084C163.67 65.3597 162.893 66.5837 161.642 66.916C160.391 67.2482 159.11 66.571 158.662 65.3857L158.584 65.1416L158.539 64.9863C158.033 63.3915 156.308 62 154 62C151.617 62 149.857 63.483 149.416 65.1416C149.062 66.476 147.693 67.2703 146.358 66.916C145.024 66.5616 144.23 65.1928 144.584 63.8584C145.667 59.7796 149.596 57 154 57ZM216 57C220.266 57 224.087 59.6083 225.307 63.4795L225.416 63.8584L225.47 64.1084C225.67 65.3597 224.893 66.5837 223.642 66.916C222.391 67.2482 221.11 66.571 220.662 65.3857L220.584 65.1416L220.539 64.9863C220.033 63.3915 218.308 62 216 62C213.617 62 211.857 63.483 211.416 65.1416C211.062 66.476 209.693 67.2703 208.358 66.916C207.024 66.5616 206.23 65.1928 206.584 63.8584C207.667 59.7796 211.596 57 216 57ZM75 4C73.8954 4 73 4.89543 73 6V21H297V6C297 4.89544 296.105 4 295 4H75ZM81.5 10C82.8807 10 84 11.1193 84 12.5C84 13.8807 82.8807 15 81.5 15C80.1193 15 79 13.8807 79 12.5C79 11.1193 80.1193 10 81.5 10ZM89.5 10C90.8807 10 92 11.1193 92 12.5C92 13.8807 90.8807 15 89.5 15C88.1193 15 87 13.8807 87 12.5C87 11.1193 88.1193 10 89.5 10ZM97.5 10C98.8807 10 100 11.1193 100 12.5C100 13.8807 98.8807 15 97.5 15C96.1193 15 95 13.8807 95 12.5C95 11.1193 96.1193 10 97.5 10Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M295 4C296.105 4 297 4.89543 297 6V21H73V6C73 4.89543 73.8954 4 75 4H295ZM81.5 10C80.1193 10 79 11.1193 79 12.5C79 13.8807 80.1193 15 81.5 15C82.8807 15 84 13.8807 84 12.5C84 11.1193 82.8807 10 81.5 10ZM89.5 10C88.1193 10 87 11.1193 87 12.5C87 13.8807 88.1193 15 89.5 15C90.8807 15 92 13.8807 92 12.5C92 11.1193 90.8807 10 89.5 10ZM97.5 10C96.1193 10 95 11.1193 95 12.5C95 13.8807 96.1193 15 97.5 15C98.8807 15 100 13.8807 100 12.5C100 11.1193 98.8807 10 97.5 10Z",
        fill: "#E5E7EC"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M185 186C213.719 186 237 190.925 237 197C237 203.075 213.719 208 185 208C156.281 208 133 203.075 133 197C133 190.925 156.281 186 185 186ZM98 44C98.5523 44 99 44.4477 99 45V99C99 99.5523 98.5523 100 98 100H44C43.4477 100 43 99.5523 43 99V45C43 44.4477 43.4477 44 44 44H98Z",
        fill: fillSecondary
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M182 196C182 198.209 180.209 200 178 200H164C161.791 200 160 198.209 160 196C160 193.791 161.791 192 164 192H174V176H182V196ZM196 192H206C208.209 192 210 193.791 210 196C210 198.209 208.209 200 206 200H192C189.791 200 188 198.209 188 196V176H196V192ZM69 138L61 142L94.498 149.882C95.8084 145.886 99.5663 143 104 143H105.5C107.433 143 109 144.567 109 146.5C109 148.433 107.433 150 105.5 150H105C102.791 150 101 151.791 101 154C101 156.209 102.791 158 105 158H112.5C114.433 158 116 159.567 116 161.5C116 163.433 114.433 165 112.5 165H104C99.4699 165 95.6443 161.987 94.415 157.856L47.6064 146.367C44.9349 145.711 44.482 142.105 46.9082 140.808L69 129V138ZM265 98C268.402 98 273.248 100.17 274.622 106.354L312.642 114.672C315.957 115.397 316.92 119.662 314.237 121.741L301 132V122L304 120L274.217 114.235C272.08 119.337 266.221 120 265 120H257C254.5 120 253 118.5 253 116.5C253 114.5 254.5 113 257 113H264C266 113 268 111.5 268 109C268 106.5 267 106 266 105C265.2 104.2 262.333 101.193 261 99.8594C261 99.1927 261.8 98 265 98ZM98 40C100.761 40 103 42.2386 103 45V99C103 101.675 100.899 103.859 98.2568 103.993L98 104H44C41.3247 104 39.1405 101.899 39.0068 99.2568L39 99V45C39 42.2386 41.2386 40 44 40H98ZM44 44C43.4477 44 43 44.4477 43 45V99C43 99.5523 43.4477 100 44 100H98C98.5523 100 99 99.5523 99 99V45C99 44.4477 98.5523 44 98 44H44ZM65 72C69.0776 72 72.6772 74.036 74.8457 77.1445C74.8565 77.16 74.8682 77.1749 74.8789 77.1904C74.9594 77.3069 75.0369 77.4255 75.1133 77.5449C75.1316 77.5735 75.1499 77.6021 75.168 77.6309C75.2451 77.7537 75.3198 77.8781 75.3926 78.0039C75.4103 78.0344 75.4279 78.065 75.4453 78.0957C75.5123 78.214 75.5776 78.3333 75.6406 78.4541C75.6633 78.4974 75.6849 78.5413 75.707 78.585C75.7666 78.7025 75.8251 78.8207 75.8809 78.9404C75.8997 78.9808 75.9171 79.0219 75.9355 79.0625C75.99 79.1828 76.0442 79.3034 76.0947 79.4258C76.1189 79.4842 76.1408 79.5436 76.1641 79.6025C76.2066 79.7105 76.2496 79.8183 76.2891 79.9277C76.3044 79.9701 76.3182 80.0131 76.333 80.0557C76.4679 80.4432 76.5826 80.8396 76.6777 81.2441C76.6987 81.3331 76.7203 81.422 76.7393 81.5117C76.9086 82.3146 77 83.1467 77 84V86C77 87.1046 76.1046 88 75 88H55C53.8954 88 53 87.1046 53 86V84C53 77.3726 58.3726 72 65 72ZM80.5 70C85.1944 70 89 73.8056 89 78.5V80.2861C88.9998 81.2326 88.2326 81.9998 87.2861 82H78.8574C78.3506 78.4569 76.5178 75.3417 73.877 73.1738C75.435 71.2389 77.8224 70 80.5 70ZM65 56C68.866 56 72 59.134 72 63C72 66.866 68.866 70 65 70C61.134 70 58 66.866 58 63C58 59.134 61.134 56 65 56ZM80.5 57C83.5376 57 86 59.4624 86 62.5C86 65.5376 83.5376 68 80.5 68C77.4624 68 75 65.5376 75 62.5C75 59.4624 77.4624 57 80.5 57Z",
        fill: fillPrimary
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M235 62C235 72.4934 226.493 81 216 81C205.507 81 197 72.4934 197 62C197 51.5066 205.507 43 216 43C226.493 43 235 51.5066 235 62Z",
        fill: "#E4F4FD",
        fillOpacity: "0.75"
    }));
};
var PaymentSearchIcon = function PaymentSearchIcon(_ref) {
    var _ref$fillPrimary = _ref.fillPrimary, fillPrimary = _ref$fillPrimary === void 0 ? SEA_GREEN : _ref$fillPrimary, _ref$fillSecondary = _ref.fillSecondary, fillSecondary = _ref$fillSecondary === void 0 ? HINT_GREEN : _ref$fillSecondary;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "366",
        height: "209",
        viewBox: "0 0 366 209"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-537 -466)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(132 332)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(405 134)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M73 25h224v144.75a2.25 2.25 0 01-2.25 2.25H75.25a2.25 2.25 0 01-2.25-2.25V25z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#292A33",
        fillRule: "nonzero",
        d: "M294.625 0A6.376 6.376 0 01301 6.377V157h19a3 3 0 01.176 5.995L320 163h-19v6.623a6.376 6.376 0 01-6.375 6.377H75.374A6.375 6.375 0 0169 169.623V163H33a3 3 0 01-.176-5.995L33 157h36V6.377A6.375 6.375 0 0175.374 0h219.251zM297 25H73v144.623c0 1.259.976 2.288 2.211 2.372l.163.005h219.251a2.376 2.376 0 002.37-2.214l.005-.163V25zm39.953 132l26.112.082a2.952 2.952 0 012.935 2.969 2.953 2.953 0 01-2.78 2.945l-.173.004-26.112-.082a2.952 2.952 0 01-2.935-2.969 2.953 2.953 0 012.78-2.945l.173-.004zM17 157a3 3 0 01.176 5.995L17 163H3a3 3 0 01-.176-5.995L3 157h14zm186-52.514a2.515 2.515 0 012.514 2.514c0 4.633-3.761 8.376-8.422 8.51l-.26.004h-23.664c-4.78 0-8.683-3.795-8.683-8.514a2.515 2.515 0 015.024-.165l.006.165c0 1.848 1.517 3.383 3.457 3.48l.196.005h23.664c1.968 0 3.549-1.475 3.648-3.301l.006-.184a2.515 2.515 0 012.514-2.514zM216 39c13.255 0 24 10.745 24 24 0 5.67-1.967 10.881-5.255 14.988l.012.01.13.114 8.51 8.049a5.002 5.002 0 015.193.818l.18.162 17.668 16.728a5 5 0 01-6.696 7.424l-.18-.162-17.667-16.728a5.001 5.001 0 01-1.26-5.348l-8.496-8.037a2.025 2.025 0 01-.132-.137A23.909 23.909 0 01216 87c-13.255 0-24-10.745-24-24C192 49.746 202.745 39 216 39zm0 5c-10.493 0-19 8.507-19 19s8.507 19 19 19 19-8.507 19-19-8.507-19-19-19zm-66 13.986c4.212 0 7.914 2.692 9.362 6.65a2.514 2.514 0 01-4.662 1.88l-.062-.153c-.734-2.009-2.576-3.349-4.639-3.349-1.988 0-3.772 1.246-4.554 3.136l-.083.213a2.515 2.515 0 01-4.724-1.726c1.446-3.958 5.148-6.651 9.361-6.651zM294.624 4H75.374a2.375 2.375 0 00-2.369 2.214L73 6.377V21h224V6.377a2.376 2.376 0 00-2.212-2.372L294.625 4zM81.5 10a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm8 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm8 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#E4E6EB",
        d: "M294.75 4A2.25 2.25 0 01297 6.25V21H73V6.25A2.25 2.25 0 0175.25 4zM81.5 10a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm8 0a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm8 0a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#E4F4FD",
        d: "M216 44c10.493 0 19 8.507 19 19s-8.507 19-19 19-19-8.507-19-19 8.507-19 19-19zm0 14c-4.206 0-7.903 2.689-9.348 6.641a2.5 2.5 0 004.696 1.718l.083-.214c.786-1.896 2.575-3.145 4.57-3.145 2.068 0 3.914 1.343 4.651 3.359l.061.152a2.5 2.5 0 004.635-1.87C223.903 60.69 220.207 58 216.001 58z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#959CA8",
        fillRule: "nonzero",
        d: "M216 58c4.207 0 7.903 2.689 9.348 6.641a2.5 2.5 0 01-4.635 1.87l-.061-.152c-.737-2.016-2.583-3.359-4.651-3.359-1.995 0-3.784 1.25-4.57 3.145l-.083.214a2.5 2.5 0 01-4.696-1.718c1.445-3.952 5.142-6.641 9.349-6.641z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: fillSecondary,
        d: "M185 185c28.719 0 52 5.373 52 12s-23.281 12-52 12c-28.718 0-52-5.373-52-12s23.282-12 52-12zM97 44a2 2 0 012 2v52a2 2 0 01-2 2H45a2 2 0 01-2-2V46a2 2 0 012-2h52zM74.134 56h-5.268c-.441 0-.806.304-.86.696l-.006.1v2.456c-4.391.845-7.029 3.74-7.144 7.532l-.004.26v.072c0 5.135 4.208 6.644 9.66 7.865 3.408.801 4.302 1.333 4.351 2.348l.002.093v.073c0 1.077-1.025 1.723-2.963 1.723-2.717 0-5.28-.875-7.66-2.542a.896.896 0 00-1.112.082l-.078.081-2.845 3.336a.84.84 0 00.11 1.21c2.061 1.596 4.522 2.668 7.182 3.207l.5.095.001 2.581c0 .37.3.677.688.725l.108.007h5.407c.403 0 .737-.275.79-.632l.007-.1v-2.602c4.212-.902 6.88-3.587 6.996-7.58l.004-.273v-.072c0-4.705-3.659-6.572-9.513-7.83-3.483-.767-4.411-1.263-4.462-2.344l-.002-.097v-.072c0-.934.842-1.616 2.562-1.616 2.041 0 4.32.669 6.462 2.007a.9.9 0 001.13-.126l.073-.089 2.566-3.556a.841.841 0 00-.185-1.18 14.999 14.999 0 00-5.178-2.318l-.451-.103-.002-2.62c0-.44-.388-.797-.866-.797z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: fillPrimary,
        fillRule: "nonzero",
        d: "M182 176v20a4 4 0 01-3.8 3.995l-.2.005h-14a4 4 0 01-.2-7.995l.2-.005h10v-16h8zm14 0v16h10a4 4 0 013.995 3.8l.005.2a4 4 0 01-3.8 3.995l-.2.005h-14a4 4 0 01-3.995-3.8L188 196v-20h8zM69 128.5v9l-7.875 4.429 32.876 6.953c1.81-4.055 5.877-6.882 10.604-6.882a4 4 0 01.2 7.995l-.2.005a3.605 3.605 0 00-3.605 3.593v.035-.023a3.606 3.606 0 003.414 3.601l.191.005h6.644a4 4 0 01.2 7.995l-.2.005h-6.644c-5.246 0-9.679-3.48-11.115-8.259l-44.708-9.457c-3.58-.757-4.322-5.493-1.242-7.336l.175-.1L69 128.5zM263.644 96c6.184 0 11.24 4.838 11.586 10.936l38.713 7.13c3.304.609 4.407 4.749 1.927 6.93l-.15.125L301 133v-10.5l2.891-2.151-31.014-5.712a11.586 11.586 0 01-8.881 4.569l-.352.005H257l-.2-.005a4 4 0 010-7.99l.2-.005h6.644l.191-.005a3.606 3.606 0 003.414-3.601c0-1.99-.358-3.259-2.403-5.238a361.04 361.04 0 00-4.65-4.395A3.998 3.998 0 01263.644 96zM97 40a6 6 0 016 6v52a6 6 0 01-6 6H45a6 6 0 01-6-6V46a6 6 0 016-6h52zm0 4H45a2 2 0 00-1.995 1.85L43 46v52a2 2 0 001.85 1.995L45 100h52a2 2 0 001.995-1.85L99 98V46a2 2 0 00-1.85-1.995L97 44zM74.134 56c.478 0 .866.356.866.796l.002 2.621c2.128.452 3.983 1.265 5.629 2.42.383.27.457.804.185 1.181l-2.566 3.556c-.275.382-.801.466-1.203.215-2.142-1.338-4.42-2.007-6.462-2.007-1.72 0-2.562.682-2.562 1.616v.072c0 1.15.879 1.652 4.464 2.442C78.341 70.169 82 72.036 82 76.742v.07c0 4.144-2.692 6.932-7 7.854v2.602c0 .404-.357.732-.797.732h-5.407c-.44 0-.796-.328-.796-.732v-2.581c-2.852-.502-5.493-1.606-7.684-3.302a.84.84 0 01-.11-1.21l2.846-3.336a.898.898 0 011.19-.163c2.38 1.667 4.943 2.542 7.66 2.542 1.938 0 2.963-.646 2.963-1.723v-.073c0-1.076-.841-1.615-4.353-2.44-5.452-1.222-9.66-2.73-9.66-7.866v-.072c0-3.92 2.657-6.928 7.148-7.792v-2.456c0-.44.388-.796.866-.796h5.268z"
    }))))));
};
var ResetPasswordIcon = function ResetPasswordIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "86",
        height: "80",
        viewBox: "0 0 86 80"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-677 -192)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(432 168)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(245 24)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M36 2.44311523L50.2941895 1.66943359 67 7.32739258 78 18.2668457 85 35.1682129 83 53.0935059 75.1977539 66.3569336 62.1745605 75.9748535 46 80 36 78z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#E5E7EC",
        d: "M46 6h17.5l11.749 10H46a1 1 0 01-1-1V7a1 1 0 011-1zm27 62L58.5 78H46a1 1 0 01-1-1v-8a1 1 0 011-1h27zm10-16l-4.506 10H46a1 1 0 01-1-1v-8a1 1 0 011-1h37zm2-16l-.382 10H46a1 1 0 01-1-1v-8a1 1 0 011-1h39zm-7-16l4 10H46a1 1 0 01-1-1v-8a1 1 0 011-1h32z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#15749D",
        d: "M45.09 0c22.091 0 40 17.909 40 40s-17.909 40-40 40C28.569 80 14.387 69.984 8.286 55.693H5a5 5 0 01-5-5V33.345a5 5 0 015-5h1.814C11.804 11.939 27.052 0 45.09 0zm33.573 55.693l-42.202-.001v20.326c2.78.667 5.682 1.02 8.667 1.02 14.84 0 27.639-8.735 33.535-21.345zm-45.24-.001l-21.83.001c4.271 9.134 12.164 16.235 21.83 19.456V55.692zm-23.41-27.345l23.41-.001V4.928C22.4 8.601 13.683 17.321 10.013 28.347zM45.128 3.038c-2.985 0-5.887.354-8.667 1.021v24.287h43.782C75.349 13.643 61.477 3.039 45.128 3.039z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(8 38)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "11",
        height: "7",
        x: "0",
        y: "2",
        fill: "#FFF",
        rx: "1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#FFF",
        strokeWidth: "2",
        d: "M5.5-1l.205.008c.609.05 1.156.317 1.563.724C7.72.185 8 .81 8 1.5h0V3H3V1.5c0-.69.28-1.315.732-1.768A2.492 2.492 0 015.5-1h0z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M41.5 38a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm11 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm11 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm11 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm-44 0a3.5 3.5 0 110 7 3.5 3.5 0 010-7z"
    }))))));
};
var PeriscopeFailedIcon = function PeriscopeFailedIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "632",
        height: "345",
        viewBox: "0 0 632 345"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "periscope-failed-path-1",
        d: "M298.876 295.918v28.33a4.498 4.498 0 01-4.159 4.488l-.335.012h-17.978a4.498 4.498 0 01-4.494-4.5 4.498 4.498 0 014.16-4.489l.334-.012 13.484.002v-23.831h8.988zm17.978 0v23.83h13.483c2.37 0 4.31 1.835 4.482 4.164l.012.336a4.498 4.498 0 01-4.159 4.488l-.335.012H312.36a4.497 4.497 0 01-4.483-4.164l-.012-.336v-28.33h8.989zm224.157-92.063a4.498 4.498 0 014.495 4.501 4.498 4.498 0 01-4.16 4.488l-.335.013h-16.67L488.01 250.85a4.49 4.49 0 01-5.106.984l-.34-.173-29.755-16.502v-11.252l31.117 18.199 27.97-29.25h-7.963a4.498 4.498 0 01-4.495-4.5 4.498 4.498 0 014.16-4.488l.335-.013h37.078zm-325.5-32.5a4.501 4.501 0 013.294 5.444 28.718 28.718 0 00-.828 6.85c0 5.071 1.337 10.012 3.92 14.631a4.504 4.504 0 01-1.724 6.126 4.491 4.491 0 01-6.117-1.727 41.106 41.106 0 01-2.574-5.511l-65.128 26.791 5.331 2.199v10.126l-18.653-8.327-.34-.165c-3.227-1.723-3.128-6.474.23-8.035l.2-.088 76.159-31.329a37.7 37.7 0 01.794-13.686 4.494 4.494 0 015.436-3.299zm335.545-38.385a4 4 0 014 4v55.01a4 4 0 01-4 4h-54.921a4 4 0 01-4-4v-55.01a4 4 0 014-4h54.921z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("filter", {
        id: "periscope-failed-filter-2",
        width: "111.3%",
        height: "124.5%",
        x: "-5.7%",
        y: "-12.3%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("feOffset", {
        "in": "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feGaussianBlur", {
        "in": "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: "8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        "in": "shadowBlurOuter1",
        values: "0 0 0 0 0.0823529412 0 0 0 0 0.454901961 0 0 0 0 0.615686275 0 0 0 0.5 0"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "periscope-failed-path-3",
        d: "M151.685 24.754V37.13l-24.838.186a2 2 0 00-1.985 2v2.766a2 2 0 002.015 1.985l24.808-.186v7.876h-91.01V26.95a2 2 0 011.995-2l89.015-.196zM113.693 37.33h-38.41a2 2 0 00-2 2v2.751a2 2 0 002 2h38.41a2 2 0 002-2v-2.75a2 2 0 00-2-2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("filter", {
        id: "periscope-failed-filter-4",
        width: "152.7%",
        height: "277.7%",
        x: "-26.4%",
        y: "-88.9%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("feOffset", {
        "in": "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feGaussianBlur", {
        "in": "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: "8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        "in": "shadowBlurOuter1",
        values: "0 0 0 0 0.161570617 0 0 0 0 0.163300979 0 0 0 0 0.199501812 0 0 0 0.3 0"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "periscope-failed-path-5",
        d: "M452.809 0l124.97.196a2 2 0 011.996 2v27.305a2 2 0 01-2 2h-.003l-124.963-.196V19.128h9.236a2 2 0 002-2v-2.751a2 2 0 00-2-2h-9.236V0zm55.047 12.377h-32.679a2 2 0 00-2 2v2.75a2 2 0 002 2h32.679a2 2 0 002-2v-2.75a2 2 0 00-2-2zm25.217 0h-12.047a2 2 0 00-2 2v2.75a2 2 0 002 2h12.047a2 2 0 002-2v-2.75a2 2 0 00-2-2zm32.094 0h-18.924a2 2 0 00-2 2v2.75a2 2 0 002 2h18.924a2 2 0 002-2v-2.75a2 2 0 00-2-2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("filter", {
        id: "periscope-failed-filter-6",
        width: "137.8%",
        height: "252.4%",
        x: "-18.9%",
        y: "-76.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("feOffset", {
        "in": "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feGaussianBlur", {
        "in": "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: "8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        "in": "shadowBlurOuter1",
        values: "0 0 0 0 0.161570617 0 0 0 0 0.163300979 0 0 0 0 0.199501812 0 0 0 0.3 0"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "periscope-failed-path-7",
        d: "M180.022 51.757a2 2 0 012 2v27.505a2 2 0 01-2 2H2a2 2 0 01-2-2V53.757a2 2 0 012-2h178.022zm-141.7 12.377h-23.65a2 2 0 00-2 2v2.751a2 2 0 002 2h23.65a2 2 0 002-2v-2.75a2 2 0 00-2-2zm25.344 0H51.538a2 2 0 00-2 2v2.751a2 2 0 002 2h12.128a2 2 0 002-2v-2.75a2 2 0 00-2-2zm56.45 0H76.883a2 2 0 00-2 2v2.751a2 2 0 002 2h43.233a2 2 0 002-2v-2.75a2 2 0 00-2-2zm47.234 0h-34.017a2 2 0 00-2 2v2.751a2 2 0 002 2h34.017a2 2 0 002-2v-2.75a2 2 0 00-2-2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("filter", {
        id: "periscope-failed-filter-8",
        width: "126.4%",
        height: "252.4%",
        x: "-13.2%",
        y: "-76.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("feOffset", {
        "in": "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feGaussianBlur", {
        "in": "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: "8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        "in": "shadowBlurOuter1",
        values: "0 0 0 0 0.161570617 0 0 0 0 0.163300979 0 0 0 0 0.199501812 0 0 0 0.3 0"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "periscope-failed-path-9",
        d: "M598 27.004a2 2 0 012 2v27.504a2 2 0 01-2 2h-42.944V46.13h30.272a2 2 0 001.994-1.85l.006-.15v-2.75a2 2 0 00-2-2H554.97l-.041-.176a4.002 4.002 0 00-3.674-2.994l-.2-.005h-54.921a4 4 0 00-3.995 3.8l-.005.2v18.302h-72.157a2 2 0 01-2-2V29.004a2 2 0 012-2H598zM456.299 39.38H432.65a2 2 0 00-2 2v2.75a2 2 0 002 2h23.649a2 2 0 002-2v-2.75a2 2 0 00-2-2zm25.345 0h-12.129a2 2 0 00-2 2v2.75a2 2 0 002 2h12.129a2 2 0 002-2v-2.75a2 2 0 00-2-2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("filter", {
        id: "periscope-failed-filter-10",
        width: "126.4%",
        height: "252.4%",
        x: "-13.2%",
        y: "-76.2%",
        filterUnits: "objectBoundingBox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("feOffset", {
        "in": "SourceAlpha",
        result: "shadowOffsetOuter1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feGaussianBlur", {
        "in": "shadowOffsetOuter1",
        result: "shadowBlurOuter1",
        stdDeviation: "8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        "in": "shadowBlurOuter1",
        values: "0 0 0 0 0.161570617 0 0 0 0 0.163300979 0 0 0 0 0.199501812 0 0 0 0.3 0"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-404 -259)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(132 195)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(288 64)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#281978",
        fillOpacity: "0.3",
        d: "M302.247 310.746c36.612 0 66.292 6.549 66.292 14.627S338.86 340 302.247 340c-36.613 0-66.292-6.55-66.292-14.627 0-8.078 29.68-14.627 66.292-14.627zM65.904 208.318c6.071 0 11.057 4.655 11.608 10.6a6.983 6.983 0 014.09-1.321c3.885 0 7.034 3.159 7.034 7.055 0 3.818-3.022 6.926-6.798 7.051l-.237.004H49.756c-4.548 0-8.234-3.696-8.234-8.256 0-4.56 3.686-8.257 8.234-8.257 1.848 0 3.549.618 4.923 1.65 1.378-4.919 5.88-8.526 11.225-8.526zm195.894-57.546c16.134 0 29.213 13.097 29.213 29.254 0 16.157-13.08 29.254-29.213 29.254-16.134 0-29.214-13.097-29.214-29.254 0-16.157 13.08-29.254 29.214-29.254zm80.899 0c16.134 0 29.213 13.097 29.213 29.254 0 16.157-13.08 29.254-29.213 29.254-16.135 0-29.214-13.097-29.214-29.254 0-16.157 13.08-29.254 29.214-29.254zm-80.899 22.503c-5.514 0-10.317 3.673-12.173 9.018a3.377 3.377 0 002.077 4.297 3.37 3.37 0 004.29-2.08l.16-.42c1.027-2.474 3.233-4.064 5.646-4.064 2.547 0 4.863 1.771 5.805 4.484l.12.302a3.37 3.37 0 004.17 1.778 3.377 3.377 0 002.077-4.297c-1.855-5.345-6.658-9.018-12.172-9.018zm80.9 0c-5.515 0-10.318 3.673-12.174 9.018a3.377 3.377 0 002.077 4.297 3.37 3.37 0 004.29-2.08l.16-.42c1.027-2.474 3.233-4.064 5.646-4.064 2.547 0 4.863 1.771 5.805 4.484l.12.302a3.37 3.37 0 004.17 1.778 3.377 3.377 0 002.077-4.297c-1.855-5.345-6.659-9.018-12.172-9.018zM519.99 12.426c12.578 0 22.908 9.642 24.048 21.958a14.473 14.473 0 018.471-2.737c8.049 0 14.575 6.544 14.575 14.617 0 7.966-6.358 14.445-14.262 14.612l-.313.003H486.54c-9.42 0-17.057-7.658-17.057-17.106 0-9.446 7.637-17.104 17.057-17.104 3.83 0 7.352 1.281 10.2 3.418 2.855-10.189 12.179-17.66 23.252-17.66zM170.591 0c6.61 0 12.239 4.15 14.476 9.99a6.571 6.571 0 011.792-.252c2.114 0 3.994.996 5.208 2.543a9.767 9.767 0 014.028-.872c5.431 0 9.833 4.414 9.833 9.86 0 5.354-4.254 9.712-9.557 9.858l-.276.004h-42.442c-5.43 0-9.833-4.415-9.833-9.861 0-5.447 4.403-9.861 9.833-9.861.666 0 1.315.068 1.942.194C157.345 4.93 163.386 0 170.59 0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M446.067 111.391v175.276a2.5 2.5 0 01-2.5 2.5h-282.64a2.5 2.5 0 01-2.5-2.5V111.39h287.64zm-184.27 39.38c-16.133 0-29.213 13.098-29.213 29.255 0 16.157 13.08 29.254 29.214 29.254s29.213-13.097 29.213-29.254c0-16.157-13.08-29.254-29.213-29.254zm80.9 0c-16.135 0-29.214 13.098-29.214 29.255 0 16.157 13.08 29.254 29.214 29.254s29.213-13.097 29.213-29.254c0-16.157-13.08-29.254-29.213-29.254z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#292A33",
        fillRule: "nonzero",
        d: "M452.808 155.272v111.39l73.035.002a4.498 4.498 0 014.494 4.5 4.498 4.498 0 01-4.159 4.488l-.335.013-73.035-.001.001 7.877c0 6.733-5.37 12.211-12.055 12.373l-.305.004H164.045c-6.724 0-12.194-5.377-12.356-12.072l-.004-.305v-7.877H94.381a4.498 4.498 0 01-4.494-4.5 4.498 4.498 0 014.159-4.488l.335-.012 57.302-.001.001-44.897 6.741-2.773.001 64.548a5.622 5.622 0 005.397 5.622l.22.004H440.45c3.03 0 5.498-2.4 5.614-5.405l.004-.221v-128.27h6.741zm129.214 111.392a4.498 4.498 0 014.495 4.5 4.498 4.498 0 01-4.16 4.488l-.335.013h-33.707a4.498 4.498 0 01-4.495-4.5 4.498 4.498 0 014.16-4.49l.335-.011h33.707zm-507.865 0a4.498 4.498 0 014.495 4.5 4.498 4.498 0 01-4.16 4.488l-.335.013H56.18a4.498 4.498 0 01-4.495-4.5 4.498 4.498 0 014.16-4.49l.335-.011h17.977zm242.477-33.13l.478.01c6.182.271 10.978 5.775 10.978 12.367a3.373 3.373 0 01-3.37 3.375c-1.8 0-3.27-1.412-3.367-3.19l-.005-.185-.011-.394c-.167-2.905-2.173-5.107-4.503-5.227l-.2-.005h-31.022l-.313.012c-2.384.193-4.4 2.564-4.4 5.614a3.373 3.373 0 01-3.37 3.375 3.373 3.373 0 01-3.372-3.375c0-6.657 4.89-12.204 11.16-12.373l.295-.004h31.022zm26.063-89.513c19.858 0 35.955 16.119 35.955 36.004 0 19.886-16.097 36.006-35.955 36.006-18.994 0-34.546-14.746-35.865-33.43l-9.166-.061c-1.288 18.712-16.854 33.491-35.868 33.491-19.857 0-35.955-16.12-35.955-36.006 0-19.885 16.097-36.004 35.955-36.004 13.281 0 24.88 7.21 31.106 17.934 3.515-1.212 6.847-1.818 9.994-1.818 2.95 0 5.89.533 8.822 1.6 6.255-10.605 17.786-17.716 30.977-17.716zm-184.27 36.005v29.234l-6.742 2.773v-32.007h6.741zm184.27-29.254c-16.135 0-29.214 13.096-29.214 29.253 0 16.158 13.079 29.255 29.214 29.255 16.135 0 29.213-13.097 29.213-29.255 0-16.157-13.078-29.253-29.213-29.253zm-80.899 0c-16.134 0-29.214 13.097-29.214 29.253 0 16.157 13.08 29.255 29.214 29.255 16.135 0 29.213-13.097 29.213-29.255 0-16.157-13.078-29.253-29.213-29.253zm0 22.503c5.514 0 10.317 3.673 12.172 9.018a3.377 3.377 0 01-2.077 4.297 3.37 3.37 0 01-4.17-1.778l-.12-.302c-.942-2.713-3.258-4.484-5.805-4.484-2.413 0-4.619 1.59-5.645 4.064l-.16.42a3.37 3.37 0 01-4.29 2.08 3.377 3.377 0 01-2.078-4.297c1.856-5.345 6.66-9.018 12.173-9.018zm80.9 0c5.512 0 10.316 3.673 12.171 9.018a3.377 3.377 0 01-2.077 4.297 3.37 3.37 0 01-4.17-1.778l-.12-.302c-.942-2.713-3.258-4.484-5.805-4.484-2.413 0-4.619 1.59-5.645 4.064l-.16.42a3.37 3.37 0 01-4.291 2.08 3.377 3.377 0 01-2.077-4.297c1.856-5.345 6.66-9.018 12.173-9.018zm-40.45-8.638a3.374 3.374 0 00-3.372 3.376 3.374 3.374 0 003.372 3.375c1.861 0 3.37-1.51 3.37-3.375a3.373 3.373 0 00-3.37-3.376zM440.45 68.635c6.725 0 12.195 5.377 12.356 12.072l.004.305-.002 23.465h.002v6.751h-.002l.001 12.539h-6.74l-.002-12.54h-287.64v37.294h-6.74V81.01c0-6.733 5.369-12.21 12.054-12.372l.305-.004h276.404zm0 6.75H164.045a5.622 5.622 0 00-5.614 5.406l-.004.22v23.466h287.64V81.012a5.622 5.622 0 00-5.397-5.622l-.22-.004zM173.034 85.513l.211.005a4.498 4.498 0 014.283 4.496c0 2.486-2.012 4.5-4.494 4.5a4.498 4.498 0 01-4.495-4.5c0-2.486 2.013-4.5 4.495-4.5zm13.483 0l.211.005a4.498 4.498 0 014.283 4.496c0 2.486-2.012 4.5-4.494 4.5a4.498 4.498 0 01-4.495-4.5c0-2.486 2.013-4.5 4.495-4.5zm13.483 0l.212.005a4.498 4.498 0 014.282 4.496c0 2.486-2.012 4.5-4.494 4.5a4.498 4.498 0 01-4.494-4.5c0-2.486 2.012-4.5 4.494-4.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#CACED8",
        d: "M38.321 160.898a2 2 0 012 2v2.751a2 2 0 01-2 2H14.672a2 2 0 01-2-2v-2.75a2 2 0 012-2h23.65zm25.345 0a2 2 0 012 2v2.751a2 2 0 01-2 2H51.538a2 2 0 01-2-2v-2.75a2 2 0 012-2h12.128zm56.45 0a2 2 0 012 2v2.751a2 2 0 01-2 2H76.883a2 2 0 01-2-2v-2.75a2 2 0 012-2h43.233zm47.234 0a2 2 0 012 2v2.751a2 2 0 01-2 2h-34.017a2 2 0 01-2-2v-2.75a2 2 0 012-2h34.017zm288.949-24.753a2 2 0 012 2v2.75a2 2 0 01-2 2H432.65a2 2 0 01-2-2v-2.75a2 2 0 012-2h23.649zm25.345 0a2 2 0 012 2v2.75a2 2 0 01-2 2h-12.129a2 2 0 01-2-2v-2.75a2 2 0 012-2h12.129zm103.684 0a2 2 0 012 2v2.75a2 2 0 01-2 2h-30.273l.001-5.925c0-.283-.03-.56-.085-.826h30.357zm-471.635-2.05a2 2 0 012 2v2.751a2 2 0 01-2 2h-38.41a2 2 0 01-2-2v-2.75a2 2 0 012-2h38.41zm37.992-.2v6.75l-24.808.186a2 2 0 01-2.015-1.985v-2.766a2 2 0 011.985-2l24.838-.186zm356.171-24.754a2 2 0 012 2v2.75a2 2 0 01-2 2h-32.679a2 2 0 01-2-2v-2.75a2 2 0 012-2h32.679zm-45.811 0a2 2 0 012 2v2.75a2 2 0 01-2 2h-9.236v-6.75h9.236zm71.028 0a2 2 0 012 2v2.75a2 2 0 01-2 2h-12.047a2 2 0 01-2-2v-2.75a2 2 0 012-2h12.047zm32.094 0a2 2 0 012 2v2.75a2 2 0 01-2 2h-18.924a2 2 0 01-2-2v-2.75a2 2 0 012-2h18.924zm-121.6-33.755a2.5 2.5 0 012.5 2.5v26.754h-287.64V77.886a2.5 2.5 0 012.5-2.5h282.64zM173.034 85.512a4.498 4.498 0 00-4.495 4.501c0 2.486 2.013 4.5 4.495 4.5a4.498 4.498 0 004.494-4.5c0-2.486-2.012-4.5-4.494-4.5zm13.483 0a4.498 4.498 0 00-4.495 4.501c0 2.486 2.013 4.5 4.495 4.5a4.498 4.498 0 004.494-4.5c0-2.486-2.012-4.5-4.494-4.5zm13.483 0a4.498 4.498 0 00-4.494 4.501c0 2.486 2.012 4.5 4.494 4.5a4.498 4.498 0 004.494-4.5c0-2.486-2.012-4.5-4.494-4.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#000",
        filter: "url(#periscope-failed-filter-2)",
        xlinkHref: "#periscope-failed-path-1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#281978",
        xlinkHref: "#periscope-failed-path-1"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(0 96.764)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#000",
        filter: "url(#periscope-failed-filter-4)",
        xlinkHref: "#periscope-failed-path-3"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#FFF",
        xlinkHref: "#periscope-failed-path-3"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#000",
        filter: "url(#periscope-failed-filter-6)",
        xlinkHref: "#periscope-failed-path-5"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#FFF",
        xlinkHref: "#periscope-failed-path-5"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#000",
        filter: "url(#periscope-failed-filter-8)",
        xlinkHref: "#periscope-failed-path-7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#FFF",
        xlinkHref: "#periscope-failed-path-7"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#000",
        filter: "url(#periscope-failed-filter-10)",
        xlinkHref: "#periscope-failed-path-9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        fill: "#FFF",
        xlinkHref: "#periscope-failed-path-9"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M524.284 47.541a3 3 0 013 3v13.002h13a3 3 0 013 3v2.002a3 3 0 01-3 3h-13v13.002a3 3 0 01-3 3h-2a3 3 0 01-3-3V71.544h-13a3 3 0 01-3-3v-2a3 3 0 013-3h13V50.54a3 3 0 013-3h2z",
        transform: "rotate(45 523.284 67.544)"
    })))))));
};
var CheckIcon = function CheckIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "21",
        viewBox: "0 0 32 21"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fillRule: "nonzero",
        transform: "translate(-870 -426)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(132 332)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(0 70)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(738 24)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "32",
        height: "21",
        x: "0",
        y: "0",
        fill: "#CFE5F4",
        rx: "1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#184390",
        d: "M20.9 8.536a.292.292 0 00.213-.086.282.282 0 00.087-.209v-.295h.6c.05 0 .096-.02.137-.061A.186.186 0 0022 7.75v-.393c0-.082-.042-.139-.125-.172l-5.8-2.16a.127.127 0 00-.15 0l-5.8 2.16c-.083.033-.125.09-.125.172v.393c0 .05.02.094.063.135.041.041.087.061.137.061h.6v.295c0 .082.03.151.087.209.059.057.13.086.213.086h9.8zm.3 5.893v-.492a.282.282 0 00-.087-.208.292.292 0 00-.213-.086H20V8.929h-1.6v4.714h-1.6V8.929h-1.6v4.714h-1.6V8.929H12v4.714h-.9a.292.292 0 00-.213.086.282.282 0 00-.087.209v.49h10.4zM21.8 16c.05 0 .096-.02.137-.061a.186.186 0 00.063-.135v-.393a.563.563 0 00-.175-.418.584.584 0 00-.425-.172H10.6a.584.584 0 00-.425.172.563.563 0 00-.175.418v.393c0 .049.02.094.063.135.041.04.087.061.137.061h11.6z"
    })))))));
};
var WarningIconXS = function WarningIconXS(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#B34A00" : _ref$color, title = _ref.title, _ref$titleID = _ref.titleID, titleID = _ref$titleID === void 0 ? "warning-icon-title" : _ref$titleID, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "16px",
        height: "13px",
        viewBox: "0 0 16 13",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        "aria-labelledby": title && "#".concat(titleID, "-").concat(iconIndex),
        role: "img"
    }, title && /*#__PURE__*/ (0, _reactDefault.default).createElement("title", {
        id: "".concat(titleID, "-").concat(iconIndex)
    }, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M11.0106463,4.4659633 C11.3063934,4.63914978 11.5526739,4.88543032 11.7258604,5.18117739 L16.7999622,13.846119 C17.3581267,14.7992854 17.0379144,16.0244612 16.0847481,16.5826257 C15.7781918,16.762142 15.4293522,16.8567653 15.0741018,16.8567653 L4.92589823,16.8567653 C3.82132873,16.8567653 2.92589823,15.9613348 2.92589823,14.8567653 C2.92589823,14.5015149 3.02052159,14.1526753 3.20003784,13.846119 L8.27413962,5.18117739 C8.83230416,4.22801102 10.0574799,3.90779877 11.0106463,4.4659633 Z M10.6666667,13.3333333 L9.33333333,13.3333333 L9.33333333,14.6666667 L10.6666667,14.6666667 L10.6666667,13.3333333 Z M10.6666667,6.66666667 L9.33333333,6.66666667 L9.33333333,12 L10.6666667,12 L10.6666667,6.66666667 Z",
        id: "WarningIconXs-path-1-".concat(iconIndex)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "WarningIconXs-Group-1-".concat(iconIndex),
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "WarningIconXs-Group-2-".concat(iconIndex),
        transform: "translate(-135.000000, -483.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "WarningIconXs-Group-3-".concat(iconIndex),
        transform: "translate(133.000000, 479.000000)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "WarningIconXs-mask-2-".concat(iconIndex),
        fill: "white"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#WarningIconXs-path-1-".concat(iconIndex)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("use", {
        id: "WarningIconXs-Mask-".concat(iconIndex),
        fill: color,
        fillRule: "nonzero",
        xlinkHref: "#WarningIconXs-path-1-".concat(iconIndex)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        id: "WarningIconXs-Path-".concat(iconIndex),
        fill: color,
        fillRule: "nonzero",
        mask: "url(#WarningIconXs-mask-2-".concat(iconIndex, ")"),
        points: "-2.84217094e-14 -4.26325641e-14 20 -4.26325641e-14 20 20 -2.84217094e-14 20"
    })))));
};
var CashIcon = function CashIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "36",
        height: "24",
        fill: "none",
        viewBox: "0 0 36 24"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "36",
        height: "24",
        fill: "#E8FFEF",
        rx: "1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#317D4F",
        d: "M17.178 5.464v1.372c-1.799.294-3.115 1.407-3.094 3.08.021 1.645 1.05 2.597 2.611 2.884l1.617.308c.924.182 1.365.406 1.365 1.085 0 .609-.553 1.092-1.484 1.092-1.036 0-1.743-.455-1.932-1.267l-2.478.021c.175 1.834 1.414 2.8 3.374 3.038v1.197h2.023V17.07c1.876-.266 3.024-1.33 3.024-2.877 0-1.617-.798-2.751-2.702-3.178l-1.603-.357c-.994-.231-1.267-.497-1.267-1.029 0-.546.511-1.015 1.596-1.015 1.015 0 1.302.511 1.393 1.267l2.415-.014c.05-1.484-1.043-2.695-2.835-3.024V5.464h-2.023z"
    }));
};
var WalletBannerIcon = function WalletBannerIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "317",
        height: "166",
        viewBox: "0 0 317 166",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        opacity: "0.301503",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M157.432 143.31C173.852 143.31 187.163 146.266 187.163 149.912C187.163 153.558 173.852 156.514 157.432 156.514C141.012 156.514 127.701 153.558 127.701 149.912C127.701 146.266 141.012 143.31 157.432 143.31ZM41.3941 87.7459C46.9893 87.7459 51.584 92.0228 52.0911 97.4855C53.1543 96.7244 54.4526 96.2715 55.8593 96.2715C59.4395 96.2715 62.3423 99.1744 62.3423 102.755C62.3423 106.335 59.4395 109.238 55.8593 109.238H26.5139C22.3239 109.238 18.9268 105.841 18.9268 101.65C18.9268 97.4605 22.3239 94.0633 26.5139 94.0633C28.2175 94.0633 29.7842 94.6317 31.0509 95.5794C32.3211 91.0603 36.4686 87.7459 41.3941 87.7459ZM289.555 54.7295C291.057 54.7295 292.275 55.9473 292.275 57.4495V79.08C292.275 80.5822 291.057 81.8 289.555 81.8H252.252C250.75 81.8 249.532 80.5822 249.532 79.08V57.4495C249.532 55.9473 250.75 54.7295 252.252 54.7295H289.555ZM64.3171 53.0475C66.8713 53.0475 69.0467 54.6476 69.9112 56.8984C70.1319 56.8362 70.3633 56.8011 70.6035 56.8011C71.4206 56.8011 72.147 57.1854 72.6164 57.7815C73.0915 57.5674 73.6177 57.4452 74.1728 57.4452C76.2714 57.4452 77.9725 59.147 77.9725 61.2464C77.9725 63.3457 76.2714 65.0475 74.1728 65.0475H57.7722C55.6737 65.0475 53.9725 63.3457 53.9725 61.2464C53.9725 59.147 55.6737 57.4452 57.7722 57.4452C58.0293 57.4452 58.2802 57.4714 58.5227 57.5203C59.199 54.9474 61.5333 53.0475 64.3171 53.0475ZM194.464 27C200.473 27 205.344 31.8711 205.344 37.88V39.3591L93.4999 41.3254V34.48C93.4999 30.3489 96.8488 27 100.98 27H194.464ZM40.8804 21.0475C43.8206 21.0475 46.3247 22.8887 47.32 25.4787C47.574 25.4072 47.8403 25.3668 48.1169 25.3668C49.0574 25.3668 49.8936 25.8089 50.4339 26.4949C50.9809 26.2485 51.5866 26.108 52.2255 26.108C54.6413 26.108 56.5995 28.0662 56.5995 30.4819C56.5995 32.8976 54.6413 34.8559 52.2255 34.8559H33.3465C30.9307 34.8559 28.9725 32.8976 28.9725 30.4819C28.9725 28.0662 30.9307 26.108 33.3465 26.108C33.6424 26.108 33.9312 26.1381 34.2103 26.1943C34.9888 23.2337 37.676 21.0475 40.8804 21.0475ZM244.693 7C247.633 7 250.138 8.84119 251.133 11.4312C251.386 11.3597 251.653 11.3193 251.93 11.3193C252.871 11.3193 253.706 11.7614 254.246 12.4474C254.794 12.201 255.399 12.0604 256.038 12.0604C258.454 12.0604 260.412 14.0187 260.412 16.4344C260.412 18.8501 258.454 20.8084 256.038 20.8084H237.159C234.744 20.8084 232.785 18.8501 232.785 16.4344C232.785 14.0187 234.744 12.0604 237.159 12.0604C237.455 12.0604 237.744 12.0906 238.024 12.1468C238.802 9.18622 241.488 7 244.693 7Z",
        fill: themeValues.singleIconColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M214.62 39.3979H104.38C98.3711 39.3979 93.5 44.2691 93.5 50.278V125.518C93.5 131.527 98.3711 136.398 104.38 136.398H214.62C220.629 136.398 225.5 131.527 225.5 125.518V50.278C225.5 44.2691 220.629 39.3979 214.62 39.3979Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M283.856 61.1409H246.553C245.051 61.1409 243.833 62.3587 243.833 63.8609V85.4913C243.833 86.9936 245.051 88.2113 246.553 88.2113H283.856C285.359 88.2113 286.576 86.9936 286.576 85.4913V63.8609C286.576 62.3587 285.359 61.1409 283.856 61.1409Z",
        fill: "#CACED8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M280.7 124.181C281.827 124.152 282.764 125.041 282.793 126.167C282.822 127.242 282.013 127.744 280.96 127.85L280.808 127.86L265.557 128.26C264.431 128.29 263.494 127.401 263.464 126.274C263.436 125.199 264.245 124.297 265.298 124.191L265.45 124.181H280.7ZM88.0248 124.181C89.1514 124.194 90.0536 125.119 90.04 126.245C90.0269 127.321 89.1841 128.192 88.1277 128.257L87.9754 128.261H64.9185C63.7919 128.247 62.8897 127.323 62.9033 126.196C62.9163 125.121 63.7591 124.25 64.8156 124.185L64.9679 124.181H88.0248ZM56.9822 126.116C57.0376 127.19 56.2519 128.112 55.2018 128.245L55.05 128.258H47.2912C46.166 128.316 45.2068 127.451 45.1488 126.326C45.0933 125.252 45.879 124.329 46.9291 124.197L47.0809 124.183H54.8397C55.9649 124.125 56.9241 124.99 56.9822 126.116ZM224.423 124.358L255.529 124.364C256.604 124.352 257.487 125.157 257.5 126.163C257.513 127.123 256.729 127.919 255.722 128L255.577 128.006L224.471 128C223.396 128.012 222.513 127.207 222.5 126.201C222.488 125.241 223.272 124.445 224.278 124.364L224.423 124.358ZM286.576 67.5523V73.2514H243.833V67.5523H286.576ZM148.315 70C150.89 70 153.143 71.6682 154.017 74.1055C154.37 75.0909 153.858 76.1762 152.872 76.5295C151.936 76.8651 150.91 76.4194 150.507 75.5291L150.448 75.3848C150.103 74.4209 149.252 73.791 148.315 73.791C147.432 73.791 146.626 74.349 146.247 75.2183L146.18 75.3848C145.827 76.3703 144.742 76.8827 143.756 76.5295C142.771 76.1762 142.259 75.0909 142.612 74.1055C143.486 71.6681 145.738 70 148.315 70ZM171.828 70C174.404 70 176.656 71.6682 177.53 74.1055C177.883 75.0909 177.371 76.1762 176.386 76.5295C175.449 76.8651 174.423 76.4194 174.02 75.5291L173.962 75.3848C173.616 74.4209 172.765 73.791 171.828 73.791C170.945 73.791 170.14 74.349 169.76 75.2183L169.694 75.3848C169.34 76.3703 168.255 76.8827 167.27 76.5295C166.284 76.1762 165.772 75.0909 166.125 74.1055C166.999 71.6681 169.252 70 171.828 70ZM195.464 24.96C202.496 24.96 208.216 30.578 208.38 37.5706L208.384 37.88L208.383 39H215.548C221.557 39 226.428 43.8711 226.428 49.88V126.429C226.428 132.437 221.557 137.309 215.548 137.309H103.38C97.3712 137.309 92.5001 132.437 92.5001 126.429V44.325L92.4601 44.3254V34.48C92.4601 29.3129 96.5767 25.1072 101.709 24.9637L101.98 24.96H195.464ZM215.548 43.08L96.5801 43.081V126.429C96.5801 130.104 99.4964 133.099 103.141 133.224L103.38 133.229H215.548C219.223 133.229 222.218 130.312 222.344 126.667L222.348 126.429V49.88C222.348 46.2043 219.431 43.2098 215.786 43.0841L215.548 43.08ZM170.148 92.5353C171.195 92.5353 172.044 93.3839 172.044 94.4308C172.044 97.3486 169.736 99.7275 166.846 99.8418L166.628 99.8461H153.123C150.133 99.8461 147.709 97.4214 147.709 94.4308C147.709 93.3839 148.557 92.5353 149.604 92.5353C150.601 92.5353 151.418 93.305 151.494 94.2826L151.5 94.4308C151.5 95.278 152.148 95.9738 152.976 96.0485L153.123 96.0551H166.628C167.475 96.0551 168.171 95.4064 168.246 94.5786L168.253 94.4308C168.253 93.3839 169.101 92.5353 170.148 92.5353ZM283.856 61.1409C285.359 61.1409 286.576 62.3587 286.576 63.8609V85.4914C286.576 86.9936 285.359 88.2114 283.856 88.2114H246.553C245.051 88.2114 243.833 86.9936 243.833 85.4914V63.8609C243.833 62.3587 245.051 61.1409 246.553 61.1409H283.856ZM283.856 63.1809H246.553C246.212 63.1809 245.929 63.4325 245.881 63.7604L245.873 63.8609V85.4914C245.873 85.8328 246.125 86.1154 246.453 86.164L246.553 86.1714H283.856C284.198 86.1714 284.48 85.9198 284.529 85.5919L284.536 85.4914V63.8609C284.536 63.5195 284.285 63.2369 283.957 63.1883L283.856 63.1809ZM279.61 79.508C280.361 79.508 280.97 80.1169 280.97 80.868V80.9975C280.97 81.7486 280.361 82.3575 279.61 82.3575H272.357C271.606 82.3575 270.997 81.7486 270.997 80.9975V80.868C270.997 80.1169 271.606 79.508 272.357 79.508H279.61ZM195.464 29.04H101.98C99.049 29.04 96.6593 31.3582 96.5444 34.2612L96.5401 34.48V39H204.303L204.304 37.88C204.304 33.0849 200.486 29.1816 195.725 29.0437L195.464 29.04Z",
        fill: "#3B414D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M163.125 136.938L163.125 147.186L169.17 147.186C170.245 147.186 171.126 148.018 171.204 149.074L171.21 149.226C171.21 150.301 170.378 151.183 169.322 151.26L169.17 151.266H161.085C160.01 151.266 159.128 150.434 159.051 149.378L159.045 149.226V136.938H163.125ZM155.206 136.938V148.828C155.206 149.903 154.373 150.784 153.318 150.862L153.166 150.868H145.081C143.954 150.868 143.041 149.954 143.041 148.828C143.041 147.752 143.873 146.871 144.928 146.793L145.081 146.788L151.125 146.787L151.126 136.938H155.206ZM92.5043 102.345C92.4966 102.35 92.494 102.988 92.4932 103.823L92.4925 106.265C92.4924 106.341 92.4923 106.416 92.4922 106.488L92.4914 106.896C92.4899 107.403 92.4869 107.742 92.481 107.747C90.9028 109.118 88.694 111.036 85.8547 113.501L101.261 118.91C102.288 117.146 104.199 115.96 106.387 115.96C107.514 115.96 108.427 116.873 108.427 118C108.427 119.075 107.595 119.957 106.539 120.034L106.387 120.04C105.367 120.04 104.54 120.867 104.54 121.887C104.54 122.859 105.29 123.656 106.243 123.73L106.387 123.735H109.783C110.91 123.735 111.823 124.649 111.823 125.775C111.823 126.851 110.991 127.732 109.936 127.81L109.783 127.815H106.387C103.489 127.815 101.077 125.736 100.562 122.987L81.8461 116.42C81.1978 116.193 80.7368 115.671 80.5604 115.057C80.0263 114.262 80.1207 113.19 80.7967 112.499L80.9186 112.384L92.297 102.503C92.3387 102.467 92.4374 102.395 92.488 102.358L92.5043 102.345ZM268.895 93.9879C270.022 93.9879 270.935 94.9013 270.935 96.0279C270.935 97.1034 270.103 97.9845 269.047 98.0623L268.895 98.0679L263.322 98.0681C263.251 98.144 263.174 98.2153 263.09 98.281L262.96 98.3742L236.748 115.767C236.067 116.219 235.187 116.218 234.51 115.778L234.369 115.678C230.885 112.971 228.272 110.941 226.529 109.587C226.52 109.58 226.514 109.172 226.511 108.363L226.51 108.019C226.51 107.958 226.51 107.895 226.51 107.83L226.51 106.728C226.51 106.646 226.51 106.562 226.51 106.476L226.511 105.939C226.512 105.473 226.513 104.964 226.515 104.409L235.713 111.556L256.041 98.0675L252.027 98.0679C250.9 98.0679 249.987 97.1546 249.987 96.0279C249.987 94.9525 250.819 94.0714 251.875 93.9935L252.027 93.9879H268.895ZM240.628 66.1276C245.545 66.1276 249.532 70.1144 249.532 75.0323C249.532 79.9503 245.545 83.9371 240.628 83.9371C235.71 83.9371 231.723 79.9503 231.723 75.0323C231.723 70.1144 235.71 66.1276 240.628 66.1276ZM289.555 53.7295C291.543 53.7295 293.167 55.2893 293.27 57.2519L293.275 57.4495V79.08C293.275 81.0682 291.715 82.6921 289.753 82.7948L289.555 82.8L286.249 82.7948V80.7948L289.555 80.8C290.455 80.8 291.194 80.1088 291.269 79.2284L291.275 79.08L291.274 67.8395L286.275 67.84V62.1409L291.274 62.1405L291.275 57.4495C291.275 56.5496 290.584 55.8111 289.704 55.7358L289.555 55.7295H252.252C251.352 55.7295 250.614 56.4206 250.539 57.3011L250.532 57.4495V61.1409H248.532V57.4495C248.532 55.4613 250.092 53.8373 252.055 53.7346L252.252 53.7295H289.555Z",
        fill: themeValues.singleIconColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M241.696 70.4019L241.696 73.9629L245.258 73.9638V76.1009L241.696 76.1009L241.696 79.6628H239.559L239.558 76.1009L235.997 76.1009V73.9638L239.558 73.9629L239.559 70.4019H241.696Z",
        fill: "white"
    }));
};
var WalletBannerIcon$1 = themeComponent(WalletBannerIcon, "Icons", fallbackValues$b, "primary");
var StandardCheckoutImage = function StandardCheckoutImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "184",
        height: "170",
        viewBox: "0 0 184 170",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Illustration - Standard Checkout"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H184V191H4C1.79086 191 0 189.209 0 187V4Z",
        fill: "#D9DAF9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M92.2989 133.448C102.365 133.448 110.525 135.187 110.525 137.332C110.525 139.478 102.365 141.217 92.2989 141.217C82.2323 141.217 74.0714 139.478 74.0714 137.332C74.0715 135.187 82.2324 133.448 92.2989 133.448ZM29.251 105.36C30.5807 105.36 31.7073 106.229 32.0948 107.43C32.4011 107.254 32.7563 107.153 33.1348 107.153C34.29 107.153 35.2266 108.089 35.2266 109.245C35.2266 110.4 34.29 111.336 33.1348 111.336H25.6651C24.3449 111.336 23.2745 110.266 23.2745 108.946C23.2745 107.626 24.3449 106.555 25.6651 106.555C26.0359 106.555 26.3871 106.64 26.7003 106.79C27.2254 105.933 28.1715 105.36 29.251 105.36ZM151.164 53.3686C154.603 53.3688 157.425 56.0094 157.713 59.3735C158.322 58.9773 159.049 58.7465 159.829 58.7465C161.974 58.7466 163.713 60.486 163.713 62.6313C163.713 64.7766 161.974 66.5159 159.829 66.5161C159.729 66.5161 159.629 66.5118 159.53 66.5043V66.5161H142.199V66.5063C139.863 66.3525 138.016 64.4086 138.016 62.0336C138.016 59.5583 140.023 57.5513 142.498 57.5512C143.349 57.5512 144.145 57.7886 144.823 58.2006C145.587 55.4152 148.136 53.3686 151.164 53.3686ZM73.3389 41.7827C75.118 41.7828 76.6376 42.8936 77.2422 44.4594C77.4201 44.3848 77.6154 44.3432 77.8204 44.3432C78.3451 44.3432 78.8068 44.6142 79.0733 45.0229C79.4188 44.8613 79.8044 44.7709 80.211 44.7709C81.6962 44.7709 82.9005 45.9752 82.9005 47.4604C82.9002 48.8668 81.8202 50.0208 80.4444 50.1391V50.1489H69.0899V50.1391C69.0131 50.1457 68.935 50.1489 68.8565 50.1489C67.3714 50.1489 66.1673 48.9454 66.1671 47.4604C66.1671 45.9752 67.3713 44.7709 68.8565 44.7709C69.0133 44.7709 69.167 44.7842 69.3165 44.81C69.818 43.0619 71.4296 41.7827 73.3389 41.7827Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M53.7528 80.2609H130.845V126.277C130.845 126.937 130.31 127.472 129.65 127.472H54.948C54.2879 127.472 53.7528 126.937 53.7528 126.277V80.2609Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.96 71.6252C51.96 69.7935 53.4449 68.3087 55.2765 68.3087H129.321C131.153 68.3087 132.638 69.7935 132.638 71.6252V80.2609H51.96V71.6252Z",
        fill: "#E5E7EC"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M66.3027 74.2835C66.3027 74.9429 65.7676 75.4774 65.1075 75.4774C64.4474 75.4774 63.9122 74.9429 63.9122 74.2835C63.9122 73.6241 64.4474 73.0895 65.1075 73.0895C65.7676 73.0895 66.3027 73.6241 66.3027 74.2835Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M62.717 74.2835C62.717 74.9429 62.1819 75.4774 61.5218 75.4774C60.8617 75.4774 60.3266 74.9429 60.3266 74.2835C60.3266 73.6241 60.8617 73.0895 61.5218 73.0895C62.1819 73.0895 62.717 73.6241 62.717 74.2835Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M59.1313 74.2835C59.1313 74.9429 58.5962 75.4774 57.9361 75.4774C57.276 75.4774 56.7409 74.9429 56.7409 74.2835C56.7409 73.6241 57.276 73.0895 57.9361 73.0895C58.5962 73.0895 59.1313 73.6241 59.1313 74.2835Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M129.65 70.1015H54.9481C54.2879 70.1015 53.7528 70.6366 53.7528 71.2967V126.277C53.7528 126.937 54.2879 127.472 54.948 127.472H129.65C130.31 127.472 130.845 126.937 130.845 126.277V71.2967C130.845 70.6366 130.31 70.1015 129.65 70.1015ZM54.9481 68.3087C53.2978 68.3087 51.96 69.6465 51.96 71.2967V126.277C51.96 127.927 53.2978 129.265 54.948 129.265H129.65C131.3 129.265 132.638 127.927 132.638 126.277V71.2967C132.638 69.6465 131.3 68.3087 129.65 68.3087H54.9481Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M156.542 122.094C156.542 121.434 157.077 120.899 157.737 120.899H167.897C168.557 120.899 169.092 121.434 169.092 122.094C169.092 122.754 168.557 123.289 167.897 123.289H157.737C157.077 123.289 156.542 122.754 156.542 122.094Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.638 120.899H152.244C152.909 120.899 153.449 121.438 153.449 122.104C153.449 122.77 152.909 123.309 152.244 123.309H132.638V120.899Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M35.2269 122.094C35.2269 121.434 35.762 120.899 36.4221 120.899H51.96V123.289H36.4221C35.762 123.289 35.2269 122.754 35.2269 122.094Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M25.0675 122.094C25.0675 121.434 25.6026 120.899 26.2627 120.899H31.0436C31.7037 120.899 32.2388 121.434 32.2388 122.094C32.2388 122.754 31.7037 123.289 31.0436 123.289H26.2627C25.6026 123.289 25.0675 122.754 25.0675 122.094Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.9601 78.4676H132.638V80.2604H51.9601V78.4676Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M90.8047 136.727C90.8047 137.226 90.3999 137.632 89.9004 137.632H84.8291C84.1691 137.632 83.6339 137.097 83.6338 136.437C83.6338 135.777 84.169 135.242 84.8291 135.242H88.4141V129.265H90.8047V136.727ZM96.1836 135.242H99.7686C100.429 135.242 100.964 135.777 100.964 136.437C100.964 137.097 100.429 137.632 99.7686 137.632H94.6973C94.1978 137.632 93.793 137.226 93.793 136.727V129.265H96.1836V135.242ZM141.655 116.661C141.271 117.046 140.676 117.126 140.204 116.856L132.638 112.532V109.543L140.796 114.205C140.918 114.275 141.072 114.251 141.167 114.148L148.176 106.556H146.383C145.723 106.556 145.188 106.021 145.188 105.361C145.188 104.701 145.723 104.165 146.383 104.165H155.944C156.604 104.165 157.14 104.701 157.14 105.361C157.139 106.021 156.604 106.556 155.944 106.556H151.761L141.655 116.661Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "141.975",
        y: "83.9315",
        width: "17.635",
        height: "17.5863",
        rx: "8.439",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M151.726 88.0383V89.0822C153.038 89.3131 153.835 90.2159 153.819 91.3019L152.283 91.3283C152.189 90.6567 151.886 90.2473 151.084 90.2473C150.256 90.2474 149.745 90.6253 149.745 91.176C149.745 91.6167 149.985 91.8378 150.803 92.0529L152.017 92.3517C153.387 92.6823 153.955 93.5118 153.955 94.6506C153.955 95.7943 153.085 96.5919 151.694 96.7756V97.715H150.381V96.7805C148.953 96.6177 148.031 95.9039 147.891 94.5764L149.475 94.5451C149.636 95.2377 150.219 95.6055 151.053 95.6057C151.803 95.6057 152.34 95.2008 152.34 94.6603C152.34 94.0993 151.991 93.8682 151.257 93.7004L150.021 93.4328C148.87 93.1966 148.13 92.5196 148.114 91.3547C148.104 90.1163 149.063 89.282 150.407 89.0773V88.0383H151.726Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_9355_281",
        maskUnits: "userSpaceOnUse",
        x: "147",
        y: "88",
        width: "7",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M151.726 88.0383V89.0822C153.038 89.3131 153.835 90.2159 153.819 91.3019L152.283 91.3283C152.189 90.6567 151.886 90.2473 151.084 90.2473C150.256 90.2474 149.745 90.6253 149.745 91.176C149.745 91.6167 149.985 91.8378 150.803 92.0529L152.017 92.3517C153.387 92.6823 153.955 93.5118 153.955 94.6506C153.955 95.7943 153.085 96.5919 151.694 96.7756V97.715H150.381V96.7805C148.953 96.6177 148.031 95.9039 147.891 94.5764L149.475 94.5451C149.636 95.2377 150.219 95.6055 151.053 95.6057C151.803 95.6057 152.34 95.2008 152.34 94.6603C152.34 94.0993 151.991 93.8682 151.257 93.7004L150.021 93.4328C148.87 93.1966 148.13 92.5196 148.114 91.3547C148.104 90.1163 149.063 89.282 150.407 89.0773V88.0383H151.726Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_9355_281)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "143.645",
        y: "85.4679",
        width: "14.5552",
        height: "14.515",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M101.263 95.9553C100.228 95.9553 99.4816 96.5571 99.2985 97.2006C99.1846 97.601 98.7676 97.8333 98.3672 97.7193C97.9668 97.6054 97.7346 97.1884 97.8486 96.7881C98.2508 95.3743 99.6905 94.4478 101.263 94.4478C102.835 94.4478 104.275 95.3743 104.677 96.7881C104.791 97.1884 104.559 97.6054 104.158 97.7193C103.758 97.8333 103.341 97.601 103.227 97.2006C103.044 96.5571 102.298 95.9553 101.263 95.9553Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M84.5299 95.9553C83.495 95.9553 82.7487 96.5571 82.5656 97.2006C82.4517 97.601 82.0347 97.8333 81.6343 97.7193C81.2339 97.6054 81.0017 97.1884 81.1156 96.7881C81.5179 95.3743 82.9576 94.4478 84.5299 94.4478C86.1022 94.4478 87.5418 95.3743 87.9441 96.7881C88.058 97.1884 87.8258 97.6054 87.4254 97.7193C87.025 97.8333 86.6081 97.601 86.4941 97.2006C86.311 96.5571 85.5647 95.9553 84.5299 95.9553Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.4261 106.4C85.8424 106.4 86.1799 106.738 86.1799 107.154C86.1799 108.058 86.9127 108.791 87.8166 108.791H96.7807C97.6847 108.791 98.4174 108.058 98.4174 107.154C98.4174 106.738 98.7549 106.4 99.1712 106.4C99.5875 106.4 99.9249 106.738 99.9249 107.154C99.9249 108.891 98.5172 110.298 96.7807 110.298H87.8166C86.0801 110.298 84.6724 108.891 84.6724 107.154C84.6724 106.738 85.0098 106.4 85.4261 106.4Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.9593 112.531V109.543L41.5712 117.457C40.7439 118.088 41.0607 119.401 42.0844 119.584L62.7163 123.288V120.897L44.7879 117.909L51.9593 112.531Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M65.7042 117.909H66.8995C67.5596 117.909 68.0947 118.444 68.0947 119.104C68.0947 119.765 67.5596 120.3 66.8995 120.3H66.3018C65.3117 120.3 64.509 121.102 64.509 122.092C64.509 123.083 65.3117 123.885 66.3018 123.885H68.6923C69.3524 123.885 69.8875 124.42 69.8875 125.081C69.8875 125.741 69.3524 126.276 68.6923 126.276H65.7042C63.7239 126.276 62.1186 124.67 62.1186 122.69V121.495C62.1186 119.515 63.7239 117.909 65.7042 117.909Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M25.8391 72.536C29.2503 72.5361 32.0497 75.1416 32.3489 78.4657C33.032 77.9232 33.897 77.5985 34.8381 77.5985C37.047 77.5985 38.8379 79.3841 38.8381 81.5868C38.8381 83.7897 37.0471 85.576 34.8381 85.576C34.7868 85.576 34.7357 85.5741 34.6848 85.5721V85.576H16.8391V85.5741C16.8138 85.5745 16.7884 85.576 16.7629 85.576C14.1718 85.576 12.0708 83.4813 12.0706 80.8973C12.0706 78.3132 14.1716 76.2177 16.7629 76.2177C17.8215 76.2177 18.7983 76.5674 19.5833 77.1571C20.3985 74.4825 22.8907 72.536 25.8391 72.536Z",
        fill: "#A99DD2"
    })));
};
var GuidedCheckoutImage = function GuidedCheckoutImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "184",
        height: "159",
        viewBox: "0 0 184 159",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Illustration - Cart"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H184V159H4C1.79086 159 0 157.209 0 155V4Z",
        fill: "#D9DAF9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M92.2989 117.448C102.365 117.448 110.525 119.187 110.525 121.332C110.525 123.478 102.365 125.217 92.2989 125.217C82.2323 125.217 74.0714 123.478 74.0714 121.332C74.0715 119.187 82.2324 117.448 92.2989 117.448ZM29.251 89.3598C30.5807 89.3599 31.7073 90.2294 32.0948 91.4301C32.4011 91.2542 32.7563 91.1528 33.1348 91.1528C34.29 91.1528 35.2266 92.0894 35.2266 93.2446C35.2266 94.3997 34.29 95.3364 33.1348 95.3364H25.6651C24.3449 95.3364 23.2745 94.2659 23.2745 92.9457C23.2745 91.6256 24.3449 90.5551 25.6651 90.5551C26.0359 90.5551 26.3871 90.6398 26.7003 90.7905C27.2254 89.9326 28.1715 89.3598 29.251 89.3598ZM151.164 37.3686C154.603 37.3688 157.425 40.0094 157.713 43.3735C158.322 42.9773 159.049 42.7465 159.829 42.7465C161.974 42.7466 163.713 44.486 163.713 46.6313C163.713 48.7766 161.974 50.5159 159.829 50.5161C159.729 50.5161 159.629 50.5118 159.53 50.5043V50.5161H142.199V50.5063C139.863 50.3525 138.016 48.4086 138.016 46.0336C138.016 43.5583 140.023 41.5513 142.498 41.5512C143.349 41.5512 144.145 41.7886 144.823 42.2006C145.587 39.4152 148.136 37.3686 151.164 37.3686ZM73.3389 25.7827C75.118 25.7828 76.6376 26.8936 77.2422 28.4594C77.4201 28.3848 77.6154 28.3432 77.8204 28.3432C78.3451 28.3432 78.8068 28.6142 79.0733 29.0229C79.4188 28.8613 79.8044 28.7709 80.211 28.7709C81.6962 28.7709 82.9005 29.9752 82.9005 31.4604C82.9002 32.8668 81.8202 34.0208 80.4444 34.1391V34.1489H69.0899V34.1391C69.0131 34.1457 68.935 34.1489 68.8565 34.1489C67.3714 34.1489 66.1673 32.9454 66.1671 31.4604C66.1671 29.9752 67.3713 28.7709 68.8565 28.7709C69.0133 28.7709 69.167 28.7842 69.3165 28.81C69.818 27.0619 71.4296 25.7827 73.3389 25.7827Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M53.7528 64.2609H130.845V110.277C130.845 110.937 130.31 111.472 129.65 111.472H54.948C54.2879 111.472 53.7528 110.937 53.7528 110.277V64.2609Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.96 55.6252C51.96 53.7935 53.4449 52.3087 55.2765 52.3087H129.321C131.153 52.3087 132.638 53.7935 132.638 55.6252V64.2609H51.96V55.6252Z",
        fill: "#E5E7EC"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M66.3027 58.2835C66.3027 58.9429 65.7676 59.4774 65.1075 59.4774C64.4474 59.4774 63.9122 58.9429 63.9122 58.2835C63.9122 57.6241 64.4474 57.0895 65.1075 57.0895C65.7676 57.0895 66.3027 57.6241 66.3027 58.2835Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M62.717 58.2835C62.717 58.9429 62.1819 59.4774 61.5218 59.4774C60.8617 59.4774 60.3266 58.9429 60.3266 58.2835C60.3266 57.6241 60.8617 57.0895 61.5218 57.0895C62.1819 57.0895 62.717 57.6241 62.717 58.2835Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M59.1313 58.2835C59.1313 58.9429 58.5962 59.4774 57.9361 59.4774C57.276 59.4774 56.7409 58.9429 56.7409 58.2835C56.7409 57.6241 57.276 57.0895 57.9361 57.0895C58.5962 57.0895 59.1313 57.6241 59.1313 58.2835Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M129.65 54.1015H54.9481C54.2879 54.1015 53.7528 54.6366 53.7528 55.2967V110.277C53.7528 110.937 54.2879 111.472 54.948 111.472H129.65C130.31 111.472 130.845 110.937 130.845 110.277V55.2967C130.845 54.6366 130.31 54.1015 129.65 54.1015ZM54.9481 52.3087C53.2978 52.3087 51.96 53.6465 51.96 55.2967V110.277C51.96 111.927 53.2978 113.265 54.948 113.265H129.65C131.3 113.265 132.638 111.927 132.638 110.277V55.2967C132.638 53.6465 131.3 52.3087 129.65 52.3087H54.9481Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M156.542 106.094C156.542 105.434 157.077 104.899 157.737 104.899H167.897C168.557 104.899 169.092 105.434 169.092 106.094C169.092 106.754 168.557 107.289 167.897 107.289H157.737C157.077 107.289 156.542 106.754 156.542 106.094Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.638 104.899H152.244C152.909 104.899 153.449 105.438 153.449 106.104C153.449 106.77 152.909 107.309 152.244 107.309H132.638V104.899Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M35.2269 106.094C35.2269 105.434 35.762 104.899 36.4221 104.899H51.96V107.289H36.4221C35.762 107.289 35.2269 106.754 35.2269 106.094Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M25.0675 106.094C25.0675 105.434 25.6026 104.899 26.2627 104.899H31.0436C31.7037 104.899 32.2388 105.434 32.2388 106.094C32.2388 106.754 31.7037 107.289 31.0436 107.289H26.2627C25.6026 107.289 25.0675 106.754 25.0675 106.094Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.9601 62.4676H132.638V64.2604H51.9601V62.4676Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M90.8047 120.727C90.8047 121.226 90.3999 121.632 89.9004 121.632H84.8291C84.1691 121.632 83.6339 121.097 83.6338 120.437C83.6338 119.777 84.169 119.242 84.8291 119.242H88.4141V113.265H90.8047V120.727ZM96.1836 119.242H99.7686C100.429 119.242 100.964 119.777 100.964 120.437C100.964 121.097 100.429 121.632 99.7686 121.632H94.6973C94.1978 121.632 93.793 121.226 93.793 120.727V113.265H96.1836V119.242ZM141.655 100.661C141.271 101.046 140.676 101.126 140.204 100.856L132.638 96.5316V93.5433L140.796 98.2054C140.918 98.275 141.072 98.251 141.167 98.1478L148.176 90.556H146.383C145.723 90.556 145.188 90.0206 145.188 89.3607C145.188 88.7006 145.723 88.1653 146.383 88.1653H155.944C156.604 88.1653 157.14 88.7006 157.14 89.3607C157.139 90.0206 156.604 90.556 155.944 90.556H151.761L141.655 100.661Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M101.263 79.9553C100.228 79.9553 99.4816 80.5571 99.2985 81.2006C99.1846 81.601 98.7676 81.8333 98.3672 81.7193C97.9668 81.6054 97.7346 81.1884 97.8486 80.7881C98.2508 79.3743 99.6905 78.4478 101.263 78.4478C102.835 78.4478 104.275 79.3743 104.677 80.7881C104.791 81.1884 104.559 81.6054 104.158 81.7193C103.758 81.8333 103.341 81.601 103.227 81.2006C103.044 80.5571 102.298 79.9553 101.263 79.9553Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M84.5299 79.9553C83.495 79.9553 82.7487 80.5571 82.5656 81.2006C82.4517 81.601 82.0347 81.8333 81.6343 81.7193C81.2339 81.6054 81.0017 81.1884 81.1156 80.7881C81.5179 79.3743 82.9576 78.4478 84.5299 78.4478C86.1022 78.4478 87.5418 79.3743 87.9441 80.7881C88.058 81.1884 87.8258 81.6054 87.4254 81.7193C87.025 81.8333 86.6081 81.601 86.4941 81.2006C86.311 80.5571 85.5647 79.9553 84.5299 79.9553Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.4261 90.4004C85.8424 90.4004 86.1799 90.7379 86.1799 91.1541C86.1799 92.0581 86.9127 92.7908 87.8166 92.7908H96.7807C97.6847 92.7908 98.4174 92.0581 98.4174 91.1541C98.4174 90.7379 98.7549 90.4004 99.1712 90.4004C99.5875 90.4004 99.9249 90.7379 99.9249 91.1541C99.9249 92.8906 98.5172 94.2984 96.7807 94.2984H87.8166C86.0801 94.2984 84.6724 92.8906 84.6724 91.1541C84.6724 90.7379 85.0098 90.4004 85.4261 90.4004Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.9593 96.5307V93.5426L41.5712 101.457C40.7439 102.088 41.0607 103.401 42.0844 103.584L62.7163 107.288V104.897L44.7879 101.909L51.9593 96.5307Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M65.7042 101.909H66.8995C67.5596 101.909 68.0947 102.444 68.0947 103.104C68.0947 103.765 67.5596 104.3 66.8995 104.3H66.3018C65.3117 104.3 64.509 105.102 64.509 106.092C64.509 107.083 65.3117 107.885 66.3018 107.885H68.6923C69.3524 107.885 69.8875 108.42 69.8875 109.081C69.8875 109.741 69.3524 110.276 68.6923 110.276H65.7042C63.7239 110.276 62.1186 108.67 62.1186 106.69V105.495C62.1186 103.515 63.7239 101.909 65.7042 101.909Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M25.8391 56.536C29.2503 56.5361 32.0497 59.1416 32.3489 62.4657C33.032 61.9232 33.897 61.5985 34.8381 61.5985C37.047 61.5985 38.8379 63.3841 38.8381 65.5868C38.8381 67.7897 37.0471 69.576 34.8381 69.576C34.7868 69.576 34.7357 69.5741 34.6848 69.5721V69.576H16.8391V69.5741C16.8138 69.5745 16.7884 69.576 16.7629 69.576C14.1718 69.576 12.0708 67.4813 12.0706 64.8973C12.0706 62.3132 14.1716 60.2177 16.7629 60.2177C17.8215 60.2177 18.7983 60.5674 19.5833 61.1571C20.3985 58.4825 22.8907 56.536 25.8391 56.536Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M161.517 66.3366C162.711 66.3366 163.678 67.304 163.678 68.4974C163.678 68.5844 163.673 68.6712 163.662 68.7576L161.795 84.1507C161.664 85.2355 160.743 86.0513 159.65 86.0513H140.761C139.669 86.0513 138.748 85.2355 138.616 84.1507L136.749 68.7576C136.605 67.5729 137.449 66.496 138.634 66.3523C138.72 66.3419 138.807 66.3366 138.894 66.3366H161.517Z",
        fill: "#B4B3F4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M162.324 66.3367C163.124 66.3367 163.772 66.9786 163.772 67.7705C163.772 67.8276 163.768 67.8848 163.761 67.9415L161.718 84.7886C161.63 85.5091 161.013 86.0513 160.281 86.0513H140.131C139.398 86.0513 138.781 85.5091 138.694 84.7886L136.65 67.9415C136.555 67.1553 137.121 66.4414 137.915 66.3469C137.972 66.3401 138.029 66.3367 138.087 66.3367H162.324ZM140.567 82.2066L140.772 83.9006L142.276 83.9006L140.567 82.2066ZM146.587 81.0019L143.66 83.9006H149.513L146.587 81.0019ZM153.824 81.0019L150.898 83.9006H156.75L153.824 81.0019ZM159.844 82.2076L158.135 83.9006L159.639 83.9006L159.844 82.2076ZM157.443 77.4177L154.336 80.4952L157.442 83.5727L159.984 81.0549L160.105 80.0555L157.443 77.4177ZM146.587 73.8335L143.481 76.911L146.587 79.9885L148.635 77.9595C148.777 77.8195 149.006 77.8195 149.147 77.9595C149.278 78.0887 149.288 78.2921 149.177 78.4327L149.147 78.4664L147.098 80.4952L150.205 83.5727L153.312 80.4952L146.587 73.8335ZM142.969 77.4177L140.306 80.056L140.427 81.0543L142.968 83.5727L146.075 80.4952L142.969 77.4177ZM150.206 70.2488L147.099 73.3263L153.824 79.9885L156.931 76.911L153.812 73.8216L152.843 74.7874C152.702 74.9277 152.473 74.9283 152.331 74.7886C152.19 74.649 152.189 74.422 152.33 74.2817L153.301 73.3149L150.206 70.2488ZM142.968 70.2488L139.529 73.6553L140.196 79.1501L142.457 76.9105L141.461 75.9246L141.431 75.8908C141.321 75.7502 141.331 75.5469 141.461 75.4177C141.589 75.2917 141.787 75.2791 141.928 75.3799L141.973 75.4177L142.968 76.4038L146.075 73.3263L142.968 70.2488ZM157.422 70.2282L154.323 73.3133L157.443 76.4038L158.262 75.5926C158.403 75.4526 158.632 75.4526 158.774 75.5926C158.904 75.7218 158.914 75.9251 158.804 76.0657L158.774 76.0995L157.954 76.9105L160.215 79.1496L160.881 73.6547L157.422 70.2282ZM148.789 68.4872H144.385L144.566 68.6666L143.481 69.7415L146.587 72.819L149.694 69.7415L148.608 68.6666L148.789 68.4872ZM156.026 68.4872H151.622L151.803 68.6666L150.717 69.7415L153.811 72.8066L156.911 69.7215L155.845 68.6666L156.026 68.4872ZM141.552 68.4872L138.903 68.4874L139.42 72.7504L142.457 69.7421L141.371 68.6666L141.552 68.4872ZM161.508 68.4874L159.023 68.4876C159.023 68.5789 158.988 68.6703 158.918 68.7402L157.933 69.7205L160.991 72.7499L161.508 68.4874ZM143.723 68.4872H142.214L142.968 69.2348L143.723 68.4872ZM150.96 68.4872H149.451L150.205 69.2348L150.96 68.4872ZM158.15 68.4872H156.688L157.421 69.2132L158.15 68.4872Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M150.935 60.96C151.531 60.96 152.015 61.4437 152.015 62.0404L152.015 66.3365L163.783 66.3367C164.678 66.3367 165.403 67.0622 165.403 67.9573V68.3006C165.403 69.1956 164.678 69.9212 163.783 69.9212H136.629C135.734 69.9212 135.008 69.1956 135.008 68.3006V67.9573C135.008 67.0622 135.734 66.3367 136.629 66.3367L148.396 66.3365L148.396 62.0404C148.396 61.4437 148.88 60.96 149.477 60.96H150.935Z",
        fill: "#292A33"
    })));
};
var ProfileImage = function ProfileImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "184",
        height: "170",
        viewBox: "0 0 184 170",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Illustration - Profile"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H184V170H4C1.79086 170 0 168.209 0 166V4Z",
        fill: "#D9DAF9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M94.7468 118.59C103.892 118.59 111.306 120.237 111.306 122.267C111.306 124.298 103.892 125.945 94.7468 125.945C85.6015 125.945 78.1881 124.298 78.1881 122.267C78.1881 120.237 85.6015 118.59 94.7468 118.59ZM73.0069 52.5063C74.1699 52.5063 75.1372 53.4009 75.228 54.5603L75.5284 58.399L123.118 58.3995C125.01 58.3995 126.623 59.9469 126.721 61.8558L129.122 108.516C129.22 110.425 127.767 111.972 125.875 111.972H60.2225C58.3307 111.972 56.7175 110.425 56.6193 108.516L54.2181 61.8558C54.1199 59.9469 55.5739 58.3995 57.4656 58.3995H58.6074L58.5185 56.6713C58.5082 56.4714 58.5234 56.2775 58.5613 56.0926L58.469 54.908C58.373 53.6814 59.2895 52.6091 60.5162 52.5131C60.574 52.5086 60.632 52.5063 60.69 52.5063H73.0069ZM28.076 95.1579C29.6551 95.1579 30.9519 96.3771 31.095 97.9343C31.395 97.7173 31.7615 97.5882 32.1585 97.5882C33.1689 97.5882 33.9882 98.4157 33.9882 99.4364C33.9882 100.457 33.1689 101.284 32.1585 101.284H23.8763C22.6938 101.284 21.735 100.316 21.735 99.1215C21.735 97.9271 22.6938 96.9587 23.8763 96.9587C24.3571 96.9587 24.7993 97.1208 25.1568 97.3909C25.5153 96.1027 26.6858 95.1579 28.076 95.1579ZM45.0508 65.1992C45.2562 65.1992 45.423 65.4207 45.423 65.6947V87.4777H29.8281V65.6947C29.8281 65.4207 29.9946 65.1992 30.2002 65.1992H45.0508ZM168.335 69.2544C169.171 69.2544 169.849 69.9327 169.849 70.7694V82.8167C169.849 83.6534 169.171 84.3317 168.335 84.3317H147.558C146.722 84.3317 146.043 83.6534 146.043 82.8167V70.7694C146.043 69.9327 146.722 69.2544 147.558 69.2544H168.335ZM21.4904 49.8311C23.2687 49.8311 24.7832 50.9451 25.3851 52.5121C25.5387 52.4688 25.6998 52.4444 25.8671 52.4444C26.4359 52.4444 26.9417 52.7119 27.2684 53.127C27.5992 52.9779 27.9656 52.8928 28.352 52.8928C29.813 52.8928 30.9974 54.0776 30.9974 55.5392C30.9974 57.0008 29.813 58.1856 28.352 58.1856H16.9339C15.4729 58.1856 14.2885 57.0008 14.2885 55.5392C14.2885 54.0776 15.4729 52.8928 16.9339 52.8928C17.1129 52.8928 17.2876 52.9111 17.4564 52.9451C17.9272 51.1539 19.5524 49.8311 21.4904 49.8311ZM136.044 43.7848C137.94 43.7848 139.556 44.973 140.198 46.6446C140.361 46.5984 140.534 46.5723 140.712 46.5723C141.319 46.5723 141.858 46.8577 142.206 47.3004C142.56 47.1414 142.95 47.0506 143.363 47.0506C144.921 47.0506 146.184 48.3144 146.184 49.8734C146.184 51.4324 144.921 52.6962 143.363 52.6962H131.183C129.625 52.6962 128.362 51.4324 128.362 49.8734C128.362 48.3144 129.625 47.0506 131.183 47.0506C131.374 47.0506 131.56 47.0701 131.741 47.1064C132.243 45.1957 133.976 43.7848 136.044 43.7848Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M83.6991 56.962C84.9295 56.962 85.927 57.9594 85.927 59.1899C85.927 59.2543 85.9242 59.3187 85.9186 59.3829L85.8661 59.9947C85.8982 60.1551 85.9122 60.3221 85.9063 60.4937L85.8481 62.1646H129.904C131.796 62.1646 133.277 63.6607 133.213 65.5063L131.644 110.62C131.58 112.466 129.994 113.962 128.103 113.962H62.4504C60.5586 113.962 59.0771 112.466 59.1413 110.62L60.7103 65.5063C60.7745 63.6607 62.3601 62.1646 64.2518 62.1646L66.7401 62.164L67.0155 58.9969C67.1156 57.8456 68.0793 56.962 69.2349 56.962H83.6991Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M49.0283 68.4397C49.2336 68.4397 49.4004 68.5696 49.4004 68.73V89.0473H33.8055V68.73C33.8055 68.5696 33.972 68.4397 34.1776 68.4397H49.0283ZM165.16 72.8253C165.997 72.8253 166.675 73.5036 166.675 74.3403V86.3876C166.675 87.2243 165.997 87.9026 165.16 87.9026H144.384C143.547 87.9026 142.869 87.2243 142.869 86.3876V74.3403C142.869 73.5036 143.547 72.8253 144.384 72.8253H165.16Z",
        fill: "#CACED8"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M72.6721 52.1393C74.5287 52.1393 76.0909 53.6378 76.1876 55.5225L76.1972 55.8481L84.1487 55.8481C85.2866 55.8481 86.2916 56.4168 86.8951 57.2854L123.118 57.2855C125.351 57.2855 127.273 58.91 127.734 61.0509L129.904 61.0506C132.373 61.0506 134.339 62.9892 134.329 65.4077L134.326 65.5451L132.849 108.034L149.383 108.038C149.982 108.031 150.474 108.48 150.481 109.04C150.488 109.575 150.051 110.018 149.491 110.063L149.41 110.067L132.778 110.063L132.757 110.659C132.674 113.064 130.667 115.002 128.243 115.074L128.103 115.076H62.4503C60.7364 115.076 59.2653 114.142 58.5289 112.762C57.3517 112.297 56.3973 111.368 55.8925 110.208L43.2203 110.208C42.5929 110.201 42.0904 109.686 42.098 109.059C42.1052 108.46 42.5746 107.975 43.163 107.938L43.2479 107.936L55.4738 107.936L53.1057 61.913C52.9772 59.4163 54.8629 57.3615 57.3281 57.2876L57.4583 57.285L57.406 55.6146C57.3101 53.7503 58.7171 52.2091 60.5573 52.1416L60.6834 52.1393H72.6721ZM84.1487 58.0759H69.7055C69.146 58.0759 68.6733 58.491 68.6009 59.0457L68.049 63.2778L64.2518 63.2785C62.9545 63.2785 61.8666 64.305 61.8235 65.5451L60.2545 110.659C60.2124 111.868 61.1828 112.848 62.4503 112.848H128.103C129.4 112.848 130.488 111.822 130.531 110.582L132.1 65.4676C132.142 64.2584 131.172 63.2785 129.904 63.2785L84.7382 63.2779L85.2533 59.3339C85.2595 59.2862 85.2627 59.238 85.2627 59.1899C85.2627 58.5747 84.7639 58.0759 84.1487 58.0759ZM163.403 107.937C164.03 107.92 164.552 108.415 164.568 109.042C164.584 109.641 164.134 109.921 163.547 109.98L163.462 109.985L154.968 110.208C154.341 110.225 153.819 109.729 153.803 109.102C153.787 108.503 154.238 108.001 154.824 107.942L154.909 107.937H163.403ZM38.8001 109.014C38.831 109.612 38.3934 110.126 37.8085 110.2L37.724 110.207H33.4026C32.7759 110.239 32.2417 109.758 32.2094 109.131C32.1785 108.533 32.6161 108.019 33.201 107.945L33.2855 107.938H37.6069C38.2335 107.905 38.7678 108.387 38.8001 109.014ZM72.6721 54.3671H60.6834C60.0897 54.3671 59.6388 54.8196 59.6302 55.4373L59.6318 55.5225L59.7567 59.5134H57.4656C56.2522 59.5134 55.3228 60.4634 55.3274 61.6834L55.3306 61.7985L57.7318 108.459C57.7523 108.858 57.8706 109.237 58.0624 109.572L59.597 65.4676C59.6823 63.0164 61.7656 61.0506 64.2516 61.0506L66.0923 61.0501L66.3918 58.7576C66.6031 57.137 67.9531 55.9139 69.5735 55.8507L69.7055 55.8481L73.9688 55.8481L73.9618 55.6146C73.9282 54.9615 73.3881 54.4164 72.7585 54.3703L72.6721 54.3671ZM49.4005 67.744L49.4004 67.9526C49.7195 68.0776 49.9574 68.3613 49.9574 68.73V89.0473C49.9574 89.3549 49.7081 89.6042 49.4005 89.6042H33.8055C33.4979 89.6042 33.2486 89.3549 33.2486 89.0473V68.73C33.2486 68.3613 33.4864 68.0776 33.8054 67.9526L33.8055 67.744H49.4005ZM48.8432 70.4215H34.3622L34.3622 88.4899H48.8432L48.8432 70.4215ZM166.675 86.3876C166.675 87.2243 165.997 87.9026 165.16 87.9026H144.384C143.547 87.9026 142.869 87.2243 142.869 86.3876V74.3403C142.869 73.5036 143.547 72.8254 144.384 72.8254H165.16C165.997 72.8254 166.675 73.5036 166.675 74.3403V86.3876ZM41.4042 84.8032C41.7219 84.8032 41.9794 85.0607 41.9794 85.3783V86.5905C41.9794 86.9081 41.7219 87.1656 41.4042 87.1656H37.0123C36.6947 87.1656 36.4371 86.9081 36.4371 86.5905V85.3783C36.4371 85.0607 36.6947 84.8032 37.0123 84.8032H41.4042ZM165.539 79.5702H144.005L144.005 86.3876C144.005 86.5778 144.146 86.7352 144.328 86.7623L144.384 86.7664H165.16C165.351 86.7664 165.508 86.6262 165.535 86.4436L165.539 86.3876L165.539 79.5702ZM40.8285 85.953H37.587V86.0148H40.8285V85.953ZM162.795 83.0551C163.214 83.0551 163.553 83.3942 163.553 83.8126V83.8847C163.553 84.303 163.214 84.6422 162.795 84.6422H158.756C158.337 84.6422 157.998 84.303 157.998 83.8847V83.8126C157.998 83.3942 158.337 83.0551 158.756 83.0551H162.795ZM46.8861 79.5696C47.1937 79.5696 47.443 79.819 47.443 80.1266V82.9114C47.443 83.219 47.1937 83.4684 46.8861 83.4684H36.3038C35.9962 83.4684 35.7468 83.219 35.7468 82.9114V80.1266C35.7468 79.819 35.9962 79.5696 36.3038 79.5696H46.8861ZM46.3291 80.6836H36.8607V82.3544H46.3291V80.6836ZM46.8861 74.557C47.1937 74.557 47.443 74.8063 47.443 75.1139V77.8987C47.443 78.2063 47.1937 78.4557 46.8861 78.4557H36.3038C35.9962 78.4557 35.7468 78.2063 35.7468 77.8987V75.1139C35.7468 74.8063 35.9962 74.557 36.3038 74.557H46.8861ZM46.3291 75.6709H36.8607V77.3418H46.3291V75.6709ZM165.16 73.9616H144.384C144.194 73.9616 144.037 74.1017 144.009 74.2843L144.005 74.3403L144.005 76.3961H165.539L165.539 74.3403C165.539 74.1501 165.399 73.9927 165.216 73.9657L165.16 73.9616ZM41.3833 72.1001C41.701 72.1001 41.9585 72.3576 41.9585 72.6752C41.9585 72.9717 41.7342 73.2158 41.446 73.247L41.3833 73.2504H36.3495C36.0318 73.2504 35.7743 72.9929 35.7743 72.6752C35.7743 72.3787 35.9986 72.1347 36.2868 72.1034L36.3495 72.1001H41.3833ZM123.118 59.5134L87.474 59.5129L87.4624 59.6223L87.2758 61.0501L125.405 61.0508C125.029 60.1892 124.186 59.5642 123.235 59.5163L123.118 59.5134Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M97.9177 115.042L97.9177 120.749L101.285 120.749C101.884 120.749 102.374 121.213 102.418 121.801L102.421 121.885C102.421 122.484 101.957 122.975 101.369 123.018L101.285 123.022H96.7815C96.1826 123.022 95.6918 122.558 95.6485 121.97L95.6453 121.885V115.042H97.9177ZM93.5069 115.042V121.664C93.5069 122.263 93.0434 122.753 92.4555 122.797L92.3707 122.8H87.8677C87.2402 122.8 86.7315 122.291 86.7315 121.664C86.7315 121.065 87.195 120.574 87.7829 120.531L87.8677 120.527L91.2342 120.527L91.2345 115.042H93.5069ZM156.828 91.1199C157.455 91.1199 157.964 91.6286 157.964 92.2561C157.964 92.8551 157.5 93.3458 156.912 93.3892L156.828 93.3923L153.724 93.3923C153.684 93.4346 153.641 93.4743 153.594 93.5109L153.522 93.5629L138.923 103.25C138.544 103.501 138.054 103.501 137.677 103.256L137.598 103.2C135.658 101.693 134.202 100.562 133.232 99.8079C133.226 99.8033 133.222 99.5121 133.221 98.9344L133.221 98.075C133.221 97.74 133.222 97.3564 133.224 96.9242L138.346 100.905L149.668 93.3921L147.433 93.3923C146.805 93.3923 146.296 92.8836 146.296 92.2561C146.296 91.6571 146.76 91.1664 147.348 91.123L147.433 91.1199H156.828ZM48.8354 91.9397C49.4629 91.9397 49.9716 92.4484 49.9716 93.076C49.9716 93.6749 49.5081 94.1657 48.9202 94.209L48.8354 94.2122L46.5562 94.2119L52.9362 100.667L58.4692 95.8625C58.4924 95.8423 58.5474 95.8025 58.5756 95.782L58.5844 95.7753L58.5838 95.7836C58.5805 95.8368 58.5792 96.111 58.5787 96.4737L58.5783 97.6945C58.5783 97.7397 58.5783 97.7844 58.5782 97.8284L58.5778 98.1995C58.5771 98.5412 58.5755 98.7799 58.5717 98.7831C57.4718 99.7384 55.8218 101.171 53.6219 103.082L53.6124 103.089L53.603 103.098C53.592 103.107 53.5808 103.116 53.5696 103.125L53.6219 103.082C53.5956 103.105 53.5686 103.126 53.5409 103.146C53.5264 103.157 53.5116 103.167 53.4966 103.176C53.485 103.184 53.4733 103.191 53.4614 103.198C53.4468 103.207 53.4322 103.216 53.4174 103.224C53.4042 103.231 53.3909 103.238 53.3776 103.244C53.3657 103.25 53.3534 103.256 53.3411 103.261C53.3261 103.268 53.3112 103.274 53.2962 103.28C53.2798 103.287 53.2631 103.293 53.2464 103.299C53.2352 103.302 53.2241 103.306 53.2129 103.31C53.1989 103.314 53.1846 103.318 53.1702 103.322C53.1497 103.327 53.129 103.332 53.1083 103.336C53.1029 103.337 53.0975 103.339 53.0921 103.34C53.0685 103.344 53.0449 103.348 53.0212 103.351C53.0133 103.352 53.0052 103.353 52.9972 103.354C52.9768 103.356 52.9564 103.357 52.936 103.359C52.9243 103.359 52.9127 103.36 52.9012 103.36C52.8861 103.36 52.8706 103.36 52.8552 103.36C52.8398 103.36 52.8246 103.359 52.8094 103.358C52.7963 103.357 52.7833 103.356 52.7703 103.355C52.7525 103.353 52.7346 103.351 52.7167 103.349C52.7071 103.347 52.6978 103.346 52.6885 103.344C52.6698 103.341 52.6509 103.338 52.632 103.333C52.6162 103.33 52.6008 103.326 52.5854 103.322C52.5724 103.319 52.5594 103.315 52.5465 103.311C52.4927 103.295 52.4399 103.274 52.3885 103.25C52.3612 103.237 52.3346 103.223 52.3085 103.208C52.2781 103.19 52.2481 103.171 52.219 103.15C52.2119 103.145 52.205 103.14 52.1981 103.135C52.1802 103.122 52.1626 103.108 52.1454 103.093C52.144 103.092 52.1424 103.091 52.1407 103.089L52.1177 103.069C52.1031 103.056 52.0889 103.043 52.0749 103.029L52.0689 103.023L44.1286 94.9886C43.9154 94.7729 43.8062 94.4934 43.8007 94.2123L38.8101 94.2122C38.1826 94.2122 37.6739 93.7035 37.6739 93.076C37.6739 92.477 38.1374 91.9862 38.7253 91.9429L38.8101 91.9397H48.8354ZM45.0508 64.6423C45.5764 64.6423 45.9419 65.0935 45.9771 65.6123L45.9799 65.6947V67.7444C45.9799 67.7444 45.7016 67.7538 45.4231 67.7585L45.4229 67.7981H33.5733V68.8596L30.3849 68.8596L30.3852 78.6293C30.8241 78.4867 31.2898 78.4036 31.7729 78.3897L31.9191 78.3875C34.6583 78.3875 36.8788 80.608 36.8788 83.3472C36.8788 86.0863 34.6583 88.3068 31.9191 88.3068C31.3508 88.3068 30.8049 88.2112 30.2964 88.0352L29.828 88.0347C29.5428 88.0347 29.3076 87.8203 29.275 87.5438C27.8836 86.6653 26.9595 85.1141 26.9595 83.3472C26.9595 81.5818 27.8818 80.0319 29.2709 79.153L29.2711 65.6947C29.2711 65.1698 29.6101 64.6924 30.1185 64.646L30.2002 64.6423H45.0508ZM141.084 75.6027C143.823 75.6027 146.043 77.8232 146.043 80.5623C146.043 83.3015 143.823 85.522 141.084 85.522C138.345 85.522 136.124 83.3015 136.124 80.5623C136.124 77.8232 138.345 75.6027 141.084 75.6027ZM168.335 68.6975C169.442 68.6975 170.346 69.5662 170.404 70.6593L170.406 70.7694V82.8167C170.406 83.9241 169.538 84.8285 168.445 84.8857L168.335 84.8886H166.208V83.7747H168.335C168.836 83.7747 169.247 83.3897 169.289 82.8994L169.293 82.8167L169.292 76.5562L166.508 76.5565V73.3823L169.292 73.3821L169.293 70.7694C169.293 70.2681 168.908 69.8568 168.417 69.8149L168.335 69.8114H147.558C147.057 69.8114 146.646 70.1963 146.604 70.6867L146.6 70.7694V73.4031H145.486V70.7694C145.486 69.662 146.355 68.7575 147.448 68.7003L147.558 68.6975H168.335ZM33.8055 74.0718V74.6288L31.9394 74.6283V76.2067L33.8055 76.2071V76.764H31.3825V74.0718H33.8055ZM33.5168 70.7164V71.2734L31.9394 71.2731V72.8515L33.5168 72.8517V73.4086H31.3825V70.7164H33.5168Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32.5143 80.7681L32.5143 82.7515L34.4981 82.752V83.9423L32.5143 83.9423L32.5143 85.9261H31.324L31.3235 83.9423L29.3401 83.9423V82.752L31.3235 82.7515L31.324 80.7681H32.5143ZM141.679 77.9833L141.679 79.9667L143.663 79.9672V81.1575L141.679 81.1575L141.679 83.1413H140.489L140.488 81.1575L138.505 81.1575V79.9672L140.488 79.9667L140.489 77.9833H141.679Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M103.263 81.9553C102.228 81.9553 101.482 82.5571 101.299 83.2006C101.185 83.601 100.768 83.8333 100.367 83.7193C99.9668 83.6054 99.7346 83.1884 99.8486 82.7881C100.251 81.3743 101.69 80.4478 103.263 80.4478C104.835 80.4478 106.275 81.3743 106.677 82.7881C106.791 83.1884 106.559 83.6054 106.158 83.7193C105.758 83.8333 105.341 83.601 105.227 83.2006C105.044 82.5571 104.298 81.9553 103.263 81.9553Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M86.5299 81.9553C85.495 81.9553 84.7487 82.5571 84.5656 83.2006C84.4517 83.601 84.0347 83.8333 83.6343 83.7193C83.2339 83.6054 83.0017 83.1884 83.1156 82.7881C83.5179 81.3743 84.9576 80.4478 86.5299 80.4478C88.1022 80.4478 89.5418 81.3743 89.9441 82.7881C90.058 83.1884 89.8258 83.6054 89.4254 83.7193C89.025 83.8333 88.6081 83.601 88.4941 83.2006C88.311 82.5571 87.5647 81.9553 86.5299 81.9553Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M87.4261 92.4004C87.8424 92.4004 88.1799 92.7379 88.1799 93.1541C88.1799 94.0581 88.9127 94.7908 89.8166 94.7908H98.7807C99.6847 94.7908 100.417 94.0581 100.417 93.1541C100.417 92.7379 100.755 92.4004 101.171 92.4004C101.587 92.4004 101.925 92.7379 101.925 93.1541C101.925 94.8906 100.517 96.2984 98.7807 96.2984H89.8166C88.0801 96.2984 86.6724 94.8906 86.6724 93.1541C86.6724 92.7379 87.0098 92.4004 87.4261 92.4004Z",
        fill: "#292A33"
    })));
};
var RevenueManagementImage = function RevenueManagementImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "184",
        height: "191",
        viewBox: "0 0 184 191",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Illustration - Revenue Management"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H184V191H4C1.79086 191 0 189.209 0 187V4Z",
        fill: "#D9DAF9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M92.2989 133.448C102.365 133.448 110.525 135.187 110.525 137.333C110.525 139.478 102.365 141.217 92.2989 141.217C82.2323 141.217 74.0714 139.478 74.0714 137.333C74.0715 135.187 82.2324 133.448 92.2989 133.448ZM29.251 105.36C30.5807 105.36 31.7073 106.229 32.0948 107.43C32.4011 107.254 32.7563 107.153 33.1348 107.153C34.29 107.153 35.2266 108.089 35.2266 109.245C35.2266 110.4 34.29 111.336 33.1348 111.336H25.6651C24.3449 111.336 23.2745 110.266 23.2745 108.946C23.2745 107.626 24.3449 106.555 25.6651 106.555C26.0359 106.555 26.3871 106.64 26.7003 106.791C27.2254 105.933 28.1715 105.36 29.251 105.36ZM151.164 53.3687C154.603 53.3689 157.425 56.0095 157.713 59.3735C158.322 58.9774 159.049 58.7466 159.829 58.7466C161.974 58.7467 163.713 60.4861 163.713 62.6313C163.713 64.7766 161.974 66.516 159.829 66.5161C159.729 66.5161 159.629 66.5119 159.53 66.5044V66.5161H142.199V66.5063C139.863 66.3525 138.016 64.4086 138.016 62.0337C138.016 59.5584 140.023 57.5513 142.498 57.5513C143.349 57.5513 144.145 57.7887 144.823 58.2007C145.587 55.4153 148.136 53.3687 151.164 53.3687ZM57.3389 49.7827C59.118 49.7829 60.6376 50.8937 61.2422 52.4595C61.4201 52.3848 61.6154 52.3433 61.8204 52.3433C62.3451 52.3433 62.8068 52.6142 63.0733 53.0229C63.4188 52.8614 63.8044 52.771 64.211 52.771C65.6962 52.771 66.9005 53.9752 66.9005 55.4604C66.9002 56.8669 65.8202 58.0209 64.4444 58.1392V58.1489H53.0899V58.1392C53.0131 58.1458 52.935 58.1489 52.8565 58.1489C51.3714 58.1489 50.1673 56.9455 50.1671 55.4604C50.1671 53.9752 51.3713 52.771 52.8565 52.771C53.0135 52.771 53.1678 52.7842 53.3174 52.8101C53.819 51.062 55.4296 49.7827 57.3389 49.7827Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M53.7528 80.261H130.845V126.277C130.845 126.937 130.31 127.472 129.65 127.472H54.948C54.2879 127.472 53.7528 126.937 53.7528 126.277V80.261Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.96 71.6253C51.96 69.7936 53.4449 68.3087 55.2765 68.3087H129.321C131.153 68.3087 132.638 69.7936 132.638 71.6253V80.261H51.96V71.6253Z",
        fill: "#E5E7EC"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M66.3027 74.2835C66.3027 74.9429 65.7676 75.4775 65.1075 75.4775C64.4474 75.4775 63.9122 74.9429 63.9122 74.2835C63.9122 73.6241 64.4474 73.0896 65.1075 73.0896C65.7676 73.0896 66.3027 73.6241 66.3027 74.2835Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M62.717 74.2835C62.717 74.9429 62.1819 75.4775 61.5218 75.4775C60.8617 75.4775 60.3266 74.9429 60.3266 74.2835C60.3266 73.6241 60.8617 73.0896 61.5218 73.0896C62.1819 73.0896 62.717 73.6241 62.717 74.2835Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M59.1313 74.2835C59.1313 74.9429 58.5962 75.4775 57.9361 75.4775C57.276 75.4775 56.7409 74.9429 56.7409 74.2835C56.7409 73.6241 57.276 73.0896 57.9361 73.0896C58.5962 73.0896 59.1313 73.6241 59.1313 74.2835Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M129.65 70.1016H54.9481C54.2879 70.1016 53.7528 70.6367 53.7528 71.2968V126.277C53.7528 126.937 54.2879 127.472 54.948 127.472H129.65C130.31 127.472 130.845 126.937 130.845 126.277V71.2968C130.845 70.6367 130.31 70.1016 129.65 70.1016ZM54.9481 68.3087C53.2978 68.3087 51.96 69.6465 51.96 71.2968V126.277C51.96 127.927 53.2978 129.265 54.948 129.265H129.65C131.3 129.265 132.638 127.927 132.638 126.277V71.2968C132.638 69.6465 131.3 68.3087 129.65 68.3087H54.9481Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M156.542 122.094C156.542 121.434 157.077 120.899 157.737 120.899H167.897C168.557 120.899 169.092 121.434 169.092 122.094C169.092 122.754 168.557 123.289 167.897 123.289H157.737C157.077 123.289 156.542 122.754 156.542 122.094Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.638 120.899H152.244C152.909 120.899 153.449 121.438 153.449 122.104C153.449 122.77 152.909 123.309 152.244 123.309H132.638V120.899Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M35.2269 122.094C35.2269 121.434 35.762 120.899 36.4221 120.899H51.96V123.289H36.4221C35.762 123.289 35.2269 122.754 35.2269 122.094Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M25.0675 122.094C25.0675 121.434 25.6026 120.899 26.2627 120.899H31.0436C31.7037 120.899 32.2388 121.434 32.2388 122.094C32.2388 122.754 31.7037 123.289 31.0436 123.289H26.2627C25.6026 123.289 25.0675 122.754 25.0675 122.094Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M90.2072 93.4087V98.7872H95.5857V93.4087C93.8736 92.6478 91.9192 92.6478 90.2072 93.4087ZM92.8964 96.3968C93.3915 96.3968 93.7928 95.9954 93.7928 95.5004C93.7928 95.0053 93.3915 94.6039 92.8964 94.6039C92.4013 94.6039 92 95.0053 92 95.5004C92 95.9954 92.4013 96.3968 92.8964 96.3968Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.4262 111.181C85.8425 111.181 86.1799 111.518 86.1799 111.935C86.1799 112.839 86.9127 113.571 87.8166 113.571H96.7808C97.6847 113.571 98.4175 112.839 98.4175 111.935C98.4175 111.518 98.755 111.181 99.1713 111.181C99.5876 111.181 99.925 111.518 99.925 111.935C99.925 113.671 98.5173 115.079 96.7808 115.079H87.8166C86.0801 115.079 84.6724 113.671 84.6724 111.935C84.6724 111.518 85.0099 111.181 85.4262 111.181Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.9601 78.4677H132.638V80.2605H51.9601V78.4677Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M27.4579 83.2494C27.4579 82.5893 27.993 82.0542 28.6531 82.0542H51.96V89.8232H28.6531C27.993 89.8232 27.4579 89.288 27.4579 88.6279V83.2494Z",
        fill: "#8F8CF0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M44.7886 85.9391C44.7886 85.4441 45.1899 85.0427 45.685 85.0427H51.9599V86.8356H45.685C45.1899 86.8356 44.7886 86.4342 44.7886 85.9391Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M30.4459 85.9391C30.4459 85.4441 30.8472 85.0427 31.3423 85.0427H41.5017C41.9968 85.0427 42.3981 85.4441 42.3981 85.9391C42.3981 86.4342 41.9968 86.8356 41.5017 86.8356H31.3423C30.8472 86.8356 30.4459 86.4342 30.4459 85.9391Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M11.92 89.8227C11.92 89.1626 12.4551 88.6274 13.1152 88.6274H59.1313C59.7914 88.6274 60.3266 89.1626 60.3266 89.8227V95.2012C60.3266 95.8613 59.7914 96.3964 59.1313 96.3964H13.1152C12.4551 96.3964 11.92 95.8613 11.92 95.2012V89.8227Z",
        fill: "#B4B3F4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M45.9838 92.5124C45.9838 92.0173 46.3852 91.616 46.8802 91.616H56.442C56.9371 91.616 57.3385 92.0173 57.3385 92.5124C57.3385 93.0075 56.9371 93.4088 56.442 93.4088H46.8802C46.3852 93.4088 45.9838 93.0075 45.9838 92.5124Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M31.0435 92.5124C31.0435 92.0173 31.4449 91.616 31.9399 91.616H42.697C43.192 91.616 43.5934 92.0173 43.5934 92.5124C43.5934 93.0075 43.192 93.4088 42.697 93.4088H31.9399C31.4449 93.4088 31.0435 93.0075 31.0435 92.5124Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M24.4698 92.5124C24.4698 92.0173 24.8711 91.616 25.3662 91.616H27.7567C28.2517 91.616 28.6531 92.0173 28.6531 92.5124C28.6531 93.0075 28.2517 93.4088 27.7567 93.4088H25.3662C24.8711 93.4088 24.4698 93.0075 24.4698 92.5124Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.908 92.5124C14.908 92.0173 15.3093 91.616 15.8044 91.616H21.1829C21.678 91.616 22.0793 92.0173 22.0793 92.5124C22.0793 93.0075 21.678 93.4088 21.1829 93.4088H15.8044C15.3093 93.4088 14.908 93.0075 14.908 92.5124Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.638 76.0773H166.104C166.764 76.0773 167.299 76.6124 167.299 77.2725V82.651C167.299 83.3111 166.764 83.8462 166.104 83.8462H132.638V76.0773Z",
        fill: "#8F8CF0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M156.542 79.9621C156.542 79.467 156.943 79.0657 157.439 79.0657H163.415C163.91 79.0657 164.311 79.467 164.311 79.9621C164.311 80.4572 163.91 80.8585 163.415 80.8585H157.439C156.943 80.8585 156.542 80.4572 156.542 79.9621Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M149.968 79.9621C149.968 79.467 150.37 79.0657 150.865 79.0657H153.255C153.75 79.0657 154.152 79.467 154.152 79.9621C154.152 80.4572 153.75 80.8585 153.255 80.8585H150.865C150.37 80.8585 149.968 80.4572 149.968 79.9621Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M138.016 79.9621C138.016 79.467 138.417 79.0657 138.913 79.0657H146.681C147.177 79.0657 147.578 79.467 147.578 79.9621C147.578 80.4572 147.177 80.8585 146.681 80.8585H138.913C138.417 80.8585 138.016 80.4572 138.016 79.9621Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.638 79.0657H134.729C135.224 79.0657 135.626 79.467 135.626 79.9621C135.626 80.4572 135.224 80.8585 134.729 80.8585H132.638V79.0657Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M123.673 83.8466C123.673 83.1865 124.209 82.6514 124.869 82.6514H170.885C171.545 82.6514 172.08 83.1865 172.08 83.8466V89.2251C172.08 89.8852 171.545 90.4203 170.885 90.4203H124.869C124.209 90.4203 123.673 89.8852 123.673 89.2251V83.8466Z",
        fill: "#B4B3F4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M158.335 86.5363C158.335 86.0412 158.736 85.6399 159.231 85.6399H168.195C168.691 85.6399 169.092 86.0412 169.092 86.5363C169.092 87.0314 168.691 87.4327 168.195 87.4327H159.231C158.736 87.4327 158.335 87.0314 158.335 86.5363Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M143.395 86.5373C143.395 86.0422 143.796 85.6409 144.291 85.6409H155.048C155.543 85.6409 155.944 86.0422 155.944 86.5373C155.944 87.0324 155.543 87.4337 155.048 87.4337H144.291C143.796 87.4337 143.395 87.0324 143.395 86.5373Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M136.223 86.5373C136.223 86.0422 136.625 85.6409 137.12 85.6409H140.108C140.603 85.6409 141.004 86.0422 141.004 86.5373C141.004 87.0324 140.603 87.4337 140.108 87.4337H137.12C136.625 87.4337 136.223 87.0324 136.223 86.5373Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M126.661 86.5375C126.661 86.0425 127.063 85.6411 127.558 85.6411H132.936C133.431 85.6411 133.833 86.0425 133.833 86.5375C133.833 87.0326 133.431 87.4339 132.936 87.4339H127.558C127.063 87.4339 126.661 87.0326 126.661 86.5375Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M90.8045 136.727C90.8045 137.227 90.3998 137.632 89.9002 137.632H84.8289C84.1688 137.632 83.6336 137.097 83.6336 136.436C83.6338 135.776 84.169 135.241 84.8289 135.241H88.4139V129.266H90.8045V136.727ZM96.1834 135.241H99.7694C100.429 135.241 100.964 135.777 100.964 136.436C100.964 137.096 100.429 137.631 99.7694 137.632H94.6971C94.1977 137.632 93.7928 137.227 93.7928 136.727V129.266H96.1834V135.241ZM155.944 104.165C156.604 104.165 157.139 104.7 157.139 105.36C157.139 106.02 156.604 106.556 155.944 106.556H151.762L141.655 116.661C141.271 117.046 140.676 117.125 140.204 116.855L132.638 112.532V109.544L140.796 114.206C140.918 114.276 141.072 114.251 141.167 114.148L148.176 106.556H146.383C145.723 106.556 145.187 106.02 145.187 105.36C145.187 104.7 145.723 104.165 146.383 104.165H155.944ZM69.1385 95.4335C69.6757 95.499 70.0575 95.9881 69.992 96.5253C69.9337 97.0043 69.9042 97.4925 69.9041 97.9882C69.9041 99.8069 70.3097 101.529 71.034 103.07C71.264 103.56 71.053 104.144 70.5633 104.374C70.0736 104.604 69.4897 104.393 69.2596 103.903C69.0591 103.476 68.8796 103.038 68.7225 102.589C66.1789 103.551 55.7523 107.503 50.7645 109.544L51.9598 110.141V113.13L46.8553 110.577C46.0469 110.172 46.0885 109.005 46.9237 108.659L68.0731 99.8885C67.9882 99.267 67.9442 98.6325 67.9442 97.9882C67.9442 97.4131 67.9788 96.8456 68.0467 96.288C68.1122 95.7508 68.6013 95.368 69.1385 95.4335ZM157.139 85.0419C158.46 85.0419 159.53 86.1123 159.53 87.4325V99.3846C159.53 100.705 158.46 101.775 157.139 101.775H145.187C143.867 101.775 142.797 100.705 142.797 99.3846V87.4325C142.797 86.1123 143.867 85.0419 145.187 85.0419H157.139Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M152.021 90.7636C152.866 91.6087 152.946 92.9291 152.261 93.8643L154.221 95.8237C154.299 95.9015 154.299 96.0276 154.221 96.1054L153.982 96.3438C153.905 96.4216 153.778 96.4216 153.701 96.3438L151.741 94.3844C150.806 95.0694 149.486 94.9893 148.641 94.1442C147.707 93.2107 147.707 91.6972 148.641 90.7636C149.574 89.8301 151.088 89.8301 152.021 90.7636ZM151.501 93.6241C152.147 92.9778 152.147 91.93 151.501 91.2837C150.855 90.6374 149.807 90.6374 149.161 91.2837C148.514 91.93 148.514 92.9778 149.161 93.6241C149.807 94.2704 150.855 94.2704 151.501 93.6241Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M81.5421 88.0298C86.9878 88.0299 91.4024 92.4453 91.4024 97.8911C91.4023 103.337 86.9877 107.751 81.5421 107.751C76.0963 107.751 71.6809 103.337 71.6807 97.8911C71.6807 92.4453 76.0962 88.0298 81.5421 88.0298ZM81.5421 89.5376C76.9288 89.5376 73.1885 93.2778 73.1885 97.8911C73.1886 102.504 76.9288 106.244 81.5421 106.244C86.1551 106.244 89.8945 102.504 89.8946 97.8911C89.8946 93.2779 86.1552 89.5377 81.5421 89.5376Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M104.251 88.0298C109.697 88.0298 114.111 92.4453 114.111 97.8911C114.111 103.337 109.697 107.751 104.251 107.751C98.8053 107.751 94.3908 103.337 94.3907 97.8911C94.3907 92.4453 98.8052 88.0298 104.251 88.0298ZM104.251 89.5376C99.6378 89.5376 95.8975 93.2778 95.8975 97.8911C95.8976 102.504 99.6378 106.244 104.251 106.244C108.864 106.244 112.604 102.504 112.605 97.8911C112.605 93.2778 108.864 89.5376 104.251 89.5376Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M81.5418 97.748C80.5069 97.748 79.7606 98.3498 79.5775 98.9934C79.4636 99.3938 79.0466 99.626 78.6462 99.5121C78.2458 99.3981 78.0136 98.9812 78.1275 98.5808C78.5298 97.167 79.9695 96.2405 81.5418 96.2405C83.1141 96.2405 84.5537 97.167 84.956 98.5808C85.0699 98.9812 84.8377 99.3981 84.4373 99.5121C84.0369 99.626 83.62 99.3938 83.5061 98.9934C83.3229 98.3498 82.5766 97.748 81.5418 97.748Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M81.5421 89.5376C86.1552 89.5377 89.8946 93.2779 89.8946 97.8911C89.8945 102.504 86.1551 106.244 81.5421 106.244C76.9288 106.244 73.1886 102.504 73.1885 97.8911C73.1885 93.2778 76.9288 89.5376 81.5421 89.5376ZM81.5421 96.2407C79.9699 96.2407 78.5304 97.167 78.128 98.5806C78.0141 98.981 78.2462 99.3983 78.6465 99.5122C79.0467 99.6259 79.4632 99.3937 79.5772 98.9937C79.7603 98.3501 80.5072 97.7476 81.5421 97.7476C82.5768 97.7477 83.3228 98.3502 83.5059 98.9937C83.6199 99.3939 84.0372 99.6261 84.4376 99.5122C84.8379 99.3982 85.07 98.9809 84.9561 98.5806C84.5538 97.167 83.1142 96.2408 81.5421 96.2407Z",
        fill: "#D9DAF9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M104.251 97.7479C103.216 97.7479 102.47 98.3497 102.287 98.9933C102.173 99.3936 101.756 99.6259 101.356 99.5119C100.955 99.398 100.723 98.9811 100.837 98.5807C101.239 97.1669 102.679 96.2404 104.251 96.2404C105.823 96.2404 107.263 97.1669 107.665 98.5807C107.779 98.9811 107.547 99.398 107.147 99.5119C106.746 99.6259 106.329 99.3936 106.215 98.9933C106.032 98.3497 105.286 97.7479 104.251 97.7479Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M104.251 89.5376C108.864 89.5376 112.605 93.2778 112.605 97.8911C112.604 102.504 108.864 106.244 104.251 106.244C99.6378 106.244 95.8976 102.504 95.8975 97.8911C95.8975 93.2778 99.6378 89.5376 104.251 89.5376ZM104.251 96.2407C102.679 96.2407 101.239 97.1669 100.837 98.5806C100.723 98.981 100.955 99.3983 101.356 99.5122C101.756 99.6261 102.173 99.3939 102.287 98.9937C102.47 98.3501 103.216 97.7476 104.251 97.7476C105.286 97.7476 106.032 98.3501 106.215 98.9937C106.329 99.3938 106.746 99.626 107.147 99.5122C107.547 99.3983 107.779 98.981 107.665 98.5806C107.263 97.1669 105.823 96.2407 104.251 96.2407Z",
        fill: "#D9DAF9"
    })));
};
var KioskImage = function KioskImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "184",
        height: "170",
        viewBox: "0 0 184 170",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Illustration - Kiosk"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H184V170H4C1.79086 170 0 168.209 0 166V4Z",
        fill: "#D9DAF9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.8395 66.0752C15.8139 66.0756 15.7883 66.0758 15.7626 66.0758C13.1713 66.0758 11.0706 63.981 11.0706 61.3968C11.0706 58.8126 13.1713 56.7178 15.7626 56.7178C16.821 56.7178 17.7976 57.0673 18.5826 57.6568C19.3979 54.9822 21.8905 53.0359 24.839 53.0359C28.2497 53.0359 31.0504 55.6404 31.3504 58.9638C32.0333 58.4221 32.8979 58.0985 33.8382 58.0985C36.0472 58.0985 37.838 59.8843 37.838 62.0871C37.838 64.29 36.0472 66.0758 33.8382 66.0758C33.7868 66.0758 33.7355 66.0749 33.6845 66.0729V66.0761H15.8395V66.0752Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.2482 96.1525C20.2357 96.1527 20.2232 96.1528 20.2107 96.1528C18.9455 96.1528 17.9199 95.13 17.9199 93.8684C17.9199 92.6067 18.9455 91.5839 20.2107 91.5839C20.7274 91.5839 21.2042 91.7545 21.5875 92.0424C21.9855 90.7365 23.2025 89.7863 24.6421 89.7863C26.3074 89.7863 27.6748 91.058 27.8212 92.6807C28.1546 92.4163 28.5767 92.2582 29.0359 92.2582C30.1144 92.2582 30.9887 93.1301 30.9887 94.2057C30.9887 95.2812 30.1144 96.1531 29.0359 96.1531C29.0107 96.1531 28.9857 96.1526 28.9608 96.1517V96.153H20.2482V96.1525Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M53.3391 82.7851C53.3583 82.7854 53.3775 82.7856 53.3968 82.7856C55.3379 82.7856 56.9114 81.1728 56.9114 79.1834C56.9114 77.194 55.3379 75.5812 53.3968 75.5812C52.604 75.5812 51.8724 75.8503 51.2844 76.3042C50.6737 74.2451 48.8066 72.7467 46.598 72.7467C44.043 72.7467 41.945 74.752 41.7205 77.3107C41.2089 76.8937 40.5613 76.6445 39.8568 76.6445C38.2021 76.6445 36.8608 78.0193 36.8608 79.7152C36.8608 81.4111 38.2021 82.786 39.8568 82.786C39.8954 82.786 39.9338 82.7852 39.972 82.7837V82.7858H53.3391V82.7851Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M147.427 54.9962C147.349 55.0028 147.27 55.0062 147.191 55.0062C145.669 55.0062 144.435 53.7759 144.435 52.2583C144.435 50.7407 145.669 49.5104 147.191 49.5104C147.376 49.5104 147.557 49.5287 147.732 49.5635C148.228 47.724 149.913 46.37 151.914 46.37C153.778 46.37 155.367 47.5448 155.977 49.1926C156.176 49.0946 156.401 49.0396 156.638 49.0396C157.195 49.0396 157.681 49.3431 157.938 49.7933C158.306 49.6122 158.719 49.5104 159.157 49.5104C160.679 49.5104 161.913 50.7407 161.913 52.2583C161.913 53.7759 160.679 55.0062 159.157 55.0062C159.131 55.0062 159.105 55.0058 159.079 55.0051V55.0062H147.427V54.9962Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M113.722 121.759C113.722 123.913 103.373 125.658 90.6076 125.658C77.8422 125.658 67.4937 123.913 67.4937 121.759C67.4937 119.606 77.8422 117.861 90.6076 117.861C103.373 117.861 113.722 119.606 113.722 121.759Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M68.373 44.9017C66.8298 44.9017 65.2658 44.7039 65.2658 47.5112V111.107C65.2658 113.914 66.7969 113.962 68.3401 113.962H113.712C115.255 113.962 116.506 113.914 116.506 111.107L116.473 47.7569C116.473 44.9496 114.629 44.9017 113.086 44.9017H68.373Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M116.473 47.7569C116.473 44.9496 114.629 44.9017 113.086 44.9017H68.373C68.2775 44.9017 68.1818 44.9009 68.0864 44.9002C66.6421 44.8887 65.2658 44.8778 65.2658 47.5112V111.107C65.2658 113.914 66.7969 113.962 68.3401 113.962H113.712C115.255 113.962 116.506 113.914 116.506 111.107L116.473 47.7569ZM114.278 111.107L114.246 47.7569C114.246 47.4665 114.216 47.2916 114.192 47.1986C114.147 47.1877 114.082 47.1751 113.992 47.164C113.756 47.1347 113.48 47.1295 113.086 47.1295H68.373C68.2686 47.1295 68.1654 47.1287 68.0724 47.128L68.0662 47.1279C67.9685 47.1272 67.8818 47.1265 67.7973 47.1265C67.6857 47.1266 67.5918 47.1279 67.5103 47.1309C67.5007 47.2284 67.4937 47.3535 67.4937 47.5112V111.107C67.4937 111.393 67.516 111.585 67.5388 111.707C67.7259 111.729 67.9635 111.734 68.3401 111.734H113.712C113.945 111.734 114.113 111.732 114.243 111.726C114.263 111.584 114.278 111.383 114.278 111.107Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M71.4335 51.5818C71.4337 51.2743 71.683 51.0253 71.9904 51.0253H104.253C104.561 51.0253 104.81 51.2746 104.81 51.5822V100.038C104.81 100.346 104.561 100.595 104.253 100.595H71.9498C71.6421 100.595 71.3926 100.345 71.3929 100.037L71.4335 51.5818Z",
        fill: "#D9DAF9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "158.685",
        y: "105.959",
        width: "11.9666",
        height: "2.51258",
        rx: "1.25629",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M115.392 106.164H153.823C154.438 106.164 154.937 106.663 154.937 107.278C154.937 107.894 154.438 108.392 153.823 108.392H115.392V106.164Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M31.2912 107.278C31.2912 106.663 31.7899 106.164 32.4051 106.164H66.9367V108.392H32.4051C31.7899 108.392 31.2912 107.894 31.2912 107.278Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "20.5965",
        y: "105.959",
        width: "7.71443",
        height: "2.5123",
        rx: "1.25615",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "92.557",
        y: "106.164",
        width: "7.71443",
        height: "2.5123",
        rx: "1.25615",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "111.221",
        y: "92.7974",
        width: "7.71443",
        height: "2.5123",
        rx: "1.25615",
        transform: "rotate(90 111.221 92.7974)",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "103.696",
        y: "106.164",
        width: "7.71443",
        height: "2.5123",
        rx: "1.25615",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M95.7816 69.3803C95.1918 69.3803 94.6563 69.8101 94.5091 70.4474C94.4068 70.8904 93.964 71.1667 93.5201 71.0646C93.0762 70.9625 92.7993 70.5206 92.9016 70.0777C93.2063 68.7581 94.3586 67.7341 95.7816 67.7341C97.2046 67.7341 98.3569 68.7581 98.6616 70.0777C98.764 70.5206 98.487 70.9625 98.0431 71.0646C97.5992 71.1667 97.1564 70.8904 97.0541 70.4474C96.9069 69.8101 96.3714 69.3803 95.7816 69.3803Z",
        fill: "#404064"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M80.4203 69.3803C79.8305 69.3803 79.2951 69.8101 79.1479 70.4474C79.0455 70.8904 78.6027 71.1667 78.1588 71.0646C77.7149 70.9625 77.438 70.5206 77.5403 70.0777C77.8451 68.7581 78.9973 67.7341 80.4203 67.7341C81.8434 67.7341 82.9956 68.7581 83.3004 70.0777C83.4027 70.5206 83.1258 70.9625 82.6818 71.0646C82.2379 71.1667 81.7951 70.8904 81.6928 70.4474C81.5456 69.8101 81.0102 69.3803 80.4203 69.3803Z",
        fill: "#404064"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M82.8492 79.9152C83.3048 79.9152 83.6741 80.2837 83.6741 80.7383C83.6741 81.4275 84.234 81.9861 84.9246 81.9861H91.2784C91.969 81.9861 92.5289 81.4275 92.5289 80.7383C92.5289 80.2837 92.8982 79.9152 93.3538 79.9152C93.8094 79.9152 94.1788 80.2837 94.1788 80.7383C94.1788 82.3367 92.8802 83.6325 91.2784 83.6325H84.9246C83.3228 83.6325 82.0242 82.3367 82.0242 80.7383C82.0242 80.2837 82.3936 79.9152 82.8492 79.9152Z",
        fill: "#404064"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M116.506 58.5392H151.249C151.801 58.5392 152.249 58.9869 152.249 59.5392V66.3323C152.249 66.8846 151.801 67.3324 151.249 67.3324H116.506V58.5392Z",
        fill: "#8F8CF0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "141.699",
        y: "61.9937",
        width: "7.08469",
        height: "1.88422",
        rx: "0.942111",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "134.929",
        y: "61.9937",
        width: "4.25081",
        height: "1.88422",
        rx: "0.942111",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "122.332",
        y: "61.9937",
        width: "10.0771",
        height: "1.88444",
        rx: "0.942218",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M116.506 61.9937H118.87C119.391 61.9937 119.813 62.4154 119.813 62.9358C119.813 63.4561 119.391 63.8779 118.87 63.8779H116.506V61.9937Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "123.73",
        y: "66.0762",
        width: "50.7006",
        height: "8.79317",
        rx: "1.5",
        fill: "#B4B3F4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "160.259",
        y: "69.5306",
        width: "10.707",
        height: "1.88444",
        rx: "0.942218",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "144.514",
        y: "69.5306",
        width: "13.2262",
        height: "1.88444",
        rx: "0.942218",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "137.428",
        y: "69.5306",
        width: "4.56569",
        height: "1.88422",
        rx: "0.942111",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "127.194",
        y: "69.5306",
        width: "7.71443",
        height: "1.88422",
        rx: "0.942111",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M116.506 94.1898V97.1663L124.357 101.424C125.023 101.785 125.848 101.663 126.38 101.125L136.503 90.8855H133.039L125.398 98.8104C125.262 98.9514 125.047 98.9814 124.878 98.883L116.506 94.1898Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M129.316 89.6295C129.316 88.9356 129.88 88.3732 130.575 88.3732H140.969C141.664 88.3732 142.228 88.9356 142.228 89.6295C142.228 90.3233 141.664 90.8858 140.969 90.8858H130.575C129.88 90.8858 129.316 90.3233 129.316 89.6295Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M83.2849 99.6975C84.0428 99.7896 84.5824 100.477 84.4901 101.234C84.4309 101.719 84.4003 102.213 84.4003 102.716C84.4003 104.558 84.8114 106.3 85.5457 107.86C85.8703 108.55 85.5732 109.372 84.8821 109.695C84.1911 110.019 83.3677 109.723 83.0431 109.033C82.1397 107.114 81.6354 104.972 81.6354 102.716C81.6354 102.102 81.6728 101.496 81.7455 100.9C81.8378 100.144 82.527 99.6054 83.2849 99.6975Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M65.5443 91.6835V94.7467L64.1232 95.4096C70.0803 98.0349 83.3328 103.878 83.3328 103.878V106.757L61.1761 96.9568C59.9803 96.4279 59.9361 94.6225 61.1044 94.0266L65.5443 91.6835Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "125.975",
        y: "68.4315",
        width: "17.635",
        height: "17.5863",
        rx: "8.439",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M135.726 72.5382V73.5822C137.038 73.8131 137.835 74.7158 137.819 75.8019L136.283 75.8282C136.189 75.1567 135.886 74.7472 135.084 74.7472C134.256 74.7473 133.745 75.1252 133.745 75.6759C133.745 76.1167 133.985 76.3377 134.803 76.5529L136.017 76.8517C137.387 77.1823 137.955 78.0118 137.955 79.1505C137.955 80.2943 137.085 81.0918 135.694 81.2755V82.215H134.381V81.2804C132.953 81.1177 132.031 80.4039 131.891 79.0763L133.475 79.045C133.636 79.7376 134.219 80.1055 135.053 80.1056C135.803 80.1056 136.34 79.7008 136.34 79.1603C136.34 78.5992 135.991 78.3682 135.257 78.2003L134.021 77.9327C132.87 77.6966 132.13 77.0196 132.114 75.8546C132.104 74.6162 133.063 73.7819 134.407 73.5773V72.5382H135.726Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_9348_204",
        maskUnits: "userSpaceOnUse",
        x: "131",
        y: "72",
        width: "7",
        height: "11"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M135.726 72.5382V73.5822C137.038 73.8131 137.835 74.7158 137.819 75.8019L136.283 75.8282C136.189 75.1567 135.886 74.7472 135.084 74.7472C134.256 74.7473 133.745 75.1252 133.745 75.6759C133.745 76.1167 133.985 76.3377 134.803 76.5529L136.017 76.8517C137.387 77.1823 137.955 78.0118 137.955 79.1505C137.955 80.2943 137.085 81.0918 135.694 81.2755V82.215H134.381V81.2804C132.953 81.1177 132.031 80.4039 131.891 79.0763L133.475 79.045C133.636 79.7376 134.219 80.1055 135.053 80.1056C135.803 80.1056 136.34 79.7008 136.34 79.1603C136.34 78.5992 135.991 78.3682 135.257 78.2003L134.021 77.9327C132.87 77.6966 132.13 77.0196 132.114 75.8546C132.104 74.6162 133.063 73.7819 134.407 73.5773V72.5382H135.726Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_9348_204)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "127.645",
        y: "69.9679",
        width: "14.5552",
        height: "14.515",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M73.6203 111.734H107.595V121.202C107.595 121.818 107.096 122.316 106.481 122.316H74.7342C74.119 122.316 73.6203 121.818 73.6203 121.202V111.734Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M105.367 113.962H75.8481V120.089H105.367V113.962ZM73.6203 111.734V121.202C73.6203 121.818 74.119 122.316 74.7342 122.316H106.481C107.096 122.316 107.595 121.818 107.595 121.202V111.734H73.6203Z",
        fill: "#292A33"
    })));
};
var CashieringImage = function CashieringImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "184",
        height: "170",
        viewBox: "0 0 184 170",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Illustration - Cashiering"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0H184V170H4C1.79086 170 0 168.209 0 166V4Z",
        fill: "#D9DAF9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M142.199 56.0061C139.863 55.8523 138.016 53.9088 138.016 51.5338C138.016 49.0584 140.022 47.0517 142.498 47.0517C143.349 47.0517 144.145 47.289 144.823 47.701C145.586 44.9154 148.135 42.8684 151.163 42.8684C154.602 42.8684 157.424 45.509 157.713 48.8732C158.321 48.4771 159.048 48.2469 159.829 48.2469C161.974 48.2469 163.713 49.986 163.713 52.1314C163.713 54.2767 161.974 56.0159 159.829 56.0159C159.728 56.0159 159.628 56.012 159.53 56.0045V56.0159H151.163H142.498H142.199V56.0061Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.665 100.837C24.3448 100.837 23.2746 99.7666 23.2746 98.4464C23.2746 97.1262 24.3448 96.0559 25.665 96.0559C26.0359 96.0559 26.387 96.1404 26.7002 96.2911C27.2253 95.4332 28.1711 94.8607 29.2507 94.8607C30.5805 94.8607 31.7073 95.7294 32.0949 96.9302C32.4013 96.7542 32.7565 96.6536 33.1352 96.6536C34.2903 96.6536 35.2268 97.59 35.2268 98.7452C35.2268 99.9004 34.2903 100.837 33.1352 100.837H29.2507H25.665Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M64.2106 47.6495H57.3381H53.0893V47.6395C53.0124 47.6461 52.9346 47.6495 52.856 47.6495C51.3708 47.6495 50.1668 46.4455 50.1668 44.9603C50.1668 43.475 51.3708 42.271 52.856 42.271C53.0131 42.271 53.1669 42.2845 53.3166 42.3103C53.8181 40.5622 55.4287 39.283 57.3381 39.283C59.1174 39.283 60.6372 40.3938 61.2419 41.9598C61.4198 41.8851 61.6152 41.8439 61.8202 41.8439C62.3449 41.8439 62.8065 42.1141 63.073 42.5228C63.4185 42.3613 63.804 42.271 64.2106 42.271C65.6959 42.271 66.8999 43.475 66.8999 44.9603C66.8999 46.3669 65.8199 47.5213 64.4439 47.6395V47.6495H64.2106Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M110.526 126.832C110.526 128.978 102.365 130.717 92.2984 130.717C82.2319 130.717 74.0713 128.978 74.0713 126.832C74.0713 124.687 82.2319 122.948 92.2984 122.948C102.365 122.948 110.526 124.687 110.526 126.832Z",
        fill: "#A99DD2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M53.7525 69.7614H130.844V115.777C130.844 116.438 130.309 116.973 129.649 116.973H54.9478C54.2877 116.973 53.7525 116.438 53.7525 115.777V69.7614Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.9599 61.1257C51.9599 59.2941 53.4448 57.8092 55.2764 57.8092H129.321C131.153 57.8092 132.637 59.2941 132.637 61.1257V69.7614H51.9599V61.1257Z",
        fill: "#E5E7EC"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M66.3021 63.7838C66.3021 64.4432 65.767 64.9777 65.1069 64.9777C64.4468 64.9777 63.9117 64.4432 63.9117 63.7838C63.9117 63.1244 64.4468 62.5898 65.1069 62.5898C65.767 62.5898 66.3021 63.1244 66.3021 63.7838Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M62.7165 63.7838C62.7165 64.4432 62.1814 64.9777 61.5213 64.9777C60.8612 64.9777 60.3261 64.4432 60.3261 63.7838C60.3261 63.1244 60.8612 62.5898 61.5213 62.5898C62.1814 62.5898 62.7165 63.1244 62.7165 63.7838Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M59.1309 63.7838C59.1309 64.4432 58.5958 64.9777 57.9357 64.9777C57.2756 64.9777 56.7405 64.4432 56.7405 63.7838C56.7405 63.1244 57.2756 62.5898 57.9357 62.5898C58.5958 62.5898 59.1309 63.1244 59.1309 63.7838Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M129.649 59.602H54.948C54.2879 59.602 53.7527 60.1372 53.7527 60.7973V115.778C53.7527 116.438 54.2879 116.973 54.948 116.973H129.649C130.309 116.973 130.845 116.438 130.845 115.778V60.7973C130.845 60.1372 130.309 59.602 129.649 59.602ZM54.948 57.8092C53.2977 57.8092 51.9599 59.147 51.9599 60.7973V115.778C51.9599 117.428 53.2977 118.766 54.948 118.766H129.649C131.3 118.766 132.637 117.428 132.637 115.778V60.7973C132.637 59.147 131.3 57.8092 129.649 57.8092H54.948Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M156.542 111.595C156.542 110.935 157.077 110.399 157.737 110.399H167.896C168.557 110.399 169.092 110.935 169.092 111.595C169.092 112.255 168.557 112.79 167.896 112.79H157.737C157.077 112.79 156.542 112.255 156.542 111.595Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.637 110.399H152.243C152.908 110.399 153.448 110.939 153.448 111.605C153.448 112.27 152.908 112.81 152.243 112.81H132.637V110.399Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M35.2261 111.595C35.2261 110.935 35.7612 110.399 36.4213 110.399H51.9592V112.79H36.4213C35.7612 112.79 35.2261 112.255 35.2261 111.595Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M25.0673 111.595C25.0673 110.935 25.6024 110.399 26.2625 110.399H31.0434C31.7035 110.399 32.2386 110.935 32.2386 111.595C32.2386 112.255 31.7035 112.79 31.0434 112.79H26.2625C25.6024 112.79 25.0673 112.255 25.0673 111.595Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M101.263 85.4553C100.228 85.4553 99.4816 86.0571 99.2985 86.7006C99.1846 87.101 98.7676 87.3333 98.3672 87.2193C97.9668 87.1054 97.7346 86.6884 97.8486 86.2881C98.2508 84.8743 99.6905 83.9478 101.263 83.9478C102.835 83.9478 104.275 84.8743 104.677 86.2881C104.791 86.6884 104.559 87.1054 104.158 87.2193C103.758 87.3333 103.341 87.101 103.227 86.7006C103.044 86.0571 102.298 85.4553 101.263 85.4553Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M84.5299 85.4553C83.495 85.4553 82.7487 86.0571 82.5656 86.7006C82.4517 87.101 82.0347 87.3333 81.6343 87.2193C81.2339 87.1054 81.0017 86.6884 81.1156 86.2881C81.5179 84.8743 82.9576 83.9478 84.5299 83.9478C86.1022 83.9478 87.5418 84.8743 87.9441 86.2881C88.058 86.6884 87.8258 87.1054 87.4254 87.2193C87.025 87.3333 86.6081 87.101 86.4941 86.7006C86.311 86.0571 85.5647 85.4553 84.5299 85.4553Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M85.4261 95.9004C85.8424 95.9004 86.1799 96.2379 86.1799 96.6541C86.1799 97.5581 86.9127 98.2908 87.8166 98.2908H96.7807C97.6847 98.2908 98.4174 97.5581 98.4174 96.6541C98.4174 96.2379 98.7549 95.9004 99.1712 95.9004C99.5875 95.9004 99.9249 96.2379 99.9249 96.6541C99.9249 98.3906 98.5172 99.7984 96.7807 99.7984H87.8166C86.0801 99.7984 84.6724 98.3906 84.6724 96.6541C84.6724 96.2379 85.0098 95.9004 85.4261 95.9004Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.9599 67.9678H132.637V69.7606H51.9599V67.9678Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M27.4588 72.7489C27.4588 72.0888 27.9939 71.5537 28.654 71.5537H51.9609V79.3227H28.654C27.9939 79.3227 27.4588 78.7875 27.4588 78.1274V72.7489Z",
        fill: "#8F8CF0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.9796 75.1566C30.655 75.0823 30.5754 75.035 30.5754 74.9269V74.9202C30.5754 74.8323 30.6516 74.768 30.8073 74.768C30.9922 74.768 31.1985 74.831 31.3925 74.957C31.4288 74.9805 31.4766 74.9725 31.5015 74.9367L31.7337 74.6021C31.7584 74.5665 31.7517 74.5163 31.7169 74.491C31.5734 74.3862 31.4116 74.312 31.2276 74.2687V74.0223C31.2276 73.979 31.1932 73.944 31.1508 73.944H30.684C30.6416 73.944 30.6073 73.979 30.6073 74.0223V74.242C30.1804 74.3142 29.9261 74.6021 29.9261 74.9809V74.9877C29.9261 75.4709 30.3071 75.6128 30.8007 75.7277C31.1188 75.8054 31.195 75.8562 31.195 75.9574V75.9643C31.195 76.0656 31.1022 76.1264 30.9266 76.1264C30.6806 76.1264 30.4486 76.0441 30.233 75.8872C30.1991 75.8626 30.152 75.87 30.1254 75.9026L29.8677 76.2165C29.8396 76.2507 29.8432 76.3026 29.8776 76.3303C30.0846 76.4969 30.3362 76.6022 30.6073 76.6463V76.8601C30.6073 76.8998 30.6389 76.932 30.6778 76.932H31.1571C31.196 76.932 31.2276 76.8998 31.2276 76.8601V76.6334C31.6054 76.5421 31.841 76.2829 31.841 75.9V75.8934C31.841 75.4506 31.5097 75.2748 30.9796 75.1566Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M44.7901 75.4388C44.7901 74.9437 45.1915 74.5424 45.6865 74.5424H51.9615V76.3352H45.6865C45.1915 76.3352 44.7901 75.9339 44.7901 75.4388Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M34.63 75.4388C34.63 74.9437 35.0313 74.5424 35.5264 74.5424H41.5025C41.9976 74.5424 42.399 74.9437 42.399 75.4388C42.399 75.9339 41.9976 76.3352 41.5025 76.3352H35.5264C35.0313 76.3352 34.63 75.9339 34.63 75.4388Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M11.92 79.323C11.92 78.6629 12.4551 78.1278 13.1152 78.1278H59.1313C59.7914 78.1278 60.3265 78.6629 60.3265 79.323V84.7015C60.3265 85.3616 59.7914 85.8968 59.1313 85.8968H13.1152C12.4551 85.8968 11.92 85.3616 11.92 84.7015V79.323Z",
        fill: "#B4B3F4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.4408 81.7307C15.1162 81.6564 15.0366 81.6091 15.0366 81.5009V81.4943C15.0366 81.4064 15.1128 81.3421 15.2685 81.3421C15.4534 81.3421 15.6597 81.4051 15.8537 81.5311C15.89 81.5546 15.9378 81.5466 15.9626 81.5108L16.1949 81.1762C16.2196 81.1406 16.2129 81.0904 16.1781 81.0651C16.0346 80.9603 15.8728 80.8861 15.6888 80.8428V80.5963C15.6888 80.5531 15.6544 80.5181 15.612 80.5181H15.1452C15.1028 80.5181 15.0685 80.5531 15.0685 80.5963V80.8161C14.6416 80.8883 14.3873 81.1762 14.3873 81.555V81.5618C14.3873 82.045 14.7682 82.1869 15.2619 82.3018C15.5799 82.3795 15.6562 82.4303 15.6562 82.5315V82.5384C15.6562 82.6397 15.5634 82.7005 15.3878 82.7005C15.1418 82.7005 14.9097 82.6182 14.6941 82.4613C14.6602 82.4367 14.6132 82.4441 14.5865 82.4767L14.3288 82.7906C14.3008 82.8248 14.3044 82.8767 14.3388 82.9044C14.5458 83.0709 14.7974 83.1763 15.0685 83.2204V83.4342C15.0685 83.4739 15.1 83.5061 15.139 83.5061H15.6182C15.6572 83.5061 15.6888 83.4739 15.6888 83.4342V83.2075C16.0666 83.1162 16.3022 82.857 16.3022 82.4741V82.4675C16.3022 82.0247 15.9709 81.8489 15.4408 81.7307Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M45.9838 82.0129C45.9838 81.5178 46.3851 81.1165 46.8802 81.1165H56.442C56.937 81.1165 57.3384 81.5178 57.3384 82.0129C57.3384 82.5079 56.937 82.9093 56.442 82.9093H46.8802C46.3851 82.9093 45.9838 82.5079 45.9838 82.0129Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M31.0439 82.0129C31.0439 81.5178 31.4452 81.1165 31.9403 81.1165H42.6973C43.1924 81.1165 43.5937 81.5178 43.5937 82.0129C43.5937 82.5079 43.1924 82.9093 42.6973 82.9093H31.9403C31.4452 82.9093 31.0439 82.5079 31.0439 82.0129Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M19.0912 82.0129C19.0912 81.5178 19.4925 81.1165 19.9876 81.1165H27.7566C28.2516 81.1165 28.653 81.5178 28.653 82.0129C28.653 82.5079 28.2516 82.9093 27.7566 82.9093H19.9876C19.4925 82.9093 19.0912 82.5079 19.0912 82.0129Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.637 65.5775H166.104C166.764 65.5775 167.299 66.1126 167.299 66.7727V72.1512C167.299 72.8113 166.764 73.3465 166.104 73.3465H132.637V65.5775Z",
        fill: "#8F8CF0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M156.543 69.4598C156.543 68.9647 156.944 68.5634 157.439 68.5634H163.415C163.91 68.5634 164.311 68.9647 164.311 69.4598C164.311 69.9548 163.91 70.3562 163.415 70.3562H157.439C156.944 70.3562 156.543 69.9548 156.543 69.4598Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M145.785 69.4598C145.785 68.9647 146.187 68.5634 146.682 68.5634H153.255C153.751 68.5634 154.152 68.9647 154.152 69.4598C154.152 69.9548 153.751 70.3562 153.255 70.3562H146.682C146.187 70.3562 145.785 69.9548 145.785 69.4598Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.638 68.5634H142.499C142.994 68.5634 143.395 68.9647 143.395 69.4598C143.395 69.9548 142.994 70.3562 142.499 70.3562H132.638V68.5634Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M123.673 73.3468C123.673 72.6867 124.209 72.1516 124.869 72.1516H170.885C171.545 72.1516 172.08 72.6867 172.08 73.3468V78.7253C172.08 79.3854 171.545 79.9206 170.885 79.9206H124.869C124.209 79.9206 123.673 79.3854 123.673 78.7253V73.3468Z",
        fill: "#B4B3F4"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M127.194 75.7546C126.87 75.6803 126.79 75.6331 126.79 75.5249V75.5182C126.79 75.4303 126.866 75.366 127.022 75.366C127.207 75.366 127.413 75.429 127.607 75.555C127.643 75.5785 127.691 75.5705 127.716 75.5347L127.948 75.2001C127.973 75.1645 127.966 75.1144 127.932 75.089C127.788 74.9842 127.626 74.91 127.442 74.8667V74.6203C127.442 74.5771 127.408 74.542 127.365 74.542H126.899C126.856 74.542 126.822 74.5771 126.822 74.6203V74.84C126.395 74.9123 126.141 75.2001 126.141 75.5789V75.5857C126.141 76.0689 126.522 76.2109 127.015 76.3257C127.333 76.4034 127.41 76.4542 127.41 76.5555V76.5623C127.41 76.6636 127.317 76.7244 127.141 76.7244C126.895 76.7244 126.663 76.6422 126.448 76.4853C126.414 76.4606 126.367 76.4681 126.34 76.5006L126.082 76.8145C126.054 76.8487 126.058 76.9007 126.092 76.9283C126.299 77.0949 126.551 77.2002 126.822 77.2444V77.4581C126.822 77.4978 126.854 77.53 126.892 77.53H127.372C127.411 77.53 127.442 77.4978 127.442 77.4581V77.2314C127.82 77.1401 128.056 76.8809 128.056 76.498V76.4914C128.056 76.0486 127.724 75.8729 127.194 75.7546Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M158.335 76.0339C158.335 75.5388 158.736 75.1375 159.231 75.1375H168.195C168.691 75.1375 169.092 75.5388 169.092 76.0339C169.092 76.5289 168.691 76.9303 168.195 76.9303H159.231C158.736 76.9303 158.335 76.5289 158.335 76.0339Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M143.394 76.0347C143.394 75.5396 143.796 75.1383 144.291 75.1383H155.048C155.543 75.1383 155.944 75.5396 155.944 76.0347C155.944 76.5298 155.543 76.9311 155.048 76.9311H144.291C143.796 76.9311 143.394 76.5298 143.394 76.0347Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M130.845 76.0339C130.845 75.5388 131.246 75.1375 131.741 75.1375H140.108C140.603 75.1375 141.004 75.5388 141.004 76.0339C141.004 76.5289 140.603 76.9303 140.108 76.9303H131.741C131.246 76.9303 130.845 76.5289 130.845 76.0339Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M88.4139 124.741V118.765H90.8043V126.227C90.8043 126.726 90.3994 127.131 89.8998 127.131H84.8282C84.1681 127.131 83.633 126.596 83.633 125.936C83.633 125.276 84.1681 124.741 84.8282 124.741H88.4139Z",
        fill: "#404064"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M93.7927 126.227V118.765H96.1832V124.741H99.7688C100.429 124.741 100.964 125.276 100.964 125.936C100.964 126.596 100.429 127.131 99.7688 127.131H94.6972C94.1977 127.131 93.7927 126.726 93.7927 126.227Z",
        fill: "#404064"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.637 99.0425V102.031L140.204 106.354C140.676 106.624 141.271 106.545 141.655 106.16L151.761 96.0544H148.175L140.871 103.651C140.774 103.752 140.62 103.773 140.5 103.702L132.637 99.0425Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M145.187 94.8594C145.187 94.1993 145.722 93.6642 146.382 93.6642H155.944C156.604 93.6642 157.139 94.1993 157.139 94.8594C157.139 95.5195 156.604 96.0546 155.944 96.0546H146.382C145.722 96.0546 145.187 95.5195 145.187 94.8594Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M51.9593 102.031V99.0426L41.5712 106.957C40.7439 107.588 41.0607 108.901 42.0844 109.084L62.7163 112.788V110.397L44.7879 107.409L51.9593 102.031Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M65.7042 107.409H66.8995C67.5596 107.409 68.0947 107.944 68.0947 108.604C68.0947 109.265 67.5596 109.8 66.8995 109.8H66.3018C65.3117 109.8 64.509 110.602 64.509 111.592C64.509 112.583 65.3117 113.385 66.3018 113.385H68.6923C69.3524 113.385 69.8875 113.92 69.8875 114.581C69.8875 115.241 69.3524 115.776 68.6923 115.776H65.7042C63.7239 115.776 62.1186 114.17 62.1186 112.19V110.995C62.1186 109.015 63.7239 107.409 65.7042 107.409Z",
        fill: "#6145F7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M140.406 84.1037C140.406 81.7933 142.279 79.9204 144.59 79.9204H157.737C160.048 79.9204 161.921 81.7933 161.921 84.1037V90.0798C161.921 90.7399 161.385 91.275 160.725 91.275H141.602C140.942 91.275 140.406 90.7399 140.406 90.0798V84.1037Z",
        fill: "#E5E7EC"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M157.737 81.1156H144.59C142.94 81.1156 141.602 82.4534 141.602 84.1037V90.0798H160.725V84.1037C160.725 82.4534 159.387 81.1156 157.737 81.1156ZM144.59 79.9204C142.279 79.9204 140.406 81.7933 140.406 84.1037V90.0798C140.406 90.7399 140.942 91.275 141.602 91.275H160.725C161.385 91.275 161.921 90.7399 161.921 90.0798V84.1037C161.921 81.7933 160.048 79.9204 157.737 79.9204H144.59Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M143.992 84.1035C143.992 83.7734 144.259 83.5059 144.589 83.5059H157.737C158.067 83.5059 158.334 83.7734 158.334 84.1035C158.334 84.4335 158.067 84.7011 157.737 84.7011H144.589C144.259 84.7011 143.992 84.4335 143.992 84.1035Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M145.188 73.9442V84.7012H157.14V76.9322H160.128C160.458 76.9322 160.725 76.6647 160.725 76.3346V73.9442C160.725 72.6239 159.655 71.5537 158.335 71.5537H147.578C146.258 71.5537 145.188 72.6239 145.188 73.9442Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M157.14 76.9322H160.128C160.458 76.9322 160.725 76.6647 160.725 76.3346V73.9442C160.725 72.6239 159.655 71.5537 158.335 71.5537H147.578C146.258 71.5537 145.188 72.6239 145.188 73.9442V84.7012H157.14V76.9322ZM155.945 83.5059V75.737H159.53V73.9442C159.53 73.2841 158.995 72.7489 158.335 72.7489H147.578C146.918 72.7489 146.383 73.2841 146.383 73.9442V83.5059H155.945Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M155.944 73.9442C155.944 72.6239 157.015 71.5537 158.335 71.5537L-nan -nanL158.335 71.5537C159.655 71.5537 160.725 72.6239 160.725 73.9442V76.3346C160.725 76.6647 160.458 76.9322 160.128 76.9322H155.944V73.9442Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M159.53 75.737V73.9442C159.53 73.2841 158.995 72.7489 158.335 72.7489C157.675 72.7489 157.14 73.2841 157.14 73.9442V75.737H159.53ZM158.335 71.5537C157.015 71.5537 155.944 72.6239 155.944 73.9442V76.9322H160.128C160.458 76.9322 160.725 76.6647 160.725 76.3346V73.9442C160.725 72.6239 159.655 71.5537 158.335 71.5537Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M148.175 75.4378C148.175 75.2728 148.309 75.139 148.474 75.139H153.853C154.018 75.139 154.151 75.2728 154.151 75.4378V76.0355C154.151 76.2005 154.018 76.3343 153.853 76.3343H148.474C148.309 76.3343 148.175 76.2005 148.175 76.0355V75.4378Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M148.175 77.8281C148.175 77.6631 148.309 77.5293 148.474 77.5293H152.657C152.822 77.5293 152.956 77.6631 152.956 77.8281V78.4257C152.956 78.5907 152.822 78.7245 152.657 78.7245H148.474C148.309 78.7245 148.175 78.5907 148.175 78.4257V77.8281Z",
        fill: "#292A33"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M148.175 80.2192C148.175 80.0542 148.309 79.9204 148.474 79.9204H153.853C154.018 79.9204 154.151 80.0542 154.151 80.2192V80.8168C154.151 80.9819 154.018 81.1156 153.853 81.1156H148.474C148.309 81.1156 148.175 80.9819 148.175 80.8168V80.2192Z",
        fill: "#292A33"
    })));
};
// When ariaHidden is true, aria-hidden="true" is added to the SVG, which tells
// screen readers to skip this element. Use this when the icon is purely decorative
// and adjacent text already conveys its meaning (e.g. an icon inside a labeled nav link).
var FindIconSmall = function FindIconSmall(_ref) {
    var themeValues = _ref.themeValues, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex, _ref$ariaHidden = _ref.ariaHidden, ariaHidden = _ref$ariaHidden === void 0 ? true : _ref$ariaHidden;
    var maskId = "find-icon-mask-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": ariaHidden ? "true" : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4142 4.34313C13.1295 6.05839 13.338 8.70983 12.0397 10.6527L15.9968 14.6098C16.1921 14.805 16.1921 15.1216 15.9968 15.3169L15.4665 15.8472C15.2712 16.0425 14.9546 16.0425 14.7594 15.8472L10.8287 11.9165C8.87269 13.3493 6.1108 13.1818 4.34315 11.4142C2.39053 9.46157 2.39053 6.29575 4.34315 4.34313C6.29577 2.39051 9.4616 2.39051 11.4142 4.34313ZM10.4246 10.4246C11.7915 9.05777 11.7915 6.84169 10.4246 5.47486C9.05779 4.10802 6.84171 4.10802 5.47488 5.47486C4.10804 6.84169 4.10804 9.05777 5.47488 10.4246C6.84171 11.7914 9.05779 11.7914 10.4246 10.4246Z",
        fill: themeValues.singleIconColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: maskId,
        style: {
            maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "2",
        y: "2",
        width: "15",
        height: "14"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4142 4.34313C13.1295 6.05839 13.338 8.70983 12.0397 10.6527L15.9968 14.6098C16.1921 14.805 16.1921 15.1216 15.9968 15.3169L15.4665 15.8472C15.2712 16.0425 14.9546 16.0425 14.7594 15.8472L10.8287 11.9165C8.87269 13.3493 6.1108 13.1818 4.34315 11.4142C2.39053 9.46157 2.39053 6.29575 4.34315 4.34313C6.29577 2.39051 9.4616 2.39051 11.4142 4.34313ZM10.4246 10.4246C11.7915 9.05777 11.7915 6.84169 10.4246 5.47486C9.05779 4.10802 6.84171 4.10802 5.47488 5.47486C4.10804 6.84169 4.10804 9.05777 5.47488 10.4246C6.84171 11.7914 9.05779 11.7914 10.4246 10.4246Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(maskId, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "20",
        height: "20",
        fill: themeValues.singleIconColor
    })));
};
var FindIconSmall$1 = themeComponent(FindIconSmall, "Icons", fallbackValues$b, "primary");
// When ariaHidden is true, aria-hidden="true" is added to the SVG, which tells
// screen readers to skip this element. Use this when the icon is purely decorative
// and adjacent text already conveys its meaning (e.g. an icon inside a labeled nav link).
var HistoryIconSmall = function HistoryIconSmall(_ref) {
    var themeValues = _ref.themeValues, _ref$ariaHidden = _ref.ariaHidden, ariaHidden = _ref$ariaHidden === void 0 ? true : _ref$ariaHidden;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": ariaHidden ? "true" : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M3.33337 8.33333C3.33337 7.8731 3.70647 7.5 4.16671 7.5H15.8334C16.2936 7.5 16.6667 7.8731 16.6667 8.33333V16.6667C16.6667 17.1269 16.2936 17.5 15.8334 17.5H4.16671C3.70647 17.5 3.33337 17.1269 3.33337 16.6667V8.33333Z",
        fill: themeValues.singleIconColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.08337 4.75C4.66916 4.75 4.33337 5.08579 4.33337 5.5C4.33337 5.91421 4.66916 6.25 5.08337 6.25H14.9134C15.3276 6.25 15.6634 5.91421 15.6634 5.5C15.6634 5.08579 15.3276 4.75 14.9134 4.75H5.08337Z",
        fill: themeValues.singleIconColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.03337 2.25C5.64677 2.25 5.33337 2.5634 5.33337 2.95C5.33337 3.3366 5.64678 3.65 6.03337 3.65H13.9634C14.35 3.65 14.6634 3.3366 14.6634 2.95C14.6634 2.5634 14.35 2.25 13.9634 2.25H6.03337Z",
        fill: themeValues.singleIconColor
    }));
};
var HistoryIconSmall$1 = themeComponent(HistoryIconSmall, "Icons", fallbackValues$b, "primary");
var ChargebackIconSmall = function ChargebackIconSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "ChargebackIconSmall-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "2",
        y: "5",
        width: "15",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.6667 6.83325C6.6667 6.28097 7.11441 5.83325 7.6667 5.83325H15.6667C16.219 5.83325 16.6667 6.28097 16.6667 6.83325V8.33325V9.99992V13.1666C16.6667 13.7189 16.219 14.1666 15.6667 14.1666H7.6667C7.11441 14.1666 6.6667 13.7189 6.6667 13.1666V9.99992V8.33325V6.83325ZM16.0417 6.5277V8.33325H7.2917V8.26381V6.5277H16.0417ZM7.2917 13.4721V9.99992H16.0417V13.4721H7.2917ZM4.8275 8.70703C4.8275 8.26157 4.28893 8.03849 3.97395 8.35347L2.68105 9.64636C2.48579 9.84163 2.48579 10.1582 2.68105 10.3535L3.97395 11.6464C4.28893 11.9613 4.8275 11.7383 4.8275 11.2928V8.70703ZM13.4896 11.6666C13.2595 11.6666 13.0729 11.8531 13.0729 12.0833C13.0729 12.3134 13.2595 12.4999 13.4896 12.4999H14.5313C14.7614 12.4999 14.9479 12.3134 14.9479 12.0833C14.9479 11.8531 14.7614 11.6666 14.5313 11.6666H13.4896Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "2.5",
        y: "2.5",
        width: "15",
        height: "15",
        fill: "white"
    })));
};
var ChargebackReversalIconSmall = function ChargebackReversalIconSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "ChargebackReversalIconSmall-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "4",
        y: "5",
        width: "14",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.16669 6.83325C4.16669 6.28097 4.6144 5.83325 5.16669 5.83325H13.1667C13.719 5.83325 14.1667 6.28097 14.1667 6.83325V8.33325V9.99992V13.1666C14.1667 13.7189 13.719 14.1666 13.1667 14.1666H5.16669C4.6144 14.1666 4.16669 13.7189 4.16669 13.1666V9.99992V8.33325V6.83325ZM13.5417 6.5277V8.33325H4.79169V8.26381V6.5277H13.5417ZM4.79169 13.4721V9.99992H13.5417V13.4721H4.79169ZM15 11.2928C15 11.7383 15.5386 11.9613 15.8536 11.6464L17.1465 10.3535C17.3417 10.1582 17.3417 9.84163 17.1465 9.64636L15.8536 8.35347C15.5386 8.03849 15 8.26157 15 8.70703V11.2928ZM10.9896 11.6666C10.7595 11.6666 10.5729 11.8531 10.5729 12.0833C10.5729 12.3134 10.7595 12.4999 10.9896 12.4999H12.0313C12.2614 12.4999 12.4479 12.3134 12.4479 12.0833C12.4479 11.8531 12.2614 11.6666 12.0313 11.6666H10.9896Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "2.5",
        y: "2.5",
        width: "15",
        height: "15",
        fill: "white"
    })));
};
var RefundIconSmall = function RefundIconSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "RefundIconSmall-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5812 14.0293V15H11.1768V14.0347C9.64976 13.8666 8.66331 13.1291 8.51283 11.757L10.2071 11.7245C10.3798 12.4403 11.004 12.82 11.8957 12.82C12.6983 12.82 13.2723 12.4024 13.2723 11.8438C13.2723 11.2636 12.8989 11.0249 12.1131 10.8514L10.7923 10.5748C9.56059 10.3308 8.7692 9.63124 8.75248 8.42733C8.74133 7.14751 9.76679 6.28525 11.2047 6.07375V5H12.6147V6.07918C14.0191 6.31779 14.8718 7.25054 14.8551 8.3731L13.211 8.40022C13.1107 7.70607 12.7875 7.28308 11.9292 7.28308C11.043 7.28308 10.4969 7.67354 10.4969 8.24295C10.4969 8.69848 10.7532 8.92625 11.6282 9.14859L12.9268 9.4577C14.3925 9.79935 15 10.6562 15 11.833C15 13.0152 14.0693 13.8395 12.5812 14.0293ZM7.5 11.3438C7.5 11.7558 7.02962 11.991 6.7 11.7438L4.7 10.2438C4.43333 10.0438 4.43333 9.64375 4.7 9.44375L6.7 7.94375C7.02962 7.69654 7.5 7.93173 7.5 8.34375V11.3438Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "4",
        y: "5",
        width: "11",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5812 14.0293V15H11.1768V14.0347C9.64976 13.8666 8.66331 13.1291 8.51283 11.757L10.2071 11.7245C10.3798 12.4403 11.004 12.82 11.8957 12.82C12.6983 12.82 13.2723 12.4024 13.2723 11.8438C13.2723 11.2636 12.8989 11.0249 12.1131 10.8514L10.7923 10.5748C9.56059 10.3308 8.7692 9.63124 8.75248 8.42733C8.74133 7.14751 9.76679 6.28525 11.2047 6.07375V5H12.6147V6.07918C14.0191 6.31779 14.8718 7.25054 14.8551 8.3731L13.211 8.40022C13.1107 7.70607 12.7875 7.28308 11.9292 7.28308C11.043 7.28308 10.4969 7.67354 10.4969 8.24295C10.4969 8.69848 10.7532 8.92625 11.6282 9.14859L12.9268 9.4577C14.3925 9.79935 15 10.6562 15 11.833C15 13.0152 14.0693 13.8395 12.5812 14.0293ZM7.5 11.3438C7.5 11.7558 7.02962 11.991 6.7 11.7438L4.7 10.2438C4.43333 10.0438 4.43333 9.64375 4.7 9.44375L6.7 7.94375C7.02962 7.69654 7.5 7.93173 7.5 8.34375V11.3438Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "2.5",
        y: "2.5",
        width: "15",
        height: "15",
        fill: "white"
    })));
};
var XCircleIconSmall = function XCircleIconSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#D11053" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "XCircleIconSmall-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10.5",
        cy: "10",
        r: "10",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8298 6.18691C13.6345 5.99165 13.3179 5.99165 13.1227 6.18691L10.5 8.80955L7.87739 6.18691C7.68213 5.99165 7.36554 5.99165 7.17028 6.18691L6.68691 6.67028C6.49165 6.86554 6.49165 7.18213 6.68691 7.37739L9.30955 10L6.68691 12.6227C6.49165 12.8179 6.49165 13.1345 6.68691 13.3298L7.17028 13.8131C7.36554 14.0084 7.68213 14.0084 7.87739 13.8131L10.5 11.1905L13.1227 13.8131C13.3179 14.0084 13.6345 14.0084 13.8298 13.8131L14.3131 13.3298C14.5084 13.1345 14.5084 12.8179 14.3131 12.6227L11.6905 10L14.3131 7.37739C14.5084 7.18213 14.5084 6.86554 14.3131 6.67028L13.8298 6.18691Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "6",
        y: "6",
        width: "9",
        height: "8"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8298 6.18691C13.6345 5.99165 13.3179 5.99165 13.1227 6.18691L10.5 8.80955L7.87739 6.18691C7.68213 5.99165 7.36554 5.99165 7.17028 6.18691L6.68691 6.67028C6.49165 6.86554 6.49165 7.18213 6.68691 7.37739L9.30955 10L6.68691 12.6227C6.49165 12.8179 6.49165 13.1345 6.68691 13.3298L7.17028 13.8131C7.36554 14.0084 7.68213 14.0084 7.87739 13.8131L10.5 11.1905L13.1227 13.8131C13.3179 14.0084 13.6345 14.0084 13.8298 13.8131L14.3131 13.3298C14.5084 13.1345 14.5084 12.8179 14.3131 12.6227L11.6905 10L14.3131 7.37739C14.5084 7.18213 14.5084 6.86554 14.3131 6.67028L13.8298 6.18691Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0.5 0H20.5V20H0.5V0Z",
        fill: "white"
    })));
};
var SuccessfulIconSmall = function SuccessfulIconSmall(_ref) {
    var _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var mask0ID = "SuccessfulIconSmall-mask0-".concat(iconIndex);
    var mask1ID = "SuccessfulIconSmall-mask1-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: "#317D4F"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: mask0ID,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(mask0ID, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.7817 6.18688C14.5864 5.99162 14.2698 5.99162 14.0746 6.18688L8.53558 11.7259L6.53211 9.72242C6.33685 9.52715 6.02027 9.52715 5.825 9.72242L5.3536 10.1938C5.15834 10.3891 5.15834 10.7057 5.3536 10.9009L7.71062 13.2579L8.18203 13.7294C8.37729 13.9246 8.69387 13.9246 8.88913 13.7294L9.36054 13.258C9.36068 13.2578 9.36082 13.2577 9.36096 13.2575L15.2531 7.36539C15.4484 7.17013 15.4484 6.85355 15.2531 6.65829L14.7817 6.18688Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: mask1ID,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "5",
        y: "6",
        width: "11",
        height: "8"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.7817 6.18688C14.5864 5.99162 14.2698 5.99162 14.0746 6.18688L8.53558 11.7259L6.53211 9.72242C6.33685 9.52715 6.02027 9.52715 5.825 9.72242L5.3536 10.1938C5.15834 10.3891 5.15834 10.7057 5.3536 10.9009L7.71062 13.2579L8.18203 13.7294C8.37729 13.9246 8.69387 13.9246 8.88913 13.7294L9.36054 13.258C9.36068 13.2578 9.36082 13.2577 9.36096 13.2575L15.2531 7.36539C15.4484 7.17013 15.4484 6.85355 15.2531 6.65829L14.7817 6.18688Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(mask1ID, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "1.66669",
        y: "1.66666",
        width: "16.6667",
        height: "16.6667",
        fill: "white"
    }))));
};
var ArrowLeftCircleIconSmall = function ArrowLeftCircleIconSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "ArrowLeftCircleIconSmall-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.528 14.472C10.7232 14.2768 10.7233 13.9605 10.5283 13.7652L7.39375 10.625H14.5C14.7761 10.625 15 10.4011 15 10.125V9.875C15 9.59886 14.7761 9.375 14.5 9.375H7.39375L10.5283 6.2348C10.7233 6.03949 10.7232 5.72315 10.528 5.52801L10.3536 5.35355C10.1583 5.15829 9.84171 5.15829 9.64645 5.35355L5.35355 9.64645C5.15829 9.84171 5.15829 10.1583 5.35355 10.3536L9.64645 14.6464C9.84171 14.8417 10.1583 14.8417 10.3536 14.6464L10.528 14.472Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "5",
        y: "5",
        width: "10",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.528 14.472C10.7232 14.2768 10.7233 13.9605 10.5283 13.7652L7.39375 10.625H14.5C14.7761 10.625 15 10.4011 15 10.125V9.875C15 9.59886 14.7761 9.375 14.5 9.375H7.39375L10.5283 6.2348C10.7233 6.03949 10.7232 5.72315 10.528 5.52801L10.3536 5.35355C10.1583 5.15829 9.84171 5.15829 9.64645 5.35355L5.35355 9.64645C5.15829 9.84171 5.15829 10.1583 5.35355 10.3536L9.64645 14.6464C9.84171 14.8417 10.1583 14.8417 10.3536 14.6464L10.528 14.472Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "17.5",
        y: "17.5",
        width: "15",
        height: "15",
        transform: "rotate(180 17.5 17.5)",
        fill: "white"
    })));
};
var ArrowRightCircleIconSmall = function ArrowRightCircleIconSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "ArrowRightCircleIconSmall-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.47199 5.52801C9.27685 5.72315 9.27671 6.03949 9.47167 6.2348L12.6062 9.375H5.5C5.22386 9.375 5 9.59886 5 9.875V10.125C5 10.4011 5.22386 10.625 5.5 10.625H12.6062L9.47167 13.7652C9.27671 13.9605 9.27685 14.2768 9.47199 14.472L9.64645 14.6464C9.84171 14.8417 10.1583 14.8417 10.3536 14.6464L14.6464 10.3536C14.8417 10.1583 14.8417 9.84171 14.6464 9.64645L10.3536 5.35355C10.1583 5.15829 9.84171 5.15829 9.64645 5.35355L9.47199 5.52801Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "5",
        y: "5",
        width: "10",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.47199 5.52801C9.27685 5.72315 9.27671 6.03949 9.47167 6.2348L12.6062 9.375H5.5C5.22386 9.375 5 9.59886 5 9.875V10.125C5 10.4011 5.22386 10.625 5.5 10.625H12.6062L9.47167 13.7652C9.27671 13.9605 9.27685 14.2768 9.47199 14.472L9.64645 14.6464C9.84171 14.8417 10.1583 14.8417 10.3536 14.6464L14.6464 10.3536C14.8417 10.1583 14.8417 9.84171 14.6464 9.64645L10.3536 5.35355C10.1583 5.15829 9.84171 5.15829 9.64645 5.35355L9.47199 5.52801Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "2.5",
        y: "2.5",
        width: "15",
        height: "15",
        fill: "white"
    })));
};
var ArrowRightIcon = function ArrowRightIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? ROYAL_BLUE_VIVID : _ref$color, _ref$labelledBy = _ref.labelledBy, labelledBy = _ref$labelledBy === void 0 ? "" : _ref$labelledBy;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-labelledby": labelledBy
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.17828 4.15501C8.98314 4.35015 8.983 4.66649 9.17796 4.8618L13.475 9.16659H3.83337C3.55723 9.16659 3.33337 9.39044 3.33337 9.66659V10.3333C3.33337 10.6094 3.55723 10.8333 3.83337 10.8333H13.475L9.17796 15.138C8.983 15.3333 8.98314 15.6497 9.17828 15.8448L9.64649 16.313C9.84175 16.5083 10.1583 16.5083 10.3536 16.313L16.3132 10.3535C16.5084 10.1582 16.5084 9.84163 16.3132 9.64637L10.3536 3.6868C10.1583 3.49154 9.84175 3.49154 9.64649 3.68681L9.17828 4.15501Z",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_6329_1483",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "3",
        width: "14",
        height: "14"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.17828 4.15501C8.98314 4.35015 8.983 4.66649 9.17796 4.8618L13.475 9.16659H3.83337C3.55723 9.16659 3.33337 9.39044 3.33337 9.66659V10.3333C3.33337 10.6094 3.55723 10.8333 3.83337 10.8333H13.475L9.17796 15.138C8.983 15.3333 8.98314 15.6497 9.17828 15.8448L9.64649 16.313C9.84175 16.5083 10.1583 16.5083 10.3536 16.313L16.3132 10.3535C16.5084 10.1582 16.5084 9.84163 16.3132 9.64637L10.3536 3.6868C10.1583 3.49154 9.84175 3.49154 9.64649 3.68681L9.17828 4.15501Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_6329_1483)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "20",
        height: "20",
        fill: color
    })));
};
var ArrowUpCircleIconSmall = function ArrowUpCircleIconSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "ArrowUpCircleIconSmall-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.52801 10.528C5.72315 10.7232 6.03949 10.7233 6.2348 10.5283L9.375 7.39375L9.375 14.5C9.375 14.7761 9.59886 15 9.875 15H10.125C10.4011 15 10.625 14.7761 10.625 14.5L10.625 7.39375L13.7652 10.5283C13.9605 10.7233 14.2768 10.7232 14.472 10.528L14.6464 10.3536C14.8417 10.1583 14.8417 9.84171 14.6464 9.64645L10.3536 5.35355C10.1583 5.15829 9.84171 5.15829 9.64645 5.35355L5.35355 9.64645C5.15829 9.84171 5.15829 10.1583 5.35355 10.3536L5.52801 10.528Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "5",
        y: "5",
        width: "10",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.52801 10.528C5.72315 10.7232 6.03949 10.7233 6.2348 10.5283L9.375 7.39375L9.375 14.5C9.375 14.7761 9.59886 15 9.875 15H10.125C10.4011 15 10.625 14.7761 10.625 14.5L10.625 7.39375L13.7652 10.5283C13.9605 10.7233 14.2768 10.7232 14.472 10.528L14.6464 10.3536C14.8417 10.1583 14.8417 9.84171 14.6464 9.64645L10.3536 5.35355C10.1583 5.15829 9.84171 5.15829 9.64645 5.35355L5.35355 9.64645C5.15829 9.84171 5.15829 10.1583 5.35355 10.3536L5.52801 10.528Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "2.5",
        y: "17.5",
        width: "15",
        height: "15",
        transform: "rotate(-90 2.5 17.5)",
        fill: "white"
    })));
};
var ArrowDownCircleIconSmall = function ArrowDownCircleIconSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "ArrowDownCircleIconSmall-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "10",
        cy: "10",
        r: "10",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.6696 9.47199C14.4745 9.27685 14.1581 9.27671 13.9628 9.47167L10.8226 12.6062V5.5C10.8226 5.22386 10.5988 5 10.3226 5H10.0726C9.79649 5 9.57263 5.22386 9.57263 5.5V12.6062L6.43244 9.47167C6.23712 9.27671 5.92078 9.27685 5.72564 9.47199L5.55119 9.64645C5.35592 9.84171 5.35592 10.1583 5.55119 10.3536L9.84408 14.6464C10.0393 14.8417 10.3559 14.8417 10.5512 14.6464L14.8441 10.3536C15.0393 10.1583 15.0393 9.84171 14.8441 9.64645L14.6696 9.47199Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "5",
        y: "5",
        width: "10",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.6696 9.47199C14.4745 9.27685 14.1581 9.27671 13.9628 9.47167L10.8226 12.6062V5.5C10.8226 5.22386 10.5988 5 10.3226 5H10.0726C9.79649 5 9.57263 5.22386 9.57263 5.5V12.6062L6.43244 9.47167C6.23712 9.27671 5.92078 9.27685 5.72564 9.47199L5.55119 9.64645C5.35592 9.84171 5.35592 10.1583 5.55119 10.3536L9.84408 14.6464C10.0393 14.8417 10.3559 14.8417 10.5512 14.6464L14.8441 10.3536C15.0393 10.1583 15.0393 9.84171 14.8441 9.64645L14.6696 9.47199Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "17.6976",
        y: "2.5",
        width: "15",
        height: "15",
        transform: "rotate(90 17.6976 2.5)",
        fill: "white"
    })));
};
var SuccessfulIconMedium = function SuccessfulIconMedium(_ref) {
    var _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? SEA_GREEN : _ref$fill;
    var mask0ID = "SuccessfulIconMedium-mask0-".concat(iconIndex);
    var mask1ID = "SuccessfulIconMedium-mask1-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: fill
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: mask0ID,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(mask0ID, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.6672 7.35354C17.472 7.15828 17.1554 7.15828 16.9601 7.35354L10.2426 14.0711L7.76775 11.5962C7.57249 11.4009 7.25591 11.4009 7.06065 11.5962L6.35354 12.3033C6.15828 12.4985 6.15828 12.8151 6.35354 13.0104L9.18167 15.8385C9.18177 15.8386 9.18187 15.8387 9.18197 15.8388L9.88907 16.5459C10.0843 16.7412 10.4009 16.7412 10.5962 16.5459L11.3033 15.8388C11.3034 15.8387 11.3036 15.8386 11.3037 15.8384L18.3744 8.76775C18.5696 8.57249 18.5696 8.25591 18.3744 8.06065L17.6672 7.35354Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: mask1ID,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "6",
        y: "7",
        width: "13",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.6672 7.35354C17.472 7.15828 17.1554 7.15828 16.9601 7.35354L10.2426 14.0711L7.76775 11.5962C7.57249 11.4009 7.25591 11.4009 7.06065 11.5962L6.35354 12.3033C6.15828 12.4985 6.15828 12.8151 6.35354 13.0104L9.18167 15.8385C9.18177 15.8386 9.18187 15.8387 9.18197 15.8388L9.88907 16.5459C10.0843 16.7412 10.4009 16.7412 10.5962 16.5459L11.3033 15.8388C11.3034 15.8387 11.3036 15.8386 11.3037 15.8384L18.3744 8.76775C18.5696 8.57249 18.5696 8.25591 18.3744 8.06065L17.6672 7.35354Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(mask1ID, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "2",
        y: "2",
        width: "20",
        height: "20",
        fill: "white"
    }))));
};
var XCircleIconMedium = function XCircleIconMedium(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#D11053" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "XCircleIconMedium-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.35355 8.07502C7.15829 8.27028 7.15829 8.58686 7.35355 8.78212L10.5714 12L7.35355 15.2179C7.15829 15.4131 7.15829 15.7297 7.35355 15.925L8.07502 16.6464C8.27028 16.8417 8.58686 16.8417 8.78212 16.6464L12 13.4286L15.2179 16.6464C15.4131 16.8417 15.7297 16.8417 15.925 16.6464L16.6464 15.925C16.8417 15.7297 16.8417 15.4131 16.6464 15.2179L13.4286 12L16.6464 8.78212C16.8417 8.58686 16.8417 8.27028 16.6464 8.07502L15.925 7.35355C15.7297 7.15829 15.4131 7.15829 15.2179 7.35355L12 10.5714L8.78212 7.35355C8.58686 7.15829 8.27028 7.15829 8.07502 7.35355L7.35355 8.07502Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "7",
        y: "7",
        width: "10",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.35355 8.07502C7.15829 8.27028 7.15829 8.58686 7.35355 8.78212L10.5714 12L7.35355 15.2179C7.15829 15.4131 7.15829 15.7297 7.35355 15.925L8.07502 16.6464C8.27028 16.8417 8.58686 16.8417 8.78212 16.6464L12 13.4286L15.2179 16.6464C15.4131 16.8417 15.7297 16.8417 15.925 16.6464L16.6464 15.925C16.8417 15.7297 16.8417 15.4131 16.6464 15.2179L13.4286 12L16.6464 8.78212C16.8417 8.58686 16.8417 8.27028 16.6464 8.07502L15.925 7.35355C15.7297 7.15829 15.4131 7.15829 15.2179 7.35355L12 10.5714L8.78212 7.35355C8.58686 7.15829 8.27028 7.15829 8.07502 7.35355L7.35355 8.07502Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 0H24V24H0V0Z",
        fill: "white"
    })));
};
var RefundIconMedium = function RefundIconMedium(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "RefundIconMedium-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0975 16.8351V18H13.4122V16.8416C11.5797 16.6399 10.396 15.7549 10.2154 14.1085L12.2485 14.0694C12.4558 14.9284 13.2049 15.3839 14.2749 15.3839C15.2379 15.3839 15.9268 14.8829 15.9268 14.2126C15.9268 13.5163 15.4787 13.2299 14.5357 13.0217L12.9507 12.6898C11.4727 12.397 10.523 11.5575 10.503 10.1128C10.4896 8.57701 11.7202 7.5423 13.4456 7.2885V6H15.1376V7.29501C16.823 7.58134 17.8462 8.70065 17.8261 10.0477L15.8532 10.0803C15.7328 9.24729 15.345 8.7397 14.315 8.7397C13.2517 8.7397 12.5963 9.20824 12.5963 9.89154C12.5963 10.4382 12.9039 10.7115 13.9539 10.9783L15.5121 11.3492C17.271 11.7592 18 12.7874 18 14.1996C18 15.6182 16.8831 16.6074 15.0975 16.8351ZM9.00001 13.8125C9.00001 14.2245 8.52963 14.4597 8.20001 14.2125L5.53334 12.2125C5.26668 12.0125 5.26668 11.6125 5.53334 11.4125L8.20001 9.4125C8.52963 9.16529 9.00001 9.40048 9.00001 9.8125V13.8125Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "5",
        y: "6",
        width: "13",
        height: "12"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0975 16.8351V18H13.4122V16.8416C11.5797 16.6399 10.396 15.7549 10.2154 14.1085L12.2485 14.0694C12.4558 14.9284 13.2049 15.3839 14.2749 15.3839C15.2379 15.3839 15.9268 14.8829 15.9268 14.2126C15.9268 13.5163 15.4787 13.2299 14.5357 13.0217L12.9507 12.6898C11.4727 12.397 10.523 11.5575 10.503 10.1128C10.4896 8.57701 11.7202 7.5423 13.4456 7.2885V6H15.1376V7.29501C16.823 7.58134 17.8462 8.70065 17.8261 10.0477L15.8532 10.0803C15.7328 9.24729 15.345 8.7397 14.315 8.7397C13.2517 8.7397 12.5963 9.20824 12.5963 9.89154C12.5963 10.4382 12.9039 10.7115 13.9539 10.9783L15.5121 11.3492C17.271 11.7592 18 12.7874 18 14.1996C18 15.6182 16.8831 16.6074 15.0975 16.8351ZM9.00001 13.8125C9.00001 14.2245 8.52963 14.4597 8.20001 14.2125L5.53334 12.2125C5.26668 12.0125 5.26668 11.6125 5.53334 11.4125L8.20001 9.4125C8.52963 9.16529 9.00001 9.40048 9.00001 9.8125V13.8125Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        fill: "white"
    })));
};
var ArrowLeftCircleIconMedium = function ArrowLeftCircleIconMedium(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "ArrowLeftCircleIconMedium-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.7043 17.2957C12.8994 17.1006 12.8995 16.7843 12.7046 16.5889L8.8725 12.75H17.5C17.7761 12.75 18 12.5261 18 12.25V11.75C18 11.4739 17.7761 11.25 17.5 11.25H8.8725L12.7046 7.41105C12.8995 7.21574 12.8994 6.8994 12.7043 6.70426L12.3536 6.35355C12.1583 6.15829 11.8417 6.15829 11.6464 6.35355L6.35355 11.6464C6.15829 11.8417 6.15829 12.1583 6.35355 12.3536L11.6464 17.6464C11.8417 17.8417 12.1583 17.8417 12.3536 17.6464L12.7043 17.2957Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "6",
        y: "6",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.7043 17.2957C12.8994 17.1006 12.8995 16.7843 12.7046 16.5889L8.8725 12.75H17.5C17.7761 12.75 18 12.5261 18 12.25V11.75C18 11.4739 17.7761 11.25 17.5 11.25H8.8725L12.7046 7.41105C12.8995 7.21574 12.8994 6.8994 12.7043 6.70426L12.3536 6.35355C12.1583 6.15829 11.8417 6.15829 11.6464 6.35355L6.35355 11.6464C6.15829 11.8417 6.15829 12.1583 6.35355 12.3536L11.6464 17.6464C11.8417 17.8417 12.1583 17.8417 12.3536 17.6464L12.7043 17.2957Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "21",
        y: "21",
        width: "18",
        height: "18",
        transform: "rotate(180 21 21)",
        fill: "white"
    })));
};
var ChargebackIconMedium = function ChargebackIconMedium(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "ChargebackIconMedium-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "7",
        width: "17",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.99999 8C7.99999 7.44772 8.4477 7 8.99999 7H19C19.5523 7 20 7.44772 20 8V10V12V16C20 16.5523 19.5523 17 19 17H8.99999C8.4477 17 7.99999 16.5523 7.99999 16V12V10V8ZM19.25 7.83333V10H8.74999V9.91667V7.83333H19.25ZM8.74999 16.1667V12H19.25V16.1667H8.74999ZM5.79295 10.2071C5.79295 9.76165 5.25438 9.53857 4.9394 9.85355L3.14651 11.6464C2.95125 11.8417 2.95125 12.1583 3.14651 12.3536L4.9394 14.1464C5.25438 14.4614 5.79295 14.2383 5.79295 13.7929V10.2071ZM16.1875 14C15.9113 14 15.6875 14.2239 15.6875 14.5C15.6875 14.7761 15.9113 15 16.1875 15H17.4375C17.7136 15 17.9375 14.7761 17.9375 14.5C17.9375 14.2239 17.7136 14 17.4375 14H16.1875Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        fill: "white"
    })));
};
var ChargebackReversalIconMedium = function ChargebackReversalIconMedium(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#15749D" : _ref$color, _ref$iconIndex = _ref.iconIndex, iconIndex = _ref$iconIndex === void 0 ? 0 : _ref$iconIndex;
    var id = "ChargebackReversalIconMedium-".concat(iconIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: id,
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "5",
        y: "7",
        width: "16",
        height: "10"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 8C5 7.44772 5.44772 7 6 7H16C16.5523 7 17 7.44772 17 8V10V12V16C17 16.5523 16.5523 17 16 17H6C5.44772 17 5 16.5523 5 16V12V10V8ZM16.25 7.83333V10H5.75V9.91667V7.83333H16.25ZM5.75 16.1667V12H16.25V16.1667H5.75ZM18 13.7929C18 14.2383 18.5386 14.4614 18.8536 14.1464L20.6464 12.3536C20.8417 12.1583 20.8417 11.8417 20.6464 11.6464L18.8536 9.85355C18.5386 9.53857 18 9.76165 18 10.2071V13.7929ZM13.1875 14C12.9114 14 12.6875 14.2239 12.6875 14.5C12.6875 14.7761 12.9114 15 13.1875 15H14.4375C14.7136 15 14.9375 14.7761 14.9375 14.5C14.9375 14.2239 14.7136 14 14.4375 14H13.1875Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#".concat(id, ")")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        fill: "white"
    })));
};
var PlusCircleIcon = function PlusCircleIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? ROYAL_BLUE_VIVID : _ref$color, _ref$labelledBy = _ref.labelledBy, labelledBy = _ref$labelledBy === void 0 ? "" : _ref$labelledBy;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        "aria-labelledby": labelledBy
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25ZM2.75 10C2.75 5.99594 5.99594 2.75 10 2.75C14.0041 2.75 17.25 5.99594 17.25 10C17.25 14.0041 14.0041 17.25 10 17.25C5.99594 17.25 2.75 14.0041 2.75 10ZM10.75 9.25V5.25H9.25V9.25H5.25V10.75H9.25V14.75H10.75V10.75H14.75V9.25H10.75Z",
        fill: color
    }));
};
var KebabMenuIcon = function KebabMenuIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "32",
        viewBox: "0 0 21 32",
        fill: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 4C0 1.79086 1.79086 0 4 0L17 0C19.2091 0 21 1.79086 21 4V28C21 30.2091 19.2091 32 17 32H4C1.79086 32 0 30.2091 0 28L0 4Z",
        fill: "none"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 6C9.39333 6 8.5 6.89333 8.5 8C8.5 9.10667 9.39333 10 10.5 10C11.6067 10 12.5 9.10667 12.5 8C12.5 6.89333 11.6067 6 10.5 6Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 14C9.39333 14 8.5 14.8933 8.5 16C8.5 17.1067 9.39333 18 10.5 18C11.6067 18 12.5 17.1067 12.5 16C12.5 14.8933 11.6067 14 10.5 14Z",
        fill: "#3B5BDB"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 22C9.39333 22 8.5 22.9067 8.5 24C8.5 25.0933 9.40667 26 10.5 26C11.5933 26 12.5 25.0933 12.5 24C12.5 22.9067 11.6067 22 10.5 22Z",
        fill: "#3B5BDB"
    }));
};
var _excluded$s = [
    "iconFill",
    "iconWidth",
    "iconHeight"
];
var MultiCartIcon = function MultiCartIcon(_ref) {
    var _ref$iconFill = _ref.iconFill, iconFill = _ref$iconFill === void 0 ? "#3B5BDB" : _ref$iconFill, _ref$iconWidth = _ref.iconWidth, iconWidth = _ref$iconWidth === void 0 ? "20" : _ref$iconWidth, _ref$iconHeight = _ref.iconHeight, iconHeight = _ref$iconHeight === void 0 ? "17" : _ref$iconHeight, rest = _objectWithoutProperties(_ref, _excluded$s);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: iconWidth,
        height: iconHeight,
        viewBox: "0 0 24.81 22.06"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, "Icon - Cart-Empty"), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M18.7499553,20.499994 C19.348912,20.499994 19.8632339,20.2851508 20.2929204,19.8554643 C20.7226068,19.4257779 20.9374501,18.911456 20.9374501,18.3124993 C20.9374501,17.8958334 20.8267735,17.5117199 20.6054196,17.1601583 C20.3840658,16.8085966 20.0780771,16.5416703 19.6874531,16.3593789 L19.6874531,16.3593789 L19.9218275,15.3828187 C19.9739105,15.0963613 19.9088069,14.835945 19.7265155,14.6015706 C19.544224,14.3671962 19.3098496,14.2500089 19.0233921,14.2500089 L19.0233921,14.2500089 L8.5156047,14.2500089 L8.28123026,13.0000119 L19.7265155,13.0000119 C19.9348481,13.0000119 20.1236501,12.9349077 20.2929204,12.8046999 C20.4621906,12.6744921 20.5728678,12.4922006 20.6249508,12.2578262 L20.6249508,12.2578262 L22.4608839,4.13284556 C22.5390088,3.84638811 22.4869258,3.58597187 22.3046343,3.35159742 C22.1223429,3.11722298 21.8749478,3.00004172 21.5624486,3.00004172 L21.5624486,3.00004172 L6.21092269,3.00004172 L5.85936103,1.24222745 C5.80727802,1.03389482 5.6966008,0.858113985 5.52733057,0.714884961 C5.35806034,0.571655937 5.16925831,0.500041723 4.96092567,0.500041723 L4.96092567,0.500041723 L0.937497765,0.500041723 C0.67708152,0.500041723 0.455728279,0.591187141 0.273436848,0.773478571 C0.0911454173,0.955770002 0,1.17712324 0,1.43753949 L0,1.43753949 L0,2.062538 C0,2.32295424 0.0911454173,2.54430748 0.273436848,2.72659891 C0.455728279,2.90889035 0.67708152,3.00004172 0.937497765,3.00004172 L0.937497765,3.00004172 L3.67186625,3.00004172 L6.40623473,16.3984413 C6.06769367,16.606774 5.80076742,16.8802108 5.60545539,17.2187519 C5.41014335,17.5572929 5.31248733,17.9218752 5.31248733,18.3124993 C5.31248733,18.911456 5.52733057,19.4257779 5.95701705,19.8554643 C6.38670352,20.2851508 6.90102541,20.499994 7.49998212,20.499994 C8.09893883,20.499994 8.61326071,20.2851508 9.04294719,19.8554643 C9.47263367,19.4257779 9.6874769,18.904946 9.6874769,18.2929681 C9.6874769,17.6809901 9.46612307,17.1666689 9.02341599,16.750003 L9.02341599,16.750003 L17.2265214,16.750003 C16.7838143,17.1666689 16.5624605,17.6809901 16.5624605,18.2929681 C16.5624605,18.904946 16.7773037,19.4257779 17.2069902,19.8554643 C17.6366767,20.2851508 18.1509986,20.499994 18.7499553,20.499994 Z",
        id: "cart-badge-shopping-cart",
        fill: iconFill,
        fillRule: "nonzero"
    }));
};
var _excluded$t = [
    "iconFill",
    "iconWidth",
    "iconHeight"
];
var CloseIcon = function CloseIcon(_ref) {
    var _ref$iconFill = _ref.iconFill, iconFill = _ref$iconFill === void 0 ? "#3B414D" : _ref$iconFill, _ref$iconWidth = _ref.iconWidth, iconWidth = _ref$iconWidth === void 0 ? "24px" : _ref$iconWidth, _ref$iconHeight = _ref.iconHeight, iconHeight = _ref$iconHeight === void 0 ? "24px" : _ref$iconHeight, rest = _objectWithoutProperties(_ref, _excluded$t);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        style: {
            width: iconWidth,
            height: iconHeight
        }
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, "Close Icon"), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.3033 6.48982C17.108 6.29456 16.7915 6.29456 16.5962 6.48982L12 11.086L7.40381 6.48982C7.20854 6.29456 6.89196 6.29456 6.6967 6.48982L5.98959 7.19693C5.79433 7.39219 5.79433 7.70878 5.98959 7.90404L10.5858 12.5002L5.98959 17.0964C5.79433 17.2917 5.79433 17.6083 5.98959 17.8035L6.6967 18.5106C6.89196 18.7059 7.20854 18.7059 7.40381 18.5106L12 13.9144L16.5962 18.5106C16.7915 18.7059 17.108 18.7059 17.3033 18.5106L18.0104 17.8035C18.2057 17.6083 18.2057 17.2917 18.0104 17.0964L13.4142 12.5002L18.0104 7.90404C18.2057 7.70878 18.2057 7.39219 18.0104 7.19693L17.3033 6.48982Z",
        fill: iconFill
    }));
};
var TrashIconV2 = function TrashIconV2(_ref) {
    var themeValues = _ref.themeValues, iconFill = _ref.iconFill;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5 4H14V6H4V4H6.5L7.21429 3H10.7857L11.5 4ZM6.99048 15C6.25714 15 5.65714 14.4857 5.65714 13.8571L4.85714 7H12.8571L12.0571 13.8571C12.0571 14.4857 11.4571 15 10.7238 15H6.99048Z",
        fill: iconFill !== null && iconFill !== void 0 ? iconFill : themeValues.singleIconColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_4292_11876",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "4",
        y: "3",
        width: "10",
        height: "12"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5 4H14V6H4V4H6.5L7.21429 3H10.7857L11.5 4ZM6.99048 15C6.25714 15 5.65714 14.4857 5.65714 13.8571L4.85714 7H12.8571L12.0571 13.8571C12.0571 14.4857 11.4571 15 10.7238 15H6.99048Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_4292_11876)"
    }));
};
var TrashIconV2$1 = themeComponent(TrashIconV2, "Icons", fallbackValues$b, "primary");
var DisabledAccountsAddIcon = function DisabledAccountsAddIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M77.0408 78.1002V32.5154C77.0408 31.9007 76.5506 31.4039 75.9474 31.4039H32.3148C31.7106 31.4039 31.2213 31.9007 31.2213 32.5154V84.5326C31.2213 84.5326 55.7247 98.7028 77.0408 78.1002Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M88.0002 51.4983C88.0002 72.4847 70.9876 89.4983 50.0002 89.4983C29.0128 89.4983 12.0002 72.4847 12.0002 51.4983C12.0002 30.5109 29.0128 13.4983 50.0002 13.4983C59.0261 13.4983 67.3177 16.6447 73.8366 21.902C82.475 28.8674 88.0002 39.5368 88.0002 51.4983Z",
        stroke: "#878E9B",
        strokeWidth: "2.59255",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M77.0408 78.1002V32.5154C77.0408 31.9007 76.5506 31.4039 75.9474 31.4039H32.3148C31.7106 31.4039 31.2213 31.9007 31.2213 32.5154V81.3853",
        stroke: "#878E9B",
        strokeWidth: "2.0653",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.3362 78.1002V11.6448C23.3362 11.0302 23.8264 10.5324 24.4306 10.5324H68.0622C68.6664 10.5324 69.1556 11.0302 69.1556 11.6448V84.1973C69.1556 84.1973 58.4947 90.719 43.9673 88.1179C32.3336 86.0346 23.3362 78.1002 23.3362 78.1002Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M69.156 84.1973V11.6448C69.156 11.0302 68.6658 10.5324 68.0625 10.5324H24.43C23.8258 10.5324 23.3365 11.0302 23.3365 11.6448V78.1002",
        stroke: "#878E9B",
        strokeWidth: "2.0653",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M23.3362 19.3115H69.1556",
        stroke: "#878E9B",
        strokeWidth: "1.9285",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M69.156 40.1818H77.041",
        stroke: "#878E9B",
        strokeWidth: "1.9285",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.82 36.5974H62.672V31.4038H29.82V36.5974Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.82 36.5974H62.672V31.4038H29.82V36.5974Z",
        stroke: "#878E9B",
        strokeWidth: "2.0653",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.82 45.9207H62.672V40.7271H29.82V45.9207Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.82 45.9207H62.672V40.7271H29.82V45.9207Z",
        stroke: "#878E9B",
        strokeWidth: "2.0653",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M29.8201 26.2602H46.2466",
        stroke: "#878E9B",
        strokeWidth: "2.0653",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.82 63.0901H62.672V57.8964H29.82V63.0901Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.82 63.0901H62.672V57.8964H29.82V63.0901Z",
        stroke: "#878E9B",
        strokeWidth: "2.0653",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.82 72.4143H62.672V67.2207H29.82V72.4143Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.82 72.4143H62.672V67.2207H29.82V72.4143Z",
        stroke: "#878E9B",
        strokeWidth: "2.0653",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48.3403 83.2719H62.672V79.298H48.3403V83.2719Z",
        fill: "#878E9B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48.3403 83.2719H62.672V79.298H48.3403V83.2719Z",
        stroke: "#878E9B",
        strokeWidth: "2.0653",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M29.8201 52.7535H46.2466",
        stroke: "#878E9B",
        strokeWidth: "2.0653",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M73.8364 21.9017C82.4748 28.8671 88 39.5365 88 51.498C88 72.4844 70.9874 89.498 50 89.498C29.0126 89.498 12 72.4844 12 51.498",
        stroke: "#878E9B",
        strokeWidth: "2.59255",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M69.1557 40.1818H77.0407V31.4038H69.1557V40.1818Z",
        fill: "#878E9B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.3363 19.3112H69.1557V10.5323H23.3363V19.3112Z",
        fill: "#878E9B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M72.0041 90.1C79.3495 90.1 85.3041 84.1454 85.3041 76.8C85.3041 69.4546 79.3495 63.5 72.0041 63.5C64.6587 63.5 58.7041 69.4546 58.7041 76.8C58.7041 84.1454 64.6587 90.1 72.0041 90.1Z",
        fill: "#878E9B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M79.2041 77.5H73.2041V83.5H71.2041V77.5H65.2041V75.5H71.2041V69.5H73.2041V75.5H79.2041V77.5Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_7610_37196",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "65",
        y: "69",
        width: "15",
        height: "15"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M79.2041 77.5H73.2041V83.5H71.2041V77.5H65.2041V75.5H71.2041V69.5H73.2041V75.5H79.2041V77.5Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_7610_37196)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "60.2041",
        y: "64.5",
        width: "24",
        height: "24",
        fill: "white"
    })));
};
var DisabledPropertiesAddIcon = function DisabledPropertiesAddIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M81.2621 37.7524C81.2621 38.0343 81.0333 38.2631 80.7514 38.2631H61.1325C60.8505 38.2631 60.6227 38.0343 60.6227 37.7524V36.6749C60.6227 36.393 60.8505 36.1641 61.1325 36.1641H80.7514C81.0333 36.1641 81.2621 36.393 81.2621 36.6749V37.7524ZM72.0783 49.0989V40.0831C72.0783 39.5434 72.5147 39.107 73.0544 39.107H79.2877C79.8274 39.107 80.2638 39.5434 80.2638 40.0831V48.2087C80.2638 48.7485 79.8274 49.1858 79.2877 49.1858H72.1643C72.116 49.1858 72.0783 49.1462 72.0783 49.0989ZM79.4277 51.0531C79.8892 51.0531 80.2638 51.4277 80.2638 51.8902V60.2948C80.2638 60.7564 79.8892 61.131 79.4277 61.131H72.9144C72.4529 61.131 72.0783 60.7564 72.0783 60.2948V51.0531H79.4277ZM61.6519 48.2898V40.003C61.6519 39.5077 62.0526 39.107 62.5479 39.107H68.9414C69.4367 39.107 69.8374 39.5077 69.8374 40.003V49.1791C69.8374 49.1829 69.8345 49.1858 69.8316 49.1858H62.5479C62.0526 49.1858 61.6519 48.7842 61.6519 48.2898ZM62.6444 51.0531H69.7351C69.7911 51.0531 69.8374 51.0994 69.8374 51.1564V60.1394C69.8374 60.6868 69.3933 61.131 68.8458 61.131H62.6444C62.096 61.131 61.6519 60.6868 61.6519 60.1394V52.0456C61.6519 51.4972 62.096 51.0531 62.6444 51.0531ZM81.2621 63.845C81.2621 64.1269 81.0333 64.3567 80.7514 64.3567H61.1325C60.8505 64.3567 60.6227 64.1269 60.6227 63.845V62.7675C60.6227 62.4856 60.8505 62.2577 61.1325 62.2577H80.7514C81.0333 62.2577 81.2621 62.4856 81.2621 62.7675V63.845ZM63.917 17.6758L62.0526 16.4226L40.6542 30.8134V73.442H44.0422V36.7994C44.0422 36.448 44.327 36.1641 44.6775 36.1641H57.367C57.7175 36.1641 58.0023 36.448 58.0023 36.7994V73.442H73.8365H78.2199C79.7917 71.6057 81.8328 68.8076 83.4635 65.1571V65.1474V30.8085L63.917 17.6758ZM46.1624 12.7267V18.6152L50.7881 15.4735V12.5857V9.95762V8.28345H46.1624V10.0986V12.7267ZM88.2929 28.3726L63.216 11.5227C62.8617 11.2871 62.4571 11.1693 62.0526 11.1693C61.648 11.1693 61.2425 11.2871 60.8882 11.5237L40.8 25.0204L35.8403 28.3533C35.6385 28.4875 35.5844 28.7607 35.7196 28.9625L36.5586 30.2254C36.6436 30.3528 36.7845 30.4223 36.9265 30.4223C37.0114 30.4223 37.0974 30.3982 37.1727 30.347L38.2521 29.6219L62.0526 13.6313L86.9615 30.3673C87.032 30.4136 87.1102 30.4358 87.1884 30.4358C87.3187 30.4358 87.4481 30.3721 87.5263 30.2543L88.4049 28.9335C88.5285 28.7482 88.4792 28.4971 88.2929 28.3726ZM38.2525 59.7028V73.4418H28.7249C28.6313 73.382 28.5454 73.3096 28.4565 73.2439C28.3185 73.1406 28.1852 73.0305 28.0578 72.9147C27.9757 72.8394 27.8917 72.765 27.8145 72.6849C27.6407 72.5024 27.4804 72.3093 27.3356 72.1046C27.2825 72.0293 27.2361 71.9501 27.1869 71.8729C27.0681 71.6846 26.96 71.4886 26.8673 71.284C26.8403 71.226 26.8094 71.171 26.7852 71.1131C26.6771 70.8533 26.595 70.5811 26.5323 70.302C26.5168 70.2325 26.5043 70.162 26.4908 70.0916C26.4367 69.7961 26.399 69.4939 26.399 69.183C26.4 66.0104 29.339 63.4876 32.6159 64.23C33.034 64.3304 33.4617 64.1354 33.6712 63.7647C33.8575 63.4345 34.069 63.1236 34.2901 62.8223C34.3383 62.7576 34.3857 62.692 34.4349 62.6292C34.6579 62.3415 34.8935 62.0673 35.1465 61.8086C35.188 61.767 35.2314 61.7284 35.2739 61.6879C35.5085 61.4571 35.7547 61.2389 36.0096 61.0352L36.1593 60.9145C36.4431 60.6982 36.7395 60.4993 37.0466 60.3159C37.1132 60.2753 37.1808 60.2387 37.2484 60.2C37.5554 60.0272 37.8692 59.866 38.1945 59.7269C38.209 59.7211 38.2225 59.7134 38.238 59.7067C38.2428 59.7057 38.2476 59.7047 38.2525 59.7028ZM48.0673 55.2366C48.8272 55.2366 49.4441 55.8536 49.4441 56.6134C49.4441 57.3732 48.8272 57.9892 48.0673 57.9892C47.3075 57.9892 46.6915 57.3732 46.6915 56.6134C46.6915 55.8536 47.3075 55.2366 48.0673 55.2366Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M43.8455 10.3697V13.0248C26.1702 15.8566 12.6213 31.209 12.6213 49.6694C12.6213 53.4068 13.1823 57.0139 14.2144 60.4192C14.4606 61.2331 14.7358 62.0326 15.036 62.8214C16.5171 66.7152 18.6316 70.2992 21.2596 73.4419C21.9558 74.2732 22.6847 75.0765 23.4494 75.844C30.1741 82.5987 39.4767 86.787 49.7399 86.787C60.0032 86.787 69.3048 82.5987 76.0304 75.844C76.7951 75.0765 77.5231 74.2732 78.2192 73.4419C80.3143 70.9354 82.0802 68.149 83.4638 65.1473C84.4863 62.9276 85.2944 60.5911 85.866 58.1628C86.508 55.4334 86.8575 52.5919 86.8575 49.6694C86.8575 46.7603 86.5225 43.9005 85.8746 41.1373L85.8669 36.1379L85.866 35.6252V33.2269C85.8998 33.3013 86.4395 34.3807 86.4559 34.4232C88.4323 39.186 89.4789 44.3504 89.4789 49.6694C89.4789 55.5637 88.1793 61.1578 85.866 66.1939C85.1582 67.7367 84.3569 69.2275 83.4638 70.6554C82.8671 71.6113 82.2376 72.543 81.5656 73.4419C80.9448 74.2703 80.2854 75.0678 79.6037 75.844C72.3142 84.1502 61.6329 89.4083 49.7399 89.4083C27.827 89.4083 10 71.5813 10 49.6694C10 29.7598 24.7181 13.2266 43.8455 10.3697ZM80.751 62.2576C81.033 62.2576 81.2618 62.4855 81.2618 62.7674V63.8459C81.2618 64.1278 81.033 64.3566 80.751 64.3566H61.1331C60.8512 64.3566 60.6223 64.1278 60.6223 63.8459V62.7674C60.6223 62.4855 60.8512 62.2576 61.1331 62.2576H80.751ZM53.1047 10.0859C54.6948 10.223 56.2744 10.4421 57.8308 10.7665L56.7041 11.5573L54.7219 12.8897C54.6456 12.879 54.5684 12.8694 54.4921 12.8588C54.0315 12.7989 53.5681 12.7661 53.1047 12.7236V10.0859ZM80.751 36.165H61.1331C60.8512 36.165 60.6223 36.3929 60.6223 36.6748V37.7523C60.6223 38.0342 60.8512 38.2631 61.1331 38.2631H80.751C81.033 38.2631 81.2618 38.0342 81.2618 37.7523V36.6748C81.2618 36.3929 81.033 36.165 80.751 36.165ZM61.6525 60.1393C61.6525 60.6868 62.0966 61.1309 62.6441 61.1309H68.8455C69.3929 61.1309 69.837 60.6868 69.837 60.1393V51.1563C69.837 51.0994 69.7907 51.054 69.7347 51.054H62.6441C62.0966 51.054 61.6525 51.4971 61.6525 52.0456V60.1393ZM72.0789 60.2948C72.0789 60.7563 72.4526 61.1309 72.9151 61.1309H79.4273C79.8889 61.1309 80.2635 60.7563 80.2635 60.2948V51.8901C80.2635 51.4276 79.8889 51.054 79.4273 51.054H72.0789V60.2948ZM69.8313 49.1857C69.8342 49.1857 69.837 49.1828 69.837 49.179V40.0029C69.837 39.5086 69.4364 39.1069 68.942 39.1069H62.5475C62.0532 39.1069 61.6525 39.5086 61.6525 40.0029V48.2898C61.6525 48.7841 62.0532 49.1857 62.5475 49.1857H69.8313ZM79.2873 49.1857C79.8271 49.1857 80.2635 48.7484 80.2635 48.2087V40.083C80.2635 39.5443 79.8271 39.1069 79.2873 39.1069H73.0541C72.5153 39.1069 72.0789 39.5443 72.0789 40.083V49.0989C72.0789 49.1462 72.1166 49.1857 72.1639 49.1857H79.2873ZM88.2935 28.3725L63.2157 11.5226C62.8623 11.287 62.4577 11.1692 62.0532 11.1692C61.6477 11.1692 61.2422 11.287 60.8888 11.5236L40.7997 25.0213L35.8399 28.3532C35.6381 28.4874 35.585 28.7616 35.7192 28.9634L36.5592 30.2253C36.6432 30.3527 36.7842 30.4222 36.9261 30.4222C37.0111 30.4222 37.097 30.3981 37.1723 30.3469L38.2517 29.6219L62.0522 13.6313L86.9621 30.3672C87.0316 30.4145 87.1098 30.4358 87.188 30.4358C87.3193 30.4358 87.4487 30.373 87.5269 30.2552L88.4055 28.9335C88.5291 28.7481 88.4789 28.497 88.2935 28.3725ZM46.1621 8.28337V10.0995V12.7266L46.163 18.6152L50.7878 15.4734V12.5856V9.95755V8.28337H46.1621ZM46.6921 56.6133C46.6921 57.3732 47.3071 57.9892 48.067 57.9892C48.8278 57.9892 49.4438 57.3732 49.4438 56.6133C49.4438 55.8535 48.8278 55.2375 48.067 55.2375C47.3071 55.2375 46.6921 55.8535 46.6921 56.6133ZM38.2517 40.9027L18.3499 40.8689L18.405 64.5555L26.2419 64.5372C26.4282 64.3267 26.6242 64.1249 26.8347 63.9376V60.3488C26.8347 60.2059 26.9506 60.0901 27.0944 60.0901H33.5131C33.6569 60.0901 33.7728 60.2059 33.7728 60.3488V60.4541C34.5848 59.6266 35.5223 58.9489 36.5351 58.4063V55.6768C36.5351 55.5339 36.6509 55.418 36.7948 55.418H38.2517V54.5867H36.7948C36.6509 54.5867 36.5351 54.4709 36.5351 54.327V51.1669C36.5351 51.0241 36.6509 50.9082 36.7948 50.9082H38.2517V50.0769H36.7948C36.6509 50.0769 36.5351 49.961 36.5351 49.8172V46.6571C36.5351 46.5132 36.6509 46.3974 36.7948 46.3974H38.2517V45.5671H36.7948C36.6509 45.5671 36.5351 45.4512 36.5351 45.3073V42.1473C36.5351 42.0034 36.6509 41.8875 36.7948 41.8875H38.2517V40.9027ZM38.2517 73.442V59.701C36.3487 60.4966 34.7199 61.91 33.6704 63.7648C33.4619 64.1355 33.0342 64.3296 32.6161 64.2301C29.3392 63.4867 26.4002 66.0105 26.3993 69.1831C26.3993 70.9674 27.3291 72.5354 28.7242 73.442H38.2517ZM90.3346 30.2166L89.456 31.5393C88.9491 32.2992 88.1014 32.753 87.188 32.753C86.7198 32.753 86.2679 32.6284 85.8624 32.4006L85.866 35.6252V58.1628C85.2944 60.5911 84.4863 62.9276 83.4638 65.1473L83.4641 30.8084L62.0522 16.4225L41.4765 30.2475L40.6549 30.8142V73.442H44.0418V36.7994C44.0418 36.4489 44.3267 36.165 44.6781 36.165H57.3667C57.7181 36.165 58.002 36.4489 58.002 36.7994V73.442H73.8361L78.2192 73.4419C77.5231 74.2732 76.7951 75.0765 76.0304 75.844L73.8361 75.8441H40.4975L23.4494 75.844C22.6847 75.0765 21.9558 74.2732 21.2596 73.4419L25.9281 73.442C25.0177 72.2583 24.4683 70.7868 24.4683 69.1831C24.4683 68.0168 24.7657 66.9181 25.2735 65.9478H18.349C17.5814 65.9478 16.9567 65.3231 16.9567 64.5555V62.8215L15.036 62.8214C14.7358 62.0326 14.4606 61.2331 14.2144 60.4192L16.9567 60.4193V40.8689H16.4662V38.3596H18.768L18.767 35.9266C18.767 35.7267 18.8491 35.5365 18.9929 35.4004L22.0545 32.5039C22.266 32.304 22.5749 32.2499 22.8395 32.3648C23.104 32.4788 23.2769 32.7404 23.2769 33.0301L23.2778 38.3596H24.4017L24.4007 35.9266C24.4007 35.7267 24.4828 35.5365 24.6266 35.4004L27.6882 32.5039C27.8997 32.304 28.2077 32.2499 28.4732 32.3648C28.7377 32.4788 28.9105 32.7404 28.9105 33.0301L28.9115 38.3596H30.0344L30.0334 35.9266C30.0334 35.7267 30.1155 35.5365 30.2593 35.4004L33.3209 32.5039C33.4233 32.4063 33.5507 32.3446 33.684 32.3195C33.8172 32.2943 33.9601 32.2866 34.2053 32.4566C34.4438 32.6207 34.5037 32.8273 34.5182 32.8679C34.5336 32.9084 34.5433 32.9741 34.5433 33.0301L34.5442 38.3596H35.6681L35.6671 35.9266C35.6671 35.7267 35.7492 35.5365 35.893 35.4004L38.2517 33.1681V32.3919C37.8462 32.6159 37.3944 32.7394 36.9261 32.7394C36.0002 32.7394 35.1419 32.2789 34.6292 31.5084L33.7892 30.2465C32.9512 28.9856 33.292 27.2738 34.5481 26.4299L43.8458 20.1822L43.8455 13.0248V10.3697L43.8439 7.88655C43.8439 6.8274 44.7061 5.96521 45.7652 5.96521H51.1846C52.2437 5.96521 53.105 6.8274 53.105 7.88655L53.1047 10.0859V12.7236L53.105 13.9624L59.6018 9.59741C60.3317 9.10984 61.1794 8.85302 62.0532 8.85302C62.926 8.85302 63.7728 9.10887 64.5075 9.60031L89.5854 26.4483C90.827 27.2815 91.162 28.9721 90.3346 30.2166ZM19.7499 45.5671H23.8127C23.9566 45.5671 24.0724 45.4512 24.0724 45.3073V42.1473C24.0724 42.0034 23.9566 41.8875 23.8127 41.8875H19.7499C19.608 41.8875 19.4911 42.0034 19.4911 42.1473V45.3073C19.4911 45.4512 19.608 45.5671 19.7499 45.5671ZM25.4319 45.5671H29.4947C29.6385 45.5671 29.7544 45.4512 29.7544 45.3073V42.1473C29.7544 42.0034 29.6385 41.8875 29.4947 41.8875H25.4319C25.289 41.8875 25.1731 42.0034 25.1731 42.1473V45.3073C25.1731 45.4512 25.289 45.5671 25.4319 45.5671ZM31.1128 45.5671H35.1757C35.3186 45.5671 35.4344 45.4512 35.4344 45.3073V42.1473C35.4344 42.0034 35.3186 41.8875 35.1757 41.8875H31.1128C30.969 41.8875 30.8531 42.0034 30.8531 42.1473V45.3073C30.8531 45.4512 30.969 45.5671 31.1128 45.5671ZM19.7499 59.0966H23.8127C23.9566 59.0966 24.0724 58.9798 24.0724 58.8369V55.6768C24.0724 55.5339 23.9566 55.418 23.8127 55.418H19.7499C19.608 55.418 19.4911 55.5339 19.4911 55.6768V58.8369C19.4911 58.9798 19.608 59.0966 19.7499 59.0966ZM25.4319 59.0966H29.4947C29.6385 59.0966 29.7544 58.9798 29.7544 58.8369V55.6768C29.7544 55.5339 29.6385 55.418 29.4947 55.418H25.4319C25.289 55.418 25.1731 55.5339 25.1731 55.6768V58.8369C25.1731 58.9798 25.289 59.0966 25.4319 59.0966ZM31.1128 59.0966H35.1757C35.3186 59.0966 35.4344 58.9798 35.4344 58.8369V55.6768C35.4344 55.5339 35.3186 55.418 35.1757 55.418H31.1128C30.969 55.418 30.8531 55.5339 30.8531 55.6768V58.8369C30.8531 58.9798 30.969 59.0966 31.1128 59.0966ZM19.7499 54.5867H23.8127C23.9566 54.5867 24.0724 54.4709 24.0724 54.327V51.1669C24.0724 51.0241 23.9566 50.9082 23.8127 50.9082H19.7499C19.608 50.9082 19.4911 51.0241 19.4911 51.1669V54.327C19.4911 54.4709 19.608 54.5867 19.7499 54.5867ZM25.4319 54.5867H29.4947C29.6385 54.5867 29.7544 54.4709 29.7544 54.327V51.1669C29.7544 51.0241 29.6385 50.9082 29.4947 50.9082H25.4319C25.289 50.9082 25.1731 51.0241 25.1731 51.1669V54.327C25.1731 54.4709 25.289 54.5867 25.4319 54.5867ZM31.1128 54.5867H35.1757C35.3186 54.5867 35.4344 54.4709 35.4344 54.327V51.1669C35.4344 51.0241 35.3186 50.9082 35.1757 50.9082H31.1128C30.969 50.9082 30.8531 51.0241 30.8531 51.1669V54.327C30.8531 54.4709 30.969 54.5867 31.1128 54.5867ZM19.7499 50.0769H23.8127C23.9566 50.0769 24.0724 49.961 24.0724 49.8172V46.6571C24.0724 46.5132 23.9566 46.3974 23.8127 46.3974H19.7499C19.608 46.3974 19.4911 46.5132 19.4911 46.6571V49.8172C19.4911 49.961 19.608 50.0769 19.7499 50.0769ZM25.4319 50.0769H29.4947C29.6385 50.0769 29.7544 49.961 29.7544 49.8172V46.6571C29.7544 46.5132 29.6385 46.3974 29.4947 46.3974H25.4319C25.289 46.3974 25.1731 46.5132 25.1731 46.6571V49.8172C25.1731 49.961 25.289 50.0769 25.4319 50.0769ZM30.8531 49.8172V46.6571C30.8531 46.5132 30.969 46.3974 31.1128 46.3974H35.1757C35.3186 46.3974 35.4344 46.5132 35.4344 46.6571V49.8172C35.4344 49.961 35.3186 50.0769 35.1757 50.0769H31.1128C30.969 50.0769 30.8531 49.961 30.8531 49.8172Z",
        fill: "#878E9B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "71.9999",
        cy: "74",
        r: "12",
        fill: "#878E9B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M65.9391 74.5102C65.9391 74.7863 66.1629 75.0102 66.4391 75.0102L70.9898 75.0102L70.9898 79.5609C70.9898 79.8371 71.2137 80.0609 71.4898 80.0609L72.5101 80.0609C72.7863 80.0609 73.0101 79.8371 73.0101 79.5609L73.0101 75.0102L77.5609 75.0102C77.837 75.0102 78.0609 74.7863 78.0609 74.5102L78.0609 73.4898C78.0609 73.2137 77.837 72.9898 77.5609 72.9898H73.0101L73.0101 68.4391C73.0101 68.1629 72.7863 67.9391 72.5101 67.9391L71.4898 67.9391C71.2137 67.9391 70.9898 68.1629 70.9898 68.4391L70.9898 72.9898L66.4391 72.9898C66.1629 72.9898 65.9391 73.2137 65.9391 73.4898L65.9391 74.5102Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_2013_203",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "65",
        y: "67",
        width: "14",
        height: "14"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M65.9391 74.5102C65.9391 74.7863 66.1629 75.0102 66.4391 75.0102L70.9898 75.0102L70.9898 79.5609C70.9898 79.8371 71.2137 80.0609 71.4898 80.0609L72.5101 80.0609C72.7863 80.0609 73.0101 79.8371 73.0101 79.5609L73.0101 75.0102L77.5609 75.0102C77.837 75.0102 78.0609 74.7863 78.0609 74.5102L78.0609 73.4898C78.0609 73.2137 77.837 72.9898 77.5609 72.9898H73.0101L73.0101 68.4391C73.0101 68.1629 72.7863 67.9391 72.5101 67.9391L71.4898 67.9391C71.2137 67.9391 70.9898 68.1629 70.9898 68.4391L70.9898 72.9898L66.4391 72.9898C66.1629 72.9898 65.9391 73.2137 65.9391 73.4898L65.9391 74.5102Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_2013_203)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M62 64H82V84H62V64Z",
        fill: "#FEFEFE"
    })));
};
var DisabledPaymentMethodsAddIcon = function DisabledPaymentMethodsAddIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "a",
        x: "-1",
        y: "0",
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#fff",
        d: "M97.88 0H-1v96h98.88V0Z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#a)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FEFEFE",
        fillRule: "evenodd",
        d: "M91.947 19.2v36.48H48.44v15.6c0 .881-.697 1.603-1.584 1.673l-.141.006H20.402c-1.888-2.755-3.416-5.315-4.649-7.68H40.53v-3.84H14.82v1.972c-6.089-12.75-3.332-19.251-3.332-19.251h13.22V19.2h67.24Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#878E9B",
        d: "M48.24 10.56c8.325 0 16.249 2.587 22.793 7.298l.442.323h20.472c.525 0 .958.397 1.013.908l.006.111v36.48c0 .525-.397.958-.908 1.013l-.11.006h-6.48l-.01.039c-4.176 16.497-19.471 28.315-37.217 28.315-21.16 0-38.328-16.668-38.328-37.246 0-11.497 5.358-21.772 13.776-28.603V19.2c0-.525.398-.958.909-1.013l.11-.006h.298c6.447-4.782 14.501-7.621 23.235-7.621Zm34.688 46.139H48.47V71.28c0 1.44-1.138 2.608-2.565 2.693l-.166.005h-21.13c6.31 5.364 14.578 8.617 23.632 8.617 16.42 0 30.585-10.788 34.687-25.897Zm-60.52 15.243h23.331a.683.683 0 0 0 .687-.572l.006-.089V56.64H13.537c1.577 5.84 4.68 11.083 8.87 15.302Zm68.52-51.723-64.542-.001c-.222.165-.442.333-.66.504l.001 22.42H45.74c1.448 0 2.64 1.116 2.726 2.533l.005.165v8.821h42.458V20.217ZM66.324 44.784l.217.134.32.208.834.562 1.937 1.34c.583.396 1.101.73 1.59 1.023 1.5.896 2.662 1.348 3.404 1.298.678-.044 1.166-.132 1.655-.293l.247-.088 2.087-.915.92-.39.337-.138.307-.12c1.758-.675 3.308.021 4.548 1.49.513.608.867 1.21 1.061 1.633a.84.84 0 0 1-1.475.795l-.146-.28-.107-.19a6.45 6.45 0 0 0-.616-.875c-.83-.982-1.703-1.374-2.664-1.005l-.437.174-.766.322-2.46 1.071-.044.018c-.72.265-1.405.406-2.337.467-1.184.079-2.6-.471-4.375-1.533a31.938 31.938 0 0 1-1.315-.834l-2.312-1.594-.823-.554-.362-.233a2.115 2.115 0 0 0-.055-.033c-1.924-1.094-4.566 1.331-6.416 5.012a.84.84 0 0 1-1.5-.754c.083-.166.168-.33.255-.493l.263-.48c.446-.788.925-1.518 1.429-2.168l.305-.38c1.954-2.344 4.255-3.47 6.494-2.197Zm-53.847.326-.03.41a34.227 34.227 0 0 0-.011 4.4l33.996-.001v-4.08c0-.33-.257-.61-.598-.655l-.095-.006H12.843c-.129 0-.252-.024-.366-.068Zm.212-1.957.043-.007.111-.006H23.69V22.442c-5.868 5.346-9.88 12.586-11 20.712ZM84.135 24v1.629c1.346.237 2.494.713 3.488 1.42l-1.884 2.36c-1.243-.793-2.603-1.189-3.806-1.189-.913 0-1.36.327-1.36.775v.034c0 .551.467.792 2.37 1.171 3.106.602 5.049 1.498 5.049 3.753v.034c0 2.027-1.49 3.375-3.858 3.79v1.583h-3.587v-1.605c-1.665-.266-3.197-.879-4.42-1.839l2.096-2.22c1.36.945 2.835 1.446 4.408 1.446 1.03 0 1.573-.312 1.573-.828v-.034c0-.516-.446-.775-2.31-1.17-2.894-.585-5.128-1.31-5.128-3.771v-.034c0-1.875 1.408-3.311 3.781-3.73V24h3.588ZM57.339 36.12a.84.84 0 0 1 .105 1.673l-.105.007H28.664a.84.84 0 0 1-.105-1.673l.105-.007h28.675Zm-11.865-5.76a.84.84 0 0 1 .105 1.673l-.105.007h-16.81a.84.84 0 0 1-.105-1.673l.105-.007h16.81ZM56.35 24.6a.84.84 0 0 1 .106 1.673l-.106.007H43.496a.84.84 0 0 1-.105-1.673l.105-.007H56.35Zm-16.81 0a.84.84 0 0 1 .106 1.673l-.105.007H28.664a.84.84 0 0 1-.105-1.673l.105-.007H39.54Zm8.7-11.583c-6.9 0-13.345 1.89-18.814 5.164h37.63c-5.592-3.349-12.06-5.164-18.815-5.164Z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#878E9B",
        d: "M73.768 86.536c7.052 0 12.768-5.716 12.768-12.768C86.536 66.716 80.82 61 73.768 61 66.716 61 61 66.716 61 73.768c0 7.052 5.716 12.768 12.768 12.768Z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FEFEFE",
        d: "M79.648 74.608h-5.04v5.04h-1.68v-5.04h-5.04v-1.68h5.04v-5.04h1.68v5.04h5.04v1.68Z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "b",
        width: "13",
        height: "13",
        x: "67",
        y: "67",
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#fff",
        d: "M79.648 74.608h-5.04v5.04h-1.68v-5.04h-5.04v-1.68h5.04v-5.04h1.68v5.04h5.04v1.68Z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#b)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FEFEFE",
        d: "M83.848 63.688h-20.16v20.16h20.16v-20.16Z"
    })));
};
var ReversalNeededIcon = function ReversalNeededIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "16",
        cy: "16",
        r: "16",
        fill: "#D11053"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.4167 14.2222H13.5833C13.4453 14.2222 13.3333 14.1103 13.3333 13.9722V11.6667C13.3333 11.1144 13.781 10.6667 14.3333 10.6667H23C23.5523 10.6667 24 11.1144 24 11.6667V20.3333C24 20.8856 23.5523 21.3333 23 21.3333H14.3333C13.781 21.3333 13.3333 20.8856 13.3333 20.3333V18.0278C13.3333 17.8897 13.4453 17.7778 13.5833 17.7778H14.4167C14.5547 17.7778 14.6667 17.8897 14.6667 18.0278V20H22.6667V11.8518H14.6667V13.9722C14.6667 14.1103 14.5547 14.2222 14.4167 14.2222Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9.8706 11.4627L5.51011 15.8232C5.41248 15.9209 5.41248 16.0791 5.51011 16.1768L9.8706 20.5373C9.96823 20.6349 10.1265 20.6349 10.2242 20.5373L10.8134 19.948C10.911 19.8504 10.911 19.6921 10.8134 19.5945L7.39573 16.1768C7.2981 16.0791 7.2981 15.9209 7.39573 15.8232L10.8134 12.4055C10.911 12.3079 10.911 12.1496 10.8134 12.052L10.2242 11.4627C10.1265 11.3651 9.96823 11.3651 9.8706 11.4627Z",
        fill: "white"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.66667 15.5833C6.66667 15.4453 6.7786 15.3333 6.91667 15.3333L18.4167 15.3333C18.5547 15.3333 18.6667 15.4453 18.6667 15.5833L18.6667 16.4167C18.6667 16.5547 18.5547 16.6667 18.4167 16.6667L6.91667 16.6667C6.7786 16.6667 6.66667 16.5547 6.66667 16.4167L6.66667 15.5833Z",
        fill: "white"
    }));
};
var OverageIcon = function OverageIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "16",
        cy: "16",
        r: "16",
        transform: "rotate(-180 16 16)",
        fill: "#D11053"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.6465 7.15426L9.7539 13.0468C9.55864 13.2421 9.55864 13.5587 9.7539 13.7539L10.461 14.461C10.6563 14.6563 10.9728 14.6563 11.1681 14.461L15 10.6291L15 20.6667H11.8333C11.5572 20.6667 11.3333 20.8905 11.3333 21.1667L11.3333 22.1667C11.3333 22.4428 11.5572 22.6667 11.8333 22.6667L20.1667 22.6667C20.4428 22.6667 20.6667 22.4428 20.6667 22.1667V21.1667C20.6667 20.8905 20.4428 20.6667 20.1667 20.6667H17L17 10.6291L20.8319 14.461C21.0272 14.6563 21.3437 14.6563 21.539 14.461L22.2461 13.7539C22.4414 13.5587 22.4414 13.2421 22.2461 13.0468L16.3536 7.15426C16.1583 6.959 15.8417 6.959 15.6465 7.15426Z",
        fill: "white"
    }));
};
var ShortageIcon = function ShortageIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "16",
        cy: "16",
        r: "16",
        fill: "#D11053"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.3333 9.83331C11.3333 9.55717 11.5572 9.33331 11.8333 9.33331H20.1667C20.4428 9.33331 20.6667 9.55717 20.6667 9.83331V10.8333C20.6667 11.1095 20.4428 11.3333 20.1667 11.3333H17V21.3709L20.8319 17.539C21.0272 17.3437 21.3437 17.3437 21.539 17.539L22.2461 18.2461C22.4414 18.4414 22.4414 18.7579 22.2461 18.9532L16.3535 24.8458C16.1583 25.041 15.8417 25.041 15.6464 24.8458L9.75388 18.9532C9.55862 18.7579 9.55862 18.4414 9.75388 18.2461L10.461 17.539C10.6563 17.3437 10.9728 17.3437 11.1681 17.539L15 21.3709V11.3333H11.8333C11.5572 11.3333 11.3333 11.1095 11.3333 10.8333V9.83331Z",
        fill: "white"
    }));
};
var NoResultsIcon = function NoResultsIcon(_ref) {
    var _ref$fillPrimary = _ref.fillPrimary, fillPrimary = _ref$fillPrimary === void 0 ? MATISSE_BLUE : _ref$fillPrimary, _ref$fillSecondary = _ref.fillSecondary, fillSecondary = _ref$fillSecondary === void 0 ? INFO_BLUE : _ref$fillSecondary;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "366",
        height: "209",
        viewBox: "0 0 366 209"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "none",
        strokeWidth: "1"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(-537 -466)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(132 332)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(405 134)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFF",
        d: "M73 25h224v144.75a2.25 2.25 0 01-2.25 2.25H75.25a2.25 2.25 0 01-2.25-2.25V25z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: fillSecondary,
        d: "M185 185c28.719 0 52 5.373 52 12s-23.281 12-52 12c-28.718 0-52-5.373-52-12s23.282-12 52-12zm35-137.5c14.084 0 25.5 11.416 25.5 25.5 0 14.083-11.416 25.5-25.5 25.5S194.5 87.083 194.5 73c0-14.084 11.416-25.5 25.5-25.5zm-70 0c14.084 0 25.5 11.416 25.5 25.5 0 14.083-11.416 25.5-25.5 25.5-14.083 0-25.5-11.417-25.5-25.5 0-14.084 11.417-25.5 25.5-25.5zM220.001 68c-4.206 0-7.903 2.689-9.348 6.641a2.5 2.5 0 004.634 1.87l.062-.152.083-.214c.786-1.896 2.574-3.145 4.57-3.145 1.994 0 3.782 1.249 4.568 3.145l.083.214.061.152a2.5 2.5 0 004.635-1.87C227.903 70.69 224.208 68 220 68zM150 68c-4.206 0-7.902 2.685-9.346 6.632a2.506 2.506 0 001.497 3.215 2.512 2.512 0 003.158-1.342l.061-.153.083-.212c.781-1.884 2.562-3.126 4.547-3.126 1.986 0 3.767 1.242 4.55 3.127l.082.212.062.153a2.512 2.512 0 003.158 1.34 2.506 2.506 0 001.496-3.215c-1.445-3.946-5.141-6.631-9.348-6.631z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#292A33",
        fillRule: "nonzero",
        d: "M294.625 0A6.376 6.376 0 01301 6.377V157h19a3 3 0 01.176 5.995L320 163h-19v6.623a6.376 6.376 0 01-6.375 6.377H75.374A6.375 6.375 0 0169 169.623V163H33a3 3 0 01-.176-5.995L33 157h36V6.377A6.375 6.375 0 0175.374 0h219.251zM297 25H73v144.623c0 1.259.976 2.288 2.211 2.372l.163.005h219.251a2.376 2.376 0 002.37-2.214l.005-.163V25zm39.953 132l26.112.082a2.952 2.952 0 012.935 2.969 2.953 2.953 0 01-2.78 2.945l-.173.004-26.112-.082a2.952 2.952 0 01-2.935-2.969 2.953 2.953 0 012.78-2.945l.173-.004zM17 157a3 3 0 01.176 5.995L17 163H3a3 3 0 01-.176-5.995L3 157h14zm179.832-42l.26.004c4.66.134 8.422 3.878 8.422 8.51a2.515 2.515 0 01-5.023.166l-.006-.166-.005-.183c-.096-1.763-1.573-3.2-3.446-3.297l-.202-.005h-23.664l-.196.005c-1.873.094-3.352 1.528-3.452 3.29l-.006.19-.005.166a2.515 2.515 0 01-5.023-.166c0-4.632 3.761-8.376 8.422-8.51l.26-.004h23.664zm23.169-72.5c16.845 0 30.499 13.654 30.499 30.5 0 16.845-13.655 30.5-30.5 30.5S189.5 89.845 189.5 73c0-.335.005-.668.016-1h-9.032l.012.499.004.5c0 16.846-13.655 30.501-30.5 30.501S119.5 89.845 119.5 73s13.655-30.5 30.5-30.5c10.22 0 19.266 5.026 24.8 12.742 3.73-1.495 7.226-2.242 10.491-2.242 3.304 0 6.593.765 9.87 2.296C200.69 47.55 209.755 42.5 220 42.5zm0 5C205.916 47.5 194.5 58.916 194.5 73c0 14.083 11.416 25.5 25.5 25.5s25.5-11.417 25.5-25.5c0-14.084-11.416-25.5-25.5-25.5zm-70 0C135.917 47.5 124.5 58.916 124.5 73c0 14.083 11.417 25.5 25.5 25.5 14.084 0 25.5-11.417 25.5-25.5 0-14.084-11.416-25.5-25.5-25.5zM185 59a3 3 0 100 6.002 3 3 0 000-6.002zM294.626 4H75.374a2.375 2.375 0 00-2.369 2.214L73 6.377V21h224V6.377a2.376 2.376 0 00-2.212-2.372L294.625 4zM81.5 10a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm8 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm8 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#959CA8",
        fillRule: "nonzero",
        d: "M220.001 68c4.207 0 7.902 2.689 9.348 6.641a2.5 2.5 0 01-4.635 1.87l-.061-.152C223.916 74.343 222.07 73 220 73c-1.995 0-3.783 1.25-4.57 3.145l-.082.214a2.5 2.5 0 01-4.696-1.718C212.098 70.69 215.795 68 220 68zM150 68c4.207 0 7.903 2.685 9.348 6.631a2.506 2.506 0 01-1.496 3.216 2.512 2.512 0 01-3.158-1.34l-.062-.154c-.734-2.003-2.572-3.339-4.632-3.339-1.985 0-3.766 1.242-4.547 3.126l-.083.212a2.511 2.511 0 01-3.22 1.495 2.506 2.506 0 01-1.496-3.215C142.097 70.685 145.793 68 150 68z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#E4E6EB",
        d: "M294.75 4A2.25 2.25 0 01297 6.25V21H73V6.25A2.25 2.25 0 0175.25 4zM81.5 10a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm8 0a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm8 0a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: fillPrimary,
        fillRule: "nonzero",
        d: "M182 176v20a4 4 0 01-3.8 3.995l-.2.005h-14a4 4 0 01-.2-7.995l.2-.005h10v-16h8zm14 0v16h10a4 4 0 013.995 3.8l.005.2a4 4 0 01-3.8 3.995l-.2.005h-14a4 4 0 01-3.995-3.8L188 196v-20h8zM69 128.5v9l-7.875 4.429 32.876 6.953c1.81-4.055 5.877-6.882 10.604-6.882a4 4 0 01.2 7.995l-.2.005a3.605 3.605 0 00-3.604 3.628l-.001-.023a3.606 3.606 0 003.414 3.601l.191.005h6.644a4 4 0 01.2 7.995l-.2.005h-6.644c-5.246 0-9.679-3.48-11.115-8.259l-44.708-9.457c-3.58-.757-4.322-5.493-1.242-7.336l.175-.1L69 128.5zm193.321-62.228a42.836 42.836 0 01.704 8.714l53.02 37.735a4 4 0 01.661 5.926l-.148.157L301 134.5V123l6.557-6.5-45.68-32.513a42.337 42.337 0 01-2.193 6.683 4 4 0 01-7.368-3.116 34.513 34.513 0 002.719-13.477c0-2.149-.195-4.27-.58-6.349a4 4 0 117.866-1.456z"
    }))))));
};
var _excluded$u = [
    "color"
];
var AgencyIcon = function AgencyIcon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "#292A33" : _ref$color, props = _objectWithoutProperties(_ref, _excluded$u);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Agency / Agency - S"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "Icon - Agency",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.5625 4.375H3.875L3.875 16.625H9.5625V7.875V7V4.375ZM10.4375 7.875V16.625H16.125V7.875H10.4375ZM10.4375 7H16.125C16.6082 7 17 7.39175 17 7.875V16.625C17 17.1082 16.6082 17.5 16.125 17.5H10.4375H9.5625H3.875C3.39175 17.5 3 17.1082 3 16.625V4.375C3 3.89175 3.39175 3.5 3.875 3.5H9.5625C10.0457 3.5 10.4375 3.89175 10.4375 4.375V7ZM8.46875 6.5625H4.96875V7.4375H8.46875V6.5625ZM4.96875 8.3125H8.46875V9.1875H4.96875V8.3125ZM8.46875 10.0625H4.96875V10.9375H8.46875V10.0625ZM4.96875 11.8125H8.46875V12.6875H4.96875V11.8125ZM4.96875 13.5625H8.46875V14.4375H4.96875V13.5625ZM11.5312 10.0625H15.0312V10.9375H11.5312V10.0625ZM11.5312 11.8125H15.0312V12.6875H11.5312V11.8125ZM15.0312 13.5625H11.5312V14.4375H15.0312V13.5625Z",
        fill: color
    })));
};
var _excluded$v = [
    "width",
    "height",
    "color"
];
var PersonIcon = function PersonIcon(_ref) {
    var _ref$width = _ref.width, width = _ref$width === void 0 ? "20" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "21" : _ref$height, _ref$color = _ref.color, color = _ref$color === void 0 ? CHARADE_GREY : _ref$color, props = _objectWithoutProperties(_ref, _excluded$v);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.25 4.8125H4.75C4.50838 4.8125 4.3125 5.00838 4.3125 5.25V15.75C4.3125 15.9916 4.50838 16.1875 4.75 16.1875H5.625V14.7778C5.625 12.8985 7.02411 11.375 8.75 11.375H11.25C12.9759 11.375 14.375 12.8985 14.375 14.7778V16.1875H15.25C15.4916 16.1875 15.6875 15.9916 15.6875 15.75V5.25C15.6875 5.00838 15.4916 4.8125 15.25 4.8125ZM4.75 17.5H5.625H14.375H15.25C16.2165 17.5 17 16.7165 17 15.75V5.25C17 4.2835 16.2165 3.5 15.25 3.5H4.75C3.7835 3.5 3 4.2835 3 5.25V15.75C3 16.7165 3.7835 17.5 4.75 17.5ZM10 10.5C11.2081 10.5 12.1875 9.52062 12.1875 8.3125C12.1875 7.10438 11.2081 6.125 10 6.125C8.79188 6.125 7.8125 7.10438 7.8125 8.3125C7.8125 9.52062 8.79188 10.5 10 10.5Z",
        fill: color
    }));
};
var _excluded$w = [
    "width",
    "height",
    "color"
];
var PaymentStatusIcon = function PaymentStatusIcon(_ref) {
    var _ref$width = _ref.width, width = _ref$width === void 0 ? "20" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "21" : _ref$height, _ref$color = _ref.color, color = _ref$color === void 0 ? CHARADE_GREY : _ref$color, props = _objectWithoutProperties(_ref, _excluded$w);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.875 4.375C10.875 3.89175 11.2668 3.5 11.75 3.5H16.125C16.6082 3.5 17 3.89175 17 4.375V8.75C17 9.23325 16.6082 9.625 16.125 9.625H15.25V15.75C15.25 16.7165 14.4665 17.5 13.5 17.5H4.75C3.7835 17.5 3 16.7165 3 15.75V7C3 6.0335 3.7835 5.25 4.75 5.25H10.875V4.375ZM10.875 8.75V6.5625H4.75C4.50838 6.5625 4.3125 6.75838 4.3125 7V15.75C4.3125 15.9916 4.50838 16.1875 4.75 16.1875H13.5C13.7416 16.1875 13.9375 15.9916 13.9375 15.75V9.625H11.75C11.2668 9.625 10.875 9.23325 10.875 8.75ZM13.9375 7.875C14.6624 7.875 15.25 7.28737 15.25 6.5625C15.25 5.83763 14.6624 5.25 13.9375 5.25C13.2126 5.25 12.625 5.83763 12.625 6.5625C12.625 7.28737 13.2126 7.875 13.9375 7.875Z",
        fill: color
    }));
};
var PaydotImage = function PaydotImage() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "157",
        height: "107",
        viewBox: "0 0 157 107",
        fill: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Illustration - Pay-Dot"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "Primary - 40",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M62.2137 0.512451C60.5541 0.512451 59.1911 1.7938 59.0407 3.43043C58.7254 3.2024 58.3403 3.06671 57.923 3.06671C56.8611 3.06671 56 3.93641 56 5.00917C56 6.08178 56.8611 6.95147 57.923 6.95147H66.6275C67.8704 6.95147 68.8781 5.9337 68.8781 4.67823C68.8781 3.42293 67.8704 2.40514 66.6275 2.40514C66.1222 2.40514 65.6575 2.57544 65.2818 2.85936C64.905 1.50543 63.6747 0.512451 62.2137 0.512451ZM129.102 5.48762C127.233 5.48762 125.641 6.65839 125.008 8.30534C124.847 8.25984 124.678 8.23416 124.502 8.23416C123.904 8.23416 123.373 8.51531 123.029 8.95151C122.681 8.79484 122.296 8.70546 121.89 8.70546C120.355 8.70546 119.11 9.95067 119.11 11.4868C119.11 13.0229 120.355 14.2681 121.89 14.2681H133.891C135.426 14.2681 136.671 13.0229 136.671 11.4868C136.671 9.95067 135.426 8.70546 133.891 8.70546C133.703 8.70546 133.519 8.72464 133.342 8.76039C132.847 6.87779 131.139 5.48762 129.102 5.48762ZM6.29173 39.5044C6.96652 37.7476 8.6644 36.4988 10.6579 36.4988C12.8309 36.4988 14.6525 37.9817 15.18 39.9898C15.3696 39.9516 15.5654 39.9312 15.7664 39.9312C17.404 39.9312 18.7317 41.2594 18.7317 42.8979C18.7317 44.5364 17.404 45.8647 15.7664 45.8647H2.96567C1.32776 45.8647 0 44.5364 0 42.8979C0 41.2594 1.32776 39.9312 2.96567 39.9312C3.39923 39.9312 3.80957 40.0265 4.18076 40.1936C4.54674 39.7284 5.11339 39.4285 5.75143 39.4285C5.93893 39.4285 6.11983 39.4558 6.29173 39.5044ZM41 26.4875C39.3431 26.4875 38 27.8307 38 29.4875V34.4875H119V29.4875C119 27.8307 117.657 26.4875 116 26.4875H41ZM78.5 97.4875C89.2695 97.4875 98 99.5023 98 101.988C98 104.473 89.2695 106.488 78.5 106.488C67.7309 106.488 59 104.473 59 101.988C59 99.5023 67.7309 97.4875 78.5 97.4875ZM137 35.5125C135.895 35.5125 135 36.4079 135 37.5125V51.5125C135 52.617 135.895 53.5125 137 53.5125H151C152.105 53.5125 153 52.617 153 51.5125V49.5125H141C139.895 49.5125 139 48.617 139 47.5125V35.5125H137Z",
        fill: "#B1BDF1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "White",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38 35.5H119V88.5C119 90.1569 117.657 91.5 116 91.5H41C39.3431 91.5 38 90.1569 38 88.5V35.5ZM131 41.5125C131 40.4079 131.895 39.5125 133 39.5125H135V51.5125C135 52.617 135.895 53.5125 137 53.5125H149V55.5125C149 56.617 148.105 57.5125 147 57.5125H133C131.895 57.5125 131 56.617 131 55.5125V41.5125ZM148.651 43.7605V44.5125H147.283V43.7649C145.957 43.6163 145.118 43.013 145 41.8676L146.677 41.8545C146.804 42.3616 147.283 42.6458 147.984 42.6458C148.613 42.6458 148.988 42.3441 148.988 41.9638C148.988 41.5398 148.689 41.3999 148.064 41.2862L146.97 41.0939C145.914 40.9146 145.218 40.3201 145.204 39.2928C145.189 38.248 146.08 37.5529 147.297 37.3693V36.5125H148.666V37.3737C149.878 37.5791 150.617 38.3354 150.584 39.2622L148.95 39.2709C148.888 38.7988 148.694 38.4797 148.007 38.4797C147.273 38.4797 146.928 38.7726 146.928 39.1135C146.928 39.4458 147.112 39.6119 147.785 39.7562L148.869 39.9791C150.157 40.2458 150.697 40.954 150.697 41.9638C150.697 42.9299 149.921 43.5944 148.651 43.7605Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "Cool Gray - 80",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41 26.4875H116C117.657 26.4875 119 27.8307 119 29.4875V34.4875H38V29.4875C38 27.8307 39.3431 26.4875 41 26.4875ZM120 35.4875V34.4875V29.4875C120 27.2784 118.209 25.4875 116 25.4875H41C38.7909 25.4875 37 27.2784 37 29.4875V34.4875V35.4875V81.5125H8.5C8.22386 81.5125 8 81.7363 8 82.0125C8 82.2886 8.22386 82.5125 8.5 82.5125H37V88.4875C37 90.6967 38.7909 92.4875 41 92.4875H116C118.209 92.4875 120 90.6967 120 88.4875V82.5125H149.5C149.776 82.5125 150 82.2886 150 82.0125C150 81.7363 149.776 81.5125 149.5 81.5125H120V35.4875ZM38 88.4875V82.5125V81.5125V35.4875H119V88.4875C119 90.1444 117.657 91.4875 116 91.4875H41C39.3431 91.4875 38 90.1444 38 88.4875ZM70 51.2375C68.9313 51.2375 68.1485 51.9136 67.7115 53.2247C67.5805 53.6177 67.1558 53.83 66.7628 53.6991C66.3699 53.5681 66.1575 53.1433 66.2885 52.7504C66.8515 51.0615 68.0687 49.7375 70 49.7375C71.9313 49.7375 73.1485 51.0615 73.7115 52.7504C73.8425 53.1433 73.6301 53.5681 73.2372 53.6991C72.8442 53.83 72.4195 53.6177 72.2885 53.2247C71.8515 51.9136 71.0687 51.2375 70 51.2375ZM84.7115 53.2247C85.1485 51.9136 85.9313 51.2375 87 51.2375C88.0687 51.2375 88.8515 51.9136 89.2885 53.2247C89.4195 53.6177 89.8442 53.83 90.2372 53.6991C90.6301 53.5681 90.8425 53.1433 90.7115 52.7504C90.1485 51.0615 88.9313 49.7375 87 49.7375C85.0687 49.7375 83.8515 51.0615 83.2885 52.7504C83.1575 53.1433 83.3699 53.5681 83.7628 53.6991C84.1558 53.83 84.5805 53.6177 84.7115 53.2247ZM70.75 65.4875C70.75 65.0733 70.4142 64.7375 70 64.7375C69.5858 64.7375 69.25 65.0733 69.25 65.4875V66.4875C69.25 68.0063 70.4812 69.2375 72 69.2375H85C86.5188 69.2375 87.75 68.0063 87.75 66.4875V65.4875C87.75 65.0733 87.4142 64.7375 87 64.7375C86.5858 64.7375 86.25 65.0733 86.25 65.4875V66.4875C86.25 67.1779 85.6904 67.7375 85 67.7375H72C71.3096 67.7375 70.75 67.1779 70.75 66.4875V65.4875ZM52 31.4875C52.5523 31.4875 53 31.0398 53 30.4875C53 29.9353 52.5523 29.4875 52 29.4875C51.4477 29.4875 51 29.9353 51 30.4875C51 31.0398 51.4477 31.4875 52 31.4875ZM48 30.4875C48 31.0398 47.5523 31.4875 47 31.4875C46.4477 31.4875 46 31.0398 46 30.4875C46 29.9353 46.4477 29.4875 47 29.4875C47.5523 29.4875 48 29.9353 48 30.4875ZM42 31.4875C42.5523 31.4875 43 31.0398 43 30.4875C43 29.9353 42.5523 29.4875 42 29.4875C41.4477 29.4875 41 29.9353 41 30.4875C41 31.0398 41.4477 31.4875 42 31.4875Z",
        fill: "#3B414D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "Primary",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M139 33.5125C139 32.4079 139.895 31.5125 141 31.5125H155C156.105 31.5125 157 32.4079 157 33.5125V47.5125C157 48.617 156.105 49.5125 155 49.5125H141C139.895 49.5125 139 48.617 139 47.5125V33.5125ZM148.651 44.5125V43.7605C149.921 43.5944 150.697 42.9299 150.697 41.9638C150.697 40.954 150.157 40.2458 148.869 39.9791L147.785 39.7562C147.112 39.6119 146.928 39.4458 146.928 39.1135C146.928 38.7726 147.273 38.4797 148.007 38.4797C148.694 38.4797 148.888 38.7988 148.95 39.2709L150.584 39.2622C150.617 38.3354 149.878 37.5791 148.666 37.3737V36.5125H147.297V37.3693C146.08 37.5529 145.189 38.248 145.204 39.2928C145.218 40.3201 145.914 40.9146 146.97 41.0939L148.064 41.2862C148.689 41.3999 148.988 41.5398 148.988 41.9638C148.988 42.3441 148.613 42.6458 147.984 42.6458C147.283 42.6458 146.804 42.3616 146.677 41.8545L145 41.8676C145.118 43.013 145.957 43.6163 147.283 43.7649V44.5125H148.651ZM135 62.4875C135 61.9353 135.448 61.4875 136 61.4875H146C146.552 61.4875 147 61.9353 147 62.4875C147 63.0398 146.552 63.4875 146 63.4875H140.926L129.345 75.5316C128.635 76.2695 127.483 76.3526 126.675 75.7241L120 70.4875V67.9875L127.903 74.1454L138.151 63.4875H136C135.448 63.4875 135 63.0398 135 62.4875ZM75 100.488V92.4875H77V100.488C77 101.592 76.1046 102.488 75 102.488H71C70.4477 102.488 70 102.04 70 101.488C70 100.935 70.4477 100.488 71 100.488H75ZM80 100.488V92.4875H82V100.488H86C86.5523 100.488 87 100.935 87 101.488C87 102.04 86.5523 102.488 86 102.488H82C80.8954 102.488 80 101.592 80 100.488ZM37 68.4875L31.8311 72.9439C30.5951 74.0151 31.0975 76.0363 32.6913 76.4041L50.0245 80.4041C50.2304 82.1407 51.7079 83.4875 53.5 83.4875H57C57.5523 83.4875 58 83.0398 58 82.4875C58 81.9353 57.5523 81.4875 57 81.4875H53.5C52.6716 81.4875 52 80.816 52 79.9875C52 79.1591 52.6716 78.4875 53.5 78.4875H54.5C55.0523 78.4875 55.5 78.0398 55.5 77.4875C55.5 76.9353 55.0523 76.4875 54.5 76.4875H53.5C52.1266 76.4875 50.9379 77.2786 50.3648 78.43L33.141 74.4553L37 70.9875V68.4875Z",
        fill: "#3B5BDB"
    })));
};
var VisaSmallIcon = function VisaSmallIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Visa"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.2387 16H0.761973C0.340958 16 0 15.6492 0 15.2168V0.783232C0 0.3508 0.340958 0 0.761973 0H23.2387C23.6598 0 24 0.3508 24 0.783232V15.2168C24 15.6492 23.6598 16 23.2387 16Z",
        fill: "#F6F6F9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        clipPath: "url(#clip0_3693_1186)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10.075 5.09143L7.98023 10.0892H6.61357L5.58274 6.10076C5.52016 5.8551 5.46574 5.7651 5.27541 5.6616C4.96466 5.49301 4.4515 5.33485 4 5.23668L4.03067 5.09143H6.23057C6.51099 5.09143 6.76307 5.2781 6.82674 5.60101L7.37115 8.493L8.71664 5.09135H10.075V5.09143ZM15.4298 8.45758C15.4353 7.13851 13.6058 7.06584 13.6184 6.47659C13.6223 6.29726 13.793 6.10659 14.1668 6.05793C14.352 6.03368 14.8624 6.01518 15.4414 6.28159L15.6684 5.22177C15.3574 5.10885 14.9571 5.00018 14.4591 5.00018C13.1812 5.00018 12.2819 5.67951 12.2743 6.65226C12.266 7.37175 12.9162 7.77325 13.406 8.01233C13.9099 8.25717 14.079 8.4145 14.0771 8.6335C14.0735 8.96875 13.6752 9.11675 13.303 9.12258C12.6531 9.13258 12.276 8.94675 11.9755 8.807L11.7411 9.90191C12.0432 10.0405 12.6008 10.1614 13.1789 10.1675C14.5371 10.1675 15.4256 9.49658 15.4298 8.45758ZM18.8043 10.0893H20L18.9563 5.09143H17.8526C17.6044 5.09143 17.3951 5.23593 17.3024 5.4581L15.3624 10.0892H16.7199L16.9894 9.34274H18.6482L18.8043 10.0892V10.0893ZM17.3617 8.3185L18.0422 6.44201L18.4338 8.3185H17.3617ZM11.9222 5.09143L10.8531 10.0892H9.5603L10.6298 5.09143H11.9222Z",
        fill: "#1434CB"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
        id: "clip0_3693_1186"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "16",
        height: "5.16731",
        fill: "white",
        transform: "translate(4 5)"
    }))));
};
var AmExSmallIcon = function AmExSmallIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "American Express"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        clipPath: "url(#clip0_3693_1095)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        clipPath: "url(#clip1_3693_1095)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M21.912 14.2507L20.8027 13.0133L19.6507 14.2507H17.3893H12.5253V8.49067H10.264L13.08 2.048H15.8107L16.792 4.26667V2.048H20.2053L20.8027 3.712L21.4 2.048H24.0027V1.06667C24.0027 0.469333 23.5333 0 22.936 0H0.0666666C-0.530667 0 -1 0.469333 -1 1.06667V14.9333C-1 15.5307 -0.530667 16 0.0666666 16H22.936C23.5333 16 24.0027 15.5307 24.0027 14.9333V14.2507H21.912Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M22.2107 13.568H24.0027L21.656 11.0507L24.0027 8.57599H22.2533L20.76 10.1973L19.3093 8.57599H17.5173L19.9067 11.0933L17.5173 13.568H19.2667L20.76 11.9467L22.2107 13.568Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.6585 12.416V11.648H17.4745V10.496H14.6585V9.72799H17.5172V8.57599H13.2932V13.568H17.5172V12.416H14.6585Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M22.68 7.85065H23.96V2.81598L21.912 2.85865L20.8027 5.97331L19.6507 2.85865H17.5173V7.85065H18.8827V4.35198L20.1627 7.85065H21.3573L22.68 4.35198V7.85065Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15.3413 2.85864H13.592L11.3733 7.85064H12.8666L13.2933 6.86931H15.5973L16.024 7.85064H17.56L15.3413 2.85864ZM13.7626 5.71731L14.4453 4.09598L15.128 5.71731H13.7626Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M22.7653 10.9226L24.0026 12.288V9.55731L22.7653 10.9226Z",
        fill: "#0071CE"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
        id: "clip0_3693_1095"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "24",
        height: "16",
        rx: "1",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
        id: "clip1_3693_1095"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "24",
        height: "16",
        fill: "white"
    }))));
};
var BankGenericSmallIcon = function BankGenericSmallIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 2C0 0.895431 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V14C24 15.1046 23.1046 16 22 16H2C0.89543 16 0 15.1046 0 14V2Z",
        fill: "#E4F4FD"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H22C22.5523 15 23 14.5523 23 14V2C23 1.44771 22.5523 1 22 1ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.895431 23.1046 0 22 0H2Z",
        fill: "#15749D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5 6C17.5 6.27614 17.2761 6.5 17 6.5H12C11.7238 6.5 11.5 6.27614 11.5 6C11.5 5.72386 11.7238 5.5 12 5.5H17C17.2761 5.5 17.5 5.72386 17.5 6Z",
        fill: "#15749D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.583 9.70019C15.5309 9.77382 15.5 9.87763 15.5 9.99998C15.5 10.2761 15.2761 10.5 15 10.5C14.7239 10.5 14.5 10.2761 14.5 9.99998C14.5 9.72073 14.5691 9.40159 14.767 9.12223C14.9715 8.8335 15.2863 8.62636 15.7006 8.54231C16.4861 8.38289 17.6234 8.66352 19.2428 9.56287C19.4842 9.69694 19.5712 10.0013 19.4371 10.2427C19.303 10.4842 18.9986 10.5712 18.7572 10.4371C17.1765 9.55919 16.3139 9.43823 15.8994 9.52233C15.7137 9.56003 15.6285 9.63593 15.583 9.70019Z",
        fill: "#15749D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.7306 9.51498C12.6173 9.54562 12.5 9.67145 12.5 9.99999C12.5 10.2761 12.2761 10.5 12 10.5C11.7239 10.5 11.5 10.2761 11.5 9.99999C11.5 9.52534 11.6827 8.76255 12.4694 8.54968C12.8296 8.45222 13.2416 8.50118 13.6926 8.66848C14.1458 8.83659 14.6755 9.13752 15.2976 9.59817C15.5195 9.7625 15.5662 10.0756 15.4018 10.2975C15.2375 10.5195 14.9244 10.5661 14.7024 10.4018C14.1245 9.97384 13.6792 9.73007 13.3449 9.60606C13.0084 9.48124 12.8204 9.49069 12.7306 9.51498Z",
        fill: "#15749D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7.54628 4H6.28841C6.23063 4 6.17522 4.02295 6.13437 4.06381C6.09351 4.10466 6.07056 4.16008 6.07056 4.21785V4.79803C4.90757 4.9927 4.21781 5.7639 4.21781 6.77533V6.79428C4.21781 8.08815 5.25783 8.46702 6.60474 8.77581C7.47427 8.9823 7.68075 9.11869 7.68075 9.38959V9.40853C7.68075 9.67943 7.4288 9.84235 6.94952 9.84235C6.26611 9.83533 5.60266 9.61109 5.05513 9.20205C5.00997 9.17064 4.95459 9.15747 4.90013 9.16521C4.84566 9.17294 4.79613 9.20099 4.7615 9.24372L4.05679 10.0829C4.03699 10.1051 4.02203 10.1312 4.01286 10.1595C4.0037 10.1878 4.00052 10.2177 4.00355 10.2473C4.00658 10.2769 4.01575 10.3055 4.03046 10.3313C4.04517 10.3572 4.0651 10.3797 4.08899 10.3974C4.67485 10.8412 5.35705 11.132 6.07428 11.2499V11.8106C6.07428 11.8608 6.09423 11.909 6.12976 11.9445C6.16528 11.98 6.21348 12 6.26372 12H7.57274C7.59809 12.0008 7.62333 11.9964 7.64698 11.9872C7.67062 11.9781 7.69218 11.9642 7.71037 11.9466C7.72857 11.9289 7.74304 11.9078 7.75291 11.8844C7.76279 11.861 7.76787 11.8359 7.76786 11.8106V11.2132C8.80451 10.9702 9.45011 10.2735 9.45011 9.24562V9.22857C9.45011 8.04268 8.54459 7.57287 7.09728 7.25651C6.21071 7.0576 5.99285 6.93067 5.99285 6.64083V6.62189C5.99285 6.38698 6.20124 6.2146 6.62747 6.2146C7.19674 6.22983 7.7502 6.40512 8.22444 6.7204C8.27194 6.75009 8.32911 6.76017 8.3839 6.74851C8.43868 6.73684 8.48679 6.70435 8.51807 6.65788L9.1527 5.76184C9.18577 5.71625 9.19954 5.65947 9.19103 5.60379C9.18252 5.54812 9.1524 5.49804 9.10722 5.46442C8.69767 5.18117 8.242 4.97799 7.76414 4.86188V4.21785C7.76414 4.16008 7.74119 4.10466 7.70033 4.06381C7.65948 4.02295 7.60406 4 7.54628 4Z",
        fill: "#15749D"
    }));
};
var CashSmallIcon = function CashSmallIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "24",
        height: "16",
        rx: "2",
        fill: "#E8FFEF"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M22 0C23.1046 0 24 0.895431 24 2V14C24 15.0357 23.2128 15.887 22.2041 15.9893L22 16H2L1.7959 15.9893C0.787223 15.887 0 15.0357 0 14V2C0 0.895431 0.895431 3.22128e-08 2 0H22ZM2 1C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H22C22.5523 15 23 14.5523 23 14V2C23 1.44771 22.5523 1 22 1H2ZM12.9434 2.93555V4.01953C14.3514 4.27803 15.2094 5.22951 15.1709 6.39551L13.2734 6.40625C13.2019 5.81251 12.9767 5.41127 12.1797 5.41113C11.3272 5.41113 10.9248 5.77998 10.9248 6.20898C10.925 6.62667 11.1402 6.83517 11.9209 7.0166L13.1807 7.29785C14.6763 7.63343 15.3037 8.52455 15.3037 9.79492C15.3035 11.0101 14.4013 11.8456 12.9277 12.0547V13.001H11.3379V12.0605C9.798 11.8736 8.82413 11.1146 8.68652 9.67383L10.6338 9.65723C10.7823 10.295 11.3377 10.6522 12.1514 10.6523C12.8827 10.6523 13.3171 10.2732 13.3174 9.79492C13.3174 9.26142 12.9711 9.08538 12.2451 8.94238L10.9746 8.7002C9.74818 8.47467 8.93935 7.72605 8.92285 6.43359C8.90658 5.11933 9.94114 4.24465 11.3545 4.01367V2.93555H12.9434Z",
        fill: "#317D4F"
    }));
};
var DiscoverSmallIcon = function DiscoverSmallIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Discover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        clipPath: "url(#clip0_3818_267)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M23.2096 0H0.790427C0.353057 0 0 0.368006 0 0.823893V15.1761C0 15.632 0.353057 16 0.790427 16H23.2096C23.6469 16 24 15.632 24 15.1761V0.823893C24 0.368006 23.6469 0 23.2096 0ZM22.8196 8C22.8196 12.265 19.5025 15.7254 15.4081 15.7254H0.790427C0.75354 15.7254 0.719289 15.7226 0.685037 15.7144C0.650785 15.7061 0.616533 15.6952 0.584916 15.6814C0.540125 15.6622 0.497969 15.632 0.461082 15.599C0.434735 15.5771 0.411022 15.5524 0.389944 15.5249C0.313536 15.4288 0.263476 15.3079 0.263476 15.1734V0.823893C0.263476 0.711294 0.297728 0.604188 0.353057 0.516306C0.371501 0.486097 0.392579 0.458634 0.416292 0.433917C0.463717 0.384483 0.521682 0.343289 0.584916 0.315826C0.616533 0.302094 0.650785 0.291109 0.685037 0.28287C0.719289 0.274631 0.75354 0.271885 0.790427 0.271885H15.4081C19.4998 0.271885 22.8196 3.72949 22.8196 7.99725V8Z",
        fill: "url(#paint0_linear_3818_267)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2.04452 6.1687H1.11182V9.28531H2.04189C2.53459 9.28531 2.89291 9.17454 3.20645 8.92531C3.57795 8.63077 3.79927 8.1877 3.79927 7.72952C3.79927 6.81065 3.07998 6.1687 2.04716 6.1687H2.04452ZM2.78752 8.50993C2.58728 8.68112 2.32907 8.75664 1.91805 8.75664H1.74679V6.69485H1.91805C2.32907 6.69485 2.57938 6.76534 2.78752 6.94659C3.00884 7.13288 3.14058 7.42491 3.14058 7.72197C3.14058 8.01903 3.00884 8.32112 2.78752 8.50741V8.50993Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M4.72409 6.1687H4.08911V9.28531H4.72409V6.1687Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.28125 7.36449C5.89921 7.22854 5.78855 7.14043 5.78855 6.97176C5.78855 6.7754 5.98879 6.62687 6.2628 6.62687C6.4525 6.62687 6.61059 6.7024 6.77658 6.87862L7.10856 6.46324C6.83454 6.23415 6.50783 6.11835 6.14951 6.11835C5.5725 6.11835 5.13249 6.501 5.13249 7.01204C5.13249 7.44253 5.338 7.66154 5.93609 7.86546C6.18376 7.94853 6.31286 8.00644 6.3761 8.04168C6.50257 8.11972 6.5658 8.23301 6.5658 8.36391C6.5658 8.61566 6.35502 8.80447 6.07047 8.80447C5.76747 8.80447 5.52244 8.65845 5.37489 8.38909L4.96387 8.76671C5.25633 9.17705 5.60938 9.36082 6.09418 9.36082C6.7555 9.36082 7.21922 8.94041 7.21922 8.33874C7.21922 7.8428 7.0058 7.61875 6.28125 7.367V7.36449Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7.41943 7.7295C7.41943 8.64585 8.17297 9.35577 9.13993 9.35577C9.41394 9.35577 9.64844 9.30542 9.93826 9.17452V8.45956C9.68269 8.70375 9.45874 8.80193 9.16891 8.80193C8.52867 8.80193 8.07285 8.35886 8.07285 7.72698C8.07285 7.12783 8.54184 6.65706 9.13993 6.65706C9.44293 6.65706 9.67215 6.76028 9.93826 7.00699V6.29203C9.65898 6.15609 9.42975 6.10071 9.15574 6.10071C8.19142 6.10071 7.41943 6.82573 7.41943 7.73202V7.7295Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.9837 8.2607L14.1116 6.1687H13.4187L14.8019 9.36335H15.1445L16.5541 6.1687H15.8638L14.9837 8.2607Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16.8413 9.28531H18.6461V8.75664H17.4763V7.91581H18.6013V7.38715H17.4763V6.69737H18.6461V6.1687H16.8413V9.28531Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M21.1649 7.08757C21.1649 6.50352 20.7433 6.1687 20.0109 6.1687H19.0676V9.28531H19.7026V8.03413H19.7869L20.6669 9.28531H21.4494L20.4219 7.9712C20.9014 7.87805 21.1649 7.56589 21.1649 7.08757ZM19.8897 7.60113H19.7026V6.65709H19.8976C20.2928 6.65709 20.5088 6.81569 20.5088 7.1203C20.5088 7.42491 20.2928 7.60113 19.887 7.60113H19.8897Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M21.6708 6.3323C21.6708 6.27691 21.6313 6.2467 21.5628 6.2467H21.4706V6.52111H21.5391V6.41537L21.6208 6.52111H21.7051L21.6102 6.40782C21.6497 6.39775 21.6735 6.37006 21.6735 6.3323H21.6708ZM21.5496 6.37006H21.5391V6.29705H21.5523C21.5865 6.29705 21.605 6.30964 21.605 6.3323C21.605 6.35495 21.5865 6.37006 21.5523 6.37006H21.5496Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M21.576 6.14349C21.4363 6.14349 21.3257 6.24923 21.3257 6.38265C21.3257 6.51608 21.439 6.62181 21.576 6.62181C21.713 6.62181 21.8237 6.51356 21.8237 6.38265C21.8237 6.25174 21.713 6.14349 21.576 6.14349ZM21.576 6.57901C21.4653 6.57901 21.3757 6.4909 21.3757 6.38265C21.3757 6.2744 21.4653 6.18629 21.576 6.18629C21.6866 6.18629 21.7736 6.27692 21.7736 6.38265C21.7736 6.48838 21.684 6.57901 21.576 6.57901Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        filter: "url(#filter0_i_3818_267)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "11.8334",
        cy: "7.75171",
        r: "1.76605",
        fill: "url(#paint1_linear_3818_267)"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("filter", {
        id: "filter0_i_3818_267",
        x: "10.0674",
        y: "5.98566",
        width: "3.7921",
        height: "3.7921",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feBlend", {
        mode: "normal",
        "in": "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        "in": "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feMorphology", {
        radius: "0.01",
        operator: "erode",
        "in": "SourceAlpha",
        result: "effect1_innerShadow_3818_267"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feOffset", {
        dx: "0.5",
        dy: "0.5"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feGaussianBlur", {
        stdDeviation: "0.125"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: "-1",
        k3: "1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_3818_267"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("linearGradient", {
        id: "paint0_linear_3818_267",
        x1: "31.9991",
        y1: "44.1909",
        x2: "3.48371",
        y2: "-3.30507",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        stopColor: "#F9A020"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        offset: "0.5",
        stopColor: "#F9A020"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        offset: "1",
        stopColor: "#DF5026"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("linearGradient", {
        id: "paint1_linear_3818_267",
        x1: "13.2656",
        y1: "8.85284",
        x2: "10.6562",
        y2: "6.41534",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        stopColor: "#EA953E"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        offset: "1",
        stopColor: "#D44B33"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
        id: "clip0_3818_267"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "24",
        height: "16",
        fill: "white"
    }))));
};
var GenericSmallIcon = function GenericSmallIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Credit card"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "24",
        height: "16",
        rx: "2",
        fill: "#15749D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M6.66663 11.5555C7.03482 11.5555 7.33362 11.8543 7.33362 12.2225C7.33344 12.5906 7.03471 12.8885 6.66663 12.8885H3.33362C2.96554 12.8885 2.6668 12.5906 2.66663 12.2225C2.66663 11.8543 2.96543 11.5555 3.33362 11.5555H6.66663ZM15.3336 11.5555C15.7017 11.5557 15.9996 11.8545 15.9996 12.2225C15.9995 12.5905 15.7015 12.8884 15.3336 12.8885H9.33362C8.96554 12.8885 8.6668 12.5906 8.66663 12.2225C8.66663 11.8543 8.96543 11.5555 9.33362 11.5555H15.3336Z",
        fill: "#E4F4FD"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16 7.56903H17.3154V8.66669H17C16.4477 8.66669 16 8.21897 16 7.66669V7.56903ZM19.1016 7.56903V8.66669H17.5654V7.56903H19.1016ZM20.667 7.66669C20.667 8.21885 20.2191 8.66649 19.667 8.66669H19.3516V7.56903H20.667V7.66669ZM16 6.23602H17.3154V7.31903H16V6.23602ZM20.667 7.31903H19.3516V6.23602H20.667V7.31903ZM19.1016 6.23602V7.31903H17.5654V6.23602H19.1016ZM17.3154 4.66669V5.98602H16V5.66669C16 5.1144 16.4477 4.66669 17 4.66669H17.3154ZM19.1016 4.66669V5.98602H17.5654V4.66669H19.1016ZM19.667 4.66669C20.2191 4.66688 20.667 5.11452 20.667 5.66669V5.98602H19.3516V4.66669H19.667Z",
        fill: "#F4C932"
    }));
};
var MasterCardSmallIcon = function MasterCardSmallIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Mastercard"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "24",
        height: "16",
        rx: "1",
        fill: "#F6F6F9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.4736 3.37988H9.51318V12.2939H14.4736V3.37988Z",
        fill: "#FF5F00"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9.82814 7.83688C9.82736 6.9784 10.0219 6.13099 10.397 5.35881C10.7722 4.58662 11.318 3.90991 11.9934 3.37989C11.1571 2.72254 10.1527 2.31374 9.09506 2.20022C8.03741 2.08671 6.96917 2.27304 6.01242 2.73794C5.05567 3.20284 4.24902 3.92755 3.68467 4.82922C3.12032 5.7309 2.82104 6.77316 2.82104 7.83688C2.82104 8.9006 3.12032 9.94286 3.68467 10.8445C4.24902 11.7462 5.05567 12.4709 6.01242 12.9358C6.96917 13.4007 8.03741 13.5871 9.09506 13.4735C10.1527 13.36 11.1571 12.9512 11.9934 12.2939C11.3181 11.7638 10.7722 11.0871 10.397 10.3149C10.0219 9.54276 9.82736 8.69536 9.82814 7.83688Z",
        fill: "#EB001B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M21.1655 7.83688C21.1655 8.90058 20.8663 9.94284 20.3019 10.8445C19.7376 11.7462 18.931 12.4709 17.9743 12.9358C17.0175 13.4007 15.9493 13.587 14.8917 13.4735C13.834 13.36 12.8297 12.9512 11.9934 12.2939C12.6681 11.7633 13.2136 11.0865 13.5887 10.3144C13.9637 9.54237 14.1586 8.69522 14.1586 7.83688C14.1586 6.97853 13.9637 6.13139 13.5887 5.35933C13.2136 4.58727 12.6681 3.91044 11.9934 3.37989C12.8297 2.72254 13.834 2.31374 14.8917 2.20022C15.9493 2.08671 17.0175 2.27305 17.9743 2.73796C18.931 3.20286 19.7376 3.92757 20.3019 4.82924C20.8663 5.73092 21.1655 6.77317 21.1655 7.83688Z",
        fill: "#F79E1B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M20.6247 11.3497V11.1672H20.6983V11.1301H20.5109V11.1672H20.5845V11.3497H20.6247ZM20.9885 11.3497V11.1297H20.9311L20.865 11.281L20.7989 11.1297H20.7414V11.3497H20.782V11.1838L20.844 11.3269H20.886L20.948 11.1834V11.3497H20.9885Z",
        fill: "#F79E1B"
    }));
};
var WireSmallIcon = function WireSmallIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "23",
        height: "15",
        rx: "1.5",
        fill: "#E4F4FD"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "0.5",
        y: "0.5",
        width: "23",
        height: "15",
        rx: "1.5",
        stroke: "#15749D"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M12.667 7.33324V10.6662H14V7.33324H12.667ZM10 10.6662H11.333V7.33324H10V10.6662ZM15.333 10.6662H15.75C15.888 10.6662 15.9999 10.7783 16 10.9162V11.7502C15.9998 11.8881 15.8879 12.0002 15.75 12.0002H8.25C8.11206 12.0002 8.00021 11.8881 8 11.7502V10.9162C8.00015 10.7783 8.11202 10.6662 8.25 10.6662H8.66699V7.33324H8.25C8.11195 7.33324 8.00003 7.22128 8 7.08324V6.15453C8 6.05983 8.05398 5.97324 8.13867 5.93089L11.8887 4.05589C11.9589 4.02092 12.0411 4.02092 12.1113 4.05589L15.8613 5.93089C15.946 5.97324 16 6.05983 16 6.15453V7.08324C16 7.22128 15.8881 7.33324 15.75 7.33324H15.333V10.6662Z",
        fill: "#15749D"
    }));
};
var VisaLargeIcon = function VisaLargeIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "36",
        height: "24",
        viewBox: "0 0 36 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Visa"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.858 24H1.14296C0.511437 24 0 23.4738 0 22.8252V1.17485C0 0.5262 0.511437 0 1.14296 0H34.858C35.4897 0 36 0.5262 36 1.17485V22.8252C36 23.4738 35.4897 24 34.858 24Z",
        fill: "#F6F6F9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        clipPath: "url(#clip0_visa_large)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M15.1125 7.63715L11.9703 15.1338H9.92036L8.37411 9.15114C8.28024 8.78265 8.19861 8.64765 7.91312 8.4924C7.44699 8.23952 6.67725 7.99227 6 7.85502L6.04601 7.63715H9.34586C9.71649 7.63715 10.0446 7.91715 10.1401 8.40152L10.9567 12.7395L13.0749 7.63702H15.1125V7.63715ZM23.1447 12.6864C23.153 10.7078 20.4087 10.5988 20.4276 9.71489C20.4335 9.44589 20.6895 9.15989 21.2502 9.08689C21.528 9.05052 22.2936 9.02277 23.162 9.42239L23.5026 7.83266C23.0361 7.66328 22.4357 7.50027 21.6887 7.50027C19.7718 7.50027 18.4229 8.51927 18.4115 9.97839C18.399 11.0576 19.3743 11.6599 20.109 12.0185C20.8649 12.3858 21.1185 12.6218 21.1157 12.9503C21.1103 13.4531 20.5128 13.6751 19.9545 13.6839C18.9797 13.6989 18.414 13.4201 17.9633 13.2105L17.6117 14.8529C17.9648 15.0608 18.9012 15.2421 19.7684 15.2513C21.8057 15.2513 23.1384 14.2449 23.1447 12.6864ZM28.2065 15.134H30L28.4345 7.63715H26.779C26.4066 7.63715 26.0927 7.85389 25.9536 8.18715L23.0436 15.1338H25.0799L25.4841 14.0141H27.9723L28.2065 15.1338V15.134ZM26.0426 12.4778L27.0633 9.66302L27.6507 12.4778H26.0426ZM17.8833 7.63715L16.2797 15.1338H14.3405L15.9447 7.63715H17.8833Z",
        fill: "#1434CB"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
        id: "clip0_visa_large"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "24",
        height: "7.75097",
        fill: "white",
        transform: "translate(6 7.5)"
    }))));
};
var AmExLargeIcon = function AmExLargeIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "36",
        height: "24",
        viewBox: "0 0 36 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "American Express"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        clipPath: "url(#clip0_amex_large)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        clipPath: "url(#clip1_amex_large)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M32.868 21.376L31.204 19.52L29.4761 21.376H26.084H18.788V12.736H15.396L19.62 3.072H23.7161L25.188 6.4V3.072H30.3079L31.204 5.568L32.1 3.072H36.004V1.6C36.004 0.704 35.2999 0 34.404 0H0.0999999C-0.795999 0 -1.5 0.704 -1.5 1.6V22.4C-1.5 23.296 -0.795999 24 0.0999999 24H34.404C35.2999 24 36.004 23.296 36.004 22.4V21.376H32.868Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M33.3161 20.352H36.004L32.484 16.576L36.004 12.864H33.38L31.14 15.296L28.9639 12.864H26.2759L29.86 16.64L26.2759 20.352H28.9L31.14 17.92L33.3161 20.352Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M21.9878 18.624V17.472H26.2118V15.744H21.9878V14.592H26.2759V12.864H19.9398V20.352H26.2759V18.624H21.9878Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M34.02 11.776H35.94V4.224L32.868 4.288L31.204 8.96L29.4761 4.288H26.2759V11.776H28.3241V6.528L30.244 11.776H32.036L34.02 6.528V11.776Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M23.012 4.28796H20.388L17.06 11.776H19.2999L19.94 10.304H23.396L24.036 11.776H26.34L23.012 4.28796ZM20.6439 8.57596L21.6679 6.14396L22.692 8.57596H20.6439Z",
        fill: "#0071CE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M34.148 16.3839L36.004 18.432V14.3359L34.148 16.3839Z",
        fill: "#0071CE"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
        id: "clip0_amex_large"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "36",
        height: "24",
        rx: "1.5",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
        id: "clip1_amex_large"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "36",
        height: "24",
        fill: "white"
    }))));
};
var DiscoverLargeIcon = function DiscoverLargeIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "36",
        height: "24",
        viewBox: "0 0 36 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Discover"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        clipPath: "url(#clip0_discover_large)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M34.8144 0H1.18564C0.529586 0 0 0.552009 0 1.23584V22.7642C0 23.448 0.529586 24 1.18564 24H34.8144C35.4704 24 36 23.448 36 22.7642V1.23584C36 0.552009 35.4704 0 34.8144 0ZM34.2294 12C34.2294 18.3975 29.2538 23.5881 23.1122 23.5881H1.18564C1.13031 23.5881 1.07893 23.5839 1.02756 23.5716C0.976178 23.5592 0.9248 23.5428 0.877374 23.5221C0.810188 23.4933 0.746954 23.448 0.691623 23.3985C0.652103 23.3657 0.616533 23.3286 0.584916 23.2874C0.470304 23.1432 0.395214 22.9619 0.395214 22.7601V1.23584C0.395214 1.06694 0.446592 0.906282 0.529586 0.774459C0.557252 0.729146 0.588869 0.687951 0.624438 0.650876C0.695576 0.576725 0.782523 0.514934 0.877374 0.47274C0.9248 0.453141 0.976178 0.436664 1.02756 0.424305C1.07893 0.411947 1.13031 0.407828 1.18564 0.407828H23.1122C29.2497 0.407828 34.2294 5.59424 34.2294 11.9959V12Z",
        fill: "url(#paint0_linear_discover_large)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M3.06678 9.25305H1.66773V13.928H3.06284C3.80189 13.928 4.33937 13.7618 4.80968 13.388C5.36693 12.9462 5.69891 12.2816 5.69891 11.5943C5.69891 10.2160 4.61997 9.25305 3.07074 9.25305H3.06678ZM4.18128 12.7649C3.88092 13.0217 3.49361 13.1350 2.87708 13.1350H2.62019V10.0423H2.87708C3.49361 10.0423 3.86907 10.1480 4.18128 10.4199C4.51326 10.6993 4.71087 11.1373 4.71087 11.583C4.71087 12.0286 4.51326 12.4817 4.18128 12.7612V12.7649Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M7.08614 9.25305H6.13367V13.928H7.08614V9.25305Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9.42188 11.0467C8.84882 10.8428 8.68283 10.7106 8.68283 10.4576C8.68283 10.1631 8.98319 9.94031 9.39413 9.94031C9.67875 9.94031 9.91589 10.0536 10.1649 10.318L10.6628 9.69486C10.2518 9.35123 9.76175 9.17725 9.22427 9.17725C8.35875 9.17725 7.69874 9.75150 7.69874 10.518C7.69874 11.1638 8.00700 11.4923 8.90415 11.7982C9.27567 11.9228 9.46929 12.0097 9.56415 12.0625C9.75386 12.1796 9.84870 12.3495 9.84870 12.5459C9.84870 12.9235 9.53253 13.2068 9.10578 13.2068C8.65113 13.2068 8.28366 12.9877 8.06241 12.5836L7.44586 13.1501C7.88445 13.7656 8.41407 14.0412 9.14119 14.0412C10.1331 14.0412 10.8286 13.4106 10.8286 12.5081C10.8286 11.7642 10.5087 11.4281 9.42188 11.1005V11.0467Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M11.1291 11.5943C11.1291 12.9688 12.2595 14.0336 13.7099 14.0336C14.1209 14.0336 14.4727 13.9581 14.9073 13.7618V12.6893C14.524 13.0556 14.1881 13.2029 13.7534 13.2029C12.7932 13.2029 12.1093 12.5383 12.1093 11.5905C12.1093 10.6917 12.8128 10.0056 13.7099 10.0056C14.1644 10.0056 14.5082 10.1604 14.9073 10.5105V9.43804C14.4885 9.23414 14.1446 9.15106 13.7336 9.15106C12.2871 9.15106 11.1291 10.2386 11.1291 11.598V11.5943Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M22.4756 12.3911L21.1674 9.25305H20.1281L22.2029 14.045H22.7167L24.8312 9.25305H23.7957L22.4756 12.3911Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M25.262 13.928H27.9692V13.1350H26.2145V11.8737H27.902V11.0808H26.2145V10.0461H27.9692V9.25305H25.262V13.928Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M31.7474 10.6314C31.7474 9.75528 31.1150 9.25305 29.9164 9.25305H28.6014V13.928H29.5539V12.0512H29.6804L31.0004 13.928H32.1742L30.6329 11.9568C31.3519 11.8171 31.7474 11.3488 31.7474 10.6314ZM29.8346 11.4016H29.5539V9.98564H29.8464C30.4393 9.98564 30.7633 10.2236 30.7633 10.6805C30.7633 11.1374 30.4393 11.4016 29.8305 11.4016H29.8346Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M32.5062 9.49845C32.5062 9.41537 32.4469 9.37005 32.3442 9.37005H32.2059V9.78167H32.3087V9.62317L32.4312 9.78167H32.5577L32.4153 9.61173C32.4746 9.59663 32.5103 9.55509 32.5103 9.49845H32.5062ZM32.3244 9.55509H32.3087V9.44558H32.3285C32.3798 9.44558 32.4075 9.46446 32.4075 9.49845C32.4075 9.53244 32.3798 9.55509 32.3285 9.55509H32.3244Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M32.364 9.21524C32.1545 9.21524 31.9886 9.37385 31.9886 9.57398C31.9886 9.77412 32.1585 9.93272 32.364 9.93272C32.5695 9.93272 32.7355 9.77034 32.7355 9.57398C32.7355 9.37762 32.5695 9.21524 32.364 9.21524ZM32.364 9.86852C32.198 9.86852 32.0636 9.73635 32.0636 9.57398C32.0636 9.41160 32.198 9.27944 32.364 9.27944C32.5299 9.27944 32.6604 9.41538 32.6604 9.57398C32.6604 9.73258 32.526 9.86852 32.364 9.86852Z",
        fill: "#261F20"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        filter: "url(#filter0_i_discover_large)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: "17.7501",
        cy: "11.6276",
        r: "2.64908",
        fill: "url(#paint1_linear_discover_large)"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("filter", {
        id: "filter0_i_discover_large",
        x: "15.1011",
        y: "8.9785",
        width: "5.68815",
        height: "5.68815",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feBlend", {
        mode: "normal",
        "in": "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        "in": "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feMorphology", {
        radius: "0.015",
        operator: "erode",
        "in": "SourceAlpha",
        result: "effect1_innerShadow_discover_large"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feOffset", {
        dx: "0.75",
        dy: "0.75"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feGaussianBlur", {
        stdDeviation: "0.1875"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: "-1",
        k3: "1"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_discover_large"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("linearGradient", {
        id: "paint0_linear_discover_large",
        x1: "47.9987",
        y1: "66.2864",
        x2: "5.22557",
        y2: "-4.9576",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        stopColor: "#F9A020"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        offset: "0.5",
        stopColor: "#F9A020"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        offset: "1",
        stopColor: "#DF5026"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("linearGradient", {
        id: "paint1_linear_discover_large",
        x1: "19.8984",
        y1: "13.2793",
        x2: "15.9843",
        y2: "9.62301",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        stopColor: "#EA953E"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("stop", {
        offset: "1",
        stopColor: "#D44B33"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("clipPath", {
        id: "clip0_discover_large"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "36",
        height: "24",
        fill: "white"
    }))));
};
var MasterCardLargeIcon = function MasterCardLargeIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "36",
        height: "24",
        viewBox: "0 0 36 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": "Mastercard"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "36",
        height: "24",
        rx: "1.5",
        fill: "#F6F6F9"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M21.7104 5.06982H14.2698V18.4409H21.7104V5.06982Z",
        fill: "#FF5F00"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M14.7422 11.7553C14.7410 10.4676 14.9329 9.19649 15.5955 8.03822C16.2583 6.87993 17.1270 5.86487 18.0001 5.06984C16.7357 4.08381 15.2291 3.47061 13.6426 3.30033C12.0561 3.13007 10.4538 3.40956 9.01863 4.10691C7.58351 4.80426 6.37353 5.89133 5.52701 7.24383C4.6805 8.59635 4.23156 10.1597 4.23156 11.7553C4.23156 13.3509 4.6805 14.9143 5.52701 16.2668C6.37353 17.6193 7.58351 18.7064 9.01863 19.4037C10.4538 20.1011 12.0561 20.3806 13.6426 20.2103C15.2291 20.0400 16.7357 19.4268 18.0001 18.4408C17.1272 17.6457 16.2583 16.6307 15.5955 15.4724C14.9329 14.3141 14.7410 13.043 14.7422 11.7553Z",
        fill: "#EB001B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M31.7483 11.7553C31.7483 13.3509 31.2994 14.9143 30.4529 16.2668C29.6064 17.6193 28.3965 18.7064 26.9614 19.4037C25.5263 20.1011 23.924 20.3805 22.3376 20.2103C20.751 20.04 19.2446 19.4268 17.9801 18.4408C18.8522 17.6450 19.5204 16.6298 19.9831 15.4716C20.4456 14.3136 20.7379 13.0428 20.7379 11.7553C20.7379 10.4678 20.4456 9.19709 19.9831 8.03899C19.5204 6.88091 18.8522 5.86566 17.9801 5.06984C19.2446 4.08381 20.751 3.47061 22.3376 3.30033C23.924 3.13006 25.5263 3.40958 26.9614 4.10694C28.3965 4.80429 29.6064 5.89136 30.4529 7.24386C31.2994 8.59638 31.7483 10.1598 31.7483 11.7553Z",
        fill: "#F79E1B"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M30.9371 17.0246V16.7508H31.0475V16.6952H30.7664V16.7508H30.8768V17.0246H30.9371ZM31.4828 17.0246V16.6946H31.3967L31.2977 16.9215L31.1984 16.6946H31.1121V17.0246H31.173V16.7757L31.266 16.9904H31.329L31.422 16.7751V17.0246H31.4828Z",
        fill: "#F79E1B"
    }));
};
var withWindowSize = function withWindowSize(Child) {
    return function(_ref) {
        var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
        var _useState = (0, _react.useState)({
            isMobile: window.innerWidth < MOBILE_WIDTH,
            mobileWidth: MOBILE_WIDTH,
            supportsTouch: "ontouchstart" in window || navigator.maxTouchPoints > 1
        }), _useState2 = _slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
        var isMobileRef = (0, _react.useRef)(state.isMobile);
        var onResize = throttle(25, function() {
            var width = window.innerWidth;
            var newMobileState = width <= MOBILE_WIDTH;
            if (newMobileState !== isMobileRef.current) {
                isMobileRef.current = newMobileState;
                setState({
                    isMobile: width <= MOBILE_WIDTH,
                    mobileWidth: MOBILE_WIDTH,
                    supportsTouch: "ontouchstart" in window || navigator.maxTouchPoints > 1
                });
            }
        });
        (0, _react.useLayoutEffect)(function() {
            window.addEventListener("resize", onResize);
            return function() {
                window.removeEventListener("resize", onResize);
            };
        }, []);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledComponents.ThemeProvider), {
            theme: state
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Child, props));
    };
};
var CardVariantSwitcher = function CardVariantSwitcher(_ref) {
    var variant = _ref.variant, children = _ref.children;
    return variant === "vertical" ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, children) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        extraStyles: "width: 100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "0",
        maxWidth: "100%",
        fullHeight: true
    }, children));
};
var CardRegistryCard = function CardRegistryCard(_ref2) {
    var themeValues = _ref2.themeValues, icon = _ref2.icon, heading = _ref2.heading, text = _ref2.text, _ref2$cardAction = _ref2.cardAction, cardAction = _ref2$cardAction === void 0 ? "/profile" : _ref2$cardAction, buttonText = _ref2.buttonText, _ref2$variant = _ref2.variant, variant = _ref2$variant === void 0 ? "vertical" : _ref2$variant;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    var navigate = (0, _reactRouterDom.useNavigate)();
    var renderIcon = function renderIcon(icon) {
        switch(icon){
            case "accounts":
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(AccountsAddIcon$1, null);
            case "properties":
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(PropertiesAddIcon$1, null);
            case "payment":
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(PaymentMethodAddIcon$1, null);
            default:
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(PaymentMethodAddIcon$1, null);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: themeValues.backgroundColor,
        borderRadius: "4px",
        boxShadow: " 0px 1px 10px 0px rgb(246, 246, 249), 0px 2px 5px 0px rgb(202, 206, 216)",
        padding: "0",
        maxWidth: variant !== "vertical" ? "100%" : "306px",
        minHeight: "100%",
        minWidth: variant !== "vertical" && "300px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        singleChild: true,
        fillCenter: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        direction: variant === "vertical" ? "column" : "row",
        justify: variant === "vertical" && "space-evenly",
        fullHeight: true,
        childGap: "0"
    }, icon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        background: themeValues.iconBackgroundColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        direction: variant === "vertical" ? "row" : "column",
        justify: "center",
        fullHeight: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: variant === "vertical" ? "0.5rem 0" : isMobile ? "1rem 1.5rem" : "2rem 2.5rem"
    }, renderIcon(icon)))), /*#__PURE__*/ (0, _reactDefault.default).createElement(CardVariantSwitcher, {
        variant: variant
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1rem",
        width: "100%",
        extraStyles: "flex-grow: 1; width: 100%;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        singleChild: true,
        fillCenter: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: "p",
        weight: "600"
    }, heading), /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pS"
    }, text)))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0.5rem 1rem 1rem",
        extraStyles: "display: flex; justify-content: center;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        variant: "smallPrimary",
        text: buttonText,
        action: function action() {
            return navigate(cardAction);
        },
        extraStyles: "width: 100%;"
    }))))));
};
var CardRegistryCard$1 = themeComponent(withWindowSize(CardRegistryCard), "CardRegistryCard", fallbackValues$a);
var cardRegistry = {
    accounts: function accounts(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(CardRegistryCard$1, _extends({
            icon: "accounts",
            heading: "Find Your Account",
            buttonText: "Find Account",
            text: "Find and attach your accounts to make your payments simple.",
            cardAction: "/profile/accounts"
        }, props));
    },
    properties: function properties(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(CardRegistryCard$1, _extends({
            icon: "properties",
            heading: "Find Your Property",
            buttonText: "Find Property",
            text: "Find and attach your properties to make your tax payments simple.",
            cardAction: "/profile/properties"
        }, props));
    },
    payment: function payment(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(CardRegistryCard$1, _extends({
            icon: "payment",
            heading: "Manage Your Wallet",
            buttonText: "Go to Wallet",
            text: "Add your personal information and payment methods to make fast payments.",
            cardAction: "/profile/wallet"
        }, props));
    }
};
var backgroundColor$2 = {
    "default": "".concat(TRANSPARENT)
};
var textFontSize = {
    "default": "1.1rem"
};
var textFontWeight = {
    "default": "400"
};
var textLineHeight = {
    "default": "2rem"
};
var textColor = {
    "default": "".concat(CHARADE_GREY)
};
var disabledCheckColor = {
    "default": "".concat(WHITE, ";")
};
var checkColor = {
    "default": "".concat(WHITE, ";")
};
var errorStyles = {
    "default": "border: 1px solid ".concat(RED, ";")
};
var focusedStyles = {
    "default": "\n    outline: 3px solid ".concat(ROYAL_BLUE, "; \n    outline-offset: 3px;\n  ")
};
var disabledCheckedStyles = {
    "default": "\n  background: #6d717e;\n  border: 1px solid #6d717e;\n"
};
var disabledStyles = {
    "default": "\n  background: ".concat(SEASHELL_WHITE, ";\n  border: 1px solid ").concat(STORM_GREY, ";\n")
};
var checkedStyles = {
    "default": "\n  background: ".concat(MATISSE_BLUE, ";    \n  border: 1px solid ").concat(MATISSE_BLUE, ";\n")
};
var defaultStyles = {
    "default": "\n  background: ".concat(WHITE, "; \n  border: 1px solid ").concat(STORM_GREY, ";\n")
};
var fallbackValues$c = {
    backgroundColor: backgroundColor$2,
    textFontSize: textFontSize,
    textFontWeight: textFontWeight,
    textLineHeight: textLineHeight,
    textColor: textColor,
    disabledCheckColor: disabledCheckColor,
    checkColor: checkColor,
    errorStyles: errorStyles,
    focusedStyles: focusedStyles,
    disabledStyles: disabledStyles,
    checkedStyles: checkedStyles,
    defaultStyles: defaultStyles,
    disabledCheckedStyles: disabledCheckedStyles
};
var ENTER = 13;
var ESCAPE = 27;
var SPACE_KEY = " ";
var _excluded$x = [
    "title",
    "name",
    "checked",
    "onChange",
    "disabled",
    "themeValues",
    "hidden",
    "error",
    "isRequired",
    "checkboxMargin",
    "extraStyles",
    "textExtraStyles",
    "labelledById",
    "dataQa",
    "checkboxExtraStyles",
    "hasIconOverride",
    "icon",
    "customAriaLabel"
];
var CheckboxContainer = (0, _styledComponentsDefault.default).span.withConfig({
    displayName: "Checkbox__CheckboxContainer",
    componentId: "sc-36kqbv-0"
})([
    "display:inline-block;vertical-align:middle;"
]);
var CheckboxLabelContainer = (0, _styledComponentsDefault.default).label.withConfig({
    displayName: "Checkbox__CheckboxLabelContainer",
    componentId: "sc-36kqbv-1"
})([
    "display:flex;align-items:center;column-gap:1rem;cursor:pointer;"
]);
var CheckboxIcon = (0, _styledComponentsDefault.default).svg.withConfig({
    displayName: "Checkbox__CheckboxIcon",
    componentId: "sc-36kqbv-2"
})([
    "fill:none;stroke-width:2px;stroke:",
    ";"
], function(_ref) {
    var disabled = _ref.disabled, disabledCheckColor = _ref.disabledCheckColor, checkColor = _ref.checkColor;
    return disabled ? (0, _styledComponents.css)([
        "",
        ""
    ], disabledCheckColor) : (0, _styledComponents.css)([
        "",
        ""
    ], checkColor);
});
var HiddenCheckbox = (0, _styledComponentsDefault.default).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "Checkbox__HiddenCheckbox",
    componentId: "sc-36kqbv-3"
})([
    "border:0;clip:rect(0 0 0 0);clippath:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px;"
]);
var StyledCheckbox = (0, _styledComponentsDefault.default).span.withConfig({
    displayName: "Checkbox__StyledCheckbox",
    componentId: "sc-36kqbv-4"
})([
    "display:inline-block;width:24px;height:24px;border-radius:2px;transition:all 150ms;",
    "{visibility:",
    ";}",
    ";",
    ""
], CheckboxIcon, function(_ref2) {
    var checked = _ref2.checked;
    return checked ? "visible" : "hidden";
}, function(_ref3) {
    var error = _ref3.error, disabled = _ref3.disabled, checked = _ref3.checked, focused = _ref3.focused, defaultStyles = _ref3.defaultStyles, checkedStyles = _ref3.checkedStyles, focusedStyles = _ref3.focusedStyles, errorStyles = _ref3.errorStyles, disabledStyles = _ref3.disabledStyles, disabledCheckedStyles = _ref3.disabledCheckedStyles;
    return error ? (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], errorStyles, focused && focusedStyles) : disabled ? (0, _styledComponents.css)([
        "",
        ""
    ], checked ? disabledCheckedStyles : disabledStyles) : checked ? (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], checkedStyles, focused && focusedStyles) : (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], defaultStyles, focused && focusedStyles);
}, function(_ref4) {
    var checkboxExtraStyles = _ref4.checkboxExtraStyles;
    return (0, _styledComponents.css)([
        "",
        ""
    ], checkboxExtraStyles);
});
var Checkbox = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref5, ref) {
    var title = _ref5.title, name = _ref5.name, checked = _ref5.checked, _ref5$onChange = _ref5.onChange, onChange = _ref5$onChange === void 0 ? noop$1 : _ref5$onChange, _ref5$disabled = _ref5.disabled, disabled = _ref5$disabled === void 0 ? false : _ref5$disabled, themeValues = _ref5.themeValues, _ref5$hidden = _ref5.hidden, hidden = _ref5$hidden === void 0 ? false : _ref5$hidden, _ref5$error = _ref5.error, error = _ref5$error === void 0 ? false : _ref5$error, _ref5$isRequired = _ref5.isRequired, isRequired = _ref5$isRequired === void 0 ? false : _ref5$isRequired, _ref5$checkboxMargin = _ref5.checkboxMargin, checkboxMargin = _ref5$checkboxMargin === void 0 ? "0 16px 0 0" : _ref5$checkboxMargin, extraStyles = _ref5.extraStyles, textExtraStyles = _ref5.textExtraStyles, labelledById = _ref5.labelledById, _ref5$dataQa = _ref5.dataQa, dataQa = _ref5$dataQa === void 0 ? null : _ref5$dataQa, checkboxExtraStyles = _ref5.checkboxExtraStyles, _ref5$hasIconOverride = _ref5.hasIconOverride, hasIconOverride = _ref5$hasIconOverride === void 0 ? false : _ref5$hasIconOverride, Icon = _ref5.icon, customAriaLabel = _ref5.customAriaLabel, rest = _objectWithoutProperties(_ref5, _excluded$x);
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var handleKeyDown = function handleKeyDown(e, func) {
        if ((e.key === SPACE_KEY || e.key === "Enter") && !disabled) {
            e.preventDefault();
            func();
        }
    };
    var normalizeName = name ? name.replace(/\s+/g, "-") : "";
    var checkboxId = "checkbox-".concat(normalizeName);
    var titleId = title ? "checkboxlabel-".concat(normalizeName) : undefined;
    var ariaLabelledById = customAriaLabel ? undefined : labelledById !== null && labelledById !== void 0 ? labelledById : titleId;
    var ariaLabel = ariaLabelledById ? undefined : customAriaLabel !== null && customAriaLabel !== void 0 ? customAriaLabel : name;
    var errorMessageNormalized = error ? "".concat(normalizeName, "-error-message") : undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        ref: ref,
        padding: "0",
        tabIndex: "0",
        role: "checkbox",
        "aria-checked": checked,
        "aria-required": isRequired || undefined,
        "aria-invalid": error,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledById,
        "aria-describedby": errorMessageNormalized,
        onFocus: function onFocus() {
            return setFocused(true);
        },
        onBlur: function onBlur() {
            return setFocused(false);
        },
        onClick: function onClick(e) {
            if (e.target === e.currentTarget && !disabled) onChange();
        },
        onKeyDown: function onKeyDown(e) {
            return handleKeyDown(e, onChange);
        },
        hiddenStyles: hidden,
        background: themeValues.backgroundColor,
        extraStyles: "\n          :focus {\n            outline: 0;\n          }\n          ".concat(extraStyles, "; \n          margin: ").concat(checkboxMargin, ";\n        ")
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement(CheckboxLabelContainer, {
        "data-qa": dataQa
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CheckboxContainer, {
        "data-qa": "Checkbox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(HiddenCheckbox, {
        id: checkboxId,
        disabled: disabled,
        name: name,
        checked: checked,
        onChange: onChange,
        tabIndex: "-1",
        required: isRequired,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledCheckbox, {
        "aria-hidden": "true",
        error: error,
        disabled: disabled,
        checked: checked,
        focused: focused,
        defaultStyles: themeValues.defaultStyles,
        checkedStyles: themeValues.checkedStyles,
        errorStyles: themeValues.errorStyles,
        disabledStyles: themeValues.disabledStyles,
        disabledCheckedStyles: themeValues.disabledCheckedStyles,
        focusedStyles: themeValues.focusedStyles,
        checkboxExtraStyles: checkboxExtraStyles
    }, hasIconOverride ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, null) : /*#__PURE__*/ (0, _reactDefault.default).createElement(CheckboxIcon, {
        viewBox: "0 0 24 24",
        disabled: disabled,
        disabledCheckColor: themeValues.disabledCheckColor,
        checkColor: themeValues.checkColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("polyline", {
        points: "20 6 9 17 4 12"
    })))), title && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        id: titleId,
        variant: "p",
        weight: themeValues.textFontWeight,
        color: themeValues.textColor,
        extraStyles: textExtraStyles ? "".concat(textExtraStyles, " ").concat(disabled && "color: #6e727e; background-color: #f7f7f7;", " ") : "margin-left: 1rem ".concat(disabled && "color: #6e727e; background-color: #f7f7f7;")
    }, title)));
});
var Checkbox$1 = themeComponent(Checkbox, "Checkbox", fallbackValues$c, "default");
var listBackgroundColor = {
    "default": "".concat(ATHENS_GREY),
    disabled: "".concat(WHITE)
};
var listItemColor = {
    "default": "".concat(MINESHAFT_GREY),
    disabled: "".concat(STORM_GREY)
};
var listItemBackgroundColor = {
    "default": "".concat(WHITE),
    disabled: "".concat(ATHENS_GREY)
};
var listItemBorderColor = {
    "default": "".concat(GHOST_GREY),
    disabled: "".concat(GHOST_GREY)
};
var radioButtonActive = {
    "default": "".concat(BOSTON_BLUE),
    disabled: "".concat(GHOST_GREY)
};
var radioButtonInactive = {
    "default": "".concat(GHOST_GREY),
    disabled: "".concat(GHOST_GREY)
};
var fallbackValues$d = {
    listBackgroundColor: listBackgroundColor,
    listItemColor: listItemColor,
    listItemBackgroundColor: listItemBackgroundColor,
    listItemBorderColor: listItemBorderColor,
    radioButtonActive: radioButtonActive,
    radioButtonInactive: radioButtonInactive
};
/*
Need to add a new color? Visit http://chir.ag/projects/name-that-color to generate a color name.

Name already taken? If you can't use the existing color, then use thesaurus.com to pick a similar name
to the one generated by name-that-color.
*/ var PEWTER_GREY$1 = "#DFE1E4";
var MARINER_BLUE$1 = "#2E75D2";
var defaultTheme = {
    theme: {
        accentColor: MARINER_BLUE$1,
        inactiveColor: PEWTER_GREY$1
    }
};
var RadioButtonBorder = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "radio-button__RadioButtonBorder",
    componentId: "sc-8odgi0-0"
})([
    "height:24px;width:24px;border:1px solid ",
    ";border-radius:12px;display:flex;justify-content:center;align-items:center;margin:10px;min-width:24px;min-height:24px;"
], function(_ref) {
    var isSelected = _ref.isSelected, theme = _ref.theme;
    return isSelected ? theme.accentColor : theme.inactiveColor;
});
RadioButtonBorder.defaultProps = defaultTheme;
var RadioButtonCenter = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "radio-button__RadioButtonCenter",
    componentId: "sc-8odgi0-1"
})([
    "height:16px;width:16px;background-color:",
    ";border-radius:8px;"
], function(_ref2) {
    var theme = _ref2.theme;
    return theme.accentColor;
});
RadioButtonCenter.defaultProps = defaultTheme;
var RadioButton = function RadioButton(_ref3) {
    var isSelected = _ref3.isSelected, name = _ref3.name;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(RadioButtonBorder, {
        isSelected: isSelected,
        name: name,
        "aria-checked": isSelected
    }, isSelected && /*#__PURE__*/ (0, _reactDefault.default).createElement(RadioButtonCenter, null));
};
var CheckboxItemIcon = (0, _styledComponentsDefault.default).img.withConfig({
    displayName: "CheckboxList__CheckboxItemIcon",
    componentId: "sc-1yakme1-0"
})([
    "width:2rem;"
]);
var HiddenCheckboxInput = (0, _styledComponentsDefault.default).input.withConfig({
    displayName: "CheckboxList__HiddenCheckboxInput",
    componentId: "sc-1yakme1-1"
})([
    "opacity:0;position:absolute;z-index:-2;cursor:pointer;"
]);
var CheckboxLabel = (0, _styledComponentsDefault.default).label.withConfig({
    displayName: "CheckboxList__CheckboxLabel",
    componentId: "sc-1yakme1-2"
})([
    "position:relative;z-index:5;&:focus{outline:none;}"
]);
var CheckboxListItem = function CheckboxListItem(_ref) {
    var text = _ref.text, render = _ref.render, isSelected = _ref.isSelected, onSelect = _ref.onSelect, index = _ref.index, name = _ref.name, imageUrl = _ref.imageUrl, image = _ref.image, _ref$imageAlt = _ref.imageAlt, imageAlt = _ref$imageAlt === void 0 ? "checkbox icon" : _ref$imageAlt, disabled = _ref.disabled, borderColor = _ref.borderColor, color = _ref.color, background = _ref.background, radioButtonActive = _ref.radioButtonActive, radioButtonInactive = _ref.radioButtonInactive;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0.875rem",
        borderRadius: "4px",
        minWidth: "30%",
        onClick: disabled ? noop$1 : onSelect,
        borderColor: borderColor,
        borderSize: "1px",
        color: color,
        background: background,
        extraStyles: "cursor: pointer;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "flex-start",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(HiddenCheckboxInput, {
        id: "checkbox-".concat(name, "-").concat(index)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(CheckboxLabel, {
        name: name,
        "aria-label": name,
        htmlFor: "checkbox-".concat(name, "-").concat(index),
        onClick: disabled ? noop$1 : onSelect,
        onKeyDown: disabled ? noop$1 : onSelect,
        tabIndex: 0
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledComponents.ThemeProvider), {
        theme: {
            accentColor: radioButtonActive,
            inactiveColor: radioButtonInactive
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(RadioButton, {
        name: name,
        isSelected: isSelected
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0rem 0.5rem 0rem 0rem",
        hiddenStyles: !imageUrl
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "flex-start",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CheckboxItemIcon, {
        src: imageUrl,
        alt: imageAlt
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0rem 0.5rem 0rem 0rem",
        hiddenStyles: !image
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "flex-start",
        align: "center"
    }, image)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "p",
        isSelected: isSelected
    }, text ? text : render())));
};
var CheckboxList = function CheckboxList(_ref2) {
    var items = _ref2.items, selectedName = _ref2.selectedName, _onSelect = _ref2.onSelect, variant = _ref2.variant, _ref2$breakpoint = _ref2.breakpoint, breakpoint = _ref2$breakpoint === void 0 ? "30rem" : _ref2$breakpoint, themeValues = _ref2.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0rem",
        background: themeValues.listBackgroundColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Switcher, {
        childGap: "0.5rem",
        breakpoint: breakpoint,
        maxChildren: 0
    }, items.map(function(item, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(CheckboxListItem, {
            color: themeValues.listItemColor,
            background: themeValues.listItemBackgroundColor,
            borderColor: themeValues.listItemBorderColor,
            key: "checkbox-item-".concat(item.name),
            text: item.text,
            render: item.render,
            isSelected: item.name === selectedName,
            onSelect: function onSelect(evt) {
                return _onSelect(evt, item);
            },
            index: index,
            imageUrl: item.imageUrl,
            image: item.image,
            name: item.name,
            disabled: variant === "disabled",
            radioButtonActive: themeValues.radioButtonActive,
            radioButtonInactive: themeValues.radioButtonInactive
        });
    })));
};
var CheckboxList$1 = themeComponent(CheckboxList, "CheckboxList", fallbackValues$d, "default");
var inactiveColor = MANATEE_GREY;
var activeColor$3 = CHARADE_GREY;
var fallbackValues$e = {
    inactiveColor: inactiveColor,
    activeColor: activeColor$3
};
var Table_styled = (0, _styledComponentsDefault.default).table.withConfig({
    displayName: "Tablestyled",
    componentId: "sc-mveye7-0"
})([
    "width:100%;table-layout:auto;border-collapse:collapse;",
    ""
], function(_ref) {
    var extraStyles = _ref.extraStyles;
    return extraStyles;
});
var TableBody_styled = (0, _styledComponentsDefault.default).tbody.withConfig({
    displayName: "TableBodystyled",
    componentId: "sc-wk5osr-0"
})([
    "",
    ""
], function(_ref) {
    var extraStyles = _ref.extraStyles;
    return extraStyles;
});
var TableCell_styled = (0, _styledComponentsDefault.default).td.withConfig({
    displayName: "TableCellstyled",
    componentId: "sc-iqndn8-0"
})([
    "padding:",
    ";font-size:",
    " white-space:nowrap;max-width:",
    ";overflow:hidden;text-overflow:ellipsis;&:last-child{text-align:right;}",
    ";"
], function(_ref) {
    var _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "24px" : _ref$padding;
    return padding;
}, function(_ref2) {
    var _ref2$fontSize = _ref2.fontSize, fontSize = _ref2$fontSize === void 0 ? "0.875rem" : _ref2$fontSize;
    return fontSize;
}, function(_ref3) {
    var _ref3$maxWidth = _ref3.maxWidth, maxWidth = _ref3$maxWidth === void 0 ? "250px" : _ref3$maxWidth;
    return maxWidth;
}, function(_ref4) {
    var extraStyles = _ref4.extraStyles;
    return extraStyles;
});
var backgroundColor$3 = ALABASTER_WHITE;
var borderColor = GREY_CHATEAU;
var fallbackValues$f = {
    backgroundColor: backgroundColor$3,
    borderColor: borderColor
};
var StyledTableHead = (0, _styledComponentsDefault.default).thead.withConfig({
    displayName: "TableHeadstyled",
    componentId: "sc-j8e6c1-0"
})([
    "background-color:",
    ";border-bottom:",
    ";font-size:",
    ";"
], function(_ref) {
    var backgroundColor = _ref.backgroundColor;
    return backgroundColor;
}, function(_ref2) {
    var borderColor = _ref2.borderColor;
    return "1px solid ".concat(borderColor);
}, function(_ref3) {
    var _ref3$fontSize = _ref3.fontSize, fontSize = _ref3$fontSize === void 0 ? "0.875rem" : _ref3$fontSize;
    return fontSize;
});
var borderColor$1 = GREY_CHATEAU;
var hoverBackgroundColor$1 = HOVER_LIGHT_BLUE;
var fallbackValues$g = {
    borderColor: borderColor$1,
    hoverBackgroundColor: hoverBackgroundColor$1
};
var TableRowWrapper = (0, _styledComponentsDefault.default).tr.withConfig({
    displayName: "TableRowstyled",
    componentId: "sc-1tc0sav-0"
})([
    "&:not(:last-child){border-bottom:",
    ";}",
    " ",
    ""
], function(_ref) {
    var borderColor = _ref.borderColor;
    return "1px solid ".concat(borderColor);
}, function(_ref2) {
    var hoverCursor = _ref2.hoverCursor, hoverEffect = _ref2.hoverEffect, hoverBackgroundColor = _ref2.hoverBackgroundColor;
    return hoverEffect && "&:hover {\n    ".concat(hoverCursor && "cursor: pointer", ";\n    background-color: ").concat(hoverBackgroundColor, ";\n  }");
}, function(_ref3) {
    var extraStyles = _ref3.extraStyles;
    return extraStyles;
});
var _excluded$y = [
    "children",
    "extraStyles",
    "hoverCursor",
    "hoverEffect",
    "onClick",
    "themeValues"
];
var TableRow = function TableRow(_ref) {
    var children = _ref.children, extraStyles = _ref.extraStyles, _ref$hoverCursor = _ref.hoverCursor, hoverCursor = _ref$hoverCursor === void 0 ? false : _ref$hoverCursor, _ref$hoverEffect = _ref.hoverEffect, hoverEffect = _ref$hoverEffect === void 0 ? true : _ref$hoverEffect, onClick = _ref.onClick, themeValues = _ref.themeValues, props = _objectWithoutProperties(_ref, _excluded$y);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRowWrapper, _extends({
        onClick: onClick,
        hoverEffect: hoverEffect,
        hoverCursor: hoverCursor,
        extraStyles: extraStyles,
        borderColor: themeValues.borderColor,
        hoverBackgroundColor: themeValues.hoverBackgroundColor
    }, props), children);
};
var TableRow$1 = themeComponent(TableRow, "TableRow", fallbackValues$g);
var TableHead = function TableHead(_ref) {
    var children = _ref.children, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledTableHead, {
        backgroundColor: themeValues.backgroundColor,
        borderColor: themeValues.borderColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableRow$1, {
        extraStyles: extraStyles,
        hoverEffect: false
    }, children));
};
var TableHead$1 = themeComponent(TableHead, "TableHead", fallbackValues$f);
var TableHeading = (0, _styledComponentsDefault.default).th.withConfig({
    displayName: "TableHeadingstyled",
    componentId: "sc-1ggk38d-0"
})([
    "padding:",
    ";min-width:",
    ";text-align:left;&:last-child{text-align:right;}",
    ""
], function(_ref) {
    var _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "24px" : _ref$padding;
    return padding;
}, function(_ref2) {
    var _ref2$minWidth = _ref2.minWidth, minWidth = _ref2$minWidth === void 0 ? "initial" : _ref2$minWidth;
    return minWidth;
}, function(_ref3) {
    var extraStyles = _ref3.extraStyles;
    return extraStyles;
});
var SortableTableHeading = function SortableTableHeading(_ref) {
    var ariaControlsId = _ref.ariaControlsId, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, displayName = _ref.displayName, onSortChange = _ref.onSortChange, _ref$sortOrder = _ref.sortOrder, sortOrder = _ref$sortOrder === void 0 ? null : _ref$sortOrder, themeValues = _ref.themeValues, extraStyles = _ref.extraStyles;
    var getCaretColor = function getCaretColor(order) {
        if (sortOrder === order) return themeValues.activeColor;
        return themeValues.inactiveColor;
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TableHeading, {
        disabled: disabled,
        extraStyles: "cursor: pointer; ".concat(extraStyles),
        onClick: function onClick(event) {
            return disabled ? noop$1 : onSortChange(event);
        },
        "aria-controls": ariaControlsId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between"
    }, displayName, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        justify: "center",
        childGap: "2px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CaretArrowUp$1, {
        color: getCaretColor("asc")
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(CaretArrowDown$1, {
        color: getCaretColor("desc")
    }))));
};
var SortableTableHeading$1 = themeComponent(SortableTableHeading, "SortableTableHeading", fallbackValues$e);
var DropdownIcon = function DropdownIcon() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        "aria-hidden": "true",
        version: "1.2",
        xmlns: "http://www.w3.org/2000/svg",
        overflow: "visible",
        preserveAspectRatio: "none",
        viewBox: "0 0 14 10",
        height: "8",
        width: "12"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(1 1)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fillRule: "evenodd",
        fill: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        fill: "#333",
        transform: "translate(-155 -22)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("polygon", {
        points: "165.59 22.59 161 27.17 156.41 22.59 155 24 161 30 167 24",
        vectorEffect: "non-scaling-stroke"
    })))));
};
var check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == "object" && self) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var fails = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});
var functionBindNative = !fails(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var call = Function.prototype.call;
var functionCall = functionBindNative ? call.bind(call) : function() {
    return call.apply(call, arguments);
};
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var objectPropertyIsEnumerable = {
    f: f
};
var createPropertyDescriptor = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var FunctionPrototype = Function.prototype;
var call$1 = FunctionPrototype.call;
var uncurryThisWithBind = functionBindNative && FunctionPrototype.bind.bind(call$1, call$1);
var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function(fn) {
    return function() {
        return call$1.apply(fn, arguments);
    };
};
var toString$2 = functionUncurryThis({}.toString);
var stringSlice = functionUncurryThis("".slice);
var classofRaw = function(it) {
    return stringSlice(toString$2(it), 8, -1);
};
var $Object = Object;
var split = functionUncurryThis("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return classofRaw(it) === "String" ? split(it, "") : $Object(it);
} : $Object;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function(it) {
    return it === null || it === undefined;
};
var $TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function(it) {
    if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var toIndexedObject = function(it) {
    return indexedObject(requireObjectCoercible(it));
};
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable = typeof documentAll == "undefined" && documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === documentAll;
} : function(argument) {
    return typeof argument == "function";
};
var isObject = function(it) {
    return typeof it == "object" ? it !== null : isCallable(it);
};
var aFunction = function(argument) {
    return isCallable(argument) ? argument : undefined;
};
var getBuiltIn = function(namespace, method) {
    return arguments.length < 2 ? aFunction(global_1[namespace]) : global_1[namespace] && global_1[namespace][method];
};
var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);
var engineUserAgent = typeof navigator != "undefined" && String(navigator.userAgent) || "";
var process$1 = global_1.process;
var Deno = global_1.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && engineUserAgent) {
    match = engineUserAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = engineUserAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
var engineV8Version = version;
/* eslint-disable es/no-symbol -- required for testing */ var $String = global_1.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && engineV8Version && engineV8Version < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $Object$1 = Object;
var isSymbol = useSymbolAsUid ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = getBuiltIn("Symbol");
    return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$1(it));
};
var $String$1 = String;
var tryToString = function(argument) {
    try {
        return $String$1(argument);
    } catch (error) {
        return "Object";
    }
};
var $TypeError$1 = TypeError;
// `Assert: IsCallable(argument) is true`
var aCallable = function(argument) {
    if (isCallable(argument)) return argument;
    throw new $TypeError$1(tryToString(argument) + " is not a function");
};
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function(V, P) {
    var func = V[P];
    return isNullOrUndefined(func) ? undefined : aCallable(func);
};
var $TypeError$2 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function(input, pref) {
    var fn, val;
    if (pref === "string" && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
    if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
    if (pref !== "string" && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
    throw new $TypeError$2("Can't convert object to primitive value");
};
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var defineGlobalProperty = function(key, value) {
    try {
        defineProperty(global_1, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        global_1[key] = value;
    }
    return value;
};
var SHARED = "__core-js_shared__";
var store = global_1[SHARED] || defineGlobalProperty(SHARED, {});
var sharedStore = store;
var shared = createCommonjsModule(function(module) {
    (module.exports = function(key, value) {
        return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
    })("versions", []).push({
        version: "3.35.1",
        mode: "global",
        copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
        license: "https://github.com/zloirock/core-js/blob/v3.35.1/LICENSE",
        source: "https://github.com/zloirock/core-js"
    });
});
var $Object$2 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function(argument) {
    return $Object$2(requireObjectCoercible(argument));
};
var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject(it), key);
};
var id$1 = 0;
var postfix = Math.random();
var toString$3 = functionUncurryThis(1.0.toString);
var uid = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + toString$3(++id$1 + postfix, 36);
};
var Symbol$1 = global_1.Symbol;
var WellKnownSymbolsStore = shared("wks");
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1["for"] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;
var wellKnownSymbol = function(name) {
    if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name) ? Symbol$1[name] : createWellKnownSymbol("Symbol." + name);
    return WellKnownSymbolsStore[name];
};
var $TypeError$3 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive = function(input, pref) {
    if (!isObject(input) || isSymbol(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = functionCall(exoticToPrim, input, pref);
        if (!isObject(result) || isSymbol(result)) return result;
        throw new $TypeError$3("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return ordinaryToPrimitive(input, pref);
};
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey = function(argument) {
    var key = toPrimitive(argument, "string");
    return isSymbol(key) ? key : key + "";
};
var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);
var documentCreateElement = function(it) {
    return EXISTS ? document$1.createElement(it) : {};
};
// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !descriptors && !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(documentCreateElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPropertyKey(P);
    if (ie8DomDefine) try {
        return $getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};
var objectGetOwnPropertyDescriptor = {
    f: f$1
};
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = descriptors && fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});
var $String$2 = String;
var $TypeError$4 = TypeError;
// `Assert: Type(argument) is Object`
var anObject = function(argument) {
    if (isObject(argument)) return argument;
    throw new $TypeError$4($String$2(argument) + " is not an object");
};
var $TypeError$5 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE = "configurable";
var WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$2 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor$1(O, P);
        if (current && current[WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
            };
        }
    }
    return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (ie8DomDefine) try {
        return $defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $TypeError$5("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var objectDefineProperty = {
    f: f$2
};
var createNonEnumerableProperty = descriptors ? function(object, key, value) {
    return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
var EXISTS$1 = hasOwnProperty_1(FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS$1 && (function something() {}).name === "something";
var CONFIGURABLE$1 = EXISTS$1 && (!descriptors || descriptors && getDescriptor(FunctionPrototype$1, "name").configurable);
var functionName = {
    EXISTS: EXISTS$1,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE$1
};
var functionToString = functionUncurryThis(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) sharedStore.inspectSource = function(it) {
    return functionToString(it);
};
var inspectSource = sharedStore.inspectSource;
var WeakMap$1 = global_1.WeakMap;
var weakMapBasicDetection = isCallable(WeakMap$1) && /native code/.test(String(WeakMap$1));
var keys$1 = shared("keys");
var sharedKey = function(key) {
    return keys$1[key] || (keys$1[key] = uid(key));
};
var hiddenKeys = {};
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError$1 = global_1.TypeError;
var WeakMap$2 = global_1.WeakMap;
var set, get, has;
var enforce = function(it) {
    return has(it) ? get(it) : set(it, {});
};
var getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError$1("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if (weakMapBasicDetection || sharedStore.state) {
    var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$2());
    /* eslint-disable no-self-assign -- prototype methods protection */ store$1.get = store$1.get;
    store$1.has = store$1.has;
    store$1.set = store$1.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
        if (store$1.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store$1.set(it, metadata);
        return metadata;
    };
    get = function(it) {
        return store$1.get(it) || {};
    };
    has = function(it) {
        return store$1.has(it);
    };
} else {
    var STATE = sharedKey("state");
    hiddenKeys[STATE] = true;
    set = function(it, metadata) {
        if (hasOwnProperty_1(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
    };
    get = function(it) {
        return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
    };
    has = function(it) {
        return hasOwnProperty_1(it, STATE);
    };
}
var internalState = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};
var makeBuiltIn_1 = createCommonjsModule(function(module) {
    var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
    var enforceInternalState = internalState.enforce;
    var getInternalState = internalState.get;
    var $String = String;
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var defineProperty = Object.defineProperty;
    var stringSlice = functionUncurryThis("".slice);
    var replace = functionUncurryThis("".replace);
    var join = functionUncurryThis([].join);
    var CONFIGURABLE_LENGTH = descriptors && !fails(function() {
        return defineProperty(function() {}, "length", {
            value: 8
        }).length !== 8;
    });
    var TEMPLATE = String(String).split("String");
    var makeBuiltIn = module.exports = function(value, name, options) {
        if (stringSlice($String(name), 0, 7) === "Symbol(") name = "[" + replace($String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
        if (options && options.getter) name = "get " + name;
        if (options && options.setter) name = "set " + name;
        if (!hasOwnProperty_1(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
            if (descriptors) defineProperty(value, "name", {
                value: name,
                configurable: true
            });
            else value.name = name;
        }
        if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, "arity") && value.length !== options.arity) defineProperty(value, "length", {
            value: options.arity
        });
        try {
            if (options && hasOwnProperty_1(options, "constructor") && options.constructor) {
                if (descriptors) defineProperty(value, "prototype", {
                    writable: false
                });
            } else if (value.prototype) value.prototype = undefined;
        } catch (error) {}
        var state = enforceInternalState(value);
        if (!hasOwnProperty_1(state, "source")) state.source = join(TEMPLATE, typeof name == "string" ? name : "");
        return value;
    };
    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    // eslint-disable-next-line no-extend-native -- required
    Function.prototype.toString = makeBuiltIn(function toString() {
        return isCallable(this) && getInternalState(this).source || inspectSource(this);
    }, "toString");
});
var defineBuiltIn = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if (isCallable(value)) makeBuiltIn_1(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else defineGlobalProperty(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else objectDefineProperty.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var ceil = Math.ceil;
var floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? floor : ceil)(n);
};
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : mathTrunc(number);
};
var max = Math.max;
var min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function(index, length) {
    var integer = toIntegerOrInfinity(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
};
var min$1 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function(argument) {
    var len = toIntegerOrInfinity(argument);
    return len > 0 ? min$1(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function(obj) {
    return toLength(obj.length);
};
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = lengthOfArrayLike(O);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
};
var indexOf = arrayIncludes.indexOf;
var push = functionUncurryThis([].push);
var objectKeysInternal = function(object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!hasOwnProperty_1(hiddenKeys, key) && hasOwnProperty_1(O, key) && push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (hasOwnProperty_1(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
    return result;
};
// IE8- don't enum bug keys
var enumBugKeys = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var hiddenKeys$1 = enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return objectKeysInternal(O, hiddenKeys$1);
};
var objectGetOwnPropertyNames = {
    f: f$3
};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$4 = Object.getOwnPropertySymbols;
var objectGetOwnPropertySymbols = {
    f: f$4
};
var concat = functionUncurryThis([].concat);
// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = objectGetOwnPropertyNames.f(anObject(it));
    var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};
var copyConstructorProperties = function(target, source, exceptions) {
    var keys = ownKeys$1(source);
    var defineProperty = objectDefineProperty.f;
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var replacement = /#|\.prototype\./;
var isForced = function(feature, detection) {
    var value = data[normalize(feature)];
    return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function(string) {
    return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = "N";
var POLYFILL = isForced.POLYFILL = "P";
var isForced_1 = isForced;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var _export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = global_1;
    else if (STATIC) target = global_1[TARGET] || defineGlobalProperty(TARGET, {});
    else target = global_1[TARGET] && global_1[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, "sham", true);
        defineBuiltIn(target, key, sourceProperty, options);
    }
};
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var test$3 = {};
test$3[TO_STRING_TAG] = "z";
var toStringTagSupport = String(test$3) === "[object z]";
var TO_STRING_TAG$1 = wellKnownSymbol("toStringTag");
var $Object$3 = Object;
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = $Object$3(it), TO_STRING_TAG$1)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === "Object" && isCallable(O.callee) ? "Arguments" : result;
};
var $String$3 = String;
var toString_1 = function(argument) {
    if (classof(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $String$3(argument);
};
var charAt = functionUncurryThis("".charAt);
var FORCED = fails(function() {
    // eslint-disable-next-line es/no-array-string-prototype-at -- safe
    return "\uD842\uDFB7".at(-2) !== "\uD842";
});
// `String.prototype.at` method
// https://tc39.es/ecma262/#sec-string.prototype.at
_export({
    target: "String",
    proto: true,
    forced: FORCED
}, {
    at: function at(index) {
        var S = toString_1(requireObjectCoercible(this));
        var len = S.length;
        var relativeIndex = toIntegerOrInfinity(index);
        var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
        return k < 0 || k >= len ? undefined : charAt(S, k);
    }
});
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
    return objectKeysInternal(O, enumBugKeys);
};
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var f$5 = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var props = toIndexedObject(Properties);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)objectDefineProperty.f(O, key = keys[index++], props[key]);
    return O;
};
var objectDefineProperties = {
    f: f$5
};
var html = getBuiltIn("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var GT = ">";
var LT = "<";
var PROTOTYPE = "prototype";
var SCRIPT = "script";
var IE_PROTO = sharedKey("IE_PROTO");
var EmptyConstructor = function() {};
var scriptTag = function(content) {
    return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write(scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement("iframe");
    var JS = "java" + SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function() {
    try {
        activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
    var length = enumBugKeys.length;
    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};
var defineProperty$1 = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol("unscopables");
var ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) defineProperty$1(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
});
// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function(key) {
    ArrayPrototype[UNSCOPABLES][key] = true;
};
// `Array.prototype.at` method
// https://tc39.es/ecma262/#sec-array.prototype.at
_export({
    target: "Array",
    proto: true
}, {
    at: function at(index) {
        var O = toObject(this);
        var len = lengthOfArrayLike(O);
        var relativeIndex = toIntegerOrInfinity(index);
        var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
        return k < 0 || k >= len ? undefined : O[k];
    }
});
addToUnscopables("at");
// eslint-disable-next-line es/no-typed-arrays -- safe
var arrayBufferBasicDetection = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";
var defineBuiltInAccessor = function(target, name, descriptor) {
    if (descriptor.get) makeBuiltIn_1(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) makeBuiltIn_1(descriptor.set, name, {
        setter: true
    });
    return objectDefineProperty.f(target, name, descriptor);
};
var correctPrototypeGetter = !fails(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var IE_PROTO$1 = sharedKey("IE_PROTO");
var $Object$4 = Object;
var ObjectPrototype = $Object$4.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object$4.getPrototypeOf : function(O) {
    var object = toObject(O);
    if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
    var constructor = object.constructor;
    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $Object$4 ? ObjectPrototype : null;
};
var functionUncurryThisAccessor = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return functionUncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};
var isPossiblePrototype = function(argument) {
    return isObject(argument) || argument === null;
};
var $String$4 = String;
var $TypeError$6 = TypeError;
var aPossiblePrototype = function(argument) {
    if (isPossiblePrototype(argument)) return argument;
    throw new $TypeError$6("Can't set " + $String$4(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ // `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = functionUncurryThisAccessor(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        anObject(O);
        aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var enforceInternalState = internalState.enforce;
var getInternalState = internalState.get;
var Int8Array = global_1.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global_1.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && objectGetPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && objectGetPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype$1 = Object.prototype;
var TypeError$2 = global_1.TypeError;
var TO_STRING_TAG$2 = wellKnownSymbol("toStringTag");
var TYPED_ARRAY_TAG = uid("TYPED_ARRAY_TAG");
var TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferBasicDetection && !!objectSetPrototypeOf && classof(global_1.opera) !== "Opera";
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;
var TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var isView = function isView(it) {
    if (!isObject(it)) return false;
    var klass = classof(it);
    return klass === "DataView" || hasOwnProperty_1(TypedArrayConstructorsList, klass) || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};
var getTypedArrayConstructor = function(it) {
    var proto = objectGetPrototypeOf(it);
    if (!isObject(proto)) return;
    var state = getInternalState(proto);
    return state && hasOwnProperty_1(state, TYPED_ARRAY_CONSTRUCTOR) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};
var isTypedArray = function(it) {
    if (!isObject(it)) return false;
    var klass = classof(it);
    return hasOwnProperty_1(TypedArrayConstructorsList, klass) || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};
var aTypedArray = function(it) {
    if (isTypedArray(it)) return it;
    throw new TypeError$2("Target is not a typed array");
};
var aTypedArrayConstructor = function(C) {
    if (isCallable(C) && (!objectSetPrototypeOf || objectIsPrototypeOf(TypedArray, C))) return C;
    throw new TypeError$2(tryToString(C) + " is not a typed array constructor");
};
var exportTypedArrayMethod = function(KEY, property, forced, options) {
    if (!descriptors) return;
    if (forced) for(var ARRAY in TypedArrayConstructorsList){
        var TypedArrayConstructor = global_1[ARRAY];
        if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!TypedArrayPrototype[KEY] || forced) defineBuiltIn(TypedArrayPrototype, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
};
var exportTypedArrayStaticMethod = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!descriptors) return;
    if (objectSetPrototypeOf) {
        if (forced) for(ARRAY in TypedArrayConstructorsList){
            TypedArrayConstructor = global_1[ARRAY];
            if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!TypedArray[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in TypedArrayConstructorsList){
        TypedArrayConstructor = global_1[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
};
for(NAME in TypedArrayConstructorsList){
    Constructor = global_1[NAME];
    Prototype = Constructor && Constructor.prototype;
    if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
    else NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for(NAME in BigIntArrayConstructorsList){
    Constructor = global_1[NAME];
    Prototype = Constructor && Constructor.prototype;
    if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    TypedArray = function TypedArray() {
        throw new TypeError$2("Incorrect invocation");
    };
    if (NATIVE_ARRAY_BUFFER_VIEWS) {
        for(NAME in TypedArrayConstructorsList)if (global_1[NAME]) objectSetPrototypeOf(global_1[NAME], TypedArray);
    }
}
if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype$1) {
    TypedArrayPrototype = TypedArray.prototype;
    if (NATIVE_ARRAY_BUFFER_VIEWS) {
        for(NAME in TypedArrayConstructorsList)if (global_1[NAME]) objectSetPrototypeOf(global_1[NAME].prototype, TypedArrayPrototype);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && objectGetPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) objectSetPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
if (descriptors && !hasOwnProperty_1(TypedArrayPrototype, TO_STRING_TAG$2)) {
    TYPED_ARRAY_TAG_REQUIRED = true;
    defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG$2, {
        configurable: true,
        get: function() {
            return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
        }
    });
    for(NAME in TypedArrayConstructorsList)if (global_1[NAME]) createNonEnumerableProperty(global_1[NAME], TYPED_ARRAY_TAG, NAME);
}
var arrayBufferViewCore = {
    NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
    TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
    aTypedArray: aTypedArray,
    aTypedArrayConstructor: aTypedArrayConstructor,
    exportTypedArrayMethod: exportTypedArrayMethod,
    exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
    getTypedArrayConstructor: getTypedArrayConstructor,
    isView: isView,
    isTypedArray: isTypedArray,
    TypedArray: TypedArray,
    TypedArrayPrototype: TypedArrayPrototype
};
var aTypedArray$1 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$1 = arrayBufferViewCore.exportTypedArrayMethod;
// `%TypedArray%.prototype.at` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.at
exportTypedArrayMethod$1("at", function at(index) {
    var O = aTypedArray$1(this);
    var len = lengthOfArrayLike(O);
    var relativeIndex = toIntegerOrInfinity(index);
    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
    return k < 0 || k >= len ? undefined : O[k];
});
var selectedColor = "".concat(LUCKY_POINT);
var hoverColor$2 = "".concat(HAWKES_BLUE);
var focusColor = "".concat(LUCKY_POINT_DARK);
var fallbackValues$h = {
    selectedColor: selectedColor,
    hoverColor: hoverColor$2,
    focusColor: focusColor
};
var IconWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Dropdown__IconWrapper",
    componentId: "sc-pn6m0h-0"
})([
    "position:absolute;display:flex;flex-direction:column;justify-content:center;transition:transform 0.3s ease;",
    ";top:20px;right:12px;"
], function(_ref) {
    var open = _ref.open;
    return open ? "transform: rotate(-180deg)" : "";
});
var DropdownContentWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Dropdown__DropdownContentWrapper",
    componentId: "sc-pn6m0h-1"
})([
    "transform-origin:0 0;border:1px solid ",
    ";border-radius:2px;background-color:",
    ";padding:8px 0 8px;position:absolute;width:",
    ";min-width:100%;max-height:",
    ";overflow-y:scroll;z-index:1;box-sizing:border-box;&:focus{outline:none;}ul{padding-left:0;}"
], STORM_GREY, WHITE, function(_ref2) {
    var widthFitOptions = _ref2.widthFitOptions;
    return widthFitOptions ? "fit-content" : "100%";
}, function(_ref3) {
    var maxHeight = _ref3.maxHeight;
    return maxHeight || "400px";
});
var DropdownItemWrapper = (0, _styledComponentsDefault.default).li.withConfig({
    displayName: "Dropdown__DropdownItemWrapper",
    componentId: "sc-pn6m0h-2"
})([
    "text-align:start;border-width:2px;border-style:solid;border-color:",
    ";box-shadow:none;box-sizing:border-box;width:100%;list-style:none;cursor:",
    ";&:hover{border-color:",
    ";> *{background:",
    ";border-color:",
    ";}}&:focus{outline:none;border-color:",
    ";> *{background:",
    ";border-color:white;outline:none;}}"
], function(_ref4) {
    var selected = _ref4.selected, themeValues = _ref4.themeValues;
    return selected ? themeValues.selectedColor : WHITE;
}, function(_ref5) {
    var disabled = _ref5.disabled;
    return disabled ? "default" : "pointer";
}, function(_ref6) {
    var disabled = _ref6.disabled, selected = _ref6.selected, themeValues = _ref6.themeValues;
    return selected ? themeValues.focusColor : disabled ? WHITE : themeValues.hoverColor;
}, function(_ref7) {
    var selected = _ref7.selected, disabled = _ref7.disabled, themeValues = _ref7.themeValues;
    return selected ? themeValues.focusColor : disabled ? WHITE : themeValues.hoverColor;
}, function(_ref8) {
    var selected = _ref8.selected, disabled = _ref8.disabled, themeValues = _ref8.themeValues;
    return selected ? themeValues.focusColor : disabled ? WHITE : themeValues.hoverColor;
}, function(_ref9) {
    var themeValues = _ref9.themeValues;
    return themeValues.selectedColor;
}, function(_ref10) {
    var selected = _ref10.selected, disabled = _ref10.disabled, themeValues = _ref10.themeValues;
    return selected ? themeValues.focusColor : disabled ? WHITE : themeValues.hoverColor;
});
var DropdownItemBorder = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Dropdown__DropdownItemBorder",
    componentId: "sc-pn6m0h-3"
})([
    "background:",
    ";border-color:",
    ";border-width:2px;border-style:solid;padding:12px;"
], function(_ref11) {
    var selected = _ref11.selected, themeValues = _ref11.themeValues;
    return selected ? themeValues.selectedColor : WHITE;
}, function(_ref12) {
    var selected = _ref12.selected, themeValues = _ref12.themeValues;
    return selected ? themeValues.selectedColor : WHITE;
});
var Dropdown = function Dropdown(_ref13) {
    var placeholder = _ref13.placeholder, options = _ref13.options, value = _ref13.value, isOpen = _ref13.isOpen, isError = _ref13.isError, onSelect = _ref13.onSelect, _ref13$disabledValues = _ref13.disabledValues, disabledValues = _ref13$disabledValues === void 0 ? [] : _ref13$disabledValues, _ref13$onClick = _ref13.onClick, _onClick = _ref13$onClick === void 0 ? noop$1 : _ref13$onClick, themeValues = _ref13.themeValues, maxHeight = _ref13.maxHeight, _ref13$widthFitOption = _ref13.widthFitOptions, widthFitOptions = _ref13$widthFitOption === void 0 ? false : _ref13$widthFitOption, disabled = _ref13.disabled, _ref13$hasTitles = _ref13.hasTitles, hasTitles = _ref13$hasTitles === void 0 ? false : _ref13$hasTitles, _ref13$autoEraseTypeA = _ref13.autoEraseTypeAhead, autoEraseTypeAhead = _ref13$autoEraseTypeA === void 0 ? true : _ref13$autoEraseTypeA, ariaLabelledby = _ref13.ariaLabelledby, ariaDescribedby = _ref13.ariaDescribedby, autocompleteValue = _ref13.autocompleteValue, _ref13$smoothScroll = _ref13.smoothScroll, smoothScroll = _ref13$smoothScroll === void 0 ? true : _ref13$smoothScroll, _ref13$ariaInvalid = _ref13.ariaInvalid, ariaInvalid = _ref13$ariaInvalid === void 0 ? false : _ref13$ariaInvalid, _ref13$isRequired = _ref13.isRequired, isRequired = _ref13$isRequired === void 0 ? false : _ref13$isRequired, extraStyles = _ref13.extraStyles;
    var _useState = (0, _react.useState)(""), _useState2 = _slicedToArray(_useState, 2), inputValue = _useState2[0], setInputValue = _useState2[1];
    var _useState3 = (0, _react.useState)([]), _useState4 = _slicedToArray(_useState3, 2), optionsState = _useState4[0], setOptionsState = _useState4[1];
    var _useState5 = (0, _react.useState)([]), _useState6 = _slicedToArray(_useState5, 2), filteredOptions = _useState6[0], setFilteredOptions = _useState6[1];
    var _useState7 = (0, _react.useState)(true), _useState8 = _slicedToArray(_useState7, 2), optionsChanged = _useState8[0], setOptionsChanged = _useState8[1];
    var _useState9 = (0, _react.useState)(undefined), _useState10 = _slicedToArray(_useState9, 2), selectedRef = _useState10[0], setSelectedRef = _useState10[1];
    var _useState11 = (0, _react.useState)(undefined), _useState12 = _slicedToArray(_useState11, 2), focusedRef = _useState12[0], setFocusedRef = _useState12[1];
    var _useState13 = (0, _react.useState)(false), _useState14 = _slicedToArray(_useState13, 2), inputChangedByAutofill = _useState14[0], setInputChangedByAutofill = _useState14[1];
    var _useState15 = (0, _react.useState)(false), _useState16 = _slicedToArray(_useState15, 2), focusedByClick = _useState16[0], setFocusedByClick = _useState16[1];
    if (optionsState !== options) {
        setOptionsState(options);
        setOptionsChanged(true);
    }
    if (optionsChanged) {
        setFilteredOptions(options);
        setOptionsChanged(false);
    }
    var _useState17 = (0, _react.useState)(null), _useState18 = _slicedToArray(_useState17, 2), timer = _useState18[0], setTimer = _useState18[1];
    var optionRefs = (0, _react.useRef)(_toConsumableArray(Array(options.length)).map(function() {
        return /*#__PURE__*/ (0, _react.createRef)();
    }));
    var dropdownRef = (0, _react.useRef)(null);
    var getSelection = function getSelection() {
        var _options$find;
        return value ? (_options$find = options.find(function(option) {
            return option.value === value;
        })) === null || _options$find === void 0 ? void 0 : _options$find.text : placeholder;
    };
    var onKeyDown = function onKeyDown(e) {
        var key = e.key, keyCode = e.keyCode;
        var focus = document.activeElement;
        var optionEl = optionRefs.current.find(function(ref) {
            return ref.current === focus;
        });
        switch(key){
            case "ArrowDown":
                e.preventDefault();
                if (!isOpen) _onClick();
                if (optionEl) {
                    if (optionEl.current.nextElementSibling) optionEl.current.nextElementSibling.focus();
                    else break;
                } else _onClick();
                break;
            case "ArrowUp":
                e.preventDefault();
                if (optionEl) {
                    if (optionEl.current.previousElementSibling) optionEl.current.previousElementSibling.focus();
                    else break;
                } else _onClick();
                break;
            case "Tab":
                if (isOpen) e.preventDefault();
                break;
            case "Backspace":
                e.preventDefault();
                setInputValue(inputValue.slice(0, -1));
                break;
            case "Home":
                e.preventDefault();
                optionRefs.current[0].current.focus();
                break;
            case "End":
                e.preventDefault();
                optionRefs.current.at(-1).current.focus();
                break;
            case "Escape":
                if (isOpen) _onClick();
                break;
        }
        if (keyCode > 64 && keyCode < 91 || keyCode == 32 || keyCode == 189) {
            e.preventDefault();
            setInputValue(inputValue + key);
        }
    };
    var handleItemSelection = function handleItemSelection(evt, choice, i) {
        if (disabledValues.includes(choice.value)) evt.preventDefault();
        else {
            setSelectedRef(optionRefs.current[i]);
            onSelect(choice.value);
            if (isOpen) _onClick();
        }
    };
    var handleOnBlur = function handleOnBlur(inputVal) {
        var selectedRefExists = selectedRef !== undefined && selectedRef.current !== null;
        var inputRequired = options.required || isRequired;
        var hasSelectedValue = value || selectedRefExists;
        // Select the empty value to trigger a validation error if it's required.
        if (inputRequired && !hasSelectedValue && inputVal === "") onSelect("");
    };
    (0, _react.useEffect)(function() {
        var selectedRefExists = selectedRef !== undefined && selectedRef.current !== null;
        if (isOpen && selectedRefExists && !focusedByClick) // For keyboard users, WAI-ARIA requires the selected option to receive focus
        selectedRef.current.focus();
        else if (isOpen && optionRefs.current[0].current && !focusedByClick) // If no selected option, first option receives focus
        optionRefs.current[0].current.focus();
        if (isOpen && focusedByClick && selectedRefExists) {
            // To support autofill for mouse users, we maintain focus on input just scroll item into view
            selectedRef.current.scrollIntoView({
                behavior: smoothScroll ? "smooth" : "auto",
                block: "nearest",
                inline: "start"
            });
            setFocusedByClick(false);
        }
        clearTimeout(timer);
        setInputValue("");
    }, [
        isOpen
    ]);
    (0, _react.useEffect)(function() {
        if (autoEraseTypeAhead) {
            clearTimeout(timer);
            setTimer(setTimeout(function() {
                return setInputValue("");
            }, 20000));
        }
        setFilteredOptions(options.filter(function(option) {
            var _option$value, _option$text;
            return (option === null || option === void 0 || (_option$value = option.value) === null || _option$value === void 0 || (_option$value = _option$value.toLowerCase()) === null || _option$value === void 0 ? void 0 : _option$value.indexOf(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase())) >= 0 || ((_option$text = option.text) === null || _option$text === void 0 || (_option$text = _option$text.toLowerCase()) === null || _option$text === void 0 ? void 0 : _option$text.indexOf(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase())) >= 0;
        }));
    }, [
        inputValue
    ]);
    (0, _react.useEffect)(function() {
        if (/*
      Either user has typed a value into input that matches a non-disabled option or
      user has autofilled or pasted into input a string matching a valid option
    */ (!isOpen || inputChangedByAutofill) && filteredOptions[0] && !disabledValues.includes(filteredOptions[0].value) && filteredOptions[0].text != placeholder) {
            setInputChangedByAutofill(false);
            onSelect(filteredOptions[0].value);
            if (isOpen) setTimeout(function() {
                return _onClick();
            }, 1000);
        }
        if (optionRefs.current[0].current) optionRefs.current[0].current.focus();
        else if (isOpen) dropdownRef.current.focus();
    }, [
        filteredOptions
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        background: isOpen ? themeValues.hoverColor : WHITE,
        extraStyles: "position: relative;".concat(extraStyles ? " ".concat(extraStyles) : ""),
        minWidth: "100%",
        onClick: function onClick() {
            if (!isOpen) {
                setFocusedByClick(true);
                _onClick();
            }
        },
        onKeyDown: onKeyDown,
        width: "100%",
        dataQa: "".concat(ariaLabelledby, "-dropdown")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        as: "input",
        autoComplete: autocompleteValue,
        "aria-controls": "".concat(ariaLabelledby, "_listbox"),
        "aria-activedescendant": isOpen ? "focused_option" : undefined,
        "aria-owns": "".concat(ariaLabelledby, "_listbox"),
        "aria-haspopup": "listbox",
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby,
        "aria-expanded": isOpen,
        "aria-required": options.required,
        "aria-invalid": ariaInvalid,
        background: isOpen ? themeValues.hoverColor : WHITE,
        borderRadius: "2px",
        borderSize: "1px",
        borderColor: isError ? ERROR_COLOR : isOpen ? themeValues.selectedColor : STORM_GREY,
        dataQa: placeholder,
        extraStyles: disabled ? "".concat(inputPlaceholderTextStyle).concat(inputDisabledStyle) : inputPlaceholderTextStyle,
        hoverStyles: "background-color: ".concat(themeValues.hoverColor, ";"),
        isOpen: isOpen,
        minHeight: "48px",
        minWidth: "100%",
        name: autocompleteValue,
        onChange: function onChange(e) {
            // support autofill and copy/paste
            if (e.target.value !== inputValue) {
                setInputValue(e.target.value);
                setInputChangedByAutofill(true);
            }
        },
        onBlur: function onBlur(e) {
            return handleOnBlur(e.target.value);
        },
        padding: "12px 25px 12px 12px",
        placeholder: getSelection(),
        required: options.required || isRequired,
        role: "combobox",
        themeValues: themeValues,
        title: hasTitles ? getSelection() : null,
        type: "text",
        tabIndex: 0,
        value: inputValue,
        width: "100%"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(IconWrapper, {
        open: isOpen,
        onClick: _onClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(DropdownIcon, null)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, isOpen ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DropdownContentWrapper, {
        maxHeight: maxHeight,
        open: isOpen,
        ref: dropdownRef,
        widthFitOptions: widthFitOptions,
        tabIndex: 0,
        role: "listbox",
        id: "".concat(ariaLabelledby, "_listbox")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "0",
        as: "ul"
    }, filteredOptions.map(function(choice, i) {
        if (choice.value === value && selectedRef !== optionRefs.current[i]) setSelectedRef(optionRefs.current[i]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(DropdownItemWrapper, {
            id: focusedRef === optionRefs.current[i] ? "focused_option" : choice.value,
            key: choice.value,
            ref: optionRefs.current[i],
            tabIndex: -1,
            onClick: function onClick(e) {
                return handleItemSelection(e, choice, i);
            },
            onKeyDown: function onKeyDown(e) {
                if (e.keyCode === ENTER) handleItemSelection(e, choice, i);
            },
            selected: choice.value === value,
            "aria-selected": choice.value === value,
            disabled: disabledValues.includes(choice.value),
            "aria-disabled": disabledValues.includes(choice.value),
            "data-qa": choice.text,
            themeValues: themeValues,
            title: hasTitles ? choice.text : null,
            role: "option",
            onFocus: function onFocus() {
                return setFocusedRef(optionRefs.current[i]);
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(DropdownItemBorder, {
            disabled: disabledValues.includes(choice.value),
            selected: choice.value === value,
            themeValues: themeValues
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
            variant: "p",
            color: choice.value === value ? WHITE : disabledValues.includes(choice.value) ? STORM_GREY : MINESHAFT_GREY,
            extraStyles: "padding-left: 16px;\n                        cursor: ".concat(disabledValues.includes(choice.value) ? "default" : "pointer", ";\n                        white-space: nowrap;\n                        overflow: hidden;\n                        text-overflow: ellipsis;")
        }, choice.text)));
    }))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)));
};
var Dropdown$1 = themeComponent(Dropdown, "Dropdown", fallbackValues$h);
var SelectContainer = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "FormSelectstyled__SelectContainer",
    componentId: "sc-hkrqrv-0"
})([
    "width:100%;display:flex;flex-direction:column;justify-content:space-between;align-items:flex-start;> * + *{margin-top:0.25rem;}"
]);
var SelectField = (0, _styledComponentsDefault.default).select.withConfig({
    displayName: "FormSelectstyled__SelectField",
    componentId: "sc-hkrqrv-1"
})([
    "border:1px solid ",
    ";border-radius:2px;height:48px;width:100%;padding:0.75rem 1rem;min-width:100px;margin:0;box-sizing:border-box;position:relative;font-size:1.1rem;font-family:Public Sans;line-height:2rem;font-weight:",
    ";background-color:",
    ";color:",
    ";box-shadow:none;&:focus{border:1px solid ",
    ";}"
], function(_ref) {
    var field = _ref.field, showErrors = _ref.showErrors;
    return field.dirty && field.hasErrors || field.hasErrors && showErrors ? ERROR_COLOR : GHOST_GREY;
}, FONT_WEIGHT_REGULAR, function(_ref2) {
    var themeValues = _ref2.themeValues;
    return themeValues.inputBackgroundColor && themeValues.inputBackgroundColor;
}, function(_ref3) {
    var themeValues = _ref3.themeValues;
    return themeValues.color && themeValues.color;
}, LUCKY_POINT);
var SelectOption = (0, _styledComponentsDefault.default).option.withConfig({
    displayName: "FormSelectstyled__SelectOption",
    componentId: "sc-hkrqrv-2"
})([
    ""
]);
var linkColor$1 = {
    "default": "".concat(LUCKY_POINT),
    disabled: "".concat(LUCKY_POINT)
};
var formBackgroundColor = {
    "default": "".concat(WHITE),
    disabled: "".concat(WHITE),
    checkout: "".concat(ATHENS_GREY),
    collapsible: "".concat(ATHENS_GREY)
};
var inputBackgroundColor = {
    "default": "".concat(WHITE),
    disabled: "".concat(SEASHELL_WHITE)
};
var color$6 = {
    "default": "".concat(MINESHAFT_GREY),
    disabled: "".concat(DUSTY_GREY)
};
var labelColor = {
    "default": "".concat(CHARADE_GREY),
    disabled: "".concat(CHARADE_GREY)
};
var borderColor$2 = {
    "default": "".concat(GREY_CHATEAU),
    disabled: "".concat(GREY_CHATEAU)
};
var lineHeight$1 = {
    "default": "1rem",
    disabled: "1rem"
};
var fontSize$4 = {
    "default": "0.875rem",
    disabled: "0.875rem"
};
var errorFontSize = {
    "default": "0.75rem",
    disabled: "0.75rem"
};
var fontWeight$3 = {
    "default": "".concat(FONT_WEIGHT_REGULAR),
    disabled: "".concat(FONT_WEIGHT_REGULAR)
};
var hoverFocusStyles = {
    "default": "color: ".concat(LUCKY_POINT_DARK, "; outline: none; text-decoration: underline;  "),
    disabled: "color: #6D717E;"
};
var fallbackValues$i = {
    linkColor: linkColor$1,
    formBackgroundColor: formBackgroundColor,
    inputBackgroundColor: inputBackgroundColor,
    color: color$6,
    labelColor: labelColor,
    borderColor: borderColor$2,
    lineHeight: lineHeight$1,
    fontSize: fontSize$4,
    errorFontSize: errorFontSize,
    fontWeight: fontWeight$3,
    hoverFocusStyles: hoverFocusStyles
};
var FormSelect = function FormSelect(_ref) {
    var fieldActions = _ref.fieldActions, labelTextWhenNoError = _ref.labelTextWhenNoError, errorMessages = _ref.errorMessages, options = _ref.options, field = _ref.field, showErrors = _ref.showErrors, onChange = _ref.onChange, dropdownMaxHeight = _ref.dropdownMaxHeight, disabledValues = _ref.disabledValues, disabled = _ref.disabled, themeValues = _ref.themeValues, _ref$hasTitles = _ref.hasTitles, hasTitles = _ref$hasTitles === void 0 ? false : _ref$hasTitles, autocompleteValue = _ref.autocompleteValue, _ref$smoothScroll = _ref.smoothScroll, smoothScroll = _ref$smoothScroll === void 0 ? true : _ref$smoothScroll, _ref$dataQa = _ref.dataQa, dataQa = _ref$dataQa === void 0 ? null : _ref$dataQa, _ref$widthFitOptions = _ref.widthFitOptions, widthFitOptions = _ref$widthFitOptions === void 0 ? false : _ref$widthFitOptions, _ref$isRequired = _ref.isRequired, isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired, _ref$labelTextVariant = _ref.labelTextVariant, labelTextVariant = _ref$labelTextVariant === void 0 ? "pS" : _ref$labelTextVariant, _ref$errorLabelTextVa = _ref.errorLabelTextVariant, errorLabelTextVariant = _ref$errorLabelTextVa === void 0 ? "pXS" : _ref$errorLabelTextVa;
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var dropdownRef = (0, _react.useRef)(null);
    var handleClickAway = function handleClickAway(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setOpen(false);
    };
    (0, _react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickAway);
        return function() {
            document.removeEventListener("mousedown", handleClickAway);
        };
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SelectContainer, {
        ref: dropdownRef,
        disabled: disabled,
        "aria-disabled": disabled,
        "data-qa": dataQa
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        as: "label",
        variant: labelTextVariant,
        color: themeValues.labelColor,
        weight: themeValues.fontWeight,
        extraStyles: "word-break: break-word;\n              font-family: Public Sans;\n              &::first-letter {\n                text-transform: uppercase;\n              }",
        id: createIdFromString(labelTextWhenNoError)
    }, labelTextWhenNoError))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Dropdown$1, {
        ariaLabelledby: createIdFromString(labelTextWhenNoError),
        ariaDescribedby: createIdFromString(labelTextWhenNoError, "error message"),
        maxHeight: dropdownMaxHeight,
        widthFitOptions: widthFitOptions,
        hasTitles: hasTitles,
        placeholder: options[0] ? options[0].text : "",
        options: options,
        value: field.rawValue,
        disabledValues: disabledValues,
        isOpen: open,
        isError: field.hasErrors && field.dirty || field.hasErrors && showErrors,
        ariaInvalid: field.hasErrors && field.dirty || field.hasErrors && showErrors,
        onSelect: onChange ? function(value) {
            return onChange(value);
        } : function(value) {
            return fieldActions.set(value);
        },
        onClick: function onClick() {
            return setOpen(!open);
        },
        disabled: disabled,
        autocompleteValue: autocompleteValue,
        smoothScroll: smoothScroll,
        isRequired: isRequired
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        direction: "row",
        justify: "space-between"
    }, field.hasErrors && field.dirty || field.hasErrors && showErrors ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        color: ERROR_COLOR,
        variant: errorLabelTextVariant,
        weight: themeValues.fontWeight,
        extraStyles: "\n            word-break: break-word;\n            font-family: Public Sans;\n            &::first-letter {\n              text-transform: uppercase;\n            }\n          ",
        id: createIdFromString(labelTextWhenNoError, "error message"),
        "aria-live": "polite",
        "aria-atomic": true,
        "data-qa": createIdFromString(labelTextWhenNoError, "error message")
    }, errorMessages[field.errors[0]]) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        extraStyles: "height: ".concat(themeValues.lineHeight, ";")
    })));
};
var FormSelect$1 = themeComponent(FormSelect, "FormSelect", fallbackValues$i, "default");
var options = [
    {
        text: "Afghanistan",
        value: "AF"
    },
    {
        text: "Aland Islands",
        value: "AX"
    },
    {
        text: "Albania",
        value: "AL"
    },
    {
        text: "Algeria",
        value: "DZ"
    },
    {
        text: "American Samoa",
        value: "AS"
    },
    {
        text: "Andorra",
        value: "AD"
    },
    {
        text: "Angola",
        value: "AO"
    },
    {
        text: "Anguilla",
        value: "AI"
    },
    {
        text: "Antarctica",
        value: "AQ"
    },
    {
        text: "Antigua and Barbuda",
        value: "AG"
    },
    {
        text: "Argentina",
        value: "AR"
    },
    {
        text: "Armenia",
        value: "AM"
    },
    {
        text: "Aruba",
        value: "AW"
    },
    {
        text: "Australia",
        value: "AU"
    },
    {
        text: "Austria",
        value: "AT"
    },
    {
        text: "Azerbaijan",
        value: "AZ"
    },
    {
        text: "Bahamas",
        value: "BS"
    },
    {
        text: "Bahrain",
        value: "BH"
    },
    {
        text: "Bangladesh",
        value: "BD"
    },
    {
        text: "Barbados",
        value: "BB"
    },
    {
        text: "Belarus",
        value: "BY"
    },
    {
        text: "Belgium",
        value: "BE"
    },
    {
        text: "Belize",
        value: "BZ"
    },
    {
        text: "Benin",
        value: "BJ"
    },
    {
        text: "Bermuda",
        value: "BM"
    },
    {
        text: "Bhutan",
        value: "BT"
    },
    {
        text: "Bolivia",
        value: "BO"
    },
    {
        text: "Bosnia and Herzegovina",
        value: "BA"
    },
    {
        text: "Botswana",
        value: "BW"
    },
    {
        text: "Bouvet Island",
        value: "BV"
    },
    {
        text: "Brazil",
        value: "BR"
    },
    {
        text: "British Virgin Islands",
        value: "VG"
    },
    {
        text: "British Indian Ocean Territory",
        value: "IO"
    },
    {
        text: "Brunei Darussalam",
        value: "BN"
    },
    {
        text: "Bulgaria",
        value: "BG"
    },
    {
        text: "Burkina Faso",
        value: "BF"
    },
    {
        text: "Burundi",
        value: "BI"
    },
    {
        text: "Cambodia",
        value: "KH"
    },
    {
        text: "Cameroon",
        value: "CM"
    },
    {
        text: "Canada",
        value: "CA"
    },
    {
        text: "Cape Verde",
        value: "CV"
    },
    {
        text: "Cayman Islands",
        value: "KY"
    },
    {
        text: "Central African Republic",
        value: "CF"
    },
    {
        text: "Chad",
        value: "TD"
    },
    {
        text: "Chile",
        value: "CL"
    },
    {
        text: "China",
        value: "CN"
    },
    {
        text: "Hong Kong, SAR China",
        value: "HK"
    },
    {
        text: "Macao, SAR China",
        value: "MO"
    },
    {
        text: "Christmas Island",
        value: "CX"
    },
    {
        text: "Cocos (Keeling) Islands",
        value: "CC"
    },
    {
        text: "Colombia",
        value: "CO"
    },
    {
        text: "Comoros",
        value: "KM"
    },
    {
        text: "Congo, (Brazzaville)",
        value: "CG"
    },
    {
        text: "Congo, (Kinshasa)",
        value: "CD"
    },
    {
        text: "Cook Islands",
        value: "CK"
    },
    {
        text: "Costa Rica",
        value: "CR"
    },
    {
        text: "C\xf4te d'Ivoire",
        value: "CI"
    },
    {
        text: "Croatia",
        value: "HR"
    },
    {
        text: "Cuba",
        value: "CU"
    },
    {
        text: "Cyprus",
        value: "CY"
    },
    {
        text: "Czech Republic",
        value: "CZ"
    },
    {
        text: "Denmark",
        value: "DK"
    },
    {
        text: "Djibouti",
        value: "DJ"
    },
    {
        text: "Dominica",
        value: "DM"
    },
    {
        text: "Dominican Republic",
        value: "DO"
    },
    {
        text: "Ecuador",
        value: "EC"
    },
    {
        text: "Egypt",
        value: "EG"
    },
    {
        text: "El Salvador",
        value: "SV"
    },
    {
        text: "Equatorial Guinea",
        value: "GQ"
    },
    {
        text: "Eritrea",
        value: "ER"
    },
    {
        text: "Estonia",
        value: "EE"
    },
    {
        text: "Ethiopia",
        value: "ET"
    },
    {
        text: "Falkland Islands (Malvinas)",
        value: "FK"
    },
    {
        text: "Faroe Islands",
        value: "FO"
    },
    {
        text: "Fiji",
        value: "FJ"
    },
    {
        text: "Finland",
        value: "FI"
    },
    {
        text: "France",
        value: "FR"
    },
    {
        text: "French Guiana",
        value: "GF"
    },
    {
        text: "French Polynesia",
        value: "PF"
    },
    {
        text: "French Southern Territories",
        value: "TF"
    },
    {
        text: "Gabon",
        value: "GA"
    },
    {
        text: "Gambia",
        value: "GM"
    },
    {
        text: "Georgia",
        value: "GE"
    },
    {
        text: "Germany",
        value: "DE"
    },
    {
        text: "Ghana",
        value: "GH"
    },
    {
        text: "Gibraltar",
        value: "GI"
    },
    {
        text: "Greece",
        value: "GR"
    },
    {
        text: "Greenland",
        value: "GL"
    },
    {
        text: "Grenada",
        value: "GD"
    },
    {
        text: "Guadeloupe",
        value: "GP"
    },
    {
        text: "Guam",
        value: "GU"
    },
    {
        text: "Guatemala",
        value: "GT"
    },
    {
        text: "Guernsey",
        value: "GG"
    },
    {
        text: "Guinea",
        value: "GN"
    },
    {
        text: "Guinea-Bissau",
        value: "GW"
    },
    {
        text: "Guyana",
        value: "GY"
    },
    {
        text: "Haiti",
        value: "HT"
    },
    {
        text: "Heard and Mcdonald Islands",
        value: "HM"
    },
    {
        text: "Holy See (Vatican City State)",
        value: "VA"
    },
    {
        text: "Honduras",
        value: "HN"
    },
    {
        text: "Hungary",
        value: "HU"
    },
    {
        text: "Iceland",
        value: "IS"
    },
    {
        text: "India",
        value: "IN"
    },
    {
        text: "Indonesia",
        value: "ID"
    },
    {
        text: "Iran, Islamic Republic of",
        value: "IR"
    },
    {
        text: "Iraq",
        value: "IQ"
    },
    {
        text: "Ireland",
        value: "IE"
    },
    {
        text: "Isle of Man",
        value: "IM"
    },
    {
        text: "Israel",
        value: "IL"
    },
    {
        text: "Italy",
        value: "IT"
    },
    {
        text: "Jamaica",
        value: "JM"
    },
    {
        text: "Japan",
        value: "JP"
    },
    {
        text: "Jersey",
        value: "JE"
    },
    {
        text: "Jordan",
        value: "JO"
    },
    {
        text: "Kazakhstan",
        value: "KZ"
    },
    {
        text: "Kenya",
        value: "KE"
    },
    {
        text: "Kiribati",
        value: "KI"
    },
    {
        text: "Korea (North)",
        value: "KP"
    },
    {
        text: "Korea (South)",
        value: "KR"
    },
    {
        text: "Kuwait",
        value: "KW"
    },
    {
        text: "Kyrgyzstan",
        value: "KG"
    },
    {
        text: "Lao PDR",
        value: "LA"
    },
    {
        text: "Latvia",
        value: "LV"
    },
    {
        text: "Lebanon",
        value: "LB"
    },
    {
        text: "Lesotho",
        value: "LS"
    },
    {
        text: "Liberia",
        value: "LR"
    },
    {
        text: "Libya",
        value: "LY"
    },
    {
        text: "Liechtenstein",
        value: "LI"
    },
    {
        text: "Lithuania",
        value: "LT"
    },
    {
        text: "Luxembourg",
        value: "LU"
    },
    {
        text: "Macedonia, Republic of",
        value: "MK"
    },
    {
        text: "Madagascar",
        value: "MG"
    },
    {
        text: "Malawi",
        value: "MW"
    },
    {
        text: "Malaysia",
        value: "MY"
    },
    {
        text: "Maldives",
        value: "MV"
    },
    {
        text: "Mali",
        value: "ML"
    },
    {
        text: "Malta",
        value: "MT"
    },
    {
        text: "Marshall Islands",
        value: "MH"
    },
    {
        text: "Martinique",
        value: "MQ"
    },
    {
        text: "Mauritania",
        value: "MR"
    },
    {
        text: "Mauritius",
        value: "MU"
    },
    {
        text: "Mayotte",
        value: "YT"
    },
    {
        text: "Mexico",
        value: "MX"
    },
    {
        text: "Micronesia, Federated States of",
        value: "FM"
    },
    {
        text: "Moldova",
        value: "MD"
    },
    {
        text: "Monaco",
        value: "MC"
    },
    {
        text: "Mongolia",
        value: "MN"
    },
    {
        text: "Montenegro",
        value: "ME"
    },
    {
        text: "Montserrat",
        value: "MS"
    },
    {
        text: "Morocco",
        value: "MA"
    },
    {
        text: "Mozambique",
        value: "MZ"
    },
    {
        text: "Myanmar",
        value: "MM"
    },
    {
        text: "Namibia",
        value: "NA"
    },
    {
        text: "Nauru",
        value: "NR"
    },
    {
        text: "Nepal",
        value: "NP"
    },
    {
        text: "Netherlands",
        value: "NL"
    },
    {
        text: "Netherlands Antilles",
        value: "AN"
    },
    {
        text: "New Caledonia",
        value: "NC"
    },
    {
        text: "New Zealand",
        value: "NZ"
    },
    {
        text: "Nicaragua",
        value: "NI"
    },
    {
        text: "Niger",
        value: "NE"
    },
    {
        text: "Nigeria",
        value: "NG"
    },
    {
        text: "Niue",
        value: "NU"
    },
    {
        text: "Norfolk Island",
        value: "NF"
    },
    {
        text: "Northern Mariana Islands",
        value: "MP"
    },
    {
        text: "Norway",
        value: "NO"
    },
    {
        text: "Oman",
        value: "OM"
    },
    {
        text: "Pakistan",
        value: "PK"
    },
    {
        text: "Palau",
        value: "PW"
    },
    {
        text: "Palestinian Territory",
        value: "PS"
    },
    {
        text: "Panama",
        value: "PA"
    },
    {
        text: "Papua New Guinea",
        value: "PG"
    },
    {
        text: "Paraguay",
        value: "PY"
    },
    {
        text: "Peru",
        value: "PE"
    },
    {
        text: "Philippines",
        value: "PH"
    },
    {
        text: "Pitcairn",
        value: "PN"
    },
    {
        text: "Poland",
        value: "PL"
    },
    {
        text: "Portugal",
        value: "PT"
    },
    {
        text: "Puerto Rico",
        value: "PR"
    },
    {
        text: "Qatar",
        value: "QA"
    },
    {
        text: "R\xe9union",
        value: "RE"
    },
    {
        text: "Romania",
        value: "RO"
    },
    {
        text: "Russian Federation",
        value: "RU"
    },
    {
        text: "Rwanda",
        value: "RW"
    },
    {
        text: "Saint-Barth\xe9lemy",
        value: "BL"
    },
    {
        text: "Saint Helena",
        value: "SH"
    },
    {
        text: "Saint Kitts and Nevis",
        value: "KN"
    },
    {
        text: "Saint Lucia",
        value: "LC"
    },
    {
        text: "Saint-Martin (French part)",
        value: "MF"
    },
    {
        text: "Saint Pierre and Miquelon",
        value: "PM"
    },
    {
        text: "Saint Vincent and Grenadines",
        value: "VC"
    },
    {
        text: "Samoa",
        value: "WS"
    },
    {
        text: "San Marino",
        value: "SM"
    },
    {
        text: "Sao Tome and Principe",
        value: "ST"
    },
    {
        text: "Saudi Arabia",
        value: "SA"
    },
    {
        text: "Senegal",
        value: "SN"
    },
    {
        text: "Serbia",
        value: "RS"
    },
    {
        text: "Seychelles",
        value: "SC"
    },
    {
        text: "Sierra Leone",
        value: "SL"
    },
    {
        text: "Singapore",
        value: "SG"
    },
    {
        text: "Slovakia",
        value: "SK"
    },
    {
        text: "Slovenia",
        value: "SI"
    },
    {
        text: "Solomon Islands",
        value: "SB"
    },
    {
        text: "Somalia",
        value: "SO"
    },
    {
        text: "South Africa",
        value: "ZA"
    },
    {
        text: "South Georgia and the South Sandwich Islands",
        value: "GS"
    },
    {
        text: "South Sudan",
        value: "SS"
    },
    {
        text: "Spain",
        value: "ES"
    },
    {
        text: "Sri Lanka",
        value: "LK"
    },
    {
        text: "Sudan",
        value: "SD"
    },
    {
        text: "Suriname",
        value: "SR"
    },
    {
        text: "Svalbard and Jan Mayen Islands",
        value: "SJ"
    },
    {
        text: "Swaziland",
        value: "SZ"
    },
    {
        text: "Sweden",
        value: "SE"
    },
    {
        text: "Switzerland",
        value: "CH"
    },
    {
        text: "Syrian Arab Republic (Syria)",
        value: "SY"
    },
    {
        text: "Taiwan, Republic of China",
        value: "TW"
    },
    {
        text: "Tajikistan",
        value: "TJ"
    },
    {
        text: "Tanzania, United Republic of",
        value: "TZ"
    },
    {
        text: "Thailand",
        value: "TH"
    },
    {
        text: "Timor-Leste",
        value: "TL"
    },
    {
        text: "Togo",
        value: "TG"
    },
    {
        text: "Tokelau",
        value: "TK"
    },
    {
        text: "Tonga",
        value: "TO"
    },
    {
        text: "Trinidad and Tobago",
        value: "TT"
    },
    {
        text: "Tunisia",
        value: "TN"
    },
    {
        text: "Turkey",
        value: "TR"
    },
    {
        text: "Turkmenistan",
        value: "TM"
    },
    {
        text: "Turks and Caicos Islands",
        value: "TC"
    },
    {
        text: "Tuvalu",
        value: "TV"
    },
    {
        text: "Uganda",
        value: "UG"
    },
    {
        text: "Ukraine",
        value: "UA"
    },
    {
        text: "United Arab Emirates",
        value: "AE"
    },
    {
        text: "United Kingdom",
        value: "GB"
    },
    {
        text: "United States of America",
        value: "US"
    },
    {
        text: "US Minor Outlying Islands",
        value: "UM"
    },
    {
        text: "Uruguay",
        value: "UY"
    },
    {
        text: "Uzbekistan",
        value: "UZ"
    },
    {
        text: "Vanuatu",
        value: "VU"
    },
    {
        text: "Venezuela (Bolivarian Republic)",
        value: "VE"
    },
    {
        text: "Viet Nam",
        value: "VN"
    },
    {
        text: "Virgin Islands, US",
        value: "VI"
    },
    {
        text: "Wallis and Futuna Islands",
        value: "WF"
    },
    {
        text: "Western Sahara",
        value: "EH"
    },
    {
        text: "Yemen",
        value: "YE"
    },
    {
        text: "Zambia",
        value: "ZM"
    },
    {
        text: "Zimbabwe",
        value: "ZW"
    }
];
var CountryDropdown = function CountryDropdown(_ref) {
    var _ref$labelTextWhenNoE = _ref.labelTextWhenNoError, labelTextWhenNoError = _ref$labelTextWhenNoE === void 0 ? "Country" : _ref$labelTextWhenNoE, errorMessages = _ref.errorMessages, field = _ref.field, fieldActions = _ref.fieldActions, showErrors = _ref.showErrors, onChange = _ref.onChange, _ref$isRequired = _ref.isRequired, isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired, _ref$dataQa = _ref.dataQa, dataQa = _ref$dataQa === void 0 ? null : _ref$dataQa;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormSelect$1, {
        options: options,
        field: field,
        fieldActions: fieldActions,
        labelTextWhenNoError: labelTextWhenNoError,
        dataQa: dataQa || "CountryDropdown",
        errorMessages: errorMessages,
        showErrors: showErrors,
        onChange: onChange,
        autocompleteValue: "country-name",
        isRequired: isRequired
    });
};
var DetailText = (0, _styledComponentsDefault.default).p.withConfig({
    displayName: "Detailstyled__DetailText",
    componentId: "sc-vn1h4n-0"
})([
    "font-size:",
    ";line-height:1.5;color:",
    ";font-weight:",
    ";margin:",
    ";text-align:",
    ";font-family:",
    ";",
    ";"
], function(_ref) {
    var fontSize = _ref.fontSize;
    return fontSize;
}, function(_ref2) {
    var color = _ref2.color;
    return color;
}, function(_ref3) {
    var weight = _ref3.weight;
    return weight;
}, function(_ref4) {
    var margin = _ref4.margin;
    return margin;
}, function(_ref5) {
    var textAlign = _ref5.textAlign;
    return textAlign;
}, function(_ref6) {
    var fontFamily = _ref6.fontFamily;
    return fontFamily;
}, function(_ref7) {
    var extraStyles = _ref7.extraStyles;
    return extraStyles;
});
// Comments assume desktop base font size of 16px, mobile base font size of 14px
var fontSize$5 = {
    large: "1.125rem",
    // 18px (at base font size of 16)
    regular: "1rem",
    // 16px
    small: "0.875rem",
    // 14px
    extraSmall: "0.75rem" // 12px
};
var fontFamily$4 = {
    large: "Public Sans",
    regular: "Public Sans",
    small: "Public Sans",
    extraSmall: "Public Sans"
};
var mobileFontSize$1 = {
    large: "1.14285rem",
    // 16px (at base font size of 14)
    regular: "1",
    // 14px
    small: "0.85714rem",
    // 12px
    extraSmall: "0.71428rem" // 10px
};
var fallbackValues$j = {
    fontFamily: fontFamily$4,
    fontSize: fontSize$5
};
var mobileFallbackValues$1 = {
    fontFamily: fontFamily$4,
    fontSize: mobileFontSize$1
};
var MOBILE_BREAKPOINT$1 = 768;
var _excluded$z = [
    "themeValues",
    "weight",
    "color",
    "margin",
    "textAlign",
    "extraStyles",
    "className",
    "variant",
    "as",
    "dataQa",
    "children"
];
var isBelowBreakpoint$1 = window.innerWidth < MOBILE_BREAKPOINT$1;
var isTouchDevice$1 = "ontouchstart" in window || navigator.maxTouchPoints > 1;
var mobileDeviceDetected$1 = isBelowBreakpoint$1 && isTouchDevice$1;
var fallbacks$1 = mobileDeviceDetected$1 ? mobileFallbackValues$1 : fallbackValues$j;
var Detail = function Detail(_ref) {
    var themeValues = _ref.themeValues, _ref$weight = _ref.weight, weight = _ref$weight === void 0 ? FONT_WEIGHT_REGULAR : _ref$weight, _ref$color = _ref.color, color = _ref$color === void 0 ? FIREFLY_GREY : _ref$color, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? 0 : _ref$margin, textAlign = _ref.textAlign, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, className = _ref.className, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "regular" : _ref$variant, _ref$as = _ref.as, as = _ref$as === void 0 ? "p" : _ref$as, dataQa = _ref.dataQa, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$z);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(DetailText, _extends({
        variant: variant,
        as: as,
        weight: weight,
        color: color,
        margin: margin,
        textAlign: textAlign,
        extraStyles: extraStyles,
        className: className,
        fontFamily: themeValues.fontFamily,
        fontSize: themeValues.fontSize,
        "data-qa": dataQa
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null)));
};
var Detail$1 = themeComponent(Detail, "Detail", fallbacks$1, "regular");
var backgroundColor$4 = WHITE;
var boxShadow = "0px 2px 14px 0px ".concat(ATHENS_GREY, ", 0px 3px 8px 0px ").concat(GHOST_GREY);
var fallbackValues$k = {
    backgroundColor: backgroundColor$4,
    boxShadow: boxShadow
};
var DisplayBox = function DisplayBox(_ref) {
    var children = _ref.children, themeValues = _ref.themeValues, showError = _ref.showError, _ref$dataQa = _ref.dataQa, dataQa = _ref$dataQa === void 0 ? null : _ref$dataQa;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0.5rem 0 1.5rem 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1.5rem",
        background: themeValues.backgroundColor,
        borderSize: showError && "1px",
        borderColor: showError && RED,
        borderRadius: "4px",
        boxShadow: themeValues.boxShadow,
        dataQa: dataQa
    }, children));
};
var DisplayBox$1 = themeComponent(DisplayBox, "DisplayBox", fallbackValues$k);
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends$2() {
    _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$2.apply(this, arguments);
}
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys$2(source, true).forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys$2(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose$1(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}
function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _iterableToArray$1(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
var getUniqueFormatDelimiters = function getUniqueFormatDelimiters(formats, formatChar) {
    return _toConsumableArray$1(new Set(formats.join("").split(formatChar).join("").split("")));
};
var format$1 = function format(formatter) {
    return function(value) {
        var usedFormat = formatter.formats[value.length];
        if (!usedFormat) return value;
        var formatPieces = usedFormat.split(formatter.formatChar);
        var valuePieces = value.split("");
        var zipped = formatPieces.map(function(v, i) {
            return v + (valuePieces[i] || "");
        });
        return zipped.join("");
    };
};
var countDelims = function countDelims(formatter, index) {
    var count = 0;
    var format = formatter.formats[index];
    if (!format) return 0;
    formatter.uniqueDelimiters.forEach(function(delim) {
        return count += format.split(delim).length - 1;
    });
    return count;
};
var unformat = function unformat(formatter) {
    return function(formattedValue, formatIndex) {
        if (formatIndex >= formatter.formats.length) return formattedValue;
        var format = formatter.formats[formatIndex];
        return formattedValue.split("").filter(function(_, i) {
            return !(format[i] != formatter.formatChar);
        }).join("");
    };
};
var inject = function inject(baseString) {
    return function(start, end, newString) {
        return baseString.substring(0, start) + newString + baseString.substring(end);
    };
};
var formattedToUnformattedIndex = function formattedToUnformattedIndex(formattedIndex, rawValue, formatter) {
    var maxFormatExceeded = rawValue.length >= formatter.formats.length;
    if (maxFormatExceeded) return formattedIndex;
    else {
        var formatString = formatter.formats[rawValue.length];
        var beforeString = formatString.slice(0, formattedIndex);
        return beforeString.split("").filter(function(c) {
            return c === formatter.formatChar;
        }).length;
    }
};
var unformattedToFormattedIndex = function unformattedToFormattedIndex(rawIndex, rawValue, formatter, del) {
    var maxFormatExceeded = rawValue.length >= formatter.formats.length; // If forced to stay formatted, offset by delims - 1
    // This is done so the component doesn't assume that any added chars will be kept
    // (i.e. if an external constraint is applied)
    if (maxFormatExceeded) {
        var delims = countDelims(formatter, rawValue.length - 1);
        return delims > 0 && !del ? rawIndex + delims - 1 : rawIndex;
    } else return formatter.formats[rawValue.length].split(formatter.formatChar).slice(0, rawIndex).reduce(function(acc, curr) {
        return curr.length + acc;
    }, 0) + rawIndex;
};
var createFormat = function createFormat(formats, formatChar) {
    return {
        uniqueDelimiters: getUniqueFormatDelimiters(formats, formatChar),
        formats: formats,
        formatChar: formatChar
    };
};
var FormattedInput = function FormattedInput(_ref) {
    var value = _ref.value, formatter = _ref.formatter, onChange = _ref.onChange, props = _objectWithoutProperties$1(_ref, [
        "value",
        "formatter",
        "onChange"
    ]);
    var inputEl = (0, _react.useRef)(null);
    var stateRefs = (0, _react.useRef)({
        selectionStart: 0,
        selectionEnd: 0,
        isDelete: false,
        rawValue: ""
    });
    (0, _react.useLayoutEffect)(function() {
        // A lot of the work here is cursor manipulation
        if (inputEl.current && inputEl.current === document.activeElement) inputEl.current.setSelectionRange(stateRefs.current.selectionStart, stateRefs.current.selectionEnd);
    }, [
        stateRefs
    ]);
    var handleChange = function handleChange(event) {
        var deleteKeyPressed = stateRefs.current.isDelete;
        var maxFormatExceeded = stateRefs.current.rawValue.length >= formatter.formats.length - 1;
        if (maxFormatExceeded && !deleteKeyPressed) return;
        /* At the beginning of onChange, event.target.value is a concat of the previous formatted value
    * and an unformatted injection at the start, end, or in the middle (maybe a deletion). To prepare 
    * the unformatted value for the user's onChange, the formatted string and unformatted injection need
    * to be separated, then unformat the formatted string, then insert (or delete) the injection from the
    * old unformatted value.
    */ // Derive the previous formatted value directly from the value prop (last
        // render's closure). This is always correct — it can never diverge even
        // when external onChange rejects or filters the typed character.
        var prevFormattedValue = format$1(formatter)(stateRefs.current.rawValue);
        var injectionLength = event.target.value.length - prevFormattedValue.length;
        var end = stateRefs.current.selectionStart === stateRefs.current.selectionEnd ? stateRefs.current.selectionStart + injectionLength : stateRefs.current.selectionEnd - 1;
        var injection = event.target.value.substring(stateRefs.current.selectionStart, end); // Injection is the new unformatted piece of the input
        // Need to find where to put it
        var rawInjectionPointStart = formattedToUnformattedIndex(stateRefs.current.selectionStart, stateRefs.current.rawValue, formatter);
        var rawInjectionPointEnd = formattedToUnformattedIndex(stateRefs.current.selectionEnd, stateRefs.current.rawValue, formatter); // Unformat the previous formatted value for injection
        // Using the relevant format string, strips away chars not marked with the formatChar
        var unformattedOldValue = unformat(formatter)(prevFormattedValue, stateRefs.current.rawValue.length); // Edit the previous unformatted value (either add, update or delete)
        var injectIntoOldValue = inject(unformattedOldValue);
        var unformattedNewValue = deleteKeyPressed ? rawInjectionPointStart === rawInjectionPointEnd ? injectIntoOldValue(rawInjectionPointStart - 1, rawInjectionPointStart, "") : injectIntoOldValue(rawInjectionPointStart, rawInjectionPointEnd, "") : injectIntoOldValue(rawInjectionPointStart, rawInjectionPointEnd, injection);
        var lengthDifference = unformattedNewValue.length - stateRefs.current.rawValue.length;
        var rawIndex = formattedToUnformattedIndex(stateRefs.current.selectionStart, stateRefs.current.rawValue, formatter) + lengthDifference; // Find the new cursor position for the potential formatted value
        // Applied by useLayoutEffect
        var newFormattedCursorPosition = stateRefs.current.selectionStart === stateRefs.current.selectionEnd ? unformattedToFormattedIndex(rawIndex, unformattedNewValue, formatter, deleteKeyPressed) : deleteKeyPressed ? stateRefs.current.selectionStart : stateRefs.current.selectionEnd;
        stateRefs.current = _objectSpread2$1({}, stateRefs.current, {
            selectionStart: newFormattedCursorPosition,
            selectionEnd: newFormattedCursorPosition
        }); // Apply the external onChange function to the raw underlying string
        // This is where the user generally updates the input value
        if (onChange) onChange(unformattedNewValue);
    };
    return (0, _reactDefault.default).createElement("input", _extends$2({}, props, {
        ref: inputEl,
        value: format$1(formatter)(value),
        onKeyDown: function onKeyDown(event) {
            // Keep track of the state of the input before onChange
            stateRefs.current = {
                isDelete: event.key === "Backspace" || event.key === "Delete",
                selectionStart: event.target.selectionStart,
                selectionEnd: event.target.selectionEnd,
                rawValue: value
            };
        },
        onChange: handleChange
    }));
};
var linkColor$2 = {
    "default": "".concat(MATISSE_BLUE),
    disabled: "".concat(MATISSE_BLUE)
};
var formBackgroundColor$1 = {
    "default": "".concat(WHITE),
    disabled: "".concat(WHITE),
    checkout: "".concat(ATHENS_GREY),
    collapsible: "".concat(ATHENS_GREY)
};
var inputBackgroundColor$1 = {
    "default": "".concat(WHITE),
    disabled: "".concat(SEASHELL_WHITE)
};
var color$7 = {
    "default": "".concat(MINESHAFT_GREY),
    disabled: "".concat(DUSTY_GREY)
};
var labelColor$1 = {
    "default": "".concat(CHARADE_GREY),
    disabled: "".concat(CHARADE_GREY)
};
var borderColor$3 = {
    "default": "".concat(STORM_GREY),
    disabled: "".concat(STORM_GREY)
};
var lineHeight$2 = {
    "default": "1rem",
    disabled: "1rem"
};
var fontSize$6 = {
    "default": "0.875rem",
    disabled: "0.875rem"
};
var errorFontSize$1 = {
    "default": "0.75rem",
    disabled: "0.75rem"
};
var fontWeight$4 = {
    "default": "".concat(FONT_WEIGHT_REGULAR),
    disabled: "".concat(FONT_WEIGHT_REGULAR)
};
var hoverFocusStyles$1 = {
    "default": "color: #0E506D; outline: none; text-decoration: underline;  ",
    disabled: "color: #6D717E;"
};
var formFooterPanel = {
    "default": "".concat(INFO_BLUE)
};
var fallbackValues$l = {
    linkColor: linkColor$2,
    formBackgroundColor: formBackgroundColor$1,
    inputBackgroundColor: inputBackgroundColor$1,
    color: color$7,
    labelColor: labelColor$1,
    borderColor: borderColor$3,
    lineHeight: lineHeight$2,
    fontSize: fontSize$6,
    errorFontSize: errorFontSize$1,
    fontWeight: fontWeight$4,
    hoverFocusStyles: hoverFocusStyles$1,
    formFooterPanel: formFooterPanel
};
var _excluded$A = [
    "showErrors",
    "themeValues"
], _excluded2 = [
    "ariaLabelledBy",
    "type",
    "labelDisplayOverride",
    "labelTextWhenNoError",
    "errorMessages",
    "isNum",
    "isEmail",
    "helperModal",
    "field",
    "fieldActions",
    "showErrors",
    "formatter",
    "decorator",
    "themeValues",
    "background",
    "customHeight",
    "autocompleteValue",
    "extraStyles",
    "removeFromValue",
    "dataQa",
    "isRequired",
    "errorFieldExtraStyles",
    "showFieldErrorRow",
    "labelTextVariant",
    "errorTextVariant"
];
var InputField = (0, _styledComponentsDefault.default).input.withConfig({
    displayName: "FormInput__InputField",
    componentId: "sc-l094r1-0"
})([
    "border:1px solid ",
    ";border-radius:2px;height:",
    ";width:100%;padding:1rem;min-width:100px;margin:0;box-sizing:border-box;position:relative;font-size:1.1rem;font-family:Public Sans;line-height:2rem;font-weight:",
    ";background-color:",
    ";color:",
    ";box-shadow:none;",
    " transition:background 0.3s ease;&:focus{outline:3px solid ",
    ";outline-offset:2px;}",
    " ",
    ""
], function(_ref) {
    var field = _ref.field, showErrors = _ref.showErrors, themeValues = _ref.themeValues;
    return field.dirty && field.hasErrors || field.hasErrors && showErrors ? ERROR_COLOR : themeValues.borderColor;
}, function(_ref2) {
    var $customHeight = _ref2.$customHeight;
    return $customHeight ? $customHeight : "48px";
}, FONT_WEIGHT_REGULAR, function(_ref3) {
    var themeValues = _ref3.themeValues;
    return themeValues.inputBackgroundColor && themeValues.inputBackgroundColor;
}, function(_ref4) {
    var themeValues = _ref4.themeValues;
    return themeValues.color && themeValues.color;
}, function(_ref5) {
    var background = _ref5.background, themeValues = _ref5.themeValues;
    return background && "background: ".concat(themeValues.inputBackgroundColor, " url(").concat(background, ") no-repeat right 0.5rem center;");
}, ROYAL_BLUE, function(_ref6) {
    var disabled = _ref6.disabled;
    return disabled && (0, _styledComponents.css)([
        "color:#6e727e;background-color:#f7f7f7;"
    ]);
}, function(_ref7) {
    var $extraStyles = _ref7.$extraStyles;
    return (0, _styledComponents.css)([
        "",
        ""
    ], $extraStyles);
});
// eslint-disable-next-line no-unused-vars
var FormattedInputField = (0, _styledComponentsDefault.default)(function(_ref8) {
    var showErrors = _ref8.showErrors, themeValues = _ref8.themeValues, props = _objectWithoutProperties(_ref8, _excluded$A);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormattedInput, props);
}).withConfig({
    displayName: "FormInput__FormattedInputField",
    componentId: "sc-l094r1-1"
})([
    "border:1px solid ",
    ";border-radius:2px;height:",
    ";width:100%;padding:1rem;min-width:100px;margin:0;box-sizing:border-box;position:relative;font-size:1.1rem;line-height:2rem;font-weight:",
    ";background-color:",
    ";color:",
    ";box-shadow:none;&:focus{outline:3px solid ",
    ";outline-offset:2px;}",
    " ",
    ""
], function(_ref9) {
    var field = _ref9.field, showErrors = _ref9.showErrors, themeValues = _ref9.themeValues;
    return field.dirty && field.hasErrors || field.hasErrors && showErrors ? ERROR_COLOR : themeValues.borderColor;
}, function(_ref10) {
    var $customHeight = _ref10.$customHeight;
    return $customHeight ? $customHeight : "48px";
}, FONT_WEIGHT_REGULAR, function(_ref11) {
    var themeValues = _ref11.themeValues;
    return themeValues.inputBackgroundColor && themeValues.inputBackgroundColor;
}, function(_ref12) {
    var themeValues = _ref12.themeValues;
    return themeValues.color && themeValues.color;
}, ROYAL_BLUE, function(_ref13) {
    var disabled = _ref13.disabled;
    return disabled && (0, _styledComponents.css)([
        "color:#6e727e;background-color:#f7f7f7;"
    ]);
}, function(_ref14) {
    var extraStyles = _ref14.extraStyles;
    return (0, _styledComponents.css)([
        "",
        ""
    ], extraStyles);
});
var FormInput = function FormInput(_ref15) {
    var _ref15$ariaLabelledBy = _ref15.ariaLabelledBy, ariaLabelledBy = _ref15$ariaLabelledBy === void 0 ? undefined : _ref15$ariaLabelledBy, _ref15$type = _ref15.type, type = _ref15$type === void 0 ? "text" : _ref15$type, _ref15$labelDisplayOv = _ref15.labelDisplayOverride, labelDisplayOverride = _ref15$labelDisplayOv === void 0 ? null : _ref15$labelDisplayOv, _ref15$labelTextWhenN = _ref15.labelTextWhenNoError, labelTextWhenNoError = _ref15$labelTextWhenN === void 0 ? "" : _ref15$labelTextWhenN, errorMessages = _ref15.errorMessages, _ref15$isNum = _ref15.isNum, isNum = _ref15$isNum === void 0 ? false : _ref15$isNum, _ref15$isEmail = _ref15.isEmail, isEmail = _ref15$isEmail === void 0 ? false : _ref15$isEmail, _ref15$helperModal = _ref15.helperModal, helperModal = _ref15$helperModal === void 0 ? false : _ref15$helperModal, field = _ref15.field, fieldActions = _ref15.fieldActions, showErrors = _ref15.showErrors, _ref15$formatter = _ref15.formatter, formatter = _ref15$formatter === void 0 ? null : _ref15$formatter, decorator = _ref15.decorator, themeValues = _ref15.themeValues, background = _ref15.background, customHeight = _ref15.customHeight, autocompleteValue = _ref15.autocompleteValue, extraStyles = _ref15.extraStyles, removeFromValue = _ref15.removeFromValue, _ref15$dataQa = _ref15.dataQa, dataQa = _ref15$dataQa === void 0 ? null : _ref15$dataQa, _ref15$isRequired = _ref15.isRequired, isRequired = _ref15$isRequired === void 0 ? false : _ref15$isRequired, errorFieldExtraStyles = _ref15.errorFieldExtraStyles, _ref15$showFieldError = _ref15.showFieldErrorRow, showFieldErrorRow = _ref15$showFieldError === void 0 ? true : _ref15$showFieldError, _ref15$labelTextVaria = _ref15.labelTextVariant, labelTextVariant = _ref15$labelTextVaria === void 0 ? "pS" : _ref15$labelTextVaria, _ref15$errorTextVaria = _ref15.errorTextVariant, errorTextVariant = _ref15$errorTextVaria === void 0 ? "pXS" : _ref15$errorTextVaria, props = _objectWithoutProperties(_ref15, _excluded2);
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), showPassword = _useState2[0], setShowPassword = _useState2[1];
    var _useState3 = (0, _react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), isFocused = _useState4[0], setIsFocused = _useState4[1];
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    var setValue = function setValue(value) {
        if (removeFromValue !== undefined) return fieldActions.set(value.replace(removeFromValue, ""));
        return fieldActions.set(value);
    };
    var handleOnBlur = function handleOnBlur(value) {
        // Sets the empty value to trigger a validation error if it's required.
        if (isRequired && value === "") setValue("");
        setIsFocused(false);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "0.25rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, helperModal ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center",
        overflow: true
    }, labelDisplayOverride ? labelDisplayOverride : /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        as: "label",
        color: themeValues.labelColor,
        variant: labelTextVariant,
        weight: themeValues.fontWeight,
        extraStyles: "word-break: break-word;\n                  font-family: Public Sans;\n                  &::first-letter {\n                    text-transform: uppercase;\n                  }",
        id: createIdFromString(labelTextWhenNoError)
    }, labelTextWhenNoError), helperModal()) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center",
        overflow: true
    }, labelDisplayOverride ? labelDisplayOverride : /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        as: "label",
        color: themeValues.labelColor,
        variant: labelTextVariant,
        fontWeight: themeValues.fontWeight,
        extraStyles: "word-break: break-word;\n                    font-family: Public Sans;\n                    &::first-letter {\n                      text-transform: uppercase;\n                    }",
        id: createIdFromString(labelTextWhenNoError)
    }, labelTextWhenNoError), type === "password" && /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        variant: "smallGhost",
        text: showPassword ? "Hide" : "Show",
        action: function action() {
            return setShowPassword(!showPassword);
        },
        "aria-label": showPassword ? "Hide Password" : "Show password",
        extraStyles: "margin: 0; min-width: auto;",
        textExtraStyles: "color: ".concat(themeValues.linkColor, ";")
    }), isMobile && decorator && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 0 0 auto"
    }, decorator)))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, formatter ? /*#__PURE__*/ (0, _reactDefault.default).createElement(FormattedInputField, _extends({
        "aria-labelledby": ariaLabelledBy === undefined ? createIdFromString(labelTextWhenNoError) : ariaLabelledBy,
        "aria-describedby": createIdFromString(labelTextWhenNoError, "error message"),
        "aria-invalid": field.dirty && field.hasErrors || field.hasErrors && showErrors,
        "aria-required": isRequired,
        onChange: function onChange(value) {
            return setValue(value);
        },
        onBlur: function onBlur(e) {
            return handleOnBlur(e.target.value);
        },
        type: type,
        value: field.rawValue,
        pattern: isNum ? "[0-9]*" : "",
        inputMode: isNum ? "numeric" : isEmail ? "email" : "text",
        field: field,
        formatter: formatter,
        showErrors: showErrors,
        themeValues: themeValues,
        $customHeight: customHeight,
        $extraStyles: extraStyles,
        "data-qa": dataQa || labelTextWhenNoError,
        autoComplete: autocompleteValue,
        required: isRequired
    }, autocompleteValue && {
        onFocus: function onFocus(e) {
            if (!isFocused) {
                var _e$target;
                setValue((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
                setIsFocused(true);
            }
        }
    }, props)) : /*#__PURE__*/ (0, _reactDefault.default).createElement(InputField, _extends({
        "aria-labelledby": ariaLabelledBy === undefined ? createIdFromString(labelTextWhenNoError) : ariaLabelledBy,
        "aria-describedby": createIdFromString(labelTextWhenNoError, "error message"),
        "aria-invalid": field.dirty && field.hasErrors || field.hasErrors && showErrors,
        "aria-required": isRequired,
        onChange: function onChange(e) {
            return setValue(e.target.value);
        },
        onBlur: function onBlur(e) {
            return handleOnBlur(e.target.value);
        },
        type: type === "password" && showPassword ? "text" : type,
        value: field.rawValue,
        pattern: isNum ? "[0-9]*" : "",
        inputMode: isNum ? "numeric" : isEmail ? "email" : "text",
        field: field,
        showErrors: showErrors,
        themeValues: themeValues,
        background: background,
        $customHeight: customHeight,
        $extraStyles: extraStyles,
        "data-qa": dataQa || labelTextWhenNoError,
        autoComplete: autocompleteValue,
        required: isRequired
    }, props))), showFieldErrorRow && /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        direction: "row",
        justify: "space-between",
        "aria-live": "polite",
        "aria-atomic": true
    }, field.hasErrors && field.dirty || field.hasErrors && showErrors ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        color: ERROR_COLOR,
        variant: errorTextVariant,
        weight: themeValues.fontWeight,
        extraStyles: "word-break: break-word;\n              font-family: Public Sans;\n              &::first-letter {\n                text-transform: uppercase;\n              }\n              ".concat(errorFieldExtraStyles, ";"),
        id: createIdFromString(labelTextWhenNoError, "error message")
    }, errorMessages[field.errors[0]]) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        extraStyles: "height: ".concat(themeValues.lineHeight, "; ").concat(errorFieldExtraStyles, ";")
    }), !isMobile && decorator && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 0 0 auto"
    }, decorator)));
};
var FormInput$1 = themeComponent(FormInput, "FormInput", fallbackValues$l, "default");
var _excluded$B = [
    "breakpoint",
    "childGap",
    "largeChild",
    "largeChildSize",
    "children"
];
var FormInputRow = function FormInputRow(_ref) {
    var _ref$breakpoint = _ref.breakpoint, breakpoint = _ref$breakpoint === void 0 ? "30rem" : _ref$breakpoint, _ref$childGap = _ref.childGap, childGap = _ref$childGap === void 0 ? "1rem" : _ref$childGap, largeChild = _ref.largeChild, largeChildSize = _ref.largeChildSize, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$B);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        padding: "0"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement(Switcher, {
        childGap: childGap,
        breakpoint: breakpoint,
        largeChild: largeChild,
        largeChildSize: largeChildSize
    }, children));
};
var _excluded$C = [
    "childGap",
    "bottomItem",
    "children"
];
var FormInputColumn = function FormInputColumn(_ref) {
    var _ref$childGap = _ref.childGap, childGap = _ref$childGap === void 0 ? "0.5rem" : _ref$childGap, bottomItem = _ref.bottomItem, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$C);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, _extends({
        childGap: childGap,
        bottomItem: bottomItem
    }, rest), children);
};
var _excluded$D = [
    "themeValues",
    "children"
];
var FormContainer = function FormContainer(_ref) {
    var themeValues = _ref.themeValues, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$D);
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        padding: isMobile ? "1rem" : "1.5rem",
        background: themeValues.formBackgroundColor,
        borderRadius: "4px"
    }, rest), children);
};
var FormContainer$1 = themeComponent(withWindowSize(FormContainer), "FormContainer", fallbackValues$l, "default");
var FormFooterPanel = function FormFooterPanel(_ref) {
    var themeValues = _ref.themeValues, link = _ref.link, linkText = _ref.linkText;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: themeValues.formFooterPanel,
        minWidth: "100%",
        padding: isMobile ? "1rem" : "1.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithLink, {
        url: link,
        variant: "smallGhost",
        text: linkText
    })));
};
var FormFooterPanel$1 = themeComponent(withWindowSize(FormFooterPanel), "FormFooterPanel", fallbackValues$l, "default");
var _excluded$E = [
    "ariaLabelledBy",
    "labelDisplayOverride",
    "labelTextWhenNoError",
    "errorMessages",
    "helperModal",
    "field",
    "fieldActions",
    "showErrors",
    "themeValues",
    "customHeight",
    "extraStyles",
    "removeFromValue",
    "dataQa",
    "isRequired",
    "errorFieldExtraStyles",
    "showFieldErrorRow",
    "labelTextVariant",
    "errorTextVariant",
    "resize",
    "rows",
    "cols",
    "placeholder",
    "maxLength"
];
var TextareaField = (0, _styledComponentsDefault.default).textarea.withConfig({
    displayName: "FormTextarea__TextareaField",
    componentId: "sc-94tlb0-0"
})([
    "border:1px solid ",
    ";border-radius:2px;height:",
    ";width:100%;padding:1rem;min-width:100px;margin:0;box-sizing:border-box;position:relative;font-size:1.1rem;font-family:Public Sans;line-height:1.5rem;font-weight:",
    ";background-color:",
    ";color:",
    ";box-shadow:none;resize:",
    ";transition:background 0.3s ease;&:focus{outline:3px solid ",
    ";outline-offset:2px;}",
    " ",
    ""
], function(_ref) {
    var field = _ref.field, showErrors = _ref.showErrors, themeValues = _ref.themeValues;
    return field.dirty && field.hasErrors || field.hasErrors && showErrors ? ERROR_COLOR : themeValues.borderColor;
}, function(_ref2) {
    var $customHeight = _ref2.$customHeight;
    return $customHeight ? $customHeight : "auto";
}, FONT_WEIGHT_REGULAR, function(_ref3) {
    var themeValues = _ref3.themeValues;
    return themeValues.inputBackgroundColor && themeValues.inputBackgroundColor;
}, function(_ref4) {
    var themeValues = _ref4.themeValues;
    return themeValues.color && themeValues.color;
}, function(_ref5) {
    var resize = _ref5.resize;
    return resize || "vertical";
}, ROYAL_BLUE, function(_ref6) {
    var disabled = _ref6.disabled;
    return disabled && (0, _styledComponents.css)([
        "color:#6e727e;background-color:#f7f7f7;"
    ]);
}, function(_ref7) {
    var $extraStyles = _ref7.$extraStyles;
    return (0, _styledComponents.css)([
        "",
        ""
    ], $extraStyles);
});
var FormTextarea = function FormTextarea(_ref8) {
    var _ref8$ariaLabelledBy = _ref8.ariaLabelledBy, ariaLabelledBy = _ref8$ariaLabelledBy === void 0 ? undefined : _ref8$ariaLabelledBy, _ref8$labelDisplayOve = _ref8.labelDisplayOverride, labelDisplayOverride = _ref8$labelDisplayOve === void 0 ? null : _ref8$labelDisplayOve, _ref8$labelTextWhenNo = _ref8.labelTextWhenNoError, labelTextWhenNoError = _ref8$labelTextWhenNo === void 0 ? "" : _ref8$labelTextWhenNo, errorMessages = _ref8.errorMessages, _ref8$helperModal = _ref8.helperModal, helperModal = _ref8$helperModal === void 0 ? false : _ref8$helperModal, field = _ref8.field, fieldActions = _ref8.fieldActions, showErrors = _ref8.showErrors, themeValues = _ref8.themeValues, customHeight = _ref8.customHeight, extraStyles = _ref8.extraStyles, removeFromValue = _ref8.removeFromValue, _ref8$dataQa = _ref8.dataQa, dataQa = _ref8$dataQa === void 0 ? null : _ref8$dataQa, _ref8$isRequired = _ref8.isRequired, isRequired = _ref8$isRequired === void 0 ? false : _ref8$isRequired, errorFieldExtraStyles = _ref8.errorFieldExtraStyles, _ref8$showFieldErrorR = _ref8.showFieldErrorRow, showFieldErrorRow = _ref8$showFieldErrorR === void 0 ? true : _ref8$showFieldErrorR, _ref8$labelTextVarian = _ref8.labelTextVariant, labelTextVariant = _ref8$labelTextVarian === void 0 ? "pS" : _ref8$labelTextVarian, _ref8$errorTextVarian = _ref8.errorTextVariant, errorTextVariant = _ref8$errorTextVarian === void 0 ? "pXS" : _ref8$errorTextVarian, _ref8$resize = _ref8.resize, resize = _ref8$resize === void 0 ? "vertical" : _ref8$resize, _ref8$rows = _ref8.rows, rows = _ref8$rows === void 0 ? 5 : _ref8$rows, cols = _ref8.cols, placeholder = _ref8.placeholder, maxLength = _ref8.maxLength, props = _objectWithoutProperties(_ref8, _excluded$E);
    var setValue = function setValue(value) {
        if (removeFromValue !== undefined) return fieldActions.set(value.replace(removeFromValue, ""));
        return fieldActions.set(value);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "0.25rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, helperModal ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center"
    }, labelDisplayOverride ? labelDisplayOverride : /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        as: "label",
        color: themeValues.labelColor,
        variant: labelTextVariant,
        weight: themeValues.fontWeight,
        extraStyles: "word-break: break-word;\n                  font-family: Public Sans;\n                  &::first-letter {\n                    text-transform: uppercase;\n                  }",
        id: createIdFromString(labelTextWhenNoError)
    }, labelTextWhenNoError), helperModal()) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center"
    }, labelDisplayOverride ? labelDisplayOverride : /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        as: "label",
        color: themeValues.labelColor,
        variant: labelTextVariant,
        fontWeight: themeValues.fontWeight,
        extraStyles: "word-break: break-word;\n                    font-family: Public Sans;\n                    &::first-letter {\n                      text-transform: uppercase;\n                    }",
        id: createIdFromString(labelTextWhenNoError)
    }, labelTextWhenNoError)))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TextareaField, _extends({
        "aria-labelledby": ariaLabelledBy === undefined ? createIdFromString(labelTextWhenNoError) : ariaLabelledBy,
        "aria-describedby": createIdFromString(labelTextWhenNoError, "error message"),
        "aria-invalid": field.dirty && field.hasErrors || field.hasErrors && showErrors,
        onChange: function onChange(e) {
            return setValue(e.target.value);
        },
        value: field.rawValue,
        field: field,
        showErrors: showErrors,
        themeValues: themeValues,
        $customHeight: customHeight,
        $extraStyles: extraStyles,
        "data-qa": dataQa || labelTextWhenNoError,
        required: isRequired,
        resize: resize,
        rows: rows,
        cols: cols,
        placeholder: placeholder,
        maxLength: maxLength
    }, props))), showFieldErrorRow && /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        direction: "row",
        justify: "space-between",
        "aria-live": "polite",
        "aria-atomic": true
    }, field.hasErrors && field.dirty || field.hasErrors && showErrors ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        color: ERROR_COLOR,
        variant: errorTextVariant,
        weight: themeValues.fontWeight,
        extraStyles: "word-break: break-word;\n              font-family: Public Sans;\n              &::first-letter {\n                text-transform: uppercase;\n              }\n              ".concat(errorFieldExtraStyles, ";"),
        id: createIdFromString(labelTextWhenNoError, "error message")
    }, errorMessages[field.errors[0]]) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        extraStyles: "height: ".concat(themeValues.lineHeight, "; ").concat(errorFieldExtraStyles, ";")
    })));
};
var FormTextarea$1 = themeComponent(FormTextarea, "FormTextarea", fallbackValues$l, "default");
var fontSize$7 = {
    "default": "1rem",
    radio: "1.0625rem"
};
var padding$1 = {
    "default": "0",
    radio: "0.625rem 0"
};
var color$8 = {
    "default": "".concat(CHARADE_GREY),
    radio: "".concat(MINESHAFT_GREY)
};
var fallbackValues$m = {
    fontSize: fontSize$7,
    padding: padding$1,
    color: color$8
};
var FormattedAddress = function FormattedAddress(_ref) {
    var street1 = _ref.street1, city = _ref.city, stateProvince = _ref.stateProvince, country = _ref.country, zip = _ref.zip, _ref$street = _ref.street2, street2 = _ref$street === void 0 ? null : _ref$street, _ref$name = _ref.name, name = _ref$name === void 0 ? null : _ref$name, themeValues = _ref.themeValues, _ref$qaPrefix = _ref.qaPrefix, qaPrefix = _ref$qaPrefix === void 0 ? "address" : _ref$qaPrefix;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: themeValues.padding
    }, name && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "p",
        color: themeValues.color,
        dataQa: "".concat(qaPrefix, "-name")
    }, name), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "p",
        color: themeValues.color,
        dataQa: "".concat(qaPrefix, "-1")
    }, street1), street2 && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "p",
        dataQa: "".concat(qaPrefix, "-2")
    }, ", ", street2)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "p",
        color: themeValues.color,
        dataQa: "".concat(qaPrefix, "-3")
    }, city, ", ", stateProvince, " ".concat(zip), country ? " ".concat(country) : "")));
};
var FormattedAddress$1 = themeComponent(FormattedAddress, "FormattedAddress", fallbackValues$m, "default");
var Hamburger = (0, _styledComponentsDefault.default).button.withConfig({
    displayName: "HamburgerButton__Hamburger",
    componentId: "sc-4wlnwv-0"
})([
    "padding:8px;display:inline-block;cursor:pointer;transition-property:opacity;transition-duration:0.15s;transition-timing-function:linear;font:inherit;color:inherit;text-transform:none;background-color:transparent;border:0;margin:0;overflow:visible;&:focus{outline:none;}"
]);
var HamburgerBox = (0, _styledComponentsDefault.default).span.withConfig({
    displayName: "HamburgerButton__HamburgerBox",
    componentId: "sc-4wlnwv-1"
})([
    "width:34px;height:34px;display:inline-block;position:relative;"
]);
var HamburgerInner = (0, _styledComponentsDefault.default).span.withConfig({
    displayName: "HamburgerButton__HamburgerInner",
    componentId: "sc-4wlnwv-2"
})([
    "display:block;top:auto;bottom:6px;left:2px;transition-duration:0.13s;transition-delay:0.13s;transition-timing-function:cubic-bezier(0.55,0.055,0.675,0.19);margin-top:12px;background-color:",
    ";&,&::before,&::after{background-color:",
    ';width:30px;height:3px;position:absolute;transition-property:transform;transition-duration:0.15s;transition-timing-function:ease;}&::before,&::after{content:"";display:block;}&::before{top:-10px;transition:top 0.12s 0.2s cubic-bezier(0.33333,0.66667,0.66667,1),transform 0.13s cubic-bezier(0.55,0.055,0.675,0.19);}&::after{bottom:-10px;top:-20px;transition:top 0.2s 0.2s cubic-bezier(0.33333,0.66667,0.66667,1),opacity 0.1s linear;}&.active,&.active::before,&.active::after{background-color:',
    ";}&.active{transform:translate3d(0,-10px,0) rotate(-45deg);transition-delay:0.22s;transition-timing-function:cubic-bezier(0.215,0.61,0.355,1);}&.active::after{top:0;opacity:0;transition:top 0.2s cubic-bezier(0.33333,0,0.66667,0.33333),opacity:0.1s 0.22s linear;}&.active::before{top:0;transform:rotate(-90deg);transition:top 0.1s 0.16s cubic-bezier(0.33333,0,0.66667,0.33333),transform 0.13s 0.25s cubic-bezier(0.215,0.61,0.355,1);}"
], function(_ref) {
    var inactiveColor = _ref.inactiveColor;
    return inactiveColor;
}, function(_ref2) {
    var inactiveColor = _ref2.inactiveColor;
    return inactiveColor;
}, function(_ref3) {
    var activeColor = _ref3.activeColor;
    return activeColor;
});
var HamburgerButton = function HamburgerButton(_ref4) {
    var activeColor = _ref4.activeColor, inactiveColor = _ref4.inactiveColor, isActive = _ref4.isActive, _ref4$onClick = _ref4.onClick, onClick = _ref4$onClick === void 0 ? noop$1 : _ref4$onClick, controls = _ref4.controls;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Hamburger, {
        className: isActive === true ? "active" : "",
        onClick: onClick,
        type: "button",
        "aria-label": "Menu",
        "aria-controls": controls
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(HamburgerBox, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(HamburgerInner, {
        className: isActive === true ? "active" : "",
        inactiveColor: inactiveColor,
        activeColor: activeColor
    })));
};
var HeadingText = (0, _styledComponentsDefault.default).h1.withConfig({
    displayName: "Headingstyled__HeadingText",
    componentId: "sc-1a3jd28-0"
})([
    "--font-size:",
    ";font-size:var(--font-size);line-height:calc(1.5 * var(--font-size));color:",
    ";font-weight:",
    ";margin:",
    ";text-align:",
    ";font-family:",
    ";",
    ";"
], function(_ref) {
    var fontSize = _ref.fontSize;
    return fontSize;
}, function(_ref2) {
    var color = _ref2.color;
    return color;
}, function(_ref3) {
    var weight = _ref3.weight;
    return weight;
}, function(_ref4) {
    var margin = _ref4.margin;
    return margin;
}, function(_ref5) {
    var textAlign = _ref5.textAlign;
    return textAlign;
}, function(_ref6) {
    var fontFamily = _ref6.fontFamily;
    return fontFamily;
}, function(_ref7) {
    var extraStyles = _ref7.extraStyles;
    return extraStyles;
});
var fontFamily$5 = {
    primary: "Public Sans",
    secondary: "Open Sans"
};
var fontSize$8 = {
    h1: "2.25rem",
    h2: "2rem",
    h3: "1.75rem",
    h4: "1.5rem",
    h5: "1.375rem",
    h6: "1.25rem"
};
var fallbackValues$n = {
    fontFamily: fontFamily$5,
    fontSize: fontSize$8
};
var _excluded$F = [
    "themeValues",
    "weight",
    "color",
    "margin",
    "textAlign",
    "extraStyles",
    "className",
    "variant",
    "as",
    "dataQa",
    "children"
];
var Heading = function Heading(_ref) {
    var themeValues = _ref.themeValues, _ref$weight = _ref.weight, weight = _ref$weight === void 0 ? FONT_WEIGHT_REGULAR : _ref$weight, _ref$color = _ref.color, color = _ref$color === void 0 ? FIREFLY_GREY : _ref$color, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? 0 : _ref$margin, textAlign = _ref.textAlign, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, className = _ref.className, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "h1" : _ref$variant, _ref$as = _ref.as, as = _ref$as === void 0 ? variant : _ref$as, dataQa = _ref.dataQa, children = _ref.children, rest = _objectWithoutProperties(_ref, _excluded$F);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(HeadingText, _extends({
        variant: variant,
        as: as,
        weight: weight,
        color: color,
        margin: margin,
        textAlign: textAlign,
        extraStyles: extraStyles,
        className: className,
        fontFamily: themeValues.fontFamily,
        fontSize: themeValues.fontSize,
        "data-qa": dataQa
    }, rest), safeChildren(children, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null)));
};
var Heading$1 = themeComponent(Heading, "Heading", fallbackValues$n, "h1");
var Image = (0, _styledComponentsDefault.default).img.withConfig({
    displayName: "ImageBoxstyled__Image",
    componentId: "sc-8lg9y6-0"
})([
    "width:",
    ";height:",
    ";object-fit:",
    ";object-position:",
    ";"
], function(_ref) {
    var _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width;
    return width;
}, function(_ref2) {
    var _ref2$height = _ref2.height, height = _ref2$height === void 0 ? "100%" : _ref2$height;
    return height;
}, function(_ref3) {
    var _ref3$objectFit = _ref3.objectFit, objectFit = _ref3$objectFit === void 0 ? "cover" : _ref3$objectFit;
    return objectFit;
}, function(_ref4) {
    var _ref4$objectPosition = _ref4.objectPosition, objectPosition = _ref4$objectPosition === void 0 ? "center" : _ref4$objectPosition;
    return objectPosition;
});
var ImageBox = function ImageBox(_ref) {
    var image = _ref.image, minHeight = _ref.minHeight, minWidth = _ref.minWidth, maxWidth = _ref.maxWidth, borderRadius = _ref.borderRadius, imgWidth = _ref.imgWidth, imgHeight = _ref.imgHeight, objectFit = _ref.objectFit, objectPosition = _ref.objectPosition;
    var boxMaxWidth = maxWidth || minWidth;
    var _image$url = image.url, url = _image$url === void 0 ? "" : _image$url, _image$altText = image.altText, altText = _image$altText === void 0 ? "" : _image$altText;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: minWidth,
        minHeight: minHeight,
        maxWidth: boxMaxWidth,
        borderRadius: borderRadius,
        extraStyles: "height: ".concat(minHeight, ";")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Image, {
        width: imgWidth,
        height: imgHeight,
        objectFit: objectFit,
        objectPosition: objectPosition,
        src: url,
        alt: altText
    }));
};
var color$9 = "#15749D";
var fallbackValues$o = {
    color: color$9
};
var SpinnerSvgAnimation = (0, _styledComponentsDefault.default).svg.withConfig({
    displayName: "Spinner__SpinnerSvgAnimation",
    componentId: "sc-vhupl9-0"
})([
    "animation:rotate 2s linear infinite;margin:-25px 0 0 -25px;width:",
    "px;height:",
    "px;& .path{stroke:",
    ";stroke-linecap:round;animation:dash 1.5s ease-in-out infinite;}@keyframes rotate{100%{transform:rotate(360deg);}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-35;}100%{stroke-dasharray:90,150;stroke-dashoffset:-124;}}",
    ""
], function(_ref) {
    var size = _ref.size;
    return size;
}, function(_ref2) {
    var size = _ref2.size;
    return size;
}, function(_ref3) {
    var color = _ref3.color;
    return color;
}, function(_ref4) {
    var centerSpinner = _ref4.centerSpinner;
    return centerSpinner ? (0, _styledComponents.css)([
        "margin:0;"
    ]) : "";
});
var SpinnerContainer$2 = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "Spinner__SpinnerContainer",
    componentId: "sc-vhupl9-1"
})([
    "width:100%;display:flex;flex-direction:row;align-items:center;justify-content:center;line-height:1;",
    ""
], function(_ref5) {
    var centerSpinner = _ref5.centerSpinner, size = _ref5.size;
    return centerSpinner ? (0, _styledComponents.css)([
        "width:",
        "px;height:",
        "px;"
    ], size, size) : "";
});
/*
  `centerSpinner` prop alters existing styling of spinner to allow it to properly center itself within
  containers. Default is false to preserve legacy behavior for past uses.
*/ var Spinner$1 = function Spinner(_ref6) {
    var _ref6$size = _ref6.size, size = _ref6$size === void 0 ? "24" : _ref6$size, _ref6$centerSpinner = _ref6.centerSpinner, centerSpinner = _ref6$centerSpinner === void 0 ? false : _ref6$centerSpinner, themeValues = _ref6.themeValues, _ref6$color = _ref6.color, color = _ref6$color === void 0 ? themeValues.color : _ref6$color, _ref6$cx = _ref6.cx, cx = _ref6$cx === void 0 ? "50" : _ref6$cx, _ref6$cy = _ref6.cy, cy = _ref6$cy === void 0 ? "50" : _ref6$cy, _ref6$radius = _ref6.radius, radius = _ref6$radius === void 0 ? "25" : _ref6$radius, _ref6$strokeWidth = _ref6.strokeWidth, strokeWidth = _ref6$strokeWidth === void 0 ? "6" : _ref6$strokeWidth;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(SpinnerContainer$2, {
        centerSpinner: centerSpinner,
        size: size
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SpinnerSvgAnimation, {
        size: size,
        color: color,
        centerSpinner: centerSpinner
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        className: "path",
        cx: cx,
        cy: cy,
        r: radius,
        fill: "none",
        strokeWidth: strokeWidth
    })));
};
var Spinner$2 = themeComponent(Spinner$1, "Spinner", fallbackValues$o);
var Jumbo = function Jumbo(_ref) {
    var showButton = _ref.showButton, heading = _ref.heading, _ref$isHeadingLoading = _ref.isHeadingLoading, isHeadingLoading = _ref$isHeadingLoading === void 0 ? false : _ref$isHeadingLoading, buttonLink = _ref.buttonLink, subHeading = _ref.subHeading, buttonText = _ref.buttonText, slug = _ref.slug, _ref$largeSide = _ref.largeSide, largeSide = _ref$largeSide === void 0 ? "right" : _ref$largeSide, _ref$largeSideSize = _ref.largeSideSize, largeSideSize = _ref$largeSideSize === void 0 ? "2" : _ref$largeSideSize, CartStatus = _ref.cartStatus, total = _ref.total, itemsCount = _ref.itemsCount, _ref$showCartStatus = _ref.showCartStatus, showCartStatus = _ref$showCartStatus === void 0 ? false : _ref$showCartStatus, openCartSlider = _ref.openCartSlider, extraStyles = _ref.extraStyles;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 20px",
        minHeight: "65px",
        id: "heroImage-".concat(slug),
        className: "themeJumboBackground",
        extraStyles: extraStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: "76.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        singleChild: true,
        minHeight: "65px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Switcher, {
        breakpoint: isMobile ? "999px" : "700px",
        largeChild: largeSide === "right" ? "2" : "1",
        largeChildSize: largeSideSize,
        childGap: "0.25rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        minHeight: "100%",
        justify: isMobile && !showCartStatus ? "center" : showButton || showCartStatus ? "space-between" : "left",
        align: "center",
        nowrap: showCartStatus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        variant: isMobile ? "small" : "large",
        as: "h1",
        color: WHITE,
        className: "themeJumboHeading",
        extraStyles: showCartStatus && isMobile && "max-width: 60%;"
    }, isHeadingLoading ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Spinner$2, {
        size: "50",
        cx: "25",
        cy: "25",
        radius: "12.5",
        strokeWidth: "3",
        centerSpinner: true,
        color: WHITE
    }) : heading), subHeading && /*#__PURE__*/ (0, _reactDefault.default).createElement(Heading$1, {
        variant: isMobile ? "h6" : "h2",
        color: WHITE,
        className: "themeJumboSubheading"
    }, subHeading), showButton && /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithLink, {
        url: buttonLink,
        text: buttonText || "Browse Services",
        variant: "primary",
        extraStyles: "margin: 0 0 65px 0; min-width: 320px;"
    }), showCartStatus && /*#__PURE__*/ (0, _reactDefault.default).createElement(CartStatus, {
        total: total,
        itemsCount: itemsCount,
        openCart: openCartSlider
    }))))));
};
var Jumbo$1 = withWindowSize(Jumbo);
var fontWeight$5 = {
    // v1 variants
    "default": "600",
    pS: "600",
    p: "600",
    pL: "600",
    h6: "700",
    // v2 variants
    regular: "600",
    // fontsize Detail large
    extraSmall: "600",
    //fontsize Detail small
    small: "600",
    // fontsize Detail regular
    large: "700" // fontsize Title small
};
var fallbackValues$p = {
    fontWeight: fontWeight$5
};
var LabeledAmountV1 = function LabeledAmountV1(_ref) {
    var _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "pL" : _ref$variant, label = _ref.label, amount = _ref.amount, themeValues = _ref.themeValues, as = _ref.as, extraStyles = _ref.extraStyles;
    var LabeledAmountText = variant === "h6" ? Heading$1 : Paragraph$1;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        direction: "row"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(LabeledAmountText, {
        variant: variant,
        as: as,
        weight: themeValues.fontWeight,
        extraStyles: "".concat(extraStyles, "; text-align: start; flex: 3;")
    }, label, ":"), /*#__PURE__*/ (0, _reactDefault.default).createElement(LabeledAmountText, {
        variant: variant,
        as: as,
        weight: themeValues.fontWeight,
        extraStyles: "".concat(extraStyles, "; text-align: end; flex: 1;")
    }, amount));
};
var LabeledAmountV2 = function LabeledAmountV2(_ref) {
    var _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "regular" : _ref$variant, label = _ref.label, amount = _ref.amount, themeValues = _ref.themeValues, as = _ref.as, extraStyles = _ref.extraStyles;
    var mappedDetailVariants = {
        regular: "large",
        small: "regular",
        extraSmall: "small"
    };
    var LabeledAmountContainer = variant === "large" ? Title$1 : Detail$1;
    var containerVariant = variant === "large" ? "small" : mappedDetailVariants[variant];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabeledAmountContainer, {
        variant: containerVariant,
        as: as,
        weight: themeValues.fontWeight,
        extraStyles: "display: flex; justify-content: space-between; ".concat(extraStyles)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, label), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, amount));
};
var _excluded$G = [
    "version"
];
var LabeledAmount = function LabeledAmount(_ref) {
    var _ref$version = _ref.version, version = _ref$version === void 0 ? "v1" : _ref$version, rest = _objectWithoutProperties(_ref, _excluded$G);
    var LabeledAmountComponent = version === "v1" ? LabeledAmountV1 : LabeledAmountV2;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(LabeledAmountComponent, rest);
};
var LabeledAmount$1 = themeComponent(LabeledAmount, "LabeledAmount", fallbackValues$p, "default");
var weightTitle = {
    "default": "600",
    small: "400"
};
var detailVariant = {
    "default": "large",
    small: "small"
};
var fallbackValues$q = {
    weightTitle: weightTitle,
    detailVariant: detailVariant
};
var LineItem = function LineItem(_ref) {
    var _customAttributes$fil;
    var description = _ref.description, subDescription = _ref.subDescription, amount = _ref.amount, themeValues = _ref.themeValues, customAttributes = _ref.customAttributes, _ref$visibleFields = _ref.visibleFields, visibleFields = _ref$visibleFields === void 0 ? [] : _ref$visibleFields, _ref$displayQuantity = _ref.displayQuantity, displayQuantity = _ref$displayQuantity === void 0 ? null : _ref$displayQuantity;
    var formatAttrKeys = function formatAttrKeys(key) {
        var keyWithoutUnderscores = key.replace(/_/g, " ");
        var capitalizedKey = keyWithoutUnderscores.split(" ").map(function(word) {
            return "".concat(word.charAt(0).toUpperCase()).concat(word.slice(1));
        }).join(" ");
        return capitalizedKey;
    };
    var visibleCustomAttrs = customAttributes === null || customAttributes === void 0 || (_customAttributes$fil = customAttributes.filter(function(attr) {
        return (visibleFields === null || visibleFields === void 0 ? void 0 : visibleFields.includes(attr.key)) && attr.key !== "description";
    })) === null || _customAttributes$fil === void 0 ? void 0 : _customAttributes$fil.map(function(attr) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Detail$1, {
            variant: "small",
            weight: "400",
            key: attr.key,
            color: STORM_GREY
        }, "".concat(formatAttrKeys(attr.key), ": ").concat(attr.value));
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "0px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Detail$1, {
        as: "h3",
        variant: themeValues.detailVariant,
        weight: themeValues.weightTitle,
        extraStyles: "display: flex; justify-content: space-between;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, description), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, !!displayQuantity && "x".concat(displayQuantity)), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, amount)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Detail$1, {
        as: "p",
        variant: themeValues.detailVariant,
        weight: "400"
    }, subDescription), visibleCustomAttrs && /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "0.25rem"
    }, visibleCustomAttrs));
};
var LineItem$1 = themeComponent(LineItem, "LineItem", fallbackValues$q, "default");
var Loading = function Loading() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        key: "spinner-container",
        extraStyles: "position: fixed; top: 0; bottom: 0; left: 0; right: 0;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        minHeight: "100%",
        singleChild: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        intrinsic: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Spinner$2, {
        size: "100"
    })))));
};
var _excluded$H = [
    "leftContent",
    "rightContent",
    "footerMinHeight",
    "backgroundColor",
    "largeSide",
    "largeSideSize",
    "footerPadding",
    "isMobile",
    "footerWidth"
];
var NavFooter = function NavFooter(_ref) {
    var leftContent = _ref.leftContent, rightContent = _ref.rightContent, _ref$footerMinHeight = _ref.footerMinHeight, footerMinHeight = _ref$footerMinHeight === void 0 ? "104px" : _ref$footerMinHeight, backgroundColor = _ref.backgroundColor, _ref$largeSide = _ref.largeSide, largeSide = _ref$largeSide === void 0 ? "right" : _ref$largeSide, _ref$largeSideSize = _ref.largeSideSize, largeSideSize = _ref$largeSideSize === void 0 ? "2" : _ref$largeSideSize, _ref$footerPadding = _ref.footerPadding, footerPadding = _ref$footerPadding === void 0 ? "1.5rem 1rem" : _ref$footerPadding, isMobile = _ref.isMobile, footerWidth = _ref.footerWidth, rest = _objectWithoutProperties(_ref, _excluded$H);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        padding: footerPadding,
        background: backgroundColor,
        minHeight: footerMinHeight,
        minWidth: "100%",
        extraStyles: isMobile ? "" : "min-height: ".concat(footerMinHeight, "; > * { min-height: 100%; };")
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: footerWidth || "76.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        singleChild: true,
        minHeight: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        minHeight: "100%",
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Switcher, {
        breakpoint: isMobile ? "999px" : "700px",
        largeChild: largeSide === "right" ? "2" : "1",
        largeChildSize: largeSideSize,
        childGap: "0.5rem"
    }, leftContent, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: isMobile ? "flex-start" : "flex-end",
        align: "center",
        childGap: "0.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Switcher, {
        maxChildrenOnly: true,
        maxChildren: isMobile ? 1 : 99,
        childGap: isMobile ? "1rem" : "2rem"
    }, rightContent)))))));
};
var _excluded$I = [
    "leftContent",
    "rightContent",
    "headerHeight",
    "isMobile",
    "backgroundColor",
    "headerWidth"
];
var NavHeader = function NavHeader(_ref) {
    var leftContent = _ref.leftContent, rightContent = _ref.rightContent, _ref$headerHeight = _ref.headerHeight, headerHeight = _ref$headerHeight === void 0 ? "105px" : _ref$headerHeight, isMobile = _ref.isMobile, backgroundColor = _ref.backgroundColor, headerWidth = _ref.headerWidth, rest = _objectWithoutProperties(_ref, _excluded$I);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        padding: "0 16px 4px",
        background: backgroundColor,
        extraStyles: isMobile ? "height: 72px; > * { height: 100%; }; z-index: 2;" : "height: ".concat(headerHeight, "; > * { height: 100%; }; z-index: 2;"),
        minWidth: "100%"
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: headerWidth || "76.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        minHeight: "100%",
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        singleChild: true,
        minHeight: isMobile ? "72px" : headerHeight
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center",
        overflow: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, leftContent), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, rightContent))))));
};
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _DEFAULT_ERROR_MESSAG;
// Constants to reprsent input error types
var MIN_LENGTH_ERROR = "error/HAS_LENGTH";
var MAX_LENGTH_ERROR = "max_length_error";
var EXACT_LENGTH_ERROR = "exact_length_error";
var MULTIPLE_LENGTHS_ERROR = "multiple_lengths_error";
var EMAIL_ERROR = "email_error";
var HAS_NUMBER_ERROR = "error/HAS_NUMBER";
var HAS_UPPERCASE_LETTER_ERROR = "error/HAS_UPPERCASE_LETTER";
var HAS_LOWERCASE_LETTER_ERROR = "error/HAS_LOWERCASE_LETTER";
var HAS_SPECIAL_CHARACTER_ERROR = "error/HAS_SPECIAL_CHARACTER";
var ONLY_NUMBERS_ERROR = "only_numbers_error";
var ONLY_LETTERS_ERROR = "only_letters_error";
var REQUIRED_FIELD_ERROR = "required_field_error";
var NUM_GREATER_THAN_ERROR = "num_greater_than_error";
var NUM_LESS_THAN_ERROR = "num_less_than_error";
var MATCHES_FIELD_ERROR = "matches_field_error";
var VALID_SELECT_OPTION_ERROR = "valid_select_option_error";
// Array<String>, Array<String> -> Object -> String
var genErrorMessage = function genErrorMessage(strings) {
    for(var _len = arguments.length, argKeys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)argKeys[_key - 1] = arguments[_key];
    return function(inputState) {
        return strings.reduce(function(accum, current, index) {
            return "".concat(accum).concat(current).concat(argKeys[index] ? pathOr("", [
                argKeys[index]
            ], inputState) : "");
        }, []);
    };
};
/*
What's going on here? This looks weird, you may ask...
DEFAULT_ERROR_MESSAGES is a map between the error constants (which are returned by validators)
and some tagged template literals.
In this case, the template tag function is curried and returns a function which accepts an args object
I'm calling that object inputState, but it could really be anything.
When the error message string fucntion is called with that arg, it's reduced to produce a custom error message
with interpolation.
*/ var DEFAULT_ERROR_MESSAGES = (_DEFAULT_ERROR_MESSAG = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_DEFAULT_ERROR_MESSAG, MIN_LENGTH_ERROR, genErrorMessage(_templateObject || (_templateObject = _taggedTemplateLiteral([
    "",
    " is too short"
])), "fieldLabel")), MAX_LENGTH_ERROR, genErrorMessage(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
    "",
    " is too long"
])), "fieldLabel")), EXACT_LENGTH_ERROR, genErrorMessage(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
    "",
    " is not the right length"
])), "fieldLabel")), MULTIPLE_LENGTHS_ERROR, genErrorMessage(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
    "",
    " is not a valid length"
])), "fieldLabel")), EMAIL_ERROR, genErrorMessage(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([
    "",
    " is not a valid email address"
])), "fieldLabel")), HAS_NUMBER_ERROR, genErrorMessage(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([
    "",
    " needs a number"
])), "fieldLabel")), HAS_UPPERCASE_LETTER_ERROR, genErrorMessage(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([
    "",
    " needs an uppercase letter"
])), "fieldLabel")), HAS_LOWERCASE_LETTER_ERROR, genErrorMessage(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([
    "",
    " needs a lowercase letter"
])), "fieldLabel")), HAS_SPECIAL_CHARACTER_ERROR, genErrorMessage(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral([
    "",
    " needs a special character"
])), "fieldLabel")), ONLY_NUMBERS_ERROR, genErrorMessage(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral([
    "",
    " must be only numbers"
])), "fieldLabel")), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_DEFAULT_ERROR_MESSAG, ONLY_LETTERS_ERROR, genErrorMessage(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral([
    "",
    " must be only letters"
])), "fieldLabel")), REQUIRED_FIELD_ERROR, genErrorMessage(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral([
    "",
    " is required"
])), "fieldLabel")), NUM_GREATER_THAN_ERROR, genErrorMessage(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral([
    "",
    " is too high"
])), "fieldLabel")), NUM_LESS_THAN_ERROR, genErrorMessage(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral([
    "",
    " is too low"
])), "fieldLabel")), MATCHES_FIELD_ERROR, genErrorMessage(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral([
    "",
    " must match ",
    ""
])), "fieldLabel", "matchField")), VALID_SELECT_OPTION_ERROR, genErrorMessage(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral([
    "",
    " is not a valid option"
])), "fieldLabel")));
// Constants to represent an input's state
// Neutral - has not been validated
// Invalid - has been validated and has an error
// Valid - has been validated and has no error
var INPUT_STATE_NEUTRAL = "NEUTRAL";
var INPUT_STATE_INVALID = "INVALID";
var INPUT_STATE_VALID = "VALID";
// Function to check the state of an input
// This function is intended to be used with inputs that have multiple validators
// Takes an input's state value, destructures for the input's error and showError booleans, list of errors
// Also takes a list of the specific error constants to look for
// If the input's showError property is false, the input has not been validated, and input state is NEUTRAL
// If the input has an error, and showError is true, check if the errors we care about are in the input's error list
// If yes, input state is INVALID
// If input has no error and showError is true, or the errors we're looking for aren't present in the list
// then input state is VALID
// { error: Boolean, showError: Boolean, errorsList: Array<String> }, Array<String> -> String
var getInputState = function getInputState(_ref) {
    var dirty = _ref.dirty, hasErrors = _ref.hasErrors, errors = _ref.errors, rawValue = _ref.rawValue;
    var errorsToCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (!dirty) return INPUT_STATE_NEUTRAL;
    else if (dirty && rawValue === "" || hasErrors && errorsToCheck.some(function(error) {
        return errors.includes(error);
    })) return INPUT_STATE_INVALID;
    return INPUT_STATE_VALID;
};
var PasswordRequirements = function PasswordRequirements(_ref) {
    var password = _ref.password, isMobile = _ref.isMobile;
    var iconMap = _defineProperty(_defineProperty(_defineProperty({}, INPUT_STATE_NEUTRAL, {
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement(IconNeutral, {
            margin: "0 0.5rem 0 0"
        }),
        color: MINESHAFT_GREY
    }), INPUT_STATE_INVALID, {
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement(IconInvalid, {
            margin: "0 0.5rem 0 0"
        }),
        color: RAZZMATAZZ_RED
    }), INPUT_STATE_VALID, {
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement(IconValid, {
            margin: "0 0.5rem 0 0",
            bgFill: SEA_GREEN
        }),
        color: SEA_GREEN
    });
    var validationMap = {
        charactersValidation: {
            validationMessage: "Password must be 8 characters",
            validationRequirement: [
                MIN_LENGTH_ERROR
            ]
        },
        numbersValidation: {
            validationMessage: "Password must contain at least one number",
            validationRequirement: [
                HAS_NUMBER_ERROR
            ]
        },
        letterCaseValidation: {
            validationMessage: "Password must contain an upper and lower case letter",
            validationRequirement: [
                HAS_UPPERCASE_LETTER_ERROR,
                HAS_LOWERCASE_LETTER_ERROR
            ]
        },
        specialCharacterValidation: {
            validationMessage: "Password must contain a special character (!@#$%^&*.?)",
            validationRequirement: [
                HAS_SPECIAL_CHARACTER_ERROR
            ]
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: ATHENS_GREY,
        padding: isMobile ? "1rem" : "1.5rem",
        width: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, null, Object.values(validationMap).map(function(item) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0",
            key: item.validationMessage
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Sidebar, {
            width: "24px",
            childGap: "0rem"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0",
            minHeight: "100%"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
            minHeight: "100%",
            singleChild: true
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0"
        }, iconMap[getInputState(password, item.validationRequirement)].icon))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Sidebar, {
            onRight: true,
            childGap: "0rem"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0.15rem 0 0 0"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
            justify: "flex-start",
            align: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
            fullHeight: true,
            childGap: "0.25rem"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
            variant: "pS",
            color: iconMap[getInputState(password, item.validationRequirement)].color
        }, item.validationMessage))))))));
    }))));
};
var color$a = {
    "default": "".concat(CHARADE_GREY),
    large: "".concat(BRIGHT_GREY)
};
var height$1 = {
    "default": "3rem",
    large: "192px"
};
var fallbackValues$r = {
    color: color$a,
    height: height$1
};
var getLargeIcon = function getLargeIcon(iconName, isDisabled) {
    switch(iconName){
        case "accounts":
            return isDisabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DisabledAccountsAddIcon, null) : /*#__PURE__*/ (0, _reactDefault.default).createElement(AccountsAddIcon$1, null);
        case "properties":
            return isDisabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DisabledPropertiesAddIcon, null) : /*#__PURE__*/ (0, _reactDefault.default).createElement(PropertiesAddIcon$1, null);
        case "payments":
            return isDisabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DisabledPaymentMethodsAddIcon, null) : /*#__PURE__*/ (0, _reactDefault.default).createElement(PaymentMethodAddIcon$1, null);
        default:
            return isDisabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DisabledAccountsAddIcon, null) : /*#__PURE__*/ (0, _reactDefault.default).createElement(AccountsAddIcon$1, null);
    }
};
var renderDisabledContent = function renderDisabledContent(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minHeight: "100%",
        extraStyles: "cursor: default;",
        "aria-disabled": true
    }, children);
};
var renderContent = function renderContent(_ref2) {
    var isLink = _ref2.isLink, destination = _ref2.destination, dataQa = _ref2.dataQa, children = _ref2.children, action = _ref2.action;
    return isLink ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Link), {
        to: destination,
        "data-qa": dataQa,
        style: {
            textDecoration: "none"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minHeight: "100%",
        extraStyles: "cursor: pointer;"
    }, children)) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        onClick: action,
        padding: "0",
        minHeight: "100%",
        extraStyles: "cursor: pointer;",
        dataQa: dataQa,
        tabIndex: "0",
        onKeyPress: function onKeyPress(e) {
            return e.key === "Enter" && action();
        }
    }, children);
};
var PlaceholderContentWrapper = function PlaceholderContentWrapper(_ref3) {
    var isLink = _ref3.isLink, action = _ref3.action, destination = _ref3.destination, children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? false : _ref3$isDisabled, dataQa = _ref3.dataQa;
    return isDisabled ? renderDisabledContent({
        children: children
    }) : renderContent({
        children: children,
        action: action,
        isLink: isLink,
        destination: destination,
        dataQa: dataQa
    });
};
var Placeholder = function Placeholder(_ref4) {
    var text = _ref4.text, action = _ref4.action, _ref4$visible = _ref4.visible, visible = _ref4$visible === void 0 ? true : _ref4$visible, _ref4$isLink = _ref4.isLink, isLink = _ref4$isLink === void 0 ? false : _ref4$isLink, destination = _ref4.destination, variant = _ref4.variant, largeIcon = _ref4.largeIcon, themeValues = _ref4.themeValues, _ref4$isDisabled = _ref4.isDisabled, isDisabled = _ref4$isDisabled === void 0 ? false : _ref4$isDisabled, dataQa = _ref4.dataQa;
    var borderColor = isDisabled ? MANATEE_GREY : themeValues.color;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(PlaceholderContentWrapper, {
        isLink: isLink,
        action: action,
        destination: destination,
        dataQa: dataQa,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        borderRadius: "4px",
        border: "none",
        minHeight: themeValues.height,
        hiddenStyles: !visible,
        extraStyles: "\n          display: flex;\n          justify-content: center;\n          align-items:center;\n          background-image: repeating-linear-gradient(0deg, ".concat(borderColor, ", ").concat(borderColor, " 2px, transparent 2px, transparent 4px, ").concat(borderColor, " 4px), repeating-linear-gradient(90deg, ").concat(borderColor, ", ").concat(borderColor, " 2px, transparent 2px, transparent 4px, ").concat(borderColor, " 4px), repeating-linear-gradient(180deg, ").concat(borderColor, ", ").concat(borderColor, " 2px, transparent 2px, transparent 4px, ").concat(borderColor, " 4px), repeating-linear-gradient(270deg, ").concat(borderColor, ", ").concat(borderColor, " 2px, transparent 2px, transparent 4px, ").concat(borderColor, " 4px);\n          background-size: 2px 100%, 100% 2px, 2px 100% , 100% 2px;\n          background-position: 0 0, 0 0, 100% 0, 0 100%;\n          background-repeat: no-repeat;\n        "),
        hoverStyles: "background-color: ".concat(isDisabled ? TRANSPARENT : curriedTint$1(0.9, themeValues.color), ";"),
        focusStyles: "background-color: ".concat(isDisabled ? TRANSPARENT : curriedTint$1(0.9, themeValues.color), ";"),
        activeStyles: "background-color: ".concat(isDisabled ? TRANSPARENT : curriedTint$1(0.8, themeValues.color), "; ").concat(!isDisabled && "background-image:none; border: 2px solid ".concat(borderColor, ";}"))
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: "300px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "center",
        minHeight: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Switcher, {
        maxChildren: 2,
        childGap: "0"
    }, variant === "large" && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        "aria-disabled": isDisabled,
        extraStyles: ".fill { \n                    fill: ".concat(isDisabled ? MANATEE_GREY : themeValues.color, "; \n                  } .stroke { \n                    stroke: ").concat(isDisabled ? MANATEE_GREY : themeValues.color, "; \n                  } ")
    }, variant === "large" ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        intrinsic: true
    }, getLargeIcon(largeIcon, isDisabled), /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pS",
        color: isDisabled ? MANATEE_GREY : themeValues.color,
        weight: FONT_WEIGHT_SEMIBOLD,
        extraStyles: "text-align: center;"
    }, text)) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        singleChild: true,
        minHeight: "100%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PlusCircleIcon, {
        color: isDisabled ? MANATEE_GREY : themeValues.color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        intrinsic: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pS",
        color: isDisabled ? MANATEE_GREY : themeValues.color,
        weight: FONT_WEIGHT_SEMIBOLD,
        extraStyles: "padding: 0 0 0 8px; text-align: center;"
    }, text)))))))))));
};
var Placeholder$1 = themeComponent(Placeholder, "Placeholder", fallbackValues$r, "default");
var backgroundColor$5 = {
    "default": "".concat(WHITE)
};
var fallbackValues$s = {
    backgroundColor: backgroundColor$5
};
var ProcessingFee = function ProcessingFee(_ref) {
    var _ref$feeValue = _ref.feeValue, feeValue = _ref$feeValue === void 0 ? 0 : _ref$feeValue, _ref$feeName = _ref.feeName, feeName = _ref$feeName === void 0 ? "" : _ref$feeName, feeType = _ref.feeType, _ref$feeMinimum = _ref.feeMinimum, feeMinimum = _ref$feeMinimum === void 0 ? 0 : _ref$feeMinimum, hide = _ref.hide, themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 1.5rem 1.5rem",
        background: themeValues.backgroundColor,
        hiddenStyles: hide
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Alert$1, {
        heading: "Processing Fee",
        text: "There is a processing fee of ".concat(feeType === "FLAT" ? "".concat(displayCurrency(feeValue)) : "".concat(formatPercent(feeValue * 100), "%"), " ").concat(ifElse(isNil, always(""), function(a) {
            return "with a minimum of ".concat(displayCurrency(a), " ");
        })(feeMinimum), "on all ").concat(feeName, " payments."),
        variant: "info",
        showQuitLink: false
    }));
};
var ProcessingFee$1 = themeComponent(ProcessingFee, "ProcessingFee", fallbackValues$s, "default");
var activeColor$4 = MATISSE_BLUE;
var disabledColor$1 = MANATEE_GREY;
var inactiveBorderColor = GREY_CHATEAU;
var fallbackValues$t = {
    activeColor: activeColor$4,
    disabledColor: disabledColor$1,
    inactiveBorderColor: inactiveBorderColor
};
var HiddenRadioInput = (0, _styledComponentsDefault.default).input.withConfig({
    displayName: "RadioButtonWithLabel__HiddenRadioInput",
    componentId: "sc-1m9whwg-0"
})([
    "position:absolute;opacity:0;margin:0;"
]);
var Circle = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "RadioButtonWithLabel__Circle",
    componentId: "sc-1m9whwg-1"
})([
    "flex-shrink:0;margin-right:8px;width:1.5rem;height 1.5rem;border:",
    ';border-radius:50%;box-sizing:border-box;padding:2px;:after{content:"";width:100%;height:100%;display:block;background:',
    ";border-radius:50%;transform:scale(0);}"
], function(_ref) {
    var borderColor = _ref.borderColor;
    return "1px solid ".concat(borderColor);
}, function(_ref2) {
    var activeColor = _ref2.activeColor;
    return activeColor;
});
var InputAndLabelContainer = (0, _styledComponentsDefault.default)(Cluster).withConfig({
    displayName: "RadioButtonWithLabel__InputAndLabelContainer",
    componentId: "sc-1m9whwg-2"
})([
    "overflow:visible;",
    ":checked + label ",
    ":after{transform:scale(0.85);transition:transform 0.15s;}",
    ":checked + label ",
    "{border:",
    "}",
    ":focus + label ",
    "{{box-shadow:",
    "}"
], HiddenRadioInput, Circle, HiddenRadioInput, Circle, function(_ref3) {
    var borderColor = _ref3.borderColor;
    return "1px solid ".concat(borderColor, ";");
}, HiddenRadioInput, Circle, function(_ref4) {
    var borderColor = _ref4.borderColor;
    return "0px 0px 2px 1px ".concat(borderColor, ";");
});
var RadioButtonWithLabel = function RadioButtonWithLabel(_ref5) {
    var _ref5$id = _ref5.id, id = _ref5$id === void 0 ? "" : _ref5$id, _ref5$value = _ref5.value, value = _ref5$value === void 0 ? "" : _ref5$value, _ref5$labelText = _ref5.labelText, labelText = _ref5$labelText === void 0 ? "" : _ref5$labelText, groupName = _ref5.groupName, setValue = _ref5.setValue, ariaInvalid = _ref5.ariaInvalid, themeValues = _ref5.themeValues, index = _ref5.index, _ref5$handleChange = _ref5.handleChange, handleChange = _ref5$handleChange === void 0 ? noop$1 : _ref5$handleChange, field = _ref5.field, config = _ref5.config, _ref5$disabled = _ref5.disabled, disabled = _ref5$disabled === void 0 ? false : _ref5$disabled;
    var getDefaultChecked = function getDefaultChecked(value, idx) {
        var selectionExistsInConfig = config === null || config === void 0 ? void 0 : config.map(function(c) {
            return c.value;
        }).includes(field.rawValue);
        if (selectionExistsInConfig) // if exists, selection comes from the redux-freeform state
        return field.rawValue === value;
        // fallback to first option as default selection
        return idx === 0;
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(InputAndLabelContainer, {
        align: "center",
        childGap: "0.5rem",
        borderColor: disabled ? themeValues.inactiveBorderColor : themeValues.activeColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(HiddenRadioInput, {
        disabled: disabled,
        "aria-invalid": ariaInvalid,
        style: {
            marginTop: 0
        },
        type: "radio",
        name: groupName,
        id: id,
        value: value,
        onChange: function onChange(e) {
            setValue(e.target.value);
            handleChange(e);
        },
        defaultChecked: getDefaultChecked(value, index)
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        as: "label",
        htmlFor: id,
        extraStyles: "\n          font-size: 1rem;\n          display: flex; \n          width: 100%;\n          :hover {\n            cursor: pointer;\n          }\n        "
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Circle, {
        activeColor: disabled ? themeValues.disabledColor : themeValues.activeColor,
        borderColor: themeValues.inactiveBorderColor
    }), labelText));
};
var RadioButtonWithLabel$1 = themeComponent(RadioButtonWithLabel, "RadioButtonWithLabel", fallbackValues$t);
var activeColor$5 = "".concat(MATISSE_BLUE);
var inactiveColor$1 = "".concat(STORM_GREY);
var fallbackValues$u = {
    activeColor: activeColor$5,
    inactiveColor: inactiveColor$1
};
var HiddenRadioButton = (0, _styledComponentsDefault.default).input.withConfig({
    displayName: "RadioButton__HiddenRadioButton",
    componentId: "sc-v6hie9-0"
})([
    "opacity:0;position:absolute;cursor:",
    ";"
], function(_ref) {
    var disabled = _ref.disabled;
    return disabled ? "auto" : "pointer";
});
var RadioButton$1 = function RadioButton(_ref2) {
    var _ref2$radioOn = _ref2.radioOn, radioOn = _ref2$radioOn === void 0 ? false : _ref2$radioOn, _ref2$radioFocused = _ref2.radioFocused, radioFocused = _ref2$radioFocused === void 0 ? false : _ref2$radioFocused, toggleRadio = _ref2.toggleRadio, name = _ref2.name, _ref2$disabled = _ref2.disabled, disabled = _ref2$disabled === void 0 ? false : _ref2$disabled, ariaDescribedBy = _ref2.ariaDescribedBy, themeValues = _ref2.themeValues, _ref2$ariaLabelledBy = _ref2.ariaLabelledBy, ariaLabelledBy = _ref2$ariaLabelledBy === void 0 ? "" : _ref2$ariaLabelledBy, _ref2$ariaLabel = _ref2.ariaLabel, ariaLabel = _ref2$ariaLabel === void 0 ? null : _ref2$ariaLabel, _ref2$isRequired = _ref2.isRequired, isRequired = _ref2$isRequired === void 0 ? false : _ref2$isRequired, inputRef = _ref2.inputRef, _ref2$tabIndex = _ref2.tabIndex, tabIndex = _ref2$tabIndex === void 0 ? "-1" : _ref2$tabIndex, _ref2$checked = _ref2.checked, checked = _ref2$checked === void 0 ? false : _ref2$checked, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onKeyDown = _ref2.onKeyDown;
    var shouldReduceMotion = useReducedMotion();
    var reducedTransition = shouldReduceMotion ? {
        duration: 0
    } : undefined;
    var buttonBorder = {
        onFocused: {
            borderColor: themeValues.activeColor,
            outlineWidth: "3px",
            outlineColor: themeValues.activeColor,
            outlineOffset: "2px"
        },
        offFocused: {
            borderColor: themeValues.activeColor,
            outlineWidth: "3px",
            outlineColor: themeValues.activeColor,
            outlineOffset: "2px"
        },
        on: {
            borderColor: themeValues.activeColor,
            outlineWidth: "0px",
            outlineColor: "rgba(0, 0, 0, 0)"
        },
        off: {
            borderColor: themeValues.inactiveColor,
            outlineWidth: "0px",
            outlineColor: "rgba(0, 0, 0, 0)"
        }
    };
    var buttonCenter = {
        on: {
            backgroundColor: themeValues.activeColor,
            height: "16px",
            width: "16px"
        },
        onFocused: {
            backgroundColor: themeValues.activeColor,
            height: "16px",
            width: "16px"
        },
        offFocused: {
            backgroundColor: "transparent",
            height: "0px",
            width: "0px"
        },
        off: {
            backgroundColor: "transparent",
            height: "0px",
            width: "0px"
        }
    };
    var extraProps = {};
    if (ariaLabelledBy && ariaLabelledBy.length) extraProps["aria-labelledby"] = ariaLabelledBy;
    else if (ariaLabel && ariaLabel !== null) extraProps["aria-label"] = ariaLabel;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Motion, {
        position: "relative",
        padding: "0",
        initial: "off",
        animate: radioOn ? radioFocused ? "onFocused" : "on" : radioFocused ? "offFocused" : "off"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(HiddenRadioButton, _extends({
        type: "radio",
        id: "radio-".concat(name),
        ref: inputRef,
        disabled: disabled,
        checked: checked,
        onChange: toggleRadio,
        "aria-describedby": ariaDescribedBy,
        tabIndex: tabIndex,
        required: isRequired,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown
    }, extraProps)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Motion, {
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "12px",
        margin: "6px 8px 6px 6px",
        height: "24px",
        width: "24px",
        variants: buttonBorder,
        transition: reducedTransition,
        display: "flex",
        extraStyles: "outline: 0px solid rgba(0, 0, 0, 0); justify-content: center; align-items: center;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Motion, {
        variants: buttonCenter,
        transition: reducedTransition,
        borderRadius: "8px"
    })));
};
var RadioButton$2 = themeComponent(RadioButton$1, "RadioButton", fallbackValues$u);
var searchIconColor = WHITE;
var searchIconBackgroundColor = MATISSE_BLUE;
var fallbackValues$v = {
    searchIconColor: searchIconColor,
    searchIconBackgroundColor: searchIconBackgroundColor
};
/**
 * Search requires a redux-freeform field and actions to use
 * for its `FormInput` state, as well as a dataset and the keys you wish
 * to include in your search.
 *
 * The `dataset` expected is a one-dimensional array of objects.
 * Properties within the objects are included in the traversal
 * when they are present in the `valuesToSearchFor` prop.
 *
 * This component expects implementations of `onSearchCallback` and `onClearCallback`
 * in the consuming application. For example, if you want to filter a table based on
 * this, your callbacks should trigger the adjustment of your table data's state in your
 * application implementing Search.
 */ var Search = function Search(_ref) {
    var field = _ref.field, fieldActions = _ref.fieldActions, dataset = _ref.dataset, _ref$disableFilter = _ref.disableFilter, disableFilter = _ref$disableFilter === void 0 ? false : _ref$disableFilter, valuesToSearchFor = _ref.valuesToSearchFor, onSearchCallback = _ref.onSearchCallback, onClearCallback = _ref.onClearCallback, disabled = _ref.disabled, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? "Search" : _ref$placeholder, _ref$searchOnKeypress = _ref.searchOnKeypress, searchOnKeypress = _ref$searchOnKeypress === void 0 ? false : _ref$searchOnKeypress, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, ariaControlsId = _ref.ariaControlsId, themeValues = _ref.themeValues, extraStyles = _ref.extraStyles;
    var searchTerm = field.rawValue;
    var getFilteredDataset = function getFilteredDataset() {
        if (!searchTerm) return dataset;
        return dataset.filter(function(item) {
            return valuesToSearchFor.some(function(key) {
                var _item$key;
                return (_item$key = item[key]) === null || _item$key === void 0 ? void 0 : _item$key.toString().toLowerCase().includes(searchTerm.toLowerCase());
            });
        });
    };
    var handleSubmit = function handleSubmit() {
        return disableFilter ? onSearchCallback() : onSearchCallback(getFilteredDataset());
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        extraStyles: "overflow: visible; width: ".concat(width, "; ").concat(extraStyles)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        extraStyles: "flex-grow: 1;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        id: "searchInput",
        role: "search",
        "aria-controls": ariaControlsId,
        extraStyles: "border-radius: 4px 0 0 4px; border: none; box-shadow: 0px 1px 2px 0px ".concat(CHARADE_GREY, "1A; font-size: 0.875rem;"),
        onKeyDown: function onKeyDown(e) {
            return searchOnKeypress || e.key === "Enter" ? handleSubmit() : noop$1;
        },
        field: field,
        fieldActions: fieldActions,
        placeholder: placeholder,
        errorMessages: {},
        disabled: disabled
    }), searchTerm.length > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        extraStyles: "\n            position: absolute;\n            right: 8px;\n            top: 10px;\n          "
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        extraStyles: "* > span { text-decoration: none; }",
        type: "reset",
        variant: "smallGhost",
        text: "Clear Search",
        "aria-label": "Clear Search",
        action: function action() {
            fieldActions.set("");
            onClearCallback();
        }
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        type: "submit",
        "aria-label": "Submit search",
        minWidth: "0",
        width: "3rem",
        padding: ".5rem",
        extraStyles: "\n          height: 48px; \n          margin: 4px 0 0;\n          border-radius: 0 4px 4px 0;\n          background: ".concat(themeValues.searchIconBackgroundColor, ";\n          border: none;\n          box-shadow: 0px 1px 2px 0px ").concat(CHARADE_GREY, "1A;\n        "),
        variant: "primary",
        contentOverride: true,
        action: handleSubmit
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SearchIcon, {
        color: themeValues.searchIconColor,
        size: 24
    })));
};
var Search$1 = themeComponent(Search, "Search", fallbackValues$v);
var border$2 = {
    "default": "1px solid #caced8"
};
var fallbackValues$w = {
    border: border$2
};
var SELECT_ALL = "Select All";
var SearchableSelect = function SearchableSelect(_ref) {
    var autocompleteValue = _ref.autocompleteValue, items = _ref.items, selectedItems = _ref.selectedItems, allSelected = _ref.allSelected, toggleSelectAllItems = _ref.toggleSelectAllItems, selectItem = _ref.selectItem, fields = _ref.fields, actions = _ref.actions, disabled = _ref.disabled, themeValues = _ref.themeValues, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? "Search agencies" : _ref$placeholder;
    var _useState = (0, _react.useState)([]), _useState2 = _slicedToArray(_useState, 2), itemList = _useState2[0], setItemList = _useState2[1];
    var completeOptionsList = itemList.sort(function(a, b) {
        return a.name == SELECT_ALL ? -1 : b.name === SELECT_ALL ? 1 : a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
    (0, _react.useEffect)(function() {
        return setItemList(items);
    }, [
        items,
        selectedItems
    ]);
    (0, _react.useEffect)(function() {
        var filteredItems = items.filter(function(item) {
            var _item$name, _fields$searchTerm;
            return item === null || item === void 0 || (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(fields === null || fields === void 0 || (_fields$searchTerm = fields.searchTerm) === null || _fields$searchTerm === void 0 || (_fields$searchTerm = _fields$searchTerm.rawValue) === null || _fields$searchTerm === void 0 ? void 0 : _fields$searchTerm.toLowerCase());
        });
        setItemList(filteredItems);
    }, [
        fields.searchTerm.rawValue
    ]);
    var handleSelect = function handleSelect(value) {
        if (value.name === SELECT_ALL) allSelected ? toggleSelectAllItems(false) : toggleSelectAllItems(true);
        else selectItem(value);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1rem",
        border: themeValues.border,
        extraStyles: disabled && "color: #6e727e; background-color: #f7f7f7; pointer-events: none;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        autocompleteValue: autocompleteValue,
        errorMessages: {},
        field: fields.searchTerm,
        fieldActions: actions.fields.searchTerm,
        placeholder: placeholder,
        disabled: disabled
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 0 0.5rem",
        extraStyles: "overflow-y: scroll; max-height: 250px;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, null, completeOptionsList.map(function(option) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Checkbox$1, {
            key: option.name,
            title: option.name,
            name: option.name,
            checked: !!(selectedItems !== null && selectedItems !== void 0 && selectedItems.find(function(item) {
                return (item === null || item === void 0 ? void 0 : item.name) === (option === null || option === void 0 ? void 0 : option.name);
            })),
            onChange: function onChange() {
                return handleSelect(option);
            },
            textExtraStyles: "margin: 0;",
            disabled: disabled,
            extraStyles: "margin: 0.5rem;"
        });
    }))));
};
var SearchableSelect$1 = themeComponent(SearchableSelect, "SearchableSelect", fallbackValues$w, "default");
var borderColor$4 = {
    "default": "".concat(GREY_CHATEAU)
};
var borderSize = {
    "default": "1px"
};
var fallbackValues$x = {
    borderColor: borderColor$4,
    borderSize: borderSize
};
var SolidDivider = function SolidDivider(_ref) {
    var borderColor = _ref.borderColor, borderSize = _ref.borderSize, themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        minHeight: "1px",
        borderColor: borderColor || themeValues.borderColor,
        borderSize: borderSize || themeValues.borderSize,
        borderWidthOverride: "0px 0px ".concat(borderSize || themeValues.borderSize, " 0px")
    });
};
var SolidDivider$1 = themeComponent(SolidDivider, "SolidDivider", fallbackValues$x, "default");
var placeHolderOptionUS = {
    text: "Please select state",
    value: ""
};
var placeHolderOption = {
    text: "Please select state or province",
    value: ""
};
var getOptions = function getOptions(countryCode) {
    return allOptions[countryCode];
};
var allOptions = {
    AF: [
        {
            text: "Badakhshan",
            value: "BDS"
        },
        {
            text: "Baghlan",
            value: "BGL"
        },
        {
            text: "Balkh",
            value: "BAL"
        },
        {
            text: "Bamyan",
            value: "BAM"
        },
        {
            text: "Farah",
            value: "FRA"
        },
        {
            text: "Faryab",
            value: "FYB"
        },
        {
            text: "Ghazni",
            value: "GHA"
        },
        {
            text: "Helmand",
            value: "HEL"
        },
        {
            text: "Herat",
            value: "HER"
        },
        {
            text: "Kabul",
            value: "KAB"
        },
        {
            text: "Kandahar",
            value: "KAN"
        },
        {
            text: "Kapisa",
            value: "KAP"
        },
        {
            text: "Khost",
            value: "KHO"
        },
        {
            text: "Kunduz",
            value: "KDZ"
        },
        {
            text: "Logar",
            value: "LOG"
        },
        {
            text: "Nangarhar",
            value: "NAN"
        },
        {
            text: "Nimroz",
            value: "NIM"
        },
        {
            text: "Paktiya",
            value: "PIA"
        },
        {
            text: "Parwan",
            value: "PAR"
        },
        {
            text: "Samangan",
            value: "SAM"
        },
        {
            text: "Takhar",
            value: "TAK"
        },
        {
            text: "Uruzgan",
            value: "URU"
        }
    ],
    AX: [
        {
            text: "Eckeroe",
            value: "01"
        },
        {
            text: "Finstroem",
            value: "02"
        },
        {
            text: "Hammarland",
            value: "03"
        },
        {
            text: "Jomala",
            value: "04"
        },
        {
            text: "Mariehamn",
            value: "05"
        },
        {
            text: "Saltvik",
            value: "06"
        },
        {
            text: "Sund",
            value: "07"
        }
    ],
    AL: [
        {
            text: "Berat",
            value: "01"
        },
        {
            text: "Diber",
            value: "09"
        },
        {
            text: "Durres",
            value: "02"
        },
        {
            text: "Elbasan",
            value: "03"
        },
        {
            text: "Fier",
            value: "04"
        },
        {
            text: "Gjirokaster",
            value: "05"
        },
        {
            text: "Korce",
            value: "06"
        },
        {
            text: "Kukes",
            value: "07"
        },
        {
            text: "Lezhe",
            value: "08"
        },
        {
            text: "Shkoder",
            value: "10"
        },
        {
            text: "Tirane",
            value: "11"
        },
        {
            text: "Vlore",
            value: "12"
        }
    ],
    DZ: [
        {
            text: "Adrar",
            value: "01"
        },
        {
            text: "Ain Defla",
            value: "44"
        },
        {
            text: "Ain Temouchent",
            value: "46"
        },
        {
            text: "Alger",
            value: "16"
        },
        {
            text: "Annaba",
            value: "23"
        },
        {
            text: "Batna",
            value: "05"
        },
        {
            text: "Bechar",
            value: "08"
        },
        {
            text: "Bejaia",
            value: "06"
        },
        {
            text: "Biskra",
            value: "07"
        },
        {
            text: "Blida",
            value: "09"
        },
        {
            text: "Bordj Bou Arreridj",
            value: "34"
        },
        {
            text: "Bouira",
            value: "10"
        },
        {
            text: "Boumerdes",
            value: "35"
        },
        {
            text: "Chlef",
            value: "02"
        },
        {
            text: "Constantine",
            value: "25"
        },
        {
            text: "Djelfa",
            value: "17"
        },
        {
            text: "El Bayadh",
            value: "32"
        },
        {
            text: "El Oued",
            value: "39"
        },
        {
            text: "El Tarf",
            value: "36"
        },
        {
            text: "Ghardaia",
            value: "47"
        },
        {
            text: "Guelma",
            value: "24"
        },
        {
            text: "Illizi",
            value: "33"
        },
        {
            text: "Jijel",
            value: "18"
        },
        {
            text: "Khenchela",
            value: "40"
        },
        {
            text: "Laghouat",
            value: "03"
        },
        {
            text: "M'sila",
            value: "28"
        },
        {
            text: "Mascara",
            value: "29"
        },
        {
            text: "Medea",
            value: "26"
        },
        {
            text: "Mila",
            value: "43"
        },
        {
            text: "Mostaganem",
            value: "27"
        },
        {
            text: "Naama",
            value: "45"
        },
        {
            text: "Oran",
            value: "31"
        },
        {
            text: "Ouargla",
            value: "30"
        },
        {
            text: "Oum el Bouaghi",
            value: "04"
        },
        {
            text: "Relizane",
            value: "48"
        },
        {
            text: "Saida",
            value: "20"
        },
        {
            text: "Setif",
            value: "19"
        },
        {
            text: "Sidi Bel Abbes",
            value: "22"
        },
        {
            text: "Skikda",
            value: "21"
        },
        {
            text: "Souk Ahras",
            value: "41"
        },
        {
            text: "Tamanrasset",
            value: "11"
        },
        {
            text: "Tebessa",
            value: "12"
        },
        {
            text: "Tiaret",
            value: "14"
        },
        {
            text: "Tindouf",
            value: "37"
        },
        {
            text: "Tipaza",
            value: "42"
        },
        {
            text: "Tissemsilt",
            value: "38"
        },
        {
            text: "Tizi Ouzou",
            value: "15"
        },
        {
            text: "Tlemcen",
            value: "13"
        }
    ],
    AS: [
        {
            text: "Eastern District",
            value: "01"
        }
    ],
    AD: [
        {
            text: "Andorra la Vella",
            value: "07"
        },
        {
            text: "Canillo",
            value: "02"
        },
        {
            text: "Encamp",
            value: "03"
        },
        {
            text: "Escaldes-Engordany",
            value: "08"
        },
        {
            text: "La Massana",
            value: "04"
        },
        {
            text: "Ordino",
            value: "05"
        },
        {
            text: "Sant Julia de Loria",
            value: "06"
        }
    ],
    AO: [
        {
            text: "Bengo",
            value: "BGO"
        },
        {
            text: "Benguela",
            value: "BGU"
        },
        {
            text: "Bie",
            value: "BIE"
        },
        {
            text: "Cabinda",
            value: "CAB"
        },
        {
            text: "Cunene",
            value: "CNN"
        },
        {
            text: "Huambo",
            value: "HUA"
        },
        {
            text: "Huila",
            value: "HUI"
        },
        {
            text: "Kuando Kubango",
            value: "CCU"
        },
        {
            text: "Kwanza Norte",
            value: "CNO"
        },
        {
            text: "Kwanza Sul",
            value: "CUS"
        },
        {
            text: "Luanda",
            value: "LUA"
        },
        {
            text: "Lunda Norte",
            value: "LNO"
        },
        {
            text: "Lunda Sul",
            value: "LSU"
        },
        {
            text: "Malange",
            value: "MAL"
        },
        {
            text: "Moxico",
            value: "MOX"
        },
        {
            text: "Namibe",
            value: "NAM"
        },
        {
            text: "Uige",
            value: "UIG"
        },
        {
            text: "Zaire",
            value: "ZAI"
        }
    ],
    AI: [
        {
            text: "Anguilla",
            value: "01"
        }
    ],
    AQ: [
        {
            text: "-",
            value: "01"
        }
    ],
    AG: [
        {
            text: "Redonda",
            value: "11"
        },
        {
            text: "Saint George",
            value: "03"
        },
        {
            text: "Saint John",
            value: "04"
        },
        {
            text: "Saint Mary",
            value: "05"
        },
        {
            text: "Saint Paul",
            value: "06"
        },
        {
            text: "Saint Peter",
            value: "07"
        },
        {
            text: "Saint Philip",
            value: "08"
        }
    ],
    AR: [
        {
            text: "Buenos Aires",
            value: "B"
        },
        {
            text: "Catamarca",
            value: "K"
        },
        {
            text: "Chaco",
            value: "H"
        },
        {
            text: "Chubut",
            value: "U"
        },
        {
            text: "Ciudad Autonoma de Buenos Aires",
            value: "C"
        },
        {
            text: "Cordoba",
            value: "X"
        },
        {
            text: "Corrientes",
            value: "W"
        },
        {
            text: "Entre Rios",
            value: "E"
        },
        {
            text: "Formosa",
            value: "P"
        },
        {
            text: "Jujuy",
            value: "Y"
        },
        {
            text: "La Pampa",
            value: "L"
        },
        {
            text: "La Rioja",
            value: "F"
        },
        {
            text: "Mendoza",
            value: "M"
        },
        {
            text: "Misiones",
            value: "N"
        },
        {
            text: "Neuquen",
            value: "Q"
        },
        {
            text: "Rio Negro",
            value: "R"
        },
        {
            text: "Salta",
            value: "A"
        },
        {
            text: "San Juan",
            value: "J"
        },
        {
            text: "San Luis",
            value: "D"
        },
        {
            text: "Santa Cruz",
            value: "Z"
        },
        {
            text: "Santa Fe",
            value: "S"
        },
        {
            text: "Santiago del Estero",
            value: "G"
        },
        {
            text: "Tierra del Fuego",
            value: "V"
        },
        {
            text: "Tucuman",
            value: "T"
        }
    ],
    AM: [
        {
            text: "Aragacotn",
            value: "AG"
        },
        {
            text: "Ararat",
            value: "AR"
        },
        {
            text: "Armavir",
            value: "AV"
        },
        {
            text: "Erevan",
            value: "ER"
        },
        {
            text: "Gegark'unik'",
            value: "GR"
        },
        {
            text: "Kotayk'",
            value: "KT"
        },
        {
            text: "Lori",
            value: "LO"
        },
        {
            text: "Sirak",
            value: "SH"
        },
        {
            text: "Syunik'",
            value: "SU"
        },
        {
            text: "Tavus",
            value: "TV"
        },
        {
            text: "Vayoc Jor",
            value: "VD"
        }
    ],
    AW: [
        {
            text: "Aruba",
            value: "01"
        }
    ],
    AU: [
        {
            text: "Australian Capital Territory",
            value: "ACT"
        },
        {
            text: "New South Wales",
            value: "NSW"
        },
        {
            text: "Northern Territory",
            value: "NT"
        },
        {
            text: "Queensland",
            value: "QLD"
        },
        {
            text: "South Australia",
            value: "SA"
        },
        {
            text: "Tasmania",
            value: "TAS"
        },
        {
            text: "Victoria",
            value: "VIC"
        },
        {
            text: "Western Australia",
            value: "WA"
        }
    ],
    AT: [
        {
            text: "Burgenland",
            value: "1"
        },
        {
            text: "Karnten",
            value: "2"
        },
        {
            text: "Niederosterreich",
            value: "3"
        },
        {
            text: "Oberosterreich",
            value: "4"
        },
        {
            text: "Salzburg",
            value: "5"
        },
        {
            text: "Steiermark",
            value: "6"
        },
        {
            text: "Tirol",
            value: "7"
        },
        {
            text: "Vorarlberg",
            value: "8"
        },
        {
            text: "Wien",
            value: "9"
        }
    ],
    AZ: [
        {
            text: "Abseron",
            value: "ABS"
        },
        {
            text: "Agcabadi",
            value: "AGC"
        },
        {
            text: "Agdas",
            value: "AGS"
        },
        {
            text: "Agstafa",
            value: "AGA"
        },
        {
            text: "Agsu",
            value: "AGU"
        },
        {
            text: "Astara",
            value: "AST"
        },
        {
            text: "Baki",
            value: "BA"
        },
        {
            text: "Balakan",
            value: "BAL"
        },
        {
            text: "Barda",
            value: "BAR"
        },
        {
            text: "Beylaqan",
            value: "BEY"
        },
        {
            text: "Bilasuvar",
            value: "BIL"
        },
        {
            text: "Calilabad",
            value: "CAL"
        },
        {
            text: "Daskasan",
            value: "DAS"
        },
        {
            text: "Gadabay",
            value: "GAD"
        },
        {
            text: "Ganca",
            value: "GA"
        },
        {
            text: "Goranboy",
            value: "GOR"
        },
        {
            text: "Goycay",
            value: "GOY"
        },
        {
            text: "Goygol",
            value: "GYG"
        },
        {
            text: "Haciqabul",
            value: "HAC"
        },
        {
            text: "Imisli",
            value: "IMI"
        },
        {
            text: "Ismayilli",
            value: "ISM"
        },
        {
            text: "Kurdamir",
            value: "KUR"
        },
        {
            text: "Lankaran",
            value: "LA"
        },
        {
            text: "Masalli",
            value: "MAS"
        },
        {
            text: "Mingacevir",
            value: "MI"
        },
        {
            text: "Naftalan",
            value: "NA"
        },
        {
            text: "Naxcivan",
            value: "NX"
        },
        {
            text: "Neftcala",
            value: "NEF"
        },
        {
            text: "Oguz",
            value: "OGU"
        },
        {
            text: "Qabala",
            value: "QAB"
        },
        {
            text: "Qax",
            value: "QAX"
        },
        {
            text: "Qazax",
            value: "QAZ"
        },
        {
            text: "Quba",
            value: "QBA"
        },
        {
            text: "Qusar",
            value: "QUS"
        },
        {
            text: "Sabirabad",
            value: "SAB"
        },
        {
            text: "Saki",
            value: "SAK"
        },
        {
            text: "Salyan",
            value: "SAL"
        },
        {
            text: "Samaxi",
            value: "SMI"
        },
        {
            text: "Samkir",
            value: "SKR"
        },
        {
            text: "Samux",
            value: "SMX"
        },
        {
            text: "Sirvan",
            value: "SR"
        },
        {
            text: "Siyazan",
            value: "SIY"
        },
        {
            text: "Sumqayit",
            value: "SM"
        },
        {
            text: "Tovuz",
            value: "TOV"
        },
        {
            text: "Xacmaz",
            value: "XAC"
        },
        {
            text: "Xizi",
            value: "XIZ"
        },
        {
            text: "Yevlax",
            value: "YEV"
        },
        {
            text: "Zaqatala",
            value: "ZAQ"
        }
    ],
    BS: [
        {
            text: "Central Andros",
            value: "CS"
        },
        {
            text: "City of Freeport",
            value: "FP"
        },
        {
            text: "Harbour Island",
            value: "HI"
        },
        {
            text: "Hope Town",
            value: "HT"
        },
        {
            text: "Long Island",
            value: "LI"
        },
        {
            text: "New Providence",
            value: "NP"
        },
        {
            text: "South Eleuthera",
            value: "SE"
        }
    ],
    BH: [
        {
            text: "Al 'Asimah",
            value: "13"
        },
        {
            text: "Al Janubiyah",
            value: "14"
        },
        {
            text: "Al Muharraq",
            value: "15"
        },
        {
            text: "Ash Shamaliyah",
            value: "17"
        }
    ],
    BD: [
        {
            text: "Barisal",
            value: "A"
        },
        {
            text: "Chittagong",
            value: "B"
        },
        {
            text: "Dhaka",
            value: "C"
        },
        {
            text: "Khulna",
            value: "D"
        },
        {
            text: "Rajshahi",
            value: "E"
        },
        {
            text: "Rangpur",
            value: "F"
        },
        {
            text: "Sylhet",
            value: "G"
        }
    ],
    BB: [
        {
            text: "Christ Church",
            value: "01"
        },
        {
            text: "Saint Andrew",
            value: "02"
        },
        {
            text: "Saint George",
            value: "03"
        },
        {
            text: "Saint James",
            value: "04"
        },
        {
            text: "Saint John",
            value: "05"
        },
        {
            text: "Saint Joseph",
            value: "06"
        },
        {
            text: "Saint Lucy",
            value: "07"
        },
        {
            text: "Saint Michael",
            value: "08"
        },
        {
            text: "Saint Peter",
            value: "09"
        },
        {
            text: "Saint Philip",
            value: "10"
        },
        {
            text: "Saint Thomas",
            value: "11"
        }
    ],
    BY: [
        {
            text: "Brestskaya voblasts'",
            value: "BR"
        },
        {
            text: "Homyel'skaya voblasts'",
            value: "HO"
        },
        {
            text: "Horad Minsk",
            value: "HM"
        },
        {
            text: "Hrodzenskaya voblasts'",
            value: "HR"
        },
        {
            text: "Mahilyowskaya voblasts'",
            value: "MA"
        },
        {
            text: "Minskaya voblasts'",
            value: "MI"
        },
        {
            text: "Vitsyebskaya voblasts'",
            value: "VI"
        }
    ],
    BE: [
        {
            text: "Antwerpen",
            value: "VAN"
        },
        {
            text: "Brabant wallon",
            value: "WBR"
        },
        {
            text: "Brussels Hoofdstedelijk Gewest",
            value: "BRU"
        },
        {
            text: "Hainaut",
            value: "WHT"
        },
        {
            text: "Liege",
            value: "WLG"
        },
        {
            text: "Limburg",
            value: "VLI"
        },
        {
            text: "Luxembourg",
            value: "WLX"
        },
        {
            text: "Namur",
            value: "WNA"
        },
        {
            text: "Oost-Vlaanderen",
            value: "VOV"
        },
        {
            text: "Vlaams-Brabant",
            value: "VBR"
        },
        {
            text: "West-Vlaanderen",
            value: "VWV"
        }
    ],
    BZ: [
        {
            text: "Belize",
            value: "BZ"
        },
        {
            text: "Cayo",
            value: "CY"
        },
        {
            text: "Corozal",
            value: "CZL"
        },
        {
            text: "Orange Walk",
            value: "OW"
        },
        {
            text: "Stann Creek",
            value: "SC"
        },
        {
            text: "Toledo",
            value: "TOL"
        }
    ],
    BJ: [
        {
            text: "Alibori",
            value: "AL"
        },
        {
            text: "Atacora",
            value: "AK"
        },
        {
            text: "Atlantique",
            value: "AQ"
        },
        {
            text: "Borgou",
            value: "BO"
        },
        {
            text: "Donga",
            value: "DO"
        },
        {
            text: "Littoral",
            value: "LI"
        },
        {
            text: "Mono",
            value: "MO"
        },
        {
            text: "Oueme",
            value: "OU"
        },
        {
            text: "Plateau",
            value: "PL"
        },
        {
            text: "Zou",
            value: "ZO"
        }
    ],
    BM: [
        {
            text: "Hamilton",
            value: "01"
        },
        {
            text: "Saint George",
            value: "02"
        }
    ],
    BT: [
        {
            text: "Bumthang",
            value: "33"
        },
        {
            text: "Chhukha",
            value: "12"
        },
        {
            text: "Gasa",
            value: "GA"
        },
        {
            text: "Haa",
            value: "13"
        },
        {
            text: "Lhuentse",
            value: "44"
        },
        {
            text: "Monggar",
            value: "42"
        },
        {
            text: "Paro",
            value: "11"
        },
        {
            text: "Pemagatshel",
            value: "43"
        },
        {
            text: "Punakha",
            value: "23"
        },
        {
            text: "Samdrup Jongkhar",
            value: "45"
        },
        {
            text: "Samtse",
            value: "14"
        },
        {
            text: "Thimphu",
            value: "15"
        },
        {
            text: "Trashigang",
            value: "41"
        },
        {
            text: "Trongsa",
            value: "32"
        },
        {
            text: "Tsirang",
            value: "21"
        },
        {
            text: "Wangdue Phodrang",
            value: "24"
        }
    ],
    BO: [
        {
            text: "Chuquisaca",
            value: "H"
        },
        {
            text: "Cochabamba",
            value: "C"
        },
        {
            text: "El Beni",
            value: "B"
        },
        {
            text: "La Paz",
            value: "L"
        },
        {
            text: "Oruro",
            value: "O"
        },
        {
            text: "Pando",
            value: "N"
        },
        {
            text: "Potosi",
            value: "P"
        },
        {
            text: "Santa Cruz",
            value: "S"
        },
        {
            text: "Tarija",
            value: "T"
        }
    ],
    BA: [
        {
            text: "Brcko distrikt",
            value: "BRC"
        },
        {
            text: "Federacija Bosne i Hercegovine",
            value: "BIH"
        },
        {
            text: "Republika Srpska",
            value: "SRP"
        }
    ],
    BW: [
        {
            text: "Central",
            value: "CE"
        },
        {
            text: "Kgatleng",
            value: "KL"
        },
        {
            text: "Kweneng",
            value: "KW"
        },
        {
            text: "North East",
            value: "NE"
        },
        {
            text: "North West",
            value: "NW"
        },
        {
            text: "South East",
            value: "SE"
        },
        {
            text: "Southern",
            value: "SO"
        }
    ],
    BV: [
        {
            text: "-",
            value: "01"
        }
    ],
    BR: [
        {
            text: "Acre",
            value: "AC"
        },
        {
            text: "Alagoas",
            value: "AL"
        },
        {
            text: "Amapa",
            value: "AP"
        },
        {
            text: "Amazonas",
            value: "AM"
        },
        {
            text: "Bahia",
            value: "BA"
        },
        {
            text: "Ceara",
            value: "CE"
        },
        {
            text: "Distrito Federal",
            value: "DF"
        },
        {
            text: "Espirito Santo",
            value: "ES"
        },
        {
            text: "Goias",
            value: "GO"
        },
        {
            text: "Maranhao",
            value: "MA"
        },
        {
            text: "Mato Grosso",
            value: "MT"
        },
        {
            text: "Mato Grosso do Sul",
            value: "MS"
        },
        {
            text: "Minas Gerais",
            value: "MG"
        },
        {
            text: "Para",
            value: "PA"
        },
        {
            text: "Paraiba",
            value: "PB"
        },
        {
            text: "Parana",
            value: "PR"
        },
        {
            text: "Pernambuco",
            value: "PE"
        },
        {
            text: "Piaui",
            value: "PI"
        },
        {
            text: "Rio Grande do Norte",
            value: "RN"
        },
        {
            text: "Rio Grande do Sul",
            value: "RS"
        },
        {
            text: "Rio de Janeiro",
            value: "RJ"
        },
        {
            text: "Rondonia",
            value: "RO"
        },
        {
            text: "Roraima",
            value: "RR"
        },
        {
            text: "Santa Catarina",
            value: "SC"
        },
        {
            text: "Sao Paulo",
            value: "SP"
        },
        {
            text: "Sergipe",
            value: "SE"
        },
        {
            text: "Tocantins",
            value: "TO"
        }
    ],
    VG: [
        {
            text: "Virgin Islands, British",
            value: "01"
        }
    ],
    IO: [
        {
            text: "British Indian Ocean Territory",
            value: "01"
        }
    ],
    BN: [
        {
            text: "Belait",
            value: "BE"
        },
        {
            text: "Brunei-Muara",
            value: "BM"
        },
        {
            text: "Temburong",
            value: "TE"
        },
        {
            text: "Tutong",
            value: "TU"
        }
    ],
    BG: [
        {
            text: "Blagoevgrad",
            value: "01"
        },
        {
            text: "Burgas",
            value: "02"
        },
        {
            text: "Dobrich",
            value: "08"
        },
        {
            text: "Gabrovo",
            value: "07"
        },
        {
            text: "Haskovo",
            value: "26"
        },
        {
            text: "Kardzhali",
            value: "09"
        },
        {
            text: "Kyustendil",
            value: "10"
        },
        {
            text: "Lovech",
            value: "11"
        },
        {
            text: "Montana",
            value: "12"
        },
        {
            text: "Pazardzhik",
            value: "13"
        },
        {
            text: "Pernik",
            value: "14"
        },
        {
            text: "Pleven",
            value: "15"
        },
        {
            text: "Plovdiv",
            value: "16"
        },
        {
            text: "Razgrad",
            value: "17"
        },
        {
            text: "Ruse",
            value: "18"
        },
        {
            text: "Shumen",
            value: "27"
        },
        {
            text: "Silistra",
            value: "19"
        },
        {
            text: "Sliven",
            value: "20"
        },
        {
            text: "Smolyan",
            value: "21"
        },
        {
            text: "Sofia",
            value: "23"
        },
        {
            text: "Sofia (stolitsa)",
            value: "22"
        },
        {
            text: "Stara Zagora",
            value: "24"
        },
        {
            text: "Targovishte",
            value: "25"
        },
        {
            text: "Varna",
            value: "03"
        },
        {
            text: "Veliko Tarnovo",
            value: "04"
        },
        {
            text: "Vidin",
            value: "05"
        },
        {
            text: "Vratsa",
            value: "06"
        },
        {
            text: "Yambol",
            value: "28"
        }
    ],
    BF: [
        {
            text: "Bale",
            value: "BAL"
        },
        {
            text: "Boulgou",
            value: "BLG"
        },
        {
            text: "Boulkiemde",
            value: "BLK"
        },
        {
            text: "Comoe",
            value: "COM"
        },
        {
            text: "Gnagna",
            value: "GNA"
        },
        {
            text: "Houet",
            value: "HOU"
        },
        {
            text: "Kadiogo",
            value: "KAD"
        },
        {
            text: "Kourweogo",
            value: "KOW"
        },
        {
            text: "Leraba",
            value: "LER"
        },
        {
            text: "Mouhoun",
            value: "MOU"
        },
        {
            text: "Oubritenga",
            value: "OUB"
        },
        {
            text: "Poni",
            value: "PON"
        },
        {
            text: "Sanmatenga",
            value: "SMT"
        },
        {
            text: "Tapoa",
            value: "TAP"
        },
        {
            text: "Tuy",
            value: "TUI"
        },
        {
            text: "Yatenga",
            value: "YAT"
        },
        {
            text: "Zoundweogo",
            value: "ZOU"
        }
    ],
    BI: [
        {
            text: "Bubanza",
            value: "BB"
        },
        {
            text: "Bujumbura Mairie",
            value: "BM"
        },
        {
            text: "Bururi",
            value: "BR"
        },
        {
            text: "Cibitoke",
            value: "CI"
        },
        {
            text: "Gitega",
            value: "GI"
        },
        {
            text: "Kirundo",
            value: "KI"
        },
        {
            text: "Muyinga",
            value: "MY"
        },
        {
            text: "Mwaro",
            value: "MW"
        },
        {
            text: "Ngozi",
            value: "NG"
        },
        {
            text: "Rutana",
            value: "RT"
        },
        {
            text: "Ruyigi",
            value: "RY"
        }
    ],
    KH: [
        {
            text: "Baat Dambang",
            value: "2"
        },
        {
            text: "Banteay Mean Chey",
            value: "1"
        },
        {
            text: "Kampong Chaam",
            value: "3"
        },
        {
            text: "Kampong Chhnang",
            value: "4"
        },
        {
            text: "Kampong Spueu",
            value: "5"
        },
        {
            text: "Kampong Thum",
            value: "6"
        },
        {
            text: "Kampot",
            value: "7"
        },
        {
            text: "Kandaal",
            value: "8"
        },
        {
            text: "Kaoh Kong",
            value: "9"
        },
        {
            text: "Kracheh",
            value: "10"
        },
        {
            text: "Krong Kaeb",
            value: "23"
        },
        {
            text: "Krong Pailin",
            value: "24"
        },
        {
            text: "Krong Preah Sihanouk",
            value: "18"
        },
        {
            text: "Mondol Kiri",
            value: "11"
        },
        {
            text: "Phnom Penh",
            value: "12"
        },
        {
            text: "Prey Veaeng",
            value: "14"
        },
        {
            text: "Rotanak Kiri",
            value: "16"
        },
        {
            text: "Siem Reab",
            value: "17"
        },
        {
            text: "Svaay Rieng",
            value: "20"
        },
        {
            text: "Taakaev",
            value: "21"
        }
    ],
    CM: [
        {
            text: "Adamaoua",
            value: "AD"
        },
        {
            text: "Centre",
            value: "CE"
        },
        {
            text: "Est",
            value: "ES"
        },
        {
            text: "Extreme-Nord",
            value: "EN"
        },
        {
            text: "Littoral",
            value: "LT"
        },
        {
            text: "Nord",
            value: "NO"
        },
        {
            text: "Nord-Ouest",
            value: "NW"
        },
        {
            text: "Ouest",
            value: "OU"
        },
        {
            text: "Sud",
            value: "SU"
        },
        {
            text: "Sud-Ouest",
            value: "SW"
        }
    ],
    CA: [
        {
            text: "Alberta",
            value: "AB"
        },
        {
            text: "British Columbia",
            value: "BC"
        },
        {
            text: "Manitoba",
            value: "MB"
        },
        {
            text: "New Brunswick",
            value: "NB"
        },
        {
            text: "Newfoundland and Labrador",
            value: "NL"
        },
        {
            text: "Northwest Territories",
            value: "NT"
        },
        {
            text: "Nova Scotia",
            value: "NS"
        },
        {
            text: "Nunavut",
            value: "NU"
        },
        {
            text: "Ontario",
            value: "ON"
        },
        {
            text: "Prince Edward Island",
            value: "PE"
        },
        {
            text: "Quebec",
            value: "QC"
        },
        {
            text: "Saskatchewan",
            value: "SK"
        },
        {
            text: "Yukon",
            value: "YT"
        }
    ],
    CV: [
        {
            text: "Boa Vista",
            value: "BV"
        },
        {
            text: "Paul",
            value: "PA"
        },
        {
            text: "Porto Novo",
            value: "PN"
        },
        {
            text: "Praia",
            value: "PR"
        },
        {
            text: "Ribeira Grande",
            value: "RG"
        },
        {
            text: "Sal",
            value: "SL"
        },
        {
            text: "Sao Vicente",
            value: "SV"
        },
        {
            text: "Tarrafal",
            value: "TA"
        }
    ],
    KY: [
        {
            text: "Cayman Islands",
            value: "01"
        }
    ],
    CF: [
        {
            text: "Bangui",
            value: "BGF"
        },
        {
            text: "Haute-Kotto",
            value: "HK"
        },
        {
            text: "Nana-Mambere",
            value: "NM"
        },
        {
            text: "Ouham",
            value: "AC"
        }
    ],
    TD: [
        {
            text: "Guera",
            value: "GR"
        },
        {
            text: "Hadjer Lamis",
            value: "HL"
        },
        {
            text: "Logone-Occidental",
            value: "LO"
        },
        {
            text: "Mayo-Kebbi-Est",
            value: "ME"
        },
        {
            text: "Ouaddai",
            value: "OD"
        },
        {
            text: "Tibesti",
            value: "TI"
        },
        {
            text: "Ville de Ndjamena",
            value: "ND"
        }
    ],
    CL: [
        {
            text: "Aisen del General Carlos Ibanez del Campo",
            value: "AI"
        },
        {
            text: "Antofagasta",
            value: "AN"
        },
        {
            text: "Arica y Parinacota",
            value: "AP"
        },
        {
            text: "Atacama",
            value: "AT"
        },
        {
            text: "Biobio",
            value: "BI"
        },
        {
            text: "Coquimbo",
            value: "CO"
        },
        {
            text: "La Araucania",
            value: "AR"
        },
        {
            text: "Libertador General Bernardo O'Higgins",
            value: "LI"
        },
        {
            text: "Los Lagos",
            value: "LL"
        },
        {
            text: "Los Rios",
            value: "LR"
        },
        {
            text: "Magallanes",
            value: "MA"
        },
        {
            text: "Maule",
            value: "ML"
        },
        {
            text: "Region Metropolitana de Santiago",
            value: "RM"
        },
        {
            text: "Tarapaca",
            value: "TA"
        },
        {
            text: "Valparaiso",
            value: "VS"
        }
    ],
    CN: [
        {
            text: "Anhui",
            value: "AH"
        },
        {
            text: "Beijing",
            value: "BJ"
        },
        {
            text: "Chongqing",
            value: "CQ"
        },
        {
            text: "Fujian",
            value: "FJ"
        },
        {
            text: "Gansu",
            value: "GS"
        },
        {
            text: "Guangdong",
            value: "GD"
        },
        {
            text: "Guangxi",
            value: "GX"
        },
        {
            text: "Guizhou",
            value: "GZ"
        },
        {
            text: "Hainan",
            value: "HI"
        },
        {
            text: "Hebei",
            value: "HE"
        },
        {
            text: "Heilongjiang",
            value: "HL"
        },
        {
            text: "Henan",
            value: "HA"
        },
        {
            text: "Hubei",
            value: "HB"
        },
        {
            text: "Hunan",
            value: "HN"
        },
        {
            text: "Jiangsu",
            value: "JS"
        },
        {
            text: "Jiangxi",
            value: "JX"
        },
        {
            text: "Jilin",
            value: "JL"
        },
        {
            text: "Liaoning",
            value: "LN"
        },
        {
            text: "Nei Mongol",
            value: "NM"
        },
        {
            text: "Ningxia",
            value: "NX"
        },
        {
            text: "Qinghai",
            value: "QH"
        },
        {
            text: "Shaanxi",
            value: "SN"
        },
        {
            text: "Shandong",
            value: "SD"
        },
        {
            text: "Shanghai",
            value: "SH"
        },
        {
            text: "Shanxi",
            value: "SX"
        },
        {
            text: "Sichuan",
            value: "SC"
        },
        {
            text: "Tianjin",
            value: "TJ"
        },
        {
            text: "Xinjiang",
            value: "XJ"
        },
        {
            text: "Xizang",
            value: "XZ"
        },
        {
            text: "Yunnan",
            value: "YN"
        },
        {
            text: "Zhejiang",
            value: "ZJ"
        }
    ],
    HK: [
        {
            text: "Hong Kong",
            value: "01"
        }
    ],
    MO: [
        {
            text: "Macao",
            value: "01"
        }
    ],
    CX: [
        {
            text: "-",
            value: "01"
        }
    ],
    CC: [
        {
            text: "-",
            value: "01"
        }
    ],
    CO: [
        {
            text: "Amazonas",
            value: "AMA"
        },
        {
            text: "Antioquia",
            value: "ANT"
        },
        {
            text: "Arauca",
            value: "ARA"
        },
        {
            text: "Atlantico",
            value: "ATL"
        },
        {
            text: "Bolivar",
            value: "BOL"
        },
        {
            text: "Boyaca",
            value: "BOY"
        },
        {
            text: "Caldas",
            value: "CAL"
        },
        {
            text: "Caqueta",
            value: "CAQ"
        },
        {
            text: "Casanare",
            value: "CAS"
        },
        {
            text: "Cauca",
            value: "CAU"
        },
        {
            text: "Cesar",
            value: "CES"
        },
        {
            text: "Choco",
            value: "CHO"
        },
        {
            text: "Cordoba",
            value: "COR"
        },
        {
            text: "Cundinamarca",
            value: "CUN"
        },
        {
            text: "Distrito Capital de Bogota",
            value: "DC"
        },
        {
            text: "Guainia",
            value: "GUA"
        },
        {
            text: "Guaviare",
            value: "GUV"
        },
        {
            text: "Huila",
            value: "HUI"
        },
        {
            text: "La Guajira",
            value: "LAG"
        },
        {
            text: "Magdalena",
            value: "MAG"
        },
        {
            text: "Meta",
            value: "MET"
        },
        {
            text: "Narino",
            value: "NAR"
        },
        {
            text: "Norte de Santander",
            value: "NSA"
        },
        {
            text: "Putumayo",
            value: "PUT"
        },
        {
            text: "Quindio",
            value: "QUI"
        },
        {
            text: "Risaralda",
            value: "RIS"
        },
        {
            text: "San Andres, Providencia y Santa Catalina",
            value: "SAP"
        },
        {
            text: "Santander",
            value: "SAN"
        },
        {
            text: "Sucre",
            value: "SUC"
        },
        {
            text: "Tolima",
            value: "TOL"
        },
        {
            text: "Valle del Cauca",
            value: "VAC"
        },
        {
            text: "Vichada",
            value: "VID"
        }
    ],
    KM: [
        {
            text: "Grande Comore",
            value: "G"
        }
    ],
    CG: [
        {
            text: "Brazzaville",
            value: "BZV"
        },
        {
            text: "Cuvette",
            value: "8"
        },
        {
            text: "Cuvette-Ouest",
            value: "15"
        },
        {
            text: "Pointe-Noire",
            value: "16"
        },
        {
            text: "Sangha",
            value: "13"
        }
    ],
    CD: [
        {
            text: "Equateur",
            value: "EQ"
        },
        {
            text: "Haut-Katanga",
            value: "HK"
        },
        {
            text: "Ituri",
            value: "IT"
        },
        {
            text: "Kasai Central",
            value: "KC"
        },
        {
            text: "Kasai Oriental",
            value: "KE"
        },
        {
            text: "Kinshasa",
            value: "KN"
        },
        {
            text: "Kongo Central",
            value: "BC"
        },
        {
            text: "Kwilu",
            value: "KL"
        },
        {
            text: "Lualaba",
            value: "LU"
        },
        {
            text: "Maniema",
            value: "MA"
        },
        {
            text: "Nord-Kivu",
            value: "NK"
        },
        {
            text: "Nord-Ubangi",
            value: "NU"
        },
        {
            text: "Sankuru",
            value: "SA"
        },
        {
            text: "Sud-Kivu",
            value: "SK"
        },
        {
            text: "Sud-Ubangi",
            value: "SU"
        },
        {
            text: "Tanganyika",
            value: "TA"
        },
        {
            text: "Tshopo",
            value: "TO"
        },
        {
            text: "Tshuapa",
            value: "TU"
        }
    ],
    CK: [
        {
            text: "Cook Islands",
            value: "01"
        }
    ],
    CR: [
        {
            text: "Alajuela",
            value: "A"
        },
        {
            text: "Cartago",
            value: "C"
        },
        {
            text: "Guanacaste",
            value: "G"
        },
        {
            text: "Heredia",
            value: "H"
        },
        {
            text: "Limon",
            value: "L"
        },
        {
            text: "Puntarenas",
            value: "P"
        },
        {
            text: "San Jose",
            value: "SJ"
        }
    ],
    CI: [
        {
            text: "Abidjan",
            value: "AB"
        },
        {
            text: "Bas-Sassandra",
            value: "BS"
        },
        {
            text: "Comoe",
            value: "CM"
        },
        {
            text: "Denguele",
            value: "DN"
        },
        {
            text: "Goh-Djiboua",
            value: "GD"
        },
        {
            text: "Lacs",
            value: "LC"
        },
        {
            text: "Lagunes",
            value: "LG"
        },
        {
            text: "Montagnes",
            value: "MG"
        },
        {
            text: "Sassandra-Marahoue",
            value: "SM"
        },
        {
            text: "Savanes",
            value: "SV"
        },
        {
            text: "Vallee du Bandama",
            value: "VB"
        },
        {
            text: "Woroba",
            value: "WR"
        },
        {
            text: "Yamoussoukro",
            value: "YM"
        },
        {
            text: "Zanzan",
            value: "ZZ"
        }
    ],
    HR: [
        {
            text: "Bjelovarsko-bilogorska zupanija",
            value: "07"
        },
        {
            text: "Brodsko-posavska zupanija",
            value: "12"
        },
        {
            text: "Dubrovacko-neretvanska zupanija",
            value: "19"
        },
        {
            text: "Grad Zagreb",
            value: "21"
        },
        {
            text: "Istarska zupanija",
            value: "18"
        },
        {
            text: "Karlovacka zupanija",
            value: "04"
        },
        {
            text: "Koprivnicko-krizevacka zupanija",
            value: "06"
        },
        {
            text: "Krapinsko-zagorska zupanija",
            value: "02"
        },
        {
            text: "Licko-senjska zupanija",
            value: "09"
        },
        {
            text: "Medimurska zupanija",
            value: "20"
        },
        {
            text: "Osjecko-baranjska zupanija",
            value: "14"
        },
        {
            text: "Pozesko-slavonska zupanija",
            value: "11"
        },
        {
            text: "Primorsko-goranska zupanija",
            value: "08"
        },
        {
            text: "Sibensko-kninska zupanija",
            value: "15"
        },
        {
            text: "Sisacko-moslavacka zupanija",
            value: "03"
        },
        {
            text: "Splitsko-dalmatinska zupanija",
            value: "17"
        },
        {
            text: "Varazdinska zupanija",
            value: "05"
        },
        {
            text: "Viroviticko-podravska zupanija",
            value: "10"
        },
        {
            text: "Vukovarsko-srijemska zupanija",
            value: "16"
        },
        {
            text: "Zadarska zupanija",
            value: "13"
        },
        {
            text: "Zagrebacka zupanija",
            value: "01"
        }
    ],
    CU: [
        {
            text: "Artemisa",
            value: "15"
        },
        {
            text: "Camaguey",
            value: "09"
        },
        {
            text: "Ciego de Avila",
            value: "08"
        },
        {
            text: "Cienfuegos",
            value: "06"
        },
        {
            text: "Granma",
            value: "12"
        },
        {
            text: "Guantanamo",
            value: "14"
        },
        {
            text: "Holguin",
            value: "11"
        },
        {
            text: "La Habana",
            value: "03"
        },
        {
            text: "Las Tunas",
            value: "10"
        },
        {
            text: "Matanzas",
            value: "04"
        },
        {
            text: "Mayabeque",
            value: "16"
        },
        {
            text: "Pinar del Rio",
            value: "01"
        },
        {
            text: "Sancti Spiritus",
            value: "07"
        },
        {
            text: "Santiago de Cuba",
            value: "13"
        },
        {
            text: "Villa Clara",
            value: "05"
        }
    ],
    CY: [
        {
            text: "Ammochostos",
            value: "04"
        },
        {
            text: "Keryneia",
            value: "06"
        },
        {
            text: "Larnaka",
            value: "03"
        },
        {
            text: "Lefkosia",
            value: "01"
        },
        {
            text: "Lemesos",
            value: "02"
        },
        {
            text: "Pafos",
            value: "05"
        }
    ],
    CZ: [
        {
            text: "Jihocesky kraj",
            value: "31"
        },
        {
            text: "Jihomoravsky kraj",
            value: "64"
        },
        {
            text: "Karlovarsky kraj",
            value: "41"
        },
        {
            text: "Kraj Vysocina",
            value: "63"
        },
        {
            text: "Kralovehradecky kraj",
            value: "52"
        },
        {
            text: "Liberecky kraj",
            value: "51"
        },
        {
            text: "Moravskoslezsky kraj",
            value: "80"
        },
        {
            text: "Olomoucky kraj",
            value: "71"
        },
        {
            text: "Pardubicky kraj",
            value: "53"
        },
        {
            text: "Plzensky kraj",
            value: "32"
        },
        {
            text: "Praha, Hlavni mesto",
            value: "10"
        },
        {
            text: "Stredocesky kraj",
            value: "20"
        },
        {
            text: "Ustecky kraj",
            value: "42"
        },
        {
            text: "Zlinsky kraj",
            value: "72"
        }
    ],
    DK: [
        {
            text: "Hovedstaden",
            value: "84"
        },
        {
            text: "Midtjylland",
            value: "82"
        },
        {
            text: "Nordjylland",
            value: "81"
        },
        {
            text: "Sjaelland",
            value: "85"
        },
        {
            text: "Syddanmark",
            value: "83"
        }
    ],
    DJ: [
        {
            text: "Djibouti",
            value: "DJ"
        }
    ],
    DM: [
        {
            text: "Saint Andrew",
            value: "02"
        },
        {
            text: "Saint George",
            value: "04"
        },
        {
            text: "Saint John",
            value: "05"
        },
        {
            text: "Saint Mark",
            value: "08"
        },
        {
            text: "Saint Paul",
            value: "10"
        }
    ],
    DO: [
        {
            text: "Azua",
            value: "02"
        },
        {
            text: "Baoruco",
            value: "03"
        },
        {
            text: "Barahona",
            value: "04"
        },
        {
            text: "Dajabon",
            value: "05"
        },
        {
            text: "Distrito Nacional (Santo Domingo)",
            value: "01"
        },
        {
            text: "Duarte",
            value: "06"
        },
        {
            text: "El Seibo",
            value: "08"
        },
        {
            text: "Espaillat",
            value: "09"
        },
        {
            text: "Hato Mayor",
            value: "30"
        },
        {
            text: "Hermanas Mirabal",
            value: "19"
        },
        {
            text: "Independencia",
            value: "10"
        },
        {
            text: "La Altagracia",
            value: "11"
        },
        {
            text: "La Romana",
            value: "12"
        },
        {
            text: "La Vega",
            value: "13"
        },
        {
            text: "Maria Trinidad Sanchez",
            value: "14"
        },
        {
            text: "Monsenor Nouel",
            value: "28"
        },
        {
            text: "Monte Cristi",
            value: "15"
        },
        {
            text: "Monte Plata",
            value: "29"
        },
        {
            text: "Peravia",
            value: "17"
        },
        {
            text: "Puerto Plata",
            value: "18"
        },
        {
            text: "Samana",
            value: "20"
        },
        {
            text: "San Cristobal",
            value: "21"
        },
        {
            text: "San Jose de Ocoa",
            value: "31"
        },
        {
            text: "San Juan",
            value: "22"
        },
        {
            text: "San Pedro de Macoris",
            value: "23"
        },
        {
            text: "Sanchez Ramirez",
            value: "24"
        },
        {
            text: "Santiago",
            value: "25"
        },
        {
            text: "Santiago Rodriguez",
            value: "26"
        },
        {
            text: "Valverde",
            value: "27"
        }
    ],
    EC: [
        {
            text: "Azuay",
            value: "A"
        },
        {
            text: "Bolivar",
            value: "B"
        },
        {
            text: "Canar",
            value: "F"
        },
        {
            text: "Carchi",
            value: "C"
        },
        {
            text: "Chimborazo",
            value: "H"
        },
        {
            text: "Cotopaxi",
            value: "X"
        },
        {
            text: "El Oro",
            value: "O"
        },
        {
            text: "Esmeraldas",
            value: "E"
        },
        {
            text: "Galapagos",
            value: "W"
        },
        {
            text: "Guayas",
            value: "G"
        },
        {
            text: "Imbabura",
            value: "I"
        },
        {
            text: "Loja",
            value: "L"
        },
        {
            text: "Los Rios",
            value: "R"
        },
        {
            text: "Manabi",
            value: "M"
        },
        {
            text: "Morona Santiago",
            value: "S"
        },
        {
            text: "Napo",
            value: "N"
        },
        {
            text: "Orellana",
            value: "D"
        },
        {
            text: "Pastaza",
            value: "Y"
        },
        {
            text: "Pichincha",
            value: "P"
        },
        {
            text: "Santa Elena",
            value: "SE"
        },
        {
            text: "Santo Domingo de los Tsachilas",
            value: "SD"
        },
        {
            text: "Sucumbios",
            value: "U"
        },
        {
            text: "Tungurahua",
            value: "T"
        },
        {
            text: "Zamora Chinchipe",
            value: "Z"
        }
    ],
    EG: [
        {
            text: "Ad Daqahliyah",
            value: "DK"
        },
        {
            text: "Al Bahr al Ahmar",
            value: "BA"
        },
        {
            text: "Al Buhayrah",
            value: "BH"
        },
        {
            text: "Al Fayyum",
            value: "FYM"
        },
        {
            text: "Al Gharbiyah",
            value: "GH"
        },
        {
            text: "Al Iskandariyah",
            value: "ALX"
        },
        {
            text: "Al Isma'iliyah",
            value: "IS"
        },
        {
            text: "Al Jizah",
            value: "GZ"
        },
        {
            text: "Al Minufiyah",
            value: "MNF"
        },
        {
            text: "Al Minya",
            value: "MN"
        },
        {
            text: "Al Qahirah",
            value: "C"
        },
        {
            text: "Al Qalyubiyah",
            value: "KB"
        },
        {
            text: "Al Uqsur",
            value: "LX"
        },
        {
            text: "Al Wadi al Jadid",
            value: "WAD"
        },
        {
            text: "As Suways",
            value: "SUZ"
        },
        {
            text: "Ash Sharqiyah",
            value: "SHR"
        },
        {
            text: "Aswan",
            value: "ASN"
        },
        {
            text: "Asyut",
            value: "AST"
        },
        {
            text: "Bani Suwayf",
            value: "BNS"
        },
        {
            text: "Bur Sa'id",
            value: "PTS"
        },
        {
            text: "Dumyat",
            value: "DT"
        },
        {
            text: "Janub Sina'",
            value: "JS"
        },
        {
            text: "Kafr ash Shaykh",
            value: "KFS"
        },
        {
            text: "Matruh",
            value: "MT"
        },
        {
            text: "Qina",
            value: "KN"
        },
        {
            text: "Shamal Sina'",
            value: "SIN"
        },
        {
            text: "Suhaj",
            value: "SHG"
        }
    ],
    SV: [
        {
            text: "Ahuachapan",
            value: "AH"
        },
        {
            text: "Cabanas",
            value: "CA"
        },
        {
            text: "Chalatenango",
            value: "CH"
        },
        {
            text: "Cuscatlan",
            value: "CU"
        },
        {
            text: "La Libertad",
            value: "LI"
        },
        {
            text: "La Paz",
            value: "PA"
        },
        {
            text: "La Union",
            value: "UN"
        },
        {
            text: "Morazan",
            value: "MO"
        },
        {
            text: "San Miguel",
            value: "SM"
        },
        {
            text: "San Salvador",
            value: "SS"
        },
        {
            text: "San Vicente",
            value: "SV"
        },
        {
            text: "Santa Ana",
            value: "SA"
        },
        {
            text: "Sonsonate",
            value: "SO"
        },
        {
            text: "Usulutan",
            value: "US"
        }
    ],
    GQ: [
        {
            text: "Bioko Norte",
            value: "BN"
        },
        {
            text: "Bioko Sur",
            value: "BS"
        },
        {
            text: "Litoral",
            value: "LI"
        },
        {
            text: "Wele-Nzas",
            value: "WN"
        }
    ],
    ER: [
        {
            text: "Al Awsat",
            value: "MA"
        }
    ],
    EE: [
        {
            text: "Harjumaa",
            value: "37"
        },
        {
            text: "Hiiumaa",
            value: "39"
        },
        {
            text: "Ida-Virumaa",
            value: "44"
        },
        {
            text: "Jarvamaa",
            value: "51"
        },
        {
            text: "Jogevamaa",
            value: "49"
        },
        {
            text: "Laane-Virumaa",
            value: "59"
        },
        {
            text: "Laanemaa",
            value: "57"
        },
        {
            text: "Parnumaa",
            value: "67"
        },
        {
            text: "Polvamaa",
            value: "65"
        },
        {
            text: "Raplamaa",
            value: "70"
        },
        {
            text: "Saaremaa",
            value: "74"
        },
        {
            text: "Tartumaa",
            value: "78"
        },
        {
            text: "Valgamaa",
            value: "82"
        },
        {
            text: "Viljandimaa",
            value: "84"
        },
        {
            text: "Vorumaa",
            value: "86"
        }
    ],
    ET: [
        {
            text: "Adis Abeba",
            value: "AA"
        },
        {
            text: "Afar",
            value: "AF"
        },
        {
            text: "Amara",
            value: "AM"
        },
        {
            text: "Binshangul Gumuz",
            value: "BE"
        },
        {
            text: "Hareri Hizb",
            value: "HA"
        },
        {
            text: "Oromiya",
            value: "OR"
        },
        {
            text: "Sumale",
            value: "SO"
        },
        {
            text: "Tigray",
            value: "TI"
        },
        {
            text: "YeDebub Biheroch Bihereseboch na Hizboch",
            value: "SN"
        }
    ],
    FK: [
        {
            text: "Falkland Islands (Malvinas)",
            value: "01"
        }
    ],
    FO: [
        {
            text: "Eysturoy",
            value: "01"
        },
        {
            text: "Nordoyar",
            value: "02"
        },
        {
            text: "Streymoy",
            value: "03"
        },
        {
            text: "Suduroy",
            value: "04"
        },
        {
            text: "Vagar",
            value: "05"
        }
    ],
    FJ: [
        {
            text: "Central",
            value: "C"
        },
        {
            text: "Eastern",
            value: "E"
        },
        {
            text: "Rotuma",
            value: "R"
        },
        {
            text: "Western",
            value: "W"
        }
    ],
    FI: [
        {
            text: "Etela-Karjala",
            value: "02"
        },
        {
            text: "Etela-Pohjanmaa",
            value: "03"
        },
        {
            text: "Etela-Savo",
            value: "04"
        },
        {
            text: "Kainuu",
            value: "05"
        },
        {
            text: "Kanta-Hame",
            value: "06"
        },
        {
            text: "Keski-Pohjanmaa",
            value: "07"
        },
        {
            text: "Keski-Suomi",
            value: "08"
        },
        {
            text: "Kymenlaakso",
            value: "09"
        },
        {
            text: "Lappi",
            value: "10"
        },
        {
            text: "Paijat-Hame",
            value: "16"
        },
        {
            text: "Pirkanmaa",
            value: "11"
        },
        {
            text: "Pohjanmaa",
            value: "12"
        },
        {
            text: "Pohjois-Karjala",
            value: "13"
        },
        {
            text: "Pohjois-Pohjanmaa",
            value: "14"
        },
        {
            text: "Pohjois-Savo",
            value: "15"
        },
        {
            text: "Satakunta",
            value: "17"
        },
        {
            text: "Uusimaa",
            value: "18"
        },
        {
            text: "Varsinais-Suomi",
            value: "19"
        }
    ],
    FR: [
        {
            text: "Auvergne-Rhone-Alpes",
            value: "ARA"
        },
        {
            text: "Bourgogne-Franche-Comte",
            value: "BFC"
        },
        {
            text: "Bretagne",
            value: "BRE"
        },
        {
            text: "Centre-Val de Loire",
            value: "CVL"
        },
        {
            text: "Corse",
            value: "COR"
        },
        {
            text: "Grand-Est",
            value: "GES"
        },
        {
            text: "Hauts-de-France",
            value: "HDF"
        },
        {
            text: "Ile-de-France",
            value: "IDF"
        },
        {
            text: "Normandie",
            value: "NOR"
        },
        {
            text: "Nouvelle-Aquitaine",
            value: "NAQ"
        },
        {
            text: "Occitanie",
            value: "OCC"
        },
        {
            text: "Pays-de-la-Loire",
            value: "PDL"
        },
        {
            text: "Provence-Alpes-Cote-d'Azur",
            value: "PAC"
        }
    ],
    GF: [
        {
            text: "Guyane",
            value: "01"
        }
    ],
    PF: [
        {
            text: "Iles Marquises",
            value: "01"
        },
        {
            text: "Iles Sous-le-Vent",
            value: "02"
        },
        {
            text: "Iles Tuamotu-Gambier",
            value: "03"
        },
        {
            text: "Iles du Vent",
            value: "04"
        }
    ],
    TF: [
        {
            text: "-",
            value: "01"
        }
    ],
    GA: [
        {
            text: "Estuaire",
            value: "1"
        },
        {
            text: "Haut-Ogooue",
            value: "2"
        },
        {
            text: "Moyen-Ogooue",
            value: "3"
        },
        {
            text: "Ngounie",
            value: "4"
        },
        {
            text: "Ogooue-Ivindo",
            value: "6"
        },
        {
            text: "Ogooue-Maritime",
            value: "8"
        },
        {
            text: "Woleu-Ntem",
            value: "9"
        }
    ],
    GM: [
        {
            text: "Banjul",
            value: "B"
        },
        {
            text: "Central River",
            value: "M"
        },
        {
            text: "Lower River",
            value: "L"
        },
        {
            text: "North Bank",
            value: "N"
        },
        {
            text: "Upper River",
            value: "U"
        },
        {
            text: "Western",
            value: "W"
        }
    ],
    GE: [
        {
            text: "Abkhazia",
            value: "AB"
        },
        {
            text: "Ajaria",
            value: "AJ"
        },
        {
            text: "Guria",
            value: "GU"
        },
        {
            text: "Imereti",
            value: "IM"
        },
        {
            text: "K'akheti",
            value: "KA"
        },
        {
            text: "Kvemo Kartli",
            value: "KK"
        },
        {
            text: "Mtskheta-Mtianeti",
            value: "MM"
        },
        {
            text: "Rach'a-Lechkhumi-Kvemo Svaneti",
            value: "RL"
        },
        {
            text: "Samegrelo-Zemo Svaneti",
            value: "SZ"
        },
        {
            text: "Samtskhe-Javakheti",
            value: "SJ"
        },
        {
            text: "Shida Kartli",
            value: "SK"
        },
        {
            text: "Tbilisi",
            value: "TB"
        }
    ],
    DE: [
        {
            text: "Baden-Wurttemberg",
            value: "BW"
        },
        {
            text: "Bayern",
            value: "BY"
        },
        {
            text: "Berlin",
            value: "BE"
        },
        {
            text: "Brandenburg",
            value: "BB"
        },
        {
            text: "Bremen",
            value: "HB"
        },
        {
            text: "Hamburg",
            value: "HH"
        },
        {
            text: "Hessen",
            value: "HE"
        },
        {
            text: "Mecklenburg-Vorpommern",
            value: "MV"
        },
        {
            text: "Niedersachsen",
            value: "NI"
        },
        {
            text: "Nordrhein-Westfalen",
            value: "NW"
        },
        {
            text: "Rheinland-Pfalz",
            value: "RP"
        },
        {
            text: "Saarland",
            value: "SL"
        },
        {
            text: "Sachsen",
            value: "SN"
        },
        {
            text: "Sachsen-Anhalt",
            value: "ST"
        },
        {
            text: "Schleswig-Holstein",
            value: "SH"
        },
        {
            text: "Thuringen",
            value: "TH"
        }
    ],
    GH: [
        {
            text: "Ashanti",
            value: "AH"
        },
        {
            text: "Brong-Ahafo",
            value: "BA"
        },
        {
            text: "Central",
            value: "CP"
        },
        {
            text: "Eastern",
            value: "EP"
        },
        {
            text: "Greater Accra",
            value: "AA"
        },
        {
            text: "Northern",
            value: "NP"
        },
        {
            text: "Upper East",
            value: "UE"
        },
        {
            text: "Volta",
            value: "TV"
        },
        {
            text: "Western",
            value: "WP"
        }
    ],
    GI: [
        {
            text: "Gibraltar",
            value: "01"
        }
    ],
    GR: [
        {
            text: "Anatoliki Makedonia kai Thraki",
            value: "A"
        },
        {
            text: "Attiki",
            value: "I"
        },
        {
            text: "Dytiki Ellada",
            value: "G"
        },
        {
            text: "Dytiki Makedonia",
            value: "C"
        },
        {
            text: "Ionia Nisia",
            value: "F"
        },
        {
            text: "Ipeiros",
            value: "D"
        },
        {
            text: "Kentriki Makedonia",
            value: "B"
        },
        {
            text: "Kriti",
            value: "M"
        },
        {
            text: "Notio Aigaio",
            value: "L"
        },
        {
            text: "Peloponnisos",
            value: "J"
        },
        {
            text: "Sterea Ellada",
            value: "H"
        },
        {
            text: "Thessalia",
            value: "E"
        },
        {
            text: "Voreio Aigaio",
            value: "K"
        }
    ],
    GL: [
        {
            text: "Avannaata Kommunia",
            value: "AV"
        },
        {
            text: "Kommune Kujalleq",
            value: "KU"
        },
        {
            text: "Kommune Qeqertalik",
            value: "QT"
        },
        {
            text: "Kommuneqarfik Sermersooq",
            value: "SM"
        },
        {
            text: "Qeqqata Kommunia",
            value: "QE"
        }
    ],
    GD: [
        {
            text: "Saint Andrew",
            value: "01"
        },
        {
            text: "Saint David",
            value: "02"
        },
        {
            text: "Saint George",
            value: "03"
        },
        {
            text: "Saint John",
            value: "04"
        },
        {
            text: "Saint Mark",
            value: "05"
        },
        {
            text: "Saint Patrick",
            value: "06"
        },
        {
            text: "Southern Grenadine Islands",
            value: "10"
        }
    ],
    GP: [
        {
            text: "Guadeloupe",
            value: "01"
        }
    ],
    GU: [
        {
            text: "Agat",
            value: "01"
        },
        {
            text: "Barrigada",
            value: "02"
        },
        {
            text: "Chalan Pago-Ordot",
            value: "03"
        },
        {
            text: "Dededo",
            value: "04"
        },
        {
            text: "Hagatna",
            value: "05"
        },
        {
            text: "Mangilao",
            value: "06"
        },
        {
            text: "Mongmong-Toto-Maite",
            value: "07"
        },
        {
            text: "Piti",
            value: "08"
        },
        {
            text: "Santa Rita",
            value: "09"
        },
        {
            text: "Sinajana",
            value: "10"
        },
        {
            text: "Tamuning-Tumon-Harmon",
            value: "11"
        },
        {
            text: "Yigo",
            value: "12"
        },
        {
            text: "Yona",
            value: "13"
        }
    ],
    GT: [
        {
            text: "Alta Verapaz",
            value: "AV"
        },
        {
            text: "Baja Verapaz",
            value: "BV"
        },
        {
            text: "Chimaltenango",
            value: "CM"
        },
        {
            text: "Chiquimula",
            value: "CQ"
        },
        {
            text: "El Progreso",
            value: "PR"
        },
        {
            text: "Escuintla",
            value: "ES"
        },
        {
            text: "Guatemala",
            value: "GU"
        },
        {
            text: "Huehuetenango",
            value: "HU"
        },
        {
            text: "Izabal",
            value: "IZ"
        },
        {
            text: "Jalapa",
            value: "JA"
        },
        {
            text: "Jutiapa",
            value: "JU"
        },
        {
            text: "Peten",
            value: "PE"
        },
        {
            text: "Quetzaltenango",
            value: "QZ"
        },
        {
            text: "Quiche",
            value: "QC"
        },
        {
            text: "Retalhuleu",
            value: "RE"
        },
        {
            text: "Sacatepequez",
            value: "SA"
        },
        {
            text: "San Marcos",
            value: "SM"
        },
        {
            text: "Santa Rosa",
            value: "SR"
        },
        {
            text: "Solola",
            value: "SO"
        },
        {
            text: "Suchitepequez",
            value: "SU"
        },
        {
            text: "Totonicapan",
            value: "TO"
        },
        {
            text: "Zacapa",
            value: "ZA"
        }
    ],
    GG: [
        {
            text: "Guernsey",
            value: "01"
        }
    ],
    GN: [
        {
            text: "Boffa",
            value: "BF"
        },
        {
            text: "Boke",
            value: "B"
        },
        {
            text: "Conakry",
            value: "C"
        },
        {
            text: "Coyah",
            value: "CO"
        },
        {
            text: "Dabola",
            value: "DB"
        },
        {
            text: "Dalaba",
            value: "DL"
        },
        {
            text: "Dubreka",
            value: "DU"
        },
        {
            text: "Kankan",
            value: "K"
        },
        {
            text: "Kissidougou",
            value: "KS"
        },
        {
            text: "Kouroussa",
            value: "KO"
        },
        {
            text: "Labe",
            value: "L"
        },
        {
            text: "Macenta",
            value: "MC"
        },
        {
            text: "Nzerekore",
            value: "N"
        },
        {
            text: "Pita",
            value: "PI"
        },
        {
            text: "Siguiri",
            value: "SI"
        }
    ],
    GW: [
        {
            text: "Bissau",
            value: "BS"
        },
        {
            text: "Bolama",
            value: "BL"
        },
        {
            text: "Gabu",
            value: "GA"
        }
    ],
    GY: [
        {
            text: "Demerara-Mahaica",
            value: "DE"
        },
        {
            text: "East Berbice-Corentyne",
            value: "EB"
        },
        {
            text: "Essequibo Islands-West Demerara",
            value: "ES"
        },
        {
            text: "Upper Demerara-Berbice",
            value: "UD"
        }
    ],
    HT: [
        {
            text: "Artibonite",
            value: "AR"
        },
        {
            text: "Centre",
            value: "CE"
        },
        {
            text: "Grande'Anse",
            value: "GA"
        },
        {
            text: "Nord",
            value: "ND"
        },
        {
            text: "Nord-Est",
            value: "NE"
        },
        {
            text: "Nord-Ouest",
            value: "NO"
        },
        {
            text: "Ouest",
            value: "OU"
        },
        {
            text: "Sud",
            value: "SD"
        },
        {
            text: "Sud-Est",
            value: "SE"
        }
    ],
    HM: [
        {
            text: "-",
            value: "01"
        }
    ],
    VA: [
        {
            text: "Vatican City",
            value: "01"
        }
    ],
    HN: [
        {
            text: "Atlantida",
            value: "AT"
        },
        {
            text: "Choluteca",
            value: "CH"
        },
        {
            text: "Colon",
            value: "CL"
        },
        {
            text: "Comayagua",
            value: "CM"
        },
        {
            text: "Copan",
            value: "CP"
        },
        {
            text: "Cortes",
            value: "CR"
        },
        {
            text: "El Paraiso",
            value: "EP"
        },
        {
            text: "Francisco Morazan",
            value: "FM"
        },
        {
            text: "Intibuca",
            value: "IN"
        },
        {
            text: "Islas de la Bahia",
            value: "IB"
        },
        {
            text: "La Paz",
            value: "LP"
        },
        {
            text: "Lempira",
            value: "LE"
        },
        {
            text: "Ocotepeque",
            value: "OC"
        },
        {
            text: "Olancho",
            value: "OL"
        },
        {
            text: "Santa Barbara",
            value: "SB"
        },
        {
            text: "Valle",
            value: "VA"
        },
        {
            text: "Yoro",
            value: "YO"
        }
    ],
    HU: [
        {
            text: "Bacs-Kiskun",
            value: "BK"
        },
        {
            text: "Baranya",
            value: "BA"
        },
        {
            text: "Bekes",
            value: "BE"
        },
        {
            text: "Borsod-Abauj-Zemplen",
            value: "BZ"
        },
        {
            text: "Budapest",
            value: "BU"
        },
        {
            text: "Csongrad",
            value: "CS"
        },
        {
            text: "Fejer",
            value: "FE"
        },
        {
            text: "Gyor-Moson-Sopron",
            value: "GS"
        },
        {
            text: "Hajdu-Bihar",
            value: "HB"
        },
        {
            text: "Heves",
            value: "HE"
        },
        {
            text: "Jasz-Nagykun-Szolnok",
            value: "JN"
        },
        {
            text: "Komarom-Esztergom",
            value: "KE"
        },
        {
            text: "Nograd",
            value: "NO"
        },
        {
            text: "Pest",
            value: "PE"
        },
        {
            text: "Somogy",
            value: "SO"
        },
        {
            text: "Szabolcs-Szatmar-Bereg",
            value: "SZ"
        },
        {
            text: "Tolna",
            value: "TO"
        },
        {
            text: "Vas",
            value: "VA"
        },
        {
            text: "Veszprem",
            value: "VE"
        },
        {
            text: "Zala",
            value: "ZA"
        }
    ],
    IS: [
        {
            text: "Austurland",
            value: "7"
        },
        {
            text: "Hofudborgarsvaedi",
            value: "1"
        },
        {
            text: "Nordurland eystra",
            value: "6"
        },
        {
            text: "Nordurland vestra",
            value: "5"
        },
        {
            text: "Sudurland",
            value: "8"
        },
        {
            text: "Sudurnes",
            value: "2"
        },
        {
            text: "Vestfirdir",
            value: "4"
        },
        {
            text: "Vesturland",
            value: "3"
        }
    ],
    IN: [
        {
            text: "Andaman and Nicobar Islands",
            value: "AN"
        },
        {
            text: "Andhra Pradesh",
            value: "AP"
        },
        {
            text: "Arunachal Pradesh",
            value: "AR"
        },
        {
            text: "Assam",
            value: "AS"
        },
        {
            text: "Bihar",
            value: "BR"
        },
        {
            text: "Chandigarh",
            value: "CH"
        },
        {
            text: "Chhattisgarh",
            value: "CT"
        },
        {
            text: "Dadra and Nagar Haveli",
            value: "DN"
        },
        {
            text: "Daman and Diu",
            value: "DD"
        },
        {
            text: "Delhi",
            value: "DL"
        },
        {
            text: "Goa",
            value: "GA"
        },
        {
            text: "Gujarat",
            value: "GJ"
        },
        {
            text: "Haryana",
            value: "HR"
        },
        {
            text: "Himachal Pradesh",
            value: "HP"
        },
        {
            text: "Jammu and Kashmir",
            value: "JK"
        },
        {
            text: "Jharkhand",
            value: "JH"
        },
        {
            text: "Karnataka",
            value: "KA"
        },
        {
            text: "Kerala",
            value: "KL"
        },
        {
            text: "Madhya Pradesh",
            value: "MP"
        },
        {
            text: "Maharashtra",
            value: "MH"
        },
        {
            text: "Manipur",
            value: "MN"
        },
        {
            text: "Meghalaya",
            value: "ML"
        },
        {
            text: "Mizoram",
            value: "MZ"
        },
        {
            text: "Nagaland",
            value: "NL"
        },
        {
            text: "Odisha",
            value: "OR"
        },
        {
            text: "Puducherry",
            value: "PY"
        },
        {
            text: "Punjab",
            value: "PB"
        },
        {
            text: "Rajasthan",
            value: "RJ"
        },
        {
            text: "Sikkim",
            value: "SK"
        },
        {
            text: "Tamil Nadu",
            value: "TN"
        },
        {
            text: "Telangana",
            value: "TG"
        },
        {
            text: "Tripura",
            value: "TR"
        },
        {
            text: "Uttar Pradesh",
            value: "UP"
        },
        {
            text: "Uttarakhand",
            value: "UT"
        },
        {
            text: "West Bengal",
            value: "WB"
        }
    ],
    ID: [
        {
            text: "Aceh",
            value: "AC"
        },
        {
            text: "Bali",
            value: "BA"
        },
        {
            text: "Banten",
            value: "BT"
        },
        {
            text: "Bengkulu",
            value: "BE"
        },
        {
            text: "Gorontalo",
            value: "GO"
        },
        {
            text: "Jakarta Raya",
            value: "JK"
        },
        {
            text: "Jambi",
            value: "JA"
        },
        {
            text: "Jawa Barat",
            value: "JB"
        },
        {
            text: "Jawa Tengah",
            value: "JT"
        },
        {
            text: "Jawa Timur",
            value: "JI"
        },
        {
            text: "Kalimantan Barat",
            value: "KB"
        },
        {
            text: "Kalimantan Selatan",
            value: "KS"
        },
        {
            text: "Kalimantan Tengah",
            value: "KT"
        },
        {
            text: "Kalimantan Timur",
            value: "KI"
        },
        {
            text: "Kalimantan Utara",
            value: "KU"
        },
        {
            text: "Kepulauan Bangka Belitung",
            value: "BB"
        },
        {
            text: "Kepulauan Riau",
            value: "KR"
        },
        {
            text: "Lampung",
            value: "LA"
        },
        {
            text: "Maluku",
            value: "ML"
        },
        {
            text: "Maluku Utara",
            value: "MU"
        },
        {
            text: "Nusa Tenggara Barat",
            value: "NB"
        },
        {
            text: "Nusa Tenggara Timur",
            value: "NT"
        },
        {
            text: "Papua",
            value: "PP"
        },
        {
            text: "Papua Barat",
            value: "PB"
        },
        {
            text: "Riau",
            value: "RI"
        },
        {
            text: "Sulawesi Barat",
            value: "SR"
        },
        {
            text: "Sulawesi Selatan",
            value: "SN"
        },
        {
            text: "Sulawesi Tengah",
            value: "ST"
        },
        {
            text: "Sulawesi Tenggara",
            value: "SG"
        },
        {
            text: "Sulawesi Utara",
            value: "SA"
        },
        {
            text: "Sumatera Barat",
            value: "SB"
        },
        {
            text: "Sumatera Selatan",
            value: "SS"
        },
        {
            text: "Sumatera Utara",
            value: "SU"
        },
        {
            text: "Yogyakarta",
            value: "YO"
        }
    ],
    IR: [
        {
            text: "Alborz",
            value: "32"
        },
        {
            text: "Ardabil",
            value: "03"
        },
        {
            text: "Azarbayjan-e Gharbi",
            value: "02"
        },
        {
            text: "Azarbayjan-e Sharqi",
            value: "01"
        },
        {
            text: "Bushehr",
            value: "06"
        },
        {
            text: "Chahar Mahal va Bakhtiari",
            value: "08"
        },
        {
            text: "Esfahan",
            value: "04"
        },
        {
            text: "Fars",
            value: "14"
        },
        {
            text: "Gilan",
            value: "19"
        },
        {
            text: "Golestan",
            value: "27"
        },
        {
            text: "Hamadan",
            value: "24"
        },
        {
            text: "Hormozgan",
            value: "23"
        },
        {
            text: "Ilam",
            value: "05"
        },
        {
            text: "Kerman",
            value: "15"
        },
        {
            text: "Kermanshah",
            value: "17"
        },
        {
            text: "Khorasan-e Jonubi",
            value: "29"
        },
        {
            text: "Khorasan-e Razavi",
            value: "30"
        },
        {
            text: "Khorasan-e Shomali",
            value: "31"
        },
        {
            text: "Khuzestan",
            value: "10"
        },
        {
            text: "Kohgiluyeh va Bowyer Ahmad",
            value: "18"
        },
        {
            text: "Kordestan",
            value: "16"
        },
        {
            text: "Lorestan",
            value: "20"
        },
        {
            text: "Markazi",
            value: "22"
        },
        {
            text: "Mazandaran",
            value: "21"
        },
        {
            text: "Qazvin",
            value: "28"
        },
        {
            text: "Qom",
            value: "26"
        },
        {
            text: "Semnan",
            value: "12"
        },
        {
            text: "Sistan va Baluchestan",
            value: "13"
        },
        {
            text: "Tehran",
            value: "07"
        },
        {
            text: "Yazd",
            value: "25"
        },
        {
            text: "Zanjan",
            value: "11"
        }
    ],
    IQ: [
        {
            text: "Al Anbar",
            value: "AN"
        },
        {
            text: "Al Basrah",
            value: "BA"
        },
        {
            text: "Al Muthanna",
            value: "MU"
        },
        {
            text: "Al Qadisiyah",
            value: "QA"
        },
        {
            text: "An Najaf",
            value: "NA"
        },
        {
            text: "Arbil",
            value: "AR"
        },
        {
            text: "As Sulaymaniyah",
            value: "SU"
        },
        {
            text: "Babil",
            value: "BB"
        },
        {
            text: "Baghdad",
            value: "BG"
        },
        {
            text: "Dahuk",
            value: "DA"
        },
        {
            text: "Dhi Qar",
            value: "DQ"
        },
        {
            text: "Diyala",
            value: "DI"
        },
        {
            text: "Karbala'",
            value: "KA"
        },
        {
            text: "Kirkuk",
            value: "KI"
        },
        {
            text: "Maysan",
            value: "MA"
        },
        {
            text: "Ninawa",
            value: "NI"
        },
        {
            text: "Salah ad Din",
            value: "SD"
        },
        {
            text: "Wasit",
            value: "WA"
        }
    ],
    IE: [
        {
            text: "Carlow",
            value: "CW"
        },
        {
            text: "Cavan",
            value: "CN"
        },
        {
            text: "Clare",
            value: "CE"
        },
        {
            text: "Cork",
            value: "CO"
        },
        {
            text: "Donegal",
            value: "DL"
        },
        {
            text: "Dublin",
            value: "D"
        },
        {
            text: "Galway",
            value: "G"
        },
        {
            text: "Kerry",
            value: "KY"
        },
        {
            text: "Kildare",
            value: "KE"
        },
        {
            text: "Kilkenny",
            value: "KK"
        },
        {
            text: "Laois",
            value: "LS"
        },
        {
            text: "Leitrim",
            value: "LM"
        },
        {
            text: "Limerick",
            value: "LK"
        },
        {
            text: "Longford",
            value: "LD"
        },
        {
            text: "Louth",
            value: "LH"
        },
        {
            text: "Mayo",
            value: "MO"
        },
        {
            text: "Meath",
            value: "MH"
        },
        {
            text: "Monaghan",
            value: "MN"
        },
        {
            text: "Offaly",
            value: "OY"
        },
        {
            text: "Roscommon",
            value: "RN"
        },
        {
            text: "Sligo",
            value: "SO"
        },
        {
            text: "Tipperary",
            value: "TA"
        },
        {
            text: "Waterford",
            value: "WD"
        },
        {
            text: "Westmeath",
            value: "WH"
        },
        {
            text: "Wexford",
            value: "WX"
        },
        {
            text: "Wicklow",
            value: "WW"
        }
    ],
    IM: [
        {
            text: "Isle of Man",
            value: "01"
        }
    ],
    IL: [
        {
            text: "HaDarom",
            value: "D"
        },
        {
            text: "HaMerkaz",
            value: "M"
        },
        {
            text: "HaTsafon",
            value: "Z"
        },
        {
            text: "Hefa",
            value: "HA"
        },
        {
            text: "Tel Aviv",
            value: "TA"
        },
        {
            text: "Yerushalayim",
            value: "JM"
        }
    ],
    IT: [
        {
            text: "Abruzzo",
            value: "65"
        },
        {
            text: "Basilicata",
            value: "77"
        },
        {
            text: "Calabria",
            value: "78"
        },
        {
            text: "Campania",
            value: "72"
        },
        {
            text: "Emilia-Romagna",
            value: "45"
        },
        {
            text: "Friuli-Venezia Giulia",
            value: "36"
        },
        {
            text: "Lazio",
            value: "62"
        },
        {
            text: "Liguria",
            value: "42"
        },
        {
            text: "Lombardia",
            value: "25"
        },
        {
            text: "Marche",
            value: "57"
        },
        {
            text: "Molise",
            value: "67"
        },
        {
            text: "Piemonte",
            value: "21"
        },
        {
            text: "Puglia",
            value: "75"
        },
        {
            text: "Sardegna",
            value: "88"
        },
        {
            text: "Sicilia",
            value: "82"
        },
        {
            text: "Toscana",
            value: "52"
        },
        {
            text: "Trentino-Alto Adige",
            value: "32"
        },
        {
            text: "Umbria",
            value: "55"
        },
        {
            text: "Valle d'Aosta",
            value: "23"
        },
        {
            text: "Veneto",
            value: "34"
        }
    ],
    JM: [
        {
            text: "Clarendon",
            value: "13"
        },
        {
            text: "Hanover",
            value: "09"
        },
        {
            text: "Kingston",
            value: "01"
        },
        {
            text: "Manchester",
            value: "12"
        },
        {
            text: "Portland",
            value: "04"
        },
        {
            text: "Saint Andrew",
            value: "02"
        },
        {
            text: "Saint Ann",
            value: "06"
        },
        {
            text: "Saint Catherine",
            value: "14"
        },
        {
            text: "Saint Elizabeth",
            value: "11"
        },
        {
            text: "Saint James",
            value: "08"
        },
        {
            text: "Saint Mary",
            value: "05"
        },
        {
            text: "Saint Thomas",
            value: "03"
        },
        {
            text: "Trelawny",
            value: "07"
        },
        {
            text: "Westmoreland",
            value: "10"
        }
    ],
    JP: [
        {
            text: "Aichi",
            value: "23"
        },
        {
            text: "Akita",
            value: "05"
        },
        {
            text: "Aomori",
            value: "02"
        },
        {
            text: "Chiba",
            value: "12"
        },
        {
            text: "Ehime",
            value: "38"
        },
        {
            text: "Fukui",
            value: "18"
        },
        {
            text: "Fukuoka",
            value: "40"
        },
        {
            text: "Fukushima",
            value: "07"
        },
        {
            text: "Gifu",
            value: "21"
        },
        {
            text: "Gunma",
            value: "10"
        },
        {
            text: "Hiroshima",
            value: "34"
        },
        {
            text: "Hokkaido",
            value: "01"
        },
        {
            text: "Hyogo",
            value: "28"
        },
        {
            text: "Ibaraki",
            value: "08"
        },
        {
            text: "Ishikawa",
            value: "17"
        },
        {
            text: "Iwate",
            value: "03"
        },
        {
            text: "Kagawa",
            value: "37"
        },
        {
            text: "Kagoshima",
            value: "46"
        },
        {
            text: "Kanagawa",
            value: "14"
        },
        {
            text: "Kochi",
            value: "39"
        },
        {
            text: "Kumamoto",
            value: "43"
        },
        {
            text: "Kyoto",
            value: "26"
        },
        {
            text: "Mie",
            value: "24"
        },
        {
            text: "Miyagi",
            value: "04"
        },
        {
            text: "Miyazaki",
            value: "45"
        },
        {
            text: "Nagano",
            value: "20"
        },
        {
            text: "Nagasaki",
            value: "42"
        },
        {
            text: "Nara",
            value: "29"
        },
        {
            text: "Niigata",
            value: "15"
        },
        {
            text: "Oita",
            value: "44"
        },
        {
            text: "Okayama",
            value: "33"
        },
        {
            text: "Okinawa",
            value: "47"
        },
        {
            text: "Osaka",
            value: "27"
        },
        {
            text: "Saga",
            value: "41"
        },
        {
            text: "Saitama",
            value: "11"
        },
        {
            text: "Shiga",
            value: "25"
        },
        {
            text: "Shimane",
            value: "32"
        },
        {
            text: "Shizuoka",
            value: "22"
        },
        {
            text: "Tochigi",
            value: "09"
        },
        {
            text: "Tokushima",
            value: "36"
        },
        {
            text: "Tokyo",
            value: "13"
        },
        {
            text: "Tottori",
            value: "31"
        },
        {
            text: "Toyama",
            value: "16"
        },
        {
            text: "Wakayama",
            value: "30"
        },
        {
            text: "Yamagata",
            value: "06"
        },
        {
            text: "Yamaguchi",
            value: "35"
        },
        {
            text: "Yamanashi",
            value: "19"
        }
    ],
    JE: [
        {
            text: "Jersey",
            value: "01"
        }
    ],
    JO: [
        {
            text: "'Ajlun",
            value: "AJ"
        },
        {
            text: "Al 'Aqabah",
            value: "AQ"
        },
        {
            text: "Al 'Asimah",
            value: "AM"
        },
        {
            text: "Al Balqa'",
            value: "BA"
        },
        {
            text: "Al Karak",
            value: "KA"
        },
        {
            text: "Al Mafraq",
            value: "MA"
        },
        {
            text: "Az Zarqa'",
            value: "AZ"
        },
        {
            text: "Irbid",
            value: "IR"
        },
        {
            text: "Jarash",
            value: "JA"
        },
        {
            text: "Ma'an",
            value: "MN"
        },
        {
            text: "Madaba",
            value: "MD"
        }
    ],
    KZ: [
        {
            text: "Almaty",
            value: "ALA"
        },
        {
            text: "Almaty oblysy",
            value: "ALM"
        },
        {
            text: "Aqmola oblysy",
            value: "AKM"
        },
        {
            text: "Aqtobe oblysy",
            value: "AKT"
        },
        {
            text: "Astana",
            value: "AST"
        },
        {
            text: "Atyrau oblysy",
            value: "ATY"
        },
        {
            text: "Batys Qazaqstan oblysy",
            value: "ZAP"
        },
        {
            text: "Bayqongyr",
            value: "BAY"
        },
        {
            text: "Mangghystau oblysy",
            value: "MAN"
        },
        {
            text: "Ongtustik Qazaqstan oblysy",
            value: "YUZ"
        },
        {
            text: "Pavlodar oblysy",
            value: "PAV"
        },
        {
            text: "Qaraghandy oblysy",
            value: "KAR"
        },
        {
            text: "Qostanay oblysy",
            value: "KUS"
        },
        {
            text: "Qyzylorda oblysy",
            value: "KZY"
        },
        {
            text: "Shyghys Qazaqstan oblysy",
            value: "VOS"
        },
        {
            text: "Soltustik Qazaqstan oblysy",
            value: "SEV"
        },
        {
            text: "Zhambyl oblysy",
            value: "ZHA"
        }
    ],
    KE: [
        {
            text: "Baringo",
            value: "01"
        },
        {
            text: "Bomet",
            value: "02"
        },
        {
            text: "Bungoma",
            value: "03"
        },
        {
            text: "Busia",
            value: "04"
        },
        {
            text: "Elgeyo/Marakwet",
            value: "05"
        },
        {
            text: "Embu",
            value: "06"
        },
        {
            text: "Garissa",
            value: "07"
        },
        {
            text: "Homa Bay",
            value: "08"
        },
        {
            text: "Isiolo",
            value: "09"
        },
        {
            text: "Kajiado",
            value: "10"
        },
        {
            text: "Kakamega",
            value: "11"
        },
        {
            text: "Kericho",
            value: "12"
        },
        {
            text: "Kiambu",
            value: "13"
        },
        {
            text: "Kilifi",
            value: "14"
        },
        {
            text: "Kirinyaga",
            value: "15"
        },
        {
            text: "Kisii",
            value: "16"
        },
        {
            text: "Kisumu",
            value: "17"
        },
        {
            text: "Kitui",
            value: "18"
        },
        {
            text: "Kwale",
            value: "19"
        },
        {
            text: "Laikipia",
            value: "20"
        },
        {
            text: "Lamu",
            value: "21"
        },
        {
            text: "Machakos",
            value: "22"
        },
        {
            text: "Makueni",
            value: "23"
        },
        {
            text: "Mandera",
            value: "24"
        },
        {
            text: "Marsabit",
            value: "25"
        },
        {
            text: "Meru",
            value: "26"
        },
        {
            text: "Migori",
            value: "27"
        },
        {
            text: "Mombasa",
            value: "28"
        },
        {
            text: "Murang'a",
            value: "29"
        },
        {
            text: "Nairobi City",
            value: "30"
        },
        {
            text: "Nakuru",
            value: "31"
        },
        {
            text: "Nandi",
            value: "32"
        },
        {
            text: "Narok",
            value: "33"
        },
        {
            text: "Nyamira",
            value: "34"
        },
        {
            text: "Nyandarua",
            value: "35"
        },
        {
            text: "Nyeri",
            value: "36"
        },
        {
            text: "Siaya",
            value: "38"
        },
        {
            text: "Taita/Taveta",
            value: "39"
        },
        {
            text: "Tharaka-Nithi",
            value: "41"
        },
        {
            text: "Trans Nzoia",
            value: "42"
        },
        {
            text: "Turkana",
            value: "43"
        },
        {
            text: "Uasin Gishu",
            value: "44"
        },
        {
            text: "Wajir",
            value: "46"
        }
    ],
    KI: [
        {
            text: "Gilbert Islands",
            value: "G"
        },
        {
            text: "Line Islands",
            value: "L"
        }
    ],
    KP: [
        {
            text: "P'yongyang",
            value: "01"
        }
    ],
    KR: [
        {
            text: "Busan-gwangyeoksi",
            value: "26"
        },
        {
            text: "Chungcheongbuk-do",
            value: "43"
        },
        {
            text: "Chungcheongnam-do",
            value: "44"
        },
        {
            text: "Daegu-gwangyeoksi",
            value: "27"
        },
        {
            text: "Daejeon-gwangyeoksi",
            value: "30"
        },
        {
            text: "Gangwon-do",
            value: "42"
        },
        {
            text: "Gwangju-gwangyeoksi",
            value: "29"
        },
        {
            text: "Gyeonggi-do",
            value: "41"
        },
        {
            text: "Gyeongsangbuk-do",
            value: "47"
        },
        {
            text: "Gyeongsangnam-do",
            value: "48"
        },
        {
            text: "Incheon-gwangyeoksi",
            value: "28"
        },
        {
            text: "Jeju-teukbyeoljachido",
            value: "49"
        },
        {
            text: "Jeollabuk-do",
            value: "45"
        },
        {
            text: "Jeollanam-do",
            value: "46"
        },
        {
            text: "Seoul-teukbyeolsi",
            value: "11"
        },
        {
            text: "Ulsan-gwangyeoksi",
            value: "31"
        }
    ],
    KW: [
        {
            text: "Al 'Asimah",
            value: "KU"
        },
        {
            text: "Al Ahmadi",
            value: "AH"
        },
        {
            text: "Al Farwaniyah",
            value: "FA"
        },
        {
            text: "Al Jahra'",
            value: "JA"
        },
        {
            text: "Hawalli",
            value: "HA"
        },
        {
            text: "Mubarak al Kabir",
            value: "MU"
        }
    ],
    KG: [
        {
            text: "Batken",
            value: "B"
        },
        {
            text: "Bishkek",
            value: "GB"
        },
        {
            text: "Chuy",
            value: "C"
        },
        {
            text: "Jalal-Abad",
            value: "J"
        },
        {
            text: "Naryn",
            value: "N"
        },
        {
            text: "Osh",
            value: "GO"
        },
        {
            text: "Talas",
            value: "T"
        },
        {
            text: "Ysyk-Kol",
            value: "Y"
        }
    ],
    LA: [
        {
            text: "Bolikhamxai",
            value: "BL"
        },
        {
            text: "Champasak",
            value: "CH"
        },
        {
            text: "Houaphan",
            value: "HO"
        },
        {
            text: "Khammouan",
            value: "KH"
        },
        {
            text: "Louang Namtha",
            value: "LM"
        },
        {
            text: "Louangphabang",
            value: "LP"
        },
        {
            text: "Oudomxai",
            value: "OU"
        },
        {
            text: "Savannakhet",
            value: "SV"
        },
        {
            text: "Viangchan",
            value: "VI"
        },
        {
            text: "Xaignabouli",
            value: "XA"
        },
        {
            text: "Xekong",
            value: "XE"
        }
    ],
    LV: [
        {
            text: "Adazu novads",
            value: "011"
        },
        {
            text: "Aglonas novads",
            value: "001"
        },
        {
            text: "Aizkraukles novads",
            value: "002"
        },
        {
            text: "Aizputes novads",
            value: "003"
        },
        {
            text: "Alojas novads",
            value: "005"
        },
        {
            text: "Aluksnes novads",
            value: "007"
        },
        {
            text: "Babites novads",
            value: "012"
        },
        {
            text: "Baldones novads",
            value: "013"
        },
        {
            text: "Balvu novads",
            value: "015"
        },
        {
            text: "Bauskas novads",
            value: "016"
        },
        {
            text: "Beverinas novads",
            value: "017"
        },
        {
            text: "Brocenu novads",
            value: "018"
        },
        {
            text: "Carnikavas novads",
            value: "020"
        },
        {
            text: "Cesu novads",
            value: "022"
        },
        {
            text: "Cesvaines novads",
            value: "021"
        },
        {
            text: "Daugavpils novads",
            value: "025"
        },
        {
            text: "Dobeles novads",
            value: "026"
        },
        {
            text: "Dundagas novads",
            value: "027"
        },
        {
            text: "Erglu novads",
            value: "030"
        },
        {
            text: "Gulbenes novads",
            value: "033"
        },
        {
            text: "Iecavas novads",
            value: "034"
        },
        {
            text: "Ikskiles novads",
            value: "035"
        },
        {
            text: "Incukalna novads",
            value: "037"
        },
        {
            text: "Jaunjelgavas novads",
            value: "038"
        },
        {
            text: "Jaunpiebalgas novads",
            value: "039"
        },
        {
            text: "Jaunpils novads",
            value: "040"
        },
        {
            text: "Jekabpils novads",
            value: "042"
        },
        {
            text: "Jelgava",
            value: "JEL"
        },
        {
            text: "Jelgavas novads",
            value: "041"
        },
        {
            text: "Jurmala",
            value: "JUR"
        },
        {
            text: "Kekavas novads",
            value: "052"
        },
        {
            text: "Kokneses novads",
            value: "046"
        },
        {
            text: "Kraslavas novads",
            value: "047"
        },
        {
            text: "Kuldigas novads",
            value: "050"
        },
        {
            text: "Lielvardes novads",
            value: "053"
        },
        {
            text: "Liepaja",
            value: "LPX"
        },
        {
            text: "Limbazu novads",
            value: "054"
        },
        {
            text: "Livanu novads",
            value: "056"
        },
        {
            text: "Lubanas novads",
            value: "057"
        },
        {
            text: "Ludzas novads",
            value: "058"
        },
        {
            text: "Madonas novads",
            value: "059"
        },
        {
            text: "Malpils novads",
            value: "061"
        },
        {
            text: "Nauksenu novads",
            value: "064"
        },
        {
            text: "Ogres novads",
            value: "067"
        },
        {
            text: "Olaines novads",
            value: "068"
        },
        {
            text: "Ozolnieku novads",
            value: "069"
        },
        {
            text: "Preilu novads",
            value: "073"
        },
        {
            text: "Rezeknes novads",
            value: "077"
        },
        {
            text: "Riebinu novads",
            value: "078"
        },
        {
            text: "Riga",
            value: "RIX"
        },
        {
            text: "Rojas novads",
            value: "079"
        },
        {
            text: "Ropazu novads",
            value: "080"
        },
        {
            text: "Rugaju novads",
            value: "082"
        },
        {
            text: "Rundales novads",
            value: "083"
        },
        {
            text: "Salacgrivas novads",
            value: "086"
        },
        {
            text: "Salaspils novads",
            value: "087"
        },
        {
            text: "Saldus novads",
            value: "088"
        },
        {
            text: "Saulkrastu novads",
            value: "089"
        },
        {
            text: "Sejas novads",
            value: "090"
        },
        {
            text: "Siguldas novads",
            value: "091"
        },
        {
            text: "Skrundas novads",
            value: "093"
        },
        {
            text: "Stopinu novads",
            value: "095"
        },
        {
            text: "Talsu novads",
            value: "097"
        },
        {
            text: "Tukuma novads",
            value: "099"
        },
        {
            text: "Valkas novads",
            value: "101"
        },
        {
            text: "Valmiera",
            value: "VMR"
        },
        {
            text: "Vecumnieku novads",
            value: "105"
        },
        {
            text: "Ventspils novads",
            value: "106"
        }
    ],
    LB: [
        {
            text: "Aakkar",
            value: "AK"
        },
        {
            text: "Baalbek-Hermel",
            value: "BH"
        },
        {
            text: "Beqaa",
            value: "BI"
        },
        {
            text: "Beyrouth",
            value: "BA"
        },
        {
            text: "Liban-Nord",
            value: "AS"
        },
        {
            text: "Liban-Sud",
            value: "JA"
        },
        {
            text: "Mont-Liban",
            value: "JL"
        },
        {
            text: "Nabatiye",
            value: "NA"
        }
    ],
    LS: [
        {
            text: "Berea",
            value: "D"
        },
        {
            text: "Leribe",
            value: "C"
        },
        {
            text: "Maseru",
            value: "A"
        },
        {
            text: "Quthing",
            value: "G"
        }
    ],
    LR: [
        {
            text: "Grand Bassa",
            value: "GB"
        },
        {
            text: "Grand Gedeh",
            value: "GG"
        },
        {
            text: "Margibi",
            value: "MG"
        },
        {
            text: "Maryland",
            value: "MY"
        },
        {
            text: "Montserrado",
            value: "MO"
        },
        {
            text: "Nimba",
            value: "NI"
        },
        {
            text: "Sinoe",
            value: "SI"
        }
    ],
    LY: [
        {
            text: "Al Butnan",
            value: "BU"
        },
        {
            text: "Al Jabal al Akhdar",
            value: "JA"
        },
        {
            text: "Al Jabal al Gharbi",
            value: "JG"
        },
        {
            text: "Al Jufrah",
            value: "JU"
        },
        {
            text: "Al Kufrah",
            value: "KF"
        },
        {
            text: "Al Marj",
            value: "MJ"
        },
        {
            text: "Al Marqab",
            value: "MB"
        },
        {
            text: "Al Wahat",
            value: "WA"
        },
        {
            text: "An Nuqat al Khams",
            value: "NQ"
        },
        {
            text: "Az Zawiyah",
            value: "ZA"
        },
        {
            text: "Banghazi",
            value: "BA"
        },
        {
            text: "Darnah",
            value: "DR"
        },
        {
            text: "Misratah",
            value: "MI"
        },
        {
            text: "Murzuq",
            value: "MQ"
        },
        {
            text: "Nalut",
            value: "NL"
        },
        {
            text: "Sabha",
            value: "SB"
        },
        {
            text: "Tarabulus",
            value: "TB"
        }
    ],
    LI: [
        {
            text: "Balzers",
            value: "01"
        },
        {
            text: "Eschen",
            value: "02"
        },
        {
            text: "Gamprin",
            value: "03"
        },
        {
            text: "Mauren",
            value: "04"
        },
        {
            text: "Planken",
            value: "05"
        },
        {
            text: "Ruggell",
            value: "06"
        },
        {
            text: "Schaan",
            value: "07"
        },
        {
            text: "Schellenberg",
            value: "08"
        },
        {
            text: "Triesen",
            value: "09"
        },
        {
            text: "Vaduz",
            value: "11"
        }
    ],
    LT: [
        {
            text: "Alytaus apskritis",
            value: "AL"
        },
        {
            text: "Kauno apskritis",
            value: "KU"
        },
        {
            text: "Klaipedos apskritis",
            value: "KL"
        },
        {
            text: "Marijampoles apskritis",
            value: "MR"
        },
        {
            text: "Panevezio apskritis",
            value: "PN"
        },
        {
            text: "Siauliu apskritis",
            value: "SA"
        },
        {
            text: "Taurages apskritis",
            value: "TA"
        },
        {
            text: "Telsiu apskritis",
            value: "TE"
        },
        {
            text: "Utenos apskritis",
            value: "UT"
        },
        {
            text: "Vilniaus apskritis",
            value: "VL"
        }
    ],
    LU: [
        {
            text: "Diekirch",
            value: "DI"
        },
        {
            text: "Grevenmacher",
            value: "GR"
        },
        {
            text: "Luxembourg",
            value: "LU"
        }
    ],
    MK: [
        {
            text: "Aracinovo",
            value: "802"
        },
        {
            text: "Berovo",
            value: "201"
        },
        {
            text: "Bitola",
            value: "501"
        },
        {
            text: "Bogdanci",
            value: "401"
        },
        {
            text: "Bogovinje",
            value: "601"
        },
        {
            text: "Bosilovo",
            value: "402"
        },
        {
            text: "Brvenica",
            value: "602"
        },
        {
            text: "Centar Zupa",
            value: "313"
        },
        {
            text: "Cesinovo-Oblesevo",
            value: "210"
        },
        {
            text: "Debar",
            value: "303"
        },
        {
            text: "Delcevo",
            value: "203"
        },
        {
            text: "Demir Kapija",
            value: "103"
        },
        {
            text: "Dolneni",
            value: "503"
        },
        {
            text: "Gevgelija",
            value: "405"
        },
        {
            text: "Gostivar",
            value: "604"
        },
        {
            text: "Ilinden",
            value: "807"
        },
        {
            text: "Jegunovce",
            value: "606"
        },
        {
            text: "Karbinci",
            value: "205"
        },
        {
            text: "Kavadarci",
            value: "104"
        },
        {
            text: "Kicevo",
            value: "307"
        },
        {
            text: "Kocani",
            value: "206"
        },
        {
            text: "Kratovo",
            value: "701"
        },
        {
            text: "Kriva Palanka",
            value: "702"
        },
        {
            text: "Krivogastani",
            value: "504"
        },
        {
            text: "Krusevo",
            value: "505"
        },
        {
            text: "Kumanovo",
            value: "703"
        },
        {
            text: "Lipkovo",
            value: "704"
        },
        {
            text: "Lozovo",
            value: "105"
        },
        {
            text: "Makedonska Kamenica",
            value: "207"
        },
        {
            text: "Negotino",
            value: "106"
        },
        {
            text: "Novo Selo",
            value: "408"
        },
        {
            text: "Ohrid",
            value: "310"
        },
        {
            text: "Pehcevo",
            value: "208"
        },
        {
            text: "Petrovec",
            value: "810"
        },
        {
            text: "Plasnica",
            value: "311"
        },
        {
            text: "Prilep",
            value: "508"
        },
        {
            text: "Probistip",
            value: "209"
        },
        {
            text: "Radovis",
            value: "409"
        },
        {
            text: "Rankovce",
            value: "705"
        },
        {
            text: "Resen",
            value: "509"
        },
        {
            text: "Rosoman",
            value: "107"
        },
        {
            text: "Skopje",
            value: "85"
        },
        {
            text: "Sopiste",
            value: "812"
        },
        {
            text: "Staro Nagoricane",
            value: "706"
        },
        {
            text: "Stip",
            value: "211"
        },
        {
            text: "Struga",
            value: "312"
        },
        {
            text: "Strumica",
            value: "410"
        },
        {
            text: "Studenicani",
            value: "813"
        },
        {
            text: "Sveti Nikole",
            value: "108"
        },
        {
            text: "Tearce",
            value: "608"
        },
        {
            text: "Tetovo",
            value: "609"
        },
        {
            text: "Valandovo",
            value: "403"
        },
        {
            text: "Vasilevo",
            value: "404"
        },
        {
            text: "Veles",
            value: "101"
        },
        {
            text: "Vevcani",
            value: "301"
        },
        {
            text: "Vinica",
            value: "202"
        },
        {
            text: "Vrapciste",
            value: "603"
        },
        {
            text: "Zelenikovo",
            value: "806"
        },
        {
            text: "Zelino",
            value: "605"
        }
    ],
    MG: [
        {
            text: "Antananarivo",
            value: "T"
        },
        {
            text: "Antsiranana",
            value: "D"
        },
        {
            text: "Fianarantsoa",
            value: "F"
        },
        {
            text: "Mahajanga",
            value: "M"
        },
        {
            text: "Toamasina",
            value: "A"
        },
        {
            text: "Toliara",
            value: "U"
        }
    ],
    MW: [
        {
            text: "Balaka",
            value: "BA"
        },
        {
            text: "Blantyre",
            value: "BL"
        },
        {
            text: "Dowa",
            value: "DO"
        },
        {
            text: "Lilongwe",
            value: "LI"
        },
        {
            text: "Machinga",
            value: "MH"
        },
        {
            text: "Mangochi",
            value: "MG"
        },
        {
            text: "Mzimba",
            value: "MZ"
        },
        {
            text: "Ntchisi",
            value: "NI"
        },
        {
            text: "Salima",
            value: "SA"
        },
        {
            text: "Zomba",
            value: "ZO"
        }
    ],
    MY: [
        {
            text: "Johor",
            value: "01"
        },
        {
            text: "Kedah",
            value: "02"
        },
        {
            text: "Kelantan",
            value: "03"
        },
        {
            text: "Melaka",
            value: "04"
        },
        {
            text: "Negeri Sembilan",
            value: "05"
        },
        {
            text: "Pahang",
            value: "06"
        },
        {
            text: "Perak",
            value: "08"
        },
        {
            text: "Perlis",
            value: "09"
        },
        {
            text: "Pulau Pinang",
            value: "07"
        },
        {
            text: "Sabah",
            value: "12"
        },
        {
            text: "Sarawak",
            value: "13"
        },
        {
            text: "Selangor",
            value: "10"
        },
        {
            text: "Terengganu",
            value: "11"
        },
        {
            text: "Wilayah Persekutuan Kuala Lumpur",
            value: "14"
        },
        {
            text: "Wilayah Persekutuan Labuan",
            value: "15"
        },
        {
            text: "Wilayah Persekutuan Putrajaya",
            value: "16"
        }
    ],
    MV: [
        {
            text: "Alifu Alifu",
            value: "02"
        },
        {
            text: "Baa",
            value: "20"
        },
        {
            text: "Dhaalu",
            value: "17"
        },
        {
            text: "Gaafu Dhaalu",
            value: "28"
        },
        {
            text: "Haa Dhaalu",
            value: "23"
        },
        {
            text: "Kaafu",
            value: "26"
        },
        {
            text: "Laamu",
            value: "05"
        },
        {
            text: "Maale",
            value: "MLE"
        },
        {
            text: "Meemu",
            value: "12"
        },
        {
            text: "Noonu",
            value: "25"
        },
        {
            text: "Raa",
            value: "13"
        },
        {
            text: "Seenu",
            value: "01"
        },
        {
            text: "Vaavu",
            value: "04"
        }
    ],
    ML: [
        {
            text: "Bamako",
            value: "BKO"
        },
        {
            text: "Gao",
            value: "7"
        },
        {
            text: "Kayes",
            value: "1"
        },
        {
            text: "Kidal",
            value: "8"
        },
        {
            text: "Koulikoro",
            value: "2"
        },
        {
            text: "Mopti",
            value: "5"
        },
        {
            text: "Segou",
            value: "4"
        },
        {
            text: "Sikasso",
            value: "3"
        },
        {
            text: "Tombouctou",
            value: "6"
        }
    ],
    MT: [
        {
            text: "Attard",
            value: "01"
        },
        {
            text: "Balzan",
            value: "02"
        },
        {
            text: "Birgu",
            value: "03"
        },
        {
            text: "Birkirkara",
            value: "04"
        },
        {
            text: "Birzebbuga",
            value: "05"
        },
        {
            text: "Bormla",
            value: "06"
        },
        {
            text: "Dingli",
            value: "07"
        },
        {
            text: "Fgura",
            value: "08"
        },
        {
            text: "Floriana",
            value: "09"
        },
        {
            text: "Fontana",
            value: "10"
        },
        {
            text: "Gharb",
            value: "14"
        },
        {
            text: "Gharghur",
            value: "15"
        },
        {
            text: "Ghasri",
            value: "16"
        },
        {
            text: "Ghaxaq",
            value: "17"
        },
        {
            text: "Gudja",
            value: "11"
        },
        {
            text: "Gzira",
            value: "12"
        },
        {
            text: "Hamrun",
            value: "18"
        },
        {
            text: "Iklin",
            value: "19"
        },
        {
            text: "Isla",
            value: "20"
        },
        {
            text: "Kalkara",
            value: "21"
        },
        {
            text: "Kercem",
            value: "22"
        },
        {
            text: "Kirkop",
            value: "23"
        },
        {
            text: "Lija",
            value: "24"
        },
        {
            text: "Luqa",
            value: "25"
        },
        {
            text: "Marsa",
            value: "26"
        },
        {
            text: "Marsaskala",
            value: "27"
        },
        {
            text: "Marsaxlokk",
            value: "28"
        },
        {
            text: "Mdina",
            value: "29"
        },
        {
            text: "Mellieha",
            value: "30"
        },
        {
            text: "Mgarr",
            value: "31"
        },
        {
            text: "Mosta",
            value: "32"
        },
        {
            text: "Mqabba",
            value: "33"
        },
        {
            text: "Msida",
            value: "34"
        },
        {
            text: "Mtarfa",
            value: "35"
        },
        {
            text: "Munxar",
            value: "36"
        },
        {
            text: "Nadur",
            value: "37"
        },
        {
            text: "Naxxar",
            value: "38"
        },
        {
            text: "Paola",
            value: "39"
        },
        {
            text: "Pembroke",
            value: "40"
        },
        {
            text: "Pieta",
            value: "41"
        },
        {
            text: "Qala",
            value: "42"
        },
        {
            text: "Qormi",
            value: "43"
        },
        {
            text: "Qrendi",
            value: "44"
        },
        {
            text: "Rabat Gozo",
            value: "45"
        },
        {
            text: "Rabat Malta",
            value: "46"
        },
        {
            text: "Safi",
            value: "47"
        },
        {
            text: "Saint John",
            value: "49"
        },
        {
            text: "Saint Julian's",
            value: "48"
        },
        {
            text: "Saint Lucia's",
            value: "53"
        },
        {
            text: "Saint Paul's Bay",
            value: "51"
        },
        {
            text: "Sannat",
            value: "52"
        },
        {
            text: "Santa Venera",
            value: "54"
        },
        {
            text: "Siggiewi",
            value: "55"
        },
        {
            text: "Sliema",
            value: "56"
        },
        {
            text: "Swieqi",
            value: "57"
        },
        {
            text: "Ta' Xbiex",
            value: "58"
        },
        {
            text: "Tarxien",
            value: "59"
        },
        {
            text: "Valletta",
            value: "60"
        },
        {
            text: "Xaghra",
            value: "61"
        },
        {
            text: "Xewkija",
            value: "62"
        },
        {
            text: "Xghajra",
            value: "63"
        },
        {
            text: "Zabbar",
            value: "64"
        },
        {
            text: "Zebbug Gozo",
            value: "65"
        },
        {
            text: "Zejtun",
            value: "67"
        },
        {
            text: "Zurrieq",
            value: "68"
        }
    ],
    MH: [
        {
            text: "Kwajalein",
            value: "KWA"
        },
        {
            text: "Majuro",
            value: "MAJ"
        }
    ],
    MQ: [
        {
            text: "Martinique",
            value: "01"
        }
    ],
    MR: [
        {
            text: "Dakhlet Nouadhibou",
            value: "08"
        },
        {
            text: "Nouakchott Nord",
            value: "14"
        },
        {
            text: "Tiris Zemmour",
            value: "11"
        }
    ],
    MU: [
        {
            text: "Black River",
            value: "BL"
        },
        {
            text: "Flacq",
            value: "FL"
        },
        {
            text: "Grand Port",
            value: "GP"
        },
        {
            text: "Moka",
            value: "MO"
        },
        {
            text: "Pamplemousses",
            value: "PA"
        },
        {
            text: "Plaines Wilhems",
            value: "PW"
        },
        {
            text: "Port Louis",
            value: "PL"
        },
        {
            text: "Riviere du Rempart",
            value: "RR"
        },
        {
            text: "Rodrigues Islands",
            value: "RO"
        },
        {
            text: "Savanne",
            value: "SA"
        }
    ],
    YT: [
        {
            text: "Mamoudzou",
            value: "01"
        },
        {
            text: "Mtsamboro",
            value: "02"
        },
        {
            text: "Ouangani",
            value: "03"
        },
        {
            text: "Pamandzi",
            value: "04"
        }
    ],
    MX: [
        {
            text: "Aguascalientes",
            value: "AGU"
        },
        {
            text: "Baja California",
            value: "BCN"
        },
        {
            text: "Baja California Sur",
            value: "BCS"
        },
        {
            text: "Campeche",
            value: "CAM"
        },
        {
            text: "Chiapas",
            value: "CHP"
        },
        {
            text: "Chihuahua",
            value: "CHH"
        },
        {
            text: "Ciudad de Mexico",
            value: "CMX"
        },
        {
            text: "Coahuila de Zaragoza",
            value: "COA"
        },
        {
            text: "Colima",
            value: "COL"
        },
        {
            text: "Durango",
            value: "DUR"
        },
        {
            text: "Guanajuato",
            value: "GUA"
        },
        {
            text: "Guerrero",
            value: "GRO"
        },
        {
            text: "Hidalgo",
            value: "HID"
        },
        {
            text: "Jalisco",
            value: "JAL"
        },
        {
            text: "Mexico",
            value: "MEX"
        },
        {
            text: "Michoacan de Ocampo",
            value: "MIC"
        },
        {
            text: "Morelos",
            value: "MOR"
        },
        {
            text: "Nayarit",
            value: "NAY"
        },
        {
            text: "Nuevo Leon",
            value: "NLE"
        },
        {
            text: "Oaxaca",
            value: "OAX"
        },
        {
            text: "Puebla",
            value: "PUE"
        },
        {
            text: "Queretaro",
            value: "QUE"
        },
        {
            text: "Quintana Roo",
            value: "ROO"
        },
        {
            text: "San Luis Potosi",
            value: "SLP"
        },
        {
            text: "Sinaloa",
            value: "SIN"
        },
        {
            text: "Sonora",
            value: "SON"
        },
        {
            text: "Tabasco",
            value: "TAB"
        },
        {
            text: "Tamaulipas",
            value: "TAM"
        },
        {
            text: "Tlaxcala",
            value: "TLA"
        },
        {
            text: "Veracruz de Ignacio de la Llave",
            value: "VER"
        },
        {
            text: "Yucatan",
            value: "YUC"
        },
        {
            text: "Zacatecas",
            value: "ZAC"
        }
    ],
    FM: [
        {
            text: "Chuuk",
            value: "TRK"
        },
        {
            text: "Kosrae",
            value: "KSA"
        },
        {
            text: "Pohnpei",
            value: "PNI"
        },
        {
            text: "Yap",
            value: "YAP"
        }
    ],
    MD: [
        {
            text: "Anenii Noi",
            value: "AN"
        },
        {
            text: "Balti",
            value: "BA"
        },
        {
            text: "Basarabeasca",
            value: "BS"
        },
        {
            text: "Bender",
            value: "BD"
        },
        {
            text: "Briceni",
            value: "BR"
        },
        {
            text: "Cahul",
            value: "CA"
        },
        {
            text: "Calarasi",
            value: "CL"
        },
        {
            text: "Cantemir",
            value: "CT"
        },
        {
            text: "Causeni",
            value: "CS"
        },
        {
            text: "Chisinau",
            value: "CU"
        },
        {
            text: "Cimislia",
            value: "CM"
        },
        {
            text: "Criuleni",
            value: "CR"
        },
        {
            text: "Donduseni",
            value: "DO"
        },
        {
            text: "Drochia",
            value: "DR"
        },
        {
            text: "Dubasari",
            value: "DU"
        },
        {
            text: "Edinet",
            value: "ED"
        },
        {
            text: "Falesti",
            value: "FA"
        },
        {
            text: "Floresti",
            value: "FL"
        },
        {
            text: "Gagauzia, Unitatea teritoriala autonoma",
            value: "GA"
        },
        {
            text: "Glodeni",
            value: "GL"
        },
        {
            text: "Hincesti",
            value: "HI"
        },
        {
            text: "Ialoveni",
            value: "IA"
        },
        {
            text: "Leova",
            value: "LE"
        },
        {
            text: "Nisporeni",
            value: "NI"
        },
        {
            text: "Ocnita",
            value: "OC"
        },
        {
            text: "Orhei",
            value: "OR"
        },
        {
            text: "Rezina",
            value: "RE"
        },
        {
            text: "Riscani",
            value: "RI"
        },
        {
            text: "Singerei",
            value: "SI"
        },
        {
            text: "Soldanesti",
            value: "SD"
        },
        {
            text: "Soroca",
            value: "SO"
        },
        {
            text: "Stefan Voda",
            value: "SV"
        },
        {
            text: "Stinga Nistrului, unitatea teritoriala din",
            value: "SN"
        },
        {
            text: "Straseni",
            value: "ST"
        },
        {
            text: "Taraclia",
            value: "TA"
        },
        {
            text: "Telenesti",
            value: "TE"
        },
        {
            text: "Ungheni",
            value: "UN"
        }
    ],
    MC: [
        {
            text: "Fontvieille",
            value: "FO"
        },
        {
            text: "La Condamine",
            value: "CO"
        },
        {
            text: "Monaco-Ville",
            value: "MO"
        },
        {
            text: "Monte-Carlo",
            value: "MC"
        },
        {
            text: "Saint-Roman",
            value: "SR"
        }
    ],
    MN: [
        {
            text: "Bayan-Olgiy",
            value: "071"
        },
        {
            text: "Dornogovi",
            value: "063"
        },
        {
            text: "Govi-Altay",
            value: "065"
        },
        {
            text: "Omnogovi",
            value: "053"
        },
        {
            text: "Orhon",
            value: "035"
        },
        {
            text: "Ovorhangay",
            value: "055"
        },
        {
            text: "Selenge",
            value: "049"
        },
        {
            text: "Tov",
            value: "047"
        },
        {
            text: "Ulaanbaatar",
            value: "1"
        }
    ],
    ME: [
        {
            text: "Bar",
            value: "02"
        },
        {
            text: "Berane",
            value: "03"
        },
        {
            text: "Bijelo Polje",
            value: "04"
        },
        {
            text: "Budva",
            value: "05"
        },
        {
            text: "Cetinje",
            value: "06"
        },
        {
            text: "Danilovgrad",
            value: "07"
        },
        {
            text: "Herceg-Novi",
            value: "08"
        },
        {
            text: "Kolasin",
            value: "09"
        },
        {
            text: "Kotor",
            value: "10"
        },
        {
            text: "Niksic",
            value: "12"
        },
        {
            text: "Plav",
            value: "13"
        },
        {
            text: "Pljevlja",
            value: "14"
        },
        {
            text: "Pluzine",
            value: "15"
        },
        {
            text: "Podgorica",
            value: "16"
        },
        {
            text: "Rozaje",
            value: "17"
        },
        {
            text: "Tivat",
            value: "19"
        },
        {
            text: "Ulcinj",
            value: "20"
        },
        {
            text: "Zabljak",
            value: "21"
        }
    ],
    MS: [
        {
            text: "Saint Anthony",
            value: "01"
        },
        {
            text: "Saint Peter",
            value: "02"
        }
    ],
    MA: [
        {
            text: "Beni-Mellal-Khenifra",
            value: "05"
        },
        {
            text: "Casablanca-Settat",
            value: "06"
        },
        {
            text: "Draa-Tafilalet",
            value: "08"
        },
        {
            text: "Fes- Meknes",
            value: "03"
        },
        {
            text: "Guelmim-Oued Noun (EH-partial)",
            value: "10"
        },
        {
            text: "L'Oriental",
            value: "02"
        },
        {
            text: "Laayoune-Sakia El Hamra (EH-partial)",
            value: "11"
        },
        {
            text: "Marrakech-Safi",
            value: "07"
        },
        {
            text: "Rabat-Sale-Kenitra",
            value: "04"
        },
        {
            text: "Souss-Massa",
            value: "09"
        },
        {
            text: "Tanger-Tetouan-Al Hoceima",
            value: "01"
        }
    ],
    MZ: [
        {
            text: "Cabo Delgado",
            value: "P"
        },
        {
            text: "Gaza",
            value: "G"
        },
        {
            text: "Inhambane",
            value: "I"
        },
        {
            text: "Manica",
            value: "B"
        },
        {
            text: "Maputo",
            value: "L"
        },
        {
            text: "Nampula",
            value: "N"
        },
        {
            text: "Niassa",
            value: "A"
        },
        {
            text: "Sofala",
            value: "S"
        },
        {
            text: "Tete",
            value: "T"
        },
        {
            text: "Zambezia",
            value: "Q"
        }
    ],
    MM: [
        {
            text: "Ayeyarwady",
            value: "07"
        },
        {
            text: "Bago",
            value: "02"
        },
        {
            text: "Chin",
            value: "14"
        },
        {
            text: "Kachin",
            value: "11"
        },
        {
            text: "Magway",
            value: "03"
        },
        {
            text: "Mandalay",
            value: "04"
        },
        {
            text: "Mon",
            value: "15"
        },
        {
            text: "Nay Pyi Taw",
            value: "18"
        },
        {
            text: "Sagaing",
            value: "01"
        },
        {
            text: "Shan",
            value: "17"
        },
        {
            text: "Tanintharyi",
            value: "05"
        },
        {
            text: "Yangon",
            value: "06"
        }
    ],
    NA: [
        {
            text: "Erongo",
            value: "ER"
        },
        {
            text: "Hardap",
            value: "HA"
        },
        {
            text: "Karas",
            value: "KA"
        },
        {
            text: "Kavango East",
            value: "KE"
        },
        {
            text: "Khomas",
            value: "KH"
        },
        {
            text: "Kunene",
            value: "KU"
        },
        {
            text: "Ohangwena",
            value: "OW"
        },
        {
            text: "Omaheke",
            value: "OH"
        },
        {
            text: "Omusati",
            value: "OS"
        },
        {
            text: "Oshana",
            value: "ON"
        },
        {
            text: "Oshikoto",
            value: "OT"
        },
        {
            text: "Otjozondjupa",
            value: "OD"
        },
        {
            text: "Zambezi",
            value: "CA"
        }
    ],
    NR: [
        {
            text: "Yaren",
            value: "14"
        }
    ],
    NP: [
        {
            text: "Bagmati",
            value: "BA"
        },
        {
            text: "Bheri",
            value: "BH"
        },
        {
            text: "Dhawalagiri",
            value: "DH"
        },
        {
            text: "Gandaki",
            value: "GA"
        },
        {
            text: "Janakpur",
            value: "JA"
        },
        {
            text: "Kosi",
            value: "KO"
        },
        {
            text: "Lumbini",
            value: "LU"
        },
        {
            text: "Mahakali",
            value: "MA"
        },
        {
            text: "Mechi",
            value: "ME"
        },
        {
            text: "Narayani",
            value: "NA"
        },
        {
            text: "Rapti",
            value: "RA"
        },
        {
            text: "Sagarmatha",
            value: "SA"
        },
        {
            text: "Seti",
            value: "SE"
        }
    ],
    NL: [
        {
            text: "Drenthe",
            value: "DR"
        },
        {
            text: "Flevoland",
            value: "FL"
        },
        {
            text: "Fryslan",
            value: "FR"
        },
        {
            text: "Gelderland",
            value: "GE"
        },
        {
            text: "Groningen",
            value: "GR"
        },
        {
            text: "Limburg",
            value: "LI"
        },
        {
            text: "Noord-Brabant",
            value: "NB"
        },
        {
            text: "Noord-Holland",
            value: "NH"
        },
        {
            text: "Overijssel",
            value: "OV"
        },
        {
            text: "Utrecht",
            value: "UT"
        },
        {
            text: "Zeeland",
            value: "ZE"
        },
        {
            text: "Zuid-Holland",
            value: "ZH"
        }
    ],
    AN: [
        {
            text: "-",
            value: "01"
        }
    ],
    NC: [
        {
            text: "Province Nord",
            value: "01"
        },
        {
            text: "Province Sud",
            value: "02"
        }
    ],
    NZ: [
        {
            text: "Auckland",
            value: "AUK"
        },
        {
            text: "Bay of Plenty",
            value: "BOP"
        },
        {
            text: "Canterbury",
            value: "CAN"
        },
        {
            text: "Chatham Islands Territory",
            value: "CIT"
        },
        {
            text: "Gisborne",
            value: "GIS"
        },
        {
            text: "Hawke's Bay",
            value: "HKB"
        },
        {
            text: "Manawatu-Wanganui",
            value: "MWT"
        },
        {
            text: "Marlborough",
            value: "MBH"
        },
        {
            text: "Nelson",
            value: "NSN"
        },
        {
            text: "Northland",
            value: "NTL"
        },
        {
            text: "Otago",
            value: "OTA"
        },
        {
            text: "Southland",
            value: "STL"
        },
        {
            text: "Taranaki",
            value: "TKI"
        },
        {
            text: "Tasman",
            value: "TAS"
        },
        {
            text: "Waikato",
            value: "WKO"
        },
        {
            text: "Wellington",
            value: "WGN"
        },
        {
            text: "West Coast",
            value: "WTC"
        }
    ],
    NI: [
        {
            text: "Boaco",
            value: "BO"
        },
        {
            text: "Carazo",
            value: "CA"
        },
        {
            text: "Chinandega",
            value: "CI"
        },
        {
            text: "Chontales",
            value: "CO"
        },
        {
            text: "Costa Caribe Norte",
            value: "AN"
        },
        {
            text: "Costa Caribe Sur",
            value: "AS"
        },
        {
            text: "Esteli",
            value: "ES"
        },
        {
            text: "Granada",
            value: "GR"
        },
        {
            text: "Jinotega",
            value: "JI"
        },
        {
            text: "Leon",
            value: "LE"
        },
        {
            text: "Madriz",
            value: "MD"
        },
        {
            text: "Managua",
            value: "MN"
        },
        {
            text: "Masaya",
            value: "MS"
        },
        {
            text: "Matagalpa",
            value: "MT"
        },
        {
            text: "Nueva Segovia",
            value: "NS"
        },
        {
            text: "Rio San Juan",
            value: "SJ"
        },
        {
            text: "Rivas",
            value: "RI"
        }
    ],
    NE: [
        {
            text: "Agadez",
            value: "1"
        },
        {
            text: "Diffa",
            value: "2"
        },
        {
            text: "Dosso",
            value: "3"
        },
        {
            text: "Maradi",
            value: "4"
        },
        {
            text: "Niamey",
            value: "8"
        },
        {
            text: "Tahoua",
            value: "5"
        },
        {
            text: "Tillaberi",
            value: "6"
        },
        {
            text: "Zinder",
            value: "7"
        }
    ],
    NG: [
        {
            text: "Abia",
            value: "AB"
        },
        {
            text: "Abuja Federal Capital Territory",
            value: "FC"
        },
        {
            text: "Adamawa",
            value: "AD"
        },
        {
            text: "Akwa Ibom",
            value: "AK"
        },
        {
            text: "Anambra",
            value: "AN"
        },
        {
            text: "Bauchi",
            value: "BA"
        },
        {
            text: "Bayelsa",
            value: "BY"
        },
        {
            text: "Benue",
            value: "BE"
        },
        {
            text: "Borno",
            value: "BO"
        },
        {
            text: "Cross River",
            value: "CR"
        },
        {
            text: "Delta",
            value: "DE"
        },
        {
            text: "Ebonyi",
            value: "EB"
        },
        {
            text: "Edo",
            value: "ED"
        },
        {
            text: "Ekiti",
            value: "EK"
        },
        {
            text: "Enugu",
            value: "EN"
        },
        {
            text: "Gombe",
            value: "GO"
        },
        {
            text: "Imo",
            value: "IM"
        },
        {
            text: "Jigawa",
            value: "JI"
        },
        {
            text: "Kaduna",
            value: "KD"
        },
        {
            text: "Kano",
            value: "KN"
        },
        {
            text: "Katsina",
            value: "KT"
        },
        {
            text: "Kebbi",
            value: "KE"
        },
        {
            text: "Kogi",
            value: "KO"
        },
        {
            text: "Kwara",
            value: "KW"
        },
        {
            text: "Lagos",
            value: "LA"
        },
        {
            text: "Nasarawa",
            value: "NA"
        },
        {
            text: "Niger",
            value: "NI"
        },
        {
            text: "Ogun",
            value: "OG"
        },
        {
            text: "Ondo",
            value: "ON"
        },
        {
            text: "Osun",
            value: "OS"
        },
        {
            text: "Oyo",
            value: "OY"
        },
        {
            text: "Plateau",
            value: "PL"
        },
        {
            text: "Rivers",
            value: "RI"
        },
        {
            text: "Sokoto",
            value: "SO"
        },
        {
            text: "Taraba",
            value: "TA"
        },
        {
            text: "Yobe",
            value: "YO"
        },
        {
            text: "Zamfara",
            value: "ZA"
        }
    ],
    NU: [
        {
            text: "Niue",
            value: "01"
        }
    ],
    NF: [
        {
            text: "Norfolk Island",
            value: "01"
        }
    ],
    MP: [
        {
            text: "Northern Mariana Islands",
            value: "01"
        }
    ],
    NO: [
        {
            text: "Akershus",
            value: "02"
        },
        {
            text: "Aust-Agder",
            value: "09"
        },
        {
            text: "Buskerud",
            value: "06"
        },
        {
            text: "Finnmark",
            value: "20"
        },
        {
            text: "Hedmark",
            value: "04"
        },
        {
            text: "Hordaland",
            value: "12"
        },
        {
            text: "More og Romsdal",
            value: "15"
        },
        {
            text: "Nord-Trondelag",
            value: "17"
        },
        {
            text: "Nordland",
            value: "18"
        },
        {
            text: "Oppland",
            value: "05"
        },
        {
            text: "Oslo",
            value: "03"
        },
        {
            text: "Ostfold",
            value: "01"
        },
        {
            text: "Rogaland",
            value: "11"
        },
        {
            text: "Sogn og Fjordane",
            value: "14"
        },
        {
            text: "Sor-Trondelag",
            value: "16"
        },
        {
            text: "Telemark",
            value: "08"
        },
        {
            text: "Troms",
            value: "19"
        },
        {
            text: "Vest-Agder",
            value: "10"
        },
        {
            text: "Vestfold",
            value: "07"
        }
    ],
    OM: [
        {
            text: "Ad Dakhiliyah",
            value: "DA"
        },
        {
            text: "Al Buraymi",
            value: "BU"
        },
        {
            text: "Al Wusta",
            value: "WU"
        },
        {
            text: "Az Zahirah",
            value: "ZA"
        },
        {
            text: "Janub al Batinah",
            value: "BJ"
        },
        {
            text: "Janub ash Sharqiyah",
            value: "SJ"
        },
        {
            text: "Masqat",
            value: "MA"
        },
        {
            text: "Musandam",
            value: "MU"
        },
        {
            text: "Shamal al Batinah",
            value: "BS"
        },
        {
            text: "Shamal ash Sharqiyah",
            value: "SS"
        },
        {
            text: "Zufar",
            value: "ZU"
        }
    ],
    PK: [
        {
            text: "Azad Jammu and Kashmir",
            value: "JK"
        },
        {
            text: "Balochistan",
            value: "BA"
        },
        {
            text: "Federally Administered Tribal Areas",
            value: "TA"
        },
        {
            text: "Gilgit-Baltistan",
            value: "GB"
        },
        {
            text: "Islamabad",
            value: "IS"
        },
        {
            text: "Khyber Pakhtunkhwa",
            value: "KP"
        },
        {
            text: "Punjab",
            value: "PB"
        },
        {
            text: "Sindh",
            value: "SD"
        }
    ],
    PW: [
        {
            text: "Airai",
            value: "004"
        },
        {
            text: "Kayangel",
            value: "100"
        },
        {
            text: "Koror",
            value: "150"
        },
        {
            text: "Melekeok",
            value: "212"
        },
        {
            text: "Ngaraard",
            value: "214"
        },
        {
            text: "Ngardmau",
            value: "222"
        }
    ],
    PS: [
        {
            text: "Bethlehem",
            value: "BTH"
        },
        {
            text: "Gaza",
            value: "GZA"
        },
        {
            text: "Hebron",
            value: "HBN"
        },
        {
            text: "Jenin",
            value: "JEN"
        },
        {
            text: "Jericho and Al Aghwar",
            value: "JRH"
        },
        {
            text: "Jerusalem",
            value: "JEM"
        },
        {
            text: "Nablus",
            value: "NBS"
        },
        {
            text: "Qalqilya",
            value: "QQA"
        },
        {
            text: "Ramallah",
            value: "RBH"
        },
        {
            text: "Salfit",
            value: "SLT"
        },
        {
            text: "Tubas",
            value: "TBS"
        },
        {
            text: "Tulkarm",
            value: "TKM"
        }
    ],
    PA: [
        {
            text: "Bocas del Toro",
            value: "1"
        },
        {
            text: "Chiriqui",
            value: "4"
        },
        {
            text: "Cocle",
            value: "2"
        },
        {
            text: "Colon",
            value: "3"
        },
        {
            text: "Herrera",
            value: "6"
        },
        {
            text: "Los Santos",
            value: "7"
        },
        {
            text: "Ngobe-Bugle",
            value: "NB"
        },
        {
            text: "Panama",
            value: "8"
        },
        {
            text: "Veraguas",
            value: "9"
        }
    ],
    PG: [
        {
            text: "Bougainville",
            value: "NSB"
        },
        {
            text: "Central",
            value: "CPM"
        },
        {
            text: "Chimbu",
            value: "CPK"
        },
        {
            text: "East New Britain",
            value: "EBR"
        },
        {
            text: "Eastern Highlands",
            value: "EHG"
        },
        {
            text: "Madang",
            value: "MPM"
        },
        {
            text: "Manus",
            value: "MRL"
        },
        {
            text: "Milne Bay",
            value: "MBA"
        },
        {
            text: "Morobe",
            value: "MPL"
        },
        {
            text: "National Capital District (Port Moresby)",
            value: "NCD"
        },
        {
            text: "New Ireland",
            value: "NIK"
        },
        {
            text: "Southern Highlands",
            value: "SHM"
        },
        {
            text: "West New Britain",
            value: "WBK"
        },
        {
            text: "Western",
            value: "WPD"
        },
        {
            text: "Western Highlands",
            value: "WHM"
        }
    ],
    PY: [
        {
            text: "Alto Paraguay",
            value: "16"
        },
        {
            text: "Alto Parana",
            value: "10"
        },
        {
            text: "Amambay",
            value: "13"
        },
        {
            text: "Asuncion",
            value: "ASU"
        },
        {
            text: "Boqueron",
            value: "19"
        },
        {
            text: "Caaguazu",
            value: "5"
        },
        {
            text: "Caazapa",
            value: "6"
        },
        {
            text: "Canindeyu",
            value: "14"
        },
        {
            text: "Central",
            value: "11"
        },
        {
            text: "Concepcion",
            value: "1"
        },
        {
            text: "Cordillera",
            value: "3"
        },
        {
            text: "Guaira",
            value: "4"
        },
        {
            text: "Itapua",
            value: "7"
        },
        {
            text: "Misiones",
            value: "8"
        },
        {
            text: "Neembucu",
            value: "12"
        },
        {
            text: "Paraguari",
            value: "9"
        },
        {
            text: "Presidente Hayes",
            value: "15"
        },
        {
            text: "San Pedro",
            value: "2"
        }
    ],
    PE: [
        {
            text: "Amazonas",
            value: "AMA"
        },
        {
            text: "Ancash",
            value: "ANC"
        },
        {
            text: "Apurimac",
            value: "APU"
        },
        {
            text: "Arequipa",
            value: "ARE"
        },
        {
            text: "Ayacucho",
            value: "AYA"
        },
        {
            text: "Cajamarca",
            value: "CAJ"
        },
        {
            text: "Cusco",
            value: "CUS"
        },
        {
            text: "El Callao",
            value: "CAL"
        },
        {
            text: "Huancavelica",
            value: "HUV"
        },
        {
            text: "Huanuco",
            value: "HUC"
        },
        {
            text: "Ica",
            value: "ICA"
        },
        {
            text: "Junin",
            value: "JUN"
        },
        {
            text: "La Libertad",
            value: "LAL"
        },
        {
            text: "Lambayeque",
            value: "LAM"
        },
        {
            text: "Lima",
            value: "LIM"
        },
        {
            text: "Loreto",
            value: "LOR"
        },
        {
            text: "Madre de Dios",
            value: "MDD"
        },
        {
            text: "Moquegua",
            value: "MOQ"
        },
        {
            text: "Pasco",
            value: "PAS"
        },
        {
            text: "Piura",
            value: "PIU"
        },
        {
            text: "Puno",
            value: "PUN"
        },
        {
            text: "San Martin",
            value: "SAM"
        },
        {
            text: "Tacna",
            value: "TAC"
        },
        {
            text: "Tumbes",
            value: "TUM"
        },
        {
            text: "Ucayali",
            value: "UCA"
        }
    ],
    PH: [
        {
            text: "Abra",
            value: "ABR"
        },
        {
            text: "Agusan del Norte",
            value: "AGN"
        },
        {
            text: "Agusan del Sur",
            value: "AGS"
        },
        {
            text: "Aklan",
            value: "AKL"
        },
        {
            text: "Albay",
            value: "ALB"
        },
        {
            text: "Antique",
            value: "ANT"
        },
        {
            text: "Apayao",
            value: "APA"
        },
        {
            text: "Aurora",
            value: "AUR"
        },
        {
            text: "Basilan",
            value: "BAS"
        },
        {
            text: "Bataan",
            value: "BAN"
        },
        {
            text: "Batanes",
            value: "BTN"
        },
        {
            text: "Batangas",
            value: "BTG"
        },
        {
            text: "Benguet",
            value: "BEN"
        },
        {
            text: "Biliran",
            value: "BIL"
        },
        {
            text: "Bohol",
            value: "BOH"
        },
        {
            text: "Bukidnon",
            value: "BUK"
        },
        {
            text: "Bulacan",
            value: "BUL"
        },
        {
            text: "Cagayan",
            value: "CAG"
        },
        {
            text: "Camarines Norte",
            value: "CAN"
        },
        {
            text: "Camarines Sur",
            value: "CAS"
        },
        {
            text: "Camiguin",
            value: "CAM"
        },
        {
            text: "Capiz",
            value: "CAP"
        },
        {
            text: "Catanduanes",
            value: "CAT"
        },
        {
            text: "Cavite",
            value: "CAV"
        },
        {
            text: "Cebu",
            value: "CEB"
        },
        {
            text: "Compostela Valley",
            value: "COM"
        },
        {
            text: "Cotabato",
            value: "NCO"
        },
        {
            text: "Davao Oriental",
            value: "DAO"
        },
        {
            text: "Davao del Norte",
            value: "DAV"
        },
        {
            text: "Davao del Sur",
            value: "DAS"
        },
        {
            text: "Dinagat Islands",
            value: "DIN"
        },
        {
            text: "Eastern Samar",
            value: "EAS"
        },
        {
            text: "Guimaras",
            value: "GUI"
        },
        {
            text: "Ifugao",
            value: "IFU"
        },
        {
            text: "Ilocos Norte",
            value: "ILN"
        },
        {
            text: "Ilocos Sur",
            value: "ILS"
        },
        {
            text: "Iloilo",
            value: "ILI"
        },
        {
            text: "Isabela",
            value: "ISA"
        },
        {
            text: "Kalinga",
            value: "KAL"
        },
        {
            text: "La Union",
            value: "LUN"
        },
        {
            text: "Laguna",
            value: "LAG"
        },
        {
            text: "Lanao del Norte",
            value: "LAN"
        },
        {
            text: "Lanao del Sur",
            value: "LAS"
        },
        {
            text: "Leyte",
            value: "LEY"
        },
        {
            text: "Maguindanao",
            value: "MAG"
        },
        {
            text: "Marinduque",
            value: "MAD"
        },
        {
            text: "Masbate",
            value: "MAS"
        },
        {
            text: "Mindoro Occidental",
            value: "MDC"
        },
        {
            text: "Mindoro Oriental",
            value: "MDR"
        },
        {
            text: "Misamis Occidental",
            value: "MSC"
        },
        {
            text: "Misamis Oriental",
            value: "MSR"
        },
        {
            text: "Mountain Province",
            value: "MOU"
        },
        {
            text: "National Capital Region",
            value: "00"
        },
        {
            text: "Negros Occidental",
            value: "NEC"
        },
        {
            text: "Negros Oriental",
            value: "NER"
        },
        {
            text: "Northern Samar",
            value: "NSA"
        },
        {
            text: "Nueva Ecija",
            value: "NUE"
        },
        {
            text: "Nueva Vizcaya",
            value: "NUV"
        },
        {
            text: "Palawan",
            value: "PLW"
        },
        {
            text: "Pampanga",
            value: "PAM"
        },
        {
            text: "Pangasinan",
            value: "PAN"
        },
        {
            text: "Quezon",
            value: "QUE"
        },
        {
            text: "Quirino",
            value: "QUI"
        },
        {
            text: "Rizal",
            value: "RIZ"
        },
        {
            text: "Romblon",
            value: "ROM"
        },
        {
            text: "Samar",
            value: "WSA"
        },
        {
            text: "Sarangani",
            value: "SAR"
        },
        {
            text: "Siquijor",
            value: "SIG"
        },
        {
            text: "Sorsogon",
            value: "SOR"
        },
        {
            text: "South Cotabato",
            value: "SCO"
        },
        {
            text: "Southern Leyte",
            value: "SLE"
        },
        {
            text: "Sultan Kudarat",
            value: "SUK"
        },
        {
            text: "Sulu",
            value: "SLU"
        },
        {
            text: "Surigao del Norte",
            value: "SUN"
        },
        {
            text: "Surigao del Sur",
            value: "SUR"
        },
        {
            text: "Tarlac",
            value: "TAR"
        },
        {
            text: "Tawi-Tawi",
            value: "TAW"
        },
        {
            text: "Zambales",
            value: "ZMB"
        },
        {
            text: "Zamboanga Sibugay",
            value: "ZSI"
        },
        {
            text: "Zamboanga del Norte",
            value: "ZAN"
        },
        {
            text: "Zamboanga del Sur",
            value: "ZAS"
        }
    ],
    PN: [
        {
            text: "Pitcairn",
            value: "01"
        }
    ],
    PL: [
        {
            text: "Dolnoslaskie",
            value: "02"
        },
        {
            text: "Kujawsko-pomorskie",
            value: "04"
        },
        {
            text: "Lodzkie",
            value: "10"
        },
        {
            text: "Lubelskie",
            value: "06"
        },
        {
            text: "Lubuskie",
            value: "08"
        },
        {
            text: "Malopolskie",
            value: "12"
        },
        {
            text: "Mazowieckie",
            value: "14"
        },
        {
            text: "Opolskie",
            value: "16"
        },
        {
            text: "Podkarpackie",
            value: "18"
        },
        {
            text: "Podlaskie",
            value: "20"
        },
        {
            text: "Pomorskie",
            value: "22"
        },
        {
            text: "Slaskie",
            value: "24"
        },
        {
            text: "Swietokrzyskie",
            value: "26"
        },
        {
            text: "Warminsko-mazurskie",
            value: "28"
        },
        {
            text: "Wielkopolskie",
            value: "30"
        },
        {
            text: "Zachodniopomorskie",
            value: "32"
        }
    ],
    PT: [
        {
            text: "Aveiro",
            value: "01"
        },
        {
            text: "Beja",
            value: "02"
        },
        {
            text: "Braga",
            value: "03"
        },
        {
            text: "Braganca",
            value: "04"
        },
        {
            text: "Castelo Branco",
            value: "05"
        },
        {
            text: "Coimbra",
            value: "06"
        },
        {
            text: "Evora",
            value: "07"
        },
        {
            text: "Faro",
            value: "08"
        },
        {
            text: "Guarda",
            value: "09"
        },
        {
            text: "Leiria",
            value: "10"
        },
        {
            text: "Lisboa",
            value: "11"
        },
        {
            text: "Portalegre",
            value: "12"
        },
        {
            text: "Porto",
            value: "13"
        },
        {
            text: "Regiao Autonoma da Madeira",
            value: "30"
        },
        {
            text: "Regiao Autonoma dos Acores",
            value: "20"
        },
        {
            text: "Santarem",
            value: "14"
        },
        {
            text: "Setubal",
            value: "15"
        },
        {
            text: "Viana do Castelo",
            value: "16"
        },
        {
            text: "Vila Real",
            value: "17"
        },
        {
            text: "Viseu",
            value: "18"
        }
    ],
    PR: [
        {
            text: "Adjuntas",
            value: "01"
        },
        {
            text: "Aguada",
            value: "02"
        },
        {
            text: "Aguadilla",
            value: "03"
        },
        {
            text: "Aguas Buenas",
            value: "04"
        },
        {
            text: "Aibonito",
            value: "05"
        },
        {
            text: "Anasco",
            value: "06"
        },
        {
            text: "Arecibo",
            value: "07"
        },
        {
            text: "Arroyo",
            value: "08"
        },
        {
            text: "Barceloneta",
            value: "09"
        },
        {
            text: "Barranquitas",
            value: "10"
        },
        {
            text: "Bayamon",
            value: "11"
        },
        {
            text: "Cabo Rojo",
            value: "12"
        },
        {
            text: "Caguas",
            value: "13"
        },
        {
            text: "Camuy",
            value: "14"
        },
        {
            text: "Canovanas",
            value: "15"
        },
        {
            text: "Carolina",
            value: "16"
        },
        {
            text: "Catano",
            value: "17"
        },
        {
            text: "Cayey",
            value: "18"
        },
        {
            text: "Ceiba",
            value: "19"
        },
        {
            text: "Ciales",
            value: "20"
        },
        {
            text: "Cidra",
            value: "21"
        },
        {
            text: "Coamo",
            value: "22"
        },
        {
            text: "Comerio",
            value: "23"
        },
        {
            text: "Corozal",
            value: "24"
        },
        {
            text: "Culebra",
            value: "25"
        },
        {
            text: "Dorado",
            value: "26"
        },
        {
            text: "Fajardo",
            value: "27"
        },
        {
            text: "Florida",
            value: "28"
        },
        {
            text: "Guanica",
            value: "29"
        },
        {
            text: "Guayama",
            value: "30"
        },
        {
            text: "Guayanilla",
            value: "31"
        },
        {
            text: "Guaynabo",
            value: "32"
        },
        {
            text: "Gurabo",
            value: "33"
        },
        {
            text: "Hatillo",
            value: "34"
        },
        {
            text: "Hormigueros",
            value: "35"
        },
        {
            text: "Humacao",
            value: "36"
        },
        {
            text: "Isabela",
            value: "37"
        },
        {
            text: "Juana Diaz",
            value: "38"
        },
        {
            text: "Lajas",
            value: "39"
        },
        {
            text: "Lares",
            value: "40"
        },
        {
            text: "Las Marias",
            value: "41"
        },
        {
            text: "Las Piedras",
            value: "42"
        },
        {
            text: "Loiza",
            value: "43"
        },
        {
            text: "Luquillo",
            value: "44"
        },
        {
            text: "Manati",
            value: "45"
        },
        {
            text: "Maricao",
            value: "46"
        },
        {
            text: "Mayaguez",
            value: "47"
        },
        {
            text: "Moca",
            value: "48"
        },
        {
            text: "Morovis",
            value: "49"
        },
        {
            text: "Municipio de Jayuya",
            value: "50"
        },
        {
            text: "Municipio de Juncos",
            value: "51"
        },
        {
            text: "Naguabo",
            value: "52"
        },
        {
            text: "Naranjito",
            value: "53"
        },
        {
            text: "Patillas",
            value: "54"
        },
        {
            text: "Penuelas",
            value: "55"
        },
        {
            text: "Ponce",
            value: "56"
        },
        {
            text: "Quebradillas",
            value: "57"
        },
        {
            text: "Rincon",
            value: "58"
        },
        {
            text: "Rio Grande",
            value: "59"
        },
        {
            text: "Sabana Grande",
            value: "60"
        },
        {
            text: "Salinas",
            value: "61"
        },
        {
            text: "San German",
            value: "62"
        },
        {
            text: "San Juan",
            value: "63"
        },
        {
            text: "San Lorenzo",
            value: "64"
        },
        {
            text: "San Sebastian",
            value: "65"
        },
        {
            text: "Santa Isabel Municipio",
            value: "66"
        },
        {
            text: "Toa Alta",
            value: "67"
        },
        {
            text: "Toa Baja",
            value: "68"
        },
        {
            text: "Trujillo Alto",
            value: "69"
        },
        {
            text: "Utuado",
            value: "70"
        },
        {
            text: "Vega Alta",
            value: "71"
        },
        {
            text: "Vega Baja",
            value: "72"
        },
        {
            text: "Vieques",
            value: "73"
        },
        {
            text: "Villalba",
            value: "74"
        },
        {
            text: "Yabucoa",
            value: "75"
        },
        {
            text: "Yauco",
            value: "76"
        }
    ],
    QA: [
        {
            text: "Ad Dawhah",
            value: "DA"
        },
        {
            text: "Al Khawr wa adh Dhakhirah",
            value: "KH"
        },
        {
            text: "Al Wakrah",
            value: "WA"
        },
        {
            text: "Ar Rayyan",
            value: "RA"
        },
        {
            text: "Ash Shamal",
            value: "MS"
        },
        {
            text: "Az Za'ayin",
            value: "ZA"
        },
        {
            text: "Umm Salal",
            value: "US"
        }
    ],
    RE: [
        {
            text: "Reunion",
            value: "01"
        }
    ],
    RO: [
        {
            text: "Alba",
            value: "AB"
        },
        {
            text: "Arad",
            value: "AR"
        },
        {
            text: "Arges",
            value: "AG"
        },
        {
            text: "Bacau",
            value: "BC"
        },
        {
            text: "Bihor",
            value: "BH"
        },
        {
            text: "Bistrita-Nasaud",
            value: "BN"
        },
        {
            text: "Botosani",
            value: "BT"
        },
        {
            text: "Braila",
            value: "BR"
        },
        {
            text: "Brasov",
            value: "BV"
        },
        {
            text: "Bucuresti",
            value: "B"
        },
        {
            text: "Buzau",
            value: "BZ"
        },
        {
            text: "Calarasi",
            value: "CL"
        },
        {
            text: "Caras-Severin",
            value: "CS"
        },
        {
            text: "Cluj",
            value: "CJ"
        },
        {
            text: "Constanta",
            value: "CT"
        },
        {
            text: "Covasna",
            value: "CV"
        },
        {
            text: "Dambovita",
            value: "DB"
        },
        {
            text: "Dolj",
            value: "DJ"
        },
        {
            text: "Galati",
            value: "GL"
        },
        {
            text: "Giurgiu",
            value: "GR"
        },
        {
            text: "Gorj",
            value: "GJ"
        },
        {
            text: "Harghita",
            value: "HR"
        },
        {
            text: "Hunedoara",
            value: "HD"
        },
        {
            text: "Ialomita",
            value: "IL"
        },
        {
            text: "Iasi",
            value: "IS"
        },
        {
            text: "Ilfov",
            value: "IF"
        },
        {
            text: "Maramures",
            value: "MM"
        },
        {
            text: "Mehedinti",
            value: "MH"
        },
        {
            text: "Mures",
            value: "MS"
        },
        {
            text: "Neamt",
            value: "NT"
        },
        {
            text: "Olt",
            value: "OT"
        },
        {
            text: "Prahova",
            value: "PH"
        },
        {
            text: "Salaj",
            value: "SJ"
        },
        {
            text: "Satu Mare",
            value: "SM"
        },
        {
            text: "Sibiu",
            value: "SB"
        },
        {
            text: "Suceava",
            value: "SV"
        },
        {
            text: "Teleorman",
            value: "TR"
        },
        {
            text: "Timis",
            value: "TM"
        },
        {
            text: "Tulcea",
            value: "TL"
        },
        {
            text: "Valcea",
            value: "VL"
        },
        {
            text: "Vaslui",
            value: "VS"
        },
        {
            text: "Vrancea",
            value: "VN"
        }
    ],
    RU: [
        {
            text: "Adygeya, Respublika",
            value: "AD"
        },
        {
            text: "Altay, Respublika",
            value: "AL"
        },
        {
            text: "Altayskiy kray",
            value: "ALT"
        },
        {
            text: "Amurskaya oblast'",
            value: "AMU"
        },
        {
            text: "Arkhangel'skaya oblast'",
            value: "ARK"
        },
        {
            text: "Astrakhanskaya oblast'",
            value: "AST"
        },
        {
            text: "Bashkortostan, Respublika",
            value: "BA"
        },
        {
            text: "Belgorodskaya oblast'",
            value: "BEL"
        },
        {
            text: "Bryanskaya oblast'",
            value: "BRY"
        },
        {
            text: "Buryatiya, Respublika",
            value: "BU"
        },
        {
            text: "Chechenskaya Respublika",
            value: "CE"
        },
        {
            text: "Chelyabinskaya oblast'",
            value: "CHE"
        },
        {
            text: "Chukotskiy avtonomnyy okrug",
            value: "CHU"
        },
        {
            text: "Chuvashskaya Respublika",
            value: "CU"
        },
        {
            text: "Dagestan, Respublika",
            value: "DA"
        },
        {
            text: "Ingushetiya, Respublika",
            value: "IN"
        },
        {
            text: "Irkutskaya oblast'",
            value: "IRK"
        },
        {
            text: "Ivanovskaya oblast'",
            value: "IVA"
        },
        {
            text: "Kabardino-Balkarskaya Respublika",
            value: "KB"
        },
        {
            text: "Kaliningradskaya oblast'",
            value: "KGD"
        },
        {
            text: "Kalmykiya, Respublika",
            value: "KL"
        },
        {
            text: "Kaluzhskaya oblast'",
            value: "KLU"
        },
        {
            text: "Kamchatskiy kray",
            value: "KAM"
        },
        {
            text: "Karachayevo-Cherkesskaya Respublika",
            value: "KC"
        },
        {
            text: "Kareliya, Respublika",
            value: "KR"
        },
        {
            text: "Kemerovskaya oblast'",
            value: "KEM"
        },
        {
            text: "Khabarovskiy kray",
            value: "KHA"
        },
        {
            text: "Khakasiya, Respublika",
            value: "KK"
        },
        {
            text: "Khanty-Mansiyskiy avtonomnyy okrug",
            value: "KHM"
        },
        {
            text: "Kirovskaya oblast'",
            value: "KIR"
        },
        {
            text: "Komi, Respublika",
            value: "KO"
        },
        {
            text: "Kostromskaya oblast'",
            value: "KOS"
        },
        {
            text: "Krasnodarskiy kray",
            value: "KDA"
        },
        {
            text: "Krasnoyarskiy kray",
            value: "KYA"
        },
        {
            text: "Kurganskaya oblast'",
            value: "KGN"
        },
        {
            text: "Kurskaya oblast'",
            value: "KRS"
        },
        {
            text: "Leningradskaya oblast'",
            value: "LEN"
        },
        {
            text: "Lipetskaya oblast'",
            value: "LIP"
        },
        {
            text: "Magadanskaya oblast'",
            value: "MAG"
        },
        {
            text: "Mariy El, Respublika",
            value: "ME"
        },
        {
            text: "Mordoviya, Respublika",
            value: "MO"
        },
        {
            text: "Moskovskaya oblast'",
            value: "MOS"
        },
        {
            text: "Moskva",
            value: "MOW"
        },
        {
            text: "Murmanskaya oblast'",
            value: "MUR"
        },
        {
            text: "Nenetskiy avtonomnyy okrug",
            value: "NEN"
        },
        {
            text: "Nizhegorodskaya oblast'",
            value: "NIZ"
        },
        {
            text: "Novgorodskaya oblast'",
            value: "NGR"
        },
        {
            text: "Novosibirskaya oblast'",
            value: "NVS"
        },
        {
            text: "Omskaya oblast'",
            value: "OMS"
        },
        {
            text: "Orenburgskaya oblast'",
            value: "ORE"
        },
        {
            text: "Orlovskaya oblast'",
            value: "ORL"
        },
        {
            text: "Penzenskaya oblast'",
            value: "PNZ"
        },
        {
            text: "Permskiy kray",
            value: "PER"
        },
        {
            text: "Primorskiy kray",
            value: "PRI"
        },
        {
            text: "Pskovskaya oblast'",
            value: "PSK"
        },
        {
            text: "Rostovskaya oblast'",
            value: "ROS"
        },
        {
            text: "Ryazanskaya oblast'",
            value: "RYA"
        },
        {
            text: "Saha, Respublika",
            value: "SA"
        },
        {
            text: "Sakhalinskaya oblast'",
            value: "SAK"
        },
        {
            text: "Samarskaya oblast'",
            value: "SAM"
        },
        {
            text: "Sankt-Peterburg",
            value: "SPE"
        },
        {
            text: "Saratovskaya oblast'",
            value: "SAR"
        },
        {
            text: "Severnaya Osetiya, Respublika",
            value: "SE"
        },
        {
            text: "Smolenskaya oblast'",
            value: "SMO"
        },
        {
            text: "Stavropol'skiy kray",
            value: "STA"
        },
        {
            text: "Sverdlovskaya oblast'",
            value: "SVE"
        },
        {
            text: "Tambovskaya oblast'",
            value: "TAM"
        },
        {
            text: "Tatarstan, Respublika",
            value: "TA"
        },
        {
            text: "Tomskaya oblast'",
            value: "TOM"
        },
        {
            text: "Tul'skaya oblast'",
            value: "TUL"
        },
        {
            text: "Tverskaya oblast'",
            value: "TVE"
        },
        {
            text: "Tyumenskaya oblast'",
            value: "TYU"
        },
        {
            text: "Tyva, Respublika",
            value: "TY"
        },
        {
            text: "Udmurtskaya Respublika",
            value: "UD"
        },
        {
            text: "Ul'yanovskaya oblast'",
            value: "ULY"
        },
        {
            text: "Vladimirskaya oblast'",
            value: "VLA"
        },
        {
            text: "Volgogradskaya oblast'",
            value: "VGG"
        },
        {
            text: "Vologodskaya oblast'",
            value: "VLG"
        },
        {
            text: "Voronezhskaya oblast'",
            value: "VOR"
        },
        {
            text: "Yamalo-Nenetskiy avtonomnyy okrug",
            value: "YAN"
        },
        {
            text: "Yaroslavskaya oblast'",
            value: "YAR"
        },
        {
            text: "Yevreyskaya avtonomnaya oblast'",
            value: "YEV"
        },
        {
            text: "Zabaykal'skiy kray",
            value: "ZAB"
        }
    ],
    RW: [
        {
            text: "Est",
            value: "02"
        },
        {
            text: "Nord",
            value: "03"
        },
        {
            text: "Ouest",
            value: "04"
        },
        {
            text: "Sud",
            value: "05"
        },
        {
            text: "Ville de Kigali",
            value: "01"
        }
    ],
    BL: [
        {
            text: "Saint Barthelemy",
            value: "01"
        }
    ],
    SH: [
        {
            text: "Saint Helena",
            value: "HL"
        }
    ],
    KN: [
        {
            text: "Saint Anne Sandy Point",
            value: "02"
        },
        {
            text: "Saint George Basseterre",
            value: "03"
        },
        {
            text: "Saint James Windward",
            value: "05"
        },
        {
            text: "Saint John Capisterre",
            value: "06"
        },
        {
            text: "Saint John Figtree",
            value: "07"
        },
        {
            text: "Saint Mary Cayon",
            value: "08"
        },
        {
            text: "Saint Paul Capisterre",
            value: "09"
        },
        {
            text: "Saint Paul Charlestown",
            value: "10"
        },
        {
            text: "Saint Peter Basseterre",
            value: "11"
        },
        {
            text: "Saint Thomas Lowland",
            value: "12"
        },
        {
            text: "Saint Thomas Middle Island",
            value: "13"
        }
    ],
    LC: [
        {
            text: "Anse la Raye",
            value: "01"
        },
        {
            text: "Castries",
            value: "02"
        },
        {
            text: "Dennery",
            value: "05"
        },
        {
            text: "Gros Islet",
            value: "06"
        },
        {
            text: "Laborie",
            value: "07"
        },
        {
            text: "Micoud",
            value: "08"
        },
        {
            text: "Soufriere",
            value: "10"
        },
        {
            text: "Vieux Fort",
            value: "11"
        }
    ],
    MF: [
        {
            text: "Saint Martin (French Part)",
            value: "01"
        }
    ],
    PM: [
        {
            text: "Saint Pierre and Miquelon",
            value: "01"
        }
    ],
    VC: [
        {
            text: "Charlotte",
            value: "01"
        },
        {
            text: "Grenadines",
            value: "06"
        },
        {
            text: "Saint David",
            value: "03"
        },
        {
            text: "Saint George",
            value: "04"
        },
        {
            text: "Saint Patrick",
            value: "05"
        }
    ],
    WS: [
        {
            text: "Fa'asaleleaga",
            value: "FA"
        },
        {
            text: "Tuamasaga",
            value: "TU"
        }
    ],
    SM: [
        {
            text: "Domagnano",
            value: "03"
        },
        {
            text: "San Marino",
            value: "07"
        },
        {
            text: "Serravalle",
            value: "09"
        }
    ],
    ST: [
        {
            text: "Principe",
            value: "P"
        },
        {
            text: "Sao Tome",
            value: "S"
        }
    ],
    SA: [
        {
            text: "'Asir",
            value: "14"
        },
        {
            text: "Al Bahah",
            value: "11"
        },
        {
            text: "Al Hudud ash Shamaliyah",
            value: "08"
        },
        {
            text: "Al Jawf",
            value: "12"
        },
        {
            text: "Al Madinah al Munawwarah",
            value: "03"
        },
        {
            text: "Al Qasim",
            value: "05"
        },
        {
            text: "Ar Riyad",
            value: "01"
        },
        {
            text: "Ash Sharqiyah",
            value: "04"
        },
        {
            text: "Ha'il",
            value: "06"
        },
        {
            text: "Jazan",
            value: "09"
        },
        {
            text: "Makkah al Mukarramah",
            value: "02"
        },
        {
            text: "Najran",
            value: "10"
        },
        {
            text: "Tabuk",
            value: "07"
        }
    ],
    SN: [
        {
            text: "Dakar",
            value: "DK"
        },
        {
            text: "Diourbel",
            value: "DB"
        },
        {
            text: "Fatick",
            value: "FK"
        },
        {
            text: "Kaffrine",
            value: "KA"
        },
        {
            text: "Kaolack",
            value: "KL"
        },
        {
            text: "Kolda",
            value: "KD"
        },
        {
            text: "Louga",
            value: "LG"
        },
        {
            text: "Matam",
            value: "MT"
        },
        {
            text: "Saint-Louis",
            value: "SL"
        },
        {
            text: "Tambacounda",
            value: "TC"
        },
        {
            text: "Thies",
            value: "TH"
        },
        {
            text: "Ziguinchor",
            value: "ZG"
        }
    ],
    RS: [
        {
            text: "Beograd",
            value: "00"
        },
        {
            text: "Borski okrug",
            value: "14"
        },
        {
            text: "Branicevski okrug",
            value: "11"
        },
        {
            text: "Jablanicki okrug",
            value: "23"
        },
        {
            text: "Juznobacki okrug",
            value: "06"
        },
        {
            text: "Juznobanatski okrug",
            value: "04"
        },
        {
            text: "Kolubarski okrug",
            value: "09"
        },
        {
            text: "Kosovsko-Mitrovacki okrug",
            value: "28"
        },
        {
            text: "Macvanski okrug",
            value: "08"
        },
        {
            text: "Moravicki okrug",
            value: "17"
        },
        {
            text: "Nisavski okrug",
            value: "20"
        },
        {
            text: "Pcinjski okrug",
            value: "24"
        },
        {
            text: "Pecki okrug",
            value: "26"
        },
        {
            text: "Pirotski okrug",
            value: "22"
        },
        {
            text: "Podunavski okrug",
            value: "10"
        },
        {
            text: "Pomoravski okrug",
            value: "13"
        },
        {
            text: "Prizrenski okrug",
            value: "27"
        },
        {
            text: "Rasinski okrug",
            value: "19"
        },
        {
            text: "Raski okrug",
            value: "18"
        },
        {
            text: "Severnobacki okrug",
            value: "01"
        },
        {
            text: "Severnobanatski okrug",
            value: "03"
        },
        {
            text: "Srednjebanatski okrug",
            value: "02"
        },
        {
            text: "Sremski okrug",
            value: "07"
        },
        {
            text: "Sumadijski okrug",
            value: "12"
        },
        {
            text: "Toplicki okrug",
            value: "21"
        },
        {
            text: "Zajecarski okrug",
            value: "15"
        },
        {
            text: "Zapadnobacki okrug",
            value: "05"
        },
        {
            text: "Zlatiborski okrug",
            value: "16"
        }
    ],
    SC: [
        {
            text: "Anse Boileau",
            value: "02"
        },
        {
            text: "Anse aux Pins",
            value: "01"
        },
        {
            text: "Baie Lazare",
            value: "06"
        },
        {
            text: "Beau Vallon",
            value: "08"
        },
        {
            text: "Bel Ombre",
            value: "10"
        },
        {
            text: "Cascade",
            value: "11"
        },
        {
            text: "English River",
            value: "16"
        },
        {
            text: "Grand Anse Mahe",
            value: "13"
        },
        {
            text: "La Digue",
            value: "15"
        },
        {
            text: "Pointe Larue",
            value: "20"
        },
        {
            text: "Port Glaud",
            value: "21"
        },
        {
            text: "Takamaka",
            value: "23"
        }
    ],
    SL: [
        {
            text: "Eastern",
            value: "E"
        },
        {
            text: "Northern",
            value: "N"
        },
        {
            text: "Western Area",
            value: "W"
        }
    ],
    SG: [
        {
            text: "Singapore",
            value: "01"
        }
    ],
    SK: [
        {
            text: "Banskobystricky kraj",
            value: "BC"
        },
        {
            text: "Bratislavsky kraj",
            value: "BL"
        },
        {
            text: "Kosicky kraj",
            value: "KI"
        },
        {
            text: "Nitriansky kraj",
            value: "NI"
        },
        {
            text: "Presovsky kraj",
            value: "PV"
        },
        {
            text: "Trenciansky kraj",
            value: "TC"
        },
        {
            text: "Trnavsky kraj",
            value: "TA"
        },
        {
            text: "Zilinsky kraj",
            value: "ZI"
        }
    ],
    SI: [
        {
            text: "Ajdovscina",
            value: "001"
        },
        {
            text: "Apace",
            value: "195"
        },
        {
            text: "Beltinci",
            value: "002"
        },
        {
            text: "Benedikt",
            value: "148"
        },
        {
            text: "Bistrica ob Sotli",
            value: "149"
        },
        {
            text: "Bled",
            value: "003"
        },
        {
            text: "Bloke",
            value: "150"
        },
        {
            text: "Bohinj",
            value: "004"
        },
        {
            text: "Borovnica",
            value: "005"
        },
        {
            text: "Bovec",
            value: "006"
        },
        {
            text: "Braslovce",
            value: "151"
        },
        {
            text: "Brda",
            value: "007"
        },
        {
            text: "Brezice",
            value: "009"
        },
        {
            text: "Brezovica",
            value: "008"
        },
        {
            text: "Cankova",
            value: "152"
        },
        {
            text: "Celje",
            value: "011"
        },
        {
            text: "Cerklje na Gorenjskem",
            value: "012"
        },
        {
            text: "Cerknica",
            value: "013"
        },
        {
            text: "Cerkno",
            value: "014"
        },
        {
            text: "Cirkulane",
            value: "196"
        },
        {
            text: "Crensovci",
            value: "015"
        },
        {
            text: "Crnomelj",
            value: "017"
        },
        {
            text: "Destrnik",
            value: "018"
        },
        {
            text: "Divaca",
            value: "019"
        },
        {
            text: "Dobje",
            value: "154"
        },
        {
            text: "Dobrepolje",
            value: "020"
        },
        {
            text: "Dobrna",
            value: "155"
        },
        {
            text: "Dobrova-Polhov Gradec",
            value: "021"
        },
        {
            text: "Dobrovnik",
            value: "156"
        },
        {
            text: "Domzale",
            value: "023"
        },
        {
            text: "Dornava",
            value: "024"
        },
        {
            text: "Dravograd",
            value: "025"
        },
        {
            text: "Duplek",
            value: "026"
        },
        {
            text: "Gorje",
            value: "207"
        },
        {
            text: "Gornja Radgona",
            value: "029"
        },
        {
            text: "Gornji Petrovci",
            value: "031"
        },
        {
            text: "Grad",
            value: "158"
        },
        {
            text: "Grosuplje",
            value: "032"
        },
        {
            text: "Hajdina",
            value: "159"
        },
        {
            text: "Hoce-Slivnica",
            value: "160"
        },
        {
            text: "Hodos",
            value: "161"
        },
        {
            text: "Horjul",
            value: "162"
        },
        {
            text: "Hrastnik",
            value: "034"
        },
        {
            text: "Hrpelje-Kozina",
            value: "035"
        },
        {
            text: "Idrija",
            value: "036"
        },
        {
            text: "Ig",
            value: "037"
        },
        {
            text: "Ilirska Bistrica",
            value: "038"
        },
        {
            text: "Ivancna Gorica",
            value: "039"
        },
        {
            text: "Izola",
            value: "040"
        },
        {
            text: "Jesenice",
            value: "041"
        },
        {
            text: "Jursinci",
            value: "042"
        },
        {
            text: "Kamnik",
            value: "043"
        },
        {
            text: "Kanal",
            value: "044"
        },
        {
            text: "Kidricevo",
            value: "045"
        },
        {
            text: "Kobarid",
            value: "046"
        },
        {
            text: "Kobilje",
            value: "047"
        },
        {
            text: "Kocevje",
            value: "048"
        },
        {
            text: "Komen",
            value: "049"
        },
        {
            text: "Komenda",
            value: "164"
        },
        {
            text: "Koper",
            value: "050"
        },
        {
            text: "Kosanjevica na Krki",
            value: "197"
        },
        {
            text: "Kostel",
            value: "165"
        },
        {
            text: "Kranj",
            value: "052"
        },
        {
            text: "Kranjska Gora",
            value: "053"
        },
        {
            text: "Krizevci",
            value: "166"
        },
        {
            text: "Krsko",
            value: "054"
        },
        {
            text: "Kungota",
            value: "055"
        },
        {
            text: "Kuzma",
            value: "056"
        },
        {
            text: "Lasko",
            value: "057"
        },
        {
            text: "Lenart",
            value: "058"
        },
        {
            text: "Lendava",
            value: "059"
        },
        {
            text: "Litija",
            value: "060"
        },
        {
            text: "Ljubljana",
            value: "061"
        },
        {
            text: "Ljutomer",
            value: "063"
        },
        {
            text: "Log-Dragomer",
            value: "208"
        },
        {
            text: "Logatec",
            value: "064"
        },
        {
            text: "Loska Dolina",
            value: "065"
        },
        {
            text: "Lovrenc na Pohorju",
            value: "167"
        },
        {
            text: "Luce",
            value: "067"
        },
        {
            text: "Lukovica",
            value: "068"
        },
        {
            text: "Majsperk",
            value: "069"
        },
        {
            text: "Makole",
            value: "198"
        },
        {
            text: "Maribor",
            value: "070"
        },
        {
            text: "Markovci",
            value: "168"
        },
        {
            text: "Medvode",
            value: "071"
        },
        {
            text: "Menges",
            value: "072"
        },
        {
            text: "Metlika",
            value: "073"
        },
        {
            text: "Mezica",
            value: "074"
        },
        {
            text: "Miklavz na Dravskem Polju",
            value: "169"
        },
        {
            text: "Miren-Kostanjevica",
            value: "075"
        },
        {
            text: "Mirna Pec",
            value: "170"
        },
        {
            text: "Mislinja",
            value: "076"
        },
        {
            text: "Mokronog-Trebelno",
            value: "199"
        },
        {
            text: "Moravce",
            value: "077"
        },
        {
            text: "Mozirje",
            value: "079"
        },
        {
            text: "Murska Sobota",
            value: "080"
        },
        {
            text: "Muta",
            value: "081"
        },
        {
            text: "Naklo",
            value: "082"
        },
        {
            text: "Nazarje",
            value: "083"
        },
        {
            text: "Nova Gorica",
            value: "084"
        },
        {
            text: "Novo Mesto",
            value: "085"
        },
        {
            text: "Odranci",
            value: "086"
        },
        {
            text: "Oplotnica",
            value: "171"
        },
        {
            text: "Ormoz",
            value: "087"
        },
        {
            text: "Piran",
            value: "090"
        },
        {
            text: "Pivka",
            value: "091"
        },
        {
            text: "Podcetrtek",
            value: "092"
        },
        {
            text: "Podlehnik",
            value: "172"
        },
        {
            text: "Poljcane",
            value: "200"
        },
        {
            text: "Polzela",
            value: "173"
        },
        {
            text: "Postojna",
            value: "094"
        },
        {
            text: "Prebold",
            value: "174"
        },
        {
            text: "Preddvor",
            value: "095"
        },
        {
            text: "Prevalje",
            value: "175"
        },
        {
            text: "Ptuj",
            value: "096"
        },
        {
            text: "Puconci",
            value: "097"
        },
        {
            text: "Race-Fram",
            value: "098"
        },
        {
            text: "Radece",
            value: "099"
        },
        {
            text: "Radenci",
            value: "100"
        },
        {
            text: "Radlje ob Dravi",
            value: "101"
        },
        {
            text: "Radovljica",
            value: "102"
        },
        {
            text: "Ravne na Koroskem",
            value: "103"
        },
        {
            text: "Razkrizje",
            value: "176"
        },
        {
            text: "Recica ob Savinji",
            value: "209"
        },
        {
            text: "Rence-Vogrsko",
            value: "201"
        },
        {
            text: "Ribnica",
            value: "104"
        },
        {
            text: "Rogaska Slatina",
            value: "106"
        },
        {
            text: "Rogasovci",
            value: "105"
        },
        {
            text: "Ruse",
            value: "108"
        },
        {
            text: "Salovci",
            value: "033"
        },
        {
            text: "Semic",
            value: "109"
        },
        {
            text: "Sempeter-Vrtojba",
            value: "183"
        },
        {
            text: "Sencur",
            value: "117"
        },
        {
            text: "Sentilj",
            value: "118"
        },
        {
            text: "Sentjernej",
            value: "119"
        },
        {
            text: "Sentjur",
            value: "120"
        },
        {
            text: "Sentrupert",
            value: "211"
        },
        {
            text: "Sevnica",
            value: "110"
        },
        {
            text: "Sezana",
            value: "111"
        },
        {
            text: "Skocjan",
            value: "121"
        },
        {
            text: "Skofja Loka",
            value: "122"
        },
        {
            text: "Skofljica",
            value: "123"
        },
        {
            text: "Slovenj Gradec",
            value: "112"
        },
        {
            text: "Slovenska Bistrica",
            value: "113"
        },
        {
            text: "Slovenske Konjice",
            value: "114"
        },
        {
            text: "Smarje pri Jelsah",
            value: "124"
        },
        {
            text: "Smarjeske Toplice",
            value: "206"
        },
        {
            text: "Smartno ob Paki",
            value: "125"
        },
        {
            text: "Smartno pri Litiji",
            value: "194"
        },
        {
            text: "Sodrazica",
            value: "179"
        },
        {
            text: "Solcava",
            value: "180"
        },
        {
            text: "Sostanj",
            value: "126"
        },
        {
            text: "Starse",
            value: "115"
        },
        {
            text: "Store",
            value: "127"
        },
        {
            text: "Straza",
            value: "203"
        },
        {
            text: "Sveta Trojica v Slovenskih Goricah",
            value: "204"
        },
        {
            text: "Sveti Andraz v Slovenskih Goricah",
            value: "182"
        },
        {
            text: "Sveti Jurij",
            value: "116"
        },
        {
            text: "Sveti Jurij v Slovenskih Goricah",
            value: "210"
        },
        {
            text: "Sveti Tomaz",
            value: "205"
        },
        {
            text: "Tabor",
            value: "184"
        },
        {
            text: "Tisina",
            value: "010"
        },
        {
            text: "Tolmin",
            value: "128"
        },
        {
            text: "Trbovlje",
            value: "129"
        },
        {
            text: "Trebnje",
            value: "130"
        },
        {
            text: "Trnovska Vas",
            value: "185"
        },
        {
            text: "Trzic",
            value: "131"
        },
        {
            text: "Trzin",
            value: "186"
        },
        {
            text: "Turnisce",
            value: "132"
        },
        {
            text: "Velenje",
            value: "133"
        },
        {
            text: "Velika Polana",
            value: "187"
        },
        {
            text: "Velike Lasce",
            value: "134"
        },
        {
            text: "Verzej",
            value: "188"
        },
        {
            text: "Videm",
            value: "135"
        },
        {
            text: "Vipava",
            value: "136"
        },
        {
            text: "Vitanje",
            value: "137"
        },
        {
            text: "Vodice",
            value: "138"
        },
        {
            text: "Vojnik",
            value: "139"
        },
        {
            text: "Vransko",
            value: "189"
        },
        {
            text: "Vrhnika",
            value: "140"
        },
        {
            text: "Vuzenica",
            value: "141"
        },
        {
            text: "Zagorje ob Savi",
            value: "142"
        },
        {
            text: "Zalec",
            value: "190"
        },
        {
            text: "Zavrc",
            value: "143"
        },
        {
            text: "Zelezniki",
            value: "146"
        },
        {
            text: "Zetale",
            value: "191"
        },
        {
            text: "Ziri",
            value: "147"
        },
        {
            text: "Zrece",
            value: "144"
        },
        {
            text: "Zuzemberk",
            value: "193"
        }
    ],
    SB: [
        {
            text: "Choiseul",
            value: "CH"
        },
        {
            text: "Guadalcanal",
            value: "GU"
        }
    ],
    SO: [
        {
            text: "Awdal",
            value: "AW"
        },
        {
            text: "Banaadir",
            value: "BN"
        },
        {
            text: "Bay",
            value: "BY"
        },
        {
            text: "Nugaal",
            value: "NU"
        },
        {
            text: "Shabeellaha Hoose",
            value: "SH"
        },
        {
            text: "Togdheer",
            value: "TO"
        },
        {
            text: "Woqooyi Galbeed",
            value: "WO"
        }
    ],
    ZA: [
        {
            text: "Eastern Cape",
            value: "EC"
        },
        {
            text: "Free State",
            value: "FS"
        },
        {
            text: "Gauteng",
            value: "GP"
        },
        {
            text: "Kwazulu-Natal",
            value: "KZN"
        },
        {
            text: "Limpopo",
            value: "LP"
        },
        {
            text: "Mpumalanga",
            value: "MP"
        },
        {
            text: "North-West",
            value: "NW"
        },
        {
            text: "Northern Cape",
            value: "NC"
        },
        {
            text: "Western Cape",
            value: "WC"
        }
    ],
    GS: [
        {
            text: "South Georgia and the South Sandwich Islands",
            value: "01"
        }
    ],
    SS: [
        {
            text: "Central Equatoria",
            value: "EC"
        },
        {
            text: "Eastern Equatoria",
            value: "EE"
        },
        {
            text: "Northern Bahr el Ghazal",
            value: "BN"
        },
        {
            text: "Unity",
            value: "UY"
        },
        {
            text: "Upper Nile",
            value: "NU"
        },
        {
            text: "Western Equatoria",
            value: "EW"
        }
    ],
    ES: [
        {
            text: "Andalucia",
            value: "AN"
        },
        {
            text: "Aragon",
            value: "AR"
        },
        {
            text: "Asturias, Principado de",
            value: "AS"
        },
        {
            text: "Canarias",
            value: "CN"
        },
        {
            text: "Cantabria",
            value: "CB"
        },
        {
            text: "Castilla y Leon",
            value: "CL"
        },
        {
            text: "Castilla-La Mancha",
            value: "CM"
        },
        {
            text: "Catalunya",
            value: "CT"
        },
        {
            text: "Ceuta",
            value: "CE"
        },
        {
            text: "Extremadura",
            value: "EX"
        },
        {
            text: "Galicia",
            value: "GA"
        },
        {
            text: "Illes Balears",
            value: "IB"
        },
        {
            text: "La Rioja",
            value: "RI"
        },
        {
            text: "Madrid, Comunidad de",
            value: "MD"
        },
        {
            text: "Melilla",
            value: "ML"
        },
        {
            text: "Murcia, Region de",
            value: "MC"
        },
        {
            text: "Navarra, Comunidad Foral de",
            value: "NC"
        },
        {
            text: "Pais Vasco",
            value: "PV"
        },
        {
            text: "Valenciana, Comunidad",
            value: "VC"
        }
    ],
    LK: [
        {
            text: "Central Province",
            value: "2"
        },
        {
            text: "Eastern Province",
            value: "5"
        },
        {
            text: "North Central Province",
            value: "7"
        },
        {
            text: "North Western Province",
            value: "6"
        },
        {
            text: "Northern Province",
            value: "4"
        },
        {
            text: "Sabaragamuwa Province",
            value: "9"
        },
        {
            text: "Southern Province",
            value: "3"
        },
        {
            text: "Uva Province",
            value: "8"
        },
        {
            text: "Western Province",
            value: "1"
        }
    ],
    SD: [
        {
            text: "Blue Nile",
            value: "NB"
        },
        {
            text: "Gedaref",
            value: "GD"
        },
        {
            text: "Gezira",
            value: "GZ"
        },
        {
            text: "Kassala",
            value: "KA"
        },
        {
            text: "Khartoum",
            value: "KH"
        },
        {
            text: "North Darfur",
            value: "DN"
        },
        {
            text: "Northern",
            value: "NO"
        },
        {
            text: "Red Sea",
            value: "RS"
        },
        {
            text: "River Nile",
            value: "NR"
        },
        {
            text: "Sennar",
            value: "SI"
        },
        {
            text: "South Darfur",
            value: "DS"
        },
        {
            text: "South Kordofan",
            value: "KS"
        },
        {
            text: "West Darfur",
            value: "DW"
        },
        {
            text: "White Nile",
            value: "NW"
        }
    ],
    SR: [
        {
            text: "Brokopondo",
            value: "BR"
        },
        {
            text: "Commewijne",
            value: "CM"
        },
        {
            text: "Nickerie",
            value: "NI"
        },
        {
            text: "Para",
            value: "PR"
        },
        {
            text: "Paramaribo",
            value: "PM"
        },
        {
            text: "Saramacca",
            value: "SA"
        },
        {
            text: "Sipaliwini",
            value: "SI"
        },
        {
            text: "Wanica",
            value: "WA"
        }
    ],
    SJ: [
        {
            text: "Svalbard and Jan Mayen",
            value: "01"
        }
    ],
    SZ: [
        {
            text: "Hhohho",
            value: "HH"
        },
        {
            text: "Lubombo",
            value: "LU"
        },
        {
            text: "Manzini",
            value: "MA"
        }
    ],
    SE: [
        {
            text: "Blekinge lan",
            value: "K"
        },
        {
            text: "Dalarnas lan",
            value: "W"
        },
        {
            text: "Gavleborgs lan",
            value: "X"
        },
        {
            text: "Gotlands lan",
            value: "I"
        },
        {
            text: "Hallands lan",
            value: "N"
        },
        {
            text: "Jamtlands lan",
            value: "Z"
        },
        {
            text: "Jonkopings lan",
            value: "F"
        },
        {
            text: "Kalmar lan",
            value: "H"
        },
        {
            text: "Kronobergs lan",
            value: "G"
        },
        {
            text: "Norrbottens lan",
            value: "BD"
        },
        {
            text: "Orebro lan",
            value: "T"
        },
        {
            text: "Ostergotlands lan",
            value: "E"
        },
        {
            text: "Skane lan",
            value: "M"
        },
        {
            text: "Sodermanlands lan",
            value: "D"
        },
        {
            text: "Stockholms lan",
            value: "AB"
        },
        {
            text: "Uppsala lan",
            value: "C"
        },
        {
            text: "Varmlands lan",
            value: "S"
        },
        {
            text: "Vasterbottens lan",
            value: "AC"
        },
        {
            text: "Vasternorrlands lan",
            value: "Y"
        },
        {
            text: "Vastmanlands lan",
            value: "U"
        },
        {
            text: "Vastra Gotalands lan",
            value: "O"
        }
    ],
    CH: [
        {
            text: "Aargau",
            value: "AG"
        },
        {
            text: "Appenzell Ausserrhoden",
            value: "AR"
        },
        {
            text: "Appenzell Innerrhoden",
            value: "AI"
        },
        {
            text: "Basel-Landschaft",
            value: "BL"
        },
        {
            text: "Basel-Stadt",
            value: "BS"
        },
        {
            text: "Bern",
            value: "BE"
        },
        {
            text: "Fribourg",
            value: "FR"
        },
        {
            text: "Geneve",
            value: "GE"
        },
        {
            text: "Glarus",
            value: "GL"
        },
        {
            text: "Graubunden",
            value: "GR"
        },
        {
            text: "Jura",
            value: "JU"
        },
        {
            text: "Luzern",
            value: "LU"
        },
        {
            text: "Neuchatel",
            value: "NE"
        },
        {
            text: "Nidwalden",
            value: "NW"
        },
        {
            text: "Obwalden",
            value: "OW"
        },
        {
            text: "Sankt Gallen",
            value: "SG"
        },
        {
            text: "Schaffhausen",
            value: "SH"
        },
        {
            text: "Schwyz",
            value: "SZ"
        },
        {
            text: "Solothurn",
            value: "SO"
        },
        {
            text: "Thurgau",
            value: "TG"
        },
        {
            text: "Ticino",
            value: "TI"
        },
        {
            text: "Uri",
            value: "UR"
        },
        {
            text: "Valais",
            value: "VS"
        },
        {
            text: "Vaud",
            value: "VD"
        },
        {
            text: "Zug",
            value: "ZG"
        },
        {
            text: "Zurich",
            value: "ZH"
        }
    ],
    SY: [
        {
            text: "Al Hasakah",
            value: "HA"
        },
        {
            text: "Al Ladhiqiyah",
            value: "LA"
        },
        {
            text: "Al Qunaytirah",
            value: "QU"
        },
        {
            text: "Ar Raqqah",
            value: "RA"
        },
        {
            text: "As Suwayda'",
            value: "SU"
        },
        {
            text: "Dar'a",
            value: "DR"
        },
        {
            text: "Dayr az Zawr",
            value: "DY"
        },
        {
            text: "Dimashq",
            value: "DI"
        },
        {
            text: "Halab",
            value: "HL"
        },
        {
            text: "Hamah",
            value: "HM"
        },
        {
            text: "Hims",
            value: "HI"
        },
        {
            text: "Idlib",
            value: "ID"
        },
        {
            text: "Rif Dimashq",
            value: "RD"
        },
        {
            text: "Tartus",
            value: "TA"
        }
    ],
    TW: [
        {
            text: "Changhua",
            value: "CHA"
        },
        {
            text: "Chiayi",
            value: "CYQ"
        },
        {
            text: "Hsinchu",
            value: "HSQ"
        },
        {
            text: "Hualien",
            value: "HUA"
        },
        {
            text: "Kaohsiung",
            value: "KHH"
        },
        {
            text: "Keelung",
            value: "KEE"
        },
        {
            text: "Kinmen",
            value: "KIN"
        },
        {
            text: "Lienchiang",
            value: "LIE"
        },
        {
            text: "Miaoli",
            value: "MIA"
        },
        {
            text: "Nantou",
            value: "NAN"
        },
        {
            text: "New Taipei",
            value: "NWT"
        },
        {
            text: "Penghu",
            value: "PEN"
        },
        {
            text: "Pingtung",
            value: "PIF"
        },
        {
            text: "Taichung",
            value: "TXG"
        },
        {
            text: "Tainan",
            value: "TNN"
        },
        {
            text: "Taipei",
            value: "TPE"
        },
        {
            text: "Taitung",
            value: "TTT"
        },
        {
            text: "Taoyuan",
            value: "TAO"
        },
        {
            text: "Yilan",
            value: "ILA"
        },
        {
            text: "Yunlin",
            value: "YUN"
        }
    ],
    TJ: [
        {
            text: "Dushanbe",
            value: "DU"
        },
        {
            text: "Khatlon",
            value: "KT"
        },
        {
            text: "Kuhistoni Badakhshon",
            value: "GB"
        },
        {
            text: "Nohiyahoi Tobei Jumhuri",
            value: "RA"
        },
        {
            text: "Sughd",
            value: "SU"
        }
    ],
    TZ: [
        {
            text: "Arusha",
            value: "01"
        },
        {
            text: "Dar es Salaam",
            value: "02"
        },
        {
            text: "Dodoma",
            value: "03"
        },
        {
            text: "Geita",
            value: "27"
        },
        {
            text: "Iringa",
            value: "04"
        },
        {
            text: "Kagera",
            value: "05"
        },
        {
            text: "Kaskazini Unguja",
            value: "07"
        },
        {
            text: "Katavi",
            value: "28"
        },
        {
            text: "Kigoma",
            value: "08"
        },
        {
            text: "Kilimanjaro",
            value: "09"
        },
        {
            text: "Kusini Pemba",
            value: "10"
        },
        {
            text: "Kusini Unguja",
            value: "11"
        },
        {
            text: "Lindi",
            value: "12"
        },
        {
            text: "Manyara",
            value: "26"
        },
        {
            text: "Mara",
            value: "13"
        },
        {
            text: "Mbeya",
            value: "14"
        },
        {
            text: "Mjini Magharibi",
            value: "15"
        },
        {
            text: "Morogoro",
            value: "16"
        },
        {
            text: "Mtwara",
            value: "17"
        },
        {
            text: "Mwanza",
            value: "18"
        },
        {
            text: "Njombe",
            value: "29"
        },
        {
            text: "Pwani",
            value: "19"
        },
        {
            text: "Rukwa",
            value: "20"
        },
        {
            text: "Ruvuma",
            value: "21"
        },
        {
            text: "Shinyanga",
            value: "22"
        },
        {
            text: "Simiyu",
            value: "30"
        },
        {
            text: "Singida",
            value: "23"
        },
        {
            text: "Tabora",
            value: "24"
        },
        {
            text: "Tanga",
            value: "25"
        }
    ],
    TH: [
        {
            text: "Amnat Charoen",
            value: "37"
        },
        {
            text: "Ang Thong",
            value: "15"
        },
        {
            text: "Bueng Kan",
            value: "38"
        },
        {
            text: "Buri Ram",
            value: "31"
        },
        {
            text: "Chachoengsao",
            value: "24"
        },
        {
            text: "Chai Nat",
            value: "18"
        },
        {
            text: "Chaiyaphum",
            value: "36"
        },
        {
            text: "Chanthaburi",
            value: "22"
        },
        {
            text: "Chiang Mai",
            value: "50"
        },
        {
            text: "Chiang Rai",
            value: "57"
        },
        {
            text: "Chon Buri",
            value: "20"
        },
        {
            text: "Chumphon",
            value: "86"
        },
        {
            text: "Kalasin",
            value: "46"
        },
        {
            text: "Kamphaeng Phet",
            value: "62"
        },
        {
            text: "Kanchanaburi",
            value: "71"
        },
        {
            text: "Khon Kaen",
            value: "40"
        },
        {
            text: "Krabi",
            value: "81"
        },
        {
            text: "Krung Thep Maha Nakhon",
            value: "10"
        },
        {
            text: "Lampang",
            value: "52"
        },
        {
            text: "Lamphun",
            value: "51"
        },
        {
            text: "Loei",
            value: "42"
        },
        {
            text: "Lop Buri",
            value: "16"
        },
        {
            text: "Mae Hong Son",
            value: "58"
        },
        {
            text: "Maha Sarakham",
            value: "44"
        },
        {
            text: "Mukdahan",
            value: "49"
        },
        {
            text: "Nakhon Nayok",
            value: "26"
        },
        {
            text: "Nakhon Pathom",
            value: "73"
        },
        {
            text: "Nakhon Phanom",
            value: "48"
        },
        {
            text: "Nakhon Ratchasima",
            value: "30"
        },
        {
            text: "Nakhon Sawan",
            value: "60"
        },
        {
            text: "Nakhon Si Thammarat",
            value: "80"
        },
        {
            text: "Nan",
            value: "55"
        },
        {
            text: "Narathiwat",
            value: "96"
        },
        {
            text: "Nong Bua Lam Phu",
            value: "39"
        },
        {
            text: "Nong Khai",
            value: "43"
        },
        {
            text: "Nonthaburi",
            value: "12"
        },
        {
            text: "Pathum Thani",
            value: "13"
        },
        {
            text: "Pattani",
            value: "94"
        },
        {
            text: "Phangnga",
            value: "82"
        },
        {
            text: "Phatthalung",
            value: "93"
        },
        {
            text: "Phayao",
            value: "56"
        },
        {
            text: "Phetchabun",
            value: "67"
        },
        {
            text: "Phetchaburi",
            value: "76"
        },
        {
            text: "Phichit",
            value: "66"
        },
        {
            text: "Phitsanulok",
            value: "65"
        },
        {
            text: "Phra Nakhon Si Ayutthaya",
            value: "14"
        },
        {
            text: "Phrae",
            value: "54"
        },
        {
            text: "Phuket",
            value: "83"
        },
        {
            text: "Prachin Buri",
            value: "25"
        },
        {
            text: "Prachuap Khiri Khan",
            value: "77"
        },
        {
            text: "Ranong",
            value: "85"
        },
        {
            text: "Ratchaburi",
            value: "70"
        },
        {
            text: "Rayong",
            value: "21"
        },
        {
            text: "Roi Et",
            value: "45"
        },
        {
            text: "Sa Kaeo",
            value: "27"
        },
        {
            text: "Sakon Nakhon",
            value: "47"
        },
        {
            text: "Samut Prakan",
            value: "11"
        },
        {
            text: "Samut Sakhon",
            value: "74"
        },
        {
            text: "Samut Songkhram",
            value: "75"
        },
        {
            text: "Saraburi",
            value: "19"
        },
        {
            text: "Satun",
            value: "91"
        },
        {
            text: "Si Sa Ket",
            value: "33"
        },
        {
            text: "Sing Buri",
            value: "17"
        },
        {
            text: "Songkhla",
            value: "90"
        },
        {
            text: "Sukhothai",
            value: "64"
        },
        {
            text: "Suphan Buri",
            value: "72"
        },
        {
            text: "Surat Thani",
            value: "84"
        },
        {
            text: "Surin",
            value: "32"
        },
        {
            text: "Tak",
            value: "63"
        },
        {
            text: "Trang",
            value: "92"
        },
        {
            text: "Trat",
            value: "23"
        },
        {
            text: "Ubon Ratchathani",
            value: "34"
        },
        {
            text: "Udon Thani",
            value: "41"
        },
        {
            text: "Uthai Thani",
            value: "61"
        },
        {
            text: "Uttaradit",
            value: "53"
        },
        {
            text: "Yala",
            value: "95"
        },
        {
            text: "Yasothon",
            value: "35"
        }
    ],
    TL: [
        {
            text: "Ainaro",
            value: "AN"
        },
        {
            text: "Cova Lima",
            value: "CO"
        },
        {
            text: "Dili",
            value: "DI"
        }
    ],
    TG: [
        {
            text: "Centrale",
            value: "C"
        },
        {
            text: "Kara",
            value: "K"
        },
        {
            text: "Maritime",
            value: "M"
        },
        {
            text: "Plateaux",
            value: "P"
        }
    ],
    TK: [
        {
            text: "Tokelau",
            value: "01"
        }
    ],
    TO: [
        {
            text: "Niuas",
            value: "03"
        },
        {
            text: "Tongatapu",
            value: "04"
        }
    ],
    TT: [
        {
            text: "Arima",
            value: "ARI"
        },
        {
            text: "Chaguanas",
            value: "CHA"
        },
        {
            text: "Couva-Tabaquite-Talparo",
            value: "CTT"
        },
        {
            text: "Diego Martin",
            value: "DMN"
        },
        {
            text: "Mayaro-Rio Claro",
            value: "MRC"
        },
        {
            text: "Penal-Debe",
            value: "PED"
        },
        {
            text: "Point Fortin",
            value: "PTF"
        },
        {
            text: "Port of Spain",
            value: "POS"
        },
        {
            text: "Princes Town",
            value: "PRT"
        },
        {
            text: "San Fernando",
            value: "SFO"
        },
        {
            text: "San Juan-Laventille",
            value: "SJL"
        },
        {
            text: "Sangre Grande",
            value: "SGE"
        },
        {
            text: "Siparia",
            value: "SIP"
        },
        {
            text: "Tobago",
            value: "TOB"
        },
        {
            text: "Tunapuna-Piarco",
            value: "TUP"
        }
    ],
    TN: [
        {
            text: "Beja",
            value: "31"
        },
        {
            text: "Ben Arous",
            value: "13"
        },
        {
            text: "Bizerte",
            value: "23"
        },
        {
            text: "Gabes",
            value: "81"
        },
        {
            text: "Gafsa",
            value: "71"
        },
        {
            text: "Jendouba",
            value: "32"
        },
        {
            text: "Kairouan",
            value: "41"
        },
        {
            text: "Kasserine",
            value: "42"
        },
        {
            text: "Kebili",
            value: "73"
        },
        {
            text: "L'Ariana",
            value: "12"
        },
        {
            text: "La Manouba",
            value: "14"
        },
        {
            text: "Le Kef",
            value: "33"
        },
        {
            text: "Mahdia",
            value: "53"
        },
        {
            text: "Medenine",
            value: "82"
        },
        {
            text: "Monastir",
            value: "52"
        },
        {
            text: "Nabeul",
            value: "21"
        },
        {
            text: "Sfax",
            value: "61"
        },
        {
            text: "Sidi Bouzid",
            value: "43"
        },
        {
            text: "Siliana",
            value: "34"
        },
        {
            text: "Sousse",
            value: "51"
        },
        {
            text: "Tataouine",
            value: "83"
        },
        {
            text: "Tozeur",
            value: "72"
        },
        {
            text: "Tunis",
            value: "11"
        },
        {
            text: "Zaghouan",
            value: "22"
        }
    ],
    TR: [
        {
            text: "Adana",
            value: "01"
        },
        {
            text: "Adiyaman",
            value: "02"
        },
        {
            text: "Afyonkarahisar",
            value: "03"
        },
        {
            text: "Agri",
            value: "04"
        },
        {
            text: "Aksaray",
            value: "68"
        },
        {
            text: "Amasya",
            value: "05"
        },
        {
            text: "Ankara",
            value: "06"
        },
        {
            text: "Antalya",
            value: "07"
        },
        {
            text: "Ardahan",
            value: "75"
        },
        {
            text: "Artvin",
            value: "08"
        },
        {
            text: "Aydin",
            value: "09"
        },
        {
            text: "Balikesir",
            value: "10"
        },
        {
            text: "Bartin",
            value: "74"
        },
        {
            text: "Batman",
            value: "72"
        },
        {
            text: "Bayburt",
            value: "69"
        },
        {
            text: "Bilecik",
            value: "11"
        },
        {
            text: "Bingol",
            value: "12"
        },
        {
            text: "Bitlis",
            value: "13"
        },
        {
            text: "Bolu",
            value: "14"
        },
        {
            text: "Burdur",
            value: "15"
        },
        {
            text: "Bursa",
            value: "16"
        },
        {
            text: "Canakkale",
            value: "17"
        },
        {
            text: "Cankiri",
            value: "18"
        },
        {
            text: "Corum",
            value: "19"
        },
        {
            text: "Denizli",
            value: "20"
        },
        {
            text: "Diyarbakir",
            value: "21"
        },
        {
            text: "Duzce",
            value: "81"
        },
        {
            text: "Edirne",
            value: "22"
        },
        {
            text: "Elazig",
            value: "23"
        },
        {
            text: "Erzincan",
            value: "24"
        },
        {
            text: "Erzurum",
            value: "25"
        },
        {
            text: "Eskisehir",
            value: "26"
        },
        {
            text: "Gaziantep",
            value: "27"
        },
        {
            text: "Giresun",
            value: "28"
        },
        {
            text: "Gumushane",
            value: "29"
        },
        {
            text: "Hakkari",
            value: "30"
        },
        {
            text: "Hatay",
            value: "31"
        },
        {
            text: "Igdir",
            value: "76"
        },
        {
            text: "Isparta",
            value: "32"
        },
        {
            text: "Istanbul",
            value: "34"
        },
        {
            text: "Izmir",
            value: "35"
        },
        {
            text: "Kahramanmaras",
            value: "46"
        },
        {
            text: "Karabuk",
            value: "78"
        },
        {
            text: "Karaman",
            value: "70"
        },
        {
            text: "Kars",
            value: "36"
        },
        {
            text: "Kastamonu",
            value: "37"
        },
        {
            text: "Kayseri",
            value: "38"
        },
        {
            text: "Kilis",
            value: "79"
        },
        {
            text: "Kirikkale",
            value: "71"
        },
        {
            text: "Kirklareli",
            value: "39"
        },
        {
            text: "Kirsehir",
            value: "40"
        },
        {
            text: "Kocaeli",
            value: "41"
        },
        {
            text: "Konya",
            value: "42"
        },
        {
            text: "Kutahya",
            value: "43"
        },
        {
            text: "Malatya",
            value: "44"
        },
        {
            text: "Manisa",
            value: "45"
        },
        {
            text: "Mardin",
            value: "47"
        },
        {
            text: "Mersin",
            value: "33"
        },
        {
            text: "Mugla",
            value: "48"
        },
        {
            text: "Mus",
            value: "49"
        },
        {
            text: "Nevsehir",
            value: "50"
        },
        {
            text: "Nigde",
            value: "51"
        },
        {
            text: "Ordu",
            value: "52"
        },
        {
            text: "Osmaniye",
            value: "80"
        },
        {
            text: "Rize",
            value: "53"
        },
        {
            text: "Sakarya",
            value: "54"
        },
        {
            text: "Samsun",
            value: "55"
        },
        {
            text: "Sanliurfa",
            value: "63"
        },
        {
            text: "Siirt",
            value: "56"
        },
        {
            text: "Sinop",
            value: "57"
        },
        {
            text: "Sirnak",
            value: "73"
        },
        {
            text: "Sivas",
            value: "58"
        },
        {
            text: "Tekirdag",
            value: "59"
        },
        {
            text: "Tokat",
            value: "60"
        },
        {
            text: "Trabzon",
            value: "61"
        },
        {
            text: "Tunceli",
            value: "62"
        },
        {
            text: "Usak",
            value: "64"
        },
        {
            text: "Van",
            value: "65"
        },
        {
            text: "Yalova",
            value: "77"
        },
        {
            text: "Yozgat",
            value: "66"
        },
        {
            text: "Zonguldak",
            value: "67"
        }
    ],
    TM: [
        {
            text: "Ahal",
            value: "A"
        },
        {
            text: "Balkan",
            value: "B"
        },
        {
            text: "Dasoguz",
            value: "D"
        },
        {
            text: "Lebap",
            value: "L"
        },
        {
            text: "Mary",
            value: "M"
        }
    ],
    TC: [
        {
            text: "Turks and Caicos Islands",
            value: "01"
        }
    ],
    TV: [
        {
            text: "Funafuti",
            value: "FUN"
        }
    ],
    UG: [
        {
            text: "Amuru",
            value: "316"
        },
        {
            text: "Arua",
            value: "303"
        },
        {
            text: "Bugiri",
            value: "201"
        },
        {
            text: "Buikwe",
            value: "117"
        },
        {
            text: "Bukedea",
            value: "219"
        },
        {
            text: "Buliisa",
            value: "416"
        },
        {
            text: "Buvuma",
            value: "120"
        },
        {
            text: "Gulu",
            value: "304"
        },
        {
            text: "Hoima",
            value: "403"
        },
        {
            text: "Iganga",
            value: "203"
        },
        {
            text: "Jinja",
            value: "204"
        },
        {
            text: "Kabale",
            value: "404"
        },
        {
            text: "Kabarole",
            value: "405"
        },
        {
            text: "Kalangala",
            value: "101"
        },
        {
            text: "Kaliro",
            value: "222"
        },
        {
            text: "Kalungu",
            value: "122"
        },
        {
            text: "Kampala",
            value: "102"
        },
        {
            text: "Kamuli",
            value: "205"
        },
        {
            text: "Kasese",
            value: "406"
        },
        {
            text: "Kayunga",
            value: "112"
        },
        {
            text: "Kibaale",
            value: "407"
        },
        {
            text: "Kiboga",
            value: "103"
        },
        {
            text: "Kiruhura",
            value: "419"
        },
        {
            text: "Kitgum",
            value: "305"
        },
        {
            text: "Kumi",
            value: "208"
        },
        {
            text: "Kyenjojo",
            value: "415"
        },
        {
            text: "Lira",
            value: "307"
        },
        {
            text: "Luwero",
            value: "104"
        },
        {
            text: "Masaka",
            value: "105"
        },
        {
            text: "Mayuge",
            value: "214"
        },
        {
            text: "Mbale",
            value: "209"
        },
        {
            text: "Mbarara",
            value: "410"
        },
        {
            text: "Mityana",
            value: "115"
        },
        {
            text: "Mpigi",
            value: "106"
        },
        {
            text: "Mukono",
            value: "108"
        },
        {
            text: "Nakaseke",
            value: "116"
        },
        {
            text: "Nwoya",
            value: "328"
        },
        {
            text: "Oyam",
            value: "321"
        },
        {
            text: "Pallisa",
            value: "210"
        },
        {
            text: "Rukungiri",
            value: "412"
        },
        {
            text: "Sironko",
            value: "215"
        },
        {
            text: "Soroti",
            value: "211"
        },
        {
            text: "Wakiso",
            value: "113"
        }
    ],
    UA: [
        {
            text: "Avtonomna Respublika Krym",
            value: "43"
        },
        {
            text: "Cherkaska oblast",
            value: "71"
        },
        {
            text: "Chernihivska oblast",
            value: "74"
        },
        {
            text: "Chernivetska oblast",
            value: "77"
        },
        {
            text: "Dnipropetrovska oblast",
            value: "12"
        },
        {
            text: "Donetska oblast",
            value: "14"
        },
        {
            text: "Ivano-Frankivska oblast",
            value: "26"
        },
        {
            text: "Kharkivska oblast",
            value: "63"
        },
        {
            text: "Khersonska oblast",
            value: "65"
        },
        {
            text: "Khmelnytska oblast",
            value: "68"
        },
        {
            text: "Kirovohradska oblast",
            value: "35"
        },
        {
            text: "Kyiv",
            value: "30"
        },
        {
            text: "Kyivska oblast",
            value: "32"
        },
        {
            text: "Luhanska oblast",
            value: "09"
        },
        {
            text: "Lvivska oblast",
            value: "46"
        },
        {
            text: "Mykolaivska oblast",
            value: "48"
        },
        {
            text: "Odeska oblast",
            value: "51"
        },
        {
            text: "Poltavska oblast",
            value: "53"
        },
        {
            text: "Rivnenska oblast",
            value: "56"
        },
        {
            text: "Sevastopol",
            value: "40"
        },
        {
            text: "Sumska oblast",
            value: "59"
        },
        {
            text: "Ternopilska oblast",
            value: "61"
        },
        {
            text: "Vinnytska oblast",
            value: "05"
        },
        {
            text: "Volynska oblast",
            value: "07"
        },
        {
            text: "Zakarpatska oblast",
            value: "21"
        },
        {
            text: "Zaporizka oblast",
            value: "23"
        },
        {
            text: "Zhytomyrska oblast",
            value: "18"
        }
    ],
    AE: [
        {
            text: "'Ajman",
            value: "AJ"
        },
        {
            text: "Abu Zaby",
            value: "AZ"
        },
        {
            text: "Al Fujayrah",
            value: "FU"
        },
        {
            text: "Ash Shariqah",
            value: "SH"
        },
        {
            text: "Dubayy",
            value: "DU"
        },
        {
            text: "Ra's al Khaymah",
            value: "RK"
        },
        {
            text: "Umm al Qaywayn",
            value: "UQ"
        }
    ],
    GB: [
        {
            text: "England",
            value: "ENG"
        },
        {
            text: "Northern Ireland",
            value: "NIR"
        },
        {
            text: "Scotland",
            value: "SCT"
        },
        {
            text: "Wales",
            value: "WLS"
        }
    ],
    US: [
        {
            text: "Alabama",
            value: "AL"
        },
        {
            text: "Alaska",
            value: "AK"
        },
        {
            text: "Arizona",
            value: "AZ"
        },
        {
            text: "Arkansas",
            value: "AR"
        },
        {
            text: "California",
            value: "CA"
        },
        {
            text: "Colorado",
            value: "CO"
        },
        {
            text: "Connecticut",
            value: "CT"
        },
        {
            text: "Delaware",
            value: "DE"
        },
        {
            text: "District of Columbia",
            value: "DC"
        },
        {
            text: "Florida",
            value: "FL"
        },
        {
            text: "Georgia",
            value: "GA"
        },
        {
            text: "Hawaii",
            value: "HI"
        },
        {
            text: "Idaho",
            value: "ID"
        },
        {
            text: "Illinois",
            value: "IL"
        },
        {
            text: "Indiana",
            value: "IN"
        },
        {
            text: "Iowa",
            value: "IA"
        },
        {
            text: "Kansas",
            value: "KS"
        },
        {
            text: "Kentucky",
            value: "KY"
        },
        {
            text: "Louisiana",
            value: "LA"
        },
        {
            text: "Maine",
            value: "ME"
        },
        {
            text: "Maryland",
            value: "MD"
        },
        {
            text: "Massachusetts",
            value: "MA"
        },
        {
            text: "Michigan",
            value: "MI"
        },
        {
            text: "Minnesota",
            value: "MN"
        },
        {
            text: "Mississippi",
            value: "MS"
        },
        {
            text: "Missouri",
            value: "MO"
        },
        {
            text: "Montana",
            value: "MT"
        },
        {
            text: "Nebraska",
            value: "NE"
        },
        {
            text: "Nevada",
            value: "NV"
        },
        {
            text: "New Hampshire",
            value: "NH"
        },
        {
            text: "New Jersey",
            value: "NJ"
        },
        {
            text: "New Mexico",
            value: "NM"
        },
        {
            text: "New York",
            value: "NY"
        },
        {
            text: "North Carolina",
            value: "NC"
        },
        {
            text: "North Dakota",
            value: "ND"
        },
        {
            text: "Ohio",
            value: "OH"
        },
        {
            text: "Oklahoma",
            value: "OK"
        },
        {
            text: "Oregon",
            value: "OR"
        },
        {
            text: "Pennsylvania",
            value: "PA"
        },
        {
            text: "Rhode Island",
            value: "RI"
        },
        {
            text: "South Carolina",
            value: "SC"
        },
        {
            text: "South Dakota",
            value: "SD"
        },
        {
            text: "Tennessee",
            value: "TN"
        },
        {
            text: "Texas",
            value: "TX"
        },
        {
            text: "Utah",
            value: "UT"
        },
        {
            text: "Vermont",
            value: "VT"
        },
        {
            text: "Virginia",
            value: "VA"
        },
        {
            text: "Washington",
            value: "WA"
        },
        {
            text: "West Virginia",
            value: "WV"
        },
        {
            text: "Wisconsin",
            value: "WI"
        },
        {
            text: "Wyoming",
            value: "WY"
        },
        {
            text: "Armed Forces Americas",
            value: "AA"
        },
        {
            text: "Armed Forces Europe",
            value: "AE"
        },
        {
            text: "Armed Forces Pacific",
            value: "AP"
        }
    ],
    UM: [
        {
            text: "Palmyra Atoll",
            value: "95"
        }
    ],
    UY: [
        {
            text: "Artigas",
            value: "AR"
        },
        {
            text: "Canelones",
            value: "CA"
        },
        {
            text: "Cerro Largo",
            value: "CL"
        },
        {
            text: "Colonia",
            value: "CO"
        },
        {
            text: "Durazno",
            value: "DU"
        },
        {
            text: "Flores",
            value: "FS"
        },
        {
            text: "Florida",
            value: "FD"
        },
        {
            text: "Lavalleja",
            value: "LA"
        },
        {
            text: "Maldonado",
            value: "MA"
        },
        {
            text: "Montevideo",
            value: "MO"
        },
        {
            text: "Paysandu",
            value: "PA"
        },
        {
            text: "Rio Negro",
            value: "RN"
        },
        {
            text: "Rivera",
            value: "RV"
        },
        {
            text: "Rocha",
            value: "RO"
        },
        {
            text: "Salto",
            value: "SA"
        },
        {
            text: "San Jose",
            value: "SJ"
        },
        {
            text: "Soriano",
            value: "SO"
        },
        {
            text: "Tacuarembo",
            value: "TA"
        },
        {
            text: "Treinta y Tres",
            value: "TT"
        }
    ],
    UZ: [
        {
            text: "Andijon",
            value: "AN"
        },
        {
            text: "Buxoro",
            value: "BU"
        },
        {
            text: "Farg'ona",
            value: "FA"
        },
        {
            text: "Jizzax",
            value: "JI"
        },
        {
            text: "Namangan",
            value: "NG"
        },
        {
            text: "Navoiy",
            value: "NW"
        },
        {
            text: "Qashqadaryo",
            value: "QA"
        },
        {
            text: "Qoraqalpog'iston Respublikasi",
            value: "QR"
        },
        {
            text: "Samarqand",
            value: "SA"
        },
        {
            text: "Sirdaryo",
            value: "SI"
        },
        {
            text: "Surxondaryo",
            value: "SU"
        },
        {
            text: "Toshkent",
            value: "TK"
        },
        {
            text: "Xorazm",
            value: "XO"
        }
    ],
    VU: [
        {
            text: "Shefa",
            value: "SEE"
        },
        {
            text: "Tafea",
            value: "TAE"
        },
        {
            text: "Torba",
            value: "TOB"
        }
    ],
    VE: [
        {
            text: "Amazonas",
            value: "Z"
        },
        {
            text: "Anzoategui",
            value: "B"
        },
        {
            text: "Apure",
            value: "C"
        },
        {
            text: "Aragua",
            value: "D"
        },
        {
            text: "Barinas",
            value: "E"
        },
        {
            text: "Bolivar",
            value: "F"
        },
        {
            text: "Carabobo",
            value: "G"
        },
        {
            text: "Cojedes",
            value: "H"
        },
        {
            text: "Delta Amacuro",
            value: "Y"
        },
        {
            text: "Distrito Capital",
            value: "A"
        },
        {
            text: "Falcon",
            value: "I"
        },
        {
            text: "Guarico",
            value: "J"
        },
        {
            text: "Lara",
            value: "K"
        },
        {
            text: "Merida",
            value: "L"
        },
        {
            text: "Miranda",
            value: "M"
        },
        {
            text: "Monagas",
            value: "N"
        },
        {
            text: "Nueva Esparta",
            value: "O"
        },
        {
            text: "Portuguesa",
            value: "P"
        },
        {
            text: "Sucre",
            value: "R"
        },
        {
            text: "Tachira",
            value: "S"
        },
        {
            text: "Trujillo",
            value: "T"
        },
        {
            text: "Vargas",
            value: "X"
        },
        {
            text: "Yaracuy",
            value: "U"
        },
        {
            text: "Zulia",
            value: "V"
        }
    ],
    VN: [
        {
            text: "An Giang",
            value: "44"
        },
        {
            text: "Ba Ria - Vung Tau",
            value: "43"
        },
        {
            text: "Bac Giang",
            value: "54"
        },
        {
            text: "Bac Kan",
            value: "53"
        },
        {
            text: "Bac Lieu",
            value: "55"
        },
        {
            text: "Bac Ninh",
            value: "56"
        },
        {
            text: "Ben Tre",
            value: "50"
        },
        {
            text: "Binh Dinh",
            value: "31"
        },
        {
            text: "Binh Duong",
            value: "57"
        },
        {
            text: "Binh Phuoc",
            value: "58"
        },
        {
            text: "Binh Thuan",
            value: "40"
        },
        {
            text: "Ca Mau",
            value: "59"
        },
        {
            text: "Can Tho",
            value: "CT"
        },
        {
            text: "Cao Bang",
            value: "04"
        },
        {
            text: "Da Nang",
            value: "DN"
        },
        {
            text: "Dak Lak",
            value: "33"
        },
        {
            text: "Dak Nong",
            value: "72"
        },
        {
            text: "Dien Bien",
            value: "71"
        },
        {
            text: "Dong Nai",
            value: "39"
        },
        {
            text: "Dong Thap",
            value: "45"
        },
        {
            text: "Gia Lai",
            value: "30"
        },
        {
            text: "Ha Giang",
            value: "03"
        },
        {
            text: "Ha Nam",
            value: "63"
        },
        {
            text: "Ha Noi",
            value: "HN"
        },
        {
            text: "Ha Tinh",
            value: "23"
        },
        {
            text: "Hai Duong",
            value: "61"
        },
        {
            text: "Hai Phong",
            value: "HP"
        },
        {
            text: "Ho Chi Minh",
            value: "SG"
        },
        {
            text: "Hoa Binh",
            value: "14"
        },
        {
            text: "Hung Yen",
            value: "66"
        },
        {
            text: "Khanh Hoa",
            value: "34"
        },
        {
            text: "Kien Giang",
            value: "47"
        },
        {
            text: "Kon Tum",
            value: "28"
        },
        {
            text: "Lai Chau",
            value: "01"
        },
        {
            text: "Lam Dong",
            value: "35"
        },
        {
            text: "Lang Son",
            value: "09"
        },
        {
            text: "Lao Cai",
            value: "02"
        },
        {
            text: "Long An",
            value: "41"
        },
        {
            text: "Nam Dinh",
            value: "67"
        },
        {
            text: "Nghe An",
            value: "22"
        },
        {
            text: "Ninh Binh",
            value: "18"
        },
        {
            text: "Ninh Thuan",
            value: "36"
        },
        {
            text: "Phu Tho",
            value: "68"
        },
        {
            text: "Phu Yen",
            value: "32"
        },
        {
            text: "Quang Binh",
            value: "24"
        },
        {
            text: "Quang Nam",
            value: "27"
        },
        {
            text: "Quang Ngai",
            value: "29"
        },
        {
            text: "Quang Ninh",
            value: "13"
        },
        {
            text: "Quang Tri",
            value: "25"
        },
        {
            text: "Soc Trang",
            value: "52"
        },
        {
            text: "Son La",
            value: "05"
        },
        {
            text: "Tay Ninh",
            value: "37"
        },
        {
            text: "Thai Binh",
            value: "20"
        },
        {
            text: "Thai Nguyen",
            value: "69"
        },
        {
            text: "Thanh Hoa",
            value: "21"
        },
        {
            text: "Thua Thien-Hue",
            value: "26"
        },
        {
            text: "Tien Giang",
            value: "46"
        },
        {
            text: "Tra Vinh",
            value: "51"
        },
        {
            text: "Tuyen Quang",
            value: "07"
        },
        {
            text: "Vinh Long",
            value: "49"
        },
        {
            text: "Vinh Phuc",
            value: "70"
        },
        {
            text: "Yen Bai",
            value: "06"
        }
    ],
    VI: [
        {
            text: "Virgin Islands, U.S.",
            value: "01"
        }
    ],
    WF: [
        {
            text: "Sigave",
            value: "SG"
        },
        {
            text: "Uvea",
            value: "UV"
        }
    ],
    EH: [
        {
            text: "-",
            value: "01"
        }
    ],
    YE: [
        {
            text: "'Adan",
            value: "AD"
        },
        {
            text: "'Amran",
            value: "AM"
        },
        {
            text: "Abyan",
            value: "AB"
        },
        {
            text: "Ad Dali'",
            value: "DA"
        },
        {
            text: "Al Bayda'",
            value: "BA"
        },
        {
            text: "Al Hudaydah",
            value: "HU"
        },
        {
            text: "Al Jawf",
            value: "JA"
        },
        {
            text: "Al Mahrah",
            value: "MR"
        },
        {
            text: "Al Mahwit",
            value: "MW"
        },
        {
            text: "Amanat al 'Asimah",
            value: "SA"
        },
        {
            text: "Dhamar",
            value: "DH"
        },
        {
            text: "Hadramawt",
            value: "HD"
        },
        {
            text: "Ibb",
            value: "IB"
        },
        {
            text: "Lahij",
            value: "LA"
        },
        {
            text: "Ma'rib",
            value: "MA"
        },
        {
            text: "Sa'dah",
            value: "SD"
        },
        {
            text: "San'a'",
            value: "SN"
        },
        {
            text: "Shabwah",
            value: "SH"
        },
        {
            text: "Ta'izz",
            value: "TA"
        }
    ],
    ZM: [
        {
            text: "Central",
            value: "02"
        },
        {
            text: "Copperbelt",
            value: "08"
        },
        {
            text: "Eastern",
            value: "03"
        },
        {
            text: "Luapula",
            value: "04"
        },
        {
            text: "Lusaka",
            value: "09"
        },
        {
            text: "North-Western",
            value: "06"
        },
        {
            text: "Northern",
            value: "05"
        },
        {
            text: "Southern",
            value: "07"
        },
        {
            text: "Western",
            value: "01"
        }
    ],
    ZW: [
        {
            text: "Bulawayo",
            value: "BU"
        },
        {
            text: "Harare",
            value: "HA"
        },
        {
            text: "Manicaland",
            value: "MA"
        },
        {
            text: "Mashonaland Central",
            value: "MC"
        },
        {
            text: "Mashonaland East",
            value: "ME"
        },
        {
            text: "Mashonaland West",
            value: "MW"
        },
        {
            text: "Masvingo",
            value: "MV"
        },
        {
            text: "Matabeleland North",
            value: "MN"
        },
        {
            text: "Matabeleland South",
            value: "MS"
        },
        {
            text: "Midlands",
            value: "MI"
        }
    ]
};
var FormStateDropdown = function FormStateDropdown(_ref) {
    var labelTextWhenNoError = _ref.labelTextWhenNoError, errorMessages = _ref.errorMessages, field = _ref.field, fieldActions = _ref.fieldActions, showErrors = _ref.showErrors, countryCode = _ref.countryCode, _ref$isRequired = _ref.isRequired, isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired;
    var placeholder = countryCode === "US" ? placeHolderOptionUS : placeHolderOption;
    var options = [
        placeholder
    ].concat(_toConsumableArray(getOptions(countryCode)));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormSelect$1, {
        options: options,
        field: field,
        fieldActions: fieldActions,
        labelTextWhenNoError: labelTextWhenNoError,
        errorMessages: errorMessages,
        showErrors: showErrors,
        autocompleteValue: "address-level1",
        isRequired: isRequired
    });
};
var onBackground = "".concat(MATISSE_BLUE);
var disabledBackground = "".concat(MANATEE_GREY);
var disabledBackgroundLight = "".concat(ATHENS_GREY);
var white = "".concat(WHITE);
var labelStyles = "\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n";
var rightLabelStyles = "\n  > div {\n    flex-direction: row;\n  }\n";
var leftLabelStyles = "\n  > div {\n    flex-direction: row-reverse;\n  }\n";
var fallbackValues$y = {
    onBackground: onBackground,
    disabledBackground: disabledBackground,
    disabledBackgroundLight: disabledBackgroundLight,
    white: white,
    rightLabelStyles: rightLabelStyles,
    leftLabelStyles: leftLabelStyles,
    labelStyles: labelStyles
};
var HiddenToggleSwitchBox = (0, _styledComponentsDefault.default).input.withConfig({
    displayName: "ToggleSwitch__HiddenToggleSwitchBox",
    componentId: "sc-1t51u6v-0"
})([
    "opacity:0;margin:0;position:absolute;cursor:",
    ";height:",
    ";width:",
    ";"
], function(_ref) {
    var disabled = _ref.disabled;
    return disabled ? "auto" : "pointer";
}, function(_ref2) {
    var isMobile = _ref2.isMobile;
    return isMobile ? "22px" : "24px";
}, function(_ref3) {
    var isMobile = _ref3.isMobile;
    return isMobile ? "40px" : "44px";
});
var VisibleSwitchComponent = (0, _styledComponentsDefault.default)(Motion).withConfig({
    displayName: "ToggleSwitch__VisibleSwitchComponent",
    componentId: "sc-1t51u6v-1"
})([
    "width:",
    ";height:",
    ";border-radius:12px;border:none;position:relative;box-sizing:border-box;cursor:",
    ";display:inline-block;&:hover{box-shadow:",
    ";}&:focus{box-shadow:0px 2px 5px 0px rgba(0,0,0,0.5);}"
], function(_ref4) {
    var isMobile = _ref4.isMobile;
    return isMobile ? "40px" : "44px";
}, function(_ref5) {
    var isMobile = _ref5.isMobile;
    return isMobile ? "22px" : "24px";
}, function(_ref6) {
    var disabled = _ref6.disabled;
    return disabled ? "auto" : "pointer";
}, function(_ref7) {
    var disabled = _ref7.disabled;
    return disabled ? "none" : "0px 2px 5px 0px rgba(0, 0, 0, 0.5) !important";
});
var ToggleSwitchRingComponent = (0, _styledComponentsDefault.default)(Motion).withConfig({
    displayName: "ToggleSwitch__ToggleSwitchRingComponent",
    componentId: "sc-1t51u6v-2"
})([
    "position:absolute;width:",
    ";height:",
    ";border:none;border-radius:50%;box-sizing:border-box;"
], function(_ref8) {
    var isMobile = _ref8.isMobile;
    return isMobile ? "14px" : "16px";
}, function(_ref9) {
    var isMobile = _ref9.isMobile;
    return isMobile ? "14px" : "16px";
});
var ToggleSwitch = function ToggleSwitch(_ref10) {
    var _ref10$ariaDescribedB = _ref10.ariaDescribedBy, ariaDescribedBy = _ref10$ariaDescribedB === void 0 ? "" : _ref10$ariaDescribedB, _ref10$isOn = _ref10.isOn, isOn = _ref10$isOn === void 0 ? false : _ref10$isOn, _ref10$onToggle = _ref10.onToggle, onToggle = _ref10$onToggle === void 0 ? noop$1 : _ref10$onToggle, _ref10$disabled = _ref10.disabled, disabled = _ref10$disabled === void 0 ? false : _ref10$disabled, _ref10$name = _ref10.name, name = _ref10$name === void 0 ? "toggle" : _ref10$name, _ref10$label = _ref10.label, label = _ref10$label === void 0 ? null : _ref10$label, _ref10$labelLeft = _ref10.labelLeft, labelLeft = _ref10$labelLeft === void 0 ? false : _ref10$labelLeft, _ref10$labelStyles = _ref10.labelStyles, labelStyles = _ref10$labelStyles === void 0 ? "" : _ref10$labelStyles, _ref10$labelAs = _ref10.labelAs, labelAs = _ref10$labelAs === void 0 ? "label" : _ref10$labelAs, themeValues = _ref10.themeValues, isMobile = _ref10.isMobile, dataQa = _ref10.dataQa, _ref10$minWidth = _ref10.minWidth, minWidth = _ref10$minWidth === void 0 ? "80px" : _ref10$minWidth, _ref10$extraStyles = _ref10.extraStyles, extraStyles = _ref10$extraStyles === void 0 ? "" : _ref10$extraStyles;
    var nameId = name.replace(/ /g, "-");
    var toggleSwitchRingVariants = {
        off: {
            backgroundColor: disabled ? themeValues.disabledBackground : themeValues.onBackground,
            left: "4px",
            top: "3px",
            bottom: "3px",
            right: "20px",
            transition: {
                ease: "backIn"
            }
        },
        on: {
            backgroundColor: themeValues.white,
            right: "8px",
            top: "3px",
            bottom: "3px",
            left: "22px",
            transition: {
                ease: "backIn"
            }
        }
    };
    var visibleSwitchVariants = {
        off: {
            border: "1px solid",
            backgroundColor: disabled ? themeValues.disabledBackgroundLight : themeValues.white,
            borderColor: disabled ? themeValues.disabledBackground : themeValues.onBackground,
            transition: {
                ease: "easeOut"
            }
        },
        on: {
            border: "1px solid",
            backgroundColor: disabled ? themeValues.disabledBackground : themeValues.onBackground,
            borderColor: disabled ? themeValues.disabledBackground : themeValues.onBackground,
            transition: {
                ease: "easeIn"
            }
        }
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.keyCode === ENTER) onToggle();
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0.5rem",
        extraStyles: "\n        margin: 0 0.5rem;\n        ".concat(labelLeft ? themeValues.leftLabelStyles : themeValues.rightLabelStyles).concat(extraStyles)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center",
        overflow: "visible",
        childGap: "0",
        minWidth: minWidth !== null && minWidth !== void 0 ? minWidth : isMobile ? "75px" : "84px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        minHeight: "100%",
        singleChild: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        minWidth: "100%",
        padding: "0",
        extraStyles: "display: flex; align-items: center;",
        dataQa: dataQa
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(HiddenToggleSwitchBox, {
        type: "checkbox",
        "aria-checked": isOn,
        "aria-label": name,
        "aria-labelledby": label ? "".concat(nameId, "-label") : null,
        "aria-describedby": ariaDescribedBy ? ariaDescribedBy : null,
        checked: isOn,
        onChange: disabled ? noop$1 : onToggle,
        disabled: disabled,
        id: "#".concat(nameId),
        isMobile: isMobile
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(VisibleSwitchComponent, {
        onClick: disabled ? noop$1 : onToggle,
        onKeyDown: disabled ? noop$1 : handleKeyDown,
        initial: isOn ? "on" : "off",
        animate: isOn ? "on" : "off",
        variants: visibleSwitchVariants,
        tabIndex: disabled ? -1 : 0,
        disabled: disabled,
        isMobile: isMobile,
        useSpan: true,
        tabindex: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ToggleSwitchRingComponent, {
        variants: toggleSwitchRingVariants,
        isMobile: isMobile
    })))), label && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        as: labelAs,
        "aria-label": "".concat(name, ": ").concat(label),
        extraStyles: "\n                font-weight: ".concat(FONT_WEIGHT_SEMIBOLD, ";\n                color: ").concat(CHARADE_GREY, ";\n                margin: 0 0 0 0.25rem; \n                position: relative; \n                bottom: 1px; \n                display: inline-block; \n                ").concat(labelStyles),
        id: "".concat(nameId, "-label"),
        htmlFor: labelAs === "label" ? nameId : null,
        padding: "0"
    }, label))));
};
var ToggleSwitch$1 = themeComponent(ToggleSwitch, "ToggleSwitch", fallbackValues$y);
var background$2 = "".concat(ATHENS_GREY);
var white$1 = "".concat(WHITE);
var black = "#000";
var focusBorder = "".concat(MATISSE_BLUE);
var themeValues = {
    background: background$2,
    white: white$1,
    black: black,
    focusBorder: focusBorder
};
var TypeaheadInputWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "TypeaheadInput__TypeaheadInputWrapper",
    componentId: "sc-cumjdb-0"
})([
    "display:flex;align-content:center;align-items:center;background:",
    ";input{border:0;height:72px;width:100%;padding:1.5rem;padding-left:1rem;min-width:100px;margin:0;box-sizing:border-box;position:relative;font-size:1.1rem;line-height:2rem;font-weight:400;background-color:",
    ";color:",
    ";box-shadow:none;border:1px solid transparent;&:focus{border:1px solid ",
    ";}}"
], themeValues.background, themeValues.background, themeValues.black, themeValues.focusBorder);
var TypeaheadInput = function TypeaheadInput(_ref) {
    var handleChange = _ref.handleChange, placeholder = _ref.placeholder, id = _ref.id, labelText = _ref.labelText;
    var onChange = function onChange(el) {
        return handleChange(el.currentTarget.value);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(TypeaheadInputWrapper, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1.5rem 0 1.5rem 1.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SearchIcon, null)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        as: "label",
        color: "black",
        variant: "pS",
        weight: 500,
        extraStyles: "\n          border: 0;\n          clip: rect(0 0 0 0);\n          height: 1px;\n          margin: -1px;\n          overflow: hidden;\n          padding: 0;\n          position: absolute;\n          width: 1px;\n        ",
        id: id
    }, labelText), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "aria-labelledby": id,
        type: "text",
        placeholder: placeholder,
        onChange: onChange
    }));
};
var backgroundColor$6 = WHITE;
var imageBackgroundColor = INFO_BLUE;
var headerBackgroundColor = STORM_GREY;
var headerColor = WHITE;
var contentBackgroundColor = INFO_BLUE;
var fallbackValues$z = {
    backgroundColor: backgroundColor$6,
    contentBackgroundColor: contentBackgroundColor,
    imageBackgroundColor: imageBackgroundColor,
    headerBackgroundColor: headerBackgroundColor,
    headerColor: headerColor
};
var CardImage = (0, _styledComponentsDefault.default).img.withConfig({
    displayName: "CardImagestyled__CardImage",
    componentId: "sc-ug7kyn-0"
})([
    "background:",
    ";object-fit:",
    ";height:",
    ";"
], function(_ref) {
    var backgroundColor = _ref.backgroundColor;
    return backgroundColor;
}, function(_ref2) {
    var objectFit = _ref2.objectFit;
    return objectFit;
}, function(_ref3) {
    var height = _ref3.height;
    return height;
});
var titleColor = BRIGHT_GREY;
var titleWeight = FONT_WEIGHT_BOLD;
var textColor$1 = BRIGHT_GREY;
var fallbackValues$A = {
    titleColor: titleColor,
    titleWeight: titleWeight,
    textColor: textColor$1
};
var CardText = function CardText(_ref) {
    var showQuitLink = _ref.showQuitLink, onQuitClick = _ref.onQuitClick, titleAs = _ref.titleAs, padding = _ref.padding, text = _ref.text, _ref$textAs = _ref.textAs, textAs = _ref$textAs === void 0 ? "p" : _ref$textAs, titleText = _ref.titleText, _ref$titleVariant = _ref.titleVariant, titleVariant = _ref$titleVariant === void 0 ? "small" : _ref$titleVariant, themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: padding
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center",
        overflow: true,
        nowrap: true
    }, titleText && /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        as: titleAs,
        variant: titleVariant,
        color: themeValues.titleColor,
        weight: themeValues.titleWeight
    }, titleText), showQuitLink && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        onClick: onQuitClick,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && onQuitClick();
        },
        role: "button",
        tabIndex: 0,
        "aria-label": "Close Card: ".concat(titleText),
        extraStyles: "cursor: pointer;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(IconQuitLarge, null))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        as: textAs,
        color: themeValues.textColor
    }, text))));
};
var CardText$1 = themeComponent(withWindowSize(CardText), "CardText", fallbackValues$A);
var CardHeader = function CardHeader(_ref) {
    var backgroundColor = _ref.backgroundColor, borderRadius = _ref.borderRadius, as = _ref.as, headerText = _ref.headerText, headerColor = _ref.headerColor, headerVariant = _ref.headerVariant, padding = _ref.padding;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: padding,
        background: backgroundColor,
        borderRadius: "".concat(borderRadius, " ").concat(borderRadius, " 0 0")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        as: as,
        variant: headerVariant,
        color: headerColor
    }, headerText));
};
var Card = function Card(_ref) {
    var _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? "4px" : _ref$borderRadius, extraStyles = _ref.extraStyles, _ref$headerAs = _ref.headerAs, headerAs = _ref$headerAs === void 0 ? "h2" : _ref$headerAs, headerText = _ref.headerText, _ref$headerVariant = _ref.headerVariant, headerVariant = _ref$headerVariant === void 0 ? "small" : _ref$headerVariant, imgSrc = _ref.imgSrc, Image = _ref.Image, _ref$imgHeight = _ref.imgHeight, imgHeight = _ref$imgHeight === void 0 ? "150px" : _ref$imgHeight, _ref$imgObjectFit = _ref.imgObjectFit, imgObjectFit = _ref$imgObjectFit === void 0 ? "none" : _ref$imgObjectFit, imgAltText = _ref.imgAltText, _ref$hasContentBackgr = _ref.hasContentBackgroundColor, hasContentBackgroundColor = _ref$hasContentBackgr === void 0 ? false : _ref$hasContentBackgr, _ref$onQuitClick = _ref.onQuitClick, onQuitClick = _ref$onQuitClick === void 0 ? noop$1 : _ref$onQuitClick, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "24px" : _ref$padding, _ref$showQuitLink = _ref.showQuitLink, showQuitLink = _ref$showQuitLink === void 0 ? false : _ref$showQuitLink, text = _ref.text, _ref$textAs = _ref.textAs, textAs = _ref$textAs === void 0 ? "p" : _ref$textAs, _ref$titleAs = _ref.titleAs, titleAs = _ref$titleAs === void 0 ? "h2" : _ref$titleAs, titleText = _ref.titleText, _ref$titleVariant = _ref.titleVariant, titleVariant = _ref$titleVariant === void 0 ? "small" : _ref$titleVariant, themeValues = _ref.themeValues, _ref$width = _ref.width, width = _ref$width === void 0 ? "276px" : _ref$width, children = _ref.children;
    var hasImage = Image || imgSrc;
    var numberOfChildren = (Array.isArray(children) ? children.length : 1) + (text ? 1 : 0) + (hasImage ? 1 : 0) + (headerText ? 1 : 0);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(BoxWithShadow$1, {
        variant: "baseStandard",
        background: themeValues.backgroundColor,
        borderRadius: borderRadius,
        padding: "0",
        margin: "0",
        minWidth: width,
        extraStyles: extraStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        singleChild: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        fullHeight: true,
        childGap: "1.5rem",
        bottomItem: numberOfChildren
    }, headerText && /*#__PURE__*/ (0, _reactDefault.default).createElement(CardHeader, {
        headerText: headerText,
        headerColor: themeValues.headerColor,
        headerVariant: headerVariant,
        backgroundColor: themeValues.headerBackgroundColor,
        borderRadius: borderRadius,
        padding: padding,
        as: headerAs
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        direction: "row",
        childGap: "0"
    }, Image && !imgSrc && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        minHeight: imgHeight,
        padding: "0",
        background: themeValues.imageBackgroundColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        minHeight: imgHeight,
        singleChild: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        intrinsic: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Image, {
        alt: imgAltText
    })))), imgSrc && /*#__PURE__*/ (0, _reactDefault.default).createElement(CardImage, {
        height: imgHeight,
        objectFit: imgObjectFit,
        backgroundColor: themeValues.imageBackgroundColor,
        src: imgSrc,
        alt: imgAltText
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        width: "100%",
        extraStyles: "\n                flex-basis: 100%;\n                background-color: ".concat(hasContentBackgroundColor ? themeValues.contentBackgroundColor : "", ";\n              ")
    }, text && /*#__PURE__*/ (0, _reactDefault.default).createElement(CardText$1, {
        onQuitClick: onQuitClick,
        padding: padding,
        showQuitLink: showQuitLink,
        titleAs: titleAs,
        titleText: titleText,
        text: text,
        textAs: textAs,
        titleVariant: titleVariant
    }), children)))));
};
var Card$1 = themeComponent(withWindowSize(Card), "Card", fallbackValues$z);
var cardBrands = {
    visa: {
        label: "Visa",
        small: VisaSmallIcon,
        large: VisaLargeIcon
    },
    master_card: {
        label: "Mastercard",
        small: MasterCardSmallIcon,
        large: MasterCardLargeIcon
    },
    discover: {
        label: "Discover",
        small: DiscoverSmallIcon,
        large: DiscoverLargeIcon
    },
    amex: {
        label: "American Express",
        small: AmExSmallIcon,
        large: AmExLargeIcon
    },
    "default": {
        label: "Credit card",
        small: GenericSmallIcon,
        large: GenericCardLarge
    }
};
var normalizeType = function normalizeType(type) {
    if (!type) return undefined;
    var lower = type.toLowerCase();
    if (lower === "mastercard") return "master_card";
    return lower;
};
var CardType = function CardType(_ref) {
    var type = _ref.type, _ref$size = _ref.size, size = _ref$size === void 0 ? "small" : _ref$size;
    var normalizedType = normalizeType(type);
    var _ref2 = cardBrands[normalizedType] || cardBrands["default"], label = _ref2.label, IconComponent = _ref2[size];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(IconComponent, null);
};
var fontFamily$6 = "Public Sans, sans-serif";
var activeColor$6 = MATISSE_BLUE;
var linkColor$3 = CHARADE_GREY;
var fallbackValues$B = {
    fontFamily: fontFamily$6,
    activeColor: activeColor$6,
    linkColor: linkColor$3
};
var NavTab = function NavTab(_ref) {
    var path = _ref.path, label = _ref.label, themeValues = _ref.themeValues;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    var location = (0, _reactRouterDom.useLocation)();
    (0, _react.useEffect)(function() {
        setIsActive(location.pathname.includes(path));
    }, [
        location.pathname
    ]);
    var border = "border-bottom: 3px solid ".concat(themeValues.activeColor);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: 0
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(InternalLink, {
        color: isActive ? themeValues.activeColor : themeValues.linkColor,
        to: path,
        extraStyles: "\n          border-bottom: 3px solid transparent;\n          font-family: ".concat(themeValues.fontFamily, ";\n          text-decoration: none;\n          ").concat(isActive && !isMobile ? border : "none", ";\n          &:hover {\n            text-decoration: none;\n            color: ").concat(themeValues.activeColor, ";\n            ").concat(isMobile ? "" : "".concat(border), "\n          };\n          padding: 1.25rem 0;\n        ")
    }, label));
};
var NavTab$1 = themeComponent(NavTab, "NavTab", fallbackValues$B);
var NavTabs = function NavTabs(_ref) {
    var tabsConfig = _ref.tabsConfig, tabGap = _ref.tabGap;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    var tabs = tabsConfig.map(function(tabConfig) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(NavTab$1, _extends({
            key: tabConfig.path
        }, tabConfig));
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(BoxWithShadow$1, {
        variant: "insetStandard",
        extraStyles: "padding: 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        intrinsic: true
    }, isMobile ? tabs : /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        childGap: tabGap
    }, tabs)));
};
var shineFrames = (0, _styledComponents.keyframes)([
    "{0{background-position:0 0;}20%{background-position:100% 100%;}100%{background-position:100% 100%;}}"
]);
var LoadingPill = (0, _styledComponentsDefault.default).span.withConfig({
    displayName: "LoadingPillstyled__LoadingPill",
    componentId: "sc-kn9rtt-0"
})([
    "display:block;width:",
    "px;background-color:",
    ";margin:",
    ";height:",
    ";border-radius:16px;background-image:linear-gradient( 135deg,",
    " 0%,",
    " 40%,",
    " 60%,",
    " 100% );background-size:400%;animation:",
    " 2s infinite ease-in-out;animation-direction:reverse;"
], function(_ref) {
    var width = _ref.width;
    return width;
}, function(_ref2) {
    var backgroundColor = _ref2.backgroundColor;
    return backgroundColor;
}, function(_ref3) {
    var margin = _ref3.margin;
    return margin;
}, function(_ref4) {
    var height = _ref4.height;
    return height;
}, function(_ref5) {
    var backgroundColor = _ref5.backgroundColor;
    return backgroundColor;
}, function(_ref6) {
    var foregroundColor = _ref6.foregroundColor;
    return foregroundColor;
}, function(_ref7) {
    var backgroundColor = _ref7.backgroundColor;
    return backgroundColor;
}, function(_ref8) {
    var backgroundColor = _ref8.backgroundColor;
    return backgroundColor;
}, shineFrames);
var _excluded$J = [
    "minWidth",
    "maxWidth",
    "exactWidth",
    "height",
    "margin",
    "backgroundColor",
    "foregroundColor"
];
var LoadingLine = function LoadingLine(_ref) {
    var minWidth = _ref.minWidth, maxWidth = _ref.maxWidth, _ref$exactWidth = _ref.exactWidth, exactWidth = _ref$exactWidth === void 0 ? null : _ref$exactWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? "16px" : _ref$height, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? "0px" : _ref$margin, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? SEASHELL_WHITE : _ref$backgroundColor, _ref$foregroundColor = _ref.foregroundColor, foregroundColor = _ref$foregroundColor === void 0 ? ALABASTER_WHITE : _ref$foregroundColor, props = _objectWithoutProperties(_ref, _excluded$J);
    var calculatedWidth = Math.floor(Math.random() * (parseInt(maxWidth) - parseInt(minWidth) + 1) + parseInt(minWidth));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingPill, _extends({
        "aria-label": "loading",
        margin: margin,
        height: height,
        width: exactWidth || calculatedWidth,
        backgroundColor: backgroundColor,
        foregroundColor: foregroundColor
    }, props));
};
var fontSize$9 = {
    "default": "1.375rem",
    largeTitle: "1.75rem",
    small: "1.25rem"
};
var fontWeight$6 = {
    "default": "600",
    largeTitle: "700",
    small: "600"
};
var fontColor = {
    "default": CHARADE_GREY,
    largeTitle: CHARADE_GREY,
    small: CHARADE_GREY
};
var lineHeight$3 = {
    "default": "2rem",
    largeTitle: "2rem",
    small: "2rem"
};
var textAlign = {
    "default": "left",
    largeTitle: "left",
    small: "left"
};
var titleType = {
    "default": "h5",
    largeTitle: "h1",
    small: "h6"
};
var titleSpacing = {
    "default": "0.5rem",
    largeTitle: "1.125rem",
    small: "0.5rem"
};
var boxShadow$1 = {
    "default": "0px 2px 14px 0px rgb(246, 246, 249), 0px 3px 8px 0px rgb(202, 206, 216)",
    largeTitle: "0px 2px 14px 0px rgb(246, 246, 249), 0px 3px 8px 0px rgb(202, 206, 216)",
    small: "0px 2px 14px 0px rgb(246, 246, 249), 0px 3px 8px 0px rgb(202, 206, 216)"
};
var borderRadius = {
    "default": "0.25rem",
    largeTitle: "0.25rem",
    small: "0.25rem"
};
var backgroundColor$7 = {
    "default": WHITE,
    largeTitle: WHITE,
    small: WHITE
};
var fallbackValues$C = {
    fontSize: fontSize$9,
    fontWeight: fontWeight$6,
    fontColor: fontColor,
    lineHeight: lineHeight$3,
    textAlign: textAlign,
    titleType: titleType,
    titleSpacing: titleSpacing,
    boxShadow: boxShadow$1,
    borderRadius: borderRadius,
    backgroundColor: backgroundColor$7
};
/*
  New (01/22) - updated <Module /> to use <Title /> atom
  Because <Title /> decouples size from element, also gave <Module />
  two new props: "as" and "fontSize"

  When present, <Module /> will use those values to dictate element type and font size.

  For backwards compatability, <Module /> still computes a themed font size and element type based on old
  <Heading /> variants. If "fontSize" or "as" is undefined, <Module /> will use themed values.
*/ var Module = function Module(_ref) {
    var _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "default" : _ref$variant, as = _ref.as, disabled = _ref.disabled, heading = _ref.heading, rightTitleContent = _ref.rightTitleContent, _ref$titleID = _ref.titleID, titleID = _ref$titleID === void 0 ? "" : _ref$titleID, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "1rem" : _ref$spacing, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "0" : _ref$padding, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? "0" : _ref$margin, _ref$spacingBottom = _ref.spacingBottom, spacingBottom = _ref$spacingBottom === void 0 ? "2.5rem" : _ref$spacingBottom, fontSize = _ref.fontSize, themeValues = _ref.themeValues, children = _ref.children, _ref$allowContentOver = _ref.allowContentOverflow, allowContentOverflow = _ref$allowContentOver === void 0 ? false : _ref$allowContentOver;
    var themedFontSize = variant === "small" ? "1.25rem" : variant === "default" ? "1.375rem" : "2rem";
    var computedFontSize = fontSize || themedFontSize;
    var themedElemType = variant === "small" ? "h6" : variant === "default" ? "h5" : "h2";
    var computedElemType = as || themedElemType;
    var disabledStyles = "opacity: 0.40;";
    var headingText = /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        weight: themeValues.fontWeight,
        color: themeValues.fontColor,
        margin: "".concat(spacing, " 0 ").concat(themeValues.titleSpacing, " 0"),
        textAlign: themeValues.textAlign,
        as: computedElemType,
        extraStyles: "font-size: ".concat(computedFontSize, ";"),
        id: titleID
    }, heading);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        "aria-disabled": disabled,
        extraStyles: disabled && disabledStyles,
        padding: "0",
        role: "group"
    }, heading && !rightTitleContent && headingText, heading && rightTitleContent && /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center",
        overflow: allowContentOverflow,
        nowrap: true
    }, headingText, rightTitleContent), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 0 ".concat(spacingBottom),
        extraStyles: "margin: ".concat(margin)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: padding,
        background: themeValues.backgroundColor,
        borderRadius: themeValues.borderRadius,
        boxShadow: themeValues.boxShadow
    }, children)));
};
var Module$1 = /*#__PURE__*/ (0, _react.memo)(themeComponent(Module, "Module", fallbackValues$C, "default"));
var WalletName = function WalletName(_ref) {
    var mainText = _ref.mainText, action = _ref.action, _ref$text = _ref.text, text = _ref$text === void 0 ? null : _ref$text, _ref$actionText = _ref.actionText, actionText = _ref$actionText === void 0 ? null : _ref$actionText, _ref$disableAction = _ref.disableAction, disableAction = _ref$disableAction === void 0 ? false : _ref$disableAction, _ref$linkButtonExtraS = _ref.linkButtonExtraStyles, linkButtonExtraStyles = _ref$linkButtonExtraS === void 0 ? "" : _ref$linkButtonExtraS, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$dataQa = _ref.dataQa, dataQa = _ref$dataQa === void 0 ? null : _ref$dataQa, _ref$actionTextPositi = _ref.actionTextPositionMobile, actionTextPositionMobile = _ref$actionTextPositi === void 0 ? "outside" : _ref$actionTextPositi;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Module$1, {
        spacingBottom: isMobile ? "0" : "1.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        align: "center",
        justify: !!text || !!actionText ? "space-between" : "flex-start",
        extraStyles: "\n            box-shadow: 0px 1px 2px 0px rgba(".concat(CHARADE_GREY, ", 0.1);\n            box-shadow: 0px 2px 6px 0px rgba(").concat(CHARADE_GREY, ", 0.2);\n            box-shadow: 0px -1px 0px 0px rgba(").concat(CHARADE_GREY, ", 0.1) inset;\n            padding: 1.5rem;\n            ").concat(isMobile ? "span {text-align: right;}" : "", "\n          ")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, isLoading ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        as: "span",
        style: {
            padding: "24px 24px 0"
        },
        intrinsic: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Spinner$2, {
        strokeWidth: "2",
        size: "24",
        radius: "10",
        cx: "12",
        cy: "12"
    })) : mainText && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, null, mainText)), (actionTextPositionMobile === "inside" || !isMobile) && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, text && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pXS"
    }, text), (text || actionText) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "\xa0"), action && actionText && /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        disabled: disableAction,
        text: actionText,
        dataQa: dataQa,
        action: action,
        variant: "smallGhost",
        extraStyles: "\n                    margin: 0;\n                    min-width: 0;\n                    span {font-size: 0.75rem;}\n                    ".concat(linkButtonExtraStyles, "\n                ")
    })))), !!isMobile && actionTextPositionMobile === "outside" && /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        align: "center",
        justify: text || actionText ? "flex-end" : "flex-start",
        extraStyles: "margin-top: 0.5rem;"
    }, text && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        extraStyles: "font-size: 0.857rem;"
    }, text), (text || actionText) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "\xa0"), action && actionText && /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        text: actionText,
        action: action,
        variant: "smallGhost",
        disabled: disableAction,
        extraStyles: "\n                margin: 0;\n                min-width: 0;\n                span {font-size: 0.857rem;}\n                ".concat(linkButtonExtraStyles, "\n              ")
    })));
};
const validatorToPredicate = (validatorFn, emptyCase)=>(value, ...rest)=>value === "" ? emptyCase : validatorFn(value, ...rest);
var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var dayjs_min = {
    exports: {}
};
(function(module, exports) {
    !function(t, e) {
        module.exports = e();
    }(commonjsGlobal$1, function() {
        var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
            name: "en",
            weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            ordinal: function(t) {
                var e = [
                    "th",
                    "st",
                    "nd",
                    "rd"
                ], n = t % 100;
                return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
            }
        }, m = function(t, e, n) {
            var r = String(t);
            return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
        }, v = {
            s: m,
            z: function(t) {
                var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
                return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
            },
            m: function t(e, n) {
                if (e.date() < n.date()) return -t(n, e);
                var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, f), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), f);
                return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
            },
            a: function(t) {
                return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
            },
            p: function(t) {
                return ({
                    M: f,
                    y: c,
                    w: o,
                    d: a,
                    D: d,
                    h: u,
                    m: s,
                    s: i,
                    ms: r,
                    Q: h
                })[t] || String(t || "").toLowerCase().replace(/s$/, "");
            },
            u: function(t) {
                return void 0 === t;
            }
        }, g = "en", D = {};
        D[g] = M;
        var p = function(t) {
            return t instanceof _;
        }, S = function t(e, n, r) {
            var i;
            if (!e) return g;
            if ("string" == typeof e) {
                var s = e.toLowerCase();
                D[s] && (i = s), n && (D[s] = n, i = s);
                var u = e.split("-");
                if (!i && u.length > 1) return t(u[0]);
            } else {
                var a = e.name;
                D[a] = e, i = a;
            }
            return !r && i && (g = i), i || !r && g;
        }, w = function(t, e) {
            if (p(t)) return t.clone();
            var n = "object" == typeof e ? e : {};
            return n.date = t, n.args = arguments, new _(n);
        }, O = v;
        O.l = S, O.i = p, O.w = function(t, e) {
            return w(t, {
                locale: e.$L,
                utc: e.$u,
                x: e.$x,
                $offset: e.$offset
            });
        };
        var _ = function() {
            function M(t) {
                this.$L = S(t.locale, null, !0), this.parse(t);
            }
            var m = M.prototype;
            return m.parse = function(t) {
                this.$d = function(t) {
                    var e = t.date, n = t.utc;
                    if (null === e) return new Date(NaN);
                    if (O.u(e)) return new Date;
                    if (e instanceof Date) return new Date(e);
                    if ("string" == typeof e && !/Z$/i.test(e)) {
                        var r = e.match($);
                        if (r) {
                            var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                            return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                        }
                    }
                    return new Date(e);
                }(t), this.$x = t.x || {}, this.init();
            }, m.init = function() {
                var t = this.$d;
                this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
            }, m.$utils = function() {
                return O;
            }, m.isValid = function() {
                return !(this.$d.toString() === l);
            }, m.isSame = function(t, e) {
                var n = w(t);
                return this.startOf(e) <= n && n <= this.endOf(e);
            }, m.isAfter = function(t, e) {
                return w(t) < this.startOf(e);
            }, m.isBefore = function(t, e) {
                return this.endOf(e) < w(t);
            }, m.$g = function(t, e, n) {
                return O.u(t) ? this[e] : this.set(n, t);
            }, m.unix = function() {
                return Math.floor(this.valueOf() / 1e3);
            }, m.valueOf = function() {
                return this.$d.getTime();
            }, m.startOf = function(t, e) {
                var n = this, r = !!O.u(e) || e, h = O.p(t), l = function(t, e) {
                    var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                    return r ? i : i.endOf(a);
                }, $ = function(t, e) {
                    return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                        0,
                        0,
                        0,
                        0
                    ] : [
                        23,
                        59,
                        59,
                        999
                    ]).slice(e)), n);
                }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
                switch(h){
                    case c:
                        return r ? l(1, 0) : l(31, 11);
                    case f:
                        return r ? l(1, M) : l(0, M + 1);
                    case o:
                        var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                        return l(r ? m - D : m + (6 - D), M);
                    case a:
                    case d:
                        return $(v + "Hours", 0);
                    case u:
                        return $(v + "Minutes", 1);
                    case s:
                        return $(v + "Seconds", 2);
                    case i:
                        return $(v + "Milliseconds", 3);
                    default:
                        return this.clone();
                }
            }, m.endOf = function(t) {
                return this.startOf(t, !1);
            }, m.$set = function(t, e) {
                var n, o = O.p(t), h = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
                if (o === f || o === c) {
                    var y = this.clone().set(d, 1);
                    y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
                } else l && this.$d[l]($);
                return this.init(), this;
            }, m.set = function(t, e) {
                return this.clone().$set(t, e);
            }, m.get = function(t) {
                return this[O.p(t)]();
            }, m.add = function(r, h) {
                var d, l = this;
                r = Number(r);
                var $ = O.p(h), y = function(t) {
                    var e = w(l);
                    return O.w(e.date(e.date() + Math.round(t * r)), l);
                };
                if ($ === f) return this.set(f, this.$M + r);
                if ($ === c) return this.set(c, this.$y + r);
                if ($ === a) return y(1);
                if ($ === o) return y(7);
                var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
                return O.w(m, this);
            }, m.subtract = function(t, e) {
                return this.add(-1 * t, e);
            }, m.format = function(t) {
                var e = this, n = this.$locale();
                if (!this.isValid()) return n.invalidDate || l;
                var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, f = n.months, h = function(t, n, i, s) {
                    return t && (t[n] || t(e, r)) || i[n].slice(0, s);
                }, c = function(t) {
                    return O.s(s % 12 || 12, t, "0");
                }, d = n.meridiem || function(t, e, n) {
                    var r = t < 12 ? "AM" : "PM";
                    return n ? r.toLowerCase() : r;
                }, $ = {
                    YY: String(this.$y).slice(-2),
                    YYYY: this.$y,
                    M: a + 1,
                    MM: O.s(a + 1, 2, "0"),
                    MMM: h(n.monthsShort, a, f, 3),
                    MMMM: h(f, a),
                    D: this.$D,
                    DD: O.s(this.$D, 2, "0"),
                    d: String(this.$W),
                    dd: h(n.weekdaysMin, this.$W, o, 2),
                    ddd: h(n.weekdaysShort, this.$W, o, 3),
                    dddd: o[this.$W],
                    H: String(s),
                    HH: O.s(s, 2, "0"),
                    h: c(1),
                    hh: c(2),
                    a: d(s, u, !0),
                    A: d(s, u, !1),
                    m: String(u),
                    mm: O.s(u, 2, "0"),
                    s: String(this.$s),
                    ss: O.s(this.$s, 2, "0"),
                    SSS: O.s(this.$ms, 3, "0"),
                    Z: i
                };
                return r.replace(y, function(t, e) {
                    return e || $[t] || i.replace(":", "");
                });
            }, m.utcOffset = function() {
                return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
            }, m.diff = function(r, d, l) {
                var $, y = O.p(d), M = w(r), m = (M.utcOffset() - this.utcOffset()) * e, v = this - M, g = O.m(this, M);
                return g = ($ = {}, $[c] = g / 12, $[f] = g, $[h] = g / 3, $[o] = (v - m) / 6048e5, $[a] = (v - m) / 864e5, $[u] = v / n, $[s] = v / e, $[i] = v / t, $)[y] || v, l ? g : O.a(g);
            }, m.daysInMonth = function() {
                return this.endOf(f).$D;
            }, m.$locale = function() {
                return D[this.$L];
            }, m.locale = function(t, e) {
                if (!t) return this.$L;
                var n = this.clone(), r = S(t, e, !0);
                return r && (n.$L = r), n;
            }, m.clone = function() {
                return O.w(this.$d, this);
            }, m.toDate = function() {
                return new Date(this.valueOf());
            }, m.toJSON = function() {
                return this.isValid() ? this.toISOString() : null;
            }, m.toISOString = function() {
                return this.$d.toISOString();
            }, m.toString = function() {
                return this.$d.toUTCString();
            }, M;
        }(), T = _.prototype;
        return w.prototype = T, [
            [
                "$ms",
                r
            ],
            [
                "$s",
                i
            ],
            [
                "$m",
                s
            ],
            [
                "$H",
                u
            ],
            [
                "$W",
                a
            ],
            [
                "$M",
                f
            ],
            [
                "$y",
                c
            ],
            [
                "$D",
                d
            ]
        ].forEach(function(t) {
            T[t[1]] = function(e) {
                return this.$g(e, t[0], t[1]);
            };
        }), w.extend = function(t, e) {
            return t.$i || (t(e, _, w), t.$i = !0), w;
        }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
            return w(1e3 * t);
        }, w.en = D[g], w.Ls = D, w.p = {}, w;
    });
})(dayjs_min);
var dayjs_minExports = dayjs_min.exports;
var dayjs = /*@__PURE__*/ getDefaultExportFromCjs(dayjs_minExports);
var customParseFormat$1 = {
    exports: {}
};
(function(module, exports) {
    !function(e, t) {
        module.exports = t();
    }(commonjsGlobal$1, function() {
        var e = {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
        }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
            return (e = +e) + (e > 68 ? 1900 : 2e3);
        };
        var a = function(e) {
            return function(t) {
                this[e] = +t;
            };
        }, f = [
            /[+-]\d\d:?(\d\d)?|Z/,
            function(e) {
                (this.zone || (this.zone = {})).offset = function(e) {
                    if (!e) return 0;
                    if ("Z" === e) return 0;
                    var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                    return 0 === n ? 0 : "+" === t[0] ? -n : n;
                }(e);
            }
        ], h = function(e) {
            var t = o[e];
            return t && (t.indexOf ? t : t.s.concat(t.f));
        }, u = function(e, t) {
            var n, r = o.meridiem;
            if (r) {
                for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                    n = i > 12;
                    break;
                }
            } else n = e === (t ? "pm" : "PM");
            return n;
        }, d = {
            A: [
                i,
                function(e) {
                    this.afternoon = u(e, !1);
                }
            ],
            a: [
                i,
                function(e) {
                    this.afternoon = u(e, !0);
                }
            ],
            S: [
                /\d/,
                function(e) {
                    this.milliseconds = 100 * +e;
                }
            ],
            SS: [
                n,
                function(e) {
                    this.milliseconds = 10 * +e;
                }
            ],
            SSS: [
                /\d{3}/,
                function(e) {
                    this.milliseconds = +e;
                }
            ],
            s: [
                r,
                a("seconds")
            ],
            ss: [
                r,
                a("seconds")
            ],
            m: [
                r,
                a("minutes")
            ],
            mm: [
                r,
                a("minutes")
            ],
            H: [
                r,
                a("hours")
            ],
            h: [
                r,
                a("hours")
            ],
            HH: [
                r,
                a("hours")
            ],
            hh: [
                r,
                a("hours")
            ],
            D: [
                r,
                a("day")
            ],
            DD: [
                n,
                a("day")
            ],
            Do: [
                i,
                function(e) {
                    var t = o.ordinal, n = e.match(/\d+/);
                    if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
                }
            ],
            M: [
                r,
                a("month")
            ],
            MM: [
                n,
                a("month")
            ],
            MMM: [
                i,
                function(e) {
                    var t = h("months"), n = (h("monthsShort") || t.map(function(e) {
                        return e.slice(0, 3);
                    })).indexOf(e) + 1;
                    if (n < 1) throw new Error;
                    this.month = n % 12 || n;
                }
            ],
            MMMM: [
                i,
                function(e) {
                    var t = h("months").indexOf(e) + 1;
                    if (t < 1) throw new Error;
                    this.month = t % 12 || t;
                }
            ],
            Y: [
                /[+-]?\d+/,
                a("year")
            ],
            YY: [
                n,
                function(e) {
                    this.year = s(e);
                }
            ],
            YYYY: [
                /\d{4}/,
                a("year")
            ],
            Z: f,
            ZZ: f
        };
        function c(n) {
            var r, i;
            r = n, i = o && o.formats;
            for(var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                var o = r && r.toUpperCase();
                return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                    return t || n.slice(1);
                });
            })).match(t), a = s.length, f = 0; f < a; f += 1){
                var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
                s[f] = l ? {
                    regex: c,
                    parser: l
                } : h.replace(/^\[|\]$/g, "");
            }
            return function(e) {
                for(var t = {}, n = 0, r = 0; n < a; n += 1){
                    var i = s[n];
                    if ("string" == typeof i) r += i.length;
                    else {
                        var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
                        f.call(t, u), e = e.replace(u, "");
                    }
                }
                return function(e) {
                    var t = e.afternoon;
                    if (void 0 !== t) {
                        var n = e.hours;
                        t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                    }
                }(t), t;
            };
        }
        return function(e, t, n) {
            n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
            var r = t.prototype, i = r.parse;
            r.parse = function(e) {
                var t = e.date, r = e.utc, s = e.args;
                this.$u = r;
                var a = s[1];
                if ("string" == typeof a) {
                    var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
                    h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
                        try {
                            if ([
                                "x",
                                "X"
                            ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                            var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = new Date, m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
                            i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
                            var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
                            return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
                        } catch (e) {
                            return new Date("");
                        }
                    }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
                } else if (a instanceof Array) for(var l = a.length, m = 1; m <= l; m += 1){
                    s[1] = a[m - 1];
                    var M = n.apply(this, s);
                    if (M.isValid()) {
                        this.$d = M.$d, this.$L = M.$L, this.init();
                        break;
                    }
                    m === l && (this.$d = new Date(""));
                }
                else i.call(this, e);
            };
        };
    });
})(customParseFormat$1);
var customParseFormatExports = customParseFormat$1.exports;
var customParseFormat = /*@__PURE__*/ getDefaultExportFromCjs(customParseFormatExports);
var isSameOrBefore$1 = {
    exports: {}
};
(function(module, exports) {
    !function(e, i) {
        module.exports = i();
    }(commonjsGlobal$1, function() {
        return function(e, i) {
            i.prototype.isSameOrBefore = function(e, i) {
                return this.isSame(e, i) || this.isBefore(e, i);
            };
        };
    });
})(isSameOrBefore$1);
var isSameOrBeforeExports = isSameOrBefore$1.exports;
var isSameOrBefore = /*@__PURE__*/ getDefaultExportFromCjs(isSameOrBeforeExports);
var isSameOrAfter$1 = {
    exports: {}
};
(function(module, exports) {
    !function(e, t) {
        module.exports = t();
    }(commonjsGlobal$1, function() {
        return function(e, t) {
            t.prototype.isSameOrAfter = function(e, t) {
                return this.isSame(e, t) || this.isAfter(e, t);
            };
        };
    });
})(isSameOrAfter$1);
var isSameOrAfterExports = isSameOrAfter$1.exports;
var isSameOrAfter = /*@__PURE__*/ getDefaultExportFromCjs(isSameOrAfterExports);
/* eslint-disable no-unused-vars */ const createValidator = (type, error)=>{
    let validator = (...args)=>({
            type,
            args,
            error
        });
    validator.error = error;
    return validator;
};
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
let validatorFns = {};
const INCLUDED_IN = "validator/INCLUDED_IN";
const INCLUDED_IN_ERROR = "error/INCLUDED_IN";
const includedIn = createValidator(INCLUDED_IN, INCLUDED_IN_ERROR);
validatorFns[INCLUDED_IN] = (value, args, form)=>Array.isArray(args[0]) ? args[0].includes(value) : args[0] === value;
const REQUIRED = "validator/REQUIRED";
const REQUIRED_ERROR = "error/REQUIRED";
const required = createValidator(REQUIRED, REQUIRED_ERROR);
validatorFns[REQUIRED] = (value, args, form)=>value !== "";
const ONLY_INTEGERS = "validator/ONLY_INTEGERS";
const ONLY_INTEGERS_ERROR = "error/ONLY_INTEGERS";
const onlyIntegers = createValidator(ONLY_INTEGERS, ONLY_INTEGERS_ERROR);
validatorFns[ONLY_INTEGERS] = (value, args, form)=>/^(-?\d+)?$/.test(value);
const ONLY_NATURALS = "validator/ONLY_NATURALS";
const ONLY_NATURALS_ERROR = "error/ONLY_NATURALS";
const onlyNaturals = createValidator(ONLY_NATURALS, ONLY_NATURALS_ERROR);
validatorFns[ONLY_NATURALS] = (value, args, form)=>/^(\d+)?$/.test(value);
/* 
07/22: experimental expiration date constraint
should allow entry of expiration date using "/" character
to accommodate browser autofill

not tested as validation function
to validate exp date instead use combo of:
required(), hasLength(), isValidMonth(), dateAfterToday()
*/ const ONLY_EXPIRATION_DATE = "validator/ONLY_EXPIRATION_DATE";
const ONLY_EXPIRATION_DATE_ERROR = "error/ONLY_EXPIRATION_DATE";
const onlyExpirationDate = createValidator(ONLY_EXPIRATION_DATE, ONLY_EXPIRATION_DATE_ERROR);
validatorFns[ONLY_EXPIRATION_DATE] = (value, args, form)=>/^(\d?\d?\/?\d?\d?)?$/.test(value);
/*
11/24 - Users have been adding full CC numbers to the name field
This validator will check if the value has more than 6 numeric characters
We have to allow for some numeric characters to account for business
names that include numbers like "3M Company" or "Smith Street Trust 40389"

1/25 - This has been superseded by the includesPotentialCardNumber validator
*/ const NO_MORE_THAN_SIX_NUMBERS = "validator/NO_MORE_THAN_SIX_NUMBERS";
const NO_MORE_THAN_SIX_NUMBERS_ERROR = "error/NO_MORE_THAN_SIX_NUMBERS";
createValidator(NO_MORE_THAN_SIX_NUMBERS, NO_MORE_THAN_SIX_NUMBERS_ERROR);
validatorFns[NO_MORE_THAN_SIX_NUMBERS] = (value)=>{
    if (value === "") return true;
    return !/(\d.*){7,}/.test(value);
};
/*
 * 1/25 - Prevent users from entering full credit card numbers in the "name" field.
 *
 * This validator is designed to reduce the accidental inclusion of credit card numbers
 * in fields where they don't belong (e.g., the name field). It identifies a potential
 * credit card number based on the following criteria:
 *
 * - It consists of 8 to 20 digits.
 * - Digits may be separated by optional spaces or hyphens.
 * - It must pass the Luhn algorithm check.
 *
 * Note:
 *   A string passing the Luhn algorithm is necessary but not sufficient to conclusively
 *   determine that the string is a valid credit card number.
 *
 * For more details on the Luhn algorithm, refer to:
 * https://stripe.com/en-ca/resources/more/how-to-use-the-luhn-algorithm-a-guide-in-applications-for-businesses#luhn-algorithm-formula
 */ function luhnValid(string) {
    if (!string) return false;
    // Extract all digit characters from the string.
    const digits = string.match(/\d/g);
    if (!digits) return false;
    let totalSum = 0;
    let shouldDouble = false;
    // Process digits from right to left
    for(let i = digits.length - 1; i >= 0; i--){
        // Convert the current character to a number.
        let digit = parseInt(digits[i], 10);
        // Double the digit and adjust if it exceeds 9.
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) // If the result of any doubling operation is greater than nine,
            // then add the digits of the result together to obtain a single-digit number.
            // This is equivalent to adding the digits together (e.g. 16: 1 + 6 = 7 = 16 - 9).
            digit -= 9;
        }
        // Add the processed digit to the total sum.
        totalSum += digit;
        // After doubling the value of the second-to-last digit, continue doing the same for every other digit.
        shouldDouble = !shouldDouble;
    }
    // The number is valid if totalSum is divisible by 10.
    return totalSum % 10 === 0;
}
const INCLUDES_POTENTIAL_CARD_NUMBER = "validator/INCLUDES_POTENTIAL_CARD_NUMBER";
const INCLUDES_POTENTIAL_CARD_NUMBER_ERROR = "error/INCLUDES_POTENTIAL_CARD_NUMBER";
const includesPotentialCardNumber = createValidator(INCLUDES_POTENTIAL_CARD_NUMBER, INCLUDES_POTENTIAL_CARD_NUMBER_ERROR);
validatorFns[INCLUDES_POTENTIAL_CARD_NUMBER] = (value)=>{
    // This is the same regex currently used in Ghenghis
    // A potential credit card number is a sequence of 8 to 20 digits, with optional spaces or hyphens between them
    const regexString = "(?:\\d[ -]*){8,20}";
    const regex = new RegExp(regexString);
    return !(luhnValid(value) && regex.test(value));
};
const NUMBER_LESS_THAN = "validator/NUMBER_LESS_THAN";
const NUMBER_LESS_THAN_ERROR = "error/NUMBER_LESS_THAN";
const numberLessThan = createValidator(NUMBER_LESS_THAN, NUMBER_LESS_THAN_ERROR);
validatorFns[NUMBER_LESS_THAN] = (value, args, form)=>{
    if (value === "") return true;
    return Number(value) < args[0];
};
const NUMBER_LESS_THAN_OR_EQUAL_TO = "validator/NUMBER_LESS_THAN_OR_EQUAL_TO";
const NUMBER_LESS_THAN_OR_EQUAL_TO_ERROR = "error/NUMBER_LESS_THAN_OR_EQUAL_TO";
const numberLessThanOrEqualTo = createValidator(NUMBER_LESS_THAN_OR_EQUAL_TO, NUMBER_LESS_THAN_OR_EQUAL_TO_ERROR);
validatorFns[NUMBER_LESS_THAN_OR_EQUAL_TO] = (value, args, form)=>{
    if (value === "") return true;
    return Number(value) <= args[0];
};
const NUMBER_GREATER_THAN = "validator/NUMBER_GREATER_THAN";
const NUMBER_GREATER_THAN_ERROR = "error/NUMBER_GREATER_THAN";
const numberGreaterThan = createValidator(NUMBER_GREATER_THAN, NUMBER_GREATER_THAN_ERROR);
validatorFns[NUMBER_GREATER_THAN] = (value, args, form)=>{
    if (value === "") return true;
    return Number(value) > args[0];
};
const NUMBER_GREATER_THAN_OR_EQUAL_TO = "validator/NUMBER_GREATER_THAN_OR_EQUAL_TO";
const NUMBER_GREATER_THAN_OR_EQUAL_TO_ERROR = "error/NUMBER_GREATER_THAN_OR_EQUAL_TO";
const numberGreaterThanOrEqualTo = createValidator(NUMBER_GREATER_THAN_OR_EQUAL_TO, NUMBER_GREATER_THAN_OR_EQUAL_TO_ERROR);
validatorFns[NUMBER_GREATER_THAN_OR_EQUAL_TO] = (value, args, form)=>{
    if (value === "") return true;
    return Number(value) >= args[0];
};
const MATCHES_FIELD = "validator/MATCHES_FIELD";
const MATCHES_FIELD_ERROR$1 = "error/MATCHES_FIELD";
const matchesField = createValidator(MATCHES_FIELD, MATCHES_FIELD_ERROR$1);
validatorFns[MATCHES_FIELD] = (value, args, form)=>{
    const dependentField = form[args[0]];
    if (dependentField === undefined) throw new Error(`${args[0]} was passed to matchesField, but that field does not exist in the form`);
    const dependentFieldValue = dependentField.rawValue;
    return value === dependentFieldValue;
};
const validateWhenErrorMessage = (type)=>`${type} was passed to validateWhen, but that validator type does not exist.
  Please check that you are only calling validator creator functions exported from
  redux-freeform in your form config and that you didn't forget to
  invoke the validator creator (you cannot pass the functions themselves to
  createFormState). Also make sure you aren't passing validateWhen() to validateWhen
  as the primary validator.`;
const VALIDATE_WHEN = "validator/VALIDATE_WHEN";
const VALIDATE_WHEN_ERROR = "error/VALIDATE_WHEN";
const validateWhen = (dependentValidator, primaryValidator, optionalFieldName)=>({
        type: VALIDATE_WHEN,
        args: [
            dependentValidator,
            primaryValidator,
            optionalFieldName
        ],
        error: dependentValidator.error
    });
validateWhen.error = VALIDATE_WHEN_ERROR;
validatorFns[VALIDATE_WHEN] = (value, args, form)=>{
    const [dependentValidator, primaryValidator, optionalFieldName] = args;
    const dependsOnOtherField = typeof optionalFieldName === "string";
    if (primaryValidator.type === undefined || typeof validatorFns[primaryValidator.type] !== "function") throw new Error(validateWhenErrorMessage(primaryValidator.type));
    if (dependsOnOtherField && form[optionalFieldName] === undefined) throw new Error(`${args[2]} was passed to matchesField, but that field does not exist in the form`);
    const primaryPredicate = validatorToPredicate(validatorFns[primaryValidator.type], false);
    const primaryValue = dependsOnOtherField ? form[optionalFieldName].rawValue : value;
    const primaryPredicatePassed = primaryPredicate(primaryValue, primaryValidator.args, form);
    return primaryPredicatePassed ? validatorFns[dependentValidator.type](value, dependentValidator.args, form) : true;
};
const validateSumErrorMessage = (type)=>`${type} was passed to validateSum, but that validator type does not exist.
  Please check that you are only calling validator creator functions exported from
  redux-freeform in your form config and that you didn't forget to
  invoke the validator creator (you cannot pass the functions themselves to
  createFormState).`;
const VALIDATE_SUM = "validator/VALIDATE_SUM";
validatorFns[VALIDATE_SUM] = (value, args, form)=>{
    const [validator, fieldNamesArray] = args;
    if (validator.type === undefined || typeof validatorFns[validator.type] !== "function") throw new Error(validateSumErrorMessage(validator.type));
    for (const fieldName of fieldNamesArray){
        if (form[fieldName] === undefined) throw new Error(`${fieldName} was passed to matchesField, but that field does not exist in the form`);
    }
    const sum = fieldNamesArray.reduce((acc, curr)=>acc + Number(form[curr].rawValue), Number(value));
    return validatorFns[validator.type](sum, validator.args, form);
};
const HAS_LENGTH = "validator/HAS_LENGTH";
const HAS_LENGTH_ERROR = "error/HAS_LENGTH";
const hasLength = createValidator(HAS_LENGTH, HAS_LENGTH_ERROR);
validatorFns[HAS_LENGTH] = (value, args, form)=>{
    if (value === "") return true;
    const min = args[0];
    const max = args[1];
    if (max == undefined || min == undefined) throw new Error("Max and min need to be defined for hasLength, both or one of them is undefined");
    if (max < min) throw new Error("hasLength validator was passed a min greater than the max");
    const valueLength = value.length;
    return max >= valueLength && valueLength >= min;
};
const DATE_BEFORE_TODAY = "validator/DATE_BEFORE_TODAY";
const DATE_BEFORE_TODAY_ERROR = "error/DATE_BEFORE_TODAY";
const dateBeforeToday = createValidator(DATE_BEFORE_TODAY, DATE_BEFORE_TODAY_ERROR);
validatorFns[DATE_BEFORE_TODAY] = (value, args, form)=>{
    if (value === "") return true;
    const dateFormat = args[0];
    const unit = args[1];
    const inclusive = args[2] || false;
    if (dateFormat == undefined || unit == undefined) throw new Error("Date format and unit need to be defined for dateBeforeToday, one or both are undefined");
    const now = dayjs();
    const dateValue = dayjs(value, dateFormat);
    if (inclusive === true) return dateValue.isSameOrBefore(now, unit);
    return dateValue.isBefore(now, unit);
};
const DATE_AFTER_TODAY = "validator/DATE_AFTER_TODAY";
const DATE_AFTER_TODAY_ERROR = "error/DATE_AFTER_TODAY";
const dateAfterToday = createValidator(DATE_AFTER_TODAY, DATE_AFTER_TODAY_ERROR);
validatorFns[DATE_AFTER_TODAY] = (value, args, form)=>{
    if (value === "") return true;
    const dateFormat = args[0];
    const unit = args[1];
    const inclusive = args[2] || false;
    if (dateFormat == undefined || unit == undefined) throw new Error("Date format and unit need to be defined for dateAfterToday, one or both are undefined");
    const now = dayjs();
    const dateValue = dayjs(value, dateFormat);
    if (inclusive === true) return dateValue.isSameOrAfter(now, unit);
    return dateValue.isAfter(now, unit);
};
const IS_VALID_MONTH = "validator/IS_VALID_MONTH";
const IS_VALID_MONTH_ERROR = "error/IS_VALID_MONTH";
const isValidMonth = createValidator(IS_VALID_MONTH, IS_VALID_MONTH_ERROR);
validatorFns[IS_VALID_MONTH] = (value, args, form)=>{
    if (value === "") return true;
    // Function takes one argument representing the character position
    // In a date string to identify where the month is
    // Eg "10/21/2021" - start position is 0
    // Or "18/03/1990" - start position is 3
    // Only works with two digit months (01, 02, 03, etc)
    const monthStartPosition = parseInt(args[0]);
    const monthEndPosition = monthStartPosition + 2;
    if (isNaN(monthStartPosition)) throw new Error("Month start position has to be a valid integer string");
    const month = parseInt(value.slice(monthStartPosition, monthEndPosition));
    if (isNaN(month)) return false;
    return month >= 1 && month <= 12;
};
const MATCHES_REGEX = "validator/MATCHES_REGEX";
const MATCHES_REGEX_ERROR = "error/MATCHES_REGEX";
const matchesRegex = createValidator(MATCHES_REGEX, MATCHES_REGEX_ERROR);
validatorFns[MATCHES_REGEX] = (value, args, form)=>{
    if (value === "") return true;
    return new RegExp(args[0]).test(value); // new RexExp never throws an error, no matter the input
};
// based on http://www.brainjar.com/js/validation/
const IS_ROUTING_NUMBER = "validator/IS_ROUTING_NUMBER";
const IS_ROUTING_NUMBER_ERROR = "error/IS_ROUTING_NUMBER";
const isRoutingNumber = createValidator(IS_ROUTING_NUMBER, IS_ROUTING_NUMBER_ERROR);
validatorFns[IS_ROUTING_NUMBER] = (value, args, form)=>{
    if (value === "") return true;
    if (value.length != 9) return false;
    const sum = value.split("").map((ch)=>parseInt(ch)).reduce((acc, cur, idx)=>{
        switch(idx % 3){
            case 0:
                return acc + 3 * cur;
            case 1:
                return acc + 7 * cur;
            case 2:
                return acc + 1 * cur;
        }
    }, 0);
    return sum != 0 && sum % 10 == 0;
};
const HAS_NUMBER = "validator/HAS_NUMBER";
const HAS_NUMBER_ERROR$1 = "error/HAS_NUMBER";
const hasNumber = createValidator(HAS_NUMBER, HAS_NUMBER_ERROR$1);
validatorFns[HAS_NUMBER] = (value, args, form)=>{
    if (value === "") return true;
    return new RegExp(/[0-9]/).test(value);
};
const HAS_LOWERCASE_LETTER = "validator/HAS_LOWERCASE_LETTER";
const HAS_LOWERCASE_LETTER_ERROR$1 = "error/HAS_LOWERCASE_LETTER";
const hasLowercaseLetter = createValidator(HAS_LOWERCASE_LETTER, HAS_LOWERCASE_LETTER_ERROR$1);
validatorFns[HAS_LOWERCASE_LETTER] = (value, args, form)=>{
    if (value === "") return true;
    return new RegExp(/[a-z]/).test(value);
};
const HAS_UPPERCASE_LETTER = "validator/HAS_UPPERCASE_LETTER";
const HAS_UPPERCASE_LETTER_ERROR$1 = "error/HAS_UPPERCASE_LETTER";
const hasUppercaseLetter = createValidator(HAS_UPPERCASE_LETTER, HAS_UPPERCASE_LETTER_ERROR$1);
validatorFns[HAS_UPPERCASE_LETTER] = (value, args, form)=>{
    if (value === "") return true;
    return new RegExp(/[A-Z]/).test(value);
};
const HAS_SPECIAL_CHARACTER = "validator/HAS_SPECIAL_CHARACTER";
const HAS_SPECIAL_CHARACTER_ERROR$1 = "error/HAS_SPECIAL_CHARACTER";
const hasSpecialCharacter = createValidator(HAS_SPECIAL_CHARACTER, HAS_SPECIAL_CHARACTER_ERROR$1);
validatorFns[HAS_SPECIAL_CHARACTER] = (value, args, form)=>{
    if (value === "") return true;
    return new RegExp(/[!@#$%^&*.?]/).test(value);
};
const IS_PROBABLY_EMAIL = "validator/IS_PROBABLY_EMAIL";
const IS_PROBABLY_EMAIL_ERROR = "error/IS_PROBABLY_EMAIL";
const isProbablyEmail = createValidator(IS_PROBABLY_EMAIL, IS_PROBABLY_EMAIL_ERROR);
validatorFns[IS_PROBABLY_EMAIL] = (value, args, form)=>{
    if (value === "") return true;
    return new RegExp(/^\S+@\S+\.\S+$/).test(value);
};
const VALID_NAME = "validator/VALID_NAME";
const VALID_NAME_ERROR = "validator/VALID_NAME_ERROR";
const validName = createValidator(VALID_NAME, VALID_NAME_ERROR);
validatorFns[VALID_NAME] = (value, args, form)=>value === "" ? false : new RegExp(/[A-zÀ-ÿ\-,'\S]+(\s?[A-zÀ-ÿ\-,'\S])*/).test(value);
const runValidatorErrorMessage = (type)=>`${type} was passed to runValidator, but that validator type does not exist. 
  Please check that you are only calling validator creator functions exported from 
  redux-freeform in your form config and that you didn't forget to 
  invoke the validator creator (you cannot pass the functions themselves to 
  createFormState)`;
const runValidator = (validator, value, form)=>{
    const validatorFn = validatorFns[validator.type];
    if (validatorFn === undefined) throw new Error(runValidatorErrorMessage(validator.type));
    return validatorFn(value, validator.args, form) ? null : validator.error;
};
const runFormValidators = (fieldName, form, validators)=>{
    return validators.map((v)=>runValidator(v, form[fieldName].rawValue, form)).filter((x)=>x !== null);
};
const computeConstraints = (fieldName, form)=>{
    const constraints = form[fieldName].constraints;
    return runFormValidators(fieldName, form, constraints);
};
const computeErrors = (fieldName, form)=>{
    const validators = form[fieldName].validators;
    return runFormValidators(fieldName, form, validators);
};
const computeErrorEntries = (formState)=>{
    const fields = Object.entries(formState);
    for (let entry of fields){
        let fieldName = entry[0];
        let errors = computeErrors(fieldName, formState);
        formState[fieldName].errors = errors;
        formState[fieldName].hasErrors = errors.length > 0;
    }
};
const computeDirtyEntries = (formState, changedFieldName)=>{
    const fields = Object.entries(formState);
    for (let entry of fields){
        let fieldName = entry[0];
        let field = entry[1];
        let dirty = fieldName === changedFieldName ? true : field.dirty;
        formState[fieldName].dirty = dirty;
    }
};
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a$1(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f$6(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c$1(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b$1(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function _() {
    return U;
}
function j(n, r) {
    r && (b$1("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b$1("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b$1("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b$1("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f$6(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b$1("MapSet").F(r, t) : v(r) ? b$1("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b$1("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b$1("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a$1(u.t, r) === t || f$6(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c$1(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b$1("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b$1("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce;
an.produceWithPatches.bind(an);
an.setAutoFreeze.bind(an);
an.setUseProxies.bind(an);
an.applyPatches.bind(an);
an.createDraft.bind(an);
an.finishDraft.bind(an);
var produce = fn;
const createInitialState = (formConfig)=>{
    let initialForm = {};
    const formConfigKeys = Object.keys(formConfig);
    for (let formKey of formConfigKeys)initialForm[formKey] = {
        dirty: false,
        rawValue: formConfig[formKey].defaultValue || "",
        validators: formConfig[formKey].validators || [],
        constraints: formConfig[formKey].constraints || []
    };
    // Because validators require the entire form we have to do a
    // second pass to add errors once the initial form has been
    // constructed
    for (let formKey of formConfigKeys){
        let errors = computeErrors(formKey, initialForm);
        initialForm[formKey].errors = errors;
        initialForm[formKey].hasErrors = errors.length > 0;
    }
    return initialForm;
};
const SET = "field/SET";
const set$1 = (fieldName)=>(value)=>({
            type: SET,
            payload: {
                fieldName,
                value
            }
        });
const CLEAR = "form/CLEAR";
const clear = ()=>({
        type: CLEAR
    });
const ADD_VALIDATOR = "field/ADD_VALIDATOR";
const addValidator = (fieldName)=>(validator)=>({
            type: ADD_VALIDATOR,
            payload: {
                fieldName,
                validator
            }
        });
const REMOVE_VALIDATOR = "field/REMOVE_VALIDATOR";
const removeValidator = (fieldName)=>(validator)=>({
            type: REMOVE_VALIDATOR,
            payload: {
                fieldName,
                validator
            }
        });
const CLEAR_FIELD_VALIDATORS = "field/CLEAR_FIELD_VALIDATORS";
const clearFieldValidators = (fieldName)=>()=>({
            type: CLEAR_FIELD_VALIDATORS,
            payload: {
                fieldName
            }
        });
const createFormReducer = (formConfig)=>(state = createInitialState(formConfig), action)=>{
        switch(action.type){
            case SET:
                {
                    const changedFieldName = action.payload.fieldName;
                    const newRawValue = action.payload.value;
                    return produce(state, (draftState)=>{
                        let originalValue = draftState[changedFieldName].rawValue;
                        draftState[changedFieldName].rawValue = newRawValue;
                        if (computeConstraints(changedFieldName, draftState).length > 0) {
                            // If the change violates constraints, revert the change
                            draftState[changedFieldName].rawValue = originalValue;
                            return draftState;
                        }
                        computeDirtyEntries(draftState, changedFieldName);
                        computeErrorEntries(draftState);
                    });
                }
            case CLEAR:
                return createInitialState(formConfig);
            case ADD_VALIDATOR:
                {
                    const fieldWithOverride = action.payload.fieldName;
                    const newValidator = action.payload.validator;
                    return produce(state, (draftState)=>{
                        draftState[fieldWithOverride].validators.push(newValidator);
                        computeErrorEntries(draftState);
                    });
                }
            case REMOVE_VALIDATOR:
                {
                    const fieldToOverride = action.payload.fieldName;
                    const targetValidator = action.payload.validator;
                    return produce(state, (draftState)=>{
                        let fieldValidators = draftState[fieldToOverride].validators;
                        draftState[fieldToOverride].validators = fieldValidators.filter((validator)=>validator.type !== targetValidator.type);
                        computeErrorEntries(draftState);
                    });
                }
            case CLEAR_FIELD_VALIDATORS:
                {
                    const fieldToClear = action.payload.fieldName;
                    return produce(state, (draftState)=>{
                        draftState[fieldToClear].validators = [];
                        computeErrorEntries(draftState);
                    });
                }
            default:
                return state;
        }
    };
const createMapDispatchToProps = (formConfig)=>{
    // Do memo-ization
    let cachedDispatch;
    let cacheValue;
    return (dispatch)=>{
        if (dispatch == cachedDispatch) return cacheValue;
        let dispatchObj = {};
        dispatchObj.fields = {};
        const keys = Object.keys(formConfig);
        for (let fieldName of keys)dispatchObj.fields[fieldName] = {
            set: (value)=>dispatch(set$1(fieldName)(value)),
            addValidator: (validator)=>dispatch(addValidator(fieldName)(validator)),
            removeValidator: (validator)=>dispatch(removeValidator(fieldName)(validator)),
            clear: ()=>dispatch(clearFieldValidators(fieldName)())
        };
        dispatchObj.form = {
            clear: ()=>dispatch(clear())
        };
        cachedDispatch = dispatch;
        cacheValue = {
            actions: dispatchObj
        };
        return cacheValue;
    };
};
const mapStateToProps = (state)=>({
        fields: state
    });
const createFormState = (formConfig)=>({
        reducer: createFormReducer(formConfig),
        mapDispatchToProps: createMapDispatchToProps(formConfig),
        mapStateToProps: mapStateToProps
    });
var formatDelimiter = "_";
var phoneFormats = [
    "",
    "_",
    "__",
    "(___) ",
    "(___) _",
    "(___) __",
    "(___) ___-",
    "(___) ___-_",
    "(___) ___-__",
    "(___) ___-___",
    "(___) ___-____"
];
var zipFormats = [
    "",
    "_",
    "__",
    "___",
    "____",
    "_____",
    "______",
    "_____-__",
    "_____-___",
    "_____-____"
];
var creditCardFormats = [
    "",
    "_",
    "__",
    "___",
    "____",
    "____ _",
    "____ __",
    "____ ___",
    "____ ____",
    "____ ____ _",
    "____ ____ __",
    "____ ____ ___",
    "____ ____ ____",
    "____ ____ ____ _",
    "____ ____ ____ __",
    "____ ____ ____ ___",
    "____ ____ ____ ____"
];
var moneyFormats = [
    "",
    "$0.0_",
    "$0.__",
    "$_.__",
    "$__.__",
    "$___.__",
    "$_,___.__",
    "$__,___.__",
    "$___,___.__",
    "$_,___,___.__",
    "$__,___,___.__",
    "$___,___,___.__",
    "$_,___,___,___.__",
    "$__,___,___,___.__",
    "$___,___,___,___.__",
    "$_,___,___,___,___.__"
];
var expirationDateFormats = [
    "",
    "_",
    "__/",
    "__/_",
    "__/__"
];
var zipFormat = createFormat(zipFormats, formatDelimiter);
var creditCardFormat = createFormat(creditCardFormats, formatDelimiter);
var expirationDateFormat = createFormat(expirationDateFormats, formatDelimiter);
var phoneFormat = createFormat(phoneFormats, formatDelimiter);
var moneyFormat = createFormat(moneyFormats, formatDelimiter);
var renderCardStatus = function renderCardStatus(expirationStatus, expireDate) {
    var textAlign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "right";
    var as = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "span";
    var ACTIVE = "ACTIVE";
    var EXPIRING_SOON = "EXPIRING_SOON";
    var EXPIRED = "EXPIRED";
    var textMargin = textAlign === "right" ? "auto" : "0";
    switch(expirationStatus){
        case ACTIVE:
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
                as: as,
                variant: "pXS",
                fontSize: ".75rem",
                color: STORM_GREY,
                extraStyles: "text-align: ".concat(textAlign, "; margin: ").concat(textMargin, ";")
            }, "Exp Date ", expireDate);
        case EXPIRING_SOON:
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
                as: as,
                variant: "pXS",
                fontSize: ".75rem",
                color: FIRE_YELLOW,
                extraStyles: "text-align: ".concat(textAlign, "; margin: ").concat(textMargin, ";")
            }, "Expiring Soon ", expireDate);
        case EXPIRED:
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
                as: as,
                variant: "pXS",
                fontSize: ".75rem",
                color: STORM_GREY,
                extraStyles: "text-align: ".concat(textAlign, "; margin: ").concat(textMargin, ";")
            }, "Expired");
    }
};
var formats = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formatDelimiter: formatDelimiter,
    phoneFormats: phoneFormats,
    moneyFormats: moneyFormats,
    expirationDateFormats: expirationDateFormats,
    zipFormat: zipFormat,
    creditCardFormat: creditCardFormat,
    expirationDateFormat: expirationDateFormat,
    phoneFormat: phoneFormat,
    moneyFormat: moneyFormat,
    renderCardStatus: renderCardStatus
});
var AddressForm = function AddressForm(_ref) {
    var _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "default" : _ref$variant, fields = _ref.fields, actions = _ref.actions, clearOnDismount = _ref.clearOnDismount, showErrors = _ref.showErrors, _ref$handleSubmit = _ref.handleSubmit, handleSubmit = _ref$handleSubmit === void 0 ? noop$1 : _ref$handleSubmit, showWalletCheckbox = _ref.showWalletCheckbox, saveToWallet = _ref.saveToWallet, walletCheckboxMarked = _ref.walletCheckboxMarked, _ref$dataQa = _ref.dataQa, dataQa = _ref$dataQa === void 0 ? null : _ref$dataQa;
    if (clearOnDismount) (0, _react.useEffect)(function() {
        return function() {
            return actions.form.clear();
        };
    }, []);
    var street1ErrorMessages = _defineProperty({}, required.error, "Street is required");
    var cityErrorMessages = _defineProperty({}, required.error, "City is required");
    var zipErrorMessages = _defineProperty(_defineProperty({}, required.error, "Zip code is required"), hasLength.error, "Zip code must be 5 or 9 digits");
    var stateProvinceErrorMessages = _defineProperty({}, required.error, "State or Province is required");
    var countryErrorMessages = _defineProperty({}, required.error, "Country is required");
    var isUS = fields.country.rawValue === "US";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormContainer$1, {
        variant: variant,
        role: "form",
        "aria-label": "Address",
        dataQa: dataQa
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(CountryDropdown, {
        labelTextWhenNoError: "Country",
        errorMessages: countryErrorMessages,
        field: fields.country,
        onChange: function onChange(value) {
            actions.fields.country.set(value);
            // temporary measure to not dirty fields until
            // we can write a reset function for fields
            if (fields.stateProvince.rawValue) actions.fields.stateProvince.set("");
            if (fields.zip.rawValue) actions.fields.zip.set("");
        },
        showErrors: showErrors,
        dataQa: "Country",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Address",
        errorMessages: street1ErrorMessages,
        field: fields.street1,
        fieldActions: actions.fields.street1,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "address-line1",
        dataQa: "Address",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Apt, Suite, Unit, Floor, etc. (Optional)",
        field: fields.street2,
        fieldActions: actions.fields.street2,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "address-line2",
        dataQa: "Address Line 2"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "City",
        errorMessages: cityErrorMessages,
        field: fields.city,
        fieldActions: actions.fields.city,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "address-level2",
        dataQa: "City",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormStateDropdown, {
        labelTextWhenNoError: isUS ? "State" : "State or Province",
        errorMessages: stateProvinceErrorMessages,
        countryCode: fields.country.rawValue || "US",
        field: fields.stateProvince,
        fieldActions: actions.fields.stateProvince,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        dataQa: "State or Province",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        isNum: isUS,
        formatter: isUS ? zipFormat : null,
        labelTextWhenNoError: "Zip code",
        errorMessages: zipErrorMessages,
        field: fields.zip,
        fieldActions: actions.fields.zip,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "postal-code",
        dataQa: "Zip code",
        isRequired: true
    }), showWalletCheckbox && /*#__PURE__*/ (0, _reactDefault.default).createElement(Checkbox$1, {
        name: "address checkbox",
        title: "Save address to wallet",
        checked: walletCheckboxMarked,
        onChange: saveToWallet
    })));
};
//TODO: Will make zip code able to have more than 5 digits once we add in the FormattedInput because it will have issues with format of 60606-1111.
var formConfig = {
    street1: {
        validators: [
            required()
        ]
    },
    street2: {
        validators: []
    },
    city: {
        validators: [
            required()
        ]
    },
    stateProvince: {
        validators: [
            required()
        ]
    },
    country: {
        defaultValue: "US",
        validators: [
            required()
        ]
    },
    zip: {
        validators: [
            required(),
            validateWhen(validateWhen(hasLength(5, 5), hasLength(0, 5)), matchesRegex("US"), "country"),
            validateWhen(validateWhen(hasLength(9, 9), hasLength(6, 9)), matchesRegex("US"), "country")
        ],
        constraints: [
            validateWhen(onlyIntegers(), matchesRegex("US"), "country"),
            validateWhen(hasLength(0, 9), matchesRegex("US"), "country")
        ]
    }
};
var _createFormState = createFormState(formConfig), reducer = _createFormState.reducer, mapStateToProps$1 = _createFormState.mapStateToProps, mapDispatchToProps = _createFormState.mapDispatchToProps;
AddressForm.reducer = reducer;
AddressForm.mapStateToProps = mapStateToProps$1;
AddressForm.mapDispatchToProps = mapDispatchToProps;
var backgroundColor$8 = "#ebeffb";
var fallbackValues$D = {
    backgroundColor: backgroundColor$8
};
var Banner = function Banner(_ref) {
    var themeValues = _ref.themeValues, heading = _ref.heading, subHeading = _ref.subHeading, Image = _ref.image, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? "0.5rem 1.5rem" : _ref$padding, _ref$mobilePadding = _ref.mobilePadding, mobilePadding = _ref$mobilePadding === void 0 ? "0.5rem 1rem" : _ref$mobilePadding, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? "100%" : _ref$minWidth, _ref$minHeight = _ref.minHeight, minHeight = _ref$minHeight === void 0 ? "auto" : _ref$minHeight, _ref$contentSpacing = _ref.contentSpacing, contentSpacing = _ref$contentSpacing === void 0 ? "3rem" : _ref$contentSpacing, _ref$mobileContentSpa = _ref.mobileContentSpacing, mobileContentSpacing = _ref$mobileContentSpa === void 0 ? "0.5rem" : _ref$mobileContentSpa;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(BoxWithShadow$1, {
        variant: "baseStandard",
        borderRadius: "4px",
        background: themeValues.backgroundColor,
        minWidth: minWidth,
        minHeight: minHeight,
        padding: isMobile ? mobilePadding : padding
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        childGap: isMobile ? mobileContentSpacing : contentSpacing,
        justify: "center",
        align: "center",
        nowrap: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        maxWidth: isMobile && "54%"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        variant: "small",
        as: "h2",
        weight: FONT_WEIGHT_SEMIBOLD
    }, heading), /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, null, subHeading))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        extraStyles: isMobile && "> svg { width: 176px; }"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Image, null))));
};
var Banner$1 = themeComponent(Banner, "Banner", fallbackValues$D);
var ChangePasswordForm = function ChangePasswordForm(_ref) {
    var clearOnDismount = _ref.clearOnDismount, fields = _ref.fields, actions = _ref.actions, _ref$handleSubmit = _ref.handleSubmit, handleSubmit = _ref$handleSubmit === void 0 ? noop$1 : _ref$handleSubmit, showErrors = _ref.showErrors, isMobile = _ref.isMobile, revenueManagement = _ref.revenueManagement, closeForm = _ref.closeForm, firstName = _ref.firstName, lastName = _ref.lastName;
    if (clearOnDismount) (0, _react.useEffect)(function() {
        return function() {
            return actions.form.clear();
        };
    }, []);
    var currentPasswordErrorMessages = _defineProperty({}, required.error, "Current Password is required");
    var newPasswordErrorMessages = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, required.error, "New Password field is required."), hasLength.error, "Your new password must have at least 8 characters"), hasNumber.error, "Your new password must contain at least one number"), hasLowercaseLetter.error, "Your new password must contain at least one lowercase letter"), hasUppercaseLetter.error, "Your new password must contain at least one uppercase letter"), hasSpecialCharacter.error, "Your new password must contain at least one special character (!@#$%^&*.?)");
    var confirmNewPasswordErrorMessages = _defineProperty({}, matchesField.error, "Confirm password must match your new password");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormContainer$1, {
        role: "form",
        "aria-label": "Change password",
        extraStyles: "padding: 0;"
    }, revenueManagement && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1.5rem",
        borderColor: GHOST_GREY,
        borderSize: "1px",
        borderWidthOverride: "0 0 1px 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "flex-start",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1.25rem",
        borderRadius: "50%",
        background: "#CACED8"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Heading$1, {
        variant: "h4",
        weight: "700"
    }, firstName.charAt(0).toUpperCase(), lastName.charAt(0).toUpperCase())), /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "p",
        weight: "700",
        extraStyles: "padding-left: 1rem;"
    }, firstName, " ", lastName))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Current password",
        errorMessages: currentPasswordErrorMessages,
        field: fields.currentPassword,
        fieldActions: actions.fields.currentPassword,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        type: "password",
        autocompleteValue: "current-password"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "New password",
        errorMessages: newPasswordErrorMessages,
        field: fields.newPassword,
        fieldActions: actions.fields.newPassword,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        type: "password",
        autocompleteValue: "new-password"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Confirm password",
        errorMessages: confirmNewPasswordErrorMessages,
        field: fields.confirmNewPassword,
        fieldActions: actions.fields.confirmNewPassword,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        type: "password",
        autocompleteValue: "new-password"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: isMobile ? "1rem 0 0" : "1.5rem 0 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PasswordRequirements, {
        password: fields.newPassword,
        isMobile: isMobile
    }))), revenueManagement && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1.5rem 0 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "1rem",
        direction: "row",
        justify: "flex-end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        text: "Cancel",
        action: closeForm,
        variant: "secondary",
        dataQa: "Cancel",
        extraStyles: "margin: 0rem; padding: 0.75rem 1.5rem; border-radius: 4px;"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        text: "Save",
        action: handleSubmit,
        variant: "primary",
        dataQa: "Save",
        extraStyles: "margin: 0rem; padding: 0.75rem 1.5rem; border-radius: 4px;"
    })))));
};
var formConfig$1 = {
    currentPassword: {
        validators: [
            required()
        ]
    },
    newPassword: {
        validators: [
            required(),
            hasLength(8, 100),
            hasNumber(),
            hasLowercaseLetter(),
            hasUppercaseLetter(),
            hasSpecialCharacter()
        ]
    },
    confirmNewPassword: {
        validators: [
            required(),
            matchesField("newPassword")
        ]
    }
};
var _createFormState$1 = createFormState(formConfig$1), reducer$1 = _createFormState$1.reducer, mapStateToProps$2 = _createFormState$1.mapStateToProps, mapDispatchToProps$1 = _createFormState$1.mapDispatchToProps;
ChangePasswordForm.reducer = reducer$1;
ChangePasswordForm.mapStateToProps = mapStateToProps$2;
ChangePasswordForm.mapDispatchToProps = mapDispatchToProps$1;
var titleColor$1 = "#292A33";
var headingBackgroundColor = "transparent";
var bodyBackgroundColor = "transparent";
var fallbackValues$E = {
    titleColor: titleColor$1,
    headingBackgroundColor: headingBackgroundColor,
    bodyBackgroundColor: bodyBackgroundColor
};
var CollapsibleSection = function CollapsibleSection(_ref) {
    var _label$replaceAll;
    var isOpen = _ref.isOpen, toggleSection = _ref.toggleSection, themeValues = _ref.themeValues, isMobile = _ref.isMobile, supportsTouch = _ref.supportsTouch, title = _ref.title, customPadding = _ref.customPadding, _ref$initiallyOpen = _ref.initiallyOpen, initiallyOpen = _ref$initiallyOpen === void 0 ? true : _ref$initiallyOpen, _ref$openHeight = _ref.openHeight, openHeight = _ref$openHeight === void 0 ? "auto" : _ref$openHeight, children = _ref.children, _ref$customTitle = _ref.customTitle, customTitle = _ref$customTitle === void 0 ? false : _ref$customTitle, _ref$stackTitle = _ref.stackTitle, stackTitle = _ref$stackTitle === void 0 ? false : _ref$stackTitle, stackTitleContent = _ref.stackTitleContent, _ref$sectionGap = _ref.sectionGap, sectionGap = _ref$sectionGap === void 0 ? "0.5rem" : _ref$sectionGap, _ref$name = _ref.name, name = _ref$name === void 0 ? "" : _ref$name, _ref$index = _ref.index, index = _ref$index === void 0 ? 1 : _ref$index, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles;
    var handleKeyDown = function handleKeyDown(e) {
        if (e.keyCode === ENTER) toggleSection();
    };
    var numChildren = typeof children === "Array" ? children.length : 1;
    var label = name !== "" ? name : !customTitle ? title : "collapsible section";
    var id = "".concat(label === null || label === void 0 || (_label$replaceAll = label.replaceAll) === null || _label$replaceAll === void 0 || (_label$replaceAll = _label$replaceAll.call(label, " ", "-")) === null || _label$replaceAll === void 0 ? void 0 : _label$replaceAll.toLowerCase(), "-").concat(index);
    var wrapper = {
        open: {
            height: openHeight,
            transition: {
                duration: 0.3,
                ease: [
                    0.04,
                    0.62,
                    0.23,
                    0.98
                ],
                staggerChildren: 0.15
            }
        },
        closed: {
            height: 0,
            transition: {
                duration: 0.3,
                ease: [
                    0.04,
                    0.62,
                    0.23,
                    0.98
                ],
                staggerChildren: 0.15,
                staggerDirection: -1,
                delay: numChildren * 0.35
            }
        }
    };
    var icon = {
        open: {
            rotate: "90deg"
        },
        closed: {
            rotate: "0deg"
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Motion, {
        padding: "0",
        hoverStyles: "outline: none;",
        animate: isOpen ? "open" : "closed",
        positionTransition: true
    }, stackTitle && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, stackTitleContent), /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: isOpen && !isMobile ? sectionGap : "0rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        role: "heading",
        "aria-label": label,
        "aria-level": 3
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: customPadding ? customPadding : "0",
        background: themeValues.headingBackgroundColor,
        onClick: isMobile && supportsTouch ? noop$1 : toggleSection,
        onTouchEnd: isMobile && supportsTouch ? toggleSection : noop$1,
        key: "header",
        hoverStyles: "cursor: pointer;",
        tabIndex: "0",
        onKeyDown: handleKeyDown,
        extraStyles: "z-index: 25; ".concat(extraStyles),
        role: "button",
        "aria-expanded": isOpen.toString(),
        "aria-controls": id,
        id: "".concat(id, "-button")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center"
    }, customTitle ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        width: "calc(100% - 36px)",
        padding: "0px"
    }, title) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        weight: FONT_WEIGHT_SEMIBOLD,
        color: themeValues.titleColor,
        as: "h6",
        variant: "small"
    }, title), /*#__PURE__*/ (0, _reactDefault.default).createElement(Motion, {
        variants: icon,
        extraStyles: "display: flex; align-items: center;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ChevronIcon$1, null))))), /*#__PURE__*/ (0, _reactDefault.default).createElement(AnimatePresence, {
        initial: false
    }, isOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement(Motion, {
        padding: "0",
        background: themeValues.bodyBackgroundColor,
        key: "content",
        positionTransition: true,
        initial: initiallyOpen ? "open" : "closed",
        exit: "closed",
        variants: wrapper,
        extraStyles: "transform-origin: 100% 0; overflow-y: hidden;",
        id: "".concat(id, "-content"),
        role: "region",
        "aria-labelledby": "".concat(id, "-button")
    }, children))));
};
var CollapsibleSection$1 = themeComponent(CollapsibleSection, "CollapsibleSection", fallbackValues$E);
var ClipboardIcon = function ClipboardIcon(_ref) {
    var themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_1104_623",
        style: {
            maskType: "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "4",
        y: "2",
        width: "16",
        height: "18"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.83929 3.43753H14.1607V5.59825H9.83929L9.83929 3.43753ZM8.75893 3.43753C8.75893 2.84087 9.24262 2.35718 9.83929 2.35718H14.1607C14.7574 2.35718 15.2411 2.84087 15.2411 3.43753V5.59825C15.2411 6.19491 14.7574 6.67861 14.1607 6.67861H9.83929C9.24262 6.67861 8.75893 6.19491 8.75893 5.59825V3.43753ZM6.59821 3.70762H7.94866V5.32816H6.59821C6.29988 5.32816 6.05804 5.57001 6.05804 5.86834V17.4822C6.05804 17.7805 6.29988 18.0224 6.59821 18.0224H17.4018C17.7001 18.0224 17.942 17.7805 17.942 17.4822V5.86834C17.942 5.57001 17.7001 5.32816 17.4018 5.32816H16.0513V3.70762H17.4018C18.5951 3.70762 19.5625 4.67501 19.5625 5.86834V17.4822C19.5625 18.6755 18.5951 19.6429 17.4018 19.6429H6.59821C5.40488 19.6429 4.4375 18.6755 4.4375 17.4822V5.86834C4.4375 4.67501 5.40488 3.70762 6.59821 3.70762Z",
        fill: themeValues.singleIconColor
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_1104_623)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: "24",
        height: "24",
        fill: themeValues.singleIconColor
    })));
};
var ClipboardIcon$1 = themeComponent(ClipboardIcon, "Icons", fallbackValues$b, "primary");
/* 
  Hook that assigns a click event listener to the main document element
  Returns a ref to attach to another element (like an icon/button that triggers a popover)
  If a click event gets captured by the document and the assigned element isn't the target
  hook will run whatever handler is passed (eg a function that closes a popover)

  See popover component for implementation

*/ var useOutsideClickHook = function useOutsideClickHook(handler) {
    var ref = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        var handleOutsideClick = function handleOutsideClick(e) {
            if (ref.current && !ref.current.contains(e.target)) handler();
        };
        document.addEventListener("click", handleOutsideClick, true);
        return function() {
            document.removeEventListener("click", handleOutsideClick, true);
        };
    }, [
        ref
    ]);
    return ref;
};
/* 
  Hook that takes an ID selector for an element on the screen
  And optionally values for top position, left position, smooth behavior
  Finds element on screen and scrolls it to the provided coordinates

  (string, number, number, string, number) => undefined;
*/ var useScrollTo = function useScrollTo(id) {
    var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var left = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var behavior = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "auto";
    var delay = arguments.length > 4 ? arguments[4] : undefined;
    var scrollItem;
    if (delay) setTimeout(function() {
        var _scrollItem;
        scrollItem = document.getElementById(id);
        (_scrollItem = scrollItem) === null || _scrollItem === void 0 || _scrollItem.scrollTo({
            top: top,
            left: left,
            behavior: behavior
        });
    }, delay);
    else {
        var _scrollItem2;
        scrollItem = document.getElementById(id);
        (_scrollItem2 = scrollItem) === null || _scrollItem2 === void 0 || _scrollItem2.scrollTo({
            top: top,
            left: left,
            behavior: behavior
        });
    }
};
var initialToastState = {
    isOpen: false,
    variant: "",
    message: ""
};
var useToastNotification = function useToastNotification() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$timeout = _ref.timeout, timeout = _ref$timeout === void 0 ? 5000 : _ref$timeout;
    var _useState = (0, _react.useState)(initialToastState), _useState2 = _slicedToArray(_useState, 2), toastState = _useState2[0], setToastState = _useState2[1];
    (0, _react.useEffect)(function() {
        if (toastState.isOpen && timeout > 0) setTimeout(function() {
            setToastState(initialToastState);
        }, timeout);
    }, [
        timeout,
        toastState.isOpen
    ]);
    var showToast = function showToast(_ref2) {
        var message = _ref2.message, variant = _ref2.variant;
        return setToastState({
            isOpen: true,
            variant: variant,
            message: message
        });
    };
    var hideToast = function hideToast() {
        return setToastState(initialToastState);
    };
    return {
        isToastOpen: toastState.isOpen,
        toastVariant: toastState.variant,
        toastMessage: toastState.message,
        showToast: showToast,
        hideToast: hideToast
    };
};
function useConditionallyAddValidator(condition, validatorFn, addValidator, removeValidator) {
    (0, _react.useEffect)(function() {
        if (condition) addValidator(validatorFn());
        return function() {
            // Remove validator when component unmounts
            removeValidator(validatorFn());
        };
    }, [
        condition,
        addValidator,
        removeValidator
    ]);
}
/**
 * A custom hook to dynamically load the Cloudflare Turnstile script.
 *
 * @param {string} verifyURL - The URL of the Turnstile verification script.
 */ var useTurnstileScript = function useTurnstileScript(verifyURL) {
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), scriptLoaded = _useState2[0], setScriptLoaded = _useState2[1];
    var _useState3 = (0, _react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), scriptError = _useState4[0], setScriptError = _useState4[1];
    var handleScriptError = function handleScriptError() {
        setScriptError(true);
        setScriptLoaded(false);
    };
    (0, _react.useEffect)(function() {
        if (typeof window === "undefined") {
            setScriptLoaded(false);
            return;
        }
        if (window.turnstile && window.turnstile.render) {
            setScriptLoaded(true);
            return;
        }
        var script = document.createElement("script");
        script.src = "".concat(verifyURL, "?render=explicit");
        script.onload = function() {
            setScriptLoaded(true);
        };
        script.onerror = function() {
            handleScriptError();
        };
        script.onabort = function() {
            handleScriptError();
        };
        script.defer = true;
        document.getElementsByTagName("head")[0].appendChild(script);
        return function() {
            setScriptLoaded(false);
            setScriptError(false);
        };
    }, [
        verifyURL
    ]);
    return {
        scriptLoaded: scriptLoaded,
        scriptError: scriptError
    };
};
var index$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    useOutsideClick: useOutsideClickHook,
    useScrollTo: useScrollTo,
    useToastNotification: useToastNotification,
    useConditionallyAddValidator: useConditionallyAddValidator,
    useTurnstileScript: useTurnstileScript,
    useUniqueId: useUniqueId
});
var hoverColor$3 = "#116285";
var activeColor$7 = "#0E506D";
var popoverTriggerColor = "#15749D";
var fallbackValues$F = {
    hoverColor: hoverColor$3,
    activeColor: activeColor$7,
    popoverTriggerColor: popoverTriggerColor
};
var Popover = function Popover(_ref) {
    var themeValues = _ref.themeValues, _ref$triggerText = _ref.triggerText, triggerText = _ref$triggerText === void 0 ? "" : _ref$triggerText, _ref$content = _ref.content, content = _ref$content === void 0 ? "" : _ref$content, _ref$hasIcon = _ref.hasIcon, hasIcon = _ref$hasIcon === void 0 ? false : _ref$hasIcon, Icon = _ref.icon, _ref$iconHelpText = _ref.iconHelpText, iconHelpText = _ref$iconHelpText === void 0 ? "" : _ref$iconHelpText, _ref$popoverID = _ref.popoverID, popoverID = _ref$popoverID === void 0 ? 0 : _ref$popoverID, _ref$popoverFocus = _ref.popoverFocus, popoverFocus = _ref$popoverFocus === void 0 ? false : _ref$popoverFocus, extraStyles = _ref.extraStyles, textExtraStyles = _ref.textExtraStyles, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? "250px" : _ref$minWidth, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? "300px" : _ref$maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? "auto" : _ref$height, position = _ref.position, arrowPosition = _ref.arrowPosition, _ref$arrowDirection = _ref.arrowDirection, arrowDirection = _ref$arrowDirection === void 0 ? "down" : _ref$arrowDirection, _ref$transform = _ref.transform, transform = _ref$transform === void 0 ? "none" : _ref$transform, buttonExtraStyles = _ref.buttonExtraStyles, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? "white" : _ref$backgroundColor, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "rgba(255, 255, 255, 0.85)" : _ref$borderColor, popoverExtraStyles = _ref.popoverExtraStyles;
    var hoverColor = themeValues.hoverColor, activeColor = themeValues.activeColor, popoverTriggerColor = themeValues.popoverTriggerColor;
    var _ref2 = position !== null && position !== void 0 ? position : {}, _ref2$top = _ref2.top, top = _ref2$top === void 0 ? "-110px" : _ref2$top, _ref2$right = _ref2.right, right = _ref2$right === void 0 ? "auto" : _ref2$right, _ref2$bottom = _ref2.bottom, bottom = _ref2$bottom === void 0 ? "auto" : _ref2$bottom, _ref2$left = _ref2.left, left = _ref2$left === void 0 ? "-225px" : _ref2$left;
    var _ref3 = arrowPosition !== null && arrowPosition !== void 0 ? arrowPosition : {}, _ref3$arrowTop = _ref3.arrowTop, arrowTop = _ref3$arrowTop === void 0 ? "auto" : _ref3$arrowTop, _ref3$arrowRight = _ref3.arrowRight, arrowRight = _ref3$arrowRight === void 0 ? "10px" : _ref3$arrowRight, _ref3$arrowBottom = _ref3.arrowBottom, arrowBottom = _ref3$arrowBottom === void 0 ? "-8px" : _ref3$arrowBottom, _ref3$arrowLeft = _ref3.arrowLeft, arrowLeft = _ref3$arrowLeft === void 0 ? "auto" : _ref3$arrowLeft;
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), popoverOpen = _useState2[0], togglePopover = _useState2[1];
    var handleTogglePopover = function handleTogglePopover(popoverState) {
        if (popoverOpen !== popoverState) togglePopover(popoverState);
    };
    var triggerRef = useOutsideClickHook(function() {
        return handleTogglePopover(false);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        extraStyles: "position: relative; ".concat(extraStyles)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        action: function action() {
            return noop$1;
        },
        onFocus: function onFocus() {
            handleTogglePopover(true);
        },
        onBlur: function onBlur() {
            handleTogglePopover(false);
        },
        onKeyDown: function onKeyDown(e) {
            if (e.keyCode === ESCAPE) handleTogglePopover(false);
        },
        onTouchStart: function onTouchStart() {
            return handleTogglePopover(true);
        },
        onTouchEnd: function onTouchEnd() {
            return handleTogglePopover(false);
        },
        onMouseEnter: function onMouseEnter() {
            return handleTogglePopover(true);
        },
        onMouseLeave: function onMouseLeave() {
            return handleTogglePopover(false);
        },
        contentOverride: true,
        variant: "smallGhost",
        tabIndex: "0",
        id: "btnPopover".concat(popoverID),
        "aria-expanded": popoverOpen,
        "aria-labelledby": "btnPopover".concat(popoverID, "_info Disclosure").concat(popoverID),
        "aria-describedby": "Disclosure".concat(popoverID),
        "aria-controls": "Disclosed".concat(popoverID),
        ref: triggerRef,
        extraStyles: buttonExtraStyles
    }, hasIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        srOnly: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        id: "btnPopover".concat(popoverID, "_info")
    }, iconHelpText))), !hasIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        color: popoverTriggerColor,
        extraStyles: "&:active { color: ".concat(activeColor, "; } &:hover { color: ").concat(hoverColor, " }; ").concat(textExtraStyles)
    }, triggerText)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: backgroundColor,
        borderRadius: "4px",
        boxShadow: "0px 2px 14px 0px rgb(246, 246, 249), 0px 3px 8px 0px rgb(202, 206, 216)",
        id: "Disclosed".concat(popoverID),
        role: "region",
        "aria-describedby": "Disclosure".concat(popoverID),
        tabIndex: popoverFocus && popoverOpen ? "0" : "-1",
        minWidth: minWidth,
        maxWidth: maxWidth,
        extraStyles: "\n          display: ".concat(popoverOpen ? "block" : "none", "; \n          position: absolute; \n          top: ").concat(top, "; \n          right: ").concat(right, "; \n          bottom: ").concat(bottom, "; \n          left: ").concat(left, ";\n          height: ").concat(height, ";\n          transform: ").concat(transform, ";\n          ").concat(popoverExtraStyles, ";\n          ")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, null, content), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        extraStyles: '\n            position: absolute;\n            content: "";\n            width: 0;\n            height: 0;\n            '.concat(arrowBorder(borderColor, arrowDirection, "8px"), ";\n            filter: drop-shadow(2px 8px 14px black);\n            bottom: ").concat(arrowBottom, ";\n            right: ").concat(arrowRight, ";\n            top: ").concat(arrowTop, ";\n            left: ").concat(arrowLeft, ";\n          ")
    })));
};
var Popover$1 = themeComponent(Popover, "Popover", fallbackValues$F);
/*
This component will render `content` and a clipboard icon.
When hovered, a popover with content `initialPopoverContent` will be displayed.
to the left of the content.

When clicked, `content` will be copied to the clipboard, the popover content
will change to `copySuccessPopoverContent` for `copiedPopoverContentDuration`
milliseconds, and the `onCopy` callback will be executed.

If the content was unable to be copied to the clipboard, the popover will instead
display `copyErrorPopoverContent`

If you only want the copy to clipboard behaviour without a popover, pass the prop
`hasPopover={false}`
*/ var CopyableContent = function CopyableContent(_ref) {
    var content = _ref.content, onClick = _ref.onClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        "data-testid": "copyable-trigger",
        contentOverride: true,
        action: onClick,
        variant: "ghost",
        extraStyles: "padding: 0; margin: 0; min-height: initial; min-width: initial"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        direction: "row",
        childGap: "0.25rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, null, content), /*#__PURE__*/ (0, _reactDefault.default).createElement(ClipboardIcon$1, null)));
};
var Copyable = function Copyable(_ref2) {
    var content = _ref2.content, onCopy = _ref2.onCopy, _ref2$initialPopoverC = _ref2.initialPopoverContent, initialPopoverContent = _ref2$initialPopoverC === void 0 ? "Click to copy to clipboard" : _ref2$initialPopoverC, _ref2$copySuccessPopo = _ref2.copySuccessPopoverContent, copySuccessPopoverContent = _ref2$copySuccessPopo === void 0 ? "Copied!" : _ref2$copySuccessPopo, _ref2$copyErrorPopove = _ref2.copyErrorPopoverContent, copyErrorPopoverContent = _ref2$copyErrorPopove === void 0 ? "Unable to copy value" : _ref2$copyErrorPopove, _ref2$copiedPopoverCo = _ref2.copiedPopoverContentDuration, copiedPopoverContentDuration = _ref2$copiedPopoverCo === void 0 ? 1000 : _ref2$copiedPopoverCo, _ref2$hasPopover = _ref2.hasPopover, hasPopover = _ref2$hasPopover === void 0 ? true : _ref2$hasPopover, _ref2$popoverMinWidth = _ref2.popoverMinWidth, popoverMinWidth = _ref2$popoverMinWidth === void 0 ? "max-content" : _ref2$popoverMinWidth, _ref2$popoverID = _ref2.popoverID, popoverID = _ref2$popoverID === void 0 ? 0 : _ref2$popoverID, popoverExtraStyles = _ref2.popoverExtraStyles;
    var _useState = (0, _react.useState)(initialPopoverContent), _useState2 = _slicedToArray(_useState, 2), popoverContent = _useState2[0], setPopoverContent = _useState2[1];
    var _useState3 = (0, _react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), startTimer = _useState4[0], setStartTimer = _useState4[1];
    var _useState5 = (0, _react.useState)(false), _useState6 = _slicedToArray(_useState5, 2), attemptCopy = _useState6[0], setAttemptCopy = _useState6[1];
    var _useState7 = (0, _react.useState)(null), _useState8 = _slicedToArray(_useState7, 2), timeoutId = _useState8[0], setTimeoutId = _useState8[1];
    var cleanup = function cleanup() {
        if (timeoutId) clearTimeout(timeoutId);
    };
    (0, _react.useEffect)(function() {
        if (startTimer) {
            if (timeoutId) // If there's an active timeout, clean it up.
            cleanup();
            // Start a timeout to restore popover content to the initial value.
            // Record the ID of the timeout so it can be cleaned up later.
            setTimeoutId(setTimeout(function() {
                setPopoverContent(initialPopoverContent);
            }, copiedPopoverContentDuration));
            // Set startTimer to false immediately after starting the timer,
            // so subsequent clicks will start a new timer, refreshing the duration.
            setStartTimer(false);
        }
        // Return cleanup function so timeout will be cleared when component unmounts.
        return cleanup;
    }, [
        startTimer
    ]);
    (0, _react.useEffect)(function() {
        if (attemptCopy) navigator.clipboard.writeText(content).then(function() {
            setPopoverContent(copySuccessPopoverContent);
            onCopy === null || onCopy === void 0 || onCopy();
            setAttemptCopy(false);
        })["catch"](function(error) {
            console.error(error);
            setPopoverContent(copyErrorPopoverContent);
            setAttemptCopy(false);
        });
    }, [
        attemptCopy
    ]);
    var onClick = function onClick() {
        setStartTimer(true);
        setAttemptCopy(true);
    };
    var popoverArrowWidth = "8px";
    return hasPopover ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Popover$1, {
        minWidth: popoverMinWidth,
        position: {
            top: "auto",
            right: "auto",
            bottom: "auto",
            left: "calc(-".concat(popoverArrowWidth, " - 8px)")
        },
        arrowPosition: {
            arrowTop: "auto",
            arrowRight: "-8px",
            arrowBottom: "calc(50% - ".concat(popoverArrowWidth, ")"),
            arrowLeft: "auto"
        },
        transform: "translate(-100%, -75%)",
        arrowDirection: "right",
        popoverID: popoverID,
        buttonExtraStyles: "margin: 0;min-width:auto",
        extraStyles: popoverExtraStyles,
        triggerText: CopyableContent({
            content: content,
            onClick: onClick
        }),
        content: popoverContent
    }) : CopyableContent({
        content: content,
        onClick: onClick
    });
};
var EditNameForm = function EditNameForm(_ref) {
    var fields = _ref.fields, actions = _ref.actions, clearOnDismount = _ref.clearOnDismount, showErrors = _ref.showErrors, _ref$handleSubmit = _ref.handleSubmit, handleSubmit = _ref$handleSubmit === void 0 ? noop$1 : _ref$handleSubmit;
    if (clearOnDismount) (0, _react.useEffect)(function() {
        return function() {
            return actions.form.clear();
        };
    }, []);
    var firstNameErrorMessages = _defineProperty({}, required.error, "First name is required");
    var lastNameErrorMessages = _defineProperty({}, required.error, "Last name is required");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormContainer$1, {
        role: "form",
        "aria-label": "Edit name"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "First Name",
        dataQa: "Edit First Name",
        errorMessages: firstNameErrorMessages,
        field: fields.firstName,
        fieldActions: actions.fields.firstName,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "given-name"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Last Name",
        dataQa: "Edit Last Name",
        errorMessages: lastNameErrorMessages,
        field: fields.lastName,
        fieldActions: actions.fields.lastName,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "family-name"
    })));
};
var formConfig$2 = {
    firstName: {
        validators: [
            required()
        ]
    },
    lastName: {
        validators: [
            required()
        ]
    }
};
var _createFormState$2 = createFormState(formConfig$2), reducer$2 = _createFormState$2.reducer, mapStateToProps$3 = _createFormState$2.mapStateToProps, mapDispatchToProps$2 = _createFormState$2.mapDispatchToProps;
EditNameForm.reducer = reducer$2;
EditNameForm.mapStateToProps = mapStateToProps$3;
EditNameForm.mapDispatchToProps = mapDispatchToProps$2;
var EditableListItem = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableListstyled__EditableListItem",
    componentId: "sc-10ehkz7-0"
})([
    "box-sizing:border-box;background:",
    ";border-color:",
    ";height:",
    ";display:flex;justify-content:space-between;align-items:center;padding:1.5rem;:not(:last-child),:not(:first-child){box-shadow:inset 0px -1px 0px 0px rgb(202,206,216);}:first-child{border-top-left-radius:3px;border-top-right-radius:3px;}:last-child{border-bottom-left-radius:3px;border-bottom-right-radius:3px;box-shadow:none;}"
], function(_ref) {
    var disabled = _ref.disabled;
    return disabled ? "rgba(246, 246, 249, 0.7)" : WHITE;
}, GHOST_GREY, function(_ref2) {
    var listItemSize = _ref2.listItemSize;
    return listItemSize === "big" ? "120px" : "72px";
});
var EditableListItemControls = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableListstyled__EditableListItemControls",
    componentId: "sc-10ehkz7-1"
})([
    "display:flex;justify-content:space-evenly;align-items:center;"
]);
var ACTIVE = "ACTIVE";
var EXPIRED = "EXPIRED";
var EditableList = function EditableList(_ref) {
    var _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, _ref$titleWeight = _ref.titleWeight, titleWeight = _ref$titleWeight === void 0 ? "400" : _ref$titleWeight, _ref$canAdd = _ref.canAdd, canAdd = _ref$canAdd === void 0 ? true : _ref$canAdd, addItem = _ref.addItem, addItemDestination = _ref.addItemDestination, removeItem = _ref.removeItem, editItem = _ref.editItem, itemName = _ref.itemName, renderItem = _ref.renderItem, items = _ref.items, _ref$canEdit = _ref.canEdit, canEdit = _ref$canEdit === void 0 ? true : _ref$canEdit, _ref$canRemove = _ref.canRemove, canRemove = _ref$canRemove === void 0 ? true : _ref$canRemove, _ref$listItemSize = _ref.listItemSize, listItemSize = _ref$listItemSize === void 0 ? "small" : _ref$listItemSize, maxItems = _ref.maxItems, _ref$useModal = _ref.useModal, useModal = _ref$useModal === void 0 ? false : _ref$useModal, Modal = _ref.modal, modalProps = _ref.modalProps, autoPayMethods = _ref.autoPayMethods, _ref$as = _ref.as, as = _ref$as === void 0 ? "p" : _ref$as, _ref$listPadding = _ref.listPadding, listPadding = _ref$listPadding === void 0 ? "0rem 0rem 1.5rem 0rem" : _ref$listPadding, qaPrefix = _ref.qaPrefix, ariaLabel = _ref.ariaLabel, _ref$editItemAriaRole = _ref.editItemAriaRole, editItemAriaRole = _ref$editItemAriaRole === void 0 ? "" : _ref$editItemAriaRole, _ref$disablePlacehold = _ref.disablePlaceholder, disablePlaceholder = _ref$disablePlacehold === void 0 ? false : _ref$disablePlacehold, _ref$getEditHref = _ref.getEditHref, getEditHref = _ref$getEditHref === void 0 ? null : _ref$getEditHref;
    var addText = "Add a".concat(itemName[0].match(/[aieouAIEOU]/) ? "n" : "", " ").concat(itemName);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: listPadding,
        as: "section",
        "aria-labelledby": typeof title === "string" ? "editable-list-".concat(createIdFromString(title)) : "",
        "aria-label": !title && typeof itemName === "string" ? "editable-list-".concat(createIdFromString(itemName)) : ""
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "0rem"
    }, title !== "" && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0rem 0rem 0.5rem 0rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        as: as,
        weight: titleWeight,
        color: CHARADE_GREY,
        extraStyles: "letter-spacing: 0.29px; font-size: 1.125rem;",
        id: typeof title === "string" ? "editable-list-".concat(createIdFromString(title)) : ""
    }, title)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        borderRadius: "4px",
        extraStyles: "box-shadow: 0px 2px 14px 0px rgb(246, 246, 249),\n    0px 3px 8px 0px rgb(202, 206, 216);"
    }, items.map(function(item) {
        var _item$expirationStatu;
        var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), modalOpen = _useState2[0], toggleModal = _useState2[1];
        var expiredItem = (_item$expirationStatu = item === null || item === void 0 ? void 0 : item.expirationStatus) !== null && _item$expirationStatu !== void 0 ? _item$expirationStatu : ACTIVE;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(EditableListItem, {
            listItemSize: !!item.id && autoPayMethods !== null && autoPayMethods !== void 0 && autoPayMethods.some(function(methodID) {
                return methodID === item.id;
            }) ? "big" : listItemSize,
            key: item.id || item,
            disabled: expiredItem === EXPIRED
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
            variant: "p",
            color: CHARADE_GREY
        }, !!renderItem && typeof renderItem === "function" && renderItem(item)), /*#__PURE__*/ (0, _reactDefault.default).createElement(EditableListItemControls, null, item.isPrimary && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
            variant: "p",
            color: STORM_GREY,
            extraStyles: "font-style: italic;",
            key: "Default ".concat(itemName)
        }, "Default ", itemName), canRemove && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0 0.5rem",
            border: "2px solid transparent",
            extraStyles: ":not(:first-child) { border-left: 2px solid ".concat(BOSTON_BLUE, ";}"),
            dataQa: qaPrefix + " Remove",
            key: "Remove ".concat(item.id)
        }, useModal ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Modal, _extends({
            item: _objectSpread2({}, item)
        }, modalProps, {
            modalOpen: modalOpen,
            toggleModal: toggleModal
        })) : /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
            variant: "smallGhost",
            text: "Remove",
            action: function action() {
                return removeItem(item.id);
            },
            extraStyles: "min-width: 0;",
            "aria-label": "Remove ".concat(ariaLabel || itemName)
        })), canEdit && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0 0.5rem",
            border: "2px solid transparent",
            extraStyles: ":not(:first-child) { border-left: 2px solid ".concat(BOSTON_BLUE, ";}"),
            dataQa: qaPrefix + " Edit",
            key: "Edit ".concat(item.id)
        }, getEditHref ? /*#__PURE__*/ (0, _reactDefault.default).createElement(InternalLink, {
            to: getEditHref(item),
            fontWeight: "400",
            extraStyles: "margin: 0.5rem; min-width: 0;",
            "aria-label": "Edit ".concat(ariaLabel || itemName)
        }, "Edit") : /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
            variant: "smallGhost",
            text: "Edit",
            action: function action() {
                return editItem(item.id);
            },
            extraStyles: "min-width: 0;",
            "aria-label": "Edit ".concat(ariaLabel || itemName),
            role: editItemAriaRole
        }))));
    })), canAdd && (!maxItems || items.length < maxItems) && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: items.length === 0 ? "0" : "1rem 0 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Placeholder$1, {
        text: addText,
        isLink: !!addItemDestination,
        destination: addItemDestination,
        action: addItem,
        dataQa: "Add " + qaPrefix,
        "aria-label": addText,
        isDisabled: disablePlaceholder
    }))));
};
var EditableTableContainer = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableTablestyled__EditableTableContainer",
    componentId: "sc-fd3i2a-0"
})([
    "display:",
    ";flex-direction:column;flex:1;"
], function(_ref) {
    var hide = _ref.hide;
    return hide ? "none" : "flex";
});
var EditableTableListItem = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableTablestyled__EditableTableListItem",
    componentId: "sc-fd3i2a-1"
})([
    "width:100%;display:flex;",
    ";align-items:",
    ";flex-direction:",
    ";flex:1;",
    ";"
], function(_ref2) {
    var isMobile = _ref2.isMobile;
    return isMobile && "justify-content: center";
}, function(_ref3) {
    var isMobile = _ref3.isMobile;
    return isMobile ? "flex-start" : "center";
}, function(_ref4) {
    var isMobile = _ref4.isMobile;
    return isMobile ? "column" : "row";
}, function(_ref5) {
    var isMobile = _ref5.isMobile;
    return isMobile ? "padding: 1rem 0.5rem" : "padding: 0 0.5rem";
});
var EditableListItemControls$1 = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableTablestyled__EditableListItemControls",
    componentId: "sc-fd3i2a-2"
})([
    "display:flex;justify-content:space-evenly;align-items:center;"
]);
var EditableListAction = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableTablestyled__EditableListAction",
    componentId: "sc-fd3i2a-3"
})([
    "color:",
    ";align-items:center;font-size:1rem;padding-right:1rem;cursor:pointer;display:",
    ";"
], MATISSE_BLUE, function(_ref6) {
    var hide = _ref6.hide;
    return hide ? "none" : "flex";
});
var ItemWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableTablestyled__ItemWrapper",
    componentId: "sc-fd3i2a-4"
})([
    "display:flex;flex-direction:row;flex:1;width:100%;border-bottom:1px solid ",
    ";"
], GHOST_GREY);
var ActionWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableTablestyled__ActionWrapper",
    componentId: "sc-fd3i2a-5"
})([
    "display:flex;align-self:center;justify-content:flex-end;",
    ";flex:1;"
], function(_ref7) {
    var isMobile = _ref7.isMobile;
    return isMobile && "display: none";
});
var TableItemKey = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableTablestyled__TableItemKey",
    componentId: "sc-fd3i2a-6"
})([
    "display:flex;",
    ";",
    ";",
    ";font-size:",
    ";color:",
    ";"
], function(_ref8) {
    var isMobile = _ref8.isMobile;
    return !isMobile && "flex: 1";
}, function(_ref9) {
    var isMobile = _ref9.isMobile;
    return isMobile && "align-items: center";
}, function(_ref10) {
    var isMobile = _ref10.isMobile;
    return !isMobile && "padding: 1.25rem 0";
}, function(_ref11) {
    var isMobile = _ref11.isMobile;
    return isMobile ? "1rem" : "1.125rem";
}, STORM_GREY);
var TableItemValue = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableTablestyled__TableItemValue",
    componentId: "sc-fd3i2a-7"
})([
    "display:flex;",
    ";",
    ";",
    ";font-size:",
    ";color:",
    ";"
], function(_ref12) {
    var isMobile = _ref12.isMobile;
    return !isMobile && "flex: 1";
}, function(_ref13) {
    var isMobile = _ref13.isMobile;
    return !isMobile && "padding: 1.25rem 0";
}, function(_ref14) {
    var isMobile = _ref14.isMobile;
    return isMobile && "align-items: center";
}, function(_ref15) {
    var isMobile = _ref15.isMobile;
    return isMobile ? "1.125rem" : "1.0625rem";
}, BRIGHT_GREY);
var TableWrapper = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "EditableTablestyled__TableWrapper",
    componentId: "sc-fd3i2a-8"
})([
    "display:flex;flex-direction:row;flex:1;width:100%;"
]);
var EditableTable = function EditableTable(_ref) {
    var title = _ref.title, renderItem = _ref.renderItem, items = _ref.items, isMobile = _ref.isMobile;
    var titleChild = title && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 0 0.5rem 0.5rem",
        borderSize: "1px",
        borderColor: GHOST_GREY,
        borderWidthOverride: "0 0 1px 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: "pL",
        weight: FONT_WEIGHT_SEMIBOLD
    }, title));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(EditableTableContainer, {
        isMobile: isMobile
    }, safeChildren(titleChild, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null)), /*#__PURE__*/ (0, _reactDefault.default).createElement(TableWrapper, null, renderItem(items)));
};
var TableListItem = function TableListItem(_ref) {
    var title = _ref.title, value = _ref.value, _ref$canEdit = _ref.canEdit, canEdit = _ref$canEdit === void 0 ? false : _ref$canEdit, _ref$canRemove = _ref.canRemove, canRemove = _ref$canRemove === void 0 ? false : _ref$canRemove, isMobile = _ref.isMobile, borderTopItem = _ref.borderTopItem;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0px",
        extraStyles: "&:last-child {\n    > * {\n      border-bottom: none;\n    }\n  }\n  ".concat(isMobile && borderTopItem && "&:first-child {\n    > * {\n      border-top: 1px solid ".concat(GHOST_GREY, ";\n    }\n  }"), "\n  ")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ItemWrapper, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(EditableTableListItem, {
        isMobile: isMobile
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TableItemKey, {
        isMobile: isMobile
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pS",
        color: CHARADE_GREY
    }, title)), /*#__PURE__*/ (0, _reactDefault.default).createElement(TableItemValue, {
        isMobile: isMobile
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "p",
        color: CHARADE_GREY
    }, value)), canRemove || canEdit ? /*#__PURE__*/ (0, _reactDefault.default).createElement(ActionWrapper, {
        isMobile: isMobile
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(EditableListAction, {
        hide: !canRemove,
        onClick: function onClick() {
            return console.log("Remove Item Coming Soon...");
        }
    }, "Remove"), /*#__PURE__*/ (0, _reactDefault.default).createElement(EditableListAction, {
        hide: !canEdit,
        onClick: function onClick() {
            return console.log("Edit Item Coming Soon...");
        }
    }, "Edit")) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null))));
};
var EmailForm = function EmailForm(_ref) {
    var _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "default" : _ref$variant, clearOnDismount = _ref.clearOnDismount, fields = _ref.fields, actions = _ref.actions, showErrors = _ref.showErrors, guestCheckout = _ref.guestCheckout, _ref$handleSubmit = _ref.handleSubmit, handleSubmit = _ref$handleSubmit === void 0 ? noop$1 : _ref$handleSubmit, showWalletCheckbox = _ref.showWalletCheckbox, saveToWallet = _ref.saveToWallet, walletCheckboxMarked = _ref.walletCheckboxMarked, _ref$isRequired = _ref.isRequired, isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired;
    if (clearOnDismount) (0, _react.useEffect)(function() {
        return function() {
            return actions.form.clear();
        };
    }, []);
    useConditionallyAddValidator(isRequired, required, actions.fields.email.addValidator, actions.fields.email.removeValidator);
    var emailFieldErrorMessages = _defineProperty(_defineProperty({}, required.error, "Email address is required"), isProbablyEmail.error, "Please enter a valid email address in the format user@example.com");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormContainer$1, {
        variant: variant,
        role: "form",
        "aria-label": "Email address"
    }, guestCheckout && /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        margin: "0 0 1.125rem 0"
    }, "If desired, you can create a wallet later for faster checkout"), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Email address",
        errorMessages: emailFieldErrorMessages,
        type: "email",
        field: fields.email,
        fieldActions: actions.fields.email,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        isEmail: true,
        autocompleteValue: "email",
        dataQa: "Email address",
        isRequired: isRequired
    }), showWalletCheckbox && /*#__PURE__*/ (0, _reactDefault.default).createElement(Checkbox$1, {
        name: "email checkbox",
        title: "Save email address to wallet",
        checked: walletCheckboxMarked,
        onChange: saveToWallet
    })));
};
var formConfig$3 = {
    email: {
        validators: [
            isProbablyEmail()
        ] // 'required' validator is conditionally added based on `isRequired` prop
    }
};
var _createFormState$3 = createFormState(formConfig$3), reducer$3 = _createFormState$3.reducer, mapStateToProps$4 = _createFormState$3.mapStateToProps, mapDispatchToProps$3 = _createFormState$3.mapDispatchToProps;
EmailForm.reducer = reducer$3;
EmailForm.mapStateToProps = mapStateToProps$4;
EmailForm.mapDispatchToProps = mapDispatchToProps$3;
var footerBackgroundColor = BRIGHT_GREY;
var subfooterBackgroundColor = STORM_GREY;
var fallbackValues$G = {
    footerBackgroundColor: footerBackgroundColor,
    subfooterBackgroundColor: subfooterBackgroundColor
};
var FooterWithSubfooter = function FooterWithSubfooter(_ref) {
    var _ref$footerLargeSide = _ref.footerLargeSide, footerLargeSide = _ref$footerLargeSide === void 0 ? "right" : _ref$footerLargeSide, _ref$footerLargeSideS = _ref.footerLargeSideSize, footerLargeSideSize = _ref$footerLargeSideS === void 0 ? "2" : _ref$footerLargeSideS, leftFooterContent = _ref.leftFooterContent, rightFooterContent = _ref.rightFooterContent, leftSubfooterContent = _ref.leftSubfooterContent, rightSubfooterContent = _ref.rightSubfooterContent, themeValues = _ref.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(NavFooter, {
        largeSide: footerLargeSide,
        largeSideSize: footerLargeSideSize,
        rightContent: rightFooterContent,
        leftContent: leftFooterContent,
        "aria-label": "footer",
        backgroundColor: themeValues.footerBackgroundColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(NavFooter, {
        backgroundColor: themeValues.subfooterBackgroundColor,
        footerMinHeight: "45px",
        footerPadding: "0 16px",
        "aria-label": "subfooter",
        leftContent: leftSubfooterContent,
        rightContent: rightSubfooterContent
    }));
};
var FooterWithSubfooter$1 = themeComponent(FooterWithSubfooter, "FooterWithSubfooter", fallbackValues$G);
var ForgotPasswordForm = function ForgotPasswordForm(_ref) {
    var fields = _ref.fields, actions = _ref.actions, clearOnDismount = _ref.clearOnDismount, showErrors = _ref.showErrors, _ref$handleSubmit = _ref.handleSubmit, handleSubmit = _ref$handleSubmit === void 0 ? noop$1 : _ref$handleSubmit;
    if (clearOnDismount) (0, _react.useEffect)(function() {
        return function() {
            return actions.form.clear();
        };
    }, []);
    var EmailErrorMessages = _defineProperty(_defineProperty({}, required.error, "Email address is required"), isProbablyEmail.error, "Please enter a valid email address in the format user@example.com");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Email address",
        errorMessages: EmailErrorMessages,
        field: fields.email,
        fieldActions: actions.fields.email,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        isEmail: true,
        autocompleteValue: "email"
    });
};
var formConfig$4 = {
    email: {
        validators: [
            required(),
            isProbablyEmail()
        ]
    }
};
var _createFormState$4 = createFormState(formConfig$4), reducer$4 = _createFormState$4.reducer, mapStateToProps$5 = _createFormState$4.mapStateToProps, mapDispatchToProps$4 = _createFormState$4.mapDispatchToProps;
ForgotPasswordForm.reducer = reducer$4;
ForgotPasswordForm.mapStateToProps = mapStateToProps$5;
ForgotPasswordForm.mapDispatchToProps = mapDispatchToProps$4;
var textColor$2 = "#ffffff";
var backgroundColor$9 = "#182848";
var fallbackValues$H = {
    textColor: textColor$2,
    backgroundColor: backgroundColor$9
};
// this component needs some fix'n
var HighlightTabRow = function HighlightTabRow(_ref) {
    var tabs = _ref.tabs, highlightIndex = _ref.highlightIndex, themeValues = _ref.themeValues, isMobile = _ref.isMobile, _ref$useOrderedList = _ref.useOrderedList, useOrderedList = _ref$useOrderedList === void 0 ? true : _ref$useOrderedList, _ref$useUnorderedList = _ref.useUnorderedList, useUnorderedList = _ref$useUnorderedList === void 0 ? false : _ref$useUnorderedList;
    var itemsAfterIndex = tabs.slice(highlightIndex).length - 1;
    var itemsBeforeIndex = tabs.slice(0, highlightIndex).length;
    var boxesBefore = itemsAfterIndex > itemsBeforeIndex && isMobile ? itemsAfterIndex - itemsBeforeIndex : 0;
    var boxesAfter = itemsAfterIndex < itemsBeforeIndex && isMobile ? itemsBeforeIndex - itemsAfterIndex : 0;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        background: themeValues.backgroundColor,
        margin: "0",
        boxShadow: "0px 0px 4px 0px rgb(110, 114, 126)",
        role: "region",
        "aria-label": "Payment step"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        srOnly: true,
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, null, "Current step: ".concat(tabs[highlightIndex]))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: "76.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Reel, {
        padding: "0",
        childGap: "0",
        childWidth: "11rem",
        justifyContent: "space-evenly",
        disableScroll: true,
        useOrderedList: useOrderedList,
        useUnorderedList: useUnorderedList
    }, repeat(/*#__PURE__*/ (0, _reactDefault.default).createElement(Box, null), boxesBefore), tabs.map(function(t, i) {
        var _t$toLowerCase;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            key: t,
            borderSize: "3px",
            borderColor: highlightIndex == i ? themeValues.textColor : "transparent",
            borderWidthOverride: "0 0 3px 0",
            extraStyles: "text-align: center; display: block;",
            as: "li",
            "aria-current": highlightIndex == i ? "step" : "",
            id: "".concat(t === null || t === void 0 || (_t$toLowerCase = t.toLowerCase()) === null || _t$toLowerCase === void 0 ? void 0 : _t$toLowerCase.replace(/\s/g, "-"), "-tab")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
            variant: "p",
            textAlign: "center",
            color: themeValues.textColor,
            weight: FONT_WEIGHT_SEMIBOLD,
            extraStyles: "display: block; white-space: nowrap;"
        }, t));
    }), repeat(/*#__PURE__*/ (0, _reactDefault.default).createElement(Box, null), boxesAfter))));
};
var HighlightTabRow$1 = themeComponent(HighlightTabRow, "HighlightTabRow", fallbackValues$H);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var b$2 = "function" === typeof Symbol && Symbol.for, c$2 = b$2 ? Symbol.for("react.element") : 60103, d$1 = b$2 ? Symbol.for("react.portal") : 60106, e = b$2 ? Symbol.for("react.fragment") : 60107, f$7 = b$2 ? Symbol.for("react.strict_mode") : 60108, g$1 = b$2 ? Symbol.for("react.profiler") : 60114, h$1 = b$2 ? Symbol.for("react.provider") : 60109, k$1 = b$2 ? Symbol.for("react.context") : 60110, l$1 = b$2 ? Symbol.for("react.async_mode") : 60111, m = b$2 ? Symbol.for("react.concurrent_mode") : 60111, n$1 = b$2 ? Symbol.for("react.forward_ref") : 60112, p$1 = b$2 ? Symbol.for("react.suspense") : 60113, q$1 = b$2 ? Symbol.for("react.suspense_list") : 60120, r$1 = b$2 ? Symbol.for("react.memo") : 60115, t$1 = b$2 ? Symbol.for("react.lazy") : 60116, v$1 = b$2 ? Symbol.for("react.block") : 60121, w$1 = b$2 ? Symbol.for("react.fundamental") : 60117, x$1 = b$2 ? Symbol.for("react.responder") : 60118, y$1 = b$2 ? Symbol.for("react.scope") : 60119;
function z$1(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c$2:
                switch(a = a.type, a){
                    case l$1:
                    case m:
                    case e:
                    case g$1:
                    case f$7:
                    case p$1:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k$1:
                            case n$1:
                            case t$1:
                            case r$1:
                            case h$1:
                                return a;
                            default:
                                return u;
                        }
                }
            case d$1:
                return u;
        }
    }
}
function A$1(a) {
    return z$1(a) === m;
}
var AsyncMode = l$1;
var ConcurrentMode = m;
var ContextConsumer = k$1;
var ContextProvider = h$1;
var Element$1 = c$2;
var ForwardRef = n$1;
var Fragment = e;
var Lazy = t$1;
var Memo = r$1;
var Portal = d$1;
var Profiler = g$1;
var StrictMode = f$7;
var Suspense = p$1;
var isAsyncMode = function(a) {
    return A$1(a) || z$1(a) === l$1;
};
var isConcurrentMode = A$1;
var isContextConsumer = function(a) {
    return z$1(a) === k$1;
};
var isContextProvider = function(a) {
    return z$1(a) === h$1;
};
var isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c$2;
};
var isForwardRef = function(a) {
    return z$1(a) === n$1;
};
var isFragment = function(a) {
    return z$1(a) === e;
};
var isLazy = function(a) {
    return z$1(a) === t$1;
};
var isMemo = function(a) {
    return z$1(a) === r$1;
};
var isPortal = function(a) {
    return z$1(a) === d$1;
};
var isProfiler = function(a) {
    return z$1(a) === g$1;
};
var isStrictMode = function(a) {
    return z$1(a) === f$7;
};
var isSuspense = function(a) {
    return z$1(a) === p$1;
};
var isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g$1 || a === f$7 || a === p$1 || a === q$1 || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};
var typeOf = z$1;
var reactIs_production_min = {
    AsyncMode: AsyncMode,
    ConcurrentMode: ConcurrentMode,
    ContextConsumer: ContextConsumer,
    ContextProvider: ContextProvider,
    Element: Element$1,
    ForwardRef: ForwardRef,
    Fragment: Fragment,
    Lazy: Lazy,
    Memo: Memo,
    Portal: Portal,
    Profiler: Profiler,
    StrictMode: StrictMode,
    Suspense: Suspense,
    isAsyncMode: isAsyncMode,
    isConcurrentMode: isConcurrentMode,
    isContextConsumer: isContextConsumer,
    isContextProvider: isContextProvider,
    isElement: isElement,
    isForwardRef: isForwardRef,
    isFragment: isFragment,
    isLazy: isLazy,
    isMemo: isMemo,
    isPortal: isPortal,
    isProfiler: isProfiler,
    isStrictMode: isStrictMode,
    isSuspense: isSuspense,
    isValidElementType: isValidElementType,
    typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function(module, exports) {});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;
var reactIs = createCommonjsModule(function(module) {
    module.exports = reactIs_production_min;
});
var reactIs_1 = reactIs.AsyncMode;
var reactIs_2 = reactIs.ConcurrentMode;
var reactIs_3 = reactIs.ContextConsumer;
var reactIs_4 = reactIs.ContextProvider;
var reactIs_5 = reactIs.Element;
var reactIs_6 = reactIs.ForwardRef;
var reactIs_7 = reactIs.Fragment;
var reactIs_8 = reactIs.Lazy;
var reactIs_9 = reactIs.Memo;
var reactIs_10 = reactIs.Portal;
var reactIs_11 = reactIs.Profiler;
var reactIs_12 = reactIs.StrictMode;
var reactIs_13 = reactIs.Suspense;
var reactIs_14 = reactIs.isAsyncMode;
var reactIs_15 = reactIs.isConcurrentMode;
var reactIs_16 = reactIs.isContextConsumer;
var reactIs_17 = reactIs.isContextProvider;
var reactIs_18 = reactIs.isElement;
var reactIs_19 = reactIs.isForwardRef;
var reactIs_20 = reactIs.isFragment;
var reactIs_21 = reactIs.isLazy;
var reactIs_22 = reactIs.isMemo;
var reactIs_23 = reactIs.isPortal;
var reactIs_24 = reactIs.isProfiler;
var reactIs_25 = reactIs.isStrictMode;
var reactIs_26 = reactIs.isSuspense;
var reactIs_27 = reactIs.isValidElementType;
var reactIs_28 = reactIs.typeOf;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject$1(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
var objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject$1(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty$1.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};
var ReactPropTypesSecret$1, loggedTypeFailures, has$2;
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    var typeSpecName, error, err, ex, stack;
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes.resetWarningCache = function() {};
var checkPropTypes_1 = checkPropTypes;
var printWarning$1 = function() {};
function emptyFunctionThatReturnsNull() {
    return null;
}
var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache, manualPropTypeWarningCount;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== ReactPropTypesSecret_1) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else var cacheKey;
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!reactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) return emptyFunctionThatReturnsNull;
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if (has$1(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret_1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) return emptyFunctionThatReturnsNull;
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                printWarning$1("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
                if (checkerResult == null) return null;
                if (checkerResult.data && has$1(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = objectAssign({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if (has$1(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret_1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes_1;
    ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret_1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
var propTypes = createCommonjsModule(function(module) {
    var ReactIs, throwOnDirectAccess;
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
});
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ var candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]:not(slot)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details"
];
var candidateSelector = /* #__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
} : function(element) {
    return element.ownerDocument;
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var getCandidates = function getCandidates(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidatesScope
 * @property {Element} scope contains inner candidates
 * @property {Element[]} candidates
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidatesScope>}
 */ var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scope: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
             // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scope: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var getTabindex = function getTabindex(node, isScope) {
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        //
        // isScope is positive for custom element with shadow root or slot that by default
        // have tabIndex -1, but need to be sorted by document order in order for their
        // content to be inserted in the correct position
        if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
    }
    return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
     // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    var nodeRootHost = getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
    if (!displayCheck || displayCheck === "full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if (nodeIsAttached) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
         // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
     // visible, as far as we can tell, or per current `displayCheck` mode
    return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i); // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                } // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    } // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
     // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidatesScope>} candidates
 * @returns Element[]
 */ var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scope;
        var element = isScope ? item.scope : item;
        var candidateTabindex = getTabindex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};
var index_esm = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    focusable: focusable,
    isFocusable: isFocusable,
    isTabbable: isTabbable,
    tabbable: tabbable
});
/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$3(Object(source), !0).forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var activeFocusTraps = function() {
    var trapQueue = [];
    return {
        activateTrap: function activateTrap(trap) {
            if (trapQueue.length > 0) {
                var activeTrap = trapQueue[trapQueue.length - 1];
                if (activeTrap !== trap) activeTrap.pause();
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) trapQueue.push(trap);
            else {
                // move this existing trap to the front of the queue
                trapQueue.splice(trapIndex, 1);
                trapQueue.push(trap);
            }
        },
        deactivateTrap: function deactivateTrap(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
            if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
        }
    };
}();
var isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent(e) {
    return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay(fn) {
    return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2$2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   firstTabbableNode: HTMLElement|null,
        //   lastTabbableNode: HTMLElement|null,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element) {
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
             // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus"); // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined) {
            // option not specified: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes
            var focusableNodes = focusable(container, config.tabbableOptions);
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    // NOTE: If tabindex is positive (in order to manipulate the tab order separate
                    //  from the DOM order), this __will not work__ because the list of focusableNodes,
                    //  while it contains tabbable nodes, does not sort its nodes in any order other
                    //  than DOM order, because it can't: Where would you place focusable (but not
                    //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
                    // Support for positive tabindex is already broken and hard to manage (possibly
                    //  not supportable, TBD), so this isn't going to make things worse than they
                    //  already are, and at least makes things better for the majority of cases where
                    //  tabindex is either 0/unset or negative.
                    // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
                    var nodeIdx = focusableNodes.findIndex(function(n) {
                        return n === node;
                    });
                    if (nodeIdx < 0) return undefined;
                    if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                    return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    }; // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) // allow the click since it ocurred inside the trap
        return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // if, on deactivation, we should return focus to the node originally-focused
                //  when the trap was activated (or the configured `setReturnFocus` node),
                //  then assume it's also OK to return focus to the outside node that was
                //  just clicked, causing deactivation, as long as that node is focusable;
                //  if it isn't focusable, then return focus to the original node focused
                //  on activation (or the configured `setReturnFocus` node)
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked, whether it's focusable or not; by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node)
                returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
            });
            return;
        } // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if (valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
         // otherwise, prevent the click
        e.preventDefault();
    }; // In case focus escapes the trap for some strange reason, pull it back in.
    var checkFocusIn = function checkFocusIn(e) {
        var target = getActualTarget(e);
        var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            e.stopImmediatePropagation();
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
    }; // Hijack Tab events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkTab = function checkTab(e) {
        var target = getActualTarget(e);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back in to...
                if (e.shiftKey) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (e.shiftKey) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                    var firstTabbableNode = _ref2.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = destinationGroup.lastTabbableNode;
                }
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                    var lastTabbableNode = _ref3.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = _destinationGroup.firstTabbableNode;
                }
            }
        } else // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        if (destinationNode) {
            e.preventDefault();
            tryFocus(destinationNode);
        } // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(e) {
        if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
            e.preventDefault();
            trap.deactivate();
            return;
        }
        if (isTabEvent(e)) {
            checkTab(e);
            return;
        }
    };
    var checkClick = function checkClick(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }; //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
         // There can be only one listening focus trap at a time
        activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    }; //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            if (onActivate) onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                if (onPostActivate) onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2$2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            activeFocusTraps.deactivateTrap(trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            if (onDeactivate) onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    if (onPostDeactivate) onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause() {
            if (state.paused || !state.active) return this;
            state.paused = true;
            removeListeners();
            return this;
        },
        unpause: function unpause() {
            if (!state.paused || !state.active) return this;
            state.paused = false;
            updateTabbableNodes();
            addListeners();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            return this;
        }
    }; // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};
var focusTrap_esm = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createFocusTrap: createFocusTrap
});
function _typeof$1(obj) {
    "@babel/helpers - typeof";
    return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof$1(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$1(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$1(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self1, call) {
    if (call && (_typeof$1(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized$1(self1);
}
function _assertThisInitialized$1(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var createFocusTrap$1 = focusTrap_esm.createFocusTrap;
var isFocusable$1 = index_esm.isFocusable; // TODO: These issues are related to older React features which we'll likely need
//  to fix in order to move the code forward to the next major version of React.
//  @see https://github.com/davidtheclark/focus-trap-react/issues/77
/* eslint-disable react/no-find-dom-node */ var FocusTrap = /*#__PURE__*/ function(_React$Component) {
    _inherits(FocusTrap, _React$Component);
    var _super = _createSuper(FocusTrap);
    function FocusTrap(props) {
        var _this;
        _classCallCheck(this, FocusTrap);
        _this = _super.call(this, props);
        _defineProperty$3(_assertThisInitialized$1(_this), "getNodeForOption", function(optionName) {
            var _this$internalOptions;
            // use internal options first, falling back to original options
            var optionValue = (_this$internalOptions = this.internalOptions[optionName]) !== null && _this$internalOptions !== void 0 ? _this$internalOptions : this.originalOptions[optionName];
            if (typeof optionValue === "function") {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                optionValue = optionValue.apply(void 0, params);
            }
            if (optionValue === true) optionValue = undefined; // use default value
            if (!optionValue) {
                if (optionValue === undefined || optionValue === false) return optionValue;
                 // else, empty string (invalid), null (invalid), 0 (invalid)
                throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
            }
            var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
            if (typeof optionValue === "string") {
                var _this$getDocument;
                node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue); // resolve to node, or null if fails
                if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            }
            return node;
        });
        _this.handleDeactivate = _this.handleDeactivate.bind(_assertThisInitialized$1(_this));
        _this.handlePostDeactivate = _this.handlePostDeactivate.bind(_assertThisInitialized$1(_this));
        _this.handleClickOutsideDeactivates = _this.handleClickOutsideDeactivates.bind(_assertThisInitialized$1(_this)); // focus-trap options used internally when creating the trap
        _this.internalOptions = {
            // We need to hijack the returnFocusOnDeactivate option,
            // because React can move focus into the element before we arrived at
            // this lifecycle hook (e.g. with autoFocus inputs). So the component
            // captures the previouslyFocusedElement in componentWillMount,
            // then (optionally) returns focus to it in componentWillUnmount.
            returnFocusOnDeactivate: false,
            // the rest of these are also related to deactivation of the trap, and we
            //  need to use them and control them as well
            checkCanReturnFocus: null,
            onDeactivate: _this.handleDeactivate,
            onPostDeactivate: _this.handlePostDeactivate,
            // we need to special-case this setting as well so that we can know if we should
            //  NOT return focus if the trap gets auto-deactivated as the result of an
            //  outside click (otherwise, we'll always think we should return focus because
            //  of how we manage that flag internally here)
            clickOutsideDeactivates: _this.handleClickOutsideDeactivates
        }; // original options provided by the consumer
        _this.originalOptions = {
            // because of the above `internalOptions`, we maintain our own flag for
            //  this option, and default it to `true` because that's focus-trap's default
            returnFocusOnDeactivate: true,
            // because of the above `internalOptions`, we keep these separate since
            //  they're part of the deactivation process which we configure (internally) to
            //  be shared between focus-trap and focus-trap-react
            onDeactivate: null,
            onPostDeactivate: null,
            checkCanReturnFocus: null,
            // the user's setting, defaulted to false since focus-trap defaults this to false
            clickOutsideDeactivates: false
        };
        var focusTrapOptions = props.focusTrapOptions;
        for(var optionName in focusTrapOptions){
            if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) continue;
            if (optionName === "returnFocusOnDeactivate" || optionName === "onDeactivate" || optionName === "onPostDeactivate" || optionName === "checkCanReturnFocus" || optionName === "clickOutsideDeactivates") {
                _this.originalOptions[optionName] = focusTrapOptions[optionName];
                continue; // exclude from internalOptions
            }
            _this.internalOptions[optionName] = focusTrapOptions[optionName];
        } // if set, `{ target: Node, allowDeactivation: boolean }` where `target` is the outside
        //  node that was clicked, and `allowDeactivation` is the result of the consumer's
        //  option (stored in `this.originalOptions.clickOutsideDeactivates`, which may be a
        //  function) whether to allow or deny auto-deactivation on click on this outside node
        _this.outsideClick = null; // elements from which to create the focus trap on mount; if a child is used
        //  instead of the `containerElements` prop, we'll get the child's related
        //  element when the trap renders and then is declared 'mounted'
        _this.focusTrapElements = props.containerElements || []; // now we remember what the currently focused element is, not relying on focus-trap
        _this.updatePreviousElement();
        return _this;
    }
    /**
   * Gets the configured document.
   * @returns {Document|undefined} Configured document, falling back to the main
   *  document, if it exists. During SSR, `undefined` is returned since the
   *  document doesn't exist.
   */ _createClass(FocusTrap, [
        {
            key: "getDocument",
            value: function getDocument() {
                // SSR: careful to check if `document` exists before accessing it as a variable
                return this.props.focusTrapOptions.document || (typeof document !== "undefined" ? document : undefined);
            }
        },
        {
            key: "getReturnFocusNode",
            value: function getReturnFocusNode() {
                var node = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
                return node ? node : node === false ? false : this.previouslyFocusedElement;
            }
        },
        {
            key: "updatePreviousElement",
            value: function updatePreviousElement() {
                var currentDocument = this.getDocument();
                if (currentDocument) this.previouslyFocusedElement = currentDocument.activeElement;
            }
        },
        {
            key: "deactivateTrap",
            value: function deactivateTrap() {
                // NOTE: it's possible the focus trap has already been deactivated without our knowing it,
                //  especially if the user set the `clickOutsideDeactivates: true` option on the trap,
                //  and the mouse was clicked on some element outside the trap; at that point, focus-trap
                //  will initiate its auto-deactivation process, which will call our own
                //  handleDeactivate(), which will call into this method
                if (!this.focusTrap || !this.focusTrap.active) return;
                this.focusTrap.deactivate({
                    // NOTE: we never let the trap return the focus since we do that ourselves
                    returnFocus: false,
                    // we'll call this in our own post deactivate handler so make sure the trap doesn't
                    //  do it prematurely
                    checkCanReturnFocus: null,
                    // let it call the user's original deactivate handler, if any, instead of
                    //  our own which calls back into this function
                    onDeactivate: this.originalOptions.onDeactivate // NOTE: for post deactivate, don't specify anything so that it calls the
                });
            }
        },
        {
            key: "handleClickOutsideDeactivates",
            value: function handleClickOutsideDeactivates(event) {
                // use consumer's option (or call their handler) as the permission or denial
                var allowDeactivation = typeof this.originalOptions.clickOutsideDeactivates === "function" ? this.originalOptions.clickOutsideDeactivates.call(null, event) // call out of context
                 : this.originalOptions.clickOutsideDeactivates; // boolean
                if (allowDeactivation) // capture the outside target that was clicked so we can use it in the deactivation
                //  process since the consumer allowed it to cause auto-deactivation
                this.outsideClick = {
                    target: event.target,
                    allowDeactivation: allowDeactivation
                };
                return allowDeactivation;
            }
        },
        {
            key: "handleDeactivate",
            value: function handleDeactivate() {
                if (this.originalOptions.onDeactivate) this.originalOptions.onDeactivate.call(null); // call user's handler out of context
                this.deactivateTrap();
            }
        },
        {
            key: "handlePostDeactivate",
            value: function handlePostDeactivate() {
                var _this2 = this;
                var finishDeactivation = function finishDeactivation() {
                    var returnFocusNode = _this2.getReturnFocusNode();
                    var canReturnFocus = !!(_this2.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
                    returnFocusNode !== null && returnFocusNode !== void 0 && returnFocusNode.focus && (!_this2.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
                    _this2.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
                    //  as a result of the click-through) -- in which case do NOT restore focus
                    //  to `returnFocusNode` because focus should remain on the outside node
                    !isFocusable$1(_this2.outsideClick.target, _this2.internalOptions.tabbableOptions) // if no, the restore focus to `returnFocusNode` at this point
                    ));
                    var _this2$internalOption = _this2.internalOptions.preventScroll, preventScroll = _this2$internalOption === void 0 ? false : _this2$internalOption;
                    if (canReturnFocus) // return focus to the element that had focus when the trap was activated
                    returnFocusNode.focus({
                        preventScroll: preventScroll
                    });
                    if (_this2.originalOptions.onPostDeactivate) _this2.originalOptions.onPostDeactivate.call(null); // don't call it in context of "this"
                    _this2.outsideClick = null; // reset: no longer needed
                };
                if (this.originalOptions.checkCanReturnFocus) this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()) // call out of context
                .then(finishDeactivation, finishDeactivation);
                else finishDeactivation();
            }
        },
        {
            key: "setupFocusTrap",
            value: function setupFocusTrap() {
                if (!this.focusTrap) {
                    var focusTrapElementDOMNodes = this.focusTrapElements.map(//  a new text node with the text wrapped in it instead of treating the
                    //  string as a selector and resolving it to a node in the DOM
                    (0, _reactDomDefault.default).findDOMNode);
                    var nodesExist = focusTrapElementDOMNodes.some(Boolean);
                    if (nodesExist) {
                        // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
                        this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNodes, this.internalOptions);
                        if (this.props.active) this.focusTrap.activate();
                        if (this.props.paused) this.focusTrap.pause();
                    }
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.active) this.setupFocusTrap();
                 // else, wait for later activation in case the `focusTrapOptions` will be updated
            //  again before the trap is activated (e.g. if waiting to know what the document
            //  object will be, so the Trap must be rendered, but the consumer is waiting to
            //  activate until they have obtained the document from a ref)
            //  @see https://github.com/focus-trap/focus-trap-react/issues/539
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.focusTrap) {
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrap.updateContainerElements(this.props.containerElements);
                    var hasActivated = !prevProps.active && this.props.active;
                    var hasDeactivated = prevProps.active && !this.props.active;
                    var hasPaused = !prevProps.paused && this.props.paused;
                    var hasUnpaused = prevProps.paused && !this.props.paused;
                    if (hasActivated) {
                        this.updatePreviousElement();
                        this.focusTrap.activate();
                    }
                    if (hasDeactivated) {
                        this.deactivateTrap();
                        return; // un/pause does nothing on an inactive trap
                    }
                    if (hasPaused) this.focusTrap.pause();
                    if (hasUnpaused) this.focusTrap.unpause();
                } else {
                    // NOTE: if we're in `componentDidUpdate` and we don't have a trap yet,
                    //  it either means it shouldn't be active, or it should be but none of
                    //  of given `containerElements` were present in the DOM the last time
                    //  we tried to create the trap
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrapElements = this.props.containerElements;
                     // don't create the trap unless it should be active in case the consumer
                    //  is still updating `focusTrapOptions`
                    //  @see https://github.com/focus-trap/focus-trap-react/issues/539
                    if (this.props.active) {
                        this.updatePreviousElement();
                        this.setupFocusTrap();
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.deactivateTrap();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var child = this.props.children ? (0, _reactDefault.default).Children.only(this.props.children) : undefined;
                if (child) {
                    if (child.type && child.type === (0, _reactDefault.default).Fragment) throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
                    var composedRefCallback = function composedRefCallback(element) {
                        var containerElements = _this3.props.containerElements;
                        if (child) {
                            if (typeof child.ref === "function") child.ref(element);
                            else if (child.ref) child.ref.current = element;
                        }
                        _this3.focusTrapElements = containerElements ? containerElements : [
                            element
                        ];
                    };
                    var childWithRef = (0, _reactDefault.default).cloneElement(child, {
                        ref: composedRefCallback
                    });
                    return childWithRef;
                }
                return null;
            }
        }
    ]);
    return FocusTrap;
}((0, _reactDefault.default).Component); // support server-side rendering where `Element` will not be defined
var ElementType = typeof Element === "undefined" ? Function : Element;
FocusTrap.propTypes = {
    active: propTypes.bool,
    paused: propTypes.bool,
    focusTrapOptions: propTypes.shape({
        document: propTypes.object,
        onActivate: propTypes.func,
        onPostActivate: propTypes.func,
        checkCanFocusTrap: propTypes.func,
        onDeactivate: propTypes.func,
        onPostDeactivate: propTypes.func,
        checkCanReturnFocus: propTypes.func,
        initialFocus: propTypes.oneOfType([
            propTypes.instanceOf(ElementType),
            propTypes.string,
            propTypes.bool,
            propTypes.func
        ]),
        fallbackFocus: propTypes.oneOfType([
            propTypes.instanceOf(ElementType),
            propTypes.string,
            propTypes.func
        ]),
        escapeDeactivates: propTypes.oneOfType([
            propTypes.bool,
            propTypes.func
        ]),
        clickOutsideDeactivates: propTypes.oneOfType([
            propTypes.bool,
            propTypes.func
        ]),
        returnFocusOnDeactivate: propTypes.bool,
        setReturnFocus: propTypes.oneOfType([
            propTypes.instanceOf(ElementType),
            propTypes.string,
            propTypes.bool,
            propTypes.func
        ]),
        allowOutsideClick: propTypes.oneOfType([
            propTypes.bool,
            propTypes.func
        ]),
        preventScroll: propTypes.bool,
        tabbableOptions: propTypes.shape({
            displayCheck: propTypes.oneOf([
                "full",
                "non-zero-area",
                "none"
            ]),
            getShadowRoot: propTypes.oneOfType([
                propTypes.bool,
                propTypes.func
            ])
        })
    }),
    containerElements: propTypes.arrayOf(propTypes.instanceOf(ElementType)),
    children: propTypes.oneOfType([
        propTypes.element,
        propTypes.instanceOf(ElementType) // DOM element
    ]) // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
};
FocusTrap.defaultProps = {
    active: true,
    paused: false,
    focusTrapOptions: {},
    _createFocusTrap: createFocusTrap$1
};
var focusTrapReact = FocusTrap;
var _createClass$1 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$1(self1, call) {
    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// React 16+ supports Portals.
var canUsePortals = !!(0, _reactDomDefault.default).createPortal;
function displace(WrappedComponent, options) {
    if (!commonjsGlobal.document) return function(_React$Component) {
        _inherits$1(EmptyDisplace, _React$Component);
        function EmptyDisplace() {
            _classCallCheck$1(this, EmptyDisplace);
            return _possibleConstructorReturn$1(this, (EmptyDisplace.__proto__ || Object.getPrototypeOf(EmptyDisplace)).apply(this, arguments));
        }
        _createClass$1(EmptyDisplace, [
            {
                key: "render",
                value: function render() {
                    return false;
                }
            }
        ]);
        return EmptyDisplace;
    }((0, _reactDefault.default).Component);
    options = options || {};
    var Displaced = function(_React$Component2) {
        _inherits$1(Displaced, _React$Component2);
        function Displaced() {
            var _ref;
            var _temp, _this2, _ret;
            _classCallCheck$1(this, Displaced);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this2 = _possibleConstructorReturn$1(this, (_ref = Displaced.__proto__ || Object.getPrototypeOf(Displaced)).call.apply(_ref, [
                this
            ].concat(args))), _this2), _this2.renderDisplaced = function() {
                (0, _reactDomDefault.default).unstable_renderSubtreeIntoContainer(_this2, (0, _reactDefault.default).createElement(WrappedComponent, _this2.props, _this2.props.children), _this2.container);
            }, _this2.removeDisplaced = function() {
                (0, _reactDomDefault.default).unmountComponentAtNode(_this2.container);
            }, _temp), _possibleConstructorReturn$1(_this2, _ret);
        }
        _createClass$1(Displaced, [
            {
                key: "componentWillMount",
                value: function componentWillMount() {
                    this.container = function() {
                        if (!options.renderTo) {
                            var result = document.createElement("div");
                            document.body.appendChild(result);
                            return result;
                        } else if (typeof options.renderTo === "string") return document.querySelector(options.renderTo);
                        else return options.renderTo;
                    }();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (canUsePortals) return;
                    if (this.props.mounted) this.renderDisplaced();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (canUsePortals) return;
                    if (prevProps.mounted && !this.props.mounted) (0, _reactDomDefault.default).unmountComponentAtNode(this.container);
                    else if (this.props.mounted) this.renderDisplaced();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (!canUsePortals) (0, _reactDomDefault.default).unmountComponentAtNode(this.container);
                    if (!options.renderTo) this.container.parentNode.removeChild(this.container);
                }
            },
            {
                key: "render",
                value: function render() {
                    if (!canUsePortals || this.props.mounted === false) return null;
                    return (0, _reactDomDefault.default).createPortal((0, _reactDefault.default).createElement(WrappedComponent, this.props, this.props.children), this.container);
                }
            }
        ]);
        return Displaced;
    }((0, _reactDefault.default).Component);
    Displaced.defaultProps = {
        mounted: true
    };
    Displaced.WrappedComponent = WrappedComponent;
    return Displaced;
}
var displace_1 = displace;
var noScroll = createCommonjsModule(function(module) {
    (function(root) {
        var isOn = false;
        var scrollbarSize;
        var scrollTop;
        function getScrollbarSize() {
            if (typeof scrollbarSize !== "undefined") return scrollbarSize;
            var doc = document.documentElement;
            var dummyScroller = document.createElement("div");
            dummyScroller.setAttribute("style", "width:99px;height:99px;position:absolute;top:-9999px;overflow:scroll;");
            doc.appendChild(dummyScroller);
            scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
            doc.removeChild(dummyScroller);
            return scrollbarSize;
        }
        function hasScrollbar() {
            return document.documentElement.scrollHeight > window.innerHeight;
        }
        function on(options) {
            if (typeof document === "undefined" || isOn) return;
            var doc = document.documentElement;
            scrollTop = window.pageYOffset;
            if (hasScrollbar()) doc.style.width = "calc(100% - " + getScrollbarSize() + "px)";
            else doc.style.width = "100%";
            doc.style.position = "fixed";
            doc.style.top = -scrollTop + "px";
            doc.style.overflow = "hidden";
            isOn = true;
        }
        function off() {
            if (typeof document === "undefined" || !isOn) return;
            var doc = document.documentElement;
            doc.style.width = "";
            doc.style.position = "";
            doc.style.top = "";
            doc.style.overflow = "";
            window.scroll(0, scrollTop);
            isOn = false;
        }
        function toggle() {
            if (isOn) {
                off();
                return;
            }
            on();
        }
        var noScroll = {
            on: on,
            off: off,
            toggle: toggle
        };
        module.exports = noScroll;
    })();
});
function _typeof$2(obj) {
    "@babel/helpers - typeof";
    return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof$2(obj);
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$2(o, p);
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf$2(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf$2(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn$2(this, result);
    };
}
function _possibleConstructorReturn$2(self1, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized$2(self1);
}
function _assertThisInitialized$2(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Modal = /*#__PURE__*/ function(_React$Component) {
    _inherits$2(Modal, _React$Component);
    var _super = _createSuper$1(Modal);
    function Modal(props) {
        var _this;
        _classCallCheck$2(this, Modal);
        _this = _super.call(this, props);
        _defineProperty$4(_assertThisInitialized$2(_this), "getApplicationNode", function() {
            if (_this.props.getApplicationNode) return _this.props.getApplicationNode();
            return _this.props.applicationNode;
        });
        _defineProperty$4(_assertThisInitialized$2(_this), "checkUnderlayClick", function(event) {
            if (_this.dialogNode && _this.dialogNode.contains(event.target) || // If the click is on the scrollbar we don't want to close the modal.
            event.pageX > event.target.ownerDocument.documentElement.offsetWidth || event.pageY > event.target.ownerDocument.documentElement.offsetHeight) return;
            _this.exit(event);
        });
        _defineProperty$4(_assertThisInitialized$2(_this), "checkDocumentKeyDown", function(event) {
            if (_this.props.escapeExits && (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27)) _this.exit(event);
        });
        _defineProperty$4(_assertThisInitialized$2(_this), "exit", function(event) {
            if (_this.props.onExit) _this.props.onExit(event);
        });
        if (!props.titleText && !props.titleId) throw new Error("react-aria-modal instances should have a `titleText` or `titleId`");
        return _this;
    }
    _createClass$2(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.onEnter) this.props.onEnter();
                 // Timeout to ensure this happens *after* focus has moved
                var applicationNode = this.getApplicationNode();
                setTimeout(function() {
                    if (applicationNode) applicationNode.setAttribute("aria-hidden", "true");
                }, 0);
                if (this.props.escapeExits) this.addKeyDownListener();
                if (this.props.scrollDisabled) noScroll.on();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.scrollDisabled && !this.props.scrollDisabled) noScroll.off();
                else if (!prevProps.scrollDisabled && this.props.scrollDisabled) noScroll.on();
                if (this.props.escapeExits && !prevProps.escapeExits) this.addKeyDownListener();
                else if (!this.props.escapeExits && prevProps.escapeExits) this.removeKeyDownListener();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.props.scrollDisabled) noScroll.off();
                var applicationNode = this.getApplicationNode();
                if (applicationNode) applicationNode.setAttribute("aria-hidden", "false");
                this.removeKeyDownListener();
            }
        },
        {
            key: "addKeyDownListener",
            value: function addKeyDownListener() {
                var _this2 = this;
                setTimeout(function() {
                    document.addEventListener("keydown", _this2.checkDocumentKeyDown);
                });
            }
        },
        {
            key: "removeKeyDownListener",
            value: function removeKeyDownListener() {
                var _this3 = this;
                setTimeout(function() {
                    document.removeEventListener("keydown", _this3.checkDocumentKeyDown);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var props = this.props;
                var style = {};
                if (props.includeDefaultStyles) {
                    style = {
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        zIndex: 1050,
                        overflowX: "hidden",
                        overflowY: "auto",
                        WebkitOverflowScrolling: "touch",
                        textAlign: "center"
                    };
                    if (props.underlayColor) style.background = props.underlayColor;
                    if (props.underlayClickExits) style.cursor = "pointer";
                }
                if (props.underlayStyle) for(var key in props.underlayStyle){
                    if (!props.underlayStyle.hasOwnProperty(key)) continue;
                    style[key] = props.underlayStyle[key];
                }
                var underlayProps = {
                    className: props.underlayClass,
                    style: style
                };
                if (props.underlayClickExits) underlayProps.onMouseDown = this.checkUnderlayClick;
                for(var prop in this.props.underlayProps)underlayProps[prop] = this.props.underlayProps[prop];
                var verticalCenterStyle = {};
                if (props.includeDefaultStyles) verticalCenterStyle = {
                    display: "inline-block",
                    height: "100%",
                    verticalAlign: "middle"
                };
                var verticalCenterHelperProps = {
                    key: "a",
                    style: verticalCenterStyle
                };
                var dialogStyle = {};
                if (props.includeDefaultStyles) {
                    dialogStyle = {
                        display: "inline-block",
                        textAlign: "left",
                        top: 0,
                        maxWidth: "100%",
                        cursor: "auto",
                        outline: props.focusDialog ? 0 : null
                    };
                    if (props.verticallyCenter) {
                        dialogStyle.verticalAlign = "middle";
                        dialogStyle.top = 0;
                    }
                }
                if (props.dialogStyle) for(var _key in props.dialogStyle){
                    if (!props.dialogStyle.hasOwnProperty(_key)) continue;
                    dialogStyle[_key] = props.dialogStyle[_key];
                }
                var dialogProps = {
                    key: "b",
                    ref: (function(el) {
                        this.dialogNode = el;
                    }).bind(this),
                    role: props.alert ? "alertdialog" : "dialog",
                    id: props.dialogId,
                    className: props.dialogClass,
                    style: dialogStyle
                };
                if (props.titleId) dialogProps["aria-labelledby"] = props.titleId;
                else if (props.titleText) dialogProps["aria-label"] = props.titleText;
                if (props.focusDialog) dialogProps.tabIndex = "-1";
                 // Apply data- and aria- attributes passed as props
                for(var _key2 in props)if (/^(data-|aria-)/.test(_key2)) dialogProps[_key2] = props[_key2];
                var childrenArray = [
                    (0, _reactDefault.default).createElement("div", dialogProps, props.children)
                ];
                if (props.verticallyCenter) childrenArray.unshift((0, _reactDefault.default).createElement("div", verticalCenterHelperProps));
                var focusTrapOptions = props.focusTrapOptions || {};
                if (props.focusDialog || props.initialFocus) focusTrapOptions.initialFocus = props.focusDialog ? "#".concat(this.props.dialogId) : props.initialFocus;
                focusTrapOptions.escapeDeactivates = props.escapeExits;
                return (0, _reactDefault.default).createElement(focusTrapReact, {
                    focusTrapOptions: focusTrapOptions,
                    paused: props.focusTrapPaused
                }, (0, _reactDefault.default).createElement("div", underlayProps, childrenArray));
            }
        }
    ]);
    return Modal;
}((0, _reactDefault.default).Component);
_defineProperty$4(Modal, "defaultProps", {
    underlayProps: {},
    dialogId: "react-aria-modal-dialog",
    underlayClickExits: true,
    escapeExits: true,
    underlayColor: "rgba(0,0,0,0.5)",
    includeDefaultStyles: true,
    focusTrapPaused: false,
    scrollDisabled: true
});
var DisplacedModal = displace_1(Modal);
DisplacedModal.renderTo = function(input) {
    return displace_1(Modal, {
        renderTo: input
    });
};
var reactAriaModal = DisplacedModal;
/*
Default Modal molecule
Uses react-aria-modal behind the scenes for a11y purposes
Styling accomplished with our atoms / layout primitives

Cancel button will (for now) always use hideModal as its action
Continue button takes an action, if you want to navigate to
a different route (as with a link) connect() and use "push" from @thecb/connected-react-router
*/ var getApplicationNode = function getApplicationNode() {
    return document.getElementById("root");
};
var Modal$1 = function Modal(_ref) {
    var hideModal = _ref.hideModal, _ref$onExit = _ref.onExit, onExit = _ref$onExit === void 0 ? hideModal : _ref$onExit, continueAction = _ref.continueAction, _ref$isContinueAction = _ref.isContinueActionDisabled, isContinueActionDisabled = _ref$isContinueAction === void 0 ? false : _ref$isContinueAction, _ref$isCloseActionDis = _ref.isCloseActionDisabled, isCloseActionDisabled = _ref$isCloseActionDis === void 0 ? false : _ref$isCloseActionDis, cancelAction = _ref.cancelAction, modalOpen = _ref.modalOpen, modalHeaderText = _ref.modalHeaderText, modalBodyText = _ref.modalBodyText, _ref$cancelButtonText = _ref.cancelButtonText, cancelButtonText = _ref$cancelButtonText === void 0 ? "Cancel" : _ref$cancelButtonText, _ref$continueButtonTe = _ref.continueButtonText, continueButtonText = _ref$continueButtonTe === void 0 ? "Continue" : _ref$continueButtonTe, _ref$closeButtonText = _ref.closeButtonText, closeButtonText = _ref$closeButtonText === void 0 ? "Close" : _ref$closeButtonText, _ref$modalHeaderBg = _ref.modalHeaderBg, modalHeaderBg = _ref$modalHeaderBg === void 0 ? WHITE : _ref$modalHeaderBg, _ref$modalBodyBg = _ref.modalBodyBg, modalBodyBg = _ref$modalBodyBg === void 0 ? ATHENS_GREY : _ref$modalBodyBg, _ref$useDangerButton = _ref.useDangerButton, useDangerButton = _ref$useDangerButton === void 0 ? false : _ref$useDangerButton, _ref$defaultWrapper = _ref.defaultWrapper, defaultWrapper = _ref$defaultWrapper === void 0 ? true : _ref$defaultWrapper, _ref$onlyCloseButton = _ref.onlyCloseButton, onlyCloseButton = _ref$onlyCloseButton === void 0 ? false : _ref$onlyCloseButton, _ref$noButtons = _ref.noButtons, noButtons = _ref$noButtons === void 0 ? false : _ref$noButtons, maxHeight = _ref.maxHeight, _ref$underlayClickExi = _ref.underlayClickExits, underlayClickExits = _ref$underlayClickExi === void 0 ? true : _ref$underlayClickExi, noBorder = _ref.noBorder, customWidth = _ref.customWidth, isLoading = _ref.isLoading, buttonExtraStyles = _ref.buttonExtraStyles, children = _ref.children, _ref$dataQa = _ref.dataQa, dataQa = _ref$dataQa === void 0 ? null : _ref$dataQa, _ref$initialFocusSele = _ref.initialFocusSelector, initialFocusSelector = _ref$initialFocusSele === void 0 ? "" : _ref$initialFocusSele, _ref$blurUnderlay = _ref.blurUnderlay, blurUnderlay = _ref$blurUnderlay === void 0 ? true : _ref$blurUnderlay;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    // `AriaModal` uses `focus-trap` as a transient dependency. It automatically looks
    // for a tabbable node when the modal mounts. When it doesn't find one, it looks to
    // the `fallbackFocus` option. However, React does not guarantee the ref supplied to
    // this option will be populated on initial render when `focus-trap` is checking
    // these option. When there are no buttons in the modal, this causes an error.
    // Because `focus-trap` cannot be disabled, the ref itself requires a default value
    // to satisfy `focus-trap` until React populates it with the real ref value.
    //
    // See:
    //   - https://react.dev/reference/react/useRef#caveats
    //   - https://github.com/davidtheclark/react-aria-modal/pull/103
    //   - https://github.com/focus-trap/focus-trap?tab=readme-ov-file#createoptions
    var modalContainerRef = (0, _react.useRef)("#react-aria-modal-dialog");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: modalContainerRef,
        tabIndex: "-1",
        "data-qa": dataQa
    }, modalOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement(reactAriaModal, {
        focusTrapOptions: {
            // fallback to resolve Jest unit test errors when tabbable doesn't exist in jsdom https://github.com/focus-trap/focus-trap-react/issues/91
            fallbackFocus: modalContainerRef === null || modalContainerRef === void 0 ? void 0 : modalContainerRef.current
        },
        onExit: onExit,
        getApplicationNode: getApplicationNode,
        titleText: modalHeaderText,
        underlayStyle: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(41, 42, 51, 0.45)",
            backdropFilter: blurUnderlay ? "blur(4px)" : "none",
            WebkitBackdropFilter: blurUnderlay ? "blur(4px)" : "none"
        },
        dialogStyle: {
            width: customWidth || "615px",
            overflow: "auto"
        },
        underlayClickExits: underlayClickExits,
        "aria-modal": true,
        initialFocus: initialFocusSelector,
        focusDialog: !initialFocusSelector // Focus the dialogue box itself if no selector for initial focus was provided
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        borderRadius: "2px",
        boxShadow: "inset 0px -2px 0px 0px rgb(0, 80, 149)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: modalHeaderBg,
        padding: "1.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "flex-start",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        as: "h2",
        weight: FONT_WEIGHT_SEMIBOLD,
        fontSize: "1.25rem"
    }, modalHeaderText))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: modalBodyBg,
        padding: "1.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "1.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        borderWidthOverride: noBorder && "0 0 2px 0",
        borderColor: !noBorder && SILVER_GREY,
        padding: !noBorder && "0 0 1.5rem 0",
        extraStyles: maxHeight ? "max-height: ".concat(maxHeight, "; overflow: auto;") : ""
    }, defaultWrapper ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: "p"
    }, modalBodyText) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: maxHeight ? "0 0 1rem 0" : "0"
    }, modalBodyText)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        direction: "row",
        justify: "flex-end",
        align: "center",
        childGap: "0rem"
    }, !noButtons && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, !onlyCloseButton ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, isMobile ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "1rem",
        direction: "row"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        width: "100%",
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        variant: "secondary",
        action: cancelAction ? cancelAction : hideModal,
        text: cancelButtonText,
        dataQa: cancelButtonText,
        extraStyles: buttonExtraStyles,
        className: "modal-cancel-button",
        role: "button",
        name: cancelButtonText
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        width: "100%",
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        variant: useDangerButton ? "danger" : "primary",
        action: continueAction,
        text: continueButtonText,
        dataQa: continueButtonText,
        isLoading: isLoading,
        disabled: isContinueActionDisabled,
        extraStyles: buttonExtraStyles,
        className: "modal-continue-button",
        role: "button",
        name: continueButtonText
    }))) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "1rem",
        direction: "row",
        justify: "flex-end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        variant: "secondary",
        action: cancelAction ? cancelAction : hideModal,
        text: cancelButtonText,
        dataQa: cancelButtonText,
        extraStyles: buttonExtraStyles,
        className: "modal-cancel-button",
        role: "button",
        name: cancelButtonText
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        variant: useDangerButton ? "danger" : "primary",
        action: continueAction,
        text: continueButtonText,
        dataQa: continueButtonText,
        isLoading: isLoading,
        disabled: isContinueActionDisabled,
        extraStyles: buttonExtraStyles,
        className: "modal-continue-button",
        role: "button",
        name: continueButtonText
    }))) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        tabIndex: "0",
        action: hideModal,
        variant: "primary",
        text: closeButtonText,
        dataQa: closeButtonText,
        disabled: isCloseActionDisabled,
        extraStyles: buttonExtraStyles,
        className: "modal-close-button",
        role: "button",
        name: closeButtonText
    }))))))))), children);
};
var ButtonLayoutWrapper = function ButtonLayoutWrapper(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? [] : _ref$children, _ref$isMobile = _ref.isMobile, isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
    var safeChildren = Array.isArray(children) ? children : [
        children
    ];
    var flexGrow = isMobile ? "flex-grow: 1;" : "";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: SPACING.MD
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "1rem",
        direction: "row",
        justify: "flex-end"
    }, safeChildren.map(function(child, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0",
            extraStyles: flexGrow,
            key: index
        }, child);
    })));
};
var CancelButton = function CancelButton(_ref) {
    var _ref$buttonExtraStyle = _ref.buttonExtraStyles, buttonExtraStyles = _ref$buttonExtraStyle === void 0 ? "" : _ref$buttonExtraStyle, _ref$cancelAction = _ref.cancelAction, cancelAction = _ref$cancelAction === void 0 ? noop$1 : _ref$cancelAction, _ref$cancelButtonText = _ref.cancelButtonText, cancelButtonText = _ref$cancelButtonText === void 0 ? "" : _ref$cancelButtonText, _ref$cancelButtonVari = _ref.cancelButtonVariant, cancelButtonVariant = _ref$cancelButtonVari === void 0 ? "secondary" : _ref$cancelButtonVari, _ref$hideModal = _ref.hideModal, hideModal = _ref$hideModal === void 0 ? noop$1 : _ref$hideModal, _ref$isMobile = _ref.isMobile, isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
    var fontSize = "font-size: ".concat(isMobile ? FONT_SIZE.XS : FONT_SIZE.SM, ";");
    var width = isMobile ? "width: 100%;" : "";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        action: cancelAction ? cancelAction : hideModal,
        borderRadius: BORDER_RADIUS.MD,
        className: "modal-cancel-button",
        dataQa: cancelButtonText,
        extraStyles: "".concat(buttonExtraStyles, "; margin: 0; ").concat(width),
        name: cancelButtonText,
        role: "button",
        text: cancelButtonText,
        textExtraStyles: "".concat(fontSize),
        variant: cancelButtonVariant
    });
};
var CloseButton = function CloseButton(_ref) {
    var _ref$buttonExtraStyle = _ref.buttonExtraStyles, buttonExtraStyles = _ref$buttonExtraStyle === void 0 ? "" : _ref$buttonExtraStyle, _ref$closeButtonText = _ref.closeButtonText, closeButtonText = _ref$closeButtonText === void 0 ? "" : _ref$closeButtonText, _ref$closeButtonVaria = _ref.closeButtonVariant, closeButtonVariant = _ref$closeButtonVaria === void 0 ? "primary" : _ref$closeButtonVaria, _ref$hideModal = _ref.hideModal, hideModal = _ref$hideModal === void 0 ? noop$1 : _ref$hideModal, _ref$isMobile = _ref.isMobile, isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
    var fontSize = "font-size: ".concat(isMobile ? FONT_SIZE.XS : FONT_SIZE.SM, ";");
    var width = isMobile ? "width: 100%;" : "";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        action: hideModal,
        borderRadius: BORDER_RADIUS.MD,
        className: "modal-close-button",
        dataQa: closeButtonText,
        extraStyles: "".concat(buttonExtraStyles, "; margin: 0; ").concat(width),
        name: closeButtonText,
        role: "button",
        text: closeButtonText,
        textExtraStyles: "".concat(fontSize),
        variant: closeButtonVariant
    });
};
var CloseIconButton = function CloseIconButton(_ref) {
    var _ref$buttonExtraStyle = _ref.buttonExtraStyles, _ref$hideModal = _ref.hideModal, hideModal = _ref$hideModal === void 0 ? noop$1 : _ref$hideModal, _ref$iconWidth = _ref.iconWidth, iconWidth = _ref$iconWidth === void 0 ? "24px" : _ref$iconWidth, _ref$iconHeight = _ref.iconHeight, iconHeight = _ref$iconHeight === void 0 ? "24px" : _ref$iconHeight, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "Close Modal" : _ref$ariaLabel;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        action: hideModal,
        "aria-label": ariaLabel,
        contentOverride: true,
        extraStyles: "\n        min-height: auto;\n        min-width: auto;\n        height: 1.5rem;\n        margin: 0 0 0 0.5rem;\n        &:focus {\n            outline-offset: -3px;\n        }\n     ",
        variant: "smallGhost"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(CloseIcon, {
        role: "img",
        "aria-hidden": "true",
        iconWidth: iconWidth,
        iconHeight: iconHeight
    }));
};
var ContinueButton = function ContinueButton(_ref) {
    var _ref$buttonExtraStyle = _ref.buttonExtraStyles, buttonExtraStyles = _ref$buttonExtraStyle === void 0 ? "" : _ref$buttonExtraStyle, _ref$continueAction = _ref.continueAction, continueAction = _ref$continueAction === void 0 ? noop$1 : _ref$continueAction, _ref$continueButtonTe = _ref.continueButtonText, continueButtonText = _ref$continueButtonTe === void 0 ? "" : _ref$continueButtonTe, _ref$continueURL = _ref.continueURL, continueURL = _ref$continueURL === void 0 ? "" : _ref$continueURL, _ref$continueButtonVa = _ref.continueButtonVariant, continueButtonVariant = _ref$continueButtonVa === void 0 ? "primary" : _ref$continueButtonVa, _ref$isContinueAction = _ref.isContinueActionDisabled, isContinueActionDisabled = _ref$isContinueAction === void 0 ? false : _ref$isContinueAction, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isMobile = _ref.isMobile, isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile, _ref$useDangerButton = _ref.useDangerButton, useDangerButton = _ref$useDangerButton === void 0 ? false : _ref$useDangerButton;
    var ContinueButtonAtom = continueURL ? ButtonWithLink : ButtonWithAction;
    var fontSize = "font-size: ".concat(isMobile ? FONT_SIZE.XS : FONT_SIZE.SM, ";");
    var width = isMobile ? "width: 100%;" : "";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ContinueButtonAtom, {
        action: continueAction,
        borderRadius: BORDER_RADIUS.MD,
        className: "modal-continue-button",
        dataQa: continueButtonText,
        disabled: isContinueActionDisabled,
        extraStyles: "".concat(buttonExtraStyles, "; margin: 0; ").concat(width),
        isLoading: isLoading,
        linkExtraStyles: "display: inline-block; ".concat(width),
        name: continueButtonText,
        role: "button",
        text: continueButtonText,
        textExtraStyles: "".concat(fontSize),
        url: continueURL,
        variant: useDangerButton ? "danger" : continueButtonVariant
    });
};
/*
Default Modal molecule
Uses react-aria-modal behind the scenes for a11y purposes
Styling accomplished with our atoms / layout primitives

Cancel button will (for now) always use hideModal as its action
Continue button takes an action, if you want to navigate to
a different route (as with a link) connect() and use "push" from @thecb/connected-react-router
*/ var getApplicationNode$1 = function getApplicationNode() {
    return document.getElementById("root");
};
var Modal$2 = function Modal(_ref) {
    var _ref$blurUnderlay = _ref.blurUnderlay, blurUnderlay = _ref$blurUnderlay === void 0 ? true : _ref$blurUnderlay, _ref$buttonExtraStyle = _ref.buttonExtraStyles, buttonExtraStyles = _ref$buttonExtraStyle === void 0 ? "" : _ref$buttonExtraStyle, _ref$cancelAction = _ref.cancelAction, cancelAction = _ref$cancelAction === void 0 ? noop$1 : _ref$cancelAction, _ref$cancelButtonText = _ref.cancelButtonText, cancelButtonText = _ref$cancelButtonText === void 0 ? "Cancel" : _ref$cancelButtonText, _ref$cancelButtonVari = _ref.cancelButtonVariant, cancelButtonVariant = _ref$cancelButtonVari === void 0 ? "secondary" : _ref$cancelButtonVari, _ref$children = _ref.children, children = _ref$children === void 0 ? [] : _ref$children, _ref$closeButtonText = _ref.closeButtonText, closeButtonText = _ref$closeButtonText === void 0 ? "Close" : _ref$closeButtonText, _ref$closeButtonVaria = _ref.closeButtonVariant, closeButtonVariant = _ref$closeButtonVaria === void 0 ? "primary" : _ref$closeButtonVaria, _ref$continueAction = _ref.continueAction, continueAction = _ref$continueAction === void 0 ? noop$1 : _ref$continueAction, _ref$continueButtonTe = _ref.continueButtonText, continueButtonText = _ref$continueButtonTe === void 0 ? "Continue" : _ref$continueButtonTe, _ref$continueButtonVa = _ref.continueButtonVariant, continueButtonVariant = _ref$continueButtonVa === void 0 ? "primary" : _ref$continueButtonVa, _ref$continueURL = _ref.continueURL, continueURL = _ref$continueURL === void 0 ? "" : _ref$continueURL, _ref$customWidth = _ref.customWidth, customWidth = _ref$customWidth === void 0 ? "" : _ref$customWidth, _ref$dataQa = _ref.dataQa, dataQa = _ref$dataQa === void 0 ? null : _ref$dataQa, _ref$defaultWrapper = _ref.defaultWrapper, defaultWrapper = _ref$defaultWrapper === void 0 ? true : _ref$defaultWrapper, _ref$hideModal = _ref.hideModal, hideModal = _ref$hideModal === void 0 ? noop$1 : _ref$hideModal, _ref$initialFocusSele = _ref.initialFocusSelector, initialFocusSelector = _ref$initialFocusSele === void 0 ? "" : _ref$initialFocusSele, _ref$isContinueAction = _ref.isContinueActionDisabled, isContinueActionDisabled = _ref$isContinueAction === void 0 ? false : _ref$isContinueAction, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$maxHeight = _ref.maxHeight, maxHeight = _ref$maxHeight === void 0 ? "" : _ref$maxHeight, _ref$modalBodyBg = _ref.modalBodyBg, modalBodyBg = _ref$modalBodyBg === void 0 ? "" : _ref$modalBodyBg, _ref$modalBodyText = _ref.modalBodyText, modalBodyText = _ref$modalBodyText === void 0 ? "" : _ref$modalBodyText, _ref$modalHeaderBg = _ref.modalHeaderBg, modalHeaderBg = _ref$modalHeaderBg === void 0 ? "" : _ref$modalHeaderBg, _ref$modalHeaderText = _ref.modalHeaderText, modalHeaderText = _ref$modalHeaderText === void 0 ? "" : _ref$modalHeaderText, _ref$modalOpen = _ref.modalOpen, modalOpen = _ref$modalOpen === void 0 ? false : _ref$modalOpen, _ref$noButtons = _ref.noButtons, noButtons = _ref$noButtons === void 0 ? false : _ref$noButtons, _ref$onExit = _ref.onExit, onExit = _ref$onExit === void 0 ? hideModal : _ref$onExit, _ref$onlyCloseButton = _ref.onlyCloseButton, onlyCloseButton = _ref$onlyCloseButton === void 0 ? false : _ref$onlyCloseButton, _ref$onlyContinueButt = _ref.onlyContinueButton, onlyContinueButton = _ref$onlyContinueButt === void 0 ? false : _ref$onlyContinueButt, _ref$showCloseIconBut = _ref.showCloseIconButton, showCloseIconButton = _ref$showCloseIconBut === void 0 ? false : _ref$showCloseIconBut, _ref$underlayClickExi = _ref.underlayClickExits, underlayClickExits = _ref$underlayClickExi === void 0 ? true : _ref$underlayClickExi, _ref$useDangerButton = _ref.useDangerButton, useDangerButton = _ref$useDangerButton === void 0 ? false : _ref$useDangerButton;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    // `AriaModal` uses `focus-trap` as a transient dependency. It automatically looks
    // for a tabbable node when the modal mounts. When it doesn't find one, it looks to
    // the `fallbackFocus` option. However, React does not guarantee the ref supplied to
    // this option will be populated on initial render when `focus-trap` is checking
    // these option. When there are no buttons in the modal, this causes an error.
    // Because `focus-trap` cannot be disabled, the ref itself requires a default value
    // to satisfy `focus-trap` until React populates it with the real ref value.
    //
    // See:
    //   - https://react.dev/reference/react/useRef#caveats
    //   - https://github.com/davidtheclark/react-aria-modal/pull/103
    //   - https://github.com/focus-trap/focus-trap?tab=readme-ov-file#createoptions
    var modalContainerRef = (0, _react.useRef)("#react-aria-modal-dialog");
    var hasCloseButton = onlyCloseButton && !noButtons;
    var hasCancelButton = !onlyContinueButton && !onlyCloseButton && !noButtons;
    var hasContinueButton = onlyContinueButton && !noButtons || !onlyCloseButton && !noButtons;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: modalContainerRef,
        tabIndex: "-1",
        "data-qa": dataQa
    }, modalOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement(reactAriaModal, {
        focusTrapOptions: {
            // fallback to resolve Jest unit test errors when tabbable doesn't exist in jsdom https://github.com/focus-trap/focus-trap-react/issues/91
            fallbackFocus: modalContainerRef === null || modalContainerRef === void 0 ? void 0 : modalContainerRef.current
        },
        onExit: onExit,
        getApplicationNode: getApplicationNode$1,
        titleText: modalHeaderText,
        underlayStyle: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(41, 42, 51, 0.45)",
            backdropFilter: blurUnderlay ? "blur(4px)" : "none",
            WebkitBackdropFilter: blurUnderlay ? "blur(4px)" : "none"
        },
        dialogStyle: {
            borderRadius: BORDER_RADIUS.MD,
            margin: SPACING.XS,
            overflow: "auto",
            width: isMobile ? "" : customWidth || "576px"
        },
        underlayClickExits: underlayClickExits,
        "aria-modal": true,
        initialFocus: initialFocusSelector,
        focusDialog: !initialFocusSelector // Focus the dialogue box itself if no selector for initial focus was provided
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        boxShadow: "inset 0px -2px 0px 0px rgb(0, 80, 149)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: modalHeaderBg || WHITE,
        borderColor: SILVER_GREY,
        borderWidthOverride: "0 0 ".concat(BORDER_THIN, " 0"),
        padding: "".concat(SPACING.XS, " ").concat(SPACING.MD)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: showCloseIconButton ? "space-between" : "flex-start",
        align: showCloseIconButton && isMobile ? "flex-start" : "center",
        nowrap: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        as: "h2",
        weight: FONT_WEIGHT_SEMIBOLD,
        fontSize: isMobile ? FONT_SIZE.MD : FONT_SIZE.LG
    }, modalHeaderText), showCloseIconButton && /*#__PURE__*/ (0, _reactDefault.default).createElement(CloseIconButton, {
        hideModal: hideModal,
        iconHeight: isMobile ? "20px" : "24px",
        iconWidth: isMobile ? "20px" : "24px"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: modalBodyBg || ATHENS_GREY,
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: SPACING.MD,
        borderWidthOverride: !noButtons && "0 0 ".concat(BORDER_THIN, " 0"),
        borderColor: !noButtons && SILVER_GREY,
        extraStyles: maxHeight ? "max-height: ".concat(maxHeight, "; overflow: auto;") : ""
    }, defaultWrapper ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: isMobile ? "pS" : "p"
    }, modalBodyText) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: maxHeight ? "0 0 ".concat(SPACING.XS, " 0") : "0"
    }, modalBodyText)), noButtons ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null) : /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonLayoutWrapper, {
        isMobile: isMobile
    }, [
        hasCancelButton && /*#__PURE__*/ (0, _reactDefault.default).createElement(CancelButton, {
            buttonExtraStyles: buttonExtraStyles,
            cancelAction: cancelAction,
            cancelButtonText: cancelButtonText,
            cancelButtonVariant: cancelButtonVariant,
            hideModal: hideModal,
            isMobile: isMobile,
            key: "cancel"
        }),
        hasContinueButton && /*#__PURE__*/ (0, _reactDefault.default).createElement(ContinueButton, {
            buttonExtraStyles: buttonExtraStyles,
            continueAction: continueAction,
            continueButtonText: continueButtonText,
            continueURL: continueURL,
            continueButtonVariant: continueButtonVariant,
            isContinueActionDisabled: isContinueActionDisabled,
            isLoading: isLoading,
            isMobile: isMobile,
            key: "continue",
            useDangerButton: useDangerButton
        }),
        hasCloseButton && /*#__PURE__*/ (0, _reactDefault.default).createElement(CloseButton, {
            buttonExtraStyles: buttonExtraStyles,
            closeButtonText: closeButtonText,
            closeButtonVariant: closeButtonVariant,
            hideModal: hideModal,
            isMobile: isMobile,
            key: "close"
        })
    ].filter(function(button) {
        return button;
    }))))), children);
};
var ModalControlV2 = withWindowSize(Modal$2);
var _excluded$K = [
    "version"
];
var Modal$3 = function Modal(_ref) {
    var _ref$version = _ref.version, version = _ref$version === void 0 ? "v1" : _ref$version, rest = _objectWithoutProperties(_ref, _excluded$K);
    var ModalControl = version === "v1" ? Modal$1 : ModalControlV2;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ModalControl, rest);
};
var IdleModal = function IdleModal(_ref) {
    var modalOpen = _ref.modalOpen, toggleModal = _ref.toggleModal, _ref$timeLeftToLogout = _ref.timeLeftToLogout, timeLeftToLogout = _ref$timeLeftToLogout === void 0 ? 0 : _ref$timeLeftToLogout, _ref$totalLogoutTime = _ref.totalLogoutTime, totalLogoutTime = _ref$totalLogoutTime === void 0 ? 30 : _ref$totalLogoutTime, logout = _ref.logout, cancelLogout = _ref.cancelLogout, useCheckoutContent = _ref.useCheckoutContent;
    var percent = (totalLogoutTime - timeLeftToLogout) * (100 / totalLogoutTime);
    var transition = {
        ease: "easeInOut",
        duration: totalLogoutTime
    };
    var variants = {
        enter: {
            x: "-100%",
            backgroundColor: "#317D4F"
        },
        animate: {
            x: [
                "-100%",
                "".concat(percent, "%")
            ],
            backgroundColor: [
                "#317D4F",
                "#93A441",
                "#F4CB32",
                "#E36E43",
                "#D11053"
            ],
            times: [
                0,
                0.4,
                0.5,
                0.6,
                0.8
            ],
            transition: transition
        }
    };
    var continueText = useCheckoutContent ? "Continue" : "Stay Logged In";
    var cancelText = useCheckoutContent ? "End Session" : "Log Off";
    var paragraphText = useCheckoutContent ? "Are you still there? Your payment will be cancelled in ".concat(timeLeftToLogout, " seconds.") : "Are you still there? For your security, you will be logged out in ".concat(timeLeftToLogout, " seconds.");
    var modalBody = /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, null, paragraphText), /*#__PURE__*/ (0, _reactDefault.default).createElement(Motion, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 0 1px 0",
        minHeight: "10px",
        width: "100%",
        borderRadius: "6px",
        extraStyles: "position: relative; overflow: hidden;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Motion, {
        padding: "0 0 1px 0",
        height: "10px",
        width: "100%",
        borderRadius: "6px",
        extraStyles: "position: absolute;",
        variants: variants,
        initial: "enter",
        animate: modalOpen ? "animate" : "enter",
        exit: "enter"
    })))));
    var modalExtraProps = {
        modalHeaderText: "Your session is about to expire!",
        modalBodyText: modalBody,
        continueButtonText: continueText,
        cancelButtonText: cancelText,
        continueAction: function continueAction() {
            cancelLogout();
            toggleModal(false);
        },
        cancelAction: function cancelAction() {
            logout();
            toggleModal(false);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Modal$3, _extends({
        showModal: function showModal() {
            return toggleModal(true);
        },
        hideModal: function hideModal() {
            cancelLogout();
            toggleModal(false);
        },
        modalOpen: modalOpen,
        defaultWrapper: false,
        underlayClickExits: false
    }, modalExtraProps), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }));
};
var LoginForm = function LoginForm(_ref) {
    var clearOnDismount = _ref.clearOnDismount, fields = _ref.fields, actions = _ref.actions, showErrors = _ref.showErrors, _ref$handleSubmit = _ref.handleSubmit, handleSubmit = _ref$handleSubmit === void 0 ? noop$1 : _ref$handleSubmit;
    if (clearOnDismount) (0, _react.useEffect)(function() {
        return function() {
            return actions.form.clear();
        };
    }, []);
    var emailErrorMessages = _defineProperty(_defineProperty({}, required.error, "Email address is required"), isProbablyEmail.error, "Please enter a valid email address in the format user@example.com");
    var passwordErrorMessages = _defineProperty({}, required.error, "Password is required");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, {
        role: "form",
        "aria-label": "Login"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Email address",
        errorMessages: emailErrorMessages,
        type: "email",
        field: fields.email,
        fieldActions: actions.fields.email,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        isEmail: true,
        autocompleteValue: "email",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Password",
        errorMessages: passwordErrorMessages,
        type: "password",
        field: fields.password,
        fieldActions: actions.fields.password,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "current-password",
        isRequired: true
    }));
};
var formConfig$5 = {
    email: {
        validators: [
            required(),
            isProbablyEmail()
        ]
    },
    password: {
        validators: [
            required()
        ]
    }
};
var _createFormState$5 = createFormState(formConfig$5), reducer$5 = _createFormState$5.reducer, mapStateToProps$6 = _createFormState$5.mapStateToProps, mapDispatchToProps$5 = _createFormState$5.mapDispatchToProps;
LoginForm.reducer = reducer$5;
LoginForm.mapStateToProps = mapStateToProps$6;
LoginForm.mapDispatchToProps = mapDispatchToProps$5;
var backgroundColor$a = {
    profile: "#3b414d",
    cms: "#3b414d"
};
var shadowColor = {
    profile: "#292A33",
    cms: "#292A33"
};
var fallbackValues$I = {
    backgroundColor: backgroundColor$a,
    shadowColor: shadowColor
};
var NavMenuDesktop = function NavMenuDesktop(_ref) {
    var id = _ref.id, _ref$top = _ref.top, top = _ref$top === void 0 ? "115%" : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? "-165%" : _ref$left, _ref$menuContent = _ref.menuContent, menuContent = _ref$menuContent === void 0 ? [] : _ref$menuContent, _ref$visible = _ref.visible, visible = _ref$visible === void 0 ? true : _ref$visible, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, onFocus = _ref.onFocus, onBlur = _ref.onBlur, themeValues = _ref.themeValues;
    var menuCarat = '&:after { bottom: 100%; right: 10px; border: solid transparent; content: " "; height: 0; width: 0; position: absolute; pointer-events: none; border-color: '.concat(themeValues.backgroundColor, "00; border-bottom-color: ").concat(themeValues.backgroundColor, "; border-width: 10px; margin-left: -10px; }");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Imposter, {
        id: id,
        breakout: true,
        top: top,
        left: left,
        visible: visible
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        minWidth: "240px",
        padding: "1rem 0.5rem",
        extraStyles: "position: relative; ".concat(menuCarat),
        background: themeValues.backgroundColor,
        borderRadius: "5px",
        boxShadow: "0px 1px 8px -1px rgba(0, 0, 0, 0.3), 0px 1px 4px 0px ".concat(themeValues.shadowColor, ", 0px 7px 32px 0px ").concat(themeValues.shadowColor),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur
    }, menuContent));
};
var NavMenuDesktop$1 = themeComponent(NavMenuDesktop, "NavMenu", fallbackValues$I, "profile");
var menuVariants = {
    invisible: {
        x: "-100vw",
        transition: {
            ease: "easeOut",
            duration: 0.5
        }
    },
    visible: {
        x: "0",
        transition: {
            ease: "easeIn",
            duration: 0.5
        }
    }
};
var ImposterMenu = (0, _styledComponentsDefault.default)(Motion).withConfig({
    displayName: "NavMenuMobile__ImposterMenu",
    componentId: "sc-1pf0qp7-0"
})([
    "position:fixed;top:",
    ";left:0;right:0;bottom:0;background:",
    ";"
], function(_ref) {
    var headerSize = _ref.headerSize;
    return headerSize;
}, function(_ref2) {
    var themeValues = _ref2.themeValues;
    return (themeValues === null || themeValues === void 0 ? void 0 : themeValues.overlayColor) || "rgba(0, 0, 0, 0.5)";
});
var NavMenuMobile = function NavMenuMobile(_ref3) {
    var id = _ref3.id, _ref3$menuContent = _ref3.menuContent, menuContent = _ref3$menuContent === void 0 ? [] : _ref3$menuContent, _ref3$visible = _ref3.visible, visible = _ref3$visible === void 0 ? false : _ref3$visible, _ref3$headerSize = _ref3.headerSize, headerSize = _ref3$headerSize === void 0 ? "72px" : _ref3$headerSize, themeValues = _ref3.themeValues;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ImposterMenu, {
        id: id,
        variants: menuVariants,
        initial: "invisible",
        animate: visible ? "visible" : "invisible",
        headerSize: headerSize,
        themeValues: themeValues
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        width: "100%",
        maxWidth: "400px",
        padding: "1rem 0.5rem",
        extraStyles: "position: relative; max-width: 400px; height: calc(100vh - 72px); overflow-y: auto;",
        background: themeValues.backgroundColor
    }, menuContent));
};
var NavMenuMobile$1 = themeComponent(NavMenuMobile, "NavMenu", fallbackValues$I, "profile");
var arrowColor = WHITE;
var numberColor = MATISSE_BLUE;
var hoverBackgroundColor$2 = ALABASTER_WHITE;
var activeBackgroundColor$1 = WHITE;
var activeColor$8 = MATISSE_BLUE;
var fallbackValues$J = {
    activeColor: activeColor$8,
    activeBackgroundColor: activeBackgroundColor$1,
    arrowColor: arrowColor,
    hoverBackgroundColor: hoverBackgroundColor$2,
    numberColor: numberColor
};
var PAGING_SPACE = 2; // how many pages we want to have before/after delimiter
var PAGING_INIT_SPACE = 3; // first delimiter should appear after 3 pages
var PrevNextPlaceholder = function PrevNextPlaceholder(_ref) {
    var buttonHeight = _ref.buttonHeight, buttonWidth = _ref.buttonWidth;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minHeight: buttonHeight,
        minWidth: buttonWidth,
        extraStyles: "max-height: ".concat(buttonHeight, ";")
    });
};
var PrevNextButton = function PrevNextButton(_ref2) {
    var action = _ref2.action, ariaLabel = _ref2.ariaLabel, arrowColor = _ref2.arrowColor, borderRadius = _ref2.borderRadius, buttonHeight = _ref2.buttonHeight, buttonWidth = _ref2.buttonWidth, numberColor = _ref2.numberColor, type = _ref2.type;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minHeight: buttonHeight,
        extraStyles: "max-height: ".concat(buttonHeight, ";"),
        as: "li"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        action: action,
        contentOverride: true,
        dataQa: type,
        "aria-label": ariaLabel,
        extraStyles: "\n        background-color: ".concat(numberColor, ";\n        border-color: ").concat(numberColor, ";\n        border-radius: ").concat(borderRadius, ";\n        margin: 0;\n        max-height: ").concat(buttonHeight, ";\n        min-height: 100%;\n        min-width: ").concat(buttonWidth, ";\n        padding: 0;\n      ")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        extraStyles: type === "prev" && "transform: scaleX(-1)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ChevronIcon$1, {
        variant: "darkMode",
        iconFill: arrowColor
    }))));
};
var getPagesPanel = function getPagesPanel(page, pagesCount) {
    if (!pagesCount || pagesCount <= 1) return [];
    var lastPageNumber = pagesCount;
    var space = page === 1 ? PAGING_INIT_SPACE : PAGING_SPACE;
    var pages = [
        {
            index: 1,
            isButton: true
        }
    ];
    if (page > space + 1) pages.push({
        isDelimiter: true,
        id: "first-delimiter"
    });
    for(var j = Math.max(1, page - space) + 1; j < Math.min(lastPageNumber, page + space); j++)pages.push({
        index: j,
        isButton: true,
        id: "page-".concat(j)
    });
    if (page < lastPageNumber - space) pages.push({
        isDelimiter: true,
        id: "last-delimiter"
    });
    pages.push({
        index: lastPageNumber,
        isButton: true,
        id: "page-".concat(lastPageNumber)
    });
    var activePage = pages.find(function(p) {
        return p.index === page;
    });
    if (activePage) activePage.active = true;
    return pages;
};
var Pagination = function Pagination(_ref3) {
    var _ref3$activeBorderWid = _ref3.activeBorderWidth, activeBorderWidth = _ref3$activeBorderWid === void 0 ? "3px" : _ref3$activeBorderWid, ariaLabel = _ref3.ariaLabel, arrowColor = _ref3.arrowColor, _ref3$borderRadius = _ref3.borderRadius, borderRadius = _ref3$borderRadius === void 0 ? "3px" : _ref3$borderRadius, _ref3$buttonHeight = _ref3.buttonHeight, buttonHeight = _ref3$buttonHeight === void 0 ? "44px" : _ref3$buttonHeight, _ref3$buttonWidth = _ref3.buttonWidth, buttonWidth = _ref3$buttonWidth === void 0 ? "44px" : _ref3$buttonWidth, _ref3$childGap = _ref3.childGap, childGap = _ref3$childGap === void 0 ? "24px" : _ref3$childGap, currentPage = _ref3.currentPage, _ref3$fontSize = _ref3.fontSize, fontSize = _ref3$fontSize === void 0 ? "17px" : _ref3$fontSize, _ref3$fontWeight = _ref3.fontWeight, fontWeight = _ref3$fontWeight === void 0 ? "900" : _ref3$fontWeight, numberColor = _ref3.numberColor, pageCount = _ref3.pageCount, pageNext = _ref3.pageNext, pagePrevious = _ref3.pagePrevious, setCurrentPage = _ref3.setCurrentPage, themeValues = _ref3.themeValues;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    var extraStyles = "\n    min-width: ".concat(buttonWidth, "; min-height: 100%; padding: 0;\n    border-radius: ").concat(borderRadius, ";\n    > * > span {\n      color: ").concat(numberColor !== null && numberColor !== void 0 ? numberColor : themeValues.numberColor, "\n    }\n    margin: 0;\n    &:hover {\n        background-color: ").concat(themeValues.hoverBackgroundColor, "\n    }\n  ");
    var currentPageStyles = "\n    border: ".concat(activeBorderWidth, " solid ").concat(numberColor !== null && numberColor !== void 0 ? numberColor : themeValues.numberColor, ";\n    color: ").concat(numberColor !== null && numberColor !== void 0 ? numberColor : themeValues.activeColor, ";\n    background-color: ").concat(themeValues.activeBackgroundColor, ";\n    &:focus {\n      box-shadow: none;\n    }\n    &:hover {\n      background-color: initial;\n      border: ").concat(activeBorderWidth, " solid ").concat(numberColor !== null && numberColor !== void 0 ? numberColor : themeValues.numberColor, ";\n      background-color: ").concat(themeValues.activeBackgroundColor, ";\n    }\n  ");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        childGap: childGap,
        overflow: true,
        as: "nav",
        role: "navigation",
        innerWrapperAs: "ul",
        "aria-label": ariaLabel,
        extraStyles: "> ul { padding: 0px; > li { list-style-type: none; } };"
    }, currentPage > 1 ? /*#__PURE__*/ (0, _reactDefault.default).createElement(PrevNextButton, {
        action: pagePrevious,
        ariaLabel: "Previous Page",
        arrowColor: arrowColor !== null && arrowColor !== void 0 ? arrowColor : themeValues.arrowColor,
        borderRadius: borderRadius,
        buttonHeight: buttonHeight,
        buttonWidth: buttonWidth,
        numberColor: numberColor !== null && numberColor !== void 0 ? numberColor : themeValues.numberColor,
        type: "prev"
    }) : isMobile && /*#__PURE__*/ (0, _reactDefault.default).createElement(PrevNextPlaceholder, {
        buttonHeight: buttonHeight,
        buttonWidth: buttonWidth
    }), isMobile ? pageCount > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        singleChild: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pXL",
        weight: fontWeight,
        color: numberColor !== null && numberColor !== void 0 ? numberColor : themeValues.numberColor,
        extraStyles: "font-size: ".concat(fontSize)
    }, "".concat(currentPage, " of ").concat(pageCount)))) : getPagesPanel(currentPage, pageCount).map(function(item, index) {
        return item.isButton ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0",
            extraStyles: "max-height: ".concat(buttonHeight, ";"),
            as: "li",
            key: item.id
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
            variant: "ghost",
            text: item.index,
            "aria-current": item.active ? "page" : undefined,
            "aria-label": "".concat(item.index == pageCount ? "Last Page, " : "", "page ").concat(item.index),
            action: !item.active ? function() {
                return setCurrentPage({
                    pageNumber: item.index
                });
            } : noop$1,
            textExtraStyles: "font-size: ".concat(fontSize, "; font-weight: ").concat(fontWeight, ";"),
            extraStyles: "".concat(extraStyles).concat(item.active ? currentPageStyles : ""),
            dataQa: index
        }, item.index)) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0 10px",
            as: "li",
            key: item.id
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
            justify: "flex-end"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
            variant: "pXL",
            weight: fontWeight,
            color: numberColor !== null && numberColor !== void 0 ? numberColor : themeValues.numberColor,
            role: "presentation"
        }, "\u2026")));
    }), currentPage < pageCount ? /*#__PURE__*/ (0, _reactDefault.default).createElement(PrevNextButton, {
        action: pageNext,
        ariaLabel: "Next Page",
        arrowColor: arrowColor !== null && arrowColor !== void 0 ? arrowColor : themeValues.arrowColor,
        borderRadius: borderRadius,
        buttonHeight: buttonHeight,
        buttonWidth: buttonWidth,
        numberColor: numberColor !== null && numberColor !== void 0 ? numberColor : themeValues.numberColor,
        type: "next"
    }) : isMobile && /*#__PURE__*/ (0, _reactDefault.default).createElement(PrevNextPlaceholder, {
        buttonHeight: buttonHeight,
        buttonWidth: buttonWidth
    }));
};
var Pagination$1 = themeComponent(Pagination, "Pagination", fallbackValues$J);
var backgroundColor$b = {
    "default": "transparent",
    small: "transparent"
};
var lineItem = {
    "default": "default",
    small: "small"
};
var labeledAmountSubtotal = {
    "default": "regular",
    small: "small"
};
var labeledAmountTotal = {
    "default": "large",
    small: "small"
};
var fallbackValues$K = {
    backgroundColor: backgroundColor$b,
    lineItem: lineItem,
    labeledAmountSubtotal: labeledAmountSubtotal,
    labeledAmountTotal: labeledAmountTotal
};
var _excluded$L = [
    "amount"
], _excluded2$1 = [
    "amount"
];
var PaymentDetailsContent = function PaymentDetailsContent(_ref) {
    var lineItemElems = _ref.lineItemElems, feeElems = _ref.feeElems, subtotal = _ref.subtotal, total = _ref.total, variant = _ref.variant, themeValues = _ref.themeValues, hasVoidablePaymentsSection = _ref.hasVoidablePaymentsSection, voidableTransactionDetails = _ref.voidableTransactionDetails, voidableAmountPaid = _ref.voidableAmountPaid, partialVoidAction = _ref.partialVoidAction, remainingBalance = _ref.remainingBalance, agencySubheading = _ref.agencySubheading, isCollapsible = _ref.isCollapsible;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "16px"
    }, isCollapsible && agencySubheading, lineItemElems, hasVoidablePaymentsSection && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: ATHENS_GREY
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "p",
        color: themeValues.text,
        weight: "400",
        fontSize: "0.875rem"
    }, "Paid"), voidableTransactionDetails.map(function(t) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
            key: t.id,
            justify: "space-between",
            align: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
            padding: "0",
            align: "center",
            extraStyles: "font-size: 14px;"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0"
        }, t.voidText), /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
            variant: "ghost",
            action: function action() {
                return partialVoidAction(t);
            },
            text: "Void",
            padding: "0",
            extraStyles: "\n                  min-width: 65px;\n                  margin: 0px;\n                  min-height: 0px;\n                ",
            textExtraStyles: "font-weight: ".concat(FONT_WEIGHT_REGULAR, "; font-size: 14px;")
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0",
            key: t.id
        }, displayCurrency(t.amount_processed)));
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "16px 0px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SolidDivider$1, null)), /*#__PURE__*/ (0, _reactDefault.default).createElement(LabeledAmount$1, {
        version: "v2",
        as: "h3",
        variant: "small",
        extraStyles: "font-weight: ".concat(FONT_WEIGHT_REGULAR, "; font-size: 14px;"),
        label: "Amount paid",
        amount: displayCurrency(voidableAmountPaid)
    })), !hasVoidablePaymentsSection && !!lineItemElems.length && /*#__PURE__*/ (0, _reactDefault.default).createElement(SolidDivider$1, null) // avoids duplicate dividers -> case of voidable payment section, that acts as divider
    , subtotal ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0.5rem 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(LabeledAmount$1, {
        version: "v2",
        variant: themeValues.labeledAmountSubtotal,
        label: "Subtotal",
        amount: displayCurrency(subtotal),
        as: "h3"
    }), feeElems), /*#__PURE__*/ (0, _reactDefault.default).createElement(SolidDivider$1, null)) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(LabeledAmount$1, {
        version: "v2",
        as: "h3",
        variant: themeValues.labeledAmountTotal,
        label: hasVoidablePaymentsSection ? "Remaining amount due" : "Total",
        amount: displayCurrency(typeof remainingBalance === "number" ? remainingBalance : total),
        extraStyles: "margin-top: 1rem;"
    }));
};
var LoadingDetails = function LoadingDetails() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minHeight: "196px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        extraStyles: "position: absolute;\n        height: 200px;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Spinner$2, {
        size: "100",
        centerSpinner: true
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "16px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        nowrap: true,
        justify: "space-between",
        align: "start"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingLine, {
        exactWidth: "110",
        height: "27px"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingLine, {
        exactWidth: "60",
        height: "27px"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(SolidDivider$1, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0.5rem 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "start"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingLine, {
        exactWidth: "80",
        height: "27px"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingLine, {
        exactWidth: "60",
        height: "27px"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "4px 0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "start"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingLine, {
        exactWidth: "100",
        height: "27px"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingLine, {
        exactWidth: "50",
        height: "27px"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement(SolidDivider$1, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        justify: "space-between",
        direction: "row"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingLine, {
        exactWidth: "55",
        height: "30px"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingLine, {
        exactWidth: "70",
        height: "30px"
    }))));
};
var ErrorDetails = function ErrorDetails() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Alert$1, {
        variant: "error",
        heading: "Error Loading Payment",
        text: "Please go back and try again.",
        showQuitLink: false,
        noBorder: true,
        enableBoxShadow: true,
        enableSmallText: true,
        innerContentPadding: "0 0 0 0.75rem",
        iconPadding: "0 0 0 0",
        height: "67px",
        minHeight: "67px",
        padding: "0.75rem"
    }));
};
var getLoadingOrErrorContent = function getLoadingOrErrorContent() {
    var isLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isLoading) return /*#__PURE__*/ (0, _reactDefault.default).createElement(LoadingDetails, null);
    else if (isError) return /*#__PURE__*/ (0, _reactDefault.default).createElement(ErrorDetails, null);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null);
};
var Collapsible = function Collapsible(_ref2) {
    var content = _ref2.content, title = _ref2.title, supportsTouch = _ref2.supportsTouch, isOpen = _ref2.isOpen, setIsOpen = _ref2.setIsOpen, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, _ref2$isError = _ref2.isError, isError = _ref2$isError === void 0 ? false : _ref2$isError;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(CollapsibleSection$1, {
        isMobile: true,
        supportsTouch: supportsTouch,
        isOpen: isOpen,
        title: title,
        initiallyOpen: false,
        toggleSection: function toggleSection() {
            return setIsOpen(!isOpen);
        },
        customTitle: true,
        name: "Collapsed Payment Details"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Motion, {
        variants: {
            open: {
                opacity: 1
            },
            closed: {
                opacity: 0
            }
        },
        positionTransition: true,
        initial: "closed",
        animate: isOpen ? "open" : "closed"
    }, isLoading || isError ? getLoadingOrErrorContent(isLoading, isError) : content));
};
var NonCollapsible = function NonCollapsible(_ref3) {
    var title = _ref3.title, content = _ref3.content, _ref3$isLoading = _ref3.isLoading, isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading, _ref3$isError = _ref3.isError, isError = _ref3$isError === void 0 ? false : _ref3$isError;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, null, title, isLoading || isError ? getLoadingOrErrorContent(isLoading, isError) : content);
};
var PaymentDetails = function PaymentDetails(_ref4) {
    var _lineItems = _ref4.lineItems, _fees = _ref4.fees, subtotal = _ref4.subtotal, total = _ref4.total, _ref4$variant = _ref4.variant, variant = _ref4$variant === void 0 ? "default" : _ref4$variant, _ref4$hideTitle = _ref4.hideTitle, hideTitle = _ref4$hideTitle === void 0 ? false : _ref4$hideTitle, _ref4$titleText = _ref4.titleText, titleText = _ref4$titleText === void 0 ? "Payment Details" : _ref4$titleText, _ref4$initiallyOpen = _ref4.initiallyOpen, initiallyOpen = _ref4$initiallyOpen === void 0 ? false : _ref4$initiallyOpen, _ref4$collapsibleOnMo = _ref4.collapsibleOnMobile, collapsibleOnMobile = _ref4$collapsibleOnMo === void 0 ? true : _ref4$collapsibleOnMo, isMobile = _ref4.isMobile, supportsTouch = _ref4.supportsTouch, themeValues = _ref4.themeValues, _ref4$hasVoidablePaym = _ref4.hasVoidablePaymentsSection, hasVoidablePaymentsSection = _ref4$hasVoidablePaym === void 0 ? false : _ref4$hasVoidablePaym, _ref4$voidableTransac = _ref4.voidableTransactionDetails, voidableTransactionDetails = _ref4$voidableTransac === void 0 ? [] : _ref4$voidableTransac, _ref4$partialVoidActi = _ref4.partialVoidAction, partialVoidAction = _ref4$partialVoidActi === void 0 ? noop$1 : _ref4$partialVoidActi, _ref4$voidableAmountP = _ref4.voidableAmountPaid, voidableAmountPaid = _ref4$voidableAmountP === void 0 ? 0 : _ref4$voidableAmountP, _ref4$remainingBalanc = _ref4.remainingBalance, remainingBalance = _ref4$remainingBalanc === void 0 ? false : _ref4$remainingBalanc, _ref4$isLoading = _ref4.isLoading, isLoading = _ref4$isLoading === void 0 ? false : _ref4$isLoading, _ref4$isError = _ref4.isError, isError = _ref4$isError === void 0 ? false : _ref4$isError, agencyDisplayName = _ref4.agencyDisplayName;
    var _useState = (0, _react.useState)(initiallyOpen), _useState2 = _slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var fees = _fees.filter(function(fee) {
        return fee.amount > 0;
    }).map(function(_ref5) {
        var amount = _ref5.amount, rest = _objectWithoutProperties(_ref5, _excluded$L);
        return _objectSpread2(_objectSpread2({}, rest), {}, {
            amount: displayCurrency(amount)
        });
    });
    var lineItems = _lineItems.map(function(_ref6) {
        var amount = _ref6.amount, rest = _objectWithoutProperties(_ref6, _excluded2$1);
        return _objectSpread2(_objectSpread2({}, rest), {}, {
            amount: displayCurrency(amount)
        });
    });
    var isCollapsible = isMobile && collapsibleOnMobile;
    var lineItemElems = lineItems.map(function(item, id) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(LineItem$1, _extends({
            key: id,
            variant: themeValues.lineItem
        }, item));
    });
    var feeElems = fees.map(function(fee) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), {
            key: fee.label
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "4px 0"
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement(LabeledAmount$1, _extends({
            version: "v2",
            as: "h3",
            key: fee.label,
            variant: themeValues.labeledAmountSubtotal
        }, fee)));
    });
    var agencySubheading = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, agencyDisplayName && /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center",
        style: {
            margin: isCollapsible ? "0" : "0.5rem 0"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        weight: FONT_WEIGHT_REGULAR,
        as: "p",
        extraStyles: "font-size: 1rem;"
    }, agencyDisplayName), (lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pS",
        color: themeValues.text,
        weight: "400"
    }, "".concat(lineItems.length, "  item").concat(lineItems.length > 1 ? "s" : ""))));
    var content = isCollapsible ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "4.5px"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(SolidDivider$1, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "8px"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(PaymentDetailsContent, {
        lineItemElems: lineItemElems,
        feeElems: feeElems,
        subtotal: subtotal,
        total: total,
        themeValues: themeValues,
        variant: variant,
        hasVoidablePaymentsSection: hasVoidablePaymentsSection,
        voidableTransactionDetails: voidableTransactionDetails,
        voidableAmountPaid: voidableAmountPaid,
        partialVoidAction: partialVoidAction,
        remainingBalance: remainingBalance,
        agencySubheading: agencySubheading,
        isCollapsible: isCollapsible
    })) : /*#__PURE__*/ (0, _reactDefault.default).createElement(PaymentDetailsContent, {
        lineItemElems: lineItemElems,
        feeElems: feeElems,
        subtotal: subtotal,
        total: total,
        themeValues: themeValues,
        variant: variant,
        hasVoidablePaymentsSection: hasVoidablePaymentsSection,
        voidableTransactionDetails: voidableTransactionDetails,
        voidableAmountPaid: voidableAmountPaid,
        partialVoidAction: partialVoidAction,
        remainingBalance: remainingBalance,
        agencySubheading: agencySubheading,
        isCollapsible: isCollapsible
    });
    var title = hideTitle ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null) : isCollapsible ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        width: "100%",
        padding: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "space-between",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        weight: FONT_WEIGHT_SEMIBOLD,
        as: "h2",
        extraStyles: "font-size: 1.375rem; line-height: ".concat(isMobile ? "2.2857rem" : "2.25rem", ";"),
        id: "payment-details-title"
    }, titleText), /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        weight: FONT_WEIGHT_BOLD,
        as: "p",
        extraStyles: "font-size: 1.375rem;"
    }, displayCurrency(total)))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Title$1, {
        as: "h2",
        weight: FONT_WEIGHT_SEMIBOLD,
        margin: "1rem 0 0 0",
        extraStyles: "font-size: 1.375rem; line-height: ".concat(isMobile ? "2.2857rem" : "2.25rem", ";"),
        id: "payment-details-title"
    }, titleText), agencySubheading);
    return isCollapsible ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Collapsible, {
        title: title,
        content: content,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        isMobile: isMobile,
        supportsTouch: supportsTouch,
        isLoading: isLoading,
        isError: isError
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement(NonCollapsible, {
        title: title,
        content: content,
        isLoading: isLoading,
        isError: isError
    });
};
var PaymentDetails$1 = themeComponent(PaymentDetails, "PaymentDetails", fallbackValues$K, "default");
var DashboardIframe = (0, _styledComponentsDefault.default).iframe.withConfig({
    displayName: "PeriscopeDashboardIframestyled__DashboardIframe",
    componentId: "sc-j0cucj-0"
})([
    "border:none;box-shadow:0 0 5px 0 ",
    ";display:none;"
], ALTO_GREY);
/**
 * Component: PeriscopeDashboardIframe
 *
 * Used for rendering Citybase's periscope reporting dashboards in iframes.
 * Receives action props to trigger a request on mount for the iframe's url.
 * Receives a string prop if/when we receive the url result.
 * And receives action props to emit errors from failed iframe loading.
 *
 * The logic and api client methods to handle requests/response,
 * store the url, etc. should be provided from the app consuming this library.
 *
 * If the url request is pending, render a spinner.
 * If the url request failed, render a UI error state.
 **/ var DASHBOARD_SIZE_MESSAGE_TYPE = "dashboard_resize";
var PERISCOPE_ORIGIN = "https://app.periscopedata.com";
var isValidMessage = function isValidMessage(message) {
    return message.isTrusted && message.origin === PERISCOPE_ORIGIN && message.data && message.data.event_type === DASHBOARD_SIZE_MESSAGE_TYPE;
};
var PeriscopeDashboardIframe = function PeriscopeDashboardIframe(_ref) {
    var url = _ref.url, requestDashboardUrl = _ref.requestDashboardUrl, periscopeDataPending = _ref.periscopeDataPending, periscopeDataSuccess = _ref.periscopeDataSuccess, periscopeDataFailure = _ref.periscopeDataFailure, periscopeDataRequestSuccess = _ref.periscopeDataRequestSuccess, periscopeDataRequestFailure = _ref.periscopeDataRequestFailure, _ref$timerMS = _ref.timerMS, timerMS = _ref$timerMS === void 0 ? 20000 : _ref$timerMS;
    var _useState = (0, _react.useState)(0), _useState2 = _slicedToArray(_useState, 2), height = _useState2[0], setHeight = _useState2[1];
    var time = {
        timer: null
    };
    (0, _react.useEffect)(function() {
        time.timer = setTimeout(function() {
            if (!periscopeDataSuccess) periscopeDataRequestFailure();
        }, timerMS);
        return function() {
            return clearTimeout(time.timer);
        };
    }, [
        periscopeDataSuccess
    ]);
    var Dashboard = function Dashboard(height) {
        return function(url) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(DashboardIframe, {
                src: url,
                width: "100%",
                height: height,
                "data-qa": "DashboardIframe",
                onLoad: function onLoad() {
                    var iframe = document.querySelector("iframe");
                    iframe.style.display = "initial";
                }
            });
        };
    };
    var validatePeriscope = function validatePeriscope(message) {
        if (isValidMessage(message)) {
            setHeight(message.data.dashboard_height + 100);
            if (!periscopeDataSuccess) {
                clearTimeout(time.timer);
                periscopeDataRequestSuccess();
            }
        }
    };
    (0, _react.useLayoutEffect)(function() {
        window.addEventListener("message", validatePeriscope);
        requestDashboardUrl();
        return function() {
            return window.removeEventListener("message", validatePeriscope);
        };
    }, [
        requestDashboardUrl
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(BoxWithShadow$1, {
        padding: "0",
        minWidth: "100%",
        minHeight: "592px",
        variant: "baseStandard",
        background: "#fff",
        borderRadius: "4px",
        extraStyles: "display: flex; justify-content: center; align-items: center; flex-direction: column;"
    }, periscopeDataPending && !periscopeDataSuccess && /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        minHeight: "100%",
        singleChild: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        intrinsic: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Spinner$2, {
        size: "100"
    }))), periscopeDataFailure && !periscopeDataSuccess && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "64px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        intrinsic: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 0 2rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PeriscopeFailedIcon, null)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Heading$1, {
        variant: "h3",
        weight: "700"
    }, "Something Went Wrong"), /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: "p",
        extraStyles: "text-align: center;"
    }, "There was an issue trying to load the dashboard."), /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: "p",
        extraStyles: "text-align: center;"
    }, "Your organization may not have a dashboard configured."))), !periscopeDataFailure && url && Dashboard(height)(url)));
};
var PhoneForm = function PhoneForm(_ref) {
    var _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "default" : _ref$variant, fields = _ref.fields, actions = _ref.actions, clearOnDismount = _ref.clearOnDismount, showErrors = _ref.showErrors, _ref$handleSubmit = _ref.handleSubmit, handleSubmit = _ref$handleSubmit === void 0 ? noop$1 : _ref$handleSubmit, showWalletCheckbox = _ref.showWalletCheckbox, saveToWallet = _ref.saveToWallet, walletCheckboxMarked = _ref.walletCheckboxMarked, _ref$isRequired = _ref.isRequired, isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired;
    if (clearOnDismount) (0, _react.useEffect)(function() {
        return function() {
            return actions.form.clear();
        };
    }, []);
    useConditionallyAddValidator(isRequired, required, actions.fields.phone.addValidator, actions.fields.phone.removeValidator);
    var phoneErrorMessage = _defineProperty(_defineProperty({}, required.error, "Phone number is required"), hasLength.error, "Phone number must be 10 digits");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormContainer$1, {
        variant: variant,
        role: "form",
        "aria-label": "Phone number"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Phone number",
        errorMessages: phoneErrorMessage,
        field: fields.phone,
        fieldActions: actions.fields.phone,
        showErrors: showErrors,
        formatter: createFormat(phoneFormats, formatDelimiter),
        onKeyUp: function onKeyUp(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "tel-national",
        dataQa: "Phone number",
        isNum: true,
        isRequired: isRequired
    }), showWalletCheckbox && /*#__PURE__*/ (0, _reactDefault.default).createElement(Checkbox$1, {
        name: "phone checkbox",
        title: "Save phone number to wallet",
        checked: walletCheckboxMarked,
        onChange: saveToWallet
    })));
};
var formConfig$6 = {
    phone: {
        validators: [
            hasLength(10, 10)
        ],
        // 'required' validator is conditionally added based on `isRequired` prop
        constraints: [
            onlyIntegers(),
            hasLength(0, 10)
        ]
    }
};
var _createFormState$6 = createFormState(formConfig$6), reducer$6 = _createFormState$6.reducer, mapStateToProps$7 = _createFormState$6.mapStateToProps, mapDispatchToProps$6 = _createFormState$6.mapDispatchToProps;
PhoneForm.reducer = reducer$6;
PhoneForm.mapStateToProps = mapStateToProps$7;
PhoneForm.mapDispatchToProps = mapDispatchToProps$6;
var DefaultHeading = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "RadioGroup__DefaultHeading",
    componentId: "sc-7lqrl8-0"
})([
    "",
    " color:",
    ";margin:0;padding:8px 0px;"
], function(_ref) {
    var fontSize = _ref.fontSize;
    return "font-size: ".concat(fontSize, ";");
}, CHARADE_GREY);
var StyledFieldset = (0, _styledComponentsDefault.default).fieldset.withConfig({
    displayName: "RadioGroup__StyledFieldset",
    componentId: "sc-7lqrl8-1"
})([
    "",
    ""
], function(props) {
    return props.$extraStyles;
});
var RadioGroup = function RadioGroup(_ref2) {
    var headingText = _ref2.headingText, groupName = _ref2.groupName, _ref2$headingFontSize = _ref2.headingFontSize, headingFontSize = _ref2$headingFontSize === void 0 ? "0.875rem" : _ref2$headingFontSize, _ref2$heading = _ref2.heading, Heading = _ref2$heading === void 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement(DefaultHeading, {
        role: "heading",
        id: "radio-group-".concat(groupName, "-heading"),
        fontSize: headingFontSize
    }, headingText) : _ref2$heading, config = _ref2.config, extraStyles = _ref2.extraStyles, _ref2$handleChange = _ref2.handleChange, handleChange = _ref2$handleChange === void 0 ? noop$1 : _ref2$handleChange, field = _ref2.field, fieldActions = _ref2.fieldActions;
    var setValue = function setValue(value) {
        return fieldActions.set(value);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledFieldset, {
        role: "radiogroup",
        "aria-labelledby": "radio-group-".concat(groupName, "-heading"),
        $extraStyles: extraStyles
    }, Heading !== null && Heading, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "4px"
    }, config.map(function(c, idx) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(RadioButtonWithLabel$1, _extends({
            index: idx,
            key: c.id
        }, c, {
            groupName: groupName,
            setValue: setValue,
            handleChange: handleChange,
            field: field,
            config: config,
            "aria-invalid": field.dirty && field.hasErrors
        }));
    })));
};
var RegistrationForm = function RegistrationForm(_ref) {
    var clearOnDismount = _ref.clearOnDismount, fields = _ref.fields, actions = _ref.actions, _ref$handleSubmit = _ref.handleSubmit, handleSubmit = _ref$handleSubmit === void 0 ? noop$1 : _ref$handleSubmit, showErrors = _ref.showErrors, isMobile = _ref.isMobile;
    if (clearOnDismount) (0, _react.useEffect)(function() {
        return function() {
            return actions.form.clear();
        };
    }, []);
    var firstNameErrorMessages = _defineProperty(_defineProperty({}, required.error, "First name is required"), validName.error, "First name contains invalid characters");
    var lastNameErrorMessages = _defineProperty(_defineProperty({}, required.error, "Last name is required"), validName.error, "Last name contains invalid characters");
    var emailErrorMessages = _defineProperty(_defineProperty({}, required.error, "Email is required"), isProbablyEmail.error, "Please enter a valid email address in the format user@example.com");
    var passwordErrorMessages = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, required.error, "Password is required"), hasLength.error, "Password must have at least 8 characters"), hasNumber.error, "Password must contain at least one number"), hasLowercaseLetter.error, "Password must contain at least one lowercase letter"), hasUppercaseLetter.error, "Password must contain at least one uppercase letter"), hasSpecialCharacter.error, "Password must contain at least one special character (!@#$%^&*.?)");
    var confirmPasswordErrorMessages = _defineProperty({}, matchesField.error, "Confirm password must match password");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, {
        role: "form",
        "aria-label": "Registration"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "First name",
        errorMessages: firstNameErrorMessages,
        field: fields.firstName,
        fieldActions: actions.fields.firstName,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "given-name",
        dataQa: "First name",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Last name",
        errorMessages: lastNameErrorMessages,
        field: fields.lastName,
        fieldActions: actions.fields.lastName,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        autocompleteValue: "family-name",
        dataQa: "Last name",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Email address",
        errorMessages: emailErrorMessages,
        field: fields.email,
        fieldActions: actions.fields.email,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        type: "email",
        isEmail: true,
        autocompleteValue: "email",
        dataQa: "Email address",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Password",
        errorMessages: passwordErrorMessages,
        field: fields.password,
        fieldActions: actions.fields.password,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        type: "password",
        autocompleteValue: "new-password",
        dataQa: "Password",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Confirm password",
        errorMessages: confirmPasswordErrorMessages,
        field: fields.confirmPassword,
        fieldActions: actions.fields.confirmPassword,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        type: "password",
        autocompleteValue: "new-password",
        dataQa: "Confirm password",
        isRequired: true
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: isMobile ? "0" : "0.5rem 0 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PasswordRequirements, {
        password: fields.password,
        isMobile: isMobile
    })));
};
var formConfig$7 = {
    firstName: {
        validators: [
            required(),
            validName()
        ]
    },
    lastName: {
        validators: [
            required(),
            validName()
        ]
    },
    email: {
        validators: [
            required(),
            isProbablyEmail()
        ]
    },
    password: {
        validators: [
            required(),
            hasLength(8, 100),
            hasNumber(),
            hasLowercaseLetter(),
            hasUppercaseLetter(),
            hasSpecialCharacter()
        ]
    },
    confirmPassword: {
        validators: [
            required(),
            matchesField("password")
        ]
    }
};
var _createFormState$7 = createFormState(formConfig$7), reducer$7 = _createFormState$7.reducer, mapStateToProps$8 = _createFormState$7.mapStateToProps, mapDispatchToProps$7 = _createFormState$7.mapDispatchToProps;
RegistrationForm.reducer = reducer$7;
RegistrationForm.mapStateToProps = mapStateToProps$8;
RegistrationForm.mapDispatchToProps = mapDispatchToProps$7;
var GRECIAN_GREY$1 = GRECIAN_GREY;
var bannerBackgroundColor = GRECIAN_GREY$1;
var fallbackValues$L = {
    bannerBackgroundColor: bannerBackgroundColor
};
var ResetConfirmationForm = function ResetConfirmationForm() {
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var themeValues = createThemeValues(themeContext, fallbackValues$L, "ResetConfirmationForm");
    var isMobile = themeContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        width: isMobile ? "auto" : "576px",
        borderRadius: "4px",
        background: WHITE,
        boxShadow: "0px 2px 14px 0px rgb(246, 246, 249), 0px 3px 8px 0px rgb(202, 206, 216)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: themeValues.bannerBackgroundColor,
        minWidth: "100%",
        padding: "0.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ForgotPasswordIcon$1, null))), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormContainer$1, {
        role: "form",
        "aria-label": "Reset password confirmation"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, {
        childGap: "0.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Heading$1, {
        color: CHARADE_GREY,
        variant: "h5",
        weight: "600"
    }, "Password reset link sent")), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: "p",
        color: CHARADE_GREY
    }, "Your password link was sent successfully. Check your email for a reset password link."))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: isMobile ? "1rem 0 0" : "1.5rem 0 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithLink, {
        url: "/login",
        text: "Back to Login",
        variant: "primary",
        extraStyles: "width: 100%;",
        linkExtraStyles: "width: 100%;"
    })))));
};
var ResetConfirmationForm$1 = withWindowSize(ResetConfirmationForm);
var ResetPasswordForm = function ResetPasswordForm(_ref) {
    var _ref$handleSubmit = _ref.handleSubmit, handleSubmit = _ref$handleSubmit === void 0 ? noop$1 : _ref$handleSubmit, clearOnDismount = _ref.clearOnDismount, fields = _ref.fields, actions = _ref.actions, showErrors = _ref.showErrors, isMobile = _ref.isMobile;
    if (clearOnDismount) (0, _react.useEffect)(function() {
        return function() {
            return actions.form.clear();
        };
    }, []);
    var passwordErrorMessages = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, required.error, "Password is required"), hasLength.error, "Password must have at least 8 characters"), hasNumber.error, "Password must contain at least one number"), hasLowercaseLetter.error, "Password must contain at least one lowercase letter"), hasUppercaseLetter.error, "Password must contain at least one uppercase letter"), hasSpecialCharacter.error, "Password must contain at least one special character (!@#$%^&*.?)");
    var confirmPasswordErrorMessages = _defineProperty({}, matchesField.error, "Confirm password must match password");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, {
        role: "form",
        "aria-label": "Reset password"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Password",
        errorMessages: passwordErrorMessages,
        field: fields.password,
        fieldActions: actions.fields.password,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        type: "password",
        autocompleteValue: "new-password"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        labelTextWhenNoError: "Confirm password",
        errorMessages: confirmPasswordErrorMessages,
        field: fields.confirmPassword,
        fieldActions: actions.fields.confirmPassword,
        showErrors: showErrors,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && handleSubmit(e);
        },
        type: "password",
        autocompleteValue: "new-password"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PasswordRequirements, {
        password: fields.password,
        isMobile: isMobile
    })));
};
var formConfig$8 = {
    password: {
        validators: [
            required(),
            hasLength(8, 100),
            hasNumber(),
            hasLowercaseLetter(),
            hasUppercaseLetter(),
            hasSpecialCharacter()
        ]
    },
    confirmPassword: {
        validators: [
            required(),
            matchesField("password")
        ]
    }
};
var _createFormState$8 = createFormState(formConfig$8), reducer$8 = _createFormState$8.reducer, mapStateToProps$9 = _createFormState$8.mapStateToProps, mapDispatchToProps$8 = _createFormState$8.mapDispatchToProps;
ResetPasswordForm.reducer = reducer$8;
ResetPasswordForm.mapStateToProps = mapStateToProps$9;
ResetPasswordForm.mapDispatchToProps = mapDispatchToProps$8;
var GRECIAN_GREY$2 = GRECIAN_GREY;
var bannerBackgroundColor$1 = GRECIAN_GREY$2;
var fallbackValues$M = {
    bannerBackgroundColor: bannerBackgroundColor$1
};
var ResetPasswordSuccess = function ResetPasswordSuccess() {
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var themeValues = createThemeValues(themeContext, fallbackValues$M, "ResetPasswordSuccess");
    var isMobile = themeContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        width: isMobile ? "auto" : "576px",
        borderRadius: "4px",
        background: WHITE,
        boxShadow: "0px 2px 14px 0px rgb(246, 246, 249), 0px 3px 8px 0px rgb(202, 206, 216)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: themeValues.bannerBackgroundColor,
        minWidth: "100%",
        padding: "0.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ForgotPasswordIcon$1, null))), /*#__PURE__*/ (0, _reactDefault.default).createElement(FormContainer$1, {
        role: "form",
        "aria-label": "Reset password success"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInputColumn, {
        childGap: "0.5rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Heading$1, {
        color: CHARADE_GREY,
        variant: "h5",
        weight: "600"
    }, "Password reset successful")), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: "p",
        color: CHARADE_GREY
    }, "You can now log in using your new password")), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: isMobile ? "0.5rem 0 0" : "1rem 0 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithLink, {
        url: "/login",
        text: "Log in",
        variant: "primary",
        extraStyles: "width: 100%;",
        linkExtraStyles: "width: 100%;"
    }))))));
};
var ResetPasswordSuccess$1 = withWindowSize(ResetPasswordSuccess);
var activeTabBackground = "#FFFFFF";
var activeTabAccent = "#15749D";
var activeTabHover = "#B8D5E1";
var fallbackValues$N = {
    activeTabBackground: activeTabBackground,
    activeTabAccent: activeTabAccent,
    activeTabHover: activeTabHover
};
var Tab = function Tab(_ref) {
    var label = _ref.label, activeTab = _ref.activeTab, setActiveTab = _ref.setActiveTab;
    var onClick = function onClick() {
        setActiveTab(label);
    };
    var className = "tab-list-item";
    if (activeTab === label) className += " tab-list-active";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        className: className,
        onClick: onClick,
        margin: "0 0 -1px 0",
        padding: "1rem 0.75rem",
        background: activeTab === label ? WHITE : GRECIAN_GREY,
        extraStyles: "cursor: pointer; flex-grow: 1; text-align: center; ".concat(activeTab === label ? "list-style: none;" : "")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        weight: "600"
    }, label));
};
var _excluded$M = [
    "tabsConfig",
    "tabsDisplayMode",
    "tabsPadding",
    "contentPadding",
    "extraStyles"
];
var HORIZONTAL = "horizontal";
var Tabs = function Tabs(_ref) {
    var _tabsConfig$tabs$;
    var tabsConfig = _ref.tabsConfig, _ref$tabsDisplayMode = _ref.tabsDisplayMode, tabsDisplayMode = _ref$tabsDisplayMode === void 0 ? HORIZONTAL : _ref$tabsDisplayMode, _ref$tabsPadding = _ref.tabsPadding, tabsPadding = _ref$tabsPadding === void 0 ? "0" : _ref$tabsPadding, _ref$contentPadding = _ref.contentPadding, contentPadding = _ref$contentPadding === void 0 ? "0" : _ref$contentPadding, _ref$extraStyles = _ref.extraStyles, extraStyles = _ref$extraStyles === void 0 ? "" : _ref$extraStyles, props = _objectWithoutProperties(_ref, _excluded$M);
    var _useState = (0, _react.useState)(((_tabsConfig$tabs$ = tabsConfig.tabs[0]) === null || _tabsConfig$tabs$ === void 0 ? void 0 : _tabsConfig$tabs$.label) || null), _useState2 = _slicedToArray(_useState, 2), activeTab = _useState2[0], toggleActiveTab = _useState2[1];
    (0, _react.useEffect)(function() {
        var currentTabExists = tabsConfig.tabs.some(function(tab) {
            return tab.label === activeTab;
        });
        if (!activeTab || !currentTabExists) {
            var _tabsConfig$tabs$2;
            toggleActiveTab(((_tabsConfig$tabs$2 = tabsConfig.tabs[0]) === null || _tabsConfig$tabs$2 === void 0 ? void 0 : _tabsConfig$tabs$2.label) || null);
        }
    }, [
        tabsConfig,
        activeTab
    ]);
    var createTabs = function createTabs(tabConfig, activeTab) {
        return tabConfig.tabs.map(function(tab) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tab, {
                activeTab: activeTab,
                key: tab.label,
                label: tab.label,
                setActiveTab: function setActiveTab() {
                    return toggleActiveTab(tab.label);
                }
            });
        });
    };
    var showHorizontal = function showHorizontal(tabsConfig, activeTab) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
            justify: "space-around"
        }, createTabs(tabsConfig, activeTab));
    };
    var showVertical = function showVertical(tabsConfig, activeTab) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, null, createTabs(tabsConfig, activeTab));
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        className: "tabs",
        padding: "0",
        extraStyles: extraStyles
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        className: "tab-list",
        padding: tabsPadding
    }, tabsDisplayMode == HORIZONTAL ? showHorizontal(tabsConfig, activeTab) : showVertical(tabsConfig, activeTab)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        className: "tab-content",
        padding: contentPadding
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, tabsConfig.tabs.map(function(tab, idx) {
        if (tab.label !== activeTab) return undefined;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), {
            key: idx
        }, tab.content);
    }))));
};
var Tabs$1 = themeComponent(Tabs, "NavigationTab", fallbackValues$N);
var activeTabBackground$1 = "#FFFFFF";
var activeTabAccent$1 = "#15749D";
var activeTabHover$1 = "#B8D5E1";
var fallbackValues$O = {
    activeTabBackground: activeTabBackground$1,
    activeTabAccent: activeTabAccent$1,
    activeTabHover: activeTabHover$1
};
var TabSidebar = function TabSidebar(_ref) {
    var links = _ref.links, isMobile = _ref.isMobile, themeValues = _ref.themeValues, _ref$minHeight = _ref.minHeight, minHeight = _ref$minHeight === void 0 ? "100%" : _ref$minHeight;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        background: COOL_GREY_05,
        minHeight: minHeight,
        role: "region",
        "aria-label": "Profile tabs",
        boxShadow: isMobile && "inset 0px -1px 0px 0px rgb(202, 206, 216)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Switcher, {
        breakpoint: "20rem",
        childGap: "0.1px",
        padding: "0",
        extraStyles: !isMobile && "overflow: visible;"
    }, links.map(function(_ref2, index) {
        var route = _ref2.route, text = _ref2.text, active = _ref2.active, icon = _ref2.icon;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(InternalLink, {
            to: route,
            key: "".concat(route, "-").concat(index),
            isUnderlined: false,
            hoverUnderline: false,
            extraStyles: "\n            &:hover {\n            ".concat(active ? "> * {\n                background-color: ".concat(themeValues.activeTabHover, ";\n              }") : "> * { \n                background-color: rgba(8, 27, 43, 0.05);\n              }", "}")
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: isMobile ? "6px 4px" : "18px 16px",
            background: active ? themeValues.activeTabBackground : "transparent",
            borderSize: active ? "3px" : "1px",
            borderColor: active ? themeValues.activeTabAccent : TRANSPARENT,
            borderWidthOverride: "0 0 3px 0",
            boxShadow: active ? "0px 2px 4px 0px ".concat(GHOST_GREY, ", 0px 2px 9px 1px ").concat(GHOST_GREY) : "0px 2px 4px 0px ".concat(TRANSPARENT, ", 0px 2px 9px 1px ").concat(TRANSPARENT),
            minWidth: "100%",
            borderRadius: "4px 4px 0 0"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
            padding: "0",
            minWidth: "100%",
            extraStyles: isMobile ? "text-align: center;" : "text-align: left;"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
            justify: isMobile ? "center" : "flex-start",
            align: "center"
        }, icon, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
            variant: isMobile ? "pXXS" : "pS",
            weight: active ? FONT_WEIGHT_BOLD : FONT_WEIGHT_REGULAR,
            color: active ? themeValues.activeTabAccent : BRIGHT_GREY,
            extraStyles: "text-transform: uppercase; ".concat(isMobile ? "width: 100%; padding-top: 4px;" : "padding-left: 8px;")
        }, text)))));
    })));
};
var TabSidebar$1 = themeComponent(TabSidebar, "ProfileTab", fallbackValues$O);
var Timeout = function Timeout(_ref) {
    var onLogout = _ref.onLogout;
    var _useContext = (0, _react.useContext)((0, _styledComponents.ThemeContext)), isMobile = _useContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        intrinsic: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        maxWidth: isMobile ? "100%" : "500px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: "32px",
        justify: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: isMobile ? "1rem" : "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TimeoutImage, null)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Heading$1, {
        textAlign: "center",
        weight: FONT_WEIGHT_BOLD
    }, "Request Timed Out"), /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: "pL",
        extraStyles: "text-align: center;"
    }, "That was taking longer than we expected and your request timed out. Please log out, log back in, and then try again.")), /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        intrinsic: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        variant: "primary",
        text: "Log out",
        action: onLogout
    })))))));
};
var Timeout$1 = withWindowSize(Timeout);
var _excluded$N = [
    "variant",
    "message",
    "toastOpen",
    "closeToastNotification",
    "extraStyles",
    "minWidth",
    "maxWidth",
    "height",
    "childGap",
    "backgroundColor",
    "role",
    "ariaLive",
    "screenReaderMessage",
    "showScreenReaderMessage"
];
var VARIANTS = {
    SUCCESS: "success",
    ERROR: "error"
};
var ToastNotification = function ToastNotification(_ref) {
    var _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? VARIANTS.SUCCESS : _ref$variant, _ref$message = _ref.message, message = _ref$message === void 0 ? "" : _ref$message, toastOpen = _ref.toastOpen, closeToastNotification = _ref.closeToastNotification, extraStyles = _ref.extraStyles, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? "112px" : _ref$minWidth, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? "350px" : _ref$maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? "56px" : _ref$height, _ref$childGap = _ref.childGap, childGap = _ref$childGap === void 0 ? "1rem" : _ref$childGap, backgroundColor = _ref.backgroundColor, _ref$role = _ref.role, role = _ref$role === void 0 ? "status" : _ref$role, _ref$ariaLive = _ref.ariaLive, ariaLive = _ref$ariaLive === void 0 ? "polite" : _ref$ariaLive, screenReaderMessage = _ref.screenReaderMessage, _ref$showScreenReader = _ref.showScreenReaderMessage, showScreenReaderMessage = _ref$showScreenReader === void 0 ? true : _ref$showScreenReader, rest = _objectWithoutProperties(_ref, _excluded$N);
    var screenReaderMessageRef = (0, _react.useRef)();
    var LIVEREGION_TRANSITION_DELAY = 1000;
    (0, _react.useEffect)(function() {
        if (showScreenReaderMessage) {
            var timeout = setTimeout(function() {
                if (screenReaderMessageRef.current) screenReaderMessageRef.current.textContent = "".concat(screenReaderMessage ? screenReaderMessage : message ? message : "");
            }, LIVEREGION_TRANSITION_DELAY);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        showScreenReaderMessage,
        screenReaderMessage,
        message
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, _extends({
        onClick: closeToastNotification,
        onKeyDown: function onKeyDown(e) {
            return e.key === "Enter" && closeToastNotification();
        },
        background: backgroundColor ? backgroundColor : variant === VARIANTS.SUCCESS ? HINT_GREEN : variant === VARIANTS.ERROR ? ERROR_BACKGROUND_COLOR : WHITE,
        minWidth: minWidth,
        minHeight: height && parseInt(height) < 100 ? height : "100px",
        height: height ? height : "auto",
        tabIndex: toastOpen ? "-1" : "0",
        padding: "0rem 1rem",
        borderRadius: "4px",
        boxShadow: generateShadows().standard.base,
        extraStyles: "\n      display: ".concat(toastOpen ? "block" : "none", ";\n      position: fixed; bottom: 4rem; left: 4rem;\n      ").concat(extraStyles, ";\n      cursor: pointer;\n    ")
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        align: "center",
        childGap: childGap,
        justify: "space-between"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        align: "center",
        childGap: childGap
    }, variant === VARIANTS.SUCCESS && /*#__PURE__*/ (0, _reactDefault.default).createElement(SuccessfulIconMedium, null), variant === VARIANTS.ERROR && /*#__PURE__*/ (0, _reactDefault.default).createElement(ErroredIcon, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1rem 0",
        maxWidth: maxWidth
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        weight: FONT_WEIGHT_SEMIBOLD,
        extraStyles: "word-break: break-word;"
    }, message))), /*#__PURE__*/ (0, _reactDefault.default).createElement(IconQuitLarge, null))), showScreenReaderMessage && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ref: screenReaderMessageRef,
        style: SCREEN_READER_ONLY,
        role: role,
        "aria-live": ariaLive,
        "aria-atomic": true
    }));
};
var fontWeight$7 = "600";
var fontColor$1 = WHITE;
var textAlign$1 = "left";
var headerBackgroundColor$1 = BRIGHT_GREY;
var imageBackgroundColor$1 = MATISSE_BLUE;
var fallbackValues$P = {
    fontWeight: fontWeight$7,
    fontColor: fontColor$1,
    textAlign: textAlign$1,
    headerBackgroundColor: headerBackgroundColor$1,
    imageBackgroundColor: imageBackgroundColor$1
};
var WelcomeImage = (0, _styledComponentsDefault.default).img.withConfig({
    displayName: "WelcomeModule__WelcomeImage",
    componentId: "sc-1d9znh4-0"
})([
    "width:auto;height:215px;"
]);
var WelcomeModule = function WelcomeModule(_ref) {
    var heading = _ref.heading, isMobile = _ref.isMobile, themeValues = _ref.themeValues;
    var welcomeImage = "https://cb-public-assets.s3-us-west-2.amazonaws.com/profile-assets/profile-welcome-image.png";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, isMobile && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        background: themeValues.imageBackgroundColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(WelcomeImage, {
        src: welcomeImage
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: isMobile ? "0.875rem 1rem" : "0.875rem 1.5rem",
        background: themeValues.headerBackgroundColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Heading$1, {
        variant: "h6",
        weight: themeValues.fontWeight,
        color: themeValues.fontColor,
        textAlign: themeValues.textAlign,
        as: "h6"
    }, heading)), !isMobile && /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        background: themeValues.imageBackgroundColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cluster, {
        justify: "center",
        align: "flex-end"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(WelcomeImage, {
        src: welcomeImage
    })))));
};
var WelcomeModule$1 = /*#__PURE__*/ (0, _react.memo)(themeComponent(WelcomeModule, "WelcomeModule", fallbackValues$P));
var WorkflowTile = function WorkflowTile(_ref) {
    var _ref$workflowName = _ref.workflowName, workflowName = _ref$workflowName === void 0 ? "Test Workflow" : _ref$workflowName, _ref$workflowDescript = _ref.workflowDescription, workflowDescription = _ref$workflowDescript === void 0 ? "Link your benefit plan" : _ref$workflowDescript, _ref$workflowActionNa = _ref.workflowActionName, workflowActionName = _ref$workflowActionNa === void 0 ? "Search" : _ref$workflowActionNa, slug = _ref.slug, _ref$buttonVariant = _ref.buttonVariant, buttonVariant = _ref$buttonVariant === void 0 ? "primary" : _ref$buttonVariant;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        background: WHITE,
        boxShadow: "0px 0px 5px 0px ".concat(GHOST_GREY),
        padding: 0,
        borderRadius: "4px"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: 0,
        bottomItem: 3,
        fullHeight: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1rem 1rem 0 1rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Heading$1, {
        variant: "h6",
        weight: FONT_WEIGHT_SEMIBOLD,
        color: CHARADE_GREY,
        margin: "0 0 0.5rem 0"
    }, workflowName)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 1rem 1rem 1rem",
        minHeight: "4.25rem"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Paragraph$1, {
        variant: "pS",
        color: STORM_GREY
    }, workflowDescription)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "1.5rem 1rem",
        background: ATHENS_GREY,
        borderColor: GRECIAN_GREY,
        borderWidthOverride: "2px 0 0 0"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithLink, {
        variant: buttonVariant,
        primary: buttonVariant == "primary",
        primaryBG: MATISSE_BLUE,
        fontWeight: FONT_WEIGHT_SEMIBOLD,
        fontSize: "1.125rem",
        text: workflowActionName,
        minWidth: "100%",
        url: "/service/".concat(slug),
        extraStyles: "width: 100%; margin: 0;",
        linkExtraStyles: "justify-content: center;",
        dataQa: slug
    }))));
};
var menuItemBackgroundColor = WHITE;
var menuItemColor = ROYAL_BLUE_VIVID;
var menuItemColorDelete = RAZZMATAZZ_RED;
var menuItemHoverBackgroundColor = CORNFLOWER_BLUE;
var menuItemHoverBackgroundColorDelete = BLUSH_RED;
var menuItemHoverColor = ROYAL_BLUE_VIVID;
var fallbackValues$Q = {
    menuItemBackgroundColor: menuItemBackgroundColor,
    menuItemColor: menuItemColor,
    menuItemColorDelete: menuItemColorDelete,
    menuItemHoverBackgroundColor: menuItemHoverBackgroundColor,
    menuItemHoverBackgroundColorDelete: menuItemHoverBackgroundColorDelete,
    menuItemHoverColor: menuItemHoverColor
};
var PopupMenuItemContainer = (0, _styledComponentsDefault.default)(ButtonWithAction).withConfig({
    displayName: "PopupMenuItemstyled__PopupMenuItemContainer",
    componentId: "sc-urj1su-0"
})([
    "width:100%;margin:0;padding:17px 11px;margin-bottom:5px;border:0;cursor:pointer;text-decoration:none;",
    " &:hover,&:active{text-decoration:none;",
    "}"
], function(_ref) {
    var theme = _ref.theme, isDeleteAction = _ref.isDeleteAction;
    return "\n    background-color: ".concat(theme.menuItemBackgroundColor, ";\n    color: ").concat(isDeleteAction ? theme.menuItemColorDelete : theme.menuItemColor, ";\n  ");
}, function(_ref2) {
    var theme = _ref2.theme, isDeleteAction = _ref2.isDeleteAction;
    return "\n    background-color: ".concat(isDeleteAction ? theme.menuItemHoverBackgroundColorDelete : theme.menuItemHoverBackgroundColor, ";\n  ");
});
var _excluded$O = [
    "id",
    "closeMenuCallback",
    "action",
    "themeValues",
    "text",
    "hasIcon",
    "isDeleteAction",
    "icon",
    "textExtraStyles",
    "hoverStyles",
    "activeStyles",
    "extraStyles"
];
var PopupMenuItem = function PopupMenuItem(_ref) {
    var id = _ref.id, closeMenuCallback = _ref.closeMenuCallback, _action = _ref.action, themeValues = _ref.themeValues, text = _ref.text, _ref$hasIcon = _ref.hasIcon, hasIcon = _ref$hasIcon === void 0 ? false : _ref$hasIcon, _ref$isDeleteAction = _ref.isDeleteAction, isDeleteAction = _ref$isDeleteAction === void 0 ? false : _ref$isDeleteAction, Icon = _ref.icon, textExtraStyles = _ref.textExtraStyles, hoverStyles = _ref.hoverStyles, activeStyles = _ref.activeStyles, extraStyles = _ref.extraStyles, rest = _objectWithoutProperties(_ref, _excluded$O);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(PopupMenuItemContainer, _extends({
        id: id,
        role: "menuItem",
        text: text,
        action: function action() {
            _action();
            closeMenuCallback();
        },
        variant: "smallGhost",
        isDeleteAction: isDeleteAction,
        theme: themeValues,
        contentOverride: true,
        textExtraStyles: textExtraStyles,
        hoverStyles: hoverStyles,
        extraStyles: extraStyles,
        activeStyles: "outline: none; ".concat(activeStyles)
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        extraStyles: "\n            display: flex;\n            gap: 8px;\n            justify-content: center;\n            padding: 0;\n        "
    }, hasIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        iconFill: isDeleteAction ? themeValues.menuItemColorDelete : themeValues.menuItemColor
    }), text && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pS",
        weight: FONT_WEIGHT_SEMIBOLD,
        fontFamily: "Public Sans, sans-serif",
        color: isDeleteAction ? themeValues.menuItemColorDelete : themeValues.menuItemColor,
        extraStyles: textExtraStyles
    }, text)));
};
var PopupMenuItem$1 = themeComponent(PopupMenuItem, "PopupMenuItem", fallbackValues$Q);
var hoverColor$4 = "#116285";
var activeColor$9 = "#0E506D";
var menuTriggerColor = "#15749D";
var backgroundColor$c = "white";
var fallbackValues$R = {
    hoverColor: hoverColor$4,
    activeColor: activeColor$9,
    menuTriggerColor: menuTriggerColor,
    backgroundColor: backgroundColor$c
};
var PopupMenuContainer = (0, _styledComponentsDefault.default)(Box).withConfig({
    displayName: "PopupMenustyled__PopupMenuContainer",
    componentId: "sc-1ge13q9-0"
})([
    "display:flex;position:relative;padding:0;"
]);
var PopupMenuTriggerButton = (0, _styledComponentsDefault.default)(ButtonWithAction).withConfig({
    displayName: "PopupMenustyled__PopupMenuTriggerButton",
    componentId: "sc-1ge13q9-1"
})([
    "padding:10px 15px;min-width:auto;&:active,&:focus{outline:none;border:1px solid rgba(196,206,244,1);background-color:rgba(235,239,251,1);}"
]);
var PopupMenu = function PopupMenu(_ref) {
    var _ref$menuId = _ref.menuId, menuId = _ref$menuId === void 0 ? "popup-menu" : _ref$menuId, _ref$menuItems = _ref.menuItems, menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems, themeValues = _ref.themeValues, _ref$triggerText = _ref.triggerText, triggerText = _ref$triggerText === void 0 ? "trigger text" : _ref$triggerText, _ref$hasIcon = _ref.hasIcon, hasIcon = _ref$hasIcon === void 0 ? false : _ref$hasIcon, Icon = _ref.icon, _ref$iconHelpText = _ref.iconHelpText, iconHelpText = _ref$iconHelpText === void 0 ? "" : _ref$iconHelpText, menuFocus = _ref.menuFocus, containerExtraStyles = _ref.containerExtraStyles, textExtraStyles = _ref.textExtraStyles, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? "250px" : _ref$minWidth, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? "300px" : _ref$maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? "auto" : _ref$height, position = _ref.position, _ref$transform = _ref.transform, transform = _ref$transform === void 0 ? "none" : _ref$transform, buttonExtraStyles = _ref.buttonExtraStyles, popupExtraStyles = _ref.popupExtraStyles;
    var hoverColor = themeValues.hoverColor, activeColor = themeValues.activeColor, menuTriggerColor = themeValues.menuTriggerColor, backgroundColor = themeValues.backgroundColor;
    var _ref2 = position !== null && position !== void 0 ? position : {}, _ref2$top = _ref2.top, top = _ref2$top === void 0 ? "".concat(height, "px") : _ref2$top, _ref2$right = _ref2.right, right = _ref2$right === void 0 ? "auto" : _ref2$right, _ref2$bottom = _ref2.bottom, bottom = _ref2$bottom === void 0 ? "auto" : _ref2$bottom, _ref2$left = _ref2.left, left = _ref2$left === void 0 ? "0" : _ref2$left;
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), isMenuOpen = _useState2[0], setIsMenuOpen = _useState2[1];
    var menuRef = (0, _react.useRef)();
    var triggerRef = (0, _react.useRef)();
    var toggleMenu = function toggleMenu(menuState) {
        return setIsMenuOpen(menuState);
    };
    (0, _react.useEffect)(function() {
        var checkIfClickedOutside = function checkIfClickedOutside(e) {
            // If the menu is open and the clicked target is not within the menu or the trigger
            if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) toggleMenu(false);
        };
        document.addEventListener("click", checkIfClickedOutside);
        return function() {
            document.removeEventListener("click", checkIfClickedOutside);
        };
    }, [
        isMenuOpen
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(PopupMenuContainer, {
        extraStyles: containerExtraStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(PopupMenuTriggerButton, {
        ref: triggerRef,
        action: function action() {
            toggleMenu(!isMenuOpen);
        },
        onKeyDown: function onKeyDown(e) {
            if (e.key === "Escape") toggleMenu(false);
        },
        contentOverride: true,
        variant: "smallGhost",
        tabIndex: "0",
        id: menuId,
        borderRadius: "8px",
        "aria-haspopup": "true",
        "aria-expanded": isMenuOpen,
        "aria-controls": "".concat(menuId, "-container"),
        extraStyles: buttonExtraStyles
    }, hasIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        srOnly: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        id: "btn".concat(menuId, "_info")
    }, iconHelpText))), !hasIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        color: menuTriggerColor,
        extraStyles: "&:active { color: ".concat(activeColor, "; } &:hover { color: ").concat(hoverColor, " }; ").concat(textExtraStyles)
    }, triggerText)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        as: "div",
        id: "".concat(menuId, "-container"),
        ref: menuRef,
        onKeyDown: function onKeyDown(e) {
            if (e.key === "Escape") toggleMenu(false);
        },
        background: backgroundColor,
        borderRadius: "8px",
        boxShadow: "\n          0px 7px 32px 0px rgba(41, 42, 51, 0.2),\n          0px 1px 4px 0px rgba(41, 42, 51, 0.2),\n          0px 1px 8px -1px rgba(41, 42, 51, 0.3);\n        ",
        role: "menu",
        "aria-labelledby": menuId,
        tabIndex: menuFocus && isMenuOpen ? "0" : "-1",
        minWidth: minWidth,
        maxWidth: maxWidth,
        extraStyles: "\n          display: ".concat(isMenuOpen ? "block" : "none", ";\n          position: absolute;\n          padding: 8px 8px 3px 8px;\n          top: ").concat(top, "; \n          left: ").concat(left, ";\n          right: ").concat(right, ";\n          bottom: ").concat(bottom, ";\n          height: ").concat(height, ";\n          transform: ").concat(transform, ";\n          ").concat(popupExtraStyles, ";\n        ")
    }, menuItems.map(function(item, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(PopupMenuItem$1, _extends({
            key: index,
            id: "".concat(menuId, "-item-").concat(index),
            closeMenuCallback: function closeMenuCallback() {
                toggleMenu(false);
                // focus back to trigger button when menu closes
                triggerRef.current.focus();
            }
        }, item));
    })));
};
var PopupMenu$1 = themeComponent(PopupMenu, "PopupMenu", fallbackValues$R);
var primaryColor$1 = WHITE;
var primaryHoverColor = INFO_BLUE;
var secondaryColor = MATISSE_BLUE;
var secondaryHoverColor = "#115D7E";
var fallbackValues$S = {
    primaryColor: primaryColor$1,
    primaryHoverColor: primaryHoverColor,
    secondaryColor: secondaryColor,
    secondaryHoverColor: secondaryHoverColor
};
var StyledFilterContainer = (0, _styledComponentsDefault.default)(Box).withConfig({
    displayName: "MultipleSelectFilterstyled__StyledFilterContainer",
    componentId: "sc-126xgc2-0"
})([
    "position:relative;overflow:visible;box-sizing:border-box;padding:0;"
]);
var FilterContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledFilterContainer, _extends({
        ref: ref
    }, props));
});
var StyledFilterDropdown = (0, _styledComponentsDefault.default)(Box).withConfig({
    displayName: "MultipleSelectFilterstyled__StyledFilterDropdown",
    componentId: "sc-126xgc2-1"
})([
    "position:absolute;top:calc(100% + 0.5rem);left:0;width:18.4rem;background-color:white;z-index:1000;border-radius:0.25rem;box-shadow:0px 1px 0px 0px rgba(41,42,51,0.1),0px 2px 4px 0px rgba(41,42,51,0.2),0px 1px 2px 0px rgba(41,42,51,0.1);padding:0;max-width:18.625rem;"
]);
var FilterDropdownContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledFilterDropdown, _extends({
        ref: ref
    }, props));
});
var FilterButton = (0, _styledComponentsDefault.default)(ButtonWithAction).withConfig({
    displayName: "MultipleSelectFilterstyled__FilterButton",
    componentId: "sc-126xgc2-2"
})([
    "min-width:auto;min-height:2.3125rem;margin:0;padding:0.5rem;border-radius:0.25rem;box-shadow:0px 1px 2px 0px rgba(41,42,51,0.1);",
    " ",
    ""
], function(_ref) {
    var opened = _ref.opened, textColor = _ref.textColor, textHoverColor = _ref.textHoverColor;
    return "\n    color: ".concat(opened ? textHoverColor : textColor, ";\n    :hover,\n    :active,\n    :focus {\n      color: ").concat(textHoverColor, ";\n      > * {\n        color: ").concat(textHoverColor, ";\n      }\n    }\n  ");
}, function(_ref2) {
    var opened = _ref2.opened, backgroundColor = _ref2.backgroundColor, backgroundHoverColor = _ref2.backgroundHoverColor;
    return "\n    background-color: ".concat(opened ? backgroundHoverColor : backgroundColor, ";  \n    :hover,\n    :active,\n    :focus {\n      background-color: ").concat(backgroundHoverColor, ";\n    }\n  ");
});
var StyledFilterButton = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FilterButton, _extends({
        ref: ref
    }, props));
});
var ActionLinkButton = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var action = _ref.action, text = _ref.text, dataQa = _ref.dataQa, ariaLabel = _ref.ariaLabel;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
        ref: ref,
        action: action,
        variant: "tertiary",
        extraStyles: "\n        padding: 0.2rem; \n        margin: 0.5rem; \n        min-height: auto; \n        min-width: auto;\n      ",
        textExtraStyles: "font-weight: ".concat(FONT_WEIGHT_REGULAR, ";"),
        text: text,
        dataQa: dataQa,
        "aria-label": ariaLabel
    });
});
var _excluded$P = [
    "width",
    "height",
    "color"
];
var DropdownIconV2 = function DropdownIconV2(_ref) {
    var _ref$width = _ref.width, width = _ref$width === void 0 ? "18" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "19" : _ref$height, _ref$color = _ref.color, color = _ref$color === void 0 ? "#292A33" : _ref$color, props = _objectWithoutProperties(_ref, _excluded$P);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        "aria-hidden": "true",
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "Carrot - Down / Carrot - Down - XS"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "Combined Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.1075 7.45743C13.9122 7.26217 13.5956 7.26216 13.4003 7.45743L8.99233 11.8654L4.59199 7.46509C4.39673 7.26983 4.08014 7.26983 3.88488 7.46509L3.45355 7.89643C3.25828 8.09169 3.25828 8.40827 3.45355 8.60354L8.65078 13.8008C8.84604 13.996 9.16263 13.996 9.35789 13.8008L9.78922 13.3694C9.81738 13.3413 9.84147 13.3106 9.86151 13.2781L14.5413 8.59836C14.7365 8.4031 14.7365 8.08652 14.5413 7.89126L14.1075 7.45743Z",
        fill: color
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_3043_4463",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "7",
        width: "12",
        height: "7"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "Combined Shape_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.1075 7.45743C13.9122 7.26217 13.5956 7.26216 13.4003 7.45743L8.99233 11.8654L4.59199 7.46509C4.39673 7.26983 4.08014 7.26983 3.88488 7.46509L3.45355 7.89643C3.25828 8.09169 3.25828 8.40827 3.45355 8.60354L8.65078 13.8008C8.84604 13.996 9.16263 13.996 9.35789 13.8008L9.78922 13.3694C9.81738 13.3413 9.84147 13.3106 9.86151 13.2781L14.5413 8.59836C14.7365 8.4031 14.7365 8.08652 14.5413 7.89126L14.1075 7.45743Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_3043_4463)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "Path",
        d: "M0 0.5H18V18.5H0V0.5Z",
        fill: color
    }))));
};
var FilterButton$1 = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var btnContentOverride = _ref.btnContentOverride, _ref$action = _ref.action, action = _ref$action === void 0 ? noop$1 : _ref$action, opened = _ref.opened, backgroundColor = _ref.backgroundColor, backgroundHoverColor = _ref.backgroundHoverColor, textColor = _ref.textColor, textHoverColor = _ref.textHoverColor, name = _ref.name, filterDropdownID = _ref.filterDropdownID, _ref$hasIcon = _ref.hasIcon, hasIcon = _ref$hasIcon === void 0 ? false : _ref$hasIcon, Icon = _ref.icon, truncateBtnTextWidth = _ref.truncateBtnTextWidth, filterLabel = _ref.filterLabel, selectedOptions = _ref.selectedOptions, extraStyles = _ref.extraStyles, dataAppliedOptions = _ref.dataAppliedOptions;
    var btnTextFilterDescription = selectedOptions !== null && selectedOptions !== void 0 && selectedOptions.length ? "".concat(filterLabel ? "".concat(filterLabel, ": ") : "").concat(selectedOptions[0].name) : "".concat(filterLabel ? filterLabel : "");
    var btnTextItemsDescription = selectedOptions !== null && selectedOptions !== void 0 && selectedOptions.length && (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 1 ? ", +".concat((selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) - 1, " More") : "";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledFilterButton, {
        ref: ref,
        variant: "tertiary",
        action: action,
        "aria-haspopup": "listbox",
        "aria-expanded": opened,
        "aria-controls": filterDropdownID,
        backgroundColor: backgroundColor,
        backgroundHoverColor: backgroundHoverColor,
        textColor: textColor,
        textHoverColor: textHoverColor,
        opened: opened,
        dataQa: "".concat(name, "-filter-button"),
        extraStyles: extraStyles,
        "aria-label": "".concat(filterLabel, " Filter: ").concat(btnTextFilterDescription, " ").concat(btnTextItemsDescription),
        "data-applied-options": dataAppliedOptions,
        contentOverride: true
    }, btnContentOverride ? btnContentOverride : /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        as: "span",
        style: {
            display: "flex",
            flexDirection: "row"
        },
        intrinsic: true
    }, hasIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        color: opened ? textHoverColor : textColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        as: "span",
        style: {
            display: "flex",
            flexDirection: "row",
            padding: "0 0.5rem 0 0.25rem"
        },
        intrinsic: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        variant: "pS",
        color: opened ? textHoverColor : textColor,
        extraStyles: "\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                  ".concat(truncateBtnTextWidth && "max-width:" + truncateBtnTextWidth, "\n                ")
    }, btnTextFilterDescription), /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        color: opened ? textHoverColor : textColor,
        variant: "pS"
    }, btnTextItemsDescription)), /*#__PURE__*/ (0, _reactDefault.default).createElement(DropdownIconV2, {
        color: opened ? textHoverColor : textColor
    })));
});
var FilterDropdown = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var id = _ref.id, ariaOwns = _ref.ariaOwns, ariaControls = _ref.ariaControls, opened = _ref.opened, extraStyles = _ref.extraStyles, children = _ref.children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, opened && /*#__PURE__*/ (0, _reactDefault.default).createElement(FilterDropdownContainer, {
        ref: ref,
        id: id,
        role: "combobox",
        "aria-expanded": opened,
        "aria-haspopup": "listbox",
        "aria-owns": ariaOwns,
        "aria-controls": ariaControls,
        extraStyles: extraStyles
    }, children));
});
var SearchBox = function SearchBox(_ref) {
    var autocompleteValue = _ref.autocompleteValue, fields = _ref.fields, actions = _ref.actions, placeholder = _ref.placeholder, disabled = _ref.disabled, showSearchBox = _ref.showSearchBox;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 0 0.5rem"
    }, showSearchBox && /*#__PURE__*/ (0, _reactDefault.default).createElement(FormInput$1, {
        autocompleteValue: autocompleteValue,
        showFieldErrorRow: false,
        errorMessages: {},
        field: fields.searchTerm,
        fieldActions: actions.fields.searchTerm,
        placeholder: placeholder,
        disabled: disabled,
        extraStyles: "\n            height: 2.875rem;\n            border: 0; \n            border-radius: 0;\n            padding: 0.45rem;\n            font-size: 0.875rem;\n            border-bottom: 1px solid ".concat(GHOST_GREY, ";\n            :focus {\n              outline-offset: -3px;\n            }\n          ")
    }));
};
var _excluded$Q = [
    "width",
    "height",
    "color"
];
var CheckboxCheckmarkIcon = function CheckboxCheckmarkIcon(_ref) {
    var _ref$width = _ref.width, width = _ref$width === void 0 ? "18" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "18" : _ref$height, _ref$color = _ref.color, color = _ref$color === void 0 ? "#FEFEFE" : _ref$color, props = _objectWithoutProperties(_ref, _excluded$Q);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width, " ").concat(height),
        fill: "none"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.7503 5.35354C13.555 5.15828 13.2385 5.15828 13.0432 5.35354L7.52373 10.873L5.52808 8.87735C5.33282 8.68209 5.01624 8.68209 4.82097 8.87735L4.35348 9.34484C4.15822 9.54011 4.15822 9.85669 4.35348 10.052L6.70268 12.4012L7.17018 12.8687C7.36544 13.0639 7.68203 13.0639 7.87729 12.8687L8.34478 12.4012L14.2178 6.52814C14.4131 6.33288 14.4131 6.0163 14.2178 5.82104L13.7503 5.35354Z",
        fill: "#FEFEFE"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "mask0_3361_1486",
        style: {
            maskType: "luminance"
        },
        maskUnits: "userSpaceOnUse",
        x: "4",
        y: "5",
        width: "11",
        height: "9"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.7503 5.35354C13.555 5.15828 13.2385 5.15828 13.0432 5.35354L7.52373 10.873L5.52808 8.87735C5.33282 8.68209 5.01624 8.68209 4.82097 8.87735L4.35348 9.34484C4.15822 9.54011 4.15822 9.85669 4.35348 10.052L6.70268 12.4012L7.17018 12.8687C7.36544 13.0639 7.68203 13.0639 7.87729 12.8687L8.34478 12.4012L14.2178 6.52814C14.4131 6.33288 14.4131 6.0163 14.2178 5.82104L13.7503 5.35354Z",
        fill: "white"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#mask0_3361_1486)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        width: width,
        height: height,
        fill: color
    })));
};
var FilterableListItem = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var index = _ref.index, option = _ref.option, checked = _ref.checked, selectOption = _ref.selectOption, disabled = _ref.disabled, tabIndex = _ref.tabIndex, name = _ref.name, showDivider = _ref.showDivider, extraStyles = _ref.extraStyles, themeValues = _ref.themeValues;
    var dividerStyles = "\n    ::after {\n      content: '';\n      position: absolute;\n      width: 100%;\n      display: block;\n      height: 1px;\n      background-color: ".concat(GHOST_GREY, ";\n      bottom: -0.5rem;\n      left: 0;\n    }");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Checkbox$1, {
        key: index,
        ref: ref,
        title: option.name,
        name: option.name,
        role: "option",
        "aria-selected": checked,
        tabIndex: tabIndex,
        dataQa: "".concat(name, "-option-").concat(index),
        checked: checked,
        onChange: function onChange() {
            return selectOption(option);
        },
        textExtraStyles: "font-size: 0.875rem; margin: 0;",
        disabled: disabled,
        extraStyles: "\n          padding: 0.375rem 0.625rem; \n          margin: 0;\n          :hover,\n          :active,\n          :focus {\n            background-color: ".concat(themeValues.primaryHoverColor, ";\n          }\n          ").concat(showDivider && dividerStyles, "\n          ").concat(extraStyles, "\n        "),
        checkboxMargin: showDivider ? "0 0 1rem" : "0",
        hasIconOverride: true,
        icon: CheckboxCheckmarkIcon,
        checkboxExtraStyles: "\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          height: 20px;\n          width: 20px;\n          ".concat(checked && !disabled ? "background: " + themeValues.secondaryColor + ";" : "", "\n       ")
    });
});
var filterItemsList = function filterItemsList(list, searchTerm) {
    return list.filter(function(item) {
        var _item$name;
        return item === null || item === void 0 || (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase().includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase());
    });
};
var sortItemsList = function sortItemsList(list) {
    return list.slice().sort(function(a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
};
var isMaxSelectionReached = function isMaxSelectionReached(maxSelection, selectedOptions) {
    return maxSelection && maxSelection === (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length);
};
var isChecked = function isChecked(option, selectedOptions) {
    return selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.some(function(selectedOption) {
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) === (option === null || option === void 0 ? void 0 : option.name);
    });
};
var selectValues = function selectValues(items) {
    return items.map(function(item) {
        return item.value;
    });
};
var selectOption = function selectOption(option, selectedOptions, setSelectedOptions) {
    if (selectValues(selectedOptions).includes(option.value)) {
        var fewerOptions = selectedOptions.filter(function(selectedOption) {
            return selectedOption.value !== option.value;
        });
        setSelectedOptions(fewerOptions);
    } else {
        var moreOptions = selectedOptions.concat(option);
        setSelectedOptions(moreOptions);
    }
};
var mergeOptions = function mergeOptions(selectedOptions, activeOptions) {
    if (!activeOptions.length) return selectedOptions;
    if (!selectedOptions.length) return activeOptions;
    var mergedOptions = _toConsumableArray(selectedOptions);
    activeOptions.forEach(function(activeOption) {
        if (!mergedOptions.some(function(option) {
            return option.name === activeOption.name;
        })) mergedOptions.push(activeOption);
    });
    return mergedOptions;
};
var useKeyboardNavigation = function useKeyboardNavigation(_ref) {
    var options = _ref.options, appliedOptions = _ref.appliedOptions, selectedOptions = _ref.selectedOptions, maxSelections = _ref.maxSelections;
    var _useState = (0, _react.useState)(-1), _useState2 = _slicedToArray(_useState, 2), focusedIndex = _useState2[0], setFocusedIndex = _useState2[1];
    var itemRefs = (0, _react.useRef)([]);
    var totalItemsLength = options.length + appliedOptions.length;
    var handleArrowUp = function handleArrowUp(event) {
        event.preventDefault();
        setFocusedIndex(function(prevIndex) {
            return prevIndex > 0 ? prevIndex - 1 : totalItemsLength - 1;
        });
    };
    var handleArrowDown = function handleArrowDown(event) {
        event.preventDefault();
        setFocusedIndex(function(prevIndex) {
            return prevIndex < totalItemsLength - 1 ? prevIndex + 1 : 0;
        });
    };
    var handleSpacebar = function handleSpacebar(event) {
        event.preventDefault();
        var validFocusedIndex = focusedIndex < 0 ? 0 : focusedIndex;
        // Select option on spacebar press if the maximum selection hasn't been reached.
        if (!isMaxSelectionReached(maxSelections, selectedOptions) && itemRefs.current && itemRefs.current[validFocusedIndex]) {
            var nestedInput = itemRefs.current[validFocusedIndex].querySelector("input");
            if (nestedInput) nestedInput.click();
        }
    };
    var handleTab = function handleTab(event) {
        // Reset focus when tabbing out of the list.
        setFocusedIndex(-1);
    };
    var keyActions = {
        " ": function _(event) {
            return handleSpacebar(event);
        },
        Space: function Space(event) {
            return handleSpacebar(event);
        },
        Tab: function Tab(event) {
            return handleTab();
        },
        ArrowUp: function ArrowUp(event) {
            return handleArrowUp(event);
        },
        ArrowDown: function ArrowDown(event) {
            return handleArrowDown(event);
        }
    };
    var handleKeyDown = function handleKeyDown(event) {
        var eventKey = event.code || event.key;
        var action = keyActions[eventKey];
        if (action) action(event);
    };
    (0, _react.useEffect)(function() {
        if (focusedIndex !== -1 && itemRefs.current && itemRefs.current[focusedIndex]) itemRefs.current[focusedIndex].focus(); // move focus to the active option
    }, [
        focusedIndex
    ]);
    return {
        itemRefs: itemRefs,
        focusedIndex: focusedIndex,
        handleKeyDown: handleKeyDown
    };
};
var FilterableList = function FilterableList(_ref) {
    var id = _ref.id, options = _ref.options, appliedOptions = _ref.appliedOptions, selectedOptions = _ref.selectedOptions, maxSelections = _ref.maxSelections, name = _ref.name, setSelectedOptions = _ref.setSelectedOptions, searchTerm = _ref.searchTerm, themeValues = _ref.themeValues;
    var _useState = (0, _react.useState)([]), _useState2 = _slicedToArray(_useState, 2), filteredOptions = _useState2[0], setFilteredOptions = _useState2[1];
    var _useState3 = (0, _react.useState)([]), _useState4 = _slicedToArray(_useState3, 2), filteredAppliedOptions = _useState4[0], setFilteredAppliedOptions = _useState4[1];
    (0, _react.useEffect)(function() {
        setFilteredOptions(options);
        setFilteredAppliedOptions(appliedOptions);
    }, [
        options,
        appliedOptions
    ]);
    (0, _react.useEffect)(function() {
        var filteredOptionItems = filterItemsList(options, searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.rawValue);
        var filteredAppliedItems = filterItemsList(appliedOptions, searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.rawValue);
        setFilteredOptions(filteredOptionItems.length ? filteredOptionItems : filteredOptions);
        setFilteredAppliedOptions(filteredAppliedItems);
    }, [
        searchTerm.rawValue
    ]);
    var handleSelectOption = function handleSelectOption(option) {
        return selectOption(option, selectedOptions, setSelectedOptions);
    };
    var isAppliedOption = function isAppliedOption(option) {
        return filteredAppliedOptions === null || filteredAppliedOptions === void 0 ? void 0 : filteredAppliedOptions.some(function(appliedItem) {
            return (appliedItem === null || appliedItem === void 0 ? void 0 : appliedItem.name) === (option === null || option === void 0 ? void 0 : option.name);
        });
    };
    var currentFilteredOptions = filteredOptions.filter(function(option) {
        return !isAppliedOption(option);
    });
    var sortedOptions = sortItemsList(currentFilteredOptions);
    var sortedAppliedOptions = sortItemsList(filteredAppliedOptions);
    var _useKeyboardNavigatio = useKeyboardNavigation({
        options: sortedOptions,
        appliedOptions: sortedAppliedOptions,
        selectedOptions: selectedOptions,
        maxSelections: maxSelections
    }), itemRefs = _useKeyboardNavigatio.itemRefs, focusedIndex = _useKeyboardNavigatio.focusedIndex, handleKeyDown = _useKeyboardNavigatio.handleKeyDown;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        id: id,
        padding: "0",
        role: "listbox",
        "aria-label": "Filter options container",
        onKeyDown: handleKeyDown,
        extraStyles: "\n        overflow-y: auto;\n        max-height: 250px;\n        display: flex;\n        flex-flow: column;\n        padding-bottom: 0.5rem;\n    "
    }, (sortedAppliedOptions === null || sortedAppliedOptions === void 0 ? void 0 : sortedAppliedOptions.length) > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, sortedAppliedOptions.map(function(option, index) {
        var checked = isChecked(option, selectedOptions);
        var tabIndex = index === focusedIndex || index === 0 && focusedIndex === -1 ? "0" : "-1";
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(FilterableListItem, {
            key: index,
            ref: function ref(el) {
                return itemRefs.current[index] = el;
            },
            index: index,
            option: option,
            checked: checked,
            selectOption: handleSelectOption,
            tabIndex: tabIndex,
            name: name,
            themeValues: themeValues,
            showDivider: sortedOptions.length > 0 && index === sortedAppliedOptions.length - 1
        });
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, sortedOptions.map(function(option, index) {
        var checked = isChecked(option, selectedOptions);
        var isDisabled = isMaxSelectionReached(maxSelections, selectedOptions) && !checked;
        var indexOffset = sortedAppliedOptions !== null && sortedAppliedOptions !== void 0 && sortedAppliedOptions.length ? sortedAppliedOptions === null || sortedAppliedOptions === void 0 ? void 0 : sortedAppliedOptions.length : 0;
        var currentIndex = index === 0 ? indexOffset : index + indexOffset;
        var tabIndex = currentIndex === focusedIndex || indexOffset === 0 && currentIndex === indexOffset && focusedIndex === -1 ? "0" : "-1";
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(FilterableListItem, {
            key: currentIndex,
            ref: function ref(el) {
                return itemRefs.current[currentIndex] = el;
            },
            index: currentIndex,
            option: option,
            checked: checked,
            selectOption: isDisabled ? noop : handleSelectOption,
            disabled: isDisabled,
            tabIndex: tabIndex,
            name: name,
            themeValues: themeValues
        });
    })));
};
var FilterableList$1 = /*#__PURE__*/ (0, _reactDefault.default).memo(FilterableList);
var MultipleSelectFilter = function MultipleSelectFilter(_ref) {
    var actions = _ref.actions, autocompleteValue = _ref.autocompleteValue, btnContentOverride = _ref.btnContentOverride, btnExtraStyles = _ref.btnExtraStyles, disabled = _ref.disabled, dropdownExtraStyles = _ref.dropdownExtraStyles, extraStyles = _ref.extraStyles, fields = _ref.fields, filterLabel = _ref.filterLabel, _ref$hasIcon = _ref.hasIcon, hasIcon = _ref$hasIcon === void 0 ? false : _ref$hasIcon, Icon = _ref.icon, maxSelections = _ref.maxSelections, _ref$name = _ref.name, name = _ref$name === void 0 ? "MultipleSelectFilter" : _ref$name, _ref$onApply = _ref.onApply, onApply = _ref$onApply === void 0 ? noop$1 : _ref$onApply, _ref$onClear = _ref.onClear, onClear = _ref$onClear === void 0 ? noop$1 : _ref$onClear, options = _ref.options, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? "Search" : _ref$placeholder, _ref$searchable = _ref.searchable, searchable = _ref$searchable === void 0 ? true : _ref$searchable, themeValues = _ref.themeValues, _ref$truncateBtnTextW = _ref.truncateBtnTextWidth, truncateBtnTextWidth = _ref$truncateBtnTextW === void 0 ? "15rem" : _ref$truncateBtnTextW, activeAppliedOptions = _ref.activeAppliedOptions;
    // State to manage whether the dropdown is open or closed
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), opened = _useState2[0], setOpened = _useState2[1];
    // State to manage the currently selected options
    var _useState3 = (0, _react.useState)([]), _useState4 = _slicedToArray(_useState3, 2), selectedOptions = _useState4[0], setSelectedOptions = _useState4[1];
    // State to manage the applied options, initialized with activeAppliedOptions or an empty array
    var _useState5 = (0, _react.useState)(activeAppliedOptions || []), _useState6 = _slicedToArray(_useState5, 2), appliedOptions = _useState6[0], setAppliedOptions = _useState6[1];
    // State to track whether the user has interacted with the component
    var _useState7 = (0, _react.useState)(false), _useState8 = _slicedToArray(_useState7, 2), hasInteracted = _useState8[0], setHasInteracted = _useState8[1];
    // Reference to keep track of the opened state across renders without causing re-renders
    var openedRef = (0, _react.useRef)(opened);
    // Hook to detect clicks outside the component and close the dropdown
    var containerRef = useOutsideClickHook(function() {
        return handleOnClose();
    });
    // References to various elements within the component
    var dropdownRef = (0, _react.useRef)(null);
    var filterButtonRef = (0, _react.useRef)(null);
    var applyFilterButtonRef = (0, _react.useRef)(null);
    // IDs for accessibility and identification purposes
    var filterDropdownID = "".concat(name, "-filter-dropdown");
    var listGroupID = "".concat(name, "-list-group");
    var handleOnClose = function handleOnClose() {
        if (openedRef.current) {
            setOpened(false);
            actions.fields.searchTerm.set("");
        }
    };
    (0, _react.useEffect)(function() {
        openedRef.current = opened;
        if (!opened) {
            if (hasInteracted) {
                onApply(selectedOptions);
                setAppliedOptions(selectedOptions);
            }
        } else setHasInteracted(true);
    }, [
        opened
    ]);
    (0, _react.useEffect)(function() {
        // Update the applied options state with the current active applied options,
        // or an empty array if activeAppliedOptions is undefined or null.
        // This ensures that the current applied options are in sync with the parent component.
        setAppliedOptions(activeAppliedOptions || []);
        // Merge the selected options with the active applied options.
        var mergedSelections = mergeOptions(selectedOptions, activeAppliedOptions);
        setSelectedOptions(mergedSelections);
    }, [
        activeAppliedOptions
    ]);
    (0, _react.useEffect)(function() {
        var handleKeyDown = function handleKeyDown(event) {
            if (event.key === "Escape") event.preventDefault();
            /*
        Close the dropdown if we hit the Escape key, 
        or if we are tabbing forward away from the last button (apply button) 
        or tabbing backward past the filter button.
      */ if (event.key === "Escape" || event.key === "Tab" && !event.shiftKey && applyFilterButtonRef.current && applyFilterButtonRef.current.contains(event.target) || event.key === "Tab" && event.shiftKey && filterButtonRef.current && filterButtonRef.current.contains(event.target)) handleOnClose();
        };
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FilterContainer, {
        ref: containerRef,
        extraStyles: "".concat(extraStyles)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(FilterButton$1, {
        ref: filterButtonRef,
        btnContentOverride: btnContentOverride,
        action: function action() {
            actions.fields.searchTerm.set("");
            setOpened(!opened);
        },
        opened: opened,
        backgroundHoverColor: appliedOptions !== null && appliedOptions !== void 0 && appliedOptions.length ? themeValues.secondaryHoverColor : themeValues.primaryHoverColor,
        backgroundColor: appliedOptions !== null && appliedOptions !== void 0 && appliedOptions.length ? themeValues.secondaryColor : themeValues.primaryColor,
        textColor: appliedOptions !== null && appliedOptions !== void 0 && appliedOptions.length ? WHITE : CHARADE_GREY,
        textHoverColor: opened && !(appliedOptions !== null && appliedOptions !== void 0 && appliedOptions.length) ? CHARADE_GREY : WHITE,
        name: name,
        filterDropdownID: filterDropdownID,
        hasIcon: hasIcon,
        icon: Icon,
        truncateBtnTextWidth: truncateBtnTextWidth,
        filterLabel: filterLabel,
        selectedOptions: selectedOptions,
        extraStyles: btnExtraStyles,
        dataAppliedOptions: appliedOptions === null || appliedOptions === void 0 ? void 0 : appliedOptions.length
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FilterDropdown, {
        id: filterDropdownID,
        ref: dropdownRef,
        ariaOwns: listGroupID,
        ariaControls: listGroupID,
        opened: opened,
        extraStyles: dropdownExtraStyles
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SearchBox, {
        showSearchBox: searchable && (options === null || options === void 0 ? void 0 : options.length) > 8,
        autocompleteValue: autocompleteValue,
        fields: fields,
        actions: actions,
        placeholder: placeholder,
        disabled: disabled
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(FilterableList$1, {
        id: listGroupID,
        options: options,
        appliedOptions: appliedOptions,
        themeValues: themeValues,
        selectedOptions: selectedOptions,
        maxSelections: maxSelections,
        name: name,
        setSelectedOptions: setSelectedOptions,
        searchTerm: fields === null || fields === void 0 ? void 0 : fields.searchTerm
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0 0.5rem 0.0625rem 0.5rem",
        extraStyles: "\n            max-height: 100px; \n            display: flex; \n            flex-flow: row; \n            justify-content: space-between;\n            border-top: 1px solid ".concat(GHOST_GREY, ";\n          ")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ActionLinkButton, {
        action: function action() {
            setSelectedOptions([]);
            handleOnClose();
            onClear();
        },
        text: "Clear",
        dataQa: "".concat(name, "-clear-filters"),
        ariaLabel: "Clear all filters"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ActionLinkButton, {
        ref: applyFilterButtonRef,
        action: function action() {
            return handleOnClose();
        },
        text: "Apply",
        dataQa: "".concat(name, "-apply-filters"),
        ariaLabel: "Apply all filters"
    }))));
};
var MultipleSelectFilter$1 = themeComponent(MultipleSelectFilter, "MultipleSelectFilter", fallbackValues$S);
var hoverColor$5 = ROYAL_BLUE;
var activeColor$a = CONGRESS_BLUE;
var linkColor$4 = ROYAL_BLUE_VIVID;
var textColor$3 = CHARADE_GREY;
var fallbackValues$T = {
    linkColor: linkColor$4,
    hoverColor: hoverColor$5,
    activeColor: activeColor$a,
    textColor: textColor$3
};
var TOOLTIP_THEME_SOURCE = "Popover";
var Tooltip = function Tooltip(_ref) {
    var tooltipID = _ref.tooltipID, children = _ref.children, _ref$hasCustomTrigger = _ref.hasCustomTrigger, hasCustomTrigger = _ref$hasCustomTrigger === void 0 ? false : _ref$hasCustomTrigger, _ref$triggerText = _ref.triggerText, triggerText = _ref$triggerText === void 0 ? "" : _ref$triggerText, _ref$containerExtraSt = _ref.containerExtraStyles, containerExtraStyles = _ref$containerExtraSt === void 0 ? "" : _ref$containerExtraSt, _ref$triggerButtonVar = _ref.triggerButtonVariant, triggerButtonVariant = _ref$triggerButtonVar === void 0 ? "smallGhost" : _ref$triggerButtonVar, _ref$content = _ref.content, content = _ref$content === void 0 ? "" : _ref$content, _ref$contentExtraStyl = _ref.contentExtraStyles, contentExtraStyles = _ref$contentExtraStyl === void 0 ? "" : _ref$contentExtraStyl, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? "250px" : _ref$minWidth, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? "100%" : _ref$maxWidth, _ref$height = _ref.height, height = _ref$height === void 0 ? "auto" : _ref$height, _ref$contentPosition = _ref.contentPosition, contentPosition = _ref$contentPosition === void 0 ? {
        top: "-110px",
        right: "auto",
        bottom: "auto",
        left: "-225px"
    } : _ref$contentPosition, _ref$arrowDirection = _ref.arrowDirection, arrowDirection = _ref$arrowDirection === void 0 ? "down" : _ref$arrowDirection, _ref$arrowPosition = _ref.arrowPosition, arrowPosition = _ref$arrowPosition === void 0 ? {
        arrowTop: "auto",
        arrowRight: "10px",
        arrowBottom: "-8px",
        arrowLeft: "auto"
    } : _ref$arrowPosition, customTriggerRole = _ref.customTriggerRole, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? WHITE : _ref$backgroundColor;
    /**
   * closeTimeoutRef is used internally to store a timer ID for delaying tooltip close. It will have a `.current` property (the timer ID) when the effect or event handlers set it.
   */ var closeTimeoutRef = (0, _react.useRef)(null);
    /**
   * containerRef is used to store a reference to the container element. It will have a `.current` property (the container element) when the effect or event handlers set it.
   */ var containerRef = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), tooltipOpen = _useState2[0], setTooltipOpen = _useState2[1];
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var themeValues = createThemeValues(themeContext, fallbackValues$T, TOOLTIP_THEME_SOURCE);
    var top = contentPosition.top, right = contentPosition.right, bottom = contentPosition.bottom, left = contentPosition.left;
    var arrowTop = arrowPosition.arrowTop, arrowRight = arrowPosition.arrowRight, arrowBottom = arrowPosition.arrowBottom, arrowLeft = arrowPosition.arrowLeft;
    var handleToggleTooltip = function handleToggleTooltip(desiredState) {
        if (tooltipOpen !== desiredState) setTooltipOpen(desiredState);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Escape") handleToggleTooltip(false);
    };
    /**
   * @function renderTrigger
   * Renders the tooltip trigger element.
   *
   * When `hasCustomTrigger` is true, the provided child element is cloned and
   * injected with the event handlers needed to control tooltip visibility:
   *  - onFocus/onBlur: open and close for keyboard users
   *  - onKeyDown: allows Escape to dismiss the tooltip
   *  - onTouchStart: open on tap for touch/mobile users (onFocus is unreliable on touch)
   *
   * Mouse interactions (hover) are handled at the container level via
   * onMouseEnter/onMouseLeave, so they do not need to be injected here.
   *
   * Any existing event handlers on the child are preserved and called first,
   * so the child's own behavior is not overridden.
   *
   * When no custom trigger is provided, a default ButtonWithAction is rendered
   * using `triggerText` and `triggerButtonVariant`.
   */ var renderTrigger = function renderTrigger() {
        if (hasCustomTrigger && !children) console.warn("Tooltip: children prop is required when hasCustomTrigger is true");
        if (hasCustomTrigger && children) {
            var _child$props, _child$props$tabIndex, _child$props2, _child$props3, _child$props4;
            var child = (0, _reactDefault.default).Children.only(children);
            /**
       * Capture the child's existing handlers before overwriting
       */ var _ref2 = (_child$props = child.props) !== null && _child$props !== void 0 ? _child$props : {}, childOnFocus = _ref2.onFocus, childOnBlur = _ref2.onBlur, childOnKeyDown = _ref2.onKeyDown, childOnTouchStart = _ref2.onTouchStart;
            /**
       * Clone the child element and add the necessary event handlers
       */ return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
                tabIndex: (_child$props$tabIndex = (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.tabIndex) !== null && _child$props$tabIndex !== void 0 ? _child$props$tabIndex : 0,
                ariaDescribedby: tooltipID,
                style: _objectSpread2({
                    cursor: "pointer"
                }, (_child$props3 = child.props) === null || _child$props3 === void 0 ? void 0 : _child$props3.style),
                onFocus: function onFocus(e) {
                    childOnFocus === null || childOnFocus === void 0 || childOnFocus(e);
                    handleToggleTooltip(true);
                },
                onBlur: function onBlur(e) {
                    childOnBlur === null || childOnBlur === void 0 || childOnBlur(e);
                    handleToggleTooltip(false);
                },
                onKeyDown: function onKeyDown(e) {
                    childOnKeyDown === null || childOnKeyDown === void 0 || childOnKeyDown(e);
                    handleKeyDown(e);
                },
                onTouchStart: function onTouchStart(e) {
                    childOnTouchStart === null || childOnTouchStart === void 0 || childOnTouchStart(e);
                    handleToggleTooltip(true);
                },
                role: customTriggerRole || ((_child$props4 = child.props) === null || _child$props4 === void 0 ? void 0 : _child$props4.role),
                "aria-describedby": tooltipID,
                "data-qa": "tooltip-trigger-".concat(tooltipID)
            });
        } else return /*#__PURE__*/ (0, _reactDefault.default).createElement(ButtonWithAction, {
            action: noop$1,
            onKeyDown: handleKeyDown,
            variant: triggerButtonVariant,
            text: triggerText,
            tabIndex: 0,
            "aria-describedby": tooltipID,
            onFocus: function onFocus() {
                return handleToggleTooltip(true);
            },
            onBlur: function onBlur() {
                return handleToggleTooltip(false);
            },
            onTouchStart: function onTouchStart() {
                return handleToggleTooltip(true);
            },
            dataQa: "tooltip-trigger-".concat(tooltipID),
            extraStyles: "\n            color: ".concat(themeValues.linkColor, ";\n            &:hover { color: ").concat(themeValues.hoverColor, "; text-decoration: none;}\n            &:active, &:focus { color: ").concat(themeValues.activeColor, ";text-decoration: none;}\n            button, span, &:hover span { text-decoration: none; }\n          ")
        });
    };
    /**
   * @function handleMouseEnter
   * Handles the mouse enter event for the tooltip container.
   * It clears any existing timeout and opens the tooltip.
   */ var handleMouseEnter = function handleMouseEnter() {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
        handleToggleTooltip(true);
    };
    /**
   * @function handleMouseLeave
   * Handles the mouse leave event for the tooltip container.
   * It sets a timeout to close the tooltip after 200ms.
   */ var handleMouseLeave = function handleMouseLeave() {
        closeTimeoutRef.current = setTimeout(function() {
            handleToggleTooltip(false);
        }, 200);
    };
    /**
   * Handles the touch start event for the tooltip container.
   * It closes the tooltip if the touch is outside the container.
   */ (0, _react.useEffect)(function() {
        if (!tooltipOpen) return;
        var handleOutsideTouch = function handleOutsideTouch(e) {
            if (containerRef.current && !containerRef.current.contains(e.target)) setTooltipOpen(false);
        };
        document.addEventListener("touchstart", handleOutsideTouch);
        return function() {
            return document.removeEventListener("touchstart", handleOutsideTouch);
        };
    }, [
        tooltipOpen
    ]);
    /**
   * Cleans up the timeout when the component unmounts.
   */ (0, _react.useEffect)(function() {
        return function() {
            if (closeTimeoutRef !== null && closeTimeoutRef !== void 0 && closeTimeoutRef.current) clearTimeout(closeTimeoutRef.current);
        };
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        ref: containerRef,
        padding: "0",
        extraStyles: "position: relative; ".concat(containerExtraStyles),
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        "data-qa": "".concat(tooltipID, "-container")
    }, renderTrigger(), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        role: "tooltip",
        id: tooltipID,
        "aria-hidden": !tooltipOpen,
        background: backgroundColor,
        "data-qa": "tooltip-contents",
        extraStyles: "\n          position: absolute;\n          display: ".concat(tooltipOpen ? "block" : "none", ";\n          top: ").concat(top, ";\n          right: ").concat(right, ";\n          bottom: ").concat(bottom, ";\n          left: ").concat(left, ";\n          height: ").concat(height, ";\n          color: ").concat(themeValues.textColor, ";\n          ").concat(contentExtraStyles, "\n        "),
        boxShadow: "0px 2px 14px 0px rgb(246, 246, 249), 0px 3px 8px 0px rgb(202, 206, 216)",
        border: "1px solid transparent",
        borderRadius: "4px",
        minWidth: minWidth,
        maxWidth: maxWidth
    }, typeof content === "string" && content !== "" ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Text$1, {
        color: themeValues.textColor
    }, content) : content !== undefined && content !== null ? content : null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        extraStyles: '\n            position: absolute;\n            content: "";\n            width: 0;\n            height: 0;\n            '.concat(arrowBorder(backgroundColor, arrowDirection, "8px"), ";\n            filter: drop-shadow(2px 8px 14px black);\n            bottom: ").concat(arrowBottom, ";\n            right: ").concat(arrowRight, ";\n            top: ").concat(arrowTop, ";\n            left: ").concat(arrowLeft, ";\n          ")
    })));
};
var pageBackground = "#FBFCFD";
var fallbackValues$U = {
    pageBackground: pageBackground
};
var CenterSingle = function CenterSingle(_ref) {
    var header = _ref.header, footer = _ref.footer, subHeader = _ref.subHeader, _ref$hideMobileSubHea = _ref.hideMobileSubHeader, hideMobileSubHeader = _ref$hideMobileSubHea === void 0 ? true : _ref$hideMobileSubHea, _ref$maxContentWidth = _ref.maxContentWidth, maxContentWidth = _ref$maxContentWidth === void 0 ? "36.75rem" : _ref$maxContentWidth, _ref$fullWidthMobile = _ref.fullWidthMobile, fullWidthMobile = _ref$fullWidthMobile === void 0 ? true : _ref$fullWidthMobile, _ref$centeredMobileCo = _ref.centeredMobileContent, centeredMobileContent = _ref$centeredMobileCo === void 0 ? false : _ref$centeredMobileCo, content = _ref.content, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? COOL_GREY_05 : _ref$backgroundColor, themeValues = _ref.themeValues;
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var isMobile = themeContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        background: backgroundColor,
        extraStyles: "flex-grow: 1;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        centerOverride: isMobile && !centeredMobileContent
    }, header ? header : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        extraStyles: "z-index: 1;"
    }, subHeader && !(isMobile && hideMobileSubHeader) ? subHeader : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: isMobile && fullWidthMobile ? "100%" : maxContentWidth,
        intrinsic: !isMobile,
        role: "main"
    }, centeredMobileContent ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        minHeight: "100%",
        singleChild: true
    }, content) : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }, content))), footer ? footer : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    })));
};
var CenterSingle$1 = withWindowSize(themeComponent(CenterSingle, "Global", fallbackValues$U));
var CenterStack = function CenterStack(_ref) {
    var header = _ref.header, footer = _ref.footer, subHeader = _ref.subHeader, _ref$hideMobileSubHea = _ref.hideMobileSubHeader, hideMobileSubHeader = _ref$hideMobileSubHea === void 0 ? true : _ref$hideMobileSubHea, _ref$contentSpacing = _ref.contentSpacing, contentSpacing = _ref$contentSpacing === void 0 ? "1rem" : _ref$contentSpacing, _ref$maxContentWidth = _ref.maxContentWidth, maxContentWidth = _ref$maxContentWidth === void 0 ? "36.75rem" : _ref$maxContentWidth, _ref$fullWidthMobile = _ref.fullWidthMobile, fullWidthMobile = _ref$fullWidthMobile === void 0 ? true : _ref$fullWidthMobile, content = _ref.content, themeValues = _ref.themeValues, _ref$role = _ref.role, role = _ref$role === void 0 ? "main" : _ref$role;
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var isMobile = themeContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        background: COOL_GREY_05,
        extraStyles: "flex-grow: 1;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, null, header ? header : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%"
    }, subHeader && !(isMobile && hideMobileSubHeader) ? subHeader : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: isMobile && fullWidthMobile ? "100%" : maxContentWidth,
        intrinsic: !isMobile,
        role: role
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        minHeight: "100%",
        singleChild: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        childGap: contentSpacing
    }, content)))), footer ? footer : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    })));
};
var CenterStack$1 = withWindowSize(themeComponent(CenterStack, "Global", fallbackValues$U));
var CenterSingle$2 = function CenterSingle(_ref) {
    var header = _ref.header, footer = _ref.footer, subHeader = _ref.subHeader, _ref$hideMobileSubHea = _ref.hideMobileSubHeader, hideMobileSubHeader = _ref$hideMobileSubHea === void 0 ? false : _ref$hideMobileSubHea, content = _ref.content, themeValues = _ref.themeValues, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? "75rem" : _ref$maxWidth, _ref$gutters = _ref.gutters, gutters = _ref$gutters === void 0 ? "2rem" : _ref$gutters, _ref$fillPageVertical = _ref.fillPageVertical, fillPageVertical = _ref$fillPageVertical === void 0 ? false : _ref$fillPageVertical, _ref$background = _ref.background, background = _ref$background === void 0 ? COOL_GREY_05 : _ref$background;
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var isMobile = themeContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        background: background,
        extraStyles: "flex-grow: 1;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        childGap: "0",
        fillCenter: true,
        style: {
            minHeight: fillPageVertical ? "100vh" : "initial"
        }
    }, header ? header : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        minHeight: "100%",
        extraStyles: "z-index: 1;"
    }, subHeader && !(isMobile && hideMobileSubHeader) ? subHeader : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: maxWidth,
        gutters: gutters,
        role: "main"
    }, content)), footer ? footer : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    })));
};
var DefaultPageTemplate = withWindowSize(themeComponent(CenterSingle$2, "Global", fallbackValues$U));
var SidebarSingleContent = function SidebarSingleContent(_ref) {
    var header = _ref.header, footer = _ref.footer, subHeader = _ref.subHeader, _ref$hideMobileSubHea = _ref.hideMobileSubHeader, hideMobileSubHeader = _ref$hideMobileSubHea === void 0 ? true : _ref$hideMobileSubHea, _ref$sidebarWrapperPa = _ref.sidebarWrapperPadding, sidebarWrapperPadding = _ref$sidebarWrapperPa === void 0 ? "0" : _ref$sidebarWrapperPa, _ref$sidebarWrapperMa = _ref.sidebarWrapperMaxWidth, sidebarWrapperMaxWidth = _ref$sidebarWrapperMa === void 0 ? "auto" : _ref$sidebarWrapperMa, sidebarContent = _ref.sidebarContent, mainContent = _ref.mainContent, _ref$sidebarOnRight = _ref.sidebarOnRight, sidebarOnRight = _ref$sidebarOnRight === void 0 ? false : _ref$sidebarOnRight, _ref$sidebarTargetWid = _ref.sidebarTargetWidth, sidebarTargetWidth = _ref$sidebarTargetWid === void 0 ? "10rem" : _ref$sidebarTargetWid, _ref$sidebarContentGa = _ref.sidebarContentGap, sidebarContentGap = _ref$sidebarContentGa === void 0 ? "1rem" : _ref$sidebarContentGa, _ref$mainContentMinWi = _ref.mainContentMinWidth, mainContentMinWidth = _ref$mainContentMinWi === void 0 ? "50%" : _ref$mainContentMinWi, _ref$sidebarVerticalC = _ref.sidebarVerticalCenter, sidebarVerticalCenter = _ref$sidebarVerticalC === void 0 ? false : _ref$sidebarVerticalC, themeValues = _ref.themeValues;
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var isMobile = themeContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        background: COOL_GREY_05,
        extraStyles: "flex-grow: 1;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        centerOverride: !sidebarVerticalCenter
    }, header ? header : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        role: "main"
    }, subHeader && !(isMobile && hideMobileSubHeader) ? subHeader : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: sidebarWrapperPadding
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: sidebarWrapperMaxWidth
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Sidebar, {
        width: sidebarTargetWidth,
        childGap: sidebarContentGap,
        sidebarOnRight: sidebarOnRight,
        contentMinWidth: mainContentMinWidth
    }, sidebarOnRight ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null) : sidebarContent, mainContent, sidebarOnRight ? sidebarContent : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null))))), footer ? footer : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0"
    })));
};
var SidebarSingleContent$1 = withWindowSize(themeComponent(SidebarSingleContent, "Global", fallbackValues$U));
var SidebarStackContent = function SidebarStackContent(_ref) {
    var header = _ref.header, footer = _ref.footer, subHeader = _ref.subHeader, _ref$hideMobileSubHea = _ref.hideMobileSubHeader, hideMobileSubHeader = _ref$hideMobileSubHea === void 0 ? true : _ref$hideMobileSubHea, _ref$sidebarWrapperPa = _ref.sidebarWrapperPadding, sidebarWrapperPadding = _ref$sidebarWrapperPa === void 0 ? "0" : _ref$sidebarWrapperPa, _ref$sidebarWrapperMa = _ref.sidebarWrapperMaxWidth, sidebarWrapperMaxWidth = _ref$sidebarWrapperMa === void 0 ? "auto" : _ref$sidebarWrapperMa, sidebarContent = _ref.sidebarContent, mainContent = _ref.mainContent, _ref$sidebarOnRight = _ref.sidebarOnRight, sidebarOnRight = _ref$sidebarOnRight === void 0 ? false : _ref$sidebarOnRight, _ref$sidebarTargetWid = _ref.sidebarTargetWidth, sidebarTargetWidth = _ref$sidebarTargetWid === void 0 ? "10rem" : _ref$sidebarTargetWid, _ref$sidebarContentGa = _ref.sidebarContentGap, sidebarContentGap = _ref$sidebarContentGa === void 0 ? "1rem" : _ref$sidebarContentGa, _ref$contentStackGap = _ref.contentStackGap, contentStackGap = _ref$contentStackGap === void 0 ? "1rem" : _ref$contentStackGap, _ref$mainContentMinWi = _ref.mainContentMinWidth, mainContentMinWidth = _ref$mainContentMinWi === void 0 ? "50%" : _ref$mainContentMinWi, _ref$sidebarVerticalC = _ref.sidebarVerticalCenter, sidebarVerticalCenter = _ref$sidebarVerticalC === void 0 ? false : _ref$sidebarVerticalC, themeValues = _ref.themeValues;
    var themeContext = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var isMobile = themeContext.isMobile;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        background: COOL_GREY_05,
        key: "page-bg",
        extraStyles: "flex-grow: 1;"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Cover, {
        centerOverride: !sidebarVerticalCenter,
        key: "page-cover"
    }, header ? header : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        key: "header-box"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        minWidth: "100%",
        key: "content-box"
    }, subHeader && !(isMobile && hideMobileSubHeader) ? subHeader : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null), /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: sidebarWrapperPadding,
        key: "content-wrapper"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Center, {
        maxWidth: sidebarWrapperMaxWidth,
        key: "content-center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Sidebar, {
        width: sidebarTargetWidth,
        childGap: sidebarContentGap,
        sidebarOnRight: sidebarOnRight,
        contentMinWidth: mainContentMinWidth,
        key: "content-sidebar"
    }, sidebarOnRight ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), {
        key: "sidebar-fragment"
    }) : sidebarContent, /*#__PURE__*/ (0, _reactDefault.default).createElement(Stack, {
        key: "content-stack",
        childGap: contentStackGap
    }, mainContent), sidebarOnRight ? sidebarContent : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), {
        key: "sidebar-fragment"
    }))))), footer ? footer : /*#__PURE__*/ (0, _reactDefault.default).createElement(Box, {
        padding: "0",
        key: "footer-box"
    })));
};
var SidebarStackContent$1 = withWindowSize(themeComponent(SidebarStackContent, "Global", fallbackValues$U));
var useFocusInvalidInput = function useFocusInvalidInput(hasErrors) {
    var resetHasErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {};
    // Only move focus when "hasErrors" is true
    // "hasErrors" is managed by container page of form
    // typically set to "true" on attempted form submission, if errors exist
    // Reset errors, if provided, resets the error state tracking in order to properly re-run
    (0, _react.useEffect)(function() {
        if (hasErrors) {
            var _inputsWithErrors$;
            var inputsWithErrors = document.querySelectorAll("input[aria-invalid=true]");
            inputsWithErrors === null || inputsWithErrors === void 0 || (_inputsWithErrors$ = inputsWithErrors[0]) === null || _inputsWithErrors$ === void 0 || _inputsWithErrors$.focus();
        }
        return function() {
            return resetHasErrors(false);
        };
    });
};
var useLogoutTimers = function useLogoutTimers(_ref) {
    var _ref$logoutTimerOn = _ref.logoutTimerOn, logoutTimerOn = _ref$logoutTimerOn === void 0 ? false : _ref$logoutTimerOn, action = _ref.action, timeLeftToLogout = _ref.timeLeftToLogout, handleSetTimeLeft = _ref.handleSetTimeLeft, _ref$initialTimeLeftT = _ref.initialTimeLeftToLogout, initialTimeLeftToLogout = _ref$initialTimeLeftT === void 0 ? 30 : _ref$initialTimeLeftT;
    var timers = {
        timer: null,
        interval: null
    };
    var timeLeft = timeLeftToLogout;
    (0, _react.useEffect)(function() {
        if (logoutTimerOn) timers.timer = window.setTimeout(function() {
            action();
            handleSetTimeLeft(initialTimeLeftToLogout);
        }, initialTimeLeftToLogout * 1000);
        return function() {
            return clearTimeout(timers.timer);
        };
    }, [
        logoutTimerOn
    ]);
    (0, _react.useEffect)(function() {
        if (logoutTimerOn) timers.interval = window.setInterval(function() {
            timeLeft--;
            handleSetTimeLeft(timeLeft);
        }, 1000);
        return function() {
            return clearInterval(timers.interval);
        };
    }, [
        logoutTimerOn
    ]);
    return timers;
};
var index$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formats: formats,
    general: general,
    theme: themeUtils,
    useFocusInvalidInput: useFocusInvalidInput,
    useOutsideClick: useOutsideClickHook,
    useToastNotification: useToastNotification,
    useLogoutTimers: useLogoutTimers,
    generateShadows: generateShadows
});

},{"2eecbd38bdd28a8f":"h0XoY","react":"d8NEQ","styled-components":"bkusY","styled-theming":"eC92z","react-router-dom":"hNarb","react-dom":"cy9SD","461728f6d476ab8":"o9rJl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eC92z":[function(require,module,exports) {
"use strict";
function getThemeValue(name, props, values) {
    var value = props.theme && props.theme[name];
    var themeValue;
    if (typeof value === "function") themeValue = value(values);
    else themeValue = values[value];
    if (typeof themeValue === "function") return themeValue(props);
    else return themeValue;
}
function theme(name, values) {
    return function(props) {
        return getThemeValue(name, props, values);
    };
}
theme.variants = function(name, prop, values) {
    return function(props) {
        var variant = props[prop] && values[props[prop]];
        return variant && getThemeValue(name, props, variant);
    };
};
module.exports = theme;

},{}],"iyfz3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _welcomeHeader = require("./WelcomeHeader");
var _welcomeHeaderDefault = parcelHelpers.interopDefault(_welcomeHeader);
exports.default = (0, _welcomeHeaderDefault.default);

},{"./WelcomeHeader":"c5pKW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c5pKW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _welcomePinpad = require("../images/WelcomePinpad");
const WelcomeHeader = ({ actionText })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        extraStyles: "background: linear-gradient(97.79deg, #D9D9FB -0.76%, #CDEBF7 100%)",
        padding: "48px 48px 48px 32px",
        borderRadius: "8px 8px 0 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
            direction: "row",
            childGap: "0",
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                    padding: "0",
                    extraStyles: `
            display: flex;
            flex-direction: column;
            justify-content: center;
          `,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            variant: "large",
                            color: (0, _components.constants).colors.CHARADE_GREY,
                            role: "heading",
                            children: "Welcome to Cashiering"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "2px"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                            variant: "pL",
                            weight: "normal",
                            color: (0, _components.constants).colors.CHARADE_GREY,
                            role: "heading",
                            children: actionText
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _welcomePinpad.WelcomePinpad), {})
            ]
        })
    });
};
exports.default = WelcomeHeader;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../images/WelcomePinpad":"i1KHX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"i1KHX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WelcomePinpad", ()=>WelcomePinpad);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const WelcomePinpad = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: "219",
        height: "121",
        viewBox: "0 0 219 121",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#clip0_503_449)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M149.24 23.68L154.44 20.95C160.65 17.69 164.54 11.26 164.54 4.24998V1.34998C164.54 0.71998 165.13 0.24998 165.75 0.39998L217.26 12.76C217.7 12.87 218.01 13.26 218.01 13.71V17.08C218.01 24.09 214.12 30.53 207.91 33.78L202.71 36.51",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M149.24 23.68L154.44 20.95C160.65 17.69 164.54 11.26 164.54 4.24998V1.34998C164.54 0.71998 165.13 0.24998 165.75 0.39998L217.26 12.76C217.7 12.87 218.01 13.26 218.01 13.71V17.08C218.01 24.09 214.12 30.53 207.91 33.78L202.71 36.51",
                        stroke: "#051F8F",
                        strokeWidth: "0.75",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M100.38 107.83L48.56 120.32C46.49 120.82 44.32 120.82 42.25 120.32L1.5 110.55C1.13 110.46 0.870001 110.13 0.870001 109.75V108.06C0.870001 108.06 0.650001 107.71 1.74 107.44C2.83 107.17 42.24 99.37 42.24 99.37L93.7 106.2L100.38 107.83Z",
                        fill: "#33B8E7"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M51.3101 95.5L1.22011 107.57C0.740107 107.69 0.740107 108.38 1.22011 108.49L42.2401 118.33C44.3201 118.83 46.4801 118.83 48.5501 118.33L97.2701 106.59",
                        fill: "#99DCF3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M100 108.81V110.04C100 110.38 99.68 110.63 99.35 110.55L41.85 96.76C41.22 96.61 40.78 96.05 40.78 95.41V94.18C40.78 93.84 41.1 93.59 41.43 93.67L98.93 107.46C99.56 107.61 100 108.17 100 108.81Z",
                        fill: "#5046A5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M51.3101 95.5L1.22011 107.57C0.740107 107.69 0.740107 108.38 1.22011 108.49L42.2401 118.33C44.3201 118.83 46.4801 118.83 48.5501 118.33L97.2701 106.59",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M167.23 65.77L89.7501 47.1C88.2001 46.73 86.5701 46.93 85.1701 47.67L83.8901 48.34",
                        stroke: "#051F8F",
                        strokeWidth: "0.75",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M211.84 42.37L114.14 93.61C112.12 94.67 110.86 96.76 110.86 99.04V120.07",
                        stroke: "#051F8F",
                        strokeWidth: "0.75",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M110.86 103.32L32.3201 84.49C31.4701 84.28 30.8601 83.52 30.8601 82.64V80.86",
                        stroke: "#051F8F",
                        strokeWidth: "0.75",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M41.6702 80.48L34.2402 84.37C33.7602 84.62 33.2102 84.69 32.6802 84.56",
                        stroke: "#051F8F",
                        strokeWidth: "0.75",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M153.99 72.58L89.3901 57.02C88.0701 56.7 86.6801 56.87 85.4801 57.5L46.3501 78.03",
                        stroke: "#051F8F",
                        strokeWidth: "0.75",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M87.6902 50.2V56.86",
                        stroke: "#051F8F",
                        strokeWidth: "0.75",
                        strokeMiterlimit: "10",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M104.01 43.43L134.74 27.31C136.4 26.44 138.32 26.2 140.14 26.64L199.71 40.94C200.69 41.17 200.85 42.5 199.96 42.96L169.14 59.12C167.48 59.99 165.56 60.23 163.73 59.79L104.25 45.46C103.27 45.22 103.11 43.9 104 43.44L104.01 43.43Z",
                        fill: "#99DCF3",
                        stroke: "#051F8F",
                        strokeWidth: "0.75",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M103.93 65.96L98.3901 68.87C97.6601 69.25 96.8201 69.36 96.0201 69.16L82.7301 65.96C82.4101 65.88 82.3601 65.46 82.6501 65.31L88.1901 62.4C88.9201 62.02 89.7601 61.91 90.5601 62.11L103.85 65.31C104.17 65.39 104.22 65.81 103.93 65.96Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M122.89 70.5L117.35 73.41C116.62 73.79 115.78 73.9 114.98 73.7L101.69 70.5C101.37 70.42 101.32 70 101.61 69.85L107.15 66.94C107.88 66.56 108.72 66.45 109.52 66.65L122.81 69.85C123.13 69.93 123.18 70.35 122.89 70.5Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M141.9 75.06L136.36 77.97C135.63 78.35 134.79 78.46 133.99 78.26L120.7 75.06C120.38 74.98 120.33 74.56 120.62 74.41L126.16 71.5C126.89 71.12 127.73 71.01 128.53 71.21L141.82 74.41C142.14 74.49 142.19 74.91 141.9 75.06Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M93.5102 71.41L87.9702 74.32C87.2402 74.7 86.4002 74.81 85.6002 74.61L72.3102 71.41C71.9902 71.33 71.9402 70.91 72.2302 70.76L77.7702 67.85C78.5002 67.47 79.3402 67.36 80.1402 67.56L93.4302 70.76C93.7502 70.84 93.8002 71.26 93.5102 71.41Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M112.46 75.95L106.92 78.86C106.19 79.24 105.35 79.35 104.55 79.15L91.2601 75.95C90.9401 75.87 90.8901 75.45 91.1801 75.3L96.7201 72.39C97.4501 72.01 98.2901 71.9 99.0901 72.1L112.38 75.3C112.7 75.38 112.75 75.8 112.46 75.95Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M131.48 80.51L125.94 83.42C125.21 83.8 124.37 83.91 123.57 83.71L110.28 80.51C109.96 80.43 109.91 80.01 110.2 79.86L115.74 76.95C116.47 76.57 117.31 76.46 118.11 76.66L131.4 79.86C131.72 79.94 131.77 80.36 131.48 80.51Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M83.09 76.86L77.55 79.77C76.82 80.15 75.98 80.26 75.18 80.06L61.89 76.86C61.57 76.78 61.52 76.36 61.81 76.21L67.35 73.3C68.08 72.92 68.92 72.81 69.72 73.01L83.01 76.21C83.33 76.29 83.38 76.71 83.09 76.86Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M102.04 81.4L96.5002 84.31C95.7702 84.69 94.9302 84.8 94.1302 84.6L80.8402 81.4C80.5202 81.32 80.4702 80.9 80.7602 80.75L86.3002 77.84C87.0302 77.46 87.8702 77.35 88.6702 77.55L101.96 80.75C102.28 80.83 102.33 81.25 102.04 81.4Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M121.06 85.96L115.52 88.87C114.79 89.25 113.95 89.36 113.15 89.16L99.8602 85.96C99.5402 85.88 99.4902 85.46 99.7802 85.31L105.32 82.4C106.05 82.02 106.89 81.91 107.69 82.11L120.98 85.31C121.3 85.39 121.35 85.81 121.06 85.96Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M72.6701 82.31L67.1301 85.22C66.4001 85.6 65.5601 85.71 64.7601 85.51L51.4701 82.31C51.1501 82.23 51.1001 81.81 51.3901 81.66L56.9301 78.75C57.6601 78.37 58.5001 78.26 59.3001 78.46L72.5901 81.66C72.9101 81.74 72.9601 82.16 72.6701 82.31Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M91.62 86.85L86.08 89.76C85.35 90.14 84.51 90.25 83.71 90.05L70.42 86.85C70.1 86.77 70.05 86.35 70.34 86.2L75.88 83.29C76.61 82.91 77.45 82.8 78.25 83L91.54 86.2C91.86 86.28 91.91 86.7 91.62 86.85Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M110.64 91.41L105.1 94.32C104.37 94.7 103.53 94.81 102.73 94.61L89.44 91.41C89.12 91.33 89.07 90.91 89.36 90.76L94.9 87.85C95.63 87.47 96.47 87.36 97.27 87.56L110.56 90.76C110.88 90.84 110.93 91.26 110.64 91.41Z",
                        fill: "#B6B2FA",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0.860107 108.06V109.75C0.860107 110.13 1.12011 110.46 1.49011 110.55L42.2401 120.32C44.3201 120.82 46.4801 120.82 48.5501 120.32L100.37 107.83",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M71.9701 107.73L64.8501 109.44C64.3901 109.55 63.9101 109.55 63.4501 109.44L61.0701 108.87L68.1901 107.16C68.6501 107.05 69.1301 107.05 69.5901 107.16L71.9701 107.73Z",
                        fill: "#051F8F",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M60.7401 110.44L53.6201 112.15C53.1601 112.26 52.6801 112.26 52.2201 112.15L49.8401 111.58L56.9601 109.87C57.4201 109.76 57.9001 109.76 58.3601 109.87L60.7401 110.44Z",
                        fill: "#051F8F",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M79.6401 112.83L108.92 119.85C110.2 120.16 111.53 120.16 112.8 119.85L211.75 96.01C214.63 95.32 216.67 92.74 216.67 89.77V44.22C216.67 41.67 214.92 39.45 212.44 38.85L139.5 21.35C137.68 20.91 135.75 21.15 134.09 22.02L34.1501 74.44C32.1301 75.5 30.8701 77.59 30.8701 79.87V99.84C30.8701 100.03 30.9001 100.22 30.9601 100.39",
                        stroke: "#051F8F",
                        strokeWidth: "0.75",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M41.3 93.65C41.3 93.65 41.38 93.65 41.42 93.66L98.92 107.45C99.55 107.6 99.99 108.16 99.99 108.8V110.03C99.99 110.33 99.75 110.56 99.47 110.56C99.43 110.56 99.39 110.56 99.35 110.55L41.85 96.76C41.22 96.61 40.78 96.05 40.78 95.41V94.18C40.78 93.88 41.02 93.65 41.3 93.65ZM41.3 92.65C40.46 92.65 39.78 93.33 39.78 94.18V95.41C39.78 96.52 40.53 97.48 41.62 97.74L99.12 111.53C99.24 111.56 99.36 111.57 99.48 111.57C100.32 111.57 101 110.89 101 110.04V108.81C101 107.7 100.25 106.74 99.16 106.48L41.66 92.69C41.54 92.66 41.42 92.65 41.3 92.65Z",
                        fill: "#D9D9FB"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M89.5801 110.43L96.8401 108.69",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M46.86 96.57L40.28 98.15",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M85.78 109.35L92.16 107.81",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeMiterlimit: "10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M50.7202 95.9L95.7302 106.69L89.5002 108.2L44.4702 97.4L50.7202 95.9Z",
                        fill: "#66CAED"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M90.1301 108.56V110.05L99.5401 107.78C99.5401 107.78 99.3101 107.55 98.9301 107.46C98.2901 107.31 96.8101 106.95 96.8101 106.95L90.1301 108.56Z",
                        fill: "#00A6E0"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M87.21 108.74L89.5 108.2L44.47 97.4L42.24 97.94L87.21 108.74Z",
                        fill: "#99DCF3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M83.2 105.03L76.08 106.74C75.62 106.85 75.14 106.85 74.68 106.74L72.3 106.17L79.42 104.46C79.88 104.35 80.36 104.35 80.82 104.46L83.2 105.03Z",
                        fill: "#051F8F",
                        stroke: "#051F8F",
                        strokeWidth: "0.5",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M90.1301 108.56L88.3901 108.98L90.1301 109.44V108.56Z",
                        fill: "#33B8E7"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M150.6 50.93C159.823 50.93 167.3 47.2498 167.3 42.71C167.3 38.1702 159.823 34.49 150.6 34.49C141.377 34.49 133.9 38.1702 133.9 42.71C133.9 47.2498 141.377 50.93 150.6 50.93Z",
                        fill: "#051F8F"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M144.96 45.1L142.22 40.67L145.66 40.09L148.4 44.52L144.96 45.1Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M143.73 43.11L159.82 40.37L161.05 42.37L144.96 45.1L143.73 43.11Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "clip0_503_449",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: "217.78",
                        height: "120.95",
                        fill: "white",
                        transform: "translate(0.610107)"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3286W":[function(require,module,exports) {
/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoginCallback", ()=>LoginCallback);
parcelHelpers.export(exports, "OktaContext", ()=>OktaContext);
parcelHelpers.export(exports, "SecureRoute", ()=>SecureRoute);
parcelHelpers.export(exports, "Security", ()=>Security);
parcelHelpers.export(exports, "useOktaAuth", ()=>useOktaAuth);
parcelHelpers.export(exports, "withOktaAuth", ()=>withOktaAuth);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _regenerator = require("@babel/runtime/regenerator");
var _regeneratorDefault = parcelHelpers.interopDefault(_regenerator);
var _react = require("react");
var _oktaAuthJs = require("@okta/okta-auth-js");
var _compareVersions = require("compare-versions");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _reactRouterDom = require("react-router-dom");
var OktaContext = /*#__PURE__*/ _react.createContext(null);
var useOktaAuth = function useOktaAuth() {
    return _react.useContext(OktaContext);
};
var OktaError = function OktaError(_ref) {
    var error = _ref.error;
    if (error.name && error.message) return /*#__PURE__*/ _react.createElement("p", null, error.name, ": ", error.message);
    return /*#__PURE__*/ _react.createElement("p", null, "Error: ", error.toString());
};
var Security = function Security(_ref) {
    var oktaAuth = _ref.oktaAuth, restoreOriginalUri = _ref.restoreOriginalUri, onAuthRequired = _ref.onAuthRequired, children = _ref.children;
    var _React$useState = _react.useState(function() {
        if (!oktaAuth) return null;
        return oktaAuth.authStateManager.getAuthState();
    }), _React$useState2 = (0, _slicedToArrayDefault.default)(_React$useState, 2), authState = _React$useState2[0], setAuthState = _React$useState2[1];
    _react.useEffect(function() {
        if (!oktaAuth || !restoreOriginalUri) return;
        if (oktaAuth.options.restoreOriginalUri) console.warn("Two custom restoreOriginalUri callbacks are detected. The one from the OktaAuth configuration will be overridden by the provided restoreOriginalUri prop from the Security component.");
        oktaAuth.options.restoreOriginalUri = /*#__PURE__*/ function() {
            var _ref2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee(oktaAuth, originalUri) {
                return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            restoreOriginalUri(oktaAuth, originalUri);
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref2.apply(this, arguments);
            };
        }();
    }, []);
    _react.useEffect(function() {
        if (!oktaAuth) return;
        if (oktaAuth._oktaUserAgent) oktaAuth._oktaUserAgent.addEnvironment("@okta/okta-react".concat("/", "6.8.0"));
        else console.warn("_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .");
        var currentAuthState = oktaAuth.authStateManager.getAuthState();
        if (currentAuthState !== authState) setAuthState(currentAuthState);
        var handler = function handler(authState) {
            setAuthState(authState);
        };
        oktaAuth.authStateManager.subscribe(handler);
        oktaAuth.start();
        return function() {
            oktaAuth.authStateManager.unsubscribe(handler);
        };
    }, [
        oktaAuth
    ]);
    if (!oktaAuth) {
        var err = new (0, _oktaAuthJs.AuthSdkError)("No oktaAuth instance passed to Security Component.");
        return /*#__PURE__*/ _react.createElement(OktaError, {
            error: err
        });
    }
    if (!restoreOriginalUri) {
        var _err = new (0, _oktaAuthJs.AuthSdkError)("No restoreOriginalUri callback passed to Security Component.");
        return /*#__PURE__*/ _react.createElement(OktaError, {
            error: _err
        });
    }
    if (!oktaAuth._oktaUserAgent) console.warn("_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .");
    else {
        var isAuthJsSupported = (0, _compareVersions.compare)(oktaAuth._oktaUserAgent.getVersion(), "5.3.1", ">=");
        if (!isAuthJsSupported) {
            var _err2 = new (0, _oktaAuthJs.AuthSdkError)("\n        Passed in oktaAuth is not compatible with the SDK,\n        minimum supported okta-auth-js version is ".concat("5.3.1", ".\n      "));
            return /*#__PURE__*/ _react.createElement(OktaError, {
                error: _err2
            });
        }
    }
    return /*#__PURE__*/ _react.createElement(OktaContext.Provider, {
        value: {
            oktaAuth: oktaAuth,
            authState: authState,
            _onAuthRequired: onAuthRequired
        }
    }, children);
};
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var withOktaAuth = function withOktaAuth(ComponentToWrap) {
    var WrappedComponent = function WrappedComponent(props) {
        var oktaAuthProps = useOktaAuth();
        return /*#__PURE__*/ _react.createElement(ComponentToWrap, _objectSpread$1(_objectSpread$1({}, oktaAuthProps), props));
    };
    WrappedComponent.displayName = "withOktaAuth_" + (ComponentToWrap.displayName || ComponentToWrap.name);
    return WrappedComponent;
};
var handledRedirect = false;
var LoginCallback = function LoginCallback(_ref) {
    var errorComponent = _ref.errorComponent, _ref$loadingElement = _ref.loadingElement, loadingElement = _ref$loadingElement === void 0 ? null : _ref$loadingElement, onAuthResume = _ref.onAuthResume;
    var _useOktaAuth = useOktaAuth(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState;
    var _React$useState = _react.useState(null), _React$useState2 = (0, _slicedToArrayDefault.default)(_React$useState, 2), callbackError = _React$useState2[0], setCallbackError = _React$useState2[1];
    var ErrorReporter = errorComponent || OktaError;
    _react.useEffect(function() {
        var isInteractionRequired = oktaAuth.idx.isInteractionRequired || oktaAuth.isInteractionRequired.bind(oktaAuth);
        if (onAuthResume && isInteractionRequired()) {
            onAuthResume();
            return;
        }
        if (!handledRedirect) {
            oktaAuth.handleLoginRedirect()["catch"](function(e) {
                setCallbackError(e);
            });
            handledRedirect = true;
        }
    }, [
        oktaAuth
    ]);
    var authError = authState === null || authState === void 0 ? void 0 : authState.error;
    var displayError = callbackError || authError;
    if (displayError) return /*#__PURE__*/ _react.createElement(ErrorReporter, {
        error: displayError
    });
    return loadingElement;
};
var _excluded = [
    "onAuthRequired",
    "errorComponent"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, _definePropertyDefault.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var useMatch;
if ("useRouteMatch" in _reactRouterDom) useMatch = _reactRouterDom["useRouteMatch" in _reactRouterDom ? "useRouteMatch" : ""];
else useMatch = function useMatch() {
    throw new (0, _oktaAuthJs.AuthSdkError)('Unsupported: SecureRoute only works with react-router-dom v5 or any router library with compatible APIs. See examples under the "samples" folder for how to implement your own custom SecureRoute Component.');
};
var SecureRoute = function SecureRoute(_ref) {
    var onAuthRequired = _ref.onAuthRequired, errorComponent = _ref.errorComponent, routeProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _useOktaAuth = useOktaAuth(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState, _onAuthRequired = _useOktaAuth._onAuthRequired;
    var match = useMatch(routeProps);
    var pendingLogin = _react.useRef(false);
    var _React$useState = _react.useState(null), _React$useState2 = (0, _slicedToArrayDefault.default)(_React$useState, 2), handleLoginError = _React$useState2[0], setHandleLoginError = _React$useState2[1];
    var ErrorReporter = errorComponent || OktaError;
    _react.useEffect(function() {
        var handleLogin = /*#__PURE__*/ function() {
            var _ref2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
                var originalUri, onAuthRequiredFn;
                return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!pendingLogin.current) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            pendingLogin.current = true;
                            originalUri = (0, _oktaAuthJs.toRelativeUrl)(window.location.href, window.location.origin);
                            oktaAuth.setOriginalUri(originalUri);
                            onAuthRequiredFn = onAuthRequired || _onAuthRequired;
                            if (!onAuthRequiredFn) {
                                _context.next = 11;
                                break;
                            }
                            _context.next = 9;
                            return onAuthRequiredFn(oktaAuth);
                        case 9:
                            _context.next = 13;
                            break;
                        case 11:
                            _context.next = 13;
                            return oktaAuth.signInWithRedirect();
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function handleLogin() {
                return _ref2.apply(this, arguments);
            };
        }();
        if (!match) return;
        if (!authState) return;
        if (authState.isAuthenticated) {
            pendingLogin.current = false;
            return;
        }
        if (!authState.isAuthenticated) handleLogin()["catch"](function(err) {
            setHandleLoginError(err);
        });
    }, [
        authState,
        oktaAuth,
        match,
        onAuthRequired,
        _onAuthRequired
    ]);
    if (handleLoginError) return /*#__PURE__*/ _react.createElement(ErrorReporter, {
        error: handleLoginError
    });
    if (!authState || !authState.isAuthenticated) return null;
    return /*#__PURE__*/ _react.createElement(_reactRouterDom.Route, _objectSpread({}, routeProps));
};

},{"@babel/runtime/helpers/asyncToGenerator":"6zYkV","@babel/runtime/helpers/slicedToArray":"6t1pI","@babel/runtime/regenerator":"lSyhM","react":"d8NEQ","@okta/okta-auth-js":"boELZ","compare-versions":"8v4T4","@babel/runtime/helpers/defineProperty":"2O4gV","@babel/runtime/helpers/objectWithoutProperties":"fTsZO","react-router-dom":"hNarb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6zYkV":[function(require,module,exports) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"6t1pI":[function(require,module,exports) {
var arrayWithHoles = require("1ac68135a8555821");
var iterableToArrayLimit = require("72fb258b94eeac96");
var unsupportedIterableToArray = require("507f7242cb3eaa43");
var nonIterableRest = require("cbe05be2b1a2de6f");
function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"1ac68135a8555821":"c4XwX","72fb258b94eeac96":"KQj8J","507f7242cb3eaa43":"iomKB","cbe05be2b1a2de6f":"hTACb"}],"c4XwX":[function(require,module,exports) {
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"KQj8J":[function(require,module,exports) {
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"iomKB":[function(require,module,exports) {
var arrayLikeToArray = require("7ef69a5997c8f9c");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"7ef69a5997c8f9c":"4iVum"}],"4iVum":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hTACb":[function(require,module,exports) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lSyhM":[function(require,module,exports) {
// TODO(Babel 8): Remove this file.
var runtime = require("1a507771f255ce81")();
module.exports = runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
    else Function("r", "regeneratorRuntime = r")(runtime);
}

},{"1a507771f255ce81":"ebPez"}],"ebPez":[function(require,module,exports) {
var _typeof = require("ada23f9c200e25ac")["default"];
function _regeneratorRuntime() {
    "use strict";
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return generator._invoke = function(innerFn, self, context) {
            var state = "suspendedStart";
            return function(method, arg) {
                if ("executing" === state) throw new Error("Generator is already running");
                if ("completed" === state) {
                    if ("throw" === method) throw arg;
                    return doneResult();
                }
                for(context.method = method, context.arg = arg;;){
                    var delegate = context.delegate;
                    if (delegate) {
                        var delegateResult = maybeInvokeDelegate(delegate, context);
                        if (delegateResult) {
                            if (delegateResult === ContinueSentinel) continue;
                            return delegateResult;
                        }
                    }
                    if ("next" === context.method) context.sent = context._sent = context.arg;
                    else if ("throw" === context.method) {
                        if ("suspendedStart" === state) throw state = "completed", context.arg;
                        context.dispatchException(context.arg);
                    } else "return" === context.method && context.abrupt("return", context.arg);
                    state = "executing";
                    var record = tryCatch(innerFn, self, context);
                    if ("normal" === record.type) {
                        if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                        return {
                            value: record.arg,
                            done: context.done
                        };
                    }
                    "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                }
            };
        }(innerFn, self, context), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        this._invoke = function(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (undefined === method) {
            if (context.delegate = null, "throw" === context.method) {
                if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"ada23f9c200e25ac":"8F0t6"}],"8F0t6":[function(require,module,exports) {
function _typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"boELZ":[function(require,module,exports) {
/*! For license information please see default.js.LICENSE.txt */ var process = require("181d1c11c5931dcf");
!function(e1, t) {
    module.exports = t();
}(self, function() {
    return function() {
        var e1 = {
            9748: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return Z;
                    }
                });
                var r = n(5385), o = n(9123), i = n(1971);
                function a(e1, t) {
                    var n = {};
                    return Object.assign(n, t), !n.stateToken && e1.stateToken && (n.stateToken = e1.stateToken), n;
                }
                function u(e1, t) {
                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn", t, {
                        withCredentials: !0
                    });
                }
                function c(e1) {
                    return !!f(e1);
                }
                function s(e1, t, n, o, i) {
                    return i = Object.assign({
                        withCredentials: !0
                    }, i), (0, r.v_)(e1, n, o, i).then(function(e1) {
                        return t.createTransaction(e1);
                    });
                }
                function f(e1) {
                    return e1.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME);
                }
                var l = n(3144), p = n(5671), d = n(4942), h = n(3193), v = n(4771), y = n(6718);
                function g(e1, t, n, i, u, c) {
                    if (Array.isArray(u)) return function(r, a) {
                        if (!r) throw new o.Z("Must provide a link name");
                        var s = (0, h.sE)(u, {
                            name: r
                        });
                        if (!s) throw new o.Z("No link found for that name");
                        return g(e1, t, n, i, s, c)(a);
                    };
                    if (u.hints && u.hints.allow && 1 === u.hints.allow.length) switch(u.hints.allow[0]){
                        case "GET":
                            return function() {
                                return (0, r.U2)(e1, u.href, {
                                    withCredentials: !0
                                });
                            };
                        case "POST":
                            return function(r) {
                                c && c.isPolling && (c.isPolling = !1);
                                var f = a(n, r);
                                "MFA_ENROLL" !== n.status && "FACTOR_ENROLL" !== n.status || Object.assign(f, {
                                    factorType: i.factorType,
                                    provider: i.provider
                                });
                                var l = {}, p = f.autoPush;
                                if (void 0 !== p) {
                                    if ("function" == typeof p) try {
                                        l.autoPush = !!p();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                    }
                                    else null !== p && (l.autoPush = !!p);
                                    f = (0, h.CE)(f, "autoPush");
                                }
                                var d = f.rememberDevice;
                                if (void 0 !== d) {
                                    if ("function" == typeof d) try {
                                        l.rememberDevice = !!d();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                    }
                                    else null !== d && (l.rememberDevice = !!d);
                                    f = (0, h.CE)(f, "rememberDevice");
                                } else f.profile && void 0 !== f.profile.updatePhone && (f.profile.updatePhone && (l.updatePhone = !0), f.profile = (0, h.CE)(f.profile, "updatePhone"));
                                var v = u.href + (0, y.UK)(l);
                                return s(e1, t, v, f);
                            };
                    }
                }
                var m = n(8750), b = n(6573);
                function k(e1, t, n) {
                    return function(u) {
                        var c, s, f, l;
                        (0, v.hj)(u) ? c = u : (0, v.Kn)(u) && (c = u.delay, s = u.rememberDevice, f = u.autoPush, l = u.transactionCallBack), c || 0 === c || (c = i.DEFAULT_POLLING_DELAY);
                        var p = (0, h.Rg)(t, "next", "poll");
                        n.isPolling = !0;
                        var d = 0;
                        return (function i() {
                            return n.isPolling ? (function() {
                                var n = {};
                                if ("function" == typeof f) try {
                                    n.autoPush = !!f();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                }
                                else null != f && (n.autoPush = !!f);
                                if ("function" == typeof s) try {
                                    n.rememberDevice = !!s();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                }
                                else null != s && (n.rememberDevice = !!s);
                                var i = p.href + (0, y.UK)(n);
                                return (0, r.v_)(e1, i, function(e1) {
                                    return a(e1);
                                }(t), {
                                    saveAuthnState: !1,
                                    withCredentials: !0
                                });
                            })().then(function(t) {
                                if (d = 0, t.factorResult && "WAITING" === t.factorResult) {
                                    if (!n.isPolling) throw new b.Z;
                                    return "function" == typeof l && l(t), (0, m.gw)(c).then(i);
                                }
                                return n.isPolling = !1, e1.tx.createTransaction(t);
                            }).catch(function(e1) {
                                if (e1.xhr && (0 === e1.xhr.status || 429 === e1.xhr.status) && d <= 4) {
                                    var t = 1e3 * Math.pow(2, d);
                                    return d++, (0, m.gw)(t).then(i);
                                }
                                throw e1;
                            }) : Promise.reject(new b.Z);
                        })().catch(function(e1) {
                            throw n.isPolling = !1, e1;
                        });
                    };
                }
                function w(e1, t, n, r, o) {
                    if (r = r || n, r = (0, h.d9)(r), Array.isArray(r)) {
                        for(var i = [], a = 0, u = r.length; a < u; a++)i.push(w(e1, t, n, r[a], o));
                        return i;
                    }
                    var c = r._embedded || {};
                    for(var s in c)Object.prototype.hasOwnProperty.call(c, s) && ((0, v.Kn)(c[s]) || Array.isArray(c[s])) && (c[s] = w(e1, t, n, c[s], o));
                    var f = function(e1, t, n, r, o) {
                        var i = {};
                        for(var a in r._links)if (Object.prototype.hasOwnProperty.call(r._links, a)) {
                            var u = r._links[a];
                            if ("next" === a && (a = u.name), u.type) i[a] = u;
                            else if ("poll" === a) i.poll = k(e1, n, o);
                            else {
                                var c = g(e1, t, n, r, u, o);
                                c && (i[a] = c);
                            }
                        }
                        return i;
                    }(e1, t, n, r, o);
                    return Object.assign(c, f), r = (0, h.CE)(r, "_embedded", "_links"), Object.assign(r, c), r;
                }
                var O = (0, l.Z)(function e1(t, n) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    (0, p.Z)(this, e1), (0, d.Z)(this, "next", void 0), (0, d.Z)(this, "cancel", void 0), (0, d.Z)(this, "skip", void 0), (0, d.Z)(this, "unlock", void 0), (0, d.Z)(this, "changePassword", void 0), (0, d.Z)(this, "resetPassword", void 0), (0, d.Z)(this, "answer", void 0), (0, d.Z)(this, "recovery", void 0), (0, d.Z)(this, "verify", void 0), (0, d.Z)(this, "resend", void 0), (0, d.Z)(this, "activate", void 0), (0, d.Z)(this, "poll", void 0), (0, d.Z)(this, "prev", void 0), (0, d.Z)(this, "data", void 0), (0, d.Z)(this, "stateToken", void 0), (0, d.Z)(this, "sessionToken", void 0), (0, d.Z)(this, "status", void 0), (0, d.Z)(this, "user", void 0), (0, d.Z)(this, "factor", void 0), (0, d.Z)(this, "factors", void 0), (0, d.Z)(this, "policy", void 0), (0, d.Z)(this, "scopes", void 0), (0, d.Z)(this, "target", void 0), (0, d.Z)(this, "authentication", void 0), this.data = void 0, this.status = void 0, r && (this.data = r, Object.assign(this, w(t, n, r, r, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== r.status || r._links || (this.cancel = function() {
                        return Promise.resolve(n.createTransaction());
                    }));
                });
                function Z(e1) {
                    var t = {
                        status: u.bind(null, e1),
                        resume: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var r = f(e1);
                                    if (!r) return Promise.reject(new o.Z("No transaction to resume"));
                                    n = {
                                        stateToken: r
                                    };
                                }
                                return u(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        exists: c.bind(null, e1),
                        introspect: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var i = f(e1);
                                    if (!i) return Promise.reject(new o.Z("No transaction to evaluate"));
                                    n = {
                                        stateToken: i
                                    };
                                }
                                return (function(e1, t) {
                                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn/introspect", t, {
                                        withCredentials: !0
                                    });
                                })(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        createTransaction: function(n) {
                            return new O(e1, t, n);
                        },
                        postToTransaction: function(n, r, o) {
                            return s(e1, t, n, r, o);
                        }
                    };
                    return t;
                }
            },
            3398: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return r.b;
                    },
                    t: function() {
                        return o.t;
                    }
                });
                var r = n(9748), o = n(3164);
            },
            3164: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return y;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(3193), h = n(8719), v = n(9748);
                function y(e1) {
                    return function(e1) {
                        (0, u.Z)(m, e1);
                        var t, n, l, y, g = (l = m, y = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, s.Z)(l);
                            if (y) {
                                var n = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function m() {
                            var e1;
                            (0, o.Z)(this, m);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = g.call.apply(g, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "tx", void 0), (0, f.Z)((0, a.Z)(e1), "authn", void 0), (0, f.Z)((0, a.Z)(e1), "fingerprint", void 0), e1.authn = e1.tx = (0, v.b)((0, a.Z)(e1)), e1.fingerprint = h.Z.bind(null, (0, a.Z)(e1)), e1;
                        }
                        return (0, i.Z)(m, [
                            {
                                key: "signIn",
                                value: (n = (0, r.Z)(p().mark(function e1(t) {
                                    var n, r = this;
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = (0, d.d9)(t || {}), n = function(e1) {
                                                    return delete t.sendFingerprint, r.tx.postToTransaction("/api/v1/authn", t, e1);
                                                }, t.sendFingerprint) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return", n());
                                            case 4:
                                                return e1.abrupt("return", this.fingerprint().then(function(e1) {
                                                    return n({
                                                        headers: {
                                                            "X-Device-Fingerprint": e1
                                                        }
                                                    });
                                                }));
                                            case 5:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithCredentials",
                                value: (t = (0, r.Z)(p().mark(function e1(t) {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", this.signIn(t));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return t.apply(this, arguments);
                                })
                            },
                            {
                                key: "forgotPassword",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/password", e1);
                                }
                            },
                            {
                                key: "unlockAccount",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/unlock", e1);
                                }
                            },
                            {
                                key: "verifyRecoveryToken",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/token", e1);
                                }
                            }
                        ]), m;
                    }(e1);
                }
            },
            9893: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = n(3193), u = n(415), c = n(1971), s = n(4279), f = n.n(s);
                function l(e1) {
                    var t = (0, r.Z)(function t() {
                        (0, o.Z)(this, t), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "emitter", void 0), (0, i.Z)(this, "features", void 0);
                        var n = new e1(arguments.length && (arguments.length <= 0 ? void 0 : arguments[0]) || {});
                        this.options = (0, a.YY)(n), this.emitter = new (f()), this.features = u;
                    });
                    return (0, i.Z)(t, "features", u), (0, i.Z)(t, "constants", c), t.features = t.prototype.features = u, Object.assign(t, {
                        constants: c
                    }), t;
                }
            },
            3306: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return o.X;
                    },
                    a: function() {
                        return r.a;
                    }
                });
                var r = n(9893), o = n(5093);
            },
            5093: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942);
                function a() {
                    return (0, r.Z)(function e1(t) {
                        (0, o.Z)(this, e1), (0, i.Z)(this, "devMode", void 0), this.devMode = !!t.devMode;
                    });
                }
            },
            4858: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = arguments[t];
                        for(var r in n)e1[r] = n[r];
                    }
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var o = function e1(t, n) {
                    function o(e1, o, i) {
                        if ("undefined" != typeof document) {
                            "number" == typeof (i = r({}, n, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), e1 = encodeURIComponent(e1).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
                            var a = "";
                            for(var u in i)i[u] && (a += "; " + u, !0 !== i[u] && (a += "=" + i[u].split(";")[0]));
                            return document.cookie = e1 + "=" + t.write(o, e1) + a;
                        }
                    }
                    return Object.create({
                        set: o,
                        get: function(e1) {
                            if ("undefined" != typeof document && (!arguments.length || e1)) {
                                for(var n = document.cookie ? document.cookie.split("; ") : [], r = {}, o = 0; o < n.length; o++){
                                    var i = n[o].split("="), a = i.slice(1).join("=");
                                    try {
                                        var u = decodeURIComponent(i[0]);
                                        if (r[u] = t.read(a, u), e1 === u) break;
                                    } catch (e1) {}
                                }
                                return e1 ? r[e1] : r;
                            }
                        },
                        remove: function(e1, t) {
                            o(e1, "", r({}, t, {
                                expires: -1
                            }));
                        },
                        withAttributes: function(t) {
                            return e1(this.converter, r({}, this.attributes, t));
                        },
                        withConverter: function(t) {
                            return e1(r({}, this.converter, t), this.attributes);
                        }
                    }, {
                        attributes: {
                            value: Object.freeze(n)
                        },
                        converter: {
                            value: Object.freeze(t)
                        }
                    });
                }({
                    read: function(e1) {
                        return '"' === e1[0] && (e1 = e1.slice(1, -1)), e1.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
                    },
                    write: function(e1) {
                        return encodeURIComponent(e1).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
                    }
                }, {
                    path: "/"
                }), i = o, a = n(9123), u = n(146), c = n(415), s = {
                    browserHasLocalStorage: function() {
                        try {
                            var e1 = this.getLocalStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    browserHasSessionStorage: function() {
                        try {
                            var e1 = this.getSessionStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    testStorageType: function(e1) {
                        var t = !1;
                        switch(e1){
                            case "sessionStorage":
                                t = this.browserHasSessionStorage();
                                break;
                            case "localStorage":
                                t = this.browserHasLocalStorage();
                                break;
                            case "cookie":
                            case "memory":
                                t = !0;
                                break;
                            default:
                                t = !1;
                        }
                        return t;
                    },
                    getStorageByType: function(e1, t) {
                        var n;
                        switch(e1){
                            case "sessionStorage":
                                n = this.getSessionStorage();
                                break;
                            case "localStorage":
                                n = this.getLocalStorage();
                                break;
                            case "cookie":
                                n = this.getCookieStorage(t);
                                break;
                            case "memory":
                                n = this.getInMemoryStorage();
                                break;
                            default:
                                throw new a.Z("Unrecognized storage option: ".concat(e1));
                        }
                        return n;
                    },
                    findStorageType: function(e1) {
                        var t, n;
                        return t = (e1 = e1.slice()).shift(), (n = e1.length ? e1[0] : null) ? this.testStorageType(t) ? t : ((0, u.ZK)("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), this.findStorageType(e1)) : t;
                    },
                    getLocalStorage: function() {
                        return (0, c.isIE11OrLess)() && !window.onstorage && (window.onstorage = function() {}), localStorage;
                    },
                    getSessionStorage: function() {
                        return sessionStorage;
                    },
                    getCookieStorage: function(e1) {
                        var t = this, n = e1.secure, r = e1.sameSite, o = e1.sessionCookie;
                        if (void 0 === n || void 0 === r) throw new a.Z('getCookieStorage: "secure" and "sameSite" options must be provided');
                        var i = {
                            getItem: this.storage.get,
                            setItem: function(e1, i) {
                                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "2200-01-01T00:00:00.000Z";
                                a = o ? null : a, t.storage.set(e1, i, a, {
                                    secure: n,
                                    sameSite: r
                                });
                            },
                            removeItem: function(e1) {
                                t.storage.delete(e1);
                            }
                        };
                        return e1.useSeparateCookies ? {
                            getItem: function(e1) {
                                var t = i.getItem(), n = {};
                                return Object.keys(t).forEach(function(r) {
                                    0 === r.indexOf(e1) && (n[r.replace("".concat(e1, "_"), "")] = JSON.parse(t[r]));
                                }), JSON.stringify(n);
                            },
                            setItem: function(e1, t) {
                                var n = JSON.parse(this.getItem(e1));
                                t = JSON.parse(t), Object.keys(t).forEach(function(r) {
                                    var o = e1 + "_" + r, a = JSON.stringify(t[r]);
                                    i.setItem(o, a), delete n[r];
                                }), Object.keys(n).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            },
                            removeItem: function(e1) {
                                var t = JSON.parse(this.getItem(e1));
                                Object.keys(t).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            }
                        } : i;
                    },
                    inMemoryStore: {},
                    getInMemoryStorage: function() {
                        var e1 = this;
                        return {
                            getItem: function(t) {
                                return e1.inMemoryStore[t];
                            },
                            setItem: function(t, n) {
                                e1.inMemoryStore[t] = n;
                            }
                        };
                    },
                    testStorage: function(e1) {
                        var t = "okta-test-storage";
                        try {
                            return e1.setItem(t, t), e1.removeItem(t), !0;
                        } catch (e1) {
                            return !1;
                        }
                    },
                    storage: {
                        set: function(e1, t, n, r) {
                            var o = r.sameSite, u = r.secure;
                            if (void 0 === u || void 0 === o) throw new a.Z('storage.set: "secure" and "sameSite" options must be provided');
                            var c = {
                                path: r.path || "/",
                                secure: u,
                                sameSite: o
                            };
                            return Date.parse(n) && (c.expires = new Date(n)), i.set(e1, t, c), this.get(e1);
                        },
                        get: function(e1) {
                            return arguments.length ? i.get(e1) : i.get();
                        },
                        delete: function(e1) {
                            return i.remove(e1, {
                                path: "/"
                            });
                        }
                    }
                }, f = s;
            },
            8719: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return u;
                    }
                });
                var r = n(9123), o = n(415), i = n(4970), a = function(e1, t) {
                    return t.source === e1.contentWindow;
                };
                function u(e1, t) {
                    var n;
                    if (!(0, o.isFingerprintSupported)()) return Promise.reject(new r.Z("Fingerprinting is not supported on this device"));
                    var u, c, s, f = null !== (n = null == t ? void 0 : t.container) && void 0 !== n ? n : document.body;
                    return new Promise(function(n, o) {
                        (c = document.createElement("iframe")).style.display = "none", s = function(t) {
                            if (a(c, t) && t && t.data && t.origin === e1.getIssuerOrigin()) {
                                var i, u, s;
                                try {
                                    i = JSON.parse(t.data);
                                } catch (e1) {
                                    return;
                                }
                                if (i) return "FingerprintAvailable" === i.type ? n(i.fingerprint) : "FingerprintServiceReady" !== i.type ? o(new r.Z("No data")) : void (null === (u = c) || void 0 === u || null === (s = u.contentWindow) || void 0 === s || s.postMessage(JSON.stringify({
                                    type: "GetFingerprint"
                                }), t.origin));
                            }
                        }, (0, i.NH)(window, "message", s), c.src = e1.getIssuerOrigin() + "/auth/services/devicefingerprint", f.appendChild(c), u = setTimeout(function() {
                            o(new r.Z("Fingerprinting timed out"));
                        }, (null == t ? void 0 : t.timeout) || 15e3);
                    }).finally(function() {
                        var e1;
                        clearTimeout(u), (0, i.ys)(window, "message", s), f.contains(c) && (null === (e1 = c.parentElement) || void 0 === e1 || e1.removeChild(c));
                    });
                }
            },
            1971: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return h;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return c;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return a;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return k;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return i;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return o;
                    },
                    IDX_API_VERSION: function() {
                        return w;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return d;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return v;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return b;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return m;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return p;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return s;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return g;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return y;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return l;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return r;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return u;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return f;
                    }
                });
                var r = "oktaStateToken", o = 500, i = 300, a = 86400, u = "okta-token-storage", c = "okta-cache-storage", s = "okta-pkce-storage", f = "okta-transaction-storage", l = "okta-shared-transaction-storage", p = "okta-original-uri-storage", d = "okta-idx-response-storage", h = "accessToken", v = "idToken", y = "refreshToken", g = "referrerPath", m = 43, b = 128, k = "S256", w = "1.0.0";
            },
            1018: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return k;
                    },
                    a: function() {
                        return g;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(4942), u = n(4687), c = n.n(u), s = n(3615), f = n.n(s), l = n(9123), p = n(7088), d = n(3548), h = n(146);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, a.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var g = null, m = {
                    updateAuthStatePromise: null,
                    canceledTimes: 0
                }, b = "authStateChange", k = function() {
                    function e1(t) {
                        var n = this;
                        if ((0, o.Z)(this, e1), (0, a.Z)(this, "_sdk", void 0), (0, a.Z)(this, "_pending", void 0), (0, a.Z)(this, "_authState", void 0), (0, a.Z)(this, "_prevAuthState", void 0), (0, a.Z)(this, "_logOptions", void 0), (0, a.Z)(this, "_transformQueue", void 0), !t.emitter) throw new l.Z("Emitter should be initialized before AuthStateManager");
                        this._sdk = t, this._pending = y({}, m), this._authState = g, this._logOptions = {}, this._prevAuthState = null, this._transformQueue = new d.b({
                            quiet: !0
                        }), t.tokenManager.on(p.O3, function(e1, t) {
                            n._setLogOptions({
                                event: p.O3,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        }), t.tokenManager.on(p.FT, function(e1, t) {
                            n._setLogOptions({
                                event: p.FT,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        });
                    }
                    var t;
                    return (0, i.Z)(e1, [
                        {
                            key: "_setLogOptions",
                            value: function(e1) {
                                this._logOptions = e1;
                            }
                        },
                        {
                            key: "getAuthState",
                            value: function() {
                                return this._authState;
                            }
                        },
                        {
                            key: "getPreviousAuthState",
                            value: function() {
                                return this._prevAuthState;
                            }
                        },
                        {
                            key: "updateAuthState",
                            value: (t = (0, r.Z)(c().mark(function e1() {
                                var t, n, r, o, i, a, u, s = this;
                                return c().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (t = this._sdk.options, n = t.transformAuthState, r = t.devMode, o = function(e1) {
                                                var t = s._logOptions, n = t.event, r = t.key, o = t.token;
                                                (0, h.dr)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n, " Status:").concat(e1)), (0, h.dr)().log(r, o), (0, h.dr)().log("Current authState", s._authState), (0, h.dr)().groupEnd(), s._logOptions = {};
                                            }, i = function(e1) {
                                                var t, n;
                                                n = e1, (t = s._authState) && t.isAuthenticated === n.isAuthenticated && JSON.stringify(t.idToken) === JSON.stringify(n.idToken) && JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) && t.error === n.error ? r && o("unchanged") : (s._prevAuthState = s._authState, s._authState = e1, s._sdk.emitter.emit(b, y({}, e1)), r && o("emitted"));
                                            }, a = function e1(t) {
                                                return s._pending.updateAuthStatePromise.then(function() {
                                                    var n = s._pending.updateAuthStatePromise;
                                                    return n && n !== t ? e1(n) : s.getAuthState();
                                                });
                                            }, !this._pending.updateAuthStatePromise) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!(this._pending.canceledTimes >= 10)) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return r && o("terminated"), e1.abrupt("return", a(this._pending.updateAuthStatePromise));
                                        case 10:
                                            this._pending.updateAuthStatePromise.cancel();
                                        case 11:
                                            return u = new (f())(function(e1, t, a) {
                                                a.shouldReject = !1, a(function() {
                                                    s._pending.updateAuthStatePromise = null, s._pending.canceledTimes = s._pending.canceledTimes + 1, r && o("canceled");
                                                });
                                                var c = function(t) {
                                                    u.isCanceled ? e1() : (i(t), e1(), s._pending = y({}, m));
                                                };
                                                s._sdk.isAuthenticated().then(function() {
                                                    if (u.isCanceled) e1();
                                                    else {
                                                        var t = s._sdk.tokenManager.getTokensSync(), r = t.accessToken, o = t.idToken, i = t.refreshToken, a = {
                                                            accessToken: r,
                                                            idToken: o,
                                                            refreshToken: i,
                                                            isAuthenticated: !(!r || !o)
                                                        };
                                                        (n ? s._transformQueue.push(n, null, s._sdk, a) : Promise.resolve(a)).then(function(e1) {
                                                            return c(e1);
                                                        }).catch(function(e1) {
                                                            return c({
                                                                accessToken: r,
                                                                idToken: o,
                                                                refreshToken: i,
                                                                isAuthenticated: !1,
                                                                error: e1
                                                            });
                                                        });
                                                    }
                                                });
                                            }), this._pending.updateAuthStatePromise = u, e1.abrupt("return", a(u));
                                        case 14:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "subscribe",
                            value: function(e1) {
                                this._sdk.emitter.on(b, e1);
                            }
                        },
                        {
                            key: "unsubscribe",
                            value: function(e1) {
                                this._sdk.emitter.off(b, e1);
                            }
                        }
                    ]), e1;
                }();
            },
            7145: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return ge;
                    }
                });
                var r = n(885), o = n(2982), i = n(5861), a = n(5671), u = n(3144), c = n(4942), s = n(4687), f = n.n(s);
                Promise.resolve(!1);
                var l = Promise.resolve(!0), p = Promise.resolve();
                function d(e1, t) {
                    return e1 || (e1 = 0), new Promise(function(n) {
                        return setTimeout(function() {
                            return n(t);
                        }, e1);
                    });
                }
                function h() {
                    return Math.random().toString(36).substring(2);
                }
                var v = 0, y = 0;
                function g() {
                    var e1 = (new Date).getTime();
                    return e1 === v ? 1e3 * e1 + ++y : (v = e1, y = 0, 1e3 * e1);
                }
                var m = {
                    create: function(e1) {
                        var t = {
                            messagesCallback: null,
                            bc: new BroadcastChannel(e1),
                            subFns: []
                        };
                        return t.bc.onmessage = function(e1) {
                            t.messagesCallback && t.messagesCallback(e1.data);
                        }, t;
                    },
                    close: function(e1) {
                        e1.bc.close(), e1.subFns = [];
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        try {
                            return e1.bc.postMessage(t, !1), p;
                        } catch (e1) {
                            return Promise.reject(e1);
                        }
                    },
                    canBeUsed: function() {
                        if ("undefined" == typeof window && "undefined" == typeof self || "function" != typeof BroadcastChannel) return !1;
                        if (BroadcastChannel._pubkey) throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
                        return !0;
                    },
                    type: "native",
                    averageResponseTime: function() {
                        return 150;
                    },
                    microSeconds: g
                }, b = function() {
                    function e1(e1) {
                        this.ttl = e1, this.map = new Map, this._to = !1;
                    }
                    return e1.prototype.has = function(e1) {
                        return this.map.has(e1);
                    }, e1.prototype.add = function(e1) {
                        var t = this;
                        this.map.set(e1, k()), this._to || (this._to = !0, setTimeout(function() {
                            t._to = !1, function(e1) {
                                for(var t = k() - e1.ttl, n = e1.map[Symbol.iterator]();;){
                                    var r = n.next().value;
                                    if (!r) return;
                                    var o = r[0];
                                    if (!(r[1] < t)) return;
                                    e1.map.delete(o);
                                }
                            }(t);
                        }, 0));
                    }, e1.prototype.clear = function() {
                        this.map.clear();
                    }, e1;
                }();
                function k() {
                    return (new Date).getTime();
                }
                function w() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = JSON.parse(JSON.stringify(e1));
                    return void 0 === t.webWorkerSupport && (t.webWorkerSupport = !0), t.idb || (t.idb = {}), t.idb.ttl || (t.idb.ttl = 45e3), t.idb.fallbackInterval || (t.idb.fallbackInterval = 150), e1.idb && "function" == typeof e1.idb.onclose && (t.idb.onclose = e1.idb.onclose), t.localstorage || (t.localstorage = {}), t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 6e4), e1.methods && (t.methods = e1.methods), t.node || (t.node = {}), t.node.ttl || (t.node.ttl = 12e4), t.node.maxParallelWrites || (t.node.maxParallelWrites = 2048), void 0 === t.node.useFastPath && (t.node.useFastPath = !0), t;
                }
                var O = "messages", Z = {
                    durability: "relaxed"
                };
                function T() {
                    if ("undefined" != typeof indexedDB) return indexedDB;
                    if ("undefined" != typeof window) {
                        if (void 0 !== window.mozIndexedDB) return window.mozIndexedDB;
                        if (void 0 !== window.webkitIndexedDB) return window.webkitIndexedDB;
                        if (void 0 !== window.msIndexedDB) return window.msIndexedDB;
                    }
                    return !1;
                }
                function E(e1) {
                    e1.commit && e1.commit();
                }
                function S(e1) {
                    e1.closed || x(e1).then(function() {
                        return d(e1.options.idb.fallbackInterval);
                    }).then(function() {
                        return S(e1);
                    });
                }
                function x(e1) {
                    return e1.closed ? p : e1.messagesCallback ? (function(e1, t) {
                        var n = e1.transaction(O, "readonly", Z), r = n.objectStore(O), o = [], i = IDBKeyRange.bound(t + 1, 1 / 0);
                        if (r.getAll) {
                            var a = r.getAll(i);
                            return new Promise(function(e1, t) {
                                a.onerror = function(e1) {
                                    return t(e1);
                                }, a.onsuccess = function(t) {
                                    e1(t.target.result);
                                };
                            });
                        }
                        return new Promise(function(e1, a) {
                            var u = function() {
                                try {
                                    return i = IDBKeyRange.bound(t + 1, 1 / 0), r.openCursor(i);
                                } catch (e1) {
                                    return r.openCursor();
                                }
                            }();
                            u.onerror = function(e1) {
                                return a(e1);
                            }, u.onsuccess = function(r) {
                                var i = r.target.result;
                                i ? i.value.id < t + 1 ? i.continue(t + 1) : (o.push(i.value), i.continue()) : (E(n), e1(o));
                            };
                        });
                    })(e1.db, e1.lastCursorId).then(function(t) {
                        var n = t.filter(function(e1) {
                            return !!e1;
                        }).map(function(t) {
                            return t.id > e1.lastCursorId && (e1.lastCursorId = t.id), t;
                        }).filter(function(t) {
                            return function(e1, t) {
                                return !(e1.uuid === t.uuid || t.eMIs.has(e1.id) || e1.data.time < t.messagesCallbackTime);
                            }(t, e1);
                        }).sort(function(e1, t) {
                            return e1.time - t.time;
                        });
                        return n.forEach(function(t) {
                            e1.messagesCallback && (e1.eMIs.add(t.id), e1.messagesCallback(t.data));
                        }), p;
                    }) : p;
                }
                var P = {
                    create: function(e1, t) {
                        return t = w(t), (function(e1) {
                            var t = "pubkey.broadcast-channel-0-" + e1, n = T().open(t);
                            return n.onupgradeneeded = function(e1) {
                                e1.target.result.createObjectStore(O, {
                                    keyPath: "id",
                                    autoIncrement: !0
                                });
                            }, new Promise(function(e1, t) {
                                n.onerror = function(e1) {
                                    return t(e1);
                                }, n.onsuccess = function() {
                                    e1(n.result);
                                };
                            });
                        })(e1).then(function(n) {
                            var r = {
                                closed: !1,
                                lastCursorId: 0,
                                channelName: e1,
                                options: t,
                                uuid: h(),
                                eMIs: new b(2 * t.idb.ttl),
                                writeBlockPromise: p,
                                messagesCallback: null,
                                readQueuePromises: [],
                                db: n
                            };
                            return n.onclose = function() {
                                r.closed = !0, t.idb.onclose && t.idb.onclose();
                            }, S(r), r;
                        });
                    },
                    close: function(e1) {
                        e1.closed = !0, e1.db.close();
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t, x(e1);
                    },
                    postMessage: function(e1, t) {
                        return e1.writeBlockPromise = e1.writeBlockPromise.then(function() {
                            return function(e1, t, n) {
                                var r = {
                                    uuid: t,
                                    time: (new Date).getTime(),
                                    data: n
                                }, o = e1.transaction([
                                    O
                                ], "readwrite", Z);
                                return new Promise(function(e1, t) {
                                    o.oncomplete = function() {
                                        return e1();
                                    }, o.onerror = function(e1) {
                                        return t(e1);
                                    }, o.objectStore(O).add(r), E(o);
                                });
                            }(e1.db, e1.uuid, t);
                        }).then(function() {
                            0 === Math.floor(11 * Math.random() + 0) && function(e1) {
                                var t, n, r, o, i, a;
                                return (t = e1.db, n = e1.options.idb.ttl, r = (new Date).getTime() - n, o = t.transaction(O, "readonly", Z), i = o.objectStore(O), a = [], new Promise(function(e1) {
                                    i.openCursor().onsuccess = function(t) {
                                        var n = t.target.result;
                                        if (n) {
                                            var i = n.value;
                                            i.time < r ? (a.push(i), n.continue()) : (E(o), e1(a));
                                        } else e1(a);
                                    };
                                })).then(function(t) {
                                    return function(e1, t) {
                                        if (e1.closed) return Promise.resolve([]);
                                        var n = e1.db.transaction(O, "readwrite", Z).objectStore(O);
                                        return Promise.all(t.map(function(e1) {
                                            var t = n.delete(e1);
                                            return new Promise(function(e1) {
                                                t.onsuccess = function() {
                                                    return e1();
                                                };
                                            });
                                        }));
                                    }(e1, t.map(function(e1) {
                                        return e1.id;
                                    }));
                                });
                            }(e1);
                        }), e1.writeBlockPromise;
                    },
                    canBeUsed: function() {
                        return !!T();
                    },
                    type: "idb",
                    averageResponseTime: function(e1) {
                        return 2 * e1.idb.fallbackInterval;
                    },
                    microSeconds: g
                };
                function A() {
                    var e1;
                    if ("undefined" == typeof window) return null;
                    try {
                        e1 = window.localStorage, e1 = window["ie8-eventlistener/storage"] || window.localStorage;
                    } catch (e1) {}
                    return e1;
                }
                function R(e1) {
                    return "pubkey.broadcastChannel-" + e1;
                }
                function _() {
                    var e1 = A();
                    if (!e1) return !1;
                    try {
                        var t = "__broadcastchannel_check";
                        e1.setItem(t, "works"), e1.removeItem(t);
                    } catch (e1) {
                        return !1;
                    }
                    return !0;
                }
                var j = {
                    create: function(e1, t) {
                        if (t = w(t), !_()) throw new Error("BroadcastChannel: localstorage cannot be used");
                        var n = h(), r = new b(t.localstorage.removeTimeout), o = {
                            channelName: e1,
                            uuid: n,
                            eMIs: r
                        };
                        return o.listener = function(e1, t) {
                            var i = R(e1), a = function(e1) {
                                var t;
                                e1.key === i && (t = JSON.parse(e1.newValue), o.messagesCallback && t.uuid !== n && t.token && !r.has(t.token) && (t.data.time && t.data.time < o.messagesCallbackTime || (r.add(t.token), o.messagesCallback(t.data))));
                            };
                            return window.addEventListener("storage", a), a;
                        }(e1), o;
                    },
                    close: function(e1) {
                        var t;
                        t = e1.listener, window.removeEventListener("storage", t);
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            d().then(function() {
                                var r = R(e1.channelName), o = {
                                    token: h(),
                                    time: (new Date).getTime(),
                                    data: t,
                                    uuid: e1.uuid
                                }, i = JSON.stringify(o);
                                A().setItem(r, i);
                                var a = document.createEvent("Event");
                                a.initEvent("storage", !0, !0), a.key = r, a.newValue = i, window.dispatchEvent(a), n();
                            });
                        });
                    },
                    canBeUsed: _,
                    type: "localstorage",
                    averageResponseTime: function() {
                        var e1 = navigator.userAgent.toLowerCase();
                        return e1.includes("safari") && !e1.includes("chrome") ? 240 : 120;
                    },
                    microSeconds: g
                }, C = g, I = new Set, D = {
                    create: function(e1) {
                        var t = {
                            name: e1,
                            messagesCallback: null
                        };
                        return I.add(t), t;
                    },
                    close: function(e1) {
                        I.delete(e1);
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            return setTimeout(function() {
                                Array.from(I).filter(function(t) {
                                    return t.name === e1.name;
                                }).filter(function(t) {
                                    return t !== e1;
                                }).filter(function(e1) {
                                    return !!e1.messagesCallback;
                                }).forEach(function(e1) {
                                    return e1.messagesCallback(t);
                                }), n();
                            }, 5);
                        });
                    },
                    canBeUsed: function() {
                        return !0;
                    },
                    type: "simulate",
                    averageResponseTime: function() {
                        return 5;
                    },
                    microSeconds: C
                }, M = [
                    m,
                    P,
                    j
                ], N = new Set, U = 0, L = function(e1, t) {
                    var n, r, o;
                    this.id = U++, N.add(this), this.name = e1, this.options = w(t), this.method = function(e1) {
                        var t = [].concat(e1.methods, M).filter(Boolean);
                        if (e1.type) {
                            if ("simulate" === e1.type) return D;
                            var n = t.find(function(t) {
                                return t.type === e1.type;
                            });
                            if (n) return n;
                            throw new Error("method-type " + e1.type + " not found");
                        }
                        e1.webWorkerSupport || (t = t.filter(function(e1) {
                            return "idb" !== e1.type;
                        }));
                        var r = t.find(function(e1) {
                            return e1.canBeUsed();
                        });
                        if (r) return r;
                        throw new Error("No usable method found in " + JSON.stringify(M.map(function(e1) {
                            return e1.type;
                        })));
                    }(this.options), this._iL = !1, this._onML = null, this._addEL = {
                        message: [],
                        internal: []
                    }, this._uMP = new Set, this._befC = [], this._prepP = null, (o = r = (n = this).method.create(n.name, n.options)) && "function" == typeof o.then ? (n._prepP = r, r.then(function(e1) {
                        n._state = e1;
                    })) : n._state = r;
                };
                function H(e1, t, n) {
                    var r = {
                        time: e1.method.microSeconds(),
                        type: t,
                        data: n
                    };
                    return (e1._prepP ? e1._prepP : p).then(function() {
                        var t = e1.method.postMessage(e1._state, r);
                        return e1._uMP.add(t), t.catch().then(function() {
                            return e1._uMP.delete(t);
                        }), t;
                    });
                }
                function B(e1) {
                    return e1._addEL.message.length > 0 || e1._addEL.internal.length > 0;
                }
                function K(e1, t, n) {
                    e1._addEL[t].push(n), function(e1) {
                        if (!e1._iL && B(e1)) {
                            var t = function(t) {
                                e1._addEL[t.type].forEach(function(e1) {
                                    var n = e1.time - 1e5;
                                    t.time >= n && e1.fn(t.data);
                                });
                            }, n = e1.method.microSeconds();
                            e1._prepP ? e1._prepP.then(function() {
                                e1._iL = !0, e1.method.onMessage(e1._state, t, n);
                            }) : (e1._iL = !0, e1.method.onMessage(e1._state, t, n));
                        }
                    }(e1);
                }
                function F(e1, t, n) {
                    e1._addEL[t] = e1._addEL[t].filter(function(e1) {
                        return e1 !== n;
                    }), function(e1) {
                        if (e1._iL && !B(e1)) {
                            e1._iL = !1;
                            var t = e1.method.microSeconds();
                            e1.method.onMessage(e1._state, null, t);
                        }
                    }(e1);
                }
                L._pubkey = !0, L.prototype = {
                    postMessage: function(e1) {
                        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + JSON.stringify(e1));
                        return H(this, "message", e1);
                    },
                    postInternal: function(e1) {
                        return H(this, "internal", e1);
                    },
                    set onmessage (e){
                        var t1 = {
                            time: this.method.microSeconds(),
                            fn: e
                        };
                        F(this, "message", this._onML), e && "function" == typeof e ? (this._onML = t1, K(this, "message", t1)) : this._onML = null;
                    },
                    addEventListener: function(e1, t) {
                        K(this, e1, {
                            time: this.method.microSeconds(),
                            fn: t
                        });
                    },
                    removeEventListener: function(e1, t) {
                        F(this, e1, this._addEL[e1].find(function(e1) {
                            return e1.fn === t;
                        }));
                    },
                    close: function() {
                        var e1 = this;
                        if (!this.closed) {
                            N.delete(this), this.closed = !0;
                            var t = this._prepP ? this._prepP : p;
                            return this._onML = null, this._addEL.message = [], t.then(function() {
                                return Promise.all(Array.from(e1._uMP));
                            }).then(function() {
                                return Promise.all(e1._befC.map(function(e1) {
                                    return e1();
                                }));
                            }).then(function() {
                                return e1.method.close(e1._state);
                            });
                        }
                    },
                    get type () {
                        return this.method.type;
                    },
                    get isClosed () {
                        return this.closed;
                    }
                };
                var G = "[object process]" === Object.prototype.toString.call("undefined" != typeof process ? process : 0) ? function(e1) {
                    process.on("exit", function() {
                        return e1();
                    }), process.on("beforeExit", function() {
                        return e1().then(function() {
                            return process.exit();
                        });
                    }), process.on("SIGINT", function() {
                        return e1().then(function() {
                            return process.exit();
                        });
                    }), process.on("uncaughtException", function(t) {
                        return e1().then(function() {
                            console.trace(t), process.exit(101);
                        });
                    });
                } : function(e1) {
                    if ("function" == typeof WorkerGlobalScope && self instanceof WorkerGlobalScope) {
                        var t = self.close.bind(self);
                        self.close = function() {
                            return e1(), t();
                        };
                    } else {
                        if ("function" != typeof window.addEventListener) return;
                        window.addEventListener("beforeunload", function() {
                            e1();
                        }, !0), window.addEventListener("unload", function() {
                            e1();
                        }, !0);
                    }
                }, V = new Set, q = !1;
                function W() {
                    var e1 = [];
                    return V.forEach(function(t) {
                        e1.push(t()), V.delete(t);
                    }), Promise.all(e1);
                }
                function Y(e1, t) {
                    var n = {
                        context: "leader",
                        action: t,
                        token: e1.token
                    };
                    return e1.broadcastChannel.postInternal(n);
                }
                function z(e1) {
                    e1.isLeader = !0, e1._hasLeader = !0;
                    var t = function(e1) {
                        if (q || (q = !0, G(W)), "function" != typeof e1) throw new Error("Listener is no function");
                        return V.add(e1), {
                            remove: function() {
                                return V.delete(e1);
                            },
                            run: function() {
                                return V.delete(e1), e1();
                            }
                        };
                    }(function() {
                        return e1.die();
                    });
                    e1._unl.push(t);
                    var n = function(t) {
                        "leader" === t.context && "apply" === t.action && Y(e1, "tell"), "leader" !== t.context || "tell" !== t.action || e1._dpLC || (e1._dpLC = !0, e1._dpL(), Y(e1, "tell"));
                    };
                    return e1.broadcastChannel.addEventListener("internal", n), e1._lstns.push(n), Y(e1, "tell");
                }
                var Q = function(e1, t) {
                    var n = this;
                    this.broadcastChannel = e1, e1._befC.push(function() {
                        return n.die();
                    }), this._options = t, this.isLeader = !1, this.isDead = !1, this.token = h(), this._lstns = [], this._unl = [], this._dpL = function() {}, this._dpLC = !1, this._wKMC = {}, this.lN = "pubkey-bc||" + e1.method.type + "||" + e1.name;
                };
                Q.prototype = {
                    hasLeader: function() {
                        var e1 = this;
                        return navigator.locks.query().then(function(t) {
                            var n = t.held ? t.held.filter(function(t) {
                                return t.name === e1.lN;
                            }) : [];
                            return !!(n && n.length > 0);
                        });
                    },
                    awaitLeadership: function() {
                        var e1 = this;
                        if (!this._wLMP) {
                            this._wKMC.c = new AbortController;
                            var t = new Promise(function(t, n) {
                                e1._wKMC.res = t, e1._wKMC.rej = n;
                            });
                            this._wLMP = new Promise(function(n) {
                                navigator.locks.request(e1.lN, {
                                    signal: e1._wKMC.c.signal
                                }, function() {
                                    return e1._wKMC.c = void 0, z(e1), n(), t;
                                }).catch(function() {});
                            });
                        }
                        return this._wLMP;
                    },
                    set onduplicate (e){},
                    die: function() {
                        var e1 = this;
                        return this._lstns.forEach(function(t) {
                            return e1.broadcastChannel.removeEventListener("internal", t);
                        }), this._lstns = [], this._unl.forEach(function(e1) {
                            return e1.remove();
                        }), this._unl = [], this.isLeader && (this.isLeader = !1), this.isDead = !0, this._wKMC.res && this._wKMC.res(), this._wKMC.c && this._wKMC.c.abort("LeaderElectionWebLock.die() called"), Y(this, "death");
                    }
                };
                var X = function(e1, t) {
                    var n = this;
                    this.broadcastChannel = e1, this._options = t, this.isLeader = !1, this._hasLeader = !1, this.isDead = !1, this.token = h(), this._aplQ = p, this._aplQC = 0, this._unl = [], this._lstns = [], this._dpL = function() {}, this._dpLC = !1;
                    var r = function(e1) {
                        "leader" === e1.context && ("death" === e1.action && (n._hasLeader = !1), "tell" === e1.action && (n._hasLeader = !0));
                    };
                    this.broadcastChannel.addEventListener("internal", r), this._lstns.push(r);
                };
                function J(e1, t) {
                    if (e1._leaderElector) throw new Error("BroadcastChannel already has a leader-elector");
                    t = function(e1, t) {
                        return e1 || (e1 = {}), (e1 = JSON.parse(JSON.stringify(e1))).fallbackInterval || (e1.fallbackInterval = 3e3), e1.responseTime || (e1.responseTime = t.method.averageResponseTime(t.options)), e1;
                    }(t, e1);
                    var n = "undefined" != typeof navigator && void 0 !== navigator.locks && "function" == typeof navigator.locks.request ? new Q(e1, t) : new X(e1, t);
                    return e1._befC.push(function() {
                        return n.die();
                    }), e1._leaderElector = n, n;
                }
                X.prototype = {
                    hasLeader: function() {
                        return Promise.resolve(this._hasLeader);
                    },
                    applyOnce: function(e1) {
                        var t = this;
                        return this.isLeader ? d(0, !0) : this.isDead ? d(0, !1) : this._aplQC > 1 ? this._aplQ : (this._aplQC = this._aplQC + 1, this._aplQ = this._aplQ.then(function() {
                            return function() {
                                if (t.isLeader) return l;
                                var n, r = !1, o = new Promise(function(e1) {
                                    n = function() {
                                        r = !0, e1();
                                    };
                                }), i = function(e1) {
                                    "leader" === e1.context && e1.token != t.token && ("apply" === e1.action && e1.token > t.token && n(), "tell" === e1.action && (n(), t._hasLeader = !0));
                                };
                                t.broadcastChannel.addEventListener("internal", i);
                                var a = e1 ? 4 * t._options.responseTime : t._options.responseTime;
                                return Y(t, "apply").then(function() {
                                    return Promise.race([
                                        d(a),
                                        o.then(function() {
                                            return Promise.reject(new Error);
                                        })
                                    ]);
                                }).then(function() {
                                    return Y(t, "apply");
                                }).then(function() {
                                    return Promise.race([
                                        d(a),
                                        o.then(function() {
                                            return Promise.reject(new Error);
                                        })
                                    ]);
                                }).catch(function() {}).then(function() {
                                    return t.broadcastChannel.removeEventListener("internal", i), !r && z(t).then(function() {
                                        return !0;
                                    });
                                });
                            }();
                        }).then(function() {
                            t._aplQC = t._aplQC - 1;
                        }), this._aplQ.then(function() {
                            return t.isLeader;
                        }));
                    },
                    awaitLeadership: function() {
                        var e1;
                        return this._aLP || (this._aLP = (e1 = this).isLeader ? p : new Promise(function(t) {
                            var n = !1;
                            function r() {
                                n || (n = !0, e1.broadcastChannel.removeEventListener("internal", o), t(!0));
                            }
                            e1.applyOnce().then(function() {
                                e1.isLeader && r();
                            }), function t() {
                                return d(e1._options.fallbackInterval).then(function() {
                                    if (!e1.isDead && !n) return e1.isLeader ? void r() : e1.applyOnce(!0).then(function() {
                                        e1.isLeader ? r() : t();
                                    });
                                });
                            }();
                            var o = function(t) {
                                "leader" === t.context && "death" === t.action && (e1._hasLeader = !1, e1.applyOnce().then(function() {
                                    e1.isLeader && r();
                                }));
                            };
                            e1.broadcastChannel.addEventListener("internal", o), e1._lstns.push(o);
                        })), this._aLP;
                    },
                    set onduplicate (e){
                        this._dpL = e;
                    },
                    die: function() {
                        var e1 = this;
                        return this._lstns.forEach(function(t) {
                            return e1.broadcastChannel.removeEventListener("internal", t);
                        }), this._lstns = [], this._unl.forEach(function(e1) {
                            return e1.remove();
                        }), this._unl = [], this.isLeader && (this._hasLeader = !1, this.isLeader = !1), this.isDead = !0, Y(this, "death");
                    }
                };
                var $ = n(415), ee = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "elector", void 0), (0, c.Z)(this, "started", !1), this.options = t, this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this), this.onLeader = this.onLeader.bind(this);
                    }
                    var t, n, r;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeaderDuplicate",
                            value: function() {}
                        },
                        {
                            key: "onLeader",
                            value: (r = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, null === (t = (n = this.options).onLeader) || void 0 === t ? void 0 : t.call(n);
                                        case 2:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return r.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.isLeader);
                            }
                        },
                        {
                            key: "hasLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.hasLeader);
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && (t = this.options.electionChannelName, this.channel = new L(t), this.elector = J(this.channel), this.elector.onduplicate = this.onLeaderDuplicate, this.elector.awaitLeadership().then(this.onLeader), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!this.elector) {
                                                e1.next = 5;
                                                break;
                                            }
                                            return e1.next = 4, this.elector.die();
                                        case 4:
                                            this.elector = void 0;
                                        case 5:
                                            if (!this.channel) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.channel.postInternal = function() {
                                                return Promise.resolve();
                                            }, e1.next = 9, this.channel.close();
                                        case 9:
                                            this.channel = void 0;
                                        case 10:
                                            this.started = !1;
                                        case 11:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return (0, $.isBrowser)() && !this.started;
                            }
                        }
                    ]), e1;
                }(), te = n(9123), ne = n(6488), re = n(7088), oe = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "renewTimeQueue", void 0), (0, c.Z)(this, "started", !1), this.tokenManager = t, this.options = n, this.renewTimeQueue = [], this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "shouldThrottleRenew",
                            value: function() {
                                var e1 = !1;
                                if (this.renewTimeQueue.push(Date.now()), this.renewTimeQueue.length >= 10) {
                                    var t = this.renewTimeQueue.shift();
                                    e1 = this.renewTimeQueue[this.renewTimeQueue.length - 1] - t < 3e4;
                                }
                                return e1;
                            }
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !!this.options.syncStorage && (0, $.isBrowser)();
                            }
                        },
                        {
                            key: "processExpiredTokens",
                            value: function() {
                                var e1 = this, t = this.tokenManager.getStorage().getStorage();
                                Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    !(0, ne.z9)(r) && e1.tokenManager.hasExpired(r) && e1.onTokenExpiredHandler(n);
                                });
                            }
                        },
                        {
                            key: "onTokenExpiredHandler",
                            value: function(e1) {
                                if (this.options.autoRenew) {
                                    if (this.shouldThrottleRenew()) {
                                        var t = new te.Z("Too many token renew requests");
                                        this.tokenManager.emitError(t);
                                    } else this.tokenManager.renew(e1).catch(function() {});
                                } else this.options.autoRemove && this.tokenManager.remove(e1);
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !(!this.options.autoRenew && !this.options.autoRemove || this.started);
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && (this.tokenManager.on(re.$Y, this.onTokenExpiredHandler), this.tokenManager.isStarted() && this.processExpiredTokens(), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.started && (this.tokenManager.off(re.$Y, this.onTokenExpiredHandler), this.renewTimeQueue = [], this.started = !1);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        }
                    ]), e1;
                }(), ie = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "enablePostMessage", !0), this.tokenManager = t, this.options = n, this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this), this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this), this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this), this.onSetStorageHandler = this.onSetStorageHandler.bind(this), this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !!this.options.syncStorage && (0, $.isBrowser)() && !this.started;
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (this.canStart()) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            t = this.options.syncChannelName, e1.prev = 3, this.channel = new L(t), e1.next = 10;
                                            break;
                                        case 7:
                                            throw e1.prev = 7, e1.t0 = e1.catch(3), new te.Z("SyncStorageService is not supported in current browser.");
                                        case 10:
                                            this.tokenManager.on(re.O3, this.onTokenAddedHandler), this.tokenManager.on(re.FT, this.onTokenRemovedHandler), this.tokenManager.on(re.E, this.onTokenRenewedHandler), this.tokenManager.on(re.zr, this.onSetStorageHandler), this.channel.addEventListener("message", this.onSyncMessageHandler), this.started = !0;
                                        case 16:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        3,
                                        7
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.tokenManager.off(re.O3, this.onTokenAddedHandler), this.tokenManager.off(re.FT, this.onTokenRemovedHandler), this.tokenManager.off(re.E, this.onTokenRenewedHandler), this.tokenManager.off(re.zr, this.onSetStorageHandler), null === (t = this.channel) || void 0 === t || t.removeEventListener("message", this.onSyncMessageHandler), e1.next = 8, null === (n = this.channel) || void 0 === n ? void 0 : n.close();
                                        case 8:
                                            this.channel = void 0, this.started = !1;
                                        case 10:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "onTokenAddedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: re.O3,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRemovedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: re.FT,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRenewedHandler",
                            value: function(e1, t, n) {
                                var r;
                                this.enablePostMessage && (null === (r = this.channel) || void 0 === r || r.postMessage({
                                    type: re.E,
                                    key: e1,
                                    token: t,
                                    oldToken: n
                                }));
                            }
                        },
                        {
                            key: "onSetStorageHandler",
                            value: function(e1) {
                                var t;
                                null === (t = this.channel) || void 0 === t || t.postMessage({
                                    type: re.zr,
                                    storage: e1
                                });
                            }
                        },
                        {
                            key: "onSyncMessageHandler",
                            value: function(e1) {
                                switch(this.enablePostMessage = !1, e1.type){
                                    case re.zr:
                                        this.tokenManager.getStorage().setStorage(e1.storage);
                                        break;
                                    case re.O3:
                                        this.tokenManager.emitAdded(e1.key, e1.token), this.tokenManager.setExpireEventTimeout(e1.key, e1.token);
                                        break;
                                    case re.FT:
                                        this.tokenManager.clearExpireEventTimeout(e1.key), this.tokenManager.emitRemoved(e1.key, e1.token);
                                        break;
                                    case re.E:
                                        this.tokenManager.emitRenewed(e1.key, e1.token, e1.oldToken);
                                }
                                this.enablePostMessage = !0;
                            }
                        }
                    ]), e1;
                }(), ae = function() {
                    return Math.floor(Date.now() / 1e3);
                }, ue = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "lastHidden", -1), (0, c.Z)(this, "onPageVisbilityChange", void 0), this.tokenManager = t, this.options = n, this.onPageVisbilityChange = this._onPageVisbilityChange.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "_onPageVisbilityChange",
                            value: function() {
                                if (document.hidden) this.lastHidden = ae();
                                else if (this.lastHidden > 0 && ae() - this.lastHidden >= this.options.tabInactivityDuration) {
                                    var e1 = this.tokenManager.getTokensSync(), t = e1.accessToken, n = e1.idToken;
                                    if (t && this.tokenManager.hasExpired(t)) {
                                        var r = this.tokenManager.getStorageKeyByType("accessToken");
                                        this.tokenManager.renew(r).catch(function() {});
                                    } else if (n && this.tokenManager.hasExpired(n)) {
                                        var o = this.tokenManager.getStorageKeyByType("idToken");
                                        this.tokenManager.renew(o).catch(function() {});
                                    }
                                }
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && document && (document.addEventListener("visibilitychange", this.onPageVisbilityChange), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            document && (document.removeEventListener("visibilitychange", this.onPageVisbilityChange), this.started = !1);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return (0, $.isBrowser)() && !!this.options.autoRenew && !!this.options.renewOnTabActivation && !this.started;
                            }
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        }
                    ]), e1;
                }(), ce = n(3193);
                function se(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function fe(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? se(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : se(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function le(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return pe(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? pe(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function pe(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var de = "autoRenew", he = "syncStorage", ve = "leaderElection", ye = "renewOnTabActivation", ge = function() {
                    function e1(t) {
                        var n = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "sdk", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "services", void 0), (0, c.Z)(this, "started", void 0), this.sdk = t, this.onLeader = this.onLeader.bind(this);
                        var o = t.tokenManager.getOptions(), i = o.autoRenew, u = o.autoRemove, s = o.syncStorage;
                        r.electionChannelName = r.electionChannelName || r.broadcastChannelName, this.options = Object.assign({}, e1.defaultOptions, {
                            autoRenew: i,
                            autoRemove: u,
                            syncStorage: s
                        }, {
                            electionChannelName: "".concat(t.options.clientId, "-election"),
                            syncChannelName: "".concat(t.options.clientId, "-sync")
                        }, (0, ce.YY)(r)), this.started = !1, this.services = new Map, e1.knownServices.forEach(function(e1) {
                            var t = n.createService(e1);
                            t && n.services.set(e1, t);
                        });
                    }
                    var t, n, s, l, p;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeader",
                            value: (p = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 3;
                                                break;
                                            }
                                            return e1.next = 3, this.startServices();
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return p.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return null === (e1 = this.getService(ve)) || void 0 === e1 ? void 0 : e1.isLeader();
                            }
                        },
                        {
                            key: "isLeaderRequired",
                            value: function() {
                                return (0, o.Z)(this.services.values()).some(function(e1) {
                                    return e1.canStart() && e1.requiresLeadership();
                                });
                            }
                        },
                        {
                            key: "start",
                            value: (l = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            return e1.next = 4, this.startServices();
                                        case 4:
                                            this.started = !0;
                                        case 5:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return l.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (s = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, this.stopServices();
                                        case 2:
                                            this.started = !1;
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return s.apply(this, arguments);
                            })
                        },
                        {
                            key: "getService",
                            value: function(e1) {
                                return this.services.get(e1);
                            }
                        },
                        {
                            key: "startServices",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t, n, o, i, a;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = le(this.services.entries()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 10;
                                                break;
                                            }
                                            if (o = (0, r.Z)(n.value, 2), i = o[0], a = o[1], !this.canStartService(i, a)) {
                                                e1.next = 8;
                                                break;
                                            }
                                            return e1.next = 8, a.start();
                                        case 8:
                                            e1.next = 3;
                                            break;
                                        case 10:
                                            e1.next = 15;
                                            break;
                                        case 12:
                                            e1.prev = 12, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 15:
                                            return e1.prev = 15, t.f(), e1.finish(15);
                                        case 18:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        12,
                                        15,
                                        18
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stopServices",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n, r;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = le(this.services.values()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 9;
                                                break;
                                            }
                                            return r = n.value, e1.next = 7, r.stop();
                                        case 7:
                                            e1.next = 3;
                                            break;
                                        case 9:
                                            e1.next = 14;
                                            break;
                                        case 11:
                                            e1.prev = 11, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 14:
                                            return e1.prev = 14, t.f(), e1.finish(14);
                                        case 17:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        11,
                                        14,
                                        17
                                    ]
                                ]);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "canStartService",
                            value: function(e1, t) {
                                var n = t.canStart() && !t.isStarted();
                                return e1 === ve ? n && (n = this.isLeaderRequired()) : t.requiresLeadership() && n && (n = this.isLeader()), n;
                            }
                        },
                        {
                            key: "createService",
                            value: function(e1) {
                                var t, n = this.sdk.tokenManager;
                                switch(e1){
                                    case ve:
                                        t = new ee(fe(fe({}, this.options), {}, {
                                            onLeader: this.onLeader
                                        }));
                                        break;
                                    case de:
                                        t = new oe(n, fe({}, this.options));
                                        break;
                                    case he:
                                        t = new ie(n, fe({}, this.options));
                                        break;
                                    case ye:
                                        t = new ue(n, fe({}, this.options));
                                        break;
                                    default:
                                        throw new Error("Unknown service ".concat(e1));
                                }
                                return t;
                            }
                        }
                    ]), e1;
                }();
                (0, c.Z)(ge, "knownServices", [
                    de,
                    he,
                    ve,
                    ye
                ]), (0, c.Z)(ge, "defaultOptions", {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0,
                    renewOnTabActivation: !0,
                    tabInactivityDuration: 1800
                });
            },
            6599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return r.W;
                    }
                });
                var r = n(7145);
            },
            1578: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return s;
                    }
                });
                var r = n(9893), o = n(265), i = n(279), a = n(2724), u = n(8386), c = n(3980);
                function s(e1, t, n) {
                    var s = (0, r.a)(t), f = (0, o.H)(s, e1), l = (0, i.A)(f), p = (0, c.Z)(l), d = (0, a.J)(p, n);
                    return (0, u.i)(d);
                }
            },
            3961: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthStateManager: function() {
                        return r.E;
                    },
                    INITIAL_AUTH_STATE: function() {
                        return r.a;
                    },
                    ServiceManager: function() {
                        return l.W;
                    },
                    createCoreOptionsConstructor: function() {
                        return o.n;
                    },
                    createCoreStorageManager: function() {
                        return u.a;
                    },
                    createOktaAuthCore: function() {
                        return i.K;
                    },
                    mixinCore: function() {
                        return a.i;
                    }
                });
                var r = n(1018), o = n(9133), i = n(1578), a = n(8386), u = n(2647), c = n(8553), s = {};
                for(var f in c)[
                    "default",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "createCoreOptionsConstructor",
                    "createOktaAuthCore",
                    "mixinCore",
                    "createCoreStorageManager"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(6599);
            },
            8386: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    i: function() {
                        return y;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(5372), h = n(1018), v = n(7145);
                function y(e1) {
                    return function(e1) {
                        (0, u.Z)(k, e1);
                        var t, n, l, y, g, m, b = (g = k, m = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, s.Z)(g);
                            if (m) {
                                var n = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function k() {
                            var e1;
                            (0, o.Z)(this, k);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = b.call.apply(b, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "authStateManager", void 0), (0, f.Z)((0, a.Z)(e1), "serviceManager", void 0), e1.authStateManager = new h.E((0, a.Z)(e1)), e1.serviceManager = new v.W((0, a.Z)(e1), e1.options.services), e1;
                        }
                        return (0, i.Z)(k, [
                            {
                                key: "start",
                                value: (y = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.serviceManager.start();
                                            case 2:
                                                if (this.tokenManager.start(), this.token.isLoginRedirect()) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                return e1.next = 6, this.authStateManager.updateAuthState();
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return y.apply(this, arguments);
                                })
                            },
                            {
                                key: "stop",
                                value: (l = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return this.tokenManager.stop(), e1.next = 3, this.serviceManager.stop();
                                            case 3:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return l.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleRedirect",
                                value: (n = (0, r.Z)(p().mark(function e1(t) {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.handleLoginRedirect(void 0, t);
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleLoginRedirect",
                                value: (t = (0, r.Z)(p().mark(function e1(t, n) {
                                    var r, o, i;
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (r = this.options.state, !t) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                this.tokenManager.setTokens(t), n = n || this.getOriginalUri(this.options.state), e1.next = 25;
                                                break;
                                            case 6:
                                                if (!this.isLoginRedirect()) {
                                                    e1.next = 24;
                                                    break;
                                                }
                                                return e1.prev = 7, e1.next = 10, (0, d.Tp)(this, {});
                                            case 10:
                                                return o = e1.sent, r = o.state, n = n || this.getOriginalUri(r), e1.next = 15, this.storeTokensFromRedirect();
                                            case 15:
                                                e1.next = 22;
                                                break;
                                            case 17:
                                                return e1.prev = 17, e1.t0 = e1.catch(7), e1.next = 21, this.authStateManager.updateAuthState();
                                            case 21:
                                                throw e1.t0;
                                            case 22:
                                                e1.next = 25;
                                                break;
                                            case 24:
                                                return e1.abrupt("return");
                                            case 25:
                                                return e1.next = 27, this.authStateManager.updateAuthState();
                                            case 27:
                                                if (this.removeOriginalUri(r), !(i = this.options.restoreOriginalUri)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                return e1.next = 32, i(this, n);
                                            case 32:
                                                e1.next = 35;
                                                break;
                                            case 34:
                                                n && window.location.replace(n);
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            7,
                                            17
                                        ]
                                    ]);
                                })), function(e1, n) {
                                    return t.apply(this, arguments);
                                })
                            }
                        ]), k;
                    }(e1);
                }
            },
            9133: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9453);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "services", void 0), (0, s.Z)((0, i.Z)(t), "transformAuthState", void 0), t.services = e1.services, t.transformAuthState = e1.transformAuthState, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.m)());
                }
            },
            2647: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return o;
                    }
                });
                var r = n(2333);
                function o() {
                    return (0, r.a)();
                }
            },
            5675: function() {},
            8553: function(e1, t, n) {
                "use strict";
                n.r(t);
                var r = n(5675), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            7987: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Df: function() {
                        return u;
                    },
                    EL: function() {
                        return f;
                    },
                    NL: function() {
                        return i;
                    },
                    Wy: function() {
                        return c;
                    },
                    aR: function() {
                        return a;
                    },
                    dX: function() {
                        return l;
                    },
                    k8: function() {
                        return s;
                    },
                    kQ: function() {
                        return p;
                    }
                });
                var r = n(9123), o = n(7594);
                function i(e1) {
                    return a((0, o.r3)(e1));
                }
                function a(e1) {
                    return e1.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
                }
                function u(e1) {
                    return e1.replace(/-/g, "+").replace(/_/g, "/");
                }
                function c(e1) {
                    var t = u(e1);
                    switch(t.length % 4){
                        case 0:
                            break;
                        case 2:
                            t += "==";
                            break;
                        case 3:
                            t += "=";
                            break;
                        default:
                            throw new r.Z("Not a valid Base64Url");
                    }
                    var n = (0, o.ty)(t);
                    try {
                        return decodeURIComponent(escape(n));
                    } catch (e1) {
                        return n;
                    }
                }
                function s(e1) {
                    for(var t = new Uint8Array(e1.length), n = 0; n < e1.length; n++)t[n] = e1.charCodeAt(n);
                    return t;
                }
                function f(e1) {
                    return (0, o.ty)(u(e1));
                }
                function l(e1) {
                    return Uint8Array.from(f(e1), function(e1) {
                        return e1.charCodeAt(0);
                    });
                }
                function p(e1) {
                    return (0, o.r3)(new Uint8Array(e1).reduce(function(e1, t) {
                        return e1 + String.fromCharCode(t);
                    }, ""));
                }
            },
            7594: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return i;
                    },
                    r3: function() {
                        return o;
                    },
                    ty: function() {
                        return r;
                    }
                });
                var r = function(e1) {
                    return atob(e1);
                }, o = function(e1) {
                    return btoa(e1);
                }, i = "undefined" == typeof crypto ? null : crypto;
            },
            9718: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    atob: function() {
                        return s.ty;
                    },
                    base64ToBase64Url: function() {
                        return r.aR;
                    },
                    base64UrlDecode: function() {
                        return r.EL;
                    },
                    base64UrlToBase64: function() {
                        return r.Df;
                    },
                    base64UrlToBuffer: function() {
                        return r.dX;
                    },
                    base64UrlToString: function() {
                        return r.Wy;
                    },
                    btoa: function() {
                        return s.r3;
                    },
                    bufferToBase64Url: function() {
                        return r.kQ;
                    },
                    getOidcHash: function() {
                        return o.X;
                    },
                    stringToBase64Url: function() {
                        return r.NL;
                    },
                    stringToBuffer: function() {
                        return r.k8;
                    },
                    verifyToken: function() {
                        return c.W;
                    },
                    webcrypto: function() {
                        return s.KP;
                    }
                });
                var r = n(7987), o = n(5698), i = n(6332), a = {};
                for(var u in i)[
                    "default",
                    "base64ToBase64Url",
                    "base64UrlDecode",
                    "base64UrlToBase64",
                    "base64UrlToBuffer",
                    "base64UrlToString",
                    "bufferToBase64Url",
                    "stringToBase64Url",
                    "stringToBuffer",
                    "getOidcHash"
                ].indexOf(u) < 0 && (a[u] = (function(e1) {
                    return i[e1];
                }).bind(0, u));
                n.d(t, a);
                var c = n(3154), s = n(1);
            },
            5698: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return i;
                    }
                });
                var r = n(7987), o = n(7594);
                function i(e1) {
                    var t = (new TextEncoder).encode(e1);
                    return o.KP.subtle.digest("SHA-256", t).then(function(e1) {
                        var t = new Uint8Array(e1).slice(0, 16), n = String.fromCharCode.apply(null, t);
                        return (0, r.NL)(n);
                    });
                }
            },
            6332: function() {},
            3154: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(7987), i = n(7594);
                function a(e1, t) {
                    t = (0, r.d9)(t);
                    var n = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: {
                            name: "SHA-256"
                        }
                    };
                    return delete t.use, i.KP.subtle.importKey("jwk", t, n, !0, [
                        "verify"
                    ]).then(function(t) {
                        var r = e1.split("."), a = (0, o.k8)(r[0] + "." + r[1]), u = (0, o.EL)(r[2]), c = (0, o.k8)(u);
                        return i.KP.subtle.verify(n, t, c, a);
                    });
                }
            },
            1: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return r.KP;
                    },
                    r3: function() {
                        return r.r3;
                    },
                    ty: function() {
                        return r.ty;
                    }
                });
                var r = n(7594);
            },
            3983: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t, n) {
                        var r;
                        (0, o.Z)(this, l);
                        var a = e1.errorSummary;
                        return r = f.call(this, a), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorLink", void 0), (0, s.Z)((0, i.Z)(r), "errorId", void 0), (0, s.Z)((0, i.Z)(r), "errorCauses", void 0), (0, s.Z)((0, i.Z)(r), "xhr", void 0), (0, s.Z)((0, i.Z)(r), "meta", void 0), r.name = "AuthApiError", r.errorSummary = e1.errorSummary, r.errorCode = e1.errorCode, r.errorLink = e1.errorLink, r.errorId = e1.errorId, r.errorCauses = e1.errorCauses, t && (r.xhr = t), n && (r.meta = n), r;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6573: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return c;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120);
                var c = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.call(this, "The poll was stopped by the sdk");
                    }
                    return (0, r.Z)(s);
                }(n(6245).Z);
            },
            9123: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, o.Z)(this, l), n = f.call(this, e1), (0, s.Z)((0, i.Z)(n), "errorSummary", void 0), (0, s.Z)((0, i.Z)(n), "errorCode", void 0), (0, s.Z)((0, i.Z)(n), "errorLink", void 0), (0, s.Z)((0, i.Z)(n), "errorId", void 0), (0, s.Z)((0, i.Z)(n), "errorCauses", void 0), (0, s.Z)((0, i.Z)(n), "xhr", void 0), n.name = "AuthSdkError", n.errorCode = "INTERNAL", n.errorSummary = e1, n.errorLink = "INTERNAL", n.errorId = "INTERNAL", n.errorCauses = [], t && (n.xhr = t), n;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6245: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return p;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(9611);
                function f(e1, t, n) {
                    return f = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }() ? Reflect.construct.bind() : function(e1, t, n) {
                        var r = [
                            null
                        ];
                        r.push.apply(r, t);
                        var o = new (Function.bind.apply(e1, r));
                        return n && (0, s.Z)(o, n.prototype), o;
                    }, f.apply(null, arguments);
                }
                function l(e1) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return l = function(e1) {
                        if (null === e1 || (n = e1, -1 === Function.toString.call(n).indexOf("[native code]"))) return e1;
                        var n;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e1)) return t.get(e1);
                            t.set(e1, r);
                        }
                        function r() {
                            return f(e1, arguments, (0, c.Z)(this).constructor);
                        }
                        return r.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: r,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), (0, s.Z)(r, e1);
                    }, l(e1);
                }
                var p = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t;
                        return (0, o.Z)(this, f), t = s.call(this, e1), Object.setPrototypeOf((0, i.Z)(t), (this instanceof f ? this.constructor : void 0).prototype), t;
                    }
                    return (0, r.Z)(f);
                }(l(Error));
            },
            2886: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t, n) {
                        var r;
                        return (0, o.Z)(this, l), r = f.call(this, t), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "error", void 0), (0, s.Z)((0, i.Z)(r), "error_description", void 0), (0, s.Z)((0, i.Z)(r), "resp", null), r.name = "OAuthError", r.errorCode = e1, r.errorSummary = t, r.error = e1, r.error_description = t, n && (r.resp = n), r;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            3114: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(6245), l = n(4771);
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p(e1, t, n) {
                        var o, a;
                        return (0, r.Z)(this, p), a = f.call(this, null !== (o = t.error) && void 0 !== o ? o : p.UNKNOWN_ERROR), (0, s.Z)((0, i.Z)(a), "scheme", void 0), (0, s.Z)((0, i.Z)(a), "parameters", void 0), (0, s.Z)((0, i.Z)(a), "name", "WWWAuthError"), (0, s.Z)((0, i.Z)(a), "resp", null), a.scheme = e1, a.parameters = t, n && (a.resp = n), a;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "error",
                            get: function() {
                                return this.parameters.error;
                            }
                        },
                        {
                            key: "errorCode",
                            get: function() {
                                return this.error;
                            }
                        },
                        {
                            key: "error_description",
                            get: function() {
                                return this.parameters.error_description;
                            }
                        },
                        {
                            key: "errorDescription",
                            get: function() {
                                return this.error_description;
                            }
                        },
                        {
                            key: "errorSummary",
                            get: function() {
                                return this.errorDescription;
                            }
                        },
                        {
                            key: "realm",
                            get: function() {
                                return this.parameters.realm;
                            }
                        }
                    ], [
                        {
                            key: "parseHeader",
                            value: function(e1) {
                                if (!e1) return null;
                                for(var t, n = /(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g, r = e1.indexOf(" "), o = e1.slice(0, r), i = e1.slice(r + 1), a = {}; null !== (t = n.exec(i));){
                                    var u;
                                    a[t[1]] = null !== (u = t[2]) && void 0 !== u ? u : t[3];
                                }
                                return new p(o, a);
                            }
                        },
                        {
                            key: "getWWWAuthenticateHeader",
                            value: function() {
                                var e1, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                return (0, l.mf)(null == t ? void 0 : t.get) ? t.get("WWW-Authenticate") : null !== (e1 = t["www-authenticate"]) && void 0 !== e1 ? e1 : t["WWW-Authenticate"];
                            }
                        }
                    ]), p;
                }(f.Z);
                (0, s.Z)(p, "UNKNOWN_ERROR", "UNKNOWN_WWW_AUTH_ERROR");
            },
            5728: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthApiError: function() {
                        return r.Z;
                    },
                    AuthPollStopError: function() {
                        return o.Z;
                    },
                    AuthSdkError: function() {
                        return i.Z;
                    },
                    OAuthError: function() {
                        return a.Z;
                    },
                    WWWAuthError: function() {
                        return u.Z;
                    },
                    isAuthApiError: function() {
                        return l;
                    },
                    isOAuthError: function() {
                        return p;
                    },
                    isWWWAuthError: function() {
                        return d;
                    }
                });
                var r = n(3983), o = n(6573), i = n(9123), a = n(2886), u = n(3114), c = n(1243), s = {};
                for(var f in c)[
                    "default",
                    "isAuthApiError",
                    "isOAuthError",
                    "isWWWAuthError",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError",
                    "WWWAuthError"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                function l(e1) {
                    return e1 instanceof r.Z;
                }
                function p(e1) {
                    return e1 instanceof a.Z;
                }
                function d(e1) {
                    return e1 instanceof u.Z;
                }
                n.d(t, s);
            },
            1243: function() {},
            6736: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return i.ACCESS_TOKEN_STORAGE_KEY;
                    },
                    BaseStorageManager: function() {
                        return d.W8;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return i.CACHE_STORAGE_NAME;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return i.DEFAULT_CACHE_DURATION;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return i.DEFAULT_CODE_CHALLENGE_METHOD;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return i.DEFAULT_MAX_CLOCK_SKEW;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return i.DEFAULT_POLLING_DELAY;
                    },
                    IDX_API_VERSION: function() {
                        return i.IDX_API_VERSION;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return i.IDX_RESPONSE_STORAGE_NAME;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return i.ID_TOKEN_STORAGE_KEY;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return i.MAX_VERIFIER_LENGTH;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return i.MIN_VERIFIER_LENGTH;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return i.ORIGINAL_URI_STORAGE_NAME;
                    },
                    OktaUserAgent: function() {
                        return f.ed;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return i.PKCE_STORAGE_NAME;
                    },
                    PromiseQueue: function() {
                        return h.bo;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return i.REFERRER_PATH_STORAGE_KEY;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return i.REFRESH_TOKEN_STORAGE_KEY;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return i.SHARED_TRANSACTION_STORAGE_NAME;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return i.STATE_TOKEN_KEY_NAME;
                    },
                    SavedObject: function() {
                        return d._e;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return i.TOKEN_STORAGE_NAME;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return i.TRANSACTION_STORAGE_NAME;
                    },
                    bind: function() {
                        return h.ak;
                    },
                    clone: function() {
                        return h.d9;
                    },
                    closeSession: function() {
                        return p.RJ;
                    },
                    createBaseOptionsConstructor: function() {
                        return o.X;
                    },
                    createHttpOptionsConstructor: function() {
                        return f.ZM;
                    },
                    createOktaAuthBase: function() {
                        return o.a;
                    },
                    createSessionApi: function() {
                        return p.MG;
                    },
                    createStorageOptionsConstructor: function() {
                        return d.Tp;
                    },
                    crypto: function() {
                        return r;
                    },
                    delay: function() {
                        return h.gw;
                    },
                    deprecate: function() {
                        return h.Rn;
                    },
                    deprecateWrap: function() {
                        return h.VA;
                    },
                    extend: function() {
                        return h.l7;
                    },
                    find: function() {
                        return h.sE;
                    },
                    genRandomString: function() {
                        return h.uh;
                    },
                    get: function() {
                        return f.U2;
                    },
                    getConsole: function() {
                        return h.dr;
                    },
                    getLink: function() {
                        return h.Rg;
                    },
                    getNativeConsole: function() {
                        return h.sW;
                    },
                    getSession: function() {
                        return p.Gg;
                    },
                    httpRequest: function() {
                        return f.c3;
                    },
                    isAbsoluteUrl: function() {
                        return h.sD;
                    },
                    isFunction: function() {
                        return h.mf;
                    },
                    isNumber: function() {
                        return h.hj;
                    },
                    isObject: function() {
                        return h.Kn;
                    },
                    isPromise: function() {
                        return h.tI;
                    },
                    isString: function() {
                        return h.HD;
                    },
                    isoToUTCString: function() {
                        return h.ng;
                    },
                    logServerSideMemoryStorageWarning: function() {
                        return d.Vp;
                    },
                    mixinHttp: function() {
                        return f.Am;
                    },
                    mixinSession: function() {
                        return p.Zg;
                    },
                    mixinStorage: function() {
                        return d.Ho;
                    },
                    omit: function() {
                        return h.CE;
                    },
                    post: function() {
                        return f.v_;
                    },
                    refreshSession: function() {
                        return p.dx;
                    },
                    removeNils: function() {
                        return h.YY;
                    },
                    removeTrailingSlash: function() {
                        return h.Qj;
                    },
                    sessionExists: function() {
                        return p.sH;
                    },
                    setCookieAndRedirect: function() {
                        return p.OT;
                    },
                    setRequestHeader: function() {
                        return f.rn;
                    },
                    split2: function() {
                        return h.YQ;
                    },
                    toAbsoluteUrl: function() {
                        return h.BY;
                    },
                    toQueryString: function() {
                        return h.UK;
                    },
                    toRelativeUrl: function() {
                        return h.QN;
                    },
                    warn: function() {
                        return h.ZK;
                    }
                });
                var r = n(9718), o = n(3306), i = n(1971), a = n(3961), u = {};
                for(var c in a)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return a[e1];
                }).bind(0, c));
                n.d(t, u);
                var s = n(5728);
                for(var c in u = {}, s)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return s[e1];
                }).bind(0, c));
                n.d(t, u);
                var f = n(4777), l = n(9443);
                for(var c in u = {}, l)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError",
                    "WWWAuthError",
                    "isAuthApiError",
                    "isOAuthError",
                    "isWWWAuthError",
                    "OktaUserAgent",
                    "createHttpOptionsConstructor",
                    "get",
                    "httpRequest",
                    "mixinHttp",
                    "post",
                    "setRequestHeader"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return l[e1];
                }).bind(0, c));
                n.d(t, u);
                var p = n(8041), d = n(9927), h = n(305);
            },
            415: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    getUserAgent: function() {
                        return u;
                    },
                    hasTextEncoder: function() {
                        return p;
                    },
                    isBrowser: function() {
                        return i;
                    },
                    isDPoPSupported: function() {
                        return y;
                    },
                    isFingerprintSupported: function() {
                        return c;
                    },
                    isHTTPS: function() {
                        return h;
                    },
                    isIE11OrLess: function() {
                        return a;
                    },
                    isLocalhost: function() {
                        return v;
                    },
                    isPKCESupported: function() {
                        return d;
                    },
                    isPopupPostMessageSupported: function() {
                        return s;
                    },
                    isTokenVerifySupported: function() {
                        return l;
                    }
                });
                var r = n(7594), o = /windows phone|iemobile|wpdesktop/i;
                function i() {
                    return "undefined" != typeof document && "undefined" != typeof window;
                }
                function a() {
                    if (!i()) return !1;
                    var e1 = document.documentMode;
                    return !!e1 && e1 <= 11;
                }
                function u() {
                    return navigator.userAgent;
                }
                function c() {
                    var e1 = u();
                    return e1 && !o.test(e1);
                }
                function s() {
                    if (!i()) return !1;
                    var e1 = document.documentMode, t = e1 && e1 < 10;
                    return void 0 !== window.postMessage && !t;
                }
                function f() {
                    return void 0 !== r.KP && null !== r.KP && void 0 !== r.KP.subtle && "undefined" != typeof Uint8Array;
                }
                function l() {
                    return f();
                }
                function p() {
                    return "undefined" != typeof TextEncoder;
                }
                function d() {
                    return l() && p();
                }
                function h() {
                    return !!i() && "https:" === window.location.protocol;
                }
                function v() {
                    return i() && "localhost" === window.location.hostname;
                }
                function y() {
                    return !a() && void 0 !== window.indexedDB && p() && f();
                }
            },
            287: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    e: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(415), u = function() {
                    function e1() {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "environments", void 0), this.environments = [
                            "okta-auth-js/".concat("7.8.1")
                        ], this.maybeAddNodeEnvironment();
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "addEnvironment",
                            value: function(e1) {
                                this.environments.push(e1);
                            }
                        },
                        {
                            key: "getHttpHeader",
                            value: function() {
                                return {
                                    "X-Okta-User-Agent-Extended": this.environments.join(" ")
                                };
                            }
                        },
                        {
                            key: "getVersion",
                            value: function() {
                                return "7.8.1";
                            }
                        },
                        {
                            key: "maybeAddNodeEnvironment",
                            value: function() {
                                if (!(0, a.isBrowser)() && process && process.versions) {
                                    var e1 = process.versions.node;
                                    this.environments.push("nodejs/".concat(e1));
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            2281: function(e1, t, n) {
                "use strict";
                function r(e1, t, n) {
                    e1.options.headers = e1.options.headers || {}, e1.options.headers[t] = n;
                }
                n.d(t, {
                    r: function() {
                        return r;
                    }
                });
            },
            4777: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Am: function() {
                        return a.A;
                    },
                    U2: function() {
                        return i.U2;
                    },
                    ZM: function() {
                        return u.Z;
                    },
                    c3: function() {
                        return i.c3;
                    },
                    ed: function() {
                        return o.e;
                    },
                    rn: function() {
                        return r.r;
                    },
                    v_: function() {
                        return i.v_;
                    }
                });
                var r = n(2281), o = n(287), i = n(5385), a = n(279), u = n(8817);
            },
            279: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(287), l = n(2281), p = n(6718), d = n(5385);
                function h(e1) {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, h = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v() {
                            var e1;
                            (0, r.Z)(this, v);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = h.call.apply(h, [
                                this
                            ].concat(n)), (0, s.Z)((0, i.Z)(e1), "_oktaUserAgent", void 0), (0, s.Z)((0, i.Z)(e1), "http", void 0), e1._oktaUserAgent = new f.e, e1.http = {
                                setRequestHeader: l.r.bind(null, (0, i.Z)(e1))
                            }, e1;
                        }
                        return (0, o.Z)(v, [
                            {
                                key: "setHeaders",
                                value: function(e1) {
                                    this.options.headers = Object.assign({}, this.options.headers, e1);
                                }
                            },
                            {
                                key: "getIssuerOrigin",
                                value: function() {
                                    return this.options.issuer.split("/oauth2/")[0];
                                }
                            },
                            {
                                key: "webfinger",
                                value: function(e1) {
                                    var t = "/.well-known/webfinger" + (0, p.UK)(e1);
                                    return (0, d.U2)(this, t, {
                                        headers: {
                                            Accept: "application/jrd+json"
                                        }
                                    });
                                }
                            }
                        ]), v;
                    }(e1);
                }
            },
            8817: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return m;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(3849), l = n(885), p = n(1002), d = n(4098), h = n.n(d);
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var y = /application\/\w*\+?json/, g = function(e1, t, r) {
                    var o = r.data, i = r.headers || {}, a = i["Content-Type"] || i["content-type"] || "";
                    o && "string" != typeof o && (y.test(a) ? o = JSON.stringify(o) : "application/x-www-form-urlencoded" === a && (o = Object.entries(o).map(function(e1) {
                        var t = (0, l.Z)(e1, 2), n = t[0], r = t[1];
                        return "".concat(n, "=").concat(encodeURIComponent(r));
                    }).join("&")));
                    var u = (n.g.fetch || h())(t, {
                        method: e1,
                        headers: r.headers,
                        body: o,
                        credentials: r.withCredentials ? "include" : "omit"
                    });
                    return u.finally || (u = Promise.resolve(u)), u.then(function(e1) {
                        var t = !e1.ok, n = e1.status;
                        return (function(e1) {
                            return e1.headers.get("Content-Type") && e1.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e1.json().catch(function(e1) {
                                return {
                                    error: e1,
                                    errorSummary: "Could not parse server response"
                                };
                            }) : e1.text();
                        })(e1).then(function(t) {
                            return function(e1, t, n) {
                                var r, o = "object" === (0, p.Z)(t), i = {}, a = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return v(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(n.headers.entries());
                                try {
                                    for(a.s(); !(r = a.n()).done;){
                                        var u = r.value;
                                        i[u[0]] = u[1];
                                    }
                                } catch (e1) {
                                    a.e(e1);
                                } finally{
                                    a.f();
                                }
                                var c = {
                                    responseText: o ? JSON.stringify(t) : t,
                                    status: e1,
                                    headers: i
                                };
                                return o && (c.responseType = "json", c.responseJSON = t), c;
                            }(n, t, e1);
                        }).then(function(e1) {
                            var n;
                            if (t || null !== (n = e1.responseJSON) && void 0 !== n && n.error) throw e1;
                            return e1;
                        });
                    });
                };
                function m() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "transformErrorXHR", void 0), (0, s.Z)((0, i.Z)(t), "headers", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestClient", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestInterceptors", void 0), t.issuer = e1.issuer, t.transformErrorXHR = e1.transformErrorXHR, t.headers = e1.headers, t.httpRequestClient = e1.httpRequestClient || g, t.httpRequestInterceptors = e1.httpRequestInterceptors, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.T)());
                }
            },
            5385: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U2: function() {
                        return g;
                    },
                    c3: function() {
                        return y;
                    },
                    v_: function() {
                        return m;
                    }
                });
                var r = n(1002), o = n(4942), i = n(4771), a = n(3193), u = n(6718), c = n(1971), s = n(3983), f = n(3114), l = n(2886);
                function p(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1, t) {
                    var n, r, o, u;
                    if (t instanceof Error) return new s.Z({
                        errorSummary: t.message
                    });
                    var c, p = t, d = {};
                    if (p.responseText && (0, i.HD)(p.responseText)) try {
                        d = JSON.parse(p.responseText);
                    } catch (e1) {
                        d = {
                            errorSummary: "Unknown error"
                        };
                    }
                    p.status >= 500 && (d.errorSummary = "Unknown error"), e1.options.transformErrorXHR && (p = e1.options.transformErrorXHR((0, a.d9)(p)));
                    var v = null !== (n = f.Z.getWWWAuthenticateHeader(null === (r = p) || void 0 === r ? void 0 : r.headers)) && void 0 !== n ? n : "";
                    if (c = d.error && d.error_description ? new l.Z(d.error, d.error_description, p) : new s.Z(d, p, {
                        wwwAuthHeader: v
                    }), v && (null === (o = p) || void 0 === o ? void 0 : o.status) >= 400 && (null === (u = p) || void 0 === u ? void 0 : u.status) < 500) {
                        var y = f.Z.parseHeader(v);
                        if (403 === p.status && "insufficient_authentication_context" === (null == y ? void 0 : y.error)) {
                            var g = y.parameters, m = g.max_age, b = g.acr_values;
                            c = new s.Z({
                                errorSummary: y.error,
                                errorCauses: [
                                    {
                                        errorSummary: y.errorDescription
                                    }
                                ]
                            }, p, h({
                                max_age: +m
                            }, b && {
                                acr_values: b
                            }));
                        } else "DPoP" === (null == y ? void 0 : y.scheme) && (c = y);
                    }
                    return c;
                };
                function y(e1, t) {
                    if (t = t || {}, e1.options.httpRequestInterceptors) {
                        var n, o = function(e1, t) {
                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                            if (!n) {
                                if (Array.isArray(e1) || (n = function(e1, t) {
                                    if (e1) {
                                        if ("string" == typeof e1) return p(e1, t);
                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e1, t) : void 0;
                                    }
                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                    n && (e1 = n);
                                    var r = 0, o = function() {};
                                    return {
                                        s: o,
                                        n: function() {
                                            return r >= e1.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e1[r++]
                                            };
                                        },
                                        e: function(e1) {
                                            throw e1;
                                        },
                                        f: o
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var i, a = !0, u = !1;
                            return {
                                s: function() {
                                    n = n.call(e1);
                                },
                                n: function() {
                                    var e1 = n.next();
                                    return a = e1.done, e1;
                                },
                                e: function(e1) {
                                    u = !0, i = e1;
                                },
                                f: function() {
                                    try {
                                        a || null == n.return || n.return();
                                    } finally{
                                        if (u) throw i;
                                    }
                                }
                            };
                        }(e1.options.httpRequestInterceptors);
                        try {
                            for(o.s(); !(n = o.n()).done;)(0, n.value)(t);
                        } catch (w) {
                            o.e(w);
                        } finally{
                            o.f();
                        }
                    }
                    var u = t.url, s = t.method, f = t.args, l = t.saveAuthnState, d = t.accessToken, y = !0 === t.withCredentials, g = e1.options.storageUtil.storage, m = e1.storageManager.getHttpCache(e1.options.cookies);
                    if (t.cacheResponse) {
                        var b = m.getStorage()[u];
                        if (b && Date.now() / 1e3 < b.expiresAt) return Promise.resolve(b.response);
                    }
                    var k = h({
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }, e1._oktaUserAgent.getHttpHeader());
                    Object.assign(k, e1.options.headers, t.headers), k = (0, a.YY)(k), d && (0, i.HD)(d) && (k.Authorization = "Bearer " + d);
                    var w, O, Z = {
                        headers: k,
                        data: f || void 0,
                        withCredentials: y
                    };
                    return e1.options.httpRequestClient(s, u, Z).then(function(n) {
                        return (O = n.responseText) && (0, i.HD)(O) && (O = JSON.parse(O)) && "object" === (0, r.Z)(O) && !O.headers && (Array.isArray(O) ? O.forEach(function(e1) {
                            e1.headers = n.headers;
                        }) : O.headers = n.headers), l && (O.stateToken || g.delete(c.STATE_TOKEN_KEY_NAME)), O && O.stateToken && O.expiresAt && g.set(c.STATE_TOKEN_KEY_NAME, O.stateToken, O.expiresAt, e1.options.cookies), O && t.cacheResponse && m.updateStorage(u, {
                            expiresAt: Math.floor(Date.now() / 1e3) + c.DEFAULT_CACHE_DURATION,
                            response: O
                        }), O;
                    }).catch(function(t) {
                        throw "E0000011" === (w = v(e1, t)).errorCode && g.delete(c.STATE_TOKEN_KEY_NAME), w;
                    });
                }
                function g(e1, t, n) {
                    var r = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "GET"
                    };
                    return Object.assign(r, n), y(e1, r);
                }
                function m(e1, t, n, r) {
                    var o = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "POST",
                        args: n,
                        saveAuthnState: !0
                    };
                    return Object.assign(o, r), y(e1, o);
                }
            },
            3334: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    v: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(1646), f = n(480);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, s = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            return (0, r.Z)(this, l), s.call(this, e1);
                        }
                        return (0, o.Z)(l, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    (0, i.Z)((0, c.Z)(l.prototype), "clear", this).call(this, e1), !1 !== e1.clearIdxResponse && this.clearIdxResponse();
                                }
                            },
                            {
                                key: "saveIdxResponse",
                                value: function(e1) {
                                    if (this.saveLastResponse) {
                                        var t = this.storageManager.getIdxResponseStorage();
                                        t && t.setStorage(e1);
                                    }
                                }
                            },
                            {
                                key: "loadIdxResponse",
                                value: function(e1) {
                                    if (!this.saveLastResponse) return null;
                                    var t = this.storageManager.getIdxResponseStorage();
                                    if (!t) return null;
                                    var n = t.getStorage();
                                    if (!n || !(0, f.P)(n.rawIdxResponse)) return null;
                                    if (e1) {
                                        var r = e1.stateHandle, o = e1.interactionHandle;
                                        if (!e1.useGenericRemediator && r && n.stateHandle !== r) return null;
                                        if (o && n.interactionHandle !== o) return null;
                                    }
                                    return n;
                                }
                            },
                            {
                                key: "clearIdxResponse",
                                value: function() {
                                    if (this.saveLastResponse) {
                                        var e1 = this.storageManager.getIdxResponseStorage();
                                        null == e1 || e1.clearStorage();
                                    }
                                }
                            }
                        ]), l;
                    }((0, s.P)());
                }
            },
            1286: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(7595), c = n(3377);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return (n = r.length > 1 && void 0 !== r[1] ? r[1] : {}).password && !n.authenticator && (n.authenticator = u.pc.OKTA_PASSWORD), e1.abrupt("return", (0, c.K)(t, f(f({}, n), {}, {
                                        flow: "authenticate"
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7644: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = (0, r.Z)(function e1(t) {
                    (0, o.Z)(this, e1), (0, i.Z)(this, "meta", void 0), this.meta = t;
                });
            },
            9582: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5671), i = n(3144), a = n(136), u = n(2963), c = n(1120);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, a.Z)(s, e1);
                    var t, n, r = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), r.apply(this, arguments);
                    }
                    return (0, i.Z)(s, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.password || e1.passcode);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.password, r = e1.passcode, o = e1.revokeSessions;
                                if (t || n || r) return t || {
                                    passcode: r || n,
                                    revokeSessions: o
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t, n, r = [
                                    f(f({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                        name: "password",
                                        type: "string",
                                        required: e1.required
                                    })
                                ];
                                return (null === (n = e1.form) || void 0 === n ? void 0 : n.value.find(function(e1) {
                                    return "revokeSessions" === e1.name;
                                })) && r.push({
                                    name: "revokeSessions",
                                    type: "boolean",
                                    label: "Sign me out of all other devices",
                                    required: !1
                                }), r;
                            }
                        }
                    ]), s;
                }(n(7644)._);
            },
            9344: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    LL: function() {
                        return i;
                    },
                    PN: function() {
                        return a;
                    },
                    h_: function() {
                        return u;
                    }
                });
                var r = n(7595);
                function o(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function i(e1) {
                    var t;
                    if ((0, r.H)(e1)) t = e1;
                    else {
                        if ("string" != typeof e1) throw new Error("Invalid format for authenticator");
                        t = {
                            key: e1
                        };
                    }
                    return t;
                }
                function a(e1, t) {
                    return !!(e1 && t && (e1.id && t.id ? e1.id === t.id : e1.key && t.key && e1.key === t.key));
                }
                function u(e1, t) {
                    var n, r, i = function(e1, t) {
                        var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (!n) {
                            if (Array.isArray(e1) || (n = function(e1, t) {
                                if (e1) {
                                    if ("string" == typeof e1) return o(e1, t);
                                    var n = Object.prototype.toString.call(e1).slice(8, -1);
                                    return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e1, t) : void 0;
                                }
                            }(e1)) || t && e1 && "number" == typeof e1.length) {
                                n && (e1 = n);
                                var r = 0, i = function() {};
                                return {
                                    s: i,
                                    n: function() {
                                        return r >= e1.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e1[r++]
                                        };
                                    },
                                    e: function(e1) {
                                        throw e1;
                                    },
                                    f: i
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var a, u = !0, c = !1;
                        return {
                            s: function() {
                                n = n.call(e1);
                            },
                            n: function() {
                                var e1 = n.next();
                                return u = e1.done, e1;
                            },
                            e: function(e1) {
                                c = !0, a = e1;
                            },
                            f: function() {
                                try {
                                    u || null == n.return || n.return();
                                } finally{
                                    if (c) throw a;
                                }
                            }
                        };
                    }(e1);
                    try {
                        var a = function() {
                            var e1 = r.value;
                            if (n = t.find(function(t) {
                                var n = t.relatesTo;
                                return n.key && n.key === e1.key;
                            })) return "break";
                        };
                        for(i.s(); !(r = i.n()).done && "break" !== a(););
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return n;
                }
            },
            9192: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = t.transactionManager.load(), o = (0, c.s)(t, r.flow), e1.abrupt("return", (0, u.K)(t, f(f(f({}, n), o), {}, {
                                        actions: [
                                            "cancel"
                                        ]
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            7985: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    GA: function() {
                        return g;
                    },
                    Jn: function() {
                        return b;
                    },
                    gc: function() {
                        return y;
                    },
                    mo: function() {
                        return m;
                    }
                });
                var r = n(5861), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(6245), h = n(1969);
                var v = function(e1) {
                    (0, u.Z)(l, e1);
                    var t, n, r = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, i.Z)(this, l), n = r.call(this, "Enter the OTP code in the originating client: ".concat(t)), (0, f.Z)((0, a.Z)(n), "state", void 0), (0, f.Z)((0, a.Z)(n), "otp", void 0), n.name = "EmailVerifyCallbackError", n.state = e1, n.otp = t, n;
                    }
                    return (0, o.Z)(l);
                }(d.Z);
                function y(e1) {
                    return "EmailVerifyCallbackError" === e1.name;
                }
                function g(e1) {
                    return /(otp=)/i.test(e1) && /(state=)/i.test(e1);
                }
                function m(e1) {
                    return (0, h.v)(e1);
                }
                function b(e1, t) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, r.Z)(p().mark(function e1(t, n) {
                        var r, o, i;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!g(n)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (r = m(n), o = r.state, i = r.otp, !t.idx.canProceed({
                                        state: o
                                    })) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 5, t.idx.proceed({
                                        state: o,
                                        otp: i
                                    });
                                case 5:
                                    return e1.abrupt("return", e1.sent);
                                case 8:
                                    throw new v(o, i);
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2144: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    }
                });
                var r = n(1578), o = n(8137);
                function i(e1, t, n) {
                    var i = (0, r.K)(e1, t, n);
                    return (0, o.B)(i);
                }
            },
            8717: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    F: function() {
                        return F;
                    }
                });
                var r = {};
                n.r(r), n.d(r, {
                    AuthenticatorEnrollmentData: function() {
                        return U.q;
                    },
                    AuthenticatorVerificationData: function() {
                        return N.q;
                    },
                    ChallengeAuthenticator: function() {
                        return E.J;
                    },
                    ChallengePoll: function() {
                        return S.U;
                    },
                    EnrollAuthenticator: function() {
                        return w.q;
                    },
                    EnrollPoll: function() {
                        return O.T;
                    },
                    EnrollProfile: function() {
                        return P.w;
                    },
                    EnrollmentChannelData: function() {
                        return T.t;
                    },
                    GenericRemediator: function() {
                        return H.P;
                    },
                    Identify: function() {
                        return A.h;
                    },
                    ReEnrollAuthenticator: function() {
                        return R.j;
                    },
                    ReEnrollAuthenticatorWarning: function() {
                        return _.i;
                    },
                    RedirectIdp: function() {
                        return j.O;
                    },
                    Remediator: function() {
                        return k.n;
                    },
                    ResetAuthenticator: function() {
                        return x.G;
                    },
                    SelectAuthenticatorAuthenticate: function() {
                        return C.X;
                    },
                    SelectAuthenticatorEnroll: function() {
                        return I.j;
                    },
                    SelectAuthenticatorUnlockAccount: function() {
                        return D.G;
                    },
                    SelectEnrollProfile: function() {
                        return M.j;
                    },
                    SelectEnrollmentChannel: function() {
                        return Z.V;
                    },
                    Skip: function() {
                        return L.h;
                    }
                });
                var o = n(8221), i = n(9912), a = n(1286), u = n(9192), c = n(7985), s = n(5021), f = n(5923), l = n(6131), p = n(2660), d = n(9310), h = n(2845), v = n(9214), y = n(8826), g = n(2473), m = n(2620), b = n(8277), k = n(3118), w = n(3857), O = n(2288), Z = n(3403), T = n(3679), E = n(4560), S = n(1104), x = n(1019), P = n(7522), A = n(8628), R = n(9024), _ = n(8107), j = n(8490), C = n(7311), I = n(9865), D = n(5272), M = n(4713), N = n(5278), U = n(2541), L = n(8443), H = n(9732), B = n(7738), K = n(5031);
                function F(e1) {
                    (0, K.TC)({
                        remediators: r,
                        getFlowSpecification: B.s
                    });
                    var t = g.Y.bind(null, e1);
                    return {
                        interact: l.E.bind(null, e1),
                        introspect: p.L.bind(null, e1),
                        makeIdxResponse: f._T.bind(null, e1),
                        authenticate: a.Y.bind(null, e1),
                        register: y.z.bind(null, e1),
                        start: t,
                        startTransaction: t,
                        poll: d.$.bind(null, e1),
                        proceed: h.x.bind(null, e1),
                        cancel: u.a.bind(null, e1),
                        recoverPassword: v.M.bind(null, e1),
                        handleInteractionCodeRedirect: s.X.bind(null, e1),
                        isInteractionRequired: o.wc.bind(null, e1),
                        isInteractionRequiredError: i.Cf,
                        handleEmailVerifyCallback: c.Jn.bind(null, e1),
                        isEmailVerifyCallback: c.GA,
                        parseEmailVerifyCallback: c.mo,
                        isEmailVerifyCallbackError: c.gc,
                        getSavedTransactionMeta: m.uN.bind(null, e1),
                        createTransactionMeta: m.Xc.bind(null, e1),
                        getTransactionMeta: m.Co.bind(null, e1),
                        saveTransactionMeta: m.r0.bind(null, e1),
                        clearTransactionMeta: m.Jm.bind(null, e1),
                        isTransactionMetaValid: m.Wf,
                        setFlow: function(t) {
                            e1.options.flow = t;
                        },
                        getFlow: function() {
                            return e1.options.flow;
                        },
                        canProceed: h.C.bind(null, e1),
                        unlockAccount: b.l.bind(null, e1)
                    };
                }
            },
            7738: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return S;
                    }
                });
                var r = n(8628), o = n(7311), i = n(9865), a = n(2541), u = n(5278), c = n(3857), s = n(4560), f = n(1104), l = n(9024), p = n(8107), d = n(2288), h = n(3403), v = n(3679), y = n(8490), g = n(8443), m = {
                    identify: r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "authenticator-enrollment-data": a.q,
                    "authenticator-verification-data": u.q,
                    "enroll-authenticator": c.q,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "reenroll-authenticator": l.j,
                    "reenroll-authenticator-warning": p.i,
                    "enroll-poll": d.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": v.t,
                    "redirect-idp": y.O,
                    skip: g.h
                }, b = n(1019), k = {
                    identify: r.h,
                    "identify-recovery": r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "challenge-authenticator": s.J,
                    "authenticator-verification-data": u.q,
                    "authenticator-enrollment-data": a.q,
                    "reset-authenticator": b.G,
                    "reenroll-authenticator": l.j,
                    "reenroll-authenticator-warning": p.i,
                    "enroll-poll": d.T
                }, w = n(4713), O = n(7522), Z = {
                    "select-enroll-profile": w.j,
                    "enroll-profile": O.w,
                    "authenticator-enrollment-data": a.q,
                    "select-authenticator-enroll": i.j,
                    "enroll-poll": d.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": v.t,
                    "enroll-authenticator": c.q,
                    skip: g.h
                }, T = n(5272), E = {
                    identify: r.h,
                    "select-authenticator-unlock-account": T.G,
                    "select-authenticator-authenticate": o.X,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "authenticator-verification-data": u.q,
                    "reenroll-authenticator-warning": p.i
                };
                function S(e1) {
                    var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default", o = !0;
                    switch(r){
                        case "register":
                        case "signup":
                        case "enrollProfile":
                            t = Z, o = !1;
                            break;
                        case "recoverPassword":
                        case "resetPassword":
                            t = k, n = [
                                "currentAuthenticator-recover",
                                "currentAuthenticatorEnrollment-recover"
                            ], o = !1;
                            break;
                        case "unlockAccount":
                            t = E, o = !1, n = [
                                "unlock-account"
                            ];
                            break;
                        default:
                            t = m;
                    }
                    return {
                        flow: r,
                        remediators: t,
                        actions: n,
                        withCredentials: o
                    };
                }
            },
            5021: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return c;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(2886);
                function c(e1, t) {
                    return s.apply(this, arguments);
                }
                function s() {
                    return (s = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, c, s, f, l, p, d, h, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = t.transactionManager.load()) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new a.Z("No transaction data was found in storage");
                                case 3:
                                    if (o = r.codeVerifier, c = r.state, s = new URL(n), f = s.searchParams, l = f.get("state"), p = f.get("interaction_code"), !(d = f.get("error"))) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new u.Z(d, f.get("error_description"));
                                case 10:
                                    if (l === c) {
                                        e1.next = 12;
                                        break;
                                    }
                                    throw new a.Z("State in redirect uri does not match with transaction state");
                                case 12:
                                    if (p) {
                                        e1.next = 14;
                                        break;
                                    }
                                    throw new a.Z("Unable to parse interaction_code from the url");
                                case 14:
                                    return e1.next = 16, t.token.exchangeCodeForTokens({
                                        interactionCode: p,
                                        codeVerifier: o
                                    });
                                case 16:
                                    h = e1.sent, v = h.tokens, t.tokenManager.setTokens(v);
                                case 19:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            5923: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _T: function() {
                        return U;
                    },
                    A0: function() {
                        return N;
                    }
                });
                var r = n(1971), o = n(5861), i = n(2982), a = n(4687), u = n.n(a), c = n(885), s = n(4942), f = n(4925), l = n(1002), p = n(5385);
                function d(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return h(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function h(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var v = function(e1) {
                    return !1 !== e1.mutable;
                }, y = function(e1) {
                    var t = {}, n = [], r = {};
                    if (!e1.value) return n.push(e1), {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                    var o, i = d(e1.value);
                    try {
                        for(i.s(); !(o = i.n()).done;){
                            var a, u, c = o.value;
                            v(c) ? (n.push(c), null !== (a = c.value) && void 0 !== a && a && (t[c.name] = c.value)) : r[c.name] = null !== (u = c.value) && void 0 !== u ? u : "";
                        }
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                }, g = n(3983);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = function(e1, t) {
                    var n = t.actionDefinition, r = t.defaultParamsForAction, i = void 0 === r ? {} : r, a = t.immutableParamsForAction, c = void 0 === a ? {} : a, s = t.toPersist, f = void 0 === s ? {} : s, l = n.href;
                    return (0, o.Z)(u().mark(function t() {
                        var r, o, a, s, d, h, v, y, m, k = arguments;
                        return u().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return r = k.length > 0 && void 0 !== k[0] ? k[0] : {}, o = {
                                        "Content-Type": "application/json",
                                        Accept: n.accepts || "application/ion+json"
                                    }, a = JSON.stringify(b(b(b({}, i), r), c)), t.prev = 3, t.next = 6, (0, p.c3)(e1, {
                                        url: l,
                                        method: n.method,
                                        headers: o,
                                        args: a,
                                        withCredentials: null === (s = null == f ? void 0 : f.withCredentials) || void 0 === s || s
                                    });
                                case 6:
                                    return d = t.sent, t.abrupt("return", e1.idx.makeIdxResponse(b({}, d), f, !0));
                                case 10:
                                    if (t.prev = 10, t.t0 = t.catch(3), t.t0 instanceof g.Z && null !== t.t0 && void 0 !== t.t0 && t.t0.xhr) {
                                        t.next = 14;
                                        break;
                                    }
                                    throw t.t0;
                                case 14:
                                    return h = t.t0.xhr, v = h.responseJSON || JSON.parse(h.responseText), y = h.headers["WWW-Authenticate"] || h.headers["www-authenticate"], m = e1.idx.makeIdxResponse(b({}, v), f, !1), 401 === h.status && 'Oktadevicejwt realm="Okta Device"' === y && (m.stepUp = !0), t.abrupt("return", m);
                                case 20:
                                case "end":
                                    return t.stop();
                            }
                        }, t, null, [
                            [
                                3,
                                10
                            ]
                        ]);
                    }));
                }, w = function(e1, t, n) {
                    var r = k, o = function(e1) {
                        var t, n = [], r = {}, o = {}, i = d(e1 = Array.isArray(e1) ? e1 : [
                            e1
                        ]);
                        try {
                            for(i.s(); !(t = i.n()).done;){
                                var a = t.value, u = y(a), c = u.defaultParamsForAction, s = u.neededParamsForAction, f = u.immutableParamsForAction;
                                n.push(s), r[a.name] = c, o[a.name] = f;
                            }
                        } catch (e1) {
                            i.e(e1);
                        } finally{
                            i.f();
                        }
                        return {
                            defaultParams: r,
                            neededParams: n,
                            immutableParams: o
                        };
                    }(t), i = o.defaultParams, a = o.neededParams, u = o.immutableParams, c = r(e1, {
                        actionDefinition: t,
                        defaultParamsForAction: i[t.name],
                        immutableParamsForAction: u[t.name],
                        toPersist: n
                    });
                    return c.neededParams = a, c;
                };
                function O(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function Z(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? O(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : O(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var T = n(136), E = n(9611);
                function S() {
                    S = function(e1, t) {
                        return new n(e1, void 0, t);
                    };
                    var e1 = RegExp.prototype, t = new WeakMap;
                    function n(e1, r, o) {
                        var i = new RegExp(e1, r);
                        return t.set(i, o || t.get(e1)), (0, E.Z)(i, n.prototype);
                    }
                    function r(e1, n) {
                        var r = t.get(n);
                        return Object.keys(r).reduce(function(t, n) {
                            var o = r[n];
                            if ("number" == typeof o) t[n] = e1[o];
                            else {
                                for(var i = 0; void 0 === e1[o[i]] && i + 1 < o.length;)i++;
                                t[n] = e1[o[i]];
                            }
                            return t;
                        }, Object.create(null));
                    }
                    return (0, T.Z)(n, RegExp), n.prototype.exec = function(t) {
                        var n = e1.exec.call(this, t);
                        return n && (n.groups = r(n, this)), n;
                    }, n.prototype[Symbol.replace] = function(n, o) {
                        if ("string" == typeof o) {
                            var i = t.get(this);
                            return e1[Symbol.replace].call(this, n, o.replace(/\$<([^>]+)>/g, function(e1, t) {
                                return "$" + i[t];
                            }));
                        }
                        if ("function" == typeof o) {
                            var a = this;
                            return e1[Symbol.replace].call(this, n, function() {
                                var e1 = arguments;
                                return "object" != (0, l.Z)(e1[e1.length - 1]) && (e1 = [].slice.call(e1)).push(r(e1, a)), o.apply(this, e1);
                            });
                        }
                        return e1[Symbol.replace].call(this, n, o);
                    }, S.apply(this, arguments);
                }
                var x = S(/\$?(\w+)|(?:\[(\d+)\])/g, {
                    step: 1,
                    index: 2
                }), P = n(9123), A = [
                    "value",
                    "type"
                ];
                function R(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function _(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? R(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var j = {
                    remediation: !0,
                    context: !0
                }, C = function e1(t, n) {
                    Object.keys(n).forEach(function(r) {
                        if ("relatesTo" === r) {
                            var o = Array.isArray(n[r]) ? n[r][0] : n[r];
                            if ("string" == typeof o) {
                                var i = function(e1) {
                                    for(var t, n = e1.path, r = e1.json, o = []; null !== (t = x.exec(n));){
                                        var i, a, u, c, s, f = null !== (i = null === (a = t) || void 0 === a || null === (u = a.groups) || void 0 === u ? void 0 : u.step) && void 0 !== i ? i : null === (c = t) || void 0 === c || null === (s = c.groups) || void 0 === s ? void 0 : s.index;
                                        f && o.push(f);
                                    }
                                    if (!(o.length < 1)) {
                                        for(var p = o.pop(), d = r, h = 0, v = o; h < v.length; h++){
                                            var y = v[h];
                                            if (Object.prototype.hasOwnProperty.call(d, y)) {
                                                if ("object" !== (0, l.Z)(d[y])) return;
                                                d = d[y];
                                            }
                                        }
                                        return d[p];
                                    }
                                }({
                                    path: o,
                                    json: t
                                });
                                if (i) return void (n[r] = i);
                                throw new P.Z("Cannot resolve relatesTo: ".concat(o));
                            }
                        }
                        Array.isArray(n[r]) && n[r].forEach(function(n) {
                            return e1(t, n);
                        });
                    });
                }, I = function(e1, t) {
                    var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = (null === (n = t.remediation) || void 0 === n ? void 0 : n.value) || [];
                    o.forEach(function(e1) {
                        var n;
                        if ("launch-authenticator" !== e1.name || "authenticatorChallenge" !== (null == e1 || null === (n = e1.relatesTo) || void 0 === n ? void 0 : n[0]) || null != t && t.authenticatorChallenge) return C(t, e1);
                        delete e1.relatesTo;
                    });
                    var i = o.map(function(t) {
                        return function(e1, t, n) {
                            if (t.rel) {
                                var r = function(e1, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                                    return t.reduce(function(t, r) {
                                        return Z(Z({}, t), {}, (0, s.Z)({}, r.name, w(e1, r, n)));
                                    }, {});
                                }(e1, [
                                    t
                                ], n), o = r[t.name];
                                return _(_({}, t), {}, {
                                    action: o
                                });
                            }
                            return t;
                        }(e1, t, r);
                    }), a = function(e1, t) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = {}, o = {};
                        return Object.keys(t).filter(function(e1) {
                            return !j[e1];
                        }).forEach(function(i) {
                            if ("object" === (0, l.Z)(t[i]) && t[i]) {
                                if (t[i].rel) r[t[i].name] = w(e1, t[i], n);
                                else {
                                    var a = t[i], u = a.value, s = a.type, p = (0, f.Z)(a, A);
                                    o[i] = _({
                                        type: s
                                    }, p), "object" === s ? (o[i].value = {}, Object.entries(u).forEach(function(t) {
                                        var a = (0, c.Z)(t, 2), u = a[0], s = a[1];
                                        s.rel ? r["".concat(i, "-").concat(u.name || u)] = w(e1, s, n) : o[i].value[u] = s;
                                    })) : o[i].value = u;
                                }
                            } else o[i] = t[i];
                        }), {
                            context: o,
                            actions: r
                        };
                    }(e1, t, r);
                    return {
                        remediations: i,
                        context: a.context,
                        actions: a.actions
                    };
                }, D = {
                    makeIdxState: function(e1, t, n, r) {
                        var a, c, s, f, l = t, p = I(e1, t, n), d = p.remediations, h = p.context, v = p.actions, y = (0, i.Z)(d), g = (f = (0, o.Z)(u().mark(function e1(t) {
                            var n, r, o = arguments;
                            return u().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = d.find(function(e1) {
                                            return e1.name === t;
                                        })) {
                                            e1.next = 4;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Unknown remediation choice: [".concat(t, "]")));
                                    case 4:
                                        if ("function" == typeof r.action) {
                                            e1.next = 7;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Current remediation cannot make form submit action: [".concat(t, "]")));
                                    case 7:
                                        return e1.abrupt("return", r.action(n));
                                    case 8:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        })), function(e1) {
                            return f.apply(this, arguments);
                        });
                        return {
                            proceed: g,
                            neededToProceed: y,
                            actions: v,
                            context: h,
                            rawIdxState: l,
                            interactionCode: null === (a = l.successWithInteractionCode) || void 0 === a || null === (c = a.value) || void 0 === c || null === (s = c.find(function(e1) {
                                return "interaction_code" === e1.name;
                            })) || void 0 === s ? void 0 : s.value,
                            toPersist: n,
                            requestDidSucceed: r
                        };
                    }
                }, M = function(e1) {
                    switch(e1){
                        case "1.0.0":
                            return D;
                        case void 0:
                        case null:
                            throw new Error("Api version is required");
                        default:
                            throw new Error("Unknown api version: ".concat(e1, ".  Use an exact semver version."));
                    }
                };
                function N(e1) {
                    if (!e1) throw new Error("version is required");
                    if ((null != e1 ? e1 : "").replace(/[^0-9a-zA-Z._-]/, "") !== e1 || !e1) throw new Error("invalid version supplied - version is required and uses semver syntax");
                    M(e1);
                }
                function U(e1, t, n, o) {
                    var i, a = null !== (i = null == t ? void 0 : t.version) && void 0 !== i ? i : r.IDX_API_VERSION;
                    return N(a), (0, M(a).makeIdxState)(e1, t, n, o);
                }
            },
            9999: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    pc: function() {
                        return K.pc;
                    },
                    Fw: function() {
                        return K.Fw;
                    },
                    Qd: function() {
                        return K.Qd;
                    },
                    YR: function() {
                        return r.Y;
                    },
                    Ch: function() {
                        return s.C;
                    },
                    al: function() {
                        return o.a;
                    },
                    Jm: function() {
                        return v.Jm;
                    },
                    F4: function() {
                        return y.F;
                    },
                    SL: function() {
                        return H.S;
                    },
                    aT: function() {
                        return B.a;
                    },
                    vK: function() {
                        return F.v;
                    },
                    UB: function() {
                        return U;
                    },
                    Yn: function() {
                        return g.Y;
                    },
                    Xc: function() {
                        return v.Xc;
                    },
                    uN: function() {
                        return v.uN;
                    },
                    Co: function() {
                        return v.Co;
                    },
                    Jn: function() {
                        return i.Jn;
                    },
                    Xx: function() {
                        return p.X;
                    },
                    $0: function() {
                        return v.$0;
                    },
                    EW: function() {
                        return a.E;
                    },
                    L8: function() {
                        return u.L;
                    },
                    H: function() {
                        return K.H;
                    },
                    GA: function() {
                        return i.GA;
                    },
                    gc: function() {
                        return i.gc;
                    },
                    Wf: function() {
                        return v.Wf;
                    },
                    bl: function() {
                        return v.bl;
                    },
                    UC: function() {
                        return v.UC;
                    },
                    B_: function() {
                        return L.B;
                    },
                    mo: function() {
                        return i.mo;
                    },
                    $l: function() {
                        return c.$;
                    },
                    xc: function() {
                        return s.x;
                    },
                    M4: function() {
                        return l.M;
                    },
                    z2: function() {
                        return f.z;
                    },
                    r0: function() {
                        return v.r0;
                    },
                    Yr: function() {
                        return d.Y;
                    },
                    le: function() {
                        return h.l;
                    }
                });
                var r = n(1286), o = n(9192), i = n(7985), a = n(6131), u = n(2660), c = n(9310), s = n(2845), f = n(8826), l = n(9214), p = n(5021), d = n(2473), h = n(8277), v = n(2620), y = n(8717), g = n(2144), m = n(3144), b = n(5671), k = n(7326), w = n(136), O = n(2963), Z = n(1120), T = n(4942), E = n(5923), S = n(8719), x = n(8716);
                function P(e1) {
                    var t;
                    return t = function(e1) {
                        (0, w.Z)(o, e1);
                        var t, n, r = (t = o, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, Z.Z)(t);
                            if (n) {
                                var o = (0, Z.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, O.Z)(this, e1);
                        });
                        function o() {
                            var e1, t, n;
                            (0, b.Z)(this, o);
                            for(var i = arguments.length, a = new Array(i), u = 0; u < i; u++)a[u] = arguments[u];
                            return e1 = r.call.apply(r, [
                                this
                            ].concat(a)), (0, T.Z)((0, k.Z)(e1), "idx", void 0), (0, T.Z)((0, k.Z)(e1), "fingerprint", void 0), e1.idx = (t = (0, k.Z)(e1), n = d.Y.bind(null, t), {
                                makeIdxResponse: E._T.bind(null, t),
                                start: n,
                                startTransaction: n,
                                proceed: s.x.bind(null, t),
                                canProceed: s.C.bind(null, t),
                                getSavedTransactionMeta: v.uN.bind(null, t),
                                createTransactionMeta: v.Xc.bind(null, t),
                                getTransactionMeta: v.Co.bind(null, t),
                                saveTransactionMeta: v.r0.bind(null, t),
                                clearTransactionMeta: v.Jm.bind(null, t),
                                isTransactionMetaValid: v.Wf
                            }), e1.fingerprint = S.Z.bind(null, (0, k.Z)(e1)), e1;
                        }
                        return (0, m.Z)(o);
                    }(e1), (0, T.Z)(t, "webauthn", x), t;
                }
                var A = n(9893), R = n(265), _ = n(279), j = n(3980), C = n(1237), I = n(8707), D = n(6898), M = n(8221);
                function N(e1, t) {
                    return function(e1) {
                        (0, w.Z)(i, e1);
                        var n, r, o = (n = i, r = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, Z.Z)(n);
                            if (r) {
                                var o = (0, Z.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, o);
                            } else e1 = t.apply(this, arguments);
                            return (0, O.Z)(this, e1);
                        });
                        function i() {
                            var e1, n;
                            (0, b.Z)(this, i);
                            for(var r = arguments.length, a = new Array(r), u = 0; u < r; u++)a[u] = arguments[u];
                            return e1 = o.call.apply(o, [
                                this
                            ].concat(a)), (0, T.Z)((0, k.Z)(e1), "token", void 0), (0, T.Z)((0, k.Z)(e1), "transactionManager", void 0), e1.transactionManager = new t(Object.assign({
                                storageManager: e1.storageManager
                            }, e1.options.transactionManager)), e1.token = (n = (0, k.Z)(e1), {
                                prepareTokenParams: D.wu.bind(null, n),
                                exchangeCodeForTokens: I.r.bind(null, n),
                                decode: C.T
                            }), e1;
                        }
                        return (0, m.Z)(i, [
                            {
                                key: "isLoginRedirect",
                                value: function() {
                                    return (0, M.gM)(this);
                                }
                            },
                            {
                                key: "isPKCE",
                                value: function() {
                                    return !!this.options.pkce;
                                }
                            },
                            {
                                key: "hasResponseType",
                                value: function(e1) {
                                    return (0, M.wV)(e1, this.options);
                                }
                            },
                            {
                                key: "isAuthorizationCodeFlow",
                                value: function() {
                                    return this.hasResponseType("code");
                                }
                            }
                        ]), i;
                    }(e1);
                }
                function U(e1, t, n) {
                    var r = (0, A.a)(t), o = (0, R.H)(r, e1), i = (0, _.A)(o);
                    return P(N((0, j.Z)(i), n));
                }
                var L = n(8137), H = n(4602), B = n(4143), K = n(7595), F = n(3334);
            },
            6131: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(2620), c = n(7599), s = n(3193), f = n(5385);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function d(e1) {
                    return {
                        meta: e1,
                        interactionHandle: e1.interactionHandle,
                        state: e1.state
                    };
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, l, h, v, y, g, m, b, k, w, O, Z, T, E, S, x, P, A, R, _, j, C, I = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = I.length > 1 && void 0 !== I[1] ? I[1] : {}, o = (0, s.YY)(o), i = (0, u.uN)(t, o), null === (n = i) || void 0 === n || !n.interactionHandle) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", d(i));
                                case 5:
                                    return e1.next = 7, (0, u.Xc)(t, p(p({}, i), o));
                                case 7:
                                    return i = e1.sent, l = (0, c.zf)(t), v = (h = i).clientId, y = h.redirectUri, g = h.state, m = h.scopes, b = h.withCredentials, k = h.codeChallenge, w = h.codeChallengeMethod, O = h.activationToken, Z = h.recoveryToken, T = h.maxAge, E = h.acrValues, S = h.nonce, x = o.clientSecret || t.options.clientSecret, b = null === (r = b) || void 0 === r || r, P = "".concat(l, "/v1/interact"), A = p(p(p(p(p(p({
                                        client_id: v,
                                        scope: m.join(" "),
                                        redirect_uri: y,
                                        code_challenge: k,
                                        code_challenge_method: w,
                                        state: g
                                    }, O && {
                                        activation_token: O
                                    }), Z && {
                                        recovery_token: Z
                                    }), x && {
                                        client_secret: x
                                    }), T && {
                                        max_age: T
                                    }), E && {
                                        acr_values: E
                                    }), S && {
                                        nonce: S
                                    }), R = {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    }, e1.next = 17, (0, f.c3)(t, {
                                        method: "POST",
                                        url: P,
                                        headers: R,
                                        withCredentials: b,
                                        args: A
                                    });
                                case 17:
                                    return _ = e1.sent, j = _.interaction_handle, C = p(p({}, i), {}, {
                                        interactionHandle: j,
                                        withCredentials: b,
                                        state: g,
                                        scopes: m,
                                        recoveryToken: Z,
                                        activationToken: O
                                    }), (0, u.r0)(t, C), e1.abrupt("return", d(C));
                                case 22:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2660: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(5923), u = n(480), c = n(7599), s = n(1971), f = n(5385), l = n(5728);
                function p(e1) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = (0, r.Z)(i().mark(function e1(t) {
                        var n, r, o, p, d, h, v, y, g, m, b, k, w, O, Z = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = Z.length > 1 && void 0 !== Z[1] ? Z[1] : {}, (p = t.transactionManager.loadIdxResponse(n)) && (r = p.rawIdxResponse, o = p.requestDidSucceed), r) {
                                        e1.next = 27;
                                        break;
                                    }
                                    return h = n.version || s.IDX_API_VERSION, v = (0, c.Xp)(t), y = n.interactionHandle, g = n.stateHandle, m = null === (d = n.withCredentials) || void 0 === d || d, e1.prev = 8, o = !0, (0, a.A0)(h), b = "".concat(v, "/idp/idx/introspect"), k = g ? {
                                        stateToken: g
                                    } : {
                                        interactionHandle: y
                                    }, w = {
                                        "Content-Type": "application/ion+json; okta-version=".concat(h),
                                        Accept: "application/ion+json; okta-version=".concat(h)
                                    }, e1.next = 16, (0, f.c3)(t, {
                                        method: "POST",
                                        url: b,
                                        headers: w,
                                        withCredentials: m,
                                        args: k
                                    });
                                case 16:
                                    r = e1.sent, e1.next = 27;
                                    break;
                                case 19:
                                    if (e1.prev = 19, e1.t0 = e1.catch(8), !((0, l.isAuthApiError)(e1.t0) && e1.t0.xhr && (0, u.P)(e1.t0.xhr.responseJSON))) {
                                        e1.next = 26;
                                        break;
                                    }
                                    r = e1.t0.xhr.responseJSON, o = !1, e1.next = 27;
                                    break;
                                case 26:
                                    throw e1.t0;
                                case 27:
                                    return O = n.withCredentials, e1.abrupt("return", (0, a._T)(t, r, {
                                        withCredentials: O
                                    }, o));
                                case 29:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                8,
                                19
                            ]
                        ]);
                    })), d.apply(this, arguments);
                }
            },
            8137: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    B: function() {
                        return d;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(8717), l = n(8719), p = n(8716);
                function d(e1) {
                    var t;
                    return t = function(e1) {
                        (0, a.Z)(d, e1);
                        var t, n, p = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function d() {
                            var e1;
                            (0, o.Z)(this, d);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = p.call.apply(p, [
                                this
                            ].concat(n)), (0, s.Z)((0, i.Z)(e1), "idx", void 0), (0, s.Z)((0, i.Z)(e1), "fingerprint", void 0), e1.idx = (0, f.F)((0, i.Z)(e1)), e1.fingerprint = l.Z.bind(null, (0, i.Z)(e1)), e1;
                        }
                        return (0, r.Z)(d);
                    }(e1), (0, s.Z)(t, "webauthn", p), t;
                }
            },
            4602: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    S: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9133);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "flow", void 0), (0, s.Z)((0, i.Z)(t), "activationToken", void 0), (0, s.Z)((0, i.Z)(t), "recoveryToken", void 0), (0, s.Z)((0, i.Z)(t), "idx", void 0), t.flow = e1.flow, t.activationToken = e1.activationToken, t.recoveryToken = e1.recoveryToken, t.idx = e1.idx, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.n)());
                }
            },
            9310: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return s;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(2845), u = n(2620), c = n(146);
                function s(e1) {
                    return f.apply(this, arguments);
                }
                function f() {
                    return f = (0, r.Z)(i().mark(function e1(t) {
                        var n, o, f, l, p, d = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = d.length > 1 && void 0 !== d[1] ? d[1] : {}, e1.next = 3, (0, a.x)(t, {
                                        startPolling: !0
                                    });
                                case 3:
                                    if (f = e1.sent, l = (0, u.uN)(t), null != (p = null == l || null === (n = l.remediations) || void 0 === n ? void 0 : n.find(function(e1) {
                                        return e1.includes("poll");
                                    })) && p.length || (0, c.ZK)("No polling remediations available at the current IDX flow stage"), !Number.isInteger(o.refresh)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.abrupt("return", new Promise(function(e1, n) {
                                        setTimeout((0, r.Z)(i().mark(function r() {
                                            var o, a, u;
                                            return i().wrap(function(r) {
                                                for(;;)switch(r.prev = r.next){
                                                    case 0:
                                                        try {
                                                            u = null === (o = f.nextStep) || void 0 === o || null === (a = o.poll) || void 0 === a ? void 0 : a.refresh, e1(u ? s(t, {
                                                                refresh: u
                                                            }) : f);
                                                        } catch (e1) {
                                                            n(e1);
                                                        }
                                                    case 1:
                                                    case "end":
                                                        return r.stop();
                                                }
                                            }, r);
                                        })), o.refresh);
                                    }));
                                case 9:
                                    return e1.abrupt("return", f);
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), f.apply(this, arguments);
                }
            },
            2845: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    C: function() {
                        return p;
                    },
                    x: function() {
                        return d;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(9123);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return !(!(0, c.uN)(e1, t) && !t.stateHandle);
                }
                function d(e1) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return h = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, f = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (p(t, n = f.length > 1 && void 0 !== f[1] ? f[1] : {})) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new s.Z("Unable to proceed: saved transaction could not be loaded");
                                case 3:
                                    return r = n.flow, o = n.state, r || (i = (0, c.uN)(t, {
                                        state: o
                                    }), r = null == i ? void 0 : i.flow), e1.abrupt("return", (0, u.K)(t, l(l({}, n), {}, {
                                        flow: r
                                    })));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), h.apply(this, arguments);
                }
            },
            9214: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, c.s)(t, "recoverPassword"), e1.abrupt("return", (0, u.K)(t, f(f({}, n), r)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            8826: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    z: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = i.length > 1 && void 0 !== i[1] ? i[1] : {}, (0, c.$0)(t)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 4, (0, s.Y)(t, d(d({}, n), {}, {
                                        flow: "register",
                                        autoRemediate: !1
                                    }));
                                case 4:
                                    if (r = e1.sent, o = r.enabledFeatures, n.activationToken || !o || o.includes(l.Fw.REGISTRATION)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new f.Z("Registration is not supported based on your current org configuration.");
                                case 8:
                                    return e1.abrupt("return", (0, u.K)(t, d(d({}, n), {}, {
                                        flow: "register"
                                    })));
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2541: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(4794), l = n(6064);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var h = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f() {
                        return (0, r.Z)(this, f), s.apply(this, arguments);
                    }
                    return (0, o.Z)(f, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorData();
                                return {
                                    id: (0, l.zg)(this.remediation).form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value,
                                    methodType: e1.methodType,
                                    phoneNumber: e1.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return [
                                    {
                                        name: "methodType",
                                        type: "string"
                                    },
                                    {
                                        name: "phoneNumber",
                                        label: "Phone Number",
                                        type: "string"
                                    }
                                ].map(function(t) {
                                    return d(d({}, e1.form.value.find(function(e1) {
                                        return e1.name === t.name;
                                    })), t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                e1 = (0, i.Z)((0, c.Z)(f.prototype), "mapAuthenticatorDataFromValues", this).call(this, e1);
                                var t = this.values.phoneNumber;
                                if (e1 || t) return d(d({}, e1 && e1), t && {
                                    phoneNumber: t
                                });
                            }
                        }
                    ]), f;
                }(f.a);
                (0, s.Z)(h, "remediationName", "authenticator-enrollment-data");
            },
            5278: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d() {
                        return (0, o.Z)(this, d), l.apply(this, arguments);
                    }
                    return (0, i.Z)(d, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                return this.getAuthenticatorData();
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorFromRemediation(), t = e1.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                });
                                return t && t.options ? {
                                    name: "methodType",
                                    type: "string",
                                    required: !0,
                                    options: t.options
                                } : (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(d.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "authenticator" !== e1;
                                }).reduce(function(t, n) {
                                    return p(p({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), d;
                }(n(4794).a);
                (0, f.Z)(d, "remediationName", "authenticator-verification-data");
            },
            4794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return y;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7595), d = n(9344);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var y = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, h), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = t.getAuthenticator(), t.formatAuthenticatorData(), t;
                    }
                    return (0, o.Z)(h, [
                        {
                            key: "formatAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                if (this.getAuthenticatorData()) this.values.authenticatorsData = this.values.authenticatorsData.map(function(t) {
                                    return (0, d.PN)(e1.authenticator, t) ? e1.mapAuthenticatorDataFromValues(t) : t;
                                });
                                else {
                                    var t = this.mapAuthenticatorDataFromValues();
                                    t && this.values.authenticatorsData.push(t);
                                }
                            }
                        },
                        {
                            key: "getAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.find(function(t) {
                                    return (0, d.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.some(function(t) {
                                    return (0, d.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                var t = this.values, n = t.methodType, r = t.authenticator;
                                !n && (0, p.H)(r) && (n = null == r ? void 0 : r.methodType);
                                var o = this.authenticator, i = v(v({
                                    id: o.id,
                                    enrollmentId: o.enrollmentId
                                }, e1 && e1), n && {
                                    methodType: n
                                });
                                return i.methodType ? i : null;
                            }
                        },
                        {
                            key: "getAuthenticatorFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "authenticator" === e1.name;
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(h.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticatorsData.filter(function(t) {
                                    return !0 !== (0, d.PN)(e1.authenticator, t);
                                });
                                return v(v({}, this.values), {}, {
                                    authenticatorsData: t
                                });
                            }
                        }
                    ]), h;
                }(l.n);
            },
            3118: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(6064), s = n(9344);
                function f(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, e1), (0, u.Z)(this, "remediation", void 0), (0, u.Z)(this, "values", void 0), (0, u.Z)(this, "options", void 0), (0, u.Z)(this, "map", void 0), this.values = p({}, n), this.options = p({}, r), this.formatAuthenticators(), this.remediation = t;
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "formatAuthenticators",
                            value: function() {
                                if (this.values.authenticators = this.values.authenticators || [], this.values.authenticators = this.values.authenticators.map(function(e1) {
                                    return (0, s.LL)(e1);
                                }), this.values.authenticator) {
                                    var e1 = (0, s.LL)(this.values.authenticator);
                                    this.values.authenticators.some(function(t) {
                                        return (0, s.PN)(e1, t);
                                    }) || this.values.authenticators.push(e1);
                                }
                                this.values.authenticatorsData = this.values.authenticators.reduce(function(e1, t) {
                                    return "object" === (0, o.Z)(t) && Object.keys(t).length > 1 && e1.push(t), e1;
                                }, this.values.authenticatorsData || []);
                            }
                        },
                        {
                            key: "getName",
                            value: function() {
                                return this.remediation.name;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function(e1) {
                                var t = this;
                                return !(0, c.QG)(this.remediation).find(function(e1) {
                                    return !t.hasData(e1);
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function(e1) {
                                var t = this;
                                if (!e1) {
                                    var n = (0, c.ix)(this.remediation).reduce(function(e1, n) {
                                        return e1[n] = t.getData(n), e1;
                                    }, {});
                                    return n;
                                }
                                if ("function" == typeof this["map".concat((0, c.Qs)(e1))]) {
                                    var r = this["map".concat((0, c.Qs)(e1))](this.remediation.value.find(function(t) {
                                        return t.name === e1;
                                    }));
                                    if (r) return r;
                                }
                                if (this.map && this.map[e1]) for(var o = this.map[e1], i = 0; i < o.length; i++){
                                    var a = this.values[o[i]];
                                    if (a) return a;
                                }
                                return this.values[e1];
                            }
                        },
                        {
                            key: "hasData",
                            value: function(e1) {
                                return !!this.getData(e1);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = this.getName(), r = this.getInputs(), o = this.getAuthenticator(), i = null == o ? void 0 : o.type;
                                return p(p({
                                    name: n,
                                    inputs: r
                                }, i && {
                                    type: i
                                }), o && {
                                    authenticator: o
                                });
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                var e1 = this, t = [];
                                return (this.remediation.value || []).forEach(function(n) {
                                    var r, o = n.name, i = n.type, a = n.visible, u = n.messages;
                                    if (!1 !== a) {
                                        if ("function" == typeof e1["getInput".concat((0, c.Qs)(o))]) r = e1["getInput".concat((0, c.Qs)(o))](n);
                                        else if ("object" !== i) {
                                            var s, f = (e1.map ? e1.map[o] : null) || [];
                                            s = 1 === f.length ? f[0] : f.find(function(t) {
                                                return Object.keys(e1.values).includes(t);
                                            }), s && (r = p(p({}, n), {}, {
                                                name: s
                                            }));
                                        }
                                        r || (r = n), Array.isArray(r) ? r.forEach(function(e1) {
                                            return t.push(e1);
                                        }) : (u && (r.messages = u), t.push(r));
                                    }
                                }), t;
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1, t = this.remediation.value || [], n = this.getInputs(), o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return f(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }([].concat((0, r.Z)(t), (0, r.Z)(n)));
                                try {
                                    for(o.s(); !(e1 = o.n()).done;){
                                        var i = e1.value;
                                        delete this.values[i.name];
                                    }
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return this.values;
                            }
                        },
                        {
                            key: "getAuthenticator",
                            value: function() {
                                var e1, t, n = null === (e1 = this.remediation.relatesTo) || void 0 === e1 ? void 0 : e1.value;
                                if (n) {
                                    var r = (0, c.zg)(this.remediation);
                                    if (!r) return n;
                                    var o = r.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value, i = null === (t = r.form.value.find(function(e1) {
                                        return "enrollmentId" === e1.name;
                                    })) || void 0 === t ? void 0 : t.value;
                                    return p(p({}, n), {}, {
                                        id: o,
                                        enrollmentId: i
                                    });
                                }
                            }
                        }
                    ], [
                        {
                            key: "getMessages",
                            value: function(e1) {
                                var t, n;
                                if (e1.value) return null === (t = e1.value[0]) || void 0 === t || null === (n = t.form) || void 0 === n ? void 0 : n.value.reduce(function(e1, t) {
                                    return t.messages && (e1 = [].concat((0, r.Z)(e1), (0, r.Z)(t.messages.value))), e1;
                                }, []);
                            }
                        }
                    ]), e1;
                }();
                (0, u.Z)(d, "remediationName", void 0);
            },
            9164: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return m;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(6064), d = n(7595), h = n(9344);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var m = function(e1) {
                    (0, u.Z)(v, e1);
                    var t, n, l = (t = v, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function v() {
                        var e1;
                        (0, r.Z)(this, v);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "selectedAuthenticator", void 0), (0, f.Z)((0, i.Z)(e1), "selectedOption", void 0), e1;
                    }
                    return (0, o.Z)(v, [
                        {
                            key: "findMatchedOption",
                            value: function(e1, t) {
                                var n, r, o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return g(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(e1);
                                try {
                                    var i = function() {
                                        var e1 = r.value;
                                        if (n = t.find(function(t) {
                                            var n = t.relatesTo;
                                            return n.key && n.key === e1.key;
                                        })) return "break";
                                    };
                                    for(o.s(); !(r = o.n()).done && "break" !== i(););
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return n;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function(e1) {
                                var t = this.values, n = t.authenticators, r = t.authenticator, o = (0, p.zg)(this.remediation).options;
                                if (!n || !n.length) return !1;
                                if ((0, d.H)(r) && r.id) return !0;
                                var i = this.findMatchedOption(n, o);
                                if (i) {
                                    var a, u, c = (null == e1 ? void 0 : e1.currentAuthenticator) && (null == e1 ? void 0 : e1.currentAuthenticator.value.id) === (null === (a = i.relatesTo) || void 0 === a ? void 0 : a.id), s = (null == e1 ? void 0 : e1.currentAuthenticatorEnrollment) && (null == e1 ? void 0 : e1.currentAuthenticatorEnrollment.value.id) === (null === (u = i.relatesTo) || void 0 === u ? void 0 : u.id);
                                    return !c && !s;
                                }
                                return !1;
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t = this.values, n = t.authenticators, r = t.authenticator;
                                if ((0, d.H)(r) && r.id) return this.selectedAuthenticator = r, r;
                                var o = e1.options, i = (0, h.h_)(n, o);
                                return this.selectedAuthenticator = i.relatesTo, this.selectedOption = i, {
                                    id: null == i ? void 0 : i.value.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return {
                                    name: "authenticator",
                                    type: "string",
                                    options: e1.options.map(function(e1) {
                                        return {
                                            label: e1.label,
                                            value: e1.relatesTo.key
                                        };
                                    })
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(v.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticators.filter(function(t) {
                                    return !0 !== (0, h.PN)(t, e1.selectedAuthenticator);
                                });
                                return y(y({}, this.values), {}, {
                                    authenticators: t
                                });
                            }
                        }
                    ]), v;
                }(l.n);
            },
            9883: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Q: function() {
                        return E;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7644);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.verificationCode || e1.otp);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.verificationCode, r = e1.otp;
                                if (t || n || r) return t || {
                                    passcode: n || r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t;
                                return h(h({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                    name: "verificationCode",
                                    type: "string",
                                    required: e1.required
                                });
                            }
                        }
                    ]), a;
                }(p._);
                var y = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.verificationCode;
                                if (t) return {
                                    totp: t
                                };
                            }
                        }
                    ]), a;
                }(v), g = n(9582);
                var m = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                if (t && t.questionKey && t.answer) return !0;
                                var n = e1.questionKey, r = e1.question, o = e1.answer;
                                return !(!n || !o) || !(!r || !o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.questionKey, n = e1.question, r = e1.answer;
                                if (r && (t || n)) return {
                                    questionKey: n ? "custom" : t,
                                    question: n,
                                    answer: r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "questionKey",
                                        type: "string",
                                        required: !0
                                    },
                                    {
                                        name: "question",
                                        type: "string",
                                        label: "Create a security question"
                                    },
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var b = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                return !(!t || !t.answer) || !!e1.answer;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.answer;
                                if (t) return {
                                    questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
                                    answer: t
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var k = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.attestation;
                                return !(!n || !r);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.clientData, r = e1.attestation;
                                if (t || n || r) return t || {
                                    clientData: n,
                                    attestation: r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "clientData",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Client Data"
                                    },
                                    {
                                        name: "attestation",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Attestation"
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var w = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.authenticatorData, o = t.signatureData;
                                return !!(n && r && o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.authenticatorData, r = e1.clientData, o = e1.signatureData;
                                if (t || n || r || o) return t || {
                                    authenticatorData: n,
                                    clientData: r,
                                    signatureData: o
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "authenticatorData",
                                        type: "string",
                                        label: "Authenticator Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "clientData",
                                        type: "string",
                                        label: "Client Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "signatureData",
                                        type: "string",
                                        label: "Signature Data",
                                        required: !0,
                                        visible: !1
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._), O = n(7595);
                function Z(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function T(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Z(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : Z(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var E = function(e1) {
                    (0, u.Z)(p, e1);
                    var t, n, l = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function p(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, p), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = function(e1) {
                            var t, n, r = e1.relatesTo, o = (null == r ? void 0 : r.value) || {};
                            switch(o.key){
                                case O.pc.OKTA_PASSWORD:
                                    return new g.a(o);
                                case O.pc.SECURITY_QUESTION:
                                    return null !== (t = o.contextualData) && void 0 !== t && t.enrolledQuestion ? new b(o) : new m(o);
                                case O.pc.OKTA_VERIFY:
                                    return new y(o);
                                case O.pc.WEBAUTHN:
                                    return null !== (n = o.contextualData) && void 0 !== n && n.challengeData ? new w(o) : new k(o);
                                default:
                                    return new v(o);
                            }
                        }(e1), t;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, r = (0, a.Z)((0, s.Z)(p.prototype), "getNextStep", this).call(this, e1, t), o = null == t || null === (n = t.authenticatorEnrollments) || void 0 === n ? void 0 : n.value;
                                return T(T({}, r), {}, {
                                    authenticatorEnrollments: o
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return this.authenticator.canVerify(this.values);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                return this.authenticator.mapCredentials(this.values);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return this.authenticator.getInputs(e1);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(p.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "credentials" !== e1;
                                }).reduce(function(t, n) {
                                    return T(T({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(l.n);
            },
            4560: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "challenge-authenticator");
            },
            1104: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "challenge-poll" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(2288).T);
                (0, c.Z)(s, "remediationName", "challenge-poll");
            },
            3857: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "enroll-authenticator");
            },
            2288: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "enroll-poll" === this.options.step;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = this.getAuthenticator();
                                return !r && null != t && t.currentAuthenticator && (r = t.currentAuthenticator.value), l(l({}, n), {}, {
                                    authenticator: r,
                                    poll: {
                                        required: !0,
                                        refresh: this.remediation.refresh
                                    }
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return "startPolling" !== e1;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enroll-poll");
            },
            7522: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    w: function() {
                        return v;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(9582);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        return (0, o.Z)(this, d), t = l.call(this, e1, n, r), (0, f.Z)((0, a.Z)(t), "authenticator", null), t.getCredentialsFromRemediation() && (t.authenticator = t.authenticator = new p.a({})), t;
                    }
                    return (0, i.Z)(d, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.authenticator && !this.authenticator.canVerify(this.values)) return !1;
                                var e1 = this.getData().userProfile;
                                return !!e1 && this.remediation.value.find(function(e1) {
                                    return "userProfile" === e1.name;
                                }).form.value.reduce(function(t, n) {
                                    return n.required && (t = t && !!e1[n.name]), t;
                                }, !0);
                            }
                        },
                        {
                            key: "getCredentialsFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "credentials" === e1.name;
                                });
                            }
                        },
                        {
                            key: "mapUserProfile",
                            value: function(e1) {
                                var t = this, n = e1.form.value.map(function(e1) {
                                    return e1.name;
                                }).reduce(function(e1, n) {
                                    return t.values[n] ? h(h({}, e1), {}, (0, f.Z)({}, n, t.values[n])) : e1;
                                }, {});
                                if (0 !== Object.keys(n).length) return n;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.authenticator && this.authenticator.mapCredentials(this.values);
                                if (e1) return e1;
                            }
                        },
                        {
                            key: "getInputUserProfile",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getErrorMessages",
                            value: function(e1) {
                                return e1.value[0].form.value.reduce(function(e1, t) {
                                    return t.messages && e1.push(t.messages.value[0].message), e1;
                                }, []);
                            }
                        }
                    ]), d;
                }(l.n);
                (0, f.Z)(v, "remediationName", "enroll-profile");
            },
            3679: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getInputEmail",
                            value: function() {
                                return [
                                    {
                                        name: "email",
                                        type: "string",
                                        required: !0,
                                        label: "Email"
                                    }
                                ];
                            }
                        },
                        {
                            key: "getInputPhoneNumber",
                            value: function() {
                                return [
                                    {
                                        name: "phoneNumber",
                                        type: "string",
                                        required: !0,
                                        label: "Phone Number"
                                    }
                                ];
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return Boolean(this.values.email || this.values.phoneNumber);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                return {
                                    stateHandle: this.values.stateHandle,
                                    email: this.values.email,
                                    phoneNumber: this.values.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return ![
                                        "email",
                                        "phoneNumber"
                                    ].includes(e1);
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enrollment-channel-data");
            },
            9732: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return k;
                    }
                });
                var r = n(5861), o = n(4942), i = n(4925), a = n(5671), u = n(3144), c = n(136), s = n(2963), f = n(1120), l = n(4687), p = n.n(l), d = n(3118), h = n(1002), v = n(885);
                function y(e1) {
                    if (Array.isArray(e1)) return e1.map(function(e1) {
                        return "string" == typeof e1 || "number" == typeof e1 || "boolean" == typeof e1 ? e1 : y(e1);
                    });
                    for(var t = {}, n = 0, r = Object.entries(e1); n < r.length; n++){
                        var o = (0, v.Z)(r[n], 2), i = o[0], a = o[1];
                        if (null != a) {
                            if ("object" === (0, h.Z)(a)) {
                                var u = Object.keys(a);
                                if ([
                                    "value",
                                    "form"
                                ].includes(i) && 1 === u.length && [
                                    "value",
                                    "form"
                                ].includes(u[0])) {
                                    var c = y(a);
                                    Object.entries(c).forEach(function(e1) {
                                        var n = (0, v.Z)(e1, 2), r = n[0], o = n[1];
                                        t[r] = o;
                                    });
                                } else t[i] = y(a);
                            } else t[i] = a;
                        }
                    }
                    return t;
                }
                var g = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces",
                    "value",
                    "action"
                ];
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = function(e1) {
                    (0, c.Z)(l, e1);
                    var t, n, o = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, f.Z)(t);
                        if (n) {
                            var o = (0, f.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, s.Z)(this, e1);
                    });
                    function l() {
                        return (0, a.Z)(this, l), o.apply(this, arguments);
                    }
                    return (0, u.Z)(l, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !("function" != typeof this.remediation.action || "poll" !== this.remediation.name && !this.remediation.name.endsWith("-poll") && !this.options.step);
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1 = this;
                                return this.getInputs().reduce(function(t, n) {
                                    var r = n.name;
                                    return t[r] = e1.values[r], t;
                                }, {});
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, o = this.getName(), a = this.getInputs(), u = this.remediation, c = (u.href, u.method, u.rel, u.accepts, u.produces, u.value, u.action), s = (0, i.Z)(u, g);
                                return c ? b(b(b({}, s), !!a.length && {
                                    inputs: a
                                }), {}, {
                                    action: (n = (0, r.Z)(p().mark(function t(n) {
                                        return p().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return t.abrupt("return", e1.idx.proceed(b({
                                                        step: o
                                                    }, n)));
                                                case 1:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    })), function(e1) {
                                        return n.apply(this, arguments);
                                    })
                                }) : b({}, this.remediation);
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return (this.remediation.value || []).filter(function(e1) {
                                    return "stateHandle" !== e1.name;
                                }).map(y).map(function(e1) {
                                    return e1.type = e1.type || "string", e1;
                                });
                            }
                        }
                    ]), l;
                }(d.n);
            },
            8628: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        var e1;
                        (0, r.Z)(this, p);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = f.call.apply(f, [
                            this
                        ].concat(n)), (0, s.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData().identifier;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values, t = e1.credentials, n = e1.password;
                                if (t || n) return t || {
                                    passcode: n
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return l(l({}, e1.form.value[0]), {}, {
                                    name: "password",
                                    required: e1.required
                                });
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "identify");
            },
            9024: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values.newPassword;
                                if (e1) return {
                                    passcode: e1
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                var t = "password" === this.getAuthenticator().type ? "newPassword" : "verificationCode";
                                return f(f({}, e1.form.value[0]), {}, {
                                    name: t
                                });
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(l, "remediationName", "reenroll-authenticator");
            },
            8107: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    i: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9024).j);
                (0, c.Z)(s, "remediationName", "reenroll-authenticator-warning");
            },
            8490: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    O: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function() {
                                var e1 = this.remediation;
                                return {
                                    name: e1.name,
                                    type: e1.type,
                                    idp: e1.idp,
                                    href: e1.href
                                };
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "redirect-idp");
            },
            1019: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "reset-authenticator");
            },
            7311: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(3144), i = n(5671), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9164), l = n(6064), p = n(7595);
                var d = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t, n, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, f);
                        var u = "recoverPassword" === (n = s.call(this, e1, o, a)).options.flow;
                        return (null === (t = (0, l.zg)(e1).options) || void 0 === t ? void 0 : t.some(function(e1) {
                            var t = e1.relatesTo;
                            return (null == t ? void 0 : t.key) === p.pc.OKTA_PASSWORD;
                        })) && (u || n.values.password) && (n.values.authenticators = [].concat((0, r.Z)(n.values.authenticators || []), [
                            {
                                key: p.pc.OKTA_PASSWORD
                            }
                        ])), n;
                    }
                    return (0, o.Z)(f);
                }(f.n);
                (0, s.Z)(d, "remediationName", "select-authenticator-authenticate");
            },
            9865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9164).n);
                (0, c.Z)(s, "remediationName", "select-authenticator-enroll");
            },
            5272: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return d;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d() {
                        var e1;
                        (0, r.Z)(this, d);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "authenticator", void 0), (0, f.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(d, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData("identifier") && (0, a.Z)((0, s.Z)(d.prototype), "canRemediate", this).call(this);
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t, n, r, o = (0, a.Z)((0, s.Z)(d.prototype), "mapAuthenticator", this).call(this, e1), i = null === (t = this.selectedOption) || void 0 === t ? void 0 : t.value.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                }), u = this.values.methodType || (null == i ? void 0 : i.value) || (null == i || null === (n = i.options) || void 0 === n || null === (r = n[0]) || void 0 === r ? void 0 : r.value);
                                return u ? p(p({}, o), {}, {
                                    methodType: u
                                }) : o;
                            }
                        },
                        {
                            key: "getInputUsername",
                            value: function() {
                                return {
                                    name: "username",
                                    type: "string"
                                };
                            }
                        }
                    ]), d;
                }(n(9164).n);
                (0, f.Z)(d, "remediationName", "select-authenticator-unlock-account");
            },
            4713: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "select-enroll-profile");
            },
            3403: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.values.channel) return !0;
                                if (this.values.authenticator) {
                                    var e1 = this.values.authenticator, t = e1.id, n = e1.channel;
                                    if (t && n) return !0;
                                }
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1;
                                return {
                                    authenticator: {
                                        id: this.remediation.value[0].value.form.value[0].value,
                                        channel: (null === (e1 = this.values.authenticator) || void 0 === e1 ? void 0 : e1.channel) || this.values.channel
                                    },
                                    stateHandle: this.values.stateHandle
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, i.Z)((0, c.Z)(p.prototype), "getValuesAfterProceed", this).call(this), delete this.values.authenticators;
                                var t = this.values.channel ? "channel" : "authenticator";
                                return Object.keys(this.values).filter(function(e1) {
                                    return e1 !== t;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "select-enrollment-channel");
            },
            8443: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.skip || "skip" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "skip");
            },
            6064: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.map(function(e1) {
                        return e1.name;
                    });
                }
                function o(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.reduce(function(e1, t) {
                        return t.required && e1.push(t.name), e1;
                    }, []);
                }
                function i(e1) {
                    return e1.charAt(0).toUpperCase() + e1.substring(1);
                }
                function a(e1) {
                    return e1.value.find(function(e1) {
                        return "authenticator" === e1.name;
                    });
                }
                n.d(t, {
                    QG: function() {
                        return o;
                    },
                    Qs: function() {
                        return i;
                    },
                    ix: function() {
                        return r;
                    },
                    zg: function() {
                        return a;
                    }
                });
            },
            3377: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return M;
                    }
                });
                var r = n(5861), o = n(4942), i = n(4687), a = n.n(i), u = n(6131), c = n(2660), s = n(1002), f = n(2982), l = n(9123), p = n(5031);
                function d(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return h(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function h(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    return Object.keys(t.actions).find(function(t) {
                        return !!e1.resend && t.includes("-resend");
                    });
                }
                function m(e1) {
                    return y(y({}, e1), {}, {
                        resend: void 0
                    });
                }
                function b(e1, t) {
                    var n = e1.actions || [];
                    return n = n.filter(function(e1) {
                        return "string" == typeof e1 ? e1 !== t : e1.name !== t;
                    }), y(y({}, e1), {}, {
                        actions: n
                    });
                }
                function k(e1, t, n, r) {
                    return w.apply(this, arguments);
                }
                function w() {
                    return (w = (0, r.Z)(a().mark(function e1(t, n, r, o) {
                        var i, u, c, h, v, w, O, Z, T, E, S, x, P, A, R, _, j, C;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (u = (i = n).neededToProceed, c = i.interactionCode, h = o.flow, !c) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 4:
                                    if (v = (0, p.l6)(n, r, o), w = g(r, n), O = o.actions || [], !(Z = [].concat((0, f.Z)(O), (0, f.Z)(w && [
                                        w
                                    ] || [])))) {
                                        e1.next = 28;
                                        break;
                                    }
                                    T = d(Z), e1.prev = 10, S = a().mark(function e1() {
                                        var i, c, s, f;
                                        return a().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (i = E.value, c = {}, "string" != typeof i && (c = i.params || {}, i = i.name), s = m(r), f = b(o, i), "function" != typeof n.actions[i]) {
                                                        e1.next = 14;
                                                        break;
                                                    }
                                                    return e1.next = 8, n.actions[i](c);
                                                case 8:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: (0, p.Tc)(t, n, o)
                                                    });
                                                case 11:
                                                    if ("cancel" !== i) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: {
                                                            idxResponse: n,
                                                            canceled: !0
                                                        }
                                                    });
                                                case 13:
                                                    return e1.abrupt("return", {
                                                        v: k(t, n, s, f)
                                                    });
                                                case 14:
                                                    if (!u.find(function(e1) {
                                                        return e1.name === i;
                                                    })) {
                                                        e1.next = 22;
                                                        break;
                                                    }
                                                    return e1.next = 18, n.proceed(i, c);
                                                case 18:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 21;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: (0, p.Tc)(t, n, o)
                                                    });
                                                case 21:
                                                    return e1.abrupt("return", {
                                                        v: k(t, n, r, f)
                                                    });
                                                case 22:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }), T.s();
                                case 13:
                                    if ((E = T.n()).done) {
                                        e1.next = 20;
                                        break;
                                    }
                                    return e1.delegateYield(S(), "t0", 15);
                                case 15:
                                    if (x = e1.t0, "object" !== (0, s.Z)(x)) {
                                        e1.next = 18;
                                        break;
                                    }
                                    return e1.abrupt("return", x.v);
                                case 18:
                                    e1.next = 13;
                                    break;
                                case 20:
                                    e1.next = 25;
                                    break;
                                case 22:
                                    e1.prev = 22, e1.t1 = e1.catch(10), T.e(e1.t1);
                                case 25:
                                    return e1.prev = 25, T.f(), e1.finish(25);
                                case 28:
                                    if (!(P = (0, p.xn)(n))) {
                                        e1.next = 31;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n,
                                        terminal: P
                                    });
                                case 31:
                                    if (v) {
                                        e1.next = 43;
                                        break;
                                    }
                                    if (!o.step) {
                                        e1.next = 40;
                                        break;
                                    }
                                    return r = (0, p.Ax)(n, o.step, r), e1.next = 36, n.proceed(o.step, r);
                                case 36:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 39;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, p.Tc)(t, n, o));
                                case 39:
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 40:
                                    if ("default" !== h) {
                                        e1.next = 42;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 42:
                                    throw new l.Z("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(u.reduce(function(e1, t) {
                                        return e1 ? e1 + " ," + t.name : t.name;
                                    }, ""), "]\n    "));
                                case 43:
                                    if (v.canRemediate()) {
                                        e1.next = 46;
                                        break;
                                    }
                                    return A = (0, p.TR)(t, v, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: A
                                    });
                                case 46:
                                    return R = v.getName(), _ = v.getData(), e1.next = 50, n.proceed(R, _);
                                case 50:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 53;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, p.Tc)(t, n, o));
                                case 53:
                                    if (r = v.getValuesAfterProceed(), !(o = y(y({}, o), {}, {
                                        step: void 0
                                    })).useGenericRemediator || n.interactionCode || (0, p.xn)(n)) {
                                        e1.next = 59;
                                        break;
                                    }
                                    return j = (0, p.l6)(n, r, o), C = (0, p.TR)(t, j, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: C
                                    });
                                case 59:
                                    return e1.abrupt("return", k(t, n, r, o));
                                case 60:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                10,
                                22,
                                25,
                                28
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                var O = n(7595), Z = n(2620);
                function T(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function E(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? T(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function S(e1) {
                    var t = E({}, e1);
                    return [
                        "flow",
                        "remediators",
                        "actions",
                        "withCredentials",
                        "step",
                        "useGenericRemediator",
                        "exchangeCodeForTokens"
                    ].forEach(function(e1) {
                        delete t[e1];
                    }), t;
                }
                function x(e1, t) {
                    var n, r, o = t.options, i = o = E(E({}, e1.options.idx), o), a = i.flow, u = i.withCredentials, c = i.remediators, s = i.actions, f = O.Qd.PENDING;
                    a = a || (null === (n = (r = e1.idx).getFlow) || void 0 === n ? void 0 : n.call(r)) || "default";
                    var l, d;
                    null === (l = (d = e1.idx).setFlow) || void 0 === l || l.call(d, a);
                    var h = (0, p.sH)(e1, a);
                    u = void 0 !== u ? u : h.withCredentials, c = c || h.remediators, s = s || h.actions;
                    return E(E({}, t), {}, {
                        options: E(E({}, o), {}, {
                            flow: a,
                            withCredentials: u,
                            remediators: c,
                            actions: s
                        }),
                        status: f
                    });
                }
                function P(e1, t) {
                    return A.apply(this, arguments);
                }
                function A() {
                    return (A = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, s, f, l, p, d, h, v, y, g, m, b, k, w, O;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = r.stateHandle, i = r.withCredentials, s = r.version, f = r.state, l = r.scopes, p = r.recoveryToken, d = r.activationToken, h = r.maxAge, v = r.acrValues, y = r.nonce, g = r.useGenericRemediator, b = (0, Z.uN)(t, {
                                        state: f,
                                        recoveryToken: p,
                                        activationToken: d
                                    }), !o) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 6, (0, c.L)(t, {
                                        withCredentials: i,
                                        version: s,
                                        stateHandle: o,
                                        useGenericRemediator: g
                                    });
                                case 6:
                                    m = e1.sent, e1.next = 20;
                                    break;
                                case 9:
                                    if (w = null === (k = b) || void 0 === k ? void 0 : k.interactionHandle) {
                                        e1.next = 17;
                                        break;
                                    }
                                    return t.transactionManager.clear(), e1.next = 14, (0, u.E)(t, {
                                        withCredentials: i,
                                        state: f,
                                        scopes: l,
                                        activationToken: d,
                                        recoveryToken: p,
                                        maxAge: h,
                                        acrValues: v,
                                        nonce: y
                                    });
                                case 14:
                                    O = e1.sent, w = O.interactionHandle, b = O.meta;
                                case 17:
                                    return e1.next = 19, (0, c.L)(t, {
                                        withCredentials: i,
                                        version: s,
                                        interactionHandle: w,
                                        useGenericRemediator: g
                                    });
                                case 19:
                                    m = e1.sent;
                                case 20:
                                    return e1.abrupt("return", E(E({}, n), {}, {
                                        idxResponse: m,
                                        meta: b
                                    }));
                                case 21:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function R(e1, t) {
                    return _.apply(this, arguments);
                }
                function _() {
                    return (_ = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, p, d, h, v, y;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.idxResponse, o = n.options, i = n.values, u = o.autoRemediate, c = o.remediators, s = o.actions, f = o.flow, l = o.step, p = o.useGenericRemediator, !1 !== u && (c || s || l)) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 5:
                                    return i = E(E({}, i), {}, {
                                        stateHandle: r.rawIdxState.stateHandle
                                    }), e1.next = 8, k(t, r, i, {
                                        remediators: c,
                                        actions: s,
                                        flow: f,
                                        step: l,
                                        useGenericRemediator: p
                                    });
                                case 8:
                                    return d = e1.sent, h = d.idxResponse, v = d.nextStep, y = d.canceled, r = h, e1.abrupt("return", E(E({}, n), {}, {
                                        idxResponse: r,
                                        nextStep: v,
                                        canceled: y
                                    }));
                                case 14:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function j(e1, t) {
                    return C.apply(this, arguments);
                }
                function C() {
                    return (C = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, p, d, h;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = n.meta, o = n.idxResponse, i = o.interactionCode, c = (u = r).clientId, s = u.codeVerifier, f = u.ignoreSignature, l = u.redirectUri, p = u.urls, d = u.scopes, e1.next = 5, t.token.exchangeCodeForTokens({
                                        interactionCode: i,
                                        clientId: c,
                                        codeVerifier: s,
                                        ignoreSignature: f,
                                        redirectUri: l,
                                        scopes: d
                                    }, p);
                                case 5:
                                    return h = e1.sent, e1.abrupt("return", h.tokens);
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function I(e1, t) {
                    return D.apply(this, arguments);
                }
                function D() {
                    return (D = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, d, h, v, y, g, m, b, k;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = n.idxResponse, i = n.canceled, u = n.status, c = r.exchangeCodeForTokens, s = !1, f = !1, l = !0, o && (s = !(!o.requestDidSucceed && !o.stepUp), v = (0, p.KM)(o), y = (0, p.kw)(t, o, r.useGenericRemediator), g = (0, p.lx)(o, r), m = (0, p.xn)(o)), !m) {
                                        e1.next = 15;
                                        break;
                                    }
                                    u = O.Qd.TERMINAL, b = Object.keys(o.actions).length > 0, k = !!g.find(function(e1) {
                                        return "ERROR" === e1.class;
                                    }), b || k || !0 !== o.requestDidSucceed ? s = !!b : f = !0, l = !1, e1.next = 32;
                                    break;
                                case 15:
                                    if (!i) {
                                        e1.next = 20;
                                        break;
                                    }
                                    u = O.Qd.CANCELED, f = !0, e1.next = 32;
                                    break;
                                case 20:
                                    if (null == o || !o.interactionCode) {
                                        e1.next = 32;
                                        break;
                                    }
                                    if (d = o.interactionCode, !1 !== c) {
                                        e1.next = 27;
                                        break;
                                    }
                                    u = O.Qd.SUCCESS, f = !1, e1.next = 32;
                                    break;
                                case 27:
                                    return e1.next = 29, j(t, n);
                                case 29:
                                    h = e1.sent, u = O.Qd.SUCCESS, f = !0;
                                case 32:
                                    return e1.abrupt("return", E(E({}, n), {}, {
                                        status: u,
                                        interactionCode: d,
                                        tokens: h,
                                        shouldSaveResponse: s,
                                        shouldClearTransaction: f,
                                        clearSharedStorage: l,
                                        enabledFeatures: v,
                                        availableSteps: y,
                                        messages: g,
                                        terminal: m
                                    }));
                                case 33:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function M(e1) {
                    return N.apply(this, arguments);
                }
                function N() {
                    return N = (0, r.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, c, s, f, l, p, d, h, v, y, g, m, b, k, w, O, T, A, _, j, C, D, M, N, U = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = {
                                        options: n = U.length > 1 && void 0 !== U[1] ? U[1] : {},
                                        values: S(n)
                                    }, r = x(t, r), e1.next = 5, P(t, r);
                                case 5:
                                    return r = e1.sent, e1.next = 8, R(t, r);
                                case 8:
                                    return r = e1.sent, e1.next = 11, I(t, r);
                                case 11:
                                    return r = e1.sent, i = (o = r).idxResponse, u = o.meta, c = o.shouldSaveResponse, s = o.shouldClearTransaction, f = o.clearSharedStorage, l = o.status, p = o.enabledFeatures, d = o.availableSteps, h = o.tokens, v = o.nextStep, y = o.messages, g = o.error, m = o.interactionCode, s ? t.transactionManager.clear({
                                        clearSharedStorage: f
                                    }) : ((0, Z.r0)(t, E({}, u)), c && (w = (k = i).rawIdxState, O = k.requestDidSucceed, t.transactionManager.saveIdxResponse({
                                        rawIdxResponse: w,
                                        requestDidSucceed: O,
                                        stateHandle: null === (b = i.context) || void 0 === b ? void 0 : b.stateHandle,
                                        interactionHandle: null == u ? void 0 : u.interactionHandle
                                    }))), A = (T = i || {}).actions, _ = T.context, j = T.neededToProceed, C = T.proceed, D = T.rawIdxState, M = T.requestDidSucceed, N = T.stepUp, e1.abrupt("return", E(E(E(E(E(E(E(E(E({
                                        status: l
                                    }, u && {
                                        meta: u
                                    }), p && {
                                        enabledFeatures: p
                                    }), d && {
                                        availableSteps: d
                                    }), h && {
                                        tokens: h
                                    }), v && {
                                        nextStep: v
                                    }), y && y.length && {
                                        messages: y
                                    }), g && {
                                        error: g
                                    }), N && {
                                        stepUp: N
                                    }), {}, {
                                        interactionCode: m,
                                        actions: A,
                                        context: _,
                                        neededToProceed: j,
                                        proceed: C,
                                        rawIdxState: D,
                                        requestDidSucceed: M
                                    }));
                                case 16:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), N.apply(this, arguments);
                }
            },
            2473: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return l = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = r.length > 1 && void 0 !== r[1] ? r[1] : {}, t.transactionManager.clear(), e1.abrupt("return", (0, u.K)(t, s({
                                        exchangeCodeForTokens: !1
                                    }, n)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), l.apply(this, arguments);
                }
            },
            4143: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5763), s = n(1971), f = n(2647), l = n(415), p = n(146), d = n(9123);
                function h() {
                    return function(e1) {
                        (0, i.Z)(h, e1);
                        var t, n, f = (t = h, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function h(e1, t, n) {
                            return (0, r.Z)(this, h), f.call(this, e1, t, n);
                        }
                        return (0, o.Z)(h, [
                            {
                                key: "getIdxResponseStorage",
                                value: function(e1) {
                                    var t;
                                    if ((0, l.isBrowser)()) try {
                                        t = this.storageUtil.getStorageByType("memory", e1);
                                    } catch (e1) {
                                        (0, p.ZK)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic");
                                    }
                                    else {
                                        var n = this.getTransactionStorage(e1);
                                        n && (t = {
                                            getItem: function(e1) {
                                                var t = n.getStorage();
                                                return t && t[e1] ? t[e1] : null;
                                            },
                                            setItem: function(e1, t) {
                                                var r = n.getStorage();
                                                if (!r) throw new d.Z("Transaction has been cleared, failed to save idxState");
                                                r[e1] = t, n.setStorage(r);
                                            },
                                            removeItem: function(e1) {
                                                var t = n.getStorage();
                                                t && (delete t[e1], n.setStorage(t));
                                            }
                                        });
                                    }
                                    return t ? new c._(t, s.IDX_RESPONSE_STORAGE_NAME) : null;
                                }
                            }
                        ]), h;
                    }((0, f.a)());
                }
            },
            2620: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $0: function() {
                        return h;
                    },
                    Co: function() {
                        return y;
                    },
                    Jm: function() {
                        return b;
                    },
                    UC: function() {
                        return O;
                    },
                    Wf: function() {
                        return k;
                    },
                    Xc: function() {
                        return p;
                    },
                    bl: function() {
                        return w;
                    },
                    r0: function() {
                        return m;
                    },
                    uN: function() {
                        return v;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3193), c = n(146), s = n(2865);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, c, f, p, d, h, v, y, g, m, b, k, w, O = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = O.length > 1 && void 0 !== O[1] ? O[1] : {}, e1.next = 3, t.token.prepareTokenParams(n);
                                case 3:
                                    return r = e1.sent, o = (0, s.H)(t, r), i = l(l({}, t.options), n), u = i.flow, c = void 0 === u ? "default" : u, f = i.withCredentials, p = void 0 === f || f, d = i.activationToken, h = void 0 === d ? void 0 : d, v = i.recoveryToken, y = void 0 === v ? void 0 : v, g = i.maxAge, m = void 0 === g ? void 0 : g, b = i.acrValues, k = void 0 === b ? void 0 : b, w = l(l({}, o), {}, {
                                        flow: c,
                                        withCredentials: p,
                                        activationToken: h,
                                        recoveryToken: y,
                                        maxAge: m,
                                        acrValues: k
                                    }), e1.abrupt("return", w);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), d.apply(this, arguments);
                }
                function h(e1, t) {
                    var n = v(e1, t);
                    return !(null == n || !n.interactionHandle);
                }
                function v(e1, t) {
                    var n;
                    t = (0, u.YY)(t), t = l(l({}, e1.options), t);
                    try {
                        n = e1.transactionManager.load(t);
                    } catch (e1) {}
                    if (n) return k(n, t) ? n : void (0, c.ZK)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
                }
                function y(e1, t) {
                    return g.apply(this, arguments);
                }
                function g() {
                    return (g = (0, o.Z)(a().mark(function e1(t, n) {
                        var r;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = (0, u.YY)(n), n = l(l({}, t.options), n), !(r = v(t, n))) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", r);
                                case 5:
                                    return e1.abrupt("return", p(t, n));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function m(e1, t) {
                    e1.transactionManager.save(t, {
                        muteWarning: !0
                    });
                }
                function b(e1) {
                    e1.transactionManager.clear();
                }
                function k(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return !1 !== O(e1, t, [
                        "issuer",
                        "clientId",
                        "redirectUri",
                        "state",
                        "codeChallenge",
                        "codeChallengeMethod",
                        "activationToken",
                        "recoveryToken"
                    ]) && !1 !== w(e1, t.flow);
                }
                function w(e1, t) {
                    return !(t && "default" !== t && "proceed" !== t) || t === e1.flow;
                }
                function O(e1, t, n) {
                    return !n.some(function(n) {
                        var r = t[n];
                        if (r && r !== e1[n]) return !0;
                    });
                }
            },
            7595: function(e1, t, n) {
                "use strict";
                var r, o, i;
                function a(e1) {
                    return e1 && (e1.key || e1.id);
                }
                n.d(t, {
                    Fw: function() {
                        return i;
                    },
                    H: function() {
                        return a;
                    },
                    Qd: function() {
                        return r;
                    },
                    pc: function() {
                        return o;
                    }
                }), function(e1) {
                    e1.SUCCESS = "SUCCESS", e1.PENDING = "PENDING", e1.FAILURE = "FAILURE", e1.TERMINAL = "TERMINAL", e1.CANCELED = "CANCELED";
                }(r || (r = {})), function(e1) {
                    e1.OKTA_PASSWORD = "okta_password", e1.OKTA_EMAIL = "okta_email", e1.PHONE_NUMBER = "phone_number", e1.GOOGLE_AUTHENTICATOR = "google_otp", e1.SECURITY_QUESTION = "security_question", e1.OKTA_VERIFY = "okta_verify", e1.WEBAUTHN = "webauthn";
                }(o || (o = {})), function(e1) {
                    e1.PASSWORD_RECOVERY = "recover-password", e1.REGISTRATION = "enroll-profile", e1.SOCIAL_IDP = "redirect-idp", e1.ACCOUNT_UNLOCK = "unlock-account";
                }(i || (i = {}));
            },
            480: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return e1 && e1.version;
                }
                n.d(t, {
                    P: function() {
                        return r;
                    }
                });
            },
            8277: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    l: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((n = i.length > 1 && void 0 !== i[1] ? i[1] : {}).flow = "unlockAccount", (0, c.$0)(t)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.Y)(t, d(d({}, n), {}, {
                                        autoRemediate: !1
                                    }));
                                case 5:
                                    if (r = e1.sent, !(o = r.enabledFeatures) || o.includes(l.Fw.ACCOUNT_UNLOCK)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("Self Service Account Unlock is not supported based on your current org configuration.");
                                case 9:
                                    return e1.abrupt("return", (0, u.K)(t, d({}, n)));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            5031: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Ax: function() {
                        return x;
                    },
                    KM: function() {
                        return E;
                    },
                    TC: function() {
                        return k;
                    },
                    TR: function() {
                        return R;
                    },
                    Tc: function() {
                        return _;
                    },
                    kw: function() {
                        return S;
                    },
                    l6: function() {
                        return A;
                    },
                    lx: function() {
                        return T;
                    },
                    sH: function() {
                        return w;
                    },
                    xn: function() {
                        return O;
                    }
                });
                var r = n(4942), o = n(4925), i = n(5861), a = n(885), u = n(2982), c = n(4687), s = n.n(c), f = n(8750), l = n(146), p = n(9732), d = n(7595), h = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces"
                ];
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return m(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function m(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var b = {
                    remediators: {},
                    getFlowSpecification: function(e1) {
                        return {
                            remediators: {}
                        };
                    }
                };
                function k(e1) {
                    Object.assign(b, e1);
                }
                function w(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
                    return b.getFlowSpecification(e1, t);
                }
                function O(e1) {
                    var t = e1.neededToProceed, n = e1.interactionCode;
                    return !t.length && !n;
                }
                function Z(e1) {
                    if (e1 && Array.isArray(e1)) return e1.reduce(function(e1, t) {
                        if (t.messages && (e1 = [].concat((0, u.Z)(e1), (0, u.Z)(t.messages.value))), t.form) {
                            var n = Z(t.form.value) || [];
                            e1 = [].concat((0, u.Z)(e1), (0, u.Z)(n));
                        }
                        if (t.options) {
                            var r = [];
                            t.options.forEach(function(e1) {
                                e1.value && "string" != typeof e1.value && (r = [].concat((0, u.Z)(r), [
                                    e1.value
                                ]));
                            });
                            var o = Z(r) || [];
                            e1 = [].concat((0, u.Z)(e1), (0, u.Z)(o));
                        }
                        return e1;
                    }, []);
                }
                function T(e1, t) {
                    var n, r = [], o = e1.rawIdxState, i = e1.neededToProceed, a = null === (n = o.messages) || void 0 === n ? void 0 : n.value.map(function(e1) {
                        return e1;
                    });
                    if (a && (r = [].concat((0, u.Z)(r), (0, u.Z)(a))), !t.useGenericRemediator) {
                        var c, s = g(i);
                        try {
                            for(s.s(); !(c = s.n()).done;){
                                var f = Z(c.value.value);
                                f && (r = [].concat((0, u.Z)(r), (0, u.Z)(f)));
                            }
                        } catch (e1) {
                            s.e(e1);
                        } finally{
                            s.f();
                        }
                    }
                    var l = {};
                    return r.reduce(function(e1, t) {
                        var n, r = null === (n = t.i18n) || void 0 === n ? void 0 : n.key;
                        return r && l[r] && t.message === l[r].message ? e1 : (l[r] = t, e1 = [].concat((0, u.Z)(e1), [
                            t
                        ]));
                    }, []);
                }
                function E(e1) {
                    var t = [], n = e1.actions, r = e1.neededToProceed;
                    return n["currentAuthenticator-recover"] && t.push(d.Fw.PASSWORD_RECOVERY), r.some(function(e1) {
                        return "select-enroll-profile" === e1.name;
                    }) && t.push(d.Fw.REGISTRATION), r.some(function(e1) {
                        return "redirect-idp" === e1.name;
                    }) && t.push(d.Fw.SOCIAL_IDP), r.some(function(e1) {
                        return "unlock-account" === e1.name;
                    }) && t.push(d.Fw.ACCOUNT_UNLOCK), t;
                }
                function S(e1, t, n) {
                    var r, u = [], c = Object.values(b.remediators).reduce(function(e1, t) {
                        return t.remediationName && (e1[t.remediationName] = t), e1;
                    }, {}), l = g(t.neededToProceed);
                    try {
                        for(l.s(); !(r = l.n()).done;){
                            var p = r.value, d = P(p, {
                                useGenericRemediator: n,
                                remediators: c
                            });
                            if (d) {
                                var v = new d(p);
                                u.push(v.getNextStep(e1, t.context));
                            }
                        }
                    } catch (e1) {
                        l.e(e1);
                    } finally{
                        l.f();
                    }
                    for(var m = function() {
                        var n, r = (0, a.Z)(w[k], 1)[0], c = {
                            name: r,
                            action: (n = (0, i.Z)(s().mark(function t(n) {
                                return s().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return t.abrupt("return", e1.idx.proceed({
                                                actions: [
                                                    {
                                                        name: r,
                                                        params: n
                                                    }
                                                ]
                                            }));
                                        case 1:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            })), function(e1) {
                                return n.apply(this, arguments);
                            })
                        };
                        if (r.startsWith("currentAuthenticator")) {
                            var l, p = (0, f.YQ)(r, "-"), d = (0, a.Z)(p, 2), v = d[0], g = d[1], m = t.rawIdxState[v].value[g], b = (m.href, m.method, m.rel, m.accepts, m.produces, (0, o.Z)(m, h)), O = null === (l = m.value) || void 0 === l ? void 0 : l.filter(function(e1) {
                                return "stateHandle" !== e1.name;
                            });
                            c = y(y(y({}, b), O && {
                                value: O
                            }), c);
                        }
                        u.push(c);
                    }, k = 0, w = Object.entries(t.actions || {}); k < w.length; k++)m();
                    return u;
                }
                function x(e1, t, n) {
                    var r = (e1.neededToProceed || []).find(function(e1) {
                        return e1.name === t;
                    });
                    return r ? r.value.reduce(function(e1, t) {
                        var r = t.name, o = t.value;
                        return e1[r] = "stateHandle" === r ? o : n[r], e1;
                    }, {}) : ((0, l.ZK)('filterValuesForRemediation: "'.concat(t, '" did not match any remediations')), n);
                }
                function P(e1, t) {
                    var n = t.useGenericRemediator, r = t.remediators;
                    if (e1) return n ? p.P : r[e1.name];
                }
                function A(e1, t, n) {
                    var r, o = n.remediators, i = n.useGenericRemediator, a = e1.neededToProceed, u = e1.context;
                    if (!n.step) {
                        var c = [];
                        if (i) c.push(new p.P(a[0], t, n));
                        else {
                            var s, f = g(a);
                            try {
                                for(f.s(); !(s = f.n()).done;){
                                    var d = s.value;
                                    if (Object.keys(o).includes(d.name)) {
                                        if ((r = new (P(d, n))(d, t, n)).canRemediate(u)) return r;
                                        c.push(r);
                                    }
                                }
                            } catch (e1) {
                                f.e(e1);
                            } finally{
                                f.f();
                            }
                        }
                        return c[0];
                    }
                    var h = a.find(function(e1) {
                        return e1.name === n.step;
                    });
                    if (h) {
                        var v = P(h, n);
                        return v ? new v(h, t, n) : void 0;
                    }
                    (0, l.ZK)('step "'.concat(n.step, '" did not match any remediations'));
                }
                function R(e1, t, n) {
                    var r = t.getNextStep(e1, n.context), o = function(e1) {
                        return e1.neededToProceed.some(function(e1) {
                            return "skip" === e1.name;
                        });
                    }(n), i = function(e1) {
                        return Object.keys(e1.actions).some(function(e1) {
                            return e1.includes("resend");
                        });
                    }(n);
                    return y(y(y({}, r), o && {
                        canSkip: o
                    }), i && {
                        canResend: i
                    });
                }
                function _(e1, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = O(t), o = T(t, n);
                    if (r) return {
                        idxResponse: t,
                        terminal: r,
                        messages: o
                    };
                    var i = A(t, {}, n), a = i && R(e1, i, t);
                    return y({
                        idxResponse: t,
                        messages: o
                    }, a && {
                        nextStep: a
                    });
                }
            },
            8716: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    buildCredentialCreationOptions: function() {
                        return i;
                    },
                    buildCredentialRequestOptions: function() {
                        return a;
                    },
                    getAssertion: function() {
                        return c;
                    },
                    getAttestation: function() {
                        return u;
                    }
                });
                var r = n(7987), o = function() {
                    var e1 = [];
                    return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach(function(t) {
                        "webauthn" === t.key && e1.push({
                            type: "public-key",
                            id: (0, r.dX)(t.credentialId)
                        });
                    }), e1;
                }, i = function(e1, t) {
                    return {
                        publicKey: {
                            rp: e1.rp,
                            user: {
                                id: (0, r.dX)(e1.user.id),
                                name: e1.user.name,
                                displayName: e1.user.displayName
                            },
                            challenge: (0, r.dX)(e1.challenge),
                            pubKeyCredParams: e1.pubKeyCredParams,
                            attestation: e1.attestation,
                            authenticatorSelection: e1.authenticatorSelection,
                            excludeCredentials: o(t)
                        }
                    };
                }, a = function(e1, t) {
                    return {
                        publicKey: {
                            challenge: (0, r.dX)(e1.challenge),
                            userVerification: e1.userVerification,
                            allowCredentials: o(t)
                        }
                    };
                }, u = function(e1) {
                    var t = e1.response;
                    return {
                        id: e1.id,
                        clientData: (0, r.kQ)(t.clientDataJSON),
                        attestation: (0, r.kQ)(t.attestationObject)
                    };
                }, c = function(e1) {
                    var t = e1.response;
                    return {
                        id: e1.id,
                        clientData: (0, r.kQ)(t.clientDataJSON),
                        authenticatorData: (0, r.kQ)(t.authenticatorData),
                        signatureData: (0, r.kQ)(t.signature)
                    };
                };
            },
            9108: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    addEmail: function() {
                        return B;
                    },
                    addPhone: function() {
                        return z;
                    },
                    deleteEmail: function() {
                        return K;
                    },
                    deletePassword: function() {
                        return oe;
                    },
                    deletePhone: function() {
                        return Q;
                    },
                    enrollPassword: function() {
                        return ne;
                    },
                    getEmail: function() {
                        return H;
                    },
                    getEmailChallenge: function() {
                        return G;
                    },
                    getEmails: function() {
                        return L;
                    },
                    getPassword: function() {
                        return te;
                    },
                    getPhone: function() {
                        return Y;
                    },
                    getPhones: function() {
                        return W;
                    },
                    getProfile: function() {
                        return A;
                    },
                    getProfileSchema: function() {
                        return _;
                    },
                    sendEmailChallenge: function() {
                        return F;
                    },
                    sendPhoneChallenge: function() {
                        return X;
                    },
                    updatePassword: function() {
                        return re;
                    },
                    updateProfile: function() {
                        return R;
                    },
                    verifyEmailChallenge: function() {
                        return V;
                    },
                    verifyPhoneChallenge: function() {
                        return J;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(4942), u = n(1002), c = n(4925), s = n(3144), f = n(5671), l = [
                    "headers"
                ], p = (0, s.Z)(function e1(t, n) {
                    var r = this;
                    (0, f.Z)(this, e1), (0, a.Z)(this, "headers", void 0);
                    var o = n.res, i = o.headers, u = (0, c.Z)(o, l);
                    i && (this.headers = i), Object.keys(u).forEach(function(e1) {
                        "_links" !== e1 && (r[e1] = u[e1]);
                    });
                }), d = n(5385), h = n(9123);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, a.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return m = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c, s, f, l, v, g, m, b = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = b.length > 2 && void 0 !== b[2] ? b[2] : p, o = t.tokenManager.getTokensSync(), a = o.accessToken, u = n.accessToken || (null == a ? void 0 : a.accessToken), c = t.getIssuerOrigin(), s = n.url, f = n.method, l = n.payload, v = s.startsWith(c) ? s : "".concat(c).concat(s), u) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new h.Z("AccessToken is required to request MyAccount API endpoints.");
                                case 8:
                                    return e1.next = 10, (0, d.c3)(t, y({
                                        headers: {
                                            Accept: "*/*;okta-version=1.0.0"
                                        },
                                        accessToken: u,
                                        url: v,
                                        method: f
                                    }, l && {
                                        args: l
                                    }));
                                case 10:
                                    return g = e1.sent, m = Array.isArray(g) ? g.map(function(e1) {
                                        return new r(t, {
                                            res: e1,
                                            accessToken: u
                                        });
                                    }) : new r(t, {
                                        res: g,
                                        accessToken: u
                                    }), e1.abrupt("return", m);
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), m.apply(this, arguments);
                }
                function b(e1) {
                    for(var t = e1.oktaAuth, n = e1.accessToken, o = e1.methodName, a = e1.links, c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p, s = function() {
                        var e1, u = l[f];
                        if (u.toLowerCase() === o) {
                            var s = a.self;
                            return {
                                v: (e1 = (0, r.Z)(i().mark(function e1(r) {
                                    return i().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", g(t, {
                                                    accessToken: n,
                                                    url: s.href,
                                                    method: u,
                                                    payload: r
                                                }, c));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                })), function(t) {
                                    return e1.apply(this, arguments);
                                })
                            };
                        }
                    }, f = 0, l = [
                        "GET",
                        "POST",
                        "PUT",
                        "DELETE"
                    ]; f < l.length; f++){
                        var d = s();
                        if ("object" === (0, u.Z)(d)) return d.v;
                    }
                    var v, y = a[o];
                    if (!y) throw new h.Z("No link is found with methodName: ".concat(o));
                    return v = (0, r.Z)(i().mark(function e1(r) {
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.abrupt("return", g(t, {
                                        accessToken: n,
                                        url: y.href,
                                        method: y.hints.allow[0],
                                        payload: r
                                    }, c));
                                case 1:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), function(e1) {
                        return v.apply(this, arguments);
                    };
                }
                var k = n(7326), w = n(136), O = n(2963), Z = n(1120);
                var T = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "createdAt", void 0), (0, a.Z)((0, k.Z)(n), "modifiedAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0);
                        var i = t.res, u = i.createdAt, c = i.modifiedAt, s = i.profile;
                        return n.createdAt = u, n.modifiedAt = c, n.profile = s, n;
                    }
                    return (0, s.Z)(o);
                }(p);
                var E, S, x, P = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        return (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "properties", void 0), n.properties = t.res.properties, n;
                    }
                    return (0, s.Z)(o);
                }(p), A = (E = (0, r.Z)(i().mark(function e1(t, n) {
                    var r;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, g(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken
                                }, T);
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return E.apply(this, arguments);
                }), R = (S = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).payload, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "PUT",
                                    payload: o,
                                    accessToken: a
                                }, T);
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return S.apply(this, arguments);
                }), _ = (x = (0, r.Z)(i().mark(function e1(t, n) {
                    var r;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, g(t, {
                                    url: "/idp/myaccount/profile/schema",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken
                                }, P);
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return x.apply(this, arguments);
                });
                var j = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "expiresAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0);
                        var i = t.res, u = i.id, c = i.profile, s = i.expiresAt, l = i.status;
                        return n.id = u, n.expiresAt = s, n.profile = c, n.status = l, n;
                    }
                    return (0, s.Z)(o);
                }(p);
                var C = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "expiresAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "poll", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c = t.accessToken, s = t.res, l = s.id, p = s.expiresAt, d = s.profile, h = s.status, v = s._links;
                        return n.id = l, n.expiresAt = p, n.profile = d, n.status = h, n.poll = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: c,
                                            methodName: "poll",
                                            links: v
                                        }, j), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.verify = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: c,
                                                methodName: "verify",
                                                links: v
                                            }, u), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }(), n;
                    }
                    return (0, s.Z)(u);
                }(p);
                var I, D, M, N, U = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "roles", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0), (0, a.Z)((0, k.Z)(n), "challenge", void 0), (0, a.Z)((0, k.Z)(n), "poll", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c, s = t.accessToken, l = t.res, p = l.id, d = l.profile, h = l.roles, v = l.status, y = l._links;
                        return n.id = p, n.profile = d, n.roles = h, n.status = v, n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "get",
                                            links: y
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "delete",
                                            links: y
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "challenge",
                                            links: y
                                        }, C), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), y.poll && (n.poll = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "poll",
                                            links: y
                                        }, j), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), y.verify && (n.verify = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "verify",
                                            links: y
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        })), n;
                    }
                    return (0, s.Z)(u);
                }(p), L = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, U);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), H = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/emails/".concat(o),
                                        method: "GET",
                                        accessToken: a
                                    }, U);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), B = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, U);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), K = (I = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o),
                                    method: "DELETE",
                                    accessToken: a
                                });
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return I.apply(this, arguments);
                }), F = (D = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge"),
                                    method: "POST",
                                    accessToken: a
                                }, C);
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return D.apply(this, arguments);
                }), G = (M = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u, c;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, a = r.challengeId, u = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(a),
                                    method: "POST",
                                    accessToken: u
                                }, C);
                            case 3:
                                return c = e1.sent, e1.abrupt("return", c);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return M.apply(this, arguments);
                }), V = (N = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u, c, s;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, a = r.challengeId, u = r.payload, c = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(a, "/verify"),
                                    method: "POST",
                                    payload: u,
                                    accessToken: c
                                });
                            case 3:
                                return s = e1.sent, e1.abrupt("return", s);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return N.apply(this, arguments);
                });
                var q = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0), (0, a.Z)((0, k.Z)(n), "challenge", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c, s = t.res, l = t.accessToken, p = s.id, d = s.profile, h = s.status, v = s._links;
                        return n.id = p, n.profile = d, n.status = h, n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "get",
                                            links: v
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "delete",
                                            links: v
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "challenge",
                                            links: v
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        }), v.verify && (n.verify = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: l,
                                                methodName: "verify",
                                                links: v
                                            }), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }()), n;
                    }
                    return (0, s.Z)(u);
                }(p), W = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, q);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), Y = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.id, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(a),
                                        method: "GET",
                                        accessToken: o
                                    }, q);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), z = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, q);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), Q = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(o),
                                        method: "DELETE",
                                        accessToken: a
                                    });
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), X = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.id, u = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(a, "/challenge"),
                                        method: "POST",
                                        payload: u,
                                        accessToken: o
                                    });
                                case 3:
                                    return c = e1.sent, e1.abrupt("return", c);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), J = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.payload, u = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(o, "/verify"),
                                        method: "POST",
                                        payload: a,
                                        accessToken: u
                                    });
                                case 3:
                                    return c = e1.sent, e1.abrupt("return", c);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), $ = n(8008);
                var ee = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "created", void 0), (0, a.Z)((0, k.Z)(n), "lastUpdated", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "enroll", void 0), (0, a.Z)((0, k.Z)(n), "update", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0);
                        var c, s = t.res, l = t.accessToken, p = s.id, d = s.status, h = s.created, v = s.lastUpdated, y = s._links;
                        return n.id = p, n.status = d, n.created = h, n.lastUpdated = v, n.status == $.Fn.NOT_ENROLLED ? n.enroll = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: l,
                                                methodName: "enroll",
                                                links: y
                                            }, u), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }() : (n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "get",
                                            links: y
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.update = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "put",
                                            links: y
                                        }, u), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        }), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "delete",
                                            links: y
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), n;
                    }
                    return (0, s.Z)(u);
                }(p), te = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, ee);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), ne = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, ee);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), re = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "PUT",
                                        payload: a,
                                        accessToken: o
                                    }, ee);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), oe = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "DELETE",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    });
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }();
            },
            1132: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    aw: function() {
                        return u.aw;
                    },
                    Fn: function() {
                        return u.Fn;
                    },
                    qb: function() {
                        return u.qb;
                    },
                    no: function() {
                        return r.addEmail;
                    },
                    Z1: function() {
                        return r.addPhone;
                    },
                    Xc: function() {
                        return a;
                    },
                    nd: function() {
                        return r.deleteEmail;
                    },
                    QN: function() {
                        return r.deletePassword;
                    },
                    qj: function() {
                        return r.deletePhone;
                    },
                    xg: function() {
                        return r.enrollPassword;
                    },
                    OD: function() {
                        return r.getEmail;
                    },
                    hG: function() {
                        return r.getEmailChallenge;
                    },
                    G5: function() {
                        return r.getEmails;
                    },
                    Ij: function() {
                        return r.getPassword;
                    },
                    u_: function() {
                        return r.getPhone;
                    },
                    Po: function() {
                        return r.getPhones;
                    },
                    Ai: function() {
                        return r.getProfile;
                    },
                    aF: function() {
                        return r.getProfileSchema;
                    },
                    HT: function() {
                        return i.H;
                    },
                    ME: function() {
                        return r.sendEmailChallenge;
                    },
                    dv: function() {
                        return r.sendPhoneChallenge;
                    },
                    gQ: function() {
                        return r.updatePassword;
                    },
                    ck: function() {
                        return r.updateProfile;
                    },
                    T8: function() {
                        return r.verifyEmailChallenge;
                    },
                    Lo: function() {
                        return r.verifyPhoneChallenge;
                    }
                });
                var r = n(9108), o = n(1578), i = n(6794);
                function a(e1, t, n) {
                    var r = (0, o.K)(e1, t, n);
                    return (0, i.H)(r);
                }
                var u = n(8008);
            },
            6794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return p;
                    }
                });
                var r = n(885), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(9108);
                function p(e1) {
                    return function(e1) {
                        (0, u.Z)(d, e1);
                        var t, n, p = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function d() {
                            var e1;
                            (0, i.Z)(this, d);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = p.call.apply(p, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "myaccount", void 0), e1.myaccount = Object.entries(l).filter(function(e1) {
                                return "default" !== (0, r.Z)(e1, 1)[0];
                            }).reduce(function(t, n) {
                                var o = (0, r.Z)(n, 2), i = o[0], u = o[1];
                                return t[i] = u.bind(null, (0, a.Z)(e1)), t;
                            }, {}), e1;
                        }
                        return (0, o.Z)(d);
                    }(e1);
                }
            },
            8008: function(e1, t, n) {
                "use strict";
                var r, o, i;
                n.d(t, {
                    Fn: function() {
                        return i;
                    },
                    aw: function() {
                        return r;
                    },
                    qb: function() {
                        return o;
                    }
                }), function(e1) {
                    e1.PRIMARY = "PRIMARY", e1.SECONDARY = "SECONDARY";
                }(r || (r = {})), function(e1) {
                    e1.VERIFIED = "VERIFIED", e1.UNVERIFIED = "UNVERIFIED";
                }(o || (o = {})), function(e1) {
                    e1.NOT_ENROLLED = "NOT_ENROLLED", e1.ACTIVE = "ACTIVE";
                }(i || (i = {}));
            },
            2427: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return w;
                    }
                });
                var r = n(5861), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(4687), s = n.n(c), f = n(3193), l = n(9123), p = n(2482), d = n(415), h = function() {
                    function e1(t) {
                        (0, i.Z)(this, e1), (0, u.Z)(this, "localOffset", void 0), this.localOffset = parseInt(t || 0);
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "now",
                            value: function() {
                                return (Date.now() + this.localOffset) / 1e3;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: function() {
                                return new e1(0);
                            }
                        }
                    ]), e1;
                }(), v = n(7088), y = n(6488), g = n(1971);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0,
                    clearPendingRemoveTokens: !0,
                    storage: void 0,
                    expireEarlySeconds: 30,
                    storageKey: g.TOKEN_STORAGE_NAME
                }, w = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if ((0, i.Z)(this, e1), (0, u.Z)(this, "sdk", void 0), (0, u.Z)(this, "clock", void 0), (0, u.Z)(this, "emitter", void 0), (0, u.Z)(this, "storage", void 0), (0, u.Z)(this, "state", void 0), (0, u.Z)(this, "options", void 0), this.sdk = t, this.emitter = t.emitter, !this.emitter) throw new l.Z("Emitter should be initialized before TokenManager");
                        n = Object.assign({}, k, (0, f.YY)(n)), (0, d.isLocalhost)() || (n.expireEarlySeconds = k.expireEarlySeconds), this.options = n;
                        var r = (0, f.YY)({
                            storageKey: n.storageKey,
                            secure: n.secure
                        });
                        "object" === (0, o.Z)(n.storage) ? r.storageProvider = n.storage : n.storage && (r.storageType = n.storage), this.storage = t.storageManager.getTokenStorage(b(b({}, r), {}, {
                            useSeparateCookies: !0
                        })), this.clock = h.create(), this.state = {
                            expireTimeouts: {},
                            renewPromise: null
                        };
                    }
                    var t, n, c;
                    return (0, a.Z)(e1, [
                        {
                            key: "on",
                            value: function(e1, t, n) {
                                n ? this.emitter.on(e1, t, n) : this.emitter.on(e1, t);
                            }
                        },
                        {
                            key: "off",
                            value: function(e1, t) {
                                t ? this.emitter.off(e1, t) : this.emitter.off(e1);
                            }
                        },
                        {
                            key: "start",
                            value: function() {
                                this.options.clearPendingRemoveTokens && this.clearPendingRemoveTokens(), this.setExpireEventTimeoutAll(), this.state.started = !0;
                            }
                        },
                        {
                            key: "stop",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.state.started = !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return !!this.state.started;
                            }
                        },
                        {
                            key: "getOptions",
                            value: function() {
                                return (0, f.d9)(this.options);
                            }
                        },
                        {
                            key: "getExpireTime",
                            value: function(e1) {
                                var t = this.options.expireEarlySeconds || 0;
                                return e1.expiresAt - t;
                            }
                        },
                        {
                            key: "hasExpired",
                            value: function(e1) {
                                return this.getExpireTime(e1) <= this.clock.now();
                            }
                        },
                        {
                            key: "emitExpired",
                            value: function(e1, t) {
                                this.emitter.emit(v.$Y, e1, t);
                            }
                        },
                        {
                            key: "emitRenewed",
                            value: function(e1, t, n) {
                                this.emitter.emit(v.E, e1, t, n);
                            }
                        },
                        {
                            key: "emitAdded",
                            value: function(e1, t) {
                                this.emitter.emit(v.O3, e1, t);
                            }
                        },
                        {
                            key: "emitRemoved",
                            value: function(e1, t) {
                                this.emitter.emit(v.FT, e1, t);
                            }
                        },
                        {
                            key: "emitError",
                            value: function(e1) {
                                this.emitter.emit(v.$I, e1);
                            }
                        },
                        {
                            key: "clearExpireEventTimeout",
                            value: function(e1) {
                                clearTimeout(this.state.expireTimeouts[e1]), delete this.state.expireTimeouts[e1], this.state.renewPromise = null;
                            }
                        },
                        {
                            key: "clearExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.state.expireTimeouts;
                                for(var t in e1)Object.prototype.hasOwnProperty.call(e1, t) && this.clearExpireEventTimeout(t);
                            }
                        },
                        {
                            key: "setExpireEventTimeout",
                            value: function(e1, t) {
                                var n = this;
                                if (!(0, y.z9)(t)) {
                                    var r = this.getExpireTime(t), o = 1e3 * Math.max(r - this.clock.now(), 0);
                                    this.clearExpireEventTimeout(e1);
                                    var i = setTimeout(function() {
                                        n.emitExpired(e1, t);
                                    }, o);
                                    this.state.expireTimeouts[e1] = i;
                                }
                            }
                        },
                        {
                            key: "setExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.storage.getStorage();
                                for(var t in e1)if (Object.prototype.hasOwnProperty.call(e1, t)) {
                                    var n = e1[t];
                                    this.setExpireEventTimeout(t, n);
                                }
                            }
                        },
                        {
                            key: "resetExpireEventTimeoutAll",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t) {
                                var n = this.storage.getStorage();
                                (0, p.R)(t), n[e1] = t, this.storage.setStorage(n), this.emitSetStorageEvent(), this.emitAdded(e1, t), this.setExpireEventTimeout(e1, t);
                            }
                        },
                        {
                            key: "getSync",
                            value: function(e1) {
                                return this.storage.getStorage()[e1];
                            }
                        },
                        {
                            key: "get",
                            value: (c = (0, r.Z)(s().mark(function e1(t) {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getSync(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return c.apply(this, arguments);
                            })
                        },
                        {
                            key: "getTokensSync",
                            value: function() {
                                var e1 = {}, t = this.storage.getStorage();
                                return Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    (0, y.hv)(r) ? e1.accessToken = r : (0, y.sI)(r) ? e1.idToken = r : (0, y.z9)(r) && (e1.refreshToken = r);
                                }), e1;
                            }
                        },
                        {
                            key: "getTokens",
                            value: (n = (0, r.Z)(s().mark(function e1() {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getTokensSync());
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "getStorageKeyByType",
                            value: function(e1) {
                                var t = this.storage.getStorage();
                                return Object.keys(t).filter(function(n) {
                                    var r = t[n];
                                    return (0, y.hv)(r) && "accessToken" === e1 || (0, y.sI)(r) && "idToken" === e1 || (0, y.z9)(r) && "refreshToken" === e1;
                                })[0];
                            }
                        },
                        {
                            key: "getTokenType",
                            value: function(e1) {
                                if ((0, y.hv)(e1)) return "accessToken";
                                if ((0, y.sI)(e1)) return "idToken";
                                if ((0, y.z9)(e1)) return "refreshToken";
                                throw new l.Z("Unknown token type");
                            }
                        },
                        {
                            key: "emitSetStorageEvent",
                            value: function() {
                                if ((0, d.isIE11OrLess)()) {
                                    var e1 = this.storage.getStorage();
                                    this.emitter.emit(v.zr, e1);
                                }
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                return this.storage;
                            }
                        },
                        {
                            key: "setTokens",
                            value: function(e1, t, n, r) {
                                var o = this, i = function(e1, i) {
                                    var a = o.getTokenType(i);
                                    "accessToken" === a ? t && t(e1, i) : "idToken" === a ? n && n(e1, i) : "refreshToken" === a && r && r(e1, i);
                                }, a = function(e1, t) {
                                    o.emitAdded(e1, t), o.setExpireEventTimeout(e1, t), i(e1, t);
                                }, u = function(e1, t) {
                                    o.clearExpireEventTimeout(e1), o.emitRemoved(e1, t), i(e1, t);
                                }, c = [
                                    "idToken",
                                    "accessToken",
                                    "refreshToken"
                                ], s = this.getTokensSync();
                                c.forEach(function(t) {
                                    var n = e1[t];
                                    n && (0, p.R)(n, t);
                                });
                                var f = c.reduce(function(t, n) {
                                    var r = e1[n];
                                    return r && (t[o.getStorageKeyByType(n) || n] = r), t;
                                }, {});
                                this.storage.setStorage(f), this.emitSetStorageEvent(), c.forEach(function(t) {
                                    var n, r, c, f = e1[t], l = s[t], p = o.getStorageKeyByType(t) || t;
                                    f && l ? (u(p, l), a(p, f), n = p, r = f, c = l, o.emitRenewed(n, r, c), o.clearExpireEventTimeout(n), o.setExpireEventTimeout(n, r), i(n, r)) : f ? a(p, f) : l && u(p, l);
                                });
                            }
                        },
                        {
                            key: "remove",
                            value: function(e1) {
                                this.clearExpireEventTimeout(e1);
                                var t = this.storage.getStorage(), n = t[e1];
                                delete t[e1], this.storage.setStorage(t), this.emitSetStorageEvent(), this.emitRemoved(e1, n);
                            }
                        },
                        {
                            key: "renewToken",
                            value: (t = (0, r.Z)(s().mark(function e1(t) {
                                var n;
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", null === (n = this.sdk.token) || void 0 === n ? void 0 : n.renew(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "validateToken",
                            value: function(e1) {
                                return (0, p.R)(e1);
                            }
                        },
                        {
                            key: "renew",
                            value: function(e1) {
                                var t = this;
                                if (this.state.renewPromise) return this.state.renewPromise;
                                try {
                                    var n = this.getSync(e1), r = void 0 !== n;
                                    if (!n && "accessToken" === e1) {
                                        var o = this.getStorageKeyByType("refreshToken");
                                        r = void 0 !== this.getSync(o);
                                    }
                                    if (!r) throw new l.Z("The tokenManager has no token for the key: " + e1);
                                } catch (e1) {
                                    return this.emitError(e1), Promise.reject(e1);
                                }
                                return this.clearExpireEventTimeout(e1), this.state.renewPromise = this.sdk.token.renewTokens().then(function(r) {
                                    if (t.setTokens(r), !n && "accessToken" === e1) {
                                        var o = r.accessToken;
                                        return t.emitRenewed(e1, o, null), o;
                                    }
                                    return r[t.getTokenType(n)];
                                }).catch(function(n) {
                                    throw t.remove(e1), n.tokenKey = e1, t.emitError(n), n;
                                }).finally(function() {
                                    t.state.renewPromise = null;
                                });
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                var e1 = this, t = this.getTokensSync();
                                this.clearExpireEventTimeoutAll(), this.storage.clearStorage(), this.emitSetStorageEvent(), Object.keys(t).forEach(function(n) {
                                    e1.emitRemoved(n, t[n]);
                                });
                            }
                        },
                        {
                            key: "clearPendingRemoveTokens",
                            value: function() {
                                var e1 = this, t = this.storage.getStorage(), n = {};
                                Object.keys(t).forEach(function(e1) {
                                    t[e1].pendingRemove && (n[e1] = t[e1], delete t[e1]);
                                }), this.storage.setStorage(t), this.emitSetStorageEvent(), Object.keys(n).forEach(function(t) {
                                    e1.clearExpireEventTimeout(t), e1.emitRemoved(t, n[t]);
                                });
                            }
                        },
                        {
                            key: "updateRefreshToken",
                            value: function(e1) {
                                var t = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY, n = this.storage.getStorage();
                                (0, p.R)(e1), n[t] = e1, this.storage.setStorage(n), this.emitSetStorageEvent();
                            }
                        },
                        {
                            key: "removeRefreshToken",
                            value: function() {
                                var e1 = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY;
                                this.remove(e1);
                            }
                        },
                        {
                            key: "addPendingRemoveFlags",
                            value: function() {
                                var e1 = this.getTokensSync();
                                Object.keys(e1).forEach(function(t) {
                                    e1[t].pendingRemove = !0;
                                }), this.setTokens(e1);
                            }
                        }
                    ]), e1;
                }();
            },
            1646: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4319), u = n(146), c = 18e5;
                function s() {
                    return function() {
                        function e1(t) {
                            (0, r.Z)(this, e1), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "storageManager", void 0), (0, i.Z)(this, "enableSharedStorage", void 0), (0, i.Z)(this, "saveLastResponse", void 0), this.storageManager = t.storageManager, this.enableSharedStorage = !1 !== t.enableSharedStorage, this.saveLastResponse = !1 !== t.saveLastResponse, this.options = t;
                        }
                        return (0, o.Z)(e1, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this.storageManager.getTransactionStorage(), n = t.getStorage();
                                    if (t.clearStorage(), this.enableSharedStorage && !1 !== e1.clearSharedStorage) {
                                        var r = e1.state || (null == n ? void 0 : n.state);
                                        r && function(e1, t) {
                                            var n = e1.getSharedTansactionStorage(), r = n.getStorage();
                                            delete r[t], n.setStorage(r);
                                        }(this.storageManager, r);
                                    }
                                }
                            },
                            {
                                key: "save",
                                value: function(e1) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = this.storageManager.getTransactionStorage(), r = n.getStorage();
                                    (0, a.mH)(r) && !t.muteWarning && (0, u.ZK)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e1), this.enableSharedStorage && e1.state && function(e1, t, n) {
                                        var r = e1.getSharedTansactionStorage(), o = r.getStorage();
                                        o[t] = {
                                            dateCreated: Date.now(),
                                            transaction: n
                                        }, r.setStorage(o);
                                    }(this.storageManager, e1.state, e1);
                                }
                            },
                            {
                                key: "exists",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    try {
                                        return !!this.load(e1);
                                    } catch (e1) {
                                        return !1;
                                    }
                                }
                            },
                            {
                                key: "load",
                                value: function() {
                                    var e1, t, n, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    return this.enableSharedStorage && r.state && (t = this.storageManager.getSharedTansactionStorage(), n = t.getStorage(), Object.keys(n).forEach(function(e1) {
                                        var t = n[e1];
                                        Date.now() - t.dateCreated > c && delete n[e1];
                                    }), t.setStorage(n), e1 = function(e1, t) {
                                        var n = e1.getSharedTansactionStorage().getStorage()[t];
                                        return n && n.transaction && (0, a.mH)(n.transaction) ? n.transaction : null;
                                    }(this.storageManager, r.state), (0, a.mH)(e1)) ? e1 : (e1 = this.storageManager.getTransactionStorage().getStorage(), (0, a.mH)(e1) ? e1 : null);
                                }
                            }
                        ]), e1;
                    }();
                }
            },
            1237: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(7987);
                function i(e1) {
                    var t, n = e1.split(".");
                    try {
                        t = {
                            header: JSON.parse((0, o.Wy)(n[0])),
                            payload: JSON.parse((0, o.Wy)(n[1])),
                            signature: n[2]
                        };
                    } catch (e1) {
                        throw new r.Z("Malformed token");
                    }
                    return t;
                }
            },
            7659: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    SO: function() {
                        return d;
                    },
                    V7: function() {
                        return A;
                    },
                    aW: function() {
                        return D;
                    },
                    ao: function() {
                        return C;
                    },
                    cE: function() {
                        return N;
                    },
                    lk: function() {
                        return E;
                    },
                    sd: function() {
                        return x;
                    },
                    vX: function() {
                        return _;
                    }
                });
                var r = n(2982), o = n(5861), i = n(4687), a = n.n(i), u = n(7987), c = n(7594), s = n(5728), f = n(9123), l = "OktaAuthJs", p = "DPoPKeys";
                function d(e1) {
                    return ((0, s.isOAuthError)(e1) || (0, s.isWWWAuthError)(e1)) && "use_dpop_nonce" === e1.errorCode;
                }
                function h(e1, t, n) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return (v = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i, s;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (0, u.NL)(JSON.stringify(t)), i = (0, u.NL)(JSON.stringify(n)), e1.next = 4, c.KP.subtle.sign({
                                        name: r.algorithm.name
                                    }, r, (0, u.k8)("".concat(o, ".").concat(i)));
                                case 4:
                                    return s = e1.sent, e1.abrupt("return", "".concat(o, ".").concat(i, ".").concat((0, u.aR)((0, u.kQ)(s))));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function y() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 32;
                    return (0, r.Z)(c.KP.getRandomValues(new Uint8Array(e1))).map(function(e1) {
                        return e1.toString(16);
                    }).join("");
                }
                function g() {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1() {
                        var t;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return t = {
                                        name: "RSASSA-PKCS1-v1_5",
                                        hash: "SHA-256",
                                        modulusLength: 2048,
                                        publicExponent: new Uint8Array([
                                            1,
                                            0,
                                            1
                                        ])
                                    }, e1.abrupt("return", c.KP.subtle.generateKey(t, !1, [
                                        "sign",
                                        "verify"
                                    ]));
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, o.Z)(a().mark(function e1(t) {
                        var n, r;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = (new TextEncoder).encode(t), e1.next = 3, c.KP.subtle.digest("SHA-256", n);
                                case 3:
                                    return r = e1.sent, e1.abrupt("return", (0, c.r3)(String.fromCharCode.apply(null, new Uint8Array(r))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function w(e1) {
                    return O.apply(this, arguments);
                }
                function O() {
                    return O = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    for(n = u.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = u[o];
                                    return e1.next = 3, new Promise(function(e1, t) {
                                        try {
                                            var n = window.indexedDB.open(l, 1);
                                            n.onerror = function() {
                                                t(n.error);
                                            }, n.onupgradeneeded = function() {
                                                n.result.createObjectStore(p);
                                            }, n.onsuccess = function() {
                                                var r = n.result, o = r.transaction(p, "readwrite");
                                                o.onerror = function() {
                                                    t(o.error);
                                                };
                                                var i = o.objectStore(p);
                                                e1(i), o.oncomplete = function() {
                                                    r.close();
                                                };
                                            };
                                        } catch (e1) {
                                            t(e1);
                                        }
                                    });
                                case 3:
                                    return i = e1.sent, e1.abrupt("return", new Promise(function(e1, n) {
                                        var o = i[t].apply(i, r);
                                        o.onsuccess = function() {
                                            e1(o);
                                        }, o.onerror = function() {
                                            n(o.error);
                                        };
                                    }));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), O.apply(this, arguments);
                }
                function Z(e1, t) {
                    return T.apply(this, arguments);
                }
                function T() {
                    return (T = (0, o.Z)(a().mark(function e1(t, n) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("add", n, t);
                                case 2:
                                    return e1.abrupt("return", n);
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function E(e1) {
                    return S.apply(this, arguments);
                }
                function S() {
                    return (S = (0, o.Z)(a().mark(function e1(t) {
                        var n;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!t) {
                                        e1.next = 6;
                                        break;
                                    }
                                    return e1.next = 3, w("get", t);
                                case 3:
                                    if (!(n = e1.sent).result) {
                                        e1.next = 6;
                                        break;
                                    }
                                    return e1.abrupt("return", n.result);
                                case 6:
                                    throw new f.Z("Unable to locate dpop key pair required for refresh".concat(t ? " (".concat(t, ")") : ""));
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function x(e1) {
                    return P.apply(this, arguments);
                }
                function P() {
                    return (P = (0, o.Z)(a().mark(function e1(t) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("delete", t);
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function A() {
                    return R.apply(this, arguments);
                }
                function R() {
                    return (R = (0, o.Z)(a().mark(function e1() {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("clear");
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function _() {
                    return j.apply(this, arguments);
                }
                function j() {
                    return (j = (0, o.Z)(a().mark(function e1() {
                        var t, n;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return t = y(4), e1.next = 3, g();
                                case 3:
                                    return n = e1.sent, e1.next = 6, Z(t, n);
                                case 6:
                                    return e1.abrupt("return", {
                                        keyPair: n,
                                        keyPairId: t
                                    });
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function C(e1, t) {
                    return I.apply(this, arguments);
                }
                function I() {
                    return (I = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = !1, i = n.accessToken, u = n.refreshToken, "access" === t && i && "DPoP" === i.tokenType && !u && (o = !0), "refresh" === t && u && !i && (o = !0), c = null !== (r = null == i ? void 0 : i.dpopPairId) && void 0 !== r ? r : null == u ? void 0 : u.dpopPairId, !o || !c) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 8, x(c);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function D(e1) {
                    return M.apply(this, arguments);
                }
                function M() {
                    return (M = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, s, f, l, p, d, v, g, m, k;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = t.keyPair, r = t.url, o = t.method, i = t.nonce, u = t.accessToken, e1.next = 3, c.KP.subtle.exportKey("jwk", n.publicKey);
                                case 3:
                                    if (s = e1.sent, f = s.kty, l = s.crv, p = s.e, d = s.n, v = s.x, g = s.y, m = {
                                        alg: "RS256",
                                        typ: "dpop+jwt",
                                        jwk: {
                                            kty: f,
                                            crv: l,
                                            e: p,
                                            n: d,
                                            x: v,
                                            y: g
                                        }
                                    }, k = {
                                        htm: o,
                                        htu: r,
                                        iat: Math.floor(Date.now() / 1e3),
                                        jti: y()
                                    }, i && (k.nonce = i), !u) {
                                        e1.next = 17;
                                        break;
                                    }
                                    return e1.next = 16, b(u);
                                case 16:
                                    k.ath = e1.sent;
                                case 17:
                                    return e1.abrupt("return", h(m, k, n.privateKey));
                                case 18:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function N(e1) {
                    return U.apply(this, arguments);
                }
                function U() {
                    return (U = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = t.keyPair, r = t.url, o = t.method, i = t.nonce, u = {
                                        keyPair: n,
                                        url: r,
                                        method: o
                                    }, i && (u.nonce = i), e1.abrupt("return", D(u));
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2206: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return l;
                    },
                    _: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(4771), i = n(3193), a = n(6718), u = n(9123);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    if (!e1.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                    if ((0, o.HD)(e1.responseType) && -1 !== e1.responseType.indexOf(" ")) throw new u.Z("Multiple OAuth responseTypes must be defined as an array");
                    var t = {
                        client_id: e1.clientId,
                        code_challenge: e1.codeChallenge,
                        code_challenge_method: e1.codeChallengeMethod,
                        display: e1.display,
                        idp: e1.idp,
                        idp_scope: e1.idpScope,
                        login_hint: e1.loginHint,
                        max_age: e1.maxAge,
                        nonce: e1.nonce,
                        prompt: e1.prompt,
                        redirect_uri: e1.redirectUri,
                        response_mode: e1.responseMode,
                        response_type: e1.responseType,
                        sessionToken: e1.sessionToken,
                        state: e1.state,
                        acr_values: e1.acrValues,
                        enroll_amr_values: e1.enrollAmrValues
                    };
                    if (t = (0, i.YY)(t), [
                        "idp_scope",
                        "response_type",
                        "enroll_amr_values"
                    ].forEach(function(e1) {
                        Array.isArray(t[e1]) && (t[e1] = t[e1].join(" "));
                    }), -1 !== e1.responseType.indexOf("id_token") && -1 === e1.scopes.indexOf("openid")) throw new u.Z("openid scope must be specified in the scopes argument when requesting an id_token");
                    return e1.scopes && (t.scope = e1.scopes.join(" ")), t;
                }
                function l(e1) {
                    var t = f(e1);
                    return (0, a.UK)(s(s({}, t), e1.extraParams && s({}, e1.extraParams)));
                }
            },
            2642: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Dp: function() {
                        return o.D;
                    },
                    ES: function() {
                        return i.E;
                    },
                    R0: function() {
                        return r.R;
                    },
                    _6: function() {
                        return r._;
                    },
                    km: function() {
                        return i.k;
                    },
                    ti: function() {
                        return o.t;
                    }
                });
                var r = n(2206), o = n(9231), i = n(52);
            },
            9231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return b;
                    },
                    t: function() {
                        return g;
                    }
                });
                var r = n(885), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(3983), s = n(3193), f = n(6718), l = n(5385), p = n(7659);
                function d(e1) {
                    if (!e1.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                    if (!e1.redirectUri) throw new u.Z("The redirectUri passed to /authorize must also be passed to /token");
                    if (!e1.authorizationCode && !e1.interactionCode) throw new u.Z("An authorization code (returned from /authorize) must be passed to /token");
                    if (!e1.codeVerifier) throw new u.Z('The "codeVerifier" (generated and saved by your app) must be passed to /token');
                }
                function h(e1, t) {
                    var n = (0, s.YY)({
                        client_id: t.clientId,
                        redirect_uri: t.redirectUri,
                        grant_type: t.interactionCode ? "interaction_code" : "authorization_code",
                        code_verifier: t.codeVerifier
                    });
                    t.interactionCode ? n.interaction_code = t.interactionCode : t.authorizationCode && (n.code = t.authorizationCode);
                    var r = e1.options.clientSecret;
                    return r && (n.client_secret = r), (0, f.UK)(n).slice(1);
                }
                function v(e1, t) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, s, f, d, h, y, g, m, b;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.url, o = n.data, i = n.nonce, s = n.dpopKeyPair, f = "POST", d = {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    }, !t.options.dpop) {
                                        e1.next = 10;
                                        break;
                                    }
                                    if (s) {
                                        e1.next = 6;
                                        break;
                                    }
                                    throw new u.Z("DPoP is configured but no key pair was provided");
                                case 6:
                                    return e1.next = 8, (0, p.cE)({
                                        url: r,
                                        method: f,
                                        nonce: i,
                                        keyPair: s
                                    });
                                case 8:
                                    h = e1.sent, d.DPoP = h;
                                case 10:
                                    return e1.prev = 10, e1.next = 13, (0, l.c3)(t, {
                                        url: r,
                                        method: f,
                                        args: o,
                                        headers: d
                                    });
                                case 13:
                                    return y = e1.sent, e1.abrupt("return", y);
                                case 17:
                                    if (e1.prev = 17, e1.t0 = e1.catch(10), !(0, p.SO)(e1.t0) || i) {
                                        e1.next = 24;
                                        break;
                                    }
                                    if (m = null === (g = e1.t0.resp) || void 0 === g ? void 0 : g.headers["dpop-nonce"]) {
                                        e1.next = 23;
                                        break;
                                    }
                                    throw new c.Z({
                                        errorSummary: "No `dpop-nonce` header found when required"
                                    }, null !== (b = e1.t0.resp) && void 0 !== b ? b : void 0);
                                case 23:
                                    return e1.abrupt("return", v(t, {
                                        url: r,
                                        data: o,
                                        dpopKeyPair: s,
                                        nonce: m
                                    }));
                                case 24:
                                    throw e1.t0;
                                case 25:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                10,
                                17
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                function g(e1, t, n) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return d(n), o = h(t, n), i = {
                                        url: r.tokenUrl,
                                        data: o,
                                        dpopKeyPair: null == n ? void 0 : n.dpopKeyPair
                                    }, e1.abrupt("return", v(t, i));
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1, t, n) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, o.Z)(a().mark(function e1(t, n, o) {
                        var i, u, c;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return i = Object.entries({
                                        client_id: n.clientId,
                                        grant_type: "refresh_token",
                                        scope: o.scopes.join(" "),
                                        refresh_token: o.refreshToken
                                    }).map(function(e1) {
                                        var t = (0, r.Z)(e1, 2), n = t[0], o = t[1];
                                        return n + "=" + encodeURIComponent(o);
                                    }).join("&"), u = o.tokenUrl, n.extraParams && Object.keys(n.extraParams).length >= 1 && (u += (0, f.UK)(n.extraParams)), c = {
                                        url: u,
                                        data: i,
                                        dpopKeyPair: null == n ? void 0 : n.dpopKeyPair
                                    }, e1.abrupt("return", v(t, c));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            52: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return a;
                    },
                    k: function() {
                        return u;
                    }
                });
                var r = n(5385), o = n(3193), i = n(9123);
                function a(e1, t) {
                    var n = t || e1.options.issuer;
                    return (0, r.U2)(e1, n + "/.well-known/openid-configuration", {
                        cacheResponse: !0
                    });
                }
                function u(e1, t, n) {
                    var u = e1.storageManager.getHttpCache(e1.options.cookies);
                    return a(e1, t).then(function(t) {
                        var a = t.jwks_uri, c = u.getStorage()[a];
                        if (c && Date.now() / 1e3 < c.expiresAt) {
                            var s = (0, o.sE)(c.response.keys, {
                                kid: n
                            });
                            if (s) return s;
                        }
                        return u.clearStorage(a), (0, r.U2)(e1, a, {
                            cacheResponse: !0
                        }).then(function(e1) {
                            var t = (0, o.sE)(e1.keys, {
                                kid: n
                            });
                            if (t) return t;
                            throw new i.Z("The key id, " + n + ", was not found in the server's keys");
                        });
                    });
                }
            },
            8707: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    r: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(7599), u = n(7756), c = n(3193), s = n(9231), f = n(8676), l = n(7659);
                function p(e1, t, n) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, d, h, v, y, g, m, b, k, w, O, Z, T, E, S, x, P, A, R, _, j;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = r || (0, a.Fc)(t, n), n = Object.assign({}, (0, u.D)(t), (0, c.d9)(n)), p = (o = n).authorizationCode, d = o.interactionCode, h = o.codeVerifier, v = o.clientId, y = o.redirectUri, g = o.scopes, m = o.ignoreSignature, b = o.state, k = o.acrValues, w = o.dpop, O = o.dpopPairId, Z = o.extraParams, T = {
                                        clientId: v,
                                        redirectUri: y,
                                        authorizationCode: p,
                                        interactionCode: d,
                                        codeVerifier: h,
                                        dpop: w
                                    }, E = [
                                        "token"
                                    ], -1 !== g.indexOf("openid") && E.push("id_token"), S = {
                                        clientId: v,
                                        redirectUri: y,
                                        scopes: g,
                                        responseType: E,
                                        ignoreSignature: m,
                                        acrValues: k,
                                        extraParams: Z
                                    }, e1.prev = 7, !w) {
                                        e1.next = 26;
                                        break;
                                    }
                                    if (!O) {
                                        e1.next = 18;
                                        break;
                                    }
                                    return e1.next = 12, (0, l.lk)(O);
                                case 12:
                                    x = e1.sent, T.dpopKeyPair = x, S.dpop = w, S.dpopPairId = O, e1.next = 26;
                                    break;
                                case 18:
                                    return e1.next = 20, (0, l.vX)();
                                case 20:
                                    P = e1.sent, A = P.keyPair, R = P.keyPairId, T.dpopKeyPair = A, S.dpop = w, S.dpopPairId = R;
                                case 26:
                                    return e1.next = 28, (0, s.t)(t, T, r);
                                case 28:
                                    return _ = e1.sent, e1.next = 31, (0, f.s)(t, S, _, r);
                                case 31:
                                    return (j = e1.sent).code = p, j.state = b, e1.abrupt("return", j);
                                case 35:
                                    return e1.prev = 35, t.transactionManager.clear(), e1.finish(35);
                                case 38:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                7,
                                ,
                                35,
                                38
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
            },
            5324: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return E;
                    },
                    o: function() {
                        return T;
                    }
                });
                var r = n(3548), o = n(1237), i = n(8707), a = n(6844), u = n(7625), c = n(9770), s = n(6803), f = n(5372), l = n(2476), p = n(6268), d = n(781), h = n(6466), v = n(8113), y = n(6898), g = n(8221), m = n(1260), b = n(3193), k = n(6757), w = n(8080), O = n(2206);
                function Z(e1, t) {
                    t = (0, b.d9)(t) || {};
                    var n = (0, k.U)(e1, t), r = (0, w.A)(e1, n), o = r.urls.authorizeUrl + (0, O.R)(n);
                    e1.transactionManager.save(r), e1.options.setLocation ? e1.options.setLocation(o) : window.location.assign(o);
                }
                function T(e1, t) {
                    var n = function(e1) {
                        return r.b.prototype.push.bind(t, e1, null);
                    }, b = n(s.H.bind(null, e1)), k = n(f.ko.bind(null, e1)), w = Object.assign(k, {
                        _getHistory: function() {
                            return window.history;
                        },
                        _getLocation: function() {
                            return window.location;
                        },
                        _getDocument: function() {
                            return window.document;
                        }
                    }), O = {
                        prepareTokenParams: y.wu.bind(null, e1),
                        exchangeCodeForTokens: i.r.bind(null, e1),
                        getWithoutPrompt: u.y.bind(null, e1),
                        getWithPopup: c.d.bind(null, e1),
                        getWithRedirect: b,
                        parseFromUrl: w,
                        decode: o.T,
                        revoke: h.P.bind(null, e1),
                        renew: l.$.bind(null, e1),
                        renewTokensWithRefresh: d.R.bind(null, e1),
                        renewTokens: p.I.bind(null, e1),
                        getUserInfo: function(t, n) {
                            return (0, a.b)(e1, t, n);
                        },
                        verify: m.W.bind(null, e1),
                        isLoginRedirect: g.gM.bind(null, e1),
                        introspect: v.j.bind(null, e1)
                    };
                    return [
                        "getWithoutPrompt",
                        "getWithPopup",
                        "revoke",
                        "renew",
                        "renewTokensWithRefresh",
                        "renewTokens"
                    ].forEach(function(e1) {
                        O[e1] = n(O[e1]);
                    }), O;
                }
                function E(e1) {
                    return {
                        authorize: {
                            enrollAuthenticator: Z.bind(null, e1)
                        }
                    };
                }
            },
            231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $V: function() {
                        return r.$;
                    },
                    zr: function() {
                        return s;
                    },
                    o5: function() {
                        return r.o;
                    }
                });
                var r = n(5324), o = n(9893), i = n(265), a = n(3980), u = n(279), c = n(2724);
                function s(e1, t, n) {
                    var r = (0, o.a)(t), s = (0, i.H)(r, e1), f = (0, u.A)(s), l = (0, a.Z)(f);
                    return (0, c.J)(l, n);
                }
            },
            3253: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return s;
                    }
                });
                var r = n(7599), o = n(4970), i = n(9123), a = n(6898), u = n(2206), c = n(8676);
                function s(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new i.Z('As of version 3.0, "getToken" takes only a single set of options'));
                    var n = (t = t || {}).popupWindow;
                    return t.popupWindow = void 0, (0, a.wu)(e1, t).then(function(a) {
                        var s, f;
                        switch(t.sessionToken ? Object.assign(a, {
                            prompt: "none",
                            responseMode: "okta_post_message",
                            display: null
                        }) : t.idp && Object.assign(a, {
                            display: "popup"
                        }), f = (0, r.Fc)(e1, a), s = (t.codeVerifier ? f.tokenUrl : f.authorizeUrl) + (0, u.R)(a), a.sessionToken || null === a.display ? "IFRAME" : "popup" === a.display ? "POPUP" : "IMPLICIT"){
                            case "IFRAME":
                                var l = (0, o.iC)(e1, t.timeout, a.state), p = (0, o.Rl)(s);
                                return l.then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    var e1;
                                    document.body.contains(p) && (null === (e1 = p.parentElement) || void 0 === e1 || e1.removeChild(p));
                                });
                            case "POPUP":
                                var d;
                                if ("okta_post_message" === a.responseMode) {
                                    if (!e1.features.isPopupPostMessageSupported()) throw new i.Z("This browser doesn't have full postMessage support");
                                    d = (0, o.iC)(e1, t.timeout, a.state);
                                }
                                return n && n.location.assign(s), new Promise(function(e1, t) {
                                    var r = setInterval(function() {
                                        n && !n.closed || (clearInterval(r), t(new i.Z("Unable to parse OAuth flow response")));
                                    }, 100);
                                    d.then(function(t) {
                                        clearInterval(r), e1(t);
                                    }).catch(function(e1) {
                                        clearInterval(r), t(e1);
                                    });
                                }).then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    n && !n.closed && n.close();
                                });
                            default:
                                throw new i.Z("The full page redirect flow is not supported");
                        }
                    });
                }
            },
            6844: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return v;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(3114), s = n(2886), f = n(3983), l = n(5385), p = n(6488);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function v(e1, t, n) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.next = 3, t.tokenManager.getTokens();
                                case 3:
                                    n = e1.sent.accessToken;
                                case 4:
                                    if (r) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 7, t.tokenManager.getTokens();
                                case 7:
                                    r = e1.sent.idToken;
                                case 8:
                                    if (n && (0, p.hv)(n)) {
                                        e1.next = 10;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an access token object")));
                                case 10:
                                    if (r && (0, p.sI)(r)) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an ID token object")));
                                case 12:
                                    if (o = {
                                        url: n.userinfoUrl,
                                        method: "GET",
                                        accessToken: n.accessToken
                                    }, !t.options.dpop) {
                                        e1.next = 19;
                                        break;
                                    }
                                    return e1.next = 16, t.getDPoPAuthorizationHeaders(h(h({}, o), {}, {
                                        accessToken: n
                                    }));
                                case 16:
                                    i = e1.sent, o.headers = i, delete o.accessToken;
                                case 19:
                                    return e1.abrupt("return", (0, l.c3)(t, o).then(function(e1) {
                                        return e1.sub === r.claims.sub ? e1 : Promise.reject(new u.Z("getUserInfo request was rejected due to token mismatch"));
                                    }).catch(function(e1) {
                                        if (e1 instanceof c.Z && !t.options.dpop) {
                                            var n = e1.error, r = e1.errorDescription;
                                            throw new s.Z(n, r);
                                        }
                                        if (!t.options.dpop) {
                                            var o, i = e1;
                                            if (e1 instanceof f.Z && null != e1 && null !== (o = e1.meta) && void 0 !== o && o.wwwAuthHeader && (i = c.Z.parseHeader(e1.meta.wwwAuthHeader)), i instanceof c.Z) {
                                                var a = i, u = a.error, l = a.errorDescription;
                                                throw new s.Z(u, l);
                                            }
                                        }
                                        throw e1;
                                    }));
                                case 20:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9770: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    d: function() {
                        return u;
                    }
                });
                var r = n(9123), o = n(3193), i = n(3253), a = n(4970);
                function u(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new r.Z('As of version 3.0, "getWithPopup" takes only a single set of options'));
                    var n = (0, a.pU)("/", t);
                    return t = (0, o.d9)(t) || {}, Object.assign(t, {
                        display: "popup",
                        responseMode: "okta_post_message",
                        popupWindow: n
                    }), (0, i.L)(e1, t);
                }
            },
            6803: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(3193), c = n(6898), s = n(2865), f = n(2206);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(p.length > 2)) {
                                        e1.next = 2;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new a.Z('As of version 3.0, "getWithRedirect" takes only a single set of options')));
                                case 2:
                                    return n = (0, u.d9)(n) || {}, e1.next = 5, (0, c.wu)(t, n);
                                case 5:
                                    r = e1.sent, o = (0, s.H)(t, r), l = o.urls.authorizeUrl + (0, f.R)(r), t.transactionManager.save(o), t.options.setLocation ? t.options.setLocation(l) : window.location.assign(l);
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7625: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    y: function() {
                        return a;
                    }
                });
                var r = n(9123), o = n(3193), i = n(3253);
                function a(e1, t) {
                    return arguments.length > 2 ? Promise.reject(new r.Z('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = (0, o.d9)(t) || {}, Object.assign(t, {
                        prompt: "none",
                        responseMode: "okta_post_message",
                        display: null
                    }), (0, i.L)(e1, t));
                }
            },
            8676: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(3193), u = n(7599), c = n(2886), s = n(9123), f = n(1260), l = n(7756);
                function p(e1, t) {
                    if (e1.error && e1.error_description) throw new c.Z(e1.error, e1.error_description);
                    if (e1.state !== t.state) throw new s.Z("OAuth flow response state doesn't match request state");
                    if (t.dpop && "DPoP" !== e1.token_type) throw new s.Z('Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP');
                }
                function d(e1, t, n, r) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r, o) {
                        var c, d, h, v, y, g, m, b, k, w, O, Z, T, E;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!1 === t.options.pkce || !r.code && !r.interaction_code) {
                                        e1.next = 3;
                                        break;
                                    }
                                    return e1.abrupt("return", t.token.exchangeCodeForTokens(Object.assign({}, n, {
                                        authorizationCode: r.code,
                                        interactionCode: r.interaction_code
                                    }), o));
                                case 3:
                                    if (n = n || (0, l.D)(t), o = o || (0, u.Fc)(t, n), c = n.responseType || [], Array.isArray(c) || "none" === c || (c = [
                                        c
                                    ]), d = r.scope ? r.scope.split(" ") : (0, a.d9)(n.scopes), h = n.clientId || t.options.clientId, p(r, n), v = {}, y = r.expires_in, g = r.token_type, m = r.access_token, b = r.id_token, k = r.refresh_token, w = Math.floor(Date.now() / 1e3), m && (O = t.token.decode(m), v.accessToken = {
                                        accessToken: m,
                                        claims: O.payload,
                                        expiresAt: Number(y) + w,
                                        tokenType: g,
                                        scopes: d,
                                        authorizeUrl: o.authorizeUrl,
                                        userinfoUrl: o.userinfoUrl
                                    }, n.dpopPairId && (v.accessToken.dpopPairId = n.dpopPairId), n.extraParams && (v.accessToken.extraParams = n.extraParams)), k && (v.refreshToken = {
                                        refreshToken: k,
                                        expiresAt: Number(y) + w,
                                        scopes: d,
                                        tokenUrl: o.tokenUrl,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer
                                    }, n.dpopPairId && (v.refreshToken.dpopPairId = n.dpopPairId), n.extraParams && (v.refreshToken.extraParams = n.extraParams)), !b) {
                                        e1.next = 28;
                                        break;
                                    }
                                    return Z = t.token.decode(b), T = {
                                        idToken: b,
                                        claims: Z.payload,
                                        expiresAt: Z.payload.exp - Z.payload.iat + w,
                                        scopes: d,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer,
                                        clientId: h
                                    }, n.extraParams && (T.extraParams = n.extraParams), E = {
                                        clientId: h,
                                        issuer: o.issuer,
                                        nonce: n.nonce,
                                        accessToken: m,
                                        acrValues: n.acrValues
                                    }, void 0 !== n.ignoreSignature && (E.ignoreSignature = n.ignoreSignature), e1.next = 27, (0, f.W)(t, T, E);
                                case 27:
                                    v.idToken = T;
                                case 28:
                                    if (-1 === c.indexOf("token") || v.accessToken) {
                                        e1.next = 30;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
                                case 30:
                                    if (-1 === c.indexOf("id_token") || v.idToken) {
                                        e1.next = 32;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
                                case 32:
                                    return e1.abrupt("return", {
                                        tokens: v,
                                        state: r.state,
                                        code: r.code,
                                        responseType: c
                                    });
                                case 33:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9443: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    TokenManager: function() {
                        return l.M;
                    },
                    addListener: function() {
                        return d.NH;
                    },
                    addPostMessageListener: function() {
                        return d.iC;
                    },
                    assertPKCESupport: function() {
                        return d.vz;
                    },
                    buildAuthorizeParams: function() {
                        return a.R0;
                    },
                    convertTokenParamsToOAuthParams: function() {
                        return a._6;
                    },
                    createEndpoints: function() {
                        return r.$V;
                    },
                    createEnrollAuthenticatorMeta: function() {
                        return d.AW;
                    },
                    createOAuthMeta: function() {
                        return d.H;
                    },
                    createOAuthOptionsConstructor: function() {
                        return u.m;
                    },
                    createOAuthStorageManager: function() {
                        return i.a;
                    },
                    createOktaAuthOAuth: function() {
                        return r.zr;
                    },
                    createTokenAPI: function() {
                        return r.o5;
                    },
                    createTransactionManager: function() {
                        return p.P;
                    },
                    decodeToken: function() {
                        return h.T;
                    },
                    exchangeCodeForTokens: function() {
                        return O.r;
                    },
                    generateNonce: function() {
                        return d.PY;
                    },
                    generateState: function() {
                        return d.aV;
                    },
                    getDefaultEnrollAuthenticatorParams: function() {
                        return d.cE;
                    },
                    getDefaultTokenParams: function() {
                        return d.Dx;
                    },
                    getHashOrSearch: function() {
                        return d.O2;
                    },
                    getKey: function() {
                        return a.km;
                    },
                    getOAuthBaseUrl: function() {
                        return d.zf;
                    },
                    getOAuthDomain: function() {
                        return d.Xp;
                    },
                    getOAuthUrls: function() {
                        return d.Fc;
                    },
                    getToken: function() {
                        return Z.L;
                    },
                    getUserInfo: function() {
                        return k.b;
                    },
                    getWellKnown: function() {
                        return a.ES;
                    },
                    getWithPopup: function() {
                        return E.d;
                    },
                    getWithRedirect: function() {
                        return S.H;
                    },
                    getWithoutPrompt: function() {
                        return T.y;
                    },
                    handleOAuthResponse: function() {
                        return w.s;
                    },
                    hasAuthorizationCode: function() {
                        return d.ZP;
                    },
                    hasErrorInUrl: function() {
                        return d.hg;
                    },
                    hasInteractionCode: function() {
                        return d.d_;
                    },
                    hasResponseType: function() {
                        return d.wV;
                    },
                    hasTokensInHash: function() {
                        return d.kU;
                    },
                    isAuthorizationCodeError: function() {
                        return d.tC;
                    },
                    isCodeFlow: function() {
                        return d.Ik;
                    },
                    isInteractionRequired: function() {
                        return d.wc;
                    },
                    isInteractionRequiredError: function() {
                        return d.Cf;
                    },
                    isLoginRedirect: function() {
                        return d.gM;
                    },
                    isRedirectUri: function() {
                        return d.Qs;
                    },
                    isRefreshTokenError: function() {
                        return d.Yo;
                    },
                    isRefreshTokenInvalidError: function() {
                        return d.$E;
                    },
                    isSameRefreshToken: function() {
                        return d.q0;
                    },
                    loadFrame: function() {
                        return d.Rl;
                    },
                    loadPopup: function() {
                        return d.pU;
                    },
                    mixinOAuth: function() {
                        return o.J;
                    },
                    oidcIntrospect: function() {
                        return P.j;
                    },
                    parseFromUrl: function() {
                        return x.ko;
                    },
                    pkce: function() {
                        return d.U5;
                    },
                    postRefreshToken: function() {
                        return a.Dp;
                    },
                    postToTokenEndpoint: function() {
                        return a.ti;
                    },
                    prepareEnrollAuthenticatorParams: function() {
                        return d.Uc;
                    },
                    preparePKCE: function() {
                        return d.mi;
                    },
                    prepareTokenParams: function() {
                        return d.wu;
                    },
                    removeListener: function() {
                        return d.ys;
                    },
                    renewToken: function() {
                        return y.$;
                    },
                    renewTokens: function() {
                        return m.I;
                    },
                    renewTokensWithRefresh: function() {
                        return g.R;
                    },
                    revokeToken: function() {
                        return v.P;
                    },
                    urlParamsToObject: function() {
                        return d.vL;
                    },
                    validateClaims: function() {
                        return d.pj;
                    },
                    validateCodeChallengeMethod: function() {
                        return d.br;
                    },
                    validateToken: function() {
                        return d.Rp;
                    },
                    verifyToken: function() {
                        return b.W;
                    }
                });
                var r = n(231), o = n(2724), i = n(2333), a = n(2642), u = n(3775), c = n(8927), s = {};
                for(var f in c)[
                    "default",
                    "decodeToken",
                    "revokeToken",
                    "renewToken",
                    "renewTokensWithRefresh",
                    "renewTokens",
                    "verifyToken",
                    "getUserInfo",
                    "handleOAuthResponse",
                    "exchangeCodeForTokens",
                    "getToken",
                    "getWithoutPrompt",
                    "getWithPopup",
                    "getWithRedirect",
                    "parseFromUrl",
                    "oidcIntrospect",
                    "createEndpoints",
                    "createOktaAuthOAuth",
                    "createTokenAPI",
                    "mixinOAuth",
                    "createOAuthStorageManager",
                    "buildAuthorizeParams",
                    "convertTokenParamsToOAuthParams",
                    "getKey",
                    "getWellKnown",
                    "postRefreshToken",
                    "postToTokenEndpoint",
                    "createOAuthOptionsConstructor"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(2427), p = n(1646), d = n(8785), h = n(1237), v = n(6466), y = n(2476), g = n(781), m = n(6268), b = n(1260), k = n(6844), w = n(8676), O = n(8707), Z = n(3253), T = n(7625), E = n(9770), S = n(6803), x = n(5372), P = n(8113);
            },
            8113: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(52), c = n(5385), s = n(6718), f = n(7594), l = n(6488), p = {
                    accessToken: "access_token",
                    idToken: "id_token",
                    refreshToken: "refresh_token"
                };
                function d(e1, t, n) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, d, h, v, y, g, m, b, k, w;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (d = t.options.clientId, h = t.options.clientSecret, r || (r = t.tokenManager.getTokens()[n]), r) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new a.Z("unable to find ".concat(n, " in storage or fn params"));
                                case 5:
                                    if (o = (o = n !== l.T6.ACCESS ? null === (v = r) || void 0 === v ? void 0 : v.issuer : null === (y = r) || void 0 === y || null === (g = y.claims) || void 0 === g ? void 0 : g.iss) || t.options.issuer, d) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new a.Z("A clientId must be specified in the OktaAuth constructor to introspect a token");
                                case 9:
                                    if (o) {
                                        e1.next = 11;
                                        break;
                                    }
                                    throw new a.Z("Unable to find issuer");
                                case 11:
                                    return e1.next = 13, (0, u.E)(t, o);
                                case 13:
                                    return m = e1.sent, b = m.introspection_endpoint, k = h ? (0, f.r3)("".concat(d, ":").concat(h)) : (0, f.r3)(d), w = (0, s.UK)({
                                        token_type_hint: p[n],
                                        token: r[n]
                                    }).slice(1), e1.abrupt("return", (0, c.v_)(t, b, w, {
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded",
                                            Authorization: "Basic " + k
                                        }
                                    }));
                                case 18:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2724: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return j;
                    }
                });
                var r = n(4925), o = n(5861), i = n(5671), a = n(3144), u = n(7326), c = n(1752), s = n(136), f = n(2963), l = n(1120), p = n(4942), d = n(4687), h = n.n(d), v = n(5385), y = n(3548), g = n(4771), m = n(9718), b = n(3611), k = n(5324), w = n(2427), O = n(8221), Z = n(7599), T = n(7659), E = n(9123), S = n(3114), x = n(1971), P = n(4858);
                var A = [
                    "originalUri"
                ];
                function R(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function _(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? R(Object(n), !0).forEach(function(t) {
                            (0, p.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function j(e1, t) {
                    var n, d = function(e1) {
                        (0, s.Z)(o, e1);
                        var t, n, r = (t = o, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, l.Z)(t);
                            if (n) {
                                var o = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function o() {
                            return (0, i.Z)(this, o), r.apply(this, arguments);
                        }
                        return (0, a.Z)(o, [
                            {
                                key: "setOriginalUri",
                                value: function(e1, t) {
                                    P.Z.getSessionStorage().setItem(x.REFERRER_PATH_STORAGE_KEY, e1), (t = t || this.options.state) && this.storageManager.getOriginalUriStorage().setItem(t, e1);
                                }
                            },
                            {
                                key: "getOriginalUri",
                                value: function(e1) {
                                    if (e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage().getItem(e1);
                                        if (t) return t;
                                    }
                                    var n = P.Z.getSessionStorage();
                                    return n && n.getItem(x.REFERRER_PATH_STORAGE_KEY) || void 0;
                                }
                            },
                            {
                                key: "removeOriginalUri",
                                value: function(e1) {
                                    if (P.Z.getSessionStorage().removeItem(x.REFERRER_PATH_STORAGE_KEY), e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage();
                                        t.removeItem && t.removeItem(e1);
                                    }
                                }
                            }
                        ]), o;
                    }(e1);
                    return n = function(e1) {
                        (0, s.Z)(H, e1);
                        var n, d, m, x, P, R, j, C, I, D, M, N, U, L = (N = H, U = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, l.Z)(N);
                            if (U) {
                                var n = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function H() {
                            var e1;
                            (0, i.Z)(this, H);
                            for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                            return e1 = L.call.apply(L, [
                                this
                            ].concat(r)), (0, p.Z)((0, u.Z)(e1), "token", void 0), (0, p.Z)((0, u.Z)(e1), "tokenManager", void 0), (0, p.Z)((0, u.Z)(e1), "transactionManager", void 0), (0, p.Z)((0, u.Z)(e1), "pkce", void 0), (0, p.Z)((0, u.Z)(e1), "endpoints", void 0), (0, p.Z)((0, u.Z)(e1), "_pending", void 0), (0, p.Z)((0, u.Z)(e1), "_tokenQueue", void 0), e1.transactionManager = new t(Object.assign({
                                storageManager: e1.storageManager
                            }, e1.options.transactionManager)), e1.pkce = {
                                DEFAULT_CODE_CHALLENGE_METHOD: b.Z.DEFAULT_CODE_CHALLENGE_METHOD,
                                generateVerifier: b.Z.generateVerifier,
                                computeChallenge: b.Z.computeChallenge
                            }, e1._pending = {
                                handleLogin: !1
                            }, e1._tokenQueue = new y.b, e1.token = (0, k.o)((0, u.Z)(e1), e1._tokenQueue), e1.tokenManager = new w.M((0, u.Z)(e1), e1.options.tokenManager), e1.endpoints = (0, k.$)((0, u.Z)(e1)), e1;
                        }
                        return (0, a.Z)(H, [
                            {
                                key: "clearStorage",
                                value: function() {
                                    (0, c.Z)((0, l.Z)(H.prototype), "clearStorage", this).call(this), this.tokenManager.clear();
                                }
                            },
                            {
                                key: "isAuthenticated",
                                value: (M = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i, a, u, c, s, f, l = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = l.length > 0 && void 0 !== l[0] ? l[0] : {}, n = this.tokenManager.getOptions(), r = n.autoRenew, o = n.autoRemove, i = t.onExpiredToken ? "renew" === t.onExpiredToken : r, a = t.onExpiredToken ? "remove" === t.onExpiredToken : o, u = this.tokenManager.getTokensSync(), !(c = u.accessToken) || !this.tokenManager.hasExpired(c)) {
                                                    e1.next = 19;
                                                    break;
                                                }
                                                if (c = void 0, !i) {
                                                    e1.next = 18;
                                                    break;
                                                }
                                                return e1.prev = 8, e1.next = 11, this.tokenManager.renew("accessToken");
                                            case 11:
                                                c = e1.sent, e1.next = 16;
                                                break;
                                            case 14:
                                                e1.prev = 14, e1.t0 = e1.catch(8);
                                            case 16:
                                                e1.next = 19;
                                                break;
                                            case 18:
                                                a && this.tokenManager.remove("accessToken");
                                            case 19:
                                                if (s = this.tokenManager.getTokensSync(), !(f = s.idToken) || !this.tokenManager.hasExpired(f)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                if (f = void 0, !i) {
                                                    e1.next = 33;
                                                    break;
                                                }
                                                return e1.prev = 23, e1.next = 26, this.tokenManager.renew("idToken");
                                            case 26:
                                                f = e1.sent, e1.next = 31;
                                                break;
                                            case 29:
                                                e1.prev = 29, e1.t1 = e1.catch(23);
                                            case 31:
                                                e1.next = 34;
                                                break;
                                            case 33:
                                                a && this.tokenManager.remove("idToken");
                                            case 34:
                                                return e1.abrupt("return", !(!c || !f));
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            8,
                                            14
                                        ],
                                        [
                                            23,
                                            29
                                        ]
                                    ]);
                                })), function() {
                                    return M.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithRedirect",
                                value: (D = (0, o.Z)(h().mark(function e1() {
                                    var t, n, o, i, a = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (n = (t = a.length > 0 && void 0 !== a[0] ? a[0] : {}).originalUri, o = (0, r.Z)(t, A), !this._pending.handleLogin) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return");
                                            case 4:
                                                return this._pending.handleLogin = !0, e1.prev = 5, n && this.setOriginalUri(n), i = Object.assign({
                                                    scopes: this.options.scopes || [
                                                        "openid",
                                                        "email",
                                                        "profile"
                                                    ]
                                                }, o), e1.next = 10, this.token.getWithRedirect(i);
                                            case 10:
                                                return e1.prev = 10, this._pending.handleLogin = !1, e1.finish(10);
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            5,
                                            ,
                                            10,
                                            13
                                        ]
                                    ]);
                                })), function() {
                                    return D.apply(this, arguments);
                                })
                            },
                            {
                                key: "getUser",
                                value: (I = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return t = this.tokenManager.getTokensSync(), n = t.idToken, r = t.accessToken, e1.abrupt("return", this.token.getUserInfo(r, n));
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return I.apply(this, arguments);
                                })
                            },
                            {
                                key: "getIdToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().idToken;
                                    return e1 ? e1.idToken : void 0;
                                }
                            },
                            {
                                key: "getAccessToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().accessToken;
                                    return e1 ? e1.accessToken : void 0;
                                }
                            },
                            {
                                key: "getRefreshToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().refreshToken;
                                    return e1 ? e1.refreshToken : void 0;
                                }
                            },
                            {
                                key: "getOrRenewAccessToken",
                                value: (C = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = this.tokenManager.getTokensSync(), !(n = t.accessToken) || this.tokenManager.hasExpired(n)) {
                                                    e1.next = 3;
                                                    break;
                                                }
                                                return e1.abrupt("return", n.accessToken);
                                            case 3:
                                                return e1.prev = 3, o = this.tokenManager.getStorageKeyByType("accessToken"), e1.next = 7, this.tokenManager.renew(null != o ? o : "accessToken");
                                            case 7:
                                                return i = e1.sent, e1.abrupt("return", null !== (r = null == i ? void 0 : i.accessToken) && void 0 !== r ? r : null);
                                            case 11:
                                                return e1.prev = 11, e1.t0 = e1.catch(3), this.emitter.emit("error", e1.t0), e1.abrupt("return", null);
                                            case 15:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            3,
                                            11
                                        ]
                                    ]);
                                })), function() {
                                    return C.apply(this, arguments);
                                })
                            },
                            {
                                key: "storeTokensFromRedirect",
                                value: (j = (0, o.Z)(h().mark(function e1() {
                                    var t, n;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.token.parseFromUrl();
                                            case 2:
                                                t = e1.sent, n = t.tokens, "none" !== t.responseType && this.tokenManager.setTokens(n);
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return j.apply(this, arguments);
                                })
                            },
                            {
                                key: "isLoginRedirect",
                                value: function() {
                                    return (0, O.gM)(this);
                                }
                            },
                            {
                                key: "isPKCE",
                                value: function() {
                                    return !!this.options.pkce;
                                }
                            },
                            {
                                key: "hasResponseType",
                                value: function(e1) {
                                    return (0, O.wV)(e1, this.options);
                                }
                            },
                            {
                                key: "isAuthorizationCodeFlow",
                                value: function() {
                                    return this.hasResponseType("code");
                                }
                            },
                            {
                                key: "invokeApiMethod",
                                value: (R = (0, o.Z)(h().mark(function e1(t) {
                                    var n;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t.accessToken) {
                                                    e1.next = 5;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                n = e1.sent.accessToken, t.accessToken = null == n ? void 0 : n.accessToken;
                                            case 5:
                                                return e1.abrupt("return", (0, v.c3)(this, t));
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return R.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeAccessToken",
                                value: (P = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                if (n = e1.sent, t = n.accessToken, r = this.tokenManager.getStorageKeyByType("accessToken"), this.tokenManager.remove(r), !this.options.dpop) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.ao)("access", n);
                                            case 10:
                                                if (t) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 12:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return P.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeRefreshToken",
                                value: (x = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                if (n = e1.sent, t = n.refreshToken, r = this.tokenManager.getStorageKeyByType("refreshToken"), this.tokenManager.remove(r), !this.options.dpop) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.ao)("refresh", n);
                                            case 10:
                                                if (t) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 12:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return x.apply(this, arguments);
                                })
                            },
                            {
                                key: "getSignOutRedirectUrl",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e1.idToken, n = e1.postLogoutRedirectUri, r = e1.state;
                                    if (t || (t = this.tokenManager.getTokensSync().idToken), !t) return "";
                                    void 0 === n && (n = this.options.postLogoutRedirectUri);
                                    var o = (0, Z.Fc)(this).logoutUrl, i = t.idToken, a = o + "?id_token_hint=" + encodeURIComponent(i);
                                    return n && (a += "&post_logout_redirect_uri=" + encodeURIComponent(n)), r && (a += "&state=" + encodeURIComponent(r)), a;
                                }
                            },
                            {
                                key: "signOut",
                                value: (m = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r, o, i, a, u, c, s, f, l, p, d, v, y, g, m;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = Object.assign({}, t), a = window.location.origin, u = window.location.href, c = null === t.postLogoutRedirectUri ? null : t.postLogoutRedirectUri || this.options.postLogoutRedirectUri || a, s = null === (n = t) || void 0 === n ? void 0 : n.state, f = t.accessToken, l = t.refreshToken, p = !1 !== t.revokeAccessToken, (d = !1 !== t.revokeRefreshToken) && void 0 === l && (l = this.tokenManager.getTokensSync().refreshToken), p && void 0 === f && (f = this.tokenManager.getTokensSync().accessToken), t.idToken || (t.idToken = this.tokenManager.getTokensSync().idToken), !d || !l) {
                                                    e1.next = 15;
                                                    break;
                                                }
                                                return e1.next = 15, this.revokeRefreshToken(l);
                                            case 15:
                                                if (!p || !f) {
                                                    e1.next = 18;
                                                    break;
                                                }
                                                return e1.next = 18, this.revokeAccessToken(f);
                                            case 18:
                                                if (v = null !== (r = null === (o = f) || void 0 === o ? void 0 : o.dpopPairId) && void 0 !== r ? r : null === (i = l) || void 0 === i ? void 0 : i.dpopPairId, !this.options.dpop || !v) {
                                                    e1.next = 22;
                                                    break;
                                                }
                                                return e1.next = 22, (0, T.sd)(v);
                                            case 22:
                                                if (y = this.getSignOutRedirectUrl(_(_({}, t), {}, {
                                                    postLogoutRedirectUri: c
                                                }))) {
                                                    e1.next = 33;
                                                    break;
                                                }
                                                return e1.next = 26, this.closeSession();
                                            case 26:
                                                return g = e1.sent, m = new URL(c || a), s && m.searchParams.append("state", s), c === u ? window.location.href = m.href : window.location.assign(m.href), e1.abrupt("return", g);
                                            case 33:
                                                return t.clearTokensBeforeRedirect ? this.tokenManager.clear() : this.tokenManager.addPendingRemoveFlags(), window.location.assign(y), e1.abrupt("return", !0);
                                            case 36:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return m.apply(this, arguments);
                                })
                            },
                            {
                                key: "getDPoPAuthorizationHeaders",
                                value: (d = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r, o, i;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (this.options.dpop) {
                                                    e1.next = 2;
                                                    break;
                                                }
                                                throw new E.Z("DPoP is not configured for this client instance");
                                            case 2:
                                                if ((r = t.accessToken) || (r = this.tokenManager.getTokensSync().accessToken), r) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                throw new E.Z("AccessToken is required to generate a DPoP Proof");
                                            case 6:
                                                return e1.next = 8, (0, T.lk)(null === (n = r) || void 0 === n ? void 0 : n.dpopPairId);
                                            case 8:
                                                return o = e1.sent, e1.next = 11, (0, T.aW)(_(_({}, t), {}, {
                                                    keyPair: o,
                                                    accessToken: r.accessToken
                                                }));
                                            case 11:
                                                return i = e1.sent, e1.abrupt("return", {
                                                    Authorization: "DPoP ".concat(r.accessToken),
                                                    Dpop: i
                                                });
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return d.apply(this, arguments);
                                })
                            },
                            {
                                key: "clearDPoPStorage",
                                value: (n = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (!(i.length > 0 && void 0 !== i[0] && i[0])) {
                                                    e1.next = 3;
                                                    break;
                                                }
                                                return e1.abrupt("return", (0, T.V7)());
                                            case 3:
                                                return e1.next = 5, this.tokenManager.getTokens();
                                            case 5:
                                                if (r = e1.sent, !(o = (null === (t = r.accessToken) || void 0 === t ? void 0 : t.dpopPairId) || (null === (n = r.refreshToken) || void 0 === n ? void 0 : n.dpopPairId))) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.sd)(o);
                                            case 10:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "parseUseDPoPNonceError",
                                value: function(e1) {
                                    var t = S.Z.getWWWAuthenticateHeader(e1), n = S.Z.parseHeader(null != t ? t : "");
                                    if ((0, T.SO)(n)) {
                                        var r, o, i = null;
                                        return (0, g.mf)(null == e1 ? void 0 : e1.get) && (i = e1.get("DPoP-Nonce")), null !== (r = null !== (o = i) && void 0 !== o ? o : e1["dpop-nonce"]) && void 0 !== r ? r : e1["DPoP-Nonce"];
                                    }
                                    return null;
                                }
                            }
                        ]), H;
                    }(d), (0, p.Z)(n, "crypto", m), n;
                }
            },
            9453: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return g;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(1971), l = n(6718), p = n(415), d = n(8817), h = !0, v = n(9123);
                function y(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function g() {
                    return function(e1) {
                        (0, a.Z)(g, e1);
                        var t, n, d = (t = g, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function g(e1) {
                            var t;
                            return (0, o.Z)(this, g), t = d.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "authorizeUrl", void 0), (0, s.Z)((0, i.Z)(t), "userinfoUrl", void 0), (0, s.Z)((0, i.Z)(t), "tokenUrl", void 0), (0, s.Z)((0, i.Z)(t), "revokeUrl", void 0), (0, s.Z)((0, i.Z)(t), "logoutUrl", void 0), (0, s.Z)((0, i.Z)(t), "pkce", void 0), (0, s.Z)((0, i.Z)(t), "clientId", void 0), (0, s.Z)((0, i.Z)(t), "redirectUri", void 0), (0, s.Z)((0, i.Z)(t), "responseType", void 0), (0, s.Z)((0, i.Z)(t), "responseMode", void 0), (0, s.Z)((0, i.Z)(t), "state", void 0), (0, s.Z)((0, i.Z)(t), "scopes", void 0), (0, s.Z)((0, i.Z)(t), "ignoreSignature", void 0), (0, s.Z)((0, i.Z)(t), "codeChallenge", void 0), (0, s.Z)((0, i.Z)(t), "codeChallengeMethod", void 0), (0, s.Z)((0, i.Z)(t), "acrValues", void 0), (0, s.Z)((0, i.Z)(t), "maxAge", void 0), (0, s.Z)((0, i.Z)(t), "dpop", void 0), (0, s.Z)((0, i.Z)(t), "tokenManager", void 0), (0, s.Z)((0, i.Z)(t), "postLogoutRedirectUri", void 0), (0, s.Z)((0, i.Z)(t), "restoreOriginalUri", void 0), (0, s.Z)((0, i.Z)(t), "transactionManager", void 0), (0, s.Z)((0, i.Z)(t), "clientSecret", void 0), (0, s.Z)((0, i.Z)(t), "setLocation", void 0), (0, s.Z)((0, i.Z)(t), "ignoreLifetime", void 0), (0, s.Z)((0, i.Z)(t), "maxClockSkew", void 0), function(e1) {
                                var t = (e1 = e1 || {}).scopes;
                                if (t && !Array.isArray(t)) throw new v.Z('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
                                var n = e1.issuer;
                                if (!n) throw new v.Z('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (!new RegExp("^http?s?://.+").test(n)) throw new v.Z('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (-1 !== n.indexOf("-admin.okta")) throw new v.Z('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
                            }(e1), t.issuer = (0, l.Qj)(e1.issuer), t.tokenUrl = (0, l.Qj)(e1.tokenUrl), t.authorizeUrl = (0, l.Qj)(e1.authorizeUrl), t.userinfoUrl = (0, l.Qj)(e1.userinfoUrl), t.revokeUrl = (0, l.Qj)(e1.revokeUrl), t.logoutUrl = (0, l.Qj)(e1.logoutUrl), t.pkce = !1 !== e1.pkce, t.clientId = e1.clientId, t.redirectUri = e1.redirectUri, (0, p.isBrowser)() && (t.redirectUri = (0, l.BY)(e1.redirectUri, window.location.origin)), t.responseType = e1.responseType, t.responseMode = e1.responseMode, t.state = e1.state, t.scopes = e1.scopes, t.ignoreSignature = !!e1.ignoreSignature, t.codeChallenge = e1.codeChallenge, t.codeChallengeMethod = e1.codeChallengeMethod, t.acrValues = e1.acrValues, t.maxAge = e1.maxAge, t.dpop = !0 === e1.dpop, t.tokenManager = e1.tokenManager, t.postLogoutRedirectUri = e1.postLogoutRedirectUri, t.restoreOriginalUri = e1.restoreOriginalUri, t.transactionManager = function(e1) {
                                for(var t = 1; t < arguments.length; t++){
                                    var n = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? y(Object(n), !0).forEach(function(t) {
                                        (0, s.Z)(e1, t, n[t]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function(t) {
                                        Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                                    });
                                }
                                return e1;
                            }({
                                enableSharedStorage: h
                            }, e1.transactionManager), t.clientSecret = e1.clientSecret, t.setLocation = e1.setLocation, t.ignoreLifetime = !!e1.ignoreLifetime, e1.maxClockSkew || 0 === e1.maxClockSkew ? t.maxClockSkew = e1.maxClockSkew : t.maxClockSkew = f.DEFAULT_MAX_CLOCK_SKEW, t;
                        }
                        return (0, r.Z)(g);
                    }((0, d.Z)());
                }
            },
            3775: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return r.m;
                    }
                });
                var r = n(9453);
            },
            5372: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Tp: function() {
                        return p;
                    },
                    ko: function() {
                        return h;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(1969), c = n(9912), s = n(4771), f = n(8676);
                function l(e1) {
                    var t = e1.options.pkce ? "query" : "fragment";
                    return e1.options.responseMode || t;
                }
                function p(e1, t) {
                    t = t || {}, (0, s.HD)(t) && (t = {
                        url: t
                    });
                    var n, r = t.url, o = t.responseMode || l(e1), i = e1.token.parseFromUrl._getLocation();
                    if (!(n = "query" === o ? r ? r.substring(r.indexOf("?")) : i.search : r ? r.substring(r.indexOf("#")) : i.hash)) throw new a.Z("Unable to parse a token from the url");
                    return (0, u.v)(n);
                }
                function d(e1, t) {
                    "query" === (t.responseMode || l(e1)) ? function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
                    }(e1) : function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
                    }(e1);
                }
                function h(e1, t) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return (v = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, u, l;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = n || {}, (0, s.HD)(n) && (n = {
                                        url: n
                                    }), r = p(t, n), o = r.state, u = t.transactionManager.load({
                                        state: o
                                    })) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (!t.options.pkce) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new a.Z("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", void 0);
                                case 8:
                                    throw new a.Z("Unable to retrieve OAuth redirect params from storage");
                                case 9:
                                    return l = u.urls, delete u.urls, n.url || d(t, n), e1.abrupt("return", (0, f.s)(t, u, r, l).catch(function(e1) {
                                        throw (0, c.Cf)(e1) || t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }).then(function(e1) {
                                        return t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2476: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(6488), c = n(7625), s = n(781);
                function f() {
                    throw new a.Z("Renew must be passed a token with an array of scopes and an accessToken or idToken");
                }
                function l(e1, t) {
                    return (0, u.sI)(e1) ? t.idToken : (0, u.hv)(e1) ? t.accessToken : void f();
                }
                function p(e1, t) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, p, d, h, v, y, g;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((0, u.sI)(n) || (0, u.hv)(n) || f(), !(r = t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 7;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.R)(t, {
                                        scopes: n.scopes
                                    }, r.refreshToken);
                                case 5:
                                    return r = e1.sent, e1.abrupt("return", l(n, r));
                                case 7:
                                    return o = t.options.pkce ? "code" : (0, u.hv)(n) ? "token" : "id_token", p = (a = n).scopes, d = a.authorizeUrl, h = a.userinfoUrl, v = a.issuer, y = a.dpopPairId, g = a.extraParams, e1.abrupt("return", (0, c.y)(t, {
                                        responseType: o,
                                        scopes: p,
                                        authorizeUrl: d,
                                        userinfoUrl: h,
                                        issuer: v,
                                        dpopPairId: y,
                                        extraParams: g
                                    }).then(function(e1) {
                                        return l(n, e1.tokens);
                                    }));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            6268: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    I: function() {
                        return f;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(7625), c = n(781), s = n(7756);
                function f(e1, t) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return (l = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, f, l, p, d, h, v, y, g, m, b, k;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(f = null !== (r = null === (o = n) || void 0 === o ? void 0 : o.tokens) && void 0 !== r ? r : t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 3;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, c.R)(t, n || {}, f.refreshToken));
                                case 3:
                                    if (f.accessToken || f.idToken) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new a.Z("renewTokens() was called but there is no existing token");
                                case 5:
                                    if (l = f.accessToken || {}, p = f.idToken || {}, d = l.scopes || p.scopes) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read scopes");
                                case 10:
                                    if (h = l.authorizeUrl || p.authorizeUrl) {
                                        e1.next = 13;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read authorizeUrl");
                                case 13:
                                    return v = l.userinfoUrl || t.options.userinfoUrl, y = p.issuer || t.options.issuer, g = null == l ? void 0 : l.dpopPairId, m = (null == l ? void 0 : l.extraParams) || (null == p ? void 0 : p.extraParams), n = Object.assign({
                                        scopes: d,
                                        authorizeUrl: h,
                                        userinfoUrl: v,
                                        issuer: y,
                                        dpopPairId: g,
                                        extraParams: m
                                    }, n), t.options.pkce ? n.responseType = "code" : (b = (0, s.D)(t), k = b.responseType, n.responseType = k), e1.abrupt("return", (0, u.y)(t, n).then(function(e1) {
                                        return e1.tokens;
                                    }));
                                case 20:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            781: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return y;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(7599), s = n(6635), f = n(8676), l = n(9231), p = n(7659), d = n(9912);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function y(e1, t, n) {
                    return g.apply(this, arguments);
                }
                function g() {
                    return (g = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i, h, y, g, m, b, k, w, O, Z;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = t.options, i = o.clientId, h = o.dpop, i) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new u.Z("A clientId must be specified in the OktaAuth constructor to renew tokens");
                                case 3:
                                    if (e1.prev = 3, y = Object.assign({}, n, {
                                        clientId: i
                                    }), r.extraParams && (y.extraParams = r.extraParams), g = v({}, y), !h) {
                                        e1.next = 14;
                                        break;
                                    }
                                    return e1.next = 10, (0, p.lk)(null == r ? void 0 : r.dpopPairId);
                                case 10:
                                    m = e1.sent, g.dpopKeyPair = m, y.dpop = h, y.dpopPairId = r.dpopPairId;
                                case 14:
                                    return e1.next = 16, (0, l.D)(t, g, r);
                                case 16:
                                    return b = e1.sent, k = (0, c.Fc)(t, n), e1.next = 20, (0, f.s)(t, y, b, k);
                                case 20:
                                    return w = e1.sent, O = w.tokens, (Z = O.refreshToken) && !(0, s.q)(Z, r) && t.tokenManager.updateRefreshToken(Z), e1.abrupt("return", O);
                                case 27:
                                    throw e1.prev = 27, e1.t0 = e1.catch(3), (0, d.$E)(e1.t0) && t.tokenManager.removeRefreshToken(), e1.t0;
                                case 31:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                3,
                                27
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
            },
            6466: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(5385), u = n(6718), c = n(7599), s = n(7594), f = n(9123);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p, d, h, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = "", o = "", n && (r = n.accessToken, o = n.refreshToken), r || o) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new f.Z("A valid access or refresh token object is required");
                                case 5:
                                    if (l = t.options.clientId, p = t.options.clientSecret, l) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("A clientId must be specified in the OktaAuth constructor to revoke a token");
                                case 9:
                                    return d = (0, c.Fc)(t).revokeUrl, h = (0, u.UK)({
                                        token_type_hint: o ? "refresh_token" : "access_token",
                                        token: o || r
                                    }).slice(1), v = p ? (0, s.r3)("".concat(l, ":").concat(p)) : (0, s.r3)(l), e1.abrupt("return", (0, a.v_)(t, d, h, {
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded",
                                            Authorization: "Basic " + v
                                        }
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2333: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5437), s = n(5763), f = n(1971);
                function l() {
                    return function(e1) {
                        (0, i.Z)(p, e1);
                        var t, n, l = (t = p, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function p(e1, t, n) {
                            return (0, r.Z)(this, p), l.call(this, e1, t, n);
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "getTransactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getSharedTansactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("shared-transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.SHARED_TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getOriginalUriStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("original-uri", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.ORIGINAL_URI_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            }
                        ]), p;
                    }(c.W);
                }
            },
            6488: function(e1, t, n) {
                "use strict";
                var r;
                function o(e1) {
                    return !!(e1 && (e1.accessToken || e1.idToken || e1.refreshToken) && Array.isArray(e1.scopes));
                }
                function i(e1) {
                    return e1 && e1.accessToken;
                }
                function a(e1) {
                    return e1 && e1.idToken;
                }
                function u(e1) {
                    return e1 && e1.refreshToken;
                }
                n.d(t, {
                    T6: function() {
                        return r;
                    },
                    hD: function() {
                        return o;
                    },
                    hv: function() {
                        return i;
                    },
                    sI: function() {
                        return a;
                    },
                    z9: function() {
                        return u;
                    }
                }), function(e1) {
                    e1.ACCESS = "accessToken", e1.ID = "idToken", e1.REFRESH = "refreshToken";
                }(r || (r = {}));
            },
            7088: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $I: function() {
                        return u;
                    },
                    $Y: function() {
                        return r;
                    },
                    E: function() {
                        return o;
                    },
                    FT: function() {
                        return a;
                    },
                    O3: function() {
                        return i;
                    },
                    zr: function() {
                        return c;
                    }
                });
                var r = "expired", o = "renewed", i = "added", a = "removed", u = "error", c = "set_storage";
            },
            4319: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G5: function() {
                        return i;
                    },
                    ZT: function() {
                        return a;
                    },
                    mH: function() {
                        return s;
                    },
                    rZ: function() {
                        return c;
                    },
                    sG: function() {
                        return u;
                    }
                });
                var r = n(1002);
                function o(e1) {
                    return !(!e1 || "object" !== (0, r.Z)(e1) || 0 === Object.values(e1).length);
                }
                function i(e1) {
                    return !(!o(e1) || !e1.redirectUri && !e1.responseType);
                }
                function a(e1) {
                    return !!i(e1) && !!e1.codeVerifier;
                }
                function u(e1) {
                    return !!a(e1) && !!e1.interactionHandle;
                }
                function c(e1) {
                    return !!o(e1) && void 0 === Object.values(e1).find(function(e1) {
                        return "string" != typeof e1;
                    });
                }
                function s(e1) {
                    return !(!i(e1) && !c(e1));
                }
            },
            7615: function() {},
            8927: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    EVENT_ADDED: function() {
                        return u.O3;
                    },
                    EVENT_ERROR: function() {
                        return u.$I;
                    },
                    EVENT_EXPIRED: function() {
                        return u.$Y;
                    },
                    EVENT_REMOVED: function() {
                        return u.FT;
                    },
                    EVENT_RENEWED: function() {
                        return u.E;
                    },
                    EVENT_SET_STORAGE: function() {
                        return u.zr;
                    },
                    TokenKind: function() {
                        return a.T6;
                    },
                    isAccessToken: function() {
                        return a.hv;
                    },
                    isCustomAuthTransactionMeta: function() {
                        return c.rZ;
                    },
                    isIDToken: function() {
                        return a.sI;
                    },
                    isIdxTransactionMeta: function() {
                        return c.sG;
                    },
                    isOAuthTransactionMeta: function() {
                        return c.G5;
                    },
                    isPKCETransactionMeta: function() {
                        return c.ZT;
                    },
                    isRefreshToken: function() {
                        return a.z9;
                    },
                    isToken: function() {
                        return a.hD;
                    },
                    isTransactionMeta: function() {
                        return c.mH;
                    }
                });
                var r = n(9263), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
                var a = n(6488), u = n(7088), c = n(4319), s = n(7615);
                for(var i in o = {}, s)[
                    "default",
                    "TokenKind",
                    "isAccessToken",
                    "isIDToken",
                    "isRefreshToken",
                    "isToken",
                    "EVENT_ADDED",
                    "EVENT_ERROR",
                    "EVENT_EXPIRED",
                    "EVENT_REMOVED",
                    "EVENT_RENEWED",
                    "EVENT_SET_STORAGE",
                    "isCustomAuthTransactionMeta",
                    "isIdxTransactionMeta",
                    "isOAuthTransactionMeta",
                    "isPKCETransactionMeta",
                    "isTransactionMeta"
                ].indexOf(i) < 0 && (o[i] = (function(e1) {
                    return s[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            9263: function() {},
            4970: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    NH: function() {
                        return o;
                    },
                    Rl: function() {
                        return a;
                    },
                    iC: function() {
                        return c;
                    },
                    pU: function() {
                        return u;
                    },
                    ys: function() {
                        return i;
                    }
                });
                var r = n(9123);
                function o(e1, t, n) {
                    e1.addEventListener ? e1.addEventListener(t, n) : e1.attachEvent("on" + t, n);
                }
                function i(e1, t, n) {
                    e1.removeEventListener ? e1.removeEventListener(t, n) : e1.detachEvent("on" + t, n);
                }
                function a(e1) {
                    var t = document.createElement("iframe");
                    return t.style.display = "none", t.src = e1, document.body.appendChild(t);
                }
                function u(e1, t) {
                    var n = t.popupTitle || "External Identity Provider User Authentication";
                    return window.open(e1, n, "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600");
                }
                function c(e1, t, n) {
                    var a, u;
                    return new Promise(function(i, c) {
                        a = function(t) {
                            if (t.data && t.data.state === n) return t.origin !== e1.getIssuerOrigin() ? c(new r.Z("The request does not match client configuration")) : void i(t.data);
                        }, o(window, "message", a), u = setTimeout(function() {
                            c(new r.Z("OAuth flow timed out"));
                        }, t || 12e4);
                    }).finally(function() {
                        clearTimeout(u), i(window, "message", a);
                    });
                }
            },
            5078: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    c: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.clientId, a = t.redirectUri, u = t.responseMode, c = t.state, s = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        clientId: n,
                        redirectUri: a || s,
                        responseMode: u,
                        state: c || (0, r.aV)(),
                        responseType: "none",
                        prompt: "enroll_authenticator"
                    });
                }
            },
            7756: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.pkce, a = t.clientId, u = t.redirectUri, c = t.responseType, s = t.responseMode, f = t.scopes, l = t.acrValues, p = t.maxAge, d = t.state, h = t.ignoreSignature, v = t.dpop, y = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        pkce: n,
                        clientId: a,
                        redirectUri: u || y,
                        responseType: c || [
                            "token",
                            "id_token"
                        ],
                        responseMode: s,
                        state: d || (0, r.aV)(),
                        nonce: (0, r.NH)(),
                        scopes: f || [
                            "openid",
                            "email"
                        ],
                        acrValues: l,
                        maxAge: p,
                        ignoreSignature: h,
                        dpop: v
                    });
                }
            },
            8080: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return o;
                    }
                });
                var r = n(7599);
                function o(e1, t) {
                    return {
                        issuer: e1.options.issuer,
                        urls: (0, r.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        state: t.state,
                        acrValues: t.acrValues,
                        enrollAmrValues: t.enrollAmrValues
                    };
                }
            },
            9912: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a;
                    },
                    Cf: function() {
                        return o;
                    },
                    tC: function() {
                        return i;
                    }
                });
                var r = n(5728);
                function o(e1) {
                    return "OAuthError" === e1.name && "interaction_required" === e1.errorCode;
                }
                function i(e1, t) {
                    if ("AuthApiError" !== t.name) return !1;
                    var n = t.xhr, r = null == n ? void 0 : n.responseJSON;
                    return e1.options.pkce && "invalid_grant" === (null == r ? void 0 : r.error);
                }
                function a(e1) {
                    return (0, r.isOAuthError)(e1) && "invalid_grant" === e1.errorCode && "The refresh token is invalid or expired." === e1.errorSummary;
                }
            },
            8785: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a.$E;
                    },
                    AW: function() {
                        return f.A;
                    },
                    Cf: function() {
                        return a.Cf;
                    },
                    Dx: function() {
                        return o.D;
                    },
                    Fc: function() {
                        return c.Fc;
                    },
                    H: function() {
                        return s.H;
                    },
                    Ik: function() {
                        return u.Ik;
                    },
                    NH: function() {
                        return r.NH;
                    },
                    O2: function() {
                        return u.O2;
                    },
                    PY: function() {
                        return c.NH;
                    },
                    Qs: function() {
                        return u.Qs;
                    },
                    Rl: function() {
                        return r.Rl;
                    },
                    Rp: function() {
                        return g.R;
                    },
                    U5: function() {
                        return l.Z;
                    },
                    Uc: function() {
                        return d.U;
                    },
                    Xp: function() {
                        return c.Xp;
                    },
                    Yo: function() {
                        return h.Y;
                    },
                    ZP: function() {
                        return u.ZP;
                    },
                    aV: function() {
                        return c.aV;
                    },
                    br: function() {
                        return p.br;
                    },
                    cE: function() {
                        return i.c;
                    },
                    d_: function() {
                        return u.d_;
                    },
                    gM: function() {
                        return u.gM;
                    },
                    hg: function() {
                        return u.hg;
                    },
                    iC: function() {
                        return r.iC;
                    },
                    kU: function() {
                        return u.kU;
                    },
                    mi: function() {
                        return p.mi;
                    },
                    pU: function() {
                        return r.pU;
                    },
                    pj: function() {
                        return y.p;
                    },
                    q0: function() {
                        return h.q;
                    },
                    tC: function() {
                        return a.tC;
                    },
                    vL: function() {
                        return v.v;
                    },
                    vz: function() {
                        return p.vz;
                    },
                    wV: function() {
                        return u.wV;
                    },
                    wc: function() {
                        return u.wc;
                    },
                    wu: function() {
                        return p.wu;
                    },
                    ys: function() {
                        return r.ys;
                    },
                    zf: function() {
                        return c.zf;
                    }
                });
                var r = n(4970), o = n(7756), i = n(5078), a = n(9912), u = n(8221), c = n(7599), s = n(2865), f = n(8080), l = n(3611), p = n(6898), d = n(6757), h = n(6635), v = n(1969), y = n(6003), g = n(2482);
            },
            8221: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /((id|access)_token=)/i.test(e1);
                }
                function o(e1) {
                    return /(code=)/i.test(e1);
                }
                function i(e1) {
                    return /(interaction_code=)/i.test(e1);
                }
                function a(e1) {
                    return /(error=)/i.test(e1) || /(error_description)/i.test(e1);
                }
                function u(e1, t) {
                    var n = t.options;
                    return !(!e1 || !n.redirectUri) && 0 === e1.indexOf(n.redirectUri);
                }
                function c(e1) {
                    return e1.pkce || "code" === e1.responseType || "query" === e1.responseMode;
                }
                function s(e1, t) {
                    return Array.isArray(t.responseType) && t.responseType.length ? t.responseType.indexOf(e1) >= 0 : t.responseType === e1;
                }
                function f(e1) {
                    return c(e1) && "fragment" !== e1.responseMode ? window.location.search : window.location.hash;
                }
                function l(e1) {
                    if (!u(window.location.href, e1)) return !1;
                    var t = c(e1.options), n = f(e1.options);
                    return !!a(n) || (t ? o(n) || i(n) : r(window.location.hash));
                }
                function p(e1, t) {
                    if (!t) {
                        if (!l(e1)) return !1;
                        t = f(e1.options);
                    }
                    return /(error=interaction_required)/i.test(t);
                }
                n.d(t, {
                    Ik: function() {
                        return c;
                    },
                    O2: function() {
                        return f;
                    },
                    Qs: function() {
                        return u;
                    },
                    ZP: function() {
                        return o;
                    },
                    d_: function() {
                        return i;
                    },
                    gM: function() {
                        return l;
                    },
                    hg: function() {
                        return a;
                    },
                    kU: function() {
                        return r;
                    },
                    wV: function() {
                        return s;
                    },
                    wc: function() {
                        return p;
                    }
                });
            },
            7599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Fc: function() {
                        return l;
                    },
                    NH: function() {
                        return u;
                    },
                    Xp: function() {
                        return f;
                    },
                    aV: function() {
                        return a;
                    },
                    zf: function() {
                        return s;
                    }
                });
                var r = n(8750), o = n(6718), i = n(9123);
                function a() {
                    return (0, r.uh)(64);
                }
                function u() {
                    return (0, r.uh)(64);
                }
                function c(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return (0, o.Qj)(t.issuer) || e1.options.issuer;
                }
                function s(e1) {
                    var t = c(e1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                    return t.indexOf("/oauth2") > 0 ? t : t + "/oauth2";
                }
                function f(e1) {
                    return c(e1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).split("/oauth2")[0];
                }
                function l(e1, t) {
                    if (arguments.length > 2) throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');
                    t = t || {};
                    var n = (0, o.Qj)(t.authorizeUrl) || e1.options.authorizeUrl, r = c(e1, t), a = (0, o.Qj)(t.userinfoUrl) || e1.options.userinfoUrl, u = (0, o.Qj)(t.tokenUrl) || e1.options.tokenUrl, f = (0, o.Qj)(t.logoutUrl) || e1.options.logoutUrl, l = (0, o.Qj)(t.revokeUrl) || e1.options.revokeUrl, p = s(e1, t);
                    return {
                        issuer: r,
                        authorizeUrl: n = n || p + "/v1/authorize",
                        userinfoUrl: a = a || p + "/v1/userinfo",
                        tokenUrl: u = u || p + "/v1/token",
                        revokeUrl: l = l || p + "/v1/revoke",
                        logoutUrl: f = f || p + "/v1/logout"
                    };
                }
            },
            2865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return u;
                    }
                });
                var r = n(4942), o = n(7599);
                function i(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function a(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function u(e1, t) {
                    var n = {
                        issuer: e1.options.issuer,
                        urls: (0, o.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        scopes: t.scopes,
                        state: t.state,
                        nonce: t.nonce,
                        ignoreSignature: t.ignoreSignature,
                        acrValues: t.acrValues,
                        extraParams: t.extraParams
                    };
                    return !1 === t.pkce ? n : a(a({}, n), {}, {
                        codeVerifier: t.codeVerifier,
                        codeChallengeMethod: t.codeChallengeMethod,
                        codeChallenge: t.codeChallenge
                    });
                }
            },
            3611: function(e1, t, n) {
                "use strict";
                var r = n(7594), o = n(7987), i = n(1971);
                function a(e1) {
                    return ("0" + e1.toString(16)).substr(-2);
                }
                t.Z = {
                    DEFAULT_CODE_CHALLENGE_METHOD: i.DEFAULT_CODE_CHALLENGE_METHOD,
                    generateVerifier: function(e1) {
                        var t, n, o = e1 || "";
                        return o.length < i.MIN_VERIFIER_LENGTH && (o += (t = i.MIN_VERIFIER_LENGTH - o.length, n = new Uint8Array(Math.ceil(t / 2)), r.KP.getRandomValues(n), Array.from(n, a).join("").slice(0, t))), encodeURIComponent(o).slice(0, i.MAX_VERIFIER_LENGTH);
                    },
                    computeChallenge: function(e1) {
                        var t = (new TextEncoder).encode(e1);
                        return r.KP.subtle.digest("SHA-256", t).then(function(e1) {
                            var t = String.fromCharCode.apply(null, new Uint8Array(e1));
                            return (0, o.NL)(t);
                        });
                    }
                };
            },
            6757: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return c;
                    }
                });
                var r = n(4942), o = n(9123), i = n(5078);
                function a(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function u(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? a(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function c(e1, t) {
                    return function(e1) {
                        if (!(e1 = u(u({}, e1), {}, {
                            responseType: "none",
                            prompt: "enroll_authenticator",
                            maxAge: 0
                        })).enrollAmrValues) throw new o.Z("enroll_amr_values must be specified");
                        if (!e1.acrValues) throw new o.Z("acr_values must be specified");
                        return delete e1.scopes, delete e1.nonce, e1;
                    }(u(u({}, (0, i.c)(e1)), t));
                }
            },
            6898: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    br: function() {
                        return v;
                    },
                    mi: function() {
                        return g;
                    },
                    vz: function() {
                        return h;
                    },
                    wu: function() {
                        return b;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(52), c = n(9123), s = n(7756), f = n(1971), l = n(3611);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    if (!e1.features.isPKCESupported()) {
                        var t = "PKCE requires a modern browser with encryption support running in a secure context.";
                        throw e1.features.isHTTPS() || (t += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e1.features.hasTextEncoder() || (t += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), new c.Z(t);
                    }
                }
                function v(e1, t) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = n || t.options.codeChallengeMethod || f.DEFAULT_CODE_CHALLENGE_METHOD, e1.next = 3, (0, u.E)(t);
                                case 3:
                                    if (-1 !== (e1.sent.code_challenge_methods_supported || []).indexOf(n)) {
                                        e1.next = 7;
                                        break;
                                    }
                                    throw new c.Z("Invalid code_challenge_method");
                                case 7:
                                    return e1.abrupt("return", n);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function g(e1, t) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = (r = n).codeVerifier, i = r.codeChallenge, u = r.codeChallengeMethod, i = i || t.options.codeChallenge) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return h(t), o = o || l.Z.generateVerifier(), e1.next = 7, l.Z.computeChallenge(o);
                                case 7:
                                    i = e1.sent;
                                case 8:
                                    return e1.next = 10, v(t, u);
                                case 10:
                                    return u = e1.sent, n = d(d({}, n), {}, {
                                        responseType: "code",
                                        codeVerifier: o,
                                        codeChallenge: i,
                                        codeChallengeMethod: u
                                    }), e1.abrupt("return", n);
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return k = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, s.D)(t), !(n = d(d({}, r), n)).dpop || t.features.isDPoPSupported()) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new c.Z("DPoP has been configured, but is not supported by browser");
                                case 5:
                                    if (!1 !== n.pkce) {
                                        e1.next = 7;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 7:
                                    return e1.abrupt("return", g(t, n));
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), k.apply(this, arguments);
                }
            },
            6635: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    },
                    q: function() {
                        return o;
                    }
                });
                var r = n(5728);
                function o(e1, t) {
                    return e1.refreshToken === t.refreshToken;
                }
                function i(e1) {
                    return !(!(0, r.isAuthApiError)(e1) || !e1.xhr || !e1.xhr.responseJSON || "invalid_grant" !== e1.xhr.responseJSON.error);
                }
            },
            1969: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = /\+/g, n = /([^&=]+)=?([^&]*)/g, r = e1 || "";
                    "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));
                    for(var o, i = {}; o = n.exec(r);){
                        var a = o[1], u = o[2];
                        i[a] = "id_token" === a || "access_token" === a || "code" === a ? u : decodeURIComponent(u.replace(t, " "));
                    }
                    return i;
                }
                n.d(t, {
                    v: function() {
                        return r;
                    }
                });
            },
            6003: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    p: function() {
                        return o;
                    }
                });
                var r = n(9123);
                function o(e1, t, n) {
                    var o = n.clientId, i = n.issuer, a = n.nonce, u = n.acrValues;
                    if (!t || !i || !o) throw new r.Z("The jwt, iss, and aud arguments are all required");
                    if (a && t.nonce !== a) throw new r.Z("OAuth flow response nonce doesn't match request nonce");
                    var c = Math.floor(Date.now() / 1e3);
                    if (t.iss !== i) throw new r.Z("The issuer [" + t.iss + "] does not match [" + i + "]");
                    if (Array.isArray(t.aud) && t.aud.indexOf(o) < 0 || !Array.isArray(t.aud) && t.aud !== o) throw new r.Z("The audience [" + t.aud + "] does not match [" + o + "]");
                    if (u && t.acr !== u) throw new r.Z("The acr [" + t.acr + "] does not match acr_values [" + u + "]");
                    if (t.iat > t.exp) throw new r.Z("The JWT expired before it was issued");
                    if (!e1.options.ignoreLifetime) {
                        if (c - e1.options.maxClockSkew > t.exp) throw new r.Z("The JWT expired and is no longer valid");
                        if (t.iat > c + e1.options.maxClockSkew) throw new r.Z("The JWT was issued in the future");
                    }
                }
            },
            2482: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(6488);
                function i(e1, t) {
                    if (!(0, o.sI)(e1) && !(0, o.hv)(e1) && !(0, o.z9)(e1)) throw new r.Z("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
                    if ("accessToken" === t && !(0, o.hv)(e1)) throw new r.Z("invalid accessToken");
                    if ("idToken" === t && !(0, o.sI)(e1)) throw new r.Z("invalid idToken");
                    if ("refreshToken" === t && !(0, o.z9)(e1)) throw new r.Z("invalid refreshToken");
                }
            },
            1260: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(52), u = n(6003), c = n(9123), s = n(1237), f = n(3154), l = n(5698);
                function p(e1, t, n) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, d, h, v, y;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n && n.idToken) {
                                        e1.next = 2;
                                        break;
                                    }
                                    throw new c.Z("Only idTokens may be verified");
                                case 2:
                                    return o = (0, s.T)(n.idToken), p = (null == r ? void 0 : r.issuer) || t.options.issuer, e1.next = 6, (0, a.E)(t, p);
                                case 6:
                                    if (d = e1.sent, h = d.issuer, v = Object.assign({
                                        clientId: t.options.clientId,
                                        ignoreSignature: t.options.ignoreSignature
                                    }, r, {
                                        issuer: h
                                    }), (0, u.p)(t, o.payload, v), 1 != v.ignoreSignature && t.features.isTokenVerifySupported()) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 12:
                                    return e1.next = 14, (0, a.k)(t, n.issuer, o.header.kid);
                                case 14:
                                    return y = e1.sent, e1.next = 17, f.W(n.idToken, y);
                                case 17:
                                    if (e1.sent) {
                                        e1.next = 20;
                                        break;
                                    }
                                    throw new c.Z("The token signature is not valid");
                                case 20:
                                    if (!(r && r.accessToken && n.claims.at_hash)) {
                                        e1.next = 26;
                                        break;
                                    }
                                    return e1.next = 23, l.X(r.accessToken);
                                case 23:
                                    if (e1.sent === n.claims.at_hash) {
                                        e1.next = 26;
                                        break;
                                    }
                                    throw new c.Z("Token hash verification failed");
                                case 26:
                                    return e1.abrupt("return", n);
                                case 27:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            3719: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return u;
                    },
                    OT: function() {
                        return f;
                    },
                    RJ: function() {
                        return c;
                    },
                    dx: function() {
                        return s;
                    },
                    sH: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(6718), i = n(5385);
                function a(e1) {
                    return e1.session.get().then(function(e1) {
                        return "ACTIVE" === e1.status;
                    }).catch(function() {
                        return !1;
                    });
                }
                function u(e1) {
                    return (0, i.U2)(e1, "/api/v1/sessions/me", {
                        withCredentials: !0
                    }).then(function(t) {
                        var n = (0, r.CE)(t, "_links");
                        return n.refresh = function() {
                            return (0, i.v_)(e1, (0, r.Rg)(t, "refresh").href, {}, {
                                withCredentials: !0
                            });
                        }, n.user = function() {
                            return (0, i.U2)(e1, (0, r.Rg)(t, "user").href, {
                                withCredentials: !0
                            });
                        }, n;
                    }).catch(function() {
                        return {
                            status: "INACTIVE"
                        };
                    });
                }
                function c(e1) {
                    return (0, i.c3)(e1, {
                        url: e1.getIssuerOrigin() + "/api/v1/sessions/me",
                        method: "DELETE",
                        withCredentials: !0
                    });
                }
                function s(e1) {
                    return (0, i.v_)(e1, "/api/v1/sessions/me/lifecycle/refresh", {}, {
                        withCredentials: !0
                    });
                }
                function f(e1, t, n) {
                    n = n || window.location.href, window.location.assign(e1.getIssuerOrigin() + "/login/sessionCookieRedirect" + (0, o.UK)({
                        checkAccountSetupComplete: !0,
                        token: t,
                        redirectUrl: n
                    }));
                }
            },
            2815: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return o;
                    }
                });
                var r = n(3719);
                function o(e1) {
                    return {
                        close: r.RJ.bind(null, e1),
                        exists: r.sH.bind(null, e1),
                        get: r.Gg.bind(null, e1),
                        refresh: r.dx.bind(null, e1),
                        setCookieAndRedirect: r.OT.bind(null, e1)
                    };
                }
            },
            8041: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return r.Gg;
                    },
                    MG: function() {
                        return o.M;
                    },
                    OT: function() {
                        return r.OT;
                    },
                    RJ: function() {
                        return r.RJ;
                    },
                    Zg: function() {
                        return i.Z;
                    },
                    dx: function() {
                        return r.dx;
                    },
                    sH: function() {
                        return r.sH;
                    }
                });
                var r = n(3719), o = n(2815), i = n(3980);
            },
            3980: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return h;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(2815);
                function h(e1) {
                    return function(e1) {
                        (0, u.Z)(h, e1);
                        var t, n, l = (t = h, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function h() {
                            var e1;
                            (0, o.Z)(this, h);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = l.call.apply(l, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "session", void 0), e1.session = (0, d.M)((0, a.Z)(e1)), e1;
                        }
                        return (0, i.Z)(h, [
                            {
                                key: "closeSession",
                                value: function() {
                                    var e1 = this;
                                    return this.session.close().then((0, r.Z)(p().mark(function t() {
                                        return p().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return e1.clearStorage(), t.abrupt("return", !0);
                                                case 2:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    }))).catch(function(e1) {
                                        if ("AuthApiError" === e1.name && "E0000007" === e1.errorCode) return !1;
                                        throw e1;
                                    });
                                }
                            }
                        ]), h;
                    }(e1);
                }
            },
            5437: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return f;
                    },
                    W: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(1971), u = n(5763), c = n(415), s = n(146);
                function f(e1) {
                    (0, c.isBrowser)() || e1.storageProvider || e1.storageKey || (0, s.ZK)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.");
                }
                var l = function() {
                    function e1(t, n, o) {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "storageManagerOptions", void 0), (0, i.Z)(this, "cookieOptions", void 0), (0, i.Z)(this, "storageUtil", void 0), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = o;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getOptionsForSection",
                            value: function(e1, t) {
                                return Object.assign({}, this.storageManagerOptions[e1], t);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function(e1) {
                                if ((e1 = Object.assign({}, this.cookieOptions, e1)).storageProvider) return e1.storageProvider;
                                var t = e1, n = t.storageType, r = t.storageTypes;
                                if ("sessionStorage" === n && (e1.sessionCookie = !0), n && r) {
                                    var o = r.indexOf(n);
                                    o >= 0 && (r = r.slice(o), n = void 0);
                                }
                                return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e1);
                            }
                        },
                        {
                            key: "getTokenStorage",
                            value: function(e1) {
                                f(e1 = this.getOptionsForSection("token", e1));
                                var t = this.getStorage(e1), n = e1.storageKey || a.TOKEN_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        },
                        {
                            key: "getHttpCache",
                            value: function(e1) {
                                e1 = this.getOptionsForSection("cache", e1);
                                var t = this.getStorage(e1), n = e1.storageKey || a.CACHE_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        }
                    ]), e1;
                }();
            },
            5763: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(9123), u = function() {
                    function e1(t, n) {
                        if ((0, r.Z)(this, e1), (0, i.Z)(this, "storageProvider", void 0), (0, i.Z)(this, "storageName", void 0), !t) throw new a.Z('"storage" is required');
                        if ("string" != typeof n || !n.length) throw new a.Z('"storageName" is required');
                        this.storageName = n, this.storageProvider = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getItem",
                            value: function(e1) {
                                return this.getStorage()[e1];
                            }
                        },
                        {
                            key: "setItem",
                            value: function(e1, t) {
                                return this.updateStorage(e1, t);
                            }
                        },
                        {
                            key: "removeItem",
                            value: function(e1) {
                                return this.clearStorage(e1);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                var e1 = this.storageProvider.getItem(this.storageName);
                                e1 = e1 || "{}";
                                try {
                                    return JSON.parse(e1);
                                } catch (e1) {
                                    throw new a.Z("Unable to parse storage string: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "setStorage",
                            value: function(e1) {
                                try {
                                    var t = e1 ? JSON.stringify(e1) : "{}";
                                    this.storageProvider.setItem(this.storageName, t);
                                } catch (e1) {
                                    throw new a.Z("Unable to set storage: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "clearStorage",
                            value: function(e1) {
                                if (e1) {
                                    var t = this.getStorage();
                                    delete t[e1], this.setStorage(t);
                                } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
                            }
                        },
                        {
                            key: "updateStorage",
                            value: function(e1, t) {
                                var n = this.getStorage();
                                n[e1] = t, this.setStorage(n);
                            }
                        }
                    ]), e1;
                }();
            },
            9927: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Ho: function() {
                        return i.H;
                    },
                    Tp: function() {
                        return r.T;
                    },
                    Vp: function() {
                        return o.V;
                    },
                    W8: function() {
                        return o.W;
                    },
                    _e: function() {
                        return a._;
                    }
                });
                var r = n(3849), o = n(5437), i = n(265), a = n(5763);
            },
            265: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return f;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    return function(e1) {
                        (0, a.Z)(p, e1);
                        var n, f, l = (n = p, f = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, c.Z)(n);
                            if (f) {
                                var r = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, r);
                            } else e1 = t.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function p() {
                            var e1;
                            (0, r.Z)(this, p);
                            for(var n = arguments.length, o = new Array(n), a = 0; a < n; a++)o[a] = arguments[a];
                            e1 = l.call.apply(l, [
                                this
                            ].concat(o)), (0, s.Z)((0, i.Z)(e1), "storageManager", void 0);
                            var u = e1.options, c = u.storageManager, f = u.cookies, d = u.storageUtil;
                            return e1.storageManager = new t(c, f, d), e1;
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "clearStorage",
                                value: function() {}
                            }
                        ]), p;
                    }(e1);
                }
            },
            3849: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return g;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(5093), l = n(146), p = n(4858), d = {
                    token: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    cache: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    transaction: {
                        storageTypes: [
                            "sessionStorage",
                            "localStorage",
                            "cookie"
                        ]
                    },
                    "shared-transaction": {
                        storageTypes: [
                            "localStorage"
                        ]
                    },
                    "original-uri": {
                        storageTypes: [
                            "localStorage"
                        ]
                    }
                }, h = n(415);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g() {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, f = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v(e1) {
                            var t;
                            return (0, o.Z)(this, v), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "cookies", void 0), (0, s.Z)((0, i.Z)(t), "storageUtil", void 0), (0, s.Z)((0, i.Z)(t), "storageManager", void 0), t.cookies = function() {
                                var e1 = arguments.length > 1 ? arguments[1] : void 0, t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).cookies || {};
                                return void 0 === t.secure && (t.secure = e1), void 0 === t.sameSite && (t.sameSite = t.secure ? "none" : "lax"), t.secure && !e1 && ((0, l.ZK)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), t.secure = !1), "none" !== t.sameSite || t.secure || (t.sameSite = "lax"), t;
                            }(e1, (0, h.isHTTPS)()), t.storageUtil = e1.storageUtil || Object.assign({}, p.Z, {
                                inMemoryStore: {}
                            }), t.storageManager = y(y({}, d), e1.storageManager), t;
                        }
                        return (0, r.Z)(v);
                    }((0, f.X)());
                }
            },
            3548: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return c;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4771), u = n(146), c = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                            quiet: !1
                        };
                        (0, r.Z)(this, e1), (0, i.Z)(this, "queue", void 0), (0, i.Z)(this, "running", void 0), (0, i.Z)(this, "options", void 0), this.queue = [], this.running = !1, this.options = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "push",
                            value: function(e1, t) {
                                for(var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)o[i - 2] = arguments[i];
                                return new Promise(function(r, i) {
                                    n.queue.length > 0 && !1 !== n.options.quiet && (0, u.ZK)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."), n.queue.push({
                                        method: e1,
                                        thisObject: t,
                                        args: o,
                                        resolve: r,
                                        reject: i
                                    }), n.run();
                                });
                            }
                        },
                        {
                            key: "run",
                            value: function() {
                                var e1 = this;
                                if (!this.running && 0 !== this.queue.length) {
                                    this.running = !0;
                                    var t = this.queue.shift(), n = t.method.apply(t.thisObject, t.args);
                                    (0, a.tI)(n) ? n.then(t.resolve, t.reject).finally(function() {
                                        e1.running = !1, e1.run();
                                    }) : (t.resolve(n), this.running = !1, this.run());
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            146: function(e1, t, n) {
                "use strict";
                function r() {
                    return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
                }
                function o() {
                    var e1 = r();
                    return e1 && e1.log ? e1 : {
                        log: function() {},
                        warn: function() {},
                        group: function() {},
                        groupEnd: function() {}
                    };
                }
                function i(e1) {
                    o().warn("[okta-auth-sdk] WARN: " + e1);
                }
                function a(e1) {
                    o().warn("[okta-auth-sdk] DEPRECATION: " + e1);
                }
                function u(e1, t) {
                    return function() {
                        return a(e1), t.apply(null, arguments);
                    };
                }
                n.d(t, {
                    Rn: function() {
                        return a;
                    },
                    VA: function() {
                        return u;
                    },
                    ZK: function() {
                        return i;
                    },
                    dr: function() {
                        return o;
                    },
                    sW: function() {
                        return r;
                    }
                });
            },
            305: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    BY: function() {
                        return c.BY;
                    },
                    CE: function() {
                        return i.CE;
                    },
                    HD: function() {
                        return u.HD;
                    },
                    Kn: function() {
                        return u.Kn;
                    },
                    QN: function() {
                        return c.QN;
                    },
                    Qj: function() {
                        return c.Qj;
                    },
                    Rg: function() {
                        return i.Rg;
                    },
                    Rn: function() {
                        return r.Rn;
                    },
                    UK: function() {
                        return c.UK;
                    },
                    VA: function() {
                        return r.VA;
                    },
                    YQ: function() {
                        return o.YQ;
                    },
                    YY: function() {
                        return i.YY;
                    },
                    ZK: function() {
                        return r.ZK;
                    },
                    ak: function() {
                        return i.ak;
                    },
                    bo: function() {
                        return a.b;
                    },
                    d9: function() {
                        return i.d9;
                    },
                    dr: function() {
                        return r.dr;
                    },
                    gw: function() {
                        return o.gw;
                    },
                    hj: function() {
                        return u.hj;
                    },
                    l7: function() {
                        return i.l7;
                    },
                    mf: function() {
                        return u.mf;
                    },
                    ng: function() {
                        return o.ng;
                    },
                    sD: function() {
                        return c.sD;
                    },
                    sE: function() {
                        return i.sE;
                    },
                    sW: function() {
                        return r.sW;
                    },
                    tI: function() {
                        return u.tI;
                    },
                    uh: function() {
                        return o.uh;
                    }
                });
                var r = n(146), o = n(8750), i = n(3193), a = n(3548), u = n(4771), c = n(6718);
            },
            8750: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = e1.match(/\d+/g), n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    return new Date(n).toUTCString();
                }
                function o(e1) {
                    for(var t = "", n = 0; n < e1; ++n)t += "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(61 * Math.random())];
                    return t;
                }
                function i(e1) {
                    return new Promise(function(t) {
                        setTimeout(t, e1);
                    });
                }
                function a(e1, t) {
                    var n = e1.split(t);
                    return [
                        n[0],
                        n.splice(1, n.length).join(t)
                    ];
                }
                n.d(t, {
                    YQ: function() {
                        return a;
                    },
                    gw: function() {
                        return i;
                    },
                    ng: function() {
                        return r;
                    },
                    uh: function() {
                        return o;
                    }
                });
            },
            3193: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    var n = Array.prototype.slice.call(arguments, 2);
                    return function() {
                        var r = Array.prototype.slice.call(arguments);
                        return r = n.concat(r), e1.apply(t, r);
                    };
                }
                function o() {
                    var e1 = arguments[0];
                    return [].slice.call(arguments, 1).forEach(function(t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e1[n] = t[n]);
                    }), e1;
                }
                function i(e1) {
                    var t = {};
                    for(var n in e1)if (Object.prototype.hasOwnProperty.call(e1, n)) {
                        var r = e1[n];
                        null != r && (t[n] = r);
                    }
                    return t;
                }
                function a(e1) {
                    if (e1) {
                        var t = JSON.stringify(e1);
                        if (t) return JSON.parse(t);
                    }
                    return e1;
                }
                function u(e1) {
                    for(var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = arguments[o];
                    for(var i in e1)Object.prototype.hasOwnProperty.call(e1, i) && -1 == r.indexOf(i) && (t[i] = e1[i]);
                    return a(t);
                }
                function c(e1, t) {
                    for(var n = e1.length; n--;){
                        var r = e1[n], o = !0;
                        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
                            o = !1;
                            break;
                        }
                        if (o) return r;
                    }
                }
                function s(e1, t, n) {
                    if (e1 && e1._links) {
                        var r = a(e1._links[t]);
                        return r && r.name && n ? r.name === n ? r : void 0 : r;
                    }
                }
                n.d(t, {
                    CE: function() {
                        return u;
                    },
                    Rg: function() {
                        return s;
                    },
                    YY: function() {
                        return i;
                    },
                    ak: function() {
                        return r;
                    },
                    d9: function() {
                        return a;
                    },
                    l7: function() {
                        return o;
                    },
                    sE: function() {
                        return c;
                    }
                });
            },
            4771: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return "[object String]" === Object.prototype.toString.call(e1);
                }
                function o(e1) {
                    return "[object Object]" === Object.prototype.toString.call(e1);
                }
                function i(e1) {
                    return "[object Number]" === Object.prototype.toString.call(e1);
                }
                function a(e1) {
                    return !!e1 && "[object Function]" === ({}).toString.call(e1);
                }
                function u(e1) {
                    return e1 && e1.finally && "function" == typeof e1.finally;
                }
                n.d(t, {
                    HD: function() {
                        return r;
                    },
                    Kn: function() {
                        return o;
                    },
                    hj: function() {
                        return i;
                    },
                    mf: function() {
                        return a;
                    },
                    tI: function() {
                        return u;
                    }
                });
            },
            6718: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /^[a-z][a-z0-9+.-]*:/i.test(e1);
                }
                function o() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) ? e1 : (t = u(t), "/" === e1[0] ? "".concat(t).concat(e1) : "".concat(t, "/").concat(e1));
                }
                function i() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) && (e1 = e1.substring(t.length)), "/" === e1[0] ? e1 : "/".concat(e1);
                }
                function a(e1) {
                    var t = [];
                    if (null !== e1) for(var n in e1)Object.prototype.hasOwnProperty.call(e1, n) && void 0 !== e1[n] && null !== e1[n] && t.push(n + "=" + encodeURIComponent(e1[n]));
                    return t.length ? "?" + t.join("&") : "";
                }
                function u(e1) {
                    if (e1) {
                        var t = e1.replace(/^\s+|\s+$/gm, "");
                        return t.replace(/\/+$/, "");
                    }
                }
                n.d(t, {
                    BY: function() {
                        return o;
                    },
                    QN: function() {
                        return i;
                    },
                    Qj: function() {
                        return u;
                    },
                    UK: function() {
                        return a;
                    },
                    sD: function() {
                        return r;
                    }
                });
            },
            3615: function(e1, t, n) {
                "use strict";
                var r = n(6690), o = n(9728), i = n(1655), a = n(4993), u = n(3808);
                function c(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var s = function(e1) {
                    i(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = u(t);
                        if (n) {
                            var o = u(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return a(this, e1);
                    });
                    function s(e1) {
                        var t;
                        return r(this, s), (t = c.call(this, e1 || "Promise was canceled")).name = "CancelError", t;
                    }
                    return o(s, [
                        {
                            key: "isCanceled",
                            get: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3496)(Error)), f = function() {
                    function e1(t) {
                        var n = this;
                        r(this, e1), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function(e1, r) {
                            n._reject = r;
                            var o = function(e1) {
                                if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
                                n._cancelHandlers.push(e1);
                            };
                            return Object.defineProperties(o, {
                                shouldReject: {
                                    get: function() {
                                        return n._rejectOnCancel;
                                    },
                                    set: function(e1) {
                                        n._rejectOnCancel = e1;
                                    }
                                }
                            }), t(function(t) {
                                n._isCanceled && o.shouldReject || (n._isPending = !1, e1(t));
                            }, function(e1) {
                                n._isPending = !1, r(e1);
                            }, o);
                        });
                    }
                    return o(e1, [
                        {
                            key: "then",
                            value: function(e1, t) {
                                return this._promise.then(e1, t);
                            }
                        },
                        {
                            key: "catch",
                            value: function(e1) {
                                return this._promise.catch(e1);
                            }
                        },
                        {
                            key: "finally",
                            value: function(e1) {
                                return this._promise.finally(e1);
                            }
                        },
                        {
                            key: "cancel",
                            value: function(e1) {
                                if (this._isPending && !this._isCanceled) {
                                    if (this._isCanceled = !0, this._cancelHandlers.length > 0) try {
                                        var t, n = function(e1, t) {
                                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                            if (!n) {
                                                if (Array.isArray(e1) || (n = function(e1, t) {
                                                    if (e1) {
                                                        if ("string" == typeof e1) return c(e1, t);
                                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(e1, t) : void 0;
                                                    }
                                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                                    n && (e1 = n);
                                                    var r = 0, o = function() {};
                                                    return {
                                                        s: o,
                                                        n: function() {
                                                            return r >= e1.length ? {
                                                                done: !0
                                                            } : {
                                                                done: !1,
                                                                value: e1[r++]
                                                            };
                                                        },
                                                        e: function(e1) {
                                                            throw e1;
                                                        },
                                                        f: o
                                                    };
                                                }
                                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }
                                            var i, a = !0, u = !1;
                                            return {
                                                s: function() {
                                                    n = n.call(e1);
                                                },
                                                n: function() {
                                                    var e1 = n.next();
                                                    return a = e1.done, e1;
                                                },
                                                e: function(e1) {
                                                    u = !0, i = e1;
                                                },
                                                f: function() {
                                                    try {
                                                        a || null == n.return || n.return();
                                                    } finally{
                                                        if (u) throw i;
                                                    }
                                                }
                                            };
                                        }(this._cancelHandlers);
                                        try {
                                            for(n.s(); !(t = n.n()).done;)(0, t.value)();
                                        } catch (e1) {
                                            n.e(e1);
                                        } finally{
                                            n.f();
                                        }
                                    } catch (e1) {
                                        return void this._reject(e1);
                                    }
                                    this._rejectOnCancel && this._reject(new s(e1));
                                }
                            }
                        },
                        {
                            key: "isCanceled",
                            get: function() {
                                return this._isCanceled;
                            }
                        }
                    ], [
                        {
                            key: "fn",
                            value: function(t) {
                                return function() {
                                    for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                                    return new e1(function(e1, n, o) {
                                        r.push(o), t.apply(void 0, r).then(e1, n);
                                    });
                                };
                            }
                        }
                    ]), e1;
                }();
                Object.setPrototypeOf(f.prototype, Promise.prototype), e1.exports = f, e1.exports.CancelError = s;
            },
            4098: function(e1, t) {
                var n = "undefined" != typeof self ? self : this, r = function() {
                    function e1() {
                        this.fetch = !1, this.DOMException = n.DOMException;
                    }
                    return e1.prototype = n, new e1;
                }();
                !function(e1) {
                    !function(t) {
                        var n = {
                            searchParams: "URLSearchParams" in e1,
                            iterable: "Symbol" in e1 && "iterator" in Symbol,
                            blob: "FileReader" in e1 && "Blob" in e1 && function() {
                                try {
                                    return new Blob, !0;
                                } catch (e1) {
                                    return !1;
                                }
                            }(),
                            formData: "FormData" in e1,
                            arrayBuffer: "ArrayBuffer" in e1
                        };
                        if (n.arrayBuffer) var r = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], o = ArrayBuffer.isView || function(e1) {
                            return e1 && r.indexOf(Object.prototype.toString.call(e1)) > -1;
                        };
                        function i(e1) {
                            if ("string" != typeof e1 && (e1 = String(e1)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e1)) throw new TypeError("Invalid character in header field name");
                            return e1.toLowerCase();
                        }
                        function a(e1) {
                            return "string" != typeof e1 && (e1 = String(e1)), e1;
                        }
                        function u(e1) {
                            var t = {
                                next: function() {
                                    var t = e1.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return n.iterable && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function c(e1) {
                            this.map = {}, e1 instanceof c ? e1.forEach(function(e1, t) {
                                this.append(t, e1);
                            }, this) : Array.isArray(e1) ? e1.forEach(function(e1) {
                                this.append(e1[0], e1[1]);
                            }, this) : e1 && Object.getOwnPropertyNames(e1).forEach(function(t) {
                                this.append(t, e1[t]);
                            }, this);
                        }
                        function s(e1) {
                            if (e1.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e1.bodyUsed = !0;
                        }
                        function f(e1) {
                            return new Promise(function(t, n) {
                                e1.onload = function() {
                                    t(e1.result);
                                }, e1.onerror = function() {
                                    n(e1.error);
                                };
                            });
                        }
                        function l(e1) {
                            var t = new FileReader, n = f(t);
                            return t.readAsArrayBuffer(e1), n;
                        }
                        function p(e1) {
                            if (e1.slice) return e1.slice(0);
                            var t = new Uint8Array(e1.byteLength);
                            return t.set(new Uint8Array(e1)), t.buffer;
                        }
                        function d() {
                            return this.bodyUsed = !1, this._initBody = function(e1) {
                                var t;
                                this._bodyInit = e1, e1 ? "string" == typeof e1 ? this._bodyText = e1 : n.blob && Blob.prototype.isPrototypeOf(e1) ? this._bodyBlob = e1 : n.formData && FormData.prototype.isPrototypeOf(e1) ? this._bodyFormData = e1 : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) ? this._bodyText = e1.toString() : n.arrayBuffer && n.blob && (t = e1) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = p(e1.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e1) || o(e1)) ? this._bodyArrayBuffer = p(e1) : this._bodyText = e1 = Object.prototype.toString.call(e1) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e1 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, n.blob && (this.blob = function() {
                                var e1 = s(this);
                                if (e1) return e1;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? s(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(l);
                            }), this.text = function() {
                                var e1, t, n, r = s(this);
                                if (r) return r;
                                if (this._bodyBlob) return e1 = this._bodyBlob, n = f(t = new FileReader), t.readAsText(e1), n;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e1) {
                                    for(var t = new Uint8Array(e1), n = new Array(t.length), r = 0; r < t.length; r++)n[r] = String.fromCharCode(t[r]);
                                    return n.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, n.formData && (this.formData = function() {
                                return this.text().then(y);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        c.prototype.append = function(e1, t) {
                            e1 = i(e1), t = a(t);
                            var n = this.map[e1];
                            this.map[e1] = n ? n + ", " + t : t;
                        }, c.prototype.delete = function(e1) {
                            delete this.map[i(e1)];
                        }, c.prototype.get = function(e1) {
                            return e1 = i(e1), this.has(e1) ? this.map[e1] : null;
                        }, c.prototype.has = function(e1) {
                            return this.map.hasOwnProperty(i(e1));
                        }, c.prototype.set = function(e1, t) {
                            this.map[i(e1)] = a(t);
                        }, c.prototype.forEach = function(e1, t) {
                            for(var n in this.map)this.map.hasOwnProperty(n) && e1.call(t, this.map[n], n, this);
                        }, c.prototype.keys = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push(n);
                            }), u(e1);
                        }, c.prototype.values = function() {
                            var e1 = [];
                            return this.forEach(function(t) {
                                e1.push(t);
                            }), u(e1);
                        }, c.prototype.entries = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push([
                                    n,
                                    t
                                ]);
                            }), u(e1);
                        }, n.iterable && (c.prototype[Symbol.iterator] = c.prototype.entries);
                        var h = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function v(e1, t) {
                            var n, r, o = (t = t || {}).body;
                            if (e1 instanceof v) {
                                if (e1.bodyUsed) throw new TypeError("Already read");
                                this.url = e1.url, this.credentials = e1.credentials, t.headers || (this.headers = new c(e1.headers)), this.method = e1.method, this.mode = e1.mode, this.signal = e1.signal, o || null == e1._bodyInit || (o = e1._bodyInit, e1.bodyUsed = !0);
                            } else this.url = String(e1);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new c(t.headers)), this.method = (r = (n = t.method || this.method || "GET").toUpperCase(), h.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                            this._initBody(o);
                        }
                        function y(e1) {
                            var t = new FormData;
                            return e1.trim().split("&").forEach(function(e1) {
                                if (e1) {
                                    var n = e1.split("="), r = n.shift().replace(/\+/g, " "), o = n.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(r), decodeURIComponent(o));
                                }
                            }), t;
                        }
                        function g(e1, t) {
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new c(t.headers), this.url = t.url || "", this._initBody(e1);
                        }
                        v.prototype.clone = function() {
                            return new v(this, {
                                body: this._bodyInit
                            });
                        }, d.call(v.prototype), d.call(g.prototype), g.prototype.clone = function() {
                            return new g(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new c(this.headers),
                                url: this.url
                            });
                        }, g.error = function() {
                            var e1 = new g(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e1.type = "error", e1;
                        };
                        var m = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        g.redirect = function(e1, t) {
                            if (-1 === m.indexOf(t)) throw new RangeError("Invalid status code");
                            return new g(null, {
                                status: t,
                                headers: {
                                    location: e1
                                }
                            });
                        }, t.DOMException = e1.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e1) {
                            t.DOMException = function(e1, t) {
                                this.message = e1, this.name = t;
                                var n = Error(e1);
                                this.stack = n.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function b(e1, r) {
                            return new Promise(function(o, i) {
                                var a = new v(e1, r);
                                if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
                                var u = new XMLHttpRequest;
                                function s() {
                                    u.abort();
                                }
                                u.onload = function() {
                                    var e1, t, n = {
                                        status: u.status,
                                        statusText: u.statusText,
                                        headers: (e1 = u.getAllResponseHeaders() || "", t = new c, e1.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e1) {
                                            var n = e1.split(":"), r = n.shift().trim();
                                            if (r) {
                                                var o = n.join(":").trim();
                                                t.append(r, o);
                                            }
                                        }), t)
                                    };
                                    n.url = "responseURL" in u ? u.responseURL : n.headers.get("X-Request-URL");
                                    var r = "response" in u ? u.response : u.responseText;
                                    o(new g(r, n));
                                }, u.onerror = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.ontimeout = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.onabort = function() {
                                    i(new t.DOMException("Aborted", "AbortError"));
                                }, u.open(a.method, a.url, !0), "include" === a.credentials ? u.withCredentials = !0 : "omit" === a.credentials && (u.withCredentials = !1), "responseType" in u && n.blob && (u.responseType = "blob"), a.headers.forEach(function(e1, t) {
                                    u.setRequestHeader(t, e1);
                                }), a.signal && (a.signal.addEventListener("abort", s), u.onreadystatechange = function() {
                                    4 === u.readyState && a.signal.removeEventListener("abort", s);
                                }), u.send(void 0 === a._bodyInit ? null : a._bodyInit);
                            });
                        }
                        b.polyfill = !0, e1.fetch || (e1.fetch = b, e1.Headers = c, e1.Request = v, e1.Response = g), t.Headers = c, t.Request = v, t.Response = g, t.fetch = b, Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    }({});
                }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
                var o = r;
                (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e1.exports = t;
            },
            4279: function(e1) {
                function t() {}
                t.prototype = {
                    on: function(e1, t, n) {
                        var r = this.e || (this.e = {});
                        return (r[e1] || (r[e1] = [])).push({
                            fn: t,
                            ctx: n
                        }), this;
                    },
                    once: function(e1, t, n) {
                        var r = this;
                        function o() {
                            r.off(e1, o), t.apply(n, arguments);
                        }
                        return o._ = t, this.on(e1, o, n);
                    },
                    emit: function(e1) {
                        for(var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e1] || []).slice(), r = 0, o = n.length; r < o; r++)n[r].fn.apply(n[r].ctx, t);
                        return this;
                    },
                    off: function(e1, t) {
                        var n = this.e || (this.e = {}), r = n[e1], o = [];
                        if (r && t) for(var i = 0, a = r.length; i < a; i++)r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
                        return o.length ? n[e1] = o : delete n[e1], this;
                    }
                }, e1.exports = t;
            },
            6115: function(e1) {
                e1.exports = function(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6690: function(e1) {
                e1.exports = function(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3515: function(e1, t, n) {
                var r = n(6015), o = n(9617);
                function i(t, n, a) {
                    return o() ? (e1.exports = i = Reflect.construct.bind(), e1.exports.__esModule = !0, e1.exports.default = e1.exports) : (e1.exports = i = function(e1, t, n) {
                        var o = [
                            null
                        ];
                        o.push.apply(o, t);
                        var i = new (Function.bind.apply(e1, o));
                        return n && r(i, n.prototype), i;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports), i.apply(null, arguments);
                }
                e1.exports = i, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9728: function(e1) {
                function t(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e1, r.key, r);
                    }
                }
                e1.exports = function(e1, n, r) {
                    return n && t(e1.prototype, n), r && t(e1, r), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3808: function(e1) {
                function t(n) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            1655: function(e1, t, n) {
                var r = n(6015);
                e1.exports = function(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && r(e1, t);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6035: function(e1) {
                e1.exports = function(e1) {
                    return -1 !== Function.toString.call(e1).indexOf("[native code]");
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9617: function(e1) {
                e1.exports = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e1) {
                        return !1;
                    }
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4993: function(e1, t, n) {
                var r = n(8698).default, o = n(6115);
                e1.exports = function(e1, t) {
                    if (t && ("object" === r(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return o(e1);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            7061: function(e1, t, n) {
                var r = n(8698).default;
                function o() {
                    "use strict";
                    e1.exports = o = function() {
                        return t;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
                    var t = {}, n = Object.prototype, i = n.hasOwnProperty, a = "function" == typeof Symbol ? Symbol : {}, u = a.iterator || "@@iterator", c = a.asyncIterator || "@@asyncIterator", s = a.toStringTag || "@@toStringTag";
                    function f(e1, t, n) {
                        return Object.defineProperty(e1, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        f({}, "");
                    } catch (e1) {
                        f = function(e1, t, n) {
                            return e1[t] = n;
                        };
                    }
                    function l(e1, t, n, r) {
                        var o = t && t.prototype instanceof h ? t : h, i = Object.create(o.prototype), a = new S(r || []);
                        return i._invoke = function(e1, t, n) {
                            var r = "suspendedStart";
                            return function(o, i) {
                                if ("executing" === r) throw new Error("Generator is already running");
                                if ("completed" === r) {
                                    if ("throw" === o) throw i;
                                    return {
                                        value: void 0,
                                        done: !0
                                    };
                                }
                                for(n.method = o, n.arg = i;;){
                                    var a = n.delegate;
                                    if (a) {
                                        var u = Z(a, n);
                                        if (u) {
                                            if (u === d) continue;
                                            return u;
                                        }
                                    }
                                    if ("next" === n.method) n.sent = n._sent = n.arg;
                                    else if ("throw" === n.method) {
                                        if ("suspendedStart" === r) throw r = "completed", n.arg;
                                        n.dispatchException(n.arg);
                                    } else "return" === n.method && n.abrupt("return", n.arg);
                                    r = "executing";
                                    var c = p(e1, t, n);
                                    if ("normal" === c.type) {
                                        if (r = n.done ? "completed" : "suspendedYield", c.arg === d) continue;
                                        return {
                                            value: c.arg,
                                            done: n.done
                                        };
                                    }
                                    "throw" === c.type && (r = "completed", n.method = "throw", n.arg = c.arg);
                                }
                            };
                        }(e1, n, a), i;
                    }
                    function p(e1, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, n)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    t.wrap = l;
                    var d = {};
                    function h() {}
                    function v() {}
                    function y() {}
                    var g = {};
                    f(g, u, function() {
                        return this;
                    });
                    var m = Object.getPrototypeOf, b = m && m(m(x([])));
                    b && b !== n && i.call(b, u) && (g = b);
                    var k = y.prototype = h.prototype = Object.create(g);
                    function w(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            f(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function O(e1, t) {
                        function n(o, a, u, c) {
                            var s = p(e1[o], e1, a);
                            if ("throw" !== s.type) {
                                var f = s.arg, l = f.value;
                                return l && "object" == r(l) && i.call(l, "__await") ? t.resolve(l.__await).then(function(e1) {
                                    n("next", e1, u, c);
                                }, function(e1) {
                                    n("throw", e1, u, c);
                                }) : t.resolve(l).then(function(e1) {
                                    f.value = e1, u(f);
                                }, function(e1) {
                                    return n("throw", e1, u, c);
                                });
                            }
                            c(s.arg);
                        }
                        var o;
                        this._invoke = function(e1, r) {
                            function i() {
                                return new t(function(t, o) {
                                    n(e1, r, t, o);
                                });
                            }
                            return o = o ? o.then(i, i) : i();
                        };
                    }
                    function Z(e1, t) {
                        var n = e1.iterator[t.method];
                        if (void 0 === n) {
                            if (t.delegate = null, "throw" === t.method) {
                                if (e1.iterator.return && (t.method = "return", t.arg = void 0, Z(e1, t), "throw" === t.method)) return d;
                                t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
                            }
                            return d;
                        }
                        var r = p(n, e1.iterator, t.arg);
                        if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, d;
                        var o = r.arg;
                        return o ? o.done ? (t[e1.resultName] = o.value, t.next = e1.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, d) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, d);
                    }
                    function T(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function E(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function S(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(T, this), this.reset(!0);
                    }
                    function x(e1) {
                        if (e1) {
                            var t = e1[u];
                            if (t) return t.call(e1);
                            if ("function" == typeof e1.next) return e1;
                            if (!isNaN(e1.length)) {
                                var n = -1, r = function t() {
                                    for(; ++n < e1.length;)if (i.call(e1, n)) return t.value = e1[n], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return r.next = r;
                            }
                        }
                        return {
                            next: P
                        };
                    }
                    function P() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return v.prototype = y, f(k, "constructor", y), f(y, "constructor", v), v.displayName = f(y, s, "GeneratorFunction"), t.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, y) : (e1.__proto__ = y, f(e1, s, "GeneratorFunction")), e1.prototype = Object.create(k), e1;
                    }, t.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, w(O.prototype), f(O.prototype, c, function() {
                        return this;
                    }), t.AsyncIterator = O, t.async = function(e1, n, r, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new O(l(e1, n, r, o), i);
                        return t.isGeneratorFunction(n) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, w(k), f(k, s, "Generator"), f(k, u, function() {
                        return this;
                    }), f(k, "toString", function() {
                        return "[object Generator]";
                    }), t.keys = function(e1) {
                        var t = [];
                        for(var n in e1)t.push(n);
                        return t.reverse(), function n() {
                            for(; t.length;){
                                var r = t.pop();
                                if (r in e1) return n.value = r, n.done = !1, n;
                            }
                            return n.done = !0, n;
                        };
                    }, t.values = x, S.prototype = {
                        constructor: S,
                        reset: function(e1) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(E), !e1) for(var t in this)"t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(e1) {
                            if (this.done) throw e1;
                            var t = this;
                            function n(n, r) {
                                return a.type = "throw", a.arg = e1, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
                            }
                            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                                var o = this.tryEntries[r], a = o.completion;
                                if ("root" === o.tryLoc) return n("end");
                                if (o.tryLoc <= this.prev) {
                                    var u = i.call(o, "catchLoc"), c = i.call(o, "finallyLoc");
                                    if (u && c) {
                                        if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                                        if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                                    } else if (u) {
                                        if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var r = this.tryEntries[n];
                                if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                                    var o = r;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var a = o ? o.completion : {};
                            return a.type = e1, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), d;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e1) return this.complete(n.completion, n.afterLoc), E(n), d;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e1) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var o = r.arg;
                                        E(n);
                                    }
                                    return o;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e1, t, n) {
                            return this.delegate = {
                                iterator: x(e1),
                                resultName: t,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = void 0), d;
                        }
                    }, t;
                }
                e1.exports = o, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6015: function(e1) {
                function t(n, r) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n, r);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            8698: function(e1) {
                function t(n) {
                    return e1.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3496: function(e1, t, n) {
                var r = n(3808), o = n(6015), i = n(6035), a = n(3515);
                function u(t) {
                    var n = "function" == typeof Map ? new Map : void 0;
                    return e1.exports = u = function(e1) {
                        if (null === e1 || !i(e1)) return e1;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== n) {
                            if (n.has(e1)) return n.get(e1);
                            n.set(e1, t);
                        }
                        function t() {
                            return a(e1, arguments, r(this).constructor);
                        }
                        return t.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: t,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), o(t, e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, u(t);
                }
                e1.exports = u, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4687: function(e1, t, n) {
                var r = n(7061)();
                e1.exports = r;
                try {
                    regeneratorRuntime = r;
                } catch (e1) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r);
                }
            },
            907: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            7326: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            5861: function(e1, t, n) {
                "use strict";
                function r(e1, t, n, r, o, i, a) {
                    try {
                        var u = e1[i](a), c = u.value;
                    } catch (e1) {
                        return void n(e1);
                    }
                    u.done ? t(c) : Promise.resolve(c).then(r, o);
                }
                function o(e1) {
                    return function() {
                        var t = this, n = arguments;
                        return new Promise(function(o, i) {
                            var a = e1.apply(t, n);
                            function u(e1) {
                                r(a, o, i, u, c, "next", e1);
                            }
                            function c(e1) {
                                r(a, o, i, u, c, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
            },
            5671: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            3144: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e1, r.key, r);
                    }
                }
                function o(e1, t, n) {
                    return t && r(e1.prototype, t), n && r(e1, n), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
            },
            4942: function(e1, t, n) {
                "use strict";
                function r(e1, t, n) {
                    return t in e1 ? Object.defineProperty(e1, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = n, e1;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            1752: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(1120);
                function o() {
                    return o = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e1, t, n) {
                        var o = function(e1, t) {
                            for(; !Object.prototype.hasOwnProperty.call(e1, t) && null !== (e1 = (0, r.Z)(e1)););
                            return e1;
                        }(e1, t);
                        if (o) {
                            var i = Object.getOwnPropertyDescriptor(o, t);
                            return i.get ? i.get.call(arguments.length < 3 ? e1 : n) : i.value;
                        }
                    }, o.apply(this, arguments);
                }
            },
            1120: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            136: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(9611);
                function o(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && (0, r.Z)(e1, t);
                }
            },
            4925: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (null == e1) return {};
                    var n, r, o = function(e1, t) {
                        if (null == e1) return {};
                        var n, r, o = {}, i = Object.keys(e1);
                        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (o[n] = e1[n]);
                        return o;
                    }(e1, t);
                    if (Object.getOwnPropertySymbols) {
                        var i = Object.getOwnPropertySymbols(e1);
                        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e1, n) && (o[n] = e1[n]);
                    }
                    return o;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            2963: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(1002), o = n(7326);
                function i(e1, t) {
                    if (t && ("object" === (0, r.Z)(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return (0, o.Z)(e1);
                }
            },
            9611: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, r(e1, t);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            885: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(181);
                function o(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var n = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != n) {
                            var r, o, i = [], a = !0, u = !1;
                            try {
                                for(n = n.call(e1); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
                            } catch (e1) {
                                u = !0, o = e1;
                            } finally{
                                try {
                                    a || null == n.return || n.return();
                                } finally{
                                    if (u) throw o;
                                }
                            }
                            return i;
                        }
                    }(e1, t) || (0, r.Z)(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            2982: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(907), o = n(181);
                function i(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return (0, r.Z)(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || (0, o.Z)(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            1002: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            181: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(907);
                function o(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return (0, r.Z)(e1, t);
                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? (0, r.Z)(e1, t) : void 0;
                    }
                }
            }
        }, t = {};
        function n(r) {
            var o = t[r];
            if (void 0 !== o) return o.exports;
            var i = t[r] = {
                exports: {}
            };
            return e1[r].call(i.exports, i, i.exports, n), i.exports;
        }
        n.n = function(e1) {
            var t = e1 && e1.__esModule ? function() {
                return e1.default;
            } : function() {
                return e1;
            };
            return n.d(t, {
                a: t
            }), t;
        }, n.d = function(e1, t) {
            for(var r in t)n.o(t, r) && !n.o(e1, r) && Object.defineProperty(e1, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e1) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(e1, t) {
            return Object.prototype.hasOwnProperty.call(e1, t);
        }, n.r = function(e1) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e1, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return function() {
            "use strict";
            n.r(r), n.d(r, {
                AuthenticatorKey: function() {
                    return y.pc;
                },
                EmailRole: function() {
                    return g.aw;
                },
                IdxFeature: function() {
                    return y.Fw;
                },
                IdxStatus: function() {
                    return y.Qd;
                },
                OktaAuth: function() {
                    return T;
                },
                PasswordStatus: function() {
                    return g.Fn;
                },
                Status: function() {
                    return g.qb;
                },
                addEmail: function() {
                    return g.no;
                },
                addPhone: function() {
                    return g.Z1;
                },
                authenticate: function() {
                    return y.YR;
                },
                canProceed: function() {
                    return y.Ch;
                },
                cancel: function() {
                    return y.al;
                },
                clearTransactionMeta: function() {
                    return y.Jm;
                },
                createAuthnTransactionAPI: function() {
                    return m.b;
                },
                createIdxAPI: function() {
                    return y.F4;
                },
                createIdxOptionsConstructor: function() {
                    return y.SL;
                },
                createIdxStorageManager: function() {
                    return y.aT;
                },
                createIdxTransactionManager: function() {
                    return y.vK;
                },
                createMinimalOktaAuthIdx: function() {
                    return y.UB;
                },
                createOktaAuthIdx: function() {
                    return y.Yn;
                },
                createOktaAuthMyAccount: function() {
                    return g.Xc;
                },
                createTransactionMeta: function() {
                    return y.Xc;
                },
                deleteEmail: function() {
                    return g.nd;
                },
                deletePassword: function() {
                    return g.QN;
                },
                deletePhone: function() {
                    return g.qj;
                },
                enrollPassword: function() {
                    return g.xg;
                },
                getEmail: function() {
                    return g.OD;
                },
                getEmailChallenge: function() {
                    return g.hG;
                },
                getEmails: function() {
                    return g.G5;
                },
                getPassword: function() {
                    return g.Ij;
                },
                getPhone: function() {
                    return g.u_;
                },
                getPhones: function() {
                    return g.Po;
                },
                getProfile: function() {
                    return g.Ai;
                },
                getProfileSchema: function() {
                    return g.aF;
                },
                getSavedTransactionMeta: function() {
                    return y.uN;
                },
                getTransactionMeta: function() {
                    return y.Co;
                },
                handleEmailVerifyCallback: function() {
                    return y.Jn;
                },
                handleInteractionCodeRedirect: function() {
                    return y.Xx;
                },
                hasSavedInteractionHandle: function() {
                    return y.$0;
                },
                interact: function() {
                    return y.EW;
                },
                introspect: function() {
                    return y.L8;
                },
                isAuthenticator: function() {
                    return y.H;
                },
                isEmailVerifyCallback: function() {
                    return y.GA;
                },
                isEmailVerifyCallbackError: function() {
                    return y.gc;
                },
                isTransactionMetaValid: function() {
                    return y.Wf;
                },
                isTransactionMetaValidForFlow: function() {
                    return y.bl;
                },
                isTransactionMetaValidForOptions: function() {
                    return y.UC;
                },
                mixinAuthn: function() {
                    return m.t;
                },
                mixinIdx: function() {
                    return y.B_;
                },
                mixinMyAccount: function() {
                    return g.HT;
                },
                parseEmailVerifyCallback: function() {
                    return y.mo;
                },
                poll: function() {
                    return y.$l;
                },
                proceed: function() {
                    return y.xc;
                },
                recoverPassword: function() {
                    return y.M4;
                },
                register: function() {
                    return y.z2;
                },
                saveTransactionMeta: function() {
                    return y.r0;
                },
                sendEmailChallenge: function() {
                    return g.ME;
                },
                sendPhoneChallenge: function() {
                    return g.dv;
                },
                startTransaction: function() {
                    return y.Yr;
                },
                unlockAccount: function() {
                    return y.le;
                },
                updatePassword: function() {
                    return g.gQ;
                },
                updateProfile: function() {
                    return g.ck;
                },
                verifyEmailChallenge: function() {
                    return g.T8;
                },
                verifyPhoneChallenge: function() {
                    return g.Lo;
                }
            });
            var e1 = n(3144), t = n(5671), o = n(136), i = n(2963), a = n(1120), u = n(4602), c = n(4143), s = n(3334), f = n(2144), l = n(6794), p = n(3164), d = n(6736), h = {};
            for(var v in d)[
                "default",
                "OktaAuth"
            ].indexOf(v) < 0 && (h[v] = (function(e1) {
                return d[e1];
            }).bind(0, v));
            n.d(r, h);
            var y = n(9999), g = n(1132), m = n(3398);
            var b = (0, u.S)(), k = (0, c.a)(), w = (0, s.v)(), O = (0, f.Y)(k, b, w), Z = (0, l.H)(O), T = function(n) {
                (0, o.Z)(s, n);
                var r, u, c = (r = s, u = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e1) {
                        return !1;
                    }
                }(), function() {
                    var e1, t = (0, a.Z)(r);
                    if (u) {
                        var n = (0, a.Z)(this).constructor;
                        e1 = Reflect.construct(t, arguments, n);
                    } else e1 = t.apply(this, arguments);
                    return (0, i.Z)(this, e1);
                });
                function s(e1) {
                    return (0, t.Z)(this, s), c.call(this, e1);
                }
                return (0, e1.Z)(s);
            }((0, p.t)(Z));
            r.default = T;
        }(), r;
    }();
});

},{"181d1c11c5931dcf":"h0XoY"}],"8v4T4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compareVersions);
parcelHelpers.export(exports, "validate", ()=>validate);
parcelHelpers.export(exports, "compare", ()=>compare);
parcelHelpers.export(exports, "satisfies", ()=>satisfies);
function compareVersions(v1, v2) {
    // validate input and split into segments
    const n1 = validateAndParse(v1);
    const n2 = validateAndParse(v2);
    // pop off the patch
    const p1 = n1.pop();
    const p2 = n2.pop();
    // validate numbers
    const r = compareSegments(n1, n2);
    if (r !== 0) return r;
    // validate pre-release
    if (p1 && p2) return compareSegments(p1.split("."), p2.split("."));
    else if (p1 || p2) return p1 ? -1 : 1;
    return 0;
}
const validate = (v)=>typeof v === "string" && /^[v\d]/.test(v) && semver.test(v);
const compare = (v1, v2, operator)=>{
    // validate input operator
    assertValidOperator(operator);
    // since result of compareVersions can only be -1 or 0 or 1
    // a simple map can be used to replace switch
    const res = compareVersions(v1, v2);
    return operatorResMap[operator].includes(res);
};
const satisfies = (v, r)=>{
    // if no range operator then "="
    const m = r.match(/^([<>=~^]+)/);
    const op = m ? m[1] : "=";
    // if gt/lt/eq then operator compare
    if (op !== "^" && op !== "~") return compare(v, r, op);
    // else range of either "~" or "^" is assumed
    const [v1, v2, v3] = validateAndParse(v);
    const [r1, r2, r3] = validateAndParse(r);
    if (compareStrings(v1, r1) !== 0) return false;
    if (op === "^") return compareSegments([
        v2,
        v3
    ], [
        r2,
        r3
    ]) >= 0;
    if (compareStrings(v2, r2) !== 0) return false;
    return compareStrings(v3, r3) >= 0;
};
// export CJS style for parity
compareVersions.validate = validate;
compareVersions.compare = compare;
compareVersions.sastisfies = satisfies;
const semver = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
const validateAndParse = (v)=>{
    if (typeof v !== "string") throw new TypeError("Invalid argument expected string");
    const match = v.match(semver);
    if (!match) throw new Error(`Invalid argument not valid semver ('${v}' received)`);
    match.shift();
    return match;
};
const isWildcard = (s)=>s === "*" || s === "x" || s === "X";
const tryParse = (v)=>{
    const n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
const forceType = (a, b)=>typeof a !== typeof b ? [
        String(a),
        String(b)
    ] : [
        a,
        b
    ];
const compareStrings = (a, b)=>{
    if (isWildcard(a) || isWildcard(b)) return 0;
    const [ap, bp] = forceType(tryParse(a), tryParse(b));
    if (ap > bp) return 1;
    if (ap < bp) return -1;
    return 0;
};
const compareSegments = (a, b)=>{
    for(let i = 0; i < Math.max(a.length, b.length); i++){
        const r = compareStrings(a[i] || 0, b[i] || 0);
        if (r !== 0) return r;
    }
    return 0;
};
const operatorResMap = {
    ">": [
        1
    ],
    ">=": [
        0,
        1
    ],
    "=": [
        0
    ],
    "<=": [
        -1,
        0
    ],
    "<": [
        -1
    ]
};
const allowedOperators = Object.keys(operatorResMap);
const assertValidOperator = (op)=>{
    if (typeof op !== "string") throw new TypeError(`Invalid operator type, expected string but got ${typeof op}`);
    if (allowedOperators.indexOf(op) === -1) throw new Error(`Invalid operator, expected one of ${allowedOperators.join("|")}`);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2O4gV":[function(require,module,exports) {
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"fTsZO":[function(require,module,exports) {
var objectWithoutPropertiesLoose = require("dccbe8884b5df173");
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"dccbe8884b5df173":"4eaZS"}],"4eaZS":[function(require,module,exports) {
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"1Yc5v":[function(require,module,exports) {
var global = arguments[3];
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    "use strict";
    const validatorToPredicate = (validatorFn, emptyCase)=>(value, ...rest)=>value === "" ? emptyCase : validatorFn(value, ...rest);
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
    }
    var dayjs_min = {
        exports: {}
    };
    dayjs_min.exports;
    (function(module, exports1) {
        !function(t, e) {
            module.exports = e();
        }(commonjsGlobal, function() {
            var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
                name: "en",
                weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                ordinal: function(t) {
                    var e = [
                        "th",
                        "st",
                        "nd",
                        "rd"
                    ], n = t % 100;
                    return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
                }
            }, m = function(t, e, n) {
                var r = String(t);
                return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
            }, v = {
                s: m,
                z: function(t) {
                    var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
                    return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
                },
                m: function t(e, n) {
                    if (e.date() < n.date()) return -t(n, e);
                    var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, f), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), f);
                    return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
                },
                a: function(t) {
                    return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
                },
                p: function(t) {
                    return ({
                        M: f,
                        y: c,
                        w: o,
                        d: a,
                        D: d,
                        h: u,
                        m: s,
                        s: i,
                        ms: r,
                        Q: h
                    })[t] || String(t || "").toLowerCase().replace(/s$/, "");
                },
                u: function(t) {
                    return void 0 === t;
                }
            }, g = "en", D = {};
            D[g] = M;
            var p = function(t) {
                return t instanceof _;
            }, S = function t(e, n, r) {
                var i;
                if (!e) return g;
                if ("string" == typeof e) {
                    var s = e.toLowerCase();
                    D[s] && (i = s), n && (D[s] = n, i = s);
                    var u = e.split("-");
                    if (!i && u.length > 1) return t(u[0]);
                } else {
                    var a = e.name;
                    D[a] = e, i = a;
                }
                return !r && i && (g = i), i || !r && g;
            }, w = function(t, e) {
                if (p(t)) return t.clone();
                var n = "object" == typeof e ? e : {};
                return n.date = t, n.args = arguments, new _(n);
            }, O = v;
            O.l = S, O.i = p, O.w = function(t, e) {
                return w(t, {
                    locale: e.$L,
                    utc: e.$u,
                    x: e.$x,
                    $offset: e.$offset
                });
            };
            var _ = function() {
                function M(t) {
                    this.$L = S(t.locale, null, !0), this.parse(t);
                }
                var m = M.prototype;
                return m.parse = function(t) {
                    this.$d = function(t) {
                        var e = t.date, n = t.utc;
                        if (null === e) return new Date(NaN);
                        if (O.u(e)) return new Date;
                        if (e instanceof Date) return new Date(e);
                        if ("string" == typeof e && !/Z$/i.test(e)) {
                            var r = e.match($);
                            if (r) {
                                var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                                return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                            }
                        }
                        return new Date(e);
                    }(t), this.$x = t.x || {}, this.init();
                }, m.init = function() {
                    var t = this.$d;
                    this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
                }, m.$utils = function() {
                    return O;
                }, m.isValid = function() {
                    return !(this.$d.toString() === l);
                }, m.isSame = function(t, e) {
                    var n = w(t);
                    return this.startOf(e) <= n && n <= this.endOf(e);
                }, m.isAfter = function(t, e) {
                    return w(t) < this.startOf(e);
                }, m.isBefore = function(t, e) {
                    return this.endOf(e) < w(t);
                }, m.$g = function(t, e, n) {
                    return O.u(t) ? this[e] : this.set(n, t);
                }, m.unix = function() {
                    return Math.floor(this.valueOf() / 1e3);
                }, m.valueOf = function() {
                    return this.$d.getTime();
                }, m.startOf = function(t, e) {
                    var n = this, r = !!O.u(e) || e, h = O.p(t), l = function(t, e) {
                        var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                        return r ? i : i.endOf(a);
                    }, $ = function(t, e) {
                        return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                            0,
                            0,
                            0,
                            0
                        ] : [
                            23,
                            59,
                            59,
                            999
                        ]).slice(e)), n);
                    }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
                    switch(h){
                        case c:
                            return r ? l(1, 0) : l(31, 11);
                        case f:
                            return r ? l(1, M) : l(0, M + 1);
                        case o:
                            var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                            return l(r ? m - D : m + (6 - D), M);
                        case a:
                        case d:
                            return $(v + "Hours", 0);
                        case u:
                            return $(v + "Minutes", 1);
                        case s:
                            return $(v + "Seconds", 2);
                        case i:
                            return $(v + "Milliseconds", 3);
                        default:
                            return this.clone();
                    }
                }, m.endOf = function(t) {
                    return this.startOf(t, !1);
                }, m.$set = function(t, e) {
                    var n, o = O.p(t), h = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
                    if (o === f || o === c) {
                        var y = this.clone().set(d, 1);
                        y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
                    } else l && this.$d[l]($);
                    return this.init(), this;
                }, m.set = function(t, e) {
                    return this.clone().$set(t, e);
                }, m.get = function(t) {
                    return this[O.p(t)]();
                }, m.add = function(r, h) {
                    var d, l = this;
                    r = Number(r);
                    var $ = O.p(h), y = function(t) {
                        var e = w(l);
                        return O.w(e.date(e.date() + Math.round(t * r)), l);
                    };
                    if ($ === f) return this.set(f, this.$M + r);
                    if ($ === c) return this.set(c, this.$y + r);
                    if ($ === a) return y(1);
                    if ($ === o) return y(7);
                    var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
                    return O.w(m, this);
                }, m.subtract = function(t, e) {
                    return this.add(-1 * t, e);
                }, m.format = function(t) {
                    var e = this, n = this.$locale();
                    if (!this.isValid()) return n.invalidDate || l;
                    var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, f = n.months, h = function(t, n, i, s) {
                        return t && (t[n] || t(e, r)) || i[n].slice(0, s);
                    }, c = function(t) {
                        return O.s(s % 12 || 12, t, "0");
                    }, d = n.meridiem || function(t, e, n) {
                        var r = t < 12 ? "AM" : "PM";
                        return n ? r.toLowerCase() : r;
                    }, $ = {
                        YY: String(this.$y).slice(-2),
                        YYYY: this.$y,
                        M: a + 1,
                        MM: O.s(a + 1, 2, "0"),
                        MMM: h(n.monthsShort, a, f, 3),
                        MMMM: h(f, a),
                        D: this.$D,
                        DD: O.s(this.$D, 2, "0"),
                        d: String(this.$W),
                        dd: h(n.weekdaysMin, this.$W, o, 2),
                        ddd: h(n.weekdaysShort, this.$W, o, 3),
                        dddd: o[this.$W],
                        H: String(s),
                        HH: O.s(s, 2, "0"),
                        h: c(1),
                        hh: c(2),
                        a: d(s, u, !0),
                        A: d(s, u, !1),
                        m: String(u),
                        mm: O.s(u, 2, "0"),
                        s: String(this.$s),
                        ss: O.s(this.$s, 2, "0"),
                        SSS: O.s(this.$ms, 3, "0"),
                        Z: i
                    };
                    return r.replace(y, function(t, e) {
                        return e || $[t] || i.replace(":", "");
                    });
                }, m.utcOffset = function() {
                    return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
                }, m.diff = function(r, d, l) {
                    var $, y = O.p(d), M = w(r), m = (M.utcOffset() - this.utcOffset()) * e, v = this - M, g = O.m(this, M);
                    return g = ($ = {}, $[c] = g / 12, $[f] = g, $[h] = g / 3, $[o] = (v - m) / 6048e5, $[a] = (v - m) / 864e5, $[u] = v / n, $[s] = v / e, $[i] = v / t, $)[y] || v, l ? g : O.a(g);
                }, m.daysInMonth = function() {
                    return this.endOf(f).$D;
                }, m.$locale = function() {
                    return D[this.$L];
                }, m.locale = function(t, e) {
                    if (!t) return this.$L;
                    var n = this.clone(), r = S(t, e, !0);
                    return r && (n.$L = r), n;
                }, m.clone = function() {
                    return O.w(this.$d, this);
                }, m.toDate = function() {
                    return new Date(this.valueOf());
                }, m.toJSON = function() {
                    return this.isValid() ? this.toISOString() : null;
                }, m.toISOString = function() {
                    return this.$d.toISOString();
                }, m.toString = function() {
                    return this.$d.toUTCString();
                }, M;
            }(), T = _.prototype;
            return w.prototype = T, [
                [
                    "$ms",
                    r
                ],
                [
                    "$s",
                    i
                ],
                [
                    "$m",
                    s
                ],
                [
                    "$H",
                    u
                ],
                [
                    "$W",
                    a
                ],
                [
                    "$M",
                    f
                ],
                [
                    "$y",
                    c
                ],
                [
                    "$D",
                    d
                ]
            ].forEach(function(t) {
                T[t[1]] = function(e) {
                    return this.$g(e, t[0], t[1]);
                };
            }), w.extend = function(t, e) {
                return t.$i || (t(e, _, w), t.$i = !0), w;
            }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
                return w(1e3 * t);
            }, w.en = D[g], w.Ls = D, w.p = {}, w;
        });
    })(dayjs_min, dayjs_min.exports);
    var dayjs_minExports = dayjs_min.exports;
    var dayjs = /*@__PURE__*/ getDefaultExportFromCjs(dayjs_minExports);
    var customParseFormat$1 = {
        exports: {}
    };
    customParseFormat$1.exports;
    (function(module, exports1) {
        !function(e, t) {
            module.exports = t();
        }(commonjsGlobal, function() {
            var e = {
                LTS: "h:mm:ss A",
                LT: "h:mm A",
                L: "MM/DD/YYYY",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY h:mm A",
                LLLL: "dddd, MMMM D, YYYY h:mm A"
            }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
                return (e = +e) + (e > 68 ? 1900 : 2e3);
            };
            var a = function(e) {
                return function(t) {
                    this[e] = +t;
                };
            }, f = [
                /[+-]\d\d:?(\d\d)?|Z/,
                function(e) {
                    (this.zone || (this.zone = {})).offset = function(e) {
                        if (!e) return 0;
                        if ("Z" === e) return 0;
                        var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                        return 0 === n ? 0 : "+" === t[0] ? -n : n;
                    }(e);
                }
            ], h = function(e) {
                var t = o[e];
                return t && (t.indexOf ? t : t.s.concat(t.f));
            }, u = function(e, t) {
                var n, r = o.meridiem;
                if (r) {
                    for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                        n = i > 12;
                        break;
                    }
                } else n = e === (t ? "pm" : "PM");
                return n;
            }, d = {
                A: [
                    i,
                    function(e) {
                        this.afternoon = u(e, !1);
                    }
                ],
                a: [
                    i,
                    function(e) {
                        this.afternoon = u(e, !0);
                    }
                ],
                S: [
                    /\d/,
                    function(e) {
                        this.milliseconds = 100 * +e;
                    }
                ],
                SS: [
                    n,
                    function(e) {
                        this.milliseconds = 10 * +e;
                    }
                ],
                SSS: [
                    /\d{3}/,
                    function(e) {
                        this.milliseconds = +e;
                    }
                ],
                s: [
                    r,
                    a("seconds")
                ],
                ss: [
                    r,
                    a("seconds")
                ],
                m: [
                    r,
                    a("minutes")
                ],
                mm: [
                    r,
                    a("minutes")
                ],
                H: [
                    r,
                    a("hours")
                ],
                h: [
                    r,
                    a("hours")
                ],
                HH: [
                    r,
                    a("hours")
                ],
                hh: [
                    r,
                    a("hours")
                ],
                D: [
                    r,
                    a("day")
                ],
                DD: [
                    n,
                    a("day")
                ],
                Do: [
                    i,
                    function(e) {
                        var t = o.ordinal, n = e.match(/\d+/);
                        if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
                    }
                ],
                M: [
                    r,
                    a("month")
                ],
                MM: [
                    n,
                    a("month")
                ],
                MMM: [
                    i,
                    function(e) {
                        var t = h("months"), n = (h("monthsShort") || t.map(function(e) {
                            return e.slice(0, 3);
                        })).indexOf(e) + 1;
                        if (n < 1) throw new Error;
                        this.month = n % 12 || n;
                    }
                ],
                MMMM: [
                    i,
                    function(e) {
                        var t = h("months").indexOf(e) + 1;
                        if (t < 1) throw new Error;
                        this.month = t % 12 || t;
                    }
                ],
                Y: [
                    /[+-]?\d+/,
                    a("year")
                ],
                YY: [
                    n,
                    function(e) {
                        this.year = s(e);
                    }
                ],
                YYYY: [
                    /\d{4}/,
                    a("year")
                ],
                Z: f,
                ZZ: f
            };
            function c(n) {
                var r, i;
                r = n, i = o && o.formats;
                for(var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var o = r && r.toUpperCase();
                    return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                        return t || n.slice(1);
                    });
                })).match(t), a = s.length, f = 0; f < a; f += 1){
                    var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
                    s[f] = l ? {
                        regex: c,
                        parser: l
                    } : h.replace(/^\[|\]$/g, "");
                }
                return function(e) {
                    for(var t = {}, n = 0, r = 0; n < a; n += 1){
                        var i = s[n];
                        if ("string" == typeof i) r += i.length;
                        else {
                            var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
                            f.call(t, u), e = e.replace(u, "");
                        }
                    }
                    return function(e) {
                        var t = e.afternoon;
                        if (void 0 !== t) {
                            var n = e.hours;
                            t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                        }
                    }(t), t;
                };
            }
            return function(e, t, n) {
                n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
                var r = t.prototype, i = r.parse;
                r.parse = function(e) {
                    var t = e.date, r = e.utc, s = e.args;
                    this.$u = r;
                    var a = s[1];
                    if ("string" == typeof a) {
                        var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
                        h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
                            try {
                                if ([
                                    "x",
                                    "X"
                                ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                                var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = new Date, m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
                                i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
                                var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
                                return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
                            } catch (e) {
                                return new Date("");
                            }
                        }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
                    } else if (a instanceof Array) for(var l = a.length, m = 1; m <= l; m += 1){
                        s[1] = a[m - 1];
                        var M = n.apply(this, s);
                        if (M.isValid()) {
                            this.$d = M.$d, this.$L = M.$L, this.init();
                            break;
                        }
                        m === l && (this.$d = new Date(""));
                    }
                    else i.call(this, e);
                };
            };
        });
    })(customParseFormat$1, customParseFormat$1.exports);
    var customParseFormatExports = customParseFormat$1.exports;
    var customParseFormat = /*@__PURE__*/ getDefaultExportFromCjs(customParseFormatExports);
    var isSameOrBefore$1 = {
        exports: {}
    };
    isSameOrBefore$1.exports;
    (function(module, exports1) {
        !function(e, i) {
            module.exports = i();
        }(commonjsGlobal, function() {
            return function(e, i) {
                i.prototype.isSameOrBefore = function(e, i) {
                    return this.isSame(e, i) || this.isBefore(e, i);
                };
            };
        });
    })(isSameOrBefore$1, isSameOrBefore$1.exports);
    var isSameOrBeforeExports = isSameOrBefore$1.exports;
    var isSameOrBefore = /*@__PURE__*/ getDefaultExportFromCjs(isSameOrBeforeExports);
    var isSameOrAfter$1 = {
        exports: {}
    };
    isSameOrAfter$1.exports;
    (function(module, exports1) {
        !function(e, t) {
            module.exports = t();
        }(commonjsGlobal, function() {
            return function(e, t) {
                t.prototype.isSameOrAfter = function(e, t) {
                    return this.isSame(e, t) || this.isAfter(e, t);
                };
            };
        });
    })(isSameOrAfter$1, isSameOrAfter$1.exports);
    var isSameOrAfterExports = isSameOrAfter$1.exports;
    var isSameOrAfter = /*@__PURE__*/ getDefaultExportFromCjs(isSameOrAfterExports);
    /* eslint-disable no-unused-vars */ const createValidator = (type, error)=>{
        let validator = (...args)=>({
                type,
                args,
                error
            });
        validator.error = error;
        return validator;
    };
    dayjs.extend(customParseFormat);
    dayjs.extend(isSameOrBefore);
    dayjs.extend(isSameOrAfter);
    let validatorFns = {};
    const INCLUDED_IN = "validator/INCLUDED_IN";
    const INCLUDED_IN_ERROR = "error/INCLUDED_IN";
    const includedIn = createValidator(INCLUDED_IN, INCLUDED_IN_ERROR);
    validatorFns[INCLUDED_IN] = (value, args, form)=>Array.isArray(args[0]) ? args[0].includes(value) : args[0] === value;
    const REQUIRED = "validator/REQUIRED";
    const REQUIRED_ERROR = "error/REQUIRED";
    const required = createValidator(REQUIRED, REQUIRED_ERROR);
    validatorFns[REQUIRED] = (value, args, form)=>value !== "";
    const ONLY_INTEGERS = "validator/ONLY_INTEGERS";
    const ONLY_INTEGERS_ERROR = "error/ONLY_INTEGERS";
    const onlyIntegers = createValidator(ONLY_INTEGERS, ONLY_INTEGERS_ERROR);
    validatorFns[ONLY_INTEGERS] = (value, args, form)=>/^(-?\d+)?$/.test(value);
    const ONLY_NATURALS = "validator/ONLY_NATURALS";
    const ONLY_NATURALS_ERROR = "error/ONLY_NATURALS";
    const onlyNaturals = createValidator(ONLY_NATURALS, ONLY_NATURALS_ERROR);
    validatorFns[ONLY_NATURALS] = (value, args, form)=>/^(\d+)?$/.test(value);
    /* 
  07/22: experimental expiration date constraint
  should allow entry of expiration date using "/" character
  to accommodate browser autofill

  not tested as validation function
  to validate exp date instead use combo of:
  required(), hasLength(), isValidMonth(), dateAfterToday()
  */ const ONLY_EXPIRATION_DATE = "validator/ONLY_EXPIRATION_DATE";
    const ONLY_EXPIRATION_DATE_ERROR = "error/ONLY_EXPIRATION_DATE";
    const onlyExpirationDate = createValidator(ONLY_EXPIRATION_DATE, ONLY_EXPIRATION_DATE_ERROR);
    validatorFns[ONLY_EXPIRATION_DATE] = (value, args, form)=>/^(\d?\d?\/?\d?\d?)?$/.test(value);
    /*
  11/24 - Users have been adding full CC numbers to the name field
  This validator will check if the value has more than 6 numeric characters
  We have to allow for some numeric characters to account for business
  names that include numbers like "3M Company" or "Smith Street Trust 40389"

  1/25 - This has been superseded by the includesPotentialCardNumber validator
  */ const NO_MORE_THAN_SIX_NUMBERS = "validator/NO_MORE_THAN_SIX_NUMBERS";
    const NO_MORE_THAN_SIX_NUMBERS_ERROR = "error/NO_MORE_THAN_SIX_NUMBERS";
    createValidator(NO_MORE_THAN_SIX_NUMBERS, NO_MORE_THAN_SIX_NUMBERS_ERROR);
    validatorFns[NO_MORE_THAN_SIX_NUMBERS] = (value)=>{
        if (value === "") return true;
        return !/(\d.*){7,}/.test(value);
    };
    /*
   * 1/25 - Prevent users from entering full credit card numbers in the "name" field.
   *
   * This validator is designed to reduce the accidental inclusion of credit card numbers
   * in fields where they don't belong (e.g., the name field). It identifies a potential
   * credit card number based on the following criteria:
   *
   * - It consists of 8 to 20 digits.
   * - Digits may be separated by optional spaces or hyphens.
   * - It must pass the Luhn algorithm check.
   *
   * Note:
   *   A string passing the Luhn algorithm is necessary but not sufficient to conclusively
   *   determine that the string is a valid credit card number.
   *
   * For more details on the Luhn algorithm, refer to:
   * https://stripe.com/en-ca/resources/more/how-to-use-the-luhn-algorithm-a-guide-in-applications-for-businesses#luhn-algorithm-formula
   */ function luhnValid(string) {
        if (!string) return false;
        // Extract all digit characters from the string.
        const digits = string.match(/\d/g);
        if (!digits) return false;
        let totalSum = 0;
        let shouldDouble = false;
        // Process digits from right to left
        for(let i = digits.length - 1; i >= 0; i--){
            // Convert the current character to a number.
            let digit = parseInt(digits[i], 10);
            // Double the digit and adjust if it exceeds 9.
            if (shouldDouble) {
                digit *= 2;
                if (digit > 9) // If the result of any doubling operation is greater than nine,
                // then add the digits of the result together to obtain a single-digit number.
                // This is equivalent to adding the digits together (e.g. 16: 1 + 6 = 7 = 16 - 9).
                digit -= 9;
            }
            // Add the processed digit to the total sum.
            totalSum += digit;
            // After doubling the value of the second-to-last digit, continue doing the same for every other digit.
            shouldDouble = !shouldDouble;
        }
        // The number is valid if totalSum is divisible by 10.
        return totalSum % 10 === 0;
    }
    const INCLUDES_POTENTIAL_CARD_NUMBER = "validator/INCLUDES_POTENTIAL_CARD_NUMBER";
    const INCLUDES_POTENTIAL_CARD_NUMBER_ERROR = "error/INCLUDES_POTENTIAL_CARD_NUMBER";
    const includesPotentialCardNumber = createValidator(INCLUDES_POTENTIAL_CARD_NUMBER, INCLUDES_POTENTIAL_CARD_NUMBER_ERROR);
    validatorFns[INCLUDES_POTENTIAL_CARD_NUMBER] = (value)=>{
        // This is the same regex currently used in Ghenghis
        // A potential credit card number is a sequence of 8 to 20 digits, with optional spaces or hyphens between them
        const regexString = "(?:\\d[ -]*){8,20}";
        const regex = new RegExp(regexString);
        return !(luhnValid(value) && regex.test(value));
    };
    const NUMBER_LESS_THAN = "validator/NUMBER_LESS_THAN";
    const NUMBER_LESS_THAN_ERROR = "error/NUMBER_LESS_THAN";
    const numberLessThan = createValidator(NUMBER_LESS_THAN, NUMBER_LESS_THAN_ERROR);
    validatorFns[NUMBER_LESS_THAN] = (value, args, form)=>{
        if (value === "") return true;
        return Number(value) < args[0];
    };
    const NUMBER_LESS_THAN_OR_EQUAL_TO = "validator/NUMBER_LESS_THAN_OR_EQUAL_TO";
    const NUMBER_LESS_THAN_OR_EQUAL_TO_ERROR = "error/NUMBER_LESS_THAN_OR_EQUAL_TO";
    const numberLessThanOrEqualTo = createValidator(NUMBER_LESS_THAN_OR_EQUAL_TO, NUMBER_LESS_THAN_OR_EQUAL_TO_ERROR);
    validatorFns[NUMBER_LESS_THAN_OR_EQUAL_TO] = (value, args, form)=>{
        if (value === "") return true;
        return Number(value) <= args[0];
    };
    const NUMBER_GREATER_THAN = "validator/NUMBER_GREATER_THAN";
    const NUMBER_GREATER_THAN_ERROR = "error/NUMBER_GREATER_THAN";
    const numberGreaterThan = createValidator(NUMBER_GREATER_THAN, NUMBER_GREATER_THAN_ERROR);
    validatorFns[NUMBER_GREATER_THAN] = (value, args, form)=>{
        if (value === "") return true;
        return Number(value) > args[0];
    };
    const NUMBER_GREATER_THAN_OR_EQUAL_TO = "validator/NUMBER_GREATER_THAN_OR_EQUAL_TO";
    const NUMBER_GREATER_THAN_OR_EQUAL_TO_ERROR = "error/NUMBER_GREATER_THAN_OR_EQUAL_TO";
    const numberGreaterThanOrEqualTo = createValidator(NUMBER_GREATER_THAN_OR_EQUAL_TO, NUMBER_GREATER_THAN_OR_EQUAL_TO_ERROR);
    validatorFns[NUMBER_GREATER_THAN_OR_EQUAL_TO] = (value, args, form)=>{
        if (value === "") return true;
        return Number(value) >= args[0];
    };
    const MATCHES_FIELD = "validator/MATCHES_FIELD";
    const MATCHES_FIELD_ERROR = "error/MATCHES_FIELD";
    const matchesField = createValidator(MATCHES_FIELD, MATCHES_FIELD_ERROR);
    validatorFns[MATCHES_FIELD] = (value, args, form)=>{
        const dependentField = form[args[0]];
        if (dependentField === undefined) throw new Error(`${args[0]} was passed to matchesField, but that field does not exist in the form`);
        const dependentFieldValue = dependentField.rawValue;
        return value === dependentFieldValue;
    };
    const validateWhenErrorMessage = (type)=>`${type} was passed to validateWhen, but that validator type does not exist.
  Please check that you are only calling validator creator functions exported from
  redux-freeform in your form config and that you didn't forget to
  invoke the validator creator (you cannot pass the functions themselves to
  createFormState). Also make sure you aren't passing validateWhen() to validateWhen
  as the primary validator.`;
    const VALIDATE_WHEN = "validator/VALIDATE_WHEN";
    const VALIDATE_WHEN_ERROR = "error/VALIDATE_WHEN";
    const validateWhen = (dependentValidator, primaryValidator, optionalFieldName)=>({
            type: VALIDATE_WHEN,
            args: [
                dependentValidator,
                primaryValidator,
                optionalFieldName
            ],
            error: dependentValidator.error
        });
    validateWhen.error = VALIDATE_WHEN_ERROR;
    validatorFns[VALIDATE_WHEN] = (value, args, form)=>{
        const [dependentValidator, primaryValidator, optionalFieldName] = args;
        const dependsOnOtherField = typeof optionalFieldName === "string";
        if (primaryValidator.type === undefined || typeof validatorFns[primaryValidator.type] !== "function") throw new Error(validateWhenErrorMessage(primaryValidator.type));
        if (dependsOnOtherField && form[optionalFieldName] === undefined) throw new Error(`${args[2]} was passed to matchesField, but that field does not exist in the form`);
        const primaryPredicate = validatorToPredicate(validatorFns[primaryValidator.type], false);
        const primaryValue = dependsOnOtherField ? form[optionalFieldName].rawValue : value;
        const primaryPredicatePassed = primaryPredicate(primaryValue, primaryValidator.args, form);
        return primaryPredicatePassed ? validatorFns[dependentValidator.type](value, dependentValidator.args, form) : true;
    };
    const validateSumErrorMessage = (type)=>`${type} was passed to validateSum, but that validator type does not exist.
  Please check that you are only calling validator creator functions exported from
  redux-freeform in your form config and that you didn't forget to
  invoke the validator creator (you cannot pass the functions themselves to
  createFormState).`;
    const VALIDATE_SUM = "validator/VALIDATE_SUM";
    const VALIDATE_SUM_ERROR = "error/VALIDATE_SUM";
    const validateSum = (validator, fieldNamesArray)=>({
            type: VALIDATE_SUM,
            args: [
                validator,
                fieldNamesArray
            ],
            error: validator.error
        });
    validateSum.error = VALIDATE_SUM_ERROR;
    validatorFns[VALIDATE_SUM] = (value, args, form)=>{
        const [validator, fieldNamesArray] = args;
        if (validator.type === undefined || typeof validatorFns[validator.type] !== "function") throw new Error(validateSumErrorMessage(validator.type));
        for (const fieldName of fieldNamesArray){
            if (form[fieldName] === undefined) throw new Error(`${fieldName} was passed to matchesField, but that field does not exist in the form`);
        }
        const sum = fieldNamesArray.reduce((acc, curr)=>acc + Number(form[curr].rawValue), Number(value));
        return validatorFns[validator.type](sum, validator.args, form);
    };
    const HAS_LENGTH = "validator/HAS_LENGTH";
    const HAS_LENGTH_ERROR = "error/HAS_LENGTH";
    const hasLength = createValidator(HAS_LENGTH, HAS_LENGTH_ERROR);
    validatorFns[HAS_LENGTH] = (value, args, form)=>{
        if (value === "") return true;
        const min = args[0];
        const max = args[1];
        if (max == undefined || min == undefined) throw new Error("Max and min need to be defined for hasLength, both or one of them is undefined");
        if (max < min) throw new Error("hasLength validator was passed a min greater than the max");
        const valueLength = value.length;
        return max >= valueLength && valueLength >= min;
    };
    const DATE_BEFORE_TODAY = "validator/DATE_BEFORE_TODAY";
    const DATE_BEFORE_TODAY_ERROR = "error/DATE_BEFORE_TODAY";
    const dateBeforeToday = createValidator(DATE_BEFORE_TODAY, DATE_BEFORE_TODAY_ERROR);
    validatorFns[DATE_BEFORE_TODAY] = (value, args, form)=>{
        if (value === "") return true;
        const dateFormat = args[0];
        const unit = args[1];
        const inclusive = args[2] || false;
        if (dateFormat == undefined || unit == undefined) throw new Error("Date format and unit need to be defined for dateBeforeToday, one or both are undefined");
        const now = dayjs();
        const dateValue = dayjs(value, dateFormat);
        if (inclusive === true) return dateValue.isSameOrBefore(now, unit);
        return dateValue.isBefore(now, unit);
    };
    const DATE_AFTER_TODAY = "validator/DATE_AFTER_TODAY";
    const DATE_AFTER_TODAY_ERROR = "error/DATE_AFTER_TODAY";
    const dateAfterToday = createValidator(DATE_AFTER_TODAY, DATE_AFTER_TODAY_ERROR);
    validatorFns[DATE_AFTER_TODAY] = (value, args, form)=>{
        if (value === "") return true;
        const dateFormat = args[0];
        const unit = args[1];
        const inclusive = args[2] || false;
        if (dateFormat == undefined || unit == undefined) throw new Error("Date format and unit need to be defined for dateAfterToday, one or both are undefined");
        const now = dayjs();
        const dateValue = dayjs(value, dateFormat);
        if (inclusive === true) return dateValue.isSameOrAfter(now, unit);
        return dateValue.isAfter(now, unit);
    };
    const IS_VALID_MONTH = "validator/IS_VALID_MONTH";
    const IS_VALID_MONTH_ERROR = "error/IS_VALID_MONTH";
    const isValidMonth = createValidator(IS_VALID_MONTH, IS_VALID_MONTH_ERROR);
    validatorFns[IS_VALID_MONTH] = (value, args, form)=>{
        if (value === "") return true;
        // Function takes one argument representing the character position
        // In a date string to identify where the month is
        // Eg "10/21/2021" - start position is 0
        // Or "18/03/1990" - start position is 3
        // Only works with two digit months (01, 02, 03, etc)
        const monthStartPosition = parseInt(args[0]);
        const monthEndPosition = monthStartPosition + 2;
        if (isNaN(monthStartPosition)) throw new Error("Month start position has to be a valid integer string");
        const month = parseInt(value.slice(monthStartPosition, monthEndPosition));
        if (isNaN(month)) return false;
        return month >= 1 && month <= 12;
    };
    const MATCHES_REGEX = "validator/MATCHES_REGEX";
    const MATCHES_REGEX_ERROR = "error/MATCHES_REGEX";
    const matchesRegex = createValidator(MATCHES_REGEX, MATCHES_REGEX_ERROR);
    validatorFns[MATCHES_REGEX] = (value, args, form)=>{
        if (value === "") return true;
        return new RegExp(args[0]).test(value); // new RexExp never throws an error, no matter the input
    };
    const IS_AMERICAN_OR_CANADIAN_ROUTING_NUMBER = "validator/IS_AMERICAN_OR_CANADIAN_ROUTING_NUMBER";
    const IS_AMERICAN_OR_CANADIAN_ROUTING_NUMBER_ERROR = "validator/IS_AMERICAN_OR_CANADIAN_ROUTING_NUMBER_ERROR";
    const isAmericanOrCanadianRoutingNumber = createValidator(IS_AMERICAN_OR_CANADIAN_ROUTING_NUMBER, IS_AMERICAN_OR_CANADIAN_ROUTING_NUMBER_ERROR);
    validatorFns[IS_AMERICAN_OR_CANADIAN_ROUTING_NUMBER] = (value, args, form)=>{
        if (value === "") return true;
        else if (value.length === 8) {
            const regExp = /^\d{8}$/;
            return regExp.test(value);
        } else if (value.length === 9) {
            const regExp = /^\d{9}$/;
            return validatorFns[IS_ROUTING_NUMBER](value, args, form) && regExp.test(value);
        } else return false;
    };
    // based on http://www.brainjar.com/js/validation/
    const IS_ROUTING_NUMBER = "validator/IS_ROUTING_NUMBER";
    const IS_ROUTING_NUMBER_ERROR = "error/IS_ROUTING_NUMBER";
    const isRoutingNumber = createValidator(IS_ROUTING_NUMBER, IS_ROUTING_NUMBER_ERROR);
    validatorFns[IS_ROUTING_NUMBER] = (value, args, form)=>{
        if (value === "") return true;
        if (value.length != 9) return false;
        const sum = value.split("").map((ch)=>parseInt(ch)).reduce((acc, cur, idx)=>{
            switch(idx % 3){
                case 0:
                    return acc + 3 * cur;
                case 1:
                    return acc + 7 * cur;
                case 2:
                    return acc + 1 * cur;
            }
        }, 0);
        return sum != 0 && sum % 10 == 0;
    };
    const HAS_NUMBER = "validator/HAS_NUMBER";
    const HAS_NUMBER_ERROR = "error/HAS_NUMBER";
    const hasNumber = createValidator(HAS_NUMBER, HAS_NUMBER_ERROR);
    validatorFns[HAS_NUMBER] = (value, args, form)=>{
        if (value === "") return true;
        return new RegExp(/[0-9]/).test(value);
    };
    const HAS_LOWERCASE_LETTER = "validator/HAS_LOWERCASE_LETTER";
    const HAS_LOWERCASE_LETTER_ERROR = "error/HAS_LOWERCASE_LETTER";
    const hasLowercaseLetter = createValidator(HAS_LOWERCASE_LETTER, HAS_LOWERCASE_LETTER_ERROR);
    validatorFns[HAS_LOWERCASE_LETTER] = (value, args, form)=>{
        if (value === "") return true;
        return new RegExp(/[a-z]/).test(value);
    };
    const HAS_UPPERCASE_LETTER = "validator/HAS_UPPERCASE_LETTER";
    const HAS_UPPERCASE_LETTER_ERROR = "error/HAS_UPPERCASE_LETTER";
    const hasUppercaseLetter = createValidator(HAS_UPPERCASE_LETTER, HAS_UPPERCASE_LETTER_ERROR);
    validatorFns[HAS_UPPERCASE_LETTER] = (value, args, form)=>{
        if (value === "") return true;
        return new RegExp(/[A-Z]/).test(value);
    };
    const HAS_SPECIAL_CHARACTER = "validator/HAS_SPECIAL_CHARACTER";
    const HAS_SPECIAL_CHARACTER_ERROR = "error/HAS_SPECIAL_CHARACTER";
    const hasSpecialCharacter = createValidator(HAS_SPECIAL_CHARACTER, HAS_SPECIAL_CHARACTER_ERROR);
    validatorFns[HAS_SPECIAL_CHARACTER] = (value, args, form)=>{
        if (value === "") return true;
        return new RegExp(/[!@#$%^&*.?]/).test(value);
    };
    const IS_PROBABLY_EMAIL = "validator/IS_PROBABLY_EMAIL";
    const IS_PROBABLY_EMAIL_ERROR = "error/IS_PROBABLY_EMAIL";
    const isProbablyEmail = createValidator(IS_PROBABLY_EMAIL, IS_PROBABLY_EMAIL_ERROR);
    validatorFns[IS_PROBABLY_EMAIL] = (value, args, form)=>{
        if (value === "") return true;
        return new RegExp(/^\S+@\S+\.\S+$/).test(value);
    };
    const VALID_NAME = "validator/VALID_NAME";
    const VALID_NAME_ERROR = "validator/VALID_NAME_ERROR";
    const validName = createValidator(VALID_NAME, VALID_NAME_ERROR);
    validatorFns[VALID_NAME] = (value, args, form)=>value === "" ? false : new RegExp(/[A-zÀ-ÿ\-,'\S]+(\s?[A-zÀ-ÿ\-,'\S])*/).test(value);
    const runValidatorErrorMessage = (type)=>`${type} was passed to runValidator, but that validator type does not exist. 
  Please check that you are only calling validator creator functions exported from 
  redux-freeform in your form config and that you didn't forget to 
  invoke the validator creator (you cannot pass the functions themselves to 
  createFormState)`;
    const runValidator = (validator, value, form)=>{
        const validatorFn = validatorFns[validator.type];
        if (validatorFn === undefined) throw new Error(runValidatorErrorMessage(validator.type));
        return validatorFn(value, validator.args, form) ? null : validator.error;
    };
    const runFormValidators = (fieldName, form, validators)=>{
        return validators.map((v)=>runValidator(v, form[fieldName].rawValue, form)).filter((x)=>x !== null);
    };
    const computeConstraints = (fieldName, form)=>{
        const constraints = form[fieldName].constraints;
        return runFormValidators(fieldName, form, constraints);
    };
    const computeErrors = (fieldName, form)=>{
        const validators = form[fieldName].validators;
        return runFormValidators(fieldName, form, validators);
    };
    const computeErrorEntries = (formState)=>{
        const fields = Object.entries(formState);
        for (let entry of fields){
            let fieldName = entry[0];
            let errors = computeErrors(fieldName, formState);
            formState[fieldName].errors = errors;
            formState[fieldName].hasErrors = errors.length > 0;
        }
    };
    const computeDirtyEntries = (formState, changedFieldName)=>{
        const fields = Object.entries(formState);
        for (let entry of fields){
            let fieldName = entry[0];
            let field = entry[1];
            let dirty = fieldName === changedFieldName ? true : field.dirty;
            formState[fieldName].dirty = dirty;
        }
    };
    function n(n) {
        for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
        var i, o;
        throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
            return "'" + n + "'";
        }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
    }
    function r(n) {
        return !!n && !!n[Q];
    }
    function t(n) {
        var r;
        return !!n && (function(n) {
            if (!n || "object" != typeof n) return !1;
            var r = Object.getPrototypeOf(n);
            if (null === r) return !0;
            var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
            return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
        }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
    }
    function i(n, r, t) {
        void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
            t && "symbol" == typeof e || r(e, n[e], n);
        }) : n.forEach(function(t, e) {
            return r(e, t, n);
        });
    }
    function o(n) {
        var r = n[Q];
        return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
    }
    function u(n, r) {
        return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
    }
    function a(n, r) {
        return 2 === o(n) ? n.get(r) : n[r];
    }
    function f(n, r, t) {
        var e = o(n);
        2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
    }
    function c(n, r) {
        return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
    }
    function s(n) {
        return X && n instanceof Map;
    }
    function v(n) {
        return q && n instanceof Set;
    }
    function p(n) {
        return n.o || n.t;
    }
    function l(n) {
        if (Array.isArray(n)) return Array.prototype.slice.call(n);
        var r = rn(n);
        delete r[Q];
        for(var t = nn(r), e = 0; e < t.length; e++){
            var i = t[e], o = r[i];
            !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
                configurable: !0,
                writable: !0,
                enumerable: o.enumerable,
                value: n[i]
            });
        }
        return Object.create(Object.getPrototypeOf(n), r);
    }
    function d(n, e) {
        return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
            return d(r, !0);
        }, !0)), n;
    }
    function h() {
        n(2);
    }
    function y(n) {
        return null == n || "object" != typeof n || Object.isFrozen(n);
    }
    function b(r) {
        var t = tn[r];
        return t || n(18, r), t;
    }
    function _() {
        return U;
    }
    function j(n, r) {
        r && (b("Patches"), n.u = [], n.s = [], n.v = r);
    }
    function g(n) {
        O(n), n.p.forEach(S), n.p = null;
    }
    function O(n) {
        n === U && (U = n.l);
    }
    function w(n) {
        return U = {
            p: [],
            l: U,
            h: n,
            m: !0,
            _: 0
        };
    }
    function S(n) {
        var r = n[Q];
        0 === r.i || 1 === r.i ? r.j() : r.g = !0;
    }
    function P(r, e) {
        e._ = e.p.length;
        var i = e.p[0], o = void 0 !== r && r !== i;
        return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
    }
    function M(n, r, t) {
        if (y(r)) return r;
        var e = r[Q];
        if (!e) return i(r, function(i, o) {
            return A(n, e, r, i, o, t);
        }, !0), r;
        if (e.A !== n) return r;
        if (!e.P) return x(n, e.t, !0), e.t;
        if (!e.I) {
            e.I = !0, e.A._--;
            var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
            3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
                return A(n, e, o, r, i, t, a);
            }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
        }
        return e.o;
    }
    function A(e, i, o, a, c, s, v) {
        if (r(c)) {
            var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
            if (f(o, a, p), !r(p)) return;
            e.m = !1;
        } else v && o.add(c);
        if (t(c) && !y(c)) {
            if (!e.h.D && e._ < 1) return;
            M(e, c), i && i.A.l || x(e, c);
        }
    }
    function x(n, r, t) {
        void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
    }
    function z(n, r) {
        var t = n[Q];
        return (t ? p(t) : n)[r];
    }
    function I(n, r) {
        if (r in n) for(var t = Object.getPrototypeOf(n); t;){
            var e = Object.getOwnPropertyDescriptor(t, r);
            if (e) return e;
            t = Object.getPrototypeOf(t);
        }
    }
    function k(n) {
        n.P || (n.P = !0, n.l && k(n.l));
    }
    function E(n) {
        n.o || (n.o = l(n.t));
    }
    function N(n, r, t) {
        var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
            var t = Array.isArray(n), e = {
                i: t ? 1 : 0,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: null,
                o: null,
                j: null,
                C: !1
            }, i = e, o = en;
            t && (i = [
                e
            ], o = on);
            var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
            return e.k = f, e.j = a, f;
        }(r, t) : b("ES5").J(r, t);
        return (t ? t.A : _()).p.push(e), e;
    }
    function R(e) {
        return r(e) || n(22, e), function n(r) {
            if (!t(r)) return r;
            var e, u = r[Q], c = o(r);
            if (u) {
                if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
                u.I = !0, e = D(r, c), u.I = !1;
            } else e = D(r, c);
            return i(e, function(r, t) {
                u && a(u.t, r) === t || f(e, r, n(t));
            }), 3 === c ? new Set(e) : e;
        }(e);
    }
    function D(n, r) {
        switch(r){
            case 2:
                return new Map(n);
            case 3:
                return Array.from(n);
        }
        return l(n);
    }
    var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", Y = {
        0: "Illegal state",
        1: "Immer drafts cannot have computed properties",
        2: "This object has been frozen and should not be mutated",
        3: function(n) {
            return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
        },
        4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
        5: "Immer forbids circular references",
        6: "The first or second argument to `produce` must be a function",
        7: "The third argument to `produce` must be a function or undefined",
        8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
        9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
        10: "The given draft is already finalized",
        11: "Object.defineProperty() cannot be used on an Immer draft",
        12: "Object.setPrototypeOf() cannot be used on an Immer draft",
        13: "Immer only supports deleting array indices",
        14: "Immer only supports setting array indices and the 'length' property",
        15: function(n) {
            return "Cannot apply patch, path doesn't resolve: " + n;
        },
        16: 'Sets cannot have "replace" patches.',
        17: function(n) {
            return "Unsupported patch operation: " + n;
        },
        18: function(n) {
            return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
        },
        20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
        21: function(n) {
            return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
        },
        22: function(n) {
            return "'current' expects a draft, got: " + n;
        },
        23: function(n) {
            return "'original' expects a draft, got: " + n;
        },
        24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
    }, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
        return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
    } : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
        var r = {};
        return nn(n).forEach(function(t) {
            r[t] = Object.getOwnPropertyDescriptor(n, t);
        }), r;
    }, tn = {}, en = {
        get: function(n, r) {
            if (r === Q) return n;
            var e = p(n);
            if (!u(e, r)) return function(n, r, t) {
                var e, i = I(r, t);
                return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
            }(n, e, r);
            var i = e[r];
            return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
        },
        has: function(n, r) {
            return r in p(n);
        },
        ownKeys: function(n) {
            return Reflect.ownKeys(p(n));
        },
        set: function(n, r, t) {
            var e = I(p(n), r);
            if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
            if (!n.P) {
                var i = z(p(n), r), o = null == i ? void 0 : i[Q];
                if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
                if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
                E(n), k(n);
            }
            return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
        },
        deleteProperty: function(n, r) {
            return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
        },
        getOwnPropertyDescriptor: function(n, r) {
            var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
            return e ? {
                writable: !0,
                configurable: 1 !== n.i || "length" !== r,
                enumerable: e.enumerable,
                value: t[r]
            } : e;
        },
        defineProperty: function() {
            n(11);
        },
        getPrototypeOf: function(n) {
            return Object.getPrototypeOf(n.t);
        },
        setPrototypeOf: function() {
            n(12);
        }
    }, on = {};
    i(en, function(n, r) {
        on[n] = function() {
            return arguments[0] = arguments[0][0], r.apply(this, arguments);
        };
    }), on.deleteProperty = function(r, t) {
        return on.set.call(this, r, t, void 0);
    }, on.set = function(r, t, e) {
        return en.set.call(this, r[0], t, e, r[0]);
    };
    var un = function() {
        function e(r) {
            var e = this;
            this.O = B, this.D = !0, this.produce = function(r, i, o) {
                if ("function" == typeof r && "function" != typeof i) {
                    var u = i;
                    i = r;
                    var a = e;
                    return function(n) {
                        var r = this;
                        void 0 === n && (n = u);
                        for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                        return a.produce(n, function(n) {
                            var t;
                            return (t = i).call.apply(t, [
                                r,
                                n
                            ].concat(e));
                        });
                    };
                }
                var f;
                if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                    var c = w(e), s = N(e, r, void 0), v = !0;
                    try {
                        f = i(s), v = !1;
                    } finally{
                        v ? g(c) : O(c);
                    }
                    return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                        return j(c, o), P(n, c);
                    }, function(n) {
                        throw g(c), n;
                    }) : (j(c, o), P(f, c));
                }
                if (!r || "object" != typeof r) {
                    if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                        var p = [], l = [];
                        b("Patches").M(r, f, p, l), o(p, l);
                    }
                    return f;
                }
                n(21, r);
            }, this.produceWithPatches = function(n, r) {
                if ("function" == typeof n) return function(r) {
                    for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                    return e.produceWithPatches(r, function(r) {
                        return n.apply(void 0, [
                            r
                        ].concat(i));
                    });
                };
                var t, i, o = e.produce(n, r, function(n, r) {
                    t = n, i = r;
                });
                return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                    return [
                        n,
                        t,
                        i
                    ];
                }) : [
                    o,
                    t,
                    i
                ];
            }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
        }
        var i = e.prototype;
        return i.createDraft = function(e) {
            t(e) || n(8), r(e) && (e = R(e));
            var i = w(this), o = N(this, e, void 0);
            return o[Q].C = !0, O(i), o;
        }, i.finishDraft = function(r, t) {
            var e = r && r[Q];
            var i = e.A;
            return j(i, t), P(void 0, i);
        }, i.setAutoFreeze = function(n) {
            this.D = n;
        }, i.setUseProxies = function(r) {
            r && !B && n(20), this.O = r;
        }, i.applyPatches = function(n, t) {
            var e;
            for(e = t.length - 1; e >= 0; e--){
                var i = t[e];
                if (0 === i.path.length && "replace" === i.op) {
                    n = i.value;
                    break;
                }
            }
            e > -1 && (t = t.slice(e + 1));
            var o = b("Patches").$;
            return r(n) ? o(n, t) : this.produce(n, function(n) {
                return o(n, t);
            });
        }, e;
    }(), an = new un, fn = an.produce;
    an.produceWithPatches.bind(an);
    an.setAutoFreeze.bind(an);
    an.setUseProxies.bind(an);
    an.applyPatches.bind(an);
    an.createDraft.bind(an);
    an.finishDraft.bind(an);
    var produce = fn;
    const createInitialState = (formConfig)=>{
        let initialForm = {};
        const formConfigKeys = Object.keys(formConfig);
        for (let formKey of formConfigKeys)initialForm[formKey] = {
            dirty: false,
            rawValue: formConfig[formKey].defaultValue || "",
            validators: formConfig[formKey].validators || [],
            constraints: formConfig[formKey].constraints || []
        };
        // Because validators require the entire form we have to do a
        // second pass to add errors once the initial form has been
        // constructed
        for (let formKey of formConfigKeys){
            let errors = computeErrors(formKey, initialForm);
            initialForm[formKey].errors = errors;
            initialForm[formKey].hasErrors = errors.length > 0;
        }
        return initialForm;
    };
    const SET = "field/SET";
    const set = (fieldName)=>(value)=>({
                type: SET,
                payload: {
                    fieldName,
                    value
                }
            });
    const CLEAR = "form/CLEAR";
    const clear = ()=>({
            type: CLEAR
        });
    const ADD_VALIDATOR = "field/ADD_VALIDATOR";
    const addValidator = (fieldName)=>(validator)=>({
                type: ADD_VALIDATOR,
                payload: {
                    fieldName,
                    validator
                }
            });
    const REMOVE_VALIDATOR = "field/REMOVE_VALIDATOR";
    const removeValidator = (fieldName)=>(validator)=>({
                type: REMOVE_VALIDATOR,
                payload: {
                    fieldName,
                    validator
                }
            });
    const CLEAR_FIELD_VALIDATORS = "field/CLEAR_FIELD_VALIDATORS";
    const clearFieldValidators = (fieldName)=>()=>({
                type: CLEAR_FIELD_VALIDATORS,
                payload: {
                    fieldName
                }
            });
    const createFormReducer = (formConfig)=>(state = createInitialState(formConfig), action)=>{
            switch(action.type){
                case SET:
                    {
                        const changedFieldName = action.payload.fieldName;
                        const newRawValue = action.payload.value;
                        return produce(state, (draftState)=>{
                            let originalValue = draftState[changedFieldName].rawValue;
                            draftState[changedFieldName].rawValue = newRawValue;
                            if (computeConstraints(changedFieldName, draftState).length > 0) {
                                // If the change violates constraints, revert the change
                                draftState[changedFieldName].rawValue = originalValue;
                                return draftState;
                            }
                            computeDirtyEntries(draftState, changedFieldName);
                            computeErrorEntries(draftState);
                        });
                    }
                case CLEAR:
                    return createInitialState(formConfig);
                case ADD_VALIDATOR:
                    {
                        const fieldWithOverride = action.payload.fieldName;
                        const newValidator = action.payload.validator;
                        return produce(state, (draftState)=>{
                            draftState[fieldWithOverride].validators.push(newValidator);
                            computeErrorEntries(draftState);
                        });
                    }
                case REMOVE_VALIDATOR:
                    {
                        const fieldToOverride = action.payload.fieldName;
                        const targetValidator = action.payload.validator;
                        return produce(state, (draftState)=>{
                            let fieldValidators = draftState[fieldToOverride].validators;
                            draftState[fieldToOverride].validators = fieldValidators.filter((validator)=>validator.type !== targetValidator.type);
                            computeErrorEntries(draftState);
                        });
                    }
                case CLEAR_FIELD_VALIDATORS:
                    {
                        const fieldToClear = action.payload.fieldName;
                        return produce(state, (draftState)=>{
                            draftState[fieldToClear].validators = [];
                            computeErrorEntries(draftState);
                        });
                    }
                default:
                    return state;
            }
        };
    const createMapDispatchToProps = (formConfig)=>{
        // Do memo-ization
        let cachedDispatch;
        let cacheValue;
        return (dispatch)=>{
            if (dispatch == cachedDispatch) return cacheValue;
            let dispatchObj = {};
            dispatchObj.fields = {};
            const keys = Object.keys(formConfig);
            for (let fieldName of keys)dispatchObj.fields[fieldName] = {
                set: (value)=>dispatch(set(fieldName)(value)),
                addValidator: (validator)=>dispatch(addValidator(fieldName)(validator)),
                removeValidator: (validator)=>dispatch(removeValidator(fieldName)(validator)),
                clear: ()=>dispatch(clearFieldValidators(fieldName)())
            };
            dispatchObj.form = {
                clear: ()=>dispatch(clear())
            };
            cachedDispatch = dispatch;
            cacheValue = {
                actions: dispatchObj
            };
            return cacheValue;
        };
    };
    const mapStateToProps = (state)=>({
            fields: state
        });
    const createFormState = (formConfig)=>({
            reducer: createFormReducer(formConfig),
            mapDispatchToProps: createMapDispatchToProps(formConfig),
            mapStateToProps: mapStateToProps
        });
    exports1.createFormState = createFormState;
    exports1.dateAfterToday = dateAfterToday;
    exports1.dateBeforeToday = dateBeforeToday;
    exports1.hasLength = hasLength;
    exports1.hasLowercaseLetter = hasLowercaseLetter;
    exports1.hasNumber = hasNumber;
    exports1.hasSpecialCharacter = hasSpecialCharacter;
    exports1.hasUppercaseLetter = hasUppercaseLetter;
    exports1.includedIn = includedIn;
    exports1.includesPotentialCardNumber = includesPotentialCardNumber;
    exports1.isAmericanOrCanadianRoutingNumber = isAmericanOrCanadianRoutingNumber;
    exports1.isProbablyEmail = isProbablyEmail;
    exports1.isRoutingNumber = isRoutingNumber;
    exports1.isValidMonth = isValidMonth;
    exports1.matchesField = matchesField;
    exports1.matchesRegex = matchesRegex;
    exports1.numberGreaterThan = numberGreaterThan;
    exports1.numberGreaterThanOrEqualTo = numberGreaterThanOrEqualTo;
    exports1.numberLessThan = numberLessThan;
    exports1.numberLessThanOrEqualTo = numberLessThanOrEqualTo;
    exports1.onlyExpirationDate = onlyExpirationDate;
    exports1.onlyIntegers = onlyIntegers;
    exports1.onlyNaturals = onlyNaturals;
    exports1.required = required;
    exports1.validName = validName;
    exports1.validateSum = validateSum;
    exports1.validateWhen = validateWhen;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

},{}],"8Zp0b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
const formConfig = {
    email: {
        validators: [
            (0, _reduxFreeform.required)(),
            (0, _reduxFreeform.isProbablyEmail)()
        ]
    }
};
const { reducer, mapStateToProps, mapDispatchToProps } = (0, _reduxFreeform.createFormState)(formConfig);

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f3A1R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ENVIRONMENTS", ()=>ENVIRONMENTS);
parcelHelpers.export(exports, "CHECK", ()=>CHECK);
parcelHelpers.export(exports, "CASH", ()=>CASH);
parcelHelpers.export(exports, "CARD", ()=>CARD);
parcelHelpers.export(exports, "WIRE", ()=>WIRE);
parcelHelpers.export(exports, "PAYLINK", ()=>PAYLINK);
parcelHelpers.export(exports, "PAYMENT_TYPE", ()=>PAYMENT_TYPE);
parcelHelpers.export(exports, "CARD_PAYMENT_TYPES", ()=>CARD_PAYMENT_TYPES);
parcelHelpers.export(exports, "CHECK_TYPE", ()=>CHECK_TYPE);
parcelHelpers.export(exports, "CC_READER_TYPE", ()=>CC_READER_TYPE);
parcelHelpers.export(exports, "ORDER_STATUS", ()=>ORDER_STATUS);
parcelHelpers.export(exports, "PAYMENT_CANCELLATION_STATUS", ()=>PAYMENT_CANCELLATION_STATUS);
parcelHelpers.export(exports, "TRANSACTION_STATUS", ()=>TRANSACTION_STATUS);
parcelHelpers.export(exports, "CASH_ACTION_TYPES", ()=>CASH_ACTION_TYPES);
parcelHelpers.export(exports, "CASH_ACTION_TYPES_DISPLAY", ()=>CASH_ACTION_TYPES_DISPLAY);
parcelHelpers.export(exports, "OKTA_LOGOUT_REASON_KEY", ()=>OKTA_LOGOUT_REASON_KEY);
parcelHelpers.export(exports, "LOGOUT_REASONS", ()=>LOGOUT_REASONS);
parcelHelpers.export(exports, "consoleWarningStyle", ()=>consoleWarningStyle);
parcelHelpers.export(exports, "OKTA_OAUTH_ERROR", ()=>OKTA_OAUTH_ERROR);
parcelHelpers.export(exports, "TABLE_MIN_LOADTIME_MS", ()=>TABLE_MIN_LOADTIME_MS);
parcelHelpers.export(exports, "IMAGE_ORIENTATIONS", ()=>IMAGE_ORIENTATIONS);
parcelHelpers.export(exports, "EMAIL_ADDRESS_FIELD_NAME", ()=>EMAIL_ADDRESS_FIELD_NAME);
parcelHelpers.export(exports, "PHONE_NUMBER_FIELD_NAME", ()=>PHONE_NUMBER_FIELD_NAME);
parcelHelpers.export(exports, "COMPANY_NAME_FIELD", ()=>COMPANY_NAME_FIELD);
const ENVIRONMENTS = {
    LOCAL: "local"
};
const CHECK = "check";
const CASH = "cash";
const CARD = "card";
const WIRE = "wire_payment";
const PAYLINK = "paylink";
const PAYMENT_TYPE = {
    CARD_PAYMENT: "Card Payment",
    CASH_PAYMENT: "Cash Payment",
    CHECK_PAYMENT: "Check Payment",
    WIRE_PAYMENT: "Wire Payment"
};
const CARD_PAYMENT_TYPES = {
    AUTOMATIC: "automatic",
    MANUAL: "manual"
};
const CHECK_TYPE = {
    PERSONAL: "personal",
    BUSINESS: "business",
    MONEY_ORDER: "money_order",
    CASHIERS_CHECK: "cashiers_check"
};
const CC_READER_TYPE = {
    TRANCLOUD: "trancloud",
    DC_DIRECT: "dc_direct",
    MAGTEK: "magtek"
};
const ORDER_STATUS = {
    SUCCESSFUL: "successful",
    OPENED: "opened",
    VOIDED: "voided",
    VOID_PENDING: "void_pending",
    INCOMPLETE: "incomplete",
    COMPLETED: "completed",
    CANCELLED: "cancelled",
    HOLD: "hold",
    REFUNDED: "refunded",
    PAYLINK_SENT: "paylink_sent",
    PAYLINK_COMPLETED: "paylink_completed"
};
const PAYMENT_CANCELLATION_STATUS = {
    PROCESSING: "processing",
    ASSISTANCE_REQUIRED: "assistance_required"
};
const TRANSACTION_STATUS = {
    SUCCESSFUL: "successful",
    ERRORED: "errored",
    CANCELLED: "cancelled",
    PENDING: "pending",
    REFUNDED: "refunded",
    CANCEL_PENDING: "cancel_pending"
};
const CASH_ACTION_TYPES = {
    ADD: "add",
    DROP: "drop",
    FLOAT: "float",
    OPENING_FLOAT: "opening_float",
    CLOSING_FLOAT: "closing_float",
    CLOSEOUT: "closeout"
};
const CASH_ACTION_TYPES_DISPLAY = {
    [CASH_ACTION_TYPES.ADD]: "Cash Add",
    [CASH_ACTION_TYPES.DROP]: "Cash Drop",
    [CASH_ACTION_TYPES.FLOAT]: "Float",
    [CASH_ACTION_TYPES.OPENING_FLOAT]: "Opening Float",
    [CASH_ACTION_TYPES.CLOSING_FLOAT]: "Closing Float",
    [CASH_ACTION_TYPES.CLOSEOUT]: "Closeout"
};
const OKTA_LOGOUT_REASON_KEY = "okta-logout-reason";
const LOGOUT_REASONS = {
    UNAUTHORIZED: {
        name: "UNAUTHORIZED",
        value: "Unauthorized",
        variant: "error"
    },
    EXPIRED: {
        name: "EXPIRED",
        value: "Your session has expired. Please login again.",
        variant: "error"
    },
    INACTIVITY: {
        name: "INACTIVITY",
        value: "You have been logged out due to inactivity.",
        variant: "info"
    },
    USER_INITIATED: {
        name: "USER_INITIATED",
        value: "You have been logged out.",
        variant: "info"
    },
    CLOSEOUT: {
        name: "CLOSEOUT",
        value: "You have successfully closed out of your session.",
        variant: "info"
    },
    ERROR: {
        name: "ERROR",
        value: "There was a problem logging in to your account.",
        variant: "error"
    },
    TERMINAL_SESSION_NOT_FOUND: {
        name: "TERMINAL_SESSION_NOT_FOUND",
        value: "Your terminal session is not found. Please log in again.",
        variant: "error"
    }
};
const consoleWarningStyle = "background-color: rgba(235, 64, 52, 0.25); color: #eb4034; display: inline-block; margin: 0.5rem; padding: 0.5rem; border: 1px solid #eb4034;";
const OKTA_OAUTH_ERROR = {
    queryStr: "error_description=User+is+not+assigned+to+the+client+application.",
    alertBarMsg: "OAuthError: User is not assigned to the client application."
};
const TABLE_MIN_LOADTIME_MS = 450;
const IMAGE_ORIENTATIONS = {
    PORTRAIT: "PORTRAIT",
    LANDSCAPE: "LANDSCAPE"
};
const EMAIL_ADDRESS_FIELD_NAME = "emailAddress";
const PHONE_NUMBER_FIELD_NAME = "phoneNumber";
const COMPANY_NAME_FIELD = "company_name";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h0jLC":[function(require,module,exports) {
// This reducer is intended for state that is used in multiple places throughout the app and doesn't pertain to one single reducer
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FETCH_CLIENT_CONFIG", ()=>FETCH_CLIENT_CONFIG);
parcelHelpers.export(exports, "fetchClientConfigRequest", ()=>fetchClientConfigRequest);
parcelHelpers.export(exports, "fetchClientConfigSuccess", ()=>fetchClientConfigSuccess);
parcelHelpers.export(exports, "fetchClientConfigError", ()=>fetchClientConfigError);
parcelHelpers.export(exports, "FETCH_CURRENT_ABILITIES", ()=>FETCH_CURRENT_ABILITIES);
parcelHelpers.export(exports, "fetchCurrentAbilitiesRequest", ()=>fetchCurrentAbilitiesRequest);
parcelHelpers.export(exports, "fetchCurrentAbilitiesSuccess", ()=>fetchCurrentAbilitiesSuccess);
parcelHelpers.export(exports, "fetchCurrentAbilitiesError", ()=>fetchCurrentAbilitiesError);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "sharedAlertBarAction", ()=>sharedAlertBarAction);
parcelHelpers.export(exports, "addSharedAlert", ()=>addSharedAlert);
parcelHelpers.export(exports, "genericErrorMessage", ()=>genericErrorMessage);
parcelHelpers.export(exports, "deleteSharedAlert", ()=>deleteSharedAlert);
parcelHelpers.export(exports, "clearSharedAlerts", ()=>clearSharedAlerts);
parcelHelpers.export(exports, "REPLACE_SHARED_ALERTS", ()=>REPLACE_SHARED_ALERTS);
parcelHelpers.export(exports, "replaceSharedAlerts", ()=>replaceSharedAlerts);
parcelHelpers.export(exports, "FETCH_DENOMINATIONS", ()=>FETCH_DENOMINATIONS);
parcelHelpers.export(exports, "fetchDenominationsRequest", ()=>fetchDenominationsRequest);
parcelHelpers.export(exports, "FETCH_DENOMINATIONS_SUCCESS", ()=>FETCH_DENOMINATIONS_SUCCESS);
parcelHelpers.export(exports, "fetchDenominationsSuccess", ()=>fetchDenominationsSuccess);
parcelHelpers.export(exports, "FETCH_DENOMINATIONS_ERROR", ()=>FETCH_DENOMINATIONS_ERROR);
parcelHelpers.export(exports, "fetchDenominationsError", ()=>fetchDenominationsError);
parcelHelpers.export(exports, "FETCH_ORDERS_FILTER_OPTIONS", ()=>FETCH_ORDERS_FILTER_OPTIONS);
parcelHelpers.export(exports, "fetchOrdersFilterOptionsRequest", ()=>fetchOrdersFilterOptionsRequest);
parcelHelpers.export(exports, "fetchOrdersFilterOptionsSuccess", ()=>fetchOrdersFilterOptionsSuccess);
parcelHelpers.export(exports, "fetchOrdersFilterOptionsError", ()=>fetchOrdersFilterOptionsError);
parcelHelpers.export(exports, "FETCH_DRAWER_HISTORIES_FILTER_OPTIONS", ()=>FETCH_DRAWER_HISTORIES_FILTER_OPTIONS);
parcelHelpers.export(exports, "fetchDrawerHistoriesFilterOptionsRequest", ()=>fetchDrawerHistoriesFilterOptionsRequest);
parcelHelpers.export(exports, "fetchDrawerHistoriesFilterOptionsSuccess", ()=>fetchDrawerHistoriesFilterOptionsSuccess);
parcelHelpers.export(exports, "fetchDrawerHistoriesFilterOptionsError", ()=>fetchDrawerHistoriesFilterOptionsError);
parcelHelpers.export(exports, "RESET_PIN_PAD", ()=>RESET_PIN_PAD);
parcelHelpers.export(exports, "resetPinPadRequest", ()=>resetPinPadRequest);
parcelHelpers.export(exports, "resetPinPadSuccess", ()=>resetPinPadSuccess);
parcelHelpers.export(exports, "resetPinPadError", ()=>resetPinPadError);
parcelHelpers.export(exports, "reducer", ()=>reducer);
var _nested = require("../utils/Nested");
var _helpers = require("../utils/helpers");
const initialState = {
    clientConfig: {
        payerNameRequired: null,
        creditCardReaderType: null
    },
    isClientConfigError: false,
    denominations: [],
    isLoading: false,
    isDenominationsError: false,
    isPinPadResetError: false,
    alerts: [],
    currentAbilities: {},
    tableFilterOptions: {
        error: false,
        isLoading: false,
        agencies: [],
        batches: [],
        locations: [],
        order_statuses: [],
        payment_methods: [],
        terminals: [],
        users: []
    }
};
const FETCH_CLIENT_CONFIG = "FETCH_CLIENT_CONFIG";
const fetchClientConfigRequest = (data)=>({
        type: FETCH_CLIENT_CONFIG,
        payload: data
    });
const CLIENT_CONFIG_SUCCESS = "CLIENT_CONFIG_SUCCESS";
const fetchClientConfigSuccess = (data)=>({
        type: CLIENT_CONFIG_SUCCESS,
        payload: data
    });
const CLIENT_CONFIG_ERROR = "CLIENT_CONFIG_ERROR";
const fetchClientConfigError = (data)=>({
        type: CLIENT_CONFIG_ERROR,
        payload: data
    });
const FETCH_CURRENT_ABILITIES = "FETCH_CURRENT_ABILITIES";
const fetchCurrentAbilitiesRequest = ()=>({
        type: FETCH_CURRENT_ABILITIES
    });
const CURRENT_ABILITIES_SUCCESS = "CURRENT_ABILITIES_SUCCESS";
const fetchCurrentAbilitiesSuccess = (data)=>({
        type: CURRENT_ABILITIES_SUCCESS,
        payload: data
    });
const CURRENT_ABILITIES_ERROR = "CURRENT_ABILITIES_ERROR";
const fetchCurrentAbilitiesError = (data)=>({
        type: CURRENT_ABILITIES_ERROR,
        payload: data
    });
const ALERT_BAR_ACTION = "shared/ALERT_BAR_ACTION";
const sharedAlertBarAction = (0, _nested.nestedAction)(ALERT_BAR_ACTION);
const ADD_SHARED_ALERT = "ADD_SHARED_ALERT";
const addSharedAlert = (alert)=>({
        type: ADD_SHARED_ALERT,
        payload: alert
    });
const genericErrorMessage = (err, heading = "Error")=>({
        heading: `${heading}:`,
        text: err.message,
        variant: "error"
    });
const DELETE_SHARED_ALERT = "DELETE_SHARED_ALERT";
const deleteSharedAlert = (index)=>({
        type: DELETE_SHARED_ALERT,
        payload: {
            index
        }
    });
const CLEAR_SHARED_ALERTS = "CLEAR_SHARED_ALERTS";
const clearSharedAlerts = ()=>({
        type: CLEAR_SHARED_ALERTS
    });
const REPLACE_SHARED_ALERTS = "REPLACE_SHARED_ALERTS";
const replaceSharedAlerts = (alert)=>({
        type: REPLACE_SHARED_ALERTS,
        payload: {
            alert
        }
    });
const FETCH_DENOMINATIONS = "FETCH_DENOMINATIONS";
const fetchDenominationsRequest = ()=>{
    return {
        type: FETCH_DENOMINATIONS
    };
};
const FETCH_DENOMINATIONS_SUCCESS = "FETCH_DENOMINATIONS_SUCCESS";
const fetchDenominationsSuccess = (data)=>{
    return {
        type: FETCH_DENOMINATIONS_SUCCESS,
        payload: data
    };
};
const FETCH_DENOMINATIONS_ERROR = "FETCH_DENOMINATIONS_ERROR";
const fetchDenominationsError = (data)=>({
        type: FETCH_DENOMINATIONS_ERROR,
        payload: data
    });
const FETCH_ORDERS_FILTER_OPTIONS = "FETCH_ORDERS_FILTER_OPTIONS";
const fetchOrdersFilterOptionsRequest = ()=>({
        type: FETCH_ORDERS_FILTER_OPTIONS
    });
const ORDERS_FILTER_OPTIONS_SUCCESS = "ORDERS_FILTER_OPTIONS_SUCCESS";
const fetchOrdersFilterOptionsSuccess = (data)=>({
        type: ORDERS_FILTER_OPTIONS_SUCCESS,
        payload: data
    });
const ORDERS_FILTER_OPTIONS_ERROR = "ORDERS_FILTER_OPTIONS_ERROR";
const fetchOrdersFilterOptionsError = (data)=>({
        type: ORDERS_FILTER_OPTIONS_ERROR,
        payload: data
    });
const FETCH_DRAWER_HISTORIES_FILTER_OPTIONS = "FETCH_DRAWER_HISTORIES_FILTER_OPTIONS";
const fetchDrawerHistoriesFilterOptionsRequest = ()=>({
        type: FETCH_DRAWER_HISTORIES_FILTER_OPTIONS
    });
const DRAWER_HISTORIES_FILTER_OPTIONS_SUCCESS = "DRAWER_HISTORIES_FILTER_OPTIONS_SUCCESS";
const fetchDrawerHistoriesFilterOptionsSuccess = (data)=>({
        type: DRAWER_HISTORIES_FILTER_OPTIONS_SUCCESS,
        payload: data
    });
const DRAWER_HISTORIES_FILTER_OPTIONS_ERROR = "DRAWER_HISTORIES_FILTER_OPTIONS_ERROR";
const fetchDrawerHistoriesFilterOptionsError = (data)=>({
        type: DRAWER_HISTORIES_FILTER_OPTIONS_ERROR,
        payload: data
    });
const RESET_PIN_PAD = "RESET_PIN_PAD";
const resetPinPadRequest = (terminalId)=>({
        type: RESET_PIN_PAD,
        payload: {
            terminalId
        }
    });
const RESET_PIN_PAD_SUCCESS = "RESET_PIN_PAD_SUCCESS";
const resetPinPadSuccess = (data)=>({
        type: RESET_PIN_PAD_SUCCESS,
        payload: data
    });
const RESET_PIN_PAD_ERROR = "RESET_PIN_PAD_ERROR";
const resetPinPadError = (data)=>({
        type: RESET_PIN_PAD_ERROR,
        payload: data
    });
const reducer = (state = initialState, { type, payload } = action)=>{
    switch(type){
        case RESET_PIN_PAD:
            return {
                ...state,
                isLoading: true
            };
        case RESET_PIN_PAD_SUCCESS:
            return {
                ...state,
                isPinPadResetError: false,
                isLoading: false
            };
        case RESET_PIN_PAD_ERROR:
            return {
                ...state,
                isPinPadResetError: true,
                isLoading: false
            };
        case FETCH_ORDERS_FILTER_OPTIONS:
            return {
                ...state,
                tableFilterOptions: {
                    ...state.tableFilterOptions,
                    isLoading: true
                }
            };
        case ORDERS_FILTER_OPTIONS_SUCCESS:
            return {
                ...state,
                tableFilterOptions: {
                    ...state.tableFilterOptions,
                    ...payload.data,
                    isLoading: false,
                    error: false
                }
            };
        case ORDERS_FILTER_OPTIONS_ERROR:
            return {
                ...state,
                tableFilterOptions: {
                    ...state.tableFilterOptions,
                    isLoading: false,
                    error: true
                }
            };
        case FETCH_DRAWER_HISTORIES_FILTER_OPTIONS:
            return {
                ...state,
                tableFilterOptions: {
                    ...state.tableFilterOptions,
                    isLoading: true
                }
            };
        case DRAWER_HISTORIES_FILTER_OPTIONS_SUCCESS:
            return {
                ...state,
                tableFilterOptions: {
                    ...state.tableFilterOptions,
                    ...payload.data,
                    isLoading: false,
                    error: false
                }
            };
        case DRAWER_HISTORIES_FILTER_OPTIONS_ERROR:
            return {
                ...state,
                tableFilterOptions: {
                    ...state.tableFilterOptions,
                    isLoading: false,
                    error: true
                }
            };
        case FETCH_CLIENT_CONFIG:
            return {
                ...state,
                isLoading: true
            };
        case CLIENT_CONFIG_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isClientConfigError: false,
                clientConfig: {
                    ...state.clientConfig,
                    payerNameRequired: payload.payer_name_required,
                    creditCardReaderType: payload.credit_card_reader_type
                }
            };
        case CLIENT_CONFIG_ERROR:
            return {
                ...state,
                isLoading: false,
                isClientConfigError: true
            };
        case FETCH_CURRENT_ABILITIES:
            return {
                ...state,
                isLoading: true
            };
        case CURRENT_ABILITIES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                currentAbilities: payload
            };
        case CURRENT_ABILITIES_ERROR:
            return {
                ...state,
                isLoading: false
            };
        case FETCH_DENOMINATIONS:
            return {
                ...state,
                isLoading: true
            };
        case FETCH_DENOMINATIONS_ERROR:
            return {
                ...state,
                isDenominationsError: true,
                isLoading: false
            };
        case FETCH_DENOMINATIONS_SUCCESS:
            return {
                ...state,
                denominations: payload.denominations.map((d)=>({
                        ...d,
                        formattedValue: (0, _helpers.formatPrice)(d.value)
                    })).sort((a, b)=>a.value - b.value),
                isDenominationsSuccess: true,
                isLoading: false,
                isDenominationsError: false
            };
        case ADD_SHARED_ALERT:
            return {
                ...state,
                alerts: [
                    ...state.alerts,
                    payload.alert
                ]
            };
        case DELETE_SHARED_ALERT:
            return {
                ...state,
                alerts: state.alerts.filter((a)=>state.alerts.indexOf(a) !== payload.index)
            };
        case CLEAR_SHARED_ALERTS:
            return {
                ...state,
                alerts: initialState.alerts
            };
        case REPLACE_SHARED_ALERTS:
            return {
                ...state,
                alerts: [
                    payload.alert
                ]
            };
        default:
            return state;
    }
};
exports.default = reducer;

},{"../utils/Nested":"gDQL4","../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"epomp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "can", ()=>can);
parcelHelpers.export(exports, "formatCurrency", ()=>formatCurrency);
parcelHelpers.export(exports, "formatCurrencyInput", ()=>formatCurrencyInput);
parcelHelpers.export(exports, "formatPrice", ()=>formatPrice);
parcelHelpers.export(exports, "formatWithParentheses", ()=>formatWithParentheses);
parcelHelpers.export(exports, "removeLeadingMinus", ()=>removeLeadingMinus);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "camelCaseToSnakeCase", ()=>camelCaseToSnakeCase);
parcelHelpers.export(exports, "denominationMultipliers", ()=>denominationMultipliers);
parcelHelpers.export(exports, "delimitDateString", ()=>delimitDateString);
parcelHelpers.export(exports, "convertToISOFormat", ()=>convertToISOFormat);
parcelHelpers.export(exports, "DATE_FIELDS", ()=>DATE_FIELDS);
parcelHelpers.export(exports, "getFiltersFromFields", ()=>getFiltersFromFields);
parcelHelpers.export(exports, "titleCase", ()=>titleCase);
parcelHelpers.export(exports, "genRandomString", ()=>genRandomString);
parcelHelpers.export(exports, "isEmptyObj", ()=>isEmptyObj);
parcelHelpers.export(exports, "isDatacapTransaction", ()=>isDatacapTransaction);
parcelHelpers.export(exports, "downloadReport", ()=>downloadReport);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "getImageOrientation", ()=>getImageOrientation);
parcelHelpers.export(exports, "phoneNumberWithoutCountryCode", ()=>phoneNumberWithoutCountryCode);
parcelHelpers.export(exports, "transformReplaceFormData", ()=>transformReplaceFormData);
parcelHelpers.export(exports, "getNamespace", ()=>getNamespace);
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _constants = require("./constants");
const can = (action, item, abilities)=>abilities?.[action]?.includes(item) ?? false;
const formatCurrency = (rawPrice)=>parseFloat(rawPrice).toLocaleString("en-US", {
        style: "currency",
        currency: "USD"
    }).replace("$", "");
const formatCurrencyInput = (rawPrice)=>parseFloat(rawPrice).toFixed(2);
const formatPrice = (rawPrice, negative = false)=>`${negative ? "-" : ""}$${formatCurrency(rawPrice)}`;
const formatWithParentheses = (value)=>{
    return `(${value})`;
};
const removeLeadingMinus = (value)=>{
    if (value === null || value === undefined || typeof value == "boolean") return "";
    const stringValue = value.toString();
    return stringValue.startsWith("-") ? stringValue.slice(1) : stringValue;
};
const capitalize = (string)=>(string?.charAt(0)?.toUpperCase() + string?.slice(1)) ?? string;
const formatDate = (timestamp)=>new Date(timestamp)?.toLocaleString("default")?.split(",")?.join(" - ");
const camelCaseToSnakeCase = (string)=>string.replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`);
const denominationMultipliers = [
    1,
    5,
    10,
    25,
    100,
    200,
    500,
    1000,
    2000,
    5000,
    10000
];
const MM_DD_YYYY_FORMAT_LENGTH = 8;
const dateInputToISOString = (dateString = "")=>{
    if (dateString.length < MM_DD_YYYY_FORMAT_LENGTH) return "";
    const month = dateString.slice(0, 2);
    const day = dateString.slice(2, 4);
    const year = dateString.slice(4, 8);
    return new Date(`${year}-${month}-${day}`).toISOString();
};
const delimitDateString = (dateString = "")=>dateString.length === MM_DD_YYYY_FORMAT_LENGTH ? `${dateString.substring(0, 2)}/${dateString.substring(2, 4)}/${dateString.substring(4, 8)}` : "";
const convertToISOFormat = (mmddyyyyDate)=>{
    if (!mmddyyyyDate) return "";
    const formatted = delimitDateString(mmddyyyyDate);
    return (0, _dayjsDefault.default)(formatted).format("YYYY-MM-DD");
};
const DATE_FIELDS = [
    "startDate",
    "endDate"
];
const getFiltersFromFields = (filterFields)=>Object.entries(filterFields).filter(([_, { rawValue }])=>Boolean(rawValue)).map(([field, { rawValue }])=>{
        if (DATE_FIELDS.includes(field)) return `filters[${camelCaseToSnakeCase(field)}]=${dateInputToISOString(rawValue)}`;
        return `filters[${camelCaseToSnakeCase(field)}]=${rawValue}`;
    }).join("&");
const titleCase = (s)=>(s ?? "").replace(/^[-_]*(.)/, (_, c)=>c.toUpperCase()).replace(/[-_]+(.)/g, (_, c)=>" " + c.toUpperCase());
const genRandomString = (text)=>`${text}${Math.random()}`; // used to create unique React key prop https://reactjs.org/docs/lists-and-keys.html
const isEmptyObj = (obj)=>Object.keys(obj).length === 0;
const isDatacapTransaction = (payment_tender_type, cc_reader_type)=>(cc_reader_type === (0, _constants.CC_READER_TYPE).TRANCLOUD || cc_reader_type === (0, _constants.CC_READER_TYPE).DC_DIRECT) && payment_tender_type === (0, _constants.CARD);
const downloadReport = (type, terminal, date, url)=>{
    const document_name = `${terminal.replace(/\s+/g, "-")}-${type}-${(0, _dayjsDefault.default)(date).format("YYYYMMDDHHmmss")}`;
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = document_name;
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};
const debounce = (callback, delay = 1000)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            callback(...args);
        }, delay);
    };
};
const getImageOrientation = async (imageUrl)=>{
    try {
        const imageObjectUrl = await fetch(imageUrl).then((response)=>response.blob()).then((imageBlob)=>URL.createObjectURL(imageBlob));
        const image = document.createElement("img");
        image.src = imageObjectUrl;
        await image.decode();
        const portraitOrLandscapeImage = image.width > image.height ? (0, _constants.IMAGE_ORIENTATIONS).LANDSCAPE : (0, _constants.IMAGE_ORIENTATIONS).PORTRAIT;
        return portraitOrLandscapeImage;
    } catch (err) {
        console.warn(`%cWarning: getImageOrientation error: ${err}`, `background-color: ${(0, _constants.consoleWarningStyle)}`);
    }
};
const phoneNumberWithoutCountryCode = (phoneNumber)=>{
    const countryCodeRegex = /^\+?\d{1}/;
    const hasCountryCode = countryCodeRegex.test(phoneNumber);
    const numberRegex = /[\s()-]*\D+/g;
    const cleanedNumber = phoneNumber.replace(numberRegex, "");
    if (hasCountryCode && cleanedNumber.length === 11) {
        const numberWithoutCountryCode = cleanedNumber.replace(countryCodeRegex, "");
        return numberWithoutCountryCode;
    }
    return cleanedNumber;
};
const transformReplaceFormData = (formData, changedField, overrides)=>{
    const OVERRIDE_TYPE = "replace";
    if (!changedField || !overrides || !overrides?.hasOwnProperty(OVERRIDE_TYPE)) return formData;
    const changedKey = changedField?.split?.("root_")?.[1];
    const isTransformApplicable = overrides[OVERRIDE_TYPE].hasOwnProperty(changedKey);
    if (isTransformApplicable) {
        const transforms = overrides[OVERRIDE_TYPE][changedKey];
        const trigger = formData[changedKey];
        const replacements = transforms.filter((t)=>t.trigger === trigger);
        replacements.forEach((t)=>{
            formData[t.field] = t.value;
        });
    }
    return formData;
};
const getNamespace = (hostname)=>{
    if (!hostname || typeof hostname !== "string" || hostname === "localhost") return null;
    if (hostname === "pos.thecitybase.com") return "default";
    const matches = hostname.match(/^pos-frontend-([\w\-]*)\./);
    return matches?.[1] ?? null;
};

},{"dayjs":"4CsUp","./constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4CsUp":[function(require,module,exports) {
!function(t, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", $ = "Invalid Date", l = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[^0-9]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_")
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, g = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, f), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), f);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: f,
                y: c,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: h
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, D = "en", v = {};
    v[D] = M;
    var p = function(t) {
        return t instanceof _;
    }, S = function(t, e, n) {
        var r;
        if (!t) return D;
        if ("string" == typeof t) v[t] && (r = t), e && (v[t] = e, r = t);
        else {
            var i = t.name;
            v[i] = t, r = i;
        }
        return !n && r && (D = r), r || !n && D;
    }, w = function(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, O = g;
    O.l = S, O.i = p, O.w = function(t, e) {
        return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match(l);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return O;
        }, m.isValid = function() {
            return !(this.$d.toString() === $);
        }, m.isSame = function(t, e) {
            var n = w(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return w(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < w(t);
        }, m.$g = function(t, e, n) {
            return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!O.u(e) || e, h = O.p(t), $ = function(t, e) {
                var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, l = function(t, e) {
                return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, g = "set" + (this.$u ? "UTC" : "");
            switch(h){
                case c:
                    return r ? $(1, 0) : $(31, 11);
                case f:
                    return r ? $(1, M) : $(0, M + 1);
                case o:
                    var D = this.$locale().weekStart || 0, v = (y < D ? y + 7 : y) - D;
                    return $(r ? m - v : m + (6 - v), M);
                case a:
                case d:
                    return l(g + "Hours", 0);
                case u:
                    return l(g + "Minutes", 1);
                case s:
                    return l(g + "Seconds", 2);
                case i:
                    return l(g + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = O.p(t), h = "set" + (this.$u ? "UTC" : ""), $ = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o], l = o === a ? this.$D + (e - this.$W) : e;
            if (o === f || o === c) {
                var y = this.clone().set(d, 1);
                y.$d[$](l), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else $ && this.$d[$](l);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[O.p(t)]();
        }, m.add = function(r, h) {
            var d, $ = this;
            r = Number(r);
            var l = O.p(h), y = function(t) {
                var e = w($);
                return O.w(e.date(e.date() + Math.round(t * r)), $);
            };
            if (l === f) return this.set(f, this.$M + r);
            if (l === c) return this.set(c, this.$y + r);
            if (l === a) return y(1);
            if (l === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[l] || 1, m = this.$d.getTime() + r * M;
            return O.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this;
            if (!this.isValid()) return $;
            var n = t || "YYYY-MM-DDTHH:mm:ssZ", r = O.z(this), i = this.$locale(), s = this.$H, u = this.$m, a = this.$M, o = i.weekdays, f = i.months, h = function(t, r, i, s) {
                return t && (t[r] || t(e, n)) || i[r].substr(0, s);
            }, c = function(t) {
                return O.s(s % 12 || 12, t, "0");
            }, d = i.meridiem || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            }, l = {
                YY: String(this.$y).slice(-2),
                YYYY: this.$y,
                M: a + 1,
                MM: O.s(a + 1, 2, "0"),
                MMM: h(i.monthsShort, a, f, 3),
                MMMM: h(f, a),
                D: this.$D,
                DD: O.s(this.$D, 2, "0"),
                d: String(this.$W),
                dd: h(i.weekdaysMin, this.$W, o, 2),
                ddd: h(i.weekdaysShort, this.$W, o, 3),
                dddd: o[this.$W],
                H: String(s),
                HH: O.s(s, 2, "0"),
                h: c(1),
                hh: c(2),
                a: d(s, u, !0),
                A: d(s, u, !1),
                m: String(u),
                mm: O.s(u, 2, "0"),
                s: String(this.$s),
                ss: O.s(this.$s, 2, "0"),
                SSS: O.s(this.$ms, 3, "0"),
                Z: r
            };
            return n.replace(y, function(t, e) {
                return e || l[t] || r.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, $) {
            var l, y = O.p(d), M = w(r), m = (M.utcOffset() - this.utcOffset()) * e, g = this - M, D = O.m(this, M);
            return D = (l = {}, l[c] = D / 12, l[f] = D, l[h] = D / 3, l[o] = (g - m) / 6048e5, l[a] = (g - m) / 864e5, l[u] = g / n, l[s] = g / e, l[i] = g / t, l)[y] || g, $ ? D : O.a(D);
        }, m.daysInMonth = function() {
            return this.endOf(f).$D;
        }, m.$locale = function() {
            return v[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = S(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return O.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), b = _.prototype;
    return w.prototype = b, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            f
        ],
        [
            "$y",
            c
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        b[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), w.extend = function(t, e) {
        return t.$i || (t(e, _, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
        return w(1e3 * t);
    }, w.en = v[D], w.Ls = v, w.p = {}, w;
});

},{}],"gk2Ni":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SharedAlertBar", ()=>SharedAlertBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _shared = require("../../state/shared");
var _reactRedux = require("react-redux");
var _alertBar = require("./AlertBar");
var _helpers = require("../../utils/helpers");
const SharedAlertBar = ({ isToast = false, alertClearTimeout = 10000, showQuitLink })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    (0, _react.useEffect)(()=>()=>dispatch((0, _shared.clearSharedAlerts)()), []);
    (0, _react.useEffect)(()=>{
        if (isToast) {
            let timeout = setTimeout(()=>{
                dispatch((0, _shared.clearSharedAlerts)());
            }, alertClearTimeout);
            return ()=>clearTimeout(timeout);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBar.AlertBarWrapper), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBar.AlertBarContainer), {
            position: isToast ? "absolute" : "static",
            children: sharedAlerts.map((alert, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Alert), {
                    showQuitLink: showQuitLink,
                    themeValues: {
                        background: alert.background,
                        border: alert.border
                    },
                    alertPosition: i,
                    ...alert,
                    onLinkClick: ()=>dispatch((0, _shared.deleteSharedAlert)(i))
                }, (0, _helpers.genRandomString)(alert.heading)))
        })
    });
};
exports.default = SharedAlertBar;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../state/shared":"h0jLC","react-redux":"k6jol","./AlertBar":"fwCei","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fwCei":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertBarContainer", ()=>AlertBarContainer);
parcelHelpers.export(exports, "AlertBarWrapper", ()=>AlertBarWrapper);
parcelHelpers.export(exports, "AlertBar", ()=>AlertBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _components = require("@thecb/components");
var _helpers = require("../../utils/helpers");
const AlertBarContainer = (0, _styledComponentsDefault.default).div`
  position: ${({ position })=>position};
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 99;
`;
const AlertBarWrapper = (0, _styledComponentsDefault.default).div`
  max-width: 85.714rem; // 1200px
  width: 100%;
  margin: 0 auto;
`;
const AlertBar = ({ alerts = [], deleteAlert = (0, _components.util).general.noop, clearAlerts = (0, _components.util).general.noop, isToast = false, alertClearTimeout = 10000 })=>{
    (0, _react.useEffect)(()=>()=>clearAlerts(), []);
    (0, _react.useEffect)(()=>{
        if (isToast) {
            let timeout = setTimeout(()=>{
                clearAlerts();
            }, alertClearTimeout);
            return ()=>clearTimeout(timeout);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertBarWrapper, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertBarContainer, {
            position: isToast ? "absolute" : "static",
            children: alerts.map((alert, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Alert), {
                    themeValues: {
                        background: alert.background,
                        border: alert.border
                    },
                    alertPosition: i,
                    ...alert,
                    onLinkClick: ()=>deleteAlert(i),
                    extraStyles: "min-height: auto"
                }, (0, _helpers.genRandomString)(alert.heading)))
        })
    });
};
exports.default = AlertBar;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","styled-components":"bkusY","@thecb/components":"g98ma","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7GhEX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUBMIT_TERMINAL_LOGIN_FORM", ()=>SUBMIT_TERMINAL_LOGIN_FORM);
parcelHelpers.export(exports, "submitTerminalLoginForm", ()=>submitTerminalLoginForm);
parcelHelpers.export(exports, "TERMINAL_LOGIN_SUCCESS", ()=>TERMINAL_LOGIN_SUCCESS);
parcelHelpers.export(exports, "terminalLoginSuccess", ()=>terminalLoginSuccess);
parcelHelpers.export(exports, "terminalLoginFailure", ()=>terminalLoginFailure);
parcelHelpers.export(exports, "FETCH_LOCATIONS", ()=>FETCH_LOCATIONS);
parcelHelpers.export(exports, "fetchLocations", ()=>fetchLocations);
parcelHelpers.export(exports, "FETCH_LOCATIONS_SUCCESS", ()=>FETCH_LOCATIONS_SUCCESS);
parcelHelpers.export(exports, "fetchLocationsSuccess", ()=>fetchLocationsSuccess);
parcelHelpers.export(exports, "FETCH_LOCATIONS_FAILURE", ()=>FETCH_LOCATIONS_FAILURE);
parcelHelpers.export(exports, "fetchLocationsFailure", ()=>fetchLocationsFailure);
parcelHelpers.export(exports, "FETCH_TERMINALS", ()=>FETCH_TERMINALS);
parcelHelpers.export(exports, "fetchTerminals", ()=>fetchTerminals);
parcelHelpers.export(exports, "FETCH_TERMINALS_SUCCESS", ()=>FETCH_TERMINALS_SUCCESS);
parcelHelpers.export(exports, "fetchTerminalsSuccess", ()=>fetchTerminalsSuccess);
parcelHelpers.export(exports, "FETCH_TERMINALS_FAILURE", ()=>FETCH_TERMINALS_FAILURE);
parcelHelpers.export(exports, "fetchTerminalsFailure", ()=>fetchTerminalsFailure);
parcelHelpers.export(exports, "OPEN_SESSION_TRANSFER_MODAL", ()=>OPEN_SESSION_TRANSFER_MODAL);
parcelHelpers.export(exports, "CLOSE_SESSION_TRANSFER_MODAL", ()=>CLOSE_SESSION_TRANSFER_MODAL);
parcelHelpers.export(exports, "sessionTransferModal", ()=>sessionTransferModal);
parcelHelpers.export(exports, "_reducer", ()=>_reducer1);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "TERMINAL_ALERT_BAR_ACTION", ()=>TERMINAL_ALERT_BAR_ACTION);
parcelHelpers.export(exports, "terminalLoginAlertBarAction", ()=>terminalLoginAlertBarAction);
parcelHelpers.export(exports, "TERMINAL_LOGIN_FORM_ACTION", ()=>TERMINAL_LOGIN_FORM_ACTION);
parcelHelpers.export(exports, "terminalLoginFormAction", ()=>terminalLoginFormAction);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _terminalLoginForm = require("./TerminalLoginForm");
var _terminalLoginFormDefault = parcelHelpers.interopDefault(_terminalLoginForm);
var _nested = require("../../utils/Nested");
var _reducer = require("../../state/reducer");
const SUBMIT_TERMINAL_LOGIN_FORM = "terminalLogin/SUBMIT_TERMINAL_LOGIN_FORM";
const submitTerminalLoginForm = (data)=>({
        type: SUBMIT_TERMINAL_LOGIN_FORM,
        payload: data
    });
const TERMINAL_LOGIN_SUCCESS = "terminalLogin/LOGIN_SUCCESS";
const terminalLoginSuccess = (data)=>({
        type: TERMINAL_LOGIN_SUCCESS,
        payload: data
    });
const TERMINAL_LOGIN_FAILURE = "terminalLogin/LOGIN_FAILURE";
const terminalLoginFailure = (error)=>({
        type: TERMINAL_LOGIN_FAILURE,
        payload: {
            error
        }
    });
const FETCH_LOCATIONS = "terminalLogin/FETCH_LOCATIONS";
const fetchLocations = (payload)=>({
        type: FETCH_LOCATIONS,
        payload
    });
const FETCH_LOCATIONS_SUCCESS = "terminalLogin/FETCH_LOCATIONS_SUCCESS";
const fetchLocationsSuccess = (payload)=>({
        type: FETCH_LOCATIONS_SUCCESS,
        payload
    });
const FETCH_LOCATIONS_FAILURE = "terminalLogin/FETCH_LOCATIONS_FAILURE";
const fetchLocationsFailure = (payload)=>({
        type: FETCH_LOCATIONS_FAILURE,
        payload
    });
const FETCH_TERMINALS = "terminalLogin/FETCH_TERMINALS";
const fetchTerminals = (locationId)=>({
        type: FETCH_TERMINALS,
        payload: locationId
    });
const FETCH_TERMINALS_SUCCESS = "terminalLogin/FETCH_TERMINALS_SUCCESS";
const fetchTerminalsSuccess = (payload)=>({
        type: FETCH_TERMINALS_SUCCESS,
        payload
    });
const FETCH_TERMINALS_FAILURE = "terminalLogin/FETCH_TERMINALS_FAILURE";
const fetchTerminalsFailure = (err)=>({
        type: FETCH_TERMINALS_FAILURE,
        payload: err
    });
const OPEN_SESSION_TRANSFER_MODAL = "OPEN_SESSION_TRANSFER_MODAL";
const CLOSE_SESSION_TRANSFER_MODAL = "CLOSE_SESSION_TRANSFER_MODAL";
const sessionTransferModal = (type)=>({
        type
    });
const initialState = {
    submitting: false,
    error: false,
    clientId: null,
    locations: {
        fetching: false,
        data: [],
        selectedLocation: {}
    },
    terminals: {
        fetching: false,
        data: []
    },
    terminalSession: null,
    isSessionTransferModalOpen: false
};
const loadInitialState = ()=>{
    try {
        const terminalSessionState = localStorage.getItem("terminalSession");
        if (!terminalSessionState) return initialState;
        else return JSON.parse(localStorage.getItem("terminalSession"));
    } catch (err) {
        return initialState;
    }
};
const _reducer1 = (state = loadInitialState(), { type, payload })=>{
    switch(type){
        case FETCH_LOCATIONS:
            return {
                ...state,
                locations: {
                    fetching: true,
                    data: []
                }
            };
        case FETCH_LOCATIONS_SUCCESS:
            return {
                ...state,
                locations: {
                    fetching: false,
                    data: [
                        ...payload.data
                    ]
                }
            };
        case FETCH_LOCATIONS_FAILURE:
            return {
                ...state,
                locations: {
                    fetching: false,
                    ...state.locations
                }
            };
        case FETCH_TERMINALS:
            return {
                ...state,
                terminals: {
                    ...state.terminals,
                    fetching: true
                }
            };
        case FETCH_TERMINALS_SUCCESS:
            return {
                ...state,
                terminals: {
                    fetching: false,
                    data: [
                        ...payload.data
                    ]
                }
            };
        case FETCH_TERMINALS_FAILURE:
            return {
                ...state,
                terminals: {
                    fetching: false,
                    ...state.terminals
                }
            };
        case SUBMIT_TERMINAL_LOGIN_FORM:
            return {
                ...state,
                submitting: true
            };
        // would be namespaced under 'terminalLogin'
        case TERMINAL_LOGIN_SUCCESS:
            const { client_id, location } = payload.terminal_session;
            return {
                ...state,
                clientId: client_id,
                terminalSession: payload.terminal_session,
                locations: {
                    ...state.locations,
                    selectedLocation: state.locations.data.find((l)=>l.name === location)
                },
                submitting: false,
                error: false
            };
        case TERMINAL_LOGIN_FAILURE:
            return {
                ...state,
                submitting: false,
                error: payload,
                terminals: {
                    ...state.terminals,
                    fetching: false
                },
                locations: {
                    ...state.locations,
                    fetching: false
                }
            };
        case 0, _reducer.LOGOUT:
            return {
                ...state,
                ...initialState
            };
        case OPEN_SESSION_TRANSFER_MODAL:
            return {
                ...state,
                isSessionTransferModalOpen: true
            };
        case CLOSE_SESSION_TRANSFER_MODAL:
            return {
                ...state,
                isSessionTransferModalOpen: false
            };
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>({
        ...state.terminalLogin
    });
const _mapDispatchToProps = (dispatch)=>({
        fetchLocations: (payload)=>dispatch(fetchLocations(payload))
    });
const TERMINAL_ALERT_BAR_ACTION = "terminalLogin/ALERT_BAR_ACTION";
const terminalLoginAlertBarAction = _nested.nestedAction(TERMINAL_ALERT_BAR_ACTION);
const TERMINAL_LOGIN_FORM_ACTION = "terminalLogin/LOGIN_FORM_ACTION";
const terminalLoginFormAction = _nested.nestedAction(TERMINAL_LOGIN_FORM_ACTION);
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer1,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    forms: {
        terminalLoginForm: {
            ...(0, _terminalLoginFormDefault.default),
            actionType: TERMINAL_LOGIN_FORM_ACTION
        }
    },
    alertBars: {
        terminalLoginAlertBar: {
            ..._alertBarState,
            actionType: TERMINAL_ALERT_BAR_ACTION
        }
    }
}, "terminalLogin");
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","./TerminalLoginForm":"eGc1m","../../utils/Nested":"gDQL4","../../state/reducer":"aTwKq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eGc1m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TerminalLoginForm", ()=>TerminalLoginForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxFreeform = require("redux-freeform");
var _components = require("@thecb/components");
var _terminalLoginFormState = require("./TerminalLoginForm.state");
var _reactRedux = require("react-redux");
var _shared = require("../../state/shared");
var _sharedAlertBar = require("../../components/alert-bar/SharedAlertBar");
var _sharedAlertBarDefault = parcelHelpers.interopDefault(_sharedAlertBar);
var _terminalLoginState = require("./TerminalLogin.state");
const defaultLocationOption = {
    text: "Select Location",
    value: ""
};
const mapLocationsToSelectOptions = (locations)=>{
    const options = [
        defaultLocationOption
    ];
    return options.concat(locations.data.map((location)=>({
            text: location.name,
            value: location.id.toString()
        })));
};
const defaultTerminalOption = {
    text: "Select Terminal",
    value: ""
};
const mapTerminalsToSelectOptions = (terminals, locationId)=>{
    const options = [
        defaultTerminalOption
    ];
    return options.concat(terminals.data.filter((t)=>t.location_id == locationId).map((terminal)=>({
            text: terminal.name,
            value: terminal.id.toString()
        })));
};
const TerminalLoginForm = ({ fields, actions, showErrors, locations, terminals, setSelectedTerminalSession })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    const isAlertCurrentlyDisplayed = !!sharedAlerts.length;
    const handleLocationSelection = (locationId)=>{
        actions.fields.location.set(locationId);
        if (locationId) dispatch((0, _terminalLoginState.fetchTerminals)(locationId));
        if (isAlertCurrentlyDisplayed) dispatch((0, _shared.clearSharedAlerts)());
    };
    const handleTerminalSelection = (terminalId)=>{
        actions.fields.terminal.set(terminalId);
        const selectedTerminalSession = terminals.data.find((t)=>t.id === Number(terminalId));
        const hasActiveSession = selectedTerminalSession?.terminal_session.cashier["active?"];
        hasActiveSession && dispatch((0, _shared.replaceSharedAlerts)({
            heading: "Open Session Already Exists",
            text: "This terminal currently has an open session.",
            type: "info"
        }));
        !hasActiveSession && isAlertCurrentlyDisplayed && dispatch((0, _shared.clearSharedAlerts)());
        setSelectedTerminalSession(selectedTerminalSession);
    };
    (0, _react.useEffect)(()=>{
        return ()=>actions.form.clear();
    }, []);
    (0, _react.useEffect)(()=>{
        // when the user re-selects a location, ensure
        // the terminals select is reset as well.
        actions.fields.terminal.set("");
    }, [
        fields.location.rawValue
    ]);
    const currentLocationId = fields.location.rawValue;
    const locationErrors = {
        [(0, _reduxFreeform.required).error]: "Location selection is required"
    };
    const terminalErrors = {
        [(0, _reduxFreeform.required).error]: "Terminal selection is required"
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormInputColumn), {
        role: "form",
        "aria-label": "Login",
        children: [
            locations.fetching ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                size: "100"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                onChange: handleLocationSelection,
                dropdownMaxHeight: "200px",
                labelTextWhenNoError: "Location",
                options: mapLocationsToSelectOptions(locations),
                fieldActions: actions.fields.location,
                showErrors: showErrors,
                errorMessages: locationErrors,
                field: fields.location,
                labelTextVariant: "p",
                errorLabelTextVariant: "p"
            }),
            terminals.fetching ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                size: "100"
            }) : fields.location.rawValue && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                onChange: handleTerminalSelection,
                dropdownMaxHeight: "200px",
                labelTextWhenNoError: "Terminal",
                options: mapTerminalsToSelectOptions(terminals, currentLocationId),
                fieldActions: actions.fields.terminal,
                showErrors: showErrors,
                errorMessages: terminalErrors,
                field: fields.terminal,
                labelTextVariant: "p",
                errorLabelTextVariant: "p"
            }),
            sharedAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharedAlertBarDefault.default), {
                showQuitLink: false
            })
        ]
    });
};
TerminalLoginForm.reducer = (0, _terminalLoginFormState.reducer);
TerminalLoginForm.mapStateToProps = (0, _terminalLoginFormState.mapStateToProps);
TerminalLoginForm.mapDispatchToProps = (0, _terminalLoginFormState.mapDispatchToProps);
exports.default = TerminalLoginForm;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","redux-freeform":"1Yc5v","@thecb/components":"g98ma","./TerminalLoginForm.state":"cllso","react-redux":"k6jol","../../state/shared":"h0jLC","../../components/alert-bar/SharedAlertBar":"gk2Ni","./TerminalLogin.state":"7GhEX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cllso":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
const formConfig = {
    location: {
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    terminal: {
        validators: [
            (0, _reduxFreeform.required)()
        ]
    }
};
const { reducer, mapStateToProps, mapDispatchToProps } = (0, _reduxFreeform.createFormState)(formConfig);

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6lCJi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeTenantEpic", ()=>initializeTenantEpic);
parcelHelpers.export(exports, "fetchThemeEpic", ()=>fetchThemeEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _reducer = require("../reducer");
var _ramda = require("ramda");
var _state = require("../../utils/state");
var _loginState = require("../../pages/login/Login.state");
const doTenantConfigurationHTTPCall = async (// app,
client_slug, configMetaEndpoint)=>{
    const url = `${configMetaEndpoint}/${client_slug}/pos/meta.json`;
    // let settingsUrl = '';
    // let paymentUrl = '';
    // settingsUrl = `${configSettingsEndpoint}/${slug}/${app}/settings.json`;
    // paymentUrl = `${configPaymentsEndpoint}/${slug}/${app}/config.json`;
    const metaResponse = await fetch(url, {
        cache: "no-store"
    });
    const metaData = await metaResponse.json();
    // const settingsResponse = await fetch(settingsUrl, { cache: 'no-store' });
    // const settingsData = await settingsResponse.json();
    // // only one subclient for now
    // const subClients = settingsData?.subClients ?? [''];
    // const subClientPath = Object.keys(subClients[0])[0] || '';
    // const subClientSlug = Object.values(subClients[0])[0] || '';
    // const paymentResponse = await fetch(paymentUrl, { cache: 'no-store' });
    // const paymentData = await paymentResponse.json();
    if (metaResponse.errors) throw new Error(`Frontend config service meta request error`);
    // if (settingsResponse.errors) {
    //   throw new Error(`Frontend config service settings request error`);
    // }
    // if (paymentResponse.errors) {
    //   throw new Error(`Backend config service payment request error`);
    // }
    // Make sure useFakeData is false, unless it is specified as true in settings.json
    // const modifiedSettingsData = {
    //   useFakeData: false,
    //   ...settingsData,
    // };
    return {
        meta: metaData
    };
};
const initializeTenantEpic = (action$, state$)=>action$.ofType((0, _loginState.LOGIN_SUCCESS)).pipe(_operators.flatMap(()=>{
        const { client_slug } = (0, _state.getDecodedAccessToken)();
        const { configMetaEndpoint } = state$.value.config;
        return _rxjs.merge(_rxjs.of((0, _reducer.fetchTenantConfiguration)()), _rxjs.from(doTenantConfigurationHTTPCall(client_slug, configMetaEndpoint)).pipe(_operators.map((response)=>(0, _reducer.fetchTenantConfigurationSuccess)(response)), _operators.catchError((error)=>{
            return _rxjs.of((0, _reducer.fetchTenantConfigurationError)(_ramda.pathOr(error.message, [
                "response",
                "statusText"
            ], error)));
        })));
    }));
const fetchThemeFromConfigService = async (state)=>{
    const { configThemesEndpoint } = state.config;
    const url = `${configThemesEndpoint}/pos/theme.json`;
    const response = await fetch(url, {
        cache: "no-store"
    });
    return response;
};
const fetchThemeEpic = (_action$, state$)=>_rxjs.merge(_rxjs.of((0, _reducer.fetchTheme)()), _rxjs.from(fetchThemeFromConfigService(state$.value)).pipe(_operators.mergeMap((response)=>_rxjs.from(response.json())), _operators.map((body)=>(0, _reducer.fetchThemeSuccess)(body)), _operators.catchError((error)=>_rxjs.of((0, _reducer.fetchThemeError)(error)))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../reducer":"aTwKq","ramda":"JPp0Z","../../utils/state":"8UPqD","../../pages/login/Login.state":"eq6dI","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8UPqD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPosApiUrl", ()=>getPosApiUrl);
parcelHelpers.export(exports, "getAccessToken", ()=>getAccessToken);
parcelHelpers.export(exports, "getRefreshToken", ()=>getRefreshToken);
parcelHelpers.export(exports, "getTerminalSessionId", ()=>getTerminalSessionId);
parcelHelpers.export(exports, "getDecodedAccessToken", ()=>getDecodedAccessToken);
parcelHelpers.export(exports, "isTokenExpired", ()=>isTokenExpired);
parcelHelpers.export(exports, "clearLocalStorageSession", ()=>clearLocalStorageSession);
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _ramda = require("ramda");
var _constants = require("./constants");
const getPosApiUrl = (state)=>(0, _ramda.pathOr)("", [
        "config",
        "posApiUrl"
    ], state);
const getAccessToken = ()=>JSON.parse(localStorage.getItem("okta-token-storage"))?.accessToken?.accessToken ?? "";
const getRefreshToken = ()=>JSON.parse(localStorage.getItem("okta-token-storage"))?.refreshToken?.refreshToken ?? "";
const getTerminalSessionId = ()=>JSON.parse(localStorage.getItem("terminalSession"))?.terminalSession?.id ?? null;
const getDecodedAccessToken = ()=>{
    const token = getAccessToken();
    if (!token) return "";
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload);
};
const isTokenExpired = ()=>{
    const token = getDecodedAccessToken();
    if (!token) console.warn("%cWarning: No auth token found.", `background-color: ${(0, _constants.consoleWarningStyle)}`);
    const { exp: tokenExpirationTime } = token;
    const tokenExpDayJS = (0, _dayjsDefault.default).unix(tokenExpirationTime);
    const nowDayJS = (0, _dayjsDefault.default)();
    return nowDayJS.isAfter(tokenExpDayJS) ? true : false;
};
const clearLocalStorageSession = ()=>{
    localStorage.removeItem("terminalSession");
    localStorage.removeItem("session");
};

},{"dayjs":"4CsUp","ramda":"JPp0Z","./constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4E8nR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkScanMaxAttempts", ()=>checkScanMaxAttempts);
parcelHelpers.export(exports, "maxSecondsToInsertCard", ()=>maxSecondsToInsertCard);
parcelHelpers.export(exports, "maxSecondsToInsertCardDps", ()=>maxSecondsToInsertCardDps);
parcelHelpers.export(exports, "INITIATE_PAYMENT", ()=>INITIATE_PAYMENT);
parcelHelpers.export(exports, "initiatePayment", ()=>initiatePayment);
parcelHelpers.export(exports, "PAYMENT_SUCCESS", ()=>PAYMENT_SUCCESS);
parcelHelpers.export(exports, "paymentSuccess", ()=>paymentSuccess);
parcelHelpers.export(exports, "PAYMENT_ERROR", ()=>PAYMENT_ERROR);
parcelHelpers.export(exports, "paymentError", ()=>paymentError);
parcelHelpers.export(exports, "INITIATE_PAYLINK", ()=>INITIATE_PAYLINK);
parcelHelpers.export(exports, "initiatePayLink", ()=>initiatePayLink);
parcelHelpers.export(exports, "PAYLINK_SUCCESS", ()=>PAYLINK_SUCCESS);
parcelHelpers.export(exports, "paylinkSuccess", ()=>paylinkSuccess);
parcelHelpers.export(exports, "PAYLINK_ERROR", ()=>PAYLINK_ERROR);
parcelHelpers.export(exports, "paylinkError", ()=>paylinkError);
parcelHelpers.export(exports, "SET_INSERT_CHECK_TIME_REMAINING", ()=>SET_INSERT_CHECK_TIME_REMAINING);
parcelHelpers.export(exports, "setInsertCheckTimeRemaining", ()=>setInsertCheckTimeRemaining);
parcelHelpers.export(exports, "CANCEL_TRANSACTION_REQUEST", ()=>CANCEL_TRANSACTION_REQUEST);
parcelHelpers.export(exports, "cancelTransactionRequest", ()=>cancelTransactionRequest);
parcelHelpers.export(exports, "CANCEL_TRANSACTION_SUCCESS", ()=>CANCEL_TRANSACTION_SUCCESS);
parcelHelpers.export(exports, "cancelTransactionSuccess", ()=>cancelTransactionSuccess);
parcelHelpers.export(exports, "CANCEL_TRANSACTION_FAILURE", ()=>CANCEL_TRANSACTION_FAILURE);
parcelHelpers.export(exports, "cancelTransactionFailure", ()=>cancelTransactionFailure);
parcelHelpers.export(exports, "INITIATE_CHECK_SCAN", ()=>INITIATE_CHECK_SCAN);
parcelHelpers.export(exports, "initiateCheckScan", ()=>initiateCheckScan);
parcelHelpers.export(exports, "IS_POLLING_FOR_CHECK_RESPONSE", ()=>IS_POLLING_FOR_CHECK_RESPONSE);
parcelHelpers.export(exports, "isPollingForCheckResponse", ()=>isPollingForCheckResponse);
parcelHelpers.export(exports, "IS_CHECK_PROCESSING", ()=>IS_CHECK_PROCESSING);
parcelHelpers.export(exports, "isCheckProcessing", ()=>isCheckProcessing);
parcelHelpers.export(exports, "IS_POLLING_TIME_EXTENDED", ()=>IS_POLLING_TIME_EXTENDED);
parcelHelpers.export(exports, "isPollingTimeExtended", ()=>isPollingTimeExtended);
parcelHelpers.export(exports, "MAKE_CHECK_PAYMENT_ERROR", ()=>MAKE_CHECK_PAYMENT_ERROR);
parcelHelpers.export(exports, "makeCheckPaymentError", ()=>makeCheckPaymentError);
parcelHelpers.export(exports, "SET_CHECK_SCAN_FEEDBACK", ()=>SET_CHECK_SCAN_FEEDBACK);
parcelHelpers.export(exports, "setCheckScanFeedback", ()=>setCheckScanFeedback);
parcelHelpers.export(exports, "STOP_CHECK_SCAN_POLL", ()=>STOP_CHECK_SCAN_POLL);
parcelHelpers.export(exports, "stopCheckScanPoll", ()=>stopCheckScanPoll);
parcelHelpers.export(exports, "IS_AWAITING_CREDIT_CARD", ()=>IS_AWAITING_CREDIT_CARD);
parcelHelpers.export(exports, "isAwaitingCreditCard", ()=>isAwaitingCreditCard);
parcelHelpers.export(exports, "STOP_AWAITING_CREDIT_CARD", ()=>STOP_AWAITING_CREDIT_CARD);
parcelHelpers.export(exports, "stopAwaitingCreditCard", ()=>stopAwaitingCreditCard);
parcelHelpers.export(exports, "SET_CARD_PAYMENT_TYPE", ()=>SET_CARD_PAYMENT_TYPE);
parcelHelpers.export(exports, "setCardPaymentType", ()=>setCardPaymentType);
parcelHelpers.export(exports, "SET_AWAIT_CREDIT_CARD_TIME_REMAINING", ()=>SET_AWAIT_CREDIT_CARD_TIME_REMAINING);
parcelHelpers.export(exports, "setAwaitCreditCardTimeRemaining", ()=>setAwaitCreditCardTimeRemaining);
parcelHelpers.export(exports, "GET_SERVICE_FEE", ()=>GET_SERVICE_FEE);
parcelHelpers.export(exports, "getServiceFee", ()=>getServiceFee);
parcelHelpers.export(exports, "GET_SERVICE_FEE_SUCCESS", ()=>GET_SERVICE_FEE_SUCCESS);
parcelHelpers.export(exports, "getServiceFeeSuccess", ()=>getServiceFeeSuccess);
parcelHelpers.export(exports, "GET_SERVICE_FEE_FAILURE", ()=>GET_SERVICE_FEE_FAILURE);
parcelHelpers.export(exports, "getServiceFeeError", ()=>getServiceFeeError);
parcelHelpers.export(exports, "GET_CONVENIENCE_FEE", ()=>GET_CONVENIENCE_FEE);
parcelHelpers.export(exports, "getConvenienceFee", ()=>getConvenienceFee);
parcelHelpers.export(exports, "GET_CONVENIENCE_FEE_SUCCESS", ()=>GET_CONVENIENCE_FEE_SUCCESS);
parcelHelpers.export(exports, "getConvenienceFeeSuccess", ()=>getConvenienceFeeSuccess);
parcelHelpers.export(exports, "GET_CONVENIENCE_FEE_FAILURE", ()=>GET_CONVENIENCE_FEE_FAILURE);
parcelHelpers.export(exports, "getConvenienceFeeError", ()=>getConvenienceFeeError);
parcelHelpers.export(exports, "GET_PAYMENT_BY_ID", ()=>GET_PAYMENT_BY_ID);
parcelHelpers.export(exports, "initiateGetPaymentById", ()=>initiateGetPaymentById);
parcelHelpers.export(exports, "GET_PAYMENT_BY_ID_SUCCESS", ()=>GET_PAYMENT_BY_ID_SUCCESS);
parcelHelpers.export(exports, "getPaymentByIdSuccess", ()=>getPaymentByIdSuccess);
parcelHelpers.export(exports, "GET_PAYMENT_BY_ID_ERROR", ()=>GET_PAYMENT_BY_ID_ERROR);
parcelHelpers.export(exports, "getPaymentByIdError", ()=>getPaymentByIdError);
parcelHelpers.export(exports, "INITIATE_POST_VISIT", ()=>INITIATE_POST_VISIT);
parcelHelpers.export(exports, "initiatePostVisitId", ()=>initiatePostVisitId);
parcelHelpers.export(exports, "RETRY_INITIATE_POST_VISIT", ()=>RETRY_INITIATE_POST_VISIT);
parcelHelpers.export(exports, "retryInitiatePostVisitId", ()=>retryInitiatePostVisitId);
parcelHelpers.export(exports, "POST_VISIT_SUCCESS", ()=>POST_VISIT_SUCCESS);
parcelHelpers.export(exports, "postVisitIdSuccess", ()=>postVisitIdSuccess);
parcelHelpers.export(exports, "POST_VISIT_ERROR", ()=>POST_VISIT_ERROR);
parcelHelpers.export(exports, "postVisitIdError", ()=>postVisitIdError);
parcelHelpers.export(exports, "SET_PAYMENT_UNIQUE_IDENTIFIER", ()=>SET_PAYMENT_UNIQUE_IDENTIFIER);
parcelHelpers.export(exports, "setPaymentUniqueIdentifier", ()=>setPaymentUniqueIdentifier);
parcelHelpers.export(exports, "START_POLLING_FOR_CC_RESPONSE", ()=>START_POLLING_FOR_CC_RESPONSE);
parcelHelpers.export(exports, "startPollingForCCResponse", ()=>startPollingForCCResponse);
parcelHelpers.export(exports, "STOP_POLLING_FOR_CC_RESPONSE", ()=>STOP_POLLING_FOR_CC_RESPONSE);
parcelHelpers.export(exports, "stopPollingForCCResponse", ()=>stopPollingForCCResponse);
parcelHelpers.export(exports, "POLLING_CC_SUCCESS", ()=>POLLING_CC_SUCCESS);
parcelHelpers.export(exports, "pollingCCSuccess", ()=>pollingCCSuccess);
parcelHelpers.export(exports, "POLLING_CC_ERROR", ()=>POLLING_CC_ERROR);
parcelHelpers.export(exports, "pollingCCError", ()=>pollingCCError);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "checkoutAlertBarAction", ()=>checkoutAlertBarAction);
parcelHelpers.export(exports, "MODAL_ACTION", ()=>MODAL_ACTION);
parcelHelpers.export(exports, "checkoutModalAction", ()=>checkoutModalAction);
parcelHelpers.export(exports, "CARD_CHECKOUT_FORM_ACTION", ()=>CARD_CHECKOUT_FORM_ACTION);
parcelHelpers.export(exports, "cardCheckoutFormAction", ()=>cardCheckoutFormAction);
parcelHelpers.export(exports, "CHECK_CHECKOUT_FORM_ACTION", ()=>CHECK_CHECKOUT_FORM_ACTION);
parcelHelpers.export(exports, "checkCheckoutFormAction", ()=>checkCheckoutFormAction);
parcelHelpers.export(exports, "CASH_CHECKOUT_FORM_ACTION", ()=>CASH_CHECKOUT_FORM_ACTION);
parcelHelpers.export(exports, "cashCheckoutFormAction", ()=>cashCheckoutFormAction);
parcelHelpers.export(exports, "WIRE_PAYMENT_CHECKOUT_FORM_ACTION", ()=>WIRE_PAYMENT_CHECKOUT_FORM_ACTION);
parcelHelpers.export(exports, "wirePaymentCheckoutFormAction", ()=>wirePaymentCheckoutFormAction);
parcelHelpers.export(exports, "PAYLINK_CHECKOUT_FORM_ACTION", ()=>PAYLINK_CHECKOUT_FORM_ACTION);
parcelHelpers.export(exports, "paylinkCheckoutFormAction", ()=>paylinkCheckoutFormAction);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
var _modalState = require("../../components/modal/Modal.state");
var _ramda = require("ramda");
var _checkoutFormState = require("./CheckoutForm.state");
var _components = require("./components");
const checkScanMaxAttempts = 30;
const maxSecondsToInsertCard = 45;
const maxSecondsToInsertCardDps = 240;
/**
 * @typedef {Object} InitialState
 *
 * Check Payment State
 *
 * @property timeRemainingToInsertCheck: Controls the countdown modal timer state and is intended to mirror the check scanner hardware timeout.
 *
 * @property isPollingForCheckResponse: Awaiting check from user to be inserted.
 *
 * @property isCheckProcessing: Check has been accepted. Awaiting async backend and hardware operations.
 *
 * @property isPollingTimeExtended:
 * In the case where the user inserts a check between 0-10 seconds, the polled payment status may not update before the countdown times out.
 * Add an additional N seconds for processing and hardware delays.
 *
 * @property visitId:
 * Provided by Ghenghis. For Datacap (TranCloud) payments, this is passed as a parameter to CB_POS.
 * It is then used by Device Payment Service (DPS) to generate a payment_attempt_unique_identifier.
 * pos-frontend then uses this unique identifier when polling for Datacap (TranCloud) payment status updates.
 *
 * @todo Document remaining properties.
 */ const initialState = {
    error: false,
    isLoading: false,
    isPaymentError: false,
    isPaymentSuccess: false,
    isPayLinkError: false,
    isAwaitingCreditCard: false,
    cardPaymentType: null,
    timeRemainingToUseCard: maxSecondsToInsertCard,
    order: {},
    serviceFeeForCurrentAmount: null,
    convenienceFee: null,
    maxCardAmountAllowed: null,
    timeRemainingToInsertCheck: checkScanMaxAttempts,
    isPollingForCheckResponse: false,
    isCheckProcessing: false,
    isPollingTimeExtended: false,
    checkScanFeedback: null,
    visitId: null,
    isPollingForCCResponse: false,
    paymentAttemptUniqueId: null,
    isCancelingTransaction: false
};
const INITIATE_PAYMENT = "INITIATE_PAYMENT";
const initiatePayment = (data)=>{
    return {
        type: INITIATE_PAYMENT,
        payload: data
    };
};
const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
const paymentSuccess = (data)=>({
        type: PAYMENT_SUCCESS,
        payload: data
    });
const PAYMENT_ERROR = "PAYMENT_ERROR";
const paymentError = (data)=>({
        type: PAYMENT_ERROR,
        payload: data
    });
const INITIATE_PAYLINK = "INITIATE_PAYLINK";
const initiatePayLink = (data)=>{
    return {
        type: INITIATE_PAYLINK,
        payload: data
    };
};
const PAYLINK_SUCCESS = "PAYLINK_SUCCESS";
const paylinkSuccess = (data)=>({
        type: PAYLINK_SUCCESS,
        payload: data
    });
const PAYLINK_ERROR = "PAYLINK_ERROR";
const paylinkError = (data)=>({
        type: PAYMENT_ERROR,
        payload: data
    });
const SET_INSERT_CHECK_TIME_REMAINING = "SET_INSERT_CHECK_TIME_REMAINING";
const setInsertCheckTimeRemaining = (timeRemaining)=>{
    return {
        type: SET_INSERT_CHECK_TIME_REMAINING,
        payload: timeRemaining
    };
};
const CANCEL_TRANSACTION_REQUEST = "CANCEL_TRANSACTION_REQUEST";
const cancelTransactionRequest = (data)=>{
    return {
        type: CANCEL_TRANSACTION_REQUEST,
        payload: data
    };
};
const CANCEL_TRANSACTION_SUCCESS = "CANCEL_TRANSACTION_SUCCESS";
const cancelTransactionSuccess = ()=>{
    return {
        type: CANCEL_TRANSACTION_SUCCESS
    };
};
const CANCEL_TRANSACTION_FAILURE = "CANCEL_TRANSACTION_FAILURE";
const cancelTransactionFailure = ()=>{
    return {
        type: CANCEL_TRANSACTION_FAILURE
    };
};
const INITIATE_CHECK_SCAN = "INITIATE_CHECK_SCAN";
const initiateCheckScan = (data)=>{
    return {
        type: INITIATE_CHECK_SCAN,
        payload: data
    };
};
const IS_POLLING_FOR_CHECK_RESPONSE = "IS_POLLING_FOR_CHECK_RESPONSE";
const isPollingForCheckResponse = (data)=>{
    return {
        type: IS_POLLING_FOR_CHECK_RESPONSE,
        payload: data
    };
};
const IS_CHECK_PROCESSING = "IS_CHECK_PROCESSING";
const isCheckProcessing = (bool)=>{
    return {
        type: IS_CHECK_PROCESSING,
        payload: bool
    };
};
const IS_POLLING_TIME_EXTENDED = "IS_POLLING_TIME_EXTENDED";
const isPollingTimeExtended = (bool)=>{
    return {
        type: IS_POLLING_TIME_EXTENDED,
        payload: bool
    };
};
const MAKE_CHECK_PAYMENT_ERROR = "MAKE_CHECK_PAYMENT_ERROR";
const makeCheckPaymentError = (data)=>{
    return {
        type: MAKE_CHECK_PAYMENT_ERROR,
        payload: data
    };
};
const SET_CHECK_SCAN_FEEDBACK = "SET_CHECK_SCAN_FEEDBACK";
const setCheckScanFeedback = (message)=>{
    return {
        type: SET_CHECK_SCAN_FEEDBACK,
        payload: message
    };
};
const STOP_CHECK_SCAN_POLL = "STOP_CHECK_SCAN_POLL";
const stopCheckScanPoll = ()=>{
    return {
        type: STOP_CHECK_SCAN_POLL
    };
};
const IS_AWAITING_CREDIT_CARD = "IS_AWAITING_CREDIT_CARD";
const isAwaitingCreditCard = (cardPaymentType)=>{
    return {
        type: IS_AWAITING_CREDIT_CARD,
        payload: cardPaymentType
    };
};
const STOP_AWAITING_CREDIT_CARD = "STOP_AWAITING_CREDIT_CARD";
const stopAwaitingCreditCard = ()=>{
    return {
        type: STOP_AWAITING_CREDIT_CARD
    };
};
const SET_CARD_PAYMENT_TYPE = "SET_CARD_PAYMENT_TYPE";
const setCardPaymentType = (cardPaymentType)=>{
    return {
        type: SET_CARD_PAYMENT_TYPE,
        payload: cardPaymentType
    };
};
const SET_AWAIT_CREDIT_CARD_TIME_REMAINING = "SET_AWAIT_CREDIT_CARD_TIME_REMAINING";
const setAwaitCreditCardTimeRemaining = (timeRemaining)=>{
    return {
        type: SET_AWAIT_CREDIT_CARD_TIME_REMAINING,
        payload: timeRemaining
    };
};
const GET_SERVICE_FEE = "GET_SERVICE_FEE";
const getServiceFee = (amount)=>{
    return {
        type: GET_SERVICE_FEE,
        payload: amount
    };
};
const GET_SERVICE_FEE_SUCCESS = "GET_SERVICE_FEE_SUCCESS";
const getServiceFeeSuccess = (data)=>({
        type: GET_SERVICE_FEE_SUCCESS,
        payload: data
    });
const GET_SERVICE_FEE_FAILURE = "GET_SERVICE_FEE_FAILURE";
const getServiceFeeError = (data)=>({
        type: GET_SERVICE_FEE_FAILURE,
        payload: data
    });
const GET_CONVENIENCE_FEE = "GET_CONVENIENCE_FEE";
const getConvenienceFee = (data)=>{
    return {
        type: GET_CONVENIENCE_FEE,
        payload: data
    };
};
const GET_CONVENIENCE_FEE_SUCCESS = "GET_CONVENIENCE_FEE_SUCCESS";
const getConvenienceFeeSuccess = (data)=>({
        type: GET_CONVENIENCE_FEE_SUCCESS,
        payload: data
    });
const GET_CONVENIENCE_FEE_FAILURE = "GET_CONVENIENCE_FEE_FAILURE";
const getConvenienceFeeError = (data)=>({
        type: GET_CONVENIENCE_FEE_FAILURE,
        payload: data
    });
const GET_PAYMENT_BY_ID = "GET_PAYMENT_BY_ID";
const initiateGetPaymentById = ()=>{
    return {
        type: GET_PAYMENT_BY_ID
    };
};
const GET_PAYMENT_BY_ID_SUCCESS = "GET_PAYMENT_BY_ID_SUCCESS";
const getPaymentByIdSuccess = (data)=>{
    return {
        type: GET_PAYMENT_BY_ID_SUCCESS,
        payload: data
    };
};
const GET_PAYMENT_BY_ID_ERROR = "GET_PAYMENT_BY_ID_ERROR";
const getPaymentByIdError = (data)=>{
    return {
        type: GET_PAYMENT_BY_ID_ERROR,
        payload: data
    };
};
const INITIATE_POST_VISIT = "INITIATE_POST_VISIT";
const initiatePostVisitId = ({ order_id })=>({
        type: INITIATE_POST_VISIT,
        payload: order_id
    });
const RETRY_INITIATE_POST_VISIT = "RETRY_INITIATE_POST_VISIT";
const retryInitiatePostVisitId = ({ order_id, retryNumber })=>({
        type: RETRY_INITIATE_POST_VISIT,
        payload: {
            order_id,
            retryNumber
        }
    });
const POST_VISIT_SUCCESS = "POST_VISIT_SUCCESS";
const postVisitIdSuccess = (data)=>({
        type: POST_VISIT_SUCCESS,
        payload: data
    });
const POST_VISIT_ERROR = "POST_VISIT_ERROR";
const postVisitIdError = (data)=>({
        type: POST_VISIT_ERROR,
        payload: data
    });
const SET_PAYMENT_UNIQUE_IDENTIFIER = "SET_PAYMENT_UNIQUE_IDENTIFIER";
const setPaymentUniqueIdentifier = ({ paymentAttemptUniqueId })=>{
    return {
        type: SET_PAYMENT_UNIQUE_IDENTIFIER,
        payload: {
            paymentAttemptUniqueId
        }
    };
};
const START_POLLING_FOR_CC_RESPONSE = "START_POLLING_FOR_CC_RESPONSE";
const startPollingForCCResponse = ({ navigate, location })=>{
    return {
        type: START_POLLING_FOR_CC_RESPONSE,
        payload: {
            navigate,
            location
        }
    };
};
const STOP_POLLING_FOR_CC_RESPONSE = "STOP_POLLING_FOR_CC_RESPONSE";
const stopPollingForCCResponse = ()=>{
    return {
        type: STOP_POLLING_FOR_CC_RESPONSE
    };
};
const POLLING_CC_SUCCESS = "POLLING_CC_SUCCESS";
const pollingCCSuccess = ()=>{
    return {
        type: POLLING_CC_SUCCESS
    };
};
const POLLING_CC_ERROR = "POLLING_CC_ERROR";
const pollingCCError = ()=>{
    return {
        type: POLLING_CC_ERROR
    };
};
const ALERT_BAR_ACTION = "checkout/ALERT_BAR_ACTION";
const checkoutAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const MODAL_ACTION = "checkout/MODAL_ACTION";
const checkoutModalAction = _nested.nestedAction(MODAL_ACTION);
const CARD_CHECKOUT_FORM_ACTION = "checkout/CARD_CHECKOUT_FORM_ACTION";
const cardCheckoutFormAction = _nested.nestedAction(CARD_CHECKOUT_FORM_ACTION);
const CHECK_CHECKOUT_FORM_ACTION = "checkout/CHECK_CHECKOUT_FORM_ACTION";
const checkCheckoutFormAction = _nested.nestedAction(CHECK_CHECKOUT_FORM_ACTION);
const CASH_CHECKOUT_FORM_ACTION = "checkout/CASH_CHECKOUT_FORM_ACTION";
const cashCheckoutFormAction = _nested.nestedAction(CASH_CHECKOUT_FORM_ACTION);
const WIRE_PAYMENT_CHECKOUT_FORM_ACTION = "checkout/WIRE_PAYMENT_CHECKOUT_FORM_ACTION";
const wirePaymentCheckoutFormAction = _nested.nestedAction(WIRE_PAYMENT_CHECKOUT_FORM_ACTION);
const PAYLINK_CHECKOUT_FORM_ACTION = "checkout/PAYLINK_CHECKOUT_FORM_ACTION";
const paylinkCheckoutFormAction = _nested.nestedAction(PAYLINK_CHECKOUT_FORM_ACTION);
const _reducer = (state = initialState, { type, payload } = action)=>{
    switch(type){
        case POST_VISIT_SUCCESS:
            return {
                ...state,
                visitId: payload.visit_id,
                isPollingForCCResponse: false
            };
        case INITIATE_PAYMENT:
            return {
                ...state,
                isLoading: true
            };
        case PAYMENT_SUCCESS:
            return {
                ...state,
                isPaymentSuccess: true,
                isLoading: false
            };
        case PAYMENT_ERROR:
            return {
                ...state,
                isPaymentError: true,
                isLoading: false
            };
        case INITIATE_PAYLINK:
            return {
                ...state,
                isLoading: true
            };
        case PAYLINK_SUCCESS:
            return {
                ...state,
                isPayLinkError: false,
                isLoading: false
            };
        case PAYLINK_ERROR:
            return {
                ...state,
                isPayLinkError: true,
                isLoading: false
            };
        case CANCEL_TRANSACTION_REQUEST:
            return {
                ...state,
                isLoading: false,
                isCancelingTransaction: true
            };
        case CANCEL_TRANSACTION_SUCCESS:
            return {
                ...state,
                isCancelingTransaction: false
            };
        case CANCEL_TRANSACTION_FAILURE:
            return {
                ...state,
                isCancelingTransaction: false
            };
        case INITIATE_CHECK_SCAN:
            return {
                ...state,
                isPollingForCheckResponse: true
            };
        case IS_POLLING_FOR_CHECK_RESPONSE:
            return {
                ...state,
                isPollingForCheckResponse: payload.isPollingForCheckResponse
            };
        case IS_CHECK_PROCESSING:
            return {
                ...state,
                isCheckProcessing: payload
            };
        case IS_POLLING_TIME_EXTENDED:
            return {
                ...state,
                isPollingTimeExtended: payload
            };
        case SET_CHECK_SCAN_FEEDBACK:
            return {
                ...state,
                checkScanFeedback: payload
            };
        case SET_CARD_PAYMENT_TYPE:
            return {
                ...state,
                cardPaymentType: payload
            };
        case IS_AWAITING_CREDIT_CARD:
            return {
                ...state,
                isAwaitingCreditCard: true,
                cardPaymentType: payload
            };
        case STOP_AWAITING_CREDIT_CARD:
            return {
                ...state,
                isAwaitingCreditCard: false
            };
        case SET_AWAIT_CREDIT_CARD_TIME_REMAINING:
            return {
                ...state,
                timeRemainingToUseCard: payload
            };
        case MAKE_CHECK_PAYMENT_ERROR:
            return {
                ...state,
                isPaymentError: true,
                isCheckProcessing: false,
                isPollingTimeExtended: false
            };
        case SET_INSERT_CHECK_TIME_REMAINING:
            return {
                ...state,
                timeRemainingToInsertCheck: payload
            };
        case GET_PAYMENT_BY_ID_ERROR:
            // success is handled in checkScanPollingEpic
            return {
                ...state,
                isPaymentError: true,
                isCheckProcessing: false,
                isPollingForCheckResponse: false,
                isPollingTimeExtended: false
            };
        case STOP_CHECK_SCAN_POLL:
            return {
                ...state,
                isPollingForCheckResponse: false,
                isCheckProcessing: false,
                isPollingTimeExtended: false,
                timeRemainingToInsertCheck: initialState.timeRemainingToInsertCheck
            };
        case GET_SERVICE_FEE:
            return {
                ...state,
                isLoading: true
            };
        case GET_SERVICE_FEE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                serviceFeeForCurrentAmount: payload.service_fee
            };
        case GET_SERVICE_FEE_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case GET_CONVENIENCE_FEE:
            return {
                ...state,
                isLoading: true
            };
        case GET_CONVENIENCE_FEE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                convenienceFee: payload.convenience_fee,
                maxCardAmountAllowed: payload.max_card_amount_allowed
            };
        case GET_CONVENIENCE_FEE_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case SET_PAYMENT_UNIQUE_IDENTIFIER:
            return {
                ...state,
                paymentAttemptUniqueId: payload.paymentAttemptUniqueId
            };
        case START_POLLING_FOR_CC_RESPONSE:
            return {
                ...state,
                isPollingForCCResponse: true
            };
        case STOP_POLLING_FOR_CC_RESPONSE:
            return {
                ...state,
                isPollingForCCResponse: false,
                timeRemainingToUseCard: maxSecondsToInsertCardDps,
                paymentAttemptUniqueId: initialState.paymentAttemptUniqueId,
                isCancelingTransaction: false
            };
        case POLLING_CC_SUCCESS:
            return {
                ...state,
                isPollingForCCResponse: false,
                isPaymentError: false,
                timeRemainingToUseCard: maxSecondsToInsertCardDps,
                paymentAttemptUniqueId: initialState.paymentAttemptUniqueId
            };
        case POLLING_CC_ERROR:
            return {
                ...state,
                isPaymentError: true
            };
        case POST_VISIT_ERROR:
            return {
                ...state,
                isPollingForCCResponse: false
            };
        default:
            return state;
    }
};
const noCreditCardReaderAlertMessage = {
    heading: "Device Error",
    text: "No credit card reader associated with this terminal",
    variant: "error"
};
const _mapStateToProps = (state)=>{
    if (state.cart != {}) return {
        ...state.cart,
        ...state.terminalLogin.terminalSession,
        remainingBalance: _ramda.pathOr((0, _checkoutFormState.DEFAULT_PAYMENT_VALUE), [
            "cart",
            "order",
            "remaining_balance"
        ], state)
    };
};
const _mapDispatchToProps = (dispatch)=>({
        makePayment: (data)=>dispatch(initiatePayment(data)),
        cancelTransaction: (data)=>dispatch(cancelTransactionRequest(data)),
        displayCreditCardReaderAlert: ()=>dispatch(checkoutAlertBarAction((0, _alertBarState.replaceAlerts)(noCreditCardReaderAlertMessage)))
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    forms: {
        cardCheckoutForm: {
            ...(0, _components.CardCheckoutForm),
            actionType: CARD_CHECKOUT_FORM_ACTION
        },
        checkCheckoutForm: {
            ...(0, _components.CheckCheckoutForm),
            actionType: CHECK_CHECKOUT_FORM_ACTION
        },
        cashCheckoutForm: {
            ...(0, _components.CashCheckoutForm),
            actionType: CASH_CHECKOUT_FORM_ACTION
        },
        wirePaymentCheckoutForm: {
            ...(0, _components.WirePaymentCheckoutForm),
            actionType: WIRE_PAYMENT_CHECKOUT_FORM_ACTION
        },
        paylinkCheckoutForm: {
            ...(0, _components.PayLinkCheckoutForm),
            actionType: PAYLINK_CHECKOUT_FORM_ACTION
        }
    },
    modals: {
        checkoutModal: {
            ..._modalState,
            actionType: MODAL_ACTION
        }
    },
    alertBars: {
        checkoutAlertBars: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    }
}, "checkout");
// Nested Reducer
const reducer = (state, action1)=>nestedReducer(state, action1);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","../../components/modal/Modal.state":"34xap","ramda":"JPp0Z","./CheckoutForm.state":"jc6Er","./components":"lB8nt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"34xap":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "openModal", ()=>openModal);
parcelHelpers.export(exports, "closeModal", ()=>closeModal);
parcelHelpers.export(exports, "toggleModal", ()=>toggleModal);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
const OPEN_MODAL = "OPEN_MODAL";
const openModal = (modalId)=>({
        type: OPEN_MODAL,
        payload: modalId
    });
const CLOSE_MODAL = "CLOSE_MODAL";
const closeModal = ()=>({
        type: CLOSE_MODAL
    });
const TOGGLE_MODAL = "TOGGLE_MODAL";
const toggleModal = ()=>({
        type: TOGGLE_MODAL
    });
const initialState = {
    modalIsOpen: false,
    modalId: null
};
const reducer = (state = initialState, { type, payload })=>{
    switch(type){
        case OPEN_MODAL:
            return {
                modalIsOpen: true,
                modalId: payload
            };
        case CLOSE_MODAL:
            return {
                modalIsOpen: false,
                content: null,
                modalId: null
            };
        case TOGGLE_MODAL:
            return {
                ...state,
                modalIsOpen: !state.modalIsOpen
            };
        default:
            return state;
    }
};
const mapStateToProps = (state)=>state;
const mapDispatchToProps = (dispatch)=>({
        openModal: (modalId)=>dispatch(openModal(modalId)),
        closeModal: ()=>dispatch(closeModal()),
        toggleModal: ()=>dispatch(toggleModal())
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jc6Er":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_PAYMENT_VALUE", ()=>DEFAULT_PAYMENT_VALUE);
parcelHelpers.export(exports, "cardReducer", ()=>cardReducer);
parcelHelpers.export(exports, "cardMapStateToProps", ()=>cardMapStateToProps);
parcelHelpers.export(exports, "cardMapDispatchToProps", ()=>cardMapDispatchToProps);
parcelHelpers.export(exports, "cashReducer", ()=>cashReducer);
parcelHelpers.export(exports, "cashMapStateToProps", ()=>cashMapStateToProps);
parcelHelpers.export(exports, "cashMapDispatchToProps", ()=>cashMapDispatchToProps);
parcelHelpers.export(exports, "checkReducer", ()=>checkReducer);
parcelHelpers.export(exports, "checkMapStateToProps", ()=>checkMapStateToProps);
parcelHelpers.export(exports, "checkMapDispatchToProps", ()=>checkMapDispatchToProps);
parcelHelpers.export(exports, "wireReducer", ()=>wireReducer);
parcelHelpers.export(exports, "wireMapStateToProps", ()=>wireMapStateToProps);
parcelHelpers.export(exports, "wireMapDispatchToProps", ()=>wireMapDispatchToProps);
parcelHelpers.export(exports, "paylinkReducer", ()=>paylinkReducer);
parcelHelpers.export(exports, "paylinkMapStateToProps", ()=>paylinkMapStateToProps);
parcelHelpers.export(exports, "paylinkMapDispatchToProps", ()=>paylinkMapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
var _constants = require("../../utils/constants");
const DEFAULT_PAYMENT_VALUE = "";
const creditCardFormConfig = {
    amount: {
        defaultValue: DEFAULT_PAYMENT_VALUE,
        validators: [
            (0, _reduxFreeform.required)(),
            (0, _reduxFreeform.numberGreaterThan)(0)
        ]
    },
    submission_type: {
        defaultValue: "Card reader",
        validators: []
    },
    first_name: {
        defaultValue: "",
        validators: []
    },
    last_name: {
        defaultValue: "",
        validators: []
    },
    number: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.hasLength)(13, 16), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.onlyIntegers)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type")
        ]
    },
    month: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.hasLength)(2, 2), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.onlyIntegers)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type")
        ]
    },
    year: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.hasLength)(4, 4), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.onlyIntegers)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type")
        ]
    },
    cvv: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.hasLength)(3, 4), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.onlyIntegers)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type")
        ]
    },
    zipcode: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.numberGreaterThanOrEqualTo)(5), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type")
        ]
    }
};
const cashFormConfig = {
    amount: {
        defaultValue: DEFAULT_PAYMENT_VALUE,
        validators: [
            (0, _reduxFreeform.required)(),
            (0, _reduxFreeform.numberGreaterThan)(0)
        ]
    },
    first_name: {
        defaultValue: "",
        validators: []
    },
    last_name: {
        defaultValue: "",
        validators: []
    },
    payment_delivery_type: {
        defaultValue: "in_person",
        validators: [
            (0, _reduxFreeform.required)()
        ]
    }
};
const checkFormConfig = {
    amount: {
        defaultValue: DEFAULT_PAYMENT_VALUE,
        validators: [
            (0, _reduxFreeform.required)(),
            (0, _reduxFreeform.numberGreaterThan)(0)
        ]
    },
    first_name: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    last_name: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    check_type: {
        defaultValue: (0, _constants.CHECK_TYPE).PERSONAL,
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    account_type: {
        defaultValue: "Checking",
        validators: [
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)("Manual entry", "submission_type"))
        ]
    },
    submission_type: {
        defaultValue: "Check reader",
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    company_name: {
        defaultValue: "",
        validators: []
    },
    check_number: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.hasLength)(3, 15), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type")
        ]
    },
    routing_number: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.isAmericanOrCanadianRoutingNumber)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type")
        ]
    },
    account_number: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                "Manual entry"
            ]), "submission_type")
        ]
    }
};
const wireFormConfig = {
    amount: {
        defaultValue: DEFAULT_PAYMENT_VALUE,
        validators: [
            (0, _reduxFreeform.required)(),
            (0, _reduxFreeform.numberGreaterThan)(0)
        ]
    },
    name: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    effectiveDate: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    description: {
        defaultValue: "",
        validators: []
    }
};
const paylinkFormConfig = {
    amount: {
        defaultValue: DEFAULT_PAYMENT_VALUE,
        validators: [
            (0, _reduxFreeform.required)(),
            (0, _reduxFreeform.numberGreaterThan)(0)
        ]
    },
    emailPayLinkCheckbox: {},
    emailAddress: {
        validators: [
            // includedIn[true] will only apply validation if the related checkbox field is checked (true)
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                true
            ]), "emailPayLinkCheckbox"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.isProbablyEmail)(), (0, _reduxFreeform.includedIn)([
                true
            ]), "emailPayLinkCheckbox")
        ]
    },
    textPayLinkCheckbox: {},
    phoneNumber: {
        validators: [
            // includedIn[true] will only apply validation if the related checkbox field is checked (true)
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                true
            ]), "textPayLinkCheckbox"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.hasLength)(10, 10), (0, _reduxFreeform.includedIn)([
                true
            ]), "textPayLinkCheckbox")
        ],
        constraints: [
            (0, _reduxFreeform.hasLength)(0, 10),
            (0, _reduxFreeform.onlyIntegers)()
        ]
    }
};
const { reducer: cardReducer, mapStateToProps: cardMapStateToProps, mapDispatchToProps: cardMapDispatchToProps } = (0, _reduxFreeform.createFormState)(creditCardFormConfig);
const { reducer: cashReducer, mapStateToProps: cashMapStateToProps, mapDispatchToProps: cashMapDispatchToProps } = (0, _reduxFreeform.createFormState)(cashFormConfig);
const { reducer: checkReducer, mapStateToProps: checkMapStateToProps, mapDispatchToProps: checkMapDispatchToProps } = (0, _reduxFreeform.createFormState)(checkFormConfig);
const { reducer: wireReducer, mapStateToProps: wireMapStateToProps, mapDispatchToProps: wireMapDispatchToProps } = (0, _reduxFreeform.createFormState)(wireFormConfig);
const { reducer: paylinkReducer, mapStateToProps: paylinkMapStateToProps, mapDispatchToProps: paylinkMapDispatchToProps } = (0, _reduxFreeform.createFormState)(paylinkFormConfig);

},{"redux-freeform":"1Yc5v","../../utils/constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lB8nt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardCheckoutForm", ()=>(0, _cardCheckoutFormDefault.default));
parcelHelpers.export(exports, "CheckCheckoutForm", ()=>(0, _checkCheckoutFormDefault.default));
parcelHelpers.export(exports, "CashCheckoutForm", ()=>(0, _cashCheckoutFormDefault.default));
parcelHelpers.export(exports, "PayLinkCheckoutForm", ()=>(0, _payLinkCheckoutFormDefault.default));
parcelHelpers.export(exports, "WirePaymentCheckoutForm", ()=>(0, _wirePaymentCheckoutFormDefault.default));
var _cardCheckoutForm = require("./CardCheckoutForm");
var _cardCheckoutFormDefault = parcelHelpers.interopDefault(_cardCheckoutForm);
var _checkCheckoutForm = require("./CheckCheckoutForm");
var _checkCheckoutFormDefault = parcelHelpers.interopDefault(_checkCheckoutForm);
var _cashCheckoutForm = require("./CashCheckoutForm");
var _cashCheckoutFormDefault = parcelHelpers.interopDefault(_cashCheckoutForm);
var _payLinkCheckoutForm = require("./PayLinkCheckoutForm");
var _payLinkCheckoutFormDefault = parcelHelpers.interopDefault(_payLinkCheckoutForm);
var _wirePaymentCheckoutForm = require("./WirePaymentCheckoutForm");
var _wirePaymentCheckoutFormDefault = parcelHelpers.interopDefault(_wirePaymentCheckoutForm);

},{"./CardCheckoutForm":"1O5XP","./CheckCheckoutForm":"b6IqT","./CashCheckoutForm":"jpLsM","./PayLinkCheckoutForm":"itIOY","./WirePaymentCheckoutForm":"6hw3k","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1O5XP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxFreeform = require("redux-freeform");
var _launchdarklyReactClientSdk = require("launchdarkly-react-client-sdk");
var _components = require("@thecb/components");
var _helpers = require("../../../utils/helpers");
var _checkoutFormState = require("../CheckoutForm.state");
var _reactRedux = require("react-redux");
var _checkoutState = require("../Checkout.state");
var _productsState = require("../../products/Products.state");
var _checkout = require("../Checkout");
var _constants = require("../../../utils/constants");
var _reactRouterDom = require("react-router-dom");
var _styled = require("../../../components/styled");
var _sharedConstants = require("./shared-constants");
const cardSubmissionTypeRadioGroupConfig = [
    {
        id: "card-reader",
        value: "Card reader",
        labelText: "Card Reader"
    },
    {
        id: "manual-entry",
        value: "Manual entry",
        labelText: "Manual Entry"
    }
];
const cardNumberErrors = {
    [(0, _reduxFreeform.onlyIntegers).error]: "Must only contain numbers",
    [(0, _reduxFreeform.required).error]: "Card Number is required",
    [(0, _reduxFreeform.hasLength).error]: "Must be between 13-16 digits"
};
const expMonthErrors = {
    [(0, _reduxFreeform.onlyIntegers).error]: "Must only contain numbers",
    [(0, _reduxFreeform.required).error]: "Expiration Month is required",
    [(0, _reduxFreeform.hasLength).error]: "Must be two digits"
};
const expYearErrors = {
    [(0, _reduxFreeform.onlyIntegers).error]: "Must only contain numbers",
    [(0, _reduxFreeform.required).error]: "Expiration Year is required",
    [(0, _reduxFreeform.hasLength).error]: "Must be four digits"
};
const cvvErrors = {
    [(0, _reduxFreeform.onlyIntegers).error]: "Must only contain numbers",
    [(0, _reduxFreeform.required).error]: "CVV is required",
    [(0, _reduxFreeform.hasLength).error]: "Must be 3 or 4 digits"
};
const zipcodeErrors = {
    [(0, _reduxFreeform.onlyIntegers).error]: "Must only contain numbers",
    [(0, _reduxFreeform.required).error]: "Zip code is required",
    [(0, _reduxFreeform.numberGreaterThanOrEqualTo).error]: "Must be at least 5 digits"
};
let CardCheckoutForm = ({ actions, fields, openProcessingModal, makePayment, creditCardReaderType, displayCreditCardReaderAlert, remainingBalance, processBtnText, splitTenderAllowed })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const flags = (0, _launchdarklyReactClientSdk.useFlags)();
    const [isTyping, setIsTyping] = (0, _react.useState)(false);
    const [errors, handleErrors] = (0, _react.useState)(false);
    const isDatacap = creditCardReaderType === (0, _constants.CC_READER_TYPE).TRANCLOUD || creditCardReaderType === (0, _constants.CC_READER_TYPE).DC_DIRECT;
    const isManualEntrySelected = fields.submission_type.rawValue === "Manual entry";
    const enable_manual_card_entry = (0, _reactRedux.useSelector)((state)=>state.terminalLogin?.locations?.selectedLocation?.enable_manual_card_entry);
    const agency_id = (0, _reactRedux.useSelector)((state)=>state.cart?.order?.agencies ? state.cart?.order?.agencies[0]?.id : null);
    const agencies = (0, _reactRedux.useSelector)((state)=>state.products?.agencies?.data);
    const agency = agencies.find((agency)=>agency.id === agency_id);
    const service_fee_percentage = agency?.agency_fee_config?.service_fee_percentage;
    const minimum_service_fee = agency?.agency_fee_config?.minimum_service_fee;
    const { isLoading: isLoadingCheckout, serviceFeeForCurrentAmount, visitId, isPollingForCCResponse, convenienceFee, maxCardAmountAllowed } = (0, _reactRedux.useSelector)((state)=>state.checkout);
    const { fetching: isLoadingCart } = (0, _reactRedux.useSelector)((state)=>state.cart);
    const { payerNameRequired } = (0, _reactRedux.useSelector)((state)=>state.shared.clientConfig);
    const isLoading = isLoadingCheckout || isLoadingCart;
    (0, _react.useEffect)(()=>{
        dispatch((0, _productsState.fetchAgencies)());
    }, []);
    (0, _react.useEffect)(()=>{
        if (payerNameRequired || isManualEntrySelected) {
            actions.fields.first_name.addValidator((0, _reduxFreeform.required)());
            actions.fields.last_name.addValidator((0, _reduxFreeform.required)());
        }
        if (!payerNameRequired && !isManualEntrySelected) {
            actions.fields.first_name.removeValidator((0, _reduxFreeform.required)());
            actions.fields.last_name.removeValidator((0, _reduxFreeform.required)());
        }
    }, [
        payerNameRequired,
        isManualEntrySelected
    ]);
    (0, _react.useEffect)(()=>{
        if (remainingBalance) {
            if (service_fee_percentage) dispatch((0, _checkoutState.getServiceFee)({
                amount: remainingBalance
            }));
            actions.fields.amount.set((0, _helpers.formatCurrencyInput)(remainingBalance));
        }
    }, [
        remainingBalance,
        service_fee_percentage
    ]);
    (0, _react.useEffect)(()=>{
        if (agency_id) dispatch((0, _checkoutState.getConvenienceFee)({
            agency_id: agency_id
        }));
    }, [
        agency_id
    ]);
    (0, _react.useEffect)(()=>{
        actions.fields.amount.removeValidator((0, _reduxFreeform.numberLessThanOrEqualTo)());
        if (maxCardAmountAllowed > 0) actions.fields.amount.addValidator((0, _reduxFreeform.numberLessThanOrEqualTo)(maxCardAmountAllowed));
    }, [
        maxCardAmountAllowed
    ]);
    const requestServiceFee = (0, _helpers.debounce)((amount)=>{
        if (Number(amount) >= 0) dispatch((0, _checkoutState.getServiceFee)({
            amount
        }));
        setIsTyping(false);
    }, 500);
    const debounceServiceFeeRequest = (0, _react.useCallback)((amount)=>{
        requestServiceFee(amount);
    }, []);
    const handleCardSubmit = (cardPaymentType)=>(0, _components.util).general.generateClickHandler({
            fields
        }, ()=>handleErrors(true), ()=>{
            switch(creditCardReaderType){
                case (0, _constants.CC_READER_TYPE).DC_DIRECT:
                case (0, _constants.CC_READER_TYPE).TRANCLOUD:
                    if (flags["pay-with-device-payment-service"]) {
                        dispatch((0, _checkoutState.setAwaitCreditCardTimeRemaining)((0, _checkoutState.maxSecondsToInsertCardDps)));
                        dispatch((0, _checkoutState.setCardPaymentType)(cardPaymentType));
                    } else {
                        dispatch((0, _checkoutState.setAwaitCreditCardTimeRemaining)((0, _checkoutState.maxSecondsToInsertCard)));
                        dispatch((0, _checkoutState.isAwaitingCreditCard)(cardPaymentType));
                    }
                    openProcessingModal((0, _checkout.CARD_COUNTDOWN_MODAL));
                    makePayment({
                        amount_given: Number(fields.amount.rawValue),
                        ...cardPaymentType === (0, _constants.CARD_PAYMENT_TYPES).MANUAL && {
                            acct_no: "Prompt"
                        },
                        ...payerNameRequired && {
                            first_name: fields.first_name.rawValue,
                            last_name: fields.last_name.rawValue
                        },
                        payment_tender_type: (0, _constants.CARD),
                        service_fee: serviceFeeForCurrentAmount,
                        convenience_fee: convenienceFee,
                        navigate,
                        location,
                        cc_reader_type: creditCardReaderType,
                        visit_id: visitId
                    });
                    break;
                case (0, _constants.CC_READER_TYPE).MAGTEK:
                    if (enable_manual_card_entry && cardPaymentType === (0, _constants.CARD_PAYMENT_TYPES).MANUAL) makePayment({
                        amount_given: Number(fields.amount.rawValue),
                        service_fee: serviceFeeForCurrentAmount,
                        convenience_fee: convenienceFee,
                        first_name: fields.first_name.rawValue,
                        last_name: fields.last_name.rawValue,
                        number: fields.number.rawValue,
                        month: fields.month.rawValue,
                        year: fields.year.rawValue,
                        cvv: fields.cvv.rawValue,
                        zipcode: fields.zipcode.rawValue,
                        payment_tender_type: (0, _constants.CARD),
                        manual_entry: true,
                        navigate,
                        location,
                        cc_reader_type: (0, _constants.CC_READER_TYPE).MAGTEK
                    });
                    else openProcessingModal((0, _checkout.MAGTEK_SWIPE_CARD_MODAL));
                    break;
                default:
                    displayCreditCardReaderAlert();
                    break;
            }
        });
    (0, _sharedConstants.paymentAmountErrors)[(0, _reduxFreeform.numberLessThanOrEqualTo).error] = `The maximum allowed amount for card payment is ${(0, _helpers.formatPrice)(Number(maxCardAmountAllowed))}`;
    const amountOverMaxCardAmount = maxCardAmountAllowed > 0 && parseFloat(fields.amount.rawValue) > maxCardAmountAllowed;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormContainer), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                disabled: !splitTenderAllowed,
                onKeyDown: (e)=>{
                    if (service_fee_percentage) {
                        const isNumber = e.key !== " " && isFinite(e.key);
                        const ALLOWABLE_KEYS = [
                            "Enter",
                            "Backspace",
                            "."
                        ];
                        if (!isTyping && (ALLOWABLE_KEYS.includes(e.key) || isNumber)) setIsTyping(true);
                    }
                },
                onKeyUp: ()=>{
                    if (service_fee_percentage) debounceServiceFeeRequest(fields.amount.rawValue || 0);
                },
                id: "card-payment-amt",
                type: "number",
                labelTextWhenNoError: "Payment Amount",
                errorMessages: (0, _sharedConstants.paymentAmountErrors),
                field: fields.amount,
                errors: fields.errors,
                fieldActions: actions.fields.amount,
                labelTextVariant: "p",
                errorTextVariant: "p"
            }),
            enable_manual_card_entry && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.RadioGroup), {
                field: fields.submission_type,
                fieldActions: actions.fields.submission_type,
                groupName: "submission-type",
                headingText: "Submission Type",
                headingFontSize: "1rem",
                config: cardSubmissionTypeRadioGroupConfig,
                extraStyles: `margin-bottom: 8px;`
            }),
            (payerNameRequired || isManualEntrySelected) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styled.HalfWidthFieldWrapper), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        id: "card-first-name",
                        labelTextWhenNoError: "First Name",
                        errorMessages: (0, _sharedConstants.requireErrors)("First Name is required"),
                        field: fields.first_name,
                        showErrors: errors,
                        fieldActions: actions.fields.first_name,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        id: "card-last-name",
                        labelTextWhenNoError: "Last Name",
                        errorMessages: (0, _sharedConstants.requireErrors)("Last Name is required"),
                        field: fields.last_name,
                        showErrors: errors,
                        fieldActions: actions.fields.last_name,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    })
                ]
            }),
            isManualEntrySelected && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        id: "card-number",
                        labelTextWhenNoError: "Card Number",
                        errorMessages: cardNumberErrors,
                        field: fields.number,
                        showErrors: errors,
                        fieldActions: actions.fields.number,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styled.HalfWidthFieldWrapper), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                id: "exp_month",
                                labelTextWhenNoError: "Expiration Month (MM)",
                                errorMessages: expMonthErrors,
                                field: fields.month,
                                showErrors: errors,
                                fieldActions: actions.fields.month,
                                labelTextVariant: "p",
                                errorTextVariant: "p"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                id: "exp_year",
                                labelTextWhenNoError: "Expiration Year (YYYY)",
                                errorMessages: expYearErrors,
                                field: fields.year,
                                showErrors: errors,
                                fieldActions: actions.fields.year,
                                labelTextVariant: "p",
                                errorTextVariant: "p"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styled.HalfWidthFieldWrapper), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                id: "cvv",
                                labelTextWhenNoError: "CVV",
                                errorMessages: cvvErrors,
                                field: fields.cvv,
                                showErrors: errors,
                                fieldActions: actions.fields.cvv,
                                labelTextVariant: "p",
                                errorTextVariant: "p"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                id: "zipcode",
                                labelTextWhenNoError: "Zip code",
                                errorMessages: zipcodeErrors,
                                field: fields.zipcode,
                                showErrors: errors,
                                fieldActions: actions.fields.zipcode,
                                labelTextVariant: "p",
                                errorTextVariant: "p"
                            })
                        ]
                    })
                ]
            }),
            service_fee_percentage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Alert), {
                heading: "Service Fee",
                showQuitLink: false,
                extraStyles: `margin-bottom: 0.875rem;`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                    id: "service-fee-alert-text",
                    children: `There is a service fee of ${parseFloat(service_fee_percentage).toFixed(2)}% ${minimum_service_fee ? `or ${(0, _helpers.formatPrice)(minimum_service_fee)} minimum` : ""} for all card payments. The fee for this transaction is ${!serviceFeeForCurrentAmount || isLoading || isTyping ? "..." : `${(0, _helpers.formatPrice)(serviceFeeForCurrentAmount)}.`}`
                })
            }),
            !!convenienceFee && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Alert), {
                heading: "Transaction Fee",
                showQuitLink: false,
                extraStyles: `margin-bottom: 0.875rem;`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                    id: "convenience-fee-alert-text",
                    children: `The fee for this transaction is $${parseFloat(convenienceFee).toFixed(2)}.`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        text: "Back to Cart",
                        variant: "secondary",
                        dataQa: "view-cart",
                        action: ()=>navigate("/pos/cart"),
                        extraStyles: "margin-left: 0",
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    isDatacap && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        text: "Manual Card Entry",
                        action: (e)=>handleCardSubmit((0, _constants.CARD_PAYMENT_TYPES).MANUAL)(e),
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        id: "process-card-btn",
                        textExtraStyles: "font-size: 1rem;",
                        disabled: isLoading || isTyping || fields.amount.rawValue <= 0 || fields.amount.hasErrors || isPollingForCCResponse || amountOverMaxCardAmount,
                        isLoading: isLoading || isTyping,
                        text: processBtnText,
                        action: (e)=>handleCardSubmit(isManualEntrySelected ? (0, _constants.CARD_PAYMENT_TYPES).MANUAL : (0, _constants.CARD_PAYMENT_TYPES).AUTOMATIC)(e)
                    })
                ]
            })
        ]
    });
};
CardCheckoutForm.reducer = (0, _checkoutFormState.cardReducer);
CardCheckoutForm.mapStateToProps = (0, _checkoutFormState.cardMapStateToProps);
CardCheckoutForm.mapDispatchToProps = (0, _checkoutFormState.cardMapDispatchToProps);
exports.default = CardCheckoutForm;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","redux-freeform":"1Yc5v","launchdarkly-react-client-sdk":"3xmjG","@thecb/components":"g98ma","../../../utils/helpers":"epomp","../CheckoutForm.state":"jc6Er","react-redux":"k6jol","../Checkout.state":"4E8nR","../../products/Products.state":"9SdM7","../Checkout":"tL9YH","../../../utils/constants":"f3A1R","react-router-dom":"hNarb","../../../components/styled":"uxYqN","./shared-constants":"3rfTN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9SdM7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FETCH_LOOKUP_BY_ID", ()=>FETCH_LOOKUP_BY_ID);
parcelHelpers.export(exports, "fetchLookupById", ()=>fetchLookupById);
parcelHelpers.export(exports, "FETCH_SEARCH_BY_ID", ()=>FETCH_SEARCH_BY_ID);
parcelHelpers.export(exports, "fetchSearchById", ()=>fetchSearchById);
parcelHelpers.export(exports, "FETCH_LOOKUP_BY_ID_SUCCESS", ()=>FETCH_LOOKUP_BY_ID_SUCCESS);
parcelHelpers.export(exports, "fetchLookupByIdSuccess", ()=>fetchLookupByIdSuccess);
parcelHelpers.export(exports, "FETCH_SEARCH_BY_ID_SUCCESS", ()=>FETCH_SEARCH_BY_ID_SUCCESS);
parcelHelpers.export(exports, "fetchSearchByIdSuccess", ()=>fetchSearchByIdSuccess);
parcelHelpers.export(exports, "FETCH_PRODUCTS", ()=>FETCH_PRODUCTS);
parcelHelpers.export(exports, "fetchProducts", ()=>fetchProducts);
parcelHelpers.export(exports, "FETCH_AGENCIES", ()=>FETCH_AGENCIES);
parcelHelpers.export(exports, "fetchAgencies", ()=>fetchAgencies);
parcelHelpers.export(exports, "FETCH_PRODUCTS_SUCCESS", ()=>FETCH_PRODUCTS_SUCCESS);
parcelHelpers.export(exports, "fetchProductsSuccess", ()=>fetchProductsSuccess);
parcelHelpers.export(exports, "FETCH_AGENCIES_SUCCESS", ()=>FETCH_AGENCIES_SUCCESS);
parcelHelpers.export(exports, "fetchAgenciesSuccess", ()=>fetchAgenciesSuccess);
parcelHelpers.export(exports, "FETCH_LOOKUP_BY_ID_FAILURE", ()=>FETCH_LOOKUP_BY_ID_FAILURE);
parcelHelpers.export(exports, "fetchLookupByIdFailure", ()=>fetchLookupByIdFailure);
parcelHelpers.export(exports, "FETCH_SEARCH_BY_ID_FAILURE", ()=>FETCH_SEARCH_BY_ID_FAILURE);
parcelHelpers.export(exports, "fetchSearchByIdFailure", ()=>fetchSearchByIdFailure);
parcelHelpers.export(exports, "FETCH_PRODUCTS_FAILURE", ()=>FETCH_PRODUCTS_FAILURE);
parcelHelpers.export(exports, "fetchProductsFailure", ()=>fetchProductsFailure);
parcelHelpers.export(exports, "FETCH_AGENCIES_FAILURE", ()=>FETCH_AGENCIES_FAILURE);
parcelHelpers.export(exports, "fetchAgenciesFailure", ()=>fetchAgenciesFailure);
parcelHelpers.export(exports, "CLEAR_CURRENT_PRODUCT", ()=>CLEAR_CURRENT_PRODUCT);
parcelHelpers.export(exports, "clearCurrentProduct", ()=>clearCurrentProduct);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "productsAlertBarAction", ()=>productsAlertBarAction);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
var _ramda = require("ramda");
const initialState = {
    error: false,
    products: {
        data: [],
        fetching: false
    },
    agencies: {
        data: [],
        fetching: false
    },
    currentProduct: {
        form_data: {},
        product_data: {},
        required_fields: [],
        transforms: {},
        fetching: false
    }
};
const FETCH_LOOKUP_BY_ID = "products/FETCH_LOOKUP_BY_ID";
const fetchLookupById = (id)=>({
        type: FETCH_LOOKUP_BY_ID,
        payload: id
    });
const FETCH_SEARCH_BY_ID = "products/FETCH_SEARCH_BY_ID";
const fetchSearchById = (id)=>({
        type: FETCH_SEARCH_BY_ID,
        payload: id
    });
const FETCH_LOOKUP_BY_ID_SUCCESS = "products/FETCH_LOOKUP_BY_ID_SUCCESS";
const fetchLookupByIdSuccess = (data)=>({
        type: FETCH_LOOKUP_BY_ID_SUCCESS,
        payload: data
    });
const FETCH_SEARCH_BY_ID_SUCCESS = "products/FETCH_SEARCH_BY_ID_SUCCESS";
const fetchSearchByIdSuccess = (data)=>({
        type: FETCH_SEARCH_BY_ID_SUCCESS,
        payload: data
    });
const FETCH_PRODUCTS = "products/FETCH_PRODUCTS";
const fetchProducts = ()=>({
        type: FETCH_PRODUCTS
    });
const FETCH_AGENCIES = "agencies/FETCH_AGENCIES";
const fetchAgencies = ()=>({
        type: FETCH_AGENCIES
    });
const FETCH_PRODUCTS_SUCCESS = "products/FETCH_PRODUCTS_SUCCESS";
const fetchProductsSuccess = (data)=>({
        type: FETCH_PRODUCTS_SUCCESS,
        payload: data
    });
const FETCH_AGENCIES_SUCCESS = "agencies/FETCH_AGENCIES_SUCCESS";
const fetchAgenciesSuccess = (data)=>({
        type: FETCH_AGENCIES_SUCCESS,
        payload: data
    });
const FETCH_LOOKUP_BY_ID_FAILURE = "products/FETCH_LOOKUP_BY_ID_FAILURE";
const fetchLookupByIdFailure = ()=>({
        type: FETCH_LOOKUP_BY_ID_FAILURE
    });
const FETCH_SEARCH_BY_ID_FAILURE = "products/FETCH_SEARCH_BY_ID_FAILURE";
const fetchSearchByIdFailure = ()=>({
        type: FETCH_SEARCH_BY_ID_FAILURE
    });
const FETCH_PRODUCTS_FAILURE = "products/FETCH_PRODUCTS_FAILURE";
const fetchProductsFailure = ()=>({
        type: FETCH_PRODUCTS_FAILURE
    });
const FETCH_AGENCIES_FAILURE = "agencies/FETCH_AGENCIES_FAILURE";
const fetchAgenciesFailure = ()=>({
        type: FETCH_AGENCIES_FAILURE
    });
const CLEAR_CURRENT_PRODUCT = "CLEAR_CURRENT_PRODUCT";
const clearCurrentProduct = ()=>({
        type: CLEAR_CURRENT_PRODUCT
    });
const _reducer = (state = initialState, { type, payload })=>{
    switch(type){
        case FETCH_LOOKUP_BY_ID:
            // Use the object in a comment by the real object for a PoC of the item options
            // enhancements w/o the backend
            return {
                ...state,
                currentProduct: {
                    ...state.currentProduct,
                    fetching: true
                }
            };
        case FETCH_SEARCH_BY_ID:
            return {
                ...state,
                currentProduct: {
                    ...state.currentProduct,
                    fetching: true
                }
            };
        case FETCH_PRODUCTS:
            return {
                ...state,
                products: {
                    ...state.products,
                    fetching: true
                }
            };
        case FETCH_AGENCIES:
            return {
                ...state,
                agencies: {
                    ...state.agencies,
                    fetching: true
                }
            };
        case FETCH_LOOKUP_BY_ID_SUCCESS:
            // Use the object in a comment by the real object for a PoC of the item options
            // enhancements w/o the backend
            return {
                ...state,
                currentProduct: {
                    ...payload,
                    fetching: false
                }
            };
        case FETCH_SEARCH_BY_ID_SUCCESS:
            return {
                ...state,
                currentProduct: {
                    ...payload,
                    fetching: false
                }
            };
        case CLEAR_CURRENT_PRODUCT:
            return {
                ...state,
                currentProduct: initialState.currentProduct
            };
        case FETCH_PRODUCTS_SUCCESS:
            return {
                ...state,
                products: {
                    ...payload,
                    fetching: false
                }
            };
        case FETCH_AGENCIES_SUCCESS:
            return {
                ...state,
                agencies: {
                    ...payload,
                    fetching: false
                }
            };
        case FETCH_LOOKUP_BY_ID_FAILURE:
            return {
                ...state,
                currentProduct: {
                    ...state.products,
                    fetching: false
                },
                error: true
            };
        case FETCH_SEARCH_BY_ID_FAILURE:
            return {
                ...state,
                currentProduct: {
                    ...state.products,
                    fetching: false
                },
                error: true
            };
        case FETCH_PRODUCTS_FAILURE:
            return {
                ...state,
                products: {
                    ...state.products,
                    fetching: false
                }
            };
        case FETCH_AGENCIES_FAILURE:
            return {
                ...state,
                agencies: {
                    ...state.agencies,
                    fetching: false
                }
            };
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>{
    const currentAgencyInCart = _ramda.pathOr("", "cart", "order", "status", state) == "completed" ? null : _ramda.pathOr("", [
        "cart",
        "order",
        "agencies",
        0,
        "id"
    ], state);
    return {
        currentProduct: state.products.currentProduct,
        products: state.products.products,
        agencies: state.products.agencies,
        currentAgencyInCart: currentAgencyInCart
    };
};
const _mapDispatchToProps = (dispatch)=>({
        fetchProducts: ()=>dispatch(fetchProducts()),
        fetchAgencies: ()=>dispatch(fetchAgencies()),
        clearCurrentProduct: ()=>dispatch(clearCurrentProduct())
    });
const ALERT_BAR_ACTION = "products/ALERT_BAR_ACTION";
const productsAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    alertBars: {
        productsAlertBar: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    }
}, "products");
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","ramda":"JPp0Z","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"tL9YH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROCESSING_MODAL", ()=>PROCESSING_MODAL);
parcelHelpers.export(exports, "CARD_COUNTDOWN_MODAL", ()=>CARD_COUNTDOWN_MODAL);
parcelHelpers.export(exports, "MAGTEK_SWIPE_CARD_MODAL", ()=>MAGTEK_SWIPE_CARD_MODAL);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxFreeform = require("redux-freeform");
var _launchdarklyReactClientSdk = require("launchdarkly-react-client-sdk");
var _components = require("@thecb/components");
var _cartSidebar = require("../../components/cart-sidebar");
var _cartSidebarDefault = parcelHelpers.interopDefault(_cartSidebar);
var _components1 = require("./components");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _reactRedux = require("react-redux");
var _sharedAlertBar = require("../../components/alert-bar/SharedAlertBar");
var _sharedAlertBarDefault = parcelHelpers.interopDefault(_sharedAlertBar);
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _magtekSwipeCardModal = require("./MagtekSwipeCardModal");
var _magtekSwipeCardModalDefault = parcelHelpers.interopDefault(_magtekSwipeCardModal);
var _helpers = require("../../utils/helpers");
var _constants = require("../../utils/constants");
var _usePostVisitId = require("../../utils/hooks/usePostVisitId");
var _usePostVisitIdDefault = parcelHelpers.interopDefault(_usePostVisitId);
const PROCESSING_MODAL = "PROCESSING_MODAL";
const CARD_COUNTDOWN_MODAL = "CARD_COUNTDOWN_MODAL";
const MAGTEK_SWIPE_CARD_MODAL = "MAGTEK_SWIPE_CARD_MODAL";
const Header = ({ alertBar, alertBarActions })=>{
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    const alertRef = (0, _react.useRef)(null);
    // Scroll the alert into view whenever a new alert appears (e.g. a payment
    // error) so it isn't left off-screen when the user is scrolled down by the
    // process button. Applies to all tender types since the alert bar is shared.
    (0, _react.useEffect)(()=>{
        if (alertBar.alerts.length === 0) return;
        const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
        // Defer to the next task so the scroll runs after the modal teardown and
        // its focus restoration, which otherwise scrolls the page back down to the
        // process button before our scroll would take effect.
        const id = setTimeout(()=>{
            alertRef.current?.scrollIntoView({
                behavior: prefersReducedMotion ? "auto" : "smooth",
                block: "center"
            });
        }, 0);
        return ()=>clearTimeout(id);
    }, [
        alertBar.alerts
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    ref: alertRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "16px 0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                            ...alertBar,
                            ...alertBarActions
                        })
                    })
                }),
                sharedAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharedAlertBarDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Checkout"
                })
            ]
        })
    });
};
const Checkout = ({ actions, forms, alertBars, modals, makePayment, order, cancelTransaction, credit_card_reader_type, displayCreditCardReaderAlert, remainingBalance })=>{
    const flags = (0, _launchdarklyReactClientSdk.useFlags)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _usePostVisitIdDefault.default)(order, dispatch);
    const cardActions = actions.forms.cardCheckoutForm.actions;
    const cardFields = forms.cardCheckoutForm.fields;
    const checkActions = actions.forms.checkCheckoutForm.actions;
    const checkFields = forms.checkCheckoutForm.fields;
    const cashActions = actions.forms.cashCheckoutForm.actions;
    const cashFields = forms.cashCheckoutForm.fields;
    const wireActions = actions.forms.wirePaymentCheckoutForm.actions;
    const wireFields = forms.wirePaymentCheckoutForm.fields;
    const paylinkActions = actions.forms.paylinkCheckoutForm.actions;
    const paylinkFields = forms.paylinkCheckoutForm.fields;
    const { fetching, order: { total: orderTotal, checkout_settings } } = (0, _reactRedux.useSelector)((state)=>state.cart);
    const { serviceFeeForCurrentAmount, convenienceFee, cardPaymentType } = (0, _reactRedux.useSelector)((state)=>state.checkout);
    const { isPollingForCheckResponse, isCheckProcessing, isPollingTimeExtended, timeRemainingToInsertCheck, timeRemainingToUseCard, isCancelingTransaction, checkScanFeedback } = (0, _reactRedux.useSelector)((state)=>state.checkout);
    const cashSplitTenderAllowed = checkout_settings?.payment_tender_types?.cash?.split_tender_enabled;
    const checkSplitTenderAllowed = checkout_settings?.payment_tender_types?.check?.split_tender_enabled;
    const cardSplitTenderAllowed = checkout_settings?.payment_tender_types?.card?.split_tender_enabled;
    const wireSplitTenderAllowed = checkout_settings?.payment_tender_types?.wire_payment?.split_tender_enabled;
    (0, _react.useEffect)(()=>{
        return ()=>{
            // Reset all child form states when Checkout is unmounted
            cardActions.form.clear();
            checkActions.form.clear();
            cashActions.form.clear();
            wireActions.form.clear();
            paylinkActions.form.clear();
        };
    }, []);
    (0, _react.useEffect)(()=>{
        if (!fetching && orderTotal && !cashSplitTenderAllowed) cashActions.fields.amount.addValidator((0, _reduxFreeform.numberGreaterThanOrEqualTo)(orderTotal));
        return ()=>{
            if (cashFields.amount.validators.map((v)=>v.type).includes("validator/NUMBER_GREATER_THAN")) // Clean up `numberGreaterThanOrEqualTo` validator if it exists
            cashActions.fields.amount.removeValidator((0, _reduxFreeform.numberGreaterThanOrEqualTo)(orderTotal));
        };
    }, [
        fetching,
        orderTotal,
        cashSplitTenderAllowed
    ]);
    const processBtnText = (fields, isCreditTabSelected)=>(0, _react.useMemo)(()=>`Process ${isCreditTabSelected ? (0, _helpers.formatPrice)(Number(fields?.amount?.rawValue) + Number(serviceFeeForCurrentAmount ?? 0) + Number(convenienceFee ?? 0)) : (0, _helpers.formatPrice)(Number(fields?.amount?.rawValue))}`, [
            fields?.amount?.rawValue,
            serviceFeeForCurrentAmount,
            convenienceFee
        ]);
    const handleCancelTransaction = ()=>{
        cancelTransaction();
        if (!flags["pay-with-device-payment-service"]) actions.modals.checkoutModal.closeModal();
    };
    const cardEnabled = checkout_settings?.payment_tender_types?.card?.enabled;
    const checkEnabled = checkout_settings?.payment_tender_types?.check?.enabled;
    const cashEnabled = checkout_settings?.payment_tender_types?.cash?.enabled;
    const wireEnabled = checkout_settings?.payment_tender_types?.wire_payment?.enabled;
    const isPayLinkEnabled = order?.order_items?.length > 0 && order.order_items.every((item)=>item?.paylink_enabled === true);
    const cardCheckoutFormComponent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components1.CardCheckoutForm), {
        actions: cardActions,
        fields: cardFields,
        openProcessingModal: (modal)=>actions.modals.checkoutModal.openModal(modal),
        makePayment: makePayment,
        creditCardReaderType: credit_card_reader_type,
        displayCreditCardReaderAlert: displayCreditCardReaderAlert,
        remainingBalance: remainingBalance,
        processBtnText: processBtnText(cardFields, true),
        splitTenderAllowed: cardSplitTenderAllowed
    });
    const checkCheckoutFormComponent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components1.CheckCheckoutForm), {
        actions: checkActions,
        fields: checkFields,
        openProcessingModal: (modal)=>actions.modals.checkoutModal.openModal(modal),
        makePayment: makePayment,
        remainingBalance: remainingBalance,
        processBtnText: processBtnText(checkFields),
        splitTenderAllowed: checkSplitTenderAllowed
    });
    const cashCheckoutFormComponent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components1.CashCheckoutForm), {
        actions: cashActions,
        fields: cashFields,
        makePayment: makePayment,
        remainingBalance: remainingBalance,
        processBtnText: processBtnText(cashFields),
        splitTenderAllowed: cashSplitTenderAllowed
    });
    const wireCheckoutFormComponent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components1.WirePaymentCheckoutForm), {
        actions: wireActions,
        fields: wireFields,
        makePayment: makePayment,
        remainingBalance: remainingBalance,
        processBtnText: processBtnText(wireFields),
        splitTenderAllowed: wireSplitTenderAllowed
    });
    const paylinkCheckoutFormComponent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components1.PayLinkCheckoutForm), {
        actions: paylinkActions,
        fields: paylinkFields,
        forms: forms,
        remainingBalance: remainingBalance,
        processBtnText: "Send PayLink",
        order: order
    });
    const tabsConfig = {
        tabs: [
            cardEnabled && {
                label: "Credit Card",
                content: cardCheckoutFormComponent
            },
            checkEnabled && {
                label: "Check",
                content: checkCheckoutFormComponent
            },
            cashEnabled && {
                label: "Cash",
                content: cashCheckoutFormComponent
            },
            wireEnabled && {
                label: "Wire Transfer",
                content: wireCheckoutFormComponent
            },
            isPayLinkEnabled && {
                label: "PayLink",
                active: true,
                content: paylinkCheckoutFormComponent
            }
        ].filter(Boolean)
    };
    const getCheckModalHeaderText = ()=>isCheckProcessing || isPollingTimeExtended ? "Processing Check" : isPollingForCheckResponse ? "Awaiting Check" : null;
    const getCheckModalBodyText = ()=>isCheckProcessing || isPollingTimeExtended ? "" : isPollingForCheckResponse ? `Please insert the check. This window will close in ${(0, _dayjsDefault.default)().startOf("day").add(timeRemainingToInsertCheck, "second").format("mm:ss").slice(1)} ${timeRemainingToInsertCheck === 1 ? "second" : "seconds"}.` : null;
    const modalHeaderText = getCheckModalHeaderText();
    const modalBodyText = getCheckModalBodyText();
    const body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: ".5rem 0 1.5rem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
            background: (0, _components.constants).colors.WHITE,
            variant: "baseStandard",
            padding: "0",
            borderRadius: "0.25rem",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
                    noButtons: true,
                    modalHeaderText: modalHeaderText,
                    defaultWrapper: false,
                    modalOpen: isPollingForCheckResponse || isCheckProcessing,
                    modalBodyText: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
                        intrinsic: true,
                        tabIndex: 0,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                padding: "0",
                                extraStyles: "margin-bottom: 32px",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                    children: modalBodyText
                                })
                            }),
                            checkScanFeedback && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                padding: "12px 16px",
                                extraStyles: "margin-bottom: 32px",
                                background: (0, _components.constants).colors.HAWKES_BLUE,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                    extraStyles: "white-space: pre-line",
                                    children: checkScanFeedback
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                                size: "100"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
                    modalHeaderText: "Awaiting Card",
                    defaultWrapper: false,
                    onlyCloseButton: true,
                    modalOpen: modals.checkoutModal.modalIsOpen && modals.checkoutModal.modalId === CARD_COUNTDOWN_MODAL,
                    hideModal: handleCancelTransaction,
                    onExit: ()=>(0, _components.util).general.noop,
                    closeButtonText: "Cancel",
                    isCloseActionDisabled: isCancelingTransaction && flags["pay-with-device-payment-service"],
                    modalBodyText: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                justify: "center",
                                childGap: "4px",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                        children: cardPaymentType === (0, _constants.CARD_PAYMENT_TYPES).AUTOMATIC ? "Please have customer insert/swipe/tap the card within 1 minute." : "Please follow the instructions on the credit card terminal. You must start within 1 minute."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                        children: `This window will close in ${(0, _dayjsDefault.default)().startOf("day").add(timeRemainingToUseCard, "second").format("mm:ss").slice(1)}.`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                padding: "24px 0px 0px 0px",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                                    size: "100"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
                    modalHeaderText: "Processing",
                    defaultWrapper: false,
                    onlyCloseButton: true,
                    modalOpen: modals.checkoutModal.modalIsOpen && modals.checkoutModal.modalId === PROCESSING_MODAL,
                    hideModal: handleCancelTransaction,
                    onExit: ()=>(0, _components.util).general.noop,
                    closeButtonText: "Cancel",
                    modalBodyText: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                        intrinsic: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                                size: "100"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _magtekSwipeCardModalDefault.default), {
                    fields: cardFields,
                    modals: modals,
                    actions: actions,
                    credit_card_reader_type: credit_card_reader_type
                }),
                !order.order_id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "1.5rem",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                        size: "100"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Tabs), {
                    tabsConfig: tabsConfig,
                    extraStyles: `
          .tab-list-item:first-child { border-top-left-radius: 0.25rem }
          .tab-list-item:last-child { border-top-right-radius: 0.25rem }
        `
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SidebarSingleContent), {
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.checkoutAlertBars,
            alertBarActions: actions.alertBars.checkoutAlertBars
        }, "CheckoutHeader"),
        mainContent: body,
        sidebarContent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartSidebarDefault.default), {}),
        sidebarTargetWidth: "27.429rem",
        sidebarWrapperMaxWidth: "85.714rem",
        sidebarOnRight: true,
        childGap: "0.5rem"
    });
};
exports.default = Checkout;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","redux-freeform":"1Yc5v","launchdarkly-react-client-sdk":"3xmjG","@thecb/components":"g98ma","../../components/cart-sidebar":"l8jjH","./components":"lB8nt","../../components/alert-bar":"aD416","react-redux":"k6jol","../../components/alert-bar/SharedAlertBar":"gk2Ni","dayjs":"4CsUp","./MagtekSwipeCardModal":"baGdo","../../utils/helpers":"epomp","../../utils/constants":"f3A1R","../../utils/hooks/usePostVisitId":"cec0Q","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l8jjH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _cartSidebar = require("./CartSidebar");
var _cartSidebarState = require("./CartSidebar.state");
exports.default = (0, _reactRedux.connect)((0, _cartSidebarState.mapStateToProps))((0, _cartSidebar.CartSidebar));

},{"react-redux":"k6jol","./CartSidebar":"bGm0t","./CartSidebar.state":"5HCzl","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bGm0t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartSidebar", ()=>CartSidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reactRedux = require("react-redux");
var _constants = require("../../utils/constants");
var _cartState = require("../../pages/cart/Cart.state");
var _reactRouterDom = require("react-router-dom");
var _paymentDetails = require("../payment-details");
var _paymentDetailsDefault = parcelHelpers.interopDefault(_paymentDetails);
var _helpers = require("../../utils/helpers");
const CartSidebar = ({ orderItems, isLoading })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const location = (0, _reactRouterDom.useLocation)();
    const centsMultiplier = 100;
    const lineItems = orderItems.map((item)=>({
            amount: item.recorded_subtotal * centsMultiplier,
            description: item.receivable_category,
            quantity: item.quantity,
            subDescription: item.external_attributes?.description,
            is_negative_amount: item.is_negative_amount
        }));
    const { transaction_details = [], remaining_balance, total } = (0, _reactRedux.useSelector)((state)=>state.cart).order;
    const { creditCardReaderType } = (0, _reactRedux.useSelector)((state)=>state.shared.clientConfig);
    const { order } = (0, _reactRedux.useSelector)((state)=>state.cart);
    const createVoidText = (transaction)=>{
        switch(transaction.payment_type){
            case (0, _constants.PAYMENT_TYPE).CASH_PAYMENT:
                return "Cash";
            case (0, _constants.PAYMENT_TYPE).CARD_PAYMENT:
                return `Card ending in ${transaction.credit_card.last_four}`;
            case (0, _constants.PAYMENT_TYPE).CHECK_PAYMENT:
                return `Account ending in ${transaction.bank_account.account_number_last_four}`;
        }
    };
    const successfulTransactions = transaction_details.filter((t)=>t.status === (0, _constants.TRANSACTION_STATUS).SUCCESSFUL || t.status === (0, _constants.TRANSACTION_STATUS).CANCEL_PENDING);
    const voidableTransactions = successfulTransactions.filter((t)=>t.status !== (0, _constants.TRANSACTION_STATUS).CANCEL_PENDING);
    const successfulTransactionsWithVoidText = voidableTransactions.map((t)=>({
            ...t,
            amount_given: t.amount_given * centsMultiplier,
            amount_processed: t.amount_processed * centsMultiplier,
            voidText: createVoidText(t)
        }));
    const amtPaid = successfulTransactions.reduce((acc, cur)=>acc += cur.amount_processed * centsMultiplier, 0);
    const totalServiceFees = successfulTransactions.reduce((acc, cur)=>acc += cur.service_fee * centsMultiplier, 0);
    const totalConvenienceFees = successfulTransactions.reduce((acc, cur)=>acc += cur.convenience_fee * centsMultiplier, 0);
    const isAtCartRoute = location.pathname === `/pos/cart`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: ".5rem 0",
        id: "cart-sidebar",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
            background: (0, _components.constants).colors.WHITE,
            variant: "baseStandard",
            padding: "0",
            borderRadius: "0.25rem",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "1.5rem",
                    children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                        size: "100"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentDetailsDefault.default), {
                        subtotal: false,
                        total: total * centsMultiplier,
                        lineItems: lineItems,
                        fees: [],
                        isMobile: !!lineItems.length,
                        collapsibleOnMobile: !!lineItems.length,
                        hideTitle: false,
                        voidableTransactionDetails: successfulTransactionsWithVoidText,
                        hasVoidablePaymentsSection: !!successfulTransactionsWithVoidText.length && order.status === (0, _constants.ORDER_STATUS).INCOMPLETE,
                        partialVoidAction: (transaction)=>dispatch((0, _cartState.initiateVoidTransactionById)({
                                id: transaction.id,
                                isDatacapTransaction: (0, _helpers.isDatacapTransaction)(transaction.payment_tender_type, creditCardReaderType),
                                payment_attempt_unique_identifier: transaction.payment_attempt_unique_identifier
                            })),
                        voidableAmountPaid: amtPaid,
                        remainingBalance: remaining_balance * centsMultiplier,
                        serviceFees: totalServiceFees,
                        convenienceFees: totalConvenienceFees
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                !isAtCartRoute && Boolean(lineItems.length) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                        extraStyles: `width: 100%;`,
                        text: "View Cart",
                        url: "/pos/cart",
                        isLoading: false,
                        variant: "secondary",
                        dataQa: "view-cart",
                        textExtraStyles: "font-size: 1rem;"
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","react-redux":"k6jol","../../utils/constants":"f3A1R","../../pages/cart/Cart.state":"bgoZn","react-router-dom":"hNarb","../payment-details":"9G1FW","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bgoZn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_ORDER_REQUEST", ()=>GET_ORDER_REQUEST);
parcelHelpers.export(exports, "getOrderRequest", ()=>getOrderRequest);
parcelHelpers.export(exports, "GET_ORDER_SUCCESS", ()=>GET_ORDER_SUCCESS);
parcelHelpers.export(exports, "getOrderSuccess", ()=>getOrderSuccess);
parcelHelpers.export(exports, "GET_ORDER_ERROR", ()=>GET_ORDER_ERROR);
parcelHelpers.export(exports, "getOrderError", ()=>getOrderError);
parcelHelpers.export(exports, "CLEAR_CART", ()=>CLEAR_CART);
parcelHelpers.export(exports, "clearCart", ()=>clearCart);
parcelHelpers.export(exports, "GET_UPDATED_CART_REQUEST", ()=>GET_UPDATED_CART_REQUEST);
parcelHelpers.export(exports, "getUpdatedCartRequest", ()=>getUpdatedCartRequest);
parcelHelpers.export(exports, "GET_UPDATED_CART_SUCCESS", ()=>GET_UPDATED_CART_SUCCESS);
parcelHelpers.export(exports, "getUpdatedCartSuccess", ()=>getUpdatedCartSuccess);
parcelHelpers.export(exports, "GET_UPDATED_CART_ERROR", ()=>GET_UPDATED_CART_ERROR);
parcelHelpers.export(exports, "getUpdatedCartError", ()=>getUpdatedCartError);
parcelHelpers.export(exports, "HOLD_ORDER_REQUEST", ()=>HOLD_ORDER_REQUEST);
parcelHelpers.export(exports, "holdOrderRequest", ()=>holdOrderRequest);
parcelHelpers.export(exports, "HOLD_ORDER_SUCCESS", ()=>HOLD_ORDER_SUCCESS);
parcelHelpers.export(exports, "holdOrderSuccess", ()=>holdOrderSuccess);
parcelHelpers.export(exports, "SUBMIT_CANCEL_ORDER_REQUEST", ()=>SUBMIT_CANCEL_ORDER_REQUEST);
parcelHelpers.export(exports, "submitCancelOrderRequest", ()=>submitCancelOrderRequest);
parcelHelpers.export(exports, "CANCEL_ORDER_SUCCESS", ()=>CANCEL_ORDER_SUCCESS);
parcelHelpers.export(exports, "cancelOrderSuccess", ()=>cancelOrderSuccess);
parcelHelpers.export(exports, "CANCEL_ORDER_ERROR", ()=>CANCEL_ORDER_ERROR);
parcelHelpers.export(exports, "cancelOrderError", ()=>cancelOrderError);
parcelHelpers.export(exports, "REMOVE_ORDER_ITEM_REQUEST", ()=>REMOVE_ORDER_ITEM_REQUEST);
parcelHelpers.export(exports, "removeOrderItemRequest", ()=>removeOrderItemRequest);
parcelHelpers.export(exports, "REMOVE_ORDER_ITEM_SUCCESS", ()=>REMOVE_ORDER_ITEM_SUCCESS);
parcelHelpers.export(exports, "removeOrderItemSuccess", ()=>removeOrderItemSuccess);
parcelHelpers.export(exports, "REMOVE_ORDER_ITEM_ERROR", ()=>REMOVE_ORDER_ITEM_ERROR);
parcelHelpers.export(exports, "removeOrderItemError", ()=>removeOrderItemError);
parcelHelpers.export(exports, "INITIATE_VOID_TRANSACTION", ()=>INITIATE_VOID_TRANSACTION);
parcelHelpers.export(exports, "initiateVoidTransactionById", ()=>initiateVoidTransactionById);
parcelHelpers.export(exports, "VOID_TRANSACTION_SUCCESS", ()=>VOID_TRANSACTION_SUCCESS);
parcelHelpers.export(exports, "voidTransactionSuccess", ()=>voidTransactionSuccess);
parcelHelpers.export(exports, "VOID_TRANSACTION_ERROR", ()=>VOID_TRANSACTION_ERROR);
parcelHelpers.export(exports, "voidTransactionError", ()=>voidTransactionError);
parcelHelpers.export(exports, "STOP_VOID_TRANSACTION_POLLING", ()=>STOP_VOID_TRANSACTION_POLLING);
parcelHelpers.export(exports, "stopVoidTransactionPolling", ()=>stopVoidTransactionPolling);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "cartAlertBarAction", ()=>cartAlertBarAction);
parcelHelpers.export(exports, "MODAL_ACTION", ()=>MODAL_ACTION);
parcelHelpers.export(exports, "cartModalAction", ()=>cartModalAction);
parcelHelpers.export(exports, "CANCEL_ORDER_FORM_ACTION", ()=>CANCEL_ORDER_FORM_ACTION);
parcelHelpers.export(exports, "cancelOrderFormAction", ()=>cancelOrderFormAction);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "selectHasSuccessfulPayments", ()=>selectHasSuccessfulPayments);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _modalState = require("../../components/modal/Modal.state");
var _cartModals = require("./CartModals");
var _nested = require("../../utils/Nested");
var _orderDetailsState = require("../order-details/OrderDetails.state");
var _checkoutState = require("../checkout/Checkout.state");
var _helpers = require("../../utils/helpers");
var _constants = require("../../utils/constants");
// Default State
const initialState = {
    fetching: false,
    error: false,
    order: {}
};
// Action Creators and Action Types
const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
const GET_ORDER_REQUEST = "GET_ORDER_REQUEST";
const getOrderRequest = ()=>({
        type: GET_ORDER_REQUEST
    });
const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
const getOrderSuccess = (data)=>({
        type: GET_ORDER_SUCCESS,
        payload: data
    });
const GET_ORDER_ERROR = "GET_ORDER_ERROR";
const getOrderError = (data)=>({
        type: GET_ORDER_ERROR,
        payload: data
    });
const CLEAR_CART = "CLEAR_CART";
const clearCart = ()=>({
        type: CLEAR_CART
    });
const GET_UPDATED_CART_REQUEST = "GET_UPDATED_CART_REQUEST";
const getUpdatedCartRequest = (data)=>({
        type: GET_UPDATED_CART_REQUEST,
        payload: data
    });
const GET_UPDATED_CART_SUCCESS = "GET_UPDATED_CART_SUCCESS";
const getUpdatedCartSuccess = (data)=>({
        type: GET_UPDATED_CART_SUCCESS,
        payload: data
    });
const GET_UPDATED_CART_ERROR = "GET_UPDATED_CART_ERROR";
const getUpdatedCartError = (data)=>({
        type: GET_ORDER_DETAILS_ERROR,
        payload: data
    });
const HOLD_ORDER_REQUEST = "HOLD_ORDER_REQUEST";
const holdOrderRequest = (data)=>({
        type: HOLD_ORDER_REQUEST,
        payload: data
    });
const HOLD_ORDER_SUCCESS = "HOLD_ORDER_SUCCESS";
const holdOrderSuccess = (data)=>({
        type: HOLD_ORDER_SUCCESS,
        payload: data
    });
const SUBMIT_CANCEL_ORDER_REQUEST = "SUBMIT_CANCEL_ORDER_REQUEST";
const submitCancelOrderRequest = (data)=>({
        type: SUBMIT_CANCEL_ORDER_REQUEST,
        payload: data
    });
const CANCEL_ORDER_SUCCESS = "CANCEL_ORDER_SUCCESS";
const cancelOrderSuccess = (data)=>({
        type: CANCEL_ORDER_SUCCESS,
        payload: data
    });
const CANCEL_ORDER_ERROR = "CANCEL_ORDER_ERROR";
const cancelOrderError = (data)=>({
        type: CANCEL_ORDER_ERROR,
        payload: data
    });
const REMOVE_ORDER_ITEM_REQUEST = "REMOVE_ORDER_ITEM_REQUEST";
const removeOrderItemRequest = (data)=>({
        type: REMOVE_ORDER_ITEM_REQUEST,
        payload: data
    });
const REMOVE_ORDER_ITEM_SUCCESS = "REMOVE_ORDER_ITEM_SUCCESS";
const removeOrderItemSuccess = (data)=>({
        type: REMOVE_ORDER_ITEM_SUCCESS,
        payload: data
    });
const REMOVE_ORDER_ITEM_ERROR = "REMOVE_ORDER_ITEM_ERROR";
const removeOrderItemError = (data)=>({
        type: REMOVE_ORDER_ITEM_ERROR,
        payload: data
    });
const INITIATE_VOID_TRANSACTION = "INITIATE_VOID_TRANSACTION";
const initiateVoidTransactionById = (data)=>({
        type: INITIATE_VOID_TRANSACTION,
        payload: data
    });
const VOID_TRANSACTION_SUCCESS = "VOID_TRANSACTION_SUCCESS";
const voidTransactionSuccess = (data)=>({
        type: VOID_TRANSACTION_SUCCESS,
        payload: data
    });
const VOID_TRANSACTION_ERROR = "VOID_TRANSACTION_ERROR";
const voidTransactionError = (data)=>({
        type: VOID_TRANSACTION_ERROR,
        payload: data
    });
const STOP_VOID_TRANSACTION_POLLING = "STOP_VOID_TRANSACTION_POLLING";
const stopVoidTransactionPolling = ()=>({
        type: STOP_VOID_TRANSACTION_POLLING
    });
const ALERT_BAR_ACTION = "cart/ALERT_BAR_ACTION";
const cartAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const MODAL_ACTION = "cart/MODAL_ACTION";
const cartModalAction = _nested.nestedAction(MODAL_ACTION);
const CANCEL_ORDER_FORM_ACTION = "cart/CANCEL_ORDER_FORM_ACTION";
const cancelOrderFormAction = _nested.nestedAction(CANCEL_ORDER_FORM_ACTION);
const _reducer = (state = initialState, { type, payload } = action)=>{
    switch(type){
        case ADD_TO_CART_SUCCESS:
            return {
                ...state,
                order: {
                    ...state.order,
                    ...payload
                },
                fetching: false
            };
        case GET_ORDER_REQUEST:
            return {
                ...state,
                fetching: true
            };
        case GET_ORDER_SUCCESS:
            return {
                ...state,
                order: {
                    ...state.order,
                    ...payload
                },
                fetching: false
            };
        case GET_ORDER_ERROR:
            return {
                ...state,
                fetching: false,
                error: true
            };
        case HOLD_ORDER_SUCCESS:
        case CANCEL_ORDER_SUCCESS:
            return {
                ...state,
                order: {},
                fetching: false
            };
        case CANCEL_ORDER_ERROR:
            return {
                ...state,
                fetching: false,
                error: true
            };
        case SUBMIT_CANCEL_ORDER_REQUEST:
            return {
                ...state,
                fetching: true
            };
        case REMOVE_ORDER_ITEM_SUCCESS:
            return {
                ...state,
                order: payload,
                fetching: false
            };
        case REMOVE_ORDER_ITEM_ERROR:
            return {
                ...state,
                fetching: false
            };
        case CLEAR_CART:
            return {
                ...state,
                order: initialState.order
            };
        case GET_UPDATED_CART_SUCCESS:
            return {
                ...state,
                fetching: false,
                order: {
                    ...state.order,
                    status: payload?.data?.order?.status,
                    remaining_balance: payload?.data?.order?.remaining_balance
                }
            };
        case 0, _orderDetailsState.REOPEN_SUCCESS:
            return {
                ...state,
                order: payload.data
            };
        case 0, _checkoutState.PAYMENT_SUCCESS:
            return {
                ...state,
                order: {
                    ...state.order,
                    transaction_details: [
                        ...state.order?.transaction_details?.length ? state.order.transaction_details : [],
                        payload.data
                    ]
                }
            };
        case INITIATE_VOID_TRANSACTION:
            return {
                ...state,
                fetching: true
            };
        case VOID_TRANSACTION_SUCCESS:
            return {
                ...state,
                order: {
                    ...state.order,
                    remaining_balance: (0, _helpers.formatCurrency)(Number(state.order.remaining_balance) + Number(state.order?.transaction_details?.find((t)=>t.id === payload.id)?.amount_processed || 0)),
                    transaction_details: state.order?.transaction_details?.map((t)=>({
                            ...t,
                            status: t.id === payload.id ? (0, _constants.TRANSACTION_STATUS).CANCELLED : t.status
                        }))
                },
                fetching: false,
                error: false
            };
        case VOID_TRANSACTION_ERROR:
            return {
                ...state,
                fetching: false,
                error: true
            };
        default:
            return state;
    }
};
const selectHasSuccessfulPayments = (state)=>state.cart?.order?.transaction_details?.some((t)=>t.status === (0, _constants.TRANSACTION_STATUS).SUCCESSFUL || t.status === (0, _constants.TRANSACTION_STATUS).CANCEL_PENDING) ?? false;
const invalidItemAdditionAlert = {
    heading: "Cart Page Error",
    text: "New items cannot be added because the order is partially paid.",
    variant: "error"
};
const _mapStateToProps = (state)=>({
        ...state.cart
    });
const _mapDispatchToProps = (dispatch)=>({
        getOrder: ()=>dispatch(getOrderRequest()),
        removeOrderItemRequest: (item_id)=>dispatch(removeOrderItemRequest(item_id)),
        displayAddItemsAlert: ()=>dispatch(cartAlertBarAction(_alertBarState.replaceAlerts(invalidItemAdditionAlert)))
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    forms: {
        cancelOrderForm: {
            ...(0, _cartModals.CancelOrderFormModal),
            actionType: CANCEL_ORDER_FORM_ACTION
        }
    },
    alertBars: {
        cartAlertBars: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    },
    modals: {
        cartModal: {
            ..._modalState,
            actionType: MODAL_ACTION
        }
    }
}, "cart");
// Nested Reducer
const reducer = (state, action1)=>nestedReducer(state, action1);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../components/modal/Modal.state":"34xap","./CartModals":"5pwyS","../../utils/Nested":"gDQL4","../order-details/OrderDetails.state":"3yj5u","../checkout/Checkout.state":"4E8nR","../../utils/helpers":"epomp","../../utils/constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5pwyS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CANCEL_ORDER_FORM_MODAL", ()=>CANCEL_ORDER_FORM_MODAL);
parcelHelpers.export(exports, "REMOVE_ITEM_MODAL", ()=>REMOVE_ITEM_MODAL);
parcelHelpers.export(exports, "CancelOrderFormModal", ()=>CancelOrderFormModal);
parcelHelpers.export(exports, "RemoveItemModal", ()=>RemoveItemModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
// Build redux freeform for cancel order modal form
var _reduxFreeform = require("redux-freeform");
var _helpers = require("../../utils/helpers");
const reasonOptions = [
    {
        text: "Constituent Walked Away",
        value: "1"
    },
    {
        text: "Constituent Had No Money",
        value: "2"
    },
    {
        text: "Credit Card Was Declined",
        value: "3"
    },
    {
        text: "Check Verification Failed",
        value: "4"
    },
    {
        text: "Debt Already Paid",
        value: "5"
    },
    {
        text: "Other",
        value: "6"
    }
];
const formConfig = {
    reason: {
        defaultValue: "1",
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    note: {
        validators: [
            (0, _reduxFreeform.required)()
        ]
    }
};
const { reducer, mapStateToProps, mapDispatchToProps } = (0, _reduxFreeform.createFormState)(formConfig);
const CANCEL_ORDER_FORM_MODAL = "CANCEL_ORDER_FORM_MODAL";
const CancelOrderFormModal = ({ fields, actions, modals, showErrors, submit, toggle })=>{
    (0, _react.useEffect)(()=>{
        return ()=>actions.form.clear();
    }, []);
    const reasonErrors = {
        [(0, _reduxFreeform.required).error]: "Reason for Cancellation Required"
    };
    const noteErrors = {
        [(0, _reduxFreeform.required).error]: "Note Required"
    };
    const body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormContainer), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormInputColumn), {
            role: "form",
            "aria-label": "Cancel Order",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                    dropdownMaxHeight: "200px",
                    labelTextWhenNoError: "Reason",
                    options: reasonOptions,
                    fieldActions: actions.fields.reason,
                    showErrors: showErrors,
                    errorMessages: reasonErrors,
                    field: fields.reason,
                    labelTextVariant: "p",
                    errorLabelTextVariant: "p"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                    labelTextWhenNoError: "Note",
                    errorMessages: noteErrors,
                    field: fields.note,
                    errors: showErrors,
                    fieldActions: actions.fields.note,
                    labelTextVariant: "p",
                    errorTextVariant: "p"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
        modalHeaderText: "Cancel Order",
        modalBodyText: body,
        modalOpen: modals.cartModal.modalIsOpen && modals.cartModal.modalId === CANCEL_ORDER_FORM_MODAL,
        toggleModal: toggle,
        continueAction: submit,
        cancelAction: toggle,
        defaultWrapper: false
    });
};
CancelOrderFormModal.reducer = reducer;
CancelOrderFormModal.mapStateToProps = mapStateToProps;
CancelOrderFormModal.mapDispatchToProps = mapDispatchToProps;
const REMOVE_ITEM_MODAL = "REMOVE_ITEM_MODAL";
const RemoveItemModal = ({ modals, submit, toggle, item = {} })=>{
    const body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                    fontSize: "1rem",
                    weight: "600",
                    children: item.receivable_category
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                    children: item.is_negative_amount ? (0, _helpers.formatWithParentheses)((0, _helpers.formatPrice)(item.recorded_subtotal)) : (0, _helpers.formatPrice)(item.recorded_subtotal)
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
        modalHeaderText: "Are you sure you want to remove this item?",
        modalBodyText: body,
        modalOpen: modals.cartModal.modalIsOpen && modals.cartModal.modalId === REMOVE_ITEM_MODAL,
        toggleModal: toggle,
        continueAction: submit,
        cancelAction: toggle,
        defaultWrapper: false
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","redux-freeform":"1Yc5v","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3yj5u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_ORDER_DETAILS_REQUEST", ()=>GET_ORDER_DETAILS_REQUEST);
parcelHelpers.export(exports, "getOrderDetailsRequest", ()=>getOrderDetailsRequest);
parcelHelpers.export(exports, "GET_ORDER_DETAILS_SUCCESS", ()=>GET_ORDER_DETAILS_SUCCESS);
parcelHelpers.export(exports, "getOrderDetailsSuccess", ()=>getOrderDetailsSuccess);
parcelHelpers.export(exports, "GET_ORDER_DETAILS_ERROR", ()=>GET_ORDER_DETAILS_ERROR);
parcelHelpers.export(exports, "getOrderDetailsError", ()=>getOrderDetailsError);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "orderDetailsAlertBarAction", ()=>orderDetailsAlertBarAction);
parcelHelpers.export(exports, "LOADING_MODAL_ACTION", ()=>LOADING_MODAL_ACTION);
parcelHelpers.export(exports, "orderDetailsLoadingModalAction", ()=>orderDetailsLoadingModalAction);
parcelHelpers.export(exports, "VOIDING_MODAL_ACTION", ()=>VOIDING_MODAL_ACTION);
parcelHelpers.export(exports, "orderDetailsVoidingModalAction", ()=>orderDetailsVoidingModalAction);
parcelHelpers.export(exports, "REFUNDING_MODAL_ACTION", ()=>REFUNDING_MODAL_ACTION);
parcelHelpers.export(exports, "orderDetailsRefundingModalAction", ()=>orderDetailsRefundingModalAction);
parcelHelpers.export(exports, "CHANGE_DUE_MODAL_ACTION", ()=>CHANGE_DUE_MODAL_ACTION);
parcelHelpers.export(exports, "orderDetailsChangeDueModalAction", ()=>orderDetailsChangeDueModalAction);
parcelHelpers.export(exports, "INITIATE_VOID", ()=>INITIATE_VOID);
parcelHelpers.export(exports, "initiateVoidOrderById", ()=>initiateVoidOrderById);
parcelHelpers.export(exports, "VOID_SUCCESS", ()=>VOID_SUCCESS);
parcelHelpers.export(exports, "voidSuccess", ()=>voidSuccess);
parcelHelpers.export(exports, "VOID_ERROR", ()=>VOID_ERROR);
parcelHelpers.export(exports, "voidError", ()=>voidError);
parcelHelpers.export(exports, "STOP_VOID_ORDER_POLLING", ()=>STOP_VOID_ORDER_POLLING);
parcelHelpers.export(exports, "stopVoidOrderPolling", ()=>stopVoidOrderPolling);
parcelHelpers.export(exports, "INITIATE_RETURN", ()=>INITIATE_RETURN);
parcelHelpers.export(exports, "initiateReturnOrderById", ()=>initiateReturnOrderById);
parcelHelpers.export(exports, "RETURN_SUCCESS", ()=>RETURN_SUCCESS);
parcelHelpers.export(exports, "returnSuccess", ()=>returnSuccess);
parcelHelpers.export(exports, "RETURN_ERROR", ()=>RETURN_ERROR);
parcelHelpers.export(exports, "returnError", ()=>returnError);
parcelHelpers.export(exports, "INITIATE_REOPEN", ()=>INITIATE_REOPEN);
parcelHelpers.export(exports, "initiateReopenOrderById", ()=>initiateReopenOrderById);
parcelHelpers.export(exports, "REOPEN_SUCCESS", ()=>REOPEN_SUCCESS);
parcelHelpers.export(exports, "reopenSuccess", ()=>reopenSuccess);
parcelHelpers.export(exports, "REOPEN_ERROR", ()=>REOPEN_ERROR);
parcelHelpers.export(exports, "reopenError", ()=>reopenError);
parcelHelpers.export(exports, "OPEN_VOID_MODAL", ()=>OPEN_VOID_MODAL);
parcelHelpers.export(exports, "CLOSE_VOID_MODAL", ()=>CLOSE_VOID_MODAL);
parcelHelpers.export(exports, "voidModal", ()=>voidModal);
parcelHelpers.export(exports, "OPEN_RETURN_MODAL", ()=>OPEN_RETURN_MODAL);
parcelHelpers.export(exports, "CLOSE_RETURN_MODAL", ()=>CLOSE_RETURN_MODAL);
parcelHelpers.export(exports, "returnModal", ()=>returnModal);
parcelHelpers.export(exports, "OPEN_CHANGE_DUE_MODAL", ()=>OPEN_CHANGE_DUE_MODAL);
parcelHelpers.export(exports, "CLOSE_CHANGE_DUE_MODAL", ()=>CLOSE_CHANGE_DUE_MODAL);
parcelHelpers.export(exports, "changeDueModal", ()=>changeDueModal);
parcelHelpers.export(exports, "VOID_FORM_ACTION", ()=>VOID_FORM_ACTION);
parcelHelpers.export(exports, "voidFormAction", ()=>voidFormAction);
parcelHelpers.export(exports, "RETURN_FORM_ACTION", ()=>RETURN_FORM_ACTION);
parcelHelpers.export(exports, "returnFormAction", ()=>returnFormAction);
parcelHelpers.export(exports, "RECEIPT_FORM_ACTION", ()=>RECEIPT_FORM_ACTION);
parcelHelpers.export(exports, "receiptFormAction", ()=>receiptFormAction);
parcelHelpers.export(exports, "SUBMIT_SEND_RECEIPT", ()=>SUBMIT_SEND_RECEIPT);
parcelHelpers.export(exports, "submitSendReceipt", ()=>submitSendReceipt);
parcelHelpers.export(exports, "SUBMIT_PRINT_RECEIPT", ()=>SUBMIT_PRINT_RECEIPT);
parcelHelpers.export(exports, "submitPrintReceipt", ()=>submitPrintReceipt);
parcelHelpers.export(exports, "SEND_RECEIPT_SUCCESS", ()=>SEND_RECEIPT_SUCCESS);
parcelHelpers.export(exports, "sendReceiptSuccess", ()=>sendReceiptSuccess);
parcelHelpers.export(exports, "SEND_RECEIPT_ERROR", ()=>SEND_RECEIPT_ERROR);
parcelHelpers.export(exports, "sendReceiptError", ()=>sendReceiptError);
parcelHelpers.export(exports, "PRINT_RECEIPT_SUCCESS", ()=>PRINT_RECEIPT_SUCCESS);
parcelHelpers.export(exports, "printReceiptSuccess", ()=>printReceiptSuccess);
parcelHelpers.export(exports, "PRINT_RECEIPT_ERROR", ()=>PRINT_RECEIPT_ERROR);
parcelHelpers.export(exports, "printReceiptError", ()=>printReceiptError);
parcelHelpers.export(exports, "INITIATE_CANCEL_PAYLINK", ()=>INITIATE_CANCEL_PAYLINK);
parcelHelpers.export(exports, "initiateCancelPaylink", ()=>initiateCancelPaylink);
parcelHelpers.export(exports, "CANCEL_PAYLINK_SUCCESS", ()=>CANCEL_PAYLINK_SUCCESS);
parcelHelpers.export(exports, "cancelPaylinkSuccess", ()=>cancelPaylinkSuccess);
parcelHelpers.export(exports, "CANCEL_PAYLINK_ERROR", ()=>CANCEL_PAYLINK_ERROR);
parcelHelpers.export(exports, "cancelPaylinkError", ()=>cancelPaylinkError);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
var _modalState = require("../../components/modal/Modal.state");
var _receiptFormModule = require("../../components/receipt-form-module");
var _checkoutState = require("../checkout/Checkout.state");
var _helpers = require("../../utils/helpers");
var _orderDetailsVoidModal = require("./OrderDetailsVoidModal");
var _orderDetailsReturnModal = require("./OrderDetailsReturnModal");
// Default State
const initialState = {
    error: false,
    data: {},
    isLoading: false,
    isPrintReceiptLoading: false,
    isSendReceiptLoading: false,
    isVoidModalOpen: false,
    isReturnModalOpen: false,
    isChangeDueModalOpen: false,
    isVoidError: false,
    isCardReturnError: false,
    isReopenOrderError: false,
    changeDue: 0,
    isPaylinkError: false,
    isPaylinkCancelled: false
};
const GET_ORDER_DETAILS_REQUEST = "GET_ORDER_DETAILS_REQUEST";
const getOrderDetailsRequest = (data)=>({
        type: GET_ORDER_DETAILS_REQUEST,
        payload: data
    });
const GET_ORDER_DETAILS_SUCCESS = "GET_ORDER_DETAILS_SUCCESS";
const getOrderDetailsSuccess = (data)=>({
        type: GET_ORDER_DETAILS_SUCCESS,
        payload: data
    });
const GET_ORDER_DETAILS_ERROR = "GET_ORDER_DETAILS_ERROR";
const getOrderDetailsError = (data)=>({
        type: GET_ORDER_DETAILS_ERROR,
        payload: data
    });
const ALERT_BAR_ACTION = "orderDetails/ALERT_BAR_ACTION";
const orderDetailsAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const LOADING_MODAL_ACTION = "orderDetails/LOADING_MODAL_ACTION";
const orderDetailsLoadingModalAction = _nested.nestedAction(LOADING_MODAL_ACTION);
const VOIDING_MODAL_ACTION = "orderDetails/VOIDING_MODAL_ACTION";
const orderDetailsVoidingModalAction = _nested.nestedAction(VOIDING_MODAL_ACTION);
const REFUNDING_MODAL_ACTION = "orderDetails/REFUNDING_MODAL_ACTION";
const orderDetailsRefundingModalAction = _nested.nestedAction(REFUNDING_MODAL_ACTION);
const CHANGE_DUE_MODAL_ACTION = "orderDetails/CHANGE_DUE_MODAL_ACTION";
const orderDetailsChangeDueModalAction = _nested.nestedAction(CHANGE_DUE_MODAL_ACTION);
const INITIATE_VOID = "INITIATE_VOID";
const initiateVoidOrderById = (data)=>({
        type: INITIATE_VOID,
        payload: data
    });
const VOID_SUCCESS = "VOID_SUCCESS";
const voidSuccess = (data)=>({
        type: VOID_SUCCESS,
        payload: data
    });
const VOID_ERROR = "VOID_ERROR";
const voidError = (data)=>({
        type: VOID_ERROR,
        payload: data
    });
const STOP_VOID_ORDER_POLLING = "STOP_VOID_ORDER_POLLING";
const stopVoidOrderPolling = ()=>({
        type: STOP_VOID_ORDER_POLLING
    });
const INITIATE_RETURN = "INITIATE_RETURN";
const initiateReturnOrderById = (data)=>({
        type: INITIATE_RETURN,
        payload: data
    });
const RETURN_SUCCESS = "RETURN_SUCCESS";
const returnSuccess = (data)=>({
        type: RETURN_SUCCESS,
        payload: data
    });
const RETURN_ERROR = "RETURN_ERROR";
const returnError = (data)=>({
        type: RETURN_ERROR,
        payload: data
    });
const INITIATE_REOPEN = "INITIATE_REOPEN";
const initiateReopenOrderById = (id)=>({
        type: INITIATE_REOPEN,
        payload: id
    });
const REOPEN_SUCCESS = "REOPEN_SUCCESS";
const reopenSuccess = (data)=>({
        type: REOPEN_SUCCESS,
        payload: data
    });
const REOPEN_ERROR = "REOPEN_ERROR";
const reopenError = (data)=>({
        type: REOPEN_ERROR,
        payload: data
    });
const OPEN_VOID_MODAL = "OPEN_VOID_MODAL";
const CLOSE_VOID_MODAL = "CLOSE_VOID_MODAL";
const voidModal = (type)=>({
        type
    });
const OPEN_RETURN_MODAL = "OPEN_RETURN_MODAL";
const CLOSE_RETURN_MODAL = "CLOSE_RETURN_MODAL";
const returnModal = (type)=>({
        type
    });
const OPEN_CHANGE_DUE_MODAL = "OPEN_CHANGE_DUE_MODAL";
const CLOSE_CHANGE_DUE_MODAL = "CLOSE_CHANGE_DUE_MODAL";
const changeDueModal = (type)=>({
        type
    });
const VOID_FORM_ACTION = "orderDetails/VOID_FORM_ACTION";
const voidFormAction = _nested.nestedAction(VOID_FORM_ACTION);
const RETURN_FORM_ACTION = "orderDetails/RETURN_FORM_ACTION";
const returnFormAction = _nested.nestedAction(RETURN_FORM_ACTION);
const RECEIPT_FORM_ACTION = "orderDetails/RECEIPT_FORM_ACTION";
const receiptFormAction = _nested.nestedAction(RECEIPT_FORM_ACTION);
const SUBMIT_SEND_RECEIPT = "orderDetails/SUBMIT_SEND_RECEIPT";
const submitSendReceipt = (payload)=>({
        type: SUBMIT_SEND_RECEIPT,
        payload
    });
const SUBMIT_PRINT_RECEIPT = "orderDetails/SUBMIT_PRINT_RECEIPT";
const submitPrintReceipt = (payload)=>({
        type: SUBMIT_PRINT_RECEIPT,
        payload
    });
const SEND_RECEIPT_SUCCESS = "orderDetails/SEND_RECEIPT_SUCCESS";
const sendReceiptSuccess = (payload)=>({
        type: SEND_RECEIPT_SUCCESS,
        payload
    });
const SEND_RECEIPT_ERROR = "orderDetails/SEND_RECEIPT_ERROR";
const sendReceiptError = ()=>({
        type: SEND_RECEIPT_ERROR
    });
const PRINT_RECEIPT_SUCCESS = "orderDetails/PRINT_RECEIPT_SUCCESS";
const printReceiptSuccess = (payload)=>({
        type: PRINT_RECEIPT_SUCCESS,
        payload
    });
const PRINT_RECEIPT_ERROR = "orderDetails/PRINT_RECEIPT_ERROR";
const printReceiptError = ()=>({
        type: PRINT_RECEIPT_ERROR
    });
const INITIATE_CANCEL_PAYLINK = "orderDetails/INITIATE_CANCEL_PAYLINK";
const initiateCancelPaylink = (data)=>({
        type: INITIATE_CANCEL_PAYLINK,
        payload: data
    });
const CANCEL_PAYLINK_SUCCESS = "orderDetails/CANCEL_PAYLINK_SUCCESS";
const cancelPaylinkSuccess = (data)=>({
        type: CANCEL_PAYLINK_SUCCESS,
        payload: data
    });
const CANCEL_PAYLINK_ERROR = "orderDetails/CANCEL_PAYLINK_ERROR";
const cancelPaylinkError = (data)=>({
        type: CANCEL_PAYLINK_ERROR,
        payload: data
    });
const _reducer = (state = initialState, { type, payload } = action)=>{
    switch(type){
        case GET_ORDER_DETAILS_REQUEST:
            return {
                ...state,
                fetching: true
            };
        case GET_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                data: payload,
                fetching: false,
                error: false,
                isPaylinkCancelled: false
            };
        case GET_ORDER_DETAILS_ERROR:
            return {
                ...state,
                error: true,
                fetching: false,
                errorText: payload
            };
        case OPEN_VOID_MODAL:
            return {
                ...state,
                isVoidModalOpen: true
            };
        case CLOSE_VOID_MODAL:
            return {
                ...state,
                isVoidModalOpen: false
            };
        case OPEN_RETURN_MODAL:
            return {
                ...state,
                isReturnModalOpen: true
            };
        case CLOSE_RETURN_MODAL:
            return {
                ...state,
                isReturnModalOpen: false
            };
        case OPEN_CHANGE_DUE_MODAL:
            return {
                ...state,
                isChangeDueModalOpen: true
            };
        case CLOSE_CHANGE_DUE_MODAL:
            return {
                ...state,
                isChangeDueModalOpen: false,
                changeDue: initialState.changeDue
            };
        case INITIATE_VOID:
            return {
                ...state,
                isLoading: true
            };
        case VOID_ERROR:
            return {
                ...state,
                isLoading: false,
                isVoidModalOpen: false,
                isVoidError: true
            };
        case VOID_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    transaction_details: payload.data.transaction_details,
                    order: {
                        ...state.data.order,
                        status: payload.data.status,
                        voidable: payload.data.voidable
                    }
                },
                isLoading: false,
                isVoidModalOpen: false,
                changeDue: payload.changeDue
            };
        case 0, _checkoutState.PAYMENT_SUCCESS:
            return {
                ...state,
                changeDue: (0, _helpers.formatCurrency)(payload.data.change_due)
            };
        case INITIATE_RETURN:
            return {
                ...state,
                isLoading: true
            };
        case RETURN_ERROR:
            return {
                ...state,
                isCardReturnError: true,
                isLoading: false
            };
        case RETURN_SUCCESS:
            return {
                ...state,
                order: payload.order,
                isCardReturnError: false,
                isLoading: false
            };
        case INITIATE_REOPEN:
            return {
                ...state,
                isLoading: true
            };
        case REOPEN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isReopenOrderError: false
            };
        case REOPEN_ERROR:
            return {
                ...state,
                isLoading: false,
                isReopenOrderError: true
            };
        case SUBMIT_PRINT_RECEIPT:
            return {
                ...state,
                isPrintReceiptLoading: true
            };
        case PRINT_RECEIPT_ERROR:
            return {
                ...state,
                isPrintReceiptLoading: false
            };
        case PRINT_RECEIPT_SUCCESS:
            return {
                ...state,
                isPrintReceiptLoading: false
            };
        case SUBMIT_SEND_RECEIPT:
            return {
                ...state,
                isSendReceiptLoading: true
            };
        case SEND_RECEIPT_ERROR:
            return {
                ...state,
                isSendReceiptLoading: false
            };
        case SEND_RECEIPT_SUCCESS:
            return {
                ...state,
                isSendReceiptLoading: false
            };
        case INITIATE_CANCEL_PAYLINK:
            return {
                ...state,
                isLoading: true
            };
        case CANCEL_PAYLINK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isPaylinkCancelled: true
            };
        case CANCEL_PAYLINK_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                isPaylinkError: true,
                isPaylinkCancelled: false
            };
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>({
        ...state.orderDetails
    });
const _mapDispatchToProps = (dispatch)=>({
        getOrderDetails: (id)=>dispatch(getOrderDetailsRequest(id)),
        initiateVoidOrderById: (id)=>dispatch(initiateVoidOrderById(id)),
        submitSendReceipt: (payload)=>dispatch(submitSendReceipt(payload)),
        submitPrintReceipt: (payload)=>dispatch(submitPrintReceipt(payload))
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    modals: {
        voidingModal: {
            ..._modalState,
            actionType: VOIDING_MODAL_ACTION
        },
        refundingModal: {
            ..._modalState,
            actionType: REFUNDING_MODAL_ACTION
        },
        loadingModal: {
            ..._modalState,
            actionType: LOADING_MODAL_ACTION
        },
        changeDueModal: {
            ..._modalState,
            actionType: CHANGE_DUE_MODAL_ACTION
        }
    },
    alertBars: {
        orderDetailsAlertBars: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    },
    forms: {
        voidForm: {
            ...(0, _orderDetailsVoidModal.VoidForm),
            actionType: VOID_FORM_ACTION
        },
        returnForm: {
            ...(0, _orderDetailsReturnModal.ReturnForm),
            actionType: RETURN_FORM_ACTION
        },
        receiptForm: {
            ...(0, _receiptFormModule.ReceiptForm),
            actionType: RECEIPT_FORM_ACTION
        }
    }
}, "orderDetails");
// Nested Reducer
const reducer = (state, action1)=>nestedReducer(state, action1);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","../../components/modal/Modal.state":"34xap","../../components/receipt-form-module":"h3Gar","../checkout/Checkout.state":"4E8nR","../../utils/helpers":"epomp","./OrderDetailsVoidModal":"cJFC9","./OrderDetailsReturnModal":"dMVt7","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h3Gar":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReceiptForm", ()=>(0, _receiptFormModule.ReceiptForm));
parcelHelpers.export(exports, "ReceiptFormModule", ()=>(0, _receiptFormModule.ReceiptFormModule));
var _receiptFormModule = require("./ReceiptFormModule");

},{"./ReceiptFormModule":"iAz5o","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iAz5o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReceiptForm", ()=>ReceiptForm);
parcelHelpers.export(exports, "ReceiptFormModule", ()=>ReceiptFormModule);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reduxFreeform = require("redux-freeform");
var _receiptFormState = require("./ReceiptForm.state");
var _pdfReports = require("../../components/pdf-reports");
var _reactRedux = require("react-redux");
var _renderer = require("@react-pdf/renderer");
var _helpers = require("../../utils/helpers");
var _cityvilleLogoBluePng = require("../../static/img/cityville-logo-blue.png");
var _cityvilleLogoBluePngDefault = parcelHelpers.interopDefault(_cityvilleLogoBluePng);
var _constants = require("../../utils/constants");
const ReceiptFormModule = ({ actions, buttonStyle, forms, handleErrors, showErrors, submitSendReceipt, submitPrintReceipt, cancelAction })=>{
    const { clientMetadata: { data: metadata } } = (0, _reactRedux.useSelector)((state)=>state.global);
    const { data } = (0, _reactRedux.useSelector)((state)=>state.orderDetails);
    const { terminal } = (0, _reactRedux.useSelector)((state)=>state.terminalLogin.terminalSession || "");
    const { data: selectedOrder, isPrintReceiptLoading, isSendReceiptLoading } = (0, _reactRedux.useSelector)((state)=>state.orderDetails);
    const lazyLoadPdf = async ()=>{
        const portraitOrLandscapeLogo = await (0, _helpers.getImageOrientation)(metadata?.headerLogoLink ?? (0, _cityvilleLogoBluePngDefault.default));
        // from https://github.com/diegomura/react-pdf/issues/975
        const doc = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdfReports.OrderReceiptReportDocument), {
            headerImg: metadata?.headerLogoLink,
            portraitOrLandscapeLogo: portraitOrLandscapeLogo,
            ...data
        });
        const asPdf = (0, _renderer.pdf)();
        asPdf.updateContainer(doc);
        const blob = await asPdf.toBlob();
        const objectUrl = window.URL.createObjectURL(blob);
        (0, _helpers.downloadReport)(`Order-ID-${selectedOrder.order.id}-Receipt`, terminal, new Date(), objectUrl);
    };
    const handleSendReceiptClick = (0, _components.util).general.generateClickHandler(forms.receiptForm, ()=>handleErrors(true), ()=>submitSendReceipt());
    const disableSendReceiptButton = !(forms.receiptForm.fields.textReceipt.rawValue || forms.receiptForm.fields.emailReceipt.rawValue);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                background: (0, _components.constants).colors.WHITE,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
                    justify: "stretch",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
                        width: "100%",
                        extraStyles: `flex-grow: 1;`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                extraStyles: `max-width: 32rem`,
                                children: "Please enter the email address or phone number to send a copy of this receipt or click \u201CPrint receipt\u201D to print a receipt."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReceiptForm, {
                                showErrors: showErrors,
                                ...forms.receiptForm,
                                ...actions.forms.receiptForm
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                background: (0, _components.constants).colors.WHITE,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
                    justify: "stretch",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        justify: "flex-end",
                        extraStyles: `flex-grow: 1; align-self: flex-end;`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                extraStyles: buttonStyle,
                                textExtraStyles: "font-size: 1rem;",
                                text: "Cancel",
                                isLoading: false,
                                variant: "secondary",
                                action: cancelAction
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                id: "print-receipt-btn",
                                extraStyles: buttonStyle,
                                textExtraStyles: "font-size: 1rem;",
                                text: "Print Receipt",
                                isLoading: isPrintReceiptLoading,
                                disabled: isPrintReceiptLoading,
                                action: submitPrintReceipt
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                id: "pdf-receipt-btn",
                                extraStyles: buttonStyle,
                                textExtraStyles: "font-size: 1rem;",
                                text: "PDF Receipt",
                                isLoading: false,
                                action: ()=>lazyLoadPdf()
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                id: "send-receipt-btn",
                                disabled: disableSendReceiptButton || isSendReceiptLoading,
                                extraStyles: buttonStyle,
                                textExtraStyles: "font-size: 1rem;",
                                text: "Send Receipt",
                                isLoading: isSendReceiptLoading,
                                action: handleSendReceiptClick
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const emailReceiptErrors = {
    [(0, _reduxFreeform.required).error]: "Email address required",
    [(0, _reduxFreeform.isProbablyEmail).error]: "Not a valid email address"
};
const textReceiptErrors = {
    [(0, _reduxFreeform.required).error]: "Phone number required",
    [(0, _reduxFreeform.hasLength).error]: "10 digit phone number required"
};
const ReceiptForm = ({ actions, fields, showErrors })=>{
    (0, _react.useEffect)(()=>{
        return ()=>actions.form.clear();
    }, []);
    const currentEmailReceiptBoolean = Boolean(fields.emailReceipt.rawValue);
    const resetFieldValueOnSelect = (field)=>{
        if (field && fields[field]?.rawValue) actions.fields[field].set("");
    };
    const handleEmailReceiptCheckboxClick = ()=>{
        actions.fields.emailReceipt.set(!currentEmailReceiptBoolean);
        resetFieldValueOnSelect((0, _constants.EMAIL_ADDRESS_FIELD_NAME));
    };
    const currentTextReceiptBoolean = Boolean(fields.textReceipt.rawValue);
    const handleTextReceiptCheckboxClick = ()=>{
        actions.fields.textReceipt.set(!currentTextReceiptBoolean);
        resetFieldValueOnSelect((0, _constants.PHONE_NUMBER_FIELD_NAME));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormContainer), {
        padding: "0 0 0 1rem",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                id: "email-receipt",
                title: "Email Receipt",
                name: "Email Receipt",
                checked: currentEmailReceiptBoolean,
                onChange: handleEmailReceiptCheckboxClick
            }),
            currentEmailReceiptBoolean && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                id: "email-address-input",
                labelTextWhenNoError: "Email Address",
                errorMessages: emailReceiptErrors,
                field: fields.emailAddress,
                errors: fields.errors,
                showErrors: showErrors,
                fieldActions: actions.fields.emailAddress,
                labelTextVariant: "p",
                errorTextVariant: "p"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                id: "text-receipt",
                title: "Text Receipt",
                name: "Text Receipt",
                checked: currentTextReceiptBoolean,
                onChange: handleTextReceiptCheckboxClick
            }),
            currentTextReceiptBoolean && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                id: "phone-number-input",
                labelTextWhenNoError: "Phone Number",
                errorMessages: textReceiptErrors,
                field: fields.phoneNumber,
                errors: fields.errors,
                showErrors: showErrors,
                fieldActions: actions.fields.phoneNumber,
                labelTextVariant: "p",
                errorTextVariant: "p"
            })
        ]
    });
};
ReceiptForm.reducer = (0, _receiptFormState.reducer);
ReceiptForm.mapStateToProps = (0, _receiptFormState.mapStateToProps);
ReceiptForm.mapDispatchToProps = (0, _receiptFormState.mapDispatchToProps);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","redux-freeform":"1Yc5v","./ReceiptForm.state":"56BGg","../../components/pdf-reports":"5TB3o","react-redux":"k6jol","@react-pdf/renderer":"jjqkY","../../utils/helpers":"epomp","../../static/img/cityville-logo-blue.png":"3ed6r","../../utils/constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"56BGg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
const receiptFormConfig = {
    emailReceipt: {},
    emailAddress: {
        validators: [
            // includedIn[true] will only apply validation if the related checkbox field is checked (true)
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                true
            ]), "emailReceipt"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.isProbablyEmail)(), (0, _reduxFreeform.includedIn)([
                true
            ]), "emailReceipt"),
            , 
        ]
    },
    textReceipt: {},
    phoneNumber: {
        validators: [
            // includedIn[true] will only apply validation if the related checkbox field is checked (true)
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.required)(), (0, _reduxFreeform.includedIn)([
                true
            ]), "textReceipt"),
            (0, _reduxFreeform.validateWhen)((0, _reduxFreeform.hasLength)(10, 10), (0, _reduxFreeform.includedIn)([
                true
            ]), "textReceipt")
        ],
        constraints: [
            (0, _reduxFreeform.hasLength)(0, 10),
            (0, _reduxFreeform.onlyIntegers)()
        ]
    }
};
const { reducer, mapStateToProps, mapDispatchToProps } = (0, _reduxFreeform.createFormState)(receiptFormConfig);

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5TB3o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseoutReportDocument", ()=>(0, _closeoutReport.CloseoutReportDocument));
parcelHelpers.export(exports, "useCloseoutReportDownloader", ()=>(0, _closeoutReport.useCloseoutReportDownloader));
parcelHelpers.export(exports, "OrderReceiptReportDocument", ()=>(0, _orderReceiptReport.OrderReceiptReportDocument));
var _closeoutReport = require("./CloseoutReport");
var _orderReceiptReport = require("./OrderReceiptReport");

},{"./CloseoutReport":"3qXTU","./OrderReceiptReport":"ildaL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3qXTU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseoutReportDocument", ()=>CloseoutReportDocument);
parcelHelpers.export(exports, "useCloseoutReportDownloader", ()=>useCloseoutReportDownloader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _helpers = require("../../utils/helpers");
var _reactRedux = require("react-redux");
var _cashActionDetailsState = require("../../pages/cash-action-details/CashActionDetails.state");
var _components = require("@thecb/components");
var _constants = require("../../utils/constants");
var _cityvilleLogoBluePng = require("../../static/img/cityville-logo-blue.png");
var _cityvilleLogoBluePngDefault = parcelHelpers.interopDefault(_cityvilleLogoBluePng);
var _sharedReportStyles = require("./SharedReportStyles");
var _sharedReportStylesDefault = parcelHelpers.interopDefault(_sharedReportStyles);
const styles = (0, _renderer.StyleSheet).create({
    ...(0, _sharedReportStylesDefault.default),
    page: {
        ...(0, _sharedReportStylesDefault.default).page,
        fontSize: 10
    },
    title: {
        ...(0, _sharedReportStylesDefault.default).title,
        fontSize: 18,
        marginBottom: 8
    },
    lineItem: {
        marginBottom: 8
    },
    table: {
        width: "100%"
    },
    trow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: 8
    },
    thead: {
        backgroundColor: "#E5E7EC",
        borderBottom: 0
    },
    thAlignLeft: {
        width: "25%",
        textAlign: "left"
    },
    thAlignRight: {
        width: "25%",
        textAlign: "right"
    },
    tdAlignLeft: {
        width: "25%",
        textAlign: "left"
    },
    tdAlignRight: {
        width: "25%",
        textAlign: "right"
    },
    cbBrand: {
        position: "absolute",
        bottom: 30,
        left: 250,
        right: 0,
        width: 100,
        height: 12
    },
    flexContainerRow: {
        ...(0, _sharedReportStylesDefault.default).flexContainerRow,
        padding: "4px 8px",
        backgroundColor: (0, _components.constants).colors.ATHENS_GREY
    },
    smallDividerGrey: {
        ...(0, _sharedReportStylesDefault.default).smallDividerGrey,
        margin: 0
    },
    greyContainer: {
        ...(0, _sharedReportStylesDefault.default).greyContainer,
        padding: 0
    }
});
const CloseoutReportHeading = ({ title, closed_at, created_at, location, cashier, batch, closeout, headerImg, portraitOrLandscapeLogo })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Image), {
                style: portraitOrLandscapeLogo === (0, _constants.IMAGE_ORIENTATIONS).PORTRAIT ? styles.clientBrandPortrait : styles.clientBrandLandscape,
                src: headerImg ?? (0, _cityvilleLogoBluePngDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: styles.title,
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                style: styles.lineItem,
                children: [
                    "Date Opened: ",
                    (0, _helpers.formatDate)(created_at)
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                style: styles.lineItem,
                children: [
                    "Date Closed: ",
                    (0, _helpers.formatDate)(closed_at)
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                style: styles.lineItem,
                children: [
                    "Location: ",
                    location
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                style: styles.lineItem,
                children: [
                    "User: ",
                    cashier
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                style: styles.lineItem,
                children: [
                    "Batch: ",
                    batch
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                style: styles.lineItem,
                children: [
                    "Drawer History ID: ",
                    closeout
                ]
            })
        ]
    });
const CloseoutReportDocument = ({ agency = {}, report_heading = {}, tender_type = {}, checks_accepted = [], headerImg, portraitOrLandscapeLogo })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Document), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Page), {
                style: styles.page,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseoutReportHeading, {
                        title: "Tender Type Summary",
                        ...report_heading,
                        headerImg: headerImg,
                        portraitOrLandscapeLogo: portraitOrLandscapeLogo
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                        style: styles.largeDividerBlack
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                        style: styles.table,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: [
                                    styles.trow,
                                    styles.thead
                                ],
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Tender Type"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Amount"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: styles.trow,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Cash Deposit"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: (0, _helpers.formatPrice)(tender_type.cash_deposit_total || 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: styles.greyContainer,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                        style: styles.flexContainerRow,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: "Opening Amount"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: (0, _helpers.formatPrice)(tender_type.opening_amount || 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                        style: {
                                            ...styles.flexContainerRow,
                                            ...styles.accentBackgroundColor
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: "Cash Drop"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: (0, _helpers.formatPrice)(tender_type.drops || 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                        style: styles.flexContainerRow,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: "Cash Entered"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: (0, _helpers.formatPrice)(tender_type.cash || 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                        style: {
                                            ...styles.flexContainerRow,
                                            ...styles.accentBackgroundColor
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: "Cash Expected"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: (0, _helpers.formatPrice)(tender_type.expected_cash || 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                        style: styles.flexContainerRow,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: "Over/Under"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: (0, _helpers.formatPrice)(tender_type.over_under || 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                        style: {
                                            ...styles.flexContainerRow,
                                            ...styles.accentBackgroundColor
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: "Float"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: (0, _helpers.formatPrice)(tender_type.closing_float || 0)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: styles.trow,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Check"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: (0, _helpers.formatPrice)(tender_type.check || 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: styles.greyContainer,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                        style: styles.flexContainerRow,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: "Physical Checks"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: (0, _helpers.formatPrice)(tender_type.processed_externally_check || 0)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                        style: {
                                            ...styles.flexContainerRow,
                                            ...styles.accentBackgroundColor
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: "Check / ICL Checks"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                children: (0, _helpers.formatPrice)(tender_type.processed_internally_check || 0)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                                style: styles.smallDividerGrey
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: styles.trow,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Credit"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: (0, _helpers.formatPrice)(tender_type.credit || 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                                style: styles.smallDividerGrey
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: styles.trow,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Wire Transfer"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: (0, _helpers.formatPrice)(tender_type.wire_payment || 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                                style: styles.smallDividerGrey
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: styles.trow,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Total"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: (0, _helpers.formatPrice)(tender_type.total || 0)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Image), {
                        style: styles.cbBrand,
                        src: "/img/citybase-product.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Page), {
                style: styles.page,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseoutReportHeading, {
                        title: "Agency Sales",
                        ...report_heading,
                        headerImg: headerImg,
                        portraitOrLandscapeLogo: portraitOrLandscapeLogo
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                        style: styles.largeDividerBlack
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                        style: styles.table,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: [
                                    styles.trow,
                                    styles.thead
                                ],
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Agency"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Amount"
                                    })
                                ]
                            }),
                            Object.entries(agency).map(([agency, amount], index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                    style: styles.trow,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            children: agency
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            children: (0, _helpers.formatPrice)(amount)
                                        })
                                    ]
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Image), {
                        style: styles.cbBrand,
                        src: "/img/citybase-product.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Page), {
                style: styles.page,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseoutReportHeading, {
                        title: "Check Sales",
                        ...report_heading,
                        headerImg: headerImg,
                        portraitOrLandscapeLogo: portraitOrLandscapeLogo
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                        style: styles.largeDividerBlack
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                        style: styles.table,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: [
                                    styles.trow,
                                    styles.thead
                                ],
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        style: styles.thAlignLeft,
                                        children: "Check Number"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        style: styles.thAlignRight,
                                        children: "Order ID"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        style: styles.thAlignRight,
                                        children: "Check Processing"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        style: styles.thAlignRight,
                                        children: "Amount"
                                    })
                                ]
                            }),
                            !checks_accepted.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                children: "No Check Payments"
                            }),
                            checks_accepted.length ? checks_accepted.map((check, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                    style: styles.trow,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignLeft,
                                            children: check.check_number
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignRight,
                                            children: check.order_id
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignRight,
                                            children: check.processed_externally ? "Physical" : "Check / ICL"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignRight,
                                            children: (0, _helpers.formatPrice)(check.amount)
                                        })
                                    ]
                                }, index)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {}),
                            checks_accepted.length ? [
                                {
                                    label: "Total",
                                    checks: checks_accepted
                                },
                                {
                                    label: "Physical Total",
                                    checks: checks_accepted.filter((check)=>check.processed_externally)
                                },
                                {
                                    label: "Check / ICL Total",
                                    checks: checks_accepted.filter((check)=>!check.processed_externally)
                                }
                            ].map(({ label, checks }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                    style: styles.trow,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignLeft,
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignRight
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignRight
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignRight
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignRight,
                                            children: checks.length
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: styles.tdAlignRight,
                                            children: (0, _helpers.formatPrice)(checks.reduce((acc, val)=>acc + parseFloat(val.amount), 0))
                                        })
                                    ]
                                }, index)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Image), {
                        style: styles.cbBrand,
                        src: "/img/citybase-product.png"
                    })
                ]
            })
        ]
    });
const useCloseoutReportDownloader = (data, logoutAction)=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { clientMetadata: { data: metadata } } = (0, _reactRedux.useSelector)((state)=>state.global);
    const [instance, update] = (0, _renderer.usePDF)({
        document: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseoutReportDocument, {
            ...data,
            headerImg: metadata?.headerLogoLink
        })
    });
    if (Object.entries(data).length !== 0) update();
    (0, _react.useEffect)(()=>{
        if (instance.loading) return;
        if (instance.error) return;
        if (instance.url && Object.entries(data).length !== 0) {
            const report_heading = data.report_heading;
            const terminal = report_heading.location.split(": ")[1];
            (0, _helpers.downloadReport)("Closeout", terminal, report_heading.closed_at, instance.url);
            if (logoutAction) logoutAction();
        }
    }, [
        instance,
        data
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>dispatch((0, _cashActionDetailsState.clearReports)());
    }, []);
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@react-pdf/renderer":"jjqkY","../../utils/helpers":"epomp","react-redux":"k6jol","../../pages/cash-action-details/CashActionDetails.state":"dI29X","@thecb/components":"g98ma","../../utils/constants":"f3A1R","../../static/img/cityville-logo-blue.png":"3ed6r","./SharedReportStyles":"iIK4l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jjqkY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlobProvider", ()=>BlobProvider);
parcelHelpers.export(exports, "Font", ()=>Font);
parcelHelpers.export(exports, "PDFDownloadLink", ()=>PDFDownloadLink);
parcelHelpers.export(exports, "PDFViewer", ()=>PDFViewer);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
parcelHelpers.export(exports, "createRenderer", ()=>createRenderer);
parcelHelpers.export(exports, "default", ()=>index);
parcelHelpers.export(exports, "pdf", ()=>pdf);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "renderToBuffer", ()=>renderToBuffer);
parcelHelpers.export(exports, "renderToFile", ()=>renderToFile);
parcelHelpers.export(exports, "renderToStream", ()=>renderToStream);
parcelHelpers.export(exports, "renderToString", ()=>renderToString);
parcelHelpers.export(exports, "usePDF", ()=>usePDF);
parcelHelpers.export(exports, "version", ()=>version);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _primitives = require("@react-pdf/primitives");
parcelHelpers.exportAll(_primitives, exports);
var _queue = require("queue");
var _queueDefault = parcelHelpers.interopDefault(_queue);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _font = require("@react-pdf/font");
var _fontDefault = parcelHelpers.interopDefault(_font);
var _render = require("@react-pdf/render");
var _renderDefault = parcelHelpers.interopDefault(_render);
var _pdfkit = require("@react-pdf/pdfkit");
var _pdfkitDefault = parcelHelpers.interopDefault(_pdfkit);
var _layout = require("@react-pdf/layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _objectAssign = require("object-assign");
var _objectAssignDefault = parcelHelpers.interopDefault(_objectAssign);
var _scheduler = require("scheduler");
var _jsxRuntime = require("react/jsx-runtime");
function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
var reactReconciler_production_min = {
    exports: {}
};
var require$$2 = /*@__PURE__*/ getAugmentedNamespace(_scheduler);
/** @license React v0.23.0
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function(module) {
    module.exports = function $$$reconciler($$$hostConfig) {
        var aa = (0, _objectAssignDefault.default), ba = (0, _reactDefault.default), m = require$$2;
        function n(a) {
            for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
            return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        var q = ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        q.hasOwnProperty("ReactCurrentDispatcher") || (q.ReactCurrentDispatcher = {
            current: null
        });
        q.hasOwnProperty("ReactCurrentBatchConfig") || (q.ReactCurrentBatchConfig = {
            suspense: null
        });
        var u = "function" === typeof Symbol && Symbol.for, ca = u ? Symbol.for("react.element") : 60103, da = u ? Symbol.for("react.portal") : 60106, ea = u ? Symbol.for("react.fragment") : 60107, fa = u ? Symbol.for("react.strict_mode") : 60108, ha = u ? Symbol.for("react.profiler") : 60114, ia = u ? Symbol.for("react.provider") : 60109, ja = u ? Symbol.for("react.context") : 60110, ka = u ? Symbol.for("react.concurrent_mode") : 60111, la = u ? Symbol.for("react.forward_ref") : 60112, ma = u ? Symbol.for("react.suspense") : 60113, na = u ? Symbol.for("react.suspense_list") : 60120, oa = u ? Symbol.for("react.memo") : 60115, pa = u ? Symbol.for("react.lazy") : 60116;
        var qa = "function" === typeof Symbol && Symbol.iterator;
        function ra(a) {
            if (null === a || "object" !== typeof a) return null;
            a = qa && a[qa] || a["@@iterator"];
            return "function" === typeof a ? a : null;
        }
        function sa(a) {
            if (-1 === a._status) {
                a._status = 0;
                var b = a._ctor;
                b = b();
                a._result = b;
                b.then(function(b) {
                    0 === a._status && (b = b.default, a._status = 1, a._result = b);
                }, function(b) {
                    0 === a._status && (a._status = 2, a._result = b);
                });
            }
        }
        function ta(a) {
            if (null == a) return null;
            if ("function" === typeof a) return a.displayName || a.name || null;
            if ("string" === typeof a) return a;
            switch(a){
                case ea:
                    return "Fragment";
                case da:
                    return "Portal";
                case ha:
                    return "Profiler";
                case fa:
                    return "StrictMode";
                case ma:
                    return "Suspense";
                case na:
                    return "SuspenseList";
            }
            if ("object" === typeof a) switch(a.$$typeof){
                case ja:
                    return "Context.Consumer";
                case ia:
                    return "Context.Provider";
                case la:
                    var b = a.render;
                    b = b.displayName || b.name || "";
                    return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
                case oa:
                    return ta(a.type);
                case pa:
                    if (a = 1 === a._status ? a._result : null) return ta(a);
            }
            return null;
        }
        function ua(a) {
            var b = a, c = a;
            if (a.alternate) for(; b.return;)b = b.return;
            else {
                a = b;
                do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
                while (a);
            }
            return 3 === b.tag ? c : null;
        }
        function va(a) {
            if (ua(a) !== a) throw Error(n(188));
        }
        function wa(a) {
            var b = a.alternate;
            if (!b) {
                b = ua(a);
                if (null === b) throw Error(n(188));
                return b !== a ? null : a;
            }
            for(var c = a, d = b;;){
                var e = c.return;
                if (null === e) break;
                var f = e.alternate;
                if (null === f) {
                    d = e.return;
                    if (null !== d) {
                        c = d;
                        continue;
                    }
                    break;
                }
                if (e.child === f.child) {
                    for(f = e.child; f;){
                        if (f === c) return va(e), a;
                        if (f === d) return va(e), b;
                        f = f.sibling;
                    }
                    throw Error(n(188));
                }
                if (c.return !== d.return) c = e, d = f;
                else {
                    for(var g = !1, l = e.child; l;){
                        if (l === c) {
                            g = !0;
                            c = e;
                            d = f;
                            break;
                        }
                        if (l === d) {
                            g = !0;
                            d = e;
                            c = f;
                            break;
                        }
                        l = l.sibling;
                    }
                    if (!g) {
                        for(l = f.child; l;){
                            if (l === c) {
                                g = !0;
                                c = f;
                                d = e;
                                break;
                            }
                            if (l === d) {
                                g = !0;
                                d = f;
                                c = e;
                                break;
                            }
                            l = l.sibling;
                        }
                        if (!g) throw Error(n(189));
                    }
                }
                if (c.alternate !== d) throw Error(n(190));
            }
            if (3 !== c.tag) throw Error(n(188));
            return c.stateNode.current === c ? a : b;
        }
        function xa(a) {
            a = wa(a);
            if (!a) return null;
            for(var b = a;;){
                if (5 === b.tag || 6 === b.tag) return b;
                if (b.child) b.child.return = b, b = b.child;
                else {
                    if (b === a) break;
                    for(; !b.sibling;){
                        if (!b.return || b.return === a) return null;
                        b = b.return;
                    }
                    b.sibling.return = b.return;
                    b = b.sibling;
                }
            }
            return null;
        }
        function ya(a) {
            a = wa(a);
            if (!a) return null;
            for(var b = a;;){
                if (5 === b.tag || 6 === b.tag) return b;
                if (b.child && 4 !== b.tag) b.child.return = b, b = b.child;
                else {
                    if (b === a) break;
                    for(; !b.sibling;){
                        if (!b.return || b.return === a) return null;
                        b = b.return;
                    }
                    b.sibling.return = b.return;
                    b = b.sibling;
                }
            }
            return null;
        }
        var za = $$$hostConfig.getPublicInstance, Aa = $$$hostConfig.getRootHostContext, Ba = $$$hostConfig.getChildHostContext, Ca = $$$hostConfig.prepareForCommit, Da = $$$hostConfig.resetAfterCommit, Ea = $$$hostConfig.createInstance, Fa = $$$hostConfig.appendInitialChild, Ga = $$$hostConfig.finalizeInitialChildren, Ia = $$$hostConfig.prepareUpdate, Ja = $$$hostConfig.shouldSetTextContent, Ka = $$$hostConfig.shouldDeprioritizeSubtree, La = $$$hostConfig.createTextInstance, Ma = $$$hostConfig.setTimeout, Na = $$$hostConfig.clearTimeout, Oa = $$$hostConfig.noTimeout, Pa = $$$hostConfig.isPrimaryRenderer, Qa = $$$hostConfig.supportsMutation, Ra = $$$hostConfig.supportsPersistence, Sa = $$$hostConfig.supportsHydration, Ta = $$$hostConfig.appendChild, Ua = $$$hostConfig.appendChildToContainer, Va = $$$hostConfig.commitTextUpdate, Wa = $$$hostConfig.commitMount, Xa = $$$hostConfig.commitUpdate, Ya = $$$hostConfig.insertBefore, Za = $$$hostConfig.insertInContainerBefore, $a = $$$hostConfig.removeChild, ab = $$$hostConfig.removeChildFromContainer, bb = $$$hostConfig.resetTextContent, cb = $$$hostConfig.hideInstance, db = $$$hostConfig.hideTextInstance, eb = $$$hostConfig.unhideInstance, fb = $$$hostConfig.unhideTextInstance, gb = $$$hostConfig.cloneInstance, hb = $$$hostConfig.createContainerChildSet, ib = $$$hostConfig.appendChildToContainerChildSet, kb = $$$hostConfig.finalizeContainerChildren, lb = $$$hostConfig.replaceContainerChildren, mb = $$$hostConfig.cloneHiddenInstance, nb = $$$hostConfig.cloneHiddenTextInstance, ob = $$$hostConfig.canHydrateInstance, pb = $$$hostConfig.canHydrateTextInstance, qb = $$$hostConfig.isSuspenseInstancePending, rb = $$$hostConfig.isSuspenseInstanceFallback, sb = $$$hostConfig.getNextHydratableSibling, tb = $$$hostConfig.getFirstHydratableChild, ub = $$$hostConfig.hydrateInstance, vb = $$$hostConfig.hydrateTextInstance, wb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, xb = $$$hostConfig.commitHydratedContainer, yb = $$$hostConfig.commitHydratedSuspenseInstance, zb = /^(.*)[\\\/]/;
        function Ab(a) {
            var b = "";
            do {
                a: switch(a.tag){
                    case 3:
                    case 4:
                    case 6:
                    case 7:
                    case 10:
                    case 9:
                        var c = "";
                        break a;
                    default:
                        var d = a._debugOwner, e = a._debugSource, f = ta(a.type);
                        c = null;
                        d && (c = ta(d.type));
                        d = f;
                        f = "";
                        e ? f = " (at " + e.fileName.replace(zb, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                        c = "\n    in " + (d || "Unknown") + f;
                }
                b += c;
                a = a.return;
            }while (a);
            return b;
        }
        var Bb = [], Cb = -1;
        function y(a) {
            0 > Cb || (a.current = Bb[Cb], Bb[Cb] = null, Cb--);
        }
        function z(a, b) {
            Cb++;
            Bb[Cb] = a.current;
            a.current = b;
        }
        var Db = {}, A = {
            current: Db
        }, B = {
            current: !1
        }, Eb = Db;
        function Fb(a, b) {
            var c = a.type.contextTypes;
            if (!c) return Db;
            var d = a.stateNode;
            if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
            var e = {}, f;
            for(f in c)e[f] = b[f];
            d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
            return e;
        }
        function C(a) {
            a = a.childContextTypes;
            return null !== a && void 0 !== a;
        }
        function Gb(a) {
            y(B);
            y(A);
        }
        function Hb(a) {
            y(B);
            y(A);
        }
        function Ib(a, b, c) {
            if (A.current !== Db) throw Error(n(168));
            z(A, b);
            z(B, c);
        }
        function Jb(a, b, c) {
            var d = a.stateNode;
            a = b.childContextTypes;
            if ("function" !== typeof d.getChildContext) return c;
            d = d.getChildContext();
            for(var e in d)if (!(e in a)) throw Error(n(108, ta(b) || "Unknown", e));
            return aa({}, c, {}, d);
        }
        function Kb(a) {
            var b = a.stateNode;
            b = b && b.__reactInternalMemoizedMergedChildContext || Db;
            Eb = A.current;
            z(A, b);
            z(B, B.current);
            return !0;
        }
        function Lb(a, b, c) {
            var d = a.stateNode;
            if (!d) throw Error(n(169));
            c ? (b = Jb(a, b, Eb), d.__reactInternalMemoizedMergedChildContext = b, y(B), y(A), z(A, b)) : y(B);
            z(B, c);
        }
        var Mb = m.unstable_runWithPriority, Nb = m.unstable_scheduleCallback, Ob = m.unstable_cancelCallback, Pb = m.unstable_shouldYield, Qb = m.unstable_requestPaint, Tb = m.unstable_now, Ub = m.unstable_getCurrentPriorityLevel, Vb = m.unstable_ImmediatePriority, Wb = m.unstable_UserBlockingPriority, Xb = m.unstable_NormalPriority, Yb = m.unstable_LowPriority, Zb = m.unstable_IdlePriority, $b = {}, ac = void 0 !== Qb ? Qb : function() {}, bc = null, cc = null, dc = !1, ec = Tb(), E = 1E4 > ec ? Tb : function() {
            return Tb() - ec;
        };
        function fc() {
            switch(Ub()){
                case Vb:
                    return 99;
                case Wb:
                    return 98;
                case Xb:
                    return 97;
                case Yb:
                    return 96;
                case Zb:
                    return 95;
                default:
                    throw Error(n(332));
            }
        }
        function gc(a) {
            switch(a){
                case 99:
                    return Vb;
                case 98:
                    return Wb;
                case 97:
                    return Xb;
                case 96:
                    return Yb;
                case 95:
                    return Zb;
                default:
                    throw Error(n(332));
            }
        }
        function hc(a, b) {
            a = gc(a);
            return Mb(a, b);
        }
        function ic(a, b, c) {
            a = gc(a);
            return Nb(a, b, c);
        }
        function jc(a) {
            null === bc ? (bc = [
                a
            ], cc = Nb(Vb, kc)) : bc.push(a);
            return $b;
        }
        function F() {
            if (null !== cc) {
                var a = cc;
                cc = null;
                Ob(a);
            }
            kc();
        }
        function kc() {
            if (!dc && null !== bc) {
                dc = !0;
                var a = 0;
                try {
                    var b = bc;
                    hc(99, function() {
                        for(; a < b.length; a++){
                            var c = b[a];
                            do c = c(!0);
                            while (null !== c);
                        }
                    });
                    bc = null;
                } catch (c) {
                    throw null !== bc && (bc = bc.slice(a + 1)), Nb(Vb, F), c;
                } finally{
                    dc = !1;
                }
            }
        }
        var lc = 3;
        function mc(a, b, c) {
            c /= 10;
            return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
        }
        function nc(a, b) {
            return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
        }
        var oc = "function" === typeof Object.is ? Object.is : nc, pc = Object.prototype.hasOwnProperty;
        function qc(a, b) {
            if (oc(a, b)) return !0;
            if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
            var c = Object.keys(a), d = Object.keys(b);
            if (c.length !== d.length) return !1;
            for(d = 0; d < c.length; d++)if (!pc.call(b, c[d]) || !oc(a[c[d]], b[c[d]])) return !1;
            return !0;
        }
        function rc(a, b) {
            if (a && a.defaultProps) {
                b = aa({}, b);
                a = a.defaultProps;
                for(var c in a)void 0 === b[c] && (b[c] = a[c]);
            }
            return b;
        }
        var sc = {
            current: null
        }, tc = null, uc = null, vc = null;
        function wc() {
            vc = uc = tc = null;
        }
        function xc(a, b) {
            var c = a.type._context;
            Pa ? (z(sc, c._currentValue), c._currentValue = b) : (z(sc, c._currentValue2), c._currentValue2 = b);
        }
        function yc(a) {
            var b = sc.current;
            y(sc);
            a = a.type._context;
            Pa ? a._currentValue = b : a._currentValue2 = b;
        }
        function zc(a, b) {
            for(; null !== a;){
                var c = a.alternate;
                if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
                else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
                else break;
                a = a.return;
            }
        }
        function Ac(a, b) {
            tc = a;
            vc = uc = null;
            a = a.dependencies;
            null !== a && null !== a.firstContext && (a.expirationTime >= b && (Bc = !0), a.firstContext = null);
        }
        function Cc(a, b) {
            if (vc !== a && !1 !== b && 0 !== b) {
                if ("number" !== typeof b || 1073741823 === b) vc = a, b = 1073741823;
                b = {
                    context: a,
                    observedBits: b,
                    next: null
                };
                if (null === uc) {
                    if (null === tc) throw Error(n(308));
                    uc = b;
                    tc.dependencies = {
                        expirationTime: 0,
                        firstContext: b,
                        responders: null
                    };
                } else uc = uc.next = b;
            }
            return Pa ? a._currentValue : a._currentValue2;
        }
        var Dc = !1;
        function Ec(a) {
            return {
                baseState: a,
                firstUpdate: null,
                lastUpdate: null,
                firstCapturedUpdate: null,
                lastCapturedUpdate: null,
                firstEffect: null,
                lastEffect: null,
                firstCapturedEffect: null,
                lastCapturedEffect: null
            };
        }
        function Fc(a) {
            return {
                baseState: a.baseState,
                firstUpdate: a.firstUpdate,
                lastUpdate: a.lastUpdate,
                firstCapturedUpdate: null,
                lastCapturedUpdate: null,
                firstEffect: null,
                lastEffect: null,
                firstCapturedEffect: null,
                lastCapturedEffect: null
            };
        }
        function Gc(a, b) {
            return {
                expirationTime: a,
                suspenseConfig: b,
                tag: 0,
                payload: null,
                callback: null,
                next: null,
                nextEffect: null
            };
        }
        function Hc(a, b) {
            null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
        }
        function Ic(a, b) {
            var c = a.alternate;
            if (null === c) {
                var d = a.updateQueue;
                var e = null;
                null === d && (d = a.updateQueue = Ec(a.memoizedState));
            } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = Ec(a.memoizedState), e = c.updateQueue = Ec(c.memoizedState)) : d = a.updateQueue = Fc(e) : null === e && (e = c.updateQueue = Fc(d));
            null === e || d === e ? Hc(d, b) : null === d.lastUpdate || null === e.lastUpdate ? (Hc(d, b), Hc(e, b)) : (Hc(d, b), e.lastUpdate = b);
        }
        function Jc(a, b) {
            var c = a.updateQueue;
            c = null === c ? a.updateQueue = Ec(a.memoizedState) : Kc(a, c);
            null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
        }
        function Kc(a, b) {
            var c = a.alternate;
            null !== c && b === c.updateQueue && (b = a.updateQueue = Fc(b));
            return b;
        }
        function Lc(a, b, c, d, e, f) {
            switch(c.tag){
                case 1:
                    return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;
                case 3:
                    a.effectTag = a.effectTag & -4097 | 64;
                case 0:
                    a = c.payload;
                    e = "function" === typeof a ? a.call(f, d, e) : a;
                    if (null === e || void 0 === e) break;
                    return aa({}, d, e);
                case 2:
                    Dc = !0;
            }
            return d;
        }
        function Nc(a, b, c, d, e) {
            Dc = !1;
            b = Kc(a, b);
            for(var f = b.baseState, g = null, l = 0, h = b.firstUpdate, k = f; null !== h;){
                var p = h.expirationTime;
                p < e ? (null === g && (g = h, f = k), l < p && (l = p)) : (Oc(p, h.suspenseConfig), k = Lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = h : (b.lastEffect.nextEffect = h, b.lastEffect = h)));
                h = h.next;
            }
            p = null;
            for(h = b.firstCapturedUpdate; null !== h;){
                var D = h.expirationTime;
                D < e ? (null === p && (p = h, null === g && (f = k)), l < D && (l = D)) : (k = Lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = h : (b.lastCapturedEffect.nextEffect = h, b.lastCapturedEffect = h)));
                h = h.next;
            }
            null === g && (b.lastUpdate = null);
            null === p ? b.lastCapturedUpdate = null : a.effectTag |= 32;
            null === g && null === p && (f = k);
            b.baseState = f;
            b.firstUpdate = g;
            b.firstCapturedUpdate = p;
            Pc(l);
            a.expirationTime = l;
            a.memoizedState = k;
        }
        function Qc(a, b, c) {
            null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
            Rc(b.firstEffect, c);
            b.firstEffect = b.lastEffect = null;
            Rc(b.firstCapturedEffect, c);
            b.firstCapturedEffect = b.lastCapturedEffect = null;
        }
        function Rc(a, b) {
            for(; null !== a;){
                var c = a.callback;
                if (null !== c) {
                    a.callback = null;
                    var d = b;
                    if ("function" !== typeof c) throw Error(n(191, c));
                    c.call(d);
                }
                a = a.nextEffect;
            }
        }
        var Sc = q.ReactCurrentBatchConfig, Tc = new ba.Component().refs;
        function Uc(a, b, c, d) {
            b = a.memoizedState;
            c = c(d, b);
            c = null === c || void 0 === c ? b : aa({}, b, c);
            a.memoizedState = c;
            d = a.updateQueue;
            null !== d && 0 === a.expirationTime && (d.baseState = c);
        }
        var Xc = {
            isMounted: function isMounted(a) {
                return (a = a._reactInternalFiber) ? ua(a) === a : !1;
            },
            enqueueSetState: function enqueueSetState(a, b, c) {
                a = a._reactInternalFiber;
                var d = G(), e = Sc.suspense;
                d = Vc(d, a, e);
                e = Gc(d, e);
                e.payload = b;
                void 0 !== c && null !== c && (e.callback = c);
                Ic(a, e);
                Wc(a, d);
            },
            enqueueReplaceState: function enqueueReplaceState(a, b, c) {
                a = a._reactInternalFiber;
                var d = G(), e = Sc.suspense;
                d = Vc(d, a, e);
                e = Gc(d, e);
                e.tag = 1;
                e.payload = b;
                void 0 !== c && null !== c && (e.callback = c);
                Ic(a, e);
                Wc(a, d);
            },
            enqueueForceUpdate: function enqueueForceUpdate(a, b) {
                a = a._reactInternalFiber;
                var c = G(), d = Sc.suspense;
                c = Vc(c, a, d);
                d = Gc(c, d);
                d.tag = 2;
                void 0 !== b && null !== b && (d.callback = b);
                Ic(a, d);
                Wc(a, c);
            }
        };
        function Yc(a, b, c, d, e, f, g) {
            a = a.stateNode;
            return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !qc(c, d) || !qc(e, f) : !0;
        }
        function Zc(a, b, c) {
            var d = !1, e = Db;
            var f = b.contextType;
            "object" === typeof f && null !== f ? f = Cc(f) : (e = C(b) ? Eb : A.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Fb(a, e) : Db);
            b = new b(c, f);
            a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
            b.updater = Xc;
            a.stateNode = b;
            b._reactInternalFiber = a;
            d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
            return b;
        }
        function $c(a, b, c, d) {
            a = b.state;
            "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
            "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
            b.state !== a && Xc.enqueueReplaceState(b, b.state, null);
        }
        function ad(a, b, c, d) {
            var e = a.stateNode;
            e.props = c;
            e.state = a.memoizedState;
            e.refs = Tc;
            var f = b.contextType;
            "object" === typeof f && null !== f ? e.context = Cc(f) : (f = C(b) ? Eb : A.current, e.context = Fb(a, f));
            f = a.updateQueue;
            null !== f && (Nc(a, f, c, e, d), e.state = a.memoizedState);
            f = b.getDerivedStateFromProps;
            "function" === typeof f && (Uc(a, b, f, c), e.state = a.memoizedState);
            "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Xc.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && (Nc(a, f, c, e, d), e.state = a.memoizedState));
            "function" === typeof e.componentDidMount && (a.effectTag |= 4);
        }
        var bd = Array.isArray;
        function cd(a, b, c) {
            a = c.ref;
            if (null !== a && "function" !== typeof a && "object" !== typeof a) {
                if (c._owner) {
                    c = c._owner;
                    if (c) {
                        if (1 !== c.tag) throw Error(n(309));
                        var d = c.stateNode;
                    }
                    if (!d) throw Error(n(147, a));
                    var e = "" + a;
                    if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
                    b = function b(_b) {
                        var a = d.refs;
                        a === Tc && (a = d.refs = {});
                        null === _b ? delete a[e] : a[e] = _b;
                    };
                    b._stringRef = e;
                    return b;
                }
                if ("string" !== typeof a) throw Error(n(284));
                if (!c._owner) throw Error(n(290, a));
            }
            return a;
        }
        function dd(a, b) {
            if ("textarea" !== a.type) throw Error(n(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
        }
        function ed(a) {
            function b(b, c) {
                if (a) {
                    var d = b.lastEffect;
                    null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
                    c.nextEffect = null;
                    c.effectTag = 8;
                }
            }
            function c(c, d) {
                if (!a) return null;
                for(; null !== d;)b(c, d), d = d.sibling;
                return null;
            }
            function d(b, a) {
                for(b = new Map(); null !== a;)null !== a.key ? b.set(a.key, a) : b.set(a.index, a), a = a.sibling;
                return b;
            }
            function e(b, a, c) {
                b = fd(b, a);
                b.index = 0;
                b.sibling = null;
                return b;
            }
            function f(b, c, d) {
                b.index = d;
                if (!a) return c;
                d = b.alternate;
                if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
                b.effectTag = 2;
                return c;
            }
            function g(b) {
                a && null === b.alternate && (b.effectTag = 2);
                return b;
            }
            function l(b, a, c, d) {
                if (null === a || 6 !== a.tag) return a = gd(c, b.mode, d), a.return = b, a;
                a = e(a, c);
                a.return = b;
                return a;
            }
            function h(b, a, c, d) {
                if (null !== a && a.elementType === c.type) return d = e(a, c.props), d.ref = cd(b, a, c), d.return = b, d;
                d = hd(c.type, c.key, c.props, null, b.mode, d);
                d.ref = cd(b, a, c);
                d.return = b;
                return d;
            }
            function k(b, a, c, d) {
                if (null === a || 4 !== a.tag || a.stateNode.containerInfo !== c.containerInfo || a.stateNode.implementation !== c.implementation) return a = id(c, b.mode, d), a.return = b, a;
                a = e(a, c.children || []);
                a.return = b;
                return a;
            }
            function p(b, a, c, d, f) {
                if (null === a || 7 !== a.tag) return a = jd(c, b.mode, d, f), a.return = b, a;
                a = e(a, c);
                a.return = b;
                return a;
            }
            function D(b, a, c) {
                if ("string" === typeof a || "number" === typeof a) return a = gd("" + a, b.mode, c), a.return = b, a;
                if ("object" === typeof a && null !== a) {
                    switch(a.$$typeof){
                        case ca:
                            return c = hd(a.type, a.key, a.props, null, b.mode, c), c.ref = cd(b, null, a), c.return = b, c;
                        case da:
                            return a = id(a, b.mode, c), a.return = b, a;
                    }
                    if (bd(a) || ra(a)) return a = jd(a, b.mode, c, null), a.return = b, a;
                    dd(b, a);
                }
                return null;
            }
            function x(b, a, c, d) {
                var e = null !== a ? a.key : null;
                if ("string" === typeof c || "number" === typeof c) return null !== e ? null : l(b, a, "" + c, d);
                if ("object" === typeof c && null !== c) {
                    switch(c.$$typeof){
                        case ca:
                            return c.key === e ? c.type === ea ? p(b, a, c.props.children, d, e) : h(b, a, c, d) : null;
                        case da:
                            return c.key === e ? k(b, a, c, d) : null;
                    }
                    if (bd(c) || ra(c)) return null !== e ? null : p(b, a, c, d, null);
                    dd(b, c);
                }
                return null;
            }
            function K(b, a, c, d, e) {
                if ("string" === typeof d || "number" === typeof d) return b = b.get(c) || null, l(a, b, "" + d, e);
                if ("object" === typeof d && null !== d) {
                    switch(d.$$typeof){
                        case ca:
                            return b = b.get(null === d.key ? c : d.key) || null, d.type === ea ? p(a, b, d.props.children, e, d.key) : h(a, b, d, e);
                        case da:
                            return b = b.get(null === d.key ? c : d.key) || null, k(a, b, d, e);
                    }
                    if (bd(d) || ra(d)) return b = b.get(c) || null, p(a, b, d, e, null);
                    dd(a, d);
                }
                return null;
            }
            function Ha(e, g, h, l) {
                for(var k = null, w = null, t = g, r = g = 0, p = null; null !== t && r < h.length; r++){
                    t.index > r ? (p = t, t = null) : p = t.sibling;
                    var v = x(e, t, h[r], l);
                    if (null === v) {
                        null === t && (t = p);
                        break;
                    }
                    a && t && null === v.alternate && b(e, t);
                    g = f(v, g, r);
                    null === w ? k = v : w.sibling = v;
                    w = v;
                    t = p;
                }
                if (r === h.length) return c(e, t), k;
                if (null === t) {
                    for(; r < h.length; r++)t = D(e, h[r], l), null !== t && (g = f(t, g, r), null === w ? k = t : w.sibling = t, w = t);
                    return k;
                }
                for(t = d(e, t); r < h.length; r++)p = K(t, e, r, h[r], l), null !== p && (a && null !== p.alternate && t.delete(null === p.key ? r : p.key), g = f(p, g, r), null === w ? k = p : w.sibling = p, w = p);
                a && t.forEach(function(a) {
                    return b(e, a);
                });
                return k;
            }
            function O(e, g, h, l) {
                var k = ra(h);
                if ("function" !== typeof k) throw Error(n(150));
                h = k.call(h);
                if (null == h) throw Error(n(151));
                for(var t = k = null, r = g, w = g = 0, p = null, v = h.next(); null !== r && !v.done; w++, v = h.next()){
                    r.index > w ? (p = r, r = null) : p = r.sibling;
                    var N = x(e, r, v.value, l);
                    if (null === N) {
                        null === r && (r = p);
                        break;
                    }
                    a && r && null === N.alternate && b(e, r);
                    g = f(N, g, w);
                    null === t ? k = N : t.sibling = N;
                    t = N;
                    r = p;
                }
                if (v.done) return c(e, r), k;
                if (null === r) {
                    for(; !v.done; w++, v = h.next())v = D(e, v.value, l), null !== v && (g = f(v, g, w), null === t ? k = v : t.sibling = v, t = v);
                    return k;
                }
                for(r = d(e, r); !v.done; w++, v = h.next())v = K(r, e, w, v.value, l), null !== v && (a && null !== v.alternate && r.delete(null === v.key ? w : v.key), g = f(v, g, w), null === t ? k = v : t.sibling = v, t = v);
                a && r.forEach(function(a) {
                    return b(e, a);
                });
                return k;
            }
            return function(a, d, f, h) {
                var k = "object" === typeof f && null !== f && f.type === ea && null === f.key;
                k && (f = f.props.children);
                var l = "object" === typeof f && null !== f;
                if (l) switch(f.$$typeof){
                    case ca:
                        a: {
                            l = f.key;
                            for(k = d; null !== k;){
                                if (k.key === l) {
                                    if (7 === k.tag ? f.type === ea : k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.type === ea ? f.props.children : f.props);
                                        d.ref = cd(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, k);
                                        break;
                                    }
                                } else b(a, k);
                                k = k.sibling;
                            }
                            f.type === ea ? (d = jd(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = hd(f.type, f.key, f.props, null, a.mode, h), h.ref = cd(a, d, f), h.return = a, a = h);
                        }
                        return g(a);
                    case da:
                        a: {
                            for(k = f.key; null !== d;){
                                if (d.key === k) {
                                    if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                        c(a, d.sibling);
                                        d = e(d, f.children || []);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    } else {
                                        c(a, d);
                                        break;
                                    }
                                } else b(a, d);
                                d = d.sibling;
                            }
                            d = id(f, a.mode, h);
                            d.return = a;
                            a = d;
                        }
                        return g(a);
                }
                if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = gd(f, a.mode, h), d.return = a, a = d), g(a);
                if (bd(f)) return Ha(a, d, f, h);
                if (ra(f)) return O(a, d, f, h);
                l && dd(a, f);
                if ("undefined" === typeof f && !k) switch(a.tag){
                    case 1:
                    case 0:
                        throw a = a.type, Error(n(152, a.displayName || a.name || "Component"));
                }
                return c(a, d);
            };
        }
        var kd = ed(!0), ld = ed(!1), md = {}, H = {
            current: md
        }, nd = {
            current: md
        }, od = {
            current: md
        };
        function pd(a) {
            if (a === md) throw Error(n(174));
            return a;
        }
        function qd(a, b) {
            z(od, b);
            z(nd, a);
            z(H, md);
            b = Aa(b);
            y(H);
            z(H, b);
        }
        function rd(a) {
            y(H);
            y(nd);
            y(od);
        }
        function sd(a) {
            var b = pd(od.current), c = pd(H.current);
            b = Ba(c, a.type, b);
            c !== b && (z(nd, a), z(H, b));
        }
        function td(a) {
            nd.current === a && (y(H), y(nd));
        }
        var I = {
            current: 0
        };
        function ud(a) {
            for(var b = a; null !== b;){
                if (13 === b.tag) {
                    var c = b.memoizedState;
                    if (null !== c && (c = c.dehydrated, null === c || qb(c) || rb(c))) return b;
                } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                    if (0 !== (b.effectTag & 64)) return b;
                } else if (null !== b.child) {
                    b.child.return = b;
                    b = b.child;
                    continue;
                }
                if (b === a) break;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) return null;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
            return null;
        }
        function vd(a, b) {
            return {
                responder: a,
                props: b
            };
        }
        var wd = q.ReactCurrentDispatcher, J = q.ReactCurrentBatchConfig, xd = 0, yd = null, L = null, zd = null, Ad = null, M = null, Bd = null, Cd = 0, Dd = null, Ed = 0, Fd = !1, Gd = null, Hd = 0;
        function P() {
            throw Error(n(321));
        }
        function Id(a, b) {
            if (null === b) return !1;
            for(var c = 0; c < b.length && c < a.length; c++)if (!oc(a[c], b[c])) return !1;
            return !0;
        }
        function Jd(a, b, c, d, e, f) {
            xd = f;
            yd = b;
            zd = null !== a ? a.memoizedState : null;
            wd.current = null === zd ? Kd : Ld;
            b = c(d, e);
            if (Fd) {
                do Fd = !1, Hd += 1, zd = null !== a ? a.memoizedState : null, Bd = Ad, Dd = M = L = null, wd.current = Ld, b = c(d, e);
                while (Fd);
                Gd = null;
                Hd = 0;
            }
            wd.current = Md;
            a = yd;
            a.memoizedState = Ad;
            a.expirationTime = Cd;
            a.updateQueue = Dd;
            a.effectTag |= Ed;
            a = null !== L && null !== L.next;
            xd = 0;
            Bd = M = Ad = zd = L = yd = null;
            Cd = 0;
            Dd = null;
            Ed = 0;
            if (a) throw Error(n(300));
            return b;
        }
        function Nd() {
            wd.current = Md;
            xd = 0;
            Bd = M = Ad = zd = L = yd = null;
            Cd = 0;
            Dd = null;
            Ed = 0;
            Fd = !1;
            Gd = null;
            Hd = 0;
        }
        function Od() {
            var a = {
                memoizedState: null,
                baseState: null,
                queue: null,
                baseUpdate: null,
                next: null
            };
            null === M ? Ad = M = a : M = M.next = a;
            return M;
        }
        function Pd() {
            if (null !== Bd) M = Bd, Bd = M.next, L = zd, zd = null !== L ? L.next : null;
            else {
                if (null === zd) throw Error(n(310));
                L = zd;
                var a = {
                    memoizedState: L.memoizedState,
                    baseState: L.baseState,
                    queue: L.queue,
                    baseUpdate: L.baseUpdate,
                    next: null
                };
                M = null === M ? Ad = a : M.next = a;
                zd = L.next;
            }
            return M;
        }
        function Qd(a, b) {
            return "function" === typeof b ? b(a) : b;
        }
        function Rd(a) {
            var b = Pd(), c = b.queue;
            if (null === c) throw Error(n(311));
            c.lastRenderedReducer = a;
            if (0 < Hd) {
                var d = c.dispatch;
                if (null !== Gd) {
                    var e = Gd.get(c);
                    if (void 0 !== e) {
                        Gd.delete(c);
                        var f = b.memoizedState;
                        do f = a(f, e.action), e = e.next;
                        while (null !== e);
                        oc(f, b.memoizedState) || (Bc = !0);
                        b.memoizedState = f;
                        b.baseUpdate === c.last && (b.baseState = f);
                        c.lastRenderedState = f;
                        return [
                            f,
                            d
                        ];
                    }
                }
                return [
                    b.memoizedState,
                    d
                ];
            }
            d = c.last;
            var g = b.baseUpdate;
            f = b.baseState;
            null !== g ? (null !== d && (d.next = null), d = g.next) : d = null !== d ? d.next : null;
            if (null !== d) {
                var l = e = null, h = d, k = !1;
                do {
                    var p = h.expirationTime;
                    p < xd ? (k || (k = !0, l = g, e = f), p > Cd && (Cd = p, Pc(Cd))) : (Oc(p, h.suspenseConfig), f = h.eagerReducer === a ? h.eagerState : a(f, h.action));
                    g = h;
                    h = h.next;
                }while (null !== h && h !== d);
                k || (l = g, e = f);
                oc(f, b.memoizedState) || (Bc = !0);
                b.memoizedState = f;
                b.baseUpdate = l;
                b.baseState = e;
                c.lastRenderedState = f;
            }
            return [
                b.memoizedState,
                c.dispatch
            ];
        }
        function Sd(a) {
            var b = Od();
            "function" === typeof a && (a = a());
            b.memoizedState = b.baseState = a;
            a = b.queue = {
                last: null,
                dispatch: null,
                lastRenderedReducer: Qd,
                lastRenderedState: a
            };
            a = a.dispatch = Td.bind(null, yd, a);
            return [
                b.memoizedState,
                a
            ];
        }
        function Ud(a) {
            return Rd(Qd);
        }
        function Vd(a, b, c, d) {
            a = {
                tag: a,
                create: b,
                destroy: c,
                deps: d,
                next: null
            };
            null === Dd ? (Dd = {
                lastEffect: null
            }, Dd.lastEffect = a.next = a) : (b = Dd.lastEffect, null === b ? Dd.lastEffect = a.next = a : (c = b.next, b.next = a, a.next = c, Dd.lastEffect = a));
            return a;
        }
        function Wd(a, b, c, d) {
            var e = Od();
            Ed |= a;
            e.memoizedState = Vd(b, c, void 0, void 0 === d ? null : d);
        }
        function Xd(a, b, c, d) {
            var e = Pd();
            d = void 0 === d ? null : d;
            var f = void 0;
            if (null !== L) {
                var g = L.memoizedState;
                f = g.destroy;
                if (null !== d && Id(d, g.deps)) {
                    Vd(0, c, f, d);
                    return;
                }
            }
            Ed |= a;
            e.memoizedState = Vd(b, c, f, d);
        }
        function Yd(a, b) {
            return Wd(516, 192, a, b);
        }
        function Zd(a, b) {
            return Xd(516, 192, a, b);
        }
        function $d(a, b) {
            if ("function" === typeof b) return a = a(), b(a), function() {
                b(null);
            };
            if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
                b.current = null;
            };
        }
        function ae() {}
        function be(a, b) {
            Od().memoizedState = [
                a,
                void 0 === b ? null : b
            ];
            return a;
        }
        function ce(a, b) {
            var c = Pd();
            b = void 0 === b ? null : b;
            var d = c.memoizedState;
            if (null !== d && null !== b && Id(b, d[1])) return d[0];
            c.memoizedState = [
                a,
                b
            ];
            return a;
        }
        function Td(a, b, c) {
            if (!(25 > Hd)) throw Error(n(301));
            var d = a.alternate;
            if (a === yd || null !== d && d === yd) {
                if (Fd = !0, a = {
                    expirationTime: xd,
                    suspenseConfig: null,
                    action: c,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                }, null === Gd && (Gd = new Map()), c = Gd.get(b), void 0 === c) Gd.set(b, a);
                else {
                    for(b = c; null !== b.next;)b = b.next;
                    b.next = a;
                }
            } else {
                var e = G(), f = Sc.suspense;
                e = Vc(e, a, f);
                f = {
                    expirationTime: e,
                    suspenseConfig: f,
                    action: c,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                };
                var g = b.last;
                if (null === g) f.next = f;
                else {
                    var l = g.next;
                    null !== l && (f.next = l);
                    g.next = f;
                }
                b.last = f;
                if (0 === a.expirationTime && (null === d || 0 === d.expirationTime) && (d = b.lastRenderedReducer, null !== d)) try {
                    var h = b.lastRenderedState, k = d(h, c);
                    f.eagerReducer = d;
                    f.eagerState = k;
                    if (oc(k, h)) return;
                } catch (p) {} finally{}
                Wc(a, e);
            }
        }
        var Md = {
            readContext: Cc,
            useCallback: P,
            useContext: P,
            useEffect: P,
            useImperativeHandle: P,
            useLayoutEffect: P,
            useMemo: P,
            useReducer: P,
            useRef: P,
            useState: P,
            useDebugValue: P,
            useResponder: P,
            useDeferredValue: P,
            useTransition: P
        }, Kd = {
            readContext: Cc,
            useCallback: be,
            useContext: Cc,
            useEffect: Yd,
            useImperativeHandle: function useImperativeHandle(a, b, c) {
                c = null !== c && void 0 !== c ? c.concat([
                    a
                ]) : null;
                return Wd(4, 36, $d.bind(null, b, a), c);
            },
            useLayoutEffect: function useLayoutEffect(a, b) {
                return Wd(4, 36, a, b);
            },
            useMemo: function useMemo(a, b) {
                var c = Od();
                b = void 0 === b ? null : b;
                a = a();
                c.memoizedState = [
                    a,
                    b
                ];
                return a;
            },
            useReducer: function useReducer(a, b, c) {
                var d = Od();
                b = void 0 !== c ? c(b) : b;
                d.memoizedState = d.baseState = b;
                a = d.queue = {
                    last: null,
                    dispatch: null,
                    lastRenderedReducer: a,
                    lastRenderedState: b
                };
                a = a.dispatch = Td.bind(null, yd, a);
                return [
                    d.memoizedState,
                    a
                ];
            },
            useRef: function useRef(a) {
                var b = Od();
                a = {
                    current: a
                };
                return b.memoizedState = a;
            },
            useState: Sd,
            useDebugValue: ae,
            useResponder: vd,
            useDeferredValue: function useDeferredValue(a, b) {
                var c = Sd(a), d = c[0], e = c[1];
                Yd(function() {
                    m.unstable_next(function() {
                        var c = J.suspense;
                        J.suspense = void 0 === b ? null : b;
                        try {
                            e(a);
                        } finally{
                            J.suspense = c;
                        }
                    });
                }, [
                    a,
                    b
                ]);
                return d;
            },
            useTransition: function useTransition(a) {
                var b = Sd(!1), c = b[0], d = b[1];
                return [
                    be(function(b) {
                        d(!0);
                        m.unstable_next(function() {
                            var c = J.suspense;
                            J.suspense = void 0 === a ? null : a;
                            try {
                                d(!1), b();
                            } finally{
                                J.suspense = c;
                            }
                        });
                    }, [
                        a,
                        c
                    ]),
                    c
                ];
            }
        }, Ld = {
            readContext: Cc,
            useCallback: ce,
            useContext: Cc,
            useEffect: Zd,
            useImperativeHandle: function useImperativeHandle(a, b, c) {
                c = null !== c && void 0 !== c ? c.concat([
                    a
                ]) : null;
                return Xd(4, 36, $d.bind(null, b, a), c);
            },
            useLayoutEffect: function useLayoutEffect(a, b) {
                return Xd(4, 36, a, b);
            },
            useMemo: function useMemo(a, b) {
                var c = Pd();
                b = void 0 === b ? null : b;
                var d = c.memoizedState;
                if (null !== d && null !== b && Id(b, d[1])) return d[0];
                a = a();
                c.memoizedState = [
                    a,
                    b
                ];
                return a;
            },
            useReducer: Rd,
            useRef: function useRef() {
                return Pd().memoizedState;
            },
            useState: Ud,
            useDebugValue: ae,
            useResponder: vd,
            useDeferredValue: function useDeferredValue(a, b) {
                var c = Ud(), d = c[0], e = c[1];
                Zd(function() {
                    m.unstable_next(function() {
                        var c = J.suspense;
                        J.suspense = void 0 === b ? null : b;
                        try {
                            e(a);
                        } finally{
                            J.suspense = c;
                        }
                    });
                }, [
                    a,
                    b
                ]);
                return d;
            },
            useTransition: function useTransition(a) {
                var b = Ud(), c = b[0], d = b[1];
                return [
                    ce(function(b) {
                        d(!0);
                        m.unstable_next(function() {
                            var c = J.suspense;
                            J.suspense = void 0 === a ? null : a;
                            try {
                                d(!1), b();
                            } finally{
                                J.suspense = c;
                            }
                        });
                    }, [
                        a,
                        c
                    ]),
                    c
                ];
            }
        }, de = null, ee = null, fe = !1;
        function ge(a, b) {
            var c = he(5, null, null, 0);
            c.elementType = "DELETED";
            c.type = "DELETED";
            c.stateNode = b;
            c.return = a;
            c.effectTag = 8;
            null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
        }
        function ie(a, b) {
            switch(a.tag){
                case 5:
                    return b = ob(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
                case 6:
                    return b = pb(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
                case 13:
                    return !1;
                default:
                    return !1;
            }
        }
        function je(a) {
            if (fe) {
                var b = ee;
                if (b) {
                    var c = b;
                    if (!ie(a, b)) {
                        b = sb(c);
                        if (!b || !ie(a, b)) {
                            a.effectTag = a.effectTag & -1025 | 2;
                            fe = !1;
                            de = a;
                            return;
                        }
                        ge(de, c);
                    }
                    de = a;
                    ee = tb(b);
                } else a.effectTag = a.effectTag & -1025 | 2, fe = !1, de = a;
            }
        }
        function ke(a) {
            for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
            de = a;
        }
        function ne(a) {
            if (!Sa || a !== de) return !1;
            if (!fe) return ke(a), fe = !0, !1;
            var b = a.type;
            if (5 !== a.tag || "head" !== b && "body" !== b && !Ja(b, a.memoizedProps)) for(b = ee; b;)ge(a, b), b = sb(b);
            ke(a);
            if (13 === a.tag) {
                if (!Sa) throw Error(n(316));
                a = a.memoizedState;
                a = null !== a ? a.dehydrated : null;
                if (!a) throw Error(n(317));
                ee = wb(a);
            } else ee = de ? sb(a.stateNode) : null;
            return !0;
        }
        function oe() {
            Sa && (ee = de = null, fe = !1);
        }
        var pe = q.ReactCurrentOwner, Bc = !1;
        function Q(a, b, c, d) {
            b.child = null === a ? ld(b, null, c, d) : kd(b, a.child, c, d);
        }
        function qe(a, b, c, d, e) {
            c = c.render;
            var f = b.ref;
            Ac(b, e);
            d = Jd(a, b, c, d, f, e);
            if (null !== a && !Bc) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), re(a, b, e);
            b.effectTag |= 1;
            Q(a, b, d, e);
            return b.child;
        }
        function se(a, b, c, d, e, f) {
            if (null === a) {
                var g = c.type;
                if ("function" === typeof g && !te(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ue(a, b, g, d, e, f);
                a = hd(c.type, null, d, null, b.mode, f);
                a.ref = b.ref;
                a.return = b;
                return b.child = a;
            }
            g = a.child;
            if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : qc, c(e, d) && a.ref === b.ref)) return re(a, b, f);
            b.effectTag |= 1;
            a = fd(g, d);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        function ue(a, b, c, d, e, f) {
            return null !== a && qc(a.memoizedProps, d) && a.ref === b.ref && (Bc = !1, e < f) ? re(a, b, f) : ve(a, b, c, d, f);
        }
        function we(a, b) {
            var c = b.ref;
            if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
        }
        function ve(a, b, c, d, e) {
            var f = C(c) ? Eb : A.current;
            f = Fb(b, f);
            Ac(b, e);
            c = Jd(a, b, c, d, f, e);
            if (null !== a && !Bc) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), re(a, b, e);
            b.effectTag |= 1;
            Q(a, b, c, e);
            return b.child;
        }
        function xe(a, b, c, d, e) {
            if (C(c)) {
                var f = !0;
                Kb(b);
            } else f = !1;
            Ac(b, e);
            if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Zc(b, c, d), ad(b, c, d, e), d = !0;
            else if (null === a) {
                var g = b.stateNode, l = b.memoizedProps;
                g.props = l;
                var h = g.context, k = c.contextType;
                "object" === typeof k && null !== k ? k = Cc(k) : (k = C(c) ? Eb : A.current, k = Fb(b, k));
                var p = c.getDerivedStateFromProps, D = "function" === typeof p || "function" === typeof g.getSnapshotBeforeUpdate;
                D || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (l !== d || h !== k) && $c(b, g, d, k);
                Dc = !1;
                var x = b.memoizedState;
                h = g.state = x;
                var K = b.updateQueue;
                null !== K && (Nc(b, K, d, g, e), h = b.memoizedState);
                l !== d || x !== h || B.current || Dc ? ("function" === typeof p && (Uc(b, c, p, d), h = b.memoizedState), (l = Dc || Yc(b, c, l, d, x, h, k)) ? (D || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = h), g.props = d, g.state = h, g.context = k, d = l) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
            } else g = b.stateNode, l = b.memoizedProps, g.props = b.type === b.elementType ? l : rc(b.type, l), h = g.context, k = c.contextType, "object" === typeof k && null !== k ? k = Cc(k) : (k = C(c) ? Eb : A.current, k = Fb(b, k)), p = c.getDerivedStateFromProps, (D = "function" === typeof p || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (l !== d || h !== k) && $c(b, g, d, k), Dc = !1, h = b.memoizedState, x = g.state = h, K = b.updateQueue, null !== K && (Nc(b, K, d, g, e), x = b.memoizedState), l !== d || h !== x || B.current || Dc ? ("function" === typeof p && (Uc(b, c, p, d), x = b.memoizedState), (p = Dc || Yc(b, c, l, d, h, x, k)) ? (D || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = p) : ("function" !== typeof g.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), d = !1);
            return ye(a, b, c, d, f, e);
        }
        function ye(a, b, c, d, e, f) {
            we(a, b);
            var g = 0 !== (b.effectTag & 64);
            if (!d && !g) return e && Lb(b, c, !1), re(a, b, f);
            d = b.stateNode;
            pe.current = b;
            var l = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
            b.effectTag |= 1;
            null !== a && g ? (b.child = kd(b, a.child, null, f), b.child = kd(b, null, l, f)) : Q(a, b, l, f);
            b.memoizedState = d.state;
            e && Lb(b, c, !0);
            return b.child;
        }
        function ze(a) {
            var b = a.stateNode;
            b.pendingContext ? Ib(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ib(a, b.context, !1);
            qd(a, b.containerInfo);
        }
        var Ae = {
            dehydrated: null,
            retryTime: 0
        };
        function Be(a, b, c) {
            var d = b.mode, e = b.pendingProps, f = I.current, g = !1, l;
            (l = 0 !== (b.effectTag & 64)) || (l = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
            l ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
            z(I, f & 1);
            if (null === a) {
                void 0 !== e.fallback && je(b);
                if (g) {
                    g = e.fallback;
                    e = jd(null, d, 0, null);
                    e.return = b;
                    if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
                    c = jd(g, d, c, null);
                    c.return = b;
                    e.sibling = c;
                    b.memoizedState = Ae;
                    b.child = e;
                    return c;
                }
                d = e.children;
                b.memoizedState = null;
                return b.child = ld(b, null, d, c);
            }
            if (null !== a.memoizedState) {
                a = a.child;
                d = a.sibling;
                if (g) {
                    e = e.fallback;
                    c = fd(a, a.pendingProps);
                    c.return = b;
                    if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
                    d = fd(d, e, d.expirationTime);
                    d.return = b;
                    c.sibling = d;
                    c.childExpirationTime = 0;
                    b.memoizedState = Ae;
                    b.child = c;
                    return d;
                }
                c = kd(b, a.child, e.children, c);
                b.memoizedState = null;
                return b.child = c;
            }
            a = a.child;
            if (g) {
                g = e.fallback;
                e = jd(null, d, 0, null);
                e.return = b;
                e.child = a;
                null !== a && (a.return = e);
                if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
                c = jd(g, d, c, null);
                c.return = b;
                e.sibling = c;
                c.effectTag |= 2;
                e.childExpirationTime = 0;
                b.memoizedState = Ae;
                b.child = e;
                return c;
            }
            b.memoizedState = null;
            return b.child = kd(b, a, e.children, c);
        }
        function Ce(a, b) {
            a.expirationTime < b && (a.expirationTime = b);
            var c = a.alternate;
            null !== c && c.expirationTime < b && (c.expirationTime = b);
            zc(a.return, b);
        }
        function De(a, b, c, d, e, f) {
            var g = a.memoizedState;
            null === g ? a.memoizedState = {
                isBackwards: b,
                rendering: null,
                last: d,
                tail: c,
                tailExpiration: 0,
                tailMode: e,
                lastEffect: f
            } : (g.isBackwards = b, g.rendering = null, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
        }
        function Ee(a, b, c) {
            var d = b.pendingProps, e = d.revealOrder, f = d.tail;
            Q(a, b, d.children, c);
            d = I.current;
            if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
            else {
                if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
                    if (13 === a.tag) null !== a.memoizedState && Ce(a, c);
                    else if (19 === a.tag) Ce(a, c);
                    else if (null !== a.child) {
                        a.child.return = a;
                        a = a.child;
                        continue;
                    }
                    if (a === b) break a;
                    for(; null === a.sibling;){
                        if (null === a.return || a.return === b) break a;
                        a = a.return;
                    }
                    a.sibling.return = a.return;
                    a = a.sibling;
                }
                d &= 1;
            }
            z(I, d);
            if (0 === (b.mode & 2)) b.memoizedState = null;
            else switch(e){
                case "forwards":
                    c = b.child;
                    for(e = null; null !== c;)a = c.alternate, null !== a && null === ud(a) && (e = c), c = c.sibling;
                    c = e;
                    null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                    De(b, !1, e, c, f, b.lastEffect);
                    break;
                case "backwards":
                    c = null;
                    e = b.child;
                    for(b.child = null; null !== e;){
                        a = e.alternate;
                        if (null !== a && null === ud(a)) {
                            b.child = e;
                            break;
                        }
                        a = e.sibling;
                        e.sibling = c;
                        c = e;
                        e = a;
                    }
                    De(b, !0, c, null, f, b.lastEffect);
                    break;
                case "together":
                    De(b, !1, null, null, void 0, b.lastEffect);
                    break;
                default:
                    b.memoizedState = null;
            }
            return b.child;
        }
        function re(a, b, c) {
            null !== a && (b.dependencies = a.dependencies);
            var d = b.expirationTime;
            0 !== d && Pc(d);
            if (b.childExpirationTime < c) return null;
            if (null !== a && b.child !== a.child) throw Error(n(153));
            if (null !== b.child) {
                a = b.child;
                c = fd(a, a.pendingProps, a.expirationTime);
                b.child = c;
                for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = fd(a, a.pendingProps, a.expirationTime), c.return = b;
                c.sibling = null;
            }
            return b.child;
        }
        function Fe(a) {
            a.effectTag |= 4;
        }
        var _Ge, He, Ie, Je;
        if (Qa) _Ge = function Ge(a, b) {
            for(var c = b.child; null !== c;){
                if (5 === c.tag || 6 === c.tag) Fa(a, c.stateNode);
                else if (4 !== c.tag && null !== c.child) {
                    c.child.return = c;
                    c = c.child;
                    continue;
                }
                if (c === b) break;
                for(; null === c.sibling;){
                    if (null === c.return || c.return === b) return;
                    c = c.return;
                }
                c.sibling.return = c.return;
                c = c.sibling;
            }
        }, He = function He() {}, Ie = function Ie(a, b, c, d, e) {
            a = a.memoizedProps;
            if (a !== d) {
                var f = b.stateNode, g = pd(H.current);
                c = Ia(f, c, a, d, e, g);
                (b.updateQueue = c) && Fe(b);
            }
        }, Je = function Je(a, b, c, d) {
            c !== d && Fe(b);
        };
        else if (Ra) {
            _Ge = function Ge(a, b, c, d) {
                for(var e = b.child; null !== e;){
                    if (5 === e.tag) {
                        var f = e.stateNode;
                        c && d && (f = mb(f, e.type, e.memoizedProps, e));
                        Fa(a, f);
                    } else if (6 === e.tag) f = e.stateNode, c && d && (f = nb(f, e.memoizedProps, e)), Fa(a, f);
                    else if (4 !== e.tag) {
                        if (13 === e.tag && 0 !== (e.effectTag & 4) && (f = null !== e.memoizedState)) {
                            var g = e.child;
                            if (null !== g && (null !== g.child && (g.child.return = g, _Ge(a, g, !0, f)), f = g.sibling, null !== f)) {
                                f.return = e;
                                e = f;
                                continue;
                            }
                        }
                        if (null !== e.child) {
                            e.child.return = e;
                            e = e.child;
                            continue;
                        }
                    }
                    if (e === b) break;
                    for(; null === e.sibling;){
                        if (null === e.return || e.return === b) return;
                        e = e.return;
                    }
                    e.sibling.return = e.return;
                    e = e.sibling;
                }
            };
            var Ke = function Ke(a, b, c, d) {
                for(var e = b.child; null !== e;){
                    if (5 === e.tag) {
                        var f = e.stateNode;
                        c && d && (f = mb(f, e.type, e.memoizedProps, e));
                        ib(a, f);
                    } else if (6 === e.tag) f = e.stateNode, c && d && (f = nb(f, e.memoizedProps, e)), ib(a, f);
                    else if (4 !== e.tag) {
                        if (13 === e.tag && 0 !== (e.effectTag & 4) && (f = null !== e.memoizedState)) {
                            var g = e.child;
                            if (null !== g && (null !== g.child && (g.child.return = g, Ke(a, g, !0, f)), f = g.sibling, null !== f)) {
                                f.return = e;
                                e = f;
                                continue;
                            }
                        }
                        if (null !== e.child) {
                            e.child.return = e;
                            e = e.child;
                            continue;
                        }
                    }
                    if (e === b) break;
                    for(; null === e.sibling;){
                        if (null === e.return || e.return === b) return;
                        e = e.return;
                    }
                    e.sibling.return = e.return;
                    e = e.sibling;
                }
            };
            He = function He(a) {
                var b = a.stateNode;
                if (null !== a.firstEffect) {
                    var c = b.containerInfo, d = hb(c);
                    Ke(d, a, !1, !1);
                    b.pendingChildren = d;
                    Fe(a);
                    kb(c, d);
                }
            };
            Ie = function Ie(a, b, c, d, e) {
                var f = a.stateNode, g = a.memoizedProps;
                if ((a = null === b.firstEffect) && g === d) b.stateNode = f;
                else {
                    var l = b.stateNode, h = pd(H.current), k = null;
                    g !== d && (k = Ia(l, c, g, d, e, h));
                    a && null === k ? b.stateNode = f : (f = gb(f, k, c, g, d, b, a, l), Ga(f, c, d, e, h) && Fe(b), b.stateNode = f, a ? Fe(b) : _Ge(f, b, !1, !1));
                }
            };
            Je = function Je(a, b, c, d) {
                c !== d && (a = pd(od.current), c = pd(H.current), b.stateNode = La(d, a, c, b), Fe(b));
            };
        } else He = function He() {}, Ie = function Ie() {}, Je = function Je() {};
        function Le(a, b) {
            switch(a.tailMode){
                case "hidden":
                    b = a.tail;
                    for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                    null === c ? a.tail = null : c.sibling = null;
                    break;
                case "collapsed":
                    c = a.tail;
                    for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                    null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
            }
        }
        function Me(a) {
            switch(a.tag){
                case 1:
                    C(a.type) && Gb();
                    var b = a.effectTag;
                    return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
                case 3:
                    rd();
                    Hb();
                    b = a.effectTag;
                    if (0 !== (b & 64)) throw Error(n(285));
                    a.effectTag = b & -4097 | 64;
                    return a;
                case 5:
                    return td(a), null;
                case 13:
                    return y(I), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
                case 19:
                    return y(I), null;
                case 4:
                    return rd(), null;
                case 10:
                    return yc(a), null;
                default:
                    return null;
            }
        }
        function Ne(a, b) {
            return {
                value: a,
                source: b,
                stack: Ab(b)
            };
        }
        var Oe = "function" === typeof WeakSet ? WeakSet : Set;
        function Pe(a, b) {
            var c = b.source, d = b.stack;
            null === d && null !== c && (d = Ab(c));
            null !== c && ta(c.type);
            b = b.value;
            null !== a && 1 === a.tag && ta(a.type);
            try {
                console.error(b);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                });
            }
        }
        function Qe(a, b) {
            try {
                b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
            } catch (c) {
                Re(a, c);
            }
        }
        function Se(a) {
            var b = a.ref;
            if (null !== b) {
                if ("function" === typeof b) try {
                    b(null);
                } catch (c) {
                    Re(a, c);
                }
                else b.current = null;
            }
        }
        function Te(a, b) {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    Ue(2, 0, b);
                    break;
                case 1:
                    if (b.effectTag & 256 && null !== a) {
                        var c = a.memoizedProps, d = a.memoizedState;
                        a = b.stateNode;
                        b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : rc(b.type, c), d);
                        a.__reactInternalSnapshotBeforeUpdate = b;
                    }
                    break;
                case 3:
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(n(163));
            }
        }
        function Ue(a, b, c) {
            c = c.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do {
                    if (0 !== (d.tag & a)) {
                        var e = d.destroy;
                        d.destroy = void 0;
                        void 0 !== e && e();
                    }
                    0 !== (d.tag & b) && (e = d.create, d.destroy = e());
                    d = d.next;
                }while (d !== c);
            }
        }
        function Ve(a, b, c) {
            "function" === typeof We && We(b);
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    a = b.updateQueue;
                    if (null !== a && (a = a.lastEffect, null !== a)) {
                        var d = a.next;
                        hc(97 < c ? 97 : c, function() {
                            var a = d;
                            do {
                                var c = a.destroy;
                                if (void 0 !== c) {
                                    var g = b;
                                    try {
                                        c();
                                    } catch (l) {
                                        Re(g, l);
                                    }
                                }
                                a = a.next;
                            }while (a !== d);
                        });
                    }
                    break;
                case 1:
                    Se(b);
                    c = b.stateNode;
                    "function" === typeof c.componentWillUnmount && Qe(b, c);
                    break;
                case 5:
                    Se(b);
                    break;
                case 4:
                    Qa ? Xe(a, b, c) : Ra && Ye(b);
            }
        }
        function Ze(a, b, c) {
            for(var d = b;;)if (Ve(a, d, c), null === d.child || Qa && 4 === d.tag) {
                if (d === b) break;
                for(; null === d.sibling;){
                    if (null === d.return || d.return === b) return;
                    d = d.return;
                }
                d.sibling.return = d.return;
                d = d.sibling;
            } else d.child.return = d, d = d.child;
        }
        function $e(a) {
            var b = a.alternate;
            a.return = null;
            a.child = null;
            a.memoizedState = null;
            a.updateQueue = null;
            a.dependencies = null;
            a.alternate = null;
            a.firstEffect = null;
            a.lastEffect = null;
            a.pendingProps = null;
            a.memoizedProps = null;
            null !== b && $e(b);
        }
        function Ye(a) {
            if (Ra) {
                a = a.stateNode.containerInfo;
                var b = hb(a);
                lb(a, b);
            }
        }
        function af(a) {
            return 5 === a.tag || 3 === a.tag || 4 === a.tag;
        }
        function bf(a) {
            if (Qa) {
                a: {
                    for(var b = a.return; null !== b;){
                        if (af(b)) {
                            var c = b;
                            break a;
                        }
                        b = b.return;
                    }
                    throw Error(n(160));
                }
                b = c.stateNode;
                switch(c.tag){
                    case 5:
                        var d = !1;
                        break;
                    case 3:
                        b = b.containerInfo;
                        d = !0;
                        break;
                    case 4:
                        b = b.containerInfo;
                        d = !0;
                        break;
                    default:
                        throw Error(n(161));
                }
                c.effectTag & 16 && (bb(b), c.effectTag &= -17);
                a: b: for(c = a;;){
                    for(; null === c.sibling;){
                        if (null === c.return || af(c.return)) {
                            c = null;
                            break a;
                        }
                        c = c.return;
                    }
                    c.sibling.return = c.return;
                    for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
                        if (c.effectTag & 2) continue b;
                        if (null === c.child || 4 === c.tag) continue b;
                        else c.child.return = c, c = c.child;
                    }
                    if (!(c.effectTag & 2)) {
                        c = c.stateNode;
                        break a;
                    }
                }
                for(var e = a;;){
                    var f = 5 === e.tag || 6 === e.tag;
                    if (f) f = f ? e.stateNode : e.stateNode.instance, c ? d ? Za(b, f, c) : Ya(b, f, c) : d ? Ua(b, f) : Ta(b, f);
                    else if (4 !== e.tag && null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                    if (e === a) break;
                    for(; null === e.sibling;){
                        if (null === e.return || e.return === a) return;
                        e = e.return;
                    }
                    e.sibling.return = e.return;
                    e = e.sibling;
                }
            }
        }
        function Xe(a, b, c) {
            for(var d = b, e = !1, f, g;;){
                if (!e) {
                    e = d.return;
                    a: for(;;){
                        if (null === e) throw Error(n(160));
                        f = e.stateNode;
                        switch(e.tag){
                            case 5:
                                g = !1;
                                break a;
                            case 3:
                                f = f.containerInfo;
                                g = !0;
                                break a;
                            case 4:
                                f = f.containerInfo;
                                g = !0;
                                break a;
                        }
                        e = e.return;
                    }
                    e = !0;
                }
                if (5 === d.tag || 6 === d.tag) Ze(a, d, c), g ? ab(f, d.stateNode) : $a(f, d.stateNode);
                else if (4 === d.tag) {
                    if (null !== d.child) {
                        f = d.stateNode.containerInfo;
                        g = !0;
                        d.child.return = d;
                        d = d.child;
                        continue;
                    }
                } else if (Ve(a, d, c), null !== d.child) {
                    d.child.return = d;
                    d = d.child;
                    continue;
                }
                if (d === b) break;
                for(; null === d.sibling;){
                    if (null === d.return || d.return === b) return;
                    d = d.return;
                    4 === d.tag && (e = !1);
                }
                d.sibling.return = d.return;
                d = d.sibling;
            }
        }
        function cf(a, b) {
            if (Qa) switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Ue(4, 8, b);
                    break;
                case 1:
                    break;
                case 5:
                    var c = b.stateNode;
                    if (null != c) {
                        var d = b.memoizedProps;
                        a = null !== a ? a.memoizedProps : d;
                        var e = b.type, f = b.updateQueue;
                        b.updateQueue = null;
                        null !== f && Xa(c, f, e, a, d, b);
                    }
                    break;
                case 6:
                    if (null === b.stateNode) throw Error(n(162));
                    c = b.memoizedProps;
                    Va(b.stateNode, null !== a ? a.memoizedProps : c, c);
                    break;
                case 3:
                    Sa && (b = b.stateNode, b.hydrate && (b.hydrate = !1, xb(b.containerInfo)));
                    break;
                case 12:
                    break;
                case 13:
                    df(b);
                    ef(b);
                    break;
                case 19:
                    ef(b);
                    break;
                case 17:
                    break;
                case 20:
                    break;
                case 21:
                    break;
                default:
                    throw Error(n(163));
            }
            else {
                switch(b.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                        Ue(4, 8, b);
                        return;
                    case 12:
                        return;
                    case 13:
                        df(b);
                        ef(b);
                        return;
                    case 19:
                        ef(b);
                        return;
                    case 3:
                        Sa && (c = b.stateNode, c.hydrate && (c.hydrate = !1, xb(c.containerInfo)));
                }
                a: if (Ra) switch(b.tag){
                    case 1:
                    case 5:
                    case 6:
                    case 20:
                        break a;
                    case 3:
                    case 4:
                        b = b.stateNode;
                        lb(b.containerInfo, b.pendingChildren);
                        break a;
                    default:
                        throw Error(n(163));
                }
            }
        }
        function df(a) {
            var b = a;
            if (null === a.memoizedState) var c = !1;
            else c = !0, b = a.child, ff = E();
            if (Qa && null !== b) {
                a: if (a = b, Qa) for(b = a;;){
                    if (5 === b.tag) {
                        var d = b.stateNode;
                        c ? cb(d) : eb(b.stateNode, b.memoizedProps);
                    } else if (6 === b.tag) d = b.stateNode, c ? db(d) : fb(d, b.memoizedProps);
                    else if (13 === b.tag && null !== b.memoizedState && null === b.memoizedState.dehydrated) {
                        d = b.child.sibling;
                        d.return = b;
                        b = d;
                        continue;
                    } else if (null !== b.child) {
                        b.child.return = b;
                        b = b.child;
                        continue;
                    }
                    if (b === a) break a;
                    for(; null === b.sibling;){
                        if (null === b.return || b.return === a) break a;
                        b = b.return;
                    }
                    b.sibling.return = b.return;
                    b = b.sibling;
                }
            }
        }
        function ef(a) {
            var b = a.updateQueue;
            if (null !== b) {
                a.updateQueue = null;
                var c = a.stateNode;
                null === c && (c = a.stateNode = new Oe());
                b.forEach(function(b) {
                    var d = gf.bind(null, a, b);
                    c.has(b) || (c.add(b), b.then(d, d));
                });
            }
        }
        var hf = "function" === typeof WeakMap ? WeakMap : Map;
        function jf(a, b, c) {
            c = Gc(c, null);
            c.tag = 3;
            c.payload = {
                element: null
            };
            var d = b.value;
            c.callback = function() {
                kf || (kf = !0, lf = d);
                Pe(a, b);
            };
            return c;
        }
        function mf(a, b, c) {
            c = Gc(c, null);
            c.tag = 3;
            var d = a.type.getDerivedStateFromError;
            if ("function" === typeof d) {
                var e = b.value;
                c.payload = function() {
                    Pe(a, b);
                    return d(e);
                };
            }
            var f = a.stateNode;
            null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
                "function" !== typeof d && (null === nf ? nf = new Set([
                    this
                ]) : nf.add(this), Pe(a, b));
                var c = b.stack;
                this.componentDidCatch(b.value, {
                    componentStack: null !== c ? c : ""
                });
            });
            return c;
        }
        var of = Math.ceil, pf = q.ReactCurrentDispatcher, qf = q.ReactCurrentOwner, R = 0, rf = 8, S = 16, sf = 32, tf = 0, uf = 1, vf = 2, wf = 3, xf = 4, yf = 5, T = R, U = null, V = null, W = 0, X = tf, zf = null, Af = 1073741823, Bf = 1073741823, Cf = null, Df = 0, Ef = !1, ff = 0, Ff = 500, Y = null, kf = !1, lf = null, nf = null, Gf = !1, Hf = null, If = 90, Jf = null, Kf = 0, Lf = null, Mf = 0;
        function G() {
            return (T & (S | sf)) !== R ? 1073741821 - (E() / 10 | 0) : 0 !== Mf ? Mf : Mf = 1073741821 - (E() / 10 | 0);
        }
        function Vc(a, b, c) {
            b = b.mode;
            if (0 === (b & 2)) return 1073741823;
            var d = fc();
            if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
            if ((T & S) !== R) return W;
            if (null !== c) a = mc(a, c.timeoutMs | 0 || 5E3, 250);
            else switch(d){
                case 99:
                    a = 1073741823;
                    break;
                case 98:
                    a = mc(a, 150, 100);
                    break;
                case 97:
                case 96:
                    a = mc(a, 5E3, 250);
                    break;
                case 95:
                    a = 2;
                    break;
                default:
                    throw Error(n(326));
            }
            null !== U && a === W && --a;
            return a;
        }
        function Wc(a, b) {
            if (50 < Kf) throw Kf = 0, Lf = null, Error(n(185));
            a = Nf(a, b);
            if (null !== a) {
                var c = fc();
                1073741823 === b ? (T & rf) !== R && (T & (S | sf)) === R ? Of(a) : (Z(a), T === R && F()) : Z(a);
                (T & 4) === R || 98 !== c && 99 !== c || (null === Jf ? Jf = new Map([
                    [
                        a,
                        b
                    ]
                ]) : (c = Jf.get(a), (void 0 === c || c > b) && Jf.set(a, b)));
            }
        }
        function Nf(a, b) {
            a.expirationTime < b && (a.expirationTime = b);
            var c = a.alternate;
            null !== c && c.expirationTime < b && (c.expirationTime = b);
            var d = a.return, e = null;
            if (null === d && 3 === a.tag) e = a.stateNode;
            else for(; null !== d;){
                c = d.alternate;
                d.childExpirationTime < b && (d.childExpirationTime = b);
                null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
                if (null === d.return && 3 === d.tag) {
                    e = d.stateNode;
                    break;
                }
                d = d.return;
            }
            null !== e && (U === e && (Pc(b), X === xf && Pf(e, W)), Qf(e, b));
            return e;
        }
        function Rf(a) {
            var b = a.lastExpiredTime;
            if (0 !== b) return b;
            b = a.firstPendingTime;
            if (!Sf(a, b)) return b;
            b = a.lastPingedTime;
            a = a.nextKnownPendingLevel;
            return b > a ? b : a;
        }
        function Z(a) {
            if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = jc(Of.bind(null, a));
            else {
                var b = Rf(a), c = a.callbackNode;
                if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
                else {
                    var d = G();
                    1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
                    if (null !== c) {
                        var e = a.callbackPriority;
                        if (a.callbackExpirationTime === b && e >= d) return;
                        c !== $b && Ob(c);
                    }
                    a.callbackExpirationTime = b;
                    a.callbackPriority = d;
                    b = 1073741823 === b ? jc(Of.bind(null, a)) : ic(d, Tf.bind(null, a), {
                        timeout: 10 * (1073741821 - b) - E()
                    });
                    a.callbackNode = b;
                }
            }
        }
        function Tf(a, b) {
            Mf = 0;
            if (b) return b = G(), Uf(a, b), Z(a), null;
            var c = Rf(a);
            if (0 !== c) {
                b = a.callbackNode;
                if ((T & (S | sf)) !== R) throw Error(n(327));
                Vf();
                a === U && c === W || Wf(a, c);
                if (null !== V) {
                    var d = T;
                    T |= S;
                    var e = Xf();
                    for(;;)try {
                        Yf();
                        break;
                    } catch (l) {
                        Zf(a, l);
                    }
                    wc();
                    T = d;
                    pf.current = e;
                    if (X === uf) throw b = zf, Wf(a, c), Pf(a, c), Z(a), b;
                    if (null === V) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = X, U = null, d){
                        case tf:
                        case uf:
                            throw Error(n(345));
                        case vf:
                            Uf(a, 2 < c ? 2 : c);
                            break;
                        case wf:
                            Pf(a, c);
                            d = a.lastSuspendedTime;
                            c === d && (a.nextKnownPendingLevel = $f(e));
                            if (1073741823 === Af && (e = ff + Ff - E(), 10 < e)) {
                                if (Ef) {
                                    var f = a.lastPingedTime;
                                    if (0 === f || f >= c) {
                                        a.lastPingedTime = c;
                                        Wf(a, c);
                                        break;
                                    }
                                }
                                f = Rf(a);
                                if (0 !== f && f !== c) break;
                                if (0 !== d && d !== c) {
                                    a.lastPingedTime = d;
                                    break;
                                }
                                a.timeoutHandle = Ma(ag.bind(null, a), e);
                                break;
                            }
                            ag(a);
                            break;
                        case xf:
                            Pf(a, c);
                            d = a.lastSuspendedTime;
                            c === d && (a.nextKnownPendingLevel = $f(e));
                            if (Ef && (e = a.lastPingedTime, 0 === e || e >= c)) {
                                a.lastPingedTime = c;
                                Wf(a, c);
                                break;
                            }
                            e = Rf(a);
                            if (0 !== e && e !== c) break;
                            if (0 !== d && d !== c) {
                                a.lastPingedTime = d;
                                break;
                            }
                            1073741823 !== Bf ? d = 10 * (1073741821 - Bf) - E() : 1073741823 === Af ? d = 0 : (d = 10 * (1073741821 - Af) - 5E3, e = E(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * of(d / 1960)) - d, c < d && (d = c));
                            if (10 < d) {
                                a.timeoutHandle = Ma(ag.bind(null, a), d);
                                break;
                            }
                            ag(a);
                            break;
                        case yf:
                            if (1073741823 !== Af && null !== Cf) {
                                f = Af;
                                var g = Cf;
                                d = g.busyMinDurationMs | 0;
                                0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = E() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                                if (10 < d) {
                                    Pf(a, c);
                                    a.timeoutHandle = Ma(ag.bind(null, a), d);
                                    break;
                                }
                            }
                            ag(a);
                            break;
                        default:
                            throw Error(n(329));
                    }
                    Z(a);
                    if (a.callbackNode === b) return Tf.bind(null, a);
                }
            }
            return null;
        }
        function Of(a) {
            var b = a.lastExpiredTime;
            b = 0 !== b ? b : 1073741823;
            if (a.finishedExpirationTime === b) ag(a);
            else {
                if ((T & (S | sf)) !== R) throw Error(n(327));
                Vf();
                a === U && b === W || Wf(a, b);
                if (null !== V) {
                    var c = T;
                    T |= S;
                    var d = Xf();
                    for(;;)try {
                        bg();
                        break;
                    } catch (e) {
                        Zf(a, e);
                    }
                    wc();
                    T = c;
                    pf.current = d;
                    if (X === uf) throw c = zf, Wf(a, b), Pf(a, b), Z(a), c;
                    if (null !== V) throw Error(n(261));
                    a.finishedWork = a.current.alternate;
                    a.finishedExpirationTime = b;
                    U = null;
                    ag(a);
                    Z(a);
                }
            }
            return null;
        }
        function cg(a, b) {
            Uf(a, b);
            Z(a);
            (T & (S | sf)) === R && F();
        }
        function dg() {
            if (null !== Jf) {
                var a = Jf;
                Jf = null;
                a.forEach(function(a, c) {
                    Uf(c, a);
                    Z(c);
                });
                F();
            }
        }
        function eg(a, b) {
            if ((T & (S | sf)) !== R) throw Error(n(187));
            var c = T;
            T |= 1;
            try {
                return hc(99, a.bind(null, b));
            } finally{
                T = c, F();
            }
        }
        function Wf(a, b) {
            a.finishedWork = null;
            a.finishedExpirationTime = 0;
            var c = a.timeoutHandle;
            c !== Oa && (a.timeoutHandle = Oa, Na(c));
            if (null !== V) for(c = V.return; null !== c;){
                var d = c;
                switch(d.tag){
                    case 1:
                        var e = d.type.childContextTypes;
                        null !== e && void 0 !== e && Gb();
                        break;
                    case 3:
                        rd();
                        Hb();
                        break;
                    case 5:
                        td(d);
                        break;
                    case 4:
                        rd();
                        break;
                    case 13:
                        y(I);
                        break;
                    case 19:
                        y(I);
                        break;
                    case 10:
                        yc(d);
                }
                c = c.return;
            }
            U = a;
            V = fd(a.current, null);
            W = b;
            X = tf;
            zf = null;
            Bf = Af = 1073741823;
            Cf = null;
            Df = 0;
            Ef = !1;
        }
        function Zf(a, b) {
            do {
                try {
                    wc();
                    Nd();
                    if (null === V || null === V.return) return X = uf, zf = b, null;
                    a: {
                        var c = a, d = V.return, e = V, f = b;
                        b = W;
                        e.effectTag |= 2048;
                        e.firstEffect = e.lastEffect = null;
                        if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                            var g = f, l = 0 !== (I.current & 1), h = d;
                            do {
                                var k;
                                if (k = 13 === h.tag) {
                                    var p = h.memoizedState;
                                    if (null !== p) k = null !== p.dehydrated ? !0 : !1;
                                    else {
                                        var D = h.memoizedProps;
                                        k = void 0 === D.fallback ? !1 : !0 !== D.unstable_avoidThisFallback ? !0 : l ? !1 : !0;
                                    }
                                }
                                if (k) {
                                    var x = h.updateQueue;
                                    if (null === x) {
                                        var K = new Set();
                                        K.add(g);
                                        h.updateQueue = K;
                                    } else x.add(g);
                                    if (0 === (h.mode & 2)) {
                                        h.effectTag |= 64;
                                        e.effectTag &= -2981;
                                        if (1 === e.tag) {
                                            if (null === e.alternate) e.tag = 17;
                                            else {
                                                var Ha = Gc(1073741823, null);
                                                Ha.tag = 2;
                                                Ic(e, Ha);
                                            }
                                        }
                                        e.expirationTime = 1073741823;
                                        break a;
                                    }
                                    f = void 0;
                                    e = b;
                                    var O = c.pingCache;
                                    null === O ? (O = c.pingCache = new hf(), f = new Set(), O.set(g, f)) : (f = O.get(g), void 0 === f && (f = new Set(), O.set(g, f)));
                                    if (!f.has(e)) {
                                        f.add(e);
                                        var w = fg.bind(null, c, g, e);
                                        g.then(w, w);
                                    }
                                    h.effectTag |= 4096;
                                    h.expirationTime = b;
                                    break a;
                                }
                                h = h.return;
                            }while (null !== h);
                            f = Error((ta(e.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + Ab(e));
                        }
                        X !== yf && (X = vf);
                        f = Ne(f, e);
                        h = d;
                        do {
                            switch(h.tag){
                                case 3:
                                    g = f;
                                    h.effectTag |= 4096;
                                    h.expirationTime = b;
                                    var r = jf(h, g, b);
                                    Jc(h, r);
                                    break a;
                                case 1:
                                    g = f;
                                    var t = h.type, N = h.stateNode;
                                    if (0 === (h.effectTag & 64) && ("function" === typeof t.getDerivedStateFromError || null !== N && "function" === typeof N.componentDidCatch && (null === nf || !nf.has(N)))) {
                                        h.effectTag |= 4096;
                                        h.expirationTime = b;
                                        var Mc = mf(h, g, b);
                                        Jc(h, Mc);
                                        break a;
                                    }
                            }
                            h = h.return;
                        }while (null !== h);
                    }
                    V = gg(V);
                } catch (Rb) {
                    b = Rb;
                    continue;
                }
                break;
            }while (1);
        }
        function Xf() {
            var a = pf.current;
            pf.current = Md;
            return null === a ? Md : a;
        }
        function Oc(a, b) {
            a < Af && 2 < a && (Af = a);
            null !== b && a < Bf && 2 < a && (Bf = a, Cf = b);
        }
        function Pc(a) {
            a > Df && (Df = a);
        }
        function bg() {
            for(; null !== V;)V = hg(V);
        }
        function Yf() {
            for(; null !== V && !Pb();)V = hg(V);
        }
        function hg(a) {
            var b = ig(a.alternate, a, W);
            a.memoizedProps = a.pendingProps;
            null === b && (b = gg(a));
            qf.current = null;
            return b;
        }
        function gg(a) {
            V = a;
            do {
                var b = V.alternate;
                a = V.return;
                if (0 === (V.effectTag & 2048)) {
                    a: {
                        var c = b;
                        b = V;
                        var d = W, e = b.pendingProps;
                        switch(b.tag){
                            case 2:
                                break;
                            case 16:
                                break;
                            case 15:
                            case 0:
                                break;
                            case 1:
                                C(b.type) && Gb();
                                break;
                            case 3:
                                rd();
                                Hb();
                                e = b.stateNode;
                                e.pendingContext && (e.context = e.pendingContext, e.pendingContext = null);
                                (null === c || null === c.child) && ne(b) && Fe(b);
                                He(b);
                                break;
                            case 5:
                                td(b);
                                var f = pd(od.current);
                                d = b.type;
                                if (null !== c && null != b.stateNode) Ie(c, b, d, e, f), c.ref !== b.ref && (b.effectTag |= 128);
                                else if (e) {
                                    c = pd(H.current);
                                    if (ne(b)) {
                                        e = b;
                                        if (!Sa) throw Error(n(175));
                                        c = ub(e.stateNode, e.type, e.memoizedProps, f, c, e);
                                        e.updateQueue = c;
                                        c = null !== c ? !0 : !1;
                                        c && Fe(b);
                                    } else {
                                        var g = Ea(d, e, f, c, b);
                                        _Ge(g, b, !1, !1);
                                        b.stateNode = g;
                                        Ga(g, d, e, f, c) && Fe(b);
                                    }
                                    null !== b.ref && (b.effectTag |= 128);
                                } else if (null === b.stateNode) throw Error(n(166));
                                break;
                            case 6:
                                if (c && null != b.stateNode) Je(c, b, c.memoizedProps, e);
                                else {
                                    if ("string" !== typeof e && null === b.stateNode) throw Error(n(166));
                                    c = pd(od.current);
                                    f = pd(H.current);
                                    if (ne(b)) {
                                        c = b;
                                        if (!Sa) throw Error(n(176));
                                        (c = vb(c.stateNode, c.memoizedProps, c)) && Fe(b);
                                    } else b.stateNode = La(e, c, f, b);
                                }
                                break;
                            case 11:
                                break;
                            case 13:
                                y(I);
                                e = b.memoizedState;
                                if (0 !== (b.effectTag & 64)) {
                                    b.expirationTime = d;
                                    break a;
                                }
                                e = null !== e;
                                f = !1;
                                null === c ? void 0 !== b.memoizedProps.fallback && ne(b) : (d = c.memoizedState, f = null !== d, e || null === d || (d = c.child.sibling, null !== d && (g = b.firstEffect, null !== g ? (b.firstEffect = d, d.nextEffect = g) : (b.firstEffect = b.lastEffect = d, d.nextEffect = null), d.effectTag = 8)));
                                if (e && !f && 0 !== (b.mode & 2)) {
                                    if (null === c && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (I.current & 1)) X === tf && (X = wf);
                                    else {
                                        if (X === tf || X === wf) X = xf;
                                        0 !== Df && null !== U && (Pf(U, W), Qf(U, Df));
                                    }
                                }
                                Ra && e && (b.effectTag |= 4);
                                Qa && (e || f) && (b.effectTag |= 4);
                                break;
                            case 7:
                                break;
                            case 8:
                                break;
                            case 12:
                                break;
                            case 4:
                                rd();
                                He(b);
                                break;
                            case 10:
                                yc(b);
                                break;
                            case 9:
                                break;
                            case 14:
                                break;
                            case 17:
                                C(b.type) && Gb();
                                break;
                            case 19:
                                y(I);
                                e = b.memoizedState;
                                if (null === e) break;
                                f = 0 !== (b.effectTag & 64);
                                g = e.rendering;
                                if (null === g) {
                                    if (f) Le(e, !1);
                                    else {
                                        if (X !== tf || null !== c && 0 !== (c.effectTag & 64)) for(c = b.child; null !== c;){
                                            g = ud(c);
                                            if (null !== g) {
                                                b.effectTag |= 64;
                                                Le(e, !1);
                                                c = g.updateQueue;
                                                null !== c && (b.updateQueue = c, b.effectTag |= 4);
                                                null === e.lastEffect && (b.firstEffect = null);
                                                b.lastEffect = e.lastEffect;
                                                c = d;
                                                for(e = b.child; null !== e;)f = e, d = c, f.effectTag &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childExpirationTime = 0, f.expirationTime = d, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null) : (f.childExpirationTime = g.childExpirationTime, f.expirationTime = g.expirationTime, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, d = g.dependencies, f.dependencies = null === d ? null : {
                                                    expirationTime: d.expirationTime,
                                                    firstContext: d.firstContext,
                                                    responders: d.responders
                                                }), e = e.sibling;
                                                z(I, I.current & 1 | 2);
                                                b = b.child;
                                                break a;
                                            }
                                            c = c.sibling;
                                        }
                                    }
                                } else {
                                    if (!f) {
                                        if (c = ud(g), null !== c) {
                                            if (b.effectTag |= 64, f = !0, c = c.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), Le(e, !0), null === e.tail && "hidden" === e.tailMode) {
                                                b = b.lastEffect = e.lastEffect;
                                                null !== b && (b.nextEffect = null);
                                                break;
                                            }
                                        } else E() > e.tailExpiration && 1 < d && (b.effectTag |= 64, f = !0, Le(e, !1), b.expirationTime = b.childExpirationTime = d - 1);
                                    }
                                    e.isBackwards ? (g.sibling = b.child, b.child = g) : (c = e.last, null !== c ? c.sibling = g : b.child = g, e.last = g);
                                }
                                if (null !== e.tail) {
                                    0 === e.tailExpiration && (e.tailExpiration = E() + 500);
                                    c = e.tail;
                                    e.rendering = c;
                                    e.tail = c.sibling;
                                    e.lastEffect = b.lastEffect;
                                    c.sibling = null;
                                    e = I.current;
                                    e = f ? e & 1 | 2 : e & 1;
                                    z(I, e);
                                    b = c;
                                    break a;
                                }
                                break;
                            case 20:
                                break;
                            case 21:
                                break;
                            default:
                                throw Error(n(156, b.tag));
                        }
                        b = null;
                    }
                    c = V;
                    if (1 === W || 1 !== c.childExpirationTime) {
                        e = 0;
                        for(f = c.child; null !== f;)d = f.expirationTime, g = f.childExpirationTime, d > e && (e = d), g > e && (e = g), f = f.sibling;
                        c.childExpirationTime = e;
                    }
                    if (null !== b) return b;
                    null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = V.firstEffect), null !== V.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = V.firstEffect), a.lastEffect = V.lastEffect), 1 < V.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = V : a.firstEffect = V, a.lastEffect = V));
                } else {
                    b = Me(V);
                    if (null !== b) return b.effectTag &= 2047, b;
                    null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
                }
                b = V.sibling;
                if (null !== b) return b;
                V = a;
            }while (null !== V);
            X === tf && (X = yf);
            return null;
        }
        function $f(a) {
            var b = a.expirationTime;
            a = a.childExpirationTime;
            return b > a ? b : a;
        }
        function ag(a) {
            var b = fc();
            hc(99, jg.bind(null, a, b));
            return null;
        }
        function jg(a, b) {
            Vf();
            if ((T & (S | sf)) !== R) throw Error(n(327));
            var c = a.finishedWork, d = a.finishedExpirationTime;
            if (null === c) return null;
            a.finishedWork = null;
            a.finishedExpirationTime = 0;
            if (c === a.current) throw Error(n(177));
            a.callbackNode = null;
            a.callbackExpirationTime = 0;
            a.callbackPriority = 90;
            a.nextKnownPendingLevel = 0;
            var e = $f(c);
            a.firstPendingTime = e;
            d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
            d <= a.lastPingedTime && (a.lastPingedTime = 0);
            d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
            a === U && (V = U = null, W = 0);
            1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
            if (null !== e) {
                var f = T;
                T |= sf;
                qf.current = null;
                Ca(a.containerInfo);
                Y = e;
                do try {
                    kg();
                } catch (jb) {
                    if (null === Y) throw Error(n(330));
                    Re(Y, jb);
                    Y = Y.nextEffect;
                }
                while (null !== Y);
                Y = e;
                do try {
                    for(var g = a, l = b; null !== Y;){
                        var h = Y.effectTag;
                        h & 16 && Qa && bb(Y.stateNode);
                        if (h & 128) {
                            var k = Y.alternate;
                            if (null !== k) {
                                var p = k.ref;
                                null !== p && ("function" === typeof p ? p(null) : p.current = null);
                            }
                        }
                        switch(h & 1038){
                            case 2:
                                bf(Y);
                                Y.effectTag &= -3;
                                break;
                            case 6:
                                bf(Y);
                                Y.effectTag &= -3;
                                cf(Y.alternate, Y);
                                break;
                            case 1024:
                                Y.effectTag &= -1025;
                                break;
                            case 1028:
                                Y.effectTag &= -1025;
                                cf(Y.alternate, Y);
                                break;
                            case 4:
                                cf(Y.alternate, Y);
                                break;
                            case 8:
                                var D = g, x = Y, K = l;
                                Qa ? Xe(D, x, K) : Ze(D, x, K);
                                $e(x);
                        }
                        Y = Y.nextEffect;
                    }
                } catch (jb) {
                    if (null === Y) throw Error(n(330));
                    Re(Y, jb);
                    Y = Y.nextEffect;
                }
                while (null !== Y);
                Da(a.containerInfo);
                a.current = c;
                Y = e;
                do try {
                    for(h = d; null !== Y;){
                        var Ha = Y.effectTag;
                        if (Ha & 36) {
                            var O = Y.alternate;
                            k = Y;
                            p = h;
                            switch(k.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Ue(16, 32, k);
                                    break;
                                case 1:
                                    var w = k.stateNode;
                                    if (k.effectTag & 4) {
                                        if (null === O) w.componentDidMount();
                                        else {
                                            var r = k.elementType === k.type ? O.memoizedProps : rc(k.type, O.memoizedProps);
                                            w.componentDidUpdate(r, O.memoizedState, w.__reactInternalSnapshotBeforeUpdate);
                                        }
                                    }
                                    var t = k.updateQueue;
                                    null !== t && Qc(k, t, w, p);
                                    break;
                                case 3:
                                    var N = k.updateQueue;
                                    if (null !== N) {
                                        g = null;
                                        if (null !== k.child) switch(k.child.tag){
                                            case 5:
                                                g = za(k.child.stateNode);
                                                break;
                                            case 1:
                                                g = k.child.stateNode;
                                        }
                                        Qc(k, N, g, p);
                                    }
                                    break;
                                case 5:
                                    var Mc = k.stateNode;
                                    null === O && k.effectTag & 4 && Wa(Mc, k.type, k.memoizedProps, k);
                                    break;
                                case 6:
                                    break;
                                case 4:
                                    break;
                                case 12:
                                    break;
                                case 13:
                                    if (Sa && null === k.memoizedState) {
                                        var Rb = k.alternate;
                                        if (null !== Rb) {
                                            var le = Rb.memoizedState;
                                            if (null !== le) {
                                                var me = le.dehydrated;
                                                null !== me && yb(me);
                                            }
                                        }
                                    }
                                    break;
                                case 19:
                                case 17:
                                case 20:
                                case 21:
                                    break;
                                default:
                                    throw Error(n(163));
                            }
                        }
                        if (Ha & 128) {
                            k = void 0;
                            var Sb = Y.ref;
                            if (null !== Sb) {
                                var v = Y.stateNode;
                                switch(Y.tag){
                                    case 5:
                                        k = za(v);
                                        break;
                                    default:
                                        k = v;
                                }
                                "function" === typeof Sb ? Sb(k) : Sb.current = k;
                            }
                        }
                        Y = Y.nextEffect;
                    }
                } catch (jb) {
                    if (null === Y) throw Error(n(330));
                    Re(Y, jb);
                    Y = Y.nextEffect;
                }
                while (null !== Y);
                Y = null;
                ac();
                T = f;
            } else a.current = c;
            if (Gf) Gf = !1, Hf = a, If = b;
            else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
            b = a.firstPendingTime;
            0 === b && (nf = null);
            1073741823 === b ? a === Lf ? Kf++ : (Kf = 0, Lf = a) : Kf = 0;
            "function" === typeof lg && lg(c.stateNode, d);
            Z(a);
            if (kf) throw kf = !1, a = lf, lf = null, a;
            if ((T & rf) !== R) return null;
            F();
            return null;
        }
        function kg() {
            for(; null !== Y;){
                var a = Y.effectTag;
                0 !== (a & 256) && Te(Y.alternate, Y);
                0 === (a & 512) || Gf || (Gf = !0, ic(97, function() {
                    Vf();
                    return null;
                }));
                Y = Y.nextEffect;
            }
        }
        function Vf() {
            if (90 !== If) {
                var a = 97 < If ? 97 : If;
                If = 90;
                return hc(a, mg);
            }
        }
        function mg() {
            if (null === Hf) return !1;
            var a = Hf;
            Hf = null;
            if ((T & (S | sf)) !== R) throw Error(n(331));
            var b = T;
            T |= sf;
            for(a = a.current.firstEffect; null !== a;){
                try {
                    var c = a;
                    if (0 !== (c.effectTag & 512)) switch(c.tag){
                        case 0:
                        case 11:
                        case 15:
                            Ue(128, 0, c), Ue(0, 64, c);
                    }
                } catch (d) {
                    if (null === a) throw Error(n(330));
                    Re(a, d);
                }
                c = a.nextEffect;
                a.nextEffect = null;
                a = c;
            }
            T = b;
            F();
            return !0;
        }
        function ng(a, b, c) {
            b = Ne(c, b);
            b = jf(a, b, 1073741823);
            Ic(a, b);
            a = Nf(a, 1073741823);
            null !== a && Z(a);
        }
        function Re(a, b) {
            if (3 === a.tag) ng(a, a, b);
            else for(var c = a.return; null !== c;){
                if (3 === c.tag) {
                    ng(c, a, b);
                    break;
                } else if (1 === c.tag) {
                    var d = c.stateNode;
                    if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === nf || !nf.has(d))) {
                        a = Ne(b, a);
                        a = mf(c, a, 1073741823);
                        Ic(c, a);
                        c = Nf(c, 1073741823);
                        null !== c && Z(c);
                        break;
                    }
                }
                c = c.return;
            }
        }
        function fg(a, b, c) {
            var d = a.pingCache;
            null !== d && d.delete(b);
            U === a && W === c ? X === xf || X === wf && 1073741823 === Af && E() - ff < Ff ? Wf(a, W) : Ef = !0 : Sf(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, a.finishedExpirationTime === c && (a.finishedExpirationTime = 0, a.finishedWork = null), Z(a)));
        }
        function gf(a, b) {
            var c = a.stateNode;
            null !== c && c.delete(b);
            b = 0;
            0 === b && (b = G(), b = Vc(b, a, null));
            a = Nf(a, b);
            null !== a && Z(a);
        }
        var ig;
        ig = function ig(a, b, c) {
            var d = b.expirationTime;
            if (null !== a) {
                var e = b.pendingProps;
                if (a.memoizedProps !== e || B.current) Bc = !0;
                else {
                    if (d < c) {
                        Bc = !1;
                        switch(b.tag){
                            case 3:
                                ze(b);
                                oe();
                                break;
                            case 5:
                                sd(b);
                                if (b.mode & 4 && 1 !== c && Ka(b.type, e)) return b.expirationTime = b.childExpirationTime = 1, null;
                                break;
                            case 1:
                                C(b.type) && Kb(b);
                                break;
                            case 4:
                                qd(b, b.stateNode.containerInfo);
                                break;
                            case 10:
                                xc(b, b.memoizedProps.value);
                                break;
                            case 13:
                                if (null !== b.memoizedState) {
                                    d = b.child.childExpirationTime;
                                    if (0 !== d && d >= c) return Be(a, b, c);
                                    z(I, I.current & 1);
                                    b = re(a, b, c);
                                    return null !== b ? b.sibling : null;
                                }
                                z(I, I.current & 1);
                                break;
                            case 19:
                                d = b.childExpirationTime >= c;
                                if (0 !== (a.effectTag & 64)) {
                                    if (d) return Ee(a, b, c);
                                    b.effectTag |= 64;
                                }
                                e = b.memoizedState;
                                null !== e && (e.rendering = null, e.tail = null);
                                z(I, I.current);
                                if (!d) return null;
                        }
                        return re(a, b, c);
                    }
                    Bc = !1;
                }
            } else Bc = !1;
            b.expirationTime = 0;
            switch(b.tag){
                case 2:
                    d = b.type;
                    null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                    a = b.pendingProps;
                    e = Fb(b, A.current);
                    Ac(b, c);
                    e = Jd(null, b, d, a, e, c);
                    b.effectTag |= 1;
                    if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                        b.tag = 1;
                        Nd();
                        if (C(d)) {
                            var f = !0;
                            Kb(b);
                        } else f = !1;
                        b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                        var g = d.getDerivedStateFromProps;
                        "function" === typeof g && Uc(b, d, g, a);
                        e.updater = Xc;
                        b.stateNode = e;
                        e._reactInternalFiber = b;
                        ad(b, d, a, c);
                        b = ye(null, b, d, !0, f, c);
                    } else b.tag = 0, Q(null, b, e, c), b = b.child;
                    return b;
                case 16:
                    e = b.elementType;
                    null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                    a = b.pendingProps;
                    sa(e);
                    if (1 !== e._status) throw e._result;
                    e = e._result;
                    b.type = e;
                    f = b.tag = og(e);
                    a = rc(e, a);
                    switch(f){
                        case 0:
                            b = ve(null, b, e, a, c);
                            break;
                        case 1:
                            b = xe(null, b, e, a, c);
                            break;
                        case 11:
                            b = qe(null, b, e, a, c);
                            break;
                        case 14:
                            b = se(null, b, e, rc(e.type, a), d, c);
                            break;
                        default:
                            throw Error(n(306, e, ""));
                    }
                    return b;
                case 0:
                    return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), ve(a, b, d, e, c);
                case 1:
                    return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), xe(a, b, d, e, c);
                case 3:
                    ze(b);
                    d = b.updateQueue;
                    if (null === d) throw Error(n(282));
                    e = b.memoizedState;
                    e = null !== e ? e.element : null;
                    Nc(b, d, b.pendingProps, null, c);
                    d = b.memoizedState.element;
                    if (d === e) oe(), b = re(a, b, c);
                    else {
                        if (e = b.stateNode.hydrate) Sa ? (ee = tb(b.stateNode.containerInfo), de = b, e = fe = !0) : e = !1;
                        if (e) for(c = ld(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                        else Q(a, b, d, c), oe();
                        b = b.child;
                    }
                    return b;
                case 5:
                    return sd(b), null === a && je(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ja(d, e) ? g = null : null !== f && Ja(d, f) && (b.effectTag |= 16), we(a, b), b.mode & 4 && 1 !== c && Ka(d, e) ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (Q(a, b, g, c), b = b.child), b;
                case 6:
                    return null === a && je(b), null;
                case 13:
                    return Be(a, b, c);
                case 4:
                    return qd(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = kd(b, null, d, c) : Q(a, b, d, c), b.child;
                case 11:
                    return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), qe(a, b, d, e, c);
                case 7:
                    return Q(a, b, b.pendingProps, c), b.child;
                case 8:
                    return Q(a, b, b.pendingProps.children, c), b.child;
                case 12:
                    return Q(a, b, b.pendingProps.children, c), b.child;
                case 10:
                    a: {
                        d = b.type._context;
                        e = b.pendingProps;
                        g = b.memoizedProps;
                        f = e.value;
                        xc(b, f);
                        if (null !== g) {
                            var l = g.value;
                            f = oc(l, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(l, f) : 1073741823) | 0;
                            if (0 === f) {
                                if (g.children === e.children && !B.current) {
                                    b = re(a, b, c);
                                    break a;
                                }
                            } else for(l = b.child, null !== l && (l.return = b); null !== l;){
                                var h = l.dependencies;
                                if (null !== h) {
                                    g = l.child;
                                    for(var k = h.firstContext; null !== k;){
                                        if (k.context === d && 0 !== (k.observedBits & f)) {
                                            1 === l.tag && (k = Gc(c, null), k.tag = 2, Ic(l, k));
                                            l.expirationTime < c && (l.expirationTime = c);
                                            k = l.alternate;
                                            null !== k && k.expirationTime < c && (k.expirationTime = c);
                                            zc(l.return, c);
                                            h.expirationTime < c && (h.expirationTime = c);
                                            break;
                                        }
                                        k = k.next;
                                    }
                                } else g = 10 === l.tag ? l.type === b.type ? null : l.child : l.child;
                                if (null !== g) g.return = l;
                                else for(g = l; null !== g;){
                                    if (g === b) {
                                        g = null;
                                        break;
                                    }
                                    l = g.sibling;
                                    if (null !== l) {
                                        l.return = g.return;
                                        g = l;
                                        break;
                                    }
                                    g = g.return;
                                }
                                l = g;
                            }
                        }
                        Q(a, b, e.children, c);
                        b = b.child;
                    }
                    return b;
                case 9:
                    return e = b.type, f = b.pendingProps, d = f.children, Ac(b, c), e = Cc(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, Q(a, b, d, c), b.child;
                case 14:
                    return e = b.type, f = rc(e, b.pendingProps), f = rc(e.type, f), se(a, b, e, f, d, c);
                case 15:
                    return ue(a, b, b.type, b.pendingProps, d, c);
                case 17:
                    return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, C(d) ? (a = !0, Kb(b)) : a = !1, Ac(b, c), Zc(b, d, e), ad(b, d, e, c), ye(null, b, d, !0, a, c);
                case 19:
                    return Ee(a, b, c);
            }
            throw Error(n(156, b.tag));
        };
        var lg = null, We = null;
        function pg(a) {
            if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (b.isDisabled || !b.supportsFiber) return !0;
            try {
                var c = b.inject(a);
                lg = function lg(a) {
                    try {
                        b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
                    } catch (e) {}
                };
                We = function We(a) {
                    try {
                        b.onCommitFiberUnmount(c, a);
                    } catch (e) {}
                };
            } catch (d) {}
            return !0;
        }
        function qg(a, b, c, d) {
            this.tag = a;
            this.key = c;
            this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
            this.index = 0;
            this.ref = null;
            this.pendingProps = b;
            this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
            this.mode = d;
            this.effectTag = 0;
            this.lastEffect = this.firstEffect = this.nextEffect = null;
            this.childExpirationTime = this.expirationTime = 0;
            this.alternate = null;
        }
        function he(a, b, c, d) {
            return new qg(a, b, c, d);
        }
        function te(a) {
            a = a.prototype;
            return !(!a || !a.isReactComponent);
        }
        function og(a) {
            if ("function" === typeof a) return te(a) ? 1 : 0;
            if (void 0 !== a && null !== a) {
                a = a.$$typeof;
                if (a === la) return 11;
                if (a === oa) return 14;
            }
            return 2;
        }
        function fd(a, b) {
            var c = a.alternate;
            null === c ? (c = he(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
            c.childExpirationTime = a.childExpirationTime;
            c.expirationTime = a.expirationTime;
            c.child = a.child;
            c.memoizedProps = a.memoizedProps;
            c.memoizedState = a.memoizedState;
            c.updateQueue = a.updateQueue;
            b = a.dependencies;
            c.dependencies = null === b ? null : {
                expirationTime: b.expirationTime,
                firstContext: b.firstContext,
                responders: b.responders
            };
            c.sibling = a.sibling;
            c.index = a.index;
            c.ref = a.ref;
            return c;
        }
        function hd(a, b, c, d, e, f) {
            var g = 2;
            d = a;
            if ("function" === typeof a) te(a) && (g = 1);
            else if ("string" === typeof a) g = 5;
            else a: switch(a){
                case ea:
                    return jd(c.children, e, f, b);
                case ka:
                    g = 8;
                    e |= 7;
                    break;
                case fa:
                    g = 8;
                    e |= 1;
                    break;
                case ha:
                    return a = he(12, c, b, e | 8), a.elementType = ha, a.type = ha, a.expirationTime = f, a;
                case ma:
                    return a = he(13, c, b, e), a.type = ma, a.elementType = ma, a.expirationTime = f, a;
                case na:
                    return a = he(19, c, b, e), a.elementType = na, a.expirationTime = f, a;
                default:
                    if ("object" === typeof a && null !== a) switch(a.$$typeof){
                        case ia:
                            g = 10;
                            break a;
                        case ja:
                            g = 9;
                            break a;
                        case la:
                            g = 11;
                            break a;
                        case oa:
                            g = 14;
                            break a;
                        case pa:
                            g = 16;
                            d = null;
                            break a;
                    }
                    throw Error(n(130, null == a ? a : typeof a, ""));
            }
            b = he(g, c, b, e);
            b.elementType = a;
            b.type = d;
            b.expirationTime = f;
            return b;
        }
        function jd(a, b, c, d) {
            a = he(7, a, d, b);
            a.expirationTime = c;
            return a;
        }
        function gd(a, b, c) {
            a = he(6, a, null, b);
            a.expirationTime = c;
            return a;
        }
        function id(a, b, c) {
            b = he(4, null !== a.children ? a.children : [], a.key, b);
            b.expirationTime = c;
            b.stateNode = {
                containerInfo: a.containerInfo,
                pendingChildren: null,
                implementation: a.implementation
            };
            return b;
        }
        function rg(a, b, c) {
            this.tag = b;
            this.current = null;
            this.containerInfo = a;
            this.pingCache = this.pendingChildren = null;
            this.finishedExpirationTime = 0;
            this.finishedWork = null;
            this.timeoutHandle = Oa;
            this.pendingContext = this.context = null;
            this.hydrate = c;
            this.callbackNode = null;
            this.callbackPriority = 90;
            this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
        }
        function Sf(a, b) {
            var c = a.firstSuspendedTime;
            a = a.lastSuspendedTime;
            return 0 !== c && c >= b && a <= b;
        }
        function Pf(a, b) {
            var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
            c < b && (a.firstSuspendedTime = b);
            if (d > b || 0 === c) a.lastSuspendedTime = b;
            b <= a.lastPingedTime && (a.lastPingedTime = 0);
            b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
        }
        function Qf(a, b) {
            b > a.firstPendingTime && (a.firstPendingTime = b);
            var c = a.firstSuspendedTime;
            0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
        }
        function Uf(a, b) {
            var c = a.lastExpiredTime;
            if (0 === c || c > b) a.lastExpiredTime = b;
        }
        function sg(a) {
            var b = a._reactInternalFiber;
            if (void 0 === b) {
                if ("function" === typeof a.render) throw Error(n(188));
                throw Error(n(268, Object.keys(a)));
            }
            a = xa(b);
            return null === a ? null : a.stateNode;
        }
        function tg(a, b) {
            a = a.memoizedState;
            null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
        }
        function ug(a, b) {
            tg(a, b);
            (a = a.alternate) && tg(a, b);
        }
        var vg = {
            createContainer: function createContainer(a, b, c) {
                a = new rg(a, b, c);
                b = he(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
                a.current = b;
                return b.stateNode = a;
            },
            updateContainer: function updateContainer(a, b, c, d) {
                var e = b.current, f = G(), g = Sc.suspense;
                f = Vc(f, e, g);
                a: if (c) {
                    c = c._reactInternalFiber;
                    b: {
                        if (ua(c) !== c || 1 !== c.tag) throw Error(n(170));
                        var l = c;
                        do {
                            switch(l.tag){
                                case 3:
                                    l = l.stateNode.context;
                                    break b;
                                case 1:
                                    if (C(l.type)) {
                                        l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break b;
                                    }
                            }
                            l = l.return;
                        }while (null !== l);
                        throw Error(n(171));
                    }
                    if (1 === c.tag) {
                        var h = c.type;
                        if (C(h)) {
                            c = Jb(c, h, l);
                            break a;
                        }
                    }
                    c = l;
                } else c = Db;
                null === b.context ? b.context = c : b.pendingContext = c;
                b = Gc(f, g);
                b.payload = {
                    element: a
                };
                d = void 0 === d ? null : d;
                null !== d && (b.callback = d);
                Ic(e, b);
                Wc(e, f);
                return f;
            },
            batchedEventUpdates: function batchedEventUpdates(a, b) {
                var c = T;
                T |= 2;
                try {
                    return a(b);
                } finally{
                    T = c, T === R && F();
                }
            },
            batchedUpdates: function batchedUpdates(a, b) {
                var c = T;
                T |= 1;
                try {
                    return a(b);
                } finally{
                    T = c, T === R && F();
                }
            },
            unbatchedUpdates: function unbatchedUpdates(a, b) {
                var c = T;
                T &= -2;
                T |= rf;
                try {
                    return a(b);
                } finally{
                    T = c, T === R && F();
                }
            },
            deferredUpdates: function deferredUpdates(a) {
                return hc(97, a);
            },
            syncUpdates: function syncUpdates(a, b, c, d) {
                return hc(99, a.bind(null, b, c, d));
            },
            discreteUpdates: function discreteUpdates(a, b, c, d) {
                var e = T;
                T |= 4;
                try {
                    return hc(98, a.bind(null, b, c, d));
                } finally{
                    T = e, T === R && F();
                }
            },
            flushDiscreteUpdates: function flushDiscreteUpdates() {
                (T & (1 | S | sf)) === R && (dg(), Vf());
            },
            flushControlled: function flushControlled(a) {
                var b = T;
                T |= 1;
                try {
                    hc(99, a);
                } finally{
                    T = b, T === R && F();
                }
            },
            flushSync: eg,
            flushPassiveEffects: Vf,
            IsThisRendererActing: {
                current: !1
            },
            getPublicRootInstance: function getPublicRootInstance(a) {
                a = a.current;
                if (!a.child) return null;
                switch(a.child.tag){
                    case 5:
                        return za(a.child.stateNode);
                    default:
                        return a.child.stateNode;
                }
            },
            attemptSynchronousHydration: function attemptSynchronousHydration(a) {
                switch(a.tag){
                    case 3:
                        var b = a.stateNode;
                        b.hydrate && cg(b, b.firstPendingTime);
                        break;
                    case 13:
                        eg(function() {
                            return Wc(a, 1073741823);
                        }), b = mc(G(), 150, 100), ug(a, b);
                }
            },
            attemptUserBlockingHydration: function attemptUserBlockingHydration(a) {
                if (13 === a.tag) {
                    var b = mc(G(), 150, 100);
                    Wc(a, b);
                    ug(a, b);
                }
            },
            attemptContinuousHydration: function attemptContinuousHydration(a) {
                if (13 === a.tag) {
                    G();
                    var b = lc++;
                    Wc(a, b);
                    ug(a, b);
                }
            },
            attemptHydrationAtCurrentPriority: function attemptHydrationAtCurrentPriority(a) {
                if (13 === a.tag) {
                    var b = G();
                    b = Vc(b, a, null);
                    Wc(a, b);
                    ug(a, b);
                }
            },
            findHostInstance: sg,
            findHostInstanceWithWarning: function findHostInstanceWithWarning(a) {
                return sg(a);
            },
            findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
                a = ya(a);
                return null === a ? null : 20 === a.tag ? a.stateNode.instance : a.stateNode;
            },
            shouldSuspend: function shouldSuspend() {
                return !1;
            },
            injectIntoDevTools: function injectIntoDevTools(a) {
                var b = a.findFiberByHostInstance;
                return pg(aa({}, a, {
                    overrideHookState: null,
                    overrideProps: null,
                    setSuspenseHandler: null,
                    scheduleUpdate: null,
                    currentDispatcherRef: q.ReactCurrentDispatcher,
                    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
                        a = xa(a);
                        return null === a ? null : a.stateNode;
                    },
                    findFiberByHostInstance: function findFiberByHostInstance(a) {
                        return b ? b(a) : null;
                    },
                    findHostInstancesForRefresh: null,
                    scheduleRefresh: null,
                    scheduleRoot: null,
                    setRefreshHandler: null,
                    getCurrentFiber: null
                }));
            }
        };
        module.exports = vg.default || vg;
        var $$$renderer = module.exports;
        module.exports = $$$reconciler;
        return $$$renderer;
    };
})(reactReconciler_production_min);
var ReactFiberReconciler = reactReconciler_production_min.exports;
/* eslint-disable no-continue */ /**
 * Checks if two sets of props are equal (recursively)
 *
 * @param {Object} props A
 * @param {Object} props B
 * @returns {Boolean} props equals?
 *
 */ var propsEqual = function propsEqual(a, b) {
    var oldPropsKeys = Object.keys(a);
    var newPropsKeys = Object.keys(b);
    if (oldPropsKeys.length !== newPropsKeys.length) return false;
    for(var i = 0; i < oldPropsKeys.length; i += 1){
        var propName = oldPropsKeys[i];
        if (propName === "render" && !a[propName] !== !b[propName]) return false;
        if (propName !== "children" && a[propName] !== b[propName]) {
            if (typeof a[propName] === "object" && typeof b[propName] === "object" && propsEqual(a[propName], b[propName])) continue;
            return false;
        }
        if (propName === "children" && (typeof a[propName] === "string" || typeof b[propName] === "string")) return a[propName] === b[propName];
    }
    return true;
};
var _excluded$1 = [
    "style",
    "children"
], _excluded2 = [
    "style"
];
var emptyObject = {};
var appendChild = function appendChild(parentInstance, child) {
    var isParentText = parentInstance.type === "TEXT" || parentInstance.type === "LINK" || parentInstance.type === "TSPAN";
    var isChildTextInstance = child.type === "TEXT_INSTANCE";
    var isOrphanTextInstance = isChildTextInstance && !isParentText;
    // Ignore orphan text instances.
    // Caused by cases such as <>{name && <Text>{name}</Text>}</>
    if (isOrphanTextInstance) {
        console.warn("Invalid '" + child.value + "' string child outside <Text> component");
        return;
    }
    parentInstance.children.push(child);
};
var createRenderer = function createRenderer(_ref) {
    var _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? function() {} : _ref$onChange;
    return ReactFiberReconciler({
        schedulePassiveEffects: _scheduler.unstable_scheduleCallback,
        cancelPassiveEffects: _scheduler.unstable_cancelCallback,
        supportsMutation: true,
        isPrimaryRenderer: false,
        warnsIfNotActing: false,
        appendInitialChild: appendChild,
        createInstance: function createInstance(type, _ref2) {
            var style = _ref2.style;
            _ref2.children;
            var props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded$1);
            return {
                type: type,
                box: {},
                style: style || {},
                props: props || {},
                children: []
            };
        },
        createTextInstance: function createTextInstance(text, rootContainerInstance) {
            return {
                type: "TEXT_INSTANCE",
                value: text
            };
        },
        finalizeInitialChildren: function finalizeInitialChildren(element, type, props) {
            return false;
        },
        getPublicInstance: function getPublicInstance(instance) {
            return instance;
        },
        prepareForCommit: function prepareForCommit() {
        // Noop
        },
        clearContainer: function clearContainer() {
        // Noop
        },
        prepareUpdate: function prepareUpdate(element, type, oldProps, newProps) {
            return !propsEqual(oldProps, newProps);
        },
        resetAfterCommit: onChange,
        resetTextContent: function resetTextContent(element) {
        // Noop
        },
        getRootHostContext: function getRootHostContext() {
            return emptyObject;
        },
        getChildHostContext: function getChildHostContext() {
            return emptyObject;
        },
        shouldSetTextContent: function shouldSetTextContent(type, props) {
            return false;
        },
        now: Date.now,
        useSyncScheduling: true,
        appendChild: appendChild,
        appendChildToContainer: function appendChildToContainer(parentInstance, child) {
            if (parentInstance.type === "ROOT") parentInstance.document = child;
            else appendChild(parentInstance, child);
        },
        insertBefore: function insertBefore(parentInstance, child, beforeChild) {
            var _parentInstance$child;
            var index = (_parentInstance$child = parentInstance.children) === null || _parentInstance$child === void 0 ? void 0 : _parentInstance$child.indexOf(beforeChild);
            if (index === undefined) return;
            if (index !== -1 && child) parentInstance.children.splice(index, 0, child);
        },
        removeChild: function removeChild(parentInstance, child) {
            var _parentInstance$child2;
            var index = (_parentInstance$child2 = parentInstance.children) === null || _parentInstance$child2 === void 0 ? void 0 : _parentInstance$child2.indexOf(child);
            if (index === undefined) return;
            if (index !== -1) parentInstance.children.splice(index, 1);
        },
        removeChildFromContainer: function removeChildFromContainer(parentInstance, child) {
            var _parentInstance$child3;
            var index = (_parentInstance$child3 = parentInstance.children) === null || _parentInstance$child3 === void 0 ? void 0 : _parentInstance$child3.indexOf(child);
            if (index === undefined) return;
            if (index !== -1) parentInstance.children.splice(index, 1);
        },
        commitTextUpdate: function commitTextUpdate(textInstance, oldText, newText) {
            textInstance.value = newText;
        },
        commitUpdate: function commitUpdate(instance, updatePayload, type, oldProps, newProps) {
            var style = newProps.style, props = (0, _objectWithoutPropertiesLooseDefault.default)(newProps, _excluded2);
            instance.props = props;
            instance.style = style;
        }
    });
};
var version = "3.1.9";
var fontStore = new (0, _fontDefault.default)();
// We must keep a single renderer instance, otherwise React will complain
var renderer;
// The pdf instance acts as an event emitter for DOM usage.
// We only want to trigger an update when PDF content changes
var events = {};
var pdf = function pdf(initialValue) {
    var onChange = function onChange() {
        var _events$change;
        var listeners = ((_events$change = events.change) === null || _events$change === void 0 ? void 0 : _events$change.slice()) || [];
        for(var i = 0; i < listeners.length; i += 1)listeners[i]();
    };
    var container = {
        type: "ROOT",
        document: null
    };
    renderer = renderer || createRenderer({
        onChange: onChange
    });
    var mountNode = renderer.createContainer(container);
    var updateContainer = function updateContainer(doc) {
        renderer.updateContainer(doc, mountNode, null);
    };
    if (initialValue) updateContainer(initialValue);
    var render = /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(compress) {
            var props, pdfVersion, language, pageLayout, pageMode, ctx, layout, fileStream;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (compress === void 0) compress = true;
                        props = container.document.props || {};
                        pdfVersion = props.pdfVersion, language = props.language, pageLayout = props.pageLayout, pageMode = props.pageMode;
                        ctx = new (0, _pdfkitDefault.default)({
                            compress: compress,
                            pdfVersion: pdfVersion,
                            lang: language,
                            displayTitle: true,
                            autoFirstPage: false,
                            pageLayout: pageLayout,
                            pageMode: pageMode
                        });
                        _context.next = 6;
                        return (0, _layoutDefault.default)(container.document, fontStore);
                    case 6:
                        layout = _context.sent;
                        fileStream = (0, _renderDefault.default)(ctx, layout);
                        return _context.abrupt("return", {
                            layout: layout,
                            fileStream: fileStream
                        });
                    case 9:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function render(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    var callOnRender = function callOnRender(params) {
        if (params === void 0) params = {};
        if (container.document.props.onRender) container.document.props.onRender(params);
    };
    var toBlob = /*#__PURE__*/ function() {
        var _ref2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee2() {
            var chunks, _yield$render, _INTERNAL__LAYOUT__DATA_, instance;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        chunks = [];
                        _context2.next = 3;
                        return render();
                    case 3:
                        _yield$render = _context2.sent;
                        _INTERNAL__LAYOUT__DATA_ = _yield$render.layout;
                        instance = _yield$render.fileStream;
                        return _context2.abrupt("return", new Promise(function(resolve, reject) {
                            instance.on("data", function(chunk) {
                                chunks.push(chunk instanceof Uint8Array ? chunk : new Uint8Array(chunk));
                            });
                            instance.on("end", function() {
                                try {
                                    var blob = new Blob(chunks, {
                                        type: "application/pdf"
                                    });
                                    callOnRender({
                                        blob: blob,
                                        _INTERNAL__LAYOUT__DATA_: _INTERNAL__LAYOUT__DATA_
                                    });
                                    resolve(blob);
                                } catch (error) {
                                    reject(error);
                                }
                            });
                        }));
                    case 7:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function toBlob() {
            return _ref2.apply(this, arguments);
        };
    }();
    // TODO: rename this method to `toStream` in next major release, because it return stream not a buffer
    var toBuffer = /*#__PURE__*/ function() {
        var _ref3 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee3() {
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        callOnRender();
                        _context3.next = 3;
                        return render();
                    case 3:
                        return _context3.abrupt("return", _context3.sent.fileStream);
                    case 4:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3);
        }));
        return function toBuffer() {
            return _ref3.apply(this, arguments);
        };
    }();
    /*
   * TODO: remove this method in next major release. it is buggy
   * see
   * - https://github.com/diegomura/react-pdf/issues/2112
   * - https://github.com/diegomura/react-pdf/issues/2095
   */ var toString = /*#__PURE__*/ function() {
        var _ref4 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee4() {
            var result, _yield$render2, instance;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        result = "";
                        _context4.next = 4;
                        return render(false);
                    case 4:
                        _yield$render2 = _context4.sent;
                        instance = _yield$render2.fileStream;
                        return _context4.abrupt("return", new Promise(function(resolve, reject) {
                            try {
                                instance.on("data", function(buffer) {
                                    result += buffer;
                                });
                                instance.on("end", function() {
                                    callOnRender();
                                    resolve(result);
                                });
                            } catch (error) {
                                reject(error);
                            }
                        }));
                    case 7:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4);
        }));
        return function toString() {
            return _ref4.apply(this, arguments);
        };
    }();
    var on = function on(event, listener) {
        if (!events[event]) events[event] = [];
        events[event].push(listener);
    };
    var removeListener = function removeListener(event, listener) {
        if (!events[event]) return;
        var idx = events[event].indexOf(listener);
        if (idx > -1) events[event].splice(idx, 1);
    };
    return {
        on: on,
        container: container,
        toBlob: toBlob,
        toBuffer: toBuffer,
        toString: toString,
        removeListener: removeListener,
        updateContainer: updateContainer
    };
};
var Font = fontStore;
var StyleSheet = {
    create: function create(s) {
        return s;
    }
};
var usePDF = function usePDF(_ref) {
    var document = _ref.document;
    var pdfInstance = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)({
        url: null,
        blob: null,
        error: null,
        loading: false
    }), state = _useState[0], setState = _useState[1];
    // Setup rendering queue
    (0, _react.useEffect)(function() {
        var renderQueue = (0, _queueDefault.default)({
            autostart: true,
            concurrency: 1
        });
        var queueDocumentRender = function queueDocumentRender() {
            setState(function(prev) {
                return (0, _extendsDefault.default)({}, prev, {
                    loading: true
                });
            });
            renderQueue.splice(0, renderQueue.length, function() {
                return state.error ? Promise.resolve() : pdfInstance.current.toBlob();
            });
        };
        var onRenderFailed = function onRenderFailed(error) {
            console.error(error);
            setState(function(prev) {
                return (0, _extendsDefault.default)({}, prev, {
                    error: error
                });
            });
        };
        var onRenderSuccessful = function onRenderSuccessful(blob) {
            setState({
                blob: blob,
                error: null,
                loading: false,
                url: URL.createObjectURL(blob)
            });
        };
        pdfInstance.current = pdf();
        pdfInstance.current.on("change", queueDocumentRender);
        pdfInstance.current.updateContainer(document);
        renderQueue.on("error", onRenderFailed);
        renderQueue.on("success", onRenderSuccessful);
        return function() {
            renderQueue.end();
            pdfInstance.current.removeListener("change", queueDocumentRender);
        };
    }, []);
    // Revoke old unused url instances
    (0, _react.useEffect)(function() {
        return function() {
            if (state.url) URL.revokeObjectURL(state.url);
        };
    }, [
        state.url
    ]);
    var update = function update() {
        pdfInstance.current.updateContainer(document);
    };
    return [
        state,
        update
    ];
};
var _excluded = [
    "title",
    "style",
    "className",
    "children",
    "innerRef",
    "showToolbar"
];
var PDFViewer = function PDFViewer(_ref) {
    var title = _ref.title, style = _ref.style, className = _ref.className, children = _ref.children, innerRef = _ref.innerRef, _ref$showToolbar = _ref.showToolbar, showToolbar = _ref$showToolbar === void 0 ? true : _ref$showToolbar, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    var _usePDF = usePDF({
        document: children
    }), instance = _usePDF[0], updateInstance = _usePDF[1];
    (0, _react.useEffect)(updateInstance, [
        children
    ]);
    var src = instance.url ? instance.url + "#toolbar=" + (showToolbar ? 1 : 0) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", (0, _extendsDefault.default)({
        src: src,
        title: title,
        ref: innerRef,
        style: style,
        className: className
    }, props));
};
/* eslint-disable no-console */ var BlobProvider = function BlobProvider(_ref) {
    var doc = _ref.document, children = _ref.children;
    var _usePDF = usePDF({
        document: doc
    }), instance = _usePDF[0], updateInstance = _usePDF[1];
    (0, _react.useEffect)(updateInstance, [
        doc
    ]);
    if (!doc) {
        console.warn("You should pass a valid document to BlobProvider");
        return null;
    }
    return children(instance);
};
/* eslint-disable no-console */ var PDFDownloadLink = function PDFDownloadLink(_ref) {
    var style = _ref.style, children = _ref.children, className = _ref.className, doc = _ref.document, _ref$fileName = _ref.fileName, fileName = _ref$fileName === void 0 ? "document.pdf" : _ref$fileName, onClick = _ref.onClick;
    var _usePDF = usePDF({
        document: doc
    }), instance = _usePDF[0], updateInstance = _usePDF[1];
    (0, _react.useEffect)(updateInstance, [
        children
    ]);
    if (!doc) {
        console.warn("You should pass a valid document to PDFDownloadLink");
        return null;
    }
    var handleDownloadIE = function handleDownloadIE() {
        if (window.navigator.msSaveBlob) // IE
        window.navigator.msSaveBlob(instance.blob, fileName);
    };
    var handleClick = function handleClick(event) {
        handleDownloadIE();
        if (typeof onClick === "function") onClick(event, instance);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
        style: style,
        href: instance.url,
        download: fileName,
        className: className,
        onClick: handleClick,
        children: typeof children === "function" ? children(instance) : children
    });
};
var throwEnvironmentError = function throwEnvironmentError(name) {
    throw new Error(name + " is a Node specific API. You're either using this method in a browser, or your bundler is not loading react-pdf from the appropriate web build.");
};
var renderToStream = function renderToStream() {
    throwEnvironmentError("renderToStream");
};
var renderToBuffer = function renderToBuffer() {
    throwEnvironmentError("renderToBuffer");
};
var renderToString = function renderToString() {
    throwEnvironmentError("renderToString");
};
var renderToFile = function renderToFile() {
    throwEnvironmentError("renderToFile");
};
var render = function render() {
    throwEnvironmentError("render");
};
// TODO: remove this default export in next major release because it breaks tree-shacking
var index = (0, _extendsDefault.default)({
    pdf: pdf,
    usePDF: usePDF,
    Font: Font,
    version: version,
    StyleSheet: StyleSheet,
    PDFViewer: PDFViewer,
    BlobProvider: BlobProvider,
    PDFDownloadLink: PDFDownloadLink,
    renderToStream: renderToStream,
    renderToString: renderToString,
    renderToFile: renderToFile,
    render: render
}, _primitives);

},{"@babel/runtime/helpers/extends":"jbPGs","@react-pdf/primitives":"6ej9E","queue":"bbWK3","react":"d8NEQ","@babel/runtime/helpers/regeneratorRuntime":"03zO2","@babel/runtime/helpers/asyncToGenerator":"lbVvv","@react-pdf/font":"g8CTo","@react-pdf/render":"iJ9h8","@react-pdf/pdfkit":"wDNMs","@react-pdf/layout":"j3MsZ","@babel/runtime/helpers/objectWithoutPropertiesLoose":"jR58g","object-assign":"9tzOV","scheduler":"6PmbL","react/jsx-runtime":"gHQIF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jbPGs":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"6ej9E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "G", ()=>G);
parcelHelpers.export(exports, "Svg", ()=>Svg);
parcelHelpers.export(exports, "View", ()=>View);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "Page", ()=>Page);
parcelHelpers.export(exports, "Note", ()=>Note);
parcelHelpers.export(exports, "Path", ()=>Path);
parcelHelpers.export(exports, "Rect", ()=>Rect);
parcelHelpers.export(exports, "Line", ()=>Line);
parcelHelpers.export(exports, "Stop", ()=>Stop);
parcelHelpers.export(exports, "Defs", ()=>Defs);
parcelHelpers.export(exports, "Image", ()=>Image);
parcelHelpers.export(exports, "Tspan", ()=>Tspan);
parcelHelpers.export(exports, "Canvas", ()=>Canvas);
parcelHelpers.export(exports, "Circle", ()=>Circle);
parcelHelpers.export(exports, "Ellipse", ()=>Ellipse);
parcelHelpers.export(exports, "Polygon", ()=>Polygon);
parcelHelpers.export(exports, "Document", ()=>Document);
parcelHelpers.export(exports, "Polyline", ()=>Polyline);
parcelHelpers.export(exports, "ClipPath", ()=>ClipPath);
parcelHelpers.export(exports, "TextInstance", ()=>TextInstance);
parcelHelpers.export(exports, "LinearGradient", ()=>LinearGradient);
parcelHelpers.export(exports, "RadialGradient", ()=>RadialGradient);
const G = "G";
const Svg = "SVG";
const View = "VIEW";
const Text = "TEXT";
const Link = "LINK";
const Page = "PAGE";
const Note = "NOTE";
const Path = "PATH";
const Rect = "RECT";
const Line = "LINE";
const Stop = "STOP";
const Defs = "DEFS";
const Image = "IMAGE";
const Tspan = "TSPAN";
const Canvas = "CANVAS";
const Circle = "CIRCLE";
const Ellipse = "ELLIPSE";
const Polygon = "POLYGON";
const Document = "DOCUMENT";
const Polyline = "POLYLINE";
const ClipPath = "CLIP_PATH";
const TextInstance = "TEXT_INSTANCE";
const LinearGradient = "LINEAR_GRADIENT";
const RadialGradient = "RADIAL_GRADIENT";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bbWK3":[function(require,module,exports) {
var inherits = require("1075dd0c6e199d0e");
var EventEmitter = require("2935debf5437e7d1").EventEmitter;
module.exports = Queue;
module.exports.default = Queue;
function Queue(options) {
    if (!(this instanceof Queue)) return new Queue(options);
    EventEmitter.call(this);
    options = options || {};
    this.concurrency = options.concurrency || Infinity;
    this.timeout = options.timeout || 0;
    this.autostart = options.autostart || false;
    this.results = options.results || null;
    this.pending = 0;
    this.session = 0;
    this.running = false;
    this.jobs = [];
    this.timers = {};
}
inherits(Queue, EventEmitter);
var arrayMethods = [
    "pop",
    "shift",
    "indexOf",
    "lastIndexOf"
];
arrayMethods.forEach(function(method) {
    Queue.prototype[method] = function() {
        return Array.prototype[method].apply(this.jobs, arguments);
    };
});
Queue.prototype.slice = function(begin, end) {
    this.jobs = this.jobs.slice(begin, end);
    return this;
};
Queue.prototype.reverse = function() {
    this.jobs.reverse();
    return this;
};
var arrayAddMethods = [
    "push",
    "unshift",
    "splice"
];
arrayAddMethods.forEach(function(method) {
    Queue.prototype[method] = function() {
        var methodResult = Array.prototype[method].apply(this.jobs, arguments);
        if (this.autostart) this.start();
        return methodResult;
    };
});
Object.defineProperty(Queue.prototype, "length", {
    get: function() {
        return this.pending + this.jobs.length;
    }
});
Queue.prototype.start = function(cb) {
    if (cb) callOnErrorOrEnd.call(this, cb);
    this.running = true;
    if (this.pending >= this.concurrency) return;
    if (this.jobs.length === 0) {
        if (this.pending === 0) done.call(this);
        return;
    }
    var self = this;
    var job = this.jobs.shift();
    var once = true;
    var session = this.session;
    var timeoutId = null;
    var didTimeout = false;
    var resultIndex = null;
    var timeout = job.hasOwnProperty("timeout") ? job.timeout : this.timeout;
    function next(err, result) {
        if (once && self.session === session) {
            once = false;
            self.pending--;
            if (timeoutId !== null) {
                delete self.timers[timeoutId];
                clearTimeout(timeoutId);
            }
            if (err) self.emit("error", err, job);
            else if (didTimeout === false) {
                if (resultIndex !== null) self.results[resultIndex] = Array.prototype.slice.call(arguments, 1);
                self.emit("success", result, job);
            }
            if (self.session === session) {
                if (self.pending === 0 && self.jobs.length === 0) done.call(self);
                else if (self.running) self.start();
            }
        }
    }
    if (timeout) {
        timeoutId = setTimeout(function() {
            didTimeout = true;
            if (self.listeners("timeout").length > 0) self.emit("timeout", next, job);
            else next();
        }, timeout);
        this.timers[timeoutId] = timeoutId;
    }
    if (this.results) {
        resultIndex = this.results.length;
        this.results[resultIndex] = null;
    }
    this.pending++;
    self.emit("start", job);
    var promise = job(next);
    if (promise && promise.then && typeof promise.then === "function") promise.then(function(result) {
        return next(null, result);
    }).catch(function(err) {
        return next(err || true);
    });
    if (this.running && this.jobs.length > 0) this.start();
};
Queue.prototype.stop = function() {
    this.running = false;
};
Queue.prototype.end = function(err) {
    clearTimers.call(this);
    this.jobs.length = 0;
    this.pending = 0;
    done.call(this, err);
};
function clearTimers() {
    for(var key in this.timers){
        var timeoutId = this.timers[key];
        delete this.timers[key];
        clearTimeout(timeoutId);
    }
}
function callOnErrorOrEnd(cb) {
    var self = this;
    this.on("error", onerror);
    this.on("end", onend);
    function onerror(err) {
        self.end(err);
    }
    function onend(err) {
        self.removeListener("error", onerror);
        self.removeListener("end", onend);
        cb(err, this.results);
    }
}
function done(err) {
    this.session++;
    this.running = false;
    this.emit("end", err);
}

},{"1075dd0c6e199d0e":"b6YCC","2935debf5437e7d1":"3YOfL"}],"b6YCC":[function(require,module,exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"3YOfL":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"03zO2":[function(require,module,exports) {
var _typeof = require("921e792370458e88")["default"];
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"921e792370458e88":"7gkxm"}],"7gkxm":[function(require,module,exports) {
function _typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lbVvv":[function(require,module,exports) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"g8CTo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FontStore);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _isUrl = require("is-url");
var _crossFetch = require("cross-fetch");
var _crossFetchDefault = parcelHelpers.interopDefault(_crossFetch);
var _fontkit = require("fontkit");
var _excluded = [
    "src",
    "fontWeight",
    "fontStyle"
];
var FONT_WEIGHTS = {
    thin: 100,
    hairline: 100,
    ultralight: 200,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    demibold: 600,
    bold: 700,
    ultrabold: 800,
    extrabold: 800,
    heavy: 900,
    black: 900
};
var fetchFont = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(src, options) {
        var response, data;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, _crossFetchDefault.default)(src, options);
                case 2:
                    response = _context.sent;
                    _context.next = 5;
                    return response.arrayBuffer();
                case 5:
                    data = _context.sent;
                    return _context.abrupt("return", new Uint8Array(data));
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchFont(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var isDataUrl = function isDataUrl(dataUrl) {
    var header = dataUrl.split(",")[0];
    var hasDataPrefix = header.substring(0, 5) === "data:";
    var hasBase64Prefix = header.split(";")[1] === "base64";
    return hasDataPrefix && hasBase64Prefix;
};
var resolveFontWeight = function resolveFontWeight(value) {
    return typeof value === "string" ? FONT_WEIGHTS[value] : value;
};
var sortByFontWeight = function sortByFontWeight(a, b) {
    return a.fontWeight - b.fontWeight;
};
var FontSource = /*#__PURE__*/ function() {
    function FontSource(src, fontFamily, fontStyle, fontWeight, options) {
        this.src = src;
        this.fontFamily = fontFamily;
        this.fontStyle = fontStyle || "normal";
        this.fontWeight = fontWeight || 400;
        this.data = null;
        this.options = options;
        this.loadResultPromise = null;
    }
    var _proto = FontSource.prototype;
    _proto._load = /*#__PURE__*/ function() {
        var _load2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee2() {
            var postscriptName, raw, uint8Array, _this$options, headers, body, _this$options$method, method, data;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        postscriptName = this.options.postscriptName;
                        if (!isDataUrl(this.src)) {
                            _context2.next = 7;
                            break;
                        }
                        raw = this.src.split(",")[1];
                        uint8Array = new Uint8Array(atob(raw).split("").map(function(c) {
                            return c.charCodeAt(0);
                        }));
                        this.data = _fontkit.create(uint8Array, postscriptName);
                        _context2.next = 19;
                        break;
                    case 7:
                        _this$options = this.options, headers = _this$options.headers, body = _this$options.body, _this$options$method = _this$options.method, method = _this$options$method === void 0 ? "GET" : _this$options$method;
                        _context2.next = 11;
                        return fetchFont(this.src, {
                            method: method,
                            body: body,
                            headers: headers
                        });
                    case 11:
                        data = _context2.sent;
                        this.data = _fontkit.create(data, postscriptName);
                        _context2.next = 19;
                        break;
                    case 15:
                        _context2.next = 19;
                        break;
                    case 18:
                        this.data = _context2.sent;
                    case 19:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function _load() {
            return _load2.apply(this, arguments);
        }
        return _load;
    }();
    _proto.load = /*#__PURE__*/ function() {
        var _load3 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee3() {
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        if (this.loadResultPromise === null) this.loadResultPromise = this._load();
                        return _context3.abrupt("return", this.loadResultPromise);
                    case 2:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3, this);
        }));
        function load() {
            return _load3.apply(this, arguments);
        }
        return load;
    }();
    return FontSource;
}();
var Font = /*#__PURE__*/ function() {
    Font.create = function create(family) {
        return new Font(family);
    };
    function Font(family) {
        this.family = family;
        this.sources = [];
    }
    var _proto2 = Font.prototype;
    _proto2.register = function register(_ref2) {
        var src = _ref2.src, fontWeight = _ref2.fontWeight, fontStyle = _ref2.fontStyle, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
        var numericFontWeight = resolveFontWeight(fontWeight);
        this.sources.push(new FontSource(src, this.family, fontStyle, numericFontWeight, options));
    };
    _proto2.resolve = function resolve(descriptor) {
        var _descriptor$fontWeigh = descriptor.fontWeight, fontWeight = _descriptor$fontWeigh === void 0 ? 400 : _descriptor$fontWeigh, _descriptor$fontStyle = descriptor.fontStyle, fontStyle = _descriptor$fontStyle === void 0 ? "normal" : _descriptor$fontStyle;
        var styleSources = this.sources.filter(function(s) {
            return s.fontStyle === fontStyle;
        });
        // Weight resolution. https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#Fallback_weights
        var exactFit = styleSources.find(function(s) {
            return s.fontWeight === fontWeight;
        });
        if (exactFit) return exactFit;
        var res;
        if (fontWeight >= 400 && fontWeight <= 500) {
            var leftOffset = styleSources.filter(function(s) {
                return s.fontWeight <= fontWeight;
            });
            var rightOffset = styleSources.filter(function(s) {
                return s.fontWeight > 500;
            });
            var fit = styleSources.filter(function(s) {
                return s.fontWeight >= fontWeight && s.fontWeight < 500;
            });
            res = fit[0] || leftOffset[leftOffset.length - 1] || rightOffset[0];
        }
        var lt = styleSources.filter(function(s) {
            return s.fontWeight < fontWeight;
        }).sort(sortByFontWeight);
        var gt = styleSources.filter(function(s) {
            return s.fontWeight > fontWeight;
        }).sort(sortByFontWeight);
        if (fontWeight < 400) res = lt[lt.length - 1] || gt[0];
        if (fontWeight > 500) res = gt[0] || lt[lt.length - 1];
        if (!res) throw new Error("Could not resolve font for " + this.family + ", fontWeight " + fontWeight);
        return res;
    };
    return Font;
}();
var standard = [
    "Courier",
    "Courier-Bold",
    "Courier-Oblique",
    "Courier-BoldOblique",
    "Helvetica",
    "Helvetica-Bold",
    "Helvetica-Oblique",
    "Helvetica-BoldOblique",
    "Times-Roman",
    "Times-Bold",
    "Times-Italic",
    "Times-BoldItalic"
];
function FontStore() {
    var _this = this;
    var fonts = {};
    var emojiSource = null;
    var hyphenationCallback = null;
    this.register = function(data) {
        var family = data.family;
        if (!fonts[family]) fonts[family] = Font.create(family);
        // Bulk loading
        if (data.fonts) for(var i = 0; i < data.fonts.length; i += 1)fonts[family].register((0, _extendsDefault.default)({
            family: family
        }, data.fonts[i]));
        else fonts[family].register(data);
    };
    this.registerEmojiSource = function(_ref) {
        var url = _ref.url, _ref$format = _ref.format, format = _ref$format === void 0 ? "png" : _ref$format, builder = _ref.builder;
        emojiSource = {
            url: url,
            format: format,
            builder: builder
        };
    };
    this.registerHyphenationCallback = function(callback) {
        hyphenationCallback = callback;
    };
    this.getFont = function(descriptor) {
        var fontFamily = descriptor.fontFamily;
        var isStandard = standard.includes(fontFamily);
        if (isStandard) return null;
        if (!fonts[fontFamily]) throw new Error("Font family not registered: " + fontFamily + ". Please register it calling Font.register() method.");
        return fonts[fontFamily].resolve(descriptor);
    };
    this.load = /*#__PURE__*/ function() {
        var _ref2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(descriptor) {
            var fontFamily, isStandard, f;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        fontFamily = descriptor.fontFamily;
                        isStandard = standard.includes(fontFamily);
                        if (!isStandard) {
                            _context.next = 4;
                            break;
                        }
                        return _context.abrupt("return");
                    case 4:
                        f = _this.getFont(descriptor); // We cache the font to avoid fetching it many times
                        _context.next = 7;
                        return f.load();
                    case 7:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    this.reset = function() {
        var keys = Object.keys(fonts);
        for(var i = 0; i < keys.length; i += 1){
            var key = keys[i];
            fonts[key].data = null;
        }
    };
    this.clear = function() {
        fonts = {};
    };
    this.getRegisteredFonts = function() {
        return fonts;
    };
    this.getEmojiSource = function() {
        return emojiSource;
    };
    this.getHyphenationCallback = function() {
        return hyphenationCallback;
    };
    this.getRegisteredFontFamilies = function() {
        return Object.keys(fonts);
    };
}

},{"@babel/runtime/helpers/regeneratorRuntime":"03zO2","@babel/runtime/helpers/asyncToGenerator":"lbVvv","@babel/runtime/helpers/extends":"jbPGs","@babel/runtime/helpers/objectWithoutPropertiesLoose":"jR58g","is-url":"a0J4T","cross-fetch":"er2sO","fontkit":"58VtG","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jR58g":[function(require,module,exports) {
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"a0J4T":[function(require,module,exports) {
/**
 * Expose `isUrl`.
 */ module.exports = isUrl;
/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */ var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
/**
 * Loosely validate a URL `string`.
 *
 * @param {String} string
 * @return {Boolean}
 */ function isUrl(string) {
    if (typeof string !== "string") return false;
    var match = string.match(protocolAndDomainRE);
    if (!match) return false;
    var everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) return false;
    if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) return true;
    return false;
}

},{}],"er2sO":[function(require,module,exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

},{}],"58VtG":[function(require,module,exports) {
var $gfJaN$restructure = require("f21b476b3755c378");
var $gfJaN$swchelperslib_define_propertyjs = require("ff6728da855c7440");
var $gfJaN$swchelperslib_ts_decoratejs = require("6aa66445f242ca61");
var $gfJaN$fastdeepequal = require("512c7b618d747e29");
var $gfJaN$unicodeproperties = require("4c80a4567e3a20c2");
var $gfJaN$unicodetrie = require("5389545d6ddd3821");
var $gfJaN$dfa = require("bffd1a7b85ce30bb");
var $gfJaN$clone = require("b4fd531a03fcb1a9");
var $gfJaN$tinyinflate = require("998fb3c74b159a7f");
var $gfJaN$brotlidecompressjs = require("6035591d530ded93");
function $parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $59aa4ed98453e1d4$exports = {};
$parcel$export($59aa4ed98453e1d4$exports, "logErrors", ()=>$59aa4ed98453e1d4$export$bd5c5d8b8dcafd78);
$parcel$export($59aa4ed98453e1d4$exports, "registerFormat", ()=>$59aa4ed98453e1d4$export$36b2f24e97d43be);
$parcel$export($59aa4ed98453e1d4$exports, "create", ()=>$59aa4ed98453e1d4$export$185802fd694ee1f5);
$parcel$export($59aa4ed98453e1d4$exports, "defaultLanguage", ()=>$59aa4ed98453e1d4$export$42940898df819940);
$parcel$export($59aa4ed98453e1d4$exports, "setDefaultLanguage", ()=>$59aa4ed98453e1d4$export$5157e7780d44cc36);
let $59aa4ed98453e1d4$export$bd5c5d8b8dcafd78 = false;
let $59aa4ed98453e1d4$var$formats = [];
function $59aa4ed98453e1d4$export$36b2f24e97d43be(format) {
    $59aa4ed98453e1d4$var$formats.push(format);
}
function $59aa4ed98453e1d4$export$185802fd694ee1f5(buffer, postscriptName) {
    for(let i = 0; i < $59aa4ed98453e1d4$var$formats.length; i++){
        let format = $59aa4ed98453e1d4$var$formats[i];
        if (format.probe(buffer)) {
            let font = new format(new $gfJaN$restructure.DecodeStream(buffer));
            if (postscriptName) return font.getFont(postscriptName);
            return font;
        }
    }
    throw new Error("Unknown font format");
}
let $59aa4ed98453e1d4$export$42940898df819940 = "en";
function $59aa4ed98453e1d4$export$5157e7780d44cc36(lang = "en") {
    $59aa4ed98453e1d4$export$42940898df819940 = lang;
}
function $3bda6911913b43f0$export$69a3209f1a06c04d(target, key1, descriptor) {
    if (descriptor.get) {
        let get = descriptor.get;
        descriptor.get = function() {
            let value = get.call(this);
            Object.defineProperty(this, key1, {
                value: value
            });
            return value;
        };
    } else if (typeof descriptor.value === "function") {
        let fn = descriptor.value;
        return {
            get () {
                let cache1 = new Map;
                function memoized(...args) {
                    let key = args.length > 0 ? args[0] : "value";
                    if (cache1.has(key)) return cache1.get(key);
                    let result = fn.apply(this, args);
                    cache1.set(key, result);
                    return result;
                }
                Object.defineProperty(this, key1, {
                    value: memoized
                });
                return memoized;
            }
        };
    }
}
let $e4ae0436c91af89f$var$SubHeader = new $gfJaN$restructure.Struct({
    firstCode: $gfJaN$restructure.uint16,
    entryCount: $gfJaN$restructure.uint16,
    idDelta: $gfJaN$restructure.int16,
    idRangeOffset: $gfJaN$restructure.uint16
});
let $e4ae0436c91af89f$var$CmapGroup = new $gfJaN$restructure.Struct({
    startCharCode: $gfJaN$restructure.uint32,
    endCharCode: $gfJaN$restructure.uint32,
    glyphID: $gfJaN$restructure.uint32
});
let $e4ae0436c91af89f$var$UnicodeValueRange = new $gfJaN$restructure.Struct({
    startUnicodeValue: $gfJaN$restructure.uint24,
    additionalCount: $gfJaN$restructure.uint8
});
let $e4ae0436c91af89f$var$UVSMapping = new $gfJaN$restructure.Struct({
    unicodeValue: $gfJaN$restructure.uint24,
    glyphID: $gfJaN$restructure.uint16
});
let $e4ae0436c91af89f$var$DefaultUVS = new $gfJaN$restructure.Array($e4ae0436c91af89f$var$UnicodeValueRange, $gfJaN$restructure.uint32);
let $e4ae0436c91af89f$var$NonDefaultUVS = new $gfJaN$restructure.Array($e4ae0436c91af89f$var$UVSMapping, $gfJaN$restructure.uint32);
let $e4ae0436c91af89f$var$VarSelectorRecord = new $gfJaN$restructure.Struct({
    varSelector: $gfJaN$restructure.uint24,
    defaultUVS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $e4ae0436c91af89f$var$DefaultUVS, {
        type: "parent"
    }),
    nonDefaultUVS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $e4ae0436c91af89f$var$NonDefaultUVS, {
        type: "parent"
    })
});
let $e4ae0436c91af89f$var$CmapSubtable = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    0: {
        length: $gfJaN$restructure.uint16,
        language: $gfJaN$restructure.uint16,
        codeMap: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint8, 256)
    },
    2: {
        length: $gfJaN$restructure.uint16,
        language: $gfJaN$restructure.uint16,
        subHeaderKeys: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, 256),
        subHeaderCount: (t)=>Math.max.apply(Math, t.subHeaderKeys),
        subHeaders: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$SubHeader, "subHeaderCount"),
        glyphIndexArray: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "subHeaderCount")
    },
    4: {
        length: $gfJaN$restructure.uint16,
        language: $gfJaN$restructure.uint16,
        segCountX2: $gfJaN$restructure.uint16,
        segCount: (t)=>t.segCountX2 >> 1,
        searchRange: $gfJaN$restructure.uint16,
        entrySelector: $gfJaN$restructure.uint16,
        rangeShift: $gfJaN$restructure.uint16,
        endCode: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "segCount"),
        reservedPad: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        startCode: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "segCount"),
        idDelta: new $gfJaN$restructure.LazyArray($gfJaN$restructure.int16, "segCount"),
        idRangeOffset: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "segCount"),
        glyphIndexArray: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, (t)=>(t.length - t._currentOffset) / 2)
    },
    6: {
        length: $gfJaN$restructure.uint16,
        language: $gfJaN$restructure.uint16,
        firstCode: $gfJaN$restructure.uint16,
        entryCount: $gfJaN$restructure.uint16,
        glyphIndices: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "entryCount")
    },
    8: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        length: $gfJaN$restructure.uint32,
        language: $gfJaN$restructure.uint16,
        is32: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint8, 8192),
        nGroups: $gfJaN$restructure.uint32,
        groups: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$CmapGroup, "nGroups")
    },
    10: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        length: $gfJaN$restructure.uint32,
        language: $gfJaN$restructure.uint32,
        firstCode: $gfJaN$restructure.uint32,
        entryCount: $gfJaN$restructure.uint32,
        glyphIndices: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "numChars")
    },
    12: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        length: $gfJaN$restructure.uint32,
        language: $gfJaN$restructure.uint32,
        nGroups: $gfJaN$restructure.uint32,
        groups: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$CmapGroup, "nGroups")
    },
    13: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        length: $gfJaN$restructure.uint32,
        language: $gfJaN$restructure.uint32,
        nGroups: $gfJaN$restructure.uint32,
        groups: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$CmapGroup, "nGroups")
    },
    14: {
        length: $gfJaN$restructure.uint32,
        numRecords: $gfJaN$restructure.uint32,
        varSelectors: new $gfJaN$restructure.LazyArray($e4ae0436c91af89f$var$VarSelectorRecord, "numRecords")
    }
});
let $e4ae0436c91af89f$var$CmapEntry = new $gfJaN$restructure.Struct({
    platformID: $gfJaN$restructure.uint16,
    encodingID: $gfJaN$restructure.uint16,
    table: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $e4ae0436c91af89f$var$CmapSubtable, {
        type: "parent",
        lazy: true
    })
});
var $e4ae0436c91af89f$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numSubtables: $gfJaN$restructure.uint16,
    tables: new $gfJaN$restructure.Array($e4ae0436c91af89f$var$CmapEntry, "numSubtables")
});
var $55a60976afb7c261$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.int32,
    revision: $gfJaN$restructure.int32,
    checkSumAdjustment: $gfJaN$restructure.uint32,
    magicNumber: $gfJaN$restructure.uint32,
    flags: $gfJaN$restructure.uint16,
    unitsPerEm: $gfJaN$restructure.uint16,
    created: new $gfJaN$restructure.Array($gfJaN$restructure.int32, 2),
    modified: new $gfJaN$restructure.Array($gfJaN$restructure.int32, 2),
    xMin: $gfJaN$restructure.int16,
    yMin: $gfJaN$restructure.int16,
    xMax: $gfJaN$restructure.int16,
    yMax: $gfJaN$restructure.int16,
    macStyle: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
        "bold",
        "italic",
        "underline",
        "outline",
        "shadow",
        "condensed",
        "extended"
    ]),
    lowestRecPPEM: $gfJaN$restructure.uint16,
    fontDirectionHint: $gfJaN$restructure.int16,
    indexToLocFormat: $gfJaN$restructure.int16,
    glyphDataFormat: $gfJaN$restructure.int16 // 0 for current format
});
var $dde72b7b5b650596$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.int32,
    ascent: $gfJaN$restructure.int16,
    descent: $gfJaN$restructure.int16,
    lineGap: $gfJaN$restructure.int16,
    advanceWidthMax: $gfJaN$restructure.uint16,
    minLeftSideBearing: $gfJaN$restructure.int16,
    minRightSideBearing: $gfJaN$restructure.int16,
    xMaxExtent: $gfJaN$restructure.int16,
    caretSlopeRise: $gfJaN$restructure.int16,
    caretSlopeRun: $gfJaN$restructure.int16,
    caretOffset: $gfJaN$restructure.int16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.int16, 4),
    metricDataFormat: $gfJaN$restructure.int16,
    numberOfMetrics: $gfJaN$restructure.uint16 // Number of advance widths in 'hmtx' table
});
let $a7c40184072c9a5b$var$HmtxEntry = new $gfJaN$restructure.Struct({
    advance: $gfJaN$restructure.uint16,
    bearing: $gfJaN$restructure.int16
});
var $a7c40184072c9a5b$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    metrics: new $gfJaN$restructure.LazyArray($a7c40184072c9a5b$var$HmtxEntry, (t)=>t.parent.hhea.numberOfMetrics),
    bearings: new $gfJaN$restructure.LazyArray($gfJaN$restructure.int16, (t)=>t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics)
});
var $521197722369f691$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.int32,
    numGlyphs: $gfJaN$restructure.uint16,
    maxPoints: $gfJaN$restructure.uint16,
    maxContours: $gfJaN$restructure.uint16,
    maxComponentPoints: $gfJaN$restructure.uint16,
    maxComponentContours: $gfJaN$restructure.uint16,
    maxZones: $gfJaN$restructure.uint16,
    maxTwilightPoints: $gfJaN$restructure.uint16,
    maxStorage: $gfJaN$restructure.uint16,
    maxFunctionDefs: $gfJaN$restructure.uint16,
    maxInstructionDefs: $gfJaN$restructure.uint16,
    maxStackElements: $gfJaN$restructure.uint16,
    maxSizeOfInstructions: $gfJaN$restructure.uint16,
    maxComponentElements: $gfJaN$restructure.uint16,
    maxComponentDepth: $gfJaN$restructure.uint16 // Maximum levels of recursion; 1 for simple components
});
function $e2613b812f052cbe$export$badc544e0651b6b1(platformID, encodingID, languageID = 0) {
    if (platformID === 1 && $e2613b812f052cbe$export$479e671907f486d1[languageID]) return $e2613b812f052cbe$export$479e671907f486d1[languageID];
    return $e2613b812f052cbe$export$6fef87b7618bdf0b[platformID][encodingID];
}
const $e2613b812f052cbe$var$SINGLE_BYTE_ENCODINGS = new Set([
    "x-mac-roman",
    "x-mac-cyrillic",
    "iso-8859-6",
    "iso-8859-8"
]);
const $e2613b812f052cbe$var$MAC_ENCODINGS = {
    "x-mac-croatian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u03A9\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026 \xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uF8FF\xa9\u2044\u20AC\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7",
    "x-mac-gaelic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u1E02\xb1\u2264\u2265\u1E03\u010A\u010B\u1E0A\u1E0B\u1E1E\u1E1F\u0120\u0121\u1E40\xe6\xf8\u1E41\u1E56\u1E57\u027C\u0192\u017F\u1E60\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\u1E61\u1E9B\xff\u0178\u1E6A\u20AC\u2039\u203A\u0176\u0177\u1E6B\xb7\u1EF2\u1EF3\u204A\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\u2663\xd2\xda\xdb\xd9\u0131\xdd\xfd\u0174\u0175\u1E84\u1E85\u1E80\u1E81\u1E82\u1E83",
    "x-mac-greek": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\u20AC\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\xb7\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026 \u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\xad",
    "x-mac-icelandic": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
    "x-mac-inuit": "\u1403\u1404\u1405\u1406\u140A\u140B\u1431\u1432\u1433\u1434\u1438\u1439\u1449\u144E\u144F\u1450\u1451\u1455\u1456\u1466\u146D\u146E\u146F\u1470\u1472\u1473\u1483\u148B\u148C\u148D\u148E\u1490\u1491\xb0\u14A1\u14A5\u14A6\u2022\xb6\u14A7\xae\xa9\u2122\u14A8\u14AA\u14AB\u14BB\u14C2\u14C3\u14C4\u14C5\u14C7\u14C8\u14D0\u14EF\u14F0\u14F1\u14F2\u14F4\u14F5\u1505\u14D5\u14D6\u14D7\u14D8\u14DA\u14DB\u14EA\u1528\u1529\u152A\u152B\u152D\u2026 \u152E\u153E\u1555\u1556\u1557\u2013\u2014\u201C\u201D\u2018\u2019\u1558\u1559\u155A\u155D\u1546\u1547\u1548\u1549\u154B\u154C\u1550\u157F\u1580\u1581\u1582\u1583\u1584\u1585\u158F\u1590\u1591\u1592\u1593\u1594\u1595\u1671\u1672\u1673\u1674\u1675\u1676\u1596\u15A0\u15A1\u15A2\u15A3\u15A4\u15A5\u15A6\u157C\u0141\u0142",
    "x-mac-ce": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026 \u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7",
    "x-mac-romanian": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u0218\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\u0103\u0219\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\u20AC\u2039\u203A\u021A\u021B\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7",
    "x-mac-turkish": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u03A9\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026 \xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uF8FF\xd2\xda\xdb\xd9\uF8A0\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
};
const $e2613b812f052cbe$var$encodingCache = new Map();
function $e2613b812f052cbe$export$1dceb3c14ed68bee(encoding) {
    let cached = $e2613b812f052cbe$var$encodingCache.get(encoding);
    if (cached) return cached;
    // These encodings aren't supported by TextDecoder.
    let mapping = $e2613b812f052cbe$var$MAC_ENCODINGS[encoding];
    if (mapping) {
        let res = new Map();
        for(let i = 0; i < mapping.length; i++)res.set(mapping.charCodeAt(i), 0x80 + i);
        $e2613b812f052cbe$var$encodingCache.set(encoding, res);
        return res;
    }
    // Only single byte encodings can be mapped 1:1.
    if ($e2613b812f052cbe$var$SINGLE_BYTE_ENCODINGS.has(encoding)) {
        // TextEncoder only supports utf8, whereas TextDecoder supports legacy encodings.
        // Use this to create a mapping of code points.
        let decoder = new TextDecoder(encoding);
        let mapping = new Uint8Array(0x80);
        for(let i = 0; i < 0x80; i++)mapping[i] = 0x80 + i;
        let res = new Map();
        let s = decoder.decode(mapping);
        for(let i1 = 0; i1 < 0x80; i1++)res.set(s.charCodeAt(i1), 0x80 + i1);
        $e2613b812f052cbe$var$encodingCache.set(encoding, res);
        return res;
    }
}
const $e2613b812f052cbe$export$6fef87b7618bdf0b = [
    // unicode
    [
        "utf16be",
        "utf16be",
        "utf16be",
        "utf16be",
        "utf16be",
        "utf16be"
    ],
    // macintosh
    // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
    // 0	Roman                 17	Malayalam
    // 1	Japanese	            18	Sinhalese
    // 2	Traditional Chinese	  19	Burmese
    // 3	Korean	              20	Khmer
    // 4	Arabic	              21	Thai
    // 5	Hebrew	              22	Laotian
    // 6	Greek	                23	Georgian
    // 7	Russian	              24	Armenian
    // 8	RSymbol	              25	Simplified Chinese
    // 9	Devanagari	          26	Tibetan
    // 10	Gurmukhi	            27	Mongolian
    // 11	Gujarati	            28	Geez
    // 12	Oriya	                29	Slavic
    // 13	Bengali	              30	Vietnamese
    // 14	Tamil	                31	Sindhi
    // 15	Telugu	              32	(Uninterpreted)
    // 16	Kannada
    [
        "x-mac-roman",
        "shift-jis",
        "big5",
        "euc-kr",
        "iso-8859-6",
        "iso-8859-8",
        "x-mac-greek",
        "x-mac-cyrillic",
        "x-mac-symbol",
        "x-mac-devanagari",
        "x-mac-gurmukhi",
        "x-mac-gujarati",
        "Oriya",
        "Bengali",
        "Tamil",
        "Telugu",
        "Kannada",
        "Malayalam",
        "Sinhalese",
        "Burmese",
        "Khmer",
        "iso-8859-11",
        "Laotian",
        "Georgian",
        "Armenian",
        "hz-gb-2312",
        "Tibetan",
        "Mongolian",
        "Geez",
        "x-mac-ce",
        "Vietnamese",
        "Sindhi"
    ],
    // ISO (deprecated)
    [
        "ascii"
    ],
    // windows
    // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
    [
        "symbol",
        "utf16be",
        "shift-jis",
        "gb18030",
        "big5",
        "x-cp20949",
        "johab",
        null,
        null,
        null,
        "utf16be"
    ]
];
const $e2613b812f052cbe$export$479e671907f486d1 = {
    15: "x-mac-icelandic",
    17: "x-mac-turkish",
    18: "x-mac-croatian",
    24: "x-mac-ce",
    25: "x-mac-ce",
    26: "x-mac-ce",
    27: "x-mac-ce",
    28: "x-mac-ce",
    30: "x-mac-icelandic",
    37: "x-mac-romanian",
    38: "x-mac-ce",
    39: "x-mac-ce",
    40: "x-mac-ce",
    143: "x-mac-inuit",
    146: "x-mac-gaelic"
};
const $e2613b812f052cbe$export$2092376fd002e13 = [
    // unicode
    [],
    {
        0: "en",
        30: "fo",
        60: "ks",
        90: "rw",
        1: "fr",
        31: "fa",
        61: "ku",
        91: "rn",
        2: "de",
        32: "ru",
        62: "sd",
        92: "ny",
        3: "it",
        33: "zh",
        63: "bo",
        93: "mg",
        4: "nl",
        34: "nl-BE",
        64: "ne",
        94: "eo",
        5: "sv",
        35: "ga",
        65: "sa",
        128: "cy",
        6: "es",
        36: "sq",
        66: "mr",
        129: "eu",
        7: "da",
        37: "ro",
        67: "bn",
        130: "ca",
        8: "pt",
        38: "cz",
        68: "as",
        131: "la",
        9: "no",
        39: "sk",
        69: "gu",
        132: "qu",
        10: "he",
        40: "si",
        70: "pa",
        133: "gn",
        11: "ja",
        41: "yi",
        71: "or",
        134: "ay",
        12: "ar",
        42: "sr",
        72: "ml",
        135: "tt",
        13: "fi",
        43: "mk",
        73: "kn",
        136: "ug",
        14: "el",
        44: "bg",
        74: "ta",
        137: "dz",
        15: "is",
        45: "uk",
        75: "te",
        138: "jv",
        16: "mt",
        46: "be",
        76: "si",
        139: "su",
        17: "tr",
        47: "uz",
        77: "my",
        140: "gl",
        18: "hr",
        48: "kk",
        78: "km",
        141: "af",
        19: "zh-Hant",
        49: "az-Cyrl",
        79: "lo",
        142: "br",
        20: "ur",
        50: "az-Arab",
        80: "vi",
        143: "iu",
        21: "hi",
        51: "hy",
        81: "id",
        144: "gd",
        22: "th",
        52: "ka",
        82: "tl",
        145: "gv",
        23: "ko",
        53: "mo",
        83: "ms",
        146: "ga",
        24: "lt",
        54: "ky",
        84: "ms-Arab",
        147: "to",
        25: "pl",
        55: "tg",
        85: "am",
        148: "el-polyton",
        26: "hu",
        56: "tk",
        86: "ti",
        149: "kl",
        27: "es",
        57: "mn-CN",
        87: "om",
        150: "az",
        28: "lv",
        58: "mn",
        88: "so",
        151: "nn",
        29: "se",
        59: "ps",
        89: "sw"
    },
    // ISO (deprecated)
    [],
    {
        0x0436: "af",
        0x4009: "en-IN",
        0x0487: "rw",
        0x0432: "tn",
        0x041C: "sq",
        0x1809: "en-IE",
        0x0441: "sw",
        0x045B: "si",
        0x0484: "gsw",
        0x2009: "en-JM",
        0x0457: "kok",
        0x041B: "sk",
        0x045E: "am",
        0x4409: "en-MY",
        0x0412: "ko",
        0x0424: "sl",
        0x1401: "ar-DZ",
        0x1409: "en-NZ",
        0x0440: "ky",
        0x2C0A: "es-AR",
        0x3C01: "ar-BH",
        0x3409: "en-PH",
        0x0454: "lo",
        0x400A: "es-BO",
        0x0C01: "ar",
        0x4809: "en-SG",
        0x0426: "lv",
        0x340A: "es-CL",
        0x0801: "ar-IQ",
        0x1C09: "en-ZA",
        0x0427: "lt",
        0x240A: "es-CO",
        0x2C01: "ar-JO",
        0x2C09: "en-TT",
        0x082E: "dsb",
        0x140A: "es-CR",
        0x3401: "ar-KW",
        0x0809: "en-GB",
        0x046E: "lb",
        0x1C0A: "es-DO",
        0x3001: "ar-LB",
        0x0409: "en",
        0x042F: "mk",
        0x300A: "es-EC",
        0x1001: "ar-LY",
        0x3009: "en-ZW",
        0x083E: "ms-BN",
        0x440A: "es-SV",
        0x1801: "ary",
        0x0425: "et",
        0x043E: "ms",
        0x100A: "es-GT",
        0x2001: "ar-OM",
        0x0438: "fo",
        0x044C: "ml",
        0x480A: "es-HN",
        0x4001: "ar-QA",
        0x0464: "fil",
        0x043A: "mt",
        0x080A: "es-MX",
        0x0401: "ar-SA",
        0x040B: "fi",
        0x0481: "mi",
        0x4C0A: "es-NI",
        0x2801: "ar-SY",
        0x080C: "fr-BE",
        0x047A: "arn",
        0x180A: "es-PA",
        0x1C01: "aeb",
        0x0C0C: "fr-CA",
        0x044E: "mr",
        0x3C0A: "es-PY",
        0x3801: "ar-AE",
        0x040C: "fr",
        0x047C: "moh",
        0x280A: "es-PE",
        0x2401: "ar-YE",
        0x140C: "fr-LU",
        0x0450: "mn",
        0x500A: "es-PR",
        0x042B: "hy",
        0x180C: "fr-MC",
        0x0850: "mn-CN",
        0x0C0A: "es",
        0x044D: "as",
        0x100C: "fr-CH",
        0x0461: "ne",
        0x040A: "es",
        0x082C: "az-Cyrl",
        0x0462: "fy",
        0x0414: "nb",
        0x540A: "es-US",
        0x042C: "az",
        0x0456: "gl",
        0x0814: "nn",
        0x380A: "es-UY",
        0x046D: "ba",
        0x0437: "ka",
        0x0482: "oc",
        0x200A: "es-VE",
        0x042D: "eu",
        0x0C07: "de-AT",
        0x0448: "or",
        0x081D: "sv-FI",
        0x0423: "be",
        0x0407: "de",
        0x0463: "ps",
        0x041D: "sv",
        0x0845: "bn",
        0x1407: "de-LI",
        0x0415: "pl",
        0x045A: "syr",
        0x0445: "bn-IN",
        0x1007: "de-LU",
        0x0416: "pt",
        0x0428: "tg",
        0x201A: "bs-Cyrl",
        0x0807: "de-CH",
        0x0816: "pt-PT",
        0x085F: "tzm",
        0x141A: "bs",
        0x0408: "el",
        0x0446: "pa",
        0x0449: "ta",
        0x047E: "br",
        0x046F: "kl",
        0x046B: "qu-BO",
        0x0444: "tt",
        0x0402: "bg",
        0x0447: "gu",
        0x086B: "qu-EC",
        0x044A: "te",
        0x0403: "ca",
        0x0468: "ha",
        0x0C6B: "qu",
        0x041E: "th",
        0x0C04: "zh-HK",
        0x040D: "he",
        0x0418: "ro",
        0x0451: "bo",
        0x1404: "zh-MO",
        0x0439: "hi",
        0x0417: "rm",
        0x041F: "tr",
        0x0804: "zh",
        0x040E: "hu",
        0x0419: "ru",
        0x0442: "tk",
        0x1004: "zh-SG",
        0x040F: "is",
        0x243B: "smn",
        0x0480: "ug",
        0x0404: "zh-TW",
        0x0470: "ig",
        0x103B: "smj-NO",
        0x0422: "uk",
        0x0483: "co",
        0x0421: "id",
        0x143B: "smj",
        0x042E: "hsb",
        0x041A: "hr",
        0x045D: "iu",
        0x0C3B: "se-FI",
        0x0420: "ur",
        0x101A: "hr-BA",
        0x085D: "iu-Latn",
        0x043B: "se",
        0x0843: "uz-Cyrl",
        0x0405: "cs",
        0x083C: "ga",
        0x083B: "se-SE",
        0x0443: "uz",
        0x0406: "da",
        0x0434: "xh",
        0x203B: "sms",
        0x042A: "vi",
        0x048C: "prs",
        0x0435: "zu",
        0x183B: "sma-NO",
        0x0452: "cy",
        0x0465: "dv",
        0x0410: "it",
        0x1C3B: "sms",
        0x0488: "wo",
        0x0813: "nl-BE",
        0x0810: "it-CH",
        0x044F: "sa",
        0x0485: "sah",
        0x0413: "nl",
        0x0411: "ja",
        0x1C1A: "sr-Cyrl-BA",
        0x0478: "ii",
        0x0C09: "en-AU",
        0x044B: "kn",
        0x0C1A: "sr",
        0x046A: "yo",
        0x2809: "en-BZ",
        0x043F: "kk",
        0x181A: "sr-Latn-BA",
        0x1009: "en-CA",
        0x0453: "km",
        0x081A: "sr-Latn",
        0x2409: "en-029",
        0x0486: "quc",
        0x046C: "nso"
    }
];
let $51a9f4feb3a3b2b1$var$NameRecord = new $gfJaN$restructure.Struct({
    platformID: $gfJaN$restructure.uint16,
    encodingID: $gfJaN$restructure.uint16,
    languageID: $gfJaN$restructure.uint16,
    nameID: $gfJaN$restructure.uint16,
    length: $gfJaN$restructure.uint16,
    string: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.String("length", (t)=>$e2613b812f052cbe$export$badc544e0651b6b1(t.platformID, t.encodingID, t.languageID)), {
        type: "parent",
        relativeTo: (ctx)=>ctx.parent.stringOffset,
        allowNull: false
    })
});
let $51a9f4feb3a3b2b1$var$LangTagRecord = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint16,
    tag: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.String("length", "utf16be"), {
        type: "parent",
        relativeTo: (ctx)=>ctx.stringOffset
    })
});
var $51a9f4feb3a3b2b1$var$NameTable = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    0: {
        count: $gfJaN$restructure.uint16,
        stringOffset: $gfJaN$restructure.uint16,
        records: new $gfJaN$restructure.Array($51a9f4feb3a3b2b1$var$NameRecord, "count")
    },
    1: {
        count: $gfJaN$restructure.uint16,
        stringOffset: $gfJaN$restructure.uint16,
        records: new $gfJaN$restructure.Array($51a9f4feb3a3b2b1$var$NameRecord, "count"),
        langTagCount: $gfJaN$restructure.uint16,
        langTags: new $gfJaN$restructure.Array($51a9f4feb3a3b2b1$var$LangTagRecord, "langTagCount")
    }
});
var $51a9f4feb3a3b2b1$export$2e2bcd8739ae039 = $51a9f4feb3a3b2b1$var$NameTable;
const $51a9f4feb3a3b2b1$var$NAMES = [
    "copyright",
    "fontFamily",
    "fontSubfamily",
    "uniqueSubfamily",
    "fullName",
    "version",
    "postscriptName",
    "trademark",
    "manufacturer",
    "designer",
    "description",
    "vendorURL",
    "designerURL",
    "license",
    "licenseURL",
    null,
    "preferredFamily",
    "preferredSubfamily",
    "compatibleFull",
    "sampleText",
    "postscriptCIDFontName",
    "wwsFamilyName",
    "wwsSubfamilyName"
];
$51a9f4feb3a3b2b1$var$NameTable.process = function(stream) {
    var records = {};
    for (let record of this.records){
        // find out what language this is for
        let language = $e2613b812f052cbe$export$2092376fd002e13[record.platformID][record.languageID];
        if (language == null && this.langTags != null && record.languageID >= 0x8000) language = this.langTags[record.languageID - 0x8000].tag;
        if (language == null) language = record.platformID + "-" + record.languageID;
        // if the nameID is >= 256, it is a font feature record (AAT)
        let key = record.nameID >= 256 ? "fontFeatures" : $51a9f4feb3a3b2b1$var$NAMES[record.nameID] || record.nameID;
        if (records[key] == null) records[key] = {};
        let obj = records[key];
        if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
        if (typeof record.string === "string" || typeof obj[language] !== "string") obj[language] = record.string;
    }
    this.records = records;
};
$51a9f4feb3a3b2b1$var$NameTable.preEncode = function() {
    if (Array.isArray(this.records)) return;
    this.version = 0;
    let records = [];
    for(let key in this.records){
        let val = this.records[key];
        if (key === "fontFeatures") continue;
        records.push({
            platformID: 3,
            encodingID: 1,
            languageID: 0x409,
            nameID: $51a9f4feb3a3b2b1$var$NAMES.indexOf(key),
            length: val.en.length * 2,
            string: val.en
        });
        if (key === "postscriptName") records.push({
            platformID: 1,
            encodingID: 0,
            languageID: 0,
            nameID: $51a9f4feb3a3b2b1$var$NAMES.indexOf(key),
            length: val.en.length,
            string: val.en
        });
    }
    this.records = records;
    this.count = records.length;
    this.stringOffset = $51a9f4feb3a3b2b1$var$NameTable.size(this, null, false);
};
var $114ea85db469b435$var$OS2 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    header: {
        xAvgCharWidth: $gfJaN$restructure.int16,
        usWeightClass: $gfJaN$restructure.uint16,
        usWidthClass: $gfJaN$restructure.uint16,
        fsType: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
            null,
            "noEmbedding",
            "viewOnly",
            "editable",
            null,
            null,
            null,
            null,
            "noSubsetting",
            "bitmapOnly"
        ]),
        ySubscriptXSize: $gfJaN$restructure.int16,
        ySubscriptYSize: $gfJaN$restructure.int16,
        ySubscriptXOffset: $gfJaN$restructure.int16,
        ySubscriptYOffset: $gfJaN$restructure.int16,
        ySuperscriptXSize: $gfJaN$restructure.int16,
        ySuperscriptYSize: $gfJaN$restructure.int16,
        ySuperscriptXOffset: $gfJaN$restructure.int16,
        ySuperscriptYOffset: $gfJaN$restructure.int16,
        yStrikeoutSize: $gfJaN$restructure.int16,
        yStrikeoutPosition: $gfJaN$restructure.int16,
        sFamilyClass: $gfJaN$restructure.int16,
        panose: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, 10),
        ulCharRange: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, 4),
        vendorID: new $gfJaN$restructure.String(4),
        fsSelection: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
            "italic",
            "underscore",
            "negative",
            "outlined",
            "strikeout",
            "bold",
            "regular",
            "useTypoMetrics",
            "wws",
            "oblique"
        ]),
        usFirstCharIndex: $gfJaN$restructure.uint16,
        usLastCharIndex: $gfJaN$restructure.uint16 // The maximum Unicode index in this font
    },
    // The Apple version of this table ends here, but the Microsoft one continues on...
    0: {},
    1: {
        typoAscender: $gfJaN$restructure.int16,
        typoDescender: $gfJaN$restructure.int16,
        typoLineGap: $gfJaN$restructure.int16,
        winAscent: $gfJaN$restructure.uint16,
        winDescent: $gfJaN$restructure.uint16,
        codePageRange: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, 2)
    },
    2: {
        // these should be common with version 1 somehow
        typoAscender: $gfJaN$restructure.int16,
        typoDescender: $gfJaN$restructure.int16,
        typoLineGap: $gfJaN$restructure.int16,
        winAscent: $gfJaN$restructure.uint16,
        winDescent: $gfJaN$restructure.uint16,
        codePageRange: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, 2),
        xHeight: $gfJaN$restructure.int16,
        capHeight: $gfJaN$restructure.int16,
        defaultChar: $gfJaN$restructure.uint16,
        breakChar: $gfJaN$restructure.uint16,
        maxContent: $gfJaN$restructure.uint16
    },
    5: {
        typoAscender: $gfJaN$restructure.int16,
        typoDescender: $gfJaN$restructure.int16,
        typoLineGap: $gfJaN$restructure.int16,
        winAscent: $gfJaN$restructure.uint16,
        winDescent: $gfJaN$restructure.uint16,
        codePageRange: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, 2),
        xHeight: $gfJaN$restructure.int16,
        capHeight: $gfJaN$restructure.int16,
        defaultChar: $gfJaN$restructure.uint16,
        breakChar: $gfJaN$restructure.uint16,
        maxContent: $gfJaN$restructure.uint16,
        usLowerOpticalPointSize: $gfJaN$restructure.uint16,
        usUpperOpticalPointSize: $gfJaN$restructure.uint16
    }
});
let $114ea85db469b435$var$versions = $114ea85db469b435$var$OS2.versions;
$114ea85db469b435$var$versions[3] = $114ea85db469b435$var$versions[4] = $114ea85db469b435$var$versions[2];
var $114ea85db469b435$export$2e2bcd8739ae039 = $114ea85db469b435$var$OS2;
var $f93b30299e1ea0f5$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.fixed32, {
    header: {
        italicAngle: $gfJaN$restructure.fixed32,
        underlinePosition: $gfJaN$restructure.int16,
        underlineThickness: $gfJaN$restructure.int16,
        isFixedPitch: $gfJaN$restructure.uint32,
        minMemType42: $gfJaN$restructure.uint32,
        maxMemType42: $gfJaN$restructure.uint32,
        minMemType1: $gfJaN$restructure.uint32,
        maxMemType1: $gfJaN$restructure.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
    },
    1: {},
    2: {
        numberOfGlyphs: $gfJaN$restructure.uint16,
        glyphNameIndex: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numberOfGlyphs"),
        names: new $gfJaN$restructure.Array(new $gfJaN$restructure.String($gfJaN$restructure.uint8))
    },
    2.5: {
        numberOfGlyphs: $gfJaN$restructure.uint16,
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "numberOfGlyphs")
    },
    3: {},
    4: {
        map: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, (t)=>t.parent.maxp.numGlyphs)
    }
});
var $8fb09b0f473d61a0$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    controlValues: new $gfJaN$restructure.Array($gfJaN$restructure.int16)
});
var // These instructions are known as the font program. The main use of this table
// is for the definition of functions that are used in many different glyph programs.
$873d79fea57d3161$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    instructions: new $gfJaN$restructure.Array($gfJaN$restructure.uint8)
});
let $83c4155666d50c37$var$loca = new $gfJaN$restructure.VersionedStruct("head.indexToLocFormat", {
    0: {
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint16)
    },
    1: {
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint32)
    }
});
$83c4155666d50c37$var$loca.process = function() {
    if (this.version === 0 && !this._processed) {
        for(let i = 0; i < this.offsets.length; i++)this.offsets[i] <<= 1;
        this._processed = true;
    }
};
$83c4155666d50c37$var$loca.preEncode = function() {
    if (this.version === 0 && this._processed !== false) {
        for(let i = 0; i < this.offsets.length; i++)this.offsets[i] >>>= 1;
        this._processed = false;
    }
};
var $83c4155666d50c37$export$2e2bcd8739ae039 = $83c4155666d50c37$var$loca;
var $b12598db7cdf7042$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    controlValueProgram: new $gfJaN$restructure.Array($gfJaN$restructure.uint8)
});
var $7707bdf21a3d89cc$export$2e2bcd8739ae039 = new $gfJaN$restructure.Array(new $gfJaN$restructure.Buffer);
class $9eaea3754914a290$export$2e2bcd8739ae039 {
    getCFFVersion(ctx) {
        while(ctx && !ctx.hdrSize)ctx = ctx.parent;
        return ctx ? ctx.version : -1;
    }
    decode(stream, parent) {
        let version = this.getCFFVersion(parent);
        let count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
        if (count === 0) return [];
        let offSize = stream.readUInt8();
        let offsetType;
        if (offSize === 1) offsetType = $gfJaN$restructure.uint8;
        else if (offSize === 2) offsetType = $gfJaN$restructure.uint16;
        else if (offSize === 3) offsetType = $gfJaN$restructure.uint24;
        else if (offSize === 4) offsetType = $gfJaN$restructure.uint32;
        else throw new Error(`Bad offset size in CFFIndex: ${offSize} ${stream.pos}`);
        let ret = [];
        let startPos = stream.pos + (count + 1) * offSize - 1;
        let start = offsetType.decode(stream);
        for(let i = 0; i < count; i++){
            let end = offsetType.decode(stream);
            if (this.type != null) {
                let pos = stream.pos;
                stream.pos = startPos + start;
                parent.length = end - start;
                ret.push(this.type.decode(stream, parent));
                stream.pos = pos;
            } else ret.push({
                offset: startPos + start,
                length: end - start
            });
            start = end;
        }
        stream.pos = startPos + start;
        return ret;
    }
    size(arr, parent) {
        let size = 2;
        if (arr.length === 0) return size;
        let type = this.type || new $gfJaN$restructure.Buffer;
        // find maximum offset to detminine offset type
        let offset = 1;
        for(let i = 0; i < arr.length; i++){
            let item = arr[i];
            offset += type.size(item, parent);
        }
        let offsetType;
        if (offset <= 0xff) offsetType = $gfJaN$restructure.uint8;
        else if (offset <= 0xffff) offsetType = $gfJaN$restructure.uint16;
        else if (offset <= 0xffffff) offsetType = $gfJaN$restructure.uint24;
        else if (offset <= 0xffffffff) offsetType = $gfJaN$restructure.uint32;
        else throw new Error("Bad offset in CFFIndex");
        size += 1 + offsetType.size() * (arr.length + 1);
        size += offset - 1;
        return size;
    }
    encode(stream, arr, parent) {
        stream.writeUInt16BE(arr.length);
        if (arr.length === 0) return;
        let type = this.type || new $gfJaN$restructure.Buffer;
        // find maximum offset to detminine offset type
        let sizes = [];
        let offset = 1;
        for (let item of arr){
            let s = type.size(item, parent);
            sizes.push(s);
            offset += s;
        }
        let offsetType;
        if (offset <= 0xff) offsetType = $gfJaN$restructure.uint8;
        else if (offset <= 0xffff) offsetType = $gfJaN$restructure.uint16;
        else if (offset <= 0xffffff) offsetType = $gfJaN$restructure.uint24;
        else if (offset <= 0xffffffff) offsetType = $gfJaN$restructure.uint32;
        else throw new Error("Bad offset in CFFIndex");
        // write offset size
        stream.writeUInt8(offsetType.size());
        // write elements
        offset = 1;
        offsetType.encode(stream, offset);
        for (let size of sizes){
            offset += size;
            offsetType.encode(stream, offset);
        }
        for (let item1 of arr)type.encode(stream, item1, parent);
        return;
    }
    constructor(type){
        this.type = type;
    }
}
const $f77b592c17132d70$var$FLOAT_EOF = 0xf;
const $f77b592c17132d70$var$FLOAT_LOOKUP = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    ".",
    "E",
    "E-",
    null,
    "-"
];
const $f77b592c17132d70$var$FLOAT_ENCODE_LOOKUP = {
    ".": 10,
    "E": 11,
    "E-": 12,
    "-": 14
};
class $f77b592c17132d70$export$2e2bcd8739ae039 {
    static decode(stream, value) {
        if (32 <= value && value <= 246) return value - 139;
        if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
        if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
        if (value === 28) return stream.readInt16BE();
        if (value === 29) return stream.readInt32BE();
        if (value === 30) {
            let str = "";
            while(true){
                let b = stream.readUInt8();
                let n1 = b >> 4;
                if (n1 === $f77b592c17132d70$var$FLOAT_EOF) break;
                str += $f77b592c17132d70$var$FLOAT_LOOKUP[n1];
                let n2 = b & 15;
                if (n2 === $f77b592c17132d70$var$FLOAT_EOF) break;
                str += $f77b592c17132d70$var$FLOAT_LOOKUP[n2];
            }
            return parseFloat(str);
        }
        return null;
    }
    static size(value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, set to 32768
        if (value.forceLarge) value = 32768;
        if ((value | 0) !== value) {
            let str = "" + value;
            return 1 + Math.ceil((str.length + 1) / 2);
        } else if (-107 <= value && value <= 107) return 1;
        else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
        else if (-32768 <= value && value <= 32767) return 3;
        else return 5;
    }
    static encode(stream, value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, save the old value and set to 32768
        let val = Number(value);
        if (value.forceLarge) {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        } else if ((val | 0) !== val) {
            stream.writeUInt8(30);
            let str = "" + val;
            for(let i = 0; i < str.length; i += 2){
                let c1 = str[i];
                let n1 = $f77b592c17132d70$var$FLOAT_ENCODE_LOOKUP[c1] || +c1;
                if (i === str.length - 1) var n2 = $f77b592c17132d70$var$FLOAT_EOF;
                else {
                    let c2 = str[i + 1];
                    var n2 = $f77b592c17132d70$var$FLOAT_ENCODE_LOOKUP[c2] || +c2;
                }
                stream.writeUInt8(n1 << 4 | n2 & 15);
            }
            if (n2 !== $f77b592c17132d70$var$FLOAT_EOF) return stream.writeUInt8($f77b592c17132d70$var$FLOAT_EOF << 4);
        } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
        else if (108 <= val && val <= 1131) {
            val -= 108;
            stream.writeUInt8((val >> 8) + 247);
            return stream.writeUInt8(val & 0xff);
        } else if (-1131 <= val && val <= -108) {
            val = -val - 108;
            stream.writeUInt8((val >> 8) + 251);
            return stream.writeUInt8(val & 0xff);
        } else if (-32768 <= val && val <= 32767) {
            stream.writeUInt8(28);
            return stream.writeInt16BE(val);
        } else {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        }
    }
}
class $efe622f40a9c35bd$export$2e2bcd8739ae039 {
    decodeOperands(type, stream, ret, operands) {
        if (Array.isArray(type)) return operands.map((op, i)=>this.decodeOperands(type[i], stream, ret, [
                op
            ]));
        else if (type.decode != null) return type.decode(stream, ret, operands);
        else switch(type){
            case "number":
            case "offset":
            case "sid":
                return operands[0];
            case "boolean":
                return !!operands[0];
            default:
                return operands;
        }
    }
    encodeOperands(type, stream, ctx, operands) {
        if (Array.isArray(type)) return operands.map((op, i)=>this.encodeOperands(type[i], stream, ctx, op)[0]);
        else if (type.encode != null) return type.encode(stream, operands, ctx);
        else if (typeof operands === "number") return [
            operands
        ];
        else if (typeof operands === "boolean") return [
            +operands
        ];
        else if (Array.isArray(operands)) return operands;
        else return [
            operands
        ];
    }
    decode(stream, parent) {
        let end = stream.pos + parent.length;
        let ret = {};
        let operands = [];
        // define hidden properties
        Object.defineProperties(ret, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            }
        });
        // fill in defaults
        for(let key in this.fields){
            let field = this.fields[key];
            ret[field[1]] = field[3];
        }
        while(stream.pos < end){
            let b = stream.readUInt8();
            if (b < 28) {
                if (b === 12) b = b << 8 | stream.readUInt8();
                let field = this.fields[b];
                if (!field) throw new Error(`Unknown operator ${b}`);
                let val = this.decodeOperands(field[2], stream, ret, operands);
                if (val != null) {
                    if (val instanceof $gfJaN$restructure.PropertyDescriptor) Object.defineProperty(ret, field[1], val);
                    else ret[field[1]] = val;
                }
                operands = [];
            } else operands.push($f77b592c17132d70$export$2e2bcd8739ae039.decode(stream, b));
        }
        return ret;
    }
    size(dict, parent, includePointers = true) {
        let ctx = {
            parent: parent,
            val: dict,
            pointerSize: 0,
            startOffset: parent.startOffset || 0
        };
        let len = 0;
        for(let k in this.fields){
            let field = this.fields[k];
            let val = dict[field[1]];
            if (val == null || $parcel$interopDefault($gfJaN$fastdeepequal)(val, field[3])) continue;
            let operands = this.encodeOperands(field[2], null, ctx, val);
            for (let op of operands)len += $f77b592c17132d70$export$2e2bcd8739ae039.size(op);
            let key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            len += key.length;
        }
        if (includePointers) len += ctx.pointerSize;
        return len;
    }
    encode(stream, dict, parent) {
        let ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: dict,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
        for (let field of this.ops){
            let val = dict[field[1]];
            if (val == null || $parcel$interopDefault($gfJaN$fastdeepequal)(val, field[3])) continue;
            let operands = this.encodeOperands(field[2], stream, ctx, val);
            for (let op of operands)$f77b592c17132d70$export$2e2bcd8739ae039.encode(stream, op);
            let key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            for (let op1 of key)stream.writeUInt8(op1);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            let ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
        return;
    }
    constructor(ops = []){
        this.ops = ops;
        this.fields = {};
        for (let field of ops){
            let key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
            this.fields[key] = field;
        }
    }
}
class $4aa1b0749c2770f8$export$2e2bcd8739ae039 extends $gfJaN$restructure.Pointer {
    decode(stream, parent, operands) {
        this.offsetType = {
            decode: ()=>operands[0]
        };
        return super.decode(stream, parent, operands);
    }
    encode(stream, value, ctx) {
        if (!stream) {
            // compute the size (so ctx.pointerSize is correct)
            this.offsetType = {
                size: ()=>0
            };
            this.size(value, ctx);
            return [
                new $4aa1b0749c2770f8$var$Ptr(0)
            ];
        }
        let ptr = null;
        this.offsetType = {
            encode: (stream, val)=>ptr = val
        };
        super.encode(stream, value, ctx);
        return [
            new $4aa1b0749c2770f8$var$Ptr(ptr)
        ];
    }
    constructor(type, options = {}){
        if (options.type == null) options.type = "global";
        super(null, type, options);
    }
}
class $4aa1b0749c2770f8$var$Ptr {
    valueOf() {
        return this.val;
    }
    constructor(val){
        this.val = val;
        this.forceLarge = true;
    }
}
class $15a0cbb3d09cf7ee$var$CFFBlendOp {
    static decode(stream, parent, operands) {
        let numBlends = operands.pop();
        // TODO: actually blend. For now just consume the deltas
        // since we don't use any of the values anyway.
        while(operands.length > numBlends)operands.pop();
    }
}
var $15a0cbb3d09cf7ee$export$2e2bcd8739ae039 = new $efe622f40a9c35bd$export$2e2bcd8739ae039([
    // key       name                    type                                          default
    [
        6,
        "BlueValues",
        "delta",
        null
    ],
    [
        7,
        "OtherBlues",
        "delta",
        null
    ],
    [
        8,
        "FamilyBlues",
        "delta",
        null
    ],
    [
        9,
        "FamilyOtherBlues",
        "delta",
        null
    ],
    [
        [
            12,
            9
        ],
        "BlueScale",
        "number",
        0.039625
    ],
    [
        [
            12,
            10
        ],
        "BlueShift",
        "number",
        7
    ],
    [
        [
            12,
            11
        ],
        "BlueFuzz",
        "number",
        1
    ],
    [
        10,
        "StdHW",
        "number",
        null
    ],
    [
        11,
        "StdVW",
        "number",
        null
    ],
    [
        [
            12,
            12
        ],
        "StemSnapH",
        "delta",
        null
    ],
    [
        [
            12,
            13
        ],
        "StemSnapV",
        "delta",
        null
    ],
    [
        [
            12,
            14
        ],
        "ForceBold",
        "boolean",
        false
    ],
    [
        [
            12,
            17
        ],
        "LanguageGroup",
        "number",
        0
    ],
    [
        [
            12,
            18
        ],
        "ExpansionFactor",
        "number",
        0.06
    ],
    [
        [
            12,
            19
        ],
        "initialRandomSeed",
        "number",
        0
    ],
    [
        20,
        "defaultWidthX",
        "number",
        0
    ],
    [
        21,
        "nominalWidthX",
        "number",
        0
    ],
    [
        22,
        "vsindex",
        "number",
        0
    ],
    [
        23,
        "blend",
        $15a0cbb3d09cf7ee$var$CFFBlendOp,
        null
    ],
    [
        19,
        "Subrs",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039, {
            type: "local"
        }),
        null
    ]
]);
var // not edit. Length should be 391.
$860d3574d7fa3a51$export$2e2bcd8739ae039 = [
    ".notdef",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "questiondown",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "AE",
    "ordfeminine",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "ae",
    "dotlessi",
    "lslash",
    "oslash",
    "oe",
    "germandbls",
    "onesuperior",
    "logicalnot",
    "mu",
    "trademark",
    "Eth",
    "onehalf",
    "plusminus",
    "Thorn",
    "onequarter",
    "divide",
    "brokenbar",
    "degree",
    "thorn",
    "threequarters",
    "twosuperior",
    "registered",
    "minus",
    "eth",
    "multiply",
    "threesuperior",
    "copyright",
    "Aacute",
    "Acircumflex",
    "Adieresis",
    "Agrave",
    "Aring",
    "Atilde",
    "Ccedilla",
    "Eacute",
    "Ecircumflex",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Ntilde",
    "Oacute",
    "Ocircumflex",
    "Odieresis",
    "Ograve",
    "Otilde",
    "Scaron",
    "Uacute",
    "Ucircumflex",
    "Udieresis",
    "Ugrave",
    "Yacute",
    "Ydieresis",
    "Zcaron",
    "aacute",
    "acircumflex",
    "adieresis",
    "agrave",
    "aring",
    "atilde",
    "ccedilla",
    "eacute",
    "ecircumflex",
    "edieresis",
    "egrave",
    "iacute",
    "icircumflex",
    "idieresis",
    "igrave",
    "ntilde",
    "oacute",
    "ocircumflex",
    "odieresis",
    "ograve",
    "otilde",
    "scaron",
    "uacute",
    "ucircumflex",
    "udieresis",
    "ugrave",
    "yacute",
    "ydieresis",
    "zcaron",
    "exclamsmall",
    "Hungarumlautsmall",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "Dotaccentsmall",
    "Macronsmall",
    "figuredash",
    "hypheninferior",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall",
    "001.000",
    "001.001",
    "001.002",
    "001.003",
    "Black",
    "Bold",
    "Book",
    "Light",
    "Medium",
    "Regular",
    "Roman",
    "Semibold"
];
let $c4ffe47cba1d7f36$export$dee0027060fa13bd = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "",
    "questiondown",
    "",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "",
    "ring",
    "cedilla",
    "",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "AE",
    "",
    "ordfeminine",
    "",
    "",
    "",
    "",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "",
    "",
    "",
    "",
    "",
    "ae",
    "",
    "",
    "",
    "dotlessi",
    "",
    "",
    "lslash",
    "oslash",
    "oe",
    "germandbls"
];
let $c4ffe47cba1d7f36$export$4f58f497e14a53c3 = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "space",
    "exclamsmall",
    "Hungarumlautsmall",
    "",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "comma",
    "hyphen",
    "period",
    "fraction",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "colon",
    "semicolon",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "",
    "",
    "isuperior",
    "",
    "",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "",
    "",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "",
    "ff",
    "fi",
    "fl",
    "ffi",
    "ffl",
    "parenleftinferior",
    "",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "",
    "",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "",
    "Dotaccentsmall",
    "",
    "",
    "Macronsmall",
    "",
    "",
    "figuredash",
    "hypheninferior",
    "",
    "",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "",
    "",
    "",
    "onequarter",
    "onehalf",
    "threequarters",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "",
    "",
    "zerosuperior",
    "onesuperior",
    "twosuperior",
    "threesuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall"
];
let $1e7c7c16984e4427$export$c33b50336c234f16 = [
    ".notdef",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "questiondown",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "AE",
    "ordfeminine",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "ae",
    "dotlessi",
    "lslash",
    "oslash",
    "oe",
    "germandbls",
    "onesuperior",
    "logicalnot",
    "mu",
    "trademark",
    "Eth",
    "onehalf",
    "plusminus",
    "Thorn",
    "onequarter",
    "divide",
    "brokenbar",
    "degree",
    "thorn",
    "threequarters",
    "twosuperior",
    "registered",
    "minus",
    "eth",
    "multiply",
    "threesuperior",
    "copyright",
    "Aacute",
    "Acircumflex",
    "Adieresis",
    "Agrave",
    "Aring",
    "Atilde",
    "Ccedilla",
    "Eacute",
    "Ecircumflex",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Ntilde",
    "Oacute",
    "Ocircumflex",
    "Odieresis",
    "Ograve",
    "Otilde",
    "Scaron",
    "Uacute",
    "Ucircumflex",
    "Udieresis",
    "Ugrave",
    "Yacute",
    "Ydieresis",
    "Zcaron",
    "aacute",
    "acircumflex",
    "adieresis",
    "agrave",
    "aring",
    "atilde",
    "ccedilla",
    "eacute",
    "ecircumflex",
    "edieresis",
    "egrave",
    "iacute",
    "icircumflex",
    "idieresis",
    "igrave",
    "ntilde",
    "oacute",
    "ocircumflex",
    "odieresis",
    "ograve",
    "otilde",
    "scaron",
    "uacute",
    "ucircumflex",
    "udieresis",
    "ugrave",
    "yacute",
    "ydieresis",
    "zcaron"
];
let $1e7c7c16984e4427$export$3ed0f9e1fee8d489 = [
    ".notdef",
    "space",
    "exclamsmall",
    "Hungarumlautsmall",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "comma",
    "hyphen",
    "period",
    "fraction",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "colon",
    "semicolon",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "fi",
    "fl",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "Dotaccentsmall",
    "Macronsmall",
    "figuredash",
    "hypheninferior",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "onequarter",
    "onehalf",
    "threequarters",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "onesuperior",
    "twosuperior",
    "threesuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall"
];
let $1e7c7c16984e4427$export$dc28be11139d4120 = [
    ".notdef",
    "space",
    "dollaroldstyle",
    "dollarsuperior",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "comma",
    "hyphen",
    "period",
    "fraction",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "colon",
    "semicolon",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "fi",
    "fl",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "hyphensuperior",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "centoldstyle",
    "figuredash",
    "hypheninferior",
    "onequarter",
    "onehalf",
    "threequarters",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "onesuperior",
    "twosuperior",
    "threesuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior"
];
//########################
// Scripts and Languages #
//########################
let $b6dd765146ad212a$var$LangSysTable = new $gfJaN$restructure.Struct({
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    reqFeatureIndex: $gfJaN$restructure.uint16,
    featureCount: $gfJaN$restructure.uint16,
    featureIndexes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "featureCount")
});
let $b6dd765146ad212a$var$LangSysRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    langSys: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$LangSysTable, {
        type: "parent"
    })
});
let $b6dd765146ad212a$var$Script = new $gfJaN$restructure.Struct({
    defaultLangSys: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$LangSysTable),
    count: $gfJaN$restructure.uint16,
    langSysRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LangSysRecord, "count")
});
let $b6dd765146ad212a$var$ScriptRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    script: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$Script, {
        type: "parent"
    })
});
let $b6dd765146ad212a$export$3e15fc05ce864229 = new $gfJaN$restructure.Array($b6dd765146ad212a$var$ScriptRecord, $gfJaN$restructure.uint16);
//#######################
// Features and Lookups #
//#######################
let $b6dd765146ad212a$var$FeatureParams = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    nameID: $gfJaN$restructure.uint16
});
let $b6dd765146ad212a$export$6e91cf7616333d5 = new $gfJaN$restructure.Struct({
    featureParams: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$FeatureParams),
    lookupCount: $gfJaN$restructure.uint16,
    lookupListIndexes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "lookupCount")
});
let $b6dd765146ad212a$var$FeatureRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    feature: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$6e91cf7616333d5, {
        type: "parent"
    })
});
let $b6dd765146ad212a$export$aa18130def4b6cb4 = new $gfJaN$restructure.Array($b6dd765146ad212a$var$FeatureRecord, $gfJaN$restructure.uint16);
let $b6dd765146ad212a$var$LookupFlags = new $gfJaN$restructure.Struct({
    markAttachmentType: $gfJaN$restructure.uint8,
    flags: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
        "rightToLeft",
        "ignoreBaseGlyphs",
        "ignoreLigatures",
        "ignoreMarks",
        "useMarkFilteringSet"
    ])
});
function $b6dd765146ad212a$export$df0008c6ff2da22a(SubTable) {
    let Lookup = new $gfJaN$restructure.Struct({
        lookupType: $gfJaN$restructure.uint16,
        flags: $b6dd765146ad212a$var$LookupFlags,
        subTableCount: $gfJaN$restructure.uint16,
        subTables: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, SubTable), "subTableCount"),
        markFilteringSet: new $gfJaN$restructure.Optional($gfJaN$restructure.uint16, (t)=>t.flags.flags.useMarkFilteringSet)
    });
    return new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, Lookup), $gfJaN$restructure.uint16);
}
//#################
// Coverage Table #
//#################
let $b6dd765146ad212a$var$RangeRecord = new $gfJaN$restructure.Struct({
    start: $gfJaN$restructure.uint16,
    end: $gfJaN$restructure.uint16,
    startCoverageIndex: $gfJaN$restructure.uint16
});
let $b6dd765146ad212a$export$17608c3f81a6111 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        glyphCount: $gfJaN$restructure.uint16,
        glyphs: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "glyphCount")
    },
    2: {
        rangeCount: $gfJaN$restructure.uint16,
        rangeRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$RangeRecord, "rangeCount")
    }
});
//#########################
// Class Definition Table #
//#########################
let $b6dd765146ad212a$var$ClassRangeRecord = new $gfJaN$restructure.Struct({
    start: $gfJaN$restructure.uint16,
    end: $gfJaN$restructure.uint16,
    class: $gfJaN$restructure.uint16
});
let $b6dd765146ad212a$export$843d551fbbafef71 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        startGlyph: $gfJaN$restructure.uint16,
        glyphCount: $gfJaN$restructure.uint16,
        classValueArray: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "glyphCount")
    },
    2: {
        classRangeCount: $gfJaN$restructure.uint16,
        classRangeRecord: new $gfJaN$restructure.Array($b6dd765146ad212a$var$ClassRangeRecord, "classRangeCount")
    }
});
let $b6dd765146ad212a$export$8215d14a63d9fb10 = new $gfJaN$restructure.Struct({
    a: $gfJaN$restructure.uint16,
    b: $gfJaN$restructure.uint16,
    deltaFormat: $gfJaN$restructure.uint16
});
//#############################################
// Contextual Substitution/Positioning Tables #
//#############################################
let $b6dd765146ad212a$var$LookupRecord = new $gfJaN$restructure.Struct({
    sequenceIndex: $gfJaN$restructure.uint16,
    lookupListIndex: $gfJaN$restructure.uint16
});
let $b6dd765146ad212a$var$Rule = new $gfJaN$restructure.Struct({
    glyphCount: $gfJaN$restructure.uint16,
    lookupCount: $gfJaN$restructure.uint16,
    input: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.glyphCount - 1),
    lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
});
let $b6dd765146ad212a$var$RuleSet = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$Rule), $gfJaN$restructure.uint16);
let $b6dd765146ad212a$var$ClassRule = new $gfJaN$restructure.Struct({
    glyphCount: $gfJaN$restructure.uint16,
    lookupCount: $gfJaN$restructure.uint16,
    classes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.glyphCount - 1),
    lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
});
let $b6dd765146ad212a$var$ClassSet = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ClassRule), $gfJaN$restructure.uint16);
let $b6dd765146ad212a$export$841858b892ce1f4c = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        ruleSetCount: $gfJaN$restructure.uint16,
        ruleSets: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$RuleSet), "ruleSetCount")
    },
    2: {
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        classDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        classSetCnt: $gfJaN$restructure.uint16,
        classSet: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ClassSet), "classSetCnt")
    },
    3: {
        glyphCount: $gfJaN$restructure.uint16,
        lookupCount: $gfJaN$restructure.uint16,
        coverages: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "glyphCount"),
        lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
    }
});
//######################################################
// Chaining Contextual Substitution/Positioning Tables #
//######################################################
let $b6dd765146ad212a$var$ChainRule = new $gfJaN$restructure.Struct({
    backtrackGlyphCount: $gfJaN$restructure.uint16,
    backtrack: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "backtrackGlyphCount"),
    inputGlyphCount: $gfJaN$restructure.uint16,
    input: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.inputGlyphCount - 1),
    lookaheadGlyphCount: $gfJaN$restructure.uint16,
    lookahead: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "lookaheadGlyphCount"),
    lookupCount: $gfJaN$restructure.uint16,
    lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
});
let $b6dd765146ad212a$var$ChainRuleSet = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ChainRule), $gfJaN$restructure.uint16);
let $b6dd765146ad212a$export$5e6d09e6861162f6 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        chainCount: $gfJaN$restructure.uint16,
        chainRuleSets: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ChainRuleSet), "chainCount")
    },
    2: {
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        backtrackClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        inputClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        lookaheadClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        chainCount: $gfJaN$restructure.uint16,
        chainClassSet: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$var$ChainRuleSet), "chainCount")
    },
    3: {
        backtrackGlyphCount: $gfJaN$restructure.uint16,
        backtrackCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "backtrackGlyphCount"),
        inputGlyphCount: $gfJaN$restructure.uint16,
        inputCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "inputGlyphCount"),
        lookaheadGlyphCount: $gfJaN$restructure.uint16,
        lookaheadCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "lookaheadGlyphCount"),
        lookupCount: $gfJaN$restructure.uint16,
        lookupRecords: new $gfJaN$restructure.Array($b6dd765146ad212a$var$LookupRecord, "lookupCount")
    }
});
/*******************
 * Variation Store *
 *******************/ let $2e4adcda047b3383$var$F2DOT14 = new $gfJaN$restructure.Fixed(16, "BE", 14);
let $2e4adcda047b3383$var$RegionAxisCoordinates = new $gfJaN$restructure.Struct({
    startCoord: $2e4adcda047b3383$var$F2DOT14,
    peakCoord: $2e4adcda047b3383$var$F2DOT14,
    endCoord: $2e4adcda047b3383$var$F2DOT14
});
let $2e4adcda047b3383$var$VariationRegionList = new $gfJaN$restructure.Struct({
    axisCount: $gfJaN$restructure.uint16,
    regionCount: $gfJaN$restructure.uint16,
    variationRegions: new $gfJaN$restructure.Array(new $gfJaN$restructure.Array($2e4adcda047b3383$var$RegionAxisCoordinates, "axisCount"), "regionCount")
});
let $2e4adcda047b3383$var$DeltaSet = new $gfJaN$restructure.Struct({
    shortDeltas: new $gfJaN$restructure.Array($gfJaN$restructure.int16, (t)=>t.parent.shortDeltaCount),
    regionDeltas: new $gfJaN$restructure.Array($gfJaN$restructure.int8, (t)=>t.parent.regionIndexCount - t.parent.shortDeltaCount),
    deltas: (t)=>t.shortDeltas.concat(t.regionDeltas)
});
let $2e4adcda047b3383$var$ItemVariationData = new $gfJaN$restructure.Struct({
    itemCount: $gfJaN$restructure.uint16,
    shortDeltaCount: $gfJaN$restructure.uint16,
    regionIndexCount: $gfJaN$restructure.uint16,
    regionIndexes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "regionIndexCount"),
    deltaSets: new $gfJaN$restructure.Array($2e4adcda047b3383$var$DeltaSet, "itemCount")
});
let $2e4adcda047b3383$export$fe1b122a2710f241 = new $gfJaN$restructure.Struct({
    format: $gfJaN$restructure.uint16,
    variationRegionList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$VariationRegionList),
    variationDataCount: $gfJaN$restructure.uint16,
    itemVariationData: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$ItemVariationData), "variationDataCount")
});
/**********************
 * Feature Variations *
 **********************/ let $2e4adcda047b3383$var$ConditionTable = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        axisIndex: $gfJaN$restructure.uint16,
        axisIndex: $gfJaN$restructure.uint16,
        filterRangeMinValue: $2e4adcda047b3383$var$F2DOT14,
        filterRangeMaxValue: $2e4adcda047b3383$var$F2DOT14
    }
});
let $2e4adcda047b3383$var$ConditionSet = new $gfJaN$restructure.Struct({
    conditionCount: $gfJaN$restructure.uint16,
    conditionTable: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$ConditionTable), "conditionCount")
});
let $2e4adcda047b3383$var$FeatureTableSubstitutionRecord = new $gfJaN$restructure.Struct({
    featureIndex: $gfJaN$restructure.uint16,
    alternateFeatureTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $b6dd765146ad212a$export$6e91cf7616333d5, {
        type: "parent"
    })
});
let $2e4adcda047b3383$var$FeatureTableSubstitution = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    substitutionCount: $gfJaN$restructure.uint16,
    substitutions: new $gfJaN$restructure.Array($2e4adcda047b3383$var$FeatureTableSubstitutionRecord, "substitutionCount")
});
let $2e4adcda047b3383$var$FeatureVariationRecord = new $gfJaN$restructure.Struct({
    conditionSet: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$ConditionSet, {
        type: "parent"
    }),
    featureTableSubstitution: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$var$FeatureTableSubstitution, {
        type: "parent"
    })
});
let $2e4adcda047b3383$export$441b70b7971dd419 = new $gfJaN$restructure.Struct({
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    featureVariationRecordCount: $gfJaN$restructure.uint32,
    featureVariationRecords: new $gfJaN$restructure.Array($2e4adcda047b3383$var$FeatureVariationRecord, "featureVariationRecordCount")
});
// Checks if an operand is an index of a predefined value,
// otherwise delegates to the provided type.
class $5b547cf9e5da519b$var$PredefinedOp {
    decode(stream, parent, operands) {
        if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
        return this.type.decode(stream, parent, operands);
    }
    size(value, ctx) {
        return this.type.size(value, ctx);
    }
    encode(stream, value, ctx) {
        let index = this.predefinedOps.indexOf(value);
        if (index !== -1) return index;
        return this.type.encode(stream, value, ctx);
    }
    constructor(predefinedOps, type){
        this.predefinedOps = predefinedOps;
        this.type = type;
    }
}
class $5b547cf9e5da519b$var$CFFEncodingVersion extends $gfJaN$restructure.Number {
    decode(stream) {
        return $gfJaN$restructure.uint8.decode(stream) & 0x7f;
    }
    constructor(){
        super("UInt8");
    }
}
let $5b547cf9e5da519b$var$Range1 = new $gfJaN$restructure.Struct({
    first: $gfJaN$restructure.uint16,
    nLeft: $gfJaN$restructure.uint8
});
let $5b547cf9e5da519b$var$Range2 = new $gfJaN$restructure.Struct({
    first: $gfJaN$restructure.uint16,
    nLeft: $gfJaN$restructure.uint16
});
let $5b547cf9e5da519b$var$CFFCustomEncoding = new $gfJaN$restructure.VersionedStruct(new $5b547cf9e5da519b$var$CFFEncodingVersion(), {
    0: {
        nCodes: $gfJaN$restructure.uint8,
        codes: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "nCodes")
    },
    1: {
        nRanges: $gfJaN$restructure.uint8,
        ranges: new $gfJaN$restructure.Array($5b547cf9e5da519b$var$Range1, "nRanges")
    }
});
let $5b547cf9e5da519b$var$CFFEncoding = new $5b547cf9e5da519b$var$PredefinedOp([
    $c4ffe47cba1d7f36$export$dee0027060fa13bd,
    $c4ffe47cba1d7f36$export$4f58f497e14a53c3
], new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$CFFCustomEncoding, {
    lazy: true
}));
// Decodes an array of ranges until the total
// length is equal to the provided length.
class $5b547cf9e5da519b$var$RangeArray extends $gfJaN$restructure.Array {
    decode(stream, parent) {
        let length = (0, $gfJaN$restructure.resolveLength)(this.length, stream, parent);
        let count = 0;
        let res = [];
        while(count < length){
            let range = this.type.decode(stream, parent);
            range.offset = count;
            count += range.nLeft + 1;
            res.push(range);
        }
        return res;
    }
}
let $5b547cf9e5da519b$var$CFFCustomCharset = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint8, {
    0: {
        glyphs: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.parent.CharStrings.length - 1)
    },
    1: {
        ranges: new $5b547cf9e5da519b$var$RangeArray($5b547cf9e5da519b$var$Range1, (t)=>t.parent.CharStrings.length - 1)
    },
    2: {
        ranges: new $5b547cf9e5da519b$var$RangeArray($5b547cf9e5da519b$var$Range2, (t)=>t.parent.CharStrings.length - 1)
    }
});
let $5b547cf9e5da519b$var$CFFCharset = new $5b547cf9e5da519b$var$PredefinedOp([
    $1e7c7c16984e4427$export$c33b50336c234f16,
    $1e7c7c16984e4427$export$3ed0f9e1fee8d489,
    $1e7c7c16984e4427$export$dc28be11139d4120
], new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$CFFCustomCharset, {
    lazy: true
}));
let $5b547cf9e5da519b$var$FDRange3 = new $gfJaN$restructure.Struct({
    first: $gfJaN$restructure.uint16,
    fd: $gfJaN$restructure.uint8
});
let $5b547cf9e5da519b$var$FDRange4 = new $gfJaN$restructure.Struct({
    first: $gfJaN$restructure.uint32,
    fd: $gfJaN$restructure.uint16
});
let $5b547cf9e5da519b$var$FDSelect = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint8, {
    0: {
        fds: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, (t)=>t.parent.CharStrings.length)
    },
    3: {
        nRanges: $gfJaN$restructure.uint16,
        ranges: new $gfJaN$restructure.Array($5b547cf9e5da519b$var$FDRange3, "nRanges"),
        sentinel: $gfJaN$restructure.uint16
    },
    4: {
        nRanges: $gfJaN$restructure.uint32,
        ranges: new $gfJaN$restructure.Array($5b547cf9e5da519b$var$FDRange4, "nRanges"),
        sentinel: $gfJaN$restructure.uint32
    }
});
let $5b547cf9e5da519b$var$ptr = new $4aa1b0749c2770f8$export$2e2bcd8739ae039($15a0cbb3d09cf7ee$export$2e2bcd8739ae039);
class $5b547cf9e5da519b$var$CFFPrivateOp {
    decode(stream, parent, operands) {
        parent.length = operands[0];
        return $5b547cf9e5da519b$var$ptr.decode(stream, parent, [
            operands[1]
        ]);
    }
    size(dict, ctx) {
        return [
            $15a0cbb3d09cf7ee$export$2e2bcd8739ae039.size(dict, ctx, false),
            $5b547cf9e5da519b$var$ptr.size(dict, ctx)[0]
        ];
    }
    encode(stream, dict, ctx) {
        return [
            $15a0cbb3d09cf7ee$export$2e2bcd8739ae039.size(dict, ctx, false),
            $5b547cf9e5da519b$var$ptr.encode(stream, dict, ctx)[0]
        ];
    }
}
let $5b547cf9e5da519b$var$FontDict = new $efe622f40a9c35bd$export$2e2bcd8739ae039([
    // key       name                   type(s)                                 default
    [
        18,
        "Private",
        new $5b547cf9e5da519b$var$CFFPrivateOp,
        null
    ],
    [
        [
            12,
            38
        ],
        "FontName",
        "sid",
        null
    ],
    [
        [
            12,
            7
        ],
        "FontMatrix",
        "array",
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        [
            12,
            5
        ],
        "PaintType",
        "number",
        0
    ]
]);
let $5b547cf9e5da519b$var$CFFTopDict = new $efe622f40a9c35bd$export$2e2bcd8739ae039([
    // key       name                   type(s)                                 default
    [
        [
            12,
            30
        ],
        "ROS",
        [
            "sid",
            "sid",
            "number"
        ],
        null
    ],
    [
        0,
        "version",
        "sid",
        null
    ],
    [
        1,
        "Notice",
        "sid",
        null
    ],
    [
        [
            12,
            0
        ],
        "Copyright",
        "sid",
        null
    ],
    [
        2,
        "FullName",
        "sid",
        null
    ],
    [
        3,
        "FamilyName",
        "sid",
        null
    ],
    [
        4,
        "Weight",
        "sid",
        null
    ],
    [
        [
            12,
            1
        ],
        "isFixedPitch",
        "boolean",
        false
    ],
    [
        [
            12,
            2
        ],
        "ItalicAngle",
        "number",
        0
    ],
    [
        [
            12,
            3
        ],
        "UnderlinePosition",
        "number",
        -100
    ],
    [
        [
            12,
            4
        ],
        "UnderlineThickness",
        "number",
        50
    ],
    [
        [
            12,
            5
        ],
        "PaintType",
        "number",
        0
    ],
    [
        [
            12,
            6
        ],
        "CharstringType",
        "number",
        2
    ],
    [
        [
            12,
            7
        ],
        "FontMatrix",
        "array",
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        13,
        "UniqueID",
        "number",
        null
    ],
    [
        5,
        "FontBBox",
        "array",
        [
            0,
            0,
            0,
            0
        ]
    ],
    [
        [
            12,
            8
        ],
        "StrokeWidth",
        "number",
        0
    ],
    [
        14,
        "XUID",
        "array",
        null
    ],
    [
        15,
        "charset",
        $5b547cf9e5da519b$var$CFFCharset,
        $1e7c7c16984e4427$export$c33b50336c234f16
    ],
    [
        16,
        "Encoding",
        $5b547cf9e5da519b$var$CFFEncoding,
        $c4ffe47cba1d7f36$export$dee0027060fa13bd
    ],
    [
        17,
        "CharStrings",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039),
        null
    ],
    [
        18,
        "Private",
        new $5b547cf9e5da519b$var$CFFPrivateOp,
        null
    ],
    [
        [
            12,
            20
        ],
        "SyntheticBase",
        "number",
        null
    ],
    [
        [
            12,
            21
        ],
        "PostScript",
        "sid",
        null
    ],
    [
        [
            12,
            22
        ],
        "BaseFontName",
        "sid",
        null
    ],
    [
        [
            12,
            23
        ],
        "BaseFontBlend",
        "delta",
        null
    ],
    // CID font specific
    [
        [
            12,
            31
        ],
        "CIDFontVersion",
        "number",
        0
    ],
    [
        [
            12,
            32
        ],
        "CIDFontRevision",
        "number",
        0
    ],
    [
        [
            12,
            33
        ],
        "CIDFontType",
        "number",
        0
    ],
    [
        [
            12,
            34
        ],
        "CIDCount",
        "number",
        8720
    ],
    [
        [
            12,
            35
        ],
        "UIDBase",
        "number",
        null
    ],
    [
        [
            12,
            37
        ],
        "FDSelect",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        "FDArray",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039($5b547cf9e5da519b$var$FontDict)),
        null
    ],
    [
        [
            12,
            38
        ],
        "FontName",
        "sid",
        null
    ]
]);
let $5b547cf9e5da519b$var$VariationStore = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint16,
    itemVariationStore: $2e4adcda047b3383$export$fe1b122a2710f241
});
let $5b547cf9e5da519b$var$CFF2TopDict = new $efe622f40a9c35bd$export$2e2bcd8739ae039([
    [
        [
            12,
            7
        ],
        "FontMatrix",
        "array",
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        17,
        "CharStrings",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039),
        null
    ],
    [
        [
            12,
            37
        ],
        "FDSelect",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        "FDArray",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039(new $9eaea3754914a290$export$2e2bcd8739ae039($5b547cf9e5da519b$var$FontDict)),
        null
    ],
    [
        24,
        "vstore",
        new $4aa1b0749c2770f8$export$2e2bcd8739ae039($5b547cf9e5da519b$var$VariationStore),
        null
    ],
    [
        25,
        "maxstack",
        "number",
        193
    ]
]);
let $5b547cf9e5da519b$var$CFFTop = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.fixed16, {
    1: {
        hdrSize: $gfJaN$restructure.uint8,
        offSize: $gfJaN$restructure.uint8,
        nameIndex: new $9eaea3754914a290$export$2e2bcd8739ae039(new $gfJaN$restructure.String("length")),
        topDictIndex: new $9eaea3754914a290$export$2e2bcd8739ae039($5b547cf9e5da519b$var$CFFTopDict),
        stringIndex: new $9eaea3754914a290$export$2e2bcd8739ae039(new $gfJaN$restructure.String("length")),
        globalSubrIndex: new $9eaea3754914a290$export$2e2bcd8739ae039
    },
    2: {
        hdrSize: $gfJaN$restructure.uint8,
        length: $gfJaN$restructure.uint16,
        topDict: $5b547cf9e5da519b$var$CFF2TopDict,
        globalSubrIndex: new $9eaea3754914a290$export$2e2bcd8739ae039
    }
});
var $5b547cf9e5da519b$export$2e2bcd8739ae039 = $5b547cf9e5da519b$var$CFFTop;
class $f717432b360040c7$var$CFFFont {
    static decode(stream) {
        return new $f717432b360040c7$var$CFFFont(stream);
    }
    decode() {
        let start = this.stream.pos;
        let top = $5b547cf9e5da519b$export$2e2bcd8739ae039.decode(this.stream);
        for(let key in top){
            let val = top[key];
            this[key] = val;
        }
        if (this.version < 2) {
            if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
            this.topDict = this.topDictIndex[0];
        }
        this.isCIDFont = this.topDict.ROS != null;
        return this;
    }
    string(sid) {
        if (this.version >= 2) return null;
        if (sid < $860d3574d7fa3a51$export$2e2bcd8739ae039.length) return $860d3574d7fa3a51$export$2e2bcd8739ae039[sid];
        return this.stringIndex[sid - $860d3574d7fa3a51$export$2e2bcd8739ae039.length];
    }
    get postscriptName() {
        if (this.version < 2) return this.nameIndex[0];
        return null;
    }
    get fullName() {
        return this.string(this.topDict.FullName);
    }
    get familyName() {
        return this.string(this.topDict.FamilyName);
    }
    getCharString(glyph) {
        this.stream.pos = this.topDict.CharStrings[glyph].offset;
        return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
    }
    getGlyphName(gid) {
        // CFF2 glyph names are in the post table.
        if (this.version >= 2) return null;
        // CID-keyed fonts don't have glyph names
        if (this.isCIDFont) return null;
        let { charset: charset } = this.topDict;
        if (Array.isArray(charset)) return charset[gid];
        if (gid === 0) return ".notdef";
        gid -= 1;
        switch(charset.version){
            case 0:
                return this.string(charset.glyphs[gid]);
            case 1:
            case 2:
                for(let i = 0; i < charset.ranges.length; i++){
                    let range = charset.ranges[i];
                    if (range.offset <= gid && gid <= range.offset + range.nLeft) return this.string(range.first + (gid - range.offset));
                }
                break;
        }
        return null;
    }
    fdForGlyph(gid) {
        if (!this.topDict.FDSelect) return null;
        switch(this.topDict.FDSelect.version){
            case 0:
                return this.topDict.FDSelect.fds[gid];
            case 3:
            case 4:
                let { ranges: ranges } = this.topDict.FDSelect;
                let low = 0;
                let high = ranges.length - 1;
                while(low <= high){
                    let mid = low + high >> 1;
                    if (gid < ranges[mid].first) high = mid - 1;
                    else if (mid < high && gid >= ranges[mid + 1].first) low = mid + 1;
                    else return ranges[mid].fd;
                }
            default:
                throw new Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
        }
    }
    privateDictForGlyph(gid) {
        if (this.topDict.FDSelect) {
            let fd = this.fdForGlyph(gid);
            if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
            return null;
        }
        if (this.version < 2) return this.topDict.Private;
        return this.topDict.FDArray[0].Private;
    }
    constructor(stream){
        this.stream = stream;
        this.decode();
    }
}
var $f717432b360040c7$export$2e2bcd8739ae039 = $f717432b360040c7$var$CFFFont;
let $8cb7ae73ed7aa7d8$var$VerticalOrigin = new $gfJaN$restructure.Struct({
    glyphIndex: $gfJaN$restructure.uint16,
    vertOriginY: $gfJaN$restructure.int16
});
var $8cb7ae73ed7aa7d8$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    defaultVertOriginY: $gfJaN$restructure.int16,
    numVertOriginYMetrics: $gfJaN$restructure.uint16,
    metrics: new $gfJaN$restructure.Array($8cb7ae73ed7aa7d8$var$VerticalOrigin, "numVertOriginYMetrics")
});
let $20e0c7bbecb76d75$export$16b227cb15d716a0 = new $gfJaN$restructure.Struct({
    height: $gfJaN$restructure.uint8,
    width: $gfJaN$restructure.uint8,
    horiBearingX: $gfJaN$restructure.int8,
    horiBearingY: $gfJaN$restructure.int8,
    horiAdvance: $gfJaN$restructure.uint8,
    vertBearingX: $gfJaN$restructure.int8,
    vertBearingY: $gfJaN$restructure.int8,
    vertAdvance: $gfJaN$restructure.uint8
});
let $20e0c7bbecb76d75$export$62c53e75f69bfe12 = new $gfJaN$restructure.Struct({
    height: $gfJaN$restructure.uint8,
    width: $gfJaN$restructure.uint8,
    bearingX: $gfJaN$restructure.int8,
    bearingY: $gfJaN$restructure.int8,
    advance: $gfJaN$restructure.uint8
});
let $20e0c7bbecb76d75$var$EBDTComponent = new $gfJaN$restructure.Struct({
    glyph: $gfJaN$restructure.uint16,
    xOffset: $gfJaN$restructure.int8,
    yOffset: $gfJaN$restructure.int8
});
class $20e0c7bbecb76d75$var$ByteAligned {
}
class $20e0c7bbecb76d75$var$BitAligned {
}
let $20e0c7bbecb76d75$export$f1f5ddeb20d14f = new $gfJaN$restructure.VersionedStruct("version", {
    1: {
        metrics: $20e0c7bbecb76d75$export$62c53e75f69bfe12,
        data: $20e0c7bbecb76d75$var$ByteAligned
    },
    2: {
        metrics: $20e0c7bbecb76d75$export$62c53e75f69bfe12,
        data: $20e0c7bbecb76d75$var$BitAligned
    },
    // format 3 is deprecated
    // format 4 is not supported by Microsoft
    5: {
        data: $20e0c7bbecb76d75$var$BitAligned
    },
    6: {
        metrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        data: $20e0c7bbecb76d75$var$ByteAligned
    },
    7: {
        metrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        data: $20e0c7bbecb76d75$var$BitAligned
    },
    8: {
        metrics: $20e0c7bbecb76d75$export$62c53e75f69bfe12,
        pad: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8),
        numComponents: $gfJaN$restructure.uint16,
        components: new $gfJaN$restructure.Array($20e0c7bbecb76d75$var$EBDTComponent, "numComponents")
    },
    9: {
        metrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        pad: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8),
        numComponents: $gfJaN$restructure.uint16,
        components: new $gfJaN$restructure.Array($20e0c7bbecb76d75$var$EBDTComponent, "numComponents")
    },
    17: {
        metrics: $20e0c7bbecb76d75$export$62c53e75f69bfe12,
        dataLen: $gfJaN$restructure.uint32,
        data: new $gfJaN$restructure.Buffer("dataLen")
    },
    18: {
        metrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        dataLen: $gfJaN$restructure.uint32,
        data: new $gfJaN$restructure.Buffer("dataLen")
    },
    19: {
        dataLen: $gfJaN$restructure.uint32,
        data: new $gfJaN$restructure.Buffer("dataLen")
    }
});
let $035bb95c0cdb1f6d$var$SBitLineMetrics = new $gfJaN$restructure.Struct({
    ascender: $gfJaN$restructure.int8,
    descender: $gfJaN$restructure.int8,
    widthMax: $gfJaN$restructure.uint8,
    caretSlopeNumerator: $gfJaN$restructure.int8,
    caretSlopeDenominator: $gfJaN$restructure.int8,
    caretOffset: $gfJaN$restructure.int8,
    minOriginSB: $gfJaN$restructure.int8,
    minAdvanceSB: $gfJaN$restructure.int8,
    maxBeforeBL: $gfJaN$restructure.int8,
    minAfterBL: $gfJaN$restructure.int8,
    pad: new $gfJaN$restructure.Reserved($gfJaN$restructure.int8, 2)
});
let $035bb95c0cdb1f6d$var$CodeOffsetPair = new $gfJaN$restructure.Struct({
    glyphCode: $gfJaN$restructure.uint16,
    offset: $gfJaN$restructure.uint16
});
let $035bb95c0cdb1f6d$var$IndexSubtable = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    header: {
        imageFormat: $gfJaN$restructure.uint16,
        imageDataOffset: $gfJaN$restructure.uint32
    },
    1: {
        offsetArray: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, (t)=>t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
    },
    2: {
        imageSize: $gfJaN$restructure.uint32,
        bigMetrics: $20e0c7bbecb76d75$export$16b227cb15d716a0
    },
    3: {
        offsetArray: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1)
    },
    4: {
        numGlyphs: $gfJaN$restructure.uint32,
        glyphArray: new $gfJaN$restructure.Array($035bb95c0cdb1f6d$var$CodeOffsetPair, (t)=>t.numGlyphs + 1)
    },
    5: {
        imageSize: $gfJaN$restructure.uint32,
        bigMetrics: $20e0c7bbecb76d75$export$16b227cb15d716a0,
        numGlyphs: $gfJaN$restructure.uint32,
        glyphCodeArray: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numGlyphs")
    }
});
let $035bb95c0cdb1f6d$var$IndexSubtableArray = new $gfJaN$restructure.Struct({
    firstGlyphIndex: $gfJaN$restructure.uint16,
    lastGlyphIndex: $gfJaN$restructure.uint16,
    subtable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $035bb95c0cdb1f6d$var$IndexSubtable)
});
let $035bb95c0cdb1f6d$var$BitmapSizeTable = new $gfJaN$restructure.Struct({
    indexSubTableArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($035bb95c0cdb1f6d$var$IndexSubtableArray, 1), {
        type: "parent"
    }),
    indexTablesSize: $gfJaN$restructure.uint32,
    numberOfIndexSubTables: $gfJaN$restructure.uint32,
    colorRef: $gfJaN$restructure.uint32,
    hori: $035bb95c0cdb1f6d$var$SBitLineMetrics,
    vert: $035bb95c0cdb1f6d$var$SBitLineMetrics,
    startGlyphIndex: $gfJaN$restructure.uint16,
    endGlyphIndex: $gfJaN$restructure.uint16,
    ppemX: $gfJaN$restructure.uint8,
    ppemY: $gfJaN$restructure.uint8,
    bitDepth: $gfJaN$restructure.uint8,
    flags: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
        "horizontal",
        "vertical"
    ])
});
var $035bb95c0cdb1f6d$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint32,
    numSizes: $gfJaN$restructure.uint32,
    sizes: new $gfJaN$restructure.Array($035bb95c0cdb1f6d$var$BitmapSizeTable, "numSizes")
});
let $73d13900b55a3c0c$var$ImageTable = new $gfJaN$restructure.Struct({
    ppem: $gfJaN$restructure.uint16,
    resolution: $gfJaN$restructure.uint16,
    imageOffsets: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, "void"), (t)=>t.parent.parent.maxp.numGlyphs + 1)
});
var // It includes several image tables with images for each bitmap glyph
// of several different sizes.
$73d13900b55a3c0c$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    flags: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
        "renderOutlines"
    ]),
    numImgTables: $gfJaN$restructure.uint32,
    imageTables: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $73d13900b55a3c0c$var$ImageTable), "numImgTables")
});
let $97f6b8be3a347a8f$var$LayerRecord = new $gfJaN$restructure.Struct({
    gid: $gfJaN$restructure.uint16,
    paletteIndex: $gfJaN$restructure.uint16 // Index value to use in the appropriate palette. This value must
}); // be less than numPaletteEntries in the CPAL table, except for
// the special case noted below. Each palette entry is 16 bits.
// A palette index of 0xFFFF is a special case indicating that
// the text foreground color should be used.
let $97f6b8be3a347a8f$var$BaseGlyphRecord = new $gfJaN$restructure.Struct({
    gid: $gfJaN$restructure.uint16,
    // and is not rendered for color.
    firstLayerIndex: $gfJaN$restructure.uint16,
    // There will be numLayers consecutive entries for this base glyph.
    numLayers: $gfJaN$restructure.uint16
});
var $97f6b8be3a347a8f$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numBaseGlyphRecords: $gfJaN$restructure.uint16,
    baseGlyphRecord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($97f6b8be3a347a8f$var$BaseGlyphRecord, "numBaseGlyphRecords")),
    layerRecords: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($97f6b8be3a347a8f$var$LayerRecord, "numLayerRecords"), {
        lazy: true
    }),
    numLayerRecords: $gfJaN$restructure.uint16
});
let $16ca60ecbdee30ea$var$ColorRecord = new $gfJaN$restructure.Struct({
    blue: $gfJaN$restructure.uint8,
    green: $gfJaN$restructure.uint8,
    red: $gfJaN$restructure.uint8,
    alpha: $gfJaN$restructure.uint8
});
var $16ca60ecbdee30ea$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    header: {
        numPaletteEntries: $gfJaN$restructure.uint16,
        numPalettes: $gfJaN$restructure.uint16,
        numColorRecords: $gfJaN$restructure.uint16,
        colorRecords: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($16ca60ecbdee30ea$var$ColorRecord, "numColorRecords")),
        colorRecordIndices: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numPalettes")
    },
    0: {},
    1: {
        offsetPaletteTypeArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($gfJaN$restructure.uint32, "numPalettes")),
        offsetPaletteLabelArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numPalettes")),
        offsetPaletteEntryLabelArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numPaletteEntries"))
    }
});
let $7327e41706f9d5c7$var$BaseCoord = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        coordinate: $gfJaN$restructure.int16 // X or Y value, in design units
    },
    2: {
        coordinate: $gfJaN$restructure.int16,
        referenceGlyph: $gfJaN$restructure.uint16,
        baseCoordPoint: $gfJaN$restructure.uint16 // Index of contour point on the referenceGlyph
    },
    3: {
        coordinate: $gfJaN$restructure.int16,
        deviceTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10) // Device table for X or Y value
    }
});
let $7327e41706f9d5c7$var$BaseValues = new $gfJaN$restructure.Struct({
    defaultIndex: $gfJaN$restructure.uint16,
    baseCoordCount: $gfJaN$restructure.uint16,
    baseCoords: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord), "baseCoordCount")
});
let $7327e41706f9d5c7$var$FeatMinMaxRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    minCoord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord, {
        type: "parent"
    }),
    maxCoord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord, {
        type: "parent"
    }) // May be NULL
});
let $7327e41706f9d5c7$var$MinMax = new $gfJaN$restructure.Struct({
    minCoord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord),
    maxCoord: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseCoord),
    featMinMaxCount: $gfJaN$restructure.uint16,
    featMinMaxRecords: new $gfJaN$restructure.Array($7327e41706f9d5c7$var$FeatMinMaxRecord, "featMinMaxCount") // In alphabetical order
});
let $7327e41706f9d5c7$var$BaseLangSysRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    minMax: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$MinMax, {
        type: "parent"
    })
});
let $7327e41706f9d5c7$var$BaseScript = new $gfJaN$restructure.Struct({
    baseValues: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseValues),
    defaultMinMax: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$MinMax),
    baseLangSysCount: $gfJaN$restructure.uint16,
    baseLangSysRecords: new $gfJaN$restructure.Array($7327e41706f9d5c7$var$BaseLangSysRecord, "baseLangSysCount") // in alphabetical order by BaseLangSysTag
});
let $7327e41706f9d5c7$var$BaseScriptRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    script: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseScript, {
        type: "parent"
    })
});
let $7327e41706f9d5c7$var$BaseScriptList = new $gfJaN$restructure.Array($7327e41706f9d5c7$var$BaseScriptRecord, $gfJaN$restructure.uint16);
// Array of 4-byte baseline identification tags-must be in alphabetical order
let $7327e41706f9d5c7$var$BaseTagList = new $gfJaN$restructure.Array(new $gfJaN$restructure.String(4), $gfJaN$restructure.uint16);
let $7327e41706f9d5c7$var$Axis = new $gfJaN$restructure.Struct({
    baseTagList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseTagList),
    baseScriptList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$BaseScriptList)
});
var $7327e41706f9d5c7$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    header: {
        horizAxis: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$Axis),
        vertAxis: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7327e41706f9d5c7$var$Axis) // May be NULL
    },
    0x00010000: {},
    0x00010001: {
        itemVariationStore: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$fe1b122a2710f241)
    }
});
let $7e48bbe9e5345664$var$AttachPoint = new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16);
let $7e48bbe9e5345664$var$AttachList = new $gfJaN$restructure.Struct({
    coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
    glyphCount: $gfJaN$restructure.uint16,
    attachPoints: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$AttachPoint), "glyphCount")
});
let $7e48bbe9e5345664$var$CaretValue = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        coordinate: $gfJaN$restructure.int16
    },
    2: {
        caretValuePoint: $gfJaN$restructure.uint16
    },
    3: {
        coordinate: $gfJaN$restructure.int16,
        deviceTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10)
    }
});
let $7e48bbe9e5345664$var$LigGlyph = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$CaretValue), $gfJaN$restructure.uint16);
let $7e48bbe9e5345664$var$LigCaretList = new $gfJaN$restructure.Struct({
    coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
    ligGlyphCount: $gfJaN$restructure.uint16,
    ligGlyphs: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$LigGlyph), "ligGlyphCount")
});
let $7e48bbe9e5345664$var$MarkGlyphSetsDef = new $gfJaN$restructure.Struct({
    markSetTableFormat: $gfJaN$restructure.uint16,
    markSetCount: $gfJaN$restructure.uint16,
    coverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $b6dd765146ad212a$export$17608c3f81a6111), "markSetCount")
});
var $7e48bbe9e5345664$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    header: {
        glyphClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
        attachList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$AttachList),
        ligCaretList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$LigCaretList),
        markAttachClassDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71)
    },
    0x00010000: {},
    0x00010002: {
        markGlyphSetsDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$MarkGlyphSetsDef)
    },
    0x00010003: {
        markGlyphSetsDef: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $7e48bbe9e5345664$var$MarkGlyphSetsDef),
        itemVariationStore: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$fe1b122a2710f241)
    }
});
let $b687332511a4da75$var$ValueFormat = new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
    "xPlacement",
    "yPlacement",
    "xAdvance",
    "yAdvance",
    "xPlaDevice",
    "yPlaDevice",
    "xAdvDevice",
    "yAdvDevice"
]);
let $b687332511a4da75$var$types = {
    xPlacement: $gfJaN$restructure.int16,
    yPlacement: $gfJaN$restructure.int16,
    xAdvance: $gfJaN$restructure.int16,
    yAdvance: $gfJaN$restructure.int16,
    xPlaDevice: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: "global",
        relativeTo: (ctx)=>ctx.rel
    }),
    yPlaDevice: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: "global",
        relativeTo: (ctx)=>ctx.rel
    }),
    xAdvDevice: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: "global",
        relativeTo: (ctx)=>ctx.rel
    }),
    yAdvDevice: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10, {
        type: "global",
        relativeTo: (ctx)=>ctx.rel
    })
};
class $b687332511a4da75$var$ValueRecord {
    buildStruct(parent) {
        let struct = parent;
        while(!struct[this.key] && struct.parent)struct = struct.parent;
        if (!struct[this.key]) return;
        let fields = {};
        fields.rel = ()=>struct._startOffset;
        let format = struct[this.key];
        for(let key in format)if (format[key]) fields[key] = $b687332511a4da75$var$types[key];
        return new $gfJaN$restructure.Struct(fields);
    }
    size(val, ctx) {
        return this.buildStruct(ctx).size(val, ctx);
    }
    decode(stream, parent) {
        let res = this.buildStruct(parent).decode(stream, parent);
        delete res.rel;
        return res;
    }
    constructor(key = "valueFormat"){
        this.key = key;
    }
}
let $b687332511a4da75$var$PairValueRecord = new $gfJaN$restructure.Struct({
    secondGlyph: $gfJaN$restructure.uint16,
    value1: new $b687332511a4da75$var$ValueRecord("valueFormat1"),
    value2: new $b687332511a4da75$var$ValueRecord("valueFormat2")
});
let $b687332511a4da75$var$PairSet = new $gfJaN$restructure.Array($b687332511a4da75$var$PairValueRecord, $gfJaN$restructure.uint16);
let $b687332511a4da75$var$Class2Record = new $gfJaN$restructure.Struct({
    value1: new $b687332511a4da75$var$ValueRecord("valueFormat1"),
    value2: new $b687332511a4da75$var$ValueRecord("valueFormat2")
});
let $b687332511a4da75$var$Anchor = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    1: {
        xCoordinate: $gfJaN$restructure.int16,
        yCoordinate: $gfJaN$restructure.int16
    },
    2: {
        xCoordinate: $gfJaN$restructure.int16,
        yCoordinate: $gfJaN$restructure.int16,
        anchorPoint: $gfJaN$restructure.uint16
    },
    3: {
        xCoordinate: $gfJaN$restructure.int16,
        yCoordinate: $gfJaN$restructure.int16,
        xDeviceTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10),
        yDeviceTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$8215d14a63d9fb10)
    }
});
let $b687332511a4da75$var$EntryExitRecord = new $gfJaN$restructure.Struct({
    entryAnchor: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor, {
        type: "parent"
    }),
    exitAnchor: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor, {
        type: "parent"
    })
});
let $b687332511a4da75$var$MarkRecord = new $gfJaN$restructure.Struct({
    class: $gfJaN$restructure.uint16,
    markAnchor: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor, {
        type: "parent"
    })
});
let $b687332511a4da75$var$MarkArray = new $gfJaN$restructure.Array($b687332511a4da75$var$MarkRecord, $gfJaN$restructure.uint16);
let $b687332511a4da75$var$BaseRecord = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor), (t)=>t.parent.classCount);
let $b687332511a4da75$var$BaseArray = new $gfJaN$restructure.Array($b687332511a4da75$var$BaseRecord, $gfJaN$restructure.uint16);
let $b687332511a4da75$var$ComponentRecord = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$Anchor), (t)=>t.parent.parent.classCount);
let $b687332511a4da75$var$LigatureAttach = new $gfJaN$restructure.Array($b687332511a4da75$var$ComponentRecord, $gfJaN$restructure.uint16);
let $b687332511a4da75$var$LigatureArray = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$LigatureAttach), $gfJaN$restructure.uint16);
let $b687332511a4da75$export$73a8cfb19cd43a0f = new $gfJaN$restructure.VersionedStruct("lookupType", {
    1: new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
        1: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat: $b687332511a4da75$var$ValueFormat,
            value: new $b687332511a4da75$var$ValueRecord()
        },
        2: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat: $b687332511a4da75$var$ValueFormat,
            valueCount: $gfJaN$restructure.uint16,
            values: new $gfJaN$restructure.LazyArray(new $b687332511a4da75$var$ValueRecord(), "valueCount")
        }
    }),
    2: new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
        1: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat1: $b687332511a4da75$var$ValueFormat,
            valueFormat2: $b687332511a4da75$var$ValueFormat,
            pairSetCount: $gfJaN$restructure.uint16,
            pairSets: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$PairSet), "pairSetCount")
        },
        2: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            valueFormat1: $b687332511a4da75$var$ValueFormat,
            valueFormat2: $b687332511a4da75$var$ValueFormat,
            classDef1: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
            classDef2: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$843d551fbbafef71),
            class1Count: $gfJaN$restructure.uint16,
            class2Count: $gfJaN$restructure.uint16,
            classRecords: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.LazyArray($b687332511a4da75$var$Class2Record, "class2Count"), "class1Count")
        }
    }),
    3: {
        format: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        entryExitCount: $gfJaN$restructure.uint16,
        entryExitRecords: new $gfJaN$restructure.Array($b687332511a4da75$var$EntryExitRecord, "entryExitCount")
    },
    4: {
        format: $gfJaN$restructure.uint16,
        markCoverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        baseCoverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        classCount: $gfJaN$restructure.uint16,
        markArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$MarkArray),
        baseArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$BaseArray)
    },
    5: {
        format: $gfJaN$restructure.uint16,
        markCoverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        ligatureCoverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        classCount: $gfJaN$restructure.uint16,
        markArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$MarkArray),
        ligatureArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$LigatureArray)
    },
    6: {
        format: $gfJaN$restructure.uint16,
        mark1Coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        mark2Coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        classCount: $gfJaN$restructure.uint16,
        mark1Array: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$MarkArray),
        mark2Array: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b687332511a4da75$var$BaseArray)
    },
    7: $b6dd765146ad212a$export$841858b892ce1f4c,
    8: $b6dd765146ad212a$export$5e6d09e6861162f6,
    9: {
        posFormat: $gfJaN$restructure.uint16,
        lookupType: $gfJaN$restructure.uint16,
        extension: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, null)
    }
});
// Fix circular reference
$b687332511a4da75$export$73a8cfb19cd43a0f.versions[9].extension.type = $b687332511a4da75$export$73a8cfb19cd43a0f;
var $b687332511a4da75$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    header: {
        scriptList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$3e15fc05ce864229),
        featureList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$aa18130def4b6cb4),
        lookupList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $b6dd765146ad212a$export$df0008c6ff2da22a($b687332511a4da75$export$73a8cfb19cd43a0f))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$441b70b7971dd419)
    }
});
let $99ccad60b96f92fb$var$Sequence = new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16);
let $99ccad60b96f92fb$var$AlternateSet = $99ccad60b96f92fb$var$Sequence;
let $99ccad60b96f92fb$var$Ligature = new $gfJaN$restructure.Struct({
    glyph: $gfJaN$restructure.uint16,
    compCount: $gfJaN$restructure.uint16,
    components: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.compCount - 1)
});
let $99ccad60b96f92fb$var$LigatureSet = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $99ccad60b96f92fb$var$Ligature), $gfJaN$restructure.uint16);
let $99ccad60b96f92fb$var$GSUBLookup = new $gfJaN$restructure.VersionedStruct("lookupType", {
    1: new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
        1: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            deltaGlyphID: $gfJaN$restructure.int16
        },
        2: {
            coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
            glyphCount: $gfJaN$restructure.uint16,
            substitute: new $gfJaN$restructure.LazyArray($gfJaN$restructure.uint16, "glyphCount")
        }
    }),
    2: {
        substFormat: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        count: $gfJaN$restructure.uint16,
        sequences: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $99ccad60b96f92fb$var$Sequence), "count")
    },
    3: {
        substFormat: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        count: $gfJaN$restructure.uint16,
        alternateSet: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $99ccad60b96f92fb$var$AlternateSet), "count")
    },
    4: {
        substFormat: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        count: $gfJaN$restructure.uint16,
        ligatureSets: new $gfJaN$restructure.LazyArray(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $99ccad60b96f92fb$var$LigatureSet), "count")
    },
    5: $b6dd765146ad212a$export$841858b892ce1f4c,
    6: $b6dd765146ad212a$export$5e6d09e6861162f6,
    7: {
        substFormat: $gfJaN$restructure.uint16,
        lookupType: $gfJaN$restructure.uint16,
        extension: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, null)
    },
    8: {
        substFormat: $gfJaN$restructure.uint16,
        coverage: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111),
        backtrackCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "backtrackGlyphCount"),
        lookaheadGlyphCount: $gfJaN$restructure.uint16,
        lookaheadCoverage: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$17608c3f81a6111), "lookaheadGlyphCount"),
        glyphCount: $gfJaN$restructure.uint16,
        substitutes: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "glyphCount")
    }
});
// Fix circular reference
$99ccad60b96f92fb$var$GSUBLookup.versions[7].extension.type = $99ccad60b96f92fb$var$GSUBLookup;
var $99ccad60b96f92fb$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    header: {
        scriptList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$3e15fc05ce864229),
        featureList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $b6dd765146ad212a$export$aa18130def4b6cb4),
        lookupList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $b6dd765146ad212a$export$df0008c6ff2da22a($99ccad60b96f92fb$var$GSUBLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$441b70b7971dd419)
    }
});
let $573d5042c76c4940$var$JstfGSUBModList = new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16);
let $573d5042c76c4940$var$JstfPriority = new $gfJaN$restructure.Struct({
    shrinkageEnableGSUB: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    shrinkageDisableGSUB: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    shrinkageEnableGPOS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    shrinkageDisableGPOS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    shrinkageJstfMax: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $b6dd765146ad212a$export$df0008c6ff2da22a($b687332511a4da75$export$73a8cfb19cd43a0f)),
    extensionEnableGSUB: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    extensionDisableGSUB: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    extensionEnableGPOS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    extensionDisableGPOS: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfGSUBModList),
    extensionJstfMax: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $b6dd765146ad212a$export$df0008c6ff2da22a($b687332511a4da75$export$73a8cfb19cd43a0f))
});
let $573d5042c76c4940$var$JstfLangSys = new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfPriority), $gfJaN$restructure.uint16);
let $573d5042c76c4940$var$JstfLangSysRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    jstfLangSys: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfLangSys)
});
let $573d5042c76c4940$var$JstfScript = new $gfJaN$restructure.Struct({
    extenderGlyphs: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16)),
    defaultLangSys: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfLangSys),
    langSysCount: $gfJaN$restructure.uint16,
    langSysRecords: new $gfJaN$restructure.Array($573d5042c76c4940$var$JstfLangSysRecord, "langSysCount")
});
let $573d5042c76c4940$var$JstfScriptRecord = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    script: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $573d5042c76c4940$var$JstfScript, {
        type: "parent"
    })
});
var $573d5042c76c4940$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint32,
    scriptCount: $gfJaN$restructure.uint16,
    scriptList: new $gfJaN$restructure.Array($573d5042c76c4940$var$JstfScriptRecord, "scriptCount")
});
// TODO: add this to restructure
class $a5875b80d6087f61$var$VariableSizeNumber {
    decode(stream, parent) {
        switch(this.size(0, parent)){
            case 1:
                return stream.readUInt8();
            case 2:
                return stream.readUInt16BE();
            case 3:
                return stream.readUInt24BE();
            case 4:
                return stream.readUInt32BE();
        }
    }
    size(val, parent) {
        return (0, $gfJaN$restructure.resolveLength)(this._size, null, parent);
    }
    constructor(size){
        this._size = size;
    }
}
let $a5875b80d6087f61$var$MapDataEntry = new $gfJaN$restructure.Struct({
    entry: new $a5875b80d6087f61$var$VariableSizeNumber((t)=>((t.parent.entryFormat & 0x0030) >> 4) + 1),
    outerIndex: (t)=>t.entry >> (t.parent.entryFormat & 0x000F) + 1,
    innerIndex: (t)=>t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1
});
let $a5875b80d6087f61$var$DeltaSetIndexMap = new $gfJaN$restructure.Struct({
    entryFormat: $gfJaN$restructure.uint16,
    mapCount: $gfJaN$restructure.uint16,
    mapData: new $gfJaN$restructure.Array($a5875b80d6087f61$var$MapDataEntry, "mapCount")
});
var $a5875b80d6087f61$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    itemVariationStore: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $2e4adcda047b3383$export$fe1b122a2710f241),
    advanceWidthMapping: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $a5875b80d6087f61$var$DeltaSetIndexMap),
    LSBMapping: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $a5875b80d6087f61$var$DeltaSetIndexMap),
    RSBMapping: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $a5875b80d6087f61$var$DeltaSetIndexMap)
});
let $4423bc1ac09bbbd1$var$Signature = new $gfJaN$restructure.Struct({
    format: $gfJaN$restructure.uint32,
    length: $gfJaN$restructure.uint32,
    offset: $gfJaN$restructure.uint32
});
let $4423bc1ac09bbbd1$var$SignatureBlock = new $gfJaN$restructure.Struct({
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16, 2),
    cbSignature: $gfJaN$restructure.uint32,
    signature: new $gfJaN$restructure.Buffer("cbSignature")
});
var $4423bc1ac09bbbd1$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    ulVersion: $gfJaN$restructure.uint32,
    usNumSigs: $gfJaN$restructure.uint16,
    usFlag: $gfJaN$restructure.uint16,
    signatures: new $gfJaN$restructure.Array($4423bc1ac09bbbd1$var$Signature, "usNumSigs"),
    signatureBlocks: new $gfJaN$restructure.Array($4423bc1ac09bbbd1$var$SignatureBlock, "usNumSigs")
});
let $7b50e3f8d83263de$var$GaspRange = new $gfJaN$restructure.Struct({
    rangeMaxPPEM: $gfJaN$restructure.uint16,
    rangeGaspBehavior: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint16, [
        "grayscale",
        "gridfit",
        "symmetricSmoothing",
        "symmetricGridfit" // only in version 1, for ClearType
    ])
});
var $7b50e3f8d83263de$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numRanges: $gfJaN$restructure.uint16,
    gaspRanges: new $gfJaN$restructure.Array($7b50e3f8d83263de$var$GaspRange, "numRanges") // Sorted by ppem
});
let $7bf92ec372cd2307$var$DeviceRecord = new $gfJaN$restructure.Struct({
    pixelSize: $gfJaN$restructure.uint8,
    maximumWidth: $gfJaN$restructure.uint8,
    widths: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, (t)=>t.parent.parent.maxp.numGlyphs)
});
var $7bf92ec372cd2307$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numRecords: $gfJaN$restructure.int16,
    sizeDeviceRecord: $gfJaN$restructure.int32,
    records: new $gfJaN$restructure.Array($7bf92ec372cd2307$var$DeviceRecord, "numRecords")
});
let $a3f544bcf76542d1$var$KernPair = new $gfJaN$restructure.Struct({
    left: $gfJaN$restructure.uint16,
    right: $gfJaN$restructure.uint16,
    value: $gfJaN$restructure.int16
});
let $a3f544bcf76542d1$var$ClassTable = new $gfJaN$restructure.Struct({
    firstGlyph: $gfJaN$restructure.uint16,
    nGlyphs: $gfJaN$restructure.uint16,
    offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "nGlyphs"),
    max: (t)=>t.offsets.length && Math.max.apply(Math, t.offsets)
});
let $a3f544bcf76542d1$var$Kern2Array = new $gfJaN$restructure.Struct({
    off: (t)=>t._startOffset - t.parent.parent._startOffset,
    len: (t)=>((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2),
    values: new $gfJaN$restructure.LazyArray($gfJaN$restructure.int16, "len")
});
let $a3f544bcf76542d1$var$KernSubtable = new $gfJaN$restructure.VersionedStruct("format", {
    0: {
        nPairs: $gfJaN$restructure.uint16,
        searchRange: $gfJaN$restructure.uint16,
        entrySelector: $gfJaN$restructure.uint16,
        rangeShift: $gfJaN$restructure.uint16,
        pairs: new $gfJaN$restructure.Array($a3f544bcf76542d1$var$KernPair, "nPairs")
    },
    2: {
        rowWidth: $gfJaN$restructure.uint16,
        leftTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $a3f544bcf76542d1$var$ClassTable, {
            type: "parent"
        }),
        rightTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $a3f544bcf76542d1$var$ClassTable, {
            type: "parent"
        }),
        array: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $a3f544bcf76542d1$var$Kern2Array, {
            type: "parent"
        })
    },
    3: {
        glyphCount: $gfJaN$restructure.uint16,
        kernValueCount: $gfJaN$restructure.uint8,
        leftClassCount: $gfJaN$restructure.uint8,
        rightClassCount: $gfJaN$restructure.uint8,
        flags: $gfJaN$restructure.uint8,
        kernValue: new $gfJaN$restructure.Array($gfJaN$restructure.int16, "kernValueCount"),
        leftClass: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "glyphCount"),
        rightClass: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "glyphCount"),
        kernIndex: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, (t)=>t.leftClassCount * t.rightClassCount)
    }
});
let $a3f544bcf76542d1$var$KernTable = new $gfJaN$restructure.VersionedStruct("version", {
    0: {
        subVersion: $gfJaN$restructure.uint16,
        length: $gfJaN$restructure.uint16,
        format: $gfJaN$restructure.uint8,
        coverage: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
            "horizontal",
            "minimum",
            "crossStream",
            "override" // If set to 1 the value in this table replaces the accumulated value
        ]),
        subtable: $a3f544bcf76542d1$var$KernSubtable,
        padding: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, (t)=>t.length - t._currentOffset)
    },
    1: {
        length: $gfJaN$restructure.uint32,
        coverage: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
            null,
            null,
            null,
            null,
            null,
            "variation",
            "crossStream",
            "vertical" // Set if table has vertical kerning values
        ]),
        format: $gfJaN$restructure.uint8,
        tupleIndex: $gfJaN$restructure.uint16,
        subtable: $a3f544bcf76542d1$var$KernSubtable,
        padding: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, (t)=>t.length - t._currentOffset)
    }
});
var $a3f544bcf76542d1$export$2e2bcd8739ae039 = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
    0: {
        nTables: $gfJaN$restructure.uint16,
        tables: new $gfJaN$restructure.Array($a3f544bcf76542d1$var$KernTable, "nTables")
    },
    1: {
        reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
        nTables: $gfJaN$restructure.uint32,
        tables: new $gfJaN$restructure.Array($a3f544bcf76542d1$var$KernTable, "nTables")
    }
});
var // Records the ppem for each glyph at which the scaling becomes linear again,
// despite instructions effecting the advance width
$86687befb45925d0$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numGlyphs: $gfJaN$restructure.uint16,
    yPels: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, "numGlyphs")
});
var // NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
$91429006e51e0fe8$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    fontNumber: $gfJaN$restructure.uint32,
    pitch: $gfJaN$restructure.uint16,
    xHeight: $gfJaN$restructure.uint16,
    style: $gfJaN$restructure.uint16,
    typeFamily: $gfJaN$restructure.uint16,
    capHeight: $gfJaN$restructure.uint16,
    symbolSet: $gfJaN$restructure.uint16,
    typeface: new $gfJaN$restructure.String(16),
    characterComplement: new $gfJaN$restructure.String(8),
    fileName: new $gfJaN$restructure.String(6),
    strokeWeight: new $gfJaN$restructure.String(1),
    widthType: new $gfJaN$restructure.String(1),
    serifStyle: $gfJaN$restructure.uint8,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8)
});
// VDMX tables contain ascender/descender overrides for certain (usually small)
// sizes. This is needed in order to match font metrics on Windows.
let $627850fc9deed59a$var$Ratio = new $gfJaN$restructure.Struct({
    bCharSet: $gfJaN$restructure.uint8,
    xRatio: $gfJaN$restructure.uint8,
    yStartRatio: $gfJaN$restructure.uint8,
    yEndRatio: $gfJaN$restructure.uint8 // Ending y-Ratio value
});
let $627850fc9deed59a$var$vTable = new $gfJaN$restructure.Struct({
    yPelHeight: $gfJaN$restructure.uint16,
    yMax: $gfJaN$restructure.int16,
    yMin: $gfJaN$restructure.int16 // Minimum value (in pels) for this yPelHeight
});
let $627850fc9deed59a$var$VdmxGroup = new $gfJaN$restructure.Struct({
    recs: $gfJaN$restructure.uint16,
    startsz: $gfJaN$restructure.uint8,
    endsz: $gfJaN$restructure.uint8,
    entries: new $gfJaN$restructure.Array($627850fc9deed59a$var$vTable, "recs") // The VDMX records
});
var $627850fc9deed59a$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    numRecs: $gfJaN$restructure.uint16,
    numRatios: $gfJaN$restructure.uint16,
    ratioRanges: new $gfJaN$restructure.Array($627850fc9deed59a$var$Ratio, "numRatios"),
    offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numRatios"),
    groups: new $gfJaN$restructure.Array($627850fc9deed59a$var$VdmxGroup, "numRecs") // The actual VDMX groupings
});
var $65c33f5f068fc77f$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    ascent: $gfJaN$restructure.int16,
    descent: $gfJaN$restructure.int16,
    lineGap: $gfJaN$restructure.int16,
    advanceHeightMax: $gfJaN$restructure.int16,
    minTopSideBearing: $gfJaN$restructure.int16,
    minBottomSideBearing: $gfJaN$restructure.int16,
    yMaxExtent: $gfJaN$restructure.int16,
    caretSlopeRise: $gfJaN$restructure.int16,
    caretSlopeRun: $gfJaN$restructure.int16,
    caretOffset: $gfJaN$restructure.int16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.int16, 4),
    metricDataFormat: $gfJaN$restructure.int16,
    numberOfMetrics: $gfJaN$restructure.uint16 // Number of advance heights in the Vertical Metrics table
});
let $597d739523b65bb3$var$VmtxEntry = new $gfJaN$restructure.Struct({
    advance: $gfJaN$restructure.uint16,
    bearing: $gfJaN$restructure.int16 // The top sidebearing of the glyph
});
var $597d739523b65bb3$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    metrics: new $gfJaN$restructure.LazyArray($597d739523b65bb3$var$VmtxEntry, (t)=>t.parent.vhea.numberOfMetrics),
    bearings: new $gfJaN$restructure.LazyArray($gfJaN$restructure.int16, (t)=>t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics)
});
let $35aa0c87d9c3d3a0$var$shortFrac = new $gfJaN$restructure.Fixed(16, "BE", 14);
let $35aa0c87d9c3d3a0$var$Correspondence = new $gfJaN$restructure.Struct({
    fromCoord: $35aa0c87d9c3d3a0$var$shortFrac,
    toCoord: $35aa0c87d9c3d3a0$var$shortFrac
});
let $35aa0c87d9c3d3a0$var$Segment = new $gfJaN$restructure.Struct({
    pairCount: $gfJaN$restructure.uint16,
    correspondence: new $gfJaN$restructure.Array($35aa0c87d9c3d3a0$var$Correspondence, "pairCount")
});
var $35aa0c87d9c3d3a0$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    axisCount: $gfJaN$restructure.uint32,
    segment: new $gfJaN$restructure.Array($35aa0c87d9c3d3a0$var$Segment, "axisCount")
});
class $22801616bd931ca3$var$UnboundedArrayAccessor {
    getItem(index) {
        if (this._items[index] == null) {
            let pos = this.stream.pos;
            this.stream.pos = this.base + this.type.size(null, this.parent) * index;
            this._items[index] = this.type.decode(this.stream, this.parent);
            this.stream.pos = pos;
        }
        return this._items[index];
    }
    inspect() {
        return `[UnboundedArray ${this.type.constructor.name}]`;
    }
    constructor(type, stream, parent){
        this.type = type;
        this.stream = stream;
        this.parent = parent;
        this.base = this.stream.pos;
        this._items = [];
    }
}
class $22801616bd931ca3$export$c5af1eebc882e39a extends $gfJaN$restructure.Array {
    decode(stream, parent) {
        return new $22801616bd931ca3$var$UnboundedArrayAccessor(this.type, stream, parent);
    }
    constructor(type){
        super(type, 0);
    }
}
let $22801616bd931ca3$export$8351f8c2ae2f103c = function(ValueType = $gfJaN$restructure.uint16) {
    // Helper class that makes internal structures invisible to pointers
    class Shadow {
        decode(stream, ctx) {
            ctx = ctx.parent.parent;
            return this.type.decode(stream, ctx);
        }
        size(val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.size(val, ctx);
        }
        encode(stream, val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.encode(stream, val, ctx);
        }
        constructor(type){
            this.type = type;
        }
    }
    ValueType = new Shadow(ValueType);
    let BinarySearchHeader = new $gfJaN$restructure.Struct({
        unitSize: $gfJaN$restructure.uint16,
        nUnits: $gfJaN$restructure.uint16,
        searchRange: $gfJaN$restructure.uint16,
        entrySelector: $gfJaN$restructure.uint16,
        rangeShift: $gfJaN$restructure.uint16
    });
    let LookupSegmentSingle = new $gfJaN$restructure.Struct({
        lastGlyph: $gfJaN$restructure.uint16,
        firstGlyph: $gfJaN$restructure.uint16,
        value: ValueType
    });
    let LookupSegmentArray = new $gfJaN$restructure.Struct({
        lastGlyph: $gfJaN$restructure.uint16,
        firstGlyph: $gfJaN$restructure.uint16,
        values: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.Array(ValueType, (t)=>t.lastGlyph - t.firstGlyph + 1), {
            type: "parent"
        })
    });
    let LookupSingle = new $gfJaN$restructure.Struct({
        glyph: $gfJaN$restructure.uint16,
        value: ValueType
    });
    return new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint16, {
        0: {
            values: new $22801616bd931ca3$export$c5af1eebc882e39a(ValueType) // length == number of glyphs maybe?
        },
        2: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $gfJaN$restructure.Array(LookupSegmentSingle, (t)=>t.binarySearchHeader.nUnits)
        },
        4: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $gfJaN$restructure.Array(LookupSegmentArray, (t)=>t.binarySearchHeader.nUnits)
        },
        6: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $gfJaN$restructure.Array(LookupSingle, (t)=>t.binarySearchHeader.nUnits)
        },
        8: {
            firstGlyph: $gfJaN$restructure.uint16,
            count: $gfJaN$restructure.uint16,
            values: new $gfJaN$restructure.Array(ValueType, "count")
        }
    });
};
function $22801616bd931ca3$export$79f7d93d790934ba(entryData = {}, lookupType = $gfJaN$restructure.uint16) {
    let entry = Object.assign({
        newState: $gfJaN$restructure.uint16,
        flags: $gfJaN$restructure.uint16
    }, entryData);
    let Entry = new $gfJaN$restructure.Struct(entry);
    let StateArray = new $22801616bd931ca3$export$c5af1eebc882e39a(new $gfJaN$restructure.Array($gfJaN$restructure.uint16, (t)=>t.nClasses));
    let StateHeader = new $gfJaN$restructure.Struct({
        nClasses: $gfJaN$restructure.uint32,
        classTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$8351f8c2ae2f103c(lookupType)),
        stateArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, StateArray),
        entryTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a(Entry))
    });
    return StateHeader;
}
function $22801616bd931ca3$export$105027425199cc51(entryData = {}, lookupType = $gfJaN$restructure.uint16) {
    let ClassLookupTable = new $gfJaN$restructure.Struct({
        version () {
            return 8;
        },
        firstGlyph: $gfJaN$restructure.uint16,
        values: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, $gfJaN$restructure.uint16)
    });
    let entry = Object.assign({
        newStateOffset: $gfJaN$restructure.uint16,
        // convert offset to stateArray index
        newState: (t)=>(t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses,
        flags: $gfJaN$restructure.uint16
    }, entryData);
    let Entry = new $gfJaN$restructure.Struct(entry);
    let StateArray = new $22801616bd931ca3$export$c5af1eebc882e39a(new $gfJaN$restructure.Array($gfJaN$restructure.uint8, (t)=>t.nClasses));
    let StateHeader1 = new $gfJaN$restructure.Struct({
        nClasses: $gfJaN$restructure.uint16,
        classTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, ClassLookupTable),
        stateArray: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, StateArray),
        entryTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $22801616bd931ca3$export$c5af1eebc882e39a(Entry))
    });
    return StateHeader1;
}
let $3a5ca96d3e3aaf20$var$BslnSubtable = new $gfJaN$restructure.VersionedStruct("format", {
    0: {
        deltas: new $gfJaN$restructure.Array($gfJaN$restructure.int16, 32)
    },
    1: {
        deltas: new $gfJaN$restructure.Array($gfJaN$restructure.int16, 32),
        mappingData: new $22801616bd931ca3$export$8351f8c2ae2f103c($gfJaN$restructure.uint16)
    },
    2: {
        standardGlyph: $gfJaN$restructure.uint16,
        controlPoints: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, 32)
    },
    3: {
        standardGlyph: $gfJaN$restructure.uint16,
        controlPoints: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, 32),
        mappingData: new $22801616bd931ca3$export$8351f8c2ae2f103c($gfJaN$restructure.uint16)
    }
});
var $3a5ca96d3e3aaf20$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    format: $gfJaN$restructure.uint16,
    defaultBaseline: $gfJaN$restructure.uint16,
    subtable: $3a5ca96d3e3aaf20$var$BslnSubtable
});
let $8d4241d96b2b0589$var$Setting = new $gfJaN$restructure.Struct({
    setting: $gfJaN$restructure.uint16,
    nameIndex: $gfJaN$restructure.int16,
    name: (t)=>t.parent.parent.parent.name.records.fontFeatures[t.nameIndex]
});
let $8d4241d96b2b0589$var$FeatureName = new $gfJaN$restructure.Struct({
    feature: $gfJaN$restructure.uint16,
    nSettings: $gfJaN$restructure.uint16,
    settingTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array($8d4241d96b2b0589$var$Setting, "nSettings"), {
        type: "parent"
    }),
    featureFlags: new $gfJaN$restructure.Bitfield($gfJaN$restructure.uint8, [
        null,
        null,
        null,
        null,
        null,
        null,
        "hasDefault",
        "exclusive"
    ]),
    defaultSetting: $gfJaN$restructure.uint8,
    nameIndex: $gfJaN$restructure.int16,
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameIndex]
});
var $8d4241d96b2b0589$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    featureNameCount: $gfJaN$restructure.uint16,
    reserved1: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    reserved2: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint32),
    featureNames: new $gfJaN$restructure.Array($8d4241d96b2b0589$var$FeatureName, "featureNameCount")
});
let $a79cd5132b1cf476$var$Axis = new $gfJaN$restructure.Struct({
    axisTag: new $gfJaN$restructure.String(4),
    minValue: $gfJaN$restructure.fixed32,
    defaultValue: $gfJaN$restructure.fixed32,
    maxValue: $gfJaN$restructure.fixed32,
    flags: $gfJaN$restructure.uint16,
    nameID: $gfJaN$restructure.uint16,
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameID]
});
let $a79cd5132b1cf476$var$Instance = new $gfJaN$restructure.Struct({
    nameID: $gfJaN$restructure.uint16,
    name: (t)=>t.parent.parent.name.records.fontFeatures[t.nameID],
    flags: $gfJaN$restructure.uint16,
    coord: new $gfJaN$restructure.Array($gfJaN$restructure.fixed32, (t)=>t.parent.axisCount),
    postscriptNameID: new $gfJaN$restructure.Optional($gfJaN$restructure.uint16, (t)=>t.parent.instanceSize - t._currentOffset > 0)
});
var $a79cd5132b1cf476$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    offsetToData: $gfJaN$restructure.uint16,
    countSizePairs: $gfJaN$restructure.uint16,
    axisCount: $gfJaN$restructure.uint16,
    axisSize: $gfJaN$restructure.uint16,
    instanceCount: $gfJaN$restructure.uint16,
    instanceSize: $gfJaN$restructure.uint16,
    axis: new $gfJaN$restructure.Array($a79cd5132b1cf476$var$Axis, "axisCount"),
    instance: new $gfJaN$restructure.Array($a79cd5132b1cf476$var$Instance, "instanceCount")
});
let $3f36f1a5e6989457$var$shortFrac = new $gfJaN$restructure.Fixed(16, "BE", 14);
class $3f36f1a5e6989457$var$Offset {
    static decode(stream, parent) {
        // In short format, offsets are multiplied by 2.
        // This doesn't seem to be documented by Apple, but it
        // is implemented this way in Freetype.
        return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
    }
}
let $3f36f1a5e6989457$var$gvar = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    axisCount: $gfJaN$restructure.uint16,
    globalCoordCount: $gfJaN$restructure.uint16,
    globalCoords: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $gfJaN$restructure.Array(new $gfJaN$restructure.Array($3f36f1a5e6989457$var$shortFrac, "axisCount"), "globalCoordCount")),
    glyphCount: $gfJaN$restructure.uint16,
    flags: $gfJaN$restructure.uint16,
    offsetToData: $gfJaN$restructure.uint32,
    offsets: new $gfJaN$restructure.Array(new $gfJaN$restructure.Pointer($3f36f1a5e6989457$var$Offset, "void", {
        relativeTo: (ctx)=>ctx.offsetToData,
        allowNull: false
    }), (t)=>t.glyphCount + 1)
});
var $3f36f1a5e6989457$export$2e2bcd8739ae039 = $3f36f1a5e6989457$var$gvar;
let $0bd8fe7a6d1d9fb4$var$ClassTable = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint16,
    coverage: $gfJaN$restructure.uint16,
    subFeatureFlags: $gfJaN$restructure.uint32,
    stateTable: new $22801616bd931ca3$export$105027425199cc51
});
let $0bd8fe7a6d1d9fb4$var$WidthDeltaRecord = new $gfJaN$restructure.Struct({
    justClass: $gfJaN$restructure.uint32,
    beforeGrowLimit: $gfJaN$restructure.fixed32,
    beforeShrinkLimit: $gfJaN$restructure.fixed32,
    afterGrowLimit: $gfJaN$restructure.fixed32,
    afterShrinkLimit: $gfJaN$restructure.fixed32,
    growFlags: $gfJaN$restructure.uint16,
    shrinkFlags: $gfJaN$restructure.uint16
});
let $0bd8fe7a6d1d9fb4$var$WidthDeltaCluster = new $gfJaN$restructure.Array($0bd8fe7a6d1d9fb4$var$WidthDeltaRecord, $gfJaN$restructure.uint32);
let $0bd8fe7a6d1d9fb4$var$ActionData = new $gfJaN$restructure.VersionedStruct("actionType", {
    0: {
        lowerLimit: $gfJaN$restructure.fixed32,
        upperLimit: $gfJaN$restructure.fixed32,
        order: $gfJaN$restructure.uint16,
        glyphs: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, $gfJaN$restructure.uint16)
    },
    1: {
        addGlyph: $gfJaN$restructure.uint16
    },
    2: {
        substThreshold: $gfJaN$restructure.fixed32,
        addGlyph: $gfJaN$restructure.uint16,
        substGlyph: $gfJaN$restructure.uint16
    },
    3: {},
    4: {
        variationAxis: $gfJaN$restructure.uint32,
        minimumLimit: $gfJaN$restructure.fixed32,
        noStretchValue: $gfJaN$restructure.fixed32,
        maximumLimit: $gfJaN$restructure.fixed32
    },
    5: {
        flags: $gfJaN$restructure.uint16,
        glyph: $gfJaN$restructure.uint16
    }
});
let $0bd8fe7a6d1d9fb4$var$Action = new $gfJaN$restructure.Struct({
    actionClass: $gfJaN$restructure.uint16,
    actionType: $gfJaN$restructure.uint16,
    actionLength: $gfJaN$restructure.uint32,
    actionData: $0bd8fe7a6d1d9fb4$var$ActionData,
    padding: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, (t)=>t.actionLength - t._currentOffset)
});
let $0bd8fe7a6d1d9fb4$var$PostcompensationAction = new $gfJaN$restructure.Array($0bd8fe7a6d1d9fb4$var$Action, $gfJaN$restructure.uint32);
let $0bd8fe7a6d1d9fb4$var$PostCompensationTable = new $gfJaN$restructure.Struct({
    lookupTable: new $22801616bd931ca3$export$8351f8c2ae2f103c(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$PostcompensationAction))
});
let $0bd8fe7a6d1d9fb4$var$JustificationTable = new $gfJaN$restructure.Struct({
    classTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$ClassTable, {
        type: "parent"
    }),
    wdcOffset: $gfJaN$restructure.uint16,
    postCompensationTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$PostCompensationTable, {
        type: "parent"
    }),
    widthDeltaClusters: new $22801616bd931ca3$export$8351f8c2ae2f103c(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$WidthDeltaCluster, {
        type: "parent",
        relativeTo: (ctx)=>ctx.wdcOffset
    }))
});
var $0bd8fe7a6d1d9fb4$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint32,
    format: $gfJaN$restructure.uint16,
    horizontal: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$JustificationTable),
    vertical: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $0bd8fe7a6d1d9fb4$var$JustificationTable)
});
let $ef40c6dc80fd50a2$var$LigatureData = {
    action: $gfJaN$restructure.uint16
};
let $ef40c6dc80fd50a2$var$ContextualData = {
    markIndex: $gfJaN$restructure.uint16,
    currentIndex: $gfJaN$restructure.uint16
};
let $ef40c6dc80fd50a2$var$InsertionData = {
    currentInsertIndex: $gfJaN$restructure.uint16,
    markedInsertIndex: $gfJaN$restructure.uint16
};
let $ef40c6dc80fd50a2$var$SubstitutionTable = new $gfJaN$restructure.Struct({
    items: new $22801616bd931ca3$export$c5af1eebc882e39a(new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$8351f8c2ae2f103c))
});
let $ef40c6dc80fd50a2$var$SubtableData = new $gfJaN$restructure.VersionedStruct("type", {
    0: {
        stateTable: new $22801616bd931ca3$export$79f7d93d790934ba
    },
    1: {
        stateTable: new $22801616bd931ca3$export$79f7d93d790934ba($ef40c6dc80fd50a2$var$ContextualData),
        substitutionTable: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $ef40c6dc80fd50a2$var$SubstitutionTable)
    },
    2: {
        stateTable: new $22801616bd931ca3$export$79f7d93d790934ba($ef40c6dc80fd50a2$var$LigatureData),
        ligatureActions: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a($gfJaN$restructure.uint32)),
        components: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a($gfJaN$restructure.uint16)),
        ligatureList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a($gfJaN$restructure.uint16))
    },
    4: {
        lookupTable: new $22801616bd931ca3$export$8351f8c2ae2f103c
    },
    5: {
        stateTable: new $22801616bd931ca3$export$79f7d93d790934ba($ef40c6dc80fd50a2$var$InsertionData),
        insertionActions: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, new $22801616bd931ca3$export$c5af1eebc882e39a($gfJaN$restructure.uint16))
    }
});
let $ef40c6dc80fd50a2$var$Subtable = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint32,
    coverage: $gfJaN$restructure.uint24,
    type: $gfJaN$restructure.uint8,
    subFeatureFlags: $gfJaN$restructure.uint32,
    table: $ef40c6dc80fd50a2$var$SubtableData,
    padding: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, (t)=>t.length - t._currentOffset)
});
let $ef40c6dc80fd50a2$var$FeatureEntry = new $gfJaN$restructure.Struct({
    featureType: $gfJaN$restructure.uint16,
    featureSetting: $gfJaN$restructure.uint16,
    enableFlags: $gfJaN$restructure.uint32,
    disableFlags: $gfJaN$restructure.uint32
});
let $ef40c6dc80fd50a2$var$MorxChain = new $gfJaN$restructure.Struct({
    defaultFlags: $gfJaN$restructure.uint32,
    chainLength: $gfJaN$restructure.uint32,
    nFeatureEntries: $gfJaN$restructure.uint32,
    nSubtables: $gfJaN$restructure.uint32,
    features: new $gfJaN$restructure.Array($ef40c6dc80fd50a2$var$FeatureEntry, "nFeatureEntries"),
    subtables: new $gfJaN$restructure.Array($ef40c6dc80fd50a2$var$Subtable, "nSubtables")
});
var $ef40c6dc80fd50a2$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint16,
    unused: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    nChains: $gfJaN$restructure.uint32,
    chains: new $gfJaN$restructure.Array($ef40c6dc80fd50a2$var$MorxChain, "nChains")
});
let $ab24dea08b58a7cc$var$OpticalBounds = new $gfJaN$restructure.Struct({
    left: $gfJaN$restructure.int16,
    top: $gfJaN$restructure.int16,
    right: $gfJaN$restructure.int16,
    bottom: $gfJaN$restructure.int16
});
var $ab24dea08b58a7cc$export$2e2bcd8739ae039 = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.fixed32,
    format: $gfJaN$restructure.uint16,
    lookupTable: new $22801616bd931ca3$export$8351f8c2ae2f103c($ab24dea08b58a7cc$var$OpticalBounds)
});
let $5825c04ce8f7102d$var$tables = {};
var $5825c04ce8f7102d$export$2e2bcd8739ae039 = $5825c04ce8f7102d$var$tables;
$5825c04ce8f7102d$var$tables.cmap = $e4ae0436c91af89f$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.head = $55a60976afb7c261$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.hhea = $dde72b7b5b650596$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.hmtx = $a7c40184072c9a5b$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.maxp = $521197722369f691$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.name = $51a9f4feb3a3b2b1$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables["OS/2"] = $114ea85db469b435$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.post = $f93b30299e1ea0f5$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.fpgm = $873d79fea57d3161$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.loca = $83c4155666d50c37$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.prep = $b12598db7cdf7042$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables["cvt "] = $8fb09b0f473d61a0$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.glyf = $7707bdf21a3d89cc$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables["CFF "] = $f717432b360040c7$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables["CFF2"] = $f717432b360040c7$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.VORG = $8cb7ae73ed7aa7d8$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.EBLC = $035bb95c0cdb1f6d$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.CBLC = $5825c04ce8f7102d$var$tables.EBLC;
$5825c04ce8f7102d$var$tables.sbix = $73d13900b55a3c0c$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.COLR = $97f6b8be3a347a8f$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.CPAL = $16ca60ecbdee30ea$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.BASE = $7327e41706f9d5c7$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.GDEF = $7e48bbe9e5345664$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.GPOS = $b687332511a4da75$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.GSUB = $99ccad60b96f92fb$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.JSTF = $573d5042c76c4940$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.HVAR = $a5875b80d6087f61$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.DSIG = $4423bc1ac09bbbd1$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.gasp = $7b50e3f8d83263de$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.hdmx = $7bf92ec372cd2307$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.kern = $a3f544bcf76542d1$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.LTSH = $86687befb45925d0$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.PCLT = $91429006e51e0fe8$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.VDMX = $627850fc9deed59a$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.vhea = $65c33f5f068fc77f$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.vmtx = $597d739523b65bb3$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.avar = $35aa0c87d9c3d3a0$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.bsln = $3a5ca96d3e3aaf20$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.feat = $8d4241d96b2b0589$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.fvar = $a79cd5132b1cf476$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.gvar = $3f36f1a5e6989457$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.just = $0bd8fe7a6d1d9fb4$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.morx = $ef40c6dc80fd50a2$export$2e2bcd8739ae039;
$5825c04ce8f7102d$var$tables.opbd = $ab24dea08b58a7cc$export$2e2bcd8739ae039;
let $df50e1efe10a1247$var$TableEntry = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    checkSum: $gfJaN$restructure.uint32,
    offset: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, "void", {
        type: "global"
    }),
    length: $gfJaN$restructure.uint32
});
let $df50e1efe10a1247$var$Directory = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    numTables: $gfJaN$restructure.uint16,
    searchRange: $gfJaN$restructure.uint16,
    entrySelector: $gfJaN$restructure.uint16,
    rangeShift: $gfJaN$restructure.uint16,
    tables: new $gfJaN$restructure.Array($df50e1efe10a1247$var$TableEntry, "numTables")
});
$df50e1efe10a1247$var$Directory.process = function() {
    let tables = {};
    for (let table of this.tables)tables[table.tag] = table;
    this.tables = tables;
};
$df50e1efe10a1247$var$Directory.preEncode = function() {
    if (!Array.isArray(this.tables)) {
        let tables = [];
        for(let tag in this.tables){
            let table = this.tables[tag];
            if (table) tables.push({
                tag: tag,
                checkSum: 0,
                offset: new $gfJaN$restructure.VoidPointer($5825c04ce8f7102d$export$2e2bcd8739ae039[tag], table),
                length: $5825c04ce8f7102d$export$2e2bcd8739ae039[tag].size(table)
            });
        }
        this.tables = tables;
    }
    this.tag = "true";
    this.numTables = this.tables.length;
    let maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
    let maxPowerOf2 = Math.pow(2, maxExponentFor2);
    this.searchRange = maxPowerOf2 * 16;
    this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
    this.rangeShift = this.numTables * 16 - this.searchRange;
};
var $df50e1efe10a1247$export$2e2bcd8739ae039 = $df50e1efe10a1247$var$Directory;
function $66a5b9fb5318558a$export$2e0ae67339d5f1ac(arr, cmp) {
    let min = 0;
    let max = arr.length - 1;
    while(min <= max){
        let mid = min + max >> 1;
        let res = cmp(arr[mid]);
        if (res < 0) max = mid - 1;
        else if (res > 0) min = mid + 1;
        else return mid;
    }
    return -1;
}
function $66a5b9fb5318558a$export$d02631cccf789723(index, end) {
    let range1 = [];
    while(index < end)range1.push(index++);
    return range1;
}
const $66a5b9fb5318558a$export$3d28c1996ced1f14 = new TextDecoder("ascii");
// Based on https://github.com/niklasvh/base64-arraybuffer. MIT license.
const $66a5b9fb5318558a$var$CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const $66a5b9fb5318558a$var$LOOKUP = new Uint8Array(256);
for(let i = 0; i < $66a5b9fb5318558a$var$CHARS.length; i++)$66a5b9fb5318558a$var$LOOKUP[$66a5b9fb5318558a$var$CHARS.charCodeAt(i)] = i;
function $66a5b9fb5318558a$export$94fdf11bafc8de6b(base64) {
    let bufferLength = base64.length * 0.75;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    let bytes = new Uint8Array(bufferLength);
    let p = 0;
    for(let i1 = 0, len = base64.length; i1 < len; i1 += 4){
        let encoded1 = $66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i1)];
        let encoded2 = $66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i1 + 1)];
        let encoded3 = $66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i1 + 2)];
        let encoded4 = $66a5b9fb5318558a$var$LOOKUP[base64.charCodeAt(i1 + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
}
class $0d6e160064c86e50$export$2e2bcd8739ae039 {
    findSubtable(cmapTable, pairs) {
        for (let [platformID, encodingID] of pairs)for (let cmap of cmapTable.tables){
            if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
        }
        return null;
    }
    lookup(codepoint, variationSelector) {
        // If there is no Unicode cmap in this font, we need to re-encode
        // the codepoint in the encoding that the cmap supports.
        if (this.encoding) codepoint = this.encoding.get(codepoint) || codepoint;
        else if (variationSelector) {
            let gid = this.getVariationSelector(codepoint, variationSelector);
            if (gid) return gid;
        }
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return cmap.codeMap.get(codepoint) || 0;
            case 4:
                {
                    let min = 0;
                    let max = cmap.segCount - 1;
                    while(min <= max){
                        let mid = min + max >> 1;
                        if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
                        else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
                        else {
                            let rangeOffset = cmap.idRangeOffset.get(mid);
                            let gid;
                            if (rangeOffset === 0) gid = codepoint + cmap.idDelta.get(mid);
                            else {
                                let index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                                gid = cmap.glyphIndexArray.get(index) || 0;
                                if (gid !== 0) gid += cmap.idDelta.get(mid);
                            }
                            return gid & 0xffff;
                        }
                    }
                    return 0;
                }
            case 8:
                throw new Error("TODO: cmap format 8");
            case 6:
            case 10:
                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
            case 12:
            case 13:
                {
                    let min = 0;
                    let max = cmap.nGroups - 1;
                    while(min <= max){
                        let mid = min + max >> 1;
                        let group = cmap.groups.get(mid);
                        if (codepoint < group.startCharCode) max = mid - 1;
                        else if (codepoint > group.endCharCode) min = mid + 1;
                        else {
                            if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
                            else return group.glyphID;
                        }
                    }
                    return 0;
                }
            case 14:
                throw new Error("TODO: cmap format 14");
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    getVariationSelector(codepoint, variationSelector) {
        if (!this.uvs) return 0;
        let selectors = this.uvs.varSelectors.toArray();
        let i = $66a5b9fb5318558a$export$2e0ae67339d5f1ac(selectors, (x)=>variationSelector - x.varSelector);
        let sel = selectors[i];
        if (i !== -1 && sel.defaultUVS) i = $66a5b9fb5318558a$export$2e0ae67339d5f1ac(sel.defaultUVS, (x)=>codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0);
        if (i !== -1 && sel.nonDefaultUVS) {
            i = $66a5b9fb5318558a$export$2e0ae67339d5f1ac(sel.nonDefaultUVS, (x)=>codepoint - x.unicodeValue);
            if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
        }
        return 0;
    }
    getCharacterSet() {
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return $66a5b9fb5318558a$export$d02631cccf789723(0, cmap.codeMap.length);
            case 4:
                {
                    let res = [];
                    let endCodes = cmap.endCode.toArray();
                    for(let i = 0; i < endCodes.length; i++){
                        let tail = endCodes[i] + 1;
                        let start = cmap.startCode.get(i);
                        res.push(...$66a5b9fb5318558a$export$d02631cccf789723(start, tail));
                    }
                    return res;
                }
            case 8:
                throw new Error("TODO: cmap format 8");
            case 6:
            case 10:
                return $66a5b9fb5318558a$export$d02631cccf789723(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
            case 12:
            case 13:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())res.push(...$66a5b9fb5318558a$export$d02631cccf789723(group.startCharCode, group.endCharCode + 1));
                    return res;
                }
            case 14:
                throw new Error("TODO: cmap format 14");
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    codePointsForGlyph(gid) {
        let cmap = this.cmap;
        switch(cmap.version){
            case 0:
                {
                    let res = [];
                    for(let i = 0; i < 256; i++)if (cmap.codeMap.get(i) === gid) res.push(i);
                    return res;
                }
            case 4:
                {
                    let res = [];
                    for(let i = 0; i < cmap.segCount; i++){
                        let end = cmap.endCode.get(i);
                        let start = cmap.startCode.get(i);
                        let rangeOffset = cmap.idRangeOffset.get(i);
                        let delta = cmap.idDelta.get(i);
                        for(var c = start; c <= end; c++){
                            let g = 0;
                            if (rangeOffset === 0) g = c + delta;
                            else {
                                let index = rangeOffset / 2 + (c - start) - (cmap.segCount - i);
                                g = cmap.glyphIndexArray.get(index) || 0;
                                if (g !== 0) g += delta;
                            }
                            if (g === gid) res.push(c);
                        }
                    }
                    return res;
                }
            case 12:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) res.push(group.startCharCode + (gid - group.glyphID));
                    return res;
                }
            case 13:
                {
                    let res = [];
                    for (let group of cmap.groups.toArray())if (gid === group.glyphID) res.push(...$66a5b9fb5318558a$export$d02631cccf789723(group.startCharCode, group.endCharCode + 1));
                    return res;
                }
            default:
                throw new Error(`Unknown cmap format ${cmap.version}`);
        }
    }
    constructor(cmapTable){
        // Attempt to find a Unicode cmap first
        this.encoding = null;
        this.cmap = this.findSubtable(cmapTable, [
            // 32-bit subtables
            [
                3,
                10
            ],
            [
                0,
                6
            ],
            [
                0,
                4
            ],
            // 16-bit subtables
            [
                3,
                1
            ],
            [
                0,
                3
            ],
            [
                0,
                2
            ],
            [
                0,
                1
            ],
            [
                0,
                0
            ]
        ]);
        // If not unicode cmap was found, take the first table with a supported encoding.
        if (!this.cmap) for (let cmap of cmapTable.tables){
            let encoding = $e2613b812f052cbe$export$badc544e0651b6b1(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
            let mapping = $e2613b812f052cbe$export$1dceb3c14ed68bee(encoding);
            if (mapping) {
                this.cmap = cmap.table;
                this.encoding = mapping;
            }
        }
        if (!this.cmap) throw new Error("Could not find a supported cmap table");
        this.uvs = this.findSubtable(cmapTable, [
            [
                0,
                5
            ]
        ]);
        if (this.uvs && this.uvs.version !== 14) this.uvs = null;
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0d6e160064c86e50$export$2e2bcd8739ae039.prototype, "getCharacterSet", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0d6e160064c86e50$export$2e2bcd8739ae039.prototype, "codePointsForGlyph", null);
class $4646d52c2a559cdb$export$2e2bcd8739ae039 {
    process(glyphs, positions) {
        for(let glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++){
            let left = glyphs[glyphIndex].id;
            let right = glyphs[glyphIndex + 1].id;
            positions[glyphIndex].xAdvance += this.getKerning(left, right);
        }
    }
    getKerning(left, right) {
        let res = 0;
        for (let table of this.kern.tables){
            if (table.coverage.crossStream) continue;
            switch(table.version){
                case 0:
                    if (!table.coverage.horizontal) continue;
                    break;
                case 1:
                    if (table.coverage.vertical || table.coverage.variation) continue;
                    break;
                default:
                    throw new Error(`Unsupported kerning table version ${table.version}`);
            }
            let val = 0;
            let s = table.subtable;
            switch(table.format){
                case 0:
                    let pairIdx = $66a5b9fb5318558a$export$2e0ae67339d5f1ac(s.pairs, function(pair) {
                        return left - pair.left || right - pair.right;
                    });
                    if (pairIdx >= 0) val = s.pairs[pairIdx].value;
                    break;
                case 2:
                    let leftOffset = 0, rightOffset = 0;
                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                    else leftOffset = s.array.off;
                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                    let index = (leftOffset + rightOffset - s.array.off) / 2;
                    val = s.array.values.get(index);
                    break;
                case 3:
                    if (left >= s.glyphCount || right >= s.glyphCount) return 0;
                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                    break;
                default:
                    throw new Error(`Unsupported kerning sub-table format ${table.format}`);
            }
            // Microsoft supports the override flag, which resets the result
            // Otherwise, the sum of the results from all subtables is returned
            if (table.coverage.override) res = val;
            else res += val;
        }
        return res;
    }
    constructor(font){
        this.kern = font.kern;
    }
}
class $a57a26817cd35108$export$2e2bcd8739ae039 {
    positionGlyphs(glyphs, positions) {
        // find each base + mark cluster, and position the marks relative to the base
        let clusterStart = 0;
        let clusterEnd = 0;
        for(let index = 0; index < glyphs.length; index++){
            let glyph = glyphs[index];
            if (glyph.isMark) clusterEnd = index;
            else {
                if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                clusterStart = clusterEnd = index;
            }
        }
        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
        return positions;
    }
    positionCluster(glyphs, positions, clusterStart, clusterEnd) {
        let base = glyphs[clusterStart];
        let baseBox = base.cbox.copy();
        // adjust bounding box for ligature glyphs
        if (base.codePoints.length > 1) baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
        let xOffset = -positions[clusterStart].xAdvance;
        let yOffset = 0;
        let yGap = this.font.unitsPerEm / 16;
        // position each of the mark glyphs relative to the base glyph
        for(let index = clusterStart + 1; index <= clusterEnd; index++){
            let mark = glyphs[index];
            let markBox = mark.cbox;
            let position = positions[index];
            let combiningClass = this.getCombiningClass(mark.codePoints[0]);
            if (combiningClass !== "Not_Reordered") {
                position.xOffset = position.yOffset = 0;
                // x positioning
                switch(combiningClass){
                    case "Double_Above":
                    case "Double_Below":
                        // LTR. TODO: RTL support.
                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                        break;
                    case "Attached_Below_Left":
                    case "Below_Left":
                    case "Above_Left":
                        // left align
                        position.xOffset += baseBox.minX - markBox.minX;
                        break;
                    case "Attached_Above_Right":
                    case "Below_Right":
                    case "Above_Right":
                        // right align
                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                        break;
                    default:
                        // center align
                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                }
                // y positioning
                switch(combiningClass){
                    case "Double_Below":
                    case "Below_Left":
                    case "Below":
                    case "Below_Right":
                    case "Attached_Below_Left":
                    case "Attached_Below":
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === "Attached_Below_Left" || combiningClass === "Attached_Below") baseBox.minY += yGap;
                        position.yOffset = -baseBox.minY - markBox.maxY;
                        baseBox.minY += markBox.height;
                        break;
                    case "Double_Above":
                    case "Above_Left":
                    case "Above":
                    case "Above_Right":
                    case "Attached_Above":
                    case "Attached_Above_Right":
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === "Attached_Above" || combiningClass === "Attached_Above_Right") baseBox.maxY += yGap;
                        position.yOffset = baseBox.maxY - markBox.minY;
                        baseBox.maxY += markBox.height;
                        break;
                }
                position.xAdvance = position.yAdvance = 0;
                position.xOffset += xOffset;
                position.yOffset += yOffset;
            } else {
                xOffset -= position.xAdvance;
                yOffset -= position.yAdvance;
            }
        }
        return;
    }
    getCombiningClass(codePoint) {
        let combiningClass = (0, $gfJaN$unicodeproperties.getCombiningClass)(codePoint);
        // Thai / Lao need some per-character work
        if ((codePoint & -256) === 0x0e00) {
            if (combiningClass === "Not_Reordered") switch(codePoint){
                case 0x0e31:
                case 0x0e34:
                case 0x0e35:
                case 0x0e36:
                case 0x0e37:
                case 0x0e47:
                case 0x0e4c:
                case 0x0e3d:
                case 0x0e4e:
                    return "Above_Right";
                case 0x0eb1:
                case 0x0eb4:
                case 0x0eb5:
                case 0x0eb6:
                case 0x0eb7:
                case 0x0ebb:
                case 0x0ecc:
                case 0x0ecd:
                    return "Above";
                case 0x0ebc:
                    return "Below";
            }
            else if (codePoint === 0x0e3a) return "Below_Right";
        }
        switch(combiningClass){
            // Hebrew
            case "CCC10":
            case "CCC11":
            case "CCC12":
            case "CCC13":
            case "CCC14":
            case "CCC15":
            case "CCC16":
            case "CCC17":
            case "CCC18":
            case "CCC20":
            case "CCC22":
                return "Below";
            case "CCC23":
                return "Attached_Above";
            case "CCC24":
                return "Above_Right";
            case "CCC25":
            case "CCC19":
                return "Above_Left";
            case "CCC26":
                return "Above";
            case "CCC21":
                break;
            // Arabic and Syriac
            case "CCC27":
            case "CCC28":
            case "CCC30":
            case "CCC31":
            case "CCC33":
            case "CCC34":
            case "CCC35":
            case "CCC36":
                return "Above";
            case "CCC29":
            case "CCC32":
                return "Below";
            // Thai
            case "CCC103":
                return "Below_Right";
            case "CCC107":
                return "Above_Right";
            // Lao
            case "CCC118":
                return "Below";
            case "CCC122":
                return "Above";
            // Tibetan
            case "CCC129":
            case "CCC132":
                return "Below";
            case "CCC130":
                return "Above";
        }
        return combiningClass;
    }
    constructor(font){
        this.font = font;
    }
}
class $0e2da1c4ce69e8ad$export$2e2bcd8739ae039 {
    /**
   * The width of the bounding box
   * @type {number}
   */ get width() {
        return this.maxX - this.minX;
    }
    /**
   * The height of the bounding box
   * @type {number}
   */ get height() {
        return this.maxY - this.minY;
    }
    addPoint(x, y) {
        if (Math.abs(x) !== Infinity) {
            if (x < this.minX) this.minX = x;
            if (x > this.maxX) this.maxX = x;
        }
        if (Math.abs(y) !== Infinity) {
            if (y < this.minY) this.minY = y;
            if (y > this.maxY) this.maxY = y;
        }
    }
    copy() {
        return new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039(this.minX, this.minY, this.maxX, this.maxY);
    }
    constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /**
     * The minimum X position in the bounding box
     * @type {number}
     */ this.minX = minX;
        /**
     * The minimum Y position in the bounding box
     * @type {number}
     */ this.minY = minY;
        /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */ this.maxX = maxX;
        /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */ this.maxY = maxY;
    }
}
// This maps the Unicode Script property to an OpenType script tag
// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
const $e38a1a895f6aeb54$var$UNICODE_SCRIPTS = {
    Caucasian_Albanian: "aghb",
    Arabic: "arab",
    Imperial_Aramaic: "armi",
    Armenian: "armn",
    Avestan: "avst",
    Balinese: "bali",
    Bamum: "bamu",
    Bassa_Vah: "bass",
    Batak: "batk",
    Bengali: [
        "bng2",
        "beng"
    ],
    Bopomofo: "bopo",
    Brahmi: "brah",
    Braille: "brai",
    Buginese: "bugi",
    Buhid: "buhd",
    Chakma: "cakm",
    Canadian_Aboriginal: "cans",
    Carian: "cari",
    Cham: "cham",
    Cherokee: "cher",
    Coptic: "copt",
    Cypriot: "cprt",
    Cyrillic: "cyrl",
    Devanagari: [
        "dev2",
        "deva"
    ],
    Deseret: "dsrt",
    Duployan: "dupl",
    Egyptian_Hieroglyphs: "egyp",
    Elbasan: "elba",
    Ethiopic: "ethi",
    Georgian: "geor",
    Glagolitic: "glag",
    Gothic: "goth",
    Grantha: "gran",
    Greek: "grek",
    Gujarati: [
        "gjr2",
        "gujr"
    ],
    Gurmukhi: [
        "gur2",
        "guru"
    ],
    Hangul: "hang",
    Han: "hani",
    Hanunoo: "hano",
    Hebrew: "hebr",
    Hiragana: "hira",
    Pahawh_Hmong: "hmng",
    Katakana_Or_Hiragana: "hrkt",
    Old_Italic: "ital",
    Javanese: "java",
    Kayah_Li: "kali",
    Katakana: "kana",
    Kharoshthi: "khar",
    Khmer: "khmr",
    Khojki: "khoj",
    Kannada: [
        "knd2",
        "knda"
    ],
    Kaithi: "kthi",
    Tai_Tham: "lana",
    Lao: "lao ",
    Latin: "latn",
    Lepcha: "lepc",
    Limbu: "limb",
    Linear_A: "lina",
    Linear_B: "linb",
    Lisu: "lisu",
    Lycian: "lyci",
    Lydian: "lydi",
    Mahajani: "mahj",
    Mandaic: "mand",
    Manichaean: "mani",
    Mende_Kikakui: "mend",
    Meroitic_Cursive: "merc",
    Meroitic_Hieroglyphs: "mero",
    Malayalam: [
        "mlm2",
        "mlym"
    ],
    Modi: "modi",
    Mongolian: "mong",
    Mro: "mroo",
    Meetei_Mayek: "mtei",
    Myanmar: [
        "mym2",
        "mymr"
    ],
    Old_North_Arabian: "narb",
    Nabataean: "nbat",
    Nko: "nko ",
    Ogham: "ogam",
    Ol_Chiki: "olck",
    Old_Turkic: "orkh",
    Oriya: [
        "ory2",
        "orya"
    ],
    Osmanya: "osma",
    Palmyrene: "palm",
    Pau_Cin_Hau: "pauc",
    Old_Permic: "perm",
    Phags_Pa: "phag",
    Inscriptional_Pahlavi: "phli",
    Psalter_Pahlavi: "phlp",
    Phoenician: "phnx",
    Miao: "plrd",
    Inscriptional_Parthian: "prti",
    Rejang: "rjng",
    Runic: "runr",
    Samaritan: "samr",
    Old_South_Arabian: "sarb",
    Saurashtra: "saur",
    Shavian: "shaw",
    Sharada: "shrd",
    Siddham: "sidd",
    Khudawadi: "sind",
    Sinhala: "sinh",
    Sora_Sompeng: "sora",
    Sundanese: "sund",
    Syloti_Nagri: "sylo",
    Syriac: "syrc",
    Tagbanwa: "tagb",
    Takri: "takr",
    Tai_Le: "tale",
    New_Tai_Lue: "talu",
    Tamil: [
        "tml2",
        "taml"
    ],
    Tai_Viet: "tavt",
    Telugu: [
        "tel2",
        "telu"
    ],
    Tifinagh: "tfng",
    Tagalog: "tglg",
    Thaana: "thaa",
    Thai: "thai",
    Tibetan: "tibt",
    Tirhuta: "tirh",
    Ugaritic: "ugar",
    Vai: "vai ",
    Warang_Citi: "wara",
    Old_Persian: "xpeo",
    Cuneiform: "xsux",
    Yi: "yi  ",
    Inherited: "zinh",
    Common: "zyyy",
    Unknown: "zzzz"
};
const $e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS = {};
for(let script in $e38a1a895f6aeb54$var$UNICODE_SCRIPTS){
    let tag = $e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script];
    if (Array.isArray(tag)) for (let t of tag)$e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS[t] = script;
    else $e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS[tag] = script;
}
function $e38a1a895f6aeb54$export$b32f0b5f69d65e51(script1) {
    return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script1];
}
function $e38a1a895f6aeb54$export$ce50e82f12a827a4(tag) {
    return $e38a1a895f6aeb54$var$OPENTYPE_SCRIPTS[tag];
}
function $e38a1a895f6aeb54$export$e5cb25e204fb8450(string) {
    let len = string.length;
    let idx = 0;
    while(idx < len){
        let code = string.charCodeAt(idx++);
        // Check if this is a high surrogate
        if (0xd800 <= code && code <= 0xdbff && idx < len) {
            let next = string.charCodeAt(idx);
            // Check if this is a low surrogate
            if (0xdc00 <= next && next <= 0xdfff) {
                idx++;
                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
            }
        }
        let script2 = (0, $gfJaN$unicodeproperties.getScript)(code);
        if (script2 !== "Common" && script2 !== "Inherited" && script2 !== "Unknown") return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script2];
    }
    return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS.Unknown;
}
function $e38a1a895f6aeb54$export$16fab0757cfc223d(codePoints) {
    for(let i = 0; i < codePoints.length; i++){
        let codePoint = codePoints[i];
        let script3 = (0, $gfJaN$unicodeproperties.getScript)(codePoint);
        if (script3 !== "Common" && script3 !== "Inherited" && script3 !== "Unknown") return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS[script3];
    }
    return $e38a1a895f6aeb54$var$UNICODE_SCRIPTS.Unknown;
}
// The scripts in this map are written from right to left
const $e38a1a895f6aeb54$var$RTL = {
    arab: true,
    hebr: true,
    syrc: true,
    thaa: true,
    cprt: true,
    khar: true,
    phnx: true,
    "nko ": true,
    lydi: true,
    avst: true,
    armi: true,
    phli: true,
    prti: true,
    sarb: true,
    orkh: true,
    samr: true,
    mand: true,
    merc: true,
    mero: true,
    // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
    mani: true,
    mend: true,
    nbat: true,
    narb: true,
    palm: true,
    phlp: true // Psalter Pahlavi
};
function $e38a1a895f6aeb54$export$9fddb9d0dd7d8a54(script4) {
    if ($e38a1a895f6aeb54$var$RTL[script4]) return "rtl";
    return "ltr";
}
class $b19c79ec7a94fa39$export$2e2bcd8739ae039 {
    /**
   * The total advance width of the run.
   * @type {number}
   */ get advanceWidth() {
        let width = 0;
        for (let position of this.positions)width += position.xAdvance;
        return width;
    }
    /**
  * The total advance height of the run.
  * @type {number}
  */ get advanceHeight() {
        let height = 0;
        for (let position of this.positions)height += position.yAdvance;
        return height;
    }
    /**
  * The bounding box containing all glyphs in the run.
  * @type {BBox}
  */ get bbox() {
        let bbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
        let x = 0;
        let y = 0;
        for(let index = 0; index < this.glyphs.length; index++){
            let glyph = this.glyphs[index];
            let p = this.positions[index];
            let b = glyph.bbox;
            bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
            bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
            x += p.xAdvance;
            y += p.yAdvance;
        }
        return bbox;
    }
    constructor(glyphs, features, script, language, direction){
        /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */ this.glyphs = glyphs;
        /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */ this.positions = null;
        /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */ this.script = script;
        /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */ this.language = language || null;
        /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */ this.direction = direction || $e38a1a895f6aeb54$export$9fddb9d0dd7d8a54(script);
        /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */ this.features = {};
        // Convert features to an object
        if (Array.isArray(features)) for (let tag of features)this.features[tag] = true;
        else if (typeof features === "object") this.features = features;
    }
}
class $9195cf1266c12ea5$export$2e2bcd8739ae039 {
    constructor(xAdvance = 0, yAdvance = 0, xOffset = 0, yOffset = 0){
        /**
     * The amount to move the virtual pen in the X direction after rendering this glyph.
     * @type {number}
     */ this.xAdvance = xAdvance;
        /**
     * The amount to move the virtual pen in the Y direction after rendering this glyph.
     * @type {number}
     */ this.yAdvance = yAdvance;
        /**
     * The offset from the pen position in the X direction at which to render this glyph.
     * @type {number}
     */ this.xOffset = xOffset;
        /**
     * The offset from the pen position in the Y direction at which to render this glyph.
     * @type {number}
     */ this.yOffset = yOffset;
    }
}
// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
const $2b7f887ebcb5888a$var$features = {
    allTypographicFeatures: {
        code: 0,
        exclusive: false,
        allTypeFeatures: 0
    },
    ligatures: {
        code: 1,
        exclusive: false,
        requiredLigatures: 0,
        commonLigatures: 2,
        rareLigatures: 4,
        // logos: 6
        rebusPictures: 8,
        diphthongLigatures: 10,
        squaredLigatures: 12,
        abbrevSquaredLigatures: 14,
        symbolLigatures: 16,
        contextualLigatures: 18,
        historicalLigatures: 20
    },
    cursiveConnection: {
        code: 2,
        exclusive: true,
        unconnected: 0,
        partiallyConnected: 1,
        cursive: 2
    },
    letterCase: {
        code: 3,
        exclusive: true
    },
    // upperAndLowerCase: 0          # deprecated
    // allCaps: 1                    # deprecated
    // allLowerCase: 2               # deprecated
    // smallCaps: 3                  # deprecated
    // initialCaps: 4                # deprecated
    // initialCapsAndSmallCaps: 5    # deprecated
    verticalSubstitution: {
        code: 4,
        exclusive: false,
        substituteVerticalForms: 0
    },
    linguisticRearrangement: {
        code: 5,
        exclusive: false,
        linguisticRearrangement: 0
    },
    numberSpacing: {
        code: 6,
        exclusive: true,
        monospacedNumbers: 0,
        proportionalNumbers: 1,
        thirdWidthNumbers: 2,
        quarterWidthNumbers: 3
    },
    smartSwash: {
        code: 8,
        exclusive: false,
        wordInitialSwashes: 0,
        wordFinalSwashes: 2,
        // lineInitialSwashes: 4
        // lineFinalSwashes: 6
        nonFinalSwashes: 8
    },
    diacritics: {
        code: 9,
        exclusive: true,
        showDiacritics: 0,
        hideDiacritics: 1,
        decomposeDiacritics: 2
    },
    verticalPosition: {
        code: 10,
        exclusive: true,
        normalPosition: 0,
        superiors: 1,
        inferiors: 2,
        ordinals: 3,
        scientificInferiors: 4
    },
    fractions: {
        code: 11,
        exclusive: true,
        noFractions: 0,
        verticalFractions: 1,
        diagonalFractions: 2
    },
    overlappingCharacters: {
        code: 13,
        exclusive: false,
        preventOverlap: 0
    },
    typographicExtras: {
        code: 14,
        exclusive: false,
        // hyphensToEmDash: 0
        // hyphenToEnDash: 2
        slashedZero: 4
    },
    // formInterrobang: 6
    // smartQuotes: 8
    // periodsToEllipsis: 10
    mathematicalExtras: {
        code: 15,
        exclusive: false,
        // hyphenToMinus: 0
        // asteristoMultiply: 2
        // slashToDivide: 4
        // inequalityLigatures: 6
        // exponents: 8
        mathematicalGreek: 10
    },
    ornamentSets: {
        code: 16,
        exclusive: true,
        noOrnaments: 0,
        dingbats: 1,
        piCharacters: 2,
        fleurons: 3,
        decorativeBorders: 4,
        internationalSymbols: 5,
        mathSymbols: 6
    },
    characterAlternatives: {
        code: 17,
        exclusive: true,
        noAlternates: 0
    },
    // user defined options
    designComplexity: {
        code: 18,
        exclusive: true,
        designLevel1: 0,
        designLevel2: 1,
        designLevel3: 2,
        designLevel4: 3,
        designLevel5: 4
    },
    styleOptions: {
        code: 19,
        exclusive: true,
        noStyleOptions: 0,
        displayText: 1,
        engravedText: 2,
        illuminatedCaps: 3,
        titlingCaps: 4,
        tallCaps: 5
    },
    characterShape: {
        code: 20,
        exclusive: true,
        traditionalCharacters: 0,
        simplifiedCharacters: 1,
        JIS1978Characters: 2,
        JIS1983Characters: 3,
        JIS1990Characters: 4,
        traditionalAltOne: 5,
        traditionalAltTwo: 6,
        traditionalAltThree: 7,
        traditionalAltFour: 8,
        traditionalAltFive: 9,
        expertCharacters: 10,
        JIS2004Characters: 11,
        hojoCharacters: 12,
        NLCCharacters: 13,
        traditionalNamesCharacters: 14
    },
    numberCase: {
        code: 21,
        exclusive: true,
        lowerCaseNumbers: 0,
        upperCaseNumbers: 1
    },
    textSpacing: {
        code: 22,
        exclusive: true,
        proportionalText: 0,
        monospacedText: 1,
        halfWidthText: 2,
        thirdWidthText: 3,
        quarterWidthText: 4,
        altProportionalText: 5,
        altHalfWidthText: 6
    },
    transliteration: {
        code: 23,
        exclusive: true,
        noTransliteration: 0
    },
    // hanjaToHangul: 1
    // hiraganaToKatakana: 2
    // katakanaToHiragana: 3
    // kanaToRomanization: 4
    // romanizationToHiragana: 5
    // romanizationToKatakana: 6
    // hanjaToHangulAltOne: 7
    // hanjaToHangulAltTwo: 8
    // hanjaToHangulAltThree: 9
    annotation: {
        code: 24,
        exclusive: true,
        noAnnotation: 0,
        boxAnnotation: 1,
        roundedBoxAnnotation: 2,
        circleAnnotation: 3,
        invertedCircleAnnotation: 4,
        parenthesisAnnotation: 5,
        periodAnnotation: 6,
        romanNumeralAnnotation: 7,
        diamondAnnotation: 8,
        invertedBoxAnnotation: 9,
        invertedRoundedBoxAnnotation: 10
    },
    kanaSpacing: {
        code: 25,
        exclusive: true,
        fullWidthKana: 0,
        proportionalKana: 1
    },
    ideographicSpacing: {
        code: 26,
        exclusive: true,
        fullWidthIdeographs: 0,
        proportionalIdeographs: 1,
        halfWidthIdeographs: 2
    },
    unicodeDecomposition: {
        code: 27,
        exclusive: false,
        canonicalComposition: 0,
        compatibilityComposition: 2,
        transcodingComposition: 4
    },
    rubyKana: {
        code: 28,
        exclusive: false,
        // noRubyKana: 0     # deprecated - use rubyKanaOff instead
        // rubyKana: 1     # deprecated - use rubyKanaOn instead
        rubyKana: 2
    },
    CJKSymbolAlternatives: {
        code: 29,
        exclusive: true,
        noCJKSymbolAlternatives: 0,
        CJKSymbolAltOne: 1,
        CJKSymbolAltTwo: 2,
        CJKSymbolAltThree: 3,
        CJKSymbolAltFour: 4,
        CJKSymbolAltFive: 5
    },
    ideographicAlternatives: {
        code: 30,
        exclusive: true,
        noIdeographicAlternatives: 0,
        ideographicAltOne: 1,
        ideographicAltTwo: 2,
        ideographicAltThree: 3,
        ideographicAltFour: 4,
        ideographicAltFive: 5
    },
    CJKVerticalRomanPlacement: {
        code: 31,
        exclusive: true,
        CJKVerticalRomanCentered: 0,
        CJKVerticalRomanHBaseline: 1
    },
    italicCJKRoman: {
        code: 32,
        exclusive: false,
        // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
        // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
        CJKItalicRoman: 2
    },
    caseSensitiveLayout: {
        code: 33,
        exclusive: false,
        caseSensitiveLayout: 0,
        caseSensitiveSpacing: 2
    },
    alternateKana: {
        code: 34,
        exclusive: false,
        alternateHorizKana: 0,
        alternateVertKana: 2
    },
    stylisticAlternatives: {
        code: 35,
        exclusive: false,
        noStylisticAlternates: 0,
        stylisticAltOne: 2,
        stylisticAltTwo: 4,
        stylisticAltThree: 6,
        stylisticAltFour: 8,
        stylisticAltFive: 10,
        stylisticAltSix: 12,
        stylisticAltSeven: 14,
        stylisticAltEight: 16,
        stylisticAltNine: 18,
        stylisticAltTen: 20,
        stylisticAltEleven: 22,
        stylisticAltTwelve: 24,
        stylisticAltThirteen: 26,
        stylisticAltFourteen: 28,
        stylisticAltFifteen: 30,
        stylisticAltSixteen: 32,
        stylisticAltSeventeen: 34,
        stylisticAltEighteen: 36,
        stylisticAltNineteen: 38,
        stylisticAltTwenty: 40
    },
    contextualAlternates: {
        code: 36,
        exclusive: false,
        contextualAlternates: 0,
        swashAlternates: 2,
        contextualSwashAlternates: 4
    },
    lowerCase: {
        code: 37,
        exclusive: true,
        defaultLowerCase: 0,
        lowerCaseSmallCaps: 1,
        lowerCasePetiteCaps: 2
    },
    upperCase: {
        code: 38,
        exclusive: true,
        defaultUpperCase: 0,
        upperCaseSmallCaps: 1,
        upperCasePetiteCaps: 2
    },
    languageTag: {
        code: 39,
        exclusive: true
    },
    CJKRomanSpacing: {
        code: 103,
        exclusive: true,
        halfWidthCJKRoman: 0,
        proportionalCJKRoman: 1,
        defaultCJKRoman: 2,
        fullWidthCJKRoman: 3
    }
};
const $2b7f887ebcb5888a$var$feature = (name, selector)=>[
        $2b7f887ebcb5888a$var$features[name].code,
        $2b7f887ebcb5888a$var$features[name][selector]
    ];
const $2b7f887ebcb5888a$var$OTMapping = {
    rlig: $2b7f887ebcb5888a$var$feature("ligatures", "requiredLigatures"),
    clig: $2b7f887ebcb5888a$var$feature("ligatures", "contextualLigatures"),
    dlig: $2b7f887ebcb5888a$var$feature("ligatures", "rareLigatures"),
    hlig: $2b7f887ebcb5888a$var$feature("ligatures", "historicalLigatures"),
    liga: $2b7f887ebcb5888a$var$feature("ligatures", "commonLigatures"),
    hist: $2b7f887ebcb5888a$var$feature("ligatures", "historicalLigatures"),
    smcp: $2b7f887ebcb5888a$var$feature("lowerCase", "lowerCaseSmallCaps"),
    pcap: $2b7f887ebcb5888a$var$feature("lowerCase", "lowerCasePetiteCaps"),
    frac: $2b7f887ebcb5888a$var$feature("fractions", "diagonalFractions"),
    dnom: $2b7f887ebcb5888a$var$feature("fractions", "diagonalFractions"),
    numr: $2b7f887ebcb5888a$var$feature("fractions", "diagonalFractions"),
    afrc: $2b7f887ebcb5888a$var$feature("fractions", "verticalFractions"),
    // aalt
    // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
    // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
    // unic, vatu, vhal, vjmo, vpal, vrt2
    // dist -> trak table?
    // kern, vkrn -> kern table
    // lfbd + opbd + rtbd -> opbd table?
    // mark, mkmk -> acnt table?
    // locl -> languageTag + ltag table
    case: $2b7f887ebcb5888a$var$feature("caseSensitiveLayout", "caseSensitiveLayout"),
    ccmp: $2b7f887ebcb5888a$var$feature("unicodeDecomposition", "canonicalComposition"),
    cpct: $2b7f887ebcb5888a$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
    valt: $2b7f887ebcb5888a$var$feature("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
    swsh: $2b7f887ebcb5888a$var$feature("contextualAlternates", "swashAlternates"),
    cswh: $2b7f887ebcb5888a$var$feature("contextualAlternates", "contextualSwashAlternates"),
    curs: $2b7f887ebcb5888a$var$feature("cursiveConnection", "cursive"),
    c2pc: $2b7f887ebcb5888a$var$feature("upperCase", "upperCasePetiteCaps"),
    c2sc: $2b7f887ebcb5888a$var$feature("upperCase", "upperCaseSmallCaps"),
    init: $2b7f887ebcb5888a$var$feature("smartSwash", "wordInitialSwashes"),
    fin2: $2b7f887ebcb5888a$var$feature("smartSwash", "wordFinalSwashes"),
    medi: $2b7f887ebcb5888a$var$feature("smartSwash", "nonFinalSwashes"),
    med2: $2b7f887ebcb5888a$var$feature("smartSwash", "nonFinalSwashes"),
    fin3: $2b7f887ebcb5888a$var$feature("smartSwash", "wordFinalSwashes"),
    fina: $2b7f887ebcb5888a$var$feature("smartSwash", "wordFinalSwashes"),
    pkna: $2b7f887ebcb5888a$var$feature("kanaSpacing", "proportionalKana"),
    half: $2b7f887ebcb5888a$var$feature("textSpacing", "halfWidthText"),
    halt: $2b7f887ebcb5888a$var$feature("textSpacing", "altHalfWidthText"),
    hkna: $2b7f887ebcb5888a$var$feature("alternateKana", "alternateHorizKana"),
    vkna: $2b7f887ebcb5888a$var$feature("alternateKana", "alternateVertKana"),
    // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
    ital: $2b7f887ebcb5888a$var$feature("italicCJKRoman", "CJKItalicRoman"),
    lnum: $2b7f887ebcb5888a$var$feature("numberCase", "upperCaseNumbers"),
    onum: $2b7f887ebcb5888a$var$feature("numberCase", "lowerCaseNumbers"),
    mgrk: $2b7f887ebcb5888a$var$feature("mathematicalExtras", "mathematicalGreek"),
    // nalt: not enough info. what type of annotation?
    // ornm: ditto, which ornament style?
    calt: $2b7f887ebcb5888a$var$feature("contextualAlternates", "contextualAlternates"),
    vrt2: $2b7f887ebcb5888a$var$feature("verticalSubstitution", "substituteVerticalForms"),
    vert: $2b7f887ebcb5888a$var$feature("verticalSubstitution", "substituteVerticalForms"),
    tnum: $2b7f887ebcb5888a$var$feature("numberSpacing", "monospacedNumbers"),
    pnum: $2b7f887ebcb5888a$var$feature("numberSpacing", "proportionalNumbers"),
    sups: $2b7f887ebcb5888a$var$feature("verticalPosition", "superiors"),
    subs: $2b7f887ebcb5888a$var$feature("verticalPosition", "inferiors"),
    ordn: $2b7f887ebcb5888a$var$feature("verticalPosition", "ordinals"),
    pwid: $2b7f887ebcb5888a$var$feature("textSpacing", "proportionalText"),
    hwid: $2b7f887ebcb5888a$var$feature("textSpacing", "halfWidthText"),
    qwid: $2b7f887ebcb5888a$var$feature("textSpacing", "quarterWidthText"),
    twid: $2b7f887ebcb5888a$var$feature("textSpacing", "thirdWidthText"),
    fwid: $2b7f887ebcb5888a$var$feature("textSpacing", "proportionalText"),
    palt: $2b7f887ebcb5888a$var$feature("textSpacing", "altProportionalText"),
    trad: $2b7f887ebcb5888a$var$feature("characterShape", "traditionalCharacters"),
    smpl: $2b7f887ebcb5888a$var$feature("characterShape", "simplifiedCharacters"),
    jp78: $2b7f887ebcb5888a$var$feature("characterShape", "JIS1978Characters"),
    jp83: $2b7f887ebcb5888a$var$feature("characterShape", "JIS1983Characters"),
    jp90: $2b7f887ebcb5888a$var$feature("characterShape", "JIS1990Characters"),
    jp04: $2b7f887ebcb5888a$var$feature("characterShape", "JIS2004Characters"),
    expt: $2b7f887ebcb5888a$var$feature("characterShape", "expertCharacters"),
    hojo: $2b7f887ebcb5888a$var$feature("characterShape", "hojoCharacters"),
    nlck: $2b7f887ebcb5888a$var$feature("characterShape", "NLCCharacters"),
    tnam: $2b7f887ebcb5888a$var$feature("characterShape", "traditionalNamesCharacters"),
    ruby: $2b7f887ebcb5888a$var$feature("rubyKana", "rubyKana"),
    titl: $2b7f887ebcb5888a$var$feature("styleOptions", "titlingCaps"),
    zero: $2b7f887ebcb5888a$var$feature("typographicExtras", "slashedZero"),
    ss01: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltOne"),
    ss02: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltTwo"),
    ss03: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltThree"),
    ss04: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltFour"),
    ss05: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltFive"),
    ss06: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltSix"),
    ss07: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltSeven"),
    ss08: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltEight"),
    ss09: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltNine"),
    ss10: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltTen"),
    ss11: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltEleven"),
    ss12: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltTwelve"),
    ss13: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltThirteen"),
    ss14: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltFourteen"),
    ss15: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltFifteen"),
    ss16: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltSixteen"),
    ss17: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltSeventeen"),
    ss18: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltEighteen"),
    ss19: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltNineteen"),
    ss20: $2b7f887ebcb5888a$var$feature("stylisticAlternatives", "stylisticAltTwenty")
};
// salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
// Add cv01-cv99 features
for(let i = 1; i <= 99; i++)$2b7f887ebcb5888a$var$OTMapping[`cv${`00${i}`.slice(-2)}`] = [
    $2b7f887ebcb5888a$var$features.characterAlternatives.code,
    i
];
// create inverse mapping
let $2b7f887ebcb5888a$var$AATMapping = {};
for(let ot in $2b7f887ebcb5888a$var$OTMapping){
    let aat = $2b7f887ebcb5888a$var$OTMapping[ot];
    if ($2b7f887ebcb5888a$var$AATMapping[aat[0]] == null) $2b7f887ebcb5888a$var$AATMapping[aat[0]] = {};
    $2b7f887ebcb5888a$var$AATMapping[aat[0]][aat[1]] = ot;
}
function $2b7f887ebcb5888a$export$b813f7d2a1677c16(features1) {
    let res = {};
    for(let k in features1){
        let r;
        if (r = $2b7f887ebcb5888a$var$OTMapping[k]) {
            if (res[r[0]] == null) res[r[0]] = {};
            res[r[0]][r[1]] = features1[k];
        }
    }
    return res;
}
// Maps strings in a [featureType, featureSetting]
// to their equivalent number codes
function $2b7f887ebcb5888a$var$mapFeatureStrings(f) {
    let [type, setting] = f;
    if (isNaN(type)) var typeCode = $2b7f887ebcb5888a$var$features[type] && $2b7f887ebcb5888a$var$features[type].code;
    else var typeCode = type;
    if (isNaN(setting)) var settingCode = $2b7f887ebcb5888a$var$features[type] && $2b7f887ebcb5888a$var$features[type][setting];
    else var settingCode = setting;
    return [
        typeCode,
        settingCode
    ];
}
function $2b7f887ebcb5888a$export$bd6df347a4f391c4(features2) {
    let res = {};
    if (Array.isArray(features2)) for(let k = 0; k < features2.length; k++){
        let r;
        let f = $2b7f887ebcb5888a$var$mapFeatureStrings(features2[k]);
        if (r = $2b7f887ebcb5888a$var$AATMapping[f[0]] && $2b7f887ebcb5888a$var$AATMapping[f[0]][f[1]]) res[r] = true;
    }
    else if (typeof features2 === "object") for(let type in features2){
        let feature1 = features2[type];
        for(let setting in feature1){
            let r;
            let f = $2b7f887ebcb5888a$var$mapFeatureStrings([
                type,
                setting
            ]);
            if (feature1[setting] && (r = $2b7f887ebcb5888a$var$AATMapping[f[0]] && $2b7f887ebcb5888a$var$AATMapping[f[0]][f[1]])) res[r] = true;
        }
    }
    return Object.keys(res);
}
class $f3d63ae925545400$export$2e2bcd8739ae039 {
    lookup(glyph) {
        switch(this.table.version){
            case 0:
                return this.table.values.getItem(glyph);
            case 2:
            case 4:
                {
                    let min = 0;
                    let max = this.table.binarySearchHeader.nUnits - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var seg = this.table.segments[mid];
                        // special end of search value
                        if (seg.firstGlyph === 0xffff) return null;
                        if (glyph < seg.firstGlyph) max = mid - 1;
                        else if (glyph > seg.lastGlyph) min = mid + 1;
                        else {
                            if (this.table.version === 2) return seg.value;
                            else return seg.values[glyph - seg.firstGlyph];
                        }
                    }
                    return null;
                }
            case 6:
                {
                    let min = 0;
                    let max = this.table.binarySearchHeader.nUnits - 1;
                    while(min <= max){
                        var mid = min + max >> 1;
                        var seg = this.table.segments[mid];
                        // special end of search value
                        if (seg.glyph === 0xffff) return null;
                        if (glyph < seg.glyph) max = mid - 1;
                        else if (glyph > seg.glyph) min = mid + 1;
                        else return seg.value;
                    }
                    return null;
                }
            case 8:
                return this.table.values[glyph - this.table.firstGlyph];
            default:
                throw new Error(`Unknown lookup table format: ${this.table.version}`);
        }
    }
    glyphsForValue(classValue) {
        let res = [];
        switch(this.table.version){
            case 2:
            case 4:
                for (let segment of this.table.segments)if (this.table.version === 2 && segment.value === classValue) res.push(...$66a5b9fb5318558a$export$d02631cccf789723(segment.firstGlyph, segment.lastGlyph + 1));
                else {
                    for(let index = 0; index < segment.values.length; index++)if (segment.values[index] === classValue) res.push(segment.firstGlyph + index);
                }
                break;
            case 6:
                for (let segment1 of this.table.segments)if (segment1.value === classValue) res.push(segment1.glyph);
                break;
            case 8:
                for(let i = 0; i < this.table.values.length; i++)if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
                break;
            default:
                throw new Error(`Unknown lookup table format: ${this.table.version}`);
        }
        return res;
    }
    constructor(table){
        this.table = table;
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $f3d63ae925545400$export$2e2bcd8739ae039.prototype, "glyphsForValue", null);
const $860c6347bb941b91$var$START_OF_TEXT_STATE = 0;
const $860c6347bb941b91$var$START_OF_LINE_STATE = 1;
const $860c6347bb941b91$var$END_OF_TEXT_CLASS = 0;
const $860c6347bb941b91$var$OUT_OF_BOUNDS_CLASS = 1;
const $860c6347bb941b91$var$DELETED_GLYPH_CLASS = 2;
const $860c6347bb941b91$var$END_OF_LINE_CLASS = 3;
const $860c6347bb941b91$var$DONT_ADVANCE = 0x4000;
class $860c6347bb941b91$export$2e2bcd8739ae039 {
    process(glyphs, reverse, processEntry) {
        let currentState = $860c6347bb941b91$var$START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
        let index = reverse ? glyphs.length - 1 : 0;
        let dir = reverse ? -1 : 1;
        while(dir === 1 && index <= glyphs.length || dir === -1 && index >= -1){
            let glyph = null;
            let classCode = $860c6347bb941b91$var$OUT_OF_BOUNDS_CLASS;
            let shouldAdvance = true;
            if (index === glyphs.length || index === -1) classCode = $860c6347bb941b91$var$END_OF_TEXT_CLASS;
            else {
                glyph = glyphs[index];
                if (glyph.id === 0xffff) classCode = $860c6347bb941b91$var$DELETED_GLYPH_CLASS;
                else {
                    classCode = this.lookupTable.lookup(glyph.id);
                    if (classCode == null) classCode = $860c6347bb941b91$var$OUT_OF_BOUNDS_CLASS;
                }
            }
            let row = this.stateTable.stateArray.getItem(currentState);
            let entryIndex = row[classCode];
            let entry = this.stateTable.entryTable.getItem(entryIndex);
            if (classCode !== $860c6347bb941b91$var$END_OF_TEXT_CLASS && classCode !== $860c6347bb941b91$var$DELETED_GLYPH_CLASS) {
                processEntry(glyph, entry, index);
                shouldAdvance = !(entry.flags & $860c6347bb941b91$var$DONT_ADVANCE);
            }
            currentState = entry.newState;
            if (shouldAdvance) index += dir;
        }
        return glyphs;
    }
    /**
   * Performs a depth-first traversal of the glyph strings
   * represented by the state machine.
   */ traverse(opts, state = 0, visited = new Set) {
        if (visited.has(state)) return;
        visited.add(state);
        let { nClasses: nClasses, stateArray: stateArray, entryTable: entryTable } = this.stateTable;
        let row = stateArray.getItem(state);
        // Skip predefined classes
        for(let classCode = 4; classCode < nClasses; classCode++){
            let entryIndex = row[classCode];
            let entry = entryTable.getItem(entryIndex);
            // Try all glyphs in the class
            for (let glyph of this.lookupTable.glyphsForValue(classCode)){
                if (opts.enter) opts.enter(glyph, entry);
                if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
                if (opts.exit) opts.exit(glyph, entry);
            }
        }
    }
    constructor(stateTable){
        this.stateTable = stateTable;
        this.lookupTable = new $f3d63ae925545400$export$2e2bcd8739ae039(stateTable.classTable);
    }
}
// indic replacement flags
const $99be642f82069918$var$MARK_FIRST = 0x8000;
const $99be642f82069918$var$MARK_LAST = 0x2000;
const $99be642f82069918$var$VERB = 0x000F;
// contextual substitution and glyph insertion flag
const $99be642f82069918$var$SET_MARK = 0x8000;
// ligature entry flags
const $99be642f82069918$var$SET_COMPONENT = 0x8000;
const $99be642f82069918$var$PERFORM_ACTION = 0x2000;
// ligature action masks
const $99be642f82069918$var$LAST_MASK = 0x80000000;
const $99be642f82069918$var$STORE_MASK = 0x40000000;
const $99be642f82069918$var$OFFSET_MASK = 0x3FFFFFFF;
const $99be642f82069918$var$VERTICAL_ONLY = 0x800000;
const $99be642f82069918$var$REVERSE_DIRECTION = 0x400000;
const $99be642f82069918$var$HORIZONTAL_AND_VERTICAL = 0x200000;
// glyph insertion flags
const $99be642f82069918$var$CURRENT_IS_KASHIDA_LIKE = 0x2000;
const $99be642f82069918$var$MARKED_IS_KASHIDA_LIKE = 0x1000;
const $99be642f82069918$var$CURRENT_INSERT_BEFORE = 0x0800;
const $99be642f82069918$var$MARKED_INSERT_BEFORE = 0x0400;
const $99be642f82069918$var$CURRENT_INSERT_COUNT = 0x03E0;
const $99be642f82069918$var$MARKED_INSERT_COUNT = 0x001F;
class $99be642f82069918$export$2e2bcd8739ae039 {
    // Processes an array of glyphs and applies the specified features
    // Features should be in the form of {featureType:{featureSetting:boolean}}
    process(glyphs, features = {}) {
        for (let chain of this.morx.chains){
            let flags = chain.defaultFlags;
            // enable/disable the requested features
            for (let feature of chain.features){
                let f;
                if (f = features[feature.featureType]) {
                    if (f[feature.featureSetting]) {
                        flags &= feature.disableFlags;
                        flags |= feature.enableFlags;
                    } else if (f[feature.featureSetting] === false) {
                        flags |= ~feature.disableFlags;
                        flags &= ~feature.enableFlags;
                    }
                }
            }
            for (let subtable of chain.subtables)if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
        }
        // remove deleted glyphs
        let index = glyphs.length - 1;
        while(index >= 0){
            if (glyphs[index].id === 0xffff) glyphs.splice(index, 1);
            index--;
        }
        return glyphs;
    }
    processSubtable(subtable, glyphs) {
        this.subtable = subtable;
        this.glyphs = glyphs;
        if (this.subtable.type === 4) {
            this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
            return;
        }
        this.ligatureStack = [];
        this.markedGlyph = null;
        this.firstGlyph = null;
        this.lastGlyph = null;
        this.markedIndex = null;
        let stateMachine = this.getStateMachine(subtable);
        let process = this.getProcessor();
        let reverse = !!(this.subtable.coverage & $99be642f82069918$var$REVERSE_DIRECTION);
        return stateMachine.process(this.glyphs, reverse, process);
    }
    getStateMachine(subtable) {
        return new $860c6347bb941b91$export$2e2bcd8739ae039(subtable.table.stateTable);
    }
    getProcessor() {
        switch(this.subtable.type){
            case 0:
                return this.processIndicRearragement;
            case 1:
                return this.processContextualSubstitution;
            case 2:
                return this.processLigature;
            case 4:
                return this.processNoncontextualSubstitutions;
            case 5:
                return this.processGlyphInsertion;
            default:
                throw new Error(`Invalid morx subtable type: ${this.subtable.type}`);
        }
    }
    processIndicRearragement(glyph, entry, index) {
        if (entry.flags & $99be642f82069918$var$MARK_FIRST) this.firstGlyph = index;
        if (entry.flags & $99be642f82069918$var$MARK_LAST) this.lastGlyph = index;
        $99be642f82069918$var$reorderGlyphs(this.glyphs, entry.flags & $99be642f82069918$var$VERB, this.firstGlyph, this.lastGlyph);
    }
    processContextualSubstitution(glyph, entry, index) {
        let subsitutions = this.subtable.table.substitutionTable.items;
        if (entry.markIndex !== 0xffff) {
            let lookup = subsitutions.getItem(entry.markIndex);
            let lookupTable = new $f3d63ae925545400$export$2e2bcd8739ae039(lookup);
            glyph = this.glyphs[this.markedGlyph];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.currentIndex !== 0xffff) {
            let lookup = subsitutions.getItem(entry.currentIndex);
            let lookupTable = new $f3d63ae925545400$export$2e2bcd8739ae039(lookup);
            glyph = this.glyphs[index];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.flags & $99be642f82069918$var$SET_MARK) this.markedGlyph = index;
    }
    processLigature(glyph, entry, index) {
        if (entry.flags & $99be642f82069918$var$SET_COMPONENT) this.ligatureStack.push(index);
        if (entry.flags & $99be642f82069918$var$PERFORM_ACTION) {
            let actions = this.subtable.table.ligatureActions;
            let components = this.subtable.table.components;
            let ligatureList = this.subtable.table.ligatureList;
            let actionIndex = entry.action;
            let last = false;
            let ligatureIndex = 0;
            let codePoints = [];
            let ligatureGlyphs = [];
            while(!last){
                let componentGlyph = this.ligatureStack.pop();
                codePoints.unshift(...this.glyphs[componentGlyph].codePoints);
                let action = actions.getItem(actionIndex++);
                last = !!(action & $99be642f82069918$var$LAST_MASK);
                let store = !!(action & $99be642f82069918$var$STORE_MASK);
                let offset = (action & $99be642f82069918$var$OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
                offset += this.glyphs[componentGlyph].id;
                let component = components.getItem(offset);
                ligatureIndex += component;
                if (last || store) {
                    let ligatureEntry = ligatureList.getItem(ligatureIndex);
                    this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                    ligatureGlyphs.push(componentGlyph);
                    ligatureIndex = 0;
                    codePoints = [];
                } else this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
            }
            // Put ligature glyph indexes back on the stack
            this.ligatureStack.push(...ligatureGlyphs);
        }
    }
    processNoncontextualSubstitutions(subtable, glyphs, index) {
        let lookupTable = new $f3d63ae925545400$export$2e2bcd8739ae039(subtable.table.lookupTable);
        for(index = 0; index < glyphs.length; index++){
            let glyph = glyphs[index];
            if (glyph.id !== 0xffff) {
                let gid = lookupTable.lookup(glyph.id);
                if (gid) glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
            }
        }
    }
    _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
        let insertions = [];
        while(count--){
            let gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
            insertions.push(this.font.getGlyph(gid));
        }
        if (!isBefore) glyphIndex++;
        this.glyphs.splice(glyphIndex, 0, ...insertions);
    }
    processGlyphInsertion(glyph, entry, index) {
        if (entry.flags & $99be642f82069918$var$SET_MARK) this.markedIndex = index;
        if (entry.markedInsertIndex !== 0xffff) {
            let count = (entry.flags & $99be642f82069918$var$MARKED_INSERT_COUNT) >>> 5;
            let isBefore = !!(entry.flags & $99be642f82069918$var$MARKED_INSERT_BEFORE);
            this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
        }
        if (entry.currentInsertIndex !== 0xffff) {
            let count = (entry.flags & $99be642f82069918$var$CURRENT_INSERT_COUNT) >>> 5;
            let isBefore = !!(entry.flags & $99be642f82069918$var$CURRENT_INSERT_BEFORE);
            this._insertGlyphs(index, entry.currentInsertIndex, count, isBefore);
        }
    }
    getSupportedFeatures() {
        let features = [];
        for (let chain of this.morx.chains)for (let feature of chain.features)features.push([
            feature.featureType,
            feature.featureSetting
        ]);
        return features;
    }
    generateInputs(gid) {
        if (!this.inputCache) this.generateInputCache();
        return this.inputCache[gid] || [];
    }
    generateInputCache() {
        this.inputCache = {};
        for (let chain of this.morx.chains){
            let flags = chain.defaultFlags;
            for (let subtable of chain.subtables)if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
        }
    }
    generateInputsForSubtable(subtable) {
        // Currently, only supporting ligature subtables.
        if (subtable.type !== 2) return;
        let reverse = !!(subtable.coverage & $99be642f82069918$var$REVERSE_DIRECTION);
        if (reverse) throw new Error("Reverse subtable, not supported.");
        this.subtable = subtable;
        this.ligatureStack = [];
        let stateMachine = this.getStateMachine(subtable);
        let process = this.getProcessor();
        let input = [];
        let stack = [];
        this.glyphs = [];
        stateMachine.traverse({
            enter: (glyph, entry)=>{
                let glyphs = this.glyphs;
                stack.push({
                    glyphs: glyphs.slice(),
                    ligatureStack: this.ligatureStack.slice()
                });
                // Add glyph to input and glyphs to process.
                let g1 = this.font.getGlyph(glyph);
                input.push(g1);
                glyphs.push(input[input.length - 1]);
                // Process ligature substitution
                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1);
                // Add input to result if only one matching (non-deleted) glyph remains.
                let count = 0;
                let found = 0;
                for(let i = 0; i < glyphs.length && count <= 1; i++)if (glyphs[i].id !== 0xffff) {
                    count++;
                    found = glyphs[i].id;
                }
                if (count === 1) {
                    let result = input.map((g)=>g.id);
                    let cache1 = this.inputCache[found];
                    if (cache1) cache1.push(result);
                    else this.inputCache[found] = [
                        result
                    ];
                }
            },
            exit: ()=>{
                ({ glyphs: this.glyphs, ligatureStack: this.ligatureStack } = stack.pop());
                input.pop();
            }
        });
    }
    constructor(font){
        this.processIndicRearragement = this.processIndicRearragement.bind(this);
        this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
        this.processLigature = this.processLigature.bind(this);
        this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
        this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
        this.font = font;
        this.morx = font.morx;
        this.inputCache = null;
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $99be642f82069918$export$2e2bcd8739ae039.prototype, "getStateMachine", null);
// swaps the glyphs in rangeA with those in rangeB
// reverse the glyphs inside those ranges if specified
// ranges are in [offset, length] format
function $99be642f82069918$var$swap(glyphs, rangeA, rangeB, reverseA = false, reverseB = false) {
    let end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
    if (reverseB) end.reverse();
    let start = glyphs.splice(rangeA[0], rangeA[1], ...end);
    if (reverseA) start.reverse();
    glyphs.splice(rangeB[0] - (rangeA[1] - 1), 0, ...start);
    return glyphs;
}
function $99be642f82069918$var$reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
    let length = lastGlyph - firstGlyph + 1;
    switch(verb){
        case 0:
            return glyphs;
        case 1:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                0
            ]);
        case 2:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                1
            ]);
        case 3:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                1
            ]);
        case 4:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ]);
        case 5:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ], true, false);
        case 6:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ]);
        case 7:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ], false, true);
        case 8:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ]);
        case 9:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ], false, true);
        case 10:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ]);
        case 11:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ], true, false);
        case 12:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ]);
        case 13:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, false);
        case 14:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], false, true);
        case 15:
            return $99be642f82069918$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, true);
        default:
            throw new Error(`Unknown verb: ${verb}`);
    }
}
class $860fcbd64bc12fbc$export$2e2bcd8739ae039 {
    substitute(glyphRun) {
        // AAT expects the glyphs to be in visual order prior to morx processing,
        // so reverse the glyphs if the script is right-to-left.
        if (glyphRun.direction === "rtl") glyphRun.glyphs.reverse();
        this.morxProcessor.process(glyphRun.glyphs, $2b7f887ebcb5888a$export$b813f7d2a1677c16(glyphRun.features));
    }
    getAvailableFeatures(script, language) {
        return $2b7f887ebcb5888a$export$bd6df347a4f391c4(this.morxProcessor.getSupportedFeatures());
    }
    stringsForGlyph(gid) {
        let glyphStrings = this.morxProcessor.generateInputs(gid);
        let result = new Set;
        for (let glyphs of glyphStrings)this._addStrings(glyphs, 0, result, "");
        return result;
    }
    _addStrings(glyphs, index, strings, string) {
        let codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
        for (let codePoint of codePoints){
            let s = string + String.fromCodePoint(codePoint);
            if (index < glyphs.length - 1) this._addStrings(glyphs, index + 1, strings, s);
            else strings.add(s);
        }
    }
    constructor(font){
        this.font = font;
        this.morxProcessor = new $99be642f82069918$export$2e2bcd8739ae039(font);
        this.fallbackPosition = false;
    }
}
class $d7e93cca3cf8ce8a$export$2e2bcd8739ae039 {
    /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */ _addFeatures(features, global) {
        let stageIndex = this.stages.length - 1;
        let stage = this.stages[stageIndex];
        for (let feature of features)if (this.allFeatures[feature] == null) {
            stage.push(feature);
            this.allFeatures[feature] = stageIndex;
            if (global) this.globalFeatures[feature] = true;
        }
    }
    /**
   * Add features to the last stage
   */ add(arg, global = true) {
        if (this.stages.length === 0) this.stages.push([]);
        if (typeof arg === "string") arg = [
            arg
        ];
        if (Array.isArray(arg)) this._addFeatures(arg, global);
        else if (typeof arg === "object") {
            this._addFeatures(arg.global || [], true);
            this._addFeatures(arg.local || [], false);
        } else throw new Error("Unsupported argument to ShapingPlan#add");
    }
    /**
   * Add a new stage
   */ addStage(arg, global) {
        if (typeof arg === "function") this.stages.push(arg, []);
        else {
            this.stages.push([]);
            this.add(arg, global);
        }
    }
    setFeatureOverrides(features) {
        if (Array.isArray(features)) this.add(features);
        else if (typeof features === "object") for(let tag in features){
            if (features[tag]) this.add(tag);
            else if (this.allFeatures[tag] != null) {
                let stage = this.stages[this.allFeatures[tag]];
                stage.splice(stage.indexOf(tag), 1);
                delete this.allFeatures[tag];
                delete this.globalFeatures[tag];
            }
        }
    }
    /**
   * Assigns the global features to the given glyphs
   */ assignGlobalFeatures(glyphs) {
        for (let glyph of glyphs)for(let feature in this.globalFeatures)glyph.features[feature] = true;
    }
    /**
   * Executes the planned stages using the given OTProcessor
   */ process(processor, glyphs, positions) {
        for (let stage of this.stages){
            if (typeof stage === "function") {
                if (!positions) stage(this.font, glyphs, this);
            } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions);
        }
    }
    constructor(font, script, direction){
        this.font = font;
        this.script = script;
        this.direction = direction;
        this.stages = [];
        this.globalFeatures = {};
        this.allFeatures = {};
    }
}
const $d28fb665ee343afc$var$VARIATION_FEATURES = [
    "rvrn"
];
const $d28fb665ee343afc$var$COMMON_FEATURES = [
    "ccmp",
    "locl",
    "rlig",
    "mark",
    "mkmk"
];
const $d28fb665ee343afc$var$FRACTIONAL_FEATURES = [
    "frac",
    "numr",
    "dnom"
];
const $d28fb665ee343afc$var$HORIZONTAL_FEATURES = [
    "calt",
    "clig",
    "liga",
    "rclt",
    "curs",
    "kern"
];
const $d28fb665ee343afc$var$VERTICAL_FEATURES = [
    "vert"
];
const $d28fb665ee343afc$var$DIRECTIONAL_FEATURES = {
    ltr: [
        "ltra",
        "ltrm"
    ],
    rtl: [
        "rtla",
        "rtlm"
    ]
};
class $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static plan(plan, glyphs, features) {
        // Plan the features we want to apply
        this.planPreprocessing(plan);
        this.planFeatures(plan);
        this.planPostprocessing(plan, features);
        // Assign the global features to all the glyphs
        plan.assignGlobalFeatures(glyphs);
        // Assign local features to glyphs
        this.assignFeatures(plan, glyphs);
    }
    static planPreprocessing(plan) {
        plan.add({
            global: [
                ...$d28fb665ee343afc$var$VARIATION_FEATURES,
                ...$d28fb665ee343afc$var$DIRECTIONAL_FEATURES[plan.direction]
            ],
            local: $d28fb665ee343afc$var$FRACTIONAL_FEATURES
        });
    }
    static planFeatures(plan) {
    // Do nothing by default. Let subclasses override this.
    }
    static planPostprocessing(plan, userFeatures) {
        plan.add([
            ...$d28fb665ee343afc$var$COMMON_FEATURES,
            ...$d28fb665ee343afc$var$HORIZONTAL_FEATURES
        ]);
        plan.setFeatureOverrides(userFeatures);
    }
    static assignFeatures(plan, glyphs) {
        // Enable contextual fractions
        for(let i = 0; i < glyphs.length; i++){
            let glyph = glyphs[i];
            if (glyph.codePoints[0] === 0x2044) {
                let start = i;
                let end = i + 1;
                // Apply numerator
                while(start > 0 && (0, $gfJaN$unicodeproperties.isDigit)(glyphs[start - 1].codePoints[0])){
                    glyphs[start - 1].features.numr = true;
                    glyphs[start - 1].features.frac = true;
                    start--;
                }
                // Apply denominator
                while(end < glyphs.length && (0, $gfJaN$unicodeproperties.isDigit)(glyphs[end].codePoints[0])){
                    glyphs[end].features.dnom = true;
                    glyphs[end].features.frac = true;
                    end++;
                }
                // Apply fraction slash
                glyph.features.frac = true;
                i = end - 1;
            }
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)($d28fb665ee343afc$export$2e2bcd8739ae039, "zeroMarkWidths", "AFTER_GPOS");
const $17ba6019f27bfcf9$var$trie = new ($parcel$interopDefault($gfJaN$unicodetrie))($66a5b9fb5318558a$export$94fdf11bafc8de6b("ABABAAAAAACgMQAAAZUBav7t2CtPA0EUBeDZB00pin9AJZIEgyUEj0QhweDAgQOJxCBRBElQSBwSicLgkOAwnNKZ5GaY2c7uzj4o5yZfZrrbefbuIx2nSq3CGmzAWH/+K+UO7MIe7MMhHMMpnMMFXMIVXIt2t3CnP088iPqjqNN8e4Ij7Rle4LUH82rLm6i/92A+RERERERERERNmfz/89GDeRARERERzbN8ceps2Iwt9H0C9/AJ6yOlDkbTczcot5VSm8Pm1vcFWfb7+BKOLTuOd2UlTX4wGP85Eg953lWPFbnuN7PkjtLmalOWbNenkHOSa7T3KmR9MVTZ2zZkVj1kHa68MueVKH0R4zqQ44WEXLM8VjcWHP0PtKLfPzQnMtGn3W4QYf6qxFxceVI394r2xnV+1rih0fV1Vzf3fO1n3evL5J78ruvZ5ptX2Rwy92Tfb1wlEqut3U+sZ3HXOeJ7/zDrbyuP6+Zz0fqa6Nv3vhY7Yu1xWnGevmsvsUpTT/RYIe8waUH/rvHMWKFzLfN8L+rTfp645mfX7ftlnfDtYxN59w0="));
const $17ba6019f27bfcf9$var$FEATURES = [
    "isol",
    "fina",
    "fin2",
    "fin3",
    "medi",
    "med2",
    "init"
];
const $17ba6019f27bfcf9$var$ShapingClasses = {
    Non_Joining: 0,
    Left_Joining: 1,
    Right_Joining: 2,
    Dual_Joining: 3,
    Join_Causing: 3,
    ALAPH: 4,
    "DALATH RISH": 5,
    Transparent: 6
};
const $17ba6019f27bfcf9$var$ISOL = "isol";
const $17ba6019f27bfcf9$var$FINA = "fina";
const $17ba6019f27bfcf9$var$FIN2 = "fin2";
const $17ba6019f27bfcf9$var$FIN3 = "fin3";
const $17ba6019f27bfcf9$var$MEDI = "medi";
const $17ba6019f27bfcf9$var$MED2 = "med2";
const $17ba6019f27bfcf9$var$INIT = "init";
const $17ba6019f27bfcf9$var$NONE = null;
// Each entry is [prevAction, curAction, nextState]
const $17ba6019f27bfcf9$var$STATE_TABLE = [
    //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
    // State 0: prev was U,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 1: prev was R or ISOL/ALAPH,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$FIN2,
            5
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 2: prev was D/L in ISOL form,  willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$INIT,
            $17ba6019f27bfcf9$var$FINA,
            1
        ],
        [
            $17ba6019f27bfcf9$var$INIT,
            $17ba6019f27bfcf9$var$FINA,
            3
        ],
        [
            $17ba6019f27bfcf9$var$INIT,
            $17ba6019f27bfcf9$var$FINA,
            4
        ],
        [
            $17ba6019f27bfcf9$var$INIT,
            $17ba6019f27bfcf9$var$FINA,
            6
        ]
    ],
    // State 3: prev was D in FINA form,  willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$MEDI,
            $17ba6019f27bfcf9$var$FINA,
            1
        ],
        [
            $17ba6019f27bfcf9$var$MEDI,
            $17ba6019f27bfcf9$var$FINA,
            3
        ],
        [
            $17ba6019f27bfcf9$var$MEDI,
            $17ba6019f27bfcf9$var$FINA,
            4
        ],
        [
            $17ba6019f27bfcf9$var$MEDI,
            $17ba6019f27bfcf9$var$FINA,
            6
        ]
    ],
    // State 4: prev was FINA ALAPH,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$MED2,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$MED2,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$MED2,
            $17ba6019f27bfcf9$var$FIN2,
            5
        ],
        [
            $17ba6019f27bfcf9$var$MED2,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$ISOL,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$ISOL,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$ISOL,
            $17ba6019f27bfcf9$var$FIN2,
            5
        ],
        [
            $17ba6019f27bfcf9$var$ISOL,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ],
    // State 6: prev was DALATH/RISH,  not willing to join.
    [
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$NONE,
            0
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            1
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            2
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$FIN3,
            5
        ],
        [
            $17ba6019f27bfcf9$var$NONE,
            $17ba6019f27bfcf9$var$ISOL,
            6
        ]
    ]
];
class $17ba6019f27bfcf9$export$2e2bcd8739ae039 extends $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.add([
            "ccmp",
            "locl"
        ]);
        for(let i = 0; i < $17ba6019f27bfcf9$var$FEATURES.length; i++){
            let feature = $17ba6019f27bfcf9$var$FEATURES[i];
            plan.addStage(feature, false);
        }
        plan.addStage("mset");
    }
    static assignFeatures(plan, glyphs) {
        super.assignFeatures(plan, glyphs);
        let prev = -1;
        let state = 0;
        let actions = [];
        // Apply the state machine to map glyphs to features
        for(let i = 0; i < glyphs.length; i++){
            let curAction, prevAction;
            var glyph = glyphs[i];
            let type = $17ba6019f27bfcf9$var$getShapingClass(glyph.codePoints[0]);
            if (type === $17ba6019f27bfcf9$var$ShapingClasses.Transparent) {
                actions[i] = $17ba6019f27bfcf9$var$NONE;
                continue;
            }
            [prevAction, curAction, state] = $17ba6019f27bfcf9$var$STATE_TABLE[state][type];
            if (prevAction !== $17ba6019f27bfcf9$var$NONE && prev !== -1) actions[prev] = prevAction;
            actions[i] = curAction;
            prev = i;
        }
        // Apply the chosen features to their respective glyphs
        for(let index = 0; index < glyphs.length; index++){
            let feature;
            var glyph = glyphs[index];
            if (feature = actions[index]) glyph.features[feature] = true;
        }
    }
}
function $17ba6019f27bfcf9$var$getShapingClass(codePoint) {
    let res = $17ba6019f27bfcf9$var$trie.get(codePoint);
    if (res) return res - 1;
    let category = (0, $gfJaN$unicodeproperties.getCategory)(codePoint);
    if (category === "Mn" || category === "Me" || category === "Cf") return $17ba6019f27bfcf9$var$ShapingClasses.Transparent;
    return $17ba6019f27bfcf9$var$ShapingClasses.Non_Joining;
}
class $d6368085223f631e$export$2e2bcd8739ae039 {
    reset(options = {}, index = 0) {
        this.options = options;
        this.flags = options.flags || {};
        this.markAttachmentType = options.markAttachmentType || 0;
        this.index = index;
    }
    get cur() {
        return this.glyphs[this.index] || null;
    }
    shouldIgnore(glyph) {
        return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
    }
    move(dir) {
        this.index += dir;
        while(0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]))this.index += dir;
        if (0 > this.index || this.index >= this.glyphs.length) return null;
        return this.glyphs[this.index];
    }
    next() {
        return this.move(1);
    }
    prev() {
        return this.move(-1);
    }
    peek(count = 1) {
        let idx = this.index;
        let res = this.increment(count);
        this.index = idx;
        return res;
    }
    peekIndex(count = 1) {
        let idx = this.index;
        this.increment(count);
        let res = this.index;
        this.index = idx;
        return res;
    }
    increment(count = 1) {
        let dir = count < 0 ? -1 : 1;
        count = Math.abs(count);
        while(count--)this.move(dir);
        return this.glyphs[this.index];
    }
    constructor(glyphs, options){
        this.glyphs = glyphs;
        this.reset(options);
    }
}
const $7b226e6bbeadedeb$var$DEFAULT_SCRIPTS = [
    "DFLT",
    "dflt",
    "latn"
];
class $7b226e6bbeadedeb$export$2e2bcd8739ae039 {
    findScript(script) {
        if (this.table.scriptList == null) return null;
        if (!Array.isArray(script)) script = [
            script
        ];
        for (let s of script)for (let entry of this.table.scriptList){
            if (entry.tag === s) return entry;
        }
        return null;
    }
    selectScript(script, language, direction) {
        let changed = false;
        let entry;
        if (!this.script || script !== this.scriptTag) {
            entry = this.findScript(script);
            if (!entry) entry = this.findScript($7b226e6bbeadedeb$var$DEFAULT_SCRIPTS);
            if (!entry) return this.scriptTag;
            this.scriptTag = entry.tag;
            this.script = entry.script;
            this.language = null;
            this.languageTag = null;
            changed = true;
        }
        if (!direction || direction !== this.direction) this.direction = direction || $e38a1a895f6aeb54$export$9fddb9d0dd7d8a54(script);
        if (language && language.length < 4) language += " ".repeat(4 - language.length);
        if (!language || language !== this.languageTag) {
            this.language = null;
            for (let lang of this.script.langSysRecords)if (lang.tag === language) {
                this.language = lang.langSys;
                this.languageTag = lang.tag;
                break;
            }
            if (!this.language) {
                this.language = this.script.defaultLangSys;
                this.languageTag = null;
            }
            changed = true;
        }
        // Build a feature lookup table
        if (changed) {
            this.features = {};
            if (this.language) for (let featureIndex of this.language.featureIndexes){
                let record = this.table.featureList[featureIndex];
                let substituteFeature = this.substituteFeatureForVariations(featureIndex);
                this.features[record.tag] = substituteFeature || record.feature;
            }
        }
        return this.scriptTag;
    }
    lookupsForFeatures(userFeatures = [], exclude) {
        let lookups = [];
        for (let tag of userFeatures){
            let feature = this.features[tag];
            if (!feature) continue;
            for (let lookupIndex of feature.lookupListIndexes){
                if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
                lookups.push({
                    feature: tag,
                    index: lookupIndex,
                    lookup: this.table.lookupList.get(lookupIndex)
                });
            }
        }
        lookups.sort((a, b)=>a.index - b.index);
        return lookups;
    }
    substituteFeatureForVariations(featureIndex) {
        if (this.variationsIndex === -1) return null;
        let record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
        let substitutions = record.featureTableSubstitution.substitutions;
        for (let substitution of substitutions){
            if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
        }
        return null;
    }
    findVariationsIndex(coords) {
        let variations = this.table.featureVariations;
        if (!variations) return -1;
        let records = variations.featureVariationRecords;
        for(let i = 0; i < records.length; i++){
            let conditions = records[i].conditionSet.conditionTable;
            if (this.variationConditionsMatch(conditions, coords)) return i;
        }
        return -1;
    }
    variationConditionsMatch(conditions, coords) {
        return conditions.every((condition)=>{
            let coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
            return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
        });
    }
    applyFeatures(userFeatures, glyphs, advances) {
        let lookups = this.lookupsForFeatures(userFeatures);
        this.applyLookups(lookups, glyphs, advances);
    }
    applyLookups(lookups, glyphs, positions) {
        this.glyphs = glyphs;
        this.positions = positions;
        this.glyphIterator = new $d6368085223f631e$export$2e2bcd8739ae039(glyphs);
        for (let { feature: feature, lookup: lookup } of lookups){
            this.currentFeature = feature;
            this.glyphIterator.reset(lookup.flags);
            while(this.glyphIterator.index < glyphs.length){
                if (!(feature in this.glyphIterator.cur.features)) {
                    this.glyphIterator.next();
                    continue;
                }
                for (let table of lookup.subTables){
                    let res = this.applyLookup(lookup.lookupType, table);
                    if (res) break;
                }
                this.glyphIterator.next();
            }
        }
    }
    applyLookup(lookup, table) {
        throw new Error("applyLookup must be implemented by subclasses");
    }
    applyLookupList(lookupRecords) {
        let options = this.glyphIterator.options;
        let glyphIndex = this.glyphIterator.index;
        for (let lookupRecord of lookupRecords){
            // Reset flags and find glyph index for this lookup record
            this.glyphIterator.reset(options, glyphIndex);
            this.glyphIterator.increment(lookupRecord.sequenceIndex);
            // Get the lookup and setup flags for subtables
            let lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
            this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);
            // Apply lookup subtables until one matches
            for (let table of lookup.subTables){
                if (this.applyLookup(lookup.lookupType, table)) break;
            }
        }
        this.glyphIterator.reset(options, glyphIndex);
        return true;
    }
    coverageIndex(coverage, glyph) {
        if (glyph == null) glyph = this.glyphIterator.cur.id;
        switch(coverage.version){
            case 1:
                return coverage.glyphs.indexOf(glyph);
            case 2:
                for (let range of coverage.rangeRecords){
                    if (range.start <= glyph && glyph <= range.end) return range.startCoverageIndex + glyph - range.start;
                }
                break;
        }
        return -1;
    }
    match(sequenceIndex, sequence, fn, matched) {
        let pos = this.glyphIterator.index;
        let glyph = this.glyphIterator.increment(sequenceIndex);
        let idx = 0;
        while(idx < sequence.length && glyph && fn(sequence[idx], glyph)){
            if (matched) matched.push(this.glyphIterator.index);
            idx++;
            glyph = this.glyphIterator.next();
        }
        this.glyphIterator.index = pos;
        if (idx < sequence.length) return false;
        return matched || true;
    }
    sequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (component, glyph)=>component === glyph.id);
    }
    sequenceMatchIndices(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (component, glyph)=>{
            // If the current feature doesn't apply to this glyph,
            if (!(this.currentFeature in glyph.features)) return false;
            return component === glyph.id;
        }, []);
    }
    coverageSequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, (coverage, glyph)=>this.coverageIndex(coverage, glyph.id) >= 0);
    }
    getClassID(glyph, classDef) {
        switch(classDef.version){
            case 1:
                let i = glyph - classDef.startGlyph;
                if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
                break;
            case 2:
                for (let range of classDef.classRangeRecord){
                    if (range.start <= glyph && glyph <= range.end) return range.class;
                }
                break;
        }
        return 0;
    }
    classSequenceMatches(sequenceIndex, sequence, classDef) {
        return this.match(sequenceIndex, sequence, (classID, glyph)=>classID === this.getClassID(glyph.id, classDef));
    }
    applyContext(table) {
        let index, set;
        switch(table.version){
            case 1:
                index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                set = table.ruleSets[index];
                for (let rule of set){
                    if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                if (index === -1) return false;
                set = table.classSet[index];
                for (let rule1 of set){
                    if (this.classSequenceMatches(1, rule1.classes, table.classDef)) return this.applyLookupList(rule1.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    }
    applyChainingContext(table) {
        let index;
        switch(table.version){
            case 1:
                index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                let set = table.chainRuleSets[index];
                for (let rule of set){
                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                let rules = table.chainClassSet[index];
                if (!rules) return false;
                for (let rule2 of rules){
                    if (this.classSequenceMatches(-rule2.backtrack.length, rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + rule2.input.length, rule2.lookahead, table.lookaheadClassDef)) return this.applyLookupList(rule2.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    }
    constructor(font, table){
        this.font = font;
        this.table = table;
        this.script = null;
        this.scriptTag = null;
        this.language = null;
        this.languageTag = null;
        this.features = {};
        this.lookups = {};
        // Setup variation substitutions
        this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;
        // initialize to default script + language
        this.selectScript();
        // current context (set by applyFeatures)
        this.glyphs = [];
        this.positions = []; // only used by GPOS
        this.ligatureID = 1;
        this.currentFeature = null;
    }
}
class $f22bb23c9fd478d8$export$2e2bcd8739ae039 {
    get id() {
        return this._id;
    }
    set id(id) {
        this._id = id;
        this.substituted = true;
        let GDEF = this._font.GDEF;
        if (GDEF && GDEF.glyphClassDef) {
            // TODO: clean this up
            let classID = $7b226e6bbeadedeb$export$2e2bcd8739ae039.prototype.getClassID(id, GDEF.glyphClassDef);
            this.isBase = classID === 1;
            this.isLigature = classID === 2;
            this.isMark = classID === 3;
            this.markAttachmentType = GDEF.markAttachClassDef ? $7b226e6bbeadedeb$export$2e2bcd8739ae039.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
        } else {
            this.isMark = this.codePoints.length > 0 && this.codePoints.every($gfJaN$unicodeproperties.isMark);
            this.isBase = !this.isMark;
            this.isLigature = this.codePoints.length > 1;
            this.markAttachmentType = 0;
        }
    }
    copy() {
        return new $f22bb23c9fd478d8$export$2e2bcd8739ae039(this._font, this.id, this.codePoints, this.features);
    }
    constructor(font, id, codePoints = [], features){
        this._font = font;
        this.codePoints = codePoints;
        this.id = id;
        this.features = {};
        if (Array.isArray(features)) for(let i = 0; i < features.length; i++){
            let feature = features[i];
            this.features[feature] = true;
        }
        else if (typeof features === "object") Object.assign(this.features, features);
        this.ligatureID = null;
        this.ligatureComponent = null;
        this.isLigated = false;
        this.cursiveAttachment = null;
        this.markAttachment = null;
        this.shaperInfo = null;
        this.substituted = false;
        this.isMultiplied = false;
    }
}
class $fa1d9fd80dd7279e$export$2e2bcd8739ae039 extends $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.add([
            "ljmo",
            "vjmo",
            "tjmo"
        ], false);
    }
    static assignFeatures(plan, glyphs) {
        let state = 0;
        let i = 0;
        while(i < glyphs.length){
            let action;
            let glyph = glyphs[i];
            let code = glyph.codePoints[0];
            let type = $fa1d9fd80dd7279e$var$getType(code);
            [action, state] = $fa1d9fd80dd7279e$var$STATE_TABLE[state][type];
            switch(action){
                case $fa1d9fd80dd7279e$var$DECOMPOSE:
                    // Decompose the composed syllable if it is not supported by the font.
                    if (!plan.font.hasGlyphForCodePoint(code)) i = $fa1d9fd80dd7279e$var$decompose(glyphs, i, plan.font);
                    break;
                case $fa1d9fd80dd7279e$var$COMPOSE:
                    // Found a decomposed syllable. Try to compose if supported by the font.
                    i = $fa1d9fd80dd7279e$var$compose(glyphs, i, plan.font);
                    break;
                case $fa1d9fd80dd7279e$var$TONE_MARK:
                    // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                    $fa1d9fd80dd7279e$var$reorderToneMark(glyphs, i, plan.font);
                    break;
                case $fa1d9fd80dd7279e$var$INVALID:
                    // Tone mark has no valid syllable to attach to, so insert a dotted circle
                    i = $fa1d9fd80dd7279e$var$insertDottedCircle(glyphs, i, plan.font);
                    break;
            }
            i++;
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)($fa1d9fd80dd7279e$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
const $fa1d9fd80dd7279e$var$HANGUL_BASE = 0xac00;
const $fa1d9fd80dd7279e$var$HANGUL_END = 0xd7a4;
const $fa1d9fd80dd7279e$var$HANGUL_COUNT = $fa1d9fd80dd7279e$var$HANGUL_END - $fa1d9fd80dd7279e$var$HANGUL_BASE + 1;
const $fa1d9fd80dd7279e$var$L_BASE = 0x1100; // lead
const $fa1d9fd80dd7279e$var$V_BASE = 0x1161; // vowel
const $fa1d9fd80dd7279e$var$T_BASE = 0x11a7; // trail
const $fa1d9fd80dd7279e$var$L_COUNT = 19;
const $fa1d9fd80dd7279e$var$V_COUNT = 21;
const $fa1d9fd80dd7279e$var$T_COUNT = 28;
const $fa1d9fd80dd7279e$var$L_END = $fa1d9fd80dd7279e$var$L_BASE + $fa1d9fd80dd7279e$var$L_COUNT - 1;
const $fa1d9fd80dd7279e$var$V_END = $fa1d9fd80dd7279e$var$V_BASE + $fa1d9fd80dd7279e$var$V_COUNT - 1;
const $fa1d9fd80dd7279e$var$T_END = $fa1d9fd80dd7279e$var$T_BASE + $fa1d9fd80dd7279e$var$T_COUNT - 1;
const $fa1d9fd80dd7279e$var$DOTTED_CIRCLE = 0x25cc;
const $fa1d9fd80dd7279e$var$isL = (code)=>0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
const $fa1d9fd80dd7279e$var$isV = (code)=>0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
const $fa1d9fd80dd7279e$var$isT = (code)=>0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
const $fa1d9fd80dd7279e$var$isTone = (code)=>0x302e <= code && code <= 0x302f;
const $fa1d9fd80dd7279e$var$isLVT = (code)=>$fa1d9fd80dd7279e$var$HANGUL_BASE <= code && code <= $fa1d9fd80dd7279e$var$HANGUL_END;
const $fa1d9fd80dd7279e$var$isLV = (code)=>code - $fa1d9fd80dd7279e$var$HANGUL_BASE < $fa1d9fd80dd7279e$var$HANGUL_COUNT && (code - $fa1d9fd80dd7279e$var$HANGUL_BASE) % $fa1d9fd80dd7279e$var$T_COUNT === 0;
const $fa1d9fd80dd7279e$var$isCombiningL = (code)=>$fa1d9fd80dd7279e$var$L_BASE <= code && code <= $fa1d9fd80dd7279e$var$L_END;
const $fa1d9fd80dd7279e$var$isCombiningV = (code)=>$fa1d9fd80dd7279e$var$V_BASE <= code && code <= $fa1d9fd80dd7279e$var$V_END;
const $fa1d9fd80dd7279e$var$isCombiningT = (code)=>$fa1d9fd80dd7279e$var$T_BASE + 1 && 1 <= code && code <= $fa1d9fd80dd7279e$var$T_END;
// Character categories
const $fa1d9fd80dd7279e$var$X = 0; // Other character
const $fa1d9fd80dd7279e$var$L = 1; // Leading consonant
const $fa1d9fd80dd7279e$var$V = 2; // Medial vowel
const $fa1d9fd80dd7279e$var$T = 3; // Trailing consonant
const $fa1d9fd80dd7279e$var$LV = 4; // Composed <LV> syllable
const $fa1d9fd80dd7279e$var$LVT = 5; // Composed <LVT> syllable
const $fa1d9fd80dd7279e$var$M = 6; // Tone mark
// This function classifies a character using the above categories.
function $fa1d9fd80dd7279e$var$getType(code) {
    if ($fa1d9fd80dd7279e$var$isL(code)) return $fa1d9fd80dd7279e$var$L;
    if ($fa1d9fd80dd7279e$var$isV(code)) return $fa1d9fd80dd7279e$var$V;
    if ($fa1d9fd80dd7279e$var$isT(code)) return $fa1d9fd80dd7279e$var$T;
    if ($fa1d9fd80dd7279e$var$isLV(code)) return $fa1d9fd80dd7279e$var$LV;
    if ($fa1d9fd80dd7279e$var$isLVT(code)) return $fa1d9fd80dd7279e$var$LVT;
    if ($fa1d9fd80dd7279e$var$isTone(code)) return $fa1d9fd80dd7279e$var$M;
    return $fa1d9fd80dd7279e$var$X;
}
// State machine actions
const $fa1d9fd80dd7279e$var$NO_ACTION = 0;
const $fa1d9fd80dd7279e$var$DECOMPOSE = 1;
const $fa1d9fd80dd7279e$var$COMPOSE = 2;
const $fa1d9fd80dd7279e$var$TONE_MARK = 4;
const $fa1d9fd80dd7279e$var$INVALID = 5;
// Build a state machine that accepts valid syllables, and applies actions along the way.
// The logic this is implementing is documented at the top of the file.
const $fa1d9fd80dd7279e$var$STATE_TABLE = [
    //       X                 L                 V                T                  LV                LVT               M
    // State 0: start state
    [
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$INVALID,
            0
        ]
    ],
    // State 1: <L>
    [
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $fa1d9fd80dd7279e$var$COMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$INVALID,
            0
        ]
    ],
    // State 2: <L,V> or <LV>
    [
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$COMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$TONE_MARK,
            0
        ]
    ],
    // State 3: <L,V,T> or <LVT>
    [
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            1
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$NO_ACTION,
            0
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            2
        ],
        [
            $fa1d9fd80dd7279e$var$DECOMPOSE,
            3
        ],
        [
            $fa1d9fd80dd7279e$var$TONE_MARK,
            0
        ]
    ]
];
function $fa1d9fd80dd7279e$var$getGlyph(font, code, features) {
    return new $f22bb23c9fd478d8$export$2e2bcd8739ae039(font, font.glyphForCodePoint(code).id, [
        code
    ], features);
}
function $fa1d9fd80dd7279e$var$decompose(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyph.codePoints[0];
    let s = code - $fa1d9fd80dd7279e$var$HANGUL_BASE;
    let t = $fa1d9fd80dd7279e$var$T_BASE + s % $fa1d9fd80dd7279e$var$T_COUNT;
    s = s / $fa1d9fd80dd7279e$var$T_COUNT | 0;
    let l = $fa1d9fd80dd7279e$var$L_BASE + s / $fa1d9fd80dd7279e$var$V_COUNT | 0;
    let v = $fa1d9fd80dd7279e$var$V_BASE + s % $fa1d9fd80dd7279e$var$V_COUNT;
    // Don't decompose if all of the components are not available
    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== $fa1d9fd80dd7279e$var$T_BASE && !font.hasGlyphForCodePoint(t)) return i;
    // Replace the current glyph with decomposed L, V, and T glyphs,
    // and apply the proper OpenType features to each component.
    let ljmo = $fa1d9fd80dd7279e$var$getGlyph(font, l, glyph.features);
    ljmo.features.ljmo = true;
    let vjmo = $fa1d9fd80dd7279e$var$getGlyph(font, v, glyph.features);
    vjmo.features.vjmo = true;
    let insert = [
        ljmo,
        vjmo
    ];
    if (t > $fa1d9fd80dd7279e$var$T_BASE) {
        let tjmo = $fa1d9fd80dd7279e$var$getGlyph(font, t, glyph.features);
        tjmo.features.tjmo = true;
        insert.push(tjmo);
    }
    glyphs.splice(i, 1, ...insert);
    return i + insert.length - 1;
}
function $fa1d9fd80dd7279e$var$compose(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    let type = $fa1d9fd80dd7279e$var$getType(code);
    let prev = glyphs[i - 1].codePoints[0];
    let prevType = $fa1d9fd80dd7279e$var$getType(prev);
    // Figure out what type of syllable we're dealing with
    let lv, ljmo, vjmo, tjmo;
    if (prevType === $fa1d9fd80dd7279e$var$LV && type === $fa1d9fd80dd7279e$var$T) {
        // <LV,T>
        lv = prev;
        tjmo = glyph;
    } else {
        if (type === $fa1d9fd80dd7279e$var$V) {
            // <L,V>
            ljmo = glyphs[i - 1];
            vjmo = glyph;
        } else {
            // <L,V,T>
            ljmo = glyphs[i - 2];
            vjmo = glyphs[i - 1];
            tjmo = glyph;
        }
        let l = ljmo.codePoints[0];
        let v = vjmo.codePoints[0];
        // Make sure L and V are combining characters
        if ($fa1d9fd80dd7279e$var$isCombiningL(l) && $fa1d9fd80dd7279e$var$isCombiningV(v)) lv = $fa1d9fd80dd7279e$var$HANGUL_BASE + ((l - $fa1d9fd80dd7279e$var$L_BASE) * $fa1d9fd80dd7279e$var$V_COUNT + (v - $fa1d9fd80dd7279e$var$V_BASE)) * $fa1d9fd80dd7279e$var$T_COUNT;
    }
    let t = tjmo && tjmo.codePoints[0] || $fa1d9fd80dd7279e$var$T_BASE;
    if (lv != null && (t === $fa1d9fd80dd7279e$var$T_BASE || $fa1d9fd80dd7279e$var$isCombiningT(t))) {
        let s = lv + (t - $fa1d9fd80dd7279e$var$T_BASE);
        // Replace with a composed glyph if supported by the font,
        // otherwise apply the proper OpenType features to each component.
        if (font.hasGlyphForCodePoint(s)) {
            let del = prevType === $fa1d9fd80dd7279e$var$V ? 3 : 2;
            glyphs.splice(i - del + 1, del, $fa1d9fd80dd7279e$var$getGlyph(font, s, glyph.features));
            return i - del + 1;
        }
    }
    // Didn't compose (either a non-combining component or unsupported by font).
    if (ljmo) ljmo.features.ljmo = true;
    if (vjmo) vjmo.features.vjmo = true;
    if (tjmo) tjmo.features.tjmo = true;
    if (prevType === $fa1d9fd80dd7279e$var$LV) {
        // Sequence was originally <L,V>, which got combined earlier.
        // Either the T was non-combining, or the LVT glyph wasn't supported.
        // Decompose the glyph again and apply OT features.
        $fa1d9fd80dd7279e$var$decompose(glyphs, i - 1, font);
        return i + 1;
    }
    return i;
}
function $fa1d9fd80dd7279e$var$getLength(code) {
    switch($fa1d9fd80dd7279e$var$getType(code)){
        case $fa1d9fd80dd7279e$var$LV:
        case $fa1d9fd80dd7279e$var$LVT:
            return 1;
        case $fa1d9fd80dd7279e$var$V:
            return 2;
        case $fa1d9fd80dd7279e$var$T:
            return 3;
    }
}
function $fa1d9fd80dd7279e$var$reorderToneMark(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    // Move tone mark to the beginning of the previous syllable, unless it is zero width
    if (font.glyphForCodePoint(code).advanceWidth === 0) return;
    let prev = glyphs[i - 1].codePoints[0];
    let len = $fa1d9fd80dd7279e$var$getLength(prev);
    glyphs.splice(i, 1);
    return glyphs.splice(i - len, 0, glyph);
}
function $fa1d9fd80dd7279e$var$insertDottedCircle(glyphs, i, font) {
    let glyph = glyphs[i];
    let code = glyphs[i].codePoints[0];
    if (font.hasGlyphForCodePoint($fa1d9fd80dd7279e$var$DOTTED_CIRCLE)) {
        let dottedCircle = $fa1d9fd80dd7279e$var$getGlyph(font, $fa1d9fd80dd7279e$var$DOTTED_CIRCLE, glyph.features);
        // If the tone mark is zero width, insert the dotted circle before, otherwise after
        let idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
        glyphs.splice(idx, 0, dottedCircle);
        i++;
    }
    return i;
}
var $d22b56f2cf15e5ba$exports = {};
$d22b56f2cf15e5ba$exports = JSON.parse('{"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],"accepting":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],"tags":[[],["broken_cluster"],["consonant_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["broken_cluster"],["broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],[],["broken_cluster"],["symbol_cluster"],[],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["symbol_cluster"],["symbol_cluster"],["symbol_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],["broken_cluster"],[],[],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["broken_cluster"],["symbol_cluster"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],["consonant_syllable"],[],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],["vowel_syllable"],[],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],[],[],[],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],["standalone_cluster"],[],[],["standalone_cluster"],["standalone_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],[],[],[],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],[],[],[],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],[],[],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],["standalone_cluster"],[],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],[],[],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],[],[],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],[],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],[],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],[],[],[],[],["consonant_syllable","broken_cluster"],["consonant_syllable","broken_cluster"],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],[],[],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],["consonant_syllable"],[],["consonant_syllable"],["consonant_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],["vowel_syllable"],[],["vowel_syllable"],["vowel_syllable"],["broken_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],["standalone_cluster"],[],["standalone_cluster"],["standalone_cluster"],[],["consonant_syllable"],["vowel_syllable"],["standalone_cluster"]]}');
var $79781f8c452881c2$exports = {};
$79781f8c452881c2$exports = JSON.parse('{"categories":["O","IND","S","GB","B","FM","CGJ","VMAbv","VMPst","VAbv","VPst","CMBlw","VPre","VBlw","H","VMBlw","CMAbv","MBlw","CS","R","SUB","MPst","MPre","FAbv","FPst","FBlw","SMAbv","SMBlw","VMPre","ZWNJ","ZWJ","WJ","VS","N","HN","MAbv"],"decompositions":{"2507":[2503,2494],"2508":[2503,2519],"2888":[2887,2902],"2891":[2887,2878],"2892":[2887,2903],"3018":[3014,3006],"3019":[3015,3006],"3020":[3014,3031],"3144":[3142,3158],"3264":[3263,3285],"3271":[3270,3285],"3272":[3270,3286],"3274":[3270,3266],"3275":[3270,3266,3285],"3402":[3398,3390],"3403":[3399,3390],"3404":[3398,3415],"3546":[3545,3530],"3548":[3545,3535],"3549":[3545,3535,3530],"3550":[3545,3551],"3635":[3661,3634],"3763":[3789,3762],"3955":[3953,3954],"3957":[3953,3956],"3958":[4018,3968],"3959":[4018,3953,3968],"3960":[4019,3968],"3961":[4019,3953,3968],"3969":[3953,3968],"6971":[6970,6965],"6973":[6972,6965],"6976":[6974,6965],"6977":[6975,6965],"6979":[6978,6965],"69934":[69937,69927],"69935":[69938,69927],"70475":[70471,70462],"70476":[70471,70487],"70843":[70841,70842],"70844":[70841,70832],"70846":[70841,70845],"71098":[71096,71087],"71099":[71097,71087]},"stateTable":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,23,0,0,2,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,23,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,46,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,23,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,46,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],"accepting":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],"tags":[[],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],[],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["broken_cluster"],["independent_cluster"],["symbol_cluster"],["symbol_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["virama_terminated_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["standard_cluster"],["broken_cluster"],["broken_cluster"],["numeral_cluster"],["number_joiner_terminated_cluster"],["standard_cluster"],["standard_cluster"],["numeral_cluster"]]}');
const $79e3b6f2c331d0bf$export$a513ea61a7bee91c = {
    X: 1,
    C: 2,
    V: 4,
    N: 8,
    H: 16,
    ZWNJ: 32,
    ZWJ: 64,
    M: 128,
    SM: 256,
    VD: 512,
    A: 1024,
    Placeholder: 2048,
    Dotted_Circle: 4096,
    RS: 8192,
    Coeng: 16384,
    Repha: 32768,
    Ra: 65536,
    CM: 131072,
    Symbol: 262144 // Avagraha, etc that take marks (SM,A,VD).
};
const $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0 = {
    Start: 1,
    Ra_To_Become_Reph: 2,
    Pre_M: 4,
    Pre_C: 8,
    Base_C: 16,
    After_Main: 32,
    Above_C: 64,
    Before_Sub: 128,
    Below_C: 256,
    After_Sub: 512,
    Before_Post: 1024,
    Post_C: 2048,
    After_Post: 4096,
    Final_C: 8192,
    SMVD: 16384,
    End: 32768
};
const $79e3b6f2c331d0bf$export$8519deaa7de2b07 = $79e3b6f2c331d0bf$export$a513ea61a7bee91c.C | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Ra | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.CM | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.V | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Placeholder | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Dotted_Circle;
const $79e3b6f2c331d0bf$export$bbcd928767338e0d = $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWNJ;
const $79e3b6f2c331d0bf$export$ca9599b2a300afc = $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Coeng;
const $79e3b6f2c331d0bf$export$e99d119da76a0fc5 = {
    Default: {
        hasOldSpec: false,
        virama: 0,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Devanagari: {
        hasOldSpec: true,
        virama: 0x094D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Bengali: {
        hasOldSpec: true,
        virama: 0x09CD,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Sub,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Gurmukhi: {
        hasOldSpec: true,
        virama: 0x0A4D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Sub,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Gujarati: {
        hasOldSpec: true,
        virama: 0x0ACD,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Before_Post,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Oriya: {
        hasOldSpec: true,
        virama: 0x0B4D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Tamil: {
        hasOldSpec: true,
        virama: 0x0BCD,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: "Implicit",
        blwfMode: "Pre_And_Post"
    },
    Telugu: {
        hasOldSpec: true,
        virama: 0x0C4D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: "Explicit",
        blwfMode: "Post_Only"
    },
    Kannada: {
        hasOldSpec: true,
        virama: 0x0CCD,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post,
        rephMode: "Implicit",
        blwfMode: "Post_Only"
    },
    Malayalam: {
        hasOldSpec: true,
        virama: 0x0D4D,
        basePos: "Last",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main,
        rephMode: "Log_Repha",
        blwfMode: "Pre_And_Post"
    },
    // Handled by UniversalShaper
    // Sinhala: {
    //   hasOldSpec: false,
    //   virama: 0x0DCA,
    //   basePos: 'Last_Sinhala',
    //   rephPos: POSITIONS.After_Main,
    //   rephMode: 'Explicit',
    //   blwfMode: 'Pre_And_Post'
    // },
    Khmer: {
        hasOldSpec: false,
        virama: 0x17D2,
        basePos: "First",
        rephPos: $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph,
        rephMode: "Vis_Repha",
        blwfMode: "Pre_And_Post"
    }
};
const $79e3b6f2c331d0bf$export$f647c9cfdd77d95a = {
    // Khmer
    0x17BE: [
        0x17C1,
        0x17BE
    ],
    0x17BF: [
        0x17C1,
        0x17BF
    ],
    0x17C0: [
        0x17C1,
        0x17C0
    ],
    0x17C4: [
        0x17C1,
        0x17C4
    ],
    0x17C5: [
        0x17C1,
        0x17C5
    ]
};
const { decompositions: $d203e6b9523d0071$var$decompositions } = /*@__PURE__*/ $parcel$interopDefault($79781f8c452881c2$exports);
const $d203e6b9523d0071$var$trie = new ($parcel$interopDefault($gfJaN$unicodetrie))($66a5b9fb5318558a$export$94fdf11bafc8de6b("AAARAAAAAACgwgAAAbENTvLtnX+sHUUVx/f13nd/vHf7bl+FRGL7R0OJMcWYphBrimkVCSJR2xiEaLEGQ7AkBGowbYRSgj8K2B/GkpRYE6wlQSyJKCagrSlGkmqsqUZMY7S2CWkgqQViQSkt4Hfuzrx77tyZ2fm1u+/RPcknuzs7O3PmnDOzs7N73zteS5KXwKvgDTCnniTvBfPBJeAVpP2vFr69GGUtAkvAModyr0DeT4BrwCpwPVgDbga3ga+DjYbyluLcCvBN8F2wGWwHO8Ej4DjyPIbtz0DCeZpvD4CD4E/gb+AoOAFOgtPgLKiNJkkbTIKLwALwfvAh8GGwHFwFPg2uAzeCm8Ft4E5wN7gPPAi+D34AfgR+Ap7kx8+AZ8HvwZ/BEXAMvAheAa+Bc6OpzvVGknTABY30eB62C8GlYDFYCpaDq/n5z2J7PVgDbgG3N1KbrOdbWzby/N/G9i6wlR8/wLebUNcOll7vX7PLsQ4bdpAy92B/L3gK7AO/A38EfwX/AC+AkyT/m3x7mqdtYz7Gfq2ZJOPgPc3UXu/D9uJmmmcRT1uC7TJwZTONJxFL1+J4JbgBrAG3gNv5Nev5dhO2m3l54rqtON7RNLd1V8Z5auMfI+8Wbvv12P4Ux78AvyZl/Bb7fwD34HwH/EVR/t8t6rRlrYgFlHnMsdyXIupRFP+Gzv8Bb4CklSSjrTR9bz21uZx/Nj8v+uIFOJ4HFnJo3kWtNG6WkPSzBl1YbC8jeVfx+q+R9Pg48lxN8jFdhd8+01LrLTCdq6io8GNb1a8qKioqKioqKioc2cbXGcrWQ2Ynf9a9rmV/zVua9Dc16V/gz8pfxvar4A6wAdwL7gdbwUPgh+BR8AR4qpWuLe3D9gA4CA6DI+AoOAFOtdL1nNexfYs937fxDA8ubKf1zmv3dViI/Uvb9m2sqKioqAiHrVtehrH3TK2/3l4WZduioqIiDq+Rd1Jbef9ehnHmSnCtNNf7nOPcr8PHilO8jrfBF9v996lfwf6tUpl3tPvvdSjsvcwGnLt3Gsw/kzkpK8CdYH83my3Id0iT91WkL5xMktXgIfD85OD54zjfmYu5OFgN7h1LkmdBMg5fgbvAChzv49ujfEuZ3xlOk7kReTaSfL/B/jl+fMXsJLkb7AcPj8TlHC/zsgnYcyLd3zSh1vGAJr2ioqKiIn/eKXkMjn3/cWF5t/z6y37+K5urwP2YB36vPfw8yr7zeRjpu8g8cTf2H2+n89EtivLE93fs27Ez/Br2vM2+qWPl/ZyX9StFfQxW5v724PPxzXz7XHu4Pps5Jvtmiq13szmzfP0hlHkYHGn358bHeD0vYvsy+K+kz9vt/jy8gT40G1w4Rua0PN98nnaGf/e1G+mXIO2DY8P6Xz7WPz7Ky/7omJ0PBff4+B91fAqsAp8HXwI3gR04txbbdWDDWDpP/g7Yxs6BXWAP2AueJHo+M5bOpw+Cw+AIOApOgFMW7Xkdec6AkXH1+QfgyzbOTY73jy/C/gJ+/CCOP4D9xfz4I9h+TFMWtf9SRWzZwq7f0yi/L9voWSRbDfV/clx/3TuKfjoT26/iX813URx4tiVG3ay/sfFuJenb7J50A4mr1di/CZzLKZ6y2reunup4qzT+fM0wHp0PUD9+A7bYNJ5fn3eNP/Ft5bc0+S4n9/l1Gj+K82zesd1wfj3fZ79h2YyyVvLj7djfCR4xjJEyuy1+S/FyDt/MPwodn5hB8axrxy9nSBtYjOyHrs+BQ+B58E+u+wsWbWBtpb/hYL8RuA/pJ8fT2GffX+wl+daSa08jz9nxNG2k4963XBG/ZVhpUS573mh3BtPo7x/Eb7pE2yd5XvZssY/M/RZLc9SLeDsfD5gfTidi9//pwrzWu7t9lKcN7dxynthAh8vcKrQu1frHTGKBNF662KfoOXU1FsaFxe6x2kjClkBnGvXxwX0bytZ5unK+S9n2jxabTc5M0HUaIyTrfFa+Ljmflc9Xz7JtNdPa4eKz6WAPlb5l6xfLBzopWxcfncvSf7rHRJk2KSN2bKRsvcu2UZmxVIb9qd551e8rZcTERGuQ+qwIjERkjl2+djOlhWfpibnp/qxmP92FVr1/bc9GYxxuI5o3UzdukzYpj+H6nOxra9nHiaksjhDdsasPe9ca/CvOU1GVwUT4t8P921H4T8gsnkdIh+dn/pXrU0mnOZw21CbJv1P5LP0r4jtkbLH171BbCvavnFfeZ8L8K2wv/CuQRU6n/qWSNSbr2mO8xtK/U+Mq6Y/1yQyFJHHtv8Kn2uOC/Gvbf2VEPxJ9SvhY5d+Q+y21iRxLruOzsY6MWGrOkPHZ1b+jFuPzqEX/VcmoZkyIPT53k36/DZnrMd+K/Dbjs6kv6+6VYl9OU+WT07TplvMvWWhfVo3f4t48S+rbjIZl/1b5Xyd5vJdQiTyf7tUdMlbn0J9d/cn6c7M5DO1TNF0+bmT0Z3qdKaaoXeg1Lv7NEhufzyT/6vIKEeO1jX/psdi38a889qpkStcI/u12U3zE1Re+/Yv6QNwvdTDJGi9t2ps1XtKYDJ0PmcZKcU812sRxvms7J47mZ5c+SWJD5LPRg4qqj+nWL8Q5sRVrGar1EG0sOI6ndH3DVWL7wpeuwaY6O1Nh19N+Oqs5uI7Eto3aICxNrCn5rAuZ7Cn2bdJtfZPlL/k8Ld+ki6v9E56XPUvT52mV/YVvmMj2Zz8TEuNMTxfHuFfFUJ60OLrz1utODnFG47fLbSjXy0xSy4gN63EywlhMxWcNmK71svszi5OGTvdJe3rtd8ifB6I/mKBr1ap7uU/sqqTsMb+H5fxBFyuq+yqLnd7cmj33TwyOVVOwuj3nVXRtQtUGWR9jzI6kecZrKSKPuFakU2hZmXXZMDlsS1W9jBavv6eHpf3EtfJ7mKwYV0lX2g9FVY5N+Ung9aH1590+n3KLgEredfiez6u9svisY/Suk9Jsnkli1a+C1m/T7rzqd5UY9mfiXX9R92ibdZUIawTC96b1GBn6rDG1JsPv/b392SkiXVUGmyN0LO5LYi46Zf/Adc/QMaCo8TtG/bH1Z/TsW1QfUPRjm2cZee5PRaT33lEbnhlMax4qe1o/Y8a0icdaoOv9bsh+Hj6jonueoGtHumcMlX9lxLxXq7/D84fSzznGt6rtUerXxYU47/IcPeG3vqBbJ1StETZqg9fS2Akd/0Ovp+/CxD3P+/6bQwzJtsvyh5w+XjeXH9KfXGH3/VbSX4tS4XoftPZbnvcyxX1G5QvW1wbWTkbs7c3mTco6NWODbdxk3R9lGZo/aGxhiknTmETXLVs1c90u9+mBGCf6hs6fsmTq29sxPv8d82CuhCpNjGNjg31blGHrz1i41hd6nuYzbU3XhLQzj7Jt67Otw0uXUdDoH8e4F/joMdVui2dMJc3E+Tetvr6jEtPnPhJaVwz9Y7TDVlx1qnfitlEbtzlTVD0qX/pcm1esxI65PO3mU4eNrr5SZMz46FDE+aIlb5tntb1o/WOUETsW847pvNpaZH225eUpNnrS9yDy9wTysyr9XVOe63+qd3M6e4X6Ptd1Dpc1SdV53ZqFag1hpP+bE5f4ivY74BzXilzWWW1+S0TjJng91Gd9wmbNgpMVz6W8d7GJZwWtWp8p++c8fpjW0Vzff3dJfzGuoersEtnmpjVLupY48H6o7n8/C+kvJn+Lcd6q3QHx3usvZax3W8apvP6rev+UJSHfiCYe/h2aTwTaRi5DO28ZSd9zNhTfJ8b2je7drOo9HtNNbPMW03zOpq2qNqnKFN+0huhlMye2Pe9TdzfCedfxMlRfG7xjncaJ7fiXMYZk3X+ZvuKbXCGh8y8XH8TybajPTfq4tjG2/qb0RJO3SB19ba2SMuoNbW8R/g653qa9sdsRYsssu+ZxPss+tnayFd94yjofEi+hZdvo73q9jd3yisUYbfEpQ9XmMqUIm2fFZh4xkZeE1BNDL5v+ZcqXh/90bSwjflz8U0QcFWHzPOpy0amM+stqf1ad7LltVPqWmG3p3+GiIvLJf8duYA3NcBwbWRpkDXmo7RP+z5E6+8Xswz512dbrW2aMNrpKaBt9y45VR2j9efhAQL/PF38Xadq907NYC5dpZLy3kMX6PUHgeGGS3nfoPn9rObJ9s/4uMntnSt/J5TX+2ZRhtFcB8ZgVmyZbit8GCd/7/C7EOcYK7LdyjNhIlL81nqN/Xf9mOHt/anovP4X0tyem/OUZF9TmscY2nzEulq96ZeVwv2Bxxnwk3s9njT8m/YWOKl199fe53tTXyu5DLojfKWXej6R3RAPtDf1ex/PvtdJ8Q7aP7Ht6XpdXSJf8/wMdQuS/j0/HtKny9KbT+oT2K2ETuW7Tt09Uss5nCdWhjPuMTXzrztO4FHMy+V6TJaH9I6+2C5HPq9oc8xlKRva5rF8M/7tC26/6BsNFivQ//e1pVsyP19VrNrH1D5Wi7oUDdVp8Q5HVr1ztlzXPtH2Gc30+lMX3edH3ecm3fp0+Ps/IPvWH6OpiV7meEMlbzyIkpi1jtDU0Pmm6nMd0jU8bXK7N0jWkb/joHyNebfWgtrJpc0h7QiQP24aKqcwYPnTRIUmG63fRQ5VXLsekgy5NtVXVadLfpjzV9S6xYnuNri159ZmsmLCpJ8/6XSRGOaH659H+GLYtwhd51xvq31B9Qm0UavM84qhoKaNOnfwf"));
const $d203e6b9523d0071$var$stateMachine = new ($parcel$interopDefault($gfJaN$dfa))(/*@__PURE__*/ $parcel$interopDefault($d22b56f2cf15e5ba$exports));
class $d203e6b9523d0071$export$2e2bcd8739ae039 extends $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.addStage($d203e6b9523d0071$var$setupSyllables);
        plan.addStage([
            "locl",
            "ccmp"
        ]);
        plan.addStage($d203e6b9523d0071$var$initialReordering);
        plan.addStage("nukt");
        plan.addStage("akhn");
        plan.addStage("rphf", false);
        plan.addStage("rkrf");
        plan.addStage("pref", false);
        plan.addStage("blwf", false);
        plan.addStage("abvf", false);
        plan.addStage("half", false);
        plan.addStage("pstf", false);
        plan.addStage("vatu");
        plan.addStage("cjct");
        plan.addStage("cfar", false);
        plan.addStage($d203e6b9523d0071$var$finalReordering);
        plan.addStage({
            local: [
                "init"
            ],
            global: [
                "pres",
                "abvs",
                "blws",
                "psts",
                "haln",
                "dist",
                "abvm",
                "blwm",
                "calt",
                "clig"
            ]
        });
        // Setup the indic config for the selected script
        plan.unicodeScript = $e38a1a895f6aeb54$export$ce50e82f12a827a4(plan.script);
        plan.indicConfig = $79e3b6f2c331d0bf$export$e99d119da76a0fc5[plan.unicodeScript] || $79e3b6f2c331d0bf$export$e99d119da76a0fc5.Default;
        plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== "2";
    // TODO: turn off kern (Khmer) and liga features.
    }
    static assignFeatures(plan, glyphs) {
        // Decompose split matras
        // TODO: do this in a more general unicode normalizer
        for(let i = glyphs.length - 1; i >= 0; i--){
            let codepoint = glyphs[i].codePoints[0];
            let d = $79e3b6f2c331d0bf$export$f647c9cfdd77d95a[codepoint] || $d203e6b9523d0071$var$decompositions[codepoint];
            if (d) {
                let decomposed = d.map((c)=>{
                    let g = plan.font.glyphForCodePoint(c);
                    return new $f22bb23c9fd478d8$export$2e2bcd8739ae039(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice(i, 1, ...decomposed);
            }
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)($d203e6b9523d0071$export$2e2bcd8739ae039, "zeroMarkWidths", "NONE");
function $d203e6b9523d0071$var$indicCategory(glyph) {
    return $d203e6b9523d0071$var$trie.get(glyph.codePoints[0]) >> 8;
}
function $d203e6b9523d0071$var$indicPosition(glyph) {
    return 1 << ($d203e6b9523d0071$var$trie.get(glyph.codePoints[0]) & 0xff);
}
class $d203e6b9523d0071$var$IndicInfo {
    constructor(category, position, syllableType, syllable){
        this.category = category;
        this.position = position;
        this.syllableType = syllableType;
        this.syllable = syllable;
    }
}
function $d203e6b9523d0071$var$setupSyllables(font, glyphs) {
    let syllable = 0;
    let last = 0;
    for (let [start, end, tags] of $d203e6b9523d0071$var$stateMachine.match(glyphs.map($d203e6b9523d0071$var$indicCategory))){
        if (start > last) {
            ++syllable;
            for(let i = last; i < start; i++)glyphs[i].shaperInfo = new $d203e6b9523d0071$var$IndicInfo($79e3b6f2c331d0bf$export$a513ea61a7bee91c.X, $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.End, "non_indic_cluster", syllable);
        }
        ++syllable;
        // Create shaper info
        for(let i = start; i <= end; i++)glyphs[i].shaperInfo = new $d203e6b9523d0071$var$IndicInfo(1 << $d203e6b9523d0071$var$indicCategory(glyphs[i]), $d203e6b9523d0071$var$indicPosition(glyphs[i]), tags[0], syllable);
        last = end + 1;
    }
    if (last < glyphs.length) {
        ++syllable;
        for(let i = last; i < glyphs.length; i++)glyphs[i].shaperInfo = new $d203e6b9523d0071$var$IndicInfo($79e3b6f2c331d0bf$export$a513ea61a7bee91c.X, $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.End, "non_indic_cluster", syllable);
    }
}
function $d203e6b9523d0071$var$isConsonant(glyph) {
    return glyph.shaperInfo.category & $79e3b6f2c331d0bf$export$8519deaa7de2b07;
}
function $d203e6b9523d0071$var$isJoiner(glyph) {
    return glyph.shaperInfo.category & $79e3b6f2c331d0bf$export$bbcd928767338e0d;
}
function $d203e6b9523d0071$var$isHalantOrCoeng(glyph) {
    return glyph.shaperInfo.category & $79e3b6f2c331d0bf$export$ca9599b2a300afc;
}
function $d203e6b9523d0071$var$wouldSubstitute(glyphs, feature) {
    for (let glyph of glyphs)glyph.features = {
        [feature]: true
    };
    let GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
    GSUB.applyFeatures([
        feature
    ], glyphs);
    return glyphs.length === 1;
}
function $d203e6b9523d0071$var$consonantPosition(font, consonant, virama) {
    let glyphs = [
        virama,
        consonant,
        virama
    ];
    if ($d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(0, 2), "blwf") || $d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(1, 3), "blwf")) return $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C;
    else if ($d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(0, 2), "pstf") || $d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(1, 3), "pstf")) return $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C;
    else if ($d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(0, 2), "pref") || $d203e6b9523d0071$var$wouldSubstitute(glyphs.slice(1, 3), "pref")) return $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C;
    return $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C;
}
function $d203e6b9523d0071$var$initialReordering(font, glyphs, plan) {
    let indicConfig = plan.indicConfig;
    let features = font._layoutEngine.engine.GSUBProcessor.features;
    let dottedCircle = font.glyphForCodePoint(0x25cc).id;
    let virama = font.glyphForCodePoint(indicConfig.virama).id;
    if (virama) {
        let info = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(font, virama, [
            indicConfig.virama
        ]);
        for(let i = 0; i < glyphs.length; i++)if (glyphs[i].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) glyphs[i].shaperInfo.position = $d203e6b9523d0071$var$consonantPosition(font, glyphs[i].copy(), info);
    }
    for(let start = 0, end = $d203e6b9523d0071$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $d203e6b9523d0071$var$nextSyllable(glyphs, start)){
        let { category: category, syllableType: syllableType } = glyphs[start].shaperInfo;
        if (syllableType === "symbol_cluster" || syllableType === "non_indic_cluster") continue;
        if (syllableType === "broken_cluster" && dottedCircle) {
            let g = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = new $d203e6b9523d0071$var$IndicInfo(1 << $d203e6b9523d0071$var$indicCategory(g), $d203e6b9523d0071$var$indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);
            // Insert after possible Repha.
            let i = start;
            while(i < end && glyphs[i].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Repha)i++;
            glyphs.splice(i++, 0, g);
            end++;
        }
        // 1. Find base consonant:
        //
        // The shaping engine finds the base consonant of the syllable, using the
        // following algorithm: starting from the end of the syllable, move backwards
        // until a consonant is found that does not have a below-base or post-base
        // form (post-base forms have to follow below-base forms), or that is not a
        // pre-base reordering Ra, or arrive at the first consonant. The consonant
        // stopped at will be the base.
        let base = end;
        let limit = start;
        let hasReph = false;
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        if (indicConfig.rephPos !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === "Implicit" && !$d203e6b9523d0071$var$isJoiner(glyphs[start + 2]) || indicConfig.rephMode === "Explicit" && glyphs[start + 2].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ)) {
            // See if it matches the 'rphf' feature.
            let g = [
                glyphs[start].copy(),
                glyphs[start + 1].copy(),
                glyphs[start + 2].copy()
            ];
            if ($d203e6b9523d0071$var$wouldSubstitute(g.slice(0, 2), "rphf") || indicConfig.rephMode === "Explicit" && $d203e6b9523d0071$var$wouldSubstitute(g, "rphf")) {
                limit += 2;
                while(limit < end && $d203e6b9523d0071$var$isJoiner(glyphs[limit]))limit++;
                base = start;
                hasReph = true;
            }
        } else if (indicConfig.rephMode === "Log_Repha" && glyphs[start].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Repha) {
            limit++;
            while(limit < end && $d203e6b9523d0071$var$isJoiner(glyphs[limit]))limit++;
            base = start;
            hasReph = true;
        }
        switch(indicConfig.basePos){
            case "Last":
                {
                    // starting from the end of the syllable, move backwards
                    let i = end;
                    let seenBelow = false;
                    do {
                        let info = glyphs[--i].shaperInfo;
                        // until a consonant is found
                        if ($d203e6b9523d0071$var$isConsonant(glyphs[i])) {
                            // that does not have a below-base or post-base form
                            // (post-base forms have to follow below-base forms),
                            if (info.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C && (info.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C || seenBelow)) {
                                base = i;
                                break;
                            }
                            // or that is not a pre-base reordering Ra,
                            //
                            // IMPLEMENTATION NOTES:
                            //
                            // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                            // by the logic above already.
                            //
                            // or arrive at the first consonant. The consonant stopped at will
                            // be the base.
                            if (info.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C) seenBelow = true;
                            base = i;
                        } else if (start < i && info.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ && glyphs[i - 1].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H) break;
                    }while (i > limit);
                    break;
                }
            case "First":
                // The first consonant is always the base.
                base = start;
                // Mark all subsequent consonants as below.
                for(let i = base + 1; i < end; i++)if ($d203e6b9523d0071$var$isConsonant(glyphs[i])) glyphs[i].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C;
        }
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        //
        //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
        if (hasReph && base === start && limit - base <= 2) hasReph = false;
        // 2. Decompose and reorder Matras:
        //
        // Each matra and any syllable modifier sign in the cluster are moved to the
        // appropriate position relative to the consonant(s) in the cluster. The
        // shaping engine decomposes two- or three-part matras into their constituent
        // parts before any repositioning. Matra characters are classified by which
        // consonant in a conjunct they have affinity for and are reordered to the
        // following positions:
        //
        //   o Before first half form in the syllable
        //   o After subjoined consonants
        //   o After post-form consonant
        //   o After main consonant (for above marks)
        //
        // IMPLEMENTATION NOTES:
        //
        // The normalize() routine has already decomposed matras for us, so we don't
        // need to worry about that.
        // 3.  Reorder marks to canonical order:
        //
        // Adjacent nukta and halant or nukta and vedic sign are always repositioned
        // if necessary, so that the nukta is first.
        //
        // IMPLEMENTATION NOTES:
        //
        // We don't need to do this: the normalize() routine already did this for us.
        // Reorder characters
        for(let i1 = start; i1 < base; i1++){
            let info = glyphs[i1].shaperInfo;
            info.position = Math.min($79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_C, info.position);
        }
        if (base < end) glyphs[base].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C;
        // Mark final consonants.  A final consonant is one appearing after a matra,
        // like in Khmer.
        for(let i2 = base + 1; i2 < end; i2++)if (glyphs[i2].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) {
            for(let j = i2 + 1; j < end; j++)if ($d203e6b9523d0071$var$isConsonant(glyphs[j])) {
                glyphs[j].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Final_C;
                break;
            }
            break;
        }
        // Handle beginning Ra
        if (hasReph) glyphs[start].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph;
        // For old-style Indic script tags, move the first post-base Halant after
        // last consonant.
        //
        // Reports suggest that in some scripts Uniscribe does this only if there
        // is *not* a Halant after last consonant already (eg. Kannada), while it
        // does it unconditionally in other scripts (eg. Malayalam).  We don't
        // currently know about other scripts, so we single out Malayalam for now.
        //
        // Kannada test case:
        // U+0C9A,U+0CCD,U+0C9A,U+0CCD
        // With some versions of Lohit Kannada.
        // https://bugs.freedesktop.org/show_bug.cgi?id=59118
        //
        // Malayalam test case:
        // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
        // With lohit-ttf-20121122/Lohit-Malayalam.ttf
        if (plan.isOldSpec) {
            let disallowDoubleHalants = plan.unicodeScript !== "Malayalam";
            for(let i = base + 1; i < end; i++)if (glyphs[i].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H) {
                let j;
                for(j = end - 1; j > i; j--){
                    if ($d203e6b9523d0071$var$isConsonant(glyphs[j]) || disallowDoubleHalants && glyphs[j].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H) break;
                }
                if (glyphs[j].shaperInfo.category !== $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H && j > i) {
                    // Move Halant to after last consonant.
                    let t = glyphs[i];
                    glyphs.splice(i, 0, ...glyphs.splice(i + 1, j - i));
                    glyphs[j] = t;
                }
                break;
            }
        }
        // Attach misc marks to previous char to move with them.
        let lastPos = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Start;
        for(let i3 = start; i3 < end; i3++){
            let info = glyphs[i3].shaperInfo;
            if (info.category & ($79e3b6f2c331d0bf$export$bbcd928767338e0d | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.N | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.RS | $79e3b6f2c331d0bf$export$a513ea61a7bee91c.CM | $79e3b6f2c331d0bf$export$ca9599b2a300afc & info.category)) {
                info.position = lastPos;
                if (info.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H && info.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                    // Uniscribe doesn't move the Halant with Left Matra.
                    // TEST: U+092B,U+093F,U+094DE
                    // We follow.  This is important for the Sinhala
                    // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                    // where U+0DD9 is a left matra and U+0DCA is the virama.
                    // We don't want to move the virama with the left matra.
                    // TEST: U+0D9A,U+0DDA
                    for(let j = i3; j > start; j--)if (glyphs[j - 1].shaperInfo.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                        info.position = glyphs[j - 1].shaperInfo.position;
                        break;
                    }
                }
            } else if (info.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD) lastPos = info.position;
        }
        // For post-base consonants let them own anything before them
        // since the last consonant or matra.
        let last = base;
        for(let i4 = base + 1; i4 < end; i4++){
            if ($d203e6b9523d0071$var$isConsonant(glyphs[i4])) {
                for(let j = last + 1; j < i4; j++)if (glyphs[j].shaperInfo.position < $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD) glyphs[j].shaperInfo.position = glyphs[i4].shaperInfo.position;
                last = i4;
            } else if (glyphs[i4].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) last = i4;
        }
        let arr = glyphs.slice(start, end);
        arr.sort((a, b)=>a.shaperInfo.position - b.shaperInfo.position);
        glyphs.splice(start, arr.length, ...arr);
        // Find base again
        for(let i5 = start; i5 < end; i5++)if (glyphs[i5].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) {
            base = i5;
            break;
        }
        // Setup features now
        // Reph
        for(let i6 = start; i6 < end && glyphs[i6].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph; i6++)glyphs[i6].features.rphf = true;
        // Pre-base
        let blwf = !plan.isOldSpec && indicConfig.blwfMode === "Pre_And_Post";
        for(let i7 = start; i7 < base; i7++){
            glyphs[i7].features.half = true;
            if (blwf) glyphs[i7].features.blwf = true;
        }
        // Post-base
        for(let i8 = base + 1; i8 < end; i8++){
            glyphs[i8].features.abvf = true;
            glyphs[i8].features.pstf = true;
            glyphs[i8].features.blwf = true;
        }
        if (plan.isOldSpec && plan.unicodeScript === "Devanagari") {
            // Old-spec eye-lash Ra needs special handling.  From the
            // spec:
            //
            // "The feature 'below-base form' is applied to consonants
            // having below-base forms and following the base consonant.
            // The exception is vattu, which may appear below half forms
            // as well as below the base glyph. The feature 'below-base
            // form' will be applied to all such occurrences of Ra as well."
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
            // with Sanskrit 2003 font.
            //
            // However, note that Ra,Halant,ZWJ is the correct way to
            // request eyelash form of Ra, so we wouldbn't inhibit it
            // in that sequence.
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
            for(let i = start; i + 1 < base; i++)if (glyphs[i].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Ra && glyphs[i + 1].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.H && (i + 1 === base || glyphs[i + 2].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ)) {
                glyphs[i].features.blwf = true;
                glyphs[i + 1].features.blwf = true;
            }
        }
        let prefLen = 2;
        if (features.pref && base + prefLen < end) for(let i9 = base + 1; i9 + prefLen - 1 < end; i9++){
            let g = [
                glyphs[i9].copy(),
                glyphs[i9 + 1].copy()
            ];
            if ($d203e6b9523d0071$var$wouldSubstitute(g, "pref")) {
                for(let j = 0; j < prefLen; j++)glyphs[i9++].features.pref = true;
                // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                // Read the feature spec.
                // This allows distinguishing the following cases with MS Khmer fonts:
                // U+1784,U+17D2,U+179A,U+17D2,U+1782
                // U+1784,U+17D2,U+1782,U+17D2,U+179A
                if (features.cfar) for(; i9 < end; i9++)glyphs[i9].features.cfar = true;
                break;
            }
        }
        // Apply ZWJ/ZWNJ effects
        for(let i10 = start + 1; i10 < end; i10++)if ($d203e6b9523d0071$var$isJoiner(glyphs[i10])) {
            let nonJoiner = glyphs[i10].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWNJ;
            let j = i10;
            do {
                j--;
                // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                // being there, since we don't skip them for the CJCT
                // feature (ie. F_MANUAL_ZWJ)
                // A ZWNJ disables HALF.
                if (nonJoiner) delete glyphs[j].features.half;
            }while (j > start && !$d203e6b9523d0071$var$isConsonant(glyphs[j]));
        }
    }
}
function $d203e6b9523d0071$var$finalReordering(font, glyphs, plan) {
    let indicConfig = plan.indicConfig;
    let features = font._layoutEngine.engine.GSUBProcessor.features;
    for(let start = 0, end = $d203e6b9523d0071$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $d203e6b9523d0071$var$nextSyllable(glyphs, start)){
        // 4. Final reordering:
        //
        // After the localized forms and basic shaping forms GSUB features have been
        // applied (see below), the shaping engine performs some final glyph
        // reordering before applying all the remaining font features to the entire
        // cluster.
        let tryPref = !!features.pref;
        // Find base again
        let base = start;
        for(; base < end; base++)if (glyphs[base].shaperInfo.position >= $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) {
            if (tryPref && base + 1 < end) {
                for(let i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                    if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                        // Ok, this was a 'pref' candidate but didn't form any.
                        // Base is around here...
                        base = i;
                        while(base < end && $d203e6b9523d0071$var$isHalantOrCoeng(glyphs[base]))base++;
                        glyphs[base].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.BASE_C;
                        tryPref = false;
                    }
                    break;
                }
            }
            // For Malayalam, skip over unformed below- (but NOT post-) forms.
            if (plan.unicodeScript === "Malayalam") for(let i = base + 1; i < end; i++){
                while(i < end && $d203e6b9523d0071$var$isJoiner(glyphs[i]))i++;
                if (i === end || !$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[i])) break;
                i++; // Skip halant.
                while(i < end && $d203e6b9523d0071$var$isJoiner(glyphs[i]))i++;
                if (i < end && $d203e6b9523d0071$var$isConsonant(glyphs[i]) && glyphs[i].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Below_C) {
                    base = i;
                    glyphs[base].shaperInfo.position = $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C;
                }
            }
            if (start < base && glyphs[base].shaperInfo.position > $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Base_C) base--;
            break;
        }
        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.ZWJ) base--;
        if (base < end) while(start < base && glyphs[base].shaperInfo.category & ($79e3b6f2c331d0bf$export$a513ea61a7bee91c.N | $79e3b6f2c331d0bf$export$ca9599b2a300afc))base--;
        // o Reorder matras:
        //
        // If a pre-base matra character had been reordered before applying basic
        // features, the glyph can be moved closer to the main consonant based on
        // whether half-forms had been formed. Actual position for the matra is
        // defined as “after last standalone halant glyph, after initial matra
        // position and before the main consonant”. If ZWJ or ZWNJ follow this
        // halant, position is moved after it.
        //
        if (start + 1 < end && start < base) {
            // If we lost track of base, alas, position before last thingy.
            let newPos = base === end ? base - 2 : base - 1;
            // Malayalam / Tamil do not have "half" forms or explicit virama forms.
            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
            // We want to position matra after them.
            if (plan.unicodeScript !== "Malayalam" && plan.unicodeScript !== "Tamil") {
                while(newPos > start && !(glyphs[newPos].shaperInfo.category & ($79e3b6f2c331d0bf$export$a513ea61a7bee91c.M | $79e3b6f2c331d0bf$export$ca9599b2a300afc)))newPos--;
                // If we found no Halant we are done.
                // Otherwise only proceed if the Halant does
                // not belong to the Matra itself!
                if ($d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                    if (newPos + 1 < end && $d203e6b9523d0071$var$isJoiner(glyphs[newPos + 1])) newPos++;
                } else newPos = start; // No move.
            }
            if (start < newPos && glyphs[newPos].shaperInfo.position !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                // Now go see if there's actually any matras...
                for(let i = newPos; i > start; i--)if (glyphs[i - 1].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M) {
                    let oldPos = i - 1;
                    if (oldPos < base && base <= newPos) base--;
                    let tmp = glyphs[oldPos];
                    glyphs.splice(oldPos, 0, ...glyphs.splice(oldPos + 1, newPos - oldPos));
                    glyphs[newPos] = tmp;
                    newPos--;
                }
            }
        }
        // o Reorder reph:
        //
        // Reph’s original position is always at the beginning of the syllable,
        // (i.e. it is not reordered at the character reordering stage). However,
        // it will be reordered according to the basic-forms shaping results.
        // Possible positions for reph, depending on the script, are; after main,
        // before post-base consonant forms, and after post-base consonant forms.
        // Two cases:
        //
        // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
        //   we should only move it if the sequence ligated to the repha form.
        //
        // - If repha is encoded separately and in the logical position, we should only
        //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
        //   to make it work without the reordering.
        if (start + 1 < end && glyphs[start].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
            let newRephPos;
            let rephPos = indicConfig.rephPos;
            let found = false;
            // 1. If reph should be positioned after post-base consonant forms,
            //    proceed to step 5.
            if (rephPos !== $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post) {
                //  2. If the reph repositioning class is not after post-base: target
                //     position is after the first explicit halant glyph between the
                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                //     are following this halant, position is moved after it. If such
                //     position is found, this is the target position. Otherwise,
                //     proceed to the next step.
                //
                //     Note: in old-implementation fonts, where classifications were
                //     fixed in shaping engine, there was no case where reph position
                //     will be found on this step.
                newRephPos = start + 1;
                while(newRephPos < base && !$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $d203e6b9523d0071$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
                // 3. If reph should be repositioned after the main consonant: find the
                //    first consonant not ligated with main, or find the first
                //    consonant that is not a potential pre-base reordering Ra.
                if (!found && rephPos === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Main)newRephPos++;
                    found = newRephPos < end;
                }
                // 4. If reph should be positioned before post-base consonant, find
                //    first post-base classified consonant not ligated with main. If no
                //    consonant is found, the target position should be before the
                //    first matra, syllable modifier sign or vedic sign.
                //
                // This is our take on what step 4 is trying to say (and failing, BADLY).
                if (!found && rephPos === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Sub) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & ($79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Post_C | $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.After_Post | $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD)))newRephPos++;
                    found = newRephPos < end;
                }
            }
            //  5. If no consonant is found in steps 3 or 4, move reph to a position
            //     immediately before the first post-base matra, syllable modifier
            //     sign or vedic sign that has a reordering class after the intended
            //     reph position. For example, if the reordering position for reph
            //     is post-main, it will skip above-base matras that also have a
            //     post-main position.
            if (!found) {
                // Copied from step 2.
                newRephPos = start + 1;
                while(newRephPos < base && !$d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $d203e6b9523d0071$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
            }
            // 6. Otherwise, reorder reph to the end of the syllable.
            if (!found) {
                newRephPos = end - 1;
                while(newRephPos > start && glyphs[newRephPos].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.SMVD)newRephPos--;
                // If the Reph is to be ending up after a Matra,Halant sequence,
                // position it before that Halant so it can interact with the Matra.
                // However, if it's a plain Consonant,Halant we shouldn't do that.
                // Uniscribe doesn't do this.
                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
                if ($d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    for(let i = base + 1; i < newRephPos; i++)if (glyphs[i].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) newRephPos--;
                }
            }
            let reph = glyphs[start];
            glyphs.splice(start, 0, ...glyphs.splice(start + 1, newRephPos - start));
            glyphs[newRephPos] = reph;
            if (start < base && base <= newRephPos) base--;
        }
        // o Reorder pre-base reordering consonants:
        //
        // If a pre-base reordering consonant is found, reorder it according to
        // the following rules:
        if (tryPref && base + 1 < end) {
            for(let i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                // 1. Only reorder a glyph produced by substitution during application
                //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                //    the feature generally but block it in certain contexts.)
                // Note: We just check that something got substituted.  We don't check that
                // the <pref> feature actually did it...
                //
                // Reorder pref only if it ligated.
                if (glyphs[i].isLigated && !glyphs[i].isMultiplied) {
                    // 2. Try to find a target position the same way as for pre-base matra.
                    //    If it is found, reorder pre-base consonant glyph.
                    //
                    // 3. If position is not found, reorder immediately before main
                    //    consonant.
                    let newPos = base;
                    // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                    // We want to position matra after them.
                    if (plan.unicodeScript !== "Malayalam" && plan.unicodeScript !== "Tamil") {
                        while(newPos > start && !(glyphs[newPos - 1].shaperInfo.category & ($79e3b6f2c331d0bf$export$a513ea61a7bee91c.M | $79e3b6f2c331d0bf$export$ca9599b2a300afc)))newPos--;
                        // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                        // split matra, it should be reordered to *before* the left part of such matra.
                        if (newPos > start && glyphs[newPos - 1].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) {
                            let oldPos = i;
                            for(let j = base + 1; j < oldPos; j++)if (glyphs[j].shaperInfo.category === $79e3b6f2c331d0bf$export$a513ea61a7bee91c.M) {
                                newPos--;
                                break;
                            }
                        }
                    }
                    if (newPos > start && $d203e6b9523d0071$var$isHalantOrCoeng(glyphs[newPos - 1])) {
                        if (newPos < end && $d203e6b9523d0071$var$isJoiner(glyphs[newPos])) newPos++;
                    }
                    let oldPos = i;
                    let tmp = glyphs[oldPos];
                    glyphs.splice(newPos + 1, 0, ...glyphs.splice(newPos, oldPos - newPos));
                    glyphs[newPos] = tmp;
                    if (newPos <= base && base < oldPos) base++;
                }
                break;
            }
        }
        // Apply 'init' to the Left Matra if it's a word start.
        if (glyphs[start].shaperInfo.position === $79e3b6f2c331d0bf$export$1a1f61c9c4dd9df0.Pre_M && (!start || !/Cf|Mn/.test((0, $gfJaN$unicodeproperties.getCategory)(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
    }
}
function $d203e6b9523d0071$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    let syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
const { categories: $9b772791ccede8a5$var$categories, decompositions: $9b772791ccede8a5$var$decompositions } = /*@__PURE__*/ $parcel$interopDefault($79781f8c452881c2$exports);
const $9b772791ccede8a5$var$trie = new ($parcel$interopDefault($gfJaN$unicodetrie))($66a5b9fb5318558a$export$94fdf11bafc8de6b("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"));
const $9b772791ccede8a5$var$stateMachine = new ($parcel$interopDefault($gfJaN$dfa))(/*@__PURE__*/ $parcel$interopDefault($79781f8c452881c2$exports));
class $9b772791ccede8a5$export$2e2bcd8739ae039 extends $d28fb665ee343afc$export$2e2bcd8739ae039 {
    static planFeatures(plan) {
        plan.addStage($9b772791ccede8a5$var$setupSyllables);
        // Default glyph pre-processing group
        plan.addStage([
            "locl",
            "ccmp",
            "nukt",
            "akhn"
        ]);
        // Reordering group
        plan.addStage($9b772791ccede8a5$var$clearSubstitutionFlags);
        plan.addStage([
            "rphf"
        ], false);
        plan.addStage($9b772791ccede8a5$var$recordRphf);
        plan.addStage($9b772791ccede8a5$var$clearSubstitutionFlags);
        plan.addStage([
            "pref"
        ]);
        plan.addStage($9b772791ccede8a5$var$recordPref);
        // Orthographic unit shaping group
        plan.addStage([
            "rkrf",
            "abvf",
            "blwf",
            "half",
            "pstf",
            "vatu",
            "cjct"
        ]);
        plan.addStage($9b772791ccede8a5$var$reorder);
        // Topographical features
        // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
        // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
        // Standard topographic presentation and positional feature application
        plan.addStage([
            "abvs",
            "blws",
            "pres",
            "psts",
            "dist",
            "abvm",
            "blwm"
        ]);
    }
    static assignFeatures(plan, glyphs) {
        // Decompose split vowels
        // TODO: do this in a more general unicode normalizer
        for(let i = glyphs.length - 1; i >= 0; i--){
            let codepoint = glyphs[i].codePoints[0];
            if ($9b772791ccede8a5$var$decompositions[codepoint]) {
                let decomposed = $9b772791ccede8a5$var$decompositions[codepoint].map((c)=>{
                    let g = plan.font.glyphForCodePoint(c);
                    return new $f22bb23c9fd478d8$export$2e2bcd8739ae039(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice(i, 1, ...decomposed);
            }
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)($9b772791ccede8a5$export$2e2bcd8739ae039, "zeroMarkWidths", "BEFORE_GPOS");
function $9b772791ccede8a5$var$useCategory(glyph) {
    return $9b772791ccede8a5$var$trie.get(glyph.codePoints[0]);
}
class $9b772791ccede8a5$var$USEInfo {
    constructor(category, syllableType, syllable){
        this.category = category;
        this.syllableType = syllableType;
        this.syllable = syllable;
    }
}
function $9b772791ccede8a5$var$setupSyllables(font, glyphs) {
    let syllable = 0;
    for (let [start, end, tags] of $9b772791ccede8a5$var$stateMachine.match(glyphs.map($9b772791ccede8a5$var$useCategory))){
        ++syllable;
        // Create shaper info
        for(let i = start; i <= end; i++)glyphs[i].shaperInfo = new $9b772791ccede8a5$var$USEInfo($9b772791ccede8a5$var$categories[$9b772791ccede8a5$var$useCategory(glyphs[i])], tags[0], syllable);
        // Assign rphf feature
        let limit = glyphs[start].shaperInfo.category === "R" ? 1 : Math.min(3, end - start);
        for(let i1 = start; i1 < start + limit; i1++)glyphs[i1].features.rphf = true;
    }
}
function $9b772791ccede8a5$var$clearSubstitutionFlags(font, glyphs) {
    for (let glyph of glyphs)glyph.substituted = false;
}
function $9b772791ccede8a5$var$recordRphf(font, glyphs) {
    for (let glyph of glyphs)if (glyph.substituted && glyph.features.rphf) glyph.shaperInfo.category = "R";
}
function $9b772791ccede8a5$var$recordPref(font, glyphs) {
    for (let glyph of glyphs)if (glyph.substituted) glyph.shaperInfo.category = "VPre";
}
function $9b772791ccede8a5$var$reorder(font, glyphs) {
    let dottedCircle = font.glyphForCodePoint(0x25cc).id;
    for(let start = 0, end = $9b772791ccede8a5$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $9b772791ccede8a5$var$nextSyllable(glyphs, start)){
        let i, j;
        let info = glyphs[start].shaperInfo;
        let type = info.syllableType;
        // Only a few syllable types need reordering.
        if (type !== "virama_terminated_cluster" && type !== "standard_cluster" && type !== "broken_cluster") continue;
        // Insert a dotted circle glyph in broken clusters.
        if (type === "broken_cluster" && dottedCircle) {
            let g = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = info;
            // Insert after possible Repha.
            for(i = start; i < end && glyphs[i].shaperInfo.category === "R"; i++);
            glyphs.splice(++i, 0, g);
            end++;
        }
        // Move things forward.
        if (info.category === "R" && end - start > 1) for(i = start + 1; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($9b772791ccede8a5$var$isBase(info) || $9b772791ccede8a5$var$isHalant(glyphs[i])) {
                // If we hit a halant, move before it; otherwise it's a base: move to it's
                // place, and shift things in between backward.
                if ($9b772791ccede8a5$var$isHalant(glyphs[i])) i--;
                glyphs.splice(start, 0, ...glyphs.splice(start + 1, i - start), glyphs[i]);
                break;
            }
        }
        // Move things back.
        for(i = start, j = end; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($9b772791ccede8a5$var$isBase(info) || $9b772791ccede8a5$var$isHalant(glyphs[i])) // place, and shift things in between backward.
            j = $9b772791ccede8a5$var$isHalant(glyphs[i]) ? i + 1 : i;
            else if ((info.category === "VPre" || info.category === "VMPre") && j < i) glyphs.splice(j, 1, glyphs[i], ...glyphs.splice(j, i - j));
        }
    }
}
function $9b772791ccede8a5$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    let syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
function $9b772791ccede8a5$var$isHalant(glyph) {
    return glyph.shaperInfo.category === "H" && !glyph.isLigated;
}
function $9b772791ccede8a5$var$isBase(info) {
    return info.category === "B" || info.category === "GB";
}
const $fdb4471fc82bc2c2$var$SHAPERS = {
    arab: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    mong: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    syrc: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    "nko ": $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    phag: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    mand: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    mani: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    phlp: $17ba6019f27bfcf9$export$2e2bcd8739ae039,
    hang: $fa1d9fd80dd7279e$export$2e2bcd8739ae039,
    bng2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    beng: $d203e6b9523d0071$export$2e2bcd8739ae039,
    dev2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    deva: $d203e6b9523d0071$export$2e2bcd8739ae039,
    gjr2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    gujr: $d203e6b9523d0071$export$2e2bcd8739ae039,
    guru: $d203e6b9523d0071$export$2e2bcd8739ae039,
    gur2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    knda: $d203e6b9523d0071$export$2e2bcd8739ae039,
    knd2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    mlm2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    mlym: $d203e6b9523d0071$export$2e2bcd8739ae039,
    ory2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    orya: $d203e6b9523d0071$export$2e2bcd8739ae039,
    taml: $d203e6b9523d0071$export$2e2bcd8739ae039,
    tml2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    telu: $d203e6b9523d0071$export$2e2bcd8739ae039,
    tel2: $d203e6b9523d0071$export$2e2bcd8739ae039,
    khmr: $d203e6b9523d0071$export$2e2bcd8739ae039,
    bali: $9b772791ccede8a5$export$2e2bcd8739ae039,
    batk: $9b772791ccede8a5$export$2e2bcd8739ae039,
    brah: $9b772791ccede8a5$export$2e2bcd8739ae039,
    bugi: $9b772791ccede8a5$export$2e2bcd8739ae039,
    buhd: $9b772791ccede8a5$export$2e2bcd8739ae039,
    cakm: $9b772791ccede8a5$export$2e2bcd8739ae039,
    cham: $9b772791ccede8a5$export$2e2bcd8739ae039,
    dupl: $9b772791ccede8a5$export$2e2bcd8739ae039,
    egyp: $9b772791ccede8a5$export$2e2bcd8739ae039,
    gran: $9b772791ccede8a5$export$2e2bcd8739ae039,
    hano: $9b772791ccede8a5$export$2e2bcd8739ae039,
    java: $9b772791ccede8a5$export$2e2bcd8739ae039,
    kthi: $9b772791ccede8a5$export$2e2bcd8739ae039,
    kali: $9b772791ccede8a5$export$2e2bcd8739ae039,
    khar: $9b772791ccede8a5$export$2e2bcd8739ae039,
    khoj: $9b772791ccede8a5$export$2e2bcd8739ae039,
    sind: $9b772791ccede8a5$export$2e2bcd8739ae039,
    lepc: $9b772791ccede8a5$export$2e2bcd8739ae039,
    limb: $9b772791ccede8a5$export$2e2bcd8739ae039,
    mahj: $9b772791ccede8a5$export$2e2bcd8739ae039,
    // mand: UniversalShaper, // Mandaic
    // mani: UniversalShaper, // Manichaean
    mtei: $9b772791ccede8a5$export$2e2bcd8739ae039,
    modi: $9b772791ccede8a5$export$2e2bcd8739ae039,
    // mong: UniversalShaper, // Mongolian
    // 'nko ': UniversalShaper, // N’Ko
    hmng: $9b772791ccede8a5$export$2e2bcd8739ae039,
    // phag: UniversalShaper, // Phags-pa
    // phlp: UniversalShaper, // Psalter Pahlavi
    rjng: $9b772791ccede8a5$export$2e2bcd8739ae039,
    saur: $9b772791ccede8a5$export$2e2bcd8739ae039,
    shrd: $9b772791ccede8a5$export$2e2bcd8739ae039,
    sidd: $9b772791ccede8a5$export$2e2bcd8739ae039,
    sinh: $d203e6b9523d0071$export$2e2bcd8739ae039,
    sund: $9b772791ccede8a5$export$2e2bcd8739ae039,
    sylo: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tglg: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tagb: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tale: $9b772791ccede8a5$export$2e2bcd8739ae039,
    lana: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tavt: $9b772791ccede8a5$export$2e2bcd8739ae039,
    takr: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tibt: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tfng: $9b772791ccede8a5$export$2e2bcd8739ae039,
    tirh: $9b772791ccede8a5$export$2e2bcd8739ae039,
    latn: $d28fb665ee343afc$export$2e2bcd8739ae039,
    DFLT: $d28fb665ee343afc$export$2e2bcd8739ae039 // Default
};
function $fdb4471fc82bc2c2$export$7877a478dd30fd3d(script) {
    if (!Array.isArray(script)) script = [
        script
    ];
    for (let s of script){
        let shaper = $fdb4471fc82bc2c2$var$SHAPERS[s];
        if (shaper) return shaper;
    }
    return $d28fb665ee343afc$export$2e2bcd8739ae039;
}
class $86bc1883359e094a$export$2e2bcd8739ae039 extends $7b226e6bbeadedeb$export$2e2bcd8739ae039 {
    applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    let glyph = this.glyphIterator.cur;
                    switch(table.version){
                        case 1:
                            glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                            break;
                        case 2:
                            glyph.id = table.substitute.get(index);
                            break;
                    }
                    return true;
                }
            case 2:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index !== -1) {
                        let sequence = table.sequences.get(index);
                        if (sequence.length === 0) {
                            // If the sequence length is zero, delete the glyph.
                            // The OpenType spec disallows this, but seems like Harfbuzz and Uniscribe allow it.
                            this.glyphs.splice(this.glyphIterator.index, 1);
                            return true;
                        }
                        this.glyphIterator.cur.id = sequence[0];
                        this.glyphIterator.cur.ligatureComponent = 0;
                        let features = this.glyphIterator.cur.features;
                        let curGlyph = this.glyphIterator.cur;
                        let replacement = sequence.slice(1).map((gid, i)=>{
                            let glyph = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(this.font, gid, undefined, features);
                            glyph.shaperInfo = curGlyph.shaperInfo;
                            glyph.isLigated = curGlyph.isLigated;
                            glyph.ligatureComponent = i + 1;
                            glyph.substituted = true;
                            glyph.isMultiplied = true;
                            return glyph;
                        });
                        this.glyphs.splice(this.glyphIterator.index + 1, 0, ...replacement);
                        return true;
                    }
                    return false;
                }
            case 3:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index !== -1) {
                        let USER_INDEX = 0; // TODO
                        this.glyphIterator.cur.id = table.alternateSet.get(index)[USER_INDEX];
                        return true;
                    }
                    return false;
                }
            case 4:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    for (let ligature of table.ligatureSets.get(index)){
                        let matched = this.sequenceMatchIndices(1, ligature.components);
                        if (!matched) continue;
                        let curGlyph = this.glyphIterator.cur;
                        // Concatenate all of the characters the new ligature will represent
                        let characters = curGlyph.codePoints.slice();
                        for (let index of matched)characters.push(...this.glyphs[index].codePoints);
                        // Create the replacement ligature glyph
                        let ligatureGlyph = new $f22bb23c9fd478d8$export$2e2bcd8739ae039(this.font, ligature.glyph, characters, curGlyph.features);
                        ligatureGlyph.shaperInfo = curGlyph.shaperInfo;
                        ligatureGlyph.isLigated = true;
                        ligatureGlyph.substituted = true;
                        // From Harfbuzz:
                        // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                        //   the ligature to keep its old ligature id.  This will allow it to attach to
                        //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                        //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                        //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                        //   later, we don't want them to lose their ligature id/component, otherwise
                        //   GPOS will fail to correctly position the mark ligature on top of the
                        //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                        //
                        // - If a ligature is formed of components that some of which are also ligatures
                        //   themselves, and those ligature components had marks attached to *their*
                        //   components, we have to attach the marks to the new ligature component
                        //   positions!  Now *that*'s tricky!  And these marks may be following the
                        //   last component of the whole sequence, so we should loop forward looking
                        //   for them and update them.
                        //
                        //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                        //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                        //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                        //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                        //   the new ligature with a component value of 2.
                        //
                        //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
                        let isMarkLigature = curGlyph.isMark;
                        for(let i = 0; i < matched.length && isMarkLigature; i++)isMarkLigature = this.glyphs[matched[i]].isMark;
                        ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                        let lastLigID = curGlyph.ligatureID;
                        let lastNumComps = curGlyph.codePoints.length;
                        let curComps = lastNumComps;
                        let idx = this.glyphIterator.index + 1;
                        // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                        // This allows GPOS to attach marks to the correct ligature components.
                        for (let matchIndex of matched){
                            // Don't assign new ligature components for mark ligatures (see above)
                            if (isMarkLigature) idx = matchIndex;
                            else while(idx < matchIndex){
                                var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                                this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                                this.glyphs[idx].ligatureComponent = ligatureComponent;
                                idx++;
                            }
                            lastLigID = this.glyphs[idx].ligatureID;
                            lastNumComps = this.glyphs[idx].codePoints.length;
                            curComps += lastNumComps;
                            idx++; // skip base glyph
                        }
                        // Adjust ligature components for any marks following
                        if (lastLigID && !isMarkLigature) for(let i1 = idx; i1 < this.glyphs.length; i1++){
                            if (this.glyphs[i1].ligatureID === lastLigID) {
                                var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[i1].ligatureComponent || 1, lastNumComps);
                                this.glyphs[i1].ligatureComponent = ligatureComponent;
                            } else break;
                        }
                        // Delete the matched glyphs, and replace the current glyph with the ligature glyph
                        for(let i2 = matched.length - 1; i2 >= 0; i2--)this.glyphs.splice(matched[i2], 1);
                        this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                        return true;
                    }
                    return false;
                }
            case 5:
                return this.applyContext(table);
            case 6:
                return this.applyChainingContext(table);
            case 7:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error(`GSUB lookupType ${lookupType} is not supported`);
        }
    }
}
class $79ea6270f0a90256$export$2e2bcd8739ae039 extends $7b226e6bbeadedeb$export$2e2bcd8739ae039 {
    applyPositionValue(sequenceIndex, value) {
        let position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
        if (value.xAdvance != null) position.xAdvance += value.xAdvance;
        if (value.yAdvance != null) position.yAdvance += value.yAdvance;
        if (value.xPlacement != null) position.xOffset += value.xPlacement;
        if (value.yPlacement != null) position.yOffset += value.yPlacement;
        // Adjustments for font variations
        let variationProcessor = this.font._variationProcessor;
        let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (value.xPlaDevice) position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
            if (value.yPlaDevice) position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
            if (value.xAdvDevice) position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
            if (value.yAdvDevice) position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
        }
    // TODO: device tables
    }
    applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                {
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    switch(table.version){
                        case 1:
                            this.applyPositionValue(0, table.value);
                            break;
                        case 2:
                            this.applyPositionValue(0, table.values.get(index));
                            break;
                    }
                    return true;
                }
            case 2:
                {
                    let nextGlyph = this.glyphIterator.peek();
                    if (!nextGlyph) return false;
                    let index = this.coverageIndex(table.coverage);
                    if (index === -1) return false;
                    switch(table.version){
                        case 1:
                            let set = table.pairSets.get(index);
                            for (let pair of set)if (pair.secondGlyph === nextGlyph.id) {
                                this.applyPositionValue(0, pair.value1);
                                this.applyPositionValue(1, pair.value2);
                                return true;
                            }
                            return false;
                        case 2:
                            let class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                            let class2 = this.getClassID(nextGlyph.id, table.classDef2);
                            if (class1 === -1 || class2 === -1) return false;
                            var pair1 = table.classRecords.get(class1).get(class2);
                            this.applyPositionValue(0, pair1.value1);
                            this.applyPositionValue(1, pair1.value2);
                            return true;
                    }
                }
            case 3:
                {
                    let nextIndex = this.glyphIterator.peekIndex();
                    let nextGlyph = this.glyphs[nextIndex];
                    if (!nextGlyph) return false;
                    let curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                    if (!curRecord || !curRecord.exitAnchor) return false;
                    let nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, nextGlyph.id)];
                    if (!nextRecord || !nextRecord.entryAnchor) return false;
                    let entry = this.getAnchor(nextRecord.entryAnchor);
                    let exit = this.getAnchor(curRecord.exitAnchor);
                    let cur = this.positions[this.glyphIterator.index];
                    let next = this.positions[nextIndex];
                    let d;
                    switch(this.direction){
                        case "ltr":
                            cur.xAdvance = exit.x + cur.xOffset;
                            d = entry.x + next.xOffset;
                            next.xAdvance -= d;
                            next.xOffset -= d;
                            break;
                        case "rtl":
                            d = exit.x + cur.xOffset;
                            cur.xAdvance -= d;
                            cur.xOffset -= d;
                            next.xAdvance = entry.x + next.xOffset;
                            break;
                    }
                    if (this.glyphIterator.flags.rightToLeft) {
                        this.glyphIterator.cur.cursiveAttachment = nextIndex;
                        cur.yOffset = entry.y - exit.y;
                    } else {
                        nextGlyph.cursiveAttachment = this.glyphIterator.index;
                        cur.yOffset = exit.y - entry.y;
                    }
                    return true;
                }
            case 4:
                {
                    let markIndex = this.coverageIndex(table.markCoverage);
                    if (markIndex === -1) return false;
                    // search backward for a base glyph
                    let baseGlyphIndex = this.glyphIterator.index;
                    while(--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0));
                    if (baseGlyphIndex < 0) return false;
                    let baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                    if (baseIndex === -1) return false;
                    let markRecord = table.markArray[markIndex];
                    let baseAnchor = table.baseArray[baseIndex][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                    return true;
                }
            case 5:
                {
                    let markIndex = this.coverageIndex(table.markCoverage);
                    if (markIndex === -1) return false;
                    // search backward for a base glyph
                    let baseGlyphIndex = this.glyphIterator.index;
                    while(--baseGlyphIndex >= 0 && this.glyphs[baseGlyphIndex].isMark);
                    if (baseGlyphIndex < 0) return false;
                    let ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[baseGlyphIndex].id);
                    if (ligIndex === -1) return false;
                    let ligAttach = table.ligatureArray[ligIndex];
                    let markGlyph = this.glyphIterator.cur;
                    let ligGlyph = this.glyphs[baseGlyphIndex];
                    let compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                    let markRecord = table.markArray[markIndex];
                    let baseAnchor = ligAttach[compIndex][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                    return true;
                }
            case 6:
                {
                    let mark1Index = this.coverageIndex(table.mark1Coverage);
                    if (mark1Index === -1) return false;
                    // get the previous mark to attach to
                    let prevIndex = this.glyphIterator.peekIndex(-1);
                    let prev = this.glyphs[prevIndex];
                    if (!prev || !prev.isMark) return false;
                    let cur = this.glyphIterator.cur;
                    // The following logic was borrowed from Harfbuzz
                    let good = false;
                    if (cur.ligatureID === prev.ligatureID) {
                        if (!cur.ligatureID) good = true;
                        else if (cur.ligatureComponent === prev.ligatureComponent) good = true;
                    } else // itself is a ligature, in which case match.
                    if (cur.ligatureID && !cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) good = true;
                    if (!good) return false;
                    let mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                    if (mark2Index === -1) return false;
                    let markRecord = table.mark1Array[mark1Index];
                    let baseAnchor = table.mark2Array[mark2Index][markRecord.class];
                    this.applyAnchor(markRecord, baseAnchor, prevIndex);
                    return true;
                }
            case 7:
                return this.applyContext(table);
            case 8:
                return this.applyChainingContext(table);
            case 9:
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error(`Unsupported GPOS table: ${lookupType}`);
        }
    }
    applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
        let baseCoords = this.getAnchor(baseAnchor);
        let markCoords = this.getAnchor(markRecord.markAnchor);
        let basePos = this.positions[baseGlyphIndex];
        let markPos = this.positions[this.glyphIterator.index];
        markPos.xOffset = baseCoords.x - markCoords.x;
        markPos.yOffset = baseCoords.y - markCoords.y;
        this.glyphIterator.cur.markAttachment = baseGlyphIndex;
    }
    getAnchor(anchor) {
        // TODO: contour point, device tables
        let x = anchor.xCoordinate;
        let y = anchor.yCoordinate;
        // Adjustments for font variations
        let variationProcessor = this.font._variationProcessor;
        let variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
            if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
        }
        return {
            x: x,
            y: y
        };
    }
    applyFeatures(userFeatures, glyphs, advances) {
        super.applyFeatures(userFeatures, glyphs, advances);
        for(var i = 0; i < this.glyphs.length; i++)this.fixCursiveAttachment(i);
        this.fixMarkAttachment();
    }
    fixCursiveAttachment(i) {
        let glyph = this.glyphs[i];
        if (glyph.cursiveAttachment != null) {
            let j = glyph.cursiveAttachment;
            glyph.cursiveAttachment = null;
            this.fixCursiveAttachment(j);
            this.positions[i].yOffset += this.positions[j].yOffset;
        }
    }
    fixMarkAttachment() {
        for(let i = 0; i < this.glyphs.length; i++){
            let glyph = this.glyphs[i];
            if (glyph.markAttachment != null) {
                let j = glyph.markAttachment;
                this.positions[i].xOffset += this.positions[j].xOffset;
                this.positions[i].yOffset += this.positions[j].yOffset;
                if (this.direction === "ltr") for(let k = j; k < i; k++){
                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                }
                else for(let k1 = j + 1; k1 < i + 1; k1++){
                    this.positions[i].xOffset += this.positions[k1].xAdvance;
                    this.positions[i].yOffset += this.positions[k1].yAdvance;
                }
            }
        }
    }
}
class $b2f26a32cb9ab2fa$export$2e2bcd8739ae039 {
    setup(glyphRun) {
        // Map glyphs to GlyphInfo objects so data can be passed between
        // GSUB and GPOS without mutating the real (shared) Glyph objects.
        this.glyphInfos = glyphRun.glyphs.map((glyph)=>new $f22bb23c9fd478d8$export$2e2bcd8739ae039(this.font, glyph.id, [
                ...glyph.codePoints
            ]));
        // Select a script based on what is available in GSUB/GPOS.
        let script = null;
        if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        // Choose a shaper based on the script, and setup a shaping plan.
        // This determines which features to apply to which glyphs.
        this.shaper = $fdb4471fc82bc2c2$export$7877a478dd30fd3d(script);
        this.plan = new $d7e93cca3cf8ce8a$export$2e2bcd8739ae039(this.font, script, glyphRun.direction);
        this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features);
        // Assign chosen features to output glyph run
        for(let key in this.plan.allFeatures)glyphRun.features[key] = true;
    }
    substitute(glyphRun) {
        if (this.GSUBProcessor) {
            this.plan.process(this.GSUBProcessor, this.glyphInfos);
            // Map glyph infos back to normal Glyph objects
            glyphRun.glyphs = this.glyphInfos.map((glyphInfo)=>this.font.getGlyph(glyphInfo.id, glyphInfo.codePoints));
        }
    }
    position(glyphRun) {
        if (this.shaper.zeroMarkWidths === "BEFORE_GPOS") this.zeroMarkAdvances(glyphRun.positions);
        if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
        if (this.shaper.zeroMarkWidths === "AFTER_GPOS") this.zeroMarkAdvances(glyphRun.positions);
        // Reverse the glyphs and positions if the script is right-to-left
        if (glyphRun.direction === "rtl") {
            glyphRun.glyphs.reverse();
            glyphRun.positions.reverse();
        }
        return this.GPOSProcessor && this.GPOSProcessor.features;
    }
    zeroMarkAdvances(positions) {
        for(let i = 0; i < this.glyphInfos.length; i++)if (this.glyphInfos[i].isMark) {
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    }
    cleanup() {
        this.glyphInfos = null;
        this.plan = null;
        this.shaper = null;
    }
    getAvailableFeatures(script, language) {
        let features = [];
        if (this.GSUBProcessor) {
            this.GSUBProcessor.selectScript(script, language);
            features.push(...Object.keys(this.GSUBProcessor.features));
        }
        if (this.GPOSProcessor) {
            this.GPOSProcessor.selectScript(script, language);
            features.push(...Object.keys(this.GPOSProcessor.features));
        }
        return features;
    }
    constructor(font){
        this.font = font;
        this.glyphInfos = null;
        this.plan = null;
        this.GSUBProcessor = null;
        this.GPOSProcessor = null;
        this.fallbackPosition = true;
        if (font.GSUB) this.GSUBProcessor = new $86bc1883359e094a$export$2e2bcd8739ae039(font, font.GSUB);
        if (font.GPOS) this.GPOSProcessor = new $79ea6270f0a90256$export$2e2bcd8739ae039(font, font.GPOS);
    }
}
class $9d641258c9d7180d$export$2e2bcd8739ae039 {
    layout(string, features, script, language, direction) {
        // Make the features parameter optional
        if (typeof features === "string") {
            direction = language;
            language = script;
            script = features;
            features = [];
        }
        // Map string to glyphs if needed
        if (typeof string === "string") {
            // Attempt to detect the script from the string if not provided.
            if (script == null) script = $e38a1a895f6aeb54$export$e5cb25e204fb8450(string);
            var glyphs = this.font.glyphsForString(string);
        } else {
            // Attempt to detect the script from the glyph code points if not provided.
            if (script == null) {
                let codePoints = [];
                for (let glyph of string)codePoints.push(...glyph.codePoints);
                script = $e38a1a895f6aeb54$export$16fab0757cfc223d(codePoints);
            }
            var glyphs = string;
        }
        let glyphRun = new $b19c79ec7a94fa39$export$2e2bcd8739ae039(glyphs, features, script, language, direction);
        // Return early if there are no glyphs
        if (glyphs.length === 0) {
            glyphRun.positions = [];
            return glyphRun;
        }
        // Setup the advanced layout engine
        if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
        // Substitute and position the glyphs
        this.substitute(glyphRun);
        this.position(glyphRun);
        this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);
        // Let the layout engine clean up any state it might have
        if (this.engine && this.engine.cleanup) this.engine.cleanup();
        return glyphRun;
    }
    substitute(glyphRun) {
        // Call the advanced layout engine to make substitutions
        if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
    }
    position(glyphRun) {
        // Get initial glyph positions
        glyphRun.positions = glyphRun.glyphs.map((glyph)=>new $9195cf1266c12ea5$export$2e2bcd8739ae039(glyph.advanceWidth));
        let positioned = null;
        // Call the advanced layout engine. Returns the features applied.
        if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
        // if there is no GPOS table, use unicode properties to position marks.
        if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
            if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new $a57a26817cd35108$export$2e2bcd8739ae039(this.font);
            this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
        }
        // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
        if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
            if (!this.kernProcessor) this.kernProcessor = new $4646d52c2a559cdb$export$2e2bcd8739ae039(this.font);
            this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
            glyphRun.features.kern = true;
        }
    }
    hideDefaultIgnorables(glyphs, positions) {
        let space = this.font.glyphForCodePoint(0x20);
        for(let i = 0; i < glyphs.length; i++)if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
            glyphs[i] = space;
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    }
    isDefaultIgnorable(ch) {
        // From DerivedCoreProperties.txt in the Unicode database,
        // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
        // Harfbuzz and Uniscribe do.
        let plane = ch >> 16;
        if (plane === 0) switch(ch >> 8){
            case 0x00:
                return ch === 0x00AD;
            case 0x03:
                return ch === 0x034F;
            case 0x06:
                return ch === 0x061C;
            case 0x17:
                return 0x17B4 <= ch && ch <= 0x17B5;
            case 0x18:
                return 0x180B <= ch && ch <= 0x180E;
            case 0x20:
                return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
            case 0xFE:
                return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
            case 0xFF:
                return 0xFFF0 <= ch && ch <= 0xFFF8;
            default:
                return false;
        }
        else switch(plane){
            case 0x01:
                return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
            case 0x0E:
                return 0xE0000 <= ch && ch <= 0xE0FFF;
            default:
                return false;
        }
    }
    getAvailableFeatures(script, language) {
        let features = [];
        if (this.engine) features.push(...this.engine.getAvailableFeatures(script, language));
        if (this.font.kern && features.indexOf("kern") === -1) features.push("kern");
        return features;
    }
    stringsForGlyph(gid) {
        let result = new Set;
        let codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
        for (let codePoint of codePoints)result.add(String.fromCodePoint(codePoint));
        if (this.engine && this.engine.stringsForGlyph) for (let string of this.engine.stringsForGlyph(gid))result.add(string);
        return Array.from(result);
    }
    constructor(font){
        this.font = font;
        this.unicodeLayoutEngine = null;
        this.kernProcessor = null;
        // Choose an advanced layout engine. We try the AAT morx table first since more
        // scripts are currently supported because the shaping logic is built into the font.
        if (this.font.morx) this.engine = new $860fcbd64bc12fbc$export$2e2bcd8739ae039(this.font);
        else if (this.font.GSUB || this.font.GPOS) this.engine = new $b2f26a32cb9ab2fa$export$2e2bcd8739ae039(this.font);
    }
}
const $67ee4828d81adb28$var$SVG_COMMANDS = {
    moveTo: "M",
    lineTo: "L",
    quadraticCurveTo: "Q",
    bezierCurveTo: "C",
    closePath: "Z"
};
class $67ee4828d81adb28$export$2e2bcd8739ae039 {
    /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */ toFunction() {
        return (ctx)=>{
            this.commands.forEach((c)=>{
                return ctx[c.command].apply(ctx, c.args);
            });
        };
    }
    /**
   * Converts the path to an SVG path data string
   * @return {string}
   */ toSVG() {
        let cmds = this.commands.map((c)=>{
            let args = c.args.map((arg)=>Math.round(arg * 100) / 100);
            return `${$67ee4828d81adb28$var$SVG_COMMANDS[c.command]}${args.join(" ")}`;
        });
        return cmds.join("");
    }
    /**
   * Gets the "control box" of a path.
   * This is like the bounding box, but it includes all points including
   * control points of bezier segments and is much faster to compute than
   * the real bounding box.
   * @type {BBox}
   */ get cbox() {
        if (!this._cbox) {
            let cbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
            for (let command1 of this.commands)for(let i = 0; i < command1.args.length; i += 2)cbox.addPoint(command1.args[i], command1.args[i + 1]);
            this._cbox = Object.freeze(cbox);
        }
        return this._cbox;
    }
    /**
   * Gets the exact bounding box of the path by evaluating curve segments.
   * Slower to compute than the control box, but more accurate.
   * @type {BBox}
   */ get bbox() {
        if (this._bbox) return this._bbox;
        let bbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
        let cx = 0, cy = 0;
        let f = (t)=>Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
        for (let c of this.commands)switch(c.command){
            case "moveTo":
            case "lineTo":
                let [x, y] = c.args;
                bbox.addPoint(x, y);
                cx = x;
                cy = y;
                break;
            case "quadraticCurveTo":
            case "bezierCurveTo":
                if (c.command === "quadraticCurveTo") {
                    // http://fontforge.org/bezier.html
                    var [qp1x, qp1y, p3x, p3y] = c.args;
                    var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
                    var cp1y = cy + 2 / 3 * (qp1y - cy);
                    var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
                    var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                } else var [cp1x, cp1y, cp2x, cp2y, p3x, p3y] = c.args;
                // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
                bbox.addPoint(p3x, p3y);
                var p0 = [
                    cx,
                    cy
                ];
                var p1 = [
                    cp1x,
                    cp1y
                ];
                var p2 = [
                    cp2x,
                    cp2y
                ];
                var p3 = [
                    p3x,
                    p3y
                ];
                for(var i = 0; i <= 1; i++){
                    let b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                    let a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                    c = 3 * p1[i] - 3 * p0[i];
                    if (a === 0) {
                        if (b === 0) continue;
                        let t = -c / b;
                        if (0 < t && t < 1) {
                            if (i === 0) bbox.addPoint(f(t), bbox.maxY);
                            else if (i === 1) bbox.addPoint(bbox.maxX, f(t));
                        }
                        continue;
                    }
                    let b2ac = Math.pow(b, 2) - 4 * c * a;
                    if (b2ac < 0) continue;
                    let t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                    if (0 < t1 && t1 < 1) {
                        if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
                    }
                    let t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                    if (0 < t2 && t2 < 1) {
                        if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
                    }
                }
                cx = p3x;
                cy = p3y;
                break;
        }
        return this._bbox = Object.freeze(bbox);
    }
    /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */ mapPoints(fn) {
        let path = new $67ee4828d81adb28$export$2e2bcd8739ae039;
        for (let c of this.commands){
            let args = [];
            for(let i = 0; i < c.args.length; i += 2){
                let [x, y] = fn(c.args[i], c.args[i + 1]);
                args.push(x, y);
            }
            path[c.command](...args);
        }
        return path;
    }
    /**
   * Transforms the path by the given matrix.
   */ transform(m0, m1, m2, m3, m4, m5) {
        return this.mapPoints((x, y)=>{
            const tx = m0 * x + m2 * y + m4;
            const ty = m1 * x + m3 * y + m5;
            return [
                tx,
                ty
            ];
        });
    }
    /**
   * Translates the path by the given offset.
   */ translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    }
    /**
   * Rotates the path by the given angle (in radians).
   */ rotate(angle) {
        let cos = Math.cos(angle);
        let sin = Math.sin(angle);
        return this.transform(cos, sin, -sin, cos, 0, 0);
    }
    /**
   * Scales the path.
   */ scale(scaleX, scaleY = scaleX) {
        return this.transform(scaleX, 0, 0, scaleY, 0, 0);
    }
    constructor(){
        this.commands = [];
        this._bbox = null;
        this._cbox = null;
    }
}
for (let command of [
    "moveTo",
    "lineTo",
    "quadraticCurveTo",
    "bezierCurveTo",
    "closePath"
])$67ee4828d81adb28$export$2e2bcd8739ae039.prototype[command] = function(...args) {
    this._bbox = this._cbox = null;
    this.commands.push({
        command: command,
        args: args
    });
    return this;
};
var $85e16e40023cfb0f$export$2e2bcd8739ae039 = [
    ".notdef",
    ".null",
    "nonmarkingreturn",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quotesingle",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "grave",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "Adieresis",
    "Aring",
    "Ccedilla",
    "Eacute",
    "Ntilde",
    "Odieresis",
    "Udieresis",
    "aacute",
    "agrave",
    "acircumflex",
    "adieresis",
    "atilde",
    "aring",
    "ccedilla",
    "eacute",
    "egrave",
    "ecircumflex",
    "edieresis",
    "iacute",
    "igrave",
    "icircumflex",
    "idieresis",
    "ntilde",
    "oacute",
    "ograve",
    "ocircumflex",
    "odieresis",
    "otilde",
    "uacute",
    "ugrave",
    "ucircumflex",
    "udieresis",
    "dagger",
    "degree",
    "cent",
    "sterling",
    "section",
    "bullet",
    "paragraph",
    "germandbls",
    "registered",
    "copyright",
    "trademark",
    "acute",
    "dieresis",
    "notequal",
    "AE",
    "Oslash",
    "infinity",
    "plusminus",
    "lessequal",
    "greaterequal",
    "yen",
    "mu",
    "partialdiff",
    "summation",
    "product",
    "pi",
    "integral",
    "ordfeminine",
    "ordmasculine",
    "Omega",
    "ae",
    "oslash",
    "questiondown",
    "exclamdown",
    "logicalnot",
    "radical",
    "florin",
    "approxequal",
    "Delta",
    "guillemotleft",
    "guillemotright",
    "ellipsis",
    "nonbreakingspace",
    "Agrave",
    "Atilde",
    "Otilde",
    "OE",
    "oe",
    "endash",
    "emdash",
    "quotedblleft",
    "quotedblright",
    "quoteleft",
    "quoteright",
    "divide",
    "lozenge",
    "ydieresis",
    "Ydieresis",
    "fraction",
    "currency",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "daggerdbl",
    "periodcentered",
    "quotesinglbase",
    "quotedblbase",
    "perthousand",
    "Acircumflex",
    "Ecircumflex",
    "Aacute",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Oacute",
    "Ocircumflex",
    "apple",
    "Ograve",
    "Uacute",
    "Ucircumflex",
    "Ugrave",
    "dotlessi",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "Lslash",
    "lslash",
    "Scaron",
    "scaron",
    "Zcaron",
    "zcaron",
    "brokenbar",
    "Eth",
    "eth",
    "Yacute",
    "yacute",
    "Thorn",
    "thorn",
    "minus",
    "multiply",
    "onesuperior",
    "twosuperior",
    "threesuperior",
    "onehalf",
    "onequarter",
    "threequarters",
    "franc",
    "Gbreve",
    "gbreve",
    "Idotaccent",
    "Scedilla",
    "scedilla",
    "Cacute",
    "cacute",
    "Ccaron",
    "ccaron",
    "dcroat"
];
class $0e4f52d7996e478b$export$2e2bcd8739ae039 {
    _getPath() {
        return new $67ee4828d81adb28$export$2e2bcd8739ae039();
    }
    _getCBox() {
        return this.path.cbox;
    }
    _getBBox() {
        return this.path.bbox;
    }
    _getTableMetrics(table) {
        if (this.id < table.metrics.length) return table.metrics.get(this.id);
        let metric = table.metrics.get(table.metrics.length - 1);
        let res = {
            advance: metric ? metric.advance : 0,
            bearing: table.bearings.get(this.id - table.metrics.length) || 0
        };
        return res;
    }
    _getMetrics(cbox) {
        if (this._metrics) return this._metrics;
        let { advance: advanceWidth, bearing: leftBearing } = this._getTableMetrics(this._font.hmtx);
        // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
        if (this._font.vmtx) var { advance: advanceHeight, bearing: topBearing } = this._getTableMetrics(this._font.vmtx);
        else {
            let os2;
            if (typeof cbox === "undefined" || cbox === null) ({ cbox: cbox } = this);
            if ((os2 = this._font["OS/2"]) && os2.version > 0) {
                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                var topBearing = os2.typoAscender - cbox.maxY;
            } else {
                let { hhea: hhea } = this._font;
                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                var topBearing = hhea.ascent - cbox.maxY;
            }
        }
        if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
        return this._metrics = {
            advanceWidth: advanceWidth,
            advanceHeight: advanceHeight,
            leftBearing: leftBearing,
            topBearing: topBearing
        };
    }
    /**
   * The glyph’s control box.
   * This is often the same as the bounding box, but is faster to compute.
   * Because of the way bezier curves are defined, some of the control points
   * can be outside of the bounding box. Where `bbox` takes this into account,
   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
   * for a more detailed description.
   *
   * @type {BBox}
   */ get cbox() {
        return this._getCBox();
    }
    /**
   * The glyph’s bounding box, i.e. the rectangle that encloses the
   * glyph outline as tightly as possible.
   * @type {BBox}
   */ get bbox() {
        return this._getBBox();
    }
    /**
   * A vector Path object representing the glyph outline.
   * @type {Path}
   */ get path() {
        // Cache the path so we only decode it once
        // Decoding is actually performed by subclasses
        return this._getPath();
    }
    /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */ getScaledPath(size) {
        let scale = 1 / this._font.unitsPerEm * size;
        return this.path.scale(scale);
    }
    /**
   * The glyph's advance width.
   * @type {number}
   */ get advanceWidth() {
        return this._getMetrics().advanceWidth;
    }
    /**
   * The glyph's advance height.
   * @type {number}
   */ get advanceHeight() {
        return this._getMetrics().advanceHeight;
    }
    get ligatureCaretPositions() {}
    _getName() {
        let { post: post } = this._font;
        if (!post) return null;
        switch(post.version){
            case 1:
                return $85e16e40023cfb0f$export$2e2bcd8739ae039[this.id];
            case 2:
                let id = post.glyphNameIndex[this.id];
                if (id < $85e16e40023cfb0f$export$2e2bcd8739ae039.length) return $85e16e40023cfb0f$export$2e2bcd8739ae039[id];
                return post.names[id - $85e16e40023cfb0f$export$2e2bcd8739ae039.length];
            case 2.5:
                return $85e16e40023cfb0f$export$2e2bcd8739ae039[this.id + post.offsets[this.id]];
            case 4:
                return String.fromCharCode(post.map[this.id]);
        }
    }
    /**
   * The glyph's name
   * @type {string}
   */ get name() {
        return this._getName();
    }
    /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */ render(ctx, size) {
        ctx.save();
        let scale = 1 / this._font.head.unitsPerEm * size;
        ctx.scale(scale, scale);
        let fn = this.path.toFunction();
        fn(ctx);
        ctx.fill();
        ctx.restore();
    }
    constructor(id, codePoints, font){
        /**
     * The glyph id in the font
     * @type {number}
     */ this.id = id;
        /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */ this.codePoints = codePoints;
        this._font = font;
        // TODO: get this info from GDEF if available
        this.isMark = this.codePoints.length > 0 && this.codePoints.every($gfJaN$unicodeproperties.isMark);
        this.isLigature = this.codePoints.length > 1;
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "cbox", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "bbox", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "path", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "advanceWidth", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "advanceHeight", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype, "name", null);
// The header for both simple and composite glyphs
let $f680320fa07ef53d$var$GlyfHeader = new $gfJaN$restructure.Struct({
    numberOfContours: $gfJaN$restructure.int16,
    xMin: $gfJaN$restructure.int16,
    yMin: $gfJaN$restructure.int16,
    xMax: $gfJaN$restructure.int16,
    yMax: $gfJaN$restructure.int16
});
// Flags for simple glyphs
const $f680320fa07ef53d$var$ON_CURVE = 1;
const $f680320fa07ef53d$var$X_SHORT_VECTOR = 2;
const $f680320fa07ef53d$var$Y_SHORT_VECTOR = 4;
const $f680320fa07ef53d$var$REPEAT = 8;
const $f680320fa07ef53d$var$SAME_X = 16;
const $f680320fa07ef53d$var$SAME_Y = 32;
// Flags for composite glyphs
const $f680320fa07ef53d$var$ARG_1_AND_2_ARE_WORDS = 1;
const $f680320fa07ef53d$var$ARGS_ARE_XY_VALUES = 2;
const $f680320fa07ef53d$var$ROUND_XY_TO_GRID = 4;
const $f680320fa07ef53d$var$WE_HAVE_A_SCALE = 8;
const $f680320fa07ef53d$var$MORE_COMPONENTS = 32;
const $f680320fa07ef53d$var$WE_HAVE_AN_X_AND_Y_SCALE = 64;
const $f680320fa07ef53d$var$WE_HAVE_A_TWO_BY_TWO = 128;
const $f680320fa07ef53d$var$WE_HAVE_INSTRUCTIONS = 256;
const $f680320fa07ef53d$var$USE_MY_METRICS = 512;
const $f680320fa07ef53d$var$OVERLAP_COMPOUND = 1024;
const $f680320fa07ef53d$var$SCALED_COMPONENT_OFFSET = 2048;
const $f680320fa07ef53d$var$UNSCALED_COMPONENT_OFFSET = 4096;
class $f680320fa07ef53d$export$baf26146a414f24a {
    copy() {
        return new $f680320fa07ef53d$export$baf26146a414f24a(this.onCurve, this.endContour, this.x, this.y);
    }
    constructor(onCurve, endContour, x = 0, y = 0){
        this.onCurve = onCurve;
        this.endContour = endContour;
        this.x = x;
        this.y = y;
    }
}
// Represents a component in a composite glyph
class $f680320fa07ef53d$var$Component {
    constructor(glyphID, dx, dy){
        this.glyphID = glyphID;
        this.dx = dx;
        this.dy = dy;
        this.pos = 0;
        this.scaleX = this.scaleY = 1;
        this.scale01 = this.scale10 = 0;
    }
}
class $f680320fa07ef53d$export$2e2bcd8739ae039 extends $0e4f52d7996e478b$export$2e2bcd8739ae039 {
    // Parses just the glyph header and returns the bounding box
    _getCBox(internal) {
        // We need to decode the glyph if variation processing is requested,
        // so it's easier just to recompute the path's cbox after decoding.
        if (this._font._variationProcessor && !internal) return this.path.cbox;
        let stream = this._font._getTableStream("glyf");
        stream.pos += this._font.loca.offsets[this.id];
        let glyph = $f680320fa07ef53d$var$GlyfHeader.decode(stream);
        let cbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
        return Object.freeze(cbox);
    }
    // Parses a single glyph coordinate
    _parseGlyphCoord(stream, prev, short, same) {
        if (short) {
            var val = stream.readUInt8();
            if (!same) val = -val;
            val += prev;
        } else if (same) var val = prev;
        else var val = prev + stream.readInt16BE();
        return val;
    }
    // Decodes the glyph data into points for simple glyphs,
    // or components for composite glyphs
    _decode() {
        let glyfPos = this._font.loca.offsets[this.id];
        let nextPos = this._font.loca.offsets[this.id + 1];
        // Nothing to do if there is no data for this glyph
        if (glyfPos === nextPos) return null;
        let stream = this._font._getTableStream("glyf");
        stream.pos += glyfPos;
        let startPos = stream.pos;
        let glyph = $f680320fa07ef53d$var$GlyfHeader.decode(stream);
        if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
        else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
        return glyph;
    }
    _decodeSimple(glyph, stream) {
        // this is a simple glyph
        glyph.points = [];
        let endPtsOfContours = new $gfJaN$restructure.Array($gfJaN$restructure.uint16, glyph.numberOfContours).decode(stream);
        glyph.instructions = new $gfJaN$restructure.Array($gfJaN$restructure.uint8, $gfJaN$restructure.uint16).decode(stream);
        let flags = [];
        let numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
        while(flags.length < numCoords){
            var flag = stream.readUInt8();
            flags.push(flag);
            // check for repeat flag
            if (flag & $f680320fa07ef53d$var$REPEAT) {
                let count = stream.readUInt8();
                for(let j = 0; j < count; j++)flags.push(flag);
            }
        }
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            let point = new $f680320fa07ef53d$export$baf26146a414f24a(!!(flag & $f680320fa07ef53d$var$ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
            glyph.points.push(point);
        }
        let px = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & $f680320fa07ef53d$var$X_SHORT_VECTOR, flag & $f680320fa07ef53d$var$SAME_X);
        }
        let py = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & $f680320fa07ef53d$var$Y_SHORT_VECTOR, flag & $f680320fa07ef53d$var$SAME_Y);
        }
        if (this._font._variationProcessor) {
            let points = glyph.points.slice();
            points.push(...this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.slice(-4);
        }
        return;
    }
    _decodeComposite(glyph, stream, offset = 0) {
        // this is a composite glyph
        glyph.components = [];
        let haveInstructions = false;
        let flags = $f680320fa07ef53d$var$MORE_COMPONENTS;
        while(flags & $f680320fa07ef53d$var$MORE_COMPONENTS){
            flags = stream.readUInt16BE();
            let gPos = stream.pos - offset;
            let glyphID = stream.readUInt16BE();
            if (!haveInstructions) haveInstructions = (flags & $f680320fa07ef53d$var$WE_HAVE_INSTRUCTIONS) !== 0;
            if (flags & $f680320fa07ef53d$var$ARG_1_AND_2_ARE_WORDS) {
                var dx = stream.readInt16BE();
                var dy = stream.readInt16BE();
            } else {
                var dx = stream.readInt8();
                var dy = stream.readInt8();
            }
            var component = new $f680320fa07ef53d$var$Component(glyphID, dx, dy);
            component.pos = gPos;
            if (flags & $f680320fa07ef53d$var$WE_HAVE_A_SCALE) component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            else if (flags & $f680320fa07ef53d$var$WE_HAVE_AN_X_AND_Y_SCALE) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            } else if (flags & $f680320fa07ef53d$var$WE_HAVE_A_TWO_BY_TWO) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            }
            glyph.components.push(component);
        }
        if (this._font._variationProcessor) {
            let points = [];
            for(let j = 0; j < glyph.components.length; j++){
                var component = glyph.components[j];
                points.push(new $f680320fa07ef53d$export$baf26146a414f24a(true, true, component.dx, component.dy));
            }
            points.push(...this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.splice(-4, 4);
            for(let i = 0; i < points.length; i++){
                let point = points[i];
                glyph.components[i].dx = point.x;
                glyph.components[i].dy = point.y;
            }
        }
        return haveInstructions;
    }
    _getPhantomPoints(glyph) {
        let cbox = this._getCBox(true);
        if (this._metrics == null) this._metrics = $0e4f52d7996e478b$export$2e2bcd8739ae039.prototype._getMetrics.call(this, cbox);
        let { advanceWidth: advanceWidth, advanceHeight: advanceHeight, leftBearing: leftBearing, topBearing: topBearing } = this._metrics;
        return [
            new $f680320fa07ef53d$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing, 0),
            new $f680320fa07ef53d$export$baf26146a414f24a(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
            new $f680320fa07ef53d$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing),
            new $f680320fa07ef53d$export$baf26146a414f24a(false, true, 0, glyph.yMax + topBearing + advanceHeight)
        ];
    }
    // Decodes font data, resolves composite glyphs, and returns an array of contours
    _getContours() {
        let glyph = this._decode();
        if (!glyph) return [];
        let points = [];
        if (glyph.numberOfContours < 0) for (let component of glyph.components){
            let contours = this._font.getGlyph(component.glyphID)._getContours();
            for(let i = 0; i < contours.length; i++){
                let contour = contours[i];
                for(let j = 0; j < contour.length; j++){
                    let point = contour[j];
                    let x = point.x * component.scaleX + point.y * component.scale01 + component.dx;
                    let y = point.y * component.scaleY + point.x * component.scale10 + component.dy;
                    points.push(new $f680320fa07ef53d$export$baf26146a414f24a(point.onCurve, point.endContour, x, y));
                }
            }
        }
        else points = glyph.points || [];
        // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
        if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
            this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
            this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
            this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
            this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
        }
        let contours = [];
        let cur = [];
        for(let k = 0; k < points.length; k++){
            var point = points[k];
            cur.push(point);
            if (point.endContour) {
                contours.push(cur);
                cur = [];
            }
        }
        return contours;
    }
    _getMetrics() {
        if (this._metrics) return this._metrics;
        let cbox = this._getCBox(true);
        super._getMetrics(cbox);
        if (this._font._variationProcessor && !this._font.HVAR) this.path;
        return this._metrics;
    }
    // Converts contours to a Path object that can be rendered
    _getPath() {
        let contours = this._getContours();
        let path = new $67ee4828d81adb28$export$2e2bcd8739ae039;
        for(let i = 0; i < contours.length; i++){
            let contour = contours[i];
            let firstPt = contour[0];
            let lastPt = contour[contour.length - 1];
            let start = 0;
            if (firstPt.onCurve) {
                // The first point will be consumed by the moveTo command, so skip in the loop
                var curvePt = null;
                start = 1;
            } else {
                if (lastPt.onCurve) firstPt = lastPt;
                else firstPt = new $f680320fa07ef53d$export$baf26146a414f24a(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                var curvePt = firstPt;
            }
            path.moveTo(firstPt.x, firstPt.y);
            for(let j = start; j < contour.length; j++){
                let pt = contour[j];
                let prevPt = j === 0 ? firstPt : contour[j - 1];
                if (prevPt.onCurve && pt.onCurve) path.lineTo(pt.x, pt.y);
                else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
                else if (!prevPt.onCurve && !pt.onCurve) {
                    let midX = (prevPt.x + pt.x) / 2;
                    let midY = (prevPt.y + pt.y) / 2;
                    path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                    var curvePt = pt;
                } else if (!prevPt.onCurve && pt.onCurve) {
                    path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                    var curvePt = null;
                } else throw new Error("Unknown TTF path state");
            }
            // Connect the first and last points
            if (curvePt) path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
            path.closePath();
        }
        return path;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "TTF");
    }
}
class $7ee0705195f3b047$export$2e2bcd8739ae039 extends $0e4f52d7996e478b$export$2e2bcd8739ae039 {
    _getName() {
        if (this._font.CFF2) return super._getName();
        return this._font["CFF "].getGlyphName(this.id);
    }
    bias(s) {
        if (s.length < 1240) return 107;
        else if (s.length < 33900) return 1131;
        else return 32768;
    }
    _getPath() {
        let cff = this._font.CFF2 || this._font["CFF "];
        let { stream: stream } = cff;
        let str = cff.topDict.CharStrings[this.id];
        let end = str.offset + str.length;
        stream.pos = str.offset;
        let path = new $67ee4828d81adb28$export$2e2bcd8739ae039;
        let stack = [];
        let trans = [];
        let width = null;
        let nStems = 0;
        let x1 = 0, y1 = 0;
        let usedGsubrs;
        let usedSubrs;
        let open = false;
        this._usedGsubrs = usedGsubrs = {};
        this._usedSubrs = usedSubrs = {};
        let gsubrs = cff.globalSubrIndex || [];
        let gsubrsBias = this.bias(gsubrs);
        let privateDict = cff.privateDictForGlyph(this.id) || {};
        let subrs = privateDict.Subrs || [];
        let subrsBias = this.bias(subrs);
        let vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
        let vsindex = privateDict.vsindex;
        let variationProcessor = this._font._variationProcessor;
        function checkWidth() {
            if (width == null) width = stack.shift() + privateDict.nominalWidthX;
        }
        function parseStems() {
            if (stack.length % 2 !== 0) checkWidth();
            nStems += stack.length >> 1;
            return stack.length = 0;
        }
        function moveTo(x, y) {
            if (open) path.closePath();
            path.moveTo(x, y);
            open = true;
        }
        let parse = function() {
            while(stream.pos < end){
                let op = stream.readUInt8();
                if (op < 32) {
                    let index, subr, phase;
                    switch(op){
                        case 1:
                        case 3:
                        case 18:
                        case 23:
                            parseStems();
                            break;
                        case 4:
                            if (stack.length > 1) checkWidth();
                            y1 += stack.shift();
                            moveTo(x1, y1);
                            break;
                        case 5:
                            while(stack.length >= 2){
                                x1 += stack.shift();
                                y1 += stack.shift();
                                path.lineTo(x1, y1);
                            }
                            break;
                        case 6:
                        case 7:
                            phase = op === 6;
                            while(stack.length >= 1){
                                if (phase) x1 += stack.shift();
                                else y1 += stack.shift();
                                path.lineTo(x1, y1);
                                phase = !phase;
                            }
                            break;
                        case 8:
                            while(stack.length > 0){
                                var c1x = x1 + stack.shift();
                                var c1y = y1 + stack.shift();
                                var c2x = c1x + stack.shift();
                                var c2y = c1y + stack.shift();
                                x1 = c2x + stack.shift();
                                y1 = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            }
                            break;
                        case 10:
                            index = stack.pop() + subrsBias;
                            subr = subrs[index];
                            if (subr) {
                                usedSubrs[index] = true;
                                var p = stream.pos;
                                var e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 11:
                            if (cff.version >= 2) break;
                            return;
                        case 14:
                            if (cff.version >= 2) break;
                            if (stack.length > 0) checkWidth();
                            if (open) {
                                path.closePath();
                                open = false;
                            }
                            break;
                        case 15:
                            if (cff.version < 2) throw new Error("vsindex operator not supported in CFF v1");
                            vsindex = stack.pop();
                            break;
                        case 16:
                            {
                                if (cff.version < 2) throw new Error("blend operator not supported in CFF v1");
                                if (!variationProcessor) throw new Error("blend operator in non-variation font");
                                let blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                                let numBlends = stack.pop();
                                let numOperands = numBlends * blendVector.length;
                                let delta = stack.length - numOperands;
                                let base = delta - numBlends;
                                for(let i = 0; i < numBlends; i++){
                                    let sum = stack[base + i];
                                    for(let j = 0; j < blendVector.length; j++)sum += blendVector[j] * stack[delta++];
                                    stack[base + i] = sum;
                                }
                                while(numOperands--)stack.pop();
                                break;
                            }
                        case 19:
                        case 20:
                            parseStems();
                            stream.pos += nStems + 7 >> 3;
                            break;
                        case 21:
                            if (stack.length > 2) checkWidth();
                            x1 += stack.shift();
                            y1 += stack.shift();
                            moveTo(x1, y1);
                            break;
                        case 22:
                            if (stack.length > 1) checkWidth();
                            x1 += stack.shift();
                            moveTo(x1, y1);
                            break;
                        case 24:
                            while(stack.length >= 8){
                                var c1x = x1 + stack.shift();
                                var c1y = y1 + stack.shift();
                                var c2x = c1x + stack.shift();
                                var c2y = c1y + stack.shift();
                                x1 = c2x + stack.shift();
                                y1 = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            }
                            x1 += stack.shift();
                            y1 += stack.shift();
                            path.lineTo(x1, y1);
                            break;
                        case 25:
                            while(stack.length >= 8){
                                x1 += stack.shift();
                                y1 += stack.shift();
                                path.lineTo(x1, y1);
                            }
                            var c1x = x1 + stack.shift();
                            var c1y = y1 + stack.shift();
                            var c2x = c1x + stack.shift();
                            var c2y = c1y + stack.shift();
                            x1 = c2x + stack.shift();
                            y1 = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            break;
                        case 26:
                            if (stack.length % 2) x1 += stack.shift();
                            while(stack.length >= 4){
                                c1x = x1;
                                c1y = y1 + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x1 = c2x;
                                y1 = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            }
                            break;
                        case 27:
                            if (stack.length % 2) y1 += stack.shift();
                            while(stack.length >= 4){
                                c1x = x1 + stack.shift();
                                c1y = y1;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x1 = c2x + stack.shift();
                                y1 = c2y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                            }
                            break;
                        case 28:
                            stack.push(stream.readInt16BE());
                            break;
                        case 29:
                            index = stack.pop() + gsubrsBias;
                            subr = gsubrs[index];
                            if (subr) {
                                usedGsubrs[index] = true;
                                var p = stream.pos;
                                var e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                            }
                            break;
                        case 30:
                        case 31:
                            phase = op === 31;
                            while(stack.length >= 4){
                                if (phase) {
                                    c1x = x1 + stack.shift();
                                    c1y = y1;
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    y1 = c2y + stack.shift();
                                    x1 = c2x + (stack.length === 1 ? stack.shift() : 0);
                                } else {
                                    c1x = x1;
                                    c1y = y1 + stack.shift();
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    x1 = c2x + stack.shift();
                                    y1 = c2y + (stack.length === 1 ? stack.shift() : 0);
                                }
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x1, y1);
                                phase = !phase;
                            }
                            break;
                        case 12:
                            op = stream.readUInt8();
                            switch(op){
                                case 3:
                                    let a = stack.pop();
                                    let b = stack.pop();
                                    stack.push(a && b ? 1 : 0);
                                    break;
                                case 4:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a || b ? 1 : 0);
                                    break;
                                case 5:
                                    a = stack.pop();
                                    stack.push(a ? 0 : 1);
                                    break;
                                case 9:
                                    a = stack.pop();
                                    stack.push(Math.abs(a));
                                    break;
                                case 10:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a + b);
                                    break;
                                case 11:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a - b);
                                    break;
                                case 12:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a / b);
                                    break;
                                case 14:
                                    a = stack.pop();
                                    stack.push(-a);
                                    break;
                                case 15:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a === b ? 1 : 0);
                                    break;
                                case 18:
                                    stack.pop();
                                    break;
                                case 20:
                                    let val = stack.pop();
                                    let idx = stack.pop();
                                    trans[idx] = val;
                                    break;
                                case 21:
                                    idx = stack.pop();
                                    stack.push(trans[idx] || 0);
                                    break;
                                case 22:
                                    let s1 = stack.pop();
                                    let s2 = stack.pop();
                                    let v1 = stack.pop();
                                    let v2 = stack.pop();
                                    stack.push(v1 <= v2 ? s1 : s2);
                                    break;
                                case 23:
                                    stack.push(Math.random());
                                    break;
                                case 24:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(a * b);
                                    break;
                                case 26:
                                    a = stack.pop();
                                    stack.push(Math.sqrt(a));
                                    break;
                                case 27:
                                    a = stack.pop();
                                    stack.push(a, a);
                                    break;
                                case 28:
                                    a = stack.pop();
                                    b = stack.pop();
                                    stack.push(b, a);
                                    break;
                                case 29:
                                    idx = stack.pop();
                                    if (idx < 0) idx = 0;
                                    else if (idx > stack.length - 1) idx = stack.length - 1;
                                    stack.push(stack[idx]);
                                    break;
                                case 30:
                                    let n = stack.pop();
                                    let j = stack.pop();
                                    if (j >= 0) while(j > 0){
                                        var t = stack[n - 1];
                                        for(let i = n - 2; i >= 0; i--)stack[i + 1] = stack[i];
                                        stack[0] = t;
                                        j--;
                                    }
                                    else while(j < 0){
                                        var t = stack[0];
                                        for(let i = 0; i <= n; i++)stack[i] = stack[i + 1];
                                        stack[n - 1] = t;
                                        j++;
                                    }
                                    break;
                                case 34:
                                    c1x = x1 + stack.shift();
                                    c1y = y1;
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    let c3x = c2x + stack.shift();
                                    let c3y = c2y;
                                    let c4x = c3x + stack.shift();
                                    let c4y = c3y;
                                    let c5x = c4x + stack.shift();
                                    let c5y = c4y;
                                    let c6x = c5x + stack.shift();
                                    let c6y = c5y;
                                    x1 = c6x;
                                    y1 = c6y;
                                    path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                    path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                    break;
                                case 35:
                                    let pts = [];
                                    for(let i = 0; i <= 5; i++){
                                        x1 += stack.shift();
                                        y1 += stack.shift();
                                        pts.push(x1, y1);
                                    }
                                    path.bezierCurveTo(...pts.slice(0, 6));
                                    path.bezierCurveTo(...pts.slice(6));
                                    stack.shift(); // fd
                                    break;
                                case 36:
                                    c1x = x1 + stack.shift();
                                    c1y = y1 + stack.shift();
                                    c2x = c1x + stack.shift();
                                    c2y = c1y + stack.shift();
                                    c3x = c2x + stack.shift();
                                    c3y = c2y;
                                    c4x = c3x + stack.shift();
                                    c4y = c3y;
                                    c5x = c4x + stack.shift();
                                    c5y = c4y + stack.shift();
                                    c6x = c5x + stack.shift();
                                    c6y = c5y;
                                    x1 = c6x;
                                    y1 = c6y;
                                    path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                    path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                    break;
                                case 37:
                                    let startx = x1;
                                    let starty = y1;
                                    pts = [];
                                    for(let i1 = 0; i1 <= 4; i1++){
                                        x1 += stack.shift();
                                        y1 += stack.shift();
                                        pts.push(x1, y1);
                                    }
                                    if (Math.abs(x1 - startx) > Math.abs(y1 - starty)) {
                                        x1 += stack.shift();
                                        y1 = starty;
                                    } else {
                                        x1 = startx;
                                        y1 += stack.shift();
                                    }
                                    pts.push(x1, y1);
                                    path.bezierCurveTo(...pts.slice(0, 6));
                                    path.bezierCurveTo(...pts.slice(6));
                                    break;
                                default:
                                    throw new Error(`Unknown op: 12 ${op}`);
                            }
                            break;
                        default:
                            throw new Error(`Unknown op: ${op}`);
                    }
                } else if (op < 247) stack.push(op - 139);
                else if (op < 251) {
                    var b1 = stream.readUInt8();
                    stack.push((op - 247) * 256 + b1 + 108);
                } else if (op < 255) {
                    var b1 = stream.readUInt8();
                    stack.push(-(op - 251) * 256 - b1 - 108);
                } else stack.push(stream.readInt32BE() / 65536);
            }
        };
        parse();
        if (open) path.closePath();
        return path;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "CFF");
    }
}
let $55855d6d316b015e$var$SBIXImage = new $gfJaN$restructure.Struct({
    originX: $gfJaN$restructure.uint16,
    originY: $gfJaN$restructure.uint16,
    type: new $gfJaN$restructure.String(4),
    data: new $gfJaN$restructure.Buffer((t)=>t.parent.buflen - t._currentOffset)
});
class $55855d6d316b015e$export$2e2bcd8739ae039 extends $f680320fa07ef53d$export$2e2bcd8739ae039 {
    /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */ getImageForSize(size) {
        for(let i = 0; i < this._font.sbix.imageTables.length; i++){
            var table = this._font.sbix.imageTables[i];
            if (table.ppem >= size) break;
        }
        let offsets = table.imageOffsets;
        let start = offsets[this.id];
        let end = offsets[this.id + 1];
        if (start === end) return null;
        this._font.stream.pos = start;
        return $55855d6d316b015e$var$SBIXImage.decode(this._font.stream, {
            buflen: end - start
        });
    }
    render(ctx, size) {
        let img = this.getImageForSize(size);
        if (img != null) {
            let scale = size / this._font.unitsPerEm;
            ctx.image(img.data, {
                height: size,
                x: img.originX,
                y: (this.bbox.minY - img.originY) * scale
            });
        }
        if (this._font.sbix.flags.renderOutlines) super.render(ctx, size);
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "SBIX");
    }
}
class $42d9dbd2de9ee2d8$var$COLRLayer {
    constructor(glyph, color){
        this.glyph = glyph;
        this.color = color;
    }
}
class $42d9dbd2de9ee2d8$export$2e2bcd8739ae039 extends $0e4f52d7996e478b$export$2e2bcd8739ae039 {
    _getBBox() {
        let bbox = new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039;
        for(let i = 0; i < this.layers.length; i++){
            let layer = this.layers[i];
            let b = layer.glyph.bbox;
            bbox.addPoint(b.minX, b.minY);
            bbox.addPoint(b.maxX, b.maxY);
        }
        return bbox;
    }
    /**
   * Returns an array of objects containing the glyph and color for
   * each layer in the composite color glyph.
   * @type {object[]}
   */ get layers() {
        let cpal = this._font.CPAL;
        let colr = this._font.COLR;
        let low = 0;
        let high = colr.baseGlyphRecord.length - 1;
        while(low <= high){
            let mid = low + high >> 1;
            var rec = colr.baseGlyphRecord[mid];
            if (this.id < rec.gid) high = mid - 1;
            else if (this.id > rec.gid) low = mid + 1;
            else {
                var baseLayer = rec;
                break;
            }
        }
        // if base glyph not found in COLR table,
        // default to normal glyph from glyf or CFF
        if (baseLayer == null) {
            var g = this._font._getBaseGlyph(this.id);
            var color = {
                red: 0,
                green: 0,
                blue: 0,
                alpha: 255
            };
            return [
                new $42d9dbd2de9ee2d8$var$COLRLayer(g, color)
            ];
        }
        // otherwise, return an array of all the layers
        let layers = [];
        for(let i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++){
            var rec = colr.layerRecords[i];
            var color = cpal.colorRecords[rec.paletteIndex];
            var g = this._font._getBaseGlyph(rec.gid);
            layers.push(new $42d9dbd2de9ee2d8$var$COLRLayer(g, color));
        }
        return layers;
    }
    render(ctx, size) {
        for (let { glyph: glyph, color: color } of this.layers){
            ctx.fillColor([
                color.red,
                color.green,
                color.blue
            ], color.alpha / 255 * 100);
            glyph.render(ctx, size);
        }
        return;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "COLR");
    }
}
const $7586bb9ea67c41d8$var$TUPLES_SHARE_POINT_NUMBERS = 0x8000;
const $7586bb9ea67c41d8$var$TUPLE_COUNT_MASK = 0x0fff;
const $7586bb9ea67c41d8$var$EMBEDDED_TUPLE_COORD = 0x8000;
const $7586bb9ea67c41d8$var$INTERMEDIATE_TUPLE = 0x4000;
const $7586bb9ea67c41d8$var$PRIVATE_POINT_NUMBERS = 0x2000;
const $7586bb9ea67c41d8$var$TUPLE_INDEX_MASK = 0x0fff;
const $7586bb9ea67c41d8$var$POINTS_ARE_WORDS = 0x80;
const $7586bb9ea67c41d8$var$POINT_RUN_COUNT_MASK = 0x7f;
const $7586bb9ea67c41d8$var$DELTAS_ARE_ZERO = 0x80;
const $7586bb9ea67c41d8$var$DELTAS_ARE_WORDS = 0x40;
const $7586bb9ea67c41d8$var$DELTA_RUN_COUNT_MASK = 0x3f;
class $7586bb9ea67c41d8$export$2e2bcd8739ae039 {
    normalizeCoords(coords) {
        // the default mapping is linear along each axis, in two segments:
        // from the minValue to defaultValue, and from defaultValue to maxValue.
        let normalized = [];
        for(var i = 0; i < this.font.fvar.axis.length; i++){
            let axis = this.font.fvar.axis[i];
            if (coords[i] < axis.defaultValue) normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
            else normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
        }
        // if there is an avar table, the normalized value is calculated
        // by interpolating between the two nearest mapped values.
        if (this.font.avar) for(var i = 0; i < this.font.avar.segment.length; i++){
            let segment = this.font.avar.segment[i];
            for(let j = 0; j < segment.correspondence.length; j++){
                let pair = segment.correspondence[j];
                if (j >= 1 && normalized[i] < pair.fromCoord) {
                    let prev = segment.correspondence[j - 1];
                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                    break;
                }
            }
        }
        return normalized;
    }
    transformPoints(gid, glyphPoints) {
        if (!this.font.fvar || !this.font.gvar) return;
        let { gvar: gvar } = this.font;
        if (gid >= gvar.glyphCount) return;
        let offset = gvar.offsets[gid];
        if (offset === gvar.offsets[gid + 1]) return;
        // Read the gvar data for this glyph
        let { stream: stream } = this.font;
        stream.pos = offset;
        if (stream.pos >= stream.length) return;
        let tupleCount = stream.readUInt16BE();
        let offsetToData = offset + stream.readUInt16BE();
        if (tupleCount & $7586bb9ea67c41d8$var$TUPLES_SHARE_POINT_NUMBERS) {
            var here = stream.pos;
            stream.pos = offsetToData;
            var sharedPoints = this.decodePoints();
            offsetToData = stream.pos;
            stream.pos = here;
        }
        let origPoints = glyphPoints.map((pt)=>pt.copy());
        tupleCount &= $7586bb9ea67c41d8$var$TUPLE_COUNT_MASK;
        for(let i = 0; i < tupleCount; i++){
            let tupleDataSize = stream.readUInt16BE();
            let tupleIndex = stream.readUInt16BE();
            if (tupleIndex & $7586bb9ea67c41d8$var$EMBEDDED_TUPLE_COORD) {
                var tupleCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)tupleCoords.push(stream.readInt16BE() / 16384);
            } else {
                if ((tupleIndex & $7586bb9ea67c41d8$var$TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error("Invalid gvar table");
                var tupleCoords = gvar.globalCoords[tupleIndex & $7586bb9ea67c41d8$var$TUPLE_INDEX_MASK];
            }
            if (tupleIndex & $7586bb9ea67c41d8$var$INTERMEDIATE_TUPLE) {
                var startCoords = [];
                for(let a = 0; a < gvar.axisCount; a++)startCoords.push(stream.readInt16BE() / 16384);
                var endCoords = [];
                for(let a1 = 0; a1 < gvar.axisCount; a1++)endCoords.push(stream.readInt16BE() / 16384);
            }
            // Get the factor at which to apply this tuple
            let factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
            if (factor === 0) {
                offsetToData += tupleDataSize;
                continue;
            }
            var here = stream.pos;
            stream.pos = offsetToData;
            if (tupleIndex & $7586bb9ea67c41d8$var$PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
            else var points = sharedPoints;
            // points.length = 0 means there are deltas for all points
            let nPoints = points.length === 0 ? glyphPoints.length : points.length;
            let xDeltas = this.decodeDeltas(nPoints);
            let yDeltas = this.decodeDeltas(nPoints);
            if (points.length === 0) for(let i = 0; i < glyphPoints.length; i++){
                var point = glyphPoints[i];
                point.x += Math.round(xDeltas[i] * factor);
                point.y += Math.round(yDeltas[i] * factor);
            }
            else {
                let outPoints = origPoints.map((pt)=>pt.copy());
                let hasDelta = glyphPoints.map(()=>false);
                for(let i = 0; i < points.length; i++){
                    let idx = points[i];
                    if (idx < glyphPoints.length) {
                        let point = outPoints[idx];
                        hasDelta[idx] = true;
                        point.x += Math.round(xDeltas[i] * factor);
                        point.y += Math.round(yDeltas[i] * factor);
                    }
                }
                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                for(let i1 = 0; i1 < glyphPoints.length; i1++){
                    let deltaX = outPoints[i1].x - origPoints[i1].x;
                    let deltaY = outPoints[i1].y - origPoints[i1].y;
                    glyphPoints[i1].x += deltaX;
                    glyphPoints[i1].y += deltaY;
                }
            }
            offsetToData += tupleDataSize;
            stream.pos = here;
        }
    }
    decodePoints() {
        let stream = this.font.stream;
        let count = stream.readUInt8();
        if (count & $7586bb9ea67c41d8$var$POINTS_ARE_WORDS) count = (count & $7586bb9ea67c41d8$var$POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
        let points = new Uint16Array(count);
        let i = 0;
        let point = 0;
        while(i < count){
            let run = stream.readUInt8();
            let runCount = (run & $7586bb9ea67c41d8$var$POINT_RUN_COUNT_MASK) + 1;
            let fn = run & $7586bb9ea67c41d8$var$POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
            for(let j = 0; j < runCount && i < count; j++){
                point += fn.call(stream);
                points[i++] = point;
            }
        }
        return points;
    }
    decodeDeltas(count) {
        let stream = this.font.stream;
        let i = 0;
        let deltas = new Int16Array(count);
        while(i < count){
            let run = stream.readUInt8();
            let runCount = (run & $7586bb9ea67c41d8$var$DELTA_RUN_COUNT_MASK) + 1;
            if (run & $7586bb9ea67c41d8$var$DELTAS_ARE_ZERO) i += runCount;
            else {
                let fn = run & $7586bb9ea67c41d8$var$DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                for(let j = 0; j < runCount && i < count; j++)deltas[i++] = fn.call(stream);
            }
        }
        return deltas;
    }
    tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
        let normalized = this.normalizedCoords;
        let { gvar: gvar } = this.font;
        let factor = 1;
        for(let i = 0; i < gvar.axisCount; i++){
            if (tupleCoords[i] === 0) continue;
            if (normalized[i] === 0) return 0;
            if ((tupleIndex & $7586bb9ea67c41d8$var$INTERMEDIATE_TUPLE) === 0) {
                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) return 0;
                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
            } else {
                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) return 0;
                else if (normalized[i] < tupleCoords[i]) factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                else factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
            }
        }
        return factor;
    }
    // Interpolates points without delta values.
    // Needed for the Ø and Q glyphs in Skia.
    // Algorithm from Freetype.
    interpolateMissingDeltas(points, inPoints, hasDelta) {
        if (points.length === 0) return;
        let point = 0;
        while(point < points.length){
            let firstPoint = point;
            // find the end point of the contour
            let endPoint = point;
            let pt = points[endPoint];
            while(!pt.endContour)pt = points[++endPoint];
            // find the first point that has a delta
            while(point <= endPoint && !hasDelta[point])point++;
            if (point > endPoint) continue;
            let firstDelta = point;
            let curDelta = point;
            point++;
            while(point <= endPoint){
                // find the next point with a delta, and interpolate intermediate points
                if (hasDelta[point]) {
                    this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                    curDelta = point;
                }
                point++;
            }
            // shift contour if we only have a single delta
            if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
            else {
                // otherwise, handle the remaining points at the end and beginning of the contour
                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
            }
            point = endPoint + 1;
        }
    }
    deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
        if (p1 > p2) return;
        let iterable = [
            "x",
            "y"
        ];
        for(let i = 0; i < iterable.length; i++){
            let k = iterable[i];
            if (inPoints[ref1][k] > inPoints[ref2][k]) {
                var p = ref1;
                ref1 = ref2;
                ref2 = p;
            }
            let in1 = inPoints[ref1][k];
            let in2 = inPoints[ref2][k];
            let out1 = outPoints[ref1][k];
            let out2 = outPoints[ref2][k];
            // If the reference points have the same coordinate but different
            // delta, inferred delta is zero.  Otherwise interpolate.
            if (in1 !== in2 || out1 === out2) {
                let scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                for(let p = p1; p <= p2; p++){
                    let out = inPoints[p][k];
                    if (out <= in1) out += out1 - in1;
                    else if (out >= in2) out += out2 - in2;
                    else out = out1 + (out - in1) * scale;
                    outPoints[p][k] = out;
                }
            }
        }
    }
    deltaShift(p1, p2, ref, inPoints, outPoints) {
        let deltaX = outPoints[ref].x - inPoints[ref].x;
        let deltaY = outPoints[ref].y - inPoints[ref].y;
        if (deltaX === 0 && deltaY === 0) return;
        for(let p = p1; p <= p2; p++)if (p !== ref) {
            outPoints[p].x += deltaX;
            outPoints[p].y += deltaY;
        }
    }
    getAdvanceAdjustment(gid, table) {
        let outerIndex, innerIndex;
        if (table.advanceWidthMapping) {
            let idx = gid;
            if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
            let entryFormat = table.advanceWidthMapping.entryFormat;
            ({ outerIndex: outerIndex, innerIndex: innerIndex } = table.advanceWidthMapping.mapData[idx]);
        } else {
            outerIndex = 0;
            innerIndex = gid;
        }
        return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
    }
    // See pseudo code from `Font Variations Overview'
    // in the OpenType specification.
    getDelta(itemStore, outerIndex, innerIndex) {
        if (outerIndex >= itemStore.itemVariationData.length) return 0;
        let varData = itemStore.itemVariationData[outerIndex];
        if (innerIndex >= varData.deltaSets.length) return 0;
        let deltaSet = varData.deltaSets[innerIndex];
        let blendVector = this.getBlendVector(itemStore, outerIndex);
        let netAdjustment = 0;
        for(let master = 0; master < varData.regionIndexCount; master++)netAdjustment += deltaSet.deltas[master] * blendVector[master];
        return netAdjustment;
    }
    getBlendVector(itemStore, outerIndex) {
        let varData = itemStore.itemVariationData[outerIndex];
        if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
        let normalizedCoords = this.normalizedCoords;
        let blendVector = [];
        // outer loop steps through master designs to be blended
        for(let master = 0; master < varData.regionIndexCount; master++){
            let scalar = 1;
            let regionIndex = varData.regionIndexes[master];
            let axes = itemStore.variationRegionList.variationRegions[regionIndex];
            // inner loop steps through axes in this region
            for(let j = 0; j < axes.length; j++){
                let axis = axes[j];
                let axisScalar;
                // compute the scalar contribution of this axis
                // ignore invalid ranges
                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
                else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1;
                else if (axis.peakCoord === 0) axisScalar = 1;
                else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0;
                else {
                    if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
                    else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                    else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                }
                // take product of all the axis scalars
                scalar *= axisScalar;
            }
            blendVector[master] = scalar;
        }
        this.blendVectors.set(varData, blendVector);
        return blendVector;
    }
    constructor(font, coords){
        this.font = font;
        this.normalizedCoords = this.normalizeCoords(coords);
        this.blendVectors = new Map;
    }
}
const $a8ac370803cb82cf$var$resolved = Promise.resolve();
class $a8ac370803cb82cf$export$2e2bcd8739ae039 {
    includeGlyph(glyph) {
        if (typeof glyph === "object") glyph = glyph.id;
        if (this.mapping[glyph] == null) {
            this.glyphs.push(glyph);
            this.mapping[glyph] = this.glyphs.length - 1;
        }
        return this.mapping[glyph];
    }
    constructor(font){
        this.font = font;
        this.glyphs = [];
        this.mapping = {};
        // always include the missing glyph
        this.includeGlyph(0);
    }
}
// Flags for simple glyphs
const $2784eedf0b35a048$var$ON_CURVE = 1;
const $2784eedf0b35a048$var$X_SHORT_VECTOR = 2;
const $2784eedf0b35a048$var$Y_SHORT_VECTOR = 4;
const $2784eedf0b35a048$var$REPEAT = 8;
const $2784eedf0b35a048$var$SAME_X = 16;
const $2784eedf0b35a048$var$SAME_Y = 32;
class $2784eedf0b35a048$var$Point {
    static size(val) {
        return val >= 0 && val <= 255 ? 1 : 2;
    }
    static encode(stream, value) {
        if (value >= 0 && value <= 255) stream.writeUInt8(value);
        else stream.writeInt16BE(value);
    }
}
let $2784eedf0b35a048$var$Glyf = new $gfJaN$restructure.Struct({
    numberOfContours: $gfJaN$restructure.int16,
    xMin: $gfJaN$restructure.int16,
    yMin: $gfJaN$restructure.int16,
    xMax: $gfJaN$restructure.int16,
    yMax: $gfJaN$restructure.int16,
    endPtsOfContours: new $gfJaN$restructure.Array($gfJaN$restructure.uint16, "numberOfContours"),
    instructions: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, $gfJaN$restructure.uint16),
    flags: new $gfJaN$restructure.Array($gfJaN$restructure.uint8, 0),
    xPoints: new $gfJaN$restructure.Array($2784eedf0b35a048$var$Point, 0),
    yPoints: new $gfJaN$restructure.Array($2784eedf0b35a048$var$Point, 0)
});
class $2784eedf0b35a048$export$2e2bcd8739ae039 {
    encodeSimple(path, instructions = []) {
        let endPtsOfContours = [];
        let xPoints = [];
        let yPoints = [];
        let flags = [];
        let same = 0;
        let lastX = 0, lastY = 0, lastFlag = 0;
        let pointCount = 0;
        for(let i = 0; i < path.commands.length; i++){
            let c = path.commands[i];
            for(let j = 0; j < c.args.length; j += 2){
                let x = c.args[j];
                let y = c.args[j + 1];
                let flag = 0;
                // If the ending point of a quadratic curve is the midpoint
                // between the control point and the control point of the next
                // quadratic curve, we can omit the ending point.
                if (c.command === "quadraticCurveTo" && j === 2) {
                    let next = path.commands[i + 1];
                    if (next && next.command === "quadraticCurveTo") {
                        let midX = (lastX + next.args[0]) / 2;
                        let midY = (lastY + next.args[1]) / 2;
                        if (x === midX && y === midY) continue;
                    }
                }
                // All points except control points are on curve.
                if (!(c.command === "quadraticCurveTo" && j === 0)) flag |= $2784eedf0b35a048$var$ON_CURVE;
                flag = this._encodePoint(x, lastX, xPoints, flag, $2784eedf0b35a048$var$X_SHORT_VECTOR, $2784eedf0b35a048$var$SAME_X);
                flag = this._encodePoint(y, lastY, yPoints, flag, $2784eedf0b35a048$var$Y_SHORT_VECTOR, $2784eedf0b35a048$var$SAME_Y);
                if (flag === lastFlag && same < 255) {
                    flags[flags.length - 1] |= $2784eedf0b35a048$var$REPEAT;
                    same++;
                } else {
                    if (same > 0) {
                        flags.push(same);
                        same = 0;
                    }
                    flags.push(flag);
                    lastFlag = flag;
                }
                lastX = x;
                lastY = y;
                pointCount++;
            }
            if (c.command === "closePath") endPtsOfContours.push(pointCount - 1);
        }
        // Close the path if the last command didn't already
        if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== "closePath") endPtsOfContours.push(pointCount - 1);
        let bbox = path.bbox;
        let glyf = {
            numberOfContours: endPtsOfContours.length,
            xMin: bbox.minX,
            yMin: bbox.minY,
            xMax: bbox.maxX,
            yMax: bbox.maxY,
            endPtsOfContours: endPtsOfContours,
            instructions: instructions,
            flags: flags,
            xPoints: xPoints,
            yPoints: yPoints
        };
        let size = $2784eedf0b35a048$var$Glyf.size(glyf);
        let tail = 4 - size % 4;
        let stream = new $gfJaN$restructure.EncodeStream(size + tail);
        $2784eedf0b35a048$var$Glyf.encode(stream, glyf);
        // Align to 4-byte length
        if (tail !== 0) stream.fill(0, tail);
        return stream.buffer;
    }
    _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
        let diff = value - last;
        if (value === last) flag |= sameFlag;
        else {
            if (-255 <= diff && diff <= 255) {
                flag |= shortFlag;
                if (diff < 0) diff = -diff;
                else flag |= sameFlag;
            }
            points.push(diff);
        }
        return flag;
    }
}
class $fe042f4b88f46896$export$2e2bcd8739ae039 extends $a8ac370803cb82cf$export$2e2bcd8739ae039 {
    _addGlyph(gid) {
        let glyph = this.font.getGlyph(gid);
        let glyf = glyph._decode();
        // get the offset to the glyph from the loca table
        let curOffset = this.font.loca.offsets[gid];
        let nextOffset = this.font.loca.offsets[gid + 1];
        let stream = this.font._getTableStream("glyf");
        stream.pos += curOffset;
        let buffer = stream.readBuffer(nextOffset - curOffset);
        // if it is a compound glyph, include its components
        if (glyf && glyf.numberOfContours < 0) {
            buffer = new Uint8Array(buffer);
            let view = new DataView(buffer.buffer);
            for (let component of glyf.components){
                gid = this.includeGlyph(component.glyphID);
                view.setUint16(component.pos, gid);
            }
        } else if (glyf && this.font._variationProcessor) buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
        this.glyf.push(buffer);
        this.loca.offsets.push(this.offset);
        this.hmtx.metrics.push({
            advance: glyph.advanceWidth,
            bearing: glyph._getMetrics().leftBearing
        });
        this.offset += buffer.length;
        return this.glyf.length - 1;
    }
    encode() {
        // tables required by PDF spec:
        //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
        //
        // additional tables required for standalone fonts:
        //   name, cmap, OS/2, post
        this.glyf = [];
        this.offset = 0;
        this.loca = {
            offsets: [],
            version: this.font.loca.version
        };
        this.hmtx = {
            metrics: [],
            bearings: []
        };
        // include all the glyphs
        // not using a for loop because we need to support adding more
        // glyphs to the array as we go, and CoffeeScript caches the length.
        let i = 0;
        while(i < this.glyphs.length)this._addGlyph(this.glyphs[i++]);
        let maxp = $parcel$interopDefault($gfJaN$clone)(this.font.maxp);
        maxp.numGlyphs = this.glyf.length;
        this.loca.offsets.push(this.offset);
        let head = $parcel$interopDefault($gfJaN$clone)(this.font.head);
        head.indexToLocFormat = this.loca.version;
        let hhea = $parcel$interopDefault($gfJaN$clone)(this.font.hhea);
        hhea.numberOfMetrics = this.hmtx.metrics.length;
        // map = []
        // for index in [0...256]
        //     if index < @numGlyphs
        //         map[index] = index
        //     else
        //         map[index] = 0
        //
        // cmapTable =
        //     version: 0
        //     length: 262
        //     language: 0
        //     codeMap: map
        //
        // cmap =
        //     version: 0
        //     numSubtables: 1
        //     tables: [
        //         platformID: 1
        //         encodingID: 0
        //         table: cmapTable
        //     ]
        // TODO: subset prep, cvt, fpgm?
        return $df50e1efe10a1247$export$2e2bcd8739ae039.toBuffer({
            tables: {
                head: head,
                hhea: hhea,
                loca: this.loca,
                maxp: maxp,
                "cvt ": this.font["cvt "],
                prep: this.font.prep,
                glyf: this.glyf,
                hmtx: this.hmtx,
                fpgm: this.font.fpgm
            }
        });
    }
    constructor(font){
        super(font);
        this.glyphEncoder = new $2784eedf0b35a048$export$2e2bcd8739ae039;
    }
}
class $ec40f80c07a4e08a$export$2e2bcd8739ae039 extends $a8ac370803cb82cf$export$2e2bcd8739ae039 {
    subsetCharstrings() {
        this.charstrings = [];
        let gsubrs = {};
        for (let gid of this.glyphs){
            this.charstrings.push(this.cff.getCharString(gid));
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedGsubrs)gsubrs[subr] = true;
        }
        this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
    }
    subsetSubrs(subrs, used) {
        let res = [];
        for(let i = 0; i < subrs.length; i++){
            let subr = subrs[i];
            if (used[i]) {
                this.cff.stream.pos = subr.offset;
                res.push(this.cff.stream.readBuffer(subr.length));
            } else res.push(new Uint8Array([
                11
            ])); // return
        }
        return res;
    }
    subsetFontdict(topDict) {
        topDict.FDArray = [];
        topDict.FDSelect = {
            version: 0,
            fds: []
        };
        let used_fds = {};
        let used_subrs = [];
        let fd_select = {};
        for (let gid of this.glyphs){
            let fd = this.cff.fdForGlyph(gid);
            if (fd == null) continue;
            if (!used_fds[fd]) {
                topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
                used_subrs.push({});
                fd_select[fd] = topDict.FDArray.length - 1;
            }
            used_fds[fd] = true;
            topDict.FDSelect.fds.push(fd_select[fd]);
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedSubrs)used_subrs[fd_select[fd]][subr] = true;
        }
        for(let i = 0; i < topDict.FDArray.length; i++){
            let dict = topDict.FDArray[i];
            delete dict.FontName;
            if (dict.Private && dict.Private.Subrs) {
                dict.Private = Object.assign({}, dict.Private);
                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
            }
        }
        return;
    }
    createCIDFontdict(topDict) {
        let used_subrs = {};
        for (let gid of this.glyphs){
            let glyph = this.font.getGlyph(gid);
            let path = glyph.path; // this causes the glyph to be parsed
            for(let subr in glyph._usedSubrs)used_subrs[subr] = true;
        }
        let privateDict = Object.assign({}, this.cff.topDict.Private);
        if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
        topDict.FDArray = [
            {
                Private: privateDict
            }
        ];
        return topDict.FDSelect = {
            version: 3,
            nRanges: 1,
            ranges: [
                {
                    first: 0,
                    fd: 0
                }
            ],
            sentinel: this.charstrings.length
        };
    }
    addString(string) {
        if (!string) return null;
        if (!this.strings) this.strings = [];
        this.strings.push(string);
        return $860d3574d7fa3a51$export$2e2bcd8739ae039.length + this.strings.length - 1;
    }
    encode() {
        this.subsetCharstrings();
        let charset = {
            version: this.charstrings.length > 255 ? 2 : 1,
            ranges: [
                {
                    first: 1,
                    nLeft: this.charstrings.length - 2
                }
            ]
        };
        let topDict = Object.assign({}, this.cff.topDict);
        topDict.Private = null;
        topDict.charset = charset;
        topDict.Encoding = null;
        topDict.CharStrings = this.charstrings;
        for (let key of [
            "version",
            "Notice",
            "Copyright",
            "FullName",
            "FamilyName",
            "Weight",
            "PostScript",
            "BaseFontName",
            "FontName"
        ])topDict[key] = this.addString(this.cff.string(topDict[key]));
        topDict.ROS = [
            this.addString("Adobe"),
            this.addString("Identity"),
            0
        ];
        topDict.CIDCount = this.charstrings.length;
        if (this.cff.isCIDFont) this.subsetFontdict(topDict);
        else this.createCIDFontdict(topDict);
        let top = {
            version: 1,
            hdrSize: this.cff.hdrSize,
            offSize: 4,
            header: this.cff.header,
            nameIndex: [
                this.cff.postscriptName
            ],
            topDictIndex: [
                topDict
            ],
            stringIndex: this.strings,
            globalSubrIndex: this.gsubrs
        };
        return $5b547cf9e5da519b$export$2e2bcd8739ae039.toBuffer(top);
    }
    constructor(font){
        super(font);
        this.cff = this.font["CFF "];
        if (!this.cff) throw new Error("Not a CFF Font");
    }
}
class $0a8ef2660a6ce4b6$export$2e2bcd8739ae039 {
    static probe(buffer) {
        let format = $66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4));
        return format === "true" || format === "OTTO" || format === String.fromCharCode(0, 1, 0, 0);
    }
    setDefaultLanguage(lang = null) {
        this.defaultLanguage = lang;
    }
    _getTable(table) {
        if (!(table.tag in this._tables)) try {
            this._tables[table.tag] = this._decodeTable(table);
        } catch (e) {
            if ($59aa4ed98453e1d4$export$bd5c5d8b8dcafd78) {
                console.error(`Error decoding table ${table.tag}`);
                console.error(e.stack);
            }
        }
        return this._tables[table.tag];
    }
    _getTableStream(tag) {
        let table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            return this.stream;
        }
        return null;
    }
    _decodeDirectory() {
        return this.directory = $df50e1efe10a1247$export$2e2bcd8739ae039.decode(this.stream, {
            _startOffset: 0
        });
    }
    _decodeTable(table) {
        let pos = this.stream.pos;
        let stream = this._getTableStream(table.tag);
        let result = $5825c04ce8f7102d$export$2e2bcd8739ae039[table.tag].decode(stream, this, table.length);
        this.stream.pos = pos;
        return result;
    }
    /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */ getName(key, lang = this.defaultLanguage || $59aa4ed98453e1d4$export$42940898df819940) {
        let record = this.name && this.name.records[key];
        if (record) return record[lang] || record[this.defaultLanguage] || record[$59aa4ed98453e1d4$export$42940898df819940] || record["en"] || record[Object.keys(record)[0]] // Seriously, ANY language would be fine
         || null;
        return null;
    }
    /**
   * The unique PostScript name for this font, e.g. "Helvetica-Bold"
   * @type {string}
   */ get postscriptName() {
        return this.getName("postscriptName");
    }
    /**
   * The font's full name, e.g. "Helvetica Bold"
   * @type {string}
   */ get fullName() {
        return this.getName("fullName");
    }
    /**
   * The font's family name, e.g. "Helvetica"
   * @type {string}
   */ get familyName() {
        return this.getName("fontFamily");
    }
    /**
   * The font's sub-family, e.g. "Bold".
   * @type {string}
   */ get subfamilyName() {
        return this.getName("fontSubfamily");
    }
    /**
   * The font's copyright information
   * @type {string}
   */ get copyright() {
        return this.getName("copyright");
    }
    /**
   * The font's version number
   * @type {string}
   */ get version() {
        return this.getName("version");
    }
    /**
   * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
   * @type {number}
   */ get ascent() {
        return this.hhea.ascent;
    }
    /**
   * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
   * @type {number}
   */ get descent() {
        return this.hhea.descent;
    }
    /**
   * The amount of space that should be included between lines
   * @type {number}
   */ get lineGap() {
        return this.hhea.lineGap;
    }
    /**
   * The offset from the normal underline position that should be used
   * @type {number}
   */ get underlinePosition() {
        return this.post.underlinePosition;
    }
    /**
   * The weight of the underline that should be used
   * @type {number}
   */ get underlineThickness() {
        return this.post.underlineThickness;
    }
    /**
   * If this is an italic font, the angle the cursor should be drawn at to match the font design
   * @type {number}
   */ get italicAngle() {
        return this.post.italicAngle;
    }
    /**
   * The height of capital letters above the baseline.
   * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
   * @type {number}
   */ get capHeight() {
        let os2 = this["OS/2"];
        return os2 ? os2.capHeight : this.ascent;
    }
    /**
   * The height of lower case letters in the font.
   * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
   * @type {number}
   */ get xHeight() {
        let os2 = this["OS/2"];
        return os2 ? os2.xHeight : 0;
    }
    /**
   * The number of glyphs in the font.
   * @type {number}
   */ get numGlyphs() {
        return this.maxp.numGlyphs;
    }
    /**
   * The size of the font’s internal coordinate grid
   * @type {number}
   */ get unitsPerEm() {
        return this.head.unitsPerEm;
    }
    /**
   * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
   * @type {BBox}
   */ get bbox() {
        return Object.freeze(new $0e2da1c4ce69e8ad$export$2e2bcd8739ae039(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
    }
    get _cmapProcessor() {
        return new $0d6e160064c86e50$export$2e2bcd8739ae039(this.cmap);
    }
    /**
   * An array of all of the unicode code points supported by the font.
   * @type {number[]}
   */ get characterSet() {
        return this._cmapProcessor.getCharacterSet();
    }
    /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */ hasGlyphForCodePoint(codePoint) {
        return !!this._cmapProcessor.lookup(codePoint);
    }
    /**
   * Maps a single unicode code point to a Glyph object.
   * Does not perform any advanced substitutions (there is no context to do so).
   *
   * @param {number} codePoint
   * @return {Glyph}
   */ glyphForCodePoint(codePoint) {
        return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
            codePoint
        ]);
    }
    /**
   * Returns an array of Glyph objects for the given string.
   * This is only a one-to-one mapping from characters to glyphs.
   * For most uses, you should use font.layout (described below), which
   * provides a much more advanced mapping supporting AAT and OpenType shaping.
   *
   * @param {string} string
   * @return {Glyph[]}
   */ glyphsForString(string) {
        let glyphs = [];
        let len = string.length;
        let idx = 0;
        let last = -1;
        let state = -1;
        while(idx <= len){
            let code = 0;
            let nextState = 0;
            if (idx < len) {
                // Decode the next codepoint from UTF 16
                code = string.charCodeAt(idx++);
                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                    let next = string.charCodeAt(idx);
                    if (0xdc00 <= next && next <= 0xdfff) {
                        idx++;
                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                    }
                }
                // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
            } else idx++;
            if (state === 0 && nextState === 1) glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                last,
                code
            ]));
            else if (state === 0 && nextState === 0) glyphs.push(this.glyphForCodePoint(last));
            last = code;
            state = nextState;
        }
        return glyphs;
    }
    get _layoutEngine() {
        return new $9d641258c9d7180d$export$2e2bcd8739ae039(this);
    }
    /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */ layout(string, userFeatures, script, language, direction) {
        return this._layoutEngine.layout(string, userFeatures, script, language, direction);
    }
    /**
   * Returns an array of strings that map to the given glyph id.
   * @param {number} gid - glyph id
   */ stringsForGlyph(gid) {
        return this._layoutEngine.stringsForGlyph(gid);
    }
    /**
   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
   * (or mapped AAT tags) supported by the font.
   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
   *
   * @type {string[]}
   */ get availableFeatures() {
        return this._layoutEngine.getAvailableFeatures();
    }
    getAvailableFeatures(script, language) {
        return this._layoutEngine.getAvailableFeatures(script, language);
    }
    _getBaseGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf) this._glyphs[glyph] = new $f680320fa07ef53d$export$2e2bcd8739ae039(glyph, characters, this);
            else if (this.directory.tables["CFF "] || this.directory.tables.CFF2) this._glyphs[glyph] = new $7ee0705195f3b047$export$2e2bcd8739ae039(glyph, characters, this);
        }
        return this._glyphs[glyph] || null;
    }
    /**
   * Returns a glyph object for the given glyph id.
   * You can pass the array of code points this glyph represents for
   * your use later, and it will be stored in the glyph object.
   *
   * @param {number} glyph
   * @param {number[]} characters
   * @return {Glyph}
   */ getGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.sbix) this._glyphs[glyph] = new $55855d6d316b015e$export$2e2bcd8739ae039(glyph, characters, this);
            else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new $42d9dbd2de9ee2d8$export$2e2bcd8739ae039(glyph, characters, this);
            else this._getBaseGlyph(glyph, characters);
        }
        return this._glyphs[glyph] || null;
    }
    /**
   * Returns a Subset for this font.
   * @return {Subset}
   */ createSubset() {
        if (this.directory.tables["CFF "]) return new $ec40f80c07a4e08a$export$2e2bcd8739ae039(this);
        return new $fe042f4b88f46896$export$2e2bcd8739ae039(this);
    }
    /**
   * Returns an object describing the available variation axes
   * that this font supports. Keys are setting tags, and values
   * contain the axis name, range, and default value.
   *
   * @type {object}
   */ get variationAxes() {
        let res = {};
        if (!this.fvar) return res;
        for (let axis of this.fvar.axis)res[axis.axisTag.trim()] = {
            name: axis.name.en,
            min: axis.minValue,
            default: axis.defaultValue,
            max: axis.maxValue
        };
        return res;
    }
    /**
   * Returns an object describing the named variation instances
   * that the font designer has specified. Keys are variation names
   * and values are the variation settings for this instance.
   *
   * @type {object}
   */ get namedVariations() {
        let res = {};
        if (!this.fvar) return res;
        for (let instance of this.fvar.instance){
            let settings = {};
            for(let i = 0; i < this.fvar.axis.length; i++){
                let axis = this.fvar.axis[i];
                settings[axis.axisTag.trim()] = instance.coord[i];
            }
            res[instance.name.en] = settings;
        }
        return res;
    }
    /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */ getVariation(settings) {
        if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
        if (typeof settings === "string") settings = this.namedVariations[settings];
        if (typeof settings !== "object") throw new Error("Variation settings must be either a variation name or settings object.");
        // normalize the coordinates
        let coords = this.fvar.axis.map((axis, i)=>{
            let axisTag = axis.axisTag.trim();
            if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
            else return axis.defaultValue;
        });
        let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer);
        stream.pos = this._directoryPos;
        let font = new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream, coords);
        font._tables = this._tables;
        return font;
    }
    get _variationProcessor() {
        if (!this.fvar) return null;
        let variationCoords = this.variationCoords;
        // Ignore if no variation coords and not CFF2
        if (!variationCoords && !this.CFF2) return null;
        if (!variationCoords) variationCoords = this.fvar.axis.map((axis)=>axis.defaultValue);
        return new $7586bb9ea67c41d8$export$2e2bcd8739ae039(this, variationCoords);
    }
    // Standardized format plugin API
    getFont(name) {
        return this.getVariation(name);
    }
    constructor(stream, variationCoords = null){
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "TTF");
        this.defaultLanguage = null;
        this.stream = stream;
        this.variationCoords = variationCoords;
        this._directoryPos = this.stream.pos;
        this._tables = {};
        this._glyphs = {};
        this._decodeDirectory();
        // define properties for each table to lazily parse
        for(let tag in this.directory.tables){
            let table = this.directory.tables[tag];
            if ($5825c04ce8f7102d$export$2e2bcd8739ae039[tag] && table.length > 0) Object.defineProperty(this, tag, {
                get: this._getTable.bind(this, table)
            });
        }
    }
}
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "bbox", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "_cmapProcessor", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "characterSet", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "_layoutEngine", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "variationAxes", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "namedVariations", null);
$parcel$interopDefault($gfJaN$swchelperslib_ts_decoratejs)([
    $3bda6911913b43f0$export$69a3209f1a06c04d
], $0a8ef2660a6ce4b6$export$2e2bcd8739ae039.prototype, "_variationProcessor", null);
let $89f72d2d7c9afc0d$var$WOFFDirectoryEntry = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    offset: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, "void", {
        type: "global"
    }),
    compLength: $gfJaN$restructure.uint32,
    length: $gfJaN$restructure.uint32,
    origChecksum: $gfJaN$restructure.uint32
});
let $89f72d2d7c9afc0d$var$WOFFDirectory = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    flavor: $gfJaN$restructure.uint32,
    length: $gfJaN$restructure.uint32,
    numTables: $gfJaN$restructure.uint16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    totalSfntSize: $gfJaN$restructure.uint32,
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    metaOffset: $gfJaN$restructure.uint32,
    metaLength: $gfJaN$restructure.uint32,
    metaOrigLength: $gfJaN$restructure.uint32,
    privOffset: $gfJaN$restructure.uint32,
    privLength: $gfJaN$restructure.uint32,
    tables: new $gfJaN$restructure.Array($89f72d2d7c9afc0d$var$WOFFDirectoryEntry, "numTables")
});
$89f72d2d7c9afc0d$var$WOFFDirectory.process = function() {
    let tables1 = {};
    for (let table of this.tables)tables1[table.tag] = table;
    this.tables = tables1;
};
var $89f72d2d7c9afc0d$export$2e2bcd8739ae039 = $89f72d2d7c9afc0d$var$WOFFDirectory;
class $8a0a49baaf5d834d$export$2e2bcd8739ae039 extends $0a8ef2660a6ce4b6$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === "wOFF";
    }
    _decodeDirectory() {
        this.directory = $89f72d2d7c9afc0d$export$2e2bcd8739ae039.decode(this.stream, {
            _startOffset: 0
        });
    }
    _getTableStream(tag) {
        let table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            if (table.compLength < table.length) {
                this.stream.pos += 2; // skip deflate header
                let outBuffer = new Uint8Array(table.length);
                let buf = $parcel$interopDefault($gfJaN$tinyinflate)(this.stream.readBuffer(table.compLength - 2), outBuffer);
                return new $gfJaN$restructure.DecodeStream(buf);
            } else return this.stream;
        }
        return null;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "WOFF");
    }
}
class $44b9edca0e403d6d$export$2e2bcd8739ae039 extends $f680320fa07ef53d$export$2e2bcd8739ae039 {
    _decode() {
        // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
        return this._font._transformedGlyphs[this.id];
    }
    _getCBox() {
        return this.path.bbox;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "WOFF2");
    }
}
const $2f0bfd9a5c1d7b58$var$Base128 = {
    decode (stream) {
        let result = 0;
        let iterable = [
            0,
            1,
            2,
            3,
            4
        ];
        for(let j = 0; j < iterable.length; j++){
            let i = iterable[j];
            let code = stream.readUInt8();
            // If any of the top seven bits are set then we're about to overflow.
            if (result & 0xe0000000) throw new Error("Overflow");
            result = result << 7 | code & 0x7f;
            if ((code & 0x80) === 0) return result;
        }
        throw new Error("Bad base 128 number");
    }
};
let $2f0bfd9a5c1d7b58$var$knownTags = [
    "cmap",
    "head",
    "hhea",
    "hmtx",
    "maxp",
    "name",
    "OS/2",
    "post",
    "cvt ",
    "fpgm",
    "glyf",
    "loca",
    "prep",
    "CFF ",
    "VORG",
    "EBDT",
    "EBLC",
    "gasp",
    "hdmx",
    "kern",
    "LTSH",
    "PCLT",
    "VDMX",
    "vhea",
    "vmtx",
    "BASE",
    "GDEF",
    "GPOS",
    "GSUB",
    "EBSC",
    "JSTF",
    "MATH",
    "CBDT",
    "CBLC",
    "COLR",
    "CPAL",
    "SVG ",
    "sbix",
    "acnt",
    "avar",
    "bdat",
    "bloc",
    "bsln",
    "cvar",
    "fdsc",
    "feat",
    "fmtx",
    "fvar",
    "gvar",
    "hsty",
    "just",
    "lcar",
    "mort",
    "morx",
    "opbd",
    "prop",
    "trak",
    "Zapf",
    "Silf",
    "Glat",
    "Gloc",
    "Feat",
    "Sill"
];
let $2f0bfd9a5c1d7b58$var$WOFF2DirectoryEntry = new $gfJaN$restructure.Struct({
    flags: $gfJaN$restructure.uint8,
    customTag: new $gfJaN$restructure.Optional(new $gfJaN$restructure.String(4), (t)=>(t.flags & 0x3f) === 0x3f),
    tag: (t)=>t.customTag || $2f0bfd9a5c1d7b58$var$knownTags[t.flags & 0x3f],
    length: $2f0bfd9a5c1d7b58$var$Base128,
    transformVersion: (t)=>t.flags >>> 6 & 0x03,
    transformed: (t)=>t.tag === "glyf" || t.tag === "loca" ? t.transformVersion === 0 : t.transformVersion !== 0,
    transformLength: new $gfJaN$restructure.Optional($2f0bfd9a5c1d7b58$var$Base128, (t)=>t.transformed)
});
let $2f0bfd9a5c1d7b58$var$WOFF2Directory = new $gfJaN$restructure.Struct({
    tag: new $gfJaN$restructure.String(4),
    flavor: $gfJaN$restructure.uint32,
    length: $gfJaN$restructure.uint32,
    numTables: $gfJaN$restructure.uint16,
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint16),
    totalSfntSize: $gfJaN$restructure.uint32,
    totalCompressedSize: $gfJaN$restructure.uint32,
    majorVersion: $gfJaN$restructure.uint16,
    minorVersion: $gfJaN$restructure.uint16,
    metaOffset: $gfJaN$restructure.uint32,
    metaLength: $gfJaN$restructure.uint32,
    metaOrigLength: $gfJaN$restructure.uint32,
    privOffset: $gfJaN$restructure.uint32,
    privLength: $gfJaN$restructure.uint32,
    tables: new $gfJaN$restructure.Array($2f0bfd9a5c1d7b58$var$WOFF2DirectoryEntry, "numTables")
});
$2f0bfd9a5c1d7b58$var$WOFF2Directory.process = function() {
    let tables = {};
    for(let i = 0; i < this.tables.length; i++){
        let table = this.tables[i];
        tables[table.tag] = table;
    }
    return this.tables = tables;
};
var $2f0bfd9a5c1d7b58$export$2e2bcd8739ae039 = $2f0bfd9a5c1d7b58$var$WOFF2Directory;
class $333fb94547d9fb5c$export$2e2bcd8739ae039 extends $0a8ef2660a6ce4b6$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === "wOF2";
    }
    _decodeDirectory() {
        this.directory = $2f0bfd9a5c1d7b58$export$2e2bcd8739ae039.decode(this.stream);
        this._dataPos = this.stream.pos;
    }
    _decompress() {
        // decompress data and setup table offsets if we haven't already
        if (!this._decompressed) {
            this.stream.pos = this._dataPos;
            let buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
            let decompressedSize = 0;
            for(let tag in this.directory.tables){
                let entry = this.directory.tables[tag];
                entry.offset = decompressedSize;
                decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
            }
            let decompressed = $parcel$interopDefault($gfJaN$brotlidecompressjs)(buffer, decompressedSize);
            if (!decompressed) throw new Error("Error decoding compressed data in WOFF2");
            this.stream = new $gfJaN$restructure.DecodeStream(decompressed);
            this._decompressed = true;
        }
    }
    _decodeTable(table) {
        this._decompress();
        return super._decodeTable(table);
    }
    // Override this method to get a glyph and return our
    // custom subclass if there is a glyf table.
    _getBaseGlyph(glyph, characters = []) {
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                if (!this._transformedGlyphs) this._transformGlyfTable();
                return this._glyphs[glyph] = new $44b9edca0e403d6d$export$2e2bcd8739ae039(glyph, characters, this);
            } else return super._getBaseGlyph(glyph, characters);
        }
    }
    _transformGlyfTable() {
        this._decompress();
        this.stream.pos = this.directory.tables.glyf.offset;
        let table = $333fb94547d9fb5c$var$GlyfTable.decode(this.stream);
        let glyphs = [];
        for(let index = 0; index < table.numGlyphs; index++){
            let glyph = {};
            let nContours = table.nContours.readInt16BE();
            glyph.numberOfContours = nContours;
            if (nContours > 0) {
                let nPoints = [];
                let totalPoints = 0;
                for(let i = 0; i < nContours; i++){
                    let r1 = $333fb94547d9fb5c$var$read255UInt16(table.nPoints);
                    totalPoints += r1;
                    nPoints.push(totalPoints);
                }
                glyph.points = $333fb94547d9fb5c$var$decodeTriplet(table.flags, table.glyphs, totalPoints);
                for(let i1 = 0; i1 < nContours; i1++)glyph.points[nPoints[i1] - 1].endContour = true;
                var instructionSize = $333fb94547d9fb5c$var$read255UInt16(table.glyphs);
            } else if (nContours < 0) {
                let haveInstructions = $f680320fa07ef53d$export$2e2bcd8739ae039.prototype._decodeComposite.call({
                    _font: this
                }, glyph, table.composites);
                if (haveInstructions) var instructionSize = $333fb94547d9fb5c$var$read255UInt16(table.glyphs);
            }
            glyphs.push(glyph);
        }
        this._transformedGlyphs = glyphs;
    }
    constructor(...args){
        super(...args);
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "WOFF2");
    }
}
// Special class that accepts a length and returns a sub-stream for that data
class $333fb94547d9fb5c$var$Substream {
    decode(stream, parent) {
        return new $gfJaN$restructure.DecodeStream(this._buf.decode(stream, parent));
    }
    constructor(length){
        this.length = length;
        this._buf = new $gfJaN$restructure.Buffer(length);
    }
}
// This struct represents the entire glyf table
let $333fb94547d9fb5c$var$GlyfTable = new $gfJaN$restructure.Struct({
    version: $gfJaN$restructure.uint32,
    numGlyphs: $gfJaN$restructure.uint16,
    indexFormat: $gfJaN$restructure.uint16,
    nContourStreamSize: $gfJaN$restructure.uint32,
    nPointsStreamSize: $gfJaN$restructure.uint32,
    flagStreamSize: $gfJaN$restructure.uint32,
    glyphStreamSize: $gfJaN$restructure.uint32,
    compositeStreamSize: $gfJaN$restructure.uint32,
    bboxStreamSize: $gfJaN$restructure.uint32,
    instructionStreamSize: $gfJaN$restructure.uint32,
    nContours: new $333fb94547d9fb5c$var$Substream("nContourStreamSize"),
    nPoints: new $333fb94547d9fb5c$var$Substream("nPointsStreamSize"),
    flags: new $333fb94547d9fb5c$var$Substream("flagStreamSize"),
    glyphs: new $333fb94547d9fb5c$var$Substream("glyphStreamSize"),
    composites: new $333fb94547d9fb5c$var$Substream("compositeStreamSize"),
    bboxes: new $333fb94547d9fb5c$var$Substream("bboxStreamSize"),
    instructions: new $333fb94547d9fb5c$var$Substream("instructionStreamSize")
});
const $333fb94547d9fb5c$var$WORD_CODE = 253;
const $333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE2 = 254;
const $333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE1 = 255;
const $333fb94547d9fb5c$var$LOWEST_U_CODE = 253;
function $333fb94547d9fb5c$var$read255UInt16(stream) {
    let code = stream.readUInt8();
    if (code === $333fb94547d9fb5c$var$WORD_CODE) return stream.readUInt16BE();
    if (code === $333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE1) return stream.readUInt8() + $333fb94547d9fb5c$var$LOWEST_U_CODE;
    if (code === $333fb94547d9fb5c$var$ONE_MORE_BYTE_CODE2) return stream.readUInt8() + $333fb94547d9fb5c$var$LOWEST_U_CODE * 2;
    return code;
}
function $333fb94547d9fb5c$var$withSign(flag, baseval) {
    return flag & 1 ? baseval : -baseval;
}
function $333fb94547d9fb5c$var$decodeTriplet(flags, glyphs, nPoints) {
    let y;
    let x = y = 0;
    let res = [];
    for(let i = 0; i < nPoints; i++){
        let dx = 0, dy = 0;
        let flag = flags.readUInt8();
        let onCurve = !(flag >> 7);
        flag &= 0x7f;
        if (flag < 10) {
            dx = 0;
            dy = $333fb94547d9fb5c$var$withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
        } else if (flag < 20) {
            dx = $333fb94547d9fb5c$var$withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
            dy = 0;
        } else if (flag < 84) {
            var b0 = flag - 20;
            var b1 = glyphs.readUInt8();
            dx = $333fb94547d9fb5c$var$withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
            dy = $333fb94547d9fb5c$var$withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
        } else if (flag < 120) {
            var b0 = flag - 84;
            dx = $333fb94547d9fb5c$var$withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
            dy = $333fb94547d9fb5c$var$withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
        } else if (flag < 124) {
            var b1 = glyphs.readUInt8();
            let b2 = glyphs.readUInt8();
            dx = $333fb94547d9fb5c$var$withSign(flag, (b1 << 4) + (b2 >> 4));
            dy = $333fb94547d9fb5c$var$withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
        } else {
            dx = $333fb94547d9fb5c$var$withSign(flag, glyphs.readUInt16BE());
            dy = $333fb94547d9fb5c$var$withSign(flag >> 1, glyphs.readUInt16BE());
        }
        x += dx;
        y += dy;
        res.push(new $f680320fa07ef53d$export$baf26146a414f24a(onCurve, false, x, y));
    }
    return res;
}
let $e0b2de9958441c02$var$TTCHeader = new $gfJaN$restructure.VersionedStruct($gfJaN$restructure.uint32, {
    0x00010000: {
        numFonts: $gfJaN$restructure.uint32,
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, "numFonts")
    },
    0x00020000: {
        numFonts: $gfJaN$restructure.uint32,
        offsets: new $gfJaN$restructure.Array($gfJaN$restructure.uint32, "numFonts"),
        dsigTag: $gfJaN$restructure.uint32,
        dsigLength: $gfJaN$restructure.uint32,
        dsigOffset: $gfJaN$restructure.uint32
    }
});
class $e0b2de9958441c02$export$2e2bcd8739ae039 {
    static probe(buffer) {
        return $66a5b9fb5318558a$export$3d28c1996ced1f14.decode(buffer.slice(0, 4)) === "ttcf";
    }
    getFont(name) {
        for (let offset of this.header.offsets){
            let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer);
            stream.pos = offset;
            let font = new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream);
            if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i)=>name[i] === v)) return font;
        }
        return null;
    }
    get fonts() {
        let fonts = [];
        for (let offset of this.header.offsets){
            let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer);
            stream.pos = offset;
            fonts.push(new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream));
        }
        return fonts;
    }
    constructor(stream){
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "TTC");
        this.stream = stream;
        if (stream.readString(4) !== "ttcf") throw new Error("Not a TrueType collection");
        this.header = $e0b2de9958441c02$var$TTCHeader.decode(stream);
    }
}
let $d0fe640dc6c78783$var$DFontName = new $gfJaN$restructure.String($gfJaN$restructure.uint8);
let $d0fe640dc6c78783$var$DFontData = new $gfJaN$restructure.Struct({
    len: $gfJaN$restructure.uint32,
    buf: new $gfJaN$restructure.Buffer("len")
});
let $d0fe640dc6c78783$var$Ref = new $gfJaN$restructure.Struct({
    id: $gfJaN$restructure.uint16,
    nameOffset: $gfJaN$restructure.int16,
    attr: $gfJaN$restructure.uint8,
    dataOffset: $gfJaN$restructure.uint24,
    handle: $gfJaN$restructure.uint32
});
let $d0fe640dc6c78783$var$Type = new $gfJaN$restructure.Struct({
    name: new $gfJaN$restructure.String(4),
    maxTypeIndex: $gfJaN$restructure.uint16,
    refList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, new $gfJaN$restructure.Array($d0fe640dc6c78783$var$Ref, (t)=>t.maxTypeIndex + 1), {
        type: "parent"
    })
});
let $d0fe640dc6c78783$var$TypeList = new $gfJaN$restructure.Struct({
    length: $gfJaN$restructure.uint16,
    types: new $gfJaN$restructure.Array($d0fe640dc6c78783$var$Type, (t)=>t.length + 1)
});
let $d0fe640dc6c78783$var$DFontMap = new $gfJaN$restructure.Struct({
    reserved: new $gfJaN$restructure.Reserved($gfJaN$restructure.uint8, 24),
    typeList: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, $d0fe640dc6c78783$var$TypeList),
    nameListOffset: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint16, "void")
});
let $d0fe640dc6c78783$var$DFontHeader = new $gfJaN$restructure.Struct({
    dataOffset: $gfJaN$restructure.uint32,
    map: new $gfJaN$restructure.Pointer($gfJaN$restructure.uint32, $d0fe640dc6c78783$var$DFontMap),
    dataLength: $gfJaN$restructure.uint32,
    mapLength: $gfJaN$restructure.uint32
});
class $d0fe640dc6c78783$export$2e2bcd8739ae039 {
    static probe(buffer) {
        let stream = new $gfJaN$restructure.DecodeStream(buffer);
        try {
            var header = $d0fe640dc6c78783$var$DFontHeader.decode(stream);
        } catch (e) {
            return false;
        }
        for (let type of header.map.typeList.types){
            if (type.name === "sfnt") return true;
        }
        return false;
    }
    getFont(name) {
        if (!this.sfnt) return null;
        for (let ref of this.sfnt.refList){
            let pos = this.header.dataOffset + ref.dataOffset + 4;
            let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer.slice(pos));
            let font = new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream);
            if (font.postscriptName === name || font.postscriptName instanceof Uint8Array && name instanceof Uint8Array && font.postscriptName.every((v, i)=>name[i] === v)) return font;
        }
        return null;
    }
    get fonts() {
        let fonts = [];
        for (let ref of this.sfnt.refList){
            let pos = this.header.dataOffset + ref.dataOffset + 4;
            let stream = new $gfJaN$restructure.DecodeStream(this.stream.buffer.slice(pos));
            fonts.push(new $0a8ef2660a6ce4b6$export$2e2bcd8739ae039(stream));
        }
        return fonts;
    }
    constructor(stream){
        $parcel$interopDefault($gfJaN$swchelperslib_define_propertyjs)(this, "type", "DFont");
        this.stream = stream;
        this.header = $d0fe640dc6c78783$var$DFontHeader.decode(this.stream);
        for (let type of this.header.map.typeList.types){
            for (let ref of type.refList)if (ref.nameOffset >= 0) {
                this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                ref.name = $d0fe640dc6c78783$var$DFontName.decode(this.stream);
            } else ref.name = null;
            if (type.name === "sfnt") this.sfnt = type;
        }
    }
}
$59aa4ed98453e1d4$export$36b2f24e97d43be($0a8ef2660a6ce4b6$export$2e2bcd8739ae039);
$59aa4ed98453e1d4$export$36b2f24e97d43be($8a0a49baaf5d834d$export$2e2bcd8739ae039);
$59aa4ed98453e1d4$export$36b2f24e97d43be($333fb94547d9fb5c$export$2e2bcd8739ae039);
$59aa4ed98453e1d4$export$36b2f24e97d43be($e0b2de9958441c02$export$2e2bcd8739ae039);
$59aa4ed98453e1d4$export$36b2f24e97d43be($d0fe640dc6c78783$export$2e2bcd8739ae039);
$parcel$exportWildcard(module.exports, $59aa4ed98453e1d4$exports); //# sourceMappingURL=browser.cjs.map

},{"f21b476b3755c378":"bA1ZV","ff6728da855c7440":"3JFGs","6aa66445f242ca61":"7rOq9","512c7b618d747e29":"5BMuz","4c80a4567e3a20c2":"cF1iU","5389545d6ddd3821":"jRHH2","bffd1a7b85ce30bb":"2xeOx","b4fd531a03fcb1a9":"6bxBg","998fb3c74b159a7f":"762Rs","6035591d530ded93":"iCGF7"}],"bA1ZV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EncodeStream", ()=>(0, _encodeStreamJs.EncodeStream));
parcelHelpers.export(exports, "DecodeStream", ()=>(0, _decodeStreamJs.DecodeStream));
parcelHelpers.export(exports, "Array", ()=>(0, _arrayJs.Array));
parcelHelpers.export(exports, "LazyArray", ()=>(0, _lazyArrayJs.LazyArray));
parcelHelpers.export(exports, "Bitfield", ()=>(0, _bitfieldJs.Bitfield));
parcelHelpers.export(exports, "Boolean", ()=>(0, _booleanJs.Boolean));
parcelHelpers.export(exports, "Buffer", ()=>(0, _bufferJs.Buffer));
parcelHelpers.export(exports, "Enum", ()=>(0, _enumJs.Enum));
parcelHelpers.export(exports, "Optional", ()=>(0, _optionalJs.Optional));
parcelHelpers.export(exports, "Reserved", ()=>(0, _reservedJs.Reserved));
parcelHelpers.export(exports, "String", ()=>(0, _stringJs.String));
parcelHelpers.export(exports, "Struct", ()=>(0, _structJs.Struct));
parcelHelpers.export(exports, "VersionedStruct", ()=>(0, _versionedStructJs.VersionedStruct));
var _encodeStreamJs = require("./src/EncodeStream.js");
var _decodeStreamJs = require("./src/DecodeStream.js");
var _arrayJs = require("./src/Array.js");
var _lazyArrayJs = require("./src/LazyArray.js");
var _bitfieldJs = require("./src/Bitfield.js");
var _booleanJs = require("./src/Boolean.js");
var _bufferJs = require("./src/Buffer.js");
var _enumJs = require("./src/Enum.js");
var _optionalJs = require("./src/Optional.js");
var _reservedJs = require("./src/Reserved.js");
var _stringJs = require("./src/String.js");
var _structJs = require("./src/Struct.js");
var _versionedStructJs = require("./src/VersionedStruct.js");
var _utilsJs = require("./src/utils.js");
parcelHelpers.exportAll(_utilsJs, exports);
var _numberJs = require("./src/Number.js");
parcelHelpers.exportAll(_numberJs, exports);
var _pointerJs = require("./src/Pointer.js");
parcelHelpers.exportAll(_pointerJs, exports);

},{"./src/EncodeStream.js":"gcNl6","./src/DecodeStream.js":"h0BbP","./src/Array.js":"86Ta3","./src/LazyArray.js":"eCTfk","./src/Bitfield.js":"cvdWr","./src/Boolean.js":"aiQsi","./src/Buffer.js":"gCuLf","./src/Enum.js":"hQalR","./src/Optional.js":"3F6fp","./src/Reserved.js":"lN1oK","./src/String.js":"iBHAm","./src/Struct.js":"8o0rp","./src/VersionedStruct.js":"iEsP5","./src/utils.js":"86AhX","./src/Number.js":"2E0Mf","./src/Pointer.js":"a5EnK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gcNl6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EncodeStream", ()=>EncodeStream);
var _decodeStreamJs = require("./DecodeStream.js");
const textEncoder = new TextEncoder();
const isBigEndian = new Uint8Array(new Uint16Array([
    0x1234
]).buffer)[0] == 0x12;
class EncodeStream {
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
        this.pos = 0;
    }
    writeBuffer(buffer) {
        this.buffer.set(buffer, this.pos);
        this.pos += buffer.length;
    }
    writeString(string, encoding = "ascii") {
        let buf;
        switch(encoding){
            case "utf16le":
            case "utf16-le":
            case "ucs2":
                buf = stringToUtf16(string, isBigEndian);
                break;
            case "utf16be":
            case "utf16-be":
                buf = stringToUtf16(string, !isBigEndian);
                break;
            case "utf8":
                buf = textEncoder.encode(string);
                break;
            case "ascii":
                buf = stringToAscii(string);
                break;
            default:
                throw new Error(`Unsupported encoding: ${encoding}`);
        }
        this.writeBuffer(buf);
    }
    writeUInt24BE(val) {
        this.buffer[this.pos++] = val >>> 16 & 0xff;
        this.buffer[this.pos++] = val >>> 8 & 0xff;
        this.buffer[this.pos++] = val & 0xff;
    }
    writeUInt24LE(val) {
        this.buffer[this.pos++] = val & 0xff;
        this.buffer[this.pos++] = val >>> 8 & 0xff;
        this.buffer[this.pos++] = val >>> 16 & 0xff;
    }
    writeInt24BE(val) {
        if (val >= 0) this.writeUInt24BE(val);
        else this.writeUInt24BE(val + 0xffffff + 1);
    }
    writeInt24LE(val) {
        if (val >= 0) this.writeUInt24LE(val);
        else this.writeUInt24LE(val + 0xffffff + 1);
    }
    fill(val, length) {
        if (length < this.buffer.length) {
            this.buffer.fill(val, this.pos, this.pos + length);
            this.pos += length;
        } else {
            const buf = new Uint8Array(length);
            buf.fill(val);
            this.writeBuffer(buf);
        }
    }
}
function stringToUtf16(string, swap) {
    let buf = new Uint16Array(string.length);
    for(let i = 0; i < string.length; i++){
        let code = string.charCodeAt(i);
        if (swap) code = code >> 8 | (code & 0xff) << 8;
        buf[i] = code;
    }
    return new Uint8Array(buf.buffer);
}
function stringToAscii(string) {
    let buf = new Uint8Array(string.length);
    for(let i = 0; i < string.length; i++)// Match node.js behavior - encoding allows 8-bit rather than 7-bit.
    buf[i] = string.charCodeAt(i);
    return buf;
}
for (let key of Object.getOwnPropertyNames(DataView.prototype))if (key.slice(0, 3) === "set") {
    let type = key.slice(3).replace("Ui", "UI");
    if (type === "Float32") type = "Float";
    else if (type === "Float64") type = "Double";
    let bytes = (0, _decodeStreamJs.DecodeStream).TYPES[type];
    EncodeStream.prototype["write" + type + (bytes === 1 ? "" : "BE")] = function(value) {
        this.view[key](this.pos, value, false);
        this.pos += bytes;
    };
    if (bytes !== 1) EncodeStream.prototype["write" + type + "LE"] = function(value) {
        this.view[key](this.pos, value, true);
        this.pos += bytes;
    };
}

},{"./DecodeStream.js":"h0BbP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h0BbP":[function(require,module,exports) {
// Node back-compat.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DecodeStream", ()=>DecodeStream);
const ENCODING_MAPPING = {
    utf16le: "utf-16le",
    ucs2: "utf-16le",
    utf16be: "utf-16be"
};
class DecodeStream {
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
        this.pos = 0;
        this.length = this.buffer.length;
    }
    readString(length, encoding = "ascii") {
        encoding = ENCODING_MAPPING[encoding] || encoding;
        let buf = this.readBuffer(length);
        try {
            let decoder = new TextDecoder(encoding);
            return decoder.decode(buf);
        } catch (err) {
            return buf;
        }
    }
    readBuffer(length) {
        return this.buffer.slice(this.pos, this.pos += length);
    }
    readUInt24BE() {
        return (this.readUInt16BE() << 8) + this.readUInt8();
    }
    readUInt24LE() {
        return this.readUInt16LE() + (this.readUInt8() << 16);
    }
    readInt24BE() {
        return (this.readInt16BE() << 8) + this.readUInt8();
    }
    readInt24LE() {
        return this.readUInt16LE() + (this.readInt8() << 16);
    }
}
DecodeStream.TYPES = {
    UInt8: 1,
    UInt16: 2,
    UInt24: 3,
    UInt32: 4,
    Int8: 1,
    Int16: 2,
    Int24: 3,
    Int32: 4,
    Float: 4,
    Double: 8
};
for (let key of Object.getOwnPropertyNames(DataView.prototype))if (key.slice(0, 3) === "get") {
    let type = key.slice(3).replace("Ui", "UI");
    if (type === "Float32") type = "Float";
    else if (type === "Float64") type = "Double";
    let bytes = DecodeStream.TYPES[type];
    DecodeStream.prototype["read" + type + (bytes === 1 ? "" : "BE")] = function() {
        const ret = this.view[key](this.pos, false);
        this.pos += bytes;
        return ret;
    };
    if (bytes !== 1) DecodeStream.prototype["read" + type + "LE"] = function() {
        const ret = this.view[key](this.pos, true);
        this.pos += bytes;
        return ret;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"86Ta3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Array", ()=>ArrayT);
var _baseJs = require("./Base.js");
var _numberJs = require("./Number.js");
var _utilsJs = require("./utils.js");
class ArrayT extends (0, _baseJs.Base) {
    constructor(type, length, lengthType = "count"){
        super();
        this.type = type;
        this.length = length;
        this.lengthType = lengthType;
    }
    decode(stream, parent) {
        let length;
        const { pos } = stream;
        const res = [];
        let ctx = parent;
        if (this.length != null) length = _utilsJs.resolveLength(this.length, stream, parent);
        if (this.length instanceof (0, _numberJs.Number)) {
            // define hidden properties
            Object.defineProperties(res, {
                parent: {
                    value: parent
                },
                _startOffset: {
                    value: pos
                },
                _currentOffset: {
                    value: 0,
                    writable: true
                },
                _length: {
                    value: length
                }
            });
            ctx = res;
        }
        if (length == null || this.lengthType === "bytes") {
            const target = length != null ? stream.pos + length : (parent != null ? parent._length : undefined) ? parent._startOffset + parent._length : stream.length;
            while(stream.pos < target)res.push(this.type.decode(stream, ctx));
        } else for(let i = 0, end = length; i < end; i++)res.push(this.type.decode(stream, ctx));
        return res;
    }
    size(array, ctx, includePointers = true) {
        if (!array) return this.type.size(null, ctx) * _utilsJs.resolveLength(this.length, null, ctx);
        let size = 0;
        if (this.length instanceof (0, _numberJs.Number)) {
            size += this.length.size();
            ctx = {
                parent: ctx,
                pointerSize: 0
            };
        }
        for (let item of array)size += this.type.size(item, ctx);
        if (ctx && includePointers && this.length instanceof (0, _numberJs.Number)) size += ctx.pointerSize;
        return size;
    }
    encode(stream, array, parent) {
        let ctx = parent;
        if (this.length instanceof (0, _numberJs.Number)) {
            ctx = {
                pointers: [],
                startOffset: stream.pos,
                parent
            };
            ctx.pointerOffset = stream.pos + this.size(array, ctx, false);
            this.length.encode(stream, array.length);
        }
        for (let item of array)this.type.encode(stream, item, ctx);
        if (this.length instanceof (0, _numberJs.Number)) {
            let i = 0;
            while(i < ctx.pointers.length){
                const ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val, ptr.parent);
            }
        }
    }
}

},{"./Base.js":"h0wd8","./Number.js":"2E0Mf","./utils.js":"86AhX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h0wd8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Base", ()=>Base);
var _decodeStreamJs = require("./DecodeStream.js");
var _encodeStreamJs = require("./EncodeStream.js");
class Base {
    fromBuffer(buffer) {
        let stream = new (0, _decodeStreamJs.DecodeStream)(buffer);
        return this.decode(stream);
    }
    toBuffer(value) {
        let size = this.size(value);
        let buffer = new Uint8Array(size);
        let stream = new (0, _encodeStreamJs.EncodeStream)(buffer);
        this.encode(stream, value);
        return buffer;
    }
}

},{"./DecodeStream.js":"h0BbP","./EncodeStream.js":"gcNl6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2E0Mf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Number", ()=>NumberT);
parcelHelpers.export(exports, "uint8", ()=>uint8);
parcelHelpers.export(exports, "uint16be", ()=>uint16be);
parcelHelpers.export(exports, "uint16", ()=>uint16);
parcelHelpers.export(exports, "uint16le", ()=>uint16le);
parcelHelpers.export(exports, "uint24be", ()=>uint24be);
parcelHelpers.export(exports, "uint24", ()=>uint24);
parcelHelpers.export(exports, "uint24le", ()=>uint24le);
parcelHelpers.export(exports, "uint32be", ()=>uint32be);
parcelHelpers.export(exports, "uint32", ()=>uint32);
parcelHelpers.export(exports, "uint32le", ()=>uint32le);
parcelHelpers.export(exports, "int8", ()=>int8);
parcelHelpers.export(exports, "int16be", ()=>int16be);
parcelHelpers.export(exports, "int16", ()=>int16);
parcelHelpers.export(exports, "int16le", ()=>int16le);
parcelHelpers.export(exports, "int24be", ()=>int24be);
parcelHelpers.export(exports, "int24", ()=>int24);
parcelHelpers.export(exports, "int24le", ()=>int24le);
parcelHelpers.export(exports, "int32be", ()=>int32be);
parcelHelpers.export(exports, "int32", ()=>int32);
parcelHelpers.export(exports, "int32le", ()=>int32le);
parcelHelpers.export(exports, "floatbe", ()=>floatbe);
parcelHelpers.export(exports, "float", ()=>float);
parcelHelpers.export(exports, "floatle", ()=>floatle);
parcelHelpers.export(exports, "doublebe", ()=>doublebe);
parcelHelpers.export(exports, "double", ()=>double);
parcelHelpers.export(exports, "doublele", ()=>doublele);
parcelHelpers.export(exports, "Fixed", ()=>Fixed);
parcelHelpers.export(exports, "fixed16be", ()=>fixed16be);
parcelHelpers.export(exports, "fixed16", ()=>fixed16);
parcelHelpers.export(exports, "fixed16le", ()=>fixed16le);
parcelHelpers.export(exports, "fixed32be", ()=>fixed32be);
parcelHelpers.export(exports, "fixed32", ()=>fixed32);
parcelHelpers.export(exports, "fixed32le", ()=>fixed32le);
var _decodeStreamJs = require("./DecodeStream.js");
var _baseJs = require("./Base.js");
class NumberT extends (0, _baseJs.Base) {
    constructor(type, endian = "BE"){
        super();
        this.type = type;
        this.endian = endian;
        this.fn = this.type;
        if (this.type[this.type.length - 1] !== "8") this.fn += this.endian;
    }
    size() {
        return (0, _decodeStreamJs.DecodeStream).TYPES[this.type];
    }
    decode(stream) {
        return stream[`read${this.fn}`]();
    }
    encode(stream, val) {
        return stream[`write${this.fn}`](val);
    }
}
const uint8 = new NumberT("UInt8");
const uint16be = new NumberT("UInt16", "BE");
const uint16 = uint16be;
const uint16le = new NumberT("UInt16", "LE");
const uint24be = new NumberT("UInt24", "BE");
const uint24 = uint24be;
const uint24le = new NumberT("UInt24", "LE");
const uint32be = new NumberT("UInt32", "BE");
const uint32 = uint32be;
const uint32le = new NumberT("UInt32", "LE");
const int8 = new NumberT("Int8");
const int16be = new NumberT("Int16", "BE");
const int16 = int16be;
const int16le = new NumberT("Int16", "LE");
const int24be = new NumberT("Int24", "BE");
const int24 = int24be;
const int24le = new NumberT("Int24", "LE");
const int32be = new NumberT("Int32", "BE");
const int32 = int32be;
const int32le = new NumberT("Int32", "LE");
const floatbe = new NumberT("Float", "BE");
const float = floatbe;
const floatle = new NumberT("Float", "LE");
const doublebe = new NumberT("Double", "BE");
const double = doublebe;
const doublele = new NumberT("Double", "LE");
class Fixed extends NumberT {
    constructor(size, endian, fracBits = size >> 1){
        super(`Int${size}`, endian);
        this._point = 1 << fracBits;
    }
    decode(stream) {
        return super.decode(stream) / this._point;
    }
    encode(stream, val) {
        return super.encode(stream, val * this._point | 0);
    }
}
const fixed16be = new Fixed(16, "BE");
const fixed16 = fixed16be;
const fixed16le = new Fixed(16, "LE");
const fixed32be = new Fixed(32, "BE");
const fixed32 = fixed32be;
const fixed32le = new Fixed(32, "LE");

},{"./DecodeStream.js":"h0BbP","./Base.js":"h0wd8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"86AhX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveLength", ()=>resolveLength);
parcelHelpers.export(exports, "PropertyDescriptor", ()=>PropertyDescriptor);
var _numberJs = require("./Number.js");
function resolveLength(length, stream, parent) {
    let res;
    if (typeof length === "number") res = length;
    else if (typeof length === "function") res = length.call(parent, parent);
    else if (parent && typeof length === "string") res = parent[length];
    else if (stream && length instanceof (0, _numberJs.Number)) res = length.decode(stream);
    if (isNaN(res)) throw new Error("Not a fixed size");
    return res;
}
class PropertyDescriptor {
    constructor(opts = {}){
        this.enumerable = true;
        this.configurable = true;
        for(let key in opts){
            const val = opts[key];
            this[key] = val;
        }
    }
}

},{"./Number.js":"2E0Mf","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eCTfk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LazyArray", ()=>LazyArray);
var _arrayJs = require("./Array.js");
var _numberJs = require("./Number.js");
var _utilsJs = require("./utils.js");
class LazyArray extends (0, _arrayJs.Array) {
    decode(stream, parent) {
        const { pos } = stream;
        const length = _utilsJs.resolveLength(this.length, stream, parent);
        if (this.length instanceof (0, _numberJs.Number)) parent = {
            parent,
            _startOffset: pos,
            _currentOffset: 0,
            _length: length
        };
        const res = new LazyArrayValue(this.type, length, stream, parent);
        stream.pos += length * this.type.size(null, parent);
        return res;
    }
    size(val, ctx) {
        if (val instanceof LazyArrayValue) val = val.toArray();
        return super.size(val, ctx);
    }
    encode(stream, val, ctx) {
        if (val instanceof LazyArrayValue) val = val.toArray();
        return super.encode(stream, val, ctx);
    }
}
class LazyArrayValue {
    constructor(type, length, stream, ctx){
        this.type = type;
        this.length = length;
        this.stream = stream;
        this.ctx = ctx;
        this.base = this.stream.pos;
        this.items = [];
    }
    get(index) {
        if (index < 0 || index >= this.length) return undefined;
        if (this.items[index] == null) {
            const { pos } = this.stream;
            this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
            this.items[index] = this.type.decode(this.stream, this.ctx);
            this.stream.pos = pos;
        }
        return this.items[index];
    }
    toArray() {
        const result = [];
        for(let i = 0, end = this.length; i < end; i++)result.push(this.get(i));
        return result;
    }
}

},{"./Array.js":"86Ta3","./Number.js":"2E0Mf","./utils.js":"86AhX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cvdWr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bitfield", ()=>Bitfield);
var _baseJs = require("./Base.js");
class Bitfield extends (0, _baseJs.Base) {
    constructor(type, flags = []){
        super();
        this.type = type;
        this.flags = flags;
    }
    decode(stream) {
        const val = this.type.decode(stream);
        const res = {};
        for(let i = 0; i < this.flags.length; i++){
            const flag = this.flags[i];
            if (flag != null) res[flag] = !!(val & 1 << i);
        }
        return res;
    }
    size() {
        return this.type.size();
    }
    encode(stream, keys) {
        let val = 0;
        for(let i = 0; i < this.flags.length; i++){
            const flag = this.flags[i];
            if (flag != null) {
                if (keys[flag]) val |= 1 << i;
            }
        }
        return this.type.encode(stream, val);
    }
}

},{"./Base.js":"h0wd8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aiQsi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BooleanT", ()=>BooleanT);
parcelHelpers.export(exports, "Boolean", ()=>BooleanT);
var _baseJs = require("./Base.js");
class BooleanT extends (0, _baseJs.Base) {
    constructor(type){
        super();
        this.type = type;
    }
    decode(stream, parent) {
        return !!this.type.decode(stream, parent);
    }
    size(val, parent) {
        return this.type.size(val, parent);
    }
    encode(stream, val, parent) {
        return this.type.encode(stream, +val, parent);
    }
}

},{"./Base.js":"h0wd8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gCuLf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BufferT", ()=>BufferT);
parcelHelpers.export(exports, "Buffer", ()=>BufferT);
var _baseJs = require("./Base.js");
var _numberJs = require("./Number.js");
var _utilsJs = require("./utils.js");
class BufferT extends (0, _baseJs.Base) {
    constructor(length){
        super();
        this.length = length;
    }
    decode(stream, parent) {
        const length = _utilsJs.resolveLength(this.length, stream, parent);
        return stream.readBuffer(length);
    }
    size(val, parent) {
        if (!val) return _utilsJs.resolveLength(this.length, null, parent);
        let len = val.length;
        if (this.length instanceof (0, _numberJs.Number)) len += this.length.size();
        return len;
    }
    encode(stream, buf, parent) {
        if (this.length instanceof (0, _numberJs.Number)) this.length.encode(stream, buf.length);
        return stream.writeBuffer(buf);
    }
}

},{"./Base.js":"h0wd8","./Number.js":"2E0Mf","./utils.js":"86AhX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hQalR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Enum", ()=>Enum);
var _baseJs = require("./Base.js");
class Enum extends (0, _baseJs.Base) {
    constructor(type, options = []){
        super();
        this.type = type;
        this.options = options;
    }
    decode(stream) {
        const index = this.type.decode(stream);
        return this.options[index] || index;
    }
    size() {
        return this.type.size();
    }
    encode(stream, val) {
        const index = this.options.indexOf(val);
        if (index === -1) throw new Error(`Unknown option in enum: ${val}`);
        return this.type.encode(stream, index);
    }
}

},{"./Base.js":"h0wd8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3F6fp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Optional", ()=>Optional);
var _baseJs = require("./Base.js");
class Optional extends (0, _baseJs.Base) {
    constructor(type, condition = true){
        super();
        this.type = type;
        this.condition = condition;
    }
    decode(stream, parent) {
        let { condition } = this;
        if (typeof condition === "function") condition = condition.call(parent, parent);
        if (condition) return this.type.decode(stream, parent);
    }
    size(val, parent) {
        let { condition } = this;
        if (typeof condition === "function") condition = condition.call(parent, parent);
        if (condition) return this.type.size(val, parent);
        else return 0;
    }
    encode(stream, val, parent) {
        let { condition } = this;
        if (typeof condition === "function") condition = condition.call(parent, parent);
        if (condition) return this.type.encode(stream, val, parent);
    }
}

},{"./Base.js":"h0wd8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lN1oK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reserved", ()=>Reserved);
var _baseJs = require("./Base.js");
var _utilsJs = require("./utils.js");
class Reserved extends (0, _baseJs.Base) {
    constructor(type, count = 1){
        super();
        this.type = type;
        this.count = count;
    }
    decode(stream, parent) {
        stream.pos += this.size(null, parent);
        return undefined;
    }
    size(data, parent) {
        const count = _utilsJs.resolveLength(this.count, null, parent);
        return this.type.size() * count;
    }
    encode(stream, val, parent) {
        return stream.fill(0, this.size(val, parent));
    }
}

},{"./Base.js":"h0wd8","./utils.js":"86AhX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iBHAm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "String", ()=>StringT);
var _baseJs = require("./Base.js");
var _numberJs = require("./Number.js");
var _utilsJs = require("./utils.js");
class StringT extends (0, _baseJs.Base) {
    constructor(length, encoding = "ascii"){
        super();
        this.length = length;
        this.encoding = encoding;
    }
    decode(stream, parent) {
        let length, pos;
        if (this.length != null) length = _utilsJs.resolveLength(this.length, stream, parent);
        else {
            let buffer;
            ({ buffer, length, pos } = stream);
            while(pos < length && buffer[pos] !== 0x00)++pos;
            length = pos - stream.pos;
        }
        let { encoding } = this;
        if (typeof encoding === "function") encoding = encoding.call(parent, parent) || "ascii";
        const string = stream.readString(length, encoding);
        if (this.length == null && stream.pos < stream.length) stream.pos++;
        return string;
    }
    size(val, parent) {
        // Use the defined value if no value was given
        if (!val) return _utilsJs.resolveLength(this.length, null, parent);
        let { encoding } = this;
        if (typeof encoding === "function") encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || "ascii";
        if (encoding === "utf16be") encoding = "utf16le";
        let size = byteLength(val, encoding);
        if (this.length instanceof (0, _numberJs.Number)) size += this.length.size();
        if (this.length == null) size++;
        return size;
    }
    encode(stream, val, parent) {
        let { encoding } = this;
        if (typeof encoding === "function") encoding = encoding.call(parent != null ? parent.val : undefined, parent != null ? parent.val : undefined) || "ascii";
        if (this.length instanceof (0, _numberJs.Number)) this.length.encode(stream, byteLength(val, encoding));
        stream.writeString(val, encoding);
        if (this.length == null) return stream.writeUInt8(0x00);
    }
}
function byteLength(string, encoding) {
    switch(encoding){
        case "ascii":
            return string.length;
        case "utf8":
            let len = 0;
            for(let i = 0; i < string.length; i++){
                let c = string.charCodeAt(i);
                if (c >= 0xd800 && c <= 0xdbff && i < string.length - 1) {
                    let c2 = string.charCodeAt(++i);
                    if ((c2 & 0xfc00) === 0xdc00) c = ((c & 0x3ff) << 10) + (c2 & 0x3ff) + 0x10000;
                    else // unmatched surrogate.
                    i--;
                }
                if ((c & 0xffffff80) === 0) len++;
                else if ((c & 0xfffff800) === 0) len += 2;
                else if ((c & 0xffff0000) === 0) len += 3;
                else if ((c & 0xffe00000) === 0) len += 4;
            }
            return len;
        case "utf16le":
        case "utf16-le":
        case "utf16be":
        case "utf16-be":
        case "ucs2":
            return string.length * 2;
        default:
            throw new Error("Unknown encoding " + encoding);
    }
}

},{"./Base.js":"h0wd8","./Number.js":"2E0Mf","./utils.js":"86AhX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8o0rp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Struct", ()=>Struct);
var _baseJs = require("./Base.js");
var _utilsJs = require("./utils.js");
class Struct extends (0, _baseJs.Base) {
    constructor(fields = {}){
        super();
        this.fields = fields;
    }
    decode(stream, parent, length = 0) {
        const res = this._setup(stream, parent, length);
        this._parseFields(stream, res, this.fields);
        if (this.process != null) this.process.call(res, stream);
        return res;
    }
    _setup(stream, parent, length) {
        const res = {};
        // define hidden properties
        Object.defineProperties(res, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            },
            _currentOffset: {
                value: 0,
                writable: true
            },
            _length: {
                value: length
            }
        });
        return res;
    }
    _parseFields(stream, res, fields) {
        for(let key in fields){
            var val;
            const type = fields[key];
            if (typeof type === "function") val = type.call(res, res);
            else val = type.decode(stream, res);
            if (val !== undefined) {
                if (val instanceof _utilsJs.PropertyDescriptor) Object.defineProperty(res, key, val);
                else res[key] = val;
            }
            res._currentOffset = stream.pos - res._startOffset;
        }
    }
    size(val, parent, includePointers = true) {
        if (val == null) val = {};
        const ctx = {
            parent,
            val,
            pointerSize: 0
        };
        if (this.preEncode != null) this.preEncode.call(val);
        let size = 0;
        for(let key in this.fields){
            const type = this.fields[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        if (includePointers) size += ctx.pointerSize;
        return size;
    }
    encode(stream, val, parent) {
        let type;
        if (this.preEncode != null) this.preEncode.call(val, stream);
        const ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent,
            val,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
        for(let key in this.fields){
            type = this.fields[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            const ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
    }
}

},{"./Base.js":"h0wd8","./utils.js":"86AhX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iEsP5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VersionedStruct", ()=>VersionedStruct);
var _structJs = require("./Struct.js");
const getPath = (object, pathArray)=>{
    return pathArray.reduce((prevObj, key)=>prevObj && prevObj[key], object);
};
class VersionedStruct extends (0, _structJs.Struct) {
    constructor(type, versions = {}){
        super();
        this.type = type;
        this.versions = versions;
        if (typeof type === "string") this.versionPath = type.split(".");
    }
    decode(stream, parent, length = 0) {
        const res = this._setup(stream, parent, length);
        if (typeof this.type === "string") res.version = getPath(parent, this.versionPath);
        else res.version = this.type.decode(stream);
        if (this.versions.header) this._parseFields(stream, res, this.versions.header);
        const fields = this.versions[res.version];
        if (fields == null) throw new Error(`Unknown version ${res.version}`);
        if (fields instanceof VersionedStruct) return fields.decode(stream, parent);
        this._parseFields(stream, res, fields);
        if (this.process != null) this.process.call(res, stream);
        return res;
    }
    size(val, parent, includePointers = true) {
        let key, type;
        if (!val) throw new Error("Not a fixed size");
        if (this.preEncode != null) this.preEncode.call(val);
        const ctx = {
            parent,
            val,
            pointerSize: 0
        };
        let size = 0;
        if (typeof this.type !== "string") size += this.type.size(val.version, ctx);
        if (this.versions.header) for(key in this.versions.header){
            type = this.versions.header[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        const fields = this.versions[val.version];
        if (fields == null) throw new Error(`Unknown version ${val.version}`);
        for(key in fields){
            type = fields[key];
            if (type.size != null) size += type.size(val[key], ctx);
        }
        if (includePointers) size += ctx.pointerSize;
        return size;
    }
    encode(stream, val, parent) {
        let key, type;
        if (this.preEncode != null) this.preEncode.call(val, stream);
        const ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent,
            val,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
        if (typeof this.type !== "string") this.type.encode(stream, val.version);
        if (this.versions.header) for(key in this.versions.header){
            type = this.versions.header[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        const fields = this.versions[val.version];
        for(key in fields){
            type = fields[key];
            if (type.encode != null) type.encode(stream, val[key], ctx);
        }
        let i = 0;
        while(i < ctx.pointers.length){
            const ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
    }
}

},{"./Struct.js":"8o0rp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a5EnK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pointer", ()=>Pointer);
// A pointer whose type is determined at decode time
parcelHelpers.export(exports, "VoidPointer", ()=>VoidPointer);
var _utilsJs = require("./utils.js");
var _baseJs = require("./Base.js");
class Pointer extends (0, _baseJs.Base) {
    constructor(offsetType, type, options = {}){
        super();
        this.offsetType = offsetType;
        this.type = type;
        this.options = options;
        if (this.type === "void") this.type = null;
        if (this.options.type == null) this.options.type = "local";
        if (this.options.allowNull == null) this.options.allowNull = true;
        if (this.options.nullValue == null) this.options.nullValue = 0;
        if (this.options.lazy == null) this.options.lazy = false;
        if (this.options.relativeTo) {
            if (typeof this.options.relativeTo !== "function") throw new Error("relativeTo option must be a function");
            this.relativeToGetter = options.relativeTo;
        }
    }
    decode(stream, ctx) {
        const offset = this.offsetType.decode(stream, ctx);
        // handle NULL pointers
        if (offset === this.options.nullValue && this.options.allowNull) return null;
        let relative;
        switch(this.options.type){
            case "local":
                relative = ctx._startOffset;
                break;
            case "immediate":
                relative = stream.pos - this.offsetType.size();
                break;
            case "parent":
                relative = ctx.parent._startOffset;
                break;
            default:
                var c = ctx;
                while(c.parent)c = c.parent;
                relative = c._startOffset || 0;
        }
        if (this.options.relativeTo) relative += this.relativeToGetter(ctx);
        const ptr = offset + relative;
        if (this.type != null) {
            let val = null;
            const decodeValue = ()=>{
                if (val != null) return val;
                const { pos } = stream;
                stream.pos = ptr;
                val = this.type.decode(stream, ctx);
                stream.pos = pos;
                return val;
            };
            // If this is a lazy pointer, define a getter to decode only when needed.
            // This obviously only works when the pointer is contained by a Struct.
            if (this.options.lazy) return new _utilsJs.PropertyDescriptor({
                get: decodeValue
            });
            return decodeValue();
        } else return ptr;
    }
    size(val, ctx) {
        const parent = ctx;
        switch(this.options.type){
            case "local":
            case "immediate":
                break;
            case "parent":
                ctx = ctx.parent;
                break;
            default:
                while(ctx.parent)ctx = ctx.parent;
        }
        let { type } = this;
        if (type == null) {
            if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
            ({ type } = val);
            val = val.value;
        }
        if (val && ctx) {
            // Must be written as two separate lines rather than += in case `type.size` mutates ctx.pointerSize.
            let size = type.size(val, parent);
            ctx.pointerSize += size;
        }
        return this.offsetType.size();
    }
    encode(stream, val, ctx) {
        let relative;
        const parent = ctx;
        if (val == null) {
            this.offsetType.encode(stream, this.options.nullValue);
            return;
        }
        switch(this.options.type){
            case "local":
                relative = ctx.startOffset;
                break;
            case "immediate":
                relative = stream.pos + this.offsetType.size(val, parent);
                break;
            case "parent":
                ctx = ctx.parent;
                relative = ctx.startOffset;
                break;
            default:
                relative = 0;
                while(ctx.parent)ctx = ctx.parent;
        }
        if (this.options.relativeTo) relative += this.relativeToGetter(parent.val);
        this.offsetType.encode(stream, ctx.pointerOffset - relative);
        let { type } = this;
        if (type == null) {
            if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
            ({ type } = val);
            val = val.value;
        }
        ctx.pointers.push({
            type,
            val,
            parent
        });
        return ctx.pointerOffset += type.size(val, parent);
    }
}
class VoidPointer {
    constructor(type, value){
        this.type = type;
        this.value = value;
    }
}

},{"./utils.js":"86AhX","./Base.js":"h0wd8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3JFGs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _defineProperty;
    }
});
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{}],"7rOq9":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _tslib["__decorate"];
    }
});
var _tslib = require("59acce9d92affc78");

},{"59acce9d92affc78":"5g31W"}],"5g31W":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5BMuz":[function(require,module,exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"cF1iU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCategory", ()=>$747425b437e121da$export$410364bbb673ddbc);
parcelHelpers.export(exports, "getCombiningClass", ()=>$747425b437e121da$export$c03b919c6651ed55);
parcelHelpers.export(exports, "getScript", ()=>$747425b437e121da$export$941569448d136665);
parcelHelpers.export(exports, "getEastAsianWidth", ()=>$747425b437e121da$export$92f6187db8ca6d26);
parcelHelpers.export(exports, "getNumericValue", ()=>$747425b437e121da$export$7d1258ebb7625a0d);
parcelHelpers.export(exports, "isAlphabetic", ()=>$747425b437e121da$export$52c8ea63abd07594);
parcelHelpers.export(exports, "isDigit", ()=>$747425b437e121da$export$727d9dbc4fbb948f);
parcelHelpers.export(exports, "isPunctuation", ()=>$747425b437e121da$export$a5b49f4dc6a07d2c);
parcelHelpers.export(exports, "isLowerCase", ()=>$747425b437e121da$export$7b6804e8df61fcf5);
parcelHelpers.export(exports, "isUpperCase", ()=>$747425b437e121da$export$aebd617640818cda);
parcelHelpers.export(exports, "isTitleCase", ()=>$747425b437e121da$export$de8b4ee23b2cf823);
parcelHelpers.export(exports, "isWhiteSpace", ()=>$747425b437e121da$export$3c52dd84024ae72c);
parcelHelpers.export(exports, "isBaseForm", ()=>$747425b437e121da$export$a11bdcffe109e74b);
parcelHelpers.export(exports, "isMark", ()=>$747425b437e121da$export$e33ad6871e762338);
parcelHelpers.export(exports, "default", ()=>$747425b437e121da$export$2e2bcd8739ae039);
var _base64Js = require("base64-js");
var _base64JsDefault = parcelHelpers.interopDefault(_base64Js);
var _unicodeTrie = require("unicode-trie");
var _unicodeTrieDefault = parcelHelpers.interopDefault(_unicodeTrie);
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $f4087201da764553$exports = {};
$f4087201da764553$exports = JSON.parse('{"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Osage","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Hanifi_Rohingya","Old_Sogdian","Sogdian","Elymaic","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Newa","Tirhuta","Siddham","Modi","Takri","Ahom","Dogra","Warang_Citi","Nandinagari","Zanabazar_Square","Soyombo","Pau_Cin_Hau","Bhaiksuki","Marchen","Masaram_Gondi","Gunjala_Gondi","Makasar","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Medefaidrin","Miao","Tangut","Nushu","Duployan","SignWriting","Nyiakeng_Puachue_Hmong","Wancho","Mende_Kikakui","Adlam"],"eaw":["N","Na","A","W","H","F"]}');
const $747425b437e121da$var$trie = new (0, _unicodeTrieDefault.default)((0, _base64JsDefault.default).toByteArray("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"));
const $747425b437e121da$var$log2 = Math.log2 || ((n)=>Math.log(n) / Math.LN2);
const $747425b437e121da$var$bits = (n)=>$747425b437e121da$var$log2(n) + 1 | 0;
// compute the number of bits stored for each field
const $747425b437e121da$var$CATEGORY_BITS = $747425b437e121da$var$bits(/*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).categories.length - 1);
const $747425b437e121da$var$COMBINING_BITS = $747425b437e121da$var$bits(/*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).combiningClasses.length - 1);
const $747425b437e121da$var$SCRIPT_BITS = $747425b437e121da$var$bits(/*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).scripts.length - 1);
const $747425b437e121da$var$EAW_BITS = $747425b437e121da$var$bits(/*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).eaw.length - 1);
const $747425b437e121da$var$NUMBER_BITS = 10;
// compute shift and mask values for each field
const $747425b437e121da$var$CATEGORY_SHIFT = $747425b437e121da$var$COMBINING_BITS + $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS;
const $747425b437e121da$var$COMBINING_SHIFT = $747425b437e121da$var$SCRIPT_BITS + $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS;
const $747425b437e121da$var$SCRIPT_SHIFT = $747425b437e121da$var$EAW_BITS + $747425b437e121da$var$NUMBER_BITS;
const $747425b437e121da$var$EAW_SHIFT = $747425b437e121da$var$NUMBER_BITS;
const $747425b437e121da$var$CATEGORY_MASK = (1 << $747425b437e121da$var$CATEGORY_BITS) - 1;
const $747425b437e121da$var$COMBINING_MASK = (1 << $747425b437e121da$var$COMBINING_BITS) - 1;
const $747425b437e121da$var$SCRIPT_MASK = (1 << $747425b437e121da$var$SCRIPT_BITS) - 1;
const $747425b437e121da$var$EAW_MASK = (1 << $747425b437e121da$var$EAW_BITS) - 1;
const $747425b437e121da$var$NUMBER_MASK = (1 << $747425b437e121da$var$NUMBER_BITS) - 1;
function $747425b437e121da$export$410364bbb673ddbc(codePoint) {
    const val = $747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).categories[val >> $747425b437e121da$var$CATEGORY_SHIFT & $747425b437e121da$var$CATEGORY_MASK];
}
function $747425b437e121da$export$c03b919c6651ed55(codePoint) {
    const val = $747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).combiningClasses[val >> $747425b437e121da$var$COMBINING_SHIFT & $747425b437e121da$var$COMBINING_MASK];
}
function $747425b437e121da$export$941569448d136665(codePoint) {
    const val = $747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).scripts[val >> $747425b437e121da$var$SCRIPT_SHIFT & $747425b437e121da$var$SCRIPT_MASK];
}
function $747425b437e121da$export$92f6187db8ca6d26(codePoint) {
    const val = $747425b437e121da$var$trie.get(codePoint);
    return /*@__PURE__*/ $parcel$interopDefault($f4087201da764553$exports).eaw[val >> $747425b437e121da$var$EAW_SHIFT & $747425b437e121da$var$EAW_MASK];
}
function $747425b437e121da$export$7d1258ebb7625a0d(codePoint) {
    let val = $747425b437e121da$var$trie.get(codePoint);
    let num = val & $747425b437e121da$var$NUMBER_MASK;
    if (num === 0) return null;
    else if (num <= 50) return num - 1;
    else if (num < 0x1e0) {
        const numerator = (num >> 4) - 12;
        const denominator = (num & 0xf) + 1;
        return numerator / denominator;
    } else if (num < 0x300) {
        val = (num >> 5) - 14;
        let exp = (num & 0x1f) + 2;
        while(exp > 0){
            val *= 10;
            exp--;
        }
        return val;
    } else {
        val = (num >> 2) - 0xbf;
        let exp = (num & 3) + 1;
        while(exp > 0){
            val *= 60;
            exp--;
        }
        return val;
    }
}
function $747425b437e121da$export$52c8ea63abd07594(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Nl";
}
function $747425b437e121da$export$727d9dbc4fbb948f(codePoint) {
    return $747425b437e121da$export$410364bbb673ddbc(codePoint) === "Nd";
}
function $747425b437e121da$export$a5b49f4dc6a07d2c(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Pc" || category === "Pd" || category === "Pe" || category === "Pf" || category === "Pi" || category === "Po" || category === "Ps";
}
function $747425b437e121da$export$7b6804e8df61fcf5(codePoint) {
    return $747425b437e121da$export$410364bbb673ddbc(codePoint) === "Ll";
}
function $747425b437e121da$export$aebd617640818cda(codePoint) {
    return $747425b437e121da$export$410364bbb673ddbc(codePoint) === "Lu";
}
function $747425b437e121da$export$de8b4ee23b2cf823(codePoint) {
    return $747425b437e121da$export$410364bbb673ddbc(codePoint) === "Lt";
}
function $747425b437e121da$export$3c52dd84024ae72c(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Zs" || category === "Zl" || category === "Zp";
}
function $747425b437e121da$export$a11bdcffe109e74b(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Nd" || category === "No" || category === "Nl" || category === "Lu" || category === "Ll" || category === "Lt" || category === "Lm" || category === "Lo" || category === "Me" || category === "Mc";
}
function $747425b437e121da$export$e33ad6871e762338(codePoint) {
    const category = $747425b437e121da$export$410364bbb673ddbc(codePoint);
    return category === "Mn" || category === "Me" || category === "Mc";
}
var $747425b437e121da$export$2e2bcd8739ae039 = {
    getCategory: $747425b437e121da$export$410364bbb673ddbc,
    getCombiningClass: $747425b437e121da$export$c03b919c6651ed55,
    getScript: $747425b437e121da$export$941569448d136665,
    getEastAsianWidth: $747425b437e121da$export$92f6187db8ca6d26,
    getNumericValue: $747425b437e121da$export$7d1258ebb7625a0d,
    isAlphabetic: $747425b437e121da$export$52c8ea63abd07594,
    isDigit: $747425b437e121da$export$727d9dbc4fbb948f,
    isPunctuation: $747425b437e121da$export$a5b49f4dc6a07d2c,
    isLowerCase: $747425b437e121da$export$7b6804e8df61fcf5,
    isUpperCase: $747425b437e121da$export$aebd617640818cda,
    isTitleCase: $747425b437e121da$export$de8b4ee23b2cf823,
    isWhiteSpace: $747425b437e121da$export$3c52dd84024ae72c,
    isBaseForm: $747425b437e121da$export$a11bdcffe109e74b,
    isMark: $747425b437e121da$export$e33ad6871e762338
};

},{"base64-js":"hzicH","unicode-trie":"jRHH2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hzicH":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"jRHH2":[function(require,module,exports) {
const inflate = require("8ae222e01e363bff");
const { swap32LE } = require("16e27bed1474c3a6");
// Shift size for getting the index-1 table offset.
const SHIFT_1 = 11;
// Shift size for getting the index-2 table offset.
const SHIFT_2 = 5;
// Difference between the two shift sizes,
// for getting an index-1 offset from an index-2 offset. 6=11-5
const SHIFT_1_2 = SHIFT_1 - SHIFT_2;
// Number of index-1 entries for the BMP. 32=0x20
// This part of the index-1 table is omitted from the serialized form.
const OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
// Number of entries in an index-2 block. 64=0x40
const INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
// Mask for getting the lower bits for the in-index-2-block offset. */
const INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
// Shift size for shifting left the index array values.
// Increases possible data size with 16-bit index values at the cost
// of compactability.
// This requires data blocks to be aligned by DATA_GRANULARITY.
const INDEX_SHIFT = 2;
// Number of entries in a data block. 32=0x20
const DATA_BLOCK_LENGTH = 1 << SHIFT_2;
// Mask for getting the lower bits for the in-data-block offset.
const DATA_MASK = DATA_BLOCK_LENGTH - 1;
// The part of the index-2 table for U+D800..U+DBFF stores values for
// lead surrogate code _units_ not code _points_.
// Values for lead surrogate code _points_ are indexed with this portion of the table.
// Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
const LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
const LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
// Count the lengths of both BMP pieces. 2080=0x820
const INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
// The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
// Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
const UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
const UTF8_2B_INDEX_2_LENGTH = 32; // U+0800 is the first code point after 2-byte UTF-8
// The index-1 table, only used for supplementary code points, at offset 2112=0x840.
// Variable length, for code points up to highStart, where the last single-value range starts.
// Maximum length 512=0x200=0x100000>>SHIFT_1.
// (For 0x100000 supplementary code points U+10000..U+10ffff.)
//
// The part of the index-2 table for supplementary code points starts
// after this index-1 table.
//
// Both the index-1 table and the following part of the index-2 table
// are omitted completely if there is only BMP data.
const INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
// The alignment size of a data block. Also the granularity for compaction.
const DATA_GRANULARITY = 1 << INDEX_SHIFT;
class UnicodeTrie {
    constructor(data){
        const isBuffer = typeof data.readUInt32BE === "function" && typeof data.slice === "function";
        if (isBuffer || data instanceof Uint8Array) {
            // read binary format
            let uncompressedLength;
            if (isBuffer) {
                this.highStart = data.readUInt32LE(0);
                this.errorValue = data.readUInt32LE(4);
                uncompressedLength = data.readUInt32LE(8);
                data = data.slice(12);
            } else {
                const view = new DataView(data.buffer);
                this.highStart = view.getUint32(0, true);
                this.errorValue = view.getUint32(4, true);
                uncompressedLength = view.getUint32(8, true);
                data = data.subarray(12);
            }
            // double inflate the actual trie data
            data = inflate(data, new Uint8Array(uncompressedLength));
            data = inflate(data, new Uint8Array(uncompressedLength));
            // swap bytes from little-endian
            swap32LE(data);
            this.data = new Uint32Array(data.buffer);
        } else // pre-parsed data
        ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = data);
    }
    get(codePoint) {
        let index;
        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
            // Ordinary BMP code point, excluding leading surrogates.
            // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
            // data is stored in the index array itself.
            index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint <= 0xffff) {
            // Lead Surrogate Code Point.  A Separate index section is stored for
            // lead surrogate code units and code points.
            //   The main index has the code unit data.
            //   For this function, we need the code point data.
            index = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint < this.highStart) {
            // Supplemental code point, use two-level lookup.
            index = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
            index = this.data[index + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
            index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        return this.data[this.data.length - DATA_GRANULARITY];
    }
}
module.exports = UnicodeTrie;

},{"8ae222e01e363bff":"762Rs","16e27bed1474c3a6":"8UsvU"}],"762Rs":[function(require,module,exports) {
var TINF_OK = 0;
var TINF_DATA_ERROR = -3;
function Tree() {
    this.table = new Uint16Array(16); /* table of code length counts */ 
    this.trans = new Uint16Array(288); /* code -> symbol translation table */ 
}
function Data(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new Tree(); /* dynamic length/symbol tree */ 
    this.dtree = new Tree(); /* dynamic distance tree */ 
}
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var sltree = new Tree();
var sdtree = new Tree();
/* extra bits and base tables for length codes */ var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);
/* special ordering of code length codes */ var clcidx = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var code_tree = new Tree();
var lengths = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function tinf_build_bits_base(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function tinf_build_fixed_trees(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var offs = new Uint16Array(16);
function tinf_build_tree(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        offs[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function tinf_getbit(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function tinf_read_bits(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function tinf_decode_symbol(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function tinf_decode_trees(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = tinf_read_bits(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = tinf_read_bits(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = tinf_read_bits(d, 4, 4);
    for(i = 0; i < 19; ++i)lengths[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = tinf_read_bits(d, 3, 0);
        lengths[clcidx[i]] = clen;
    }
    /* build code length tree */ tinf_build_tree(code_tree, lengths, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = tinf_decode_symbol(d, code_tree);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = lengths[num - 1];
                for(length = tinf_read_bits(d, 2, 3); length; --length)lengths[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = tinf_read_bits(d, 3, 3); length; --length)lengths[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = tinf_read_bits(d, 7, 11); length; --length)lengths[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ lengths[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ tinf_build_tree(lt, lengths, 0, hlit);
    tinf_build_tree(dt, lengths, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function tinf_inflate_block_data(d, lt, dt) {
    while(true){
        var sym = tinf_decode_symbol(d, lt);
        /* check for end of block */ if (sym === 256) return TINF_OK;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = tinf_read_bits(d, length_bits[sym], length_base[sym]);
            dist = tinf_decode_symbol(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function tinf_inflate_uncompressed_block(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return TINF_DATA_ERROR;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return TINF_OK;
}
/* inflate stream from source to dest */ function tinf_uncompress(source, dest) {
    var d = new Data(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = tinf_getbit(d);
        /* read block type (2 bits) */ btype = tinf_read_bits(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = tinf_inflate_uncompressed_block(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = tinf_inflate_block_data(d, sltree, sdtree);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ tinf_decode_trees(d, d.ltree, d.dtree);
                res = tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
            default:
                res = TINF_DATA_ERROR;
        }
        if (res !== TINF_OK) throw new Error("Data error");
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === "function") return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ tinf_build_fixed_trees(sltree, sdtree);
/* build extra bits and base tables */ tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);
/* fix a special case */ length_bits[28] = 0;
length_base[28] = 258;
module.exports = tinf_uncompress;

},{}],"8UsvU":[function(require,module,exports) {
const isBigEndian = new Uint8Array(new Uint32Array([
    0x12345678
]).buffer)[0] === 0x12;
const swap = (b, n, m)=>{
    let i = b[n];
    b[n] = b[m];
    b[m] = i;
};
const swap32 = (array)=>{
    const len = array.length;
    for(let i = 0; i < len; i += 4){
        swap(array, i, i + 3);
        swap(array, i + 1, i + 2);
    }
};
const swap32LE = (array)=>{
    if (isBigEndian) swap32(array);
};
module.exports = {
    swap32LE: swap32LE
};

},{}],"2xeOx":[function(require,module,exports) {
"use strict";
var INITIAL_STATE = 1;
var FAIL_STATE = 0;
/**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */ class StateMachine {
    constructor(dfa){
        this.stateTable = dfa.stateTable;
        this.accepting = dfa.accepting;
        this.tags = dfa.tags;
    }
    /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */ match(str) {
        var self = this;
        return {
            *[Symbol.iterator] () {
                var state = INITIAL_STATE;
                var startRun = null;
                var lastAccepting = null;
                var lastState = null;
                for(var p = 0; p < str.length; p++){
                    var c = str[p];
                    lastState = state;
                    state = self.stateTable[state][c];
                    if (state === FAIL_STATE) {
                        // yield the last match if any
                        if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                            startRun,
                            lastAccepting,
                            self.tags[lastState]
                        ];
                         // reset the state as if we started over from the initial state
                        state = self.stateTable[INITIAL_STATE][c];
                        startRun = null;
                    } // start a run if not in the failure state
                    if (state !== FAIL_STATE && startRun == null) startRun = p;
                     // if accepting, mark the potential match end
                    if (self.accepting[state]) lastAccepting = p;
                     // reset the state to the initial state if we get into the failure state
                    if (state === FAIL_STATE) state = INITIAL_STATE;
                } // yield the last match if any
                if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                    startRun,
                    lastAccepting,
                    self.tags[state]
                ];
            }
        };
    }
    /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */ apply(str, actions) {
        for (var [start, end, tags] of this.match(str)){
            for (var tag of tags)if (typeof actions[tag] === "function") actions[tag](start, end, str.slice(start, end + 1));
        }
    }
}
module.exports = StateMachine;

},{}],"6bxBg":[function(require,module,exports) {
var Buffer = require("6a12806bba69ad08").Buffer;
var clone = function() {
    "use strict";
    function _instanceof(obj, type) {
        return type != null && obj instanceof type;
    }
    var nativeMap;
    try {
        nativeMap = Map;
    } catch (_) {
        // maybe a reference error because no `Map`. Give it a dummy value that no
        // value will ever be an instanceof.
        nativeMap = function() {};
    }
    var nativeSet;
    try {
        nativeSet = Set;
    } catch (_) {
        nativeSet = function() {};
    }
    var nativePromise;
    try {
        nativePromise = Promise;
    } catch (_) {
        nativePromise = function() {};
    }
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === "object") {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof Buffer != "undefined";
        if (typeof circular == "undefined") circular = true;
        if (typeof depth == "undefined") depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth === 0) return parent;
            var child;
            var proto;
            if (typeof parent != "object") return parent;
            if (_instanceof(parent, nativeMap)) child = new nativeMap();
            else if (_instanceof(parent, nativeSet)) child = new nativeSet();
            else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                parent.then(function(value) {
                    resolve(_clone(value, depth - 1));
                }, function(err) {
                    reject(_clone(err, depth - 1));
                });
            });
            else if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && Buffer.isBuffer(parent)) {
                if (Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (_instanceof(parent, Error)) child = Object.create(parent);
            else if (typeof prototype == "undefined") {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
            });
            if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
            });
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(parent);
                for(var i = 0; i < symbols.length; i++){
                    // Don't need to worry about cloning a symbol because it is a primitive,
                    // like a number or string.
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                    child[symbol] = _clone(parent[symbol], depth - 1);
                    if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                        enumerable: false
                    });
                }
            }
            if (includeNonEnumerable) {
                var allPropertyNames = Object.getOwnPropertyNames(parent);
                for(var i = 0; i < allPropertyNames.length; i++){
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                    if (descriptor && descriptor.enumerable) continue;
                    child[propertyName] = _clone(parent[propertyName], depth - 1);
                    Object.defineProperty(child, propertyName, {
                        enumerable: false
                    });
                }
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === "object" && __objToStr(o) === "[object Date]";
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === "object" && __objToStr(o) === "[object Array]";
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === "object" && __objToStr(o) === "[object RegExp]";
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = "";
        if (re.global) flags += "g";
        if (re.ignoreCase) flags += "i";
        if (re.multiline) flags += "m";
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (0, module.exports) module.exports = clone;

},{"6a12806bba69ad08":"l7ZVv"}],"l7ZVv":[function(require,module,exports) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ "use strict";
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === "string") return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== "number") throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

},{"9c62938f1dccc73c":"hzicH","aceacb6a4531a9d2":"c51Y0"}],"c51Y0":[function(require,module,exports) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"iCGF7":[function(require,module,exports) {
module.exports = require("e749e0bd4b2ed991").BrotliDecompressBuffer;

},{"e749e0bd4b2ed991":"bUqLP"}],"bUqLP":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ var BrotliInput = require("e78da4f881c045fc").BrotliInput;
var BrotliOutput = require("e78da4f881c045fc").BrotliOutput;
var BrotliBitReader = require("8ead054b5aa5fe7b");
var BrotliDictionary = require("972dabfef886f9ef");
var HuffmanCode = require("3a26f72c03db659e").HuffmanCode;
var BrotliBuildHuffmanTable = require("3a26f72c03db659e").BrotliBuildHuffmanTable;
var Context = require("ec89e1d307370091");
var Prefix = require("b64dbc814ce2ff4a");
var Transform = require("3133426e058893de");
var kDefaultCodeLength = 8;
var kCodeLengthRepeatCode = 16;
var kNumLiteralCodes = 256;
var kNumInsertAndCopyCodes = 704;
var kNumBlockLengthCodes = 26;
var kLiteralContextBits = 6;
var kDistanceContextBits = 2;
var HUFFMAN_TABLE_BITS = 8;
var HUFFMAN_TABLE_MASK = 0xff;
/* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */ var HUFFMAN_MAX_TABLE_SIZE = 1080;
var CODE_LENGTH_CODES = 18;
var kCodeLengthCodeOrder = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
]);
var NUM_DISTANCE_SHORT_CODES = 16;
var kDistanceShortCodeIndexOffset = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
]);
var kDistanceShortCodeValueOffset = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
]);
var kMaxHuffmanTableSize = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
]);
function DecodeWindowBits(br) {
    var n;
    if (br.readBits(1) === 0) return 16;
    n = br.readBits(3);
    if (n > 0) return 17 + n;
    n = br.readBits(3);
    if (n > 0) return 8 + n;
    return 17;
}
/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */ function DecodeVarLenUint8(br) {
    if (br.readBits(1)) {
        var nbits = br.readBits(3);
        if (nbits === 0) return 1;
        else return br.readBits(nbits) + (1 << nbits);
    }
    return 0;
}
function MetaBlockLength() {
    this.meta_block_length = 0;
    this.input_end = 0;
    this.is_uncompressed = 0;
    this.is_metadata = false;
}
function DecodeMetaBlockLength(br) {
    var out = new MetaBlockLength;
    var size_nibbles;
    var size_bytes;
    var i;
    out.input_end = br.readBits(1);
    if (out.input_end && br.readBits(1)) return out;
    size_nibbles = br.readBits(2) + 4;
    if (size_nibbles === 7) {
        out.is_metadata = true;
        if (br.readBits(1) !== 0) throw new Error("Invalid reserved bit");
        size_bytes = br.readBits(2);
        if (size_bytes === 0) return out;
        for(i = 0; i < size_bytes; i++){
            var next_byte = br.readBits(8);
            if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0) throw new Error("Invalid size byte");
            out.meta_block_length |= next_byte << i * 8;
        }
    } else for(i = 0; i < size_nibbles; ++i){
        var next_nibble = br.readBits(4);
        if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0) throw new Error("Invalid size nibble");
        out.meta_block_length |= next_nibble << i * 4;
    }
    ++out.meta_block_length;
    if (!out.input_end && !out.is_metadata) out.is_uncompressed = br.readBits(1);
    return out;
}
/* Decodes the next Huffman code from bit-stream. */ function ReadSymbol(table, index, br) {
    var start_index = index;
    var nbits;
    br.fillBitWindow();
    index += br.val_ >>> br.bit_pos_ & HUFFMAN_TABLE_MASK;
    nbits = table[index].bits - HUFFMAN_TABLE_BITS;
    if (nbits > 0) {
        br.bit_pos_ += HUFFMAN_TABLE_BITS;
        index += table[index].value;
        index += br.val_ >>> br.bit_pos_ & (1 << nbits) - 1;
    }
    br.bit_pos_ += table[index].bits;
    return table[index].value;
}
function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
    var symbol = 0;
    var prev_code_len = kDefaultCodeLength;
    var repeat = 0;
    var repeat_code_len = 0;
    var space = 32768;
    var table = [];
    for(var i = 0; i < 32; i++)table.push(new HuffmanCode(0, 0));
    BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);
    while(symbol < num_symbols && space > 0){
        var p = 0;
        var code_len;
        br.readMoreInput();
        br.fillBitWindow();
        p += br.val_ >>> br.bit_pos_ & 31;
        br.bit_pos_ += table[p].bits;
        code_len = table[p].value & 0xff;
        if (code_len < kCodeLengthRepeatCode) {
            repeat = 0;
            code_lengths[symbol++] = code_len;
            if (code_len !== 0) {
                prev_code_len = code_len;
                space -= 32768 >> code_len;
            }
        } else {
            var extra_bits = code_len - 14;
            var old_repeat;
            var repeat_delta;
            var new_len = 0;
            if (code_len === kCodeLengthRepeatCode) new_len = prev_code_len;
            if (repeat_code_len !== new_len) {
                repeat = 0;
                repeat_code_len = new_len;
            }
            old_repeat = repeat;
            if (repeat > 0) {
                repeat -= 2;
                repeat <<= extra_bits;
            }
            repeat += br.readBits(extra_bits) + 3;
            repeat_delta = repeat - old_repeat;
            if (symbol + repeat_delta > num_symbols) throw new Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
            for(var x = 0; x < repeat_delta; x++)code_lengths[symbol + x] = repeat_code_len;
            symbol += repeat_delta;
            if (repeat_code_len !== 0) space -= repeat_delta << 15 - repeat_code_len;
        }
    }
    if (space !== 0) throw new Error("[ReadHuffmanCodeLengths] space = " + space);
    for(; symbol < num_symbols; symbol++)code_lengths[symbol] = 0;
}
function ReadHuffmanCode(alphabet_size, tables, table, br) {
    var table_size = 0;
    var simple_code_or_skip;
    var code_lengths = new Uint8Array(alphabet_size);
    br.readMoreInput();
    /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */ simple_code_or_skip = br.readBits(2);
    if (simple_code_or_skip === 1) {
        /* Read symbols, codes & code lengths directly. */ var i;
        var max_bits_counter = alphabet_size - 1;
        var max_bits = 0;
        var symbols = new Int32Array(4);
        var num_symbols = br.readBits(2) + 1;
        while(max_bits_counter){
            max_bits_counter >>= 1;
            ++max_bits;
        }
        for(i = 0; i < num_symbols; ++i){
            symbols[i] = br.readBits(max_bits) % alphabet_size;
            code_lengths[symbols[i]] = 2;
        }
        code_lengths[symbols[0]] = 1;
        switch(num_symbols){
            case 1:
                break;
            case 3:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[1] === symbols[2]) throw new Error("[ReadHuffmanCode] invalid symbols");
                break;
            case 2:
                if (symbols[0] === symbols[1]) throw new Error("[ReadHuffmanCode] invalid symbols");
                code_lengths[symbols[1]] = 1;
                break;
            case 4:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[0] === symbols[3] || symbols[1] === symbols[2] || symbols[1] === symbols[3] || symbols[2] === symbols[3]) throw new Error("[ReadHuffmanCode] invalid symbols");
                if (br.readBits(1)) {
                    code_lengths[symbols[2]] = 3;
                    code_lengths[symbols[3]] = 3;
                } else code_lengths[symbols[0]] = 2;
                break;
        }
    } else {
        var i;
        var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
        var space = 32;
        var num_codes = 0;
        /* Static Huffman code for the code length code lengths */ var huff = [
            new HuffmanCode(2, 0),
            new HuffmanCode(2, 4),
            new HuffmanCode(2, 3),
            new HuffmanCode(3, 2),
            new HuffmanCode(2, 0),
            new HuffmanCode(2, 4),
            new HuffmanCode(2, 3),
            new HuffmanCode(4, 1),
            new HuffmanCode(2, 0),
            new HuffmanCode(2, 4),
            new HuffmanCode(2, 3),
            new HuffmanCode(3, 2),
            new HuffmanCode(2, 0),
            new HuffmanCode(2, 4),
            new HuffmanCode(2, 3),
            new HuffmanCode(4, 5)
        ];
        for(i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i){
            var code_len_idx = kCodeLengthCodeOrder[i];
            var p = 0;
            var v;
            br.fillBitWindow();
            p += br.val_ >>> br.bit_pos_ & 15;
            br.bit_pos_ += huff[p].bits;
            v = huff[p].value;
            code_length_code_lengths[code_len_idx] = v;
            if (v !== 0) {
                space -= 32 >> v;
                ++num_codes;
            }
        }
        if (!(num_codes === 1 || space === 0)) throw new Error("[ReadHuffmanCode] invalid num_codes or space");
        ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
    }
    table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
    if (table_size === 0) throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return table_size;
}
function ReadBlockLength(table, index, br) {
    var code;
    var nbits;
    code = ReadSymbol(table, index, br);
    nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
    return Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
}
function TranslateShortCodes(code, ringbuffer, index) {
    var val;
    if (code < NUM_DISTANCE_SHORT_CODES) {
        index += kDistanceShortCodeIndexOffset[code];
        index &= 3;
        val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
    } else val = code - NUM_DISTANCE_SHORT_CODES + 1;
    return val;
}
function MoveToFront(v, index) {
    var value = v[index];
    var i = index;
    for(; i; --i)v[i] = v[i - 1];
    v[0] = value;
}
function InverseMoveToFrontTransform(v, v_len) {
    var mtf = new Uint8Array(256);
    var i;
    for(i = 0; i < 256; ++i)mtf[i] = i;
    for(i = 0; i < v_len; ++i){
        var index = v[i];
        v[i] = mtf[index];
        if (index) MoveToFront(mtf, index);
    }
}
/* Contains a collection of huffman trees with the same alphabet size. */ function HuffmanTreeGroup(alphabet_size, num_htrees) {
    this.alphabet_size = alphabet_size;
    this.num_htrees = num_htrees;
    this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[alphabet_size + 31 >>> 5]);
    this.htrees = new Uint32Array(num_htrees);
}
HuffmanTreeGroup.prototype.decode = function(br) {
    var i;
    var table_size;
    var next = 0;
    for(i = 0; i < this.num_htrees; ++i){
        this.htrees[i] = next;
        table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
        next += table_size;
    }
};
function DecodeContextMap(context_map_size, br) {
    var out = {
        num_htrees: null,
        context_map: null
    };
    var use_rle_for_zeros;
    var max_run_length_prefix = 0;
    var table;
    var i;
    br.readMoreInput();
    var num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;
    var context_map = out.context_map = new Uint8Array(context_map_size);
    if (num_htrees <= 1) return out;
    use_rle_for_zeros = br.readBits(1);
    if (use_rle_for_zeros) max_run_length_prefix = br.readBits(4) + 1;
    table = [];
    for(i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++)table[i] = new HuffmanCode(0, 0);
    ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
    for(i = 0; i < context_map_size;){
        var code;
        br.readMoreInput();
        code = ReadSymbol(table, 0, br);
        if (code === 0) {
            context_map[i] = 0;
            ++i;
        } else if (code <= max_run_length_prefix) {
            var reps = 1 + (1 << code) + br.readBits(code);
            while(--reps){
                if (i >= context_map_size) throw new Error("[DecodeContextMap] i >= context_map_size");
                context_map[i] = 0;
                ++i;
            }
        } else {
            context_map[i] = code - max_run_length_prefix;
            ++i;
        }
    }
    if (br.readBits(1)) InverseMoveToFrontTransform(context_map, context_map_size);
    return out;
}
function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
    var ringbuffer = tree_type * 2;
    var index = tree_type;
    var type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
    var block_type;
    if (type_code === 0) block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
    else if (type_code === 1) block_type = ringbuffers[ringbuffer + (indexes[index] - 1 & 1)] + 1;
    else block_type = type_code - 2;
    if (block_type >= max_block_type) block_type -= max_block_type;
    block_types[tree_type] = block_type;
    ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
    ++indexes[index];
}
function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
    var rb_size = ringbuffer_mask + 1;
    var rb_pos = pos & ringbuffer_mask;
    var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
    var nbytes;
    /* For short lengths copy byte-by-byte */ if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
        while(len-- > 0){
            br.readMoreInput();
            ringbuffer[rb_pos++] = br.readBits(8);
            if (rb_pos === rb_size) {
                output.write(ringbuffer, rb_size);
                rb_pos = 0;
            }
        }
        return;
    }
    if (br.bit_end_pos_ < 32) throw new Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
    /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */ while(br.bit_pos_ < 32){
        ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
        br.bit_pos_ += 8;
        ++rb_pos;
        --len;
    }
    /* Copy remaining bytes from br.buf_ to ringbuffer. */ nbytes = br.bit_end_pos_ - br.bit_pos_ >> 3;
    if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
        var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
        for(var x = 0; x < tail; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
        nbytes -= tail;
        rb_pos += tail;
        len -= tail;
        br_pos = 0;
    }
    for(var x = 0; x < nbytes; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
    rb_pos += nbytes;
    len -= nbytes;
    /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */ if (rb_pos >= rb_size) {
        output.write(ringbuffer, rb_size);
        rb_pos -= rb_size;
        for(var x = 0; x < rb_pos; x++)ringbuffer[x] = ringbuffer[rb_size + x];
    }
    /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */ while(rb_pos + len >= rb_size){
        nbytes = rb_size - rb_pos;
        if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
        output.write(ringbuffer, rb_size);
        len -= nbytes;
        rb_pos = 0;
    }
    /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */ if (br.input_.read(ringbuffer, rb_pos, len) < len) throw new Error("[CopyUncompressedBlockToOutput] not enough bytes");
    /* Restore the state of the bit reader. */ br.reset();
}
/* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */ function JumpToByteBoundary(br) {
    var new_bit_pos = br.bit_pos_ + 7 & -8;
    var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
    return pad_bits == 0;
}
function BrotliDecompressedSize(buffer) {
    var input = new BrotliInput(buffer);
    var br = new BrotliBitReader(input);
    DecodeWindowBits(br);
    var out = DecodeMetaBlockLength(br);
    return out.meta_block_length;
}
exports.BrotliDecompressedSize = BrotliDecompressedSize;
function BrotliDecompressBuffer(buffer, output_size) {
    var input = new BrotliInput(buffer);
    if (output_size == null) output_size = BrotliDecompressedSize(buffer);
    var output_buffer = new Uint8Array(output_size);
    var output = new BrotliOutput(output_buffer);
    BrotliDecompress(input, output);
    if (output.pos < output.buffer.length) output.buffer = output.buffer.subarray(0, output.pos);
    return output.buffer;
}
exports.BrotliDecompressBuffer = BrotliDecompressBuffer;
function BrotliDecompress(input, output) {
    var i;
    var pos = 0;
    var input_end = 0;
    var window_bits = 0;
    var max_backward_distance;
    var max_distance = 0;
    var ringbuffer_size;
    var ringbuffer_mask;
    var ringbuffer;
    var ringbuffer_end;
    /* This ring buffer holds a few past copy distances that will be used by */ /* some special distance codes. */ var dist_rb = [
        16,
        15,
        11,
        4
    ];
    var dist_rb_idx = 0;
    /* The previous 2 bytes used for context. */ var prev_byte1 = 0;
    var prev_byte2 = 0;
    var hgroup = [
        new HuffmanTreeGroup(0, 0),
        new HuffmanTreeGroup(0, 0),
        new HuffmanTreeGroup(0, 0)
    ];
    var block_type_trees;
    var block_len_trees;
    var br;
    /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */ var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;
    br = new BrotliBitReader(input);
    /* Decode window size. */ window_bits = DecodeWindowBits(br);
    max_backward_distance = (1 << window_bits) - 16;
    ringbuffer_size = 1 << window_bits;
    ringbuffer_mask = ringbuffer_size - 1;
    ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
    ringbuffer_end = ringbuffer_size;
    block_type_trees = [];
    block_len_trees = [];
    for(var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++){
        block_type_trees[x] = new HuffmanCode(0, 0);
        block_len_trees[x] = new HuffmanCode(0, 0);
    }
    while(!input_end){
        var meta_block_remaining_len = 0;
        var is_uncompressed;
        var block_length = [
            268435456,
            268435456,
            268435456
        ];
        var block_type = [
            0
        ];
        var num_block_types = [
            1,
            1,
            1
        ];
        var block_type_rb = [
            0,
            1,
            0,
            1,
            0,
            1
        ];
        var block_type_rb_index = [
            0
        ];
        var distance_postfix_bits;
        var num_direct_distance_codes;
        var distance_postfix_mask;
        var num_distance_codes;
        var context_map = null;
        var context_modes = null;
        var num_literal_htrees;
        var dist_context_map = null;
        var num_dist_htrees;
        var context_offset = 0;
        var context_map_slice = null;
        var literal_htree_index = 0;
        var dist_context_offset = 0;
        var dist_context_map_slice = null;
        var dist_htree_index = 0;
        var context_lookup_offset1 = 0;
        var context_lookup_offset2 = 0;
        var context_mode;
        var htree_command;
        for(i = 0; i < 3; ++i){
            hgroup[i].codes = null;
            hgroup[i].htrees = null;
        }
        br.readMoreInput();
        var _out = DecodeMetaBlockLength(br);
        meta_block_remaining_len = _out.meta_block_length;
        if (pos + meta_block_remaining_len > output.buffer.length) {
            /* We need to grow the output buffer to fit the additional data. */ var tmp = new Uint8Array(pos + meta_block_remaining_len);
            tmp.set(output.buffer);
            output.buffer = tmp;
        }
        input_end = _out.input_end;
        is_uncompressed = _out.is_uncompressed;
        if (_out.is_metadata) {
            JumpToByteBoundary(br);
            for(; meta_block_remaining_len > 0; --meta_block_remaining_len){
                br.readMoreInput();
                /* Read one byte and ignore it. */ br.readBits(8);
            }
            continue;
        }
        if (meta_block_remaining_len === 0) continue;
        if (is_uncompressed) {
            br.bit_pos_ = br.bit_pos_ + 7 & -8;
            CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos, ringbuffer, ringbuffer_mask, br);
            pos += meta_block_remaining_len;
            continue;
        }
        for(i = 0; i < 3; ++i){
            num_block_types[i] = DecodeVarLenUint8(br) + 1;
            if (num_block_types[i] >= 2) {
                ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
                block_type_rb_index[i] = 1;
            }
        }
        br.readMoreInput();
        distance_postfix_bits = br.readBits(2);
        num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
        distance_postfix_mask = (1 << distance_postfix_bits) - 1;
        num_distance_codes = num_direct_distance_codes + (48 << distance_postfix_bits);
        context_modes = new Uint8Array(num_block_types[0]);
        for(i = 0; i < num_block_types[0]; ++i){
            br.readMoreInput();
            context_modes[i] = br.readBits(2) << 1;
        }
        var _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
        num_literal_htrees = _o1.num_htrees;
        context_map = _o1.context_map;
        var _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
        num_dist_htrees = _o2.num_htrees;
        dist_context_map = _o2.context_map;
        hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
        hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
        hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
        for(i = 0; i < 3; ++i)hgroup[i].decode(br);
        context_map_slice = 0;
        dist_context_map_slice = 0;
        context_mode = context_modes[block_type[0]];
        context_lookup_offset1 = Context.lookupOffsets[context_mode];
        context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
        htree_command = hgroup[1].htrees[0];
        while(meta_block_remaining_len > 0){
            var cmd_code;
            var range_idx;
            var insert_code;
            var copy_code;
            var insert_length;
            var copy_length;
            var distance_code;
            var distance;
            var context;
            var j;
            var copy_dst;
            br.readMoreInput();
            if (block_length[1] === 0) {
                DecodeBlockType(num_block_types[1], block_type_trees, 1, block_type, block_type_rb, block_type_rb_index, br);
                block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
                htree_command = hgroup[1].htrees[block_type[1]];
            }
            --block_length[1];
            cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
            range_idx = cmd_code >> 6;
            if (range_idx >= 2) {
                range_idx -= 2;
                distance_code = -1;
            } else distance_code = 0;
            insert_code = Prefix.kInsertRangeLut[range_idx] + (cmd_code >> 3 & 7);
            copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
            insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset + br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
            copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset + br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
            prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
            for(j = 0; j < insert_length; ++j){
                br.readMoreInput();
                if (block_length[0] === 0) {
                    DecodeBlockType(num_block_types[0], block_type_trees, 0, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[0] = ReadBlockLength(block_len_trees, 0, br);
                    context_offset = block_type[0] << kLiteralContextBits;
                    context_map_slice = context_offset;
                    context_mode = context_modes[block_type[0]];
                    context_lookup_offset1 = Context.lookupOffsets[context_mode];
                    context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
                }
                context = Context.lookup[context_lookup_offset1 + prev_byte1] | Context.lookup[context_lookup_offset2 + prev_byte2];
                literal_htree_index = context_map[context_map_slice + context];
                --block_length[0];
                prev_byte2 = prev_byte1;
                prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
                ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                ++pos;
            }
            meta_block_remaining_len -= insert_length;
            if (meta_block_remaining_len <= 0) break;
            if (distance_code < 0) {
                var context;
                br.readMoreInput();
                if (block_length[2] === 0) {
                    DecodeBlockType(num_block_types[2], block_type_trees, 2, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
                    dist_context_offset = block_type[2] << kDistanceContextBits;
                    dist_context_map_slice = dist_context_offset;
                }
                --block_length[2];
                context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                dist_htree_index = dist_context_map[dist_context_map_slice + context];
                distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
                if (distance_code >= num_direct_distance_codes) {
                    var nbits;
                    var postfix;
                    var offset;
                    distance_code -= num_direct_distance_codes;
                    postfix = distance_code & distance_postfix_mask;
                    distance_code >>= distance_postfix_bits;
                    nbits = (distance_code >> 1) + 1;
                    offset = (2 + (distance_code & 1) << nbits) - 4;
                    distance_code = num_direct_distance_codes + (offset + br.readBits(nbits) << distance_postfix_bits) + postfix;
                }
            }
            /* Convert the distance code to the actual distance by possibly looking */ /* up past distnaces from the ringbuffer. */ distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
            if (distance < 0) throw new Error("[BrotliDecompress] invalid distance");
            if (pos < max_backward_distance && max_distance !== max_backward_distance) max_distance = pos;
            else max_distance = max_backward_distance;
            copy_dst = pos & ringbuffer_mask;
            if (distance > max_distance) {
                if (copy_length >= BrotliDictionary.minDictionaryWordLength && copy_length <= BrotliDictionary.maxDictionaryWordLength) {
                    var offset = BrotliDictionary.offsetsByLength[copy_length];
                    var word_id = distance - max_distance - 1;
                    var shift = BrotliDictionary.sizeBitsByLength[copy_length];
                    var mask = (1 << shift) - 1;
                    var word_idx = word_id & mask;
                    var transform_idx = word_id >> shift;
                    offset += word_idx * copy_length;
                    if (transform_idx < Transform.kNumTransforms) {
                        var len = Transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
                        copy_dst += len;
                        pos += len;
                        meta_block_remaining_len -= len;
                        if (copy_dst >= ringbuffer_end) {
                            output.write(ringbuffer, ringbuffer_size);
                            for(var _x = 0; _x < copy_dst - ringbuffer_end; _x++)ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                        }
                    } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
            } else {
                if (distance_code > 0) {
                    dist_rb[dist_rb_idx & 3] = distance;
                    ++dist_rb_idx;
                }
                if (copy_length > meta_block_remaining_len) throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                for(j = 0; j < copy_length; ++j){
                    ringbuffer[pos & ringbuffer_mask] = ringbuffer[pos - distance & ringbuffer_mask];
                    if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                    ++pos;
                    --meta_block_remaining_len;
                }
            }
            /* When we get here, we must have inserted at least one literal and */ /* made a copy of at least length two, therefore accessing the last 2 */ /* bytes is valid. */ prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
        }
        /* Protect pos from overflow, wrap it around at every GB of input data */ pos &= 0x3fffffff;
    }
    output.write(ringbuffer, pos & ringbuffer_mask);
}
exports.BrotliDecompress = BrotliDecompress;
BrotliDictionary.init();

},{"e78da4f881c045fc":"fTboR","8ead054b5aa5fe7b":"kV9hB","972dabfef886f9ef":"lcZVj","3a26f72c03db659e":"d9I69","ec89e1d307370091":"6Kx61","b64dbc814ce2ff4a":"j5bwT","3133426e058893de":"ciQhd"}],"fTboR":[function(require,module,exports) {
function BrotliInput(buffer) {
    this.buffer = buffer;
    this.pos = 0;
}
BrotliInput.prototype.read = function(buf, i, count) {
    if (this.pos + count > this.buffer.length) count = this.buffer.length - this.pos;
    for(var p = 0; p < count; p++)buf[i + p] = this.buffer[this.pos + p];
    this.pos += count;
    return count;
};
exports.BrotliInput = BrotliInput;
function BrotliOutput(buf) {
    this.buffer = buf;
    this.pos = 0;
}
BrotliOutput.prototype.write = function(buf, count) {
    if (this.pos + count > this.buffer.length) throw new Error("Output buffer is not large enough");
    this.buffer.set(buf.subarray(0, count), this.pos);
    this.pos += count;
    return count;
};
exports.BrotliOutput = BrotliOutput;

},{}],"kV9hB":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/ var BROTLI_READ_SIZE = 4096;
var BROTLI_IBUF_SIZE = 2 * BROTLI_READ_SIZE + 32;
var BROTLI_IBUF_MASK = 2 * BROTLI_READ_SIZE - 1;
var kBitMask = new Uint32Array([
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023,
    2047,
    4095,
    8191,
    16383,
    32767,
    65535,
    131071,
    262143,
    524287,
    1048575,
    2097151,
    4194303,
    8388607,
    16777215
]);
/* Input byte buffer, consist of a ringbuffer and a "slack" region where */ /* bytes from the start of the ringbuffer are copied. */ function BrotliBitReader(input) {
    this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
    this.input_ = input; /* input callback */ 
    this.reset();
}
BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;
BrotliBitReader.prototype.reset = function() {
    this.buf_ptr_ = 0; /* next input will write here */ 
    this.val_ = 0; /* pre-fetched bits */ 
    this.pos_ = 0; /* byte position in stream */ 
    this.bit_pos_ = 0; /* current bit-reading position in val_ */ 
    this.bit_end_pos_ = 0; /* bit-reading end position from LSB of val_ */ 
    this.eos_ = 0; /* input stream is finished */ 
    this.readMoreInput();
    for(var i = 0; i < 4; i++){
        this.val_ |= this.buf_[this.pos_] << 8 * i;
        ++this.pos_;
    }
    return this.bit_end_pos_ > 0;
};
/* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/ BrotliBitReader.prototype.readMoreInput = function() {
    if (this.bit_end_pos_ > 256) return;
    else if (this.eos_) {
        if (this.bit_pos_ > this.bit_end_pos_) throw new Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
    } else {
        var dst = this.buf_ptr_;
        var bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
        if (bytes_read < 0) throw new Error("Unexpected end of input");
        if (bytes_read < BROTLI_READ_SIZE) {
            this.eos_ = 1;
            /* Store 32 bytes of zero after the stream end. */ for(var p = 0; p < 32; p++)this.buf_[dst + bytes_read + p] = 0;
        }
        if (dst === 0) {
            /* Copy the head of the ringbuffer to the slack region. */ for(var p = 0; p < 32; p++)this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
            this.buf_ptr_ = BROTLI_READ_SIZE;
        } else this.buf_ptr_ = 0;
        this.bit_end_pos_ += bytes_read << 3;
    }
};
/* Guarantees that there are at least 24 bits in the buffer. */ BrotliBitReader.prototype.fillBitWindow = function() {
    while(this.bit_pos_ >= 8){
        this.val_ >>>= 8;
        this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
        ++this.pos_;
        this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
        this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
    }
};
/* Reads the specified number of bits from Read Buffer. */ BrotliBitReader.prototype.readBits = function(n_bits) {
    if (32 - this.bit_pos_ < n_bits) this.fillBitWindow();
    var val = this.val_ >>> this.bit_pos_ & kBitMask[n_bits];
    this.bit_pos_ += n_bits;
    return val;
};
module.exports = BrotliBitReader;

},{}],"lcZVj":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Collection of static dictionary words.
*/ var data = require("cc4e303e4d9de88b");
exports.init = function() {
    exports.dictionary = data.init();
};
exports.offsetsByLength = new Uint32Array([
    0,
    0,
    0,
    0,
    0,
    4096,
    9216,
    21504,
    35840,
    44032,
    53248,
    63488,
    74752,
    87040,
    93696,
    100864,
    104704,
    106752,
    108928,
    113536,
    115968,
    118528,
    119872,
    121280,
    122016
]);
exports.sizeBitsByLength = new Uint8Array([
    0,
    0,
    0,
    0,
    10,
    10,
    11,
    11,
    10,
    10,
    10,
    10,
    10,
    9,
    9,
    8,
    7,
    7,
    8,
    7,
    7,
    6,
    6,
    5,
    5
]);
exports.minDictionaryWordLength = 4;
exports.maxDictionaryWordLength = 24;

},{"cc4e303e4d9de88b":"c1bau"}],"c1bau":[function(require,module,exports) {
var base64 = require("ca5b90775bbb49d4");
/**
 * The normal dictionary-data.js is quite large, which makes it 
 * unsuitable for browser usage. In order to make it smaller, 
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses 
 * it's own dictionary. 😜
 */ exports.init = function() {
    var BrotliDecompressBuffer = require("88e0068b448e70dd").BrotliDecompressBuffer;
    var compressed = base64.toByteArray(require("5f847a6a03eeb1d8"));
    return BrotliDecompressBuffer(compressed);
};

},{"ca5b90775bbb49d4":"35I7g","88e0068b448e70dd":"bUqLP","5f847a6a03eeb1d8":"gGiYL"}],"35I7g":[function(require,module,exports) {
"use strict";
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

},{}],"gGiYL":[function(require,module,exports) {
module.exports = "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";

},{}],"d9I69":[function(require,module,exports) {
function HuffmanCode(bits, value) {
    this.bits = bits; /* number of bits used for this symbol */ 
    this.value = value; /* symbol value or table offset */ 
}
exports.HuffmanCode = HuffmanCode;
var MAX_LENGTH = 15;
/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */ function GetNextKey(key, len) {
    var step = 1 << len - 1;
    while(key & step)step >>= 1;
    return (key & step - 1) + step;
}
/* Stores code in table[0], table[step], table[2*step], ..., table[end] */ /* Assumes that end is an integer multiple of step */ function ReplicateValue(table, i, step, end, code) {
    do {
        end -= step;
        table[i + end] = new HuffmanCode(code.bits, code.value);
    }while (end > 0);
}
/* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */ function NextTableBitSize(count, len, root_bits) {
    var left = 1 << len - root_bits;
    while(len < MAX_LENGTH){
        left -= count[len];
        if (left <= 0) break;
        ++len;
        left <<= 1;
    }
    return len - root_bits;
}
exports.BrotliBuildHuffmanTable = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
    var start_table = table;
    var code; /* current table entry */ 
    var len; /* current code length */ 
    var symbol; /* symbol index in original or sorted table */ 
    var key; /* reversed prefix code */ 
    var step; /* step size to replicate values in current table */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low bits */ 
    var table_bits; /* key length of current table */ 
    var table_size; /* size of current table */ 
    var total_size; /* sum of root table size and 2nd level table sizes */ 
    var sorted; /* symbols sorted by code length */ 
    var count = new Int32Array(MAX_LENGTH + 1); /* number of codes of each length */ 
    var offset = new Int32Array(MAX_LENGTH + 1); /* offsets in sorted table for each length */ 
    sorted = new Int32Array(code_lengths_size);
    /* build histogram of code lengths */ for(symbol = 0; symbol < code_lengths_size; symbol++)count[code_lengths[symbol]]++;
    /* generate offsets into sorted symbol table by code length */ offset[1] = 0;
    for(len = 1; len < MAX_LENGTH; len++)offset[len + 1] = offset[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(symbol = 0; symbol < code_lengths_size; symbol++)if (code_lengths[symbol] !== 0) sorted[offset[code_lengths[symbol]]++] = symbol;
    table_bits = root_bits;
    table_size = 1 << table_bits;
    total_size = table_size;
    /* special case code with only one value */ if (offset[MAX_LENGTH] === 1) {
        for(key = 0; key < total_size; ++key)root_table[table + key] = new HuffmanCode(0, sorted[0] & 0xffff);
        return total_size;
    }
    /* fill in root table */ key = 0;
    symbol = 0;
    for(len = 1, step = 2; len <= root_bits; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
        ReplicateValue(root_table, table + key, step, table_size, code);
        key = GetNextKey(key, len);
    }
    /* fill in 2nd level tables and add pointers to root table */ mask = total_size - 1;
    low = -1;
    for(len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        if ((key & mask) !== low) {
            table += table_size;
            table_bits = NextTableBitSize(count, len, root_bits);
            table_size = 1 << table_bits;
            total_size += table_size;
            low = key & mask;
            root_table[start_table + low] = new HuffmanCode(table_bits + root_bits & 0xff, table - start_table - low & 0xffff);
        }
        code = new HuffmanCode(len - root_bits & 0xff, sorted[symbol++] & 0xffff);
        ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
        key = GetNextKey(key, len);
    }
    return total_size;
};

},{}],"6Kx61":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/ var CONTEXT_LSB6 = 0;
var CONTEXT_MSB6 = 1;
var CONTEXT_UTF8 = 2;
var CONTEXT_SIGNED = 3;
/* Common context lookup table for all context modes. */ exports.lookup = new Uint8Array([
    /* CONTEXT_UTF8, last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    4,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    8,
    12,
    16,
    12,
    12,
    20,
    12,
    16,
    24,
    28,
    12,
    12,
    32,
    12,
    36,
    12,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    32,
    32,
    24,
    40,
    28,
    12,
    12,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    24,
    12,
    28,
    12,
    12,
    12,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    24,
    12,
    28,
    12,
    0,
    /* UTF8 continuation byte range. */ 0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    /* UTF8 lead byte range. */ 2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    /* CONTEXT_UTF8 second last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    0,
    /* UTF8 continuation byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    /* UTF8 lead byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    /* CONTEXT_SIGNED, second last byte. */ 0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */ 0,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    56,
    /* CONTEXT_LSB6, last byte. */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    /* CONTEXT_MSB6, last byte. */ 0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    30,
    30,
    30,
    30,
    31,
    31,
    31,
    31,
    32,
    32,
    32,
    32,
    33,
    33,
    33,
    33,
    34,
    34,
    34,
    34,
    35,
    35,
    35,
    35,
    36,
    36,
    36,
    36,
    37,
    37,
    37,
    37,
    38,
    38,
    38,
    38,
    39,
    39,
    39,
    39,
    40,
    40,
    40,
    40,
    41,
    41,
    41,
    41,
    42,
    42,
    42,
    42,
    43,
    43,
    43,
    43,
    44,
    44,
    44,
    44,
    45,
    45,
    45,
    45,
    46,
    46,
    46,
    46,
    47,
    47,
    47,
    47,
    48,
    48,
    48,
    48,
    49,
    49,
    49,
    49,
    50,
    50,
    50,
    50,
    51,
    51,
    51,
    51,
    52,
    52,
    52,
    52,
    53,
    53,
    53,
    53,
    54,
    54,
    54,
    54,
    55,
    55,
    55,
    55,
    56,
    56,
    56,
    56,
    57,
    57,
    57,
    57,
    58,
    58,
    58,
    58,
    59,
    59,
    59,
    59,
    60,
    60,
    60,
    60,
    61,
    61,
    61,
    61,
    62,
    62,
    62,
    62,
    63,
    63,
    63,
    63,
    /* CONTEXT_{M,L}SB6, second last byte, */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]);
exports.lookupOffsets = new Uint16Array([
    /* CONTEXT_LSB6 */ 1024,
    1536,
    /* CONTEXT_MSB6 */ 1280,
    1536,
    /* CONTEXT_UTF8 */ 0,
    256,
    /* CONTEXT_SIGNED */ 768,
    512
]);

},{}],"j5bwT":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/ /* Represents the range of values belonging to a prefix code: */ /* [offset, offset + 2^nbits) */ function PrefixCodeRange(offset, nbits) {
    this.offset = offset;
    this.nbits = nbits;
}
exports.kBlockLengthPrefixCode = [
    new PrefixCodeRange(1, 2),
    new PrefixCodeRange(5, 2),
    new PrefixCodeRange(9, 2),
    new PrefixCodeRange(13, 2),
    new PrefixCodeRange(17, 3),
    new PrefixCodeRange(25, 3),
    new PrefixCodeRange(33, 3),
    new PrefixCodeRange(41, 3),
    new PrefixCodeRange(49, 4),
    new PrefixCodeRange(65, 4),
    new PrefixCodeRange(81, 4),
    new PrefixCodeRange(97, 4),
    new PrefixCodeRange(113, 5),
    new PrefixCodeRange(145, 5),
    new PrefixCodeRange(177, 5),
    new PrefixCodeRange(209, 5),
    new PrefixCodeRange(241, 6),
    new PrefixCodeRange(305, 6),
    new PrefixCodeRange(369, 7),
    new PrefixCodeRange(497, 8),
    new PrefixCodeRange(753, 9),
    new PrefixCodeRange(1265, 10),
    new PrefixCodeRange(2289, 11),
    new PrefixCodeRange(4337, 12),
    new PrefixCodeRange(8433, 13),
    new PrefixCodeRange(16625, 24)
];
exports.kInsertLengthPrefixCode = [
    new PrefixCodeRange(0, 0),
    new PrefixCodeRange(1, 0),
    new PrefixCodeRange(2, 0),
    new PrefixCodeRange(3, 0),
    new PrefixCodeRange(4, 0),
    new PrefixCodeRange(5, 0),
    new PrefixCodeRange(6, 1),
    new PrefixCodeRange(8, 1),
    new PrefixCodeRange(10, 2),
    new PrefixCodeRange(14, 2),
    new PrefixCodeRange(18, 3),
    new PrefixCodeRange(26, 3),
    new PrefixCodeRange(34, 4),
    new PrefixCodeRange(50, 4),
    new PrefixCodeRange(66, 5),
    new PrefixCodeRange(98, 5),
    new PrefixCodeRange(130, 6),
    new PrefixCodeRange(194, 7),
    new PrefixCodeRange(322, 8),
    new PrefixCodeRange(578, 9),
    new PrefixCodeRange(1090, 10),
    new PrefixCodeRange(2114, 12),
    new PrefixCodeRange(6210, 14),
    new PrefixCodeRange(22594, 24)
];
exports.kCopyLengthPrefixCode = [
    new PrefixCodeRange(2, 0),
    new PrefixCodeRange(3, 0),
    new PrefixCodeRange(4, 0),
    new PrefixCodeRange(5, 0),
    new PrefixCodeRange(6, 0),
    new PrefixCodeRange(7, 0),
    new PrefixCodeRange(8, 0),
    new PrefixCodeRange(9, 0),
    new PrefixCodeRange(10, 1),
    new PrefixCodeRange(12, 1),
    new PrefixCodeRange(14, 2),
    new PrefixCodeRange(18, 2),
    new PrefixCodeRange(22, 3),
    new PrefixCodeRange(30, 3),
    new PrefixCodeRange(38, 4),
    new PrefixCodeRange(54, 4),
    new PrefixCodeRange(70, 5),
    new PrefixCodeRange(102, 5),
    new PrefixCodeRange(134, 6),
    new PrefixCodeRange(198, 7),
    new PrefixCodeRange(326, 8),
    new PrefixCodeRange(582, 9),
    new PrefixCodeRange(1094, 10),
    new PrefixCodeRange(2118, 24)
];
exports.kInsertRangeLut = [
    0,
    0,
    8,
    8,
    0,
    16,
    8,
    16,
    16
];
exports.kCopyRangeLut = [
    0,
    8,
    0,
    8,
    16,
    0,
    16,
    8,
    16
];

},{}],"ciQhd":[function(require,module,exports) {
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/ var BrotliDictionary = require("45d18961111db3ce");
var kIdentity = 0;
var kOmitLast1 = 1;
var kOmitLast2 = 2;
var kOmitLast3 = 3;
var kOmitLast4 = 4;
var kOmitLast5 = 5;
var kOmitLast6 = 6;
var kOmitLast7 = 7;
var kOmitLast8 = 8;
var kOmitLast9 = 9;
var kUppercaseFirst = 10;
var kUppercaseAll = 11;
var kOmitFirst1 = 12;
var kOmitFirst2 = 13;
var kOmitFirst3 = 14;
var kOmitFirst4 = 15;
var kOmitFirst5 = 16;
var kOmitFirst6 = 17;
var kOmitFirst7 = 18;
var kOmitFirst8 = 19;
var kOmitFirst9 = 20;
function Transform(prefix, transform, suffix) {
    this.prefix = new Uint8Array(prefix.length);
    this.transform = transform;
    this.suffix = new Uint8Array(suffix.length);
    for(var i = 0; i < prefix.length; i++)this.prefix[i] = prefix.charCodeAt(i);
    for(var i = 0; i < suffix.length; i++)this.suffix[i] = suffix.charCodeAt(i);
}
var kTransforms = [
    new Transform("", kIdentity, ""),
    new Transform("", kIdentity, " "),
    new Transform(" ", kIdentity, " "),
    new Transform("", kOmitFirst1, ""),
    new Transform("", kUppercaseFirst, " "),
    new Transform("", kIdentity, " the "),
    new Transform(" ", kIdentity, ""),
    new Transform("s ", kIdentity, " "),
    new Transform("", kIdentity, " of "),
    new Transform("", kUppercaseFirst, ""),
    new Transform("", kIdentity, " and "),
    new Transform("", kOmitFirst2, ""),
    new Transform("", kOmitLast1, ""),
    new Transform(", ", kIdentity, " "),
    new Transform("", kIdentity, ", "),
    new Transform(" ", kUppercaseFirst, " "),
    new Transform("", kIdentity, " in "),
    new Transform("", kIdentity, " to "),
    new Transform("e ", kIdentity, " "),
    new Transform("", kIdentity, '"'),
    new Transform("", kIdentity, "."),
    new Transform("", kIdentity, '">'),
    new Transform("", kIdentity, "\n"),
    new Transform("", kOmitLast3, ""),
    new Transform("", kIdentity, "]"),
    new Transform("", kIdentity, " for "),
    new Transform("", kOmitFirst3, ""),
    new Transform("", kOmitLast2, ""),
    new Transform("", kIdentity, " a "),
    new Transform("", kIdentity, " that "),
    new Transform(" ", kUppercaseFirst, ""),
    new Transform("", kIdentity, ". "),
    new Transform(".", kIdentity, ""),
    new Transform(" ", kIdentity, ", "),
    new Transform("", kOmitFirst4, ""),
    new Transform("", kIdentity, " with "),
    new Transform("", kIdentity, "'"),
    new Transform("", kIdentity, " from "),
    new Transform("", kIdentity, " by "),
    new Transform("", kOmitFirst5, ""),
    new Transform("", kOmitFirst6, ""),
    new Transform(" the ", kIdentity, ""),
    new Transform("", kOmitLast4, ""),
    new Transform("", kIdentity, ". The "),
    new Transform("", kUppercaseAll, ""),
    new Transform("", kIdentity, " on "),
    new Transform("", kIdentity, " as "),
    new Transform("", kIdentity, " is "),
    new Transform("", kOmitLast7, ""),
    new Transform("", kOmitLast1, "ing "),
    new Transform("", kIdentity, "\n	"),
    new Transform("", kIdentity, ":"),
    new Transform(" ", kIdentity, ". "),
    new Transform("", kIdentity, "ed "),
    new Transform("", kOmitFirst9, ""),
    new Transform("", kOmitFirst7, ""),
    new Transform("", kOmitLast6, ""),
    new Transform("", kIdentity, "("),
    new Transform("", kUppercaseFirst, ", "),
    new Transform("", kOmitLast8, ""),
    new Transform("", kIdentity, " at "),
    new Transform("", kIdentity, "ly "),
    new Transform(" the ", kIdentity, " of "),
    new Transform("", kOmitLast5, ""),
    new Transform("", kOmitLast9, ""),
    new Transform(" ", kUppercaseFirst, ", "),
    new Transform("", kUppercaseFirst, '"'),
    new Transform(".", kIdentity, "("),
    new Transform("", kUppercaseAll, " "),
    new Transform("", kUppercaseFirst, '">'),
    new Transform("", kIdentity, '="'),
    new Transform(" ", kIdentity, "."),
    new Transform(".com/", kIdentity, ""),
    new Transform(" the ", kIdentity, " of the "),
    new Transform("", kUppercaseFirst, "'"),
    new Transform("", kIdentity, ". This "),
    new Transform("", kIdentity, ","),
    new Transform(".", kIdentity, " "),
    new Transform("", kUppercaseFirst, "("),
    new Transform("", kUppercaseFirst, "."),
    new Transform("", kIdentity, " not "),
    new Transform(" ", kIdentity, '="'),
    new Transform("", kIdentity, "er "),
    new Transform(" ", kUppercaseAll, " "),
    new Transform("", kIdentity, "al "),
    new Transform(" ", kUppercaseAll, ""),
    new Transform("", kIdentity, "='"),
    new Transform("", kUppercaseAll, '"'),
    new Transform("", kUppercaseFirst, ". "),
    new Transform(" ", kIdentity, "("),
    new Transform("", kIdentity, "ful "),
    new Transform(" ", kUppercaseFirst, ". "),
    new Transform("", kIdentity, "ive "),
    new Transform("", kIdentity, "less "),
    new Transform("", kUppercaseAll, "'"),
    new Transform("", kIdentity, "est "),
    new Transform(" ", kUppercaseFirst, "."),
    new Transform("", kUppercaseAll, '">'),
    new Transform(" ", kIdentity, "='"),
    new Transform("", kUppercaseFirst, ","),
    new Transform("", kIdentity, "ize "),
    new Transform("", kUppercaseAll, "."),
    new Transform("\xc2\xa0", kIdentity, ""),
    new Transform(" ", kIdentity, ","),
    new Transform("", kUppercaseFirst, '="'),
    new Transform("", kUppercaseAll, '="'),
    new Transform("", kIdentity, "ous "),
    new Transform("", kUppercaseAll, ", "),
    new Transform("", kUppercaseFirst, "='"),
    new Transform(" ", kUppercaseFirst, ","),
    new Transform(" ", kUppercaseAll, '="'),
    new Transform(" ", kUppercaseAll, ", "),
    new Transform("", kUppercaseAll, ","),
    new Transform("", kUppercaseAll, "("),
    new Transform("", kUppercaseAll, ". "),
    new Transform(" ", kUppercaseAll, "."),
    new Transform("", kUppercaseAll, "='"),
    new Transform(" ", kUppercaseAll, ". "),
    new Transform(" ", kUppercaseFirst, '="'),
    new Transform(" ", kUppercaseAll, "='"),
    new Transform(" ", kUppercaseFirst, "='")
];
exports.kTransforms = kTransforms;
exports.kNumTransforms = kTransforms.length;
function ToUpperCase(p, i) {
    if (p[i] < 0xc0) {
        if (p[i] >= 97 && p[i] <= 122) p[i] ^= 32;
        return 1;
    }
    /* An overly simplified uppercasing model for utf-8. */ if (p[i] < 0xe0) {
        p[i + 1] ^= 32;
        return 2;
    }
    /* An arbitrary transform for three byte characters. */ p[i + 2] ^= 5;
    return 3;
}
exports.transformDictionaryWord = function(dst, idx, word, len, transform) {
    var prefix = kTransforms[transform].prefix;
    var suffix = kTransforms[transform].suffix;
    var t = kTransforms[transform].transform;
    var skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
    var i = 0;
    var start_idx = idx;
    var uppercase;
    if (skip > len) skip = len;
    var prefix_pos = 0;
    while(prefix_pos < prefix.length)dst[idx++] = prefix[prefix_pos++];
    word += skip;
    len -= skip;
    if (t <= kOmitLast9) len -= t;
    for(i = 0; i < len; i++)dst[idx++] = BrotliDictionary.dictionary[word + i];
    uppercase = idx - len;
    if (t === kUppercaseFirst) ToUpperCase(dst, uppercase);
    else if (t === kUppercaseAll) while(len > 0){
        var step = ToUpperCase(dst, uppercase);
        uppercase += step;
        len -= step;
    }
    var suffix_pos = 0;
    while(suffix_pos < suffix.length)dst[idx++] = suffix[suffix_pos++];
    return idx - start_idx;
};

},{"45d18961111db3ce":"lcZVj"}],"iJ9h8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>render);
var _primitives = require("@react-pdf/primitives");
var _fns = require("@react-pdf/fns");
var _absSvgPath = require("abs-svg-path");
var _absSvgPathDefault = parcelHelpers.interopDefault(_absSvgPath);
var _parseSvgPath = require("parse-svg-path");
var _parseSvgPathDefault = parcelHelpers.interopDefault(_parseSvgPath);
var _normalizeSvgPath = require("normalize-svg-path");
var _normalizeSvgPathDefault = parcelHelpers.interopDefault(_normalizeSvgPath);
var _colorString = require("color-string");
var _colorStringDefault = parcelHelpers.interopDefault(_colorString);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var renderPath = function renderPath(ctx, node) {
    var _node$props;
    var d = (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.d;
    if (d) ctx.path(node.props.d);
};
var KAPPA$3 = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var renderRect = function renderRect(ctx, node) {
    var _node$props, _node$props2, _node$props3, _node$props4, _node$props5, _node$props6;
    var x = ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.x) || 0;
    var y = ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.y) || 0;
    var rx = ((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.rx) || 0;
    var ry = ((_node$props4 = node.props) === null || _node$props4 === void 0 ? void 0 : _node$props4.ry) || 0;
    var width = ((_node$props5 = node.props) === null || _node$props5 === void 0 ? void 0 : _node$props5.width) || 0;
    var height = ((_node$props6 = node.props) === null || _node$props6 === void 0 ? void 0 : _node$props6.height) || 0;
    if (!width || !height) return;
    if (rx && ry) {
        var krx = rx * KAPPA$3;
        var kry = ry * KAPPA$3;
        ctx.moveTo(x + rx, y);
        ctx.lineTo(x - rx + width, y);
        ctx.bezierCurveTo(x - rx + width + krx, y, x + width, y + ry - kry, x + width, y + ry);
        ctx.lineTo(x + width, y + height - ry);
        ctx.bezierCurveTo(x + width, y + height - ry + kry, x - rx + width + krx, y + height, x - rx + width, y + height);
        ctx.lineTo(x + rx, y + height);
        ctx.bezierCurveTo(x + rx - krx, y + height, x, y + height - ry + kry, x, y + height - ry);
        ctx.lineTo(x, y + ry);
        ctx.bezierCurveTo(x, y + ry - kry, x + rx - krx, y, x + rx, y);
    } else {
        ctx.moveTo(x, y);
        ctx.lineTo(x + width, y);
        ctx.lineTo(x + width, y + height);
        ctx.lineTo(x, y + height);
    }
    ctx.closePath();
};
var renderLine$1 = function renderLine(ctx, node) {
    var _ref = node.props || {}, x1 = _ref.x1, x2 = _ref.x2, y1 = _ref.y1, y2 = _ref.y2;
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
};
var renderGroup = function renderGroup() {
// noop
};
var KAPPA$2 = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var drawEllipse = function drawEllipse(ctx, cx, cy, rx, ry) {
    var x = cx - rx;
    var y = cy - ry;
    var ox = rx * KAPPA$2;
    var oy = ry * KAPPA$2;
    var xe = x + rx * 2;
    var ye = y + ry * 2;
    var xm = x + rx;
    var ym = y + ry;
    ctx.moveTo(x, ym);
    ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
    ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
    ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
    ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
    ctx.closePath();
};
var renderEllipse = function renderEllipse(ctx, node) {
    var _ref = node.props || {}, cx = _ref.cx, cy = _ref.cy, rx = _ref.rx, ry = _ref.ry;
    drawEllipse(ctx, cx, cy, rx, ry);
};
var renderCircle = function renderCircle(ctx, node) {
    var _node$props, _node$props2, _node$props3;
    var cx = (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.cx;
    var cy = (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.cy;
    var r = (_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.r;
    drawEllipse(ctx, cx, cy, r, r);
};
var renderGlyphs = function renderGlyphs(ctx, glyphs, positions, x, y, options) {
    if (options === void 0) options = {};
    var scale = 1000 / ctx._fontSize;
    var unitsPerEm = ctx._font.font.unitsPerEm || 1000;
    var advanceWidthScale = 1000 / unitsPerEm;
    // Glyph encoding and positioning
    var encodedGlyphs = ctx._font.encodeGlyphs(glyphs);
    var encodedPositions = positions.map(function(pos, i) {
        return {
            xAdvance: pos.xAdvance * scale,
            yAdvance: pos.yAdvance * scale,
            xOffset: pos.xOffset,
            yOffset: pos.yOffset,
            advanceWidth: glyphs[i].advanceWidth * advanceWidthScale
        };
    });
    return ctx._glyphs(encodedGlyphs, encodedPositions, x, y, options);
};
var renderRun$1 = function renderRun(ctx, run) {
    var runAdvanceWidth = run.xAdvance;
    var _run$attributes = run.attributes, font = _run$attributes.font, fontSize = _run$attributes.fontSize, color = _run$attributes.color, opacity = _run$attributes.opacity;
    ctx.fillColor(color);
    ctx.fillOpacity(opacity);
    if (font.sbix || font.COLR && font.CPAL) {
        ctx.save();
        ctx.translate(0, -run.ascent);
        for(var i = 0; i < run.glyphs.length; i += 1){
            var position = run.positions[i];
            var glyph = run.glyphs[i];
            ctx.save();
            ctx.translate(position.xOffset, position.yOffset);
            glyph.render(ctx, fontSize);
            ctx.restore();
            ctx.translate(position.xAdvance, position.yAdvance);
        }
        ctx.restore();
    } else {
        ctx.font(typeof font.name === "string" ? font.name : font, fontSize);
        try {
            renderGlyphs(ctx, run.glyphs, run.positions, 0, 0);
        } catch (error) {
            console.log(error);
        }
    }
    ctx.translate(runAdvanceWidth, 0);
};
var renderSpan = function renderSpan(ctx, line, textAnchor, dominantBaseline) {
    var _line$box, _line$box2, _line$runs$, _line$runs$2, _line$runs$2$attribut;
    ctx.save();
    var x = ((_line$box = line.box) === null || _line$box === void 0 ? void 0 : _line$box.x) || 0;
    var y = ((_line$box2 = line.box) === null || _line$box2 === void 0 ? void 0 : _line$box2.y) || 0;
    var font = (_line$runs$ = line.runs[0]) === null || _line$runs$ === void 0 ? void 0 : _line$runs$.attributes.font;
    var scale = ((_line$runs$2 = line.runs[0]) === null || _line$runs$2 === void 0 ? void 0 : (_line$runs$2$attribut = _line$runs$2.attributes) === null || _line$runs$2$attribut === void 0 ? void 0 : _line$runs$2$attribut.scale) || 1;
    var width = line.xAdvance;
    var ascent = font.ascent * scale;
    var xHeight = font.xHeight * scale;
    var descent = font.descent * scale;
    var capHeight = font.capHeight * scale;
    var xTranslate = x;
    var yTranslate = y;
    switch(textAnchor){
        case "middle":
            xTranslate = x - width / 2;
            break;
        case "end":
            xTranslate = x - width;
            break;
        default:
            xTranslate = x;
            break;
    }
    switch(dominantBaseline){
        case "middle":
        case "central":
            yTranslate = y + capHeight / 2;
            break;
        case "hanging":
            yTranslate = y + capHeight;
            break;
        case "mathematical":
            yTranslate = y + xHeight;
            break;
        case "text-after-edge":
            yTranslate = y + descent;
            break;
        case "text-before-edge":
            yTranslate = y + ascent;
            break;
        default:
            yTranslate = y;
            break;
    }
    ctx.translate(xTranslate, yTranslate);
    line.runs.forEach(function(run) {
        return renderRun$1(ctx, run);
    });
    ctx.restore();
};
var renderSvgText = function renderSvgText(ctx, node) {
    node.children.forEach(function(span) {
        return renderSpan(ctx, span.lines[0], span.props.textAnchor, span.props.dominantBaseline);
    });
};
var pairs = function pairs(values) {
    var result = [];
    for(var i = 0; i < values.length; i += 2)result.push([
        values[i],
        values[i + 1]
    ]);
    return result;
};
/**
 * Parse svg-like points into number arrays
 *
 * @param {String} points string ex. "20,30 50,60"
 * @return {Array} points array ex. [[20, 30], [50, 60]]
 */ var parsePoints = function parsePoints(points) {
    var values = (points || "").trim().replace(/,/g, " ").replace(/(\d)-(\d)/g, "$1 -$2").split(/\s+/);
    if (values.length % 2 !== 0) values = values.slice(0, -1);
    values = values.map(parseFloat);
    return pairs(values);
};
var drawPolyline = function drawPolyline(ctx, points) {
    if (points.length > 0) {
        ctx.moveTo(points[0][0], points[0][1]);
        points.slice(1).forEach(function(p) {
            return ctx.lineTo(p[0], p[1]);
        });
    }
};
var renderPolyline = function renderPolyline(ctx, node) {
    var points = parsePoints(node.props.points || "");
    drawPolyline(ctx, points);
};
var renderPolygon = function renderPolygon(ctx, node) {
    renderPolyline(ctx, node);
    ctx.closePath();
};
var renderImage$1 = function renderImage(ctx, node) {
    if (!node.image.data) return;
    var _node$props = node.props, x = _node$props.x, y = _node$props.y;
    var _node$style = node.style, width = _node$style.width, height = _node$style.height, opacity = _node$style.opacity;
    var paddingTop = node.box.paddingLeft || 0;
    var paddingLeft = node.box.paddingLeft || 0;
    if (width === 0 || height === 0) {
        console.warn("Image with src '" + node.props.href + "' skipped due to invalid dimensions");
        return;
    }
    ctx.save();
    ctx.fillOpacity(opacity || 1).image(node.image.data, x + paddingLeft, y + paddingTop, {
        width: width,
        height: height
    });
    ctx.restore();
};
// This constant is used to approximate a symmetrical arc using a cubic
// Bezier curve.
var KAPPA$1 = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var clipNode = function clipNode(ctx, node) {
    if (!node.style) return;
    var _node$box = node.box, top = _node$box.top, left = _node$box.left, width = _node$box.width, height = _node$box.height;
    var _node$style = node.style, _node$style$borderTop = _node$style.borderTopLeftRadius, borderTopLeftRadius = _node$style$borderTop === void 0 ? 0 : _node$style$borderTop, _node$style$borderTop2 = _node$style.borderTopRightRadius, borderTopRightRadius = _node$style$borderTop2 === void 0 ? 0 : _node$style$borderTop2, _node$style$borderBot = _node$style.borderBottomRightRadius, borderBottomRightRadius = _node$style$borderBot === void 0 ? 0 : _node$style$borderBot, _node$style$borderBot2 = _node$style.borderBottomLeftRadius, borderBottomLeftRadius = _node$style$borderBot2 === void 0 ? 0 : _node$style$borderBot2;
    // Border top
    var rtr = Math.min(borderTopRightRadius, 0.5 * width, 0.5 * height);
    var ctr = rtr * (1.0 - KAPPA$1);
    ctx.moveTo(left + rtr, top);
    ctx.lineTo(left + width - rtr, top);
    ctx.bezierCurveTo(left + width - ctr, top, left + width, top + ctr, left + width, top + rtr);
    // Border right
    var rbr = Math.min(borderBottomRightRadius, 0.5 * width, 0.5 * height);
    var cbr = rbr * (1.0 - KAPPA$1);
    ctx.lineTo(left + width, top + height - rbr);
    ctx.bezierCurveTo(left + width, top + height - cbr, left + width - cbr, top + height, left + width - rbr, top + height);
    // Border bottom
    var rbl = Math.min(borderBottomLeftRadius, 0.5 * width, 0.5 * height);
    var cbl = rbl * (1.0 - KAPPA$1);
    ctx.lineTo(left + rbl, top + height);
    ctx.bezierCurveTo(left + cbl, top + height, left, top + height - cbl, left, top + height - rbl);
    // Border left
    var rtl = Math.min(borderTopLeftRadius, 0.5 * width, 0.5 * height);
    var ctl = rtl * (1.0 - KAPPA$1);
    ctx.lineTo(left, top + rtl);
    ctx.bezierCurveTo(left, top + ctl, left + ctl, top, left + rtl, top);
    ctx.closePath();
    ctx.clip();
};
var applySingleTransformation = function applySingleTransformation(ctx, transform, origin) {
    var operation = transform.operation, value = transform.value;
    switch(operation){
        case "scale":
            var scaleX = value[0], scaleY = value[1];
            ctx.scale(scaleX, scaleY, {
                origin: origin
            });
            break;
        case "rotate":
            var angle = value[0];
            ctx.rotate(angle, {
                origin: origin
            });
            break;
        case "translate":
            var x = value[0], y = value[1];
            ctx.translate(x, y, {
                origin: origin
            });
            break;
        case "skew":
            var xAngle = value[0], yAngle = value[1];
            ctx.skew(xAngle, yAngle, {
                origin: origin
            });
            break;
        case "matrix":
            ctx.transform.apply(ctx, value);
            break;
        default:
            console.error("Transform operation: '" + operation + "' doesn't supported");
    }
};
var applyTransformations = function applyTransformations(ctx, node) {
    var _node$style, _node$props;
    if (!node.origin) return;
    var origin = [
        node.origin.left,
        node.origin.top
    ];
    var operations = ((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.transform) || ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.transform) || [];
    operations.forEach(function(operation) {
        applySingleTransformation(ctx, operation, origin);
    });
};
var _boundingBoxFns;
// From https://github.com/dy/svg-path-bounds/blob/master/index.js
var getPathBoundingBox = function getPathBoundingBox(node) {
    var _node$props;
    var path = (0, _normalizeSvgPathDefault.default)((0, _absSvgPathDefault.default)((0, _parseSvgPathDefault.default)(((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.d) || "")));
    if (!path.length) return [
        0,
        0,
        0,
        0
    ];
    var bounds = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    for(var i = 0, l = path.length; i < l; i += 1){
        var points = path[i].slice(1);
        for(var j = 0; j < points.length; j += 2){
            if (points[j + 0] < bounds[0]) bounds[0] = points[j + 0];
            if (points[j + 1] < bounds[1]) bounds[1] = points[j + 1];
            if (points[j + 0] > bounds[2]) bounds[2] = points[j + 0];
            if (points[j + 1] > bounds[3]) bounds[3] = points[j + 1];
        }
    }
    return bounds;
};
var getCircleBoundingBox = function getCircleBoundingBox(node) {
    var _node$props2, _node$props3, _node$props4;
    var r = ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.r) || 0;
    var cx = ((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.cx) || 0;
    var cy = ((_node$props4 = node.props) === null || _node$props4 === void 0 ? void 0 : _node$props4.cy) || 0;
    return [
        cx - r,
        cy - r,
        cx + r,
        cy + r
    ];
};
var getEllipseBoundingBox = function getEllipseBoundingBox(node) {
    var _node$props5, _node$props6, _node$props7, _node$props8;
    var cx = ((_node$props5 = node.props) === null || _node$props5 === void 0 ? void 0 : _node$props5.cx) || 0;
    var cy = ((_node$props6 = node.props) === null || _node$props6 === void 0 ? void 0 : _node$props6.cy) || 0;
    var rx = ((_node$props7 = node.props) === null || _node$props7 === void 0 ? void 0 : _node$props7.rx) || 0;
    var ry = ((_node$props8 = node.props) === null || _node$props8 === void 0 ? void 0 : _node$props8.ry) || 0;
    return [
        cx - rx,
        cy - ry,
        cx + rx,
        cy + ry
    ];
};
var getLineBoundingBox = function getLineBoundingBox(node) {
    var _node$props9, _node$props10, _node$props11, _node$props12;
    var x1 = ((_node$props9 = node.props) === null || _node$props9 === void 0 ? void 0 : _node$props9.x1) || 0;
    var y1 = ((_node$props10 = node.props) === null || _node$props10 === void 0 ? void 0 : _node$props10.y1) || 0;
    var x2 = ((_node$props11 = node.props) === null || _node$props11 === void 0 ? void 0 : _node$props11.x2) || 0;
    var y2 = ((_node$props12 = node.props) === null || _node$props12 === void 0 ? void 0 : _node$props12.y2) || 0;
    return [
        Math.min(x1, x2),
        Math.min(y1, y2),
        Math.max(x1, x2),
        Math.max(y1, y2)
    ];
};
var getRectBoundingBox = function getRectBoundingBox(node) {
    var _node$props13, _node$props14, _node$props15, _node$props16;
    var x = ((_node$props13 = node.props) === null || _node$props13 === void 0 ? void 0 : _node$props13.x) || 0;
    var y = ((_node$props14 = node.props) === null || _node$props14 === void 0 ? void 0 : _node$props14.y) || 0;
    var width = ((_node$props15 = node.props) === null || _node$props15 === void 0 ? void 0 : _node$props15.width) || 0;
    var height = ((_node$props16 = node.props) === null || _node$props16 === void 0 ? void 0 : _node$props16.height) || 0;
    return [
        x,
        y,
        x + width,
        y + height
    ];
};
var max = function max(values) {
    return Math.max.apply(Math, [
        -Infinity
    ].concat(values));
};
var min = function min(values) {
    return Math.min.apply(Math, [
        Infinity
    ].concat(values));
};
var getPolylineBoundingBox = function getPolylineBoundingBox(node) {
    var _node$props17;
    var points = parsePoints(((_node$props17 = node.props) === null || _node$props17 === void 0 ? void 0 : _node$props17.points) || []);
    var xValues = points.map(function(p) {
        return p[0];
    });
    var yValues = points.map(function(p) {
        return p[1];
    });
    return [
        min(xValues),
        min(yValues),
        max(xValues),
        max(yValues)
    ];
};
var boundingBoxFns = (_boundingBoxFns = {}, _boundingBoxFns[_primitives.Rect] = getRectBoundingBox, _boundingBoxFns[_primitives.Line] = getLineBoundingBox, _boundingBoxFns[_primitives.Path] = getPathBoundingBox, _boundingBoxFns[_primitives.Circle] = getCircleBoundingBox, _boundingBoxFns[_primitives.Ellipse] = getEllipseBoundingBox, _boundingBoxFns[_primitives.Polygon] = getPolylineBoundingBox, _boundingBoxFns[_primitives.Polyline] = getPolylineBoundingBox, _boundingBoxFns);
var getBoundingBox = function getBoundingBox(node) {
    var boundingBoxFn = boundingBoxFns[node.type];
    return boundingBoxFn ? boundingBoxFn(node) : [
        0,
        0,
        0,
        0
    ];
};
var _renderFns$1;
var setStrokeWidth = function setStrokeWidth(ctx, node) {
    var _node$props;
    var lineWidth = ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.strokeWidth) || 0;
    if (lineWidth) ctx.lineWidth(lineWidth);
};
var setStrokeColor = function setStrokeColor(ctx, node) {
    var _node$props2;
    var strokeColor = ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.stroke) || null;
    if (strokeColor) ctx.strokeColor(strokeColor);
};
var setOpacity = function setOpacity(ctx, node) {
    var _node$props3;
    var opacity = ((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.opacity) || null;
    if (!(0, _fns.isNil)(opacity)) ctx.opacity(opacity);
};
var setFillOpacity = function setFillOpacity(ctx, node) {
    var _node$props4;
    var fillOpacity = ((_node$props4 = node.props) === null || _node$props4 === void 0 ? void 0 : _node$props4.fillOpacity) || null;
    if (!(0, _fns.isNil)(fillOpacity)) ctx.fillOpacity(fillOpacity);
};
var setStrokeOpacity = function setStrokeOpacity(ctx, node) {
    var _node$props5;
    var strokeOpacity = ((_node$props5 = node.props) === null || _node$props5 === void 0 ? void 0 : _node$props5.strokeOpacity) || null;
    if (!(0, _fns.isNil)(strokeOpacity)) ctx.strokeOpacity(strokeOpacity);
};
var setLineJoin = function setLineJoin(ctx, node) {
    var _node$props6;
    var lineJoin = ((_node$props6 = node.props) === null || _node$props6 === void 0 ? void 0 : _node$props6.strokeLinejoin) || null;
    if (lineJoin) ctx.lineJoin(lineJoin);
};
var setLineCap = function setLineCap(ctx, node) {
    var _node$props7;
    var lineCap = ((_node$props7 = node.props) === null || _node$props7 === void 0 ? void 0 : _node$props7.strokeLinecap) || null;
    if (lineCap) ctx.lineCap(lineCap);
};
var setLineDash = function setLineDash(ctx, node) {
    var _node$props8;
    var value = ((_node$props8 = node.props) === null || _node$props8 === void 0 ? void 0 : _node$props8.strokeDasharray) || null;
    if (value) ctx.dash(value.split(","));
};
var hasLinearGradientFill = function hasLinearGradientFill(node) {
    var _node$props9, _node$props9$fill;
    return ((_node$props9 = node.props) === null || _node$props9 === void 0 ? void 0 : (_node$props9$fill = _node$props9.fill) === null || _node$props9$fill === void 0 ? void 0 : _node$props9$fill.type) === _primitives.LinearGradient;
};
var hasRadialGradientFill = function hasRadialGradientFill(node) {
    var _node$props10, _node$props10$fill;
    return ((_node$props10 = node.props) === null || _node$props10 === void 0 ? void 0 : (_node$props10$fill = _node$props10.fill) === null || _node$props10$fill === void 0 ? void 0 : _node$props10$fill.type) === _primitives.RadialGradient;
};
// Math simplified from https://github.com/devongovett/svgkit/blob/master/src/elements/SVGGradient.js#L104
var setLinearGradientFill = function setLinearGradientFill(ctx, node) {
    var _node$props11;
    var bbox = getBoundingBox(node);
    var gradient = ((_node$props11 = node.props) === null || _node$props11 === void 0 ? void 0 : _node$props11.fill) || null;
    var x1 = gradient.props.x1 || 0;
    var y1 = gradient.props.y1 || 0;
    var x2 = gradient.props.x2 || 1;
    var y2 = gradient.props.y2 || 0;
    var m0 = bbox[2] - bbox[0];
    var m3 = bbox[3] - bbox[1];
    var m4 = bbox[0];
    var m5 = bbox[1];
    var gx1 = m0 * x1 + m4;
    var gy1 = m3 * y1 + m5;
    var gx2 = m0 * x2 + m4;
    var gy2 = m3 * y2 + m5;
    var grad = ctx.linearGradient(gx1, gy1, gx2, gy2);
    gradient.children.forEach(function(stop) {
        grad.stop(stop.props.offset, stop.props.stopColor, stop.props.stopOpacity);
    });
    ctx.fill(grad);
};
// Math simplified from https://github.com/devongovett/svgkit/blob/master/src/elements/SVGGradient.js#L155
var setRadialGradientFill = function setRadialGradientFill(ctx, node) {
    var _node$props12;
    var bbox = getBoundingBox(node);
    var gradient = ((_node$props12 = node.props) === null || _node$props12 === void 0 ? void 0 : _node$props12.fill) || null;
    var cx = gradient.props.cx || 0.5;
    var cy = gradient.props.cy || 0.5;
    var fx = gradient.props.fx || cx;
    var fy = gradient.props.fy || cy;
    var r = gradient.props.r || 0.5;
    var m0 = bbox[2] - bbox[0];
    var m3 = bbox[3] - bbox[1];
    var m4 = bbox[0];
    var m5 = bbox[1];
    var gr = r * m0;
    var gcx = m0 * cx + m4;
    var gcy = m3 * cy + m5;
    var gfx = m0 * fx + m4;
    var gfy = m3 * fy + m5;
    var grad = ctx.radialGradient(gfx, gfy, 0, gcx, gcy, gr);
    gradient.children.forEach(function(stop) {
        grad.stop(stop.props.offset, stop.props.stopColor, stop.props.stopOpacity);
    });
    ctx.fill(grad);
};
var setFillColor = function setFillColor(ctx, node) {
    var _node$props13;
    var fillColor = ((_node$props13 = node.props) === null || _node$props13 === void 0 ? void 0 : _node$props13.fill) || null;
    if (fillColor) ctx.fillColor(fillColor);
};
var setFill = function setFill(ctx, node) {
    if (hasLinearGradientFill(node)) return setLinearGradientFill(ctx, node);
    if (hasRadialGradientFill(node)) return setRadialGradientFill(ctx, node);
    return setFillColor(ctx, node);
};
var draw = function draw(ctx, node) {
    var props = node.props || {};
    if (props.fill && props.stroke) ctx.fillAndStroke(props.fillRule);
    else if (props.fill) ctx.fill(props.fillRule);
    else if (props.stroke) ctx.stroke();
    else {
        ctx.save();
        ctx.opacity(0);
        ctx.fill(null);
        ctx.restore();
    }
};
var noop = function noop() {};
var renderFns$1 = (_renderFns$1 = {}, _renderFns$1[_primitives.Tspan] = noop, _renderFns$1[_primitives.TextInstance] = noop, _renderFns$1[_primitives.Path] = renderPath, _renderFns$1[_primitives.Rect] = renderRect, _renderFns$1[_primitives.Line] = renderLine$1, _renderFns$1[_primitives.G] = renderGroup, _renderFns$1[_primitives.Text] = renderSvgText, _renderFns$1[_primitives.Circle] = renderCircle, _renderFns$1[_primitives.Image] = renderImage$1, _renderFns$1[_primitives.Ellipse] = renderEllipse, _renderFns$1[_primitives.Polygon] = renderPolygon, _renderFns$1[_primitives.Polyline] = renderPolyline, _renderFns$1);
var renderNode$1 = function renderNode(ctx, node) {
    var renderFn = renderFns$1[node.type];
    if (renderFns$1) renderFn(ctx, node);
    else console.warn("SVG node of type " + node.type + " is not currenty supported");
};
var drawNode = function drawNode(ctx, node) {
    setLineCap(ctx, node);
    setLineDash(ctx, node);
    setLineJoin(ctx, node);
    setStrokeWidth(ctx, node);
    setStrokeColor(ctx, node);
    setFill(ctx, node);
    setStrokeOpacity(ctx, node);
    setFillOpacity(ctx, node);
    setOpacity(ctx, node);
    applyTransformations(ctx, node);
    renderNode$1(ctx, node);
    draw(ctx, node);
};
var clipPath = function clipPath(ctx, node) {
    var _node$props14;
    var value = (_node$props14 = node.props) === null || _node$props14 === void 0 ? void 0 : _node$props14.clipPath;
    if (value) {
        var children = value.children || [];
        children.forEach(function(child) {
            return renderNode$1(ctx, child);
        });
        ctx.clip();
    }
};
var drawChildren = function drawChildren(ctx, node) {
    var children = node.children || [];
    children.forEach(function(child) {
        ctx.save();
        clipPath(ctx, child);
        drawNode(ctx, child);
        drawChildren(ctx, child);
        ctx.restore();
    });
};
var resolveAspectRatio = function resolveAspectRatio(ctx, node) {
    var _node$box = node.box, width = _node$box.width, height = _node$box.height;
    var _node$props15 = node.props, viewBox = _node$props15.viewBox, _node$props15$preserv = _node$props15.preserveAspectRatio, preserveAspectRatio = _node$props15$preserv === void 0 ? {} : _node$props15$preserv;
    var _preserveAspectRatio$ = preserveAspectRatio.meetOrSlice, meetOrSlice = _preserveAspectRatio$ === void 0 ? "meet" : _preserveAspectRatio$, _preserveAspectRatio$2 = preserveAspectRatio.align, align = _preserveAspectRatio$2 === void 0 ? "xMidYMid" : _preserveAspectRatio$2;
    if (viewBox == null || width == null || height == null) return;
    var x = (viewBox === null || viewBox === void 0 ? void 0 : viewBox.minX) || 0;
    var y = (viewBox === null || viewBox === void 0 ? void 0 : viewBox.minY) || 0;
    var logicalWidth = (viewBox === null || viewBox === void 0 ? void 0 : viewBox.maxX) || width;
    var logicalHeight = (viewBox === null || viewBox === void 0 ? void 0 : viewBox.maxY) || height;
    var logicalRatio = logicalWidth / logicalHeight;
    var physicalRatio = width / height;
    var scaleX = width / logicalWidth;
    var scaleY = height / logicalHeight;
    if (align === "none") {
        ctx.scale(scaleX, scaleY);
        ctx.translate(-x, -y);
        return;
    }
    if (logicalRatio < physicalRatio && meetOrSlice === "meet" || logicalRatio >= physicalRatio && meetOrSlice === "slice") {
        ctx.scale(scaleY, scaleY);
        switch(align){
            case "xMinYMin":
            case "xMinYMid":
            case "xMinYMax":
                ctx.translate(-x, -y);
                break;
            case "xMidYMin":
            case "xMidYMid":
            case "xMidYMax":
                ctx.translate(-x - (logicalWidth - width * logicalHeight / height) / 2, -y);
                break;
            default:
                ctx.translate(-x - (logicalWidth - width * logicalHeight / height), -y);
        }
    } else {
        ctx.scale(scaleX, scaleX);
        switch(align){
            case "xMinYMin":
            case "xMidYMin":
            case "xMaxYMin":
                ctx.translate(-x, -y);
                break;
            case "xMinYMid":
            case "xMidYMid":
            case "xMaxYMid":
                ctx.translate(-x, -y - (logicalHeight - height * logicalWidth / width) / 2);
                break;
            default:
                ctx.translate(-x, -y - (logicalHeight - height * logicalWidth / width));
        }
    }
};
var moveToOrigin = function moveToOrigin(ctx, node) {
    var _node$box2 = node.box, top = _node$box2.top, left = _node$box2.left;
    var paddingLeft = node.box.paddingLeft || 0;
    var paddingTop = node.box.paddingTop || 0;
    ctx.translate(left + paddingLeft, top + paddingTop);
};
var renderSvg = function renderSvg(ctx, node) {
    ctx.save();
    clipNode(ctx, node);
    moveToOrigin(ctx, node);
    resolveAspectRatio(ctx, node);
    drawChildren(ctx, node);
    ctx.restore();
};
var parseColor = function parseColor(hex) {
    var parsed = (0, _colorStringDefault.default).get(hex);
    var value = (0, _colorStringDefault.default).to.hex(parsed.value.slice(0, 3));
    var opacity = parsed.value[3];
    return {
        value: value,
        opacity: opacity
    };
};
/* eslint-disable no-param-reassign */ var DEST_REGEXP = /^#.+/;
var isSrcId$1 = function isSrcId(src) {
    return src.match(DEST_REGEXP);
};
var renderAttachment = function renderAttachment(ctx, attachment) {
    var _attachment$xOffset = attachment.xOffset, xOffset = _attachment$xOffset === void 0 ? 0 : _attachment$xOffset, _attachment$yOffset = attachment.yOffset, yOffset = _attachment$yOffset === void 0 ? 0 : _attachment$yOffset, width = attachment.width, height = attachment.height, image = attachment.image;
    ctx.translate(-width + xOffset, -height + yOffset);
    ctx.image(image, 0, 0, {
        fit: [
            width,
            height
        ],
        align: "center",
        valign: "bottom"
    });
};
var renderAttachments = function renderAttachments(ctx, run) {
    ctx.save();
    var font = run.attributes.font;
    var space = font.glyphForCodePoint(0x20);
    var objectReplacement = font.glyphForCodePoint(0xfffc);
    var attachmentAdvance = 0;
    for(var i = 0; i < run.glyphs.length; i += 1){
        var position = run.positions[i];
        var glyph = run.glyphs[i];
        attachmentAdvance += position.xAdvance || 0;
        if (glyph.id === objectReplacement.id && run.attributes.attachment) {
            ctx.translate(attachmentAdvance, position.yOffset || 0);
            renderAttachment(ctx, run.attributes.attachment);
            run.glyphs[i] = space;
            attachmentAdvance = 0;
        }
    }
    ctx.restore();
};
var renderRun = function renderRun(ctx, run, options) {
    var _run$attributes = run.attributes, font = _run$attributes.font, fontSize = _run$attributes.fontSize, link = _run$attributes.link;
    var color = parseColor(run.attributes.color);
    var opacity = (0, _fns.isNil)(run.attributes.opacity) ? color.opacity : run.attributes.opacity;
    var height = run.height, descent = run.descent, xAdvance = run.xAdvance;
    if (options.outlineRuns) ctx.rect(0, -height, xAdvance, height).stroke();
    ctx.fillColor(color.value);
    ctx.fillOpacity(opacity);
    if (link) {
        if (isSrcId$1(link)) ctx.goTo(0, -height - descent, xAdvance, height, link.slice(1));
        else ctx.link(0, -height - descent, xAdvance, height, link);
    }
    renderAttachments(ctx, run);
    if (font.sbix || font.COLR && font.CPAL) {
        ctx.save();
        ctx.translate(0, -run.ascent);
        for(var i = 0; i < run.glyphs.length; i += 1){
            var position = run.positions[i];
            var glyph = run.glyphs[i];
            ctx.save();
            ctx.translate(position.xOffset, position.yOffset);
            glyph.render(ctx, fontSize);
            ctx.restore();
            ctx.translate(position.xAdvance, position.yAdvance);
        }
        ctx.restore();
    } else {
        ctx.font(typeof font.name === "string" ? font.name : font, fontSize);
        try {
            renderGlyphs(ctx, run.glyphs, run.positions, 0, 0);
        } catch (error) {
            console.log(error);
        }
    }
    ctx.translate(xAdvance, 0);
};
var renderBackground$1 = function renderBackground(ctx, rect, backgroundColor) {
    var color = parseColor(backgroundColor);
    ctx.save();
    ctx.fillOpacity(color.opacity);
    ctx.rect(rect.x, rect.y, rect.width, rect.height);
    ctx.fill(color.value);
    ctx.restore();
};
var renderDecorationLine = function renderDecorationLine(ctx, line) {
    ctx.save();
    ctx.lineWidth(line.rect.height);
    ctx.strokeOpacity(line.opacity);
    if (/dashed/.test(line.style)) ctx.dash(3 * line.rect.height);
    else if (/dotted/.test(line.style)) ctx.dash(line.rect.height);
    if (/wavy/.test(line.style)) {
        var dist = Math.max(2, line.rect.height);
        var step = 1.1 * dist;
        var stepCount = Math.floor(line.rect.width / (2 * step));
        // Adjust step to fill entire width
        var remainingWidth = line.rect.width - stepCount * 2 * step;
        var adjustment = remainingWidth / stepCount / 2;
        step += adjustment;
        var cp1y = line.rect.y + dist;
        var cp2y = line.rect.y - dist;
        var x = line.rect.x;
        ctx.moveTo(line.rect.x, line.rect.y);
        for(var i = 0; i < stepCount; i += 1){
            ctx.bezierCurveTo(x + step, cp1y, x + step, cp2y, x + 2 * step, line.rect.y);
            x += 2 * step;
        }
    } else {
        ctx.moveTo(line.rect.x, line.rect.y);
        ctx.lineTo(line.rect.x + line.rect.width, line.rect.y);
        if (/double/.test(line.style)) {
            ctx.moveTo(line.rect.x, line.rect.y + line.rect.height * 2);
            ctx.lineTo(line.rect.x + line.rect.width, line.rect.y + line.rect.height * 2);
        }
    }
    ctx.stroke(line.color);
    ctx.restore();
};
var renderLine = function renderLine(ctx, line, options) {
    var lineAscent = line.ascent;
    if (options.outlineLines) ctx.rect(line.box.x, line.box.y, line.box.width, line.box.height).stroke();
    ctx.save();
    ctx.translate(line.box.x, line.box.y + lineAscent);
    for(var i = 0; i < line.runs.length; i += 1){
        var run = line.runs[i];
        var isLastRun = i === line.runs.length - 1;
        if (run.attributes.backgroundColor) {
            var overflowRight = isLastRun ? line.overflowRight : 0;
            var backgroundRect = {
                x: 0,
                y: -lineAscent,
                height: line.box.height,
                width: run.xAdvance - overflowRight
            };
            renderBackground$1(ctx, backgroundRect, run.attributes.backgroundColor);
        }
        renderRun(ctx, run, options);
    }
    ctx.restore();
    ctx.save();
    ctx.translate(line.box.x, line.box.y);
    for(var _i = 0; _i < line.decorationLines.length; _i += 1){
        var decorationLine = line.decorationLines[_i];
        renderDecorationLine(ctx, decorationLine);
    }
    ctx.restore();
};
var renderBlock = function renderBlock(ctx, block, options) {
    block.forEach(function(line) {
        renderLine(ctx, line, options);
    });
};
var renderText = function renderText(ctx, node) {
    var _node$box2, _node$box3;
    var _node$box = node.box, top = _node$box.top, left = _node$box.left;
    var blocks = [
        node.lines
    ];
    var paddingTop = ((_node$box2 = node.box) === null || _node$box2 === void 0 ? void 0 : _node$box2.paddingTop) || 0;
    var paddingLeft = ((_node$box3 = node.box) === null || _node$box3 === void 0 ? void 0 : _node$box3.paddingLeft) || 0;
    var initialY = node.lines[0] ? node.lines[0].box.y : 0;
    var offsetX = node.alignOffset || 0;
    ctx.save();
    ctx.translate(left + paddingLeft - offsetX, top + paddingTop - initialY);
    blocks.forEach(function(block) {
        renderBlock(ctx, block, {});
    });
    ctx.restore();
};
var renderPage = function renderPage(ctx, node) {
    var _node$props;
    var _node$box = node.box, width = _node$box.width, height = _node$box.height;
    var dpi = ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.dpi) || 72;
    var userUnit = dpi / 72;
    ctx.addPage({
        size: [
            width,
            height
        ],
        margin: 0,
        userUnit: userUnit
    });
};
var renderNote = function renderNote(ctx, node) {
    var _node$children, _node$style, _node$style2;
    var _node$box = node.box, top = _node$box.top, left = _node$box.left;
    var value = (node === null || node === void 0 ? void 0 : (_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children[0].value) || "";
    var color = ((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.backgroundColor) || null;
    var borderWidth = ((_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2.borderWidth) || null;
    ctx.note(left, top, 0, 0, value, {
        color: color,
        borderWidth: borderWidth
    });
};
var isNumeric = function isNumeric(n) {
    return !Number.isNaN(parseFloat(n)) && Number.isFinite(n);
};
var applyContainObjectFit = function applyContainObjectFit(cw, ch, iw, ih, px, py) {
    var cr = cw / ch;
    var ir = iw / ih;
    var pxp = (0, _fns.matchPercent)(px);
    var pyp = (0, _fns.matchPercent)(py);
    var pxv = pxp ? pxp.percent : 0.5;
    var pyv = pyp ? pyp.percent : 0.5;
    if (cr > ir) {
        var _height = ch;
        var _width = _height * ir;
        var _yOffset = isNumeric(py) ? py : 0;
        var _xOffset = isNumeric(px) ? px : (cw - _width) * pxv;
        return {
            width: _width,
            height: _height,
            xOffset: _xOffset,
            yOffset: _yOffset
        };
    }
    var width = cw;
    var height = width / ir;
    var xOffset = isNumeric(px) ? px : 0;
    var yOffset = isNumeric(py) ? py : (ch - height) * pyv;
    return {
        width: width,
        height: height,
        yOffset: yOffset,
        xOffset: xOffset
    };
};
var applyNoneObjectFit = function applyNoneObjectFit(cw, ch, iw, ih, px, py) {
    var width = iw;
    var height = ih;
    var pxp = (0, _fns.matchPercent)(px);
    var pyp = (0, _fns.matchPercent)(py);
    var pxv = pxp ? pxp.percent : 0.5;
    var pyv = pyp ? pyp.percent : 0.5;
    var xOffset = isNumeric(px) ? px : (cw - width) * pxv;
    var yOffset = isNumeric(py) ? py : (ch - height) * pyv;
    return {
        width: width,
        height: height,
        xOffset: xOffset,
        yOffset: yOffset
    };
};
var applyCoverObjectFit = function applyCoverObjectFit(cw, ch, iw, ih, px, py) {
    var ir = iw / ih;
    var cr = cw / ch;
    var pxp = (0, _fns.matchPercent)(px);
    var pyp = (0, _fns.matchPercent)(py);
    var pxv = pxp ? pxp.percent : 0.5;
    var pyv = pyp ? pyp.percent : 0.5;
    if (cr > ir) {
        var _width2 = cw;
        var _height2 = _width2 / ir;
        var _xOffset2 = isNumeric(px) ? px : 0;
        var _yOffset2 = isNumeric(py) ? py : (ch - _height2) * pyv;
        return {
            width: _width2,
            height: _height2,
            yOffset: _yOffset2,
            xOffset: _xOffset2
        };
    }
    var height = ch;
    var width = height * ir;
    var xOffset = isNumeric(px) ? px : (cw - width) * pxv;
    var yOffset = isNumeric(py) ? py : 0;
    return {
        width: width,
        height: height,
        xOffset: xOffset,
        yOffset: yOffset
    };
};
var applyScaleDownObjectFit = function applyScaleDownObjectFit(cw, ch, iw, ih, px, py) {
    var containDimension = applyContainObjectFit(cw, ch, iw, ih, px, py);
    var noneDimension = applyNoneObjectFit(cw, ch, iw, ih, px, py);
    return containDimension.width < noneDimension.width ? containDimension : noneDimension;
};
var applyFillObjectFit = function applyFillObjectFit(cw, ch, px, py) {
    return {
        width: cw,
        height: ch,
        xOffset: (0, _fns.matchPercent)(px) ? 0 : px || 0,
        yOffset: (0, _fns.matchPercent)(py) ? 0 : py || 0
    };
};
var resolveObjectFit = function resolveObjectFit(type, cw, ch, iw, ih, px, py) {
    if (type === void 0) type = "fill";
    switch(type){
        case "contain":
            return applyContainObjectFit(cw, ch, iw, ih, px, py);
        case "cover":
            return applyCoverObjectFit(cw, ch, iw, ih, px, py);
        case "none":
            return applyNoneObjectFit(cw, ch, iw, ih, px, py);
        case "scale-down":
            return applyScaleDownObjectFit(cw, ch, iw, ih, px, py);
        default:
            return applyFillObjectFit(cw, ch, px, py);
    }
};
var drawImage = function drawImage(ctx, node, options) {
    var _node$style, _node$style2, _node$style3, _node$style4;
    if (options === void 0) options = {};
    var _node$box = node.box, left = _node$box.left, top = _node$box.top;
    var opacity = (_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.opacity;
    var objectFit = (_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2.objectFit;
    var objectPositionX = (_node$style3 = node.style) === null || _node$style3 === void 0 ? void 0 : _node$style3.objectPositionX;
    var objectPositionY = (_node$style4 = node.style) === null || _node$style4 === void 0 ? void 0 : _node$style4.objectPositionY;
    var paddingTop = node.box.paddingTop || 0;
    var paddingRight = node.box.paddingRight || 0;
    var paddingBottom = node.box.paddingBottom || 0;
    var paddingLeft = node.box.paddingLeft || 0;
    var imageCache = options.imageCache || new Map();
    var _resolveObjectFit = resolveObjectFit(objectFit, node.box.width - paddingLeft - paddingRight, node.box.height - paddingTop - paddingBottom, node.image.width, node.image.height, objectPositionX, objectPositionY), width = _resolveObjectFit.width, height = _resolveObjectFit.height, xOffset = _resolveObjectFit.xOffset, yOffset = _resolveObjectFit.yOffset;
    if (node.image.data) {
        if (width !== 0 && height !== 0) {
            var cacheKey = node.image.key;
            var image = imageCache.get(cacheKey) || ctx.embedImage(node.image.data);
            if (cacheKey) imageCache.set(cacheKey, image);
            var imageOpacity = (0, _fns.isNil)(opacity) ? 1 : opacity;
            ctx.fillOpacity(imageOpacity).image(image, left + paddingLeft + xOffset, top + paddingTop + yOffset, {
                width: width,
                height: height
            });
        } else console.warn("Image with src '" + JSON.stringify(node.props.src) + "' skipped due to invalid dimensions");
    }
};
var renderImage = function renderImage(ctx, node, options) {
    ctx.save();
    clipNode(ctx, node);
    drawImage(ctx, node, options);
    ctx.restore();
};
var CONTENT_COLOR = "#a1c6e7";
var PADDING_COLOR = "#c4deb9";
var MARGIN_COLOR = "#f8cca1";
// TODO: Draw debug boxes using clipping to enhance quality
var debugContent = function debugContent(ctx, node) {
    var _node$box = node.box, left = _node$box.left, top = _node$box.top, width = _node$box.width, height = _node$box.height, _node$box$paddingLeft = _node$box.paddingLeft, paddingLeft = _node$box$paddingLeft === void 0 ? 0 : _node$box$paddingLeft, _node$box$paddingTop = _node$box.paddingTop, paddingTop = _node$box$paddingTop === void 0 ? 0 : _node$box$paddingTop, _node$box$paddingRigh = _node$box.paddingRight, paddingRight = _node$box$paddingRigh === void 0 ? 0 : _node$box$paddingRigh, _node$box$paddingBott = _node$box.paddingBottom, paddingBottom = _node$box$paddingBott === void 0 ? 0 : _node$box$paddingBott, _node$box$borderLeftW = _node$box.borderLeftWidth, borderLeftWidth = _node$box$borderLeftW === void 0 ? 0 : _node$box$borderLeftW, _node$box$borderTopWi = _node$box.borderTopWidth, borderTopWidth = _node$box$borderTopWi === void 0 ? 0 : _node$box$borderTopWi, _node$box$borderRight = _node$box.borderRightWidth, borderRightWidth = _node$box$borderRight === void 0 ? 0 : _node$box$borderRight, _node$box$borderBotto = _node$box.borderBottomWidth, borderBottomWidth = _node$box$borderBotto === void 0 ? 0 : _node$box$borderBotto;
    ctx.fillColor(CONTENT_COLOR).opacity(0.5).rect(left + paddingLeft + borderLeftWidth, top + paddingTop + borderTopWidth, width - paddingLeft - paddingRight - borderRightWidth - borderLeftWidth, height - paddingTop - paddingBottom - borderTopWidth - borderBottomWidth).fill();
};
var debugPadding = function debugPadding(ctx, node) {
    var _node$box2 = node.box, left = _node$box2.left, top = _node$box2.top, width = _node$box2.width, height = _node$box2.height, _node$box2$paddingLef = _node$box2.paddingLeft, paddingLeft = _node$box2$paddingLef === void 0 ? 0 : _node$box2$paddingLef, _node$box2$paddingTop = _node$box2.paddingTop, paddingTop = _node$box2$paddingTop === void 0 ? 0 : _node$box2$paddingTop, _node$box2$paddingRig = _node$box2.paddingRight, paddingRight = _node$box2$paddingRig === void 0 ? 0 : _node$box2$paddingRig, _node$box2$paddingBot = _node$box2.paddingBottom, paddingBottom = _node$box2$paddingBot === void 0 ? 0 : _node$box2$paddingBot, _node$box2$borderLeft = _node$box2.borderLeftWidth, borderLeftWidth = _node$box2$borderLeft === void 0 ? 0 : _node$box2$borderLeft, _node$box2$borderTopW = _node$box2.borderTopWidth, borderTopWidth = _node$box2$borderTopW === void 0 ? 0 : _node$box2$borderTopW, _node$box2$borderRigh = _node$box2.borderRightWidth, borderRightWidth = _node$box2$borderRigh === void 0 ? 0 : _node$box2$borderRigh, _node$box2$borderBott = _node$box2.borderBottomWidth, borderBottomWidth = _node$box2$borderBott === void 0 ? 0 : _node$box2$borderBott;
    ctx.fillColor(PADDING_COLOR).opacity(0.5);
    // Padding top
    ctx.rect(left + paddingLeft + borderLeftWidth, top + borderTopWidth, width - paddingRight - paddingLeft - borderLeftWidth - borderRightWidth, paddingTop).fill();
    // Padding left
    ctx.rect(left + borderLeftWidth, top + borderTopWidth, paddingLeft, height - borderTopWidth - borderBottomWidth).fill();
    // Padding right
    ctx.rect(left + width - paddingRight - borderRightWidth, top + borderTopWidth, paddingRight, height - borderTopWidth - borderBottomWidth).fill();
    // Padding bottom
    ctx.rect(left + paddingLeft + borderLeftWidth, top + height - paddingBottom - borderBottomWidth, width - paddingRight - paddingLeft - borderLeftWidth - borderRightWidth, paddingBottom).fill();
};
var getMargin = function getMargin(box) {
    var marginLeft = box.marginLeft === "auto" ? 0 : box.marginLeft;
    var marginTop = box.marginTop === "auto" ? 0 : box.marginTop;
    var marginRight = box.marginRight === "auto" ? 0 : box.marginRight;
    var marginBottom = box.marginBottom === "auto" ? 0 : box.marginBottom;
    return {
        marginLeft: marginLeft,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom
    };
};
var debugMargin = function debugMargin(ctx, node) {
    var _node$box3 = node.box, left = _node$box3.left, top = _node$box3.top, width = _node$box3.width, height = _node$box3.height;
    var _getMargin = getMargin(node.box), _getMargin$marginLeft = _getMargin.marginLeft, marginLeft = _getMargin$marginLeft === void 0 ? 0 : _getMargin$marginLeft, _getMargin$marginTop = _getMargin.marginTop, marginTop = _getMargin$marginTop === void 0 ? 0 : _getMargin$marginTop, _getMargin$marginRigh = _getMargin.marginRight, marginRight = _getMargin$marginRigh === void 0 ? 0 : _getMargin$marginRigh, _getMargin$marginBott = _getMargin.marginBottom, marginBottom = _getMargin$marginBott === void 0 ? 0 : _getMargin$marginBott;
    ctx.fillColor(MARGIN_COLOR).opacity(0.5);
    // Margin top
    ctx.rect(left, top - marginTop, width, marginTop).fill();
    // Margin left
    ctx.rect(left - marginLeft, top - marginTop, marginLeft, height + marginTop + marginBottom).fill();
    // Margin right
    ctx.rect(left + width, top - marginTop, marginRight, height + marginTop + marginBottom).fill();
    // Margin bottom
    ctx.rect(left, top + height, width, marginBottom).fill();
};
var debugText = function debugText(ctx, node) {
    var _node$box4 = node.box, left = _node$box4.left, top = _node$box4.top, width = _node$box4.width, height = _node$box4.height;
    var _getMargin2 = getMargin(node.box), _getMargin2$marginLef = _getMargin2.marginLeft, marginLeft = _getMargin2$marginLef === void 0 ? 0 : _getMargin2$marginLef, _getMargin2$marginTop = _getMargin2.marginTop, marginTop = _getMargin2$marginTop === void 0 ? 0 : _getMargin2$marginTop, _getMargin2$marginRig = _getMargin2.marginRight, marginRight = _getMargin2$marginRig === void 0 ? 0 : _getMargin2$marginRig, _getMargin2$marginBot = _getMargin2.marginBottom, marginBottom = _getMargin2$marginBot === void 0 ? 0 : _getMargin2$marginBot;
    var roundedWidth = Math.round(width + marginLeft + marginRight);
    var roundedHeight = Math.round(height + marginTop + marginBottom);
    ctx.fontSize(6).opacity(1).fillColor("black").text(roundedWidth + " x " + roundedHeight, left - marginLeft, Math.max(top - marginTop - 4, 1));
};
var debugOrigin = function debugOrigin(ctx, node) {
    if (node.origin) ctx.circle(node.origin.left, node.origin.top, 3).fill("red").circle(node.origin.left, node.origin.top, 5).stroke("red");
};
var renderDebug = function renderDebug(ctx, node) {
    var _node$props;
    if (!((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.debug)) return;
    ctx.save();
    debugContent(ctx, node);
    debugPadding(ctx, node);
    debugMargin(ctx, node);
    debugText(ctx, node);
    debugOrigin(ctx, node);
    ctx.restore();
};
var availableMethods = [
    "dash",
    "clip",
    "save",
    "path",
    "fill",
    "font",
    "text",
    "rect",
    "scale",
    "moveTo",
    "lineTo",
    "stroke",
    "rotate",
    "circle",
    "lineCap",
    "opacity",
    "ellipse",
    "polygon",
    "restore",
    "lineJoin",
    "fontSize",
    "fillColor",
    "lineWidth",
    "translate",
    "miterLimit",
    "strokeColor",
    "fillOpacity",
    "roundedRect",
    "fillAndStroke",
    "strokeOpacity",
    "bezierCurveTo",
    "quadraticCurveTo",
    "linearGradient",
    "radialGradient"
];
var painter = function painter(ctx) {
    var p = availableMethods.reduce(function(acc, prop) {
        var _extends2;
        return (0, _extendsDefault.default)({}, acc, (_extends2 = {}, _extends2[prop] = function() {
            ctx[prop].apply(ctx, arguments);
            return p;
        }, _extends2));
    }, {});
    return p;
};
var renderCanvas = function renderCanvas(ctx, node) {
    var _node$box = node.box, top = _node$box.top, left = _node$box.left, width = _node$box.width, height = _node$box.height;
    var paddingTop = node.box.paddingTop || 0;
    var paddingLeft = node.box.paddingLeft || 0;
    var paddingRight = node.box.paddingRight || 0;
    var paddingBottom = node.box.paddingBottom || 0;
    var availableWidth = width - paddingLeft - paddingRight;
    var availableHeight = height - paddingTop - paddingBottom;
    if (!availableWidth || !availableHeight) console.warn("Canvas element has null width or height. Please provide valid values via the `style` prop in order to correctly render it.");
    ctx.save().translate(left + paddingLeft, top + paddingTop);
    if (node.props.paint) node.props.paint(painter(ctx), availableWidth, availableHeight);
    ctx.restore();
};
// Ref: https://www.w3.org/TR/css-backgrounds-3/#borders
// This constant is used to approximate a symmetrical arc using a cubic Bezier curve.
var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var clipBorderTop = function clipBorderTop(ctx, layout, style, rtr, rtl) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderTopWidth = style.borderTopWidth, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    // Clip outer top border edge
    ctx.moveTo(left + rtl, top);
    ctx.lineTo(left + width - rtr, top);
    // Ellipse coefficients outer top right cap
    var c0 = rtr * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + width - c0, top, left + width, top + c0, left + width, top + rtr);
    // Move down in case the margin exceedes the radius
    var topRightYCoord = top + Math.max(borderTopWidth, rtr);
    ctx.lineTo(left + width, topRightYCoord);
    // Clip inner top right cap
    ctx.lineTo(left + width - borderRightWidth, topRightYCoord);
    // Ellipse coefficients inner top right cap
    var innerTopRightRadiusX = Math.max(rtr - borderRightWidth, 0);
    var innerTopRightRadiusY = Math.max(rtr - borderTopWidth, 0);
    var c1 = innerTopRightRadiusX * (1.0 - KAPPA);
    var c2 = innerTopRightRadiusY * (1.0 - KAPPA);
    // Clip inner top right cap
    ctx.bezierCurveTo(left + width - borderRightWidth, top + borderTopWidth + c2, left + width - borderRightWidth - c1, top + borderTopWidth, left + width - borderRightWidth - innerTopRightRadiusX, top + borderTopWidth);
    // Clip inner top border edge
    ctx.lineTo(left + Math.max(rtl, borderLeftWidth), top + borderTopWidth);
    // Ellipse coefficients inner top left cap
    var innerTopLeftRadiusX = Math.max(rtl - borderLeftWidth, 0);
    var innerTopLeftRadiusY = Math.max(rtl - borderTopWidth, 0);
    var c3 = innerTopLeftRadiusX * (1.0 - KAPPA);
    var c4 = innerTopLeftRadiusY * (1.0 - KAPPA);
    var topLeftYCoord = top + Math.max(borderTopWidth, rtl);
    // Clip inner top left cap
    ctx.bezierCurveTo(left + borderLeftWidth + c3, top + borderTopWidth, left + borderLeftWidth, top + borderTopWidth + c4, left + borderLeftWidth, topLeftYCoord);
    ctx.lineTo(left, topLeftYCoord);
    // Move down in case the margin exceedes the radius
    ctx.lineTo(left, top + rtl);
    // Ellipse coefficients outer top left cap
    var c5 = rtl * (1.0 - KAPPA);
    // Clip outer top left cap
    ctx.bezierCurveTo(left, top + c5, left + c5, top, left + rtl, top);
    ctx.closePath();
    ctx.clip();
    // Clip border top cap joins
    if (borderRightWidth) {
        var trSlope = -borderTopWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, trSlope * (-width / 2) + top);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left, top);
        ctx.lineTo(left, top + height);
        ctx.closePath();
        ctx.clip();
    }
    if (borderLeftWidth) {
        var _trSlope = -borderTopWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, _trSlope * (-width / 2) + top);
        ctx.lineTo(left, top);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left + width, top + height);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderTop = function fillBorderTop(ctx, layout, style, rtr, rtl) {
    var top = layout.top, left = layout.left, width = layout.width;
    var borderTopColor = style.borderTopColor, borderTopWidth = style.borderTopWidth, borderTopStyle = style.borderTopStyle, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    var c0 = rtl * (1.0 - KAPPA);
    var c1 = rtr * (1.0 - KAPPA);
    ctx.moveTo(left, top + Math.max(rtl, borderTopWidth));
    ctx.bezierCurveTo(left, top + c0, left + c0, top, left + rtl, top);
    ctx.lineTo(left + width - rtr, top);
    ctx.bezierCurveTo(left + width - c1, top, left + width, top + c1, left + width, top + rtr);
    ctx.strokeColor(borderTopColor);
    ctx.lineWidth(Math.max(borderRightWidth, borderTopWidth, borderLeftWidth) * 2);
    if (borderTopStyle === "dashed") ctx.dash(borderTopWidth * 2, {
        space: borderTopWidth * 1.2
    });
    else if (borderTopStyle === "dotted") ctx.dash(borderTopWidth, {
        space: borderTopWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var clipBorderRight = function clipBorderRight(ctx, layout, style, rtr, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderTopWidth = style.borderTopWidth, borderRightWidth = style.borderRightWidth, borderBottomWidth = style.borderBottomWidth;
    // Clip outer right border edge
    ctx.moveTo(left + width, top + rtr);
    ctx.lineTo(left + width, top + height - rbr);
    // Ellipse coefficients outer bottom right cap
    var c0 = rbr * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + width, top + height - c0, left + width - c0, top + height, left + width - rbr, top + height);
    // Move left in case the margin exceedes the radius
    var topBottomXCoord = left + width - Math.max(borderRightWidth, rbr);
    ctx.lineTo(topBottomXCoord, top + height);
    // Clip inner bottom right cap
    ctx.lineTo(topBottomXCoord, top + height - borderBottomWidth);
    // Ellipse coefficients inner bottom right cap
    var innerBottomRightRadiusX = Math.max(rbr - borderRightWidth, 0);
    var innerBottomRightRadiusY = Math.max(rbr - borderBottomWidth, 0);
    var c1 = innerBottomRightRadiusX * (1.0 - KAPPA);
    var c2 = innerBottomRightRadiusY * (1.0 - KAPPA);
    // Clip inner top right cap
    ctx.bezierCurveTo(left + width - borderRightWidth - c1, top + height - borderBottomWidth, left + width - borderRightWidth, top + height - borderBottomWidth - c2, left + width - borderRightWidth, top + height - Math.max(rbr, borderBottomWidth));
    // Clip inner right border edge
    ctx.lineTo(left + width - borderRightWidth, top + Math.max(rtr, borderTopWidth));
    // Ellipse coefficients inner top right cap
    var innerTopRightRadiusX = Math.max(rtr - borderRightWidth, 0);
    var innerTopRightRadiusY = Math.max(rtr - borderTopWidth, 0);
    var c3 = innerTopRightRadiusX * (1.0 - KAPPA);
    var c4 = innerTopRightRadiusY * (1.0 - KAPPA);
    var topRightXCoord = left + width - Math.max(rtr, borderRightWidth);
    // Clip inner top left cap
    ctx.bezierCurveTo(left + width - borderRightWidth, top + borderTopWidth + c4, left + width - borderRightWidth - c3, top + borderTopWidth, topRightXCoord, top + borderTopWidth);
    ctx.lineTo(topRightXCoord, top);
    // Move right in case the margin exceedes the radius
    ctx.lineTo(left + width - rtr, top);
    // Ellipse coefficients outer top right cap
    var c5 = rtr * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + width - c5, top, left + width, top + c5, left + width, top + rtr);
    ctx.closePath();
    ctx.clip();
    // Clip border right cap joins
    if (borderTopWidth) {
        var trSlope = -borderTopWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, trSlope * (-width / 2) + top);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left, top + height);
        ctx.closePath();
        ctx.clip();
    }
    if (borderBottomWidth) {
        var brSlope = borderBottomWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, brSlope * (-width / 2) + top + height);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left, top);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderRight = function fillBorderRight(ctx, layout, style, rtr, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderRightColor = style.borderRightColor, borderRightStyle = style.borderRightStyle, borderRightWidth = style.borderRightWidth, borderTopWidth = style.borderTopWidth, borderBottomWidth = style.borderBottomWidth;
    var c0 = rbr * (1.0 - KAPPA);
    var c1 = rtr * (1.0 - KAPPA);
    ctx.moveTo(left + width - rtr, top);
    ctx.bezierCurveTo(left + width - c1, top, left + width, top + c1, left + width, top + rtr);
    ctx.lineTo(left + width, top + height - rbr);
    ctx.bezierCurveTo(left + width, top + height - c0, left + width - c0, top + height, left + width - rbr, top + height);
    ctx.strokeColor(borderRightColor);
    ctx.lineWidth(Math.max(borderRightWidth, borderTopWidth, borderBottomWidth) * 2);
    if (borderRightStyle === "dashed") ctx.dash(borderRightWidth * 2, {
        space: borderRightWidth * 1.2
    });
    else if (borderRightStyle === "dotted") ctx.dash(borderRightWidth, {
        space: borderRightWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var clipBorderBottom = function clipBorderBottom(ctx, layout, style, rbl, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderBottomWidth = style.borderBottomWidth, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    // Clip outer top border edge
    ctx.moveTo(left + width - rbr, top + height);
    ctx.lineTo(left + rbl, top + height);
    // Ellipse coefficients outer top right cap
    var c0 = rbl * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + c0, top + height, left, top + height - c0, left, top + height - rbl);
    // Move up in case the margin exceedes the radius
    var bottomLeftYCoord = top + height - Math.max(borderBottomWidth, rbl);
    ctx.lineTo(left, bottomLeftYCoord);
    // Clip inner bottom left cap
    ctx.lineTo(left + borderLeftWidth, bottomLeftYCoord);
    // Ellipse coefficients inner top right cap
    var innerBottomLeftRadiusX = Math.max(rbl - borderLeftWidth, 0);
    var innerBottomLeftRadiusY = Math.max(rbl - borderBottomWidth, 0);
    var c1 = innerBottomLeftRadiusX * (1.0 - KAPPA);
    var c2 = innerBottomLeftRadiusY * (1.0 - KAPPA);
    // Clip inner bottom left cap
    ctx.bezierCurveTo(left + borderLeftWidth, top + height - borderBottomWidth - c2, left + borderLeftWidth + c1, top + height - borderBottomWidth, left + borderLeftWidth + innerBottomLeftRadiusX, top + height - borderBottomWidth);
    // Clip inner bottom border edge
    ctx.lineTo(left + width - Math.max(rbr, borderRightWidth), top + height - borderBottomWidth);
    // Ellipse coefficients inner top left cap
    var innerBottomRightRadiusX = Math.max(rbr - borderRightWidth, 0);
    var innerBottomRightRadiusY = Math.max(rbr - borderBottomWidth, 0);
    var c3 = innerBottomRightRadiusX * (1.0 - KAPPA);
    var c4 = innerBottomRightRadiusY * (1.0 - KAPPA);
    var bottomRightYCoord = top + height - Math.max(borderBottomWidth, rbr);
    // Clip inner top left cap
    ctx.bezierCurveTo(left + width - borderRightWidth - c3, top + height - borderBottomWidth, left + width - borderRightWidth, top + height - borderBottomWidth - c4, left + width - borderRightWidth, bottomRightYCoord);
    ctx.lineTo(left + width, bottomRightYCoord);
    // Move down in case the margin exceedes the radius
    ctx.lineTo(left + width, top + height - rbr);
    // Ellipse coefficients outer top left cap
    var c5 = rbr * (1.0 - KAPPA);
    // Clip outer top left cap
    ctx.bezierCurveTo(left + width, top + height - c5, left + width - c5, top + height, left + width - rbr, top + height);
    ctx.closePath();
    ctx.clip();
    // Clip border bottom cap joins
    if (borderRightWidth) {
        var brSlope = borderBottomWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, brSlope * (-width / 2) + top + height);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left, top);
        ctx.closePath();
        ctx.clip();
    }
    if (borderLeftWidth) {
        var trSlope = -borderBottomWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, trSlope * (width / 2) + top + height);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left + width, top);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderBottom = function fillBorderBottom(ctx, layout, style, rbl, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderBottomColor = style.borderBottomColor, borderBottomStyle = style.borderBottomStyle, borderBottomWidth = style.borderBottomWidth, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    var c0 = rbl * (1.0 - KAPPA);
    var c1 = rbr * (1.0 - KAPPA);
    ctx.moveTo(left + width, top + height - rbr);
    ctx.bezierCurveTo(left + width, top + height - c1, left + width - c1, top + height, left + width - rbr, top + height);
    ctx.lineTo(left + rbl, top + height);
    ctx.bezierCurveTo(left + c0, top + height, left, top + height - c0, left, top + height - rbl);
    ctx.strokeColor(borderBottomColor);
    ctx.lineWidth(Math.max(borderBottomWidth, borderRightWidth, borderLeftWidth) * 2);
    if (borderBottomStyle === "dashed") ctx.dash(borderBottomWidth * 2, {
        space: borderBottomWidth * 1.2
    });
    else if (borderBottomStyle === "dotted") ctx.dash(borderBottomWidth, {
        space: borderBottomWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var clipBorderLeft = function clipBorderLeft(ctx, layout, style, rbl, rtl) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderTopWidth = style.borderTopWidth, borderLeftWidth = style.borderLeftWidth, borderBottomWidth = style.borderBottomWidth;
    // Clip outer left border edge
    ctx.moveTo(left, top + height - rbl);
    ctx.lineTo(left, top + rtl);
    // Ellipse coefficients outer top left cap
    var c0 = rtl * (1.0 - KAPPA);
    // Clip outer top left cap
    ctx.bezierCurveTo(left, top + c0, left + c0, top, left + rtl, top);
    // Move right in case the margin exceedes the radius
    var topLeftCoordX = left + Math.max(borderLeftWidth, rtl);
    ctx.lineTo(topLeftCoordX, top);
    // Clip inner top left cap
    ctx.lineTo(topLeftCoordX, top + borderTopWidth);
    // Ellipse coefficients inner top left cap
    var innerTopLeftRadiusX = Math.max(rtl - borderLeftWidth, 0);
    var innerTopLeftRadiusY = Math.max(rtl - borderTopWidth, 0);
    var c1 = innerTopLeftRadiusX * (1.0 - KAPPA);
    var c2 = innerTopLeftRadiusY * (1.0 - KAPPA);
    // Clip inner top right cap
    ctx.bezierCurveTo(left + borderLeftWidth + c1, top + borderTopWidth, left + borderLeftWidth, top + borderTopWidth + c2, left + borderLeftWidth, top + Math.max(rtl, borderTopWidth));
    // Clip inner left border edge
    ctx.lineTo(left + borderLeftWidth, top + height - Math.max(rbl, borderBottomWidth));
    // Ellipse coefficients inner bottom left cap
    var innerBottomLeftRadiusX = Math.max(rbl - borderLeftWidth, 0);
    var innerBottomLeftRadiusY = Math.max(rbl - borderBottomWidth, 0);
    var c3 = innerBottomLeftRadiusX * (1.0 - KAPPA);
    var c4 = innerBottomLeftRadiusY * (1.0 - KAPPA);
    var bottomLeftXCoord = left + Math.max(rbl, borderLeftWidth);
    // Clip inner top left cap
    ctx.bezierCurveTo(left + borderLeftWidth, top + height - borderBottomWidth - c4, left + borderLeftWidth + c3, top + height - borderBottomWidth, bottomLeftXCoord, top + height - borderBottomWidth);
    ctx.lineTo(bottomLeftXCoord, top + height);
    // Move left in case the margin exceedes the radius
    ctx.lineTo(left + rbl, top + height);
    // Ellipse coefficients outer top right cap
    var c5 = rbl * (1.0 - KAPPA);
    // Clip outer top right cap
    ctx.bezierCurveTo(left + c5, top + height, left, top + height - c5, left, top + height - rbl);
    ctx.closePath();
    ctx.clip();
    // Clip border right cap joins
    if (borderBottomWidth) {
        var trSlope = -borderBottomWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, trSlope * (width / 2) + top + height);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left, top);
        ctx.lineTo(left + width, top);
        ctx.closePath();
        ctx.clip();
    }
    if (borderBottomWidth) {
        var _trSlope2 = -borderTopWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, _trSlope2 * (-width / 2) + top);
        ctx.lineTo(left, top);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left + width, top + height);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderLeft = function fillBorderLeft(ctx, layout, style, rbl, rtl) {
    var top = layout.top, left = layout.left, height = layout.height;
    var borderLeftColor = style.borderLeftColor, borderLeftStyle = style.borderLeftStyle, borderLeftWidth = style.borderLeftWidth, borderTopWidth = style.borderTopWidth, borderBottomWidth = style.borderBottomWidth;
    var c0 = rbl * (1.0 - KAPPA);
    var c1 = rtl * (1.0 - KAPPA);
    ctx.moveTo(left + rbl, top + height);
    ctx.bezierCurveTo(left + c0, top + height, left, top + height - c0, left, top + height - rbl);
    ctx.lineTo(left, top + rtl);
    ctx.bezierCurveTo(left, top + c1, left + c1, top, left + rtl, top);
    ctx.strokeColor(borderLeftColor);
    ctx.lineWidth(Math.max(borderLeftWidth, borderTopWidth, borderBottomWidth) * 2);
    if (borderLeftStyle === "dashed") ctx.dash(borderLeftWidth * 2, {
        space: borderLeftWidth * 1.2
    });
    else if (borderLeftStyle === "dotted") ctx.dash(borderLeftWidth, {
        space: borderLeftWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var shouldRenderBorders = function shouldRenderBorders(node) {
    return node.box && (node.box.borderTopWidth || node.box.borderRightWidth || node.box.borderBottomWidth || node.box.borderLeftWidth);
};
var renderBorders = function renderBorders(ctx, node) {
    if (!shouldRenderBorders(node)) return;
    var _node$box = node.box, width = _node$box.width, height = _node$box.height, borderTopWidth = _node$box.borderTopWidth, borderLeftWidth = _node$box.borderLeftWidth, borderRightWidth = _node$box.borderRightWidth, borderBottomWidth = _node$box.borderBottomWidth;
    var _node$style = node.style, opacity = _node$style.opacity, _node$style$borderTop = _node$style.borderTopLeftRadius, borderTopLeftRadius = _node$style$borderTop === void 0 ? 0 : _node$style$borderTop, _node$style$borderTop2 = _node$style.borderTopRightRadius, borderTopRightRadius = _node$style$borderTop2 === void 0 ? 0 : _node$style$borderTop2, _node$style$borderBot = _node$style.borderBottomLeftRadius, borderBottomLeftRadius = _node$style$borderBot === void 0 ? 0 : _node$style$borderBot, _node$style$borderBot2 = _node$style.borderBottomRightRadius, borderBottomRightRadius = _node$style$borderBot2 === void 0 ? 0 : _node$style$borderBot2, _node$style$borderTop3 = _node$style.borderTopColor, borderTopColor = _node$style$borderTop3 === void 0 ? "black" : _node$style$borderTop3, _node$style$borderTop4 = _node$style.borderTopStyle, borderTopStyle = _node$style$borderTop4 === void 0 ? "solid" : _node$style$borderTop4, _node$style$borderLef = _node$style.borderLeftColor, borderLeftColor = _node$style$borderLef === void 0 ? "black" : _node$style$borderLef, _node$style$borderLef2 = _node$style.borderLeftStyle, borderLeftStyle = _node$style$borderLef2 === void 0 ? "solid" : _node$style$borderLef2, _node$style$borderRig = _node$style.borderRightColor, borderRightColor = _node$style$borderRig === void 0 ? "black" : _node$style$borderRig, _node$style$borderRig2 = _node$style.borderRightStyle, borderRightStyle = _node$style$borderRig2 === void 0 ? "solid" : _node$style$borderRig2, _node$style$borderBot3 = _node$style.borderBottomColor, borderBottomColor = _node$style$borderBot3 === void 0 ? "black" : _node$style$borderBot3, _node$style$borderBot4 = _node$style.borderBottomStyle, borderBottomStyle = _node$style$borderBot4 === void 0 ? "solid" : _node$style$borderBot4;
    var style = {
        borderTopColor: borderTopColor,
        borderTopWidth: borderTopWidth,
        borderTopStyle: borderTopStyle,
        borderLeftColor: borderLeftColor,
        borderLeftWidth: borderLeftWidth,
        borderLeftStyle: borderLeftStyle,
        borderRightColor: borderRightColor,
        borderRightWidth: borderRightWidth,
        borderRightStyle: borderRightStyle,
        borderBottomColor: borderBottomColor,
        borderBottomWidth: borderBottomWidth,
        borderBottomStyle: borderBottomStyle,
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius,
        borderBottomRightRadius: borderBottomRightRadius
    };
    var rtr = Math.min(borderTopRightRadius, 0.5 * width, 0.5 * height);
    var rtl = Math.min(borderTopLeftRadius, 0.5 * width, 0.5 * height);
    var rbr = Math.min(borderBottomRightRadius, 0.5 * width, 0.5 * height);
    var rbl = Math.min(borderBottomLeftRadius, 0.5 * width, 0.5 * height);
    ctx.save();
    ctx.strokeOpacity(opacity);
    if (borderTopWidth) {
        ctx.save();
        clipBorderTop(ctx, node.box, style, rtr, rtl);
        fillBorderTop(ctx, node.box, style, rtr, rtl);
        ctx.restore();
    }
    if (borderRightWidth) {
        ctx.save();
        clipBorderRight(ctx, node.box, style, rtr, rbr);
        fillBorderRight(ctx, node.box, style, rtr, rbr);
        ctx.restore();
    }
    if (borderBottomWidth) {
        ctx.save();
        clipBorderBottom(ctx, node.box, style, rbl, rbr);
        fillBorderBottom(ctx, node.box, style, rbl, rbr);
        ctx.restore();
    }
    if (borderLeftWidth) {
        ctx.save();
        clipBorderLeft(ctx, node.box, style, rbl, rtl);
        fillBorderLeft(ctx, node.box, style, rbl, rtl);
        ctx.restore();
    }
    ctx.restore();
};
var drawBackground = function drawBackground(ctx, node) {
    var _node$style;
    var _node$box = node.box, top = _node$box.top, left = _node$box.left, width = _node$box.width, height = _node$box.height;
    var color = parseColor(node.style.backgroundColor);
    var nodeOpacity = (0, _fns.isNil)((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.opacity) ? 1 : node.style.opacity;
    var opacity = Math.min(color.opacity, nodeOpacity);
    ctx.fillOpacity(opacity).fillColor(color.value).rect(left, top, width, height).fill();
};
var renderBackground = function renderBackground(ctx, node) {
    var _node$style2;
    var hasBackground = !!node.box && !!((_node$style2 = node.style) !== null && _node$style2 !== void 0 && _node$style2.backgroundColor);
    if (hasBackground) {
        ctx.save();
        clipNode(ctx, node);
        drawBackground(ctx, node);
        ctx.restore();
    }
};
var isSrcId = function isSrcId(value) {
    return /^#.+/.test(value);
};
var setLink = function setLink(ctx, node) {
    var props = node.props || {};
    var _node$box = node.box, top = _node$box.top, left = _node$box.left, width = _node$box.width, height = _node$box.height;
    var src = props.src || props.href;
    if (src) {
        var isId = isSrcId(src);
        var method = isId ? "goTo" : "link";
        var value = isId ? src.slice(1) : src;
        ctx[method](left, top, width, height, value);
    }
};
var setDestination = function setDestination(ctx, node) {
    var _node$props;
    if ((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.id) ctx.addNamedDestination(node.props.id, "XYZ", null, node.box.top, null);
};
var _renderFns;
var isRecursiveNode = function isRecursiveNode(node) {
    return node.type !== _primitives.Text && node.type !== _primitives.Svg;
};
var renderChildren = function renderChildren(ctx, node, options) {
    ctx.save();
    if (node.box) ctx.translate(node.box.left, node.box.top);
    var children = node.children || [];
    var renderChild = function renderChild(child) {
        return renderNode(ctx, child, options);
    };
    children.forEach(renderChild);
    ctx.restore();
};
var renderFns = (_renderFns = {}, _renderFns[_primitives.Text] = renderText, _renderFns[_primitives.Note] = renderNote, _renderFns[_primitives.Image] = renderImage, _renderFns[_primitives.Canvas] = renderCanvas, _renderFns[_primitives.Svg] = renderSvg, _renderFns[_primitives.Link] = setLink, _renderFns);
var renderNode = function renderNode(ctx, node, options) {
    var _node$style;
    var overflowHidden = ((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.overflow) === "hidden";
    var shouldRenderChildren = isRecursiveNode(node);
    if (node.type === _primitives.Page) renderPage(ctx, node);
    ctx.save();
    if (overflowHidden) clipNode(ctx, node);
    applyTransformations(ctx, node);
    renderBackground(ctx, node);
    renderBorders(ctx, node);
    var renderFn = renderFns[node.type];
    if (renderFn) renderFn(ctx, node, options);
    if (shouldRenderChildren) renderChildren(ctx, node, options);
    setDestination(ctx, node);
    renderDebug(ctx, node);
    ctx.restore();
};
/* eslint-disable no-param-reassign */ var setPDFMetadata = function setPDFMetadata(target) {
    return function(key, value) {
        if (value) target.info[key] = value;
    };
};
/**
 * Set document instance metadata
 *
 * @param {Object} ctx document instance
 * @param {Object} doc document root
 */ var addMetadata = function addMetadata(ctx, doc) {
    var setProp = setPDFMetadata(ctx);
    var props = doc.props || {};
    var title = props.title || null;
    var author = props.author || null;
    var subject = props.subject || null;
    var keywords = props.keywords || null;
    var creator = props.creator || "react-pdf";
    var producer = props.producer || "react-pdf";
    setProp("Title", title);
    setProp("Author", author);
    setProp("Subject", subject);
    setProp("Keywords", keywords);
    setProp("Creator", creator);
    setProp("Producer", producer);
};
/* eslint-disable no-param-reassign */ var addNodeBookmark = function addNodeBookmark(ctx, node, pageNumber, registry) {
    var _node$props;
    var bookmark = (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.bookmark;
    if (bookmark) {
        var title = bookmark.title, parent = bookmark.parent, expanded = bookmark.expanded, zoom = bookmark.zoom, fit = bookmark.fit;
        var outline = registry[parent] || ctx.outline;
        var top = bookmark.top || node.box.top;
        var left = bookmark.left || node.box.left;
        var instance = outline.addItem(title, {
            pageNumber: pageNumber,
            expanded: expanded,
            top: top,
            left: left,
            zoom: zoom,
            fit: fit
        });
        registry[bookmark.ref] = instance;
    }
    if (!node.children) return;
    node.children.forEach(function(child) {
        return addNodeBookmark(ctx, child, pageNumber, registry);
    });
};
var addBookmarks = function addBookmarks(ctx, root) {
    var registry = {};
    var pages = root.children || [];
    pages.forEach(function(page, i) {
        addNodeBookmark(ctx, page, i, registry);
    });
};
var render = function render(ctx, doc) {
    var pages = doc.children || [];
    var options = {
        imageCache: new Map()
    };
    addMetadata(ctx, doc);
    pages.forEach(function(page) {
        return renderNode(ctx, page, options);
    });
    addBookmarks(ctx, doc);
    ctx.end();
    return ctx;
};

},{"@react-pdf/primitives":"6ej9E","@react-pdf/fns":"9CfuB","abs-svg-path":"3o3bp","parse-svg-path":"k7rA3","normalize-svg-path":"bhGXJ","color-string":"lysB6","@babel/runtime/helpers/extends":"jbPGs","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9CfuB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adjust", ()=>adjust);
parcelHelpers.export(exports, "asyncCompose", ()=>asyncCompose);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "castArray", ()=>castArray);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "dropLast", ()=>dropLast);
parcelHelpers.export(exports, "evolve", ()=>evolve);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "isNil", ()=>isNil);
parcelHelpers.export(exports, "last", ()=>last);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
parcelHelpers.export(exports, "matchPercent", ()=>matchPercent);
parcelHelpers.export(exports, "omit", ()=>omit);
parcelHelpers.export(exports, "pick", ()=>pick);
parcelHelpers.export(exports, "reverse", ()=>reverse);
parcelHelpers.export(exports, "upperFirst", ()=>upperFirst);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
/**
 * Applies a function to the value at the given index of an array

 * @param {number} index
 * @param {function} fn
 * @param {array} collection
 * @returns copy of the array with the element at the given index replaced with the result of the function application.
 */ var adjust = function adjust(index, fn, collection) {
    var _Object$assign;
    if (index >= 0 && index >= collection.length) return collection;
    if (index < 0 && Math.abs(index) > collection.length) return collection;
    var i = index < 0 ? collection.length + index : index;
    return Object.assign([], collection, (_Object$assign = {}, _Object$assign[i] = fn(collection[i]), _Object$assign));
};
var reverse = function reverse(list) {
    return Array.prototype.slice.call(list, 0).reverse();
};
/**
 * Performs right-to-left function composition with async functions support
 *
 * @param  {...any} functions
 */ var asyncCompose = function asyncCompose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(value) {
            var result, reversedFns, _len2, args, _key2, i, fn, _args = arguments;
            return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        result = value;
                        reversedFns = reverse(fns);
                        for(_len2 = _args.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = _args[_key2];
                        i = 0;
                    case 4:
                        if (!(i < reversedFns.length)) {
                            _context.next = 12;
                            break;
                        }
                        fn = reversedFns[i];
                        _context.next = 8;
                        return fn.apply(void 0, [
                            result
                        ].concat(args));
                    case 8:
                        result = _context.sent;
                    case 9:
                        i += 1;
                        _context.next = 4;
                        break;
                    case 12:
                        return _context.abrupt("return", result);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * Capitalize first letter of each word
 *
 * @param {String} string
 * @returns {String} capitalized string
 */ var capitalize = function capitalize(value) {
    if (!value) return value;
    return value.replace(/(^|\s)\S/g, function(l) {
        return l.toUpperCase();
    });
};
/**
 * Casts value to array
 *
 * @param {any} value
 * @returns {Array} casted value
 */ var castArray = function castArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
};
/* eslint-disable no-await-in-loop */ /**
 * Performs right-to-left function composition
 *
 * @param  {...any} functions
 */ var compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(value) {
        var result = value;
        var reversedFns = reverse(fns);
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        for(var i = 0; i < reversedFns.length; i += 1){
            var fn = reversedFns[i];
            result = fn.apply(void 0, [
                result
            ].concat(args));
        }
        return result;
    };
};
var dropLast = function dropLast(array) {
    return array.slice(0, array.length - 1);
};
var evolve = function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var keys = Object.keys(object);
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        var transformation = transformations[key];
        var type = typeof transformation;
        if (type === "function") result[key] = transformation(object[key]);
        else if (transformation && type === "object") result[key] = evolve(transformation, object[key]);
        else result[key] = object[key];
    }
    return result;
};
var isNil = function isNil(value) {
    return value === null || value === undefined;
};
var get = function get(target, path, defaultValue) {
    if (isNil(target)) return defaultValue;
    var _path = castArray(path);
    var result = target;
    for(var i = 0; i < _path.length; i += 1){
        if (isNil(result)) return undefined;
        result = result[_path[i]];
    }
    return isNil(result) ? defaultValue : result;
};
var last = function last(value) {
    return value === "" ? "" : value[value.length - 1];
};
var mapValues = function mapValues(object, fn) {
    var entries = Object.entries(object);
    return entries.reduce(function(acc, _ref, index) {
        var key = _ref[0], value = _ref[1];
        acc[key] = fn(value, key, index);
        return acc;
    }, {});
};
var isPercent = function isPercent(value) {
    return /((-)?\d+\.?\d*)%/g.exec(value);
};
/**
 * Get percentage value of input
 *
 * @param {String} value
 * @returns {Object} percent value (if matches)
 */ var matchPercent = function matchPercent(value) {
    var match = isPercent(value);
    if (match) {
        var f = parseFloat(match[1], 10);
        var percent = f / 100;
        return {
            percent: percent,
            value: f
        };
    }
    return null;
};
var omit = function omit(keys, object) {
    var _keys = castArray(keys);
    var copy = Object.assign({}, object);
    _keys.forEach(function(key) {
        delete copy[key];
    });
    return copy;
};
var pick = function pick(keys, obj) {
    var result = {};
    for(var i = 0; i < keys.length; i += 1){
        var key = keys[i];
        if (key in obj) result[key] = obj[key];
    }
    return result;
};
/**
 * Capitalize first letter of string
 *
 * @param {String} string
 * @returns {String} capitalized string
 */ var upperFirst = function upperFirst(value) {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
};

},{"@babel/runtime/helpers/regeneratorRuntime":"03zO2","@babel/runtime/helpers/asyncToGenerator":"lbVvv","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3o3bp":[function(require,module,exports) {
module.exports = absolutize;
/**
 * redefine `path` with absolute coordinates
 *
 * @param {Array} path
 * @return {Array}
 */ function absolutize(path) {
    var startX = 0;
    var startY = 0;
    var x = 0;
    var y = 0;
    return path.map(function(seg) {
        seg = seg.slice();
        var type = seg[0];
        var command = type.toUpperCase();
        // is relative
        if (type != command) {
            seg[0] = command;
            switch(type){
                case "a":
                    seg[6] += x;
                    seg[7] += y;
                    break;
                case "v":
                    seg[1] += y;
                    break;
                case "h":
                    seg[1] += x;
                    break;
                default:
                    for(var i = 1; i < seg.length;){
                        seg[i++] += x;
                        seg[i++] += y;
                    }
            }
        }
        // update cursor state
        switch(command){
            case "Z":
                x = startX;
                y = startY;
                break;
            case "H":
                x = seg[1];
                break;
            case "V":
                y = seg[1];
                break;
            case "M":
                x = startX = seg[1];
                y = startY = seg[2];
                break;
            default:
                x = seg[seg.length - 2];
                y = seg[seg.length - 1];
        }
        return seg;
    });
}

},{}],"k7rA3":[function(require,module,exports) {
module.exports = parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function parse(path) {
    var data = [];
    path.replace(segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = parseValues(args);
        // overloaded moveTo
        if (type == "m" && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = "l";
            command = command == "m" ? "l" : "L";
        }
        while(true){
            if (args.length == length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < length[type]) throw new Error("malformed path data");
            data.push([
                command
            ].concat(args.splice(0, length[type])));
        }
    });
    return data;
}
var number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function parseValues(args) {
    var numbers = args.match(number);
    return numbers ? numbers.map(Number) : [];
}

},{}],"bhGXJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>normalize);
var _svgArcToCubicBezier = require("svg-arc-to-cubic-bezier");
var _svgArcToCubicBezierDefault = parcelHelpers.interopDefault(_svgArcToCubicBezier);
function normalize(path) {
    // init state
    var prev;
    var result = [];
    var bezierX = 0;
    var bezierY = 0;
    var startX = 0;
    var startY = 0;
    var quadX = null;
    var quadY = null;
    var x = 0;
    var y = 0;
    for(var i = 0, len = path.length; i < len; i++){
        var seg = path[i];
        var command = seg[0];
        switch(command){
            case "M":
                startX = seg[1];
                startY = seg[2];
                break;
            case "A":
                var curves = (0, _svgArcToCubicBezierDefault.default)({
                    px: x,
                    py: y,
                    cx: seg[6],
                    cy: seg[7],
                    rx: seg[1],
                    ry: seg[2],
                    xAxisRotation: seg[3],
                    largeArcFlag: seg[4],
                    sweepFlag: seg[5]
                });
                // null-curves
                if (!curves.length) continue;
                for(var j = 0, c; j < curves.length; j++){
                    c = curves[j];
                    seg = [
                        "C",
                        c.x1,
                        c.y1,
                        c.x2,
                        c.y2,
                        c.x,
                        c.y
                    ];
                    if (j < curves.length - 1) result.push(seg);
                }
                break;
            case "S":
                // default control point
                var cx = x;
                var cy = y;
                if (prev == "C" || prev == "S") {
                    cx += cx - bezierX // reflect the previous command's control
                    ;
                    cy += cy - bezierY // point relative to the current point
                    ;
                }
                seg = [
                    "C",
                    cx,
                    cy,
                    seg[1],
                    seg[2],
                    seg[3],
                    seg[4]
                ];
                break;
            case "T":
                if (prev == "Q" || prev == "T") {
                    quadX = x * 2 - quadX // as with 'S' reflect previous control point
                    ;
                    quadY = y * 2 - quadY;
                } else {
                    quadX = x;
                    quadY = y;
                }
                seg = quadratic(x, y, quadX, quadY, seg[1], seg[2]);
                break;
            case "Q":
                quadX = seg[1];
                quadY = seg[2];
                seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4]);
                break;
            case "L":
                seg = line(x, y, seg[1], seg[2]);
                break;
            case "H":
                seg = line(x, y, seg[1], y);
                break;
            case "V":
                seg = line(x, y, x, seg[1]);
                break;
            case "Z":
                seg = line(x, y, startX, startY);
                break;
        }
        // update state
        prev = command;
        x = seg[seg.length - 2];
        y = seg[seg.length - 1];
        if (seg.length > 4) {
            bezierX = seg[seg.length - 4];
            bezierY = seg[seg.length - 3];
        } else {
            bezierX = x;
            bezierY = y;
        }
        result.push(seg);
    }
    return result;
}
function line(x1, y1, x2, y2) {
    return [
        "C",
        x1,
        y1,
        x2,
        y2,
        x2,
        y2
    ];
}
function quadratic(x1, y1, cx, cy, x2, y2) {
    return [
        "C",
        x1 / 3 + 2 / 3 * cx,
        y1 / 3 + 2 / 3 * cy,
        x2 / 3 + 2 / 3 * cx,
        y2 / 3 + 2 / 3 * cy,
        x2,
        y2
    ];
}

},{"svg-arc-to-cubic-bezier":"kqjwZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kqjwZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var TAU = Math.PI * 2;
var mapToEllipse = function mapToEllipse(_ref, rx, ry, cosphi, sinphi, centerx, centery) {
    var x = _ref.x, y = _ref.y;
    x *= rx;
    y *= ry;
    var xp = cosphi * x - sinphi * y;
    var yp = sinphi * x + cosphi * y;
    return {
        x: xp + centerx,
        y: yp + centery
    };
};
var approxUnitArc = function approxUnitArc(ang1, ang2) {
    // If 90 degree circular arc, use a constant
    // as derived from http://spencermortensen.com/articles/bezier-circle
    var a = ang2 === 1.5707963267948966 ? 0.551915024494 : ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    var x1 = Math.cos(ang1);
    var y1 = Math.sin(ang1);
    var x2 = Math.cos(ang1 + ang2);
    var y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
};
var vectorAngle = function vectorAngle(ux, uy, vx, vy) {
    var sign = ux * vy - uy * vx < 0 ? -1 : 1;
    var dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
var getArcCenter = function getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp) {
    var rxsq = Math.pow(rx, 2);
    var rysq = Math.pow(ry, 2);
    var pxpsq = Math.pow(pxp, 2);
    var pypsq = Math.pow(pyp, 2);
    var radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;
    if (radicant < 0) radicant = 0;
    radicant /= rxsq * pypsq + rysq * pxpsq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    var centerxp = radicant * rx / ry * pyp;
    var centeryp = radicant * -ry / rx * pxp;
    var centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
    var centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;
    var vx1 = (pxp - centerxp) / rx;
    var vy1 = (pyp - centeryp) / ry;
    var vx2 = (-pxp - centerxp) / rx;
    var vy2 = (-pyp - centeryp) / ry;
    var ang1 = vectorAngle(1, 0, vx1, vy1);
    var ang2 = vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += TAU;
    return [
        centerx,
        centery,
        ang1,
        ang2
    ];
};
var arcToBezier = function arcToBezier(_ref2) {
    var px = _ref2.px, py = _ref2.py, cx = _ref2.cx, cy = _ref2.cy, rx = _ref2.rx, ry = _ref2.ry, _ref2$xAxisRotation = _ref2.xAxisRotation, xAxisRotation = _ref2$xAxisRotation === undefined ? 0 : _ref2$xAxisRotation, _ref2$largeArcFlag = _ref2.largeArcFlag, largeArcFlag = _ref2$largeArcFlag === undefined ? 0 : _ref2$largeArcFlag, _ref2$sweepFlag = _ref2.sweepFlag, sweepFlag = _ref2$sweepFlag === undefined ? 0 : _ref2$sweepFlag;
    var curves = [];
    if (rx === 0 || ry === 0) return [];
    var sinphi = Math.sin(xAxisRotation * TAU / 360);
    var cosphi = Math.cos(xAxisRotation * TAU / 360);
    var pxp = cosphi * (px - cx) / 2 + sinphi * (py - cy) / 2;
    var pyp = -sinphi * (px - cx) / 2 + cosphi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return [];
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    var lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    var _getArcCenter = getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp), _getArcCenter2 = _slicedToArray(_getArcCenter, 4), centerx = _getArcCenter2[0], centery = _getArcCenter2[1], ang1 = _getArcCenter2[2], ang2 = _getArcCenter2[3];
    // If 'ang2' == 90.0000000001, then `ratio` will evaluate to
    // 1.0000000001. This causes `segments` to be greater than one, which is an
    // unecessary split, and adds extra points to the bezier curve. To alleviate
    // this issue, we round to 1.0 when the ratio is close to 1.0.
    var ratio = Math.abs(ang2) / (TAU / 4);
    if (Math.abs(1.0 - ratio) < 0.0000001) ratio = 1.0;
    var segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    for(var i = 0; i < segments; i++){
        curves.push(approxUnitArc(ang1, ang2));
        ang1 += ang2;
    }
    return curves.map(function(curve) {
        var _mapToEllipse = mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery), x1 = _mapToEllipse.x, y1 = _mapToEllipse.y;
        var _mapToEllipse2 = mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery), x2 = _mapToEllipse2.x, y2 = _mapToEllipse2.y;
        var _mapToEllipse3 = mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery), x = _mapToEllipse3.x, y = _mapToEllipse3.y;
        return {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            x: x,
            y: y
        };
    });
};
exports.default = arcToBezier;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lysB6":[function(require,module,exports) {
/* MIT license */ var colorNames = require("d7a6eeb7388b4bb");
var swizzle = require("248ce9e419a8df53");
var reverseNames = {};
// create a list of reverse color names
for(var name in colorNames)if (colorNames.hasOwnProperty(name)) reverseNames[colorNames[name]] = name;
var cs = module.exports = {
    to: {},
    get: {}
};
cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var keyword = /(\D+)/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) rgb[3] = parseFloat(match[4]);
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) rgb[3] = parseFloat(match[4]);
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        rgb = colorNames[match[1]];
        if (!rgb) return null;
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = clamp(rgb[i], 0, 255);
    rgb[3] = clamp(rgb[3], 0, 1);
    return rgb;
};
cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) + 360) % 360;
        var s = clamp(parseFloat(match[2]), 0, 100);
        var l = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = clamp(parseFloat(match[2]), 0, 100);
        var b = clamp(parseFloat(match[3]), 0, 100);
        var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
cs.to.hex = function() {
    var rgba = swizzle(arguments);
    return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : "");
};
cs.to.rgb = function() {
    var rgba = swizzle(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
cs.to.rgb.percent = function() {
    var rgba = swizzle(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
cs.to.hsl = function() {
    var hsla = swizzle(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function() {
    var hwba = swizzle(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
cs.to.keyword = function(rgb) {
    return reverseNames[rgb.slice(0, 3)];
};
// helpers
function clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function hexDouble(num) {
    var str = num.toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}

},{"d7a6eeb7388b4bb":"ftNU4","248ce9e419a8df53":"1oe5f"}],"ftNU4":[function(require,module,exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

},{}],"1oe5f":[function(require,module,exports) {
"use strict";
var isArrayish = require("ce0bf6d0bc000d24");
var concat = Array.prototype.concat;
var slice = Array.prototype.slice;
var swizzle = module.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if (isArrayish(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = concat.call(results, slice.call(arg));
        else results.push(arg);
    }
    return results;
};
swizzle.wrap = function(fn) {
    return function() {
        return fn(swizzle(arguments));
    };
};

},{"ce0bf6d0bc000d24":"6JS9S"}],"6JS9S":[function(require,module,exports) {
module.exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};

},{}],"wDNMs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmbeddedFont", ()=>EmbeddedFont);
parcelHelpers.export(exports, "PDFFont", ()=>PDFFont);
parcelHelpers.export(exports, "StandardFont", ()=>StandardFont);
parcelHelpers.export(exports, "default", ()=>PDFDocument);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _zstream = require("pako/lib/zlib/zstream");
var _zstreamDefault = parcelHelpers.interopDefault(_zstream);
var _deflateJs = require("pako/lib/zlib/deflate.js");
var _deflateJsDefault = parcelHelpers.interopDefault(_deflateJs);
var _inflateJs = require("pako/lib/zlib/inflate.js");
var _inflateJsDefault = parcelHelpers.interopDefault(_inflateJs);
var _constants = require("pako/lib/zlib/constants");
var _constantsDefault = parcelHelpers.interopDefault(_constants);
var _createForOfIteratorHelperLoose = require("@babel/runtime/helpers/createForOfIteratorHelperLoose");
var _createForOfIteratorHelperLooseDefault = parcelHelpers.interopDefault(_createForOfIteratorHelperLoose);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _md5 = require("crypto-js/md5");
var _md5Default = parcelHelpers.interopDefault(_md5);
var _fontkit = require("fontkit");
var _pngJs = require("@react-pdf/png-js");
var _pngJsDefault = parcelHelpers.interopDefault(_pngJs);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _core = require("crypto-js/core");
var global = arguments[3];
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var lookup$1 = [];
var revLookup$1 = [];
var Arr$1 = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var inited = false;
function init() {
    inited = true;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup$1[i] = code[i];
        revLookup$1[code.charCodeAt(i)] = i;
    }
    revLookup$1["-".charCodeAt(0)] = 62;
    revLookup$1["_".charCodeAt(0)] = 63;
}
function toByteArray$1(b64) {
    if (!inited) init();
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === "=" ? 2 : b64[len - 1] === "=" ? 1 : 0;
    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr$1(len * 3 / 4 - placeHolders);
    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;
    for(i = 0, j = 0; i < l; i += 4, j += 3){
        tmp = revLookup$1[b64.charCodeAt(i)] << 18 | revLookup$1[b64.charCodeAt(i + 1)] << 12 | revLookup$1[b64.charCodeAt(i + 2)] << 6 | revLookup$1[b64.charCodeAt(i + 3)];
        arr[L++] = tmp >> 16 & 0xFF;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    if (placeHolders === 2) {
        tmp = revLookup$1[b64.charCodeAt(i)] << 2 | revLookup$1[b64.charCodeAt(i + 1)] >> 4;
        arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
        tmp = revLookup$1[b64.charCodeAt(i)] << 10 | revLookup$1[b64.charCodeAt(i + 1)] << 4 | revLookup$1[b64.charCodeAt(i + 2)] >> 2;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64$1(num) {
    return lookup$1[num >> 18 & 0x3F] + lookup$1[num >> 12 & 0x3F] + lookup$1[num >> 6 & 0x3F] + lookup$1[num & 0x3F];
}
function encodeChunk$1(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
        output.push(tripletToBase64$1(tmp));
    }
    return output.join("");
}
function fromByteArray$1(uint8) {
    if (!inited) init();
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = "";
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk$1(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup$1[tmp >> 2];
        output += lookup$1[tmp << 4 & 0x3F];
        output += "==";
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        output += lookup$1[tmp >> 10];
        output += lookup$1[tmp >> 4 & 0x3F];
        output += lookup$1[tmp << 2 & 0x3F];
        output += "=";
    }
    parts.push(output);
    return parts.join("");
}
function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
}
var toString$1 = {}.toString;
var isArray = Array.isArray || function(arr) {
    return toString$1.call(arr) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ var INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer$4.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined ? global$1.TYPED_ARRAY_SUPPORT : true;
function kMaxLength() {
    return Buffer$4.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer$4.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer$4(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer$4(arg, encodingOrOffset, length) {
    if (!Buffer$4.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$4)) return new Buffer$4(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from$1(this, arg, encodingOrOffset, length);
}
Buffer$4.poolSize = 8192; // not used by this implementation
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer$4._augment = function(arr) {
    arr.__proto__ = Buffer$4.prototype;
    return arr;
};
function from$1(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer$4.from = function(value, encodingOrOffset, length) {
    return from$1(null, value, encodingOrOffset, length);
};
if (Buffer$4.TYPED_ARRAY_SUPPORT) {
    Buffer$4.prototype.__proto__ = Uint8Array.prototype;
    Buffer$4.__proto__ = Uint8Array;
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer$4.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer$4.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer$4.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer$4.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer$4.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength$1(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer$4.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (internalIsBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
Buffer$4.isBuffer = isBuffer;
function internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
}
Buffer$4.compare = function compare(a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer$4.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer$4.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer$4.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer$4.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!internalIsBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength$1(string, encoding) {
    if (internalIsBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer$4.byteLength = byteLength$1;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer$4.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer$4.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer$4.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer$4.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer$4.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer$4.prototype.equals = function equals(b) {
    if (!internalIsBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer$4.compare(this, b) === 0;
};
Buffer$4.prototype.inspect = function inspect() {
    var str = "";
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer$4.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer$4.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer$4.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer$4.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer$4.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer$4.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer$4.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer$4.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return fromByteArray$1(buf);
    else return fromByteArray$1(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex$1(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer$4.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer$4.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer$4(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer$4.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer$4.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer$4.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer$4.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer$4.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer$4.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer$4.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer$4.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer$4.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer$4.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer$4.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer$4.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer$4.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer$4.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer$4.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4);
};
Buffer$4.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4);
};
Buffer$4.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8);
};
Buffer$4.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer$4.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer$4.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer$4.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer$4.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer$4.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer$4.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer$4.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer$4.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer$4.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer$4.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer$4.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer$4.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer$4.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer$4.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer$4.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer$4.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer$4.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4);
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer$4.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer$4.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8);
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer$4.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer$4.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer$4.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer$4.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer$4.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer$4.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer$4(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex$1(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return toByteArray$1(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}
// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
}
function isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isFastBuffer(obj.slice(0, 0));
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
var readableBrowser = {
    exports: {}
};
var _registry = {};
// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === "function") cachedSetTimeout = setTimeout;
if (typeof global$1.clearTimeout === "function") cachedClearTimeout = clearTimeout;
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
var title = "browser";
var platform = "browser";
var browser$1 = true;
var env = {};
var argv = [];
var version = ""; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config$1 = {};
function noop$2() {}
var on = noop$2;
var addListener = noop$2;
var once$3 = noop$2;
var off = noop$2;
var removeListener = noop$2;
var removeAllListeners = noop$2;
var emit = noop$2;
function binding$1(name) {
    throw new Error("process.binding is not supported");
}
function cwd() {
    return "/";
}
function chdir(dir) {
    throw new Error("process.chdir is not supported");
}
function umask() {
    return 0;
}
// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function() {
    return new Date().getTime();
};
// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp) {
    var clocktime = performanceNow.call(performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds < 0) {
            seconds--;
            nanoseconds += 1e9;
        }
    }
    return [
        seconds,
        nanoseconds
    ];
}
var startTime = new Date();
function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
}
var browser$1$1 = {
    nextTick: nextTick,
    title: title,
    browser: browser$1,
    env: env,
    argv: argv,
    version: version,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once$3,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding$1,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config$1,
    uptime: uptime
};
var events = {
    exports: {}
};
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once$2;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function get() {
        return defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once$2(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}
var streamBrowser = events.exports.EventEmitter;
var buffer = {};
var base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ ieee754.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
ieee754.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ (function(exports) {
    var base64 = base64Js;
    var ieee754$1 = ieee754;
    var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
     ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
     : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Print warning and recommend using `buffer` v4.x which has an Object
   *               implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * We report that the browser does not support typed arrays if the are not subclassable
   * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
   * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
   * for __proto__ and has a buggy typed array implementation.
   */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            var arr = new Uint8Array(1);
            var proto = {
                foo: function foo() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, Uint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, "parent", {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, "offset", {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
        // Return an augmented `Uint8Array` instance
        var buf = new Uint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === "number") {
            if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === "string") return fromString(value, encodingOrOffset);
        if (ArrayBuffer.isView(value)) return fromArrayView(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
        var valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        var b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    };
    // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer, Uint8Array);
    function assertSize(size) {
        if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpreted as a start offset.
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
        if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        var length = byteLength(string, encoding) | 0;
        var buf = createBuffer(length);
        var actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        var length = array.length < 0 ? 0 : checked(array.length) | 0;
        var buf = createBuffer(length);
        for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayView(arrayView) {
        if (isInstance(arrayView, Uint8Array)) {
            var copy = new Uint8Array(arrayView);
            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        var buf;
        if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
        else if (length === undefined) buf = new Uint8Array(array, byteOffset);
        else buf = new Uint8Array(array, byteOffset, length);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            var len = checked(obj.length) | 0;
            var buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) // eslint-disable-line eqeqeq
        length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        var i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        var buffer = Buffer.allocUnsafe(length);
        var pos = 0;
        for(i = 0; i < list.length; ++i){
            var buf = list[i];
            if (isInstance(buf, Uint8Array)) {
                if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
                else Uint8Array.prototype.set.call(buffer, buf, pos);
            } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            else buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
        if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
        var len = string.length;
        var mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0;
        // Use a for loop to avoid recursion
        var loweredCase = false;
        for(;;)switch(encoding){
            case "ascii":
            case "latin1":
            case "binary":
                return len;
            case "utf8":
            case "utf-8":
                return utf8ToBytes(string).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return len * 2;
            case "hex":
                return len >>> 1;
            case "base64":
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        var loweredCase = false;
        // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
        // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return "";
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return "";
        // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return "";
        if (!encoding) encoding = "utf8";
        while(true)switch(encoding){
            case "hex":
                return hexSlice(this, start, end);
            case "utf8":
            case "utf-8":
                return utf8Slice(this, start, end);
            case "ascii":
                return asciiSlice(this, start, end);
            case "latin1":
            case "binary":
                return latin1Slice(this, start, end);
            case "base64":
                return base64Slice(this, start, end);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = (encoding + "").toLowerCase();
                loweredCase = true;
        }
    }
    // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        var i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        var len = this.length;
        if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        var len = this.length;
        if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for(var i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        var len = this.length;
        if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for(var i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        var length = this.length;
        if (length === 0) return "";
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        var str = "";
        var max = exports.INSPECT_MAX_BYTES;
        str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
        if (this.length > max) str += " ... ";
        return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        var x = thisEnd - thisStart;
        var y = end - start;
        var len = Math.min(x, y);
        var thisCopy = this.slice(thisStart, thisEnd);
        var targetCopy = target.slice(start, end);
        for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1;
        // Normalize byteOffset
        if (typeof byteOffset === "string") {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
        // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        }
        // Normalize val
        if (typeof val === "string") val = Buffer.from(val, encoding);
        // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === "number") {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof Uint8Array.prototype.indexOf === "function") {
                if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        var indexSize = 1;
        var arrLength = arr.length;
        var valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        var i;
        if (dir) {
            var foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                var found = true;
                for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        var remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        var strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        for(var i = 0; i < length; ++i){
            var parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = "utf8";
            length = this.length;
            offset = 0;
        // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === "string") {
            encoding = offset;
            length = this.length;
            offset = 0;
        // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = "utf8";
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        var remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        if (!encoding) encoding = "utf8";
        var loweredCase = false;
        for(;;)switch(encoding){
            case "hex":
                return hexWrite(this, string, offset, length);
            case "utf8":
            case "utf-8":
                return utf8Write(this, string, offset, length);
            case "ascii":
            case "latin1":
            case "binary":
                return asciiWrite(this, string, offset, length);
            case "base64":
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
        else return base64.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        var res = [];
        var i = start;
        while(i < end){
            var firstByte = buf[i];
            var codePoint = null;
            var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                var secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    }
    // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        var len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
        // Decode in chunks to avoid "call stack size exceeded".
        var res = "";
        var i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        var ret = "";
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        var ret = "";
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        var len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        var out = "";
        for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        var bytes = buf.slice(start, end);
        var res = "";
        // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
        for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        var len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        var newBuf = this.subarray(start, end);
        // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
        if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset + --byteLength];
        var mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var i = byteLength;
        var mul = 1;
        var val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
    }
    Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var mul = 1;
        var i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var i = byteLength - 1;
        var mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = 0;
        var mul = 1;
        var sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = byteLength - 1;
        var mul = 1;
        var sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
        if (offset < 0) throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    };
    // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start;
        // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0;
        // Fatal error conditions
        if (targetStart < 0) throw new RangeError("targetStart out of bounds");
        if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
        if (end < 0) throw new RangeError("sourceEnd out of bounds");
        // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        var len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    };
    // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === "string") {
            if (typeof start === "string") {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === "string") {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
            if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
            if (val.length === 1) {
                var code = val.charCodeAt(0);
                if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === "number") val = val & 255;
        else if (typeof val === "boolean") val = Number(val);
        // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        var i;
        if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
        else {
            var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            var len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    };
    // HELPER FUNCTIONS
    // ================
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split("=")[0];
        // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, "");
        // Node converts strings with length < 2 to ''
        if (str.length < 2) return "";
        // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + "=";
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        var codePoint;
        var length = string.length;
        var leadSurrogate = null;
        var bytes = [];
        for(var i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i);
            // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    }
                    // valid lead
                    leadSurrogate = codePoint;
                    continue;
                }
                // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                }
                // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null;
            // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error("Invalid code point");
        }
        return bytes;
    }
    function asciiToBytes(str) {
        var byteArray = [];
        for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        var c, hi, lo;
        var byteArray = [];
        for(var i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        for(var i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    }
    // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj; // eslint-disable-line no-self-compare
    }
    // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    var hexSliceLookupTable = function() {
        var alphabet = "0123456789abcdef";
        var table = new Array(256);
        for(var i = 0; i < 16; ++i){
            var i16 = i * 16;
            for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
})(buffer);
var _nodeResolve_empty = {};
var _nodeResolve_empty$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    "default": _nodeResolve_empty
});
var require$$4 = /*@__PURE__*/ getAugmentedNamespace(_nodeResolve_empty$1);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck$3(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
}
var _require$4 = buffer, Buffer$3 = _require$4.Buffer;
var _require2$2 = require$$4, inspect$2 = _require2$2.inspect;
var custom = inspect$2 && inspect$2.custom || "inspect";
function copyBuffer(src, target, offset) {
    Buffer$3.prototype.copy.call(src, target, offset);
}
var buffer_list = /*#__PURE__*/ function() {
    function BufferList() {
        _classCallCheck$3(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    _createClass$1(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return Buffer$3.alloc(0);
                var ret = Buffer$3.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = Buffer$3.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: custom,
            value: function value(_, options) {
                return inspect$2(this, _objectSpread$1({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) browser$1$1.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                browser$1$1.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) browser$1$1.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                browser$1$1.nextTick(emitErrorAndCloseNT, _this, err);
            } else browser$1$1.nextTick(emitCloseNT, _this);
        } else if (cb) {
            browser$1$1.nextTick(emitCloseNT, _this);
            cb(err);
        } else browser$1$1.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self1, err) {
    emitErrorNT(self1, err);
    emitCloseNT(self1);
}
function emitCloseNT(self1) {
    if (self1._writableState && !self1._writableState.emitClose) return;
    if (self1._readableState && !self1._readableState.emitClose) return;
    self1.emit("close");
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self1, err) {
    self1.emit("error", err);
}
function errorOrDestroy$2(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
var destroy_1 = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy$2
};
var errorsBrowser = {};
function _inheritsLoose1(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes$1 = {};
function createErrorType$1(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose1(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes$1[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf$1(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith$1(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith$2(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes$1(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType$1("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType$1("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith$1(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith$2(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf$1(expected, "type"));
    else {
        var type = includes$1(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf$1(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType$1("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
createErrorType$1("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
createErrorType$1("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
createErrorType$1("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
createErrorType$1("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
createErrorType$1("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
createErrorType$1("ERR_STREAM_WRITE_AFTER_END", "write after end");
createErrorType$1("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
createErrorType$1("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
createErrorType$1("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
errorsBrowser.codes = codes$1;
var ERR_INVALID_OPT_VALUE = errorsBrowser.codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark$2(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
var state = {
    getHighWaterMark: getHighWaterMark$2
};
var inherits_browser = {
    exports: {}
};
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
inherits_browser.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
inherits_browser.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};
var string_decoder = {};
var safeBuffer = {
    exports: {}
};
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ (function(module, exports) {
    /* eslint-disable node/no-deprecated-api */ var buffer$1 = buffer;
    var Buffer = buffer$1.Buffer;
    // alternative to using Object.keys for old browsers
    function copyProps(src, dst) {
        for(var key in src)dst[key] = src[key];
    }
    if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer$1;
    else {
        // Copy properties from require('buffer')
        copyProps(buffer$1, exports);
        exports.Buffer = SafeBuffer;
    }
    function SafeBuffer(arg, encodingOrOffset, length) {
        return Buffer(arg, encodingOrOffset, length);
    }
    SafeBuffer.prototype = Object.create(Buffer.prototype);
    // Copy static methods from Buffer
    copyProps(Buffer, SafeBuffer);
    SafeBuffer.from = function(arg, encodingOrOffset, length) {
        if (typeof arg === "number") throw new TypeError("Argument must not be a number");
        return Buffer(arg, encodingOrOffset, length);
    };
    SafeBuffer.alloc = function(size, fill, encoding) {
        if (typeof size !== "number") throw new TypeError("Argument must be a number");
        var buf = Buffer(size);
        if (fill !== undefined) {
            if (typeof encoding === "string") buf.fill(fill, encoding);
            else buf.fill(fill);
        } else buf.fill(0);
        return buf;
    };
    SafeBuffer.allocUnsafe = function(size) {
        if (typeof size !== "number") throw new TypeError("Argument must be a number");
        return Buffer(size);
    };
    SafeBuffer.allocUnsafeSlow = function(size) {
        if (typeof size !== "number") throw new TypeError("Argument must be a number");
        return buffer$1.SlowBuffer(size);
    };
})(safeBuffer, safeBuffer.exports);
/*<replacement>*/ var Buffer$2 = safeBuffer.exports.Buffer;
/*</replacement>*/ var isEncoding = Buffer$2.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== "string" && (Buffer$2.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
string_decoder.StringDecoder = StringDecoder$1;
function StringDecoder$1(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer$2.allocUnsafe(nb);
}
StringDecoder$1.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
StringDecoder$1.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder$1.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder$1.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self1, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self1.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self1.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self1.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self1, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self1.lastNeed = 0;
        return "\uFFFD";
    }
    if (self1.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self1.lastNeed = 1;
            return "\uFFFD";
        }
        if (self1.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self1.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}
var ERR_STREAM_PREMATURE_CLOSE = errorsBrowser.codes.ERR_STREAM_PREMATURE_CLOSE;
function once$1(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop$1() {}
function isRequest$1(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function eos$1(stream, opts, callback) {
    if (typeof opts === "function") return eos$1(stream, null, opts);
    if (!opts) opts = {};
    callback = once$1(callback || noop$1);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if (isRequest$1(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
var endOfStream = eos$1;
var _Object$setPrototypeO;
function _defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var finished = endOfStream;
var kLastResolve = Symbol("lastResolve");
var kLastReject = Symbol("lastReject");
var kError = Symbol("error");
var kEnded = Symbol("ended");
var kLastPromise = Symbol("lastPromise");
var kHandlePromise = Symbol("handlePromise");
var kStream = Symbol("stream");
function createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
        var data = iter[kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[kLastPromise] = null;
            iter[kLastResolve] = null;
            iter[kLastReject] = null;
            resolve(createIterResult(data, false));
        }
    }
}
function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    browser$1$1.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
            }
            iter[kHandlePromise](resolve, reject);
        }, reject);
    };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream () {
        return this[kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[kError];
        if (error !== null) return Promise.reject(error);
        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            browser$1$1.nextTick(function() {
                if (_this[kError]) reject(_this[kError]);
                else resolve(createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[kStream].read();
            if (data !== null) return Promise.resolve(createIterResult(data, false));
            promise = new Promise(this[kHandlePromise]);
        }
        this[kLastPromise] = promise;
        return promise;
    }
}, _defineProperty$1(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), _defineProperty$1(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve(createIterResult(undefined, true));
        });
    });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator$1 = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty$1(_Object$create, kStream, {
        value: stream,
        writable: true
    }), _defineProperty$1(_Object$create, kLastResolve, {
        value: null,
        writable: true
    }), _defineProperty$1(_Object$create, kLastReject, {
        value: null,
        writable: true
    }), _defineProperty$1(_Object$create, kError, {
        value: null,
        writable: true
    }), _defineProperty$1(_Object$create, kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), _defineProperty$1(_Object$create, kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[kStream].read();
            if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
            } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    finished(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
            }
            iterator[kError] = err;
            return;
        }
        var resolve = iterator[kLastResolve];
        if (resolve !== null) {
            iterator[kLastPromise] = null;
            iterator[kLastResolve] = null;
            iterator[kLastReject] = null;
            resolve(createIterResult(undefined, true));
        }
        iterator[kEnded] = true;
    });
    stream.on("readable", onReadable.bind(null, iterator));
    return iterator;
};
var async_iterator = createReadableStreamAsyncIterator$1;
var fromBrowser = function fromBrowser() {
    throw new Error("Readable.from is not available in the browser");
};
var Registry$4 = _registry;
Registry$4.Readable = Readable;
Readable.ReadableState = ReadableState;
/*<replacement>*/ events.exports.EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream$1 = streamBrowser;
/*</replacement>*/ var Buffer$1 = buffer.Buffer;
var OurUint8Array$1 = commonjsGlobal.Uint8Array || function() {};
function _uint8ArrayToBuffer$1(chunk) {
    return Buffer$1.from(chunk);
}
function _isUint8Array$1(obj) {
    return Buffer$1.isBuffer(obj) || obj instanceof OurUint8Array$1;
}
/*<replacement>*/ var debugUtil = require$$4;
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog("stream");
else debug = function debug() {};
/*</replacement>*/ var BufferList = buffer_list;
var destroyImpl$1 = destroy_1;
var _require$3 = state, getHighWaterMark$1 = _require$3.getHighWaterMark;
var _require$codes$4 = errorsBrowser.codes, ERR_INVALID_ARG_TYPE$3 = _require$codes$4.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes$4.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED$2 = _require$codes$4.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes$4.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
inherits_browser.exports(Readable, Stream$1);
var errorOrDestroy$1 = destroyImpl$1.errorOrDestroy;
var kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Registry$4.Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark$1(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = string_decoder.StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Registry$4.Duplex;
    this._readableState = new ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    Stream$1.call(this);
}
Object.defineProperty(Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl$1.destroy;
Readable.prototype._undestroy = destroyImpl$1.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer$1.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy$1(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer$1.prototype) chunk = _uint8ArrayToBuffer$1(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy$1(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy$1(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array$1(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE$3("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = string_decoder.StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        browser$1$1.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        browser$1$1.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy$1(this, new ERR_METHOD_NOT_IMPLEMENTED$2("_read()"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== browser$1$1.stdout && dest !== browser$1$1.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) browser$1$1.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug("onend");
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup"); // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        var ret = dest.write(chunk);
        debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (EElistenerCount(dest, "error") === 0) errorOrDestroy$1(dest, er);
    } // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit("pipe", src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream$1.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug("on readable", state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) browser$1$1.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream$1.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    browser$1$1.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream$1.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    browser$1$1.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume"); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        browser$1$1.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === "function") Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = async_iterator;
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        browser$1$1.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === "function") Readable.from = function(iterable, opts) {
    if (from === undefined) from = fromBrowser;
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
/**
 * Module exports.
 */ var browser = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config("throwDeprecation")) throw new Error(msg);
            else if (config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!commonjsGlobal.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = commonjsGlobal.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}
var Registry$3 = _registry;
Registry$3.Writable = Writable;
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ /*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: browser
};
/*</replacement>*/ /*<replacement>*/ var Stream = streamBrowser;
/*</replacement>*/ var Buffer = buffer.Buffer;
var OurUint8Array = commonjsGlobal.Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = destroy_1;
var _require$2 = state, getHighWaterMark = _require$2.getHighWaterMark;
var _require$codes$3 = errorsBrowser.codes, ERR_INVALID_ARG_TYPE$2 = _require$codes$3.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED$1 = _require$codes$3.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK$1 = _require$codes$3.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes$3.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED$1 = _require$codes$3.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes$3.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes$3.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes$3.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
inherits_browser.exports(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof Registry$3.Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, "buffer", {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Registry$3.Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    Stream.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    browser$1$1.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new ERR_INVALID_ARG_TYPE$2("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        browser$1$1.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED$1("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        browser$1$1.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        browser$1$1.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new ERR_MULTIPLE_CALLBACK$1();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) browser$1$1.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
} // if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED$1("_write()"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        finishMaybe(stream, state);
    });
}
function prefinish$1(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            browser$1$1.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish$1(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) browser$1$1.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
/*<replacement>*/ var objectKeys$1 = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ var Registry$2 = _registry;
Registry$2.Duplex = Duplex;
inherits_browser.exports(Duplex, Registry$2.Readable);
// Allow the keys array to be GC'ed.
var keys$1 = objectKeys$1(Registry$2.Writable.prototype);
for(var v = 0; v < keys$1.length; v++){
    var method = keys$1[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Registry$2.Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Registry$2.Readable.call(this, options);
    Registry$2.Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    browser$1$1.nextTick(onEndNT, this);
}
function onEndNT(self1) {
    self1.end();
}
Object.defineProperty(Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
var Registry$1 = _registry;
Registry$1.Transform = Transform$1;
var _require$codes$2 = errorsBrowser.codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes$2.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes$2.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes$2.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes$2.ERR_TRANSFORM_WITH_LENGTH_0;
inherits_browser.exports(Transform$1, Registry$1.Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform$1(options) {
    if (!(this instanceof Transform$1)) return new Transform$1(options);
    Registry$1.Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform$1.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Registry$1.Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform$1.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
Transform$1.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform$1.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform$1.prototype._destroy = function(err, cb) {
    Registry$1.Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}
var Registry = _registry;
Registry.PassThrough = PassThrough;
inherits_browser.exports(PassThrough, Registry.Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes$1 = errorsBrowser.codes, ERR_MISSING_ARGS$1 = _require$codes$1.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes$1.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if (eos === undefined) eos = endOfStream;
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED("pipe"));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== "function") return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS$1("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
var pipeline_1 = pipeline;
(function(module, exports) {
    var Registry = _registry;
    exports = module.exports = Registry.Readable;
    exports.Stream = Registry.Readable;
    exports.Readable = Registry.Readable;
    exports.Writable = Registry.Writable;
    exports.Duplex = Registry.Duplex;
    exports.Transform = Registry.Transform;
    exports.PassThrough = Registry.PassThrough;
    exports.finished = endOfStream;
    exports.pipeline = pipeline_1;
})(readableBrowser, readableBrowser.exports);
var stream = readableBrowser.exports;
var lib = {};
var binding = {};
var assert$2 = {
    exports: {}
};
var errors = {};
var util$1 = {};
var types = {};
/* eslint complexity: [2, 18], max-statements: [2, 33] */ var shams$1 = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams$1;
var hasSymbols$3 = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice$1 = Array.prototype.slice;
var toStr$4 = Object.prototype.toString;
var funcType = "[object Function]";
var implementation$8 = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr$4.call(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slice$1.call(arguments, 1);
    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice$1.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat(slice$1.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};
var implementation$7 = implementation$8;
var functionBind = Function.prototype.bind || implementation$7;
var bind$1 = functionBind;
var src = bind$1.call(Function.call, Object.prototype.hasOwnProperty);
var undefined$1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) try {
    $gOPD$1({}, "");
} catch (e) {
    $gOPD$1 = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function throwTypeError() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD$1 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD$1(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols$2 = hasSymbols$3();
var getProto$1 = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined$1 : getProto$1(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols$2 ? getProto$1([][Symbol.iterator]()) : undefined$1,
    "%AsyncFromSyncIteratorPrototype%": undefined$1,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols$2 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
    "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
    "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols$2 ? undefined$1 : getProto$1(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols$2 ? undefined$1 : getProto$1(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols$2 ? getProto$1(""[Symbol.iterator]()) : undefined$1,
    "%Symbol%": hasSymbols$2 ? Symbol : undefined$1,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = getProto$1(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = functionBind;
var hasOwn$1 = src;
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn$1(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn$1(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD$1 && i + 1 >= parts.length) {
                var desc = $gOPD$1(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn$1(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};
var callBind$3 = {
    exports: {}
};
(function(module) {
    var bind = functionBind;
    var GetIntrinsic = getIntrinsic;
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
    var $max = GetIntrinsic("%Math.max%");
    if ($defineProperty) try {
        $defineProperty({}, "a", {
            value: 1
        });
    } catch (e) {
        // IE 8 has a broken defineProperty
        $defineProperty = null;
    }
    module.exports = function callBind(originalFunction) {
        var func = $reflectApply(bind, $call, arguments);
        if ($gOPD && $defineProperty) {
            var desc = $gOPD(func, "length");
            if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
            $defineProperty(func, "length", {
                value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
            });
        }
        return func;
    };
    var applyBind = function applyBind() {
        return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty) $defineProperty(module.exports, "apply", {
        value: applyBind
    });
    else module.exports.apply = applyBind;
})(callBind$3);
var GetIntrinsic$1 = getIntrinsic;
var callBind$2 = callBind$3.exports;
var $indexOf$1 = callBind$2(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$3 = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic$1(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf$1(name, ".prototype.") > -1) return callBind$2(intrinsic);
    return intrinsic;
};
var hasToStringTag$3 = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
var callBound$2 = callBound$3;
var $toString$2 = callBound$2("Object.prototype.toString");
var isStandardArguments = function isArguments(value) {
    if (hasToStringTag$3 && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $toString$2(value) === "[object Arguments]";
};
var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString$2(value) !== "[object Array]" && $toString$2(value.callee) === "[object Function]";
};
var supportsStandardArguments = function() {
    return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
var hasSymbols$1 = shams$1;
var shams = function hasToStringTagShams() {
    return hasSymbols$1() && !!Symbol.toStringTag;
};
var toStr$3 = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag$2 = shams();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function getGeneratorFunc() {
    // eslint-disable-line consistent-return
    if (!hasToStringTag$2) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var GeneratorFunction;
var isGeneratorFunction = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if (isFnRegex.test(fnToStr.call(fn))) return true;
    if (!hasToStringTag$2) {
        var str = toStr$3.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!getProto) return false;
    if (typeof GeneratorFunction === "undefined") {
        var generatorFunc = getGeneratorFunc();
        GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
    }
    return getProto(fn) === GeneratorFunction;
};
var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var foreach = function forEach(obj, fn, ctx) {
    if (toString.call(fn) !== "[object Function]") throw new TypeError("iterator must be a function");
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if (hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};
var possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var g$2 = typeof globalThis === "undefined" ? commonjsGlobal : globalThis;
var availableTypedArrays$2 = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < possibleNames.length; i++)if (typeof g$2[possibleNames[i]] === "function") out[out.length] = possibleNames[i];
    return out;
};
var GetIntrinsic = getIntrinsic;
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) try {
    $gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
var getOwnPropertyDescriptor = $gOPD;
var forEach$1 = foreach;
var availableTypedArrays$1 = availableTypedArrays$2;
var callBound$1 = callBound$3;
var $toString$1 = callBound$1("Object.prototype.toString");
var hasToStringTag$1 = shams();
var g$1 = typeof globalThis === "undefined" ? commonjsGlobal : globalThis;
var typedArrays$1 = availableTypedArrays$1();
var $indexOf = callBound$1("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $slice$1 = callBound$1("String.prototype.slice");
var toStrTags$1 = {};
var gOPD$1 = getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag$1 && gOPD$1 && getPrototypeOf$1) forEach$1(typedArrays$1, function(typedArray) {
    var arr = new g$1[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = getPrototypeOf$1(arr);
        var descriptor = gOPD$1(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = getPrototypeOf$1(proto);
            descriptor = gOPD$1(superProto, Symbol.toStringTag);
        }
        toStrTags$1[typedArray] = descriptor.get;
    }
});
var tryTypedArrays$1 = function tryAllTypedArrays(value) {
    var anyTrue = false;
    forEach$1(toStrTags$1, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
var isTypedArray$1 = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!hasToStringTag$1 || !(Symbol.toStringTag in value)) {
        var tag = $slice$1($toString$1(value), 8, -1);
        return $indexOf(typedArrays$1, tag) > -1;
    }
    if (!gOPD$1) return false;
    return tryTypedArrays$1(value);
};
var forEach = foreach;
var availableTypedArrays = availableTypedArrays$2;
var callBound = callBound$3;
var $toString = callBound("Object.prototype.toString");
var hasToStringTag = shams();
var g = typeof globalThis === "undefined" ? commonjsGlobal : globalThis;
var typedArrays = availableTypedArrays();
var $slice = callBound("String.prototype.slice");
var toStrTags = {};
var gOPD = getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) forEach(typedArrays, function(typedArray) {
    if (typeof g[typedArray] === "function") {
        var arr = new g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = getPrototypeOf(arr);
            var descriptor = gOPD(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = getPrototypeOf(proto);
                descriptor = gOPD(superProto, Symbol.toStringTag);
            }
            toStrTags[typedArray] = descriptor.get;
        }
    }
});
var tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    forEach(toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};
var isTypedArray = isTypedArray$1;
var whichTypedArray = function whichTypedArray(value) {
    if (!isTypedArray(value)) return false;
    if (!hasToStringTag || !(Symbol.toStringTag in value)) return $slice($toString(value), 8, -1);
    return tryTypedArrays(value);
};
(function(exports) {
    var isArgumentsObject = isArguments$1;
    var isGeneratorFunction$1 = isGeneratorFunction;
    var whichTypedArray$1 = whichTypedArray;
    var isTypedArray = isTypedArray$1;
    function uncurryThis(f) {
        return f.call.bind(f);
    }
    var BigIntSupported = typeof BigInt !== "undefined";
    var SymbolSupported = typeof Symbol !== "undefined";
    var ObjectToString = uncurryThis(Object.prototype.toString);
    var numberValue = uncurryThis(Number.prototype.valueOf);
    var stringValue = uncurryThis(String.prototype.valueOf);
    var booleanValue = uncurryThis(Boolean.prototype.valueOf);
    if (BigIntSupported) var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
    if (SymbolSupported) var symbolValue = uncurryThis(Symbol.prototype.valueOf);
    function checkBoxedPrimitive(value, prototypeValueOf) {
        if (typeof value !== "object") return false;
        try {
            prototypeValueOf(value);
            return true;
        } catch (e) {
            return false;
        }
    }
    exports.isArgumentsObject = isArgumentsObject;
    exports.isGeneratorFunction = isGeneratorFunction$1;
    exports.isTypedArray = isTypedArray;
    // Taken from here and modified for better browser support
    // https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
    function isPromise(input) {
        return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
    }
    exports.isPromise = isPromise;
    function isArrayBufferView(value) {
        if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
        return isTypedArray(value) || isDataView(value);
    }
    exports.isArrayBufferView = isArrayBufferView;
    function isUint8Array(value) {
        return whichTypedArray$1(value) === "Uint8Array";
    }
    exports.isUint8Array = isUint8Array;
    function isUint8ClampedArray(value) {
        return whichTypedArray$1(value) === "Uint8ClampedArray";
    }
    exports.isUint8ClampedArray = isUint8ClampedArray;
    function isUint16Array(value) {
        return whichTypedArray$1(value) === "Uint16Array";
    }
    exports.isUint16Array = isUint16Array;
    function isUint32Array(value) {
        return whichTypedArray$1(value) === "Uint32Array";
    }
    exports.isUint32Array = isUint32Array;
    function isInt8Array(value) {
        return whichTypedArray$1(value) === "Int8Array";
    }
    exports.isInt8Array = isInt8Array;
    function isInt16Array(value) {
        return whichTypedArray$1(value) === "Int16Array";
    }
    exports.isInt16Array = isInt16Array;
    function isInt32Array(value) {
        return whichTypedArray$1(value) === "Int32Array";
    }
    exports.isInt32Array = isInt32Array;
    function isFloat32Array(value) {
        return whichTypedArray$1(value) === "Float32Array";
    }
    exports.isFloat32Array = isFloat32Array;
    function isFloat64Array(value) {
        return whichTypedArray$1(value) === "Float64Array";
    }
    exports.isFloat64Array = isFloat64Array;
    function isBigInt64Array(value) {
        return whichTypedArray$1(value) === "BigInt64Array";
    }
    exports.isBigInt64Array = isBigInt64Array;
    function isBigUint64Array(value) {
        return whichTypedArray$1(value) === "BigUint64Array";
    }
    exports.isBigUint64Array = isBigUint64Array;
    function isMapToString(value) {
        return ObjectToString(value) === "[object Map]";
    }
    isMapToString.working = typeof Map !== "undefined" && isMapToString(new Map());
    function isMap(value) {
        if (typeof Map === "undefined") return false;
        return isMapToString.working ? isMapToString(value) : value instanceof Map;
    }
    exports.isMap = isMap;
    function isSetToString(value) {
        return ObjectToString(value) === "[object Set]";
    }
    isSetToString.working = typeof Set !== "undefined" && isSetToString(new Set());
    function isSet(value) {
        if (typeof Set === "undefined") return false;
        return isSetToString.working ? isSetToString(value) : value instanceof Set;
    }
    exports.isSet = isSet;
    function isWeakMapToString(value) {
        return ObjectToString(value) === "[object WeakMap]";
    }
    isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(new WeakMap());
    function isWeakMap(value) {
        if (typeof WeakMap === "undefined") return false;
        return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
    }
    exports.isWeakMap = isWeakMap;
    function isWeakSetToString(value) {
        return ObjectToString(value) === "[object WeakSet]";
    }
    isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(new WeakSet());
    function isWeakSet(value) {
        return isWeakSetToString(value);
    }
    exports.isWeakSet = isWeakSet;
    function isArrayBufferToString(value) {
        return ObjectToString(value) === "[object ArrayBuffer]";
    }
    isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
    function isArrayBuffer(value) {
        if (typeof ArrayBuffer === "undefined") return false;
        return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
    }
    exports.isArrayBuffer = isArrayBuffer;
    function isDataViewToString(value) {
        return ObjectToString(value) === "[object DataView]";
    }
    isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
    function isDataView(value) {
        if (typeof DataView === "undefined") return false;
        return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
    }
    exports.isDataView = isDataView;
    // Store a copy of SharedArrayBuffer in case it's deleted elsewhere
    var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
    function isSharedArrayBufferToString(value) {
        return ObjectToString(value) === "[object SharedArrayBuffer]";
    }
    function isSharedArrayBuffer(value) {
        if (typeof SharedArrayBufferCopy === "undefined") return false;
        if (typeof isSharedArrayBufferToString.working === "undefined") isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
        return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
    }
    exports.isSharedArrayBuffer = isSharedArrayBuffer;
    function isAsyncFunction(value) {
        return ObjectToString(value) === "[object AsyncFunction]";
    }
    exports.isAsyncFunction = isAsyncFunction;
    function isMapIterator(value) {
        return ObjectToString(value) === "[object Map Iterator]";
    }
    exports.isMapIterator = isMapIterator;
    function isSetIterator(value) {
        return ObjectToString(value) === "[object Set Iterator]";
    }
    exports.isSetIterator = isSetIterator;
    function isGeneratorObject(value) {
        return ObjectToString(value) === "[object Generator]";
    }
    exports.isGeneratorObject = isGeneratorObject;
    function isWebAssemblyCompiledModule(value) {
        return ObjectToString(value) === "[object WebAssembly.Module]";
    }
    exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
    function isNumberObject(value) {
        return checkBoxedPrimitive(value, numberValue);
    }
    exports.isNumberObject = isNumberObject;
    function isStringObject(value) {
        return checkBoxedPrimitive(value, stringValue);
    }
    exports.isStringObject = isStringObject;
    function isBooleanObject(value) {
        return checkBoxedPrimitive(value, booleanValue);
    }
    exports.isBooleanObject = isBooleanObject;
    function isBigIntObject(value) {
        return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
    }
    exports.isBigIntObject = isBigIntObject;
    function isSymbolObject(value) {
        return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
    }
    exports.isSymbolObject = isSymbolObject;
    function isBoxedPrimitive(value) {
        return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
    }
    exports.isBoxedPrimitive = isBoxedPrimitive;
    function isAnyArrayBuffer(value) {
        return typeof Uint8Array !== "undefined" && (isArrayBuffer(value) || isSharedArrayBuffer(value));
    }
    exports.isAnyArrayBuffer = isAnyArrayBuffer;
    [
        "isProxy",
        "isExternal",
        "isModuleNamespaceObject"
    ].forEach(function(method) {
        Object.defineProperty(exports, method, {
            enumerable: false,
            value: function value() {
                throw new Error(method + " is not supported in userland");
            }
        });
    });
})(types);
var isBufferBrowser = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};
(function(exports) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
        var keys = Object.keys(obj);
        var descriptors = {};
        for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
        return descriptors;
    };
    var formatRegExp = /%[sdj%]/g;
    exports.format = function(f) {
        if (!isString(f)) {
            var objects = [];
            for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
            return objects.join(" ");
        }
        var i = 1;
        var args = arguments;
        var len = args.length;
        var str = String(f).replace(formatRegExp, function(x) {
            if (x === "%%") return "%";
            if (i >= len) return x;
            switch(x){
                case "%s":
                    return String(args[i++]);
                case "%d":
                    return Number(args[i++]);
                case "%j":
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return "[Circular]";
                    }
                default:
                    return x;
            }
        });
        for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
        else str += " " + inspect(x);
        return str;
    };
    // Mark that a method should not be used.
    // Returns a modified function which warns once by default.
    // If --no-deprecation is set, then it is a no-op.
    exports.deprecate = function(fn, msg) {
        if (typeof browser$1$1 !== "undefined" && browser$1$1.noDeprecation === true) return fn;
        // Allow for deprecating things in the process of starting up.
        if (typeof browser$1$1 === "undefined") return function() {
            return exports.deprecate(fn, msg).apply(this, arguments);
        };
        var warned = false;
        function deprecated() {
            if (!warned) {
                console.error(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    };
    var debugs = {};
    var debugEnvRegex = /^$/;
    if (browser$1$1.env.NODE_DEBUG) {
        var debugEnv = browser$1$1.env.NODE_DEBUG;
        debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase();
        debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
    }
    exports.debuglog = function(set) {
        set = set.toUpperCase();
        if (!debugs[set]) {
            if (debugEnvRegex.test(set)) {
                var pid = browser$1$1.pid;
                debugs[set] = function() {
                    var msg = exports.format.apply(exports, arguments);
                    console.error("%s %d: %s", set, pid, msg);
                };
            } else debugs[set] = function() {};
        }
        return debugs[set];
    };
    /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
        // default options
        var ctx = {
            seen: [],
            stylize: stylizeNoColor
        };
        // legacy...
        if (arguments.length >= 3) ctx.depth = arguments[2];
        if (arguments.length >= 4) ctx.colors = arguments[3];
        if (isBoolean(opts)) // legacy...
        ctx.showHidden = opts;
        else if (opts) // got an "options" object
        exports._extend(ctx, opts);
        // set default options
        if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
        if (isUndefined(ctx.depth)) ctx.depth = 2;
        if (isUndefined(ctx.colors)) ctx.colors = false;
        if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
        if (ctx.colors) ctx.stylize = stylizeWithColor;
        return formatValue(ctx, obj, ctx.depth);
    }
    exports.inspect = inspect;
    // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
    inspect.colors = {
        "bold": [
            1,
            22
        ],
        "italic": [
            3,
            23
        ],
        "underline": [
            4,
            24
        ],
        "inverse": [
            7,
            27
        ],
        "white": [
            37,
            39
        ],
        "grey": [
            90,
            39
        ],
        "black": [
            30,
            39
        ],
        "blue": [
            34,
            39
        ],
        "cyan": [
            36,
            39
        ],
        "green": [
            32,
            39
        ],
        "magenta": [
            35,
            39
        ],
        "red": [
            31,
            39
        ],
        "yellow": [
            33,
            39
        ]
    };
    // Don't use 'blue' not visible on cmd.exe
    inspect.styles = {
        "special": "cyan",
        "number": "yellow",
        "boolean": "yellow",
        "undefined": "grey",
        "null": "bold",
        "string": "green",
        "date": "magenta",
        // "name": intentionally not styling
        "regexp": "red"
    };
    function stylizeWithColor(str, styleType) {
        var style = inspect.styles[styleType];
        if (style) return "\x1b[" + inspect.colors[style][0] + "m" + str + "\x1b[" + inspect.colors[style][1] + "m";
        else return str;
    }
    function stylizeNoColor(str, styleType) {
        return str;
    }
    function arrayToHash(array) {
        var hash = {};
        array.forEach(function(val, idx) {
            hash[val] = true;
        });
        return hash;
    }
    function formatValue(ctx, value, recurseTimes) {
        // Provide a hook for user-specified inspect functions.
        // Check that value is an object with an inspect function on it
        if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
        value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
        !(value.constructor && value.constructor.prototype === value)) {
            var ret = value.inspect(recurseTimes, ctx);
            if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
            return ret;
        }
        // Primitive types cannot have properties
        var primitive = formatPrimitive(ctx, value);
        if (primitive) return primitive;
        // Look up the keys of the object.
        var keys = Object.keys(value);
        var visibleKeys = arrayToHash(keys);
        if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
        // IE doesn't make error fields non-enumerable
        // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
        if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
        // Some type of object without properties can be shortcutted.
        if (keys.length === 0) {
            if (isFunction(value)) {
                var name = value.name ? ": " + value.name : "";
                return ctx.stylize("[Function" + name + "]", "special");
            }
            if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
            if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
            if (isError(value)) return formatError(value);
        }
        var base = "", array = false, braces = [
            "{",
            "}"
        ];
        // Make Array say that they are Array
        if (isArray(value)) {
            array = true;
            braces = [
                "[",
                "]"
            ];
        }
        // Make functions say that they are functions
        if (isFunction(value)) {
            var n = value.name ? ": " + value.name : "";
            base = " [Function" + n + "]";
        }
        // Make RegExps say that they are RegExps
        if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
        // Make dates with properties first say the date
        if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
        // Make error with message first say the error
        if (isError(value)) base = " " + formatError(value);
        if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
        if (recurseTimes < 0) {
            if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
            else return ctx.stylize("[Object]", "special");
        }
        ctx.seen.push(value);
        var output;
        if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
        else output = keys.map(function(key) {
            return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
        ctx.seen.pop();
        return reduceToSingleString(output, base, braces);
    }
    function formatPrimitive(ctx, value) {
        if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
        if (isString(value)) {
            var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
            return ctx.stylize(simple, "string");
        }
        if (isNumber(value)) return ctx.stylize("" + value, "number");
        if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
        // For some reason typeof null is "object", so special case here.
        if (isNull(value)) return ctx.stylize("null", "null");
    }
    function formatError(value) {
        return "[" + Error.prototype.toString.call(value) + "]";
    }
    function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
        var output = [];
        for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        else output.push("");
        keys.forEach(function(key) {
            if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        });
        return output;
    }
    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
        var name, str, desc;
        desc = Object.getOwnPropertyDescriptor(value, key) || {
            value: value[key]
        };
        if (desc.get) {
            if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
            else str = ctx.stylize("[Getter]", "special");
        } else if (desc.set) str = ctx.stylize("[Setter]", "special");
        if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
        if (!str) {
            if (ctx.seen.indexOf(desc.value) < 0) {
                if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
                else str = formatValue(ctx, desc.value, recurseTimes - 1);
                if (str.indexOf("\n") > -1) {
                    if (array) str = str.split("\n").map(function(line) {
                        return "  " + line;
                    }).join("\n").substr(2);
                    else str = "\n" + str.split("\n").map(function(line) {
                        return "   " + line;
                    }).join("\n");
                }
            } else str = ctx.stylize("[Circular]", "special");
        }
        if (isUndefined(name)) {
            if (array && key.match(/^\d+$/)) return str;
            name = JSON.stringify("" + key);
            if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.substr(1, name.length - 2);
                name = ctx.stylize(name, "name");
            } else {
                name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, "string");
            }
        }
        return name + ": " + str;
    }
    function reduceToSingleString(output, base, braces) {
        var length = output.reduce(function(prev, cur) {
            cur.indexOf("\n");
            return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0);
        if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
        return braces[0] + base + " " + output.join(", ") + " " + braces[1];
    }
    // NOTE: These type checking functions intentionally don't use `instanceof`
    // because it is fragile and can be easily faked with `Object.create()`.
    exports.types = types;
    function isArray(ar) {
        return Array.isArray(ar);
    }
    exports.isArray = isArray;
    function isBoolean(arg) {
        return typeof arg === "boolean";
    }
    exports.isBoolean = isBoolean;
    function isNull(arg) {
        return arg === null;
    }
    exports.isNull = isNull;
    function isNullOrUndefined(arg) {
        return arg == null;
    }
    exports.isNullOrUndefined = isNullOrUndefined;
    function isNumber(arg) {
        return typeof arg === "number";
    }
    exports.isNumber = isNumber;
    function isString(arg) {
        return typeof arg === "string";
    }
    exports.isString = isString;
    function isSymbol(arg) {
        return typeof arg === "symbol";
    }
    exports.isSymbol = isSymbol;
    function isUndefined(arg) {
        return arg === void 0;
    }
    exports.isUndefined = isUndefined;
    function isRegExp(re) {
        return isObject(re) && objectToString(re) === "[object RegExp]";
    }
    exports.isRegExp = isRegExp;
    exports.types.isRegExp = isRegExp;
    function isObject(arg) {
        return typeof arg === "object" && arg !== null;
    }
    exports.isObject = isObject;
    function isDate(d) {
        return isObject(d) && objectToString(d) === "[object Date]";
    }
    exports.isDate = isDate;
    exports.types.isDate = isDate;
    function isError(e) {
        return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
    }
    exports.isError = isError;
    exports.types.isNativeError = isError;
    function isFunction(arg) {
        return typeof arg === "function";
    }
    exports.isFunction = isFunction;
    function isPrimitive(arg) {
        return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
        typeof arg === "undefined";
    }
    exports.isPrimitive = isPrimitive;
    exports.isBuffer = isBufferBrowser;
    function objectToString(o) {
        return Object.prototype.toString.call(o);
    }
    function pad(n) {
        return n < 10 ? "0" + n.toString(10) : n.toString(10);
    }
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    // 26 Feb 16:19:34
    function timestamp() {
        var d = new Date();
        var time = [
            pad(d.getHours()),
            pad(d.getMinutes()),
            pad(d.getSeconds())
        ].join(":");
        return [
            d.getDate(),
            months[d.getMonth()],
            time
        ].join(" ");
    }
    // log is just a thin wrapper to console.log that prepends a timestamp
    exports.log = function() {
        console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
    };
    /**
   * Inherit the prototype methods from one constructor into another.
   *
   * The Function.prototype.inherits from lang.js rewritten as a standalone
   * function (not on Function.prototype). NOTE: If this file is to be loaded
   * during bootstrapping this function needs to be rewritten using some native
   * functions as prototype setup using normal JavaScript does not work as
   * expected during bootstrapping (see mirror.js in r114903).
   *
   * @param {function} ctor Constructor function which needs to inherit the
   *     prototype.
   * @param {function} superCtor Constructor function to inherit prototype from.
   */ exports.inherits = inherits_browser.exports;
    exports._extend = function(origin, add) {
        // Don't do anything if add isn't an object
        if (!add || !isObject(add)) return origin;
        var keys = Object.keys(add);
        var i = keys.length;
        while(i--)origin[keys[i]] = add[keys[i]];
        return origin;
    };
    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
    exports.promisify = function promisify(original) {
        if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
        if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
            var fn = original[kCustomPromisifiedSymbol];
            if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
            });
            return fn;
        }
        function fn() {
            var promiseResolve, promiseReject;
            var promise = new Promise(function(resolve, reject) {
                promiseResolve = resolve;
                promiseReject = reject;
            });
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            args.push(function(err, value) {
                if (err) promiseReject(err);
                else promiseResolve(value);
            });
            try {
                original.apply(this, args);
            } catch (err) {
                promiseReject(err);
            }
            return promise;
        }
        Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
        if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
    };
    exports.promisify.custom = kCustomPromisifiedSymbol;
    function callbackifyOnRejected(reason, cb) {
        // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
        // Because `null` is a special error value in callbacks which means "no error
        // occurred", we error-wrap so the callback consumer can distinguish between
        // "the promise rejected with null" or "the promise fulfilled with undefined".
        if (!reason) {
            var newReason = new Error("Promise was rejected with a falsy value");
            newReason.reason = reason;
            reason = newReason;
        }
        return cb(reason);
    }
    function callbackify(original) {
        if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
        // We DO NOT return the promise as it gives the user a false sense that
        // the promise is actually somehow related to the callback's execution
        // and that the callback throwing will reject the promise.
        function callbackified() {
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            var maybeCb = args.pop();
            if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
            var self1 = this;
            var cb = function cb() {
                return maybeCb.apply(self1, arguments);
            };
            // In true node style we process the callback on `nextTick` with all the
            // implications (stack, `uncaughtException`, `async_hooks`)
            original.apply(this, args).then(function(ret) {
                browser$1$1.nextTick(cb.bind(null, null, ret));
            }, function(rej) {
                browser$1$1.nextTick(callbackifyOnRejected.bind(null, rej, cb));
            });
        }
        Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
        Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
        return callbackified;
    }
    exports.callbackify = callbackify;
})(util$1);
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function _typeof$3(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$3 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$3(obj);
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$1(self1, call) {
    if (call && (_typeof$3(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$1(self1);
}
function _assertThisInitialized$1(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
var codes = {}; // Lazy loaded
var assert$1;
var util;
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inherits$1(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            _classCallCheck$2(this, NodeError);
            _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(NodeError).call(this, getMessage(arg1, arg2, arg3)));
            _this.code = code;
            return _this;
        }
        return NodeError;
    }(Base);
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith$1(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if (assert$1 === undefined) assert$1 = assert$2.exports;
    assert$1(typeof name === "string", "'name' must be a string"); // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith$1(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    } // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat(_typeof$3(actual));
    return msg;
}, TypeError);
createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if (util === undefined) util = util$1;
    var inspected = util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat(_typeof$3(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (assert$1 === undefined) assert$1 = assert$2.exports;
    assert$1(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
errors.codes = codes;
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self1, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized1(self1);
}
function _assertThisInitialized1(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _typeof$2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$2 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$2(obj);
}
var _require$1 = util$1, inspect$1 = _require$1.inspect;
var _require2$1 = errors, ERR_INVALID_ARG_TYPE$1 = _require2$1.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var blue = "";
var green = "";
var red = "";
var white = "";
var kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
}; // Comparing short primitives should just show === / !== instead of using the
// diff.
var kMaxShortLength = 10;
function copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return inspect$1(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = inspectValue(expected).split("\n");
    var i = 0;
    var indicator = ""; // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && _typeof$2(actual) === "object" && _typeof$2(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
     // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= kMaxShortLength) {
            if ((_typeof$2(actual) !== "object" || actual === null) && (_typeof$2(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                 // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat(repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    } // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n"); // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat(blue, "...").concat(white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat(blue, "...").concat(white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
    var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the expected line to the cache.
            other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
            printedLines++; // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the actual line to the result.
            res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
            printedLines++; // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat(blue, "...").concat(white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
                other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
                printedLines += 2; // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ""; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        } // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var AssertionError$1 = /*#__PURE__*/ function(_Error) {
    _inherits(AssertionError, _Error);
    function AssertionError(options) {
        var _this;
        _classCallCheck$1(this, AssertionError);
        if (_typeof$2(options) !== "object" || options === null) throw new ERR_INVALID_ARG_TYPE$1("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, String(message)));
        else {
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if (_typeof$2(actual) === "object" && actual !== null && _typeof$2(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = copyError(actual);
                expected = copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, createErrDiff(actual, expected, operator)));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = kReadableOperator[operator];
                var res = inspectValue(actual).split("\n"); // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && _typeof$2(actual) === "object" && actual !== null) base = kReadableOperator.notStrictEqualObject;
                 // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat(blue, "...").concat(white);
                    while(res.length > 27)res.pop();
                } // Only print a single input.
                if (res.length === 1) _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
                else _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n")));
            } else {
                var _res = inspectValue(actual);
                var other = "";
                var knownOperators = kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat(inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty(_assertThisInitialized1(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace(_assertThisInitialized1(_this), stackStartFn);
         // Create error message including the error code in the name.
        _this.stack; // Reset the name.
        _this.name = "AssertionError";
        return _possibleConstructorReturn(_this);
    }
    _createClass1(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: inspect$1.custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return inspect$1(this, _objectSpread({}, ctx, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(_wrapNativeSuper(Error));
var assertion_error = AssertionError$1;
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ function assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError("Cannot convert first argument to object");
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function polyfill$4() {
    if (!Object.assign) Object.defineProperty(Object, "assign", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: assign
    });
}
var es6ObjectAssign = {
    assign: assign,
    polyfill: polyfill$4
};
var toStr$2 = Object.prototype.toString;
var isArguments = function isArguments(value) {
    var str = toStr$2.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr$2.call(value.callee) === "[object Function]";
    return isArgs;
};
var keysShim$1;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr$1 = Object.prototype.toString;
    var isArgs$1 = isArguments; // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
        toString: null
    }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {}, "prototype");
    var dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!excludedKeys["$" + k] && has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
        /* global window */ if (typeof window === "undefined" || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
        try {
            return equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    keysShim$1 = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = toStr$1.call(object) === "[object Function]";
        var isArguments = isArgs$1(object);
        var isString = isObject && toStr$1.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && has.call(object, name)) theKeys.push(String(name));
        }
        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === "constructor") && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
        }
        return theKeys;
    };
}
var implementation$6 = keysShim$1;
var slice = Array.prototype.slice;
var isArgs = isArguments;
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
} : implementation$6;
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            // eslint-disable-line func-name-matching
            if (isArgs(object)) return originalKeys(slice.call(object));
            return originalKeys(object);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
var objectKeys = keysShim;
var keys = objectKeys;
var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;
var isFunction = function isFunction(fn) {
    return typeof fn === "function" && toStr.call(fn) === "[object Function]";
};
var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
    var obj = {};
    try {
        origDefineProperty(obj, "x", {
            enumerable: false,
            value: obj
        });
        // eslint-disable-next-line no-unused-vars, no-restricted-syntax
        for(var _ in obj)// jscs:ignore disallowUnusedVariables
        return false;
        return obj.x === obj;
    } catch (e) {
        /* this is IE 8. */ return false;
    }
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
var defineProperty = function defineProperty(object, name, value, predicate) {
    if (name in object && (!isFunction(predicate) || !predicate())) return;
    if (supportsDescriptors) origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value;
};
var defineProperties = function defineProperties(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
var defineProperties_1 = defineProperties;
var numberIsNaN$1 = function numberIsNaN(value) {
    return value !== value;
};
var implementation$5 = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if (numberIsNaN$1(a) && numberIsNaN$1(b)) return true;
    return false;
};
var implementation$4 = implementation$5;
var polyfill$3 = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : implementation$4;
};
var getPolyfill$3 = polyfill$3;
var define$3 = defineProperties_1;
var shim$3 = function shimObjectIs() {
    var polyfill = getPolyfill$3();
    define$3(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};
var define$2 = defineProperties_1;
var callBind$1 = callBind$3.exports;
var implementation$3 = implementation$5;
var getPolyfill$2 = polyfill$3;
var shim$2 = shim$3;
var polyfill$2 = callBind$1(getPolyfill$2(), Object);
define$2(polyfill$2, {
    getPolyfill: getPolyfill$2,
    implementation: implementation$3,
    shim: shim$2
});
var objectIs$2 = polyfill$2;
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ var implementation$2 = function isNaN1(value) {
    return value !== value;
};
var implementation$1 = implementation$2;
var polyfill$1 = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return implementation$1;
};
var define$1 = defineProperties_1;
var getPolyfill$1 = polyfill$1;
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ var shim$1 = function shimNumberIsNaN() {
    var polyfill = getPolyfill$1();
    define$1(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};
var callBind = callBind$3.exports;
var define = defineProperties_1;
var implementation = implementation$2;
var getPolyfill = polyfill$1;
var shim = shim$1;
var polyfill = callBind(getPolyfill(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
var isNan = polyfill;
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof$1(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$1 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$1(obj);
}
var regexFlagsSupported = /a/g.flags !== undefined;
var arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};
var objectIs$1 = Object.is ? Object.is : objectIs$2;
var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};
var numberIsNaN = Number.isNaN ? Number.isNaN : isNan;
function uncurryThis(f) {
    return f.call.bind(f);
}
var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
var objectToString = uncurryThis(Object.prototype.toString);
var _require$types$1 = util$1.types, isAnyArrayBuffer = _require$types$1.isAnyArrayBuffer, isArrayBufferView = _require$types$1.isArrayBufferView, isDate = _require$types$1.isDate, isMap = _require$types$1.isMap, isRegExp$1 = _require$types$1.isRegExp, isSet = _require$types$1.isSet, isNativeError = _require$types$1.isNativeError, isBoxedPrimitive = _require$types$1.isBoxedPrimitive, isNumberObject = _require$types$1.isNumberObject, isStringObject = _require$types$1.isStringObject, isBooleanObject = _require$types$1.isBooleanObject, isBigIntObject = _require$types$1.isBigIntObject, isSymbolObject = _require$types$1.isSymbolObject, isFloat32Array = _require$types$1.isFloat32Array, isFloat64Array = _require$types$1.isFloat64Array;
function isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    } // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function getOwnNonIndexProperties(value) {
    return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var kStrict = true;
var kLoose = false;
var kNoIterator = 0;
var kIsArray = 1;
var kIsSet = 2;
var kIsMap = 3; // Check if they have the same source and flags
function areSimilarRegExps(a, b) {
    return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function isEqualBoxedPrimitive(val1, val2) {
    if (isNumberObject(val1)) return isNumberObject(val2) && objectIs$1(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if (isStringObject(val1)) return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if (isBooleanObject(val1)) return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if (isBigIntObject(val1)) return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? objectIs$1(val1, val2) : true;
    } // Check more closely if val1 and val2 are equal.
    if (strict) {
        if (_typeof$1(val1) !== "object") return typeof val1 === "number" && numberIsNaN(val1) && numberIsNaN(val2);
        if (_typeof$1(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || _typeof$1(val1) !== "object") {
            if (val2 === null || _typeof$1(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || _typeof$1(val2) !== "object") return false;
    }
    var val1Tag = objectToString(val1);
    var val2Tag = objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = getOwnNonIndexProperties(val1);
        var keys2 = getOwnNonIndexProperties(val2);
        if (keys1.length !== keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
    } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) return false;
    }
    if (isDate(val1)) {
        if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if (isRegExp$1(val1)) {
        if (!isRegExp$1(val2) || !areSimilarRegExps(val1, val2)) return false;
    } else if (isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if (isArrayBufferView(val1)) {
        if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
            if (!areSimilarFloatArrays(val1, val2)) return false;
        } else if (!areSimilarTypedArrays(val1, val2)) return false;
         // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = getOwnNonIndexProperties(val1);
        var _keys2 = getOwnNonIndexProperties(val2);
        if (_keys.length !== _keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
    } else if (isSet(val1)) {
        if (!isSet(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsSet);
    } else if (isMap(val1)) {
        if (!isMap(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsMap);
    } else if (isAnyArrayBuffer(val1)) {
        if (!areEqualArrayBuffers(val1, val2)) return false;
    } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) return false;
    return keyCheck(val1, val2, strict, memos, kNoIterator);
}
function getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return propertyIsEnumerable(val, k);
    });
}
function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    } // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if (propertyIsEnumerable(val1, key)) {
                    if (!propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if (propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) return true;
     // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if (innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function findLooseMatchingPrimitives(prim) {
    switch(_typeof$1(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if (numberIsNaN(prim)) return false;
    }
    return true;
}
function setMightHaveLoosePrim(a, b, prim) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
}
function setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if (_typeof$1(val) === "object" && val !== null) {
            if (set === null) set = new Set();
             // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
            if (!setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i]; // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if (_typeof$1(_val) === "object" && _val !== null) {
                if (!setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = _slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if (_typeof$1(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = _slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
            if (_typeof$1(key) === "object" && key !== null) {
                if (!mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(key) || !innerDeepEqual(a.get(key), item, false, memo)) && !mapHasEqualEntry(set, a, key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === kIsSet) {
        if (!setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsMap) {
        if (!mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsArray) for(; i < a.length; i++){
        if (hasOwnProperty(a, i)) {
            if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if (hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
     // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key = keys[i];
        if (!innerDeepEqual(a[_key], b[_key], strict, memos)) return false;
    }
    return true;
}
function isDeepEqual$1(val1, val2) {
    return innerDeepEqual(val1, val2, kLoose);
}
function isDeepStrictEqual$1(val1, val2) {
    return innerDeepEqual(val1, val2, kStrict);
}
var comparisons = {
    isDeepEqual: isDeepEqual$1,
    isDeepStrictEqual: isDeepStrictEqual$1
};
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var _require = errors, _require$codes = _require.codes, ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE, ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
var AssertionError = assertion_error;
var _require2 = util$1, inspect = _require2.inspect;
var _require$types = util$1.types, isPromise = _require$types.isPromise, isRegExp = _require$types.isRegExp;
var objectAssign = Object.assign ? Object.assign : es6ObjectAssign.assign;
var objectIs = Object.is ? Object.is : objectIs$2;
var isDeepEqual;
var isDeepStrictEqual;
function lazyLoadComparison() {
    var comparison = comparisons;
    isDeepEqual = comparison.isDeepEqual;
    isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
var warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var assert = assert$2.exports = ok;
var NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new AssertionError(obj);
}
function fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if (warned === false) {
            warned = true;
            var warn = console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new AssertionError(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
assert.fail = fail; // The AssertionError is defined in internal/error.
assert.AssertionError = AssertionError;
function innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new AssertionError({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.
function ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    innerOk.apply(void 0, [
        ok,
        args.length
    ].concat(args));
}
assert.ok = ok; // The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual != expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.
assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual == expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
}; // The equivalence assertion tests a deep equality relation.
assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
}; // The non-equivalence assertion tests for any deep inequality.
assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: notDeepStrictEqual
    });
}
assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (!objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var Comparison = function Comparison(obj, keys, actual) {
    var _this = this;
    _classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && isRegExp(obj[key]) && obj[key].test(actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
};
function compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new Comparison(actual, keys);
            var b = new Comparison(expected, keys, actual);
            var err = new AssertionError({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if (isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
         // Handle primitives properly.
        if (_typeof(actual) !== "object" || actual === null) {
            var err = new AssertionError({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if (isDeepEqual === undefined) lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && isRegExp(expected[key]) && expected[key].test(actual[key])) return;
            compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    } // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function getActual(fn) {
    if (typeof fn !== "function") throw new ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return NO_EXCEPTION_SENTINEL;
}
function checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return isPromise(obj) || obj !== null && _typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn(); // Fail in case no promise is returned.
            if (!checkIsPromise(resultPromise)) throw new ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if (checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if (_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && _typeof(error) !== "object" && typeof error !== "function") throw new ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !expectedException(actual, error, message, stackStartFn)) throw actual;
}
function expectsNoError(stackStartFn, actual, error, message) {
    if (actual === NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    expectsError.apply(void 0, [
        throws,
        getActual(promiseFn)
    ].concat(args));
};
assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return waitForActual(promiseFn).then(function(result) {
        return expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    expectsNoError.apply(void 0, [
        doesNotThrow,
        getActual(fn)
    ].concat(args));
};
assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return waitForActual(fn).then(function(result) {
        return expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if (_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += inspect(err);
        var newErr = new AssertionError({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        }); // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift(); // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
}; // Expose a strict only variant of assert
function strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    innerOk.apply(void 0, [
        strict,
        args.length
    ].concat(args));
}
assert.strict = objectAssign(strict, assert, {
    equal: assert.strictEqual,
    deepEqual: assert.deepStrictEqual,
    notEqual: assert.notStrictEqual,
    notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;
(function(exports) {
    /* eslint camelcase: "off" */ var assert = assert$2.exports;
    var Zstream = (0, _zstreamDefault.default);
    var zlib_deflate = (0, _deflateJsDefault.default);
    var zlib_inflate = (0, _inflateJsDefault.default);
    var constants = (0, _constantsDefault.default);
    for(var key in constants)exports[key] = constants[key];
    // zlib modes
    exports.NONE = 0;
    exports.DEFLATE = 1;
    exports.INFLATE = 2;
    exports.GZIP = 3;
    exports.GUNZIP = 4;
    exports.DEFLATERAW = 5;
    exports.INFLATERAW = 6;
    exports.UNZIP = 7;
    var GZIP_HEADER_ID1 = 0x1f;
    var GZIP_HEADER_ID2 = 0x8b;
    /**
   * Emulate Node's zlib C++ layer for use by the JS layer in index.js
   */ function Zlib(mode) {
        if (typeof mode !== "number" || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError("Bad argument");
        this.dictionary = null;
        this.err = 0;
        this.flush = 0;
        this.init_done = false;
        this.level = 0;
        this.memLevel = 0;
        this.mode = mode;
        this.strategy = 0;
        this.windowBits = 0;
        this.write_in_progress = false;
        this.pending_close = false;
        this.gzip_id_bytes_read = 0;
    }
    Zlib.prototype.close = function() {
        if (this.write_in_progress) {
            this.pending_close = true;
            return;
        }
        this.pending_close = false;
        assert(this.init_done, "close before init");
        assert(this.mode <= exports.UNZIP);
        if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
        else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
        this.mode = exports.NONE;
        this.dictionary = null;
    };
    Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
        return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
    };
    Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
        return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
    };
    Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
        assert.equal(arguments.length, 8);
        assert(this.init_done, "write before init");
        assert(this.mode !== exports.NONE, "already finalized");
        assert.equal(false, this.write_in_progress, "write already in progress");
        assert.equal(false, this.pending_close, "close is pending");
        this.write_in_progress = true;
        assert.equal(false, flush === undefined, "must provide flush value");
        this.write_in_progress = true;
        if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error("Invalid flush value");
        if (input == null) {
            input = Buffer$4.alloc(0);
            in_len = 0;
            in_off = 0;
        }
        this.strm.avail_in = in_len;
        this.strm.input = input;
        this.strm.next_in = in_off;
        this.strm.avail_out = out_len;
        this.strm.output = out;
        this.strm.next_out = out_off;
        this.flush = flush;
        if (!async) {
            // sync version
            this._process();
            if (this._checkError()) return this._afterSync();
            return;
        }
        // async version
        var self1 = this;
        browser$1$1.nextTick(function() {
            self1._process();
            self1._after();
        });
        return this;
    };
    Zlib.prototype._afterSync = function() {
        var avail_out = this.strm.avail_out;
        var avail_in = this.strm.avail_in;
        this.write_in_progress = false;
        return [
            avail_in,
            avail_out
        ];
    };
    Zlib.prototype._process = function() {
        var next_expected_header_byte = null;
        // If the avail_out is left at 0, then it means that it ran out
        // of room.  If there was avail_out left over, then it means
        // that all of the input was consumed.
        switch(this.mode){
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflate(this.strm, this.flush);
                break;
            case exports.UNZIP:
                if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
                switch(this.gzip_id_bytes_read){
                    case 0:
                        if (next_expected_header_byte === null) break;
                        if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                            this.gzip_id_bytes_read = 1;
                            next_expected_header_byte++;
                            if (this.strm.avail_in === 1) break;
                        } else {
                            this.mode = exports.INFLATE;
                            break;
                        }
                    // fallthrough
                    case 1:
                        if (next_expected_header_byte === null) break;
                        if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                            this.gzip_id_bytes_read = 2;
                            this.mode = exports.GUNZIP;
                        } else // There is no actual difference between INFLATE and INFLATERAW
                        // (after initialization).
                        this.mode = exports.INFLATE;
                        break;
                    default:
                        throw new Error("invalid number of gzip magic number bytes read");
                }
            // fallthrough
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
                this.err = zlib_inflate.inflate(this.strm, this.flush);
                if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                    // Load it
                    this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                    if (this.err === exports.Z_OK) // And try to decode again
                    this.err = zlib_inflate.inflate(this.strm, this.flush);
                    else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                    // Make it possible for After() to tell a bad dictionary from bad
                    // input.
                    this.err = exports.Z_NEED_DICT;
                }
                while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                    // Bytes remain in input buffer. Perhaps this is another compressed
                    // member in the same archive, or just trailing garbage.
                    // Trailing zero bytes are okay, though, since they are frequently
                    // used for padding.
                    this.reset();
                    this.err = zlib_inflate.inflate(this.strm, this.flush);
                }
                break;
            default:
                throw new Error("Unknown mode " + this.mode);
        }
    };
    Zlib.prototype._checkError = function() {
        // Acceptable error states depend on the type of zlib stream.
        switch(this.err){
            case exports.Z_OK:
            case exports.Z_BUF_ERROR:
                if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                    this._error("unexpected end of file");
                    return false;
                }
                break;
            case exports.Z_STREAM_END:
                break;
            case exports.Z_NEED_DICT:
                if (this.dictionary == null) this._error("Missing dictionary");
                else this._error("Bad dictionary");
                return false;
            default:
                // something else.
                this._error("Zlib error");
                return false;
        }
        return true;
    };
    Zlib.prototype._after = function() {
        if (!this._checkError()) return;
        var avail_out = this.strm.avail_out;
        var avail_in = this.strm.avail_in;
        this.write_in_progress = false;
        // call the write() cb
        this.callback(avail_in, avail_out);
        if (this.pending_close) this.close();
    };
    Zlib.prototype._error = function(message) {
        if (this.strm.msg) message = this.strm.msg;
        this.onerror(message, this.err);
        this.write_in_progress = false;
        if (this.pending_close) this.close();
    };
    Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
        assert(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])");
        assert(windowBits >= 8 && windowBits <= 15, "invalid windowBits");
        assert(level >= -1 && level <= 9, "invalid compression level");
        assert(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
        assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, "invalid strategy");
        this._init(level, windowBits, memLevel, strategy, dictionary);
        this._setDictionary();
    };
    Zlib.prototype.params = function() {
        throw new Error("deflateParams Not supported");
    };
    Zlib.prototype.reset = function() {
        this._reset();
        this._setDictionary();
    };
    Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
        this.level = level;
        this.windowBits = windowBits;
        this.memLevel = memLevel;
        this.strategy = strategy;
        this.flush = exports.Z_NO_FLUSH;
        this.err = exports.Z_OK;
        if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
        if (this.mode === exports.UNZIP) this.windowBits += 32;
        if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
        this.strm = new Zstream();
        switch(this.mode){
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                break;
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
            case exports.UNZIP:
                this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
                break;
            default:
                throw new Error("Unknown mode " + this.mode);
        }
        if (this.err !== exports.Z_OK) this._error("Init error");
        this.dictionary = dictionary;
        this.write_in_progress = false;
        this.init_done = true;
    };
    Zlib.prototype._setDictionary = function() {
        if (this.dictionary == null) return;
        this.err = exports.Z_OK;
        switch(this.mode){
            case exports.DEFLATE:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
                break;
        }
        if (this.err !== exports.Z_OK) this._error("Failed to set dictionary");
    };
    Zlib.prototype._reset = function() {
        this.err = exports.Z_OK;
        switch(this.mode){
            case exports.DEFLATE:
            case exports.DEFLATERAW:
            case exports.GZIP:
                this.err = zlib_deflate.deflateReset(this.strm);
                break;
            case exports.INFLATE:
            case exports.INFLATERAW:
            case exports.GUNZIP:
                this.err = zlib_inflate.inflateReset(this.strm);
                break;
        }
        if (this.err !== exports.Z_OK) this._error("Failed to reset stream");
    };
    exports.Zlib = Zlib;
})(binding);
(function(exports) {
    var Buffer = buffer.Buffer;
    var Transform1 = readableBrowser.exports.Transform;
    var binding$1 = binding;
    var util = util$1;
    var assert = assert$2.exports.ok;
    var kMaxLength = buffer.kMaxLength;
    var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + " bytes";
    // zlib doesn't provide these, so kludge them in following the same
    // const naming scheme zlib uses.
    binding$1.Z_MIN_WINDOWBITS = 8;
    binding$1.Z_MAX_WINDOWBITS = 15;
    binding$1.Z_DEFAULT_WINDOWBITS = 15;
    // fewer than 64 bytes per chunk is stupid.
    // technically it could work with as few as 8, but even 64 bytes
    // is absurdly low.  Usually a MB or more is best.
    binding$1.Z_MIN_CHUNK = 64;
    binding$1.Z_MAX_CHUNK = Infinity;
    binding$1.Z_DEFAULT_CHUNK = 16384;
    binding$1.Z_MIN_MEMLEVEL = 1;
    binding$1.Z_MAX_MEMLEVEL = 9;
    binding$1.Z_DEFAULT_MEMLEVEL = 8;
    binding$1.Z_MIN_LEVEL = -1;
    binding$1.Z_MAX_LEVEL = 9;
    binding$1.Z_DEFAULT_LEVEL = binding$1.Z_DEFAULT_COMPRESSION;
    // expose all the zlib constants
    var bkeys = Object.keys(binding$1);
    for(var bk = 0; bk < bkeys.length; bk++){
        var bkey = bkeys[bk];
        if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
            enumerable: true,
            value: binding$1[bkey],
            writable: false
        });
    }
    // translation table for return codes.
    var codes = {
        Z_OK: binding$1.Z_OK,
        Z_STREAM_END: binding$1.Z_STREAM_END,
        Z_NEED_DICT: binding$1.Z_NEED_DICT,
        Z_ERRNO: binding$1.Z_ERRNO,
        Z_STREAM_ERROR: binding$1.Z_STREAM_ERROR,
        Z_DATA_ERROR: binding$1.Z_DATA_ERROR,
        Z_MEM_ERROR: binding$1.Z_MEM_ERROR,
        Z_BUF_ERROR: binding$1.Z_BUF_ERROR,
        Z_VERSION_ERROR: binding$1.Z_VERSION_ERROR
    };
    var ckeys = Object.keys(codes);
    for(var ck = 0; ck < ckeys.length; ck++){
        var ckey = ckeys[ck];
        codes[codes[ckey]] = ckey;
    }
    Object.defineProperty(exports, "codes", {
        enumerable: true,
        value: Object.freeze(codes),
        writable: false
    });
    exports.Deflate = Deflate;
    exports.Inflate = Inflate;
    exports.Gzip = Gzip;
    exports.Gunzip = Gunzip;
    exports.DeflateRaw = DeflateRaw;
    exports.InflateRaw = InflateRaw;
    exports.Unzip = Unzip;
    exports.createDeflate = function(o) {
        return new Deflate(o);
    };
    exports.createInflate = function(o) {
        return new Inflate(o);
    };
    exports.createDeflateRaw = function(o) {
        return new DeflateRaw(o);
    };
    exports.createInflateRaw = function(o) {
        return new InflateRaw(o);
    };
    exports.createGzip = function(o) {
        return new Gzip(o);
    };
    exports.createGunzip = function(o) {
        return new Gunzip(o);
    };
    exports.createUnzip = function(o) {
        return new Unzip(o);
    };
    // Convenience methods.
    // compress/decompress a string or buffer in one step.
    exports.deflate = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Deflate(opts), buffer, callback);
    };
    exports.deflateSync = function(buffer, opts) {
        return zlibBufferSync(new Deflate(opts), buffer);
    };
    exports.gzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Gzip(opts), buffer, callback);
    };
    exports.gzipSync = function(buffer, opts) {
        return zlibBufferSync(new Gzip(opts), buffer);
    };
    exports.deflateRaw = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new DeflateRaw(opts), buffer, callback);
    };
    exports.deflateRawSync = function(buffer, opts) {
        return zlibBufferSync(new DeflateRaw(opts), buffer);
    };
    exports.unzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Unzip(opts), buffer, callback);
    };
    exports.unzipSync = function(buffer, opts) {
        return zlibBufferSync(new Unzip(opts), buffer);
    };
    exports.inflate = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Inflate(opts), buffer, callback);
    };
    exports.inflateSync = function(buffer, opts) {
        return zlibBufferSync(new Inflate(opts), buffer);
    };
    exports.gunzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Gunzip(opts), buffer, callback);
    };
    exports.gunzipSync = function(buffer, opts) {
        return zlibBufferSync(new Gunzip(opts), buffer);
    };
    exports.inflateRaw = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new InflateRaw(opts), buffer, callback);
    };
    exports.inflateRawSync = function(buffer, opts) {
        return zlibBufferSync(new InflateRaw(opts), buffer);
    };
    function zlibBuffer(engine, buffer, callback) {
        var buffers = [];
        var nread = 0;
        engine.on("error", onError);
        engine.on("end", onEnd);
        engine.end(buffer);
        flow();
        function flow() {
            var chunk;
            while(null !== (chunk = engine.read())){
                buffers.push(chunk);
                nread += chunk.length;
            }
            engine.once("readable", flow);
        }
        function onError(err) {
            engine.removeListener("end", onEnd);
            engine.removeListener("readable", flow);
            callback(err);
        }
        function onEnd() {
            var buf;
            var err = null;
            if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
            else buf = Buffer.concat(buffers, nread);
            buffers = [];
            engine.close();
            callback(err, buf);
        }
    }
    function zlibBufferSync(engine, buffer) {
        if (typeof buffer === "string") buffer = Buffer.from(buffer);
        if (!Buffer.isBuffer(buffer)) throw new TypeError("Not a string or buffer");
        var flushFlag = engine._finishFlushFlag;
        return engine._processChunk(buffer, flushFlag);
    }
    // generic zlib
    // minimal 2-byte header
    function Deflate(opts) {
        if (!(this instanceof Deflate)) return new Deflate(opts);
        Zlib.call(this, opts, binding$1.DEFLATE);
    }
    function Inflate(opts) {
        if (!(this instanceof Inflate)) return new Inflate(opts);
        Zlib.call(this, opts, binding$1.INFLATE);
    }
    // gzip - bigger header, same deflate compression
    function Gzip(opts) {
        if (!(this instanceof Gzip)) return new Gzip(opts);
        Zlib.call(this, opts, binding$1.GZIP);
    }
    function Gunzip(opts) {
        if (!(this instanceof Gunzip)) return new Gunzip(opts);
        Zlib.call(this, opts, binding$1.GUNZIP);
    }
    // raw - no header
    function DeflateRaw(opts) {
        if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
        Zlib.call(this, opts, binding$1.DEFLATERAW);
    }
    function InflateRaw(opts) {
        if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
        Zlib.call(this, opts, binding$1.INFLATERAW);
    }
    // auto-detect header.
    function Unzip(opts) {
        if (!(this instanceof Unzip)) return new Unzip(opts);
        Zlib.call(this, opts, binding$1.UNZIP);
    }
    function isValidFlushFlag(flag) {
        return flag === binding$1.Z_NO_FLUSH || flag === binding$1.Z_PARTIAL_FLUSH || flag === binding$1.Z_SYNC_FLUSH || flag === binding$1.Z_FULL_FLUSH || flag === binding$1.Z_FINISH || flag === binding$1.Z_BLOCK;
    }
    // the Zlib class they all inherit from
    // This thing manages the queue of requests, and returns
    // true or false if there is anything in the queue when
    // you call the .write() method.
    function Zlib(opts, mode) {
        var _this = this;
        this._opts = opts = opts || {};
        this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
        Transform1.call(this, opts);
        if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error("Invalid flush flag: " + opts.flush);
        if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error("Invalid flush flag: " + opts.finishFlush);
        this._flushFlag = opts.flush || binding$1.Z_NO_FLUSH;
        this._finishFlushFlag = typeof opts.finishFlush !== "undefined" ? opts.finishFlush : binding$1.Z_FINISH;
        if (opts.chunkSize) {
            if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error("Invalid chunk size: " + opts.chunkSize);
        }
        if (opts.windowBits) {
            if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error("Invalid windowBits: " + opts.windowBits);
        }
        if (opts.level) {
            if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error("Invalid compression level: " + opts.level);
        }
        if (opts.memLevel) {
            if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error("Invalid memLevel: " + opts.memLevel);
        }
        if (opts.strategy) {
            if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + opts.strategy);
        }
        if (opts.dictionary) {
            if (!Buffer.isBuffer(opts.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
        }
        this._handle = new binding$1.Zlib(mode);
        var self1 = this;
        this._hadError = false;
        this._handle.onerror = function(message, errno) {
            // there is no way to cleanly recover.
            // continuing only obscures problems.
            _close(self1);
            self1._hadError = true;
            var error = new Error(message);
            error.errno = errno;
            error.code = exports.codes[errno];
            self1.emit("error", error);
        };
        var level = exports.Z_DEFAULT_COMPRESSION;
        if (typeof opts.level === "number") level = opts.level;
        var strategy = exports.Z_DEFAULT_STRATEGY;
        if (typeof opts.strategy === "number") strategy = opts.strategy;
        this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
        this._buffer = Buffer.allocUnsafe(this._chunkSize);
        this._offset = 0;
        this._level = level;
        this._strategy = strategy;
        this.once("end", this.close);
        Object.defineProperty(this, "_closed", {
            get: function get() {
                return !_this._handle;
            },
            configurable: true,
            enumerable: true
        });
    }
    util.inherits(Zlib, Transform1);
    Zlib.prototype.params = function(level, strategy, callback) {
        if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + level);
        if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + strategy);
        if (this._level !== level || this._strategy !== strategy) {
            var self1 = this;
            this.flush(binding$1.Z_SYNC_FLUSH, function() {
                assert(self1._handle, "zlib binding closed");
                self1._handle.params(level, strategy);
                if (!self1._hadError) {
                    self1._level = level;
                    self1._strategy = strategy;
                    if (callback) callback();
                }
            });
        } else browser$1$1.nextTick(callback);
    };
    Zlib.prototype.reset = function() {
        assert(this._handle, "zlib binding closed");
        return this._handle.reset();
    };
    // This is the _flush function called by the transform class,
    // internally, when the last chunk has been written.
    Zlib.prototype._flush = function(callback) {
        this._transform(Buffer.alloc(0), "", callback);
    };
    Zlib.prototype.flush = function(kind, callback) {
        var _this2 = this;
        var ws = this._writableState;
        if (typeof kind === "function" || kind === undefined && !callback) {
            callback = kind;
            kind = binding$1.Z_FULL_FLUSH;
        }
        if (ws.ended) {
            if (callback) browser$1$1.nextTick(callback);
        } else if (ws.ending) {
            if (callback) this.once("end", callback);
        } else if (ws.needDrain) {
            if (callback) this.once("drain", function() {
                return _this2.flush(kind, callback);
            });
        } else {
            this._flushFlag = kind;
            this.write(Buffer.alloc(0), "", callback);
        }
    };
    Zlib.prototype.close = function(callback) {
        _close(this, callback);
        browser$1$1.nextTick(emitCloseNT, this);
    };
    function _close(engine, callback) {
        if (callback) browser$1$1.nextTick(callback);
        // Caller may invoke .close after a zlib error (which will null _handle).
        if (!engine._handle) return;
        engine._handle.close();
        engine._handle = null;
    }
    function emitCloseNT(self1) {
        self1.emit("close");
    }
    Zlib.prototype._transform = function(chunk, encoding, cb) {
        var flushFlag;
        var ws = this._writableState;
        var ending = ws.ending || ws.ended;
        var last = ending && (!chunk || ws.length === chunk.length);
        if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error("invalid input"));
        if (!this._handle) return cb(new Error("zlib binding closed"));
        // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
        // (or whatever flag was provided using opts.finishFlush).
        // If it's explicitly flushing at some other time, then we use
        // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
        // goodness.
        if (last) flushFlag = this._finishFlushFlag;
        else {
            flushFlag = this._flushFlag;
            // once we've flushed the last of the queue, stop flushing and
            // go back to the normal behavior.
            if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding$1.Z_NO_FLUSH;
        }
        this._processChunk(chunk, flushFlag, cb);
    };
    Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
        var availInBefore = chunk && chunk.length;
        var availOutBefore = this._chunkSize - this._offset;
        var inOff = 0;
        var self1 = this;
        var async = typeof cb === "function";
        if (!async) {
            var buffers = [];
            var nread = 0;
            var error;
            this.on("error", function(er) {
                error = er;
            });
            assert(this._handle, "zlib binding closed");
            do var res = this._handle.writeSync(flushFlag, chunk, // in
            inOff, // in_off
            availInBefore, // in_len
            this._buffer, // out
            this._offset, //out_off
            availOutBefore); // out_len
            while (!this._hadError && callback(res[0], res[1]));
            if (this._hadError) throw error;
            if (nread >= kMaxLength) {
                _close(this);
                throw new RangeError(kRangeErrorMessage);
            }
            var buf = Buffer.concat(buffers, nread);
            _close(this);
            return buf;
        }
        assert(this._handle, "zlib binding closed");
        var req = this._handle.write(flushFlag, chunk, // in
        inOff, // in_off
        availInBefore, // in_len
        this._buffer, // out
        this._offset, //out_off
        availOutBefore); // out_len
        req.buffer = chunk;
        req.callback = callback;
        function callback(availInAfter, availOutAfter) {
            // When the callback is used in an async write, the callback's
            // context is the `req` object that was created. The req object
            // is === this._handle, and that's why it's important to null
            // out the values after they are done being used. `this._handle`
            // can stay in memory longer than the callback and buffer are needed.
            if (this) {
                this.buffer = null;
                this.callback = null;
            }
            if (self1._hadError) return;
            var have = availOutBefore - availOutAfter;
            assert(have >= 0, "have should not go down");
            if (have > 0) {
                var out = self1._buffer.slice(self1._offset, self1._offset + have);
                self1._offset += have;
                // serve some output to the consumer.
                if (async) self1.push(out);
                else {
                    buffers.push(out);
                    nread += out.length;
                }
            }
            // exhausted the output buffer, or used all the input create a new one.
            if (availOutAfter === 0 || self1._offset >= self1._chunkSize) {
                availOutBefore = self1._chunkSize;
                self1._offset = 0;
                self1._buffer = Buffer.allocUnsafe(self1._chunkSize);
            }
            if (availOutAfter === 0) {
                // Not actually done.  Need to reprocess.
                // Also, update the availInBefore to the availInAfter value,
                // so that if we have to hit it a third (fourth, etc.) time,
                // it'll have the correct byte counts.
                inOff += availInBefore - availInAfter;
                availInBefore = availInAfter;
                if (!async) return true;
                var newReq = self1._handle.write(flushFlag, chunk, inOff, availInBefore, self1._buffer, self1._offset, self1._chunkSize);
                newReq.callback = callback; // this same function
                newReq.buffer = chunk;
                return;
            }
            if (!async) return false;
            // finished with the chunk.
            cb();
        }
    };
    util.inherits(Deflate, Zlib);
    util.inherits(Inflate, Zlib);
    util.inherits(Gzip, Zlib);
    util.inherits(Gunzip, Zlib);
    util.inherits(DeflateRaw, Zlib);
    util.inherits(InflateRaw, Zlib);
    util.inherits(Unzip, Zlib);
})(lib);
var PDFReference = /*#__PURE__*/ function(_stream$Writable) {
    (0, _inheritsLooseDefault.default)(PDFReference, _stream$Writable);
    function PDFReference(document, id, data) {
        var _this;
        _this = _stream$Writable.call(this, {
            decodeStrings: false
        }) || this;
        _this.finalize = _this.finalize.bind((0, _assertThisInitializedDefault.default)(_this));
        _this.document = document;
        _this.id = id;
        if (data == null) data = {};
        _this.data = data;
        _this.gen = 0;
        _this.deflate = null;
        _this.compress = _this.document.compress && !_this.data.Filter;
        _this.uncompressedLength = 0;
        _this.chunks = [];
        return _this;
    }
    var _proto = PDFReference.prototype;
    _proto.initDeflate = function initDeflate() {
        var _this2 = this;
        this.data.Filter = "FlateDecode";
        this.deflate = lib.createDeflate();
        this.deflate.on("data", function(chunk) {
            _this2.chunks.push(chunk);
            return _this2.data.Length += chunk.length;
        });
        return this.deflate.on("end", this.finalize);
    };
    _proto._write = function _write(chunk, encoding, callback) {
        if (!(chunk instanceof Uint8Array)) chunk = Buffer$4.from(chunk + "\n", "binary");
        this.uncompressedLength += chunk.length;
        if (this.data.Length == null) this.data.Length = 0;
        if (this.compress) {
            if (!this.deflate) this.initDeflate();
            this.deflate.write(chunk);
        } else {
            this.chunks.push(chunk);
            this.data.Length += chunk.length;
        }
        return callback();
    };
    _proto.end = function end() {
        _stream$Writable.prototype.end.apply(this, arguments);
        if (this.deflate) return this.deflate.end();
        return this.finalize();
    };
    _proto.finalize = function finalize() {
        this.offset = this.document._offset;
        this.document._write(this.id + " " + this.gen + " obj");
        this.document._write(PDFObject$1.convert(this.data));
        if (this.chunks.length) {
            this.document._write("stream");
            for(var _i = 0, _Array$from = Array.from(this.chunks); _i < _Array$from.length; _i++){
                var chunk = _Array$from[_i];
                this.document._write(chunk);
            }
            this.chunks.length = 0; // free up memory
            this.document._write("\nendstream");
        }
        this.document._write("endobj");
        return this.document._refEnd(this);
    };
    _proto.toString = function toString() {
        return this.id + " " + this.gen + " R";
    };
    return PDFReference;
}(stream.Writable);
var PDFTree = /*#__PURE__*/ function() {
    function PDFTree(options) {
        if (options === void 0) options = {};
        this._items = {};
        // disable /Limits output for this tree
        this.limits = typeof options.limits === "boolean" ? options.limits : true;
    }
    var _proto = PDFTree.prototype;
    _proto.add = function add(key, val) {
        return this._items[key] = val;
    };
    _proto.get = function get(key) {
        return this._items[key];
    };
    _proto.toString = function toString() {
        var _this = this;
        // Needs to be sorted by key
        var sortedKeys = Object.keys(this._items).sort(function(a, b) {
            return _this._compareKeys(a, b);
        });
        var out = [
            "<<"
        ];
        if (this.limits && sortedKeys.length > 1) {
            var first = sortedKeys[0];
            var last = sortedKeys[sortedKeys.length - 1];
            out.push("  /Limits " + PDFObject$1.convert([
                this._dataForKey(first),
                this._dataForKey(last)
            ]));
        }
        out.push("  /" + this._keysName() + " [");
        for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(sortedKeys), _step; !(_step = _iterator()).done;){
            var key = _step.value;
            out.push("    " + PDFObject$1.convert(this._dataForKey(key)) + " " + PDFObject$1.convert(this._items[key]));
        }
        out.push("]");
        out.push(">>");
        return out.join("\n");
    };
    _proto._compareKeys = function _compareKeys() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto._keysName = function _keysName() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto._dataForKey = function _dataForKey() {
        throw new Error("Must be implemented by subclasses");
    };
    return PDFTree;
}();
var PDFNameTree = /*#__PURE__*/ function(_PDFTree) {
    (0, _inheritsLooseDefault.default)(PDFNameTree, _PDFTree);
    function PDFNameTree() {
        return _PDFTree.apply(this, arguments) || this;
    }
    var _proto = PDFNameTree.prototype;
    _proto._compareKeys = function _compareKeys(a, b) {
        return a.localeCompare(b);
    };
    _proto._keysName = function _keysName() {
        return "Names";
    };
    _proto._dataForKey = function _dataForKey(k) {
        return new String(k);
    };
    return PDFNameTree;
}(PDFTree);
var escapableRe = /[\n\r\t\b\f\(\)\\]/g;
var escapable = {
    "\n": "\\n",
    "\r": "\\r",
    "	": "\\t",
    "\b": "\\b",
    "\f": "\\f",
    "\\": "\\\\",
    "(": "\\(",
    ")": "\\)"
};
var pad = function pad(str, length) {
    return (Array(length + 1).join("0") + str).slice(-length);
};
// Convert little endian UTF-16 to big endian
var swapBytes = function swapBytes(buff) {
    var l = buff.length;
    if (l & 0x01) throw new Error("Buffer length must be even");
    else for(var i = 0, end = l - 1; i < end; i += 2){
        var a = buff[i];
        buff[i] = buff[i + 1];
        buff[i + 1] = a;
    }
    return buff;
};
var PDFObject = /*#__PURE__*/ function() {
    function PDFObject() {}
    PDFObject.convert = function convert(object) {
        // String literals are converted to the PDF name type
        if (typeof object === "string") return "/" + object;
        // String objects are converted to PDF strings (UTF-16)
        if (object instanceof String) {
            var string = object;
            // Detect if this is a unicode string
            var isUnicode = false;
            for(var i = 0, end = string.length; i < end; i++)if (string.charCodeAt(i) > 0x7f) {
                isUnicode = true;
                break;
            }
            // If so, encode it as big endian UTF-16
            if (isUnicode) string = swapBytes(Buffer$4.from("\uFEFF" + string, "utf16le")).toString("binary");
            // Escape characters as required by the spec
            string = string.replace(escapableRe, function(c) {
                return escapable[c];
            });
            return "(" + string + ")";
        // Buffers are converted to PDF hex strings
        }
        if (Buffer$4.isBuffer(object)) return "<" + object.toString("hex") + ">";
        if (object instanceof PDFReference || object instanceof PDFNameTree) return object.toString();
        if (object instanceof Date) return "(D:" + pad(object.getUTCFullYear(), 4) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2) + "Z)";
        if (Array.isArray(object)) {
            var items = Array.from(object).map(function(e) {
                return PDFObject.convert(e);
            }).join(" ");
            return "[" + items + "]";
        }
        if (({}).toString.call(object) === "[object Object]") {
            var out = [
                "<<"
            ];
            for(var key in object){
                var val = object[key];
                out.push("/" + key + " " + PDFObject.convert(val));
            }
            out.push(">>");
            return out.join("\n");
        }
        if (typeof object === "number") return PDFObject.number(object);
        return "" + object;
    };
    PDFObject.number = function number(n) {
        if (n > -1000000000000000000000 && n < 1e21) return Math.round(n * 1e6) / 1e6;
        throw new Error("unsupported number: " + n);
    };
    return PDFObject;
}();
var PDFObject$1 = PDFObject;
var DEFAULT_MARGINS = {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
var SIZES = {
    "4A0": [
        4767.87,
        6740.79
    ],
    "2A0": [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    EXECUTIVE: [
        521.86,
        756.0
    ],
    FOLIO: [
        612.0,
        936.0
    ],
    LEGAL: [
        612.0,
        1008.0
    ],
    LETTER: [
        612.0,
        792.0
    ],
    TABLOID: [
        792.0,
        1224.0
    ]
};
var PDFPage = /*#__PURE__*/ function() {
    function PDFPage(document, options) {
        if (options === void 0) options = {};
        this.document = document;
        this.size = options.size || "letter";
        this.layout = options.layout || "portrait";
        this.userUnit = options.userUnit || 1.0;
        this.margins = DEFAULT_MARGINS;
        // calculate page dimensions
        var dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
        this.width = dimensions[this.layout === "portrait" ? 0 : 1];
        this.height = dimensions[this.layout === "portrait" ? 1 : 0];
        this.content = this.document.ref();
        // Initialize the Font, XObject, and ExtGState dictionaries
        this.resources = this.document.ref({
            ProcSet: [
                "PDF",
                "Text",
                "ImageB",
                "ImageC",
                "ImageI"
            ]
        });
        // The page dictionary
        this.dictionary = this.document.ref({
            Type: "Page",
            Parent: this.document._root.data.Pages,
            MediaBox: [
                0,
                0,
                this.width,
                this.height
            ],
            Contents: this.content,
            Resources: this.resources,
            UserUnit: this.userUnit
        });
    }
    // Lazily create these objects
    var _proto = PDFPage.prototype;
    _proto.maxY = function maxY() {
        return this.height;
    };
    _proto.write = function write(chunk) {
        return this.content.write(chunk);
    };
    _proto.end = function end() {
        this.dictionary.end();
        this.resources.end();
        return this.content.end();
    };
    (0, _createClassDefault.default)(PDFPage, [
        {
            key: "fonts",
            get: function get() {
                var data = this.resources.data;
                return data.Font != null ? data.Font : data.Font = {};
            }
        },
        {
            key: "xobjects",
            get: function get() {
                var data = this.resources.data;
                return data.XObject != null ? data.XObject : data.XObject = {};
            }
        },
        {
            key: "ext_gstates",
            get: function get() {
                var data = this.resources.data;
                return data.ExtGState != null ? data.ExtGState : data.ExtGState = {};
            }
        },
        {
            key: "patterns",
            get: function get() {
                var data = this.resources.data;
                return data.Pattern != null ? data.Pattern : data.Pattern = {};
            }
        },
        {
            key: "colorSpaces",
            get: function get() {
                var data = this.resources.data;
                return data.ColorSpace || (data.ColorSpace = {});
            }
        },
        {
            key: "annotations",
            get: function get() {
                var data = this.dictionary.data;
                return data.Annots != null ? data.Annots : data.Annots = [];
            }
        },
        {
            key: "structParentTreeKey",
            get: function get() {
                var data = this.dictionary.data;
                return data.StructParents != null ? data.StructParents : data.StructParents = this.document.createStructParentTreeNextKey();
            }
        }
    ]);
    return PDFPage;
}();
var wordArrayToBuffer = function wordArrayToBuffer(wordArray) {
    var byteArray = [];
    for(var i = 0; i < wordArray.sigBytes; i++)byteArray.push(wordArray.words[Math.floor(i / 4)] >> 8 * (3 - i % 4) & 0xff);
    return Buffer$4.from(byteArray);
};
var PDFSecurity = /*#__PURE__*/ function() {
    function PDFSecurity() {}
    PDFSecurity.generateFileID = function generateFileID(info) {
        if (info === void 0) info = {};
        var infoStr = info.CreationDate.getTime() + "\n";
        for(var key in info){
            if (!info.hasOwnProperty(key)) continue;
            infoStr += key + ": " + info[key].valueOf() + "\n";
        }
        return wordArrayToBuffer((0, _md5Default.default)(infoStr));
    };
    return PDFSecurity;
}();
var number$2 = PDFObject$1.number;
var PDFGradient$1 = /*#__PURE__*/ function() {
    function PDFGradient(doc) {
        this.doc = doc;
        this.stops = [];
        this.embedded = false;
        this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    var _proto = PDFGradient.prototype;
    _proto.stop = function stop(pos, color, opacity) {
        if (opacity == null) opacity = 1;
        color = this.doc._normalizeColor(color);
        if (this.stops.length === 0) {
            if (color.length === 3) this._colorSpace = "DeviceRGB";
            else if (color.length === 4) this._colorSpace = "DeviceCMYK";
            else if (color.length === 1) this._colorSpace = "DeviceGray";
            else throw new Error("Unknown color space");
        } else if (this._colorSpace === "DeviceRGB" && color.length !== 3 || this._colorSpace === "DeviceCMYK" && color.length !== 4 || this._colorSpace === "DeviceGray" && color.length !== 1) throw new Error("All gradient stops must use the same color space");
        opacity = Math.max(0, Math.min(1, opacity));
        this.stops.push([
            pos,
            color,
            opacity
        ]);
        return this;
    };
    _proto.setTransform = function setTransform(m11, m12, m21, m22, dx, dy) {
        this.transform = [
            m11,
            m12,
            m21,
            m22,
            dx,
            dy
        ];
        return this;
    };
    _proto.embed = function embed(m) {
        var fn;
        var stopsLength = this.stops.length;
        if (stopsLength === 0) return;
        this.embedded = true;
        this.matrix = m;
        // if the last stop comes before 100%, add a copy at 100%
        var last = this.stops[stopsLength - 1];
        if (last[0] < 1) this.stops.push([
            1,
            last[1],
            last[2]
        ]);
        var bounds = [];
        var encode = [];
        var stops = [];
        for(var i = 0; i < stopsLength - 1; i++){
            encode.push(0, 1);
            if (i + 2 !== stopsLength) bounds.push(this.stops[i + 1][0]);
            fn = this.doc.ref({
                FunctionType: 2,
                Domain: [
                    0,
                    1
                ],
                C0: this.stops[i + 0][1],
                C1: this.stops[i + 1][1],
                N: 1
            });
            stops.push(fn);
            fn.end();
        }
        // if there are only two stops, we don't need a stitching function
        if (stopsLength === 1) fn = stops[0];
        else {
            fn = this.doc.ref({
                FunctionType: 3,
                // stitching function
                Domain: [
                    0,
                    1
                ],
                Functions: stops,
                Bounds: bounds,
                Encode: encode
            });
            fn.end();
        }
        this.id = "Sh" + ++this.doc._gradCount;
        var shader = this.shader(fn);
        shader.end();
        var pattern = this.doc.ref({
            Type: "Pattern",
            PatternType: 2,
            Shading: shader,
            Matrix: this.matrix.map(number$2)
        });
        pattern.end();
        if (this.stops.some(function(stop) {
            return stop[2] < 1;
        })) {
            var grad = this.opacityGradient();
            grad._colorSpace = "DeviceGray";
            for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(this.stops), _step; !(_step = _iterator()).done;){
                var stop = _step.value;
                grad.stop(stop[0], [
                    stop[2]
                ]);
            }
            grad = grad.embed(this.matrix);
            var pageBBox = [
                0,
                0,
                this.doc.page.width,
                this.doc.page.height
            ];
            var form = this.doc.ref({
                Type: "XObject",
                Subtype: "Form",
                FormType: 1,
                BBox: pageBBox,
                Group: {
                    Type: "Group",
                    S: "Transparency",
                    CS: "DeviceGray"
                },
                Resources: {
                    ProcSet: [
                        "PDF",
                        "Text",
                        "ImageB",
                        "ImageC",
                        "ImageI"
                    ],
                    Pattern: {
                        Sh1: grad
                    }
                }
            });
            form.write("/Pattern cs /Sh1 scn");
            form.end(pageBBox.join(" ") + " re f");
            var gstate = this.doc.ref({
                Type: "ExtGState",
                SMask: {
                    Type: "Mask",
                    S: "Luminosity",
                    G: form
                }
            });
            gstate.end();
            var opacityPattern = this.doc.ref({
                Type: "Pattern",
                PatternType: 1,
                PaintType: 1,
                TilingType: 2,
                BBox: pageBBox,
                XStep: pageBBox[2],
                YStep: pageBBox[3],
                Resources: {
                    ProcSet: [
                        "PDF",
                        "Text",
                        "ImageB",
                        "ImageC",
                        "ImageI"
                    ],
                    Pattern: {
                        Sh1: pattern
                    },
                    ExtGState: {
                        Gs1: gstate
                    }
                }
            });
            opacityPattern.write("/Gs1 gs /Pattern cs /Sh1 scn");
            opacityPattern.end(pageBBox.join(" ") + " re f");
            this.doc.page.patterns[this.id] = opacityPattern;
        } else this.doc.page.patterns[this.id] = pattern;
        return pattern;
    };
    _proto.apply = function apply(op) {
        // apply gradient transform to existing document ctm
        var _this$doc$_ctm = this.doc._ctm, m0 = _this$doc$_ctm[0], m1 = _this$doc$_ctm[1], m2 = _this$doc$_ctm[2], m3 = _this$doc$_ctm[3], m4 = _this$doc$_ctm[4], m5 = _this$doc$_ctm[5];
        var _this$transform = this.transform, m11 = _this$transform[0], m12 = _this$transform[1], m21 = _this$transform[2], m22 = _this$transform[3], dx = _this$transform[4], dy = _this$transform[5];
        var m = [
            m0 * m11 + m2 * m12,
            m1 * m11 + m3 * m12,
            m0 * m21 + m2 * m22,
            m1 * m21 + m3 * m22,
            m0 * dx + m2 * dy + m4,
            m1 * dx + m3 * dy + m5
        ];
        if (!this.embedded || m.join(" ") !== this.matrix.join(" ")) this.embed(m);
        return this.doc.addContent("/" + this.id + " " + op);
    };
    return PDFGradient;
}();
var PDFLinearGradient$1 = /*#__PURE__*/ function(_PDFGradient) {
    (0, _inheritsLooseDefault.default)(PDFLinearGradient, _PDFGradient);
    function PDFLinearGradient(doc, x1, y1, x2, y2) {
        var _this;
        _this = _PDFGradient.call(this, doc) || this;
        _this.x1 = x1;
        _this.y1 = y1;
        _this.x2 = x2;
        _this.y2 = y2;
        return _this;
    }
    var _proto2 = PDFLinearGradient.prototype;
    _proto2.shader = function shader(fn) {
        return this.doc.ref({
            ShadingType: 2,
            ColorSpace: this._colorSpace,
            Coords: [
                this.x1,
                this.y1,
                this.x2,
                this.y2
            ],
            Function: fn,
            Extend: [
                true,
                true
            ]
        });
    };
    _proto2.opacityGradient = function opacityGradient() {
        return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
    };
    return PDFLinearGradient;
}(PDFGradient$1);
var PDFRadialGradient$1 = /*#__PURE__*/ function(_PDFGradient2) {
    (0, _inheritsLooseDefault.default)(PDFRadialGradient, _PDFGradient2);
    function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
        var _this2;
        _this2 = _PDFGradient2.call(this, doc) || this;
        _this2.doc = doc;
        _this2.x1 = x1;
        _this2.y1 = y1;
        _this2.r1 = r1;
        _this2.x2 = x2;
        _this2.y2 = y2;
        _this2.r2 = r2;
        return _this2;
    }
    var _proto3 = PDFRadialGradient.prototype;
    _proto3.shader = function shader(fn) {
        return this.doc.ref({
            ShadingType: 3,
            ColorSpace: this._colorSpace,
            Coords: [
                this.x1,
                this.y1,
                this.r1,
                this.x2,
                this.y2,
                this.r2
            ],
            Function: fn,
            Extend: [
                true,
                true
            ]
        });
    };
    _proto3.opacityGradient = function opacityGradient() {
        return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
    };
    return PDFRadialGradient;
}(PDFGradient$1);
var Gradient = {
    PDFGradient: PDFGradient$1,
    PDFLinearGradient: PDFLinearGradient$1,
    PDFRadialGradient: PDFRadialGradient$1
};
var PDFGradient = Gradient.PDFGradient, PDFLinearGradient = Gradient.PDFLinearGradient, PDFRadialGradient = Gradient.PDFRadialGradient;
var ColorMixin = {
    initColor: function initColor() {
        // The opacity dictionaries
        this._opacityRegistry = {};
        this._opacityCount = 0;
        return this._gradCount = 0;
    },
    _normalizeColor: function _normalizeColor(color) {
        if (color instanceof PDFGradient) return color;
        var part;
        if (typeof color === "string") {
            if (color.charAt(0) === "#") {
                if (color.length === 4) color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3");
                var hex = parseInt(color.slice(1), 16);
                color = [
                    hex >> 16,
                    hex >> 8 & 0xff,
                    hex & 0xff
                ];
            } else if (namedColors[color]) color = namedColors[color];
        }
        if (Array.isArray(color)) {
            // RGB
            if (color.length === 3) color = function() {
                var result = [];
                for(var _i = 0, _Array$from = Array.from(color); _i < _Array$from.length; _i++){
                    part = _Array$from[_i];
                    result.push(part / 255);
                }
                return result;
            }();
            else if (color.length === 4) color = function() {
                var result1 = [];
                for(var _i2 = 0, _Array$from2 = Array.from(color); _i2 < _Array$from2.length; _i2++){
                    part = _Array$from2[_i2];
                    result1.push(part / 100);
                }
                return result1;
            }();
            return color;
        }
        return null;
    },
    _setColor: function _setColor(color, stroke) {
        color = this._normalizeColor(color);
        if (!color) return false;
        var op = stroke ? "SCN" : "scn";
        if (color instanceof PDFGradient) {
            this._setColorSpace("Pattern", stroke);
            color.apply(op);
        } else {
            var space = color.length === 4 ? "DeviceCMYK" : "DeviceRGB";
            this._setColorSpace(space, stroke);
            color = color.join(" ");
            this.addContent(color + " " + op);
        }
        return true;
    },
    _setColorSpace: function _setColorSpace(space, stroke) {
        var op = stroke ? "CS" : "cs";
        return this.addContent("/" + space + " " + op);
    },
    fillColor: function fillColor(color, opacity) {
        var set = this._setColor(color, false);
        if (set) this.fillOpacity(opacity);
        // save this for text wrapper, which needs to reset
        // the fill color on new pages
        this._fillColor = [
            color,
            opacity
        ];
        return this;
    },
    strokeColor: function strokeColor(color, opacity) {
        var set = this._setColor(color, true);
        if (set) this.strokeOpacity(opacity);
        return this;
    },
    opacity: function opacity(_opacity) {
        this._doOpacity(_opacity, _opacity);
        return this;
    },
    fillOpacity: function fillOpacity(opacity) {
        this._doOpacity(opacity, null);
        return this;
    },
    strokeOpacity: function strokeOpacity(opacity) {
        this._doOpacity(null, opacity);
        return this;
    },
    _doOpacity: function _doOpacity(fillOpacity, strokeOpacity) {
        var dictionary, name;
        if (fillOpacity == null && strokeOpacity == null) return;
        if (fillOpacity != null) fillOpacity = Math.max(0, Math.min(1, fillOpacity));
        if (strokeOpacity != null) strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
        var key = fillOpacity + "_" + strokeOpacity;
        if (this._opacityRegistry[key]) {
            var _Array$from3 = Array.from(this._opacityRegistry[key]);
            dictionary = _Array$from3[0];
            name = _Array$from3[1];
        } else {
            dictionary = {
                Type: "ExtGState"
            };
            if (fillOpacity != null) dictionary.ca = fillOpacity;
            if (strokeOpacity != null) dictionary.CA = strokeOpacity;
            dictionary = this.ref(dictionary);
            dictionary.end();
            var id = ++this._opacityCount;
            name = "Gs" + id;
            this._opacityRegistry[key] = [
                dictionary,
                name
            ];
        }
        this.page.ext_gstates[name] = dictionary;
        return this.addContent("/" + name + " gs");
    },
    linearGradient: function linearGradient(x1, y1, x2, y2) {
        return new PDFLinearGradient(this, x1, y1, x2, y2);
    },
    radialGradient: function radialGradient(x1, y1, r1, x2, y2, r2) {
        return new PDFRadialGradient(this, x1, y1, r1, x2, y2, r2);
    }
};
var namedColors = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    grey: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
/* eslint-disable no-lonely-if */ var cx, cy, px, py, sx, sy;
cx = cy = px = py = sx = sy = 0;
// parseDataPath copy pasted from svgo
// https://github.com/svg/svgo/blob/e4918ccdd1a2b5831defe0f00c1286744b479448/lib/path.js
var argsCountPerCommand = {
    M: 2,
    m: 2,
    Z: 0,
    z: 0,
    L: 2,
    l: 2,
    H: 1,
    h: 1,
    V: 1,
    v: 1,
    C: 6,
    c: 6,
    S: 4,
    s: 4,
    Q: 4,
    q: 4,
    T: 2,
    t: 2,
    A: 7,
    a: 7
};
/**
 * @type {(c: string) => c is PathDataCommand}
 */ var isCommand = function isCommand(c) {
    return c in argsCountPerCommand;
};
/**
 * @type {(c: string) => boolean}
 */ var isWsp = function isWsp(c) {
    var codePoint = c.codePointAt(0);
    return codePoint === 0x20 || codePoint === 0x9 || codePoint === 0xd || codePoint === 0xa;
};
/**
 * @type {(c: string) => boolean}
 */ var isDigit = function isDigit(c) {
    var codePoint = c.codePointAt(0);
    if (codePoint == null) return false;
    return 48 <= codePoint && codePoint <= 57;
};
/**
 * @typedef {'none' | 'sign' | 'whole' | 'decimal_point' | 'decimal' | 'e' | 'exponent_sign' | 'exponent'} ReadNumberState
 */ /**
 * @type {(string: string, cursor: number) => [number, number | null]}
 */ var readNumber = function readNumber(string, cursor) {
    var i = cursor;
    var value = "";
    var state = /** @type {ReadNumberState} */ "none";
    for(; i < string.length; i += 1){
        var c = string[i];
        if (c === "+" || c === "-") {
            if (state === "none") {
                state = "sign";
                value += c;
                continue;
            }
            if (state === "e") {
                state = "exponent_sign";
                value += c;
                continue;
            }
        }
        if (isDigit(c)) {
            if (state === "none" || state === "sign" || state === "whole") {
                state = "whole";
                value += c;
                continue;
            }
            if (state === "decimal_point" || state === "decimal") {
                state = "decimal";
                value += c;
                continue;
            }
            if (state === "e" || state === "exponent_sign" || state === "exponent") {
                state = "exponent";
                value += c;
                continue;
            }
        }
        if (c === ".") {
            if (state === "none" || state === "sign" || state === "whole") {
                state = "decimal_point";
                value += c;
                continue;
            }
        }
        if (c === "E" || c === "e") {
            if (state === "whole" || state === "decimal_point" || state === "decimal") {
                state = "e";
                value += c;
                continue;
            }
        }
        break;
    }
    var number = Number.parseFloat(value);
    if (Number.isNaN(number)) return [
        cursor,
        null
    ];
    else // step back to delegate iteration to parent loop
    return [
        i - 1,
        number
    ];
};
/**
 * @type {(string: string) => Array<PathDataItem>}
 */ var parsePathData = function parsePathData(string) {
    /**
   * @type {Array<PathDataItem>}
   */ var pathData = [];
    /**
   * @type {null | PathDataCommand}
   */ var command = null;
    var args = /** @type {number[]} */ [];
    var argsCount = 0;
    var canHaveComma = false;
    var hadComma = false;
    for(var i = 0; i < string.length; i += 1){
        var c = string.charAt(i);
        if (isWsp(c)) continue;
        // allow comma only between arguments
        if (canHaveComma && c === ",") {
            if (hadComma) break;
            hadComma = true;
            continue;
        }
        if (isCommand(c)) {
            if (hadComma) return pathData;
            if (command == null) {
                // moveto should be leading command
                if (c !== "M" && c !== "m") return pathData;
            } else {
                // stop if previous command arguments are not flushed
                if (args.length !== 0) return pathData;
            }
            command = c;
            args = [];
            argsCount = argsCountPerCommand[command];
            canHaveComma = false;
            // flush command without arguments
            if (argsCount === 0) pathData.push({
                command: command,
                args: args
            });
            continue;
        }
        // avoid parsing arguments if no command detected
        if (command == null) return pathData;
        // read next argument
        var newCursor = i;
        var number = null;
        if (command === "A" || command === "a") {
            var position = args.length;
            if (position === 0 || position === 1) // allow only positive number without sign as first two arguments
            {
                if (c !== "+" && c !== "-") {
                    var _readNumber = readNumber(string, i);
                    newCursor = _readNumber[0];
                    number = _readNumber[1];
                }
            }
            if (position === 2 || position === 5 || position === 6) {
                var _readNumber2 = readNumber(string, i);
                newCursor = _readNumber2[0];
                number = _readNumber2[1];
            }
            if (position === 3 || position === 4) {
                // read flags
                if (c === "0") number = 0;
                if (c === "1") number = 1;
            }
        } else {
            var _readNumber3 = readNumber(string, i);
            newCursor = _readNumber3[0];
            number = _readNumber3[1];
        }
        if (number == null) return pathData;
        args.push(number);
        canHaveComma = true;
        hadComma = false;
        i = newCursor;
        // flush arguments when necessary count is reached
        if (args.length === argsCount) {
            pathData.push({
                command: command,
                args: args
            });
            // subsequent moveto coordinates are threated as implicit lineto commands
            if (command === "M") command = "L";
            if (command === "m") command = "l";
            args = [];
        }
    }
    return pathData;
};
var _apply = function apply(commands, doc) {
    // current point, control point, and subpath starting point
    cx = cy = px = py = sx = sy = 0;
    // run the commands
    for(var i = 0; i < commands.length; i++){
        var _commands$i = commands[i], command = _commands$i.command, args = _commands$i.args;
        if (typeof runners[command] === "function") runners[command](doc, args);
    }
};
var runners = {
    M: function M(doc, a) {
        cx = a[0];
        cy = a[1];
        px = py = null;
        sx = cx;
        sy = cy;
        return doc.moveTo(cx, cy);
    },
    m: function m(doc, a) {
        cx += a[0];
        cy += a[1];
        px = py = null;
        sx = cx;
        sy = cy;
        return doc.moveTo(cx, cy);
    },
    C: function C(doc, a) {
        cx = a[4];
        cy = a[5];
        px = a[2];
        py = a[3];
        return doc.bezierCurveTo.apply(doc, a);
    },
    c: function c(doc, a) {
        doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
        px = cx + a[2];
        py = cy + a[3];
        cx += a[4];
        return cy += a[5];
    },
    S: function S(doc, a) {
        if (px === null) {
            px = cx;
            py = cy;
        }
        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
        px = a[0];
        py = a[1];
        cx = a[2];
        return cy = a[3];
    },
    s: function s(doc, a) {
        if (px === null) {
            px = cx;
            py = cy;
        }
        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
        px = cx + a[0];
        py = cy + a[1];
        cx += a[2];
        return cy += a[3];
    },
    Q: function Q(doc, a) {
        px = a[0];
        py = a[1];
        cx = a[2];
        cy = a[3];
        return doc.quadraticCurveTo(a[0], a[1], cx, cy);
    },
    q: function q(doc, a) {
        doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
        px = cx + a[0];
        py = cy + a[1];
        cx += a[2];
        return cy += a[3];
    },
    T: function T(doc, a) {
        if (px === null) {
            px = cx;
            py = cy;
        } else {
            px = cx - (px - cx);
            py = cy - (py - cy);
        }
        doc.quadraticCurveTo(px, py, a[0], a[1]);
        px = cx - (px - cx);
        py = cy - (py - cy);
        cx = a[0];
        return cy = a[1];
    },
    t: function t(doc, a) {
        if (px === null) {
            px = cx;
            py = cy;
        } else {
            px = cx - (px - cx);
            py = cy - (py - cy);
        }
        doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
        cx += a[0];
        return cy += a[1];
    },
    A: function A(doc, a) {
        solveArc(doc, cx, cy, a);
        cx = a[5];
        return cy = a[6];
    },
    a: function a(doc, _a) {
        _a[5] += cx;
        _a[6] += cy;
        solveArc(doc, cx, cy, _a);
        cx = _a[5];
        return cy = _a[6];
    },
    L: function L(doc, a) {
        cx = a[0];
        cy = a[1];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    l: function l(doc, a) {
        cx += a[0];
        cy += a[1];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    H: function H(doc, a) {
        cx = a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    h: function h(doc, a) {
        cx += a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    V: function V(doc, a) {
        cy = a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    v: function v(doc, a) {
        cy += a[0];
        px = py = null;
        return doc.lineTo(cx, cy);
    },
    Z: function Z(doc) {
        doc.closePath();
        cx = sx;
        return cy = sy;
    },
    z: function z(doc) {
        doc.closePath();
        cx = sx;
        return cy = sy;
    }
};
var solveArc = function solveArc(doc, x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(segs), _step; !(_step = _iterator()).done;){
        var seg = _step.value;
        var bez = segmentToBezier.apply(void 0, seg);
        doc.bezierCurveTo.apply(doc, bez);
    }
};
// from Inkscape svgtopdf, thanks!
var arcToSegments = function arcToSegments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sin_th = Math.sin(th);
    var cos_th = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
    py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
    var pl = px * px / (rx * rx) + py * py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cos_th / rx;
    var a01 = sin_th / rx;
    var a10 = -sin_th / ry;
    var a11 = cos_th / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactor_sq = 1 / d - 0.25;
    if (sfactor_sq < 0) sfactor_sq = 0;
    var sfactor = Math.sqrt(sfactor_sq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var th_arc = th1 - th0;
    if (th_arc < 0 && sweep === 1) th_arc += 2 * Math.PI;
    else if (th_arc > 0 && sweep === 0) th_arc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * th_arc / segments;
        var th3 = th0 + (i + 1) * th_arc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sin_th,
            cos_th
        ];
    }
    return result;
};
var segmentToBezier = function segmentToBezier(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
    var a00 = cos_th * rx;
    var a01 = -sin_th * ry;
    var a10 = sin_th * rx;
    var a11 = cos_th * ry;
    var th_half = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
    var x1 = cx + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx + Math.cos(th1);
    var y3 = cy + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    return [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
};
var SVGPath = /*#__PURE__*/ function() {
    function SVGPath() {}
    SVGPath.apply = function apply(doc, path) {
        var commands = parsePathData(path);
        _apply(commands, doc);
    };
    return SVGPath;
}();
var number$1 = PDFObject$1.number;
// This constant is used to approximate a symmetrical arc using a cubic
// Bezier curve.
var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var VectorMixin = {
    initVector: function initVector() {
        this._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ]; // current transformation matrix
        return this._ctmStack = [];
    },
    save: function save() {
        this._ctmStack.push(this._ctm.slice());
        // TODO: save/restore colorspace and styles so not setting it unnessesarily all the time?
        return this.addContent("q");
    },
    restore: function restore() {
        this._ctm = this._ctmStack.pop() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        return this.addContent("Q");
    },
    closePath: function closePath() {
        return this.addContent("h");
    },
    lineWidth: function lineWidth(w) {
        return this.addContent(number$1(w) + " w");
    },
    _CAP_STYLES: {
        BUTT: 0,
        ROUND: 1,
        SQUARE: 2
    },
    lineCap: function lineCap(c) {
        if (typeof c === "string") c = this._CAP_STYLES[c.toUpperCase()];
        return this.addContent(c + " J");
    },
    _JOIN_STYLES: {
        MITER: 0,
        ROUND: 1,
        BEVEL: 2
    },
    lineJoin: function lineJoin(j) {
        if (typeof j === "string") j = this._JOIN_STYLES[j.toUpperCase()];
        return this.addContent(j + " j");
    },
    miterLimit: function miterLimit(m) {
        return this.addContent(number$1(m) + " M");
    },
    dash: function dash(length, options) {
        var phase;
        if (options == null) options = {};
        if (length == null) return this;
        if (Array.isArray(length)) {
            length = Array.from(length).map(function(v) {
                return PDFObject$1.number(v);
            }).join(" ");
            phase = options.phase || 0;
            return this.addContent("[" + length + "] " + PDFObject$1.number(phase) + " d");
        }
        var space = options.space != null ? options.space : length;
        phase = options.phase || 0;
        return this.addContent("[" + PDFObject$1.number(length) + " " + PDFObject$1.number(space) + "] " + PDFObject$1.number(phase) + " d");
    },
    undash: function undash() {
        return this.addContent("[] 0 d");
    },
    moveTo: function moveTo(x, y) {
        return this.addContent(number$1(x) + " " + number$1(y) + " m");
    },
    lineTo: function lineTo(x, y) {
        return this.addContent(number$1(x) + " " + number$1(y) + " l");
    },
    bezierCurveTo: function bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        return this.addContent(number$1(cp1x) + " " + number$1(cp1y) + " " + number$1(cp2x) + " " + number$1(cp2y) + " " + number$1(x) + " " + number$1(y) + " c");
    },
    quadraticCurveTo: function quadraticCurveTo(cpx, cpy, x, y) {
        return this.addContent(number$1(cpx) + " " + number$1(cpy) + " " + number$1(x) + " " + number$1(y) + " v");
    },
    rect: function rect(x, y, w, h) {
        return this.addContent(number$1(x) + " " + number$1(y) + " " + number$1(w) + " " + number$1(h) + " re");
    },
    roundedRect: function roundedRect(x, y, w, h, r) {
        if (r == null) r = 0;
        r = Math.min(r, 0.5 * w, 0.5 * h);
        // amount to inset control points from corners (see `ellipse`)
        var c = r * (1.0 - KAPPA);
        this.moveTo(x + r, y);
        this.lineTo(x + w - r, y);
        this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
        this.lineTo(x + w, y + h - r);
        this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
        this.lineTo(x + r, y + h);
        this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
        this.lineTo(x, y + r);
        this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
        return this.closePath();
    },
    ellipse: function ellipse(x, y, r1, r2) {
        // based on http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas/2173084#2173084
        if (r2 == null) r2 = r1;
        x -= r1;
        y -= r2;
        var ox = r1 * KAPPA;
        var oy = r2 * KAPPA;
        var xe = x + r1 * 2;
        var ye = y + r2 * 2;
        var xm = x + r1;
        var ym = y + r2;
        this.moveTo(x, ym);
        this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
        this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
        this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
        this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
        return this.closePath();
    },
    circle: function circle(x, y, radius) {
        return this.ellipse(x, y, radius);
    },
    arc: function arc(x, y, radius, startAngle, endAngle, anticlockwise) {
        if (anticlockwise == null) anticlockwise = false;
        var TWO_PI = 2.0 * Math.PI;
        var HALF_PI = 0.5 * Math.PI;
        var deltaAng = endAngle - startAngle;
        if (Math.abs(deltaAng) > TWO_PI) // draw only full circle if more than that is specified
        deltaAng = TWO_PI;
        else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
            // necessary to flip direction of rendering
            var dir = anticlockwise ? -1 : 1;
            deltaAng = dir * TWO_PI + deltaAng;
        }
        var numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
        var segAng = deltaAng / numSegs;
        var handleLen = segAng / HALF_PI * KAPPA * radius;
        var curAng = startAngle;
        // component distances between anchor point and control point
        var deltaCx = -Math.sin(curAng) * handleLen;
        var deltaCy = Math.cos(curAng) * handleLen;
        // anchor point
        var ax = x + Math.cos(curAng) * radius;
        var ay = y + Math.sin(curAng) * radius;
        // calculate and render segments
        this.moveTo(ax, ay);
        for(var segIdx = 0, end = numSegs, asc = 0 <= end; asc ? segIdx < end : segIdx > end; asc ? segIdx++ : segIdx--){
            // starting control point
            var cp1x = ax + deltaCx;
            var cp1y = ay + deltaCy;
            // step angle
            curAng += segAng;
            // next anchor point
            ax = x + Math.cos(curAng) * radius;
            ay = y + Math.sin(curAng) * radius;
            // next control point delta
            deltaCx = -Math.sin(curAng) * handleLen;
            deltaCy = Math.cos(curAng) * handleLen;
            // ending control point
            var cp2x = ax - deltaCx;
            var cp2y = ay - deltaCy;
            // render segment
            this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
        }
        return this;
    },
    polygon: function polygon() {
        for(var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++)points[_key] = arguments[_key];
        this.moveTo.apply(this, Array.from(points.shift() || []));
        for(var _i = 0, _Array$from = Array.from(points); _i < _Array$from.length; _i++){
            var point = _Array$from[_i];
            this.lineTo.apply(this, Array.from(point || []));
        }
        return this.closePath();
    },
    path: function path(_path) {
        SVGPath.apply(this, _path);
        return this;
    },
    _windingRule: function _windingRule(rule) {
        if (/even-?odd/.test(rule)) return "*";
        return "";
    },
    fill: function fill(color, rule) {
        if (/(even-?odd)|(non-?zero)/.test(color)) {
            rule = color;
            color = null;
        }
        if (color) this.fillColor(color);
        return this.addContent("f" + this._windingRule(rule));
    },
    stroke: function stroke(color) {
        if (color) this.strokeColor(color);
        return this.addContent("S");
    },
    fillAndStroke: function fillAndStroke(fillColor, strokeColor, rule) {
        if (strokeColor == null) strokeColor = fillColor;
        var isFillRule = /(even-?odd)|(non-?zero)/;
        if (isFillRule.test(fillColor)) {
            rule = fillColor;
            fillColor = null;
        }
        if (isFillRule.test(strokeColor)) {
            rule = strokeColor;
            strokeColor = fillColor;
        }
        if (fillColor) {
            this.fillColor(fillColor);
            this.strokeColor(strokeColor);
        }
        return this.addContent("B" + this._windingRule(rule));
    },
    clip: function clip(rule) {
        return this.addContent("W" + this._windingRule(rule) + " n");
    },
    transform: function transform(m11, m12, m21, m22, dx, dy) {
        // keep track of the current transformation matrix
        var m = this._ctm;
        var _Array$from2 = Array.from(m), m0 = _Array$from2[0], m1 = _Array$from2[1], m2 = _Array$from2[2], m3 = _Array$from2[3], m4 = _Array$from2[4], m5 = _Array$from2[5];
        m[0] = m0 * m11 + m2 * m12;
        m[1] = m1 * m11 + m3 * m12;
        m[2] = m0 * m21 + m2 * m22;
        m[3] = m1 * m21 + m3 * m22;
        m[4] = m0 * dx + m2 * dy + m4;
        m[5] = m1 * dx + m3 * dy + m5;
        var values = [
            m11,
            m12,
            m21,
            m22,
            dx,
            dy
        ].map(function(v) {
            return PDFObject$1.number(v);
        }).join(" ");
        return this.addContent(values + " cm");
    },
    translate: function translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    },
    rotate: function rotate(angle, options) {
        if (options === void 0) options = {};
        var rad = angle * Math.PI / 180;
        var cos = Math.cos(rad);
        var sin = Math.sin(rad);
        var x = 0;
        var y = 0;
        if (options.origin != null) {
            var _Array$from3 = Array.from(options.origin);
            x = _Array$from3[0];
            y = _Array$from3[1];
            var x1 = x * cos - y * sin;
            var y1 = x * sin + y * cos;
            x -= x1;
            y -= y1;
        }
        return this.transform(cos, sin, -sin, cos, x, y);
    },
    scale: function scale(xFactor, yFactor, options) {
        if (options === void 0) options = {};
        if (yFactor == null) yFactor = xFactor;
        if (typeof yFactor === "object") {
            options = yFactor;
            yFactor = xFactor;
        }
        var x = 0;
        var y = 0;
        if (options.origin != null) {
            var _Array$from4 = Array.from(options.origin);
            x = _Array$from4[0];
            y = _Array$from4[1];
            x -= xFactor * x;
            y -= yFactor * y;
        }
        return this.transform(xFactor, 0, 0, yFactor, x, y);
    },
    skew: function skew(xAngle, yAngle, options) {
        if (xAngle === void 0) xAngle = 0;
        if (yAngle === void 0) yAngle = 0;
        var radx = xAngle * Math.PI / 180;
        var rady = yAngle * Math.PI / 180;
        var tanx = Math.tan(radx);
        var tany = Math.tan(rady);
        var x = 0;
        var y = 0;
        if (options.origin != null) {
            var _Array$from5 = Array.from(options.origin);
            x = _Array$from5[0];
            y = _Array$from5[1];
            var x1 = x + tanx * y;
            var y1 = y + tany * x;
            x -= x1;
            y -= y1;
        }
        return this.transform(1, tany, tanx, 1, x, y);
    }
};
var range = function range(left, right, inclusive) {
    var range = [];
    var ascending = left < right;
    var end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(var i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
};
var WIN_ANSI_MAP = {
    402: 131,
    8211: 150,
    8212: 151,
    8216: 145,
    8217: 146,
    8218: 130,
    8220: 147,
    8221: 148,
    8222: 132,
    8224: 134,
    8225: 135,
    8226: 149,
    8230: 133,
    8364: 128,
    8240: 137,
    8249: 139,
    8250: 155,
    710: 136,
    8482: 153,
    338: 140,
    339: 156,
    732: 152,
    352: 138,
    353: 154,
    376: 159,
    381: 142,
    382: 158
};
var characters = ".notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n\nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n\nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n\ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n\nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n\nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n\nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n\nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis".split(/\s+/);
function _parse(contents) {
    var obj = {
        attributes: {},
        glyphWidths: {},
        kernPairs: {}
    };
    var section = "";
    for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(contents.split("\n")), _step; !(_step = _iterator()).done;){
        var line = _step.value;
        var match;
        var a;
        if (match = line.match(/^Start(\w+)/)) {
            section = match[1];
            continue;
        } else if (match = line.match(/^End(\w+)/)) {
            section = "";
            continue;
        }
        switch(section){
            case "FontMetrics":
                match = line.match(/(^\w+)\s+(.*)/);
                var key = match[1];
                var value = match[2];
                if (a = obj.attributes[key]) {
                    if (!Array.isArray(a)) a = obj.attributes[key] = [
                        a
                    ];
                    a.push(value);
                } else obj.attributes[key] = value;
                break;
            case "CharMetrics":
                if (!/^CH?\s/.test(line)) continue;
                var name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
                obj.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
                break;
            case "KernPairs":
                match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);
                if (match) obj.kernPairs[match[1] + match[2]] = parseInt(match[3]);
                break;
        }
    }
    return obj;
}
var AFMFont = /*#__PURE__*/ function() {
    AFMFont.open = function open(filename) {
        throw new Error("AFMFont.open not available on browser build");
    };
    AFMFont.fromJson = function fromJson(json) {
        return new AFMFont(json);
    };
    function AFMFont(contents) {
        var _this = this;
        if (typeof contents === "string") {
            this.contents = contents;
            this.parse();
        } else {
            this.attributes = contents.attributes;
            this.glyphWidths = contents.glyphWidths;
            this.kernPairs = contents.kernPairs;
        }
        this.charWidths = range(0, 255, true).map(function(i) {
            return _this.glyphWidths[characters[i]];
        });
        this.bbox = Array.from(this.attributes.FontBBox.split(/\s+/)).map(function(e) {
            return +e;
        });
        this.ascender = +(this.attributes.Ascender || 0);
        this.descender = +(this.attributes.Descender || 0);
        this.xHeight = +(this.attributes.XHeight || 0);
        this.capHeight = +(this.attributes.CapHeight || 0);
        this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
    }
    var _proto = AFMFont.prototype;
    _proto.parse = function parse() {
        var parsed = _parse(this.contents);
        this.attributes = parsed.attributes;
        this.glyphWidths = parsed.glyphWidths;
        this.kernPairs = parsed.kernPairs;
    };
    _proto.encodeText = function encodeText(text) {
        var res = [];
        for(var i = 0, end = text.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--){
            var char = text.charCodeAt(i);
            char = WIN_ANSI_MAP[char] || char;
            res.push(char.toString(16));
        }
        return res;
    };
    _proto.glyphsForString = function glyphsForString(string) {
        var glyphs = [];
        for(var i = 0, end = string.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--){
            var charCode = string.charCodeAt(i);
            glyphs.push(this.characterToGlyph(charCode));
        }
        return glyphs;
    };
    _proto.characterToGlyph = function characterToGlyph(character) {
        return characters[WIN_ANSI_MAP[character] || character] || ".notdef";
    };
    _proto.widthOfGlyph = function widthOfGlyph(glyph) {
        return this.glyphWidths[glyph] || 0;
    };
    _proto.getKernPair = function getKernPair(left, right) {
        return this.kernPairs[left + right] || 0;
    };
    _proto.advancesForGlyphs = function advancesForGlyphs(glyphs) {
        var advances = [];
        for(var index = 0; index < glyphs.length; index++){
            var left = glyphs[index];
            var right = glyphs[index + 1];
            advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
        }
        return advances;
    };
    return AFMFont;
}();
var attributes = [
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:43:52 1997",
            "UniqueID 43052",
            "VMusage 37169 48194"
        ],
        FontName: "Helvetica-Bold",
        FullName: "Helvetica Bold",
        FamilyName: "Helvetica",
        Weight: "Bold",
        ItalicAngle: "0",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-170 -228 1003 962 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "718",
        XHeight: "532",
        Ascender: "718",
        Descender: "-207",
        StdHW: "118",
        StdVW: "140"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:45:12 1997",
            "UniqueID 43053",
            "VMusage 14482 68586"
        ],
        FontName: "Helvetica-BoldOblique",
        FullName: "Helvetica Bold Oblique",
        FamilyName: "Helvetica",
        Weight: "Bold",
        ItalicAngle: "-12",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-174 -228 1114 962",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "718",
        XHeight: "532",
        Ascender: "718",
        Descender: "-207",
        StdHW: "118",
        StdVW: "140"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:44:31 1997",
            "UniqueID 43055",
            "VMusage 14960 69346"
        ],
        FontName: "Helvetica-Oblique",
        FullName: "Helvetica Oblique",
        FamilyName: "Helvetica",
        Weight: "Medium",
        ItalicAngle: "-12",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-170 -225 1116 931 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "718",
        XHeight: "523",
        Ascender: "718",
        Descender: "-207",
        StdHW: "76",
        StdVW: "88"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:38:23 1997",
            "UniqueID 43054",
            "VMusage 37069 48094"
        ],
        FontName: "Helvetica",
        FullName: "Helvetica",
        FamilyName: "Helvetica",
        Weight: "Medium",
        ItalicAngle: "0",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-166 -225 1000 931 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "718",
        XHeight: "523",
        Ascender: "718",
        Descender: "-207",
        StdHW: "76",
        StdVW: "88"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:52:56 1997",
            "UniqueID 43065",
            "VMusage 41636 52661"
        ],
        FontName: "Times-Bold",
        FullName: "Times Bold",
        FamilyName: "Times",
        Weight: "Bold",
        ItalicAngle: "0",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-168 -218 1000 935 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "676",
        XHeight: "461",
        Ascender: "683",
        Descender: "-217",
        StdHW: "44",
        StdVW: "139"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 13:04:06 1997",
            "UniqueID 43066",
            "VMusage 45874 56899"
        ],
        FontName: "Times-BoldItalic",
        FullName: "Times Bold Italic",
        FamilyName: "Times",
        Weight: "Bold",
        ItalicAngle: "-15",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-200 -218 996 921",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "669",
        XHeight: "462",
        Ascender: "683",
        Descender: "-217",
        StdHW: "42",
        StdVW: "121"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:56:55 1997",
            "UniqueID 43067",
            "VMusage 47727 58752"
        ],
        FontName: "Times-Italic",
        FullName: "Times Italic",
        FamilyName: "Times",
        Weight: "Medium",
        ItalicAngle: "-15.5",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-169 -217 1010 883 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "653",
        XHeight: "441",
        Ascender: "683",
        Descender: "-217",
        StdHW: "32",
        StdVW: "76"
    },
    {
        Comment: [
            "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 12:49:17 1997",
            "UniqueID 43068",
            "VMusage 43909 54934"
        ],
        FontName: "Times-Roman",
        FullName: "Times Roman",
        FamilyName: "Times",
        Weight: "Roman",
        ItalicAngle: "0",
        IsFixedPitch: "false",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-168 -218 1000 898 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "002.000",
        Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "662",
        XHeight: "450",
        Ascender: "683",
        Descender: "-217",
        StdHW: "28",
        StdVW: "84"
    },
    {
        Comment: [
            "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Mon Jun 23 16:28:00 1997",
            "UniqueID 43048",
            "VMusage 41139 52164"
        ],
        FontName: "Courier-Bold",
        FullName: "Courier Bold",
        FamilyName: "Courier",
        Weight: "Bold",
        ItalicAngle: "0",
        IsFixedPitch: "true",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-113 -250 749 801 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "003.000",
        Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "562",
        XHeight: "439",
        Ascender: "629",
        Descender: "-157",
        StdHW: "84",
        StdVW: "106"
    },
    {
        Comment: [
            "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Mon Jun 23 16:28:46 1997",
            "UniqueID 43049",
            "VMusage 17529 79244"
        ],
        FontName: "Courier-BoldOblique",
        FullName: "Courier Bold Oblique",
        FamilyName: "Courier",
        Weight: "Bold",
        ItalicAngle: "-12",
        IsFixedPitch: "true",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-57 -250 869 801",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "003.000",
        Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "562",
        XHeight: "439",
        Ascender: "629",
        Descender: "-157",
        StdHW: "84",
        StdVW: "106"
    },
    {
        Comment: [
            "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 17:37:52 1997",
            "UniqueID 43051",
            "VMusage 16248 75829"
        ],
        FontName: "Courier-Oblique",
        FullName: "Courier Oblique",
        FamilyName: "Courier",
        Weight: "Medium",
        ItalicAngle: "-12",
        IsFixedPitch: "true",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-27 -250 849 805 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "003.000",
        Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "562",
        XHeight: "426",
        Ascender: "629",
        Descender: "-157",
        StdHW: "51",
        StdVW: "51"
    },
    {
        Comment: [
            "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
            "Creation Date: Thu May  1 17:27:09 1997",
            "UniqueID 43050",
            "VMusage 39754 50779"
        ],
        FontName: "Courier",
        FullName: "Courier",
        FamilyName: "Courier",
        Weight: "Medium",
        ItalicAngle: "0",
        IsFixedPitch: "true",
        CharacterSet: "ExtendedRoman",
        FontBBox: "-23 -250 715 805 ",
        UnderlinePosition: "-100",
        UnderlineThickness: "50",
        Version: "003.000",
        Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
        EncodingScheme: "AdobeStandardEncoding",
        CapHeight: "562",
        XHeight: "426",
        Ascender: "629",
        Descender: "-157",
        StdHW: "51",
        StdVW: "51"
    }
];
var glyphWidths = {
    space: [
        278,
        278,
        278,
        278,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    exclam: [
        333,
        333,
        278,
        278,
        333,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    quotedbl: [
        474,
        474,
        355,
        355,
        555,
        555,
        420,
        408,
        600,
        600,
        600,
        600
    ],
    numbersign: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    dollar: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    percent: [
        889,
        889,
        889,
        889,
        1000,
        833,
        833,
        833,
        600,
        600,
        600,
        600
    ],
    ampersand: [
        722,
        722,
        667,
        667,
        833,
        778,
        778,
        778,
        600,
        600,
        600,
        600
    ],
    quoteright: [
        278,
        278,
        222,
        222,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    parenleft: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    parenright: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    asterisk: [
        389,
        389,
        389,
        389,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    plus: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    comma: [
        278,
        278,
        278,
        278,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    hyphen: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    period: [
        278,
        278,
        278,
        278,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    slash: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    zero: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    one: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    two: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    three: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    four: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    five: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    six: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    seven: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    eight: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    nine: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    colon: [
        333,
        333,
        278,
        278,
        333,
        333,
        333,
        278,
        600,
        600,
        600,
        600
    ],
    semicolon: [
        333,
        333,
        278,
        278,
        333,
        333,
        333,
        278,
        600,
        600,
        600,
        600
    ],
    less: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    equal: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    greater: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    question: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    at: [
        975,
        975,
        1015,
        1015,
        930,
        832,
        920,
        921,
        600,
        600,
        600,
        600
    ],
    A: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    B: [
        722,
        722,
        667,
        667,
        667,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    C: [
        722,
        722,
        722,
        722,
        722,
        667,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    D: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    E: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    F: [
        611,
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        600,
        600,
        600,
        600
    ],
    G: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    H: [
        722,
        722,
        722,
        722,
        778,
        778,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    I: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    J: [
        556,
        556,
        500,
        500,
        500,
        500,
        444,
        389,
        600,
        600,
        600,
        600
    ],
    K: [
        722,
        722,
        667,
        667,
        778,
        667,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    L: [
        611,
        611,
        556,
        556,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    M: [
        833,
        833,
        833,
        833,
        944,
        889,
        833,
        889,
        600,
        600,
        600,
        600
    ],
    N: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    O: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    P: [
        667,
        667,
        667,
        667,
        611,
        611,
        611,
        556,
        600,
        600,
        600,
        600
    ],
    Q: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    R: [
        722,
        722,
        722,
        722,
        722,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    S: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    T: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    U: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    V: [
        667,
        667,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    W: [
        944,
        944,
        944,
        944,
        1000,
        889,
        833,
        944,
        600,
        600,
        600,
        600
    ],
    X: [
        667,
        667,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Y: [
        667,
        667,
        667,
        667,
        722,
        611,
        556,
        722,
        600,
        600,
        600,
        600
    ],
    Z: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    bracketleft: [
        333,
        333,
        278,
        278,
        333,
        333,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    backslash: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    bracketright: [
        333,
        333,
        278,
        278,
        333,
        333,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    asciicircum: [
        584,
        584,
        469,
        469,
        581,
        570,
        422,
        469,
        600,
        600,
        600,
        600
    ],
    underscore: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    quoteleft: [
        278,
        278,
        222,
        222,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    a: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    b: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    c: [
        556,
        556,
        500,
        500,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    d: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    e: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    f: [
        333,
        333,
        278,
        278,
        333,
        333,
        278,
        333,
        600,
        600,
        600,
        600
    ],
    g: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    h: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    i: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    j: [
        278,
        278,
        222,
        222,
        333,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    k: [
        556,
        556,
        500,
        500,
        556,
        500,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    l: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    m: [
        889,
        889,
        833,
        833,
        833,
        778,
        722,
        778,
        600,
        600,
        600,
        600
    ],
    n: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    o: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    p: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    q: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    r: [
        389,
        389,
        333,
        333,
        444,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    s: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    t: [
        333,
        333,
        278,
        278,
        333,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    u: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    v: [
        556,
        556,
        500,
        500,
        500,
        444,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    w: [
        778,
        778,
        722,
        722,
        722,
        667,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    x: [
        556,
        556,
        500,
        500,
        500,
        500,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    y: [
        556,
        556,
        500,
        500,
        500,
        444,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    z: [
        500,
        500,
        500,
        500,
        444,
        389,
        389,
        444,
        600,
        600,
        600,
        600
    ],
    braceleft: [
        389,
        389,
        334,
        334,
        394,
        348,
        400,
        480,
        600,
        600,
        600,
        600
    ],
    bar: [
        280,
        280,
        260,
        260,
        220,
        220,
        275,
        200,
        600,
        600,
        600,
        600
    ],
    braceright: [
        389,
        389,
        334,
        334,
        394,
        348,
        400,
        480,
        600,
        600,
        600,
        600
    ],
    asciitilde: [
        584,
        584,
        584,
        584,
        520,
        570,
        541,
        541,
        600,
        600,
        600,
        600
    ],
    exclamdown: [
        333,
        333,
        333,
        333,
        333,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    cent: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    sterling: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    fraction: [
        167,
        167,
        167,
        167,
        167,
        167,
        167,
        167,
        600,
        600,
        600,
        600
    ],
    yen: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    florin: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    section: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    currency: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    quotesingle: [
        238,
        238,
        191,
        191,
        278,
        278,
        214,
        180,
        600,
        600,
        600,
        600
    ],
    quotedblleft: [
        500,
        500,
        333,
        333,
        500,
        500,
        556,
        444,
        600,
        600,
        600,
        600
    ],
    guillemotleft: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    guilsinglleft: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    guilsinglright: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    fi: [
        611,
        611,
        500,
        500,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    fl: [
        611,
        611,
        500,
        500,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    endash: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    dagger: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    daggerdbl: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    periodcentered: [
        278,
        278,
        278,
        278,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    paragraph: [
        556,
        556,
        537,
        537,
        540,
        500,
        523,
        453,
        600,
        600,
        600,
        600
    ],
    bullet: [
        350,
        350,
        350,
        350,
        350,
        350,
        350,
        350,
        600,
        600,
        600,
        600
    ],
    quotesinglbase: [
        278,
        278,
        222,
        222,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    quotedblbase: [
        500,
        500,
        333,
        333,
        500,
        500,
        556,
        444,
        600,
        600,
        600,
        600
    ],
    quotedblright: [
        500,
        500,
        333,
        333,
        500,
        500,
        556,
        444,
        600,
        600,
        600,
        600
    ],
    guillemotright: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    ellipsis: [
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        889,
        1000,
        600,
        600,
        600,
        600
    ],
    perthousand: [
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        600,
        600,
        600,
        600
    ],
    questiondown: [
        611,
        611,
        611,
        611,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    grave: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    acute: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    circumflex: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    tilde: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    macron: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    breve: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    dotaccent: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    dieresis: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    ring: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    cedilla: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    hungarumlaut: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    ogonek: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    caron: [
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    emdash: [
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        889,
        1000,
        600,
        600,
        600,
        600
    ],
    AE: [
        1000,
        1000,
        1000,
        1000,
        1000,
        944,
        889,
        889,
        600,
        600,
        600,
        600
    ],
    ordfeminine: [
        370,
        370,
        370,
        370,
        300,
        266,
        276,
        276,
        600,
        600,
        600,
        600
    ],
    Lslash: [
        611,
        611,
        556,
        556,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Oslash: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    OE: [
        1000,
        1000,
        1000,
        1000,
        1000,
        944,
        944,
        889,
        600,
        600,
        600,
        600
    ],
    ordmasculine: [
        365,
        365,
        365,
        365,
        330,
        300,
        310,
        310,
        600,
        600,
        600,
        600
    ],
    ae: [
        889,
        889,
        889,
        889,
        722,
        722,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    dotlessi: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    lslash: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    oslash: [
        611,
        611,
        611,
        611,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    oe: [
        944,
        944,
        944,
        944,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    germandbls: [
        611,
        611,
        611,
        611,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Idieresis: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    eacute: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    abreve: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    uhungarumlaut: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    ecaron: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Ydieresis: [
        667,
        667,
        667,
        667,
        722,
        611,
        556,
        722,
        600,
        600,
        600,
        600
    ],
    divide: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    Yacute: [
        667,
        667,
        667,
        667,
        722,
        611,
        556,
        722,
        600,
        600,
        600,
        600
    ],
    Acircumflex: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    aacute: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Ucircumflex: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    yacute: [
        556,
        556,
        500,
        500,
        500,
        444,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    scommaaccent: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    ecircumflex: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Uring: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Udieresis: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    aogonek: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Uacute: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    uogonek: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Edieresis: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    Dcroat: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    commaaccent: [
        250,
        250,
        250,
        250,
        250,
        250,
        250,
        250,
        600,
        600,
        600,
        600
    ],
    copyright: [
        737,
        737,
        737,
        737,
        747,
        747,
        760,
        760,
        600,
        600,
        600,
        600
    ],
    Emacron: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    ccaron: [
        556,
        556,
        500,
        500,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    aring: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Ncommaaccent: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    lacute: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    agrave: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Tcommaaccent: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Cacute: [
        722,
        722,
        722,
        722,
        722,
        667,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    atilde: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Edotaccent: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    scaron: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    scedilla: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    iacute: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    lozenge: [
        494,
        494,
        471,
        471,
        494,
        494,
        471,
        471,
        600,
        600,
        600,
        600
    ],
    Rcaron: [
        722,
        722,
        722,
        722,
        722,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    Gcommaaccent: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    ucircumflex: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    acircumflex: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    Amacron: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    rcaron: [
        389,
        389,
        333,
        333,
        444,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    ccedilla: [
        556,
        556,
        500,
        500,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Zdotaccent: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Thorn: [
        667,
        667,
        667,
        667,
        611,
        611,
        611,
        556,
        600,
        600,
        600,
        600
    ],
    Omacron: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Racute: [
        722,
        722,
        722,
        722,
        722,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    Sacute: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    dcaron: [
        743,
        743,
        643,
        643,
        672,
        608,
        544,
        588,
        600,
        600,
        600,
        600
    ],
    Umacron: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    uring: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    threesuperior: [
        333,
        333,
        333,
        333,
        300,
        300,
        300,
        300,
        600,
        600,
        600,
        600
    ],
    Ograve: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Agrave: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Abreve: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    multiply: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    uacute: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Tcaron: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    partialdiff: [
        494,
        494,
        476,
        476,
        494,
        494,
        476,
        476,
        600,
        600,
        600,
        600
    ],
    ydieresis: [
        556,
        556,
        500,
        500,
        500,
        444,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    Nacute: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    icircumflex: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    Ecircumflex: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    adieresis: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    edieresis: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    cacute: [
        556,
        556,
        500,
        500,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    nacute: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    umacron: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Ncaron: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    Iacute: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    plusminus: [
        584,
        584,
        584,
        584,
        570,
        570,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    brokenbar: [
        280,
        280,
        260,
        260,
        220,
        220,
        275,
        200,
        600,
        600,
        600,
        600
    ],
    registered: [
        737,
        737,
        737,
        737,
        747,
        747,
        760,
        760,
        600,
        600,
        600,
        600
    ],
    Gbreve: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Idotaccent: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    summation: [
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600,
        600
    ],
    Egrave: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    racute: [
        389,
        389,
        333,
        333,
        444,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    omacron: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Zacute: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Zcaron: [
        611,
        611,
        611,
        611,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    greaterequal: [
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        600,
        600,
        600,
        600
    ],
    Eth: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Ccedilla: [
        722,
        722,
        722,
        722,
        722,
        667,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    lcommaaccent: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    tcaron: [
        389,
        389,
        317,
        317,
        416,
        366,
        300,
        326,
        600,
        600,
        600,
        600
    ],
    eogonek: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Uogonek: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Aacute: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Adieresis: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    egrave: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    zacute: [
        500,
        500,
        500,
        500,
        444,
        389,
        389,
        444,
        600,
        600,
        600,
        600
    ],
    iogonek: [
        278,
        278,
        222,
        222,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    Oacute: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    oacute: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    amacron: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        444,
        600,
        600,
        600,
        600
    ],
    sacute: [
        556,
        556,
        500,
        500,
        389,
        389,
        389,
        389,
        600,
        600,
        600,
        600
    ],
    idieresis: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    Ocircumflex: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Ugrave: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Delta: [
        612,
        612,
        612,
        612,
        612,
        612,
        612,
        612,
        600,
        600,
        600,
        600
    ],
    thorn: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    twosuperior: [
        333,
        333,
        333,
        333,
        300,
        300,
        300,
        300,
        600,
        600,
        600,
        600
    ],
    Odieresis: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    mu: [
        611,
        611,
        556,
        556,
        556,
        576,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    igrave: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    ohungarumlaut: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Eogonek: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    dcroat: [
        611,
        611,
        556,
        556,
        556,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    threequarters: [
        834,
        834,
        834,
        834,
        750,
        750,
        750,
        750,
        600,
        600,
        600,
        600
    ],
    Scedilla: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    lcaron: [
        400,
        400,
        299,
        299,
        394,
        382,
        300,
        344,
        600,
        600,
        600,
        600
    ],
    Kcommaaccent: [
        722,
        722,
        667,
        667,
        778,
        667,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    Lacute: [
        611,
        611,
        556,
        556,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    trademark: [
        1000,
        1000,
        1000,
        1000,
        1000,
        1000,
        980,
        980,
        600,
        600,
        600,
        600
    ],
    edotaccent: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    Igrave: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    Imacron: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    Lcaron: [
        611,
        611,
        556,
        556,
        667,
        611,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    onehalf: [
        834,
        834,
        834,
        834,
        750,
        750,
        750,
        750,
        600,
        600,
        600,
        600
    ],
    lessequal: [
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        600,
        600,
        600,
        600
    ],
    ocircumflex: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    ntilde: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Uhungarumlaut: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    Eacute: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    emacron: [
        556,
        556,
        556,
        556,
        444,
        444,
        444,
        444,
        600,
        600,
        600,
        600
    ],
    gbreve: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    onequarter: [
        834,
        834,
        834,
        834,
        750,
        750,
        750,
        750,
        600,
        600,
        600,
        600
    ],
    Scaron: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    Scommaaccent: [
        667,
        667,
        667,
        667,
        556,
        556,
        500,
        556,
        600,
        600,
        600,
        600
    ],
    Ohungarumlaut: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    degree: [
        400,
        400,
        400,
        400,
        400,
        400,
        400,
        400,
        600,
        600,
        600,
        600
    ],
    ograve: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Ccaron: [
        722,
        722,
        722,
        722,
        722,
        667,
        667,
        667,
        600,
        600,
        600,
        600
    ],
    ugrave: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    radical: [
        549,
        549,
        453,
        453,
        549,
        549,
        453,
        453,
        600,
        600,
        600,
        600
    ],
    Dcaron: [
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    rcommaaccent: [
        389,
        389,
        333,
        333,
        444,
        389,
        389,
        333,
        600,
        600,
        600,
        600
    ],
    Ntilde: [
        722,
        722,
        722,
        722,
        722,
        722,
        667,
        722,
        600,
        600,
        600,
        600
    ],
    otilde: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    Rcommaaccent: [
        722,
        722,
        722,
        722,
        722,
        667,
        611,
        667,
        600,
        600,
        600,
        600
    ],
    Lcommaaccent: [
        611,
        611,
        556,
        556,
        667,
        611,
        556,
        611,
        600,
        600,
        600,
        600
    ],
    Atilde: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Aogonek: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Aring: [
        722,
        722,
        667,
        667,
        722,
        667,
        611,
        722,
        600,
        600,
        600,
        600
    ],
    Otilde: [
        778,
        778,
        778,
        778,
        778,
        722,
        722,
        722,
        600,
        600,
        600,
        600
    ],
    zdotaccent: [
        500,
        500,
        500,
        500,
        444,
        389,
        389,
        444,
        600,
        600,
        600,
        600
    ],
    Ecaron: [
        667,
        667,
        667,
        667,
        667,
        667,
        611,
        611,
        600,
        600,
        600,
        600
    ],
    Iogonek: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    kcommaaccent: [
        556,
        556,
        500,
        500,
        556,
        500,
        444,
        500,
        600,
        600,
        600,
        600
    ],
    minus: [
        584,
        584,
        584,
        584,
        570,
        606,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    Icircumflex: [
        278,
        278,
        278,
        278,
        389,
        389,
        333,
        333,
        600,
        600,
        600,
        600
    ],
    ncaron: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    tcommaaccent: [
        333,
        333,
        278,
        278,
        333,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    logicalnot: [
        584,
        584,
        584,
        584,
        570,
        606,
        675,
        564,
        600,
        600,
        600,
        600
    ],
    odieresis: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    udieresis: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    notequal: [
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        549,
        600,
        600,
        600,
        600
    ],
    gcommaaccent: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    eth: [
        611,
        611,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    zcaron: [
        500,
        500,
        500,
        500,
        444,
        389,
        389,
        444,
        600,
        600,
        600,
        600
    ],
    ncommaaccent: [
        611,
        611,
        556,
        556,
        556,
        556,
        500,
        500,
        600,
        600,
        600,
        600
    ],
    onesuperior: [
        333,
        333,
        333,
        333,
        300,
        300,
        300,
        300,
        600,
        600,
        600,
        600
    ],
    imacron: [
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        278,
        600,
        600,
        600,
        600
    ],
    Euro: [
        556,
        556,
        556,
        556,
        500,
        500,
        500,
        500,
        600,
        600,
        600,
        600
    ]
};
var kernPairs = {
    AC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    ACacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    ACcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    ACcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    ATcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    ATcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Au: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Auacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Audieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Augrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Auhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Auogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Auring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Av: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Aw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Ay: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Ayacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AacuteC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AacuteCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AacuteCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AacuteCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AacuteG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AacuteGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AacuteGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AacuteO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AacuteQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AacuteT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AacuteTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AacuteTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AacuteU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AacuteV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AacuteW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AacuteY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AacuteYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AacuteYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Aacuteu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacuteuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aacutev: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Aacutew: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Aacutey: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aacuteyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aacuteydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AbreveC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AbreveCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AbreveCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AbreveCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AbreveG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AbreveGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AbreveGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AbreveO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AbreveQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AbreveT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AbreveTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AbreveTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AbreveU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AbreveV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AbreveW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AbreveY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AbreveYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AbreveYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Abreveu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abreveuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Abrevev: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Abrevew: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Abrevey: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Abreveyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Abreveydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AcircumflexC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AcircumflexCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AcircumflexCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AcircumflexCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AcircumflexG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AcircumflexGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AcircumflexGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AcircumflexO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AcircumflexQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AcircumflexT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AcircumflexTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AcircumflexTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AcircumflexU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AcircumflexV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AcircumflexW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AcircumflexY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AcircumflexYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AcircumflexYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Acircumflexu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Acircumflexv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Acircumflexw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Acircumflexy: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Acircumflexyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Acircumflexydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AdieresisC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AdieresisCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AdieresisCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AdieresisCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AdieresisG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AdieresisGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AdieresisGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AdieresisO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AdieresisQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AdieresisT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AdieresisTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AdieresisTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AdieresisU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AdieresisV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AdieresisW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AdieresisY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AdieresisYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AdieresisYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Adieresisu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Adieresisv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Adieresisw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Adieresisy: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Adieresisyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Adieresisydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AgraveC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AgraveCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AgraveCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AgraveCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AgraveG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AgraveGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AgraveGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AgraveO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AgraveQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AgraveT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AgraveTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AgraveTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AgraveU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AgraveV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AgraveW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AgraveY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AgraveYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AgraveYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Agraveu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agraveuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Agravev: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Agravew: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Agravey: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Agraveyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Agraveydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AmacronC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AmacronCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AmacronCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AmacronCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AmacronG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AmacronGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AmacronGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AmacronO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AmacronQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AmacronT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AmacronTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AmacronTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AmacronU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AmacronV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AmacronW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AmacronY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AmacronYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AmacronYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Amacronu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Amacronv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Amacronw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Amacrony: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Amacronyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Amacronydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AogonekC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AogonekCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AogonekCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AogonekCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AogonekG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AogonekGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AogonekGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AogonekO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AogonekQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AogonekT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AogonekTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AogonekTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AogonekU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AogonekV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AogonekW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AogonekY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AogonekYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AogonekYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Aogoneku: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aogonekv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Aogonekw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -52
    ],
    Aogoneky: [
        -30,
        -30,
        -40,
        -40,
        -34,
        -34,
        -55,
        -52
    ],
    Aogonekyacute: [
        -30,
        -30,
        -40,
        -40,
        -34,
        -34,
        -55,
        -52
    ],
    Aogonekydieresis: [
        -30,
        -30,
        -40,
        -40,
        -34,
        -34,
        -55,
        -52
    ],
    AringC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AringCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AringCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AringCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AringG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AringGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AringGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AringO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AringQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AringT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AringTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AringTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AringU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AringV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AringW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AringY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AringYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AringYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Aringu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Aringv: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Aringw: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Aringy: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aringyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Aringydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    AtildeC: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AtildeCacute: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AtildeCcaron: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AtildeCcedilla: [
        -40,
        -40,
        -30,
        -30,
        -55,
        -65,
        -30,
        -40
    ],
    AtildeG: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AtildeGbreve: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AtildeGcommaaccent: [
        -50,
        -50,
        -30,
        -30,
        -55,
        -60,
        -35,
        -40
    ],
    AtildeO: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOacute: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOcircumflex: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOdieresis: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOgrave: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOhungarumlaut: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOmacron: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOslash: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeOtilde: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -50,
        -40,
        -55
    ],
    AtildeQ: [
        -40,
        -40,
        -30,
        -30,
        -45,
        -55,
        -40,
        -55
    ],
    AtildeT: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AtildeTcaron: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AtildeTcommaaccent: [
        -90,
        -90,
        -120,
        -120,
        -95,
        -55,
        -37,
        -111
    ],
    AtildeU: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUacute: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUcircumflex: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUdieresis: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUgrave: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUhungarumlaut: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUmacron: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUogonek: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeUring: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -55
    ],
    AtildeV: [
        -80,
        -80,
        -70,
        -70,
        -145,
        -95,
        -105,
        -135
    ],
    AtildeW: [
        -60,
        -60,
        -50,
        -50,
        -130,
        -100,
        -95,
        -90
    ],
    AtildeY: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AtildeYacute: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    AtildeYdieresis: [
        -110,
        -110,
        -100,
        -100,
        -100,
        -70,
        -55,
        -105
    ],
    Atildeu: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeuacute: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeudieresis: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeugrave: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeumacron: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeuogonek: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildeuring: [
        -30,
        -30,
        -30,
        -30,
        -50,
        -30,
        -20
    ],
    Atildev: [
        -40,
        -40,
        -40,
        -40,
        -100,
        -74,
        -55,
        -74
    ],
    Atildew: [
        -30,
        -30,
        -40,
        -40,
        -90,
        -74,
        -55,
        -92
    ],
    Atildey: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Atildeyacute: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    Atildeydieresis: [
        -30,
        -30,
        -40,
        -40,
        -74,
        -74,
        -55,
        -92
    ],
    BA: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAacute: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAbreve: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAcircumflex: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAdieresis: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAgrave: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAmacron: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAogonek: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAring: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BAtilde: [
        -30,
        -30,
        0,
        0,
        -30,
        -25,
        -25,
        -35
    ],
    BU: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUacute: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUcircumflex: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUdieresis: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUgrave: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUhungarumlaut: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUmacron: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUogonek: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    BUring: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    DA: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAacute: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAbreve: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAdieresis: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAgrave: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAmacron: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAogonek: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAring: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DAtilde: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DV: [
        -40,
        -40,
        -70,
        -70,
        -40,
        -50,
        -40,
        -40
    ],
    DW: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -30
    ],
    DY: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DYacute: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DYdieresis: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    Dcomma: [
        -30,
        -30,
        -70,
        -70
    ],
    Dperiod: [
        -30,
        -30,
        -70,
        -70,
        -20
    ],
    DcaronA: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAacute: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAbreve: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAdieresis: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAgrave: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAmacron: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAogonek: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAring: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronAtilde: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcaronV: [
        -40,
        -40,
        -70,
        -70,
        -40,
        -50,
        -40,
        -40
    ],
    DcaronW: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -30
    ],
    DcaronY: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DcaronYacute: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DcaronYdieresis: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    Dcaroncomma: [
        -30,
        -30,
        -70,
        -70
    ],
    Dcaronperiod: [
        -30,
        -30,
        -70,
        -70,
        -20
    ],
    DcroatA: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAacute: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAbreve: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAdieresis: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAgrave: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAmacron: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAogonek: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAring: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatAtilde: [
        -40,
        -40,
        -40,
        -40,
        -35,
        -25,
        -35,
        -40
    ],
    DcroatV: [
        -40,
        -40,
        -70,
        -70,
        -40,
        -50,
        -40,
        -40
    ],
    DcroatW: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -30
    ],
    DcroatY: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DcroatYacute: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    DcroatYdieresis: [
        -70,
        -70,
        -90,
        -90,
        -40,
        -50,
        -40,
        -55
    ],
    Dcroatcomma: [
        -30,
        -30,
        -70,
        -70
    ],
    Dcroatperiod: [
        -30,
        -30,
        -70,
        -70,
        -20
    ],
    FA: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAacute: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAbreve: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAcircumflex: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAdieresis: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAgrave: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAmacron: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAogonek: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAring: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    FAtilde: [
        -80,
        -80,
        -80,
        -80,
        -90,
        -100,
        -115,
        -74
    ],
    Fa: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Faacute: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fabreve: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Facircumflex: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fadieresis: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fagrave: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Famacron: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Faogonek: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Faring: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fatilde: [
        -20,
        -20,
        -50,
        -50,
        -25,
        -95,
        -75,
        -15
    ],
    Fcomma: [
        -100,
        -100,
        -150,
        -150,
        -92,
        -129,
        -135,
        -80
    ],
    Fperiod: [
        -100,
        -100,
        -150,
        -150,
        -110,
        -129,
        -135,
        -80
    ],
    JA: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAbreve: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAogonek: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAring: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    JAtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -25,
        -40,
        -60
    ],
    Jcomma: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        -25
    ],
    Jperiod: [
        -20,
        -20,
        -30,
        -30,
        -20,
        -10,
        -25
    ],
    Ju: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Juacute: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jucircumflex: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Judieresis: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jugrave: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Juhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jumacron: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Juogonek: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Juring: [
        -20,
        -20,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    KO: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOacute: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOcircumflex: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOdieresis: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOgrave: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOhungarumlaut: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOmacron: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOslash: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KOtilde: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    Ke: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Keacute: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kecaron: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kecircumflex: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kedieresis: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kedotaccent: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kegrave: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kemacron: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Keogonek: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Ko: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Koacute: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kocircumflex: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kodieresis: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kograve: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kohungarumlaut: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Komacron: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Koslash: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kotilde: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Ku: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kuacute: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kudieresis: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kugrave: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kumacron: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kuogonek: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kuring: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Ky: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    Kyacute: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    Kydieresis: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    KcommaaccentO: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOacute: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOcircumflex: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOdieresis: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOgrave: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOhungarumlaut: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOmacron: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOslash: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    KcommaaccentOtilde: [
        -30,
        -30,
        -50,
        -50,
        -30,
        -30,
        -50,
        -30
    ],
    Kcommaaccente: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccenteacute: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentecaron: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentecircumflex: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentedieresis: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentedotaccent: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentegrave: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccentemacron: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccenteogonek: [
        -15,
        -15,
        -40,
        -40,
        -25,
        -25,
        -35,
        -25
    ],
    Kcommaaccento: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentoacute: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentocircumflex: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentodieresis: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentograve: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentohungarumlaut: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentomacron: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentoslash: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentotilde: [
        -35,
        -35,
        -40,
        -40,
        -25,
        -25,
        -40,
        -35
    ],
    Kcommaaccentu: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentuacute: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentucircumflex: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentudieresis: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentugrave: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentuhungarumlaut: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentumacron: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccentuogonek: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccenturing: [
        -30,
        -30,
        -30,
        -30,
        -15,
        -20,
        -40,
        -15
    ],
    Kcommaaccenty: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    Kcommaaccentyacute: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    Kcommaaccentydieresis: [
        -40,
        -40,
        -50,
        -50,
        -45,
        -20,
        -40,
        -25
    ],
    LT: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LTcaron: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LTcommaaccent: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LV: [
        -110,
        -110,
        -110,
        -110,
        -92,
        -37,
        -55,
        -100
    ],
    LW: [
        -80,
        -80,
        -70,
        -70,
        -92,
        -37,
        -55,
        -74
    ],
    LY: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LYacute: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LYdieresis: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    Lquotedblright: [
        -140,
        -140,
        -140,
        -140,
        -20
    ],
    Lquoteright: [
        -140,
        -140,
        -160,
        -160,
        -110,
        -55,
        -37,
        -92
    ],
    Ly: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lyacute: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lydieresis: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    LacuteT: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LacuteTcaron: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LacuteTcommaaccent: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LacuteV: [
        -110,
        -110,
        -110,
        -110,
        -92,
        -37,
        -55,
        -100
    ],
    LacuteW: [
        -80,
        -80,
        -70,
        -70,
        -92,
        -37,
        -55,
        -74
    ],
    LacuteY: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LacuteYacute: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LacuteYdieresis: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    Lacutequotedblright: [
        -140,
        -140,
        -140,
        -140,
        -20
    ],
    Lacutequoteright: [
        -140,
        -140,
        -160,
        -160,
        -110,
        -55,
        -37,
        -92
    ],
    Lacutey: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lacuteyacute: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lacuteydieresis: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    LcommaaccentT: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LcommaaccentTcaron: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LcommaaccentTcommaaccent: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LcommaaccentV: [
        -110,
        -110,
        -110,
        -110,
        -92,
        -37,
        -55,
        -100
    ],
    LcommaaccentW: [
        -80,
        -80,
        -70,
        -70,
        -92,
        -37,
        -55,
        -74
    ],
    LcommaaccentY: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LcommaaccentYacute: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LcommaaccentYdieresis: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    Lcommaaccentquotedblright: [
        -140,
        -140,
        -140,
        -140,
        -20
    ],
    Lcommaaccentquoteright: [
        -140,
        -140,
        -160,
        -160,
        -110,
        -55,
        -37,
        -92
    ],
    Lcommaaccenty: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lcommaaccentyacute: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lcommaaccentydieresis: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    LslashT: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LslashTcaron: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LslashTcommaaccent: [
        -90,
        -90,
        -110,
        -110,
        -92,
        -18,
        -20,
        -92
    ],
    LslashV: [
        -110,
        -110,
        -110,
        -110,
        -92,
        -37,
        -55,
        -100
    ],
    LslashW: [
        -80,
        -80,
        -70,
        -70,
        -92,
        -37,
        -55,
        -74
    ],
    LslashY: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LslashYacute: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    LslashYdieresis: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -37,
        -20,
        -100
    ],
    Lslashquotedblright: [
        -140,
        -140,
        -140,
        -140,
        -20
    ],
    Lslashquoteright: [
        -140,
        -140,
        -160,
        -160,
        -110,
        -55,
        -37,
        -92
    ],
    Lslashy: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lslashyacute: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    Lslashydieresis: [
        -30,
        -30,
        -30,
        -30,
        -55,
        -37,
        -30,
        -55
    ],
    OA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Ocomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Operiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OacuteA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OacuteT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OacuteTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OacuteTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OacuteV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OacuteW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OacuteX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OacuteY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OacuteYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OacuteYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Oacutecomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Oacuteperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OcircumflexT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OcircumflexW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OcircumflexX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OcircumflexY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OcircumflexYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OcircumflexYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Ocircumflexcomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Ocircumflexperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OdieresisT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OdieresisW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OdieresisX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OdieresisY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OdieresisYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OdieresisYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Odieresiscomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Odieresisperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OgraveA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OgraveT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OgraveTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OgraveTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OgraveV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OgraveW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OgraveX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OgraveY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OgraveYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OgraveYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Ogravecomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Ograveperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OhungarumlautT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OhungarumlautW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OhungarumlautX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OhungarumlautY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OhungarumlautYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OhungarumlautYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Ohungarumlautcomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Ohungarumlautperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OmacronA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OmacronT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OmacronTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OmacronTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OmacronV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OmacronW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OmacronX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OmacronY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OmacronYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OmacronYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Omacroncomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Omacronperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OslashA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OslashT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OslashTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OslashTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OslashV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OslashW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OslashX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OslashY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OslashYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OslashYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Oslashcomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Oslashperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    OtildeA: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAacute: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAbreve: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAcircumflex: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAdieresis: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAgrave: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAmacron: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAogonek: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAring: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeAtilde: [
        -50,
        -50,
        -20,
        -20,
        -40,
        -40,
        -55,
        -35
    ],
    OtildeT: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OtildeTcaron: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OtildeTcommaaccent: [
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    OtildeV: [
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50,
        -50
    ],
    OtildeW: [
        -50,
        -50,
        -30,
        -30,
        -50,
        -50,
        -50,
        -35
    ],
    OtildeX: [
        -50,
        -50,
        -60,
        -60,
        -40,
        -40,
        -40,
        -40
    ],
    OtildeY: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OtildeYacute: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    OtildeYdieresis: [
        -70,
        -70,
        -70,
        -70,
        -50,
        -50,
        -50,
        -50
    ],
    Otildecomma: [
        -40,
        -40,
        -40,
        -40
    ],
    Otildeperiod: [
        -40,
        -40,
        -40,
        -40
    ],
    PA: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAacute: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAbreve: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAcircumflex: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAdieresis: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAgrave: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAmacron: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAogonek: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAring: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    PAtilde: [
        -100,
        -100,
        -120,
        -120,
        -74,
        -85,
        -90,
        -92
    ],
    Pa: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Paacute: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pabreve: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pacircumflex: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Padieresis: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pagrave: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pamacron: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Paogonek: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Paring: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Patilde: [
        -30,
        -30,
        -40,
        -40,
        -10,
        -40,
        -80,
        -15
    ],
    Pcomma: [
        -120,
        -120,
        -180,
        -180,
        -92,
        -129,
        -135,
        -111
    ],
    Pe: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Peacute: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pecaron: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pecircumflex: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pedieresis: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pedotaccent: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pegrave: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Pemacron: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Peogonek: [
        -30,
        -30,
        -50,
        -50,
        -20,
        -50,
        -80
    ],
    Po: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Poacute: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pocircumflex: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Podieresis: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pograve: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pohungarumlaut: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pomacron: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Poslash: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Potilde: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -55,
        -80
    ],
    Pperiod: [
        -120,
        -120,
        -180,
        -180,
        -110,
        -129,
        -135,
        -111
    ],
    QU: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUacute: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUcircumflex: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUdieresis: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUgrave: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUhungarumlaut: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUmacron: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUogonek: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    QUring: [
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10,
        -10
    ],
    Qcomma: [
        20,
        20
    ],
    Qperiod: [
        20,
        20,
        0,
        0,
        -20
    ],
    RO: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROslash: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    ROtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RT: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RTcaron: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RTcommaaccent: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RU: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUacute: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUcircumflex: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUdieresis: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUgrave: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUhungarumlaut: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUmacron: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUogonek: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RUring: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RV: [
        -50,
        -50,
        -50,
        -50,
        -55,
        -18,
        -18,
        -80
    ],
    RW: [
        -40,
        -40,
        -30,
        -30,
        -35,
        -18,
        -18,
        -55
    ],
    RY: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RYacute: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RYdieresis: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RacuteO: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOslash: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteOtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteT: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RacuteTcaron: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RacuteTcommaaccent: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RacuteU: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUacute: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUcircumflex: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUdieresis: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUgrave: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUhungarumlaut: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUmacron: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUogonek: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteUring: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RacuteV: [
        -50,
        -50,
        -50,
        -50,
        -55,
        -18,
        -18,
        -80
    ],
    RacuteW: [
        -40,
        -40,
        -30,
        -30,
        -35,
        -18,
        -18,
        -55
    ],
    RacuteY: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RacuteYacute: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RacuteYdieresis: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcaronO: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOslash: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronOtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronT: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcaronTcaron: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcaronTcommaaccent: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcaronU: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUacute: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUcircumflex: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUdieresis: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUgrave: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUhungarumlaut: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUmacron: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUogonek: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronUring: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcaronV: [
        -50,
        -50,
        -50,
        -50,
        -55,
        -18,
        -18,
        -80
    ],
    RcaronW: [
        -40,
        -40,
        -30,
        -30,
        -35,
        -18,
        -18,
        -55
    ],
    RcaronY: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcaronYacute: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcaronYdieresis: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcommaaccentO: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOacute: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOdieresis: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOgrave: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOmacron: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOslash: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentOtilde: [
        -20,
        -20,
        -20,
        -20,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentT: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcommaaccentTcaron: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcommaaccentTcommaaccent: [
        -20,
        -20,
        -30,
        -30,
        -40,
        -30,
        0,
        -60
    ],
    RcommaaccentU: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUacute: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUcircumflex: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUdieresis: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUgrave: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUhungarumlaut: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUmacron: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUogonek: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentUring: [
        -20,
        -20,
        -40,
        -40,
        -30,
        -40,
        -40,
        -40
    ],
    RcommaaccentV: [
        -50,
        -50,
        -50,
        -50,
        -55,
        -18,
        -18,
        -80
    ],
    RcommaaccentW: [
        -40,
        -40,
        -30,
        -30,
        -35,
        -18,
        -18,
        -55
    ],
    RcommaaccentY: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcommaaccentYacute: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    RcommaaccentYdieresis: [
        -50,
        -50,
        -50,
        -50,
        -35,
        -18,
        -18,
        -65
    ],
    TA: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAacute: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAbreve: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAcircumflex: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAdieresis: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAgrave: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAmacron: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAogonek: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAring: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TAtilde: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TO: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOacute: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOdieresis: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOgrave: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOhungarumlaut: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOmacron: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOslash: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TOtilde: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    Ta: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Taacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tabreve: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -80
    ],
    Tacircumflex: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -80
    ],
    Tadieresis: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tagrave: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tamacron: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Taogonek: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Taring: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tatilde: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -55,
        -50
    ],
    Tcomma: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -92,
        -74,
        -74
    ],
    Te: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Teacute: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tecaron: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tecircumflex: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -52,
        -70
    ],
    Tedieresis: [
        -60,
        -60,
        -120,
        -120,
        -52,
        -52,
        -52,
        -30
    ],
    Tedotaccent: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tegrave: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -70
    ],
    Temacron: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -30
    ],
    Teogonek: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Thyphen: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -92,
        -74,
        -92
    ],
    To: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Toacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tocircumflex: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Todieresis: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tograve: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tohungarumlaut: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tomacron: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Toslash: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Totilde: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tperiod: [
        -80,
        -80,
        -120,
        -120,
        -90,
        -92,
        -74,
        -74
    ],
    Tr: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tracute: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Trcommaaccent: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tsemicolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -65,
        -55
    ],
    Tu: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tuacute: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tucircumflex: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tudieresis: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tugrave: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tuhungarumlaut: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tumacron: [
        -90,
        -90,
        -60,
        -60,
        -92,
        -37,
        -55,
        -45
    ],
    Tuogonek: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Turing: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tw: [
        -60,
        -60,
        -120,
        -120,
        -74,
        -37,
        -74,
        -80
    ],
    Ty: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tyacute: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tydieresis: [
        -60,
        -60,
        -60,
        -60,
        -34,
        -37,
        -34,
        -80
    ],
    TcaronA: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAacute: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAbreve: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAcircumflex: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAdieresis: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAgrave: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAmacron: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAogonek: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAring: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronAtilde: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcaronO: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOacute: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOdieresis: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOgrave: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOhungarumlaut: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOmacron: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOslash: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcaronOtilde: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    Tcarona: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcaronaacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcaronabreve: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -80
    ],
    Tcaronacircumflex: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -80
    ],
    Tcaronadieresis: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tcaronagrave: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tcaronamacron: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcaronaogonek: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcaronaring: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcaronatilde: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcaroncolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -55,
        -50
    ],
    Tcaroncomma: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -92,
        -74,
        -74
    ],
    Tcarone: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaroneacute: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaronecaron: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaronecircumflex: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -52,
        -30
    ],
    Tcaronedieresis: [
        -60,
        -60,
        -120,
        -120,
        -52,
        -52,
        -52,
        -30
    ],
    Tcaronedotaccent: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaronegrave: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -70
    ],
    Tcaronemacron: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -30
    ],
    Tcaroneogonek: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcaronhyphen: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -92,
        -74,
        -92
    ],
    Tcarono: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronoacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronocircumflex: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronodieresis: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronograve: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronohungarumlaut: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronomacron: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronoslash: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronotilde: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tcaronperiod: [
        -80,
        -80,
        -120,
        -120,
        -90,
        -92,
        -74,
        -74
    ],
    Tcaronr: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcaronracute: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcaronrcommaaccent: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcaronsemicolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -65,
        -55
    ],
    Tcaronu: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronuacute: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronucircumflex: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronudieresis: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronugrave: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronuhungarumlaut: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronumacron: [
        -90,
        -90,
        -60,
        -60,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronuogonek: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronuring: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcaronw: [
        -60,
        -60,
        -120,
        -120,
        -74,
        -37,
        -74,
        -80
    ],
    Tcarony: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tcaronyacute: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tcaronydieresis: [
        -60,
        -60,
        -60,
        -60,
        -34,
        -37,
        -34,
        -80
    ],
    TcommaaccentA: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAacute: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAbreve: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAcircumflex: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAdieresis: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAgrave: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAmacron: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAogonek: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAring: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentAtilde: [
        -90,
        -90,
        -120,
        -120,
        -90,
        -55,
        -50,
        -93
    ],
    TcommaaccentO: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOacute: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOcircumflex: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOdieresis: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOgrave: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOhungarumlaut: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOmacron: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOslash: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    TcommaaccentOtilde: [
        -40,
        -40,
        -40,
        -40,
        -18,
        -18,
        -18,
        -18
    ],
    Tcommaaccenta: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcommaaccentaacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcommaaccentabreve: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -80
    ],
    Tcommaaccentacircumflex: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -80
    ],
    Tcommaaccentadieresis: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tcommaaccentagrave: [
        -80,
        -80,
        -120,
        -120,
        -52,
        -92,
        -92,
        -40
    ],
    Tcommaaccentamacron: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcommaaccentaogonek: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcommaaccentaring: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -92,
        -92,
        -80
    ],
    Tcommaaccentatilde: [
        -80,
        -80,
        -60,
        -60,
        -52,
        -92,
        -92,
        -40
    ],
    Tcommaaccentcolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -55,
        -50
    ],
    Tcommaaccentcomma: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -92,
        -74,
        -74
    ],
    Tcommaaccente: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccenteacute: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccentecaron: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccentecircumflex: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -52,
        -30
    ],
    Tcommaaccentedieresis: [
        -60,
        -60,
        -120,
        -120,
        -52,
        -52,
        -52,
        -30
    ],
    Tcommaaccentedotaccent: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccentegrave: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -30
    ],
    Tcommaaccentemacron: [
        -60,
        -60,
        -60,
        -60,
        -52,
        -52,
        -52,
        -70
    ],
    Tcommaaccenteogonek: [
        -60,
        -60,
        -120,
        -120,
        -92,
        -92,
        -92,
        -70
    ],
    Tcommaaccenthyphen: [
        -120,
        -120,
        -140,
        -140,
        -92,
        -92,
        -74,
        -92
    ],
    Tcommaaccento: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentoacute: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentocircumflex: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentodieresis: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentograve: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentohungarumlaut: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentomacron: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentoslash: [
        -80,
        -80,
        -120,
        -120,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentotilde: [
        -80,
        -80,
        -60,
        -60,
        -92,
        -95,
        -92,
        -80
    ],
    Tcommaaccentperiod: [
        -80,
        -80,
        -120,
        -120,
        -90,
        -92,
        -74,
        -74
    ],
    Tcommaaccentr: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcommaaccentracute: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcommaaccentrcommaaccent: [
        -80,
        -80,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcommaaccentsemicolon: [
        -40,
        -40,
        -20,
        -20,
        -74,
        -74,
        -65,
        -55
    ],
    Tcommaaccentu: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentuacute: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentucircumflex: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentudieresis: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentugrave: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentuhungarumlaut: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentumacron: [
        -90,
        -90,
        -60,
        -60,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentuogonek: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccenturing: [
        -90,
        -90,
        -120,
        -120,
        -92,
        -37,
        -55,
        -45
    ],
    Tcommaaccentw: [
        -60,
        -60,
        -120,
        -120,
        -74,
        -37,
        -74,
        -80
    ],
    Tcommaaccenty: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tcommaaccentyacute: [
        -60,
        -60,
        -120,
        -120,
        -34,
        -37,
        -74,
        -80
    ],
    Tcommaaccentydieresis: [
        -60,
        -60,
        -60,
        -60,
        -34,
        -37,
        -34,
        -80
    ],
    UA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Ucomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UacuteA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UacuteAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Uacutecomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uacuteperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UcircumflexA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UcircumflexAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Ucircumflexcomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Ucircumflexperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UdieresisA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UdieresisAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Udieresiscomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Udieresisperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UgraveA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UgraveAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Ugravecomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Ugraveperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UhungarumlautA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UhungarumlautAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Uhungarumlautcomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uhungarumlautperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UmacronA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UmacronAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Umacroncomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Umacronperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UogonekA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UogonekAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Uogonekcomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uogonekperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    UringA: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAacute: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAbreve: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAdieresis: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAgrave: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAmacron: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAogonek: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAring: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    UringAtilde: [
        -50,
        -50,
        -40,
        -40,
        -60,
        -45,
        -40,
        -40
    ],
    Uringcomma: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    Uringperiod: [
        -30,
        -30,
        -40,
        -40,
        -50,
        0,
        -25
    ],
    VA: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAacute: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAbreve: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAcircumflex: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAdieresis: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAgrave: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAmacron: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAogonek: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAring: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VAtilde: [
        -80,
        -80,
        -80,
        -80,
        -135,
        -85,
        -60,
        -135
    ],
    VG: [
        -50,
        -50,
        -40,
        -40,
        -30,
        -10,
        0,
        -15
    ],
    VGbreve: [
        -50,
        -50,
        -40,
        -40,
        -30,
        -10,
        0,
        -15
    ],
    VGcommaaccent: [
        -50,
        -50,
        -40,
        -40,
        -30,
        -10,
        0,
        -15
    ],
    VO: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOacute: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOcircumflex: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOdieresis: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOgrave: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOhungarumlaut: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOmacron: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOslash: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    VOtilde: [
        -50,
        -50,
        -40,
        -40,
        -45,
        -30,
        -30,
        -40
    ],
    Va: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Vaacute: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Vabreve: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Vacircumflex: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vadieresis: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vagrave: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vamacron: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vaogonek: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Varing: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -111
    ],
    Vatilde: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -111,
        -111,
        -71
    ],
    Vcolon: [
        -40,
        -40,
        -40,
        -40,
        -92,
        -74,
        -65,
        -74
    ],
    Vcomma: [
        -120,
        -120,
        -125,
        -125,
        -129,
        -129,
        -129,
        -129
    ],
    Ve: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -111
    ],
    Veacute: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -111
    ],
    Vecaron: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -71
    ],
    Vecircumflex: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -71
    ],
    Vedieresis: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -71,
        -71,
        -71
    ],
    Vedotaccent: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -111
    ],
    Vegrave: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -71,
        -71,
        -71
    ],
    Vemacron: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -71,
        -71,
        -71
    ],
    Veogonek: [
        -50,
        -50,
        -80,
        -80,
        -100,
        -111,
        -111,
        -111
    ],
    Vhyphen: [
        -80,
        -80,
        -80,
        -80,
        -74,
        -70,
        -55,
        -100
    ],
    Vo: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Voacute: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Vocircumflex: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Vodieresis: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -89
    ],
    Vograve: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -89
    ],
    Vohungarumlaut: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Vomacron: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -89
    ],
    Voslash: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -129
    ],
    Votilde: [
        -90,
        -90,
        -80,
        -80,
        -100,
        -111,
        -111,
        -89
    ],
    Vperiod: [
        -120,
        -120,
        -125,
        -125,
        -145,
        -129,
        -129,
        -129
    ],
    Vsemicolon: [
        -40,
        -40,
        -40,
        -40,
        -92,
        -74,
        -74,
        -74
    ],
    Vu: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vuacute: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vucircumflex: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vudieresis: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vugrave: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vuhungarumlaut: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vumacron: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vuogonek: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    Vuring: [
        -60,
        -60,
        -70,
        -70,
        -92,
        -55,
        -74,
        -75
    ],
    WA: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAacute: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAbreve: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAcircumflex: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAdieresis: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAgrave: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAmacron: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAogonek: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAring: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WAtilde: [
        -60,
        -60,
        -50,
        -50,
        -120,
        -74,
        -60,
        -120
    ],
    WO: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOacute: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOcircumflex: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOdieresis: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOgrave: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOmacron: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOslash: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    WOtilde: [
        -20,
        -20,
        -20,
        -20,
        -10,
        -15,
        -25,
        -10
    ],
    Wa: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Waacute: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wabreve: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wacircumflex: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wadieresis: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wagrave: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wamacron: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Waogonek: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Waring: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Watilde: [
        -40,
        -40,
        -40,
        -40,
        -65,
        -85,
        -92,
        -80
    ],
    Wcolon: [
        -10,
        -10,
        0,
        0,
        -55,
        -55,
        -65,
        -37
    ],
    Wcomma: [
        -80,
        -80,
        -80,
        -80,
        -92,
        -74,
        -92,
        -92
    ],
    We: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Weacute: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Wecaron: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Wecircumflex: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Wedieresis: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -50,
        -52,
        -40
    ],
    Wedotaccent: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Wegrave: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -50,
        -52,
        -40
    ],
    Wemacron: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -50,
        -52,
        -40
    ],
    Weogonek: [
        -35,
        -35,
        -30,
        -30,
        -65,
        -90,
        -92,
        -80
    ],
    Whyphen: [
        -40,
        -40,
        -40,
        -40,
        -37,
        -50,
        -37,
        -65
    ],
    Wo: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Woacute: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wocircumflex: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wodieresis: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wograve: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wohungarumlaut: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Womacron: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Woslash: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wotilde: [
        -60,
        -60,
        -30,
        -30,
        -75,
        -80,
        -92,
        -80
    ],
    Wperiod: [
        -80,
        -80,
        -80,
        -80,
        -92,
        -74,
        -92,
        -92
    ],
    Wsemicolon: [
        -10,
        -10,
        0,
        0,
        -55,
        -55,
        -65,
        -37
    ],
    Wu: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wuacute: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wucircumflex: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wudieresis: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wugrave: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wuhungarumlaut: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wumacron: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wuogonek: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wuring: [
        -45,
        -45,
        -30,
        -30,
        -50,
        -55,
        -55,
        -50
    ],
    Wy: [
        -20,
        -20,
        -20,
        -20,
        -60,
        -55,
        -70,
        -73
    ],
    Wyacute: [
        -20,
        -20,
        -20,
        -20,
        -60,
        -55,
        -70,
        -73
    ],
    Wydieresis: [
        -20,
        -20,
        -20,
        -20,
        -60,
        -55,
        -70,
        -73
    ],
    YA: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAacute: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAbreve: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAcircumflex: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAdieresis: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAgrave: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAmacron: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAogonek: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAring: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YAtilde: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YO: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOacute: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOcircumflex: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOdieresis: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOgrave: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOhungarumlaut: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOmacron: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOslash: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YOtilde: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    Ya: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yaacute: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yabreve: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -100
    ],
    Yacircumflex: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yadieresis: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Yagrave: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Yamacron: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -60
    ],
    Yaogonek: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yaring: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yatilde: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Ycolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Ycomma: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -92,
        -92,
        -129
    ],
    Ye: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yeacute: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yecaron: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yecircumflex: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -71,
        -92,
        -100
    ],
    Yedieresis: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Yedotaccent: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yegrave: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Yemacron: [
        -80,
        -80,
        -70,
        -70,
        -71,
        -71,
        -52,
        -60
    ],
    Yeogonek: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yo: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yoacute: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yocircumflex: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yodieresis: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yograve: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yohungarumlaut: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yomacron: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yoslash: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yotilde: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yperiod: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -74,
        -92,
        -129
    ],
    Ysemicolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Yu: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yuacute: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yucircumflex: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yudieresis: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yugrave: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yuhungarumlaut: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yumacron: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yuogonek: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yuring: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    YacuteA: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAacute: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAbreve: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAcircumflex: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAdieresis: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAgrave: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAmacron: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAogonek: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAring: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteAtilde: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YacuteO: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOacute: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOcircumflex: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOdieresis: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOgrave: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOhungarumlaut: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOmacron: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOslash: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YacuteOtilde: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    Yacutea: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteaacute: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteabreve: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteacircumflex: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteadieresis: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Yacuteagrave: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Yacuteamacron: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -60
    ],
    Yacuteaogonek: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacutearing: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Yacuteatilde: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -60
    ],
    Yacutecolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Yacutecomma: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -92,
        -92,
        -129
    ],
    Yacutee: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteeacute: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteecaron: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteecircumflex: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -71,
        -92,
        -100
    ],
    Yacuteedieresis: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Yacuteedotaccent: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteegrave: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Yacuteemacron: [
        -80,
        -80,
        -70,
        -70,
        -71,
        -71,
        -52,
        -60
    ],
    Yacuteeogonek: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Yacuteo: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteoacute: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteocircumflex: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteodieresis: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yacuteograve: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yacuteohungarumlaut: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteomacron: [
        -100,
        -100,
        -70,
        -70,
        -111,
        -111,
        -92,
        -70
    ],
    Yacuteoslash: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Yacuteotilde: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Yacuteperiod: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -74,
        -92,
        -129
    ],
    Yacutesemicolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Yacuteu: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteuacute: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteucircumflex: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteudieresis: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yacuteugrave: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yacuteuhungarumlaut: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteumacron: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Yacuteuogonek: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Yacuteuring: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    YdieresisA: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAacute: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAbreve: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAcircumflex: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAdieresis: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAgrave: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAmacron: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAogonek: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAring: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisAtilde: [
        -110,
        -110,
        -110,
        -110,
        -110,
        -74,
        -50,
        -120
    ],
    YdieresisO: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOacute: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOcircumflex: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOdieresis: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOgrave: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOhungarumlaut: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOmacron: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOslash: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    YdieresisOtilde: [
        -70,
        -70,
        -85,
        -85,
        -35,
        -25,
        -15,
        -30
    ],
    Ydieresisa: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisaacute: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisabreve: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisacircumflex: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisadieresis: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Ydieresisagrave: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -60
    ],
    Ydieresisamacron: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -60
    ],
    Ydieresisaogonek: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisaring: [
        -90,
        -90,
        -140,
        -140,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresisatilde: [
        -90,
        -90,
        -70,
        -70,
        -85,
        -92,
        -92,
        -100
    ],
    Ydieresiscolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Ydieresiscomma: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -92,
        -92,
        -129
    ],
    Ydieresise: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresiseacute: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresisecaron: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresisecircumflex: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -71,
        -92,
        -100
    ],
    Ydieresisedieresis: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Ydieresisedotaccent: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresisegrave: [
        -80,
        -80,
        -140,
        -140,
        -71,
        -71,
        -52,
        -60
    ],
    Ydieresisemacron: [
        -80,
        -80,
        -70,
        -70,
        -71,
        -71,
        -52,
        -60
    ],
    Ydieresiseogonek: [
        -80,
        -80,
        -140,
        -140,
        -111,
        -111,
        -92,
        -100
    ],
    Ydieresiso: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisoacute: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisocircumflex: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisodieresis: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Ydieresisograve: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Ydieresisohungarumlaut: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisomacron: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Ydieresisoslash: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -110
    ],
    Ydieresisotilde: [
        -100,
        -100,
        -140,
        -140,
        -111,
        -111,
        -92,
        -70
    ],
    Ydieresisperiod: [
        -100,
        -100,
        -140,
        -140,
        -92,
        -74,
        -92,
        -129
    ],
    Ydieresissemicolon: [
        -50,
        -50,
        -60,
        -60,
        -92,
        -92,
        -65,
        -92
    ],
    Ydieresisu: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisuacute: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisucircumflex: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisudieresis: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Ydieresisugrave: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Ydieresisuhungarumlaut: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisumacron: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -71
    ],
    Ydieresisuogonek: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    Ydieresisuring: [
        -100,
        -100,
        -110,
        -110,
        -92,
        -92,
        -92,
        -111
    ],
    ag: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    av: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    aw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    ay: [
        -20,
        -20,
        -30,
        -30
    ],
    ayacute: [
        -20,
        -20,
        -30,
        -30
    ],
    aydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    aacuteg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aacutegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aacutegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aacutev: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    aacutew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    aacutey: [
        -20,
        -20,
        -30,
        -30
    ],
    aacuteyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    aacuteydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    abreveg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    abrevegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    abrevegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    abrevev: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    abrevew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    abrevey: [
        -20,
        -20,
        -30,
        -30
    ],
    abreveyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    abreveydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    acircumflexg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    acircumflexgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    acircumflexgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    acircumflexv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    acircumflexw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    acircumflexy: [
        -20,
        -20,
        -30,
        -30
    ],
    acircumflexyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    acircumflexydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    adieresisg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    adieresisgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    adieresisgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    adieresisv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    adieresisw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    adieresisy: [
        -20,
        -20,
        -30,
        -30
    ],
    adieresisyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    adieresisydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    agraveg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agravegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agravegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    agravev: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    agravew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    agravey: [
        -20,
        -20,
        -30,
        -30
    ],
    agraveyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    agraveydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    amacrong: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    amacrongbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    amacrongcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    amacronv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    amacronw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    amacrony: [
        -20,
        -20,
        -30,
        -30
    ],
    amacronyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    amacronydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    aogonekg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aogonekgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aogonekgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aogonekv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    aogonekw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    aogoneky: [
        -20,
        -20,
        -30,
        -30
    ],
    aogonekyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    aogonekydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    aringg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aringgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aringgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    aringv: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    aringw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    aringy: [
        -20,
        -20,
        -30,
        -30
    ],
    aringyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    aringydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    atildeg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    atildegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    atildegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    atildev: [
        -15,
        -15,
        -20,
        -20,
        -25,
        0,
        0,
        -20
    ],
    atildew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        0,
        -15
    ],
    atildey: [
        -20,
        -20,
        -30,
        -30
    ],
    atildeyacute: [
        -20,
        -20,
        -30,
        -30
    ],
    atildeydieresis: [
        -20,
        -20,
        -30,
        -30
    ],
    bl: [
        -10,
        -10,
        -20,
        -20
    ],
    blacute: [
        -10,
        -10,
        -20,
        -20
    ],
    blcommaaccent: [
        -10,
        -10,
        -20,
        -20
    ],
    blslash: [
        -10,
        -10,
        -20,
        -20
    ],
    bu: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    buacute: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    bucircumflex: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    budieresis: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    bugrave: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    buhungarumlaut: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    bumacron: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    buogonek: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    buring: [
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20,
        -20
    ],
    bv: [
        -20,
        -20,
        -20,
        -20,
        -15,
        0,
        0,
        -15
    ],
    by: [
        -20,
        -20,
        -20,
        -20
    ],
    byacute: [
        -20,
        -20,
        -20,
        -20
    ],
    bydieresis: [
        -20,
        -20,
        -20,
        -20
    ],
    ch: [
        -10,
        -10,
        0,
        0,
        0,
        -10,
        -15
    ],
    ck: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ckcommaaccent: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    cl: [
        -20,
        -20
    ],
    clacute: [
        -20,
        -20
    ],
    clcommaaccent: [
        -20,
        -20
    ],
    clslash: [
        -20,
        -20
    ],
    cy: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cyacute: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cydieresis: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cacuteh: [
        -10,
        -10,
        0,
        0,
        0,
        -10,
        -15
    ],
    cacutek: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    cacutekcommaaccent: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    cacutel: [
        -20,
        -20
    ],
    cacutelacute: [
        -20,
        -20
    ],
    cacutelcommaaccent: [
        -20,
        -20
    ],
    cacutelslash: [
        -20,
        -20
    ],
    cacutey: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cacuteyacute: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    cacuteydieresis: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccaronh: [
        -10,
        -10,
        0,
        0,
        0,
        -10,
        -15
    ],
    ccaronk: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ccaronkcommaaccent: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ccaronl: [
        -20,
        -20
    ],
    ccaronlacute: [
        -20,
        -20
    ],
    ccaronlcommaaccent: [
        -20,
        -20
    ],
    ccaronlslash: [
        -20,
        -20
    ],
    ccarony: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccaronyacute: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccaronydieresis: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccedillah: [
        -10,
        -10,
        0,
        0,
        0,
        -10,
        -15
    ],
    ccedillak: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ccedillakcommaaccent: [
        -20,
        -20,
        -20,
        -20,
        0,
        -10,
        -20
    ],
    ccedillal: [
        -20,
        -20
    ],
    ccedillalacute: [
        -20,
        -20
    ],
    ccedillalcommaaccent: [
        -20,
        -20
    ],
    ccedillalslash: [
        -20,
        -20
    ],
    ccedillay: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccedillayacute: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    ccedillaydieresis: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        0,
        -15
    ],
    colonspace: [
        -40,
        -40,
        -50,
        -50
    ],
    commaquotedblright: [
        -120,
        -120,
        -100,
        -100,
        -45,
        -95,
        -140,
        -70
    ],
    commaquoteright: [
        -120,
        -120,
        -100,
        -100,
        -55,
        -95,
        -140,
        -70
    ],
    commaspace: [
        -40,
        -40
    ],
    dd: [
        -10,
        -10
    ],
    ddcroat: [
        -10,
        -10
    ],
    dv: [
        -15,
        -15
    ],
    dw: [
        -15,
        -15,
        0,
        0,
        -15
    ],
    dy: [
        -15,
        -15
    ],
    dyacute: [
        -15,
        -15
    ],
    dydieresis: [
        -15,
        -15
    ],
    dcroatd: [
        -10,
        -10
    ],
    dcroatdcroat: [
        -10,
        -10
    ],
    dcroatv: [
        -15,
        -15
    ],
    dcroatw: [
        -15,
        -15,
        0,
        0,
        -15
    ],
    dcroaty: [
        -15,
        -15
    ],
    dcroatyacute: [
        -15,
        -15
    ],
    dcroatydieresis: [
        -15,
        -15
    ],
    ecomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    eperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    ev: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    ew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    ex: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    ey: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eacutecomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    eacuteperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    eacutev: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    eacutew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    eacutex: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    eacutey: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eacuteyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eacuteydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecaroncomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    ecaronperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    ecaronv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    ecaronw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    ecaronx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    ecarony: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecaronyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecaronydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecircumflexcomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    ecircumflexperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    ecircumflexv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    ecircumflexw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    ecircumflexx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    ecircumflexy: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecircumflexyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    ecircumflexydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edieresiscomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    edieresisperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    edieresisv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    edieresisw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    edieresisx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    edieresisy: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edieresisyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edieresisydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edotaccentcomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    edotaccentperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    edotaccentv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    edotaccentw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    edotaccentx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    edotaccenty: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edotaccentyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    edotaccentydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    egravecomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    egraveperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    egravev: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    egravew: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    egravex: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    egravey: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    egraveyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    egraveydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    emacroncomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    emacronperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    emacronv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    emacronw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    emacronx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    emacrony: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    emacronyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    emacronydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eogonekcomma: [
        10,
        10,
        -15,
        -15,
        0,
        0,
        -10
    ],
    eogonekperiod: [
        20,
        20,
        -15,
        -15,
        0,
        0,
        -15
    ],
    eogonekv: [
        -15,
        -15,
        -30,
        -30,
        -15,
        0,
        -15,
        -25
    ],
    eogonekw: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -15,
        -25
    ],
    eogonekx: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        -20,
        -15
    ],
    eogoneky: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eogonekyacute: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    eogonekydieresis: [
        -15,
        -15,
        -20,
        -20,
        0,
        0,
        -30,
        -15
    ],
    fcomma: [
        -10,
        -10,
        -30,
        -30,
        -15,
        -10,
        -10
    ],
    fe: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10
    ],
    feacute: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10
    ],
    fecaron: [
        -10,
        -10,
        -30,
        -30
    ],
    fecircumflex: [
        -10,
        -10,
        -30,
        -30
    ],
    fedieresis: [
        -10,
        -10,
        -30,
        -30
    ],
    fedotaccent: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10
    ],
    fegrave: [
        -10,
        -10,
        -30,
        -30
    ],
    femacron: [
        -10,
        -10,
        -30,
        -30
    ],
    feogonek: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10
    ],
    fo: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    foacute: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    focircumflex: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fodieresis: [
        -20,
        -20,
        -30,
        -30,
        -25
    ],
    fograve: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fohungarumlaut: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fomacron: [
        -20,
        -20,
        -30,
        -30,
        -25
    ],
    foslash: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fotilde: [
        -20,
        -20,
        -30,
        -30,
        -25,
        -10
    ],
    fperiod: [
        -10,
        -10,
        -30,
        -30,
        -15,
        -10,
        -15
    ],
    fquotedblright: [
        30,
        30,
        60,
        60,
        50
    ],
    fquoteright: [
        30,
        30,
        50,
        50,
        55,
        55,
        92,
        55
    ],
    ge: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    geacute: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gecaron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gecircumflex: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gedieresis: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gedotaccent: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gegrave: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gemacron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    geogonek: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    ggbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    ggcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbrevee: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveeacute: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveecaron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveecircumflex: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveedieresis: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveedotaccent: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveegrave: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveemacron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveeogonek: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbreveg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbrevegbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gbrevegcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccente: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccenteacute: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentecaron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentecircumflex: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentedieresis: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentedotaccent: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentegrave: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentemacron: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccenteogonek: [
        10,
        10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentg: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentgbreve: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentgcommaaccent: [
        -10,
        -10,
        0,
        0,
        0,
        0,
        -10
    ],
    hy: [
        -20,
        -20,
        -30,
        -30,
        -15,
        0,
        0,
        -5
    ],
    hyacute: [
        -20,
        -20,
        -30,
        -30,
        -15,
        0,
        0,
        -5
    ],
    hydieresis: [
        -20,
        -20,
        -30,
        -30,
        -15,
        0,
        0,
        -5
    ],
    ko: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    koacute: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kocircumflex: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kodieresis: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kograve: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kohungarumlaut: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    komacron: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    koslash: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kotilde: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccento: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentoacute: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentocircumflex: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentodieresis: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentograve: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentohungarumlaut: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentomacron: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentoslash: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    kcommaaccentotilde: [
        -15,
        -15,
        -20,
        -20,
        -15,
        -10,
        -10,
        -10
    ],
    lw: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ly: [
        -15,
        -15
    ],
    lyacute: [
        -15,
        -15
    ],
    lydieresis: [
        -15,
        -15
    ],
    lacutew: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    lacutey: [
        -15,
        -15
    ],
    lacuteyacute: [
        -15,
        -15
    ],
    lacuteydieresis: [
        -15,
        -15
    ],
    lcommaaccentw: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    lcommaaccenty: [
        -15,
        -15
    ],
    lcommaaccentyacute: [
        -15,
        -15
    ],
    lcommaaccentydieresis: [
        -15,
        -15
    ],
    lslashw: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    lslashy: [
        -15,
        -15
    ],
    lslashyacute: [
        -15,
        -15
    ],
    lslashydieresis: [
        -15,
        -15
    ],
    mu: [
        -20,
        -20,
        -10,
        -10
    ],
    muacute: [
        -20,
        -20,
        -10,
        -10
    ],
    mucircumflex: [
        -20,
        -20,
        -10,
        -10
    ],
    mudieresis: [
        -20,
        -20,
        -10,
        -10
    ],
    mugrave: [
        -20,
        -20,
        -10,
        -10
    ],
    muhungarumlaut: [
        -20,
        -20,
        -10,
        -10
    ],
    mumacron: [
        -20,
        -20,
        -10,
        -10
    ],
    muogonek: [
        -20,
        -20,
        -10,
        -10
    ],
    muring: [
        -20,
        -20,
        -10,
        -10
    ],
    my: [
        -30,
        -30,
        -15,
        -15
    ],
    myacute: [
        -30,
        -30,
        -15,
        -15
    ],
    mydieresis: [
        -30,
        -30,
        -15,
        -15
    ],
    nu: [
        -10,
        -10,
        -10,
        -10
    ],
    nuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    nucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    nudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    nugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    nuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    numacron: [
        -10,
        -10,
        -10,
        -10
    ],
    nuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    nuring: [
        -10,
        -10,
        -10,
        -10
    ],
    nv: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    ny: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nacuteu: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteumacron: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    nacuteuring: [
        -10,
        -10,
        -10,
        -10
    ],
    nacutev: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    nacutey: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nacuteyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    nacuteydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncaronu: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronumacron: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronuring: [
        -10,
        -10,
        -10,
        -10
    ],
    ncaronv: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    ncarony: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncaronyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncaronydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncommaaccentu: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentumacron: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccenturing: [
        -10,
        -10,
        -10,
        -10
    ],
    ncommaaccentv: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    ncommaaccenty: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncommaaccentyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ncommaaccentydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ntildeu: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeuacute: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeucircumflex: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeudieresis: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeugrave: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeuhungarumlaut: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeumacron: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeuogonek: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildeuring: [
        -10,
        -10,
        -10,
        -10
    ],
    ntildev: [
        -40,
        -40,
        -20,
        -20,
        -40,
        -40,
        -40,
        -40
    ],
    ntildey: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ntildeyacute: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ntildeydieresis: [
        -20,
        -20,
        -15,
        -15,
        0,
        0,
        0,
        -15
    ],
    ov: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    ow: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    ox: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    oy: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oacutev: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    oacutew: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    oacutex: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    oacutey: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oacuteyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oacuteydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ocircumflexv: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    ocircumflexw: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    ocircumflexx: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    ocircumflexy: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ocircumflexyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ocircumflexydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    odieresisv: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    odieresisw: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    odieresisx: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    odieresisy: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    odieresisyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    odieresisydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ogravev: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    ogravew: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    ogravex: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    ogravey: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ograveyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ograveydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ohungarumlautv: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    ohungarumlautw: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    ohungarumlautx: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    ohungarumlauty: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ohungarumlautyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    ohungarumlautydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    omacronv: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    omacronw: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    omacronx: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    omacrony: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    omacronyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    omacronydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    oslashv: [
        -20,
        -20,
        -70,
        -70,
        -10,
        -15,
        -10,
        -15
    ],
    oslashw: [
        -15,
        -15,
        -70,
        -70,
        -10,
        -25,
        0,
        -25
    ],
    oslashx: [
        -30,
        -30,
        -85,
        -85,
        0,
        -10
    ],
    oslashy: [
        -20,
        -20,
        -70,
        -70,
        0,
        -10,
        0,
        -10
    ],
    oslashyacute: [
        -20,
        -20,
        -70,
        -70,
        0,
        -10,
        0,
        -10
    ],
    oslashydieresis: [
        -20,
        -20,
        -70,
        -70,
        0,
        -10,
        0,
        -10
    ],
    otildev: [
        -20,
        -20,
        -15,
        -15,
        -10,
        -15,
        -10,
        -15
    ],
    otildew: [
        -15,
        -15,
        -15,
        -15,
        -10,
        -25,
        0,
        -25
    ],
    otildex: [
        -30,
        -30,
        -30,
        -30,
        0,
        -10
    ],
    otildey: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    otildeyacute: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    otildeydieresis: [
        -20,
        -20,
        -30,
        -30,
        0,
        -10,
        0,
        -10
    ],
    py: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    pyacute: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    pydieresis: [
        -15,
        -15,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    periodquotedblright: [
        -120,
        -120,
        -100,
        -100,
        -55,
        -95,
        -140,
        -70
    ],
    periodquoteright: [
        -120,
        -120,
        -100,
        -100,
        -55,
        -95,
        -140,
        -70
    ],
    periodspace: [
        -40,
        -40,
        -60,
        -60
    ],
    quotedblrightspace: [
        -80,
        -80,
        -40,
        -40
    ],
    quoteleftquoteleft: [
        -46,
        -46,
        -57,
        -57,
        -63,
        -74,
        -111,
        -74
    ],
    quoterightd: [
        -80,
        -80,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightdcroat: [
        -80,
        -80,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightl: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    quoterightlacute: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    quoterightlcommaaccent: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    quoterightlslash: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    quoterightquoteright: [
        -46,
        -46,
        -57,
        -57,
        -63,
        -74,
        -111,
        -74
    ],
    quoterightr: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightracute: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightrcaron: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterightrcommaaccent: [
        -40,
        -40,
        -50,
        -50,
        -20,
        -15,
        -25,
        -50
    ],
    quoterights: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightsacute: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightscaron: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightscedilla: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightscommaaccent: [
        -60,
        -60,
        -50,
        -50,
        -37,
        -74,
        -40,
        -55
    ],
    quoterightspace: [
        -80,
        -80,
        -70,
        -70,
        -74,
        -74,
        -111,
        -74
    ],
    quoterightv: [
        -20,
        -20,
        0,
        0,
        -20,
        -15,
        -10,
        -50
    ],
    rc: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rccaron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rccedilla: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcomma: [
        -60,
        -60,
        -50,
        -50,
        -92,
        -65,
        -111,
        -40
    ],
    rd: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rdcroat: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rg: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rgbreve: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rgcommaaccent: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rhyphen: [
        -20,
        -20,
        0,
        0,
        -37,
        0,
        -20,
        -20
    ],
    ro: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    roacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rocircumflex: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rodieresis: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rograve: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rohungarumlaut: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    romacron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    roslash: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rotilde: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rperiod: [
        -60,
        -60,
        -50,
        -50,
        -100,
        -65,
        -111,
        -55
    ],
    rq: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rs: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rsacute: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rscaron: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rscedilla: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rscommaaccent: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rt: [
        20,
        20,
        40,
        40
    ],
    rtcommaaccent: [
        20,
        20,
        40,
        40
    ],
    rv: [
        10,
        10,
        30,
        30,
        -10
    ],
    ry: [
        10,
        10,
        30,
        30
    ],
    ryacute: [
        10,
        10,
        30,
        30
    ],
    rydieresis: [
        10,
        10,
        30,
        30
    ],
    racutec: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racutecacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteccaron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteccedilla: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racutecomma: [
        -60,
        -60,
        -50,
        -50,
        -92,
        -65,
        -111,
        -40
    ],
    racuted: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    racutedcroat: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    racuteg: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    racutegbreve: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    racutegcommaaccent: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    racutehyphen: [
        -20,
        -20,
        0,
        0,
        -37,
        0,
        -20,
        -20
    ],
    racuteo: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteoacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteocircumflex: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteodieresis: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteograve: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteohungarumlaut: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteomacron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteoslash: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteotilde: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    racuteperiod: [
        -60,
        -60,
        -50,
        -50,
        -100,
        -65,
        -111,
        -55
    ],
    racuteq: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    racutes: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutesacute: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutescaron: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutescedilla: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutescommaaccent: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    racutet: [
        20,
        20,
        40,
        40
    ],
    racutetcommaaccent: [
        20,
        20,
        40,
        40
    ],
    racutev: [
        10,
        10,
        30,
        30,
        -10
    ],
    racutey: [
        10,
        10,
        30,
        30
    ],
    racuteyacute: [
        10,
        10,
        30,
        30
    ],
    racuteydieresis: [
        10,
        10,
        30,
        30
    ],
    rcaronc: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaroncacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronccaron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronccedilla: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaroncomma: [
        -60,
        -60,
        -50,
        -50,
        -92,
        -65,
        -111,
        -40
    ],
    rcarond: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rcarondcroat: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rcarong: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcarongbreve: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcarongcommaaccent: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcaronhyphen: [
        -20,
        -20,
        0,
        0,
        -37,
        0,
        -20,
        -20
    ],
    rcarono: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronoacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronocircumflex: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronodieresis: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronograve: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronohungarumlaut: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronomacron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronoslash: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronotilde: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcaronperiod: [
        -60,
        -60,
        -50,
        -50,
        -100,
        -65,
        -111,
        -55
    ],
    rcaronq: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcarons: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaronsacute: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaronscaron: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaronscedilla: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaronscommaaccent: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcaront: [
        20,
        20,
        40,
        40
    ],
    rcarontcommaaccent: [
        20,
        20,
        40,
        40
    ],
    rcaronv: [
        10,
        10,
        30,
        30,
        -10
    ],
    rcarony: [
        10,
        10,
        30,
        30
    ],
    rcaronyacute: [
        10,
        10,
        30,
        30
    ],
    rcaronydieresis: [
        10,
        10,
        30,
        30
    ],
    rcommaaccentc: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentcacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentccaron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentccedilla: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentcomma: [
        -60,
        -60,
        -50,
        -50,
        -92,
        -65,
        -111,
        -40
    ],
    rcommaaccentd: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rcommaaccentdcroat: [
        -20,
        -20,
        0,
        0,
        0,
        0,
        -37
    ],
    rcommaaccentg: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcommaaccentgbreve: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcommaaccentgcommaaccent: [
        -15,
        -15,
        0,
        0,
        -10,
        0,
        -37,
        -18
    ],
    rcommaaccenthyphen: [
        -20,
        -20,
        0,
        0,
        -37,
        0,
        -20,
        -20
    ],
    rcommaaccento: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentoacute: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentocircumflex: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentodieresis: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentograve: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentohungarumlaut: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentomacron: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentoslash: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentotilde: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -45
    ],
    rcommaaccentperiod: [
        -60,
        -60,
        -50,
        -50,
        -100,
        -65,
        -111,
        -55
    ],
    rcommaaccentq: [
        -20,
        -20,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccents: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentsacute: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentscaron: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentscedilla: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentscommaaccent: [
        -15,
        -15,
        0,
        0,
        0,
        0,
        -10
    ],
    rcommaaccentt: [
        20,
        20,
        40,
        40
    ],
    rcommaaccenttcommaaccent: [
        20,
        20,
        40,
        40
    ],
    rcommaaccentv: [
        10,
        10,
        30,
        30,
        -10
    ],
    rcommaaccenty: [
        10,
        10,
        30,
        30
    ],
    rcommaaccentyacute: [
        10,
        10,
        30,
        30
    ],
    rcommaaccentydieresis: [
        10,
        10,
        30,
        30
    ],
    sw: [
        -15,
        -15,
        -30,
        -30
    ],
    sacutew: [
        -15,
        -15,
        -30,
        -30
    ],
    scaronw: [
        -15,
        -15,
        -30,
        -30
    ],
    scedillaw: [
        -15,
        -15,
        -30,
        -30
    ],
    scommaaccentw: [
        -15,
        -15,
        -30,
        -30
    ],
    semicolonspace: [
        -40,
        -40,
        -50,
        -50
    ],
    spaceT: [
        -100,
        -100,
        -50,
        -50,
        -30,
        0,
        -18,
        -18
    ],
    spaceTcaron: [
        -100,
        -100,
        -50,
        -50,
        -30,
        0,
        -18,
        -18
    ],
    spaceTcommaaccent: [
        -100,
        -100,
        -50,
        -50,
        -30,
        0,
        -18,
        -18
    ],
    spaceV: [
        -80,
        -80,
        -50,
        -50,
        -45,
        -70,
        -35,
        -50
    ],
    spaceW: [
        -80,
        -80,
        -40,
        -40,
        -30,
        -70,
        -40,
        -30
    ],
    spaceY: [
        -120,
        -120,
        -90,
        -90,
        -55,
        -70,
        -75,
        -90
    ],
    spaceYacute: [
        -120,
        -120,
        -90,
        -90,
        -55,
        -70,
        -75,
        -90
    ],
    spaceYdieresis: [
        -120,
        -120,
        -90,
        -90,
        -55,
        -70,
        -75,
        -90
    ],
    spacequotedblleft: [
        -80,
        -80,
        -30,
        -30
    ],
    spacequoteleft: [
        -60,
        -60,
        -60,
        -60
    ],
    va: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vaacute: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vabreve: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vacircumflex: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vadieresis: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vagrave: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vamacron: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vaogonek: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    varing: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vatilde: [
        -20,
        -20,
        -25,
        -25,
        -10,
        0,
        0,
        -25
    ],
    vcomma: [
        -80,
        -80,
        -80,
        -80,
        -55,
        -37,
        -74,
        -65
    ],
    vo: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    voacute: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vocircumflex: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vodieresis: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vograve: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vohungarumlaut: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vomacron: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    voslash: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    votilde: [
        -30,
        -30,
        -25,
        -25,
        -10,
        -15,
        0,
        -20
    ],
    vperiod: [
        -80,
        -80,
        -80,
        -80,
        -70,
        -37,
        -74,
        -65
    ],
    wcomma: [
        -40,
        -40,
        -60,
        -60,
        -55,
        -37,
        -74,
        -65
    ],
    wo: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    woacute: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wocircumflex: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wodieresis: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wograve: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wohungarumlaut: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    womacron: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    woslash: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wotilde: [
        -20,
        -20,
        -10,
        -10,
        -10,
        -15,
        0,
        -10
    ],
    wperiod: [
        -40,
        -40,
        -60,
        -60,
        -70,
        -37,
        -74,
        -65
    ],
    xe: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xeacute: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xecaron: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xecircumflex: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xedieresis: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xedotaccent: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xegrave: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xemacron: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    xeogonek: [
        -10,
        -10,
        -30,
        -30,
        0,
        -10,
        0,
        -15
    ],
    ya: [
        -30,
        -30,
        -20,
        -20
    ],
    yaacute: [
        -30,
        -30,
        -20,
        -20
    ],
    yabreve: [
        -30,
        -30,
        -20,
        -20
    ],
    yacircumflex: [
        -30,
        -30,
        -20,
        -20
    ],
    yadieresis: [
        -30,
        -30,
        -20,
        -20
    ],
    yagrave: [
        -30,
        -30,
        -20,
        -20
    ],
    yamacron: [
        -30,
        -30,
        -20,
        -20
    ],
    yaogonek: [
        -30,
        -30,
        -20,
        -20
    ],
    yaring: [
        -30,
        -30,
        -20,
        -20
    ],
    yatilde: [
        -30,
        -30,
        -20,
        -20
    ],
    ycomma: [
        -80,
        -80,
        -100,
        -100,
        -55,
        -37,
        -55,
        -65
    ],
    ye: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yeacute: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yecaron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yecircumflex: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yedieresis: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yedotaccent: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yegrave: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yemacron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yeogonek: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yo: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yoacute: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yocircumflex: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yodieresis: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yograve: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yohungarumlaut: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yomacron: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yoslash: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yotilde: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yperiod: [
        -80,
        -80,
        -100,
        -100,
        -70,
        -37,
        -55,
        -65
    ],
    yacutea: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteaacute: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteabreve: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteacircumflex: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteadieresis: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteagrave: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteamacron: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteaogonek: [
        -30,
        -30,
        -20,
        -20
    ],
    yacutearing: [
        -30,
        -30,
        -20,
        -20
    ],
    yacuteatilde: [
        -30,
        -30,
        -20,
        -20
    ],
    yacutecomma: [
        -80,
        -80,
        -100,
        -100,
        -55,
        -37,
        -55,
        -65
    ],
    yacutee: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteeacute: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteecaron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteecircumflex: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteedieresis: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteedotaccent: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteegrave: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteemacron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteeogonek: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    yacuteo: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteoacute: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteocircumflex: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteodieresis: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteograve: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteohungarumlaut: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteomacron: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteoslash: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteotilde: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    yacuteperiod: [
        -80,
        -80,
        -100,
        -100,
        -70,
        -37,
        -55,
        -65
    ],
    ydieresisa: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisaacute: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisabreve: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisacircumflex: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisadieresis: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisagrave: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisamacron: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisaogonek: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisaring: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresisatilde: [
        -30,
        -30,
        -20,
        -20
    ],
    ydieresiscomma: [
        -80,
        -80,
        -100,
        -100,
        -55,
        -37,
        -55,
        -65
    ],
    ydieresise: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresiseacute: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisecaron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisecircumflex: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisedieresis: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisedotaccent: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisegrave: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresisemacron: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresiseogonek: [
        -10,
        -10,
        -20,
        -20,
        -10
    ],
    ydieresiso: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisoacute: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisocircumflex: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisodieresis: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisograve: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisohungarumlaut: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisomacron: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisoslash: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisotilde: [
        -25,
        -25,
        -20,
        -20,
        -25
    ],
    ydieresisperiod: [
        -80,
        -80,
        -100,
        -100,
        -70,
        -37,
        -55,
        -65
    ],
    ze: [
        10,
        10,
        -15,
        -15
    ],
    zeacute: [
        10,
        10,
        -15,
        -15
    ],
    zecaron: [
        10,
        10,
        -15,
        -15
    ],
    zecircumflex: [
        10,
        10,
        -15,
        -15
    ],
    zedieresis: [
        10,
        10,
        -15,
        -15
    ],
    zedotaccent: [
        10,
        10,
        -15,
        -15
    ],
    zegrave: [
        10,
        10,
        -15,
        -15
    ],
    zemacron: [
        10,
        10,
        -15,
        -15
    ],
    zeogonek: [
        10,
        10,
        -15,
        -15
    ],
    zacutee: [
        10,
        10,
        -15,
        -15
    ],
    zacuteeacute: [
        10,
        10,
        -15,
        -15
    ],
    zacuteecaron: [
        10,
        10,
        -15,
        -15
    ],
    zacuteecircumflex: [
        10,
        10,
        -15,
        -15
    ],
    zacuteedieresis: [
        10,
        10,
        -15,
        -15
    ],
    zacuteedotaccent: [
        10,
        10,
        -15,
        -15
    ],
    zacuteegrave: [
        10,
        10,
        -15,
        -15
    ],
    zacuteemacron: [
        10,
        10,
        -15,
        -15
    ],
    zacuteeogonek: [
        10,
        10,
        -15,
        -15
    ],
    zcarone: [
        10,
        10,
        -15,
        -15
    ],
    zcaroneacute: [
        10,
        10,
        -15,
        -15
    ],
    zcaronecaron: [
        10,
        10,
        -15,
        -15
    ],
    zcaronecircumflex: [
        10,
        10,
        -15,
        -15
    ],
    zcaronedieresis: [
        10,
        10,
        -15,
        -15
    ],
    zcaronedotaccent: [
        10,
        10,
        -15,
        -15
    ],
    zcaronegrave: [
        10,
        10,
        -15,
        -15
    ],
    zcaronemacron: [
        10,
        10,
        -15,
        -15
    ],
    zcaroneogonek: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccente: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccenteacute: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentecaron: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentecircumflex: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentedieresis: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentedotaccent: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentegrave: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccentemacron: [
        10,
        10,
        -15,
        -15
    ],
    zdotaccenteogonek: [
        10,
        10,
        -15,
        -15
    ],
    Bcomma: [
        0,
        0,
        -20,
        -20
    ],
    Bperiod: [
        0,
        0,
        -20,
        -20
    ],
    Ccomma: [
        0,
        0,
        -30,
        -30
    ],
    Cperiod: [
        0,
        0,
        -30,
        -30
    ],
    Cacutecomma: [
        0,
        0,
        -30,
        -30
    ],
    Cacuteperiod: [
        0,
        0,
        -30,
        -30
    ],
    Ccaroncomma: [
        0,
        0,
        -30,
        -30
    ],
    Ccaronperiod: [
        0,
        0,
        -30,
        -30
    ],
    Ccedillacomma: [
        0,
        0,
        -30,
        -30
    ],
    Ccedillaperiod: [
        0,
        0,
        -30,
        -30
    ],
    Fe: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Feacute: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fecaron: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fecircumflex: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fedieresis: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fedotaccent: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fegrave: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Femacron: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Feogonek: [
        0,
        0,
        -30,
        -30,
        -25,
        -100,
        -75
    ],
    Fo: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Foacute: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Focircumflex: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fodieresis: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fograve: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fohungarumlaut: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fomacron: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Foslash: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fotilde: [
        0,
        0,
        -30,
        -30,
        -25,
        -70,
        -105,
        -15
    ],
    Fr: [
        0,
        0,
        -45,
        -45,
        0,
        -50,
        -55
    ],
    Fracute: [
        0,
        0,
        -45,
        -45,
        0,
        -50,
        -55
    ],
    Frcaron: [
        0,
        0,
        -45,
        -45,
        0,
        -50,
        -55
    ],
    Frcommaaccent: [
        0,
        0,
        -45,
        -45,
        0,
        -50,
        -55
    ],
    Ja: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jaacute: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jabreve: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jacircumflex: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jadieresis: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jagrave: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jamacron: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jaogonek: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jaring: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    Jatilde: [
        0,
        0,
        -20,
        -20,
        -15,
        -40,
        -35
    ],
    LcaronT: [
        0,
        0,
        -110,
        -110
    ],
    LcaronTcaron: [
        0,
        0,
        -110,
        -110
    ],
    LcaronTcommaaccent: [
        0,
        0,
        -110,
        -110
    ],
    LcaronV: [
        0,
        0,
        -110,
        -110
    ],
    LcaronW: [
        0,
        0,
        -70,
        -70
    ],
    LcaronY: [
        0,
        0,
        -140,
        -140
    ],
    LcaronYacute: [
        0,
        0,
        -140,
        -140
    ],
    LcaronYdieresis: [
        0,
        0,
        -140,
        -140
    ],
    Lcaronquotedblright: [
        0,
        0,
        -140,
        -140
    ],
    Lcaronquoteright: [
        0,
        0,
        -160,
        -160,
        0,
        0,
        0,
        -92
    ],
    Lcarony: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -55
    ],
    Lcaronyacute: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -55
    ],
    Lcaronydieresis: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -55
    ],
    Scomma: [
        0,
        0,
        -20,
        -20
    ],
    Speriod: [
        0,
        0,
        -20,
        -20
    ],
    Sacutecomma: [
        0,
        0,
        -20,
        -20
    ],
    Sacuteperiod: [
        0,
        0,
        -20,
        -20
    ],
    Scaroncomma: [
        0,
        0,
        -20,
        -20
    ],
    Scaronperiod: [
        0,
        0,
        -20,
        -20
    ],
    Scedillacomma: [
        0,
        0,
        -20,
        -20
    ],
    Scedillaperiod: [
        0,
        0,
        -20,
        -20
    ],
    Scommaaccentcomma: [
        0,
        0,
        -20,
        -20
    ],
    Scommaaccentperiod: [
        0,
        0,
        -20,
        -20
    ],
    Trcaron: [
        0,
        0,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcaronrcaron: [
        0,
        0,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Tcommaaccentrcaron: [
        0,
        0,
        -120,
        -120,
        -74,
        -37,
        -55,
        -35
    ],
    Yhyphen: [
        0,
        0,
        -140,
        -140,
        -92,
        -92,
        -74,
        -111
    ],
    Yi: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yiacute: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yiogonek: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yacutehyphen: [
        0,
        0,
        -140,
        -140,
        -92,
        -92,
        -74,
        -111
    ],
    Yacutei: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yacuteiacute: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Yacuteiogonek: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Ydieresishyphen: [
        0,
        0,
        -140,
        -140,
        -92,
        -92,
        -74,
        -111
    ],
    Ydieresisi: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Ydieresisiacute: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    Ydieresisiogonek: [
        0,
        0,
        -20,
        -20,
        -37,
        -55,
        -74,
        -55
    ],
    bb: [
        0,
        0,
        -10,
        -10,
        -10,
        -10
    ],
    bcomma: [
        0,
        0,
        -40,
        -40
    ],
    bperiod: [
        0,
        0,
        -40,
        -40,
        -40,
        -40,
        -40,
        -40
    ],
    ccomma: [
        0,
        0,
        -15,
        -15
    ],
    cacutecomma: [
        0,
        0,
        -15,
        -15
    ],
    ccaroncomma: [
        0,
        0,
        -15,
        -15
    ],
    ccedillacomma: [
        0,
        0,
        -15,
        -15
    ],
    fa: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    faacute: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fabreve: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    facircumflex: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fadieresis: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fagrave: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    famacron: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    faogonek: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    faring: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fatilde: [
        0,
        0,
        -30,
        -30,
        0,
        0,
        0,
        -10
    ],
    fdotlessi: [
        0,
        0,
        -28,
        -28,
        -35,
        -30,
        -60,
        -50
    ],
    gr: [
        0,
        0,
        -10,
        -10
    ],
    gracute: [
        0,
        0,
        -10,
        -10
    ],
    grcaron: [
        0,
        0,
        -10,
        -10
    ],
    grcommaaccent: [
        0,
        0,
        -10,
        -10
    ],
    gbrever: [
        0,
        0,
        -10,
        -10
    ],
    gbreveracute: [
        0,
        0,
        -10,
        -10
    ],
    gbrevercaron: [
        0,
        0,
        -10,
        -10
    ],
    gbrevercommaaccent: [
        0,
        0,
        -10,
        -10
    ],
    gcommaaccentr: [
        0,
        0,
        -10,
        -10
    ],
    gcommaaccentracute: [
        0,
        0,
        -10,
        -10
    ],
    gcommaaccentrcaron: [
        0,
        0,
        -10,
        -10
    ],
    gcommaaccentrcommaaccent: [
        0,
        0,
        -10,
        -10
    ],
    ke: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    keacute: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kecaron: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kecircumflex: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kedieresis: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kedotaccent: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kegrave: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kemacron: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    keogonek: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccente: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccenteacute: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentecaron: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentecircumflex: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentedieresis: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentedotaccent: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentegrave: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccentemacron: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    kcommaaccenteogonek: [
        0,
        0,
        -20,
        -20,
        -10,
        -30,
        -10,
        -10
    ],
    ocomma: [
        0,
        0,
        -40,
        -40
    ],
    operiod: [
        0,
        0,
        -40,
        -40
    ],
    oacutecomma: [
        0,
        0,
        -40,
        -40
    ],
    oacuteperiod: [
        0,
        0,
        -40,
        -40
    ],
    ocircumflexcomma: [
        0,
        0,
        -40,
        -40
    ],
    ocircumflexperiod: [
        0,
        0,
        -40,
        -40
    ],
    odieresiscomma: [
        0,
        0,
        -40,
        -40
    ],
    odieresisperiod: [
        0,
        0,
        -40,
        -40
    ],
    ogravecomma: [
        0,
        0,
        -40,
        -40
    ],
    ograveperiod: [
        0,
        0,
        -40,
        -40
    ],
    ohungarumlautcomma: [
        0,
        0,
        -40,
        -40
    ],
    ohungarumlautperiod: [
        0,
        0,
        -40,
        -40
    ],
    omacroncomma: [
        0,
        0,
        -40,
        -40
    ],
    omacronperiod: [
        0,
        0,
        -40,
        -40
    ],
    oslasha: [
        0,
        0,
        -55,
        -55
    ],
    oslashaacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashabreve: [
        0,
        0,
        -55,
        -55
    ],
    oslashacircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashadieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashagrave: [
        0,
        0,
        -55,
        -55
    ],
    oslashamacron: [
        0,
        0,
        -55,
        -55
    ],
    oslashaogonek: [
        0,
        0,
        -55,
        -55
    ],
    oslasharing: [
        0,
        0,
        -55,
        -55
    ],
    oslashatilde: [
        0,
        0,
        -55,
        -55
    ],
    oslashb: [
        0,
        0,
        -55,
        -55
    ],
    oslashc: [
        0,
        0,
        -55,
        -55
    ],
    oslashcacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashccaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashccedilla: [
        0,
        0,
        -55,
        -55
    ],
    oslashcomma: [
        0,
        0,
        -95,
        -95
    ],
    oslashd: [
        0,
        0,
        -55,
        -55
    ],
    oslashdcroat: [
        0,
        0,
        -55,
        -55
    ],
    oslashe: [
        0,
        0,
        -55,
        -55
    ],
    oslasheacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashecaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashecircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashedieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashedotaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashegrave: [
        0,
        0,
        -55,
        -55
    ],
    oslashemacron: [
        0,
        0,
        -55,
        -55
    ],
    oslasheogonek: [
        0,
        0,
        -55,
        -55
    ],
    oslashf: [
        0,
        0,
        -55,
        -55
    ],
    oslashg: [
        0,
        0,
        -55,
        -55,
        0,
        0,
        -10
    ],
    oslashgbreve: [
        0,
        0,
        -55,
        -55,
        0,
        0,
        -10
    ],
    oslashgcommaaccent: [
        0,
        0,
        -55,
        -55,
        0,
        0,
        -10
    ],
    oslashh: [
        0,
        0,
        -55,
        -55
    ],
    oslashi: [
        0,
        0,
        -55,
        -55
    ],
    oslashiacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashicircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashidieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashigrave: [
        0,
        0,
        -55,
        -55
    ],
    oslashimacron: [
        0,
        0,
        -55,
        -55
    ],
    oslashiogonek: [
        0,
        0,
        -55,
        -55
    ],
    oslashj: [
        0,
        0,
        -55,
        -55
    ],
    oslashk: [
        0,
        0,
        -55,
        -55
    ],
    oslashkcommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashl: [
        0,
        0,
        -55,
        -55
    ],
    oslashlacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashlcommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashlslash: [
        0,
        0,
        -55,
        -55
    ],
    oslashm: [
        0,
        0,
        -55,
        -55
    ],
    oslashn: [
        0,
        0,
        -55,
        -55
    ],
    oslashnacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashncaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashncommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashntilde: [
        0,
        0,
        -55,
        -55
    ],
    oslasho: [
        0,
        0,
        -55,
        -55
    ],
    oslashoacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashocircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashodieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashograve: [
        0,
        0,
        -55,
        -55
    ],
    oslashohungarumlaut: [
        0,
        0,
        -55,
        -55
    ],
    oslashomacron: [
        0,
        0,
        -55,
        -55
    ],
    oslashoslash: [
        0,
        0,
        -55,
        -55
    ],
    oslashotilde: [
        0,
        0,
        -55,
        -55
    ],
    oslashp: [
        0,
        0,
        -55,
        -55
    ],
    oslashperiod: [
        0,
        0,
        -95,
        -95
    ],
    oslashq: [
        0,
        0,
        -55,
        -55
    ],
    oslashr: [
        0,
        0,
        -55,
        -55
    ],
    oslashracute: [
        0,
        0,
        -55,
        -55
    ],
    oslashrcaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashrcommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashs: [
        0,
        0,
        -55,
        -55
    ],
    oslashsacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashscaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashscedilla: [
        0,
        0,
        -55,
        -55
    ],
    oslashscommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslasht: [
        0,
        0,
        -55,
        -55
    ],
    oslashtcommaaccent: [
        0,
        0,
        -55,
        -55
    ],
    oslashu: [
        0,
        0,
        -55,
        -55
    ],
    oslashuacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashucircumflex: [
        0,
        0,
        -55,
        -55
    ],
    oslashudieresis: [
        0,
        0,
        -55,
        -55
    ],
    oslashugrave: [
        0,
        0,
        -55,
        -55
    ],
    oslashuhungarumlaut: [
        0,
        0,
        -55,
        -55
    ],
    oslashumacron: [
        0,
        0,
        -55,
        -55
    ],
    oslashuogonek: [
        0,
        0,
        -55,
        -55
    ],
    oslashuring: [
        0,
        0,
        -55,
        -55
    ],
    oslashz: [
        0,
        0,
        -55,
        -55
    ],
    oslashzacute: [
        0,
        0,
        -55,
        -55
    ],
    oslashzcaron: [
        0,
        0,
        -55,
        -55
    ],
    oslashzdotaccent: [
        0,
        0,
        -55,
        -55
    ],
    otildecomma: [
        0,
        0,
        -40,
        -40
    ],
    otildeperiod: [
        0,
        0,
        -40,
        -40
    ],
    pcomma: [
        0,
        0,
        -35,
        -35
    ],
    pperiod: [
        0,
        0,
        -35,
        -35
    ],
    ra: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    raacute: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rabreve: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    radieresis: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    ragrave: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    ramacron: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    raogonek: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    raring: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    ratilde: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcolon: [
        0,
        0,
        30,
        30
    ],
    ri: [
        0,
        0,
        15,
        15
    ],
    riacute: [
        0,
        0,
        15,
        15
    ],
    ricircumflex: [
        0,
        0,
        15,
        15
    ],
    ridieresis: [
        0,
        0,
        15,
        15
    ],
    rigrave: [
        0,
        0,
        15,
        15
    ],
    rimacron: [
        0,
        0,
        15,
        15
    ],
    riogonek: [
        0,
        0,
        15,
        15
    ],
    rk: [
        0,
        0,
        15,
        15
    ],
    rkcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rl: [
        0,
        0,
        15,
        15
    ],
    rlacute: [
        0,
        0,
        15,
        15
    ],
    rlcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rlslash: [
        0,
        0,
        15,
        15
    ],
    rm: [
        0,
        0,
        25,
        25
    ],
    rn: [
        0,
        0,
        25,
        25,
        -15
    ],
    rnacute: [
        0,
        0,
        25,
        25,
        -15
    ],
    rncaron: [
        0,
        0,
        25,
        25,
        -15
    ],
    rncommaaccent: [
        0,
        0,
        25,
        25,
        -15
    ],
    rntilde: [
        0,
        0,
        25,
        25,
        -15
    ],
    rp: [
        0,
        0,
        30,
        30,
        -10
    ],
    rsemicolon: [
        0,
        0,
        30,
        30
    ],
    ru: [
        0,
        0,
        15,
        15
    ],
    ruacute: [
        0,
        0,
        15,
        15
    ],
    rucircumflex: [
        0,
        0,
        15,
        15
    ],
    rudieresis: [
        0,
        0,
        15,
        15
    ],
    rugrave: [
        0,
        0,
        15,
        15
    ],
    ruhungarumlaut: [
        0,
        0,
        15,
        15
    ],
    rumacron: [
        0,
        0,
        15,
        15
    ],
    ruogonek: [
        0,
        0,
        15,
        15
    ],
    ruring: [
        0,
        0,
        15,
        15
    ],
    racutea: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteaacute: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteabreve: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteacircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteadieresis: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteagrave: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteamacron: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteaogonek: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racutearing: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racuteatilde: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    racutecolon: [
        0,
        0,
        30,
        30
    ],
    racutei: [
        0,
        0,
        15,
        15
    ],
    racuteiacute: [
        0,
        0,
        15,
        15
    ],
    racuteicircumflex: [
        0,
        0,
        15,
        15
    ],
    racuteidieresis: [
        0,
        0,
        15,
        15
    ],
    racuteigrave: [
        0,
        0,
        15,
        15
    ],
    racuteimacron: [
        0,
        0,
        15,
        15
    ],
    racuteiogonek: [
        0,
        0,
        15,
        15
    ],
    racutek: [
        0,
        0,
        15,
        15
    ],
    racutekcommaaccent: [
        0,
        0,
        15,
        15
    ],
    racutel: [
        0,
        0,
        15,
        15
    ],
    racutelacute: [
        0,
        0,
        15,
        15
    ],
    racutelcommaaccent: [
        0,
        0,
        15,
        15
    ],
    racutelslash: [
        0,
        0,
        15,
        15
    ],
    racutem: [
        0,
        0,
        25,
        25
    ],
    racuten: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutenacute: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutencaron: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutencommaaccent: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutentilde: [
        0,
        0,
        25,
        25,
        -15
    ],
    racutep: [
        0,
        0,
        30,
        30,
        -10
    ],
    racutesemicolon: [
        0,
        0,
        30,
        30
    ],
    racuteu: [
        0,
        0,
        15,
        15
    ],
    racuteuacute: [
        0,
        0,
        15,
        15
    ],
    racuteucircumflex: [
        0,
        0,
        15,
        15
    ],
    racuteudieresis: [
        0,
        0,
        15,
        15
    ],
    racuteugrave: [
        0,
        0,
        15,
        15
    ],
    racuteuhungarumlaut: [
        0,
        0,
        15,
        15
    ],
    racuteumacron: [
        0,
        0,
        15,
        15
    ],
    racuteuogonek: [
        0,
        0,
        15,
        15
    ],
    racuteuring: [
        0,
        0,
        15,
        15
    ],
    rcarona: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronaacute: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronabreve: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronacircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronadieresis: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronagrave: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronamacron: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronaogonek: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronaring: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaronatilde: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcaroncolon: [
        0,
        0,
        30,
        30
    ],
    rcaroni: [
        0,
        0,
        15,
        15
    ],
    rcaroniacute: [
        0,
        0,
        15,
        15
    ],
    rcaronicircumflex: [
        0,
        0,
        15,
        15
    ],
    rcaronidieresis: [
        0,
        0,
        15,
        15
    ],
    rcaronigrave: [
        0,
        0,
        15,
        15
    ],
    rcaronimacron: [
        0,
        0,
        15,
        15
    ],
    rcaroniogonek: [
        0,
        0,
        15,
        15
    ],
    rcaronk: [
        0,
        0,
        15,
        15
    ],
    rcaronkcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rcaronl: [
        0,
        0,
        15,
        15
    ],
    rcaronlacute: [
        0,
        0,
        15,
        15
    ],
    rcaronlcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rcaronlslash: [
        0,
        0,
        15,
        15
    ],
    rcaronm: [
        0,
        0,
        25,
        25
    ],
    rcaronn: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronnacute: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronncaron: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronncommaaccent: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronntilde: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcaronp: [
        0,
        0,
        30,
        30,
        -10
    ],
    rcaronsemicolon: [
        0,
        0,
        30,
        30
    ],
    rcaronu: [
        0,
        0,
        15,
        15
    ],
    rcaronuacute: [
        0,
        0,
        15,
        15
    ],
    rcaronucircumflex: [
        0,
        0,
        15,
        15
    ],
    rcaronudieresis: [
        0,
        0,
        15,
        15
    ],
    rcaronugrave: [
        0,
        0,
        15,
        15
    ],
    rcaronuhungarumlaut: [
        0,
        0,
        15,
        15
    ],
    rcaronumacron: [
        0,
        0,
        15,
        15
    ],
    rcaronuogonek: [
        0,
        0,
        15,
        15
    ],
    rcaronuring: [
        0,
        0,
        15,
        15
    ],
    rcommaaccenta: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentaacute: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentabreve: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentacircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentadieresis: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentagrave: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentamacron: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentaogonek: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentaring: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentatilde: [
        0,
        0,
        -10,
        -10,
        0,
        0,
        -15
    ],
    rcommaaccentcolon: [
        0,
        0,
        30,
        30
    ],
    rcommaaccenti: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentiacute: [
        0,
        0,
        15,
        15
    ],
    rcommaaccenticircumflex: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentidieresis: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentigrave: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentimacron: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentiogonek: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentk: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentkcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentl: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentlacute: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentlcommaaccent: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentlslash: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentm: [
        0,
        0,
        25,
        25
    ],
    rcommaaccentn: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentnacute: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentncaron: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentncommaaccent: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentntilde: [
        0,
        0,
        25,
        25,
        -15
    ],
    rcommaaccentp: [
        0,
        0,
        30,
        30,
        -10
    ],
    rcommaaccentsemicolon: [
        0,
        0,
        30,
        30
    ],
    rcommaaccentu: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentuacute: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentucircumflex: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentudieresis: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentugrave: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentuhungarumlaut: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentumacron: [
        0,
        0,
        15,
        15
    ],
    rcommaaccentuogonek: [
        0,
        0,
        15,
        15
    ],
    rcommaaccenturing: [
        0,
        0,
        15,
        15
    ],
    scomma: [
        0,
        0,
        -15,
        -15
    ],
    speriod: [
        0,
        0,
        -15,
        -15
    ],
    sacutecomma: [
        0,
        0,
        -15,
        -15
    ],
    sacuteperiod: [
        0,
        0,
        -15,
        -15
    ],
    scaroncomma: [
        0,
        0,
        -15,
        -15
    ],
    scaronperiod: [
        0,
        0,
        -15,
        -15
    ],
    scedillacomma: [
        0,
        0,
        -15,
        -15
    ],
    scedillaperiod: [
        0,
        0,
        -15,
        -15
    ],
    scommaaccentcomma: [
        0,
        0,
        -15,
        -15
    ],
    scommaaccentperiod: [
        0,
        0,
        -15,
        -15
    ],
    ve: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    veacute: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vecaron: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vecircumflex: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vedieresis: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vedotaccent: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vegrave: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    vemacron: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    veogonek: [
        0,
        0,
        -25,
        -25,
        -10,
        -15,
        0,
        -15
    ],
    wa: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    waacute: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wabreve: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wacircumflex: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wadieresis: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wagrave: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    wamacron: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    waogonek: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    waring: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    watilde: [
        0,
        0,
        -15,
        -15,
        0,
        -10,
        0,
        -10
    ],
    we: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    weacute: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wecaron: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wecircumflex: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wedieresis: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wedotaccent: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wegrave: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    wemacron: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    weogonek: [
        0,
        0,
        -10,
        -10,
        0,
        -10
    ],
    zo: [
        0,
        0,
        -15,
        -15
    ],
    zoacute: [
        0,
        0,
        -15,
        -15
    ],
    zocircumflex: [
        0,
        0,
        -15,
        -15
    ],
    zodieresis: [
        0,
        0,
        -15,
        -15
    ],
    zograve: [
        0,
        0,
        -15,
        -15
    ],
    zohungarumlaut: [
        0,
        0,
        -15,
        -15
    ],
    zomacron: [
        0,
        0,
        -15,
        -15
    ],
    zoslash: [
        0,
        0,
        -15,
        -15
    ],
    zotilde: [
        0,
        0,
        -15,
        -15
    ],
    zacuteo: [
        0,
        0,
        -15,
        -15
    ],
    zacuteoacute: [
        0,
        0,
        -15,
        -15
    ],
    zacuteocircumflex: [
        0,
        0,
        -15,
        -15
    ],
    zacuteodieresis: [
        0,
        0,
        -15,
        -15
    ],
    zacuteograve: [
        0,
        0,
        -15,
        -15
    ],
    zacuteohungarumlaut: [
        0,
        0,
        -15,
        -15
    ],
    zacuteomacron: [
        0,
        0,
        -15,
        -15
    ],
    zacuteoslash: [
        0,
        0,
        -15,
        -15
    ],
    zacuteotilde: [
        0,
        0,
        -15,
        -15
    ],
    zcarono: [
        0,
        0,
        -15,
        -15
    ],
    zcaronoacute: [
        0,
        0,
        -15,
        -15
    ],
    zcaronocircumflex: [
        0,
        0,
        -15,
        -15
    ],
    zcaronodieresis: [
        0,
        0,
        -15,
        -15
    ],
    zcaronograve: [
        0,
        0,
        -15,
        -15
    ],
    zcaronohungarumlaut: [
        0,
        0,
        -15,
        -15
    ],
    zcaronomacron: [
        0,
        0,
        -15,
        -15
    ],
    zcaronoslash: [
        0,
        0,
        -15,
        -15
    ],
    zcaronotilde: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccento: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentoacute: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentocircumflex: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentodieresis: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentograve: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentohungarumlaut: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentomacron: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentoslash: [
        0,
        0,
        -15,
        -15
    ],
    zdotaccentotilde: [
        0,
        0,
        -15,
        -15
    ],
    Ap: [
        0,
        0,
        0,
        0,
        -25
    ],
    Aquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Aacutep: [
        0,
        0,
        0,
        0,
        -25
    ],
    Aacutequoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Abrevep: [
        0,
        0,
        0,
        0,
        -25
    ],
    Abrevequoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Acircumflexp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Acircumflexquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Adieresisp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Adieresisquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Agravep: [
        0,
        0,
        0,
        0,
        -25
    ],
    Agravequoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Amacronp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Amacronquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Aogonekp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Aogonekquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Aringp: [
        0,
        0,
        0,
        0,
        -25
    ],
    Aringquoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Atildep: [
        0,
        0,
        0,
        0,
        -25
    ],
    Atildequoteright: [
        0,
        0,
        0,
        0,
        -74,
        -74,
        -37,
        -111
    ],
    Je: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jeacute: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jecaron: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jecircumflex: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jedieresis: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jedotaccent: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jegrave: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jemacron: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jeogonek: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jo: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Joacute: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jocircumflex: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jodieresis: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jograve: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Johungarumlaut: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jomacron: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Joslash: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    Jotilde: [
        0,
        0,
        0,
        0,
        -15,
        -40,
        -25
    ],
    NA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NacuteAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcaronAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NcommaaccentAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeA: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAacute: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAbreve: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAcircumflex: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAdieresis: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAgrave: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAmacron: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAogonek: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAring: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    NtildeAtilde: [
        0,
        0,
        0,
        0,
        -20,
        -30,
        -27,
        -35
    ],
    Ti: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tiacute: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tiogonek: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcaroni: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcaroniacute: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcaroniogonek: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcommaaccenti: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcommaaccentiacute: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Tcommaaccentiogonek: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -35
    ],
    Vi: [
        0,
        0,
        0,
        0,
        -37,
        -55,
        -74,
        -60
    ],
    Viacute: [
        0,
        0,
        0,
        0,
        -37,
        -55,
        -74,
        -60
    ],
    Vicircumflex: [
        0,
        0,
        0,
        0,
        -37,
        0,
        -34,
        -20
    ],
    Vidieresis: [
        0,
        0,
        0,
        0,
        -37,
        0,
        -34,
        -20
    ],
    Vigrave: [
        0,
        0,
        0,
        0,
        -37,
        0,
        -34,
        -20
    ],
    Vimacron: [
        0,
        0,
        0,
        0,
        -37,
        0,
        -34,
        -20
    ],
    Viogonek: [
        0,
        0,
        0,
        0,
        -37,
        -55,
        -74,
        -60
    ],
    Wi: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -40
    ],
    Wiacute: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -40
    ],
    Wiogonek: [
        0,
        0,
        0,
        0,
        -18,
        -37,
        -55,
        -40
    ],
    fi: [
        0,
        0,
        0,
        0,
        -25,
        0,
        -20,
        -20
    ],
    gperiod: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -15
    ],
    gbreveperiod: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -15
    ],
    gcommaaccentperiod: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -15
    ],
    iv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    iacutev: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    icircumflexv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    idieresisv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    igravev: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    imacronv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    iogonekv: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -25
    ],
    ky: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kyacute: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kydieresis: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kcommaaccenty: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kcommaaccentyacute: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    kcommaaccentydieresis: [
        0,
        0,
        0,
        0,
        -15,
        0,
        -10,
        -15
    ],
    quotedblleftA: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAacute: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAbreve: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAcircumflex: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAdieresis: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAgrave: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAmacron: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAogonek: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAring: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quotedblleftAtilde: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftA: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAacute: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAbreve: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAcircumflex: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAdieresis: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAgrave: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAmacron: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAogonek: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAring: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    quoteleftAtilde: [
        0,
        0,
        0,
        0,
        -10,
        0,
        0,
        -80
    ],
    re: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    reacute: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    recaron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    recircumflex: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    redieresis: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    redotaccent: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    regrave: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    remacron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    reogonek: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racutee: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteeacute: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteecaron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteecircumflex: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteedieresis: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteedotaccent: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteegrave: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteemacron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    racuteeogonek: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcarone: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaroneacute: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronecaron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronecircumflex: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronedieresis: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronedotaccent: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronegrave: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaronemacron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcaroneogonek: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccente: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccenteacute: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentecaron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentecircumflex: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentedieresis: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentedotaccent: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentegrave: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccentemacron: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    rcommaaccenteogonek: [
        0,
        0,
        0,
        0,
        -18,
        0,
        -37
    ],
    spaceA: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAacute: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAbreve: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAcircumflex: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAdieresis: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAgrave: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAmacron: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAogonek: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAring: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    spaceAtilde: [
        0,
        0,
        0,
        0,
        -55,
        -37,
        -18,
        -55
    ],
    Fi: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Fiacute: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Ficircumflex: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Fidieresis: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Figrave: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Fimacron: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    Fiogonek: [
        0,
        0,
        0,
        0,
        0,
        -40,
        -45
    ],
    eb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    eacuteb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ecaronb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ecircumflexb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    edieresisb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    edotaccentb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    egraveb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    emacronb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    eogonekb: [
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ff: [
        0,
        0,
        0,
        0,
        0,
        -18,
        -18,
        -25
    ],
    quoterightt: [
        0,
        0,
        0,
        0,
        0,
        -37,
        -30,
        -18
    ],
    quoterighttcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        -37,
        -30,
        -18
    ],
    Yicircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yidieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yigrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yimacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yacuteicircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yacuteidieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yacuteigrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Yacuteimacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Ydieresisicircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Ydieresisidieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Ydieresisigrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    Ydieresisimacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        -34
    ],
    eg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eacuteg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eacutegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eacutegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecarong: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecarongbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecarongcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecircumflexg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecircumflexgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    ecircumflexgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edieresisg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edieresisgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edieresisgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edotaccentg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edotaccentgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    edotaccentgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egraveg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egravegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    egravegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    emacrong: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    emacrongbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    emacrongcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eogonekg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eogonekgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    eogonekgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -40,
        -15
    ],
    fiogonek: [
        0,
        0,
        0,
        0,
        0,
        0,
        -20
    ],
    gcomma: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    gbrevecomma: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    gcommaaccentcomma: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    og: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ogbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ogcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    oacuteg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    oacutegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    oacutegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ocircumflexg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ocircumflexgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ocircumflexgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    odieresisg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    odieresisgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    odieresisgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ograveg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ogravegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ogravegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ohungarumlautg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ohungarumlautgbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    ohungarumlautgcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    omacrong: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    omacrongbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    omacrongcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    otildeg: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    otildegbreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    otildegcommaaccent: [
        0,
        0,
        0,
        0,
        0,
        0,
        -10
    ],
    fiacute: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -20
    ],
    ga: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gaacute: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gabreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gacircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gadieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gagrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gamacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gaogonek: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    garing: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gatilde: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbrevea: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveaacute: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveabreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveacircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveadieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveagrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveamacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveaogonek: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbrevearing: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gbreveatilde: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccenta: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentaacute: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentabreve: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentacircumflex: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentadieresis: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentagrave: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentamacron: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentaogonek: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentaring: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ],
    gcommaaccentatilde: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        -5
    ]
};
var data = {
    attributes: attributes,
    glyphWidths: glyphWidths,
    kernPairs: kernPairs
};
var initFont = function initFont(font) {
    return [
        font.FontName,
        {
            attributes: font,
            glyphWidths: {},
            kernPairs: {}
        }
    ];
};
var expandData = function expandData(data) {
    var attributes = data.attributes, glyphWidths = data.glyphWidths, kernPairs = data.kernPairs;
    var fonts = attributes.map(initFont);
    Object.keys(glyphWidths).forEach(function(key) {
        glyphWidths[key].forEach(function(value, index) {
            if (value) fonts[index][1].glyphWidths[key] = value;
        });
    });
    Object.keys(kernPairs).forEach(function(key) {
        kernPairs[key].forEach(function(value, index) {
            if (value) fonts[index][1].kernPairs[key] = value;
        });
    });
    return Object.fromEntries(fonts);
};
var STANDARD_FONTS = expandData(data);
var createStandardFont = function createStandardFont(PDFFont) {
    return /*#__PURE__*/ function(_PDFFont) {
        (0, _inheritsLooseDefault.default)(StandardFont, _PDFFont);
        function StandardFont(document, name, id) {
            var _this;
            _this = _PDFFont.call(this) || this;
            _this.document = document;
            _this.name = name;
            _this.id = id;
            _this.font = AFMFont.fromJson(STANDARD_FONTS[_this.name]);
            _this.ascender = _this.font.ascender;
            _this.descender = _this.font.descender;
            _this.bbox = _this.font.bbox;
            _this.lineGap = _this.font.lineGap;
            return _this;
        }
        var _proto = StandardFont.prototype;
        _proto.embed = function embed() {
            this.dictionary.data = {
                Type: "Font",
                BaseFont: this.name,
                Subtype: "Type1",
                Encoding: "WinAnsiEncoding"
            };
            return this.dictionary.end();
        };
        _proto.encode = function encode(text) {
            var encoded = this.font.encodeText(text);
            var glyphs = this.font.glyphsForString("" + text);
            var advances = this.font.advancesForGlyphs(glyphs);
            var positions = [];
            for(var i = 0; i < glyphs.length; i++){
                var glyph = glyphs[i];
                positions.push({
                    xAdvance: advances[i],
                    yAdvance: 0,
                    xOffset: 0,
                    yOffset: 0,
                    advanceWidth: this.font.widthOfGlyph(glyph)
                });
            }
            return [
                encoded,
                positions
            ];
        };
        _proto.encodeGlyphs = function encodeGlyphs(glyphs) {
            var res = [];
            for(var _i = 0, _Array$from = Array.from(glyphs); _i < _Array$from.length; _i++){
                var glyph = _Array$from[_i];
                res.push(("00" + glyph.id.toString(16)).slice(-2));
            }
            return res;
        };
        _proto.widthOfString = function widthOfString(string, size) {
            var glyphs = this.font.glyphsForString("" + string);
            var advances = this.font.advancesForGlyphs(glyphs);
            var width = 0;
            for(var _i2 = 0, _Array$from2 = Array.from(advances); _i2 < _Array$from2.length; _i2++){
                var advance = _Array$from2[_i2];
                width += advance;
            }
            var scale = size / 1000;
            return width * scale;
        };
        StandardFont.isStandardFont = function isStandardFont(name) {
            return name in STANDARD_FONTS;
        };
        return StandardFont;
    }(PDFFont);
};
var toHex = function toHex() {
    for(var _len = arguments.length, codePoints = new Array(_len), _key = 0; _key < _len; _key++)codePoints[_key] = arguments[_key];
    var codes = Array.from(codePoints).map(function(code) {
        return ("0000" + code.toString(16)).slice(-4);
    });
    return codes.join("");
};
var createEmbeddedFont = function createEmbeddedFont(PDFFont) {
    return /*#__PURE__*/ function(_PDFFont) {
        (0, _inheritsLooseDefault.default)(EmbeddedFont, _PDFFont);
        function EmbeddedFont(document, font, id) {
            var _this;
            _this = _PDFFont.call(this) || this;
            _this.document = document;
            _this.font = font;
            _this.id = id;
            _this.subset = _this.font.createSubset();
            _this.unicode = [
                [
                    0
                ]
            ];
            _this.widths = [
                _this.font.getGlyph(0).advanceWidth
            ];
            _this.name = _this.font.postscriptName;
            _this.scale = 1000 / _this.font.unitsPerEm;
            _this.ascender = _this.font.ascent * _this.scale;
            _this.descender = _this.font.descent * _this.scale;
            _this.xHeight = _this.font.xHeight * _this.scale;
            _this.capHeight = _this.font.capHeight * _this.scale;
            _this.lineGap = _this.font.lineGap * _this.scale;
            _this.bbox = _this.font.bbox;
            _this.layoutCache = Object.create(null);
            return _this;
        }
        var _proto = EmbeddedFont.prototype;
        _proto.layoutRun = function layoutRun(text, features) {
            var run = this.font.layout(text, features);
            // Normalize position values
            for(var i = 0; i < run.positions.length; i++){
                var position = run.positions[i];
                for(var key in position)position[key] *= this.scale;
                position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
            }
            return run;
        };
        _proto.layoutCached = function layoutCached(text) {
            var cached;
            if (cached = this.layoutCache[text]) return cached;
            var run = this.layoutRun(text);
            this.layoutCache[text] = run;
            return run;
        };
        _proto.layout = function layout(text, features, onlyWidth) {
            // Skip the cache if any user defined features are applied
            if (onlyWidth == null) onlyWidth = false;
            if (features) return this.layoutRun(text, features);
            var glyphs = onlyWidth ? null : [];
            var positions = onlyWidth ? null : [];
            var advanceWidth = 0;
            // Split the string by words to increase cache efficiency.
            // For this purpose, spaces and tabs are a good enough delimeter.
            var last = 0;
            var index = 0;
            while(index <= text.length){
                var needle;
                if (index === text.length && last < index || (needle = text.charAt(index), [
                    " ",
                    "	"
                ].includes(needle))) {
                    var run = this.layoutCached(text.slice(last, ++index));
                    if (!onlyWidth) {
                        glyphs.push.apply(glyphs, Array.from(run.glyphs || []));
                        positions.push.apply(positions, Array.from(run.positions || []));
                    }
                    advanceWidth += run.advanceWidth;
                    last = index;
                } else index++;
            }
            return {
                glyphs: glyphs,
                positions: positions,
                advanceWidth: advanceWidth
            };
        };
        _proto.encode = function encode(text, features) {
            var _this$layout = this.layout(text, features), glyphs = _this$layout.glyphs, positions = _this$layout.positions;
            var res = [];
            for(var i = 0; i < glyphs.length; i++){
                var glyph = glyphs[i];
                var gid = this.subset.includeGlyph(glyph.id);
                res.push(("0000" + gid.toString(16)).slice(-4));
                if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
                if (this.unicode[gid] == null) this.unicode[gid] = this.font._cmapProcessor.codePointsForGlyph(glyph.id);
            }
            return [
                res,
                positions
            ];
        };
        _proto.encodeGlyphs = function encodeGlyphs(glyphs) {
            var res = [];
            for(var i = 0; i < glyphs.length; i++){
                var glyph = glyphs[i];
                var gid = this.subset.includeGlyph(glyph.id);
                res.push(("0000" + gid.toString(16)).slice(-4));
                if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
                if (this.unicode[gid] == null) this.unicode[gid] = this.font._cmapProcessor.codePointsForGlyph(glyph.id);
            }
            return res;
        };
        _proto.widthOfString = function widthOfString(string, size, features) {
            var width = this.layout(string, features, true).advanceWidth;
            var scale = size / 1000;
            return width * scale;
        };
        _proto.embed = function embed() {
            var isCFF = this.subset.cff != null;
            var fontFile = this.document.ref();
            if (isCFF) fontFile.data.Subtype = "CIDFontType0C";
            fontFile.end(this.subset.encode());
            var familyClass = ((this.font["OS/2"] != null ? this.font["OS/2"].sFamilyClass : undefined) || 0) >> 8;
            var flags = 0;
            if (this.font.post.isFixedPitch) flags |= 1;
            if (1 <= familyClass && familyClass <= 7) flags |= 2;
            flags |= 4; // assume the font uses non-latin characters
            if (familyClass === 10) flags |= 8;
            if (this.font.head.macStyle.italic) flags |= 64;
            // generate a random tag (6 uppercase letters. 65 is the char code for 'A')
            var tag = [
                0,
                1,
                2,
                3,
                4,
                5
            ].map(function(i) {
                return String.fromCharCode(Math.random() * 26 + 65);
            }).join("");
            var name = tag + "+" + this.font.postscriptName;
            var bbox = this.font.bbox;
            var descriptor = this.document.ref({
                Type: "FontDescriptor",
                FontName: name,
                Flags: flags,
                FontBBox: [
                    bbox.minX * this.scale,
                    bbox.minY * this.scale,
                    bbox.maxX * this.scale,
                    bbox.maxY * this.scale
                ],
                ItalicAngle: this.font.italicAngle,
                Ascent: this.ascender,
                Descent: this.descender,
                CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
                XHeight: (this.font.xHeight || 0) * this.scale,
                StemV: 0
            }); // not sure how to calculate this
            if (isCFF) descriptor.data.FontFile3 = fontFile;
            else descriptor.data.FontFile2 = fontFile;
            descriptor.end();
            var descendantFont = this.document.ref({
                Type: "Font",
                Subtype: isCFF ? "CIDFontType0" : "CIDFontType2",
                BaseFont: name,
                CIDSystemInfo: {
                    Registry: new String("Adobe"),
                    Ordering: new String("Identity"),
                    Supplement: 0
                },
                FontDescriptor: descriptor,
                W: [
                    0,
                    this.widths
                ]
            });
            descendantFont.end();
            this.dictionary.data = {
                Type: "Font",
                Subtype: "Type0",
                BaseFont: name,
                Encoding: "Identity-H",
                DescendantFonts: [
                    descendantFont
                ],
                ToUnicode: this.toUnicodeCmap()
            };
            return this.dictionary.end();
        };
        _proto.toUnicodeCmap = function toUnicodeCmap() {
            var cmap = this.document.ref();
            var entries = [];
            for(var _i = 0, _Array$from = Array.from(this.unicode); _i < _Array$from.length; _i++){
                var codePoints = _Array$from[_i];
                var encoded = [];
                for(var _i2 = 0, _Array$from2 = Array.from(codePoints); _i2 < _Array$from2.length; _i2++){
                    var value = _Array$from2[_i2];
                    if (value > 0xffff) {
                        value -= 0x10000;
                        encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
                        value = 0xdc00 | value & 0x3ff;
                    }
                    encoded.push(toHex(value));
                    entries.push("<" + encoded.join(" ") + ">");
                }
            }
            cmap.end("  /CIDInit /ProcSet findresource begin\n  12 dict begin\n  begincmap\n  /CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n  >> def\n  /CMapName /Adobe-Identity-UCS def\n  /CMapType 2 def\n  1 begincodespacerange\n  <0000><ffff>\n  endcodespacerange\n  1 beginbfrange\n  <0000> <" + toHex(entries.length - 1) + "> [" + entries.join(" ") + "]\n  endbfrange\n  endcmap\n  CMapName currentdict /CMap defineresource pop\n  end\n  end  ");
            return cmap;
        };
        return EmbeddedFont;
    }(PDFFont);
};
var PDFFont = /*#__PURE__*/ function() {
    function PDFFont() {}
    PDFFont.open = function open(document, src, family, id) {
        var font;
        if (typeof src === "string") {
            if (StandardFont.isStandardFont(src)) return new StandardFont(document, src, id);
            throw new Error("Can't open " + src + " in browser build");
        } else if (src instanceof Uint8Array) font = _fontkit.create(src, family);
        else if (src instanceof ArrayBuffer) font = _fontkit.create(new Uint8Array(src), family);
        else if (typeof src === "object") font = src;
        if (font == null) throw new Error("Not a supported font format or standard PDF font.");
        return new EmbeddedFont(document, font, id);
    };
    var _proto = PDFFont.prototype;
    _proto.encode = function encode() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto.widthOfString = function widthOfString() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto.ref = function ref() {
        return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
    };
    _proto.finalize = function finalize() {
        if (this.embedded || this.dictionary == null) return;
        this.embed();
        return this.embedded = true;
    };
    _proto.embed = function embed() {
        throw new Error("Must be implemented by subclasses");
    };
    _proto.lineHeight = function lineHeight(size, includeGap) {
        if (includeGap == null) includeGap = false;
        var gap = includeGap ? this.lineGap : 0;
        return (this.ascender + gap - this.descender) / 1000 * size;
    };
    return PDFFont;
}();
var StandardFont = createStandardFont(PDFFont);
var EmbeddedFont = createEmbeddedFont(PDFFont);
var FontsMixin = {
    initFonts: function initFonts() {
        // Lookup table for embedded fonts
        this._fontFamilies = {};
        this._fontCount = 0;
        // Font state
        this._fontSize = 12;
        this._font = null;
        this._registeredFonts = {};
        // Set the default font
        return this.font("Helvetica");
    },
    font: function font(src, family, size) {
        var cacheKey, font;
        if (typeof family === "number") {
            size = family;
            family = null;
        }
        // check registered fonts if src is a string
        if (typeof src === "string" && this._registeredFonts[src]) {
            cacheKey = src;
            var _this$_registeredFont = this._registeredFonts[src];
            src = _this$_registeredFont.src;
            family = _this$_registeredFont.family;
        } else {
            cacheKey = family || src;
            if (typeof cacheKey !== "string") cacheKey = null;
        }
        if (size != null) this.fontSize(size);
        // fast path: check if the font is already in the PDF
        if (font = this._fontFamilies[cacheKey]) {
            this._font = font;
            return this;
        }
        // load the font
        var id = "F" + ++this._fontCount;
        this._font = PDFFont.open(this, src, family, id);
        // check for existing font familes with the same name already in the PDF
        // useful if the font was passed as a buffer
        if (font = this._fontFamilies[this._font.name]) {
            this._font = font;
            return this;
        }
        // save the font for reuse later
        if (cacheKey) this._fontFamilies[cacheKey] = this._font;
        if (this._font.name) this._fontFamilies[this._font.name] = this._font;
        return this;
    },
    fontSize: function fontSize(_fontSize) {
        this._fontSize = _fontSize;
        return this;
    },
    currentLineHeight: function currentLineHeight(includeGap) {
        if (includeGap == null) includeGap = false;
        return this._font.lineHeight(this._fontSize, includeGap);
    },
    registerFont: function registerFont(name, src, family) {
        this._registeredFonts[name] = {
            src: src,
            family: family
        };
        return this;
    }
};
var number = PDFObject$1.number;
var TextMixin = {
    initText: function initText() {
        this._line = this._line.bind(this);
        // Current coordinates
        this.x = 0;
        this.y = 0;
        return this._lineGap = 0;
    },
    _text: function _text(text, x, y, options, lineCallback) {
        var _this = this;
        options = this._initOptions(x, y, options);
        // Convert text to a string
        text = text == null ? "" : "" + text;
        // if the wordSpacing option is specified, remove multiple consecutive spaces
        if (options.wordSpacing) text = text.replace(/\s{2,}/g, " ");
        var addStructure = function addStructure() {
            if (options.structParent) options.structParent.add(_this.struct(options.structType || "P", [
                _this.markStructureContent(options.structType || "P")
            ]));
        };
        for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(text.split("\n")), _step; !(_step = _iterator()).done;){
            var line = _step.value;
            addStructure();
            lineCallback(line, options);
        }
        return this;
    },
    text: function text(_text2, x, y, options) {
        return this._text(_text2, x, y, options, this._line);
    },
    widthOfString: function widthOfString(string, options) {
        if (options === void 0) options = {};
        return this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1);
    },
    _initOptions: function _initOptions(x, y, options) {
        if (x === void 0) x = {};
        if (options === void 0) options = {};
        if (typeof x === "object") {
            options = x;
            x = null;
        }
        // clone options object
        var result = Object.assign({}, options);
        // extend options with previous values for continued text
        if (this._textOptions) for(var key in this._textOptions){
            var val = this._textOptions[key];
            if (key !== "continued") {
                if (result[key] === undefined) result[key] = val;
            }
        }
        // Update the current position
        if (x != null) this.x = x;
        if (y != null) this.y = y;
        // wrap to margins if no x or y position passed
        if (result.lineBreak !== false) {
            if (result.width == null) result.width = this.page.width - this.x - this.page.margins.right;
            result.width = Math.max(result.width, 0);
        }
        if (!result.columns) result.columns = 0;
        if (result.columnGap == null) result.columnGap = 18;
         // 1/4 inch
        return result;
    },
    _line: function _line(text, options) {
        if (options === void 0) options = {};
        this._fragment(text, this.x, this.y, options);
        return this.x += this.widthOfString(text);
    },
    _fragment: function _fragment(text, x, y, options) {
        text = ("" + text).replace(/\n/g, "");
        if (text.length === 0) return;
        var _this$_font$encode = this._font.encode(text, options.features), encoded = _this$_font$encode[0], positions = _this$_font$encode[1];
        var dy = this._font.ascender / 1000 * this._fontSize;
        this._glyphs(encoded, positions, x, y + dy, options);
    },
    _glyphs: function _glyphs(encoded, positions, x, y, options) {
        var _this2 = this;
        var commands = [];
        var scale = this._fontSize / 1000;
        var i;
        var last = 0;
        var hadOffset = false;
        this.save();
        // flip coordinate system
        this.transform(1, 0, 0, -1, 0, this.page.height);
        y = this.page.height - y;
        // add current font to page if necessary
        if (this.page.fonts[this._font.id] == null) this.page.fonts[this._font.id] = this._font.ref();
        // begin the text object
        this.addContent("BT");
        // text position
        this.addContent("1 0 0 1 " + number(x) + " " + number(y) + " Tm");
        // font and font size
        this.addContent("/" + this._font.id + " " + number(this._fontSize) + " Tf");
        // rendering mode
        var mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
        if (mode) this.addContent(mode + " Tr");
        // Adds a segment of text to the TJ command buffer
        var addSegment = function addSegment(cur) {
            if (last < cur) {
                var hex = encoded.slice(last, cur).join("");
                var advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
                commands.push("<" + hex + "> " + number(-advance));
            }
            return last = cur;
        };
        // Flushes the current TJ commands to the output stream
        var flush = function flush(i) {
            addSegment(i);
            if (commands.length > 0) {
                _this2.addContent("[" + commands.join(" ") + "] TJ");
                return commands.length = 0;
            }
        };
        for(i = 0; i < positions.length; i++){
            // If we have an x or y offset, we have to break out of the current TJ command
            // so we can move the text position.
            var pos = positions[i];
            if (pos.xOffset || pos.yOffset) {
                // Flush the current buffer
                flush(i);
                // Move the text position and flush just the current character
                this.addContent("1 0 0 1 " + number(x + pos.xOffset * scale) + " " + number(y + pos.yOffset * scale) + " Tm");
                flush(i + 1);
                hadOffset = true;
            } else {
                // If the last character had an offset, reset the text position
                if (hadOffset) {
                    this.addContent("1 0 0 1 " + number(x) + " " + number(y) + " Tm");
                    hadOffset = false;
                }
                // Group segments that don't have any advance adjustments
                if (pos.xAdvance - pos.advanceWidth !== 0) addSegment(i + 1);
            }
            x += pos.xAdvance * scale;
        }
        // Flush any remaining commands
        flush(i);
        // end the text object
        this.addContent("ET");
        // restore flipped coordinate system
        return this.restore();
    }
};
var MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var JPEG = /*#__PURE__*/ function() {
    function JPEG(data, label) {
        var marker;
        this.data = data;
        this.label = label;
        if (this.data.readUInt16BE(0) !== 0xffd8) throw "SOI not found in JPEG";
        var pos = 2;
        while(pos < this.data.length){
            marker = this.data.readUInt16BE(pos);
            pos += 2;
            if (Array.from(MARKERS).includes(marker)) break;
            pos += this.data.readUInt16BE(pos);
        }
        if (!Array.from(MARKERS).includes(marker)) throw "Invalid JPEG.";
        pos += 2;
        this.bits = this.data[pos++];
        this.height = this.data.readUInt16BE(pos);
        pos += 2;
        this.width = this.data.readUInt16BE(pos);
        pos += 2;
        var channels = this.data[pos++];
        this.colorSpace = function() {
            switch(channels){
                case 1:
                    return "DeviceGray";
                case 3:
                    return "DeviceRGB";
                case 4:
                    return "DeviceCMYK";
            }
        }();
        this.obj = null;
    }
    var _proto = JPEG.prototype;
    _proto.embed = function embed(document) {
        if (this.obj) return;
        this.obj = document.ref({
            Type: "XObject",
            Subtype: "Image",
            BitsPerComponent: this.bits,
            Width: this.width,
            Height: this.height,
            ColorSpace: this.colorSpace,
            Filter: "DCTDecode"
        });
        // add extra decode params for CMYK images. By swapping the
        // min and max values from the default, we invert the colors. See
        // section 4.8.4 of the spec.
        if (this.colorSpace === "DeviceCMYK") this.obj.data["Decode"] = [
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0,
            1.0,
            0.0
        ];
        this.obj.end(this.data);
        // free memory
        this.data = null;
    };
    return JPEG;
}();
var PNGImage = /*#__PURE__*/ function() {
    function PNGImage(data, label) {
        this.label = label;
        this.image = new (0, _pngJsDefault.default)(data);
        this.width = this.image.width;
        this.height = this.image.height;
        this.imgData = this.image.imgData;
        this.obj = null;
    }
    var _proto = PNGImage.prototype;
    _proto.embed = function embed(document) {
        var dataDecoded = false;
        this.document = document;
        if (this.obj) return;
        var hasAlphaChannel = this.image.hasAlphaChannel;
        var isInterlaced = this.image.interlaceMethod === 1;
        this.obj = this.document.ref({
            Type: "XObject",
            Subtype: "Image",
            BitsPerComponent: hasAlphaChannel ? 8 : this.image.bits,
            Width: this.width,
            Height: this.height,
            Filter: "FlateDecode"
        });
        if (!hasAlphaChannel) {
            var params = this.document.ref({
                Predictor: isInterlaced ? 1 : 15,
                Colors: this.image.colors,
                BitsPerComponent: this.image.bits,
                Columns: this.width
            });
            this.obj.data["DecodeParms"] = params;
            params.end();
        }
        if (this.image.palette.length === 0) this.obj.data["ColorSpace"] = this.image.colorSpace;
        else {
            // embed the color palette in the PDF as an object stream
            var palette = this.document.ref();
            palette.end(Buffer$4.from(this.image.palette));
            // build the color space array for the image
            this.obj.data["ColorSpace"] = [
                "Indexed",
                "DeviceRGB",
                this.image.palette.length / 3 - 1,
                palette
            ];
        }
        // For PNG color types 0, 2 and 3, the transparency data is stored in
        // a dedicated PNG chunk.
        if (this.image.transparency.grayscale != null) {
            // Use Color Key Masking (spec section 4.8.5)
            // An array with N elements, where N is two times the number of color components.
            var val = this.image.transparency.grayscale;
            this.obj.data["Mask"] = [
                val,
                val
            ];
        } else if (this.image.transparency.rgb) {
            // Use Color Key Masking (spec section 4.8.5)
            // An array with N elements, where N is two times the number of color components.
            var rgb = this.image.transparency.rgb;
            var mask = [];
            for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(rgb), _step; !(_step = _iterator()).done;){
                var x = _step.value;
                mask.push(x, x);
            }
            this.obj.data["Mask"] = mask;
        } else if (this.image.transparency.indexed) {
            // Create a transparency SMask for the image based on the data
            // in the PLTE and tRNS sections. See below for details on SMasks.
            dataDecoded = true;
            return this.loadIndexedAlphaChannel();
        } else if (hasAlphaChannel) {
            // For PNG color types 4 and 6, the transparency data is stored as a alpha
            // channel mixed in with the main image data. Separate this data out into an
            // SMask object and store it separately in the PDF.
            dataDecoded = true;
            return this.splitAlphaChannel();
        }
        if (isInterlaced && !dataDecoded) return this.decodeData();
        this.finalize();
    };
    _proto.finalize = function finalize() {
        if (this.alphaChannel) {
            var sMask = this.document.ref({
                Type: "XObject",
                Subtype: "Image",
                Height: this.height,
                Width: this.width,
                BitsPerComponent: 8,
                Filter: "FlateDecode",
                ColorSpace: "DeviceGray",
                Decode: [
                    0,
                    1
                ]
            });
            sMask.end(this.alphaChannel);
            this.obj.data["SMask"] = sMask;
        }
        // add the actual image data
        this.obj.end(this.imgData);
        // free memory
        this.image = null;
        this.imgData = null;
    };
    _proto.splitAlphaChannel = function splitAlphaChannel() {
        var _this = this;
        return this.image.decodePixels(function(pixels) {
            var a;
            var p;
            var colorCount = _this.image.colors;
            var pixelCount = _this.width * _this.height;
            var imgData = Buffer$4.alloc(pixelCount * colorCount);
            var alphaChannel = Buffer$4.alloc(pixelCount);
            var i = p = a = 0;
            var len = pixels.length;
            // For 16bit images copy only most significant byte (MSB) - PNG data is always stored in network byte order (MSB first)
            var skipByteCount = _this.image.bits === 16 ? 1 : 0;
            while(i < len){
                for(var colorIndex = 0; colorIndex < colorCount; colorIndex++){
                    imgData[p++] = pixels[i++];
                    i += skipByteCount;
                }
                alphaChannel[a++] = pixels[i++];
                i += skipByteCount;
            }
            _this.imgData = lib.deflateSync(imgData);
            _this.alphaChannel = lib.deflateSync(alphaChannel);
            return _this.finalize();
        });
    };
    _proto.loadIndexedAlphaChannel = function loadIndexedAlphaChannel() {
        var _this2 = this;
        var transparency = this.image.transparency.indexed;
        return this.image.decodePixels(function(pixels) {
            var alphaChannel = Buffer$4.alloc(_this2.width * _this2.height);
            var i = 0;
            for(var j = 0, end = pixels.length; j < end; j++)alphaChannel[i++] = transparency[pixels[j]];
            _this2.alphaChannel = lib.deflateSync(alphaChannel);
            return _this2.finalize();
        });
    };
    _proto.decodeData = function decodeData() {
        var _this3 = this;
        this.image.decodePixels(function(pixels) {
            _this3.imgData = lib.deflateSync(pixels);
            _this3.finalize();
        });
    };
    return PNGImage;
}();
var PDFImage = /*#__PURE__*/ function() {
    function PDFImage() {}
    PDFImage.open = function open(src, label) {
        var data;
        if (Buffer$4.isBuffer(src)) data = src;
        else if (src instanceof ArrayBuffer) data = Buffer$4.from(new Uint8Array(src));
        else {
            var match = /^data:.+;base64,(.*)$/.exec(src);
            if (match) data = Buffer$4.from(match[1], "base64");
        }
        if (data[0] === 0xff && data[1] === 0xd8) return new JPEG(data, label);
        if (data[0] === 0x89 && data.toString("ascii", 1, 4) === "PNG") return new PNGImage(data, label);
        throw new Error("Unknown image format.");
    };
    return PDFImage;
}();
var ImagesMixin = {
    initImages: function initImages() {
        this._imageRegistry = {};
        this._imageCount = 0;
    },
    embedImage: function embedImage(src) {
        var image;
        if (typeof src === "string") image = this._imageRegistry[src];
        if (!image) {
            if (src.width && src.height) image = src;
            else image = this.openImage(src);
        }
        if (!image.obj) image.embed(this);
        return image;
    },
    image: function image(src, x, y, options) {
        if (options === void 0) options = {};
        var bh;
        var bp;
        var bw;
        var ip;
        var left;
        var left1;
        if (typeof x === "object") {
            options = x;
            x = null;
        }
        var image = src instanceof PDFImage ? src : this.embedImage(src);
        x = (left = x != null ? x : options.x) != null ? left : this.x;
        y = (left1 = y != null ? y : options.y) != null ? left1 : this.y;
        if (this.page.xobjects[image.label] == null) this.page.xobjects[image.label] = image.obj;
        var w = options.width || image.width;
        var h = options.height || image.height;
        if (options.width && !options.height) {
            var wp = w / image.width;
            w = image.width * wp;
            h = image.height * wp;
        } else if (options.height && !options.width) {
            var hp = h / image.height;
            w = image.width * hp;
            h = image.height * hp;
        } else if (options.scale) {
            w = image.width * options.scale;
            h = image.height * options.scale;
        } else if (options.fit) {
            var _Array$from = Array.from(options.fit);
            bw = _Array$from[0];
            bh = _Array$from[1];
            bp = bw / bh;
            ip = image.width / image.height;
            if (ip > bp) {
                w = bw;
                h = bw / ip;
            } else {
                h = bh;
                w = bh * ip;
            }
        }
        // Set the current y position to below the image if it is in the document flow
        if (this.y === y) this.y += h;
        this.save();
        this.transform(w, 0, 0, -h, x, y + h);
        this.addContent("/" + image.label + " Do");
        this.restore();
        return this;
    },
    openImage: function openImage(src) {
        var image;
        if (typeof src === "string") image = this._imageRegistry[src];
        if (!image) {
            image = PDFImage.open(src, "I" + ++this._imageCount);
            if (typeof src === "string") this._imageRegistry[src] = image;
        }
        return image;
    }
};
var AnnotationsMixin = {
    annotate: function annotate(x, y, w, h, options) {
        options.Type = "Annot";
        options.Rect = this._convertRect(x, y, w, h);
        options.Border = [
            0,
            0,
            0
        ];
        if (options.Subtype === "Link" && typeof options.F === "undefined") options.F = 4; // Print Annotation Flag
        if (options.Subtype !== "Link") {
            if (options.C == null) options.C = this._normalizeColor(options.color || [
                0,
                0,
                0
            ]);
        } // convert colors
        delete options.color;
        if (typeof options.Dest === "string") options.Dest = new String(options.Dest);
        // Capitalize keys
        for(var key in options){
            var val = options[key];
            options[key[0].toUpperCase() + key.slice(1)] = val;
        }
        var ref = this.ref(options);
        this.page.annotations.push(ref);
        ref.end();
        return this;
    },
    note: function note(x, y, w, h, contents, options) {
        if (options === void 0) options = {};
        options.Subtype = "Text";
        options.Contents = new String(contents);
        options.Name = "Comment";
        if (options.color == null) options.color = [
            243,
            223,
            92
        ];
        options.Border = [
            0,
            0,
            options.borderWidth || 0
        ];
        delete options.borderWidth;
        return this.annotate(x, y, w, h, options);
    },
    goTo: function goTo(x, y, w, h, name, options) {
        if (options === void 0) options = {};
        options.Subtype = "Link";
        options.A = this.ref({
            S: "GoTo",
            D: new String(name)
        });
        options.A.end();
        return this.annotate(x, y, w, h, options);
    },
    link: function link(x, y, w, h, url, options) {
        if (options === void 0) options = {};
        options.Subtype = "Link";
        if (typeof url === "number") {
            // Link to a page in the document (the page must already exist)
            var pages = this._root.data.Pages.data;
            if (url >= 0 && url < pages.Kids.length) {
                options.A = this.ref({
                    S: "GoTo",
                    D: [
                        pages.Kids[url],
                        "XYZ",
                        null,
                        null,
                        null
                    ]
                });
                options.A.end();
            } else throw new Error("The document has no page " + url);
        } else {
            // Link to an external url
            options.A = this.ref({
                S: "URI",
                URI: new String(url)
            });
            options.A.end();
        }
        return this.annotate(x, y, w, h, options);
    },
    _markup: function _markup(x, y, w, h, options) {
        if (options === void 0) options = {};
        var _this$_convertRect = this._convertRect(x, y, w, h), x1 = _this$_convertRect[0], y1 = _this$_convertRect[1], x2 = _this$_convertRect[2], y2 = _this$_convertRect[3];
        options.QuadPoints = [
            x1,
            y2,
            x2,
            y2,
            x1,
            y1,
            x2,
            y1
        ];
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    highlight: function highlight(x, y, w, h, options) {
        if (options === void 0) options = {};
        options.Subtype = "Highlight";
        if (options.color == null) options.color = [
            241,
            238,
            148
        ];
        return this._markup(x, y, w, h, options);
    },
    fileAnnotation: function fileAnnotation(x, y, w, h, file, options) {
        if (file === void 0) file = {};
        if (options === void 0) options = {};
        // create hidden file
        var filespec = this.file(file.src, Object.assign({
            hidden: true
        }, file));
        options.Subtype = "FileAttachment";
        options.FS = filespec;
        // add description from filespec unless description (Contents) has already been set
        if (options.Contents) options.Contents = new String(options.Contents);
        else if (filespec.data.Desc) options.Contents = filespec.data.Desc;
        return this.annotate(x, y, w, h, options);
    },
    _convertRect: function _convertRect(x1, y1, w, h) {
        // flip y1 and y2
        var y2 = y1;
        y1 += h;
        // make x2
        var x2 = x1 + w;
        // apply current transformation matrix to points
        var _this$_ctm = this._ctm, m0 = _this$_ctm[0], m1 = _this$_ctm[1], m2 = _this$_ctm[2], m3 = _this$_ctm[3], m4 = _this$_ctm[4], m5 = _this$_ctm[5];
        x1 = m0 * x1 + m2 * y1 + m4;
        y1 = m1 * x1 + m3 * y1 + m5;
        x2 = m0 * x2 + m2 * y2 + m4;
        y2 = m1 * x2 + m3 * y2 + m5;
        return [
            x1,
            y1,
            x2,
            y2
        ];
    }
};
var DEFAULT_OPTIONS = {
    top: 0,
    left: 0,
    zoom: 0,
    fit: false,
    pageNumber: null,
    expanded: false
};
var PDFOutline = /*#__PURE__*/ function() {
    function PDFOutline(document, parent, title, dest, options) {
        if (options === void 0) options = DEFAULT_OPTIONS;
        this.document = document;
        this.options = options;
        this.outlineData = {};
        if (dest !== null) {
            var destWidth = dest.data.MediaBox[2];
            var destHeight = dest.data.MediaBox[3];
            var top = destHeight - (options.top || 0);
            var left = destWidth - (options.left || 0);
            var zoom = options.zoom || 0;
            this.outlineData.Dest = options.fit ? [
                dest,
                "Fit"
            ] : [
                dest,
                "XYZ",
                left,
                top,
                zoom
            ];
        }
        if (parent !== null) this.outlineData.Parent = parent;
        if (title !== null) this.outlineData.Title = new String(title);
        this.dictionary = this.document.ref(this.outlineData);
        this.children = [];
    }
    var _proto = PDFOutline.prototype;
    _proto.addItem = function addItem(title, options) {
        if (options === void 0) options = DEFAULT_OPTIONS;
        var pages = this.document._root.data.Pages.data.Kids;
        var dest = options.pageNumber !== null ? pages[options.pageNumber] : this.document.page.dictionary;
        var result = new PDFOutline(this.document, this.dictionary, title, dest, options);
        this.children.push(result);
        return result;
    };
    _proto.endOutline = function endOutline() {
        if (this.children.length > 0) {
            if (this.options.expanded) this.outlineData.Count = this.children.length;
            var first = this.children[0];
            var last = this.children[this.children.length - 1];
            this.outlineData.First = first.dictionary;
            this.outlineData.Last = last.dictionary;
            for(var i = 0, len = this.children.length; i < len; i++){
                var child = this.children[i];
                if (i > 0) child.outlineData.Prev = this.children[i - 1].dictionary;
                if (i < this.children.length - 1) child.outlineData.Next = this.children[i + 1].dictionary;
                child.endOutline();
            }
        }
        return this.dictionary.end();
    };
    return PDFOutline;
}();
var OutlineMixin = {
    initOutline: function initOutline() {
        this.outline = new PDFOutline(this, null, null, null);
    },
    endOutline: function endOutline() {
        this.outline.endOutline();
        if (this.outline.children.length > 0) {
            this._root.data.Outlines = this.outline.dictionary;
            this._root.data.PageMode = this._root.data.PageMode || "UseOutlines";
        }
    }
};
var FIELD_FLAGS = {
    readOnly: 1,
    required: 2,
    noExport: 4,
    multiline: 0x1000,
    password: 0x2000,
    toggleToOffButton: 0x4000,
    radioButton: 0x8000,
    pushButton: 0x10000,
    combo: 0x20000,
    edit: 0x40000,
    sort: 0x80000,
    multiSelect: 0x200000,
    noSpell: 0x400000
};
var FIELD_JUSTIFY = {
    left: 0,
    center: 1,
    right: 2
};
var VALUE_MAP = {
    value: "V",
    defaultValue: "DV"
};
var FORMAT_SPECIAL = {
    zip: "0",
    zipPlus4: "1",
    zip4: "1",
    phone: "2",
    ssn: "3"
};
var FORMAT_DEFAULT = {
    number: {
        nDec: 0,
        sepComma: false,
        negStyle: "MinusBlack",
        currency: "",
        currencyPrepend: true
    },
    percent: {
        nDec: 0,
        sepComma: false
    }
};
var AcroFormMixin = {
    /**
   * Must call if adding AcroForms to a document. Must also call font() before
   * this method to set the default font.
   */ initForm: function initForm() {
        if (!this._font) throw new Error("Must set a font before calling initForm method");
        this._acroform = {
            fonts: {},
            defaultFont: this._font.name
        };
        this._acroform.fonts[this._font.id] = this._font.ref();
        var data = {
            Fields: [],
            NeedAppearances: true,
            DA: new String("/" + this._font.id + " 0 Tf 0 g"),
            DR: {
                Font: {}
            }
        };
        data.DR.Font[this._font.id] = this._font.ref();
        var AcroForm = this.ref(data);
        this._root.data.AcroForm = AcroForm;
        return this;
    },
    /**
   * Called automatically by document.js
   */ endAcroForm: function endAcroForm() {
        var _this = this;
        if (this._root.data.AcroForm) {
            if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont) throw new Error("No fonts specified for PDF form");
            var fontDict = this._root.data.AcroForm.data.DR.Font;
            Object.keys(this._acroform.fonts).forEach(function(name) {
                fontDict[name] = _this._acroform.fonts[name];
            });
            this._root.data.AcroForm.data.Fields.forEach(function(fieldRef) {
                _this._endChild(fieldRef);
            });
            this._root.data.AcroForm.end();
        }
        return this;
    },
    _endChild: function _endChild(ref) {
        var _this2 = this;
        if (Array.isArray(ref.data.Kids)) {
            ref.data.Kids.forEach(function(childRef) {
                _this2._endChild(childRef);
            });
            ref.end();
        }
        return this;
    },
    /**
   * Creates and adds a form field to the document. Form fields are intermediate
   * nodes in a PDF form that are used to specify form name heirarchy and form
   * value defaults.
   * @param {string} name - field name (T attribute in field dictionary)
   * @param {object} options  - other attributes to include in field dictionary
   */ formField: function formField(name, options) {
        if (options === void 0) options = {};
        var fieldDict = this._fieldDict(name, null, options);
        var fieldRef = this.ref(fieldDict);
        this._addToParent(fieldRef);
        return fieldRef;
    },
    /**
   * Creates and adds a Form Annotation to the document. Form annotations are
   * called Widget annotations internally within a PDF file.
   * @param {string} name - form field name (T attribute of widget annotation
   * dictionary)
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {object} options
   */ formAnnotation: function formAnnotation(name, type, x, y, w, h, options) {
        if (options === void 0) options = {};
        var fieldDict = this._fieldDict(name, type, options);
        fieldDict.Subtype = "Widget";
        if (fieldDict.F === undefined) fieldDict.F = 4; // print the annotation
        // Add Field annot to page, and get it's ref
        this.annotate(x, y, w, h, fieldDict);
        var annotRef = this.page.annotations[this.page.annotations.length - 1];
        return this._addToParent(annotRef);
    },
    formText: function formText(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "text", x, y, w, h, options);
    },
    formPushButton: function formPushButton(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "pushButton", x, y, w, h, options);
    },
    formCombo: function formCombo(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "combo", x, y, w, h, options);
    },
    formList: function formList(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "list", x, y, w, h, options);
    },
    formRadioButton: function formRadioButton(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "radioButton", x, y, w, h, options);
    },
    formCheckbox: function formCheckbox(name, x, y, w, h, options) {
        if (options === void 0) options = {};
        return this.formAnnotation(name, "checkbox", x, y, w, h, options);
    },
    _addToParent: function _addToParent(fieldRef) {
        var parent = fieldRef.data.Parent;
        if (parent) {
            if (!parent.data.Kids) parent.data.Kids = [];
            parent.data.Kids.push(fieldRef);
        } else this._root.data.AcroForm.data.Fields.push(fieldRef);
        return this;
    },
    _fieldDict: function _fieldDict(name, type, options) {
        if (options === void 0) options = {};
        if (!this._acroform) throw new Error("Call document.initForms() method before adding form elements to document");
        var opts = Object.assign({}, options);
        if (type !== null) opts = this._resolveType(type, options);
        opts = this._resolveFlags(opts);
        opts = this._resolveJustify(opts);
        opts = this._resolveFont(opts);
        opts = this._resolveStrings(opts);
        opts = this._resolveColors(opts);
        opts = this._resolveFormat(opts);
        opts.T = new String(name);
        if (opts.parent) {
            opts.Parent = opts.parent;
            delete opts.parent;
        }
        return opts;
    },
    _resolveType: function _resolveType(type, opts) {
        if (type === "text") opts.FT = "Tx";
        else if (type === "pushButton") {
            opts.FT = "Btn";
            opts.pushButton = true;
        } else if (type === "radioButton") {
            opts.FT = "Btn";
            opts.radioButton = true;
        } else if (type === "checkbox") opts.FT = "Btn";
        else if (type === "combo") {
            opts.FT = "Ch";
            opts.combo = true;
        } else if (type === "list") opts.FT = "Ch";
        else throw new Error("Invalid form annotation type '" + type + "'");
        return opts;
    },
    _resolveFormat: function _resolveFormat(opts) {
        var f = opts.format;
        if (f && f.type) {
            var fnKeystroke;
            var fnFormat;
            var params = "";
            if (FORMAT_SPECIAL[f.type] !== undefined) {
                fnKeystroke = "AFSpecial_Keystroke";
                fnFormat = "AFSpecial_Format";
                params = FORMAT_SPECIAL[f.type];
            } else {
                var format = f.type.charAt(0).toUpperCase() + f.type.slice(1);
                fnKeystroke = "AF" + format + "_Keystroke";
                fnFormat = "AF" + format + "_Format";
                if (f.type === "date") {
                    fnKeystroke += "Ex";
                    params = String(f.param);
                } else if (f.type === "time") params = String(f.param);
                else if (f.type === "number") {
                    var p = Object.assign({}, FORMAT_DEFAULT.number, f);
                    params = String([
                        String(p.nDec),
                        p.sepComma ? "0" : "1",
                        '"' + p.negStyle + '"',
                        "null",
                        '"' + p.currency + '"',
                        String(p.currencyPrepend)
                    ].join(","));
                } else if (f.type === "percent") {
                    var _p = Object.assign({}, FORMAT_DEFAULT.percent, f);
                    params = String([
                        String(_p.nDec),
                        _p.sepComma ? "0" : "1"
                    ].join(","));
                }
            }
            opts.AA = opts.AA ? opts.AA : {};
            opts.AA.K = {
                S: "JavaScript",
                JS: new String(fnKeystroke + "(" + params + ");")
            };
            opts.AA.F = {
                S: "JavaScript",
                JS: new String(fnFormat + "(" + params + ");")
            };
        }
        delete opts.format;
        return opts;
    },
    _resolveColors: function _resolveColors(opts) {
        var color = this._normalizeColor(opts.backgroundColor);
        if (color) {
            if (!opts.MK) opts.MK = {};
            opts.MK.BG = color;
        }
        color = this._normalizeColor(opts.borderColor);
        if (color) {
            if (!opts.MK) opts.MK = {};
            opts.MK.BC = color;
        }
        delete opts.backgroundColor;
        delete opts.borderColor;
        return opts;
    },
    _resolveFlags: function _resolveFlags(options) {
        var result = 0;
        Object.keys(options).forEach(function(key) {
            if (FIELD_FLAGS[key]) {
                result |= FIELD_FLAGS[key];
                delete options[key];
            }
        });
        if (result !== 0) {
            options.Ff = options.Ff ? options.Ff : 0;
            options.Ff |= result;
        }
        return options;
    },
    _resolveJustify: function _resolveJustify(options) {
        var result = 0;
        if (options.align !== undefined) {
            if (typeof FIELD_JUSTIFY[options.align] === "number") result = FIELD_JUSTIFY[options.align];
            delete options.align;
        }
        if (result !== 0) options.Q = result; // default
        return options;
    },
    _resolveFont: function _resolveFont(options) {
        // add current font to document-level AcroForm dict if necessary
        if (this._acroform.fonts[this._font.id] === null) this._acroform.fonts[this._font.id] = this._font.ref();
        // add current font to field's resource dict (RD) if not the default acroform font
        if (this._acroform.defaultFont !== this._font.name) {
            options.DR = {
                Font: {}
            };
            // Get the fontSize option. If not set use auto sizing
            var fontSize = options.fontSize || 0;
            options.DR.Font[this._font.id] = this._font.ref();
            options.DA = new String("/" + this._font.id + " " + fontSize + " Tf 0 g");
        }
        return options;
    },
    _resolveStrings: function _resolveStrings(options) {
        var select = [];
        function appendChoices(a) {
            if (Array.isArray(a)) {
                for(var idx = 0; idx < a.length; idx++)if (typeof a[idx] === "string") select.push(new String(a[idx]));
                else select.push(a[idx]);
            }
        }
        appendChoices(options.Opt);
        if (options.select) {
            appendChoices(options.select);
            delete options.select;
        }
        if (select.length) options.Opt = select;
        Object.keys(VALUE_MAP).forEach(function(key) {
            if (options[key] !== undefined) {
                options[VALUE_MAP[key]] = options[key];
                delete options[key];
            }
        });
        [
            "V",
            "DV"
        ].forEach(function(key) {
            if (typeof options[key] === "string") options[key] = new String(options[key]);
        });
        if (options.MK && options.MK.CA) options.MK.CA = new String(options.MK.CA);
        if (options.label) {
            options.MK = options.MK ? options.MK : {};
            options.MK.CA = new String(options.label);
            delete options.label;
        }
        return options;
    }
};
var AttachmentsMixin = {
    /**
   * Embed contents of `src` in PDF
   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
   * @param {object} options
   *  * options.name: filename to be shown in PDF, will use `src` if none set
   *  * options.type: filetype to be shown in PDF
   *  * options.description: description to be shown in PDF
   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
   *  * options.creationDate: override creation date
   *  * options.modifiedDate: override modified date
   * @returns filespec reference
   */ file: function file(src, options) {
        if (options === void 0) options = {};
        options.name = options.name || src;
        var refBody = {
            Type: "EmbeddedFile",
            Params: {}
        };
        var data;
        if (!src) throw new Error("No src specified");
        if (Buffer$4.isBuffer(src)) data = src;
        else if (src instanceof ArrayBuffer) data = Buffer$4.from(new Uint8Array(src));
        else {
            var match;
            if (match = /^data:(.*);base64,(.*)$/.exec(src)) {
                if (match[1]) refBody.Subtype = match[1].replace("/", "#2F");
                data = Buffer$4.from(match[2], "base64");
            } else throw new Error("Could not find file " + src);
        }
        // override creation date and modified date
        if (options.creationDate instanceof Date) refBody.Params.CreationDate = options.creationDate;
        if (options.modifiedDate instanceof Date) refBody.Params.ModDate = options.modifiedDate;
        // add optional subtype
        if (options.type) refBody.Subtype = options.type.replace("/", "#2F");
        // add checksum and size information
        var checksum = (0, _md5Default.default)(_core.lib.WordArray.create(new Uint8Array(data)));
        refBody.Params.CheckSum = new String(checksum);
        refBody.Params.Size = data.byteLength;
        // save some space when embedding the same file again
        // if a file with the same name and metadata exists, reuse its reference
        var ref;
        if (!this._fileRegistry) this._fileRegistry = {};
        var file = this._fileRegistry[options.name];
        if (file && isEqual(refBody, file)) ref = file.ref;
        else {
            ref = this.ref(refBody);
            ref.end(data);
            this._fileRegistry[options.name] = (0, _extendsDefault.default)({}, refBody, {
                ref: ref
            });
        }
        // add filespec for embedded file
        var fileSpecBody = {
            Type: "Filespec",
            F: new String(options.name),
            EF: {
                F: ref
            },
            UF: new String(options.name)
        };
        if (options.description) fileSpecBody.Desc = new String(options.description);
        var filespec = this.ref(fileSpecBody);
        filespec.end();
        if (!options.hidden) this.addNamedEmbeddedFile(options.name, filespec);
        return filespec;
    }
};
/** check two embedded file metadata objects for equality */ function isEqual(a, b) {
    return a.Subtype === b.Subtype && a.Params.CheckSum.toString() === b.Params.CheckSum.toString() && a.Params.Size === b.Params.Size && a.Params.CreationDate === b.Params.CreationDate && a.Params.ModDate === b.Params.ModDate;
}
var capitalize = function capitalize(v) {
    return v[0].toUpperCase() + v.slice(1);
};
var PDFDocument = /*#__PURE__*/ function(_stream$Readable) {
    (0, _inheritsLooseDefault.default)(PDFDocument, _stream$Readable);
    function PDFDocument(options) {
        var _this;
        if (options === void 0) options = {};
        _this = _stream$Readable.call(this) || this;
        _this.options = options;
        // PDF version
        switch(options.pdfVersion){
            case "1.4":
                _this.version = 1.4;
                break;
            case "1.5":
                _this.version = 1.5;
                break;
            case "1.6":
                _this.version = 1.6;
                break;
            case "1.7":
            case "1.7ext3":
                _this.version = 1.7;
                break;
            default:
                _this.version = 1.3;
                break;
        }
        // Whether streams should be compressed
        _this.compress = _this.options.compress != null ? _this.options.compress : true;
        _this._pageBuffer = [];
        _this._pageBufferStart = 0;
        // The PDF object store
        _this._offsets = [];
        _this._waiting = 0;
        _this._ended = false;
        _this._offset = 0;
        var Pages = _this.ref({
            Type: "Pages",
            Count: 0,
            Kids: []
        });
        var Names = _this.ref({
            Dests: new PDFNameTree()
        });
        _this._root = _this.ref({
            Type: "Catalog",
            Pages: Pages,
            Names: Names
        });
        if (_this.options.lang) _this._root.data.Lang = new String(_this.options.lang);
        if (_this.options.pageLayout) _this._root.data.PageLayout = capitalize(_this.options.pageLayout);
        if (_this.options.pageMode) _this._root.data.PageMode = capitalize(_this.options.pageMode);
        // The current page
        _this.page = null;
        // Initialize mixins
        _this.initColor();
        _this.initVector();
        _this.initFonts();
        _this.initText();
        _this.initImages();
        _this.initOutline();
        // this.initMarkings(options)
        // Initialize the metadata
        _this.info = {
            Producer: "PDFKit",
            Creator: "PDFKit",
            CreationDate: new Date()
        };
        if (_this.options.info) for(var key in _this.options.info){
            var val = _this.options.info[key];
            _this.info[key] = val;
        }
        if (_this.options.displayTitle) _this._root.data.ViewerPreferences = _this.ref({
            DisplayDocTitle: true
        });
        // Generate file ID
        _this._id = PDFSecurity.generateFileID(_this.info);
        // Initialize security settings
        // this._security = PDFSecurity.create(this, options);
        // Write the header PDF version
        _this._write("%PDF-" + _this.version);
        // 4 binary chars, as recommended by the spec
        _this._write("%\xff\xff\xff\xff");
        // Add the first page
        if (_this.options.autoFirstPage !== false) _this.addPage();
        return _this;
    }
    var _proto = PDFDocument.prototype;
    _proto.addPage = function addPage(options) {
        // end the current page if needed
        if (options == null) options = this.options;
        // end the current page if needed
        if (!this.options.bufferPages) this.flushPages();
        // create a page object
        this.page = new PDFPage(this, options);
        this._pageBuffer.push(this.page);
        // add the page to the object store
        var pages = this._root.data.Pages.data;
        pages.Kids.push(this.page.dictionary);
        pages.Count++;
        // flip PDF coordinate system so that the origin is in
        // the top left rather than the bottom left
        this._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        this.transform(1, 0, 0, -1, 0, this.page.height);
        // this.emit('pageAdded');
        return this;
    };
    _proto.flushPages = function flushPages() {
        // this local variable exists so we're future-proof against
        // reentrant calls to flushPages.
        var pages = this._pageBuffer;
        this._pageBuffer = [];
        this._pageBufferStart += pages.length;
        for(var _i = 0, _Array$from = Array.from(pages); _i < _Array$from.length; _i++){
            var page = _Array$from[_i];
            // this.endPageMarkings(page);
            page.end();
        }
    };
    _proto.addNamedDestination = function addNamedDestination(name) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (args.length === 0) args = [
            "XYZ",
            null,
            null,
            null
        ];
        if (args[0] === "XYZ" && args[2] !== null) args[2] = this.page.height - args[2];
        args.unshift(this.page.dictionary);
        this._root.data.Names.data.Dests.add(name, args);
    };
    _proto.addNamedEmbeddedFile = function addNamedEmbeddedFile(name, ref) {
        if (!this._root.data.Names.data.EmbeddedFiles) // disabling /Limits for this tree fixes attachments not showing in Adobe Reader
        this._root.data.Names.data.EmbeddedFiles = new PDFNameTree({
            limits: false
        });
        // add filespec to EmbeddedFiles
        this._root.data.Names.data.EmbeddedFiles.add(name, ref);
    };
    _proto.addNamedJavaScript = function addNamedJavaScript(name, js) {
        if (!this._root.data.Names.data.JavaScript) this._root.data.Names.data.JavaScript = new PDFNameTree();
        var data = {
            JS: new String(js),
            S: "JavaScript"
        };
        this._root.data.Names.data.JavaScript.add(name, data);
    };
    _proto.ref = function ref(data) {
        var ref = new PDFReference(this, this._offsets.length + 1, data);
        this._offsets.push(null); // placeholder for this object's offset once it is finalized
        this._waiting++;
        return ref;
    };
    _proto._read = function _read() {
    // do nothing, but this method is required by node
    };
    _proto._write = function _write(data) {
        if (!Buffer$4.isBuffer(data)) data = Buffer$4.from(data + "\n", "binary");
        this.push(data);
        return this._offset += data.length;
    };
    _proto.addContent = function addContent(data) {
        this.page.write(data);
        return this;
    };
    _proto._refEnd = function _refEnd(ref) {
        this._offsets[ref.id - 1] = ref.offset;
        if (--this._waiting === 0 && this._ended) {
            this._finalize();
            return this._ended = false;
        }
    };
    _proto.end = function end() {
        this.flushPages();
        this._info = this.ref();
        for(var key in this.info){
            var val = this.info[key];
            if (typeof val === "string") val = new String(val);
            var entry = this.ref(val);
            entry.end();
            this._info.data[key] = entry;
        }
        this._info.end();
        for(var name in this._fontFamilies){
            var font = this._fontFamilies[name];
            font.finalize();
        }
        this.endOutline();
        // this.endMarkings();
        this._root.end();
        this._root.data.Pages.end();
        this._root.data.Names.end();
        this.endAcroForm();
        if (this._root.data.ViewerPreferences) this._root.data.ViewerPreferences.end();
        // if (this._security) {
        //   this._security.end();
        // }
        if (this._waiting === 0) return this._finalize();
        this._ended = true;
    };
    _proto._finalize = function _finalize() {
        // generate xref
        var xRefOffset = this._offset;
        this._write("xref");
        this._write("0 " + (this._offsets.length + 1));
        this._write("0000000000 65535 f ");
        for(var _i2 = 0, _Array$from2 = Array.from(this._offsets); _i2 < _Array$from2.length; _i2++){
            var offset = _Array$from2[_i2];
            offset = ("0000000000" + offset).slice(-10);
            this._write(offset + " 00000 n ");
        }
        // trailer
        var trailer = {
            Size: this._offsets.length + 1,
            Root: this._root,
            Info: this._info,
            ID: [
                this._id,
                this._id
            ]
        };
        // if (this._security) {
        //   trailer.Encrypt = this._security.dictionary;
        // }
        this._write("trailer");
        this._write(PDFObject$1.convert(trailer));
        this._write("startxref");
        this._write("" + xRefOffset);
        this._write("%%EOF");
        // end the stream
        return this.push(null);
    };
    _proto.toString = function toString() {
        return "[object PDFDocument]";
    };
    return PDFDocument;
}(stream.Readable);
var mixin = function mixin(methods) {
    Object.assign(PDFDocument.prototype, methods);
};
// Load mixins
mixin(ColorMixin);
mixin(VectorMixin);
mixin(FontsMixin);
mixin(TextMixin);
mixin(ImagesMixin);
mixin(AnnotationsMixin);
mixin(OutlineMixin);
// mixin(MarkingsMixin);
mixin(AcroFormMixin);
mixin(AttachmentsMixin);

},{"@babel/runtime/helpers/inheritsLoose":"109Zb","@babel/runtime/helpers/assertThisInitialized":"4ATMB","pako/lib/zlib/zstream":"1l8oC","pako/lib/zlib/deflate.js":"2FWfV","pako/lib/zlib/inflate.js":"74516","pako/lib/zlib/constants":"9y6mc","@babel/runtime/helpers/createForOfIteratorHelperLoose":"2Q0sa","@babel/runtime/helpers/createClass":"9Lv34","crypto-js/md5":"haQyg","fontkit":"58VtG","@react-pdf/png-js":"3TRo0","@babel/runtime/helpers/extends":"jbPGs","crypto-js/core":"dKTGa","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"109Zb":[function(require,module,exports) {
var setPrototypeOf = require("56507d829b6b7d3d");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    setPrototypeOf(subClass, superClass);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"56507d829b6b7d3d":"b5GbO"}],"b5GbO":[function(require,module,exports) {
function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4ATMB":[function(require,module,exports) {
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"1l8oC":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = ZStream;

},{}],"2FWfV":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("6ecd050ab5cf9e92");
var trees = require("b17b4660c9a756a1");
var adler32 = require("8a0173ce93724f81");
var crc32 = require("9fe740ea87b93669");
var msg = require("86729d90d4373c72");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;
var Z_FILTERED = 1;
var Z_HUFFMAN_ONLY = 2;
var Z_RLE = 3;
var Z_FIXED = 4;
var Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/* The deflate compression method */ var Z_DEFLATED = 8;
/*============================================================================*/ var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
var PRESET_DICT = 0x20;
var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;
var BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var BS_BLOCK_DONE = 2; /* block flush performed */ 
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function err(strm, errorCode) {
    strm.msg = msg[errorCode];
    return errorCode;
}
function rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function flush_block_only(s, last) {
    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    flush_pending(s.strm);
}
function put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    utils.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
        if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                if (s.strm.avail_out === 0) return BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var configuration_table;
configuration_table = [
    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
    s.good_match = configuration_table[s.level].good_length;
    s.nice_match = configuration_table[s.level].nice_length;
    s.max_chain_length = configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
    this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
    this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
    zero(this.dyn_ltree);
    zero(this.dyn_dtree);
    zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new utils.Buf16(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
    zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
    zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = Z_NO_FLUSH;
    trees._tr_init(s);
    return Z_OK;
}
function deflateReset(strm) {
    var ret = deflateResetKeep(strm);
    if (ret === Z_OK) lm_init(strm.state);
    return ret;
}
function deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return Z_OK;
}
function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return Z_STREAM_ERROR;
    var wrap = 1;
    if (level === Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    s.window = new utils.Buf8(s.w_size * 2);
    s.head = new utils.Buf16(s.hash_size);
    s.prev = new utils.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new utils.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return deflateReset(strm);
}
function deflateInit(strm, level) {
    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}
function deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, OS_CODE);
                s.status = BUSY_STATE;
            } else {
                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                put_byte(s, s.gzhead.time & 0xff);
                put_byte(s, s.gzhead.time >> 8 & 0xff);
                put_byte(s, s.gzhead.time >> 16 & 0xff);
                put_byte(s, s.gzhead.time >> 24 & 0xff);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    put_byte(s, s.gzhead.extra.length & 0xff);
                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = EXTRA_STATE;
            }
        } else {
            var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= PRESET_DICT;
            header += 31 - header % 31;
            s.status = BUSY_STATE;
            putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = NAME_STATE;
            }
        } else s.status = NAME_STATE;
    }
    if (s.status === NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = COMMENT_STATE;
            }
        } else s.status = COMMENT_STATE;
    }
    if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = HCRC_STATE;
        } else s.status = HCRC_STATE;
    }
    if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = BUSY_STATE;
            }
        } else s.status = BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
            else if (flush !== Z_BLOCK) {
                trees._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== Z_FINISH) return Z_OK;
    if (s.wrap <= 0) return Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        put_byte(s, strm.adler >> 16 & 0xff);
        put_byte(s, strm.adler >> 24 & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, strm.total_in >> 8 & 0xff);
        put_byte(s, strm.total_in >> 16 & 0xff);
        put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
    }
    flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}
function deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR);
    strm.state = null;
    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new utils.Buf8(s.w_size);
        utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    fill_window(s);
    while(s.lookahead >= MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - (MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return Z_OK;
}
exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

},{"6ecd050ab5cf9e92":"kQZxD","b17b4660c9a756a1":"lCaRq","8a0173ce93724f81":"FnOMW","9fe740ea87b93669":"5qm9i","86729d90d4373c72":"fnCyK"}],"kQZxD":[function(require,module,exports) {
"use strict";
var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function _has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if (_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function(on) {
    if (on) {
        exports.Buf8 = Uint8Array;
        exports.Buf16 = Uint16Array;
        exports.Buf32 = Int32Array;
        exports.assign(exports, fnTyped);
    } else {
        exports.Buf8 = Array;
        exports.Buf16 = Array;
        exports.Buf32 = Array;
        exports.assign(exports, fnUntyped);
    }
};
exports.setTyped(TYPED_OK);

},{}],"lCaRq":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ var utils = require("f7e73d4e313a2bb7");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
var Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/*============================================================================*/ function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES = 2;
/* The three kinds of block type */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
/* end of block literal code */ var REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var static_l_desc;
var static_d_desc;
var static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function d_code(dist) {
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
    if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function send_code(s, c, tree) {
    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
    if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < LENGTH_CODES - 1; code++){
        base_length[code] = length;
        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        base_dist[code] = dist;
        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < D_CODES; code++){
        base_dist[code] = dist << 7;
        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES; n++){
        static_dtree[n * 2 + 1] = 5;
        static_dtree[n * 2] = bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
    if (s.bi_valid > 8) put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    bi_windup(s); /* align on byte boundary */ 
    if (header) {
        put_short(s, len);
        put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
            send_code(s, code + LITERALS + 1, ltree); /* send the length code */ 
            extra = extra_lbits[code];
            if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            send_code(s, code, dtree); /* send the distance code */ 
            extra = extra_dbits[code];
            if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    send_code(s, END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
        else s.bl_tree[REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
        } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    send_bits(s, dcodes - 1, 5);
    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
    for(n = 32; n < LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
}
var static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
    if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
    }
    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
    send_bits(s, STATIC_TREES << 1, 3);
    send_code(s, END_BLOCK, static_ltree);
    bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
    } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
    if (last) bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
        s.dyn_dtree[d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
exports._tr_init = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"f7e73d4e313a2bb7":"kQZxD"}],"FnOMW":[function(require,module,exports) {
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = adler32;

},{}],"5qm9i":[function(require,module,exports) {
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();
function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = crc32;

},{}],"fnCyK":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};

},{}],"74516":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("3693fcbb98dc8df0");
var adler32 = require("6ebe24dff7c86ec6");
var crc32 = require("733ae5de3dad536a");
var inflate_fast = require("d6c5d4935fa23026");
var inflate_table = require("f4fe87fcccdc3597");
var CODES = 0;
var LENS = 1;
var DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
var Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
var Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
var Z_MEM_ERROR = -4;
var Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1; /* i: waiting for magic header */ 
var FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var TIME = 3; /* i: waiting for modification time (gzip) */ 
var OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var NAME = 7; /* i: waiting for end of file name (gzip) */ 
var COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var HCRC = 9; /* i: waiting for header crc (gzip) */ 
var DICTID = 10; /* i: waiting for dictionary check value */ 
var DICT = 11; /* waiting for inflateSetDictionary() call */ 
var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var STORED = 14; /* i: waiting for stored size (length and complement) */ 
var COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var LENLENS = 18; /* i: waiting for code length code lengths */ 
var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var LEN = 21; /* i: waiting for length/lit/eob code */ 
var LENEXT = 22; /* i: waiting for length extra bits */ 
var DIST = 23; /* i: waiting for distance code */ 
var DISTEXT = 24; /* i: waiting for distance extra bits */ 
var MATCH = 25; /* o: waiting for output space to copy string */ 
var LIT = 26; /* o: waiting for output space to write literal */ 
var CHECK = 27; /* i: waiting for 32-bit check value */ 
var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var DONE = 29; /* finished check, done -- remain here until reset */ 
var BAD = 30; /* got a data error -- remain here until reset */ 
var MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
function zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new utils.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new utils.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return Z_OK;
}
function inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return inflateResetKeep(strm);
}
function inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return inflateReset(strm);
}
function inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = inflateReset2(strm, windowBits);
    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function inflateInit(strm) {
    return inflateInit2(strm, DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
var lenfix, distfix; // We have no pointers in JS, so keep tables separate
function fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
        var sym;
        lenfix = new utils.Buf32(512);
        distfix = new utils.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ virgin = false;
    }
    state.lencode = lenfix;
    state.lenbits = 9;
    state.distcode = distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new utils.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        utils.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === TYPE) state.mode = TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case HEAD:
            if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = BAD;
                break;
            }
            if ((hold & 0x0f) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? DICTID : TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = TIME;
        /* falls through */ case TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = OS;
        /* falls through */ case OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = EXLEN;
        /* falls through */ case EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = EXTRA;
        /* falls through */ case EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = NAME;
        /* falls through */ case NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = COMMENT;
        /* falls through */ case COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = HCRC;
        /* falls through */ case HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = TYPE;
            break;
        case DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = DICT;
        /* falls through */ case DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = TYPE;
        /* falls through */ case TYPE:
            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
        /* falls through */ case TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = STORED;
                    break;
                case 1:
                    /* fixed block */ fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = LEN_; /* decode codes */ 
                    if (flush === Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = COPY_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case COPY_:
            state.mode = COPY;
        /* falls through */ case COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                utils.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = TYPE;
            break;
        case TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = LENLENS;
        /* falls through */ case LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = CODELENS;
        /* falls through */ case CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = LEN_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case LEN_:
            state.mode = LEN;
        /* falls through */ case LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = LENEXT;
        /* falls through */ case LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = DIST;
        /* falls through */ case DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = DISTEXT;
        /* falls through */ case DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = MATCH;
        /* falls through */ case MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = LEN;
            break;
        case LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = LEN;
            break;
        case CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = LENGTH;
        /* falls through */ case LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = DONE;
        /* falls through */ case DONE:
            ret = Z_STREAM_END;
            break inf_leave;
        case BAD:
            ret = Z_DATA_ERROR;
            break inf_leave;
        case MEM:
            return Z_MEM_ERROR;
        case SYNC:
        /* falls through */ default:
            return Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = MEM;
            return Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
    return ret;
}
function inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return Z_OK;
}
function inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return Z_OK;
}
function inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = MEM;
        return Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return Z_OK;
}
exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

},{"3693fcbb98dc8df0":"kQZxD","6ebe24dff7c86ec6":"FnOMW","733ae5de3dad536a":"5qm9i","d6c5d4935fa23026":"kATLQ","f4fe87fcccdc3597":"gXHOZ"}],"kATLQ":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var BAD = 30; /* got a data error -- remain here until reset */ 
var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

},{}],"gXHOZ":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("11b3fa99ba8f3902");
var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var CODES = 0;
var LENS = 1;
var DISTS = 2;
var lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === LENS) {
        base = lbase;
        base_index -= 257;
        extra = lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = dbase;
        extra = dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

},{"11b3fa99ba8f3902":"kQZxD"}],"9y6mc":[function(require,module,exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

},{}],"2Q0sa":[function(require,module,exports) {
var unsupportedIterableToArray = require("750ca7ff73b0b6ce");
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _createForOfIteratorHelperLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"750ca7ff73b0b6ce":"bKVuP"}],"bKVuP":[function(require,module,exports) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"9fSdk"}],"9fSdk":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"9Lv34":[function(require,module,exports) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"cKD2g"}],"cKD2g":[function(require,module,exports) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function _toPropertyKey(arg) {
    var key = toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"7gkxm","2713647ce51d8c75":"cwJ9i"}],"cwJ9i":[function(require,module,exports) {
var _typeof = require("e0211298897b2d31")["default"];
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"7gkxm"}],"haQyg":[function(require,module,exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory(require("df297d5f1a7605f5"));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

},{"df297d5f1a7605f5":"dKTGa"}],"dKTGa":[function(require,module,exports) {
var global = arguments[3];
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof global !== "undefined" && global.crypto) crypto = global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = require("b7760e5f0b7216d4");
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

},{"b7760e5f0b7216d4":"7mGSR"}],"7mGSR":[function(require,module,exports) {
"use strict";

},{}],"3TRo0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PNG);
var global = arguments[3];
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var lookup$1 = [];
var revLookup$1 = [];
var Arr$1 = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var inited = false;
function init() {
    inited = true;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup$1[i] = code[i];
        revLookup$1[code.charCodeAt(i)] = i;
    }
    revLookup$1["-".charCodeAt(0)] = 62;
    revLookup$1["_".charCodeAt(0)] = 63;
}
function toByteArray$1(b64) {
    if (!inited) init();
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === "=" ? 2 : b64[len - 1] === "=" ? 1 : 0;
    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr$1(len * 3 / 4 - placeHolders);
    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;
    for(i = 0, j = 0; i < l; i += 4, j += 3){
        tmp = revLookup$1[b64.charCodeAt(i)] << 18 | revLookup$1[b64.charCodeAt(i + 1)] << 12 | revLookup$1[b64.charCodeAt(i + 2)] << 6 | revLookup$1[b64.charCodeAt(i + 3)];
        arr[L++] = tmp >> 16 & 0xFF;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    if (placeHolders === 2) {
        tmp = revLookup$1[b64.charCodeAt(i)] << 2 | revLookup$1[b64.charCodeAt(i + 1)] >> 4;
        arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
        tmp = revLookup$1[b64.charCodeAt(i)] << 10 | revLookup$1[b64.charCodeAt(i + 1)] << 4 | revLookup$1[b64.charCodeAt(i + 2)] >> 2;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64$1(num) {
    return lookup$1[num >> 18 & 0x3F] + lookup$1[num >> 12 & 0x3F] + lookup$1[num >> 6 & 0x3F] + lookup$1[num & 0x3F];
}
function encodeChunk$1(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
        output.push(tripletToBase64$1(tmp));
    }
    return output.join("");
}
function fromByteArray$1(uint8) {
    if (!inited) init();
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = "";
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk$1(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup$1[tmp >> 2];
        output += lookup$1[tmp << 4 & 0x3F];
        output += "==";
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        output += lookup$1[tmp >> 10];
        output += lookup$1[tmp >> 4 & 0x3F];
        output += lookup$1[tmp << 2 & 0x3F];
        output += "=";
    }
    parts.push(output);
    return parts.join("");
}
function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
}
var toString$1 = {}.toString;
var isArray = Array.isArray || function(arr) {
    return toString$1.call(arr) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ var INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer$1.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined ? global$1.TYPED_ARRAY_SUPPORT : true;
function kMaxLength() {
    return Buffer$1.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer$1.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer$1(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer$1(arg, encodingOrOffset, length) {
    if (!Buffer$1.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer$1)) return new Buffer$1(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer$1.poolSize = 8192; // not used by this implementation
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer$1._augment = function(arr) {
    arr.__proto__ = Buffer$1.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer$1.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer$1.TYPED_ARRAY_SUPPORT) {
    Buffer$1.prototype.__proto__ = Uint8Array.prototype;
    Buffer$1.__proto__ = Uint8Array;
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer$1.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer$1.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer$1.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer$1.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer$1.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength$1(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer$1.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (internalIsBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
Buffer$1.isBuffer = isBuffer;
function internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
}
Buffer$1.compare = function compare(a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer$1.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer$1.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer$1.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer$1.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!internalIsBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength$1(string, encoding) {
    if (internalIsBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer$1.byteLength = byteLength$1;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer$1.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer$1.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer$1.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer$1.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer$1.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer$1.prototype.equals = function equals(b) {
    if (!internalIsBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer$1.compare(this, b) === 0;
};
Buffer$1.prototype.inspect = function inspect() {
    var str = "";
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer$1.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer$1.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer$1.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer$1.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer$1.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer$1.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer$1.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer$1.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return fromByteArray$1(buf);
    else return fromByteArray$1(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer$1.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer$1.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer$1(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer$1.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer$1.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer$1.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer$1.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer$1.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer$1.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer$1.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer$1.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer$1.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer$1.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer$1.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer$1.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer$1.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer$1.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer$1.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4);
};
Buffer$1.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4);
};
Buffer$1.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8);
};
Buffer$1.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer$1.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer$1.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer$1.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer$1.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer$1.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer$1.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer$1.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer$1.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer$1.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer$1.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer$1.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer$1.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer$1.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer$1.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer$1.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer$1.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4);
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer$1.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer$1.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8);
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer$1.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer$1.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer$1.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer$1.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer$1.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer$1.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer$1(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return toByteArray$1(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}
// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
}
function isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isFastBuffer(obj.slice(0, 0));
}
// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js
function defaultSetTimout$1() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout$1() {
    throw new Error("clearTimeout has not been defined");
}
var cachedSetTimeout$1 = defaultSetTimout$1;
var cachedClearTimeout$1 = defaultClearTimeout$1;
if (typeof global$1.setTimeout === "function") cachedSetTimeout$1 = setTimeout;
if (typeof global$1.clearTimeout === "function") cachedClearTimeout$1 = clearTimeout;
function runTimeout$1(fun) {
    if (cachedSetTimeout$1 === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout$1 === defaultSetTimout$1 || !cachedSetTimeout$1) && setTimeout) {
        cachedSetTimeout$1 = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout$1(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout$1.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout$1.call(this, fun, 0);
        }
    }
}
function runClearTimeout$1(marker) {
    if (cachedClearTimeout$1 === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout$1 === defaultClearTimeout$1 || !cachedClearTimeout$1) && clearTimeout) {
        cachedClearTimeout$1 = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout$1(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout$1.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout$1.call(this, marker);
        }
    }
}
var queue$1 = [];
var draining$1 = false;
var currentQueue$1;
var queueIndex$1 = -1;
function cleanUpNextTick$1() {
    if (!draining$1 || !currentQueue$1) return;
    draining$1 = false;
    if (currentQueue$1.length) queue$1 = currentQueue$1.concat(queue$1);
    else queueIndex$1 = -1;
    if (queue$1.length) drainQueue$1();
}
function drainQueue$1() {
    if (draining$1) return;
    var timeout = runTimeout$1(cleanUpNextTick$1);
    draining$1 = true;
    var len = queue$1.length;
    while(len){
        currentQueue$1 = queue$1;
        queue$1 = [];
        while(++queueIndex$1 < len)if (currentQueue$1) currentQueue$1[queueIndex$1].run();
        queueIndex$1 = -1;
        len = queue$1.length;
    }
    currentQueue$1 = null;
    draining$1 = false;
    runClearTimeout$1(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue$1.push(new Item$1(fun, args));
    if (queue$1.length === 1 && !draining$1) runTimeout$1(drainQueue$1);
}
// v8 likes predictible objects
function Item$1(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item$1.prototype.run = function() {
    this.fun.apply(null, this.array);
};
var title = "browser";
var platform = "browser";
var browser$1 = true;
var env = {};
var argv = [];
var version = ""; // empty string to avoid regexp issues
var versions = {};
var release = {};
var config = {};
function noop$1() {}
var on = noop$1;
var addListener = noop$1;
var once$1 = noop$1;
var off = noop$1;
var removeListener = noop$1;
var removeAllListeners = noop$1;
var emit = noop$1;
function binding$1(name) {
    throw new Error("process.binding is not supported");
}
function cwd() {
    return "/";
}
function chdir(dir) {
    throw new Error("process.chdir is not supported");
}
function umask() {
    return 0;
}
// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function() {
    return new Date().getTime();
};
// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp) {
    var clocktime = performanceNow.call(performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds < 0) {
            seconds--;
            nanoseconds += 1e9;
        }
    }
    return [
        seconds,
        nanoseconds
    ];
}
var startTime = new Date();
function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1000;
}
var browser$1$1 = {
    nextTick: nextTick,
    title: title,
    browser: browser$1,
    env: env,
    argv: argv,
    version: version,
    versions: versions,
    on: on,
    addListener: addListener,
    once: once$1,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding$1,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config,
    uptime: uptime
};
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
var lib = {};
var buffer = {};
var base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
} // Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
     // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
} // base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
     // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ ieee754.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
ieee754.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ (function(exports) {
    var base64 = base64Js;
    var ieee754$1 = ieee754;
    var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
     ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
     : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Print warning and recommend using `buffer` v4.x which has an Object
   *               implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * We report that the browser does not support typed arrays if the are not subclassable
   * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
   * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
   * for __proto__ and has a buggy typed array implementation.
   */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            var arr = new Uint8Array(1);
            var proto = {
                foo: function foo() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, Uint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, "parent", {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, "offset", {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
         // Return an augmented `Uint8Array` instance
        var buf = new Uint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === "number") {
            if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === "string") return fromString(value, encodingOrOffset);
        if (ArrayBuffer.isView(value)) return fromArrayView(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
        var valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        var b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    }; // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer, Uint8Array);
    function assertSize(size) {
        if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpreted as a start offset.
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
        if (!Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        var length = byteLength(string, encoding) | 0;
        var buf = createBuffer(length);
        var actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        var length = array.length < 0 ? 0 : checked(array.length) | 0;
        var buf = createBuffer(length);
        for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayView(arrayView) {
        if (isInstance(arrayView, Uint8Array)) {
            var copy = new Uint8Array(arrayView);
            return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
        }
        return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        var buf;
        if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
        else if (length === undefined) buf = new Uint8Array(array, byteOffset);
        else buf = new Uint8Array(array, byteOffset, length);
         // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            var len = checked(obj.length) | 0;
            var buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== "number" || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === "Buffer" && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) // eslint-disable-line eqeqeq
        length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        var i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        var buffer = Buffer.allocUnsafe(length);
        var pos = 0;
        for(i = 0; i < list.length; ++i){
            var buf = list[i];
            if (isInstance(buf, Uint8Array)) {
                if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
                else Uint8Array.prototype.set.call(buffer, buf, pos);
            } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            else buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
        if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
        var len = string.length;
        var mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0; // Use a for loop to avoid recursion
        var loweredCase = false;
        for(;;)switch(encoding){
            case "ascii":
            case "latin1":
            case "binary":
                return len;
            case "utf8":
            case "utf-8":
                return utf8ToBytes(string).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return len * 2;
            case "hex":
                return len >>> 1;
            case "base64":
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        var loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
         // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return "";
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return "";
         // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return "";
        if (!encoding) encoding = "utf8";
        while(true)switch(encoding){
            case "hex":
                return hexSlice(this, start, end);
            case "utf8":
            case "utf-8":
                return utf8Slice(this, start, end);
            case "ascii":
                return asciiSlice(this, start, end);
            case "latin1":
            case "binary":
                return latin1Slice(this, start, end);
            case "base64":
                return base64Slice(this, start, end);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = (encoding + "").toLowerCase();
                loweredCase = true;
        }
    } // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        var i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        var len = this.length;
        if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        var len = this.length;
        if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for(var i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        var len = this.length;
        if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for(var i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        var length = this.length;
        if (length === 0) return "";
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        var str = "";
        var max = exports.INSPECT_MAX_BYTES;
        str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
        if (this.length > max) str += " ... ";
        return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        var x = thisEnd - thisStart;
        var y = end - start;
        var len = Math.min(x, y);
        var thisCopy = this.slice(thisStart, thisEnd);
        var targetCopy = target.slice(start, end);
        for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    }; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1; // Normalize byteOffset
        if (typeof byteOffset === "string") {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
         // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        } // Normalize val
        if (typeof val === "string") val = Buffer.from(val, encoding);
         // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === "number") {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof Uint8Array.prototype.indexOf === "function") {
                if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        var indexSize = 1;
        var arrLength = arr.length;
        var valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        var i;
        if (dir) {
            var foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                var found = true;
                for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        var remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        var strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        for(var i = 0; i < length; ++i){
            var parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = "utf8";
            length = this.length;
            offset = 0; // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === "string") {
            encoding = offset;
            length = this.length;
            offset = 0; // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = "utf8";
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        var remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        if (!encoding) encoding = "utf8";
        var loweredCase = false;
        for(;;)switch(encoding){
            case "hex":
                return hexWrite(this, string, offset, length);
            case "utf8":
            case "utf-8":
                return utf8Write(this, string, offset, length);
            case "ascii":
            case "latin1":
            case "binary":
                return asciiWrite(this, string, offset, length);
            case "base64":
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
                encoding = ("" + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
        else return base64.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        var res = [];
        var i = start;
        while(i < end){
            var firstByte = buf[i];
            var codePoint = null;
            var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                var secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    } // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        var len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
         // Decode in chunks to avoid "call stack size exceeded".
        var res = "";
        var i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        var ret = "";
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        var ret = "";
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        var len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        var out = "";
        for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        var bytes = buf.slice(start, end);
        var res = ""; // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
        for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        var len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        var newBuf = this.subarray(start, end); // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
        if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset + --byteLength];
        var mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var i = byteLength;
        var mul = 1;
        var val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return ieee754$1.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return ieee754$1.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
    }
    Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var mul = 1;
        var i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var i = byteLength - 1;
        var mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = 0;
        var mul = 1;
        var sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = byteLength - 1;
        var mul = 1;
        var sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError("Index out of range");
        if (offset < 0) throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    }; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions
        if (targetStart < 0) throw new RangeError("targetStart out of bounds");
        if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
        if (end < 0) throw new RangeError("sourceEnd out of bounds"); // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        var len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    }; // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === "string") {
            if (typeof start === "string") {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === "string") {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
            if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
            if (val.length === 1) {
                var code = val.charCodeAt(0);
                if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === "number") val = val & 255;
        else if (typeof val === "boolean") val = Number(val);
         // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        var i;
        if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
        else {
            var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            var len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    }; // HELPER FUNCTIONS
    // ================
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split("=")[0]; // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, ""); // Node converts strings with length < 2 to ''
        if (str.length < 2) return ""; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + "=";
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        var codePoint;
        var length = string.length;
        var leadSurrogate = null;
        var bytes = [];
        for(var i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i); // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } // valid lead
                    leadSurrogate = codePoint;
                    continue;
                } // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                } // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null; // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error("Invalid code point");
        }
        return bytes;
    }
    function asciiToBytes(str) {
        var byteArray = [];
        for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        var c, hi, lo;
        var byteArray = [];
        for(var i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        for(var i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    } // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj; // eslint-disable-line no-self-compare
    } // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    var hexSliceLookupTable = function() {
        var alphabet = "0123456789abcdef";
        var table = new Array(256);
        for(var i = 0; i < 16; ++i){
            var i16 = i * 16;
            for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
})(buffer);
var events = {
    exports: {}
};
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once; // Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function get() {
        return defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
}; // Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false; // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
         // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ]; // If we've already got an array, just append.
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
         // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true; // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
}; // Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this; // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    } // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return listenerCount$1.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount$1;
function listenerCount$1(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}
var EE = events.exports;
var util$1 = {};
var types = {};
/* eslint complexity: [2, 18], max-statements: [2, 33] */ var shams$1 = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
     // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams$1;
var hasSymbols$3 = function hasNativeSymbols() {
    if (typeof origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return hasSymbolSham();
};
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice$1 = Array.prototype.slice;
var toStr$4 = Object.prototype.toString;
var funcType = "[object Function]";
var implementation$8 = function bind(that) {
    var target = this;
    if (typeof target !== "function" || toStr$4.call(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slice$1.call(arguments, 1);
    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat(slice$1.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat(slice$1.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};
var implementation$7 = implementation$8;
var functionBind = Function.prototype.bind || implementation$7;
var bind$1 = functionBind;
var src = bind$1.call(Function.call, Object.prototype.hasOwnProperty);
var undefined$1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError; // eslint-disable-next-line consistent-return
var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) try {
    $gOPD$1({}, "");
} catch (e) {
    $gOPD$1 = null; // this is IE 8, which has a broken gOPD
}
var throwTypeError = function throwTypeError() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD$1 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD$1(arguments, "callee").get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols$2 = hasSymbols$3();
var getProto$1 = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" ? undefined$1 : getProto$1(Uint8Array);
var INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
    "%ArrayIteratorPrototype%": hasSymbols$2 ? getProto$1([][Symbol.iterator]()) : undefined$1,
    "%AsyncFromSyncIteratorPrototype%": undefined$1,
    "%AsyncFunction%": needsEval,
    "%AsyncGenerator%": needsEval,
    "%AsyncGeneratorFunction%": needsEval,
    "%AsyncIteratorPrototype%": needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
    "%Function%": $Function,
    "%GeneratorFunction%": needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": hasSymbols$2 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
    "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
    "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols$2 ? undefined$1 : getProto$1(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols$2 ? undefined$1 : getProto$1(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": hasSymbols$2 ? getProto$1(""[Symbol.iterator]()) : undefined$1,
    "%Symbol%": hasSymbols$2 ? Symbol : undefined$1,
    "%SyntaxError%": $SyntaxError,
    "%ThrowTypeError%": ThrowTypeError,
    "%TypedArray%": TypedArray,
    "%TypeError%": $TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
var doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = getProto$1(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};
var bind = functionBind;
var hasOwn$1 = src;
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g;
/** Used to match backslashes in property paths. */ var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if (hasOwn$1(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError("intrinsic " + name + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $TypeError('"allowMissing" argument must be a boolean');
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn$1(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($gOPD$1 && i + 1 >= parts.length) {
                var desc = $gOPD$1(value, part);
                isOwn = !!desc; // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn$1(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};
var callBind$3 = {
    exports: {}
};
(function(module) {
    var bind = functionBind;
    var GetIntrinsic = getIntrinsic;
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
    var $max = GetIntrinsic("%Math.max%");
    if ($defineProperty) try {
        $defineProperty({}, "a", {
            value: 1
        });
    } catch (e) {
        // IE 8 has a broken defineProperty
        $defineProperty = null;
    }
    module.exports = function callBind(originalFunction) {
        var func = $reflectApply(bind, $call, arguments);
        if ($gOPD && $defineProperty) {
            var desc = $gOPD(func, "length");
            if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
            $defineProperty(func, "length", {
                value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
            });
        }
        return func;
    };
    var applyBind = function applyBind() {
        return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty) $defineProperty(module.exports, "apply", {
        value: applyBind
    });
    else module.exports.apply = applyBind;
})(callBind$3);
var GetIntrinsic$1 = getIntrinsic;
var callBind$2 = callBind$3.exports;
var $indexOf$1 = callBind$2(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$3 = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic$1(name, !!allowMissing);
    if (typeof intrinsic === "function" && $indexOf$1(name, ".prototype.") > -1) return callBind$2(intrinsic);
    return intrinsic;
};
var hasToStringTag$3 = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
var callBound$2 = callBound$3;
var $toString$2 = callBound$2("Object.prototype.toString");
var isStandardArguments = function isArguments(value) {
    if (hasToStringTag$3 && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $toString$2(value) === "[object Arguments]";
};
var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString$2(value) !== "[object Array]" && $toString$2(value.callee) === "[object Function]";
};
var supportsStandardArguments = function() {
    return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
var hasSymbols$1 = shams$1;
var shams = function hasToStringTagShams() {
    return hasSymbols$1() && !!Symbol.toStringTag;
};
var toStr$3 = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag$2 = shams();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function getGeneratorFunc() {
    // eslint-disable-line consistent-return
    if (!hasToStringTag$2) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var GeneratorFunction;
var isGeneratorFunction = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if (isFnRegex.test(fnToStr.call(fn))) return true;
    if (!hasToStringTag$2) {
        var str = toStr$3.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!getProto) return false;
    if (typeof GeneratorFunction === "undefined") {
        var generatorFunc = getGeneratorFunc();
        GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
    }
    return getProto(fn) === GeneratorFunction;
};
var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var foreach = function forEach(obj, fn, ctx) {
    if (toString.call(fn) !== "[object Function]") throw new TypeError("iterator must be a function");
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if (hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};
var possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
var g$2 = typeof globalThis === "undefined" ? commonjsGlobal : globalThis;
var availableTypedArrays$2 = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < possibleNames.length; i++)if (typeof g$2[possibleNames[i]] === "function") out[out.length] = possibleNames[i];
    return out;
};
var GetIntrinsic = getIntrinsic;
var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD) try {
    $gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
var getOwnPropertyDescriptor = $gOPD;
var forEach$2 = foreach;
var availableTypedArrays$1 = availableTypedArrays$2;
var callBound$1 = callBound$3;
var $toString$1 = callBound$1("Object.prototype.toString");
var hasToStringTag$1 = shams();
var g$1 = typeof globalThis === "undefined" ? commonjsGlobal : globalThis;
var typedArrays$1 = availableTypedArrays$1();
var $indexOf = callBound$1("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $slice$1 = callBound$1("String.prototype.slice");
var toStrTags$1 = {};
var gOPD$1 = getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag$1 && gOPD$1 && getPrototypeOf$1) forEach$2(typedArrays$1, function(typedArray) {
    var arr = new g$1[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = getPrototypeOf$1(arr);
        var descriptor = gOPD$1(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = getPrototypeOf$1(proto);
            descriptor = gOPD$1(superProto, Symbol.toStringTag);
        }
        toStrTags$1[typedArray] = descriptor.get;
    }
});
var tryTypedArrays$1 = function tryAllTypedArrays(value) {
    var anyTrue = false;
    forEach$2(toStrTags$1, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {
        /**/ }
    });
    return anyTrue;
};
var isTypedArray$1 = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!hasToStringTag$1 || !(Symbol.toStringTag in value)) {
        var tag = $slice$1($toString$1(value), 8, -1);
        return $indexOf(typedArrays$1, tag) > -1;
    }
    if (!gOPD$1) return false;
    return tryTypedArrays$1(value);
};
var forEach$1 = foreach;
var availableTypedArrays = availableTypedArrays$2;
var callBound = callBound$3;
var $toString = callBound("Object.prototype.toString");
var hasToStringTag = shams();
var g = typeof globalThis === "undefined" ? commonjsGlobal : globalThis;
var typedArrays = availableTypedArrays();
var $slice = callBound("String.prototype.slice");
var toStrTags = {};
var gOPD = getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) forEach$1(typedArrays, function(typedArray) {
    if (typeof g[typedArray] === "function") {
        var arr = new g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = getPrototypeOf(arr);
            var descriptor = gOPD(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = getPrototypeOf(proto);
                descriptor = gOPD(superProto, Symbol.toStringTag);
            }
            toStrTags[typedArray] = descriptor.get;
        }
    }
});
var tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    forEach$1(toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};
var isTypedArray = isTypedArray$1;
var whichTypedArray = function whichTypedArray(value) {
    if (!isTypedArray(value)) return false;
    if (!hasToStringTag || !(Symbol.toStringTag in value)) return $slice($toString(value), 8, -1);
    return tryTypedArrays(value);
};
(function(exports) {
    var isArgumentsObject = isArguments$1;
    var isGeneratorFunction$1 = isGeneratorFunction;
    var whichTypedArray$1 = whichTypedArray;
    var isTypedArray = isTypedArray$1;
    function uncurryThis(f) {
        return f.call.bind(f);
    }
    var BigIntSupported = typeof BigInt !== "undefined";
    var SymbolSupported = typeof Symbol !== "undefined";
    var ObjectToString = uncurryThis(Object.prototype.toString);
    var numberValue = uncurryThis(Number.prototype.valueOf);
    var stringValue = uncurryThis(String.prototype.valueOf);
    var booleanValue = uncurryThis(Boolean.prototype.valueOf);
    if (BigIntSupported) var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
    if (SymbolSupported) var symbolValue = uncurryThis(Symbol.prototype.valueOf);
    function checkBoxedPrimitive(value, prototypeValueOf) {
        if (typeof value !== "object") return false;
        try {
            prototypeValueOf(value);
            return true;
        } catch (e) {
            return false;
        }
    }
    exports.isArgumentsObject = isArgumentsObject;
    exports.isGeneratorFunction = isGeneratorFunction$1;
    exports.isTypedArray = isTypedArray; // Taken from here and modified for better browser support
    // https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
    function isPromise(input) {
        return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
    }
    exports.isPromise = isPromise;
    function isArrayBufferView(value) {
        if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
        return isTypedArray(value) || isDataView(value);
    }
    exports.isArrayBufferView = isArrayBufferView;
    function isUint8Array(value) {
        return whichTypedArray$1(value) === "Uint8Array";
    }
    exports.isUint8Array = isUint8Array;
    function isUint8ClampedArray(value) {
        return whichTypedArray$1(value) === "Uint8ClampedArray";
    }
    exports.isUint8ClampedArray = isUint8ClampedArray;
    function isUint16Array(value) {
        return whichTypedArray$1(value) === "Uint16Array";
    }
    exports.isUint16Array = isUint16Array;
    function isUint32Array(value) {
        return whichTypedArray$1(value) === "Uint32Array";
    }
    exports.isUint32Array = isUint32Array;
    function isInt8Array(value) {
        return whichTypedArray$1(value) === "Int8Array";
    }
    exports.isInt8Array = isInt8Array;
    function isInt16Array(value) {
        return whichTypedArray$1(value) === "Int16Array";
    }
    exports.isInt16Array = isInt16Array;
    function isInt32Array(value) {
        return whichTypedArray$1(value) === "Int32Array";
    }
    exports.isInt32Array = isInt32Array;
    function isFloat32Array(value) {
        return whichTypedArray$1(value) === "Float32Array";
    }
    exports.isFloat32Array = isFloat32Array;
    function isFloat64Array(value) {
        return whichTypedArray$1(value) === "Float64Array";
    }
    exports.isFloat64Array = isFloat64Array;
    function isBigInt64Array(value) {
        return whichTypedArray$1(value) === "BigInt64Array";
    }
    exports.isBigInt64Array = isBigInt64Array;
    function isBigUint64Array(value) {
        return whichTypedArray$1(value) === "BigUint64Array";
    }
    exports.isBigUint64Array = isBigUint64Array;
    function isMapToString(value) {
        return ObjectToString(value) === "[object Map]";
    }
    isMapToString.working = typeof Map !== "undefined" && isMapToString(new Map());
    function isMap(value) {
        if (typeof Map === "undefined") return false;
        return isMapToString.working ? isMapToString(value) : value instanceof Map;
    }
    exports.isMap = isMap;
    function isSetToString(value) {
        return ObjectToString(value) === "[object Set]";
    }
    isSetToString.working = typeof Set !== "undefined" && isSetToString(new Set());
    function isSet(value) {
        if (typeof Set === "undefined") return false;
        return isSetToString.working ? isSetToString(value) : value instanceof Set;
    }
    exports.isSet = isSet;
    function isWeakMapToString(value) {
        return ObjectToString(value) === "[object WeakMap]";
    }
    isWeakMapToString.working = typeof WeakMap !== "undefined" && isWeakMapToString(new WeakMap());
    function isWeakMap(value) {
        if (typeof WeakMap === "undefined") return false;
        return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
    }
    exports.isWeakMap = isWeakMap;
    function isWeakSetToString(value) {
        return ObjectToString(value) === "[object WeakSet]";
    }
    isWeakSetToString.working = typeof WeakSet !== "undefined" && isWeakSetToString(new WeakSet());
    function isWeakSet(value) {
        return isWeakSetToString(value);
    }
    exports.isWeakSet = isWeakSet;
    function isArrayBufferToString(value) {
        return ObjectToString(value) === "[object ArrayBuffer]";
    }
    isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && isArrayBufferToString(new ArrayBuffer());
    function isArrayBuffer(value) {
        if (typeof ArrayBuffer === "undefined") return false;
        return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
    }
    exports.isArrayBuffer = isArrayBuffer;
    function isDataViewToString(value) {
        return ObjectToString(value) === "[object DataView]";
    }
    isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
    function isDataView(value) {
        if (typeof DataView === "undefined") return false;
        return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
    }
    exports.isDataView = isDataView; // Store a copy of SharedArrayBuffer in case it's deleted elsewhere
    var SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
    function isSharedArrayBufferToString(value) {
        return ObjectToString(value) === "[object SharedArrayBuffer]";
    }
    function isSharedArrayBuffer(value) {
        if (typeof SharedArrayBufferCopy === "undefined") return false;
        if (typeof isSharedArrayBufferToString.working === "undefined") isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
        return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
    }
    exports.isSharedArrayBuffer = isSharedArrayBuffer;
    function isAsyncFunction(value) {
        return ObjectToString(value) === "[object AsyncFunction]";
    }
    exports.isAsyncFunction = isAsyncFunction;
    function isMapIterator(value) {
        return ObjectToString(value) === "[object Map Iterator]";
    }
    exports.isMapIterator = isMapIterator;
    function isSetIterator(value) {
        return ObjectToString(value) === "[object Set Iterator]";
    }
    exports.isSetIterator = isSetIterator;
    function isGeneratorObject(value) {
        return ObjectToString(value) === "[object Generator]";
    }
    exports.isGeneratorObject = isGeneratorObject;
    function isWebAssemblyCompiledModule(value) {
        return ObjectToString(value) === "[object WebAssembly.Module]";
    }
    exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
    function isNumberObject(value) {
        return checkBoxedPrimitive(value, numberValue);
    }
    exports.isNumberObject = isNumberObject;
    function isStringObject(value) {
        return checkBoxedPrimitive(value, stringValue);
    }
    exports.isStringObject = isStringObject;
    function isBooleanObject(value) {
        return checkBoxedPrimitive(value, booleanValue);
    }
    exports.isBooleanObject = isBooleanObject;
    function isBigIntObject(value) {
        return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
    }
    exports.isBigIntObject = isBigIntObject;
    function isSymbolObject(value) {
        return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
    }
    exports.isSymbolObject = isSymbolObject;
    function isBoxedPrimitive(value) {
        return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
    }
    exports.isBoxedPrimitive = isBoxedPrimitive;
    function isAnyArrayBuffer(value) {
        return typeof Uint8Array !== "undefined" && (isArrayBuffer(value) || isSharedArrayBuffer(value));
    }
    exports.isAnyArrayBuffer = isAnyArrayBuffer;
    [
        "isProxy",
        "isExternal",
        "isModuleNamespaceObject"
    ].forEach(function(method) {
        Object.defineProperty(exports, method, {
            enumerable: false,
            value: function value() {
                throw new Error(method + " is not supported in userland");
            }
        });
    });
})(types);
var isBufferBrowser = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};
var inherits_browser = {
    exports: {}
};
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
inherits_browser.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
inherits_browser.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function TempCtor() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};
(function(exports) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
        var keys = Object.keys(obj);
        var descriptors = {};
        for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
        return descriptors;
    };
    var formatRegExp = /%[sdj%]/g;
    exports.format = function(f) {
        if (!isString(f)) {
            var objects = [];
            for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
            return objects.join(" ");
        }
        var i = 1;
        var args = arguments;
        var len = args.length;
        var str = String(f).replace(formatRegExp, function(x) {
            if (x === "%%") return "%";
            if (i >= len) return x;
            switch(x){
                case "%s":
                    return String(args[i++]);
                case "%d":
                    return Number(args[i++]);
                case "%j":
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return "[Circular]";
                    }
                default:
                    return x;
            }
        });
        for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += " " + x;
        else str += " " + inspect(x);
        return str;
    }; // Mark that a method should not be used.
    // Returns a modified function which warns once by default.
    // If --no-deprecation is set, then it is a no-op.
    exports.deprecate = function(fn, msg) {
        if (typeof browser$1$1 !== "undefined" && browser$1$1.noDeprecation === true) return fn;
         // Allow for deprecating things in the process of starting up.
        if (typeof browser$1$1 === "undefined") return function() {
            return exports.deprecate(fn, msg).apply(this, arguments);
        };
        var warned = false;
        function deprecated() {
            if (!warned) {
                console.error(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    };
    var debugs = {};
    var debugEnvRegex = /^$/;
    if (browser$1$1.env.NODE_DEBUG) {
        var debugEnv = browser$1$1.env.NODE_DEBUG;
        debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase();
        debugEnvRegex = new RegExp("^" + debugEnv + "$", "i");
    }
    exports.debuglog = function(set) {
        set = set.toUpperCase();
        if (!debugs[set]) {
            if (debugEnvRegex.test(set)) {
                var pid = browser$1$1.pid;
                debugs[set] = function() {
                    var msg = exports.format.apply(exports, arguments);
                    console.error("%s %d: %s", set, pid, msg);
                };
            } else debugs[set] = function() {};
        }
        return debugs[set];
    };
    /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
        // default options
        var ctx = {
            seen: [],
            stylize: stylizeNoColor
        }; // legacy...
        if (arguments.length >= 3) ctx.depth = arguments[2];
        if (arguments.length >= 4) ctx.colors = arguments[3];
        if (isBoolean(opts)) // legacy...
        ctx.showHidden = opts;
        else if (opts) // got an "options" object
        exports._extend(ctx, opts);
         // set default options
        if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
        if (isUndefined(ctx.depth)) ctx.depth = 2;
        if (isUndefined(ctx.colors)) ctx.colors = false;
        if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
        if (ctx.colors) ctx.stylize = stylizeWithColor;
        return formatValue(ctx, obj, ctx.depth);
    }
    exports.inspect = inspect; // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
    inspect.colors = {
        "bold": [
            1,
            22
        ],
        "italic": [
            3,
            23
        ],
        "underline": [
            4,
            24
        ],
        "inverse": [
            7,
            27
        ],
        "white": [
            37,
            39
        ],
        "grey": [
            90,
            39
        ],
        "black": [
            30,
            39
        ],
        "blue": [
            34,
            39
        ],
        "cyan": [
            36,
            39
        ],
        "green": [
            32,
            39
        ],
        "magenta": [
            35,
            39
        ],
        "red": [
            31,
            39
        ],
        "yellow": [
            33,
            39
        ]
    }; // Don't use 'blue' not visible on cmd.exe
    inspect.styles = {
        "special": "cyan",
        "number": "yellow",
        "boolean": "yellow",
        "undefined": "grey",
        "null": "bold",
        "string": "green",
        "date": "magenta",
        // "name": intentionally not styling
        "regexp": "red"
    };
    function stylizeWithColor(str, styleType) {
        var style = inspect.styles[styleType];
        if (style) return "\x1b[" + inspect.colors[style][0] + "m" + str + "\x1b[" + inspect.colors[style][1] + "m";
        else return str;
    }
    function stylizeNoColor(str, styleType) {
        return str;
    }
    function arrayToHash(array) {
        var hash = {};
        array.forEach(function(val, idx) {
            hash[val] = true;
        });
        return hash;
    }
    function formatValue(ctx, value, recurseTimes) {
        // Provide a hook for user-specified inspect functions.
        // Check that value is an object with an inspect function on it
        if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
        value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
        !(value.constructor && value.constructor.prototype === value)) {
            var ret = value.inspect(recurseTimes, ctx);
            if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
            return ret;
        } // Primitive types cannot have properties
        var primitive = formatPrimitive(ctx, value);
        if (primitive) return primitive;
         // Look up the keys of the object.
        var keys = Object.keys(value);
        var visibleKeys = arrayToHash(keys);
        if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
         // IE doesn't make error fields non-enumerable
        // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
        if (isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return formatError(value);
         // Some type of object without properties can be shortcutted.
        if (keys.length === 0) {
            if (isFunction(value)) {
                var name = value.name ? ": " + value.name : "";
                return ctx.stylize("[Function" + name + "]", "special");
            }
            if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
            if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
            if (isError(value)) return formatError(value);
        }
        var base = "", array = false, braces = [
            "{",
            "}"
        ]; // Make Array say that they are Array
        if (isArray(value)) {
            array = true;
            braces = [
                "[",
                "]"
            ];
        } // Make functions say that they are functions
        if (isFunction(value)) {
            var n = value.name ? ": " + value.name : "";
            base = " [Function" + n + "]";
        } // Make RegExps say that they are RegExps
        if (isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
         // Make dates with properties first say the date
        if (isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
         // Make error with message first say the error
        if (isError(value)) base = " " + formatError(value);
        if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
        if (recurseTimes < 0) {
            if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
            else return ctx.stylize("[Object]", "special");
        }
        ctx.seen.push(value);
        var output;
        if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
        else output = keys.map(function(key) {
            return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
        ctx.seen.pop();
        return reduceToSingleString(output, base, braces);
    }
    function formatPrimitive(ctx, value) {
        if (isUndefined(value)) return ctx.stylize("undefined", "undefined");
        if (isString(value)) {
            var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
            return ctx.stylize(simple, "string");
        }
        if (isNumber(value)) return ctx.stylize("" + value, "number");
        if (isBoolean(value)) return ctx.stylize("" + value, "boolean"); // For some reason typeof null is "object", so special case here.
        if (isNull(value)) return ctx.stylize("null", "null");
    }
    function formatError(value) {
        return "[" + Error.prototype.toString.call(value) + "]";
    }
    function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
        var output = [];
        for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        else output.push("");
        keys.forEach(function(key) {
            if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        });
        return output;
    }
    function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
        var name, str, desc;
        desc = Object.getOwnPropertyDescriptor(value, key) || {
            value: value[key]
        };
        if (desc.get) {
            if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
            else str = ctx.stylize("[Getter]", "special");
        } else if (desc.set) str = ctx.stylize("[Setter]", "special");
        if (!hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
        if (!str) {
            if (ctx.seen.indexOf(desc.value) < 0) {
                if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
                else str = formatValue(ctx, desc.value, recurseTimes - 1);
                if (str.indexOf("\n") > -1) {
                    if (array) str = str.split("\n").map(function(line) {
                        return "  " + line;
                    }).join("\n").substr(2);
                    else str = "\n" + str.split("\n").map(function(line) {
                        return "   " + line;
                    }).join("\n");
                }
            } else str = ctx.stylize("[Circular]", "special");
        }
        if (isUndefined(name)) {
            if (array && key.match(/^\d+$/)) return str;
            name = JSON.stringify("" + key);
            if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.substr(1, name.length - 2);
                name = ctx.stylize(name, "name");
            } else {
                name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, "string");
            }
        }
        return name + ": " + str;
    }
    function reduceToSingleString(output, base, braces) {
        var length = output.reduce(function(prev, cur) {
            cur.indexOf("\n");
            return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0);
        if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
        return braces[0] + base + " " + output.join(", ") + " " + braces[1];
    } // NOTE: These type checking functions intentionally don't use `instanceof`
    // because it is fragile and can be easily faked with `Object.create()`.
    exports.types = types;
    function isArray(ar) {
        return Array.isArray(ar);
    }
    exports.isArray = isArray;
    function isBoolean(arg) {
        return typeof arg === "boolean";
    }
    exports.isBoolean = isBoolean;
    function isNull(arg) {
        return arg === null;
    }
    exports.isNull = isNull;
    function isNullOrUndefined(arg) {
        return arg == null;
    }
    exports.isNullOrUndefined = isNullOrUndefined;
    function isNumber(arg) {
        return typeof arg === "number";
    }
    exports.isNumber = isNumber;
    function isString(arg) {
        return typeof arg === "string";
    }
    exports.isString = isString;
    function isSymbol(arg) {
        return typeof arg === "symbol";
    }
    exports.isSymbol = isSymbol;
    function isUndefined(arg) {
        return arg === void 0;
    }
    exports.isUndefined = isUndefined;
    function isRegExp(re) {
        return isObject(re) && objectToString(re) === "[object RegExp]";
    }
    exports.isRegExp = isRegExp;
    exports.types.isRegExp = isRegExp;
    function isObject(arg) {
        return typeof arg === "object" && arg !== null;
    }
    exports.isObject = isObject;
    function isDate(d) {
        return isObject(d) && objectToString(d) === "[object Date]";
    }
    exports.isDate = isDate;
    exports.types.isDate = isDate;
    function isError(e) {
        return isObject(e) && (objectToString(e) === "[object Error]" || e instanceof Error);
    }
    exports.isError = isError;
    exports.types.isNativeError = isError;
    function isFunction(arg) {
        return typeof arg === "function";
    }
    exports.isFunction = isFunction;
    function isPrimitive(arg) {
        return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
        typeof arg === "undefined";
    }
    exports.isPrimitive = isPrimitive;
    exports.isBuffer = isBufferBrowser;
    function objectToString(o) {
        return Object.prototype.toString.call(o);
    }
    function pad(n) {
        return n < 10 ? "0" + n.toString(10) : n.toString(10);
    }
    var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]; // 26 Feb 16:19:34
    function timestamp() {
        var d = new Date();
        var time = [
            pad(d.getHours()),
            pad(d.getMinutes()),
            pad(d.getSeconds())
        ].join(":");
        return [
            d.getDate(),
            months[d.getMonth()],
            time
        ].join(" ");
    } // log is just a thin wrapper to console.log that prepends a timestamp
    exports.log = function() {
        console.log("%s - %s", timestamp(), exports.format.apply(exports, arguments));
    };
    /**
   * Inherit the prototype methods from one constructor into another.
   *
   * The Function.prototype.inherits from lang.js rewritten as a standalone
   * function (not on Function.prototype). NOTE: If this file is to be loaded
   * during bootstrapping this function needs to be rewritten using some native
   * functions as prototype setup using normal JavaScript does not work as
   * expected during bootstrapping (see mirror.js in r114903).
   *
   * @param {function} ctor Constructor function which needs to inherit the
   *     prototype.
   * @param {function} superCtor Constructor function to inherit prototype from.
   */ exports.inherits = inherits_browser.exports;
    exports._extend = function(origin, add) {
        // Don't do anything if add isn't an object
        if (!add || !isObject(add)) return origin;
        var keys = Object.keys(add);
        var i = keys.length;
        while(i--)origin[keys[i]] = add[keys[i]];
        return origin;
    };
    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
    exports.promisify = function promisify(original) {
        if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
        if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
            var fn = original[kCustomPromisifiedSymbol];
            if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            Object.defineProperty(fn, kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
            });
            return fn;
        }
        function fn() {
            var promiseResolve, promiseReject;
            var promise = new Promise(function(resolve, reject) {
                promiseResolve = resolve;
                promiseReject = reject;
            });
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            args.push(function(err, value) {
                if (err) promiseReject(err);
                else promiseResolve(value);
            });
            try {
                original.apply(this, args);
            } catch (err) {
                promiseReject(err);
            }
            return promise;
        }
        Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
        if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
    };
    exports.promisify.custom = kCustomPromisifiedSymbol;
    function callbackifyOnRejected(reason, cb) {
        // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
        // Because `null` is a special error value in callbacks which means "no error
        // occurred", we error-wrap so the callback consumer can distinguish between
        // "the promise rejected with null" or "the promise fulfilled with undefined".
        if (!reason) {
            var newReason = new Error("Promise was rejected with a falsy value");
            newReason.reason = reason;
            reason = newReason;
        }
        return cb(reason);
    }
    function callbackify(original) {
        if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
         // We DO NOT return the promise as it gives the user a false sense that
        // the promise is actually somehow related to the callback's execution
        // and that the callback throwing will reject the promise.
        function callbackified() {
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            var maybeCb = args.pop();
            if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
            var self1 = this;
            var cb = function cb() {
                return maybeCb.apply(self1, arguments);
            }; // In true node style we process the callback on `nextTick` with all the
            // implications (stack, `uncaughtException`, `async_hooks`)
            original.apply(this, args).then(function(ret) {
                browser$1$1.nextTick(cb.bind(null, null, ret));
            }, function(rej) {
                browser$1$1.nextTick(callbackifyOnRejected.bind(null, rej, cb));
            });
        }
        Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
        Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
        return callbackified;
    }
    exports.callbackify = callbackify;
})(util$1);
var browser = {
    exports: {}
};
var process = browser.exports = {}; // cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
     // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
     // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
}; // v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};
function BufferList() {
    this.head = null;
    this.tail = null;
    this.length = 0;
}
BufferList.prototype.push = function(v) {
    var entry = {
        data: v,
        next: null
    };
    if (this.length > 0) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
    ++this.length;
};
BufferList.prototype.unshift = function(v) {
    var entry = {
        data: v,
        next: this.head
    };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
};
BufferList.prototype.shift = function() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;
    else this.head = this.head.next;
    --this.length;
    return ret;
};
BufferList.prototype.clear = function() {
    this.head = this.tail = null;
    this.length = 0;
};
BufferList.prototype.join = function(s) {
    if (this.length === 0) return "";
    var p = this.head;
    var ret = "" + p.data;
    while(p = p.next)ret += s + p.data;
    return ret;
};
BufferList.prototype.concat = function(n) {
    if (this.length === 0) return buffer.Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = buffer.Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while(p){
        p.data.copy(ret, i);
        i += p.data.length;
        p = p.next;
    }
    return ret;
};
var safeBuffer = {
    exports: {}
};
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ (function(module, exports) {
    /* eslint-disable node/no-deprecated-api */ var buffer$1 = buffer;
    var Buffer = buffer$1.Buffer; // alternative to using Object.keys for old browsers
    function copyProps(src, dst) {
        for(var key in src)dst[key] = src[key];
    }
    if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer$1;
    else {
        // Copy properties from require('buffer')
        copyProps(buffer$1, exports);
        exports.Buffer = SafeBuffer;
    }
    function SafeBuffer(arg, encodingOrOffset, length) {
        return Buffer(arg, encodingOrOffset, length);
    }
    SafeBuffer.prototype = Object.create(Buffer.prototype); // Copy static methods from Buffer
    copyProps(Buffer, SafeBuffer);
    SafeBuffer.from = function(arg, encodingOrOffset, length) {
        if (typeof arg === "number") throw new TypeError("Argument must not be a number");
        return Buffer(arg, encodingOrOffset, length);
    };
    SafeBuffer.alloc = function(size, fill, encoding) {
        if (typeof size !== "number") throw new TypeError("Argument must be a number");
        var buf = Buffer(size);
        if (fill !== undefined) {
            if (typeof encoding === "string") buf.fill(fill, encoding);
            else buf.fill(fill);
        } else buf.fill(0);
        return buf;
    };
    SafeBuffer.allocUnsafe = function(size) {
        if (typeof size !== "number") throw new TypeError("Argument must be a number");
        return Buffer(size);
    };
    SafeBuffer.allocUnsafeSlow = function(size) {
        if (typeof size !== "number") throw new TypeError("Argument must be a number");
        return buffer$1.SlowBuffer(size);
    };
})(safeBuffer, safeBuffer.exports);
/*<replacement>*/ var Buffer = safeBuffer.exports.Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== "string" && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
} // StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var StringDecoder_1 = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
StringDecoder.prototype.end = utf8End; // Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text; // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
}; // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
} // Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self1, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self1.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self1.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self1.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
} // Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self1, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self1.lastNeed = 0;
        return "\uFFFD";
    }
    if (self1.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self1.lastNeed = 1;
            return "\uFFFD";
        }
        if (self1.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self1.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
} // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
} // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
} // For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
} // UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
} // For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
} // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}
Readable.ReadableState = ReadableState;
var debug = util$1.debuglog("stream");
util$1.inherits(Readable, EE);
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    else {
        // This is a hack to make sure that our error handler is attached before any
        // userland ones.  NEVER DO THIS. This is here only because this code needs
        // to continue to work with older versions of Node.js that do not include
        // the prependListener() method. The goal is to eventually remove this hack.
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
}
function listenerCount(emitter, type) {
    return emitter.listeners(type).length;
}
function ReadableState(options, stream) {
    options = options || {};
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
    // cast to ints.
    this.highWaterMark = ~~this.highWaterMark;
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // when piping, we only care about 'readable' events that happen
    // after read()ing all the bytes and not getting any pushback.
    this.ranOut = false;
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        this.decoder = new StringDecoder_1(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    if (!(this instanceof Readable)) return new Readable(options);
    this._readableState = new ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options && typeof options.read === "function") this._read = options.read;
    EE.call(this);
}
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    if (!state.objectMode && typeof chunk === "string") {
        encoding = encoding || state.defaultEncoding;
        if (encoding !== state.encoding) {
            chunk = Buffer$1.from(chunk, encoding);
            encoding = "";
        }
    }
    return readableAddChunk(this, state, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    var state = this._readableState;
    return readableAddChunk(this, state, chunk, "", true);
};
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
function readableAddChunk(stream, state, chunk, encoding, addToFront) {
    var er = chunkInvalid(state, chunk);
    if (er) stream.emit("error", er);
    else if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else if (state.objectMode || chunk && chunk.length > 0) {
        if (state.ended && !addToFront) {
            var e = new Error("stream.push() after EOF");
            stream.emit("error", e);
        } else if (state.endEmitted && addToFront) {
            var _e = new Error("stream.unshift() after end event");
            stream.emit("error", _e);
        } else {
            var skipAdd;
            if (state.decoder && !addToFront && !encoding) {
                chunk = state.decoder.write(chunk);
                skipAdd = !state.objectMode && chunk.length === 0;
            }
            if (!addToFront) state.reading = false;
            // Don't add to the buffer if we've decoded to an empty string chunk and
            // we're not in object mode
            if (!skipAdd) {
                // if we want the data now, just emit it.
                if (state.flowing && state.length === 0 && !state.sync) {
                    stream.emit("data", chunk);
                    stream.read(0);
                } else {
                    // update the buffer info.
                    state.length += state.objectMode ? 1 : chunk.length;
                    if (addToFront) state.buffer.unshift(chunk);
                    else state.buffer.push(chunk);
                    if (state.needReadable) emitReadable(stream);
                }
            }
            maybeReadMore(stream, state);
        }
    } else if (!addToFront) state.reading = false;
    return needMoreData(state);
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    this._readableState.decoder = new StringDecoder_1(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug("reading or ended", doRead);
    } else if (doRead) {
        debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function chunkInvalid(state, chunk) {
    var er = null;
    if (!Buffer$1.isBuffer(chunk) && typeof chunk !== "string" && chunk !== null && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
function onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) browser.exports.nextTick(emitReadable_, stream);
        else emitReadable_(stream);
    }
}
function emitReadable_(stream) {
    debug("emit readable");
    stream.emit("readable");
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        browser.exports.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    this.emit("error", new Error("not implemented"));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = !pipeOpts || pipeOpts.end !== false;
    var endFn = doEnd ? onend : cleanup;
    if (state.endEmitted) browser.exports.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable) {
        debug("onunpipe");
        if (readable === src) cleanup();
    }
    function onend() {
        debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", cleanup);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug("false write response, pause", src._readableState.awaitDrain);
                src._readableState.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (listenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug("pipe resume");
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && src.listeners("data").length) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var _i = 0; _i < len; _i++)dests[_i].emit("unpipe", this);
        return this;
    }
    // try to find the right one.
    var i = indexOf(state.pipes, dest);
    if (i === -1) return this;
    state.pipes.splice(i, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = EE.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) browser.exports.nextTick(nReadingNextTick, this);
            else if (state.length) emitReadable(this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
function nReadingNextTick(self1) {
    debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug("resume");
        state.flowing = true;
        resume(this, state);
    }
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        browser.exports.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    if (!state.reading) {
        debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var state = this._readableState;
    var paused = false;
    var self1 = this;
    stream.on("end", function() {
        debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) self1.push(chunk);
        }
        self1.push(null);
    });
    stream.on("data", function(chunk) {
        debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = self1.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    var events = [
        "error",
        "close",
        "destroy",
        "pause",
        "resume"
    ];
    forEach(events, function(ev) {
        stream.on(ev, self1.emit.bind(self1, ev));
    });
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    self1._read = function(n) {
        debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return self1;
};
// exposed for testing purposes only.
Readable._fromList = fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
    var ret = Buffer$1.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        browser.exports.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function forEach(xs, f) {
    for(var i = 0, l = xs.length; i < l; i++)f(xs[i], i);
}
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
// A bit simpler than readable streams.
Writable.WritableState = WritableState;
util$1.inherits(Writable, events.exports.EventEmitter);
function nop() {}
function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
function WritableState(options, stream) {
    Object.defineProperty(this, "buffer", {
        get: util$1.deprecate(function() {
            return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
    });
    options = options || {};
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
    // cast to ints.
    this.highWaterMark = ~~this.highWaterMark;
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function writableStateGetBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
function Writable(options) {
    // Writable ctor is applied to Duplexes, though they're not
    // instanceof Writable, they're instanceof Readable.
    if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);
    this._writableState = new WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
    }
    events.exports.EventEmitter.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    browser.exports.nextTick(cb, er);
}
// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    // Always throw error if a null is written
    // if we are not in object mode then throw
    // if it is not a buffer, string, or undefined.
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (!buffer.Buffer.isBuffer(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        browser.exports.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (buffer.Buffer.isBuffer(chunk)) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = nop;
    if (state.ended) writeAfterEnd(this, cb);
    else if (validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = buffer.Buffer.from(chunk, encoding);
    return chunk;
}
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
    chunk = decodeChunk(state, chunk, encoding);
    if (buffer.Buffer.isBuffer(chunk)) encoding = "buffer";
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) browser.exports.nextTick(cb, er);
    else cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit("error", er);
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) /*<replacement>*/ browser.exports.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        while(entry){
            buffer[count] = entry;
            entry = entry.next;
            count += 1;
        }
        doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequestCount = 0;
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("not implemented"));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) endWritable(this, state, cb);
};
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function prefinish(stream, state) {
    if (!state.prefinished) {
        state.prefinished = true;
        stream.emit("prefinish");
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        if (state.pendingcb === 0) {
            prefinish(stream, state);
            state.finished = true;
            stream.emit("finish");
        } else prefinish(stream, state);
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) browser.exports.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function(err) {
        var entry = _this.entry;
        _this.entry = null;
        while(entry){
            var cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        if (state.corkedRequestsFree) state.corkedRequestsFree.next = _this;
        else state.corkedRequestsFree = _this;
    };
}
util$1.inherits(Duplex, Readable);
var keys$1 = Object.keys(Writable.prototype);
for(var v = 0; v < keys$1.length; v++){
    var method = keys$1[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", onend);
}
// the no-half-open enforcer
function onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    browser.exports.nextTick(onEndNT, this);
}
function onEndNT(self1) {
    self1.end();
}
// a transform stream is a readable/writable stream where you do
util$1.inherits(Transform, Duplex);
function TransformState(stream) {
    this.afterTransform = function(er, data) {
        return afterTransform(stream, er, data);
    };
    this.needTransform = false;
    this.transforming = false;
    this.writecb = null;
    this.writechunk = null;
    this.writeencoding = null;
}
function afterTransform(stream, er, data) {
    var ts = stream._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return stream.emit("error", new Error("no writecb in Transform class"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data !== null && data !== undefined) stream.push(data);
    cb(er);
    var rs = stream._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) stream._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = new TransformState(this);
    // when the writable side finishes, then flush out anything remaining.
    var stream = this;
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    this.once("prefinish", function() {
        if (typeof this._flush === "function") this._flush(function(er) {
            done(stream, er);
        });
        else done(stream);
    });
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("Not implemented");
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
function done(stream, er) {
    if (er) return stream.emit("error", er);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    var ws = stream._writableState;
    var ts = stream._transformState;
    if (ws.length) throw new Error("Calling transform done when ws.length != 0");
    if (ts.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}
util$1.inherits(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};
util$1.inherits(Stream, EE);
Stream.Readable = Readable;
Stream.Writable = Writable;
Stream.Duplex = Duplex;
Stream.Transform = Transform;
Stream.PassThrough = PassThrough;
// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function Stream() {
    EE.call(this);
}
Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if (EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
var _polyfillNode_stream = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    "default": Stream,
    Readable: Readable,
    Writable: Writable,
    Duplex: Duplex,
    Transform: Transform,
    PassThrough: PassThrough,
    Stream: Stream
});
var require$$1 = /*@__PURE__*/ getAugmentedNamespace(_polyfillNode_stream);
var binding = {};
var assert$2 = {
    exports: {}
};
var errors = {};
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function _typeof$3(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$3 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$3(obj);
}
function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$1(self1, call) {
    if (call && (_typeof$3(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized$1(self1);
}
function _assertThisInitialized$1(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
}
function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf$1(o, p);
}
var codes = {}; // Lazy loaded
var assert$1;
var util;
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inherits$1(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            _classCallCheck$2(this, NodeError);
            _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(NodeError).call(this, getMessage(arg1, arg2, arg3)));
            _this.code = code;
            return _this;
        }
        return NodeError;
    }(Base);
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith$1(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);
createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if (assert$1 === undefined) assert$1 = assert$2.exports;
    assert$1(typeof name === "string", "'name' must be a string"); // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if (endsWith$1(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    else {
        var type = includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat(oneOf(expected, "type"));
    } // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat(_typeof$3(actual));
    return msg;
}, TypeError);
createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if (util === undefined) util = util$1;
    var inspected = util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError);
createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat(_typeof$3(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);
createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (assert$1 === undefined) assert$1 = assert$2.exports;
    assert$1(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
errors.codes = codes;
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self1, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self1);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _typeof$2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$2 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$2(obj);
}
var _require$1 = util$1, inspect$1 = _require$1.inspect;
var _require2$1 = errors, ERR_INVALID_ARG_TYPE$1 = _require2$1.codes.ERR_INVALID_ARG_TYPE; // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var blue = "";
var green = "";
var red = "";
var white = "";
var kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
}; // Comparing short primitives should just show === / !== instead of using the
// diff.
var kMaxShortLength = 10;
function copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return inspect$1(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = inspectValue(expected).split("\n");
    var i = 0;
    var indicator = ""; // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && _typeof$2(actual) === "object" && _typeof$2(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
     // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length; // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= kMaxShortLength) {
            if ((_typeof$2(actual) !== "object" || actual === null) && (_typeof$2(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                 // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat(repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    } // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length); // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n"); // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat(blue, "...").concat(white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat(blue, "...").concat(white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
    var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the expected line to the cache.
            other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
            printedLines++; // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            } // Mark the current line as the last diverging one.
            lastPos = i; // Add the actual line to the result.
            res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
            printedLines++; // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i]; // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine); // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat(blue, "...").concat(white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                } // Mark the current line as the last diverging one.
                lastPos = i; // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
                other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
                printedLines += 2; // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = ""; // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        } // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var AssertionError$1 = /*#__PURE__*/ function(_Error) {
    _inherits(AssertionError, _Error);
    function AssertionError(options) {
        var _this;
        _classCallCheck$1(this, AssertionError);
        if (_typeof$2(options) !== "object" || options === null) throw new ERR_INVALID_ARG_TYPE$1("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, String(message)));
        else {
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if (_typeof$2(actual) === "object" && actual !== null && _typeof$2(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = copyError(actual);
                expected = copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, createErrDiff(actual, expected, operator)));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = kReadableOperator[operator];
                var res = inspectValue(actual).split("\n"); // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && _typeof$2(actual) === "object" && actual !== null) base = kReadableOperator.notStrictEqualObject;
                 // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat(blue, "...").concat(white);
                    while(res.length > 27)res.pop();
                } // Only print a single input.
                if (res.length === 1) _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(base, " ").concat(res[0])));
                else _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n")));
            } else {
                var _res = inspectValue(actual);
                var other = "";
                var knownOperators = kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat(inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "".concat(_res).concat(other)));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty(_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
         // Create error message including the error code in the name.
        _this.stack; // Reset the name.
        _this.name = "AssertionError";
        return _possibleConstructorReturn(_this);
    }
    _createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: inspect$1.custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return inspect$1(this, _objectSpread({}, ctx, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(_wrapNativeSuper(Error));
var assertion_error = AssertionError$1;
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ function assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError("Cannot convert first argument to object");
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function polyfill$4() {
    if (!Object.assign) Object.defineProperty(Object, "assign", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: assign
    });
}
var es6ObjectAssign = {
    assign: assign,
    polyfill: polyfill$4
};
var toStr$2 = Object.prototype.toString;
var isArguments = function isArguments(value) {
    var str = toStr$2.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr$2.call(value.callee) === "[object Function]";
    return isArgs;
};
var keysShim$1;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr$1 = Object.prototype.toString;
    var isArgs$1 = isArguments; // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
        toString: null
    }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {}, "prototype");
    var dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!excludedKeys["$" + k] && has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
        /* global window */ if (typeof window === "undefined" || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
        try {
            return equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    keysShim$1 = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = toStr$1.call(object) === "[object Function]";
        var isArguments = isArgs$1(object);
        var isString = isObject && toStr$1.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && has.call(object, name)) theKeys.push(String(name));
        }
        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === "constructor") && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
        }
        return theKeys;
    };
}
var implementation$6 = keysShim$1;
var slice = Array.prototype.slice;
var isArgs = isArguments;
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
} : implementation$6;
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            // eslint-disable-line func-name-matching
            if (isArgs(object)) return originalKeys(slice.call(object));
            return originalKeys(object);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
var objectKeys = keysShim;
var keys = objectKeys;
var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;
var isFunction = function isFunction(fn) {
    return typeof fn === "function" && toStr.call(fn) === "[object Function]";
};
var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
    var obj = {};
    try {
        origDefineProperty(obj, "x", {
            enumerable: false,
            value: obj
        }); // eslint-disable-next-line no-unused-vars, no-restricted-syntax
        for(var _ in obj)// jscs:ignore disallowUnusedVariables
        return false;
        return obj.x === obj;
    } catch (e) {
        /* this is IE 8. */ return false;
    }
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
var defineProperty = function defineProperty(object, name, value, predicate) {
    if (name in object && (!isFunction(predicate) || !predicate())) return;
    if (supportsDescriptors) origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value;
};
var defineProperties = function defineProperties(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
var defineProperties_1 = defineProperties;
var numberIsNaN$1 = function numberIsNaN(value) {
    return value !== value;
};
var implementation$5 = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if (numberIsNaN$1(a) && numberIsNaN$1(b)) return true;
    return false;
};
var implementation$4 = implementation$5;
var polyfill$3 = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : implementation$4;
};
var getPolyfill$3 = polyfill$3;
var define$3 = defineProperties_1;
var shim$3 = function shimObjectIs() {
    var polyfill = getPolyfill$3();
    define$3(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};
var define$2 = defineProperties_1;
var callBind$1 = callBind$3.exports;
var implementation$3 = implementation$5;
var getPolyfill$2 = polyfill$3;
var shim$2 = shim$3;
var polyfill$2 = callBind$1(getPolyfill$2(), Object);
define$2(polyfill$2, {
    getPolyfill: getPolyfill$2,
    implementation: implementation$3,
    shim: shim$2
});
var objectIs$2 = polyfill$2;
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ var implementation$2 = function isNaN1(value) {
    return value !== value;
};
var implementation$1 = implementation$2;
var polyfill$1 = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return implementation$1;
};
var define$1 = defineProperties_1;
var getPolyfill$1 = polyfill$1;
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ var shim$1 = function shimNumberIsNaN() {
    var polyfill = getPolyfill$1();
    define$1(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};
var callBind = callBind$3.exports;
var define = defineProperties_1;
var implementation = implementation$2;
var getPolyfill = polyfill$1;
var shim = shim$1;
var polyfill = callBind(getPolyfill(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
var isNan = polyfill;
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof$1(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof$1 = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof$1(obj);
}
var regexFlagsSupported = /a/g.flags !== undefined;
var arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};
var objectIs$1 = Object.is ? Object.is : objectIs$2;
var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};
var numberIsNaN = Number.isNaN ? Number.isNaN : isNan;
function uncurryThis(f) {
    return f.call.bind(f);
}
var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
var objectToString = uncurryThis(Object.prototype.toString);
var _require$types$1 = util$1.types, isAnyArrayBuffer = _require$types$1.isAnyArrayBuffer, isArrayBufferView = _require$types$1.isArrayBufferView, isDate = _require$types$1.isDate, isMap = _require$types$1.isMap, isRegExp$1 = _require$types$1.isRegExp, isSet = _require$types$1.isSet, isNativeError = _require$types$1.isNativeError, isBoxedPrimitive = _require$types$1.isBoxedPrimitive, isNumberObject = _require$types$1.isNumberObject, isStringObject = _require$types$1.isStringObject, isBooleanObject = _require$types$1.isBooleanObject, isBigIntObject = _require$types$1.isBigIntObject, isSymbolObject = _require$types$1.isSymbolObject, isFloat32Array = _require$types$1.isFloat32Array, isFloat64Array = _require$types$1.isFloat64Array;
function isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    } // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function getOwnNonIndexProperties(value) {
    return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
} // Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var kStrict = true;
var kLoose = false;
var kNoIterator = 0;
var kIsArray = 1;
var kIsSet = 2;
var kIsMap = 3; // Check if they have the same source and flags
function areSimilarRegExps(a, b) {
    return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function isEqualBoxedPrimitive(val1, val2) {
    if (isNumberObject(val1)) return isNumberObject(val2) && objectIs$1(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if (isStringObject(val1)) return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if (isBooleanObject(val1)) return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if (isBigIntObject(val1)) return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
} // Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? objectIs$1(val1, val2) : true;
    } // Check more closely if val1 and val2 are equal.
    if (strict) {
        if (_typeof$1(val1) !== "object") return typeof val1 === "number" && numberIsNaN(val1) && numberIsNaN(val2);
        if (_typeof$1(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || _typeof$1(val1) !== "object") {
            if (val2 === null || _typeof$1(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || _typeof$1(val2) !== "object") return false;
    }
    var val1Tag = objectToString(val1);
    var val2Tag = objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = getOwnNonIndexProperties(val1);
        var keys2 = getOwnNonIndexProperties(val2);
        if (keys1.length !== keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
    } // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) return false;
    }
    if (isDate(val1)) {
        if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if (isRegExp$1(val1)) {
        if (!isRegExp$1(val2) || !areSimilarRegExps(val1, val2)) return false;
    } else if (isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if (isArrayBufferView(val1)) {
        if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
            if (!areSimilarFloatArrays(val1, val2)) return false;
        } else if (!areSimilarTypedArrays(val1, val2)) return false;
         // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = getOwnNonIndexProperties(val1);
        var _keys2 = getOwnNonIndexProperties(val2);
        if (_keys.length !== _keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
    } else if (isSet(val1)) {
        if (!isSet(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsSet);
    } else if (isMap(val1)) {
        if (!isMap(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsMap);
    } else if (isAnyArrayBuffer(val1)) {
        if (!areEqualArrayBuffers(val1, val2)) return false;
    } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) return false;
    return keyCheck(val1, val2, strict, memos, kNoIterator);
}
function getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return propertyIsEnumerable(val, k);
    });
}
function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2); // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    } // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if (propertyIsEnumerable(val1, key)) {
                    if (!propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if (propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) return true;
     // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if (innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
} // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function findLooseMatchingPrimitives(prim) {
    switch(_typeof$1(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if (numberIsNaN(prim)) return false;
    }
    return true;
}
function setMightHaveLoosePrim(a, b, prim) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
}
function setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i]; // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if (_typeof$1(val) === "object" && val !== null) {
            if (set === null) set = new Set();
             // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false; // Fast path to detect missing string, symbol, undefined and null values.
            if (!setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i]; // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if (_typeof$1(_val) === "object" && _val !== null) {
                if (!setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = _slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if (_typeof$1(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false; // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = _slicedToArray(bEntries[_i2], 2), key = _bEntries$_i[0], item = _bEntries$_i[1];
            if (_typeof$1(key) === "object" && key !== null) {
                if (!mapHasEqualEntry(set, a, key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(key) || !innerDeepEqual(a.get(key), item, false, memo)) && !mapHasEqualEntry(set, a, key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === kIsSet) {
        if (!setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsMap) {
        if (!mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsArray) for(; i < a.length; i++){
        if (hasOwnProperty(a, i)) {
            if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if (hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
     // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key = keys[i];
        if (!innerDeepEqual(a[_key], b[_key], strict, memos)) return false;
    }
    return true;
}
function isDeepEqual$1(val1, val2) {
    return innerDeepEqual(val1, val2, kLoose);
}
function isDeepStrictEqual$1(val1, val2) {
    return innerDeepEqual(val1, val2, kStrict);
}
var comparisons = {
    isDeepEqual: isDeepEqual$1,
    isDeepStrictEqual: isDeepStrictEqual$1
};
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var _require = errors, _require$codes = _require.codes, ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE, ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
var AssertionError = assertion_error;
var _require2 = util$1, inspect = _require2.inspect;
var _require$types = util$1.types, isPromise = _require$types.isPromise, isRegExp = _require$types.isRegExp;
var objectAssign = Object.assign ? Object.assign : es6ObjectAssign.assign;
var objectIs = Object.is ? Object.is : objectIs$2;
var isDeepEqual;
var isDeepStrictEqual;
function lazyLoadComparison() {
    var comparison = comparisons;
    isDeepEqual = comparison.isDeepEqual;
    isDeepStrictEqual = comparison.isDeepStrictEqual;
} // Escape control characters but not \n and \t to keep the line breaks and
var warned = false; // The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var assert = assert$2.exports = ok;
var NO_EXCEPTION_SENTINEL = {}; // All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new AssertionError(obj);
}
function fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if (warned === false) {
            warned = true;
            var warn = console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new AssertionError(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
assert.fail = fail; // The AssertionError is defined in internal/error.
assert.AssertionError = AssertionError;
function innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new AssertionError({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
} // Pure assertion tests whether a value is truthy, as determined
// by !!value.
function ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    innerOk.apply(void 0, [
        ok,
        args.length
    ].concat(args));
}
assert.ok = ok; // The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual != expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
}; // The non-equality assertion tests for whether two objects are not
// equal with !=.
assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
     // eslint-disable-next-line eqeqeq
    if (actual == expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
}; // The equivalence assertion tests a deep equality relation.
assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
}; // The non-equivalence assertion tests for any deep inequality.
assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: notDeepStrictEqual
    });
}
assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (!objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS("actual", "expected");
    if (objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var Comparison = function Comparison(obj, keys, actual) {
    var _this = this;
    _classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && isRegExp(obj[key]) && obj[key].test(actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
};
function compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new Comparison(actual, keys);
            var b = new Comparison(expected, keys, actual);
            var err = new AssertionError({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if (isRegExp(expected)) return expected.test(actual); // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
         // Handle primitives properly.
        if (_typeof(actual) !== "object" || actual === null) {
            var err = new AssertionError({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected); // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if (isDeepEqual === undefined) lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && isRegExp(expected[key]) && expected[key].test(actual[key])) return;
            compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    } // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function getActual(fn) {
    if (typeof fn !== "function") throw new ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return NO_EXCEPTION_SENTINEL;
}
function checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return isPromise(obj) || obj !== null && _typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn(); // Fail in case no promise is returned.
            if (!checkIsPromise(resultPromise)) throw new ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if (checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if (_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && _typeof(error) !== "object" && typeof error !== "function") throw new ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !expectedException(actual, error, message, stackStartFn)) throw actual;
}
function expectsNoError(stackStartFn, actual, error, message) {
    if (actual === NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    expectsError.apply(void 0, [
        throws,
        getActual(promiseFn)
    ].concat(args));
};
assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return waitForActual(promiseFn).then(function(result) {
        return expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    expectsNoError.apply(void 0, [
        doesNotThrow,
        getActual(fn)
    ].concat(args));
};
assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return waitForActual(fn).then(function(result) {
        return expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if (_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += inspect(err);
        var newErr = new AssertionError({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        }); // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift(); // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
}; // Expose a strict only variant of assert
function strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    innerOk.apply(void 0, [
        strict,
        args.length
    ].concat(args));
}
assert.strict = objectAssign(strict, assert, {
    equal: assert.strictEqual,
    deepEqual: assert.deepStrictEqual,
    notEqual: assert.notStrictEqual,
    notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var zstream = ZStream;
var deflate$1 = {};
var common = {};
(function(exports) {
    var TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
    function _has(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
    }
    exports.assign = function(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        while(sources.length){
            var source = sources.shift();
            if (!source) continue;
            if (typeof source !== "object") throw new TypeError(source + "must be non-object");
            for(var p in source)if (_has(source, p)) obj[p] = source[p];
        }
        return obj;
    }; // reduce buffer size, avoiding mem copy
    exports.shrinkBuf = function(buf, size) {
        if (buf.length === size) return buf;
        if (buf.subarray) return buf.subarray(0, size);
        buf.length = size;
        return buf;
    };
    var fnTyped = {
        arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
            if (src.subarray && dest.subarray) {
                dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
                return;
            } // Fallback to ordinary array
            for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
        },
        // Join array of chunks to single array.
        flattenChunks: function flattenChunks(chunks) {
            var i, l, len, pos, chunk, result; // calculate data length
            len = 0;
            for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
             // join chunks
            result = new Uint8Array(len);
            pos = 0;
            for(i = 0, l = chunks.length; i < l; i++){
                chunk = chunks[i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
    };
    var fnUntyped = {
        arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
            for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
        },
        // Join array of chunks to single array.
        flattenChunks: function flattenChunks(chunks) {
            return [].concat.apply([], chunks);
        }
    }; // Enable/Disable typed arrays use, for testing
    //
    exports.setTyped = function(on) {
        if (on) {
            exports.Buf8 = Uint8Array;
            exports.Buf16 = Uint16Array;
            exports.Buf32 = Int32Array;
            exports.assign(exports, fnTyped);
        } else {
            exports.Buf8 = Array;
            exports.Buf16 = Array;
            exports.Buf32 = Array;
            exports.assign(exports, fnUntyped);
        }
    };
    exports.setTyped(TYPED_OK);
})(common);
var trees$1 = {};
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ var utils$3 = common;
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED$1 = 4; //var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
var Z_TEXT = 1; //var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN$1 = 2;
/*============================================================================*/ function zero$1(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
} // From zutil.h
var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES = 2;
/* The three kinds of block type */ var MIN_MATCH$1 = 3;
var MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS$1 = 256;
/* number of literal bytes 0..255 */ var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES$1 = 30;
/* number of distance codes */ var BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
/* maximum heap size */ var MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
/* end of block literal code */ var REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var DIST_CODE_LEN = 512;
/* see definition of array dist_code below */ // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES$1);
zero$1(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES$1);
zero$1(base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree;
    /* static tree or NULL */ this.extra_bits = extra_bits;
    /* extra bits for each code or NULL */ this.extra_base = extra_base;
    /* base index for extra_bits */ this.elems = elems;
    /* max number of elements in the tree */ this.max_length = max_length;
    /* max bit length for the codes */ // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var static_l_desc;
var static_d_desc;
var static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree;
    /* the dynamic tree */ this.max_code = 0;
    /* largest code with non zero frequency */ this.stat_desc = stat_desc;
/* the corresponding static tree */ }
function d_code(dist) {
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
    if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function send_code(s, c, tree) {
    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
    if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h;
    /* heap index */ var n, m;
    /* iterate over the tree elements */ var bits;
    /* bit length */ var xbits;
    /* extra bits */ var f;
    /* frequency */ var overflow = 0;
    /* number of elements with bit length too large */ for(bits = 0; bits <= MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0;
    /* root of the heap */ for(h = s.heap_max + 1; h < HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
        /* not a leaf node */ s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
     // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--;
        /* move one leaf down the tree */ s.bl_count[bits + 1] += 2;
        /* move one overflow item as its brother */ s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array(MAX_BITS$1 + 1);
    /* next code value for each bit length */ var code = 0;
    /* running code value */ var bits;
    /* bit index */ var n;
    /* code index */ /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS$1; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len); //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
    var n;
    /* iterates over tree elements */ var bits;
    /* bit counter */ var length;
    /* length value */ var code;
    /* code value */ var dist;
    /* distance index */ var bl_count = new Array(MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
    static_l_desc.static_tree = static_ltree;
    static_l_desc.extra_bits = extra_lbits;
    static_d_desc.static_tree = static_dtree;
    static_d_desc.extra_bits = extra_dbits;
    static_bl_desc.extra_bits = extra_blbits;
  #endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < LENGTH_CODES$1 - 1; code++){
        base_length[code] = length;
        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
    } //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        base_dist[code] = dist;
        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
    } //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7;
    /* from now on, all distances are divided by 128 */ for(; code < D_CODES$1; code++){
        base_dist[code] = dist << 7;
        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
    } //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES$1; n++){
        static_dtree[n * 2 + 1] = 5;
        static_dtree[n * 2] = bi_reverse(n, 5);
    } // Now data ready and we can init static trees
    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES$1, MAX_BITS$1);
    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES$1, MAX_BL_BITS); //static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
    var n;
    /* iterates over tree elements */ /* Initialize the trees. */ for(n = 0; n < L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
    if (s.bi_valid > 8) put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    bi_windup(s);
    /* align on byte boundary */ if (header) {
        put_short(s, len);
        put_short(s, ~len);
    } //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    utils$3.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1;
    /* left son of k */ while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
} // inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist;
    /* distance of matched string */ var lc;
    /* match length or unmatched char (if dist == 0) */ var lx = 0;
    /* running index in l_buf */ var code;
    /* the code to send */ var extra;
    /* number of extra bits to send */ if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) send_code(s, lc, ltree);
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
            send_code(s, code + LITERALS$1 + 1, ltree);
            /* send the length code */ extra = extra_lbits[code];
            if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra);
            /* send the extra length bits */ }
            dist--;
            /* dist is now the match distance - 1 */ code = d_code(dist); //Assert (code < D_CODES, "bad d_code");
            send_code(s, code, dtree);
            /* send the distance code */ extra = extra_dbits[code];
            if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra);
            /* send the extra distance bits */ }
        }
    /* literal or match pair ? */ /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    send_code(s, END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m;
    /* iterate over heap elements */ var max_code = -1;
    /* largest code with non zero frequency */ var node;
    /* new node being created */ /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems;
    /* next internal node of the tree */ do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1];
        s.heap[1] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1);
        /***/ m = s.heap[1];
        /* m = node of next least frequency */ s.heap[--s.heap_max] = n;
        /* keep the nodes sorted by frequency */ s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1] = node++;
        pqdownheap(s, tree, 1);
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n;
    /* iterates over all tree elements */ var prevlen = -1;
    /* last emitted length */ var curlen;
    /* length of current code */ var nextlen = tree[1] /*.Len*/ ;
    /* length of next code */ var count = 0;
    /* repeat count of the current code */ var max_count = 7;
    /* max repeat count */ var min_count = 4;
    /* min repeat count */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff;
    /* guard */ for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
        else s.bl_tree[REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n;
    /* iterates over all tree elements */ var prevlen = -1;
    /* last emitted length */ var curlen;
    /* length of current code */ var nextlen = tree[1] /*.Len*/ ;
    /* length of next code */ var count = 0;
    /* repeat count of the current code */ var max_count = 7;
    /* max repeat count */ var min_count = 4;
    /* min repeat count */ /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                send_code(s, curlen, s.bl_tree);
                count--;
            } //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
        } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
    var max_blindex;
    /* index of last bit length code of non zero freq */ /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank;
    /* index in bl_order */ //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    send_bits(s, lcodes - 257, 5);
    /* not +255 as stated in appnote.txt */ send_bits(s, dcodes - 1, 5);
    send_bits(s, blcodes - 4, 4);
    /* not -3 as stated in appnote.txt */ for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
     //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_ltree, lcodes - 1);
    /* literal tree */ //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_dtree, dcodes - 1);
/* distance tree */ //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
    for(n = 32; n < LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
}
var static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
    if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
    }
    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
    /* send block type */ copy_block(s, buf, stored_len, true);
/* with header */ }
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
    send_bits(s, STATIC_TREES << 1, 3);
    send_code(s, END_BLOCK, static_ltree);
    bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb;
    /* opt_len and static_len in bytes */ var max_blindex = 0;
    /* index of last bit length code of non zero freq */ /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN$1) s.strm.data_type = detect_data_type(s);
        /* Construct the literal and distance trees */ build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5;
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
    } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
    } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
    if (last) bi_windup(s);
     // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--;
        /* dist = match distance - 1 */ //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[d_code(dist) * 2]++;
    } // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
trees$1._tr_init = _tr_init;
trees$1._tr_stored_block = _tr_stored_block;
trees$1._tr_flush_block = _tr_flush_block;
trees$1._tr_tally = _tr_tally;
trees$1._tr_align = _tr_align;
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function adler32$2(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
var adler32_1 = adler32$2;
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
} // Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();
function crc32$2(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
var crc32_1 = crc32$2;
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version"
};
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils$2 = common;
var trees = trees$1;
var adler32$1 = adler32_1;
var crc32$1 = crc32_1;
var msg = messages;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
var Z_PARTIAL_FLUSH = 1; //var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH = 3;
var Z_FINISH$1 = 4;
var Z_BLOCK$1 = 5; //var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK$1 = 0;
var Z_STREAM_END$1 = 1; //var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR$1 = -2;
var Z_DATA_ERROR$1 = -3; //var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR$1 = -5; //var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;
var Z_FILTERED = 1;
var Z_HUFFMAN_ONLY = 2;
var Z_RLE = 3;
var Z_FIXED = 4;
var Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/* The deflate compression method */ var Z_DEFLATED$1 = 8;
/*============================================================================*/ var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS$1 = 15;
/* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
var PRESET_DICT = 0x20;
var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;
var BS_NEED_MORE = 1;
/* block not completed, need more input or more output */ var BS_BLOCK_DONE = 2;
/* block flush performed */ var BS_FINISH_STARTED = 3;
/* finish started, need only more output at next deflate */ var BS_FINISH_DONE = 4;
/* finish done, accept no more input or output */ var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function err(strm, errorCode) {
    strm.msg = msg[errorCode];
    return errorCode;
}
function rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
    var s = strm.state; //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    utils$2.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function flush_block_only(s, last) {
    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    flush_pending(s.strm);
}
function put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);
    utils$2.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = adler32$1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = crc32$1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
    var chain_length = s.max_chain_length;
    /* max hash chain length */ var scan = s.strstart;
    /* current string */ var match;
    /* matched string */ var len;
    /* length of current match */ var best_len = s.prev_length;
    /* best match length so far */ var nice_match = s.nice_match;
    /* stop if match long enough */ var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
     // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++; // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str; //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils$2.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask; //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ } //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
    var hash_head;
    /* head of the hash chain */ var bflush;
    /* set if current block must be flushed */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
        if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match && s.lookahead >= MIN_MATCH) {
                s.match_length--;
                /* string at strstart already in table */ do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask; //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
    var hash_head;
    /* head of hash chain */ var bflush;
    /* set if current block must be flushed */ var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;
        if (hash_head !== 0 && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096)) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                if (s.strm.avail_out === 0) return BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    } //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
    var bflush;
    /* set if current block must be flushed */ var prev;
    /* byte at distance one to match */ var scan, strend;
    /* scan goes up to strend for length of run */ var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            } //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
    var bflush;
    /* set if current block must be flushed */ for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                break;
            /* flush the current block */ }
        }
        /* Output a literal byte */ s.match_length = 0; //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH$1) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var configuration_table;
configuration_table = [
    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
    s.good_match = configuration_table[s.level].good_length;
    s.nice_match = configuration_table[s.level].nice_length;
    s.max_chain_length = configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function DeflateState() {
    this.strm = null;
    /* pointer back to this zlib stream */ this.status = 0;
    /* as the name implies */ this.pending_buf = null;
    /* output still pending */ this.pending_buf_size = 0;
    /* size of pending_buf */ this.pending_out = 0;
    /* next pending byte to output to the stream */ this.pending = 0;
    /* nb of bytes in the pending buffer */ this.wrap = 0;
    /* bit 0 true for zlib, bit 1 true for gzip */ this.gzhead = null;
    /* gzip header information to write */ this.gzindex = 0;
    /* where in extra, name, or comment */ this.method = Z_DEFLATED$1;
    /* can only be DEFLATED */ this.last_flush = -1;
    /* value of flush param for previous deflate call */ this.w_size = 0;
    /* LZ77 window size (32K by default) */ this.w_bits = 0;
    /* log2(w_size)  (8..16) */ this.w_mask = 0;
    /* w_size - 1 */ this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null;
    /* Heads of the hash chains or NIL. */ this.ins_h = 0;
    /* hash index of string to be inserted */ this.hash_size = 0;
    /* number of elements in hash table */ this.hash_bits = 0;
    /* log2(hash_size) */ this.hash_mask = 0;
    /* hash_size-1 */ this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0;
    /* length of best match */ this.prev_match = 0;
    /* previous match */ this.match_available = 0;
    /* set if previous match exists */ this.strstart = 0;
    /* start of string to insert */ this.match_start = 0;
    /* start of matching string */ this.lookahead = 0;
    /* number of valid bytes ahead in window */ this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0;
    /* compression level (1..9) */ this.strategy = 0;
    /* favor or force Huffman coding*/ this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0;
    /* Stop searching when current match exceeds this */ /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new utils$2.Buf16(HEAP_SIZE * 2);
    this.dyn_dtree = new utils$2.Buf16((2 * D_CODES + 1) * 2);
    this.bl_tree = new utils$2.Buf16((2 * BL_CODES + 1) * 2);
    zero(this.dyn_ltree);
    zero(this.dyn_dtree);
    zero(this.bl_tree);
    this.l_desc = null;
    /* desc. for literal tree */ this.d_desc = null;
    /* desc. for distance tree */ this.bl_desc = null;
    /* desc. for bit length tree */ //ush bl_count[MAX_BITS+1];
    this.bl_count = new utils$2.Buf16(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new utils$2.Buf16(2 * L_CODES + 1);
    /* heap used to build the Huffman trees */ zero(this.heap);
    this.heap_len = 0;
    /* number of elements in the heap */ this.heap_max = 0;
    /* element of largest frequency */ /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils$2.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
    zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0;
    /* buffer index for literals or lengths */ this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0;
    /* running index in l_buf */ this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0;
    /* bit length of current block with optimal trees */ this.static_len = 0;
    /* bit length of current block with static trees */ this.matches = 0;
    /* number of string matches in current block */ this.insert = 0;
    /* bytes at end of window left to insert */ this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR$1);
    strm.total_in = strm.total_out = 0;
    strm.data_type = Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = Z_NO_FLUSH;
    trees._tr_init(s);
    return Z_OK$1;
}
function deflateReset(strm) {
    var ret = deflateResetKeep(strm);
    if (ret === Z_OK$1) lm_init(strm.state);
    return ret;
}
function deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return Z_STREAM_ERROR$1;
    if (strm.state.wrap !== 2) return Z_STREAM_ERROR$1;
    strm.state.gzhead = head;
    return Z_OK$1;
}
function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) // === Z_NULL
    return Z_STREAM_ERROR$1;
    var wrap = 1;
    if (level === Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        /* suppress zlib wrapper */ wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2;
        /* write gzip wrapper instead */ windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$1 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR$1);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    s.window = new utils$2.Buf8(s.w_size * 2);
    s.head = new utils$2.Buf16(s.hash_size);
    s.prev = new utils$2.Buf16(s.w_size); // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6;
    /* 16K elements by default */ s.pending_buf_size = s.lit_bufsize * 4; //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new utils$2.Buf8(s.pending_buf_size); // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize; //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return deflateReset(strm);
}
function deflateInit(strm, level) {
    return deflateInit2(strm, level, Z_DEFLATED$1, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}
function deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > Z_BLOCK$1 || flush < 0) return strm ? err(strm, Z_STREAM_ERROR$1) : Z_STREAM_ERROR$1;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH$1) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$1);
    s.strm = strm;
    /* just in case */ old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === INIT_STATE) {
        if (s.wrap === 2) {
            // GZIP header
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
                // s->gzhead == Z_NULL
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, OS_CODE);
                s.status = BUSY_STATE;
            } else {
                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                put_byte(s, s.gzhead.time & 0xff);
                put_byte(s, s.gzhead.time >> 8 & 0xff);
                put_byte(s, s.gzhead.time >> 16 & 0xff);
                put_byte(s, s.gzhead.time >> 24 & 0xff);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    put_byte(s, s.gzhead.extra.length & 0xff);
                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = EXTRA_STATE;
            }
        } else {
            var header = Z_DEFLATED$1 + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= PRESET_DICT;
            header += 31 - header % 31;
            s.status = BUSY_STATE;
            putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    } //#ifdef GZIP
    if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra) {
            beg = s.pending;
            /* start of bytes to update crc */ while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = NAME_STATE;
            }
        } else s.status = NAME_STATE;
    }
    if (s.status === NAME_STATE) {
        if (s.gzhead.name) {
            beg = s.pending;
            /* start of bytes to update crc */ //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                } // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = COMMENT_STATE;
            }
        } else s.status = COMMENT_STATE;
    }
    if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment) {
            beg = s.pending;
            /* start of bytes to update crc */ //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                } // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32$1(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = HCRC_STATE;
        } else s.status = HCRC_STATE;
    }
    if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = BUSY_STATE;
            }
        } else s.status = BUSY_STATE;
    } //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return Z_OK$1;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH$1) return err(strm, Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR$1);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return Z_OK$1;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
            else if (flush !== Z_BLOCK$1) {
                /* FULL_FLUSH or SYNC_FLUSH */ trees._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1;
                /* avoid BUF_ERROR at next call, see above */ return Z_OK$1;
            }
        }
    } //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== Z_FINISH$1) return Z_OK$1;
    if (s.wrap <= 0) return Z_STREAM_END$1;
    /* Write the trailer */ if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        put_byte(s, strm.adler >> 16 & 0xff);
        put_byte(s, strm.adler >> 24 & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, strm.total_in >> 8 & 0xff);
        put_byte(s, strm.total_in >> 16 & 0xff);
        put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
    }
    flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK$1 : Z_STREAM_END$1;
}
function deflateEnd(strm) {
    var status;
    if (!strm || !strm.state) return Z_STREAM_ERROR$1;
    status = strm.state.status;
    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR$1);
    strm.state = null;
    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$1) : Z_OK$1;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm || !strm.state) return Z_STREAM_ERROR$1;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR$1;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32$1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0;
    /* avoid computing Adler-32 in read_buf */ /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /* already empty otherwise */ /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new utils$2.Buf8(s.w_size);
        utils$2.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    fill_window(s);
    while(s.lookahead >= MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - (MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return Z_OK$1;
}
deflate$1.deflateInit = deflateInit;
deflate$1.deflateInit2 = deflateInit2;
deflate$1.deflateReset = deflateReset;
deflate$1.deflateResetKeep = deflateResetKeep;
deflate$1.deflateSetHeader = deflateSetHeader;
deflate$1.deflate = deflate;
deflate$1.deflateEnd = deflateEnd;
deflate$1.deflateSetDictionary = deflateSetDictionary;
deflate$1.deflateInfo = "pako deflate (from Nodeca project)";
var inflate$1 = {};
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var BAD$1 = 30;
/* got a data error -- remain here until reset */ var TYPE$1 = 12;
/* i: waiting for type bits, including last-flag bit */ /*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var inffast = function inflate_fast(strm, start) {
    var state;
    var _in;
    /* local strm.input */ var last;
    /* have enough input while in < last */ var _out;
    /* local strm.output */ var beg;
    /* inflate()'s initial strm.output */ var end;
    /* while out < end, enough space available */ //#ifdef INFLATE_STRICT
    var dmax;
    /* maximum distance from zlib header */ //#endif
    var wsize;
    /* window size or zero if not using window */ var whave;
    /* valid bytes in the window */ var wnext;
    /* window write index */ // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window;
    /* allocated sliding window, if wsize != 0 */ var hold;
    /* local strm.hold */ var bits;
    /* local strm.bits */ var lcode;
    /* local strm.lencode */ var dcode;
    /* local strm.distcode */ var lmask;
    /* mask for first level of length codes */ var dmask;
    /* mask for first level of distance codes */ var here;
    /* retrieved table entry */ var op;
    /* code bits, operation, extra bits, or */ /*  window position, window bytes to copy */ var len;
    /* match length, unused bytes */ var dist;
    /* match distance */ var from;
    /* where to copy match from */ var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state; //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257); //#ifdef INFLATE_STRICT
    dmax = state.dmax; //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            // Goto emulation
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) /* literal */ //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                /* length base */ len = here & 0xffff /*here.val*/ ;
                op &= 15;
                /* number of extra bits */ if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                } //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    // goto emulation
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        /* distance base */ dist = here & 0xffff /*here.val*/ ;
                        op &= 15;
                        /* number of extra bits */ if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1; //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = BAD$1;
                            break top;
                        } //#endif
                        hold >>>= op;
                        bits -= op; //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg;
                        /* max distance in output */ if (dist > op) {
                            /* see if copy from window */ op = dist - op;
                            /* distance back in window */ if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = BAD$1;
                                    break top;
                                } // (!) This block is disabled in zlib defaults,
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                /* very common case */ from += wsize - op;
                                if (op < len) {
                                    /* some from window */ len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist;
                                    /* rest from output */ from_source = output;
                                }
                            } else if (wnext < op) {
                                /* wrap around window */ from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    /* some from end of window */ len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        /* some from start of window */ op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist;
                                        /* rest from output */ from_source = output;
                                    }
                                }
                            } else {
                                /* contiguous in window */ from += wnext - op;
                                if (op < len) {
                                    /* some from window */ len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist;
                                    /* rest from output */ from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist;
                            /* copy direct from output */ do {
                                /* minimum length is three */ output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        /* 2nd level distance code */ here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                /* 2nd level length code */ here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                /* end-of-block */ //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils$1 = common;
var MAXBITS = 15;
var ENOUGH_LENS$1 = 852;
var ENOUGH_DISTS$1 = 592; //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var CODES$1 = 0;
var LENS$1 = 1;
var DISTS$1 = 2;
var lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
var inftrees = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits; //here = opts.here; /* table entry for duplication */
    var len = 0;
    /* a code's length in bits */ var sym = 0;
    /* index of code symbols */ var min = 0, max = 0;
    /* minimum and maximum code lengths */ var root = 0;
    /* number of index bits for root table */ var curr = 0;
    /* number of index bits for current table */ var drop = 0;
    /* code bits to drop for sub-table */ var left = 0;
    /* number of prefix codes available */ var used = 0;
    /* code entries in table used */ var huff = 0;
    /* Huffman code */ var incr;
    /* for incrementing code, index */ var fill;
    /* index for replicating entries */ var low;
    /* low bits for current root entry */ var mask;
    /* mask for low root bits */ var next;
    /* next available space in table */ var base = null;
    /* base value table to use */ var base_index = 0; //  var shoextra;    /* extra bits table to use */
    var end;
    /* use base and extra for symbol > end */ var count = new utils$1.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new utils$1.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.
    This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.
    The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.
    The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        /* no symbols to code at all */ //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520; //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0;
    /* no symbols, but wait for decoding to report error */ }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
    /* over-subscribed */ }
    if (left > 0 && (type === CODES$1 || max !== 1)) return -1;
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.
    root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.
    When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.
    used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.
    sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === CODES$1) {
        base = extra = work;
        /* dummy value--not used */ end = 19;
    } else if (type === LENS$1) {
        base = lbase;
        base_index -= 257;
        extra = lext;
        extra_index -= 257;
        end = 256;
    } else {
        /* DISTS */ base = dbase;
        extra = dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0;
    /* starting code */ sym = 0;
    /* starting code symbol */ len = min;
    /* starting code length */ next = table_index;
    /* current table to fill in */ curr = root;
    /* current table index bits */ drop = 0;
    /* current bits to drop from code for index */ low = -1;
    /* trigger new sub-table when len > root */ used = 1 << root;
    /* use root table entries */ mask = used - 1;
    /* mask for comparing low */ /* check available table space */ if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96;
            /* end of block */ here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill;
        /* save offset to next table */ do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min;
            /* here min is 1 << curr */ /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = common;
var adler32 = adler32_1;
var crc32 = crc32_1;
var inflate_fast = inffast;
var inflate_table = inftrees;
var CODES = 0;
var LENS = 1;
var DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
var Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
var Z_NEED_DICT = 2; //var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
var Z_MEM_ERROR = -4;
var Z_BUF_ERROR = -5; //var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1;
/* i: waiting for magic header */ var FLAGS = 2;
/* i: waiting for method and flags (gzip) */ var TIME = 3;
/* i: waiting for modification time (gzip) */ var OS = 4;
/* i: waiting for extra flags and operating system (gzip) */ var EXLEN = 5;
/* i: waiting for extra length (gzip) */ var EXTRA = 6;
/* i: waiting for extra bytes (gzip) */ var NAME = 7;
/* i: waiting for end of file name (gzip) */ var COMMENT = 8;
/* i: waiting for end of comment (gzip) */ var HCRC = 9;
/* i: waiting for header crc (gzip) */ var DICTID = 10;
/* i: waiting for dictionary check value */ var DICT = 11;
/* waiting for inflateSetDictionary() call */ var TYPE = 12;
/* i: waiting for type bits, including last-flag bit */ var TYPEDO = 13;
/* i: same, but skip check to exit inflate on new block */ var STORED = 14;
/* i: waiting for stored size (length and complement) */ var COPY_ = 15;
/* i/o: same as COPY below, but only first time in */ var COPY = 16;
/* i/o: waiting for input or output to copy stored block */ var TABLE = 17;
/* i: waiting for dynamic block table lengths */ var LENLENS = 18;
/* i: waiting for code length code lengths */ var CODELENS = 19;
/* i: waiting for length/lit and distance code lengths */ var LEN_ = 20;
/* i: same as LEN below, but only first time in */ var LEN = 21;
/* i: waiting for length/lit/eob code */ var LENEXT = 22;
/* i: waiting for length extra bits */ var DIST = 23;
/* i: waiting for distance code */ var DISTEXT = 24;
/* i: waiting for distance extra bits */ var MATCH = 25;
/* o: waiting for output space to copy string */ var LIT = 26;
/* o: waiting for output space to write literal */ var CHECK = 27;
/* i: waiting for 32-bit check value */ var LENGTH = 28;
/* i: waiting for 32-bit length (gzip) */ var DONE = 29;
/* finished check, done -- remain here until reset */ var BAD = 30;
/* got a data error -- remain here until reset */ var MEM = 31;
/* got an inflate() memory error -- remain here until reset */ var SYNC = 32;
/* looking for synchronization bytes to restart inflate() */ /* ===========================================================================*/ var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592; //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
function zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function InflateState() {
    this.mode = 0;
    /* current inflate mode */ this.last = false;
    /* true if processing last block */ this.wrap = 0;
    /* bit 0 true for zlib, bit 1 true for gzip */ this.havedict = false;
    /* true if dictionary provided */ this.flags = 0;
    /* gzip header method and flags (0 if zlib) */ this.dmax = 0;
    /* zlib header max distance (INFLATE_STRICT) */ this.check = 0;
    /* protected copy of check value */ this.total = 0;
    /* protected copy of output count */ // TODO: may be {}
    this.head = null;
    /* where to save gzip header information */ /* sliding window */ this.wbits = 0;
    /* log base 2 of requested window size */ this.wsize = 0;
    /* window size or zero if not using window */ this.whave = 0;
    /* valid bytes in the window */ this.wnext = 0;
    /* window write index */ this.window = null;
    /* allocated sliding window, if needed */ /* bit accumulator */ this.hold = 0;
    /* input bit accumulator */ this.bits = 0;
    /* number of bits in "in" */ /* for string and stored block copying */ this.length = 0;
    /* literal or length of data to copy */ this.offset = 0;
    /* distance back to copy string from */ /* for table and code decoding */ this.extra = 0;
    /* extra bits needed */ /* fixed and dynamic code tables */ this.lencode = null;
    /* starting table for length/literal codes */ this.distcode = null;
    /* starting table for distance codes */ this.lenbits = 0;
    /* index bits for lencode */ this.distbits = 0;
    /* index bits for distcode */ /* dynamic table building */ this.ncode = 0;
    /* number of code length code lengths */ this.nlen = 0;
    /* number of length code lengths */ this.ndist = 0;
    /* number of distance code lengths */ this.have = 0;
    /* number of code lengths in lens[] */ this.next = null;
    /* next available space in codes[] */ this.lens = new utils.Buf16(320);
    /* temporary storage for code lengths */ this.work = new utils.Buf16(288);
    /* work area for code table building */ /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null;
    /* dynamic table for length/literal codes (JS specific) */ this.distdyn = null;
    /* dynamic table for distance codes (JS specific) */ this.sane = 0;
    /* if false, allow invalid distance too far */ this.back = 0;
    /* bits back of last unprocessed length/lit */ this.was = 0;
/* initial length of match */ }
function inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = "";
    /*Z_NULL*/ if (state.wrap) /* to support ill-conceived Java test suite */ strm.adler = state.wrap & 1;
    state.mode = HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0; //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1; //Tracev((stderr, "inflate: reset\n"));
    return Z_OK;
}
function inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return inflateResetKeep(strm);
}
function inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return inflateReset(strm);
}
function inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return Z_STREAM_ERROR;
     //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new InflateState(); //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = inflateReset2(strm, windowBits);
    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function inflateInit(strm) {
    return inflateInit2(strm, DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
var lenfix, distfix; // We have no pointers in JS, so keep tables separate
function fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
        var sym;
        lenfix = new utils.Buf32(512);
        distfix = new utils.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ virgin = false;
    }
    state.lencode = lenfix;
    state.lenbits = 9;
    state.distcode = distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new utils.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
         //zmemcpy(state->window + state->wnext, end - copy, dist);
        utils.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next;
    /* next input INDEX */ var put;
    /* next output INDEX */ var have, left;
    /* available input and output */ var hold;
    /* bit buffer */ var bits;
    /* bits in bit buffer */ var _in, _out;
    /* save starting available input and output */ var copy;
    /* number of stored or match bytes to copy */ var from;
    /* where to copy match bytes from */ var from_source;
    var here = 0;
    /* current decoding table entry */ var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len;
    /* length to copy for repeats, bits to drop */ var ret;
    /* return code */ var hbuf = new utils.Buf8(4);
    /* buffer for gzip header crc calculation */ var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === TYPE) state.mode = TYPEDO;
    /* skip check */ //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits; //---
    _in = have;
    _out = left;
    ret = Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case HEAD:
            if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
            } //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            } //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                /* gzip header */ state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ; //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0); //===//
                //=== INITBITS();
                hold = 0;
                bits = 0; //===//
                state.mode = FLAGS;
                break;
            }
            state.flags = 0;
            /* expect zlib header */ if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = BAD;
                break;
            }
            if ((hold & 0x0f) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            } //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4; //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = BAD;
                break;
            }
            state.dmax = 1 << len; //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? DICTID : TYPE; //=== INITBITS();
            hold = 0;
            bits = 0; //===//
            break;
        case FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            } //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0); //===//
            } //=== INITBITS();
            hold = 0;
            bits = 0; //===//
            state.mode = TIME;
        /* falls through */ case TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            } //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0); //===
            } //=== INITBITS();
            hold = 0;
            bits = 0; //===//
            state.mode = OS;
        /* falls through */ case OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            } //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0); //===//
            } //=== INITBITS();
            hold = 0;
            bits = 0; //===//
            state.mode = EXLEN;
        /* falls through */ case EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                } //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = crc32(state.check, hbuf, 2, 0); //===//
                } //=== INITBITS();
                hold = 0;
                bits = 0; //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = EXTRA;
        /* falls through */ case EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        utils.arraySet(state.head.extra, input, next, // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len); //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = NAME;
        /* falls through */ case NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = COMMENT;
        /* falls through */ case COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = HCRC;
        /* falls through */ case HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                } //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = BAD;
                    break;
                } //=== INITBITS();
                hold = 0;
                bits = 0; //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = TYPE;
            break;
        case DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            } //===//
            strm.adler = state.check = zswap32(hold); //=== INITBITS();
            hold = 0;
            bits = 0; //===//
            state.mode = DICT;
        /* falls through */ case DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits; //---
                return Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = TYPE;
        /* falls through */ case TYPE:
            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
        /* falls through */ case TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7; //---//
                state.mode = CHECK;
                break;
            } //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            } //===//
            state.last = hold & 0x01 /*BITS(1)*/ ; //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1; //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = STORED;
                    break;
                case 1:
                    /* fixed block */ fixedtables(state); //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = LEN_;
                    /* decode codes */ if (flush === Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2; //---//
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = BAD;
            } //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2; //---//
            break;
        case STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7; //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            } //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = BAD;
                break;
            }
            state.length = hold & 0xffff; //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0; //===//
            state.mode = COPY_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case COPY_:
            state.mode = COPY;
        /* falls through */ case COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                 //--- zmemcpy(put, next, copy); ---
                utils.arraySet(output, input, next, copy, put); //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            } //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = TYPE;
            break;
        case TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            } //===//
            state.nlen = (hold & 0x1f) + 257; //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5; //---//
            state.ndist = (hold & 0x1f) + 1; //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5; //---//
            state.ncode = (hold & 0x0f) + 4; //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4; //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = BAD;
                break;
            } //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = LENLENS;
        /* falls through */ case LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                } //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3; //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
             // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = BAD;
                break;
            } //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = CODELENS;
        /* falls through */ case CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1];
                    /*BITS(state.lenbits)*/ here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                     //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8; //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits; //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        } //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits; //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2; //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        } //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits; //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3; //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        } //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits; //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7; //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts); // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits; // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = BAD;
                break;
            }
            state.distbits = 6; //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts); // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits; // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = BAD;
                break;
            } //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = LEN_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case LEN_:
            state.mode = LEN;
        /* falls through */ case LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits; //---
                inflate_fast(strm, _out); //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits; //---
                if (state.mode === TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1];
                /*BITS(state.lenbits)*/ here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                 //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8; //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                     //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8; //---//
                } //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits; //---//
                state.back += last_bits;
            } //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits; //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = LENEXT;
        /* falls through */ case LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                } //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ; //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra; //---//
                state.back += state.extra;
            } //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = DIST;
        /* falls through */ case DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1];
                /*BITS(state.distbits)*/ here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                 //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8; //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                     //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8; //---//
                } //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits; //---//
                state.back += last_bits;
            } //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits; //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = DISTEXT;
        /* falls through */ case DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                } //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ; //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra; //---//
                state.back += state.extra;
            } //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = BAD;
                break;
            } //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = MATCH;
        /* falls through */ case MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                /* copy from window */ copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = BAD;
                        break;
                    } // (!) This block is disabled in zlib defaults,
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                /* copy from output */ from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = LEN;
            break;
        case LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = LEN;
            break;
        case CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--; // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                } //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                _out = left; // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = BAD;
                    break;
                } //=== INITBITS();
                hold = 0;
                bits = 0; //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = LENGTH;
        /* falls through */ case LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                } //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = BAD;
                    break;
                } //=== INITBITS();
                hold = 0;
                bits = 0; //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = DONE;
        /* falls through */ case DONE:
            ret = Z_STREAM_END;
            break inf_leave;
        case BAD:
            ret = Z_DATA_ERROR;
            break inf_leave;
        case MEM:
            return Z_MEM_ERROR;
        case SYNC:
        /* falls through */ default:
            return Z_STREAM_ERROR;
    }
     // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits; //---
    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
    return ret;
}
function inflateEnd(strm) {
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return Z_OK;
}
function inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return Z_OK;
}
function inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === DICT) {
        dictid = 1;
        /* adler32(0, null, 0)*/ /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = MEM;
        return Z_MEM_ERROR;
    }
    state.havedict = 1; // Tracev((stderr, "inflate:   dictionary set\n"));
    return Z_OK;
}
inflate$1.inflateReset = inflateReset;
inflate$1.inflateReset2 = inflateReset2;
inflate$1.inflateResetKeep = inflateResetKeep;
inflate$1.inflateInit = inflateInit;
inflate$1.inflateInit2 = inflateInit2;
inflate$1.inflate = inflate;
inflate$1.inflateEnd = inflateEnd;
inflate$1.inflateGetHeader = inflateGetHeader;
inflate$1.inflateSetDictionary = inflateSetDictionary;
inflate$1.inflateInfo = "pako inflate (from Nodeca project)";
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var constants = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8 //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
(function(exports) {
    /* eslint camelcase: "off" */ var assert = assert$2.exports;
    var Zstream = zstream;
    var zlib_deflate = deflate$1;
    var zlib_inflate = inflate$1;
    var constants$1 = constants;
    for(var key in constants$1)exports[key] = constants$1[key];
     // zlib modes
    exports.NONE = 0;
    exports.DEFLATE = 1;
    exports.INFLATE = 2;
    exports.GZIP = 3;
    exports.GUNZIP = 4;
    exports.DEFLATERAW = 5;
    exports.INFLATERAW = 6;
    exports.UNZIP = 7;
    var GZIP_HEADER_ID1 = 0x1f;
    var GZIP_HEADER_ID2 = 0x8b;
    /**
   * Emulate Node's zlib C++ layer for use by the JS layer in index.js
   */ function Zlib(mode) {
        if (typeof mode !== "number" || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError("Bad argument");
        this.dictionary = null;
        this.err = 0;
        this.flush = 0;
        this.init_done = false;
        this.level = 0;
        this.memLevel = 0;
        this.mode = mode;
        this.strategy = 0;
        this.windowBits = 0;
        this.write_in_progress = false;
        this.pending_close = false;
        this.gzip_id_bytes_read = 0;
    }
    Zlib.prototype.close = function() {
        if (this.write_in_progress) {
            this.pending_close = true;
            return;
        }
        this.pending_close = false;
        assert(this.init_done, "close before init");
        assert(this.mode <= exports.UNZIP);
        if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
        else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
        this.mode = exports.NONE;
        this.dictionary = null;
    };
    Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
        return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
    };
    Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
        return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
    };
    Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
        assert.equal(arguments.length, 8);
        assert(this.init_done, "write before init");
        assert(this.mode !== exports.NONE, "already finalized");
        assert.equal(false, this.write_in_progress, "write already in progress");
        assert.equal(false, this.pending_close, "close is pending");
        this.write_in_progress = true;
        assert.equal(false, flush === undefined, "must provide flush value");
        this.write_in_progress = true;
        if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error("Invalid flush value");
        if (input == null) {
            input = Buffer$1.alloc(0);
            in_len = 0;
            in_off = 0;
        }
        this.strm.avail_in = in_len;
        this.strm.input = input;
        this.strm.next_in = in_off;
        this.strm.avail_out = out_len;
        this.strm.output = out;
        this.strm.next_out = out_off;
        this.flush = flush;
        if (!async) {
            // sync version
            this._process();
            if (this._checkError()) return this._afterSync();
            return;
        } // async version
        var self1 = this;
        browser$1$1.nextTick(function() {
            self1._process();
            self1._after();
        });
        return this;
    };
    Zlib.prototype._afterSync = function() {
        var avail_out = this.strm.avail_out;
        var avail_in = this.strm.avail_in;
        this.write_in_progress = false;
        return [
            avail_in,
            avail_out
        ];
    };
    Zlib.prototype._process = function() {
        var next_expected_header_byte = null; // If the avail_out is left at 0, then it means that it ran out
        // of room.  If there was avail_out left over, then it means
        // that all of the input was consumed.
        switch(this.mode){
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflate(this.strm, this.flush);
                break;
            case exports.UNZIP:
                if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
                switch(this.gzip_id_bytes_read){
                    case 0:
                        if (next_expected_header_byte === null) break;
                        if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                            this.gzip_id_bytes_read = 1;
                            next_expected_header_byte++;
                            if (this.strm.avail_in === 1) break;
                        } else {
                            this.mode = exports.INFLATE;
                            break;
                        }
                    // fallthrough
                    case 1:
                        if (next_expected_header_byte === null) break;
                        if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                            this.gzip_id_bytes_read = 2;
                            this.mode = exports.GUNZIP;
                        } else // There is no actual difference between INFLATE and INFLATERAW
                        // (after initialization).
                        this.mode = exports.INFLATE;
                        break;
                    default:
                        throw new Error("invalid number of gzip magic number bytes read");
                }
            // fallthrough
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
                this.err = zlib_inflate.inflate(this.strm, this.flush // If data was encoded with dictionary
                );
                if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                    // Load it
                    this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                    if (this.err === exports.Z_OK) // And try to decode again
                    this.err = zlib_inflate.inflate(this.strm, this.flush);
                    else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                    // Make it possible for After() to tell a bad dictionary from bad
                    // input.
                    this.err = exports.Z_NEED_DICT;
                }
                while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                    // Bytes remain in input buffer. Perhaps this is another compressed
                    // member in the same archive, or just trailing garbage.
                    // Trailing zero bytes are okay, though, since they are frequently
                    // used for padding.
                    this.reset();
                    this.err = zlib_inflate.inflate(this.strm, this.flush);
                }
                break;
            default:
                throw new Error("Unknown mode " + this.mode);
        }
    };
    Zlib.prototype._checkError = function() {
        // Acceptable error states depend on the type of zlib stream.
        switch(this.err){
            case exports.Z_OK:
            case exports.Z_BUF_ERROR:
                if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                    this._error("unexpected end of file");
                    return false;
                }
                break;
            case exports.Z_STREAM_END:
                break;
            case exports.Z_NEED_DICT:
                if (this.dictionary == null) this._error("Missing dictionary");
                else this._error("Bad dictionary");
                return false;
            default:
                // something else.
                this._error("Zlib error");
                return false;
        }
        return true;
    };
    Zlib.prototype._after = function() {
        if (!this._checkError()) return;
        var avail_out = this.strm.avail_out;
        var avail_in = this.strm.avail_in;
        this.write_in_progress = false; // call the write() cb
        this.callback(avail_in, avail_out);
        if (this.pending_close) this.close();
    };
    Zlib.prototype._error = function(message) {
        if (this.strm.msg) message = this.strm.msg;
        this.onerror(message, this.err // no hope of rescue.
        );
        this.write_in_progress = false;
        if (this.pending_close) this.close();
    };
    Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
        assert(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])");
        assert(windowBits >= 8 && windowBits <= 15, "invalid windowBits");
        assert(level >= -1 && level <= 9, "invalid compression level");
        assert(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
        assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, "invalid strategy");
        this._init(level, windowBits, memLevel, strategy, dictionary);
        this._setDictionary();
    };
    Zlib.prototype.params = function() {
        throw new Error("deflateParams Not supported");
    };
    Zlib.prototype.reset = function() {
        this._reset();
        this._setDictionary();
    };
    Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
        this.level = level;
        this.windowBits = windowBits;
        this.memLevel = memLevel;
        this.strategy = strategy;
        this.flush = exports.Z_NO_FLUSH;
        this.err = exports.Z_OK;
        if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
        if (this.mode === exports.UNZIP) this.windowBits += 32;
        if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
        this.strm = new Zstream();
        switch(this.mode){
            case exports.DEFLATE:
            case exports.GZIP:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
                break;
            case exports.INFLATE:
            case exports.GUNZIP:
            case exports.INFLATERAW:
            case exports.UNZIP:
                this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
                break;
            default:
                throw new Error("Unknown mode " + this.mode);
        }
        if (this.err !== exports.Z_OK) this._error("Init error");
        this.dictionary = dictionary;
        this.write_in_progress = false;
        this.init_done = true;
    };
    Zlib.prototype._setDictionary = function() {
        if (this.dictionary == null) return;
        this.err = exports.Z_OK;
        switch(this.mode){
            case exports.DEFLATE:
            case exports.DEFLATERAW:
                this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
                break;
        }
        if (this.err !== exports.Z_OK) this._error("Failed to set dictionary");
    };
    Zlib.prototype._reset = function() {
        this.err = exports.Z_OK;
        switch(this.mode){
            case exports.DEFLATE:
            case exports.DEFLATERAW:
            case exports.GZIP:
                this.err = zlib_deflate.deflateReset(this.strm);
                break;
            case exports.INFLATE:
            case exports.INFLATERAW:
            case exports.GUNZIP:
                this.err = zlib_inflate.inflateReset(this.strm);
                break;
        }
        if (this.err !== exports.Z_OK) this._error("Failed to reset stream");
    };
    exports.Zlib = Zlib;
})(binding);
(function(exports) {
    var Buffer = buffer.Buffer;
    var Transform = require$$1.Transform;
    var binding$1 = binding;
    var util = util$1;
    var assert = assert$2.exports.ok;
    var kMaxLength = buffer.kMaxLength;
    var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + " bytes"; // zlib doesn't provide these, so kludge them in following the same
    // const naming scheme zlib uses.
    binding$1.Z_MIN_WINDOWBITS = 8;
    binding$1.Z_MAX_WINDOWBITS = 15;
    binding$1.Z_DEFAULT_WINDOWBITS = 15; // fewer than 64 bytes per chunk is stupid.
    // technically it could work with as few as 8, but even 64 bytes
    // is absurdly low.  Usually a MB or more is best.
    binding$1.Z_MIN_CHUNK = 64;
    binding$1.Z_MAX_CHUNK = Infinity;
    binding$1.Z_DEFAULT_CHUNK = 16384;
    binding$1.Z_MIN_MEMLEVEL = 1;
    binding$1.Z_MAX_MEMLEVEL = 9;
    binding$1.Z_DEFAULT_MEMLEVEL = 8;
    binding$1.Z_MIN_LEVEL = -1;
    binding$1.Z_MAX_LEVEL = 9;
    binding$1.Z_DEFAULT_LEVEL = binding$1.Z_DEFAULT_COMPRESSION; // expose all the zlib constants
    var bkeys = Object.keys(binding$1);
    for(var bk = 0; bk < bkeys.length; bk++){
        var bkey = bkeys[bk];
        if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
            enumerable: true,
            value: binding$1[bkey],
            writable: false
        });
    } // translation table for return codes.
    var codes = {
        Z_OK: binding$1.Z_OK,
        Z_STREAM_END: binding$1.Z_STREAM_END,
        Z_NEED_DICT: binding$1.Z_NEED_DICT,
        Z_ERRNO: binding$1.Z_ERRNO,
        Z_STREAM_ERROR: binding$1.Z_STREAM_ERROR,
        Z_DATA_ERROR: binding$1.Z_DATA_ERROR,
        Z_MEM_ERROR: binding$1.Z_MEM_ERROR,
        Z_BUF_ERROR: binding$1.Z_BUF_ERROR,
        Z_VERSION_ERROR: binding$1.Z_VERSION_ERROR
    };
    var ckeys = Object.keys(codes);
    for(var ck = 0; ck < ckeys.length; ck++){
        var ckey = ckeys[ck];
        codes[codes[ckey]] = ckey;
    }
    Object.defineProperty(exports, "codes", {
        enumerable: true,
        value: Object.freeze(codes),
        writable: false
    });
    exports.Deflate = Deflate;
    exports.Inflate = Inflate;
    exports.Gzip = Gzip;
    exports.Gunzip = Gunzip;
    exports.DeflateRaw = DeflateRaw;
    exports.InflateRaw = InflateRaw;
    exports.Unzip = Unzip;
    exports.createDeflate = function(o) {
        return new Deflate(o);
    };
    exports.createInflate = function(o) {
        return new Inflate(o);
    };
    exports.createDeflateRaw = function(o) {
        return new DeflateRaw(o);
    };
    exports.createInflateRaw = function(o) {
        return new InflateRaw(o);
    };
    exports.createGzip = function(o) {
        return new Gzip(o);
    };
    exports.createGunzip = function(o) {
        return new Gunzip(o);
    };
    exports.createUnzip = function(o) {
        return new Unzip(o);
    }; // Convenience methods.
    // compress/decompress a string or buffer in one step.
    exports.deflate = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Deflate(opts), buffer, callback);
    };
    exports.deflateSync = function(buffer, opts) {
        return zlibBufferSync(new Deflate(opts), buffer);
    };
    exports.gzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Gzip(opts), buffer, callback);
    };
    exports.gzipSync = function(buffer, opts) {
        return zlibBufferSync(new Gzip(opts), buffer);
    };
    exports.deflateRaw = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new DeflateRaw(opts), buffer, callback);
    };
    exports.deflateRawSync = function(buffer, opts) {
        return zlibBufferSync(new DeflateRaw(opts), buffer);
    };
    exports.unzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Unzip(opts), buffer, callback);
    };
    exports.unzipSync = function(buffer, opts) {
        return zlibBufferSync(new Unzip(opts), buffer);
    };
    exports.inflate = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Inflate(opts), buffer, callback);
    };
    exports.inflateSync = function(buffer, opts) {
        return zlibBufferSync(new Inflate(opts), buffer);
    };
    exports.gunzip = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new Gunzip(opts), buffer, callback);
    };
    exports.gunzipSync = function(buffer, opts) {
        return zlibBufferSync(new Gunzip(opts), buffer);
    };
    exports.inflateRaw = function(buffer, opts, callback) {
        if (typeof opts === "function") {
            callback = opts;
            opts = {};
        }
        return zlibBuffer(new InflateRaw(opts), buffer, callback);
    };
    exports.inflateRawSync = function(buffer, opts) {
        return zlibBufferSync(new InflateRaw(opts), buffer);
    };
    function zlibBuffer(engine, buffer, callback) {
        var buffers = [];
        var nread = 0;
        engine.on("error", onError);
        engine.on("end", onEnd);
        engine.end(buffer);
        flow();
        function flow() {
            var chunk;
            while(null !== (chunk = engine.read())){
                buffers.push(chunk);
                nread += chunk.length;
            }
            engine.once("readable", flow);
        }
        function onError(err) {
            engine.removeListener("end", onEnd);
            engine.removeListener("readable", flow);
            callback(err);
        }
        function onEnd() {
            var buf;
            var err = null;
            if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
            else buf = Buffer.concat(buffers, nread);
            buffers = [];
            engine.close();
            callback(err, buf);
        }
    }
    function zlibBufferSync(engine, buffer) {
        if (typeof buffer === "string") buffer = Buffer.from(buffer);
        if (!Buffer.isBuffer(buffer)) throw new TypeError("Not a string or buffer");
        var flushFlag = engine._finishFlushFlag;
        return engine._processChunk(buffer, flushFlag);
    } // generic zlib
    // minimal 2-byte header
    function Deflate(opts) {
        if (!(this instanceof Deflate)) return new Deflate(opts);
        Zlib.call(this, opts, binding$1.DEFLATE);
    }
    function Inflate(opts) {
        if (!(this instanceof Inflate)) return new Inflate(opts);
        Zlib.call(this, opts, binding$1.INFLATE);
    } // gzip - bigger header, same deflate compression
    function Gzip(opts) {
        if (!(this instanceof Gzip)) return new Gzip(opts);
        Zlib.call(this, opts, binding$1.GZIP);
    }
    function Gunzip(opts) {
        if (!(this instanceof Gunzip)) return new Gunzip(opts);
        Zlib.call(this, opts, binding$1.GUNZIP);
    } // raw - no header
    function DeflateRaw(opts) {
        if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
        Zlib.call(this, opts, binding$1.DEFLATERAW);
    }
    function InflateRaw(opts) {
        if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
        Zlib.call(this, opts, binding$1.INFLATERAW);
    } // auto-detect header.
    function Unzip(opts) {
        if (!(this instanceof Unzip)) return new Unzip(opts);
        Zlib.call(this, opts, binding$1.UNZIP);
    }
    function isValidFlushFlag(flag) {
        return flag === binding$1.Z_NO_FLUSH || flag === binding$1.Z_PARTIAL_FLUSH || flag === binding$1.Z_SYNC_FLUSH || flag === binding$1.Z_FULL_FLUSH || flag === binding$1.Z_FINISH || flag === binding$1.Z_BLOCK;
    } // the Zlib class they all inherit from
    // This thing manages the queue of requests, and returns
    // true or false if there is anything in the queue when
    // you call the .write() method.
    function Zlib(opts, mode) {
        var _this = this;
        this._opts = opts = opts || {};
        this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
        Transform.call(this, opts);
        if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error("Invalid flush flag: " + opts.flush);
        if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error("Invalid flush flag: " + opts.finishFlush);
        this._flushFlag = opts.flush || binding$1.Z_NO_FLUSH;
        this._finishFlushFlag = typeof opts.finishFlush !== "undefined" ? opts.finishFlush : binding$1.Z_FINISH;
        if (opts.chunkSize) {
            if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error("Invalid chunk size: " + opts.chunkSize);
        }
        if (opts.windowBits) {
            if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error("Invalid windowBits: " + opts.windowBits);
        }
        if (opts.level) {
            if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error("Invalid compression level: " + opts.level);
        }
        if (opts.memLevel) {
            if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error("Invalid memLevel: " + opts.memLevel);
        }
        if (opts.strategy) {
            if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + opts.strategy);
        }
        if (opts.dictionary) {
            if (!Buffer.isBuffer(opts.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
        }
        this._handle = new binding$1.Zlib(mode);
        var self1 = this;
        this._hadError = false;
        this._handle.onerror = function(message, errno) {
            // there is no way to cleanly recover.
            // continuing only obscures problems.
            _close(self1);
            self1._hadError = true;
            var error = new Error(message);
            error.errno = errno;
            error.code = exports.codes[errno];
            self1.emit("error", error);
        };
        var level = exports.Z_DEFAULT_COMPRESSION;
        if (typeof opts.level === "number") level = opts.level;
        var strategy = exports.Z_DEFAULT_STRATEGY;
        if (typeof opts.strategy === "number") strategy = opts.strategy;
        this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
        this._buffer = Buffer.allocUnsafe(this._chunkSize);
        this._offset = 0;
        this._level = level;
        this._strategy = strategy;
        this.once("end", this.close);
        Object.defineProperty(this, "_closed", {
            get: function get() {
                return !_this._handle;
            },
            configurable: true,
            enumerable: true
        });
    }
    util.inherits(Zlib, Transform);
    Zlib.prototype.params = function(level, strategy, callback) {
        if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + level);
        if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + strategy);
        if (this._level !== level || this._strategy !== strategy) {
            var self1 = this;
            this.flush(binding$1.Z_SYNC_FLUSH, function() {
                assert(self1._handle, "zlib binding closed");
                self1._handle.params(level, strategy);
                if (!self1._hadError) {
                    self1._level = level;
                    self1._strategy = strategy;
                    if (callback) callback();
                }
            });
        } else browser$1$1.nextTick(callback);
    };
    Zlib.prototype.reset = function() {
        assert(this._handle, "zlib binding closed");
        return this._handle.reset();
    }; // This is the _flush function called by the transform class,
    // internally, when the last chunk has been written.
    Zlib.prototype._flush = function(callback) {
        this._transform(Buffer.alloc(0), "", callback);
    };
    Zlib.prototype.flush = function(kind, callback) {
        var _this2 = this;
        var ws = this._writableState;
        if (typeof kind === "function" || kind === undefined && !callback) {
            callback = kind;
            kind = binding$1.Z_FULL_FLUSH;
        }
        if (ws.ended) {
            if (callback) browser$1$1.nextTick(callback);
        } else if (ws.ending) {
            if (callback) this.once("end", callback);
        } else if (ws.needDrain) {
            if (callback) this.once("drain", function() {
                return _this2.flush(kind, callback);
            });
        } else {
            this._flushFlag = kind;
            this.write(Buffer.alloc(0), "", callback);
        }
    };
    Zlib.prototype.close = function(callback) {
        _close(this, callback);
        browser$1$1.nextTick(emitCloseNT, this);
    };
    function _close(engine, callback) {
        if (callback) browser$1$1.nextTick(callback); // Caller may invoke .close after a zlib error (which will null _handle).
        if (!engine._handle) return;
        engine._handle.close();
        engine._handle = null;
    }
    function emitCloseNT(self1) {
        self1.emit("close");
    }
    Zlib.prototype._transform = function(chunk, encoding, cb) {
        var flushFlag;
        var ws = this._writableState;
        var ending = ws.ending || ws.ended;
        var last = ending && (!chunk || ws.length === chunk.length);
        if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error("invalid input"));
        if (!this._handle) return cb(new Error("zlib binding closed")); // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
        // (or whatever flag was provided using opts.finishFlush).
        // If it's explicitly flushing at some other time, then we use
        // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
        // goodness.
        if (last) flushFlag = this._finishFlushFlag;
        else {
            flushFlag = this._flushFlag; // once we've flushed the last of the queue, stop flushing and
            // go back to the normal behavior.
            if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding$1.Z_NO_FLUSH;
        }
        this._processChunk(chunk, flushFlag, cb);
    };
    Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
        var availInBefore = chunk && chunk.length;
        var availOutBefore = this._chunkSize - this._offset;
        var inOff = 0;
        var self1 = this;
        var async = typeof cb === "function";
        if (!async) {
            var buffers = [];
            var nread = 0;
            var error;
            this.on("error", function(er) {
                error = er;
            });
            assert(this._handle, "zlib binding closed");
            do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
            while (!this._hadError && callback(res[0], res[1]));
            if (this._hadError) throw error;
            if (nread >= kMaxLength) {
                _close(this);
                throw new RangeError(kRangeErrorMessage);
            }
            var buf = Buffer.concat(buffers, nread);
            _close(this);
            return buf;
        }
        assert(this._handle, "zlib binding closed");
        var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        req.buffer = chunk;
        req.callback = callback;
        function callback(availInAfter, availOutAfter) {
            // When the callback is used in an async write, the callback's
            // context is the `req` object that was created. The req object
            // is === this._handle, and that's why it's important to null
            // out the values after they are done being used. `this._handle`
            // can stay in memory longer than the callback and buffer are needed.
            if (this) {
                this.buffer = null;
                this.callback = null;
            }
            if (self1._hadError) return;
            var have = availOutBefore - availOutAfter;
            assert(have >= 0, "have should not go down");
            if (have > 0) {
                var out = self1._buffer.slice(self1._offset, self1._offset + have);
                self1._offset += have; // serve some output to the consumer.
                if (async) self1.push(out);
                else {
                    buffers.push(out);
                    nread += out.length;
                }
            } // exhausted the output buffer, or used all the input create a new one.
            if (availOutAfter === 0 || self1._offset >= self1._chunkSize) {
                availOutBefore = self1._chunkSize;
                self1._offset = 0;
                self1._buffer = Buffer.allocUnsafe(self1._chunkSize);
            }
            if (availOutAfter === 0) {
                // Not actually done.  Need to reprocess.
                // Also, update the availInBefore to the availInAfter value,
                // so that if we have to hit it a third (fourth, etc.) time,
                // it'll have the correct byte counts.
                inOff += availInBefore - availInAfter;
                availInBefore = availInAfter;
                if (!async) return true;
                var newReq = self1._handle.write(flushFlag, chunk, inOff, availInBefore, self1._buffer, self1._offset, self1._chunkSize);
                newReq.callback = callback; // this same function
                newReq.buffer = chunk;
                return;
            }
            if (!async) return false; // finished with the chunk.
            cb();
        }
    };
    util.inherits(Deflate, Zlib);
    util.inherits(Inflate, Zlib);
    util.inherits(Gzip, Zlib);
    util.inherits(Gunzip, Zlib);
    util.inherits(DeflateRaw, Zlib);
    util.inherits(InflateRaw, Zlib);
    util.inherits(Unzip, Zlib);
})(lib);
var PNG = /*#__PURE__*/ function() {
    PNG.decode = function decode(path, fn) {
        throw new Error("PNG.decode not available in browser build");
    };
    PNG.load = function load(path) {
        throw new Error("PNG.load not available in browser build");
    };
    function PNG(data) {
        var i;
        this.data = data;
        this.pos = 8; // Skip the default header
        this.palette = [];
        this.imgData = [];
        this.transparency = {};
        this.text = {};
        while(true){
            var chunkSize = this.readUInt32();
            var section = "";
            for(i = 0; i < 4; i++)section += String.fromCharCode(this.data[this.pos++]);
            switch(section){
                case "IHDR":
                    // we can grab  interesting values from here (like width, height, etc)
                    this.width = this.readUInt32();
                    this.height = this.readUInt32();
                    this.bits = this.data[this.pos++];
                    this.colorType = this.data[this.pos++];
                    this.compressionMethod = this.data[this.pos++];
                    this.filterMethod = this.data[this.pos++];
                    this.interlaceMethod = this.data[this.pos++];
                    break;
                case "PLTE":
                    this.palette = this.read(chunkSize);
                    break;
                case "IDAT":
                    for(i = 0; i < chunkSize; i++)this.imgData.push(this.data[this.pos++]);
                    break;
                case "tRNS":
                    // This chunk can only occur once and it must occur after the
                    // PLTE chunk and before the IDAT chunk.
                    this.transparency = {};
                    switch(this.colorType){
                        case 3:
                            // Indexed color, RGB. Each byte in this chunk is an alpha for
                            // the palette index in the PLTE ("palette") chunk up until the
                            // last non-opaque entry. Set up an array, stretching over all
                            // palette entries which will be 0 (opaque) or 1 (transparent).
                            this.transparency.indexed = this.read(chunkSize);
                            var short = 255 - this.transparency.indexed.length;
                            if (short > 0) for(i = 0; i < short; i++)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            // Greyscale. Corresponding to entries in the PLTE chunk.
                            // Grey is two bytes, range 0 .. (2 ^ bit-depth) - 1
                            this.transparency.grayscale = this.read(chunkSize)[0];
                            break;
                        case 2:
                            // True color with proper alpha channel.
                            this.transparency.rgb = this.read(chunkSize);
                            break;
                    }
                    break;
                case "tEXt":
                    var text = this.read(chunkSize);
                    var index = text.indexOf(0);
                    var key = String.fromCharCode.apply(String, text.slice(0, index));
                    this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
                    break;
                case "IEND":
                    // we've got everything we need!
                    switch(this.colorType){
                        case 0:
                        case 3:
                        case 4:
                            this.colors = 1;
                            break;
                        case 2:
                        case 6:
                            this.colors = 3;
                            break;
                    }
                    this.hasAlphaChannel = [
                        4,
                        6
                    ].includes(this.colorType);
                    var colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
                    this.pixelBitlength = this.bits * colors;
                    switch(this.colors){
                        case 1:
                            this.colorSpace = "DeviceGray";
                            break;
                        case 3:
                            this.colorSpace = "DeviceRGB";
                            break;
                    }
                    this.imgData = Buffer$1.from(this.imgData);
                    return;
                default:
                    // unknown (or unimportant) section, skip it
                    this.pos += chunkSize;
            }
            this.pos += 4; // Skip the CRC
            if (this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
    }
    var _proto = PNG.prototype;
    _proto.read = function read(bytes) {
        var result = new Array(bytes);
        for(var i = 0; i < bytes; i++)result[i] = this.data[this.pos++];
        return result;
    };
    _proto.readUInt32 = function readUInt32() {
        var b1 = this.data[this.pos++] << 24;
        var b2 = this.data[this.pos++] << 16;
        var b3 = this.data[this.pos++] << 8;
        var b4 = this.data[this.pos++];
        return b1 | b2 | b3 | b4;
    };
    _proto.readUInt16 = function readUInt16() {
        var b1 = this.data[this.pos++] << 8;
        var b2 = this.data[this.pos++];
        return b1 | b2;
    };
    _proto.decodePixels = function decodePixels(fn) {
        var _this = this;
        return lib.inflate(this.imgData, function(err, data) {
            if (err) throw err;
            var pos = 0;
            var width = _this.width, height = _this.height;
            var pixelBytes = _this.pixelBitlength / 8;
            var pixels = Buffer$1.alloc(width * height * pixelBytes);
            function pass(x0, y0, dx, dy, singlePass) {
                if (singlePass === void 0) singlePass = false;
                var w = Math.ceil((width - x0) / dx);
                var h = Math.ceil((height - y0) / dy);
                var scanlineLength = pixelBytes * w;
                var buffer = singlePass ? pixels : Buffer$1.alloc(scanlineLength * h);
                var row = 0;
                var c = 0;
                while(row < h && pos < data.length){
                    var byte;
                    var col;
                    var i;
                    var left;
                    var upper;
                    switch(data[pos++]){
                        case 0:
                            // None
                            for(i = 0; i < scanlineLength; i++)buffer[c++] = data[pos++];
                            break;
                        case 1:
                            // Sub
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                buffer[c++] = (byte + left) % 256;
                            }
                            break;
                        case 2:
                            // Up
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                buffer[c++] = (upper + byte) % 256;
                            }
                            break;
                        case 3:
                            // Average
                            for(i = 0; i < scanlineLength; i++){
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                upper = row && buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                buffer[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
                            }
                            break;
                        case 4:
                            // Paeth
                            for(i = 0; i < scanlineLength; i++){
                                var paeth;
                                var upperLeft;
                                byte = data[pos++];
                                col = (i - i % pixelBytes) / pixelBytes;
                                left = i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                if (row === 0) upper = upperLeft = 0;
                                else {
                                    upper = buffer[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                    upperLeft = col && buffer[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];
                                }
                                var p = left + upper - upperLeft;
                                var pa = Math.abs(p - left);
                                var pb = Math.abs(p - upper);
                                var pc = Math.abs(p - upperLeft);
                                if (pa <= pb && pa <= pc) paeth = left;
                                else if (pb <= pc) paeth = upper;
                                else paeth = upperLeft;
                                buffer[c++] = (byte + paeth) % 256;
                            }
                            break;
                        default:
                            throw new Error("Invalid filter algorithm: " + data[pos - 1]);
                    }
                    if (!singlePass) {
                        var pixelsPos = ((y0 + row * dy) * width + x0) * pixelBytes;
                        var bufferPos = row * scanlineLength;
                        for(i = 0; i < w; i++){
                            for(var j = 0; j < pixelBytes; j++)pixels[pixelsPos++] = buffer[bufferPos++];
                            pixelsPos += (dx - 1) * pixelBytes;
                        }
                    }
                    row++;
                }
            }
            if (_this.interlaceMethod === 1) {
                /*
          1 6 4 6 2 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
          3 6 4 6 3 6 4 6
          7 7 7 7 7 7 7 7
          5 6 5 6 5 6 5 6
          7 7 7 7 7 7 7 7
        */ pass(0, 0, 8, 8); // 1
                pass(4, 0, 8, 8); // 2
                pass(0, 4, 4, 8); // 3
                pass(2, 0, 4, 4); // 4
                pass(0, 2, 2, 4); // 5
                pass(1, 0, 2, 2); // 6
                pass(0, 1, 1, 2); // 7
            } else pass(0, 0, 1, 1, true);
            return fn(pixels);
        });
    };
    _proto.decodePalette = function decodePalette() {
        var palette = this.palette;
        var length = palette.length;
        var transparency = this.transparency.indexed || [];
        var ret = Buffer$1.alloc(transparency.length + length);
        var pos = 0;
        var c = 0;
        for(var i = 0; i < length; i += 3){
            var left;
            ret[pos++] = palette[i];
            ret[pos++] = palette[i + 1];
            ret[pos++] = palette[i + 2];
            ret[pos++] = (left = transparency[c++]) != null ? left : 255;
        }
        return ret;
    };
    _proto.copyToImageData = function copyToImageData(imageData, pixels) {
        var j;
        var k;
        var colors = this.colors;
        var palette = null;
        var alpha = this.hasAlphaChannel;
        if (this.palette.length) {
            palette = this._decodedPalette || (this._decodedPalette = this.decodePalette());
            colors = 4;
            alpha = true;
        }
        var data = imageData.data || imageData;
        var length = data.length;
        var input = palette || pixels;
        var i = j = 0;
        if (colors === 1) while(i < length){
            k = palette ? pixels[i / 4] * 4 : j;
            var v = input[k++];
            data[i++] = v;
            data[i++] = v;
            data[i++] = v;
            data[i++] = alpha ? input[k++] : 255;
            j = k;
        }
        else while(i < length){
            k = palette ? pixels[i / 4] * 4 : j;
            data[i++] = input[k++];
            data[i++] = input[k++];
            data[i++] = input[k++];
            data[i++] = alpha ? input[k++] : 255;
            j = k;
        }
    };
    _proto.decode = function decode(fn) {
        var _this2 = this;
        var ret = Buffer$1.alloc(this.width * this.height * 4);
        return this.decodePixels(function(pixels) {
            _this2.copyToImageData(ret, pixels);
            return fn(ret);
        });
    };
    return PNG;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j3MsZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>layout);
var _fns = require("@react-pdf/fns");
var _primitives = require("@react-pdf/primitives");
var _stylesheet = require("@react-pdf/stylesheet");
var _stylesheetDefault = parcelHelpers.interopDefault(_stylesheet);
var _textkit = require("@react-pdf/textkit");
var _textkitDefault = parcelHelpers.interopDefault(_textkit);
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _pdfkit = require("@react-pdf/pdfkit");
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _emojiRegex = require("emoji-regex");
var _emojiRegexDefault = parcelHelpers.interopDefault(_emojiRegex);
var _image = require("@react-pdf/image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _yoga = require("@react-pdf/yoga");
var _yogaDefault = parcelHelpers.interopDefault(_yoga);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/**
 * Create attributed string from text fragments
 *
 * @param  {Array}  fragments
 * @return {Object} attributed string
 */ var fromFragments = function fromFragments(fragments) {
    var offset = 0;
    var string = "";
    var runs = [];
    fragments.forEach(function(fragment) {
        string += fragment.string;
        runs.push({
            start: offset,
            end: offset + fragment.string.length,
            attributes: fragment.attributes || {}
        });
        offset += fragment.string.length;
    });
    return {
        string: string,
        runs: runs
    };
};
/**
 * Apply transformation to text string
 *
 * @param {String} text
 * @param {String} transformation type
 * @returns {String} transformed text
 */ var transformText = function transformText(text, transformation) {
    switch(transformation){
        case "uppercase":
            return text.toUpperCase();
        case "lowercase":
            return text.toLowerCase();
        case "capitalize":
            return (0, _fns.capitalize)(text);
        case "upperfirst":
            return (0, _fns.upperFirst)(text);
        default:
            return text;
    }
};
var StandardFont = /*#__PURE__*/ function() {
    function StandardFont(src) {
        this.name = src;
        this.src = (0, _pdfkit.PDFFont).open(null, src);
    }
    var _proto = StandardFont.prototype;
    _proto.encode = function encode(str) {
        return this.src.encode(str);
    };
    _proto.layout = function layout(str) {
        var _this = this;
        var _this$encode = this.encode(str), encoded = _this$encode[0], positions = _this$encode[1];
        return {
            positions: positions,
            stringIndices: positions.map(function(_, i) {
                return i;
            }),
            glyphs: encoded.map(function(g, i) {
                var glyph = _this.getGlyph(parseInt(g, 16));
                glyph.advanceWidth = positions[i].advanceWidth;
                return glyph;
            })
        };
    };
    _proto.glyphForCodePoint = function glyphForCodePoint(codePoint) {
        var glyph = this.getGlyph(codePoint);
        glyph.advanceWidth = 400;
        return glyph;
    };
    _proto.getGlyph = function getGlyph(id) {
        return {
            id: id,
            _font: this.src,
            codePoints: [
                id
            ],
            isLigature: false,
            name: this.src.font.characterToGlyph(id)
        };
    };
    _proto.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
        return this.src.font.characterToGlyph(codePoint) !== ".notdef";
    };
    (0, _createClassDefault.default)(StandardFont, [
        {
            key: "ascent",
            get: function get() {
                return 900;
            }
        },
        {
            key: "capHeight",
            get: function get() {
                switch(this.name){
                    case "Times-Roman":
                    case "Times-Bold":
                    case "Times-Italic":
                    case "Times-BoldItalic":
                        return 650;
                    case "Courier":
                    case "Courier-Bold":
                    case "Courier-Oblique":
                    case "Courier-BoldOblique":
                        return 550;
                    default:
                        return 690;
                }
            }
        },
        {
            key: "xHeight",
            get: function get() {
                switch(this.name){
                    case "Times-Roman":
                    case "Times-Bold":
                    case "Times-Italic":
                    case "Times-BoldItalic":
                        return 440;
                    case "Courier":
                    case "Courier-Bold":
                    case "Courier-Oblique":
                    case "Courier-BoldOblique":
                        return 390;
                    default:
                        return 490;
                }
            }
        },
        {
            key: "descent",
            get: function get() {
                switch(this.name){
                    case "Times-Roman":
                    case "Times-Bold":
                    case "Times-Italic":
                    case "Times-BoldItalic":
                        return -220;
                    case "Courier":
                    case "Courier-Bold":
                    case "Courier-Oblique":
                    case "Courier-BoldOblique":
                        return -230;
                    default:
                        return -200;
                }
            }
        },
        {
            key: "lineGap",
            get: function get() {
                return 0;
            }
        },
        {
            key: "unitsPerEm",
            get: function get() {
                return 1000;
            }
        }
    ]);
    return StandardFont;
}();
var fontCache = {};
var IGNORED_CODE_POINTS = [
    173
];
var getFontSize = function getFontSize(node) {
    return node.attributes.fontSize || 12;
};
var getOrCreateFont = function getOrCreateFont(name) {
    if (fontCache[name]) return fontCache[name];
    var font = new StandardFont(name);
    fontCache[name] = font;
    return font;
};
var getFallbackFont = function getFallbackFont() {
    return getOrCreateFont("Helvetica");
};
var shouldFallbackToFont = function shouldFallbackToFont(codePoint, font) {
    return !font || !IGNORED_CODE_POINTS.includes(codePoint) && !font.hasGlyphForCodePoint(codePoint) && getFallbackFont().hasGlyphForCodePoint(codePoint);
};
var fontSubstitution = function fontSubstitution() {
    return function(_ref) {
        var string = _ref.string, runs = _ref.runs;
        var lastFont = null;
        var lastFontSize = null;
        var lastIndex = 0;
        var index = 0;
        var res = [];
        for(var i = 0; i < runs.length; i += 1){
            var run = runs[i];
            var defaultFont = typeof run.attributes.font === "string" ? getOrCreateFont(run.attributes.font) : run.attributes.font;
            if (string.length === 0) {
                res.push({
                    start: 0,
                    end: 0,
                    attributes: {
                        font: defaultFont
                    }
                });
                break;
            }
            var chars = string.slice(run.start, run.end);
            for(var j = 0; j < chars.length; j += 1){
                var char = chars[j];
                var codePoint = char.codePointAt();
                var shouldFallback = shouldFallbackToFont(codePoint, defaultFont);
                // If the default font does not have a glyph and the fallback font does, we use it
                var font = shouldFallback ? getFallbackFont() : defaultFont;
                var fontSize = getFontSize(run);
                // If anything that would impact res has changed, update it
                if (font !== lastFont || fontSize !== lastFontSize || font.unitsPerEm !== lastFont.unitsPerEm) {
                    if (lastFont) res.push({
                        start: lastIndex,
                        end: index,
                        attributes: {
                            font: lastFont,
                            scale: lastFontSize / lastFont.unitsPerEm
                        }
                    });
                    lastFont = font;
                    lastFontSize = fontSize;
                    lastIndex = index;
                }
                index += char.length;
            }
        }
        if (lastIndex < string.length) {
            var _fontSize = getFontSize((0, _fns.last)(runs));
            res.push({
                start: lastIndex,
                end: string.length,
                attributes: {
                    font: lastFont,
                    scale: _fontSize / lastFont.unitsPerEm
                }
            });
        }
        return {
            string: string,
            runs: res
        };
    };
};
var isTextInstance$4 = function isTextInstance(node) {
    return node.type === _primitives.TextInstance;
};
var engines$1 = {
    linebreaker: (0, _textkit.linebreaker),
    justification: (0, _textkit.justification),
    textDecoration: (0, _textkit.textDecoration),
    scriptItemizer: (0, _textkit.scriptItemizer),
    wordHyphenation: (0, _textkit.wordHyphenation),
    fontSubstitution: fontSubstitution
};
var engine$1 = (0, _textkitDefault.default)(engines$1);
var getFragments$1 = function getFragments(fontStore, instance) {
    if (!instance) return [
        {
            string: ""
        }
    ];
    var fragments = [];
    var _instance$props = instance.props, _instance$props$fill = _instance$props.fill, fill = _instance$props$fill === void 0 ? "black" : _instance$props$fill, _instance$props$fontF = _instance$props.fontFamily, fontFamily = _instance$props$fontF === void 0 ? "Helvetica" : _instance$props$fontF, fontWeight = _instance$props.fontWeight, fontStyle = _instance$props.fontStyle, _instance$props$fontS = _instance$props.fontSize, fontSize = _instance$props$fontS === void 0 ? 18 : _instance$props$fontS, textDecorationColor = _instance$props.textDecorationColor, textDecorationStyle = _instance$props.textDecorationStyle, textTransform = _instance$props.textTransform, opacity = _instance$props.opacity;
    var _textDecoration = instance.props.textDecoration;
    var obj = fontStore ? fontStore.getFont({
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontStyle: fontStyle
    }) : null;
    var font = obj ? obj.data : fontFamily;
    var attributes = {
        font: font,
        opacity: opacity,
        fontSize: fontSize,
        color: fill,
        underlineStyle: textDecorationStyle,
        underline: _textDecoration === "underline" || _textDecoration === "underline line-through" || _textDecoration === "line-through underline",
        underlineColor: textDecorationColor || fill,
        strike: _textDecoration === "line-through" || _textDecoration === "underline line-through" || _textDecoration === "line-through underline",
        strikeStyle: textDecorationStyle,
        strikeColor: textDecorationColor || fill
    };
    for(var i = 0; i < instance.children.length; i += 1){
        var child = instance.children[i];
        if (isTextInstance$4(child)) fragments.push({
            string: transformText(child.value, textTransform),
            attributes: attributes
        });
        else if (child) fragments.push.apply(fragments, getFragments(child));
    }
    return fragments;
};
var getAttributedString$1 = function getAttributedString(fontStore, instance) {
    return fromFragments(getFragments$1(fontStore, instance));
};
var AlmostInfinity = 999999999999;
var shrinkWhitespaceFactor = {
    before: -0.5,
    after: -0.5
};
var layoutTspan = function layoutTspan(fontStore) {
    return function(node) {
        var _node$props, _node$props2;
        var attributedString = getAttributedString$1(fontStore, node);
        var x = ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.x) || 0;
        var y = ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.y) || 0;
        var container = {
            x: x,
            y: y,
            width: AlmostInfinity,
            height: AlmostInfinity
        };
        var hyphenationCallback = node.props.hyphenationCallback || (fontStore === null || fontStore === void 0 ? void 0 : fontStore.getHyphenationCallback()) || null;
        var layoutOptions = {
            hyphenationCallback: hyphenationCallback,
            shrinkWhitespaceFactor: shrinkWhitespaceFactor
        };
        var lines = engine$1(attributedString, container, layoutOptions).flat();
        return Object.assign({}, node, {
            lines: lines
        });
    };
};
var layoutText$1 = function layoutText(fontStore, node) {
    if (!node.children) return node;
    var children = node.children.map(layoutTspan(fontStore));
    return Object.assign({}, node, {
        children: children
    });
};
var isDefs = function isDefs(node) {
    return node.type === _primitives.Defs;
};
var getDefs = function getDefs(node) {
    var children = node.children || [];
    var defs = children.find(isDefs) || {};
    var values = defs.children || [];
    return values.reduce(function(acc, value) {
        var _value$props;
        var id = (_value$props = value.props) === null || _value$props === void 0 ? void 0 : _value$props.id;
        if (id) acc[id] = value;
        return acc;
    }, {});
};
var isNotDefs = function isNotDefs(node) {
    return node.type !== _primitives.Defs;
};
var detachDefs = function detachDefs(node) {
    if (!node.children) return node;
    var children = node.children.filter(isNotDefs);
    return Object.assign({}, node, {
        children: children
    });
};
var URL_REGEX = /url\(['"]?#([^'"]+)['"]?\)/;
var replaceDef = function replaceDef(defs, value) {
    if (!value) return undefined;
    if (!URL_REGEX.test(value)) return value;
    var match = value.match(URL_REGEX);
    return defs[match[1]];
};
var parseNodeDefs = function parseNodeDefs(defs) {
    return function(node) {
        var _node$props, _node$props2;
        var fill = replaceDef(defs, (_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.fill);
        var clipPath = replaceDef(defs, (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.clipPath);
        var props = Object.assign({}, node.props, {
            fill: fill,
            clipPath: clipPath
        });
        var children = node.children ? node.children.map(parseNodeDefs(defs)) : undefined;
        return Object.assign({}, node, {
            props: props,
            children: children
        });
    };
};
var parseDefs = function parseDefs(root) {
    if (!root.children) return root;
    var defs = getDefs(root);
    var children = root.children.map(parseNodeDefs(defs));
    return Object.assign({}, root, {
        children: children
    });
};
var replaceDefs = function replaceDefs(node) {
    return detachDefs(parseDefs(node));
};
var parseViewbox = function parseViewbox(value) {
    if (!value) return null;
    var values = value.split(/[,\s]+/).map(parseFloat);
    if (values.length !== 4) return null;
    return {
        minX: values[0],
        minY: values[1],
        maxX: values[2],
        maxY: values[3]
    };
};
var getContainer$1 = function getContainer(node) {
    var viewbox = parseViewbox(node.props.viewBox);
    if (viewbox) return {
        width: viewbox.maxX,
        height: viewbox.maxY
    };
    if (node.props.width && node.props.height) return {
        width: parseFloat(node.props.width),
        height: parseFloat(node.props.height)
    };
    return {
        width: 0,
        height: 0
    };
};
var SVG_INHERITED_PROPS = [
    "x",
    "y",
    "clipPath",
    "clipRule",
    "opacity",
    "fill",
    "fillOpacity",
    "fillRule",
    "stroke",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeOpacity",
    "strokeWidth",
    "textAnchor",
    "dominantBaseline",
    "color",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "letterSpacing",
    "opacity",
    "textDecoration",
    "lineHeight",
    "textAlign",
    "visibility",
    "wordSpacing"
];
var getInheritProps = function getInheritProps(node) {
    var props = node.props || {};
    return (0, _fns.pick)(SVG_INHERITED_PROPS, props);
};
var inheritProps = function inheritProps(node) {
    if (!node.children) return node;
    var inheritedProps = getInheritProps(node);
    var children = node.children.map(function(child) {
        var props = Object.assign({}, inheritedProps, child.props || {});
        var newChild = Object.assign({}, child, {
            props: props
        });
        return inheritProps(newChild);
    });
    return Object.assign({}, node, {
        children: children
    });
};
var parseAspectRatio = function parseAspectRatio(value) {
    var match = value.replace(/[\s\r\t\n]+/gm, " ").replace(/^defer\s/, "").split(" ");
    var align = match[0] || "xMidYMid";
    var meetOrSlice = match[1] || "meet";
    return {
        align: align,
        meetOrSlice: meetOrSlice
    };
};
var STYLE_PROPS = [
    "width",
    "height",
    "color",
    "stroke",
    "strokeWidth",
    "opacity",
    "fillOpacity",
    "strokeOpacity",
    "fill",
    "fillRule",
    "clipPath",
    "offset",
    "transform",
    "strokeLinejoin",
    "strokeLinecap",
    "strokeDasharray"
];
var VERTICAL_PROPS = [
    "y",
    "y1",
    "y2",
    "height",
    "cy",
    "ry"
];
var HORIZONTAL_PROPS = [
    "x",
    "x1",
    "x2",
    "width",
    "cx",
    "rx"
];
var isType$3 = function isType(type) {
    return function(node) {
        return node.type === type;
    };
};
var isSvg$3 = isType$3(_primitives.Svg);
var isText$4 = isType$3(_primitives.Text);
var isTextInstance$3 = isType$3(_primitives.TextInstance);
var transformPercent = function transformPercent(container) {
    return function(props) {
        return (0, _fns.mapValues)(props, function(value, key) {
            var match = (0, _fns.matchPercent)(value);
            if (match && VERTICAL_PROPS.includes(key)) return match.percent * container.height;
            if (match && HORIZONTAL_PROPS.includes(key)) return match.percent * container.width;
            return value;
        });
    };
};
var parsePercent = function parsePercent(value) {
    var match = (0, _fns.matchPercent)(value);
    return match ? match.percent : parseFloat(value);
};
var parseProps = function parseProps(container) {
    return function(node) {
        var props = transformPercent(container)(node.props);
        props = (0, _fns.evolve)({
            x: parseFloat,
            x1: parseFloat,
            x2: parseFloat,
            y: parseFloat,
            y1: parseFloat,
            y2: parseFloat,
            r: parseFloat,
            rx: parseFloat,
            ry: parseFloat,
            cx: parseFloat,
            cy: parseFloat,
            width: parseFloat,
            height: parseFloat,
            offset: parsePercent,
            fill: (0, _stylesheet.transformColor),
            opacity: parsePercent,
            stroke: (0, _stylesheet.transformColor),
            stopOpacity: parsePercent,
            stopColor: (0, _stylesheet.transformColor),
            transform: (0, _stylesheet.processTransform)
        }, props);
        return Object.assign({}, node, {
            props: props
        });
    };
};
var mergeStyles$1 = function mergeStyles(node) {
    var style = node.style || {};
    var props = Object.assign({}, style, node.props);
    return Object.assign({}, node, {
        props: props
    });
};
var removeNoneValues = function removeNoneValues(node) {
    var removeNone = function removeNone(value) {
        return value === "none" ? null : value;
    };
    var props = (0, _fns.mapValues)(node.props, removeNone);
    return Object.assign({}, node, {
        props: props
    });
};
var pickStyleProps = function pickStyleProps(node) {
    var props = node.props || {};
    var styleProps = (0, _fns.pick)(STYLE_PROPS, props);
    var style = Object.assign({}, styleProps, node.style || {});
    return Object.assign({}, node, {
        style: style
    });
};
var parseSvgProps = function parseSvgProps(node) {
    var props = (0, _fns.evolve)({
        width: parseFloat,
        height: parseFloat,
        viewBox: parseViewbox,
        preserveAspectRatio: parseAspectRatio
    }, node.props);
    return Object.assign({}, node, {
        props: props
    });
};
var wrapBetweenTspan = function wrapBetweenTspan(node) {
    return {
        type: _primitives.Tspan,
        props: {},
        children: [
            node
        ]
    };
};
var addMissingTspan = function addMissingTspan(node) {
    if (!isText$4(node)) return node;
    if (!node.children) return node;
    var resolveChild = function resolveChild(child) {
        return isTextInstance$3(child) ? wrapBetweenTspan(child) : child;
    };
    var children = node.children.map(resolveChild);
    return Object.assign({}, node, {
        children: children
    });
};
var parseText = function parseText(fontStore) {
    return function(node) {
        if (isText$4(node)) return layoutText$1(fontStore, node);
        if (!node.children) return node;
        var children = node.children.map(parseText(fontStore));
        return Object.assign({}, node, {
            children: children
        });
    };
};
var resolveSvgNode = function resolveSvgNode(container) {
    return (0, _fns.compose)(parseProps(container), addMissingTspan, removeNoneValues, mergeStyles$1);
};
var resolveChildren = function resolveChildren(container) {
    return function(node) {
        if (!node.children) return node;
        var resolveChild = (0, _fns.compose)(resolveChildren(container), resolveSvgNode(container));
        var children = node.children.map(resolveChild);
        return Object.assign({}, node, {
            children: children
        });
    };
};
var resolveSvgRoot = function resolveSvgRoot(node, fontStore) {
    var container = getContainer$1(node);
    return (0, _fns.compose)(replaceDefs, parseText(fontStore), parseSvgProps, pickStyleProps, inheritProps, resolveChildren(container))(node);
};
/**
 * Pre-process SVG nodes so they can be rendered in the next steps
 *
 * @param {Object} root node
 * @param {Object} fontStore font store
 * @returns {Object} root node
 */ var resolveSvg = function resolveSvg(node, fontStore) {
    if (!node.children) return node;
    var resolveChild = function resolveChild(child) {
        return resolveSvg(child, fontStore);
    };
    var root = isSvg$3(node) ? resolveSvgRoot(node, fontStore) : node;
    var children = root.children.map(resolveChild);
    return Object.assign({}, root, {
        children: children
    });
};
var getZIndex = function getZIndex(node) {
    return node.style.zIndex;
};
var shouldSort = function shouldSort(node) {
    return node.type !== _primitives.Document && node.type !== _primitives.Svg;
};
var sortZIndex = function sortZIndex(a, b) {
    var za = getZIndex(a);
    var zb = getZIndex(b);
    if (!za && !zb) return 0;
    if (!za) return 1;
    if (!zb) return -1;
    return zb - za;
};
/**
 * Sort children by zIndex value
 *
 * @param {Object} node
 * @returns {Object} node
 */ var resolveZIndex = function resolveZIndex(node) {
    if (!node.children) return node;
    var sortedChildren = shouldSort(node) ? node.children.sort(sortZIndex) : node.children;
    var children = sortedChildren.map(resolveZIndex);
    return Object.assign({}, node, {
        children: children
    });
};
// Caches emoji images data
var emojis = {};
var regex = (0, _emojiRegexDefault.default)();
var reflect = function reflect(promise) {
    return function() {
        return promise.apply(void 0, arguments).then(function(v) {
            return v;
        }, function(e) {
            return e;
        });
    };
};
// Returns a function to be able to mock resolveImage.
var makeFetchEmojiImage = function makeFetchEmojiImage() {
    return reflect((0, _imageDefault.default));
};
/**
 * When an emoji as no color, it might still have 2 parts,
 * the canonical emoji and an empty string.
 * ex.
 *   (no color) Array.from('❤️') => ["❤", "️"]
 *   (w/ color) Array.from('👍🏿') => ["👍", "🏿"]
 *
 * The empty string needs to be removed otherwise the generated
 * url will be incorect.
 */ var _removeNoColor = function _removeNoColor(x) {
    return x !== "\uFE0F";
};
var getCodePoints = function getCodePoints(string) {
    return Array.from(string).filter(_removeNoColor).map(function(char) {
        return char.codePointAt(0).toString(16);
    }).join("-");
};
var buildEmojiUrl = function buildEmojiUrl(emoji, source) {
    var url = source.url, format = source.format, builder = source.builder;
    if (typeof builder === "function") return builder(getCodePoints(emoji));
    return "" + url + getCodePoints(emoji) + "." + format;
};
var fetchEmojis = function fetchEmojis(string, source) {
    if (!source || !source.url && !source.builder) return [];
    var promises = [];
    Array.from(string.matchAll(regex)).forEach(function(match) {
        var emoji = match[0];
        if (!emojis[emoji] || emojis[emoji].loading) {
            var emojiUrl = buildEmojiUrl(emoji, source);
            emojis[emoji] = {
                loading: true
            };
            var fetchEmojiImage = makeFetchEmojiImage();
            promises.push(fetchEmojiImage({
                uri: emojiUrl
            }).then(function(image) {
                emojis[emoji].loading = false;
                emojis[emoji].data = image.data;
            }));
        }
    });
    return promises;
};
var embedEmojis = function embedEmojis(fragments) {
    var result = [];
    var _loop = function _loop() {
        var fragment = fragments[i];
        var lastIndex = 0;
        Array.from(fragment.string.matchAll(regex)).forEach(function(match) {
            var index = match.index;
            var emoji = match[0];
            var emojiSize = fragment.attributes.fontSize;
            var chunk = fragment.string.slice(lastIndex, index + match[0].length);
            // If emoji image was found, we create a new fragment with the
            // correct attachment and object substitution character;
            if (emojis[emoji] && emojis[emoji].data) result.push({
                string: chunk.replace(match, String.fromCharCode(0xfffc)),
                attributes: (0, _extendsDefault.default)({}, fragment.attributes, {
                    attachment: {
                        width: emojiSize,
                        height: emojiSize,
                        yOffset: Math.floor(emojiSize * 0.1),
                        image: emojis[emoji].data
                    }
                })
            });
            else // If no emoji data, we just replace the emoji with a nodef char
            result.push({
                string: chunk.replace(match, String.fromCharCode(0)),
                attributes: fragment.attributes
            });
            lastIndex = index + emoji.length;
        });
        if (lastIndex < fragment.string.length) result.push({
            string: fragment.string.slice(lastIndex),
            attributes: fragment.attributes
        });
    };
    for(var i = 0; i < fragments.length; i += 1)_loop();
    return result;
};
/**
 * Get image source
 *
 * @param {Object} image node
 * @returns {String | Object} image src
 */ var getSource = function getSource(node) {
    var _node$props, _node$props2, _node$props3;
    return ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.src) || ((_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.source) || ((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.href);
};
/**
 * Resolves `src` to `@react-pdf/image` interface.
 *
 * Also it handles factories and async sources.
 *
 * @param {string | Object | Function} src
 * @returns {object} resolved src
 */ var resolveSource = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(src) {
        var source;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(typeof src === "function")) {
                        _context.next = 6;
                        break;
                    }
                    _context.next = 3;
                    return src();
                case 3:
                    _context.t0 = _context.sent;
                    _context.next = 9;
                    break;
                case 6:
                    _context.next = 8;
                    return src;
                case 8:
                    _context.t0 = _context.sent;
                case 9:
                    source = _context.t0;
                    return _context.abrupt("return", typeof source === "string" ? {
                        uri: source
                    } : source);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function resolveSource(_x) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetches image and append data to node
 * Ideally this fn should be immutable.
 *
 * @param {Object} node
 */ var fetchImage = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(node) {
        var src, cache, source;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    src = getSource(node);
                    cache = node.props.cache;
                    if (src) {
                        _context.next = 5;
                        break;
                    }
                    console.warn(false, 'Image should receive either a "src" or "source" prop');
                    return _context.abrupt("return");
                case 5:
                    _context.prev = 5;
                    _context.next = 8;
                    return resolveSource(src);
                case 8:
                    source = _context.sent;
                    if (source) {
                        _context.next = 11;
                        break;
                    }
                    throw new Error('Image\'s "src" or "source" prop returned ' + source);
                case 11:
                    _context.next = 13;
                    return (0, _imageDefault.default)(source, {
                        cache: cache
                    });
                case 13:
                    node.image = _context.sent;
                    node.image.key = source.data ? source.data.toString() : source.uri;
                    _context.next = 21;
                    break;
                case 17:
                    _context.prev = 17;
                    _context.t0 = _context["catch"](5);
                    node.image = {
                        width: 0,
                        height: 0,
                        key: null
                    };
                    console.warn(_context.t0.message);
                case 21:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                5,
                17
            ]
        ]);
    }));
    return function fetchImage(_x) {
        return _ref.apply(this, arguments);
    };
}();
var isImage$2 = function isImage(node) {
    return node.type === _primitives.Image;
};
/**
 * Get all asset promises that need to be resolved
 *
 * @param {Object} root node
 * @returns {Array} asset promises
 */ var fetchAssets = function fetchAssets(fontStore, node) {
    var _node$children;
    var promises = [];
    var listToExplore = ((_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.slice(0)) || [];
    var emojiSource = fontStore ? fontStore.getEmojiSource() : null;
    while(listToExplore.length > 0){
        var _n$style;
        var n = listToExplore.shift();
        if (isImage$2(n)) promises.push(fetchImage(n));
        if (fontStore && (_n$style = n.style) !== null && _n$style !== void 0 && _n$style.fontFamily) promises.push(fontStore.load(n.style));
        if (typeof n === "string") promises.push.apply(promises, fetchEmojis(n, emojiSource));
        if (typeof n.value === "string") promises.push.apply(promises, fetchEmojis(n.value, emojiSource));
        if (n.children) n.children.forEach(function(childNode) {
            listToExplore.push(childNode);
        });
    }
    return promises;
};
/**
 * Fetch image, font and emoji assets in parallel.
 * Layout process will not be resumed until promise resolves.
 *
 * @param {Object} root node
 * @param {Object} fontStore font store
 * @returns {Object} root node
 */ var resolveAssets = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(node, fontStore) {
        var promises;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    promises = fetchAssets(fontStore, node);
                    _context.next = 3;
                    return Promise.all(promises);
                case 3:
                    return _context.abrupt("return", node);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function resolveAssets(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var isLink$1 = function isLink(node) {
    return node.type === _primitives.Link;
};
var DEFAULT_LINK_STYLES = {
    color: "blue",
    textDecoration: "underline"
};
/**
 * Computes styles using stylesheet
 *
 * @param {Object} container
 * @param {Object} document node
 * @returns {Object} computed styles
 */ var computeStyle = function computeStyle(container, node) {
    var baseStyle = node.style;
    if (isLink$1(node)) baseStyle = Array.isArray(node.style) ? [
        DEFAULT_LINK_STYLES
    ].concat(node.style) : [
        DEFAULT_LINK_STYLES,
        node.style
    ];
    return (0, _stylesheetDefault.default)(container, baseStyle);
};
/**
 * Resolves node styles
 *
 * @param {Object} container
 * @param {Object} document node
 * @returns {Object} node (and subnodes) with resolved styles
 */ var resolveNodeStyles = function resolveNodeStyles(container) {
    return function(node) {
        var style = computeStyle(container, node);
        if (!node.children) return Object.assign({}, node, {
            style: style
        });
        var children = node.children.map(resolveNodeStyles(container));
        return Object.assign({}, node, {
            style: style,
            children: children
        });
    };
};
/**
 * Resolves page styles
 *
 * @param {Object} document page
 * @returns {Object} document page with resolved styles
 */ var resolvePageStyles = function resolvePageStyles(page) {
    var _page$props, _page$box, _page$box2, _page$props2;
    var dpi = ((_page$props = page.props) === null || _page$props === void 0 ? void 0 : _page$props.dpi) || 72;
    var width = ((_page$box = page.box) === null || _page$box === void 0 ? void 0 : _page$box.width) || page.style.width;
    var height = ((_page$box2 = page.box) === null || _page$box2 === void 0 ? void 0 : _page$box2.height) || page.style.height;
    var orientation = ((_page$props2 = page.props) === null || _page$props2 === void 0 ? void 0 : _page$props2.orientation) || "portrait";
    var container = {
        width: width,
        height: height,
        orientation: orientation,
        dpi: dpi
    };
    return resolveNodeStyles(container)(page);
};
/**
 * Resolves document styles
 *
 * @param {Object} document root
 * @returns {Object} document root with resolved styles
 */ var resolveStyles = function resolveStyles(root) {
    if (!root.children) return root;
    var children = root.children.map(resolvePageStyles);
    return Object.assign({}, root, {
        children: children
    });
};
var getTransformStyle = function getTransformStyle(s) {
    return function(node) {
        var _node$style, _node$style2;
        return (0, _fns.isNil)((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style[s]) ? "50%" : (_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2[s];
    };
};
/**
 * Get node origin
 *
 * @param {Object} node
 * @returns {Object} node origin
 */ var getOrigin = function getOrigin(node) {
    if (!node.box) return {};
    var _node$box = node.box, left = _node$box.left, top = _node$box.top, width = _node$box.width, height = _node$box.height;
    var transformOriginX = getTransformStyle("transformOriginX")(node);
    var transformOriginY = getTransformStyle("transformOriginY")(node);
    var percentX = (0, _fns.matchPercent)(transformOriginX);
    var percentY = (0, _fns.matchPercent)(transformOriginY);
    var offsetX = percentX ? width * percentX.percent : transformOriginX;
    var offsetY = percentY ? height * percentY.percent : transformOriginY;
    return {
        left: left + offsetX,
        top: top + offsetY
    };
};
/**
 * Resolve node origin
 *
 * @param {Object} node
 * @returns {Object} node with origin attribute
 */ var resolveNodeOrigin = function resolveNodeOrigin(node) {
    var origin = getOrigin(node);
    var newNode = Object.assign({}, node, {
        origin: origin
    });
    if (!node.children) return newNode;
    var children = node.children.map(resolveNodeOrigin);
    return Object.assign({}, newNode, {
        children: children
    });
};
/**
 * Resolve document origins
 *
 * @param {Object} document root
 * @returns {Object} documrnt root
 */ var resolveOrigin = function resolveOrigin(root) {
    if (!root.children) return root;
    var children = root.children.map(resolveNodeOrigin);
    return Object.assign({}, root, {
        children: children
    });
};
/* eslint-disable no-plusplus */ /* eslint-disable prefer-const */ /* eslint-disable prefer-destructuring */ var getBookmarkValue = function getBookmarkValue(title) {
    return typeof title === "string" ? {
        title: title,
        fit: false,
        expanded: false
    } : title;
};
var resolveBookmarks = function resolveBookmarks(node) {
    var refs = 0;
    var children = (node.children || []).slice(0);
    var listToExplore = children.map(function(value) {
        return {
            value: value,
            parent: null
        };
    });
    var _loop = function _loop() {
        var _child$props;
        var element = listToExplore.shift();
        var child = element.value;
        var parent = element.parent;
        if ((_child$props = child.props) !== null && _child$props !== void 0 && _child$props.bookmark) {
            var _parent;
            var bookmark = getBookmarkValue(child.props.bookmark);
            var ref = refs++;
            var newHierarchy = (0, _extendsDefault.default)({
                ref: ref,
                parent: (_parent = parent) === null || _parent === void 0 ? void 0 : _parent.ref
            }, bookmark);
            child.props.bookmark = newHierarchy;
            parent = newHierarchy;
        }
        if (child.children) child.children.forEach(function(childNode) {
            listToExplore.push({
                value: childNode,
                parent: parent
            });
        });
    };
    while(listToExplore.length > 0)_loop();
    return node;
};
var VALID_ORIENTATIONS = [
    "portrait",
    "landscape"
];
/**
 * Get page orientation. Defaults to portrait
 *
 * @param { Object } page object
 * @returns { String } page orientation
 */ var getOrientation = function getOrientation(page) {
    var _page$props;
    var value = ((_page$props = page.props) === null || _page$props === void 0 ? void 0 : _page$props.orientation) || "portrait";
    return VALID_ORIENTATIONS.includes(value) ? value : "portrait";
};
/**
 * Return true if page is landscape
 *
 * @param {Object} page instance
 * @returns {Boolean} is page landscape
 */ var isLandscape = function isLandscape(page) {
    return getOrientation(page) === "landscape";
};
var PAGE_SIZES = {
    "4A0": [
        4767.87,
        6740.79
    ],
    "2A0": [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    EXECUTIVE: [
        521.86,
        756.0
    ],
    FOLIO: [
        612.0,
        936.0
    ],
    LEGAL: [
        612.0,
        1008.0
    ],
    LETTER: [
        612.0,
        792.0
    ],
    TABLOID: [
        792.0,
        1224.0
    ],
    ID1: [
        153,
        243
    ]
};
/**
 * Transforms array into size object
 *
 * @param {Array} array
 * @returns {Object} size object with width and height
 */ var toSizeObject = function toSizeObject(v) {
    return {
        width: v[0],
        height: v[1]
    };
};
/**
 * Flip size object
 *
 * @param {Object} size object
 * @returns {Object} flipped size object
 */ var flipSizeObject = function flipSizeObject(v) {
    return {
        width: v.height,
        height: v.width
    };
};
/**
 * Adjust page size to passed DPI
 *
 * @param {Object} size object
 * @param {number} dpi
 * @returns {Object} adjusted size object
 */ var adjustDpi = function adjustDpi(v, dpi) {
    return {
        width: v.width ? v.width * dpi : v.width,
        height: v.height ? v.height * dpi : v.height
    };
};
/**
 * Returns size object from a given string
 *
 * @param {String} page size string
 * @returns {Object} size object with width and height
 */ var getStringSize = function getStringSize(v) {
    return toSizeObject(PAGE_SIZES[v.toUpperCase()]);
};
/**
 * Returns size object from a single number
 *
 * @param {Number} page size number
 * @returns {Object} size object with width and height
 */ var getNumberSize = function getNumberSize(n) {
    return toSizeObject([
        n
    ]);
};
/**
 * Return page size in an object { width, height }
 *
 * @param {Object} page instance
 * @returns {Object} size object with width and height
 */ var getSize = function getSize(page) {
    var _page$props, _page$props2;
    var value = ((_page$props = page.props) === null || _page$props === void 0 ? void 0 : _page$props.size) || "A4";
    var dpi = parseFloat(((_page$props2 = page.props) === null || _page$props2 === void 0 ? void 0 : _page$props2.dpi) || 72);
    var type = typeof value;
    var size = value;
    if (type === "string") size = getStringSize(value);
    else if (Array.isArray(value)) size = toSizeObject(value);
    else if (type === "number") size = getNumberSize(value);
    size = adjustDpi(size, dpi / 72);
    return isLandscape(page) ? flipSizeObject(size) : size;
};
/**
 * Resolves page size
 *
 * @param {Object} page
 * @returns {Object} page with resolved size in style attribute
 */ var resolvePageSize = function resolvePageSize(page) {
    var size = getSize(page);
    var style = (0, _stylesheet.flatten)(page.style || {});
    return (0, _extendsDefault.default)({}, page, {
        style: (0, _extendsDefault.default)({}, style, size)
    });
};
/**
 * Resolves page sizes
 *
 * @param {Object} document root
 * @returns {Object} document root with resolved page sizes
 */ var resolvePageSizes = function resolvePageSizes(root) {
    if (!root.children) return root;
    var children = root.children.map(resolvePageSize);
    return Object.assign({}, root, {
        children: children
    });
};
var isFixed = function isFixed(node) {
    var _node$props;
    return ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.fixed) === true;
};
/**
 * Get line index at given height
 *
 * @param {Object} node
 * @param {Number} height
 */ var lineIndexAtHeight = function lineIndexAtHeight(node, height) {
    var y = 0;
    if (!node.lines) return 0;
    for(var i = 0; i < node.lines.length; i += 1){
        var line = node.lines[i];
        if (y + line.box.height > height) return i;
        y += line.box.height;
    }
    return node.lines.length;
};
/**
 * Get height for given text line index
 *
 * @param {Object} node
 * @param {Number} index
 */ var heightAtLineIndex = function heightAtLineIndex(node, index) {
    var counter = 0;
    if (!node.lines) return counter;
    for(var i = 0; i < index; i += 1){
        var line = node.lines[i];
        if (!line) break;
        counter += line.box.height;
    }
    return counter;
};
var getLineBreak = function getLineBreak(node, height) {
    var top = (0, _fns.get)(node, [
        "box",
        "top"
    ], 0);
    var widows = (0, _fns.get)(node, [
        "props",
        "widows"
    ], 2);
    var orphans = (0, _fns.get)(node, [
        "props",
        "orphans"
    ], 2);
    var linesQuantity = node.lines.length;
    var slicedLine = lineIndexAtHeight(node, height - top);
    if (slicedLine === 0) return 0;
    if (linesQuantity < orphans) return linesQuantity;
    if (slicedLine < orphans || linesQuantity < orphans + widows) return 0;
    if (linesQuantity === orphans + widows) return orphans;
    if (linesQuantity - slicedLine < widows) return linesQuantity - widows;
    return slicedLine;
};
// Also receives contentArea in case it's needed
var splitText = function splitText(node, height) {
    var slicedLineIndex = getLineBreak(node, height);
    var currentHeight = heightAtLineIndex(node, slicedLineIndex);
    var nextHeight = node.box.height - currentHeight;
    var current = Object.assign({}, node, {
        box: (0, _extendsDefault.default)({}, node.box, {
            height: currentHeight,
            borderBottomWidth: 0
        }),
        style: (0, _extendsDefault.default)({}, node.style, {
            marginBottom: 0,
            paddingBottom: 0,
            borderBottomWidth: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        }),
        lines: node.lines.slice(0, slicedLineIndex)
    });
    var next = Object.assign({}, node, {
        box: (0, _extendsDefault.default)({}, node.box, {
            top: 0,
            height: nextHeight,
            borderTopWidth: 0
        }),
        style: (0, _extendsDefault.default)({}, node.style, {
            marginTop: 0,
            paddingTop: 0,
            borderTopWidth: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }),
        lines: node.lines.slice(slicedLineIndex)
    });
    return [
        current,
        next
    ];
};
var getTop$1 = function getTop(node) {
    var _node$box;
    return ((_node$box = node.box) === null || _node$box === void 0 ? void 0 : _node$box.top) || 0;
};
var hasFixedHeight = function hasFixedHeight(node) {
    var _node$style;
    return !(0, _fns.isNil)((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.height);
};
var splitNode = function splitNode(node, height) {
    if (!node) return [
        null,
        null
    ];
    var nodeTop = getTop$1(node);
    var current = Object.assign({}, node, {
        box: (0, _extendsDefault.default)({}, node.box, {
            borderBottomWidth: 0
        }),
        style: (0, _extendsDefault.default)({}, node.style, {
            marginBottom: 0,
            paddingBottom: 0,
            borderBottomWidth: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        })
    });
    current.style.height = height - nodeTop;
    var nextHeight = hasFixedHeight(node) ? node.box.height - (height - nodeTop) : null;
    var next = Object.assign({}, node, {
        box: (0, _extendsDefault.default)({}, node.box, {
            top: 0,
            borderTopWidth: 0
        }),
        style: (0, _extendsDefault.default)({}, node.style, {
            marginTop: 0,
            paddingTop: 0,
            borderTopWidth: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        })
    });
    if (nextHeight) next.style.height = nextHeight;
    return [
        current,
        next
    ];
};
var NON_WRAP_TYPES = [
    _primitives.Svg,
    _primitives.Note,
    _primitives.Image,
    _primitives.Canvas
];
var getWrap = function getWrap(node) {
    var _node$props;
    if (NON_WRAP_TYPES.includes(node.type)) return false;
    return (0, _fns.isNil)((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.wrap) ? true : node.props.wrap;
};
var getComputedPadding = function getComputedPadding(node, edge) {
    var yogaNode = node.yogaNode;
    return yogaNode ? yogaNode.getComputedPadding(edge) : null;
};
/**
 * Get Yoga computed paddings. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} paddings
 */ var getPadding = function getPadding(node) {
    var style = node.style, box = node.box;
    var paddingTop = getComputedPadding(node, (0, _yogaDefault.default).EDGE_TOP) || (box === null || box === void 0 ? void 0 : box.paddingTop) || (style === null || style === void 0 ? void 0 : style.paddingTop) || (style === null || style === void 0 ? void 0 : style.paddingVertical) || (style === null || style === void 0 ? void 0 : style.padding) || 0;
    var paddingRight = getComputedPadding(node, (0, _yogaDefault.default).EDGE_RIGHT) || (box === null || box === void 0 ? void 0 : box.paddingRight) || (style === null || style === void 0 ? void 0 : style.paddingRight) || (style === null || style === void 0 ? void 0 : style.paddingHorizontal) || (style === null || style === void 0 ? void 0 : style.padding) || 0;
    var paddingBottom = getComputedPadding(node, (0, _yogaDefault.default).EDGE_BOTTOM) || (box === null || box === void 0 ? void 0 : box.paddingBottom) || (style === null || style === void 0 ? void 0 : style.paddingBottom) || (style === null || style === void 0 ? void 0 : style.paddingVertical) || (style === null || style === void 0 ? void 0 : style.padding) || 0;
    var paddingLeft = getComputedPadding(node, (0, _yogaDefault.default).EDGE_LEFT) || (box === null || box === void 0 ? void 0 : box.paddingLeft) || (style === null || style === void 0 ? void 0 : style.paddingLeft) || (style === null || style === void 0 ? void 0 : style.paddingHorizontal) || (style === null || style === void 0 ? void 0 : style.padding) || 0;
    return {
        paddingTop: paddingTop,
        paddingRight: paddingRight,
        paddingBottom: paddingBottom,
        paddingLeft: paddingLeft
    };
};
var getWrapArea = function getWrapArea(page) {
    var _page$style;
    var _getPadding = getPadding(page), paddingBottom = _getPadding.paddingBottom;
    var height = (_page$style = page.style) === null || _page$style === void 0 ? void 0 : _page$style.height;
    return height - paddingBottom;
};
var getContentArea = function getContentArea(page) {
    var _page$style;
    var height = (_page$style = page.style) === null || _page$style === void 0 ? void 0 : _page$style.height;
    var _getPadding = getPadding(page), paddingTop = _getPadding.paddingTop, paddingBottom = _getPadding.paddingBottom;
    return height - paddingBottom - paddingTop;
};
var _excluded = [
    "style",
    "children"
];
var isString = function isString(value) {
    return typeof value === "string";
};
var isNumber = function isNumber(value) {
    return typeof value === "number";
};
var isFragment = function isFragment(value) {
    return value && value.type === Symbol.for("react.fragment");
};
/**
 * Transforms a react element instance to internal element format.
 *
 * Can return multiple instances in the case of arrays or fragments.
 *
 * @param {Object} React element
 * @returns {Array} parsed react elements
 */ var createInstances = function createInstances(element) {
    if (!element) return [];
    if (isString(element) || isNumber(element)) return [
        {
            type: (0, _primitives.TextInstance),
            value: "" + element
        }
    ];
    if (isFragment(element)) return createInstances(element.props.children);
    if (Array.isArray(element)) return element.reduce(function(acc, el) {
        return acc.concat(createInstances(el));
    }, []);
    if (!isString(element.type)) return createInstances(element.type(element.props));
    var type = element.type, _element$props = element.props, _element$props$style = _element$props.style, style = _element$props$style === void 0 ? {} : _element$props$style, _element$props$childr = _element$props.children, children = _element$props$childr === void 0 ? [] : _element$props$childr, props = (0, _objectWithoutPropertiesLooseDefault.default)(_element$props, _excluded);
    var nextChildren = (0, _fns.castArray)(children).reduce(function(acc, child) {
        return acc.concat(createInstances(child));
    }, []);
    return [
        {
            type: type,
            style: style,
            props: props,
            box: {},
            children: nextChildren
        }
    ];
};
/**
 * Get many nodes height
 *
 * @param {Array} nodes
 * @return {number} nodes height
 */ var getNodesHeight = function getNodesHeight(nodes) {
    var max = 0;
    var min = Infinity;
    if (!nodes || nodes.length === 0) return 0;
    for(var i = 0; i < nodes.length; i += 1){
        var node = nodes[i];
        min = Math.min(min, node.box.top);
        max = Math.max(max, node.box.top + node.box.height);
    }
    return max - min;
};
/* eslint-disable no-continue */ var getBreak = function getBreak(node) {
    var _node$props;
    return ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.break) || false;
};
var getMinPresenceAhead = function getMinPresenceAhead(node) {
    var _node$props2;
    return (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.minPresenceAhead;
};
var defaultPresenceAhead = function defaultPresenceAhead(element) {
    return function(height) {
        return Math.min(element.box.height, height);
    };
};
var getPresenceAhead = function getPresenceAhead(elements, height) {
    var result = 0;
    for(var i = 0; i < elements.length; i += 1){
        var element = elements[i];
        if (!element.box) continue;
        var isElementInside = height > element.box.top;
        var presenceAhead = element.props.presenceAhead || defaultPresenceAhead(element);
        if (element && isElementInside) result += presenceAhead(height - element.box.top);
    }
    return result;
};
var shouldBreak = function shouldBreak(child, futureElements, height) {
    var minPresenceAhead = getMinPresenceAhead(child);
    var presenceAhead = getPresenceAhead(futureElements, height);
    var futureHeight = getNodesHeight(futureElements);
    var shouldSplit = height < child.box.top + child.box.height;
    var shouldWrap = getWrap(child);
    return getBreak(child) || !shouldWrap && shouldSplit || minPresenceAhead < futureHeight && presenceAhead < minPresenceAhead;
};
var IGNORABLE_CODEPOINTS = [
    8232,
    // LINE_SEPARATOR
    8233 // PARAGRAPH_SEPARATOR
];
var buildSubsetForFont = function buildSubsetForFont(font) {
    return IGNORABLE_CODEPOINTS.reduce(function(acc, codePoint) {
        if (font && font.hasGlyphForCodePoint && font.hasGlyphForCodePoint(codePoint)) return acc;
        return [].concat(acc, [
            String.fromCharCode(codePoint)
        ]);
    }, []);
};
var ignoreChars = function ignoreChars(fragments) {
    return fragments.map(function(fragment) {
        var charSubset = buildSubsetForFont(fragment.attributes.font);
        var subsetRegex = new RegExp(charSubset.join("|"));
        return {
            string: fragment.string.replace(subsetRegex, ""),
            attributes: fragment.attributes
        };
    });
};
var PREPROCESSORS = [
    ignoreChars,
    embedEmojis
];
var isImage$1 = function isImage(node) {
    return node.type === _primitives.Image;
};
var isTextInstance$2 = function isTextInstance(node) {
    return node.type === _primitives.TextInstance;
};
/**
 * Get textkit fragments of given node object
 *
 * @param {Object} font store
 * @param {Object} instance node
 * @returns {Array} text fragments
 */ var getFragments = function getFragments(fontStore, instance, parentLink, level) {
    var _instance$props, _instance$props2;
    if (level === void 0) level = 0;
    if (!instance) return [
        {
            string: ""
        }
    ];
    var fragments = [];
    var _instance$style = instance.style, _instance$style$color = _instance$style.color, color = _instance$style$color === void 0 ? "black" : _instance$style$color, _instance$style$fontF = _instance$style.fontFamily, fontFamily = _instance$style$fontF === void 0 ? "Helvetica" : _instance$style$fontF, fontWeight = _instance$style.fontWeight, fontStyle = _instance$style.fontStyle, _instance$style$fontS = _instance$style.fontSize, fontSize = _instance$style$fontS === void 0 ? 18 : _instance$style$fontS, _instance$style$textA = _instance$style.textAlign, textAlign = _instance$style$textA === void 0 ? "left" : _instance$style$textA, lineHeight = _instance$style.lineHeight, textDecoration = _instance$style.textDecoration, textDecorationColor = _instance$style.textDecorationColor, textDecorationStyle = _instance$style.textDecorationStyle, textTransform = _instance$style.textTransform, letterSpacing = _instance$style.letterSpacing, textIndent = _instance$style.textIndent, opacity = _instance$style.opacity, verticalAlign = _instance$style.verticalAlign;
    var opts = {
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontStyle: fontStyle
    };
    var obj = fontStore ? fontStore.getFont(opts) : null;
    var font = obj ? obj.data : fontFamily;
    // Don't pass main background color to textkit. Will be rendered by the render package instead
    var backgroundColor = level === 0 ? null : instance.style.backgroundColor;
    var attributes = {
        font: font,
        color: color,
        opacity: opacity,
        fontSize: fontSize,
        backgroundColor: backgroundColor,
        align: textAlign,
        indent: textIndent,
        characterSpacing: letterSpacing,
        strikeStyle: textDecorationStyle,
        underlineStyle: textDecorationStyle,
        underline: textDecoration === "underline" || textDecoration === "underline line-through" || textDecoration === "line-through underline",
        strike: textDecoration === "line-through" || textDecoration === "underline line-through" || textDecoration === "line-through underline",
        strikeColor: textDecorationColor || color,
        underlineColor: textDecorationColor || color,
        link: parentLink || ((_instance$props = instance.props) === null || _instance$props === void 0 ? void 0 : _instance$props.src) || ((_instance$props2 = instance.props) === null || _instance$props2 === void 0 ? void 0 : _instance$props2.href),
        lineHeight: lineHeight ? lineHeight * fontSize : null,
        verticalAlign: verticalAlign
    };
    for(var i = 0; i < instance.children.length; i += 1){
        var child = instance.children[i];
        if (isImage$1(child)) fragments.push({
            string: String.fromCharCode(0xfffc),
            attributes: (0, _extendsDefault.default)({}, attributes, {
                attachment: {
                    width: child.style.width || fontSize,
                    height: child.style.height || fontSize,
                    image: child.image.data
                }
            })
        });
        else if (isTextInstance$2(child)) fragments.push({
            string: transformText(child.value, textTransform),
            attributes: attributes
        });
        else if (child) {
            var _fragments;
            (_fragments = fragments).push.apply(_fragments, getFragments(fontStore, child, attributes.link, level + 1));
        }
    }
    for(var _i = 0; _i < PREPROCESSORS.length; _i += 1){
        var preprocessor = PREPROCESSORS[_i];
        fragments = preprocessor(fragments);
    }
    return fragments;
};
/**
 * Get textkit attributed string from text node
 *
 * @param {Object} font store
 * @param {Object} instance node
 * @returns {Object} attributed string
 */ var getAttributedString = function getAttributedString(fontStore, instance) {
    var fragments = getFragments(fontStore, instance);
    return fromFragments(fragments);
};
var engines = {
    linebreaker: (0, _textkit.linebreaker),
    justification: (0, _textkit.justification),
    textDecoration: (0, _textkit.textDecoration),
    scriptItemizer: (0, _textkit.scriptItemizer),
    wordHyphenation: (0, _textkit.wordHyphenation),
    fontSubstitution: fontSubstitution
};
var engine = (0, _textkitDefault.default)(engines);
var getMaxLines = function getMaxLines(node) {
    var _node$style;
    return (_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.maxLines;
};
var getTextOverflow = function getTextOverflow(node) {
    var _node$style2;
    return (_node$style2 = node.style) === null || _node$style2 === void 0 ? void 0 : _node$style2.textOverflow;
};
/**
 * Get layout container for specific text node
 *
 * @param {Number} width
 * @param {Number} height
 * @param {Object} node
 * @returns {Object} layout container
 */ var getContainer = function getContainer(width, height, node) {
    var maxLines = getMaxLines(node);
    var textOverflow = getTextOverflow(node);
    return {
        x: 0,
        y: 0,
        width: width,
        maxLines: maxLines,
        height: height || Infinity,
        truncateMode: textOverflow
    };
};
/**
 * Get text layout options for specific text node
 *
 * @param {Object} node instance
 * @returns {Object} layout options
 */ var getLayoutOptions = function getLayoutOptions(fontStore, node) {
    return {
        hyphenationPenalty: node.props.hyphenationPenalty,
        shrinkWhitespaceFactor: {
            before: -0.5,
            after: -0.5
        },
        hyphenationCallback: node.props.hyphenationCallback || (fontStore === null || fontStore === void 0 ? void 0 : fontStore.getHyphenationCallback()) || null
    };
};
/**
 * Get text lines for given node
 *
 * @param {Object} node
 * @param {Number} container width
 * @param {Number} container height
 * @param {Number} fontStore font store
 * @returns {Array} layout lines
 */ var layoutText = function layoutText(node, width, height, fontStore) {
    var attributedString = getAttributedString(fontStore, node);
    var container = getContainer(width, height, node);
    var options = getLayoutOptions(fontStore, node);
    var lines = engine(attributedString, container, options);
    return lines.reduce(function(acc, line) {
        return [].concat(acc, line);
    }, []);
};
var isType$2 = function isType(type) {
    return function(node) {
        return node.type === type;
    };
};
var isSvg$2 = isType$2(_primitives.Svg);
var isText$3 = isType$2(_primitives.Text);
var shouldIterate = function shouldIterate(node) {
    return !isSvg$2(node) && !isText$3(node);
};
var shouldLayoutText = function shouldLayoutText(node) {
    return isText$3(node) && !node.lines;
};
/**
 * Performs text layout on text node if wasn't calculated before.
 * Text layout is usually performed on Yoga's layout process (via setMeasureFunc),
 * but we need to layout those nodes with fixed width and height.
 *
 * @param {Object} node
 * @returns {Object} layout node
 */ var resolveTextLayout = function resolveTextLayout(node, fontStore) {
    if (shouldLayoutText(node)) {
        var width = node.box.width - (node.box.paddingRight + node.box.paddingLeft);
        var height = node.box.height - (node.box.paddingTop + node.box.paddingBottom);
        // eslint-disable-next-line no-param-reassign
        node.lines = layoutText(node, width, height, fontStore);
    }
    if (shouldIterate(node)) {
        if (!node.children) return node;
        var mapChild = function mapChild(child) {
            return resolveTextLayout(child, fontStore);
        };
        var children = node.children.map(mapChild);
        return Object.assign({}, node, {
            children: children
        });
    }
    return node;
};
var INHERITED_PROPERTIES = [
    "color",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontWeight",
    "letterSpacing",
    "opacity",
    "textDecoration",
    "textTransform",
    "lineHeight",
    "textAlign",
    "visibility",
    "wordSpacing"
];
var isSvg$1 = function isSvg(node) {
    return node.type === _primitives.Svg;
};
// Merge style values
var mergeValues = function mergeValues(styleName, value, inheritedValue) {
    switch(styleName){
        case "textDecoration":
            // merge not none and not false textDecoration values to one rule
            return [
                inheritedValue,
                value
            ].filter(function(v) {
                return v && v !== "none";
            }).join(" ");
        default:
            return value;
    }
};
// Merge inherited and node styles
var merge = function merge(inheritedStyles, style) {
    var mergedStyles = (0, _extendsDefault.default)({}, inheritedStyles);
    Object.entries(style).forEach(function(_ref) {
        var styleName = _ref[0], value = _ref[1];
        mergedStyles[styleName] = mergeValues(styleName, value, inheritedStyles[styleName]);
    });
    return mergedStyles;
};
/**
 * Merges styles with node
 *
 * @param {Object} style object
 * @param {Object} node
 * @returns {Object} node with styles merged
 */ var mergeStyles = function mergeStyles(inheritedStyles) {
    return function(node) {
        var style = merge(inheritedStyles, node.style || {});
        return Object.assign({}, node, {
            style: style
        });
    };
};
/**
 * Inherit style values from the root to the leafs
 *
 * @param {Object} document root
 * @returns {Object} document root with inheritance
 *
 */ var resolveInheritance = function resolveInheritance(node) {
    if (isSvg$1(node)) return node;
    if (!node.children) return node;
    var inheritStyles = (0, _fns.pick)(INHERITED_PROPERTIES, node.style || {});
    var resolveChild = (0, _fns.compose)(resolveInheritance, mergeStyles(inheritStyles));
    var children = node.children.map(resolveChild);
    return Object.assign({}, node, {
        children: children
    });
};
var getComputedMargin = function getComputedMargin(node, edge) {
    var yogaNode = node.yogaNode;
    return yogaNode ? yogaNode.getComputedMargin(edge) : null;
};
/**
 * Get Yoga computed magins. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} margins
 */ var getMargin = function getMargin(node) {
    var style = node.style, box = node.box;
    var marginTop = getComputedMargin(node, (0, _yogaDefault.default).EDGE_TOP) || (box === null || box === void 0 ? void 0 : box.marginTop) || (style === null || style === void 0 ? void 0 : style.marginTop) || (style === null || style === void 0 ? void 0 : style.marginVertical) || (style === null || style === void 0 ? void 0 : style.margin) || 0;
    var marginRight = getComputedMargin(node, (0, _yogaDefault.default).EDGE_RIGHT) || (box === null || box === void 0 ? void 0 : box.marginRight) || (style === null || style === void 0 ? void 0 : style.marginRight) || (style === null || style === void 0 ? void 0 : style.marginHorizontal) || (style === null || style === void 0 ? void 0 : style.margin) || 0;
    var marginBottom = getComputedMargin(node, (0, _yogaDefault.default).EDGE_BOTTOM) || (box === null || box === void 0 ? void 0 : box.marginBottom) || (style === null || style === void 0 ? void 0 : style.marginBottom) || (style === null || style === void 0 ? void 0 : style.marginVertical) || (style === null || style === void 0 ? void 0 : style.margin) || 0;
    var marginLeft = getComputedMargin(node, (0, _yogaDefault.default).EDGE_LEFT) || (box === null || box === void 0 ? void 0 : box.marginLeft) || (style === null || style === void 0 ? void 0 : style.marginLeft) || (style === null || style === void 0 ? void 0 : style.marginHorizontal) || (style === null || style === void 0 ? void 0 : style.margin) || 0;
    return {
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft
    };
};
/**
 * Get Yoga computed position. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} position
 */ var getPosition = function getPosition(node) {
    var yogaNode = node.yogaNode;
    return {
        top: (yogaNode === null || yogaNode === void 0 ? void 0 : yogaNode.getComputedTop()) || 0,
        right: (yogaNode === null || yogaNode === void 0 ? void 0 : yogaNode.getComputedRight()) || 0,
        bottom: (yogaNode === null || yogaNode === void 0 ? void 0 : yogaNode.getComputedBottom()) || 0,
        left: (yogaNode === null || yogaNode === void 0 ? void 0 : yogaNode.getComputedLeft()) || 0
    };
};
var DEFAULT_DIMENSION = {
    width: 0,
    height: 0
};
/**
 * Get Yoga computed dimensions. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} dimensions
 */ var getDimension = function getDimension(node) {
    var yogaNode = node.yogaNode;
    if (!yogaNode) return DEFAULT_DIMENSION;
    return {
        width: yogaNode.getComputedWidth(),
        height: yogaNode.getComputedHeight()
    };
};
var getComputedBorder = function getComputedBorder(yogaNode, edge) {
    return yogaNode ? yogaNode.getComputedBorder(edge) : 0;
};
/**
 * Get Yoga computed border width. Zero otherwise
 *
 * @param {Object} node
 * @return {Object} border widths
 */ var getBorderWidth = function getBorderWidth(node) {
    var yogaNode = node.yogaNode;
    return {
        borderTopWidth: getComputedBorder(yogaNode, (0, _yogaDefault.default).EDGE_TOP),
        borderRightWidth: getComputedBorder(yogaNode, (0, _yogaDefault.default).EDGE_RIGHT),
        borderBottomWidth: getComputedBorder(yogaNode, (0, _yogaDefault.default).EDGE_BOTTOM),
        borderLeftWidth: getComputedBorder(yogaNode, (0, _yogaDefault.default).EDGE_LEFT)
    };
};
/**
 * Set display attribute to node's Yoga instance
 *
 * @param {String} display
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setDisplay = function setDisplay(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (yogaNode) yogaNode.setDisplay(value === "none" ? (0, _yogaDefault.default).DISPLAY_NONE : (0, _yogaDefault.default).DISPLAY_FLEX);
        return node;
    };
};
var OVERFLOW = {
    hidden: (0, _yogaDefault.default).OVERFLOW_HIDDEN,
    scroll: (0, _yogaDefault.default).OVERFLOW_SCROLL
};
/**
 * Set overflow attribute to node's Yoga instance
 *
 * @param {String} overflow value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setOverflow = function setOverflow(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) {
            var overflow = OVERFLOW[value] || (0, _yogaDefault.default).OVERFLOW_VISIBLE;
            yogaNode.setOverflow(overflow);
        }
        return node;
    };
};
var FLEX_WRAP = {
    wrap: (0, _yogaDefault.default).WRAP_WRAP,
    "wrap-reverse": (0, _yogaDefault.default).WRAP_WRAP_REVERSE
};
/**
 * Set flex wrap attribute to node's Yoga instance
 *
 * @param {String} flex wrap value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexWrap = function setFlexWrap(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (yogaNode) {
            var flexWrap = FLEX_WRAP[value] || (0, _yogaDefault.default).WRAP_NO_WRAP;
            yogaNode.setFlexWrap(flexWrap);
        }
        return node;
    };
};
/* eslint-disable no-unused-expressions */ /**
 * Set generic yoga attribute to node's Yoga instance, handing `auto`, edges and percentage cases
 *
 * @param {String} property
 * @param {Number} edge
 * @param {any} value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setYogaValue = function setYogaValue(attr, edge) {
    return function(value) {
        return function(node) {
            var yogaNode = node.yogaNode;
            if (!(0, _fns.isNil)(value) && yogaNode) {
                var hasEdge = !(0, _fns.isNil)(edge);
                var fixedMethod = "set" + (0, _fns.upperFirst)(attr);
                var autoMethod = fixedMethod + "Auto";
                var percentMethod = fixedMethod + "Percent";
                var percent = (0, _fns.matchPercent)(value);
                if (percent && !yogaNode[percentMethod]) throw new Error("You can't pass percentage values to " + attr + " property");
                if (percent) {
                    if (hasEdge) {
                        var _yogaNode$percentMeth;
                        (_yogaNode$percentMeth = yogaNode[percentMethod]) === null || _yogaNode$percentMeth === void 0 || _yogaNode$percentMeth.call(yogaNode, edge, percent.value);
                    } else {
                        var _yogaNode$percentMeth2;
                        (_yogaNode$percentMeth2 = yogaNode[percentMethod]) === null || _yogaNode$percentMeth2 === void 0 || _yogaNode$percentMeth2.call(yogaNode, percent.value);
                    }
                } else if (value === "auto") {
                    if (hasEdge) {
                        var _yogaNode$autoMethod;
                        (_yogaNode$autoMethod = yogaNode[autoMethod]) === null || _yogaNode$autoMethod === void 0 || _yogaNode$autoMethod.call(yogaNode, edge);
                    } else {
                        var _yogaNode$autoMethod2;
                        (_yogaNode$autoMethod2 = yogaNode[autoMethod]) === null || _yogaNode$autoMethod2 === void 0 || _yogaNode$autoMethod2.call(yogaNode);
                    }
                } else if (hasEdge) {
                    var _yogaNode$fixedMethod;
                    (_yogaNode$fixedMethod = yogaNode[fixedMethod]) === null || _yogaNode$fixedMethod === void 0 || _yogaNode$fixedMethod.call(yogaNode, edge, value);
                } else {
                    var _yogaNode$fixedMethod2;
                    (_yogaNode$fixedMethod2 = yogaNode[fixedMethod]) === null || _yogaNode$fixedMethod2 === void 0 || _yogaNode$fixedMethod2.call(yogaNode, value);
                }
            }
            return node;
        };
    };
};
/**
 * Set flex grow attribute to node's Yoga instance
 *
 * @param {Number} flex grow value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexGrow = function setFlexGrow(value) {
    return function(node) {
        return setYogaValue("flexGrow")(value || 0)(node);
    };
};
/**
 * Set flex basis attribute to node's Yoga instance
 *
 * @param {Number} flex basis value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexBasis = setYogaValue("flexBasis");
var ALIGN = {
    "flex-start": (0, _yogaDefault.default).ALIGN_FLEX_START,
    center: (0, _yogaDefault.default).ALIGN_CENTER,
    "flex-end": (0, _yogaDefault.default).ALIGN_FLEX_END,
    stretch: (0, _yogaDefault.default).ALIGN_STRETCH,
    baseline: (0, _yogaDefault.default).ALIGN_BASELINE,
    "space-between": (0, _yogaDefault.default).ALIGN_SPACE_BETWEEN,
    "space-around": (0, _yogaDefault.default).ALIGN_SPACE_AROUND
};
/**
 * Set generic align attribute to node's Yoga instance
 *
 * @param {String} specific align property
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAlign = function setAlign(attr) {
    return function(value) {
        return function(node) {
            var yogaNode = node.yogaNode;
            var defaultValue = attr === "items" ? (0, _yogaDefault.default).ALIGN_STRETCH : (0, _yogaDefault.default).ALIGN_AUTO;
            if (yogaNode) {
                var align = ALIGN[value] || defaultValue;
                yogaNode["setAlign" + (0, _fns.upperFirst)(attr)](align);
            }
            return node;
        };
    };
};
/**
 * Set align self attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAlignSelf = setAlign("self");
/**
 * Set align items attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAlignItems = setAlign("items");
/**
 * Set flex shrink attribute to node's Yoga instance
 *
 * @param {Number} flex shrink value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexShrink = function setFlexShrink(value) {
    return function(node) {
        return setYogaValue("flexShrink")(value || 1)(node);
    };
};
/**
 * Set aspect ratio attribute to node's Yoga instance
 *
 * @param {Number} ratio
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAspectRatio = function setAspectRatio(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) yogaNode.setAspectRatio(value);
        return node;
    };
};
/**
 * Set align content attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setAlignContent = setAlign("content");
/**
 * Set position type attribute to node's Yoga instance
 *
 * @param {String} position type
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionType = function setPositionType(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) yogaNode.setPositionType(value === "absolute" ? (0, _yogaDefault.default).POSITION_TYPE_ABSOLUTE : (0, _yogaDefault.default).POSITION_TYPE_RELATIVE);
        return node;
    };
};
var FLEX_DIRECTIONS = {
    row: (0, _yogaDefault.default).FLEX_DIRECTION_ROW,
    "row-reverse": (0, _yogaDefault.default).FLEX_DIRECTION_ROW_REVERSE,
    "column-reverse": (0, _yogaDefault.default).FLEX_DIRECTION_COLUMN_REVERSE
};
/**
 * Set flex direction attribute to node's Yoga instance
 *
 * @param {String} flex direction value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setFlexDirection = function setFlexDirection(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (yogaNode) {
            var flexDirection = FLEX_DIRECTIONS[value] || (0, _yogaDefault.default).FLEX_DIRECTION_COLUMN;
            yogaNode.setFlexDirection(flexDirection);
        }
        return node;
    };
};
var JUSTIFY_CONTENT = {
    center: (0, _yogaDefault.default).JUSTIFY_CENTER,
    "flex-end": (0, _yogaDefault.default).JUSTIFY_FLEX_END,
    "space-between": (0, _yogaDefault.default).JUSTIFY_SPACE_BETWEEN,
    "space-around": (0, _yogaDefault.default).JUSTIFY_SPACE_AROUND,
    "space-evenly": (0, _yogaDefault.default).JUSTIFY_SPACE_EVENLY
};
/**
 * Set justify content attribute to node's Yoga instance
 *
 * @param {String} justify content value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setJustifyContent = function setJustifyContent(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) {
            var justifyContent = JUSTIFY_CONTENT[value] || (0, _yogaDefault.default).JUSTIFY_FLEX_START;
            yogaNode.setJustifyContent(justifyContent);
        }
        return node;
    };
};
/**
 * Set margin top attribute to node's Yoga instance
 *
 * @param {Number} margin top
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMarginTop = setYogaValue("margin", (0, _yogaDefault.default).EDGE_TOP);
/**
 * Set margin right attribute to node's Yoga instance
 *
 * @param {Number} margin right
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMarginRight = setYogaValue("margin", (0, _yogaDefault.default).EDGE_RIGHT);
/**
 * Set margin bottom attribute to node's Yoga instance
 *
 * @param {Number} margin bottom
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMarginBottom = setYogaValue("margin", (0, _yogaDefault.default).EDGE_BOTTOM);
/**
 * Set margin left attribute to node's Yoga instance
 *
 * @param {Number} margin left
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMarginLeft = setYogaValue("margin", (0, _yogaDefault.default).EDGE_LEFT);
/**
 * Set padding top attribute to node's Yoga instance
 *
 * @param {Number} padding top
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPaddingTop = setYogaValue("padding", (0, _yogaDefault.default).EDGE_TOP);
/**
 * Set padding right attribute to node's Yoga instance
 *
 * @param {Number} padding right
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPaddingRight = setYogaValue("padding", (0, _yogaDefault.default).EDGE_RIGHT);
/**
 * Set padding bottom attribute to node's Yoga instance
 *
 * @param {Number} padding bottom
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPaddingBottom = setYogaValue("padding", (0, _yogaDefault.default).EDGE_BOTTOM);
/**
 * Set padding left attribute to node's Yoga instance
 *
 * @param {Number} padding left
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPaddingLeft = setYogaValue("padding", (0, _yogaDefault.default).EDGE_LEFT);
/**
 * Set border top attribute to node's Yoga instance
 *
 * @param {Number} border top width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setBorderTop = setYogaValue("border", (0, _yogaDefault.default).EDGE_TOP);
/**
 * Set border right attribute to node's Yoga instance
 *
 * @param {Number} border right width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setBorderRight = setYogaValue("border", (0, _yogaDefault.default).EDGE_RIGHT);
/**
 * Set border bottom attribute to node's Yoga instance
 *
 * @param {Number} border bottom width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setBorderBottom = setYogaValue("border", (0, _yogaDefault.default).EDGE_BOTTOM);
/**
 * Set border left attribute to node's Yoga instance
 *
 * @param {Number} border left width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setBorderLeft = setYogaValue("border", (0, _yogaDefault.default).EDGE_LEFT);
/**
 * Set position top attribute to node's Yoga instance
 *
 * @param {Number} position top
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionTop = setYogaValue("position", (0, _yogaDefault.default).EDGE_TOP);
/**
 * Set position right attribute to node's Yoga instance
 *
 * @param {Number} position right
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionRight = setYogaValue("position", (0, _yogaDefault.default).EDGE_RIGHT);
/**
 * Set position bottom attribute to node's Yoga instance
 *
 * @param {Number} position bottom
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionBottom = setYogaValue("position", (0, _yogaDefault.default).EDGE_BOTTOM);
/**
 * Set position left attribute to node's Yoga instance
 *
 * @param {Number} position left
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setPositionLeft = setYogaValue("position", (0, _yogaDefault.default).EDGE_LEFT);
/**
 * Set width to node's Yoga instance
 *
 * @param {Number} width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setWidth = setYogaValue("width");
/**
 * Set min width to node's Yoga instance
 *
 * @param {Number} min width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMinWidth = setYogaValue("minWidth");
/**
 * Set max width to node's Yoga instance
 *
 * @param {Number} max width
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMaxWidth = setYogaValue("maxWidth");
/**
 * Set height to node's Yoga instance
 *
 * @param {Number} height
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setHeight = setYogaValue("height");
/**
 * Set min height to node's Yoga instance
 *
 * @param {Number} min height
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMinHeight = setYogaValue("minHeight");
/**
 * Set max height to node's Yoga instance
 *
 * @param {Number} max height
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setMaxHeight = setYogaValue("maxHeight");
var checkPercents = function checkPercents(attr, value) {
    var percent = (0, _fns.matchPercent)(value);
    if (percent) throw new Error("You can't pass percentage values to " + attr + " property");
};
/**
 * Set rowGap value to node's Yoga instance
 *
 * @param {Number} gap value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setRowGap = function setRowGap(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) {
            checkPercents("rowGap", value);
            yogaNode.setGap((0, _yogaDefault.default).GUTTER_ROW, value);
        }
        return node;
    };
};
/**
 * Set columnGap value to node's Yoga instance
 *
 * @param {Number} gap value
 * @param {Object} node instance
 * @return {Object} node instance
 */ var setColumnGap = function setColumnGap(value) {
    return function(node) {
        var yogaNode = node.yogaNode;
        if (!(0, _fns.isNil)(value) && yogaNode) {
            checkPercents("columnGap", value);
            yogaNode.setGap((0, _yogaDefault.default).GUTTER_COLUMN, value);
        }
        return node;
    };
};
var getAspectRatio = function getAspectRatio(viewbox) {
    if (!viewbox) return null;
    return (viewbox.maxX - viewbox.minX) / (viewbox.maxY - viewbox.minY);
};
/**
 * Yoga svg measure function
 *
 * @param {Object} page
 * @param {Object} node
 * @param {Number} width
 * @param {Number} widthMode
 * @param {Number} height
 * @param {Number} heightMode
 * @returns {Object} canvas width and height
 */ var measureCanvas$1 = function measureCanvas(page, node) {
    return function(width, widthMode, height, heightMode) {
        var aspectRatio = getAspectRatio(node.props.viewBox) || 1;
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY || widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) return {
            width: width,
            height: width / aspectRatio
        };
        if (heightMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY) return {
            width: height * aspectRatio
        };
        return {};
    };
};
/**
 * Get lines width (if any)
 *
 * @param {Object} node
 * @returns {Number} lines width
 */ var linesWidth = function linesWidth(node) {
    if (!node.lines) return 0;
    return Math.max.apply(Math, [
        0
    ].concat(node.lines.map(function(line) {
        return line.xAdvance;
    })));
};
/**
 * Get lines height (if any)
 *
 * @param {Object} node
 * @returns {Number} lines height
 */ var linesHeight = function linesHeight(node) {
    if (!node.lines) return -1;
    return node.lines.reduce(function(acc, line) {
        return acc + line.box.height;
    }, 0);
};
/* eslint-disable no-param-reassign */ var ALIGNMENT_FACTORS = {
    center: 0.5,
    right: 1
};
/**
 * Yoga text measure function
 *
 * @param {Object} page
 * @param {Object} node
 * @param {Number} width
 * @param {Number} widthMode
 * @param {Number} height
 * @param {Number} heightMode
 * @returns {Object} text width and height
 */ var measureText = function measureText(page, node, fontStore) {
    return function(width, widthMode, height) {
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY) {
            if (!node.lines) node.lines = layoutText(node, width, height, fontStore);
            return {
                height: linesHeight(node)
            };
        }
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) {
            var _node$style;
            var alignFactor = ALIGNMENT_FACTORS[(_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.textAlign] || 0;
            if (!node.lines) {
                node.lines = layoutText(node, width, height, fontStore);
                node.alignOffset = (width - linesWidth(node)) * alignFactor; // Compensate align in variable width containers
            }
            return {
                height: linesHeight(node),
                width: Math.min(width, linesWidth(node))
            };
        }
        return {};
    };
};
/**
 * Get image ratio
 *
 * @param {Object} image node
 * @returns {Number} image ratio
 */ var getRatio = function getRatio(node) {
    var _node$image;
    return (_node$image = node.image) !== null && _node$image !== void 0 && _node$image.data ? node.image.width / node.image.height : 1;
};
/**
 * Checks if page has auto height
 *
 * @param {Object} page
 * @returns {Boolean} is page height auto
 */ var isHeightAuto = function isHeightAuto(page) {
    var _page$box;
    return (0, _fns.isNil)((_page$box = page.box) === null || _page$box === void 0 ? void 0 : _page$box.height);
};
var SAFETY_HEIGHT$1 = 10;
/**
 * Yoga image measure function
 *
 * @param {Object} page
 * @param {Object} node
 * @param {Number} width
 * @param {Number} widthMode
 * @param {Number} height
 * @param {Number} heightMode
 * @returns {Object} image width and height
 */ var measureImage = function measureImage(page, node) {
    return function(width, widthMode, height, heightMode) {
        var imageRatio = getRatio(node);
        var imageMargin = getMargin(node);
        var pagePadding = getPadding(page);
        var pageArea = isHeightAuto(page) ? Infinity : page.box.height - pagePadding.paddingTop - pagePadding.paddingBottom - imageMargin.marginTop - imageMargin.marginBottom - SAFETY_HEIGHT$1;
        // Skip measure if image data not present yet
        if (!node.image) return {
            width: 0,
            height: 0
        };
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY && heightMode === (0, _yogaDefault.default).MEASURE_MODE_UNDEFINED) {
            var scaledHeight = width / imageRatio;
            return {
                height: Math.min(pageArea, scaledHeight)
            };
        }
        if (heightMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY && (widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST || widthMode === (0, _yogaDefault.default).MEASURE_MODE_UNDEFINED)) return {
            width: Math.min(height * imageRatio, width)
        };
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY && heightMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) {
            var _scaledHeight = width / imageRatio;
            return {
                height: Math.min(height, pageArea, _scaledHeight)
            };
        }
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST && heightMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) {
            if (imageRatio > 1) return {
                width: width,
                height: Math.min(width / imageRatio, height)
            };
            return {
                height: height,
                width: Math.min(height * imageRatio, width)
            };
        }
        return {
            height: height,
            width: width
        };
    };
};
/* eslint-disable no-param-reassign */ var SAFETY_HEIGHT = 10;
var getMax = function getMax(values) {
    return Math.max.apply(Math, [
        -Infinity
    ].concat(values));
};
/**
 * Helper object to predict canvas size
 * TODO: Implement remaining functions (as close as possible);
 */ var measureCtx = function measureCtx() {
    var ctx = {};
    var points = [];
    var nil = function nil() {
        return ctx;
    };
    var addPoint = function addPoint(x, y) {
        return points.push([
            x,
            y
        ]);
    };
    var moveTo = function moveTo() {
        addPoint.apply(void 0, arguments);
        return ctx;
    };
    var rect = function rect(x, y, w, h) {
        addPoint(x, y);
        addPoint(x + w, y);
        addPoint(x, y + h);
        addPoint(x + w, y + h);
        return ctx;
    };
    var ellipse = function ellipse(x, y, rx, ry) {
        ry = ry || rx;
        addPoint(x - rx, y - ry);
        addPoint(x + rx, y - ry);
        addPoint(x + rx, y + ry);
        addPoint(x - rx, y + ry);
        return ctx;
    };
    var polygon = function polygon() {
        points.push.apply(points, arguments);
        return ctx;
    };
    // Change dimensions
    ctx.rect = rect;
    ctx.moveTo = moveTo;
    ctx.lineTo = moveTo;
    ctx.circle = ellipse;
    ctx.polygon = polygon;
    ctx.ellipse = ellipse;
    ctx.roundedRect = rect;
    // To be implemented
    ctx.text = nil;
    ctx.path = nil;
    ctx.lineWidth = nil;
    ctx.bezierCurveTo = nil;
    ctx.quadraticCurveTo = nil;
    ctx.scale = nil;
    ctx.rotate = nil;
    ctx.translate = nil;
    // These don't change dimensions
    ctx.dash = nil;
    ctx.clip = nil;
    ctx.save = nil;
    ctx.fill = nil;
    ctx.font = nil;
    ctx.stroke = nil;
    ctx.lineCap = nil;
    ctx.opacity = nil;
    ctx.restore = nil;
    ctx.lineJoin = nil;
    ctx.fontSize = nil;
    ctx.fillColor = nil;
    ctx.miterLimit = nil;
    ctx.strokeColor = nil;
    ctx.fillOpacity = nil;
    ctx.strokeOpacity = nil;
    ctx.linearGradient = nil;
    ctx.radialGradient = nil;
    ctx.getWidth = function() {
        return getMax(points.map(function(p) {
            return p[0];
        }));
    };
    ctx.getHeight = function() {
        return getMax(points.map(function(p) {
            return p[1];
        }));
    };
    return ctx;
};
/**
 * Yoga canvas measure function
 *
 * @param {Object} page
 * @param {Object} node
 * @param {Number} width
 * @param {Number} widthMode
 * @param {Number} height
 * @param {Number} heightMode
 * @returns {Object} canvas width and height
 */ var measureCanvas = function measureCanvas(page, node) {
    return function() {
        var imageMargin = getMargin(node);
        var pagePadding = getPadding(page);
        var pageArea = isHeightAuto(page) ? Infinity : page.box.height - pagePadding.paddingTop - pagePadding.paddingBottom - imageMargin.marginTop - imageMargin.marginBottom - SAFETY_HEIGHT;
        var ctx = measureCtx();
        node.props.paint(ctx);
        var width = ctx.getWidth();
        var height = Math.min(pageArea, ctx.getHeight());
        return {
            height: height,
            width: width
        };
    };
};
var YOGA_CONFIG = (0, _yogaDefault.default).Config.create();
YOGA_CONFIG.setPointScaleFactor(0);
var isType$1 = function isType(type) {
    return function(node) {
        return node.type === type;
    };
};
var isSvg = isType$1(_primitives.Svg);
var isText$2 = isType$1(_primitives.Text);
var isNote = isType$1(_primitives.Note);
var isPage = isType$1(_primitives.Page);
var isImage = isType$1(_primitives.Image);
var isCanvas = isType$1(_primitives.Canvas);
var isTextInstance$1 = isType$1(_primitives.TextInstance);
var setNodeHeight = function setNodeHeight(node) {
    var value = isPage(node) ? node.box.height : node.style.height;
    return setHeight(value);
};
/**
 * Set styles valeus into yoga node before layout calculation
 *
 * @param {Object} node
 * @returns {Object} node
 */ var setYogaValues = function setYogaValues(node) {
    (0, _fns.compose)(setNodeHeight(node), setWidth(node.style.width), setMinWidth(node.style.minWidth), setMaxWidth(node.style.maxWidth), setMinHeight(node.style.minHeight), setMaxHeight(node.style.maxHeight), setMarginTop(node.style.marginTop), setMarginRight(node.style.marginRight), setMarginBottom(node.style.marginBottom), setMarginLeft(node.style.marginLeft), setPaddingTop(node.style.paddingTop), setPaddingRight(node.style.paddingRight), setPaddingBottom(node.style.paddingBottom), setPaddingLeft(node.style.paddingLeft), setPositionType(node.style.position), setPositionTop(node.style.top), setPositionRight(node.style.right), setPositionBottom(node.style.bottom), setPositionLeft(node.style.left), setBorderTop(node.style.borderTopWidth), setBorderRight(node.style.borderRightWidth), setBorderBottom(node.style.borderBottomWidth), setBorderLeft(node.style.borderLeftWidth), setDisplay(node.style.display), setFlexDirection(node.style.flexDirection), setAlignSelf(node.style.alignSelf), setAlignContent(node.style.alignContent), setAlignItems(node.style.alignItems), setJustifyContent(node.style.justifyContent), setFlexWrap(node.style.flexWrap), setOverflow(node.style.overflow), setAspectRatio(node.style.aspectRatio), setFlexBasis(node.style.flexBasis), setFlexGrow(node.style.flexGrow), setFlexShrink(node.style.flexShrink), setRowGap(node.style.rowGap), setColumnGap(node.style.columnGap))(node);
};
/**
 * Inserts child into parent' yoga node
 *
 * @param {Object} parent
 * @param {Object} node
 * @param {Object} node
 */ var insertYogaNodes = function insertYogaNodes(parent) {
    return function(child) {
        parent.insertChild(child.yogaNode, parent.getChildCount());
        return child;
    };
};
var setMeasureFunc = function setMeasureFunc(node, page, fontStore) {
    var yogaNode = node.yogaNode;
    if (isText$2(node)) yogaNode.setMeasureFunc(measureText(page, node, fontStore));
    if (isImage(node)) yogaNode.setMeasureFunc(measureImage(page, node));
    if (isCanvas(node)) yogaNode.setMeasureFunc(measureCanvas(page, node));
    if (isSvg(node)) yogaNode.setMeasureFunc(measureCanvas$1(page, node));
    return node;
};
var isLayoutElement = function isLayoutElement(node) {
    return !isText$2(node) && !isNote(node) && !isSvg(node);
};
/**
 * Creates and add yoga node to document tree
 * Handles measure function for text and image nodes
 *
 * @param {Object} node
 * @returns {Object} node with appended yoga node
 */ var createYogaNodes = function createYogaNodes(page, fontStore) {
    return function(node) {
        var yogaNode = (0, _yogaDefault.default).Node.createWithConfig(YOGA_CONFIG);
        var result = Object.assign({}, node, {
            yogaNode: yogaNode
        });
        setYogaValues(result);
        if (isLayoutElement(node) && node.children) {
            var resolveChild = (0, _fns.compose)(insertYogaNodes(yogaNode), createYogaNodes(page, fontStore));
            result.children = node.children.map(resolveChild);
        }
        setMeasureFunc(result, page, fontStore);
        return result;
    };
};
/**
 * Performs yoga calculation
 *
 * @param {Object} node
 * @returns {Object} node
 */ var calculateLayout = function calculateLayout(page) {
    page.yogaNode.calculateLayout();
    return page;
};
/**
 * Saves Yoga layout result into 'box' attribute of node
 *
 * @param {Object} node
 * @returns {Object} node with box data
 */ var persistDimensions = function persistDimensions(node) {
    if (isTextInstance$1(node)) return node;
    var box = Object.assign(getPadding(node), getMargin(node), getBorderWidth(node), getPosition(node), getDimension(node));
    var newNode = Object.assign({}, node, {
        box: box
    });
    if (!node.children) return newNode;
    var children = node.children.map(persistDimensions);
    return Object.assign({}, newNode, {
        children: children
    });
};
/**
 * Removes yoga node from document tree
 *
 * @param {Object} node
 * @returns {Object} node without yoga node
 */ var destroyYogaNodes = function destroyYogaNodes(node) {
    var newNode = Object.assign({}, node);
    delete newNode.yogaNode;
    if (!node.children) return newNode;
    var children = node.children.map(destroyYogaNodes);
    return Object.assign({}, newNode, {
        children: children
    });
};
/**
 * Free yoga node from document tree
 *
 * @param {Object} node
 * @returns {Object} node without yoga node
 */ var freeYogaNodes = function freeYogaNodes(node) {
    if (node.yogaNode) node.yogaNode.freeRecursive();
    return node;
};
/**
 * Calculates page object layout using Yoga.
 * Takes node values from 'box' and 'style' attributes, and persist them back into 'box'
 * Destroy yoga values at the end.
 *
 * @param {Object} page object
 * @returns {Object} page object with correct 'box' layout attributes
 */ var resolvePageDimensions = function resolvePageDimensions(page, fontStore) {
    if ((0, _fns.isNil)(page)) return null;
    return (0, _fns.compose)(destroyYogaNodes, freeYogaNodes, persistDimensions, calculateLayout, createYogaNodes(page, fontStore))(page);
};
/**
 * Calculates root object layout using Yoga.
 *
 * @param {Object} root object
 * @returns {Object} root object with correct 'box' layout attributes
 */ var resolveDimensions = function resolveDimensions(node, fontStore) {
    if (!node.children) return node;
    var resolveChild = function resolveChild(child) {
        return resolvePageDimensions(child, fontStore);
    };
    var children = node.children.map(resolveChild);
    return Object.assign({}, node, {
        children: children
    });
};
var isText$1 = function isText(node) {
    return node.type === _primitives.Text;
};
// Prevent splitting elements by low decimal numbers
var SAFTY_THRESHOLD = 0.001;
var assingChildren = function assingChildren(children, node) {
    return Object.assign({}, node, {
        children: children
    });
};
var getTop = function getTop(node) {
    var _node$box;
    return ((_node$box = node.box) === null || _node$box === void 0 ? void 0 : _node$box.top) || 0;
};
var allFixed = function allFixed(nodes) {
    return nodes.every(isFixed);
};
var isDynamic = function isDynamic(node) {
    var _node$props;
    return !(0, _fns.isNil)((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.render);
};
var relayoutPage = (0, _fns.compose)(resolveTextLayout, resolveInheritance, resolvePageDimensions);
var warnUnavailableSpace = function warnUnavailableSpace(node) {
    console.warn("Node of type " + node.type + " can't wrap between pages and it's bigger than available page height");
};
var splitNodes = function splitNodes(height, contentArea, nodes) {
    var currentChildren = [];
    var nextChildren = [];
    for(var i = 0; i < nodes.length; i += 1){
        var child = nodes[i];
        var futureNodes = nodes.slice(i + 1);
        var futureFixedNodes = futureNodes.filter(isFixed);
        var nodeTop = getTop(child);
        var nodeHeight = child.box.height;
        var isOutside = height <= nodeTop;
        var shouldBreak$1 = shouldBreak(child, futureNodes, height);
        var shouldSplit = height + SAFTY_THRESHOLD < nodeTop + nodeHeight;
        var canWrap = getWrap(child);
        var fitsInsidePage = nodeHeight <= contentArea;
        if (isFixed(child)) {
            nextChildren.push(child);
            currentChildren.push(child);
            continue;
        }
        if (isOutside) {
            var box = Object.assign({}, child.box, {
                top: child.box.top - height
            });
            var next = Object.assign({}, child, {
                box: box
            });
            nextChildren.push(next);
            continue;
        }
        if (!fitsInsidePage && !canWrap) {
            currentChildren.push(child);
            nextChildren.push.apply(nextChildren, futureNodes);
            warnUnavailableSpace(child);
            break;
        }
        if (shouldBreak$1) {
            var _box = Object.assign({}, child.box, {
                top: child.box.top - height
            });
            var props = Object.assign({}, child.props, {
                wrap: true,
                break: false
            });
            var _next = Object.assign({}, child, {
                box: _box,
                props: props
            });
            currentChildren.push.apply(currentChildren, futureFixedNodes);
            nextChildren.push.apply(nextChildren, [
                _next
            ].concat(futureNodes));
            break;
        }
        if (shouldSplit) {
            var _split = split(child, height, contentArea), currentChild = _split[0], nextChild = _split[1];
            // All children are moved to the next page, it doesn't make sense to show the parent on the current page
            if (child.children.length > 0 && currentChild.children.length === 0) {
                var _box2 = Object.assign({}, child.box, {
                    top: child.box.top - height
                });
                var _next2 = Object.assign({}, child, {
                    box: _box2
                });
                currentChildren.push.apply(currentChildren, futureFixedNodes);
                nextChildren.push.apply(nextChildren, [
                    _next2
                ].concat(futureNodes));
                break;
            }
            if (currentChild) currentChildren.push(currentChild);
            if (nextChild) nextChildren.push(nextChild);
            continue;
        }
        currentChildren.push(child);
    }
    return [
        currentChildren,
        nextChildren
    ];
};
var splitChildren = function splitChildren(height, contentArea, node) {
    var children = node.children || [];
    var availableHeight = height - getTop(node);
    return splitNodes(availableHeight, contentArea, children);
};
var splitView = function splitView(node, height, contentArea) {
    var _splitNode = splitNode(node, height), currentNode = _splitNode[0], nextNode = _splitNode[1];
    var _splitChildren = splitChildren(height, contentArea, node), currentChilds = _splitChildren[0], nextChildren = _splitChildren[1];
    return [
        assingChildren(currentChilds, currentNode),
        assingChildren(nextChildren, nextNode)
    ];
};
var split = function split(node, height, contentArea) {
    return isText$1(node) ? splitText(node, height) : splitView(node, height, contentArea);
};
var shouldResolveDynamicNodes = function shouldResolveDynamicNodes(node) {
    var children = node.children || [];
    return isDynamic(node) || children.some(shouldResolveDynamicNodes);
};
var resolveDynamicNodes = function resolveDynamicNodes(props, node) {
    var isNodeDynamic = isDynamic(node);
    // Call render prop on dynamic nodes and append result to children
    var resolveChildren = function resolveChildren(children) {
        if (children === void 0) children = [];
        if (isNodeDynamic) {
            var res = node.props.render(props);
            return createInstances(res).filter(Boolean).map(function(n) {
                return resolveDynamicNodes(props, n);
            });
        }
        return children.map(function(c) {
            return resolveDynamicNodes(props, c);
        });
    };
    // We reset dynamic text box so it can be computed again later on
    var resetHeight = isNodeDynamic && isText$1(node);
    var box = resetHeight ? (0, _extendsDefault.default)({}, node.box, {
        height: 0
    }) : node.box;
    var children = resolveChildren(node.children);
    var lines = isNodeDynamic ? null : node.lines;
    return Object.assign({}, node, {
        box: box,
        lines: lines,
        children: children
    });
};
var resolveDynamicPage = function resolveDynamicPage(props, page, fontStore) {
    if (shouldResolveDynamicNodes(page)) {
        var resolvedPage = resolveDynamicNodes(props, page);
        return relayoutPage(resolvedPage, fontStore);
    }
    return page;
};
var splitPage = function splitPage(page, pageNumber, fontStore) {
    var wrapArea = getWrapArea(page);
    var contentArea = getContentArea(page);
    var dynamicPage = resolveDynamicPage({
        pageNumber: pageNumber
    }, page, fontStore);
    var height = page.style.height;
    var _splitNodes = splitNodes(wrapArea, contentArea, dynamicPage.children), currentChilds = _splitNodes[0], nextChilds = _splitNodes[1];
    var relayout = function relayout(node) {
        return relayoutPage(node, fontStore);
    };
    var currentBox = (0, _extendsDefault.default)({}, page.box, {
        height: height
    });
    var currentPage = relayout(Object.assign({}, page, {
        box: currentBox,
        children: currentChilds
    }));
    if (nextChilds.length === 0 || allFixed(nextChilds)) return [
        currentPage,
        null
    ];
    var nextBox = (0, _fns.omit)("height", page.box);
    var nextProps = (0, _fns.omit)("bookmark", page.props);
    var nextPage = relayout(Object.assign({}, page, {
        props: nextProps,
        box: nextBox,
        children: nextChilds
    }));
    return [
        currentPage,
        nextPage
    ];
};
var resolvePageIndices = function resolvePageIndices(fontStore, page, pageNumber, pages) {
    var totalPages = pages.length;
    var props = {
        totalPages: totalPages,
        pageNumber: pageNumber + 1,
        subPageNumber: page.subPageNumber + 1,
        subPageTotalPages: page.subPageTotalPages
    };
    return resolveDynamicPage(props, page, fontStore);
};
var assocSubPageData = function assocSubPageData(subpages) {
    return subpages.map(function(page, i) {
        return (0, _extendsDefault.default)({}, page, {
            subPageNumber: i,
            subPageTotalPages: subpages.length
        });
    });
};
var dissocSubPageData = function dissocSubPageData(page) {
    return (0, _fns.omit)([
        "subPageNumber",
        "subPageTotalPages"
    ], page);
};
var paginate = function paginate(page, pageNumber, fontStore) {
    var _page$props;
    if (!page) return [];
    if (((_page$props = page.props) === null || _page$props === void 0 ? void 0 : _page$props.wrap) === false) return [
        page
    ];
    var splittedPage = splitPage(page, pageNumber, fontStore);
    var pages = [
        splittedPage[0]
    ];
    var nextPage = splittedPage[1];
    while(nextPage !== null){
        splittedPage = splitPage(nextPage, pageNumber + pages.length, fontStore);
        pages.push(splittedPage[0]);
        nextPage = splittedPage[1];
    }
    return pages;
};
/**
 * Performs pagination. This is the step responsible of breaking the whole document
 * into pages following pagiation rules, such as `fixed`, `break` and dynamic nodes.
 *
 * @param {Object} node
 * @param {Object} fontStore font store
 * @returns {Object} layout node
 */ var resolvePagination = function resolvePagination(doc, fontStore) {
    var pages = [];
    var pageNumber = 1;
    for(var i = 0; i < doc.children.length; i += 1){
        var page = doc.children[i];
        var subpages = paginate(page, pageNumber, fontStore);
        subpages = assocSubPageData(subpages);
        pageNumber += subpages.length;
        pages = pages.concat(subpages);
    }
    pages = pages.map(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return dissocSubPageData(resolvePageIndices.apply(void 0, [
            fontStore
        ].concat(args)));
    });
    return assingChildren(pages, doc);
};
/*
 * Translates page percentage horizontal paddings in fixed ones
 *
 * @param {Object} page container
 * @param {String} padding value
 * @returns {Object} translated padding value
 */ var resolvePageHorizontalPadding = function resolvePageHorizontalPadding(container) {
    return function(value) {
        var match = (0, _fns.matchPercent)(value);
        return match ? match.percent * container.width : value;
    };
};
/**
 * Translates page percentage vertical paddings in fixed ones
 *
 * @param {Object} page container
 * @param {String} padding value
 * @returns {Object} translated padding value
 */ var resolvePageVerticalPadding = function resolvePageVerticalPadding(container) {
    return function(value) {
        var match = (0, _fns.matchPercent)(value);
        return match ? match.percent * container.height : value;
    };
};
/**
 * Translates page percentage paddings in fixed ones
 *
 * @param {Object} page
 * @returns {Object} page with fixed paddings
 */ var resolvePagePaddings = function resolvePagePaddings(page) {
    var container = page.style;
    var style = (0, _fns.evolve)({
        paddingTop: resolvePageVerticalPadding(container),
        paddingLeft: resolvePageHorizontalPadding(container),
        paddingRight: resolvePageHorizontalPadding(container),
        paddingBottom: resolvePageVerticalPadding(container)
    }, page.style);
    return Object.assign({}, page, {
        style: style
    });
};
/**
 * Translates all pages percentage paddings in fixed ones
 * This has to be computed from pages calculated size and not by Yoga
 * because at this point we didn't performed pagination yet.
 *
 * @param {Object} document root
 * @returns {Object} document root with translated page paddings
 */ var resolvePagesPaddings = function resolvePagesPaddings(root) {
    if (!root.children) return root;
    var children = root.children.map(resolvePagePaddings);
    return Object.assign({}, root, {
        children: children
    });
};
/**
 *
 * @param {Object} container width and height
 * @param {String | Number} value border radius value
 * @returns {Number} fixed border radius value
 */ var resolveRadius = function resolveRadius(container) {
    return function(value) {
        if (!value) return undefined;
        var match = (0, _fns.matchPercent)(value);
        return match ? match.percent * Math.min(container.width, container.height) : value;
    };
};
/**
 * Transforms percent border radius into fixed values
 *
 * @param {Object} node
 * @returns {Object} node
 */ var resolvePercentRadius = function resolvePercentRadius(node) {
    var style = (0, _fns.evolve)({
        borderTopLeftRadius: resolveRadius(node.box),
        borderTopRightRadius: resolveRadius(node.box),
        borderBottomRightRadius: resolveRadius(node.box),
        borderBottomLeftRadius: resolveRadius(node.box)
    }, node.style || {});
    var newNode = Object.assign({}, node, {
        style: style
    });
    if (!node.children) return newNode;
    var children = node.children.map(resolvePercentRadius);
    return Object.assign({}, newNode, {
        children: children
    });
};
/**
 * Transform percent height into fixed
 *
 * @param {String | number} height
 * @return {number} height
 */ var transformHeight = function transformHeight(pageArea, height) {
    var match = (0, _fns.matchPercent)(height);
    return match ? match.percent * pageArea : height;
};
/**
 * Get page area (height minus paddings)
 *
 * @param {Object} page
 * @return {number} page area
 */ var getPageArea = function getPageArea(page) {
    var _page$style, _page$style2;
    var pageHeight = page.style.height;
    var pagePaddingTop = ((_page$style = page.style) === null || _page$style === void 0 ? void 0 : _page$style.paddingTop) || 0;
    var pagePaddingBottom = ((_page$style2 = page.style) === null || _page$style2 === void 0 ? void 0 : _page$style2.paddingBottom) || 0;
    return pageHeight - pagePaddingTop - pagePaddingBottom;
};
/**
 * Transform node percent height to fixed
 *
 * @param {Object} page
 * @param {Object} node
 * @return {Object} transformed node
 */ var resolveNodePercentHeight = function resolveNodePercentHeight(page, node) {
    var _page$style3, _node$style;
    if ((0, _fns.isNil)((_page$style3 = page.style) === null || _page$style3 === void 0 ? void 0 : _page$style3.height)) return node;
    if ((0, _fns.isNil)((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.height)) return node;
    var pageArea = getPageArea(page);
    var height = transformHeight(pageArea, node.style.height);
    var style = Object.assign({}, node.style, {
        height: height
    });
    return Object.assign({}, node, {
        style: style
    });
};
/**
 * Transform page immediate children with percent height to fixed
 *
 * @param {Object} page
 * @return {Object} transformed page
 */ var resolvePagePercentHeight = function resolvePagePercentHeight(page) {
    if (!page.children) return page;
    var resolveChild = function resolveChild(child) {
        return resolveNodePercentHeight(page, child);
    };
    var children = page.children.map(resolveChild);
    return Object.assign({}, page, {
        children: children
    });
};
/**
 * Transform all page immediate children with percent height to fixed.
 * This is needed for computing correct dimensions on pre-pagination layout.
 *
 * @param {Object} document root
 * @return {Object} transformed document root
 */ var resolvePercentHeight = function resolvePercentHeight(root) {
    if (!root.children) return root;
    var children = root.children.map(resolvePagePercentHeight);
    return Object.assign({}, root, {
        children: children
    });
};
var isType = function isType(type) {
    return function(node) {
        return node.type === type;
    };
};
var isLink = isType(_primitives.Link);
var isText = isType(_primitives.Text);
var isTextInstance = isType(_primitives.TextInstance);
/**
 * Checks if node has render prop
 *
 * @param {Object} node
 * @returns {Boolean} has render prop?
 */ var hasRenderProp = function hasRenderProp(node) {
    var _node$props;
    return !!((_node$props = node.props) !== null && _node$props !== void 0 && _node$props.render);
};
/**
 * Checks if node is text type (Text or TextInstance)
 *
 * @param {Object} node
 * @returns {Boolean} are all children text instances?
 */ var isTextType = function isTextType(node) {
    return isText(node) || isTextInstance(node);
};
/**
 * Checks if is tet link that needs to be wrapped in Text
 *
 * @param {Object} node
 * @returns {Boolean} are all children text instances?
 */ var isTextLink = function isTextLink(node) {
    var children = node.children || [];
    // Text string inside a Link
    if (children.every(isTextInstance)) return true;
    // Text node inside a Link
    if (children.every(isText)) return false;
    return children.every(isTextType);
};
/**
 * Wraps node children inside Text node
 *
 * @param {Object} node
 * @returns {Boolean} node with intermediate Text child
 */ var wrapText = function wrapText(node) {
    var textElement = {
        type: _primitives.Text,
        props: {},
        style: {},
        box: {},
        children: node.children
    };
    return Object.assign({}, node, {
        children: [
            textElement
        ]
    });
};
var transformLink = function transformLink(node) {
    if (!isLink(node)) return node;
    // If has render prop substitute the instance by a Text, that will
    // ultimately render the inline Link via the textkit PDF renderer.
    if (hasRenderProp(node)) return Object.assign({}, node, {
        type: _primitives.Text
    });
    // If is a text link (either contains Text or TextInstalce), wrap it
    // inside a Text element so styles are applied correctly
    if (isTextLink(node)) return wrapText(node);
    return node;
};
/**
 * Transforms Link layout to correctly render text and dynamic rendered links
 *
 * @param {Object} node
 * @returns {Object} node with link substitution
 */ var resolveLinkSubstitution = function resolveLinkSubstitution(node) {
    if (!node.children) return node;
    var resolveChild = (0, _fns.compose)(transformLink, resolveLinkSubstitution);
    var children = node.children.map(resolveChild);
    return Object.assign({}, node, {
        children: children
    });
};
var layout = (0, _fns.asyncCompose)(resolveZIndex, resolveOrigin, resolvePagination, resolveTextLayout, resolvePercentRadius, resolveDimensions, resolveSvg, resolveAssets, resolveInheritance, resolvePercentHeight, resolvePagesPaddings, resolveStyles, resolveLinkSubstitution, resolveBookmarks, resolvePageSizes);

},{"@react-pdf/fns":"9CfuB","@react-pdf/primitives":"6ej9E","@react-pdf/stylesheet":"SWYo7","@react-pdf/textkit":"3eHWb","@babel/runtime/helpers/createClass":"9Lv34","@react-pdf/pdfkit":"wDNMs","@babel/runtime/helpers/regeneratorRuntime":"03zO2","@babel/runtime/helpers/asyncToGenerator":"lbVvv","@babel/runtime/helpers/extends":"jbPGs","emoji-regex":"iXAvI","@react-pdf/image":"7Um3C","@react-pdf/yoga":"loY41","@babel/runtime/helpers/objectWithoutPropertiesLoose":"jR58g","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"SWYo7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>resolveStyles);
parcelHelpers.export(exports, "flatten", ()=>flatten);
parcelHelpers.export(exports, "processTransform", ()=>processTransform);
parcelHelpers.export(exports, "transformColor", ()=>transformColor);
var _fns = require("@react-pdf/fns");
var _parse = require("postcss-value-parser/lib/parse");
var _parseDefault = parcelHelpers.interopDefault(_parse);
var _unit = require("postcss-value-parser/lib/unit");
var _unitDefault = parcelHelpers.interopDefault(_unit);
var _hslToHex = require("hsl-to-hex");
var _hslToHexDefault = parcelHelpers.interopDefault(_hslToHex);
var _colorString = require("color-string");
var _colorStringDefault = parcelHelpers.interopDefault(_colorString);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _mediaEngine = require("media-engine");
var _mediaEngineDefault = parcelHelpers.interopDefault(_mediaEngine);
// https://developer.mozilla.org/en-US/docs/Web/CSS/flex#values
// TODO: change flex defaults to [0, 1, 'auto'] as in spec in next major release
var flexDefaults = [
    1,
    1,
    0
];
var flexAuto = [
    1,
    1,
    "auto"
];
var expandFlex = function expandFlex(key, value) {
    var defaults = flexDefaults;
    var matches = [];
    if (value === "auto") defaults = flexAuto;
    else matches = ("" + value).split(" ");
    var flexGrow = matches[0] || defaults[0];
    var flexShrink = matches[1] || defaults[1];
    var flexBasis = matches[2] || defaults[2];
    return {
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        flexBasis: flexBasis
    };
};
/* eslint-disable no-plusplus */ var BOX_MODEL_UNITS = "px,in,mm,cm,pt,%,vw,vh";
var logError = function logError(style, value) {
    console.error("\n    @react-pdf/stylesheet parsing error:\n\n    " + style + ": " + value + ",\n    " + " ".repeat(style.length + 2) + "^\n    Unsupported " + style + " value format\n  ");
};
var expandBoxModel = function expandBoxModel(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, expandsTo = _ref.expandsTo, _ref$maxValues = _ref.maxValues, maxValues = _ref$maxValues === void 0 ? 1 : _ref$maxValues, _ref$autoSupported = _ref.autoSupported, autoSupported = _ref$autoSupported === void 0 ? false : _ref$autoSupported;
    return function(model, value) {
        var _ref2;
        var nodes = (0, _parseDefault.default)("" + value);
        var parts = [];
        for(var i = 0; i < nodes.length; i++){
            var node = nodes[i];
            // value contains `calc`, `url` or other css function
            // `,`, `/` or strings that unsupported by margin and padding
            if (node.type === "function" || node.type === "string" || node.type === "div") {
                logError(model, value);
                return {};
            }
            if (node.type === "word") {
                if (node.value === "auto" && autoSupported) parts.push(node.value);
                else {
                    var result = (0, _unitDefault.default)(node.value);
                    // when unit isn't specified this condition is true
                    if (result && BOX_MODEL_UNITS.includes(result.unit)) parts.push(node.value);
                    else {
                        logError(model, value);
                        return {};
                    }
                }
            }
        }
        // checks that we have enough parsed values
        if (parts.length > maxValues) {
            logError(model, value);
            return {};
        }
        var first = parts[0];
        if (expandsTo) {
            var second = parts[1] || parts[0];
            var third = parts[2] || parts[0];
            var fourth = parts[3] || parts[1] || parts[0];
            return expandsTo({
                first: first,
                second: second,
                third: third,
                fourth: fourth
            });
        }
        return _ref2 = {}, _ref2[model] = first, _ref2;
    };
};
var processMargin = expandBoxModel({
    expandsTo: function expandsTo(_ref) {
        var first = _ref.first, second = _ref.second, third = _ref.third, fourth = _ref.fourth;
        return {
            marginTop: first,
            marginRight: second,
            marginBottom: third,
            marginLeft: fourth
        };
    },
    maxValues: 4,
    autoSupported: true
});
var processMarginVertical = expandBoxModel({
    expandsTo: function expandsTo(_ref2) {
        var first = _ref2.first, second = _ref2.second;
        return {
            marginTop: first,
            marginBottom: second
        };
    },
    maxValues: 2,
    autoSupported: true
});
var processMarginHorizontal = expandBoxModel({
    expandsTo: function expandsTo(_ref3) {
        var first = _ref3.first, second = _ref3.second;
        return {
            marginRight: first,
            marginLeft: second
        };
    },
    maxValues: 2,
    autoSupported: true
});
var processMarginSingle = expandBoxModel({
    autoSupported: true
});
var BORDER_SHORTHAND_REGEX = /(-?\d+(\.\d+)?(px|in|mm|cm|pt|vw|vh|px)?)\s(\S+)\s(.+)/;
var matchBorderShorthand = function matchBorderShorthand(value) {
    return value.match(BORDER_SHORTHAND_REGEX) || [];
};
var expandBorders = function expandBorders(key, value) {
    var match = matchBorderShorthand("" + value);
    if (match) {
        var color = match[5] || value;
        var style = match[4] || value;
        var width = match[1] || value;
        if (key.match(/(Top|Right|Bottom|Left)$/)) {
            var _ref;
            return _ref = {}, _ref[key + "Color"] = color, _ref[key + "Style"] = style, _ref[key + "Width"] = width, _ref;
        }
        if (key.match(/Color$/)) return {
            borderTopColor: color,
            borderRightColor: color,
            borderBottomColor: color,
            borderLeftColor: color
        };
        if (key.match(/Style$/)) return {
            borderTopStyle: style,
            borderRightStyle: style,
            borderBottomStyle: style,
            borderLeftStyle: style
        };
        if (key.match(/Width$/)) return {
            borderTopWidth: width,
            borderRightWidth: width,
            borderBottomWidth: width,
            borderLeftWidth: width
        };
        if (key.match(/Radius$/)) return {
            borderTopLeftRadius: value,
            borderTopRightRadius: value,
            borderBottomRightRadius: value,
            borderBottomLeftRadius: value
        };
        return {
            borderTopColor: color,
            borderTopStyle: style,
            borderTopWidth: width,
            borderRightColor: color,
            borderRightStyle: style,
            borderRightWidth: width,
            borderBottomColor: color,
            borderBottomStyle: style,
            borderBottomWidth: width,
            borderLeftColor: color,
            borderLeftStyle: style,
            borderLeftWidth: width
        };
    }
    return value;
};
var processPadding = expandBoxModel({
    expandsTo: function expandsTo(_ref) {
        var first = _ref.first, second = _ref.second, third = _ref.third, fourth = _ref.fourth;
        return {
            paddingTop: first,
            paddingRight: second,
            paddingBottom: third,
            paddingLeft: fourth
        };
    },
    maxValues: 4
});
var processPaddingVertical = expandBoxModel({
    expandsTo: function expandsTo(_ref2) {
        var first = _ref2.first, second = _ref2.second;
        return {
            paddingTop: first,
            paddingBottom: second
        };
    },
    maxValues: 2
});
var processPaddingHorizontal = expandBoxModel({
    expandsTo: function expandsTo(_ref3) {
        var first = _ref3.first, second = _ref3.second;
        return {
            paddingRight: first,
            paddingLeft: second
        };
    },
    maxValues: 2
});
var processPaddingSingle = expandBoxModel();
var expandObjectPosition = function expandObjectPosition(key, value) {
    var match = ("" + value).split(" ");
    return {
        objectPositionX: (match === null || match === void 0 ? void 0 : match[0]) || value,
        objectPositionY: (match === null || match === void 0 ? void 0 : match[1]) || value
    };
};
var Y_AXIS_SHORTHANDS = {
    top: true,
    bottom: true
};
var sortTransformOriginPair = function sortTransformOriginPair(a, b) {
    if (Y_AXIS_SHORTHANDS[a]) return 1;
    if (Y_AXIS_SHORTHANDS[b]) return -1;
    return 0;
};
var getTransformOriginPair = function getTransformOriginPair(values) {
    if (!values || values.length === 0) return [
        "center",
        "center"
    ];
    var pair = values.length === 1 ? [
        values[0],
        "center"
    ] : values;
    return pair.sort(sortTransformOriginPair);
};
// Transforms shorthand transformOrigin values
var expandTransformOrigin = function expandTransformOrigin(key, value) {
    var match = ("" + value).split(" ");
    var pair = getTransformOriginPair(match);
    return {
        transformOriginX: pair[0],
        transformOriginY: pair[1]
    };
};
var expandGap = function expandGap(key, value) {
    var match = ("" + value).split(" ");
    return {
        rowGap: (match === null || match === void 0 ? void 0 : match[0]) || value,
        columnGap: (match === null || match === void 0 ? void 0 : match[1]) || value
    };
};
var shorthands = {
    flex: expandFlex,
    gap: expandGap,
    margin: processMargin,
    marginHorizontal: processMarginHorizontal,
    marginVertical: processMarginVertical,
    marginTop: processMarginSingle,
    marginRight: processMarginSingle,
    marginBottom: processMarginSingle,
    marginLeft: processMarginSingle,
    padding: processPadding,
    paddingHorizontal: processPaddingHorizontal,
    paddingVertical: processPaddingVertical,
    paddingTop: processPaddingSingle,
    paddingRight: processPaddingSingle,
    paddingBottom: processPaddingSingle,
    paddingLeft: processPaddingSingle,
    border: expandBorders,
    borderTop: expandBorders,
    borderRight: expandBorders,
    borderBottom: expandBorders,
    borderLeft: expandBorders,
    borderColor: expandBorders,
    borderRadius: expandBorders,
    borderStyle: expandBorders,
    borderWidth: expandBorders,
    objectPosition: expandObjectPosition,
    transformOrigin: expandTransformOrigin
};
/**
 * Transforms style key-value
 *
 * @param {String} key style key
 * @param {String} value style value
 * @returns {String | Number} transformed style values
 */ var expandStyle = function expandStyle(key, value) {
    var _ref;
    return shorthands[key] ? shorthands[key](key, value) : (_ref = {}, _ref[key] = value, _ref);
};
/**
 * Expand the shorthand properties.
 *
 * @param { Object } style object
 * @returns { Object } expanded style object
 */ var expand = function expand(style) {
    if (!style) return style;
    var propsArray = Object.keys(style);
    var resolvedStyle = {};
    for(var i = 0; i < propsArray.length; i += 1){
        var key = propsArray[i];
        var value = style[key];
        var extended = expandStyle(key, value);
        var keys = Object.keys(extended);
        for(var j = 0; j < keys.length; j += 1){
            var propName = keys[j];
            var propValue = extended[propName];
            resolvedStyle[propName] = propValue;
        }
    }
    return resolvedStyle;
};
/**
 * Remove nil values from array
 *
 * @param {Array} array
 * @returns {Array} array without nils
 */ var compact = function compact(array) {
    return array.filter(Boolean);
};
/**
 * Merges style objects array
 *
 * @param {Array} style objects array
 * @returns {Object} merged style object
 */ var mergeStyles = function mergeStyles(styles) {
    return styles.reduce(function(acc, style) {
        var s = Array.isArray(style) ? flatten(style) : style;
        Object.keys(s).forEach(function(key) {
            if (s[key] !== null && s[key] !== undefined) acc[key] = s[key];
        });
        return acc;
    }, {});
};
/**
 * Flattens an array of style objects, into one aggregated style object.
 *
 * @param {Array} style objects array
 * @returns {Object} flatted style object
 */ var flatten = (0, _fns.compose)(mergeStyles, compact, (0, _fns.castArray));
/**
 * Parses scalar value in value and unit pairs
 *
 * @param {String} scalar value
 * @returns {Object} parsed value
 */ var parseValue = function parseValue(value) {
    var match = /^(-?\d*\.?\d+)(in|mm|cm|pt|vh|vw|px)?$/g.exec(value);
    return match ? {
        value: parseFloat(match[1], 10),
        unit: match[2] || "pt"
    } : {
        value: value,
        unit: undefined
    };
};
/**
 * Transform given scalar value
 *
 * @param {Object} container
 * @param {String} styles value
 * @returns {Object} transformed value
 */ var transformUnit = function transformUnit(container, value) {
    var scalar = parseValue(value);
    var dpi = container.dpi || 72;
    var mmFactor = 1 / 25.4 * dpi;
    var cmFactor = 1 / 2.54 * dpi;
    switch(scalar.unit){
        case "in":
            return scalar.value * dpi;
        case "mm":
            return scalar.value * mmFactor;
        case "cm":
            return scalar.value * cmFactor;
        case "vh":
            return scalar.value * (container.height / 100);
        case "vw":
            return scalar.value * (container.width / 100);
        default:
            return scalar.value;
    }
};
var isRgb = function isRgb(value) {
    return /rgba?/g.test(value);
};
var isHsl = function isHsl(value) {
    return /hsla?/g.test(value);
};
/**
 * Transform rgb color to hexa
 *
 * @param {String} styles value
 * @returns {Object} transformed value
 */ var parseRgb = function parseRgb(value) {
    var rgb = (0, _colorStringDefault.default).get.rgb(value);
    return (0, _colorStringDefault.default).to.hex(rgb);
};
/**
 * Transform Hsl color to hexa
 *
 * @param {String} styles value
 * @returns {Object} transformed value
 */ var parseHsl = function parseHsl(value) {
    var hsl = (0, _colorStringDefault.default).get.hsl(value).map(Math.round);
    var hex = (0, _hslToHexDefault.default).apply(void 0, hsl);
    return hex.toUpperCase();
};
/**
 * Transform given color to hexa
 *
 * @param {String} styles value
 * @returns {Object} transformed value
 */ var transformColor = function transformColor(value) {
    if (isRgb(value)) return parseRgb(value);
    if (isHsl(value)) return parseHsl(value);
    return value;
};
var parse = function parse(transformString) {
    var transforms = transformString.trim().split(/\) |\)/);
    // Handle "initial", "inherit", "unset".
    if (transforms.length === 1) return [
        [
            transforms[0],
            true
        ]
    ];
    var parsed = [];
    for(var i = 0; i < transforms.length; i += 1){
        var transform = transforms[i];
        if (transform) {
            var _transform$split = transform.split("("), name = _transform$split[0], rawValue = _transform$split[1];
            var splitChar = rawValue.indexOf(",") >= 0 ? "," : " ";
            var value = rawValue.split(splitChar).map(function(val) {
                return val.trim();
            });
            parsed.push({
                operation: name,
                value: value
            });
        }
    }
    return parsed;
};
var parseAngle = function parseAngle(value) {
    var unitsRegexp = /(-?\d*\.?\d*)(\w*)?/i;
    var _unitsRegexp$exec = unitsRegexp.exec(value), angle = _unitsRegexp$exec[1], unit = _unitsRegexp$exec[2];
    var number = Number.parseFloat(angle);
    return unit === "rad" ? number * 180 / Math.PI : number;
};
var normalizeTransformOperation = function normalizeTransformOperation(_ref) {
    var operation = _ref.operation, value = _ref.value;
    switch(operation){
        case "scale":
            var _value$map = value.map(function(num) {
                return Number.parseFloat(num);
            }), scaleX = _value$map[0], _value$map$ = _value$map[1], scaleY = _value$map$ === void 0 ? scaleX : _value$map$;
            return {
                operation: "scale",
                value: [
                    scaleX,
                    scaleY
                ]
            };
        case "scaleX":
            return {
                operation: "scale",
                value: [
                    Number.parseFloat(value),
                    1
                ]
            };
        case "scaleY":
            return {
                operation: "scale",
                value: [
                    1,
                    Number.parseFloat(value)
                ]
            };
        case "rotate":
            return {
                operation: "rotate",
                value: [
                    parseAngle(value)
                ]
            };
        case "translate":
            return {
                operation: "translate",
                value: value.map(function(num) {
                    return Number.parseFloat(num);
                })
            };
        case "translateX":
            return {
                operation: "translate",
                value: [
                    Number.parseFloat(value),
                    0
                ]
            };
        case "translateY":
            return {
                operation: "translate",
                value: [
                    0,
                    Number.parseFloat(value)
                ]
            };
        case "skew":
            return {
                operation: "skew",
                value: value.map(parseAngle)
            };
        case "skewX":
            return {
                operation: "skew",
                value: [
                    parseAngle(value),
                    0
                ]
            };
        case "skewY":
            return {
                operation: "skew",
                value: [
                    0,
                    parseAngle(value)
                ]
            };
        default:
            return {
                operation: operation,
                value: value.map(function(num) {
                    return Number.parseFloat(num);
                })
            };
    }
};
var normalize = function normalize(operations) {
    return operations.map(function(operation) {
        return normalizeTransformOperation(operation);
    });
};
var processTransform = function processTransform(value) {
    if (typeof value !== "string") return value;
    return normalize(parse(value));
};
var FONT_WEIGHTS = {
    thin: 100,
    hairline: 100,
    ultralight: 200,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    demibold: 600,
    bold: 700,
    ultrabold: 800,
    extrabold: 800,
    heavy: 900,
    black: 900
};
var processFontWeight = function processFontWeight(value) {
    if (!value) return FONT_WEIGHTS.normal;
    if (typeof value === "number") return value;
    var lv = value.toLowerCase();
    if (FONT_WEIGHTS[lv]) return FONT_WEIGHTS[lv];
    return value;
};
var matchNumber = function matchNumber(value) {
    return typeof value === "string" && /^-?\d*\.?\d*$/.test(value);
};
var castFloat = function castFloat(value) {
    if (typeof value !== "string") return value;
    if (matchNumber(value)) return parseFloat(value, 10);
    return value;
};
var offsetKeyword = function offsetKeyword(value) {
    switch(value){
        case "top":
        case "left":
            return "0%";
        case "right":
        case "bottom":
            return "100%";
        case "center":
            return "50%";
        default:
            return null;
    }
};
var transformObjectPosition = function transformObjectPosition(value) {
    return offsetKeyword(value) || castFloat(value);
};
var transformTransformOrigin = function transformTransformOrigin(value) {
    return offsetKeyword(value) || castFloat(value);
};
var handlers = {
    transform: processTransform,
    fontWeight: processFontWeight,
    objectPositionX: transformObjectPosition,
    objectPositionY: transformObjectPosition,
    transformOriginX: transformTransformOrigin,
    transformOriginY: transformTransformOrigin
};
var transformStyle = function transformStyle(key, value, container) {
    var result = handlers[key] ? handlers[key](value) : value;
    return transformColor(transformUnit(container, castFloat(result)));
};
/**
 * Transform styles values
 *
 * @param {Object} styles object
 * @returns {Object} transformed styles
 */ var transform = function transform(container) {
    return function(style) {
        if (!style) return style;
        var propsArray = Object.keys(style);
        var resolvedStyle = {};
        for(var i = 0; i < propsArray.length; i += 1){
            var key = propsArray[i];
            var value = style[key];
            var transformed = transformStyle(key, value, container);
            resolvedStyle[key] = transformed;
        }
        return resolvedStyle;
    };
};
/**
 * Resolves media queries in styles object
 *
 * @param {Object} container
 * @param {Object} styles object
 */ var resolveMediaQueries = function resolveMediaQueries(container, styles) {
    return Object.keys(styles).reduce(function(acc, key) {
        var _extends2;
        if (/@media/.test(key)) {
            var _matchMedia;
            return (0, _extendsDefault.default)({}, acc, (0, _mediaEngineDefault.default)((_matchMedia = {}, _matchMedia[key] = styles[key], _matchMedia), container));
        }
        return (0, _extendsDefault.default)({}, acc, (_extends2 = {}, _extends2[key] = styles[key], _extends2));
    }, {});
};
/**
 * Resolves styles
 *
 * @param {Object} container
 * @param {Object} style object
 * @returns {Object} resolved style object
 */ var resolveStyles = function resolveStyles(container, style) {
    var computeMediaQueries = function computeMediaQueries(value) {
        return resolveMediaQueries(container, value);
    };
    return (0, _fns.compose)(transform(container), expand, computeMediaQueries, flatten)(style);
};

},{"@react-pdf/fns":"9CfuB","postcss-value-parser/lib/parse":"4jJXR","postcss-value-parser/lib/unit":"ipU9T","hsl-to-hex":"h1QwH","color-string":"lysB6","@babel/runtime/helpers/extends":"jbPGs","media-engine":"eLpff","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4jJXR":[function(require,module,exports) {
var openParentheses = "(".charCodeAt(0);
var closeParentheses = ")".charCodeAt(0);
var singleQuote = "'".charCodeAt(0);
var doubleQuote = '"'.charCodeAt(0);
var backslash = "\\".charCodeAt(0);
var slash = "/".charCodeAt(0);
var comma = ",".charCodeAt(0);
var colon = ":".charCodeAt(0);
var star = "*".charCodeAt(0);
var uLower = "u".charCodeAt(0);
var uUpper = "U".charCodeAt(0);
var plus = "+".charCodeAt(0);
var isUnicodeRange = /^[a-f0-9?-]+$/i;
module.exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos, parenthesesOpenPos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") {
                prev.after = token;
                prev.sourceEndIndex += token.length;
            } else if (code === comma || code === colon || code === slash && value.charCodeAt(next + 1) !== star && (!parent || parent && parent.type === "function" && parent.value !== "calc")) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                sourceEndIndex: next,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === singleQuote || code === doubleQuote) {
            next = pos;
            quote = code === singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            token.sourceEndIndex = token.unclosed ? next : next + 1;
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === slash && value.charCodeAt(pos + 1) === star) {
            next = value.indexOf("*/", pos);
            token = {
                type: "comment",
                sourceIndex: pos,
                sourceEndIndex: next + 2
            };
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
                token.sourceEndIndex = next;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Operation within calc
        } else if ((code === slash || code === star) && parent && parent.type === "function" && parent.value === "calc") {
            token = value[pos];
            tokens.push({
                type: "word",
                sourceIndex: pos - before.length,
                sourceEndIndex: pos + token.length,
                value: token
            });
            pos += 1;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === slash || code === comma || code === colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                sourceEndIndex: pos + token.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if (openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            parenthesesOpenPos = pos;
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(parenthesesOpenPos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== singleQuote && code !== doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (parenthesesOpenPos < whitespacePos) {
                    if (pos !== whitespacePos + 1) token.nodes = [
                        {
                            type: "word",
                            sourceIndex: pos,
                            sourceEndIndex: whitespacePos + 1,
                            value: value.slice(pos, whitespacePos + 1)
                        }
                    ];
                    else token.nodes = [];
                    if (token.unclosed && whitespacePos + 1 !== next) {
                        token.after = "";
                        token.nodes.push({
                            type: "space",
                            sourceIndex: whitespacePos + 1,
                            sourceEndIndex: next,
                            value: value.slice(whitespacePos + 1, next)
                        });
                    } else {
                        token.after = value.slice(whitespacePos + 1, next);
                        token.sourceEndIndex = next;
                    }
                } else {
                    token.after = "";
                    token.nodes = [];
                }
                pos = next + 1;
                token.sourceEndIndex = token.unclosed ? next : pos;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                token.sourceEndIndex = pos + 1;
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if (closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            parent.sourceEndIndex += after.length;
            after = "";
            balanced -= 1;
            stack[stack.length - 1].sourceEndIndex = pos;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === singleQuote || code === doubleQuote || code === comma || code === colon || code === slash || code === openParentheses || code === star && parent && parent.type === "function" && parent.value === "calc" || code === slash && parent.type === "function" && parent.value === "calc" || code === closeParentheses && balanced));
            token = value.slice(pos, next);
            if (openParentheses === code) name = token;
            else if ((uLower === token.charCodeAt(0) || uUpper === token.charCodeAt(0)) && plus === token.charCodeAt(1) && isUnicodeRange.test(token.slice(2))) tokens.push({
                type: "unicode-range",
                sourceIndex: pos,
                sourceEndIndex: next,
                value: token
            });
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                sourceEndIndex: next,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1){
        stack[pos].unclosed = true;
        stack[pos].sourceEndIndex = value.length;
    }
    return stack[0].nodes;
};

},{}],"ipU9T":[function(require,module,exports) {
var minus = "-".charCodeAt(0);
var plus = "+".charCodeAt(0);
var dot = ".".charCodeAt(0);
var exp = "e".charCodeAt(0);
var EXP = "E".charCodeAt(0);
// Check if three code points would start a number
// https://www.w3.org/TR/css-syntax-3/#starts-with-a-number
function likeNumber(value) {
    var code = value.charCodeAt(0);
    var nextCode;
    if (code === plus || code === minus) {
        nextCode = value.charCodeAt(1);
        if (nextCode >= 48 && nextCode <= 57) return true;
        var nextNextCode = value.charCodeAt(2);
        if (nextCode === dot && nextNextCode >= 48 && nextNextCode <= 57) return true;
        return false;
    }
    if (code === dot) {
        nextCode = value.charCodeAt(1);
        if (nextCode >= 48 && nextCode <= 57) return true;
        return false;
    }
    if (code >= 48 && code <= 57) return true;
    return false;
}
// Consume a number
// https://www.w3.org/TR/css-syntax-3/#consume-number
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var code;
    var nextCode;
    var nextNextCode;
    if (length === 0 || !likeNumber(value)) return false;
    code = value.charCodeAt(pos);
    if (code === plus || code === minus) pos++;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code < 48 || code > 57) break;
        pos += 1;
    }
    code = value.charCodeAt(pos);
    nextCode = value.charCodeAt(pos + 1);
    if (code === dot && nextCode >= 48 && nextCode <= 57) {
        pos += 2;
        while(pos < length){
            code = value.charCodeAt(pos);
            if (code < 48 || code > 57) break;
            pos += 1;
        }
    }
    code = value.charCodeAt(pos);
    nextCode = value.charCodeAt(pos + 1);
    nextNextCode = value.charCodeAt(pos + 2);
    if ((code === exp || code === EXP) && (nextCode >= 48 && nextCode <= 57 || (nextCode === plus || nextCode === minus) && nextNextCode >= 48 && nextNextCode <= 57)) {
        pos += nextCode === plus || nextCode === minus ? 3 : 2;
        while(pos < length){
            code = value.charCodeAt(pos);
            if (code < 48 || code > 57) break;
            pos += 1;
        }
    }
    return {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    };
};

},{}],"h1QwH":[function(require,module,exports) {
// In our case, there's only one dependency
var toRgb = require("467415a3873c50a0");
// Typically all dependencies should be declared at the top of the file.
// Now let's define an API for our module, we're taking hue, saturation and luminosity values and outputting a CSS compatible hex string.
// Hue is in degrees, between 0 and 359. Since degrees a cyclical in nature, we'll support numbers greater than 359 or less than 0 by "spinning" them around until they fall within the 0 to 359 range.
// Saturation and luminosity are both percentages, we'll represent these percentages with whole numbers between 0 and 100. For these numbers we'll need to enforce a maximum and a minimum, anything below 0 will become 0, anything above 100 will become 100.
// Let's write some utility functions to handle this logic:
function max(val, n) {
    return val > n ? n : val;
}
function min(val, n) {
    return val < n ? n : val;
}
function cycle(val) {
    // for safety:
    val = max(val, 1e7);
    val = min(val, -10000000);
    // cycle value:
    while(val < 0)val += 360;
    while(val > 359)val -= 360;
    return val;
}
// Now for the main piece, the `hsl` function:
function hsl(hue, saturation, luminosity) {
    // resolve degrees to 0 - 359 range
    hue = cycle(hue);
    // enforce constraints
    saturation = min(max(saturation, 100), 0);
    luminosity = min(max(luminosity, 100), 0);
    // convert to 0 to 1 range used by hsl-to-rgb-for-reals
    saturation /= 100;
    luminosity /= 100;
    // let hsl-to-rgb-for-reals do the hard work
    var rgb = toRgb(hue, saturation, luminosity);
    // convert each value in the returned RGB array
    // to a 2 character hex value, join the array into
    // a string, prefixed with a hash
    return "#" + rgb.map(function(n) {
        return (256 + n).toString(16).substr(-2);
    }).join("");
}
// In order to make our code into a bona fide module we have to export it:
module.exports = hsl;

},{"467415a3873c50a0":"9aqsm"}],"9aqsm":[function(require,module,exports) {
// expected hue range: [0, 360)
// expected saturation range: [0, 1]
// expected lightness range: [0, 1]
var hslToRgb = function(hue, saturation, lightness) {
    // based on algorithm from http://en.wikipedia.org/wiki/HSL_and_HSV#Converting_to_RGB
    if (hue == undefined) return [
        0,
        0,
        0
    ];
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var huePrime = hue / 60;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    huePrime = Math.floor(huePrime);
    var red;
    var green;
    var blue;
    if (huePrime === 0) {
        red = chroma;
        green = secondComponent;
        blue = 0;
    } else if (huePrime === 1) {
        red = secondComponent;
        green = chroma;
        blue = 0;
    } else if (huePrime === 2) {
        red = 0;
        green = chroma;
        blue = secondComponent;
    } else if (huePrime === 3) {
        red = 0;
        green = secondComponent;
        blue = chroma;
    } else if (huePrime === 4) {
        red = secondComponent;
        green = 0;
        blue = chroma;
    } else if (huePrime === 5) {
        red = chroma;
        green = 0;
        blue = secondComponent;
    }
    var lightnessAdjustment = lightness - chroma / 2;
    red += lightnessAdjustment;
    green += lightnessAdjustment;
    blue += lightnessAdjustment;
    return [
        Math.abs(Math.round(red * 255)),
        Math.abs(Math.round(green * 255)),
        Math.abs(Math.round(blue * 255))
    ];
};
module.exports = hslToRgb;

},{}],"eLpff":[function(require,module,exports) {
var Parser = require("87bc0e8707db2e9a");
module.exports = function(queries, options) {
    var result = {};
    Object.keys(queries).forEach(function(query) {
        if (Parser.parse(query).match(options)) Object.assign(result, queries[query]);
    });
    return result;
};

},{"87bc0e8707db2e9a":"1q681"}],"1q681":[function(require,module,exports) {
var Query = require("65352f2699c24bdf");
var Operator = require("7f5fc0bd01bcfeb3");
var NUMBERS = /[0-9]/;
var LETTERS = /[a-z|\-]/i;
var WHITESPACE = /\s/;
var COLON = /:/;
var COMMA = /,/;
var AND = /and$/;
var AT = /@/;
function tokenizer(input) {
    var current = 0;
    var tokens = [];
    while(current < input.length){
        var char = input[current];
        if (AT.test(char)) {
            char = input[++current];
            while(LETTERS.test(char) && char !== undefined)char = input[++current];
        }
        if (WHITESPACE.test(char) || char === ")" || char === "(") {
            current++;
            continue;
        }
        if (COLON.test(char) || COMMA.test(char)) {
            current++;
            tokens.push({
                type: "operator",
                value: char
            });
            continue;
        }
        if (NUMBERS.test(char)) {
            var value = "";
            while(NUMBERS.test(char)){
                value += char;
                char = input[++current];
            }
            tokens.push({
                type: "number",
                value: value
            });
            continue;
        }
        if (LETTERS.test(char)) {
            var value = "";
            while(LETTERS.test(char) && char !== undefined){
                value += char;
                char = input[++current];
            }
            if (AND.test(value)) tokens.push({
                type: "operator",
                value: value
            });
            else tokens.push({
                type: "literal",
                value: value
            });
            continue;
        }
        throw new TypeError("Tokenizer: I dont know what this character is: " + char);
    }
    return tokens;
}
function parser(tokens) {
    var output = [];
    var stack = [];
    while(tokens.length > 0){
        var token = tokens.shift();
        if (token.type === "number" || token.type === "literal") {
            output.push(token);
            continue;
        }
        if (token.type === "operator") {
            if (COLON.test(token.value)) {
                token = {
                    type: "query",
                    key: output.pop(),
                    value: tokens.shift()
                };
                output.push(token);
                continue;
            }
            while(stack.length > 0)output.unshift(stack.pop());
            stack.push(token);
        }
    }
    while(stack.length > 0)output.unshift(stack.pop());
    function walk() {
        var head = output.shift();
        if (head.type === "number") return parseInt(head.value);
        if (head.type === "literal") return head.value;
        if (head.type === "operator") {
            var l = walk();
            var r = walk();
            return Operator(head.value, l, r);
        }
        if (head.type === "query") {
            var l = head.key.value;
            var r = head.value.value;
            return Query(l, r);
        }
    }
    return walk();
}
module.exports = {
    parse: function(query) {
        var tokens = tokenizer(query);
        var ast = parser(tokens);
        return ast;
    }
};

},{"65352f2699c24bdf":"jnde1","7f5fc0bd01bcfeb3":"kkMIr"}],"jnde1":[function(require,module,exports) {
function MaxHeight(value) {
    this.value = value;
    this.match = function(options) {
        return this.value >= options.height;
    };
}
function MinHeight(value) {
    this.value = value;
    this.match = function(options) {
        return this.value < options.height;
    };
}
function MaxWidth(value) {
    this.value = value;
    this.match = function(options) {
        return this.value >= options.width;
    };
}
function MinWidth(value) {
    this.value = value;
    this.match = function(options) {
        return this.value < options.width;
    };
}
function Orientation(value) {
    this.value = value;
    this.match = function(options) {
        return this.value === options.orientation;
    };
}
module.exports = function Query(type, value) {
    switch(type){
        case "max-height":
            return new MaxHeight(value);
        case "min-height":
            return new MinHeight(value);
        case "max-width":
            return new MaxWidth(value);
        case "min-width":
            return new MinWidth(value);
        case "orientation":
            return new Orientation(value);
        default:
            throw new Error(value);
    }
};

},{}],"kkMIr":[function(require,module,exports) {
function And(left, right) {
    this.left = left;
    this.right = right;
    this.match = function(options) {
        return left.match(options) && right.match(options);
    };
}
function Or(left, right) {
    this.left = left;
    this.right = right;
    this.match = function(options) {
        return left.match(options) || right.match(options);
    };
}
module.exports = function Operator(type, left, right) {
    switch(type){
        case "and":
            return new And(left, right);
        case ",":
            return new Or(left, right);
        default:
            throw new Error(value);
    }
};

},{}],"3eHWb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>layoutEngine);
parcelHelpers.export(exports, "fontSubstitution", ()=>fontSubstitution);
parcelHelpers.export(exports, "justification", ()=>justification);
parcelHelpers.export(exports, "linebreaker", ()=>linebreaker);
parcelHelpers.export(exports, "scriptItemizer", ()=>scriptItemizer);
parcelHelpers.export(exports, "textDecoration", ()=>textDecoration);
parcelHelpers.export(exports, "wordHyphenation", ()=>wordHyphenation);
var _fns = require("@react-pdf/fns");
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _createForOfIteratorHelperLoose = require("@babel/runtime/helpers/createForOfIteratorHelperLoose");
var _createForOfIteratorHelperLooseDefault = parcelHelpers.interopDefault(_createForOfIteratorHelperLoose);
var _unicodeProperties = require("unicode-properties");
var _unicodePropertiesDefault = parcelHelpers.interopDefault(_unicodeProperties);
var _hyphen = require("hyphen");
var _hyphenDefault = parcelHelpers.interopDefault(_hyphen);
var _enUs = require("hyphen/patterns/en-us");
var _enUsDefault = parcelHelpers.interopDefault(_enUs);
/**
 * Create attributed string from text fragments
 *
 * @param  {Array}  fragments
 * @return {Object} attributed string
 */ var fromFragments = function fromFragments(fragments) {
    var offset = 0;
    var string = "";
    var runs = [];
    fragments.forEach(function(fragment) {
        string += fragment.string;
        runs.push({
            start: offset,
            end: offset + fragment.string.length,
            attributes: fragment.attributes || {}
        });
        offset += fragment.string.length;
    });
    return {
        string: string,
        runs: runs
    };
};
/**
 * Default word hyphenation engine used when no one provided.
 * Does not perform word hyphenation at all
 *
 * @param  {String} word
 * @return {Array} same word
 */ var defaultHyphenationEngine = function defaultHyphenationEngine(word) {
    return [
        word
    ];
};
/**
 * Wrap words of attribute string
 *
 * @param  {Object} layout engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string including syllables
 */ var wrapWords = function wrapWords(engines, options) {
    if (engines === void 0) engines = {};
    if (options === void 0) options = {};
    return function(attributedString) {
        var _engines$wordHyphenat, _engines;
        var syllables = [];
        var fragments = [];
        var hyphenateWord = options.hyphenationCallback || ((_engines$wordHyphenat = (_engines = engines).wordHyphenation) === null || _engines$wordHyphenat === void 0 ? void 0 : _engines$wordHyphenat.call(_engines, options)) || defaultHyphenationEngine;
        for(var i = 0; i < attributedString.runs.length; i += 1){
            var string = "";
            var run = attributedString.runs[i];
            var words = attributedString.string.slice(run.start, run.end).split(/([ ]+)/g).filter(Boolean);
            for(var j = 0; j < words.length; j += 1){
                var word = words[j];
                var parts = hyphenateWord(word);
                syllables.push.apply(syllables, parts);
                string += parts.join("");
            }
            fragments.push({
                string: string,
                attributes: run.attributes
            });
        }
        return (0, _extendsDefault.default)({}, fromFragments(fragments), {
            syllables: syllables
        });
    };
};
/**
 * Clone rect
 *
 * @param  {Object}  rect
 * @return {Object} cloned rect
 */ var copy = function copy(rect) {
    return Object.assign({}, rect);
};
var partition = function partition(rect, height) {
    var a = Object.assign({}, rect, {
        height: height
    });
    var b = Object.assign({}, rect, {
        y: rect.y + height,
        height: rect.height - height
    });
    return [
        a,
        b
    ];
};
/**
 * Crop upper section of rect
 *
 * @param  {Object}  rect
 * @return {Object} cropped rect
 */ var crop = function crop(height, rect) {
    var _partition = partition(rect, height), result = _partition[1];
    return result;
};
/**
 * Get paragraph block height
 *
 * @param  {Object}  paragraph block
 * @return {number} paragraph block height
 */ var height$2 = function height(paragraph) {
    return paragraph.reduce(function(acc, block) {
        return acc + block.box.height;
    }, 0);
};
/**
 * Calculate run scale
 *
 * @param  {Object}  run
 * @return {number} scale
 */ var calculateScale = function calculateScale(run) {
    var _attributes$font;
    var attributes = run.attributes || {};
    var fontSize = attributes.fontSize || 12;
    var unitsPerEm = (_attributes$font = attributes.font) === null || _attributes$font === void 0 ? void 0 : _attributes$font.unitsPerEm;
    return unitsPerEm ? fontSize / unitsPerEm : 0;
};
/**
 * Get run scale
 *
 * @param  {Object}  run
 * @return {number} scale
 */ var scale = function scale(run) {
    var _run$attributes;
    return ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.scale) || calculateScale(run);
};
/**
 * Get ligature offset by index
 *
 * Ex. ffi ligature
 *
 *   glyphs:         l  o  f  f  i  m
 *   glyphIndices:   0  1  2  2  2  3
 *   offset:         0  0  0  1  2  0
 *
 * @param  {number}  index
 * @param  {Object}  run
 * @return {number} ligature offset
 */ var offset = function offset(index, run) {
    if (!run) return 0;
    var glyphIndices = run.glyphIndices || [];
    var value = glyphIndices[index];
    return glyphIndices.slice(0, index).filter(function(i) {
        return i === value;
    }).length;
};
/**
 * Get run font
 *
 * @param  {Object}  run
 * @return {Object} font
 */ var getFont = function getFont(run) {
    var _run$attributes;
    return ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.font) || null;
};
/**
 * Slice glyph between codePoints range
 * Util for breaking ligatures
 *
 * @param  {number}  start code point index
 * @param  {number}  end code point index
 * @param  {Object}  font to generate new glyph
 * @param  {Object} glyph to be sliced
 * @return {Array} sliced glyph parts
 */ var slice$2 = function slice(start, end, font, glyph) {
    if (!glyph) return [];
    if (start === end) return [];
    if (start === 0 && end === glyph.codePoints.length) return [
        glyph
    ];
    var codePoints = glyph.codePoints.slice(start, end);
    var string = String.fromCodePoint.apply(String, codePoints);
    return font ? font.layout(string).glyphs : [
        glyph
    ];
};
/**
 * Return glyph index at string index, if glyph indices present.
 * Otherwise return string index
 *
 * @param  {number}  string index
 * @param  {Object}  run
 * @return {number}  glyph index
 */ var glyphIndexAt = function glyphIndexAt(index, run) {
    var _run$glyphIndices;
    var result = run === null || run === void 0 ? void 0 : (_run$glyphIndices = run.glyphIndices) === null || _run$glyphIndices === void 0 ? void 0 : _run$glyphIndices[index];
    return (0, _fns.isNil)(result) ? index : result;
};
/**
 * Returns new array starting with zero, and keeping same relation between consecutive values
 *
 * @param  {Array[number]}  list
 * @return {boolean} normalized array
 */ var normalize = function normalize(array) {
    var head = array[0];
    return array.map(function(value) {
        return value - head;
    });
};
/**
 * Slice run between glyph indices range
 *
 * @param  {number}  start glyph index
 * @param  {number}  end glyph index
 * @param  {Object}  run
 * @return {Object} sliced run
 */ var slice$1 = function slice(start, end, run) {
    var _run$glyphs, _run$glyphs2;
    var runScale = scale(run);
    var font = getFont(run);
    // Get glyph start and end indices
    var startIndex = glyphIndexAt(start, run);
    var endIndex = glyphIndexAt(end, run);
    // Get start and end glyph
    var startGlyph = (_run$glyphs = run.glyphs) === null || _run$glyphs === void 0 ? void 0 : _run$glyphs[startIndex];
    var endGlyph = (_run$glyphs2 = run.glyphs) === null || _run$glyphs2 === void 0 ? void 0 : _run$glyphs2[endIndex];
    // Get start ligature chunks (if any)
    var startOffset = offset(start, run);
    var startGlyphs = startOffset > 0 ? slice$2(startOffset, Infinity, font, startGlyph) : [];
    // Get end ligature chunks (if any)
    var endOffset = offset(end, run);
    var endGlyphs = slice$2(0, endOffset, font, endGlyph);
    // Compute new glyphs
    var sliceStart = startIndex + Math.min(1, startOffset);
    var glyphs = (run.glyphs || []).slice(sliceStart, endIndex);
    // Compute new positions
    var glyphPosition = function glyphPosition(g) {
        return {
            xAdvance: g.advanceWidth * runScale
        };
    };
    var startPositions = startGlyphs.map(glyphPosition);
    var positions = (run.positions || []).slice(sliceStart, endIndex);
    var endPositions = endGlyphs.map(glyphPosition);
    return Object.assign({}, run, {
        start: run.start + start,
        end: Math.min(run.end, run.start + end),
        glyphIndices: normalize((run.glyphIndices || []).slice(start, end)),
        glyphs: [
            startGlyphs,
            glyphs,
            endGlyphs
        ].flat(),
        positions: [
            startPositions,
            positions,
            endPositions
        ].flat()
    });
};
/**
 * Get run index that contains passed index
 *
 * @param  {number}  char index
 * @param  {Array}  runs array
 * @return {Array} run index
 */ var runIndexAt$1 = function runIndexAt(n, runs) {
    if (!runs) return -1;
    return runs.findIndex(function(run) {
        return run.start <= n && n < run.end;
    });
};
/**
 * Filter runs contained between start and end
 *
 * @param  {number}  start
 * @param  {number}  end
 * @param  {Array}  runs
 * @return {boolean} filtered runs
 */ var filter = function filter(start, end, runs) {
    var startIndex = runIndexAt$1(start, runs);
    var endIndex = Math.max(runIndexAt$1(end - 1, runs), startIndex);
    return runs.slice(startIndex, endIndex + 1);
};
/**
 * Subtract scalar to run
 *
 * @param  {number}  scalar
 * @param  {Object}  run
 * @return {Object} subtracted run
 */ var subtract = function subtract(n, run) {
    var start = run.start - n;
    var end = run.end - n;
    return Object.assign({}, run, {
        start: start,
        end: end
    });
};
/**
 * Slice array of runs
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Array}  runs
 * @return {Array} sliced runs
 */ var sliceRuns = function sliceRuns(start, end, runs) {
    var sliceFirstRun = function sliceFirstRun(a) {
        return slice$1(start - a.start, end - a.start, a);
    };
    var sliceLastRun = function sliceLastRun(a) {
        return slice$1(0, end - a.start, a);
    };
    return runs.map(function(run, i) {
        var result = run;
        var isFirst = i === 0;
        var isLast = !isFirst && i === runs.length - 1;
        if (isFirst) result = sliceFirstRun(run);
        if (isLast) result = sliceLastRun(run);
        return subtract(start, result);
    });
};
/**
 * Slice attributed string between two indices
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Object}  attributedString
 * @return {Object} attributedString
 */ var slice = function slice(start, end, attributedString) {
    if (attributedString.string.length === 0) return attributedString;
    var string = attributedString.string.slice(start, end);
    var filteredRuns = filter(start, end, attributedString.runs);
    var slicedRuns = sliceRuns(start, end, filteredRuns);
    return Object.assign({}, attributedString, {
        string: string,
        runs: slicedRuns
    });
};
var findCharIndex = function findCharIndex(string) {
    return string.search(/\S/g);
};
var findLastCharIndex = function findLastCharIndex(string) {
    var match = string.match(/\S/g);
    return match ? string.lastIndexOf(match[match.length - 1]) : -1;
};
/**
 * Removes (strips) whitespace from both ends of the attributted string.
 *
 * @param  {Object}  attributedString
 * @return {Object} attributedString
 */ var trim = function trim(attributedString) {
    var start = findCharIndex(attributedString.string);
    var end = findLastCharIndex(attributedString.string);
    return slice(start, end + 1, attributedString);
};
/**
 * Returns empty run
 *
 * @return {Object} empty run
 */ var empty$1 = function empty() {
    return {
        start: 0,
        end: 0,
        glyphIndices: [],
        glyphs: [],
        positions: [],
        attributes: {}
    };
};
var isNumber = function isNumber(value) {
    return typeof value === "number";
};
/**
 * Append glyph indices with given length
 *
 * Ex. appendIndices(3, [0, 1, 2, 2]) => [0, 1, 2, 2, 3, 3, 3]
 *
 * @param  {number}  length
 * @param  {Array}  glyph indices
 * @return {Array}  extended glyph indices
 */ var appendIndices = function appendIndices(length, indices) {
    var lastIndex = (0, _fns.last)(indices);
    var value = (0, _fns.isNil)(lastIndex) ? 0 : lastIndex + 1;
    var newIndices = Array(length).fill(value);
    return indices.concat(newIndices);
};
/**
 * Get glyph for a given code point
 *
 * @param  {number}  codePoint
 * @param  {Object}  font
 * @return {Object}  glyph
 * */ var fromCodePoint = function fromCodePoint(value, font) {
    return font && value ? font.glyphForCodePoint(value) : null;
};
/**
 * Append glyph to run
 *
 * @param  {Object}  glyph
 * @param  {Object}  run
 * @return {Object} run with glyph
 */ var appendGlyph = function appendGlyph(glyph, run) {
    var _glyph$codePoints;
    var glyphLength = ((_glyph$codePoints = glyph.codePoints) === null || _glyph$codePoints === void 0 ? void 0 : _glyph$codePoints.length) || 0;
    var end = run.end + glyphLength;
    var glyphs = run.glyphs.concat(glyph);
    var glyphIndices = appendIndices(glyphLength, run.glyphIndices);
    if (!run.positions) return Object.assign({}, run, {
        end: end,
        glyphs: glyphs,
        glyphIndices: glyphIndices
    });
    var positions = run.positions.concat({
        xAdvance: glyph.advanceWidth * scale(run)
    });
    return Object.assign({}, run, {
        end: end,
        glyphs: glyphs,
        glyphIndices: glyphIndices,
        positions: positions
    });
};
/**
 * Append glyph or code point to run
 *
 * @param  {Object | number}  glyph | codePoint
 * @param  {Object}  run
 * @return {Object} run with glyph
 */ var append$1 = function append(value, run) {
    if (!value) return run;
    var font = getFont(run);
    var glyph = isNumber(value) ? fromCodePoint(value, font) : value;
    return appendGlyph(glyph, run);
};
/**
 * Get string from array of code points
 *
 * @param {Array} code points
 * @return {String} string
 */ var stringFromCodePoints = function stringFromCodePoints(codePoints) {
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Append glyph into last run of attributed string
 *
 * @param {Object} glyph
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var append = function append(glyph, attributedString) {
    var codePoints = (glyph === null || glyph === void 0 ? void 0 : glyph.codePoints) || [];
    var codePointsString = stringFromCodePoints(codePoints);
    var string = attributedString.string + codePointsString;
    var firstRuns = attributedString.runs.slice(0, -1);
    var lastRun = (0, _fns.last)(attributedString.runs) || empty$1();
    var runs = firstRuns.concat(append$1(glyph, lastRun));
    return Object.assign({}, attributedString, {
        string: string,
        runs: runs
    });
};
var ELLIPSIS_UNICODE = 8230;
var ELLIPSIS_STRING = String.fromCharCode(ELLIPSIS_UNICODE);
/**
 * Get ellipsis codepoint. This may be different in standard and embedded fonts
 *
 * @param  {number}  font
 * @return {Object} ellipsis codepoint
 */ var getEllipsisCodePoint = function getEllipsisCodePoint(font) {
    if (!font.encode) return ELLIPSIS_UNICODE;
    var _font$encode = font.encode(ELLIPSIS_STRING), codePoints = _font$encode[0];
    return parseInt(codePoints[0], 16);
};
/**
 * Trucante block with ellipsis
 *
 * @param  {number}  lines quantity
 * @param  {Object}  paragraph block
 * @return {Object} sliced paragraph block
 */ var truncate = function truncate(block) {
    var _last, _last2, _last2$attributes;
    var runs = ((_last = (0, _fns.last)(block)) === null || _last === void 0 ? void 0 : _last.runs) || [];
    var font = (_last2 = (0, _fns.last)(runs)) === null || _last2 === void 0 ? void 0 : (_last2$attributes = _last2.attributes) === null || _last2$attributes === void 0 ? void 0 : _last2$attributes.font;
    if (font) {
        var _Object$assign;
        var index = block.length - 1;
        var codePoint = getEllipsisCodePoint(font);
        var glyph = font.glyphForCodePoint(codePoint);
        var lastBlock = append(glyph, trim(block[index]));
        return Object.assign([], block, (_Object$assign = {}, _Object$assign[index] = lastBlock, _Object$assign));
    }
    return block;
};
/**
 * Omit attribute from run
 *
 * @param  {Object}  run
 * @return {Object} run without ommited attribute
 */ var omit = function omit(value, run) {
    var attributes = Object.assign({}, run.attributes);
    delete attributes[value];
    return Object.assign({}, run, {
        attributes: attributes
    });
};
/**
 * Get run ascent
 *
 * @param  {Object}  run
 * @return {boolean} ascent
 */ var ascent$1 = function ascent(run) {
    var _run$attributes, _run$attributes$attac, _run$attributes2, _run$attributes2$font;
    var attachmentHeight = ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$attac = _run$attributes.attachment) === null || _run$attributes$attac === void 0 ? void 0 : _run$attributes$attac.height) || 0;
    var fontAscent = ((_run$attributes2 = run.attributes) === null || _run$attributes2 === void 0 ? void 0 : (_run$attributes2$font = _run$attributes2.font) === null || _run$attributes2$font === void 0 ? void 0 : _run$attributes2$font.ascent) || 0;
    return Math.max(attachmentHeight, fontAscent * scale(run));
};
/**
 * Get run descent
 *
 * @param  {Object}  run
 * @return {number} descent
 */ var descent = function descent(run) {
    var _run$attributes, _run$attributes$font;
    var fontDescent = ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$font = _run$attributes.font) === null || _run$attributes$font === void 0 ? void 0 : _run$attributes$font.descent) || 0;
    return scale(run) * fontDescent;
};
/**
 * Get run lineGap
 *
 * @param  {Object}  run
 * @return {number} lineGap
 */ var lineGap = function lineGap(run) {
    var _run$attributes, _run$attributes$font;
    return (((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$font = _run$attributes.font) === null || _run$attributes$font === void 0 ? void 0 : _run$attributes$font.lineGap) || 0) * scale(run);
};
/**
 * Get run height
 *
 * @param  {Object}  run
 * @return {number} height
 */ var height$1 = function height(run) {
    var _run$attributes;
    var lineHeight = (_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.lineHeight;
    return lineHeight || lineGap(run) + ascent$1(run) - descent(run);
};
/**
 * Returns attributed string height
 *
 * @param {Object} attributed string
 * @return {number} height
 */ var height = function height(attributeString) {
    var reducer = function reducer(acc, run) {
        return Math.max(acc, height$1(run));
    };
    return attributeString.runs.reduce(reducer, 0);
};
/**
 * Checks if two rects intersect each other
 *
 * @param {Rect} a
 * @param {Rect} b
 * @returns {Boolean} rects intersects
 */ var intersects = function intersects(a, b) {
    var x = Math.max(a.x, b.x);
    var num1 = Math.min(a.x + a.width, b.x + b.width);
    var y = Math.max(a.y, b.y);
    var num2 = Math.min(a.y + a.height, b.y + b.height);
    return num1 >= x && num2 >= y;
};
var _excluded = [
    "excludeRects"
];
var getLineFragment = function getLineFragment(lineRect, excludeRect) {
    if (!intersects(excludeRect, lineRect)) return [
        lineRect
    ];
    var eStart = excludeRect.x;
    var eEnd = excludeRect.x + excludeRect.width;
    var lStart = lineRect.x;
    var lEnd = lineRect.x + lineRect.width;
    var a = Object.assign({}, lineRect, {
        width: eStart - lStart
    });
    var b = Object.assign({}, lineRect, {
        x: eEnd,
        width: lEnd - eEnd
    });
    return [
        a,
        b
    ].filter(function(r) {
        return r.width > 0;
    });
};
var getLineFragments = function getLineFragments(rect, excludeRects) {
    var fragments = [
        rect
    ];
    var _loop = function _loop() {
        var excludeRect = excludeRects[i];
        fragments = fragments.reduce(function(acc, fragment) {
            var pieces = getLineFragment(fragment, excludeRect);
            return acc.concat(pieces);
        }, []);
    };
    for(var i = 0; i < excludeRects.length; i += 1)_loop();
    return fragments;
};
var generateLineRects = function generateLineRects(container, height) {
    var excludeRects = container.excludeRects, rect = (0, _objectWithoutPropertiesLooseDefault.default)(container, _excluded);
    if (!excludeRects) return [
        rect
    ];
    var lineRects = [];
    var maxY = Math.max.apply(Math, excludeRects.map(function(r) {
        return r.y + r.height;
    }));
    var currentRect = rect;
    while(currentRect.y < maxY){
        var _partition = partition(currentRect, height), lineRect = _partition[0], rest = _partition[1];
        var lineRectFragments = getLineFragments(lineRect, excludeRects);
        currentRect = rest;
        lineRects.push.apply(lineRects, lineRectFragments);
    }
    return [].concat(lineRects, [
        currentRect
    ]);
};
var ATTACHMENT_CODE$1 = "\uFFFC"; // 65532
/**
 * Remove attachment attribute if no char present
 *
 * @param  {Object} attributed string
 * @return {Object} attributed string
 */ var purgeAttachments = function purgeAttachments(attributedString) {
    var shouldPurge = !attributedString.string.includes(ATTACHMENT_CODE$1);
    if (!shouldPurge) return attributedString;
    var runs = attributedString.runs.map(function(run) {
        return omit("attachment", run);
    });
    return Object.assign({}, attributedString, {
        runs: runs
    });
};
/**
 * Layout paragraphs inside rectangle
 *
 * @param  {Object} rect
 * @param  {Array} attributed strings
 * @return {Object} layout blocks
 */ var layoutLines = function layoutLines(rects, lines, indent) {
    var rect = rects.shift();
    var currentY = rect.y;
    return lines.map(function(line, i) {
        var _line$runs, _line$runs$;
        var lineIndent = i === 0 ? indent : 0;
        var style = ((_line$runs = line.runs) === null || _line$runs === void 0 ? void 0 : (_line$runs$ = _line$runs[0]) === null || _line$runs$ === void 0 ? void 0 : _line$runs$.attributes) || {};
        var height$1 = Math.max(height(line), style.lineHeight);
        if (currentY + height$1 > rect.y + rect.height && rects.length > 0) {
            rect = rects.shift();
            currentY = rect.y;
        }
        var newLine = Object.assign({}, line);
        delete newLine.syllables;
        newLine.box = {
            x: rect.x + lineIndent,
            y: currentY,
            width: rect.width - lineIndent,
            height: height$1
        };
        currentY += height$1;
        return purgeAttachments(newLine);
    });
};
/**
 * Performs line breaking and layout
 *
 * @param  {Object} engines
 * @param  {Object}  layout options
 * @param  {Object} rect
 * @param  {Object} attributed string
 * @return {Object} layout block
 */ var layoutParagraph = function layoutParagraph(engines, options) {
    return function(container, paragraph) {
        var _paragraph$runs, _paragraph$runs$, _paragraph$runs$$attr;
        var height$1 = height(paragraph);
        var indent = ((_paragraph$runs = paragraph.runs) === null || _paragraph$runs === void 0 ? void 0 : (_paragraph$runs$ = _paragraph$runs[0]) === null || _paragraph$runs$ === void 0 ? void 0 : (_paragraph$runs$$attr = _paragraph$runs$.attributes) === null || _paragraph$runs$$attr === void 0 ? void 0 : _paragraph$runs$$attr.indent) || 0;
        var rects = generateLineRects(container, height$1);
        var availableWidths = rects.map(function(r) {
            return r.width;
        });
        availableWidths[0] -= indent;
        var lines = engines.linebreaker(options)(paragraph, availableWidths);
        return layoutLines(rects, lines, indent);
    };
};
/**
 * Slice block at given height
 *
 * @param  {number}  height
 * @param  {Object}  paragraph block
 * @return {number} sliced paragraph block
 */ var sliceAtHeight = function sliceAtHeight(height, block) {
    var newBlock = [];
    var counter = 0;
    for(var i = 0; i < block.length; i += 1){
        var line = block[i];
        counter += line.box.height;
        if (counter < height) newBlock.push(line);
        else break;
    }
    return newBlock;
};
/**
 * Layout paragraphs inside container until it does not
 * fit anymore, performing line wrapping in the process.
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  container rect
 * @param  {Object}  attributed strings (paragraphs)
 * @return {Array} paragraph blocks
 */ var typesetter = function typesetter(engines, options, container) {
    return function(attributedStrings) {
        var blocks = [];
        var paragraphs = [].concat(attributedStrings);
        var layoutBlock = layoutParagraph(engines, options);
        var maxLines = (0, _fns.isNil)(container.maxLines) ? Infinity : container.maxLines;
        var truncateEllipsis = container.truncateMode === "ellipsis";
        var linesCount = maxLines;
        var paragraphRect = copy(container);
        var nextParagraph = paragraphs.shift();
        while(linesCount > 0 && nextParagraph){
            var block = layoutBlock(paragraphRect, nextParagraph);
            var slicedBlock = block.slice(0, linesCount);
            var linesHeight = height$2(slicedBlock);
            var shouldTruncate = truncateEllipsis && block.length !== slicedBlock.length;
            linesCount -= slicedBlock.length;
            if (paragraphRect.height >= linesHeight) {
                blocks.push(shouldTruncate ? truncate(slicedBlock) : slicedBlock);
                paragraphRect = crop(linesHeight, paragraphRect);
                nextParagraph = paragraphs.shift();
            } else {
                blocks.push(truncate(sliceAtHeight(paragraphRect.height, slicedBlock)));
                break;
            }
        }
        return blocks;
    };
};
var DUMMY_CODEPOINT = 123;
/**
 * Resolve string indices based on glyphs code points
 *
 * @param  {Array}  glyphs
 * @return {Array} glyph indices
 */ var resolve = function resolve(glyphs) {
    if (glyphs === void 0) glyphs = [];
    return glyphs.reduce(function(acc, glyph) {
        var codePoints = (glyph === null || glyph === void 0 ? void 0 : glyph.codePoints) || [
            DUMMY_CODEPOINT
        ];
        if (acc.length === 0) return codePoints.map(function() {
            return 0;
        });
        var last = acc[acc.length - 1];
        var next = codePoints.map(function() {
            return last + 1;
        });
        return [].concat(acc, next);
    }, []);
};
var getCharacterSpacing = function getCharacterSpacing(run) {
    var _run$attributes;
    return ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.characterSpacing) || 0;
};
/**
 * Scale run positions
 *
 * @param  {Object}  run
 * @param  {Array}  positions
 * @return {Array} scaled positions
 */ var scalePositions = function scalePositions(run, positions) {
    var runScale = scale(run);
    var characterSpacing = getCharacterSpacing(run);
    return positions.map(function(position, i) {
        var isLast = i === positions.length;
        var xSpacing = isLast ? 0 : characterSpacing;
        return Object.assign({}, position, {
            xAdvance: position.xAdvance * runScale + xSpacing,
            yAdvance: position.yAdvance * runScale,
            xOffset: position.xOffset * runScale,
            yOffset: position.yOffset * runScale
        });
    });
};
/**
 * Create glyph run
 *
 * @param  {String}  string
 * @param  {Object}  run
 * @return {Object}  glyph run
 */ var layoutRun = function layoutRun(string) {
    return function(run) {
        var start = run.start, end = run.end, _run$attributes2 = run.attributes, attributes = _run$attributes2 === void 0 ? {} : _run$attributes2;
        var font = attributes.font;
        if (!font) return (0, _extendsDefault.default)({}, run, {
            glyphs: [],
            glyphIndices: [],
            positions: []
        });
        var runString = string.slice(start, end);
        var glyphRun = font.layout(runString);
        var positions = scalePositions(run, glyphRun.positions);
        var glyphIndices = resolve(glyphRun.glyphs);
        return (0, _extendsDefault.default)({}, run, {
            positions: positions,
            glyphIndices: glyphIndices,
            glyphs: glyphRun.glyphs
        });
    };
};
/**
 * Generate glyphs for single attributed string
 *
 * @param  {Object}  layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings
 * @return {Array} attributed string with glyphs
 */ var generateGlyphs = function generateGlyphs() {
    return function(attributedString) {
        var runs = attributedString.runs.map(layoutRun(attributedString.string));
        return Object.assign({}, attributedString, {
            runs: runs
        });
    };
};
/**
 * Resolves yOffset for run
 *
 * @param  {Object}  run
 * @return {Object} run
 */ var resolveRunYOffset = function resolveRunYOffset(run) {
    var _run$attributes, _run$attributes$font, _run$attributes2;
    if (!run.positions) return run;
    var unitsPerEm = ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$font = _run$attributes.font) === null || _run$attributes$font === void 0 ? void 0 : _run$attributes$font.unitsPerEm) || 0;
    var yOffset = (((_run$attributes2 = run.attributes) === null || _run$attributes2 === void 0 ? void 0 : _run$attributes2.yOffset) || 0) * unitsPerEm;
    var positions = run.positions.map(function(p) {
        return Object.assign({}, p, {
            yOffset: yOffset
        });
    });
    return Object.assign({}, run, {
        positions: positions
    });
};
/**
 * Resolves yOffset for multiple paragraphs
 *
 * @param  {Object} layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings (paragraphs)
 * @return {Array} attributed strings (paragraphs)
 */ var resolveYOffset = function resolveYOffset() {
    return function(attributedString) {
        var runs = attributedString.runs.map(resolveRunYOffset);
        return Object.assign({}, attributedString, {
            runs: runs
        });
    };
};
/**
 * Sort runs in ascending order
 *
 * @param  {Array}  runs
 * @return {Array} sorted runs
 */ var sort = function sort(runs) {
    return runs.sort(function(a, b) {
        return a.start - b.start || a.end - b.end;
    });
};
/**
 * Is run empty (start === end)
 *
 * @param  {Object}  run
 * @return {Object} is run empty
 */ var isEmpty = function isEmpty(run) {
    return run.start === run.end;
};
var sortPoints = function sortPoints(a, b) {
    return a[1] - b[1] || a[3] - b[3];
};
var generatePoints = function generatePoints(runs) {
    var result = runs.reduce(function(acc, run, i) {
        return acc.concat([
            [
                "start",
                run.start,
                run.attributes,
                i
            ],
            [
                "end",
                run.end,
                run.attributes,
                i
            ]
        ]);
    }, []);
    return result.sort(sortPoints);
};
var mergeRuns = function mergeRuns(runs) {
    return runs.reduce(function(acc, run) {
        var attributes = Object.assign({}, acc.attributes, run.attributes);
        return Object.assign({}, run, {
            attributes: attributes
        });
    }, {});
};
var groupEmptyRuns = function groupEmptyRuns(runs) {
    var groups = runs.reduce(function(acc, run) {
        if (!acc[run.start]) acc[run.start] = [];
        acc[run.start].push(run);
        return acc;
    }, {});
    return Object.values(groups);
};
var flattenEmptyRuns = function flattenEmptyRuns(runs) {
    return groupEmptyRuns(runs).map(mergeRuns);
};
var flattenRegularRuns = function flattenRegularRuns(runs) {
    var res = [];
    var points = generatePoints(runs);
    var start = -1;
    var attrs = {};
    var stack = [];
    for(var i = 0; i < points.length; i += 1){
        var _points$i = points[i], type = _points$i[0], offset = _points$i[1], attributes = _points$i[2];
        if (start !== -1 && start < offset) res.push({
            start: start,
            end: offset,
            attributes: attrs
        });
        if (type === "start") {
            stack.push(attributes);
            attrs = Object.assign({}, attrs, attributes);
        } else {
            attrs = {};
            for(var j = 0; j < stack.length; j += 1)if (stack[j] === attributes) // eslint-disable-next-line no-plusplus
            stack.splice(j--, 1);
            else attrs = Object.assign({}, attrs, stack[j]);
        }
        start = offset;
    }
    return res;
};
/**
 * Flatten many runs
 *
 * @param  {Array}  runs
 * @return {Array} flatten runs
 */ var flatten = function flatten(runs) {
    if (runs === void 0) runs = [];
    var emptyRuns = flattenEmptyRuns(runs.filter(function(run) {
        return isEmpty(run);
    }));
    var regularRuns = flattenRegularRuns(runs.filter(function(run) {
        return !isEmpty(run);
    }));
    return sort(emptyRuns.concat(regularRuns));
};
/**
 * Returns empty attributed string
 *
 * @return {Object} empty attributed string
 */ var empty = function empty() {
    return {
        string: "",
        runs: []
    };
};
var omitFont = function omitFont(attributedString) {
    var runs = attributedString.runs.map(function(run) {
        return omit("font", run);
    });
    return Object.assign({}, attributedString, {
        runs: runs
    });
};
/**
 * Performs font substitution and script itemization on attributed string
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} processed attributed string
 */ var preprocessRuns = function preprocessRuns(engines, options) {
    return function(attributedString) {
        if ((0, _fns.isNil)(attributedString)) return empty();
        var string = attributedString.string;
        var fontSubstitution = engines.fontSubstitution, scriptItemizer = engines.scriptItemizer;
        var _omitFont = omitFont(attributedString), omittedFontRuns = _omitFont.runs;
        var _fontSubstitution = fontSubstitution(options)(attributedString), substitutedRuns = _fontSubstitution.runs;
        var _scriptItemizer = scriptItemizer(options)(attributedString), itemizationRuns = _scriptItemizer.runs;
        var runs = substitutedRuns.concat(itemizationRuns).concat(omittedFontRuns);
        return {
            string: string,
            runs: flatten(runs)
        };
    };
};
/**
 * Get attributed string start value
 *
 * @param  {Object}  attributed string
 * @return {number} start
 */ var start = function start(attributedString) {
    var runs = attributedString.runs;
    return runs.length === 0 ? 0 : runs[0].start;
};
/**
 * Get attributed string end value
 *
 * @param  {Object}  attributed string
 * @return {number} end
 */ var end = function end(attributedString) {
    var runs = attributedString.runs;
    return runs.length === 0 ? 0 : (0, _fns.last)(runs).end;
};
/**
 * Get attributed string length
 *
 * @param  {Object}  glyph string
 * @return {number} end
 */ var length$1 = function length(attributedString) {
    return end(attributedString) - start(attributedString);
};
/**
 * Breaks attributed string into paragraphs
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Array} attributed string array
 */ var splitParagraphs = function splitParagraphs() {
    return function(attributedString) {
        var res = [];
        var start = 0;
        var breakPoint = attributedString.string.indexOf("\n") + 1;
        while(breakPoint > 0){
            res.push(slice(start, breakPoint, attributedString));
            start = breakPoint;
            breakPoint = attributedString.string.indexOf("\n", breakPoint) + 1;
        }
        if (start === 0) res.push(attributedString);
        else if (start < attributedString.string.length) res.push(slice(start, length$1(attributedString), attributedString));
        return res;
    };
};
/**
 * Return positions advance width
 *
 * @param  {Object}  positions
 * @return {number} advance width
 */ var advanceWidth$2 = function advanceWidth(positions) {
    return positions.reduce(function(acc, pos) {
        return acc + (pos.xAdvance || 0);
    }, 0);
};
/**
 * Return run advance width
 *
 * @param  {Object}  run
 * @return {number} advance width
 */ var advanceWidth$1 = function advanceWidth(run) {
    return advanceWidth$2(run.positions || []);
};
/**
 * Returns attributed string advancewidth
 *
 * @param {Object} attributed string
 * @return {number} advance width
 */ var advanceWidth = function advanceWidth(attributeString) {
    var reducer = function reducer(acc, run) {
        return acc + advanceWidth$1(run);
    };
    return attributeString.runs.reduce(reducer, 0);
};
var WHITE_SPACES_CODE = 32;
/**
 * Check if glyph is white space
 *
 * @param  {Object}  glyph
 * @return {Boolean}  is white space
 * */ var isWhiteSpace = function isWhiteSpace(glyph) {
    var codePoints = (glyph === null || glyph === void 0 ? void 0 : glyph.codePoints) || [];
    return codePoints.includes(WHITE_SPACES_CODE);
};
/**
 * Get white space leading positions
 *
 * @param  {Object}  run
 * @return {Array} white space leading positions
 */ var leadingPositions = function leadingPositions(run) {
    var glyphs = run.glyphs || [];
    var positions = run.positions || [];
    var leadingWhitespaces = glyphs.findIndex(function(g) {
        return !isWhiteSpace(g);
    });
    return positions.slice(0, leadingWhitespaces);
};
/**
 * Get run leading white space offset
 *
 * @param  {Object}  run
 * @return {number} leading white space offset
 */ var leadingOffset$1 = function leadingOffset(run) {
    var positions = leadingPositions(run);
    return positions.reduce(function(acc, pos) {
        return acc + (pos.xAdvance || 0);
    }, 0);
};
/**
 * Get attributed string leading white space offset
 *
 * @param  {Object}  attributed string
 * @return {number} leading white space offset
 */ var leadingOffset = function leadingOffset(attributedString) {
    var runs = attributedString.runs || [];
    return leadingOffset$1(runs[0]);
};
var reverse = function reverse(array) {
    return [].concat(array).reverse();
};
/**
 * Get white space trailing positions
 *
 * @param  {Object}  run
 * @return {Array} white space trailing positions
 */ var trailingPositions = function trailingPositions(run) {
    var glyphs = reverse(run.glyphs || []);
    var positions = reverse(run.positions || []);
    var leadingWhitespaces = glyphs.findIndex(function(g) {
        return !isWhiteSpace(g);
    });
    return positions.slice(0, leadingWhitespaces);
};
/**
 * Get run trailing white space offset
 *
 * @param  {Object}  run
 * @return {number} trailing white space offset
 */ var trailingOffset$1 = function trailingOffset(run) {
    var positions = trailingPositions(run);
    return positions.reduce(function(acc, pos) {
        return acc + (pos.xAdvance || 0);
    }, 0);
};
/**
 * Get attributed string trailing white space offset
 *
 * @param  {Object}  attributed string
 * @return {number} trailing white space offset
 */ var trailingOffset = function trailingOffset(attributedString) {
    var runs = attributedString.runs || [];
    return trailingOffset$1((0, _fns.last)(runs));
};
/**
 * Drop last char of run
 *
 * @param  {Object}  run
 * @return {boolean} run without last char
 */ var dropLast$1 = function dropLast(run) {
    return slice$1(0, run.end - run.start - 1, run);
};
/**
 * Drop last glyph
 *
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var dropLast = function dropLast(attributeString) {
    var string = (0, _fns.dropLast)(attributeString.string);
    var runs = (0, _fns.adjust)(-1, dropLast$1, attributeString.runs);
    return Object.assign({}, attributeString, {
        string: string,
        runs: runs
    });
};
var ALIGNMENT_FACTORS = {
    center: 0.5,
    right: 1
};
/**
 * Remove new line char at the end of line if present
 *
 * @param  {Object}  line
 * @return {Object} line
 */ var removeNewLine = function removeNewLine(line) {
    return (0, _fns.last)(line.string) === "\n" ? dropLast(line) : line;
};
var getOverflowLeft = function getOverflowLeft(line) {
    return leadingOffset(line) + (line.overflowLeft || 0);
};
var getOverflowRight = function getOverflowRight(line) {
    return trailingOffset(line) + (line.overflowRight || 0);
};
/**
 * Ignore whitespace at the start and end of a line for alignment
 *
 * @param  {Object}  line
 * @return {Object} line
 */ var adjustOverflow = function adjustOverflow(line) {
    var overflowLeft = getOverflowLeft(line);
    var overflowRight = getOverflowRight(line);
    var x = line.box.x - overflowLeft;
    var width = line.box.width + overflowLeft + overflowRight;
    var box = Object.assign({}, line.box, {
        x: x,
        width: width
    });
    return Object.assign({}, line, {
        box: box,
        overflowLeft: overflowLeft,
        overflowRight: overflowRight
    });
};
/**
 * Performs line justification by calling appropiate engine
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {string}  text align
 * @param  {Object}  line
 * @return {Object} line
 */ var justifyLine$1 = function justifyLine(engines, options, align) {
    return function(line) {
        var lineWidth = advanceWidth(line);
        var alignFactor = ALIGNMENT_FACTORS[align] || 0;
        var remainingWidth = Math.max(0, line.box.width - lineWidth);
        var shouldJustify = align === "justify" || lineWidth > line.box.width;
        var x = line.box.x + remainingWidth * alignFactor;
        var box = Object.assign({}, line.box, {
            x: x
        });
        var newLine = Object.assign({}, line, {
            box: box
        });
        return shouldJustify ? engines.justification(options)(newLine) : newLine;
    };
};
var finalizeLine = function finalizeLine(line) {
    var lineAscent = 0;
    var lineDescent = 0;
    var lineHeight = 0;
    var lineXAdvance = 0;
    var runs = line.runs.map(function(run) {
        var height = height$1(run);
        var ascent = ascent$1(run);
        var descent$1 = descent(run);
        var xAdvance = advanceWidth$1(run);
        lineHeight = Math.max(lineHeight, height);
        lineAscent = Math.max(lineAscent, ascent);
        lineDescent = Math.max(lineDescent, descent$1);
        lineXAdvance += xAdvance;
        return Object.assign({}, run, {
            height: height,
            ascent: ascent,
            descent: descent$1,
            xAdvance: xAdvance
        });
    });
    return Object.assign({}, line, {
        runs: runs,
        height: lineHeight,
        ascent: lineAscent,
        descent: lineDescent,
        xAdvance: lineXAdvance
    });
};
/**
 * Finalize line by performing line justification
 * and text decoration (using appropiate engines)
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  line
 * @param  {number}  line index
 * @param  {Array}  total lines
 * @return {Object} line
 */ var finalizeBlock = function finalizeBlock(engines, options) {
    if (engines === void 0) engines = {};
    return function(line, i, lines) {
        var _line$runs, _line$runs$;
        var isLastFragment = i === lines.length - 1;
        var style = ((_line$runs = line.runs) === null || _line$runs === void 0 ? void 0 : (_line$runs$ = _line$runs[0]) === null || _line$runs$ === void 0 ? void 0 : _line$runs$.attributes) || {};
        var align = isLastFragment ? style.alignLastLine : style.align;
        return (0, _fns.compose)(finalizeLine, engines.textDecoration(options), justifyLine$1(engines, options, align), adjustOverflow, removeNewLine)(line);
    };
};
/**
 * Finalize line block by performing line justification
 * and text decoration (using appropiate engines)
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Array}  line blocks
 * @return {Array} line blocks
 */ var finalizeFragments = function finalizeFragments(engines, options) {
    return function(blocks) {
        var blockFinalizer = finalizeBlock(engines, options);
        return blocks.map(function(block) {
            return block.map(blockFinalizer);
        });
    };
};
var ATTACHMENT_CODE = 0xfffc; // 65532
var isReplaceGlyph = function isReplaceGlyph(glyph) {
    return glyph.codePoints.includes(ATTACHMENT_CODE);
};
/**
 * Resolve attachments of run
 *
 * @param  {Object}  run
 * @return {Object} run
 */ var resolveRunAttachments = function resolveRunAttachments(run) {
    var _run$attributes;
    if (!run.positions) return run;
    var glyphs = run.glyphs || [];
    var attachment = ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.attachment) || {};
    var positions = run.positions.map(function(position, i) {
        var glyph = glyphs[i];
        if (attachment && attachment.width && isReplaceGlyph(glyph)) return Object.assign({}, position, {
            xAdvance: attachment.width
        });
        return Object.assign({}, position);
    });
    return Object.assign({}, run, {
        positions: positions
    });
};
/**
 * Resolve attachments for multiple paragraphs
 *
 * @param  {Object} layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings (paragraphs)
 * @return {Array} attributed strings (paragraphs)
 */ var resolveAttachments = function resolveAttachments() {
    return function(attributedString) {
        var runs = attributedString.runs.map(resolveRunAttachments);
        return Object.assign({}, attributedString, {
            runs: runs
        });
    };
};
var applyAttributes = function applyAttributes(a) {
    return {
        align: a.align || "left",
        alignLastLine: a.alignLastLine || (a.align === "justify" ? "left" : a.align || "left"),
        attachment: a.attachment || null,
        backgroundColor: a.backgroundColor || null,
        bidiLevel: a.bidiLevel || null,
        bullet: a.bullet || null,
        characterSpacing: a.characterSpacing || 0,
        color: a.color || "black",
        features: a.features || [],
        fill: a.fill !== false,
        font: a.font || null,
        fontSize: a.fontSize || 12,
        hangingPunctuation: a.hangingPunctuation || false,
        hyphenationFactor: a.hyphenationFactor || 0,
        indent: a.indent || 0,
        justificationFactor: a.justificationFactor || 1,
        lineHeight: a.lineHeight || null,
        lineSpacing: a.lineSpacing || 0,
        link: a.link || null,
        marginLeft: a.marginLeft || a.margin || 0,
        marginRight: a.marginRight || a.margin || 0,
        opacity: a.opacity,
        paddingTop: a.paddingTop || a.padding || 0,
        paragraphSpacing: a.paragraphSpacing || 0,
        underline: a.underline || false,
        underlineColor: a.underlineColor || a.color || "black",
        underlineStyle: a.underlineStyle || "solid",
        script: a.script || null,
        shrinkFactor: a.shrinkFactor || 0,
        strike: a.strike || false,
        strikeColor: a.strikeColor || a.color || "black",
        strikeStyle: a.strikeStyle || "solid",
        stroke: a.stroke || false,
        verticalAlign: a.verticalAlign || null,
        wordSpacing: a.wordSpacing || 0,
        yOffset: a.yOffset || 0
    };
};
/**
 * Apply default style to run
 *
 * @param  {Object}  run
 * @return {Object} run with styles
 */ var applyRunStyles = function applyRunStyles(run) {
    var attributes = applyAttributes(run.attributes);
    return Object.assign({}, run, {
        attributes: attributes
    });
};
/**
 * Apply default attributes for an attributed string
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string
 */ var applyDefaultStyles = function applyDefaultStyles() {
    return function(attributedString) {
        var string = attributedString.string || "";
        var runs = (attributedString.runs || []).map(applyRunStyles);
        return {
            string: string,
            runs: runs
        };
    };
};
/* eslint-disable no-restricted-syntax */ /**
 * Apply scaling and yOffset for verticalAlign 'sub' and 'super'.
 *
 * @param  {Object} layout options
 * @param  {Object} attributed string
 * @return {Object} attributed string
 */ var verticalAlignment = function verticalAlignment() {
    return function(attributedString) {
        attributedString.runs.forEach(function(run) {
            var attributes = run.attributes;
            var verticalAlign = attributes.verticalAlign;
            if (verticalAlign === "sub") attributes.yOffset = -0.2;
            else if (verticalAlign === "super") attributes.yOffset = 0.4;
        });
        return attributedString;
    };
};
/**
 * A LayoutEngine is the main object that performs text layout.
 * It accepts an AttributedString and a Container object
 * to layout text into, and uses several helper objects to perform
 * various layout tasks. These objects can be overridden to customize
 * layout behavior.
 *
 * @param  {Object}  engines
 * @param  {Object}  attributed string
 * @param  {Object}  container rect
 * @param  {Object}  layout options
 * @return {Array} paragraph blocks
 */ var layoutEngine = function layoutEngine(engines) {
    return function(attributedString, container, options) {
        if (options === void 0) options = {};
        var processParagraph = (0, _fns.compose)(resolveYOffset(), resolveAttachments(), generateGlyphs(), verticalAlignment(), wrapWords(engines, options));
        var processParagraphs = function processParagraphs(paragraphs) {
            return paragraphs.map(processParagraph);
        };
        return (0, _fns.compose)(finalizeFragments(engines, options), typesetter(engines, options, container), processParagraphs, splitParagraphs(), preprocessRuns(engines, options), applyDefaultStyles())(attributedString);
    };
};
/* eslint-disable no-plusplus */ var INFINITY = 10000;
var getNextBreakpoint = function getNextBreakpoint(subnodes, widths, lineNumber) {
    var position = null;
    var minimumBadness = Infinity;
    var sum = {
        width: 0,
        stretch: 0,
        shrink: 0
    };
    var lineLength = widths[Math.min(lineNumber, widths.length - 1)];
    var calculateRatio = function calculateRatio(node) {
        if (sum.width < lineLength) return sum.stretch - node.stretch > 0 ? (lineLength - sum.width) / sum.stretch : INFINITY;
        if (sum.width > lineLength) return sum.shrink - node.shrink > 0 ? (lineLength - sum.width) / sum.shrink : INFINITY;
        return 0;
    };
    for(var i = 0; i < subnodes.length; i += 1){
        var node = subnodes[i];
        if (node.type === "box") sum.width += node.width;
        else if (node.type === "glue") {
            sum.width += node.width;
            sum.stretch += node.stretch;
            sum.shrink += node.shrink;
        }
        if (sum.width - sum.shrink > lineLength) {
            if (position === null) {
                var j = i === 0 ? i + 1 : i;
                while(j < subnodes.length && (subnodes[j].type === "glue" || subnodes[j].type === "penalty"))j++;
                position = j - 1;
            }
            break;
        }
        if (node.type === "penalty" || node.type === "glue") {
            var ratio = calculateRatio(node);
            var penalty = node.type === "penalty" ? node.penalty : 0;
            var badness = 100 * Math.pow(Math.abs(ratio), 3) + penalty;
            if (minimumBadness >= badness) {
                position = i;
                minimumBadness = badness;
            }
        }
    }
    return sum.width - sum.shrink > lineLength ? position : null;
};
var applyBestFit = function applyBestFit(nodes, widths) {
    var count = 0;
    var lineNumber = 0;
    var subnodes = nodes;
    var breakpoints = [
        {
            position: 0
        }
    ];
    while(subnodes.length > 0){
        var breakpoint = getNextBreakpoint(subnodes, widths, lineNumber);
        if (breakpoint !== null) {
            count += breakpoint;
            breakpoints.push({
                position: count
            });
            subnodes = subnodes.slice(breakpoint + 1, subnodes.length);
            count++;
            lineNumber++;
        } else subnodes = [];
    }
    return breakpoints;
};
/* eslint-disable no-param-reassign */ /* eslint-disable max-classes-per-file */ var Node = /*#__PURE__*/ function() {
    function Node(data) {
        this.prev = null;
        this.next = null;
        this.data = data;
    }
    var _proto = Node.prototype;
    _proto.toString = function toString() {
        return this.data.toString();
    };
    return Node;
}();
var LinkedList = /*#__PURE__*/ function() {
    function LinkedList() {
        this.head = null;
        this.tail = null;
        this.listSize = 0;
    }
    var _proto2 = LinkedList.prototype;
    _proto2.isLinked = function isLinked(node) {
        return !(node && node.prev === null && node.next === null && this.tail !== node && this.head !== node || this.isEmpty());
    };
    _proto2.size = function size() {
        return this.listSize;
    };
    _proto2.isEmpty = function isEmpty() {
        return this.listSize === 0;
    };
    _proto2.first = function first() {
        return this.head;
    };
    _proto2.last = function last() {
        return this.last;
    };
    _proto2.toString = function toString() {
        return this.toArray().toString();
    };
    _proto2.toArray = function toArray() {
        var node = this.head;
        var result = [];
        while(node !== null){
            result.push(node);
            node = node.next;
        }
        return result;
    };
    _proto2.forEach = function forEach(fun) {
        var node = this.head;
        while(node !== null){
            fun(node);
            node = node.next;
        }
    };
    _proto2.contains = function contains(n) {
        var node = this.head;
        if (!this.isLinked(n)) return false;
        while(node !== null){
            if (node === n) return true;
            node = node.next;
        }
        return false;
    };
    _proto2.at = function at(i) {
        var node = this.head;
        var index = 0;
        if (i >= this.listLength || i < 0) return null;
        while(node !== null){
            if (i === index) return node;
            node = node.next;
            index += 1;
        }
        return null;
    };
    _proto2.insertAfter = function insertAfter(node, newNode) {
        if (!this.isLinked(node)) return this;
        newNode.prev = node;
        newNode.next = node.next;
        if (node.next === null) this.tail = newNode;
        else node.next.prev = newNode;
        node.next = newNode;
        this.listSize += 1;
        return this;
    };
    _proto2.insertBefore = function insertBefore(node, newNode) {
        if (!this.isLinked(node)) return this;
        newNode.prev = node.prev;
        newNode.next = node;
        if (node.prev === null) this.head = newNode;
        else node.prev.next = newNode;
        node.prev = newNode;
        this.listSize += 1;
        return this;
    };
    _proto2.push = function push(node) {
        if (this.head === null) this.unshift(node);
        else this.insertAfter(this.tail, node);
        return this;
    };
    _proto2.unshift = function unshift(node) {
        if (this.head === null) {
            this.head = node;
            this.tail = node;
            node.prev = null;
            node.next = null;
            this.listSize += 1;
        } else this.insertBefore(this.head, node);
        return this;
    };
    _proto2.remove = function remove(node) {
        if (!this.isLinked(node)) return this;
        if (node.prev === null) this.head = node.next;
        else node.prev.next = node.next;
        if (node.next === null) this.tail = node.prev;
        else node.next.prev = node.prev;
        this.listSize -= 1;
        return this;
    };
    _proto2.pop = function pop() {
        var node = this.tail;
        this.tail.prev.next = null;
        this.tail = this.tail.prev;
        this.listSize -= 1;
        node.prev = null;
        node.next = null;
        return node;
    };
    _proto2.shift = function shift() {
        var node = this.head;
        this.head.next.prev = null;
        this.head = this.head.next;
        this.listSize -= 1;
        node.prev = null;
        node.next = null;
        return node;
    };
    return LinkedList;
}();
LinkedList.Node = Node;
/* eslint-disable no-restricted-properties */ /**
 * @preserve Knuth and Plass line breaking algorithm in JavaScript
 *
 * Licensed under the new BSD License.
 * Copyright 2009-2010, Bram Stein
 * All rights reserved.
 */ var linebreak = function linebreak(nodes, lines, settings) {
    var options = {
        demerits: {
            line: settings && settings.demerits && settings.demerits.line || 10,
            flagged: settings && settings.demerits && settings.demerits.flagged || 100,
            fitness: settings && settings.demerits && settings.demerits.fitness || 3000
        },
        tolerance: settings && settings.tolerance || 3
    };
    var activeNodes = new LinkedList();
    var sum = {
        width: 0,
        stretch: 0,
        shrink: 0
    };
    var lineLengths = lines;
    var breaks = [];
    var tmp = {
        data: {
            demerits: Infinity
        }
    };
    function breakpoint(position, demerits, ratio, line, fitnessClass, totals, previous) {
        return {
            position: position,
            demerits: demerits,
            ratio: ratio,
            line: line,
            fitnessClass: fitnessClass,
            totals: totals || {
                width: 0,
                stretch: 0,
                shrink: 0
            },
            previous: previous
        };
    }
    function computeCost(start, end, active, currentLine) {
        var width = sum.width - active.totals.width;
        var stretch = 0;
        var shrink = 0;
        // If the current line index is within the list of linelengths, use it, otherwise use
        // the last line length of the list.
        var lineLength = currentLine < lineLengths.length ? lineLengths[currentLine - 1] : lineLengths[lineLengths.length - 1];
        if (nodes[end].type === "penalty") width += nodes[end].width;
        if (width < lineLength) {
            // Calculate the stretch ratio
            stretch = sum.stretch - active.totals.stretch;
            if (stretch > 0) return (lineLength - width) / stretch;
            return linebreak.infinity;
        }
        if (width > lineLength) {
            // Calculate the shrink ratio
            shrink = sum.shrink - active.totals.shrink;
            if (shrink > 0) return (lineLength - width) / shrink;
            return linebreak.infinity;
        }
        // perfect match
        return 0;
    }
    // Add width, stretch and shrink values from the current
    // break point up to the next box or forced penalty.
    function computeSum(breakPointIndex) {
        var result = {
            width: sum.width,
            stretch: sum.stretch,
            shrink: sum.shrink
        };
        for(var i = breakPointIndex; i < nodes.length; i += 1){
            if (nodes[i].type === "glue") {
                result.width += nodes[i].width;
                result.stretch += nodes[i].stretch;
                result.shrink += nodes[i].shrink;
            } else if (nodes[i].type === "box" || nodes[i].type === "penalty" && nodes[i].penalty === -linebreak.infinity && i > breakPointIndex) break;
        }
        return result;
    }
    // The main loop of the algorithm
    // eslint-disable-next-line no-shadow
    function mainLoop(node, index, nodes) {
        var active = activeNodes.first();
        var next = null;
        var ratio = 0;
        var demerits = 0;
        var candidates = [];
        var badness;
        var currentLine = 0;
        var tmpSum;
        var currentClass = 0;
        var fitnessClass;
        var candidate;
        var newNode;
        // The inner loop iterates through all the active nodes with line < currentLine and then
        // breaks out to insert the new active node candidates before looking at the next active
        // nodes for the next lines. The result of this is that the active node list is always
        // sorted by line number.
        while(active !== null){
            candidates = [
                {
                    demerits: Infinity
                },
                {
                    demerits: Infinity
                },
                {
                    demerits: Infinity
                },
                {
                    demerits: Infinity
                }
            ];
            // Iterate through the linked list of active nodes to find new potential active nodes
            // and deactivate current active nodes.
            while(active !== null){
                next = active.next;
                currentLine = active.data.line + 1;
                ratio = computeCost(active.data.position, index, active.data, currentLine);
                // Deactive nodes when the distance between the current active node and the
                // current node becomes too large (i.e. it exceeds the stretch limit and the stretch
                // ratio becomes negative) or when the current node is a forced break (i.e. the end
                // of the paragraph when we want to remove all active nodes, but possibly have a final
                // candidate active node---if the paragraph can be set using the given tolerance value.)
                if (ratio < -1 || node.type === "penalty" && node.penalty === -linebreak.infinity) activeNodes.remove(active);
                // If the ratio is within the valid range of -1 <= ratio <= tolerance calculate the
                // total demerits and record a candidate active node.
                if (ratio >= -1 && ratio <= options.tolerance) {
                    badness = 100 * Math.pow(Math.abs(ratio), 3);
                    // Positive penalty
                    if (node.type === "penalty" && node.penalty >= 0) demerits = Math.pow(options.demerits.line + badness, 2) + Math.pow(node.penalty, 2);
                    else if (node.type === "penalty" && node.penalty !== -linebreak.infinity) demerits = Math.pow(options.demerits.line + badness, 2) - Math.pow(node.penalty, 2);
                    else demerits = Math.pow(options.demerits.line + badness, 2);
                    if (node.type === "penalty" && nodes[active.data.position].type === "penalty") demerits += options.demerits.flagged * node.flagged * nodes[active.data.position].flagged;
                    // Calculate the fitness class for this candidate active node.
                    if (ratio < -0.5) currentClass = 0;
                    else if (ratio <= 0.5) currentClass = 1;
                    else if (ratio <= 1) currentClass = 2;
                    else currentClass = 3;
                    // Add a fitness penalty to the demerits if the fitness classes of two adjacent lines
                    // differ too much.
                    if (Math.abs(currentClass - active.data.fitnessClass) > 1) demerits += options.demerits.fitness;
                    // Add the total demerits of the active node to get the total demerits of this candidate node.
                    demerits += active.data.demerits;
                    // Only store the best candidate for each fitness class
                    if (demerits < candidates[currentClass].demerits) candidates[currentClass] = {
                        active: active,
                        demerits: demerits,
                        ratio: ratio
                    };
                }
                active = next;
                // Stop iterating through active nodes to insert new candidate active nodes in the active list
                // before moving on to the active nodes for the next line.
                // TODO: The Knuth and Plass paper suggests a conditional for currentLine < j0. This means paragraphs
                // with identical line lengths will not be sorted by line number. Find out if that is a desirable outcome.
                // For now I left this out, as it only adds minimal overhead to the algorithm and keeping the active node
                // list sorted has a higher priority.
                if (active !== null && active.data.line >= currentLine) break;
            }
            tmpSum = computeSum(index);
            for(fitnessClass = 0; fitnessClass < candidates.length; fitnessClass += 1){
                candidate = candidates[fitnessClass];
                if (candidate.demerits < Infinity) {
                    newNode = new LinkedList.Node(breakpoint(index, candidate.demerits, candidate.ratio, candidate.active.data.line + 1, fitnessClass, tmpSum, candidate.active));
                    if (active !== null) activeNodes.insertBefore(active, newNode);
                    else activeNodes.push(newNode);
                }
            }
        }
    }
    // Add an active node for the start of the paragraph.
    activeNodes.push(new LinkedList.Node(breakpoint(0, 0, 0, 0, 0, undefined, null)));
    // eslint-disable-next-line no-shadow
    nodes.forEach(function(node, index, nodes) {
        if (node.type === "box") sum.width += node.width;
        else if (node.type === "glue") {
            if (index > 0 && nodes[index - 1].type === "box") mainLoop(node, index, nodes);
            sum.width += node.width;
            sum.stretch += node.stretch;
            sum.shrink += node.shrink;
        } else if (node.type === "penalty" && node.penalty !== linebreak.infinity) mainLoop(node, index, nodes);
    });
    if (activeNodes.size() !== 0) {
        // Find the best active node (the one with the least total demerits.)
        activeNodes.forEach(function(node) {
            if (node.data.demerits < tmp.data.demerits) tmp = node;
        });
        while(tmp !== null){
            breaks.push({
                position: tmp.data.position,
                ratio: tmp.data.ratio
            });
            tmp = tmp.data.previous;
        }
        return breaks.reverse();
    }
    return [];
};
linebreak.infinity = 10000;
linebreak.glue = function(width, value, stretch, shrink) {
    return {
        type: "glue",
        value: value,
        width: width,
        stretch: stretch,
        shrink: shrink
    };
};
linebreak.box = function(width, value, hyphenated) {
    if (hyphenated === void 0) hyphenated = false;
    return {
        type: "box",
        width: width,
        value: value,
        hyphenated: hyphenated
    };
};
linebreak.penalty = function(width, penalty, flagged) {
    return {
        type: "penalty",
        width: width,
        penalty: penalty,
        flagged: flagged
    };
};
/**
 * Add scalar to run
 *
 * @param  {number}  scalar
 * @param  {Object}  run
 * @return {Object} added run
 */ var add = function add(n, run) {
    var start = run.start + n;
    var end = run.end + n;
    return Object.assign({}, run, {
        start: start,
        end: end
    });
};
/**
 * Get run length
 *
 * @param  {Object}  run
 * @return {number} length
 */ var length = function length(run) {
    return run.end - run.start;
};
/**
 * Concats two runs into one
 *
 * @param  {Object}  first run
 * @param  {Object}  second run
 * @return {Object}  concatenated run
 */ var concat = function concat(runA, runB) {
    var end = runA.end + length(runB);
    var glyphs = (runA.glyphs || []).concat(runB.glyphs || []);
    var positions = (runA.positions || []).concat(runB.positions || []);
    var attributes = Object.assign({}, runA.attributes, runB.attributes);
    var runAIndices = runA.glyphIndices || [];
    var runALastIndex = (0, _fns.last)(runAIndices) || 0;
    var runBIndices = (runB.glyphIndices || []).map(function(i) {
        return i + runALastIndex + 1;
    });
    var glyphIndices = normalize(runAIndices.concat(runBIndices));
    return Object.assign({}, runA, {
        end: end,
        glyphs: glyphs,
        positions: positions,
        attributes: attributes,
        glyphIndices: glyphIndices
    });
};
/**
 * Insert glyph to run in the given index
 *
 * @param  {number}  string index
 * @param  {Object}  glyph
 * @param  {Object}  run
 * @return {Object}  run with glyph
 */ var insertGlyph$1 = function insertGlyph(index, glyph, run) {
    if (!glyph) return run;
    // Split resolves ligature splitting in case new glyph breaks some
    var leadingRun = slice$1(0, index, run);
    var trailingRun = slice$1(index, Infinity, run);
    return concat(append$1(glyph, leadingRun), trailingRun);
};
/**
 * Insert either glyph or code point to run in the given index
 *
 * @param  {number}  string index
 * @param  {Object | number}  glyph | codePoint
 * @param  {Object}  run
 * @return {Object}  run with glyph
 */ var insert = function insert(index, value, run) {
    var font = getFont(run);
    var glyph = isNumber(value) ? fromCodePoint(value, font) : value;
    return insertGlyph$1(index, glyph, run);
};
/**
 * Get run index at char index
 *
 * @param  {number}  char index
 * @param  {Object}  attributedString
 * @return {number} run index
 */ var runIndexAt = function runIndexAt(n, string) {
    return runIndexAt$1(n, string.runs);
};
/**
 * Insert glyph into attributed string
 *
 * @param {number} index
 * @param {Object} glyph
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var insertGlyph = function insertGlyph(index, glyph, attributedString) {
    var runIndex = runIndexAt(index, attributedString);
    // Add glyph to the end if run index invalid
    if (runIndex === -1) return append(glyph, attributedString);
    var codePoints = (glyph === null || glyph === void 0 ? void 0 : glyph.codePoints) || [];
    var string = attributedString.string.slice(0, index) + stringFromCodePoints(codePoints) + attributedString.string.slice(index);
    var runs = attributedString.runs.map(function(run, i) {
        if (i === runIndex) return insert(index - run.start, glyph, run);
        if (i > runIndex) return add(codePoints.length, run);
        return run;
    });
    return Object.assign({}, attributedString, {
        string: string,
        runs: runs
    });
};
/**
 * Advance width between two string indices
 *
 * @param  {number}  start glyph index
 * @param  {number}  end glyph index
 * @param  {Object}  run
 * @return {Object} advanced width run
 */ var advanceWidthBetween$1 = function advanceWidthBetween(start, end, run) {
    var runStart = run.start || 0;
    var glyphStartIndex = Math.max(0, glyphIndexAt(start - runStart, run));
    var glyphEndIndex = Math.max(0, glyphIndexAt(end - runStart, run));
    var positions = (run.positions || []).slice(glyphStartIndex, glyphEndIndex);
    return advanceWidth$2(positions);
};
/**
 * Advance width between start and end
 * Does not consider ligature splitting for the moment.
 * Check performance impact on supporting this
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Object}  attributedString
 * @return {number} advance width
 */ var advanceWidthBetween = function advanceWidthBetween(start, end, attributedString) {
    var runs = filter(start, end, attributedString.runs);
    return runs.reduce(function(acc, run) {
        return acc + advanceWidthBetween$1(start, end, run);
    }, 0);
};
var HYPHEN = 0x002d;
var TOLERANCE_STEPS = 5;
var TOLERANCE_LIMIT = 50;
var opts = {
    width: 3,
    stretch: 6,
    shrink: 9
};
/**
 * Slice attributed string to many lines
 *
 * @param {Object} attributed string
 * @param  {Array}  nodes
 * @param  {Array}  breaks
 * @return {Array} attributed strings
 */ var breakLines = function breakLines(string, nodes, breaks) {
    var start = 0;
    var end = null;
    var lines = breaks.reduce(function(acc, breakPoint) {
        var node = nodes[breakPoint.position];
        var prevNode = nodes[breakPoint.position - 1];
        // Last breakpoint corresponds to K&P mandatory final glue
        if (breakPoint.position === nodes.length - 1) return acc;
        var line;
        if (node.type === "penalty") {
            end = prevNode.value.end;
            line = slice(start, end, string);
            line = insertGlyph(line.length, HYPHEN, line);
        } else {
            end = node.value.end;
            line = slice(start, end, string);
        }
        start = end;
        return [].concat(acc, [
            line
        ]);
    }, []);
    // Last line
    lines.push(slice(start, string.string.length, string));
    return lines;
};
/**
 * Return Knuth & Plass nodes based on line and previously calculated syllables
 *
 * @param {Object} attributed string
 * @param  {Object}  attributed string
 * @param  {Object}  layout options
 * @return {Array} attributed strings
 */ var getNodes = function getNodes(attributedString, _ref, options) {
    var align = _ref.align;
    var start = 0;
    var hyphenWidth = 5;
    var syllables = attributedString.syllables;
    var hyphenPenalty = options.hyphenationPenalty || (align === "justify" ? 100 : 600);
    var result = syllables.reduce(function(acc, s, index) {
        var width = advanceWidthBetween(start, start + s.length, attributedString);
        if (s.trim() === "") {
            var stretch = width * opts.width / opts.stretch;
            var shrink = width * opts.width / opts.shrink;
            var value = {
                start: start,
                end: start + s.length
            };
            acc.push(linebreak.glue(width, value, stretch, shrink));
        } else {
            var hyphenated = syllables[index + 1] !== " ";
            var _value = {
                start: start,
                end: start + s.length
            };
            acc.push(linebreak.box(width, _value, hyphenated));
            if (syllables[index + 1] && hyphenated) acc.push(linebreak.penalty(hyphenWidth, hyphenPenalty, 1));
        }
        start += s.length;
        return acc;
    }, []);
    result.push(linebreak.glue(0, null, linebreak.infinity, 0));
    result.push(linebreak.penalty(0, -linebreak.infinity, 1));
    return result;
};
var getStyles = function getStyles(attributedString) {
    var _attributedString$run, _attributedString$run2;
    return ((_attributedString$run = attributedString.runs) === null || _attributedString$run === void 0 ? void 0 : (_attributedString$run2 = _attributedString$run[0]) === null || _attributedString$run2 === void 0 ? void 0 : _attributedString$run2.attributes) || {};
};
/**
 * Performs Knuth & Plass line breaking algorithm
 * Fallbacks to best fit algorithm if latter not successful
 *
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @param {Object} attributed string
 * @return {Array} attributed strings
 */ var linebreaker = function linebreaker(options) {
    return function(attributedString, availableWidths) {
        var tolerance = options.tolerance || 4;
        var style = getStyles(attributedString);
        var nodes = getNodes(attributedString, style, options);
        var breaks = linebreak(nodes, availableWidths, {
            tolerance: tolerance
        });
        // Try again with a higher tolerance if the line breaking failed.
        while(breaks.length === 0 && tolerance < TOLERANCE_LIMIT){
            tolerance += TOLERANCE_STEPS;
            breaks = linebreak(nodes, availableWidths, {
                tolerance: tolerance
            });
        }
        if (breaks.length === 0 || breaks.length === 1 && breaks[0].position === 0) breaks = applyBestFit(nodes, availableWidths);
        return breakLines(attributedString, nodes, breaks.slice(1));
    };
};
var WHITESPACE_PRIORITY = 1;
var LETTER_PRIORITY = 2;
var EXPAND_WHITESPACE_FACTOR = {
    before: 0.5,
    after: 0.5,
    priority: WHITESPACE_PRIORITY,
    unconstrained: false
};
var EXPAND_CHAR_FACTOR = {
    before: 0.14453125,
    // 37/256
    after: 0.14453125,
    priority: LETTER_PRIORITY,
    unconstrained: false
};
var SHRINK_WHITESPACE_FACTOR = {
    before: -0.04296875,
    // -11/256
    after: -0.04296875,
    priority: WHITESPACE_PRIORITY,
    unconstrained: false
};
var SHRINK_CHAR_FACTOR = {
    before: -0.04296875,
    after: -0.04296875,
    priority: LETTER_PRIORITY,
    unconstrained: false
};
var getCharFactor = function getCharFactor(direction, options) {
    var expandCharFactor = options.expandCharFactor || {};
    var shrinkCharFactor = options.shrinkCharFactor || {};
    return direction === "GROW" ? Object.assign({}, EXPAND_CHAR_FACTOR, expandCharFactor) : Object.assign({}, SHRINK_CHAR_FACTOR, shrinkCharFactor);
};
var getWhitespaceFactor = function getWhitespaceFactor(direction, options) {
    var expandWhitespaceFactor = options.expandWhitespaceFactor || {};
    var shrinkWhitespaceFactor = options.shrinkWhitespaceFactor || {};
    return direction === "GROW" ? Object.assign({}, EXPAND_WHITESPACE_FACTOR, expandWhitespaceFactor) : Object.assign({}, SHRINK_WHITESPACE_FACTOR, shrinkWhitespaceFactor);
};
var factor = function factor(direction, options) {
    return function(glyphs) {
        var charFactor = getCharFactor(direction, options);
        var whitespaceFactor = getWhitespaceFactor(direction, options);
        var factors = [];
        for(var index = 0; index < glyphs.length; index += 1){
            var f = void 0;
            var glyph = glyphs[index];
            if (isWhiteSpace(glyph)) {
                f = Object.assign({}, whitespaceFactor);
                if (index === glyphs.length - 1) {
                    f.before = 0;
                    if (index > 0) factors[index - 1].after = 0;
                }
            } else if (glyph.isMark && index > 0) {
                f = Object.assign({}, factors[index - 1]);
                f.before = 0;
                factors[index - 1].after = 0;
            } else f = Object.assign({}, charFactor);
            factors.push(f);
        }
        return factors;
    };
};
var getFactors = function getFactors(gap, line, options) {
    var direction = gap > 0 ? "GROW" : "SHRINK";
    var getFactor = factor(direction, options);
    var factors = line.runs.reduce(function(acc, run) {
        return acc.concat(getFactor(run.glyphs));
    }, []);
    factors[0].before = 0;
    factors[factors.length - 1].after = 0;
    return factors;
};
/* eslint-disable no-multi-assign */ var KASHIDA_PRIORITY = 0;
var NULL_PRIORITY = 3;
var getDistances = function getDistances(gap, factors) {
    var total = 0;
    var priorities = [];
    var unconstrained = [];
    for(var _priority = KASHIDA_PRIORITY; _priority <= NULL_PRIORITY; _priority += 1)priorities[_priority] = unconstrained[_priority] = 0;
    // sum the factors at each priority
    for(var j = 0; j < factors.length; j += 1){
        var f = factors[j];
        var sum = f.before + f.after;
        total += sum;
        priorities[f.priority] += sum;
        if (f.unconstrained) unconstrained[f.priority] += sum;
    }
    // choose the priorities that need to be applied
    var highestPriority = -1;
    var highestPrioritySum = 0;
    var remainingGap = gap;
    var priority;
    for(priority = KASHIDA_PRIORITY; priority <= NULL_PRIORITY; priority += 1){
        var prioritySum = priorities[priority];
        if (prioritySum !== 0) {
            if (highestPriority === -1) {
                highestPriority = priority;
                highestPrioritySum = prioritySum;
            }
            // if this priority covers the remaining gap, we're done
            if (Math.abs(remainingGap) <= Math.abs(prioritySum)) {
                priorities[priority] = remainingGap / prioritySum;
                unconstrained[priority] = 0;
                remainingGap = 0;
                break;
            }
            // mark that we need to use 100% of the adjustment from
            // this priority, and subtract the space that it consumes
            priorities[priority] = 1;
            remainingGap -= prioritySum;
            // if this priority has unconstrained glyphs, let them consume the remaining space
            if (unconstrained[priority] !== 0) {
                unconstrained[priority] = remainingGap / unconstrained[priority];
                remainingGap = 0;
                break;
            }
        }
    }
    // zero out remaining priorities (if any)
    for(var p = priority + 1; p <= NULL_PRIORITY; p += 1){
        priorities[p] = 0;
        unconstrained[p] = 0;
    }
    // if there is still space left over, assign it to the highest priority that we saw.
    // this violates their factors, but it only happens in extreme cases
    if (remainingGap > 0 && highestPriority > -1) priorities[highestPriority] = (highestPrioritySum + (gap - total)) / highestPrioritySum;
    // create and return an array of distances to add to each glyph's advance
    var distances = [];
    for(var index = 0; index < factors.length; index += 1){
        // the distance to add to this glyph is the sum of the space to add
        // after this glyph, and the space to add before the next glyph
        var _f = factors[index];
        var next = factors[index + 1];
        var dist = _f.after * priorities[_f.priority];
        if (next) dist += next.before * priorities[next.priority];
        // if this glyph is unconstrained, add the unconstrained distance as well
        if (_f.unconstrained) {
            dist += _f.after * unconstrained[_f.priority];
            if (next) dist += next.before * unconstrained[next.priority];
        }
        distances.push(dist);
    }
    return distances;
};
/**
 * Adjust run positions by given distances
 *
 * @param {Array} distances
 * @param {Object} line
 * @returns {Object} line
 */ var justifyLine = function justifyLine(distances, line) {
    var index = 0;
    for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(line.runs), _step; !(_step = _iterator()).done;){
        var run = _step.value;
        for(var _iterator2 = (0, _createForOfIteratorHelperLooseDefault.default)(run.positions), _step2; !(_step2 = _iterator2()).done;){
            var position = _step2.value;
            position.xAdvance += distances[index++];
        }
    }
    return line;
};
/**
 * A JustificationEngine is used by a Typesetter to perform line fragment
 * justification. This implementation is based on a description of Apple's
 * justification algorithm from a PDF in the Apple Font Tools package.
 *
 * //TODO: Make it immutable
 *
 * @param {Object} layout options
 * @param {Object} line
 * @returns {Object} line
 */ var justification = function justification(options) {
    return function(line) {
        var gap = line.box.width - advanceWidth(line);
        if (gap === 0) return; // Exact fit
        var factors = getFactors(gap, line, options);
        var distances = getDistances(gap, factors);
        return justifyLine(distances, line);
    };
};
/**
 * Returns attributed string ascent
 *
 * @param {Object} attributed string
 * @return {number} ascent
 */ var ascent = function ascent(attributeString) {
    var reducer = function reducer(acc, run) {
        return Math.max(acc, ascent$1(run));
    };
    return attributeString.runs.reduce(reducer, 0);
};
/* eslint-disable no-param-reassign */ // The base font size used for calculating underline thickness.
var BASE_FONT_SIZE = 12;
/**
 * A TextDecorationEngine is used by a Typesetter to generate
 * DecorationLines for a line fragment, including underlines
 * and strikes.
 */ var textDecoration = function textDecoration() {
    return function(lineFragment) {
        var x = lineFragment.overflowLeft || 0;
        var overflowRight = lineFragment.overflowRight || 0;
        var maxX = advanceWidth(lineFragment) - overflowRight;
        lineFragment.decorationLines = [];
        for(var i = 0; i < lineFragment.runs.length; i += 1){
            var run = lineFragment.runs[i];
            var width = Math.min(maxX - x, advanceWidth$1(run));
            var thickness = Math.max(0.5, Math.floor(run.attributes.fontSize / BASE_FONT_SIZE));
            if (run.attributes.underline) {
                var rect = {
                    x: x,
                    y: ascent(lineFragment) + thickness * 2,
                    width: width,
                    height: thickness
                };
                var line = {
                    rect: rect,
                    opacity: run.attributes.opacity,
                    color: run.attributes.underlineColor || "black",
                    style: run.attributes.underlineStyle || "solid"
                };
                lineFragment.decorationLines.push(line);
            }
            if (run.attributes.strike) {
                var y = ascent(lineFragment) - ascent$1(run) / 3;
                var _rect = {
                    x: x,
                    y: y,
                    width: width,
                    height: thickness
                };
                var _line = {
                    rect: _rect,
                    opacity: run.attributes.opacity,
                    color: run.attributes.strikeColor || "black",
                    style: run.attributes.strikeStyle || "solid"
                };
                lineFragment.decorationLines.push(_line);
            }
            x += width;
        }
        return lineFragment;
    };
};
var ignoredScripts = [
    "Common",
    "Inherited",
    "Unknown"
];
/**
 * Resolves unicode script in runs, grouping equal runs together
 *
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string
 */ var scriptItemizer = function scriptItemizer() {
    return function(attributedString) {
        var string = attributedString.string;
        var lastScript = "Unknown";
        var lastIndex = 0;
        var index = 0;
        var res = [];
        if (!string) return empty();
        for(var i = 0; i < string.length; i += 1){
            var char = string[i];
            var codePoint = char.codePointAt();
            var script = (0, _unicodePropertiesDefault.default).getScript(codePoint);
            if (script !== lastScript && !ignoredScripts.includes(script)) {
                if (lastScript !== "Unknown") res.push({
                    start: lastIndex,
                    end: index,
                    attributes: {
                        script: lastScript
                    }
                });
                lastIndex = index;
                lastScript = script;
            }
            index += char.length;
        }
        if (lastIndex < string.length) res.push({
            start: lastIndex,
            end: string.length,
            attributes: {
                script: lastScript
            }
        });
        return {
            string: string,
            runs: res
        };
    };
};
var SOFT_HYPHEN = "\xad";
var hyphenator = (0, _hyphenDefault.default)((0, _enUsDefault.default));
var splitHyphen = function splitHyphen(word) {
    return word.split(SOFT_HYPHEN);
};
var cache = {};
var getParts = function getParts(word) {
    var base = word.includes(SOFT_HYPHEN) ? word : hyphenator(word);
    return splitHyphen(base);
};
var wordHyphenation = function wordHyphenation() {
    return function(word) {
        var cacheKey = "_" + word;
        if ((0, _fns.isNil)(word)) return [];
        if (cache[cacheKey]) return cache[cacheKey];
        cache[cacheKey] = getParts(word);
        return cache[cacheKey];
    };
};
var getFontSize = function getFontSize(value) {
    return value.attributes.fontSize || 12;
};
/**
 * Resolve font runs in an AttributedString, grouping equal
 * runs and performing font substitution where necessary.
 *
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string
 */ var fontSubstitution = function fontSubstitution() {
    return function(attributedString) {
        var string = attributedString.string, runs = attributedString.runs;
        var lastFont = null;
        var lastIndex = 0;
        var index = 0;
        var res = [];
        if (!string) return empty();
        for(var _iterator = (0, _createForOfIteratorHelperLooseDefault.default)(runs), _step; !(_step = _iterator()).done;){
            var run = _step.value;
            var _fontSize = getFontSize(run);
            var defaultFont = run.attributes.font;
            if (string.length === 0) {
                res.push({
                    start: 0,
                    end: 0,
                    attributes: {
                        font: defaultFont
                    }
                });
                break;
            }
            for(var _iterator2 = (0, _createForOfIteratorHelperLooseDefault.default)(string.slice(run.start, run.end)), _step2; !(_step2 = _iterator2()).done;){
                var char = _step2.value;
                var font = defaultFont;
                if (font !== lastFont) {
                    if (lastFont) res.push({
                        start: lastIndex,
                        end: index,
                        attributes: {
                            font: lastFont,
                            scale: lastFont ? _fontSize / lastFont.unitsPerEm : 0
                        }
                    });
                    lastFont = font;
                    lastIndex = index;
                }
                index += char.length;
            }
        }
        if (lastIndex < string.length) {
            var fontSize = getFontSize((0, _fns.last)(runs));
            res.push({
                start: lastIndex,
                end: string.length,
                attributes: {
                    font: lastFont,
                    scale: lastFont ? fontSize / lastFont.unitsPerEm : 0
                }
            });
        }
        return {
            string: string,
            runs: res
        };
    };
};

},{"@react-pdf/fns":"9CfuB","@babel/runtime/helpers/extends":"jbPGs","@babel/runtime/helpers/objectWithoutPropertiesLoose":"jR58g","@babel/runtime/helpers/createForOfIteratorHelperLoose":"2Q0sa","unicode-properties":"cF1iU","hyphen":"h3fII","hyphen/patterns/en-us":"d2UoR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h3fII":[function(require,module,exports) {
module.exports = require("8b4291662007c213");

},{"8b4291662007c213":"1cEPp"}],"1cEPp":[function(require,module,exports) {
var global = arguments[3];
/** Text hyphenation in Javascript.
 *  Copyright (C) 2021 Yevhen Tiurin (yevhentiurin@gmail.com)
 *  https://github.com/ytiurin/hyphen
 *
 *  Released under the ISC license
 *  https://github.com/ytiurin/hyphen/blob/master/LICENSE
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.createHyphenator = factory();
})(this, function() {
    var SETTING_DEFAULT_ASYNC = false, SETTING_DEFAULT_DEBUG = false, SETTING_DEFAULT_HTML = false, SETTING_DEFAULT_HYPH_CHAR = "\xad", SETTING_DEFAULT_MIN_WORD_LENGTH = 5, SETTING_NAME_ASYNC = "async", SETTING_NAME_DEBUG = "debug", SETTING_NAME_HTML = "html", SETTING_NAME_HYPH_CHAR = "hyphenChar", SETTING_NAME_MIN_WORD_LENGTH = "minWordLength";
    var _global = typeof global === "object" ? global : typeof window === "object" ? window : typeof this === "object" ? this : {};
    function cloneObj(source) {
        var target = {};
        for(var key in source)target[key] = source[key];
        return target;
    }
    function keyOrDefault(object, key, defaultValue) {
        if (key in object) return object[key];
        return defaultValue;
    }
    function exceptionsFromDefinition(patternsDefinition, hyphenChar) {
        return patternsDefinition.exceptions.reduce(function(exceptions, exception) {
            exceptions[exception.replace(/\-/g, "")] = exception.replace(/\-/g, hyphenChar);
            return exceptions;
        }, {});
    }
    function createHyphenator(patternsDefinition, options) {
        options = options || {};
        var asyncMode = keyOrDefault(options, SETTING_NAME_ASYNC, SETTING_DEFAULT_ASYNC), caches = {}, debug = keyOrDefault(options, SETTING_NAME_DEBUG, SETTING_DEFAULT_DEBUG), exceptions = {}, hyphenChar = keyOrDefault(options, SETTING_NAME_HYPH_CHAR, SETTING_DEFAULT_HYPH_CHAR), patterns = patternsDefinition.patterns.map(preprocessPattern), minWordLength = keyOrDefault(options, SETTING_NAME_MIN_WORD_LENGTH, SETTING_DEFAULT_MIN_WORD_LENGTH) >> 0, skipHTML = keyOrDefault(options, SETTING_NAME_HTML, SETTING_DEFAULT_HTML);
        // Prepare cache
        var cacheKey = hyphenChar + minWordLength;
        exceptions[cacheKey] = exceptionsFromDefinition(patternsDefinition, hyphenChar);
        caches[cacheKey] = cloneObj(exceptions[cacheKey]);
        if (asyncMode && !("Promise" in _global)) throw new Error("Failed to create hyphenator: Could not find global Promise object, needed for hyphenator to work in async mode");
        return function(text, options) {
            options = options || {};
            var localDebug = keyOrDefault(options, SETTING_NAME_DEBUG, debug), localHyphenChar = keyOrDefault(options, SETTING_NAME_HYPH_CHAR, hyphenChar), localMinWordLength = keyOrDefault(options, SETTING_NAME_MIN_WORD_LENGTH, minWordLength) >> 0, cacheKey = localHyphenChar + localMinWordLength;
            if (!exceptions[cacheKey]) exceptions[cacheKey] = exceptionsFromDefinition(patternsDefinition, localHyphenChar);
            if (!caches[cacheKey]) caches[cacheKey] = cloneObj(exceptions[cacheKey]);
            return start(text, patterns, caches[cacheKey], localDebug, localHyphenChar, skipHTML, localMinWordLength, asyncMode);
        };
    }
    function createTextChunkReader(text, hyphenChar, skipHTML, minWordLength) {
        function readNextTextChunk() {
            var nextTextChunk = "";
            shouldHyphenate = void 0;
            chunkReader: while(nextCharIndex <= text.length){
                var nextChar = text.charAt(nextCharIndex++), charIsLetter = !!nextChar && !/\s|[\!-\@\[-\`\{-\~\u2013-\u203C]/.test(nextChar), charIsAngleOpen = nextChar === "<", charIsAngleClose = nextChar === ">", charIsHyphen = nextChar === hyphenChar;
                do {
                    if (state === STATE_READ_TAG) {
                        if (charIsAngleClose) state = STATE_RETURN_UNTOUCHED;
                        break;
                    }
                    if (charIsHyphen) {
                        shouldHyphenate = SHOULD_SKIP;
                        state = STATE_READ_WORD;
                        break;
                    }
                    if (charIsLetter) {
                        state = STATE_READ_WORD;
                        break;
                    }
                    if (state === STATE_READ_WORD) {
                        state = STATE_RETURN_WORD;
                        shouldHyphenate = shouldHyphenate || nextTextChunk.length >= minWordLength && SHOULD_HYPHENATE;
                        break;
                    }
                    shouldHyphenate = SHOULD_SKIP;
                    state = STATE_RETURN_UNTOUCHED;
                }while (0);
                if (charIsAngleOpen && state !== STATE_RETURN_WORD && skipHTML && !isSpacelike(text.charAt(nextCharIndex))) {
                    shouldHyphenate = SHOULD_SKIP;
                    state = STATE_READ_TAG;
                }
                switch(state){
                    case STATE_READ_TAG:
                        nextTextChunk += nextChar;
                        break;
                    case STATE_READ_WORD:
                        nextTextChunk += nextChar;
                        break;
                    case STATE_RETURN_UNTOUCHED:
                        nextTextChunk += nextChar;
                        break chunkReader;
                    case STATE_RETURN_WORD:
                        nextCharIndex--;
                        break chunkReader;
                }
            }
            return nextTextChunk || void 0;
        }
        function shouldNextHyphenate() {
            return shouldHyphenate === SHOULD_HYPHENATE;
        }
        var isSpacelike = RegExp.prototype.test.bind(/\s/);
        var nextCharIndex = 0, SHOULD_HYPHENATE = 1, SHOULD_SKIP = 2, shouldHyphenate, STATE_READ_TAG = 1, STATE_READ_WORD = 2, STATE_RETURN_UNTOUCHED = 3, STATE_RETURN_WORD = 4, state;
        return [
            readNextTextChunk,
            shouldNextHyphenate
        ];
    }
    function hyphenateWord(text, patterns, debug, hyphenChar) {
        var levels = new Array(text.length + 1), loweredText = text.toLocaleLowerCase(), p = [], patternData, patternIndex = 0;
        for(var i = levels.length; i--;)levels[i] = 0;
        while(patternData = patterns[patternIndex++]){
            var fromChar = 0, endPattern = false;
            while(!endPattern){
                var patternEntityIndex = loweredText.indexOf(patternData.text, fromChar), patternFits = patternEntityIndex > -1 && (patternData.stickToLeft ? patternEntityIndex === 0 : true) && (patternData.stickToRight ? patternEntityIndex + patternData.text.length === text.length : true);
                if (patternFits) {
                    p.push(patternData.pattern + ">" + patternData.levels.join(""));
                    for(var i = 0; i < patternData.levels.length; i++)levels[patternEntityIndex + i] = Math.max(patternData.levels[i], levels[patternEntityIndex + i]);
                }
                if (patternEntityIndex > -1 && patternData.text.length > 0) fromChar = patternEntityIndex + patternData.text.length + 1;
                else endPattern = true;
            }
        }
        levels[0] = levels[1] = levels[levels.length - 1] = levels[levels.length - 2] = 0;
        var hyphenatedText = "", leveledText = "", debugHyphenatedText = "";
        for(var i = 0; i < levels.length; i++){
            hyphenatedText += (levels[i] % 2 === 1 ? hyphenChar : "") + text.charAt(i);
            debugHyphenatedText += (levels[i] % 2 === 1 ? "-" : "") + text.charAt(i);
            leveledText += (levels[i] > 0 ? levels[i] : "") + text.charAt(i);
        }
        if (debug) console.log.apply(console, [
            text,
            "->"
        ].concat(p).concat([
            "->"
        ]).concat(levels).concat([
            "->",
            leveledText
        ]).concat([
            "->",
            debugHyphenatedText
        ]));
        return hyphenatedText;
    }
    function preprocessPattern(pattern) {
        var patternCharIndex = 0, patternChar, patternData = {
            pattern: pattern,
            text: "",
            levels: [],
            stickToLeft: 0,
            stickToRight: 0
        }, states = {
            alphabet: 1,
            level: 2,
            stickToLeft: 3,
            stickToRight: 4
        };
        while(patternChar = pattern.charAt(patternCharIndex++)){
            var charIsDot = patternChar === ".", charIsNumber = !charIsDot && /\d/.test(patternChar), state = charIsDot ? patternCharIndex - 1 === 0 ? states.stickToLeft : states.stickToRight : charIsNumber ? states.level : states.alphabet;
            switch(state){
                case states.alphabet:
                    !prevCharIsNumber && patternData.levels.push(0);
                    patternData.text += patternChar;
                    break;
                case states.level:
                    patternData.levels.push(parseInt(patternChar));
                    break;
                case states.stickToLeft:
                    patternData.stickToLeft = true;
                    break;
                case states.stickToRight:
                    patternData.stickToRight = true;
                    break;
            }
            var prevCharIsNumber = charIsNumber;
        }
        return patternData;
    }
    function start(text, patterns, cache, debug, hyphenChar, skipHTML, minWordLength, isAsync) {
        function done() {
            allTime = new Date() - allTime;
            resolveNewText(newText);
            if (debug) {
                console.log("----------------\nHyphenation stats: " + processedN + " text chunks processed, " + hyphenatedN + " words hyphenated");
                console.log("Work time: " + workTime / 1000);
                console.log("Wait time: " + (allTime - workTime) / 1000);
                console.log("All time: " + allTime / 1000);
            }
        }
        var cacheKey, newText = "", textChunk, reader = createTextChunkReader(text, hyphenChar, skipHTML, minWordLength), readNextTextChunk = reader[0], shouldNextHyphenate = reader[1], processedN = 0, hyphenatedN = 0;
        var allTime = new Date(), workTime = 0;
        var resolveNewText = function() {};
        function nextTick() {
            var loopStart = new Date();
            while((!isAsync || new Date() - loopStart < 10) && (textChunk = readNextTextChunk())){
                cacheKey = textChunk.length ? "$" + textChunk : "";
                if (shouldNextHyphenate()) {
                    if (cache[cacheKey] === undefined) cache[cacheKey] = hyphenateWord(textChunk, patterns, debug, hyphenChar);
                    if (textChunk !== cache[cacheKey]) hyphenatedN++;
                    textChunk = cache[cacheKey];
                }
                newText += textChunk;
                processedN++;
            }
            workTime += new Date() - loopStart;
            if (!textChunk) done();
            else setTimeout(nextTick);
        }
        if (isAsync) {
            setTimeout(nextTick);
            return new Promise(function(resolve) {
                resolveNewText = resolve;
            });
        } else {
            nextTick();
            return newText;
        }
    }
    return createHyphenator;
});

},{}],"d2UoR":[function(require,module,exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.hyphenationPatternsEnUs = factory();
})(this, function() {
    var patterns = [], hyphenation = [];
    // title: Hyphenation patterns for American English
    // copyright: Copyright (C) 1990, 2004, 2005 Gerard D.C. Kuiken
    // notice: This file is part of the hyph-utf8 package.
    //     See http://www.hyphenation.org/tex for more information.
    // language:
    //     name: English, American spelling
    //     tag: en-us
    // version: 2005-05-30
    // authors:
    //   -
    //     name: Gerard D.C. Kuiken
    // licence:
    //     text: >
    //         Copying and distribution of this file, with or without modification,
    //         are permitted in any medium without royalty provided the copyright
    //         notice and this notice are preserved.
    // changes:
    //     March 1, 1990 Initial release
    //     May 30, 2005 Added copyright notice, no patterns change.
    // ==========================================
    //
    // ushyphmax.tex -- patterns for more hyphenation pattern memory (12000+).
    // Also known as ushyphen.max.
    //
    // Needs extended pattern memory.
    // Hyphenation trie becomes 7283 with 377 ops.
    //
    // These patterns are based on the Hyphenation Exception Log
    // published in TUGboat, Volume 10 (1989), No. 3, pp. 337-341,
    // and a large number of incorrectly hyphenated words not yet published.
    // If added to Liang's before the closing bracket } of \patterns,
    // the patterns run errorfree as far as known at this moment.
    //
    // These patterns find all admissible hyphens of the words in
    // the Exception Log.  ushyph2.tex is a smaller set.
    //
    // Please send bugs or suggestions to tex-live (at) tug.org.
    //
    // 2005-05-30 (karl): in the past, ushyphmax.tex was a file containing
    // only the additional patterns, without the \patterns command, etc.
    // This turned out not to be very useful, since in practice the TeX
    // distributions need one self-contained file for a language.  Therefore,
    // ushyphmax.tex now contains both the additional patterns from
    // Dr. Kuiken, and the original patterns and hyphenations from Knuth's
    // hyphen.tex.
    //
    // The Plain TeX hyphenation tables.
    var patterns = [
        " ",
        ".ach4",
        ".ad4der",
        ".af1t",
        ".al3t",
        ".am5at",
        ".an5c",
        ".ang4",
        ".ani5m",
        ".ant4",
        ".an3te",
        ".anti5s",
        ".ar5s",
        ".ar4tie",
        ".ar4ty",
        ".as3c",
        ".as1p",
        ".as1s",
        ".aster5",
        ".atom5",
        ".au1d",
        ".av4i",
        ".awn4",
        ".ba4g",
        ".ba5na",
        ".bas4e",
        ".ber4",
        ".be5ra",
        ".be3sm",
        ".be5sto",
        ".bri2",
        ".but4ti",
        ".cam4pe",
        ".can5c",
        ".capa5b",
        ".car5ol",
        ".ca4t",
        ".ce4la",
        ".ch4",
        ".chill5i",
        ".ci2",
        ".cit5r",
        ".co3e",
        ".co4r",
        ".cor5ner",
        ".de4moi",
        ".de3o",
        ".de3ra",
        ".de3ri",
        ".des4c",
        ".dictio5",
        ".do4t",
        ".du4c",
        ".dumb5",
        ".earth5",
        ".eas3i",
        ".eb4",
        ".eer4",
        ".eg2",
        ".el5d",
        ".el3em",
        ".enam3",
        ".en3g",
        ".en3s",
        ".eq5ui5t",
        ".er4ri",
        ".es3",
        ".eu3",
        ".eye5",
        ".fes3",
        ".for5mer",
        ".ga2",
        ".ge2",
        ".gen3t4",
        ".ge5og",
        ".gi5a",
        ".gi4b",
        ".go4r",
        ".hand5i",
        ".han5k",
        ".he2",
        ".hero5i",
        ".hes3",
        ".het3",
        ".hi3b",
        ".hi3er",
        ".hon5ey",
        ".hon3o",
        ".hov5",
        ".id4l",
        ".idol3",
        ".im3m",
        ".im5pin",
        ".in1",
        ".in3ci",
        ".ine2",
        ".in2k",
        ".in3s",
        ".ir5r",
        ".is4i",
        ".ju3r",
        ".la4cy",
        ".la4m",
        ".lat5er",
        ".lath5",
        ".le2",
        ".leg5e",
        ".len4",
        ".lep5",
        ".lev1",
        ".li4g",
        ".lig5a",
        ".li2n",
        ".li3o",
        ".li4t",
        ".mag5a5",
        ".mal5o",
        ".man5a",
        ".mar5ti",
        ".me2",
        ".mer3c",
        ".me5ter",
        ".mis1",
        ".mist5i",
        ".mon3e",
        ".mo3ro",
        ".mu5ta",
        ".muta5b",
        ".ni4c",
        ".od2",
        ".odd5",
        ".of5te",
        ".or5ato",
        ".or3c",
        ".or1d",
        ".or3t",
        ".os3",
        ".os4tl",
        ".oth3",
        ".out3",
        ".ped5al",
        ".pe5te",
        ".pe5tit",
        ".pi4e",
        ".pio5n",
        ".pi2t",
        ".pre3m",
        ".ra4c",
        ".ran4t",
        ".ratio5na",
        ".ree2",
        ".re5mit",
        ".res2",
        ".re5stat",
        ".ri4g",
        ".rit5u",
        ".ro4q",
        ".ros5t",
        ".row5d",
        ".ru4d",
        ".sci3e",
        ".self5",
        ".sell5",
        ".se2n",
        ".se5rie",
        ".sh2",
        ".si2",
        ".sing4",
        ".st4",
        ".sta5bl",
        ".sy2",
        ".ta4",
        ".te4",
        ".ten5an",
        ".th2",
        ".ti2",
        ".til4",
        ".tim5o5",
        ".ting4",
        ".tin5k",
        ".ton4a",
        ".to4p",
        ".top5i",
        ".tou5s",
        ".trib5ut",
        ".un1a",
        ".un3ce",
        ".under5",
        ".un1e",
        ".un5k",
        ".un5o",
        ".un3u",
        ".up3",
        ".ure3",
        ".us5a",
        ".ven4de",
        ".ve5ra",
        ".wil5i",
        ".ye4",
        "4ab.",
        "a5bal",
        "a5ban",
        "abe2",
        "ab5erd",
        "abi5a",
        "ab5it5ab",
        "ab5lat",
        "ab5o5liz",
        "4abr",
        "ab5rog",
        "ab3ul",
        "a4car",
        "ac5ard",
        "ac5aro",
        "a5ceou",
        "ac1er",
        "a5chet",
        "4a2ci",
        "a3cie",
        "ac1in",
        "a3cio",
        "ac5rob",
        "act5if",
        "ac3ul",
        "ac4um",
        "a2d",
        "ad4din",
        "ad5er.",
        "2adi",
        "a3dia",
        "ad3ica",
        "adi4er",
        "a3dio",
        "a3dit",
        "a5diu",
        "ad4le",
        "ad3ow",
        "ad5ran",
        "ad4su",
        "4adu",
        "a3duc",
        "ad5um",
        "ae4r",
        "aeri4e",
        "a2f",
        "aff4",
        "a4gab",
        "aga4n",
        "ag5ell",
        "age4o",
        "4ageu",
        "ag1i",
        "4ag4l",
        "ag1n",
        "a2go",
        "3agog",
        "ag3oni",
        "a5guer",
        "ag5ul",
        "a4gy",
        "a3ha",
        "a3he",
        "ah4l",
        "a3ho",
        "ai2",
        "a5ia",
        "a3ic.",
        "ai5ly",
        "a4i4n",
        "ain5in",
        "ain5o",
        "ait5en",
        "a1j",
        "ak1en",
        "al5ab",
        "al3ad",
        "a4lar",
        "4aldi",
        "2ale",
        "al3end",
        "a4lenti",
        "a5le5o",
        "al1i",
        "al4ia.",
        "ali4e",
        "al5lev",
        "4allic",
        "4alm",
        "a5log.",
        "a4ly.",
        "4alys",
        "5a5lyst",
        "5alyt",
        "3alyz",
        "4ama",
        "am5ab",
        "am3ag",
        "ama5ra",
        "am5asc",
        "a4matis",
        "a4m5ato",
        "am5era",
        "am3ic",
        "am5if",
        "am5ily",
        "am1in",
        "ami4no",
        "a2mo",
        "a5mon",
        "amor5i",
        "amp5en",
        "a2n",
        "an3age",
        "3analy",
        "a3nar",
        "an3arc",
        "anar4i",
        "a3nati",
        "4and",
        "ande4s",
        "an3dis",
        "an1dl",
        "an4dow",
        "a5nee",
        "a3nen",
        "an5est.",
        "a3neu",
        "2ang",
        "ang5ie",
        "an1gl",
        "a4n1ic",
        "a3nies",
        "an3i3f",
        "an4ime",
        "a5nimi",
        "a5nine",
        "an3io",
        "a3nip",
        "an3ish",
        "an3it",
        "a3niu",
        "an4kli",
        "5anniz",
        "ano4",
        "an5ot",
        "anoth5",
        "an2sa",
        "an4sco",
        "an4sn",
        "an2sp",
        "ans3po",
        "an4st",
        "an4sur",
        "antal4",
        "an4tie",
        "4anto",
        "an2tr",
        "an4tw",
        "an3ua",
        "an3ul",
        "a5nur",
        "4ao",
        "apar4",
        "ap5at",
        "ap5ero",
        "a3pher",
        "4aphi",
        "a4pilla",
        "ap5illar",
        "ap3in",
        "ap3ita",
        "a3pitu",
        "a2pl",
        "apoc5",
        "ap5ola",
        "apor5i",
        "apos3t",
        "aps5es",
        "a3pu",
        "aque5",
        "2a2r",
        "ar3act",
        "a5rade",
        "ar5adis",
        "ar3al",
        "a5ramete",
        "aran4g",
        "ara3p",
        "ar4at",
        "a5ratio",
        "ar5ativ",
        "a5rau",
        "ar5av4",
        "araw4",
        "arbal4",
        "ar4chan",
        "ar5dine",
        "ar4dr",
        "ar5eas",
        "a3ree",
        "ar3ent",
        "a5ress",
        "ar4fi",
        "ar4fl",
        "ar1i",
        "ar5ial",
        "ar3ian",
        "a3riet",
        "ar4im",
        "ar5inat",
        "ar3io",
        "ar2iz",
        "ar2mi",
        "ar5o5d",
        "a5roni",
        "a3roo",
        "ar2p",
        "ar3q",
        "arre4",
        "ar4sa",
        "ar2sh",
        "4as.",
        "as4ab",
        "as3ant",
        "ashi4",
        "a5sia.",
        "a3sib",
        "a3sic",
        "5a5si4t",
        "ask3i",
        "as4l",
        "a4soc",
        "as5ph",
        "as4sh",
        "as3ten",
        "as1tr",
        "asur5a",
        "a2ta",
        "at3abl",
        "at5ac",
        "at3alo",
        "at5ap",
        "ate5c",
        "at5ech",
        "at3ego",
        "at3en.",
        "at3era",
        "ater5n",
        "a5terna",
        "at3est",
        "at5ev",
        "4ath",
        "ath5em",
        "a5then",
        "at4ho",
        "ath5om",
        "4ati.",
        "a5tia",
        "at5i5b",
        "at1ic",
        "at3if",
        "ation5ar",
        "at3itu",
        "a4tog",
        "a2tom",
        "at5omiz",
        "a4top",
        "a4tos",
        "a1tr",
        "at5rop",
        "at4sk",
        "at4tag",
        "at5te",
        "at4th",
        "a2tu",
        "at5ua",
        "at5ue",
        "at3ul",
        "at3ura",
        "a2ty",
        "au4b",
        "augh3",
        "au3gu",
        "au4l2",
        "aun5d",
        "au3r",
        "au5sib",
        "aut5en",
        "au1th",
        "a2va",
        "av3ag",
        "a5van",
        "ave4no",
        "av3era",
        "av5ern",
        "av5ery",
        "av1i",
        "avi4er",
        "av3ig",
        "av5oc",
        "a1vor",
        "3away",
        "aw3i",
        "aw4ly",
        "aws4",
        "ax4ic",
        "ax4id",
        "ay5al",
        "aye4",
        "ays4",
        "azi4er",
        "azz5i",
        "5ba.",
        "bad5ger",
        "ba4ge",
        "bal1a",
        "ban5dag",
        "ban4e",
        "ban3i",
        "barbi5",
        "bari4a",
        "bas4si",
        "1bat",
        "ba4z",
        "2b1b",
        "b2be",
        "b3ber",
        "bbi4na",
        "4b1d",
        "4be.",
        "beak4",
        "beat3",
        "4be2d",
        "be3da",
        "be3de",
        "be3di",
        "be3gi",
        "be5gu",
        "1bel",
        "be1li",
        "be3lo",
        "4be5m",
        "be5nig",
        "be5nu",
        "4bes4",
        "be3sp",
        "be5str",
        "3bet",
        "bet5iz",
        "be5tr",
        "be3tw",
        "be3w",
        "be5yo",
        "2bf",
        "4b3h",
        "bi2b",
        "bi4d",
        "3bie",
        "bi5en",
        "bi4er",
        "2b3if",
        "1bil",
        "bi3liz",
        "bina5r4",
        "bin4d",
        "bi5net",
        "bi3ogr",
        "bi5ou",
        "bi2t",
        "3bi3tio",
        "bi3tr",
        "3bit5ua",
        "b5itz",
        "b1j",
        "bk4",
        "b2l2",
        "blath5",
        "b4le.",
        "blen4",
        "5blesp",
        "b3lis",
        "b4lo",
        "blun4t",
        "4b1m",
        "4b3n",
        "bne5g",
        "3bod",
        "bod3i",
        "bo4e",
        "bol3ic",
        "bom4bi",
        "bon4a",
        "bon5at",
        "3boo",
        "5bor.",
        "4b1ora",
        "bor5d",
        "5bore",
        "5bori",
        "5bos4",
        "b5ota",
        "both5",
        "bo4to",
        "bound3",
        "4bp",
        "4brit",
        "broth3",
        "2b5s2",
        "bsor4",
        "2bt",
        "bt4l",
        "b4to",
        "b3tr",
        "buf4fer",
        "bu4ga",
        "bu3li",
        "bumi4",
        "bu4n",
        "bunt4i",
        "bu3re",
        "bus5ie",
        "buss4e",
        "5bust",
        "4buta",
        "3butio",
        "b5uto",
        "b1v",
        "4b5w",
        "5by.",
        "bys4",
        "1ca",
        "cab3in",
        "ca1bl",
        "cach4",
        "ca5den",
        "4cag4",
        "2c5ah",
        "ca3lat",
        "cal4la",
        "call5in",
        "4calo",
        "can5d",
        "can4e",
        "can4ic",
        "can5is",
        "can3iz",
        "can4ty",
        "cany4",
        "ca5per",
        "car5om",
        "cast5er",
        "cas5tig",
        "4casy",
        "ca4th",
        "4cativ",
        "cav5al",
        "c3c",
        "ccha5",
        "cci4a",
        "ccompa5",
        "ccon4",
        "ccou3t",
        "2ce.",
        "4ced.",
        "4ceden",
        "3cei",
        "5cel.",
        "3cell",
        "1cen",
        "3cenc",
        "2cen4e",
        "4ceni",
        "3cent",
        "3cep",
        "ce5ram",
        "4cesa",
        "3cessi",
        "ces5si5b",
        "ces5t",
        "cet4",
        "c5e4ta",
        "cew4",
        "2ch",
        "4ch.",
        "4ch3ab",
        "5chanic",
        "ch5a5nis",
        "che2",
        "cheap3",
        "4ched",
        "che5lo",
        "3chemi",
        "ch5ene",
        "ch3er.",
        "ch3ers",
        "4ch1in",
        "5chine.",
        "ch5iness",
        "5chini",
        "5chio",
        "3chit",
        "chi2z",
        "3cho2",
        "ch4ti",
        "1ci",
        "3cia",
        "ci2a5b",
        "cia5r",
        "ci5c",
        "4cier",
        "5cific.",
        "4cii",
        "ci4la",
        "3cili",
        "2cim",
        "2cin",
        "c4ina",
        "3cinat",
        "cin3em",
        "c1ing",
        "c5ing.",
        "5cino",
        "cion4",
        "4cipe",
        "ci3ph",
        "4cipic",
        "4cista",
        "4cisti",
        "2c1it",
        "cit3iz",
        "5ciz",
        "ck1",
        "ck3i",
        "1c4l4",
        "4clar",
        "c5laratio",
        "5clare",
        "cle4m",
        "4clic",
        "clim4",
        "cly4",
        "c5n",
        "1co",
        "co5ag",
        "coe2",
        "2cog",
        "co4gr",
        "coi4",
        "co3inc",
        "col5i",
        "5colo",
        "col3or",
        "com5er",
        "con4a",
        "c4one",
        "con3g",
        "con5t",
        "co3pa",
        "cop3ic",
        "co4pl",
        "4corb",
        "coro3n",
        "cos4e",
        "cov1",
        "cove4",
        "cow5a",
        "coz5e",
        "co5zi",
        "c1q",
        "cras5t",
        "5crat.",
        "5cratic",
        "cre3at",
        "5cred",
        "4c3reta",
        "cre4v",
        "cri2",
        "cri5f",
        "c4rin",
        "cris4",
        "5criti",
        "cro4pl",
        "crop5o",
        "cros4e",
        "cru4d",
        "4c3s2",
        "2c1t",
        "cta4b",
        "ct5ang",
        "c5tant",
        "c2te",
        "c3ter",
        "c4ticu",
        "ctim3i",
        "ctu4r",
        "c4tw",
        "cud5",
        "c4uf",
        "c4ui",
        "cu5ity",
        "5culi",
        "cul4tis",
        "3cultu",
        "cu2ma",
        "c3ume",
        "cu4mi",
        "3cun",
        "cu3pi",
        "cu5py",
        "cur5a4b",
        "cu5ria",
        "1cus",
        "cuss4i",
        "3c4ut",
        "cu4tie",
        "4c5utiv",
        "4cutr",
        "1cy",
        "cze4",
        "1d2a",
        "5da.",
        "2d3a4b",
        "dach4",
        "4daf",
        "2dag",
        "da2m2",
        "dan3g",
        "dard5",
        "dark5",
        "4dary",
        "3dat",
        "4dativ",
        "4dato",
        "5dav4",
        "dav5e",
        "5day",
        "d1b",
        "d5c",
        "d1d4",
        "2de.",
        "deaf5",
        "deb5it",
        "de4bon",
        "decan4",
        "de4cil",
        "de5com",
        "2d1ed",
        "4dee.",
        "de5if",
        "deli4e",
        "del5i5q",
        "de5lo",
        "d4em",
        "5dem.",
        "3demic",
        "dem5ic.",
        "de5mil",
        "de4mons",
        "demor5",
        "1den",
        "de4nar",
        "de3no",
        "denti5f",
        "de3nu",
        "de1p",
        "de3pa",
        "depi4",
        "de2pu",
        "d3eq",
        "d4erh",
        "5derm",
        "dern5iz",
        "der5s",
        "des2",
        "d2es.",
        "de1sc",
        "de2s5o",
        "des3ti",
        "de3str",
        "de4su",
        "de1t",
        "de2to",
        "de1v",
        "dev3il",
        "4dey",
        "4d1f",
        "d4ga",
        "d3ge4t",
        "dg1i",
        "d2gy",
        "d1h2",
        "5di.",
        "1d4i3a",
        "dia5b",
        "di4cam",
        "d4ice",
        "3dict",
        "3did",
        "5di3en",
        "d1if",
        "di3ge",
        "di4lato",
        "d1in",
        "1dina",
        "3dine.",
        "5dini",
        "di5niz",
        "1dio",
        "dio5g",
        "di4pl",
        "dir2",
        "di1re",
        "dirt5i",
        "dis1",
        "5disi",
        "d4is3t",
        "d2iti",
        "1di1v",
        "d1j",
        "d5k2",
        "4d5la",
        "3dle.",
        "3dled",
        "3dles.",
        "4dless",
        "2d3lo",
        "4d5lu",
        "2dly",
        "d1m",
        "4d1n4",
        "1do",
        "3do.",
        "do5de",
        "5doe",
        "2d5of",
        "d4og",
        "do4la",
        "doli4",
        "do5lor",
        "dom5iz",
        "do3nat",
        "doni4",
        "doo3d",
        "dop4p",
        "d4or",
        "3dos",
        "4d5out",
        "do4v",
        "3dox",
        "d1p",
        "1dr",
        "drag5on",
        "4drai",
        "dre4",
        "drea5r",
        "5dren",
        "dri4b",
        "dril4",
        "dro4p",
        "4drow",
        "5drupli",
        "4dry",
        "2d1s2",
        "ds4p",
        "d4sw",
        "d4sy",
        "d2th",
        "1du",
        "d1u1a",
        "du2c",
        "d1uca",
        "duc5er",
        "4duct.",
        "4ducts",
        "du5el",
        "du4g",
        "d3ule",
        "dum4be",
        "du4n",
        "4dup",
        "du4pe",
        "d1v",
        "d1w",
        "d2y",
        "5dyn",
        "dy4se",
        "dys5p",
        "e1a4b",
        "e3act",
        "ead1",
        "ead5ie",
        "ea4ge",
        "ea5ger",
        "ea4l",
        "eal5er",
        "eal3ou",
        "eam3er",
        "e5and",
        "ear3a",
        "ear4c",
        "ear5es",
        "ear4ic",
        "ear4il",
        "ear5k",
        "ear2t",
        "eart3e",
        "ea5sp",
        "e3ass",
        "east3",
        "ea2t",
        "eat5en",
        "eath3i",
        "e5atif",
        "e4a3tu",
        "ea2v",
        "eav3en",
        "eav5i",
        "eav5o",
        "2e1b",
        "e4bel.",
        "e4bels",
        "e4ben",
        "e4bit",
        "e3br",
        "e4cad",
        "ecan5c",
        "ecca5",
        "e1ce",
        "ec5essa",
        "ec2i",
        "e4cib",
        "ec5ificat",
        "ec5ifie",
        "ec5ify",
        "ec3im",
        "eci4t",
        "e5cite",
        "e4clam",
        "e4clus",
        "e2col",
        "e4comm",
        "e4compe",
        "e4conc",
        "e2cor",
        "ec3ora",
        "eco5ro",
        "e1cr",
        "e4crem",
        "ec4tan",
        "ec4te",
        "e1cu",
        "e4cul",
        "ec3ula",
        "2e2da",
        "4ed3d",
        "e4d1er",
        "ede4s",
        "4edi",
        "e3dia",
        "ed3ib",
        "ed3ica",
        "ed3im",
        "ed1it",
        "edi5z",
        "4edo",
        "e4dol",
        "edon2",
        "e4dri",
        "e4dul",
        "ed5ulo",
        "ee2c",
        "eed3i",
        "ee2f",
        "eel3i",
        "ee4ly",
        "ee2m",
        "ee4na",
        "ee4p1",
        "ee2s4",
        "eest4",
        "ee4ty",
        "e5ex",
        "e1f",
        "e4f3ere",
        "1eff",
        "e4fic",
        "5efici",
        "efil4",
        "e3fine",
        "ef5i5nite",
        "3efit",
        "efor5es",
        "e4fuse.",
        "4egal",
        "eger4",
        "eg5ib",
        "eg4ic",
        "eg5ing",
        "e5git5",
        "eg5n",
        "e4go.",
        "e4gos",
        "eg1ul",
        "e5gur",
        "5egy",
        "e1h4",
        "eher4",
        "ei2",
        "e5ic",
        "ei5d",
        "eig2",
        "ei5gl",
        "e3imb",
        "e3inf",
        "e1ing",
        "e5inst",
        "eir4d",
        "eit3e",
        "ei3th",
        "e5ity",
        "e1j",
        "e4jud",
        "ej5udi",
        "eki4n",
        "ek4la",
        "e1la",
        "e4la.",
        "e4lac",
        "elan4d",
        "el5ativ",
        "e4law",
        "elaxa4",
        "e3lea",
        "el5ebra",
        "5elec",
        "e4led",
        "el3ega",
        "e5len",
        "e4l1er",
        "e1les",
        "el2f",
        "el2i",
        "e3libe",
        "e4l5ic.",
        "el3ica",
        "e3lier",
        "el5igib",
        "e5lim",
        "e4l3ing",
        "e3lio",
        "e2lis",
        "el5ish",
        "e3liv3",
        "4ella",
        "el4lab",
        "ello4",
        "e5loc",
        "el5og",
        "el3op.",
        "el2sh",
        "el4ta",
        "e5lud",
        "el5ug",
        "e4mac",
        "e4mag",
        "e5man",
        "em5ana",
        "em5b",
        "e1me",
        "e2mel",
        "e4met",
        "em3ica",
        "emi4e",
        "em5igra",
        "em1in2",
        "em5ine",
        "em3i3ni",
        "e4mis",
        "em5ish",
        "e5miss",
        "em3iz",
        "5emniz",
        "emo4g",
        "emoni5o",
        "em3pi",
        "e4mul",
        "em5ula",
        "emu3n",
        "e3my",
        "en5amo",
        "e4nant",
        "ench4er",
        "en3dic",
        "e5nea",
        "e5nee",
        "en3em",
        "en5ero",
        "en5esi",
        "en5est",
        "en3etr",
        "e3new",
        "en5ics",
        "e5nie",
        "e5nil",
        "e3nio",
        "en3ish",
        "en3it",
        "e5niu",
        "5eniz",
        "4enn",
        "4eno",
        "eno4g",
        "e4nos",
        "en3ov",
        "en4sw",
        "ent5age",
        "4enthes",
        "en3ua",
        "en5uf",
        "e3ny.",
        "4en3z",
        "e5of",
        "eo2g",
        "e4oi4",
        "e3ol",
        "eop3ar",
        "e1or",
        "eo3re",
        "eo5rol",
        "eos4",
        "e4ot",
        "eo4to",
        "e5out",
        "e5ow",
        "e2pa",
        "e3pai",
        "ep5anc",
        "e5pel",
        "e3pent",
        "ep5etitio",
        "ephe4",
        "e4pli",
        "e1po",
        "e4prec",
        "ep5reca",
        "e4pred",
        "ep3reh",
        "e3pro",
        "e4prob",
        "ep4sh",
        "ep5ti5b",
        "e4put",
        "ep5uta",
        "e1q",
        "equi3l",
        "e4q3ui3s",
        "er1a",
        "era4b",
        "4erand",
        "er3ar",
        "4erati.",
        "2erb",
        "er4bl",
        "er3ch",
        "er4che",
        "2ere.",
        "e3real",
        "ere5co",
        "ere3in",
        "er5el.",
        "er3emo",
        "er5ena",
        "er5ence",
        "4erene",
        "er3ent",
        "ere4q",
        "er5ess",
        "er3est",
        "eret4",
        "er1h",
        "er1i",
        "e1ria4",
        "5erick",
        "e3rien",
        "eri4er",
        "er3ine",
        "e1rio",
        "4erit",
        "er4iu",
        "eri4v",
        "e4riva",
        "er3m4",
        "er4nis",
        "4ernit",
        "5erniz",
        "er3no",
        "2ero",
        "er5ob",
        "e5roc",
        "ero4r",
        "er1ou",
        "er1s",
        "er3set",
        "ert3er",
        "4ertl",
        "er3tw",
        "4eru",
        "eru4t",
        "5erwau",
        "e1s4a",
        "e4sage.",
        "e4sages",
        "es2c",
        "e2sca",
        "es5can",
        "e3scr",
        "es5cu",
        "e1s2e",
        "e2sec",
        "es5ecr",
        "es5enc",
        "e4sert.",
        "e4serts",
        "e4serva",
        "4esh",
        "e3sha",
        "esh5en",
        "e1si",
        "e2sic",
        "e2sid",
        "es5iden",
        "es5igna",
        "e2s5im",
        "es4i4n",
        "esis4te",
        "esi4u",
        "e5skin",
        "es4mi",
        "e2sol",
        "es3olu",
        "e2son",
        "es5ona",
        "e1sp",
        "es3per",
        "es5pira",
        "es4pre",
        "2ess",
        "es4si4b",
        "estan4",
        "es3tig",
        "es5tim",
        "4es2to",
        "e3ston",
        "2estr",
        "e5stro",
        "estruc5",
        "e2sur",
        "es5urr",
        "es4w",
        "eta4b",
        "eten4d",
        "e3teo",
        "ethod3",
        "et1ic",
        "e5tide",
        "etin4",
        "eti4no",
        "e5tir",
        "e5titio",
        "et5itiv",
        "4etn",
        "et5ona",
        "e3tra",
        "e3tre",
        "et3ric",
        "et5rif",
        "et3rog",
        "et5ros",
        "et3ua",
        "et5ym",
        "et5z",
        "4eu",
        "e5un",
        "e3up",
        "eu3ro",
        "eus4",
        "eute4",
        "euti5l",
        "eu5tr",
        "eva2p5",
        "e2vas",
        "ev5ast",
        "e5vea",
        "ev3ell",
        "evel3o",
        "e5veng",
        "even4i",
        "ev1er",
        "e5verb",
        "e1vi",
        "ev3id",
        "evi4l",
        "e4vin",
        "evi4v",
        "e5voc",
        "e5vu",
        "e1wa",
        "e4wag",
        "e5wee",
        "e3wh",
        "ewil5",
        "ew3ing",
        "e3wit",
        "1exp",
        "5eyc",
        "5eye.",
        "eys4",
        "1fa",
        "fa3bl",
        "fab3r",
        "fa4ce",
        "4fag",
        "fain4",
        "fall5e",
        "4fa4ma",
        "fam5is",
        "5far",
        "far5th",
        "fa3ta",
        "fa3the",
        "4fato",
        "fault5",
        "4f5b",
        "4fd",
        "4fe.",
        "feas4",
        "feath3",
        "fe4b",
        "4feca",
        "5fect",
        "2fed",
        "fe3li",
        "fe4mo",
        "fen2d",
        "fend5e",
        "fer1",
        "5ferr",
        "fev4",
        "4f1f",
        "f4fes",
        "f4fie",
        "f5fin.",
        "f2f5is",
        "f4fly",
        "f2fy",
        "4fh",
        "1fi",
        "fi3a",
        "2f3ic.",
        "4f3ical",
        "f3ican",
        "4ficate",
        "f3icen",
        "fi3cer",
        "fic4i",
        "5ficia",
        "5ficie",
        "4fics",
        "fi3cu",
        "fi5del",
        "fight5",
        "fil5i",
        "fill5in",
        "4fily",
        "2fin",
        "5fina",
        "fin2d5",
        "fi2ne",
        "f1in3g",
        "fin4n",
        "fis4ti",
        "f4l2",
        "f5less",
        "flin4",
        "flo3re",
        "f2ly5",
        "4fm",
        "4fn",
        "1fo",
        "5fon",
        "fon4de",
        "fon4t",
        "fo2r",
        "fo5rat",
        "for5ay",
        "fore5t",
        "for4i",
        "fort5a",
        "fos5",
        "4f5p",
        "fra4t",
        "f5rea",
        "fres5c",
        "fri2",
        "fril4",
        "frol5",
        "2f3s",
        "2ft",
        "f4to",
        "f2ty",
        "3fu",
        "fu5el",
        "4fug",
        "fu4min",
        "fu5ne",
        "fu3ri",
        "fusi4",
        "fus4s",
        "4futa",
        "1fy",
        "1ga",
        "gaf4",
        "5gal.",
        "3gali",
        "ga3lo",
        "2gam",
        "ga5met",
        "g5amo",
        "gan5is",
        "ga3niz",
        "gani5za",
        "4gano",
        "gar5n4",
        "gass4",
        "gath3",
        "4gativ",
        "4gaz",
        "g3b",
        "gd4",
        "2ge.",
        "2ged",
        "geez4",
        "gel4in",
        "ge5lis",
        "ge5liz",
        "4gely",
        "1gen",
        "ge4nat",
        "ge5niz",
        "4geno",
        "4geny",
        "1geo",
        "ge3om",
        "g4ery",
        "5gesi",
        "geth5",
        "4geto",
        "ge4ty",
        "ge4v",
        "4g1g2",
        "g2ge",
        "g3ger",
        "gglu5",
        "ggo4",
        "gh3in",
        "gh5out",
        "gh4to",
        "5gi.",
        "1gi4a",
        "gia5r",
        "g1ic",
        "5gicia",
        "g4ico",
        "gien5",
        "5gies.",
        "gil4",
        "g3imen",
        "3g4in.",
        "gin5ge",
        "5g4ins",
        "5gio",
        "3gir",
        "gir4l",
        "g3isl",
        "gi4u",
        "5giv",
        "3giz",
        "gl2",
        "gla4",
        "glad5i",
        "5glas",
        "1gle",
        "gli4b",
        "g3lig",
        "3glo",
        "glo3r",
        "g1m",
        "g4my",
        "gn4a",
        "g4na.",
        "gnet4t",
        "g1ni",
        "g2nin",
        "g4nio",
        "g1no",
        "g4non",
        "1go",
        "3go.",
        "gob5",
        "5goe",
        "3g4o4g",
        "go3is",
        "gon2",
        "4g3o3na",
        "gondo5",
        "go3ni",
        "5goo",
        "go5riz",
        "gor5ou",
        "5gos.",
        "gov1",
        "g3p",
        "1gr",
        "4grada",
        "g4rai",
        "gran2",
        "5graph.",
        "g5rapher",
        "5graphic",
        "4graphy",
        "4gray",
        "gre4n",
        "4gress.",
        "4grit",
        "g4ro",
        "gruf4",
        "gs2",
        "g5ste",
        "gth3",
        "gu4a",
        "3guard",
        "2gue",
        "5gui5t",
        "3gun",
        "3gus",
        "4gu4t",
        "g3w",
        "1gy",
        "2g5y3n",
        "gy5ra",
        "h3ab4l",
        "hach4",
        "hae4m",
        "hae4t",
        "h5agu",
        "ha3la",
        "hala3m",
        "ha4m",
        "han4ci",
        "han4cy",
        "5hand.",
        "han4g",
        "hang5er",
        "hang5o",
        "h5a5niz",
        "han4k",
        "han4te",
        "hap3l",
        "hap5t",
        "ha3ran",
        "ha5ras",
        "har2d",
        "hard3e",
        "har4le",
        "harp5en",
        "har5ter",
        "has5s",
        "haun4",
        "5haz",
        "haz3a",
        "h1b",
        "1head",
        "3hear",
        "he4can",
        "h5ecat",
        "h4ed",
        "he5do5",
        "he3l4i",
        "hel4lis",
        "hel4ly",
        "h5elo",
        "hem4p",
        "he2n",
        "hena4",
        "hen5at",
        "heo5r",
        "hep5",
        "h4era",
        "hera3p",
        "her4ba",
        "here5a",
        "h3ern",
        "h5erou",
        "h3ery",
        "h1es",
        "he2s5p",
        "he4t",
        "het4ed",
        "heu4",
        "h1f",
        "h1h",
        "hi5an",
        "hi4co",
        "high5",
        "h4il2",
        "himer4",
        "h4ina",
        "hion4e",
        "hi4p",
        "hir4l",
        "hi3ro",
        "hir4p",
        "hir4r",
        "his3el",
        "his4s",
        "hith5er",
        "hi2v",
        "4hk",
        "4h1l4",
        "hlan4",
        "h2lo",
        "hlo3ri",
        "4h1m",
        "hmet4",
        "2h1n",
        "h5odiz",
        "h5ods",
        "ho4g",
        "hoge4",
        "hol5ar",
        "3hol4e",
        "ho4ma",
        "home3",
        "hon4a",
        "ho5ny",
        "3hood",
        "hoon4",
        "hor5at",
        "ho5ris",
        "hort3e",
        "ho5ru",
        "hos4e",
        "ho5sen",
        "hos1p",
        "1hous",
        "house3",
        "hov5el",
        "4h5p",
        "4hr4",
        "hree5",
        "hro5niz",
        "hro3po",
        "4h1s2",
        "h4sh",
        "h4tar",
        "ht1en",
        "ht5es",
        "h4ty",
        "hu4g",
        "hu4min",
        "hun5ke",
        "hun4t",
        "hus3t4",
        "hu4t",
        "h1w",
        "h4wart",
        "hy3pe",
        "hy3ph",
        "hy2s",
        "2i1a",
        "i2al",
        "iam4",
        "iam5ete",
        "i2an",
        "4ianc",
        "ian3i",
        "4ian4t",
        "ia5pe",
        "iass4",
        "i4ativ",
        "ia4tric",
        "i4atu",
        "ibe4",
        "ib3era",
        "ib5ert",
        "ib5ia",
        "ib3in",
        "ib5it.",
        "ib5ite",
        "i1bl",
        "ib3li",
        "i5bo",
        "i1br",
        "i2b5ri",
        "i5bun",
        "4icam",
        "5icap",
        "4icar",
        "i4car.",
        "i4cara",
        "icas5",
        "i4cay",
        "iccu4",
        "4iceo",
        "4ich",
        "2ici",
        "i5cid",
        "ic5ina",
        "i2cip",
        "ic3ipa",
        "i4cly",
        "i2c5oc",
        "4i1cr",
        "5icra",
        "i4cry",
        "ic4te",
        "ictu2",
        "ic4t3ua",
        "ic3ula",
        "ic4um",
        "ic5uo",
        "i3cur",
        "2id",
        "i4dai",
        "id5anc",
        "id5d",
        "ide3al",
        "ide4s",
        "i2di",
        "id5ian",
        "idi4ar",
        "i5die",
        "id3io",
        "idi5ou",
        "id1it",
        "id5iu",
        "i3dle",
        "i4dom",
        "id3ow",
        "i4dr",
        "i2du",
        "id5uo",
        "2ie4",
        "ied4e",
        "5ie5ga",
        "ield3",
        "ien5a4",
        "ien4e",
        "i5enn",
        "i3enti",
        "i1er.",
        "i3esc",
        "i1est",
        "i3et",
        "4if.",
        "if5ero",
        "iff5en",
        "if4fr",
        "4ific.",
        "i3fie",
        "i3fl",
        "4ift",
        "2ig",
        "iga5b",
        "ig3era",
        "ight3i",
        "4igi",
        "i3gib",
        "ig3il",
        "ig3in",
        "ig3it",
        "i4g4l",
        "i2go",
        "ig3or",
        "ig5ot",
        "i5gre",
        "igu5i",
        "ig1ur",
        "i3h",
        "4i5i4",
        "i3j",
        "4ik",
        "i1la",
        "il3a4b",
        "i4lade",
        "i2l5am",
        "ila5ra",
        "i3leg",
        "il1er",
        "ilev4",
        "il5f",
        "il1i",
        "il3ia",
        "il2ib",
        "il3io",
        "il4ist",
        "2ilit",
        "il2iz",
        "ill5ab",
        "4iln",
        "il3oq",
        "il4ty",
        "il5ur",
        "il3v",
        "i4mag",
        "im3age",
        "ima5ry",
        "imenta5r",
        "4imet",
        "im1i",
        "im5ida",
        "imi5le",
        "i5mini",
        "4imit",
        "im4ni",
        "i3mon",
        "i2mu",
        "im3ula",
        "2in.",
        "i4n3au",
        "4inav",
        "incel4",
        "in3cer",
        "4ind",
        "in5dling",
        "2ine",
        "i3nee",
        "iner4ar",
        "i5ness",
        "4inga",
        "4inge",
        "in5gen",
        "4ingi",
        "in5gling",
        "4ingo",
        "4ingu",
        "2ini",
        "i5ni.",
        "i4nia",
        "in3io",
        "in1is",
        "i5nite.",
        "5initio",
        "in3ity",
        "4ink",
        "4inl",
        "2inn",
        "2i1no",
        "i4no4c",
        "ino4s",
        "i4not",
        "2ins",
        "in3se",
        "insur5a",
        "2int.",
        "2in4th",
        "in1u",
        "i5nus",
        "4iny",
        "2io",
        "4io.",
        "ioge4",
        "io2gr",
        "i1ol",
        "io4m",
        "ion3at",
        "ion4ery",
        "ion3i",
        "io5ph",
        "ior3i",
        "i4os",
        "io5th",
        "i5oti",
        "io4to",
        "i4our",
        "2ip",
        "ipe4",
        "iphras4",
        "ip3i",
        "ip4ic",
        "ip4re4",
        "ip3ul",
        "i3qua",
        "iq5uef",
        "iq3uid",
        "iq3ui3t",
        "4ir",
        "i1ra",
        "ira4b",
        "i4rac",
        "ird5e",
        "ire4de",
        "i4ref",
        "i4rel4",
        "i4res",
        "ir5gi",
        "ir1i",
        "iri5de",
        "ir4is",
        "iri3tu",
        "5i5r2iz",
        "ir4min",
        "iro4g",
        "5iron.",
        "ir5ul",
        "2is.",
        "is5ag",
        "is3ar",
        "isas5",
        "2is1c",
        "is3ch",
        "4ise",
        "is3er",
        "3isf",
        "is5han",
        "is3hon",
        "ish5op",
        "is3ib",
        "isi4d",
        "i5sis",
        "is5itiv",
        "4is4k",
        "islan4",
        "4isms",
        "i2so",
        "iso5mer",
        "is1p",
        "is2pi",
        "is4py",
        "4is1s",
        "is4sal",
        "issen4",
        "is4ses",
        "is4ta.",
        "is1te",
        "is1ti",
        "ist4ly",
        "4istral",
        "i2su",
        "is5us",
        "4ita.",
        "ita4bi",
        "i4tag",
        "4ita5m",
        "i3tan",
        "i3tat",
        "2ite",
        "it3era",
        "i5teri",
        "it4es",
        "2ith",
        "i1ti",
        "4itia",
        "4i2tic",
        "it3ica",
        "5i5tick",
        "it3ig",
        "it5ill",
        "i2tim",
        "2itio",
        "4itis",
        "i4tism",
        "i2t5o5m",
        "4iton",
        "i4tram",
        "it5ry",
        "4itt",
        "it3uat",
        "i5tud",
        "it3ul",
        "4itz.",
        "i1u",
        "2iv",
        "iv3ell",
        "iv3en.",
        "i4v3er.",
        "i4vers.",
        "iv5il.",
        "iv5io",
        "iv1it",
        "i5vore",
        "iv3o3ro",
        "i4v3ot",
        "4i5w",
        "ix4o",
        "4iy",
        "4izar",
        "izi4",
        "5izont",
        "5ja",
        "jac4q",
        "ja4p",
        "1je",
        "jer5s",
        "4jestie",
        "4jesty",
        "jew3",
        "jo4p",
        "5judg",
        "3ka.",
        "k3ab",
        "k5ag",
        "kais4",
        "kal4",
        "k1b",
        "k2ed",
        "1kee",
        "ke4g",
        "ke5li",
        "k3en4d",
        "k1er",
        "kes4",
        "k3est.",
        "ke4ty",
        "k3f",
        "kh4",
        "k1i",
        "5ki.",
        "5k2ic",
        "k4ill",
        "kilo5",
        "k4im",
        "k4in.",
        "kin4de",
        "k5iness",
        "kin4g",
        "ki4p",
        "kis4",
        "k5ish",
        "kk4",
        "k1l",
        "4kley",
        "4kly",
        "k1m",
        "k5nes",
        "1k2no",
        "ko5r",
        "kosh4",
        "k3ou",
        "kro5n",
        "4k1s2",
        "k4sc",
        "ks4l",
        "k4sy",
        "k5t",
        "k1w",
        "lab3ic",
        "l4abo",
        "laci4",
        "l4ade",
        "la3dy",
        "lag4n",
        "lam3o",
        "3land",
        "lan4dl",
        "lan5et",
        "lan4te",
        "lar4g",
        "lar3i",
        "las4e",
        "la5tan",
        "4lateli",
        "4lativ",
        "4lav",
        "la4v4a",
        "2l1b",
        "lbin4",
        "4l1c2",
        "lce4",
        "l3ci",
        "2ld",
        "l2de",
        "ld4ere",
        "ld4eri",
        "ldi4",
        "ld5is",
        "l3dr",
        "l4dri",
        "le2a",
        "le4bi",
        "left5",
        "5leg.",
        "5legg",
        "le4mat",
        "lem5atic",
        "4len.",
        "3lenc",
        "5lene.",
        "1lent",
        "le3ph",
        "le4pr",
        "lera5b",
        "ler4e",
        "3lerg",
        "3l4eri",
        "l4ero",
        "les2",
        "le5sco",
        "5lesq",
        "3less",
        "5less.",
        "l3eva",
        "lev4er.",
        "lev4era",
        "lev4ers",
        "3ley",
        "4leye",
        "2lf",
        "l5fr",
        "4l1g4",
        "l5ga",
        "lgar3",
        "l4ges",
        "lgo3",
        "2l3h",
        "li4ag",
        "li2am",
        "liar5iz",
        "li4as",
        "li4ato",
        "li5bi",
        "5licio",
        "li4cor",
        "4lics",
        "4lict.",
        "l4icu",
        "l3icy",
        "l3ida",
        "lid5er",
        "3lidi",
        "lif3er",
        "l4iff",
        "li4fl",
        "5ligate",
        "3ligh",
        "li4gra",
        "3lik",
        "4l4i4l",
        "lim4bl",
        "lim3i",
        "li4mo",
        "l4im4p",
        "l4ina",
        "1l4ine",
        "lin3ea",
        "lin3i",
        "link5er",
        "li5og",
        "4l4iq",
        "lis4p",
        "l1it",
        "l2it.",
        "5litica",
        "l5i5tics",
        "liv3er",
        "l1iz",
        "4lj",
        "lka3",
        "l3kal",
        "lka4t",
        "l1l",
        "l4law",
        "l2le",
        "l5lea",
        "l3lec",
        "l3leg",
        "l3lel",
        "l3le4n",
        "l3le4t",
        "ll2i",
        "l2lin4",
        "l5lina",
        "ll4o",
        "lloqui5",
        "ll5out",
        "l5low",
        "2lm",
        "l5met",
        "lm3ing",
        "l4mod",
        "lmon4",
        "2l1n2",
        "3lo.",
        "lob5al",
        "lo4ci",
        "4lof",
        "3logic",
        "l5ogo",
        "3logu",
        "lom3er",
        "5long",
        "lon4i",
        "l3o3niz",
        "lood5",
        "5lope.",
        "lop3i",
        "l3opm",
        "lora4",
        "lo4rato",
        "lo5rie",
        "lor5ou",
        "5los.",
        "los5et",
        "5losophiz",
        "5losophy",
        "los4t",
        "lo4ta",
        "loun5d",
        "2lout",
        "4lov",
        "2lp",
        "lpa5b",
        "l3pha",
        "l5phi",
        "lp5ing",
        "l3pit",
        "l4pl",
        "l5pr",
        "4l1r",
        "2l1s2",
        "l4sc",
        "l2se",
        "l4sie",
        "4lt",
        "lt5ag",
        "ltane5",
        "l1te",
        "lten4",
        "ltera4",
        "lth3i",
        "l5ties.",
        "ltis4",
        "l1tr",
        "ltu2",
        "ltur3a",
        "lu5a",
        "lu3br",
        "luch4",
        "lu3ci",
        "lu3en",
        "luf4",
        "lu5id",
        "lu4ma",
        "5lumi",
        "l5umn.",
        "5lumnia",
        "lu3o",
        "luo3r",
        "4lup",
        "luss4",
        "lus3te",
        "1lut",
        "l5ven",
        "l5vet4",
        "2l1w",
        "1ly",
        "4lya",
        "4lyb",
        "ly5me",
        "ly3no",
        "2lys4",
        "l5yse",
        "1ma",
        "2mab",
        "ma2ca",
        "ma5chine",
        "ma4cl",
        "mag5in",
        "5magn",
        "2mah",
        "maid5",
        "4mald",
        "ma3lig",
        "ma5lin",
        "mal4li",
        "mal4ty",
        "5mania",
        "man5is",
        "man3iz",
        "4map",
        "ma5rine.",
        "ma5riz",
        "mar4ly",
        "mar3v",
        "ma5sce",
        "mas4e",
        "mas1t",
        "5mate",
        "math3",
        "ma3tis",
        "4matiza",
        "4m1b",
        "mba4t5",
        "m5bil",
        "m4b3ing",
        "mbi4v",
        "4m5c",
        "4me.",
        "2med",
        "4med.",
        "5media",
        "me3die",
        "m5e5dy",
        "me2g",
        "mel5on",
        "mel4t",
        "me2m",
        "mem1o3",
        "1men",
        "men4a",
        "men5ac",
        "men4de",
        "4mene",
        "men4i",
        "mens4",
        "mensu5",
        "3ment",
        "men4te",
        "me5on",
        "m5ersa",
        "2mes",
        "3mesti",
        "me4ta",
        "met3al",
        "me1te",
        "me5thi",
        "m4etr",
        "5metric",
        "me5trie",
        "me3try",
        "me4v",
        "4m1f",
        "2mh",
        "5mi.",
        "mi3a",
        "mid4a",
        "mid4g",
        "mig4",
        "3milia",
        "m5i5lie",
        "m4ill",
        "min4a",
        "3mind",
        "m5inee",
        "m4ingl",
        "min5gli",
        "m5ingly",
        "min4t",
        "m4inu",
        "miot4",
        "m2is",
        "mis4er.",
        "mis5l",
        "mis4ti",
        "m5istry",
        "4mith",
        "m2iz",
        "4mk",
        "4m1l",
        "m1m",
        "mma5ry",
        "4m1n",
        "mn4a",
        "m4nin",
        "mn4o",
        "1mo",
        "4mocr",
        "5mocratiz",
        "mo2d1",
        "mo4go",
        "mois2",
        "moi5se",
        "4mok",
        "mo5lest",
        "mo3me",
        "mon5et",
        "mon5ge",
        "moni3a",
        "mon4ism",
        "mon4ist",
        "mo3niz",
        "monol4",
        "mo3ny.",
        "mo2r",
        "4mora.",
        "mos2",
        "mo5sey",
        "mo3sp",
        "moth3",
        "m5ouf",
        "3mous",
        "mo2v",
        "4m1p",
        "mpara5",
        "mpa5rab",
        "mpar5i",
        "m3pet",
        "mphas4",
        "m2pi",
        "mpi4a",
        "mp5ies",
        "m4p1in",
        "m5pir",
        "mp5is",
        "mpo3ri",
        "mpos5ite",
        "m4pous",
        "mpov5",
        "mp4tr",
        "m2py",
        "4m3r",
        "4m1s2",
        "m4sh",
        "m5si",
        "4mt",
        "1mu",
        "mula5r4",
        "5mult",
        "multi3",
        "3mum",
        "mun2",
        "4mup",
        "mu4u",
        "4mw",
        "1na",
        "2n1a2b",
        "n4abu",
        "4nac.",
        "na4ca",
        "n5act",
        "nag5er.",
        "nak4",
        "na4li",
        "na5lia",
        "4nalt",
        "na5mit",
        "n2an",
        "nanci4",
        "nan4it",
        "nank4",
        "nar3c",
        "4nare",
        "nar3i",
        "nar4l",
        "n5arm",
        "n4as",
        "nas4c",
        "nas5ti",
        "n2at",
        "na3tal",
        "nato5miz",
        "n2au",
        "nau3se",
        "3naut",
        "nav4e",
        "4n1b4",
        "ncar5",
        "n4ces.",
        "n3cha",
        "n5cheo",
        "n5chil",
        "n3chis",
        "nc1in",
        "nc4it",
        "ncour5a",
        "n1cr",
        "n1cu",
        "n4dai",
        "n5dan",
        "n1de",
        "nd5est.",
        "ndi4b",
        "n5d2if",
        "n1dit",
        "n3diz",
        "n5duc",
        "ndu4r",
        "nd2we",
        "2ne.",
        "n3ear",
        "ne2b",
        "neb3u",
        "ne2c",
        "5neck",
        "2ned",
        "ne4gat",
        "neg5ativ",
        "5nege",
        "ne4la",
        "nel5iz",
        "ne5mi",
        "ne4mo",
        "1nen",
        "4nene",
        "3neo",
        "ne4po",
        "ne2q",
        "n1er",
        "nera5b",
        "n4erar",
        "n2ere",
        "n4er5i",
        "ner4r",
        "1nes",
        "2nes.",
        "4nesp",
        "2nest",
        "4nesw",
        "3netic",
        "ne4v",
        "n5eve",
        "ne4w",
        "n3f",
        "n4gab",
        "n3gel",
        "nge4n4e",
        "n5gere",
        "n3geri",
        "ng5ha",
        "n3gib",
        "ng1in",
        "n5git",
        "n4gla",
        "ngov4",
        "ng5sh",
        "n1gu",
        "n4gum",
        "n2gy",
        "4n1h4",
        "nha4",
        "nhab3",
        "nhe4",
        "3n4ia",
        "ni3an",
        "ni4ap",
        "ni3ba",
        "ni4bl",
        "ni4d",
        "ni5di",
        "ni4er",
        "ni2fi",
        "ni5ficat",
        "n5igr",
        "nik4",
        "n1im",
        "ni3miz",
        "n1in",
        "5nine.",
        "nin4g",
        "ni4o",
        "5nis.",
        "nis4ta",
        "n2it",
        "n4ith",
        "3nitio",
        "n3itor",
        "ni3tr",
        "n1j",
        "4nk2",
        "n5kero",
        "n3ket",
        "nk3in",
        "n1kl",
        "4n1l",
        "n5m",
        "nme4",
        "nmet4",
        "4n1n2",
        "nne4",
        "nni3al",
        "nni4v",
        "nob4l",
        "no3ble",
        "n5ocl",
        "4n3o2d",
        "3noe",
        "4nog",
        "noge4",
        "nois5i",
        "no5l4i",
        "5nologis",
        "3nomic",
        "n5o5miz",
        "no4mo",
        "no3my",
        "no4n",
        "non4ag",
        "non5i",
        "n5oniz",
        "4nop",
        "5nop5o5li",
        "nor5ab",
        "no4rary",
        "4nosc",
        "nos4e",
        "nos5t",
        "no5ta",
        "1nou",
        "3noun",
        "nov3el3",
        "nowl3",
        "n1p4",
        "npi4",
        "npre4c",
        "n1q",
        "n1r",
        "nru4",
        "2n1s2",
        "ns5ab",
        "nsati4",
        "ns4c",
        "n2se",
        "n4s3es",
        "nsid1",
        "nsig4",
        "n2sl",
        "ns3m",
        "n4soc",
        "ns4pe",
        "n5spi",
        "nsta5bl",
        "n1t",
        "nta4b",
        "nter3s",
        "nt2i",
        "n5tib",
        "nti4er",
        "nti2f",
        "n3tine",
        "n4t3ing",
        "nti4p",
        "ntrol5li",
        "nt4s",
        "ntu3me",
        "nu1a",
        "nu4d",
        "nu5en",
        "nuf4fe",
        "n3uin",
        "3nu3it",
        "n4um",
        "nu1me",
        "n5umi",
        "3nu4n",
        "n3uo",
        "nu3tr",
        "n1v2",
        "n1w4",
        "nym4",
        "nyp4",
        "4nz",
        "n3za",
        "4oa",
        "oad3",
        "o5a5les",
        "oard3",
        "oas4e",
        "oast5e",
        "oat5i",
        "ob3a3b",
        "o5bar",
        "obe4l",
        "o1bi",
        "o2bin",
        "ob5ing",
        "o3br",
        "ob3ul",
        "o1ce",
        "och4",
        "o3chet",
        "ocif3",
        "o4cil",
        "o4clam",
        "o4cod",
        "oc3rac",
        "oc5ratiz",
        "ocre3",
        "5ocrit",
        "octor5a",
        "oc3ula",
        "o5cure",
        "od5ded",
        "od3ic",
        "odi3o",
        "o2do4",
        "odor3",
        "od5uct.",
        "od5ucts",
        "o4el",
        "o5eng",
        "o3er",
        "oe4ta",
        "o3ev",
        "o2fi",
        "of5ite",
        "ofit4t",
        "o2g5a5r",
        "og5ativ",
        "o4gato",
        "o1ge",
        "o5gene",
        "o5geo",
        "o4ger",
        "o3gie",
        "1o1gis",
        "og3it",
        "o4gl",
        "o5g2ly",
        "3ogniz",
        "o4gro",
        "ogu5i",
        "1ogy",
        "2ogyn",
        "o1h2",
        "ohab5",
        "oi2",
        "oic3es",
        "oi3der",
        "oiff4",
        "oig4",
        "oi5let",
        "o3ing",
        "oint5er",
        "o5ism",
        "oi5son",
        "oist5en",
        "oi3ter",
        "o5j",
        "2ok",
        "o3ken",
        "ok5ie",
        "o1la",
        "o4lan",
        "olass4",
        "ol2d",
        "old1e",
        "ol3er",
        "o3lesc",
        "o3let",
        "ol4fi",
        "ol2i",
        "o3lia",
        "o3lice",
        "ol5id.",
        "o3li4f",
        "o5lil",
        "ol3ing",
        "o5lio",
        "o5lis.",
        "ol3ish",
        "o5lite",
        "o5litio",
        "o5liv",
        "olli4e",
        "ol5ogiz",
        "olo4r",
        "ol5pl",
        "ol2t",
        "ol3ub",
        "ol3ume",
        "ol3un",
        "o5lus",
        "ol2v",
        "o2ly",
        "om5ah",
        "oma5l",
        "om5atiz",
        "om2be",
        "om4bl",
        "o2me",
        "om3ena",
        "om5erse",
        "o4met",
        "om5etry",
        "o3mia",
        "om3ic.",
        "om3ica",
        "o5mid",
        "om1in",
        "o5mini",
        "5ommend",
        "omo4ge",
        "o4mon",
        "om3pi",
        "ompro5",
        "o2n",
        "on1a",
        "on4ac",
        "o3nan",
        "on1c",
        "3oncil",
        "2ond",
        "on5do",
        "o3nen",
        "on5est",
        "on4gu",
        "on1ic",
        "o3nio",
        "on1is",
        "o5niu",
        "on3key",
        "on4odi",
        "on3omy",
        "on3s",
        "onspi4",
        "onspir5a",
        "onsu4",
        "onten4",
        "on3t4i",
        "ontif5",
        "on5um",
        "onva5",
        "oo2",
        "ood5e",
        "ood5i",
        "oo4k",
        "oop3i",
        "o3ord",
        "oost5",
        "o2pa",
        "ope5d",
        "op1er",
        "3opera",
        "4operag",
        "2oph",
        "o5phan",
        "o5pher",
        "op3ing",
        "o3pit",
        "o5pon",
        "o4posi",
        "o1pr",
        "op1u",
        "opy5",
        "o1q",
        "o1ra",
        "o5ra.",
        "o4r3ag",
        "or5aliz",
        "or5ange",
        "ore5a",
        "o5real",
        "or3ei",
        "ore5sh",
        "or5est.",
        "orew4",
        "or4gu",
        "4o5ria",
        "or3ica",
        "o5ril",
        "or1in",
        "o1rio",
        "or3ity",
        "o3riu",
        "or2mi",
        "orn2e",
        "o5rof",
        "or3oug",
        "or5pe",
        "3orrh",
        "or4se",
        "ors5en",
        "orst4",
        "or3thi",
        "or3thy",
        "or4ty",
        "o5rum",
        "o1ry",
        "os3al",
        "os2c",
        "os4ce",
        "o3scop",
        "4oscopi",
        "o5scr",
        "os4i4e",
        "os5itiv",
        "os3ito",
        "os3ity",
        "osi4u",
        "os4l",
        "o2so",
        "os4pa",
        "os4po",
        "os2ta",
        "o5stati",
        "os5til",
        "os5tit",
        "o4tan",
        "otele4g",
        "ot3er.",
        "ot5ers",
        "o4tes",
        "4oth",
        "oth5esi",
        "oth3i4",
        "ot3ic.",
        "ot5ica",
        "o3tice",
        "o3tif",
        "o3tis",
        "oto5s",
        "ou2",
        "ou3bl",
        "ouch5i",
        "ou5et",
        "ou4l",
        "ounc5er",
        "oun2d",
        "ou5v",
        "ov4en",
        "over4ne",
        "over3s",
        "ov4ert",
        "o3vis",
        "oviti4",
        "o5v4ol",
        "ow3der",
        "ow3el",
        "ow5est",
        "ow1i",
        "own5i",
        "o4wo",
        "oy1a",
        "1pa",
        "pa4ca",
        "pa4ce",
        "pac4t",
        "p4ad",
        "5pagan",
        "p3agat",
        "p4ai",
        "pain4",
        "p4al",
        "pan4a",
        "pan3el",
        "pan4ty",
        "pa3ny",
        "pa1p",
        "pa4pu",
        "para5bl",
        "par5age",
        "par5di",
        "3pare",
        "par5el",
        "p4a4ri",
        "par4is",
        "pa2te",
        "pa5ter",
        "5pathic",
        "pa5thy",
        "pa4tric",
        "pav4",
        "3pay",
        "4p1b",
        "pd4",
        "4pe.",
        "3pe4a",
        "pear4l",
        "pe2c",
        "2p2ed",
        "3pede",
        "3pedi",
        "pedia4",
        "ped4ic",
        "p4ee",
        "pee4d",
        "pek4",
        "pe4la",
        "peli4e",
        "pe4nan",
        "p4enc",
        "pen4th",
        "pe5on",
        "p4era.",
        "pera5bl",
        "p4erag",
        "p4eri",
        "peri5st",
        "per4mal",
        "perme5",
        "p4ern",
        "per3o",
        "per3ti",
        "pe5ru",
        "per1v",
        "pe2t",
        "pe5ten",
        "pe5tiz",
        "4pf",
        "4pg",
        "4ph.",
        "phar5i",
        "phe3no",
        "ph4er",
        "ph4es.",
        "ph1ic",
        "5phie",
        "ph5ing",
        "5phisti",
        "3phiz",
        "ph2l",
        "3phob",
        "3phone",
        "5phoni",
        "pho4r",
        "4phs",
        "ph3t",
        "5phu",
        "1phy",
        "pi3a",
        "pian4",
        "pi4cie",
        "pi4cy",
        "p4id",
        "p5ida",
        "pi3de",
        "5pidi",
        "3piec",
        "pi3en",
        "pi4grap",
        "pi3lo",
        "pi2n",
        "p4in.",
        "pind4",
        "p4ino",
        "3pi1o",
        "pion4",
        "p3ith",
        "pi5tha",
        "pi2tu",
        "2p3k2",
        "1p2l2",
        "3plan",
        "plas5t",
        "pli3a",
        "pli5er",
        "4plig",
        "pli4n",
        "ploi4",
        "plu4m",
        "plum4b",
        "4p1m",
        "2p3n",
        "po4c",
        "5pod.",
        "po5em",
        "po3et5",
        "5po4g",
        "poin2",
        "5point",
        "poly5t",
        "po4ni",
        "po4p",
        "1p4or",
        "po4ry",
        "1pos",
        "pos1s",
        "p4ot",
        "po4ta",
        "5poun",
        "4p1p",
        "ppa5ra",
        "p2pe",
        "p4ped",
        "p5pel",
        "p3pen",
        "p3per",
        "p3pet",
        "ppo5site",
        "pr2",
        "pray4e",
        "5preci",
        "pre5co",
        "pre3em",
        "pref5ac",
        "pre4la",
        "pre3r",
        "p3rese",
        "3press",
        "pre5ten",
        "pre3v",
        "5pri4e",
        "prin4t3",
        "pri4s",
        "pris3o",
        "p3roca",
        "prof5it",
        "pro3l",
        "pros3e",
        "pro1t",
        "2p1s2",
        "p2se",
        "ps4h",
        "p4sib",
        "2p1t",
        "pt5a4b",
        "p2te",
        "p2th",
        "pti3m",
        "ptu4r",
        "p4tw",
        "pub3",
        "pue4",
        "puf4",
        "pul3c",
        "pu4m",
        "pu2n",
        "pur4r",
        "5pus",
        "pu2t",
        "5pute",
        "put3er",
        "pu3tr",
        "put4ted",
        "put4tin",
        "p3w",
        "qu2",
        "qua5v",
        "2que.",
        "3quer",
        "3quet",
        "2rab",
        "ra3bi",
        "rach4e",
        "r5acl",
        "raf5fi",
        "raf4t",
        "r2ai",
        "ra4lo",
        "ram3et",
        "r2ami",
        "rane5o",
        "ran4ge",
        "r4ani",
        "ra5no",
        "rap3er",
        "3raphy",
        "rar5c",
        "rare4",
        "rar5ef",
        "4raril",
        "r2as",
        "ration4",
        "rau4t",
        "ra5vai",
        "rav3el",
        "ra5zie",
        "r1b",
        "r4bab",
        "r4bag",
        "rbi2",
        "rbi4f",
        "r2bin",
        "r5bine",
        "rb5ing.",
        "rb4o",
        "r1c",
        "r2ce",
        "rcen4",
        "r3cha",
        "rch4er",
        "r4ci4b",
        "rc4it",
        "rcum3",
        "r4dal",
        "rd2i",
        "rdi4a",
        "rdi4er",
        "rdin4",
        "rd3ing",
        "2re.",
        "re1al",
        "re3an",
        "re5arr",
        "5reav",
        "re4aw",
        "r5ebrat",
        "rec5oll",
        "rec5ompe",
        "re4cre",
        "2r2ed",
        "re1de",
        "re3dis",
        "red5it",
        "re4fac",
        "re2fe",
        "re5fer.",
        "re3fi",
        "re4fy",
        "reg3is",
        "re5it",
        "re1li",
        "re5lu",
        "r4en4ta",
        "ren4te",
        "re1o",
        "re5pin",
        "re4posi",
        "re1pu",
        "r1er4",
        "r4eri",
        "rero4",
        "re5ru",
        "r4es.",
        "re4spi",
        "ress5ib",
        "res2t",
        "re5stal",
        "re3str",
        "re4ter",
        "re4ti4z",
        "re3tri",
        "reu2",
        "re5uti",
        "rev2",
        "re4val",
        "rev3el",
        "r5ev5er.",
        "re5vers",
        "re5vert",
        "re5vil",
        "rev5olu",
        "re4wh",
        "r1f",
        "rfu4",
        "r4fy",
        "rg2",
        "rg3er",
        "r3get",
        "r3gic",
        "rgi4n",
        "rg3ing",
        "r5gis",
        "r5git",
        "r1gl",
        "rgo4n",
        "r3gu",
        "rh4",
        "4rh.",
        "4rhal",
        "ri3a",
        "ria4b",
        "ri4ag",
        "r4ib",
        "rib3a",
        "ric5as",
        "r4ice",
        "4rici",
        "5ricid",
        "ri4cie",
        "r4ico",
        "rid5er",
        "ri3enc",
        "ri3ent",
        "ri1er",
        "ri5et",
        "rig5an",
        "5rigi",
        "ril3iz",
        "5riman",
        "rim5i",
        "3rimo",
        "rim4pe",
        "r2ina",
        "5rina.",
        "rin4d",
        "rin4e",
        "rin4g",
        "ri1o",
        "5riph",
        "riph5e",
        "ri2pl",
        "rip5lic",
        "r4iq",
        "r2is",
        "r4is.",
        "ris4c",
        "r3ish",
        "ris4p",
        "ri3ta3b",
        "r5ited.",
        "rit5er.",
        "rit5ers",
        "rit3ic",
        "ri2tu",
        "rit5ur",
        "riv5el",
        "riv3et",
        "riv3i",
        "r3j",
        "r3ket",
        "rk4le",
        "rk4lin",
        "r1l",
        "rle4",
        "r2led",
        "r4lig",
        "r4lis",
        "rl5ish",
        "r3lo4",
        "r1m",
        "rma5c",
        "r2me",
        "r3men",
        "rm5ers",
        "rm3ing",
        "r4ming.",
        "r4mio",
        "r3mit",
        "r4my",
        "r4nar",
        "r3nel",
        "r4ner",
        "r5net",
        "r3ney",
        "r5nic",
        "r1nis4",
        "r3nit",
        "r3niv",
        "rno4",
        "r4nou",
        "r3nu",
        "rob3l",
        "r2oc",
        "ro3cr",
        "ro4e",
        "ro1fe",
        "ro5fil",
        "rok2",
        "ro5ker",
        "5role.",
        "rom5ete",
        "rom4i",
        "rom4p",
        "ron4al",
        "ron4e",
        "ro5n4is",
        "ron4ta",
        "1room",
        "5root",
        "ro3pel",
        "rop3ic",
        "ror3i",
        "ro5ro",
        "ros5per",
        "ros4s",
        "ro4the",
        "ro4ty",
        "ro4va",
        "rov5el",
        "rox5",
        "r1p",
        "r4pea",
        "r5pent",
        "rp5er.",
        "r3pet",
        "rp4h4",
        "rp3ing",
        "r3po",
        "r1r4",
        "rre4c",
        "rre4f",
        "r4reo",
        "rre4st",
        "rri4o",
        "rri4v",
        "rron4",
        "rros4",
        "rrys4",
        "4rs2",
        "r1sa",
        "rsa5ti",
        "rs4c",
        "r2se",
        "r3sec",
        "rse4cr",
        "rs5er.",
        "rs3es",
        "rse5v2",
        "r1sh",
        "r5sha",
        "r1si",
        "r4si4b",
        "rson3",
        "r1sp",
        "r5sw",
        "rtach4",
        "r4tag",
        "r3teb",
        "rten4d",
        "rte5o",
        "r1ti",
        "rt5ib",
        "rti4d",
        "r4tier",
        "r3tig",
        "rtil3i",
        "rtil4l",
        "r4tily",
        "r4tist",
        "r4tiv",
        "r3tri",
        "rtroph4",
        "rt4sh",
        "ru3a",
        "ru3e4l",
        "ru3en",
        "ru4gl",
        "ru3in",
        "rum3pl",
        "ru2n",
        "runk5",
        "run4ty",
        "r5usc",
        "ruti5n",
        "rv4e",
        "rvel4i",
        "r3ven",
        "rv5er.",
        "r5vest",
        "r3vey",
        "r3vic",
        "rvi4v",
        "r3vo",
        "r1w",
        "ry4c",
        "5rynge",
        "ry3t",
        "sa2",
        "2s1ab",
        "5sack",
        "sac3ri",
        "s3act",
        "5sai",
        "salar4",
        "sal4m",
        "sa5lo",
        "sal4t",
        "3sanc",
        "san4de",
        "s1ap",
        "sa5ta",
        "5sa3tio",
        "sat3u",
        "sau4",
        "sa5vor",
        "5saw",
        "4s5b",
        "scan4t5",
        "sca4p",
        "scav5",
        "s4ced",
        "4scei",
        "s4ces",
        "sch2",
        "s4cho",
        "3s4cie",
        "5scin4d",
        "scle5",
        "s4cli",
        "scof4",
        "4scopy",
        "scour5a",
        "s1cu",
        "4s5d",
        "4se.",
        "se4a",
        "seas4",
        "sea5w",
        "se2c3o",
        "3sect",
        "4s4ed",
        "se4d4e",
        "s5edl",
        "se2g",
        "seg3r",
        "5sei",
        "se1le",
        "5self",
        "5selv",
        "4seme",
        "se4mol",
        "sen5at",
        "4senc",
        "sen4d",
        "s5ened",
        "sen5g",
        "s5enin",
        "4sentd",
        "4sentl",
        "sep3a3",
        "4s1er.",
        "s4erl",
        "ser4o",
        "4servo",
        "s1e4s",
        "se5sh",
        "ses5t",
        "5se5um",
        "5sev",
        "sev3en",
        "sew4i",
        "5sex",
        "4s3f",
        "2s3g",
        "s2h",
        "2sh.",
        "sh1er",
        "5shev",
        "sh1in",
        "sh3io",
        "3ship",
        "shiv5",
        "sho4",
        "sh5old",
        "shon3",
        "shor4",
        "short5",
        "4shw",
        "si1b",
        "s5icc",
        "3side.",
        "5sides",
        "5sidi",
        "si5diz",
        "4signa",
        "sil4e",
        "4sily",
        "2s1in",
        "s2ina",
        "5sine.",
        "s3ing",
        "1sio",
        "5sion",
        "sion5a",
        "si2r",
        "sir5a",
        "1sis",
        "3sitio",
        "5siu",
        "1siv",
        "5siz",
        "sk2",
        "4ske",
        "s3ket",
        "sk5ine",
        "sk5ing",
        "s1l2",
        "s3lat",
        "s2le",
        "slith5",
        "2s1m",
        "s3ma",
        "small3",
        "sman3",
        "smel4",
        "s5men",
        "5smith",
        "smol5d4",
        "s1n4",
        "1so",
        "so4ce",
        "soft3",
        "so4lab",
        "sol3d2",
        "so3lic",
        "5solv",
        "3som",
        "3s4on.",
        "sona4",
        "son4g",
        "s4op",
        "5sophic",
        "s5ophiz",
        "s5ophy",
        "sor5c",
        "sor5d",
        "4sov",
        "so5vi",
        "2spa",
        "5spai",
        "spa4n",
        "spen4d",
        "2s5peo",
        "2sper",
        "s2phe",
        "3spher",
        "spho5",
        "spil4",
        "sp5ing",
        "4spio",
        "s4ply",
        "s4pon",
        "spor4",
        "4spot",
        "squal4l",
        "s1r",
        "2ss",
        "s1sa",
        "ssas3",
        "s2s5c",
        "s3sel",
        "s5seng",
        "s4ses.",
        "s5set",
        "s1si",
        "s4sie",
        "ssi4er",
        "ss5ily",
        "s4sl",
        "ss4li",
        "s4sn",
        "sspend4",
        "ss2t",
        "ssur5a",
        "ss5w",
        "2st.",
        "s2tag",
        "s2tal",
        "stam4i",
        "5stand",
        "s4ta4p",
        "5stat.",
        "s4ted",
        "stern5i",
        "s5tero",
        "ste2w",
        "stew5a",
        "s3the",
        "st2i",
        "s4ti.",
        "s5tia",
        "s1tic",
        "5stick",
        "s4tie",
        "s3tif",
        "st3ing",
        "5stir",
        "s1tle",
        "5stock",
        "stom3a",
        "5stone",
        "s4top",
        "3store",
        "st4r",
        "s4trad",
        "5stratu",
        "s4tray",
        "s4trid",
        "4stry",
        "4st3w",
        "s2ty",
        "1su",
        "su1al",
        "su4b3",
        "su2g3",
        "su5is",
        "suit3",
        "s4ul",
        "su2m",
        "sum3i",
        "su2n",
        "su2r",
        "4sv",
        "sw2",
        "4swo",
        "s4y",
        "4syc",
        "3syl",
        "syn5o",
        "sy5rin",
        "1ta",
        "3ta.",
        "2tab",
        "ta5bles",
        "5taboliz",
        "4taci",
        "ta5do",
        "4taf4",
        "tai5lo",
        "ta2l",
        "ta5la",
        "tal5en",
        "tal3i",
        "4talk",
        "tal4lis",
        "ta5log",
        "ta5mo",
        "tan4de",
        "tanta3",
        "ta5per",
        "ta5pl",
        "tar4a",
        "4tarc",
        "4tare",
        "ta3riz",
        "tas4e",
        "ta5sy",
        "4tatic",
        "ta4tur",
        "taun4",
        "tav4",
        "2taw",
        "tax4is",
        "2t1b",
        "4tc",
        "t4ch",
        "tch5et",
        "4t1d",
        "4te.",
        "tead4i",
        "4teat",
        "tece4",
        "5tect",
        "2t1ed",
        "te5di",
        "1tee",
        "teg4",
        "te5ger",
        "te5gi",
        "3tel.",
        "teli4",
        "5tels",
        "te2ma2",
        "tem3at",
        "3tenan",
        "3tenc",
        "3tend",
        "4tenes",
        "1tent",
        "ten4tag",
        "1teo",
        "te4p",
        "te5pe",
        "ter3c",
        "5ter3d",
        "1teri",
        "ter5ies",
        "ter3is",
        "teri5za",
        "5ternit",
        "ter5v",
        "4tes.",
        "4tess",
        "t3ess.",
        "teth5e",
        "3teu",
        "3tex",
        "4tey",
        "2t1f",
        "4t1g",
        "2th.",
        "than4",
        "th2e",
        "4thea",
        "th3eas",
        "the5at",
        "the3is",
        "3thet",
        "th5ic.",
        "th5ica",
        "4thil",
        "5think",
        "4thl",
        "th5ode",
        "5thodic",
        "4thoo",
        "thor5it",
        "tho5riz",
        "2ths",
        "1tia",
        "ti4ab",
        "ti4ato",
        "2ti2b",
        "4tick",
        "t4ico",
        "t4ic1u",
        "5tidi",
        "3tien",
        "tif2",
        "ti5fy",
        "2tig",
        "5tigu",
        "till5in",
        "1tim",
        "4timp",
        "tim5ul",
        "2t1in",
        "t2ina",
        "3tine.",
        "3tini",
        "1tio",
        "ti5oc",
        "tion5ee",
        "5tiq",
        "ti3sa",
        "3tise",
        "tis4m",
        "ti5so",
        "tis4p",
        "5tistica",
        "ti3tl",
        "ti4u",
        "1tiv",
        "tiv4a",
        "1tiz",
        "ti3za",
        "ti3zen",
        "2tl",
        "t5la",
        "tlan4",
        "3tle.",
        "3tled",
        "3tles.",
        "t5let.",
        "t5lo",
        "4t1m",
        "tme4",
        "2t1n2",
        "1to",
        "to3b",
        "to5crat",
        "4todo",
        "2tof",
        "to2gr",
        "to5ic",
        "to2ma",
        "tom4b",
        "to3my",
        "ton4ali",
        "to3nat",
        "4tono",
        "4tony",
        "to2ra",
        "to3rie",
        "tor5iz",
        "tos2",
        "5tour",
        "4tout",
        "to3war",
        "4t1p",
        "1tra",
        "tra3b",
        "tra5ch",
        "traci4",
        "trac4it",
        "trac4te",
        "tras4",
        "tra5ven",
        "trav5es5",
        "tre5f",
        "tre4m",
        "trem5i",
        "5tria",
        "tri5ces",
        "5tricia",
        "4trics",
        "2trim",
        "tri4v",
        "tro5mi",
        "tron5i",
        "4trony",
        "tro5phe",
        "tro3sp",
        "tro3v",
        "tru5i",
        "trus4",
        "4t1s2",
        "t4sc",
        "tsh4",
        "t4sw",
        "4t3t2",
        "t4tes",
        "t5to",
        "ttu4",
        "1tu",
        "tu1a",
        "tu3ar",
        "tu4bi",
        "tud2",
        "4tue",
        "4tuf4",
        "5tu3i",
        "3tum",
        "tu4nis",
        "2t3up.",
        "3ture",
        "5turi",
        "tur3is",
        "tur5o",
        "tu5ry",
        "3tus",
        "4tv",
        "tw4",
        "4t1wa",
        "twis4",
        "4two",
        "1ty",
        "4tya",
        "2tyl",
        "type3",
        "ty5ph",
        "4tz",
        "tz4e",
        "4uab",
        "uac4",
        "ua5na",
        "uan4i",
        "uar5ant",
        "uar2d",
        "uar3i",
        "uar3t",
        "u1at",
        "uav4",
        "ub4e",
        "u4bel",
        "u3ber",
        "u4bero",
        "u1b4i",
        "u4b5ing",
        "u3ble.",
        "u3ca",
        "uci4b",
        "uc4it",
        "ucle3",
        "u3cr",
        "u3cu",
        "u4cy",
        "ud5d",
        "ud3er",
        "ud5est",
        "udev4",
        "u1dic",
        "ud3ied",
        "ud3ies",
        "ud5is",
        "u5dit",
        "u4don",
        "ud4si",
        "u4du",
        "u4ene",
        "uens4",
        "uen4te",
        "uer4il",
        "3ufa",
        "u3fl",
        "ugh3en",
        "ug5in",
        "2ui2",
        "uil5iz",
        "ui4n",
        "u1ing",
        "uir4m",
        "uita4",
        "uiv3",
        "uiv4er.",
        "u5j",
        "4uk",
        "u1la",
        "ula5b",
        "u5lati",
        "ulch4",
        "5ulche",
        "ul3der",
        "ul4e",
        "u1len",
        "ul4gi",
        "ul2i",
        "u5lia",
        "ul3ing",
        "ul5ish",
        "ul4lar",
        "ul4li4b",
        "ul4lis",
        "4ul3m",
        "u1l4o",
        "4uls",
        "uls5es",
        "ul1ti",
        "ultra3",
        "4ultu",
        "u3lu",
        "ul5ul",
        "ul5v",
        "um5ab",
        "um4bi",
        "um4bly",
        "u1mi",
        "u4m3ing",
        "umor5o",
        "um2p",
        "unat4",
        "u2ne",
        "un4er",
        "u1ni",
        "un4im",
        "u2nin",
        "un5ish",
        "uni3v",
        "un3s4",
        "un4sw",
        "unt3ab",
        "un4ter.",
        "un4tes",
        "unu4",
        "un5y",
        "un5z",
        "u4ors",
        "u5os",
        "u1ou",
        "u1pe",
        "uper5s",
        "u5pia",
        "up3ing",
        "u3pl",
        "up3p",
        "upport5",
        "upt5ib",
        "uptu4",
        "u1ra",
        "4ura.",
        "u4rag",
        "u4ras",
        "ur4be",
        "urc4",
        "ur1d",
        "ure5at",
        "ur4fer",
        "ur4fr",
        "u3rif",
        "uri4fic",
        "ur1in",
        "u3rio",
        "u1rit",
        "ur3iz",
        "ur2l",
        "url5ing.",
        "ur4no",
        "uros4",
        "ur4pe",
        "ur4pi",
        "urs5er",
        "ur5tes",
        "ur3the",
        "urti4",
        "ur4tie",
        "u3ru",
        "2us",
        "u5sad",
        "u5san",
        "us4ap",
        "usc2",
        "us3ci",
        "use5a",
        "u5sia",
        "u3sic",
        "us4lin",
        "us1p",
        "us5sl",
        "us5tere",
        "us1tr",
        "u2su",
        "usur4",
        "uta4b",
        "u3tat",
        "4ute.",
        "4utel",
        "4uten",
        "uten4i",
        "4u1t2i",
        "uti5liz",
        "u3tine",
        "ut3ing",
        "ution5a",
        "u4tis",
        "5u5tiz",
        "u4t1l",
        "ut5of",
        "uto5g",
        "uto5matic",
        "u5ton",
        "u4tou",
        "uts4",
        "u3u",
        "uu4m",
        "u1v2",
        "uxu3",
        "uz4e",
        "1va",
        "5va.",
        "2v1a4b",
        "vac5il",
        "vac3u",
        "vag4",
        "va4ge",
        "va5lie",
        "val5o",
        "val1u",
        "va5mo",
        "va5niz",
        "va5pi",
        "var5ied",
        "3vat",
        "4ve.",
        "4ved",
        "veg3",
        "v3el.",
        "vel3li",
        "ve4lo",
        "v4ely",
        "ven3om",
        "v5enue",
        "v4erd",
        "5vere.",
        "v4erel",
        "v3eren",
        "ver5enc",
        "v4eres",
        "ver3ie",
        "vermi4n",
        "3verse",
        "ver3th",
        "v4e2s",
        "4ves.",
        "ves4te",
        "ve4te",
        "vet3er",
        "ve4ty",
        "vi5ali",
        "5vian",
        "5vide.",
        "5vided",
        "4v3iden",
        "5vides",
        "5vidi",
        "v3if",
        "vi5gn",
        "vik4",
        "2vil",
        "5vilit",
        "v3i3liz",
        "v1in",
        "4vi4na",
        "v2inc",
        "vin5d",
        "4ving",
        "vio3l",
        "v3io4r",
        "vi1ou",
        "vi4p",
        "vi5ro",
        "vis3it",
        "vi3so",
        "vi3su",
        "4viti",
        "vit3r",
        "4vity",
        "3viv",
        "5vo.",
        "voi4",
        "3vok",
        "vo4la",
        "v5ole",
        "5volt",
        "3volv",
        "vom5i",
        "vor5ab",
        "vori4",
        "vo4ry",
        "vo4ta",
        "4votee",
        "4vv4",
        "v4y",
        "w5abl",
        "2wac",
        "wa5ger",
        "wag5o",
        "wait5",
        "w5al.",
        "wam4",
        "war4t",
        "was4t",
        "wa1te",
        "wa5ver",
        "w1b",
        "wea5rie",
        "weath3",
        "wed4n",
        "weet3",
        "wee5v",
        "wel4l",
        "w1er",
        "west3",
        "w3ev",
        "whi4",
        "wi2",
        "wil2",
        "will5in",
        "win4de",
        "win4g",
        "wir4",
        "3wise",
        "with3",
        "wiz5",
        "w4k",
        "wl4es",
        "wl3in",
        "w4no",
        "1wo2",
        "wom1",
        "wo5ven",
        "w5p",
        "wra4",
        "wri4",
        "writa4",
        "w3sh",
        "ws4l",
        "ws4pe",
        "w5s4t",
        "4wt",
        "wy4",
        "x1a",
        "xac5e",
        "x4ago",
        "xam3",
        "x4ap",
        "xas5",
        "x3c2",
        "x1e",
        "xe4cuto",
        "x2ed",
        "xer4i",
        "xe5ro",
        "x1h",
        "xhi2",
        "xhil5",
        "xhu4",
        "x3i",
        "xi5a",
        "xi5c",
        "xi5di",
        "x4ime",
        "xi5miz",
        "x3o",
        "x4ob",
        "x3p",
        "xpan4d",
        "xpecto5",
        "xpe3d",
        "x1t2",
        "x3ti",
        "x1u",
        "xu3a",
        "xx4",
        "y5ac",
        "3yar4",
        "y5at",
        "y1b",
        "y1c",
        "y2ce",
        "yc5er",
        "y3ch",
        "ych4e",
        "ycom4",
        "ycot4",
        "y1d",
        "y5ee",
        "y1er",
        "y4erf",
        "yes4",
        "ye4t",
        "y5gi",
        "4y3h",
        "y1i",
        "y3la",
        "ylla5bl",
        "y3lo",
        "y5lu",
        "ymbol5",
        "yme4",
        "ympa3",
        "yn3chr",
        "yn5d",
        "yn5g",
        "yn5ic",
        "5ynx",
        "y1o4",
        "yo5d",
        "y4o5g",
        "yom4",
        "yo5net",
        "y4ons",
        "y4os",
        "y4ped",
        "yper5",
        "yp3i",
        "y3po",
        "y4poc",
        "yp2ta",
        "y5pu",
        "yra5m",
        "yr5ia",
        "y3ro",
        "yr4r",
        "ys4c",
        "y3s2e",
        "ys3ica",
        "ys3io",
        "3ysis",
        "y4so",
        "yss4",
        "ys1t",
        "ys3ta",
        "ysur4",
        "y3thin",
        "yt3ic",
        "y1w",
        "za1",
        "z5a2b",
        "zar2",
        "4zb",
        "2ze",
        "ze4n",
        "ze4p",
        "z1er",
        "ze3ro",
        "zet4",
        "2z1i",
        "z4il",
        "z4is",
        "5zl",
        "4zm",
        "1zo",
        "zo4m",
        "zo5ol",
        "zte4",
        "4z1z2",
        "z4zy",
        // hyphen.tex patterns end here, and additional patterns begin:
        ".con5gr",
        ".de5riva",
        ".dri5v4",
        ".eth1y6l1",
        ".eu4ler",
        ".ev2",
        ".ever5si5b",
        ".ga4s1om1",
        ".ge4ome",
        ".ge5ot1",
        ".he3mo1",
        ".he3p6a",
        ".he3roe",
        ".in5u2t",
        ".kil2n3i",
        ".ko6r1te1",
        ".le6ices",
        ".me4ga1l",
        ".met4ala",
        ".mim5i2c1",
        ".mi1s4ers",
        ".ne6o3f",
        ".noe1th",
        ".non1e2m",
        ".poly1s",
        ".post1am",
        ".pre1am",
        ".rav5en1o",
        ".semi5",
        ".sem4ic",
        ".semid6",
        ".semip4",
        ".semir4",
        ".sem6is4",
        ".semiv4",
        ".sph6in1",
        ".spin1o",
        ".ta5pes1tr",
        ".te3legr",
        ".to6pog",
        ".to2q",
        ".un3at5t",
        ".un5err5",
        ".vi2c3ar",
        ".we2b1l",
        ".re1e4c",
        "a5bolic",
        "a2cabl",
        "af6fish",
        "am1en3ta5b",
        "anal6ys",
        "ano5a2c",
        "ans5gr",
        "ans3v",
        "anti1d",
        "an3ti1n2",
        "anti1re",
        "a4pe5able",
        "ar3che5t",
        "ar2range",
        "as5ymptot",
        "ath3er1o1s",
        "at6tes.",
        "augh4tl",
        "au5li5f",
        "av3iou",
        "back2er.",
        "ba6r1onie",
        "ba1thy",
        "bbi4t",
        "be2vie",
        "bi5d2if",
        "bil2lab",
        "bio5m",
        "bi1orb",
        "bio1rh",
        "b1i3tive",
        "blan2d1",
        "blin2d1",
        "blon2d2",
        "bor1no5",
        "bo2t1u1l",
        "brus4q",
        "bus6i2er",
        "bus6i2es",
        "buss4ing",
        "but2ed.",
        "but4ted",
        "cad5e1m",
        "cat1a1s2",
        "4chs.",
        "chs3hu",
        "chie5vo",
        "cig3a3r",
        "cin2q",
        "cle4ar",
        "co6ph1o3n",
        "cous2ti",
        "cri3tie",
        "croc1o1d",
        "cro5e2co",
        "c2tro3me6c",
        "1cu2r1ance",
        "2d3alone",
        "data1b",
        "dd5a5b",
        "d2d5ib",
        "de4als.",
        "de5clar1",
        "de2c5lina",
        "de3fin3iti",
        "de2mos",
        "des3ic",
        "de2tic",
        "dic1aid",
        "dif5fra",
        "3di1methy",
        "di2ren",
        "di2rer",
        "2d1lead",
        "2d1li2e",
        "3do5word",
        "dren1a5l",
        "drif2t1a",
        "d1ri3pleg5",
        "drom3e5d",
        "d3tab",
        "du2al.",
        "du1op1o1l",
        "ea4n3ies",
        "e3chas",
        "edg1l",
        "ed1uling",
        "eli2t1is",
        "e1loa",
        "en1dix",
        "eo3grap",
        "1e6p3i3neph1",
        "e2r3i4an.",
        "e3spac6i",
        "eth1y6l1ene",
        "5eu2clid1",
        "feb1rua",
        "fermi1o",
        "3fich",
        "fit5ted.",
        "fla1g6el",
        "flow2er.",
        "3fluor",
        "gen2cy.",
        "ge3o1d",
        "ght1we",
        "g1lead",
        "get2ic.",
        "4g1lish",
        "5glo5bin",
        "1g2nac",
        "gnet1ism",
        "gno5mo",
        "g2n1or.",
        "g2noresp",
        "2g1o4n3i1za",
        "graph5er.",
        "griev1",
        "g1utan",
        "hair1s",
        "ha2p3ar5r",
        "hatch1",
        "hex2a3",
        "hite3sid",
        "h3i5pel1a4",
        "hnau3z",
        "ho6r1ic.",
        "h2t1eou",
        "hypo1tha",
        "id4ios",
        "ifac1et",
        "ign4it",
        "ignit1er",
        "i4jk",
        "im3ped3a",
        "infra1s2",
        "i5nitely.",
        "irre6v3oc",
        "i1tesima",
        "ith5i2l",
        "itin5er5ar",
        "janu3a",
        "japan1e2s",
        "je1re1m",
        "1ke6ling",
        "1ki5netic",
        "1kovian",
        "k3sha",
        "la4c3i5e",
        "lai6n3ess",
        "lar5ce1n",
        "l3chai",
        "l3chil6d1",
        "lead6er.",
        "lea4s1a",
        "1lec3ta6b",
        "le3g6en2dre",
        "1le1noid",
        "lith1o5g",
        "ll1fl",
        "l2l3ish",
        "l5mo3nell",
        "lo1bot1o1",
        "lo2ges.",
        "load4ed.",
        "load6er.",
        "l3tea",
        "lth5i2ly",
        "lue1p",
        "1lunk3er",
        "1lum5bia.",
        "3lyg1a1mi",
        "ly5styr",
        "ma1la1p",
        "m2an.",
        "man3u1sc",
        "mar1gin1",
        "medi2c",
        "med3i3cin",
        "medio6c1",
        "me3gran3",
        "m2en.",
        "3mi3da5b",
        "3milita",
        "mil2l1ag",
        "mil5li5li",
        "mi6n3is.",
        "mi1n2ut1er",
        "mi1n2ut1est",
        "m3ma1b",
        "5maph1ro1",
        "5moc1ra1t",
        "mo5e2las",
        "mol1e5c",
        "mon4ey1l",
        "mono3ch",
        "mo4no1en",
        "moro6n5is",
        "mono1s6",
        "moth4et2",
        "m1ou3sin",
        "m5shack2",
        "mu2dro",
        "mul2ti5u",
        "n3ar4chs.",
        "n3ch2es1t",
        "ne3back",
        "2ne1ski",
        "n1dieck",
        "nd3thr",
        "nfi6n3ites",
        "4n5i4an.",
        "nge5nes",
        "ng1ho",
        "ng1spr",
        "nk3rup",
        "n5less",
        "5noc3er1os",
        "nom1a6l",
        "nom5e1no",
        "n1o1mist",
        "non1eq",
        "non1i4so",
        "5nop1oly.",
        "no1vemb",
        "ns5ceiv",
        "ns4moo",
        "ntre1p",
        "obli2g1",
        "o3chas",
        "odel3li",
        "odit1ic",
        "oerst2",
        "oke1st",
        "o3les3ter",
        "oli3gop1o1",
        "o1lo3n4om",
        "o3mecha6",
        "onom1ic",
        "o3norma",
        "o3no2t1o3n",
        "o3nou",
        "op1ism.",
        "or4tho3ni4t",
        "orth1ri",
        "or5tively",
        "o4s3pher",
        "o5test1er",
        "o5tes3tor",
        "oth3e1o1s",
        "ou3ba3do",
        "o6v3i4an.",
        "oxi6d1ic",
        "pal6mat",
        "parag6ra4",
        "par4a1le",
        "param4",
        "para3me",
        "pee2v1",
        "phi2l3ant",
        "phi5lat1e3l",
        "pi2c1a3d",
        "pli2c1ab",
        "pli5nar",
        "poin3ca",
        "1pole.",
        "poly1e",
        "po3lyph1ono",
        "1prema3c",
        "pre1neu",
        "pres2pli",
        "pro2cess",
        "proc3i3ty.",
        "pro2g1e",
        "3pseu2d",
        "pseu3d6o3d2",
        "pseu3d6o3f2",
        "pto3mat4",
        "p5trol3",
        "pu5bes5c",
        "quain2t1e",
        "qu6a3si3",
        "quasir6",
        "quasis6",
        "quin5tes5s",
        "qui3v4ar",
        "r1abolic",
        "3rab1o1loi",
        "ra3chu",
        "r3a3dig",
        "radi1o6g",
        "r2amen",
        "3ra4m5e1triz",
        "ra3mou",
        "ra5n2has",
        "ra1or",
        "r3bin1ge",
        "re2c3i1pr",
        "rec5t6ang",
        "re4t1ribu",
        "r3ial.",
        "riv1o1l",
        "6rk.",
        "rk1ho",
        "r1krau",
        "6rks.",
        "r5le5qu",
        "ro1bot1",
        "ro5e2las",
        "ro5epide1",
        "ro3mesh",
        "ro1tron",
        "r3pau5li",
        "rse1rad1i",
        "r1thou",
        "r1treu",
        "r1veil",
        "rz1sc",
        "sales3c",
        "sales5w",
        "5sa3par5il",
        "sca6p1er",
        "sca2t1ol",
        "s4chitz",
        "schro1ding1",
        "1sci2utt",
        "scrap4er.",
        "scy4th1",
        "sem1a1ph",
        "se3mes1t",
        "se1mi6t5ic",
        "sep3temb",
        "shoe1st",
        "sid2ed.",
        "side5st",
        "side5sw",
        "si5resid",
        "sky1sc",
        "3slova1kia",
        "3s2og1a1my",
        "so2lute",
        "3s2pace",
        "1s2pacin",
        "spe3cio",
        "spher1o",
        "spi2c1il",
        "spokes5w",
        "sports3c",
        "sports3w",
        "s3qui3to",
        "s2s1a3chu1",
        "ss3hat",
        "s2s3i4an.",
        "s5sign5a3b",
        "1s2tamp",
        "s2t1ant5shi",
        "star3tli",
        "sta1ti",
        "st5b",
        "1stor1ab",
        "strat1a1g",
        "strib5ut",
        "st5scr",
        "stu1pi4d1",
        "styl1is",
        "su2per1e6",
        "1sync",
        "1syth3i2",
        "swimm6",
        "5tab1o1lism",
        "ta3gon.",
        "talk1a5",
        "t1a1min",
        "t6ap6ath",
        "5tar2rh",
        "tch1c",
        "tch3i1er",
        "t1cr",
        "teach4er.",
        "tele2g",
        "tele1r6o",
        "3ter1gei",
        "ter2ic.",
        "t3ess2es",
        "tha4l1am",
        "tho3don",
        "th1o5gen1i",
        "tho1k2er",
        "thy4l1an",
        "thy3sc",
        "2t3i4an.",
        "ti2n3o1m",
        "t1li2er",
        "tolo2gy",
        "tot3ic",
        "trai3tor1",
        "tra1vers",
        "travers3a3b",
        "treach1e",
        "tr4ial.",
        "3tro1le1um",
        "trof4ic.",
        "tro3fit",
        "tro1p2is",
        "3trop1o5les",
        "3trop1o5lis",
        "t1ro1pol3it",
        "tsch3ie",
        "ttrib1ut1",
        "turn3ar",
        "t1wh",
        "ty2p5al",
        "ua3drati",
        "uad1ratu",
        "u5do3ny",
        "uea1m",
        "u2r1al.",
        "uri4al.",
        "us2er.",
        "v1ativ",
        "v1oir5du1",
        "va6guer",
        "vaude3v",
        "1verely.",
        "v1er1eig",
        "ves1tite",
        "vi1vip3a3r",
        "voice1p",
        "waste3w6a2",
        "wave1g4",
        "w3c",
        "week1n",
        "wide5sp",
        "wo4k1en",
        "wrap3aro",
        "writ6er.",
        "x1q",
        "xquis3",
        "y5che3d",
        "ym5e5try",
        "y1stro",
        "yes5ter1y",
        "z3ian.",
        "z3o1phr",
        "z2z3w",
        // end of additional patterns.
        ""
    ];
    // DEK's hyphenation exception list, from hyphen.tex; not changed.
    var hyphenation = [
        "as-so-ciate",
        "as-so-ciates",
        "dec-li-na-tion",
        "oblig-a-tory",
        "phil-an-thropic",
        "present",
        "presents",
        "project",
        "projects",
        "reci-procity",
        "re-cog-ni-zance",
        "ref-or-ma-tion",
        "ret-ri-bu-tion",
        "ta-ble",
        ""
    ];
    return {
        patterns: patterns,
        exceptions: hyphenation
    };
});

},{}],"iXAvI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = ()=>{
    // https://mths.be/emoji
    return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC08\uDC26](?:\u200D\u2B1B)?|[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7Um3C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>resolveImage);
var _regeneratorRuntime = require("@babel/runtime/helpers/regeneratorRuntime");
var _regeneratorRuntimeDefault = parcelHelpers.interopDefault(_regeneratorRuntime);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _crossFetch = require("cross-fetch");
var _crossFetchDefault = parcelHelpers.interopDefault(_crossFetch);
var _pngJs = require("@react-pdf/png-js");
var _pngJsDefault = parcelHelpers.interopDefault(_pngJs);
var global = arguments[3];
var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var inited = false;
function init() {
    inited = true;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(var i = 0, len = code.length; i < len; ++i){
        lookup[i] = code[i];
        revLookup[code.charCodeAt(i)] = i;
    }
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
}
function toByteArray(b64) {
    if (!inited) init();
    var i, j, l, tmp, placeHolders, arr;
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // the number of equal signs (place holders)
    // if there are two placeholders, than the two characters before it
    // represent one byte
    // if there is only one, then the three characters before it represent 2 bytes
    // this is just a cheap hack to not do indexOf twice
    placeHolders = b64[len - 2] === "=" ? 2 : b64[len - 1] === "=" ? 1 : 0;
    // base64 is 4/3 + up to two characters of the original data
    arr = new Arr(len * 3 / 4 - placeHolders);
    // if there are placeholders, only get up to the last complete 4 chars
    l = placeHolders > 0 ? len - 4 : len;
    var L = 0;
    for(i = 0, j = 0; i < l; i += 4, j += 3){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[L++] = tmp >> 16 & 0xFF;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    if (placeHolders === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[L++] = tmp & 0xFF;
    } else if (placeHolders === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[L++] = tmp >> 8 & 0xFF;
        arr[L++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
        output.push(tripletToBase64(tmp));
    }
    return output.join("");
}
function fromByteArray(uint8) {
    if (!inited) init();
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var output = "";
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        output += lookup[tmp >> 2];
        output += lookup[tmp << 4 & 0x3F];
        output += "==";
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        output += lookup[tmp >> 10];
        output += lookup[tmp >> 4 & 0x3F];
        output += lookup[tmp << 2 & 0x3F];
        output += "=";
    }
    parts.push(output);
    return parts.join("");
}
function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
}
function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
}
var toString = {}.toString;
var isArray = Array.isArray || function(arr) {
    return toString.call(arr) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ var INSPECT_MAX_BYTES = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ Buffer.TYPED_ARRAY_SUPPORT = global$1.TYPED_ARRAY_SUPPORT !== undefined ? global$1.TYPED_ARRAY_SUPPORT : true;
function kMaxLength() {
    return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function createBuffer(that, length) {
    if (kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return allocUnsafe(this, arg);
    }
    return from(this, arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192; // not used by this implementation
// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function(arr) {
    arr.__proto__ = Buffer.prototype;
    return arr;
};
function from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return fromString(that, value, encodingOrOffset);
    return fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(null, value, encodingOrOffset, length);
};
if (Buffer.TYPED_ARRAY_SUPPORT) {
    Buffer.prototype.__proto__ = Uint8Array.prototype;
    Buffer.__proto__ = Uint8Array;
}
function assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function alloc(that, size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
    return createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(null, size, fill, encoding);
};
function allocUnsafe(that, size) {
    assertSize(size);
    that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(null, size);
};
function fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = byteLength(string, encoding) | 0;
    that = createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    that = createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength; // this throws if `array` is not a valid ArrayBuffer
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
    return that;
}
function fromObject(that, obj) {
    if (internalIsBuffer(obj)) {
        var len = checked(obj.length) | 0;
        that = createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || isnan(obj.length)) return createBuffer(that, 0);
            return fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && isArray(obj.data)) return fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
    return length | 0;
}
Buffer.isBuffer = isBuffer;
function internalIsBuffer(b) {
    return !!(b != null && b._isBuffer);
}
Buffer.compare = function compare(a, b) {
    if (!internalIsBuffer(a) || !internalIsBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!internalIsBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (internalIsBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return utf8Slice(this, start, end);
        case "ascii":
            return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return latin1Slice(this, start, end);
        case "base64":
            return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.equals = function equals(b) {
    if (!internalIsBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = INSPECT_MAX_BYTES;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!internalIsBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (internalIsBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function latin1Write(buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return utf8Write(this, string, offset, length);
        case "ascii":
            return asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return fromByteArray(buf);
    else return fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += toHex(buf[i]);
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 4, this.length);
    return read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) checkOffset(offset, 8, this.length);
    return read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!internalIsBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if (Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 4);
    write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) checkIEEE754(buf, value, offset, 8);
    write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = internalIsBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = stringtrim(str).replace(INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}
// the following is from is-buffer, also by Feross Aboukhadijeh and with same lisence
// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
function isBuffer(obj) {
    return obj != null && (!!obj._isBuffer || isFastBuffer(obj) || isSlowBuffer(obj));
}
function isFastBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && isFastBuffer(obj.slice(0, 0));
}
(0, _pngJsDefault.default).isValid = function(data) {
    try {
        return new (0, _pngJsDefault.default)(data), true;
    } catch (e) {
        return false;
    }
};
// Extracted from https://github.com/devongovett/pdfkit/blob/master/lib/image/jpeg.coffee
var MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var JPEG = function JPEG(data) {
    this.data = null;
    this.width = null;
    this.height = null;
    this.data = data;
    if (data.readUInt16BE(0) !== 0xffd8) throw new Error("SOI not found in JPEG");
    var marker;
    var pos = 2;
    while(pos < data.length){
        marker = data.readUInt16BE(pos);
        pos += 2;
        if (MARKERS.includes(marker)) break;
        pos += data.readUInt16BE(pos);
    }
    if (!MARKERS.includes(marker)) throw new Error("Invalid JPEG.");
    pos += 3;
    this.height = data.readUInt16BE(pos);
    pos += 2;
    this.width = data.readUInt16BE(pos);
};
JPEG.isValid = function(data) {
    if (!data || !Buffer.isBuffer(data) || data.readUInt16BE(0) !== 0xffd8) return false;
    var marker;
    var pos = 2;
    while(pos < data.length){
        marker = data.readUInt16BE(pos);
        pos += 2;
        if (MARKERS.includes(marker)) break;
        pos += data.readUInt16BE(pos);
    }
    if (!MARKERS.includes(marker)) return false;
    return true;
};
var createCache = function createCache(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 100 : _ref$limit;
    var cache = {};
    var keys = [];
    return {
        get: function get(key) {
            return cache[key];
        },
        set: function set(key, value) {
            keys.push(key);
            if (keys.length > limit) delete cache[keys.shift()];
            cache[key] = value;
        },
        reset: function reset() {
            cache = {};
            keys = [];
        },
        length: function length() {
            return keys.length;
        }
    };
};
var IMAGE_CACHE = createCache({
    limit: 30
});
var fetchRemoteFile = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee(uri, options) {
        var response, buffer;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, _crossFetchDefault.default)(uri, options);
                case 2:
                    response = _context.sent;
                    _context.next = 5;
                    return response.buffer ? response.buffer() : response.arrayBuffer();
                case 5:
                    buffer = _context.sent;
                    return _context.abrupt("return", buffer.constructor.name === "Buffer" ? buffer : Buffer.from(buffer));
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchRemoteFile(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var isValidFormat = function isValidFormat(format) {
    var lower = format.toLowerCase();
    return lower === "jpg" || lower === "jpeg" || lower === "png";
};
var guessFormat = function guessFormat(buffer) {
    var format;
    if (JPEG.isValid(buffer)) format = "jpg";
    else if ((0, _pngJsDefault.default).isValid(buffer)) format = "png";
    return format;
};
var isCompatibleBase64 = function isCompatibleBase64(_ref2) {
    var uri = _ref2.uri;
    return /^data:image\/[a-zA-Z]*;base64,[^"]*/g.test(uri);
};
function getImage(body, extension) {
    switch(extension.toLowerCase()){
        case "jpg":
        case "jpeg":
            return new JPEG(body);
        case "png":
            return new (0, _pngJsDefault.default)(body);
        default:
            return null;
    }
}
var resolveBase64Image = function resolveBase64Image(_ref3) {
    var uri = _ref3.uri;
    var match = /^data:image\/([a-zA-Z]*);base64,([^"]*)/g.exec(uri);
    var format = match[1];
    var data = match[2];
    if (!isValidFormat(format)) throw new Error("Base64 image invalid format: " + format);
    return new Promise(function(resolve) {
        return resolve(getImage(Buffer.from(data, "base64"), format));
    });
};
var resolveImageFromData = function resolveImageFromData(src) {
    if (src.data && src.format) return new Promise(function(resolve) {
        return resolve(getImage(src.data, src.format));
    });
    throw new Error("Invalid data given for local file: " + JSON.stringify(src));
};
var resolveBufferImage = function resolveBufferImage(buffer) {
    var format = guessFormat(buffer);
    if (format) return new Promise(function(resolve) {
        return resolve(getImage(buffer, format));
    });
    return Promise.resolve();
};
var getImageFormat = function getImageFormat(body) {
    var isPng = body[0] === 137 && body[1] === 80 && body[2] === 78 && body[3] === 71 && body[4] === 13 && body[5] === 10 && body[6] === 26 && body[7] === 10;
    var isJpg = body[0] === 255 && body[1] === 216 && body[2] === 255;
    var extension = "";
    if (isPng) extension = "png";
    else if (isJpg) extension = "jpg";
    else throw new Error("Not valid image extension");
    return extension;
};
var resolveImageFromUrl = /*#__PURE__*/ function() {
    var _ref4 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorRuntimeDefault.default)().mark(function _callee2(src) {
        var uri, body, headers, _src$method, method, data, extension;
        return (0, _regeneratorRuntimeDefault.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    uri = src.uri, body = src.body, headers = src.headers, _src$method = src.method, method = _src$method === void 0 ? "GET" : _src$method;
                    _context2.next = 7;
                    break;
                case 4:
                    _context2.t0 = _context2.sent;
                    _context2.next = 10;
                    break;
                case 7:
                    _context2.next = 9;
                    return fetchRemoteFile(uri, {
                        body: body,
                        headers: headers,
                        method: method
                    });
                case 9:
                    _context2.t0 = _context2.sent;
                case 10:
                    data = _context2.t0;
                    extension = getImageFormat(data);
                    return _context2.abrupt("return", getImage(data, extension));
                case 13:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function resolveImageFromUrl(_x3) {
        return _ref4.apply(this, arguments);
    };
}();
var resolveImage = function resolveImage(src, _temp) {
    var _ref5 = _temp === void 0 ? {} : _temp, _ref5$cache = _ref5.cache, cache = _ref5$cache === void 0 ? true : _ref5$cache;
    var image;
    var cacheKey = src.data ? src.data.toString() : src.uri;
    if (Buffer.isBuffer(src)) image = resolveBufferImage(src);
    else if (cache && IMAGE_CACHE.get(cacheKey)) return IMAGE_CACHE.get(cacheKey);
    else if (isCompatibleBase64(src)) image = resolveBase64Image(src);
    else if (typeof src === "object" && src.data) image = resolveImageFromData(src);
    else image = resolveImageFromUrl(src);
    if (!image) throw new Error("Cannot resolve image");
    if (cache) IMAGE_CACHE.set(cacheKey, image);
    return image;
};

},{"@babel/runtime/helpers/regeneratorRuntime":"03zO2","@babel/runtime/helpers/asyncToGenerator":"lbVvv","cross-fetch":"er2sO","@react-pdf/png-js":"3TRo0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"loY41":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var E = {};
E.ALIGN_AUTO = 0;
E.ALIGN_FLEX_START = 1;
E.ALIGN_CENTER = 2;
E.ALIGN_FLEX_END = 3;
E.ALIGN_STRETCH = 4;
E.ALIGN_BASELINE = 5;
E.ALIGN_SPACE_BETWEEN = 6;
E.ALIGN_SPACE_AROUND = 7;
E.DIMENSION_WIDTH = 0;
E.DIMENSION_HEIGHT = 1;
E.DIRECTION_INHERIT = 0;
E.DIRECTION_LTR = 1;
E.DIRECTION_RTL = 2;
E.DISPLAY_FLEX = 0;
E.DISPLAY_NONE = 1;
E.EDGE_LEFT = 0;
E.EDGE_TOP = 1;
E.EDGE_RIGHT = 2;
E.EDGE_BOTTOM = 3;
E.EDGE_START = 4;
E.EDGE_END = 5;
E.EDGE_HORIZONTAL = 6;
E.EDGE_VERTICAL = 7;
E.EDGE_ALL = 8;
E.EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS = 0;
E.EXPERIMENTAL_FEATURE_ABSOLUTE_PERCENTAGE_AGAINST_PADDING_EDGE = 1;
E.EXPERIMENTAL_FEATURE_FIX_ABSOLUTE_TRAILING_COLUMN_MARGIN = 2;
E.FLEX_DIRECTION_COLUMN = 0;
E.FLEX_DIRECTION_COLUMN_REVERSE = 1;
E.FLEX_DIRECTION_ROW = 2;
E.FLEX_DIRECTION_ROW_REVERSE = 3;
E.GUTTER_COLUMN = 0;
E.GUTTER_ROW = 1;
E.GUTTER_ALL = 2;
E.JUSTIFY_FLEX_START = 0;
E.JUSTIFY_CENTER = 1;
E.JUSTIFY_FLEX_END = 2;
E.JUSTIFY_SPACE_BETWEEN = 3;
E.JUSTIFY_SPACE_AROUND = 4;
E.JUSTIFY_SPACE_EVENLY = 5;
E.LOG_LEVEL_ERROR = 0;
E.LOG_LEVEL_WARN = 1;
E.LOG_LEVEL_INFO = 2;
E.LOG_LEVEL_DEBUG = 3;
E.LOG_LEVEL_VERBOSE = 4;
E.LOG_LEVEL_FATAL = 5;
E.MEASURE_MODE_UNDEFINED = 0;
E.MEASURE_MODE_EXACTLY = 1;
E.MEASURE_MODE_AT_MOST = 2;
E.NODE_TYPE_DEFAULT = 0;
E.NODE_TYPE_TEXT = 1;
E.OVERFLOW_VISIBLE = 0;
E.OVERFLOW_HIDDEN = 1;
E.OVERFLOW_SCROLL = 2;
E.POSITION_TYPE_STATIC = 0;
E.POSITION_TYPE_RELATIVE = 1;
E.POSITION_TYPE_ABSOLUTE = 2;
E.PRINT_OPTIONS_LAYOUT = 1;
E.PRINT_OPTIONS_STYLE = 2;
E.PRINT_OPTIONS_CHILDREN = 4;
E.UNIT_UNDEFINED = 0;
E.UNIT_POINT = 1;
E.UNIT_PERCENT = 2;
E.UNIT_AUTO = 3;
E.WRAP_NO_WRAP = 0;
E.WRAP_WRAP = 1;
E.WRAP_WRAP_REVERSE = 2;
var rE = E;
var AE = function AE(E) {
    function a(E, a, _) {
        var s = E[a];
        E[a] = function() {
            for(var _len = arguments.length, E = new Array(_len), _key = 0; _key < _len; _key++)E[_key] = arguments[_key];
            return _.call.apply(_, [
                this,
                s
            ].concat(E));
        };
    }
    var _loop = function _loop() {
        var _s;
        var _ = _arr[_i];
        var s = (_s = {}, _s[rE.UNIT_POINT] = E.Node.prototype[_], _s[rE.UNIT_PERCENT] = E.Node.prototype[_ + "Percent"], _s[rE.UNIT_AUTO] = E.Node.prototype[_ + "Auto"], _s);
        a(E.Node.prototype, _, function(E) {
            var _s$t, _s$t2;
            for(var _len2 = arguments.length, a = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)a[_key2 - 1] = arguments[_key2];
            var e = a.pop();
            var t, N;
            if ("auto" === e) t = rE.UNIT_AUTO, N = void 0;
            else if ("object" == typeof e) t = e.unit, N = e.valueOf();
            else if (t = "string" == typeof e && e.endsWith("%") ? rE.UNIT_PERCENT : rE.UNIT_POINT, N = parseFloat(e), !Number.isNaN(e) && Number.isNaN(N)) throw new Error("Invalid value " + e + " for " + _);
            if (!s[t]) throw new Error('Failed to execute "' + _ + "\": Unsupported unit '" + e + "'");
            return void 0 !== N ? (_s$t = s[t]).call.apply(_s$t, [
                this
            ].concat(a, [
                N
            ])) : (_s$t2 = s[t]).call.apply(_s$t2, [
                this
            ].concat(a));
        });
    };
    for(var _i = 0, _arr = [
        "setPosition",
        "setMargin",
        "setFlexBasis",
        "setWidth",
        "setHeight",
        "setMinWidth",
        "setMinHeight",
        "setMaxWidth",
        "setMaxHeight",
        "setPadding"
    ]; _i < _arr.length; _i++)_loop();
    return a(E.Node.prototype, "setMeasureFunc", function(a, _) {
        var s;
        return _ ? a.call(this, (s = _, E.MeasureCallback.implement({
            measure: function measure() {
                var _s2 = s.apply(void 0, arguments), a = _s2.width, _ = _s2.height;
                return {
                    width: a != null ? a : NaN,
                    height: _ != null ? _ : NaN
                };
            }
        }))) : this.unsetMeasureFunc();
    }), a(E.Node.prototype, "setDirtiedFunc", function(a, _) {
        var s;
        a.call(this, (s = _, E.DirtiedCallback.implement({
            dirtied: s
        })));
    }), a(E.Config.prototype, "free", function() {
        E.Config.destroy(this);
    }), a(E.Node, "create", function(a, _) {
        return _ ? E.Node.createWithConfig(_) : E.Node.createDefault();
    }), a(E.Node.prototype, "free", function() {
        E.Node.destroy(this);
    }), a(E.Node.prototype, "freeRecursive", function() {
        for(var _E2 = 0, _a = this.getChildCount(); _E2 < _a; ++_E2)this.getChild(0).freeRecursive();
        this.free();
    }), a(E.Node.prototype, "calculateLayout", function(E, a, _, s) {
        if (a === void 0) a = NaN;
        if (_ === void 0) _ = NaN;
        if (s === void 0) s = rE.DIRECTION_LTR;
        return E.call(this, a, _, s);
    }), (0, _extendsDefault.default)({
        Config: E.Config,
        Node: E.Node
    }, rE);
};
var rr, er = (rr = "undefined" != typeof document && document.currentScript ? document.currentScript.src : void 0, function(r) {
    if (r === void 0) r = {};
    var e, a, i;
    e || (e = void 0 !== r ? r : {}), e.ready = new Promise(function(r, e) {
        a = r, i = e;
    });
    var n = Object.assign({}, e), t = "";
    "undefined" != typeof document && document.currentScript && (t = document.currentScript.src), rr && (t = rr), t = 0 !== t.indexOf("blob:") ? t.substr(0, t.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "";
    var f, o = e.print || console.log.bind(console), c = e.printErr || console.warn.bind(console);
    function u() {}
    function b(r) {
        this.exports = function(r) {
            for(var e, a = new Uint8Array(123), i = 25; i >= 0; --i)a[48 + i] = 52 + i, a[65 + i] = i, a[97 + i] = 26 + i;
            function n(r, e, i) {
                for(var n, t, f = 0, o = e, c = i.length, u = e + (3 * c >> 2) - ("=" == i[c - 2]) - ("=" == i[c - 1]); f < c; f += 4)n = a[i.charCodeAt(f + 1)], t = a[i.charCodeAt(f + 2)], r[o++] = a[i.charCodeAt(f)] << 2 | n >> 4, o < u && (r[o++] = n << 4 | t >> 2), o < u && (r[o++] = t << 6 | a[i.charCodeAt(f + 3)]);
            }
            a[43] = 62, a[47] = 63;
            var t = new ArrayBuffer(16), f = new Int32Array(t), o = new Float32Array(t), c = new Float64Array(t);
            function u(r) {
                return f[r];
            }
            function b(r, e) {
                f[r] = e;
            }
            function s() {
                return c[0];
            }
            function A(r) {
                c[0] = r;
            }
            function k() {
                throw new Error("abort");
            }
            function l(r) {
                o[2] = r;
            }
            function d() {
                return o[2];
            }
            return function(r) {
                var a = r.a, i = a.a, t = i.buffer;
                i.grow = function(r) {
                    r |= 0;
                    var a = 0 | ia(), n = a + r | 0;
                    if (a < n && n < 65536) {
                        var u = new ArrayBuffer(w(n, 65536));
                        new Int8Array(u).set(f), f = new Int8Array(u), o = new Int16Array(u), c = new Int32Array(u), v = new Uint8Array(u), h = new Uint16Array(u), p = new Uint32Array(u), m = new Float32Array(u), N = new Float64Array(u), t = u, i.buffer = t, e = v;
                    }
                    return a;
                };
                var f = new Int8Array(t), o = new Int16Array(t), c = new Int32Array(t), v = new Uint8Array(t), h = new Uint16Array(t), p = new Uint32Array(t), m = new Float32Array(t), N = new Float64Array(t), w = Math.imul, y = Math.fround, E = Math.abs, G = Math.clz32, R = Math.min, g = Math.max, Z = a.b, W = a.c, V = a.d, B = a.e, T = a.f, I = a.g, X = a.h, O = a.i, L = a.j, _ = a.k, F = a.l, C = a.m, S = a.n, P = a.o, Y = a.p, U = a.q, M = a.r, H = a.s, Q = a.t, z = a.u, j = a.v, D = a.w, x = a.x, J = a.y, K = a.z, q = a.A, $ = a.B, rr = a.C, er = a.D, ar = 73632, ir = 0;
                function nr(r, e, a, i, n, t, o, u, s, A, l, h, p, N) {
                    var w, G = y(0), R = y(0), g = 0, Z = 0, W = 0, V = y(0), B = y(0), T = y(0), X = 0, O = 0, L = 0, _ = y(0), F = y(0), C = y(0), S = 0, P = y(0), Y = 0, U = y(0), M = y(0), H = 0, Q = 0, z = 0, j = 0, D = 0, x = y(0), J = 0, K = y(0), q = 0, $ = 0, rr = 0, er = 0, ir = y(0), nr = 0, tr = 0, fr = 0, cr = 0, br = y(0), lr = 0, dr = 0, vr = 0, hr = y(0), Nr = y(0), yr = 0, Er = y(0), Gr = y(0), Zr = y(0), _r = 0, Cr = 0, Sr = y(0), Pr = 0, Yr = y(0), Hr = y(0), jr = y(0), xr = y(0), Kr = 0, qr = 0, $r = 0, re = 0, ee = 0, ae = 0, ie = 0, ne = 0, te = 0, fe = y(0), oe = y(0);
                    ar = w = ar - 384 | 0;
                    r: {
                        e: {
                            a: {
                                if (!n || e == e) {
                                    if (!t || a == a) {
                                        if (c[(g = (s ? 0 : 4) + l | 0) >> 2] = c[g >> 2] + 1, Pr = (0 | i) <= 1 ? 1 : i, J = (g = 3 & c[r + 24 >> 2]) || Pr, f[r + 300 | 0] = 252 & v[r + 300 | 0] | 3 & J, g = r + 252 | 0, i = (1 != (0 | J)) << 3, B = Mr(r, lr = 2 == (0 | J) ? 3 : 2, o), m[g + i >> 2] = B, Z = g, g = (1 == (0 | J)) << 3, F = Ur(r, lr, o), m[Z + g >> 2] = F, _ = Mr(r, 0, o), m[r + 256 >> 2] = _, V = Ur(r, 0, o), m[r + 264 >> 2] = V, te = (W = r + 268 | 0) + i | 0, fe = zr(r, lr), m[te >> 2] = fe, te = g + W | 0, fe = Qr(r, lr), m[te >> 2] = fe, G = zr(r, 0), m[r + 272 >> 2] = G, T = Qr(r, 0), m[r + 280 >> 2] = T, te = (Z = i) + (i = r + 284 | 0) | 0, fe = Br(r, lr, o), m[te >> 2] = fe, te = i + g | 0, fe = Tr(r, lr, o), m[te >> 2] = fe, R = Br(r, 0, o), m[r + 288 >> 2] = R, P = Tr(r, 0, o), m[r + 296 >> 2] = P, B = y(B + F), F = y(_ + V), i = c[r + 8 >> 2]) {
                                            if (_ = y(y(y(m[r + 284 >> 2] + m[r + 292 >> 2]) + m[r + 268 >> 2]) + m[r + 276 >> 2]), a = y(t ? a - F : NaN), G = y(y(R + P) + G), (e = R = y(n ? e - B : NaN)) == e && (e = (e = y(R - _)) == e ? Re(e, y(0)) : y(0)), B = y(G + T), G = a, a == a && (G = (G = y(a - B)) == G ? Re(G, y(0)) : y(0)), !(1 != (0 | n) | 1 != (0 | t))) {
                                                e = (i = (e = ur(r, 2, R, o)) != e) | (G = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != G ? i ? G : e : Re(e, G), m[r + 516 >> 2] = e, e = (i = (e = ur(r, 0, a, u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                                                break r;
                                            }
                                            16 & v[r + 4 | 0] ? aa[0 | i](w + 24 | 0, r, e, n, G, t, 0) : aa[0 | i](w + 24 | 0, r, e, n, G, t), c[l + 20 >> 2] = c[l + 20 >> 2] + 1, c[24 + (i = (N << 2) + l | 0) >> 2] = c[i + 24 >> 2] + 1, e = y(_ + m[w + 24 >> 2]), e = (i = (e = ur(r, 2, n ? 2 == (0 | n) ? e : R : e, o)) != e) | (G = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != G ? i ? G : e : Re(e, G), m[r + 516 >> 2] = e, e = y(B + m[w + 28 >> 2]), e = (i = (e = ur(r, 0, t ? 2 == (0 | t) ? e : a : e, u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                                            break r;
                                        }
                                        if ((0 | (i = c[r + 556 >> 2])) == (0 | (N = c[r + 560 >> 2]))) {
                                            F = y(a - F), e = (i = (e = ur(r, 2, y(-3 & n ? e - B : y(y(m[r + 284 >> 2] + m[r + 292 >> 2]) + m[r + 268 >> 2]) + m[r + 276 >> 2]), o)) != e) | (a = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != a ? i ? a : e : Re(e, a), m[r + 516 >> 2] = e, e = (i = (e = ur(r, 0, -3 & t ? F : y(y(y(R + P) + G) + T), u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                                            break r;
                                        }
                                        if (!(s || (R = y(e - B), G = y(a - F), !(2 == (0 | n) & R <= y(0) | !(!(G <= y(0)) | 2 != (0 | t)) & G == G) & (1 != (0 | n) | 1 != (0 | t))))) {
                                            e = (i = (e = ur(r, 2, R == R ? 2 == (0 | n) && R < y(0) ? y(0) : R : y(0), o)) != e) | (a = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != a ? i ? a : e : Re(e, a), m[r + 516 >> 2] = e, e = (i = (e = ur(r, 0, G != G || 2 == (0 | t) && G < y(0) ? y(0) : G, u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                                            break r;
                                        }
                                        for(er = (z = N - i | 0) >> 2; g = c[i >> 2], c[g + 552 >> 2] != (0 | r) && (W = c[r + 568 >> 2], g = Ir(c[W >> 2], v[W + 8 | 0], g, r, O, 0), c[i >> 2] = g, c[g + 552 >> 2] = r), O = O + 1 | 0, (0 | N) != (0 | (i = i + 4 | 0)););
                                        f[r + 300 | 0] = 251 & v[r + 300 | 0], O = 3, i = (yr = c[r + 24 >> 2]) >>> 2 & 3;
                                        i: {
                                            n: {
                                                t: {
                                                    if (2 == (0 | J)) {
                                                        N = 0;
                                                        f: switch(i - 2 | 0){
                                                            case 0:
                                                                break i;
                                                            case 1:
                                                                break f;
                                                            default:
                                                                break t;
                                                        }
                                                        O = 2;
                                                        break i;
                                                    }
                                                    if (O = 2, N = 0, i >>> 0 > 1) break n;
                                                }
                                                N = O;
                                            }
                                            O = i;
                                        }
                                        Yr = y(e - B), ir = y(y(Br(r, O, o) + zr(r, O)) + y(Tr(r, O, o) + Qr(r, O))), P = y(Br(r, N, o) + zr(r, N)), K = y(P + y(Tr(r, N, o) + Qr(r, N))), V = kr(r, 0, Yr, (q = O >>> 0 > 1) ? ir : K, o), U = kr(r, 1, Hr = y(a - F), q ? K : ir, u), M = q ? U : V, F = q ? V : U, nr = c[r + 560 >> 2], g = c[r + 556 >> 2];
                                        i: if (1 == (0 | (Y = q ? n : t))) {
                                            if ((0 | g) == (0 | nr)) break a;
                                            for(i = 0, W = g;;){
                                                Z = i;
                                                n: if (Dr(i = c[W >> 2])) {
                                                    if (X = 0, Z) break i;
                                                    if (!(Z = c[i + 552 >> 2])) break i;
                                                    t: {
                                                        if (!((a = m[i + 32 >> 2]) == a || (G = y(0), (a = m[i + 28 >> 2]) > y(0))) || (G = a, a == a)) {
                                                            if (y(E(G)) < y(9999999747378752e-20)) break i;
                                                            if (!Z) {
                                                                a = y(0);
                                                                break t;
                                                            }
                                                        }
                                                        if ((a = m[i + 36 >> 2]) != a) {
                                                            if (f[i + 4 | 0] < 0) {
                                                                a = y(1);
                                                                break t;
                                                            }
                                                            if (a = y(0), !((e = m[i + 28 >> 2]) < y(0))) break t;
                                                            a = y(-e);
                                                        }
                                                        if (a != a) break n;
                                                    }
                                                    if (y(E(a)) < y(9999999747378752e-20)) break i;
                                                } else i = Z;
                                                if (X = i, (0 | nr) == (0 | (W = W + 4 | 0))) break;
                                            }
                                        }
                                        if ((0 | g) == (0 | nr)) break a;
                                        for(j = (0 | J) <= 1 ? 1 : J, tr = (fr = V != V) | 1 != (0 | n), cr = U == U, dr = V == V, G = y(0);;){
                                            sr(L = c[g >> 2]);
                                            i: if (4194304 & (W = c[L + 24 >> 2])) {
                                                if (mr(L, 0), W = 1 | (i = v[L + 4 | 0]), f[L + 4 | 0] = W, !(4 & i)) break i;
                                                f[L + 4 | 0] = 251 & W;
                                            } else if (s && (Fr(L, (i = 3 & W) || j, F, M, V), W = c[L + 24 >> 2]), 131072 != (196608 & W)) {
                                                if ((0 | X) != (0 | L)) {
                                                    Z = (vr = c[r + 24 >> 2]) >>> 2 & 3;
                                                    n: {
                                                        t: if (2 == (0 | J)) {
                                                            i = 3;
                                                            f: switch(Z - 2 | 0){
                                                                case 0:
                                                                    break n;
                                                                case 1:
                                                                    break f;
                                                                default:
                                                                    break t;
                                                            }
                                                            i = 2;
                                                            break n;
                                                        }
                                                        i = Z;
                                                    }
                                                    R = ($ = i >>> 0 > 1) ? V : U, a = y(0), e = m[L + 40 >> 2];
                                                    n: {
                                                        t: {
                                                            f: if (2139156720 != (0 | (Z = c[L + 40 >> 2]))) {
                                                                if (2140081935 == (0 | Z)) break t;
                                                                S = 4276;
                                                                o: {
                                                                    if (2141891242 != (0 | Z)) {
                                                                        if (e == e) break o;
                                                                        S = 4268;
                                                                    }
                                                                    a = m[S >> 2];
                                                                    c: {
                                                                        u: switch(0 | (Z = c[S + 4 >> 2])){
                                                                            case 0:
                                                                            case 3:
                                                                                break u;
                                                                            default:
                                                                                break c;
                                                                        }
                                                                        if (e = y(NaN), !(m[L + 28 >> 2] > y(0))) break n;
                                                                        Z = (S = f[L + 4 | 0] < 0) ? 3 : 1, b(2, D = S ? 2143289344 : 0), a = d();
                                                                    }
                                                                    switch(e = y(NaN), Z - 1 | 0){
                                                                        case 0:
                                                                            break t;
                                                                        case 1:
                                                                            break f;
                                                                        default:
                                                                            break n;
                                                                    }
                                                                }
                                                                if (b(2, 536870912 + (-1073741825 & Z) | 0), a = d(), !(1073741824 & Z)) break t;
                                                            }
                                                            e = y(y(R * a) * y(.009999999776482582));
                                                            break n;
                                                        }
                                                        e = a;
                                                    }
                                                    a = m[L + 572 >> 2], Z = 0;
                                                    n: {
                                                        switch(0 | (Q = c[L + 576 >> 2])){
                                                            case 0:
                                                            case 3:
                                                                break n;
                                                        }
                                                        if (1 != (0 | Q) | (B = m[L + 572 >> 2]) != B) Z = 1, 2 != (0 | Q) | B != B || (Z = 0, a < y(0) || (Z = dr));
                                                        else {
                                                            if (a < y(0)) break n;
                                                            Z = 1;
                                                        }
                                                    }
                                                    B = m[L + 580 >> 2], S = 0;
                                                    n: {
                                                        switch(0 | (H = c[L + 584 >> 2])){
                                                            case 0:
                                                            case 3:
                                                                break n;
                                                        }
                                                        if (1 != (0 | H) | (T = m[L + 580 >> 2]) != T) S = 1, 2 != (0 | H) | T != T || (S = 0, B < y(0) || (S = cr));
                                                        else {
                                                            if (B < y(0)) break n;
                                                            S = 1;
                                                        }
                                                    }
                                                    n: {
                                                        t: if (e != e | R != R) {
                                                            if (Z & $) {
                                                                switch(R = y(y(Br(L, 2, V) + zr(L, 2)) + y(Tr(L, 2, V) + Qr(L, 2))), e = y(NaN), Q - 1 | 0){
                                                                    case 1:
                                                                        a = y(y(V * a) * y(.009999999776482582));
                                                                    case 0:
                                                                        if (R <= (e = a)) break t;
                                                                }
                                                                if (!(e == e | R == R)) {
                                                                    a = e;
                                                                    break t;
                                                                }
                                                                if (e < R) {
                                                                    a = R;
                                                                    break t;
                                                                }
                                                                a = e != e ? R : e;
                                                            } else if ($ | 1 ^ S) {
                                                                if (c[w + 360 >> 2] = 2143289344, c[w + 24 >> 2] = 2143289344, D = 0, c[w + 356 >> 2] = 0, c[w + 352 >> 2] = 0, T = y(Mr(L, 2, V) + Ur(L, 2, V)), _ = Mr(L, 0, V), C = Ur(L, 0, V), R = y(NaN), rr = 0, e = y(NaN), Z) {
                                                                    f: {
                                                                        o: switch(Q - 1 | 0){
                                                                            case 0:
                                                                                e = a;
                                                                                break f;
                                                                            case 1:
                                                                                break o;
                                                                            default:
                                                                                break f;
                                                                        }
                                                                        e = y(y(V * a) * y(.009999999776482582));
                                                                    }
                                                                    c[w + 356 >> 2] = 1, e = y(T + e), m[w + 24 >> 2] = e, rr = 1;
                                                                }
                                                                if (_ = y(_ + C), S) {
                                                                    a = y(NaN);
                                                                    f: {
                                                                        o: switch(H - 1 | 0){
                                                                            case 0:
                                                                                a = B;
                                                                                break f;
                                                                            case 1:
                                                                                break o;
                                                                            default:
                                                                                break f;
                                                                        }
                                                                        a = y(y(U * B) * y(.009999999776482582));
                                                                    }
                                                                    c[w + 352 >> 2] = 1, R = y(_ + a), m[w + 360 >> 2] = R, D = 1;
                                                                }
                                                                Q = i >>> 0 < 2;
                                                                f: {
                                                                    o: {
                                                                        c: {
                                                                            if (!(!$ & 2097152 == (0 | (H = 3145728 & vr)))) {
                                                                                if (fr | 2097152 == (0 | H)) break o;
                                                                                if (e != e) break c;
                                                                                break o;
                                                                            }
                                                                            if (fr | e == e) break f;
                                                                        }
                                                                        rr = 2, c[w + 356 >> 2] = 2, m[w + 24 >> 2] = V, e = V;
                                                                    }
                                                                    o: {
                                                                        if (!(!Q & 2097152 == (0 | H))) {
                                                                            if (2097152 == (0 | H) | U != U) break f;
                                                                            if (R != R) break o;
                                                                            break f;
                                                                        }
                                                                        if (R == R | U != U) break f;
                                                                    }
                                                                    D = 2, c[w + 352 >> 2] = 2, m[w + 360 >> 2] = U, R = U;
                                                                }
                                                                f: if (!(H = (a = m[L + 224 >> 2]) != a)) {
                                                                    if ($ | 1 != (0 | rr)) {
                                                                        if (Q | 1 != (0 | D)) break f;
                                                                        c[w + 356 >> 2] = 1, m[w + 24 >> 2] = y(y(R - _) * a) + T;
                                                                    } else c[w + 352 >> 2] = 1, m[w + 360 >> 2] = _ + y(y(e - T) / a);
                                                                    D = 1, rr = 1;
                                                                }
                                                                5 == (0 | (W = (W = W >>> 13 & 7) || vr >>> 10 & 7)) | 1 == (0 | rr) | $ | Z | tr | 4 != (0 | W) || (c[w + 356 >> 2] = 1, m[w + 24 >> 2] = V, H || (D = 1, c[w + 352 >> 2] = 1, m[w + 360 >> 2] = y(V - T) / a)), Q | 1 != (0 | t) | U != U | S | 4 != (0 | W) | 1 == (0 | D) || (c[w + 352 >> 2] = 1, m[w + 360 >> 2] = U, H || (c[w + 356 >> 2] = 1, m[w + 24 >> 2] = y(U - _) * a)), Vr(L, 2, V, V, w + 356 | 0, w + 24 | 0), Vr(L, 0, U, V, w + 352 | 0, w + 360 | 0), or(L, m[w + 24 >> 2], m[w + 360 >> 2], J, c[w + 356 >> 2], c[w + 352 >> 2], V, U, 0, 5, A, l, h, p), a = (W = (e = m[516 + (L + (c[4252 + (i << 2) >> 2] << 2) | 0) >> 2]) != e) | (a = y(y(Br(L, i, V) + zr(L, i)) + y(Tr(L, i, V) + Qr(L, i)))) != a ? W ? a : e : Re(e, a);
                                                            } else {
                                                                switch(e = y(y(Br(L, 0, V) + zr(L, 0)) + y(Tr(L, 0, V) + Qr(L, 0))), a = y(NaN), H - 1 | 0){
                                                                    case 1:
                                                                        B = y(y(U * B) * y(.009999999776482582));
                                                                    case 0:
                                                                        if (e <= (a = B)) break t;
                                                                }
                                                                if (a != a & e != e) break t;
                                                                if (e > a) {
                                                                    a = e;
                                                                    break t;
                                                                }
                                                                a = a != a ? e : a;
                                                            }
                                                        } else {
                                                            if (a = m[L + 308 >> 2], (!v[c[L + 568 >> 2] + 20 | 0] | c[L + 304 >> 2] == (0 | p)) & a == a) break n;
                                                            if (!((a = y(y(Br(L, i, V) + zr(L, i)) + y(Tr(L, i, V) + Qr(L, i)))) <= e) & e < a) break t;
                                                            a = e;
                                                        }
                                                        m[L + 308 >> 2] = a;
                                                    }
                                                    c[L + 304 >> 2] = p;
                                                } else c[X + 308 >> 2] = 0, c[X + 304 >> 2] = p, a = y(0);
                                                G = y(G + y(a + y(Mr(L, O, V) + Ur(L, O, V))));
                                            }
                                            if ((0 | nr) == (0 | (g = g + 4 | 0))) break;
                                        }
                                        break e;
                                    }
                                    c[w >> 2] = 3023, Xr(r, w), De(), k();
                                }
                                c[w + 16 >> 2] = 3105, Xr(r, w + 16 | 0), De(), k();
                            }
                            G = y(0);
                        }
                        e = y(G + y(0)), Er = q ? u : o, hr = q ? o : u, z >>> 0 >= 5 && (e = y(y(pr(r, O, M) * y(er - 1 >>> 0)) + e)), i = e > F, nr = 786432 & yr, cr = 2 == (0 | Y) && nr && i ? 1 : Y, qr = (fr = 1 == (0 | (L = q ? t : n))) & (1 ^ s), q = O >>> 0 < 2, $r = -3 & L, vr = r + 208 | 0, H = 4220 + (t = N << 2) | 0, re = fr & !nr, ee = 1 != (0 | L) | s, $ = 4220 + (g = O << 2) | 0, dr = g + 4252 | 0, ae = (rr = M == M) << 1, Q = t + 4252 | 0, ie = !Y | !i, yr = w + 52 | 0, jr = pr(r, N, M), W = 0, i = 0, D = 0;
                        e: {
                            for(;;){
                                if (S = i, Rr(w + 24 | 0, 0, 44), (0 | (i = c[r + 560 >> 2])) != (0 | (t = c[r + 556 >> 2]))) {
                                    if ((0 | (i = i - t | 0)) < 0) break e;
                                    g = pe(w + 360 | 0, i >> 2, 0, yr), i = c[w + 44 >> 2], t = c[w + 48 >> 2] - i | 0, t = wr(c[w + 364 >> 2] - t | 0, i, t), i = c[w + 44 >> 2], c[w + 364 >> 2] = i, c[w + 44 >> 2] = t, Z = c[w + 368 >> 2], X = c[w + 372 >> 2], t = c[w + 48 >> 2], c[w + 368 >> 2] = t, Y = c[w + 52 >> 2], c[w + 48 >> 2] = Z, c[w + 52 >> 2] = X, c[w + 372 >> 2] = Y, c[g >> 2] = i, (0 | i) != (0 | t) && (c[w + 368 >> 2] = t + (3 + (i - t | 0) & -4)), i && gr(i);
                                }
                                t = (X = c[r + 24 >> 2]) >>> 2 & 3;
                                a: {
                                    i: if (2 == (0 | ((i = 3 & X) || Pr))) {
                                        i = 3;
                                        n: switch(t - 2 | 0){
                                            case 0:
                                                break a;
                                            case 1:
                                                break n;
                                            default:
                                                break i;
                                        }
                                        i = 2;
                                        break a;
                                    }
                                    i = t;
                                }
                                G = pr(r, i, V);
                                a: if (!((g = W) >>> 0 >= (Z = c[r + 560 >> 2]) - (t = c[r + 556 >> 2]) >> 2 >>> 0)) for(Y = 786432 & X, a = y(0);;){
                                    if (Z - t >> 2 >>> 0 <= g >>> 0) break e;
                                    if (X = c[(g << 2) + t >> 2], !(4194304 & (z = c[X + 24 >> 2]) | 131072 == (196608 & z))) {
                                        if (c[X + 548 >> 2] = S, e = Mr(X, i, V), R = Ur(X, i, V), t = c[w + 24 >> 2], B = (0 | g) == (0 | W) ? y(0) : G, e = y(e + R), T = ur(X, i, R = m[X + 308 >> 2], hr), t && !(!(y(B + y(e + y(a + T))) > F) | !Y)) break a;
                                        if (c[w + 24 >> 2] = t + 1, B = y(B + y(e + T)), m[w + 28 >> 2] = B + m[w + 28 >> 2], Dr(X)) {
                                            i: if (c[X + 552 >> 2]) {
                                                if ((e = m[X + 32 >> 2]) != e && (e = (e = m[X + 28 >> 2]) > y(0) ? e : y(0)), m[w + 32 >> 2] = e + m[w + 32 >> 2], (e = m[X + 36 >> 2]) == e) break i;
                                                if (f[X + 4 | 0] < 0) {
                                                    e = y(1);
                                                    break i;
                                                }
                                                if (e = y(0), !((T = m[X + 28 >> 2]) < y(0))) break i;
                                                e = y(-T);
                                            } else e = y(0), m[w + 32 >> 2] = m[w + 32 >> 2] + y(0);
                                            m[w + 36 >> 2] = m[w + 36 >> 2] - y(e * R);
                                        }
                                        if ((0 | (t = c[w + 48 >> 2])) == c[w + 52 >> 2]) {
                                            if ((Z = 1 + (z = (t = t - c[w + 44 >> 2] | 0) >> 2) | 0) >>> 0 >= 1073741824) break e;
                                            j = t >>> 1 | 0, z = pe(w + 360 | 0, t >>> 0 >= 2147483644 ? 1073741823 : Z >>> 0 < j >>> 0 ? j : Z, z, yr), c[c[w + 368 >> 2] >> 2] = X, c[w + 368 >> 2] = c[w + 368 >> 2] + 4, t = c[w + 44 >> 2], Z = c[w + 48 >> 2] - t | 0, Z = wr(c[w + 364 >> 2] - Z | 0, t, Z), t = c[w + 44 >> 2], c[w + 364 >> 2] = t, c[w + 44 >> 2] = Z, X = c[w + 368 >> 2], j = c[w + 372 >> 2], Z = c[w + 48 >> 2], c[w + 368 >> 2] = Z, tr = c[w + 52 >> 2], c[w + 48 >> 2] = X, c[w + 52 >> 2] = j, c[w + 372 >> 2] = tr, c[z >> 2] = t, (0 | t) != (0 | Z) && (c[w + 368 >> 2] = Z + (3 + (t - Z | 0) & -4)), t && gr(t);
                                        } else c[t >> 2] = X, c[w + 48 >> 2] = t + 4;
                                        t = c[r + 556 >> 2], Z = c[r + 560 >> 2], a = y(a + B);
                                    }
                                    if (!((g = g + 1 | 0) >>> 0 < Z - t >> 2 >>> 0)) break;
                                }
                                !((C = m[w + 32 >> 2]) > y(0)) | !(C < y(1)) || (c[w + 32 >> 2] = 1065353216, C = y(1)), !((x = m[w + 36 >> 2]) > y(0)) | !(x < y(1)) || (c[w + 36 >> 2] = 1065353216, x = y(1)), c[w + 40 >> 2] = g, _ = m[w + 28 >> 2], Y = c[w + 24 >> 2], D && gr(D), B = m[w + 56 >> 2], z = c[w + 48 >> 2], D = c[w + 44 >> 2];
                                a: {
                                    i: {
                                        n: {
                                            if (1 != (0 | cr)) {
                                                a = y(0), e = m[vr >> 2];
                                                t: {
                                                    f: {
                                                        o: if (2139156720 != (0 | (i = c[vr >> 2]))) {
                                                            if (2140081935 == (0 | i)) break f;
                                                            t = 4276;
                                                            c: {
                                                                if (2141891242 != (0 | i)) {
                                                                    if (e == e) break c;
                                                                    t = 4268;
                                                                }
                                                                switch(a = m[t >> 2], e = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                                    case 0:
                                                                        break f;
                                                                    case 1:
                                                                        break o;
                                                                    default:
                                                                        break t;
                                                                }
                                                            }
                                                            if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break f;
                                                        }
                                                        e = y(y(a * o) * y(.009999999776482582));
                                                        break t;
                                                    }
                                                    e = a;
                                                }
                                                a = y(0), G = m[r + 216 >> 2];
                                                t: {
                                                    f: {
                                                        o: if (2139156720 != (0 | (i = c[r + 216 >> 2]))) {
                                                            if (2140081935 == (0 | i)) break f;
                                                            t = 4276;
                                                            c: {
                                                                if (2141891242 != (0 | i)) {
                                                                    if (G == G) break c;
                                                                    t = 4268;
                                                                }
                                                                switch(a = m[t >> 2], G = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                                    case 0:
                                                                        break f;
                                                                    case 1:
                                                                        break o;
                                                                    default:
                                                                        break t;
                                                                }
                                                            }
                                                            if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break f;
                                                        }
                                                        G = y(y(a * o) * y(.009999999776482582));
                                                        break t;
                                                    }
                                                    G = a;
                                                }
                                                a = y(0), R = m[r + 212 >> 2];
                                                t: {
                                                    f: {
                                                        o: if (2139156720 != (0 | (i = c[r + 212 >> 2]))) {
                                                            if (2140081935 == (0 | i)) break f;
                                                            t = 4276;
                                                            c: {
                                                                if (2141891242 != (0 | i)) {
                                                                    if (R == R) break c;
                                                                    t = 4268;
                                                                }
                                                                switch(a = m[t >> 2], T = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                                    case 0:
                                                                        break f;
                                                                    case 1:
                                                                        break o;
                                                                    default:
                                                                        break t;
                                                                }
                                                            }
                                                            if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break f;
                                                        }
                                                        T = y(y(a * u) * y(.009999999776482582));
                                                        break t;
                                                    }
                                                    T = a;
                                                }
                                                a = y(0), R = m[r + 220 >> 2];
                                                t: {
                                                    f: {
                                                        o: if (2139156720 != (0 | (i = c[r + 220 >> 2]))) {
                                                            if (2140081935 == (0 | i)) break f;
                                                            t = 4276;
                                                            c: {
                                                                if (2141891242 != (0 | i)) {
                                                                    if (R == R) break c;
                                                                    t = 4268;
                                                                }
                                                                switch(a = m[t >> 2], R = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                                    case 0:
                                                                        break f;
                                                                    case 1:
                                                                        break o;
                                                                    default:
                                                                        break t;
                                                                }
                                                            }
                                                            if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break f;
                                                        }
                                                        R = y(y(a * u) * y(.009999999776482582));
                                                        break t;
                                                    }
                                                    R = a;
                                                }
                                                if ((a = y(((i = O >>> 0 > 1) ? e : T) - ir)) == a & a > _) break n;
                                                if ((a = y((i ? G : R) - ir)) == a & a < _) break n;
                                                if (!v[c[r + 568 >> 2] + 11 | 0]) {
                                                    if (a = _, !c[r + 552 >> 2] | C == y(0)) break i;
                                                    t: {
                                                        if ((e = m[r + 32 >> 2]) != e) {
                                                            if (!((a = m[r + 28 >> 2]) > y(0))) break t;
                                                        } else a = e;
                                                        if (a != a) {
                                                            a = F;
                                                            break i;
                                                        }
                                                        e = m[r + 32 >> 2];
                                                    }
                                                    if (e != e && (a = _, !((e = m[r + 28 >> 2]) > y(0)))) break i;
                                                    if (a = F, e != y(0)) break i;
                                                    a = _;
                                                    break i;
                                                }
                                            }
                                            a = F;
                                        }
                                        if (a == a) {
                                            B = y(a - _);
                                            break a;
                                        }
                                    }
                                    _ < y(0) && (B = y(-_));
                                }
                                if (F = a, !qr) {
                                    if ((0 | D) != (0 | z)) {
                                        for(R = y(0), t = D;;){
                                            a = ur(i = c[t >> 2], O, _ = m[i + 308 >> 2], hr);
                                            a: if (B < y(0)) {
                                                if ((X = c[i + 552 >> 2]) ? (G = m[i + 36 >> 2]) != G && (f[i + 4 | 0] < 0 ? G = y(1) : (G = y(0), (e = m[i + 28 >> 2]) < y(0) && (G = y(-e)))) : G = y(0), !((e = y(a * y(-G))) > y(0) | e < y(0))) break a;
                                                if ((G = y(y(y(B / x) * e) + a)) != G | (e = (Z = (e = ur(i, O, G, F)) != e) | (T = y(y(Br(i, O, V) + zr(i, O)) + y(Tr(i, O, V) + Qr(i, O)))) != T ? Z ? T : e : Re(e, T)) != e | e == G) break a;
                                                e = y(e - a), X ? (a = m[i + 36 >> 2]) != a && (f[i + 4 | 0] < 0 ? a = y(1) : (a = y(0), (G = m[i + 28 >> 2]) < y(0) && (a = y(-G)))) : a = y(0), R = y(R + e), x = y(y(a * _) + x);
                                            } else !(B > y(0)) | !c[i + 552 >> 2] || ((G = m[i + 32 >> 2]) == G || (G = m[i + 28 >> 2]) > y(0)) && G < y(0) | G > y(0) && ((T = y(y(y(B / C) * G) + a)) != T | (e = (Z = (e = ur(i, O, T, F)) != e) | (_ = y(y(Br(i, O, V) + zr(i, O)) + y(Tr(i, O, V) + Qr(i, O)))) != _ ? Z ? _ : e : Re(e, _)) != e | e == T || (C = y(C - G), R = y(R + y(e - a))));
                                            if ((0 | z) == (0 | (t = t + 4 | 0))) break;
                                        }
                                        for(_ = y(B - R), Gr = y(_ / x), Zr = y(_ / C), Cr = !(j = fr & (!(12 & v[r + 26 | 0]) | ie)), tr = c[Q >> 2], T = y(0), Z = D;;){
                                            a = ur(t = c[Z >> 2], O, m[t + 308 >> 2], hr);
                                            a: {
                                                if (_ < y(0)) {
                                                    if (c[t + 552 >> 2] ? (e = m[t + 36 >> 2]) != e && (f[t + 4 | 0] < 0 ? e = y(1) : (e = y(0), (G = m[t + 28 >> 2]) < y(0) && (e = y(-G)))) : e = y(0), G = a, (e = y(a * y(-e))) == y(0)) break a;
                                                    e = x == y(0) ? y(a + e) : y(y(Gr * e) + a);
                                                } else {
                                                    if (G = a, !(_ > y(0)) | !c[t + 552 >> 2]) break a;
                                                    if ((e = m[t + 32 >> 2]) != e && !((e = m[t + 28 >> 2]) > y(0))) break a;
                                                    if (!(e < y(0) | e > y(0))) break a;
                                                    e = y(y(Zr * e) + a);
                                                }
                                                G = (i = (e = ur(t, O, e, F)) != e) | (G = y(y(Br(t, O, V) + zr(t, O)) + y(Tr(t, O, V) + Qr(t, O)))) != G ? i ? G : e : Re(e, G);
                                            }
                                            if (e = Mr(t, O, V), R = Ur(t, O, V), C = Mr(t, N, V), Sr = Ur(t, N, V), R = y(e + R), xr = y(G + R), m[w + 352 >> 2] = xr, c[w + 344 >> 2] = 1, C = y(C + Sr), (e = m[t + 224 >> 2]) != e) {
                                                e = m[572 + (X = t + (tr << 3) | 0) >> 2];
                                                a: {
                                                    i: {
                                                        n: {
                                                            t: {
                                                                f: {
                                                                    o: {
                                                                        c: {
                                                                            u: {
                                                                                if (rr) {
                                                                                    R = m[X + 572 >> 2];
                                                                                    b: {
                                                                                        s: {
                                                                                            A: {
                                                                                                switch(0 | (i = c[X + 576 >> 2])){
                                                                                                    case 0:
                                                                                                    case 3:
                                                                                                        break A;
                                                                                                }
                                                                                                if (!(1 != (0 | i) | e != e)) {
                                                                                                    if (!(j & R < y(0))) break b;
                                                                                                    break s;
                                                                                                }
                                                                                                if (!(Cr | !(R < y(0)) | 2 != (0 | i) | e != e)) break s;
                                                                                                break b;
                                                                                            }
                                                                                            if (!j) break b;
                                                                                        }
                                                                                        if ((X = c[t + 24 >> 2] >>> 13 & 7) || (X = c[r + 24 >> 2] >>> 10 & 7), 4 == (0 | X) && (ve(w + 24 | 0, t, N), 3 != c[w + 28 >> 2] && (de(w + 360 | 0, t, N), 3 != c[w + 364 >> 2]))) break u;
                                                                                    }
                                                                                    e = R;
                                                                                } else R = m[X + 572 >> 2], i = c[X + 576 >> 2];
                                                                                switch(0 | i){
                                                                                    case 0:
                                                                                    case 3:
                                                                                        break o;
                                                                                    default:
                                                                                        break c;
                                                                                }
                                                                            }
                                                                            c[w + 348 >> 2] = 1;
                                                                            break i;
                                                                        }
                                                                        if (!(1 != (0 | i) | e != e)) {
                                                                            if ((e = R) < y(0)) break o;
                                                                            break n;
                                                                        }
                                                                        if (2 != (0 | i) | e != e) break f;
                                                                        if (M == M && !(R < y(0))) break t;
                                                                    }
                                                                    c[w + 348 >> 2] = ae;
                                                                    break i;
                                                                }
                                                                e = y(NaN);
                                                                f: switch(i - 1 | 0){
                                                                    case 1:
                                                                        break t;
                                                                    case 0:
                                                                        break f;
                                                                    default:
                                                                        break n;
                                                                }
                                                                e = R;
                                                                break n;
                                                            }
                                                            e = y(y(M * R) * y(.009999999776482582));
                                                        }
                                                        e = y(C + e), m[w + 356 >> 2] = e, c[w + 348 >> 2] = (fr | 2 != (0 | i)) & e == e;
                                                        break a;
                                                    }
                                                    m[w + 356 >> 2] = M;
                                                }
                                                e = R;
                                            } else c[w + 348 >> 2] = 1, R = y(xr - R), m[w + 356 >> 2] = C + y(q ? R * e : R / e), R = m[572 + (X = t + (tr << 3) | 0) >> 2], i = c[X + 576 >> 2], e = m[X + 572 >> 2];
                                            Vr(t, O, F, V, w + 344 | 0, w + 352 | 0), Vr(t, N, M, V, w + 348 | 0, w + 356 | 0);
                                            a: {
                                                i: {
                                                    n: {
                                                        switch(0 | i){
                                                            case 0:
                                                            case 3:
                                                                break n;
                                                        }
                                                        if (!(1 != (0 | i) | e != e)) {
                                                            if (R < y(0)) break n;
                                                            break i;
                                                        }
                                                        if (2 != (0 | i) | e != e) break i;
                                                        if (!(R < y(0)) && (X = 0, rr)) break a;
                                                    }
                                                    if (X = 0, (i = c[t + 24 >> 2] >>> 13 & 7) || (i = c[r + 24 >> 2] >>> 10 & 7), 4 != (0 | i)) break a;
                                                    if (ve(w + 24 | 0, t, N), 3 == c[w + 28 >> 2]) break a;
                                                    de(w + 360 | 0, t, N), X = 3 != c[w + 364 >> 2];
                                                    break a;
                                                }
                                                X = 0;
                                            }
                                            e = m[w + 352 >> 2], R = m[w + 356 >> 2], C = (i = O >>> 0 > 1) ? e : R, e = i ? R : e, _r = c[w + 344 >> 2], Kr = c[w + 348 >> 2], ne = i ? _r : Kr, _r = i ? Kr : _r, i = (1 ^ X) & s, or(t, C, e, 3 & v[r + 300 | 0], ne, _r, V, U, i, i ? 4 : 7, A, l, h, p), T = y(T + y(G - a));
                                            a: {
                                                if (4 & (i = v[r + 300 | 0])) X = 251 & i;
                                                else if (X = 251 & i, i = 0, !(4 & v[t + 300 | 0])) break a;
                                                i = 4;
                                            }
                                            if (f[r + 300 | 0] = i | X, (0 | z) == (0 | (Z = Z + 4 | 0))) break;
                                        }
                                    } else T = y(0);
                                    B = y(B - T);
                                }
                                i = v[r + 300 | 0], f[r + 300 | 0] = 251 & i | (B < y(0) ? 4 : 4 & i), R = y(Br(r, O, o) + zr(r, O)), Gr = y(Tr(r, O, o) + Qr(r, O)), _ = pr(r, O, o);
                                a: if (!(B > y(0)) | 2 != (0 | cr)) T = B;
                                else {
                                    T = y(0), a = y(0);
                                    i: {
                                        n: {
                                            i = vr + (c[dr >> 2] << 2) | 0, e = m[i >> 2];
                                            t: {
                                                if (!(t = 2139156720 == (0 | (i = c[i >> 2])))) {
                                                    if (Z = 2140081935 == (0 | i)) break n;
                                                    if ((X = 2141891242 == (0 | i)) | e != e) break a;
                                                    if (Z) break n;
                                                    if (X) break a;
                                                    if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break t;
                                                }
                                                a = y(y(hr * a) * y(.009999999776482582));
                                            }
                                            if (a != a) break a;
                                            a = y(0);
                                            t: if (!t) {
                                                if (2140081935 == (0 | i)) break n;
                                                t = 4276;
                                                f: {
                                                    if (2141891242 != (0 | i)) {
                                                        if (e == e) break f;
                                                        t = 4268;
                                                    }
                                                    switch(a = m[t >> 2], G = y(NaN), c[t + 4 >> 2] - 1 | 0){
                                                        case 0:
                                                            break n;
                                                        case 1:
                                                            break t;
                                                        default:
                                                            break i;
                                                    }
                                                }
                                                if (b(2, 536870912 + (-1073741825 & i) | 0), a = d(), !(1073741824 & i)) break n;
                                            }
                                            G = y(y(hr * a) * y(.009999999776482582));
                                            break i;
                                        }
                                        G = a;
                                    }
                                    if ((e = y(y(y(G - R) - Gr) - y(F - B))) != e) break a;
                                    T = Re(e, y(0));
                                }
                                a: {
                                    if (!(X = g >>> 0 <= W >>> 0)) {
                                        for(z = c[r + 556 >> 2], j = (i = c[r + 560 >> 2] - z >> 2) >>> 0 < W >>> 0 ? W : i, Z = 0, i = W;;){
                                            if ((0 | i) == (0 | j)) break e;
                                            if (t = c[z + (i << 2) >> 2], 131072 != (196608 & c[t + 24 >> 2]) && (ve(tr = w + 24 | 0, t, O), Cr = c[w + 28 >> 2], de(tr, t, O), Z = ((3 == (0 | Cr)) + Z | 0) + (3 == c[w + 28 >> 2]) | 0), (0 | g) == (0 | (i = i + 1 | 0))) break;
                                        }
                                        if (C = y(0), a = _, Z) break a;
                                    }
                                    C = y(0), Z = 0, a = _;
                                    i: switch((c[r + 24 >> 2] >>> 4 & 7) - 1 | 0){
                                        case 0:
                                            C = y(T * y(.5));
                                            break a;
                                        case 1:
                                            C = T;
                                            break a;
                                        case 2:
                                            if (Y >>> 0 < 2) break a;
                                            a = y(_ + y((fe = y(0), oe = Re(T, y(0)), ((te = T != T) ? fe : oe) / y(Y - 1 >>> 0))));
                                            break a;
                                        case 4:
                                            C = y(T / y(Y + 1 >>> 0)), a = y(_ + C);
                                            break a;
                                        case 3:
                                            break i;
                                        default:
                                            break a;
                                    }
                                    C = y(y(T * y(.5)) / y(Y >>> 0)), a = y(y(C + C) + _);
                                }
                                if (e = y(R + C), B = y(0), Y = Jr(r), X) a = y(0);
                                else {
                                    for(z = g - 1 | 0, Zr = y(T / y(0 | Z)), R = y(0), G = y(0), i = W;;){
                                        if (t = c[r + 556 >> 2], c[r + 560 >> 2] - t >> 2 >>> 0 <= i >>> 0) break e;
                                        Ar(w + 24 | 0, Z = (t = c[t + (i << 2) >> 2]) + 228 | 0, 320), a = y(a - ((0 | i) == (0 | z) ? _ : y(0)));
                                        a: if (!(4194304 & (j = c[t + 24 >> 2]))) {
                                            i: {
                                                if (131072 == (196608 & j)) {
                                                    if (!se(t, O)) break i;
                                                    if (!s) break a;
                                                    T = Lr(t, O, F), x = zr(r, O), Sr = Mr(t, O, V), m[Z + (c[$ >> 2] << 2) >> 2] = Sr + y(T + x);
                                                    break a;
                                                }
                                                if (ve(w + 360 | 0, t, O), e = y(e + (3 == c[w + 364 >> 2] ? Zr : y(-0))), s && (j = Z, Z = c[$ >> 2] << 2, m[j + Z >> 2] = e + m[Z + (w + 24 | 0) >> 2]), de(w + 360 | 0, t, O), e = y(e + (3 == c[w + 364 >> 2] ? Zr : y(-0))), !ee) {
                                                    e = y(e + y(y(a + y(Mr(t, O, V) + Ur(t, O, V))) + m[w + 104 >> 2])), B = M;
                                                    break a;
                                                }
                                                if (e = y(e + y(a + y(m[(Z = t + 516 | 0) + (c[dr >> 2] << 2) >> 2] + y(Mr(t, O, V) + Ur(t, O, V))))), Y) {
                                                    if (T = Wr(t), x = Mr(t, 0, V), T = y(T + x), x = y(y(m[t + 520 >> 2] + y(Mr(t, 0, V) + Ur(t, 0, V))) - T), R = (t = R != R) | T != T ? t ? T : R : Re(R, T), !((t = G != G) | x != x)) {
                                                        G = Re(G, x);
                                                        break a;
                                                    }
                                                    G = t ? x : G;
                                                    break a;
                                                }
                                                if (!((T = y(m[Z + (c[Q >> 2] << 2) >> 2] + y(Mr(t, N, V) + Ur(t, N, V)))) != T | (t = B != B))) {
                                                    B = Re(B, T);
                                                    break a;
                                                }
                                                B = t ? T : B;
                                                break a;
                                            }
                                            s && (t = c[$ >> 2] << 2, T = m[t + (w + 24 | 0) >> 2], te = t + Z | 0, fe = y(C + y(T + zr(r, O))), m[te >> 2] = fe);
                                        }
                                        if ((0 | g) == (0 | (i = i + 1 | 0))) break;
                                    }
                                    a = y(G + R);
                                }
                                if (R = Y ? a : B, T = M, $r || (a = (i = (a = ur(r, N, y(K + R), Er)) != a) | (G = y(y(Br(r, N, o) + zr(r, N)) + y(Tr(r, N, o) + Qr(r, N)))) != G ? i ? G : a : Re(a, G), T = y(a - K)), a = (i = (a = ur(r, N, y(K + (re ? M : R)), Er)) != a) | (G = y(y(Br(r, N, o) + zr(r, N)) + y(Tr(r, N, o) + Qr(r, N)))) != G ? i ? G : a : Re(a, G), G = y(a - K), !(X | !s)) for(;;){
                                    if (i = c[r + 556 >> 2], c[r + 560 >> 2] - i >> 2 >>> 0 <= W >>> 0) break e;
                                    i = c[i + (W << 2) >> 2];
                                    a: if (!(4194304 & (t = c[i + 24 >> 2]))) {
                                        if (131072 != (196608 & t)) {
                                            (t = t >>> 13 & 7) || (t = c[r + 24 >> 2] >>> 10 & 7);
                                            i: {
                                                n: {
                                                    if (5 != (0 | t)) {
                                                        if (4 == (0 | t) && (ve(w + 24 | 0, i, N), t = 4, 3 != c[w + 28 >> 2])) {
                                                            if (de(w + 360 | 0, i, N), Z = c[Q >> 2], 3 == c[w + 364 >> 2]) break n;
                                                            R = m[572 + (Z = i + (Z << 3) | 0) >> 2];
                                                            t: {
                                                                switch(0 | (t = c[Z + 576 >> 2])){
                                                                    case 0:
                                                                    case 3:
                                                                        break t;
                                                                }
                                                                if (!(1 != (0 | t) | (B = m[Z + 572 >> 2]) != B)) {
                                                                    if (a = P, R < y(0)) break t;
                                                                    break i;
                                                                }
                                                                if (a = P, rr & !(R < y(0)) | 2 != (0 | t) | B != B) break i;
                                                            }
                                                            R = m[516 + (i + (c[dr >> 2] << 2) | 0) >> 2], a = (a = m[i + 224 >> 2]) == a ? y(y(Mr(i, N, V) + Ur(i, N, V)) + y(q ? R * a : R / a)) : G, m[w + 360 >> 2] = a, te = w, fe = y(R + y(Mr(i, O, V) + Ur(i, O, V))), m[te + 24 >> 2] = fe, c[w + 356 >> 2] = 1, c[w + 352 >> 2] = 1, Vr(i, O, F, V, w + 356 | 0, w + 24 | 0), Vr(i, N, M, V, w + 352 | 0, w + 360 | 0), R = m[w + 360 >> 2], B = m[w + 24 >> 2], a = (t = O >>> 0 > 1) ? R : B, or(i, R = t ? B : R, a, J, !((t = 0 != (0 | nr) & 512 != (896 & c[r + 24 >> 2])) & q | R != R), (q | !t) & a == a, V, U, 1, 2, A, l, h, p), a = P;
                                                            break i;
                                                        }
                                                    } else t = 8 & c[r + 24 >> 2] ? 5 : 1;
                                                    Z = c[Q >> 2];
                                                }
                                                if (a = m[516 + ((Z << 2) + i | 0) >> 2], R = Mr(i, N, V), B = Ur(i, N, V), ve(w + 24 | 0, i, N), R = y(T - y(a + y(R + B))), 3 != c[w + 28 >> 2] || (de(w + 360 | 0, i, N), 3 != c[w + 364 >> 2])) {
                                                    if (de(w + 24 | 0, i, N), a = P, 3 != c[w + 28 >> 2]) {
                                                        if (ve(w + 24 | 0, i, N), 3 != c[w + 28 >> 2]) {
                                                            switch(t - 1 | 0){
                                                                case 1:
                                                                    a = y(P + y(R * y(.5)));
                                                                    break i;
                                                                case 0:
                                                                    break i;
                                                            }
                                                            a = y(P + R);
                                                        } else a = y(P + (fe = y(0), oe = Re(R, y(0)), (te = R != R) ? fe : oe));
                                                    }
                                                } else a = y(R * y(.5)), a = y(P + (fe = y(0), oe = Re(a, y(0)), (te = a != a) ? fe : oe));
                                            }
                                            i = i + (c[H >> 2] << 2) | 0, m[i + 228 >> 2] = a + y(br + m[i + 228 >> 2]);
                                        } else {
                                            if (t = c[H >> 2], se(i, N) && (a = y(y(Lr(i, N, M) + zr(r, N)) + Mr(i, N, V)), m[228 + (i + (t << 2) | 0) >> 2] = a, a == a)) break a;
                                            te = i + (t << 2) | 0, fe = y(zr(r, N) + Mr(i, N, V)), m[te + 228 >> 2] = fe;
                                        }
                                    }
                                    if ((0 | (W = W + 1 | 0)) == (0 | g)) break;
                                }
                                if (a = y((S ? jr : y(0)) + G), Nr = (i = Nr != Nr) | (e = y(Gr + e)) != e ? i ? e : Nr : Re(Nr, e), br = y(br + a), i = S + 1 | 0, W = g, !(g >>> 0 < er >>> 0)) break;
                            }
                            a: if (s && (nr || Jr(r))) {
                                R = y(0);
                                i: {
                                    n: if (M == M) {
                                        e = y(M - br);
                                        t: switch((c[r + 24 >> 2] >>> 7 & 7) - 2 | 0){
                                            case 0:
                                                P = y(P + y(e * y(.5)));
                                                break n;
                                            case 2:
                                                if (!(M > br)) break n;
                                                R = y(e / y(i >>> 0));
                                                break n;
                                            case 5:
                                                if (M > br) {
                                                    if (P = y(P + y(e / y(i << 1 >>> 0))), i >>> 0 < 2) break n;
                                                    R = y(e / y(i >>> 0));
                                                    break i;
                                                }
                                                P = y(P + y(e * y(.5)));
                                                break n;
                                            case 4:
                                                if (!(M > br) | i >>> 0 < 2) break n;
                                                R = y(e / y(S >>> 0));
                                                break i;
                                            case 1:
                                                break t;
                                            default:
                                                break n;
                                        }
                                        P = y(P + e);
                                    }
                                    if (!i) break a;
                                }
                                for(Z = 0, i = 0, t = 0;;){
                                    if (B = y(0), a = y(0), e = y(0), G = y(0), g = i, i >>> 0 < er >>> 0) {
                                        i: {
                                            for(;;){
                                                if (t = c[r + 556 >> 2], c[r + 560 >> 2] - t >> 2 >>> 0 <= g >>> 0) break e;
                                                if (W = c[t + (g << 2) >> 2], !(4194304 & (X = c[W + 24 >> 2]) | 131072 == (196608 & X))) {
                                                    if (t = g, c[W + 548 >> 2] != (0 | Z)) break i;
                                                    (e = m[516 + (W + (c[Q >> 2] << 2) | 0) >> 2]) >= y(0) && (a = (t = a != a) | (e = y(e + y(Mr(W, N, V) + Ur(W, N, V)))) != e ? t ? e : a : Re(a, e)), (t = X >>> 13 & 7) || (t = c[r + 24 >> 2] >>> 10 & 7), !(8 & v[r + 24 | 0]) | 5 != (0 | t) || (e = Wr(W), T = Mr(W, 0, V), e = y(e + T), T = y(y(m[W + 520 >> 2] + y(Mr(W, 0, V) + Ur(W, 0, V))) - e), t = a != a, G = (W = G != G) | e != e ? W ? e : G : Re(G, e), B = (W = B != B) | T != T ? W ? T : B : Re(B, T), a = t | (e = y(G + B)) != e ? t ? e : a : Re(a, e));
                                                }
                                                if ((0 | er) == (0 | (g = g + 1 | 0))) break;
                                            }
                                            t = er;
                                        }
                                        e = a;
                                    }
                                    if (T = y(P + (Z ? jr : y(0))), a = y(R + e), P = y(T + a), i >>> 0 < t >>> 0) for(_ = y(T + G);;){
                                        if (g = c[r + 556 >> 2], c[r + 560 >> 2] - g >> 2 >>> 0 <= i >>> 0) break e;
                                        W = c[g + (i << 2) >> 2];
                                        i: if (!(4194304 & (g = c[W + 24 >> 2]) | 131072 == (196608 & g))) {
                                            (g = g >>> 13 & 7) || (g = c[r + 24 >> 2] >>> 10 & 7);
                                            n: {
                                                t: switch(g - 1 | 0){
                                                    case 4:
                                                        if (8 & v[r + 24 | 0]) break n;
                                                    case 0:
                                                        e = Mr(W, N, V), m[228 + (W + (c[H >> 2] << 2) | 0) >> 2] = T + e;
                                                        break i;
                                                    case 2:
                                                        e = Ur(W, N, V), m[(g = W + 228 | 0) + (c[H >> 2] << 2) >> 2] = y(P - e) - m[288 + (g + (c[Q >> 2] << 2) | 0) >> 2];
                                                        break i;
                                                    case 1:
                                                        m[(g = W + 228 | 0) + (c[H >> 2] << 2) >> 2] = T + y(y(a - m[288 + (g + (c[Q >> 2] << 2) | 0) >> 2]) * y(.5));
                                                        break i;
                                                    case 3:
                                                        break t;
                                                    default:
                                                        break i;
                                                }
                                                e = Mr(W, N, V), m[228 + (W + (c[H >> 2] << 2) | 0) >> 2] = T + e, X = W + (c[Q >> 2] << 3) | 0, e = m[(g = X) + 572 >> 2];
                                                t: {
                                                    switch(0 | (g = c[g + 576 >> 2])){
                                                        case 0:
                                                        case 3:
                                                            break t;
                                                    }
                                                    if (!(1 != (0 | g) | (G = m[X + 572 >> 2]) != G)) {
                                                        if (e < y(0)) break t;
                                                        break i;
                                                    }
                                                    if (rr & !(e < y(0)) | 2 != (0 | g) | G != G) break i;
                                                }
                                                O >>> 0 >= 2 ? (B = a, e = m[W + 516 >> 2], G = y(e + y(Mr(W, O, V) + Ur(W, O, V)))) : (B = y(m[W + 520 >> 2] + y(Mr(W, N, V) + Ur(W, N, V))), e = m[W + 516 >> 2], G = a);
                                                t: {
                                                    f: {
                                                        if (!(G != G | e != e)) {
                                                            if (y(E(y(G - e))) < y(9999999747378752e-20)) break f;
                                                            break t;
                                                        }
                                                        if (G == G | e == e) break t;
                                                    }
                                                    if (!((g = (e = m[W + 520 >> 2]) != e) | B != B)) {
                                                        if (!(y(E(y(B - e))) < y(9999999747378752e-20))) break t;
                                                        break i;
                                                    }
                                                    if (B != B && g) break i;
                                                }
                                                or(W, G, B, J, 1, 1, V, U, 1, 3, A, l, h, p);
                                                break i;
                                            }
                                            te = W, fe = y(y(_ - Wr(W)) + Lr(W, 0, M)), m[te + 232 >> 2] = fe;
                                        }
                                        if ((0 | t) == (0 | (i = i + 1 | 0))) break;
                                    }
                                    if (g = (0 | Z) != (0 | S), Z = Z + 1 | 0, i = t, !g) break;
                                }
                            }
                            Z = r + 516 | 0, e = (i = (e = ur(r, 2, Yr, o)) != e) | (a = y(y(Br(r, 2, o) + zr(r, 2)) + y(Tr(r, 2, o) + Qr(r, 2)))) != a ? i ? a : e : Re(e, a), m[Z >> 2] = e, e = (i = (e = ur(r, 0, Hr, u)) != e) | (a = y(y(Br(r, 0, o) + zr(r, 0)) + y(Tr(r, 0, o) + Qr(r, 0)))) != a ? i ? a : e : Re(e, a), m[r + 520 >> 2] = e;
                            a: {
                                i: if (cr && 2 == (0 | (i = c[r + 24 >> 2] >>> 20 & 3)) | 2 != (0 | cr)) {
                                    if (2 != (0 | cr) | 2 != (0 | i)) break a;
                                    e = (i = (e = (i = (a = y(ir + F)) != a) | (e = ur(r, O, Nr, hr)) != e ? i ? e : a : ge(a, e)) != e) | ir != ir ? i ? ir : e : Re(e, ir);
                                } else {
                                    if (!((i = (e = ur(r, O, Nr, hr)) != e) | (a = y(y(Br(r, O, o) + zr(r, O)) + y(Tr(r, O, o) + Qr(r, O)))) != a)) {
                                        e = Re(e, a);
                                        break i;
                                    }
                                    e = i ? a : e;
                                }
                                m[Z + (c[dr >> 2] << 2) >> 2] = e;
                            }
                            a: {
                                i: if (L && (t = 2 != (0 | L)) | 2 == (0 | (i = c[r + 24 >> 2] >>> 20 & 3))) {
                                    if (t | 2 != (0 | i)) break a;
                                    e = (i = (e = (i = (a = y(K + M)) != a) | (e = ur(r, N, y(K + br), Er)) != e ? i ? e : a : ge(a, e)) != e) | K != K ? i ? K : e : Re(e, K);
                                } else {
                                    if (!((i = (e = ur(r, N, y(K + br), Er)) != e) | (a = y(y(Br(r, N, o) + zr(r, N)) + y(Tr(r, N, o) + Qr(r, N)))) != a)) {
                                        e = Re(e, a);
                                        break i;
                                    }
                                    e = i ? a : e;
                                }
                                m[Z + (c[Q >> 2] << 2) >> 2] = e;
                            }
                            if (s) {
                                if (i = c[r + 560 >> 2], W = c[r + 556 >> 2], 524288 == (786432 & c[r + 24 >> 2])) {
                                    for(t = er >>> 0 <= 1 ? 1 : er, s = i - W >> 2, i = 0; g = 0, g = i >>> 0 < s >>> 0 ? c[(i << 2) + W >> 2] : g, 131072 != (196608 & c[g + 24 >> 2]) && (X = (g = g + 228 | 0) + (c[H >> 2] << 2) | 0, S = c[Q >> 2] << 2, m[X >> 2] = y(m[S + Z >> 2] - m[X >> 2]) - m[288 + (g + S | 0) >> 2]), (0 | t) != (0 | (i = i + 1 | 0)););
                                    W = c[r + 556 >> 2], i = c[r + 560 >> 2];
                                }
                                if ((0 | i) != (0 | W)) for(S = 0 != (0 | (O >>> 0 > 1 ? cr : n));;){
                                    s = c[W >> 2];
                                    a: if (131072 == (4390912 & c[s + 24 >> 2])) {
                                        a = V, F = U, v[c[r + 568 >> 2] + 21 | 0] && (F = m[r + 520 >> 2], a = m[r + 516 >> 2]), n = c[r + 24 >> 2] >>> 2 & 3;
                                        i: {
                                            n: {
                                                if (2 == (0 | J)) {
                                                    t = 0, g = 3;
                                                    t: switch(n - 2 | 0){
                                                        case 0:
                                                            break i;
                                                        case 1:
                                                            break t;
                                                        default:
                                                            break n;
                                                    }
                                                    g = 2;
                                                    break i;
                                                }
                                                if (t = 0, !(n >>> 0 <= 1)) {
                                                    g = n;
                                                    break i;
                                                }
                                            }
                                            g = n, t = lr;
                                        }
                                        u = y(Mr(s, 2, a) + Ur(s, 2, a)), R = Mr(s, 0, a), B = Ur(s, 0, a), e = m[s + 572 >> 2];
                                        i: {
                                            n: {
                                                switch(0 | (n = c[s + 576 >> 2])){
                                                    case 0:
                                                    case 3:
                                                        break n;
                                                }
                                                t: {
                                                    if (!(1 != (0 | n) | (o = m[s + 572 >> 2]) != o)) {
                                                        if (G = e, !(e < y(0))) break t;
                                                        break n;
                                                    }
                                                    f: {
                                                        if (2 != (0 | n) | o != o) {
                                                            G = y(NaN);
                                                            o: switch(n - 1 | 0){
                                                                case 1:
                                                                    break f;
                                                                case 0:
                                                                    break o;
                                                                default:
                                                                    break t;
                                                            }
                                                            G = e;
                                                            break t;
                                                        }
                                                        if (a != a | e < y(0)) break n;
                                                    }
                                                    G = y(y(a * e) * y(.009999999776482582));
                                                }
                                                G = y(u + G);
                                                break i;
                                            }
                                            G = y(NaN), se(s, 2) && be(s, 2) && (G = (n = (e = ur(s, 2, y(y(m[r + 516 >> 2] - y(zr(r, 2) + Qr(r, 2))) - y(Lr(s, 2, a) + Or(s, 2, a))), a)) != e) | (o = y(y(Br(s, 2, a) + zr(s, 2)) + y(Tr(s, 2, a) + Qr(s, 2)))) != o ? n ? o : e : Re(e, o));
                                        }
                                        B = y(R + B);
                                        i: {
                                            n: {
                                                t: {
                                                    f: {
                                                        o: {
                                                            c: {
                                                                u: {
                                                                    X = G != G, o = m[s + 580 >> 2];
                                                                    b: {
                                                                        s: {
                                                                            switch(0 | (n = c[s + 584 >> 2])){
                                                                                case 0:
                                                                                case 3:
                                                                                    break s;
                                                                            }
                                                                            A: {
                                                                                if (!(1 != (0 | n) | (e = m[s + 580 >> 2]) != e)) {
                                                                                    if (!((e = o) < y(0))) break A;
                                                                                    break s;
                                                                                }
                                                                                k: {
                                                                                    if (2 != (0 | n) | e != e) {
                                                                                        e = y(NaN);
                                                                                        l: switch(n - 1 | 0){
                                                                                            case 1:
                                                                                                break k;
                                                                                            case 0:
                                                                                                break l;
                                                                                            default:
                                                                                                break A;
                                                                                        }
                                                                                        e = o;
                                                                                        break A;
                                                                                    }
                                                                                    if (F != F | o < y(0)) break s;
                                                                                }
                                                                                e = y(y(F * o) * y(.009999999776482582));
                                                                            }
                                                                            e = y(B + e);
                                                                            break b;
                                                                        }
                                                                        if (!se(s, 0) || !be(s, 0)) {
                                                                            if (e = y(NaN), G == G) break u;
                                                                            break t;
                                                                        }
                                                                        e = (n = (e = ur(s, 0, y(y(m[r + 520 >> 2] - y(zr(r, 0) + Qr(r, 0))) - y(Lr(s, 0, F) + Or(s, 0, F))), F)) != e) | (o = y(y(Br(s, 0, a) + zr(s, 0)) + y(Tr(s, 0, a) + Qr(s, 0)))) != o ? n ? o : e : Re(e, o);
                                                                    }
                                                                    if ((0 | X) == (e != e | 0)) break o;
                                                                    if ((R = m[s + 224 >> 2]) != R) break o;
                                                                    if (G != G) {
                                                                        G = y(y(y(e - B) * R) + u);
                                                                        break o;
                                                                    }
                                                                    if (e == e) break o;
                                                                    break c;
                                                                }
                                                                if ((R = m[s + 224 >> 2]) != R) break f;
                                                            }
                                                            e = y(B + y(y(G - u) / R));
                                                        }
                                                        if (G != G) break t;
                                                        if (e == e) break i;
                                                    }
                                                    n = 0;
                                                    break n;
                                                }
                                                n = 1;
                                            }
                                            X = a > y(0), Y = n & S & g >>> 0 < 2, n ^= 1, or(s, o = Y && X ? a : G, e, J, Y && X ? 2 : n, e == e, o, e, 0, 6, A, l, h, p), G = y(m[s + 516 >> 2] + Ue(s, 2, a)), e = y(m[s + 520 >> 2] + Ue(s, 0, a));
                                        }
                                        or(s, G, e, J, 1, 1, G, e, 1, 1, A, l, h, p), u = (n = g >>> 0 < 2) ? a : F, X = c[r + 568 >> 2], o = v[X + 22 | 0] ? u : a;
                                        i: {
                                            if (!be(s, g) || se(s, g)) {
                                                if (se(s, g) | 16 != (112 & c[r + 24 >> 2])) {
                                                    if (se(s, g) | 32 != (112 & c[r + 24 >> 2])) {
                                                        if (!v[X + 21 | 0]) break i;
                                                        if (!se(s, g)) break i;
                                                        e = m[Z + (c[4252 + (g << 2) >> 2] << 2) >> 2], e = y(y(Lr(s, g, e) + zr(r, g)) + Mr(s, g, e));
                                                    } else n = c[4252 + (g << 2) >> 2] << 2, e = y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]);
                                                } else n = c[4252 + (g << 2) >> 2] << 2, e = y(y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]) * y(.5));
                                            } else Y = c[4252 + (g << 2) >> 2] << 2, e = y(y(y(y(m[Y + Z >> 2] - m[516 + (s + Y | 0) >> 2]) - Qr(r, g)) - Ur(s, g, o)) - Or(s, g, n ? F : a));
                                            m[228 + (s + (c[4220 + (g << 2) >> 2] << 2) | 0) >> 2] = e;
                                        }
                                        i: if (!be(s, t) || se(s, t)) {
                                            if (se(s, t) || ((n = c[s + 24 >> 2] >>> 13 & 7) || (n = c[r + 24 >> 2] >>> 10 & 7), 2 != (0 | n))) {
                                                n: if (!se(s, t)) {
                                                    g = c[s + 24 >> 2] >>> 13 & 7, n = c[r + 24 >> 2];
                                                    t: {
                                                        if (!(5 != (0 | (g = g || n >>> 10 & 7)) | 8 & n)) {
                                                            if (524288 == (786432 & n)) break t;
                                                            break n;
                                                        }
                                                        if ((524288 == (786432 & n) | 0) == (3 == (0 | g) | 0)) break n;
                                                    }
                                                    n = c[4252 + (t << 2) >> 2] << 2, e = y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]);
                                                    break i;
                                                }
                                                if (!v[X + 21 | 0]) break a;
                                                if (!se(s, t)) break a;
                                                e = m[Z + (c[4252 + (t << 2) >> 2] << 2) >> 2], e = y(y(Lr(s, t, e) + zr(r, t)) + Mr(s, t, e));
                                            } else n = c[4252 + (t << 2) >> 2] << 2, e = y(y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]) * y(.5));
                                        } else n = c[4252 + (t << 2) >> 2] << 2, e = y(y(y(y(m[n + Z >> 2] - m[516 + (n + s | 0) >> 2]) - Qr(r, t)) - Ur(s, t, o)) - Or(s, t, u));
                                        m[228 + (s + (c[4220 + (t << 2) >> 2] << 2) | 0) >> 2] = e;
                                    }
                                    if ((0 | (W = W + 4 | 0)) == (0 | i)) break;
                                }
                                if (1 & (N | O)) for(t = 1 & N, s = 1 & O, A = er >>> 0 <= 1 ? 1 : er, l = 4236 + (N << 2) | 0, h = 4236 + (O << 2) | 0, p = c[r + 556 >> 2], N = c[r + 560 >> 2] - p >> 2, i = 0;;){
                                    if ((0 | i) == (0 | N)) break e;
                                    if (r = c[p + (i << 2) >> 2], 64 & v[r + 26 | 0] || (s && (n = r + 228 | 0, g = c[dr >> 2] << 2, m[n + (c[h >> 2] << 2) >> 2] = y(m[g + Z >> 2] - m[288 + (n + g | 0) >> 2]) - m[n + (c[$ >> 2] << 2) >> 2]), t && (r = r + 228 | 0, n = c[Q >> 2] << 2, m[r + (c[l >> 2] << 2) >> 2] = y(m[n + Z >> 2] - m[288 + (r + n | 0) >> 2]) - m[r + (c[H >> 2] << 2) >> 2])), (0 | A) == (0 | (i = i + 1 | 0))) break;
                                }
                            }
                            if (!D) break r;
                            gr(D);
                            break r;
                        }
                        I(), k();
                    }
                    ar = w + 384 | 0;
                }
                function tr() {
                    var r = 0, e = 0;
                    T(6952, 6953, 6954, 0, 4284, 17, 4287, 0, 4287, 0, 2528, 4289, 18), r = ye(8), c[r >> 2] = 8, c[r + 4 >> 2] = 1, Z(6952, 2873, 6, 4304, 4328, 19, 0 | r, 1), T(6956, 6957, 6958, 6952, 4284, 20, 4284, 21, 4284, 22, 2e3, 4289, 23), r = ye(4), c[r >> 2] = 24, Z(6956, 2358, 2, 4336, 4344, 25, 0 | r, 0), V(6952, 1397, 2, 4348, 4356, 26, 27), V(6952, 2978, 3, 4436, 4448, 28, 29), T(6976, 6977, 6978, 0, 4284, 30, 4287, 0, 4287, 0, 2544, 4289, 31), r = ye(8), c[r >> 2] = 8, c[r + 4 >> 2] = 1, Z(6976, 3244, 2, 4456, 4344, 32, 0 | r, 1), T(6979, 6980, 6981, 6976, 4284, 33, 4284, 34, 4284, 35, 2023, 4289, 36), r = ye(4), c[r >> 2] = 37, Z(6979, 2358, 2, 4464, 4344, 38, 0 | r, 0), V(6976, 1397, 2, 4472, 4356, 39, 40), V(6976, 2978, 3, 4436, 4448, 28, 41), T(6982, 6983, 6984, 0, 4284, 42, 4287, 0, 4287, 0, 2812, 4289, 43), Y(6982, 1, 4520, 4284, 44, 45), V(6982, 2866, 1, 4520, 4284, 44, 45), V(6982, 1128, 2, 4524, 4344, 46, 47), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 48, Z(6982, 3185, 4, 4544, 4560, 49, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 50, Z(6982, 1980, 3, 4568, 4580, 51, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 52, Z(6982, 1951, 3, 4588, 4600, 53, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 54, Z(6982, 1799, 3, 4588, 4600, 53, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 55, Z(6982, 3215, 3, 4608, 4448, 56, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 57, Z(6982, 1925, 2, 4620, 4356, 58, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 59, Z(6982, 1784, 2, 4620, 4356, 58, 0 | r, 0), F(6985, 1270, 4628, 60, 4289, 61), Be(1731, 0), Be(1611, 8), Be(2144, 16), Be(2454, 24), Be(2560, 32), Be(1617, 40), _(6985), F(6955, 2849, 4628, 62, 4289, 63), Ve(2560, 0), Ve(1617, 8), _(6955), F(6986, 2860, 4628, 64, 4289, 65), r = ye(4), c[r >> 2] = 8, e = ye(4), c[e >> 2] = 8, O(6986, 2854, 7018, 4630, 66, 0 | r, 7018, 4634, 67, 0 | e), r = ye(4), c[r >> 2] = 0, e = ye(4), c[e >> 2] = 0, O(6986, 1606, 7011, 4356, 68, 0 | r, 7011, 4600, 69, 0 | e), _(6986), T(6987, 6988, 6989, 0, 4284, 70, 4287, 0, 4287, 0, 2973, 4289, 71), Y(6987, 1, 4640, 4284, 72, 73), V(6987, 1592, 1, 4640, 4284, 72, 73), V(6987, 2802, 2, 4644, 4356, 74, 75), V(6987, 1128, 2, 4652, 4344, 76, 77), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 78, Z(6987, 1752, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 80, Z(6987, 2956, 3, 4660, 4600, 81, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 82, Z(6987, 2881, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 84, Z(6987, 2334, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 86, Z(6987, 1484, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 87, Z(6987, 1355, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 88, Z(6987, 1817, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 89, Z(6987, 2823, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 90, Z(6987, 2378, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 91, Z(6987, 2163, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 92, Z(6987, 1319, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 93, Z(6987, 2412, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 94, Z(6987, 1503, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 95, Z(6987, 2235, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 96, Z(6987, 1219, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 97, Z(6987, 1136, 3, 4672, 4600, 83, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 98, Z(6987, 1158, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 100, Z(6987, 1845, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 101, Z(6987, 1464, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 102, Z(6987, 2218, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 103, Z(6987, 1195, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 104, Z(6987, 2500, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 105, Z(6987, 2590, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 106, Z(6987, 1539, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 107, Z(6987, 2249, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 108, Z(6987, 1650, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 109, Z(6987, 1427, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 110, Z(6987, 2204, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 111, Z(6987, 2608, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 112, Z(6987, 1555, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 113, Z(6987, 1670, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 114, Z(6987, 1444, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 115, Z(6987, 2566, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 116, Z(6987, 1520, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 117, Z(6987, 1624, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 118, Z(6987, 1407, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 119, Z(6987, 2304, 3, 4712, 4634, 99, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 120, Z(6987, 2092, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 121, Z(6987, 2718, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 122, Z(6987, 1574, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 123, Z(6987, 2187, 4, 4688, 4704, 85, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 124, Z(6987, 2897, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 126, Z(6987, 2346, 3, 4732, 4448, 127, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 128, Z(6987, 1371, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 129, Z(6987, 1831, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 130, Z(6987, 2836, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 131, Z(6987, 2395, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 132, Z(6987, 2175, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 133, Z(6987, 1337, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 134, Z(6987, 2422, 3, 4732, 4448, 127, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 135, Z(6987, 1858, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 137, Z(6987, 1207, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 139, Z(6987, 2514, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 140, Z(6987, 2599, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 141, Z(6987, 1660, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 142, Z(6987, 2620, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 143, Z(6987, 1683, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 144, Z(6987, 2578, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 145, Z(6987, 1637, 2, 4744, 4356, 136, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 146, Z(6987, 2319, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 147, Z(6987, 2102, 3, 4760, 4772, 148, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 149, Z(6987, 1231, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 150, Z(6987, 1147, 2, 4724, 4356, 125, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 151, Z(6987, 2729, 3, 4732, 4448, 127, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 152, Z(6987, 2194, 3, 4780, 4792, 153, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 154, Z(6987, 2985, 4, 4800, 4560, 155, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 156, Z(6987, 3006, 3, 4816, 4600, 157, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 158, Z(6987, 1292, 2, 4828, 4356, 159, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 160, Z(6987, 1387, 2, 4836, 4356, 161, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 162, Z(6987, 2997, 3, 4844, 4448, 163, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 164, Z(6987, 2913, 2, 4856, 4356, 165, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 166, Z(6987, 2933, 3, 4864, 4600, 167, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 168, Z(6987, 3308, 3, 4876, 4600, 169, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 170, Z(6987, 3306, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 171, Z(6987, 3325, 3, 4888, 4600, 172, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 173, Z(6987, 3323, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 174, Z(6987, 1118, 2, 4652, 4344, 79, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 175, Z(6987, 1110, 2, 4900, 4356, 176, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 177, Z(6987, 1243, 5, 4912, 4932, 178, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 179, Z(6987, 1736, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 180, Z(6987, 1714, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 181, Z(6987, 2148, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 182, Z(6987, 2461, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 183, Z(6987, 2632, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 184, Z(6987, 1696, 2, 4752, 4630, 138, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 185, Z(6987, 1259, 2, 4940, 4356, 186, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 187, Z(6987, 2432, 3, 4760, 4772, 148, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 188, Z(6987, 2112, 3, 4760, 4772, 148, 0 | r, 0), r = ye(8), c[r + 4 >> 2] = 0, c[r >> 2] = 189, Z(6987, 2740, 3, 4760, 4772, 148, 0 | r, 0);
                }
                function fr(r, e, a, i, n, t, u) {
                    var b, s, A, k = 0, l = 0, d = 0, h = 0, p = 0, m = 0, y = 0, E = 0, G = 0, R = 0, g = 0, Z = 0, W = 0, V = 0, B = 0, T = 0, I = 0;
                    ar = b = ar - 80 | 0, c[b + 76 >> 2] = e, A = b + 55 | 0, s = b + 56 | 0;
                    r: {
                        e: {
                            a: {
                                i: {
                                    n: for(;;){
                                        if (d = e, (2147483647 ^ E) < (0 | k)) break i;
                                        E = k + E | 0;
                                        t: {
                                            f: {
                                                o: {
                                                    if (l = v[0 | (k = d)]) for(;;){
                                                        c: {
                                                            u: if (e = 255 & l) {
                                                                if (37 != (0 | e)) break c;
                                                                for(l = k;;){
                                                                    if (37 != v[l + 1 | 0]) {
                                                                        e = l;
                                                                        break u;
                                                                    }
                                                                    if (k = k + 1 | 0, h = v[l + 2 | 0], l = e = l + 2 | 0, 37 != (0 | h)) break;
                                                                }
                                                            } else e = k;
                                                            if ((0 | (k = k - d | 0)) > (0 | (B = 2147483647 ^ E))) break i;
                                                            if (r && Pr(r, d, k), k) continue n;
                                                            c[b + 76 >> 2] = e, k = e + 1 | 0, R = -1, !xe(l = f[e + 1 | 0]) | 36 != v[e + 2 | 0] || (R = l - 48 | 0, Z = 1, k = e + 3 | 0), c[b + 76 >> 2] = k, y = 0;
                                                            u: if ((e = (l = f[0 | k]) - 32 | 0) >>> 0 > 31) h = k;
                                                            else if (h = k, 75913 & (e = 1 << e)) for(;;){
                                                                if (h = k + 1 | 0, c[b + 76 >> 2] = h, y |= e, (e = (l = f[k + 1 | 0]) - 32 | 0) >>> 0 >= 32) break u;
                                                                if (k = h, !(75913 & (e = 1 << e))) break;
                                                            }
                                                            u: if (42 != (0 | l)) {
                                                                if ((0 | (G = he(b + 76 | 0))) < 0) break i;
                                                                l = c[b + 76 >> 2];
                                                            } else {
                                                                if (!xe(e = f[h + 1 | 0]) | 36 != v[h + 2 | 0]) {
                                                                    if (Z) break o;
                                                                    if (l = h + 1 | 0, !r) {
                                                                        c[b + 76 >> 2] = l, Z = 0, G = 0;
                                                                        break u;
                                                                    }
                                                                    e = c[a >> 2], c[a >> 2] = e + 4, Z = 0, G = c[e >> 2];
                                                                } else c[((e << 2) + n | 0) - 192 >> 2] = 10, l = h + 3 | 0, Z = 1, G = c[((f[h + 1 | 0] << 3) + i | 0) - 384 >> 2];
                                                                if (c[b + 76 >> 2] = l, (0 | G) >= 0) break u;
                                                                G = 0 - G | 0, y |= 8192;
                                                            }
                                                            if (k = 0, m = -1, 46 == v[0 | l]) {
                                                                if (42 != v[l + 1 | 0]) c[b + 76 >> 2] = l + 1, m = he(b + 76 | 0), e = c[b + 76 >> 2], g = 1;
                                                                else {
                                                                    if (!xe(e = f[l + 2 | 0]) | 36 != v[l + 3 | 0]) {
                                                                        if (Z) break o;
                                                                        e = l + 2 | 0, m = 0, r && (l = c[a >> 2], c[a >> 2] = l + 4, m = c[l >> 2]);
                                                                    } else c[((e << 2) + n | 0) - 192 >> 2] = 10, e = l + 4 | 0, m = c[((f[l + 2 | 0] << 3) + i | 0) - 384 >> 2];
                                                                    c[b + 76 >> 2] = e, g = (-1 ^ m) >>> 31 | 0;
                                                                }
                                                            } else e = l, g = 0;
                                                            for(;;){
                                                                if (p = k, h = 28, W = e, (k = f[0 | e]) - 123 >>> 0 < 4294967238) break a;
                                                                if (e = W + 1 | 0, !((k = v[4895 + (k + w(p, 58) | 0) | 0]) - 1 >>> 0 < 8)) break;
                                                            }
                                                            c[b + 76 >> 2] = e;
                                                            u: {
                                                                b: {
                                                                    if (27 != (0 | k)) {
                                                                        if (!k) break a;
                                                                        if ((0 | R) >= 0) {
                                                                            c[(R << 2) + n >> 2] = k, l = c[4 + (k = (R << 3) + i | 0) >> 2], c[b + 64 >> 2] = c[k >> 2], c[b + 68 >> 2] = l;
                                                                            break b;
                                                                        }
                                                                        if (!r) break t;
                                                                        yr(b - -64 | 0, k, a, u);
                                                                        break u;
                                                                    }
                                                                    if ((0 | R) >= 0) break a;
                                                                }
                                                                if (k = 0, !r) continue n;
                                                            }
                                                            l = -65537 & y, y = 8192 & y ? l : y, R = 0, V = 1166, h = s;
                                                            u: {
                                                                b: {
                                                                    s: {
                                                                        A: {
                                                                            k: {
                                                                                l: {
                                                                                    d: {
                                                                                        v: {
                                                                                            h: {
                                                                                                p: {
                                                                                                    m: {
                                                                                                        N: {
                                                                                                            w: {
                                                                                                                y: {
                                                                                                                    E: {
                                                                                                                        switch(k = f[0 | W], (k = p && 3 == (15 & k) ? -33 & k : k) - 88 | 0){
                                                                                                                            case 11:
                                                                                                                                break u;
                                                                                                                            case 9:
                                                                                                                            case 13:
                                                                                                                            case 14:
                                                                                                                            case 15:
                                                                                                                                break b;
                                                                                                                            case 27:
                                                                                                                                break d;
                                                                                                                            case 12:
                                                                                                                            case 17:
                                                                                                                                break p;
                                                                                                                            case 23:
                                                                                                                                break m;
                                                                                                                            case 0:
                                                                                                                            case 32:
                                                                                                                                break N;
                                                                                                                            case 24:
                                                                                                                                break w;
                                                                                                                            case 22:
                                                                                                                                break y;
                                                                                                                            case 29:
                                                                                                                                break E;
                                                                                                                            case 1:
                                                                                                                            case 2:
                                                                                                                            case 3:
                                                                                                                            case 4:
                                                                                                                            case 5:
                                                                                                                            case 6:
                                                                                                                            case 7:
                                                                                                                            case 8:
                                                                                                                            case 10:
                                                                                                                            case 16:
                                                                                                                            case 18:
                                                                                                                            case 19:
                                                                                                                            case 20:
                                                                                                                            case 21:
                                                                                                                            case 25:
                                                                                                                            case 26:
                                                                                                                            case 28:
                                                                                                                            case 30:
                                                                                                                            case 31:
                                                                                                                                break f;
                                                                                                                        }
                                                                                                                        switch(k - 65 | 0){
                                                                                                                            case 0:
                                                                                                                            case 4:
                                                                                                                            case 5:
                                                                                                                            case 6:
                                                                                                                                break b;
                                                                                                                            case 2:
                                                                                                                                break k;
                                                                                                                            case 1:
                                                                                                                            case 3:
                                                                                                                                break f;
                                                                                                                        }
                                                                                                                        if (83 == (0 | k)) break l;
                                                                                                                        break f;
                                                                                                                    }
                                                                                                                    l = c[b + 64 >> 2], p = c[b + 68 >> 2], k = 1166;
                                                                                                                    break h;
                                                                                                                }
                                                                                                                k = 0;
                                                                                                                y: switch(255 & p){
                                                                                                                    case 0:
                                                                                                                    case 1:
                                                                                                                    case 6:
                                                                                                                        c[c[b + 64 >> 2] >> 2] = E;
                                                                                                                        continue n;
                                                                                                                    case 2:
                                                                                                                        d = c[b + 64 >> 2], c[d >> 2] = E, c[d + 4 >> 2] = E >> 31;
                                                                                                                        continue n;
                                                                                                                    case 3:
                                                                                                                        o[c[b + 64 >> 2] >> 1] = E;
                                                                                                                        continue n;
                                                                                                                    case 4:
                                                                                                                        f[c[b + 64 >> 2]] = E;
                                                                                                                        continue n;
                                                                                                                    case 7:
                                                                                                                        break y;
                                                                                                                    default:
                                                                                                                        continue n;
                                                                                                                }
                                                                                                                d = c[b + 64 >> 2], c[d >> 2] = E, c[d + 4 >> 2] = E >> 31;
                                                                                                                continue n;
                                                                                                            }
                                                                                                            m = m >>> 0 <= 8 ? 8 : m, y |= 8, k = 120;
                                                                                                        }
                                                                                                        if (d = s, (l = c[b + 64 >> 2]) | (p = c[b + 68 >> 2])) for(T = 32 & k; f[0 | (d = d - 1 | 0)] = T | v[5424 + (15 & l) | 0], I = !p & l >>> 0 > 15 | 0 != (0 | p), W = p, p = p >>> 4 | 0, l = (15 & W) << 28 | l >>> 4, I;);
                                                                                                        if (!(8 & y) | !(c[b + 64 >> 2] | c[b + 68 >> 2])) break v;
                                                                                                        V = 1166 + (k >>> 4 | 0) | 0, R = 2;
                                                                                                        break v;
                                                                                                    }
                                                                                                    if (k = s, p = d = c[b + 68 >> 2], d | (l = c[b + 64 >> 2])) for(; f[0 | (k = k - 1 | 0)] = 7 & l | 48, W = !p & l >>> 0 > 7 | 0 != (0 | p), p = (d = p) >>> 3 | 0, l = (7 & d) << 29 | l >>> 3, W;);
                                                                                                    if (d = k, !(8 & y)) break v;
                                                                                                    m = (0 | (k = s - d | 0)) < (0 | m) ? m : k + 1 | 0;
                                                                                                    break v;
                                                                                                }
                                                                                                l = c[b + 64 >> 2], p = k = c[b + 68 >> 2], (0 | k) < 0 ? (p = d = 0 - (p + (0 != (0 | l)) | 0) | 0, l = 0 - l | 0, c[b + 64 >> 2] = l, c[b + 68 >> 2] = d, R = 1, k = 1166) : 2048 & y ? (R = 1, k = 1167) : k = (R = 1 & y) ? 1168 : 1166;
                                                                                            }
                                                                                            V = k, d = re(l, p, s);
                                                                                        }
                                                                                        if ((0 | m) < 0 && g) break i;
                                                                                        if (y = g ? -65537 & y : y, !(0 != ((k = c[b + 64 >> 2]) | (l = c[b + 68 >> 2])) | m)) {
                                                                                            d = s, m = 0;
                                                                                            break f;
                                                                                        }
                                                                                        m = (0 | (k = !(k | l) + (s - d | 0) | 0)) < (0 | m) ? m : k;
                                                                                        break f;
                                                                                    }
                                                                                    y = 0, h = 0 != (0 | (p = g = m >>> 0 >= 2147483647 ? 2147483647 : m));
                                                                                    d: {
                                                                                        v: {
                                                                                            h: {
                                                                                                p: {
                                                                                                    m: if (!((k = d = (k = c[b + 64 >> 2]) || 4208, false) | !p)) for(;;){
                                                                                                        if (!(y = v[0 | k])) break p;
                                                                                                        if (h = 0 != (0 | (p = p - 1 | 0)), !(3 & (k = k + 1 | 0))) break m;
                                                                                                        if (!p) break;
                                                                                                    }
                                                                                                    if (!h) break v;
                                                                                                    m: {
                                                                                                        if (!(!v[0 | k] | p >>> 0 < 4)) for(;;){
                                                                                                            if ((-1 ^ (h = c[k >> 2])) & h - 16843009 & -2139062144) break m;
                                                                                                            if (k = k + 4 | 0, !((p = p - 4 | 0) >>> 0 > 3)) break;
                                                                                                        }
                                                                                                        if (!p) break v;
                                                                                                    }
                                                                                                    h = 0;
                                                                                                    break h;
                                                                                                }
                                                                                                h = 1;
                                                                                            }
                                                                                            for(;;)if (h) {
                                                                                                if (!y) break d;
                                                                                                if (k = k + 1 | 0, !(p = p - 1 | 0)) break v;
                                                                                                h = 0;
                                                                                            } else y = v[0 | k], h = 1;
                                                                                        }
                                                                                        k = 0;
                                                                                    }
                                                                                    if (h = (k = k ? k - d | 0 : g) + d | 0, (0 | m) >= 0) {
                                                                                        y = l, m = k;
                                                                                        break f;
                                                                                    }
                                                                                    if (y = l, m = k, v[0 | h]) break i;
                                                                                    break f;
                                                                                }
                                                                                if (m) {
                                                                                    l = c[b + 64 >> 2];
                                                                                    break A;
                                                                                }
                                                                                k = 0, le(r, 32, G, 0, y);
                                                                                break s;
                                                                            }
                                                                            c[b + 12 >> 2] = 0, c[b + 8 >> 2] = c[b + 64 >> 2], l = b + 8 | 0, c[b + 64 >> 2] = l, m = -1;
                                                                        }
                                                                        k = 0;
                                                                        A: {
                                                                            for(;;){
                                                                                if (!(d = c[l >> 2])) break A;
                                                                                if (!((h = (0 | (d = We(b + 4 | 0, d))) < 0) | d >>> 0 > m - k >>> 0)) {
                                                                                    if (l = l + 4 | 0, m >>> 0 > (k = k + d | 0) >>> 0) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            if (h) break e;
                                                                        }
                                                                        if (h = 61, (0 | k) < 0) break a;
                                                                        if (le(r, 32, G, k, y), k) for(h = 0, l = c[b + 64 >> 2];;){
                                                                            if (!(d = c[l >> 2])) break s;
                                                                            if ((h = (d = We(b + 4 | 0, d)) + h | 0) >>> 0 > k >>> 0) break s;
                                                                            if (Pr(r, b + 4 | 0, d), l = l + 4 | 0, !(k >>> 0 > h >>> 0)) break;
                                                                        }
                                                                        else k = 0;
                                                                    }
                                                                    le(r, 32, G, k, 8192 ^ y), k = (0 | k) < (0 | G) ? G : k;
                                                                    continue n;
                                                                }
                                                                if ((0 | m) < 0 && g) break i;
                                                                if (h = 61, (0 | (k = 0 | aa[0 | t](r, N[b + 64 >> 3], G, m, y, k))) >= 0) continue n;
                                                                break a;
                                                            }
                                                            f[b + 55 | 0] = c[b + 64 >> 2], m = 1, d = A, y = l;
                                                            break f;
                                                        }
                                                        l = v[k + 1 | 0], k = k + 1 | 0;
                                                    }
                                                    if (r) break r;
                                                    if (!Z) break t;
                                                    for(k = 1;;){
                                                        if (r = c[(k << 2) + n >> 2]) {
                                                            if (yr((k << 3) + i | 0, r, a, u), E = 1, 10 != (0 | (k = k + 1 | 0))) continue;
                                                            break r;
                                                        }
                                                        break;
                                                    }
                                                    if (E = 1, k >>> 0 >= 10) break r;
                                                    for(;;){
                                                        if (c[(k << 2) + n >> 2]) break o;
                                                        if (10 == (0 | (k = k + 1 | 0))) break;
                                                    }
                                                    break r;
                                                }
                                                h = 28;
                                                break a;
                                            }
                                            if ((0 | (m = (0 | m) > (0 | (p = h - d | 0)) ? m : p)) > (2147483647 ^ R)) break i;
                                            if (h = 61, (0 | B) < (0 | (k = (0 | (l = m + R | 0)) < (0 | G) ? G : l))) break a;
                                            le(r, 32, k, l, y), Pr(r, V, R), le(r, 48, k, l, 65536 ^ y), le(r, 48, m, p, 0), Pr(r, d, p), le(r, 32, k, l, 8192 ^ y);
                                            continue;
                                        }
                                        break;
                                    }
                                    E = 0;
                                    break r;
                                }
                                h = 61;
                            }
                            c[1761] = h;
                        }
                        E = -1;
                    }
                    return ar = b + 80 | 0, E;
                }
                function or(r, e, a, i, n, t, o, u, b, s, A, k, l, d) {
                    var h, N = y(0), G = 0, R = 0, g = 0, Z = y(0), W = 0, V = 0, B = y(0);
                    (c[r + 312 >> 2] != (0 | d) && 4 & v[r + 4 | 0] || (W = 0, c[r + 316 >> 2] != (0 | i))) && (c[r + 540 >> 2] = -1082130432, c[r + 544 >> 2] = -1082130432, c[r + 532 >> 2] = 0, c[r + 536 >> 2] = 0, c[r + 524 >> 2] = -1082130432, c[r + 528 >> 2] = -1082130432, c[r + 320 >> 2] = 0, W = 1), h = l + 1 | 0;
                    r: {
                        e: {
                            a: {
                                i: if (c[r + 8 >> 2]) {
                                    if (Z = Mr(r, 2, o), B = Ur(r, 2, o), N = y(Mr(r, 0, o) + Ur(r, 0, o)), l = r + 524 | 0, Z = y(Z + B), lr(n, e, t, a, c[r + 532 >> 2], m[l >> 2], c[r + 536 >> 2], m[r + 528 >> 2], m[r + 540 >> 2], m[r + 544 >> 2], Z, N, A)) break a;
                                    if (!(R = c[r + 320 >> 2])) break i;
                                    for(G = r + 324 | 0;;){
                                        if (l = G + w(g, 24) | 0, lr(n, e, t, a, c[l + 8 >> 2], m[l >> 2], c[l + 12 >> 2], m[l + 4 >> 2], m[l + 16 >> 2], m[l + 20 >> 2], Z, N, A)) break a;
                                        if ((0 | R) == (0 | (g = g + 1 | 0))) break;
                                    }
                                } else {
                                    if (b) {
                                        n: {
                                            if (!((N = m[(l = r + 524 | 0) >> 2]) != N | e != e)) {
                                                if (y(E(y(N - e))) < y(9999999747378752e-20)) break n;
                                                break i;
                                            }
                                            if (N == N | e == e) break i;
                                        }
                                        G = c[r + 532 >> 2] == (0 | n) && c[r + 536 >> 2] == (0 | t) ? l : 0, (l = (N = m[r + 528 >> 2]) != N) | (R = a != a) ? l &= R : l = y(E(y(N - a))) < y(9999999747378752e-20), l = l ? G : 0;
                                        break a;
                                    }
                                    if (!(V = c[r + 320 >> 2])) break i;
                                    for(R = r + 324 | 0;;){
                                        G = w(g, 24);
                                        n: {
                                            t: {
                                                if (!((N = m[(l = G + R | 0) >> 2]) != N | e != e)) {
                                                    if (y(E(y(N - e))) < y(9999999747378752e-20)) break t;
                                                    break n;
                                                }
                                                if (N == N | e == e) break n;
                                            }
                                            t: {
                                                if (!((N = m[4 + (G = R + G | 0) >> 2]) != N | a != a)) {
                                                    if (y(E(y(N - a))) < y(9999999747378752e-20)) break t;
                                                    break n;
                                                }
                                                if (N == N | a == a) break n;
                                            }
                                            if (c[G + 8 >> 2] == (0 | n) && c[G + 12 >> 2] == (0 | t)) break a;
                                        }
                                        if ((0 | V) == (0 | (g = g + 1 | 0))) break;
                                    }
                                }
                                nr(r, e, a, i, n, t, o, u, b, A, k, h, d, s), c[r + 316 >> 2] = i;
                                break e;
                            }
                            if (!(!l | W)) {
                                m[r + 516 >> 2] = m[l + 16 >> 2], m[r + 520 >> 2] = m[l + 20 >> 2], c[(i = (b ? 12 : 16) + k | 0) >> 2] = c[i >> 2] + 1, i = 0;
                                break r;
                            }
                            if (nr(r, e, a, i, n, t, o, u, b, A, k, h, d, s), c[r + 316 >> 2] = i, i = 1, l) break r;
                        }
                        (i = (l = c[r + 320 >> 2]) + 1 | 0) >>> 0 > p[k + 8 >> 2] && (c[k + 8 >> 2] = i), 8 == (0 | l) && (c[r + 320 >> 2] = 0, l = 0), b ? i = r + 524 | 0 : (c[r + 320 >> 2] = l + 1, i = 324 + (w(l, 24) + r | 0) | 0), c[i + 12 >> 2] = t, c[i + 8 >> 2] = n, m[i + 4 >> 2] = a, m[i >> 2] = e, m[i + 16 >> 2] = m[r + 516 >> 2], m[i + 20 >> 2] = m[r + 520 >> 2], i = 1;
                    }
                    return b && (n = c[r + 520 >> 2], c[r + 244 >> 2] = c[r + 516 >> 2], c[r + 248 >> 2] = n, t = 1 | (n = v[r + 4 | 0]), f[r + 4 | 0] = t, 4 & n && (f[r + 4 | 0] = 251 & t)), c[r + 312 >> 2] = d, i;
                }
                function cr(r) {
                    var e = 0, a = 0, i = 0, n = 0, t = 0, f = 0, o = 0, u = 0, b = 0, s = 0, A = 0;
                    o = 8;
                    r: if (!((r |= 0) >>> 0 > 4294967239)) {
                        e: {
                            for(;;){
                                if (o = o >>> 0 <= 8 ? 8 : o, t = e = c[1731], n = c[1730], (r = r >>> 0 <= 8 ? 8 : r + 3 & -4) >>> 0 <= 127 ? f = (r >>> 3 | 0) - 1 | 0 : (f = 110 + ((r >>> 29 - (i = G(r)) ^ 4) - (i << 2) | 0) | 0, r >>> 0 <= 4095 || (f = (i = 71 + ((r >>> 30 - i ^ 2) - (i << 1) | 0) | 0) >>> 0 >= 63 ? 63 : i)), a = 31 & f, (63 & f) >>> 0 >= 32 ? (i = 0, e = e >>> a | 0) : (i = e >>> a | 0, e = ((1 << a) - 1 & e) << 32 - a | n >>> a), e | i) {
                                    for(;;){
                                        if (n = i, e | i ? (u = 1 + (a = i - 1 | 0) | 0, t = a, a = 63 - (i = 32 == (0 | (i = G(i ^ (t = -1 != (0 | (a = e - 1 | 0)) ? u : t)))) ? G(e ^ a) + 32 | 0 : i) | 0, ir = 0 - (i >>> 0 > 63) | 0) : (ir = 0, a = 64), a = 31 & (t = a), (63 & t) >>> 0 >= 32 ? (i = 0, e = n >>> a | 0) : (i = n >>> a | 0, e = ((1 << a) - 1 & n) << 32 - a | e >>> a), u = e, (0 | (e = c[5896 + (a = (f = t + f | 0) << 4) >> 2])) == (0 | (t = a + 5888 | 0))) b = c[1731], n = 31 & (e = t = 63 & f), e >>> 0 >= 32 ? (e = 0, a = -1 >>> n | 0) : a = (e = -1 >>> n | 0) | (1 << n) - 1 << 32 - n, a &= -2, n = 31 & t, t >>> 0 >= 32 ? (e = a << n, a = 0) : (e = (1 << n) - 1 & a >>> 32 - n | e << n, a <<= n), s = a, n = e, e = 31 & (a = t = 0 - f & 63), a >>> 0 >= 32 ? (e = -1 << e, a = 0) : e = (a = -1 << e) | (1 << e) - 1 & -1 >>> 32 - e, A = -2 & a, a = 31 & t, t >>> 0 >= 32 ? (t = 0, e = e >>> a | 0) : (t = e >>> a | 0, e = ((1 << a) - 1 & e) << 32 - a | A >>> a), e |= s, ir = n | t, c[1730] = c[1730] & e, c[1731] = ir & b, e = 1 ^ u;
                                        else {
                                            if (n = Nr(e, o, r)) break r;
                                            n = c[e + 4 >> 2], c[n + 8 >> 2] = c[e + 8 >> 2], c[c[e + 8 >> 2] + 4 >> 2] = n, c[e + 8 >> 2] = t, n = a + 5892 | 0, c[e + 4 >> 2] = c[n >> 2], c[n >> 2] = e, c[c[e + 4 >> 2] + 8 >> 2] = e, f = f + 1 | 0, e = (1 & i) << 31 | u >>> 1, i = i >>> 1 | 0;
                                        }
                                        if (!(e | i)) break;
                                    }
                                    t = c[1731], n = c[1730];
                                }
                                a: {
                                    if (n | t) {
                                        a = 63 - (32 == (0 | (i = G(t))) ? G(n) + 32 | 0 : i) | 0, i = c[5896 + (e = a << 4) >> 2];
                                        i: if (!(!t & n >>> 0 < 1073741824) && (f = 99, (0 | (e = e + 5888 | 0)) != (0 | i))) {
                                            for(;;){
                                                if (!f) break i;
                                                if (n = Nr(i, o, r)) break r;
                                                if (f = f - 1 | 0, (0 | e) == (0 | (i = c[i + 8 >> 2]))) break;
                                            }
                                            i = e;
                                        }
                                        if (vr(r + 48 | 0)) break a;
                                        if (!i) break e;
                                        if ((0 | (e = 5888 + (a << 4) | 0)) == (0 | i)) break e;
                                        for(;;){
                                            if (n = Nr(i, o, r)) break r;
                                            if ((0 | e) == (0 | (i = c[i + 8 >> 2]))) break;
                                        }
                                        break e;
                                    }
                                    if (!vr(r + 48 | 0)) break e;
                                }
                                if (n = 0, o - 1 & o) break r;
                                if (!(r >>> 0 <= 4294967239)) break;
                            }
                            break r;
                        }
                        n = 0;
                    }
                    return 0 | n;
                }
                function ur(r, e, a, i) {
                    var n = y(0), t = y(0), f = 0, o = y(0);
                    r: {
                        e: {
                            a: {
                                i: {
                                    n: {
                                        t: {
                                            if (e >>> 0 <= 1) {
                                                t = m[r + 212 >> 2];
                                                f: if (2139156720 != (0 | (e = c[r + 212 >> 2]))) {
                                                    if (2140081935 == (0 | e)) break t;
                                                    f = 4276;
                                                    o: {
                                                        if (2141891242 != (0 | e)) {
                                                            if (t == t) break o;
                                                            f = 4268;
                                                        }
                                                        switch(n = m[f >> 2], t = y(NaN), c[f + 4 >> 2] - 1 | 0){
                                                            case 0:
                                                                break t;
                                                            case 1:
                                                                break f;
                                                            default:
                                                                break n;
                                                        }
                                                    }
                                                    if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break t;
                                                }
                                                t = y(y(n * i) * y(.009999999776482582));
                                                break n;
                                            }
                                            t = m[r + 208 >> 2];
                                            f: {
                                                o: {
                                                    c: if (2139156720 != (0 | (e = c[r + 208 >> 2]))) {
                                                        if (2140081935 == (0 | e)) break o;
                                                        f = 4276;
                                                        u: {
                                                            if (2141891242 != (0 | e)) {
                                                                if (t == t) break u;
                                                                f = 4268;
                                                            }
                                                            switch(n = m[f >> 2], t = y(NaN), c[f + 4 >> 2] - 1 | 0){
                                                                case 0:
                                                                    break o;
                                                                case 1:
                                                                    break c;
                                                                default:
                                                                    break f;
                                                            }
                                                        }
                                                        if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break o;
                                                    }
                                                    t = y(y(n * i) * y(.009999999776482582));
                                                    break f;
                                                }
                                                t = n;
                                            }
                                            n = y(0), o = m[r + 216 >> 2];
                                            f: if (2139156720 != (0 | (r = c[r + 216 >> 2]))) {
                                                if (2140081935 == (0 | r)) break a;
                                                e = 4276;
                                                o: {
                                                    if (2141891242 != (0 | r)) {
                                                        if (o == o) break o;
                                                        e = 4268;
                                                    }
                                                    switch(n = m[e >> 2], c[e + 4 >> 2] - 1 | 0){
                                                        case 1:
                                                            break f;
                                                        case 0:
                                                            break i;
                                                        default:
                                                            break e;
                                                    }
                                                }
                                                if (b(2, 536870912 + (-1073741825 & r) | 0), n = d(), !(1073741824 & r)) break i;
                                            }
                                            n = y(y(n * i) * y(.009999999776482582));
                                            break i;
                                        }
                                        t = n;
                                    }
                                    n = y(0), o = m[r + 220 >> 2];
                                    n: if (2139156720 != (0 | (r = c[r + 220 >> 2]))) {
                                        if (2140081935 == (0 | r)) break a;
                                        e = 4276;
                                        t: {
                                            if (2141891242 != (0 | r)) {
                                                if (o == o) break t;
                                                e = 4268;
                                            }
                                            switch(n = m[e >> 2], c[e + 4 >> 2] - 1 | 0){
                                                case 1:
                                                    break n;
                                                case 0:
                                                    break i;
                                                default:
                                                    break e;
                                            }
                                        }
                                        if (b(2, 536870912 + (-1073741825 & r) | 0), n = d(), !(1073741824 & r)) break i;
                                    }
                                    n = y(y(n * i) * y(.009999999776482582));
                                }
                                if (!(n >= y(0))) break e;
                            }
                            if (a > n) break r;
                        }
                        if (!(t >= y(0))) return a;
                        n = a < t ? t : a;
                    }
                    return n;
                }
                function br(r, e) {
                    var a = 0, i = 0;
                    for(c[r + 8 >> 2] = 0, c[r + 12 >> 2] = 0, o[r + 4 >> 1] = 1, c[r >> 2] = 0, c[r + 16 >> 2] = 0, c[r + 20 >> 2] = 0, c[r + 24 >> 2] = 0, c[r + 36 >> 2] = 2143289344, c[r + 40 >> 2] = 2141891242, c[r + 28 >> 2] = 2143289344, c[r + 32 >> 2] = 2143289344, i = Rr(r + 44 | 0, 0, 36); c[i + (a << 2) >> 2] = 2143289344, 9 != (0 | (a = a + 1 | 0)););
                    for(a = 0, i = Rr(r + 80 | 0, 0, 36); c[i + (a << 2) >> 2] = 2143289344, 9 != (0 | (a = a + 1 | 0)););
                    for(a = 0, i = Rr(r + 116 | 0, 0, 36); c[i + (a << 2) >> 2] = 2143289344, 9 != (0 | (a = a + 1 | 0)););
                    for(a = 0, i = Rr(r + 152 | 0, 0, 36); c[i + (a << 2) >> 2] = 2143289344, 9 != (0 | (a = a + 1 | 0)););
                    for(a = 0, c[r + 196 >> 2] = 0, c[(i = r + 188 | 0) >> 2] = 0, c[i + 4 >> 2] = 0; c[i + (a << 2) >> 2] = 2143289344, 3 != (0 | (a = a + 1 | 0)););
                    for(c[r + 24 >> 2] = 4224, c[r + 224 >> 2] = 2143289344, c[r + 216 >> 2] = 2143289344, c[r + 220 >> 2] = 2143289344, c[r + 208 >> 2] = 2143289344, c[r + 212 >> 2] = 2143289344, c[r + 200 >> 2] = 2141891242, c[r + 204 >> 2] = 2141891242, Rr(r + 228 | 0, 0, 288), c[r + 244 >> 2] = 2143289344, c[r + 248 >> 2] = 2143289344, Rr(r + 252 | 0, 0, 49), c[r + 308 >> 2] = 2143289344, i = r + 516 | 0, a = r + 324 | 0; c[a + 16 >> 2] = -1082130432, c[a + 20 >> 2] = -1082130432, c[a + 8 >> 2] = 0, c[a + 12 >> 2] = 0, c[a >> 2] = -1082130432, c[a + 4 >> 2] = -1082130432, (0 | i) != (0 | (a = a + 24 | 0)););
                    return c[r + 548 >> 2] = 0, c[r + 552 >> 2] = 0, c[r + 516 >> 2] = 2143289344, c[r + 520 >> 2] = 2143289344, c[r + 572 >> 2] = 2143289344, c[r + 576 >> 2] = 0, c[r + 568 >> 2] = e, c[r + 540 >> 2] = -1082130432, c[r + 544 >> 2] = -1082130432, c[r + 532 >> 2] = 0, c[r + 536 >> 2] = 0, c[r + 524 >> 2] = -1082130432, c[r + 528 >> 2] = -1082130432, c[r + 556 >> 2] = 0, c[r + 560 >> 2] = 0, c[r + 564 >> 2] = 0, c[r + 580 >> 2] = 2143289344, c[r + 584 >> 2] = 0, v[e + 10 | 0] && (c[r + 24 >> 2] = 4616, f[r + 4 | 0] = 128 | v[r + 4 | 0]), r;
                }
                function sr(r) {
                    var e, a, i, n, t, f = 0, o = 0, u = y(0), s = y(0), A = y(0), k = 0, l = 0, v = 0, h = 0;
                    for(c[8 + (e = ar - 16 | 0) >> 2] = 0, c[e + 12 >> 2] = 1, a = r + 200 | 0, i = r + 572 | 0, n = r + 208 | 0, t = r + 216 | 0, r = 0;;){
                        h = r, v = c[(e + 8 | 0) + (r << 2) >> 2], u = m[(r = t + (k = v << 2) | 0) >> 2];
                        r: {
                            e: {
                                a: {
                                    i: {
                                        n: {
                                            if (!(!((l = 2139156720 == (0 | (f = c[r >> 2]))) | 2140081935 == (0 | f) | 2141891242 == (0 | f)) & u != u)) {
                                                s = m[(r = k + n | 0) >> 2];
                                                t: {
                                                    f: {
                                                        if (2139156720 != (0 | (o = c[r >> 2]))) {
                                                            if (A = y(NaN), r = 3, 2141891242 == (0 | o)) break t;
                                                            if (2140081935 != (0 | o)) break f;
                                                            A = y(0), r = 1;
                                                            break t;
                                                        }
                                                        A = y(0), r = 2;
                                                        break t;
                                                    }
                                                    r = 0, s == s && (b(2, 536870912 + (-1073741825 & o) | 0), A = d(), r = 1073741824 & o ? 2 : 1);
                                                }
                                                o = r;
                                                t: {
                                                    f: {
                                                        if (!l) {
                                                            if (s = y(NaN), r = 3, 2141891242 == (0 | f)) break t;
                                                            if (2140081935 != (0 | f)) break f;
                                                            s = y(0), r = 1;
                                                            break t;
                                                        }
                                                        s = y(0), r = 2;
                                                        break t;
                                                    }
                                                    r = 0, u == u && (b(2, 536870912 + (-1073741825 & f) | 0), s = d(), r = 1073741824 & f ? 2 : 1);
                                                }
                                                if (!((0 | o) != (0 | r) | !(!r | s != s & A != A | y(E(y(s - A))) < y(9999999747378752e-20)))) {
                                                    if (r = 0, l) break n;
                                                    if (2140081935 == (0 | f)) break e;
                                                    if (2141891242 == (0 | f)) break a;
                                                    if (u != u) break i;
                                                    r = 536870912 + (-1073741825 & f) | 0, f = 1073741824 & f ? 2 : 1;
                                                    break r;
                                                }
                                            }
                                            if (r = 0, u = m[(f = k + a | 0) >> 2], 2139156720 != (0 | (f = c[f >> 2]))) {
                                                if (2140081935 == (0 | f)) break e;
                                                if (2141891242 == (0 | f)) break a;
                                                if (u != u) break i;
                                                r = 536870912 + (-1073741825 & f) | 0, f = 1073741824 & f ? 2 : 1;
                                                break r;
                                            }
                                        }
                                        f = 2;
                                        break r;
                                    }
                                    r = 2143289344, f = 0;
                                    break r;
                                }
                                r = 2143289344, f = 3;
                                break r;
                            }
                            f = 1;
                        }
                        if (c[4 + (o = (v << 3) + i | 0) >> 2] = f, c[o >> 2] = r, r = 1, 1 & h) break;
                    }
                }
                function Ar(r, e, a) {
                    var i, n = 0, t = 0;
                    if (a >>> 0 >= 512) return J(0 | r, 0 | e, 0 | a), r;
                    i = r + a | 0;
                    r: if (3 & (r ^ e)) {
                        if (i >>> 0 < 4) a = r;
                        else if ((n = i - 4 | 0) >>> 0 < r >>> 0) a = r;
                        else for(a = r; f[0 | a] = v[0 | e], f[a + 1 | 0] = v[e + 1 | 0], f[a + 2 | 0] = v[e + 2 | 0], f[a + 3 | 0] = v[e + 3 | 0], e = e + 4 | 0, n >>> 0 >= (a = a + 4 | 0) >>> 0;);
                    } else {
                        e: if (3 & r) {
                            if (a) for(a = r;;){
                                if (f[0 | a] = v[0 | e], e = e + 1 | 0, !(3 & (a = a + 1 | 0))) break e;
                                if (!(a >>> 0 < i >>> 0)) break;
                            }
                            else a = r;
                        } else a = r;
                        if (!((n = -4 & i) >>> 0 < 64 || (t = n + -64 | 0) >>> 0 < a >>> 0)) for(; c[a >> 2] = c[e >> 2], c[a + 4 >> 2] = c[e + 4 >> 2], c[a + 8 >> 2] = c[e + 8 >> 2], c[a + 12 >> 2] = c[e + 12 >> 2], c[a + 16 >> 2] = c[e + 16 >> 2], c[a + 20 >> 2] = c[e + 20 >> 2], c[a + 24 >> 2] = c[e + 24 >> 2], c[a + 28 >> 2] = c[e + 28 >> 2], c[a + 32 >> 2] = c[e + 32 >> 2], c[a + 36 >> 2] = c[e + 36 >> 2], c[a + 40 >> 2] = c[e + 40 >> 2], c[a + 44 >> 2] = c[e + 44 >> 2], c[a + 48 >> 2] = c[e + 48 >> 2], c[a + 52 >> 2] = c[e + 52 >> 2], c[a + 56 >> 2] = c[e + 56 >> 2], c[a + 60 >> 2] = c[e + 60 >> 2], e = e - -64 | 0, t >>> 0 >= (a = a - -64 | 0) >>> 0;);
                        if (a >>> 0 >= n >>> 0) break r;
                        for(; c[a >> 2] = c[e >> 2], e = e + 4 | 0, n >>> 0 > (a = a + 4 | 0) >>> 0;);
                    }
                    if (a >>> 0 < i >>> 0) for(; f[0 | a] = v[0 | e], e = e + 1 | 0, (0 | i) != (0 | (a = a + 1 | 0)););
                    return r;
                }
                function kr(r, e, a, i, n) {
                    var t, f = y(0), o = 0, u = y(0), s = y(0), A = 0, k = y(0), l = y(0);
                    if (!(t = (u = y(a - i)) != u)) {
                        a = y(0), f = m[208 + (o = (e << 2) + r | 0) >> 2];
                        r: {
                            e: {
                                a: {
                                    i: if (2139156720 != (0 | (o = c[o + 208 >> 2]))) {
                                        if (2140081935 == (0 | o)) break e;
                                        A = 4276;
                                        n: {
                                            if (2141891242 != (0 | o)) {
                                                if (f == f) break n;
                                                A = 4268;
                                            }
                                            switch(a = m[A >> 2], c[A + 4 >> 2] - 1 | 0){
                                                case 0:
                                                    break a;
                                                case 1:
                                                    break i;
                                                default:
                                                    break r;
                                            }
                                        }
                                        if (b(2, 536870912 + (-1073741825 & o) | 0), a = d(), !(1073741824 & o)) break a;
                                    }
                                    a = y(y(a * n) * y(.009999999776482582));
                                }
                                if (a != a) break r;
                            }
                            s = y(a - i);
                        }
                        a = y(0), f = m[216 + (r = (e << 2) + r | 0) >> 2];
                        r: {
                            e: {
                                a: {
                                    i: if (2139156720 != (0 | (e = c[r + 216 >> 2]))) {
                                        if (2140081935 == (0 | e)) break e;
                                        r = 4276;
                                        n: {
                                            if (2141891242 != (0 | e)) {
                                                if (f == f) break n;
                                                r = 4268;
                                            }
                                            switch(a = m[r >> 2], f = y(34028234663852886e22), c[r + 4 >> 2] - 1 | 0){
                                                case 0:
                                                    break a;
                                                case 1:
                                                    break i;
                                                default:
                                                    break r;
                                            }
                                        }
                                        if (b(2, 536870912 + (-1073741825 & e) | 0), a = d(), !(1073741824 & e)) break a;
                                    }
                                    a = y(y(a * n) * y(.009999999776482582));
                                }
                                if (a != a) {
                                    f = y(34028234663852886e22);
                                    break r;
                                }
                            }
                            f = y(a - i);
                        }
                        if (k = u, l = ge(u, f), !((r = (a = f != f | t ? k : l) != a) | s != s)) return Re(a, s);
                        u = r ? s : a;
                    }
                    return u;
                }
                function lr(r, e, a, i, n, t, f, o, c, u, b, s, A) {
                    var k = y(0), l = y(0), d = 0, v = 0, h = y(0), p = y(0), N = y(0), w = 0, G = 0;
                    if (c < y(0) | u < y(0)) r = 0;
                    else {
                        h = t, p = e, N = i, l = o, A && (l = o, (k = m[A + 16 >> 2]) != y(0) && (p = jr(+e, w = +k, 0, 0), N = jr(+i, w, 0, 0), h = jr(+t, w, 0, 0), l = jr(+o, w, 0, 0))), k = l, A = 0, (0 | r) == (0 | n) && ((G = h != h) | (A = p != p) ? A &= G : A = y(E(y(h - p))) < y(9999999747378752e-20)), G = A, (0 | a) == (0 | f) && ((d = k != k) | (A = N != N) ? d &= A : d = y(E(y(k - N))) < y(9999999747378752e-20)), v = 1, A = 1;
                        r: if (!G) {
                            e = y(e - b);
                            e: if (1 != (0 | r)) {
                                if (!((r = 2 != (0 | r)) | n)) {
                                    if (!(e >= c)) break e;
                                    break r;
                                }
                                if (A = 0, !(e < t) | r | 2 != (0 | n) | e != e | t != t | c != c) break r;
                                if (A = 1, e >= c) break r;
                            }
                            A = (n = e != e) | (r = c != c) ? r & n : y(E(y(e - c))) < y(9999999747378752e-20);
                        }
                        r: if (!d) {
                            e = y(i - s);
                            e: if (1 != (0 | a)) {
                                if (!((r = 2 != (0 | a)) | f)) {
                                    if (!(e >= u)) break e;
                                    break r;
                                }
                                if (v = 0, !(e < o) | r | 2 != (0 | f) | e != e | o != o | u != u) break r;
                                if (v = 1, e >= u) break r;
                            }
                            v = (a = e != e) | (r = u != u) ? r & a : y(E(y(e - u))) < y(9999999747378752e-20);
                        }
                        r = A & v;
                    }
                    return r;
                }
                function dr(r) {
                    var e, a, i = 0, n = 0, t = 0, f = 0, o = 0, c = 0;
                    if (A(+r), o = 0 | u(1), t = 0 | u(0), 2047 == (0 | (f = o >>> 20 & 2047))) return (r *= 1) / r;
                    if (!(i = t << 1) & 2145386496 == (0 | (c = o << 1 | t >>> 31)) | c >>> 0 < 2145386496) return !i & 2145386496 == (0 | c) ? 0 * r : r;
                    if (f) i = 1048575 & o | 1048576;
                    else {
                        if (f = 0, n = t << 12, (0 | (i = o << 12 | t >>> 20)) > 0 | (0 | i) >= 0) for(; f = f - 1 | 0, i = i << 1 | n >>> 31, n <<= 1, (0 | i) > 0 | (0 | i) >= 0;);
                        n = 31 & (i = 1 - f | 0), (63 & i) >>> 0 >= 32 ? (i = t << n, t = 0) : (i = (1 << n) - 1 & t >>> 32 - n | o << n, t <<= n);
                    }
                    if (n = t, (0 | f) > 1023) {
                        for(;;){
                            if (!((0 | (t = i + -1048576 | 0)) < 0 || (i = t) | n)) return 0 * r;
                            if (i = i << 1 | n >>> 31, n <<= 1, !((0 | (f = f - 1 | 0)) > 1023)) break;
                        }
                        f = 1023;
                    }
                    if (!((0 | (t = i + -1048576 | 0)) < 0 || (i = t) | n)) return 0 * r;
                    if (1048575 == (0 | i) | i >>> 0 < 1048575) for(; f = f - 1 | 0, t = i >>> 0 < 524288, c = i << 1 | n >>> 31, n <<= 1, i = c, t;);
                    return a = -2147483648 & o, c = i + -1048576 | f << 20, o = i, e = n, n = 31 & (t = 1 - f | 0), (63 & t) >>> 0 >= 32 ? (i = 0, t = o >>> n | 0) : (i = o >>> n | 0, t = ((1 << n) - 1 & o) << 32 - n | e >>> n), b(0, 0 | ((n = (0 | f) > 0) ? e : t)), b(1, (n ? c : i) | a), +s();
                }
                function vr(r) {
                    var e = 0, a = 0, i = 0, n = 0, t = 0;
                    if ((a = (i = c[1396]) + (e = r + 7 & -8) | 0) >>> 0 <= i >>> 0 && e || a >>> 0 > ia() << 16 >>> 0 && !(0 | x(0 | a)) ? (c[1761] = 48, i = -1) : c[1396] = a, -1 != (0 | i)) {
                        c[12 + (a = (e = r + i | 0) - 16 | 0) >> 2] = 16, c[a >> 2] = 16;
                        r: {
                            e: {
                                if ((0 | (t = (r = c[1728]) ? c[r + 8 >> 2] : 0)) == (0 | i)) {
                                    if (n = i - (-2 & c[i - 4 >> 2]) | 0, t = c[n - 4 >> 2], c[r + 8 >> 2] = e, e = -16, !(1 & f[((r = n - (-2 & t) | 0) + c[r >> 2] | 0) - 4 | 0])) break e;
                                    e = c[r + 4 >> 2], c[e + 8 >> 2] = c[r + 8 >> 2], c[c[r + 8 >> 2] + 4 >> 2] = e, a = a - r | 0, c[r >> 2] = a;
                                    break r;
                                }
                                c[i + 12 >> 2] = 16, c[i >> 2] = 16, c[i + 8 >> 2] = e, c[i + 4 >> 2] = r, c[1728] = i, e = 16;
                            }
                            a = a - (r = e + i | 0) | 0, c[r >> 2] = a;
                        }
                        c[((-4 & a) + r | 0) - 4 >> 2] = 1 | a, (e = c[r >> 2] - 8 | 0) >>> 0 <= 127 ? a = (e >>> 3 | 0) - 1 | 0 : (a = 110 + ((e >>> 29 - (n = G(e)) ^ 4) - (n << 2) | 0) | 0, e >>> 0 <= 4095 || (a = (a = 71 + ((e >>> 30 - n ^ 2) - (n << 1) | 0) | 0) >>> 0 >= 63 ? 63 : a)), e = a << 4, c[r + 4 >> 2] = e + 5888, e = e + 5896 | 0, c[r + 8 >> 2] = c[e >> 2], c[e >> 2] = r, c[c[r + 8 >> 2] + 4 >> 2] = r, e = c[1730], n = c[1731], r = 31 & a, (63 & a) >>> 0 >= 32 ? (a = 1 << r, t = 0) : a = (t = 1 << r) - 1 & 1 >>> 32 - r, c[1730] = t | e, c[1731] = a | n;
                    }
                    return -1 != (0 | i);
                }
                function hr(r, e, a) {
                    var i = 0, n = 0, t = 0, f = 0, o = 0, c = 0, u = 0, b = 0, s = 0;
                    r: {
                        e: {
                            a: {
                                i: {
                                    n: {
                                        t: {
                                            f: {
                                                o: {
                                                    c: {
                                                        u: {
                                                            if (e) {
                                                                if (!a) break u;
                                                                break c;
                                                            }
                                                            ir = 0, r = (r >>> 0) / (a >>> 0) | 0;
                                                            break r;
                                                        }
                                                        if (!r) break o;
                                                        break f;
                                                    }
                                                    if (!(a - 1 & a)) break t;
                                                    f = 0 - (t = (G(a) + 33 | 0) - G(e) | 0) | 0;
                                                    break i;
                                                }
                                                ir = 0, r = (e >>> 0) / 0 | 0;
                                                break r;
                                            }
                                            if ((i = 32 - G(e) | 0) >>> 0 < 31) break n;
                                            break a;
                                        }
                                        if (1 == (0 | a)) break e;
                                        a = 31 & (t = a ? 31 - G(a - 1 ^ a) | 0 : 32), (63 & t) >>> 0 >= 32 ? r = e >>> a | 0 : (i = e >>> a | 0, r = ((1 << a) - 1 & e) << 32 - a | r >>> a), ir = i;
                                        break r;
                                    }
                                    t = i + 1 | 0, f = 63 - i | 0;
                                }
                                if (n = 31 & (i = 63 & t), i >>> 0 >= 32 ? (i = 0, o = e >>> n | 0) : (i = e >>> n | 0, o = ((1 << n) - 1 & e) << 32 - n | r >>> n), n = 31 & (f &= 63), f >>> 0 >= 32 ? (e = r << n, r = 0) : (e = (1 << n) - 1 & r >>> 32 - n | e << n, r <<= n), t) for(s = -1 == (0 | (f = a - 1 | 0)) ? -1 : 0; c = i << 1 | o >>> 31, o = (i = o << 1 | e >>> 31) - (u = a & (n = s - (c + (i >>> 0 > f >>> 0) | 0) >> 31)) | 0, i = c - (i >>> 0 < u >>> 0) | 0, e = e << 1 | r >>> 31, r = b | r << 1, b = 1 & n, t = t - 1 | 0;);
                                ir = e << 1 | r >>> 31, r = b | r << 1;
                                break r;
                            }
                            r = 0, e = 0;
                        }
                        ir = e;
                    }
                    return r;
                }
                function pr(r, e, a) {
                    var i = y(0), n = y(0);
                    r: {
                        e: {
                            a: {
                                if (2 == (-2 & e)) {
                                    if (2139156720 == (0 | (e = c[r + 188 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (i = m[r + 188 >> 2]) == i) break a;
                                    if (2139156720 == (0 | (e = c[r + 196 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (i = m[r + 196 >> 2]) == i) break a;
                                    break e;
                                }
                                if (!(2139156720 == (0 | (e = c[r + 192 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (i = m[r + 192 >> 2]) == i || (i = m[r + 196 >> 2], 2139156720 == (0 | (e = c[r + 196 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) || i == i))) break e;
                            }
                            i = y(0);
                            a: {
                                i: if (2139156720 != (0 | e)) {
                                    if (2140081935 == (0 | e)) break r;
                                    r = 4276;
                                    n: {
                                        if (2141891242 != (0 | e)) {
                                            if (b(2, e), (i = d()) == i) break n;
                                            r = 4268;
                                        }
                                        switch(i = m[r >> 2], n = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                            case 0:
                                                break r;
                                            case 1:
                                                break i;
                                            default:
                                                break a;
                                        }
                                    }
                                    if (b(2, 536870912 + (-1073741825 & e) | 0), i = d(), !(1073741824 & e)) break r;
                                }
                                n = y(y(i * a) * y(.009999999776482582));
                            }
                            return n;
                        }
                        i = y(0);
                    }
                    return i;
                }
                function mr(r, e) {
                    var a, i, n = 0, t = 0, o = 0, u = 0;
                    for(ar = n = ar - 320 | 0, a = Rr(n, 0, 288), c[(n = a) + 16 >> 2] = 2143289344, c[n + 20 >> 2] = 2143289344, Rr(n + 24 | 0, 0, 49), c[n + 80 >> 2] = 2143289344, o = n + 288 | 0, t = n + 96 | 0; c[(n = t) + 16 >> 2] = -1082130432, c[n + 20 >> 2] = -1082130432, c[n + 8 >> 2] = 0, c[n + 12 >> 2] = 0, c[n >> 2] = -1082130432, c[n + 4 >> 2] = -1082130432, (0 | o) != (0 | (t = n + 24 | 0)););
                    if (c[a + 312 >> 2] = -1082130432, c[a + 316 >> 2] = -1082130432, c[a + 304 >> 2] = 0, c[a + 308 >> 2] = 0, c[a + 296 >> 2] = -1082130432, c[a + 300 >> 2] = -1082130432, c[a + 288 >> 2] = 2143289344, c[a + 292 >> 2] = 2143289344, Ar(r + 228 | 0, a, 320), c[r + 244 >> 2] = 0, c[r + 248 >> 2] = 0, f[r + 4 | 0] = 1 | v[r + 4 | 0], (0 | (t = c[r + 556 >> 2])) != (0 | (i = c[r + 560 >> 2]))) for(; n = c[t >> 2], c[n + 552 >> 2] != (0 | r) && (o = c[r + 568 >> 2], n = Ir(c[o >> 2], v[o + 8 | 0], n, r, u, e), c[t >> 2] = n, c[n + 552 >> 2] = r, n = c[t >> 2]), mr(n, e), u = u + 1 | 0, (0 | i) != (0 | (t = t + 4 | 0)););
                    ar = a + 320 | 0;
                }
                function Nr(r, e, a) {
                    var i = 0, n = 0, t = 0, f = 0;
                    return (n = ((i = r + 4 | 0) + e | 0) - 1 & 0 - e) + a >>> 0 <= ((e = c[r >> 2]) + r | 0) - 4 >>> 0 ? (t = c[r + 4 >> 2], c[t + 8 >> 2] = c[r + 8 >> 2], c[c[r + 8 >> 2] + 4 >> 2] = t, (0 | i) != (0 | n) && (n = n - i | 0, t = r - (-2 & c[r - 4 >> 2]) | 0, i = n + c[t >> 2] | 0, c[t >> 2] = i, c[(t + (-4 & i) | 0) - 4 >> 2] = i, e = e - n | 0, c[(r = r + n | 0) >> 2] = e), a + 24 >>> 0 <= e >>> 0 ? (e = (e - a | 0) - 8 | 0, c[(i = 8 + (r + a | 0) | 0) >> 2] = e, c[(i + (-4 & e) | 0) - 4 >> 2] = 1 | e, (n = c[i >> 2] - 8 | 0) >>> 0 <= 127 ? e = (n >>> 3 | 0) - 1 | 0 : (e = 110 + ((n >>> 29 - (t = G(n)) ^ 4) - (t << 2) | 0) | 0, n >>> 0 <= 4095 || (e = (e = 71 + ((n >>> 30 - t ^ 2) - (t << 1) | 0) | 0) >>> 0 >= 63 ? 63 : e)), n = e << 4, c[i + 4 >> 2] = n + 5888, n = n + 5896 | 0, c[i + 8 >> 2] = c[n >> 2], c[n >> 2] = i, c[c[i + 8 >> 2] + 4 >> 2] = i, n = c[1730], t = c[1731], i = 31 & e, (63 & e) >>> 0 >= 32 ? (e = 1 << i, i = 0) : (e = (f = 1 << i) - 1 & 1 >>> 32 - i, i = f), c[1730] = i | n, c[1731] = e | t, e = a + 8 | 0, c[r >> 2] = e, c[((-4 & e) + r | 0) - 4 >> 2] = e) : c[(r + e | 0) - 4 >> 2] = e, r = r + 4 | 0) : r = 0, r;
                }
                function wr(r, e, a) {
                    var i = 0, n = 0;
                    r: if ((0 | r) != (0 | e)) {
                        if (e - (n = r + a | 0) >>> 0 <= 0 - (a << 1) >>> 0) return Ar(r, e, a);
                        if (i = 3 & (r ^ e), r >>> 0 < e >>> 0) {
                            if (i) i = r;
                            else {
                                if (3 & r) for(i = r;;){
                                    if (!a) break r;
                                    if (f[0 | i] = v[0 | e], e = e + 1 | 0, a = a - 1 | 0, !(3 & (i = i + 1 | 0))) break;
                                }
                                else i = r;
                                if (!(a >>> 0 <= 3)) for(; c[i >> 2] = c[e >> 2], e = e + 4 | 0, i = i + 4 | 0, (a = a - 4 | 0) >>> 0 > 3;);
                            }
                            if (a) for(; f[0 | i] = v[0 | e], i = i + 1 | 0, e = e + 1 | 0, a = a - 1 | 0;);
                        } else {
                            if (!i) {
                                if (3 & n) for(;;){
                                    if (!a) break r;
                                    if (f[0 | (i = (a = a - 1 | 0) + r | 0)] = v[e + a | 0], !(3 & i)) break;
                                }
                                if (!(a >>> 0 <= 3)) for(; c[(a = a - 4 | 0) + r >> 2] = c[e + a >> 2], a >>> 0 > 3;);
                            }
                            if (!a) break r;
                            for(; f[(a = a - 1 | 0) + r | 0] = v[e + a | 0], a;);
                        }
                    }
                    return r;
                }
                function yr(r, e, a, i) {
                    switch(e - 9 | 0){
                        case 0:
                            return e = c[a >> 2], c[a >> 2] = e + 4, void (c[r >> 2] = c[e >> 2]);
                        case 6:
                            return e = c[a >> 2], c[a >> 2] = e + 4, e = o[e >> 1], c[r >> 2] = e, void (c[r + 4 >> 2] = e >> 31);
                        case 7:
                            return e = c[a >> 2], c[a >> 2] = e + 4, c[r >> 2] = h[e >> 1], void (c[r + 4 >> 2] = 0);
                        case 8:
                            return e = c[a >> 2], c[a >> 2] = e + 4, e = f[0 | e], c[r >> 2] = e, void (c[r + 4 >> 2] = e >> 31);
                        case 9:
                            return e = c[a >> 2], c[a >> 2] = e + 4, c[r >> 2] = v[0 | e], void (c[r + 4 >> 2] = 0);
                        case 16:
                            return e = c[a >> 2] + 7 & -8, c[a >> 2] = e + 8, void (N[r >> 3] = N[e >> 3]);
                        case 17:
                            aa[0 | i](r, a);
                        default:
                            return;
                        case 1:
                        case 4:
                        case 14:
                            return e = c[a >> 2], c[a >> 2] = e + 4, e = c[e >> 2], c[r >> 2] = e, void (c[r + 4 >> 2] = e >> 31);
                        case 2:
                        case 5:
                        case 11:
                        case 15:
                            return e = c[a >> 2], c[a >> 2] = e + 4, c[r >> 2] = c[e >> 2], void (c[r + 4 >> 2] = 0);
                        case 3:
                        case 10:
                        case 12:
                        case 13:
                    }
                    e = c[a >> 2] + 7 & -8, c[a >> 2] = e + 8, a = c[e + 4 >> 2], c[r >> 2] = c[e >> 2], c[r + 4 >> 2] = a;
                }
                function Er(r, e, a, i) {
                    var n = 0, t = 0, f = 0, o = 0, u = 0, b = 0, s = 0, A = 0, k = 0, l = 0, d = 0, h = y(0), p = y(0), N = y(0), w = 0, G = y(0);
                    if (0 != e && (h = m[r + 248 >> 2], p = m[r + 244 >> 2], N = m[r + 232 >> 2], w = r, G = jr(A = +m[r + 228 >> 2], e, 0, n = (f = 8 & v[r + 4 | 0]) >>> 3 | 0), m[w + 228 >> 2] = G, w = r, G = jr(k = +N, e, 0, n), m[w + 232 >> 2] = G, n = (u = dr((l = +p) * e)) != u, t = (b = dr((d = +h) * e)) != b, a = A + a, o = n | (o = E(u) < 1e-4) ? n | !o : !(E(u + -1) < 1e-4), w = r, G = y(jr(a + l, e, o & (n = 0 != (0 | f)), n & !o) - jr(a, e, 0, n)), m[w + 244 >> 2] = G, i = k + i, t = t | (f = E(b) < 1e-4) ? t | !f : !(E(b + -1) < 1e-4), w = r, G = y(jr(i + d, e, n & t, n & !t) - jr(i, e, 0, n)), m[w + 248 >> 2] = G, (0 | (n = c[r + 560 >> 2])) != (0 | (t = c[r + 556 >> 2])))) for(t = (n = n - t >> 2) >>> 0 <= 1 ? 1 : n; n = c[r + 556 >> 2], Er(n = c[r + 560 >> 2] - n >> 2 >>> 0 > s >>> 0 ? c[n + (s << 2) >> 2] : 0, e, a, i), (0 | t) != (0 | (s = s + 1 | 0)););
                }
                function Gr() {
                    er(7004, 3018), rr(7005, 2479, 1, 1, 0), B(7006, 2139, 1, -128, 127), B(7007, 2132, 1, -128, 127), B(7008, 2130, 1, 0, 255), B(7009, 1286, 2, -32768, 32767), B(7010, 1277, 2, 0, 65535), B(7011, 1315, 4, -2147483648, 2147483647), B(7012, 1306, 4, 0, -1), B(7013, 2658, 4, -2147483648, 2147483647), B(7014, 2649, 4, 0, -1), Me(7015, 1776, -2147483648, 2147483647), Me(7016, 1775, 0, -1), S(7017, 1769, 4), S(7018, 2966, 8), P(7019, 2676), P(7020, 3835), L(7021, 4, 2663), L(7022, 2, 2688), L(7023, 4, 2703), $(7024, 2484), W(7025, 0, 3766), W(7026, 0, 3868), W(7027, 1, 3796), W(7028, 2, 3398), W(7029, 3, 3429), W(7030, 4, 3469), W(7031, 5, 3498), W(7032, 4, 3905), W(7033, 5, 3935), W(7026, 0, 3600), W(7027, 1, 3567), W(7028, 2, 3666), W(7029, 3, 3632), W(7030, 4, 3733), W(7031, 5, 3699), W(7034, 6, 3536), W(7035, 7, 3974);
                }
                function Rr(r, e, a) {
                    var i = 0, n = 0, t = 0, o = 0;
                    if (a && (f[0 | r] = e, f[(i = r + a | 0) - 1 | 0] = e, !(a >>> 0 < 3 || (f[r + 2 | 0] = e, f[r + 1 | 0] = e, f[i - 3 | 0] = e, f[i - 2 | 0] = e, a >>> 0 < 7 || (f[r + 3 | 0] = e, f[i - 4 | 0] = e, a >>> 0 < 9 || (n = (i = 0 - r & 3) + r | 0, e = w(255 & e, 16843009), c[n >> 2] = e, c[(a = (i = a - i & -4) + n | 0) - 4 >> 2] = e, i >>> 0 < 9 || (c[n + 8 >> 2] = e, c[n + 4 >> 2] = e, c[a - 8 >> 2] = e, c[a - 12 >> 2] = e, i >>> 0 < 25 || (c[n + 24 >> 2] = e, c[n + 20 >> 2] = e, c[n + 16 >> 2] = e, c[n + 12 >> 2] = e, c[a - 16 >> 2] = e, c[a - 20 >> 2] = e, c[a - 24 >> 2] = e, c[a - 28 >> 2] = e, (a = i - (o = 4 & n | 24) | 0) >>> 0 < 32)))))))) for(i = Ae(e, 0, 1, 1), t = ir, e = n + o | 0; c[e + 24 >> 2] = i, c[e + 28 >> 2] = t, c[e + 16 >> 2] = i, c[e + 20 >> 2] = t, c[e + 8 >> 2] = i, c[e + 12 >> 2] = t, c[e >> 2] = i, c[e + 4 >> 2] = t, e = e + 32 | 0, (a = a - 32 | 0) >>> 0 > 31;);
                    return r;
                }
                function gr(r) {
                    var e = 0, a = 0, i = 0, n = 0, t = 0;
                    (r |= 0) && (a = n = c[(e = r - 4 | 0) >> 2], i = e, (0 | (r = -2 & (t = c[r - 8 >> 2]))) != (0 | t) && (a = c[4 + (i = e - r | 0) >> 2], c[a + 8 >> 2] = c[i + 8 >> 2], c[c[i + 8 >> 2] + 4 >> 2] = a, a = r + n | 0), (0 | (e = c[(r = e + n | 0) >> 2])) != c[(r + e | 0) - 4 >> 2] && (n = c[r + 4 >> 2], c[n + 8 >> 2] = c[r + 8 >> 2], c[c[r + 8 >> 2] + 4 >> 2] = n, a = e + a | 0), c[i >> 2] = a, c[((-4 & a) + i | 0) - 4 >> 2] = 1 | a, (e = c[i >> 2] - 8 | 0) >>> 0 <= 127 ? r = (e >>> 3 | 0) - 1 | 0 : (r = 110 + ((e >>> 29 - (a = G(e)) ^ 4) - (a << 2) | 0) | 0, e >>> 0 <= 4095 || (r = (r = 71 + ((e >>> 30 - a ^ 2) - (a << 1) | 0) | 0) >>> 0 >= 63 ? 63 : r)), e = r << 4, c[i + 4 >> 2] = e + 5888, e = e + 5896 | 0, c[i + 8 >> 2] = c[e >> 2], c[e >> 2] = i, c[c[i + 8 >> 2] + 4 >> 2] = i, e = c[1730], a = c[1731], i = 31 & r, (63 & r) >>> 0 >= 32 ? (r = 1 << i, n = 0) : r = (n = 1 << i) - 1 & 1 >>> 32 - i, c[1730] = n | e, c[1731] = r | a);
                }
                function Zr(r, e, a, i, n) {
                    var t, f = 0, o = 0;
                    if (ar = t = ar - 208 | 0, c[t + 204 >> 2] = a, Rr(a = t + 160 | 0, 0, 40), c[t + 200 >> 2] = c[t + 204 >> 2], (0 | fr(0, e, t + 200 | 0, t + 80 | 0, a, i, n)) < 0) n = -1;
                    else {
                        c[r + 76 >> 2], f = c[r >> 2], c[r + 72 >> 2] <= 0 && (c[r >> 2] = -33 & f);
                        r: {
                            e: {
                                if (c[r + 48 >> 2]) {
                                    if (c[r + 16 >> 2]) break e;
                                } else c[r + 48 >> 2] = 80, c[r + 28 >> 2] = 0, c[r + 16 >> 2] = 0, c[r + 20 >> 2] = 0, o = c[r + 44 >> 2], c[r + 44 >> 2] = t;
                                if (a = -1, me(r)) break r;
                            }
                            a = fr(r, e, t + 200 | 0, t + 80 | 0, t + 160 | 0, i, n);
                        }
                        o && (aa[c[r + 36 >> 2]](r, 0, 0), c[r + 48 >> 2] = 0, c[r + 44 >> 2] = o, c[r + 28 >> 2] = 0, e = c[r + 20 >> 2], c[r + 16 >> 2] = 0, c[r + 20 >> 2] = 0, a = e ? a : -1), e = r, r = c[r >> 2], c[e >> 2] = r | 32 & f, n = 32 & r ? -1 : a;
                    }
                    return ar = t + 208 | 0, n;
                }
                function Wr(r) {
                    var e, a = 0, i = y(0), n = 0, t = 0, f = 0, o = 0, u = y(0), b = 0;
                    ar = e = ar - 16 | 0;
                    r: {
                        if (a = c[r + 12 >> 2]) {
                            if (u = m[r + 520 >> 2], i = m[r + 516 >> 2], (i = 32 & v[r + 4 | 0] ? y(aa[0 | a](r, i, u, 0)) : y(aa[0 | a](r, i, u))) == i) break r;
                            c[e >> 2] = 3340, Xr(r, e), De(), k();
                        }
                        e: {
                            a: {
                                if ((0 | (f = c[r + 556 >> 2])) != (0 | (a = c[r + 560 >> 2]))) {
                                    for(b = (a = a - f >> 2) >>> 0 <= 1 ? 1 : a;;){
                                        if (t = c[(o << 2) + f >> 2], !c[t + 548 >> 2]) {
                                            if (131072 != (196608 & (a = c[t + 24 >> 2]))) {
                                                if ((a = a >>> 13 & 7) || (a = c[r + 24 >> 2] >>> 10 & 7), 2 & v[t + 4 | 0] | (8 & v[r + 24 | 0] ? 5 == (0 | a) : 0)) break a;
                                                n = n || t;
                                            }
                                            if ((0 | b) != (0 | (o = o + 1 | 0))) continue;
                                        }
                                        break;
                                    }
                                    if (n) break e;
                                }
                                i = m[r + 520 >> 2];
                                break r;
                            }
                            n = t;
                        }
                        i = y(Wr(n) + m[n + 232 >> 2]);
                    }
                    return ar = e + 16 | 0, i;
                }
                function Vr(r, e, a, i, n, t) {
                    var f = 0, o = y(0), u = 0, s = y(0);
                    f = (c[4252 + (e << 2) >> 2] << 2) + r | 0, o = m[f + 216 >> 2];
                    r: {
                        e: {
                            a: if (2139156720 != (0 | (f = c[f + 216 >> 2]))) {
                                if (2140081935 == (0 | f)) break e;
                                u = 4276;
                                i: {
                                    if (2141891242 != (0 | f)) {
                                        if (o == o) break i;
                                        u = 4268;
                                    }
                                    switch(s = m[u >> 2], o = y(NaN), c[u + 4 >> 2] - 1 | 0){
                                        case 0:
                                            break e;
                                        case 1:
                                            break a;
                                        default:
                                            break r;
                                    }
                                }
                                if (b(2, 536870912 + (-1073741825 & f) | 0), s = d(), !(1073741824 & f)) break e;
                            }
                            o = y(y(s * a) * y(.009999999776482582));
                            break r;
                        }
                        o = s;
                    }
                    i = y(o + y(Mr(r, e, i) + Ur(r, e, i)));
                    r: {
                        e: {
                            a: switch(c[n >> 2]){
                                case 1:
                                case 2:
                                    a = m[t >> 2], i = i != i || a < i ? a : i;
                                    break e;
                                case 0:
                                    break a;
                                default:
                                    break r;
                            }
                            if (i != i) break r;
                            c[n >> 2] = 2;
                        }
                        m[t >> 2] = i;
                    }
                }
                function Br(r, e, a) {
                    var i, n = y(0), t = y(0), f = y(0);
                    r = r + 116 | 0, i = c[4220 + (e << 2) >> 2];
                    r: {
                        e: {
                            a: {
                                i: if (2139156720 != (0 | (e = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 4, i, 2140081935)))) {
                                    if (2140081935 == (0 | e)) break r;
                                    r = 4276;
                                    n: {
                                        if (2141891242 != (0 | e)) {
                                            if (b(2, e), (n = d()) == n) break n;
                                            r = 4268;
                                        }
                                        switch(n = m[r >> 2], t = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                            case 0:
                                                break a;
                                            case 1:
                                                break i;
                                            default:
                                                break e;
                                        }
                                    }
                                    if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break a;
                                }
                                n = y(y(n * a) * y(.009999999776482582));
                            }
                            if (n >= y(0)) return n;
                            if (t = n, n < y(0)) break r;
                        }
                        f = t == t ? t : y(0);
                    }
                    return f;
                }
                function Tr(r, e, a) {
                    var i, n = y(0), t = y(0), f = y(0);
                    r = r + 116 | 0, i = c[4236 + (e << 2) >> 2];
                    r: {
                        e: {
                            a: {
                                i: if (2139156720 != (0 | (e = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 5, i, 2140081935)))) {
                                    if (2140081935 == (0 | e)) break r;
                                    r = 4276;
                                    n: {
                                        if (2141891242 != (0 | e)) {
                                            if (b(2, e), (n = d()) == n) break n;
                                            r = 4268;
                                        }
                                        switch(n = m[r >> 2], t = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                            case 0:
                                                break a;
                                            case 1:
                                                break i;
                                            default:
                                                break e;
                                        }
                                    }
                                    if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break a;
                                }
                                n = y(y(n * a) * y(.009999999776482582));
                            }
                            if (n >= y(0)) return n;
                            if (t = n, n < y(0)) break r;
                        }
                        f = t == t ? t : y(0);
                    }
                    return f;
                }
                function Ir(r, e, a, i, n, t) {
                    var f = 0;
                    r: {
                        if (!r || !(t = 255 & e ? 0 | aa[0 | r](a, i, n, t) : 0 | aa[0 | r](a, i, n))) {
                            if (e = Ar(t = ye(588), a, 552), c[e + 564 >> 2] = 0, c[e + 556 >> 2] = 0, c[e + 560 >> 2] = 0, (0 | (n = c[a + 556 >> 2])) != (0 | (i = c[a + 560 >> 2]))) {
                                if ((0 | (f = i - n | 0)) < 0) break r;
                                for(r = ye(f), c[e + 556 >> 2] = r, c[e + 564 >> 2] = r + f; c[r >> 2] = c[n >> 2], r = r + 4 | 0, (0 | i) != (0 | (n = n + 4 | 0)););
                                c[e + 560 >> 2] = r;
                            }
                            r = c[a + 572 >> 2], c[e + 568 >> 2] = c[a + 568 >> 2], c[e + 572 >> 2] = r, c[e + 584 >> 2] = c[a + 584 >> 2], r = c[a + 580 >> 2], c[e + 576 >> 2] = c[a + 576 >> 2], c[e + 580 >> 2] = r, c[e + 552 >> 2] = 0;
                        }
                        return t;
                    }
                    I(), k();
                }
                function Xr(r, e) {
                    var a, i = 0, n = 0;
                    ar = a = ar - 16 | 0, c[a + 12 >> 2] = e;
                    r: {
                        if (r) {
                            if (e = c[a + 12 >> 2], i = c[r + 568 >> 2]) {
                                if (n = c[i + 4 >> 2], v[i + 9 | 0]) {
                                    aa[0 | n](i, r, 5, 0, 4215, e);
                                    break r;
                                }
                                aa[0 | n](i, r, 5, 4215, e);
                                break r;
                            }
                        } else e = c[a + 12 >> 2];
                        if (v[6936]) {
                            if (i = c[1733], n = c[i + 4 >> 2], v[i + 9 | 0]) {
                                aa[0 | n](i, r, 5, 0, 4215, e);
                                break r;
                            }
                        } else i = ye(28), o[i + 20 >> 1] = 0, c[i + 16 >> 2] = 1065353216, o[i + 10 >> 1] = 0, o[i + 12 >> 1] = 0, c[i >> 2] = 0, c[i + 24 >> 2] = 0, f[i + 9 | 0] = 0, n = 1, c[i + 4 >> 2] = 1, f[i + 22 | 0] = 0, c[1733] = i, f[6936] = 1, c[1732] = c[1732] + 1;
                        aa[0 | n](i, r, 5, 4215, e);
                    }
                    ar = a + 16 | 0;
                }
                function Or(r, e, a) {
                    var i, n = y(0), t = y(0);
                    r = r + 80 | 0, i = c[4236 + (e << 2) >> 2];
                    r: {
                        e: {
                            a: if (2139156720 != (0 | (e = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 5, i, 2140081935)))) {
                                if (2140081935 == (0 | e)) break r;
                                r = 4276;
                                i: {
                                    if (2141891242 != (0 | e)) {
                                        if (b(2, e), (n = d()) == n) break i;
                                        r = 4268;
                                    }
                                    switch(n = m[r >> 2], t = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                        case 0:
                                            break r;
                                        case 1:
                                            break a;
                                        default:
                                            break e;
                                    }
                                }
                                if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break r;
                            }
                            t = y(y(n * a) * y(.009999999776482582));
                        }
                        return t;
                    }
                    return n;
                }
                function Lr(r, e, a) {
                    var i, n = y(0), t = y(0);
                    r = r + 80 | 0, i = c[4220 + (e << 2) >> 2];
                    r: {
                        e: {
                            a: if (2139156720 != (0 | (e = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 4, i, 2140081935)))) {
                                if (2140081935 == (0 | e)) break r;
                                r = 4276;
                                i: {
                                    if (2141891242 != (0 | e)) {
                                        if (b(2, e), (n = d()) == n) break i;
                                        r = 4268;
                                    }
                                    switch(n = m[r >> 2], t = y(NaN), c[r + 4 >> 2] - 1 | 0){
                                        case 0:
                                            break r;
                                        case 1:
                                            break a;
                                        default:
                                            break e;
                                    }
                                }
                                if (b(2, 536870912 + (-1073741825 & e) | 0), n = d(), !(1073741824 & e)) break r;
                            }
                            t = y(y(n * a) * y(.009999999776482582));
                        }
                        return t;
                    }
                    return n;
                }
                function _r(r, e, a, i) {
                    var n = y(0);
                    return n = m[(e = (e << 2) + r | 0) >> 2], 2139156720 == (0 | (e = c[e >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | n == n || (n = m[(e = (a << 2) + r | 0) >> 2], 2139156720 == (0 | (e = c[e >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | n == n || 2139156720 == (0 | (e = c[r + 24 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (n = m[r + 24 >> 2]) == n || (n = m[r + 32 >> 2], (2139156720 == (0 | (r = c[r + 32 >> 2])) | 2140081935 == (0 | r) | 2141891242 == (0 | r) || (e = i, n == n)) && (e = r))), e;
                }
                function Fr(r, e, a, i, n) {
                    var t, f = 0, o = 0, u = y(0);
                    f = 2, o = c[r + 24 >> 2] >>> 2 & 3;
                    r: {
                        e: {
                            a: {
                                if (!(!c[r + 552 >> 2] | 2 != (0 | e))) {
                                    e = 0, f = 3;
                                    i: switch(o - 2 | 0){
                                        case 0:
                                            break r;
                                        case 1:
                                            break i;
                                        default:
                                            break a;
                                    }
                                    f = 2;
                                    break r;
                                }
                                if (e = 0, o >>> 0 > 1) break e;
                            }
                            e = f;
                        }
                        f = o;
                    }
                    a = _e(r, f, a), i = _e(r, e, i), u = Mr(r, f, n), m[(o = r + 228 | 0) + (c[4220 + (t = f << 2) >> 2] << 2) >> 2] = a + u, u = Ur(r, f, n), m[o + (c[t + 4236 >> 2] << 2) >> 2] = a + u, a = Mr(r, e, n), m[o + (c[4220 + (f = e << 2) >> 2] << 2) >> 2] = i + a, a = Ur(r, e, n), m[o + (c[f + 4236 >> 2] << 2) >> 2] = i + a;
                }
                function Cr(r) {
                    var e = 0, a = 0, i = 0, n = 0;
                    if (r |= 0) {
                        if (e = c[r >> 2], (a = c[e + 552 >> 2]) && (ee(a, e), c[e + 552 >> 2] = 0), (0 | (i = c[e + 560 >> 2])) != (0 | (a = c[e + 556 >> 2]))) for(n = (i = i - a >> 2) >>> 0 <= 1 ? 1 : i, i = 0; c[c[a + (i << 2) >> 2] + 552 >> 2] = 0, (0 | n) != (0 | (i = i + 1 | 0)););
                        c[e + 560 >> 2] = a, Sr(e + 556 | 0), (a = c[e + 556 >> 2]) && (c[e + 560 >> 2] = a, gr(a)), gr(e), e = c[r + 8 >> 2], c[r + 8 >> 2] = 0, e && aa[c[c[e >> 2] + 4 >> 2]](e), e = c[r + 4 >> 2], c[r + 4 >> 2] = 0, e && aa[c[c[e >> 2] + 4 >> 2]](e), gr(r);
                    }
                }
                function Sr(r) {
                    var e, a = 0, i = 0, n = 0, t = 0;
                    ar = e = ar - 32 | 0, a = c[r >> 2], (i = c[r + 4 >> 2] - a >> 2) >>> 0 >= c[r + 8 >> 2] - a >> 2 >>> 0 || (i = pe(e + 8 | 0, i, i, r + 8 | 0), a = c[r >> 2], n = c[r + 4 >> 2] - a | 0, n = wr(c[i + 4 >> 2] - n | 0, a, n), a = c[r >> 2], c[r >> 2] = n, c[i + 4 >> 2] = a, n = c[r + 4 >> 2], c[r + 4 >> 2] = c[i + 8 >> 2], c[i + 8 >> 2] = n, t = c[r + 8 >> 2], c[r + 8 >> 2] = c[i + 12 >> 2], c[i >> 2] = a, c[i + 12 >> 2] = t, (0 | a) != (0 | n) && (c[i + 8 >> 2] = n + (3 + (a - n | 0) & -4)), a && gr(a)), ar = e + 32 | 0;
                }
                function Pr(r, e, a) {
                    var i = 0, n = 0, t = 0;
                    if (!(32 & v[0 | r])) r: {
                        i = e;
                        e: {
                            if (!(r = c[(e = r) + 16 >> 2])) {
                                if (me(e)) break e;
                                r = c[e + 16 >> 2];
                            }
                            if (r - (t = c[e + 20 >> 2]) >>> 0 < a >>> 0) {
                                aa[c[e + 36 >> 2]](e, i, a);
                                break r;
                            }
                            a: if (!(c[e + 80 >> 2] < 0)) {
                                for(r = a;;){
                                    if (n = r, !r) break a;
                                    if (10 == v[i + (r = n - 1 | 0) | 0]) break;
                                }
                                if (aa[c[e + 36 >> 2]](e, i, n) >>> 0 < n >>> 0) break e;
                                i = i + n | 0, a = a - n | 0, t = c[e + 20 >> 2];
                            }
                            Ar(t, i, a), c[e + 20 >> 2] = c[e + 20 >> 2] + a;
                        }
                    }
                }
                function Yr(r, e, a) {
                    var i, n = 0, t = 0;
                    ar = i = ar - 16 | 0, n = r + 24 | 0, aa[0 | e](i + 8 | 0, n), t = c[i + 12 >> 2];
                    r: if ((c[c[i + 8 >> 2] >> 2] & 7 << t) >> t != (0 | a)) for(aa[0 | e](i + 8 | 0, n), n = e = c[i + 8 >> 2], t = c[e >> 2], e = c[i + 12 >> 2], c[n >> 2] = t & (7 << e ^ -1) | (7 & a) << e;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                    ar = i + 16 | 0;
                }
                function Ur(r, e, a) {
                    var i, n = y(0);
                    r = r + 44 | 0, i = c[4236 + (e << 2) >> 2];
                    r: {
                        if (2139156720 != (0 | (r = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 5, i, 2140081935)))) {
                            if (2140081935 == (0 | r) | 2141891242 == (0 | r)) break r;
                            if (b(2, r), (n = d()) != n) return y(NaN);
                            if (b(2, 536870912 + (-1073741825 & r) | 0), n = d(), !(1073741824 & r)) break r;
                        }
                        n = y(y(n * a) * y(.009999999776482582));
                    }
                    return n;
                }
                function Mr(r, e, a) {
                    var i, n = y(0);
                    r = r + 44 | 0, i = c[4220 + (e << 2) >> 2];
                    r: {
                        if (2139156720 != (0 | (r = 2 != (-2 & e) ? Hr(r, i, 2140081935) : _r(r, 4, i, 2140081935)))) {
                            if (2140081935 == (0 | r) | 2141891242 == (0 | r)) break r;
                            if (b(2, r), (n = d()) != n) return y(NaN);
                            if (b(2, 536870912 + (-1073741825 & r) | 0), n = d(), !(1073741824 & r)) break r;
                        }
                        n = y(y(n * a) * y(.009999999776482582));
                    }
                    return n;
                }
                function Hr(r, e, a) {
                    var i = y(0);
                    return i = m[(e = (e << 2) + r | 0) >> 2], 2139156720 == (0 | (e = c[e >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | i == i || 2139156720 == (0 | (e = c[r + 28 >> 2])) | 2140081935 == (0 | e) | 2141891242 == (0 | e) | (i = m[r + 28 >> 2]) == i || (i = m[r + 32 >> 2], (2139156720 == (0 | (r = c[r + 32 >> 2])) | 2140081935 == (0 | r) | 2141891242 == (0 | r) || (e = a, i == i)) && (e = r)), e;
                }
                function Qr(r, e) {
                    var a, i = y(0);
                    return r = r + 152 | 0, a = c[4236 + (e << 2) >> 2], r = 2 != (-2 & e) ? Hr(r, a, 2140081935) : _r(r, 5, a, 2140081935), i = y(0), 2139156720 != (0 | r) && (i = y(0), 2140081935 != (0 | r) && (2141891242 == (0 | r) || (b(2, r), (i = d()) != i) ? i = y(NaN) : (b(2, 536870912 + (-1073741825 & r) | 0), i = d()))), Re(i, y(0));
                }
                function zr(r, e) {
                    var a, i = y(0);
                    return r = r + 152 | 0, a = c[4220 + (e << 2) >> 2], r = 2 != (-2 & e) ? Hr(r, a, 2140081935) : _r(r, 4, a, 2140081935), i = y(0), 2139156720 != (0 | r) && (i = y(0), 2140081935 != (0 | r) && (2141891242 == (0 | r) || (b(2, r), (i = d()) != i) ? i = y(NaN) : (b(2, 536870912 + (-1073741825 & r) | 0), i = d()))), Re(i, y(0));
                }
                function jr(r, e, a, i) {
                    var n, t = 0, f = 0;
                    r: if ((n = (t = (t = dr(r *= e)) < 0 ? t + 1 : t) != t) | !(E(t) < 1e-4)) {
                        if (t == t) {
                            if (r -= t, E(t + -1) < 1e-4) {
                                r += 1;
                                break r;
                            }
                        } else r -= t;
                        a ? r += 1 : i || (f = 0, n || (f = 1, t > .5 || (f = E(t + -0.5) < 1e-4 ? 1 : 0)), r += f);
                    } else r -= t;
                    return y(r != r | e != e ? NaN : r / e);
                }
                function Dr(r) {
                    var e = y(0), a = 0, i = y(0);
                    a = 0;
                    r: if (131072 != (196608 & c[r + 24 >> 2])) {
                        if (c[r + 552 >> 2]) {
                            if (((e = m[r + 32 >> 2]) == e || (e = m[r + 28 >> 2]) > y(0)) && (a = 1, e != y(0))) break r;
                            (e = m[r + 36 >> 2]) != e && (f[r + 4 | 0] < 0 ? e = y(1) : (e = y(0), (i = m[r + 28 >> 2]) < y(0) && (e = y(-i))));
                        }
                        a = e != y(0);
                    }
                    return a;
                }
                function xr(r, e) {
                    var a = y(0);
                    r: {
                        if (2139156720 != (0 | e)) {
                            if (2140081935 != (0 | e)) {
                                if (2141891242 != (0 | e)) break r;
                                return c[r >> 2] = 2143289344, void (c[r + 4 >> 2] = 3);
                            }
                            return c[r >> 2] = 0, void (c[r + 4 >> 2] = 1);
                        }
                        return c[r >> 2] = 0, void (c[r + 4 >> 2] = 2);
                    }
                    if (b(2, e), (a = d()) != a) return c[r >> 2] = 2143289344, void (c[r + 4 >> 2] = 0);
                    c[r + 4 >> 2] = 1073741824 & e ? 2 : 1, c[r >> 2] = 536870912 + (-1073741825 & e);
                }
                function Jr(r) {
                    var e = 0, a = 0, i = 0;
                    r: if (8 & (a = c[r + 24 >> 2]) && (e = 1, 5120 != (7168 & a) && (e = 0, (0 | (i = c[r + 560 >> 2])) != (0 | (a = c[r + 556 >> 2]))))) for(i = (r = i - a >> 2) >>> 0 <= 1 ? 1 : r, r = 0;;){
                        if (e = 131072 != (196608 & (e = c[c[a + (r << 2) >> 2] + 24 >> 2])) & 40960 == (57344 & e)) break r;
                        if ((0 | i) == (0 | (r = r + 1 | 0))) break;
                    }
                    return e;
                }
                function Kr(r) {
                    var e = 0, a = y(0);
                    return e = 2143289344, y(E(r)) == y(1 / 0) | r != r || (e = 2139156720, r < y(10842021724855044e-35) & r > y(-0.00000000000000000010842021724855044) | r == y(0) || (b(2, -2147483648 & (l(r), u(2)) | 1602224127), a = d(), e = 1073741824 | (l(r > y(0xffffff0000000000) || r < y(-18446742974197924000) ? a : r), u(2) - 536870912))), e;
                }
                function qr(r) {
                    var e = 0, a = y(0);
                    return e = 2143289344, y(E(r)) == y(1 / 0) | r != r || (e = 2140081935, r < y(10842021724855044e-35) & r > y(-0.00000000000000000010842021724855044) | r == y(0) || (b(2, -2147483648 & (l(r), u(2)) | 1610612735), a = d(), e = 0 | (l(r > y(0x1fffffe0000000000) || r < y(-36893485948395848000) ? a : r), u(2) - 536870912))), e;
                }
                function $r(r, e) {
                    return e ? e = Te(c[e >> 2]) : (v[6936] ? e = c[1733] : (e = ye(28), o[e + 20 >> 1] = 0, c[e + 16 >> 2] = 1065353216, o[e + 10 >> 1] = 0, o[e + 12 >> 1] = 0, c[e >> 2] = 0, c[e + 24 >> 2] = 0, f[e + 9 | 0] = 0, c[e + 4 >> 2] = 1, f[e + 22 | 0] = 0, c[1733] = e, f[6936] = 1, c[1732] = c[1732] + 1), e = Te(e)), c[r + 4 >> 2] = 0, c[r + 8 >> 2] = 0, c[r >> 2] = e, c[e >> 2] = r, r;
                }
                function re(r, e, a) {
                    var i = 0, n = 0, t = 0;
                    if (e) for(; r = Ae(i = hr(r, e, 10), n = ir, 246, 0) + r | 0, f[0 | (a = a - 1 | 0)] = 48 | r, t = e >>> 0 > 9, r = i, e = n, t;);
                    else i = r;
                    if (i) for(; r = (i >>> 0) / 10 | 0, f[0 | (a = a - 1 | 0)] = w(r, 246) + i | 48, e = i >>> 0 > 9, i = r, e;);
                    return a;
                }
                function ee(r, e) {
                    var a = 0, i = 0;
                    r: {
                        e: if ((0 | (a = c[r + 556 >> 2])) != (0 | (i = c[r + 560 >> 2]))) {
                            for(;;){
                                if (c[a >> 2] == (0 | e)) break e;
                                if ((0 | i) == (0 | (a = a + 4 | 0))) break;
                            }
                            break r;
                        }
                        if ((0 | a) != (0 | i)) return wr(a, e = a + 4 | 0, i - e | 0), c[r + 560 >> 2] = i - 4, 1;
                    }
                    return 0;
                }
                function ae(r, e) {
                    var a, i, n = 0;
                    if (A(+r), a = 0 | u(1), i = 0 | u(0), 2047 != (0 | (n = a >>> 20 & 2047))) {
                        if (!n) return 0 == r ? n = 0 : (r = ae(0x10000000000000000 * r, e), n = c[e >> 2] + -64 | 0), c[e >> 2] = n, r;
                        c[e >> 2] = n - 1022, b(0, 0 | i), b(1, -2146435073 & a | 1071644672), r = +s();
                    }
                    return r;
                }
                function ie(r, e, a) {
                    var i = 0;
                    r: if (c[184 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[184 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function ne(r, e, a) {
                    var i = 0;
                    r: if (c[192 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[192 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function te(r, e, a) {
                    var i = 0;
                    r: if (c[176 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[176 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function fe(r, e) {
                    var a = 0, i = 0, n = 0;
                    r: if (c[16 + (a = r + 24 | 0) >> 2] != (0 | e)) for(i = 0 | aa[9](a), n = e, c[i + 16 >> 2] = n;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function oe(r, e, a) {
                    var i = 0;
                    r: if (c[56 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[56 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function ce(r, e, a) {
                    var i = 0;
                    r: if (c[92 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[92 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function ue(r, e, a) {
                    var i = 0;
                    r: if (c[20 + ((i = r + 24 | 0) + (e << 2) | 0) >> 2] != (0 | a)) for(c[20 + ((e << 2) + i | 0) >> 2] = a;;){
                        if (4 & (e = v[r + 4 | 0])) break r;
                        if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                    }
                }
                function be(r, e) {
                    var a, i = y(0);
                    return r = r + 80 | 0, a = c[4236 + (e << 2) >> 2], 2139156720 == (0 | (r = 2 != (-2 & e) ? Hr(r, a, 2143289344) : _r(r, 5, a, 2143289344))) | 2140081935 == (0 | r) | 2141891242 == (0 | r) ? r = 1 : (b(2, r), r = (i = d()) == i), r;
                }
                function se(r, e) {
                    var a, i = y(0);
                    return r = r + 80 | 0, a = c[4220 + (e << 2) >> 2], 2139156720 == (0 | (r = 2 != (-2 & e) ? Hr(r, a, 2143289344) : _r(r, 4, a, 2143289344))) | 2140081935 == (0 | r) | 2141891242 == (0 | r) ? r = 1 : (b(2, r), r = (i = d()) == i), r;
                }
                function Ae(r, e, a, i) {
                    var n, t, f, o, c = 0, u = 0;
                    return o = w(c = a >>> 16 | 0, u = r >>> 16 | 0), c = (65535 & (u = ((f = w(n = 65535 & a, t = 65535 & r)) >>> 16 | 0) + w(u, n) | 0)) + w(c, t) | 0, ir = (w(e, a) + o | 0) + w(r, i) + (u >>> 16) + (c >>> 16) | 0, 65535 & f | c << 16;
                }
                function ke(r, e) {
                    var a, i, n = 0;
                    ar = a = ar - 16 | 0, i = -17 & (n = v[r + 4 | 0]), f[r + 4 | 0] = i;
                    r: {
                        if (e) {
                            if (c[r + 560 >> 2] != c[r + 556 >> 2]) break r;
                            n = 8 | i;
                        } else n &= 231;
                        return c[r + 8 >> 2] = e, f[r + 4 | 0] = n, void (ar = a + 16 | 0);
                    }
                    c[a >> 2] = 4059, Xr(r, a), De(), k();
                }
                function le(r, e, a, i, n) {
                    var t;
                    if (ar = t = ar - 256 | 0, !(73728 & n | (0 | a) <= (0 | i))) {
                        if (Rr(t, 255 & e, (a = (i = a - i | 0) >>> 0 < 256) ? i : 256), !a) for(; Pr(r, t, 256), (i = i - 256 | 0) >>> 0 > 255;);
                        Pr(r, t, i);
                    }
                    ar = t + 256 | 0;
                }
                function de(r, e, a) {
                    var i = 0, n = y(0);
                    2 == (-2 & a) && (n = m[(i = e - -64 | 0) >> 2], 2139156720 == (0 | (i = c[i >> 2])) | 2140081935 == (0 | i) | 2141891242 == (0 | i) | n == n) || (i = c[44 + ((c[4236 + (a << 2) >> 2] << 2) + e | 0) >> 2]), xr(r, i);
                }
                function ve(r, e, a) {
                    var i = 0, n = y(0);
                    2 == (-2 & a) && 2139156720 == (0 | (i = c[e + 60 >> 2])) | 2140081935 == (0 | i) | 2141891242 == (0 | i) | (n = m[e + 60 >> 2]) == n || (i = c[44 + ((c[4220 + (a << 2) >> 2] << 2) + e | 0) >> 2]), xr(r, i);
                }
                function he(r) {
                    var e = 0, a = 0, i = 0;
                    for(i = c[r >> 2]; xe(a = f[0 | i]);)i = i + 1 | 0, c[r >> 2] = i, e = e >>> 0 <= 214748364 ? (0 | (a = a - 48 | 0)) > (2147483647 ^ (e = w(e, 10))) ? -1 : a + e | 0 : -1;
                    return e;
                }
                function pe(r, e, a, i) {
                    var n = 0;
                    c[r + 12 >> 2] = 0, c[r + 16 >> 2] = i;
                    r: {
                        if (e) {
                            if (e >>> 0 >= 1073741824) break r;
                            n = ye(e << 2);
                        }
                        return c[r >> 2] = n, a = (a << 2) + n | 0, c[r + 8 >> 2] = a, c[r + 12 >> 2] = (e << 2) + n, c[r + 4 >> 2] = a, r;
                    }
                    ea(), k();
                }
                function me(r) {
                    var e = 0;
                    return e = c[r + 72 >> 2], c[r + 72 >> 2] = e - 1 | e, 8 & (e = c[r >> 2]) ? (c[r >> 2] = 32 | e, -1) : (c[r + 4 >> 2] = 0, c[r + 8 >> 2] = 0, e = c[r + 44 >> 2], c[r + 28 >> 2] = e, c[r + 20 >> 2] = e, c[r + 16 >> 2] = e + c[r + 48 >> 2], 0);
                }
                function Ne(r, e, a, i) {
                    e |= 0, a |= 0, i |= 0;
                    var n = 0;
                    n = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (n = c[n + c[e >> 2] >> 2]), aa[0 | n](e, a, i);
                }
                function we(r, e, a) {
                    e |= 0, a |= 0;
                    var i = 0;
                    return i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), 0 | aa[0 | i](e, a);
                }
                function ye(r) {
                    var e = 0;
                    r = r || 1;
                    r: {
                        for(;;){
                            if (e = cr(r)) break r;
                            if (!(e = c[2022])) break;
                            aa[0 | e]();
                        }
                        I(), k();
                    }
                    return e;
                }
                function Ee(r, e, a) {
                    e |= 0, a |= 0;
                    var i = 0;
                    i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](e, a);
                }
                function Ge(r, e) {
                    e |= 0;
                    var a = 0;
                    return a = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (a = c[a + c[e >> 2] >> 2]), 0 | aa[0 | a](e);
                }
                function Re(r, e) {
                    return (2147483647 & (l(r), u(2))) >>> 0 <= 2139095040 ? (2147483647 & (l(e), u(2))) >>> 0 > 2139095040 ? r : y(g(r, e)) : e;
                }
                function ge(r, e) {
                    return (2147483647 & (l(r), u(2))) >>> 0 <= 2139095040 ? (2147483647 & (l(e), u(2))) >>> 0 > 2139095040 ? r : y(R(r, e)) : e;
                }
                function Ze(r, e) {
                    var a;
                    return r |= 0, e |= 0, ar = a = ar - 16 | 0, c[a + 8 >> 2] = e, r = 0 | aa[0 | r](a + 8 | 0), X(c[a + 8 >> 2]), ar = a + 16 | 0, 0 | r;
                }
                function We(r, e) {
                    return r ? (57216 == (-128 & e) | e >>> 0 <= 127 ? (f[0 | r] = e, r = 1) : (c[1761] = 25, r = -1), r) : 0;
                }
                function Ve(r, e) {
                    var a, i;
                    a = ye(4), c[a >> 2] = e, i = ye(4), c[i >> 2] = e, O(6955, 0 | r, 7018, 4630, 192, 0 | a, 7018, 4634, 193, 0 | i);
                }
                function Be(r, e) {
                    var a, i;
                    a = ye(4), c[a >> 2] = e, i = ye(4), c[i >> 2] = e, O(6985, 0 | r, 7018, 4630, 190, 0 | a, 7018, 4634, 191, 0 | i);
                }
                function Te(r) {
                    var e, a;
                    return ar = e = ar - 16 | 0, a = br(ye(588), r), r || (c[e >> 2] = 2759, Xr(0, e), De(), k()), ar = e + 16 | 0, a;
                }
                function Ie(r, e) {
                    var a = 0;
                    1 & f[6964] ? a = c[1740] : (a = 0 | C(1, 4400), f[6964] = 1, c[1740] = a), z(0 | a, 0 | r, 0 | e, 0);
                }
                function Xe(r, e) {
                    e |= 0;
                    var a = 0;
                    a = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (a = c[a + c[e >> 2] >> 2]), aa[0 | a](e);
                }
                function Oe(r) {
                    return c[(r |= 0) >> 2] = 4508, v[r + 4 | 0] && Ie(c[r + 8 >> 2], 1758), X(c[r + 8 >> 2]), 0 | r;
                }
                function Le(r) {
                    return c[(r |= 0) >> 2] = 4388, v[r + 4 | 0] && Ie(c[r + 8 >> 2], 1758), X(c[r + 8 >> 2]), 0 | r;
                }
                function _e(r, e, a) {
                    return se(r, e) ? Lr(r, e, a) : ((a = Or(r, e, a)) == a && (a = y(-a)), a);
                }
                function Fe(r) {
                    var e = 0;
                    (r |= 0) && ((e = c[r >> 2]) && gr(e), c[1732] = c[1732] - 1, gr(r));
                }
                function Ce(r, e, a) {
                    e |= 0, a = +a, N[c[(r |= 0) >> 2] + e >> 3] = a;
                }
                function Se(r, e) {
                    return e |= 0, +N[c[(r |= 0) >> 2] + e >> 3];
                }
                function Pe(r) {
                    (r |= 0) && aa[c[c[r >> 2] + 4 >> 2]](r);
                }
                function Ye(r) {
                    return r ? (c[1761] = r, -1) : 0;
                }
                function Ue(r, e, a) {
                    return y(Mr(r, e, a) + Ur(r, e, a));
                }
                function Me(r, e, a, i) {
                    D(0 | r, 0 | e, 8, 0, 0 | a, -1, 0 | i);
                }
                function He(r, e) {
                    e |= 0, aa[c[(r |= 0) >> 2]](e);
                }
                function Qe(r, e, a) {
                    return Zr(r, e, a, 2, 3);
                }
                function ze(r) {
                    return 0 | aa[0 | (r |= 0)]();
                }
                function je(r, e) {
                    e |= 0, aa[0 | (r |= 0)](e);
                }
                function De() {
                    aa[c[1470]](), ea(), k();
                }
                function xe(r) {
                    return r - 48 >>> 0 < 10;
                }
                function Je(r) {
                    (r |= 0) && gr(r);
                }
                function Ke(r) {
                    return 0 | r;
                }
                function qe(r) {
                    f[4 + (r |= 0) | 0] = 1;
                }
                function $e(r) {
                    k();
                }
                function ra() {
                    ea(), k();
                }
                function ea() {
                    I(), k();
                }
                n(e = v, 1024, "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"), n(e, 4270, "wH8AAAAAAADAfwMAAABpaQB2AHZp"), n(e, 4304, "KxsAACkbAABpGwAAYxsAAGkbAABjGwAAaWlpZmlmaQBcGwAALBsAAHZpaQAtGwAAcBsAAGlpaQ=="), n(e, 4368, "wwAAAMQAAADF"), n(e, 4388, "wwAAAMYAAADHAAAAXBs="), n(e, 4416, "KxsAAGkbAABjGwAAaRsAAGMbAABwGwAAaxsAAHAbAABpaWlpAAAAAFwbAABBGwAAXBsAAEMbAABEGwAAcBs="), n(e, 4488, "yAAAAMkAAADK"), n(e, 4508, "yAAAAMsAAADHAAAARxsAAFwbAABHGw=="), n(e, 4544, "XBsAAEcbAABjGwAAXRsAAHZpaWlpAAAAXBsAAEcbAABpGwAAdmlpZgAAAABcGwAARxsAAF0bAAB2aWlpAAAAAF0bAABIGwAAYxsAAF0bAABHGwAAaQBkaWkAdmlpZAAATBsAAEwbAABHGwAAXBsAAEwbAABcGwAATBsAAEsbAABcGwAATBsAAGMbAAAAAAAAXBsAAEwbAABjGwAAahsAAHZpaWlkAAAAXBsAAEwbAABqGwAAYxsAAE0bAABKGwAATRsAAGMbAABKGwAATRsAAGobAABNGwAAahsAAE0bAABjGwAAZGlpaQAAAABpGwAATBsAAGMbAABmaWlpAAAAAFwbAABMGwAATBsAAGQbAABcGwAATBsAAEwbAABkGwAATRsAAEwbAABMGwAATBsAAEwbAABkGwAAXRsAAEwbAABcGwAATBsAAF0bAABcGwAATBsAACkbAABcGwAATBsAAEEbAABdGwAATRsAAAAAAABcGwAATBsAAGobAABqGwAAYxsAAHZpaWRkaQAASRsAAE0b"), n(e, 4960, "GQAKABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZABEKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), n(e, 5041, "DgAAAAAAAAAAGQAKDRkZGQANAAACAAkOAAAACQAOAAAO"), n(e, 5099, "DA=="), n(e, 5111, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), n(e, 5157, "EA=="), n(e, 5169, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), n(e, 5215, "Eg=="), n(e, 5227, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), n(e, 5282, "GgAAABoaGgAAAAAAAAk="), n(e, 5331, "FA=="), n(e, 5343, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), n(e, 5389, "Fg=="), n(e, 5401, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"), n(e, 5476, "0Q=="), n(e, 5516, "//////////8="), n(e, 5584, "oB8BAAAAAAAF"), n(e, 5604, "zA=="), n(e, 5628, "zQAAAM4AAACEGw=="), n(e, 5652, "Ag=="), n(e, 5668, "//////////8="), n(e, 5736, "BQ=="), n(e, 5748, "zw=="), n(e, 5772, "zQAAANAAAACYGwAAAAQ="), n(e, 5796, "AQ=="), n(e, 5812, "/////wo="), n(e, 5880, "0g==");
                var aa = function(r) {
                    return r.set = function(r, e) {
                        this[r] = e;
                    }, r.get = function(r) {
                        return this[r];
                    }, r;
                }([
                    null,
                    function(r, e, a, i, n) {
                        return i |= 0, n |= 0, (a |= 0) && 5 != (0 | a) ? 0 | Qe(5736, i, n) : 0 | Qe(5592, i, n);
                    },
                    function(r, e, a, i, n, t) {
                        r |= 0, e = +e, a |= 0, i |= 0, n |= 0, t |= 0;
                        var o, b = 0, s = 0, k = 0, l = 0, d = 0, h = 0, p = 0, m = 0, N = 0, y = 0, G = 0, R = 0, g = 0, Z = 0, W = 0, V = 0, B = 0, T = 0;
                        ar = o = ar - 560 | 0, c[o + 44 >> 2] = 0, A(+e), b = 0 | u(1), u(0), (0 | b) < 0 ? (R = 1, B = 1176, A(+(e = -e)), b = 0 | u(1), u(0)) : 2048 & n ? (R = 1, B = 1179) : (B = (R = 1 & n) ? 1182 : 1177, T = !R);
                        r: if (2146435072 != (2146435072 & b)) {
                            Z = o + 16 | 0;
                            e: {
                                a: {
                                    i: {
                                        if (e = ae(e, o + 44 | 0), 0 != (e += e)) {
                                            if (b = c[o + 44 >> 2], c[o + 44 >> 2] = b - 1, 97 != (0 | (W = 32 | t))) break i;
                                            break e;
                                        }
                                        if (97 == (0 | (W = 32 | t))) break e;
                                        d = c[o + 44 >> 2], h = (0 | i) < 0 ? 6 : i;
                                        break a;
                                    }
                                    d = b - 29 | 0, c[o + 44 >> 2] = d, e *= 268435456, h = (0 | i) < 0 ? 6 : i;
                                }
                                for(s = y = (o + 48 | 0) + ((0 | d) >= 0 ? 288 : 0) | 0; i = e < 4294967296 & e >= 0 ? ~~e >>> 0 : 0, c[s >> 2] = i, s = s + 4 | 0, 0 != (e = 1e9 * (e - +(i >>> 0))););
                                if ((0 | d) <= 0) i = d, b = s, k = y;
                                else for(k = y, i = d;;){
                                    if (m = (0 | i) >= 29 ? 29 : i, !(k >>> 0 > (b = s - 4 | 0) >>> 0)) {
                                        for(i = 0; l = c[b >> 2], V = i, i = 31 & m, (63 & m) >>> 0 >= 32 ? (p = l << i, i = 0) : (p = (1 << i) - 1 & l >>> 32 - i, i = l << i), l = p + N | 0, l = Ae(i = hr(V = V + i | 0, i >>> 0 > V >>> 0 ? l + 1 | 0 : l, 1e9), ir, -1000000000, 0) + V | 0, c[b >> 2] = l, k >>> 0 <= (b = b - 4 | 0) >>> 0;);
                                        i && (c[(k = k - 4 | 0) >> 2] = i);
                                    }
                                    for(; k >>> 0 < (b = s) >>> 0 && !c[(s = b - 4 | 0) >> 2];);
                                    if (i = c[o + 44 >> 2] - m | 0, c[o + 44 >> 2] = i, s = b, !((0 | i) > 0)) break;
                                }
                                if ((0 | i) < 0) for(g = 1 + ((h + 25 >>> 0) / 9 | 0) | 0, N = 102 == (0 | W);;){
                                    if (p = (0 | (i = 0 - i | 0)) >= 9 ? 9 : i, b >>> 0 <= k >>> 0) s = c[k >> 2];
                                    else {
                                        for(m = 1e9 >>> p | 0, l = -1 << p ^ -1, i = 0, s = k; V = i, i = c[s >> 2], c[s >> 2] = V + (i >>> p | 0), i = w(m, i & l), (s = s + 4 | 0) >>> 0 < b >>> 0;);
                                        s = c[k >> 2], i && (c[b >> 2] = i, b = b + 4 | 0);
                                    }
                                    if (i = p + c[o + 44 >> 2] | 0, c[o + 44 >> 2] = i, k = (!s << 2) + k | 0, b = b - (s = N ? y : k) >> 2 > (0 | g) ? s + (g << 2) | 0 : b, !((0 | i) < 0)) break;
                                }
                                if (i = 0, !(b >>> 0 <= k >>> 0 || (i = w(y - k >> 2, 9), s = 10, (l = c[k >> 2]) >>> 0 < 10))) for(; i = i + 1 | 0, l >>> 0 >= (s = w(s, 10)) >>> 0;);
                                if ((0 | (s = (h - (102 != (0 | W) ? i : 0) | 0) - (103 == (0 | W) & 0 != (0 | h)) | 0)) < (w(b - y >> 2, 9) - 9 | 0)) {
                                    if (d = ((((0 | d) < 0 ? 4 : 292) + o | 0) + ((l = (0 | (m = s + 9216 | 0)) / 9 | 0) << 2) | 0) - 4048 | 0, s = 10, (0 | (p = m + w(l, -9) | 0)) <= 7) for(; s = w(s, 10), 8 != (0 | (p = p + 1 | 0)););
                                    if (!((0 | (m = c[d >> 2])) == (0 | (N = w(g = (m >>> 0) / (s >>> 0) | 0, s))) & (0 | (l = d + 4 | 0)) == (0 | b)) && (m = m - N | 0, !(1 & g) && (e = 9007199254740992, !(1 & f[d - 4 | 0]) | 1e9 != (0 | s) | k >>> 0 >= d >>> 0) || (e = 9007199254740994), G = (0 | b) == (0 | l) ? 1 : 1.5, G = (l = s >>> 1 | 0) >>> 0 > m >>> 0 ? .5 : (0 | l) == (0 | m) ? G : 1.5, 45 != v[0 | B] | T || (G = -G, e = -e), c[d >> 2] = N, e + G != e)) {
                                        if (i = s + N | 0, c[d >> 2] = i, i >>> 0 >= 1e9) for(; c[d >> 2] = 0, (d = d - 4 | 0) >>> 0 < k >>> 0 && (c[(k = k - 4 | 0) >> 2] = 0), i = c[d >> 2] + 1 | 0, c[d >> 2] = i, i >>> 0 > 999999999;);
                                        if (i = w(y - k >> 2, 9), s = 10, !((l = c[k >> 2]) >>> 0 < 10)) for(; i = i + 1 | 0, l >>> 0 >= (s = w(s, 10)) >>> 0;);
                                    }
                                    b = b >>> 0 > (s = d + 4 | 0) >>> 0 ? s : b;
                                }
                                for(; l = b, !(m = b >>> 0 <= k >>> 0) && !c[(b = l - 4 | 0) >> 2];);
                                if (103 == (0 | W)) {
                                    if (h = ((b = (0 | (s = h || 1)) > (0 | i) & (0 | i) > -5) ? -1 ^ i : -1) + s | 0, t = (b ? -1 : -2) + t | 0, !(d = 8 & n)) {
                                        if (b = -9, !m && (d = c[l - 4 >> 2]) && (p = 10, b = 0, !((d >>> 0) % 10 | 0))) {
                                            for(; s = b, b = b + 1 | 0, !((d >>> 0) % ((p = w(p, 10)) >>> 0) | 0););
                                            b = -1 ^ s;
                                        }
                                        s = w(l - y >> 2, 9), 70 != (-33 & t) ? (d = 0, h = (0 | (b = (0 | (b = ((i + s | 0) + b | 0) - 9 | 0)) > 0 ? b : 0)) > (0 | h) ? h : b) : (d = 0, h = (0 | (b = (0 | (b = (b + s | 0) - 9 | 0)) > 0 ? b : 0)) > (0 | h) ? h : b);
                                    }
                                } else d = 8 & n;
                                if (p = -1, (0 | ((m = d | h) ? 2147483645 : 2147483646)) < (0 | h)) break r;
                                if (N = 1 + ((0 != (0 | m)) + h | 0) | 0, 70 != (0 | (s = -33 & t))) {
                                    if ((Z - (b = re(((b = i >> 31) ^ i) - b | 0, 0, Z)) | 0) <= 1) for(; f[0 | (b = b - 1 | 0)] = 48, (Z - b | 0) < 2;);
                                    if (f[0 | (g = b - 2 | 0)] = t, f[b - 1 | 0] = (0 | i) < 0 ? 45 : 43, (0 | (b = Z - g | 0)) > (2147483647 ^ N)) break r;
                                } else {
                                    if ((2147483647 ^ N) < (0 | i)) break r;
                                    b = (0 | i) > 0 ? i : 0;
                                }
                                if ((0 | (i = b + N | 0)) > (2147483647 ^ R)) break r;
                                le(r, 32, a, N = i + R | 0, n), Pr(r, B, R), le(r, 48, a, N, 65536 ^ n);
                                a: {
                                    i: {
                                        n: {
                                            if (70 == (0 | s)) {
                                                for(i = 8 | (t = o + 16 | 0), d = 9 | t, k = s = k >>> 0 > y >>> 0 ? y : k;;){
                                                    b = re(c[k >> 2], 0, d);
                                                    t: if ((0 | s) == (0 | k)) (0 | b) == (0 | d) && (f[o + 24 | 0] = 48, b = i);
                                                    else {
                                                        if (o + 16 >>> 0 >= b >>> 0) break t;
                                                        for(; f[0 | (b = b - 1 | 0)] = 48, o + 16 >>> 0 < b >>> 0;);
                                                    }
                                                    if (Pr(r, b, d - b | 0), !(y >>> 0 >= (k = k + 4 | 0) >>> 0)) break;
                                                }
                                                if (m && Pr(r, 4206, 1), (0 | h) <= 0 | k >>> 0 >= l >>> 0) break n;
                                                for(;;){
                                                    if ((b = re(c[k >> 2], 0, d)) >>> 0 > o + 16 >>> 0) for(; f[0 | (b = b - 1 | 0)] = 48, o + 16 >>> 0 < b >>> 0;);
                                                    if (Pr(r, b, (0 | h) >= 9 ? 9 : h), b = h - 9 | 0, l >>> 0 <= (k = k + 4 | 0) >>> 0) break i;
                                                    if (i = (0 | h) > 9, h = b, !i) break;
                                                }
                                                break i;
                                            }
                                            t: if (!((0 | h) < 0)) for(y = k >>> 0 < l >>> 0 ? l : k + 4 | 0, i = 8 | (t = o + 16 | 0), l = 9 | t, s = k;;){
                                                (0 | l) == (0 | (b = re(c[s >> 2], 0, l))) && (f[o + 24 | 0] = 48, b = i);
                                                f: if ((0 | s) == (0 | k)) Pr(r, b, 1), b = b + 1 | 0, d | h && Pr(r, 4206, 1);
                                                else {
                                                    if (o + 16 >>> 0 >= b >>> 0) break f;
                                                    for(; f[0 | (b = b - 1 | 0)] = 48, o + 16 >>> 0 < b >>> 0;);
                                                }
                                                if (Pr(r, b, (0 | (t = l - b | 0)) > (0 | h) ? h : t), h = h - t | 0, y >>> 0 <= (s = s + 4 | 0) >>> 0) break t;
                                                if (!((0 | h) >= 0)) break;
                                            }
                                            le(r, 48, h + 18 | 0, 18, 0), Pr(r, g, Z - g | 0);
                                            break a;
                                        }
                                        b = h;
                                    }
                                    le(r, 48, b + 9 | 0, 9, 0);
                                }
                                le(r, 32, a, N, 8192 ^ n), p = (0 | a) < (0 | N) ? N : a;
                                break r;
                            }
                            if (d = (t << 26 >> 31 & 9) + B | 0, !(i >>> 0 > 11)) {
                                for(b = 12 - i | 0, G = 16; G *= 16, b = b - 1 | 0;);
                                e = 45 != v[0 | d] ? e + G - G : -(G + (-e - G));
                            }
                            for(y = 2 | R, k = 32 & t, (0 | Z) == (0 | (b = re(((b = (s = c[o + 44 >> 2]) >> 31) ^ s) - b | 0, 0, Z))) && (f[o + 15 | 0] = 48, b = o + 15 | 0), f[0 | (h = b - 2 | 0)] = t + 15, f[b - 1 | 0] = (0 | s) < 0 ? 45 : 43, b = 8 & n, s = o + 16 | 0; t = s, l = E(e) < 2147483648 ? ~~e : -2147483648, f[0 | s] = k | v[l + 5424 | 0], !(b | (0 | i) > 0) & 0 == (e = 16 * (e - +(0 | l))) | 1 != ((s = t + 1 | 0) - (o + 16 | 0) | 0) || (f[t + 1 | 0] = 46, s = t + 2 | 0), 0 != e;);
                            p = -1, (2147483645 - (t = (b = Z - h | 0) + y | 0) | 0) < (0 | i) || (le(r, 32, a, t = (i = !i || ((k = s - (o + 16 | 0) | 0) - 2 | 0) >= (0 | i) ? k = s - (o + 16 | 0) | 0 : i + 2 | 0) + t | 0, n), Pr(r, d, y), le(r, 48, a, t, 65536 ^ n), Pr(r, o + 16 | 0, k), le(r, 48, i - k | 0, 0, 0), Pr(r, h, b), le(r, 32, a, t, 8192 ^ n), p = (0 | a) < (0 | t) ? t : a);
                        } else le(r, 32, a, b = R + 3 | 0, -65537 & n), Pr(r, B, R), i = 32 & t, Pr(r, e != e ? i ? 2450 : 3390 : i ? 2819 : 3394, 3), le(r, 32, a, b, 8192 ^ n), p = (0 | a) < (0 | b) ? b : a;
                        return ar = o + 560 | 0, 0 | p;
                    },
                    function(r, e) {
                        r |= 0;
                        var a, i, n, t, f, o = 0, u = 0, A = 0, k = 0, l = 0, d = 0, v = 0, h = 0, p = 0, m = 0, w = 0;
                        o = e |= 0, e = c[e >> 2] + 7 & -8, c[o >> 2] = e + 16, n = r, d = c[e >> 2], u = c[e + 4 >> 2], i = r = c[e + 12 >> 2], ar = a = ar - 32 | 0, l = r &= 2147483647;
                        r: if ((0 | (A = r - 1006698496 | 0)) == (0 | (r = r - 1140785152 | 0)) & (e = o = c[e + 8 >> 2]) >>> 0 < e >>> 0 | r >>> 0 > A >>> 0) {
                            if (e = (r = o) << 4 | u >>> 28, r = o = i << 4 | r >>> 28, 134217728 == (0 | (u &= 268435455)) & 0 != (0 | d) | u >>> 0 > 134217728) {
                                r = r + 1073741824 | 0, r = (e = e + 1 | 0) ? r : r + 1 | 0;
                                break r;
                            }
                            if (r = r + 1073741824 | 0, d | 134217728 != (0 | u)) break r;
                            r = (e = (u = 1 & e) + e | 0) >>> 0 < u >>> 0 ? r + 1 | 0 : r;
                        } else (!e & 2147418112 == (0 | l) ? !(u | d) : l >>> 0 < 2147418112) ? (e = 0, r = 2146435072, l >>> 0 > 1140785151 || (r = 0, (m = l >>> 16 | 0) >>> 0 < 15249 || (e = d, r = u, l = A = 65535 & i | 65536, p = o, k = o, 64 & (v = m - 15233 | 0) ? (o = e, e = 31 & (A = v + -64 | 0), (63 & A) >>> 0 >= 32 ? (r = o << e, k = 0) : (r = (1 << e) - 1 & o >>> 32 - e | r << e, k = o << e), A = r, e = 0, r = 0) : v && (h = k, k = 31 & v, (63 & v) >>> 0 >= 32 ? (o = h << k, k = 0) : (o = (1 << k) - 1 & h >>> 32 - k | A << k, k = h << k), A = o, w = k, h = e, k = 31 & (o = 64 - v | 0), (63 & o) >>> 0 >= 32 ? (o = 0, e = r >>> k | 0) : (o = r >>> k | 0, e = ((1 << k) - 1 & r) << 32 - k | h >>> k), k = w | e, A |= o, e = 31 & v, (63 & v) >>> 0 >= 32 ? (o = h << e, e = 0) : (o = (1 << e) - 1 & h >>> 32 - e | r << e, e = h << e), r = o), c[a + 16 >> 2] = e, c[a + 20 >> 2] = r, c[a + 24 >> 2] = k, c[a + 28 >> 2] = A, 64 & (e = 15361 - m | 0) ? (u = p, r = 31 & (e = e + -64 | 0), (63 & e) >>> 0 >= 32 ? (o = 0, d = l >>> r | 0) : (o = l >>> r | 0, d = ((1 << r) - 1 & l) << 32 - r | u >>> r), u = o, p = 0, l = 0) : e && (A = p, o = 31 & (r = 64 - e | 0), (63 & r) >>> 0 >= 32 ? (r = A << o, k = 0) : (r = (1 << o) - 1 & A >>> 32 - o | l << o, k = A << o), A = d, d = 31 & e, (63 & e) >>> 0 >= 32 ? (o = 0, A = u >>> d | 0) : (o = u >>> d | 0, A = ((1 << d) - 1 & u) << 32 - d | A >>> d), d = k | A, u = r | o, A = p, o = 31 & e, (63 & e) >>> 0 >= 32 ? (r = 0, p = l >>> o | 0) : (r = l >>> o | 0, p = ((1 << o) - 1 & l) << 32 - o | A >>> o), l = r), c[a >> 2] = d, c[a + 4 >> 2] = u, c[a + 8 >> 2] = p, c[a + 12 >> 2] = l, e = c[a + 8 >> 2], r = c[a + 12 >> 2] << 4 | e >>> 28, e <<= 4, o = c[a >> 2], e |= (l = c[a + 4 >> 2]) >>> 28, 134217728 == (0 | (u = 268435455 & l)) & 0 != (0 | (o |= 0 != (c[a + 16 >> 2] | c[a + 24 >> 2] | c[a + 20 >> 2] | c[a + 28 >> 2]))) | u >>> 0 > 134217728 ? r = (e = e + 1 | 0) ? r : r + 1 | 0 : o | 134217728 != (0 | u) || (r = (o = e) >>> 0 > (e = e + (1 & e) | 0) >>> 0 ? r + 1 | 0 : r)))) : (e = (r = o) << 4 | u >>> 28, r = 524287 & (o = i << 4 | r >>> 28) | 2146959360);
                        ar = a + 32 | 0, b(0, 0 | e), b(1, -2147483648 & i | r), t = n, f = +s(), N[t >> 3] = f;
                    },
                    Ke,
                    function(r, e) {
                        e |= 0, c[4 + (r |= 0) >> 2] = 7, c[r >> 2] = e;
                    },
                    function(r, e) {
                        e |= 0, c[4 + (r |= 0) >> 2] = 10, c[r >> 2] = e;
                    },
                    function(r, e) {
                        e |= 0, c[4 + (r |= 0) >> 2] = 13, c[r >> 2] = e;
                    },
                    Ke,
                    Ke,
                    Ke,
                    Ke,
                    Ke,
                    Ke,
                    function(r, e, a, i, n, t) {
                        var f;
                        r |= 0, e |= 0, a = y(a), i |= 0, n = y(n), t |= 0, ar = f = ar - 16 | 0, e = c[c[e >> 2] + 4 >> 2], aa[c[c[e >> 2] + 8 >> 2]](f, e, a, i, n, t), m[r >> 2] = N[f >> 3], m[r + 4 >> 2] = N[f + 8 >> 3], ar = f + 16 | 0;
                    },
                    function(r) {
                        r = c[c[(r |= 0) >> 2] + 8 >> 2], aa[c[c[r >> 2] + 8 >> 2]](r);
                    },
                    tr,
                    function(r) {
                        return 6952;
                    },
                    Pe,
                    function(r, e, a, i, n, t) {
                        r |= 0, e |= 0, a = y(a), i |= 0, n = y(n), t |= 0;
                        var f, o = 0;
                        return ar = f = ar - 16 | 0, o = c[r >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (o = c[o + c[e >> 2] >> 2]), aa[0 | o](f, e, a, i, n, t), r = ye(16), e = c[f + 12 >> 2], c[r + 8 >> 2] = c[f + 8 >> 2], c[r + 12 >> 2] = e, e = c[f + 4 >> 2], c[r >> 2] = c[f >> 2], c[r + 4 >> 2] = e, ar = f + 16 | 0, 0 | r;
                    },
                    function(r) {
                        return 6956;
                    },
                    Ke,
                    Ke,
                    Pe,
                    qe,
                    He,
                    Ze,
                    function(r) {
                        var e;
                        return r |= 0, e = ye(12), f[e + 4 | 0] = 0, c[e + 8 >> 2] = c[r >> 2], c[r >> 2] = 0, c[e >> 2] = 4368, 0 | e;
                    },
                    function(r, e, a) {
                        r |= 0, a |= 0;
                        var i, n, t = 0, o = 0;
                        if (ar = i = ar - 32 | 0, (n = c[(e |= 0) >> 2]) >>> 0 < 2147483632) {
                            r: {
                                if (n >>> 0 >= 11) o = ye(t = 1 + (15 | n) | 0), c[i + 16 >> 2] = -2147483648 | t, c[i + 8 >> 2] = o, c[i + 12 >> 2] = n, t = n + o | 0;
                                else if (f[i + 19 | 0] = n, t = (o = i + 8 | 0) + n | 0, !n) break r;
                                Ar(o, e + 4 | 0, n);
                            }
                            return f[0 | t] = 0, c[i >> 2] = a, aa[0 | r](i + 24 | 0, i + 8 | 0, i), M(c[i + 24 >> 2]), r = c[i + 24 >> 2], X(0 | r), X(c[i >> 2]), f[i + 19 | 0] < 0 && gr(c[i + 8 >> 2]), ar = i + 32 | 0, 0 | r;
                        }
                        I(), k();
                    },
                    function(r, e, a) {
                        var i, n;
                        a |= 0, i = r |= 0, n = 0 | U(0 | (f[11 + (e |= 0) | 0] < 0 ? c[e >> 2] : e), 6956, c[a >> 2]), c[i >> 2] = n;
                    },
                    function(r) {
                        return 6976;
                    },
                    Pe,
                    Xe,
                    function(r) {
                        return 6979;
                    },
                    Ke,
                    Ke,
                    Pe,
                    qe,
                    He,
                    Ze,
                    function(r) {
                        var e;
                        return r |= 0, e = ye(12), f[e + 4 | 0] = 0, c[e + 8 >> 2] = c[r >> 2], c[r >> 2] = 0, c[e >> 2] = 4488, 0 | e;
                    },
                    function(r, e, a) {
                        var i, n;
                        a |= 0, i = r |= 0, n = 0 | U(0 | (f[11 + (e |= 0) | 0] < 0 ? c[e >> 2] : e), 6979, c[a >> 2]), c[i >> 2] = n;
                    },
                    function(r) {
                        return 6982;
                    },
                    Fe,
                    ze,
                    function() {
                        var r, e;
                        return e = ye(4), r = ye(28), o[r + 20 >> 1] = 0, c[r + 16 >> 2] = 1065353216, o[r + 10 >> 1] = 0, o[r + 12 >> 1] = 0, c[r >> 2] = 0, c[r + 24 >> 2] = 0, f[r + 9 | 0] = 0, c[r + 4 >> 2] = 1, f[r + 22 | 0] = 0, c[1732] = c[1732] + 1, c[e >> 2] = r, 0 | e;
                    },
                    je,
                    Fe,
                    function(r, e, a) {
                        e |= 0, a |= 0, f[20 + (c[(r |= 0) >> 2] + e | 0) | 0] = a;
                    },
                    Ne,
                    function(r, e) {
                        r |= 0, e = y(e);
                        var a, i = 0, n = 0;
                        ar = a = ar - 16 | 0, r = c[r >> 2], e >= y(0) || (c[a >> 2] = 2262, ar = i = ar - 16 | 0, c[i + 12 >> 2] = a, r || (v[6936] ? r = c[1733] : (r = ye(28), o[r + 20 >> 1] = 0, c[r + 16 >> 2] = 1065353216, o[r + 10 >> 1] = 0, o[r + 12 >> 1] = 0, c[r >> 2] = 0, c[r + 24 >> 2] = 0, f[r + 9 | 0] = 0, c[r + 4 >> 2] = 1, f[r + 22 | 0] = 0, c[1733] = r, f[6936] = 1, c[1732] = c[1732] + 1)), n = c[r + 4 >> 2], v[r + 9 | 0] ? aa[0 | n](r, 0, 5, 0, 4215, a) : aa[0 | n](r, 0, 5, 4215, a), ar = i + 16 | 0, De(), k()), m[r + 16 >> 2] = e == y(0) ? y(0) : e, ar = a + 16 | 0;
                    },
                    function(r, e, a) {
                        r |= 0, e |= 0, a = y(a);
                        var i = 0;
                        i = c[r >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](e, a);
                    },
                    function(r, e) {
                        e |= 0, f[c[(r |= 0) >> 2] + 11 | 0] = e;
                    },
                    Ee,
                    function(r, e) {
                        e |= 0, f[c[(r |= 0) >> 2] + 10 | 0] = e;
                    },
                    function(r, e) {
                        return e |= 0, v[20 + (c[(r |= 0) >> 2] + e | 0) | 0];
                    },
                    we,
                    function(r) {
                        return v[c[(r |= 0) >> 2] + 11 | 0];
                    },
                    Ge,
                    function(r) {
                        return v[c[(r |= 0) >> 2] + 10 | 0];
                    },
                    function() {
                        return 0 | Rr(ye(48), 0, 48);
                    },
                    Je,
                    function() {
                        var r;
                        return r = ye(16), c[r >> 2] = 0, c[r + 4 >> 2] = 0, c[r + 8 >> 2] = 0, c[r + 12 >> 2] = 0, 0 | r;
                    },
                    Je,
                    function() {
                        var r;
                        return r = ye(16), c[r + 8 >> 2] = 0, c[r + 12 >> 2] = 0, c[r >> 2] = 0, 0 | r;
                    },
                    Je,
                    Se,
                    Ce,
                    function(r, e) {
                        return e |= 0, c[c[(r |= 0) >> 2] + e >> 2];
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0, c[c[(r |= 0) >> 2] + e >> 2] = a;
                    },
                    function(r) {
                        return 6987;
                    },
                    Cr,
                    ze,
                    function() {
                        return 0 | $r(ye(12), 0);
                    },
                    function(r, e) {
                        return e |= 0, 0 | aa[0 | (r |= 0)](e);
                    },
                    function(r) {
                        return r |= 0, 0 | $r(ye(12), r);
                    },
                    je,
                    Cr,
                    function(r) {
                        var e, a = 0, i = 0, n = 0;
                        ar = e = ar - 624 | 0, a = c[4 + (r |= 0) >> 2], c[r + 4 >> 2] = 0, a && aa[c[c[a >> 2] + 4 >> 2]](a), a = c[r + 8 >> 2], c[r + 8 >> 2] = 0, a && aa[c[c[a >> 2] + 4 >> 2]](a);
                        r: {
                            if (r = c[r >> 2], c[r + 560 >> 2] == c[r + 556 >> 2]) {
                                if (c[r + 552 >> 2]) break r;
                                return Sr(r + 556 | 0), n = f[r + 4 | 0], a = br(e + 32 | 0, c[r + 568 >> 2]), i = c[a + 4 >> 2], c[r >> 2] = c[a >> 2], c[r + 4 >> 2] = i, i = c[a + 20 >> 2], c[r + 16 >> 2] = c[a + 16 >> 2], c[r + 20 >> 2] = i, i = c[a + 12 >> 2], c[r + 8 >> 2] = c[a + 8 >> 2], c[r + 12 >> 2] = i, Ar(r + 24 | 0, a + 24 | 0, 204), Ar(r + 228 | 0, a + 228 | 0, 328), (i = c[r + 556 >> 2]) && (c[r + 560 >> 2] = i, gr(i)), c[r + 556 >> 2] = c[a + 556 >> 2], c[r + 560 >> 2] = c[a + 560 >> 2], c[r + 564 >> 2] = c[a + 564 >> 2], c[r + 584 >> 2] = c[a + 584 >> 2], i = c[a + 580 >> 2], c[r + 576 >> 2] = c[a + 576 >> 2], c[r + 580 >> 2] = i, i = c[a + 572 >> 2], c[r + 568 >> 2] = c[a + 568 >> 2], c[r + 572 >> 2] = i, (0 | n) < 0 && (f[r + 4 | 0] = 128 | v[r + 4 | 0], c[r + 24 >> 2] = -909 & c[r + 24 >> 2] | 520), void (ar = e + 624 | 0);
                            }
                            c[e + 16 >> 2] = 3252, Xr(r, e + 16 | 0), De(), k();
                        }
                        c[e >> 2] = 2046, Xr(r, e), De(), k();
                    },
                    Xe,
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = y(0), n = 0, t = 0, o = y(0), u = 0, s = 0, A = 0, k = y(0);
                        r: {
                            s = c[e >> 2], e = c[r >> 2];
                            e: if (!(8388607 & (c[s + 24 >> 2] ^ c[e + 24 >> 2]))) {
                                k = m[s + 40 >> 2], n = c[s + 40 >> 2], i = m[e + 40 >> 2];
                                a: {
                                    i: {
                                        if (2139156720 != (0 | (a = c[e + 40 >> 2]))) {
                                            if (o = y(NaN), r = 3, 2141891242 == (0 | a)) break a;
                                            if (2140081935 != (0 | a)) break i;
                                            o = y(0), r = 1;
                                            break a;
                                        }
                                        r = 2;
                                        break a;
                                    }
                                    r = 0, i == i && (b(2, 536870912 + (-1073741825 & a) | 0), o = d(), r = 1073741824 & a ? 2 : 1);
                                }
                                a: {
                                    i: {
                                        if (2139156720 != (0 | n)) {
                                            if (i = y(NaN), a = 3, 2141891242 == (0 | n)) break a;
                                            if (2140081935 != (0 | n)) break i;
                                            i = y(0), a = 1;
                                            break a;
                                        }
                                        i = y(0), a = 2;
                                        break a;
                                    }
                                    a = 0, k == k && (b(2, 536870912 + (-1073741825 & n) | 0), i = d(), a = 1073741824 & n ? 2 : 1);
                                }
                                if (!((0 | a) != (0 | r) | !(!r | o != o & i != i | y(E(y(o - i))) < y(9999999747378752e-20))) && (t = s + 44 | 0, c[(a = e + 44 | 0) >> 2] == c[t >> 2])) {
                                    r = 0;
                                    a: {
                                        for(;;){
                                            if (n = r, 9 == (0 | (r = r + 1 | 0))) break a;
                                            if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                        }
                                        if (n >>> 0 < 8) break e;
                                    }
                                    if (t = s + 80 | 0, c[(a = e + 80 | 0) >> 2] == c[t >> 2]) {
                                        r = 0;
                                        a: {
                                            for(;;){
                                                if (n = r, 9 == (0 | (r = r + 1 | 0))) break a;
                                                if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                            }
                                            if (n >>> 0 < 8) break e;
                                        }
                                        if (t = s + 116 | 0, c[(a = e + 116 | 0) >> 2] == c[t >> 2]) {
                                            r = 0;
                                            a: {
                                                for(;;){
                                                    if (n = r, 9 == (0 | (r = r + 1 | 0))) break a;
                                                    if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                                }
                                                if (n >>> 0 < 8) break e;
                                            }
                                            if (t = s + 152 | 0, c[(a = e + 152 | 0) >> 2] == c[t >> 2]) {
                                                r = 0;
                                                a: {
                                                    for(;;){
                                                        if (n = r, 9 == (0 | (r = r + 1 | 0))) break a;
                                                        if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                                    }
                                                    if (n >>> 0 < 8) break e;
                                                }
                                                if (t = s + 188 | 0, c[(a = e + 188 | 0) >> 2] == c[t >> 2]) {
                                                    r = 0;
                                                    a: {
                                                        for(;;){
                                                            if (n = r, 3 == (0 | (r = r + 1 | 0))) break a;
                                                            if (c[(u = r << 2) + a >> 2] != c[t + u >> 2]) break;
                                                        }
                                                        if (n >>> 0 < 2) break e;
                                                    }
                                                    for(u = s + 200 | 0, A = e + 200 | 0, r = 0, n = 1; a = c[(r <<= 2) + u >> 2], t = c[r + A >> 2], n && (n = 0, r = 1, (0 | a) == (0 | t)););
                                                    if ((0 | a) == (0 | t)) {
                                                        for(u = s + 208 | 0, A = e + 208 | 0, r = 0, n = 1; a = c[(r <<= 2) + u >> 2], t = c[r + A >> 2], n && (n = 0, r = 1, (0 | a) == (0 | t)););
                                                        if ((0 | a) == (0 | t)) {
                                                            for(u = s + 216 | 0, A = e + 216 | 0, r = 0, n = 1; a = c[(r <<= 2) + u >> 2], t = c[r + A >> 2], n && (n = 0, r = 1, (0 | a) == (0 | t)););
                                                            if ((0 | a) == (0 | t) && !((0 | (r = (o = m[s + 28 >> 2]) != o)) == ((i = m[e + 28 >> 2]) == i | 0) | !(r | i != i) & i != o || ((i = m[e + 32 >> 2]) == i | 0) == ((o = m[s + 32 >> 2]) != o | 0) | i == i & i != o || (0 | (r = (o = m[s + 36 >> 2]) != o)) == ((i = m[e + 36 >> 2]) == i | 0) | !r & i != o)) {
                                                                if (r = 0, (i = m[e + 224 >> 2]) != i && (r = 1, (o = m[s + 224 >> 2]) != o)) break r;
                                                                if ((o = i) == (i = m[s + 224 >> 2]) | i != i & r) break r;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            for(Ar(e + 24 | 0, s + 24 | 0, 204);;){
                                if (4 & (r = v[e + 4 | 0])) break r;
                                if (f[e + 4 | 0] = 4 | r, (r = c[e + 20 >> 2]) && aa[0 | r](e), c[e + 308 >> 2] = 2143289344, !(e = c[e + 552 >> 2])) break;
                            }
                        }
                    },
                    Ee,
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 16 & 3) != (0 | e)) for(c[r + 24 >> 2] = -196609 & a | e << 16 & 196608;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    Ee,
                    function(r, e, a) {
                        e |= 0, a = +a, oe(c[(r |= 0) >> 2], e, qr(y(a)));
                    },
                    function(r, e, a, i) {
                        e |= 0, a |= 0, i = +i;
                        var n = 0;
                        n = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (n = c[n + c[e >> 2] >> 2]), aa[0 | n](e, a, i);
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, oe(c[(r |= 0) >> 2], e, Kr(y(a)));
                    },
                    function(r, e) {
                        e |= 0, Yr(c[(r |= 0) >> 2], 5, e);
                    },
                    function(r, e) {
                        e |= 0, Yr(c[(r |= 0) >> 2], 6, e);
                    },
                    function(r, e) {
                        e |= 0, Yr(c[(r |= 0) >> 2], 7, e);
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 2 & 3) != (0 | e)) for(c[r + 24 >> 2] = -13 & a | e << 2 & 12;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 18 & 3) != (0 | e)) for(c[r + 24 >> 2] = -786433 & a | e << 18 & 786432;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 4 & 7) != (0 | e)) for(c[r + 24 >> 2] = -113 & a | e << 4 & 112;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, ue(c[(r |= 0) >> 2], e, qr(y(a)));
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, ue(c[(r |= 0) >> 2], e, Kr(y(a)));
                    },
                    function(r, e) {
                        e |= 0, ue(c[(r |= 0) >> 2], e, 2141891242);
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 20 & 3) != (0 | e)) for(c[r + 24 >> 2] = -3145729 & a | e << 20 & 3145728;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((a = c[r + 24 >> 2]) >>> 22 & 1) != (0 | e)) for(c[r + 24 >> 2] = -4194305 & a | e << 22 & 4194304;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        r |= 0, e = +e;
                        var a = 0, i = y(0), n = y(0);
                        r: if (i = y(e), r = c[r >> 2], !(i == (n = m[r + 28 >> 2]) | i != i & n != n)) for(m[r + 28 >> 2] = i;;){
                            if (4 & (a = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e, a) {
                        e |= 0, a = +a;
                        var i = 0;
                        i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](e, a);
                    },
                    function(r, e) {
                        e = +e, fe(c[(r |= 0) >> 2], qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, fe(c[(r |= 0) >> 2], Kr(y(e)));
                    },
                    function(r) {
                        fe(c[(r |= 0) >> 2], 2141891242);
                    },
                    function(r, e) {
                        r |= 0, e = +e;
                        var a = 0, i = y(0), n = y(0);
                        r: if (i = y(e), r = c[r >> 2], !(i == (n = m[r + 32 >> 2]) | i != i & n != n)) for(m[r + 32 >> 2] = i;;){
                            if (4 & (a = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        r |= 0, e = +e;
                        var a = 0, i = y(0), n = y(0);
                        r: if (i = y(e), r = c[r >> 2], !(i == (n = m[r + 36 >> 2]) | i != i & n != n)) for(m[r + 36 >> 2] = i;;){
                            if (4 & (a = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e) {
                        e = +e, te(c[(r |= 0) >> 2], 0, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, te(c[(r |= 0) >> 2], 0, Kr(y(e)));
                    },
                    function(r) {
                        te(c[(r |= 0) >> 2], 0, 2141891242);
                    },
                    function(r, e) {
                        e = +e, te(c[(r |= 0) >> 2], 1, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, te(c[(r |= 0) >> 2], 1, Kr(y(e)));
                    },
                    function(r) {
                        te(c[(r |= 0) >> 2], 1, 2141891242);
                    },
                    function(r, e) {
                        e = +e, ie(c[(r |= 0) >> 2], 0, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ie(c[(r |= 0) >> 2], 0, Kr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ie(c[(r |= 0) >> 2], 1, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ie(c[(r |= 0) >> 2], 1, Kr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ne(c[(r |= 0) >> 2], 0, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ne(c[(r |= 0) >> 2], 0, Kr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ne(c[(r |= 0) >> 2], 1, qr(y(e)));
                    },
                    function(r, e) {
                        e = +e, ne(c[(r |= 0) >> 2], 1, Kr(y(e)));
                    },
                    function(r, e) {
                        r |= 0, e = +e;
                        var a = 0, i = y(0), n = y(0);
                        r: if (i = y(e), r = c[r >> 2], !(i == (n = m[r + 224 >> 2]) | i != i & n != n)) for(m[r + 224 >> 2] = i;;){
                            if (4 & (a = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e, a) {
                        e |= 0, a = +a;
                        var i = 0;
                        r: if (r = c[(r |= 0) >> 2], (0 | c[152 + (e = r + (e << 2) | 0) >> 2]) != (0 | (i = qr(y(a))))) for(c[e + 152 >> 2] = i;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, ce(c[(r |= 0) >> 2], e, qr(y(a)));
                    },
                    function(r, e, a) {
                        e |= 0, a = +a, ce(c[(r |= 0) >> 2], e, Kr(y(a)));
                    },
                    function(r, e, a) {
                        e |= 0, a = +a;
                        var i = 0;
                        r: if (r = c[(r |= 0) >> 2], (0 | c[188 + (e = r + (e << 2) | 0) >> 2]) != (0 | (i = qr(y(a))))) for(c[e + 188 >> 2] = i;;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    function(r) {
                        return 3 & h[c[(r |= 0) >> 2] + 26 >> 1];
                    },
                    Ge,
                    function(r, e, a) {
                        r |= 0, e |= 0, a |= 0;
                        var i = 0, n = 0, t = y(0);
                        i = 2, e = c[e >> 2] + (a << 2) | 0, t = m[e + 80 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 80 >> 2]))) {
                                    if (n = NaN, 2141891242 == (0 | e)) {
                                        i = 3;
                                        break r;
                                    }
                                    if (2140081935 != (0 | e)) break e;
                                    n = 0, i = 1;
                                    break r;
                                }
                                break r;
                            }
                            t == t ? (i = 1073741824 & e ? 2 : 1, b(2, 536870912 + (-1073741825 & e) | 0), n = +d()) : i = 0;
                        }
                        N[r + 8 >> 3] = n, c[r >> 2] = i;
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i, n = 0;
                        return ar = i = ar - 16 | 0, n = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (n = c[n + c[e >> 2] >> 2]), aa[0 | n](i, e, a), r = ye(16), e = c[i + 12 >> 2], c[r + 8 >> 2] = c[i + 8 >> 2], c[r + 12 >> 2] = e, e = c[i + 4 >> 2], c[r >> 2] = c[i >> 2], c[r + 4 >> 2] = e, ar = i + 16 | 0, 0 | r;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 7 & 7;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 10 & 7;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 13 & 7;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 2 & 3;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 18 & 3;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 4 & 7;
                    },
                    function(r, e, a) {
                        r |= 0, e |= 0, a |= 0;
                        var i = 0, n = 0, t = y(0);
                        i = 2, e = c[e >> 2] + (a << 2) | 0, t = m[e + 44 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 44 >> 2]))) {
                                    if (n = NaN, 2141891242 == (0 | e)) {
                                        i = 3;
                                        break r;
                                    }
                                    if (2140081935 != (0 | e)) break e;
                                    n = 0, i = 1;
                                    break r;
                                }
                                break r;
                            }
                            t == t ? (i = 1073741824 & e ? 2 : 1, b(2, 536870912 + (-1073741825 & e) | 0), n = +d()) : i = 0;
                        }
                        N[r + 8 >> 3] = n, c[r >> 2] = i;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = y(0), n = y(0);
                        i = y(NaN), e = c[e >> 2], n = m[e + 40 >> 2], a = 3, 2141891242 != (0 | (e = c[e + 40 >> 2])) && (2140081935 != (0 | e) ? 2139156720 != (0 | e) ? (a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = d(), a = 1073741824 & e ? 2 : 1)) : (i = y(0), a = 2) : (i = y(0), a = 1)), c[r >> 2] = a, N[r + 8 >> 3] = i;
                    },
                    function(r, e) {
                        e |= 0;
                        var a, i = 0;
                        return ar = a = ar - 16 | 0, i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](a, e), r = ye(16), e = c[a + 12 >> 2], c[r + 8 >> 2] = c[a + 8 >> 2], c[r + 12 >> 2] = e, e = c[a + 4 >> 2], c[r >> 2] = c[a >> 2], c[r + 4 >> 2] = e, ar = a + 16 | 0, 0 | r;
                    },
                    function(r) {
                        r |= 0;
                        var e = y(0);
                        return +((e = m[c[r >> 2] + 32 >> 2]) == e ? e : y(0));
                    },
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        return a = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (a = c[a + c[e >> 2] >> 2]), +aa[0 | a](e);
                    },
                    function(r) {
                        r |= 0;
                        var e = y(0);
                        return r = c[r >> 2], (e = m[r + 36 >> 2]) != e && (e = v[c[r + 568 >> 2] + 10 | 0] ? y(1) : y(0)), +e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 200 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 200 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 204 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 204 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 208 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 208 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 212 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 212 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 216 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 216 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = 0, n = y(0);
                        e = c[e >> 2], n = m[e + 220 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 220 >> 2]))) {
                                    if (i = NaN, a = 3, 2141891242 == (0 | e)) break r;
                                    if (2140081935 != (0 | e)) break e;
                                    i = 0, a = 1;
                                    break r;
                                }
                                a = 2;
                                break r;
                            }
                            a = 0, n == n && (b(2, 536870912 + (-1073741825 & e) | 0), i = +d(), a = 1073741824 & e ? 2 : 1);
                        }
                        e = a, N[r + 8 >> 3] = i, c[r >> 2] = e;
                    },
                    function(r) {
                        r |= 0;
                        var e = y(0);
                        return +((e = m[c[r >> 2] + 224 >> 2]) != e ? y(NaN) : e);
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = 0, i = y(0);
                        r = c[r >> 2] + (e << 2) | 0, i = m[r + 152 >> 2];
                        r: {
                            if (!(2139156720 == (0 | (r = c[r + 152 >> 2])) | 2140081935 == (0 | r))) {
                                if (a = NaN, 2141891242 == (0 | r) | i != i) break r;
                                if (2139156720 != (0 | r)) return b(2, 536870912 + (-1073741825 & r) | 0), +d();
                            }
                            a = 0;
                        }
                        return +a;
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i = 0;
                        return i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), +aa[0 | i](e, a);
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 20 & 3;
                    },
                    function(r) {
                        return c[c[(r |= 0) >> 2] + 24 >> 2] >>> 22 & 1;
                    },
                    function(r, e, a) {
                        r |= 0, e |= 0, a |= 0;
                        var i = 0, n = 0, t = y(0);
                        i = 2, e = c[e >> 2] + (a << 2) | 0, t = m[e + 116 >> 2];
                        r: {
                            e: {
                                if (2139156720 != (0 | (e = c[e + 116 >> 2]))) {
                                    if (n = NaN, 2141891242 == (0 | e)) {
                                        i = 3;
                                        break r;
                                    }
                                    if (2140081935 != (0 | e)) break e;
                                    n = 0, i = 1;
                                    break r;
                                }
                                break r;
                            }
                            t == t ? (i = 1073741824 & e ? 2 : 1, b(2, 536870912 + (-1073741825 & e) | 0), n = +d()) : i = 0;
                        }
                        N[r + 8 >> 3] = n, c[r >> 2] = i;
                    },
                    function(r, e) {
                        r |= 0, e |= 0;
                        var a = y(0), i = y(0);
                        r = c[r >> 2] + (e << 2) | 0, i = m[r + 188 >> 2];
                        r: {
                            if (!(2139156720 == (0 | (r = c[r + 188 >> 2])) | 2140081935 == (0 | r))) {
                                if (a = y(NaN), 2141891242 == (0 | r) | i != i) break r;
                                if (2139156720 != (0 | r)) return y((b(2, 536870912 + (-1073741825 & r) | 0), d()));
                            }
                            a = y(0);
                        }
                        return y(a);
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i = 0;
                        return i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), y(y(aa[0 | i](e, a)));
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i, n = 0, t = 0, o = 0, u = 0, b = 0, s = 0, A = 0, l = 0, d = 0;
                        ar = i = ar - 80 | 0, r = c[(r |= 0) >> 2];
                        r: {
                            e: {
                                if (b = c[e >> 2], !c[b + 552 >> 2]) {
                                    if (c[r + 8 >> 2]) break e;
                                    u = (e = c[r + 556 >> 2]) + (a << 2) | 0;
                                    a: if ((n = c[r + 560 >> 2]) >>> 0 < (o = c[(t = r + 564 | 0) >> 2]) >>> 0) {
                                        if ((0 | n) == (0 | u)) {
                                            c[u >> 2] = b, c[r + 560 >> 2] = u + 4;
                                            break a;
                                        }
                                        if (a = n, n >>> 0 > (e = n - 4 | 0) >>> 0) for(; c[a >> 2] = c[e >> 2], a = a + 4 | 0, n >>> 0 > (e = e + 4 | 0) >>> 0;);
                                        c[r + 560 >> 2] = a, (0 | (e = u + 4 | 0)) != (0 | n) && wr(n - (-4 & (e = n - e | 0)) | 0, u, e), c[u >> 2] = b;
                                    } else {
                                        if ((n = 1 + (n - e >> 2) | 0) >>> 0 >= 1073741824) break r;
                                        if (o = (e = o - e | 0) >>> 1 | 0, t = pe(i + 32 | 0, e >>> 0 >= 2147483644 ? 1073741823 : n >>> 0 < o >>> 0 ? o : n, a, t), (0 | (a = c[t + 8 >> 2])) == c[t + 12 >> 2]) {
                                            if ((e = c[t + 4 >> 2]) >>> 0 > (n = c[t >> 2]) >>> 0) a = wr(s = (n = (1 + (e - n >> 2) | 0) / -2 << 2) + e | 0, o = e, e = a - e | 0) + e | 0, c[t + 8 >> 2] = a, c[t + 4 >> 2] = n + c[t + 4 >> 2];
                                            else {
                                                if (o = pe(i + 56 | 0, e = (0 | a) == (0 | n) ? 1 : a - n >> 1, e >>> 2 | 0, c[t + 16 >> 2]), n = c[o + 8 >> 2], (0 | (e = c[t + 4 >> 2])) != (0 | (a = c[t + 8 >> 2]))) {
                                                    for(a = (a - e | 0) + n | 0; c[n >> 2] = c[e >> 2], e = e + 4 | 0, (0 | (n = n + 4 | 0)) != (0 | a););
                                                    e = c[t + 8 >> 2], n = c[t + 4 >> 2];
                                                } else a = n, n = e;
                                                s = c[t >> 2], c[t >> 2] = c[o >> 2], c[o >> 2] = s, c[t + 4 >> 2] = c[o + 4 >> 2], c[o + 4 >> 2] = n, c[t + 8 >> 2] = a, c[o + 8 >> 2] = e, A = c[t + 12 >> 2], c[t + 12 >> 2] = c[o + 12 >> 2], c[o + 12 >> 2] = A, (0 | e) != (0 | n) && (c[o + 8 >> 2] = (3 + (n - e | 0) & -4) + e), s && (gr(s), a = c[t + 8 >> 2]);
                                            }
                                        }
                                        c[a >> 2] = b, c[t + 8 >> 2] = c[t + 8 >> 2] + 4, a = u - (e = c[r + 556 >> 2]) | 0, l = t, d = wr(c[t + 4 >> 2] - a | 0, e, a), c[l + 4 >> 2] = d, n = c[r + 560 >> 2] - u | 0, u = wr(c[t + 8 >> 2], u, n), e = c[r + 556 >> 2], c[r + 556 >> 2] = c[t + 4 >> 2], c[t + 4 >> 2] = e, a = c[r + 560 >> 2], c[r + 560 >> 2] = n + u, c[t + 8 >> 2] = a, n = c[r + 564 >> 2], c[r + 564 >> 2] = c[t + 12 >> 2], c[t >> 2] = e, c[t + 12 >> 2] = n, (0 | e) != (0 | a) && (c[t + 8 >> 2] = a + (3 + (e - a | 0) & -4)), e && gr(e);
                                    }
                                    for(c[b + 552 >> 2] = r; !(4 & (e = v[r + 4 | 0])) && (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, r = c[r + 552 >> 2]););
                                    return void (ar = i + 80 | 0);
                                }
                                c[i + 16 >> 2] = 4006, Xr(r, i + 16 | 0), De(), k();
                            }
                            c[i >> 2] = 4139, Xr(r, i), De(), k();
                        }
                        I(), k();
                    },
                    Ne,
                    function(r, e) {
                        e |= 0;
                        var a, i = 0, n = 0, t = 0;
                        ar = a = ar - 320 | 0, r = c[(r |= 0) >> 2];
                        r: if (c[r + 560 >> 2] != c[r + 556 >> 2] && (n = c[e >> 2], e = c[n + 552 >> 2], ee(r, n))) {
                            if ((0 | r) == (0 | e)) {
                                for(i = Rr(a, 0, 288), c[(e = i) + 16 >> 2] = 2143289344, c[e + 20 >> 2] = 2143289344, Rr(e + 24 | 0, 0, 49), c[e + 80 >> 2] = 2143289344, t = e + 288 | 0, e = e + 96 | 0; c[e + 16 >> 2] = -1082130432, c[e + 20 >> 2] = -1082130432, c[e + 8 >> 2] = 0, c[e + 12 >> 2] = 0, c[e >> 2] = -1082130432, c[e + 4 >> 2] = -1082130432, (0 | t) != (0 | (e = e + 24 | 0)););
                                c[i + 312 >> 2] = -1082130432, c[i + 316 >> 2] = -1082130432, c[i + 304 >> 2] = 0, c[i + 308 >> 2] = 0, c[i + 296 >> 2] = -1082130432, c[i + 300 >> 2] = -1082130432, c[i + 288 >> 2] = 2143289344, c[i + 292 >> 2] = 2143289344, Ar(n + 228 | 0, i, 320), c[n + 552 >> 2] = 0;
                            }
                            for(;;){
                                if (4 & (e = v[r + 4 | 0])) break r;
                                if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                            }
                        }
                        ar = a + 320 | 0;
                    },
                    Ee,
                    function(r) {
                        return r = c[(r |= 0) >> 2], c[r + 560 >> 2] - c[r + 556 >> 2] >> 2;
                    },
                    Ge,
                    function(r) {
                        return (r = c[c[(r |= 0) >> 2] + 552 >> 2]) ? c[r >> 2] : 0;
                    },
                    Ge,
                    function(r, e) {
                        e |= 0;
                        var a, i = 0;
                        return a = c[(r |= 0) >> 2], r = c[a + 556 >> 2], c[a + 560 >> 2] - r >> 2 >>> 0 <= e >>> 0 || (r = c[r + (e << 2) >> 2]) && (i = c[r >> 2]), 0 | i;
                    },
                    we,
                    function(r) {
                        return (2 & v[c[(r |= 0) >> 2] + 4 | 0]) >>> 1 | 0;
                    },
                    Ge,
                    function(r, e) {
                        e |= 0;
                        var a = 0;
                        r: if (r = c[(r |= 0) >> 2], ((2 & (a = v[r + 4 | 0])) >>> 1 | 0) != (0 | e)) for(f[r + 4 | 0] = 253 & a | (e ? 2 : 0);;){
                            if (4 & (e = v[r + 4 | 0])) break r;
                            if (f[r + 4 | 0] = 4 | e, (e = c[r + 20 >> 2]) && aa[0 | e](r), c[r + 308 >> 2] = 2143289344, !(r = c[r + 552 >> 2])) break;
                        }
                    },
                    Ee,
                    function(r, e) {
                        var a;
                        e |= 0, a = c[4 + (r |= 0) >> 2], c[r + 4 >> 2] = e, a && aa[c[c[a >> 2] + 4 >> 2]](a), ke(c[r >> 2], 14);
                    },
                    Ee,
                    function(r) {
                        var e;
                        e = c[4 + (r |= 0) >> 2], c[r + 4 >> 2] = 0, e && aa[c[c[e >> 2] + 4 >> 2]](e), ke(c[r >> 2], 0);
                    },
                    function(r, e) {
                        var a;
                        e |= 0, a = c[8 + (r |= 0) >> 2], c[r + 8 >> 2] = e, a && aa[c[c[a >> 2] + 4 >> 2]](a), c[c[r >> 2] + 20 >> 2] = 15;
                    },
                    Ee,
                    function(r) {
                        var e;
                        e = c[8 + (r |= 0) >> 2], c[r + 8 >> 2] = 0, e && aa[c[c[e >> 2] + 4 >> 2]](e), c[c[r >> 2] + 20 >> 2] = 0;
                    },
                    function(r) {
                        var e, a = 0;
                        if (ar = e = ar - 16 | 0, r = c[(r |= 0) >> 2], c[r + 8 >> 2]) {
                            for(; !(4 & (a = v[r + 4 | 0])) && (f[r + 4 | 0] = 4 | a, (a = c[r + 20 >> 2]) && aa[0 | a](r), c[r + 308 >> 2] = 2143289344, r = c[r + 552 >> 2]););
                            ar = e + 16 | 0;
                        } else c[e >> 2] = 1024, Xr(r, e), De(), k();
                    },
                    function(r) {
                        return (4 & v[c[(r |= 0) >> 2] + 4 | 0]) >>> 2 | 0;
                    },
                    Ge,
                    function(r, e, a, i) {
                        r |= 0, e = +e, a = +a, i |= 0;
                        var n, t, f = y(0), o = y(0), u = y(0), s = 0, A = y(0), k = 0, l = y(0);
                        ar = t = ar + -64 | 0, n = c[r >> 2], Rr(t + 8 | 0, 0, 56), c[1735] = c[1735] + 1, sr(n), u = y(e), o = m[n + 572 >> 2];
                        r: {
                            e: {
                                switch(0 | (r = c[n + 576 >> 2])){
                                    case 0:
                                    case 3:
                                        break e;
                                }
                                a: {
                                    if (!(1 != (0 | r) | (f = m[n + 572 >> 2]) != f)) {
                                        if (!((f = o) < y(0))) break a;
                                        break e;
                                    }
                                    i: {
                                        if (2 != (0 | r) | f != f) {
                                            f = y(NaN);
                                            n: switch(r - 1 | 0){
                                                case 1:
                                                    break i;
                                                case 0:
                                                    break n;
                                                default:
                                                    break a;
                                            }
                                            f = o;
                                            break a;
                                        }
                                        if (u != u | o < y(0)) break e;
                                    }
                                    f = y(y(o * u) * y(.009999999776482582));
                                }
                                l = y(f + y(Mr(n, 2, u) + Ur(n, 2, u))), k = 1;
                                break r;
                            }
                            f = y(0), o = m[n + 216 >> 2];
                            e: {
                                a: {
                                    i: {
                                        n: if (2139156720 != (0 | (r = c[n + 216 >> 2]))) {
                                            if (2140081935 == (0 | r)) break e;
                                            k = 4276;
                                            t: {
                                                if (2141891242 != (0 | r)) {
                                                    if (o == o) break t;
                                                    k = 4268;
                                                }
                                                switch(f = m[k >> 2], c[k + 4 >> 2] - 1 | 0){
                                                    case 0:
                                                        break i;
                                                    case 1:
                                                        break n;
                                                    default:
                                                        break a;
                                                }
                                            }
                                            if (b(2, 536870912 + (-1073741825 & r) | 0), f = d(), !(1073741824 & r)) break i;
                                        }
                                        f = y(y(f * u) * y(.009999999776482582));
                                    }
                                    if (f == f) {
                                        f = y(0);
                                        i: if (2139156720 != (0 | r)) {
                                            if (2140081935 == (0 | r)) break e;
                                            s = 4276;
                                            n: {
                                                if (2141891242 != (0 | r)) {
                                                    if (o == o) break n;
                                                    s = 4268;
                                                }
                                                switch(f = m[s >> 2], l = y(NaN), k = 2, c[s + 4 >> 2] - 1 | 0){
                                                    case 1:
                                                        break i;
                                                    case 0:
                                                        break e;
                                                    default:
                                                        break r;
                                                }
                                            }
                                            if (b(2, 536870912 + (-1073741825 & r) | 0), f = d(), !(1073741824 & r)) break e;
                                        }
                                        l = y(y(f * u) * y(.009999999776482582)), k = 2;
                                        break r;
                                    }
                                }
                                k = u == u, l = u;
                                break r;
                            }
                            k = 2, l = f;
                        }
                        A = y(a), o = m[n + 580 >> 2];
                        r: {
                            e: {
                                switch(0 | (r = c[n + 584 >> 2])){
                                    case 0:
                                    case 3:
                                        break e;
                                }
                                a: {
                                    if (!(1 != (0 | r) | (f = m[n + 580 >> 2]) != f)) {
                                        if (!((f = o) < y(0))) break a;
                                        break e;
                                    }
                                    i: {
                                        if (2 != (0 | r) | f != f) {
                                            f = y(NaN);
                                            n: switch(r - 1 | 0){
                                                case 1:
                                                    break i;
                                                case 0:
                                                    break n;
                                                default:
                                                    break a;
                                            }
                                            f = o;
                                            break a;
                                        }
                                        if (A != A | o < y(0)) break e;
                                    }
                                    f = y(y(o * A) * y(.009999999776482582));
                                }
                                o = y(f + y(Mr(n, 0, u) + Ur(n, 0, u))), r = 1;
                                break r;
                            }
                            f = y(0), o = m[n + 220 >> 2];
                            e: {
                                a: {
                                    i: {
                                        n: if (2139156720 != (0 | (r = c[n + 220 >> 2]))) {
                                            if (2140081935 == (0 | r)) break e;
                                            s = 4276;
                                            t: {
                                                if (2141891242 != (0 | r)) {
                                                    if (o == o) break t;
                                                    s = 4268;
                                                }
                                                switch(f = m[s >> 2], c[s + 4 >> 2] - 1 | 0){
                                                    case 0:
                                                        break i;
                                                    case 1:
                                                        break n;
                                                    default:
                                                        break a;
                                                }
                                            }
                                            if (b(2, 536870912 + (-1073741825 & r) | 0), f = d(), !(1073741824 & r)) break i;
                                        }
                                        f = y(y(f * A) * y(.009999999776482582));
                                    }
                                    if (f == f) {
                                        f = y(0);
                                        i: if (2139156720 != (0 | r)) {
                                            if (2140081935 == (0 | r)) break e;
                                            s = 4276;
                                            n: {
                                                if (2141891242 != (0 | r)) {
                                                    if (o == o) break n;
                                                    s = 4268;
                                                }
                                                switch(f = m[s >> 2], o = y(NaN), r = 2, c[s + 4 >> 2] - 1 | 0){
                                                    case 0:
                                                        break e;
                                                    case 1:
                                                        break i;
                                                    default:
                                                        break r;
                                                }
                                            }
                                            if (b(2, 536870912 + (-1073741825 & r) | 0), f = d(), !(1073741824 & r)) break e;
                                        }
                                        o = y(y(f * A) * y(.009999999776482582)), r = 2;
                                        break r;
                                    }
                                }
                                r = A == A, o = A;
                                break r;
                            }
                            r = 2, o = f;
                        }
                        or(n, l, o, i, k, r, u, A, 1, 0, c[n + 568 >> 2], t + 8 | 0, 0, c[1735]) && (Fr(n, 3 & v[n + 300 | 0], u, A, u), Er(n, +m[c[n + 568 >> 2] + 16 >> 2], 0, 0)), ar = t - -64 | 0;
                    },
                    function(r, e, a, i, n) {
                        e |= 0, a = +a, i = +i, n |= 0;
                        var t = 0;
                        t = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (t = c[t + c[e >> 2] >> 2]), aa[0 | t](e, a, i, n);
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 228 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 236 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 232 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 240 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 244 >> 2];
                    },
                    function(r) {
                        return +m[c[(r |= 0) >> 2] + 248 >> 2];
                    },
                    function(r, e) {
                        r |= 0, e = c[(e |= 0) >> 2], N[r >> 3] = m[e + 228 >> 2], N[r + 8 >> 3] = m[e + 236 >> 2], N[r + 16 >> 3] = m[e + 232 >> 2], N[r + 24 >> 3] = m[e + 240 >> 2], N[r + 32 >> 3] = m[e + 244 >> 2], N[r + 40 >> 3] = m[e + 248 >> 2];
                    },
                    function(r, e) {
                        e |= 0;
                        var a, i = 0;
                        return ar = a = ar - 48 | 0, i = c[(r |= 0) >> 2], e = ((r = c[r + 4 >> 2]) >> 1) + e | 0, 1 & r && (i = c[i + c[e >> 2] >> 2]), aa[0 | i](a, e), r = Ar(ye(48), a, 48), ar = a + 48 | 0, 0 | r;
                    },
                    function(r, e) {
                        var a;
                        if (e |= 0, ar = a = ar - 16 | 0, r = c[(r |= 0) >> 2], (0 | e) < 6) {
                            ar = a + 16 | 0;
                            r: {
                                switch(e - 4 | 0){
                                    case 0:
                                        if (e = r + 260 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 252 | 0;
                                        break r;
                                    case 1:
                                        if (e = r + 252 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 260 | 0;
                                        break r;
                                }
                                e = 252 + (r + (e << 2) | 0) | 0;
                            }
                            return +m[e >> 2];
                        }
                        c[a >> 2] = 1871, Xr(r, a), De(), k();
                    },
                    function(r, e) {
                        var a;
                        if (e |= 0, ar = a = ar - 16 | 0, r = c[(r |= 0) >> 2], (0 | e) < 6) {
                            ar = a + 16 | 0;
                            r: {
                                switch(e - 4 | 0){
                                    case 0:
                                        if (e = r + 276 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 268 | 0;
                                        break r;
                                    case 1:
                                        if (e = r + 268 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 276 | 0;
                                        break r;
                                }
                                e = 268 + (r + (e << 2) | 0) | 0;
                            }
                            return +m[e >> 2];
                        }
                        c[a >> 2] = 1871, Xr(r, a), De(), k();
                    },
                    function(r, e) {
                        var a;
                        if (e |= 0, ar = a = ar - 16 | 0, r = c[(r |= 0) >> 2], (0 | e) < 6) {
                            ar = a + 16 | 0;
                            r: {
                                switch(e - 4 | 0){
                                    case 0:
                                        if (e = r + 292 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 284 | 0;
                                        break r;
                                    case 1:
                                        if (e = r + 284 | 0, 2 == (3 & v[r + 300 | 0])) break r;
                                        e = r + 292 | 0;
                                        break r;
                                }
                                e = 284 + (r + (e << 2) | 0) | 0;
                            }
                            return +m[e >> 2];
                        }
                        c[a >> 2] = 1871, Xr(r, a), De(), k();
                    },
                    Se,
                    Ce,
                    Se,
                    Ce,
                    Gr,
                    Le,
                    function(r) {
                        gr(Le(r |= 0));
                    },
                    function(r, e, a, i, n, t) {
                        var o, u, b;
                        r |= 0, e |= 0, a = y(a), i |= 0, n = y(n), t |= 0, ar = o = ar - 48 | 0, b = c[e + 8 >> 2], 1 & f[6972] ? e = c[1742] : (e = 0 | C(5, 4416), f[6972] = 1, c[1742] = e), c[o + 40 >> 2] = t, m[o + 32 >> 2] = n, c[o + 24 >> 2] = i, m[o + 16 >> 2] = a, e = (u = +Q(0 | e, 0 | b, 2873, o + 12 | 0, o + 16 | 0)) < 4294967296 & u >= 0 ? ~~u >>> 0 : 0, i = c[o + 12 >> 2], t = c[e + 4 >> 2], c[r >> 2] = c[e >> 2], c[r + 4 >> 2] = t, t = c[e + 12 >> 2], c[r + 8 >> 2] = c[e + 8 >> 2], c[r + 12 >> 2] = t, H(0 | i), ar = o + 48 | 0;
                    },
                    $e,
                    ra,
                    Oe,
                    function(r) {
                        gr(Oe(r |= 0));
                    },
                    function(r) {
                        Ie(c[8 + (r |= 0) >> 2], 3244);
                    },
                    $e,
                    function(r) {
                        return 0 | q(c[60 + (r |= 0) >> 2]);
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i, n = 0, t = 0, f = 0, o = 0, u = 0, b = 0;
                        ar = i = ar - 32 | 0, n = c[28 + (r |= 0) >> 2], c[i + 16 >> 2] = n, t = c[r + 20 >> 2], c[i + 28 >> 2] = a, c[i + 24 >> 2] = e, e = t - n | 0, c[i + 20 >> 2] = e, t = e + a | 0, u = 2, e = i + 16 | 0;
                        r: {
                            for(;;){
                                e: {
                                    a: {
                                        i: {
                                            if (!Ye(0 | K(c[r + 60 >> 2], 0 | e, 0 | u, i + 12 | 0))) {
                                                if ((0 | (f = c[i + 12 >> 2])) == (0 | t)) break i;
                                                if ((0 | f) >= 0) break a;
                                                break e;
                                            }
                                            if (-1 != (0 | t)) break e;
                                        }
                                        e = c[r + 44 >> 2], c[r + 28 >> 2] = e, c[r + 20 >> 2] = e, c[r + 16 >> 2] = e + c[r + 48 >> 2], r = a;
                                        break r;
                                    }
                                    o = f - ((b = (o = c[e + 4 >> 2]) >>> 0 < f >>> 0) ? o : 0) | 0, c[(n = (b << 3) + e | 0) >> 2] = o + c[n >> 2], c[(e = (b ? 12 : 4) + e | 0) >> 2] = c[e >> 2] - o, t = t - f | 0, u = u - b | 0, e = n;
                                    continue;
                                }
                                break;
                            }
                            c[r + 28 >> 2] = 0, c[r + 16 >> 2] = 0, c[r + 20 >> 2] = 0, c[r >> 2] = 32 | c[r >> 2], r = 0, 2 != (0 | u) && (r = a - c[e + 4 >> 2] | 0);
                        }
                        return ar = i + 32 | 0, 0 | r;
                    },
                    function(r, e, a, i) {
                        var n;
                        return e |= 0, a |= 0, i |= 0, ar = n = ar - 16 | 0, r = Ye(0 | j(c[60 + (r |= 0) >> 2], 0 | e, 0 | a, 255 & i, n + 8 | 0)), ar = n + 16 | 0, ir = r ? -1 : c[n + 12 >> 2], 0 | (r ? -1 : c[n + 8 >> 2]);
                    },
                    function(r) {
                        return 0;
                    },
                    function(r, e, a, i) {
                        return ir = 0, 0;
                    },
                    function(r, e, a) {
                        e |= 0, a |= 0;
                        var i, n, t = 0, o = 0, u = 0;
                        return i = c[84 + (r |= 0) >> 2], o = c[i >> 2], t = c[i + 4 >> 2], n = c[r + 28 >> 2], (u = t >>> 0 < (u = c[r + 20 >> 2] - n | 0) >>> 0 ? t : u) && (Ar(o, n, u), o = u + c[i >> 2] | 0, c[i >> 2] = o, t = c[i + 4 >> 2] - u | 0, c[i + 4 >> 2] = t), (t = a >>> 0 > t >>> 0 ? t : a) && (Ar(o, e, t), o = t + c[i >> 2] | 0, c[i >> 2] = o, c[i + 4 >> 2] = c[i + 4 >> 2] - t), f[0 | o] = 0, e = c[r + 44 >> 2], c[r + 28 >> 2] = e, c[r + 20 >> 2] = e, 0 | a;
                    },
                    ra
                ]);
                function ia() {
                    return t.byteLength / 65536 | 0;
                }
                return {
                    E: function E() {
                        for(var r = 0, e = 0, a = 0; a = 5888 + (e = r << 4) | 0, c[e + 5892 >> 2] = a, c[e + 5896 >> 2] = a, 64 != (0 | (r = r + 1 | 0)););
                        vr(48), c[1736] = 16, c[1737] = 0, tr(), c[1737] = c[1748], c[1748] = 6944, c[1749] = 194, c[1750] = 0, Gr(), c[1750] = c[1748], c[1748] = 6996;
                    },
                    F: function F(r) {
                        r |= 0;
                        var e, a, i = 0, n = 0, t = 0;
                        ar = e = ar - 96 | 0, c[e >> 2] = r, ar = n = ar - 16 | 0, c[n + 12 >> 2] = e, ar = r = ar - 144 | 0, r = Ar(r, 5440, 144), i = a = e + 16 | 0, c[r + 44 >> 2] = i, c[r + 20 >> 2] = i, t = (t = -2 - i | 0) >>> 0 >= 2147483647 ? 2147483647 : t, c[r + 48 >> 2] = t, i = i + t | 0, c[r + 28 >> 2] = i, c[r + 16 >> 2] = i, Zr(r, 2201, e, 0, 0), t && (i = c[r + 20 >> 2], f[i - ((0 | i) == c[r + 16 >> 2]) | 0] = 0), ar = r + 144 | 0, ar = n + 16 | 0;
                        r: {
                            if (3 & (r = a)) for(;;){
                                if (!v[0 | r]) break r;
                                if (!(3 & (r = r + 1 | 0))) break;
                            }
                            for(; i = r, r = r + 4 | 0, !((-1 ^ (n = c[i >> 2])) & n - 16843009 & -2139062144););
                            for(; i = (r = i) + 1 | 0, v[0 | r];);
                        }
                        return r = (i = cr(r = 1 + (r - a | 0) | 0)) ? Ar(i, a, r) : 0, ar = e + 96 | 0, 0 | r;
                    },
                    G: function G() {
                        var r = 0;
                        if (r = c[1748]) for(; aa[c[r >> 2]](), r = c[r + 4 >> 2];);
                    },
                    H: cr,
                    I: aa,
                    J: gr,
                    K: function K(r, e, a, i, n) {
                        return e |= 0, a |= 0, i |= 0, n |= 0, 0 | aa[0 | (r |= 0)](e, a, i, n);
                    }
                };
            }(r);
        }(r);
    }
    Object.assign(e, n), n = null, e.wasmBinary && (f = e.wasmBinary), e.noExitRuntime;
    var s = Error;
    f = [];
    var A, k, l, d, v, h, p, m, N, w = !1;
    function y(r, e, a) {
        a = e + a;
        for(var i = ""; !(e >= a);){
            var n = r[e++];
            if (!n) break;
            if (128 & n) {
                var t = 63 & r[e++];
                if (192 == (224 & n)) i += String.fromCharCode((31 & n) << 6 | t);
                else {
                    var f = 63 & r[e++];
                    65536 > (n = 224 == (240 & n) ? (15 & n) << 12 | t << 6 | f : (7 & n) << 18 | t << 12 | f << 6 | 63 & r[e++]) ? i += String.fromCharCode(n) : (n -= 65536, i += String.fromCharCode(55296 | n >> 10, 56320 | 1023 & n));
                }
            } else i += String.fromCharCode(n);
        }
        return i;
    }
    function E() {
        var r = A.buffer;
        e.HEAP8 = k = new Int8Array(r), e.HEAP16 = d = new Int16Array(r), e.HEAP32 = h = new Int32Array(r), e.HEAPU8 = l = new Uint8Array(r), e.HEAPU16 = v = new Uint16Array(r), e.HEAPU32 = p = new Uint32Array(r), e.HEAPF32 = m = new Float32Array(r), e.HEAPF64 = N = new Float64Array(r);
    }
    var G = e.INITIAL_MEMORY || 16777216;
    65536 <= G || X("INITIAL_MEMORY should be larger than STACK_SIZE, was " + G + "! (STACK_SIZE=65536)"), A = e.wasmMemory ? e.wasmMemory : new function() {
        this.buffer = new ArrayBuffer(G / 65536 * 65536);
    }(), E(), G = A.buffer.byteLength;
    var R, g = [], Z = [], W = [];
    function V() {
        var r = e.preRun.shift();
        g.unshift(r);
    }
    var B, T = 0, I = null;
    function X(r) {
        throw e.onAbort && e.onAbort(r), c(r = "Aborted(" + r + ")"), w = !0, r = new s(r + ". Build with -sASSERTIONS for more info."), i(r), r;
    }
    function O(r) {
        return r.startsWith("data:application/octet-stream;base64,");
    }
    if (!O(B = "yoga-asm.wasm")) {
        var L = B;
        B = e.locateFile ? e.locateFile(L, t) : t + L;
    }
    function _(r) {
        for(; 0 < r.length;)r.shift()(e);
    }
    function F(r) {
        if (void 0 === r) return "_unknown";
        var e = (r = r.replace(/[^a-zA-Z0-9_]/g, "$")).charCodeAt(0);
        return 48 <= e && 57 >= e ? "_" + r : r;
    }
    function C(r, e) {
        return r = F(r), function() {
            return e.apply(this, arguments);
        };
    }
    var S = [
        {},
        {
            value: void 0
        },
        {
            value: null
        },
        {
            value: !0
        },
        {
            value: !1
        }
    ], P = [];
    function Y(r) {
        var e = Error, a = C(r, function(e) {
            this.name = r, this.message = e, void 0 !== (e = Error(e).stack) && (this.stack = this.toString() + "\n" + e.replace(/^Error(:[^\n]*)?\n/, ""));
        });
        return a.prototype = Object.create(e.prototype), a.prototype.constructor = a, a.prototype.toString = function() {
            return void 0 === this.message ? this.name : this.name + ": " + this.message;
        }, a;
    }
    var U = void 0;
    function M(r) {
        throw new U(r);
    }
    var H = function H(r) {
        return r || M("Cannot use deleted val. handle = " + r), S[r].value;
    }, Q = function Q(r) {
        switch(r){
            case void 0:
                return 1;
            case null:
                return 2;
            case !0:
                return 3;
            case !1:
                return 4;
            default:
                var e = P.length ? P.pop() : S.length;
                return S[e] = {
                    fa: 1,
                    value: r
                }, e;
        }
    }, z = void 0, j = void 0;
    function _D(r) {
        for(var e = ""; l[r];)e += j[l[r++]];
        return e;
    }
    var x = [];
    function J() {
        for(; x.length;){
            var r = x.pop();
            r.L.Z = !1, r.delete();
        }
    }
    var K = void 0, _q = {};
    function $(r, e) {
        for(void 0 === e && M("ptr should not be undefined"); r.P;)e = r.aa(e), r = r.P;
        return e;
    }
    var er = {};
    function ar(r) {
        var e = _D(r = ee(r));
        return ne(r), e;
    }
    function ir(r, e) {
        var a = er[r];
        return void 0 === a && M(e + " has unknown type " + ar(r)), a;
    }
    function nr() {}
    var tr = !1;
    function fr(r) {
        --r.count.value, 0 === r.count.value && (r.S ? r.T.V(r.S) : r.O.M.V(r.N));
    }
    function or(r, e, a) {
        return e === a ? r : void 0 === a.P || null === (r = or(r, e, a.P)) ? null : a.ma(r);
    }
    var cr = {}, ur = void 0;
    function br(r) {
        throw new ur(r);
    }
    function sr(r, e) {
        return e.O && e.N || br("makeClassHandle requires ptr and ptrType"), !!e.T != !!e.S && br("Both smartPtrType and smartPtr must be specified"), e.count = {
            value: 1
        }, Ar(Object.create(r, {
            L: {
                value: e
            }
        }));
    }
    function Ar(r) {
        return "undefined" == typeof FinalizationRegistry ? (Ar = function Ar(r) {
            return r;
        }, r) : (tr = new FinalizationRegistry(function(r) {
            fr(r.L);
        }), nr = function nr(r) {
            tr.unregister(r);
        }, (Ar = function Ar(r) {
            var e = r.L;
            return e.S && tr.register(r, {
                L: e
            }, r), r;
        })(r));
    }
    var kr = {};
    function lr(r) {
        for(; r.length;){
            var e = r.pop();
            r.pop()(e);
        }
    }
    function dr(r) {
        return this.fromWireType(h[r >> 2]);
    }
    var vr = {}, hr = {};
    function pr(r, e, a) {
        function i(e) {
            (e = a(e)).length !== r.length && br("Mismatched type converter count");
            for(var i = 0; i < r.length; ++i)Nr(r[i], e[i]);
        }
        r.forEach(function(r) {
            hr[r] = e;
        });
        var n = Array(e.length), t = [], f = 0;
        e.forEach(function(r, e) {
            er.hasOwnProperty(r) ? n[e] = er[r] : (t.push(r), vr.hasOwnProperty(r) || (vr[r] = []), vr[r].push(function() {
                n[e] = er[r], ++f === t.length && i(n);
            }));
        }), 0 === t.length && i(n);
    }
    function mr(r) {
        switch(r){
            case 1:
                return 0;
            case 2:
                return 1;
            case 4:
                return 2;
            case 8:
                return 3;
            default:
                throw new TypeError("Unknown type size: " + r);
        }
    }
    function Nr(r, e, a) {
        if (a === void 0) a = {};
        if (!("argPackAdvance" in e)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
        var i = e.name;
        if (r || M('type "' + i + '" must have a positive integer typeid pointer'), er.hasOwnProperty(r)) {
            if (a.ta) return;
            M("Cannot register type '" + i + "' twice");
        }
        er[r] = e, delete hr[r], vr.hasOwnProperty(r) && (e = vr[r], delete vr[r], e.forEach(function(r) {
            return r();
        }));
    }
    function wr(r) {
        M(r.L.O.M.name + " instance already deleted");
    }
    function yr() {}
    function Er(r, e, a) {
        if (void 0 === r[e].R) {
            var i = r[e];
            r[e] = function() {
                return r[e].R.hasOwnProperty(arguments.length) || M("Function '" + a + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + r[e].R + ")!"), r[e].R[arguments.length].apply(this, arguments);
            }, r[e].R = [], r[e].R[i.Y] = i;
        }
    }
    function Gr(r, e, a, i, n, t, f, o) {
        this.name = r, this.constructor = e, this.W = a, this.V = i, this.P = n, this.oa = t, this.aa = f, this.ma = o, this.ia = [];
    }
    function Rr(r, e, a) {
        for(; e !== a;)e.aa || M("Expected null or instance of " + a.name + ", got an instance of " + e.name), r = e.aa(r), e = e.P;
        return r;
    }
    function gr(r, e) {
        return null === e ? (this.da && M("null is not a valid " + this.name), 0) : (e.L || M('Cannot pass "' + _r(e) + '" as a ' + this.name), e.L.N || M("Cannot pass deleted object as a pointer of type " + this.name), Rr(e.L.N, e.L.O.M, this.M));
    }
    function Zr(r, e) {
        if (null === e) {
            if (this.da && M("null is not a valid " + this.name), this.ca) {
                var a = this.ea();
                return null !== r && r.push(this.V, a), a;
            }
            return 0;
        }
        if (e.L || M('Cannot pass "' + _r(e) + '" as a ' + this.name), e.L.N || M("Cannot pass deleted object as a pointer of type " + this.name), !this.ba && e.L.O.ba && M("Cannot convert argument of type " + (e.L.T ? e.L.T.name : e.L.O.name) + " to parameter type " + this.name), a = Rr(e.L.N, e.L.O.M, this.M), this.ca) switch(void 0 === e.L.S && M("Passing raw pointer to smart pointer is illegal"), this.Aa){
            case 0:
                e.L.T === this ? a = e.L.S : M("Cannot convert argument of type " + (e.L.T ? e.L.T.name : e.L.O.name) + " to parameter type " + this.name);
                break;
            case 1:
                a = e.L.S;
                break;
            case 2:
                if (e.L.T === this) a = e.L.S;
                else {
                    var i = e.clone();
                    a = this.wa(a, Q(function() {
                        i.delete();
                    })), null !== r && r.push(this.V, a);
                }
                break;
            default:
                M("Unsupporting sharing policy");
        }
        return a;
    }
    function Wr(r, e) {
        return null === e ? (this.da && M("null is not a valid " + this.name), 0) : (e.L || M('Cannot pass "' + _r(e) + '" as a ' + this.name), e.L.N || M("Cannot pass deleted object as a pointer of type " + this.name), e.L.O.ba && M("Cannot convert argument of type " + e.L.O.name + " to parameter type " + this.name), Rr(e.L.N, e.L.O.M, this.M));
    }
    function Vr(r, e, a, i) {
        this.name = r, this.M = e, this.da = a, this.ba = i, this.ca = !1, this.V = this.wa = this.ea = this.ja = this.Aa = this.va = void 0, void 0 !== e.P ? this.toWireType = Zr : (this.toWireType = i ? gr : Wr, this.U = null);
    }
    function Br(r, a) {
        var i = (r = _D(r)).includes("j") ? function(r, a) {
            var i = [];
            return function() {
                if (i.length = 0, Object.assign(i, arguments), r.includes("j")) {
                    var n = e["dynCall_" + r];
                    n = i && i.length ? n.apply(null, [
                        a
                    ].concat(i)) : n.call(null, a);
                } else n = R.get(a).apply(null, i);
                return n;
            };
        }(r, a) : R.get(a);
        return "function" != typeof i && M("unknown function pointer with signature " + r + ": " + a), i;
    }
    var Tr = void 0;
    function Ir(r, e) {
        var a = [], i = {};
        throw e.forEach(function r(e) {
            i[e] || er[e] || (hr[e] ? hr[e].forEach(r) : (a.push(e), i[e] = !0));
        }), new Tr(r + ": " + a.map(ar).join([
            ", "
        ]));
    }
    function Xr(r, e, a, i, n) {
        var t = e.length;
        2 > t && M("argTypes array size mismatch! Must at least get return value and 'this' types!");
        var f = null !== e[1] && null !== a, o = !1;
        for(a = 1; a < e.length; ++a)if (null !== e[a] && void 0 === e[a].U) {
            o = !0;
            break;
        }
        var c = "void" !== e[0].name, u = t - 2, b = Array(u), s = [], A = [];
        return function() {
            if (arguments.length !== u && M("function " + r + " called with " + arguments.length + " arguments, expected " + u + " args!"), A.length = 0, s.length = f ? 2 : 1, s[0] = n, f) {
                var a = e[1].toWireType(A, this);
                s[1] = a;
            }
            for(var t = 0; t < u; ++t)b[t] = e[t + 2].toWireType(A, arguments[t]), s.push(b[t]);
            if (t = i.apply(null, s), o) lr(A);
            else for(var k = f ? 1 : 2; k < e.length; k++){
                var l = 1 === k ? a : b[k - 2];
                null !== e[k].U && e[k].U(l);
            }
            return c ? e[0].fromWireType(t) : void 0;
        };
    }
    function Or(r, e) {
        for(var a = [], i = 0; i < r; i++)a.push(p[e + 4 * i >> 2]);
        return a;
    }
    function Lr(r) {
        4 < r && 0 == --S[r].fa && (S[r] = void 0, P.push(r));
    }
    function _r(r) {
        if (null === r) return "null";
        var e = typeof r;
        return "object" === e || "array" === e || "function" === e ? r.toString() : "" + r;
    }
    function Fr(r, e) {
        switch(e){
            case 2:
                return function(r) {
                    return this.fromWireType(m[r >> 2]);
                };
            case 3:
                return function(r) {
                    return this.fromWireType(N[r >> 3]);
                };
            default:
                throw new TypeError("Unknown float type: " + r);
        }
    }
    function Cr(r, e, a) {
        switch(e){
            case 0:
                return a ? function(r) {
                    return k[r];
                } : function(r) {
                    return l[r];
                };
            case 1:
                return a ? function(r) {
                    return d[r >> 1];
                } : function(r) {
                    return v[r >> 1];
                };
            case 2:
                return a ? function(r) {
                    return h[r >> 2];
                } : function(r) {
                    return p[r >> 2];
                };
            default:
                throw new TypeError("Unknown integer type: " + r);
        }
    }
    function Sr(r, e) {
        for(var a = "", i = 0; !(i >= e / 2); ++i){
            var n = d[r + 2 * i >> 1];
            if (0 == n) break;
            a += String.fromCharCode(n);
        }
        return a;
    }
    function Pr(r, e, a) {
        if (void 0 === a && (a = 2147483647), 2 > a) return 0;
        var i = e;
        a = (a -= 2) < 2 * r.length ? a / 2 : r.length;
        for(var n = 0; n < a; ++n)d[e >> 1] = r.charCodeAt(n), e += 2;
        return d[e >> 1] = 0, e - i;
    }
    function Yr(r) {
        return 2 * r.length;
    }
    function Ur(r, e) {
        for(var a = 0, i = ""; !(a >= e / 4);){
            var n = h[r + 4 * a >> 2];
            if (0 == n) break;
            ++a, 65536 <= n ? (n -= 65536, i += String.fromCharCode(55296 | n >> 10, 56320 | 1023 & n)) : i += String.fromCharCode(n);
        }
        return i;
    }
    function Mr(r, e, a) {
        if (void 0 === a && (a = 2147483647), 4 > a) return 0;
        var i = e;
        a = i + a - 4;
        for(var n = 0; n < r.length; ++n){
            var t = r.charCodeAt(n);
            if (55296 <= t && 57343 >= t && (t = 65536 + ((1023 & t) << 10) | 1023 & r.charCodeAt(++n)), h[e >> 2] = t, (e += 4) + 4 > a) break;
        }
        return h[e >> 2] = 0, e - i;
    }
    function Hr(r) {
        for(var e = 0, a = 0; a < r.length; ++a){
            var i = r.charCodeAt(a);
            55296 <= i && 57343 >= i && ++a, e += 4;
        }
        return e;
    }
    var Qr = {};
    function zr(r) {
        var e = Qr[r];
        return void 0 === e ? _D(r) : e;
    }
    var jr = [], Dr = [], xr = [
        null,
        [],
        []
    ];
    U = e.BindingError = Y("BindingError"), e.count_emval_handles = function() {
        for(var r = 0, e = 5; e < S.length; ++e)void 0 !== S[e] && ++r;
        return r;
    }, e.get_first_emval = function() {
        for(var r = 5; r < S.length; ++r)if (void 0 !== S[r]) return S[r];
        return null;
    }, z = e.PureVirtualError = Y("PureVirtualError");
    for(var Jr = Array(256), Kr = 0; 256 > Kr; ++Kr)Jr[Kr] = String.fromCharCode(Kr);
    j = Jr, e.getInheritedInstanceCount = function() {
        return Object.keys(_q).length;
    }, e.getLiveInheritedInstances = function() {
        var r, e = [];
        for(r in _q)_q.hasOwnProperty(r) && e.push(_q[r]);
        return e;
    }, e.flushPendingDeletes = J, e.setDelayFunction = function(r) {
        K = r, x.length && K && K(J);
    }, ur = e.InternalError = Y("InternalError"), yr.prototype.isAliasOf = function(r) {
        if (!(this instanceof yr && r instanceof yr)) return !1;
        var e = this.L.O.M, a = this.L.N, i = r.L.O.M;
        for(r = r.L.N; e.P;)a = e.aa(a), e = e.P;
        for(; i.P;)r = i.aa(r), i = i.P;
        return e === i && a === r;
    }, yr.prototype.clone = function() {
        if (this.L.N || wr(this), this.L.$) return this.L.count.value += 1, this;
        var r = Ar, e = Object, a = e.create, i = Object.getPrototypeOf(this), n = this.L;
        return (r = r(a.call(e, i, {
            L: {
                value: {
                    count: n.count,
                    Z: n.Z,
                    $: n.$,
                    N: n.N,
                    O: n.O,
                    S: n.S,
                    T: n.T
                }
            }
        }))).L.count.value += 1, r.L.Z = !1, r;
    }, yr.prototype.delete = function() {
        this.L.N || wr(this), this.L.Z && !this.L.$ && M("Object already scheduled for deletion"), nr(this), fr(this.L), this.L.$ || (this.L.S = void 0, this.L.N = void 0);
    }, yr.prototype.isDeleted = function() {
        return !this.L.N;
    }, yr.prototype.deleteLater = function() {
        return this.L.N || wr(this), this.L.Z && !this.L.$ && M("Object already scheduled for deletion"), x.push(this), 1 === x.length && K && K(J), this.L.Z = !0, this;
    }, Vr.prototype.pa = function(r) {
        return this.ja && (r = this.ja(r)), r;
    }, Vr.prototype.ga = function(r) {
        this.V && this.V(r);
    }, Vr.prototype.argPackAdvance = 8, Vr.prototype.readValueFromPointer = dr, Vr.prototype.deleteObject = function(r) {
        null !== r && r.delete();
    }, Vr.prototype.fromWireType = function(r) {
        function e() {
            return this.ca ? sr(this.M.W, {
                O: this.va,
                N: a,
                T: this,
                S: r
            }) : sr(this.M.W, {
                O: this,
                N: r
            });
        }
        var a = this.pa(r);
        if (!a) return this.ga(r), null;
        var i = function(r, e) {
            return e = $(r, e), _q[e];
        }(this.M, a);
        if (void 0 !== i) return 0 === i.L.count.value ? (i.L.N = a, i.L.S = r, i.clone()) : (i = i.clone(), this.ga(r), i);
        if (i = this.M.oa(a), !(i = cr[i])) return e.call(this);
        i = this.ba ? i.ka : i.pointerType;
        var n = or(a, this.M, i.M);
        return null === n ? e.call(this) : this.ca ? sr(i.M.W, {
            O: i,
            N: n,
            T: this,
            S: r
        }) : sr(i.M.W, {
            O: i,
            N: n
        });
    }, Tr = e.UnboundTypeError = Y("UnboundTypeError");
    var qr = "function" == typeof atob ? atob : function(r) {
        var e = "", a = 0;
        r = r.replace(/[^A-Za-z0-9\+\/=]/g, "");
        do {
            var i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r.charAt(a++)), n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r.charAt(a++)), t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r.charAt(a++)), f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r.charAt(a++));
            i = i << 2 | n >> 4, n = (15 & n) << 4 | t >> 2;
            var o = (3 & t) << 6 | f;
            e += String.fromCharCode(i), 64 !== t && (e += String.fromCharCode(n)), 64 !== f && (e += String.fromCharCode(o));
        }while (a < r.length);
        return e;
    }, $r = {
        q: function q(r, e, a) {
            r = _D(r), e = ir(e, "wrapper"), a = H(a);
            var i = [].slice, n = e.M, t = n.W, f = n.P.W, o = n.P.constructor;
            for(var c in r = C(r, function() {
                n.P.ia.forEach((function(r) {
                    if (this[r] === f[r]) throw new z("Pure virtual function " + r + " must be implemented in JavaScript");
                }).bind(this)), Object.defineProperty(this, "__parent", {
                    value: t
                }), this.__construct.apply(this, i.call(arguments));
            }), t.__construct = function() {
                this === t && M("Pass correct 'this' to __construct");
                var r = o.implement.apply(void 0, [
                    this
                ].concat(i.call(arguments)));
                nr(r);
                var e = r.L;
                r.notifyOnDestruction(), e.$ = !0, Object.defineProperties(this, {
                    L: {
                        value: e
                    }
                }), Ar(this), r = e.N, r = $(n, r), _q.hasOwnProperty(r) ? M("Tried to register registered instance: " + r) : _q[r] = this;
            }, t.__destruct = function() {
                this === t && M("Pass correct 'this' to __destruct"), nr(this);
                var r = this.L.N;
                r = $(n, r), _q.hasOwnProperty(r) ? delete _q[r] : M("Tried to unregister unregistered instance: " + r);
            }, r.prototype = Object.create(t), a)r.prototype[c] = a[c];
            return Q(r);
        },
        k: function k(r) {
            var e = kr[r];
            delete kr[r];
            var a = e.ea, i = e.V, n = e.ha;
            pr([
                r
            ], n.map(function(r) {
                return r.sa;
            }).concat(n.map(function(r) {
                return r.ya;
            })), function(r) {
                var t = {};
                return n.forEach(function(e, a) {
                    var i = r[a], f = e.qa, o = e.ra, c = r[a + n.length], u = e.xa, b = e.za;
                    t[e.na] = {
                        read: function read(r) {
                            return i.fromWireType(f(o, r));
                        },
                        write: function write(r, e) {
                            var a = [];
                            u(b, r, c.toWireType(a, e)), lr(a);
                        }
                    };
                }), [
                    {
                        name: e.name,
                        fromWireType: function fromWireType(r) {
                            var e, a = {};
                            for(e in t)a[e] = t[e].read(r);
                            return i(r), a;
                        },
                        toWireType: function toWireType(r, e) {
                            for(var n in t)if (!(n in e)) throw new TypeError('Missing field:  "' + n + '"');
                            var f = a();
                            for(n in t)t[n].write(f, e[n]);
                            return null !== r && r.push(i, f), f;
                        },
                        argPackAdvance: 8,
                        readValueFromPointer: dr,
                        U: i
                    }
                ];
            });
        },
        w: function w() {},
        C: function C(r, e, a, i, n) {
            var t = mr(a);
            Nr(r, {
                name: e = _D(e),
                fromWireType: function fromWireType(r) {
                    return !!r;
                },
                toWireType: function toWireType(r, e) {
                    return e ? i : n;
                },
                argPackAdvance: 8,
                readValueFromPointer: function readValueFromPointer(r) {
                    if (1 === a) var i = k;
                    else if (2 === a) i = d;
                    else {
                        if (4 !== a) throw new TypeError("Unknown boolean type size: " + e);
                        i = h;
                    }
                    return this.fromWireType(i[r >> t]);
                },
                U: null
            });
        },
        f: function f(r, a, i, n, t, _f, o, c, u, b, s, A, k) {
            s = _D(s), _f = Br(t, _f), c && (c = Br(o, c)), b && (b = Br(u, b)), k = Br(A, k);
            var l = F(s);
            !function(r, a) {
                e.hasOwnProperty(r) ? (M("Cannot register public name '" + r + "' twice"), Er(e, r, r), e.hasOwnProperty(void 0) && M("Cannot register multiple overloads of a function with the same number of arguments (undefined)!"), e[r].R[void 0] = a) : e[r] = a;
            }(l, function() {
                Ir("Cannot construct " + s + " due to unbound types", [
                    n
                ]);
            }), pr([
                r,
                a,
                i
            ], n ? [
                n
            ] : [], function(a) {
                if (a = a[0], n) var i = a.M, t = i.W;
                else t = yr.prototype;
                a = C(l, function() {
                    if (Object.getPrototypeOf(this) !== o) throw new U("Use 'new' to construct " + s);
                    if (void 0 === u.X) throw new U(s + " has no accessible constructor");
                    var r = u.X[arguments.length];
                    if (void 0 === r) throw new U("Tried to invoke ctor of " + s + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(u.X).toString() + ") parameters instead!");
                    return r.apply(this, arguments);
                });
                var o = Object.create(t, {
                    constructor: {
                        value: a
                    }
                });
                a.prototype = o;
                var u = new Gr(s, a, o, k, i, _f, c, b);
                i = new Vr(s, u, !0, !1), t = new Vr(s + "*", u, !1, !1);
                var A = new Vr(s + " const*", u, !1, !0);
                return cr[r] = {
                    pointerType: t,
                    ka: A
                }, function(r, a) {
                    e.hasOwnProperty(r) || br("Replacing nonexistant public symbol"), e[r] = a, e[r].Y = void 0;
                }(l, a), [
                    i,
                    t,
                    A
                ];
            });
        },
        d: function d(r, e, a, i, n, t, f) {
            var o = Or(a, i);
            e = _D(e), t = Br(n, t), pr([], [
                r
            ], function(r) {
                function i() {
                    Ir("Cannot call " + n + " due to unbound types", o);
                }
                var n = (r = r[0]).name + "." + e;
                e.startsWith("@@") && (e = Symbol[e.substring(2)]);
                var c = r.M.constructor;
                return void 0 === c[e] ? (i.Y = a - 1, c[e] = i) : (Er(c, e, n), c[e].R[a - 1] = i), pr([], o, function(r) {
                    return r = Xr(n, [
                        r[0],
                        null
                    ].concat(r.slice(1)), null, t, f), void 0 === c[e].R ? (r.Y = a - 1, c[e] = r) : c[e].R[a - 1] = r, [];
                }), [];
            });
        },
        p: function p(r, e, a, i, n, t) {
            0 < e || X();
            var f = Or(e, a);
            n = Br(i, n), pr([], [
                r
            ], function(r) {
                var a = "constructor " + (r = r[0]).name;
                if (void 0 === r.M.X && (r.M.X = []), void 0 !== r.M.X[e - 1]) throw new U("Cannot register multiple constructors with identical number of parameters (" + (e - 1) + ") for class '" + r.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
                return r.M.X[e - 1] = function() {
                    Ir("Cannot construct " + r.name + " due to unbound types", f);
                }, pr([], f, function(i) {
                    return i.splice(1, 0, null), r.M.X[e - 1] = Xr(a, i, null, n, t), [];
                }), [];
            });
        },
        b: function b(r, e, a, i, n, t, f, o) {
            var c = Or(a, i);
            e = _D(e), t = Br(n, t), pr([], [
                r
            ], function(r) {
                function i() {
                    Ir("Cannot call " + n + " due to unbound types", c);
                }
                var n = (r = r[0]).name + "." + e;
                e.startsWith("@@") && (e = Symbol[e.substring(2)]), o && r.M.ia.push(e);
                var u = r.M.W, b = u[e];
                return void 0 === b || void 0 === b.R && b.className !== r.name && b.Y === a - 2 ? (i.Y = a - 2, i.className = r.name, u[e] = i) : (Er(u, e, n), u[e].R[a - 2] = i), pr([], c, function(i) {
                    return i = Xr(n, i, r, t, f), void 0 === u[e].R ? (i.Y = a - 2, u[e] = i) : u[e].R[a - 2] = i, [];
                }), [];
            });
        },
        B: function B(r, e) {
            Nr(r, {
                name: e = _D(e),
                fromWireType: function fromWireType(r) {
                    var e = H(r);
                    return Lr(r), e;
                },
                toWireType: function toWireType(r, e) {
                    return Q(e);
                },
                argPackAdvance: 8,
                readValueFromPointer: dr,
                U: null
            });
        },
        n: function n(r, e, a) {
            a = mr(a), Nr(r, {
                name: e = _D(e),
                fromWireType: function fromWireType(r) {
                    return r;
                },
                toWireType: function toWireType(r, e) {
                    return e;
                },
                argPackAdvance: 8,
                readValueFromPointer: Fr(e, a),
                U: null
            });
        },
        e: function e(r, _e2, a, i, n) {
            _e2 = _D(_e2), -1 === n && (n = 4294967295), n = mr(a);
            var t = function t(r) {
                return r;
            };
            if (0 === i) {
                var f = 32 - 8 * a;
                t = function t(r) {
                    return r << f >>> f;
                };
            }
            a = _e2.includes("unsigned") ? function(r, e) {
                return e >>> 0;
            } : function(r, e) {
                return e;
            }, Nr(r, {
                name: _e2,
                fromWireType: t,
                toWireType: a,
                argPackAdvance: 8,
                readValueFromPointer: Cr(_e2, n, 0 !== i),
                U: null
            });
        },
        c: function c(r, e, a) {
            function i(r) {
                r >>= 2;
                var e = p;
                return new n(e.buffer, e[r + 1], e[r]);
            }
            var n = [
                Int8Array,
                Uint8Array,
                Int16Array,
                Uint16Array,
                Int32Array,
                Uint32Array,
                Float32Array,
                Float64Array
            ][e];
            Nr(r, {
                name: a = _D(a),
                fromWireType: i,
                argPackAdvance: 8,
                readValueFromPointer: i
            }, {
                ta: !0
            });
        },
        o: function o(r, e) {
            var a = "std::string" === (e = _D(e));
            Nr(r, {
                name: e,
                fromWireType: function fromWireType(r) {
                    var e = p[r >> 2], i = r + 4;
                    if (a) for(var n = i, t = 0; t <= e; ++t){
                        var f = i + t;
                        if (t == e || 0 == l[f]) {
                            if (n = n ? y(l, n, f - n) : "", void 0 === o) var o = n;
                            else o += String.fromCharCode(0), o += n;
                            n = f + 1;
                        }
                    }
                    else {
                        for(o = Array(e), t = 0; t < e; ++t)o[t] = String.fromCharCode(l[i + t]);
                        o = o.join("");
                    }
                    return ne(r), o;
                },
                toWireType: function toWireType(r, e) {
                    e instanceof ArrayBuffer && (e = new Uint8Array(e));
                    var i, n = "string" == typeof e;
                    if (n || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array || M("Cannot pass non-string to std::string"), a && n) {
                        var t = 0;
                        for(i = 0; i < e.length; ++i){
                            var f = e.charCodeAt(i);
                            127 >= f ? t++ : 2047 >= f ? t += 2 : 55296 <= f && 57343 >= f ? (t += 4, ++i) : t += 3;
                        }
                        i = t;
                    } else i = e.length;
                    if (f = (t = ie(4 + i + 1)) + 4, p[t >> 2] = i, a && n) {
                        if (n = f, f = i + 1, i = l, 0 < f) {
                            f = n + f - 1;
                            for(var o = 0; o < e.length; ++o){
                                var c = e.charCodeAt(o);
                                if (55296 <= c && 57343 >= c && (c = 65536 + ((1023 & c) << 10) | 1023 & e.charCodeAt(++o)), 127 >= c) {
                                    if (n >= f) break;
                                    i[n++] = c;
                                } else {
                                    if (2047 >= c) {
                                        if (n + 1 >= f) break;
                                        i[n++] = 192 | c >> 6;
                                    } else {
                                        if (65535 >= c) {
                                            if (n + 2 >= f) break;
                                            i[n++] = 224 | c >> 12;
                                        } else {
                                            if (n + 3 >= f) break;
                                            i[n++] = 240 | c >> 18, i[n++] = 128 | c >> 12 & 63;
                                        }
                                        i[n++] = 128 | c >> 6 & 63;
                                    }
                                    i[n++] = 128 | 63 & c;
                                }
                            }
                            i[n] = 0;
                        }
                    } else if (n) for(n = 0; n < i; ++n)255 < (o = e.charCodeAt(n)) && (ne(f), M("String has UTF-16 code units that do not fit in 8 bits")), l[f + n] = o;
                    else for(n = 0; n < i; ++n)l[f + n] = e[n];
                    return null !== r && r.push(ne, t), t;
                },
                argPackAdvance: 8,
                readValueFromPointer: dr,
                U: function U(r) {
                    ne(r);
                }
            });
        },
        j: function j(r, e, a) {
            if (a = _D(a), 2 === e) var i = Sr, n = Pr, t = Yr, f = function f() {
                return v;
            }, o = 1;
            else 4 === e && (i = Ur, n = Mr, t = Hr, f = function f() {
                return p;
            }, o = 2);
            Nr(r, {
                name: a,
                fromWireType: function fromWireType(r) {
                    for(var a, n = p[r >> 2], t = f(), c = r + 4, u = 0; u <= n; ++u){
                        var b = r + 4 + u * e;
                        u != n && 0 != t[b >> o] || (c = i(c, b - c), void 0 === a ? a = c : (a += String.fromCharCode(0), a += c), c = b + e);
                    }
                    return ne(r), a;
                },
                toWireType: function toWireType(r, i) {
                    "string" != typeof i && M("Cannot pass non-string to C++ string type " + a);
                    var f = t(i), c = ie(4 + f + e);
                    return p[c >> 2] = f >> o, n(i, c + 4, f + e), null !== r && r.push(ne, c), c;
                },
                argPackAdvance: 8,
                readValueFromPointer: dr,
                U: function U(r) {
                    ne(r);
                }
            });
        },
        l: function l(r, e, a, i, n, t) {
            kr[r] = {
                name: _D(e),
                ea: Br(a, i),
                V: Br(n, t),
                ha: []
            };
        },
        i: function i(r, e, a, _i, n, t, f, o, c, u) {
            kr[r].ha.push({
                na: _D(e),
                sa: a,
                qa: Br(_i, n),
                ra: t,
                ya: f,
                xa: Br(o, c),
                za: u
            });
        },
        D: function D(r, e) {
            Nr(r, {
                ua: !0,
                name: e = _D(e),
                argPackAdvance: 0,
                fromWireType: function fromWireType() {},
                toWireType: function toWireType() {}
            });
        },
        t: function t(r, e, a, i, n) {
            r = jr[r], e = H(e), a = zr(a);
            var t = [];
            return p[i >> 2] = Q(t), r(e, a, t, n);
        },
        u: function u(r, e, a, i) {
            (r = jr[r])(e = H(e), a = zr(a), null, i);
        },
        h: Lr,
        m: function m(r, e) {
            var a = function(r, e) {
                for(var a = Array(r), i = 0; i < r; ++i)a[i] = ir(p[e + 4 * i >> 2], "parameter " + i);
                return a;
            }(r, e), i = a[0];
            e = i.name + "_$" + a.slice(1).map(function(r) {
                return r.name;
            }).join("_") + "$";
            var n = Dr[e];
            if (void 0 !== n) return n;
            var t = Array(r - 1);
            return n = function(r) {
                var e = jr.length;
                return jr.push(r), e;
            }(function(e, n, f, o) {
                for(var c = 0, u = 0; u < r - 1; ++u)t[u] = a[u + 1].readValueFromPointer(o + c), c += a[u + 1].argPackAdvance;
                for(e = e[n].apply(e, t), u = 0; u < r - 1; ++u)a[u + 1].la && a[u + 1].la(t[u]);
                if (!i.ua) return i.toWireType(f, e);
            }), Dr[e] = n;
        },
        r: function r(_r2) {
            4 < _r2 && (S[_r2].fa += 1);
        },
        s: function s(r) {
            lr(H(r)), Lr(r);
        },
        g: function g() {
            X("");
        },
        y: function y(r, e, a) {
            l.copyWithin(r, e, e + a);
        },
        x: function x(r) {
            var e = l.length;
            if (2147483648 < (r >>>= 0)) return !1;
            for(var a = 1; 4 >= a; a *= 2){
                var i = e * (1 + .2 / a);
                i = Math.min(i, r + 100663296);
                var n = Math, t = n.min;
                i = Math.max(r, i), i += (65536 - i % 65536) % 65536;
                r: {
                    var f = A.buffer;
                    try {
                        A.grow(t.call(n, 2147483648, i) - f.byteLength + 65535 >>> 16), E();
                        var o = 1;
                        break r;
                    } catch (r) {}
                    o = void 0;
                }
                if (o) return !0;
            }
            return !1;
        },
        A: function A() {
            return 52;
        },
        v: function v() {
            return 70;
        },
        z: function z(r, e, a, i) {
            for(var n = 0, t = 0; t < a; t++){
                var f = p[e >> 2], u = p[e + 4 >> 2];
                e += 8;
                for(var b = 0; b < u; b++){
                    var s = l[f + b], A = xr[r];
                    0 === s || 10 === s ? ((1 === r ? o : c)(y(A, 0)), A.length = 0) : A.push(s);
                }
                n += u;
            }
            return p[i >> 2] = n, 0;
        },
        a: A
    }, re = function() {
        function r(r) {
            e.asm = r.exports, R = e.asm.I, Z.unshift(e.asm.E), T--, e.monitorRunDependencies && e.monitorRunDependencies(T), 0 == T && I && (r = I, I = null, r());
        }
        var a = {
            a: $r
        };
        if (T++, e.monitorRunDependencies && e.monitorRunDependencies(T), e.instantiateWasm) try {
            return e.instantiateWasm(a, r);
        } catch (r) {
            c("Module.instantiateWasm callback failed with error: " + r), i(r);
        }
        return a = function(r) {
            var e = B;
            try {
                try {
                    if (e == B && f) new Uint8Array(f);
                    else {
                        if (O(e)) {
                            try {
                                var a = qr(e.slice(37)), i = new Uint8Array(a.length);
                                for(e = 0; e < a.length; ++e)i[e] = a.charCodeAt(e);
                                var n = i;
                            } catch (r) {
                                throw Error("Converting base64 string to bytes failed.");
                            }
                            var t = n;
                        } else t = void 0;
                        if (!t) throw "sync fetching of the wasm failed: you can preload it to Module['wasmBinary'] manually, or emcc.py will do that for you when generating HTML (but not JS)";
                    }
                } catch (r) {
                    X(r);
                }
                var o = new u(), s = new b(r);
            } catch (e) {
                throw r = e.toString(), c("failed to compile wasm module: " + r), (r.includes("imported Memory") || r.includes("memory import")) && c("Memory size incompatibility issues may be due to changing INITIAL_MEMORY at runtime to something too large. Use ALLOW_MEMORY_GROWTH to allow any size memory (and also make sure not to set INITIAL_MEMORY at runtime to something smaller than it was at compile time)."), e;
            }
            return [
                s,
                o
            ];
        }(a), r(a[0]), e.asm;
    }(), ee = e.___getTypeName = re.F;
    e.__embind_initialize_bindings = re.G;
    var ae, ie = re.H, ne = re.J;
    function te() {
        function r() {
            if (!ae && (ae = !0, e.calledRun = !0, !w)) {
                if (_(Z), a(e), e.onRuntimeInitialized && e.onRuntimeInitialized(), e.postRun) for("function" == typeof e.postRun && (e.postRun = [
                    e.postRun
                ]); e.postRun.length;){
                    var r = e.postRun.shift();
                    W.unshift(r);
                }
                _(W);
            }
        }
        if (!(0 < T)) {
            if (e.preRun) for("function" == typeof e.preRun && (e.preRun = [
                e.preRun
            ]); e.preRun.length;)V();
            _(g), 0 < T || (e.setStatus ? (e.setStatus("Running..."), setTimeout(function() {
                setTimeout(function() {
                    e.setStatus("");
                }, 1), r();
            }, 1)) : r());
        }
    }
    if (e.dynCall_jiji = re.K, I = function r() {
        ae || te(), ae || (I = r);
    }, e.preInit) for("function" == typeof e.preInit && (e.preInit = [
        e.preInit
    ]); 0 < e.preInit.length;)e.preInit.pop()();
    return te(), r;
});
function ar() {
    return AE(er());
}
// eslint-disable-next-line import/no-unresolved
var index = ar();

},{"@babel/runtime/helpers/extends":"jbPGs","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9tzOV":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"6PmbL":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"68tv8"}],"68tv8":[function(require,module,exports) {
/** @license React v0.17.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var f, g, h, k, l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var p = null, q = null, t = function() {
        if (null !== p) try {
            var a = exports.unstable_now();
            p(!0, a);
            p = null;
        } catch (b) {
            throw setTimeout(t, 0), b;
        }
    }, u = Date.now();
    exports.unstable_now = function() {
        return Date.now() - u;
    };
    f = function(a) {
        null !== p ? setTimeout(f, 0, a) : (p = a, setTimeout(t, 0));
    };
    g = function(a, b) {
        q = setTimeout(a, b);
    };
    h = function() {
        clearTimeout(q);
    };
    k = function() {
        return !1;
    };
    l = exports.unstable_forceFrameRate = function() {};
} else {
    var w = window.performance, x = window.Date, y = window.setTimeout, z = window.clearTimeout, A = window.requestAnimationFrame, B = window.cancelAnimationFrame;
    "undefined" !== typeof console && ("function" !== typeof A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
    if ("object" === typeof w && "function" === typeof w.now) exports.unstable_now = function() {
        return w.now();
    };
    else {
        var C = x.now();
        exports.unstable_now = function() {
            return x.now() - C;
        };
    }
    var D = !1, E = null, F = -1, G = 5, H = 0;
    k = function() {
        return exports.unstable_now() >= H;
    };
    l = function() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : G = 0 < a ? Math.floor(1E3 / a) : 33.33;
    };
    var I = new MessageChannel, J = I.port2;
    I.port1.onmessage = function() {
        if (null !== E) {
            var a = exports.unstable_now();
            H = a + G;
            try {
                E(!0, a) ? J.postMessage(null) : (D = !1, E = null);
            } catch (b) {
                throw J.postMessage(null), b;
            }
        } else D = !1;
    };
    f = function(a) {
        E = a;
        D || (D = !0, J.postMessage(null));
    };
    g = function(a, b) {
        F = y(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function() {
        z(F);
        F = -1;
    };
}
function K(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = Math.floor((c - 1) / 2), e = a[d];
        if (void 0 !== e && 0 < L(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function M(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function N(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > L(n, c)) void 0 !== r && 0 > L(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > L(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function L(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var O = [], P = [], Q = 1, R = null, S = 3, T = !1, U = !1, V = !1;
function W(a) {
    for(var b = M(P); null !== b;){
        if (null === b.callback) N(P);
        else if (b.startTime <= a) N(P), b.sortIndex = b.expirationTime, K(O, b);
        else break;
        b = M(P);
    }
}
function X(a) {
    V = !1;
    W(a);
    if (!U) {
        if (null !== M(O)) U = !0, f(Y);
        else {
            var b = M(P);
            null !== b && g(X, b.startTime - a);
        }
    }
}
function Y(a, b) {
    U = !1;
    V && (V = !1, h());
    T = !0;
    var c = S;
    try {
        W(b);
        for(R = M(O); null !== R && (!(R.expirationTime > b) || a && !k());){
            var d = R.callback;
            if (null !== d) {
                R.callback = null;
                S = R.priorityLevel;
                var e = d(R.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? R.callback = e : R === M(O) && N(O);
                W(b);
            } else N(O);
            R = M(O);
        }
        if (null !== R) var m = !0;
        else {
            var n = M(P);
            null !== n && g(X, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        R = null, S = c, T = !1;
    }
}
function Z(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var aa = l;
exports.unstable_ImmediatePriority = 1;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_NormalPriority = 3;
exports.unstable_IdlePriority = 5;
exports.unstable_LowPriority = 4;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = S;
    S = a;
    try {
        return b();
    } finally{
        S = c;
    }
};
exports.unstable_next = function(a) {
    switch(S){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = S;
    }
    var c = S;
    S = b;
    try {
        return a();
    } finally{
        S = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : Z(a);
    } else c = Z(a), e = d;
    c = e + c;
    a = {
        id: Q++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, K(P, a), null === M(O) && a === M(P) && (V ? h() : V = !0, g(X, e - d))) : (a.sortIndex = c, K(O, a), U || T || (U = !0, f(Y)));
    return a;
};
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_wrapCallback = function(a) {
    var b = S;
    return function() {
        var c = S;
        S = b;
        try {
            return a.apply(this, arguments);
        } finally{
            S = c;
        }
    };
};
exports.unstable_getCurrentPriorityLevel = function() {
    return S;
};
exports.unstable_shouldYield = function() {
    var a = exports.unstable_now();
    W(a);
    var b = M(O);
    return b !== R && null !== R && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < R.expirationTime || k();
};
exports.unstable_requestPaint = aa;
exports.unstable_continueExecution = function() {
    U || T || (U = !0, f(Y));
};
exports.unstable_pauseExecution = function() {};
exports.unstable_getFirstCallbackNode = function() {
    return M(O);
};
exports.unstable_Profiling = null;

},{}],"dI29X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GET_CASH_ACTION_DETAILS_REQUEST", ()=>GET_CASH_ACTION_DETAILS_REQUEST);
parcelHelpers.export(exports, "getCashActionDetailsRequest", ()=>getCashActionDetailsRequest);
parcelHelpers.export(exports, "GET_CASH_ACTION_DETAILS_SUCCESS", ()=>GET_CASH_ACTION_DETAILS_SUCCESS);
parcelHelpers.export(exports, "getCashActionDetailsSuccess", ()=>getCashActionDetailsSuccess);
parcelHelpers.export(exports, "GET_CASH_ACTION_DETAILS_ERROR", ()=>GET_CASH_ACTION_DETAILS_ERROR);
parcelHelpers.export(exports, "getCashActionDetailsError", ()=>getCashActionDetailsError);
parcelHelpers.export(exports, "GET_CLOSEOUT_DETAILS_REQUEST", ()=>GET_CLOSEOUT_DETAILS_REQUEST);
parcelHelpers.export(exports, "getCloseoutDetailsRequest", ()=>getCloseoutDetailsRequest);
parcelHelpers.export(exports, "GET_CLOSEOUT_DETAILS_SUCCESS", ()=>GET_CLOSEOUT_DETAILS_SUCCESS);
parcelHelpers.export(exports, "getCloseoutDetailsSuccess", ()=>getCloseoutDetailsSuccess);
parcelHelpers.export(exports, "GET_CLOSEOUT_DETAILS_ERROR", ()=>GET_CLOSEOUT_DETAILS_ERROR);
parcelHelpers.export(exports, "getCloseoutDetailsError", ()=>getCloseoutDetailsError);
parcelHelpers.export(exports, "CLEAR_REPORTS", ()=>CLEAR_REPORTS);
parcelHelpers.export(exports, "clearReports", ()=>clearReports);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "cashActionDetailsAlertBarAction", ()=>cashActionDetailsAlertBarAction);
parcelHelpers.export(exports, "LOADING_MODAL_ACTION", ()=>LOADING_MODAL_ACTION);
parcelHelpers.export(exports, "cashActionDetailsLoadingModalAction", ()=>cashActionDetailsLoadingModalAction);
parcelHelpers.export(exports, "SUBMIT_PRINT_RECEIPT", ()=>SUBMIT_PRINT_RECEIPT);
parcelHelpers.export(exports, "submitPrintReceipt", ()=>submitPrintReceipt);
parcelHelpers.export(exports, "POST_RECEIPT_SUCCESS", ()=>POST_RECEIPT_SUCCESS);
parcelHelpers.export(exports, "postReceiptSuccess", ()=>postReceiptSuccess);
parcelHelpers.export(exports, "REPRINT_CLOSEOUT_REPORTS_REQUEST", ()=>REPRINT_CLOSEOUT_REPORTS_REQUEST);
parcelHelpers.export(exports, "reprintCloseoutReports", ()=>reprintCloseoutReports);
parcelHelpers.export(exports, "REPRINT_CLOSEOUT_REPORTS_SUCCESS", ()=>REPRINT_CLOSEOUT_REPORTS_SUCCESS);
parcelHelpers.export(exports, "reprintCloseoutReportsSuccess", ()=>reprintCloseoutReportsSuccess);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _reselect = require("reselect");
var _ramda = require("ramda");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
var _cashDropState = require("../cash-drop/CashDrop.state");
var _closeoutState = require("../closeout/Closeout.state");
var _helpers = require("../../utils/helpers");
var _constants = require("../../utils/constants");
// Default State
const initialState = {
    error: false,
    data: {},
    meta: {},
    reports: {},
    isLoading: false
};
const GET_CASH_ACTION_DETAILS_REQUEST = "GET_CASH_ACTION_DETAILS_REQUEST";
const getCashActionDetailsRequest = (data)=>({
        type: GET_CASH_ACTION_DETAILS_REQUEST,
        payload: data
    });
const GET_CASH_ACTION_DETAILS_SUCCESS = "GET_CASH_ACTION_DETAILS_SUCCESS";
const getCashActionDetailsSuccess = (data)=>({
        type: GET_CASH_ACTION_DETAILS_SUCCESS,
        payload: data
    });
const GET_CASH_ACTION_DETAILS_ERROR = "GET_CASH_ACTION_DETAILS_ERROR";
const getCashActionDetailsError = (data)=>({
        type: GET_CASH_ACTION_DETAILS_ERROR,
        payload: data
    });
const GET_CLOSEOUT_DETAILS_REQUEST = "GET_CLOSEOUT_DETAILS_REQUEST";
const getCloseoutDetailsRequest = (data)=>({
        type: GET_CLOSEOUT_DETAILS_REQUEST,
        payload: data
    });
const GET_CLOSEOUT_DETAILS_SUCCESS = "GET_CLOSEOUT_DETAILS_SUCCESS";
const getCloseoutDetailsSuccess = (data)=>({
        type: GET_CLOSEOUT_DETAILS_SUCCESS,
        payload: data
    });
const GET_CLOSEOUT_DETAILS_ERROR = "GET_CLOSEOUT_DETAILS_ERROR";
const getCloseoutDetailsError = (data)=>({
        type: GET_CLOSEOUT_DETAILS_ERROR,
        payload: data
    });
const CLEAR_REPORTS = "CLEAR_REPORTS";
const clearReports = ()=>({
        type: CLEAR_REPORTS
    });
const ALERT_BAR_ACTION = "cashActionDetails/ALERT_BAR_ACTION";
const cashActionDetailsAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const LOADING_MODAL_ACTION = "cashActionDetails/LOADING_MODAL_ACTION";
const cashActionDetailsLoadingModalAction = _nested.nestedAction(LOADING_MODAL_ACTION);
const SUBMIT_PRINT_RECEIPT = "cashActionDetails/SUBMIT_PRINT_RECEIPT";
const submitPrintReceipt = (payload)=>({
        type: SUBMIT_PRINT_RECEIPT,
        payload
    });
const POST_RECEIPT_SUCCESS = "cashActionDetails/POST_RECEIPT_SUCCESS";
const postReceiptSuccess = (payload)=>({
        type: POST_RECEIPT_SUCCESS,
        payload
    });
const REPRINT_CLOSEOUT_REPORTS_REQUEST = "cashActionDetails/REPRINT_CLOSEOUT_REPORTS_REQUEST";
const reprintCloseoutReports = (payload)=>({
        type: REPRINT_CLOSEOUT_REPORTS_REQUEST,
        payload
    });
const REPRINT_CLOSEOUT_REPORTS_SUCCESS = "cashActionDetails/REPRINT_CLOSEOUT_REPORTS_SUCCESS";
const reprintCloseoutReportsSuccess = (payload)=>({
        type: REPRINT_CLOSEOUT_REPORTS_SUCCESS,
        payload
    });
const _reducer = (state = initialState, { type, payload } = action)=>{
    switch(type){
        // Do not separate this fall through syntax
        case 0, _closeoutState.SUBMIT_CLOSEOUT_FORM:
        case 0, _cashDropState.SUBMIT_CASH_DROP_FORM:
            // case REPRINT_CLOSEOUT_REPORTS_REQUEST:
            return {
                ...state,
                fetching: true
            };
        case 0, _cashDropState.CASH_DROP_SUCCESS:
            return {
                ...state,
                fetching: false,
                data: {
                    type: "cashDrop",
                    ...payload
                }
            };
        case GET_CASH_ACTION_DETAILS_REQUEST:
            return {
                ...state,
                fetching: true
            };
        case GET_CASH_ACTION_DETAILS_SUCCESS:
            return {
                ...state,
                data: {
                    type: "cashDrop",
                    ...payload
                },
                fetching: false,
                error: false
            };
        case GET_CASH_ACTION_DETAILS_ERROR:
            return {
                ...state,
                error: true,
                fetching: false,
                errorText: payload
            };
        case 0, _closeoutState.CREATE_CLOSEOUT_SUCCESS:
            return {
                ...state,
                fetching: false,
                data: {
                    type: "closeout",
                    ...payload
                }
            };
        case GET_CLOSEOUT_DETAILS_REQUEST:
            return {
                ...state,
                fetching: true
            };
        case GET_CLOSEOUT_DETAILS_SUCCESS:
            return {
                ...state,
                data: {
                    type: "closeout",
                    ...payload
                },
                fetching: false,
                error: false
            };
        case REPRINT_CLOSEOUT_REPORTS_SUCCESS:
            return {
                ...state,
                reports: payload.reports
            };
        case CLEAR_REPORTS:
            return {
                ...state,
                reports: initialState.reports
            };
        default:
            return state;
    }
};
// Selectors
const selectCashActionData = (state)=>({
        type: state.cashActionDetails.data.type,
        ...state.cashActionDetails.data
    });
const selectFlattenCashActionData = (0, _reselect.createSelector)(selectCashActionData, (data)=>({
        id: data.id || data.terminal_session?.uuid,
        batchNumber: data.uuid || data.terminal_session?.uuid,
        total: data.type === (0, _constants.CASH_ACTION_TYPES).CLOSEOUT ? data.closeout?.total : data.total,
        date: data.type === (0, _constants.CASH_ACTION_TYPES).CLOSEOUT ? data.terminal_session?.closeout_at : data.created_at,
        closeoutTotals: [
            {
                label: "Cash",
                total: (0, _helpers.formatPrice)(data.closeout?.cash_total_amount)
            },
            {
                label: "Card",
                total: (0, _helpers.formatPrice)(data.closeout?.credit_card_total_amount)
            },
            {
                label: "Check",
                total: (0, _helpers.formatPrice)(data.closeout?.check_total_amount)
            }
        ],
        denominations: data.closeout?.denominations?.map((denomination)=>({
                label: (0, _helpers.formatPrice)(denomination.label),
                count: denomination.count,
                total: (0, _helpers.formatPrice)(denomination.total)
            })),
        ...data
    }));
const selectCashActionTypeDisplay = (0, _reselect.createSelector)(selectCashActionData, (data)=>(0, _constants.CASH_ACTION_TYPES_DISPLAY)[data.type]);
const _mapStateToProps = (state)=>({
        ...state.cashActionDetails,
        data: selectFlattenCashActionData(state),
        typeDisplay: selectCashActionTypeDisplay(state),
        reports: _ramda.pathOr({}, [
            "cashActionDetails",
            "reports"
        ], state)
    });
const _mapDispatchToProps = (dispatch)=>({
        getCloseoutDetails: (id)=>dispatch(getCloseoutDetailsRequest(id)),
        getCashActionDetails: (id)=>dispatch(getCashActionDetailsRequest(id)),
        submitPrintReceipt: (payload)=>dispatch(submitPrintReceipt(payload)),
        submitReprintReport: (payload)=>dispatch(reprintCloseoutReports(payload))
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    alertBars: {
        cashActionDetailsAlertBars: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    }
}, "cashActionDetails");
// Nested Reducer
const reducer = (state, action1)=>nestedReducer(state, action1);

},{"reselect":"7dznn","ramda":"JPp0Z","../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","../cash-drop/CashDrop.state":"esqw8","../closeout/Closeout.state":"eCCPO","../../utils/helpers":"epomp","../../utils/constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7dznn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMemoize", ()=>(0, _defaultMemoize.defaultMemoize));
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>(0, _defaultMemoize.defaultEqualityCheck));
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
var _defaultMemoize = require("./defaultMemoize");
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var createSelector = /* #__PURE__ */ createSelectorCreator((0, _defaultMemoize.defaultMemoize));
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = createSelector;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

},{"./defaultMemoize":"iUtHY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iUtHY":[function(require,module,exports) {
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEqualityCheck", ()=>defaultEqualityCheck);
parcelHelpers.export(exports, "createCacheKeyComparator", ()=>createCacheKeyComparator);
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
parcelHelpers.export(exports, "defaultMemoize", ()=>defaultMemoize);
var NOT_FOUND = "NOT_FOUND";
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"esqw8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CASH_DROP_ALERT_BAR_ACTION", ()=>CASH_DROP_ALERT_BAR_ACTION);
parcelHelpers.export(exports, "cashDropAlertBarAction", ()=>cashDropAlertBarAction);
parcelHelpers.export(exports, "MODAL_ACTION", ()=>MODAL_ACTION);
parcelHelpers.export(exports, "cashDropModalAction", ()=>cashDropModalAction);
parcelHelpers.export(exports, "CASH_DROP_FORM_ACTION", ()=>CASH_DROP_FORM_ACTION);
parcelHelpers.export(exports, "cashDropFormAction", ()=>cashDropFormAction);
parcelHelpers.export(exports, "SUBMIT_CASH_DROP_FORM", ()=>SUBMIT_CASH_DROP_FORM);
parcelHelpers.export(exports, "submitCashDropForm", ()=>submitCashDropForm);
parcelHelpers.export(exports, "CASH_DROP_SUCCESS", ()=>CASH_DROP_SUCCESS);
parcelHelpers.export(exports, "postCashDropSuccess", ()=>postCashDropSuccess);
parcelHelpers.export(exports, "CASH_DROP_ERROR", ()=>CASH_DROP_ERROR);
parcelHelpers.export(exports, "postCashDropError", ()=>postCashDropError);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
var _cashDropForm = require("./CashDropForm");
const CASH_DROP_ALERT_BAR_ACTION = "cashDrop/CASH_DROP_ALERT_BAR_ACTION";
const cashDropAlertBarAction = _nested.nestedAction(CASH_DROP_ALERT_BAR_ACTION);
const MODAL_ACTION = "cashDrop/MODAL_ACTION";
const cashDropModalAction = _nested.nestedAction(MODAL_ACTION);
const CASH_DROP_FORM_ACTION = "cashDrop/CASH_DROP_FORM_ACTION";
const cashDropFormAction = _nested.nestedAction(CASH_DROP_FORM_ACTION);
const SUBMIT_CASH_DROP_FORM = "cashDrop/SUBMIT_CASH_DROP_FORM";
const submitCashDropForm = (payload)=>({
        type: SUBMIT_CASH_DROP_FORM,
        payload
    });
const CASH_DROP_SUCCESS = "cashDrop/CASH_DROP_SUCCESS";
const postCashDropSuccess = (payload)=>({
        type: CASH_DROP_SUCCESS,
        payload
    });
const CASH_DROP_ERROR = "cashDrop/CASH_DROP_ERROR";
const postCashDropError = (payload)=>({
        type: CASH_DROP_ERROR,
        payload
    });
// Default State
const initialState = {
    data: {},
    batch: {},
    error: false,
    isLoading: false
};
const _reducer = (state = initialState, { type/* , payload */  })=>{
    switch(type){
        case SUBMIT_CASH_DROP_FORM:
            return {
                ...state,
                isLoading: true
            };
        case CASH_DROP_SUCCESS:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>({
        ...state.cashDrop,
        terminalSession: state.terminalLogin.terminalSession
    });
const _mapDispatchToProps = (dispatch)=>({
        submitCashDropForm: (payload)=>dispatch(submitCashDropForm(payload))
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    alertBars: {
        cashDropAlertBars: {
            ..._alertBarState,
            actionType: CASH_DROP_ALERT_BAR_ACTION
        }
    },
    forms: {
        cashDropForm: {
            ...(0, _cashDropForm.CashDropForm),
            actionType: CASH_DROP_FORM_ACTION
        }
    }
}, "cashDrop");
// Nested Reducer
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","./CashDropForm":"gUrPx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gUrPx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CashDropForm", ()=>CashDropForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reduxFreeform = require("redux-freeform");
var _tooltip = require("../../components/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _cashDropFormState = require("./CashDropForm.state");
var _constants = require("../../utils/constants");
var _helpers = require("../../utils/helpers");
var _rxjs = require("rxjs");
var _reactRedux = require("react-redux");
var _formBlocks = require("../../components/form-blocks");
var _peripheralDevices = require("../../state/peripheralDevices");
var _reactRouterDom = require("react-router-dom");
const requireErrors = (error_text)=>({
        [(0, _reduxFreeform.required).error]: error_text
    });
const CashDropForm = ({ actions, fields, forms, submitCashDropForm, terminalSession = {} })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [isCashSectionOpen, setCashSectionIsOpen] = (0, _react.useState)(false);
    const { uuid } = terminalSession;
    const [denominationsFormState, setDenominationsFormState] = (0, _react.useState)({});
    const { denominations } = (0, _reactRedux.useSelector)((state)=>state.shared);
    const { isLoading } = (0, _reactRedux.useSelector)((state)=>state.cashDrop);
    (0, _react.useEffect)(()=>{
        return ()=>actions.form.clear();
    }, []);
    const handleInputClick = (event)=>{
        event.stopPropagation();
    };
    const denominationsSum = isCashSectionOpen ? Object.entries(denominationsFormState).reduce((acc, cur)=>{
        const [key, quantity] = cur;
        return acc += quantity * denominations.find((d)=>d.name === key).value || 0;
    }, 0) : parseFloat(fields.cashTotal.rawValue || 0);
    const confirmAmountsBoolean = Boolean(fields.confirmAmounts.rawValue);
    const handleConfirmAmountsCheckboxClick = ()=>{
        actions.fields.confirmAmounts.set(!confirmAmountsBoolean);
    };
    const handleSubmit = ()=>{
        const hasDenominations = denominationsFormState && !!denominations.length;
        const reducedDenominationFields = Object.entries(denominationsFormState).reduce((acc, [key, quantity])=>{
            const denomination_id = denominations.find((d)=>d.name === key).id;
            return quantity > 0 ? [
                ...acc,
                {
                    denomination_id,
                    quantity
                }
            ] : acc;
        }, []);
        const denominationsWithValues = hasDenominations ? reducedDenominationFields : [];
        return submitCashDropForm({
            cash_action_type: (0, _constants.CASH_ACTION_TYPES).DROP,
            cash_actions_denominations_attributes: denominationsWithValues,
            notes: fields.notes.rawValue,
            total: denominationsSum,
            navigate
        });
    };
    const ShowTooltip = ({ show, text, children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
            children: show ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                width: "275px",
                height: "95%",
                variant: "error",
                left: true,
                noIcon: true,
                text: text,
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                children: children
            })
        });
    const disabledBtnContainerStyle = `
    cursor: not-allowed;
    margin-left: -8px;
    z-index: 1;
  `;
    const negativeCashDrop = denominationsSum < 0;
    const unconfirmedAmount = !confirmAmountsBoolean;
    const showToolTip = unconfirmedAmount || negativeCashDrop;
    const toolTipText = unconfirmedAmount ? "You must check Confirm Amounts above to continue" : "Cash Total cannot be a negative amount";
    const handleCashDropSubmitClick = (0, _components.util).general.generateClickHandler(forms.cashDropForm, ()=>handleErrors(true), handleSubmit);
    const cashDenominationsDropdownHeading = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        height: "10rem",
        padding: "0 0 0 1.5rem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            justify: "space-between",
            align: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        nowrap: "true",
                        overflow: "visible",
                        childGap: "1rem",
                        justify: "flex-start",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                margin: "",
                                as: "h4",
                                children: "Cash"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                margin: "",
                                as: "span",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                textExtraStyles: "font-size: 1rem;",
                                variant: "smallGhost",
                                action: (0, _rxjs.noop),
                                text: isCashSectionOpen ? "Hide Denominations" : "Show Denominations"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "0",
                    children: isCashSectionOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        align: "center",
                        minHeight: "5rem",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                textExtraStyles: "font-size: 1rem;",
                                variant: "smallGhost",
                                action: (e)=>{
                                    e.stopPropagation();
                                    setDenominationsFormState({});
                                    actions.form.clear();
                                },
                                text: "Clear count"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                children: (0, _helpers.formatPrice)(denominationsSum)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
                        overflow: "visible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                            "data-testid": "cash-total-input",
                            extraStyles: `text-align: right; width: 9.5rem; margin-right: .5rem;`,
                            onClick: handleInputClick,
                            labelTextWhenNoError: "",
                            errorMessages: requireErrors("Cash Total Error"),
                            field: fields.cashTotal,
                            errors: fields.errors,
                            fieldActions: actions.fields.cashTotal,
                            labelTextVariant: "p",
                            errorTextVariant: "p"
                        })
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
        padding: "0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                as: "h3",
                margin: "0.25rem 0",
                children: "Details"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                variant: "baseStandard",
                borderRadius: ".25rem",
                padding: "1.5rem",
                background: (0, _components.constants).colors.WHITE,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        justify: "space-between",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                as: "h5",
                                margin: ".25rem 0",
                                children: "Batch number"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                children: uuid
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        "data-testid": "notes",
                        labelTextWhenNoError: "Notes (optional)",
                        field: fields.notes,
                        errors: fields.errors,
                        fieldActions: actions.fields.notes,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                as: "h3",
                margin: "1.5rem 0 .25rem",
                children: "Cash Totals"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                variant: "baseStandard",
                borderRadius: ".25rem",
                padding: "0",
                background: (0, _components.constants).colors.WHITE,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CollapsibleSection), {
                            supportsTouch: false,
                            isOpen: isCashSectionOpen,
                            title: cashDenominationsDropdownHeading,
                            initiallyOpen: false,
                            toggleSection: ()=>setCashSectionIsOpen(!isCashSectionOpen),
                            customTitle: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Motion), {
                                variants: {
                                    open: {
                                        opacity: 1
                                    },
                                    closed: {
                                        opacity: 0
                                    }
                                },
                                initial: "open",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                        background: (0, _components.constants).colors.ATHENS_GREY,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormInputColumn), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.LineItem), {
                                                    description: "Denomination",
                                                    amount: "Amount"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formBlocks.DynamicDenominationsFieldGroup), {
                                                    denominationsFormState: denominationsFormState,
                                                    setDenominationsFormState: setDenominationsFormState
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "1.5rem",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    variant: "large",
                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                    children: "Total"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    variant: "large",
                                    "data-testid": "total",
                                    children: (0, _helpers.formatPrice)(denominationsSum)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "2rem 0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                    variant: "baseStandard",
                    borderRadius: ".25rem",
                    background: (0, _components.constants).colors.WHITE,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                            id: "confirm-amounts",
                            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                children: "Confirm Amounts"
                            }),
                            name: "Confirm Amounts",
                            checked: confirmAmountsBoolean,
                            onChange: handleConfirmAmountsCheckboxClick
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                            margin: ".5rem 2.5rem 0",
                            as: "p",
                            children: "By checking the box above, I confirm the amounts above are accurate."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                justify: "space-between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                        text: "Cancel",
                        isLoading: false,
                        variant: "secondary",
                        url: "/pos",
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        align: "center",
                        overflow: "visible",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                textExtraStyles: "font-size: 1rem;",
                                text: "Open Drawer",
                                isLoading: false,
                                variant: "secondary",
                                action: ()=>dispatch((0, _peripheralDevices.openCashDrawer)({
                                        location
                                    }))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ShowTooltip, {
                                show: showToolTip,
                                text: toolTipText,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                        padding: "0",
                                        extraStyles: showToolTip && disabledBtnContainerStyle
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                        textExtraStyles: "font-size: 1rem;",
                                        id: "drop-cash-btn",
                                        disabled: isLoading || showToolTip,
                                        isLoading: isLoading,
                                        text: "Drop Cash",
                                        "data-testid": "cash-drop-cta",
                                        action: handleCashDropSubmitClick
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
CashDropForm.reducer = (0, _cashDropFormState.reducer);
CashDropForm.mapStateToProps = (0, _cashDropFormState.mapStateToProps);
CashDropForm.mapDispatchToProps = (0, _cashDropFormState.mapDispatchToProps);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","redux-freeform":"1Yc5v","../../components/tooltip":"a8IOS","./CashDropForm.state":"iW5tK","../../utils/constants":"f3A1R","../../utils/helpers":"epomp","rxjs":"kbxjh","react-redux":"k6jol","../../components/form-blocks":"b6ROU","../../state/peripheralDevices":"3U6I5","react-router-dom":"hNarb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a8IOS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tooltipDefault.default));
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);

},{"./Tooltip":"dWQpW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dWQpW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tooltipStyled = require("./Tooltip.styled");
var _infoIcon = require("./InfoIcon");
var _infoIconDefault = parcelHelpers.interopDefault(_infoIcon);
var _warnIcon = require("./WarnIcon");
var _warnIconDefault = parcelHelpers.interopDefault(_warnIcon);
var _errorIcon = require("./ErrorIcon");
var _errorIconDefault = parcelHelpers.interopDefault(_errorIcon);
var _components = require("@thecb/components");
const TooltipIcons = {
    info: (0, _infoIconDefault.default),
    warn: (0, _warnIconDefault.default),
    error: (0, _errorIconDefault.default)
};
const Tooltip = ({ text, bottom, right, left, height, width, variant = "info", noIcon, children })=>{
    const Icon = TooltipIcons[variant];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltipStyled.TooltipWrap), {
        children: [
            noIcon ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                children: [
                    children,
                    " "
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipStyled.TooltipBody), {
                bottom: bottom,
                right: right,
                left: left,
                height: height,
                width: width,
                variant: variant,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
                    direction: "row",
                    childGap: "8px",
                    fullHeight: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cover), {
                            minHeight: "100%",
                            singleChild: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                padding: "0",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {})
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0",
                            extraStyles: "display: flex; align-items: center;",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
                                justify: "flex-start",
                                align: "center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                    padding: "0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                        variant: "pXS",
                                        extraStyles: `text-align: left;`,
                                        children: text
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = Tooltip;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","./Tooltip.styled":"7aLRC","./InfoIcon":"8MuoW","./WarnIcon":"8nLzS","./ErrorIcon":"5rssY","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7aLRC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipWrap", ()=>TooltipWrap);
parcelHelpers.export(exports, "TooltipBody", ()=>TooltipBody);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _components = require("@thecb/components");
const TooltipWrap = (0, _styledComponentsDefault.default).div`
  position: relative;
  display: inline-block;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: fit-content;
  text-decoration: none !important;
  &:hover {
    > div {
      visibility: visible;
    }
  }
`;
const TooltipBody = (0, _styledComponentsDefault.default).div`
  position: absolute;
  visibility: hidden;
  text-align: center;

  height: ${({ height })=>`${height}` || "fit-content"};
  width: ${({ width })=>`${width}` || "fit-content"};
  padding: 1rem;
  font-size: 12px;
  letter-spacing: 0;
  font-family: Public Sans;
  font-weight: ${(0, _components.constants).FONT_WEIGHT_REGULAR};
  color: ${(0, _components.constants).CHARADE_GREY};
  background-color: ${({ variant })=>variant === "info" ? (0, _components.constants).WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`};
  box-shadow:
    0px 3px 7px 2px rgba(0, 0, 0, 0.1),
    0px 1px 2px 1px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  z-index: 1;

  ${({ width })=>!width && "white-space: nowrap;"}

  ${({ bottom, right, left })=>bottom ? `
      left: 50%;
      transform: translateX(-50%);
      top: 150%;
    ` : right ? `
      left: 175%;
      transform: translateY(-50%);
      top: 50%;
    ` : left ? `
      right: 120%;
      transform: translateY(-50%);
      top: 50%;
    ` : `
      top: 0;
      left: 50%;
    `}

  &:after {
    content: '';
    ${({ bottom, right, left, variant })=>bottom ? `
        left: 50%;
        transform: translateX(-50%);
        bottom: 100%;
        border-color: transparent transparent ${variant === "info" ? (0, _components.constants).WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`}
      transparent;
    ` : right ? `
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
      border-color: transparent ${variant === "info" ? (0, _components.constants).WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`} transparent transparent;
    ` : left ? `
      left: 96%;
      top: 50%;
      box-shadow: -4px 4px 5px 0px rgba(0, 0, 0, 0.1);
      z-index: -1;
      transform: translateY(-50%) scaleX(-1) rotate(45deg);
      border-color: ${variant === "info" ? (0, _components.constants).WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`};
    ` : `
      top: 0;
      left: 50%;
      border-color: ${variant === "info" ? (0, _components.constants).WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`}
      transparent transparent transparent;
    `}

    position: absolute;
    border-width: 8px;
    border-style: solid;
  }
`;

},{"styled-components":"bkusY","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8MuoW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
const InfoIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        version: "1.2",
        overflow: "visible",
        preserveAspectRatio: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        height: "24",
        width: "24",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                height: "24",
                width: "24",
                fillRule: "nonzero",
                fill: (0, _components.constants).MATISSE_BLUE,
                y: "0",
                x: "0",
                id: "Rectangle-background",
                rx: "2",
                ry: "2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                height: "2",
                width: "2",
                fillRule: "nonzero",
                fill: (0, _components.constants).WHITE,
                y: "5",
                x: "11",
                id: "Rectangle-1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                height: "2",
                width: "3",
                fillRule: "nonzero",
                fill: (0, _components.constants).WHITE,
                y: "9",
                x: "10",
                id: "Rectangle-2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                height: "4",
                width: "2",
                fillRule: "nonzero",
                fill: (0, _components.constants).WHITE,
                y: "11",
                x: "11",
                id: "Rectangle-3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                height: "2",
                width: "4",
                fillRule: "nonzero",
                fill: (0, _components.constants).WHITE,
                y: "15",
                x: "10",
                id: "Rectangle-4"
            })
        ]
    });
exports.default = InfoIcon;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8nLzS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const WarnIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            id: "warning-icon-group-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                id: "Settings---Deactivated-User-Alert-Copy-2",
                transform: "translate(-767.000000, -469.000000)",
                fill: "#B34A00",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    id: "warning-icon-group-2",
                    transform: "translate(759.000000, 430.000000)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M16,39 C20.418278,39 24,42.581722 24,47 C24,51.418278 20.418278,55 16,55 C11.581722,55 8,51.418278 8,47 C8,42.581722 11.581722,39 16,39 Z M16.4166667,50 L15.5833333,50 C15.4452621,50 15.3333333,50.1119288 15.3333333,50.25 L15.3333333,50.25 L15.3333333,51.0833333 C15.3333333,51.2214045 15.4452621,51.3333333 15.5833333,51.3333333 L15.5833333,51.3333333 L16.4166667,51.3333333 C16.5547379,51.3333333 16.6666667,51.2214045 16.6666667,51.0833333 L16.6666667,51.0833333 L16.6666667,50.25 C16.6666667,50.1119288 16.5547379,50 16.4166667,50 L16.4166667,50 Z M16.4166667,42.6666667 L15.5833333,42.6666667 C15.4452621,42.6666667 15.3333333,42.7785955 15.3333333,42.9166667 L15.3333333,42.9166667 L15.3333333,48.4166667 C15.3333333,48.5547379 15.4452621,48.6666667 15.5833333,48.6666667 L15.5833333,48.6666667 L16.4166667,48.6666667 C16.5547379,48.6666667 16.6666667,48.5547379 16.6666667,48.4166667 L16.6666667,48.4166667 L16.6666667,42.9166667 C16.6666667,42.7785955 16.5547379,42.6666667 16.4166667,42.6666667 L16.4166667,42.6666667 Z",
                        id: "alert-icon---warning"
                    })
                })
            })
        })
    });
exports.default = WarnIcon;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5rssY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ErrorIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: "16px",
        height: "16px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M15.5714286,7 L12,10.572 L8.42857143,7 L7,8.42857143 L10.571,12 L7,15.5714286 L8.42857143,17 L11.999,13.428 L15.5714286,17 L17,15.5714286 L13.428,12 L17,8.42857143 L15.5714286,7 Z",
                    id: "path-1-error-icon"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                id: "error-icon symbols",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    id: "alert/error",
                    transform: "translate(-24.000000, -32.000000)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        id: "Icon/Error-Container",
                        transform: "translate(24.000000, 32.000000)",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                                id: "error-icon-mask-2",
                                fill: "white",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("use", {
                                    xlinkHref: "#path-1-error-icon"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("use", {
                                id: "icon---error",
                                fill: "#ED125F",
                                fillRule: "nonzero",
                                xlinkHref: "#path-1-error-icon"
                            })
                        ]
                    })
                })
            })
        ]
    });
exports.default = ErrorIcon;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iW5tK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
const cashDropFormConfig = {
    cashTotal: {
        defaultValue: "0",
        validators: [
            (0, _reduxFreeform.numberGreaterThanOrEqualTo)(0)
        ],
        constraints: [
            (0, _reduxFreeform.numberGreaterThanOrEqualTo)(0)
        ]
    },
    confirmAmounts: {
        defaultValue: false,
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    notes: {}
};
const { reducer, mapStateToProps, mapDispatchToProps } = (0, _reduxFreeform.createFormState)(cashDropFormConfig);

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"b6ROU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputByCriteria", ()=>(0, _inputByCriteria.InputByCriteria));
parcelHelpers.export(exports, "DynamicLookupFieldGroup", ()=>(0, _dynamicLookupFieldGroup.DynamicLookupFieldGroup));
parcelHelpers.export(exports, "DynamicDenominationsFieldGroup", ()=>(0, _dynamicDenominationsFieldGroup.DynamicDenominationsFieldGroup));
var _inputByCriteria = require("./input-by-criteria");
var _dynamicLookupFieldGroup = require("./dynamic-lookup-field-group");
var _dynamicDenominationsFieldGroup = require("./dynamic-denominations-field-group");

},{"./input-by-criteria":"aNRG9","./dynamic-lookup-field-group":"sPLfQ","./dynamic-denominations-field-group":"ezS18","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aNRG9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputByCriteria", ()=>InputByCriteria);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@rjsf/core");
var _coreDefault = parcelHelpers.interopDefault(_core);
var _rxjs = require("rxjs");
var _validator = require("../../utils/json-schema-validator/validator");
const InputByCriteria = ({ criteria = {}, criteriaGroupName, submitForm = (0, _rxjs.noop), formActions })=>{
    const { display_names, fields } = criteria;
    const properties = {
        type: "string",
        title: "Search by",
        enum: display_names
    };
    if (display_names.length === 1) properties.default = display_names[0];
    const oneOfConditions = fields.map((field)=>({
            properties: {
                criteria: {
                    enum: [
                        field.display_name
                    ]
                },
                [field.field_name]: {
                    type: "string",
                    title: field.display_name
                }
            },
            required: [
                field.field_name
            ]
        }));
    const schema = {
        title: criteriaGroupName,
        type: "object",
        properties: {
            criteria: properties
        },
        required: [
            "criteria"
        ],
        dependencies: {
            criteria: {
                oneOf: oneOfConditions
            }
        }
    };
    const uiSchema = {
        criteria: {
            "ui:widget": "radio",
            "ui:options": {
                inline: false
            }
        }
    };
    const handleSubmit = ({ formData })=>{
        /* Form data will look like
    // {
    //  criteria: 'Display Name',
    //  field_name: 'search input value',
    // } */ const currentFormDisplayName = formData.criteria;
        const fieldOption = criteria.fields.find((field)=>field.display_name === currentFormDisplayName);
        const criteriaSearchSlug = fieldOption.field_name;
        submitForm({
            key: criteriaSearchSlug,
            value: formData[criteriaSearchSlug]
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coreDefault.default), {
        schema: schema,
        uiSchema: uiSchema,
        validator: (0, _validator.defaultValidator),
        onSubmit: handleSubmit,
        children: formActions
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/core":"g03Jy","rxjs":"kbxjh","../../utils/json-schema-validator/validator":"dXyR8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g03Jy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withTheme", ()=>(0, _withThemeDefault.default));
parcelHelpers.export(exports, "getDefaultRegistry", ()=>(0, _getDefaultRegistryDefault.default));
var _form = require("./components/Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _withTheme = require("./withTheme");
var _withThemeDefault = parcelHelpers.interopDefault(_withTheme);
var _getDefaultRegistry = require("./getDefaultRegistry");
var _getDefaultRegistryDefault = parcelHelpers.interopDefault(_getDefaultRegistry);
exports.default = (0, _formDefault.default);

},{"./components/Form":"b1OIF","./withTheme":"2O1yt","./getDefaultRegistry":"dJxnW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"b1OIF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _pick = require("lodash/pick");
var _pickDefault = parcelHelpers.interopDefault(_pick);
var _toPath = require("lodash/toPath");
var _toPathDefault = parcelHelpers.interopDefault(_toPath);
var _getDefaultRegistry = require("../getDefaultRegistry");
var _getDefaultRegistryDefault = parcelHelpers.interopDefault(_getDefaultRegistry);
class Form extends (0, _react.Component) {
    /** Constructs the `Form` from the `props`. Will setup the initial state from the props. It will also call the
     * `onChange` handler if the initially provided `formData` is modified to add missing default values as part of the
     * state construction.
     *
     * @param props - The initial props for the `Form`
     */ constructor(props){
        super(props);
        /** Returns the `formData` with only the elements specified in the `fields` list
         *
         * @param formData - The data for the `Form`
         * @param fields - The fields to keep while filtering
         */ this.getUsedFormData = (formData, fields)=>{
            // For the case of a single input form
            if (fields.length === 0 && typeof formData !== "object") return formData;
            // _pick has incorrect type definition, it works with string[][], because lodash/hasIn supports it
            const data = (0, _pickDefault.default)(formData, fields);
            if (Array.isArray(formData)) return Object.keys(data).map((key)=>data[key]);
            return data;
        };
        /** Returns the list of field names from inspecting the `pathSchema` as well as using the `formData`
         *
         * @param pathSchema - The `PathSchema` object for the form
         * @param [formData] - The form data to use while checking for empty objects/arrays
         */ this.getFieldNames = (pathSchema, formData)=>{
            const getAllPaths = (_obj, acc = [], paths = [
                []
            ])=>{
                Object.keys(_obj).forEach((key)=>{
                    if (typeof _obj[key] === "object") {
                        const newPaths = paths.map((path)=>[
                                ...path,
                                key
                            ]);
                        // If an object is marked with additionalProperties, all its keys are valid
                        if (_obj[key][0, _utils.RJSF_ADDITONAL_PROPERTIES_FLAG] && _obj[key][0, _utils.NAME_KEY] !== "") acc.push(_obj[key][0, _utils.NAME_KEY]);
                        else getAllPaths(_obj[key], acc, newPaths);
                    } else if (key === (0, _utils.NAME_KEY) && _obj[key] !== "") paths.forEach((path)=>{
                        const formValue = (0, _getDefault.default)(formData, path);
                        // adds path to fieldNames if it points to a value
                        // or an empty object/array
                        if (typeof formValue !== "object" || (0, _isEmptyDefault.default)(formValue) || Array.isArray(formValue) && formValue.every((val)=>typeof val !== "object")) acc.push(path);
                    });
                });
                return acc;
            };
            return getAllPaths(pathSchema);
        };
        /** Function to handle changes made to a field in the `Form`. This handler receives an entirely new copy of the
         * `formData` along with a new `ErrorSchema`. It will first update the `formData` with any missing default fields and
         * then, if `omitExtraData` and `liveOmit` are turned on, the `formData` will be filterer to remove any extra data not
         * in a form field. Then, the resulting formData will be validated if required. The state will be updated with the new
         * updated (potentially filtered) `formData`, any errors that resulted from validation. Finally the `onChange`
         * callback will be called if specified with the updated state.
         *
         * @param formData - The new form data from a change to a field
         * @param newErrorSchema - The new `ErrorSchema` based on the field change
         * @param id - The id of the field that caused the change
         */ this.onChange = (formData, newErrorSchema, id)=>{
            const { extraErrors, omitExtraData, liveOmit, noValidate, liveValidate, onChange } = this.props;
            const { schemaUtils, schema, retrievedSchema } = this.state;
            if ((0, _utils.isObject)(formData) || Array.isArray(formData)) {
                const newState = this.getStateFromProps(this.props, formData, retrievedSchema);
                formData = newState.formData;
            }
            const mustValidate = !noValidate && liveValidate;
            let state = {
                formData,
                schema
            };
            let newFormData = formData;
            let _retrievedSchema;
            if (omitExtraData === true && liveOmit === true) {
                _retrievedSchema = schemaUtils.retrieveSchema(schema, formData);
                const pathSchema = schemaUtils.toPathSchema(_retrievedSchema, "", formData);
                const fieldNames = this.getFieldNames(pathSchema, formData);
                newFormData = this.getUsedFormData(formData, fieldNames);
                state = {
                    formData: newFormData
                };
            }
            if (mustValidate) {
                const schemaValidation = this.validate(newFormData, schema, schemaUtils, retrievedSchema);
                let errors = schemaValidation.errors;
                let errorSchema = schemaValidation.errorSchema;
                const schemaValidationErrors = errors;
                const schemaValidationErrorSchema = errorSchema;
                if (extraErrors) {
                    const merged = (0, _utils.validationDataMerge)(schemaValidation, extraErrors);
                    errorSchema = merged.errorSchema;
                    errors = merged.errors;
                }
                state = {
                    formData: newFormData,
                    errors,
                    errorSchema,
                    schemaValidationErrors,
                    schemaValidationErrorSchema
                };
            } else if (!noValidate && newErrorSchema) {
                const errorSchema = extraErrors ? (0, _utils.mergeObjects)(newErrorSchema, extraErrors, "preventDuplicates") : newErrorSchema;
                state = {
                    formData: newFormData,
                    errorSchema: errorSchema,
                    errors: (0, _utils.toErrorList)(errorSchema)
                };
            }
            if (_retrievedSchema) state.retrievedSchema = _retrievedSchema;
            this.setState(state, ()=>onChange && onChange({
                    ...this.state,
                    ...state
                }, id));
        };
        /**
         * Callback function to handle reset form data.
         * - Reset all fields with default values.
         * - Reset validations and errors
         *
         */ this.reset = ()=>{
            const { onChange } = this.props;
            const newState = this.getStateFromProps(this.props, undefined);
            const newFormData = newState.formData;
            const state = {
                formData: newFormData,
                errorSchema: {},
                errors: [],
                schemaValidationErrors: [],
                schemaValidationErrorSchema: {}
            };
            this.setState(state, ()=>onChange && onChange({
                    ...this.state,
                    ...state
                }));
        };
        /** Callback function to handle when a field on the form is blurred. Calls the `onBlur` callback for the `Form` if it
         * was provided.
         *
         * @param id - The unique `id` of the field that was blurred
         * @param data - The data associated with the field that was blurred
         */ this.onBlur = (id, data)=>{
            const { onBlur } = this.props;
            if (onBlur) onBlur(id, data);
        };
        /** Callback function to handle when a field on the form is focused. Calls the `onFocus` callback for the `Form` if it
         * was provided.
         *
         * @param id - The unique `id` of the field that was focused
         * @param data - The data associated with the field that was focused
         */ this.onFocus = (id, data)=>{
            const { onFocus } = this.props;
            if (onFocus) onFocus(id, data);
        };
        /** Callback function to handle when the form is submitted. First, it prevents the default event behavior. Nothing
         * happens if the target and currentTarget of the event are not the same. It will omit any extra data in the
         * `formData` in the state if `omitExtraData` is true. It will validate the resulting `formData`, reporting errors
         * via the `onError()` callback unless validation is disabled. Finally, it will add in any `extraErrors` and then call
         * back the `onSubmit` callback if it was provided.
         *
         * @param event - The submit HTML form event
         */ this.onSubmit = (event)=>{
            event.preventDefault();
            if (event.target !== event.currentTarget) return;
            event.persist();
            const { omitExtraData, extraErrors, noValidate, onSubmit } = this.props;
            let { formData: newFormData } = this.state;
            const { schema, schemaUtils } = this.state;
            if (omitExtraData === true) {
                const retrievedSchema = schemaUtils.retrieveSchema(schema, newFormData);
                const pathSchema = schemaUtils.toPathSchema(retrievedSchema, "", newFormData);
                const fieldNames = this.getFieldNames(pathSchema, newFormData);
                newFormData = this.getUsedFormData(newFormData, fieldNames);
            }
            if (noValidate || this.validateForm()) {
                // There are no errors generated through schema validation.
                // Check for user provided errors and update state accordingly.
                const errorSchema = extraErrors || {};
                const errors = extraErrors ? (0, _utils.toErrorList)(extraErrors) : [];
                this.setState({
                    formData: newFormData,
                    errors,
                    errorSchema,
                    schemaValidationErrors: [],
                    schemaValidationErrorSchema: {}
                }, ()=>{
                    if (onSubmit) onSubmit({
                        ...this.state,
                        formData: newFormData,
                        status: "submitted"
                    }, event);
                });
            }
        };
        /** Provides a function that can be used to programmatically submit the `Form` */ this.submit = ()=>{
            if (this.formElement.current) {
                const submitCustomEvent = new CustomEvent("submit", {
                    cancelable: true
                });
                submitCustomEvent.preventDefault();
                this.formElement.current.dispatchEvent(submitCustomEvent);
                this.formElement.current.requestSubmit();
            }
        };
        if (!props.validator) throw new Error("A validator is required for Form functionality to work");
        this.state = this.getStateFromProps(props, props.formData);
        if (this.props.onChange && !(0, _utils.deepEquals)(this.state.formData, this.props.formData)) this.props.onChange(this.state);
        this.formElement = (0, _react.createRef)();
    }
    /**
     * `getSnapshotBeforeUpdate` is a React lifecycle method that is invoked right before the most recently rendered
     * output is committed to the DOM. It enables your component to capture current values (e.g., scroll position) before
     * they are potentially changed.
     *
     * In this case, it checks if the props have changed since the last render. If they have, it computes the next state
     * of the component using `getStateFromProps` method and returns it along with a `shouldUpdate` flag set to `true` IF
     * the `nextState` and `prevState` are different, otherwise `false`. This ensures that we have the most up-to-date
     * state ready to be applied in `componentDidUpdate`.
     *
     * If `formData` hasn't changed, it simply returns an object with `shouldUpdate` set to `false`, indicating that a
     * state update is not necessary.
     *
     * @param prevProps - The previous set of props before the update.
     * @param prevState - The previous state before the update.
     * @returns Either an object containing the next state and a flag indicating that an update should occur, or an object
     *        with a flag indicating that an update is not necessary.
     */ getSnapshotBeforeUpdate(prevProps, prevState) {
        if (!(0, _utils.deepEquals)(this.props, prevProps)) {
            const isSchemaChanged = !(0, _utils.deepEquals)(prevProps.schema, this.props.schema);
            const isFormDataChanged = !(0, _utils.deepEquals)(prevProps.formData, this.props.formData);
            const nextState = this.getStateFromProps(this.props, this.props.formData, // If the `schema` has changed, we need to update the retrieved schema.
            // Or if the `formData` changes, for example in the case of a schema with dependencies that need to
            //  match one of the subSchemas, the retrieved schema must be updated.
            isSchemaChanged || isFormDataChanged ? undefined : this.state.retrievedSchema, isSchemaChanged);
            const shouldUpdate = !(0, _utils.deepEquals)(nextState, prevState);
            return {
                nextState,
                shouldUpdate
            };
        }
        return {
            shouldUpdate: false
        };
    }
    /**
     * `componentDidUpdate` is a React lifecycle method that is invoked immediately after updating occurs. This method is
     * not called for the initial render.
     *
     * Here, it checks if an update is necessary based on the `shouldUpdate` flag received from `getSnapshotBeforeUpdate`.
     * If an update is required, it applies the next state and, if needed, triggers the `onChange` handler to inform about
     * changes.
     *
     * This method effectively replaces the deprecated `UNSAFE_componentWillReceiveProps`, providing a safer alternative
     * to handle prop changes and state updates.
     *
     * @param _ - The previous set of props.
     * @param prevState - The previous state of the component before the update.
     * @param snapshot - The value returned from `getSnapshotBeforeUpdate`.
     */ componentDidUpdate(_, prevState, snapshot) {
        if (snapshot.shouldUpdate) {
            const { nextState } = snapshot;
            if (!(0, _utils.deepEquals)(nextState.formData, this.props.formData) && !(0, _utils.deepEquals)(nextState.formData, prevState.formData) && this.props.onChange) this.props.onChange(nextState);
            this.setState(nextState);
        }
    }
    /** Extracts the updated state from the given `props` and `inputFormData`. As part of this process, the
     * `inputFormData` is first processed to add any missing required defaults. After that, the data is run through the
     * validation process IF required by the `props`.
     *
     * @param props - The props passed to the `Form`
     * @param inputFormData - The new or current data for the `Form`
     * @param retrievedSchema - An expanded schema, if not provided, it will be retrieved from the `schema` and `formData`.
     * @param isSchemaChanged - A flag indicating whether the schema has changed.
     * @returns - The new state for the `Form`
     */ getStateFromProps(props, inputFormData, retrievedSchema, isSchemaChanged = false) {
        const state = this.state || {};
        const schema = "schema" in props ? props.schema : this.props.schema;
        const uiSchema = ("uiSchema" in props ? props.uiSchema : this.props.uiSchema) || {};
        const edit = typeof inputFormData !== "undefined";
        const liveValidate = "liveValidate" in props ? props.liveValidate : this.props.liveValidate;
        const mustValidate = edit && !props.noValidate && liveValidate;
        const rootSchema = schema;
        const experimental_defaultFormStateBehavior = "experimental_defaultFormStateBehavior" in props ? props.experimental_defaultFormStateBehavior : this.props.experimental_defaultFormStateBehavior;
        let schemaUtils = state.schemaUtils;
        if (!schemaUtils || schemaUtils.doesSchemaUtilsDiffer(props.validator, rootSchema, experimental_defaultFormStateBehavior)) schemaUtils = (0, _utils.createSchemaUtils)(props.validator, rootSchema, experimental_defaultFormStateBehavior);
        const formData = schemaUtils.getDefaultFormState(schema, inputFormData);
        const _retrievedSchema = retrievedSchema !== null && retrievedSchema !== void 0 ? retrievedSchema : schemaUtils.retrieveSchema(schema, formData);
        const getCurrentErrors = ()=>{
            // If the `props.noValidate` option is set or the schema has changed, we reset the error state.
            if (props.noValidate || isSchemaChanged) return {
                errors: [],
                errorSchema: {}
            };
            else if (!props.liveValidate) return {
                errors: state.schemaValidationErrors || [],
                errorSchema: state.schemaValidationErrorSchema || {}
            };
            return {
                errors: state.errors || [],
                errorSchema: state.errorSchema || {}
            };
        };
        let errors;
        let errorSchema;
        let schemaValidationErrors = state.schemaValidationErrors;
        let schemaValidationErrorSchema = state.schemaValidationErrorSchema;
        if (mustValidate) {
            const schemaValidation = this.validate(formData, schema, schemaUtils, _retrievedSchema);
            errors = schemaValidation.errors;
            errorSchema = schemaValidation.errorSchema;
            schemaValidationErrors = errors;
            schemaValidationErrorSchema = errorSchema;
        } else {
            const currentErrors = getCurrentErrors();
            errors = currentErrors.errors;
            errorSchema = currentErrors.errorSchema;
        }
        if (props.extraErrors) {
            const merged = (0, _utils.validationDataMerge)({
                errorSchema,
                errors
            }, props.extraErrors);
            errorSchema = merged.errorSchema;
            errors = merged.errors;
        }
        const idSchema = schemaUtils.toIdSchema(_retrievedSchema, uiSchema["ui:rootFieldId"], formData, props.idPrefix, props.idSeparator);
        const nextState = {
            schemaUtils,
            schema,
            uiSchema,
            idSchema,
            formData,
            edit,
            errors,
            errorSchema,
            schemaValidationErrors,
            schemaValidationErrorSchema,
            retrievedSchema: _retrievedSchema
        };
        return nextState;
    }
    /** React lifecycle method that is used to determine whether component should be updated.
     *
     * @param nextProps - The next version of the props
     * @param nextState - The next version of the state
     * @returns - True if the component should be updated, false otherwise
     */ shouldComponentUpdate(nextProps, nextState) {
        return (0, _utils.shouldRender)(this, nextProps, nextState);
    }
    /** Validates the `formData` against the `schema` using the `altSchemaUtils` (if provided otherwise it uses the
     * `schemaUtils` in the state), returning the results.
     *
     * @param formData - The new form data to validate
     * @param schema - The schema used to validate against
     * @param altSchemaUtils - The alternate schemaUtils to use for validation
     */ validate(formData, schema = this.props.schema, altSchemaUtils, retrievedSchema) {
        const schemaUtils = altSchemaUtils ? altSchemaUtils : this.state.schemaUtils;
        const { customValidate, transformErrors, uiSchema } = this.props;
        const resolvedSchema = retrievedSchema !== null && retrievedSchema !== void 0 ? retrievedSchema : schemaUtils.retrieveSchema(schema, formData);
        return schemaUtils.getValidator().validateFormData(formData, resolvedSchema, customValidate, transformErrors, uiSchema);
    }
    /** Renders any errors contained in the `state` in using the `ErrorList`, if not disabled by `showErrorList`. */ renderErrors(registry) {
        const { errors, errorSchema, schema, uiSchema } = this.state;
        const { formContext } = this.props;
        const options = (0, _utils.getUiOptions)(uiSchema);
        const ErrorListTemplate = (0, _utils.getTemplate)("ErrorListTemplate", registry, options);
        if (errors && errors.length) return (0, _jsxRuntime.jsx)(ErrorListTemplate, {
            errors: errors,
            errorSchema: errorSchema || {},
            schema: schema,
            uiSchema: uiSchema,
            formContext: formContext,
            registry: registry
        });
        return null;
    }
    /** Returns the registry for the form */ getRegistry() {
        var _a;
        const { translateString: customTranslateString, uiSchema = {} } = this.props;
        const { schemaUtils } = this.state;
        const { fields, templates, widgets, formContext, translateString } = (0, _getDefaultRegistryDefault.default)();
        return {
            fields: {
                ...fields,
                ...this.props.fields
            },
            templates: {
                ...templates,
                ...this.props.templates,
                ButtonTemplates: {
                    ...templates.ButtonTemplates,
                    ...(_a = this.props.templates) === null || _a === void 0 ? void 0 : _a.ButtonTemplates
                }
            },
            widgets: {
                ...widgets,
                ...this.props.widgets
            },
            rootSchema: this.props.schema,
            formContext: this.props.formContext || formContext,
            schemaUtils,
            translateString: customTranslateString || translateString,
            globalUiOptions: uiSchema[0, _utils.UI_GLOBAL_OPTIONS_KEY]
        };
    }
    /** Attempts to focus on the field associated with the `error`. Uses the `property` field to compute path of the error
     * field, then, using the `idPrefix` and `idSeparator` converts that path into an id. Then the input element with that
     * id is attempted to be found using the `formElement` ref. If it is located, then it is focused.
     *
     * @param error - The error on which to focus
     */ focusOnError(error) {
        const { idPrefix = "root", idSeparator = "_" } = this.props;
        const { property } = error;
        const path = (0, _toPathDefault.default)(property);
        if (path[0] === "") // Most of the time the `.foo` property results in the first element being empty, so replace it with the idPrefix
        path[0] = idPrefix;
        else // Otherwise insert the idPrefix into the first location using unshift
        path.unshift(idPrefix);
        const elementId = path.join(idSeparator);
        let field = this.formElement.current.elements[elementId];
        if (!field) // if not an exact match, try finding an input starting with the element id (like radio buttons or checkboxes)
        field = this.formElement.current.querySelector(`input[id^=${elementId}`);
        if (field && field.length) // If we got a list with length > 0
        field = field[0];
        if (field) field.focus();
    }
    /** Programmatically validate the form. If `onError` is provided, then it will be called with the list of errors the
     * same way as would happen on form submission.
     *
     * @returns - True if the form is valid, false otherwise.
     */ validateForm() {
        const { extraErrors, extraErrorsBlockSubmit, focusOnFirstError, onError } = this.props;
        const { formData, errors: prevErrors } = this.state;
        const schemaValidation = this.validate(formData);
        let errors = schemaValidation.errors;
        let errorSchema = schemaValidation.errorSchema;
        const schemaValidationErrors = errors;
        const schemaValidationErrorSchema = errorSchema;
        const hasError = errors.length > 0 || extraErrors && extraErrorsBlockSubmit;
        if (hasError) {
            if (extraErrors) {
                const merged = (0, _utils.validationDataMerge)(schemaValidation, extraErrors);
                errorSchema = merged.errorSchema;
                errors = merged.errors;
            }
            if (focusOnFirstError) {
                if (typeof focusOnFirstError === "function") focusOnFirstError(errors[0]);
                else this.focusOnError(errors[0]);
            }
            this.setState({
                errors,
                errorSchema,
                schemaValidationErrors,
                schemaValidationErrorSchema
            }, ()=>{
                if (onError) onError(errors);
                else console.error("Form validation failed", errors);
            });
        } else if (prevErrors.length > 0) this.setState({
            errors: [],
            errorSchema: {},
            schemaValidationErrors: [],
            schemaValidationErrorSchema: {}
        });
        return !hasError;
    }
    /** Renders the `Form` fields inside the <form> | `tagName` or `_internalFormWrapper`, rendering any errors if
     * needed along with the submit button or any children of the form.
     */ render() {
        const { children, id, idPrefix, idSeparator, className = "", tagName, name, method, target, action, autoComplete, enctype, acceptcharset, noHtml5Validate = false, disabled = false, readonly = false, formContext, showErrorList = "top", _internalFormWrapper } = this.props;
        const { schema, uiSchema, formData, errorSchema, idSchema } = this.state;
        const registry = this.getRegistry();
        const { SchemaField: _SchemaField } = registry.fields;
        const { SubmitButton } = registry.templates.ButtonTemplates;
        // The `semantic-ui` and `material-ui` themes have `_internalFormWrapper`s that take an `as` prop that is the
        // PropTypes.elementType to use for the inner tag, so we'll need to pass `tagName` along if it is provided.
        // NOTE, the `as` prop is native to `semantic-ui` and is emulated in the `material-ui` theme
        const as = _internalFormWrapper ? tagName : undefined;
        const FormTag = _internalFormWrapper || tagName || "form";
        let { [(0, _utils.SUBMIT_BTN_OPTIONS_KEY)]: submitOptions = {} } = (0, _utils.getUiOptions)(uiSchema);
        if (disabled) submitOptions = {
            ...submitOptions,
            props: {
                ...submitOptions.props,
                disabled: true
            }
        };
        const submitUiSchema = {
            [(0, _utils.UI_OPTIONS_KEY)]: {
                [(0, _utils.SUBMIT_BTN_OPTIONS_KEY)]: submitOptions
            }
        };
        return (0, _jsxRuntime.jsxs)(FormTag, {
            className: className ? className : "rjsf",
            id: id,
            name: name,
            method: method,
            target: target,
            action: action,
            autoComplete: autoComplete,
            encType: enctype,
            acceptCharset: acceptcharset,
            noValidate: noHtml5Validate,
            onSubmit: this.onSubmit,
            as: as,
            ref: this.formElement,
            children: [
                showErrorList === "top" && this.renderErrors(registry),
                (0, _jsxRuntime.jsx)(_SchemaField, {
                    name: "",
                    schema: schema,
                    uiSchema: uiSchema,
                    errorSchema: errorSchema,
                    idSchema: idSchema,
                    idPrefix: idPrefix,
                    idSeparator: idSeparator,
                    formContext: formContext,
                    formData: formData,
                    onChange: this.onChange,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    registry: registry,
                    disabled: disabled,
                    readonly: readonly
                }),
                children ? children : (0, _jsxRuntime.jsx)(SubmitButton, {
                    uiSchema: submitUiSchema,
                    registry: registry
                }),
                showErrorList === "bottom" && this.renderErrors(registry)
            ]
        });
    }
}
exports.default = Form;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","lodash/get":"g5ox6","lodash/isEmpty":"c3uBm","lodash/pick":"4ZUxZ","lodash/toPath":"hWzOh","../getDefaultRegistry":"dJxnW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"joqWx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "allowAdditionalItems", ()=>(0, _allowAdditionalItemsDefault.default));
parcelHelpers.export(exports, "ariaDescribedByIds", ()=>(0, _idGenerators.ariaDescribedByIds));
parcelHelpers.export(exports, "asNumber", ()=>(0, _asNumberDefault.default));
parcelHelpers.export(exports, "canExpand", ()=>(0, _canExpandDefault.default));
parcelHelpers.export(exports, "createErrorHandler", ()=>(0, _createErrorHandlerDefault.default));
parcelHelpers.export(exports, "createSchemaUtils", ()=>(0, _createSchemaUtilsDefault.default));
parcelHelpers.export(exports, "dataURItoBlob", ()=>(0, _dataURItoBlobDefault.default));
parcelHelpers.export(exports, "deepEquals", ()=>(0, _deepEqualsDefault.default));
parcelHelpers.export(exports, "descriptionId", ()=>(0, _idGenerators.descriptionId));
parcelHelpers.export(exports, "englishStringTranslator", ()=>(0, _englishStringTranslatorDefault.default));
parcelHelpers.export(exports, "enumOptionsDeselectValue", ()=>(0, _enumOptionsDeselectValueDefault.default));
parcelHelpers.export(exports, "enumOptionsIndexForValue", ()=>(0, _enumOptionsIndexForValueDefault.default));
parcelHelpers.export(exports, "enumOptionsIsSelected", ()=>(0, _enumOptionsIsSelectedDefault.default));
parcelHelpers.export(exports, "enumOptionsSelectValue", ()=>(0, _enumOptionsSelectValueDefault.default));
parcelHelpers.export(exports, "enumOptionsValueForIndex", ()=>(0, _enumOptionsValueForIndexDefault.default));
parcelHelpers.export(exports, "errorId", ()=>(0, _idGenerators.errorId));
parcelHelpers.export(exports, "examplesId", ()=>(0, _idGenerators.examplesId));
parcelHelpers.export(exports, "ErrorSchemaBuilder", ()=>(0, _errorSchemaBuilderDefault.default));
parcelHelpers.export(exports, "findSchemaDefinition", ()=>(0, _findSchemaDefinitionDefault.default));
parcelHelpers.export(exports, "getDateElementProps", ()=>(0, _getDateElementPropsDefault.default));
parcelHelpers.export(exports, "getDiscriminatorFieldFromSchema", ()=>(0, _getDiscriminatorFieldFromSchemaDefault.default));
parcelHelpers.export(exports, "getInputProps", ()=>(0, _getInputPropsDefault.default));
parcelHelpers.export(exports, "getOptionMatchingSimpleDiscriminator", ()=>(0, _getOptionMatchingSimpleDiscriminatorDefault.default));
parcelHelpers.export(exports, "getSchemaType", ()=>(0, _getSchemaTypeDefault.default));
parcelHelpers.export(exports, "getSubmitButtonOptions", ()=>(0, _getSubmitButtonOptionsDefault.default));
parcelHelpers.export(exports, "getTemplate", ()=>(0, _getTemplateDefault.default));
parcelHelpers.export(exports, "getUiOptions", ()=>(0, _getUiOptionsDefault.default));
parcelHelpers.export(exports, "getWidget", ()=>(0, _getWidgetDefault.default));
parcelHelpers.export(exports, "guessType", ()=>(0, _guessTypeDefault.default));
parcelHelpers.export(exports, "hasWidget", ()=>(0, _hasWidgetDefault.default));
parcelHelpers.export(exports, "hashForSchema", ()=>(0, _hashForSchemaDefault.default));
parcelHelpers.export(exports, "helpId", ()=>(0, _idGenerators.helpId));
parcelHelpers.export(exports, "isConstant", ()=>(0, _isConstantDefault.default));
parcelHelpers.export(exports, "isCustomWidget", ()=>(0, _isCustomWidgetDefault.default));
parcelHelpers.export(exports, "isFixedItems", ()=>(0, _isFixedItemsDefault.default));
parcelHelpers.export(exports, "isObject", ()=>(0, _isObjectDefault.default));
parcelHelpers.export(exports, "labelValue", ()=>(0, _labelValueDefault.default));
parcelHelpers.export(exports, "localToUTC", ()=>(0, _localToUTCDefault.default));
parcelHelpers.export(exports, "mergeDefaultsWithFormData", ()=>(0, _mergeDefaultsWithFormDataDefault.default));
parcelHelpers.export(exports, "mergeObjects", ()=>(0, _mergeObjectsDefault.default));
parcelHelpers.export(exports, "mergeSchemas", ()=>(0, _mergeSchemasDefault.default));
parcelHelpers.export(exports, "optionId", ()=>(0, _idGenerators.optionId));
parcelHelpers.export(exports, "optionsList", ()=>(0, _optionsListDefault.default));
parcelHelpers.export(exports, "orderProperties", ()=>(0, _orderPropertiesDefault.default));
parcelHelpers.export(exports, "pad", ()=>(0, _padDefault.default));
parcelHelpers.export(exports, "parseDateString", ()=>(0, _parseDateStringDefault.default));
parcelHelpers.export(exports, "rangeSpec", ()=>(0, _rangeSpecDefault.default));
parcelHelpers.export(exports, "replaceStringParameters", ()=>(0, _replaceStringParametersDefault.default));
parcelHelpers.export(exports, "schemaRequiresTrueValue", ()=>(0, _schemaRequiresTrueValueDefault.default));
parcelHelpers.export(exports, "shouldRender", ()=>(0, _shouldRenderDefault.default));
parcelHelpers.export(exports, "titleId", ()=>(0, _idGenerators.titleId));
parcelHelpers.export(exports, "toConstant", ()=>(0, _toConstantDefault.default));
parcelHelpers.export(exports, "toDateString", ()=>(0, _toDateStringDefault.default));
parcelHelpers.export(exports, "toErrorList", ()=>(0, _toErrorListDefault.default));
parcelHelpers.export(exports, "toErrorSchema", ()=>(0, _toErrorSchemaDefault.default));
parcelHelpers.export(exports, "unwrapErrorHandler", ()=>(0, _unwrapErrorHandlerDefault.default));
parcelHelpers.export(exports, "utcToLocal", ()=>(0, _utcToLocalDefault.default));
parcelHelpers.export(exports, "validationDataMerge", ()=>(0, _validationDataMergeDefault.default));
parcelHelpers.export(exports, "withIdRefPrefix", ()=>(0, _withIdRefPrefixDefault.default));
var _allowAdditionalItems = require("./allowAdditionalItems");
var _allowAdditionalItemsDefault = parcelHelpers.interopDefault(_allowAdditionalItems);
var _asNumber = require("./asNumber");
var _asNumberDefault = parcelHelpers.interopDefault(_asNumber);
var _canExpand = require("./canExpand");
var _canExpandDefault = parcelHelpers.interopDefault(_canExpand);
var _createErrorHandler = require("./createErrorHandler");
var _createErrorHandlerDefault = parcelHelpers.interopDefault(_createErrorHandler);
var _createSchemaUtils = require("./createSchemaUtils");
var _createSchemaUtilsDefault = parcelHelpers.interopDefault(_createSchemaUtils);
var _dataURItoBlob = require("./dataURItoBlob");
var _dataURItoBlobDefault = parcelHelpers.interopDefault(_dataURItoBlob);
var _deepEquals = require("./deepEquals");
var _deepEqualsDefault = parcelHelpers.interopDefault(_deepEquals);
var _englishStringTranslator = require("./englishStringTranslator");
var _englishStringTranslatorDefault = parcelHelpers.interopDefault(_englishStringTranslator);
var _enumOptionsDeselectValue = require("./enumOptionsDeselectValue");
var _enumOptionsDeselectValueDefault = parcelHelpers.interopDefault(_enumOptionsDeselectValue);
var _enumOptionsIndexForValue = require("./enumOptionsIndexForValue");
var _enumOptionsIndexForValueDefault = parcelHelpers.interopDefault(_enumOptionsIndexForValue);
var _enumOptionsIsSelected = require("./enumOptionsIsSelected");
var _enumOptionsIsSelectedDefault = parcelHelpers.interopDefault(_enumOptionsIsSelected);
var _enumOptionsSelectValue = require("./enumOptionsSelectValue");
var _enumOptionsSelectValueDefault = parcelHelpers.interopDefault(_enumOptionsSelectValue);
var _enumOptionsValueForIndex = require("./enumOptionsValueForIndex");
var _enumOptionsValueForIndexDefault = parcelHelpers.interopDefault(_enumOptionsValueForIndex);
var _errorSchemaBuilder = require("./ErrorSchemaBuilder");
var _errorSchemaBuilderDefault = parcelHelpers.interopDefault(_errorSchemaBuilder);
var _findSchemaDefinition = require("./findSchemaDefinition");
var _findSchemaDefinitionDefault = parcelHelpers.interopDefault(_findSchemaDefinition);
var _getDateElementProps = require("./getDateElementProps");
var _getDateElementPropsDefault = parcelHelpers.interopDefault(_getDateElementProps);
var _getDiscriminatorFieldFromSchema = require("./getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _getInputProps = require("./getInputProps");
var _getInputPropsDefault = parcelHelpers.interopDefault(_getInputProps);
var _getSchemaType = require("./getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
var _getSubmitButtonOptions = require("./getSubmitButtonOptions");
var _getSubmitButtonOptionsDefault = parcelHelpers.interopDefault(_getSubmitButtonOptions);
var _getTemplate = require("./getTemplate");
var _getTemplateDefault = parcelHelpers.interopDefault(_getTemplate);
var _getUiOptions = require("./getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
var _getWidget = require("./getWidget");
var _getWidgetDefault = parcelHelpers.interopDefault(_getWidget);
var _guessType = require("./guessType");
var _guessTypeDefault = parcelHelpers.interopDefault(_guessType);
var _hashForSchema = require("./hashForSchema");
var _hashForSchemaDefault = parcelHelpers.interopDefault(_hashForSchema);
var _hasWidget = require("./hasWidget");
var _hasWidgetDefault = parcelHelpers.interopDefault(_hasWidget);
var _idGenerators = require("./idGenerators");
var _isConstant = require("./isConstant");
var _isConstantDefault = parcelHelpers.interopDefault(_isConstant);
var _isCustomWidget = require("./isCustomWidget");
var _isCustomWidgetDefault = parcelHelpers.interopDefault(_isCustomWidget);
var _isFixedItems = require("./isFixedItems");
var _isFixedItemsDefault = parcelHelpers.interopDefault(_isFixedItems);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _labelValue = require("./labelValue");
var _labelValueDefault = parcelHelpers.interopDefault(_labelValue);
var _localToUTC = require("./localToUTC");
var _localToUTCDefault = parcelHelpers.interopDefault(_localToUTC);
var _mergeDefaultsWithFormData = require("./mergeDefaultsWithFormData");
var _mergeDefaultsWithFormDataDefault = parcelHelpers.interopDefault(_mergeDefaultsWithFormData);
var _mergeObjects = require("./mergeObjects");
var _mergeObjectsDefault = parcelHelpers.interopDefault(_mergeObjects);
var _mergeSchemas = require("./mergeSchemas");
var _mergeSchemasDefault = parcelHelpers.interopDefault(_mergeSchemas);
var _optionsList = require("./optionsList");
var _optionsListDefault = parcelHelpers.interopDefault(_optionsList);
var _orderProperties = require("./orderProperties");
var _orderPropertiesDefault = parcelHelpers.interopDefault(_orderProperties);
var _pad = require("./pad");
var _padDefault = parcelHelpers.interopDefault(_pad);
var _parseDateString = require("./parseDateString");
var _parseDateStringDefault = parcelHelpers.interopDefault(_parseDateString);
var _rangeSpec = require("./rangeSpec");
var _rangeSpecDefault = parcelHelpers.interopDefault(_rangeSpec);
var _replaceStringParameters = require("./replaceStringParameters");
var _replaceStringParametersDefault = parcelHelpers.interopDefault(_replaceStringParameters);
var _schemaRequiresTrueValue = require("./schemaRequiresTrueValue");
var _schemaRequiresTrueValueDefault = parcelHelpers.interopDefault(_schemaRequiresTrueValue);
var _shouldRender = require("./shouldRender");
var _shouldRenderDefault = parcelHelpers.interopDefault(_shouldRender);
var _toConstant = require("./toConstant");
var _toConstantDefault = parcelHelpers.interopDefault(_toConstant);
var _toDateString = require("./toDateString");
var _toDateStringDefault = parcelHelpers.interopDefault(_toDateString);
var _toErrorList = require("./toErrorList");
var _toErrorListDefault = parcelHelpers.interopDefault(_toErrorList);
var _toErrorSchema = require("./toErrorSchema");
var _toErrorSchemaDefault = parcelHelpers.interopDefault(_toErrorSchema);
var _unwrapErrorHandler = require("./unwrapErrorHandler");
var _unwrapErrorHandlerDefault = parcelHelpers.interopDefault(_unwrapErrorHandler);
var _utcToLocal = require("./utcToLocal");
var _utcToLocalDefault = parcelHelpers.interopDefault(_utcToLocal);
var _validationDataMerge = require("./validationDataMerge");
var _validationDataMergeDefault = parcelHelpers.interopDefault(_validationDataMerge);
var _withIdRefPrefix = require("./withIdRefPrefix");
var _withIdRefPrefixDefault = parcelHelpers.interopDefault(_withIdRefPrefix);
var _getOptionMatchingSimpleDiscriminator = require("./getOptionMatchingSimpleDiscriminator");
var _getOptionMatchingSimpleDiscriminatorDefault = parcelHelpers.interopDefault(_getOptionMatchingSimpleDiscriminator);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _enums = require("./enums");
parcelHelpers.exportAll(_enums, exports);
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _parser = require("./parser");
parcelHelpers.exportAll(_parser, exports);
var _schema = require("./schema");
parcelHelpers.exportAll(_schema, exports);

},{"./allowAdditionalItems":"5zgxP","./asNumber":"gElnp","./canExpand":"810PS","./createErrorHandler":"5Hf25","./createSchemaUtils":"iIpJC","./dataURItoBlob":"4AvYk","./deepEquals":"5U4lj","./englishStringTranslator":"2SFey","./enumOptionsDeselectValue":"alqw9","./enumOptionsIndexForValue":"l4wNs","./enumOptionsIsSelected":"fkR0n","./enumOptionsSelectValue":"inCLa","./enumOptionsValueForIndex":"kRkuH","./ErrorSchemaBuilder":"3FcmL","./findSchemaDefinition":"cMrNB","./getDateElementProps":"dt9os","./getDiscriminatorFieldFromSchema":"lULGM","./getInputProps":"57fhF","./getSchemaType":"Po4xY","./getSubmitButtonOptions":"j3wmP","./getTemplate":"4Pj31","./getUiOptions":"5pjcb","./getWidget":"e8fAZ","./guessType":"Qabco","./hashForSchema":"hGAwf","./hasWidget":"2ZiZm","./idGenerators":"5CuCJ","./isConstant":"njn20","./isCustomWidget":"fPdiF","./isFixedItems":"eBu8s","./isObject":"9dcnp","./labelValue":"clCtK","./localToUTC":"fC2MV","./mergeDefaultsWithFormData":"64T3g","./mergeObjects":"63YAa","./mergeSchemas":"dxsEQ","./optionsList":"diDQO","./orderProperties":"c3VvF","./pad":"iODBK","./parseDateString":"djJ8R","./rangeSpec":"fA7pp","./replaceStringParameters":"jVPf8","./schemaRequiresTrueValue":"iFtYs","./shouldRender":"aSGyU","./toConstant":"7eDq5","./toDateString":"15SvM","./toErrorList":"gTnhe","./toErrorSchema":"3KTWd","./unwrapErrorHandler":"jDav4","./utcToLocal":"8I0KT","./validationDataMerge":"1KTMq","./withIdRefPrefix":"cQ3jv","./getOptionMatchingSimpleDiscriminator":"d39Bz","./types":"he9xI","./enums":"fM0s1","./constants":"7SuQb","./parser":"cJlLS","./schema":"2iJHF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5zgxP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>allowAdditionalItems);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function allowAdditionalItems(schema) {
    if (schema.additionalItems === true) console.warn("additionalItems=true is currently not supported");
    return (0, _isObjectDefault.default)(schema.additionalItems);
}

},{"./isObject":"9dcnp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9dcnp":[function(require,module,exports) {
/** Determines whether a `thing` is an object for the purposes of RSJF. In this case, `thing` is an object if it has
 * the type `object` but is NOT null, an array or a File.
 *
 * @param thing - The thing to check to see whether it is an object
 * @returns - True if it is a non-null, non-array, non-File object
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isObject);
function isObject(thing) {
    if (typeof File !== "undefined" && thing instanceof File) return false;
    if (typeof Date !== "undefined" && thing instanceof Date) return false;
    return typeof thing === "object" && thing !== null && !Array.isArray(thing);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gElnp":[function(require,module,exports) {
/** Attempts to convert the string into a number. If an empty string is provided, then `undefined` is returned. If a
 * `null` is provided, it is returned. If the string ends in a `.` then the string is returned because the user may be
 * in the middle of typing a float number. If a number ends in a pattern like `.0`, `.20`, `.030`, string is returned
 * because the user may be typing number that will end in a non-zero digit. Otherwise, the string is wrapped by
 * `Number()` and if that result is not `NaN`, that number will be returned, otherwise the string `value` will be.
 *
 * @param value - The string or null value to convert to a number
 * @returns - The `value` converted to a number when appropriate, otherwise the `value`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>asNumber);
function asNumber(value) {
    if (value === "") return undefined;
    if (value === null) return null;
    if (/\.$/.test(value)) // '3.' can't really be considered a number even if it parses in js. The
    // user is most likely entering a float.
    return value;
    if (/\.0$/.test(value)) // we need to return this as a string here, to allow for input like 3.07
    return value;
    if (/\.\d*0$/.test(value)) // It's a number, that's cool - but we need it as a string so it doesn't screw
    // with the user when entering dollar amounts or other values (such as those with
    // specific precision or number of significant digits)
    return value;
    const n = Number(value);
    const valid = typeof n === "number" && !Number.isNaN(n);
    return valid ? n : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"810PS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>canExpand);
var _getUiOptions = require("./getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
function canExpand(schema, uiSchema = {}, formData) {
    if (!schema.additionalProperties) return false;
    const { expandable = true } = (0, _getUiOptionsDefault.default)(uiSchema);
    if (expandable === false) return expandable;
    // if ui:options.expandable was not explicitly set to false, we can add
    // another property if we have not exceeded maxProperties yet
    if (schema.maxProperties !== undefined && formData) return Object.keys(formData).length < schema.maxProperties;
    return true;
}

},{"./getUiOptions":"5pjcb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5pjcb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUiOptions);
var _constants = require("./constants");
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function getUiOptions(uiSchema = {}, globalOptions = {}) {
    return Object.keys(uiSchema).filter((key)=>key.indexOf("ui:") === 0).reduce((options, key)=>{
        const value = uiSchema[key];
        if (key === (0, _constants.UI_WIDGET_KEY) && (0, _isObjectDefault.default)(value)) {
            console.error("Setting options via ui:widget object is no longer supported, use ui:options instead");
            return options;
        }
        if (key === (0, _constants.UI_OPTIONS_KEY) && (0, _isObjectDefault.default)(value)) return {
            ...options,
            ...value
        };
        return {
            ...options,
            [key.substring(3)]: value
        };
    }, {
        ...globalOptions
    });
}

},{"./constants":"7SuQb","./isObject":"9dcnp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7SuQb":[function(require,module,exports) {
/** Below are the list of all the keys into various elements of a RJSFSchema or UiSchema that are used by the various
 * utility functions. In addition to those keys, there are the special `ADDITIONAL_PROPERTY_FLAG` and
 * `RJSF_ADDITONAL_PROPERTIES_FLAG` flags that is added to a schema under certain conditions by the `retrieveSchema()`
 * utility.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADDITIONAL_PROPERTY_FLAG", ()=>ADDITIONAL_PROPERTY_FLAG);
parcelHelpers.export(exports, "ADDITIONAL_PROPERTIES_KEY", ()=>ADDITIONAL_PROPERTIES_KEY);
parcelHelpers.export(exports, "ALL_OF_KEY", ()=>ALL_OF_KEY);
parcelHelpers.export(exports, "ANY_OF_KEY", ()=>ANY_OF_KEY);
parcelHelpers.export(exports, "CONST_KEY", ()=>CONST_KEY);
parcelHelpers.export(exports, "DEFAULT_KEY", ()=>DEFAULT_KEY);
parcelHelpers.export(exports, "DEFINITIONS_KEY", ()=>DEFINITIONS_KEY);
parcelHelpers.export(exports, "DEPENDENCIES_KEY", ()=>DEPENDENCIES_KEY);
parcelHelpers.export(exports, "ENUM_KEY", ()=>ENUM_KEY);
parcelHelpers.export(exports, "ERRORS_KEY", ()=>ERRORS_KEY);
parcelHelpers.export(exports, "ID_KEY", ()=>ID_KEY);
parcelHelpers.export(exports, "IF_KEY", ()=>IF_KEY);
parcelHelpers.export(exports, "ITEMS_KEY", ()=>ITEMS_KEY);
parcelHelpers.export(exports, "JUNK_OPTION_ID", ()=>JUNK_OPTION_ID);
parcelHelpers.export(exports, "NAME_KEY", ()=>NAME_KEY);
parcelHelpers.export(exports, "ONE_OF_KEY", ()=>ONE_OF_KEY);
parcelHelpers.export(exports, "PROPERTIES_KEY", ()=>PROPERTIES_KEY);
parcelHelpers.export(exports, "REQUIRED_KEY", ()=>REQUIRED_KEY);
parcelHelpers.export(exports, "SUBMIT_BTN_OPTIONS_KEY", ()=>SUBMIT_BTN_OPTIONS_KEY);
parcelHelpers.export(exports, "REF_KEY", ()=>REF_KEY);
parcelHelpers.export(exports, "RJSF_ADDITONAL_PROPERTIES_FLAG", ()=>RJSF_ADDITONAL_PROPERTIES_FLAG);
parcelHelpers.export(exports, "ROOT_SCHEMA_PREFIX", ()=>ROOT_SCHEMA_PREFIX);
parcelHelpers.export(exports, "UI_FIELD_KEY", ()=>UI_FIELD_KEY);
parcelHelpers.export(exports, "UI_WIDGET_KEY", ()=>UI_WIDGET_KEY);
parcelHelpers.export(exports, "UI_OPTIONS_KEY", ()=>UI_OPTIONS_KEY);
parcelHelpers.export(exports, "UI_GLOBAL_OPTIONS_KEY", ()=>UI_GLOBAL_OPTIONS_KEY);
const ADDITIONAL_PROPERTY_FLAG = "__additional_property";
const ADDITIONAL_PROPERTIES_KEY = "additionalProperties";
const ALL_OF_KEY = "allOf";
const ANY_OF_KEY = "anyOf";
const CONST_KEY = "const";
const DEFAULT_KEY = "default";
const DEFINITIONS_KEY = "definitions";
const DEPENDENCIES_KEY = "dependencies";
const ENUM_KEY = "enum";
const ERRORS_KEY = "__errors";
const ID_KEY = "$id";
const IF_KEY = "if";
const ITEMS_KEY = "items";
const JUNK_OPTION_ID = "_$junk_option_schema_id$_";
const NAME_KEY = "$name";
const ONE_OF_KEY = "oneOf";
const PROPERTIES_KEY = "properties";
const REQUIRED_KEY = "required";
const SUBMIT_BTN_OPTIONS_KEY = "submitButtonOptions";
const REF_KEY = "$ref";
const RJSF_ADDITONAL_PROPERTIES_FLAG = "__rjsf_additionalProperties";
const ROOT_SCHEMA_PREFIX = "__rjsf_rootSchema";
const UI_FIELD_KEY = "ui:field";
const UI_WIDGET_KEY = "ui:widget";
const UI_OPTIONS_KEY = "ui:options";
const UI_GLOBAL_OPTIONS_KEY = "ui:globalOptions";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5Hf25":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createErrorHandler);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _constants = require("./constants");
function createErrorHandler(formData) {
    const handler = {
        // We store the list of errors for this node in a property named __errors
        // to avoid name collision with a possible sub schema field named
        // 'errors' (see `utils.toErrorSchema`).
        [(0, _constants.ERRORS_KEY)]: [],
        addError (message) {
            this[0, _constants.ERRORS_KEY].push(message);
        }
    };
    if (Array.isArray(formData)) return formData.reduce((acc, value, key)=>{
        return {
            ...acc,
            [key]: createErrorHandler(value)
        };
    }, handler);
    if ((0, _isPlainObjectDefault.default)(formData)) {
        const formObject = formData;
        return Object.keys(formObject).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: createErrorHandler(formObject[key])
            };
        }, handler);
    }
    return handler;
}

},{"lodash/isPlainObject":"g5UGm","./constants":"7SuQb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g5UGm":[function(require,module,exports) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"a1nlZ","2ca5b85a120835de":"4IYkl","963b65e043435612":"17Pxd"}],"a1nlZ":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"gjsRy","9b2aaf31b7bdd837":"iCJR3","46d5beb3375f8a28":"ewd8E"}],"gjsRy":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"7fHqO"}],"7fHqO":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"20wQX"}],"20wQX":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"iCJR3":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"gjsRy"}],"ewd8E":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"4IYkl":[function(require,module,exports) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"UfyfF"}],"UfyfF":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"17Pxd":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"iIpJC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSchemaUtils);
var _deepEquals = require("./deepEquals");
var _deepEqualsDefault = parcelHelpers.interopDefault(_deepEquals);
var _schema = require("./schema");
/** The `SchemaUtils` class provides a wrapper around the publicly exported APIs in the `utils/schema` directory such
 * that one does not have to explicitly pass the `validator`, `rootSchema`, or `experimental_defaultFormStateBehavior` to each method.
 * Since these generally do not change across a `Form`, this allows for providing a simplified set of APIs to the
 * `@rjsf/core` components and the various themes as well. This class implements the `SchemaUtilsType` interface.
 */ class SchemaUtils {
    /** Constructs the `SchemaUtils` instance with the given `validator` and `rootSchema` stored as instance variables
     *
     * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
     * @param rootSchema - The root schema that will be forwarded to all the APIs
     * @param experimental_defaultFormStateBehavior - Configuration flags to allow users to override default form state behavior
     */ constructor(validator, rootSchema, experimental_defaultFormStateBehavior){
        this.rootSchema = rootSchema;
        this.validator = validator;
        this.experimental_defaultFormStateBehavior = experimental_defaultFormStateBehavior;
    }
    /** Returns the `ValidatorType` in the `SchemaUtilsType`
     *
     * @returns - The `ValidatorType`
     */ getValidator() {
        return this.validator;
    }
    /** Determines whether either the `validator` and `rootSchema` differ from the ones associated with this instance of
     * the `SchemaUtilsType`. If either `validator` or `rootSchema` are falsy, then return false to prevent the creation
     * of a new `SchemaUtilsType` with incomplete properties.
     *
     * @param validator - An implementation of the `ValidatorType` interface that will be compared against the current one
     * @param rootSchema - The root schema that will be compared against the current one
     * @param [experimental_defaultFormStateBehavior] Optional configuration object, if provided, allows users to override default form state behavior
     * @returns - True if the `SchemaUtilsType` differs from the given `validator` or `rootSchema`
     */ doesSchemaUtilsDiffer(validator, rootSchema, experimental_defaultFormStateBehavior = {}) {
        if (!validator || !rootSchema) return false;
        return this.validator !== validator || !(0, _deepEqualsDefault.default)(this.rootSchema, rootSchema) || !(0, _deepEqualsDefault.default)(this.experimental_defaultFormStateBehavior, experimental_defaultFormStateBehavior);
    }
    /** Returns the superset of `formData` that includes the given set updated to include any missing fields that have
     * computed to have defaults provided in the `schema`.
     *
     * @param schema - The schema for which the default state is desired
     * @param [formData] - The current formData, if any, onto which to provide any missing defaults
     * @param [includeUndefinedValues=false] - Optional flag, if true, cause undefined values to be added as defaults.
     *          If "excludeObjectChildren", pass `includeUndefinedValues` as false when computing defaults for any nested
     *          object properties.
     * @returns - The resulting `formData` with all the defaults provided
     */ getDefaultFormState(schema, formData, includeUndefinedValues = false) {
        return (0, _schema.getDefaultFormState)(this.validator, schema, formData, this.rootSchema, includeUndefinedValues, this.experimental_defaultFormStateBehavior);
    }
    /** Determines whether the combination of `schema` and `uiSchema` properties indicates that the label for the `schema`
     * should be displayed in a UI.
     *
     * @param schema - The schema for which the display label flag is desired
     * @param [uiSchema] - The UI schema from which to derive potentially displayable information
     * @param [globalOptions={}] - The optional Global UI Schema from which to get any fallback `xxx` options
     * @returns - True if the label should be displayed or false if it should not
     */ getDisplayLabel(schema, uiSchema, globalOptions) {
        return (0, _schema.getDisplayLabel)(this.validator, schema, uiSchema, this.rootSchema, globalOptions);
    }
    /** Determines which of the given `options` provided most closely matches the `formData`.
     * Returns the index of the option that is valid and is the closest match, or 0 if there is no match.
     *
     * The closest match is determined using the number of matching properties, and more heavily favors options with
     * matching readOnly, default, or const values.
     *
     * @param formData - The form data associated with the schema
     * @param options - The list of options that can be selected from
     * @param [selectedOption] - The index of the currently selected option, defaulted to -1 if not specified
     * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
     *          determine which option is selected
     * @returns - The index of the option that is the closest match to the `formData` or the `selectedOption` if no match
     */ getClosestMatchingOption(formData, options, selectedOption, discriminatorField) {
        return (0, _schema.getClosestMatchingOption)(this.validator, this.rootSchema, formData, options, selectedOption, discriminatorField);
    }
    /** Given the `formData` and list of `options`, attempts to find the index of the first option that matches the data.
     * Always returns the first option if there is nothing that matches.
     *
     * @param formData - The current formData, if any, used to figure out a match
     * @param options - The list of options to find a matching options from
     * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
     *          determine which option is selected
     * @returns - The firstindex of the matched option or 0 if none is available
     */ getFirstMatchingOption(formData, options, discriminatorField) {
        return (0, _schema.getFirstMatchingOption)(this.validator, formData, options, this.rootSchema, discriminatorField);
    }
    /** Given the `formData` and list of `options`, attempts to find the index of the option that best matches the data.
     * Deprecated, use `getFirstMatchingOption()` instead.
     *
     * @param formData - The current formData, if any, onto which to provide any missing defaults
     * @param options - The list of options to find a matching options from
     * @param [discriminatorField] - The optional name of the field within the options object whose value is used to
     *          determine which option is selected
     * @returns - The index of the matched option or 0 if none is available
     * @deprecated
     */ getMatchingOption(formData, options, discriminatorField) {
        return (0, _schema.getMatchingOption)(this.validator, formData, options, this.rootSchema, discriminatorField);
    }
    /** Checks to see if the `schema` and `uiSchema` combination represents an array of files
     *
     * @param schema - The schema for which check for array of files flag is desired
     * @param [uiSchema] - The UI schema from which to check the widget
     * @returns - True if schema/uiSchema contains an array of files, otherwise false
     */ isFilesArray(schema, uiSchema) {
        return (0, _schema.isFilesArray)(this.validator, schema, uiSchema, this.rootSchema);
    }
    /** Checks to see if the `schema` combination represents a multi-select
     *
     * @param schema - The schema for which check for a multi-select flag is desired
     * @returns - True if schema contains a multi-select, otherwise false
     */ isMultiSelect(schema) {
        return (0, _schema.isMultiSelect)(this.validator, schema, this.rootSchema);
    }
    /** Checks to see if the `schema` combination represents a select
     *
     * @param schema - The schema for which check for a select flag is desired
     * @returns - True if schema contains a select, otherwise false
     */ isSelect(schema) {
        return (0, _schema.isSelect)(this.validator, schema, this.rootSchema);
    }
    /** Merges the errors in `additionalErrorSchema` into the existing `validationData` by combining the hierarchies in
     * the two `ErrorSchema`s and then appending the error list from the `additionalErrorSchema` obtained by calling
     * `getValidator().toErrorList()` onto the `errors` in the `validationData`. If no `additionalErrorSchema` is passed,
     * then `validationData` is returned.
     *
     * @param validationData - The current `ValidationData` into which to merge the additional errors
     * @param [additionalErrorSchema] - The additional set of errors
     * @returns - The `validationData` with the additional errors from `additionalErrorSchema` merged into it, if provided.
     * @deprecated - Use the `validationDataMerge()` function exported from `@rjsf/utils` instead. This function will be
     *        removed in the next major release.
     */ mergeValidationData(validationData, additionalErrorSchema) {
        return (0, _schema.mergeValidationData)(this.validator, validationData, additionalErrorSchema);
    }
    /** Retrieves an expanded schema that has had all of its conditions, additional properties, references and
     * dependencies resolved and merged into the `schema` given a `rawFormData` that is used to do the potentially
     * recursive resolution.
     *
     * @param schema - The schema for which retrieving a schema is desired
     * @param [rawFormData] - The current formData, if any, to assist retrieving a schema
     * @returns - The schema having its conditions, additional properties, references and dependencies resolved
     */ retrieveSchema(schema, rawFormData) {
        return (0, _schema.retrieveSchema)(this.validator, schema, this.rootSchema, rawFormData);
    }
    /** Sanitize the `data` associated with the `oldSchema` so it is considered appropriate for the `newSchema`. If the
     * new schema does not contain any properties, then `undefined` is returned to clear all the form data. Due to the
     * nature of schemas, this sanitization happens recursively for nested objects of data. Also, any properties in the
     * old schemas that are non-existent in the new schema are set to `undefined`.
     *
     * @param [newSchema] - The new schema for which the data is being sanitized
     * @param [oldSchema] - The old schema from which the data originated
     * @param [data={}] - The form data associated with the schema, defaulting to an empty object when undefined
     * @returns - The new form data, with all the fields uniquely associated with the old schema set
     *      to `undefined`. Will return `undefined` if the new schema is not an object containing properties.
     */ sanitizeDataForNewSchema(newSchema, oldSchema, data) {
        return (0, _schema.sanitizeDataForNewSchema)(this.validator, this.rootSchema, newSchema, oldSchema, data);
    }
    /** Generates an `IdSchema` object for the `schema`, recursively
     *
     * @param schema - The schema for which the display label flag is desired
     * @param [id] - The base id for the schema
     * @param [formData] - The current formData, if any, onto which to provide any missing defaults
     * @param [idPrefix='root'] - The prefix to use for the id
     * @param [idSeparator='_'] - The separator to use for the path segments in the id
     * @returns - The `IdSchema` object for the `schema`
     */ toIdSchema(schema, id, formData, idPrefix = "root", idSeparator = "_") {
        return (0, _schema.toIdSchema)(this.validator, schema, id, this.rootSchema, formData, idPrefix, idSeparator);
    }
    /** Generates an `PathSchema` object for the `schema`, recursively
     *
     * @param schema - The schema for which the display label flag is desired
     * @param [name] - The base name for the schema
     * @param [formData] - The current formData, if any, onto which to provide any missing defaults
     * @returns - The `PathSchema` object for the `schema`
     */ toPathSchema(schema, name, formData) {
        return (0, _schema.toPathSchema)(this.validator, schema, name, this.rootSchema, formData);
    }
}
function createSchemaUtils(validator, rootSchema, experimental_defaultFormStateBehavior = {}) {
    return new SchemaUtils(validator, rootSchema, experimental_defaultFormStateBehavior);
}

},{"./deepEquals":"5U4lj","./schema":"2iJHF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5U4lj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deepEquals);
var _isEqualWith = require("lodash/isEqualWith");
var _isEqualWithDefault = parcelHelpers.interopDefault(_isEqualWith);
function deepEquals(a, b) {
    return (0, _isEqualWithDefault.default)(a, b, (obj, other)=>{
        if (typeof obj === "function" && typeof other === "function") // Assume all functions are equivalent
        // see https://github.com/rjsf-team/react-jsonschema-form/issues/255
        return true;
        return undefined; // fallback to default isEquals behavior
    });
}

},{"lodash/isEqualWith":"kN4fc","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kN4fc":[function(require,module,exports) {
var baseIsEqual = require("9aa86f93cc374370");
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == "function" ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
}
module.exports = isEqualWith;

},{"9aa86f93cc374370":"2rFa2"}],"2rFa2":[function(require,module,exports) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"jgu1R","809bbb0c20650dbc":"17Pxd"}],"jgu1R":[function(require,module,exports) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"bE9kf","96bc8a1825db53a5":"2cm8A","8bdece495e87fb69":"7RWRd","bb94920432a68eca":"f0lJC","45495edff98e5837":"kRep8","18256411ae9e2858":"2vMMN","e5ba7abf54247fc5":"arWtb","50d786bb5c7366af":"fDUzl"}],"bE9kf":[function(require,module,exports) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"2ld1n","ceda2a63c77c915":"3McOK","91ee1b348d9d7172":"cX9ri","3fe28318f65b9332":"9Nv2g","724ca4def8b84e06":"2lbNn","e9ceacb40d9582bd":"d0tdb"}],"2ld1n":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"3jlpQ","b700cb849df2c166":"8BxAW","d76dd90eead6cced":"gSv0N","3d210628ba60ec8":"6dKTv","76026bf2d4cfff93":"1Vrf8"}],"3jlpQ":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"8BxAW":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"jeqJ9"}],"jeqJ9":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"9yMLM"}],"9yMLM":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"gSv0N":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"jeqJ9"}],"6dKTv":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"jeqJ9"}],"1Vrf8":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"jeqJ9"}],"3McOK":[function(require,module,exports) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"2ld1n"}],"cX9ri":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"9Nv2g":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"2lbNn":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"d0tdb":[function(require,module,exports) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"2ld1n","1494efbafafa9552":"d8eHX","6049e8027fe9407f":"2vAR1"}],"d8eHX":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"9c7PC","29224713b8d411e6":"7fHqO"}],"9c7PC":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"91M38","16db51a0e009bd8c":"3S7Bu"}],"91M38":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"jdOCL","cabbc2adfaeb27d9":"wsog5","cbb5703fe1562e7f":"kYJe3","388b819f47a43aa5":"dYwcc"}],"jdOCL":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"a1nlZ","3cba3c966459d528":"kYJe3"}],"kYJe3":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{}],"wsog5":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"iD3ul"}],"iD3ul":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"7fHqO"}],"dYwcc":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"3S7Bu":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"2vAR1":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"9Y9L6","d2967b0e32ccfa56":"8QgvC","ca21409ea89624c0":"35E36","f88fd07f8dd1f67d":"9gnKe","dbf3eae765642a3b":"d4U6s"}],"9Y9L6":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"h8tk0","a07dcf3fd3097a0c":"2ld1n","92c01c953ef00ded":"d8eHX"}],"h8tk0":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"6HImY","bc25d439ccd1fb47":"6y3G6","f096b37295a92ab0":"1JAgc","d88173cbc6a133c8":"bwLvu","afb9b3bae0461cbf":"fpdad"}],"6HImY":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"hfb3c"}],"hfb3c":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"9c7PC"}],"6y3G6":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"1JAgc":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"hfb3c"}],"bwLvu":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"hfb3c"}],"fpdad":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"hfb3c"}],"8QgvC":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"krXan"}],"krXan":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"d4UTj"}],"d4UTj":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{}],"35E36":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"krXan"}],"9gnKe":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"krXan"}],"d4U6s":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"krXan"}],"2cm8A":[function(require,module,exports) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"dLr8c","1ee20de911db0cb0":"Z0hJC","defff3d81be91b23":"68Ius"}],"dLr8c":[function(require,module,exports) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"2vAR1","9a831e81e9a1f98c":"35MgB","1a2b6c8a7399c39f":"e4xjo"}],"35MgB":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"e4xjo":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"Z0hJC":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"68Ius":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"7RWRd":[function(require,module,exports) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"gjsRy","dbf6aa5033a0f48":"3TOAk","539966708f906e61":"9yMLM","8142d4017f0a425f":"2cm8A","48cddf732eff33ba":"2adS3","9dc78b26c5daba20":"lN92r"}],"3TOAk":[function(require,module,exports) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"7fHqO"}],"2adS3":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"lN92r":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"f0lJC":[function(require,module,exports) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"eZ1Zl"}],"eZ1Zl":[function(require,module,exports) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"iyvEe","aa79b69a13f924db":"3ddJv","e3ad83e53433bc8a":"cpq56"}],"iyvEe":[function(require,module,exports) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"1QUph","148b85918856c33a":"2vMMN"}],"1QUph":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"2vMMN":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"3ddJv":[function(require,module,exports) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"13Ycc","6b1c62cea92cdb9":"aCn55"}],"13Ycc":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"aCn55":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"cpq56":[function(require,module,exports) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"8sKjP","e8453365fdacc8da":"d1mAs","7760b47b02971dfa":"6tjkt"}],"8sKjP":[function(require,module,exports) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"Xdcvx","9cdb51ffa56f149b":"g7Fgq","38cd49f1e493b3d7":"2vMMN","b379831fe1873fed":"arWtb","f362a34cd8321bb7":"jPvkN","c019db5297494469":"fDUzl"}],"Xdcvx":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"g7Fgq":[function(require,module,exports) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"b56e5b7d86069686":"fH1T9","bead821d6af018b5":"17Pxd"}],"fH1T9":[function(require,module,exports) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"a1nlZ","b6cdbe52dcf709f8":"17Pxd"}],"arWtb":[function(require,module,exports) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"7fHqO","a1e87b138cf75d1d":"8m00s"}],"8m00s":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"jPvkN":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"fDUzl":[function(require,module,exports) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"1Ns7F","903f50eb1c16d257":"2K30s","fa49853a82034c30":"9CzEe"}],"1Ns7F":[function(require,module,exports) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"a1nlZ","f661b3a120d7a4cb":"bSsER","cdd86c83797c0618":"17Pxd"}],"bSsER":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"2K30s":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"9CzEe":[function(require,module,exports) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"20wQX"}],"d1mAs":[function(require,module,exports) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"274Cn","3ec652610d8dd5d3":"jW0US"}],"274Cn":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"jW0US":[function(require,module,exports) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"UfyfF"}],"6tjkt":[function(require,module,exports) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"jdOCL","f3db08d4d1110aaf":"bSsER"}],"kRep8":[function(require,module,exports) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"eLb31","28e3344aae951f13":"d8eHX","b286298be5b1d9a4":"7I5mH","3ae50c158f89813":"8m712","9f458755f627d456":"254nk","8e9160b373d7fe66":"a1nlZ","b210627dd951641f":"dYwcc"}],"eLb31":[function(require,module,exports) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"a6517d0448dad786":"9c7PC","f83c375075418382":"7fHqO"}],"7I5mH":[function(require,module,exports) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"6940648d854355b5":"9c7PC","a5c6637bac681a0":"7fHqO"}],"8m712":[function(require,module,exports) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"56b792d64741a4ff":"9c7PC","ca486d41cdf819d4":"7fHqO"}],"254nk":[function(require,module,exports) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"4507415bd8810d3c":"9c7PC","7a9a6581834a8452":"7fHqO"}],"2iJHF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultFormState", ()=>(0, _getDefaultFormStateDefault.default));
parcelHelpers.export(exports, "getDisplayLabel", ()=>(0, _getDisplayLabelDefault.default));
parcelHelpers.export(exports, "getClosestMatchingOption", ()=>(0, _getClosestMatchingOptionDefault.default));
parcelHelpers.export(exports, "getFirstMatchingOption", ()=>(0, _getFirstMatchingOptionDefault.default));
parcelHelpers.export(exports, "getMatchingOption", ()=>(0, _getMatchingOptionDefault.default));
parcelHelpers.export(exports, "isFilesArray", ()=>(0, _isFilesArrayDefault.default));
parcelHelpers.export(exports, "isMultiSelect", ()=>(0, _isMultiSelectDefault.default));
parcelHelpers.export(exports, "isSelect", ()=>(0, _isSelectDefault.default));
parcelHelpers.export(exports, "mergeValidationData", ()=>(0, _mergeValidationDataDefault.default));
parcelHelpers.export(exports, "retrieveSchema", ()=>(0, _retrieveSchemaDefault.default));
parcelHelpers.export(exports, "sanitizeDataForNewSchema", ()=>(0, _sanitizeDataForNewSchemaDefault.default));
parcelHelpers.export(exports, "toIdSchema", ()=>(0, _toIdSchemaDefault.default));
parcelHelpers.export(exports, "toPathSchema", ()=>(0, _toPathSchemaDefault.default));
var _getDefaultFormState = require("./getDefaultFormState");
var _getDefaultFormStateDefault = parcelHelpers.interopDefault(_getDefaultFormState);
var _getDisplayLabel = require("./getDisplayLabel");
var _getDisplayLabelDefault = parcelHelpers.interopDefault(_getDisplayLabel);
var _getClosestMatchingOption = require("./getClosestMatchingOption");
var _getClosestMatchingOptionDefault = parcelHelpers.interopDefault(_getClosestMatchingOption);
var _getFirstMatchingOption = require("./getFirstMatchingOption");
var _getFirstMatchingOptionDefault = parcelHelpers.interopDefault(_getFirstMatchingOption);
var _getMatchingOption = require("./getMatchingOption");
var _getMatchingOptionDefault = parcelHelpers.interopDefault(_getMatchingOption);
var _isFilesArray = require("./isFilesArray");
var _isFilesArrayDefault = parcelHelpers.interopDefault(_isFilesArray);
var _isMultiSelect = require("./isMultiSelect");
var _isMultiSelectDefault = parcelHelpers.interopDefault(_isMultiSelect);
var _isSelect = require("./isSelect");
var _isSelectDefault = parcelHelpers.interopDefault(_isSelect);
var _mergeValidationData = require("./mergeValidationData");
var _mergeValidationDataDefault = parcelHelpers.interopDefault(_mergeValidationData);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
var _sanitizeDataForNewSchema = require("./sanitizeDataForNewSchema");
var _sanitizeDataForNewSchemaDefault = parcelHelpers.interopDefault(_sanitizeDataForNewSchema);
var _toIdSchema = require("./toIdSchema");
var _toIdSchemaDefault = parcelHelpers.interopDefault(_toIdSchema);
var _toPathSchema = require("./toPathSchema");
var _toPathSchemaDefault = parcelHelpers.interopDefault(_toPathSchema);

},{"./getDefaultFormState":"8li6s","./getDisplayLabel":"6NsDI","./getClosestMatchingOption":"d8isN","./getFirstMatchingOption":"ePFIw","./getMatchingOption":"a7A4o","./isFilesArray":"3G3xc","./isMultiSelect":"kaTqm","./isSelect":"g2GqK","./mergeValidationData":"ad5pK","./retrieveSchema":"g3Irx","./sanitizeDataForNewSchema":"cp6dv","./toIdSchema":"aPCBv","./toPathSchema":"j4ljm","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8li6s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdditionalItemsHandling", ()=>AdditionalItemsHandling);
/** Given a `schema` will return an inner schema that for an array item. This is computed differently based on the
 * `additionalItems` enum and the value of `idx`. There are four possible returns:
 * 1. If `idx` is >= 0, then if `schema.items` is an array the `idx`th element of the array is returned if it is a valid
 *    index and not a boolean, otherwise it falls through to 3.
 * 2. If `schema.items` is not an array AND truthy and not a boolean, then `schema.items` is returned since it actually
 *    is a schema, otherwise it falls through to 3.
 * 3. If `additionalItems` is not `AdditionalItemsHandling.Ignore` and `schema.additionalItems` is an object, then
 *    `schema.additionalItems` is returned since it actually is a schema, otherwise it falls through to 4.
 * 4. {} is returned representing an empty schema
 *
 * @param schema - The schema from which to get the particular item
 * @param [additionalItems=AdditionalItemsHandling.Ignore] - How do we want to handle additional items?
 * @param [idx=-1] - Index, if non-negative, will be used to return the idx-th element in a `schema.items` array
 * @returns - The best fit schema object from the `schema` given the `additionalItems` and `idx` modifiers
 */ parcelHelpers.export(exports, "getInnerSchemaForArrayItem", ()=>getInnerSchemaForArrayItem);
/** Computes the defaults for the current `schema` given the `rawFormData` and `parentDefaults` if any. This drills into
 * each level of the schema, recursively, to fill out every level of defaults provided by the schema.
 *
 * @param validator - an implementation of the `ValidatorType` interface that will be used when necessary
 * @param rawSchema - The schema for which the default state is desired
 * @param [props] - Optional props for this function
 * @param [props.parentDefaults] - Any defaults provided by the parent field in the schema
 * @param [props.rootSchema] - The options root schema, used to primarily to look up `$ref`s
 * @param [props.rawFormData] - The current formData, if any, onto which to provide any missing defaults
 * @param [props.includeUndefinedValues=false] - Optional flag, if true, cause undefined values to be added as defaults.
 *          If "excludeObjectChildren", cause undefined values for this object and pass `includeUndefinedValues` as
 *          false when computing defaults for any nested object properties.
 * @param [props._recurseList=[]] - The list of ref names currently being recursed, used to prevent infinite recursion
 * @param [props.experimental_defaultFormStateBehavior] Optional configuration object, if provided, allows users to override default form state behavior
 * @param [props.required] - Optional flag, if true, indicates this schema was required in the parent schema.
 * @returns - The resulting `formData` with all the defaults provided
 */ parcelHelpers.export(exports, "computeDefaults", ()=>computeDefaults);
parcelHelpers.export(exports, "default", ()=>getDefaultFormState);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _constants = require("../constants");
var _findSchemaDefinition = require("../findSchemaDefinition");
var _findSchemaDefinitionDefault = parcelHelpers.interopDefault(_findSchemaDefinition);
var _getClosestMatchingOption = require("./getClosestMatchingOption");
var _getClosestMatchingOptionDefault = parcelHelpers.interopDefault(_getClosestMatchingOption);
var _getDiscriminatorFieldFromSchema = require("../getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _getSchemaType = require("../getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
var _isObject = require("../isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _isFixedItems = require("../isFixedItems");
var _isFixedItemsDefault = parcelHelpers.interopDefault(_isFixedItems);
var _mergeDefaultsWithFormData = require("../mergeDefaultsWithFormData");
var _mergeDefaultsWithFormDataDefault = parcelHelpers.interopDefault(_mergeDefaultsWithFormData);
var _mergeObjects = require("../mergeObjects");
var _mergeObjectsDefault = parcelHelpers.interopDefault(_mergeObjects);
var _mergeSchemas = require("../mergeSchemas");
var _mergeSchemasDefault = parcelHelpers.interopDefault(_mergeSchemas);
var _isMultiSelect = require("./isMultiSelect");
var _isMultiSelectDefault = parcelHelpers.interopDefault(_isMultiSelect);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
var AdditionalItemsHandling;
(function(AdditionalItemsHandling) {
    AdditionalItemsHandling[AdditionalItemsHandling["Ignore"] = 0] = "Ignore";
    AdditionalItemsHandling[AdditionalItemsHandling["Invert"] = 1] = "Invert";
    AdditionalItemsHandling[AdditionalItemsHandling["Fallback"] = 2] = "Fallback";
})(AdditionalItemsHandling || (AdditionalItemsHandling = {}));
function getInnerSchemaForArrayItem(schema, additionalItems = AdditionalItemsHandling.Ignore, idx = -1) {
    if (idx >= 0) {
        if (Array.isArray(schema.items) && idx < schema.items.length) {
            const item = schema.items[idx];
            if (typeof item !== "boolean") return item;
        }
    } else if (schema.items && !Array.isArray(schema.items) && typeof schema.items !== "boolean") return schema.items;
    if (additionalItems !== AdditionalItemsHandling.Ignore && (0, _isObjectDefault.default)(schema.additionalItems)) return schema.additionalItems;
    return {};
}
/** Either add `computedDefault` at `key` into `obj` or not add it based on its value, the value of
 * `includeUndefinedValues`, the value of `emptyObjectFields` and if its parent field is required. Generally undefined
 * `computedDefault` values are added only when `includeUndefinedValues` is either true/"excludeObjectChildren". If `
 * includeUndefinedValues` is false and `emptyObjectFields` is not "skipDefaults", then non-undefined and non-empty-object
 * values will be added based on certain conditions.
 *
 * @param obj - The object into which the computed default may be added
 * @param key - The key into the object at which the computed default may be added
 * @param computedDefault - The computed default value that maybe should be added to the obj
 * @param includeUndefinedValues - Optional flag, if true, cause undefined values to be added as defaults.
 *          If "excludeObjectChildren", cause undefined values for this object and pass `includeUndefinedValues` as
 *          false when computing defaults for any nested object properties. If "allowEmptyObject", prevents undefined
 *          values in this object while allow the object itself to be empty and passing `includeUndefinedValues` as
 *          false when computing defaults for any nested object properties.
 * @param isParentRequired - The optional boolean that indicates whether the parent field is required
 * @param requiredFields - The list of fields that are required
 * @param experimental_defaultFormStateBehavior - Optional configuration object, if provided, allows users to override
 *        default form state behavior
 */ function maybeAddDefaultToObject(obj, key, computedDefault, includeUndefinedValues, isParentRequired, requiredFields = [], experimental_defaultFormStateBehavior = {}) {
    const { emptyObjectFields = "populateAllDefaults" } = experimental_defaultFormStateBehavior;
    if (includeUndefinedValues) obj[key] = computedDefault;
    else if (emptyObjectFields !== "skipDefaults") {
        if ((0, _isObjectDefault.default)(computedDefault)) {
            // If isParentRequired is undefined, then we are at the root level of the schema so defer to the requiredness of
            // the field key itself in the `requiredField` list
            const isSelfOrParentRequired = isParentRequired === undefined ? requiredFields.includes(key) : isParentRequired;
            // If emptyObjectFields 'skipEmptyDefaults' store computedDefault if it's a non-empty object(e.g. not {})
            if (emptyObjectFields === "skipEmptyDefaults") {
                if (!(0, _isEmptyDefault.default)(computedDefault)) obj[key] = computedDefault;
            } else if ((!(0, _isEmptyDefault.default)(computedDefault) || requiredFields.includes(key)) && (isSelfOrParentRequired || emptyObjectFields !== "populateRequiredDefaults")) obj[key] = computedDefault;
        } else if (// Store computedDefault if it's a defined primitive (e.g., true) and satisfies certain conditions
        // Condition 1: computedDefault is not undefined
        // Condition 2: If emptyObjectFields is 'populateAllDefaults' or 'skipEmptyDefaults) or if the key is a required field
        computedDefault !== undefined && (emptyObjectFields === "populateAllDefaults" || emptyObjectFields === "skipEmptyDefaults" || requiredFields.includes(key))) obj[key] = computedDefault;
    }
}
function computeDefaults(validator, rawSchema, { parentDefaults, rawFormData, rootSchema = {}, includeUndefinedValues = false, _recurseList = [], experimental_defaultFormStateBehavior, required } = {}) {
    var _a, _b, _c, _d;
    const formData = (0, _isObjectDefault.default)(rawFormData) ? rawFormData : {};
    const schema = (0, _isObjectDefault.default)(rawSchema) ? rawSchema : {};
    // Compute the defaults recursively: give highest priority to deepest nodes.
    let defaults = parentDefaults;
    // If we get a new schema, then we need to recompute defaults again for the new schema found.
    let schemaToCompute = null;
    let updatedRecurseList = _recurseList;
    if ((0, _isObjectDefault.default)(defaults) && (0, _isObjectDefault.default)(schema.default)) // For object defaults, only override parent defaults that are defined in
    // schema.default.
    defaults = (0, _mergeObjectsDefault.default)(defaults, schema.default);
    else if ((0, _constants.DEFAULT_KEY) in schema) defaults = schema.default;
    else if ((0, _constants.REF_KEY) in schema) {
        const refName = schema[0, _constants.REF_KEY];
        // Use referenced schema defaults for this node.
        if (!_recurseList.includes(refName)) {
            updatedRecurseList = _recurseList.concat(refName);
            schemaToCompute = (0, _findSchemaDefinitionDefault.default)(refName, rootSchema);
        }
    } else if ((0, _constants.DEPENDENCIES_KEY) in schema) {
        const resolvedSchema = (0, _retrieveSchema.resolveDependencies)(validator, schema, rootSchema, false, [], formData);
        schemaToCompute = resolvedSchema[0]; // pick the first element from resolve dependencies
    } else if ((0, _isFixedItemsDefault.default)(schema)) defaults = schema.items.map((itemSchema, idx)=>computeDefaults(validator, itemSchema, {
            rootSchema,
            includeUndefinedValues,
            _recurseList,
            experimental_defaultFormStateBehavior,
            parentDefaults: Array.isArray(parentDefaults) ? parentDefaults[idx] : undefined,
            rawFormData: formData,
            required
        }));
    else if ((0, _constants.ONE_OF_KEY) in schema) {
        const { oneOf, ...remaining } = schema;
        if (oneOf.length === 0) return undefined;
        const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(schema);
        schemaToCompute = oneOf[(0, _getClosestMatchingOptionDefault.default)(validator, rootSchema, (0, _isEmptyDefault.default)(formData) ? undefined : formData, oneOf, 0, discriminator)];
        schemaToCompute = (0, _mergeSchemasDefault.default)(remaining, schemaToCompute);
    } else if ((0, _constants.ANY_OF_KEY) in schema) {
        const { anyOf, ...remaining } = schema;
        if (anyOf.length === 0) return undefined;
        const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(schema);
        schemaToCompute = anyOf[(0, _getClosestMatchingOptionDefault.default)(validator, rootSchema, (0, _isEmptyDefault.default)(formData) ? undefined : formData, anyOf, 0, discriminator)];
        schemaToCompute = (0, _mergeSchemasDefault.default)(remaining, schemaToCompute);
    }
    if (schemaToCompute) return computeDefaults(validator, schemaToCompute, {
        rootSchema,
        includeUndefinedValues,
        _recurseList: updatedRecurseList,
        experimental_defaultFormStateBehavior,
        parentDefaults: defaults,
        rawFormData: formData,
        required
    });
    // No defaults defined for this node, fallback to generic typed ones.
    if (defaults === undefined) defaults = schema.default;
    switch((0, _getSchemaTypeDefault.default)(schema)){
        // We need to recurse for object schema inner default values.
        case "object":
            {
                // This is a custom addition that fixes this issue:
                // https://github.com/rjsf-team/react-jsonschema-form/issues/3832
                const retrievedSchema = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.allOf) === "populateDefaults" && (0, _constants.ALL_OF_KEY) in schema ? (0, _retrieveSchemaDefault.default)(validator, schema, rootSchema, formData) : schema;
                const objectDefaults = Object.keys(retrievedSchema.properties || {}).reduce((acc, key)=>{
                    var _a;
                    // Compute the defaults for this node, with the parent defaults we might
                    // have from a previous run: defaults[key].
                    const computedDefault = computeDefaults(validator, (0, _getDefault.default)(retrievedSchema, [
                        (0, _constants.PROPERTIES_KEY),
                        key
                    ]), {
                        rootSchema,
                        _recurseList,
                        experimental_defaultFormStateBehavior,
                        includeUndefinedValues: includeUndefinedValues === true,
                        parentDefaults: (0, _getDefault.default)(defaults, [
                            key
                        ]),
                        rawFormData: (0, _getDefault.default)(formData, [
                            key
                        ]),
                        required: (_a = retrievedSchema.required) === null || _a === void 0 ? void 0 : _a.includes(key)
                    });
                    maybeAddDefaultToObject(acc, key, computedDefault, includeUndefinedValues, required, retrievedSchema.required, experimental_defaultFormStateBehavior);
                    return acc;
                }, {});
                if (retrievedSchema.additionalProperties) {
                    // as per spec additionalProperties may be either schema or boolean
                    const additionalPropertiesSchema = (0, _isObjectDefault.default)(retrievedSchema.additionalProperties) ? retrievedSchema.additionalProperties : {};
                    const keys = new Set();
                    if ((0, _isObjectDefault.default)(defaults)) Object.keys(defaults).filter((key)=>!retrievedSchema.properties || !retrievedSchema.properties[key]).forEach((key)=>keys.add(key));
                    const formDataRequired = [];
                    Object.keys(formData).filter((key)=>!retrievedSchema.properties || !retrievedSchema.properties[key]).forEach((key)=>{
                        keys.add(key);
                        formDataRequired.push(key);
                    });
                    keys.forEach((key)=>{
                        var _a;
                        const computedDefault = computeDefaults(validator, additionalPropertiesSchema, {
                            rootSchema,
                            _recurseList,
                            experimental_defaultFormStateBehavior,
                            includeUndefinedValues: includeUndefinedValues === true,
                            parentDefaults: (0, _getDefault.default)(defaults, [
                                key
                            ]),
                            rawFormData: (0, _getDefault.default)(formData, [
                                key
                            ]),
                            required: (_a = retrievedSchema.required) === null || _a === void 0 ? void 0 : _a.includes(key)
                        });
                        // Since these are additional properties we don't need to add the `experimental_defaultFormStateBehavior` prop
                        maybeAddDefaultToObject(objectDefaults, key, computedDefault, includeUndefinedValues, required, formDataRequired);
                    });
                }
                return objectDefaults;
            }
        case "array":
            {
                const neverPopulate = ((_a = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) === null || _a === void 0 ? void 0 : _a.populate) === "never";
                const ignoreMinItemsFlagSet = ((_b = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) === null || _b === void 0 ? void 0 : _b.populate) === "requiredOnly";
                const isSkipEmptyDefaults = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.emptyObjectFields) === "skipEmptyDefaults";
                const computeSkipPopulate = (_d = (_c = experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) === null || _c === void 0 ? void 0 : _c.computeSkipPopulate) !== null && _d !== void 0 ? _d : ()=>false;
                const emptyDefault = isSkipEmptyDefaults ? undefined : [];
                // Inject defaults into existing array defaults
                if (Array.isArray(defaults)) defaults = defaults.map((item, idx)=>{
                    const schemaItem = getInnerSchemaForArrayItem(schema, AdditionalItemsHandling.Fallback, idx);
                    return computeDefaults(validator, schemaItem, {
                        rootSchema,
                        _recurseList,
                        experimental_defaultFormStateBehavior,
                        parentDefaults: item,
                        required
                    });
                });
                // Deeply inject defaults into already existing form data
                if (Array.isArray(rawFormData)) {
                    const schemaItem = getInnerSchemaForArrayItem(schema);
                    if (neverPopulate) defaults = rawFormData;
                    else defaults = rawFormData.map((item, idx)=>{
                        return computeDefaults(validator, schemaItem, {
                            rootSchema,
                            _recurseList,
                            experimental_defaultFormStateBehavior,
                            rawFormData: item,
                            parentDefaults: (0, _getDefault.default)(defaults, [
                                idx
                            ]),
                            required
                        });
                    });
                }
                if (neverPopulate) return defaults !== null && defaults !== void 0 ? defaults : emptyDefault;
                if (ignoreMinItemsFlagSet && !required) // If no form data exists or defaults are set leave the field empty/non-existent, otherwise
                // return form data/defaults
                return defaults ? defaults : undefined;
                const defaultsLength = Array.isArray(defaults) ? defaults.length : 0;
                if (!schema.minItems || (0, _isMultiSelectDefault.default)(validator, schema, rootSchema) || computeSkipPopulate(validator, schema, rootSchema) || schema.minItems <= defaultsLength) return defaults ? defaults : emptyDefault;
                const defaultEntries = defaults || [];
                const fillerSchema = getInnerSchemaForArrayItem(schema, AdditionalItemsHandling.Invert);
                const fillerDefault = fillerSchema.default;
                // Calculate filler entries for remaining items (minItems - existing raw data/defaults)
                const fillerEntries = new Array(schema.minItems - defaultsLength).fill(computeDefaults(validator, fillerSchema, {
                    parentDefaults: fillerDefault,
                    rootSchema,
                    _recurseList,
                    experimental_defaultFormStateBehavior,
                    required
                }));
                // then fill up the rest with either the item default or empty, up to minItems
                return defaultEntries.concat(fillerEntries);
            }
    }
    return defaults;
}
function getDefaultFormState(validator, theSchema, formData, rootSchema, includeUndefinedValues = false, experimental_defaultFormStateBehavior) {
    if (!(0, _isObjectDefault.default)(theSchema)) throw new Error("Invalid schema: " + theSchema);
    const schema = (0, _retrieveSchemaDefault.default)(validator, theSchema, rootSchema, formData);
    const defaults = computeDefaults(validator, schema, {
        rootSchema,
        includeUndefinedValues,
        experimental_defaultFormStateBehavior,
        rawFormData: formData
    });
    if (formData === undefined || formData === null || typeof formData === "number" && isNaN(formData)) // No form data? Use schema defaults.
    return defaults;
    const { mergeExtraDefaults } = (experimental_defaultFormStateBehavior === null || experimental_defaultFormStateBehavior === void 0 ? void 0 : experimental_defaultFormStateBehavior.arrayMinItems) || {};
    if ((0, _isObjectDefault.default)(formData)) return (0, _mergeDefaultsWithFormDataDefault.default)(defaults, formData, mergeExtraDefaults);
    if (Array.isArray(formData)) return (0, _mergeDefaultsWithFormDataDefault.default)(defaults, formData, mergeExtraDefaults);
    return formData;
}

},{"lodash/get":"g5ox6","lodash/isEmpty":"c3uBm","../constants":"7SuQb","../findSchemaDefinition":"cMrNB","./getClosestMatchingOption":"d8isN","../getDiscriminatorFieldFromSchema":"lULGM","../getSchemaType":"Po4xY","../isObject":"9dcnp","../isFixedItems":"eBu8s","../mergeDefaultsWithFormData":"64T3g","../mergeObjects":"63YAa","../mergeSchemas":"dxsEQ","./isMultiSelect":"kaTqm","./retrieveSchema":"g3Irx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g5ox6":[function(require,module,exports) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"5yD9j"}],"5yD9j":[function(require,module,exports) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"7zM0U","c3296f04fad32769":"bDIXW"}],"7zM0U":[function(require,module,exports) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"2vMMN","e823e604d75f975b":"hn10w","f5fff1c342107fbd":"dCEkE","b04e8cc634273c23":"70rwt"}],"hn10w":[function(require,module,exports) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"2vMMN","4cdff6c9e9ff5d38":"b0EEv"}],"b0EEv":[function(require,module,exports) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"a1nlZ","74644060ad1a1d3c":"17Pxd"}],"dCEkE":[function(require,module,exports) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"aZbCM"}],"aZbCM":[function(require,module,exports) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"akrTo"}],"akrTo":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"2vAR1"}],"70rwt":[function(require,module,exports) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"27GfB"}],"27GfB":[function(require,module,exports) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"gjsRy","8439a3a1551d0706":"4aQow","4b12c9f502d3288a":"2vMMN","a0ebd327d618908a":"b0EEv"}],"4aQow":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"bDIXW":[function(require,module,exports) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"b0EEv"}],"c3uBm":[function(require,module,exports) {
var baseKeys = require("a008df59f82d2c8f"), getTag = require("d63799a808049d04"), isArguments = require("1f4ee6aee3a7eae0"), isArray = require("b708be4f72c2a706"), isArrayLike = require("ab4b4eaf96f9163a"), isBuffer = require("80b58ade5ee2f70"), isPrototype = require("3a444e8bd8b275f2"), isTypedArray = require("6af418b3352c301b");
/** `Object#toString` result references. */ var mapTag = "[object Map]", setTag = "[object Set]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (value == null) return true;
    if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (isPrototype(value)) return !baseKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = isEmpty;

},{"a008df59f82d2c8f":"d1mAs","d63799a808049d04":"kRep8","1f4ee6aee3a7eae0":"g7Fgq","b708be4f72c2a706":"2vMMN","ab4b4eaf96f9163a":"6tjkt","80b58ade5ee2f70":"arWtb","3a444e8bd8b275f2":"274Cn","6af418b3352c301b":"fDUzl"}],"cMrNB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Splits out the value at the `key` in `object` from the `object`, returning an array that contains in the first
 * location, the `object` minus the `key: value` and in the second location the `value`.
 *
 * @param key - The key from the object to extract
 * @param object - The object from which to extract the element
 * @returns - An array with the first value being the object minus the `key` element and the second element being the
 *      value from `object[key]`
 */ parcelHelpers.export(exports, "splitKeyElementFromObject", ()=>splitKeyElementFromObject);
/** Given the name of a `$ref` from within a schema, using the `rootSchema`, recursively look up and return the
 * sub-schema using the path provided by that reference. If `#` is not the first character of the reference, the path
 * does not exist in the schema, or the reference resolves circularly back to itself, then throw an Error.
 * Otherwise return the sub-schema. Also deals with nested `$ref`s in the sub-schema.
 *
 * @param $ref - The ref string for which the schema definition is desired
 * @param [rootSchema={}] - The root schema in which to search for the definition
 * @param recurseList - List of $refs already resolved to prevent recursion
 * @returns - The sub-schema within the `rootSchema` which matches the `$ref` if it exists
 * @throws - Error indicating that no schema for that reference could be resolved
 */ parcelHelpers.export(exports, "findSchemaDefinitionRecursive", ()=>findSchemaDefinitionRecursive);
parcelHelpers.export(exports, "default", ()=>findSchemaDefinition);
var _jsonpointer = require("jsonpointer");
var _jsonpointerDefault = parcelHelpers.interopDefault(_jsonpointer);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _constants = require("./constants");
function splitKeyElementFromObject(key, object) {
    const value = object[key];
    const remaining = (0, _omitDefault.default)(object, [
        key
    ]);
    return [
        remaining,
        value
    ];
}
function findSchemaDefinitionRecursive($ref, rootSchema = {}, recurseList = []) {
    const ref = $ref || "";
    let decodedRef;
    if (ref.startsWith("#")) // Decode URI fragment representation.
    decodedRef = decodeURIComponent(ref.substring(1));
    else throw new Error(`Could not find a definition for ${$ref}.`);
    const current = (0, _jsonpointerDefault.default).get(rootSchema, decodedRef);
    if (current === undefined) throw new Error(`Could not find a definition for ${$ref}.`);
    const nextRef = current[0, _constants.REF_KEY];
    if (nextRef) {
        // Check for circular references.
        if (recurseList.includes(nextRef)) {
            if (recurseList.length === 1) throw new Error(`Definition for ${$ref} is a circular reference`);
            const [firstRef, ...restRefs] = recurseList;
            const circularPath = [
                ...restRefs,
                ref,
                firstRef
            ].join(" -> ");
            throw new Error(`Definition for ${firstRef} contains a circular reference through ${circularPath}`);
        }
        const [remaining, theRef] = splitKeyElementFromObject((0, _constants.REF_KEY), current);
        const subSchema = findSchemaDefinitionRecursive(theRef, rootSchema, [
            ...recurseList,
            ref
        ]);
        if (Object.keys(remaining).length > 0) return {
            ...remaining,
            ...subSchema
        };
        return subSchema;
    }
    return current;
}
function findSchemaDefinition($ref, rootSchema = {}) {
    const recurseList = [];
    return findSchemaDefinitionRecursive($ref, rootSchema, recurseList);
}

},{"jsonpointer":"5GwOO","lodash/omit":"ijdpj","./constants":"7SuQb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5GwOO":[function(require,module,exports) {
var hasExcape = /~/;
var escapeMatcher = /~[01]/g;
function escapeReplacer(m) {
    switch(m){
        case "~1":
            return "/";
        case "~0":
            return "~";
    }
    throw new Error("Invalid tilde escape: " + m);
}
function untilde(str) {
    if (!hasExcape.test(str)) return str;
    return str.replace(escapeMatcher, escapeReplacer);
}
function setter(obj, pointer, value) {
    var part;
    var hasNextPart;
    for(var p = 1, len = pointer.length; p < len;){
        if (pointer[p] === "constructor" || pointer[p] === "prototype" || pointer[p] === "__proto__") return obj;
        part = untilde(pointer[p++]);
        hasNextPart = len > p;
        if (typeof obj[part] === "undefined") {
            // support setting of /-
            if (Array.isArray(obj) && part === "-") part = obj.length;
            // support nested objects/array when setting values
            if (hasNextPart) {
                if (pointer[p] !== "" && pointer[p] < Infinity || pointer[p] === "-") obj[part] = [];
                else obj[part] = {};
            }
        }
        if (!hasNextPart) break;
        obj = obj[part];
    }
    var oldValue = obj[part];
    if (value === undefined) delete obj[part];
    else obj[part] = value;
    return oldValue;
}
function compilePointer(pointer) {
    if (typeof pointer === "string") {
        pointer = pointer.split("/");
        if (pointer[0] === "") return pointer;
        throw new Error("Invalid JSON pointer.");
    } else if (Array.isArray(pointer)) {
        for (const part of pointer){
            if (typeof part !== "string" && typeof part !== "number") throw new Error("Invalid JSON pointer. Must be of type string or number.");
        }
        return pointer;
    }
    throw new Error("Invalid JSON pointer.");
}
function get(obj, pointer) {
    if (typeof obj !== "object") throw new Error("Invalid input object.");
    pointer = compilePointer(pointer);
    var len = pointer.length;
    if (len === 1) return obj;
    for(var p = 1; p < len;){
        obj = obj[untilde(pointer[p++])];
        if (len === p) return obj;
        if (typeof obj !== "object" || obj === null) return undefined;
    }
}
function set(obj, pointer, value) {
    if (typeof obj !== "object") throw new Error("Invalid input object.");
    pointer = compilePointer(pointer);
    if (pointer.length === 0) throw new Error("Invalid JSON pointer for set.");
    return setter(obj, pointer, value);
}
function compile(pointer) {
    var compiled = compilePointer(pointer);
    return {
        get: function(object) {
            return get(object, compiled);
        },
        set: function(object, value) {
            return set(object, compiled, value);
        }
    };
}
exports.get = get;
exports.set = set;
exports.compile = compile;

},{}],"ijdpj":[function(require,module,exports) {
var arrayMap = require("edf8d2f2f36e65cf"), baseClone = require("dd27ddc2340179e5"), baseUnset = require("589767d435c41297"), castPath = require("565c158f6d380e60"), copyObject = require("9b4f3122fc9cc1a6"), customOmitClone = require("1c19467b6c51de37"), flatRest = require("24ab2b6e4b71312a"), getAllKeysIn = require("e20a1a7cbb58999e");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var omit = flatRest(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    var length = paths.length;
    while(length--)baseUnset(result, paths[length]);
    return result;
});
module.exports = omit;

},{"edf8d2f2f36e65cf":"4aQow","dd27ddc2340179e5":"4qp1b","589767d435c41297":"hHMYq","565c158f6d380e60":"7zM0U","9b4f3122fc9cc1a6":"irgYF","1c19467b6c51de37":"3QnCt","24ab2b6e4b71312a":"ay1jj","e20a1a7cbb58999e":"8aLor"}],"4qp1b":[function(require,module,exports) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"bE9kf","3a79976eb46af94a":"545SQ","bc83a05a4f99d69b":"1GsQO","e6b4c3e6c85df6bb":"6bO1P","f340cc553ba5643c":"f4J6S","e72e99883a50402d":"d1F9Q","dc840ead07f1054":"jNUX7","309288e8ee190af0":"iA11f","687fa30fede0b048":"fIAoZ","bb0ba724f98b094d":"eZ1Zl","12bae1dca0e83064":"8aLor","4c3204eaea28d680":"kRep8","fd7741200b462cdf":"i67Mm","f93a1d24ac08e076":"3Lv3C","630039e80f692f17":"3NCrZ","f37949484ab52dae":"2vMMN","ac876cc65d29c86e":"arWtb","1056c031d98783c0":"5BTpu","1800fb3122907fc2":"kYJe3","31f022f648037bd3":"1nHX5","5f3267fbd9848a7d":"cpq56","7d3f3bdc4f2e7bb8":"cYRBj"}],"545SQ":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"1GsQO":[function(require,module,exports) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"66fGk","b62ef95b3cf1cde1":"9yMLM"}],"66fGk":[function(require,module,exports) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"o3t5I"}],"o3t5I":[function(require,module,exports) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"9c7PC"}],"6bO1P":[function(require,module,exports) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"irgYF","fcf23a0242ef0da9":"cpq56"}],"irgYF":[function(require,module,exports) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"1GsQO","9cddf6ac1a092765":"66fGk"}],"f4J6S":[function(require,module,exports) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"irgYF","7697a1565646c93":"cYRBj"}],"cYRBj":[function(require,module,exports) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"8sKjP","194eb1a802636842":"bOrBL","ac15afdc3ddd76cd":"6tjkt"}],"bOrBL":[function(require,module,exports) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"kYJe3","f7d53cd92b2b977b":"274Cn","c039208a16eb68bd":"2Ifdi"}],"2Ifdi":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"d1F9Q":[function(require,module,exports) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"7fHqO"}],"jNUX7":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"iA11f":[function(require,module,exports) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"irgYF","39cbde2205d9399c":"3ddJv"}],"fIAoZ":[function(require,module,exports) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"irgYF","9b660e6b0c20d303":"bJLGC"}],"bJLGC":[function(require,module,exports) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"1QUph","6ccae2aa7cfa3c66":"4IYkl","bdb501682ee9305d":"3ddJv","7641fe4ae6d2cc96":"aCn55"}],"8aLor":[function(require,module,exports) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"iyvEe","feede5d0a2d06427":"bJLGC","287f70f798405911":"cYRBj"}],"i67Mm":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"3Lv3C":[function(require,module,exports) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"gwJM2","dbf04edaab2ae376":"939yg","763300f2dd9bdaf3":"7vM4X","c30e64d90e4b92d1":"8VnT0","d1edd8349e9ad54d":"11I6K"}],"gwJM2":[function(require,module,exports) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"3TOAk"}],"939yg":[function(require,module,exports) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"gwJM2"}],"7vM4X":[function(require,module,exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"8VnT0":[function(require,module,exports) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"gjsRy"}],"11I6K":[function(require,module,exports) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"gwJM2"}],"3NCrZ":[function(require,module,exports) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"aBMSU","8c92276927b7c3e0":"4IYkl","e939f15d7a0f64a5":"274Cn"}],"aBMSU":[function(require,module,exports) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"kYJe3"}],"5BTpu":[function(require,module,exports) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"kkDHF","6a7e6b1a2d9fb1d5":"2K30s","7d4f449dd306450f":"9CzEe"}],"kkDHF":[function(require,module,exports) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"kRep8","88260e33e0003386":"17Pxd"}],"1nHX5":[function(require,module,exports) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"2kyZm","3cb35dba719c68b1":"2K30s","7a3e899a332ff7be":"9CzEe"}],"2kyZm":[function(require,module,exports) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"kRep8","b6fc875bc5f351c9":"17Pxd"}],"hHMYq":[function(require,module,exports) {
var castPath = require("f9ed36b4ad99fc49"), last = require("bbfbe3a50d8efe39"), parent = require("b7b0084465c39aec"), toKey = require("7b9792fcc4179101");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
}
module.exports = baseUnset;

},{"f9ed36b4ad99fc49":"7zM0U","bbfbe3a50d8efe39":"drQua","b7b0084465c39aec":"7CpKI","7b9792fcc4179101":"bDIXW"}],"drQua":[function(require,module,exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"7CpKI":[function(require,module,exports) {
var baseGet = require("cbcb75b7339c1ad"), baseSlice = require("3443758a32fd0de1");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
module.exports = parent;

},{"cbcb75b7339c1ad":"5yD9j","3443758a32fd0de1":"a76cn"}],"a76cn":[function(require,module,exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"3QnCt":[function(require,module,exports) {
var isPlainObject = require("e34ef634df1bf68a");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
}
module.exports = customOmitClone;

},{"e34ef634df1bf68a":"g5UGm"}],"ay1jj":[function(require,module,exports) {
var flatten = require("199f7cbd69032298"), overRest = require("aa5c38699e42775a"), setToString = require("6a66c8b3fbd122d5");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + "");
}
module.exports = flatRest;

},{"199f7cbd69032298":"5AbnX","aa5c38699e42775a":"eGjc4","6a66c8b3fbd122d5":"hhR0y"}],"5AbnX":[function(require,module,exports) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"6cEdQ"}],"6cEdQ":[function(require,module,exports) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"1QUph","ec5f080ebf5764e8":"1x9fE"}],"1x9fE":[function(require,module,exports) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"gjsRy","ee6f325d7f5309b1":"g7Fgq","ff8d93236e335297":"2vMMN"}],"eGjc4":[function(require,module,exports) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"dV0Pb"}],"dV0Pb":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"hhR0y":[function(require,module,exports) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"fgeM6","9114f59293388d49":"3dJUH"}],"fgeM6":[function(require,module,exports) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"1yxYJ","eff1240bc0447727":"o3t5I","b00d1e57326793e1":"4q4zt"}],"1yxYJ":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"4q4zt":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"3dJUH":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"d8isN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JUNK_OPTION", ()=>JUNK_OPTION);
/** Recursive function that calculates the score of a `formData` against the given `schema`. The computation is fairly
 * simple. Initially the total score is 0. When `schema.properties` object exists, then all the `key/value` pairs within
 * the object are processed as follows after obtaining the formValue from `formData` using the `key`:
 * - If the `value` contains a `$ref`, `calculateIndexScore()` is called recursively with the formValue and the new
 *   schema that is the result of the ref in the schema being resolved and that sub-schema's resulting score is added to
 *   the total.
 * - If the `value` contains a `oneOf` and there is a formValue, then score based on the index returned from calling
 *   `getClosestMatchingOption()` of that oneOf.
 * - If the type of the `value` is 'object', `calculateIndexScore()` is called recursively with the formValue and the
 *   `value` itself as the sub-schema, and the score is added to the total.
 * - If the type of the `value` matches the guessed-type of the `formValue`, the score is incremented by 1, UNLESS the
 *   value has a `default` or `const`. In those case, if the `default` or `const` and the `formValue` match, the score
 *   is incremented by another 1 otherwise it is decremented by 1.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param rootSchema - The root JSON schema of the entire form
 * @param schema - The schema for which the score is being calculated
 * @param formData - The form data associated with the schema, used to calculate the score
 * @returns - The score a schema against the formData
 */ parcelHelpers.export(exports, "calculateIndexScore", ()=>calculateIndexScore);
parcelHelpers.export(exports, "default", ()=>getClosestMatchingOption);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _reduce = require("lodash/reduce");
var _reduceDefault = parcelHelpers.interopDefault(_reduce);
var _times = require("lodash/times");
var _timesDefault = parcelHelpers.interopDefault(_times);
var _getFirstMatchingOption = require("./getFirstMatchingOption");
var _getFirstMatchingOptionDefault = parcelHelpers.interopDefault(_getFirstMatchingOption);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
var _constants = require("../constants");
var _guessType = require("../guessType");
var _guessTypeDefault = parcelHelpers.interopDefault(_guessType);
var _getDiscriminatorFieldFromSchema = require("../getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _getOptionMatchingSimpleDiscriminator = require("../getOptionMatchingSimpleDiscriminator");
var _getOptionMatchingSimpleDiscriminatorDefault = parcelHelpers.interopDefault(_getOptionMatchingSimpleDiscriminator);
const JUNK_OPTION = {
    type: "object",
    $id: (0, _constants.JUNK_OPTION_ID),
    properties: {
        __not_really_there__: {
            type: "number"
        }
    }
};
function calculateIndexScore(validator, rootSchema, schema, formData = {}) {
    let totalScore = 0;
    if (schema) {
        if ((0, _isObjectDefault.default)(schema.properties)) totalScore += (0, _reduceDefault.default)(schema.properties, (score, value, key)=>{
            const formValue = (0, _getDefault.default)(formData, key);
            if (typeof value === "boolean") return score;
            if ((0, _hasDefault.default)(value, (0, _constants.REF_KEY))) {
                const newSchema = (0, _retrieveSchemaDefault.default)(validator, value, rootSchema, formValue);
                return score + calculateIndexScore(validator, rootSchema, newSchema, formValue || {});
            }
            if (((0, _hasDefault.default)(value, (0, _constants.ONE_OF_KEY)) || (0, _hasDefault.default)(value, (0, _constants.ANY_OF_KEY))) && formValue) {
                const key = (0, _hasDefault.default)(value, (0, _constants.ONE_OF_KEY)) ? (0, _constants.ONE_OF_KEY) : (0, _constants.ANY_OF_KEY);
                const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(value);
                return score + getClosestMatchingOption(validator, rootSchema, formValue, (0, _getDefault.default)(value, key), -1, discriminator);
            }
            if (value.type === "object") return score + calculateIndexScore(validator, rootSchema, value, formValue || {});
            if (value.type === (0, _guessTypeDefault.default)(formValue)) {
                // If the types match, then we bump the score by one
                let newScore = score + 1;
                if (value.default) // If the schema contains a readonly default value score the value that matches the default higher and
                // any non-matching value lower
                newScore += formValue === value.default ? 1 : -1;
                else if (value.const) // If the schema contains a const value score the value that matches the default higher and
                // any non-matching value lower
                newScore += formValue === value.const ? 1 : -1;
                // TODO eventually, deal with enums/arrays
                return newScore;
            }
            return score;
        }, 0);
        else if ((0, _isStringDefault.default)(schema.type) && schema.type === (0, _guessTypeDefault.default)(formData)) totalScore += 1;
    }
    return totalScore;
}
function getClosestMatchingOption(validator, rootSchema, formData, options, selectedOption = -1, discriminatorField) {
    // First resolve any refs in the options
    const resolvedOptions = options.map((option)=>{
        return (0, _retrieveSchema.resolveAllReferences)(option, rootSchema, []);
    });
    const simpleDiscriminatorMatch = (0, _getOptionMatchingSimpleDiscriminatorDefault.default)(formData, options, discriminatorField);
    if ((0, _isNumberDefault.default)(simpleDiscriminatorMatch)) return simpleDiscriminatorMatch;
    // Reduce the array of options down to a list of the indexes that are considered matching options
    const allValidIndexes = resolvedOptions.reduce((validList, option, index)=>{
        const testOptions = [
            JUNK_OPTION,
            option
        ];
        const match = (0, _getFirstMatchingOptionDefault.default)(validator, formData, testOptions, rootSchema, discriminatorField);
        // The match is the real option, so add its index to list of valid indexes
        if (match === 1) validList.push(index);
        return validList;
    }, []);
    // There is only one valid index, so return it!
    if (allValidIndexes.length === 1) return allValidIndexes[0];
    if (!allValidIndexes.length) // No indexes were valid, so we'll score all the options, add all the indexes
    (0, _timesDefault.default)(resolvedOptions.length, (i)=>allValidIndexes.push(i));
    const scoreCount = new Set();
    // Score all the options in the list of valid indexes and return the index with the best score
    const { bestIndex } = allValidIndexes.reduce((scoreData, index)=>{
        const { bestScore } = scoreData;
        const option = resolvedOptions[index];
        const score = calculateIndexScore(validator, rootSchema, option, formData);
        scoreCount.add(score);
        if (score > bestScore) return {
            bestIndex: index,
            bestScore: score
        };
        return scoreData;
    }, {
        bestIndex: selectedOption,
        bestScore: 0
    });
    // if all scores are the same go with selectedOption
    if (scoreCount.size === 1 && selectedOption >= 0) return selectedOption;
    return bestIndex;
}

},{"lodash/get":"g5ox6","lodash/has":"frHYl","lodash/isNumber":"ggoUg","lodash/isObject":"kYJe3","lodash/isString":"gFUE8","lodash/reduce":"gMleP","lodash/times":"47mI7","./getFirstMatchingOption":"ePFIw","./retrieveSchema":"g3Irx","../constants":"7SuQb","../guessType":"Qabco","../getDiscriminatorFieldFromSchema":"lULGM","../getOptionMatchingSimpleDiscriminator":"d39Bz","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"frHYl":[function(require,module,exports) {
var baseHas = require("adf86b651ea78123"), hasPath = require("d1ab8f0895b2d3d5");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function has(object, path) {
    return object != null && hasPath(object, path, baseHas);
}
module.exports = has;

},{"adf86b651ea78123":"egCJ6","d1ab8f0895b2d3d5":"fopIJ"}],"egCJ6":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHas(object, key) {
    return object != null && hasOwnProperty.call(object, key);
}
module.exports = baseHas;

},{}],"fopIJ":[function(require,module,exports) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"7zM0U","47ffafdab3ba0d6f":"g7Fgq","93ebd263ff0131c1":"2vMMN","252ef74480e01958":"jPvkN","23c2f64e75e90a2":"bSsER","af5ade297cb685ee":"bDIXW"}],"ggoUg":[function(require,module,exports) {
var baseGetTag = require("d5df50bb79e32710"), isObjectLike = require("6ae0825ac2dae50f");
/** `Object#toString` result references. */ var numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
    return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
}
module.exports = isNumber;

},{"d5df50bb79e32710":"a1nlZ","6ae0825ac2dae50f":"17Pxd"}],"gFUE8":[function(require,module,exports) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"a1nlZ","46fdd4d2c5d7b4ab":"2vMMN","36ebbb6a9d8b3fe4":"17Pxd"}],"gMleP":[function(require,module,exports) {
var arrayReduce = require("8772d9c160085222"), baseEach = require("7c156122a905f02e"), baseIteratee = require("288ce78b1e338692"), baseReduce = require("7941e51212237a70"), isArray = require("b7d00545ad8400ba");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function reduce(collection, iteratee, accumulator) {
    var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
    return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}
module.exports = reduce;

},{"8772d9c160085222":"lKFFJ","7c156122a905f02e":"35UR4","288ce78b1e338692":"kp7IX","7941e51212237a70":"76SwT","b7d00545ad8400ba":"2vMMN"}],"lKFFJ":[function(require,module,exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = arrayReduce;

},{}],"35UR4":[function(require,module,exports) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"4ePKQ","f1e3fc84161ef3ec":"cwGr1"}],"4ePKQ":[function(require,module,exports) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"6Q5Ej","1fb77c53defe5720":"cpq56"}],"6Q5Ej":[function(require,module,exports) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"gRMOr"}],"gRMOr":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"cwGr1":[function(require,module,exports) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"6tjkt"}],"kp7IX":[function(require,module,exports) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"gdZGe","4f010869f7b63154":"lX4GF","28f06147d1eb9502":"4q4zt","3c56f88c4debf449":"2vMMN","aee920e0ef5bf111":"4cfAG"}],"gdZGe":[function(require,module,exports) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"5FPHR","89e9034a8071e297":"7XkUg","782598b150762386":"ivtGb"}],"5FPHR":[function(require,module,exports) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"bE9kf","9003c0cc8ac007b6":"2rFa2"}],"7XkUg":[function(require,module,exports) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"hG5aw","94ffded3a85af2f6":"cpq56"}],"hG5aw":[function(require,module,exports) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"kYJe3"}],"ivtGb":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"lX4GF":[function(require,module,exports) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"2rFa2","d5ca180f7d6f956a":"g5ox6","3462bb3f546fa1f7":"YHJaw","f5fef07966a1c4ee":"hn10w","2a1cd212d48516":"hG5aw","885e72ee7fc6d296":"ivtGb","cd65eaf4a3af29f6":"bDIXW"}],"YHJaw":[function(require,module,exports) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"dhv12","b0aefd36de99e579":"fopIJ"}],"dhv12":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"4cfAG":[function(require,module,exports) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"bUI4x","abf31da39349df22":"f0Izz","a387ef4a4373de2c":"hn10w","9315973458389ae7":"bDIXW"}],"bUI4x":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"f0Izz":[function(require,module,exports) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"5yD9j"}],"76SwT":[function(require,module,exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = baseReduce;

},{}],"47mI7":[function(require,module,exports) {
var baseTimes = require("c53ee78be6207d9e"), castFunction = require("ee0d1e8cec6d9709"), toInteger = require("71e7e31e9a6f7634");
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function times(n, iteratee) {
    n = toInteger(n);
    if (n < 1 || n > MAX_SAFE_INTEGER) return [];
    var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
    iteratee = castFunction(iteratee);
    n -= MAX_ARRAY_LENGTH;
    var result = baseTimes(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
module.exports = times;

},{"c53ee78be6207d9e":"Xdcvx","ee0d1e8cec6d9709":"9r5CH","71e7e31e9a6f7634":"li2Vq"}],"9r5CH":[function(require,module,exports) {
var identity = require("c0eaa1c5ad52cc2f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == "function" ? value : identity;
}
module.exports = castFunction;

},{"c0eaa1c5ad52cc2f":"4q4zt"}],"li2Vq":[function(require,module,exports) {
var toFinite = require("e624a4916a3de577");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"e624a4916a3de577":"5VPJi"}],"5VPJi":[function(require,module,exports) {
var toNumber = require("90c5878489629896");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"90c5878489629896":"khjK3"}],"khjK3":[function(require,module,exports) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"jTFpN","faaa289d287a34a5":"kYJe3","47b3bd23f771891":"b0EEv"}],"jTFpN":[function(require,module,exports) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"72LG9"}],"72LG9":[function(require,module,exports) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"ePFIw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFirstMatchingOption);
var _getMatchingOption = require("./getMatchingOption");
var _getMatchingOptionDefault = parcelHelpers.interopDefault(_getMatchingOption);
function getFirstMatchingOption(validator, formData, options, rootSchema, discriminatorField) {
    return (0, _getMatchingOptionDefault.default)(validator, formData, options, rootSchema, discriminatorField);
}

},{"./getMatchingOption":"a7A4o","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a7A4o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMatchingOption);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _isNumber = require("lodash/isNumber");
var _isNumberDefault = parcelHelpers.interopDefault(_isNumber);
var _constants = require("../constants");
var _getOptionMatchingSimpleDiscriminator = require("../getOptionMatchingSimpleDiscriminator");
var _getOptionMatchingSimpleDiscriminatorDefault = parcelHelpers.interopDefault(_getOptionMatchingSimpleDiscriminator);
function getMatchingOption(validator, formData, options, rootSchema, discriminatorField) {
    // For performance, skip validating subschemas if formData is undefined. We just
    // want to get the first option in that case.
    if (formData === undefined) return 0;
    const simpleDiscriminatorMatch = (0, _getOptionMatchingSimpleDiscriminatorDefault.default)(formData, options, discriminatorField);
    if ((0, _isNumberDefault.default)(simpleDiscriminatorMatch)) return simpleDiscriminatorMatch;
    for(let i = 0; i < options.length; i++){
        const option = options[i];
        // If we have a discriminator field, then we will use this to make the determination
        if (discriminatorField && (0, _hasDefault.default)(option, [
            (0, _constants.PROPERTIES_KEY),
            discriminatorField
        ])) {
            const value = (0, _getDefault.default)(formData, discriminatorField);
            const discriminator = (0, _getDefault.default)(option, [
                (0, _constants.PROPERTIES_KEY),
                discriminatorField
            ], {});
            if (validator.isValid(discriminator, value, rootSchema)) return i;
        } else if (option[0, _constants.PROPERTIES_KEY]) {
            // If the schema describes an object then we need to add slightly more
            // strict matching to the schema, because unless the schema uses the
            // "requires" keyword, an object will match the schema as long as it
            // doesn't have matching keys with a conflicting type. To do this we use an
            // "anyOf" with an array of requires. This augmentation expresses that the
            // schema should match if any of the keys in the schema are present on the
            // object and pass validation.
            //
            // Create an "anyOf" schema that requires at least one of the keys in the
            // "properties" object
            const requiresAnyOf = {
                anyOf: Object.keys(option[0, _constants.PROPERTIES_KEY]).map((key)=>({
                        required: [
                            key
                        ]
                    }))
            };
            let augmentedSchema;
            // If the "anyOf" keyword already exists, wrap the augmentation in an "allOf"
            if (option.anyOf) {
                // Create a shallow clone of the option
                const { ...shallowClone } = option;
                if (!shallowClone.allOf) shallowClone.allOf = [];
                else // If "allOf" already exists, shallow clone the array
                shallowClone.allOf = shallowClone.allOf.slice();
                shallowClone.allOf.push(requiresAnyOf);
                augmentedSchema = shallowClone;
            } else augmentedSchema = Object.assign({}, option, requiresAnyOf);
            // Remove the "required" field as it's likely that not all fields have
            // been filled in yet, which will mean that the schema is not valid
            delete augmentedSchema.required;
            if (validator.isValid(augmentedSchema, formData, rootSchema)) return i;
        } else if (validator.isValid(option, formData, rootSchema)) return i;
    }
    return 0;
}

},{"lodash/get":"g5ox6","lodash/has":"frHYl","lodash/isNumber":"ggoUg","../constants":"7SuQb","../getOptionMatchingSimpleDiscriminator":"d39Bz","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d39Bz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOptionMatchingSimpleDiscriminator);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _constants = require("./constants");
function getOptionMatchingSimpleDiscriminator(formData, options, discriminatorField) {
    var _a;
    if (formData && discriminatorField) {
        const value = (0, _getDefault.default)(formData, discriminatorField);
        if (value === undefined) return;
        for(let i = 0; i < options.length; i++){
            const option = options[i];
            const discriminator = (0, _getDefault.default)(option, [
                (0, _constants.PROPERTIES_KEY),
                discriminatorField
            ], {});
            if (discriminator.type === "object" || discriminator.type === "array") continue;
            if (discriminator.const === value) return i;
            if ((_a = discriminator.enum) === null || _a === void 0 ? void 0 : _a.includes(value)) return i;
        }
    }
    return;
}

},{"lodash/get":"g5ox6","./constants":"7SuQb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g3Irx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>retrieveSchema);
/** Resolves a conditional block (if/else/then) by removing the condition and merging the appropriate conditional branch
 * with the rest of the schema. If `expandAllBranches` is true, then the `retrieveSchemaInteral()` results for both
 * conditions will be returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that is used to detect valid schema conditions
 * @param schema - The schema for which resolving a condition is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and
 *          dependencies as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData to assist retrieving a schema
 * @returns - A list of schemas with the appropriate conditions resolved, possibly with all branches expanded
 */ parcelHelpers.export(exports, "resolveCondition", ()=>resolveCondition);
/** Given a list of lists of allOf, anyOf or oneOf values, create a list of lists of all permutations of the values. The
 * `listOfLists` is expected to be all resolved values of the 1st...nth schemas within an `allOf`, `anyOf` or `oneOf`.
 * From those lists, build a matrix for each `xxxOf` where there is more than one schema for a row in the list of lists.
 *
 * For example:
 * - If there are three xxxOf rows (A, B, C) and they have been resolved such that there is only one A, two B and three
 *   C schemas then:
 *   - The permutation for the first row is `[[A]]`
 *   - The permutations for the second row are `[[A,B1], [A,B2]]`
 *   - The permutations for the third row are `[[A,B1,C1], [A,B1,C2], [A,B1,C3], [A,B2,C1], [A,B2,C2], [A,B2,C3]]`
 *
 * @param listOfLists - The list of lists of elements that represent the allOf, anyOf or oneOf resolved values in order
 * @returns - The list of all permutations of schemas for a set of `xxxOf`s
 */ parcelHelpers.export(exports, "getAllPermutationsOfXxxOf", ()=>getAllPermutationsOfXxxOf);
/** Resolves references and dependencies within a schema and its 'allOf' children. Passes the `expandAllBranches` flag
 * down to the `retrieveSchemaInternal()`, `resolveReference()` and `resolveDependencies()` helper calls. If
 * `expandAllBranches` is true, then all possible dependencies and/or allOf branches are returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @returns - The list of schemas having its references, dependencies and allOf schemas resolved
 */ parcelHelpers.export(exports, "resolveSchema", ()=>resolveSchema);
/** Resolves all references within a schema and then returns the `retrieveSchemaInternal()` if the resolved schema is
 * actually different than the original. Passes the `expandAllBranches` flag down to the `retrieveSchemaInternal()`
 * helper call.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a reference is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @returns - The list schemas retrieved after having all references resolved
 */ parcelHelpers.export(exports, "resolveReference", ()=>resolveReference);
/** Resolves all references within the schema itself as well as any of its properties and array items.
 *
 * @param schema - The schema for which resolving all references is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param recurseList - List of $refs already resolved to prevent recursion
 * @returns - given schema will all references resolved or the original schema if no internal `$refs` were resolved
 */ parcelHelpers.export(exports, "resolveAllReferences", ()=>resolveAllReferences);
/** Creates new 'properties' items for each key in the `formData`
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param theSchema - The schema for which the existing additional properties is desired
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s * @param validator
 * @param [aFormData] - The current formData, if any, to assist retrieving a schema
 * @returns - The updated schema with additional properties stubbed
 */ parcelHelpers.export(exports, "stubExistingAdditionalProperties", ()=>stubExistingAdditionalProperties);
/** Internal handler that retrieves an expanded schema that has had all of its conditions, additional properties,
 * references and dependencies resolved and merged into the `schema` given a `validator`, `rootSchema` and `rawFormData`
 * that is used to do the potentially recursive resolution. If `expandAllBranches` is true, then all possible branches
 * of the schema and its references, conditions and dependencies are returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which retrieving a schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param [rawFormData] - The current formData, if any, to assist retrieving a schema
 * @param [expandAllBranches=false] - Flag, if true, will return all possible branches of conditions, any/oneOf and
 *          dependencies as a list of schemas
 * @param [recurseList=[]] - The optional, list of recursive references already processed
 * @returns - The schema(s) resulting from having its conditions, additional properties, references and dependencies
 *          resolved. Multiple schemas may be returned if `expandAllBranches` is true.
 */ parcelHelpers.export(exports, "retrieveSchemaInternal", ()=>retrieveSchemaInternal);
/** Resolves an `anyOf` or `oneOf` within a schema (if present) to the list of schemas returned from
 * `retrieveSchemaInternal()` for the best matching option. If `expandAllBranches` is true, then a list of schemas for ALL
 * options are retrieved and returned.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which retrieving a schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param [rawFormData] - The current formData, if any, to assist retrieving a schema, defaults to an empty object
 * @returns - Either an array containing the best matching option or all options if `expandAllBranches` is true
 */ parcelHelpers.export(exports, "resolveAnyOrOneOfSchemas", ()=>resolveAnyOrOneOfSchemas);
/** Resolves dependencies within a schema and its 'anyOf/oneOf' children. Passes the `expandAllBranches` flag down to
 * the `resolveAnyOrOneOfSchema()` and `processDependencies()` helper calls.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a dependency is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @returns - The list of schemas with their dependencies resolved
 */ parcelHelpers.export(exports, "resolveDependencies", ()=>resolveDependencies);
/** Processes all the `dependencies` recursively into the list of `resolvedSchema`s as needed. Passes the
 * `expandAllBranches` flag down to the `withDependentSchema()` and the recursive `processDependencies()` helper calls.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param dependencies - The set of dependencies that needs to be processed
 * @param resolvedSchema - The schema for which processing dependencies is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @returns - The schema with the `dependencies` resolved into it
 */ parcelHelpers.export(exports, "processDependencies", ()=>processDependencies);
/** Updates a schema with additionally required properties added
 *
 * @param schema - The schema for which resolving a dependent properties is desired
 * @param [additionallyRequired] - An optional array of additionally required names
 * @returns - The schema with the additional required values merged in
 */ parcelHelpers.export(exports, "withDependentProperties", ()=>withDependentProperties);
/** Merges a dependent schema into the `schema` dealing with oneOfs and references. Passes the `expandAllBranches` flag
 * down to the `retrieveSchemaInternal()`, `resolveReference()` and `withExactlyOneSubschema()` helper calls.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be forwarded to all the APIs
 * @param schema - The schema for which resolving a dependent schema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param dependencyKey - The key name of the dependency
 * @param dependencyValue - The potentially dependent schema
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData]- The current formData to assist retrieving a schema
 * @returns - The list of schemas with the dependent schema resolved into them
 */ parcelHelpers.export(exports, "withDependentSchema", ()=>withDependentSchema);
/** Returns a list of `schema`s with the best choice from the `oneOf` options merged into it. If `expandAllBranches` is
 * true, then a list of schemas for ALL options are retrieved and returned. Passes the `expandAllBranches` flag down to
 * the `retrieveSchemaInternal()` helper call.
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used to validate oneOf options
 * @param schema - The schema for which resolving a oneOf subschema is desired
 * @param rootSchema - The root schema that will be forwarded to all the APIs
 * @param dependencyKey - The key name of the oneOf dependency
 * @param oneOf - The list of schemas representing the oneOf options
 * @param expandAllBranches - Flag, if true, will return all possible branches of conditions, any/oneOf and dependencies
 *          as a list of schemas
 * @param recurseList - The list of recursive references already processed
 * @param [formData] - The current formData to assist retrieving a schema
 * @returns - Either an array containing the best matching option or all options if `expandAllBranches` is true
 */ parcelHelpers.export(exports, "withExactlyOneSubschema", ()=>withExactlyOneSubschema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _times = require("lodash/times");
var _timesDefault = parcelHelpers.interopDefault(_times);
var _transform = require("lodash/transform");
var _transformDefault = parcelHelpers.interopDefault(_transform);
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _flattenDeep = require("lodash/flattenDeep");
var _flattenDeepDefault = parcelHelpers.interopDefault(_flattenDeep);
var _uniq = require("lodash/uniq");
var _uniqDefault = parcelHelpers.interopDefault(_uniq);
var _jsonSchemaMergeAllof = require("json-schema-merge-allof");
var _jsonSchemaMergeAllofDefault = parcelHelpers.interopDefault(_jsonSchemaMergeAllof);
var _constants = require("../constants");
var _findSchemaDefinition = require("../findSchemaDefinition");
var _findSchemaDefinitionDefault = parcelHelpers.interopDefault(_findSchemaDefinition);
var _getDiscriminatorFieldFromSchema = require("../getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _guessType = require("../guessType");
var _guessTypeDefault = parcelHelpers.interopDefault(_guessType);
var _isObject = require("../isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _mergeSchemas = require("../mergeSchemas");
var _mergeSchemasDefault = parcelHelpers.interopDefault(_mergeSchemas);
var _getFirstMatchingOption = require("./getFirstMatchingOption");
var _getFirstMatchingOptionDefault = parcelHelpers.interopDefault(_getFirstMatchingOption);
function retrieveSchema(validator, schema, rootSchema = {}, rawFormData) {
    return retrieveSchemaInternal(validator, schema, rootSchema, rawFormData)[0];
}
function resolveCondition(validator, schema, rootSchema, expandAllBranches, recurseList, formData) {
    const { if: expression, then, else: otherwise, ...resolvedSchemaLessConditional } = schema;
    const conditionValue = validator.isValid(expression, formData || {}, rootSchema);
    let resolvedSchemas = [
        resolvedSchemaLessConditional
    ];
    let schemas = [];
    if (expandAllBranches) {
        if (then && typeof then !== "boolean") schemas = schemas.concat(retrieveSchemaInternal(validator, then, rootSchema, formData, expandAllBranches, recurseList));
        if (otherwise && typeof otherwise !== "boolean") schemas = schemas.concat(retrieveSchemaInternal(validator, otherwise, rootSchema, formData, expandAllBranches, recurseList));
    } else {
        const conditionalSchema = conditionValue ? then : otherwise;
        if (conditionalSchema && typeof conditionalSchema !== "boolean") schemas = schemas.concat(retrieveSchemaInternal(validator, conditionalSchema, rootSchema, formData, expandAllBranches, recurseList));
    }
    if (schemas.length) resolvedSchemas = schemas.map((s)=>(0, _mergeSchemasDefault.default)(resolvedSchemaLessConditional, s));
    return resolvedSchemas.flatMap((s)=>retrieveSchemaInternal(validator, s, rootSchema, formData, expandAllBranches, recurseList));
}
function getAllPermutationsOfXxxOf(listOfLists) {
    const allPermutations = listOfLists.reduce((permutations, list)=>{
        // When there are more than one set of schemas for a row, duplicate the set of permutations and add in the values
        if (list.length > 1) return list.flatMap((element)=>(0, _timesDefault.default)(permutations.length, (i)=>[
                    ...permutations[i]
                ].concat(element)));
        // Otherwise just push in the single value into the current set of permutations
        permutations.forEach((permutation)=>permutation.push(list[0]));
        return permutations;
    }, [
        []
    ] // Start with an empty list
    );
    return allPermutations;
}
function resolveSchema(validator, schema, rootSchema, expandAllBranches, recurseList, formData) {
    const updatedSchemas = resolveReference(validator, schema, rootSchema, expandAllBranches, recurseList, formData);
    if (updatedSchemas.length > 1 || updatedSchemas[0] !== schema) // return the updatedSchemas array if it has either multiple schemas within it
    // OR the first schema is not the same as the original schema
    return updatedSchemas;
    if ((0, _constants.DEPENDENCIES_KEY) in schema) {
        const resolvedSchemas = resolveDependencies(validator, schema, rootSchema, expandAllBranches, recurseList, formData);
        return resolvedSchemas.flatMap((s)=>{
            return retrieveSchemaInternal(validator, s, rootSchema, formData, expandAllBranches, recurseList);
        });
    }
    if ((0, _constants.ALL_OF_KEY) in schema && Array.isArray(schema.allOf)) {
        const allOfSchemaElements = schema.allOf.map((allOfSubschema)=>retrieveSchemaInternal(validator, allOfSubschema, rootSchema, formData, expandAllBranches, recurseList));
        const allPermutations = getAllPermutationsOfXxxOf(allOfSchemaElements);
        return allPermutations.map((permutation)=>({
                ...schema,
                allOf: permutation
            }));
    }
    // No $ref or dependencies or allOf attribute was found, returning the original schema.
    return [
        schema
    ];
}
function resolveReference(validator, schema, rootSchema, expandAllBranches, recurseList, formData) {
    const updatedSchema = resolveAllReferences(schema, rootSchema, recurseList);
    if (updatedSchema !== schema) // Only call this if the schema was actually changed by the `resolveAllReferences()` function
    return retrieveSchemaInternal(validator, updatedSchema, rootSchema, formData, expandAllBranches, recurseList);
    return [
        schema
    ];
}
function resolveAllReferences(schema, rootSchema, recurseList) {
    if (!(0, _isObjectDefault.default)(schema)) return schema;
    let resolvedSchema = schema;
    // resolve top level ref
    if ((0, _constants.REF_KEY) in resolvedSchema) {
        const { $ref, ...localSchema } = resolvedSchema;
        // Check for a recursive reference and stop the loop
        if (recurseList.includes($ref)) return resolvedSchema;
        recurseList.push($ref);
        // Retrieve the referenced schema definition.
        const refSchema = (0, _findSchemaDefinitionDefault.default)($ref, rootSchema);
        resolvedSchema = {
            ...refSchema,
            ...localSchema
        };
    }
    if ((0, _constants.PROPERTIES_KEY) in resolvedSchema) {
        const childrenLists = [];
        const updatedProps = (0, _transformDefault.default)(resolvedSchema[0, _constants.PROPERTIES_KEY], (result, value, key)=>{
            const childList = [
                ...recurseList
            ];
            result[key] = resolveAllReferences(value, rootSchema, childList);
            childrenLists.push(childList);
        }, {});
        (0, _mergeDefault.default)(recurseList, (0, _uniqDefault.default)((0, _flattenDeepDefault.default)(childrenLists)));
        resolvedSchema = {
            ...resolvedSchema,
            [(0, _constants.PROPERTIES_KEY)]: updatedProps
        };
    }
    if ((0, _constants.ITEMS_KEY) in resolvedSchema && !Array.isArray(resolvedSchema.items) && typeof resolvedSchema.items !== "boolean") resolvedSchema = {
        ...resolvedSchema,
        items: resolveAllReferences(resolvedSchema.items, rootSchema, recurseList)
    };
    return (0, _isEqualDefault.default)(schema, resolvedSchema) ? schema : resolvedSchema;
}
function stubExistingAdditionalProperties(validator, theSchema, rootSchema, aFormData) {
    // Clone the schema so that we don't ruin the consumer's original
    const schema = {
        ...theSchema,
        properties: {
            ...theSchema.properties
        }
    };
    // make sure formData is an object
    const formData = aFormData && (0, _isObjectDefault.default)(aFormData) ? aFormData : {};
    Object.keys(formData).forEach((key)=>{
        if (key in schema.properties) // No need to stub, our schema already has the property
        return;
        let additionalProperties = {};
        if (typeof schema.additionalProperties !== "boolean") {
            if ((0, _constants.REF_KEY) in schema.additionalProperties) additionalProperties = retrieveSchema(validator, {
                $ref: (0, _getDefault.default)(schema.additionalProperties, [
                    (0, _constants.REF_KEY)
                ])
            }, rootSchema, formData);
            else if ("type" in schema.additionalProperties) additionalProperties = {
                ...schema.additionalProperties
            };
            else if ((0, _constants.ANY_OF_KEY) in schema.additionalProperties || (0, _constants.ONE_OF_KEY) in schema.additionalProperties) additionalProperties = {
                type: "object",
                ...schema.additionalProperties
            };
            else additionalProperties = {
                type: (0, _guessTypeDefault.default)((0, _getDefault.default)(formData, [
                    key
                ]))
            };
        } else additionalProperties = {
            type: (0, _guessTypeDefault.default)((0, _getDefault.default)(formData, [
                key
            ]))
        };
        // The type of our new key should match the additionalProperties value;
        schema.properties[key] = additionalProperties;
        // Set our additional property flag so we know it was dynamically added
        (0, _setDefault.default)(schema.properties, [
            key,
            (0, _constants.ADDITIONAL_PROPERTY_FLAG)
        ], true);
    });
    return schema;
}
function retrieveSchemaInternal(validator, schema, rootSchema, rawFormData, expandAllBranches = false, recurseList = []) {
    if (!(0, _isObjectDefault.default)(schema)) return [
        {}
    ];
    const resolvedSchemas = resolveSchema(validator, schema, rootSchema, expandAllBranches, recurseList, rawFormData);
    return resolvedSchemas.flatMap((s)=>{
        let resolvedSchema = s;
        if ((0, _constants.IF_KEY) in resolvedSchema) return resolveCondition(validator, resolvedSchema, rootSchema, expandAllBranches, recurseList, rawFormData);
        if ((0, _constants.ALL_OF_KEY) in resolvedSchema) {
            // resolve allOf schemas
            if (expandAllBranches) {
                const { allOf, ...restOfSchema } = resolvedSchema;
                return [
                    ...allOf,
                    restOfSchema
                ];
            }
            try {
                resolvedSchema = (0, _jsonSchemaMergeAllofDefault.default)(resolvedSchema, {
                    deep: false
                });
            } catch (e) {
                console.warn("could not merge subschemas in allOf:\n", e);
                const { allOf, ...resolvedSchemaWithoutAllOf } = resolvedSchema;
                return resolvedSchemaWithoutAllOf;
            }
        }
        const hasAdditionalProperties = (0, _constants.ADDITIONAL_PROPERTIES_KEY) in resolvedSchema && resolvedSchema.additionalProperties !== false;
        if (hasAdditionalProperties) return stubExistingAdditionalProperties(validator, resolvedSchema, rootSchema, rawFormData);
        return resolvedSchema;
    });
}
function resolveAnyOrOneOfSchemas(validator, schema, rootSchema, expandAllBranches, rawFormData) {
    let anyOrOneOf;
    const { oneOf, anyOf, ...remaining } = schema;
    if (Array.isArray(oneOf)) anyOrOneOf = oneOf;
    else if (Array.isArray(anyOf)) anyOrOneOf = anyOf;
    if (anyOrOneOf) {
        // Ensure that during expand all branches we pass an object rather than undefined so that all options are interrogated
        const formData = rawFormData === undefined && expandAllBranches ? {} : rawFormData;
        const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(schema);
        anyOrOneOf = anyOrOneOf.map((s)=>{
            // Due to anyOf/oneOf possibly using the same $ref we always pass a fresh recurse list array so that each option
            // can resolve recursive references independently
            return resolveAllReferences(s, rootSchema, []);
        });
        // Call this to trigger the set of isValid() calls that the schema parser will need
        const option = (0, _getFirstMatchingOptionDefault.default)(validator, formData, anyOrOneOf, rootSchema, discriminator);
        if (expandAllBranches) return anyOrOneOf.map((item)=>(0, _mergeSchemasDefault.default)(remaining, item));
        schema = (0, _mergeSchemasDefault.default)(remaining, anyOrOneOf[option]);
    }
    return [
        schema
    ];
}
function resolveDependencies(validator, schema, rootSchema, expandAllBranches, recurseList, formData) {
    // Drop the dependencies from the source schema.
    const { dependencies, ...remainingSchema } = schema;
    const resolvedSchemas = resolveAnyOrOneOfSchemas(validator, remainingSchema, rootSchema, expandAllBranches, formData);
    return resolvedSchemas.flatMap((resolvedSchema)=>processDependencies(validator, dependencies, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData));
}
function processDependencies(validator, dependencies, resolvedSchema, rootSchema, expandAllBranches, recurseList, formData) {
    let schemas = [
        resolvedSchema
    ];
    // Process dependencies updating the local schema properties as appropriate.
    for(const dependencyKey in dependencies){
        // Skip this dependency if its trigger property is not present.
        if (!expandAllBranches && (0, _getDefault.default)(formData, [
            dependencyKey
        ]) === undefined) continue;
        // Skip this dependency if it is not included in the schema (such as when dependencyKey is itself a hidden dependency.)
        if (resolvedSchema.properties && !(dependencyKey in resolvedSchema.properties)) continue;
        const [remainingDependencies, dependencyValue] = (0, _findSchemaDefinition.splitKeyElementFromObject)(dependencyKey, dependencies);
        if (Array.isArray(dependencyValue)) schemas[0] = withDependentProperties(resolvedSchema, dependencyValue);
        else if ((0, _isObjectDefault.default)(dependencyValue)) schemas = withDependentSchema(validator, resolvedSchema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData);
        return schemas.flatMap((schema)=>processDependencies(validator, remainingDependencies, schema, rootSchema, expandAllBranches, recurseList, formData));
    }
    return schemas;
}
function withDependentProperties(schema, additionallyRequired) {
    if (!additionallyRequired) return schema;
    const required = Array.isArray(schema.required) ? Array.from(new Set([
        ...schema.required,
        ...additionallyRequired
    ])) : additionallyRequired;
    return {
        ...schema,
        required: required
    };
}
function withDependentSchema(validator, schema, rootSchema, dependencyKey, dependencyValue, expandAllBranches, recurseList, formData) {
    const dependentSchemas = retrieveSchemaInternal(validator, dependencyValue, rootSchema, formData, expandAllBranches, recurseList);
    return dependentSchemas.flatMap((dependent)=>{
        const { oneOf, ...dependentSchema } = dependent;
        schema = (0, _mergeSchemasDefault.default)(schema, dependentSchema);
        // Since it does not contain oneOf, we return the original schema.
        if (oneOf === undefined) return schema;
        // Resolve $refs inside oneOf.
        const resolvedOneOfs = oneOf.map((subschema)=>{
            if (typeof subschema === "boolean" || !((0, _constants.REF_KEY) in subschema)) return [
                subschema
            ];
            return resolveReference(validator, subschema, rootSchema, expandAllBranches, recurseList, formData);
        });
        const allPermutations = getAllPermutationsOfXxxOf(resolvedOneOfs);
        return allPermutations.flatMap((resolvedOneOf)=>withExactlyOneSubschema(validator, schema, rootSchema, dependencyKey, resolvedOneOf, expandAllBranches, recurseList, formData));
    });
}
function withExactlyOneSubschema(validator, schema, rootSchema, dependencyKey, oneOf, expandAllBranches, recurseList, formData) {
    const validSubschemas = oneOf.filter((subschema)=>{
        if (typeof subschema === "boolean" || !subschema || !subschema.properties) return false;
        const { [dependencyKey]: conditionPropertySchema } = subschema.properties;
        if (conditionPropertySchema) {
            const conditionSchema = {
                type: "object",
                properties: {
                    [dependencyKey]: conditionPropertySchema
                }
            };
            return validator.isValid(conditionSchema, formData, rootSchema) || expandAllBranches;
        }
        return false;
    });
    if (!expandAllBranches && validSubschemas.length !== 1) {
        console.warn("ignoring oneOf in dependencies because there isn't exactly one subschema that is valid");
        return [
            schema
        ];
    }
    return validSubschemas.flatMap((s)=>{
        const subschema = s;
        const [dependentSubschema] = (0, _findSchemaDefinition.splitKeyElementFromObject)(dependencyKey, subschema.properties);
        const dependentSchema = {
            ...subschema,
            properties: dependentSubschema
        };
        const schemas = retrieveSchemaInternal(validator, dependentSchema, rootSchema, formData, expandAllBranches, recurseList);
        return schemas.map((s)=>(0, _mergeSchemasDefault.default)(schema, s));
    });
}

},{"lodash/get":"g5ox6","lodash/isEqual":"cMAmC","lodash/set":"04gxh","lodash/times":"47mI7","lodash/transform":"7fC25","lodash/merge":"8XUBI","lodash/flattenDeep":"dFca2","lodash/uniq":"ewIby","json-schema-merge-allof":"76sv1","../constants":"7SuQb","../findSchemaDefinition":"cMrNB","../getDiscriminatorFieldFromSchema":"lULGM","../guessType":"Qabco","../isObject":"9dcnp","../mergeSchemas":"dxsEQ","./getFirstMatchingOption":"ePFIw","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cMAmC":[function(require,module,exports) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"2rFa2"}],"04gxh":[function(require,module,exports) {
var baseSet = require("a003324b62105673");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function set(object, path, value) {
    return object == null ? object : baseSet(object, path, value);
}
module.exports = set;

},{"a003324b62105673":"3qkFO"}],"3qkFO":[function(require,module,exports) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"1GsQO","56e0b8a492d56399":"7zM0U","d1eb8acc5a65dc38":"jPvkN","dfb182b16ef275c0":"kYJe3","6a51dc787ca5b6e3":"bDIXW"}],"7fC25":[function(require,module,exports) {
var arrayEach = require("d57417dcea9d94ef"), baseCreate = require("ae8b9c2d0de74697"), baseForOwn = require("e8007e2f3ceb005"), baseIteratee = require("476d1d83c8d574f1"), getPrototype = require("acfb4accdf68465"), isArray = require("88449cb98c9006a6"), isBuffer = require("7c5216b8ad5bca12"), isFunction = require("476eb3f3ee868a2c"), isObject = require("500add944347d34f"), isTypedArray = require("f3f8e3916066083f");
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function transform(object, iteratee, accumulator) {
    var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
    iteratee = baseIteratee(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
module.exports = transform;

},{"d57417dcea9d94ef":"545SQ","ae8b9c2d0de74697":"aBMSU","e8007e2f3ceb005":"4ePKQ","476d1d83c8d574f1":"kp7IX","acfb4accdf68465":"4IYkl","88449cb98c9006a6":"2vMMN","7c5216b8ad5bca12":"arWtb","476eb3f3ee868a2c":"jdOCL","500add944347d34f":"kYJe3","f3f8e3916066083f":"fDUzl"}],"8XUBI":[function(require,module,exports) {
var baseMerge = require("7b601c4be119b25d"), createAssigner = require("e87a09d93c0fc32d");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"7b601c4be119b25d":"1HhBF","e87a09d93c0fc32d":"cCe8Q"}],"1HhBF":[function(require,module,exports) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"bE9kf","76e9fd6386317324":"8Z9Od","e7dca58bcfe9c669":"6Q5Ej","4ea46d88599071ec":"ehaTA","c52c932be04280cc":"kYJe3","27adf66142f57b4b":"cYRBj","564385b2292facea":"iIwwF"}],"8Z9Od":[function(require,module,exports) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"66fGk","7d9c95e1ffdd4f16":"9yMLM"}],"ehaTA":[function(require,module,exports) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"8Z9Od","ec8e1b90277c5e12":"d1F9Q","4b1a2b5090faf247":"11I6K","d7675bdf0a02bffc":"jNUX7","1067a6f3f6bd5986":"3NCrZ","2238139506f6727b":"g7Fgq","290c774b41e416bb":"2vMMN","f481819c40e5b527":"cwU9N","6532fda6a198015f":"arWtb","7f306c94b573f977":"jdOCL","32c89e763261c579":"kYJe3","ff359d315efefc4f":"g5UGm","61ce92c01fd411fe":"fDUzl","abfa8f7e72201edb":"iIwwF","c54d414b219fa287":"dP4Go"}],"cwU9N":[function(require,module,exports) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"6tjkt","639a4883b097af28":"17Pxd"}],"iIwwF":[function(require,module,exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = safeGet;

},{}],"dP4Go":[function(require,module,exports) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"irgYF","437a3e3814017158":"cYRBj"}],"cCe8Q":[function(require,module,exports) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"23bOk","4f5832110eba92d3":"798t3"}],"23bOk":[function(require,module,exports) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"4q4zt","ff7d23ff2a2ea6f8":"eGjc4","a11d545e809d14f7":"hhR0y"}],"798t3":[function(require,module,exports) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"9yMLM","616bc732534dffe0":"6tjkt","e781332a36d1bd7":"jPvkN","c8548bf6929b8a5d":"kYJe3"}],"dFca2":[function(require,module,exports) {
var baseFlatten = require("57782bd3a8a372a0");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, INFINITY) : [];
}
module.exports = flattenDeep;

},{"57782bd3a8a372a0":"6cEdQ"}],"ewIby":[function(require,module,exports) {
var baseUniq = require("8e268641906a92b2");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}
module.exports = uniq;

},{"8e268641906a92b2":"e1UjE"}],"e1UjE":[function(require,module,exports) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"dLr8c","a1d85be956e037a9":"fbGrX","8cd18f86a4a2c118":"cE5Gg","3acf9f4a3a78c511":"68Ius","19b77385b4f7775a":"eFHJ4","4568580f7416eb83":"lN92r"}],"fbGrX":[function(require,module,exports) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"eYHU9"}],"eYHU9":[function(require,module,exports) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"fpzTX","c991ed2b82d165b":"eg1I6","c0bb8190b05a00a5":"cCOZu"}],"fpzTX":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"eg1I6":[function(require,module,exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"cCOZu":[function(require,module,exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"cE5Gg":[function(require,module,exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"eFHJ4":[function(require,module,exports) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"8m712","a02c367b3608ccee":"23DmJ","cd8d0af6a14b2f7d":"lN92r"}],"23DmJ":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"76sv1":[function(require,module,exports) {
const cloneDeep = require("eaede3ab6d27e129");
const compare = require("1a2afe8d0c610fb0");
const computeLcm = require("442e4feed98e459");
const defaultsDeep = require("e25f416854cb8173");
const flatten = require("ac7f62997984c20c");
const flattenDeep = require("88b49ca963adb703");
const intersection = require("6c293d3bddf92666");
const intersectionWith = require("7ea3115b810a7014");
const isEqual = require("4d5667d6f26039ba");
const isPlainObject = require("fbc0c1d2257f94b");
const pullAll = require("838199c0d6d6c4e5");
const sortBy = require("33f995abdc38f788");
const uniq = require("71ac4cce2884b18c");
const uniqWith = require("c445257c25fff161");
const propertiesResolver = require("94c0843ee6bd2bdc");
const itemsResolver = require("35db618df5ee8d2e");
const contains = (arr, val)=>arr.indexOf(val) !== -1;
const isSchema = (val)=>isPlainObject(val) || val === true || val === false;
const isFalse = (val)=>val === false;
const isTrue = (val)=>val === true;
const schemaResolver = (compacted, key, mergeSchemas)=>mergeSchemas(compacted);
const stringArray = (values)=>sortBy(uniq(flattenDeep(values)));
const notUndefined = (val)=>val !== undefined;
const allUniqueKeys = (arr)=>uniq(flattenDeep(arr.map(keys)));
// resolvers
const first = (compacted)=>compacted[0];
const required = (compacted)=>stringArray(compacted);
const maximumValue = (compacted)=>Math.max.apply(Math, compacted);
const minimumValue = (compacted)=>Math.min.apply(Math, compacted);
const uniqueItems = (compacted)=>compacted.some(isTrue);
const examples = (compacted)=>uniqWith(flatten(compacted), isEqual);
function compareProp(key) {
    return function(a, b) {
        return compare({
            [key]: a
        }, {
            [key]: b
        });
    };
}
function getAllOf(schema) {
    let { allOf = [], ...copy } = schema;
    copy = isPlainObject(schema) ? copy : schema // if schema is boolean
    ;
    return [
        copy,
        ...allOf.map(getAllOf)
    ];
}
function getValues(schemas, key) {
    return schemas.map((schema)=>schema && schema[key]);
}
function tryMergeSchemaGroups(schemaGroups, mergeSchemas) {
    return schemaGroups.map(function(schemas, index) {
        try {
            return mergeSchemas(schemas, index);
        } catch (e) {
            return undefined;
        }
    }).filter(notUndefined);
}
function keys(obj) {
    if (isPlainObject(obj) || Array.isArray(obj)) return Object.keys(obj);
    else return [];
}
function getAnyOfCombinations(arrOfArrays, combinations) {
    combinations = combinations || [];
    if (!arrOfArrays.length) return combinations;
    const values = arrOfArrays.slice(0).shift();
    const rest = arrOfArrays.slice(1);
    if (combinations.length) return getAnyOfCombinations(rest, flatten(combinations.map((combination)=>values.map((item)=>[
                item
            ].concat(combination)))));
    return getAnyOfCombinations(rest, values.map((item)=>item));
}
function throwIncompatible(values, paths) {
    let asJSON;
    try {
        asJSON = values.map(function(val) {
            return JSON.stringify(val, null, 2);
        }).join("\n");
    } catch (variable) {
        asJSON = values.join(", ");
    }
    throw new Error('Could not resolve values for path:"' + paths.join(".") + '". They are probably incompatible. Values: \n' + asJSON);
}
function callGroupResolver(complexKeywords, resolverName, schemas, mergeSchemas, options, parents) {
    if (complexKeywords.length) {
        const resolverConfig = options.complexResolvers[resolverName];
        if (!resolverConfig || !resolverConfig.resolver) throw new Error("No resolver found for " + resolverName);
        // extract all keywords from all the schemas that have one or more
        // then remove all undefined ones and not unique
        const extractedKeywordsOnly = schemas.map((schema)=>complexKeywords.reduce((all, key)=>{
                if (schema[key] !== undefined) all[key] = schema[key];
                return all;
            }, {}));
        const unique = uniqWith(extractedKeywordsOnly, compare);
        // create mergers that automatically add the path of the keyword for use in the complex resolver
        const mergers = resolverConfig.keywords.reduce((all, key)=>({
                ...all,
                [key]: (schemas, extraKey = [])=>mergeSchemas(schemas, null, parents.concat(key, extraKey))
            }), {});
        const result = resolverConfig.resolver(unique, parents.concat(resolverName), mergers, options);
        if (!isPlainObject(result)) throwIncompatible(unique, parents.concat(resolverName));
        return result;
    }
}
function createRequiredMetaArray(arr) {
    return {
        required: arr
    };
}
const schemaGroupProps = [
    "properties",
    "patternProperties",
    "definitions",
    "dependencies"
];
const schemaArrays = [
    "anyOf",
    "oneOf"
];
const schemaProps = [
    "additionalProperties",
    "additionalItems",
    "contains",
    "propertyNames",
    "not",
    "items"
];
const defaultResolvers = {
    type (compacted) {
        if (compacted.some(Array.isArray)) {
            const normalized = compacted.map(function(val) {
                return Array.isArray(val) ? val : [
                    val
                ];
            });
            const common = intersection.apply(null, normalized);
            if (common.length === 1) return common[0];
            else if (common.length > 1) return uniq(common);
        }
    },
    dependencies (compacted, paths, mergeSchemas) {
        const allChildren = allUniqueKeys(compacted);
        return allChildren.reduce(function(all, childKey) {
            const childSchemas = getValues(compacted, childKey);
            let innerCompacted = uniqWith(childSchemas.filter(notUndefined), isEqual);
            // to support dependencies
            const innerArrays = innerCompacted.filter(Array.isArray);
            if (innerArrays.length) {
                if (innerArrays.length === innerCompacted.length) all[childKey] = stringArray(innerCompacted);
                else {
                    const innerSchemas = innerCompacted.filter(isSchema);
                    const arrayMetaScheams = innerArrays.map(createRequiredMetaArray);
                    all[childKey] = mergeSchemas(innerSchemas.concat(arrayMetaScheams), childKey);
                }
                return all;
            }
            innerCompacted = uniqWith(innerCompacted, compare);
            all[childKey] = mergeSchemas(innerCompacted, childKey);
            return all;
        }, {});
    },
    oneOf (compacted, paths, mergeSchemas) {
        const combinations = getAnyOfCombinations(cloneDeep(compacted));
        const result = tryMergeSchemaGroups(combinations, mergeSchemas);
        const unique = uniqWith(result, compare);
        if (unique.length) return unique;
    },
    not (compacted) {
        return {
            anyOf: compacted
        };
    },
    pattern (compacted) {
        return compacted.map((r)=>"(?=" + r + ")").join("");
    },
    multipleOf (compacted) {
        let integers = compacted.slice(0);
        let factor = 1;
        while(integers.some((n)=>!Number.isInteger(n))){
            integers = integers.map((n)=>n * 10);
            factor = factor * 10;
        }
        return computeLcm(integers) / factor;
    },
    enum (compacted) {
        const enums = intersectionWith.apply(null, compacted.concat(isEqual));
        if (enums.length) return sortBy(enums);
    }
};
defaultResolvers.$id = first;
defaultResolvers.$ref = first;
defaultResolvers.$schema = first;
defaultResolvers.additionalItems = schemaResolver;
defaultResolvers.additionalProperties = schemaResolver;
defaultResolvers.anyOf = defaultResolvers.oneOf;
defaultResolvers.contains = schemaResolver;
defaultResolvers.default = first;
defaultResolvers.definitions = defaultResolvers.dependencies;
defaultResolvers.description = first;
defaultResolvers.examples = examples;
defaultResolvers.exclusiveMaximum = minimumValue;
defaultResolvers.exclusiveMinimum = maximumValue;
defaultResolvers.items = itemsResolver;
defaultResolvers.maximum = minimumValue;
defaultResolvers.maxItems = minimumValue;
defaultResolvers.maxLength = minimumValue;
defaultResolvers.maxProperties = minimumValue;
defaultResolvers.minimum = maximumValue;
defaultResolvers.minItems = maximumValue;
defaultResolvers.minLength = maximumValue;
defaultResolvers.minProperties = maximumValue;
defaultResolvers.properties = propertiesResolver;
defaultResolvers.propertyNames = schemaResolver;
defaultResolvers.required = required;
defaultResolvers.title = first;
defaultResolvers.uniqueItems = uniqueItems;
const defaultComplexResolvers = {
    properties: propertiesResolver,
    items: itemsResolver
};
function merger(rootSchema, options, totalSchemas) {
    totalSchemas = totalSchemas || [];
    options = defaultsDeep(options, {
        ignoreAdditionalProperties: false,
        resolvers: defaultResolvers,
        complexResolvers: defaultComplexResolvers,
        deep: true
    });
    const complexResolvers = Object.entries(options.complexResolvers);
    function mergeSchemas(schemas, base, parents) {
        schemas = cloneDeep(schemas.filter(notUndefined));
        parents = parents || [];
        const merged = isPlainObject(base) ? base : {};
        // return undefined, an empty schema
        if (!schemas.length) return;
        if (schemas.some(isFalse)) return false;
        if (schemas.every(isTrue)) return true;
        // there are no false and we don't need the true ones as they accept everything
        schemas = schemas.filter(isPlainObject);
        const allKeys = allUniqueKeys(schemas);
        if (options.deep && contains(allKeys, "allOf")) return merger({
            allOf: schemas
        }, options, totalSchemas);
        const complexKeysArr = complexResolvers.map(([mainKeyWord, resolverConf])=>allKeys.filter((k)=>resolverConf.keywords.includes(k)));
        // remove all complex keys before simple resolvers
        complexKeysArr.forEach((keys)=>pullAll(allKeys, keys));
        // call all simple resolvers for relevant keywords
        allKeys.forEach(function(key) {
            const values = getValues(schemas, key);
            const compacted = uniqWith(values.filter(notUndefined), compareProp(key));
            // arrayprops like anyOf and oneOf must be merged first, as they contains schemas
            // allOf is treated differently alltogether
            if (compacted.length === 1 && contains(schemaArrays, key)) merged[key] = compacted[0].map((schema)=>mergeSchemas([
                    schema
                ], schema));
            else if (compacted.length === 1 && !contains(schemaGroupProps, key) && !contains(schemaProps, key)) merged[key] = compacted[0];
            else {
                const resolver = options.resolvers[key] || options.resolvers.defaultResolver;
                if (!resolver) throw new Error("No resolver found for key " + key + ". You can provide a resolver for this keyword in the options, or provide a default resolver.");
                const merger = (schemas, extraKey = [])=>mergeSchemas(schemas, null, parents.concat(key, extraKey));
                merged[key] = resolver(compacted, parents.concat(key), merger, options);
                if (merged[key] === undefined) throwIncompatible(compacted, parents.concat(key));
                else if (merged[key] === undefined) delete merged[key];
            }
        });
        return complexResolvers.reduce((all, [resolverKeyword, config], index)=>({
                ...all,
                ...callGroupResolver(complexKeysArr[index], resolverKeyword, schemas, mergeSchemas, options, parents)
            }), merged);
    }
    const allSchemas = flattenDeep(getAllOf(rootSchema));
    const merged = mergeSchemas(allSchemas);
    return merged;
}
merger.options = {
    resolvers: defaultResolvers
};
module.exports = merger;

},{"eaede3ab6d27e129":"4qlAD","1a2afe8d0c610fb0":"lzmKp","442e4feed98e459":"DqVY5","e25f416854cb8173":"30GKO","ac7f62997984c20c":"5AbnX","88b49ca963adb703":"dFca2","6c293d3bddf92666":"dIGHr","7ea3115b810a7014":"h84J7","4d5667d6f26039ba":"cMAmC","fbc0c1d2257f94b":"g5UGm","838199c0d6d6c4e5":"eY1rJ","33f995abdc38f788":"gv1Nt","71ac4cce2884b18c":"ewIby","c445257c25fff161":"cBrfe","94c0843ee6bd2bdc":"4VFG2","35db618df5ee8d2e":"jAf3Y"}],"4qlAD":[function(require,module,exports) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"4qp1b"}],"lzmKp":[function(require,module,exports) {
var isEqual = require("564e952241636b94");
var sortBy = require("992b689f14f0eabc");
var uniq = require("e2e33f108d75d07b");
var uniqWith = require("b08be2df2fb7ba0e");
var defaults = require("b8566f0fc1895145");
var intersectionWith = require("a2c664647fd57a85");
var isPlainObject = require("a1a13e3894746ebe");
var isBoolean = require("f47d147a22f42074");
var normalizeArray = (val)=>Array.isArray(val) ? val : [
        val
    ];
var undef = (val)=>val === undefined;
var keys = (obj)=>isPlainObject(obj) || Array.isArray(obj) ? Object.keys(obj) : [];
var has = (obj, key)=>obj.hasOwnProperty(key);
var stringArray = (arr)=>sortBy(uniq(arr));
var undefEmpty = (val)=>undef(val) || Array.isArray(val) && val.length === 0;
var keyValEqual = (a, b, key, compare)=>b && has(b, key) && a && has(a, key) && compare(a[key], b[key]);
var undefAndZero = (a, b)=>undef(a) && b === 0 || undef(b) && a === 0 || isEqual(a, b);
var falseUndefined = (a, b)=>undef(a) && b === false || undef(b) && a === false || isEqual(a, b);
var emptySchema = (schema)=>undef(schema) || isEqual(schema, {}) || schema === true;
var emptyObjUndef = (schema)=>undef(schema) || isEqual(schema, {});
var isSchema = (val)=>undef(val) || isPlainObject(val) || val === true || val === false;
function undefArrayEqual(a, b) {
    if (undefEmpty(a) && undefEmpty(b)) return true;
    else return isEqual(stringArray(a), stringArray(b));
}
function unsortedNormalizedArray(a, b) {
    a = normalizeArray(a);
    b = normalizeArray(b);
    return isEqual(stringArray(a), stringArray(b));
}
function schemaGroup(a, b, key, compare) {
    var allProps = uniq(keys(a).concat(keys(b)));
    if (emptyObjUndef(a) && emptyObjUndef(b)) return true;
    else if (emptyObjUndef(a) && keys(b).length) return false;
    else if (emptyObjUndef(b) && keys(a).length) return false;
    return allProps.every(function(key) {
        var aVal = a[key];
        var bVal = b[key];
        if (Array.isArray(aVal) && Array.isArray(bVal)) return isEqual(stringArray(a), stringArray(b));
        else if (Array.isArray(aVal) && !Array.isArray(bVal)) return false;
        else if (Array.isArray(bVal) && !Array.isArray(aVal)) return false;
        return keyValEqual(a, b, key, compare);
    });
}
function items(a, b, key, compare) {
    if (isPlainObject(a) && isPlainObject(b)) return compare(a, b);
    else if (Array.isArray(a) && Array.isArray(b)) return schemaGroup(a, b, key, compare);
    else return isEqual(a, b);
}
function unsortedArray(a, b, key, compare) {
    var uniqueA = uniqWith(a, compare);
    var uniqueB = uniqWith(b, compare);
    var inter = intersectionWith(uniqueA, uniqueB, compare);
    return inter.length === Math.max(uniqueA.length, uniqueB.length);
}
var comparers = {
    title: isEqual,
    uniqueItems: falseUndefined,
    minLength: undefAndZero,
    minItems: undefAndZero,
    minProperties: undefAndZero,
    required: undefArrayEqual,
    enum: undefArrayEqual,
    type: unsortedNormalizedArray,
    items: items,
    anyOf: unsortedArray,
    allOf: unsortedArray,
    oneOf: unsortedArray,
    properties: schemaGroup,
    patternProperties: schemaGroup,
    dependencies: schemaGroup
};
var acceptsUndefined = [
    "properties",
    "patternProperties",
    "dependencies",
    "uniqueItems",
    "minLength",
    "minItems",
    "minProperties",
    "required"
];
var schemaProps = [
    "additionalProperties",
    "additionalItems",
    "contains",
    "propertyNames",
    "not"
];
function compare(a, b, options) {
    options = defaults(options, {
        ignore: []
    });
    if (emptySchema(a) && emptySchema(b)) return true;
    if (!isSchema(a) || !isSchema(b)) throw new Error("Either of the values are not a JSON schema.");
    if (a === b) return true;
    if (isBoolean(a) && isBoolean(b)) return a === b;
    if (a === undefined && b === false || b === undefined && a === false) return false;
    if (undef(a) && !undef(b) || !undef(a) && undef(b)) return false;
    var allKeys = uniq(Object.keys(a).concat(Object.keys(b)));
    if (options.ignore.length) allKeys = allKeys.filter((k)=>options.ignore.indexOf(k) === -1);
    if (!allKeys.length) return true;
    function innerCompare(a, b) {
        return compare(a, b, options);
    }
    return allKeys.every(function(key) {
        var aValue = a[key];
        var bValue = b[key];
        if (schemaProps.indexOf(key) !== -1) return compare(aValue, bValue, options);
        var comparer = comparers[key];
        if (!comparer) comparer = isEqual;
        // do simple lodash check first
        if (isEqual(aValue, bValue)) return true;
        if (acceptsUndefined.indexOf(key) === -1) {
            if (!has(a, key) && has(b, key) || has(a, key) && !has(b, key)) return aValue === bValue;
        }
        var result = comparer(aValue, bValue, key, innerCompare);
        if (!isBoolean(result)) throw new Error("Comparer must return true or false");
        return result;
    });
}
module.exports = compare;

},{"564e952241636b94":"cMAmC","992b689f14f0eabc":"gv1Nt","e2e33f108d75d07b":"ewIby","b08be2df2fb7ba0e":"cBrfe","b8566f0fc1895145":"g2lgI","a2c664647fd57a85":"h84J7","a1a13e3894746ebe":"g5UGm","f47d147a22f42074":"hoNez"}],"gv1Nt":[function(require,module,exports) {
var baseFlatten = require("7dd3b18d381f1f29"), baseOrderBy = require("2553e45e897c3cba"), baseRest = require("9df1e918b0eea173"), isIterateeCall = require("36218471fd8f4dda");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var sortBy = baseRest(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
module.exports = sortBy;

},{"7dd3b18d381f1f29":"6cEdQ","2553e45e897c3cba":"h9WOF","9df1e918b0eea173":"23bOk","36218471fd8f4dda":"798t3"}],"h9WOF":[function(require,module,exports) {
var arrayMap = require("8b3be8ab05c5c021"), baseGet = require("56eb179604ce4d19"), baseIteratee = require("41950d167c7e12b5"), baseMap = require("b09740a39499ec43"), baseSortBy = require("35a9013ca73ef017"), baseUnary = require("b387a5b76e29e664"), compareMultiple = require("2ab709818f44804c"), identity = require("5cb379329c706719"), isArray = require("8acdbb462385356c");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;

},{"8b3be8ab05c5c021":"4aQow","56eb179604ce4d19":"5yD9j","41950d167c7e12b5":"kp7IX","b09740a39499ec43":"4K6vf","35a9013ca73ef017":"jhpDi","b387a5b76e29e664":"2K30s","2ab709818f44804c":"v4QDx","5cb379329c706719":"4q4zt","8acdbb462385356c":"2vMMN"}],"4K6vf":[function(require,module,exports) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"35UR4","2924e2db4bb5430d":"6tjkt"}],"jhpDi":[function(require,module,exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = baseSortBy;

},{}],"v4QDx":[function(require,module,exports) {
var compareAscending = require("dd5e23e02b1cd726");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = compareMultiple;

},{"dd5e23e02b1cd726":"gr3Ky"}],"gr3Ky":[function(require,module,exports) {
var isSymbol = require("a51b63ee8daeecee");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = compareAscending;

},{"a51b63ee8daeecee":"b0EEv"}],"cBrfe":[function(require,module,exports) {
var baseUniq = require("5c64b423b6ad4c59");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function uniqWith(array, comparator) {
    comparator = typeof comparator == "function" ? comparator : undefined;
    return array && array.length ? baseUniq(array, undefined, comparator) : [];
}
module.exports = uniqWith;

},{"5c64b423b6ad4c59":"e1UjE"}],"g2lgI":[function(require,module,exports) {
var baseRest = require("7185e90d741afd2a"), eq = require("c7442b0697635fa9"), isIterateeCall = require("4bcb10da45efc3b8"), keysIn = require("4217ca21be56753d");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var defaults = baseRest(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = defaults;

},{"7185e90d741afd2a":"23bOk","c7442b0697635fa9":"9yMLM","4bcb10da45efc3b8":"798t3","4217ca21be56753d":"cYRBj"}],"h84J7":[function(require,module,exports) {
var arrayMap = require("939e78cd71d9dc7"), baseIntersection = require("f6a959711bf8ce02"), baseRest = require("5641df5b02bcbdf6"), castArrayLikeObject = require("26d16185c6ed7ee7"), last = require("914d9b37eb9cd0f6");
/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */ var intersectionWith = baseRest(function(arrays) {
    var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
    comparator = typeof comparator == "function" ? comparator : undefined;
    if (comparator) mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
});
module.exports = intersectionWith;

},{"939e78cd71d9dc7":"4aQow","f6a959711bf8ce02":"bdOH6","5641df5b02bcbdf6":"23bOk","26d16185c6ed7ee7":"bZLfV","914d9b37eb9cd0f6":"drQua"}],"bdOH6":[function(require,module,exports) {
var SetCache = require("7070c945ceea62ce"), arrayIncludes = require("ea93e7f7041da225"), arrayIncludesWith = require("95ac92fc6b845c29"), arrayMap = require("96e97fb8c1f62c2a"), baseUnary = require("cfcf6ce49738e1b2"), cacheHas = require("27c425d77edc5a7b");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseIntersection;

},{"7070c945ceea62ce":"dLr8c","ea93e7f7041da225":"fbGrX","95ac92fc6b845c29":"cE5Gg","96e97fb8c1f62c2a":"4aQow","cfcf6ce49738e1b2":"2K30s","27c425d77edc5a7b":"68Ius"}],"bZLfV":[function(require,module,exports) {
var isArrayLikeObject = require("36f79b126a48f510");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function castArrayLikeObject(value) {
    return isArrayLikeObject(value) ? value : [];
}
module.exports = castArrayLikeObject;

},{"36f79b126a48f510":"cwU9N"}],"hoNez":[function(require,module,exports) {
var baseGetTag = require("763d54281423d9ac"), isObjectLike = require("37c1c7912587466b");
/** `Object#toString` result references. */ var boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}
module.exports = isBoolean;

},{"763d54281423d9ac":"a1nlZ","37c1c7912587466b":"17Pxd"}],"DqVY5":[function(require,module,exports) {
"use strict";
// MODULES //
var gcd = require("3ea38b1b362dbeb0"), isArray = require("d89d45b81303b812"), isIntegerArray = require("8619c72ba74e5ebd"), isFunction = require("3a79b6f86033bff");
// LEAST COMMON MULTIPLE //
/**
* FUNCTION: lcm( arr[, clbk] )
*	Computes the least common multiple (lcm).
*
* @param {Number[]|Number} arr - input array of integers
* @param {Function|Number} [accessor] - accessor function for accessing array values
* @returns {Number|Null} least common multiple or null
*/ function lcm() {
    var nargs = arguments.length, args, clbk, arr, len, a, b, i;
    // Copy the input arguments to an array...
    args = new Array(nargs);
    for(i = 0; i < nargs; i++)args[i] = arguments[i];
    // Have we been provided with integer arguments?
    if (isIntegerArray(args)) {
        if (nargs === 2) {
            a = args[0];
            b = args[1];
            if (a < 0) a = -a;
            if (b < 0) b = -b;
            if (a === 0 || b === 0) return 0;
            return a / gcd(a, b) * b;
        }
        arr = args;
    } else if (!isArray(args[0])) throw new TypeError("lcm()::invalid input argument. Must provide an array of integers. Value: `" + args[0] + "`.");
    else if (nargs > 1) {
        arr = args[0];
        clbk = args[1];
        if (!isFunction(clbk)) throw new TypeError("lcm()::invalid input argument. Accessor must be a function. Value: `" + clbk + "`.");
    } else arr = args[0];
    len = arr.length;
    // Check if a sufficient number of values have been provided...
    if (len < 2) return null;
    // If an accessor is provided, extract the array values...
    if (clbk) {
        a = new Array(len);
        for(i = 0; i < len; i++)a[i] = clbk(arr[i], i);
        arr = a;
    }
    // Given an input array, ensure all array values are integers...
    if (nargs < 3) {
        if (!isIntegerArray(arr)) throw new TypeError("lcm()::invalid input argument. Accessed array values must be integers. Value: `" + arr + "`.");
    }
    // Convert any negative integers to positive integers...
    for(i = 0; i < len; i++){
        a = arr[i];
        if (a < 0) arr[i] = -a;
    }
    // Exploit the fact that the lcm is an associative function...
    a = arr[0];
    for(i = 1; i < len; i++){
        b = arr[i];
        if (a === 0 || b === 0) return 0;
        a = a / gcd(a, b) * b;
    }
    return a;
} // end FUNCTION lcm()
// EXPORTS //
module.exports = lcm;

},{"3ea38b1b362dbeb0":"ifnA4","d89d45b81303b812":"j9ulN","8619c72ba74e5ebd":"dft7J","3a79b6f86033bff":"5VDB6"}],"ifnA4":[function(require,module,exports) {
"use strict";
// MODULES //
var isArray = require("22f194d5a3afec12"), isIntegerArray = require("1b91b82798457561"), isFunction = require("20defc9a8b93f093");
// VARIABLES //
var MAXINT = Math.pow(2, 31) - 1;
// FUNCTIONS //
/**
* FUNCTION: gcd( a, b )
*	Computes the greatest common divisor of two integers `a` and `b`, using the binary GCD algorithm.
*
* @param {Number} a - integer
* @param {Number} b - integer
* @returns {Number} greatest common divisor
*/ function gcd(a, b) {
    var k = 1, t;
    // Simple cases:
    if (a === 0) return b;
    if (b === 0) return a;
    // Reduce `a` and/or `b` to odd numbers and keep track of the greatest power of 2 dividing both `a` and `b`...
    while(a % 2 === 0 && b % 2 === 0){
        a = a / 2; // right shift
        b = b / 2; // right shift
        k = k * 2; // left shift
    }
    // Reduce `a` to an odd number...
    while(a % 2 === 0)a = a / 2; // right shift
    // Henceforth, `a` is always odd...
    while(b){
        // Remove all factors of 2 in `b`, as they are not common...
        while(b % 2 === 0)b = b / 2; // right shift
        // `a` and `b` are both odd. Swap values such that `b` is the larger of the two values, and then set `b` to the difference (which is even)...
        if (a > b) {
            t = b;
            b = a;
            a = t;
        }
        b = b - a; // b=0 iff b=a
    }
    // Restore common factors of 2...
    return k * a;
} // end FUNCTION gcd()
/**
* FUNCTION: bitwise( a, b )
*	Computes the greatest common divisor of two integers `a` and `b`, using the binary GCD algorithm and bitwise operations.
*
* @param {Number} a - safe integer
* @param {Number} b - safe integer
* @returns {Number} greatest common divisor
*/ function bitwise(a, b) {
    var k = 0, t;
    // Simple cases:
    if (a === 0) return b;
    if (b === 0) return a;
    // Reduce `a` and/or `b` to odd numbers and keep track of the greatest power of 2 dividing both `a` and `b`...
    while((a & 1) === 0 && (b & 1) === 0){
        a >>>= 1; // right shift
        b >>>= 1; // right shift
        k++;
    }
    // Reduce `a` to an odd number...
    while((a & 1) === 0)a >>>= 1; // right shift
    // Henceforth, `a` is always odd...
    while(b){
        // Remove all factors of 2 in `b`, as they are not common...
        while((b & 1) === 0)b >>>= 1; // right shift
        // `a` and `b` are both odd. Swap values such that `b` is the larger of the two values, and then set `b` to the difference (which is even)...
        if (a > b) {
            t = b;
            b = a;
            a = t;
        }
        b = b - a; // b=0 iff b=a
    }
    // Restore common factors of 2...
    return a << k;
} // end FUNCTION bitwise()
// GREATEST COMMON DIVISOR //
/**
* FUNCTION: compute( arr[, clbk] )
*	Computes the greatest common divisor.
*
* @param {Number[]|Number} arr - input array of integers
* @param {Function|Number} [clbk] - accessor function for accessing array values
* @returns {Number|Null} greatest common divisor or null
*/ function compute() {
    var nargs = arguments.length, args, clbk, arr, len, a, b, i;
    // Copy the input arguments to an array...
    args = new Array(nargs);
    for(i = 0; i < nargs; i++)args[i] = arguments[i];
    // Have we been provided with integer arguments?
    if (isIntegerArray(args)) {
        if (nargs === 2) {
            a = args[0];
            b = args[1];
            if (a < 0) a = -a;
            if (b < 0) b = -b;
            if (a <= MAXINT && b <= MAXINT) return bitwise(a, b);
            else return gcd(a, b);
        }
        arr = args;
    } else if (!isArray(args[0])) throw new TypeError("gcd()::invalid input argument. Must provide an array of integers. Value: `" + args[0] + "`.");
    else if (nargs > 1) {
        arr = args[0];
        clbk = args[1];
        if (!isFunction(clbk)) throw new TypeError("gcd()::invalid input argument. Accessor must be a function. Value: `" + clbk + "`.");
    } else arr = args[0];
    len = arr.length;
    // Check if a sufficient number of values have been provided...
    if (len < 2) return null;
    // If an accessor is provided, extract the array values...
    if (clbk) {
        a = new Array(len);
        for(i = 0; i < len; i++)a[i] = clbk(arr[i], i);
        arr = a;
    }
    // Given an input array, ensure all array values are integers...
    if (nargs < 3) {
        if (!isIntegerArray(arr)) throw new TypeError("gcd()::invalid input argument. Accessed array values must be integers. Value: `" + arr + "`.");
    }
    // Convert any negative integers to positive integers...
    for(i = 0; i < len; i++){
        a = arr[i];
        if (a < 0) arr[i] = -a;
    }
    // Exploit the fact that the gcd is an associative function...
    a = arr[0];
    for(i = 1; i < len; i++){
        b = arr[i];
        if (b <= MAXINT && a <= MAXINT) a = bitwise(a, b);
        else a = gcd(a, b);
    }
    return a;
} // end FUNCTION compute()
// EXPORTS //
module.exports = compute;

},{"22f194d5a3afec12":"j9ulN","1b91b82798457561":"dft7J","20defc9a8b93f093":"5VDB6"}],"j9ulN":[function(require,module,exports) {
"use strict";
/**
* FUNCTION: isArray( value )
*	Validates if a value is an array.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is an array
*/ function isArray(value) {
    return Object.prototype.toString.call(value) === "[object Array]";
} // end FUNCTION isArray()
// EXPORTS //
module.exports = Array.isArray || isArray;

},{}],"dft7J":[function(require,module,exports) {
/**
*
*	VALIDATE: integer-array
*
*
*	DESCRIPTION:
*		- Validates if a value is an integer array.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2015. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2015.
*
*/ "use strict";
// MODULES //
var isArray = require("bd6887385d1682bc"), isInteger = require("15ad048fb6c282e6");
// IS INTEGER ARRAY //
/**
* FUNCTION: isIntegerArray( value )
*	Validates if a value is an integer array.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating if a value is an integer array
*/ function isIntegerArray(value) {
    var len;
    if (!isArray(value)) return false;
    len = value.length;
    if (!len) return false;
    for(var i = 0; i < len; i++){
        if (!isInteger(value[i])) return false;
    }
    return true;
} // end FUNCTION isIntegerArray()
// EXPORTS //
module.exports = isIntegerArray;

},{"bd6887385d1682bc":"j9ulN","15ad048fb6c282e6":"jddgU"}],"jddgU":[function(require,module,exports) {
/**
*
*	VALIDATE: integer
*
*
*	DESCRIPTION:
*		- Validates if a value is an integer.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/ "use strict";
// MODULES //
var isNumber = require("ba0d3ce27a1c2850");
// ISINTEGER //
/**
* FUNCTION: isInteger( value )
*	Validates if a value is an integer.
*
* @param {Number} value - value to be validated
* @returns {Boolean} boolean indicating whether value is an integer
*/ function isInteger(value) {
    return isNumber(value) && value % 1 === 0;
} // end FUNCTION isInteger()
// EXPORTS //
module.exports = isInteger;

},{"ba0d3ce27a1c2850":"aC2ZJ"}],"aC2ZJ":[function(require,module,exports) {
/**
*
*	VALIDATE: number
*
*
*	DESCRIPTION:
*		- Validates if a value is a number.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/ "use strict";
/**
* FUNCTION: isNumber( value )
*	Validates if a value is a number.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is a number
*/ function isNumber(value) {
    return (typeof value === "number" || Object.prototype.toString.call(value) === "[object Number]") && value.valueOf() === value.valueOf();
} // end FUNCTION isNumber()
// EXPORTS //
module.exports = isNumber;

},{}],"5VDB6":[function(require,module,exports) {
/**
*
*	VALIDATE: function
*
*
*	DESCRIPTION:
*		- Validates if a value is a function.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/ "use strict";
/**
* FUNCTION: isFunction( value )
*	Validates if a value is a function.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is a function
*/ function isFunction(value) {
    return typeof value === "function";
} // end FUNCTION isFunction()
// EXPORTS //
module.exports = isFunction;

},{}],"30GKO":[function(require,module,exports) {
var apply = require("22a11e8cef4c515a"), baseRest = require("a535b85c1e935c35"), customDefaultsMerge = require("1b6265fdf2b2becb"), mergeWith = require("23dda4f4ca071ecb");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var defaultsDeep = baseRest(function(args) {
    args.push(undefined, customDefaultsMerge);
    return apply(mergeWith, undefined, args);
});
module.exports = defaultsDeep;

},{"22a11e8cef4c515a":"dV0Pb","a535b85c1e935c35":"23bOk","1b6265fdf2b2becb":"6C57e","23dda4f4ca071ecb":"eafKc"}],"6C57e":[function(require,module,exports) {
var baseMerge = require("df69673e1974f60f"), isObject = require("184af3126e981d10");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack["delete"](srcValue);
    }
    return objValue;
}
module.exports = customDefaultsMerge;

},{"df69673e1974f60f":"1HhBF","184af3126e981d10":"kYJe3"}],"eafKc":[function(require,module,exports) {
var baseMerge = require("534a42b3db0d10f3"), createAssigner = require("1dd402ac842b0276");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
    baseMerge(object, source, srcIndex, customizer);
});
module.exports = mergeWith;

},{"534a42b3db0d10f3":"1HhBF","1dd402ac842b0276":"cCe8Q"}],"dIGHr":[function(require,module,exports) {
var arrayMap = require("6a250a20b4b08a64"), baseIntersection = require("a82701bebbafe8d6"), baseRest = require("a4c4fe36b8bc714c"), castArrayLikeObject = require("a81a4617d84f59b5");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var intersection = baseRest(function(arrays) {
    var mapped = arrayMap(arrays, castArrayLikeObject);
    return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
});
module.exports = intersection;

},{"6a250a20b4b08a64":"4aQow","a82701bebbafe8d6":"bdOH6","a4c4fe36b8bc714c":"23bOk","a81a4617d84f59b5":"bZLfV"}],"eY1rJ":[function(require,module,exports) {
var basePullAll = require("ac3106171ce4858");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function pullAll(array, values) {
    return array && array.length && values && values.length ? basePullAll(array, values) : array;
}
module.exports = pullAll;

},{"ac3106171ce4858":"2b7tv"}],"2b7tv":[function(require,module,exports) {
var arrayMap = require("a353916a8217d76c"), baseIndexOf = require("bb22bfc11f13e432"), baseIndexOfWith = require("6cda42a127972471"), baseUnary = require("8164bbbe2998b4c8"), copyArray = require("79c1d6a76564e4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
    if (array === values) values = copyArray(values);
    if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) splice.call(seen, fromIndex, 1);
            splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = basePullAll;

},{"a353916a8217d76c":"4aQow","bb22bfc11f13e432":"eYHU9","6cda42a127972471":"asoAZ","8164bbbe2998b4c8":"2K30s","79c1d6a76564e4f":"jNUX7"}],"asoAZ":[function(require,module,exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = baseIndexOfWith;

},{}],"4VFG2":[function(require,module,exports) {
const compare = require("dbfeade8bb096b46");
const forEach = require("cef7246235a2a902");
const { allUniqueKeys, deleteUndefinedProps, getValues, keys, notUndefined, uniqWith, withoutArr } = require("33200a4a5dcc19d6");
function removeFalseSchemas(target) {
    forEach(target, function(schema, prop) {
        if (schema === false) delete target[prop];
    });
}
function mergeSchemaGroup(group, mergeSchemas) {
    const allKeys = allUniqueKeys(group);
    return allKeys.reduce(function(all, key) {
        const schemas = getValues(group, key);
        const compacted = uniqWith(schemas.filter(notUndefined), compare);
        all[key] = mergeSchemas(compacted, key);
        return all;
    }, {});
}
module.exports = {
    keywords: [
        "properties",
        "patternProperties",
        "additionalProperties"
    ],
    resolver (values, parents, mergers, options) {
        // first get rid of all non permitted properties
        if (!options.ignoreAdditionalProperties) {
            values.forEach(function(subSchema) {
                const otherSubSchemas = values.filter((s)=>s !== subSchema);
                const ownKeys = keys(subSchema.properties);
                const ownPatternKeys = keys(subSchema.patternProperties);
                const ownPatterns = ownPatternKeys.map((k)=>new RegExp(k));
                otherSubSchemas.forEach(function(other) {
                    const allOtherKeys = keys(other.properties);
                    const keysMatchingPattern = allOtherKeys.filter((k)=>ownPatterns.some((pk)=>pk.test(k)));
                    const additionalKeys = withoutArr(allOtherKeys, ownKeys, keysMatchingPattern);
                    additionalKeys.forEach(function(key) {
                        other.properties[key] = mergers.properties([
                            other.properties[key],
                            subSchema.additionalProperties
                        ], key);
                    });
                });
            });
            // remove disallowed patternProperties
            values.forEach(function(subSchema) {
                const otherSubSchemas = values.filter((s)=>s !== subSchema);
                const ownPatternKeys = keys(subSchema.patternProperties);
                if (subSchema.additionalProperties === false) otherSubSchemas.forEach(function(other) {
                    const allOtherPatterns = keys(other.patternProperties);
                    const additionalPatternKeys = withoutArr(allOtherPatterns, ownPatternKeys);
                    additionalPatternKeys.forEach((key)=>delete other.patternProperties[key]);
                });
            });
        }
        const returnObject = {
            additionalProperties: mergers.additionalProperties(values.map((s)=>s.additionalProperties)),
            patternProperties: mergeSchemaGroup(values.map((s)=>s.patternProperties), mergers.patternProperties),
            properties: mergeSchemaGroup(values.map((s)=>s.properties), mergers.properties)
        };
        if (returnObject.additionalProperties === false) removeFalseSchemas(returnObject.properties);
        return deleteUndefinedProps(returnObject);
    }
};

},{"dbfeade8bb096b46":"lzmKp","cef7246235a2a902":"b9hn9","33200a4a5dcc19d6":"dMdpR"}],"b9hn9":[function(require,module,exports) {
var arrayEach = require("5dbec210c3629ee5"), baseEach = require("8e0dc727d328c3d7"), castFunction = require("759fcc4330a9fea9"), isArray = require("38760405c7e16565");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forEach(collection, iteratee) {
    var func = isArray(collection) ? arrayEach : baseEach;
    return func(collection, castFunction(iteratee));
}
module.exports = forEach;

},{"5dbec210c3629ee5":"545SQ","8e0dc727d328c3d7":"35UR4","759fcc4330a9fea9":"9r5CH","38760405c7e16565":"2vMMN"}],"dMdpR":[function(require,module,exports) {
const flatten = require("98c863903e5632e2");
const flattenDeep = require("6cb31a86da238c87");
const isPlainObject = require("e45175d98a537aa6");
const uniq = require("46d84a9a1886d4e0");
const uniqWith = require("53243ce33a134685");
const without = require("90628609344b4fd6");
function deleteUndefinedProps(returnObject) {
    // cleanup empty
    for(const prop in returnObject)if (has(returnObject, prop) && isEmptySchema(returnObject[prop])) delete returnObject[prop];
    return returnObject;
}
const allUniqueKeys = (arr)=>uniq(flattenDeep(arr.map(keys)));
const getValues = (schemas, key)=>schemas.map((schema)=>schema && schema[key]);
const has = (obj, propName)=>Object.prototype.hasOwnProperty.call(obj, propName);
const keys = (obj)=>{
    if (isPlainObject(obj) || Array.isArray(obj)) return Object.keys(obj);
    else return [];
};
const notUndefined = (val)=>val !== undefined;
const isSchema = (val)=>isPlainObject(val) || val === true || val === false;
const isEmptySchema = (obj)=>!keys(obj).length && obj !== false && obj !== true;
const withoutArr = (arr, ...rest)=>without.apply(null, [
        arr
    ].concat(flatten(rest)));
module.exports = {
    allUniqueKeys,
    deleteUndefinedProps,
    getValues,
    has,
    isEmptySchema,
    isSchema,
    keys,
    notUndefined,
    uniqWith,
    withoutArr
};

},{"98c863903e5632e2":"5AbnX","6cb31a86da238c87":"dFca2","e45175d98a537aa6":"g5UGm","46d84a9a1886d4e0":"ewIby","53243ce33a134685":"cBrfe","90628609344b4fd6":"gHNts"}],"gHNts":[function(require,module,exports) {
var baseDifference = require("4db0cb250ff88e72"), baseRest = require("b2f01aa6851573dc"), isArrayLikeObject = require("15809c5e06486880");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var without = baseRest(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});
module.exports = without;

},{"4db0cb250ff88e72":"4aBg2","b2f01aa6851573dc":"23bOk","15809c5e06486880":"cwU9N"}],"4aBg2":[function(require,module,exports) {
var SetCache = require("24f4b9cbc81696e0"), arrayIncludes = require("81e4fe535468d831"), arrayIncludesWith = require("90bb2140eaac029e"), arrayMap = require("7436ea7dfb9a8bab"), baseUnary = require("c466a3eeaa8c48da"), cacheHas = require("aea8a6a021670ce5");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = arrayMap(values, baseUnary(iteratee));
    if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = baseDifference;

},{"24f4b9cbc81696e0":"dLr8c","81e4fe535468d831":"fbGrX","90bb2140eaac029e":"cE5Gg","7436ea7dfb9a8bab":"4aQow","c466a3eeaa8c48da":"2K30s","aea8a6a021670ce5":"68Ius"}],"jAf3Y":[function(require,module,exports) {
const compare = require("15e6aa3e8464c524");
const forEach = require("5d03020cec9cd603");
const { allUniqueKeys, deleteUndefinedProps, has, isSchema, notUndefined, uniqWith } = require("adfbf5b29a9aa7c8");
function removeFalseSchemasFromArray(target) {
    forEach(target, function(schema, index) {
        if (schema === false) target.splice(index, 1);
    });
}
function getItemSchemas(subSchemas, key) {
    return subSchemas.map(function(sub) {
        if (!sub) return undefined;
        if (Array.isArray(sub.items)) {
            const schemaAtPos = sub.items[key];
            if (isSchema(schemaAtPos)) return schemaAtPos;
            else if (has(sub, "additionalItems")) return sub.additionalItems;
        } else return sub.items;
        return undefined;
    });
}
function getAdditionalSchemas(subSchemas) {
    return subSchemas.map(function(sub) {
        if (!sub) return undefined;
        if (Array.isArray(sub.items)) return sub.additionalItems;
        return sub.items;
    });
}
// Provide source when array
function mergeItems(group, mergeSchemas, items) {
    const allKeys = allUniqueKeys(items);
    return allKeys.reduce(function(all, key) {
        const schemas = getItemSchemas(group, key);
        const compacted = uniqWith(schemas.filter(notUndefined), compare);
        all[key] = mergeSchemas(compacted, key);
        return all;
    }, []);
}
module.exports = {
    keywords: [
        "items",
        "additionalItems"
    ],
    resolver (values, parents, mergers) {
        // const createSubMerger = groupKey => (schemas, key) => mergeSchemas(schemas, parents.concat(groupKey, key))
        const items = values.map((s)=>s.items);
        const itemsCompacted = items.filter(notUndefined);
        const returnObject = {};
        // if all items keyword values are schemas, we can merge them as simple schemas
        // if not we need to merge them as mixed
        if (itemsCompacted.every(isSchema)) returnObject.items = mergers.items(items);
        else returnObject.items = mergeItems(values, mergers.items, items);
        let schemasAtLastPos;
        if (itemsCompacted.every(Array.isArray)) schemasAtLastPos = values.map((s)=>s.additionalItems);
        else if (itemsCompacted.some(Array.isArray)) schemasAtLastPos = getAdditionalSchemas(values);
        if (schemasAtLastPos) returnObject.additionalItems = mergers.additionalItems(schemasAtLastPos);
        if (returnObject.additionalItems === false && Array.isArray(returnObject.items)) removeFalseSchemasFromArray(returnObject.items);
        return deleteUndefinedProps(returnObject);
    }
};

},{"15e6aa3e8464c524":"lzmKp","5d03020cec9cd603":"b9hn9","adfbf5b29a9aa7c8":"dMdpR"}],"lULGM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDiscriminatorFieldFromSchema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
function getDiscriminatorFieldFromSchema(schema) {
    let discriminator;
    const maybeString = (0, _getDefault.default)(schema, "discriminator.propertyName", undefined);
    if ((0, _isStringDefault.default)(maybeString)) discriminator = maybeString;
    else if (maybeString !== undefined) console.warn(`Expecting discriminator to be a string, got "${typeof maybeString}" instead`);
    return discriminator;
}

},{"lodash/get":"g5ox6","lodash/isString":"gFUE8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"Qabco":[function(require,module,exports) {
/** Given a specific `value` attempts to guess the type of a schema element. In the case where we have to implicitly
 *  create a schema, it is useful to know what type to use based on the data we are defining.
 *
 * @param value - The value from which to guess the type
 * @returns - The best guess for the object type
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>guessType);
function guessType(value) {
    if (Array.isArray(value)) return "array";
    if (typeof value === "string") return "string";
    if (value == null) return "null";
    if (typeof value === "boolean") return "boolean";
    if (!isNaN(value)) return "number";
    if (typeof value === "object") return "object";
    // Default to string if we can't figure it out
    return "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dxsEQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeSchemas);
var _union = require("lodash/union");
var _unionDefault = parcelHelpers.interopDefault(_union);
var _constants = require("./constants");
var _getSchemaType = require("./getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function mergeSchemas(obj1, obj2) {
    const acc = Object.assign({}, obj1); // Prevent mutation of source object.
    return Object.keys(obj2).reduce((acc, key)=>{
        const left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && key in obj1 && (0, _isObjectDefault.default)(right)) acc[key] = mergeSchemas(left, right);
        else if (obj1 && obj2 && ((0, _getSchemaTypeDefault.default)(obj1) === "object" || (0, _getSchemaTypeDefault.default)(obj2) === "object") && key === (0, _constants.REQUIRED_KEY) && Array.isArray(left) && Array.isArray(right)) // Don't include duplicate values when merging 'required' fields.
        acc[key] = (0, _unionDefault.default)(left, right);
        else acc[key] = right;
        return acc;
    }, acc);
}

},{"lodash/union":"1TUKU","./constants":"7SuQb","./getSchemaType":"Po4xY","./isObject":"9dcnp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1TUKU":[function(require,module,exports) {
var baseFlatten = require("4c6a8d1d22b46f1e"), baseRest = require("3c5b68a5bd4cb3c4"), baseUniq = require("d4a39eace292bbe3"), isArrayLikeObject = require("b9956cfd928a69da");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var union = baseRest(function(arrays) {
    return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});
module.exports = union;

},{"4c6a8d1d22b46f1e":"6cEdQ","3c5b68a5bd4cb3c4":"23bOk","d4a39eace292bbe3":"e1UjE","b9956cfd928a69da":"cwU9N"}],"Po4xY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getSchemaType);
var _guessType = require("./guessType");
var _guessTypeDefault = parcelHelpers.interopDefault(_guessType);
function getSchemaType(schema) {
    let { type } = schema;
    if (!type && schema.const) return (0, _guessTypeDefault.default)(schema.const);
    if (!type && schema.enum) return "string";
    if (!type && (schema.properties || schema.additionalProperties)) return "object";
    if (Array.isArray(type)) {
        if (type.length === 2 && type.includes("null")) type = type.find((type)=>type !== "null");
        else type = type[0];
    }
    return type;
}

},{"./guessType":"Qabco","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eBu8s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isFixedItems);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function isFixedItems(schema) {
    return Array.isArray(schema.items) && schema.items.length > 0 && schema.items.every((item)=>(0, _isObjectDefault.default)(item));
}

},{"./isObject":"9dcnp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"64T3g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeDefaultsWithFormData);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function mergeDefaultsWithFormData(defaults, formData, mergeExtraArrayDefaults = false) {
    if (Array.isArray(formData)) {
        const defaultsArray = Array.isArray(defaults) ? defaults : [];
        const mapped = formData.map((value, idx)=>{
            if (defaultsArray[idx]) return mergeDefaultsWithFormData(defaultsArray[idx], value, mergeExtraArrayDefaults);
            return value;
        });
        // Merge any extra defaults when mergeExtraArrayDefaults is true
        if (mergeExtraArrayDefaults && mapped.length < defaultsArray.length) mapped.push(...defaultsArray.slice(mapped.length));
        return mapped;
    }
    if ((0, _isObjectDefault.default)(formData)) {
        const acc = Object.assign({}, defaults); // Prevent mutation of source object.
        return Object.keys(formData).reduce((acc, key)=>{
            acc[key] = mergeDefaultsWithFormData(defaults ? (0, _getDefault.default)(defaults, key) : {}, (0, _getDefault.default)(formData, key), mergeExtraArrayDefaults);
            return acc;
        }, acc);
    }
    return formData;
}

},{"lodash/get":"g5ox6","./isObject":"9dcnp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"63YAa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeObjects);
var _isObject = require("./isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
function mergeObjects(obj1, obj2, concatArrays = false) {
    return Object.keys(obj2).reduce((acc, key)=>{
        const left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && key in obj1 && (0, _isObjectDefault.default)(right)) acc[key] = mergeObjects(left, right, concatArrays);
        else if (concatArrays && Array.isArray(left) && Array.isArray(right)) {
            let toMerge = right;
            if (concatArrays === "preventDuplicates") toMerge = right.reduce((result, value)=>{
                if (!left.includes(value)) result.push(value);
                return result;
            }, []);
            acc[key] = left.concat(toMerge);
        } else acc[key] = right;
        return acc;
    }, Object.assign({}, obj1)); // Prevent mutation of source object.
}

},{"./isObject":"9dcnp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kaTqm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isMultiSelect);
var _isSelect = require("./isSelect");
var _isSelectDefault = parcelHelpers.interopDefault(_isSelect);
function isMultiSelect(validator, schema, rootSchema) {
    if (!schema.uniqueItems || !schema.items || typeof schema.items === "boolean") return false;
    return (0, _isSelectDefault.default)(validator, schema.items, rootSchema);
}

},{"./isSelect":"g2GqK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g2GqK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSelect);
var _isConstant = require("../isConstant");
var _isConstantDefault = parcelHelpers.interopDefault(_isConstant);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
function isSelect(validator, theSchema, rootSchema = {}) {
    const schema = (0, _retrieveSchemaDefault.default)(validator, theSchema, rootSchema, undefined);
    const altSchemas = schema.oneOf || schema.anyOf;
    if (Array.isArray(schema.enum)) return true;
    if (Array.isArray(altSchemas)) return altSchemas.every((altSchemas)=>typeof altSchemas !== "boolean" && (0, _isConstantDefault.default)(altSchemas));
    return false;
}

},{"../isConstant":"njn20","./retrieveSchema":"g3Irx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"njn20":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isConstant);
var _constants = require("./constants");
function isConstant(schema) {
    return Array.isArray(schema.enum) && schema.enum.length === 1 || (0, _constants.CONST_KEY) in schema;
}

},{"./constants":"7SuQb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6NsDI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDisplayLabel);
var _constants = require("../constants");
var _getSchemaType = require("../getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
var _getUiOptions = require("../getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
var _isCustomWidget = require("../isCustomWidget");
var _isCustomWidgetDefault = parcelHelpers.interopDefault(_isCustomWidget);
var _isFilesArray = require("./isFilesArray");
var _isFilesArrayDefault = parcelHelpers.interopDefault(_isFilesArray);
var _isMultiSelect = require("./isMultiSelect");
var _isMultiSelectDefault = parcelHelpers.interopDefault(_isMultiSelect);
function getDisplayLabel(validator, schema, uiSchema = {}, rootSchema, globalOptions) {
    const uiOptions = (0, _getUiOptionsDefault.default)(uiSchema, globalOptions);
    const { label = true } = uiOptions;
    let displayLabel = !!label;
    const schemaType = (0, _getSchemaTypeDefault.default)(schema);
    if (schemaType === "array") displayLabel = (0, _isMultiSelectDefault.default)(validator, schema, rootSchema) || (0, _isFilesArrayDefault.default)(validator, schema, uiSchema, rootSchema) || (0, _isCustomWidgetDefault.default)(uiSchema);
    if (schemaType === "object") displayLabel = false;
    if (schemaType === "boolean" && !uiSchema[0, _constants.UI_WIDGET_KEY]) displayLabel = false;
    if (uiSchema[0, _constants.UI_FIELD_KEY]) displayLabel = false;
    return displayLabel;
}

},{"../constants":"7SuQb","../getSchemaType":"Po4xY","../getUiOptions":"5pjcb","../isCustomWidget":"fPdiF","./isFilesArray":"3G3xc","./isMultiSelect":"kaTqm","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fPdiF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCustomWidget);
var _getUiOptions = require("./getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
function isCustomWidget(uiSchema = {}) {
    return(// TODO: Remove the `&& uiSchema['ui:widget'] !== 'hidden'` once we support hidden widgets for arrays.
    // https://rjsf-team.github.io/react-jsonschema-form/docs/usage/widgets/#hidden-widgets
    "widget" in (0, _getUiOptionsDefault.default)(uiSchema) && (0, _getUiOptionsDefault.default)(uiSchema)["widget"] !== "hidden");
}

},{"./getUiOptions":"5pjcb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3G3xc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isFilesArray);
var _constants = require("../constants");
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
function isFilesArray(validator, schema, uiSchema = {}, rootSchema) {
    if (uiSchema[0, _constants.UI_WIDGET_KEY] === "files") return true;
    if (schema.items) {
        const itemsSchema = (0, _retrieveSchemaDefault.default)(validator, schema.items, rootSchema);
        return itemsSchema.type === "string" && itemsSchema.format === "data-url";
    }
    return false;
}

},{"../constants":"7SuQb","./retrieveSchema":"g3Irx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ad5pK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeValidationData);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _mergeObjects = require("../mergeObjects");
var _mergeObjectsDefault = parcelHelpers.interopDefault(_mergeObjects);
function mergeValidationData(validator, validationData, additionalErrorSchema) {
    if (!additionalErrorSchema) return validationData;
    const { errors: oldErrors, errorSchema: oldErrorSchema } = validationData;
    let errors = validator.toErrorList(additionalErrorSchema);
    let errorSchema = additionalErrorSchema;
    if (!(0, _isEmptyDefault.default)(oldErrorSchema)) {
        errorSchema = (0, _mergeObjectsDefault.default)(oldErrorSchema, additionalErrorSchema, true);
        errors = [
            ...oldErrors
        ].concat(errors);
    }
    return {
        errorSchema,
        errors
    };
}

},{"lodash/isEmpty":"c3uBm","../mergeObjects":"63YAa","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cp6dv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sanitizeDataForNewSchema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _constants = require("../constants");
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
const NO_VALUE = Symbol("no Value");
function sanitizeDataForNewSchema(validator, rootSchema, newSchema, oldSchema, data = {}) {
    // By default, we will clear the form data
    let newFormData;
    // If the new schema is of type object and that object contains a list of properties
    if ((0, _hasDefault.default)(newSchema, (0, _constants.PROPERTIES_KEY))) {
        // Create an object containing root-level keys in the old schema, setting each key to undefined to remove the data
        const removeOldSchemaData = {};
        if ((0, _hasDefault.default)(oldSchema, (0, _constants.PROPERTIES_KEY))) {
            const properties = (0, _getDefault.default)(oldSchema, (0, _constants.PROPERTIES_KEY), {});
            Object.keys(properties).forEach((key)=>{
                if ((0, _hasDefault.default)(data, key)) removeOldSchemaData[key] = undefined;
            });
        }
        const keys = Object.keys((0, _getDefault.default)(newSchema, (0, _constants.PROPERTIES_KEY), {}));
        // Create a place to store nested data that will be a side-effect of the filter
        const nestedData = {};
        keys.forEach((key)=>{
            const formValue = (0, _getDefault.default)(data, key);
            let oldKeyedSchema = (0, _getDefault.default)(oldSchema, [
                (0, _constants.PROPERTIES_KEY),
                key
            ], {});
            let newKeyedSchema = (0, _getDefault.default)(newSchema, [
                (0, _constants.PROPERTIES_KEY),
                key
            ], {});
            // Resolve the refs if they exist
            if ((0, _hasDefault.default)(oldKeyedSchema, (0, _constants.REF_KEY))) oldKeyedSchema = (0, _retrieveSchemaDefault.default)(validator, oldKeyedSchema, rootSchema, formValue);
            if ((0, _hasDefault.default)(newKeyedSchema, (0, _constants.REF_KEY))) newKeyedSchema = (0, _retrieveSchemaDefault.default)(validator, newKeyedSchema, rootSchema, formValue);
            // Now get types and see if they are the same
            const oldSchemaTypeForKey = (0, _getDefault.default)(oldKeyedSchema, "type");
            const newSchemaTypeForKey = (0, _getDefault.default)(newKeyedSchema, "type");
            // Check if the old option has the same key with the same type
            if (!oldSchemaTypeForKey || oldSchemaTypeForKey === newSchemaTypeForKey) {
                if ((0, _hasDefault.default)(removeOldSchemaData, key)) // SIDE-EFFECT: remove the undefined value for a key that has the same type between the old and new schemas
                delete removeOldSchemaData[key];
                // If it is an object, we'll recurse and store the resulting sanitized data for the key
                if (newSchemaTypeForKey === "object" || newSchemaTypeForKey === "array" && Array.isArray(formValue)) {
                    // SIDE-EFFECT: process the new schema type of object recursively to save iterations
                    const itemData = sanitizeDataForNewSchema(validator, rootSchema, newKeyedSchema, oldKeyedSchema, formValue);
                    if (itemData !== undefined || newSchemaTypeForKey === "array") // only put undefined values for the array type and not the object type
                    nestedData[key] = itemData;
                } else {
                    // Ok, the non-object types match, let's make sure that a default or a const of a different value is replaced
                    // with the new default or const. This allows the case where two schemas differ that only by the default/const
                    // value to be properly selected
                    const newOptionDefault = (0, _getDefault.default)(newKeyedSchema, "default", NO_VALUE);
                    const oldOptionDefault = (0, _getDefault.default)(oldKeyedSchema, "default", NO_VALUE);
                    if (newOptionDefault !== NO_VALUE && newOptionDefault !== formValue) {
                        if (oldOptionDefault === formValue) // If the old default matches the formValue, we'll update the new value to match the new default
                        removeOldSchemaData[key] = newOptionDefault;
                        else if ((0, _getDefault.default)(newKeyedSchema, "readOnly") === true) // If the new schema has the default set to read-only, treat it like a const and remove the value
                        removeOldSchemaData[key] = undefined;
                    }
                    const newOptionConst = (0, _getDefault.default)(newKeyedSchema, "const", NO_VALUE);
                    const oldOptionConst = (0, _getDefault.default)(oldKeyedSchema, "const", NO_VALUE);
                    if (newOptionConst !== NO_VALUE && newOptionConst !== formValue) // Since this is a const, if the old value matches, replace the value with the new const otherwise clear it
                    removeOldSchemaData[key] = oldOptionConst === formValue ? newOptionConst : undefined;
                }
            }
        });
        newFormData = {
            ...typeof data == "string" || Array.isArray(data) ? undefined : data,
            ...removeOldSchemaData,
            ...nestedData
        };
    // First apply removing the old schema data, then apply the nested data, then apply the old data keys to keep
    } else if ((0, _getDefault.default)(oldSchema, "type") === "array" && (0, _getDefault.default)(newSchema, "type") === "array" && Array.isArray(data)) {
        let oldSchemaItems = (0, _getDefault.default)(oldSchema, "items");
        let newSchemaItems = (0, _getDefault.default)(newSchema, "items");
        // If any of the array types `items` are arrays (remember arrays are objects) then we'll just drop the data
        // Eventually, we may want to deal with when either of the `items` are arrays since those tuple validations
        if (typeof oldSchemaItems === "object" && typeof newSchemaItems === "object" && !Array.isArray(oldSchemaItems) && !Array.isArray(newSchemaItems)) {
            if ((0, _hasDefault.default)(oldSchemaItems, (0, _constants.REF_KEY))) oldSchemaItems = (0, _retrieveSchemaDefault.default)(validator, oldSchemaItems, rootSchema, data);
            if ((0, _hasDefault.default)(newSchemaItems, (0, _constants.REF_KEY))) newSchemaItems = (0, _retrieveSchemaDefault.default)(validator, newSchemaItems, rootSchema, data);
            // Now get types and see if they are the same
            const oldSchemaType = (0, _getDefault.default)(oldSchemaItems, "type");
            const newSchemaType = (0, _getDefault.default)(newSchemaItems, "type");
            // Check if the old option has the same key with the same type
            if (!oldSchemaType || oldSchemaType === newSchemaType) {
                const maxItems = (0, _getDefault.default)(newSchema, "maxItems", -1);
                if (newSchemaType === "object") newFormData = data.reduce((newValue, aValue)=>{
                    const itemValue = sanitizeDataForNewSchema(validator, rootSchema, newSchemaItems, oldSchemaItems, aValue);
                    if (itemValue !== undefined && (maxItems < 0 || newValue.length < maxItems)) newValue.push(itemValue);
                    return newValue;
                }, []);
                else newFormData = maxItems > 0 && data.length > maxItems ? data.slice(0, maxItems) : data;
            }
        } else if (typeof oldSchemaItems === "boolean" && typeof newSchemaItems === "boolean" && oldSchemaItems === newSchemaItems) // If they are both booleans and have the same value just return the data as is otherwise fall-thru to undefined
        newFormData = data;
    // Also probably want to deal with `prefixItems` as tuples with the latest 2020 draft
    }
    return newFormData;
}

},{"lodash/get":"g5ox6","lodash/has":"frHYl","../constants":"7SuQb","./retrieveSchema":"g3Irx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aPCBv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toIdSchema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _constants = require("../constants");
var _isObject = require("../isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
var _getSchemaType = require("../getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
/** An internal helper that generates an `IdSchema` object for the `schema`, recursively with protection against
 * infinite recursion
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param schema - The schema for which the `IdSchema` is desired
 * @param idPrefix - The prefix to use for the id
 * @param idSeparator - The separator to use for the path segments in the id
 * @param [id] - The base id for the schema
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @param [_recurseList=[]] - The list of retrieved schemas currently being recursed, used to prevent infinite recursion
 * @returns - The `IdSchema` object for the `schema`
 */ function toIdSchemaInternal(validator, schema, idPrefix, idSeparator, id, rootSchema, formData, _recurseList = []) {
    if ((0, _constants.REF_KEY) in schema || (0, _constants.DEPENDENCIES_KEY) in schema || (0, _constants.ALL_OF_KEY) in schema) {
        const _schema = (0, _retrieveSchemaDefault.default)(validator, schema, rootSchema, formData);
        const sameSchemaIndex = _recurseList.findIndex((item)=>(0, _isEqualDefault.default)(item, _schema));
        if (sameSchemaIndex === -1) return toIdSchemaInternal(validator, _schema, idPrefix, idSeparator, id, rootSchema, formData, _recurseList.concat(_schema));
    }
    if ((0, _constants.ITEMS_KEY) in schema && !(0, _getDefault.default)(schema, [
        (0, _constants.ITEMS_KEY),
        (0, _constants.REF_KEY)
    ])) return toIdSchemaInternal(validator, (0, _getDefault.default)(schema, (0, _constants.ITEMS_KEY)), idPrefix, idSeparator, id, rootSchema, formData, _recurseList);
    const $id = id || idPrefix;
    const idSchema = {
        $id
    };
    if ((0, _getSchemaTypeDefault.default)(schema) === "object" && (0, _constants.PROPERTIES_KEY) in schema) for(const name in schema.properties){
        const field = (0, _getDefault.default)(schema, [
            (0, _constants.PROPERTIES_KEY),
            name
        ]);
        const fieldId = idSchema[0, _constants.ID_KEY] + idSeparator + name;
        idSchema[name] = toIdSchemaInternal(validator, (0, _isObjectDefault.default)(field) ? field : {}, idPrefix, idSeparator, fieldId, rootSchema, // It's possible that formData is not an object -- this can happen if an
        // array item has just been added, but not populated with data yet
        (0, _getDefault.default)(formData, [
            name
        ]), _recurseList);
    }
    return idSchema;
}
function toIdSchema(validator, schema, id, rootSchema, formData, idPrefix = "root", idSeparator = "_") {
    return toIdSchemaInternal(validator, schema, idPrefix, idSeparator, id, rootSchema, formData);
}

},{"lodash/get":"g5ox6","lodash/isEqual":"cMAmC","../constants":"7SuQb","../isObject":"9dcnp","./retrieveSchema":"g3Irx","../getSchemaType":"Po4xY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j4ljm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPathSchema);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _constants = require("../constants");
var _getDiscriminatorFieldFromSchema = require("../getDiscriminatorFieldFromSchema");
var _getDiscriminatorFieldFromSchemaDefault = parcelHelpers.interopDefault(_getDiscriminatorFieldFromSchema);
var _getClosestMatchingOption = require("./getClosestMatchingOption");
var _getClosestMatchingOptionDefault = parcelHelpers.interopDefault(_getClosestMatchingOption);
var _retrieveSchema = require("./retrieveSchema");
var _retrieveSchemaDefault = parcelHelpers.interopDefault(_retrieveSchema);
/** An internal helper that generates an `PathSchema` object for the `schema`, recursively with protection against
 * infinite recursion
 *
 * @param validator - An implementation of the `ValidatorType` interface that will be used when necessary
 * @param schema - The schema for which the `PathSchema` is desired
 * @param [name=''] - The base name for the schema
 * @param [rootSchema] - The root schema, used to primarily to look up `$ref`s
 * @param [formData] - The current formData, if any, to assist retrieving a schema
 * @param [_recurseList=[]] - The list of retrieved schemas currently being recursed, used to prevent infinite recursion
 * @returns - The `PathSchema` object for the `schema`
 */ function toPathSchemaInternal(validator, schema, name, rootSchema, formData, _recurseList = []) {
    if ((0, _constants.REF_KEY) in schema || (0, _constants.DEPENDENCIES_KEY) in schema || (0, _constants.ALL_OF_KEY) in schema) {
        const _schema = (0, _retrieveSchemaDefault.default)(validator, schema, rootSchema, formData);
        const sameSchemaIndex = _recurseList.findIndex((item)=>(0, _isEqualDefault.default)(item, _schema));
        if (sameSchemaIndex === -1) return toPathSchemaInternal(validator, _schema, name, rootSchema, formData, _recurseList.concat(_schema));
    }
    let pathSchema = {
        [(0, _constants.NAME_KEY)]: name.replace(/^\./, "")
    };
    if ((0, _constants.ONE_OF_KEY) in schema || (0, _constants.ANY_OF_KEY) in schema) {
        const xxxOf = (0, _constants.ONE_OF_KEY) in schema ? schema.oneOf : schema.anyOf;
        const discriminator = (0, _getDiscriminatorFieldFromSchemaDefault.default)(schema);
        const index = (0, _getClosestMatchingOptionDefault.default)(validator, rootSchema, formData, xxxOf, 0, discriminator);
        const _schema = xxxOf[index];
        pathSchema = {
            ...pathSchema,
            ...toPathSchemaInternal(validator, _schema, name, rootSchema, formData, _recurseList)
        };
    }
    if ((0, _constants.ADDITIONAL_PROPERTIES_KEY) in schema && schema[0, _constants.ADDITIONAL_PROPERTIES_KEY] !== false) (0, _setDefault.default)(pathSchema, (0, _constants.RJSF_ADDITONAL_PROPERTIES_FLAG), true);
    if ((0, _constants.ITEMS_KEY) in schema && Array.isArray(formData)) {
        const { items: schemaItems, additionalItems: schemaAdditionalItems } = schema;
        if (Array.isArray(schemaItems)) formData.forEach((element, i)=>{
            if (schemaItems[i]) pathSchema[i] = toPathSchemaInternal(validator, schemaItems[i], `${name}.${i}`, rootSchema, element, _recurseList);
            else if (schemaAdditionalItems) pathSchema[i] = toPathSchemaInternal(validator, schemaAdditionalItems, `${name}.${i}`, rootSchema, element, _recurseList);
            else console.warn(`Unable to generate path schema for "${name}.${i}". No schema defined for it`);
        });
        else formData.forEach((element, i)=>{
            pathSchema[i] = toPathSchemaInternal(validator, schemaItems, `${name}.${i}`, rootSchema, element, _recurseList);
        });
    } else if ((0, _constants.PROPERTIES_KEY) in schema) for(const property in schema.properties){
        const field = (0, _getDefault.default)(schema, [
            (0, _constants.PROPERTIES_KEY),
            property
        ]);
        pathSchema[property] = toPathSchemaInternal(validator, field, `${name}.${property}`, rootSchema, // It's possible that formData is not an object -- this can happen if an
        // array item has just been added, but not populated with data yet
        (0, _getDefault.default)(formData, [
            property
        ]), _recurseList);
    }
    return pathSchema;
}
function toPathSchema(validator, schema, name = "", rootSchema, formData) {
    return toPathSchemaInternal(validator, schema, name, rootSchema, formData);
}

},{"lodash/get":"g5ox6","lodash/isEqual":"cMAmC","lodash/set":"04gxh","../constants":"7SuQb","../getDiscriminatorFieldFromSchema":"lULGM","./getClosestMatchingOption":"d8isN","./retrieveSchema":"g3Irx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4AvYk":[function(require,module,exports) {
/** Given the `FileReader.readAsDataURL()` based `dataURI` extracts that data into an actual Blob along with the name
 * of that Blob if provided in the URL. If no name is provided, then the name falls back to `unknown`.
 *
 * @param dataURI - The `DataUrl` potentially containing name and raw data to be converted to a Blob
 * @returns - an object containing a Blob and its name, extracted from the URI
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dataURItoBlob);
function dataURItoBlob(dataURILike) {
    var _a;
    // check if is dataURI
    if (dataURILike.indexOf("data:") === -1) throw new Error("File is invalid: URI must be a dataURI");
    const dataURI = dataURILike.slice(5);
    // split the dataURI into media and base64, with the base64 signature
    const splitted = dataURI.split(";base64,");
    // if the base64 signature is not present, the latter part will become empty
    if (splitted.length !== 2) throw new Error("File is invalid: dataURI must be base64");
    // extract the mime type, media parameters including the name, and the base64 string
    const [media, base64] = splitted;
    const [mime, ...mediaparams] = media.split(";");
    const type = mime || "";
    // extract the name from the parameters
    const name = decodeURI(// parse the parameters into key-value pairs, find a key, and extract a value
    // if no key is found, then the name is unknown
    ((_a = mediaparams.map((param)=>param.split("=")).find(([key])=>key === "name")) === null || _a === void 0 ? void 0 : _a[1]) || "unknown");
    // Built the Uint8Array Blob parameter from the base64 string.
    try {
        const binary = atob(base64);
        const array = new Array(binary.length);
        for(let i = 0; i < binary.length; i++)array[i] = binary.charCodeAt(i);
        // Create the blob object
        const blob = new window.Blob([
            new Uint8Array(array)
        ], {
            type
        });
        return {
            blob,
            name
        };
    } catch (error) {
        throw new Error("File is invalid: " + error.message);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2SFey":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>englishStringTranslator);
var _replaceStringParameters = require("./replaceStringParameters");
var _replaceStringParametersDefault = parcelHelpers.interopDefault(_replaceStringParameters);
function englishStringTranslator(stringToTranslate, params) {
    return (0, _replaceStringParametersDefault.default)(stringToTranslate, params);
}

},{"./replaceStringParameters":"jVPf8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jVPf8":[function(require,module,exports) {
/** Potentially substitutes all replaceable parameters with the associated value(s) from the `params` if available. When
 * a `params` array is provided, each value in the array is used to replace any of the replaceable parameters in the
 * `inputString` using the `%1`, `%2`, etc. replacement specifiers.
 *
 * @param inputString - The string which will be potentially updated with replacement parameters
 * @param params - The optional list of replaceable parameter values to substitute into the english string
 * @returns - The updated string with any replacement specifiers replaced
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>replaceStringParameters);
function replaceStringParameters(inputString, params) {
    let output = inputString;
    if (Array.isArray(params)) {
        const parts = output.split(/(%\d)/);
        params.forEach((param, index)=>{
            const partIndex = parts.findIndex((part)=>part === `%${index + 1}`);
            if (partIndex >= 0) parts[partIndex] = param;
        });
        output = parts.join("");
    }
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"alqw9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsDeselectValue);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _enumOptionsValueForIndex = require("./enumOptionsValueForIndex");
var _enumOptionsValueForIndexDefault = parcelHelpers.interopDefault(_enumOptionsValueForIndex);
function enumOptionsDeselectValue(valueIndex, selected, allEnumOptions = []) {
    const value = (0, _enumOptionsValueForIndexDefault.default)(valueIndex, allEnumOptions);
    if (Array.isArray(selected)) return selected.filter((v)=>!(0, _isEqualDefault.default)(v, value));
    return (0, _isEqualDefault.default)(value, selected) ? undefined : selected;
}

},{"lodash/isEqual":"cMAmC","./enumOptionsValueForIndex":"kRkuH","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kRkuH":[function(require,module,exports) {
/** Returns the value(s) from `allEnumOptions` at the index(es) provided by `valueIndex`. If `valueIndex` is not an
 * array AND the index is not valid for `allEnumOptions`, `emptyValue` is returned. If `valueIndex` is an array, AND it
 * contains an invalid index, the returned array will have the resulting undefined values filtered out, leaving only
 * valid values or in the worst case, an empty array.
 *
 * @param valueIndex - The index(es) of the value(s) that should be returned
 * @param [allEnumOptions=[]] - The list of all the known enumOptions
 * @param [emptyValue] - The value to return when the non-array `valueIndex` does not refer to a real option
 * @returns - The single or list of values specified by the single or list of indexes if they are valid. Otherwise,
 *        `emptyValue` or an empty list.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsValueForIndex);
function enumOptionsValueForIndex(valueIndex, allEnumOptions = [], emptyValue) {
    if (Array.isArray(valueIndex)) return valueIndex.map((index)=>enumOptionsValueForIndex(index, allEnumOptions))// Since the recursive call returns `emptyValue` when we get a bad option, only filter those out
    .filter((val)=>val !== emptyValue);
    // So Number(null) and Number('') both return 0, so use emptyValue for those two values
    const index = valueIndex === "" || valueIndex === null ? -1 : Number(valueIndex);
    const option = allEnumOptions[index];
    return option ? option.value : emptyValue;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l4wNs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsIndexForValue);
var _enumOptionsIsSelected = require("./enumOptionsIsSelected");
var _enumOptionsIsSelectedDefault = parcelHelpers.interopDefault(_enumOptionsIsSelected);
function enumOptionsIndexForValue(value, allEnumOptions = [], multiple = false) {
    const selectedIndexes = allEnumOptions.map((opt, index)=>(0, _enumOptionsIsSelectedDefault.default)(opt.value, value) ? String(index) : undefined).filter((opt)=>typeof opt !== "undefined");
    if (!multiple) return selectedIndexes[0];
    return selectedIndexes;
}

},{"./enumOptionsIsSelected":"fkR0n","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fkR0n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsIsSelected);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
function enumOptionsIsSelected(value, selected) {
    if (Array.isArray(selected)) return selected.some((sel)=>(0, _isEqualDefault.default)(sel, value));
    return (0, _isEqualDefault.default)(selected, value);
}

},{"lodash/isEqual":"cMAmC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"inCLa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>enumOptionsSelectValue);
var _enumOptionsValueForIndex = require("./enumOptionsValueForIndex");
var _enumOptionsValueForIndexDefault = parcelHelpers.interopDefault(_enumOptionsValueForIndex);
var _isNil = require("lodash/isNil");
var _isNilDefault = parcelHelpers.interopDefault(_isNil);
function enumOptionsSelectValue(valueIndex, selected, allEnumOptions = []) {
    const value = (0, _enumOptionsValueForIndexDefault.default)(valueIndex, allEnumOptions);
    if (!(0, _isNilDefault.default)(value)) {
        const index = allEnumOptions.findIndex((opt)=>value === opt.value);
        const all = allEnumOptions.map(({ value: val })=>val);
        const updated = selected.slice(0, index).concat(value, selected.slice(index));
        // As inserting values at predefined index positions doesn't work with empty
        // arrays, we need to reorder the updated selection to match the initial order
        return updated.sort((a, b)=>Number(all.indexOf(a) > all.indexOf(b)));
    }
    return selected;
}

},{"./enumOptionsValueForIndex":"kRkuH","lodash/isNil":"ku0d8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ku0d8":[function(require,module,exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function isNil(value) {
    return value == null;
}
module.exports = isNil;

},{}],"3FcmL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneDeep = require("lodash/cloneDeep");
var _cloneDeepDefault = parcelHelpers.interopDefault(_cloneDeep);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _constants = require("./constants");
class ErrorSchemaBuilder {
    /** Construct an `ErrorSchemaBuilder` with an optional initial set of errors in an `ErrorSchema`.
     *
     * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
     */ constructor(initialSchema){
        /** The error schema being built
         *
         * @private
         */ this.errorSchema = {};
        this.resetAllErrors(initialSchema);
    }
    /** Returns the `ErrorSchema` that has been updated by the methods of the `ErrorSchemaBuilder`
     */ get ErrorSchema() {
        return this.errorSchema;
    }
    /** Will get an existing `ErrorSchema` at the specified `pathOfError` or create and return one.
     *
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
     * @returns - The error block for the given `pathOfError` or the root if not provided
     * @private
     */ getOrCreateErrorBlock(pathOfError) {
        const hasPath = Array.isArray(pathOfError) && pathOfError.length > 0 || typeof pathOfError === "string";
        let errorBlock = hasPath ? (0, _getDefault.default)(this.errorSchema, pathOfError) : this.errorSchema;
        if (!errorBlock && pathOfError) {
            errorBlock = {};
            (0, _setDefault.default)(this.errorSchema, pathOfError, errorBlock);
        }
        return errorBlock;
    }
    /** Resets all errors in the `ErrorSchemaBuilder` back to the `initialSchema` if provided, otherwise an empty set.
     *
     * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ resetAllErrors(initialSchema) {
        this.errorSchema = initialSchema ? (0, _cloneDeepDefault.default)(initialSchema) : {};
        return this;
    }
    /** Adds the `errorOrList` to the list of errors in the `ErrorSchema` at either the root level or the location within
     * the schema described by the `pathOfError`. For more information about how to specify the path see the
     * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
     *
     * @param errorOrList - The error or list of errors to add into the `ErrorSchema`
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ addErrors(errorOrList, pathOfError) {
        const errorBlock = this.getOrCreateErrorBlock(pathOfError);
        let errorsList = (0, _getDefault.default)(errorBlock, (0, _constants.ERRORS_KEY));
        if (!Array.isArray(errorsList)) {
            errorsList = [];
            errorBlock[0, _constants.ERRORS_KEY] = errorsList;
        }
        if (Array.isArray(errorOrList)) errorsList.push(...errorOrList);
        else errorsList.push(errorOrList);
        return this;
    }
    /** Sets/replaces the `errorOrList` as the error(s) in the `ErrorSchema` at either the root level or the location
     * within the schema described by the `pathOfError`. For more information about how to specify the path see the
     * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
     *
     * @param errorOrList - The error or list of errors to set into the `ErrorSchema`
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to set the error(s)
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ setErrors(errorOrList, pathOfError) {
        const errorBlock = this.getOrCreateErrorBlock(pathOfError);
        // Effectively clone the array being given to prevent accidental outside manipulation of the given list
        const listToAdd = Array.isArray(errorOrList) ? [
            ...errorOrList
        ] : [
            errorOrList
        ];
        (0, _setDefault.default)(errorBlock, (0, _constants.ERRORS_KEY), listToAdd);
        return this;
    }
    /** Clears the error(s) in the `ErrorSchema` at either the root level or the location within the schema described by
     * the `pathOfError`. For more information about how to specify the path see the
     * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
     *
     * @param [pathOfError] - The optional path into the `ErrorSchema` at which to clear the error(s)
     * @returns - The `ErrorSchemaBuilder` object for chaining purposes
     */ clearErrors(pathOfError) {
        const errorBlock = this.getOrCreateErrorBlock(pathOfError);
        (0, _setDefault.default)(errorBlock, (0, _constants.ERRORS_KEY), []);
        return this;
    }
}
exports.default = ErrorSchemaBuilder;

},{"lodash/cloneDeep":"4qlAD","lodash/get":"g5ox6","lodash/set":"04gxh","./constants":"7SuQb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dt9os":[function(require,module,exports) {
/** Given date & time information with optional yearRange & format, returns props for DateElement
 *
 * @param date - Object containing date with optional time information
 * @param time - Determines whether to include time or not
 * @param [yearRange=[1900, new Date().getFullYear() + 2]] - Controls the list of years to be displayed
 * @param [format='YMD'] - Controls the order in which day, month and year input element will be displayed
 * @returns Array of props for DateElement
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDateElementProps);
function getDateElementProps(date, time, yearRange = [
    1900,
    new Date().getFullYear() + 2
], format = "YMD") {
    const { day, month, year, hour, minute, second } = date;
    const dayObj = {
        type: "day",
        range: [
            1,
            31
        ],
        value: day
    };
    const monthObj = {
        type: "month",
        range: [
            1,
            12
        ],
        value: month
    };
    const yearObj = {
        type: "year",
        range: yearRange,
        value: year
    };
    const dateElementProp = [];
    switch(format){
        case "MDY":
            dateElementProp.push(monthObj, dayObj, yearObj);
            break;
        case "DMY":
            dateElementProp.push(dayObj, monthObj, yearObj);
            break;
        case "YMD":
        default:
            dateElementProp.push(yearObj, monthObj, dayObj);
    }
    if (time) dateElementProp.push({
        type: "hour",
        range: [
            0,
            23
        ],
        value: hour
    }, {
        type: "minute",
        range: [
            0,
            59
        ],
        value: minute
    }, {
        type: "second",
        range: [
            0,
            59
        ],
        value: second
    });
    return dateElementProp;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"57fhF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getInputProps);
var _rangeSpec = require("./rangeSpec");
var _rangeSpecDefault = parcelHelpers.interopDefault(_rangeSpec);
function getInputProps(schema, defaultType, options = {}, autoDefaultStepAny = true) {
    const inputProps = {
        type: defaultType || "text",
        ...(0, _rangeSpecDefault.default)(schema)
    };
    // If options.inputType is set use that as the input type
    if (options.inputType) inputProps.type = options.inputType;
    else if (!defaultType) {
        // If the schema is of type number or integer, set the input type to number
        if (schema.type === "number") {
            inputProps.type = "number";
            // Only add step if one isn't already defined and we are auto-defaulting the "any" step
            if (autoDefaultStepAny && inputProps.step === undefined) // Setting step to 'any' fixes a bug in Safari where decimals are not
            // allowed in number inputs
            inputProps.step = "any";
        } else if (schema.type === "integer") {
            inputProps.type = "number";
            // Only add step if one isn't already defined
            if (inputProps.step === undefined) // Since this is integer, you always want to step up or down in multiples of 1
            inputProps.step = 1;
        }
    }
    if (options.autocomplete) inputProps.autoComplete = options.autocomplete;
    return inputProps;
}

},{"./rangeSpec":"fA7pp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fA7pp":[function(require,module,exports) {
/** Extracts the range spec information `{ step?: number, min?: number, max?: number }` that can be spread onto an HTML
 * input from the range analog in the schema `{ multipleOf?: number, minimum?: number, maximum?: number }`.
 *
 * @param schema - The schema from which to extract the range spec
 * @returns - A range specification from the schema
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rangeSpec);
function rangeSpec(schema) {
    const spec = {};
    if (schema.multipleOf) spec.step = schema.multipleOf;
    if (schema.minimum || schema.minimum === 0) spec.min = schema.minimum;
    if (schema.maximum || schema.maximum === 0) spec.max = schema.maximum;
    return spec;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j3wmP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_OPTIONS", ()=>DEFAULT_OPTIONS);
parcelHelpers.export(exports, "default", ()=>getSubmitButtonOptions);
var _constants = require("./constants");
var _getUiOptions = require("./getUiOptions");
var _getUiOptionsDefault = parcelHelpers.interopDefault(_getUiOptions);
const DEFAULT_OPTIONS = {
    props: {
        disabled: false
    },
    submitText: "Submit",
    norender: false
};
function getSubmitButtonOptions(uiSchema = {}) {
    const uiOptions = (0, _getUiOptionsDefault.default)(uiSchema);
    if (uiOptions && uiOptions[0, _constants.SUBMIT_BTN_OPTIONS_KEY]) {
        const options = uiOptions[0, _constants.SUBMIT_BTN_OPTIONS_KEY];
        return {
            ...DEFAULT_OPTIONS,
            ...options
        };
    }
    return DEFAULT_OPTIONS;
}

},{"./constants":"7SuQb","./getUiOptions":"5pjcb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4Pj31":[function(require,module,exports) {
/** Returns the template with the given `name` from either the `uiSchema` if it is defined or from the `registry`
 * otherwise. NOTE, since `ButtonTemplates` are not overridden in `uiSchema` only those in the `registry` are returned.
 *
 * @param name - The name of the template to fetch, restricted to the keys of `TemplatesType`
 * @param registry - The `Registry` from which to read the template
 * @param [uiOptions={}] - The `UIOptionsType` from which to read an alternate template
 * @returns - The template from either the `uiSchema` or `registry` for the `name`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTemplate);
function getTemplate(name, registry, uiOptions = {}) {
    const { templates } = registry;
    if (name === "ButtonTemplates") return templates[name];
    return(// Evaluating uiOptions[name] results in TS2590: Expression produces a union type that is too complex to represent
    // To avoid that, we cast uiOptions to `any` before accessing the name field
    uiOptions[name] || templates[name]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e8fAZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactIs = require("react-is");
var _reactIsDefault = parcelHelpers.interopDefault(_reactIs);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _getSchemaType = require("./getSchemaType");
var _getSchemaTypeDefault = parcelHelpers.interopDefault(_getSchemaType);
/** The map of schema types to widget type to widget name
 */ const widgetMap = {
    boolean: {
        checkbox: "CheckboxWidget",
        radio: "RadioWidget",
        select: "SelectWidget",
        hidden: "HiddenWidget"
    },
    string: {
        text: "TextWidget",
        password: "PasswordWidget",
        email: "EmailWidget",
        hostname: "TextWidget",
        ipv4: "TextWidget",
        ipv6: "TextWidget",
        uri: "URLWidget",
        "data-url": "FileWidget",
        radio: "RadioWidget",
        select: "SelectWidget",
        textarea: "TextareaWidget",
        hidden: "HiddenWidget",
        date: "DateWidget",
        datetime: "DateTimeWidget",
        "date-time": "DateTimeWidget",
        "alt-date": "AltDateWidget",
        "alt-datetime": "AltDateTimeWidget",
        time: "TimeWidget",
        color: "ColorWidget",
        file: "FileWidget"
    },
    number: {
        text: "TextWidget",
        select: "SelectWidget",
        updown: "UpDownWidget",
        range: "RangeWidget",
        radio: "RadioWidget",
        hidden: "HiddenWidget"
    },
    integer: {
        text: "TextWidget",
        select: "SelectWidget",
        updown: "UpDownWidget",
        range: "RangeWidget",
        radio: "RadioWidget",
        hidden: "HiddenWidget"
    },
    array: {
        select: "SelectWidget",
        checkboxes: "CheckboxesWidget",
        files: "FileWidget",
        hidden: "HiddenWidget"
    }
};
/** Wraps the given widget with stateless functional component that will merge any `defaultProps.options` with the
 * `options` that are provided in the props. It will add the wrapper component as a `MergedWidget` property onto the
 * `Widget` so that future attempts to wrap `AWidget` will return the already existing wrapper.
 *
 * @param AWidget - A widget that will be wrapped or one that is already wrapped
 * @returns - The wrapper widget
 */ function mergeWidgetOptions(AWidget) {
    let MergedWidget = (0, _getDefault.default)(AWidget, "MergedWidget");
    // cache return value as property of widget for proper react reconciliation
    if (!MergedWidget) {
        const defaultOptions = AWidget.defaultProps && AWidget.defaultProps.options || {};
        MergedWidget = ({ options, ...props })=>{
            return (0, _jsxRuntime.jsx)(AWidget, {
                options: {
                    ...defaultOptions,
                    ...options
                },
                ...props
            });
        };
        (0, _setDefault.default)(AWidget, "MergedWidget", MergedWidget);
    }
    return MergedWidget;
}
function getWidget(schema, widget, registeredWidgets = {}) {
    const type = (0, _getSchemaTypeDefault.default)(schema);
    if (typeof widget === "function" || widget && (0, _reactIsDefault.default).isForwardRef((0, _react.createElement)(widget)) || (0, _reactIsDefault.default).isMemo(widget)) return mergeWidgetOptions(widget);
    if (typeof widget !== "string") throw new Error(`Unsupported widget definition: ${typeof widget}`);
    if (widget in registeredWidgets) {
        const registeredWidget = registeredWidgets[widget];
        return getWidget(schema, registeredWidget, registeredWidgets);
    }
    if (typeof type === "string") {
        if (!(type in widgetMap)) throw new Error(`No widget for type '${type}'`);
        if (widget in widgetMap[type]) {
            const registeredWidget = registeredWidgets[widgetMap[type][widget]];
            return getWidget(schema, registeredWidget, registeredWidgets);
        }
    }
    throw new Error(`No widget '${widget}' for type '${type}'`);
}

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-is":"1p1tk","lodash/get":"g5ox6","lodash/set":"04gxh","./getSchemaType":"Po4xY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1p1tk":[function(require,module,exports) {
"use strict";
module.exports = require("fddd9c7776590e34");

},{"fddd9c7776590e34":"aQjRL"}],"aQjRL":[function(require,module,exports) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"hGAwf":[function(require,module,exports) {
/** JS has no built-in hashing function, so rolling our own
 *  based on Java's hashing fn:
 *  http://www.java2s.com/example/nodejs-utility-method/string-hash/hashcode-4dc2b.html
 *
 * @param string - The string for which to get the hash
 * @returns - The resulting hash of the string in hex format
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hashForSchema);
function hashString(string) {
    let hash = 0;
    for(let i = 0; i < string.length; i += 1){
        const chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash.toString(16);
}
function hashForSchema(schema) {
    const allKeys = new Set();
    // solution source: https://stackoverflow.com/questions/16167581/sort-object-properties-and-json-stringify/53593328#53593328
    JSON.stringify(schema, (key, value)=>(allKeys.add(key), value));
    return hashString(JSON.stringify(schema, Array.from(allKeys).sort()));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2ZiZm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasWidget);
var _getWidget = require("./getWidget");
var _getWidgetDefault = parcelHelpers.interopDefault(_getWidget);
function hasWidget(schema, widget, registeredWidgets = {}) {
    try {
        (0, _getWidgetDefault.default)(schema, widget, registeredWidgets);
        return true;
    } catch (e) {
        const err = e;
        if (err.message && (err.message.startsWith("No widget") || err.message.startsWith("Unsupported widget"))) return false;
        throw e;
    }
}

},{"./getWidget":"e8fAZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5CuCJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Return a consistent `id` for the field description element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field description element from the given `id`
 */ parcelHelpers.export(exports, "descriptionId", ()=>descriptionId);
/** Return a consistent `id` for the field error element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field error element from the given `id`
 */ parcelHelpers.export(exports, "errorId", ()=>errorId);
/** Return a consistent `id` for the field examples element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field examples element from the given `id`
 */ parcelHelpers.export(exports, "examplesId", ()=>examplesId);
/** Return a consistent `id` for the field help element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field help element from the given `id`
 */ parcelHelpers.export(exports, "helpId", ()=>helpId);
/** Return a consistent `id` for the field title element
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @returns - The consistent id for the field title element from the given `id`
 */ parcelHelpers.export(exports, "titleId", ()=>titleId);
/** Return a list of element ids that contain additional information about the field that can be used to as the aria
 * description of the field. This is correctly omitting `titleId` which would be "labeling" rather than "describing" the
 * element.
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @param [includeExamples=false] - Optional flag, if true, will add the `examplesId` into the list
 * @returns - The string containing the list of ids for use in an `aria-describedBy` attribute
 */ parcelHelpers.export(exports, "ariaDescribedByIds", ()=>ariaDescribedByIds);
/** Return a consistent `id` for the `optionIndex`s of a `Radio` or `Checkboxes` widget
 *
 * @param id - The id of the parent component for the option
 * @param optionIndex - The index of the option for which the id is desired
 * @returns - An id for the option index based on the parent `id`
 */ parcelHelpers.export(exports, "optionId", ()=>optionId);
var _isString = require("lodash/isString");
var _isStringDefault = parcelHelpers.interopDefault(_isString);
var _constants = require("./constants");
/** Generates a consistent `id` pattern for a given `id` and a `suffix`
 *
 * @param id - Either simple string id or an IdSchema from which to extract it
 * @param suffix - The suffix to append to the id
 */ function idGenerator(id, suffix) {
    const theId = (0, _isStringDefault.default)(id) ? id : id[0, _constants.ID_KEY];
    return `${theId}__${suffix}`;
}
function descriptionId(id) {
    return idGenerator(id, "description");
}
function errorId(id) {
    return idGenerator(id, "error");
}
function examplesId(id) {
    return idGenerator(id, "examples");
}
function helpId(id) {
    return idGenerator(id, "help");
}
function titleId(id) {
    return idGenerator(id, "title");
}
function ariaDescribedByIds(id, includeExamples = false) {
    const examples = includeExamples ? ` ${examplesId(id)}` : "";
    return `${errorId(id)} ${descriptionId(id)} ${helpId(id)}${examples}`;
}
function optionId(id, optionIndex) {
    return `${id}-${optionIndex}`;
}

},{"lodash/isString":"gFUE8","./constants":"7SuQb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"clCtK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>labelValue);
function labelValue(label, hideLabel, fallback) {
    return hideLabel ? fallback : label;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fC2MV":[function(require,module,exports) {
/** Converts a local Date string into a UTC date string
 *
 * @param dateString - The string representation of a date as accepted by the `Date()` constructor
 * @returns - A UTC date string if `dateString` is truthy, otherwise undefined
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>localToUTC);
function localToUTC(dateString) {
    return dateString ? new Date(dateString).toJSON() : undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"diDQO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>optionsList);
var _toConstant = require("./toConstant");
var _toConstantDefault = parcelHelpers.interopDefault(_toConstant);
function optionsList(schema) {
    // enumNames was deprecated in v5 and is intentionally omitted from the RJSFSchema type.
    // Cast the type to include enumNames so the feature still works.
    const schemaWithEnumNames = schema;
    schemaWithEnumNames.enumNames;
    if (schema.enum) return schema.enum.map((value, i)=>{
        const label = schemaWithEnumNames.enumNames && schemaWithEnumNames.enumNames[i] || String(value);
        return {
            label,
            value
        };
    });
    const altSchemas = schema.oneOf || schema.anyOf;
    return altSchemas && altSchemas.map((aSchemaDef)=>{
        const aSchema = aSchemaDef;
        const value = (0, _toConstantDefault.default)(aSchema);
        const label = aSchema.title || String(value);
        return {
            schema: aSchema,
            label,
            value
        };
    });
}

},{"./toConstant":"7eDq5","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7eDq5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toConstant);
var _constants = require("./constants");
function toConstant(schema) {
    if ((0, _constants.ENUM_KEY) in schema && Array.isArray(schema.enum) && schema.enum.length === 1) return schema.enum[0];
    if ((0, _constants.CONST_KEY) in schema) return schema.const;
    throw new Error("schema cannot be inferred as a constant");
}

},{"./constants":"7SuQb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c3VvF":[function(require,module,exports) {
/** Given a list of `properties` and an `order` list, returns a list that contains the `properties` ordered correctly.
 * If `order` is not an array, then the untouched `properties` list is returned. Otherwise `properties` is ordered per
 * the `order` list. If `order` contains a '*' then any `properties` that are not mentioned explicity in `order` will be
 * places in the location of the `*`.
 *
 * @param properties - The list of property keys to be ordered
 * @param order - An array of property keys to be ordered first, with an optional '*' property
 * @returns - A list with the `properties` ordered
 * @throws - Error when the properties cannot be ordered correctly
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderProperties);
function orderProperties(properties, order) {
    if (!Array.isArray(order)) return properties;
    const arrayToHash = (arr)=>arr.reduce((prev, curr)=>{
            prev[curr] = true;
            return prev;
        }, {});
    const errorPropList = (arr)=>arr.length > 1 ? `properties '${arr.join("', '")}'` : `property '${arr[0]}'`;
    const propertyHash = arrayToHash(properties);
    const orderFiltered = order.filter((prop)=>prop === "*" || propertyHash[prop]);
    const orderHash = arrayToHash(orderFiltered);
    const rest = properties.filter((prop)=>!orderHash[prop]);
    const restIndex = orderFiltered.indexOf("*");
    if (restIndex === -1) {
        if (rest.length) throw new Error(`uiSchema order list does not contain ${errorPropList(rest)}`);
        return orderFiltered;
    }
    if (restIndex !== orderFiltered.lastIndexOf("*")) throw new Error("uiSchema order list contains more than one wildcard item");
    const complete = [
        ...orderFiltered
    ];
    complete.splice(restIndex, 1, ...rest);
    return complete;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iODBK":[function(require,module,exports) {
/** Returns a string representation of the `num` that is padded with leading "0"s if necessary
 *
 * @param num - The number to pad
 * @param width - The width of the string at which no lead padding is necessary
 * @returns - The number converted to a string with leading zero padding if the number of digits is less than `width`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pad);
function pad(num, width) {
    let s = String(num);
    while(s.length < width)s = "0" + s;
    return s;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"djJ8R":[function(require,module,exports) {
/** Parses the `dateString` into a `DateObject`, including the time information when `includeTime` is true
 *
 * @param dateString - The date string to parse into a DateObject
 * @param [includeTime=true] - Optional flag, if false, will not include the time data into the object
 * @returns - The date string converted to a `DateObject`
 * @throws - Error when the date cannot be parsed from the string
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseDateString);
function parseDateString(dateString, includeTime = true) {
    if (!dateString) return {
        year: -1,
        month: -1,
        day: -1,
        hour: includeTime ? -1 : 0,
        minute: includeTime ? -1 : 0,
        second: includeTime ? -1 : 0
    };
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) throw new Error("Unable to parse date " + dateString);
    return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate(),
        hour: includeTime ? date.getUTCHours() : 0,
        minute: includeTime ? date.getUTCMinutes() : 0,
        second: includeTime ? date.getUTCSeconds() : 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iFtYs":[function(require,module,exports) {
/** Check to see if a `schema` specifies that a value must be true. This happens when:
 * - `schema.const` is truthy
 * - `schema.enum` == `[true]`
 * - `schema.anyOf` or `schema.oneOf` has a single value which recursively returns true
 * - `schema.allOf` has at least one value which recursively returns true
 *
 * @param schema - The schema to check
 * @returns - True if the schema specifies a value that must be true, false otherwise
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>schemaRequiresTrueValue);
function schemaRequiresTrueValue(schema) {
    // Check if const is a truthy value
    if (schema.const) return true;
    // Check if an enum has a single value of true
    if (schema.enum && schema.enum.length === 1 && schema.enum[0] === true) return true;
    // If anyOf has a single value, evaluate the subschema
    if (schema.anyOf && schema.anyOf.length === 1) return schemaRequiresTrueValue(schema.anyOf[0]);
    // If oneOf has a single value, evaluate the subschema
    if (schema.oneOf && schema.oneOf.length === 1) return schemaRequiresTrueValue(schema.oneOf[0]);
    // Evaluate each subschema in allOf, to see if one of them requires a true value
    if (schema.allOf) {
        const schemaSome = (subSchema)=>schemaRequiresTrueValue(subSchema);
        return schema.allOf.some(schemaSome);
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aSGyU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shouldRender);
var _deepEquals = require("./deepEquals");
var _deepEqualsDefault = parcelHelpers.interopDefault(_deepEquals);
function shouldRender(component, nextProps, nextState) {
    const { props, state } = component;
    return !(0, _deepEqualsDefault.default)(props, nextProps) || !(0, _deepEqualsDefault.default)(state, nextState);
}

},{"./deepEquals":"5U4lj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"15SvM":[function(require,module,exports) {
/** Returns a UTC date string for the given `dateObject`. If `time` is false, then the time portion of the string is
 * removed.
 *
 * @param dateObject - The `DateObject` to convert to a date string
 * @param [time=true] - Optional flag used to remove the time portion of the date string if false
 * @returns - The UTC date string
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDateString);
function toDateString(dateObject, time = true) {
    const { year, month, day, hour = 0, minute = 0, second = 0 } = dateObject;
    const utcTime = Date.UTC(year, month - 1, day, hour, minute, second);
    const datetime = new Date(utcTime).toJSON();
    return time ? datetime : datetime.slice(0, 10);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gTnhe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toErrorList);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _constants = require("./constants");
function toErrorList(errorSchema, fieldPath = []) {
    if (!errorSchema) return [];
    let errorList = [];
    if ((0, _constants.ERRORS_KEY) in errorSchema) errorList = errorList.concat(errorSchema[0, _constants.ERRORS_KEY].map((message)=>{
        const property = `.${fieldPath.join(".")}`;
        return {
            property,
            message,
            stack: `${property} ${message}`
        };
    }));
    return Object.keys(errorSchema).reduce((acc, key)=>{
        if (key !== (0, _constants.ERRORS_KEY)) {
            const childSchema = errorSchema[key];
            if ((0, _isPlainObjectDefault.default)(childSchema)) acc = acc.concat(toErrorList(childSchema, [
                ...fieldPath,
                key
            ]));
        }
        return acc;
    }, errorList);
}

},{"lodash/isPlainObject":"g5UGm","./constants":"7SuQb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3KTWd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toErrorSchema);
var _toPath = require("lodash/toPath");
var _toPathDefault = parcelHelpers.interopDefault(_toPath);
var _errorSchemaBuilder = require("./ErrorSchemaBuilder");
var _errorSchemaBuilderDefault = parcelHelpers.interopDefault(_errorSchemaBuilder);
function toErrorSchema(errors) {
    const builder = new (0, _errorSchemaBuilderDefault.default)();
    if (errors.length) errors.forEach((error)=>{
        const { property, message } = error;
        // When the property is the root element, just use an empty array for the path
        const path = property === "." ? [] : (0, _toPathDefault.default)(property);
        // If the property is at the root (.level1) then toPath creates
        // an empty array element at the first index. Remove it.
        if (path.length > 0 && path[0] === "") path.splice(0, 1);
        if (message) builder.addErrors(message, path);
    });
    return builder.ErrorSchema;
}

},{"lodash/toPath":"hWzOh","./ErrorSchemaBuilder":"3FcmL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hWzOh":[function(require,module,exports) {
var arrayMap = require("7ba7869940617745"), copyArray = require("8a8afdd7f66c30d3"), isArray = require("1326c29ab72d9c5a"), isSymbol = require("a182054f85505cf4"), stringToPath = require("e75722fcac9a080"), toKey = require("43c6affe82c9fa11"), toString = require("b80a77da9aba90a8");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function toPath(value) {
    if (isArray(value)) return arrayMap(value, toKey);
    return isSymbol(value) ? [
        value
    ] : copyArray(stringToPath(toString(value)));
}
module.exports = toPath;

},{"7ba7869940617745":"4aQow","8a8afdd7f66c30d3":"jNUX7","1326c29ab72d9c5a":"2vMMN","a182054f85505cf4":"b0EEv","e75722fcac9a080":"dCEkE","43c6affe82c9fa11":"bDIXW","b80a77da9aba90a8":"70rwt"}],"jDav4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unwrapErrorHandler);
var _isPlainObject = require("lodash/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
function unwrapErrorHandler(errorHandler) {
    return Object.keys(errorHandler).reduce((acc, key)=>{
        if (key === "addError") return acc;
        else {
            const childSchema = errorHandler[key];
            if ((0, _isPlainObjectDefault.default)(childSchema)) return {
                ...acc,
                [key]: unwrapErrorHandler(childSchema)
            };
            return {
                ...acc,
                [key]: childSchema
            };
        }
    }, {});
}

},{"lodash/isPlainObject":"g5UGm","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8I0KT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>utcToLocal);
var _pad = require("./pad");
var _padDefault = parcelHelpers.interopDefault(_pad);
function utcToLocal(jsonDate) {
    if (!jsonDate) return "";
    // required format of `'yyyy-MM-ddThh:mm' followed by optional ':ss' or ':ss.SSS'
    // https://html.spec.whatwg.org/multipage/input.html#local-date-and-time-state-(type%3Ddatetime-local)
    // > should be a _valid local date and time string_ (not GMT)
    // Note - date constructor passed local ISO-8601 does not correctly
    // change time to UTC in node pre-8
    const date = new Date(jsonDate);
    const yyyy = (0, _padDefault.default)(date.getFullYear(), 4);
    const MM = (0, _padDefault.default)(date.getMonth() + 1, 2);
    const dd = (0, _padDefault.default)(date.getDate(), 2);
    const hh = (0, _padDefault.default)(date.getHours(), 2);
    const mm = (0, _padDefault.default)(date.getMinutes(), 2);
    const ss = (0, _padDefault.default)(date.getSeconds(), 2);
    const SSS = (0, _padDefault.default)(date.getMilliseconds(), 3);
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}.${SSS}`;
}

},{"./pad":"iODBK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1KTMq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>validationDataMerge);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _mergeObjects = require("./mergeObjects");
var _mergeObjectsDefault = parcelHelpers.interopDefault(_mergeObjects);
var _toErrorList = require("./toErrorList");
var _toErrorListDefault = parcelHelpers.interopDefault(_toErrorList);
function validationDataMerge(validationData, additionalErrorSchema) {
    if (!additionalErrorSchema) return validationData;
    const { errors: oldErrors, errorSchema: oldErrorSchema } = validationData;
    let errors = (0, _toErrorListDefault.default)(additionalErrorSchema);
    let errorSchema = additionalErrorSchema;
    if (!(0, _isEmptyDefault.default)(oldErrorSchema)) {
        errorSchema = (0, _mergeObjectsDefault.default)(oldErrorSchema, additionalErrorSchema, true);
        errors = [
            ...oldErrors
        ].concat(errors);
    }
    return {
        errorSchema,
        errors
    };
}

},{"lodash/isEmpty":"c3uBm","./mergeObjects":"63YAa","./toErrorList":"gTnhe","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cQ3jv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>withIdRefPrefix);
var _constants = require("./constants");
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
/** Takes a `node` object and transforms any contained `$ref` node variables with a prefix, recursively calling
 * `withIdRefPrefix` for any other elements.
 *
 * @param node - The object node to which a ROOT_SCHEMA_PREFIX is added when a REF_KEY is part of it
 */ function withIdRefPrefixObject(node) {
    for(const key in node){
        const realObj = node;
        const value = realObj[key];
        if (key === (0, _constants.REF_KEY) && typeof value === "string" && value.startsWith("#")) realObj[key] = (0, _constants.ROOT_SCHEMA_PREFIX) + value;
        else realObj[key] = withIdRefPrefix(value);
    }
    return node;
}
/** Takes a `node` object list and transforms any contained `$ref` node variables with a prefix, recursively calling
 * `withIdRefPrefix` for any other elements.
 *
 * @param node - The list of object nodes to which a ROOT_SCHEMA_PREFIX is added when a REF_KEY is part of it
 */ function withIdRefPrefixArray(node) {
    for(let i = 0; i < node.length; i++)node[i] = withIdRefPrefix(node[i]);
    return node;
}
function withIdRefPrefix(schemaNode) {
    if (Array.isArray(schemaNode)) return withIdRefPrefixArray([
        ...schemaNode
    ]);
    if ((0, _isObjectDefault.default)(schemaNode)) return withIdRefPrefixObject({
        ...schemaNode
    });
    return schemaNode;
}

},{"./constants":"7SuQb","lodash/isObject":"kYJe3","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"he9xI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fM0s1":[function(require,module,exports) {
/** An enumeration of all the translatable strings used by `@rjsf/core` and its themes. The value of each of the
 * enumeration keys is expected to be the actual english string. Some strings contain replaceable parameter values
 * as indicated by `%1`, `%2`, etc. The number after the `%` indicates the order of the parameter. The ordering of
 * parameters is important because some languages may choose to put the second parameter before the first in its
 * translation. Also, some strings are rendered using `markdown-to-jsx` and thus support markdown and inline html.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TranslatableString", ()=>TranslatableString);
var TranslatableString;
(function(TranslatableString) {
    /** Fallback title of an array item, used by ArrayField */ TranslatableString["ArrayItemTitle"] = "Item";
    /** Missing items reason, used by ArrayField */ TranslatableString["MissingItems"] = "Missing items definition";
    /** Yes label, used by BooleanField */ TranslatableString["YesLabel"] = "Yes";
    /** No label, used by BooleanField */ TranslatableString["NoLabel"] = "No";
    /** Close label, used by ErrorList */ TranslatableString["CloseLabel"] = "Close";
    /** Errors label, used by ErrorList */ TranslatableString["ErrorsLabel"] = "Errors";
    /** New additionalProperties string default value, used by ObjectField */ TranslatableString["NewStringDefault"] = "New Value";
    /** Add button title, used by AddButton */ TranslatableString["AddButton"] = "Add";
    /** Add button title, used by AddButton */ TranslatableString["AddItemButton"] = "Add Item";
    /** Copy button title, used by IconButton */ TranslatableString["CopyButton"] = "Copy";
    /** Move down button title, used by IconButton */ TranslatableString["MoveDownButton"] = "Move down";
    /** Move up button title, used by IconButton */ TranslatableString["MoveUpButton"] = "Move up";
    /** Remove button title, used by IconButton */ TranslatableString["RemoveButton"] = "Remove";
    /** Now label, used by AltDateWidget */ TranslatableString["NowLabel"] = "Now";
    /** Clear label, used by AltDateWidget */ TranslatableString["ClearLabel"] = "Clear";
    /** Aria date label, used by DateWidget */ TranslatableString["AriaDateLabel"] = "Select a date";
    /** File preview label, used by FileWidget */ TranslatableString["PreviewLabel"] = "Preview";
    /** Decrement button aria label, used by UpDownWidget */ TranslatableString["DecrementAriaLabel"] = "Decrease value by 1";
    /** Increment button aria label, used by UpDownWidget */ TranslatableString["IncrementAriaLabel"] = "Increase value by 1";
    // Strings with replaceable parameters
    /** Unknown field type reason, where %1 will be replaced with the type as provided by SchemaField */ TranslatableString["UnknownFieldType"] = "Unknown field type %1";
    /** Option prefix, where %1 will be replaced with the option index as provided by MultiSchemaField */ TranslatableString["OptionPrefix"] = "Option %1";
    /** Option prefix, where %1 and %2 will be replaced by the schema title and option index, respectively as provided by
     * MultiSchemaField
     */ TranslatableString["TitleOptionPrefix"] = "%1 option %2";
    /** Key label, where %1 will be replaced by the label as provided by WrapIfAdditionalTemplate */ TranslatableString["KeyLabel"] = "%1 Key";
    // Strings with replaceable parameters AND/OR that support markdown and html
    /** Invalid object field configuration as provided by the ObjectField */ TranslatableString["InvalidObjectField"] = 'Invalid "%1" object field configuration: <em>%2</em>.';
    /** Unsupported field schema, used by UnsupportedField */ TranslatableString["UnsupportedField"] = "Unsupported field schema.";
    /** Unsupported field schema, where %1 will be replaced by the idSchema.$id as provided by UnsupportedField */ TranslatableString["UnsupportedFieldWithId"] = "Unsupported field schema for field <code>%1</code>.";
    /** Unsupported field schema, where %1 will be replaced by the reason string as provided by UnsupportedField */ TranslatableString["UnsupportedFieldWithReason"] = "Unsupported field schema: <em>%1</em>.";
    /** Unsupported field schema, where %1 and %2 will be replaced by the idSchema.$id and reason strings, respectively,
     * as provided by UnsupportedField
     */ TranslatableString["UnsupportedFieldWithIdAndReason"] = "Unsupported field schema for field <code>%1</code>: <em>%2</em>.";
    /** File name, type and size info, where %1, %2 and %3 will be replaced by the file name, file type and file size as
     * provided by FileWidget
     */ TranslatableString["FilesInfo"] = "**%1** (%2, %3 bytes)";
})(TranslatableString || (TranslatableString = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cJlLS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemaParser", ()=>(0, _schemaParserDefault.default));
var _schemaParser = require("./schemaParser");
var _schemaParserDefault = parcelHelpers.interopDefault(_schemaParser);

},{"./schemaParser":"4acXg","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4acXg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>schemaParser);
var _forEach = require("lodash/forEach");
var _forEachDefault = parcelHelpers.interopDefault(_forEach);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _constants = require("../constants");
var _parserValidator = require("./ParserValidator");
var _parserValidatorDefault = parcelHelpers.interopDefault(_parserValidator);
var _retrieveSchema = require("../schema/retrieveSchema");
/** Recursive function used to parse the given `schema` belonging to the `rootSchema`. The `validator` is used to
 * capture the sub-schemas that the `isValid()` function is called with. For each schema returned by the
 * `retrieveSchemaInternal()`, the `resolveAnyOrOneOfSchemas()` function is called. For each of the schemas returned
 * from THAT call have `properties`, then each of the sub-schema property objects are then recursively parsed.
 *
 * @param validator - The `ParserValidator` implementation used to capture `isValid()` calls during parsing
 * @param recurseList - The list of schemas returned from the `retrieveSchemaInternal`, preventing infinite recursion
 * @param rootSchema - The root schema from which the schema parsing began
 * @param schema - The current schema element being parsed
 */ function parseSchema(validator, recurseList, rootSchema, schema) {
    const schemas = (0, _retrieveSchema.retrieveSchemaInternal)(validator, schema, rootSchema, undefined, true);
    schemas.forEach((schema)=>{
        const sameSchemaIndex = recurseList.findIndex((item)=>(0, _isEqualDefault.default)(item, schema));
        if (sameSchemaIndex === -1) {
            recurseList.push(schema);
            const allOptions = (0, _retrieveSchema.resolveAnyOrOneOfSchemas)(validator, schema, rootSchema, true);
            allOptions.forEach((s)=>{
                if ((0, _constants.PROPERTIES_KEY) in s && s[0, _constants.PROPERTIES_KEY]) (0, _forEachDefault.default)(schema[0, _constants.PROPERTIES_KEY], (value)=>{
                    parseSchema(validator, recurseList, rootSchema, value);
                });
            });
            if ((0, _constants.ITEMS_KEY) in schema && !Array.isArray(schema.items) && typeof schema.items !== "boolean") parseSchema(validator, recurseList, rootSchema, schema.items);
        }
    });
}
function schemaParser(rootSchema) {
    const validator = new (0, _parserValidatorDefault.default)(rootSchema);
    const recurseList = [];
    parseSchema(validator, recurseList, rootSchema, rootSchema);
    return validator.getSchemaMap();
}

},{"lodash/forEach":"b9hn9","lodash/isEqual":"cMAmC","../constants":"7SuQb","./ParserValidator":"kFWin","../schema/retrieveSchema":"g3Irx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kFWin":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEqual = require("lodash/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _constants = require("../constants");
var _hashForSchema = require("../hashForSchema");
var _hashForSchemaDefault = parcelHelpers.interopDefault(_hashForSchema);
class ParserValidator {
    /** Construct the ParserValidator for the given `rootSchema`. This `rootSchema` will be stashed in the `schemaMap`
     * first.
     *
     * @param rootSchema - The root schema against which this validator will be executed
     */ constructor(rootSchema){
        /** The map of schemas encountered by the ParserValidator */ this.schemaMap = {};
        this.rootSchema = rootSchema;
        this.addSchema(rootSchema, (0, _hashForSchemaDefault.default)(rootSchema));
    }
    /** Adds the given `schema` to the `schemaMap` keyed by the `hash` or `ID_KEY` if present on the `schema`. If the
     * schema does not have an `ID_KEY`, then the `hash` will be added as the `ID_KEY` to allow the schema to be
     * associated with it's `hash` for future use (by a schema compiler).
     *
     * @param schema - The schema which is to be added to the map
     * @param hash - The hash value at which to map the schema
     */ addSchema(schema, hash) {
        const key = (0, _getDefault.default)(schema, (0, _constants.ID_KEY), hash);
        const identifiedSchema = {
            ...schema,
            [(0, _constants.ID_KEY)]: key
        };
        const existing = this.schemaMap[key];
        if (!existing) this.schemaMap[key] = identifiedSchema;
        else if (!(0, _isEqualDefault.default)(existing, identifiedSchema)) {
            console.error("existing schema:", JSON.stringify(existing, null, 2));
            console.error("new schema:", JSON.stringify(identifiedSchema, null, 2));
            throw new Error(`Two different schemas exist with the same key ${key}! What a bad coincidence. If possible, try adding an $id to one of the schemas`);
        }
    }
    /** Returns the current `schemaMap` to the caller
     */ getSchemaMap() {
        return this.schemaMap;
    }
    /** Implements the `ValidatorType` `isValid()` method to capture the `schema` in the `schemaMap`. Throws an error when
     * the `rootSchema` is not the same as the root schema provided during construction.
     *
     * @param schema - The schema to record in the `schemaMap`
     * @param _formData - The formData parameter that is ignored
     * @param rootSchema - The root schema associated with the schema
     * @throws - Error when the given `rootSchema` differs from the root schema provided during construction
     */ isValid(schema, _formData, rootSchema) {
        if (!(0, _isEqualDefault.default)(rootSchema, this.rootSchema)) throw new Error("Unexpectedly calling isValid() with a rootSchema that differs from the construction rootSchema");
        this.addSchema(schema, (0, _hashForSchemaDefault.default)(schema));
        return false;
    }
    /** Implements the `ValidatorType` `rawValidation()` method to throw an error since it is never supposed to be called
     *
     * @param _schema - The schema parameter that is ignored
     * @param _formData - The formData parameter that is ignored
     */ rawValidation(_schema, _formData) {
        throw new Error("Unexpectedly calling the `rawValidation()` method during schema parsing");
    }
    /** Implements the `ValidatorType` `toErrorList()` method to throw an error since it is never supposed to be called
     *
     * @param _errorSchema - The error schema parameter that is ignored
     * @param _fieldPath - The field path parameter that is ignored
     */ toErrorList(_errorSchema, _fieldPath) {
        throw new Error("Unexpectedly calling the `toErrorList()` method during schema parsing");
    }
    /** Implements the `ValidatorType` `validateFormData()` method to throw an error since it is never supposed to be
     * called
     *
     * @param _formData - The formData parameter that is ignored
     * @param _schema - The schema parameter that is ignored
     * @param _customValidate - The customValidate parameter that is ignored
     * @param _transformErrors - The transformErrors parameter that is ignored
     * @param _uiSchema - The uiSchema parameter that is ignored
     */ validateFormData(_formData, _schema, _customValidate, _transformErrors, _uiSchema) {
        throw new Error("Unexpectedly calling the `validateFormData()` method during schema parsing");
    }
}
exports.default = ParserValidator;

},{"lodash/get":"g5ox6","lodash/isEqual":"cMAmC","../constants":"7SuQb","../hashForSchema":"hGAwf","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4ZUxZ":[function(require,module,exports) {
var basePick = require("e13834df88faab8"), flatRest = require("7f4b4cdb31764f87");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
});
module.exports = pick;

},{"e13834df88faab8":"BagPL","7f4b4cdb31764f87":"ay1jj"}],"BagPL":[function(require,module,exports) {
var basePickBy = require("4620eb0b3c4f1463"), hasIn = require("c697490fd5f67a25");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function basePick(object, paths) {
    return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
    });
}
module.exports = basePick;

},{"4620eb0b3c4f1463":"eBLev","c697490fd5f67a25":"YHJaw"}],"eBLev":[function(require,module,exports) {
var baseGet = require("d8aa974fba65e61e"), baseSet = require("b07dbab95dca4167"), castPath = require("64b51364f27b9088");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"d8aa974fba65e61e":"5yD9j","b07dbab95dca4167":"3qkFO","64b51364f27b9088":"7zM0U"}],"dJxnW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDefaultRegistry);
var _utils = require("@rjsf/utils");
var _fields = require("./components/fields");
var _fieldsDefault = parcelHelpers.interopDefault(_fields);
var _templates = require("./components/templates");
var _templatesDefault = parcelHelpers.interopDefault(_templates);
var _widgets = require("./components/widgets");
var _widgetsDefault = parcelHelpers.interopDefault(_widgets);
function getDefaultRegistry() {
    return {
        fields: (0, _fieldsDefault.default)(),
        templates: (0, _templatesDefault.default)(),
        widgets: (0, _widgetsDefault.default)(),
        rootSchema: {},
        formContext: {},
        translateString: (0, _utils.englishStringTranslator)
    };
}

},{"@rjsf/utils":"joqWx","./components/fields":"3nOtF","./components/templates":"3Ts0H","./components/widgets":"hszus","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3nOtF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayField = require("./ArrayField");
var _arrayFieldDefault = parcelHelpers.interopDefault(_arrayField);
var _booleanField = require("./BooleanField");
var _booleanFieldDefault = parcelHelpers.interopDefault(_booleanField);
var _multiSchemaField = require("./MultiSchemaField");
var _multiSchemaFieldDefault = parcelHelpers.interopDefault(_multiSchemaField);
var _numberField = require("./NumberField");
var _numberFieldDefault = parcelHelpers.interopDefault(_numberField);
var _objectField = require("./ObjectField");
var _objectFieldDefault = parcelHelpers.interopDefault(_objectField);
var _schemaField = require("./SchemaField");
var _schemaFieldDefault = parcelHelpers.interopDefault(_schemaField);
var _stringField = require("./StringField");
var _stringFieldDefault = parcelHelpers.interopDefault(_stringField);
var _nullField = require("./NullField");
var _nullFieldDefault = parcelHelpers.interopDefault(_nullField);
function fields() {
    return {
        AnyOfField: (0, _multiSchemaFieldDefault.default),
        ArrayField: (0, _arrayFieldDefault.default),
        BooleanField: // ArrayField falls back to SchemaField if ArraySchemaField is not defined, which it isn't by default
        (0, _booleanFieldDefault.default),
        NumberField: (0, _numberFieldDefault.default),
        ObjectField: (0, _objectFieldDefault.default),
        OneOfField: (0, _multiSchemaFieldDefault.default),
        SchemaField: (0, _schemaFieldDefault.default),
        StringField: (0, _stringFieldDefault.default),
        NullField: (0, _nullFieldDefault.default)
    };
}
exports.default = fields;

},{"./ArrayField":"d3e4y","./BooleanField":"aW2w6","./MultiSchemaField":"7ZTJA","./NumberField":"jLWtP","./ObjectField":"dROHH","./SchemaField":"lVvmU","./StringField":"kXBLr","./NullField":"8G7v0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d3e4y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
var _cloneDeep = require("lodash/cloneDeep");
var _cloneDeepDefault = parcelHelpers.interopDefault(_cloneDeep);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _nanoid = require("nanoid");
/** Used to generate a unique ID for an element in a row */ function generateRowId() {
    return (0, _nanoid.nanoid)();
}
/** Converts the `formData` into `KeyedFormDataType` data, using the `generateRowId()` function to create the key
 *
 * @param formData - The data for the form
 * @returns - The `formData` converted into a `KeyedFormDataType` element
 */ function generateKeyedFormData(formData) {
    return !Array.isArray(formData) ? [] : formData.map((item)=>{
        return {
            key: generateRowId(),
            item
        };
    });
}
/** Converts `KeyedFormDataType` data into the inner `formData`
 *
 * @param keyedFormData - The `KeyedFormDataType` to be converted
 * @returns - The inner `formData` item(s) in the `keyedFormData`
 */ function keyedToPlainFormData(keyedFormData) {
    if (Array.isArray(keyedFormData)) return keyedFormData.map((keyedItem)=>keyedItem.item);
    return [];
}
/** The `ArrayField` component is used to render a field in the schema that is of type `array`. It supports both normal
 * and fixed array, allowing user to add and remove elements from the array data.
 */ class ArrayField extends (0, _react.Component) {
    /** Constructs an `ArrayField` from the `props`, generating the initial keyed data from the `formData`
     *
     * @param props - The `FieldProps` for this template
     */ constructor(props){
        super(props);
        /** Returns the default form information for an item based on the schema for that item. Deals with the possibility
         * that the schema is fixed and allows additional items.
         */ this._getNewFormDataRow = ()=>{
            const { schema, registry } = this.props;
            const { schemaUtils } = registry;
            let itemSchema = schema.items;
            if ((0, _utils.isFixedItems)(schema) && (0, _utils.allowAdditionalItems)(schema)) itemSchema = schema.additionalItems;
            // Cast this as a T to work around schema utils being for T[] caused by the FieldProps<T[], S, F> call on the class
            return schemaUtils.getDefaultFormState(itemSchema);
        };
        /** Callback handler for when the user clicks on the add button. Creates a new row of keyed form data at the end of
         * the list, adding it into the state, and then returning `onChange()` with the plain form data converted from the
         * keyed data
         *
         * @param event - The event for the click
         */ this.onAddClick = (event)=>{
            this._handleAddClick(event);
        };
        /** Callback handler for when the user clicks on the add button on an existing array element. Creates a new row of
         * keyed form data inserted at the `index`, adding it into the state, and then returning `onChange()` with the plain
         * form data converted from the keyed data
         *
         * @param index - The index at which the add button is clicked
         */ this.onAddIndexClick = (index)=>{
            return (event)=>{
                this._handleAddClick(event, index);
            };
        };
        /** Callback handler for when the user clicks on the copy button on an existing array element. Clones the row of
         * keyed form data at the `index` into the next position in the state, and then returning `onChange()` with the plain
         * form data converted from the keyed data
         *
         * @param index - The index at which the copy button is clicked
         */ this.onCopyIndexClick = (index)=>{
            return (event)=>{
                if (event) event.preventDefault();
                const { onChange, errorSchema } = this.props;
                const { keyedFormData } = this.state;
                // refs #195: revalidate to ensure properly reindexing errors
                let newErrorSchema;
                if (errorSchema) {
                    newErrorSchema = {};
                    for(const idx in errorSchema){
                        const i = parseInt(idx);
                        if (i <= index) (0, _setDefault.default)(newErrorSchema, [
                            i
                        ], errorSchema[idx]);
                        else if (i > index) (0, _setDefault.default)(newErrorSchema, [
                            i + 1
                        ], errorSchema[idx]);
                    }
                }
                const newKeyedFormDataRow = {
                    key: generateRowId(),
                    item: (0, _cloneDeepDefault.default)(keyedFormData[index].item)
                };
                const newKeyedFormData = [
                    ...keyedFormData
                ];
                if (index !== undefined) newKeyedFormData.splice(index + 1, 0, newKeyedFormDataRow);
                else newKeyedFormData.push(newKeyedFormDataRow);
                this.setState({
                    keyedFormData: newKeyedFormData,
                    updatedKeyedFormData: true
                }, ()=>onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema));
            };
        };
        /** Callback handler for when the user clicks on the remove button on an existing array element. Removes the row of
         * keyed form data at the `index` in the state, and then returning `onChange()` with the plain form data converted
         * from the keyed data
         *
         * @param index - The index at which the remove button is clicked
         */ this.onDropIndexClick = (index)=>{
            return (event)=>{
                if (event) event.preventDefault();
                const { onChange, errorSchema } = this.props;
                const { keyedFormData } = this.state;
                // refs #195: revalidate to ensure properly reindexing errors
                let newErrorSchema;
                if (errorSchema) {
                    newErrorSchema = {};
                    for(const idx in errorSchema){
                        const i = parseInt(idx);
                        if (i < index) (0, _setDefault.default)(newErrorSchema, [
                            i
                        ], errorSchema[idx]);
                        else if (i > index) (0, _setDefault.default)(newErrorSchema, [
                            i - 1
                        ], errorSchema[idx]);
                    }
                }
                const newKeyedFormData = keyedFormData.filter((_, i)=>i !== index);
                this.setState({
                    keyedFormData: newKeyedFormData,
                    updatedKeyedFormData: true
                }, ()=>onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema));
            };
        };
        /** Callback handler for when the user clicks on one of the move item buttons on an existing array element. Moves the
         * row of keyed form data at the `index` to the `newIndex` in the state, and then returning `onChange()` with the
         * plain form data converted from the keyed data
         *
         * @param index - The index of the item to move
         * @param newIndex - The index to where the item is to be moved
         */ this.onReorderClick = (index, newIndex)=>{
            return (event)=>{
                if (event) {
                    event.preventDefault();
                    event.currentTarget.blur();
                }
                const { onChange, errorSchema } = this.props;
                let newErrorSchema;
                if (errorSchema) {
                    newErrorSchema = {};
                    for(const idx in errorSchema){
                        const i = parseInt(idx);
                        if (i == index) (0, _setDefault.default)(newErrorSchema, [
                            newIndex
                        ], errorSchema[index]);
                        else if (i == newIndex) (0, _setDefault.default)(newErrorSchema, [
                            index
                        ], errorSchema[newIndex]);
                        else (0, _setDefault.default)(newErrorSchema, [
                            idx
                        ], errorSchema[i]);
                    }
                }
                const { keyedFormData } = this.state;
                function reOrderArray() {
                    // Copy item
                    const _newKeyedFormData = keyedFormData.slice();
                    // Moves item from index to newIndex
                    _newKeyedFormData.splice(index, 1);
                    _newKeyedFormData.splice(newIndex, 0, keyedFormData[index]);
                    return _newKeyedFormData;
                }
                const newKeyedFormData = reOrderArray();
                this.setState({
                    keyedFormData: newKeyedFormData
                }, ()=>onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema));
            };
        };
        /** Callback handler used to deal with changing the value of the data in the array at the `index`. Calls the
         * `onChange` callback with the updated form data
         *
         * @param index - The index of the item being changed
         */ this.onChangeForIndex = (index)=>{
            return (value, newErrorSchema, id)=>{
                const { formData, onChange, errorSchema } = this.props;
                const arrayData = Array.isArray(formData) ? formData : [];
                const newFormData = arrayData.map((item, i)=>{
                    // We need to treat undefined items as nulls to have validation.
                    // See https://github.com/tdegrunt/jsonschema/issues/206
                    const jsonValue = typeof value === "undefined" ? null : value;
                    return index === i ? jsonValue : item;
                });
                onChange(newFormData, errorSchema && errorSchema && {
                    ...errorSchema,
                    [index]: newErrorSchema
                }, id);
            };
        };
        /** Callback handler used to change the value for a checkbox */ this.onSelectChange = (value)=>{
            const { onChange, idSchema } = this.props;
            onChange(value, undefined, idSchema && idSchema.$id);
        };
        const { formData = [] } = props;
        const keyedFormData = generateKeyedFormData(formData);
        this.state = {
            keyedFormData,
            updatedKeyedFormData: false
        };
    }
    /** React lifecycle method that is called when the props are about to change allowing the state to be updated. It
     * regenerates the keyed form data and returns it
     *
     * @param nextProps - The next set of props data
     * @param prevState - The previous set of state data
     */ static getDerivedStateFromProps(nextProps, prevState) {
        // Don't call getDerivedStateFromProps if keyed formdata was just updated.
        if (prevState.updatedKeyedFormData) return {
            updatedKeyedFormData: false
        };
        const nextFormData = Array.isArray(nextProps.formData) ? nextProps.formData : [];
        const previousKeyedFormData = prevState.keyedFormData || [];
        const newKeyedFormData = nextFormData.length === previousKeyedFormData.length ? previousKeyedFormData.map((previousKeyedFormDatum, index)=>{
            return {
                key: previousKeyedFormDatum.key,
                item: nextFormData[index]
            };
        }) : generateKeyedFormData(nextFormData);
        return {
            keyedFormData: newKeyedFormData
        };
    }
    /** Returns the appropriate title for an item by getting first the title from the schema.items, then falling back to
     * the description from the schema.items, and finally the string "Item"
     */ get itemTitle() {
        const { schema, registry } = this.props;
        const { translateString } = registry;
        return (0, _getDefault.default)(schema, [
            (0, _utils.ITEMS_KEY),
            "title"
        ], (0, _getDefault.default)(schema, [
            (0, _utils.ITEMS_KEY),
            "description"
        ], translateString((0, _utils.TranslatableString).ArrayItemTitle)));
    }
    /** Determines whether the item described in the schema is always required, which is determined by whether any item
     * may be null.
     *
     * @param itemSchema - The schema for the item
     * @return - True if the item schema type does not contain the "null" type
     */ isItemRequired(itemSchema) {
        if (Array.isArray(itemSchema.type)) // While we don't yet support composite/nullable jsonschema types, it's
        // future-proof to check for requirement against these.
        return !itemSchema.type.includes("null");
        // All non-null array item types are inherently required by design
        return itemSchema.type !== "null";
    }
    /** Determines whether more items can be added to the array. If the uiSchema indicates the array doesn't allow adding
     * then false is returned. Otherwise, if the schema indicates that there are a maximum number of items and the
     * `formData` matches that value, then false is returned, otherwise true is returned.
     *
     * @param formItems - The list of items in the form
     * @returns - True if the item is addable otherwise false
     */ canAddItem(formItems) {
        const { schema, uiSchema, registry } = this.props;
        let { addable } = (0, _utils.getUiOptions)(uiSchema, registry.globalUiOptions);
        if (addable !== false) {
            // if ui:options.addable was not explicitly set to false, we can add
            // another item if we have not exceeded maxItems yet
            if (schema.maxItems !== undefined) addable = formItems.length < schema.maxItems;
            else addable = true;
        }
        return addable;
    }
    /** Callback handler for when the user clicks on the add or add at index buttons. Creates a new row of keyed form data
     * either at the end of the list (when index is not specified) or inserted at the `index` when it is, adding it into
     * the state, and then returning `onChange()` with the plain form data converted from the keyed data
     *
     * @param event - The event for the click
     * @param [index] - The optional index at which to add the new data
     */ _handleAddClick(event, index) {
        if (event) event.preventDefault();
        const { onChange, errorSchema } = this.props;
        const { keyedFormData } = this.state;
        // refs #195: revalidate to ensure properly reindexing errors
        let newErrorSchema;
        if (errorSchema) {
            newErrorSchema = {};
            for(const idx in errorSchema){
                const i = parseInt(idx);
                if (index === undefined || i < index) (0, _setDefault.default)(newErrorSchema, [
                    i
                ], errorSchema[idx]);
                else if (i >= index) (0, _setDefault.default)(newErrorSchema, [
                    i + 1
                ], errorSchema[idx]);
            }
        }
        const newKeyedFormDataRow = {
            key: generateRowId(),
            item: this._getNewFormDataRow()
        };
        const newKeyedFormData = [
            ...keyedFormData
        ];
        if (index !== undefined) newKeyedFormData.splice(index, 0, newKeyedFormDataRow);
        else newKeyedFormData.push(newKeyedFormDataRow);
        this.setState({
            keyedFormData: newKeyedFormData,
            updatedKeyedFormData: true
        }, ()=>onChange(keyedToPlainFormData(newKeyedFormData), newErrorSchema));
    }
    /** Renders the `ArrayField` depending on the specific needs of the schema and uischema elements
     */ render() {
        const { schema, uiSchema, idSchema, registry } = this.props;
        const { schemaUtils, translateString } = registry;
        if (!((0, _utils.ITEMS_KEY) in schema)) {
            const uiOptions = (0, _utils.getUiOptions)(uiSchema);
            const UnsupportedFieldTemplate = (0, _utils.getTemplate)("UnsupportedFieldTemplate", registry, uiOptions);
            return (0, _jsxRuntime.jsx)(UnsupportedFieldTemplate, {
                schema: schema,
                idSchema: idSchema,
                reason: translateString((0, _utils.TranslatableString).MissingItems),
                registry: registry
            });
        }
        if (schemaUtils.isMultiSelect(schema)) // If array has enum or uniqueItems set to true, call renderMultiSelect() to render the default multiselect widget or a custom widget, if specified.
        return this.renderMultiSelect();
        if ((0, _utils.isCustomWidget)(uiSchema)) return this.renderCustomWidget();
        if ((0, _utils.isFixedItems)(schema)) return this.renderFixedArray();
        if (schemaUtils.isFilesArray(schema, uiSchema)) return this.renderFiles();
        return this.renderNormalArray();
    }
    /** Renders a normal array without any limitations of length
     */ renderNormalArray() {
        const { schema, uiSchema = {}, errorSchema, idSchema, name, title, disabled = false, readonly = false, autofocus = false, required = false, registry, onBlur, onFocus, idPrefix, idSeparator = "_", rawErrors } = this.props;
        const { keyedFormData } = this.state;
        const fieldTitle = schema.title || title || name;
        const { schemaUtils, formContext } = registry;
        const uiOptions = (0, _utils.getUiOptions)(uiSchema);
        const _schemaItems = (0, _isObjectDefault.default)(schema.items) ? schema.items : {};
        const itemsSchema = schemaUtils.retrieveSchema(_schemaItems);
        const formData = keyedToPlainFormData(this.state.keyedFormData);
        const canAdd = this.canAddItem(formData);
        const arrayProps = {
            canAdd,
            items: keyedFormData.map((keyedItem, index)=>{
                const { key, item } = keyedItem;
                // While we are actually dealing with a single item of type T, the types require a T[], so cast
                const itemCast = item;
                const itemSchema = schemaUtils.retrieveSchema(_schemaItems, itemCast);
                const itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
                const itemIdPrefix = idSchema.$id + idSeparator + index;
                const itemIdSchema = schemaUtils.toIdSchema(itemSchema, itemIdPrefix, itemCast, idPrefix, idSeparator);
                return this.renderArrayFieldItem({
                    key,
                    index,
                    name: name && `${name}-${index}`,
                    title: fieldTitle ? `${fieldTitle}-${index + 1}` : undefined,
                    canAdd,
                    canMoveUp: index > 0,
                    canMoveDown: index < formData.length - 1,
                    itemSchema,
                    itemIdSchema,
                    itemErrorSchema,
                    itemData: itemCast,
                    itemUiSchema: uiSchema.items,
                    autofocus: autofocus && index === 0,
                    onBlur,
                    onFocus,
                    rawErrors,
                    totalItems: keyedFormData.length
                });
            }),
            className: `field field-array field-array-of-${itemsSchema.type}`,
            disabled,
            idSchema,
            uiSchema,
            onAddClick: this.onAddClick,
            readonly,
            required,
            schema,
            title: fieldTitle,
            formContext,
            formData,
            rawErrors,
            registry
        };
        const Template = (0, _utils.getTemplate)("ArrayFieldTemplate", registry, uiOptions);
        return (0, _jsxRuntime.jsx)(Template, {
            ...arrayProps
        });
    }
    /** Renders an array using the custom widget provided by the user in the `uiSchema`
     */ renderCustomWidget() {
        var _a;
        const { schema, idSchema, uiSchema, disabled = false, readonly = false, autofocus = false, required = false, hideError, placeholder, onBlur, onFocus, formData: items = [], registry, rawErrors, name } = this.props;
        const { widgets, formContext, globalUiOptions, schemaUtils } = registry;
        const { widget, title: uiTitle, ...options } = (0, _utils.getUiOptions)(uiSchema, globalUiOptions);
        const Widget = (0, _utils.getWidget)(schema, widget, widgets);
        const label = (_a = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schema.title) !== null && _a !== void 0 ? _a : name;
        const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
        return (0, _jsxRuntime.jsx)(Widget, {
            id: idSchema.$id,
            name: name,
            multiple: true,
            onChange: this.onSelectChange,
            onBlur: onBlur,
            onFocus: onFocus,
            options: options,
            schema: schema,
            uiSchema: uiSchema,
            registry: registry,
            value: items,
            disabled: disabled,
            readonly: readonly,
            hideError: hideError,
            required: required,
            label: label,
            hideLabel: !displayLabel,
            placeholder: placeholder,
            formContext: formContext,
            autofocus: autofocus,
            rawErrors: rawErrors
        });
    }
    /** Renders an array as a set of checkboxes
     */ renderMultiSelect() {
        var _a;
        const { schema, idSchema, uiSchema, formData: items = [], disabled = false, readonly = false, autofocus = false, required = false, placeholder, onBlur, onFocus, registry, rawErrors, name } = this.props;
        const { widgets, schemaUtils, formContext, globalUiOptions } = registry;
        const itemsSchema = schemaUtils.retrieveSchema(schema.items, items);
        const enumOptions = (0, _utils.optionsList)(itemsSchema);
        const { widget = "select", title: uiTitle, ...options } = (0, _utils.getUiOptions)(uiSchema, globalUiOptions);
        const Widget = (0, _utils.getWidget)(schema, widget, widgets);
        const label = (_a = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schema.title) !== null && _a !== void 0 ? _a : name;
        const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
        return (0, _jsxRuntime.jsx)(Widget, {
            id: idSchema.$id,
            name: name,
            multiple: true,
            onChange: this.onSelectChange,
            onBlur: onBlur,
            onFocus: onFocus,
            options: {
                ...options,
                enumOptions
            },
            schema: schema,
            uiSchema: uiSchema,
            registry: registry,
            value: items,
            disabled: disabled,
            readonly: readonly,
            required: required,
            label: label,
            hideLabel: !displayLabel,
            placeholder: placeholder,
            formContext: formContext,
            autofocus: autofocus,
            rawErrors: rawErrors
        });
    }
    /** Renders an array of files using the `FileWidget`
     */ renderFiles() {
        var _a;
        const { schema, uiSchema, idSchema, name, disabled = false, readonly = false, autofocus = false, required = false, onBlur, onFocus, registry, formData: items = [], rawErrors } = this.props;
        const { widgets, formContext, globalUiOptions, schemaUtils } = registry;
        const { widget = "files", title: uiTitle, ...options } = (0, _utils.getUiOptions)(uiSchema, globalUiOptions);
        const Widget = (0, _utils.getWidget)(schema, widget, widgets);
        const label = (_a = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schema.title) !== null && _a !== void 0 ? _a : name;
        const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
        return (0, _jsxRuntime.jsx)(Widget, {
            options: options,
            id: idSchema.$id,
            name: name,
            multiple: true,
            onChange: this.onSelectChange,
            onBlur: onBlur,
            onFocus: onFocus,
            schema: schema,
            uiSchema: uiSchema,
            value: items,
            disabled: disabled,
            readonly: readonly,
            required: required,
            registry: registry,
            formContext: formContext,
            autofocus: autofocus,
            rawErrors: rawErrors,
            label: label,
            hideLabel: !displayLabel
        });
    }
    /** Renders an array that has a maximum limit of items
     */ renderFixedArray() {
        const { schema, uiSchema = {}, formData = [], errorSchema, idPrefix, idSeparator = "_", idSchema, name, title, disabled = false, readonly = false, autofocus = false, required = false, registry, onBlur, onFocus, rawErrors } = this.props;
        const { keyedFormData } = this.state;
        let { formData: items = [] } = this.props;
        const fieldTitle = schema.title || title || name;
        const uiOptions = (0, _utils.getUiOptions)(uiSchema);
        const { schemaUtils, formContext } = registry;
        const _schemaItems = (0, _isObjectDefault.default)(schema.items) ? schema.items : [];
        const itemSchemas = _schemaItems.map((item, index)=>schemaUtils.retrieveSchema(item, formData[index]));
        const additionalSchema = (0, _isObjectDefault.default)(schema.additionalItems) ? schemaUtils.retrieveSchema(schema.additionalItems, formData) : null;
        if (!items || items.length < itemSchemas.length) {
            // to make sure at least all fixed items are generated
            items = items || [];
            items = items.concat(new Array(itemSchemas.length - items.length));
        }
        // These are the props passed into the render function
        const canAdd = this.canAddItem(items) && !!additionalSchema;
        const arrayProps = {
            canAdd,
            className: "field field-array field-array-fixed-items",
            disabled,
            idSchema,
            formData,
            items: keyedFormData.map((keyedItem, index)=>{
                const { key, item } = keyedItem;
                // While we are actually dealing with a single item of type T, the types require a T[], so cast
                const itemCast = item;
                const additional = index >= itemSchemas.length;
                const itemSchema = (additional && (0, _isObjectDefault.default)(schema.additionalItems) ? schemaUtils.retrieveSchema(schema.additionalItems, itemCast) : itemSchemas[index]) || {};
                const itemIdPrefix = idSchema.$id + idSeparator + index;
                const itemIdSchema = schemaUtils.toIdSchema(itemSchema, itemIdPrefix, itemCast, idPrefix, idSeparator);
                const itemUiSchema = additional ? uiSchema.additionalItems || {} : Array.isArray(uiSchema.items) ? uiSchema.items[index] : uiSchema.items || {};
                const itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
                return this.renderArrayFieldItem({
                    key,
                    index,
                    name: name && `${name}-${index}`,
                    title: fieldTitle ? `${fieldTitle}-${index + 1}` : undefined,
                    canAdd,
                    canRemove: additional,
                    canMoveUp: index >= itemSchemas.length + 1,
                    canMoveDown: additional && index < items.length - 1,
                    itemSchema,
                    itemData: itemCast,
                    itemUiSchema,
                    itemIdSchema,
                    itemErrorSchema,
                    autofocus: autofocus && index === 0,
                    onBlur,
                    onFocus,
                    rawErrors,
                    totalItems: keyedFormData.length
                });
            }),
            onAddClick: this.onAddClick,
            readonly,
            required,
            registry,
            schema,
            uiSchema,
            title: fieldTitle,
            formContext,
            errorSchema,
            rawErrors
        };
        const Template = (0, _utils.getTemplate)("ArrayFieldTemplate", registry, uiOptions);
        return (0, _jsxRuntime.jsx)(Template, {
            ...arrayProps
        });
    }
    /** Renders the individual array item using a `SchemaField` along with the additional properties required to be send
     * back to the `ArrayFieldItemTemplate`.
     *
     * @param props - The props for the individual array item to be rendered
     */ renderArrayFieldItem(props) {
        const { key, index, name, canAdd, canRemove = true, canMoveUp, canMoveDown, itemSchema, itemData, itemUiSchema, itemIdSchema, itemErrorSchema, autofocus, onBlur, onFocus, rawErrors, totalItems, title } = props;
        const { disabled, hideError, idPrefix, idSeparator, readonly, uiSchema, registry, formContext } = this.props;
        const { fields: { ArraySchemaField, SchemaField }, globalUiOptions } = registry;
        const ItemSchemaField = ArraySchemaField || SchemaField;
        const { orderable = true, removable = true, copyable = false } = (0, _utils.getUiOptions)(uiSchema, globalUiOptions);
        const has = {
            moveUp: orderable && canMoveUp,
            moveDown: orderable && canMoveDown,
            copy: copyable && canAdd,
            remove: removable && canRemove,
            toolbar: false
        };
        has.toolbar = Object.keys(has).some((key)=>has[key]);
        return {
            children: (0, _jsxRuntime.jsx)(ItemSchemaField, {
                name: name,
                title: title,
                index: index,
                schema: itemSchema,
                uiSchema: itemUiSchema,
                formData: itemData,
                formContext: formContext,
                errorSchema: itemErrorSchema,
                idPrefix: idPrefix,
                idSeparator: idSeparator,
                idSchema: itemIdSchema,
                required: this.isItemRequired(itemSchema),
                onChange: this.onChangeForIndex(index),
                onBlur: onBlur,
                onFocus: onFocus,
                registry: registry,
                disabled: disabled,
                readonly: readonly,
                hideError: hideError,
                autofocus: autofocus,
                rawErrors: rawErrors
            }),
            className: "array-item",
            disabled,
            canAdd,
            hasCopy: has.copy,
            hasToolbar: has.toolbar,
            hasMoveUp: has.moveUp,
            hasMoveDown: has.moveDown,
            hasRemove: has.remove,
            index,
            totalItems,
            key,
            onAddIndexClick: this.onAddIndexClick,
            onCopyIndexClick: this.onCopyIndexClick,
            onDropIndexClick: this.onDropIndexClick,
            onReorderClick: this.onReorderClick,
            readonly,
            registry,
            schema: itemSchema,
            uiSchema: itemUiSchema
        };
    }
}
/** `ArrayField` is `React.ComponentType<FieldProps<T[], S, F>>` (necessarily) but the `registry` requires things to be a
 * `Field` which is defined as `React.ComponentType<FieldProps<T, S, F>>`, so cast it to make `registry` happy.
 */ exports.default = ArrayField;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","lodash/cloneDeep":"4qlAD","lodash/get":"g5ox6","lodash/isObject":"kYJe3","lodash/set":"04gxh","nanoid":"jDufQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jDufQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "customAlphabet", ()=>customAlphabet);
parcelHelpers.export(exports, "customRandom", ()=>customRandom);
parcelHelpers.export(exports, "urlAlphabet", ()=>(0, _indexJs.urlAlphabet));
parcelHelpers.export(exports, "random", ()=>random);
var _indexJs = require("./url-alphabet/index.js");
let random = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let customAlphabet = (alphabet, size = 21)=>customRandom(alphabet, size, random);
let nanoid = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

},{"./url-alphabet/index.js":"a5xf9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a5xf9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "urlAlphabet", ()=>urlAlphabet);
let urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aW2w6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
/** The `BooleanField` component is used to render a field in the schema is boolean. It constructs `enumOptions` for the
 * two boolean values based on the various alternatives in the schema.
 *
 * @param props - The `FieldProps` for this template
 */ function BooleanField(props) {
    var _a, _b, _c;
    const { schema, name, uiSchema, idSchema, formData, registry, required, disabled, readonly, hideError, autofocus, title, onChange, onFocus, onBlur, rawErrors } = props;
    const { title: schemaTitle } = schema;
    const { widgets, formContext, translateString, globalUiOptions } = registry;
    const { widget = "checkbox", title: uiTitle, // Unlike the other fields, don't use `getDisplayLabel()` since it always returns false for the boolean type
    label: displayLabel = true, ...options } = (0, _utils.getUiOptions)(uiSchema, globalUiOptions);
    const Widget = (0, _utils.getWidget)(schema, widget, widgets);
    const yes = translateString((0, _utils.TranslatableString).YesLabel);
    const no = translateString((0, _utils.TranslatableString).NoLabel);
    let enumOptions;
    const label = (_b = (_a = uiTitle !== null && uiTitle !== void 0 ? uiTitle : schemaTitle) !== null && _a !== void 0 ? _a : title) !== null && _b !== void 0 ? _b : name;
    if (Array.isArray(schema.oneOf)) enumOptions = (0, _utils.optionsList)({
        oneOf: schema.oneOf.map((option)=>{
            if ((0, _isObjectDefault.default)(option)) return {
                ...option,
                title: option.title || (option.const === true ? yes : no)
            };
            return undefined;
        }).filter((o)=>o)
    });
    else {
        // We deprecated enumNames in v5. It's intentionally omitted from RSJFSchema type, so we need to cast here.
        const schemaWithEnumNames = schema;
        const enums = (_c = schema.enum) !== null && _c !== void 0 ? _c : [
            true,
            false
        ];
        if (!schemaWithEnumNames.enumNames && enums.length === 2 && enums.every((v)=>typeof v === "boolean")) enumOptions = [
            {
                value: enums[0],
                label: enums[0] ? yes : no
            },
            {
                value: enums[1],
                label: enums[1] ? yes : no
            }
        ];
        else enumOptions = (0, _utils.optionsList)({
            enum: enums,
            // NOTE: enumNames is deprecated, but still supported for now.
            enumNames: schemaWithEnumNames.enumNames
        });
    }
    return (0, _jsxRuntime.jsx)(Widget, {
        options: {
            ...options,
            enumOptions
        },
        schema: schema,
        uiSchema: uiSchema,
        id: idSchema.$id,
        name: name,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        label: label,
        hideLabel: !displayLabel,
        value: formData,
        required: required,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError,
        registry: registry,
        formContext: formContext,
        autofocus: autofocus,
        rawErrors: rawErrors
    });
}
exports.default = BooleanField;

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","lodash/isObject":"kYJe3","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7ZTJA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _isEmpty = require("lodash/isEmpty");
var _isEmptyDefault = parcelHelpers.interopDefault(_isEmpty);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _utils = require("@rjsf/utils");
/** The `AnyOfField` component is used to render a field in the schema that is an `anyOf`, `allOf` or `oneOf`. It tracks
 * the currently selected option and cleans up any irrelevant data in `formData`.
 *
 * @param props - The `FieldProps` for this template
 */ class AnyOfField extends (0, _react.Component) {
    /** Constructs an `AnyOfField` with the given `props` to initialize the initially selected option in state
     *
     * @param props - The `FieldProps` for this template
     */ constructor(props){
        super(props);
        /** Callback handler to remember what the currently selected option is. In addition to that the `formData` is updated
         * to remove properties that are not part of the newly selected option schema, and then the updated data is passed to
         * the `onChange` handler.
         *
         * @param option - The new option value being selected
         */ this.onOptionChange = (option)=>{
            const { selectedOption, retrievedOptions } = this.state;
            const { formData, onChange, registry } = this.props;
            const { schemaUtils } = registry;
            const intOption = option !== undefined ? parseInt(option, 10) : -1;
            if (intOption === selectedOption) return;
            const newOption = intOption >= 0 ? retrievedOptions[intOption] : undefined;
            const oldOption = selectedOption >= 0 ? retrievedOptions[selectedOption] : undefined;
            let newFormData = schemaUtils.sanitizeDataForNewSchema(newOption, oldOption, formData);
            if (newFormData && newOption) // Call getDefaultFormState to make sure defaults are populated on change. Pass "excludeObjectChildren"
            // so that only the root objects themselves are created without adding undefined children properties
            newFormData = schemaUtils.getDefaultFormState(newOption, newFormData, "excludeObjectChildren");
            onChange(newFormData, undefined, this.getFieldId());
            this.setState({
                selectedOption: intOption
            });
        };
        const { formData, options, registry: { schemaUtils } } = this.props;
        // cache the retrieved options in state in case they have $refs to save doing it later
        const retrievedOptions = options.map((opt)=>schemaUtils.retrieveSchema(opt, formData));
        this.state = {
            retrievedOptions,
            selectedOption: this.getMatchingOption(0, formData, retrievedOptions)
        };
    }
    /** React lifecycle method that is called when the props and/or state for this component is updated. It recomputes the
     * currently selected option based on the overall `formData`
     *
     * @param prevProps - The previous `FieldProps` for this template
     * @param prevState - The previous `AnyOfFieldState` for this template
     */ componentDidUpdate(prevProps, prevState) {
        const { formData, options, idSchema } = this.props;
        const { selectedOption } = this.state;
        let newState = this.state;
        if (!(0, _utils.deepEquals)(prevProps.options, options)) {
            const { registry: { schemaUtils } } = this.props;
            // re-cache the retrieved options in state in case they have $refs to save doing it later
            const retrievedOptions = options.map((opt)=>schemaUtils.retrieveSchema(opt, formData));
            newState = {
                selectedOption,
                retrievedOptions
            };
        }
        if (!(0, _utils.deepEquals)(formData, prevProps.formData) && idSchema.$id === prevProps.idSchema.$id) {
            const { retrievedOptions } = newState;
            const matchingOption = this.getMatchingOption(selectedOption, formData, retrievedOptions);
            if (prevState && matchingOption !== selectedOption) newState = {
                selectedOption: matchingOption,
                retrievedOptions
            };
        }
        if (newState !== this.state) this.setState(newState);
    }
    /** Determines the best matching option for the given `formData` and `options`.
     *
     * @param formData - The new formData
     * @param options - The list of options to choose from
     * @return - The index of the `option` that best matches the `formData`
     */ getMatchingOption(selectedOption, formData, options) {
        const { schema, registry: { schemaUtils } } = this.props;
        const discriminator = (0, _utils.getDiscriminatorFieldFromSchema)(schema);
        const option = schemaUtils.getClosestMatchingOption(formData, options, selectedOption, discriminator);
        return option;
    }
    getFieldId() {
        const { idSchema, schema } = this.props;
        return `${idSchema.$id}${schema.oneOf ? "__oneof_select" : "__anyof_select"}`;
    }
    /** Renders the `AnyOfField` selector along with a `SchemaField` for the value of the `formData`
     */ render() {
        const { name, disabled = false, errorSchema = {}, formContext, onBlur, onFocus, registry, schema, uiSchema } = this.props;
        const { widgets, fields, translateString, globalUiOptions, schemaUtils } = registry;
        const { SchemaField: _SchemaField } = fields;
        const { selectedOption, retrievedOptions } = this.state;
        const { widget = "select", placeholder, autofocus, autocomplete, title = schema.title, ...uiOptions } = (0, _utils.getUiOptions)(uiSchema, globalUiOptions);
        const Widget = (0, _utils.getWidget)({
            type: "number"
        }, widget, widgets);
        const rawErrors = (0, _getDefault.default)(errorSchema, (0, _utils.ERRORS_KEY), []);
        const fieldErrorSchema = (0, _omitDefault.default)(errorSchema, [
            (0, _utils.ERRORS_KEY)
        ]);
        const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
        const option = selectedOption >= 0 ? retrievedOptions[selectedOption] || null : null;
        let optionSchema;
        if (option) {
            // merge top level required field
            const { required } = schema;
            // Merge in all the non-oneOf/anyOf properties and also skip the special ADDITIONAL_PROPERTY_FLAG property
            optionSchema = required ? (0, _utils.mergeSchemas)({
                required
            }, option) : option;
        }
        // First we will check to see if there is an anyOf/oneOf override for the UI schema
        let optionsUiSchema = [];
        if ((0, _utils.ONE_OF_KEY) in schema && uiSchema && (0, _utils.ONE_OF_KEY) in uiSchema) {
            if (Array.isArray(uiSchema[0, _utils.ONE_OF_KEY])) optionsUiSchema = uiSchema[0, _utils.ONE_OF_KEY];
            else console.warn(`uiSchema.oneOf is not an array for "${title || name}"`);
        } else if ((0, _utils.ANY_OF_KEY) in schema && uiSchema && (0, _utils.ANY_OF_KEY) in uiSchema) {
            if (Array.isArray(uiSchema[0, _utils.ANY_OF_KEY])) optionsUiSchema = uiSchema[0, _utils.ANY_OF_KEY];
            else console.warn(`uiSchema.anyOf is not an array for "${title || name}"`);
        }
        // Then we pick the one that matches the selected option index, if one exists otherwise default to the main uiSchema
        let optionUiSchema = uiSchema;
        if (selectedOption >= 0 && optionsUiSchema.length > selectedOption) optionUiSchema = optionsUiSchema[selectedOption];
        const translateEnum = title ? (0, _utils.TranslatableString).TitleOptionPrefix : (0, _utils.TranslatableString).OptionPrefix;
        const translateParams = title ? [
            title
        ] : [];
        const enumOptions = retrievedOptions.map((opt, index)=>{
            // Also see if there is an override title in the uiSchema for each option, otherwise use the title from the option
            const { title: uiTitle = opt.title } = (0, _utils.getUiOptions)(optionsUiSchema[index]);
            return {
                label: uiTitle || translateString(translateEnum, translateParams.concat(String(index + 1))),
                value: index
            };
        });
        return (0, _jsxRuntime.jsxs)("div", {
            className: "panel panel-default panel-body",
            children: [
                (0, _jsxRuntime.jsx)("div", {
                    className: "form-group",
                    children: (0, _jsxRuntime.jsx)(Widget, {
                        id: this.getFieldId(),
                        name: `${name}${schema.oneOf ? "__oneof_select" : "__anyof_select"}`,
                        schema: {
                            type: "number",
                            default: 0
                        },
                        onChange: this.onOptionChange,
                        onBlur: onBlur,
                        onFocus: onFocus,
                        disabled: disabled || (0, _isEmptyDefault.default)(enumOptions),
                        multiple: false,
                        rawErrors: rawErrors,
                        errorSchema: fieldErrorSchema,
                        value: selectedOption >= 0 ? selectedOption : undefined,
                        options: {
                            enumOptions,
                            ...uiOptions
                        },
                        registry: registry,
                        formContext: formContext,
                        placeholder: placeholder,
                        autocomplete: autocomplete,
                        autofocus: autofocus,
                        label: title !== null && title !== void 0 ? title : name,
                        hideLabel: !displayLabel
                    })
                }),
                optionSchema && (0, _jsxRuntime.jsx)(_SchemaField, {
                    ...this.props,
                    schema: optionSchema,
                    uiSchema: optionUiSchema
                })
            ]
        });
    }
}
exports.default = AnyOfField;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","lodash/get":"g5ox6","lodash/isEmpty":"c3uBm","lodash/omit":"ijdpj","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jLWtP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
// Matches a string that ends in a . character, optionally followed by a sequence of
// digits followed by any number of 0 characters up until the end of the line.
// Ensuring that there is at least one prefixed character is important so that
// you don't incorrectly match against "0".
const trailingCharMatcherWithPrefix = /\.([0-9]*0)*$/;
// This is used for trimming the trailing 0 and . characters without affecting
// the rest of the string. Its possible to use one RegEx with groups for this
// functionality, but it is fairly complex compared to simply defining two
// different matchers.
const trailingCharMatcher = /[0.]0*$/;
/**
 * The NumberField class has some special handling for dealing with trailing
 * decimal points and/or zeroes. This logic is designed to allow trailing values
 * to be visible in the input element, but not be represented in the
 * corresponding form data.
 *
 * The algorithm is as follows:
 *
 * 1. When the input value changes the value is cached in the component state
 *
 * 2. The value is then normalized, removing trailing decimal points and zeros,
 *    then passed to the "onChange" callback
 *
 * 3. When the component is rendered, the formData value is checked against the
 *    value cached in the state. If it matches the cached value, the cached
 *    value is passed to the input instead of the formData value
 */ function NumberField(props) {
    const { registry, onChange, formData, value: initialValue } = props;
    const [lastValue, setLastValue] = (0, _react.useState)(initialValue);
    const { StringField } = registry.fields;
    let value = formData;
    /** Handle the change from the `StringField` to properly convert to a number
     *
     * @param value - The current value for the change occurring
     */ const handleChange = (0, _react.useCallback)((value)=>{
        // Cache the original value in component state
        setLastValue(value);
        // Normalize decimals that don't start with a zero character in advance so
        // that the rest of the normalization logic is simpler
        if (`${value}`.charAt(0) === ".") value = `0${value}`;
        // Check that the value is a string (this can happen if the widget used is a
        // <select>, due to an enum declaration etc) then, if the value ends in a
        // trailing decimal point or multiple zeroes, strip the trailing values
        const processed = typeof value === "string" && value.match(trailingCharMatcherWithPrefix) ? (0, _utils.asNumber)(value.replace(trailingCharMatcher, "")) : (0, _utils.asNumber)(value);
        onChange(processed);
    }, [
        onChange
    ]);
    if (typeof lastValue === "string" && typeof value === "number") {
        // Construct a regular expression that checks for a string that consists
        // of the formData value suffixed with zero or one '.' characters and zero
        // or more '0' characters
        const re = new RegExp(`${value}`.replace(".", "\\.") + "\\.?0*$");
        // If the cached "lastValue" is a match, use that instead of the formData
        // value to prevent the input value from changing in the UI
        if (lastValue.match(re)) value = lastValue;
    }
    return (0, _jsxRuntime.jsx)(StringField, {
        ...props,
        formData: value,
        onChange: handleChange
    });
}
exports.default = NumberField;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dROHH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
var _markdownToJsx = require("markdown-to-jsx");
var _markdownToJsxDefault = parcelHelpers.interopDefault(_markdownToJsx);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _has = require("lodash/has");
var _hasDefault = parcelHelpers.interopDefault(_has);
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _set = require("lodash/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _unset = require("lodash/unset");
var _unsetDefault = parcelHelpers.interopDefault(_unset);
/** The `ObjectField` component is used to render a field in the schema that is of type `object`. It tracks whether an
 * additional property key was modified and what it was modified to
 *
 * @param props - The `FieldProps` for this template
 */ class ObjectField extends (0, _react.Component) {
    constructor(){
        super(...arguments);
        /** Set up the initial state */ this.state = {
            wasPropertyKeyModified: false,
            additionalProperties: {}
        };
        /** Returns the `onPropertyChange` handler for the `name` field. Handles the special case where a user is attempting
         * to clear the data for a field added as an additional property. Calls the `onChange()` handler with the updated
         * formData.
         *
         * @param name - The name of the property
         * @param addedByAdditionalProperties - Flag indicating whether this property is an additional property
         * @returns - The onPropertyChange callback for the `name` property
         */ this.onPropertyChange = (name, addedByAdditionalProperties = false)=>{
            return (value, newErrorSchema, id)=>{
                const { formData, onChange, errorSchema } = this.props;
                if (value === undefined && addedByAdditionalProperties) // Don't set value = undefined for fields added by
                // additionalProperties. Doing so removes them from the
                // formData, which causes them to completely disappear
                // (including the input field for the property name). Unlike
                // fields which are "mandated" by the schema, these fields can
                // be set to undefined by clicking a "delete field" button, so
                // set empty values to the empty string.
                value = "";
                const newFormData = {
                    ...formData,
                    [name]: value
                };
                onChange(newFormData, errorSchema && errorSchema && {
                    ...errorSchema,
                    [name]: newErrorSchema
                }, id);
            };
        };
        /** Returns a callback to handle the onDropPropertyClick event for the given `key` which removes the old `key` data
         * and calls the `onChange` callback with it
         *
         * @param key - The key for which the drop callback is desired
         * @returns - The drop property click callback
         */ this.onDropPropertyClick = (key)=>{
            return (event)=>{
                event.preventDefault();
                const { onChange, formData } = this.props;
                const copiedFormData = {
                    ...formData
                };
                (0, _unsetDefault.default)(copiedFormData, key);
                onChange(copiedFormData);
            };
        };
        /** Computes the next available key name from the `preferredKey`, indexing through the already existing keys until one
         * that is already not assigned is found.
         *
         * @param preferredKey - The preferred name of a new key
         * @param [formData] - The form data in which to check if the desired key already exists
         * @returns - The name of the next available key from `preferredKey`
         */ this.getAvailableKey = (preferredKey, formData)=>{
            const { uiSchema, registry } = this.props;
            const { duplicateKeySuffixSeparator = "-" } = (0, _utils.getUiOptions)(uiSchema, registry.globalUiOptions);
            let index = 0;
            let newKey = preferredKey;
            while((0, _hasDefault.default)(formData, newKey))newKey = `${preferredKey}${duplicateKeySuffixSeparator}${++index}`;
            return newKey;
        };
        /** Returns a callback function that deals with the rename of a key for an additional property for a schema. That
         * callback will attempt to rename the key and move the existing data to that key, calling `onChange` when it does.
         *
         * @param oldValue - The old value of a field
         * @returns - The key change callback function
         */ this.onKeyChange = (oldValue)=>{
            return (value, newErrorSchema)=>{
                if (oldValue === value) return;
                const { formData, onChange, errorSchema } = this.props;
                value = this.getAvailableKey(value, formData);
                const newFormData = {
                    ...formData
                };
                const newKeys = {
                    [oldValue]: value
                };
                const keyValues = Object.keys(newFormData).map((key)=>{
                    const newKey = newKeys[key] || key;
                    return {
                        [newKey]: newFormData[key]
                    };
                });
                const renamedObj = Object.assign({}, ...keyValues);
                this.setState({
                    wasPropertyKeyModified: true
                });
                onChange(renamedObj, errorSchema && errorSchema && {
                    ...errorSchema,
                    [value]: newErrorSchema
                });
            };
        };
        /** Handles the adding of a new additional property on the given `schema`. Calls the `onChange` callback once the new
         * default data for that field has been added to the formData.
         *
         * @param schema - The schema element to which the new property is being added
         */ this.handleAddClick = (schema)=>()=>{
                if (!schema.additionalProperties) return;
                const { formData, onChange, registry } = this.props;
                const newFormData = {
                    ...formData
                };
                let type = undefined;
                if ((0, _isObjectDefault.default)(schema.additionalProperties)) {
                    type = schema.additionalProperties.type;
                    let apSchema = schema.additionalProperties;
                    if ((0, _utils.REF_KEY) in apSchema) {
                        const { schemaUtils } = registry;
                        apSchema = schemaUtils.retrieveSchema({
                            $ref: apSchema[0, _utils.REF_KEY]
                        }, formData);
                        type = apSchema.type;
                    }
                    if (!type && ((0, _utils.ANY_OF_KEY) in apSchema || (0, _utils.ONE_OF_KEY) in apSchema)) type = "object";
                }
                const newKey = this.getAvailableKey("newKey", newFormData);
                // Cast this to make the `set` work properly
                (0, _setDefault.default)(newFormData, newKey, this.getDefaultValue(type));
                onChange(newFormData);
            };
    }
    /** Returns a flag indicating whether the `name` field is required in the object schema
     *
     * @param name - The name of the field to check for required-ness
     * @returns - True if the field `name` is required, false otherwise
     */ isRequired(name) {
        const { schema } = this.props;
        return Array.isArray(schema.required) && schema.required.indexOf(name) !== -1;
    }
    /** Returns a default value to be used for a new additional schema property of the given `type`
     *
     * @param type - The type of the new additional schema property
     */ getDefaultValue(type) {
        const { registry: { translateString } } = this.props;
        switch(type){
            case "array":
                return [];
            case "boolean":
                return false;
            case "null":
                return null;
            case "number":
                return 0;
            case "object":
                return {};
            case "string":
            default:
                // We don't have a datatype for some reason (perhaps additionalProperties was true)
                return translateString((0, _utils.TranslatableString).NewStringDefault);
        }
    }
    /** Renders the `ObjectField` from the given props
     */ render() {
        var _a, _b, _c, _d;
        const { schema: rawSchema, uiSchema = {}, formData, errorSchema, idSchema, name, required = false, disabled = false, readonly = false, hideError, idPrefix, idSeparator, onBlur, onFocus, registry, title } = this.props;
        const { fields, formContext, schemaUtils, translateString, globalUiOptions } = registry;
        const { SchemaField } = fields;
        const schema = schemaUtils.retrieveSchema(rawSchema, formData);
        const uiOptions = (0, _utils.getUiOptions)(uiSchema, globalUiOptions);
        const { properties: schemaProperties = {} } = schema;
        const templateTitle = (_c = (_b = (_a = uiOptions.title) !== null && _a !== void 0 ? _a : schema.title) !== null && _b !== void 0 ? _b : title) !== null && _c !== void 0 ? _c : name;
        const description = (_d = uiOptions.description) !== null && _d !== void 0 ? _d : schema.description;
        let orderedProperties;
        try {
            const properties = Object.keys(schemaProperties);
            orderedProperties = (0, _utils.orderProperties)(properties, uiOptions.order);
        } catch (err) {
            return (0, _jsxRuntime.jsxs)("div", {
                children: [
                    (0, _jsxRuntime.jsx)("p", {
                        className: "config-error",
                        style: {
                            color: "red"
                        },
                        children: (0, _jsxRuntime.jsx)((0, _markdownToJsxDefault.default), {
                            children: translateString((0, _utils.TranslatableString).InvalidObjectField, [
                                name || "root",
                                err.message
                            ])
                        })
                    }),
                    (0, _jsxRuntime.jsx)("pre", {
                        children: JSON.stringify(schema)
                    })
                ]
            });
        }
        const Template = (0, _utils.getTemplate)("ObjectFieldTemplate", registry, uiOptions);
        const templateProps = {
            // getDisplayLabel() always returns false for object types, so just check the `uiOptions.label`
            title: uiOptions.label === false ? "" : templateTitle,
            description: uiOptions.label === false ? undefined : description,
            properties: orderedProperties.map((name)=>{
                const addedByAdditionalProperties = (0, _hasDefault.default)(schema, [
                    (0, _utils.PROPERTIES_KEY),
                    name,
                    (0, _utils.ADDITIONAL_PROPERTY_FLAG)
                ]);
                const fieldUiSchema = addedByAdditionalProperties ? uiSchema.additionalProperties : uiSchema[name];
                const hidden = (0, _utils.getUiOptions)(fieldUiSchema).widget === "hidden";
                const fieldIdSchema = (0, _getDefault.default)(idSchema, [
                    name
                ], {});
                return {
                    content: (0, _jsxRuntime.jsx)(SchemaField, {
                        name: name,
                        required: this.isRequired(name),
                        schema: (0, _getDefault.default)(schema, [
                            (0, _utils.PROPERTIES_KEY),
                            name
                        ], {}),
                        uiSchema: fieldUiSchema,
                        errorSchema: (0, _getDefault.default)(errorSchema, name),
                        idSchema: fieldIdSchema,
                        idPrefix: idPrefix,
                        idSeparator: idSeparator,
                        formData: (0, _getDefault.default)(formData, name),
                        formContext: formContext,
                        wasPropertyKeyModified: this.state.wasPropertyKeyModified,
                        onKeyChange: this.onKeyChange(name),
                        onChange: this.onPropertyChange(name, addedByAdditionalProperties),
                        onBlur: onBlur,
                        onFocus: onFocus,
                        registry: registry,
                        disabled: disabled,
                        readonly: readonly,
                        hideError: hideError,
                        onDropPropertyClick: this.onDropPropertyClick
                    }, name),
                    name,
                    readonly,
                    disabled,
                    required,
                    hidden
                };
            }),
            readonly,
            disabled,
            required,
            idSchema,
            uiSchema,
            errorSchema,
            schema,
            formData,
            formContext,
            registry
        };
        return (0, _jsxRuntime.jsx)(Template, {
            ...templateProps,
            onAddClick: this.handleAddClick
        });
    }
}
exports.default = ObjectField;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","markdown-to-jsx":"dhXvF","lodash/get":"g5ox6","lodash/has":"frHYl","lodash/isObject":"kYJe3","lodash/set":"04gxh","lodash/unset":"Oe3tY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dhXvF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(n) {
        var r = n.children, t = n.options, a = function(e, n) {
            if (null == e) return {};
            var r, t, i = {}, a = Object.keys(e);
            for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (i[r] = e[r]);
            return i;
        }(n, i);
        return _react.cloneElement(Ve(r, t), a);
    });
parcelHelpers.export(exports, "RuleType", ()=>r);
parcelHelpers.export(exports, "compiler", ()=>Ve);
var _react = require("react");
function n() {
    return n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, n.apply(this, arguments);
}
var r, t, i = [
    "children",
    "options"
];
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}(r || (r = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}(t || (t = {}));
var a = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(e, n) {
    return e[n.toLowerCase()] = n, e;
}, {
    for: "htmlFor"
}), c = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, o = [
    "style",
    "script"
], l = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, u = /mailto:/i, s = /\n{2,}$/, f = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, d = /^ *> ?/gm, p = /^ {2,}\n/, h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, k = /^(?:\n *)*\n/, v = /\r\n?/g, x = /^\[\^([^\]]+)](:.*)\n/, b = /^\[\^([^\]]+)]/, S = /\f/g, w = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, C = /^\s*?\[(x|\s)\]/, E = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $ = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i, T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, L = /^<!--[\s\S]*?(?:-->)/, z = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, M = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, I = /^\{.*\}$/, R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, U = /^<([^ >]+@[^ >]+)>/, j = /^<([^ >]+:\/[^ >]+)>/, B = /-([a-z])?/gi, N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, _ = /(\[|\])/g, F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, W = /\t/g, G = /^ *\| */, Z = /(^ *\||\| *$)/g, q = / *$/, V = /^ *:-+: *$/, X = /^ *:-+ *$/, Q = /^ *-+: *$/, J = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/, K = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/, Y = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/, ee = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/, ne = /^\\([^0-9A-Za-z\s])/, re = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, te = /^\n+/, ie = /^([ \t]*)/, ae = /\\([^\\])/g, ce = / *\n+$/, oe = /(?:^|\n)( *)$/, le = "(?:\\d+\\.)", ue = "(?:[*+-])";
function se(e) {
    return "( *)(" + (1 === e ? le : ue) + ") +";
}
var fe = se(1), de = se(2);
function pe(e) {
    return new RegExp("^" + (1 === e ? fe : de));
}
var he = pe(1), me = pe(2);
function ge(e) {
    return new RegExp("^" + (1 === e ? fe : de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? le : ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
var ye = ge(1), ke = ge(2);
function ve(e) {
    var n = 1 === e ? le : ue;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
var xe = ve(1), be = ve(2);
function Se(e, n) {
    var r = 1 === n, t = r ? xe : be, i = r ? ye : ke, a = r ? he : me;
    return {
        match: function(e, n, r) {
            var i = oe.exec(r);
            return i && (n.list || !n.inline && !n.simple) ? t.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse: function(e, n, t) {
            var c = r ? +e[2] : void 0, o = e[0].replace(s, "\n").match(i), l = !1;
            return {
                items: o.map(function(e, r) {
                    var i = a.exec(e)[0].length, c = new RegExp("^ {1," + i + "}", "gm"), u = e.replace(c, "").replace(a, ""), s = r === o.length - 1, f = -1 !== u.indexOf("\n\n") || s && l;
                    l = f;
                    var d, p = t.inline, h = t.list;
                    t.list = !0, f ? (t.inline = !1, d = u.replace(ce, "\n\n")) : (t.inline = !0, d = u.replace(ce, ""));
                    var m = n(d, t);
                    return t.inline = p, t.list = h, m;
                }),
                ordered: r,
                start: c
            };
        },
        render: function(n, r, t) {
            return e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, r(n, t));
            }));
        }
    };
}
var we = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, Ce = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, Ee = [
    f,
    m,
    g,
    E,
    A,
    $,
    L,
    N,
    ye,
    xe,
    ke,
    be
], $e = [].concat(Ee, [
    /^[^\n]+(?:  \n|\n{2,})/,
    O,
    M
]);
function Ae(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function Oe(e) {
    return Q.test(e) ? "right" : V.test(e) ? "center" : X.test(e) ? "left" : null;
}
function Te(e, n, r) {
    var t = r.inTable;
    r.inTable = !0;
    var i = n(e.trim(), r);
    r.inTable = t;
    var a = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && a.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace(q, "")), a[a.length - 1].push(e));
    }), a;
}
function Le(e, n, r) {
    r.inline = !0;
    var t = Te(e[1], n, r), i = e[2].replace(Z, "").split("|").map(Oe), a = function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return Te(e, n, r);
        });
    }(e[3], n, r);
    return r.inline = !1, {
        align: i,
        cells: a,
        header: t,
        type: "25"
    };
}
function ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function Me(e) {
    return function(n, r) {
        return r.inline ? e.exec(n) : null;
    };
}
function Ie(e) {
    return function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    };
}
function Re(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function Ue(e) {
    return function(n) {
        return e.exec(n);
    };
}
function je(e, n, r) {
    if (n.inline || n.simple) return null;
    if (r && !r.endsWith("\n")) return null;
    var t = "";
    e.split("\n").every(function(e) {
        return !Ee.some(function(n) {
            return n.test(e);
        }) && (t += e + "\n", e.trim());
    });
    var i = t.trimEnd();
    return "" == i ? null : [
        t,
        i
    ];
}
function Be(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function Ne(e) {
    return e.replace(ae, "$1");
}
function He(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !0, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function De(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !1, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function Pe(e, n, r) {
    return r.inline = !1, e(n, r);
}
var _e = function(e, n, r) {
    return {
        children: He(n, e[1], r)
    };
};
function Fe() {
    return {};
}
function We() {
    return null;
}
function Ge() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function Ze(e, n, r) {
    for(var t = e, i = n.split("."); i.length && void 0 !== (t = t[i[0]]);)i.shift();
    return t || r;
}
function qe(e, n) {
    var r = Ze(n, e);
    return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : Ze(n, e + ".component", e) : e;
}
function Ve(r, t) {
    var i;
    void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.slugify = t.slugify || Ae, t.namedCodesToUnicode = t.namedCodesToUnicode ? n({}, c, t.namedCodesToUnicode) : c;
    var s = t.createElement || _react.createElement;
    function Z(e, r) {
        var i = Ze(t.overrides, e + ".props", {});
        return s.apply(void 0, [
            qe(e, t.overrides),
            n({}, r, i, {
                className: Ge(null == r ? void 0 : r.className, i.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function q(n) {
        n = n.replace(w, "");
        var r = !1;
        t.forceInline ? r = !0 : t.forceBlock || (r = !1 === F.test(n));
        for(var i = le(oe(r ? n : n.trimEnd().replace(te, "") + "\n\n", {
            inline: r
        })); "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === t.wrapper) return i;
        var a, c = t.wrapper || (r ? "span" : "div");
        if (i.length > 1 || t.forceWrapper) a = i;
        else {
            if (1 === i.length) return "string" == typeof (a = i[0]) ? Z("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return _react.createElement(c, {
            key: "outer"
        }, a);
    }
    function V(n) {
        var r = n.match(l);
        return r ? r.reduce(function(n, r, t) {
            var i = r.indexOf("=");
            if (-1 !== i) {
                var c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match(z) && (e = e.replace(B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, i)).trim(), o = function(e) {
                    var n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(i + 1).trim()), l = a[c] || c, u = n[l] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        var r = n.slice(0, n.indexOf(":"));
                        return e[r.replace(/(-[a-z])/g, function(e) {
                            return e[1].toUpperCase();
                        })] = n.slice(r.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? Be(n) : (n.match(I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(c, o);
                "string" == typeof u && (O.test(u) || M.test(u)) && (n[l] = _react.cloneElement(q(u.trim()), {
                    key: t
                }));
            } else "style" !== r && (n[a[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    var X = [], Q = {}, ae = ((i = {})[0] = {
        match: Re(f),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: n(e[0].replace(d, ""), r)
            };
        },
        render: function(e, n, r) {
            return Z("blockquote", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[1] = {
        match: Ue(p),
        order: 1,
        parse: Fe,
        render: function(e, n, r) {
            return Z("br", {
                key: r.key
            });
        }
    }, i[2] = {
        match: Re(h),
        order: 1,
        parse: Fe,
        render: function(e, n, r) {
            return Z("hr", {
                key: r.key
            });
        }
    }, i[3] = {
        match: Re(g),
        order: 0,
        parse: function(e) {
            return {
                lang: void 0,
                text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
            };
        },
        render: function(e, r, t) {
            return Z("pre", {
                key: t.key
            }, Z("code", n({}, e.attrs, {
                className: e.lang ? "lang-" + e.lang : ""
            }), e.text));
        }
    }, i[4] = {
        match: Re(m),
        order: 0,
        parse: function(e) {
            return {
                attrs: V(e[3] || ""),
                lang: e[2] || void 0,
                text: e[4],
                type: "3"
            };
        }
    }, i[5] = {
        match: Ie(y),
        order: 3,
        parse: function(e) {
            return {
                text: e[2]
            };
        },
        render: function(e, n, r) {
            return Z("code", {
                key: r.key
            }, e.text);
        }
    }, i[6] = {
        match: Re(x),
        order: 0,
        parse: function(e) {
            return X.push({
                footnote: e[2],
                identifier: e[1]
            }), {};
        },
        render: We
    }, i[7] = {
        match: Me(b),
        order: 1,
        parse: function(e) {
            return {
                target: "#" + t.slugify(e[1]),
                text: e[1]
            };
        },
        render: function(e, n, r) {
            return Z("a", {
                key: r.key,
                href: Be(e.target)
            }, Z("sup", {
                key: r.key
            }, e.text));
        }
    }, i[8] = {
        match: Me(C),
        order: 1,
        parse: function(e) {
            return {
                completed: "x" === e[1].toLowerCase()
            };
        },
        render: function(e, n, r) {
            return Z("input", {
                checked: e.completed,
                key: r.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, i[9] = {
        match: Re(t.enforceAtxHeadings ? $ : E),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: He(n, e[2], r),
                id: t.slugify(e[2]),
                level: e[1].length
            };
        },
        render: function(e, n, r) {
            return Z("h" + e.level, {
                id: e.id,
                key: r.key
            }, n(e.children, r));
        }
    }, i[10] = {
        match: Re(A),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: He(n, e[1], r),
                level: "=" === e[2] ? 1 : 2,
                type: "9"
            };
        }
    }, i[11] = {
        match: Ue(O),
        order: 1,
        parse: function(e, n, r) {
            var t, i = e[3].match(ie), a = new RegExp("^" + i[1], "gm"), c = e[3].replace(a, ""), l = (t = c, $e.some(function(e) {
                return e.test(t);
            }) ? Pe : He), u = e[1].toLowerCase(), s = -1 !== o.indexOf(u), f = {
                attrs: V(e[2]),
                noInnerParse: s,
                tag: s ? u : e[1]
            };
            return r.inAnchor = r.inAnchor || "a" === u, s ? f.text = e[3] : f.children = l(n, c, r), r.inAnchor = !1, f;
        },
        render: function(e, r, t) {
            return Z(e.tag, n({
                key: t.key
            }, e.attrs), e.text || r(e.children, t));
        }
    }, i[13] = {
        match: Ue(M),
        order: 1,
        parse: function(e) {
            return {
                attrs: V(e[2] || ""),
                tag: e[1]
            };
        },
        render: function(e, r, t) {
            return Z(e.tag, n({}, e.attrs, {
                key: t.key
            }));
        }
    }, i[12] = {
        match: Ue(L),
        order: 1,
        parse: function() {
            return {};
        },
        render: We
    }, i[14] = {
        match: Ie(Ce),
        order: 1,
        parse: function(e) {
            return {
                alt: e[1],
                target: Ne(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return Z("img", {
                key: r.key,
                alt: e.alt || void 0,
                title: e.title || void 0,
                src: Be(e.target)
            });
        }
    }, i[15] = {
        match: Me(we),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: De(n, e[1], r),
                target: Ne(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return Z("a", {
                key: r.key,
                href: Be(e.target),
                title: e.title
            }, n(e.children, r));
        }
    }, i[16] = {
        match: Me(j),
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                type: "15"
            };
        }
    }, i[17] = {
        match: function(e, n) {
            return n.inAnchor ? null : Me(R)(e, n);
        },
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                title: void 0,
                type: "15"
            };
        }
    }, i[18] = {
        match: Me(U),
        order: 0,
        parse: function(e) {
            var n = e[1], r = e[1];
            return u.test(r) || (r = "mailto:" + r), {
                children: [
                    {
                        text: n.replace("mailto:", ""),
                        type: "27"
                    }
                ],
                target: r,
                type: "15"
            };
        }
    }, i[20] = Se(Z, 1), i[33] = Se(Z, 2), i[19] = {
        match: Re(k),
        order: 3,
        parse: Fe,
        render: function() {
            return "\n";
        }
    }, i[21] = {
        match: je,
        order: 3,
        parse: _e,
        render: function(e, n, r) {
            return Z("p", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[22] = {
        match: Me(H),
        order: 0,
        parse: function(e) {
            return Q[e[1]] = {
                target: e[2],
                title: e[4]
            }, {};
        },
        render: We
    }, i[23] = {
        match: Ie(D),
        order: 0,
        parse: function(e) {
            return {
                alt: e[1] || void 0,
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return Z("img", {
                key: r.key,
                alt: e.alt,
                src: Be(Q[e.ref].target),
                title: Q[e.ref].title
            });
        }
    }, i[24] = {
        match: Me(P),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: n(e[1], r),
                fallbackChildren: n(e[0].replace(_, "\\$1"), r),
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return Q[e.ref] ? Z("a", {
                key: r.key,
                href: Be(Q[e.ref].target),
                title: Q[e.ref].title
            }, n(e.children, r)) : Z("span", {
                key: r.key
            }, n(e.fallbackChildren, r));
        }
    }, i[25] = {
        match: Re(N),
        order: 1,
        parse: Le,
        render: function(e, n, r) {
            return Z("table", {
                key: r.key
            }, Z("thead", null, Z("tr", null, e.header.map(function(t, i) {
                return Z("th", {
                    key: i,
                    style: ze(e, i)
                }, n(t, r));
            }))), Z("tbody", null, e.cells.map(function(t, i) {
                return Z("tr", {
                    key: i
                }, t.map(function(t, i) {
                    return Z("td", {
                        key: i,
                        style: ze(e, i)
                    }, n(t, r));
                }));
            })));
        }
    }, i[26] = {
        match: function(e, n) {
            return n.inTable ? (n.inline = !0, G.exec(e)) : null;
        },
        order: 1,
        parse: function() {
            return {
                type: "26"
            };
        },
        render: function() {
            return " | ";
        }
    }, i[27] = {
        match: Ue(re),
        order: 4,
        parse: function(e) {
            return {
                text: e[0].replace(T, function(e, n) {
                    return t.namedCodesToUnicode[n] ? t.namedCodesToUnicode[n] : e;
                })
            };
        },
        render: function(e) {
            return e.text;
        }
    }, i[28] = {
        match: Ie(J),
        order: 2,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return Z("strong", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[29] = {
        match: Ie(K),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return Z("em", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[30] = {
        match: Ie(ne),
        order: 1,
        parse: function(e) {
            return {
                text: e[1],
                type: "27"
            };
        }
    }, i[31] = {
        match: Ie(Y),
        order: 3,
        parse: _e,
        render: function(e, n, r) {
            return Z("mark", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[32] = {
        match: Ie(ee),
        order: 3,
        parse: _e,
        render: function(e, n, r) {
            return Z("del", {
                key: r.key
            }, n(e.children, r));
        }
    }, i);
    !0 === t.disableParsingRawHTML && (delete ae[11], delete ae[13]);
    var ce, oe = function(e) {
        var n = Object.keys(e);
        function r(t, i) {
            for(var a = [], c = ""; t;)for(var o = 0; o < n.length;){
                var l = n[o], u = e[l], s = u.match(t, i, c);
                if (s) {
                    var f = s[0];
                    t = t.substring(f.length);
                    var d = u.parse(s, r, i);
                    null == d.type && (d.type = l), a.push(d), c = f;
                    break;
                }
                o++;
            }
            return a;
        }
        return n.sort(function(n, r) {
            var t = e[n].order, i = e[r].order;
            return t !== i ? t - i : 1;
        }), function(e, n) {
            return r(function(e) {
                return e.replace(v, "\n").replace(S, "").replace(W, "    ");
            }(e), n);
        };
    }(ae), le = (ce = function(e, n) {
        return function(r, t, i) {
            var a = e[r.type].render;
            return n ? n(function() {
                return a(r, t, i);
            }, r, t, i) : a(r, t, i);
        };
    }(ae, t.renderRule), function e(n, r) {
        if (void 0 === r && (r = {}), Array.isArray(n)) {
            for(var t = r.key, i = [], a = !1, c = 0; c < n.length; c++){
                r.key = c;
                var o = e(n[c], r), l = "string" == typeof o;
                l && a ? i[i.length - 1] += o : null !== o && i.push(o), a = l;
            }
            return r.key = t, i;
        }
        return ce(n, e, r);
    }), ue = q(r);
    return X.length ? Z("div", null, ue, Z("footer", {
        key: "footer"
    }, X.map(function(e) {
        return Z("div", {
            id: t.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, le(oe(e.footnote, {
            inline: !0
        })));
    }))) : ue;
}

},{"react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"Oe3tY":[function(require,module,exports) {
var baseUnset = require("f260d72e9d2e6dce");
/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */ function unset(object, path) {
    return object == null ? true : baseUnset(object, path);
}
module.exports = unset;

},{"f260d72e9d2e6dce":"hHMYq"}],"lVvmU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
var _isObject = require("lodash/isObject");
var _isObjectDefault = parcelHelpers.interopDefault(_isObject);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _markdownToJsx = require("markdown-to-jsx");
var _markdownToJsxDefault = parcelHelpers.interopDefault(_markdownToJsx);
/** The map of component type to FieldName */ const COMPONENT_TYPES = {
    array: "ArrayField",
    boolean: "BooleanField",
    integer: "NumberField",
    number: "NumberField",
    object: "ObjectField",
    string: "StringField",
    null: "NullField"
};
/** Computes and returns which `Field` implementation to return in order to render the field represented by the
 * `schema`. The `uiOptions` are used to alter what potential `Field` implementation is actually returned. If no
 * appropriate `Field` implementation can be found then a wrapper around `UnsupportedFieldTemplate` is used.
 *
 * @param schema - The schema from which to obtain the type
 * @param uiOptions - The UI Options that may affect the component decision
 * @param idSchema - The id that is passed to the `UnsupportedFieldTemplate`
 * @param registry - The registry from which fields and templates are obtained
 * @returns - The `Field` component that is used to render the actual field data
 */ function getFieldComponent(schema, uiOptions, idSchema, registry) {
    const field = uiOptions.field;
    const { fields, translateString } = registry;
    if (typeof field === "function") return field;
    if (typeof field === "string" && field in fields) return fields[field];
    const schemaType = (0, _utils.getSchemaType)(schema);
    const type = Array.isArray(schemaType) ? schemaType[0] : schemaType || "";
    const schemaId = schema.$id;
    let componentName = COMPONENT_TYPES[type];
    if (schemaId && schemaId in fields) componentName = schemaId;
    // If the type is not defined and the schema uses 'anyOf' or 'oneOf', don't
    // render a field and let the MultiSchemaField component handle the form display
    if (!componentName && (schema.anyOf || schema.oneOf)) return ()=>null;
    return componentName in fields ? fields[componentName] : ()=>{
        const UnsupportedFieldTemplate = (0, _utils.getTemplate)("UnsupportedFieldTemplate", registry, uiOptions);
        return (0, _jsxRuntime.jsx)(UnsupportedFieldTemplate, {
            schema: schema,
            idSchema: idSchema,
            reason: translateString((0, _utils.TranslatableString).UnknownFieldType, [
                String(schema.type)
            ]),
            registry: registry
        });
    };
}
/** The `SchemaFieldRender` component is the work-horse of react-jsonschema-form, determining what kind of real field to
 * render based on the `schema`, `uiSchema` and all the other props. It also deals with rendering the `anyOf` and
 * `oneOf` fields.
 *
 * @param props - The `FieldProps` for this component
 */ function SchemaFieldRender(props) {
    const { schema: _schema, idSchema: _idSchema, uiSchema, formData, errorSchema, idPrefix, idSeparator, name, onChange, onKeyChange, onDropPropertyClick, required, registry, wasPropertyKeyModified = false } = props;
    const { formContext, schemaUtils, globalUiOptions } = registry;
    const uiOptions = (0, _utils.getUiOptions)(uiSchema, globalUiOptions);
    const FieldTemplate = (0, _utils.getTemplate)("FieldTemplate", registry, uiOptions);
    const DescriptionFieldTemplate = (0, _utils.getTemplate)("DescriptionFieldTemplate", registry, uiOptions);
    const FieldHelpTemplate = (0, _utils.getTemplate)("FieldHelpTemplate", registry, uiOptions);
    const FieldErrorTemplate = (0, _utils.getTemplate)("FieldErrorTemplate", registry, uiOptions);
    const schema = schemaUtils.retrieveSchema(_schema, formData);
    const fieldId = _idSchema[0, _utils.ID_KEY];
    const idSchema = (0, _utils.mergeObjects)(schemaUtils.toIdSchema(schema, fieldId, formData, idPrefix, idSeparator), _idSchema);
    /** Intermediary `onChange` handler for field components that will inject the `id` of the current field into the
     * `onChange` chain if it is not already being provided from a deeper level in the hierarchy
     */ const handleFieldComponentChange = (0, _react.useCallback)((formData, newErrorSchema, id)=>{
        const theId = id || fieldId;
        return onChange(formData, newErrorSchema, theId);
    }, [
        fieldId,
        onChange
    ]);
    const FieldComponent = getFieldComponent(schema, uiOptions, idSchema, registry);
    const disabled = Boolean(props.disabled || uiOptions.disabled);
    const readonly = Boolean(props.readonly || uiOptions.readonly || props.schema.readOnly || schema.readOnly);
    const uiSchemaHideError = uiOptions.hideError;
    // Set hideError to the value provided in the uiSchema, otherwise stick with the prop to propagate to children
    const hideError = uiSchemaHideError === undefined ? props.hideError : Boolean(uiSchemaHideError);
    const autofocus = Boolean(props.autofocus || uiOptions.autofocus);
    if (Object.keys(schema).length === 0) return null;
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    const { __errors, ...fieldErrorSchema } = errorSchema || {};
    // See #439: uiSchema: Don't pass consumed class names or style to child components
    const fieldUiSchema = (0, _omitDefault.default)(uiSchema, [
        "ui:classNames",
        "classNames",
        "ui:style"
    ]);
    if ((0, _utils.UI_OPTIONS_KEY) in fieldUiSchema) fieldUiSchema[0, _utils.UI_OPTIONS_KEY] = (0, _omitDefault.default)(fieldUiSchema[0, _utils.UI_OPTIONS_KEY], [
        "classNames",
        "style"
    ]);
    const field = (0, _jsxRuntime.jsx)(FieldComponent, {
        ...props,
        onChange: handleFieldComponentChange,
        idSchema: idSchema,
        schema: schema,
        uiSchema: fieldUiSchema,
        disabled: disabled,
        readonly: readonly,
        hideError: hideError,
        autofocus: autofocus,
        errorSchema: fieldErrorSchema,
        formContext: formContext,
        rawErrors: __errors
    });
    const id = idSchema[0, _utils.ID_KEY];
    // If this schema has a title defined, but the user has set a new key/label, retain their input.
    let label;
    if (wasPropertyKeyModified) label = name;
    else label = (0, _utils.ADDITIONAL_PROPERTY_FLAG) in schema ? name : uiOptions.title || props.schema.title || schema.title || props.title || name;
    const description = uiOptions.description || props.schema.description || schema.description || "";
    const richDescription = uiOptions.enableMarkdownInDescription ? (0, _jsxRuntime.jsx)((0, _markdownToJsxDefault.default), {
        children: description
    }) : description;
    const help = uiOptions.help;
    const hidden = uiOptions.widget === "hidden";
    const classNames = [
        "form-group",
        "field",
        `field-${(0, _utils.getSchemaType)(schema)}`
    ];
    if (!hideError && __errors && __errors.length > 0) classNames.push("field-error has-error has-danger");
    if (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema.classNames) classNames.push(uiSchema.classNames);
    if (uiOptions.classNames) classNames.push(uiOptions.classNames);
    const helpComponent = (0, _jsxRuntime.jsx)(FieldHelpTemplate, {
        help: help,
        idSchema: idSchema,
        schema: schema,
        uiSchema: uiSchema,
        hasErrors: !hideError && __errors && __errors.length > 0,
        registry: registry
    });
    /*
     * AnyOf/OneOf errors handled by child schema
     * unless it can be rendered as select control
     */ const errorsComponent = hideError || (schema.anyOf || schema.oneOf) && !schemaUtils.isSelect(schema) ? undefined : (0, _jsxRuntime.jsx)(FieldErrorTemplate, {
        errors: __errors,
        errorSchema: errorSchema,
        idSchema: idSchema,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry
    });
    const fieldProps = {
        description: (0, _jsxRuntime.jsx)(DescriptionFieldTemplate, {
            id: (0, _utils.descriptionId)(id),
            description: richDescription,
            schema: schema,
            uiSchema: uiSchema,
            registry: registry
        }),
        rawDescription: description,
        help: helpComponent,
        rawHelp: typeof help === "string" ? help : undefined,
        errors: errorsComponent,
        rawErrors: hideError ? undefined : __errors,
        id,
        label,
        hidden,
        onChange,
        onKeyChange,
        onDropPropertyClick,
        required,
        disabled,
        readonly,
        hideError,
        displayLabel,
        classNames: classNames.join(" ").trim(),
        style: uiOptions.style,
        formContext,
        formData,
        schema,
        uiSchema,
        registry
    };
    const _AnyOfField = registry.fields.AnyOfField;
    const _OneOfField = registry.fields.OneOfField;
    const isReplacingAnyOrOneOf = (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema["ui:field"]) && (uiSchema === null || uiSchema === void 0 ? void 0 : uiSchema["ui:fieldReplacesAnyOrOneOf"]) === true;
    return (0, _jsxRuntime.jsx)(FieldTemplate, {
        ...fieldProps,
        children: (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                field,
                schema.anyOf && !isReplacingAnyOrOneOf && !schemaUtils.isSelect(schema) && (0, _jsxRuntime.jsx)(_AnyOfField, {
                    name: name,
                    disabled: disabled,
                    readonly: readonly,
                    hideError: hideError,
                    errorSchema: errorSchema,
                    formData: formData,
                    formContext: formContext,
                    idPrefix: idPrefix,
                    idSchema: idSchema,
                    idSeparator: idSeparator,
                    onBlur: props.onBlur,
                    onChange: props.onChange,
                    onFocus: props.onFocus,
                    options: schema.anyOf.map((_schema)=>schemaUtils.retrieveSchema((0, _isObjectDefault.default)(_schema) ? _schema : {}, formData)),
                    registry: registry,
                    schema: schema,
                    uiSchema: uiSchema
                }),
                schema.oneOf && !isReplacingAnyOrOneOf && !schemaUtils.isSelect(schema) && (0, _jsxRuntime.jsx)(_OneOfField, {
                    name: name,
                    disabled: disabled,
                    readonly: readonly,
                    hideError: hideError,
                    errorSchema: errorSchema,
                    formData: formData,
                    formContext: formContext,
                    idPrefix: idPrefix,
                    idSchema: idSchema,
                    idSeparator: idSeparator,
                    onBlur: props.onBlur,
                    onChange: props.onChange,
                    onFocus: props.onFocus,
                    options: schema.oneOf.map((_schema)=>schemaUtils.retrieveSchema((0, _isObjectDefault.default)(_schema) ? _schema : {}, formData)),
                    registry: registry,
                    schema: schema,
                    uiSchema: uiSchema
                })
            ]
        })
    });
}
/** The `SchemaField` component determines whether it is necessary to rerender the component based on any props changes
 * and if so, calls the `SchemaFieldRender` component with the props.
 */ class SchemaField extends (0, _react.Component) {
    shouldComponentUpdate(nextProps) {
        return !(0, _utils.deepEquals)(this.props, nextProps);
    }
    render() {
        return (0, _jsxRuntime.jsx)(SchemaFieldRender, {
            ...this.props
        });
    }
}
exports.default = SchemaField;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","lodash/isObject":"kYJe3","lodash/omit":"ijdpj","markdown-to-jsx":"dhXvF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kXBLr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
/** The `StringField` component is used to render a schema field that represents a string type
 *
 * @param props - The `FieldProps` for this template
 */ function StringField(props) {
    var _a;
    const { schema, name, uiSchema, idSchema, formData, required, disabled = false, readonly = false, autofocus = false, onChange, onBlur, onFocus, registry, rawErrors, hideError } = props;
    const { title, format } = schema;
    const { widgets, formContext, schemaUtils, globalUiOptions } = registry;
    const enumOptions = schemaUtils.isSelect(schema) ? (0, _utils.optionsList)(schema) : undefined;
    let defaultWidget = enumOptions ? "select" : "text";
    if (format && (0, _utils.hasWidget)(schema, format, widgets)) defaultWidget = format;
    const { widget = defaultWidget, placeholder = "", title: uiTitle, ...options } = (0, _utils.getUiOptions)(uiSchema);
    const displayLabel = schemaUtils.getDisplayLabel(schema, uiSchema, globalUiOptions);
    const label = (_a = uiTitle !== null && uiTitle !== void 0 ? uiTitle : title) !== null && _a !== void 0 ? _a : name;
    const Widget = (0, _utils.getWidget)(schema, widget, widgets);
    return (0, _jsxRuntime.jsx)(Widget, {
        options: {
            ...options,
            enumOptions
        },
        schema: schema,
        uiSchema: uiSchema,
        id: idSchema.$id,
        name: name,
        label: label,
        hideLabel: !displayLabel,
        hideError: hideError,
        value: formData,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        required: required,
        disabled: disabled,
        readonly: readonly,
        formContext: formContext,
        autofocus: autofocus,
        registry: registry,
        placeholder: placeholder,
        rawErrors: rawErrors
    });
}
exports.default = StringField;

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8G7v0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/** The `NullField` component is used to render a field in the schema is null. It also ensures that the `formData` is
 * also set to null if it has no value.
 *
 * @param props - The `FieldProps` for this template
 */ function NullField(props) {
    const { formData, onChange } = props;
    (0, _react.useEffect)(()=>{
        if (formData === undefined) onChange(null);
    }, [
        formData,
        onChange
    ]);
    return null;
}
exports.default = NullField;

},{"react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3Ts0H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayFieldDescriptionTemplate = require("./ArrayFieldDescriptionTemplate");
var _arrayFieldDescriptionTemplateDefault = parcelHelpers.interopDefault(_arrayFieldDescriptionTemplate);
var _arrayFieldItemTemplate = require("./ArrayFieldItemTemplate");
var _arrayFieldItemTemplateDefault = parcelHelpers.interopDefault(_arrayFieldItemTemplate);
var _arrayFieldTemplate = require("./ArrayFieldTemplate");
var _arrayFieldTemplateDefault = parcelHelpers.interopDefault(_arrayFieldTemplate);
var _arrayFieldTitleTemplate = require("./ArrayFieldTitleTemplate");
var _arrayFieldTitleTemplateDefault = parcelHelpers.interopDefault(_arrayFieldTitleTemplate);
var _baseInputTemplate = require("./BaseInputTemplate");
var _baseInputTemplateDefault = parcelHelpers.interopDefault(_baseInputTemplate);
var _buttonTemplates = require("./ButtonTemplates");
var _buttonTemplatesDefault = parcelHelpers.interopDefault(_buttonTemplates);
var _descriptionField = require("./DescriptionField");
var _descriptionFieldDefault = parcelHelpers.interopDefault(_descriptionField);
var _errorList = require("./ErrorList");
var _errorListDefault = parcelHelpers.interopDefault(_errorList);
var _fieldTemplate = require("./FieldTemplate");
var _fieldTemplateDefault = parcelHelpers.interopDefault(_fieldTemplate);
var _fieldErrorTemplate = require("./FieldErrorTemplate");
var _fieldErrorTemplateDefault = parcelHelpers.interopDefault(_fieldErrorTemplate);
var _fieldHelpTemplate = require("./FieldHelpTemplate");
var _fieldHelpTemplateDefault = parcelHelpers.interopDefault(_fieldHelpTemplate);
var _objectFieldTemplate = require("./ObjectFieldTemplate");
var _objectFieldTemplateDefault = parcelHelpers.interopDefault(_objectFieldTemplate);
var _titleField = require("./TitleField");
var _titleFieldDefault = parcelHelpers.interopDefault(_titleField);
var _unsupportedField = require("./UnsupportedField");
var _unsupportedFieldDefault = parcelHelpers.interopDefault(_unsupportedField);
var _wrapIfAdditionalTemplate = require("./WrapIfAdditionalTemplate");
var _wrapIfAdditionalTemplateDefault = parcelHelpers.interopDefault(_wrapIfAdditionalTemplate);
function templates() {
    return {
        ArrayFieldDescriptionTemplate: (0, _arrayFieldDescriptionTemplateDefault.default),
        ArrayFieldItemTemplate: (0, _arrayFieldItemTemplateDefault.default),
        ArrayFieldTemplate: (0, _arrayFieldTemplateDefault.default),
        ArrayFieldTitleTemplate: (0, _arrayFieldTitleTemplateDefault.default),
        ButtonTemplates: (0, _buttonTemplatesDefault.default)(),
        BaseInputTemplate: (0, _baseInputTemplateDefault.default),
        DescriptionFieldTemplate: (0, _descriptionFieldDefault.default),
        ErrorListTemplate: (0, _errorListDefault.default),
        FieldTemplate: (0, _fieldTemplateDefault.default),
        FieldErrorTemplate: (0, _fieldErrorTemplateDefault.default),
        FieldHelpTemplate: (0, _fieldHelpTemplateDefault.default),
        ObjectFieldTemplate: (0, _objectFieldTemplateDefault.default),
        TitleFieldTemplate: (0, _titleFieldDefault.default),
        UnsupportedFieldTemplate: (0, _unsupportedFieldDefault.default),
        WrapIfAdditionalTemplate: (0, _wrapIfAdditionalTemplateDefault.default)
    };
}
exports.default = templates;

},{"./ArrayFieldDescriptionTemplate":"kM9Wb","./ArrayFieldItemTemplate":"Fy0qu","./ArrayFieldTemplate":"iwpq8","./ArrayFieldTitleTemplate":"ewv5N","./BaseInputTemplate":"5sq7u","./ButtonTemplates":"kydKB","./DescriptionField":"9oy8b","./ErrorList":"8klK3","./FieldTemplate":"cZzTo","./FieldErrorTemplate":"gUkw2","./FieldHelpTemplate":"2YJ96","./ObjectFieldTemplate":"gW8If","./TitleField":"fScEX","./UnsupportedField":"8sTWU","./WrapIfAdditionalTemplate":"cuUcV","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kM9Wb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ArrayFieldDescriptionTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function ArrayFieldDescriptionTemplate(props) {
    const { idSchema, description, registry, schema, uiSchema } = props;
    const options = (0, _utils.getUiOptions)(uiSchema, registry.globalUiOptions);
    const { label: displayLabel = true } = options;
    if (!description || !displayLabel) return null;
    const DescriptionFieldTemplate = (0, _utils.getTemplate)("DescriptionFieldTemplate", registry, options);
    return (0, _jsxRuntime.jsx)(DescriptionFieldTemplate, {
        id: (0, _utils.descriptionId)(idSchema),
        description: description,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"Fy0qu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ArrayFieldItemTemplate);
var _jsxRuntime = require("react/jsx-runtime");
function ArrayFieldItemTemplate(props) {
    const { children, className, disabled, hasToolbar, hasMoveDown, hasMoveUp, hasRemove, hasCopy, index, onCopyIndexClick, onDropIndexClick, onReorderClick, readonly, registry, uiSchema } = props;
    const { CopyButton, MoveDownButton, MoveUpButton, RemoveButton } = registry.templates.ButtonTemplates;
    const btnStyle = {
        flex: 1,
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: "bold"
    };
    return (0, _jsxRuntime.jsxs)("div", {
        className: className,
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: hasToolbar ? "col-xs-9" : "col-xs-12",
                children: children
            }),
            hasToolbar && (0, _jsxRuntime.jsx)("div", {
                className: "col-xs-3 array-item-toolbox",
                children: (0, _jsxRuntime.jsxs)("div", {
                    className: "btn-group",
                    style: {
                        display: "flex",
                        justifyContent: "space-around"
                    },
                    children: [
                        (hasMoveUp || hasMoveDown) && (0, _jsxRuntime.jsx)(MoveUpButton, {
                            style: btnStyle,
                            disabled: disabled || readonly || !hasMoveUp,
                            onClick: onReorderClick(index, index - 1),
                            uiSchema: uiSchema,
                            registry: registry
                        }),
                        (hasMoveUp || hasMoveDown) && (0, _jsxRuntime.jsx)(MoveDownButton, {
                            style: btnStyle,
                            disabled: disabled || readonly || !hasMoveDown,
                            onClick: onReorderClick(index, index + 1),
                            uiSchema: uiSchema,
                            registry: registry
                        }),
                        hasCopy && (0, _jsxRuntime.jsx)(CopyButton, {
                            style: btnStyle,
                            disabled: disabled || readonly,
                            onClick: onCopyIndexClick(index),
                            uiSchema: uiSchema,
                            registry: registry
                        }),
                        hasRemove && (0, _jsxRuntime.jsx)(RemoveButton, {
                            style: btnStyle,
                            disabled: disabled || readonly,
                            onClick: onDropIndexClick(index),
                            uiSchema: uiSchema,
                            registry: registry
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gHQIF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iwpq8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ArrayFieldTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function ArrayFieldTemplate(props) {
    const { canAdd, className, disabled, idSchema, uiSchema, items, onAddClick, readonly, registry, required, schema, title } = props;
    const uiOptions = (0, _utils.getUiOptions)(uiSchema);
    const ArrayFieldDescriptionTemplate = (0, _utils.getTemplate)("ArrayFieldDescriptionTemplate", registry, uiOptions);
    const ArrayFieldItemTemplate = (0, _utils.getTemplate)("ArrayFieldItemTemplate", registry, uiOptions);
    const ArrayFieldTitleTemplate = (0, _utils.getTemplate)("ArrayFieldTitleTemplate", registry, uiOptions);
    // Button templates are not overridden in the uiSchema
    const { ButtonTemplates: { AddButton } } = registry.templates;
    return (0, _jsxRuntime.jsxs)("fieldset", {
        className: className,
        id: idSchema.$id,
        children: [
            (0, _jsxRuntime.jsx)(ArrayFieldTitleTemplate, {
                idSchema: idSchema,
                title: uiOptions.title || title,
                required: required,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            (0, _jsxRuntime.jsx)(ArrayFieldDescriptionTemplate, {
                idSchema: idSchema,
                description: uiOptions.description || schema.description,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            (0, _jsxRuntime.jsx)("div", {
                className: "row array-item-list",
                children: items && items.map(({ key, ...itemProps })=>(0, _jsxRuntime.jsx)(ArrayFieldItemTemplate, {
                        ...itemProps
                    }, key))
            }),
            canAdd && (0, _jsxRuntime.jsx)(AddButton, {
                className: "array-item-add",
                onClick: onAddClick,
                disabled: disabled || readonly,
                uiSchema: uiSchema,
                registry: registry
            })
        ]
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ewv5N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ArrayFieldTitleTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function ArrayFieldTitleTemplate(props) {
    const { idSchema, title, schema, uiSchema, required, registry } = props;
    const options = (0, _utils.getUiOptions)(uiSchema, registry.globalUiOptions);
    const { label: displayLabel = true } = options;
    if (!title || !displayLabel) return null;
    const TitleFieldTemplate = (0, _utils.getTemplate)("TitleFieldTemplate", registry, options);
    return (0, _jsxRuntime.jsx)(TitleFieldTemplate, {
        id: (0, _utils.titleId)(idSchema),
        title: title,
        required: required,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5sq7u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BaseInputTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
function BaseInputTemplate(props) {
    const { id, name, value, readonly, disabled, autofocus, onBlur, onFocus, onChange, onChangeOverride, options, schema, uiSchema, formContext, registry, rawErrors, type, hideLabel, hideError, ...rest } = props;
    // Note: since React 15.2.0 we can't forward unknown element attributes, so we
    // exclude the "options" and "schema" ones here.
    if (!id) {
        console.log("No id for", props);
        throw new Error(`no id for props ${JSON.stringify(props)}`);
    }
    const inputProps = {
        ...rest,
        ...(0, _utils.getInputProps)(schema, type, options)
    };
    let inputValue;
    if (inputProps.type === "number" || inputProps.type === "integer") inputValue = value || value === 0 ? value : "";
    else inputValue = value == null ? "" : value;
    const _onChange = (0, _react.useCallback)(({ target: { value } })=>onChange(value === "" ? options.emptyValue : value), [
        onChange,
        options
    ]);
    const _onBlur = (0, _react.useCallback)(({ target: { value } })=>onBlur(id, value), [
        onBlur,
        id
    ]);
    const _onFocus = (0, _react.useCallback)(({ target: { value } })=>onFocus(id, value), [
        onFocus,
        id
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)("input", {
                id: id,
                name: id,
                className: "form-control",
                readOnly: readonly,
                disabled: disabled,
                autoFocus: autofocus,
                value: inputValue,
                ...inputProps,
                list: schema.examples ? (0, _utils.examplesId)(id) : undefined,
                onChange: onChangeOverride || _onChange,
                onBlur: _onBlur,
                onFocus: _onFocus,
                "aria-describedby": (0, _utils.ariaDescribedByIds)(id, !!schema.examples)
            }),
            Array.isArray(schema.examples) && (0, _jsxRuntime.jsx)("datalist", {
                id: (0, _utils.examplesId)(id),
                children: schema.examples.concat(schema.default && !schema.examples.includes(schema.default) ? [
                    schema.default
                ] : []).map((example)=>{
                    return (0, _jsxRuntime.jsx)("option", {
                        value: example
                    }, example);
                })
            }, `datalist_${id}`)
        ]
    });
}

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kydKB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _submitButton = require("./SubmitButton");
var _submitButtonDefault = parcelHelpers.interopDefault(_submitButton);
var _addButton = require("./AddButton");
var _addButtonDefault = parcelHelpers.interopDefault(_addButton);
var _iconButton = require("./IconButton");
function buttonTemplates() {
    return {
        SubmitButton: (0, _submitButtonDefault.default),
        AddButton: (0, _addButtonDefault.default),
        CopyButton: (0, _iconButton.CopyButton),
        MoveDownButton: (0, _iconButton.MoveDownButton),
        MoveUpButton: (0, _iconButton.MoveUpButton),
        RemoveButton: (0, _iconButton.RemoveButton)
    };
}
exports.default = buttonTemplates;

},{"./SubmitButton":"1NxGL","./AddButton":"02hIC","./IconButton":"8QYlL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1NxGL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubmitButton);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function SubmitButton({ uiSchema }) {
    const { submitText, norender, props: submitButtonProps = {} } = (0, _utils.getSubmitButtonOptions)(uiSchema);
    if (norender) return null;
    return (0, _jsxRuntime.jsx)("div", {
        children: (0, _jsxRuntime.jsx)("button", {
            type: "submit",
            ...submitButtonProps,
            className: `btn btn-info ${submitButtonProps.className || ""}`,
            children: submitText
        })
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"02hIC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddButton);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
var _iconButton = require("./IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
function AddButton({ className, onClick, disabled, registry }) {
    const { translateString } = registry;
    return (0, _jsxRuntime.jsx)("div", {
        className: "row",
        children: (0, _jsxRuntime.jsx)("p", {
            className: `col-xs-3 col-xs-offset-9 text-right ${className}`,
            children: (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                iconType: "info",
                icon: "plus",
                className: "btn-add col-xs-12",
                title: translateString((0, _utils.TranslatableString).AddButton),
                onClick: onClick,
                disabled: disabled,
                registry: registry
            })
        })
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","./IconButton":"8QYlL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8QYlL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IconButton);
parcelHelpers.export(exports, "CopyButton", ()=>CopyButton);
parcelHelpers.export(exports, "MoveDownButton", ()=>MoveDownButton);
parcelHelpers.export(exports, "MoveUpButton", ()=>MoveUpButton);
parcelHelpers.export(exports, "RemoveButton", ()=>RemoveButton);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function IconButton(props) {
    const { iconType = "default", icon, className, uiSchema, registry, ...otherProps } = props;
    return (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: `btn btn-${iconType} ${className}`,
        ...otherProps,
        children: (0, _jsxRuntime.jsx)("i", {
            className: `glyphicon glyphicon-${icon}`
        })
    });
}
function CopyButton(props) {
    const { registry: { translateString } } = props;
    return (0, _jsxRuntime.jsx)(IconButton, {
        title: translateString((0, _utils.TranslatableString).CopyButton),
        className: "array-item-copy",
        ...props,
        icon: "copy"
    });
}
function MoveDownButton(props) {
    const { registry: { translateString } } = props;
    return (0, _jsxRuntime.jsx)(IconButton, {
        title: translateString((0, _utils.TranslatableString).MoveDownButton),
        className: "array-item-move-down",
        ...props,
        icon: "arrow-down"
    });
}
function MoveUpButton(props) {
    const { registry: { translateString } } = props;
    return (0, _jsxRuntime.jsx)(IconButton, {
        title: translateString((0, _utils.TranslatableString).MoveUpButton),
        className: "array-item-move-up",
        ...props,
        icon: "arrow-up"
    });
}
function RemoveButton(props) {
    const { registry: { translateString } } = props;
    return (0, _jsxRuntime.jsx)(IconButton, {
        title: translateString((0, _utils.TranslatableString).RemoveButton),
        className: "array-item-remove",
        ...props,
        iconType: "danger",
        icon: "remove"
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9oy8b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DescriptionField);
var _jsxRuntime = require("react/jsx-runtime");
function DescriptionField(props) {
    const { id, description } = props;
    if (!description) return null;
    if (typeof description === "string") return (0, _jsxRuntime.jsx)("p", {
        id: id,
        className: "field-description",
        children: description
    });
    else return (0, _jsxRuntime.jsx)("div", {
        id: id,
        className: "field-description",
        children: description
    });
}

},{"react/jsx-runtime":"gHQIF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8klK3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ErrorList);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function ErrorList({ errors, registry }) {
    const { translateString } = registry;
    return (0, _jsxRuntime.jsxs)("div", {
        className: "panel panel-danger errors",
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: "panel-heading",
                children: (0, _jsxRuntime.jsx)("h3", {
                    className: "panel-title",
                    children: translateString((0, _utils.TranslatableString).ErrorsLabel)
                })
            }),
            (0, _jsxRuntime.jsx)("ul", {
                className: "list-group",
                children: errors.map((error, i)=>{
                    return (0, _jsxRuntime.jsx)("li", {
                        className: "list-group-item text-danger",
                        children: error.stack
                    }, i);
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cZzTo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fieldTemplate = require("./FieldTemplate");
var _fieldTemplateDefault = parcelHelpers.interopDefault(_fieldTemplate);
exports.default = (0, _fieldTemplateDefault.default);

},{"./FieldTemplate":"2FwbV","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2FwbV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FieldTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
var _label = require("./Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
function FieldTemplate(props) {
    const { id, label, children, errors, help, description, hidden, required, displayLabel, registry, uiSchema } = props;
    const uiOptions = (0, _utils.getUiOptions)(uiSchema);
    const WrapIfAdditionalTemplate = (0, _utils.getTemplate)("WrapIfAdditionalTemplate", registry, uiOptions);
    if (hidden) return (0, _jsxRuntime.jsx)("div", {
        className: "hidden",
        children: children
    });
    return (0, _jsxRuntime.jsxs)(WrapIfAdditionalTemplate, {
        ...props,
        children: [
            displayLabel && (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
                label: label,
                required: required,
                id: id
            }),
            displayLabel && description ? description : null,
            children,
            errors,
            help
        ]
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","./Label":"jtRsY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jtRsY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Label);
var _jsxRuntime = require("react/jsx-runtime");
const REQUIRED_FIELD_SYMBOL = "*";
function Label(props) {
    const { label, required, id } = props;
    if (!label) return null;
    return (0, _jsxRuntime.jsxs)("label", {
        className: "control-label",
        htmlFor: id,
        children: [
            label,
            required && (0, _jsxRuntime.jsx)("span", {
                className: "required",
                children: REQUIRED_FIELD_SYMBOL
            })
        ]
    });
}

},{"react/jsx-runtime":"gHQIF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gUkw2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FieldErrorTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function FieldErrorTemplate(props) {
    const { errors = [], idSchema } = props;
    if (errors.length === 0) return null;
    const id = (0, _utils.errorId)(idSchema);
    return (0, _jsxRuntime.jsx)("div", {
        children: (0, _jsxRuntime.jsx)("ul", {
            id: id,
            className: "error-detail bs-callout bs-callout-info",
            children: errors.filter((elem)=>!!elem).map((error, index)=>{
                return (0, _jsxRuntime.jsx)("li", {
                    className: "text-danger",
                    children: error
                }, index);
            })
        })
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2YJ96":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FieldHelpTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function FieldHelpTemplate(props) {
    const { idSchema, help } = props;
    if (!help) return null;
    const id = (0, _utils.helpId)(idSchema);
    if (typeof help === "string") return (0, _jsxRuntime.jsx)("p", {
        id: id,
        className: "help-block",
        children: help
    });
    return (0, _jsxRuntime.jsx)("div", {
        id: id,
        className: "help-block",
        children: help
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gW8If":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ObjectFieldTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function ObjectFieldTemplate(props) {
    const { description, disabled, formData, idSchema, onAddClick, properties, readonly, registry, required, schema, title, uiSchema } = props;
    const options = (0, _utils.getUiOptions)(uiSchema);
    const TitleFieldTemplate = (0, _utils.getTemplate)("TitleFieldTemplate", registry, options);
    const DescriptionFieldTemplate = (0, _utils.getTemplate)("DescriptionFieldTemplate", registry, options);
    // Button templates are not overridden in the uiSchema
    const { ButtonTemplates: { AddButton } } = registry.templates;
    return (0, _jsxRuntime.jsxs)("fieldset", {
        id: idSchema.$id,
        children: [
            title && (0, _jsxRuntime.jsx)(TitleFieldTemplate, {
                id: (0, _utils.titleId)(idSchema),
                title: title,
                required: required,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            description && (0, _jsxRuntime.jsx)(DescriptionFieldTemplate, {
                id: (0, _utils.descriptionId)(idSchema),
                description: description,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            properties.map((prop)=>prop.content),
            (0, _utils.canExpand)(schema, uiSchema, formData) && (0, _jsxRuntime.jsx)(AddButton, {
                className: "object-property-expand",
                onClick: onAddClick(schema),
                disabled: disabled || readonly,
                uiSchema: uiSchema,
                registry: registry
            })
        ]
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fScEX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TitleField);
var _jsxRuntime = require("react/jsx-runtime");
const REQUIRED_FIELD_SYMBOL = "*";
function TitleField(props) {
    const { id, title, required } = props;
    return (0, _jsxRuntime.jsxs)("legend", {
        id: id,
        children: [
            title,
            required && (0, _jsxRuntime.jsx)("span", {
                className: "required",
                children: REQUIRED_FIELD_SYMBOL
            })
        ]
    });
}

},{"react/jsx-runtime":"gHQIF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8sTWU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
var _markdownToJsx = require("markdown-to-jsx");
var _markdownToJsxDefault = parcelHelpers.interopDefault(_markdownToJsx);
/** The `UnsupportedField` component is used to render a field in the schema is one that is not supported by
 * react-jsonschema-form.
 *
 * @param props - The `FieldProps` for this template
 */ function UnsupportedField(props) {
    const { schema, idSchema, reason, registry } = props;
    const { translateString } = registry;
    let translateEnum = (0, _utils.TranslatableString).UnsupportedField;
    const translateParams = [];
    if (idSchema && idSchema.$id) {
        translateEnum = (0, _utils.TranslatableString).UnsupportedFieldWithId;
        translateParams.push(idSchema.$id);
    }
    if (reason) {
        translateEnum = translateEnum === (0, _utils.TranslatableString).UnsupportedField ? (0, _utils.TranslatableString).UnsupportedFieldWithReason : (0, _utils.TranslatableString).UnsupportedFieldWithIdAndReason;
        translateParams.push(reason);
    }
    return (0, _jsxRuntime.jsxs)("div", {
        className: "unsupported-field",
        children: [
            (0, _jsxRuntime.jsx)("p", {
                children: (0, _jsxRuntime.jsx)((0, _markdownToJsxDefault.default), {
                    children: translateString(translateEnum, translateParams)
                })
            }),
            schema && (0, _jsxRuntime.jsx)("pre", {
                children: JSON.stringify(schema, null, 2)
            })
        ]
    });
}
exports.default = UnsupportedField;

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","markdown-to-jsx":"dhXvF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cuUcV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WrapIfAdditionalTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
var _label = require("./FieldTemplate/Label");
var _labelDefault = parcelHelpers.interopDefault(_label);
function WrapIfAdditionalTemplate(props) {
    const { id, classNames, style, disabled, label, onKeyChange, onDropPropertyClick, readonly, required, schema, children, uiSchema, registry } = props;
    const { templates, translateString } = registry;
    // Button templates are not overridden in the uiSchema
    const { RemoveButton } = templates.ButtonTemplates;
    const keyLabel = translateString((0, _utils.TranslatableString).KeyLabel, [
        label
    ]);
    const additional = (0, _utils.ADDITIONAL_PROPERTY_FLAG) in schema;
    if (!additional) return (0, _jsxRuntime.jsx)("div", {
        className: classNames,
        style: style,
        children: children
    });
    return (0, _jsxRuntime.jsx)("div", {
        className: classNames,
        style: style,
        children: (0, _jsxRuntime.jsxs)("div", {
            className: "row",
            children: [
                (0, _jsxRuntime.jsx)("div", {
                    className: "col-xs-5 form-additional",
                    children: (0, _jsxRuntime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
                                label: keyLabel,
                                required: required,
                                id: `${id}-key`
                            }),
                            (0, _jsxRuntime.jsx)("input", {
                                className: "form-control",
                                type: "text",
                                id: `${id}-key`,
                                onBlur: (event)=>onKeyChange(event.target.value),
                                defaultValue: label
                            })
                        ]
                    })
                }),
                (0, _jsxRuntime.jsx)("div", {
                    className: "form-additional form-group col-xs-5",
                    children: children
                }),
                (0, _jsxRuntime.jsx)("div", {
                    className: "col-xs-2",
                    children: (0, _jsxRuntime.jsx)(RemoveButton, {
                        className: "array-item-remove btn-block",
                        style: {
                            border: "0"
                        },
                        disabled: disabled || readonly,
                        onClick: onDropPropertyClick(label),
                        uiSchema: uiSchema,
                        registry: registry
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","./FieldTemplate/Label":"jtRsY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hszus":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _altDateWidget = require("./AltDateWidget");
var _altDateWidgetDefault = parcelHelpers.interopDefault(_altDateWidget);
var _altDateTimeWidget = require("./AltDateTimeWidget");
var _altDateTimeWidgetDefault = parcelHelpers.interopDefault(_altDateTimeWidget);
var _checkboxWidget = require("./CheckboxWidget");
var _checkboxWidgetDefault = parcelHelpers.interopDefault(_checkboxWidget);
var _checkboxesWidget = require("./CheckboxesWidget");
var _checkboxesWidgetDefault = parcelHelpers.interopDefault(_checkboxesWidget);
var _colorWidget = require("./ColorWidget");
var _colorWidgetDefault = parcelHelpers.interopDefault(_colorWidget);
var _dateWidget = require("./DateWidget");
var _dateWidgetDefault = parcelHelpers.interopDefault(_dateWidget);
var _dateTimeWidget = require("./DateTimeWidget");
var _dateTimeWidgetDefault = parcelHelpers.interopDefault(_dateTimeWidget);
var _emailWidget = require("./EmailWidget");
var _emailWidgetDefault = parcelHelpers.interopDefault(_emailWidget);
var _fileWidget = require("./FileWidget");
var _fileWidgetDefault = parcelHelpers.interopDefault(_fileWidget);
var _hiddenWidget = require("./HiddenWidget");
var _hiddenWidgetDefault = parcelHelpers.interopDefault(_hiddenWidget);
var _passwordWidget = require("./PasswordWidget");
var _passwordWidgetDefault = parcelHelpers.interopDefault(_passwordWidget);
var _radioWidget = require("./RadioWidget");
var _radioWidgetDefault = parcelHelpers.interopDefault(_radioWidget);
var _rangeWidget = require("./RangeWidget");
var _rangeWidgetDefault = parcelHelpers.interopDefault(_rangeWidget);
var _selectWidget = require("./SelectWidget");
var _selectWidgetDefault = parcelHelpers.interopDefault(_selectWidget);
var _textareaWidget = require("./TextareaWidget");
var _textareaWidgetDefault = parcelHelpers.interopDefault(_textareaWidget);
var _textWidget = require("./TextWidget");
var _textWidgetDefault = parcelHelpers.interopDefault(_textWidget);
var _timeWidget = require("./TimeWidget");
var _timeWidgetDefault = parcelHelpers.interopDefault(_timeWidget);
var _urlwidget = require("./URLWidget");
var _urlwidgetDefault = parcelHelpers.interopDefault(_urlwidget);
var _upDownWidget = require("./UpDownWidget");
var _upDownWidgetDefault = parcelHelpers.interopDefault(_upDownWidget);
function widgets() {
    return {
        AltDateWidget: (0, _altDateWidgetDefault.default),
        AltDateTimeWidget: (0, _altDateTimeWidgetDefault.default),
        CheckboxWidget: (0, _checkboxWidgetDefault.default),
        CheckboxesWidget: (0, _checkboxesWidgetDefault.default),
        ColorWidget: (0, _colorWidgetDefault.default),
        DateWidget: (0, _dateWidgetDefault.default),
        DateTimeWidget: (0, _dateTimeWidgetDefault.default),
        EmailWidget: (0, _emailWidgetDefault.default),
        FileWidget: (0, _fileWidgetDefault.default),
        HiddenWidget: (0, _hiddenWidgetDefault.default),
        PasswordWidget: (0, _passwordWidgetDefault.default),
        RadioWidget: (0, _radioWidgetDefault.default),
        RangeWidget: (0, _rangeWidgetDefault.default),
        SelectWidget: (0, _selectWidgetDefault.default),
        TextWidget: (0, _textWidgetDefault.default),
        TextareaWidget: (0, _textareaWidgetDefault.default),
        TimeWidget: (0, _timeWidgetDefault.default),
        UpDownWidget: (0, _upDownWidgetDefault.default),
        URLWidget: (0, _urlwidgetDefault.default)
    };
}
exports.default = widgets;

},{"./AltDateWidget":"5HouQ","./AltDateTimeWidget":"7lWgr","./CheckboxWidget":"2EgUz","./CheckboxesWidget":"a9AkP","./ColorWidget":"dsW5U","./DateWidget":"cVYZL","./DateTimeWidget":"lHMq0","./EmailWidget":"6LltY","./FileWidget":"j6bvq","./HiddenWidget":"eWi6J","./PasswordWidget":"l2DY4","./RadioWidget":"6rinT","./RangeWidget":"42dRA","./SelectWidget":"7cLea","./TextareaWidget":"cnEWd","./TextWidget":"dGDOb","./TimeWidget":"kLVyt","./URLWidget":"dHAWU","./UpDownWidget":"diyqy","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5HouQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
function rangeOptions(start, stop) {
    const options = [];
    for(let i = start; i <= stop; i++)options.push({
        value: i,
        label: (0, _utils.pad)(i, 2)
    });
    return options;
}
function readyForChange(state) {
    return Object.values(state).every((value)=>value !== -1);
}
function DateElement({ type, range, value, select, rootId, name, disabled, readonly, autofocus, registry, onBlur, onFocus }) {
    const id = rootId + "_" + type;
    const { SelectWidget } = registry.widgets;
    return (0, _jsxRuntime.jsx)(SelectWidget, {
        schema: {
            type: "integer"
        },
        id: id,
        name: name,
        className: "form-control",
        options: {
            enumOptions: rangeOptions(range[0], range[1])
        },
        placeholder: type,
        value: value,
        disabled: disabled,
        readonly: readonly,
        autofocus: autofocus,
        onChange: (value)=>select(type, value),
        onBlur: onBlur,
        onFocus: onFocus,
        registry: registry,
        label: "",
        "aria-describedby": (0, _utils.ariaDescribedByIds)(rootId)
    });
}
/** The `AltDateWidget` is an alternative widget for rendering date properties.
 * @param props - The `WidgetProps` for this component
 */ function AltDateWidget({ time = false, disabled = false, readonly = false, autofocus = false, options, id, name, registry, onBlur, onFocus, onChange, value }) {
    const { translateString } = registry;
    const [lastValue, setLastValue] = (0, _react.useState)(value);
    const [state, setState] = (0, _react.useReducer)((state, action)=>{
        return {
            ...state,
            ...action
        };
    }, (0, _utils.parseDateString)(value, time));
    (0, _react.useEffect)(()=>{
        const stateValue = (0, _utils.toDateString)(state, time);
        if (readyForChange(state) && stateValue !== value) // The user changed the date to a new valid data via the comboboxes, so call onChange
        onChange(stateValue);
        else if (lastValue !== value) {
            // We got a new value in the props
            setLastValue(value);
            setState((0, _utils.parseDateString)(value, time));
        }
    }, [
        time,
        value,
        onChange,
        state,
        lastValue
    ]);
    const handleChange = (0, _react.useCallback)((property, value)=>{
        setState({
            [property]: value
        });
    }, []);
    const handleSetNow = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        if (disabled || readonly) return;
        const nextState = (0, _utils.parseDateString)(new Date().toJSON(), time);
        onChange((0, _utils.toDateString)(nextState, time));
    }, [
        disabled,
        readonly,
        time
    ]);
    const handleClear = (0, _react.useCallback)((event)=>{
        event.preventDefault();
        if (disabled || readonly) return;
        onChange(undefined);
    }, [
        disabled,
        readonly,
        onChange
    ]);
    return (0, _jsxRuntime.jsxs)("ul", {
        className: "list-inline",
        children: [
            (0, _utils.getDateElementProps)(state, time, options.yearsRange, options.format).map((elemProps, i)=>(0, _jsxRuntime.jsx)("li", {
                    className: "list-inline-item",
                    children: (0, _jsxRuntime.jsx)(DateElement, {
                        rootId: id,
                        name: name,
                        select: handleChange,
                        ...elemProps,
                        disabled: disabled,
                        readonly: readonly,
                        registry: registry,
                        onBlur: onBlur,
                        onFocus: onFocus,
                        autofocus: autofocus && i === 0
                    })
                }, i)),
            (options.hideNowButton !== "undefined" ? !options.hideNowButton : true) && (0, _jsxRuntime.jsx)("li", {
                className: "list-inline-item",
                children: (0, _jsxRuntime.jsx)("a", {
                    href: "#",
                    className: "btn btn-info btn-now",
                    onClick: handleSetNow,
                    children: translateString((0, _utils.TranslatableString).NowLabel)
                })
            }),
            (options.hideClearButton !== "undefined" ? !options.hideClearButton : true) && (0, _jsxRuntime.jsx)("li", {
                className: "list-inline-item",
                children: (0, _jsxRuntime.jsx)("a", {
                    href: "#",
                    className: "btn btn-warning btn-clear",
                    onClick: handleClear,
                    children: translateString((0, _utils.TranslatableString).ClearLabel)
                })
            })
        ]
    });
}
exports.default = AltDateWidget;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7lWgr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
/** The `AltDateTimeWidget` is an alternative widget for rendering datetime properties.
 *  It uses the AltDateWidget for rendering, with the `time` prop set to true by default.
 *
 * @param props - The `WidgetProps` for this component
 */ function AltDateTimeWidget({ time = true, ...props }) {
    const { AltDateWidget } = props.registry.widgets;
    return (0, _jsxRuntime.jsx)(AltDateWidget, {
        time: time,
        ...props
    });
}
exports.default = AltDateTimeWidget;

},{"react/jsx-runtime":"gHQIF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2EgUz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
/** The `CheckBoxWidget` is a widget for rendering boolean properties.
 *  It is typically used to represent a boolean.
 *
 * @param props - The `WidgetProps` for this component
 */ function CheckboxWidget({ schema, uiSchema, options, id, value, disabled, readonly, label, hideLabel, autofocus = false, onBlur, onFocus, onChange, registry }) {
    var _a;
    const DescriptionFieldTemplate = (0, _utils.getTemplate)("DescriptionFieldTemplate", registry, options);
    // Because an unchecked checkbox will cause html5 validation to fail, only add
    // the "required" attribute if the field value must be "true", due to the
    // "const" or "enum" keywords
    const required = (0, _utils.schemaRequiresTrueValue)(schema);
    const handleChange = (0, _react.useCallback)((event)=>onChange(event.target.checked), [
        onChange
    ]);
    const handleBlur = (0, _react.useCallback)((event)=>onBlur(id, event.target.checked), [
        onBlur,
        id
    ]);
    const handleFocus = (0, _react.useCallback)((event)=>onFocus(id, event.target.checked), [
        onFocus,
        id
    ]);
    const description = (_a = options.description) !== null && _a !== void 0 ? _a : schema.description;
    return (0, _jsxRuntime.jsxs)("div", {
        className: `checkbox ${disabled || readonly ? "disabled" : ""}`,
        children: [
            !hideLabel && !!description && (0, _jsxRuntime.jsx)(DescriptionFieldTemplate, {
                id: (0, _utils.descriptionId)(id),
                description: description,
                schema: schema,
                uiSchema: uiSchema,
                registry: registry
            }),
            (0, _jsxRuntime.jsxs)("label", {
                children: [
                    (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        id: id,
                        name: id,
                        checked: typeof value === "undefined" ? false : value,
                        required: required,
                        disabled: disabled || readonly,
                        autoFocus: autofocus,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        onFocus: handleFocus,
                        "aria-describedby": (0, _utils.ariaDescribedByIds)(id)
                    }),
                    (0, _utils.labelValue)((0, _jsxRuntime.jsx)("span", {
                        children: label
                    }), hideLabel)
                ]
            })
        ]
    });
}
exports.default = CheckboxWidget;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a9AkP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
/** The `CheckboxesWidget` is a widget for rendering checkbox groups.
 *  It is typically used to represent an array of enums.
 *
 * @param props - The `WidgetProps` for this component
 */ function CheckboxesWidget({ id, disabled, options: { inline = false, enumOptions, enumDisabled, emptyValue }, value, autofocus = false, readonly, onChange, onBlur, onFocus }) {
    const checkboxesValues = Array.isArray(value) ? value : [
        value
    ];
    const handleBlur = (0, _react.useCallback)(({ target: { value } })=>onBlur(id, (0, _utils.enumOptionsValueForIndex)(value, enumOptions, emptyValue)), [
        onBlur,
        id
    ]);
    const handleFocus = (0, _react.useCallback)(({ target: { value } })=>onFocus(id, (0, _utils.enumOptionsValueForIndex)(value, enumOptions, emptyValue)), [
        onFocus,
        id
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: "checkboxes",
        id: id,
        children: Array.isArray(enumOptions) && enumOptions.map((option, index)=>{
            const checked = (0, _utils.enumOptionsIsSelected)(option.value, checkboxesValues);
            const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.indexOf(option.value) !== -1;
            const disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
            const handleChange = (event)=>{
                if (event.target.checked) onChange((0, _utils.enumOptionsSelectValue)(index, checkboxesValues, enumOptions));
                else onChange((0, _utils.enumOptionsDeselectValue)(index, checkboxesValues, enumOptions));
            };
            const checkbox = (0, _jsxRuntime.jsxs)("span", {
                children: [
                    (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        id: (0, _utils.optionId)(id, index),
                        name: id,
                        checked: checked,
                        value: String(index),
                        disabled: disabled || itemDisabled || readonly,
                        autoFocus: autofocus && index === 0,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        onFocus: handleFocus,
                        "aria-describedby": (0, _utils.ariaDescribedByIds)(id)
                    }),
                    (0, _jsxRuntime.jsx)("span", {
                        children: option.label
                    })
                ]
            });
            return inline ? (0, _jsxRuntime.jsx)("label", {
                className: `checkbox-inline ${disabledCls}`,
                children: checkbox
            }, index) : (0, _jsxRuntime.jsx)("div", {
                className: `checkbox ${disabledCls}`,
                children: (0, _jsxRuntime.jsx)("label", {
                    children: checkbox
                })
            }, index);
        })
    });
}
exports.default = CheckboxesWidget;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dsW5U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ColorWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function ColorWidget(props) {
    const { disabled, readonly, options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    return (0, _jsxRuntime.jsx)(BaseInputTemplate, {
        type: "color",
        ...props,
        disabled: disabled || readonly
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cVYZL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
function DateWidget(props) {
    const { onChange, options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    const handleChange = (0, _react.useCallback)((value)=>onChange(value || undefined), [
        onChange
    ]);
    return (0, _jsxRuntime.jsx)(BaseInputTemplate, {
        type: "date",
        ...props,
        onChange: handleChange
    });
}

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lHMq0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateTimeWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function DateTimeWidget(props) {
    const { onChange, value, options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    return (0, _jsxRuntime.jsx)(BaseInputTemplate, {
        type: "datetime-local",
        ...props,
        value: (0, _utils.utcToLocal)(value),
        onChange: (value)=>onChange((0, _utils.localToUTC)(value))
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6LltY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EmailWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function EmailWidget(props) {
    const { options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    return (0, _jsxRuntime.jsx)(BaseInputTemplate, {
        type: "email",
        ...props
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j6bvq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
var _markdownToJsx = require("markdown-to-jsx");
var _markdownToJsxDefault = parcelHelpers.interopDefault(_markdownToJsx);
function addNameToDataURL(dataURL, name) {
    if (dataURL === null) return null;
    return dataURL.replace(";base64", `;name=${encodeURIComponent(name)};base64`);
}
function processFile(file) {
    const { name, size, type } = file;
    return new Promise((resolve, reject)=>{
        const reader = new window.FileReader();
        reader.onerror = reject;
        reader.onload = (event)=>{
            var _a;
            if (typeof ((_a = event.target) === null || _a === void 0 ? void 0 : _a.result) === "string") resolve({
                dataURL: addNameToDataURL(event.target.result, name),
                name,
                size,
                type
            });
            else resolve({
                dataURL: null,
                name,
                size,
                type
            });
        };
        reader.readAsDataURL(file);
    });
}
function processFiles(files) {
    return Promise.all(Array.from(files).map(processFile));
}
function FileInfoPreview({ fileInfo, registry }) {
    const { translateString } = registry;
    const { dataURL, type, name } = fileInfo;
    if (!dataURL) return null;
    // If type is JPEG or PNG then show image preview.
    // Originally, any type of image was supported, but this was changed into a whitelist
    // since SVGs and animated GIFs are also images, which are generally considered a security risk.
    if ([
        "image/jpeg",
        "image/png"
    ].includes(type)) return (0, _jsxRuntime.jsx)("img", {
        src: dataURL,
        style: {
            maxWidth: "100%"
        },
        className: "file-preview"
    });
    // otherwise, let users download file
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            " ",
            (0, _jsxRuntime.jsx)("a", {
                download: `preview-${name}`,
                href: dataURL,
                className: "file-download",
                children: translateString((0, _utils.TranslatableString).PreviewLabel)
            })
        ]
    });
}
function FilesInfo({ filesInfo, registry, preview, onRemove, options }) {
    if (filesInfo.length === 0) return null;
    const { translateString } = registry;
    const { RemoveButton } = (0, _utils.getTemplate)("ButtonTemplates", registry, options);
    return (0, _jsxRuntime.jsx)("ul", {
        className: "file-info",
        children: filesInfo.map((fileInfo, key)=>{
            const { name, size, type } = fileInfo;
            const handleRemove = ()=>onRemove(key);
            return (0, _jsxRuntime.jsxs)("li", {
                children: [
                    (0, _jsxRuntime.jsx)((0, _markdownToJsxDefault.default), {
                        children: translateString((0, _utils.TranslatableString).FilesInfo, [
                            name,
                            type,
                            String(size)
                        ])
                    }),
                    preview && (0, _jsxRuntime.jsx)(FileInfoPreview, {
                        fileInfo: fileInfo,
                        registry: registry
                    }),
                    (0, _jsxRuntime.jsx)(RemoveButton, {
                        onClick: handleRemove,
                        registry: registry
                    })
                ]
            }, key);
        })
    });
}
function extractFileInfo(dataURLs) {
    return dataURLs.reduce((acc, dataURL)=>{
        if (!dataURL) return acc;
        try {
            const { blob, name } = (0, _utils.dataURItoBlob)(dataURL);
            return [
                ...acc,
                {
                    dataURL,
                    name: name,
                    size: blob.size,
                    type: blob.type
                }
            ];
        } catch (e) {
            // Invalid dataURI, so just ignore it.
            return acc;
        }
    }, []);
}
/**
 *  The `FileWidget` is a widget for rendering file upload fields.
 *  It is typically used with a string property with data-url format.
 */ function FileWidget(props) {
    const { disabled, readonly, required, multiple, onChange, value, options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    const handleChange = (0, _react.useCallback)((event)=>{
        if (!event.target.files) return;
        // Due to variances in themes, dealing with multiple files for the array case now happens one file at a time.
        // This is because we don't pass `multiple` into the `BaseInputTemplate` anymore. Instead, we deal with the single
        // file in each event and concatenate them together ourselves
        processFiles(event.target.files).then((filesInfoEvent)=>{
            const newValue = filesInfoEvent.map((fileInfo)=>fileInfo.dataURL);
            if (multiple) onChange(value.concat(newValue[0]));
            else onChange(newValue[0]);
        });
    }, [
        multiple,
        value,
        onChange
    ]);
    const filesInfo = (0, _react.useMemo)(()=>extractFileInfo(Array.isArray(value) ? value : [
            value
        ]), [
        value
    ]);
    const rmFile = (0, _react.useCallback)((index)=>{
        if (multiple) {
            const newValue = value.filter((_, i)=>i !== index);
            onChange(newValue);
        } else onChange(undefined);
    }, [
        multiple,
        value,
        onChange
    ]);
    return (0, _jsxRuntime.jsxs)("div", {
        children: [
            (0, _jsxRuntime.jsx)(BaseInputTemplate, {
                ...props,
                disabled: disabled || readonly,
                type: "file",
                required: value ? false : required,
                onChangeOverride: handleChange,
                value: "",
                accept: options.accept ? String(options.accept) : undefined
            }),
            (0, _jsxRuntime.jsx)(FilesInfo, {
                filesInfo: filesInfo,
                onRemove: rmFile,
                registry: registry,
                preview: options.filePreview,
                options: options
            })
        ]
    });
}
exports.default = FileWidget;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","markdown-to-jsx":"dhXvF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eWi6J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
/** The `HiddenWidget` is a widget for rendering a hidden input field.
 *  It is typically used by setting type to "hidden".
 *
 * @param props - The `WidgetProps` for this component
 */ function HiddenWidget({ id, value }) {
    return (0, _jsxRuntime.jsx)("input", {
        type: "hidden",
        id: id,
        name: id,
        value: typeof value === "undefined" ? "" : value
    });
}
exports.default = HiddenWidget;

},{"react/jsx-runtime":"gHQIF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l2DY4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PasswordWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function PasswordWidget(props) {
    const { options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    return (0, _jsxRuntime.jsx)(BaseInputTemplate, {
        type: "password",
        ...props
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6rinT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
/** The `RadioWidget` is a widget for rendering a radio group.
 *  It is typically used with a string property constrained with enum options.
 *
 * @param props - The `WidgetProps` for this component
 */ function RadioWidget({ options, value, required, disabled, readonly, autofocus = false, onBlur, onFocus, onChange, id }) {
    const { enumOptions, enumDisabled, inline, emptyValue } = options;
    const handleBlur = (0, _react.useCallback)(({ target: { value } })=>onBlur(id, (0, _utils.enumOptionsValueForIndex)(value, enumOptions, emptyValue)), [
        onBlur,
        id
    ]);
    const handleFocus = (0, _react.useCallback)(({ target: { value } })=>onFocus(id, (0, _utils.enumOptionsValueForIndex)(value, enumOptions, emptyValue)), [
        onFocus,
        id
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: "field-radio-group",
        id: id,
        children: Array.isArray(enumOptions) && enumOptions.map((option, i)=>{
            const checked = (0, _utils.enumOptionsIsSelected)(option.value, value);
            const itemDisabled = Array.isArray(enumDisabled) && enumDisabled.indexOf(option.value) !== -1;
            const disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
            const handleChange = ()=>onChange(option.value);
            const radio = (0, _jsxRuntime.jsxs)("span", {
                children: [
                    (0, _jsxRuntime.jsx)("input", {
                        type: "radio",
                        id: (0, _utils.optionId)(id, i),
                        checked: checked,
                        name: id,
                        required: required,
                        value: String(i),
                        disabled: disabled || itemDisabled || readonly,
                        autoFocus: autofocus && i === 0,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        onFocus: handleFocus,
                        "aria-describedby": (0, _utils.ariaDescribedByIds)(id)
                    }),
                    (0, _jsxRuntime.jsx)("span", {
                        children: option.label
                    })
                ]
            });
            return inline ? (0, _jsxRuntime.jsx)("label", {
                className: `radio-inline ${disabledCls}`,
                children: radio
            }, i) : (0, _jsxRuntime.jsx)("div", {
                className: `radio ${disabledCls}`,
                children: (0, _jsxRuntime.jsx)("label", {
                    children: radio
                })
            }, i);
        })
    });
}
exports.default = RadioWidget;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"42dRA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RangeWidget);
var _jsxRuntime = require("react/jsx-runtime");
function RangeWidget(props) {
    const { value, registry: { templates: { BaseInputTemplate } } } = props;
    return (0, _jsxRuntime.jsxs)("div", {
        className: "field-range-wrapper",
        children: [
            (0, _jsxRuntime.jsx)(BaseInputTemplate, {
                type: "range",
                ...props
            }),
            (0, _jsxRuntime.jsx)("span", {
                className: "range-view",
                children: value
            })
        ]
    });
}

},{"react/jsx-runtime":"gHQIF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7cLea":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
function getValue(event, multiple) {
    if (multiple) return Array.from(event.target.options).slice().filter((o)=>o.selected).map((o)=>o.value);
    return event.target.value;
}
/** The `SelectWidget` is a widget for rendering dropdowns.
 *  It is typically used with string properties constrained with enum options.
 *
 * @param props - The `WidgetProps` for this component
 */ function SelectWidget({ schema, id, options, value, required, disabled, readonly, multiple = false, autofocus = false, onChange, onBlur, onFocus, placeholder }) {
    const { enumOptions, enumDisabled, emptyValue: optEmptyVal } = options;
    const emptyValue = multiple ? [] : "";
    const handleFocus = (0, _react.useCallback)((event)=>{
        const newValue = getValue(event, multiple);
        return onFocus(id, (0, _utils.enumOptionsValueForIndex)(newValue, enumOptions, optEmptyVal));
    }, [
        onFocus,
        id,
        schema,
        multiple,
        options
    ]);
    const handleBlur = (0, _react.useCallback)((event)=>{
        const newValue = getValue(event, multiple);
        return onBlur(id, (0, _utils.enumOptionsValueForIndex)(newValue, enumOptions, optEmptyVal));
    }, [
        onBlur,
        id,
        schema,
        multiple,
        options
    ]);
    const handleChange = (0, _react.useCallback)((event)=>{
        const newValue = getValue(event, multiple);
        return onChange((0, _utils.enumOptionsValueForIndex)(newValue, enumOptions, optEmptyVal));
    }, [
        onChange,
        schema,
        multiple,
        options
    ]);
    const selectedIndexes = (0, _utils.enumOptionsIndexForValue)(value, enumOptions, multiple);
    return (0, _jsxRuntime.jsxs)("select", {
        id: id,
        name: id,
        multiple: multiple,
        className: "form-control",
        value: typeof selectedIndexes === "undefined" ? emptyValue : selectedIndexes,
        required: required,
        disabled: disabled || readonly,
        autoFocus: autofocus,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleChange,
        "aria-describedby": (0, _utils.ariaDescribedByIds)(id),
        children: [
            !multiple && schema.default === undefined && (0, _jsxRuntime.jsx)("option", {
                value: "",
                children: placeholder
            }),
            Array.isArray(enumOptions) && enumOptions.map(({ value, label }, i)=>{
                const disabled = enumDisabled && enumDisabled.indexOf(value) !== -1;
                return (0, _jsxRuntime.jsx)("option", {
                    value: String(i),
                    disabled: disabled,
                    children: label
                }, i);
            })
        ]
    });
}
exports.default = SelectWidget;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cnEWd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
/** The `TextareaWidget` is a widget for rendering input fields as textarea.
 *
 * @param props - The `WidgetProps` for this component
 */ function TextareaWidget({ id, options = {}, placeholder, value, required, disabled, readonly, autofocus = false, onChange, onBlur, onFocus }) {
    const handleChange = (0, _react.useCallback)(({ target: { value } })=>onChange(value === "" ? options.emptyValue : value), [
        onChange,
        options.emptyValue
    ]);
    const handleBlur = (0, _react.useCallback)(({ target: { value } })=>onBlur(id, value), [
        onBlur,
        id
    ]);
    const handleFocus = (0, _react.useCallback)(({ target: { value } })=>onFocus(id, value), [
        id,
        onFocus
    ]);
    return (0, _jsxRuntime.jsx)("textarea", {
        id: id,
        name: id,
        className: "form-control",
        value: value ? value : "",
        placeholder: placeholder,
        required: required,
        disabled: disabled,
        readOnly: readonly,
        autoFocus: autofocus,
        rows: options.rows,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleChange,
        "aria-describedby": (0, _utils.ariaDescribedByIds)(id)
    });
}
TextareaWidget.defaultProps = {
    autofocus: false,
    options: {}
};
exports.default = TextareaWidget;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dGDOb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function TextWidget(props) {
    const { options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    return (0, _jsxRuntime.jsx)(BaseInputTemplate, {
        ...props
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kLVyt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TimeWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@rjsf/utils");
function TimeWidget(props) {
    const { onChange, options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    const handleChange = (0, _react.useCallback)((value)=>onChange(value ? `${value}:00` : undefined), [
        onChange
    ]);
    return (0, _jsxRuntime.jsx)(BaseInputTemplate, {
        type: "time",
        ...props,
        onChange: handleChange
    });
}

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dHAWU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>URLWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function URLWidget(props) {
    const { options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    return (0, _jsxRuntime.jsx)(BaseInputTemplate, {
        type: "url",
        ...props
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"diyqy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UpDownWidget);
var _jsxRuntime = require("react/jsx-runtime");
var _utils = require("@rjsf/utils");
function UpDownWidget(props) {
    const { options, registry } = props;
    const BaseInputTemplate = (0, _utils.getTemplate)("BaseInputTemplate", registry, options);
    return (0, _jsxRuntime.jsx)(BaseInputTemplate, {
        type: "number",
        ...props
    });
}

},{"react/jsx-runtime":"gHQIF","@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2O1yt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>withTheme);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _form = require("./components/Form");
var _formDefault = parcelHelpers.interopDefault(_form);
function withTheme(themeProps) {
    return (0, _react.forwardRef)(({ fields, widgets, templates, ...directProps }, ref)=>{
        var _a;
        fields = {
            ...themeProps === null || themeProps === void 0 ? void 0 : themeProps.fields,
            ...fields
        };
        widgets = {
            ...themeProps === null || themeProps === void 0 ? void 0 : themeProps.widgets,
            ...widgets
        };
        templates = {
            ...themeProps === null || themeProps === void 0 ? void 0 : themeProps.templates,
            ...templates,
            ButtonTemplates: {
                ...(_a = themeProps === null || themeProps === void 0 ? void 0 : themeProps.templates) === null || _a === void 0 ? void 0 : _a.ButtonTemplates,
                ...templates === null || templates === void 0 ? void 0 : templates.ButtonTemplates
            }
        };
        return (0, _jsxRuntime.jsx)((0, _formDefault.default), {
            ...themeProps,
            ...directProps,
            fields: fields,
            widgets: widgets,
            templates: templates,
            ref: ref
        });
    });
}

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","./components/Form":"b1OIF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dXyR8":[function(require,module,exports) {
/**
 * Provides a custom validator for RJSF that does not use the AJV validation library.
 * The type signatures of this class and methods generally follow the RJSF structure
 * set by the `validator-ajv8` package. This validator can run without requiring the
 * use of `eval` or `new Function`, which is useful when creating a more restrictive
 * Content Security Policy (CSP).
 *
 * See:
 *   - https://github.com/rjsf-team/react-jsonschema-form/blob/v5.17.1/packages/validator-ajv8/src/validator.ts
 *   - https://www.npmjs.com/package/@cfworker/json-schema
 *   - https://ajv.js.org/security.html#content-security-policy
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultValidator", ()=>defaultValidator);
var _jsonSchema = require("@cfworker/json-schema");
var _utils = require("@rjsf/utils");
var _jsonSchemaDraft07Json = require("./json-schema-draft-07.json");
var _jsonSchemaDraft07JsonDefault = parcelHelpers.interopDefault(_jsonSchemaDraft07Json);
var _errorTransformer = require("./error-transformer");
class CFWorkerFormValidator {
    // Optional additional validation schemas for the underlying JSON validator
    additionalMetaSchemas = [];
    // Optional transformation function to localize validation errors
    localizeErrors = (errors)=>errors;
    /**
   * Constructs a new validator object that uses `@cfworker/json-schema` instead of AJV.
   *
   * @param [options] - options
   * @param [localizeErrors] - function that localizes validation errors
   */ constructor(options, localizeErrors){
        if (Array.isArray(options?.additionalMetaSchemas)) this.additionalMetaSchemas = options.additionalMetaSchemas;
        if (typeof localizeErrors === "function") this.localizeErrors = localizeErrors;
    }
    /**
   * Validates `formData` against the provided `schema` while bypassing RJSF entirely.
   *
   * @param schema - used to validate form data
   * @param formData - form data to be validated
   */ rawValidation(schema, formData) {
        let compilationError;
        let validationErrors;
        try {
            const compiledValidator = new (0, _jsonSchema.Validator)(schema, "7", false);
            this.additionalMetaSchemas.forEach((additionalSchema)=>{
                compiledValidator.addSchema(additionalSchema);
            });
            const validationResult = compiledValidator.validate(formData);
            validationErrors = this.localizeErrors(validationResult.errors);
        } catch (err) {
            console.warn("Error encountered running the raw validation:", err);
            compilationError = err;
        }
        // The terminology here may seem confusing, but this is the existing contract set up
        // for the original ajv8 validator and what the calling code expects.
        return {
            errors: validationErrors,
            validationError: compilationError
        };
    }
    /**
   * Validates form data using the provided schema and a variety of different options.
   * Custom validation errors can be added to each field. The resultant validation
   * errors can also be transformed as desired. By default, the `@cfworker/json-schema`
   * library validates the form data and transforms the output into a format that
   * RJSF expects. See `./error-transformer.js` for additional details concerning
   * error post-processing.
   *
   * @param schema - used to validate form data
   * @param formData - form data to be validated
   * @param [customValidate] - function that may be used to perform custom validation
   * @param [transformErrors] - function that may be used to transform errors after validation
   * @param [uiSchema] - schema option passed to `customValidate` and `transformErrors`
   */ validateFormData(formData, schema, customValidate, transformErrors, uiSchema) {
        const rawErrors = this.rawValidation(schema, formData);
        return (0, _errorTransformer.processRawValidationErrors)(this, rawErrors, formData, schema, customValidate, transformErrors, uiSchema);
    }
    /**
   * Validates form data against a custom schema. Returns true when the custom schema
   * is a valid JSON schema and the form data is a valid instance of the custom schema.
   *
   * @param schema - used to validate form data
   * @param formData - form data to be validated
   * @param rootSchema - used to handle models that only live in the root schema
   */ isValid(schema, formData, rootSchema) {
        if (!this.#isValidSchema(schema, rootSchema)) return false;
        try {
            const schemaWithIdRefPrefix = (0, _utils.withIdRefPrefix)(schema);
            const compiledValidator = new (0, _jsonSchema.Validator)(schemaWithIdRefPrefix, "7", true);
            const schemaId = schemaWithIdRefPrefix[0, _utils.ID_KEY] ?? (0, _utils.hashForSchema)(schemaWithIdRefPrefix);
            compiledValidator.addSchema(schema, schemaId);
            const rootSchemaId = rootSchema[0, _utils.ID_KEY] ?? (0, _utils.ROOT_SCHEMA_PREFIX);
            compiledValidator.addSchema(rootSchema, rootSchemaId);
            const result = compiledValidator.validate(formData);
            return result.valid;
        } catch (err) {
            console.warn("Error encountered running the validation:", err);
            return false;
        }
    }
    /**
   * Determines whether the provided schema is a valid JSON schema according
   * to Draft 7 of the standard.
   *
   * @param schema - schema to be validated against the JSON Draft 7 standard
   */ #isValidSchema(schema, rootSchema) {
        try {
            const compiledValidator = new (0, _jsonSchema.Validator)((0, _jsonSchemaDraft07JsonDefault.default));
            const schemaResult = compiledValidator.validate(schema).valid;
            const rootSchemaResult = compiledValidator.validate(rootSchema).valid;
            return schemaResult && rootSchemaResult;
        } catch (err) {
            console.warn("Error encountered validating the schema formats:", err);
            return false;
        }
    }
}
exports.default = CFWorkerFormValidator;
const defaultValidator = new CFWorkerFormValidator();

},{"@cfworker/json-schema":"505oO","@rjsf/utils":"joqWx","./json-schema-draft-07.json":"e6d3r","./error-transformer":"pZ1MA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"505oO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepCompareStrictJs = require("./deep-compare-strict.js");
parcelHelpers.exportAll(_deepCompareStrictJs, exports);
var _dereferenceJs = require("./dereference.js");
parcelHelpers.exportAll(_dereferenceJs, exports);
var _formatJs = require("./format.js");
parcelHelpers.exportAll(_formatJs, exports);
var _pointerJs = require("./pointer.js");
parcelHelpers.exportAll(_pointerJs, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _ucs2LengthJs = require("./ucs2-length.js");
parcelHelpers.exportAll(_ucs2LengthJs, exports);
var _validateJs = require("./validate.js");
parcelHelpers.exportAll(_validateJs, exports);
var _validatorJs = require("./validator.js");
parcelHelpers.exportAll(_validatorJs, exports);

},{"./deep-compare-strict.js":false,"./dereference.js":false,"./format.js":false,"./pointer.js":false,"./types.js":false,"./ucs2-length.js":false,"./validate.js":false,"./validator.js":"6kJbK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"grMEr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepCompareStrict", ()=>deepCompareStrict);
function deepCompareStrict(a, b) {
    const typeofa = typeof a;
    if (typeofa !== typeof b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return false;
        const length = a.length;
        if (length !== b.length) return false;
        for(let i = 0; i < length; i++){
            if (!deepCompareStrict(a[i], b[i])) return false;
        }
        return true;
    }
    if (typeofa === "object") {
        if (!a || !b) return a === b;
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        const length = aKeys.length;
        if (length !== bKeys.length) return false;
        for (const k of aKeys){
            if (!deepCompareStrict(a[k], b[k])) return false;
        }
        return true;
    }
    return a === b;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"14NYx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemaKeyword", ()=>schemaKeyword);
parcelHelpers.export(exports, "schemaArrayKeyword", ()=>schemaArrayKeyword);
parcelHelpers.export(exports, "schemaMapKeyword", ()=>schemaMapKeyword);
parcelHelpers.export(exports, "ignoredKeyword", ()=>ignoredKeyword);
parcelHelpers.export(exports, "initialBaseURI", ()=>initialBaseURI);
parcelHelpers.export(exports, "dereference", ()=>dereference);
var _pointerJs = require("./pointer.js");
const schemaKeyword = {
    additionalItems: true,
    unevaluatedItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    unevaluatedProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
const schemaArrayKeyword = {
    prefixItems: true,
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
const schemaMapKeyword = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependentSchemas: true
};
const ignoredKeyword = {
    id: true,
    $id: true,
    $ref: true,
    $schema: true,
    $anchor: true,
    $vocabulary: true,
    $comment: true,
    default: true,
    enum: true,
    const: true,
    required: true,
    type: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
let initialBaseURI = typeof self !== "undefined" && self.location && self.location.origin !== "null" ? new URL(self.location.origin + self.location.pathname + location.search) : new URL("https://github.com/cfworker");
function dereference(schema, lookup = Object.create(null), baseURI = initialBaseURI, basePointer = "") {
    if (schema && typeof schema === "object" && !Array.isArray(schema)) {
        const id = schema.$id || schema.id;
        if (id) {
            const url = new URL(id, baseURI.href);
            if (url.hash.length > 1) lookup[url.href] = schema;
            else {
                url.hash = "";
                if (basePointer === "") baseURI = url;
                else dereference(schema, lookup, baseURI);
            }
        }
    } else if (schema !== true && schema !== false) return lookup;
    const schemaURI = baseURI.href + (basePointer ? "#" + basePointer : "");
    if (lookup[schemaURI] !== undefined) throw new Error(`Duplicate schema URI "${schemaURI}".`);
    lookup[schemaURI] = schema;
    if (schema === true || schema === false) return lookup;
    if (schema.__absolute_uri__ === undefined) Object.defineProperty(schema, "__absolute_uri__", {
        enumerable: false,
        value: schemaURI
    });
    if (schema.$ref && schema.__absolute_ref__ === undefined) {
        const url = new URL(schema.$ref, baseURI.href);
        url.hash = url.hash;
        Object.defineProperty(schema, "__absolute_ref__", {
            enumerable: false,
            value: url.href
        });
    }
    if (schema.$recursiveRef && schema.__absolute_recursive_ref__ === undefined) {
        const url = new URL(schema.$recursiveRef, baseURI.href);
        url.hash = url.hash;
        Object.defineProperty(schema, "__absolute_recursive_ref__", {
            enumerable: false,
            value: url.href
        });
    }
    if (schema.$anchor) {
        const url = new URL("#" + schema.$anchor, baseURI.href);
        lookup[url.href] = schema;
    }
    for(let key in schema){
        if (ignoredKeyword[key]) continue;
        const keyBase = `${basePointer}/${(0, _pointerJs.encodePointer)(key)}`;
        const subSchema = schema[key];
        if (Array.isArray(subSchema)) {
            if (schemaArrayKeyword[key]) {
                const length = subSchema.length;
                for(let i = 0; i < length; i++)dereference(subSchema[i], lookup, baseURI, `${keyBase}/${i}`);
            }
        } else if (schemaMapKeyword[key]) for(let subKey in subSchema)dereference(subSchema[subKey], lookup, baseURI, `${keyBase}/${(0, _pointerJs.encodePointer)(subKey)}`);
        else dereference(subSchema, lookup, baseURI, keyBase);
    }
    return lookup;
}

},{"./pointer.js":"5KeDf","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5KeDf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encodePointer", ()=>encodePointer);
parcelHelpers.export(exports, "escapePointer", ()=>escapePointer);
function encodePointer(p) {
    return encodeURI(escapePointer(p));
}
function escapePointer(p) {
    return p.replace(/~/g, "~0").replace(/\//g, "~1");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kNQFe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fullFormat", ()=>fullFormat);
parcelHelpers.export(exports, "fastFormat", ()=>fastFormat);
const DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
const HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
const URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
const URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
const URL_ = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
const UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
const JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
const RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
const FASTDATE = /^\d\d\d\d-[0-1]\d-[0-3]\d$/;
const FASTTIME = /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i;
const FASTDATETIME = /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i;
const FASTURIREFERENCE = /^(?:(?:[a-z][a-z0-9+-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i;
const EMAIL = (input)=>{
    if (input[0] === '"') return false;
    const [name, host, ...rest] = input.split("@");
    if (!name || !host || rest.length !== 0 || name.length > 64 || host.length > 253) return false;
    if (name[0] === "." || name.endsWith(".") || name.includes("..")) return false;
    if (!/^[a-z0-9.-]+$/i.test(host) || !/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(name)) return false;
    return host.split(".").every((part)=>/^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/i.test(part));
};
const IPV4 = /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/;
const IPV6 = /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i;
const DURATION = (input)=>input.length > 1 && input.length < 80 && (/^P\d+([.,]\d+)?W$/.test(input) || /^P[\dYMDTHS]*(\d[.,]\d+)?[YMDHS]$/.test(input) && /^P([.,\d]+Y)?([.,\d]+M)?([.,\d]+D)?(T([.,\d]+H)?([.,\d]+M)?([.,\d]+S)?)?$/.test(input));
function bind(r) {
    return r.test.bind(r);
}
const fullFormat = {
    date,
    time: time.bind(undefined, false),
    "date-time": date_time,
    duration: DURATION,
    uri,
    "uri-reference": bind(URIREF),
    "uri-template": bind(URITEMPLATE),
    url: bind(URL_),
    email: EMAIL,
    hostname: bind(HOSTNAME),
    ipv4: bind(IPV4),
    ipv6: bind(IPV6),
    regex: regex,
    uuid: bind(UUID),
    "json-pointer": bind(JSON_POINTER),
    "json-pointer-uri-fragment": bind(JSON_POINTER_URI_FRAGMENT),
    "relative-json-pointer": bind(RELATIVE_JSON_POINTER)
};
const fastFormat = {
    ...fullFormat,
    date: bind(FASTDATE),
    time: bind(FASTTIME),
    "date-time": bind(FASTDATETIME),
    "uri-reference": bind(FASTURIREFERENCE)
};
function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function date(str) {
    const matches = str.match(DATE);
    if (!matches) return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && isLeapYear(year) ? 29 : DAYS[month]);
}
function time(full, str) {
    const matches = str.match(TIME);
    if (!matches) return false;
    const hour = +matches[1];
    const minute = +matches[2];
    const second = +matches[3];
    const timeZone = !!matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour == 23 && minute == 59 && second == 60) && (!full || timeZone);
}
const DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
    const dateTime = str.split(DATE_TIME_SEPARATOR);
    return dateTime.length == 2 && date(dateTime[0]) && time(true, dateTime[1]);
}
const NOT_URI_FRAGMENT = /\/|:/;
const URI_PATTERN = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function uri(str) {
    return NOT_URI_FRAGMENT.test(str) && URI_PATTERN.test(str);
}
const Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
    if (Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str, "u");
        return true;
    } catch (e) {
        return false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4Oxoq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ucs2length", ()=>ucs2length);
function ucs2length(s) {
    let result = 0;
    let length = s.length;
    let index = 0;
    let charCode;
    while(index < length){
        result++;
        charCode = s.charCodeAt(index++);
        if (charCode >= 0xd800 && charCode <= 0xdbff && index < length) {
            charCode = s.charCodeAt(index);
            if ((charCode & 0xfc00) == 0xdc00) index++;
        }
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8kjd6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validate", ()=>validate);
var _deepCompareStrictJs = require("./deep-compare-strict.js");
var _dereferenceJs = require("./dereference.js");
var _formatJs = require("./format.js");
var _pointerJs = require("./pointer.js");
var _ucs2LengthJs = require("./ucs2-length.js");
function validate(instance, schema, draft = "2019-09", lookup = (0, _dereferenceJs.dereference)(schema), shortCircuit = true, recursiveAnchor = null, instanceLocation = "#", schemaLocation = "#", evaluated = Object.create(null)) {
    if (schema === true) return {
        valid: true,
        errors: []
    };
    if (schema === false) return {
        valid: false,
        errors: [
            {
                instanceLocation,
                keyword: "false",
                keywordLocation: instanceLocation,
                error: "False boolean schema."
            }
        ]
    };
    const rawInstanceType = typeof instance;
    let instanceType;
    switch(rawInstanceType){
        case "boolean":
        case "number":
        case "string":
            instanceType = rawInstanceType;
            break;
        case "object":
            if (instance === null) instanceType = "null";
            else if (Array.isArray(instance)) instanceType = "array";
            else instanceType = "object";
            break;
        default:
            throw new Error(`Instances of "${rawInstanceType}" type are not supported.`);
    }
    const { $ref, $recursiveRef, $recursiveAnchor, type: $type, const: $const, enum: $enum, required: $required, not: $not, anyOf: $anyOf, allOf: $allOf, oneOf: $oneOf, if: $if, then: $then, else: $else, format: $format, properties: $properties, patternProperties: $patternProperties, additionalProperties: $additionalProperties, unevaluatedProperties: $unevaluatedProperties, minProperties: $minProperties, maxProperties: $maxProperties, propertyNames: $propertyNames, dependentRequired: $dependentRequired, dependentSchemas: $dependentSchemas, dependencies: $dependencies, prefixItems: $prefixItems, items: $items, additionalItems: $additionalItems, unevaluatedItems: $unevaluatedItems, contains: $contains, minContains: $minContains, maxContains: $maxContains, minItems: $minItems, maxItems: $maxItems, uniqueItems: $uniqueItems, minimum: $minimum, maximum: $maximum, exclusiveMinimum: $exclusiveMinimum, exclusiveMaximum: $exclusiveMaximum, multipleOf: $multipleOf, minLength: $minLength, maxLength: $maxLength, pattern: $pattern, __absolute_ref__, __absolute_recursive_ref__ } = schema;
    const errors = [];
    if ($recursiveAnchor === true && recursiveAnchor === null) recursiveAnchor = schema;
    if ($recursiveRef === "#") {
        const refSchema = recursiveAnchor === null ? lookup[__absolute_recursive_ref__] : recursiveAnchor;
        const keywordLocation = `${schemaLocation}/$recursiveRef`;
        const result = validate(instance, recursiveAnchor === null ? schema : recursiveAnchor, draft, lookup, shortCircuit, refSchema, instanceLocation, keywordLocation, evaluated);
        if (!result.valid) errors.push({
            instanceLocation,
            keyword: "$recursiveRef",
            keywordLocation,
            error: "A subschema had errors."
        }, ...result.errors);
    }
    if ($ref !== undefined) {
        const uri = __absolute_ref__ || $ref;
        const refSchema = lookup[uri];
        if (refSchema === undefined) {
            let message = `Unresolved $ref "${$ref}".`;
            if (__absolute_ref__ && __absolute_ref__ !== $ref) message += `  Absolute URI "${__absolute_ref__}".`;
            message += `\nKnown schemas:\n- ${Object.keys(lookup).join("\n- ")}`;
            throw new Error(message);
        }
        const keywordLocation = `${schemaLocation}/$ref`;
        const result = validate(instance, refSchema, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation, evaluated);
        if (!result.valid) errors.push({
            instanceLocation,
            keyword: "$ref",
            keywordLocation,
            error: "A subschema had errors."
        }, ...result.errors);
        if (draft === "4" || draft === "7") return {
            valid: errors.length === 0,
            errors
        };
    }
    if (Array.isArray($type)) {
        let length = $type.length;
        let valid = false;
        for(let i = 0; i < length; i++)if (instanceType === $type[i] || $type[i] === "integer" && instanceType === "number" && instance % 1 === 0 && instance === instance) {
            valid = true;
            break;
        }
        if (!valid) errors.push({
            instanceLocation,
            keyword: "type",
            keywordLocation: `${schemaLocation}/type`,
            error: `Instance type "${instanceType}" is invalid. Expected "${$type.join('", "')}".`
        });
    } else if ($type === "integer") {
        if (instanceType !== "number" || instance % 1 || instance !== instance) errors.push({
            instanceLocation,
            keyword: "type",
            keywordLocation: `${schemaLocation}/type`,
            error: `Instance type "${instanceType}" is invalid. Expected "${$type}".`
        });
    } else if ($type !== undefined && instanceType !== $type) errors.push({
        instanceLocation,
        keyword: "type",
        keywordLocation: `${schemaLocation}/type`,
        error: `Instance type "${instanceType}" is invalid. Expected "${$type}".`
    });
    if ($const !== undefined) {
        if (instanceType === "object" || instanceType === "array") {
            if (!(0, _deepCompareStrictJs.deepCompareStrict)(instance, $const)) errors.push({
                instanceLocation,
                keyword: "const",
                keywordLocation: `${schemaLocation}/const`,
                error: `Instance does not match ${JSON.stringify($const)}.`
            });
        } else if (instance !== $const) errors.push({
            instanceLocation,
            keyword: "const",
            keywordLocation: `${schemaLocation}/const`,
            error: `Instance does not match ${JSON.stringify($const)}.`
        });
    }
    if ($enum !== undefined) {
        if (instanceType === "object" || instanceType === "array") {
            if (!$enum.some((value)=>(0, _deepCompareStrictJs.deepCompareStrict)(instance, value))) errors.push({
                instanceLocation,
                keyword: "enum",
                keywordLocation: `${schemaLocation}/enum`,
                error: `Instance does not match any of ${JSON.stringify($enum)}.`
            });
        } else if (!$enum.some((value)=>instance === value)) errors.push({
            instanceLocation,
            keyword: "enum",
            keywordLocation: `${schemaLocation}/enum`,
            error: `Instance does not match any of ${JSON.stringify($enum)}.`
        });
    }
    if ($not !== undefined) {
        const keywordLocation = `${schemaLocation}/not`;
        const result = validate(instance, $not, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation);
        if (result.valid) errors.push({
            instanceLocation,
            keyword: "not",
            keywordLocation,
            error: 'Instance matched "not" schema.'
        });
    }
    let subEvaluateds = [];
    if ($anyOf !== undefined) {
        const keywordLocation = `${schemaLocation}/anyOf`;
        const errorsLength = errors.length;
        let anyValid = false;
        for(let i = 0; i < $anyOf.length; i++){
            const subSchema = $anyOf[i];
            const subEvaluated = Object.create(evaluated);
            const result = validate(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            anyValid = anyValid || result.valid;
            if (result.valid) subEvaluateds.push(subEvaluated);
        }
        if (anyValid) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation,
            keyword: "anyOf",
            keywordLocation,
            error: "Instance does not match any subschemas."
        });
    }
    if ($allOf !== undefined) {
        const keywordLocation = `${schemaLocation}/allOf`;
        const errorsLength = errors.length;
        let allValid = true;
        for(let i = 0; i < $allOf.length; i++){
            const subSchema = $allOf[i];
            const subEvaluated = Object.create(evaluated);
            const result = validate(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            allValid = allValid && result.valid;
            if (result.valid) subEvaluateds.push(subEvaluated);
        }
        if (allValid) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation,
            keyword: "allOf",
            keywordLocation,
            error: `Instance does not match every subschema.`
        });
    }
    if ($oneOf !== undefined) {
        const keywordLocation = `${schemaLocation}/oneOf`;
        const errorsLength = errors.length;
        const matches = $oneOf.filter((subSchema, i)=>{
            const subEvaluated = Object.create(evaluated);
            const result = validate(instance, subSchema, draft, lookup, shortCircuit, $recursiveAnchor === true ? recursiveAnchor : null, instanceLocation, `${keywordLocation}/${i}`, subEvaluated);
            errors.push(...result.errors);
            if (result.valid) subEvaluateds.push(subEvaluated);
            return result.valid;
        }).length;
        if (matches === 1) errors.length = errorsLength;
        else errors.splice(errorsLength, 0, {
            instanceLocation,
            keyword: "oneOf",
            keywordLocation,
            error: `Instance does not match exactly one subschema (${matches} matches).`
        });
    }
    if (instanceType === "object" || instanceType === "array") Object.assign(evaluated, ...subEvaluateds);
    if ($if !== undefined) {
        const keywordLocation = `${schemaLocation}/if`;
        const conditionResult = validate(instance, $if, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, keywordLocation, evaluated).valid;
        if (conditionResult) {
            if ($then !== undefined) {
                const thenResult = validate(instance, $then, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${schemaLocation}/then`, evaluated);
                if (!thenResult.valid) errors.push({
                    instanceLocation,
                    keyword: "if",
                    keywordLocation,
                    error: `Instance does not match "then" schema.`
                }, ...thenResult.errors);
            }
        } else if ($else !== undefined) {
            const elseResult = validate(instance, $else, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${schemaLocation}/else`, evaluated);
            if (!elseResult.valid) errors.push({
                instanceLocation,
                keyword: "if",
                keywordLocation,
                error: `Instance does not match "else" schema.`
            }, ...elseResult.errors);
        }
    }
    if (instanceType === "object") {
        if ($required !== undefined) {
            for (const key of $required)if (!(key in instance)) errors.push({
                instanceLocation,
                keyword: "required",
                keywordLocation: `${schemaLocation}/required`,
                error: `Instance does not have required property "${key}".`
            });
        }
        const keys = Object.keys(instance);
        if ($minProperties !== undefined && keys.length < $minProperties) errors.push({
            instanceLocation,
            keyword: "minProperties",
            keywordLocation: `${schemaLocation}/minProperties`,
            error: `Instance does not have at least ${$minProperties} properties.`
        });
        if ($maxProperties !== undefined && keys.length > $maxProperties) errors.push({
            instanceLocation,
            keyword: "maxProperties",
            keywordLocation: `${schemaLocation}/maxProperties`,
            error: `Instance does not have at least ${$maxProperties} properties.`
        });
        if ($propertyNames !== undefined) {
            const keywordLocation = `${schemaLocation}/propertyNames`;
            for(const key in instance){
                const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                const result = validate(key, $propertyNames, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (!result.valid) errors.push({
                    instanceLocation,
                    keyword: "propertyNames",
                    keywordLocation,
                    error: `Property name "${key}" does not match schema.`
                }, ...result.errors);
            }
        }
        if ($dependentRequired !== undefined) {
            const keywordLocation = `${schemaLocation}/dependantRequired`;
            for(const key in $dependentRequired)if (key in instance) {
                const required = $dependentRequired[key];
                for (const dependantKey of required)if (!(dependantKey in instance)) errors.push({
                    instanceLocation,
                    keyword: "dependentRequired",
                    keywordLocation,
                    error: `Instance has "${key}" but does not have "${dependantKey}".`
                });
            }
        }
        if ($dependentSchemas !== undefined) for(const key in $dependentSchemas){
            const keywordLocation = `${schemaLocation}/dependentSchemas`;
            if (key in instance) {
                const result = validate(instance, $dependentSchemas[key], draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${keywordLocation}/${(0, _pointerJs.encodePointer)(key)}`, evaluated);
                if (!result.valid) errors.push({
                    instanceLocation,
                    keyword: "dependentSchemas",
                    keywordLocation,
                    error: `Instance has "${key}" but does not match dependant schema.`
                }, ...result.errors);
            }
        }
        if ($dependencies !== undefined) {
            const keywordLocation = `${schemaLocation}/dependencies`;
            for(const key in $dependencies)if (key in instance) {
                const propsOrSchema = $dependencies[key];
                if (Array.isArray(propsOrSchema)) {
                    for (const dependantKey of propsOrSchema)if (!(dependantKey in instance)) errors.push({
                        instanceLocation,
                        keyword: "dependencies",
                        keywordLocation,
                        error: `Instance has "${key}" but does not have "${dependantKey}".`
                    });
                } else {
                    const result = validate(instance, propsOrSchema, draft, lookup, shortCircuit, recursiveAnchor, instanceLocation, `${keywordLocation}/${(0, _pointerJs.encodePointer)(key)}`);
                    if (!result.valid) errors.push({
                        instanceLocation,
                        keyword: "dependencies",
                        keywordLocation,
                        error: `Instance has "${key}" but does not match dependant schema.`
                    }, ...result.errors);
                }
            }
        }
        const thisEvaluated = Object.create(null);
        let stop = false;
        if ($properties !== undefined) {
            const keywordLocation = `${schemaLocation}/properties`;
            for(const key in $properties){
                if (!(key in instance)) continue;
                const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                const result = validate(instance[key], $properties[key], draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, `${keywordLocation}/${(0, _pointerJs.encodePointer)(key)}`);
                if (result.valid) evaluated[key] = thisEvaluated[key] = true;
                else {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation,
                        keyword: "properties",
                        keywordLocation,
                        error: `Property "${key}" does not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
        }
        if (!stop && $patternProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/patternProperties`;
            for(const pattern in $patternProperties){
                const regex = new RegExp(pattern, "u");
                const subSchema = $patternProperties[pattern];
                for(const key in instance){
                    if (!regex.test(key)) continue;
                    const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                    const result = validate(instance[key], subSchema, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, `${keywordLocation}/${(0, _pointerJs.encodePointer)(pattern)}`);
                    if (result.valid) evaluated[key] = thisEvaluated[key] = true;
                    else {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation,
                            keyword: "patternProperties",
                            keywordLocation,
                            error: `Property "${key}" matches pattern "${pattern}" but does not match associated schema.`
                        }, ...result.errors);
                    }
                }
            }
        }
        if (!stop && $additionalProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/additionalProperties`;
            for(const key in instance){
                if (thisEvaluated[key]) continue;
                const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                const result = validate(instance[key], $additionalProperties, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (result.valid) evaluated[key] = true;
                else {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation,
                        keyword: "additionalProperties",
                        keywordLocation,
                        error: `Property "${key}" does not match additional properties schema.`
                    }, ...result.errors);
                }
            }
        } else if (!stop && $unevaluatedProperties !== undefined) {
            const keywordLocation = `${schemaLocation}/unevaluatedProperties`;
            for(const key in instance)if (!evaluated[key]) {
                const subInstancePointer = `${instanceLocation}/${(0, _pointerJs.encodePointer)(key)}`;
                const result = validate(instance[key], $unevaluatedProperties, draft, lookup, shortCircuit, recursiveAnchor, subInstancePointer, keywordLocation);
                if (result.valid) evaluated[key] = true;
                else errors.push({
                    instanceLocation,
                    keyword: "unevaluatedProperties",
                    keywordLocation,
                    error: `Property "${key}" does not match unevaluated properties schema.`
                }, ...result.errors);
            }
        }
    } else if (instanceType === "array") {
        if ($maxItems !== undefined && instance.length > $maxItems) errors.push({
            instanceLocation,
            keyword: "maxItems",
            keywordLocation: `${schemaLocation}/maxItems`,
            error: `Array has too many items (${instance.length} > ${$maxItems}).`
        });
        if ($minItems !== undefined && instance.length < $minItems) errors.push({
            instanceLocation,
            keyword: "minItems",
            keywordLocation: `${schemaLocation}/minItems`,
            error: `Array has too few items (${instance.length} < ${$minItems}).`
        });
        const length = instance.length;
        let i = 0;
        let stop = false;
        if ($prefixItems !== undefined) {
            const keywordLocation = `${schemaLocation}/prefixItems`;
            const length2 = Math.min($prefixItems.length, length);
            for(; i < length2; i++){
                const result = validate(instance[i], $prefixItems[i], draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, `${keywordLocation}/${i}`);
                evaluated[i] = true;
                if (!result.valid) {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation,
                        keyword: "prefixItems",
                        keywordLocation,
                        error: `Items did not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
        }
        if ($items !== undefined) {
            const keywordLocation = `${schemaLocation}/items`;
            if (Array.isArray($items)) {
                const length2 = Math.min($items.length, length);
                for(; i < length2; i++){
                    const result = validate(instance[i], $items[i], draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, `${keywordLocation}/${i}`);
                    evaluated[i] = true;
                    if (!result.valid) {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation,
                            keyword: "items",
                            keywordLocation,
                            error: `Items did not match schema.`
                        }, ...result.errors);
                        if (stop) break;
                    }
                }
            } else for(; i < length; i++){
                const result = validate(instance[i], $items, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                evaluated[i] = true;
                if (!result.valid) {
                    stop = shortCircuit;
                    errors.push({
                        instanceLocation,
                        keyword: "items",
                        keywordLocation,
                        error: `Items did not match schema.`
                    }, ...result.errors);
                    if (stop) break;
                }
            }
            if (!stop && $additionalItems !== undefined) {
                const keywordLocation = `${schemaLocation}/additionalItems`;
                for(; i < length; i++){
                    const result = validate(instance[i], $additionalItems, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                    evaluated[i] = true;
                    if (!result.valid) {
                        stop = shortCircuit;
                        errors.push({
                            instanceLocation,
                            keyword: "additionalItems",
                            keywordLocation,
                            error: `Items did not match additional items schema.`
                        }, ...result.errors);
                    }
                }
            }
        }
        if ($contains !== undefined) {
            if (length === 0 && $minContains === undefined) errors.push({
                instanceLocation,
                keyword: "contains",
                keywordLocation: `${schemaLocation}/contains`,
                error: `Array is empty. It must contain at least one item matching the schema.`
            });
            else if ($minContains !== undefined && length < $minContains) errors.push({
                instanceLocation,
                keyword: "minContains",
                keywordLocation: `${schemaLocation}/minContains`,
                error: `Array has less items (${length}) than minContains (${$minContains}).`
            });
            else {
                const keywordLocation = `${schemaLocation}/contains`;
                const errorsLength = errors.length;
                let contained = 0;
                for(let j = 0; j < length; j++){
                    const result = validate(instance[j], $contains, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${j}`, keywordLocation);
                    if (result.valid) {
                        evaluated[j] = true;
                        contained++;
                    } else errors.push(...result.errors);
                }
                if (contained >= ($minContains || 0)) errors.length = errorsLength;
                if ($minContains === undefined && $maxContains === undefined && contained === 0) errors.splice(errorsLength, 0, {
                    instanceLocation,
                    keyword: "contains",
                    keywordLocation,
                    error: `Array does not contain item matching schema.`
                });
                else if ($minContains !== undefined && contained < $minContains) errors.push({
                    instanceLocation,
                    keyword: "minContains",
                    keywordLocation: `${schemaLocation}/minContains`,
                    error: `Array must contain at least ${$minContains} items matching schema. Only ${contained} items were found.`
                });
                else if ($maxContains !== undefined && contained > $maxContains) errors.push({
                    instanceLocation,
                    keyword: "maxContains",
                    keywordLocation: `${schemaLocation}/maxContains`,
                    error: `Array may contain at most ${$maxContains} items matching schema. ${contained} items were found.`
                });
            }
        }
        if (!stop && $unevaluatedItems !== undefined) {
            const keywordLocation = `${schemaLocation}/unevaluatedItems`;
            for(i; i < length; i++){
                if (evaluated[i]) continue;
                const result = validate(instance[i], $unevaluatedItems, draft, lookup, shortCircuit, recursiveAnchor, `${instanceLocation}/${i}`, keywordLocation);
                evaluated[i] = true;
                if (!result.valid) errors.push({
                    instanceLocation,
                    keyword: "unevaluatedItems",
                    keywordLocation,
                    error: `Items did not match unevaluated items schema.`
                }, ...result.errors);
            }
        }
        if ($uniqueItems) for(let j = 0; j < length; j++){
            const a = instance[j];
            const ao = typeof a === "object" && a !== null;
            for(let k = 0; k < length; k++){
                if (j === k) continue;
                const b = instance[k];
                const bo = typeof b === "object" && b !== null;
                if (a === b || ao && bo && (0, _deepCompareStrictJs.deepCompareStrict)(a, b)) {
                    errors.push({
                        instanceLocation,
                        keyword: "uniqueItems",
                        keywordLocation: `${schemaLocation}/uniqueItems`,
                        error: `Duplicate items at indexes ${j} and ${k}.`
                    });
                    j = Number.MAX_SAFE_INTEGER;
                    k = Number.MAX_SAFE_INTEGER;
                }
            }
        }
    } else if (instanceType === "number") {
        if (draft === "4") {
            if ($minimum !== undefined && ($exclusiveMinimum === true && instance <= $minimum || instance < $minimum)) errors.push({
                instanceLocation,
                keyword: "minimum",
                keywordLocation: `${schemaLocation}/minimum`,
                error: `${instance} is less than ${$exclusiveMinimum ? "or equal to " : ""} ${$minimum}.`
            });
            if ($maximum !== undefined && ($exclusiveMaximum === true && instance >= $maximum || instance > $maximum)) errors.push({
                instanceLocation,
                keyword: "maximum",
                keywordLocation: `${schemaLocation}/maximum`,
                error: `${instance} is greater than ${$exclusiveMaximum ? "or equal to " : ""} ${$maximum}.`
            });
        } else {
            if ($minimum !== undefined && instance < $minimum) errors.push({
                instanceLocation,
                keyword: "minimum",
                keywordLocation: `${schemaLocation}/minimum`,
                error: `${instance} is less than ${$minimum}.`
            });
            if ($maximum !== undefined && instance > $maximum) errors.push({
                instanceLocation,
                keyword: "maximum",
                keywordLocation: `${schemaLocation}/maximum`,
                error: `${instance} is greater than ${$maximum}.`
            });
            if ($exclusiveMinimum !== undefined && instance <= $exclusiveMinimum) errors.push({
                instanceLocation,
                keyword: "exclusiveMinimum",
                keywordLocation: `${schemaLocation}/exclusiveMinimum`,
                error: `${instance} is less than ${$exclusiveMinimum}.`
            });
            if ($exclusiveMaximum !== undefined && instance >= $exclusiveMaximum) errors.push({
                instanceLocation,
                keyword: "exclusiveMaximum",
                keywordLocation: `${schemaLocation}/exclusiveMaximum`,
                error: `${instance} is greater than or equal to ${$exclusiveMaximum}.`
            });
        }
        if ($multipleOf !== undefined) {
            const remainder = instance % $multipleOf;
            if (Math.abs(0 - remainder) >= 1.1920929e-7 && Math.abs($multipleOf - remainder) >= 1.1920929e-7) errors.push({
                instanceLocation,
                keyword: "multipleOf",
                keywordLocation: `${schemaLocation}/multipleOf`,
                error: `${instance} is not a multiple of ${$multipleOf}.`
            });
        }
    } else if (instanceType === "string") {
        const length = $minLength === undefined && $maxLength === undefined ? 0 : (0, _ucs2LengthJs.ucs2length)(instance);
        if ($minLength !== undefined && length < $minLength) errors.push({
            instanceLocation,
            keyword: "minLength",
            keywordLocation: `${schemaLocation}/minLength`,
            error: `String is too short (${length} < ${$minLength}).`
        });
        if ($maxLength !== undefined && length > $maxLength) errors.push({
            instanceLocation,
            keyword: "maxLength",
            keywordLocation: `${schemaLocation}/maxLength`,
            error: `String is too long (${length} > ${$maxLength}).`
        });
        if ($pattern !== undefined && !new RegExp($pattern, "u").test(instance)) errors.push({
            instanceLocation,
            keyword: "pattern",
            keywordLocation: `${schemaLocation}/pattern`,
            error: `String does not match pattern.`
        });
        if ($format !== undefined && (0, _formatJs.fastFormat)[$format] && !(0, _formatJs.fastFormat)[$format](instance)) errors.push({
            instanceLocation,
            keyword: "format",
            keywordLocation: `${schemaLocation}/format`,
            error: `String does not match format "${$format}".`
        });
    }
    return {
        valid: errors.length === 0,
        errors
    };
}

},{"./deep-compare-strict.js":"grMEr","./dereference.js":"14NYx","./format.js":"kNQFe","./pointer.js":"5KeDf","./ucs2-length.js":"4Oxoq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6kJbK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Validator", ()=>Validator);
var _dereferenceJs = require("./dereference.js");
var _validateJs = require("./validate.js");
class Validator {
    constructor(schema, draft = "2019-09", shortCircuit = true){
        this.schema = schema;
        this.draft = draft;
        this.shortCircuit = shortCircuit;
        this.lookup = (0, _dereferenceJs.dereference)(schema);
    }
    validate(instance) {
        return (0, _validateJs.validate)(instance, this.schema, this.draft, this.lookup, this.shortCircuit);
    }
    addSchema(schema, id) {
        if (id) schema = {
            ...schema,
            $id: id
        };
        (0, _dereferenceJs.dereference)(schema, this.lookup);
    }
}

},{"./dereference.js":"14NYx","./validate.js":"8kjd6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e6d3r":[function(require,module,exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"writeOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

},{}],"pZ1MA":[function(require,module,exports) {
/**
 * Helper methods that translate custom validation errors into errors that RJSF expects.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Transforms validation errors that the `@cfworker/json-schema` library generates into
 * errors that the RJSF library expects.
 *
 * @param errors - error-like objects produced by the `@cfworker/json-schema` library
 */ parcelHelpers.export(exports, "transformRJSFValidationErrors", ()=>transformRJSFValidationErrors);
/**
 * --------------------------------------------------------------------------------------
 * SECTION NOTE:
 * All code in the following section has been duplicated and modified as needed from
 * the original source.
 *
 * LICENSE:
 * Apache License, Version 2.0 (Apache-2.0)
 * - https://github.com/rjsf-team/react-jsonschema-form/blob/v5.17.1/LICENSE.md
 * - https://www.apache.org/licenses/LICENSE-2.0
 *
 * COPYRIGHT:
 * The original source code is presumed to be the copyrighted works of the `rjsf-team`.
 * No formal copyright notice was posted with the source code at the time this module
 * was created. See: https://github.com/rjsf-team/react-jsonschema-form/tree/5.17.1
 *
 * NOTICE FILE:
 * No `NOTICE` file was posted with the source code at the time this module was created.
 * See: https://github.com/rjsf-team/react-jsonschema-form/tree/5.17.1
 *
 * STATEMENT OF CHANGES:
 * The following code has been converted from TypeScript to JavaScript and formatted
 * using an auto-formatter library.
 * --------------------------------------------------------------------------------------
 */ /**
 * This function processes the `formData` with an optional user contributed `customValidate` function, which receives
 * the form data and an `errorHandler` function that will be used to add custom validation errors for each field. Also
 * supports a `transformErrors` function that will take the raw validation errors, prior to custom validation, and
 * transform them in whatever way it chooses.
 *
 * See: https://github.com/rjsf-team/react-jsonschema-form/blob/v5.17.1/packages/validator-ajv8/src/processRawValidationErrors.ts
 *
 * @param validator - The `ValidatorType` implementation used for the `getDefaultFormState()` call
 * @param rawErrors - The list of raw `ErrorObject`s to process
 * @param formData - The form data to validate
 * @param schema - The schema against which to validate the form data
 * @param [customValidate] - An optional function that is used to perform custom validation
 * @param [transformErrors] - An optional function that is used to transform errors after validation
 * @param [uiSchema] - An optional uiSchema that is passed to `transformErrors` and `customValidate`
 */ parcelHelpers.export(exports, "processRawValidationErrors", ()=>processRawValidationErrors);
var _utils = require("@rjsf/utils");
function transformRJSFValidationErrors(errors = []) {
    // Excludes all generic errors that precede more specific errors.
    // Includes generic errors that are missing a required property.
    // Includes all other errors.
    return errors.filter((err)=>err.instanceLocation !== "#" || err.keyword === "required").map((err)=>{
        return {
            name: err.keyword,
            property: extractFailedProperty(err),
            message: err.error,
            params: err.params || {},
            stack: generateStackMessage(err),
            schemaPath: err.instanceLocation
        };
    });
}
/**
 * Extracts the invalid JSON property where possible from the `@cfworker/json-schema`
 * error format. See: https://www.npmjs.com/package/@cfworker/json-schema
 *
 * @param validationFailure - error-like object containing validation failure data
 */ function extractFailedProperty(validationFailure) {
    const { instanceLocation = "", error, keyword } = validationFailure;
    const locationPrefixRegex = /^#\/?/;
    const normalizedLocation = instanceLocation.replace(locationPrefixRegex, "");
    switch(keyword){
        case "required":
            const propertyRegex = /Instance does not have required property "(.*?)"/;
            const maybe_property = error.match(propertyRegex)?.[1] ?? "";
            return `${normalizedLocation}.${maybe_property}`;
        default:
            return decodeURI(normalizedLocation);
    }
}
/**
 * Transforms values from the `@cfworker/json-schema` data format into a stack message
 * format that RJSF expects.
 *
 * @param validationFailure - error-like object containing validation failure data
 */ function generateStackMessage(validationFailure) {
    const { keywordLocation = "", error: errorMsg } = validationFailure;
    const keywordPrefixRegex = /^#\/?.*required$/;
    const normalizedLocation = keywordLocation.replace(keywordPrefixRegex, "");
    return `${normalizedLocation} ${errorMsg}`.trim();
}
function processRawValidationErrors(validator, rawErrors, formData, schema, customValidate, transformErrors, uiSchema) {
    const { validationError: invalidSchemaError } = rawErrors;
    let errors = transformRJSFValidationErrors(rawErrors.errors, uiSchema);
    if (invalidSchemaError) errors = [
        ...errors,
        {
            stack: invalidSchemaError?.message
        }
    ];
    if (typeof transformErrors === "function") errors = transformErrors(errors, uiSchema);
    let errorSchema = (0, _utils.toErrorSchema)(errors);
    if (invalidSchemaError) errorSchema = {
        ...errorSchema,
        $schema: {
            __errors: [
                invalidSchemaError?.message
            ]
        }
    };
    if (typeof customValidate !== "function") return {
        errors,
        errorSchema
    };
    // Include form data with undefined values, which is required for custom validation.
    const newFormData = (0, _utils.getDefaultFormState)(validator, schema, formData, schema, true);
    const errorHandler = customValidate(newFormData, (0, _utils.createErrorHandler)(newFormData), uiSchema);
    const userErrorSchema = (0, _utils.unwrapErrorHandler)(errorHandler);
    return (0, _utils.validationDataMerge)({
        errors,
        errorSchema
    }, userErrorSchema);
}

},{"@rjsf/utils":"joqWx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"sPLfQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DynamicLookupFieldGroup", ()=>DynamicLookupFieldGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@rjsf/core");
var _coreDefault = parcelHelpers.interopDefault(_core);
var _rxjs = require("rxjs");
var _helpers = require("../../utils/helpers");
var _validator = require("../../utils/json-schema-validator/validator");
const DynamicLookupFieldGroup = ({ attributes, attributesGroupName, requiredFields, submitForm = (0, _rxjs.noop), formActions, onChange, formData })=>{
    if (attributes.amount) attributes.amount.default = (0, _helpers.formatCurrencyInput)(attributes.amount?.default ?? 0);
    const jsonSchema = {
        title: attributesGroupName,
        type: "object",
        required: requiredFields,
        properties: attributes
    };
    const uiSchema = Object.entries(attributes).reduce((acc, cur)=>{
        const [key, form_field_attributes] = cur;
        /*
      The backend has data on whether or not quantity and price (amount) are editable.
      To avoid needing to add a new field to this file every time the backend has the ability to make the field editable or disabled,
      we can dynamically generate a structure like the one below:
      {
        amount: {
          'ui:disabled': Boolean,
        },
        quantity: {
          'ui:disabled': Boolean,
        },
      };
    */ if (form_field_attributes.hasOwnProperty("editable")) {
            const isFieldEditable = form_field_attributes.editable;
            acc[key] = {
                "ui:disabled": !isFieldEditable
            };
        }
        if (key === "quantity" && !form_field_attributes.editable) acc[key] = {
            "ui:widget": "hidden"
        };
        return acc;
    }, {});
    const handleSubmit = ({ formData })=>{
        // Might need to format here
        submitForm(formData);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coreDefault.default), {
        schema: jsonSchema,
        uiSchema: uiSchema,
        validator: (0, _validator.defaultValidator),
        onSubmit: handleSubmit,
        onChange: onChange,
        formData: formData,
        children: formActions
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@rjsf/core":"g03Jy","rxjs":"kbxjh","../../utils/helpers":"epomp","../../utils/json-schema-validator/validator":"dXyR8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ezS18":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DynamicDenominationsFieldGroup", ()=>DynamicDenominationsFieldGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _core = require("@rjsf/core");
var _coreDefault = parcelHelpers.interopDefault(_core);
var _components = require("@thecb/components");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _shared = require("../../state/shared");
var _validator = require("../../utils/json-schema-validator/validator");
const DenominationContainer = (0, _styledComponentsDefault.default)((0, _components.Box))`
  // override rjsf/core styles
  > * {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  input {
    width: 150px;
    margin-bottom: 12px;
  }
  input:last-of-type {
    margin-bottom: 0px;
  }
  label {
    font-weight: normal;
  }
`;
function ObjectFieldTemplate(props) {
    // solely for styling purposes
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DenominationContainer, {
        padding: "16px 0px 0px 16px",
        children: props.properties.map((element)=>{
            return element.content;
        })
    });
}
const DynamicDenominationsFieldGroup = ({ denominationsFormState, setDenominationsFormState })=>{
    const { isLoading, denominations } = (0, _reactRedux.useSelector)((state)=>state.shared);
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        if (!denominations.length) dispatch((0, _shared.fetchDenominationsRequest)());
    }, []);
    const handleChange = (e)=>{
        setDenominationsFormState(e.formData);
    };
    const denominationsJsonSchema = (0, _react.useMemo)(()=>({
            type: "object",
            properties: denominations.reduce((acc, cur)=>{
                acc[cur.name] = {
                    title: cur.formattedValue,
                    type: "number",
                    quantity: 0,
                    denomination_id: cur.id
                };
                return acc;
            }, {})
        }), [
        denominations
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
            size: "100"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coreDefault.default), {
            formData: denominationsFormState,
            onChange: handleChange,
            schema: denominationsJsonSchema,
            validator: (0, _validator.defaultValidator),
            ObjectFieldTemplate: ObjectFieldTemplate,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {})
        })
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-redux":"k6jol","@rjsf/core":"g03Jy","@thecb/components":"g98ma","styled-components":"bkusY","../../state/shared":"h0jLC","../../utils/json-schema-validator/validator":"dXyR8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3U6I5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OPEN_CASH_DRAWER", ()=>OPEN_CASH_DRAWER);
parcelHelpers.export(exports, "openCashDrawer", ()=>openCashDrawer);
const OPEN_CASH_DRAWER = "peripheralDevices/OPEN_CASH_DRAWER";
const openCashDrawer = (payload)=>({
        type: OPEN_CASH_DRAWER,
        payload
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eCCPO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CLOSEOUT_ALERT_BAR_ACTION", ()=>CLOSEOUT_ALERT_BAR_ACTION);
parcelHelpers.export(exports, "closeoutAlertBarAction", ()=>closeoutAlertBarAction);
parcelHelpers.export(exports, "MODAL_ACTION", ()=>MODAL_ACTION);
parcelHelpers.export(exports, "closeoutModalAction", ()=>closeoutModalAction);
parcelHelpers.export(exports, "CLOSEOUT_FORM_ACTION", ()=>CLOSEOUT_FORM_ACTION);
parcelHelpers.export(exports, "closeoutFormAction", ()=>closeoutFormAction);
parcelHelpers.export(exports, "SUBMIT_CLOSEOUT_FORM", ()=>SUBMIT_CLOSEOUT_FORM);
parcelHelpers.export(exports, "submitCloseoutForm", ()=>submitCloseoutForm);
parcelHelpers.export(exports, "FETCH_CURRENT_BATCH_REQUEST", ()=>FETCH_CURRENT_BATCH_REQUEST);
parcelHelpers.export(exports, "fetchCurrentBatch", ()=>fetchCurrentBatch);
parcelHelpers.export(exports, "FETCH_CURRENT_BATCH_SUCCESS", ()=>FETCH_CURRENT_BATCH_SUCCESS);
parcelHelpers.export(exports, "fetchCurrentBatchSuccess", ()=>fetchCurrentBatchSuccess);
parcelHelpers.export(exports, "CREATE_CLOSEOUT_SUCCESS", ()=>CREATE_CLOSEOUT_SUCCESS);
parcelHelpers.export(exports, "createCloseoutSuccess", ()=>createCloseoutSuccess);
parcelHelpers.export(exports, "FETCH_CLOSEOUT_REPORT_REQUEST", ()=>FETCH_CLOSEOUT_REPORT_REQUEST);
parcelHelpers.export(exports, "fetchCloseoutReportRequest", ()=>fetchCloseoutReportRequest);
parcelHelpers.export(exports, "FETCH_CLOSEOUT_REPORT_SUCCESS", ()=>FETCH_CLOSEOUT_REPORT_SUCCESS);
parcelHelpers.export(exports, "fetchCloseoutReportSuccess", ()=>fetchCloseoutReportSuccess);
parcelHelpers.export(exports, "_reducer", ()=>_reducer1);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _modalState = require("../../components/modal/Modal.state");
var _reducer = require("../../state/reducer");
var _nested = require("../../utils/Nested");
var _closeoutForm = require("./CloseoutForm");
const CLOSEOUT_ALERT_BAR_ACTION = "closeout/CLOSEOUT_ALERT_BAR_ACTION";
const closeoutAlertBarAction = _nested.nestedAction(CLOSEOUT_ALERT_BAR_ACTION);
const MODAL_ACTION = "closeout/MODAL_ACTION";
const closeoutModalAction = _nested.nestedAction(MODAL_ACTION);
const CLOSEOUT_FORM_ACTION = "closeout/CLOSEOUT_FORM_ACTION";
const closeoutFormAction = _nested.nestedAction(CLOSEOUT_FORM_ACTION);
const SUBMIT_CLOSEOUT_FORM = "closeout/SUBMIT_CLOSEOUT_FORM";
const submitCloseoutForm = (payload)=>({
        type: SUBMIT_CLOSEOUT_FORM,
        payload
    });
const FETCH_CURRENT_BATCH_REQUEST = "closeout/FETCH_CURRENT_BATCH_REQUEST";
const fetchCurrentBatch = (payload)=>({
        type: FETCH_CURRENT_BATCH_REQUEST,
        payload
    });
const FETCH_CURRENT_BATCH_SUCCESS = "closeout/FETCH_CURRENT_BATCH_SUCCESS";
const fetchCurrentBatchSuccess = (payload)=>({
        type: FETCH_CURRENT_BATCH_SUCCESS,
        payload
    });
const CREATE_CLOSEOUT_SUCCESS = "closeout/CREATE_CLOSEOUT_SUCCESS";
const createCloseoutSuccess = (payload)=>({
        type: CREATE_CLOSEOUT_SUCCESS,
        payload
    });
const FETCH_CLOSEOUT_REPORT_REQUEST = "closeout/FETCH_CLOSEOUT_REPORT_REQUEST";
const fetchCloseoutReportRequest = (payload)=>({
        type: FETCH_CLOSEOUT_REPORT_REQUEST,
        payload
    });
const FETCH_CLOSEOUT_REPORT_SUCCESS = "closeout/FETCH_CLOSEOUT_REPORT_SUCCESS";
const fetchCloseoutReportSuccess = (payload)=>({
        type: FETCH_CLOSEOUT_REPORT_SUCCESS,
        payload
    });
// Default State
const initialState = {
    data: {
        batch: {
            id: "",
            float: "0.00",
            total_cash: "0.00",
            total_check: "0.00",
            total_card: "0.00",
            total_wire_payment: "0.00"
        },
        reports: {}
    },
    error: false,
    isLoading: false
};
const _reducer1 = (state = initialState, { type, payload })=>{
    switch(type){
        case SUBMIT_CLOSEOUT_FORM:
            return {
                ...state,
                isLoading: true
            };
        case FETCH_CURRENT_BATCH_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    batch: {
                        ...payload
                    }
                }
            };
        case FETCH_CLOSEOUT_REPORT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: {
                    ...state.data,
                    reports: payload.reports
                }
            };
        case CREATE_CLOSEOUT_SUCCESS:
        default:
            return state;
    }
};
const cartAlertMessage = {
    heading: "Closeout Page Error",
    text: "Can't closeout with items in cart.",
    variant: "error"
};
const _mapStateToProps = ()=>{
/* 
  this piece of the state tree has been refactored to use useSelector instead, 
  but the Nested states pattern forces this function to exist so the forms, alertBars, and modals can be passed in.
  */ };
const _mapDispatchToProps = (dispatch)=>({
        submitCloseoutForm: (payload)=>dispatch(submitCloseoutForm(payload)),
        fetchCurrentBatch: ()=>dispatch(fetchCurrentBatch()),
        logout: (navigate)=>dispatch((0, _reducer.logout)(navigate)),
        displayCartAlert: ()=>dispatch(closeoutAlertBarAction((0, _alertBarState.replaceAlerts)(cartAlertMessage)))
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer1,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    forms: {
        closeoutForm: {
            ...(0, _closeoutForm.CloseoutForm),
            actionType: CLOSEOUT_FORM_ACTION
        }
    },
    alertBars: {
        closeoutAlertBars: {
            ..._alertBarState,
            actionType: CLOSEOUT_ALERT_BAR_ACTION
        }
    },
    modals: {
        closeout: {
            ..._modalState,
            actionType: MODAL_ACTION
        }
    }
}, "closeout");
// Nested Reducer
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../components/modal/Modal.state":"34xap","../../state/reducer":"aTwKq","../../utils/Nested":"gDQL4","./CloseoutForm":"fSO1r","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fSO1r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseoutForm", ()=>CloseoutForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reduxFreeform = require("redux-freeform");
var _ramda = require("ramda");
var _renderer = require("@react-pdf/renderer");
var _pdfReports = require("../../components/pdf-reports");
var _closeoutFormState = require("./CloseoutForm.state");
var _helpers = require("../../utils/helpers");
var _rxjs = require("rxjs");
var _closeoutModals = require("./CloseoutModals");
var _formBlocks = require("../../components/form-blocks");
var _reactRedux = require("react-redux");
var _constants = require("../../utils/constants");
var _reactRouterDom = require("react-router-dom");
var _peripheralDevices = require("../../state/peripheralDevices");
var _cityvilleLogoBluePng = require("../../static/img/cityville-logo-blue.png");
var _cityvilleLogoBluePngDefault = parcelHelpers.interopDefault(_cityvilleLogoBluePng);
const requireErrors = (error_text)=>({
        [(0, _reduxFreeform.required).error]: error_text
    });
const CloseoutForm = ({ actions, fields, forms, modals, submitCloseoutForm, openModal, toggleModal })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [errors, handleErrors] = (0, _react.useState)(false);
    const [isCashSectionOpen, setCashSectionIsOpen] = (0, _react.useState)(false);
    const [denominationsFormState, setDenominationsFormState] = (0, _react.useState)({});
    const { denominations } = (0, _reactRedux.useSelector)((state)=>state.shared);
    const { uuid, created_at, terminal } = (0, _reactRedux.useSelector)((state)=>state.terminalLogin.terminalSession);
    const { float, total_cash: expectedCashTotal, total_check: totalCheck, total_processed_internally_check: totalProcessedInternallyCheck, total_processed_externally_check: totalProcessedExternallyCheck, total_card: totalCard, total_wire_payment: totalWirePayment } = (0, _reactRedux.useSelector)((state)=>state.closeout.data.batch);
    const { order_items } = (0, _reactRedux.useSelector)((state)=>state.cart.order);
    const { isLoading, data } = (0, _reactRedux.useSelector)((state)=>state.closeout);
    const { clientMetadata: { data: metadata } } = (0, _reactRedux.useSelector)((state)=>state.global);
    const batchOpenDate = new Date(created_at);
    const batchOpenDisplay = `${batchOpenDate.toLocaleDateString()} - ${batchOpenDate.toLocaleTimeString()}`;
    const handleLogout = ()=>{
        localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), (0, _constants.LOGOUT_REASONS).CLOSEOUT.name);
        navigate("/logout");
    };
    (0, _react.useEffect)(()=>{
        actions.fields.float.set((0, _helpers.formatCurrency)(float));
    }, [
        float
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>actions.form.clear();
    }, []);
    const handleInputClick = (event)=>{
        event.stopPropagation();
    };
    const denominationsSum = isCashSectionOpen ? Object.entries(denominationsFormState).reduce((acc, cur)=>{
        const [key, quantity] = cur;
        return acc += quantity * denominations.find((d)=>d.name === key).value || 0;
    }, 0) : parseFloat(fields.cashTotal.rawValue || 0);
    const closeoutTotal = denominationsSum + parseFloat(totalCheck) + parseFloat(totalCard) + parseFloat(totalWirePayment);
    const confirmAmountsBoolean = Boolean(fields.confirmAmounts.rawValue);
    const handleConfirmAmountsCheckboxClick = ()=>{
        actions.fields.confirmAmounts.set(!confirmAmountsBoolean);
    };
    const closeoutIsOutOfBalance = ()=>denominationsSum != expectedCashTotal;
    (0, _react.useEffect)(()=>{
        const lazyLoadPdf = async ()=>{
            const portraitOrLandscapeLogo = await (0, _helpers.getImageOrientation)(metadata?.headerLogoLink ?? (0, _cityvilleLogoBluePngDefault.default));
            // from https://github.com/diegomura/react-pdf/issues/975
            const doc = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdfReports.CloseoutReportDocument), {
                ...data.reports,
                headerImg: metadata?.headerLogoLink,
                portraitOrLandscapeLogo: portraitOrLandscapeLogo
            });
            const asPdf = (0, _renderer.pdf)();
            asPdf.updateContainer(doc);
            const blob = await asPdf.toBlob();
            const objectUrl = window.URL.createObjectURL(blob);
            (0, _helpers.downloadReport)("Closeout", terminal, new Date(), objectUrl);
            handleLogout();
        };
        if (Object.keys(data.reports).length > 0) lazyLoadPdf();
    }, [
        data.reports
    ]);
    const handleSubmit = ()=>{
        const hasDenominations = denominationsFormState && !!denominations.length;
        const reducedDenominationFields = Object.entries(denominationsFormState).reduce((acc, [key, quantity])=>{
            const denomination_id = denominations.find((d)=>d.name === key).id;
            return quantity > 0 ? [
                ...acc,
                {
                    denomination_id,
                    quantity
                }
            ] : acc;
        }, []);
        const denominationsWithValues = hasDenominations ? reducedDenominationFields : [];
        return submitCloseoutForm({
            closing_float: fields.float.rawValue,
            cash_total: denominationsSum,
            closing_note: fields.notes.rawValue,
            denominations: denominationsWithValues
        });
    };
    const handleCloseoutSubmitClick = (0, _components.util).general.generateClickHandler(forms.closeoutForm, ()=>handleErrors(true), closeoutIsOutOfBalance() ? ()=>openModal((0, _closeoutModals.OUT_OF_BALANCE)) : handleSubmit);
    const outOfBalanceModal = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeoutModals.OutOfBalanceModal), {
        modals: modals,
        submit: handleSubmit,
        toggle: toggleModal
    });
    const cashDenominationsDropdownHeading = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        height: "10rem",
        padding: "0 0 0 1.5rem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            justify: "space-between",
            align: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        nowrap: "true",
                        overflow: "visible",
                        childGap: "1rem",
                        justify: "flex-start",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                margin: "",
                                as: "h4",
                                children: "Cash"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                margin: "",
                                as: "span",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                variant: "smallGhost",
                                action: (0, _rxjs.noop),
                                text: isCashSectionOpen ? "Hide Denominations" : "Show Denominations"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "0",
                    children: isCashSectionOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        align: "center",
                        minHeight: "5rem",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                variant: "smallGhost",
                                action: (e)=>{
                                    e.stopPropagation();
                                    setDenominationsFormState({});
                                    actions.form.clear();
                                },
                                text: "Clear count"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                children: (0, _helpers.formatPrice)(denominationsSum)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
                        overflow: "visible",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                            "data-testid": "cash-total-input",
                            extraStyles: `text-align: right; width: 9.5rem; margin-right: .5rem;`,
                            onClick: handleInputClick,
                            labelTextWhenNoError: "",
                            errorMessages: requireErrors("Cash Total Error"),
                            field: fields.cashTotal,
                            errors: fields.errors,
                            fieldActions: actions.fields.cashTotal,
                            labelTextVariant: "p",
                            errorTextVariant: "p"
                        })
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
        padding: "0",
        children: [
            outOfBalanceModal,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                as: "h3",
                margin: "0.25rem 0",
                children: "Batch Details"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                variant: "baseStandard",
                borderRadius: ".25rem",
                padding: "1.5rem",
                background: (0, _components.constants).colors.WHITE,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        justify: "space-between",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                as: "h5",
                                margin: "0 0 .25rem",
                                children: "Open date"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                children: batchOpenDisplay
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        justify: "space-between",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                as: "h5",
                                margin: ".25rem 0",
                                children: "Batch number"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                children: uuid
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        justify: "space-between",
                        align: "center",
                        overflow: "visible",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                as: "h5",
                                margin: ".25rem 0",
                                children: "Float"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                isNum: "true",
                                extraStyles: `text-align: right; width: 9.5rem; margin-right: .25rem;`,
                                "data-testid": "cash-float",
                                labelTextWhenNoError: "",
                                field: fields.float,
                                fieldActions: actions.fields.float,
                                themeValues: {
                                    lineHeight: 0
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        "data-testid": "batch-notes",
                        labelTextWhenNoError: "Batch notes (optional)",
                        field: fields.notes,
                        errors: fields.errors,
                        fieldActions: actions.fields.notes,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                as: "h3",
                margin: "1.5rem 0 .25rem",
                children: "Batch Totals"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                variant: "baseStandard",
                borderRadius: ".25rem",
                padding: "0",
                background: (0, _components.constants).colors.WHITE,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CollapsibleSection), {
                            supportsTouch: false,
                            isOpen: isCashSectionOpen,
                            title: cashDenominationsDropdownHeading,
                            initiallyOpen: false,
                            toggleSection: ()=>setCashSectionIsOpen(!isCashSectionOpen),
                            customTitle: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Motion), {
                                variants: {
                                    open: {
                                        opacity: 1
                                    },
                                    closed: {
                                        opacity: 0
                                    }
                                },
                                initial: "open",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                        background: (0, _components.constants).colors.ATHENS_GREY,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormInputColumn), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.LineItem), {
                                                    description: "Denomination",
                                                    amount: "Amount"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formBlocks.DynamicDenominationsFieldGroup), {
                                                    denominationsFormState: denominationsFormState,
                                                    setDenominationsFormState: setDenominationsFormState
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                        padding: "1.5rem",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                        as: "h5",
                                        children: "Checks"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                        children: (0, _helpers.formatPrice)(totalCheck)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                justify: "space-between",
                                margin: "0.5rem 0 0 0",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                        as: "p",
                                        variant: "small",
                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR,
                                        children: "Physical Checks"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                        variant: "small",
                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR,
                                        children: (0, _helpers.formatPrice)(totalProcessedExternallyCheck)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                justify: "space-between",
                                margin: "0.25rem 0 0 0",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                        as: "p",
                                        variant: "small",
                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR,
                                        children: "Check / ICL Checks"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                        variant: "small",
                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR,
                                        children: (0, _helpers.formatPrice)(totalProcessedInternallyCheck)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "1.5rem",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    as: "h5",
                                    children: "Credit"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    children: (0, _helpers.formatPrice)(totalCard)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "1.5rem",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    as: "h5",
                                    children: "Wire Transfer"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    children: (0, _helpers.formatPrice)(totalWirePayment)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "1.5rem",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    variant: "large",
                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                    children: "Total"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    variant: "large",
                                    "data-testid": "total",
                                    children: (0, _helpers.formatPrice)(closeoutTotal)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                padding: "2rem 0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                        variant: "baseStandard",
                        borderRadius: ".25rem",
                        background: (0, _components.constants).colors.WHITE,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                                id: "confirm-amounts",
                                title: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                    children: "Confirm Amounts"
                                }),
                                name: "Confirm Amounts",
                                checked: confirmAmountsBoolean,
                                onChange: handleConfirmAmountsCheckboxClick
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                margin: ".5rem 2.5rem 0",
                                as: "p",
                                children: "By checking the box above, I confirm the amounts above are accurate."
                            })
                        ]
                    }),
                    errors && Boolean(_ramda.pathOr(false, [
                        "confirmAmounts",
                        "errors",
                        "length"
                    ], fields)) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                        variant: "small",
                        margin: ".5rem 0 0",
                        color: (0, _components.constants).colors.ERROR_COLOR,
                        children: "You must check confirm amounts above to continue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                        text: "Cancel",
                        isLoading: false,
                        variant: "secondary",
                        url: "/pos",
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                text: "Open drawer",
                                isLoading: false,
                                variant: "secondary",
                                action: ()=>dispatch((0, _peripheralDevices.openCashDrawer)({
                                        location
                                    })),
                                textExtraStyles: "font-size: 1rem;"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                id: "submit-closeout-btn",
                                disabled: isLoading || (order_items ? order_items.length > 0 : false),
                                isLoading: isLoading,
                                text: "Closeout",
                                "data-testid": "closeout-cta",
                                action: handleCloseoutSubmitClick,
                                textExtraStyles: "font-size: 1rem;"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
CloseoutForm.reducer = (0, _closeoutFormState.reducer);
CloseoutForm.mapStateToProps = (0, _closeoutFormState.mapStateToProps);
CloseoutForm.mapDispatchToProps = (0, _closeoutFormState.mapDispatchToProps);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","redux-freeform":"1Yc5v","ramda":"JPp0Z","@react-pdf/renderer":"jjqkY","../../components/pdf-reports":"5TB3o","./CloseoutForm.state":"l4dzU","../../utils/helpers":"epomp","rxjs":"kbxjh","./CloseoutModals":"7obpP","../../components/form-blocks":"b6ROU","react-redux":"k6jol","../../utils/constants":"f3A1R","react-router-dom":"hNarb","../../state/peripheralDevices":"3U6I5","../../static/img/cityville-logo-blue.png":"3ed6r","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l4dzU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
const closeoutFormConfig = {
    cashTotal: {
        defaultValue: "0",
        validators: [
            (0, _reduxFreeform.numberGreaterThanOrEqualTo)(0)
        ],
        constraints: [
            (0, _reduxFreeform.numberGreaterThanOrEqualTo)(0)
        ]
    },
    confirmAmounts: {
        defaultValue: false,
        validators: [
            (0, _reduxFreeform.required)()
        ]
    },
    notes: {},
    float: {
        // A default should probably not be hardcoded here
        defaultValue: "0.00",
        constraints: [
            (0, _reduxFreeform.numberGreaterThanOrEqualTo)(0)
        ]
    }
};
const { reducer, mapStateToProps, mapDispatchToProps } = (0, _reduxFreeform.createFormState)(closeoutFormConfig);

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7obpP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OUT_OF_BALANCE", ()=>OUT_OF_BALANCE);
parcelHelpers.export(exports, "OutOfBalanceModal", ()=>OutOfBalanceModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reactRedux = require("react-redux");
const OUT_OF_BALANCE = "OUT_OF_BALANCE";
const OutOfBalanceModal = ({ modals, submit, toggle })=>{
    const { isLoading } = (0, _reactRedux.useSelector)((state)=>state.closeout);
    const body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
            fontSize: "1rem",
            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR,
            children: "Your total is out of balance. If you continue you will closeout out of balance. There is no undoing this action."
        })
    });
    const modalHeaderText = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
        variant: "large",
        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
        color: (0, _components.constants).colors.WHITE,
        children: "Total out of balance"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
        isLoading: isLoading,
        isContinueActionDisabled: isLoading,
        modalHeaderText: modalHeaderText,
        modalBodyText: body,
        modalOpen: modals.closeout.modalIsOpen && modals.closeout.modalId === OUT_OF_BALANCE,
        toggleModal: toggle,
        continueAction: submit,
        cancelAction: toggle,
        cancelButtonText: "Edit totals",
        continueButtonText: "Continue Closeout",
        defaultWrapper: false,
        modalHeaderBg: (0, _components.constants).colors.ERROR_COLOR
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","react-redux":"k6jol","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3ed6r":[function(require,module,exports) {
module.exports = require("e9e472469efcabb").getBundleURL("jLXBE") + "cityville-logo-blue.295fea09.png";

},{"e9e472469efcabb":"gJ0PF"}],"iIK4l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _renderer = require("@react-pdf/renderer");
var _components = require("@thecb/components");
var _publicSansRegularTtf = require("url:../../fonts/Public-Sans-Regular.ttf");
var _publicSansRegularTtfDefault = parcelHelpers.interopDefault(_publicSansRegularTtf);
var _publicSansSemiboldTtf = require("url:../../fonts/Public-Sans-Semibold.ttf");
var _publicSansSemiboldTtfDefault = parcelHelpers.interopDefault(_publicSansSemiboldTtf);
var _publicSansBoldTtf = require("url:../../fonts/Public-Sans-Bold.ttf");
var _publicSansBoldTtfDefault = parcelHelpers.interopDefault(_publicSansBoldTtf);
// https://stackoverflow.com/questions/69088511/how-to-use-custom-font-for-react-pdf-renderer
const PUBLIC_SANS = "Public Sans";
// Font Weight 400 / Regular
(0, _renderer.Font).register({
    family: PUBLIC_SANS,
    src: (0, _publicSansRegularTtfDefault.default)
});
// Font Weight 600 / Semi Bold
(0, _renderer.Font).register({
    family: PUBLIC_SANS,
    src: (0, _publicSansSemiboldTtfDefault.default)
});
// Font Weight 700 / Bold
(0, _renderer.Font).register({
    family: PUBLIC_SANS,
    src: (0, _publicSansBoldTtfDefault.default)
});
const sharedReportStyles = {
    page: {
        fontFamily: PUBLIC_SANS,
        padding: 32,
        fontSize: 8,
        fontWeight: (0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR
    },
    title: {
        fontSize: 16,
        marginBottom: 24,
        fontWeight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD
    },
    agencyHeading: {
        fontWeight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
        fontSize: 10,
        marginBottom: 8
    },
    heading: {
        fontWeight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
        fontSize: 10,
        marginBottom: 8
    },
    lineItem: {
        display: "flex",
        flexDirection: "row",
        marginBottom: 4
    },
    semiBoldText: {
        fontWeight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD
    },
    boldText: {
        fontWeight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD
    },
    largeDividerGrey: {
        width: "100%",
        borderBottom: 1,
        borderColor: (0, _components.constants).colors.GHOST_GREY,
        margin: "16px 0px"
    },
    smallDividerGrey: {
        width: "100%",
        borderBottom: 1,
        borderColor: (0, _components.constants).colors.GHOST_GREY,
        margin: "8px 0px"
    },
    smallDividerBlack: {
        width: "100%",
        borderBottom: 1,
        margin: "8px 0px"
    },
    largeDividerBlack: {
        width: "100%",
        borderBottom: 1,
        marginTop: 16,
        marginBottom: 24
    },
    clientBrandLandscape: {
        position: "absolute",
        top: 0,
        right: 0,
        width: 130
    },
    clientBrandPortrait: {
        position: "absolute",
        top: 0,
        right: 0,
        height: 75
    },
    greyContainer: {
        backgroundColor: (0, _components.constants).colors.ATHENS_GREY,
        padding: "8px",
        fontSize: 8
    },
    flexContainerRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    stack: {
        flexDirection: "column"
    },
    accentBackgroundColor: {
        backgroundColor: (0, _components.constants).colors.COOL_GREY_05
    }
};
exports.default = sharedReportStyles;

},{"@react-pdf/renderer":"jjqkY","@thecb/components":"g98ma","url:../../fonts/Public-Sans-Regular.ttf":"cJONz","url:../../fonts/Public-Sans-Semibold.ttf":"7kXXl","url:../../fonts/Public-Sans-Bold.ttf":"kcpaO","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cJONz":[function(require,module,exports) {
module.exports = require("be2d4d48fa0c58ff").getBundleURL("jLXBE") + "Public-Sans-Regular.904796cb.ttf";

},{"be2d4d48fa0c58ff":"gJ0PF"}],"7kXXl":[function(require,module,exports) {
module.exports = require("99068037457ff021").getBundleURL("jLXBE") + "Public-Sans-Semibold.742c1cf5.ttf";

},{"99068037457ff021":"gJ0PF"}],"kcpaO":[function(require,module,exports) {
module.exports = require("776251511d50a94f").getBundleURL("jLXBE") + "Public-Sans-Bold.60b5b43b.ttf";

},{"776251511d50a94f":"gJ0PF"}],"ildaL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrderReceiptReportDocument", ()=>OrderReceiptReportDocument);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _helpers = require("../../utils/helpers");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _constants = require("../../utils/constants");
var _uuid = require("uuid");
var _cityvilleLogoBluePng = require("../../static/img/cityville-logo-blue.png");
var _cityvilleLogoBluePngDefault = parcelHelpers.interopDefault(_cityvilleLogoBluePng);
var _sharedReportStyles = require("./SharedReportStyles");
var _sharedReportStylesDefault = parcelHelpers.interopDefault(_sharedReportStyles);
const styles = (0, _renderer.StyleSheet).create((0, _sharedReportStylesDefault.default));
const HeadingSection = ({ title, headerImg, portraitOrLandscapeLogo, order })=>{
    const { location_info: { address_1, address_2, city, state, zipcode, phone_number_1, phone_number_2, email }, agencies_info } = order;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Image), {
                style: portraitOrLandscapeLogo === (0, _constants.IMAGE_ORIENTATIONS).PORTRAIT ? styles.clientBrandPortrait : styles.clientBrandLandscape,
                src: headerImg ?? (0, _cityvilleLogoBluePngDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: styles.title,
                children: title
            }),
            agencies_info[0]?.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: styles.agencyHeading,
                children: agencies_info[0]?.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                children: [
                    address_1,
                    address_2 && `, ${address_2}`
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                children: `${city}, ${state} ${zipcode}`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                children: phone_number_1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                children: phone_number_2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                children: email
            })
        ]
    });
};
const OrderDetailsSection = ({ order, order_items, isRefund })=>{
    const { location, terminal, completed_at, id, subtotal, total_service_fees, total_convenience_fees, total, voided_at } = order;
    const isVoided = Boolean(voided_at);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: styles.heading,
                children: "Order Details"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: styles.lineItem,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        style: styles.semiBoldText,
                        children: "Location: "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: location
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: styles.lineItem,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        style: styles.semiBoldText,
                        children: "Terminal: "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: terminal
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: styles.lineItem,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        style: styles.semiBoldText,
                        children: "Order Date: "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: (0, _dayjsDefault.default)(completed_at).format("MM/DD/YYYY hh:mmA")
                    })
                ]
            }),
            isVoided && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: styles.lineItem,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        style: styles.semiBoldText,
                        children: "Voided Date: "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: (0, _dayjsDefault.default)(voided_at).format("MM/DD/YYYY hh:mmA")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: styles.lineItem,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        style: styles.semiBoldText,
                        children: "Order ID: "
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: id
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: styles.greyContainer,
                children: [
                    order_items.map((item, idx)=>{
                        const isLastItem = idx === order_items.length - 1;
                        const receiptVisibleAttributesEntries = Object.entries(item.receipt_visible_attributes);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                            style: styles.flexContainerRow,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                    style: styles.stack,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                                            style: styles.lineItem,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                style: styles.semiBoldText,
                                                children: item.category
                                            })
                                        }),
                                        receiptVisibleAttributesEntries.map((attr, idx)=>{
                                            const isLastAttr = idx === receiptVisibleAttributesEntries.length - 1;
                                            const [key, value] = attr;
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                                                style: {
                                                    marginBottom: !isLastItem && isLastAttr ? 8 : 0
                                                },
                                                children: [
                                                    (0, _helpers.titleCase)(key),
                                                    ": ",
                                                    value
                                                ]
                                            }, `${item.category}-${(0, _uuid.v4)()}`);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                    style: styles.lineItem,
                                    children: [
                                        item.quantity > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            children: `${(0, _helpers.formatPrice)(item.recorded_price)} per x ${item.quantity}`
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            style: {
                                                ...styles.semiBoldText,
                                                textAlign: "right",
                                                width: "100px"
                                            },
                                            children: item.is_negative_amount ? (0, _helpers.formatWithParentheses)((0, _helpers.formatPrice)(item.amount, isRefund)) : (0, _helpers.formatPrice)(item.amount, isRefund)
                                        })
                                    ]
                                })
                            ]
                        }, `${item.category}-${(0, _uuid.v4)()}`);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                        style: styles.smallDividerGrey
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                        style: styles.semiBoldText,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: {
                                    ...styles.flexContainerRow,
                                    marginBottom: total_service_fees > 0 || total_convenience_fees > 0 ? 8 : 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Subtotal: "
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: (0, _helpers.formatPrice)(subtotal, isRefund)
                                    })
                                ]
                            }),
                            total_service_fees > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: styles.flexContainerRow,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Service Fees: "
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: (0, _helpers.formatPrice)(total_service_fees, isRefund)
                                    })
                                ]
                            }),
                            total_convenience_fees > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: styles.flexContainerRow,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Transaction Fee: "
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: (0, _helpers.formatPrice)(total_convenience_fees, isRefund)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                                style: styles.smallDividerGrey
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                style: {
                                    ...styles.flexContainerRow,
                                    ...styles.boldText
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: "Total: "
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                        children: (0, _helpers.formatPrice)(total, isRefund)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const PaymentDetailsSection = ({ filteredTransactions, isRefund })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: styles.heading,
                children: "Payment Details"
            }),
            filteredTransactions.map((t)=>{
                const BankPayment = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: `Bank account ending in ${t.bank_account?.account_number_last_four ?? "****"}`
                    })
                });
                const CardPayment = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: `Card ending in ${t.credit_card?.last_four ?? "****"}`
                    })
                });
                const CashPayment = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: "Cash"
                    })
                });
                const WirePayment = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: "Wire Transfer"
                    })
                });
                const PaymentType = ()=>{
                    switch(t.payment_type){
                        case (0, _constants.PAYMENT_TYPE).CASH_PAYMENT:
                            return CashPayment;
                        case (0, _constants.PAYMENT_TYPE).CARD_PAYMENT:
                            return CardPayment;
                        case (0, _constants.PAYMENT_TYPE).CHECK_PAYMENT:
                            return BankPayment;
                        case (0, _constants.PAYMENT_TYPE).WIRE_PAYMENT:
                            return WirePayment;
                        default:
                            throw new Error("Unhandled Payment Type when generating order receipt PDF");
                    }
                };
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                    style: {
                        marginBottom: 16
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                            style: styles.lineItem,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    style: styles.semiBoldText,
                                    children: "Payment ID: "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    children: t.gateway_payment_id
                                })
                            ]
                        }),
                        t.payer_name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                            style: styles.lineItem,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    style: styles.semiBoldText,
                                    children: "Payer Name: "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    children: t.payer_name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                            style: styles.lineItem,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    style: styles.semiBoldText,
                                    children: "Status: "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    children: (0, _helpers.capitalize)(t.status)
                                })
                            ]
                        }),
                        t.payment_type === (0, _constants.PAYMENT_TYPE).CARD_PAYMENT && t.credit_card?.auth_code && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                            style: styles.lineItem,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    style: styles.semiBoldText,
                                    children: "Auth Code: "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    children: t.credit_card?.auth_code
                                })
                            ]
                        }),
                        t.wire_payment?.name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                            style: styles.lineItem,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    style: styles.semiBoldText,
                                    children: "Name: "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    children: t.wire_payment.name
                                })
                            ]
                        }),
                        t.wire_payment?.effective_date && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                            style: styles.lineItem,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    style: styles.semiBoldText,
                                    children: "Effective Date: "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    children: t.wire_payment.effective_date
                                })
                            ]
                        }),
                        t.wire_payment?.description && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                            style: styles.lineItem,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    style: styles.semiBoldText,
                                    children: "Description: "
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                    style: {
                                        maxWidth: "480px"
                                    },
                                    children: t.wire_payment.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                            style: styles.greyContainer,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                    style: {
                                        ...styles.flexContainerRow,
                                        ...styles.semiBoldText,
                                        marginBottom: t.service_fee > 0 || t.convenience_fee > 0 ? 8 : 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentType, {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                            children: (0, _helpers.formatPrice)(t.amount_processed, isRefund)
                                        })
                                    ]
                                }),
                                t.service_fee > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                            style: {
                                                ...styles.flexContainerRow,
                                                ...styles.semiBoldText
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                    children: "Service Fees: "
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                    children: (0, _helpers.formatPrice)(t.service_fee, isRefund)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                                            style: styles.smallDividerGrey
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                            style: {
                                                ...styles.flexContainerRow,
                                                ...styles.boldText
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                    style: styles.boldText,
                                                    children: "Total: "
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                    children: (0, _helpers.formatPrice)(t.amount_processed + t.service_fee, isRefund)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                t.convenience_fee > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                            style: {
                                                ...styles.flexContainerRow,
                                                ...styles.semiBoldText
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                    children: "Transaction Fee: "
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                    children: (0, _helpers.formatPrice)(t.convenience_fee, isRefund)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                                            style: styles.smallDividerGrey
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                                            style: {
                                                ...styles.flexContainerRow,
                                                ...styles.boldText
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                    style: styles.boldText,
                                                    children: "Total: "
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                                    children: (0, _helpers.formatPrice)(t.amount_processed + t.convenience_fee, isRefund)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, t.id);
            })
        ]
    });
const FooterSection = ({ customFooterText })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: {
            marginTop: "auto"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                children: "Signature"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: styles.smallDividerGrey
            }),
            customFooterText && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: {
                    textAlign: "center",
                    marginTop: 8
                },
                children: customFooterText
            })
        ]
    });
const OrderReceiptReportDocument = ({ headerImg, portraitOrLandscapeLogo, order, order_items, transaction_details })=>{
    const isRefund = !!order.parent_id;
    const includedTransactions = [
        (0, _constants.TRANSACTION_STATUS).SUCCESSFUL,
        (0, _constants.TRANSACTION_STATUS).REFUNDED,
        (0, _constants.TRANSACTION_STATUS).CANCELLED
    ];
    const filteredTransactions = transaction_details.filter((t)=>includedTransactions.includes(t.status));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Document), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Page), {
            style: styles.page,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(HeadingSection, {
                    title: "Receipt",
                    headerImg: headerImg,
                    portraitOrLandscapeLogo: portraitOrLandscapeLogo,
                    order: order
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                    style: styles.largeDividerGrey
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(OrderDetailsSection, {
                    order: order,
                    order_items: order_items,
                    isRefund: isRefund
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                    style: styles.largeDividerGrey
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentDetailsSection, {
                    filteredTransactions: filteredTransactions,
                    isRefund: isRefund
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(FooterSection, {
                    customFooterText: order.agencies_info[0]?.pay_at_message ?? null
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@react-pdf/renderer":"jjqkY","../../utils/helpers":"epomp","dayjs":"4CsUp","../../utils/constants":"f3A1R","uuid":"4vdp3","../../static/img/cityville-logo-blue.png":"3ed6r","./SharedReportStyles":"iIK4l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4vdp3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"bfrTv","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bfrTv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"99RZh","./rng.js":"iKOQN","./stringify.js":"ad2SO","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"99RZh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iKOQN":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ad2SO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"dCpgt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dCpgt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"6Wll2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6Wll2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cJFC9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VoidForm", ()=>VoidForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reduxFreeform = require("redux-freeform");
var _orderDetailsVoidModalState = require("./OrderDetailsVoidModal.state");
var _constants = require("../../utils/constants");
var _helpers = require("../../utils/helpers");
const notesErrors = {
    [(0, _reduxFreeform.hasLength).error]: "Character limit exceeded (250)"
};
const VoidForm = ({ actions, fields, orderContainsCashPayments, transactionsForOrder })=>{
    (0, _react.useEffect)(()=>{
        return ()=>actions.form.clear();
    }, []);
    const totalCashToVoid = (0, _react.useMemo)(()=>transactionsForOrder?.filter((transaction)=>transaction?.payment_type === (0, _constants.PAYMENT_TYPE).CASH_PAYMENT && transaction?.status === (0, _constants.TRANSACTION_STATUS).SUCCESSFUL).reduce((acc, cur)=>acc += cur.amount_processed, 0), [
        transactionsForOrder
    ]);
    const voidText = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
        padding: "0px",
        extraStyles: `text-align: center;`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                variant: "p",
                children: `Are you sure you want to void this order? ${orderContainsCashPayments ? "This order contains cash. To complete this void the below amount of cash will need to be returned." : ""}`
            }),
            orderContainsCashPayments && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                as: "h3",
                margin: "8px 0px 0px 0px",
                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                children: (0, _helpers.formatPrice)(totalCashToVoid)
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormContainer), {
        children: [
            voidText,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                "data-testid": "Notes Test",
                labelTextWhenNoError: "Notes",
                field: fields.notes,
                fieldActions: actions.fields.notes,
                errors: fields.errors,
                errorMessages: notesErrors,
                labelTextVariant: "p",
                errorTextVariant: "p"
            })
        ]
    });
};
VoidForm.reducer = (0, _orderDetailsVoidModalState.voidFormReducer);
VoidForm.mapStateToProps = (0, _orderDetailsVoidModalState.voidFormMapStateToProps);
VoidForm.mapDispatchToProps = (0, _orderDetailsVoidModalState.voidFormMapDispatchToProps);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","redux-freeform":"1Yc5v","./OrderDetailsVoidModal.state":"hKVnh","../../utils/constants":"f3A1R","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hKVnh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "voidFormReducer", ()=>voidFormReducer);
parcelHelpers.export(exports, "voidFormMapStateToProps", ()=>voidFormMapStateToProps);
parcelHelpers.export(exports, "voidFormMapDispatchToProps", ()=>voidFormMapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
const voidFormConfig = {
    notes: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.hasLength)(0, 250)
        ]
    }
};
const { reducer: voidFormReducer, mapStateToProps: voidFormMapStateToProps, mapDispatchToProps: voidFormMapDispatchToProps } = (0, _reduxFreeform.createFormState)(voidFormConfig);

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dMVt7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReturnForm", ()=>ReturnForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reduxFreeform = require("redux-freeform");
var _orderDetailsReturnModalState = require("./OrderDetailsReturnModal.state");
const notesErrors = {
    [(0, _reduxFreeform.hasLength).error]: "Character limit exceeded (250)"
};
const ReturnForm = ({ actions, fields })=>{
    (0, _react.useEffect)(()=>{
        return ()=>actions.form.clear();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormContainer), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                children: "Are you sure you want to refund this order?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                "data-testid": "Notes Test",
                labelTextWhenNoError: "Notes",
                field: fields.notes,
                fieldActions: actions.fields.notes,
                errors: fields.errors,
                errorMessages: notesErrors,
                labelTextVariant: "p",
                errorTextVariant: "p"
            })
        ]
    });
};
ReturnForm.reducer = (0, _orderDetailsReturnModalState.returnFormReducer);
ReturnForm.mapStateToProps = (0, _orderDetailsReturnModalState.returnFormMapStateToProps);
ReturnForm.mapDispatchToProps = (0, _orderDetailsReturnModalState.returnFormMapDispatchToProps);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","redux-freeform":"1Yc5v","./OrderDetailsReturnModal.state":"1X8fb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1X8fb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "returnFormReducer", ()=>returnFormReducer);
parcelHelpers.export(exports, "returnFormMapStateToProps", ()=>returnFormMapStateToProps);
parcelHelpers.export(exports, "returnFormMapDispatchToProps", ()=>returnFormMapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
const returnFormConfig = {
    notes: {
        defaultValue: "",
        validators: [
            (0, _reduxFreeform.hasLength)(0, 250)
        ]
    }
};
const { reducer: returnFormReducer, mapStateToProps: returnFormMapStateToProps, mapDispatchToProps: returnFormMapDispatchToProps } = (0, _reduxFreeform.createFormState)(returnFormConfig);

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9G1FW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _paymentDetails = require("./PaymentDetails");
var _paymentDetailsDefault = parcelHelpers.interopDefault(_paymentDetails);
exports.default = (0, _paymentDetailsDefault.default);

},{"./PaymentDetails":"8IOfJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8IOfJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _paymentDetailsThemeJs = require("./PaymentDetails.theme.js");
var _rxjs = require("rxjs");
var _components = require("@thecb/components");
var _lineItemGrid = require("../line-item-grid");
var _lineItemGridDefault = parcelHelpers.interopDefault(_lineItemGrid);
var _reactRedux = require("react-redux");
var _paymentDetailsStateJs = require("./PaymentDetails.state.js");
var _helpers = require("../../utils/helpers");
const { theme: { themeComponent } } = (0, _components.util);
const PaymentDetailsContent = ({ lineItems, feeElems, subtotal, themeValues, hasVoidablePaymentsSection, voidableTransactionDetails, voidableAmountPaid, partialVoidAction, serviceFees, convenienceFees })=>{
    const amountPaid = [
        voidableAmountPaid,
        serviceFees,
        convenienceFees
    ].filter(Boolean).reduce((total, fee)=>total + fee, 0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
        childGap: "16px",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lineItemGridDefault.default), {
                lineItems: lineItems
            }),
            hasVoidablePaymentsSection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                background: (0, _components.constants).colors.ATHENS_GREY,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        variant: "p",
                        color: themeValues.text,
                        weight: "400",
                        fontSize: "1rem",
                        children: "Paid"
                    }),
                    voidableTransactionDetails.map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            justify: "space-between",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                    padding: "0",
                                    align: "center",
                                    extraStyles: `font-size: 14px;`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                            padding: "0",
                                            children: t.voidText
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                            variant: "ghost",
                                            action: ()=>partialVoidAction(t),
                                            text: "Void",
                                            padding: "0",
                                            extraStyles: `
                    min-width: 65px; 
                    margin: 0px;
                    min-height: 0px;
                  `,
                                            textExtraStyles: `font-weight: ${(0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR}; font-size: 1rem;`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                    padding: "0",
                                    children: (0, _components.util).general.displayCurrency(t.amount_processed)
                                }, t.id)
                            ]
                        }, t.id)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "16px 0px",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {})
                    }),
                    !!serviceFees && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                        id: "service-fees",
                        padding: "0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.LabeledAmount), {
                                extraStyles: `font-weight: ${(0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR}; font-size: 14px;`,
                                label: "Service Fees",
                                amount: (0, _components.util).general.displayCurrency(serviceFees)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                padding: "16px 0px",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {})
                            })
                        ]
                    }),
                    !!convenienceFees && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                        id: "convenience-fees",
                        padding: "0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.LabeledAmount), {
                                extraStyles: `font-weight: ${(0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR}; font-size: 14px;`,
                                label: "Transaction Fee",
                                amount: (0, _components.util).general.displayCurrency(convenienceFees)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                padding: "16px 0px",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.LabeledAmount), {
                        extraStyles: `font-weight: ${(0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR}; font-size: 14px;`,
                        label: "Amount Paid",
                        amount: (0, _components.util).general.displayCurrency(amountPaid)
                    })
                ]
            }),
            !hasVoidablePaymentsSection && !!lineItems.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}) // avoids duplicate dividers -> case of voidable payment section, that acts as divider
            ,
            subtotal ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                        padding: "0.5rem 0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.LabeledAmount), {
                                variant: themeValues.labeledAmountSubtotal,
                                label: "Subtotal",
                                amount: (0, _components.util).general.displayCurrency(subtotal)
                            }),
                            feeElems
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {})
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {})
        ]
    });
};
const Collapsible = ({ content, title, supportsTouch, isExpanded, dispatch })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CollapsibleSection), {
        isMobile: true,
        supportsTouch: supportsTouch,
        isOpen: isExpanded,
        title: title,
        toggleSection: ()=>dispatch((0, _paymentDetailsStateJs.toggleExpanded)()),
        customTitle: true,
        name: "Collapsed Payment Details",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Motion), {
            variants: {
                open: {
                    opacity: 1
                },
                closed: {
                    opacity: 0
                }
            },
            positionTransition: true,
            initial: false,
            children: content
        })
    });
const NonCollapsible = ({ title, content })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
        children: [
            title,
            content
        ]
    });
const BottomSection = ({ hasVoidablePaymentsSection, remainingBalance, total, isExpanded, isCollapsible })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isCollapsible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "8px 0"
                    }),
                    (!isCollapsible || !isExpanded) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                padding: "8px 0px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                justify: "space-between",
                align: "center",
                id: "payment-details-bottom-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0 8px 0 0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1.25rem",
                            extraStyles: `font-weight: ${(0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD};`,
                            children: hasVoidablePaymentsSection ? "Remaining amount due" : "Total"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0 8px 0 0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1.25rem",
                            extraStyles: `font-weight: ${(0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD};`,
                            children: (0, _components.util).general.displayCurrency(typeof remainingBalance === "number" ? remainingBalance : total)
                        })
                    })
                ]
            })
        ]
    });
const PaymentDetails = ({ lineItems: _lineItems, fees: _fees, subtotal, total, hideTitle = false, titleText = "Payment Details", collapsibleOnMobile = true, isMobile, supportsTouch, themeValues, // partial void section (optional)
hasVoidablePaymentsSection = false, voidableTransactionDetails = [], partialVoidAction = (0, _rxjs.noop), voidableAmountPaid = 0, remainingBalance = false, // end partial void section
serviceFees, convenienceFees })=>{
    const isExpanded = (0, _reactRedux.useSelector)((state)=>state.paymentDetails.isExpanded);
    const dispatch = (0, _reactRedux.useDispatch)();
    const fees = _fees.filter((fee)=>fee.amount > 0).map(({ amount, ...rest })=>({
            ...rest,
            amount: (0, _components.util).general.displayCurrency(amount)
        }));
    const lineItems = _lineItems.map(({ amount, is_negative_amount, ...rest })=>({
            ...rest,
            amount: is_negative_amount ? (0, _helpers.formatWithParentheses)((0, _components.util).general.displayCurrency(amount)) : (0, _components.util).general.displayCurrency(amount)
        }));
    const isCollapsible = isMobile && collapsibleOnMobile;
    const feeElems = fees.map((fee)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "4px 0"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.LabeledAmount), {
                    variant: themeValues.labeledAmountSubtotal,
                    ...fee
                }, fee.label)
            ]
        }, fee.label));
    const content = isCollapsible ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
        childGap: "0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "4.5px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "8px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentDetailsContent, {
                lineItems,
                fees,
                subtotal,
                themeValues,
                hasVoidablePaymentsSection,
                voidableTransactionDetails,
                voidableAmountPaid,
                partialVoidAction,
                serviceFees,
                convenienceFees
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentDetailsContent, {
        lineItems,
        feeElems,
        subtotal,
        themeValues,
        hasVoidablePaymentsSection,
        voidableTransactionDetails,
        voidableAmountPaid,
        partialVoidAction,
        serviceFees,
        convenienceFees
    });
    const title = hideTitle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {}) : isCollapsible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "none",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
            as: "h1",
            extraStyles: `font-size: 1.375rem;`,
            id: "payment-details-title",
            children: titleText
        })
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
        as: "h1",
        extraStyles: `font-size: 1.375rem;`,
        id: "payment-details-title",
        children: titleText
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isCollapsible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Collapsible, {
                title,
                content,
                isExpanded,
                isMobile,
                supportsTouch,
                dispatch
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(NonCollapsible, {
                title,
                content
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(BottomSection, {
                hasVoidablePaymentsSection,
                remainingBalance,
                total,
                isExpanded,
                isCollapsible
            })
        ]
    });
};
exports.default = themeComponent(PaymentDetails, "PaymentDetails", (0, _paymentDetailsThemeJs.fallbackValues), "default");

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","./PaymentDetails.theme.js":"cEMIV","rxjs":"kbxjh","@thecb/components":"g98ma","../line-item-grid":"36a0J","react-redux":"k6jol","./PaymentDetails.state.js":"9ORuF","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cEMIV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fallbackValues", ()=>fallbackValues);
const backgroundColor = {
    default: "transparent",
    small: "transparent"
};
const lineItem = {
    default: "default",
    small: "small"
};
const labeledAmountSubtotal = {
    default: "pL",
    small: "pS"
};
const labeledAmountTotal = {
    default: "h6",
    small: "p"
};
const fallbackValues = {
    backgroundColor,
    lineItem,
    labeledAmountSubtotal,
    labeledAmountTotal
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"36a0J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lineItemGrid = require("./LineItemGrid");
var _lineItemGridDefault = parcelHelpers.interopDefault(_lineItemGrid);
exports.default = (0, _lineItemGridDefault.default);

},{"./LineItemGrid":"h0KkP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h0KkP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _components = require("@thecb/components");
const GridContainer = (0, _styledComponentsDefault.default).div`
  display: grid;
  grid-template-columns: fit-content(60%) 1fr 2fr;
  grid-gap: 16px;

  // Right align Quantity and Amount columns
  text-align: right;

  // Left align Item column
  div:nth-child(3n - 2) {
    text-align: left;
  }

  p {
    margin: 0px;
  }
`;
const LineItemGrid = ({ lineItems })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(GridContainer, {
        id: "line-items-container",
        children: lineItems.map((lineItem, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                        padding: "0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                as: "p",
                                fontSize: "p",
                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                children: lineItem.description
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                as: "p",
                                fontSize: "p",
                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_REGULAR,
                                children: lineItem.subDescription
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        as: "p",
                        fontSize: "p",
                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                        children: `x ${lineItem.quantity}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        as: "p",
                        fontSize: "p",
                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                        children: lineItem.amount
                    })
                ]
            }, `li-${index}`))
    });
exports.default = LineItemGrid;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","styled-components":"bkusY","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9ORuF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toggleExpanded", ()=>toggleExpanded);
parcelHelpers.export(exports, "reducer", ()=>reducer);
const initialState = {
    isExpanded: true
};
// Action Type
const TOGGLE_EXPANDED = "TOGGLE_EXPANDED";
const toggleExpanded = ()=>({
        type: TOGGLE_EXPANDED
    });
const reducer = (state = initialState, action)=>{
    switch(action.type){
        case TOGGLE_EXPANDED:
            return {
                ...state,
                isExpanded: !state.isExpanded
            };
        default:
            return state;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5HCzl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
var _ramda = require("ramda");
/*
 * ACTION CREATORS & TYPES
 */ // INITIAL STATE OBJECT
const initialState = {};
const reducer = (state = initialState, { type/* payload */  })=>{
    type;
    return state;
};
const mapStateToProps = (state)=>({
        orderItems: _ramda.pathOr([], [
            "cart",
            "order",
            "order_items"
        ], state),
        isLoading: _ramda.pathOr(false, [
            "cart",
            "fetching"
        ], state)
    });

},{"ramda":"JPp0Z","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aD416":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _alertBar = require("./AlertBar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
exports.default = (0, _alertBarDefault.default);

},{"./AlertBar":"fwCei","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"baGdo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MagtekSwipeCardModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reactRedux = require("react-redux");
var _checkoutState = require("../checkout/Checkout.state");
var _checkout = require("./Checkout");
var _reactRouterDom = require("react-router-dom");
function MagtekSwipeCardModal({ fields, modals, actions }) {
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const { serviceFeeForCurrentAmount, convenienceFee } = (0, _reactRedux.useSelector)((state)=>state.checkout);
    let payload = (0, _react.useRef)("");
    const isMagtekSwipe = (str)=>str.slice(0, 2) === "%B";
    const doneTyping = ()=>{
        if (isMagtekSwipe(payload.current)) {
            dispatch((0, _checkoutState.initiatePayment)({
                amount_given: Number(fields.amount.rawValue),
                payment_tender_type: "card",
                full_track_data: payload.current,
                service_fee: serviceFeeForCurrentAmount,
                convenience_fee: convenienceFee,
                navigate,
                location
            }));
            actions.modals.checkoutModal.closeModal();
        }
        payload.current = "";
    };
    const detectKeyDown = (e)=>{
        e.preventDefault();
        if (e.key !== "Shift") payload.current += e.key;
    };
    const detectKeyUp = (e)=>{
        e.preventDefault();
        if (e.key === "Enter") doneTyping();
    };
    /* 
  In case we want to implement visual indicators within the modal that the card swipe will work.

  const onFocus = () => {};
  const onBlur = () => {};
  */ (0, _react.useEffect)(()=>{
        if (modals.checkoutModal.modalIsOpen) {
            document.addEventListener("keydown", detectKeyDown);
            document.addEventListener("keyup", detectKeyUp);
        /*
      window.addEventListener('focus', onFocus);
      window.addEventListener('blur', onBlur);
      */ }
        return ()=>{
            document.removeEventListener("keydown", detectKeyDown);
            document.removeEventListener("keyup", detectKeyUp);
        /*
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
      */ };
    }, [
        modals.checkoutModal.modalIsOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
        modalHeaderText: "Swipe Card",
        defaultWrapper: false,
        onlyCloseButton: true,
        modalOpen: modals.checkoutModal.modalIsOpen && modals.checkoutModal.modalId === (0, _checkout.MAGTEK_SWIPE_CARD_MODAL),
        hideModal: actions.modals.checkoutModal.closeModal,
        onExit: (0, _components.util).general.noop,
        closeButtonText: "Cancel",
        modalBodyText: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
            intrinsic: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                variant: "p",
                children: "Please swipe the card to continue."
            })
        })
    });
}

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","react-redux":"k6jol","../checkout/Checkout.state":"4E8nR","./Checkout":"tL9YH","react-router-dom":"hNarb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cec0Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _checkoutState = require("../../pages/checkout/Checkout.state");
const usePostVisitId = (order, dispatch)=>(0, _react.useEffect)(()=>{
        // Create a visit ID via POST request if an order_id exists in state
        if (order?.order_id && dispatch) dispatch((0, _checkoutState.initiatePostVisitId)({
            order_id: order.order_id
        }));
    }, [
        order?.order_id,
        dispatch
    ]);
exports.default = usePostVisitId;

},{"react":"d8NEQ","../../pages/checkout/Checkout.state":"4E8nR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"uxYqN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmtFilterContainer", ()=>(0, _amtFilterContainerDefault.default));
parcelHelpers.export(exports, "DateFilterContainer", ()=>(0, _dateFilterContainerDefault.default));
parcelHelpers.export(exports, "SelectContainer", ()=>(0, _selectContainerDefault.default));
parcelHelpers.export(exports, "HalfWidthFieldWrapper", ()=>(0, _halfWidthFieldWrapperDefault.default));
var _amtFilterContainer = require("./Filters/AmtFilterContainer");
var _amtFilterContainerDefault = parcelHelpers.interopDefault(_amtFilterContainer);
var _dateFilterContainer = require("./Filters/DateFilterContainer");
var _dateFilterContainerDefault = parcelHelpers.interopDefault(_dateFilterContainer);
var _selectContainer = require("./Filters/SelectContainer");
var _selectContainerDefault = parcelHelpers.interopDefault(_selectContainer);
var _halfWidthFieldWrapper = require("./HalfWidthFieldWrapper");
var _halfWidthFieldWrapperDefault = parcelHelpers.interopDefault(_halfWidthFieldWrapper);

},{"./Filters/AmtFilterContainer":"94L40","./Filters/DateFilterContainer":"97XLc","./Filters/SelectContainer":"bL2Fd","./HalfWidthFieldWrapper":"8jAJP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"94L40":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const AmtContainer = (0, _styledComponentsDefault.default).div`
  width: 12rem;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;
exports.default = AmtContainer;

},{"styled-components":"bkusY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"97XLc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _components = require("@thecb/components");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const DateFilterContainer = (0, _styledComponentsDefault.default).div`
  width: ${(props)=>props.fullWidth ? "100%" : "12rem"};
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
  input {
    // have ReactDate input match styles from FormInput CB component
    border: 1px solid
      ${(props)=>props.$hasError ? (0, _components.constants).colors.ERROR_COLOR : (0, _components.constants).colors.STORM_GREY};
    border-radius: 2px;
    height: 48px;
    width: 100%;
    padding: 1rem;
    min-width: 100px;
    margin: 0;
    box-sizing: border-box;
    position: relative;
    font-size: 1.1rem;
    font-family: Public Sans;
    line-height: 2rem;
    font-weight: 400;
    background-color: ${(0, _components.constants).colors.WHITE};
    color: ${(0, _components.constants).colors.MINESHAFT_GREY};
    box-shadow: none;
    -webkit-transition: background 0.3s ease;
    transition: background 0.3s ease;
    :focus {
      outline: 3px solid ${(0, _components.constants).colors.ROYAL_BLUE};
      outline-offset: 2px;
    }
  }
`;
exports.default = DateFilterContainer;

},{"@thecb/components":"g98ma","styled-components":"bkusY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bL2Fd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const SelectContainer = (0, _styledComponentsDefault.default).div`
  position: relative;
  width: 9.55rem;
  & input {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;
exports.default = SelectContainer;

},{"styled-components":"bkusY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8jAJP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const HalfWidthFieldWrapper = (0, _styledComponentsDefault.default).div`
  display: flex;
  justify-content: space-between;
  > * {
    width: calc(50% - 8px);
  }
`;
exports.default = HalfWidthFieldWrapper;

},{"styled-components":"bkusY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3rfTN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requireErrors", ()=>requireErrors);
parcelHelpers.export(exports, "paymentAmountErrors", ()=>paymentAmountErrors);
var _reduxFreeform = require("redux-freeform");
const requireErrors = (error_text)=>({
        [(0, _reduxFreeform.required).error]: error_text
    });
const paymentAmountErrors = {
    [(0, _reduxFreeform.required).error]: "Payment amount is required",
    [(0, _reduxFreeform.numberGreaterThan).error]: "Your payment must be more than $0.00",
    [(0, _reduxFreeform.numberGreaterThanOrEqualTo).error]: "Amount should be equal to or greater than order total"
};

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"b6IqT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxFreeform = require("redux-freeform");
var _components = require("@thecb/components");
var _helpers = require("../../../utils/helpers");
var _checkoutFormState = require("../CheckoutForm.state");
var _reactRedux = require("react-redux");
var _checkoutState = require("../Checkout.state");
var _checkout = require("../Checkout");
var _constants = require("../../../utils/constants");
var _reactRouterDom = require("react-router-dom");
var _sharedConstants = require("./shared-constants");
const ACCOUNT_NUMBER_FIELD = "account_number";
const CHECK_NUMBER_FIELD = "check_number";
const ROUTING_NUMBER_FIELD = "routing_number";
const routingNumberErrorMessages = {
    [(0, _reduxFreeform.required).error]: "Routing Number is required",
    [(0, _reduxFreeform.isAmericanOrCanadianRoutingNumber).error]: "Routing Number format is invalid"
};
const checkNumberErrorMessages = {
    [(0, _reduxFreeform.required).error]: "Check Number is required",
    [(0, _reduxFreeform.hasLength).error]: "Check Number should be between 3 and 15 characters"
};
const checkSubmissionTypeRadioGroupConfig = [
    {
        id: "check-reader",
        value: "Check reader",
        labelText: "Check Reader"
    },
    {
        id: "manual-entry",
        value: "Manual entry",
        labelText: "Manual Entry"
    }
];
const accountTypeRadioGroupConfig = [
    {
        id: "checking",
        value: "checking",
        labelText: "Checking"
    },
    {
        id: "savings",
        value: "savings",
        labelText: "Savings"
    }
];
const checkTypeRadioGroupConfig = [
    {
        id: (0, _constants.CHECK_TYPE).PERSONAL,
        value: (0, _constants.CHECK_TYPE).PERSONAL,
        labelText: "Personal Check"
    },
    {
        id: (0, _constants.CHECK_TYPE).BUSINESS,
        value: (0, _constants.CHECK_TYPE).BUSINESS,
        labelText: "Business Check"
    },
    {
        id: (0, _constants.CHECK_TYPE).MONEY_ORDER,
        value: (0, _constants.CHECK_TYPE).MONEY_ORDER,
        labelText: "Money Order"
    },
    {
        id: (0, _constants.CHECK_TYPE).CASHIERS_CHECK,
        value: (0, _constants.CHECK_TYPE).CASHIERS_CHECK,
        labelText: "Cashier's Check"
    }
];
let CheckCheckoutForm = ({ actions, fields, openProcessingModal, makePayment, remainingBalance, processBtnText, splitTenderAllowed })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const { isLoading, isCheckProcessing, isPollingForCheckResponse } = (0, _reactRedux.useSelector)((state)=>state.checkout);
    const [errors, handleErrors] = (0, _react.useState)(false);
    const isManualEntrySelected = fields.submission_type.rawValue === "Manual entry";
    const isPersonalCheck = fields.check_type.rawValue === (0, _constants.CHECK_TYPE).PERSONAL;
    const isBusinessCheck = fields.check_type.rawValue === (0, _constants.CHECK_TYPE).BUSINESS;
    (0, _react.useEffect)(()=>{
        if (remainingBalance) actions.fields.amount.set((0, _helpers.formatCurrencyInput)(remainingBalance));
    }, [
        remainingBalance
    ]);
    const handleCheckSubmit = (0, _components.util).general.generateClickHandler({
        fields
    }, ()=>handleErrors(true), ()=>{
        const payload = {
            amount_given: Number(fields.amount.rawValue),
            first_name: fields.first_name.rawValue,
            last_name: fields.last_name.rawValue,
            check_type: fields.check_type.rawValue,
            submission_type: fields.submission_type.rawValue,
            payment_tender_type: (0, _constants.CHECK),
            account_type: fields.account_type.rawValue,
            ...isBusinessCheck && {
                company_name: fields.company_name.rawValue
            },
            ...isManualEntrySelected && {
                check_number: fields.check_number.rawValue,
                routing_number: fields.routing_number.rawValue,
                account_number: fields.account_number.rawValue,
                isManualEntry: true
            }
        };
        if (isManualEntrySelected) {
            openProcessingModal((0, _checkout.PROCESSING_MODAL));
            makePayment({
                ...payload,
                navigate,
                location
            });
        } else dispatch((0, _checkoutState.initiateCheckScan)({
            ...payload,
            navigate,
            location
        }));
    });
    const resetFieldValueIfDirty = (field)=>{
        if (fields && fields[field]?.dirty) actions.fields[field].set("");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
        padding: "21px",
        as: "form",
        onSubmit: handleCheckSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                disabled: !splitTenderAllowed,
                id: "check-payment-amt",
                type: "number",
                labelTextWhenNoError: "Payment Amount",
                errorMessages: (0, _sharedConstants.paymentAmountErrors),
                field: fields.amount,
                errors: fields.errors,
                fieldActions: actions.fields.amount,
                labelTextVariant: "p",
                errorTextVariant: "p"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                labelTextWhenNoError: "First Name",
                errorMessages: (0, _sharedConstants.requireErrors)("First Name is required"),
                field: fields.first_name,
                showErrors: errors,
                fieldActions: actions.fields.first_name,
                labelTextVariant: "p",
                errorTextVariant: "p"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                labelTextWhenNoError: "Last Name",
                errorMessages: (0, _sharedConstants.requireErrors)("Last Name is required"),
                field: fields.last_name,
                showErrors: errors,
                fieldActions: actions.fields.last_name,
                labelTextVariant: "p",
                errorTextVariant: "p"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                fontSize: "1.25em",
                children: "Check Information"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.RadioGroup), {
                field: fields.submission_type,
                fieldActions: actions.fields.submission_type,
                groupName: "submission-type",
                headingText: "Submission Type",
                config: checkSubmissionTypeRadioGroupConfig,
                extraStyles: `margin-bottom: 8px;`,
                headingFontSize: "1rem"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.RadioGroup), {
                handleChange: (e)=>{
                    if (e.currentTarget.getAttribute("name")) {
                        // clear account/routing number fields on check type change
                        resetFieldValueIfDirty(ACCOUNT_NUMBER_FIELD);
                        resetFieldValueIfDirty(CHECK_NUMBER_FIELD);
                        resetFieldValueIfDirty(ROUTING_NUMBER_FIELD);
                        resetFieldValueIfDirty((0, _constants.COMPANY_NAME_FIELD));
                    }
                },
                field: fields.check_type,
                fieldActions: actions.fields.check_type,
                groupName: "check-type",
                headingText: "Check Type",
                config: checkTypeRadioGroupConfig,
                extraStyles: `margin-bottom: 8px;`,
                headingFontSize: "1rem"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                padding: "16px 0 0",
                children: [
                    isBusinessCheck && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        labelTextWhenNoError: "Business Name",
                        field: fields.company_name,
                        errors: fields.errors,
                        showErrors: errors,
                        fieldActions: actions.fields.company_name,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    }),
                    isManualEntrySelected && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            isPersonalCheck && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.RadioGroup), {
                                field: fields.account_type,
                                fieldActions: actions.fields.account_type,
                                groupName: "account-type",
                                headingText: "Account Type",
                                config: accountTypeRadioGroupConfig,
                                extraStyles: `margin-bottom: 8px;`,
                                headingFontSize: "1rem"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                labelTextWhenNoError: "Check Number",
                                errorMessages: checkNumberErrorMessages,
                                field: fields.check_number,
                                errors: fields.errors,
                                showErrors: errors,
                                fieldActions: actions.fields.check_number,
                                labelTextVariant: "p",
                                errorTextVariant: "p"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                labelTextWhenNoError: "Routing Number",
                                errorMessages: routingNumberErrorMessages,
                                field: fields.routing_number,
                                errors: fields.errors,
                                showErrors: errors,
                                fieldActions: actions.fields.routing_number,
                                labelTextVariant: "p",
                                errorTextVariant: "p"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                labelTextWhenNoError: "Account Number",
                                errorMessages: (0, _sharedConstants.requireErrors)("Account Number is required"),
                                field: fields.account_number,
                                errors: fields.errors,
                                showErrors: errors,
                                fieldActions: actions.fields.account_number,
                                labelTextVariant: "p",
                                errorTextVariant: "p"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                type: "reset",
                                text: "Back to Cart",
                                action: ()=>navigate("/pos/cart"),
                                variant: "secondary",
                                dataQa: "view-cart",
                                extraStyles: "margin-left: 0",
                                textExtraStyles: "font-size: 1rem;"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                type: "submit",
                                id: "check-payment-btn",
                                textExtraStyles: "font-size: 1rem;",
                                disabled: isLoading || isPollingForCheckResponse || isCheckProcessing || fields.amount.rawValue <= 0 || fields.amount.hasErrors,
                                isLoading: isLoading || isPollingForCheckResponse || isCheckProcessing,
                                text: processBtnText,
                                action: handleCheckSubmit
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
CheckCheckoutForm.reducer = (0, _checkoutFormState.checkReducer);
CheckCheckoutForm.mapStateToProps = (0, _checkoutFormState.checkMapStateToProps);
CheckCheckoutForm.mapDispatchToProps = (0, _checkoutFormState.checkMapDispatchToProps);
exports.default = CheckCheckoutForm;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","redux-freeform":"1Yc5v","@thecb/components":"g98ma","../../../utils/helpers":"epomp","../CheckoutForm.state":"jc6Er","react-redux":"k6jol","../Checkout.state":"4E8nR","../Checkout":"tL9YH","../../../utils/constants":"f3A1R","react-router-dom":"hNarb","./shared-constants":"3rfTN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jpLsM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxFreeform = require("redux-freeform");
var _components = require("@thecb/components");
var _helpers = require("../../../utils/helpers");
var _checkoutFormState = require("../CheckoutForm.state");
var _reactRedux = require("react-redux");
var _constants = require("../../../utils/constants");
var _reactRouterDom = require("react-router-dom");
var _sharedConstants = require("./shared-constants");
let CashCheckoutForm = ({ actions, fields, makePayment, remainingBalance, processBtnText })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const [changeDue, setChangeDue] = (0, _react.useState)();
    const [errors, handleErrors] = (0, _react.useState)(false);
    const { isLoading } = (0, _reactRedux.useSelector)((state)=>state.checkout);
    const { payerNameRequired } = (0, _reactRedux.useSelector)((state)=>state.shared.clientConfig);
    (0, _react.useEffect)(()=>{
        if (payerNameRequired) {
            actions.fields.first_name.addValidator((0, _reduxFreeform.required)());
            actions.fields.last_name.addValidator((0, _reduxFreeform.required)());
        }
    }, [
        actions.fields.first_name,
        actions.fields.last_name,
        payerNameRequired
    ]);
    (0, _react.useEffect)(()=>{
        if (remainingBalance) actions.fields.amount.set((0, _helpers.formatCurrencyInput)(remainingBalance));
    }, [
        remainingBalance
    ]);
    (0, _react.useEffect)(()=>{
        recalculateChangeDue(fields.amount.rawValue, remainingBalance);
    }, [
        fields.amount.rawValue
    ]);
    const recalculateChangeDue = (amountGiven, remaining)=>{
        const balance = parseFloat(remaining);
        amountGiven = parseFloat(amountGiven);
        if (amountGiven > balance) setChangeDue((amountGiven - balance).toFixed(2));
        else setChangeDue(0.0.toFixed(2));
    };
    const handleCashSubmit = (0, _components.util).general.generateClickHandler({
        fields
    }, ()=>handleErrors(true), ()=>makePayment({
            amount_given: Number(fields.amount.rawValue),
            ...payerNameRequired && {
                first_name: fields.first_name.rawValue,
                last_name: fields.last_name.rawValue
            },
            payment_delivery_type: fields.payment_delivery_type.rawValue,
            payment_tender_type: (0, _constants.CASH),
            change_due: changeDue,
            navigate,
            location
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormContainer), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                id: "cash-payment-amt",
                type: "number",
                labelTextWhenNoError: "Payment Amount",
                errorMessages: (0, _sharedConstants.paymentAmountErrors),
                field: fields.amount,
                errors: fields.errors,
                fieldActions: actions.fields.amount,
                labelTextVariant: "p",
                errorTextVariant: "p"
            }),
            payerNameRequired && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        id: "cash-first-name",
                        labelTextWhenNoError: "First Name",
                        errorMessages: (0, _sharedConstants.requireErrors)("First Name is required"),
                        field: fields.first_name,
                        showErrors: errors,
                        fieldActions: actions.fields.first_name,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        id: "cash-last-name",
                        labelTextWhenNoError: "Last Name",
                        errorMessages: (0, _sharedConstants.requireErrors)("Last Name is required"),
                        field: fields.last_name,
                        showErrors: errors,
                        fieldActions: actions.fields.last_name,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "16px 0 0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            text: "Back to Cart",
                            action: ()=>navigate("/pos/cart"),
                            variant: "secondary",
                            dataQa: "view-cart",
                            extraStyles: "margin-left: 0",
                            textExtraStyles: "font-size: 1rem;"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            id: "submit-cash-btn",
                            disabled: isLoading || fields.amount.rawValue <= 0 || fields.amount.hasErrors,
                            isLoading: isLoading,
                            text: processBtnText,
                            action: handleCashSubmit,
                            textExtraStyles: "font-size: 1rem;"
                        })
                    ]
                })
            })
        ]
    });
};
CashCheckoutForm.reducer = (0, _checkoutFormState.cashReducer);
CashCheckoutForm.mapStateToProps = (0, _checkoutFormState.cashMapStateToProps);
CashCheckoutForm.mapDispatchToProps = (0, _checkoutFormState.cashMapDispatchToProps);
exports.default = CashCheckoutForm;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","redux-freeform":"1Yc5v","@thecb/components":"g98ma","../../../utils/helpers":"epomp","../CheckoutForm.state":"jc6Er","react-redux":"k6jol","../../../utils/constants":"f3A1R","react-router-dom":"hNarb","./shared-constants":"3rfTN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"itIOY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reduxFreeform = require("redux-freeform");
var _components = require("@thecb/components");
var _helpers = require("../../../utils/helpers");
var _checkoutFormState = require("../CheckoutForm.state");
var _reactRedux = require("react-redux");
var _checkoutState = require("../Checkout.state");
var _constants = require("../../../utils/constants");
var _reactRouterDom = require("react-router-dom");
var _sharedConstants = require("./shared-constants");
const emailPayLinkErrors = {
    [(0, _reduxFreeform.required).error]: "Email address required",
    [(0, _reduxFreeform.isProbablyEmail).error]: "Not a valid email address"
};
const textPayLinkErrors = {
    [(0, _reduxFreeform.required).error]: "Phone number required",
    [(0, _reduxFreeform.hasLength).error]: "10 digit phone number required"
};
let PayLinkCheckoutForm = ({ actions, fields, forms, processBtnText, order })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const [errors, handleErrors] = (0, _react.useState)(false);
    const { isLoading } = (0, _reactRedux.useSelector)((state)=>state.checkout);
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    (0, _react.useEffect)(()=>{
        if (order?.total) actions.fields.amount.set((0, _helpers.formatCurrencyInput)(order?.total));
    }, [
        order?.total,
        actions.fields?.amount
    ]);
    const isPayingFullAmount = Number(fields.amount.rawValue) === Number(order?.total) && Number(order?.remaining_balance) === Number(order?.total);
    const resetFieldValueOnSelect = (field)=>{
        if (field && fields[field]?.rawValue) actions.fields[field].set("");
    };
    const handleEmailPayLinkCheckboxClick = ()=>{
        actions.fields.emailPayLinkCheckbox.set(!currentEmailPayLinkBoolean);
        resetFieldValueOnSelect((0, _constants.EMAIL_ADDRESS_FIELD_NAME));
    };
    const handleTextPayLinkCheckboxClick = ()=>{
        actions.fields.textPayLinkCheckbox.set(!currentTextPayLinkBoolean);
        resetFieldValueOnSelect((0, _constants.PHONE_NUMBER_FIELD_NAME));
    };
    const currentEmailPayLinkBoolean = Boolean(fields.emailPayLinkCheckbox.rawValue);
    const currentTextPayLinkBoolean = Boolean(fields.textPayLinkCheckbox.rawValue);
    const disableSendPaymentLinkButton = !isPayingFullAmount || isLoading || !fields.emailAddress.rawValue && !fields.phoneNumber.rawValue || fields.emailAddress.errors.length || fields.phoneNumber.errors.length || fields.amount.errors.length;
    const handleSendPayLinkClick = (0, _components.util).general.generateClickHandler(forms.paylinkCheckoutForm, ()=>handleErrors(true), ()=>dispatch((0, _checkoutState.initiatePayLink)({
            amount_given: Number(fields.amount.rawValue),
            payment_tender_type: (0, _constants.PAYLINK),
            email: fields.emailAddress.rawValue,
            phone: fields.phoneNumber.rawValue,
            invoice_types: [
                ...fields.emailAddress.rawValue ? [
                    "email"
                ] : [],
                ...fields.phoneNumber.rawValue ? [
                    "sms"
                ] : []
            ],
            navigate,
            location
        })));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormContainer), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                id: "paylink-payment-amt",
                type: "number",
                labelTextWhenNoError: "Payment Amount",
                errorMessages: (0, _sharedConstants.paymentAmountErrors),
                field: fields.amount,
                errors: fields.errors,
                fieldActions: actions.fields.amount,
                disabled: true,
                labelTextVariant: "p",
                errorTextVariant: "p"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
                width: "50%",
                extraStyles: `flex-grow: 1;`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                        id: "enter-email-or-phone-number-explanation",
                        role: "note",
                        extraStyles: `max-width: 32rem`,
                        children: "Enter an email address or phone number to send this order as a payment link to the customer."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                        id: "email-link",
                        title: "Email Link",
                        name: "Email Link",
                        checked: currentEmailPayLinkBoolean,
                        onChange: handleEmailPayLinkCheckboxClick
                    }),
                    currentEmailPayLinkBoolean && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        id: "email-address-input",
                        labelTextWhenNoError: "Email Address",
                        errorMessages: emailPayLinkErrors,
                        field: fields.emailAddress,
                        errors: fields.errors,
                        showErrors: errors,
                        fieldActions: actions.fields.emailAddress,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                        id: "text-link",
                        title: "Text Link",
                        name: "Text Link",
                        checked: currentTextPayLinkBoolean,
                        onChange: handleTextPayLinkCheckboxClick
                    }),
                    currentTextPayLinkBoolean && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                        id: "phone-number-input",
                        labelTextWhenNoError: "Phone Number",
                        errorMessages: textPayLinkErrors,
                        field: fields.phoneNumber,
                        errors: fields.errors,
                        showErrors: errors,
                        fieldActions: actions.fields.phoneNumber,
                        labelTextVariant: "p",
                        errorTextVariant: "p"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "16px 0 0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            text: "Back to Cart",
                            action: ()=>navigate("/pos/cart"),
                            variant: "secondary",
                            dataQa: "view-cart",
                            extraStyles: "margin-left: 0",
                            textExtraStyles: "font-size: 1rem;"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            id: "paylink-payment-btn",
                            "aria-describedby": "must-pay-in-full-explanation enter-email-or-phone-number-explanation",
                            disabled: disableSendPaymentLinkButton,
                            isLoading: isLoading,
                            text: processBtnText,
                            action: handleSendPayLinkClick,
                            textExtraStyles: "font-size: 1rem;"
                        })
                    ]
                })
            }),
            !isPayingFullAmount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "8px 0px",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                    id: "must-pay-in-full-explanation",
                    role: "alert",
                    color: (0, _components.constants).colors.THUNDERBIRD_RED,
                    children: "PayLink does not support split-tender transactions. Please void any completed payments and pay in full via PayLink."
                })
            })
        ]
    });
};
PayLinkCheckoutForm.reducer = (0, _checkoutFormState.paylinkReducer);
PayLinkCheckoutForm.mapStateToProps = (0, _checkoutFormState.paylinkMapStateToProps);
PayLinkCheckoutForm.mapDispatchToProps = (0, _checkoutFormState.paylinkMapDispatchToProps);
exports.default = PayLinkCheckoutForm;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","redux-freeform":"1Yc5v","@thecb/components":"g98ma","../../../utils/helpers":"epomp","../CheckoutForm.state":"jc6Er","react-redux":"k6jol","../Checkout.state":"4E8nR","../../../utils/constants":"f3A1R","react-router-dom":"hNarb","./shared-constants":"3rfTN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6hw3k":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _helpers = require("../../../utils/helpers");
var _checkoutFormState = require("../CheckoutForm.state");
var _reactRedux = require("react-redux");
var _constants = require("../../../utils/constants");
var _reactRouterDom = require("react-router-dom");
var _datePicker = require("../../../components/date-picker");
var _datePickerDefault = parcelHelpers.interopDefault(_datePicker);
var _sharedConstants = require("./shared-constants");
let WirePaymentCheckoutForm = ({ actions, fields, makePayment, remainingBalance, processBtnText, splitTenderAllowed })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const [errors, handleErrors] = (0, _react.useState)(false);
    const { isLoading } = (0, _reactRedux.useSelector)((state)=>state.checkout);
    (0, _react.useEffect)(()=>{
        if (remainingBalance) actions.fields.amount.set((0, _helpers.formatCurrencyInput)(remainingBalance));
    }, [
        remainingBalance
    ]);
    const handleWirePaymentSubmit = (0, _components.util).general.generateClickHandler({
        fields
    }, ()=>handleErrors(true), ()=>makePayment({
            amount_given: Number(fields.amount.rawValue),
            name: fields.name.rawValue,
            effective_date: (0, _helpers.convertToISOFormat)(fields.effectiveDate.rawValue),
            description: fields.description.rawValue,
            payment_tender_type: (0, _constants.WIRE),
            navigate,
            location
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.FormContainer), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                id: "wire-payment-amt",
                type: "number",
                labelTextWhenNoError: "Payment Amount",
                errorMessages: (0, _sharedConstants.paymentAmountErrors),
                field: fields.amount,
                errors: fields.errors,
                fieldActions: actions.fields.amount,
                labelTextVariant: "p",
                errorTextVariant: "p",
                disabled: !splitTenderAllowed
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                fontSize: "1.25em",
                children: "Wire Transfer Information"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                id: "wire-name",
                labelTextWhenNoError: "Name",
                errorMessages: (0, _sharedConstants.requireErrors)("Name is required"),
                field: fields.name,
                showErrors: errors,
                fieldActions: actions.fields.name,
                labelTextVariant: "p",
                errorTextVariant: "p"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDefault.default), {
                label: "Effective Date",
                labelTextWhenNoError: "Effective Date",
                id: "wire-effective-date",
                field: fields.effectiveDate,
                fieldActions: actions.fields.effectiveDate,
                errorMessages: (0, _sharedConstants.requireErrors)("Effective Date is required"),
                showErrors: errors,
                errorTextVariant: "p",
                fullWidth: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormTextarea), {
                id: "wire-description",
                labelTextWhenNoError: "Description",
                field: fields.description,
                showErrors: errors,
                fieldActions: actions.fields.description,
                labelTextVariant: "p",
                errorTextVariant: "p",
                maxLength: 200,
                resize: "none",
                rows: 3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "16px 0 0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            text: "Back to Cart",
                            action: ()=>navigate("/pos/cart"),
                            variant: "secondary",
                            dataQa: "view-cart",
                            extraStyles: "margin-left: 0",
                            textExtraStyles: "font-size: 1rem;"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            id: "submit-wire-payment-btn",
                            disabled: isLoading || fields.amount.rawValue <= 0 || fields.amount.hasErrors,
                            isLoading: isLoading,
                            text: processBtnText,
                            action: handleWirePaymentSubmit,
                            textExtraStyles: "font-size: 1rem;"
                        })
                    ]
                })
            })
        ]
    });
};
WirePaymentCheckoutForm.reducer = (0, _checkoutFormState.wireReducer);
WirePaymentCheckoutForm.mapStateToProps = (0, _checkoutFormState.wireMapStateToProps);
WirePaymentCheckoutForm.mapDispatchToProps = (0, _checkoutFormState.wireMapDispatchToProps);
exports.default = WirePaymentCheckoutForm;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../../utils/helpers":"epomp","../CheckoutForm.state":"jc6Er","react-redux":"k6jol","../../../utils/constants":"f3A1R","react-router-dom":"hNarb","../../../components/date-picker":"2lTFu","./shared-constants":"3rfTN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2lTFu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _datePicker = require("./DatePicker");
var _datePickerDefault = parcelHelpers.interopDefault(_datePicker);
exports.default = (0, _datePickerDefault.default);

},{"./DatePicker":"LWbjT","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"LWbjT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _styled = require("../styled");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _helpers = require("../../utils/helpers");
var _components = require("@thecb/components");
const ReactDatePickerLabel = (0, _styledComponentsDefault.default).label`
  font-size: 14px;
  font-weight: normal;
`;
const GlobalDatePickerStyles = (0, _styledComponents.createGlobalStyle)`
  .react-datepicker__day--selected {
    background-color: ${(0, _components.constants).colors.LUCKY_POINT};
  }
`;
const DatePicker = ({ field, fieldActions, id, label, fullWidth = false, errorTextVariant = "pXS", showFieldErrorRow = true, showErrors, errorMessages, errorFieldExtraStyles = "", labelTextWhenNoError = "" })=>{
    // redux-freeform expects a simple string ie "01072022" while react-datepicker expects a date object for the `selected` prop
    const formattedDate = (0, _helpers.delimitDateString)(field.rawValue);
    const handleDateChangeRaw = (e)=>{
        if (e.target.value === "") // default react-datepicker behavior would assume a default date set upon leaving calendar focus.
        // this allows the user to backspace/clear the individual input value without clearing all other filters too
        fieldActions.set("");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _styled.DateFilterContainer), {
        fullWidth: fullWidth,
        $hasError: field.hasErrors && field.dirty || field.hasErrors && showErrors,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(GlobalDatePickerStyles, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReactDatePickerLabel, {
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                id: id,
                selected: formattedDate ? new Date(formattedDate) : formattedDate,
                onChange: (date)=>fieldActions.set((0, _dayjsDefault.default)(date).format("MMDDYYYY")),
                dateFormat: "MM/dd/yyyy",
                autoComplete: "off",
                minDate: new Date("01/01/2022"),
                maxDate: new Date(),
                onChangeRaw: handleDateChangeRaw,
                popperModifiers: [
                    {
                        name: "arrow",
                        options: {
                            padding: 10
                        }
                    }
                ]
            }),
            showFieldErrorRow && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Stack), {
                direction: "row",
                justify: "space-between",
                "aria-live": "polite",
                "aria-atomic": true,
                children: field.hasErrors && field.dirty || field.hasErrors && showErrors ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                    color: (0, _components.constants).colors.ERROR_COLOR,
                    variant: errorTextVariant,
                    weight: "400",
                    extraStyles: `word-break: break-word;
              font-family: Public Sans;
              &::first-letter {
                text-transform: uppercase;
              }
              ${errorFieldExtraStyles};`,
                    id: (0, _components.util).general.createIdFromString(labelTextWhenNoError, "error message"),
                    children: errorMessages[field.errors[0]]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                    extraStyles: `height: 1rem;`
                })
            })
        ]
    });
};
exports.default = DatePicker;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-datepicker":"aOpHt","styled-components":"bkusY","../styled":"uxYqN","react-datepicker/dist/react-datepicker.css":"c0GsX","dayjs":"4CsUp","../../utils/helpers":"epomp","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aOpHt":[function(require,module,exports) {
!function(e, t) {
    t(exports, require("55b400dfb9477df9"), require("6a082dc438cb1ca2"), require("3647656f9c7ebc5e"), require("13c776570732a9da"), require("6553b0b4b603e1c3"), require("d7b993ace1eca80"), require("786b9925c1b6b5ed"), require("4f1b37d05fed00b3"), require("5fc940b8b11b2f30"), require("b78d0278e54da1b4"), require("baecc74d7df402ea"), require("7360dafd9cf06bde"), require("376cbc5302b1ec0d"), require("f011acafa9d72da6"), require("aa659b497503e983"), require("7b7bf8fb2c20e0c7"), require("f501b8cd52ae4ff"), require("9e212fc4b323ed41"), require("e8ff49b0d1cab426"), require("12eec1f6d562e008"), require("72fc20cc52029f11"), require("42e3036b4499153e"), require("5592c752ef1290f4"), require("8406427195a66845"), require("fa470ac376b26caf"), require("bf3222da2f520817"), require("685dda4962dc82e1"), require("d6dea87c85b53e02"), require("b9a1398c1c94250d"), require("e1fbbdf633f9e5ae"), require("8ac41f1b252a0973"), require("156a522b3b8fd124"), require("f2620442a53b80d6"), require("1b94d4eb34edeca3"), require("47020b485e994171"), require("9818583261d8a102"), require("1a7d4440a348b466"), require("50dce9ec585a5332"), require("a738370d89dd61ec"), require("cdc90b6df52760f"), require("2fdd28e51cf3c8b2"), require("72fb68fdc0d9bca3"), require("964e71bf85841794"), require("38468de993ee0549"), require("ec1866b328e982ea"), require("5c05196fbf6d6b4d"), require("9a6937c0aa7a418e"), require("23c6d2169b7feabe"), require("fda4089c257f1876"), require("b5061c3c95f48e73"), require("f57afb99b9b06613"), require("496ef8c8ed2b34d6"), require("6663b9b2b265a941"), require("c3348d940b830a7f"), require("53a4aaeeb87e1c51"), require("45f66dd8a17e85aa"), require("a3a5398768dc185f"), require("201a807b2e6adc5e"), require("a89a534c753bb4c3"), require("11a993db5effee60"), require("96de361de41dc920"), require("acb830835f9d8af1"));
}(this, function(e, t, r, a, n, o, s, i, p, l, d, c, u, f, h, m, y, D, v, w, g, k, b, S, C, _, M, P, E, N, x, O, Y, I, T, L, R, F, A, q, W, B, K, H, j, Q, V, U, $, z, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe) {
    "use strict";
    function le(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = le(t), ce = le(a), ue = le(n), fe = le(o), he = le(s), me = le(i), ye = le(p), De = le(l), ve = le(d), we = le(c), ge = le(u), ke = le(m), be = le(y), Se = le(D), Ce = le(v), _e = le(w), Me = le(g), Pe = le(k), Ee = le(b), Ne = le(S), xe = le(C), Oe = le(_), Ye = le(M), Ie = le(P), Te = le(E), Le = le(N), Re = le(x), Fe = le(O), Ae = le(Y), qe = le(I), We = le(T), Be = le(L), Ke = le(R), He = le(F), je = le(A), Qe = le(W), Ve = le(B), Ue = le(K), $e = le(H), ze = le(j), Ge = le(Q), Je = le(V), Xe = le(z), Ze = le(G), et = le(J), tt = le(X), rt = le(Z), at = le(ee), nt = le(te), ot = le(re), st = le(ae), it = le(ne), pt = le(oe), lt = le(se), dt = le(ie);
    function ct(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            t && (a = a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ut(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ct(Object(r), !0).forEach(function(t) {
                Dt(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ct(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ft(e) {
        return (ft = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
    }
    function ht(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function mt(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
    }
    function yt(e, t, r) {
        return t && mt(e.prototype, t), r && mt(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Dt(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function vt() {
        return (vt = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }).apply(this, arguments);
    }
    function wt(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        Object.defineProperty(e, "prototype", {
            value: Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }),
            writable: !1
        }), t && kt(e, t);
    }
    function gt(e) {
        return (gt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
    }
    function kt(e, t) {
        return (kt = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        })(e, t);
    }
    function bt(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function St(e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return bt(e);
    }
    function Ct(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = gt(e);
            if (t) {
                var n = gt(this).constructor;
                r = Reflect.construct(a, arguments, n);
            } else r = a.apply(this, arguments);
            return St(this, r);
        };
    }
    function _t(e) {
        return function(e) {
            if (Array.isArray(e)) return Mt(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Mt(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mt(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Mt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Pt(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            case "PPPP":
            default:
                return t.date({
                    width: "full"
                });
        }
    }
    function Et(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            case "pppp":
            default:
                return t.time({
                    width: "full"
                });
        }
    }
    var Nt = {
        p: Et,
        P: function(e, t) {
            var r, a = e.match(/(P+)(p+)?/) || [], n = a[1], o = a[2];
            if (!o) return Pt(e, t);
            switch(n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                case "PPPP":
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", Pt(n, t)).replace("{{time}}", Et(o, t));
        }
    }, xt = 12, Ot = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Yt(e) {
        var t = e ? "string" == typeof e || e instanceof String ? pt.default(e) : st.default(e) : new Date;
        return Tt(t) ? t : null;
    }
    function It(e, t, r, a, n) {
        var o = null, s = Xt(r) || Xt(Jt()), i = !0;
        return Array.isArray(t) ? (t.forEach(function(t) {
            var p = it.default(e, t, new Date, {
                locale: s
            });
            a && (i = Tt(p, n) && e === Lt(p, t, r)), Tt(p, n) && i && (o = p);
        }), o) : (o = it.default(e, t, new Date, {
            locale: s
        }), a ? i = Tt(o) && e === Lt(o, t, r) : Tt(o) || (t = t.match(Ot).map(function(e) {
            var t = e[0];
            return "p" === t || "P" === t ? s ? (0, Nt[t])(e, s.formatLong) : t : e;
        }).join(""), e.length > 0 && (o = it.default(e, t.slice(0, e.length), new Date)), Tt(o) || (o = new Date(e))), Tt(o) && i ? o : null);
    }
    function Tt(e, t) {
        return t = t || new Date("1/1/1000"), fe.default(e) && !nt.default(e, t);
    }
    function Lt(e, t, r) {
        if ("en" === r) return he.default(e, t, {
            awareOfUnicodeTokens: !0
        });
        var a = Xt(r);
        return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && Jt() && Xt(Jt()) && (a = Xt(Jt())), he.default(e, t, {
            locale: a || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Rt(e, t) {
        var r = t.dateFormat, a = t.locale;
        return e && Lt(e, Array.isArray(r) ? r[0] : r, a) || "";
    }
    function Ft(e, t) {
        var r = t.hour, a = void 0 === r ? 0 : r, n = t.minute, o = void 0 === n ? 0 : n, s = t.second, i = void 0 === s ? 0 : s;
        return Fe.default(Re.default(Le.default(e, i), o), a);
    }
    function At(e, t) {
        var r = t && Xt(t) || Jt() && Xt(Jt());
        return xe.default(e, r ? {
            locale: r
        } : null);
    }
    function qt(e, t) {
        return Lt(e, "ddd", t);
    }
    function Wt(e) {
        return Ve.default(e);
    }
    function Bt(e, t, r) {
        var a = Xt(t || Jt());
        return Ue.default(e, {
            locale: a,
            weekStartsOn: r
        });
    }
    function Kt(e) {
        return $e.default(e);
    }
    function Ht(e) {
        return Ge.default(e);
    }
    function jt(e) {
        return ze.default(e);
    }
    function Qt(e, t) {
        return e && t ? tt.default(e, t) : !e && !t;
    }
    function Vt(e, t) {
        return e && t ? et.default(e, t) : !e && !t;
    }
    function Ut(e, t) {
        return e && t ? rt.default(e, t) : !e && !t;
    }
    function $t(e, t) {
        return e && t ? Ze.default(e, t) : !e && !t;
    }
    function zt(e, t) {
        return e && t ? Xe.default(e, t) : !e && !t;
    }
    function Gt(e, t, r) {
        var a, n = Ve.default(t), o = Je.default(r);
        try {
            a = ot.default(e, {
                start: n,
                end: o
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function Jt() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function Xt(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Zt(e, t) {
        return Lt(Ae.default(Yt(), e), "LLLL", t);
    }
    function er(e, t) {
        return Lt(Ae.default(Yt(), e), "LLL", t);
    }
    function tr(e, t) {
        return Lt(qe.default(Yt(), e), "QQQ", t);
    }
    function rr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return $t(e, t);
        }) || o && o.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || s && !s.some(function(t) {
            return $t(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || p && !p(Yt(e)) || !1;
    }
    function ar(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, a = t.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) : r && r.some(function(t) {
            return $t(e, t);
        }) || !1;
    }
    function nr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Vt(e, t);
        }) || o && !o.some(function(t) {
            return Vt(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function or(e, t, r, a) {
        var n = Ie.default(e), o = Oe.default(e), s = Ie.default(t), i = Oe.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function sr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Ut(e, t);
        }) || o && !o.some(function(t) {
            return Ut(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function ir(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = new Date(e, 0, 1);
        return lr(n, {
            minDate: r,
            maxDate: a
        }) || !1;
    }
    function pr(e, t, r, a) {
        var n = Ie.default(e), o = Ye.default(e), s = Ie.default(t), i = Ye.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function lr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
        return r && He.default(e, r) < 0 || a && He.default(e, a) > 0;
    }
    function dr(e, t) {
        return t.some(function(t) {
            return Pe.default(t) === Pe.default(e) && Me.default(t) === Me.default(e);
        });
    }
    function cr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
        return r && dr(e, r) || a && !dr(e, a) || n && !n(e) || !1;
    }
    function ur(e, t) {
        var r = t.minTime, a = t.maxTime;
        if (!r || !a) throw new Error("Both minTime and maxTime props required");
        var n, o = Yt(), s = Fe.default(Re.default(o, Me.default(e)), Pe.default(e)), i = Fe.default(Re.default(o, Me.default(r)), Pe.default(r)), p = Fe.default(Re.default(o, Me.default(a)), Pe.default(a));
        try {
            n = !ot.default(s, {
                start: i,
                end: p
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function fr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Se.default(e, 1);
        return r && je.default(r, n) > 0 || a && a.every(function(e) {
            return je.default(e, n) > 0;
        }) || !1;
    }
    function hr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = we.default(e, 1);
        return r && je.default(n, r) > 0 || a && a.every(function(e) {
            return je.default(n, e) > 0;
        }) || !1;
    }
    function mr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Ce.default(e, 1);
        return r && Qe.default(r, n) > 0 || a && a.every(function(e) {
            return Qe.default(e, n) > 0;
        }) || !1;
    }
    function yr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = ge.default(e, 1);
        return r && Qe.default(n, r) > 0 || a && a.every(function(e) {
            return Qe.default(n, e) > 0;
        }) || !1;
    }
    function Dr(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) >= 0;
            });
            return Be.default(a);
        }
        return r ? Be.default(r) : t;
    }
    function vr(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) <= 0;
            });
            return Ke.default(a);
        }
        return r ? Ke.default(r) : t;
    }
    function wr() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, a = 0, n = e.length; a < n; a++){
            var o = e[a];
            if (ue.default(o)) {
                var s = Lt(o, "MM.dd.yyyy"), i = r.get(s) || [];
                i.includes(t) || (i.push(t), r.set(s, i));
            } else if ("object" === ft(o)) {
                var p = Object.keys(o), l = p[0], d = o[p[0]];
                if ("string" == typeof l && d.constructor === Array) for(var c = 0, u = d.length; c < u; c++){
                    var f = Lt(d[c], "MM.dd.yyyy"), h = r.get(f) || [];
                    h.includes(l) || (h.push(l), r.set(f, h));
                }
            }
        }
        return r;
    }
    function gr(e, t, r, a, n) {
        for(var o = n.length, s = [], i = 0; i < o; i++){
            var p = me.default(ye.default(e, Pe.default(n[i])), Me.default(n[i])), l = me.default(e, (r + 1) * a);
            at.default(p, t) && nt.default(p, l) && s.push(n[i]);
        }
        return s;
    }
    function kr(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function br(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : xt, r = Math.ceil(Ie.default(e) / t) * t, a = r - (t - 1);
        return {
            startPeriod: a,
            endPeriod: r
        };
    }
    function Sr(e, t, r, a) {
        for(var n = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Ie.default(r) <= s), a && i && (i = Ie.default(a) >= s), i && n.push(s);
        }
        return n;
    }
    var Cr = function(e) {
        wt(a, e);
        var r = Ct(a);
        function a(e) {
            var n;
            ht(this, a), Dt(bt(n = r.call(this, e)), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(bt(n), t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Ie.default(n.props.minDate) : null, a = n.props.maxDate ? Ie.default(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Dt(bt(n), "onChange", function(e) {
                n.props.onChange(e);
            }), Dt(bt(n), "handleClickOutside", function() {
                n.props.onCancel();
            }), Dt(bt(n), "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), Dt(bt(n), "incrementYears", function() {
                return n.shiftYears(1);
            }), Dt(bt(n), "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var o = e.yearDropdownItemNumber, s = e.scrollableYearDropdown, i = o || (s ? 10 : 5);
            return n.state = {
                yearsList: Sr(n.props.year, i, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return yt(a, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    e && (e.scrollTop = e.scrollHeight / 2 - e.clientHeight / 2);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]), a;
    }(de.default.Component), _r = lt.default(Cr), Mr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Ie.default(e.props.minDate) : 1900, r = e.props.maxDate ? Ie.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++)a.push(de.default.createElement("option", {
                    key: n,
                    value: n
                }, n));
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(_r, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Dt(bt(e), "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Dt(bt(e), "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Dt(bt(e), "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Pr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), Dt(bt(e), "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(bt(e), r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Dt(bt(e), "onChange", function(t) {
                return e.props.onChange(t);
            }), Dt(bt(e), "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Er = lt.default(Pr), Nr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Dt(bt(e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Dt(bt(e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Dt(bt(e), "renderDropdown", function(t) {
                return de.default.createElement(Er, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Dt(bt(e), "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, a = [
                    e.renderReadView(!r, t)
                ];
                return r && a.unshift(e.renderDropdown(t)), a;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return er(e, t.props.locale);
                    } : function(e) {
                        return Zt(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component);
    function xr(e, t) {
        for(var r = [], a = Kt(e), n = Kt(t); !at.default(a, n);)r.push(Yt(a)), a = we.default(a, 1);
        return r;
    }
    var Or = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "renderOptions", function() {
                return a.state.monthYearsList.map(function(e) {
                    var t = Te.default(e), r = Qt(a.props.date, e) && Vt(a.props.date, e);
                    return de.default.createElement("div", {
                        className: r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: a.onChange.bind(bt(a), t),
                        "aria-selected": r ? "true" : void 0
                    }, r ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Lt(e, a.props.dateFormat, a.props.locale));
                });
            }), Dt(bt(a), "onChange", function(e) {
                return a.props.onChange(e);
            }), Dt(bt(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), a.state = {
                monthYearsList: xr(a.props.minDate, a.props.maxDate)
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Yr = lt.default(Or), Ir = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = Kt(e.props.minDate), r = Kt(e.props.maxDate), a = []; !at.default(t, r);){
                    var n = Te.default(t);
                    a.push(de.default.createElement("option", {
                        key: n,
                        value: n
                    }, Lt(t, e.props.dateFormat, e.props.locale))), t = we.default(t, 1);
                }
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Te.default(Kt(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                var r = Lt(e.props.date, e.props.dateFormat, e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(Yr, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown();
                var r = Yt(parseInt(t));
                Qt(e.props.date, r) && Vt(e.props.date, r) || e.props.onChange(r);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Tr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "dayEl", de.default.createRef()), Dt(bt(e), "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Dt(bt(e), "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Dt(bt(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "isSameDay", function(t) {
                return $t(e.props.day, t);
            }), Dt(bt(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
            }), Dt(bt(e), "isDisabled", function() {
                return rr(e.props.day, e.props);
            }), Dt(bt(e), "isExcluded", function() {
                return ar(e.props.day, e.props);
            }), Dt(bt(e), "getHighLightedClass", function(t) {
                var r = e.props, a = r.day, n = r.highlightDates;
                if (!n) return !1;
                var o = Lt(a, "MM.dd.yyyy");
                return n.get(o);
            }), Dt(bt(e), "isInRange", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Gt(r, a, n);
            }), Dt(bt(e), "isInSelectingRange", function() {
                var t, r = e.props, a = r.day, n = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, l = r.endDate, d = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(n || o || s) || !d || !i && e.isDisabled()) && (n && l && (nt.default(d, l) || zt(d, l)) ? Gt(a, d, l) : (o && p && (at.default(d, p) || zt(d, p)) || !(!s || !p || l || !at.default(d, p) && !zt(d, p))) && Gt(a, p, d));
            }), Dt(bt(e), "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.endDate, o = r.selectsEnd, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isRangeStart", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(a, r);
            }), Dt(bt(e), "isRangeEnd", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(n, r);
            }), Dt(bt(e), "isWeekend", function() {
                var t = Ee.default(e.props.day);
                return 0 === t || 6 === t;
            }), Dt(bt(e), "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === Oe.default(e.props.day);
            }), Dt(bt(e), "isBeforeMonth", function() {
                return void 0 !== e.props.month && (Oe.default(e.props.day) + 1) % 12 === e.props.month;
            }), Dt(bt(e), "isCurrentDay", function() {
                return e.isSameDay(Yt());
            }), Dt(bt(e), "isSelected", function() {
                return e.isSameDay(e.props.selected);
            }), Dt(bt(e), "getClassNames", function(t) {
                var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return ce.default("react-datepicker__day", r, "react-datepicker__day--" + qt(e.props.day), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"));
            }), Dt(bt(e), "getAriaLabel", function() {
                var t = e.props, r = t.day, a = t.ariaLabelPrefixWhenEnabled, n = void 0 === a ? "Choose" : a, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : n;
                return "".concat(i, " ").concat(Lt(r, "PPPP", e.props.locale));
            }), Dt(bt(e), "getTabIndex", function(t, r) {
                var a = t || e.props.selected, n = r || e.props.preSelection;
                return e.isKeyboardSelected() || e.isSameDay(a) && $t(n, a) ? 0 : -1;
            }), Dt(bt(e), "handleFocusDay", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus({
                    preventScroll: !0
                });
            }), Dt(bt(e), "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Ne.default(e.props.day), e.props.day) : Ne.default(e.props.day);
            }), Dt(bt(e), "render", function() {
                return de.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.handleMouseEnter,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected()
                }, e.renderDayContents());
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), r;
    }(de.default.Component), Lr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!e.onClick
                    };
                    return de.default.createElement("div", {
                        className: ce.default(n),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick
                    }, t);
                }
            }
        ]), r;
    }(de.default.Component), Rr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleWeekClick", function(t, r, a) {
                "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Dt(bt(e), "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : At(t);
            }), Dt(bt(e), "renderDays", function() {
                var t = Bt(e.props.day, e.props.locale, e.props.calendarStartDay), r = [], a = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var n = e.props.onWeekSelect ? e.handleWeekClick.bind(bt(e), t, a) : void 0;
                    r.push(de.default.createElement(Lr, {
                        key: "W",
                        weekNumber: a,
                        onClick: n,
                        ariaLabelPrefix: e.props.ariaLabelPrefix
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = De.default(t, r);
                    return de.default.createElement(Tr, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: a.valueOf(),
                        day: a,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(bt(e), a),
                        onMouseEnter: e.handleDayMouseEnter.bind(bt(e), a),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__week"
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Fr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "MONTH_REFS", _t(Array(12)).map(function() {
                return de.default.createRef();
            })), Dt(bt(e), "isDisabled", function(t) {
                return rr(t, e.props);
            }), Dt(bt(e), "isExcluded", function(t) {
                return ar(t, e.props);
            }), Dt(bt(e), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Dt(bt(e), "isRangeStartMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), n);
            }), Dt(bt(e), "isRangeStartQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), n);
            }), Dt(bt(e), "isRangeEndMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), o);
            }), Dt(bt(e), "isRangeEndQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), o);
            }), Dt(bt(e), "isWeekInMonth", function(t) {
                var r = e.props.day, a = De.default(t, 6);
                return Vt(t, r) || Vt(a, r);
            }), Dt(bt(e), "isCurrentMonth", function(e, t) {
                return Ie.default(e) === Ie.default(Yt()) && t === Oe.default(Yt());
            }), Dt(bt(e), "isSelectedMonth", function(e, t, r) {
                return Oe.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "isSelectedQuarter", function(e, t, r) {
                return Ye.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = Bt(Kt(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(de.default.createElement(Rr, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: a,
                    day: o,
                    month: Oe.default(e.props.day),
                    onDayClick: e.handleDayClick,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: e.props.preSelection,
                    selected: e.props.selected,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    showWeekNumber: e.props.showWeekNumbers,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !n;){
                    a++, o = ve.default(o, 1);
                    var s = r && a >= 6, i = !r && !e.isWeekInMonth(o);
                    if (s || i) {
                        if (!e.props.peekNextMonth) break;
                        n = !0;
                    }
                }
                return t;
            }), Dt(bt(e), "onMonthClick", function(t, r) {
                e.handleDayClick(Kt(Ae.default(e.props.day, r)), t);
            }), Dt(bt(e), "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Dt(bt(e), "onMonthKeyDown", function(t, r) {
                var a = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        e.onMonthClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleMonthNavigation(11 === r ? 0 : r + 1, we.default(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleMonthNavigation(0 === r ? 11 : r - 1, Se.default(e.props.preSelection, 1));
                }
            }), Dt(bt(e), "onQuarterClick", function(t, r) {
                e.handleDayClick(jt(qe.default(e.props.day, r)), t);
            }), Dt(bt(e), "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, d = r.monthClassName, c = d ? d(a) : void 0;
                return ce.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), c, {
                    "react-datepicker__month--disabled": (i || p) && nr(Ae.default(a, t), e.props),
                    "react-datepicker__month--selected": e.isSelectedMonth(a, t, s),
                    "react-datepicker__month-text--keyboard-selected": Oe.default(l) === t,
                    "react-datepicker__month--in-range": or(n, o, t, a),
                    "react-datepicker__month--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), Dt(bt(e), "getTabIndex", function(t) {
                var r = Oe.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Dt(bt(e), "getAriaLabel", function(t) {
                var r = e.props, a = r.chooseDayAriaLabelPrefix, n = void 0 === a ? "Choose" : a, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = Ae.default(i, t), l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
                return "".concat(l, " ").concat(Lt(p, "MMMM yyyy"));
            }), Dt(bt(e), "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate;
                return ce.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter--disabled": (i || p) && sr(qe.default(a, t), e.props),
                    "react-datepicker__quarter--selected": e.isSelectedQuarter(a, t, s),
                    "react-datepicker__quarter--in-range": pr(n, o, t, a),
                    "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
                });
            }), Dt(bt(e), "renderMonths", function() {
                var t = e.props, r = t.showFullMonthYearPicker, a = t.showTwoColumnMonthYearPicker, n = t.showFourColumnMonthYearPicker, o = t.locale, s = t.day, i = t.selected;
                return (n ? [
                    [
                        0,
                        1,
                        2,
                        3
                    ],
                    [
                        4,
                        5,
                        6,
                        7
                    ],
                    [
                        8,
                        9,
                        10,
                        11
                    ]
                ] : a ? [
                    [
                        0,
                        1
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        7
                    ],
                    [
                        8,
                        9
                    ],
                    [
                        10,
                        11
                    ]
                ] : [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        3,
                        4,
                        5
                    ],
                    [
                        6,
                        7,
                        8
                    ],
                    [
                        9,
                        10,
                        11
                    ]
                ]).map(function(t, a) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: a
                    }, t.map(function(t, a) {
                        return de.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: a,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                e.onMonthKeyDown(r, t);
                            },
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(s, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(s, t, i)
                        }, r ? Zt(t, o) : er(t, o));
                    }));
                });
            }), Dt(bt(e), "renderQuarters", function() {
                var t = e.props, r = t.day, a = t.selected;
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, n) {
                    return de.default.createElement("div", {
                        key: n,
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, a)
                    }, tr(t, e.props.locale));
                }));
            }), Dt(bt(e), "getClassNames", function() {
                var t = e.props;
                t.day;
                var r = t.selectingDate, a = t.selectsStart, n = t.selectsEnd, o = t.showMonthYearPicker, s = t.showQuarterYearPicker;
                return ce.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || n)
                }, {
                    "react-datepicker__monthPicker": o
                }, {
                    "react-datepicker__quarterPicker": s
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, a = e.day, n = e.ariaLabelPrefix, o = void 0 === n ? "month " : n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(o, " ").concat(Lt(a, "yyyy-MM")),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(de.default.Component), Ar = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                height: null
            }), Dt(bt(e), "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props) || e.props.onChange(t);
            }), Dt(bt(e), "isSelectedTime", function(t, r, a) {
                return e.props.selected && r === Pe.default(t) && a === Me.default(t);
            }), Dt(bt(e), "liClasses", function(t, r, a) {
                var n = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t, r, a) : void 0
                ];
                return e.isSelectedTime(t, r, a) && n.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props)) && n.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Pe.default(t) + Me.default(t)) % e.props.intervals != 0 && n.push("react-datepicker__time-list-item--injected"), n.join(" ");
            }), Dt(bt(e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "renderTimes", function() {
                for(var t = [], r = e.props.format ? e.props.format : "p", a = e.props.intervals, n = Wt(Yt(e.props.selected)), o = 1440 / a, s = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), i = e.props.selected || e.props.openToDate || Yt(), p = Pe.default(i), l = Me.default(i), d = Fe.default(Re.default(n, l), p), c = 0; c < o; c++){
                    var u = me.default(n, c * a);
                    if (t.push(u), s) {
                        var f = gr(n, u, c, a, s);
                        t = t.concat(f);
                    }
                }
                return t.map(function(t, a) {
                    return de.default.createElement("li", {
                        key: a,
                        onClick: e.handleClick.bind(bt(e), t),
                        className: e.liClasses(t, p, l),
                        ref: function(r) {
                            (nt.default(t, d) || zt(t, d)) && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: "0",
                        "aria-selected": e.isSelectedTime(t, p, l) ? "true" : void 0
                    }, Lt(t, r, e.props.locale));
                });
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.list.scrollTop = r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        tabIndex: "0"
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }(de.default.Component);
    Dt(Ar, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var qr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "YEAR_REFS", _t(Array(a.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), Dt(bt(a), "isDisabled", function(e) {
                return rr(e, a.props);
            }), Dt(bt(a), "isExcluded", function(e) {
                return ar(e, a.props);
            }), Dt(bt(a), "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(bt(a));
                window.requestAnimationFrame(t);
            }), Dt(bt(a), "handleYearClick", function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }), Dt(bt(a), "handleYearNavigation", function(e, t) {
                var r = a.props, n = r.date, o = r.yearItemNumber, s = br(n, o).startPeriod;
                a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
            }), Dt(bt(a), "isSameDay", function(e, t) {
                return $t(e, t);
            }), Dt(bt(a), "isCurrentYear", function(e) {
                return e === Ie.default(Yt());
            }), Dt(bt(a), "isKeyboardSelected", function(e) {
                var t = Ht(We.default(a.props.date, e));
                return !a.props.disabledKeyboardNavigation && !a.props.inline && !$t(t, Ht(a.props.selected)) && $t(t, Ht(a.props.preSelection));
            }), Dt(bt(a), "onYearClick", function(e, t) {
                var r = a.props.date;
                a.handleYearClick(Ht(We.default(r, t)), e);
            }), Dt(bt(a), "onYearKeyDown", function(e, t) {
                var r = e.key;
                if (!a.props.disabledKeyboardNavigation) switch(r){
                    case "Enter":
                        a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
                        break;
                    case "ArrowRight":
                        a.handleYearNavigation(t + 1, ge.default(a.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        a.handleYearNavigation(t - 1, Ce.default(a.props.preSelection, 1));
                }
            }), Dt(bt(a), "getYearClassNames", function(e) {
                var t = a.props, r = t.minDate, n = t.maxDate, o = t.selected;
                return ce.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Ie.default(o),
                    "react-datepicker__year-text--disabled": (r || n) && ir(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }), Dt(bt(a), "getYearTabIndex", function(e) {
                return a.props.disabledKeyboardNavigation ? "-1" : e === Ie.default(a.props.preSelection) ? "0" : "-1";
            }), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, a = br(r.date, r.yearItemNumber), n = a.startPeriod, o = a.endPeriod, s = function(r) {
                        t.push(de.default.createElement("div", {
                            ref: e.YEAR_REFS[r - n],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, r));
                    }, i = n; i <= o; i++)s(i);
                    return de.default.createElement("div", {
                        className: "react-datepicker__year"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper"
                    }, t));
                }
            }
        ]), r;
    }(de.default.Component), Wr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "onTimeChange", function(e) {
                a.setState({
                    time: e
                });
                var t = new Date;
                t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
            }), Dt(bt(a), "renderTimeInput", function() {
                var e = a.state.time, t = a.props, r = t.date, n = t.timeString, o = t.customTimeInput;
                return o ? de.default.cloneElement(o, {
                    date: r,
                    value: e,
                    onChange: a.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        a.onTimeChange(e.target.value || n);
                    }
                });
            }), a.state = {
                time: a.props.timeString
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), r;
    }(de.default.Component);
    function Br(e) {
        var t = e.className, r = e.children, a = e.showPopperArrow, n = e.arrowProps, o = void 0 === n ? {} : n;
        return de.default.createElement("div", {
            className: t
        }, a && de.default.createElement("div", vt({
            className: "react-datepicker__triangle"
        }, o)), r);
    }
    var Kr = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Hr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "handleClickOutside", function(e) {
                a.props.onClickOutside(e);
            }), Dt(bt(a), "setClickOutsideRef", function() {
                return a.containerRef.current;
            }), Dt(bt(a), "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Kr.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && a.props.onDropdownFocus();
            }), Dt(bt(a), "getDateInView", function() {
                var e = a.props, t = e.preSelection, r = e.selected, n = e.openToDate, o = Dr(a.props), s = vr(a.props), i = Yt(), p = n || r || t;
                return p || (o && nt.default(i, o) ? o : s && at.default(i, s) ? s : i);
            }), Dt(bt(a), "increaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: we.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "decreaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Se.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "handleDayClick", function(e, t, r) {
                a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleDayMouseEnter", function(e) {
                a.setState({
                    selectingDate: e
                }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
            }), Dt(bt(a), "handleMonthMouseLeave", function() {
                a.setState({
                    selectingDate: null
                }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
            }), Dt(bt(a), "handleYearChange", function(e) {
                a.props.onYearChange && a.props.onYearChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthChange", function(e) {
                a.props.onMonthChange && a.props.onMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthYearChange", function(e) {
                a.handleYearChange(e), a.handleMonthChange(e);
            }), Dt(bt(a), "changeYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(r, e)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonth", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Ae.default(r, e)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonthYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(Ae.default(r, Oe.default(e)), Ie.default(e))
                    };
                }, function() {
                    return a.handleMonthYearChange(a.state.date);
                });
            }), Dt(bt(a), "header", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = Bt(e, a.props.locale, a.props.calendarStartDay), r = [];
                return a.props.showWeekNumbers && r.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, a.props.weekLabel || "#")), r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var r = De.default(t, e), n = a.formatWeekday(r, a.props.locale), o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
                    return de.default.createElement("div", {
                        key: e,
                        className: ce.default("react-datepicker__day-name", o)
                    }, n);
                }));
            }), Dt(bt(a), "formatWeekday", function(e, t) {
                return a.props.formatWeekDay ? function(e, t, r) {
                    return t(Lt(e, "EEEE", r));
                }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function(e, t) {
                    return Lt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Lt(e, "EEEEEE", t);
                }(e, t);
            }), Dt(bt(a), "decreaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Ce.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderPreviousButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = mr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.yearItemNumber, n = void 0 === a ? xt : a, o = br(Ht(Ce.default(e, n)), n).endPeriod, s = r && Ie.default(r);
                                return s && s > o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = fr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], r = a.decreaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = a.props, l = p.previousMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l, c = p.previousYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Previous Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "increaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ge.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderNextButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = yr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.yearItemNumber, n = void 0 === a ? xt : a, o = br(ge.default(e, n), n).startPeriod, s = r && Ie.default(r);
                                return s && s < o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = hr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var r = a.increaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = a.props, l = p.nextMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Next Month" : l, c = p.nextYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Next Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: t.join(" ")
                }, Lt(e, a.props.dateFormat, a.props.locale));
            }), Dt(bt(a), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showYearDropdown && !e) return de.default.createElement(Mr, {
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    date: a.state.date,
                    onSelect: a.props.onSelect,
                    setOpen: a.props.setOpen,
                    dropdownMode: a.props.dropdownMode,
                    onChange: a.changeYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    year: Ie.default(a.state.date),
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber
                });
            }), Dt(bt(a), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthDropdown && !e) return de.default.createElement(Nr, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    onChange: a.changeMonth,
                    month: Oe.default(a.state.date),
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown
                });
            }), Dt(bt(a), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthYearDropdown && !e) return de.default.createElement(Ir, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    dateFormat: a.props.dateFormat,
                    onChange: a.changeMonthYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    date: a.state.date,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
                });
            }), Dt(bt(a), "renderTodayButton", function() {
                if (a.props.todayButton && !a.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return a.props.onSelect(Ve.default(Yt()), e);
                    }
                }, a.props.todayButton);
            }), Dt(bt(a), "renderDefaultHeader", function(e) {
                var t = e.monthDate, r = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, a.renderCurrentMonth(t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
                    onFocus: a.handleDropdownFocus
                }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, r = e.i;
                if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
                var n = fr(a.state.date, a.props), o = hr(a.state.date, a.props), s = mr(a.state.date, a.props), i = yr(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: a.props.onDropdownFocus
                }, a.props.renderCustomHeader(ut(ut({}, a.state), {}, {
                    customHeaderCount: r,
                    monthDate: t,
                    changeMonth: a.changeMonth,
                    changeYear: a.changeYear,
                    decreaseMonth: a.decreaseMonth,
                    increaseMonth: a.increaseMonth,
                    decreaseYear: a.decreaseYear,
                    increaseYear: a.increaseYear,
                    prevMonthButtonDisabled: n,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderYearHeader", function() {
                var e = a.state.date, t = a.props, r = t.showYearPicker, n = br(e, t.yearItemNumber), o = n.startPeriod, s = n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, r ? "".concat(o, " - ").concat(s) : Ie.default(e));
            }), Dt(bt(a), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== a.props.renderCustomHeader:
                        return a.renderCustomHeader(e);
                    case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
                        return a.renderYearHeader(e);
                    default:
                        return a.renderDefaultHeader(e);
                }
            }), Dt(bt(a), "renderMonths", function() {
                if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
                    for(var e = [], t = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, r = Se.default(a.state.date, t), n = 0; n < a.props.monthsShown; ++n){
                        var o = n - a.props.monthSelectedIn, s = we.default(r, o), i = "month-".concat(n), p = n < a.props.monthsShown - 1, l = n > 0;
                        e.push(de.default.createElement("div", {
                            key: i,
                            ref: function(e) {
                                a.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, a.renderHeader({
                            monthDate: s,
                            i: n
                        }), de.default.createElement(Fr, {
                            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: a.props.monthAriaLabelPrefix,
                            onChange: a.changeMonthYear,
                            day: s,
                            dayClassName: a.props.dayClassName,
                            calendarStartDay: a.props.calendarStartDay,
                            monthClassName: a.props.monthClassName,
                            onDayClick: a.handleDayClick,
                            handleOnKeyDown: a.props.handleOnDayKeyDown,
                            onDayMouseEnter: a.handleDayMouseEnter,
                            onMouseLeave: a.handleMonthMouseLeave,
                            onWeekSelect: a.props.onWeekSelect,
                            orderInDisplay: n,
                            formatWeekNumber: a.props.formatWeekNumber,
                            locale: a.props.locale,
                            minDate: a.props.minDate,
                            maxDate: a.props.maxDate,
                            excludeDates: a.props.excludeDates,
                            excludeDateIntervals: a.props.excludeDateIntervals,
                            highlightDates: a.props.highlightDates,
                            selectingDate: a.state.selectingDate,
                            includeDates: a.props.includeDates,
                            includeDateIntervals: a.props.includeDateIntervals,
                            inline: a.props.inline,
                            shouldFocusDayInline: a.props.shouldFocusDayInline,
                            fixedHeight: a.props.fixedHeight,
                            filterDate: a.props.filterDate,
                            preSelection: a.props.preSelection,
                            setPreSelection: a.props.setPreSelection,
                            selected: a.props.selected,
                            selectsStart: a.props.selectsStart,
                            selectsEnd: a.props.selectsEnd,
                            selectsRange: a.props.selectsRange,
                            selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                            showWeekNumbers: a.props.showWeekNumbers,
                            startDate: a.props.startDate,
                            endDate: a.props.endDate,
                            peekNextMonth: a.props.peekNextMonth,
                            setOpen: a.props.setOpen,
                            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                            renderDayContents: a.props.renderDayContents,
                            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                            showMonthYearPicker: a.props.showMonthYearPicker,
                            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                            showYearPicker: a.props.showYearPicker,
                            showQuarterYearPicker: a.props.showQuarterYearPicker,
                            isInputFocused: a.props.isInputFocused,
                            containerRef: a.containerRef,
                            monthShowsDuplicateDaysEnd: p,
                            monthShowsDuplicateDaysStart: l
                        })));
                    }
                    return e;
                }
            }), Dt(bt(a), "renderYears", function() {
                if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, a.renderHeader(), de.default.createElement(qr, vt({
                    onDayClick: a.handleDayClick,
                    date: a.state.date
                }, a.props))) : void 0;
            }), Dt(bt(a), "renderTimeSection", function() {
                if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return de.default.createElement(Ar, {
                    selected: a.props.selected,
                    openToDate: a.props.openToDate,
                    onChange: a.props.onTimeChange,
                    timeClassName: a.props.timeClassName,
                    format: a.props.timeFormat,
                    includeTimes: a.props.includeTimes,
                    intervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    todayButton: a.props.todayButton,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    monthRef: a.state.monthContainer,
                    injectTimes: a.props.injectTimes,
                    locale: a.props.locale,
                    handleOnKeyDown: a.props.handleOnKeyDown,
                    showTimeSelectOnly: a.props.showTimeSelectOnly
                });
            }), Dt(bt(a), "renderInputTimeSection", function() {
                var e = new Date(a.props.selected), t = Tt(e) && Boolean(a.props.selected) ? "".concat(kr(e.getHours()), ":").concat(kr(e.getMinutes())) : "";
                if (a.props.showTimeInput) return de.default.createElement(Wr, {
                    date: e,
                    timeString: t,
                    timeInputLabel: a.props.timeInputLabel,
                    onChange: a.props.onTimeChange,
                    customTimeInput: a.props.customTimeInput
                });
            }), a.containerRef = de.default.createRef(), a.state = {
                date: a.getDateInView(),
                selectingDate: null,
                monthContainer: null
            }, a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.props.preSelection && !$t(this.props.preSelection, e.preSelection) ? this.setState({
                        date: this.props.preSelection
                    }) : this.props.openToDate && !$t(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Br;
                    return de.default.createElement("div", {
                        ref: this.containerRef
                    }, de.default.createElement(e, {
                        className: ce.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow,
                        arrowProps: this.props.arrowProps
                    }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        monthSelectedIn: 0,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: xt
                    };
                }
            }
        ]), r;
    }(de.default.Component), jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return dt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), r;
    }(de.default.Component), Qr = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, Vr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getTabChildren", function() {
                return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Qr);
            }), Dt(bt(a), "handleFocusStart", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[t.length - 1].focus();
            }), Dt(bt(a), "handleFocusEnd", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[0].focus();
            }), a.tabLoopRef = de.default.createRef(), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Ur = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            return ht(this, r), t.apply(this, arguments);
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, n = t.hidePopper, o = t.popperComponent, s = t.popperModifiers, i = t.popperPlacement, p = t.popperProps, l = t.targetComponent, d = t.enableTabLoop, c = t.popperOnKeyDown, u = t.portalId, f = t.portalHost;
                    if (!n) {
                        var h = ce.default("react-datepicker-popper", r);
                        e = de.default.createElement(pe.Popper, vt({
                            modifiers: s,
                            placement: i
                        }, p), function(e) {
                            var t = e.ref, r = e.style, a = e.placement, n = e.arrowProps;
                            return de.default.createElement(Vr, {
                                enableTabLoop: d
                            }, de.default.createElement("div", {
                                ref: t,
                                style: r,
                                className: h,
                                "data-placement": a,
                                onKeyDown: c
                            }, de.default.cloneElement(o, {
                                arrowProps: n
                            })));
                        });
                    }
                    this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = de.default.createElement(jr, {
                        portalId: u,
                        portalHost: f
                    }, e));
                    var m = ce.default("react-datepicker-wrapper", a);
                    return de.default.createElement(pe.Manager, {
                        className: "react-datepicker-manager"
                    }, de.default.createElement(pe.Reference, null, function(e) {
                        var t = e.ref;
                        return de.default.createElement("div", {
                            ref: t,
                            className: m
                        }, l);
                    }), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0,
                        popperModifiers: [],
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(de.default.Component), $r = "react-datepicker-ignore-onclickoutside", zr = lt.default(Hr);
    var Gr = "Date input not valid.", Jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getPreSelection", function() {
                return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Yt();
            }), Dt(bt(a), "calcInitialState", function() {
                var e, t = a.getPreSelection(), r = Dr(a.props), n = vr(a.props), o = r && nt.default(t, Ve.default(r)) ? r : n && at.default(t, Je.default(n)) ? n : t;
                return {
                    open: a.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
                    highlightDates: wr(a.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1
                };
            }), Dt(bt(a), "clearPreventFocusTimeout", function() {
                a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
            }), Dt(bt(a), "setFocus", function() {
                a.input && a.input.focus && a.input.focus({
                    preventScroll: !0
                });
            }), Dt(bt(a), "setBlur", function() {
                a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
            }), Dt(bt(a), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                a.setState({
                    open: e,
                    preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
                    lastPreSelectChange: Zr
                }, function() {
                    e || a.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && a.setBlur(), a.setState({
                            inputValue: null
                        });
                    });
                });
            }), Dt(bt(a), "inputOk", function() {
                return ue.default(a.state.preSelection);
            }), Dt(bt(a), "isCalendarOpen", function() {
                return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
            }), Dt(bt(a), "handleFocus", function(e) {
                a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
                    focused: !0
                });
            }), Dt(bt(a), "cancelFocusInput", function() {
                clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
            }), Dt(bt(a), "deferFocusInput", function() {
                a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
                    return a.setFocus();
                }, 1);
            }), Dt(bt(a), "handleDropdownFocus", function() {
                a.cancelFocusInput();
            }), Dt(bt(a), "handleBlur", function(e) {
                (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
                    focused: !1
                });
            }), Dt(bt(a), "handleCalendarClickOutside", function(e) {
                a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
            }), Dt(bt(a), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = t[0];
                if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(bt(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    a.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: Xr
                    });
                    var o = It(n.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing, a.props.minDate);
                    !o && n.target.value || a.setSelected(o, n, !0);
                }
            }), Dt(bt(a), "handleSelect", function(e, t, r) {
                if (a.setState({
                    preventFocus: !0
                }, function() {
                    return a.preventFocusTimeout = setTimeout(function() {
                        return a.setState({
                            preventFocus: !1
                        });
                    }, 50), a.preventFocusTimeout;
                }), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, r), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);
                else if (!a.props.inline) {
                    a.props.selectsRange || a.setOpen(!1);
                    var n = a.props, o = n.startDate, s = n.endDate;
                    !o || s || nt.default(e, o) || a.setOpen(!1);
                }
            }), Dt(bt(a), "setSelected", function(e, t, r, n) {
                var o = e;
                if (null === o || !rr(o, a.props)) {
                    var s = a.props, i = s.onChange, p = s.selectsRange, l = s.startDate, d = s.endDate;
                    if (!zt(a.props.selected, o) || a.props.allowSameDay || p) {
                        if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Ft(o, {
                            hour: Pe.default(a.props.selected),
                            minute: Me.default(a.props.selected),
                            second: _e.default(a.props.selected)
                        })), a.props.inline || a.setState({
                            preSelection: o
                        }), a.props.focusSelectedMonth || a.setState({
                            monthSelectedIn: n
                        })), p) {
                            var c = l && !d, u = l && d;
                            !l && !d ? i([
                                o,
                                null
                            ], t) : c && (nt.default(o, l) ? i([
                                o,
                                null
                            ], t) : i([
                                l,
                                o
                            ], t)), u && i([
                                o,
                                null
                            ], t);
                        } else i(o, t);
                    }
                    r || (a.props.onSelect(o, t), a.setState({
                        inputValue: null
                    }));
                }
            }), Dt(bt(a), "setPreSelection", function(e) {
                var t = void 0 !== a.props.minDate, r = void 0 !== a.props.maxDate, n = !0;
                if (e) {
                    var o = Ve.default(e);
                    if (t && r) n = Gt(e, a.props.minDate, a.props.maxDate);
                    else if (t) {
                        var s = Ve.default(a.props.minDate);
                        n = at.default(e, s) || zt(o, s);
                    } else if (r) {
                        var i = Je.default(a.props.maxDate);
                        n = nt.default(e, i) || zt(o, i);
                    }
                }
                n && a.setState({
                    preSelection: e
                });
            }), Dt(bt(a), "handleTimeChange", function(e) {
                var t = Ft(a.props.selected ? a.props.selected : a.getPreSelection(), {
                    hour: Pe.default(e),
                    minute: Me.default(e)
                });
                a.setState({
                    preSelection: t
                }), a.props.onChange(t), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "onInputClick", function() {
                a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
            }), Dt(bt(a), "onInputKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key;
                if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
                    if (a.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var r = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                            return void (r && r.focus({
                                preventScroll: !0
                            }));
                        }
                        var n = Yt(a.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === Zr ? (a.handleSelect(n, e), !a.props.shouldCloseOnSelect && a.setPreSelection(n)) : a.setOpen(!1)) : "Escape" === t && (e.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({
                            code: 1,
                            msg: Gr
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
            }), Dt(bt(a), "onDayKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key, r = Yt(a.state.preSelection);
                if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);
                else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
                    code: 1,
                    msg: Gr
                });
                else if (!a.props.disabledKeyboardNavigation) {
                    var n;
                    switch(t){
                        case "ArrowLeft":
                            n = ke.default(r, 1);
                            break;
                        case "ArrowRight":
                            n = De.default(r, 1);
                            break;
                        case "ArrowUp":
                            n = be.default(r, 1);
                            break;
                        case "ArrowDown":
                            n = ve.default(r, 1);
                            break;
                        case "PageUp":
                            n = Se.default(r, 1);
                            break;
                        case "PageDown":
                            n = we.default(r, 1);
                            break;
                        case "Home":
                            n = Ce.default(r, 1);
                            break;
                        case "End":
                            n = ge.default(r, 1);
                    }
                    if (!n) return void (a.props.onInputError && a.props.onInputError({
                        code: 1,
                        msg: Gr
                    }));
                    if (e.preventDefault(), a.setState({
                        lastPreSelectChange: Zr
                    }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
                        var o = Oe.default(r), s = Oe.default(n), i = Ie.default(r), p = Ie.default(n);
                        o !== s || i !== p ? a.setState({
                            shouldFocusDayInline: !0
                        }) : a.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Dt(bt(a), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.setOpen(!1), setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Dt(bt(a), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), a.props.selectsRange ? a.props.onChange([
                    null,
                    null
                ], e) : a.props.onChange(null, e), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "clear", function() {
                a.onClearClick();
            }), Dt(bt(a), "onScroll", function(e) {
                "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
            }), Dt(bt(a), "renderCalendar", function() {
                return a.props.inline || a.isCalendarOpen() ? de.default.createElement(zr, {
                    ref: function(e) {
                        a.calendar = e;
                    },
                    locale: a.props.locale,
                    calendarStartDay: a.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: a.props.monthAriaLabelPrefix,
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    setOpen: a.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    dateFormat: a.props.dateFormatCalendar,
                    useWeekdaysShort: a.props.useWeekdaysShort,
                    formatWeekDay: a.props.formatWeekDay,
                    dropdownMode: a.props.dropdownMode,
                    selected: a.props.selected,
                    preSelection: a.state.preSelection,
                    onSelect: a.handleSelect,
                    onWeekSelect: a.props.onWeekSelect,
                    openToDate: a.props.openToDate,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    selectsRange: a.props.selectsRange,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    excludeDates: a.props.excludeDates,
                    excludeDateIntervals: a.props.excludeDateIntervals,
                    filterDate: a.props.filterDate,
                    onClickOutside: a.handleCalendarClickOutside,
                    formatWeekNumber: a.props.formatWeekNumber,
                    highlightDates: a.state.highlightDates,
                    includeDates: a.props.includeDates,
                    includeDateIntervals: a.props.includeDateIntervals,
                    includeTimes: a.props.includeTimes,
                    injectTimes: a.props.injectTimes,
                    inline: a.props.inline,
                    shouldFocusDayInline: a.state.shouldFocusDayInline,
                    peekNextMonth: a.props.peekNextMonth,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showPreviousMonths: a.props.showPreviousMonths,
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showWeekNumbers: a.props.showWeekNumbers,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    forceShowMonthNavigation: a.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
                    todayButton: a.props.todayButton,
                    weekLabel: a.props.weekLabel,
                    outsideClickIgnoreClass: $r,
                    fixedHeight: a.props.fixedHeight,
                    monthsShown: a.props.monthsShown,
                    monthSelectedIn: a.state.monthSelectedIn,
                    onDropdownFocus: a.handleDropdownFocus,
                    onMonthChange: a.props.onMonthChange,
                    onYearChange: a.props.onYearChange,
                    dayClassName: a.props.dayClassName,
                    weekDayClassName: a.props.weekDayClassName,
                    monthClassName: a.props.monthClassName,
                    timeClassName: a.props.timeClassName,
                    showTimeSelect: a.props.showTimeSelect,
                    showTimeSelectOnly: a.props.showTimeSelectOnly,
                    onTimeChange: a.handleTimeChange,
                    timeFormat: a.props.timeFormat,
                    timeIntervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    className: a.props.calendarClassName,
                    container: a.props.calendarContainer,
                    yearItemNumber: a.props.yearItemNumber,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: a.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: a.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: a.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: a.props.nextMonthButtonLabel,
                    previousYearAriaLabel: a.props.previousYearAriaLabel,
                    previousYearButtonLabel: a.props.previousYearButtonLabel,
                    nextYearAriaLabel: a.props.nextYearAriaLabel,
                    nextYearButtonLabel: a.props.nextYearButtonLabel,
                    timeInputLabel: a.props.timeInputLabel,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    renderCustomHeader: a.props.renderCustomHeader,
                    popperProps: a.props.popperProps,
                    renderDayContents: a.props.renderDayContents,
                    onDayMouseEnter: a.props.onDayMouseEnter,
                    onMonthMouseLeave: a.props.onMonthMouseLeave,
                    selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                    showTimeInput: a.props.showTimeInput,
                    showMonthYearPicker: a.props.showMonthYearPicker,
                    showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                    showYearPicker: a.props.showYearPicker,
                    showQuarterYearPicker: a.props.showQuarterYearPicker,
                    showPopperArrow: a.props.showPopperArrow,
                    excludeScrollbar: a.props.excludeScrollbar,
                    handleOnKeyDown: a.props.onKeyDown,
                    handleOnDayKeyDown: a.onDayKeyDown,
                    isInputFocused: a.state.focused,
                    customTimeInput: a.props.customTimeInput,
                    setPreSelection: a.setPreSelection
                }, a.props.children) : null;
            }), Dt(bt(a), "renderDateInput", function() {
                var e, t = ce.default(a.props.className, Dt({}, $r, a.state.open)), r = a.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), n = a.props.customInputRef || "ref", o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var a = Rt(e, r), n = t ? Rt(t, r) : "";
                    return "".concat(a, " - ").concat(n);
                }(a.props.startDate, a.props.endDate, a.props) : Rt(a.props.selected, a.props);
                return de.default.cloneElement(r, (Dt(e = {}, n, function(e) {
                    a.input = e;
                }), Dt(e, "value", o), Dt(e, "onBlur", a.handleBlur), Dt(e, "onChange", a.handleChange), Dt(e, "onClick", a.onInputClick), Dt(e, "onFocus", a.handleFocus), Dt(e, "onKeyDown", a.onInputKeyDown), Dt(e, "id", a.props.id), Dt(e, "name", a.props.name), Dt(e, "autoFocus", a.props.autoFocus), Dt(e, "placeholder", a.props.placeholderText), Dt(e, "disabled", a.props.disabled), Dt(e, "autoComplete", a.props.autoComplete), Dt(e, "className", ce.default(r.props.className, t)), Dt(e, "title", a.props.title), Dt(e, "readOnly", a.props.readOnly), Dt(e, "required", a.props.required), Dt(e, "tabIndex", a.props.tabIndex), Dt(e, "aria-describedby", a.props.ariaDescribedBy), Dt(e, "aria-invalid", a.props.ariaInvalid), Dt(e, "aria-labelledby", a.props.ariaLabelledBy), Dt(e, "aria-required", a.props.ariaRequired), e));
            }), Dt(bt(a), "renderClearButton", function() {
                var e = a.props, t = e.isClearable, r = e.selected, n = e.startDate, o = e.endDate, s = e.clearButtonTitle, i = e.clearButtonClassName, p = void 0 === i ? "" : i, l = e.ariaLabelClose, d = void 0 === l ? "Close" : l;
                return !t || null == r && null == n && null == o ? null : de.default.createElement("button", {
                    type: "button",
                    className: "react-datepicker__close-icon ".concat(p).trim(),
                    "aria-label": d,
                    onClick: a.onClearClick,
                    title: s,
                    tabIndex: -1
                });
            }), a.state = a.calcInitialState(), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, a;
                    e.inline && (r = e.selected, a = this.props.selected, r && a ? Oe.default(r) !== Oe.default(a) || Ie.default(r) !== Ie.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: wr(this.props.highlightDates)
                    }), t.focused || zt(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container"
                    }, this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? de.default.createElement("div", {
                            className: "react-datepicker__portal"
                        }, e) : null;
                        return this.state.open && this.props.portalId && (t = de.default.createElement(jr, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), de.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return de.default.createElement(Ur, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: xt,
                        renderDayContents: function(e) {
                            return e;
                        },
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Xr = "input", Zr = "navigate";
    e.CalendarContainer = Br, e.default = Jr, e.getDefaultLocale = Jt, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

},{"55b400dfb9477df9":"d8NEQ","6a082dc438cb1ca2":"jEkrD","3647656f9c7ebc5e":"keQ4Y","13c776570732a9da":"dT5AY","6553b0b4b603e1c3":"d5v85","d7b993ace1eca80":"g05d2","786b9925c1b6b5ed":"39TMu","4f1b37d05fed00b3":"1BsMD","5fc940b8b11b2f30":"beyui","b78d0278e54da1b4":"1dN3f","baecc74d7df402ea":"ijaw2","7360dafd9cf06bde":"cm4V5","376cbc5302b1ec0d":"6Aom7","f011acafa9d72da6":"lis7p","aa659b497503e983":"1Kohj","7b7bf8fb2c20e0c7":"aShM3","f501b8cd52ae4ff":"hkqcp","9e212fc4b323ed41":"aXlcv","e8ff49b0d1cab426":"92I2h","12eec1f6d562e008":"8xIgL","72fc20cc52029f11":"boQfE","42e3036b4499153e":"lr8VL","5592c752ef1290f4":"kEbjg","8406427195a66845":"aJOlE","fa470ac376b26caf":"fVsbj","bf3222da2f520817":"9DsUB","685dda4962dc82e1":"Xa7qF","d6dea87c85b53e02":"bF4ql","b9a1398c1c94250d":"fbCzF","e1fbbdf633f9e5ae":"aW8FH","8ac41f1b252a0973":"d0Ijt","156a522b3b8fd124":"hCl3O","f2620442a53b80d6":"jxmSK","1b94d4eb34edeca3":"8wAIN","47020b485e994171":"j4bzO","9818583261d8a102":"82rt1","1a7d4440a348b466":"2A50r","50dce9ec585a5332":"82nH1","a738370d89dd61ec":"5Puy8","cdc90b6df52760f":"g5suo","2fdd28e51cf3c8b2":"6DwzE","72fb68fdc0d9bca3":"d7uVr","964e71bf85841794":"jkvTC","38468de993ee0549":"jy2Lb","ec1866b328e982ea":"26ekz","5c05196fbf6d6b4d":"gjsAr","9a6937c0aa7a418e":"kPZY1","23c6d2169b7feabe":"17c4z","fda4089c257f1876":"dpLfD","b5061c3c95f48e73":"82dIZ","f57afb99b9b06613":"iNMQ0","496ef8c8ed2b34d6":"lm2KY","6663b9b2b265a941":"fsoQJ","c3348d940b830a7f":"cOi2Z","53a4aaeeb87e1c51":"eLajm","45f66dd8a17e85aa":"bayIk","a3a5398768dc185f":"enGhO","201a807b2e6adc5e":"hHoRV","a89a534c753bb4c3":"gp07A","11a993db5effee60":"jRD2l","96de361de41dc920":"cy9SD","acb830835f9d8af1":"juvm1"}],"jEkrD":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"eTn0I"}],"eTn0I":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"5JPkk"}],"5JPkk":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"keQ4Y":[function(require,module,exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"dT5AY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isDate);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || _typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

},{"../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dd8zJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requiredArgs);
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d5v85":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isValid);
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"dT5AY","../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"enGhO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g05d2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError("Invalid time value");
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"d5v85","../subMilliseconds/index.js":"kZIam","../toDate/index.js":"enGhO","../_lib/format/formatters/index.js":"1zbsI","../_lib/format/longFormatters/index.js":"604Ra","../_lib/getTimezoneOffsetInMilliseconds/index.js":"2i94P","../_lib/protectedTokens/index.js":"V34JB","../_lib/toInteger/index.js":"ly2q2","../_lib/requiredArgs/index.js":"dd8zJ","../_lib/defaultOptions/index.js":"fqv9U","../_lib/defaultLocale/index.js":"g3xWM","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kZIam":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMilliseconds);
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"4VBJ7","../_lib/requiredArgs/index.js":"dd8zJ","../_lib/toInteger/index.js":"ly2q2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4VBJ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMilliseconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"ly2q2","../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ly2q2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toInteger);
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1zbsI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
         // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date); // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"uGgIi","../../../_lib/getUTCISOWeek/index.js":"3pJa3","../../../_lib/getUTCISOWeekYear/index.js":"f9AUp","../../../_lib/getUTCWeek/index.js":"f9k5U","../../../_lib/getUTCWeekYear/index.js":"4kwHD","../../addLeadingZeros/index.js":"kW4m1","../lightFormatters/index.js":"k9Dl3","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"uGgIi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCDayOfYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"enGhO","../requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3pJa3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"enGhO","../startOfUTCISOWeek/index.js":"6g4tj","../startOfUTCISOWeekYear/index.js":"aZcqh","../requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6g4tj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"enGhO","../requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aZcqh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeekYear);
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"f9AUp","../startOfUTCISOWeek/index.js":"6g4tj","../requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f9AUp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"enGhO","../requiredArgs/index.js":"dd8zJ","../startOfUTCISOWeek/index.js":"6g4tj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f9k5U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"enGhO","../startOfUTCWeek/index.js":"2qHy9","../startOfUTCWeekYear/index.js":"3Hxw6","../requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2qHy9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"enGhO","../requiredArgs/index.js":"dd8zJ","../toInteger/index.js":"ly2q2","../defaultOptions/index.js":"fqv9U","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fqv9U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3Hxw6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeekYear);
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"4kwHD","../requiredArgs/index.js":"dd8zJ","../startOfUTCWeek/index.js":"2qHy9","../toInteger/index.js":"ly2q2","../defaultOptions/index.js":"fqv9U","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4kwHD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"enGhO","../requiredArgs/index.js":"dd8zJ","../startOfUTCWeek/index.js":"2qHy9","../toInteger/index.js":"ly2q2","../defaultOptions/index.js":"fqv9U","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kW4m1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k9Dl3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"kW4m1","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"604Ra":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2i94P":[function(require,module,exports) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"V34JB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "throwProtectedError", ()=>throwProtectedError);
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g3xWM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"6Eplm","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6Eplm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: "en-US",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"7Y8FK","./_lib/formatLong/index.js":"gEl4U","./_lib/formatRelative/index.js":"kcVHZ","./_lib/localize/index.js":"96C85","./_lib/match/index.js":"dGgT2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7Y8FK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gEl4U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"78DS7","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"78DS7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kcVHZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"96C85":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"2EONQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2EONQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dGgT2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"5EzEH","../../../_lib/buildMatchPatternFn/index.js":"2pn2G","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5EzEH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchFn);
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2pn2G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"39TMu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMinutes);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_MINUTE = 60000;
function addMinutes(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

},{"../_lib/toInteger/index.js":"ly2q2","../addMilliseconds/index.js":"4VBJ7","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1BsMD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addHours);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_HOUR = 3600000;
function addHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

},{"../_lib/toInteger/index.js":"ly2q2","../addMilliseconds/index.js":"4VBJ7","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"beyui":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addDays);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"ly2q2","../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1dN3f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addWeeks);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var days = amount * 7;
    return (0, _indexJsDefault1.default)(dirtyDate, days);
}

},{"../_lib/toInteger/index.js":"ly2q2","../addDays/index.js":"beyui","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ijaw2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"ly2q2","../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cm4V5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addYears);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 12);
}

},{"../_lib/toInteger/index.js":"ly2q2","../addMonths/index.js":"ijaw2","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6Aom7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMinutes);
var _indexJs = require("../addMinutes/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMinutes(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMinutes/index.js":"39TMu","../_lib/requiredArgs/index.js":"dd8zJ","../_lib/toInteger/index.js":"ly2q2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lis7p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subHours);
var _indexJs = require("../addHours/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addHours/index.js":"1BsMD","../_lib/requiredArgs/index.js":"dd8zJ","../_lib/toInteger/index.js":"ly2q2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1Kohj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subDays);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addDays/index.js":"beyui","../_lib/requiredArgs/index.js":"dd8zJ","../_lib/toInteger/index.js":"ly2q2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aShM3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subWeeks);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addWeeks/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"ly2q2","../addWeeks/index.js":"1dN3f","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hkqcp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"ly2q2","../addMonths/index.js":"ijaw2","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aXlcv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subYears);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"ly2q2","../addYears/index.js":"cm4V5","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"92I2h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getSeconds);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getSeconds(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8xIgL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMinutes);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMinutes(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"boQfE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHours);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getHours(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lr8VL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kEbjg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDate);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDate(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aJOlE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getISOWeek);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../toDate/index.js":"enGhO","../startOfISOWeek/index.js":"hjtbC","../startOfISOWeekYear/index.js":"ezNW6","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hjtbC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfISOWeek);
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../startOfWeek/index.js":"d7uVr","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d7uVr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfWeek);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"enGhO","../_lib/toInteger/index.js":"ly2q2","../_lib/requiredArgs/index.js":"dd8zJ","../_lib/defaultOptions/index.js":"fqv9U","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ezNW6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfISOWeekYear);
var _indexJs = require("../getISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getISOWeekYear/index.js":"5zLCc","../startOfISOWeek/index.js":"hjtbC","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5zLCc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getISOWeekYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../toDate/index.js":"enGhO","../startOfISOWeek/index.js":"hjtbC","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fVsbj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9DsUB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getQuarter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"Xa7qF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getFullYear();
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bF4ql":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTime);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fbCzF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setSeconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setSeconds(dirtyDate, dirtySeconds) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var seconds = (0, _indexJsDefault.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

},{"../_lib/toInteger/index.js":"ly2q2","../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aW8FH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMinutes);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setMinutes(dirtyDate, dirtyMinutes) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var minutes = (0, _indexJsDefault.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

},{"../_lib/toInteger/index.js":"ly2q2","../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d0Ijt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setHours);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setHours(dirtyDate, dirtyHours) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var hours = (0, _indexJsDefault.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

},{"../_lib/toInteger/index.js":"ly2q2","../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hCl3O":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMonth);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDaysInMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setMonth(dirtyDate, dirtyMonth) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var month = (0, _indexJsDefault.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _indexJsDefault2.default)(dateWithDesiredMonth); // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

},{"../_lib/toInteger/index.js":"ly2q2","../toDate/index.js":"enGhO","../getDaysInMonth/index.js":"8Lcbd","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8Lcbd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDaysInMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDaysInMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jxmSK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setQuarter);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../setMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setQuarter(dirtyDate, dirtyQuarter) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var quarter = (0, _indexJsDefault.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, _indexJsDefault2.default)(date, date.getMonth() + diff * 3);
}

},{"../_lib/toInteger/index.js":"ly2q2","../toDate/index.js":"enGhO","../setMonth/index.js":"hCl3O","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8wAIN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setYear);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setYear(dirtyDate, dirtyYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = (0, _indexJsDefault.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

},{"../_lib/toInteger/index.js":"ly2q2","../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j4bzO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function min(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if (_typeof(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"82rt1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function max(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if (_typeof(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2A50r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarDays);
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"2i94P","../startOfDay/index.js":"6DwzE","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6DwzE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"82nH1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarMonths);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5Puy8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarWeeks);
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_WEEK = 604800000;
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfWeekLeft = (0, _indexJsDefault.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, _indexJsDefault.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, _indexJsDefault1.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, _indexJsDefault1.default)(startOfWeekRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

},{"../startOfWeek/index.js":"d7uVr","../_lib/getTimezoneOffsetInMilliseconds/index.js":"2i94P","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g5suo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarYears);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jkvTC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jy2Lb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfQuarter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"26ekz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var cleanDate = (0, _indexJsDefault.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gjsAr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kPZY1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfWeek);
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../_lib/defaultOptions/index.js":"fqv9U","../toDate/index.js":"enGhO","../_lib/toInteger/index.js":"ly2q2","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"17c4z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dpLfD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isEqual);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isEqual(dirtyLeftDate, dirtyRightDate) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyLeftDate);
    var dateRight = (0, _indexJsDefault.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"82dIZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameDay);
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfDay = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

},{"../startOfDay/index.js":"6DwzE","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iNMQ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lm2KY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameYear(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fsoQJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameQuarter);
var _indexJs = require("../startOfQuarter/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

},{"../startOfQuarter/index.js":"jy2Lb","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cOi2Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAfter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eLajm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isBefore);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bayIk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isWithinInterval);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWithinInterval(dirtyDate, interval) {
    (0, _indexJsDefault1.default)(2, arguments);
    var time = (0, _indexJsDefault.default)(dirtyDate).getTime();
    var startTime = (0, _indexJsDefault.default)(interval.start).getTime();
    var endTime = (0, _indexJsDefault.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}

},{"../toDate/index.js":"enGhO","../_lib/requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hHoRV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parse);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    }; // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = _createForOfIteratorHelper(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                 // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                 // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if (_typeof(_ret) === "object") return _ret.v;
        } // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]); // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"../_lib/defaultLocale/index.js":"g3xWM","../subMilliseconds/index.js":"kZIam","../toDate/index.js":"enGhO","../_lib/assign/index.js":"bOeQP","../_lib/format/longFormatters/index.js":"604Ra","../_lib/getTimezoneOffsetInMilliseconds/index.js":"2i94P","../_lib/protectedTokens/index.js":"V34JB","../_lib/toInteger/index.js":"ly2q2","../_lib/requiredArgs/index.js":"dd8zJ","./_lib/Setter.js":"diGkd","./_lib/parsers/index.js":"8pnbF","../_lib/defaultOptions/index.js":"fqv9U","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bOeQP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assign);
function assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"diGkd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", ()=>Setter);
parcelHelpers.export(exports, "ValueSetter", ()=>ValueSetter);
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", ()=>DateToSystemTimezoneSetter);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        _classCallCheck(this, Setter);
        _defineProperty(this, "subPriority", 0);
    }
    _createClass(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    _inherits(ValueSetter, _Setter);
    var _super = _createSuper(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        _classCallCheck(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    _createClass(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    _inherits(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = _createSuper(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        _classCallCheck(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);
        return _this2;
    }
    _createClass(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8pnbF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", ()=>parsers);
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"izMZn","./YearParser.js":"4CJFm","./LocalWeekYearParser.js":"fcALk","./ISOWeekYearParser.js":"jO6am","./ExtendedYearParser.js":"ixxWu","./QuarterParser.js":"34TjF","./StandAloneQuarterParser.js":"ckaqZ","./MonthParser.js":"84OH9","./StandAloneMonthParser.js":"2Yj2o","./LocalWeekParser.js":"hZnNF","./ISOWeekParser.js":"lgDG3","./DateParser.js":"lCtfI","./DayOfYearParser.js":"oTsgg","./DayParser.js":"6muRd","./LocalDayParser.js":"jzAL2","./StandAloneLocalDayParser.js":"adwcb","./ISODayParser.js":"cYKVu","./AMPMParser.js":"l66S5","./AMPMMidnightParser.js":"2NRKW","./DayPeriodParser.js":"9Jzee","./Hour1to12Parser.js":"6RLac","./Hour0to23Parser.js":"iTmIR","./Hour0To11Parser.js":"768BY","./Hour1To24Parser.js":"bwx1E","./MinuteParser.js":"1w97o","./SecondParser.js":"f7sNU","./FractionOfSecondParser.js":"aZHYA","./ISOTimezoneWithZParser.js":"gV42y","./ISOTimezoneParser.js":"4MSwO","./TimestampSecondsParser.js":"04Dpy","./TimestampMillisecondsParser.js":"e6FbX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"izMZn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", ()=>EraParser);
var _parserJs = require("../Parser.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var EraParser = /*#__PURE__*/ function(_Parser) {
    _inherits(EraParser, _Parser);
    var _super = _createSuper(EraParser);
    function EraParser() {
        var _this;
        _classCallCheck(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 140);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9az6q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _setterJs = require("./Setter.js");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        _classCallCheck(this, Parser);
    }
    _createClass(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"./Setter.js":"diGkd","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4CJFm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", ()=>YearParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var YearParser = /*#__PURE__*/ function(_Parser) {
    _inherits(YearParser, _Parser);
    var _super = _createSuper(YearParser);
    function YearParser() {
        var _this;
        _classCallCheck(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 130);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4CcZu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
parcelHelpers.export(exports, "parseNumericPattern", ()=>parseNumericPattern);
parcelHelpers.export(exports, "parseTimezonePattern", ()=>parseTimezonePattern);
parcelHelpers.export(exports, "parseAnyDigitsSigned", ()=>parseAnyDigitsSigned);
parcelHelpers.export(exports, "parseNDigits", ()=>parseNDigits);
parcelHelpers.export(exports, "parseNDigitsSigned", ()=>parseNDigitsSigned);
parcelHelpers.export(exports, "dayPeriodEnumToHours", ()=>dayPeriodEnumToHours);
parcelHelpers.export(exports, "normalizeTwoDigitYear", ()=>normalizeTwoDigitYear);
parcelHelpers.export(exports, "isLeapYearIndex", ()=>isLeapYearIndex);
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"fM3jY","./constants.js":"3HTBi","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fM3jY":[function(require,module,exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3HTBi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", ()=>numericPatterns);
parcelHelpers.export(exports, "timezonePatterns", ()=>timezonePatterns);
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fcALk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", ()=>LocalWeekYearParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    _inherits(LocalWeekYearParser, _Parser);
    var _super = _createSuper(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        _classCallCheck(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 130);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","../../../_lib/getUTCWeekYear/index.js":"4kwHD","../../../_lib/startOfUTCWeek/index.js":"2qHy9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jO6am":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", ()=>ISOWeekYearParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    _inherits(ISOWeekYearParser, _Parser);
    var _super = _createSuper(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        _classCallCheck(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 130);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","../../../_lib/startOfUTCISOWeek/index.js":"6g4tj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ixxWu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", ()=>ExtendedYearParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    _inherits(ExtendedYearParser, _Parser);
    var _super = _createSuper(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        _classCallCheck(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 130);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"34TjF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", ()=>QuarterParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    _inherits(QuarterParser, _Parser);
    var _super = _createSuper(QuarterParser);
    function QuarterParser() {
        var _this;
        _classCallCheck(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 120);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ckaqZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", ()=>StandAloneQuarterParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    _inherits(StandAloneQuarterParser, _Parser);
    var _super = _createSuper(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        _classCallCheck(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 120);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"84OH9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", ()=>MonthParser);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var MonthParser = /*#__PURE__*/ function(_Parser) {
    _inherits(MonthParser, _Parser);
    var _super = _createSuper(MonthParser);
    function MonthParser() {
        var _this;
        _classCallCheck(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        _defineProperty(_assertThisInitialized(_this), "priority", 110);
        return _this;
    }
    _createClass(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"../utils.js":"4CcZu","../Parser.js":"9az6q","../constants.js":"3HTBi","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2Yj2o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", ()=>StandAloneMonthParser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    _inherits(StandAloneMonthParser, _Parser);
    var _super = _createSuper(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        _classCallCheck(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 110);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hZnNF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", ()=>LocalWeekParser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    _inherits(LocalWeekParser, _Parser);
    var _super = _createSuper(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        _classCallCheck(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 100);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","../../../_lib/setUTCWeek/index.js":"6ZnPo","../../../_lib/startOfUTCWeek/index.js":"2qHy9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6ZnPo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"ly2q2","../../toDate/index.js":"enGhO","../getUTCWeek/index.js":"f9k5U","../requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lgDG3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", ()=>ISOWeekParser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    _inherits(ISOWeekParser, _Parser);
    var _super = _createSuper(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        _classCallCheck(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 100);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","../../../_lib/setUTCISOWeek/index.js":"bZZB1","../../../_lib/startOfUTCISOWeek/index.js":"6g4tj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bZZB1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISOWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"ly2q2","../../toDate/index.js":"enGhO","../getUTCISOWeek/index.js":"3pJa3","../requiredArgs/index.js":"dd8zJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lCtfI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", ()=>DateParser);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // Day of the month
var DateParser = /*#__PURE__*/ function(_Parser) {
    _inherits(DateParser, _Parser);
    var _super = _createSuper(DateParser);
    function DateParser() {
        var _this;
        _classCallCheck(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "subPriority", 1);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"../utils.js":"4CcZu","../Parser.js":"9az6q","../constants.js":"3HTBi","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"oTsgg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", ()=>DayOfYearParser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    _inherits(DayOfYearParser, _Parser);
    var _super = _createSuper(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        _classCallCheck(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "subpriority", 1);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6muRd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", ()=>DayParser);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DayParser = /*#__PURE__*/ function(_Parser) {
    _inherits(DayParser, _Parser);
    var _super = _createSuper(DayParser);
    function DayParser() {
        var _this;
        _classCallCheck(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../../../_lib/setUTCDay/index.js":"kanER","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kanER":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCDay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"enGhO","../requiredArgs/index.js":"dd8zJ","../toInteger/index.js":"ly2q2","../defaultOptions/index.js":"fqv9U","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jzAL2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", ()=>LocalDayParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    _inherits(LocalDayParser, _Parser);
    var _super = _createSuper(LocalDayParser);
    function LocalDayParser() {
        var _this;
        _classCallCheck(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","../../../_lib/setUTCDay/index.js":"kanER","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"adwcb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", ()=>StandAloneLocalDayParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    _inherits(StandAloneLocalDayParser, _Parser);
    var _super = _createSuper(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        _classCallCheck(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","../../../_lib/setUTCDay/index.js":"kanER","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cYKVu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", ()=>ISODayParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    _inherits(ISODayParser, _Parser);
    var _super = _createSuper(ISODayParser);
    function ISODayParser() {
        var _this;
        _classCallCheck(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","../../../_lib/setUTCISODay/index.js":"2jjpR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2jjpR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISODay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"enGhO","../requiredArgs/index.js":"dd8zJ","../toInteger/index.js":"ly2q2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l66S5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", ()=>AMPMParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    _inherits(AMPMParser, _Parser);
    var _super = _createSuper(AMPMParser);
    function AMPMParser() {
        var _this;
        _classCallCheck(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 80);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2NRKW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", ()=>AMPMMidnightParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    _inherits(AMPMMidnightParser, _Parser);
    var _super = _createSuper(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        _classCallCheck(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 80);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9Jzee":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", ()=>DayPeriodParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    _inherits(DayPeriodParser, _Parser);
    var _super = _createSuper(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        _classCallCheck(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 80);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6RLac":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", ()=>Hour1to12Parser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    _inherits(Hour1to12Parser, _Parser);
    var _super = _createSuper(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        _classCallCheck(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 70);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iTmIR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", ()=>Hour0to23Parser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    _inherits(Hour0to23Parser, _Parser);
    var _super = _createSuper(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        _classCallCheck(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 70);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"768BY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", ()=>Hour0To11Parser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    _inherits(Hour0To11Parser, _Parser);
    var _super = _createSuper(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        _classCallCheck(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 70);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bwx1E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", ()=>Hour1To24Parser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    _inherits(Hour1To24Parser, _Parser);
    var _super = _createSuper(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        _classCallCheck(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 70);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1w97o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", ()=>MinuteParser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    _inherits(MinuteParser, _Parser);
    var _super = _createSuper(MinuteParser);
    function MinuteParser() {
        var _this;
        _classCallCheck(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 60);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"f7sNU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", ()=>SecondParser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var SecondParser = /*#__PURE__*/ function(_Parser) {
    _inherits(SecondParser, _Parser);
    var _super = _createSuper(SecondParser);
    function SecondParser() {
        var _this;
        _classCallCheck(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 50);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aZHYA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", ()=>FractionOfSecondParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    _inherits(FractionOfSecondParser, _Parser);
    var _super = _createSuper(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        _classCallCheck(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 30);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    _createClass(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gV42y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", ()=>ISOTimezoneWithZParser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    _inherits(ISOTimezoneWithZParser, _Parser);
    var _super = _createSuper(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        _classCallCheck(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 10);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    _createClass(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4MSwO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", ()=>ISOTimezoneParser);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    _inherits(ISOTimezoneParser, _Parser);
    var _super = _createSuper(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        _classCallCheck(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 10);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    _createClass(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../constants.js":"3HTBi","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"04Dpy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", ()=>TimestampSecondsParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    _inherits(TimestampSecondsParser, _Parser);
    var _super = _createSuper(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        _classCallCheck(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 40);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
        return _this;
    }
    _createClass(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e6FbX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", ()=>TimestampMillisecondsParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    _inherits(TimestampMillisecondsParser, _Parser);
    var _super = _createSuper(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        _classCallCheck(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 20);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
        return _this;
    }
    _createClass(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"../Parser.js":"9az6q","../utils.js":"4CcZu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gp07A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseISO);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
function parseISO(argument, options) {
    var _options$additionalDi;
    (0, _indexJsDefault.default)(1, arguments);
    var additionalDigits = (0, _indexJsDefault1.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex); // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

},{"../constants/index.js":"fM3jY","../_lib/requiredArgs/index.js":"dd8zJ","../_lib/toInteger/index.js":"ly2q2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jRD2l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IGNORE_CLASS_NAME", ()=>IGNORE_CLASS_NAME);
var _react = require("react");
var _reactDom = require("react-dom");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === "undefined" || typeof window.addEventListener !== "function") return;
    var passive = false;
    var options = Object.defineProperty({}, "passive", {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener("testPassiveEventSupport", noop, options);
    window.removeEventListener("testPassiveEventSupport", noop, options);
    return passive;
};
function autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = [
    "touchstart",
    "touchmove"
];
var IGNORE_CLASS_NAME = "ignore-react-onclickoutside";
/**
 * Options for addEventHandler and removeEventHandler
 */ function getEventHandlerOptions(instance, eventName) {
    var handlerOptions = null;
    var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && passiveEventSupport) handlerOptions = {
        passive: !instance.props.preventDefault
    };
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        _inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === "function") {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === "function") {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === "function") {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === "function") return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === "function") return instance.setClickOutsideRef();
                return (0, _reactDom.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === "undefined" || enabledInstances[_this._uid]) return;
                if (typeof passiveEventSupport === "undefined") passiveEventSupport = testPassiveEventSupport();
                enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete enabledInstances[_this._uid];
                var fn = handlersMap[_this._uid];
                if (fn && typeof document !== "undefined") {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                    });
                    delete handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = uid();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === "undefined" || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === "function") {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== "function") throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = _objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, _react.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, _react.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            "mousedown",
            "touchstart"
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: IGNORE_CLASS_NAME,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
exports.default = onClickOutsideHOC;

},{"react":"d8NEQ","react-dom":"cy9SD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"juvm1":[function(require,module,exports) {
// Public components
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>(0, _popper.Popper)) // Public types
;
parcelHelpers.export(exports, "Manager", ()=>(0, _manager.Manager));
parcelHelpers.export(exports, "Reference", ()=>(0, _reference.Reference));
parcelHelpers.export(exports, "usePopper", ()=>(0, _usePopper.usePopper));
var _popper = require("./Popper");
var _manager = require("./Manager");
var _reference = require("./Reference");
var _usePopper = require("./usePopper");

},{"./Popper":"fPnyB","./Manager":"gArKd","./Reference":"5MZU7","./usePopper":"j2wnY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fPnyB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>Popper);
var _react = require("react");
var _manager = require("./Manager");
var _utils = require("./utils");
var _usePopper = require("./usePopper");
var NOOP = function NOOP() {
    return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var EMPTY_MODIFIERS = [];
function Popper(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = _react.useContext((0, _manager.ManagerReferenceNodeContext));
    var _React$useState = _react.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = _react.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    _react.useEffect(function() {
        (0, _utils.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = _react.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper1 = (0, _usePopper.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper1.state, styles = _usePopper1.styles, forceUpdate = _usePopper1.forceUpdate, update = _usePopper1.update;
    var childrenProps = _react.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || NOOP,
            update: update || NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, _utils.unwrapArray)(children)(childrenProps);
}

},{"react":"d8NEQ","./Manager":"gArKd","./utils":"lcuk6","./usePopper":"j2wnY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gArKd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagerReferenceNodeContext", ()=>ManagerReferenceNodeContext);
parcelHelpers.export(exports, "ManagerReferenceNodeSetterContext", ()=>ManagerReferenceNodeSetterContext);
parcelHelpers.export(exports, "Manager", ()=>Manager);
var _react = require("react");
var ManagerReferenceNodeContext = _react.createContext();
var ManagerReferenceNodeSetterContext = _react.createContext();
function Manager(_ref) {
    var children = _ref.children;
    var _React$useState = _react.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = _react.useRef(false);
    _react.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = _react.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ _react.createElement(ManagerReferenceNodeContext.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ _react.createElement(ManagerReferenceNodeSetterContext.Provider, {
        value: handleSetReferenceNode
    }, children));
}

},{"react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lcuk6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", ()=>unwrapArray);
parcelHelpers.export(exports, "safeInvoke", ()=>safeInvoke);
parcelHelpers.export(exports, "setRef", ()=>setRef);
parcelHelpers.export(exports, "fromEntries", ()=>fromEntries);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};
var fromEntries = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? _react.useLayoutEffect : _react.useEffect;

},{"react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j2wnY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePopper", ()=>usePopper);
var _react = require("react");
var _reactDom = require("react-dom");
var _core = require("@popperjs/core");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _utils = require("./utils");
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = _react.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || EMPTY_MODIFIERS
    };
    var _React$useState = _react.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = _react.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                _reactDom.flushSync(function() {
                    setState({
                        styles: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = _react.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, _reactFastCompareDefault.default)(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = _react.useRef();
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, _core.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

},{"react":"d8NEQ","react-dom":"cy9SD","@popperjs/core":"87pKX","react-fast-compare":"1jSR0","./utils":"lcuk6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"87pKX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":false,"./createPopper.js":false,"./popper.js":"h2ejb","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6TpCB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead"; // pure-logic modifiers
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9vihL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getComputedStyleJs = require("./dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _validateModifiersJs = require("./utils/validateModifiers.js");
var _validateModifiersJsDefault = parcelHelpers.interopDefault(_validateModifiersJs);
var _uniqueByJs = require("./utils/uniqueBy.js");
var _uniqueByJsDefault = parcelHelpers.interopDefault(_uniqueByJs);
var _getBasePlacementJs = require("./utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var _enumsJs = require("./enums.js");
var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"2EXEe","./dom-utils/getLayoutRect.js":"bb23H","./dom-utils/listScrollParents.js":"gksOC","./dom-utils/getOffsetParent.js":"fY4qK","./dom-utils/getComputedStyle.js":"3b2D4","./utils/orderModifiers.js":"lfu61","./utils/debounce.js":"24uXL","./utils/validateModifiers.js":"7RRgf","./utils/uniqueBy.js":"8yP03","./utils/getBasePlacement.js":"8APSI","./utils/mergeByName.js":"jcjQD","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"baf0a","./enums.js":"6TpCB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2EXEe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"eBMMf","./getNodeScroll.js":"6jZRg","./getNodeName.js":"c5ZmD","./instanceOf.js":"baf0a","./getWindowScrollBarX.js":"iQNmC","./getDocumentElement.js":"8LnJn","./isScrollParent.js":"4lC9B","../utils/math.js":"iQ8HR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eBMMf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"baf0a","../utils/math.js":"iQ8HR","./getWindow.js":"1Igzy","./isLayoutViewport.js":"byWKf","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"baf0a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"1Igzy","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1Igzy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iQ8HR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"byWKf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"4jcWZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4jcWZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6jZRg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"e17gP","./getWindow.js":"1Igzy","./instanceOf.js":"baf0a","./getHTMLElementScroll.js":"jpYey","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e17gP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"1Igzy","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jpYey":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c5ZmD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iQNmC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"eBMMf","./getDocumentElement.js":"8LnJn","./getWindowScroll.js":"e17gP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8LnJn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"baf0a","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4lC9B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"3b2D4","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3b2D4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"1Igzy","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bb23H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"eBMMf","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gksOC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"ghe8Z","./getParentNode.js":"fFNtW","./getWindow.js":"1Igzy","./isScrollParent.js":"4lC9B","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ghe8Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"fFNtW","./isScrollParent.js":"4lC9B","./getNodeName.js":"c5ZmD","./instanceOf.js":"baf0a","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fFNtW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"c5ZmD","./getDocumentElement.js":"8LnJn","./instanceOf.js":"baf0a","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fY4qK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === "html" || (0, _getNodeNameJsDefault.default)(offsetParent) === "body" && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"1Igzy","./getNodeName.js":"c5ZmD","./getComputedStyle.js":"3b2D4","./instanceOf.js":"baf0a","./isTableElement.js":"hKSCs","./getParentNode.js":"fFNtW","../utils/userAgent.js":"4jcWZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hKSCs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"c5ZmD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lfu61":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"6TpCB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"24uXL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7RRgf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>validateModifiers);
var _formatJs = require("./format.js");
var _formatJsDefault = parcelHelpers.interopDefault(_formatJs);
var _enumsJs = require("../enums.js");
var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = [
    "name",
    "enabled",
    "phase",
    "fn",
    "effect",
    "requires",
    "options"
];
function validateModifiers(modifiers) {
    modifiers.forEach(function(modifier) {
        [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
        .filter(function(value, index, self) {
            return self.indexOf(value) === index;
        }).forEach(function(key) {
            switch(key){
                case "name":
                    if (typeof modifier.name !== "string") console.error((0, _formatJsDefault.default)(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
                    break;
                case "enabled":
                    if (typeof modifier.enabled !== "boolean") console.error((0, _formatJsDefault.default)(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
                    break;
                case "phase":
                    if ((0, _enumsJs.modifierPhases).indexOf(modifier.phase) < 0) console.error((0, _formatJsDefault.default)(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + (0, _enumsJs.modifierPhases).join(", "), '"' + String(modifier.phase) + '"'));
                    break;
                case "fn":
                    if (typeof modifier.fn !== "function") console.error((0, _formatJsDefault.default)(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
                    break;
                case "effect":
                    if (modifier.effect != null && typeof modifier.effect !== "function") console.error((0, _formatJsDefault.default)(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
                    break;
                case "requires":
                    if (modifier.requires != null && !Array.isArray(modifier.requires)) console.error((0, _formatJsDefault.default)(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
                    break;
                case "requiresIfExists":
                    if (!Array.isArray(modifier.requiresIfExists)) console.error((0, _formatJsDefault.default)(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
                    break;
                case "options":
                case "data":
                    break;
                default:
                    console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function(s) {
                        return '"' + s + '"';
                    }).join(", ") + '; but "' + key + '" was provided.');
            }
            modifier.requires && modifier.requires.forEach(function(requirement) {
                if (modifiers.find(function(mod) {
                    return mod.name === requirement;
                }) == null) console.error((0, _formatJsDefault.default)(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
            });
        });
    });
}

},{"./format.js":"9rqep","../enums.js":"6TpCB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9rqep":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
function format(str) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return [].concat(args).reduce(function(p, c) {
        return p.replace(/%s/, c);
    }, str);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8yP03":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>uniqueBy);
function uniqueBy(arr, fn) {
    var identifiers = new Set();
    return arr.filter(function(item) {
        var identifier = fn(item);
        if (!identifiers.has(identifier)) {
            identifiers.add(identifier);
            return true;
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8APSI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split("-")[0];
}

},{"../enums.js":"6TpCB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jcjQD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"drRjq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"2Cjme","../dom-utils/getDocumentElement.js":"8LnJn","../dom-utils/getBoundingClientRect.js":"eBMMf","./computeOffsets.js":"em9i3","./rectToClientRect.js":"5ZnqG","../enums.js":"6TpCB","../dom-utils/instanceOf.js":"baf0a","./mergePaddingObject.js":"au2Ml","./expandToHashMap.js":"6tytB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2Cjme":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"6TpCB","./getViewportRect.js":"8RN3s","./getDocumentRect.js":"dCqUK","./listScrollParents.js":"gksOC","./getOffsetParent.js":"fY4qK","./getDocumentElement.js":"8LnJn","./getComputedStyle.js":"3b2D4","./instanceOf.js":"baf0a","./getBoundingClientRect.js":"eBMMf","./getParentNode.js":"fFNtW","./contains.js":"hoyAs","./getNodeName.js":"c5ZmD","../utils/rectToClientRect.js":"5ZnqG","../utils/math.js":"iQ8HR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8RN3s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"1Igzy","./getDocumentElement.js":"8LnJn","./getWindowScrollBarX.js":"iQNmC","./isLayoutViewport.js":"byWKf","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dCqUK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === "rtl") x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"8LnJn","./getComputedStyle.js":"3b2D4","./getWindowScrollBarX.js":"iQNmC","./getWindowScroll.js":"e17gP","../utils/math.js":"iQ8HR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hoyAs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"baf0a","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5ZnqG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"em9i3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"8APSI","./getVariation.js":"bAYsK","./getMainAxisFromPlacement.js":"d6Wac","../enums.js":"6TpCB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bAYsK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split("-")[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d6Wac":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"au2Ml":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"eoxAW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eoxAW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6tytB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h2ejb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"9vihL","./modifiers/eventListeners.js":"iyU7B","./modifiers/popperOffsets.js":"fqYCb","./modifiers/computeStyles.js":"453yu","./modifiers/applyStyles.js":"iYqST","./modifiers/offset.js":"lHL1e","./modifiers/flip.js":"w5fKD","./modifiers/preventOverflow.js":"5Sjmt","./modifiers/arrow.js":"i11Wt","./modifiers/hide.js":"6dY7d","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iyU7B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, passive);
    });
    if (resize) window.addEventListener("resize", instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"1Igzy","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fqYCb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"em9i3","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"453yu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"6TpCB","../dom-utils/getOffsetParent.js":"fY4qK","../dom-utils/getWindow.js":"1Igzy","../dom-utils/getDocumentElement.js":"8LnJn","../dom-utils/getComputedStyle.js":"3b2D4","../utils/getBasePlacement.js":"8APSI","../utils/getVariation.js":"bAYsK","../utils/math.js":"iQ8HR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iYqST":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: applyStyles,
    effect: effect,
    requires: [
        "computeStyles"
    ]
};

},{"../dom-utils/getNodeName.js":"c5ZmD","../dom-utils/instanceOf.js":"baf0a","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lHL1e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"8APSI","../enums.js":"6TpCB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"w5fKD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"9Ysjr","../utils/getBasePlacement.js":"8APSI","../utils/getOppositeVariationPlacement.js":"90yTG","../utils/detectOverflow.js":"drRjq","../utils/computeAutoPlacement.js":"hjqQI","../enums.js":"6TpCB","../utils/getVariation.js":"bAYsK","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9Ysjr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"90yTG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: "end",
    end: "start"
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hjqQI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"bAYsK","../enums.js":"6TpCB","./detectOverflow.js":"drRjq","./getBasePlacement.js":"8APSI","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5Sjmt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === "x" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

},{"../enums.js":"6TpCB","../utils/getBasePlacement.js":"8APSI","../utils/getMainAxisFromPlacement.js":"d6Wac","../utils/getAltAxis.js":"5kulN","../utils/within.js":"6irTS","../dom-utils/getLayoutRect.js":"bb23H","../dom-utils/getOffsetParent.js":"fY4qK","../utils/detectOverflow.js":"drRjq","../utils/getVariation.js":"bAYsK","../utils/getFreshSideObject.js":"eoxAW","../utils/math.js":"iQ8HR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5kulN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === "x" ? "y" : "x";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6irTS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"iQ8HR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"i11Wt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: arrow,
    effect: effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

},{"../utils/getBasePlacement.js":"8APSI","../dom-utils/getLayoutRect.js":"bb23H","../dom-utils/contains.js":"hoyAs","../dom-utils/getOffsetParent.js":"fY4qK","../utils/getMainAxisFromPlacement.js":"d6Wac","../utils/within.js":"6irTS","../utils/mergePaddingObject.js":"au2Ml","../utils/expandToHashMap.js":"6tytB","../enums.js":"6TpCB","../dom-utils/instanceOf.js":"baf0a","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6dY7d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: hide
};

},{"../enums.js":"6TpCB","../utils/detectOverflow.js":"drRjq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1jSR0":[function(require,module,exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"5MZU7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reference", ()=>Reference);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _manager = require("./Manager");
var _utils = require("./utils");
function Reference(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = _react.useContext((0, _manager.ManagerReferenceNodeSetterContext));
    var refHandler = _react.useCallback(function(node) {
        (0, _utils.setRef)(innerRef, node);
        (0, _utils.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    _react.useEffect(function() {
        return function() {
            return (0, _utils.setRef)(innerRef, null);
        };
    }, []);
    _react.useEffect(function() {
        (0, _warningDefault.default)(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, _utils.unwrapArray)(children)({
        ref: refHandler
    });
}

},{"react":"d8NEQ","warning":"fptHu","./Manager":"gArKd","./utils":"lcuk6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fptHu":[function(require,module,exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"c0GsX":[function() {},{}],"lcTto":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEND_SEARCH_REQUEST", ()=>SEND_SEARCH_REQUEST);
parcelHelpers.export(exports, "sendSearchRequest", ()=>sendSearchRequest);
parcelHelpers.export(exports, "SEARCH_REQUEST_SUCCESS", ()=>SEARCH_REQUEST_SUCCESS);
parcelHelpers.export(exports, "searchRequestSuccess", ()=>searchRequestSuccess);
parcelHelpers.export(exports, "searchError", ()=>searchError);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "searchAlertBarAction", ()=>searchAlertBarAction);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
var _productsState = require("../products/Products.state");
// Default State
const initialState = {
    error: false,
    isLoading: false
};
const SEND_SEARCH_REQUEST = "SEND_SEARCH_REQUEST";
const sendSearchRequest = (searchData)=>({
        type: SEND_SEARCH_REQUEST,
        payload: searchData
    });
const SEARCH_REQUEST_SUCCESS = "SEARCH_REQUEST_SUCCESS";
const searchRequestSuccess = (searchData)=>({
        type: SEARCH_REQUEST_SUCCESS,
        payload: searchData
    });
const SEARCH_ERROR = "search/SEARCH_ERROR";
const searchError = (error)=>({
        type: SEARCH_ERROR,
        payload: {
            error
        }
    });
const ALERT_BAR_ACTION = "search/ALERT_BAR_ACTION";
const searchAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const _reducer = (state = initialState, { type })=>{
    switch(type){
        case SEND_SEARCH_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case SEARCH_REQUEST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                error: false
            };
        case SEARCH_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true
            };
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>({
        ...state.search
    });
const _mapDispatchToProps = (dispatch)=>({
        fetchSearchById: (id)=>dispatch((0, _productsState.fetchSearchById)(id)),
        sendSearchRequest: (searchData)=>dispatch(sendSearchRequest(searchData))
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    alertBars: {
        searchAlertBars: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    }
}, "search");
// Nested Reducer
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","../products/Products.state":"9SdM7","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bEN0h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADD_TO_CART_REQUEST", ()=>ADD_TO_CART_REQUEST);
parcelHelpers.export(exports, "addToCartRequest", ()=>addToCartRequest);
parcelHelpers.export(exports, "ADD_TO_CART_SUCCESS", ()=>ADD_TO_CART_SUCCESS);
parcelHelpers.export(exports, "addToCartSuccess", ()=>addToCartSuccess);
parcelHelpers.export(exports, "ADD_TO_CART_ERROR", ()=>ADD_TO_CART_ERROR);
parcelHelpers.export(exports, "addToCartError", ()=>addToCartError);
parcelHelpers.export(exports, "searchError", ()=>searchError);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "lookupAlertBarAction", ()=>lookupAlertBarAction);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
var _productsState = require("../products/Products.state");
// Default State
const initialState = {
    error: false,
    isLoading: false
};
const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
const addToCartRequest = (data)=>({
        type: ADD_TO_CART_REQUEST,
        payload: data
    });
const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
const addToCartSuccess = (data)=>({
        type: ADD_TO_CART_SUCCESS,
        payload: data
    });
const ADD_TO_CART_ERROR = "ADD_TO_CART_ERROR";
const addToCartError = (data)=>({
        type: ADD_TO_CART_ERROR,
        payload: data
    });
const LOOKUP_ERROR = "lookup/LOOKUP_ERROR";
const searchError = (error)=>({
        type: LOOKUP_ERROR,
        payload: {
            error
        }
    });
const ALERT_BAR_ACTION = "lookup/ALERT_BAR_ACTION";
const lookupAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const _reducer = (state = initialState, { type/* , payload */  })=>{
    switch(type){
        case ADD_TO_CART_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case ADD_TO_CART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                error: false
            };
        case ADD_TO_CART_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true
            };
        case LOOKUP_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true
            };
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>({
        ...state.lookup
    });
const _mapDispatchToProps = (dispatch)=>({
        fetchLookupById: (id)=>dispatch((0, _productsState.fetchLookupById)(id))
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    alertBars: {
        lookupAlertBars: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    }
}, "lookup");
// Nested Reducer
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","../products/Products.state":"9SdM7","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"04CNM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateResultAmount", ()=>updateResultAmount);
parcelHelpers.export(exports, "toggleResultSelect", ()=>toggleResultSelect);
parcelHelpers.export(exports, "updateResultAnnotation", ()=>updateResultAnnotation);
parcelHelpers.export(exports, "toggleSelectAll", ()=>toggleSelectAll);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _reselect = require("reselect");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _helpers = require("../../utils/helpers");
var _nested = require("../../utils/Nested");
var _searchState = require("../search/Search.state");
var _uuid = require("uuid");
var _lookupState = require("../lookup/Lookup.state");
// Default State
const initialState = {
    error: false,
    data: {
        searchResults: [],
        account: []
    }
};
// Action Creators and Action Types
const UPDATE_RESULT_AMOUNT = "UPDATE_RESULT_AMOUNT";
const updateResultAmount = (id, amount)=>({
        type: UPDATE_RESULT_AMOUNT,
        payload: {
            uniqueId: id,
            newAmount: amount
        }
    });
const TOGGLE_RESULT_SELECT = "TOGGLE_RESULT_SELECT";
const toggleResultSelect = (id)=>({
        type: TOGGLE_RESULT_SELECT,
        payload: {
            uniqueId: id
        }
    });
const UPDATE_RESULT_ANNOTATION = "UPDATE_RESULT_ANNOTATION";
const updateResultAnnotation = (id, fieldName, value)=>({
        type: UPDATE_RESULT_ANNOTATION,
        payload: {
            uniqueId: id,
            fieldName,
            value
        }
    });
const TOGGLE_SELECT_ALL = "TOGGLE_SELECT_ALL";
const toggleSelectAll = ()=>({
        type: TOGGLE_SELECT_ALL
    });
const itemReducer = (item, { type, payload })=>{
    switch(type){
        case UPDATE_RESULT_AMOUNT:
            return {
                ...item,
                recorded_price: item.amouont,
                amount: payload.newAmount
            };
        case TOGGLE_RESULT_SELECT:
            return {
                ...item,
                selected: !item.selected
            };
        case UPDATE_RESULT_ANNOTATION:
            return {
                ...item,
                annotations: {
                    ...item.annotations,
                    [payload.fieldName]: payload.value
                }
            };
        default:
            return item;
    }
};
const _reducer = (state = initialState, { type, payload } = action)=>{
    switch(type){
        case 0, _searchState.SEARCH_REQUEST_SUCCESS:
            return {
                ...state,
                /**
         * 200 response but receivables are empty means that the search was successful,
         * but there are no payments available. The user is not redirected to the results page
         * so there is no need to update the state here.
         *
         * See searchForItemEpic in Search.epic.js for more information.
         */ data: !payload.receivables ? state.data : {
                    searchResults: payload.receivables.map((r)=>({
                            ...r,
                            uniqueId: (0, _uuid.v4)(),
                            amount: (0, _helpers.formatCurrencyInput)(r.amount)
                        })),
                    account: payload.contact_info,
                    tableHeaders: payload.table_headers
                }
            };
        case TOGGLE_SELECT_ALL:
            if (state.data.searchResults.some((result)=>!Boolean(result.selected))) return {
                ...state,
                data: {
                    ...state.data,
                    searchResults: state.data.searchResults.map((result)=>({
                            ...result,
                            selected: true
                        }))
                }
            };
            return {
                ...state,
                data: {
                    ...state.data,
                    searchResults: state.data.searchResults.map((result)=>({
                            ...result,
                            selected: false
                        }))
                }
            };
        case UPDATE_RESULT_AMOUNT:
        case TOGGLE_RESULT_SELECT:
        case UPDATE_RESULT_ANNOTATION:
            return {
                ...state,
                data: {
                    ...state.data,
                    searchResults: state.data.searchResults.map((item)=>{
                        return item.uniqueId === payload.uniqueId ? itemReducer(item, {
                            type,
                            payload
                        }) : item;
                    })
                }
            };
        default:
            return state;
    }
};
// Selectors
const searchResultsSelector = (state)=>state.searchResults.data.searchResults;
const accountDataSelector = (state)=>state.searchResults.data.account;
const selectedResultsSelector = (0, _reselect.createSelector)(searchResultsSelector, (items)=>items.filter((item)=>Boolean(item.selected)));
const selectedTotalSelector = (0, _reselect.createSelector)(selectedResultsSelector, (items)=>items.reduce((total, item)=>total + Number(item.amount), 0));
const _mapStateToProps = (state)=>({
        ...state.searchResults,
        searchResults: searchResultsSelector(state),
        selectedResults: selectedResultsSelector(state),
        selectedResultsTotal: selectedTotalSelector(state),
        accountData: accountDataSelector(state)
    });
const _mapDispatchToProps = (dispatch)=>({
        updateResultAmount: (...args)=>dispatch(updateResultAmount(...args)),
        updateResultAnnotation: (...args)=>dispatch(updateResultAnnotation(...args)),
        toggleResultSelect: (...args)=>dispatch(toggleResultSelect(...args)),
        toggleSelectAll: ()=>dispatch(toggleSelectAll())
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    alertBars: {
        searchResultsAlertBars: {
            ..._alertBarState,
            actionType: (0, _lookupState.ALERT_BAR_ACTION)
        }
    }
}, "searchResults");
// Nested Reducer
const reducer = (state, action1)=>nestedReducer(state, action1);

},{"reselect":"7dznn","../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/helpers":"epomp","../../utils/Nested":"gDQL4","../search/Search.state":"lcTto","uuid":"4vdp3","../lookup/Lookup.state":"bEN0h","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cB6HN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FETCH_ORDERS_REQUEST", ()=>FETCH_ORDERS_REQUEST);
parcelHelpers.export(exports, "fetchOrdersRequest", ()=>fetchOrdersRequest);
parcelHelpers.export(exports, "FETCH_ORDERS_SUCCESS", ()=>FETCH_ORDERS_SUCCESS);
parcelHelpers.export(exports, "fetchOrdersSuccess", ()=>fetchOrdersSuccess);
parcelHelpers.export(exports, "FETCH_ORDERS_ERROR", ()=>FETCH_ORDERS_ERROR);
parcelHelpers.export(exports, "fetchOrdersError", ()=>fetchOrdersError);
parcelHelpers.export(exports, "FETCH_USERS_REQUEST", ()=>FETCH_USERS_REQUEST);
parcelHelpers.export(exports, "fetchUsersRequest", ()=>fetchUsersRequest);
parcelHelpers.export(exports, "FETCH_USERS_SUCCESS", ()=>FETCH_USERS_SUCCESS);
parcelHelpers.export(exports, "fetchUsersSuccess", ()=>fetchUsersSuccess);
parcelHelpers.export(exports, "FETCH_USERS_ERROR", ()=>FETCH_USERS_ERROR);
parcelHelpers.export(exports, "fetchUsersError", ()=>fetchUsersError);
parcelHelpers.export(exports, "FETCH_BATCHES_REQUEST", ()=>FETCH_BATCHES_REQUEST);
parcelHelpers.export(exports, "fetchBatchesRequest", ()=>fetchBatchesRequest);
parcelHelpers.export(exports, "FETCH_BATCHES_SUCCESS", ()=>FETCH_BATCHES_SUCCESS);
parcelHelpers.export(exports, "fetchBatchesSuccess", ()=>fetchBatchesSuccess);
parcelHelpers.export(exports, "FETCH_BATCHES_ERROR", ()=>FETCH_BATCHES_ERROR);
parcelHelpers.export(exports, "fetchBatchesError", ()=>fetchBatchesError);
parcelHelpers.export(exports, "CLEAR_SEARCH_FORM_ACTION", ()=>CLEAR_SEARCH_FORM_ACTION);
parcelHelpers.export(exports, "clearSearchFormAction", ()=>clearSearchFormAction);
parcelHelpers.export(exports, "SEARCH_ORDERS_ACTION", ()=>SEARCH_ORDERS_ACTION);
parcelHelpers.export(exports, "searchOrdersAction", ()=>searchOrdersAction);
parcelHelpers.export(exports, "ORDERS_INDEX_FILTERS_FORM_ACTION", ()=>ORDERS_INDEX_FILTERS_FORM_ACTION);
parcelHelpers.export(exports, "ordersIndexFiltersFormAction", ()=>ordersIndexFiltersFormAction);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "ordersIndexAlertBarAction", ()=>ordersIndexAlertBarAction);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
var _ordersIndexFiltersForm = require("./OrdersIndexFiltersForm");
// Default State
const initialState = {
    data: null,
    loading: false,
    isLoadingOrders: true,
    isLoadingFilters: false,
    shouldClear: false,
    currentPage: 1,
    pageSize: 15,
    pageCount: 0,
    isSearchError: false,
    filters: [],
    batches: [],
    users: []
};
const FETCH_ORDERS_REQUEST = "FETCH_ORDERS_REQUEST";
const fetchOrdersRequest = (payload)=>({
        type: FETCH_ORDERS_REQUEST,
        payload
    });
const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
const fetchOrdersSuccess = (payload)=>({
        type: FETCH_ORDERS_SUCCESS,
        payload
    });
const FETCH_ORDERS_ERROR = "FETCH_ORDERS_ERROR";
const fetchOrdersError = (payload)=>({
        type: FETCH_ORDERS_ERROR,
        payload
    });
const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
const fetchUsersRequest = (payload)=>({
        type: FETCH_USERS_REQUEST,
        payload: payload
    });
const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
const fetchUsersSuccess = (payload)=>({
        type: FETCH_USERS_SUCCESS,
        payload
    });
const FETCH_USERS_ERROR = "FETCH_USERS_ERROR";
const fetchUsersError = (payload)=>({
        type: FETCH_USERS_ERROR,
        payload
    });
const FETCH_BATCHES_REQUEST = "FETCH_BATCHES_REQUEST";
const fetchBatchesRequest = (payload)=>({
        type: FETCH_BATCHES_REQUEST,
        payload: payload
    });
const FETCH_BATCHES_SUCCESS = "FETCH_BATCHES_SUCCESS";
const fetchBatchesSuccess = (payload)=>({
        type: FETCH_BATCHES_SUCCESS,
        payload
    });
const FETCH_BATCHES_ERROR = "FETCH_BATCHES_ERROR";
const fetchBatchesError = (payload)=>({
        type: FETCH_BATCHES_ERROR,
        payload
    });
const CLEAR_SEARCH_FORM_ACTION = "search/CLEAR_SEARCH_FORM_ACTION";
const clearSearchFormAction = _nested.nestedAction(CLEAR_SEARCH_FORM_ACTION);
const SEARCH_ORDERS_ACTION = "search/SEARCH_ORDERS_ACTION";
const searchOrdersAction = _nested.nestedAction(SEARCH_ORDERS_ACTION);
const ORDERS_INDEX_FILTERS_FORM_ACTION = "orderDetails/ORDERS_INDEX_FILTERS_FORM_ACTION";
const ordersIndexFiltersFormAction = _nested.nestedAction(ORDERS_INDEX_FILTERS_FORM_ACTION);
const ALERT_BAR_ACTION = "ordersIndex/ALERT_BAR_ACTION";
const ordersIndexAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const _reducer = (state = initialState, { type, payload })=>{
    switch(type){
        case ORDERS_INDEX_FILTERS_FORM_ACTION:
            return {
                ...state,
                shouldClear: false
            };
        case CLEAR_SEARCH_FORM_ACTION:
            return {
                ...state,
                shouldClear: true
            };
        case FETCH_USERS_SUCCESS:
            return {
                ...state,
                users: payload
            };
        case FETCH_BATCHES_SUCCESS:
            return {
                ...state,
                batches: payload
            };
        case FETCH_ORDERS_REQUEST:
            return {
                ...state,
                data: initialState.data,
                currentPage: payload.pageIndex,
                isLoadingOrders: true
            };
        case FETCH_ORDERS_SUCCESS:
            return {
                ...state,
                ...payload,
                isLoadingOrders: false
            };
        case FETCH_USERS_REQUEST:
        case FETCH_BATCHES_REQUEST:
            return {
                ...state
            };
        case FETCH_ORDERS_ERROR:
        case FETCH_USERS_ERROR:
        case FETCH_BATCHES_ERROR:
            return {
                ...state,
                fetching: false
            };
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>({
        ...state.ordersIndex
    });
const _mapDispatchToProps = (dispatch)=>({
        fetchData: (data)=>dispatch(fetchOrdersRequest(data)),
        clearSearchForm: ()=>dispatch(clearSearchFormAction())
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    alertBars: {
        ordersIndexAlertBars: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    },
    forms: {
        ordersIndexFiltersForm: {
            ...(0, _ordersIndexFiltersForm.OrdersIndexFiltersForm),
            actionType: ORDERS_INDEX_FILTERS_FORM_ACTION
        }
    }
}, "ordersIndex");
// Nested Reducer
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","./OrdersIndexFiltersForm":"aKM2X","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aKM2X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrdersIndexFiltersForm", ()=>OrdersIndexFiltersForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _ordersIndexSearchInputStyled = require("./OrdersIndexSearchInput.styled");
var _ordersIndexFiltersFormState = require("./OrdersIndexFiltersForm.state");
var _styled = require("../../components/styled");
var _datePicker = require("../../components/date-picker");
var _datePickerDefault = parcelHelpers.interopDefault(_datePicker);
let OrdersIndexFiltersForm = ({ actions, fields, forms, showErrors, clear, shouldClear, fetchData, terminalOptions = [], locationOptions = [], orderStatusOptions = [], paymentMethodOptions = [], agencyOptions = [], userOptions = [], batchOptions = [], loading })=>{
    const [, handleErrors] = (0, _react.useState)(false);
    const transformedPaymentMethodOptions = paymentMethodOptions.map((option)=>({
            ...option,
            text: option.text === "Wire Payment" ? "Wire Transfer" : option.text
        }));
    (0, _react.useEffect)(()=>{
        fetchData({
            pageIndex: 1
        });
    }, [
        fields.paymentMethod.rawValue,
        fields.batch.rawValue,
        fields.status.rawValue,
        fields.user.rawValue,
        fields.terminal.rawValue,
        fields.location.rawValue,
        fields.agency.rawValue
    ]);
    const oneOrMoreActiveFilters = Object.entries(fields).some(([_, { rawValue }])=>Boolean(rawValue));
    const clearFilterForm = ()=>{
        actions.form.clear();
    };
    const handleFiltersSubmit = (0, _components.util).general.generateClickHandler(forms.ordersIndexFiltersForm, ()=>handleErrors(true), ()=>fetchData({
            pageIndex: 1
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        as: "form",
        onSubmit: handleFiltersSubmit,
        children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Loading), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ordersIndexSearchInputStyled.OrdersIndexSearchInput), {
                    actions: actions,
                    fields: fields,
                    searchErrors: showErrors,
                    fetchData: fetchData,
                    handleSubmit: handleFiltersSubmit,
                    shouldClear: shouldClear,
                    clear: clear
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                    background: (0, _components.constants).colors.ATHENS_GREY,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            childGap: "1rem",
                            align: "center",
                            overflow: "visible",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.AmtFilterContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                        "data-testid": "Min Amount Test",
                                        labelTextWhenNoError: "Min Amount",
                                        field: fields.minAmount,
                                        fieldActions: actions.fields.minAmount,
                                        type: "number",
                                        labelTextVariant: "p",
                                        errorTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.AmtFilterContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                        "data-testid": "Max Amount Test",
                                        labelTextWhenNoError: "Max Amount",
                                        field: fields.maxAmount,
                                        fieldActions: actions.fields.maxAmount,
                                        type: "number",
                                        labelTextVariant: "p",
                                        errorTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDefault.default), {
                                    label: "Start Date (mm/dd/yyyy)",
                                    id: "orders-index-start-date",
                                    field: fields.startDate,
                                    fieldActions: actions.fields.startDate
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDefault.default), {
                                    label: "End Date (mm/dd/yyyy)",
                                    id: "orders-index-end-date",
                                    field: fields.endDate,
                                    fieldActions: actions.fields.endDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            childGap: "1rem",
                            align: "center",
                            overflow: "visible",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        "data-testid": "Status Test",
                                        dropdownMaxHeight: "200px",
                                        labelTextWhenNoError: "Status",
                                        options: orderStatusOptions,
                                        fieldActions: actions.fields.status,
                                        showErrors: fields.errors,
                                        field: fields.status,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "Payment Method Test",
                                        labelTextWhenNoError: "Payment method",
                                        options: transformedPaymentMethodOptions,
                                        fieldActions: actions.fields.paymentMethod,
                                        showErrors: fields.errors,
                                        field: fields.paymentMethod,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "Agency Test",
                                        labelTextWhenNoError: "Agency",
                                        options: agencyOptions,
                                        fieldActions: actions.fields.agency,
                                        showErrors: fields.errors,
                                        field: fields.agency,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "Location Test",
                                        labelTextWhenNoError: "Location",
                                        options: locationOptions,
                                        fieldActions: actions.fields.location,
                                        showErrors: fields.errors,
                                        field: fields.location,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "Terminal Test",
                                        labelTextWhenNoError: "Terminal",
                                        options: terminalOptions,
                                        fieldActions: actions.fields.terminal,
                                        showErrors: fields.errors,
                                        field: fields.terminal,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "User Test",
                                        labelTextWhenNoError: "User",
                                        options: userOptions,
                                        fieldActions: actions.fields.user,
                                        showErrors: fields.errors,
                                        field: fields.user,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "Batch Test",
                                        labelTextWhenNoError: "Batch",
                                        options: batchOptions,
                                        fieldActions: actions.fields.batch,
                                        showErrors: fields.errors,
                                        field: fields.batch,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                })
                            ]
                        }),
                        oneOrMoreActiveFilters && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            type: "reset",
                            padding: "0",
                            margin: "0",
                            variant: "smallGhost",
                            action: clearFilterForm,
                            text: "Clear filters",
                            "data-testid": "orders-clear-filters",
                            textExtraStyles: "font-size: 1rem;"
                        })
                    ]
                })
            ]
        })
    });
};
OrdersIndexFiltersForm.reducer = (0, _ordersIndexFiltersFormState.reducer);
OrdersIndexFiltersForm.mapStateToProps = (0, _ordersIndexFiltersFormState.mapStateToProps);
OrdersIndexFiltersForm.mapDispatchToProps = (0, _ordersIndexFiltersFormState.mapDispatchToProps);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","./OrdersIndexSearchInput.styled":"630Ol","./OrdersIndexFiltersForm.state":"ishX5","../../components/styled":"uxYqN","../../components/date-picker":"2lTFu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"630Ol":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrdersIndexSearchInput", ()=>OrdersIndexSearchInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _searchIcons = require("../../components/search-icons");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const OrdersIndexSearchInputWrapper = (0, _styledComponentsDefault.default).div`
  .searchOrderNumberSearchIcon {
    width: 2rem;
  }

  .searchOrderNumberInput {
    border: 0;
    width: 860px;
    margin-top: 0.25rem;
  }
`;
const OrdersIndexSearchInput = ({ fields, actions, clear, shouldClear, fetchData, handleSubmit })=>{
    (0, _react.useEffect)(()=>{
        if (shouldClear) {
            actions.fields.orderNumber.set("");
            fetchData({
                pageIndex: 1
            });
        }
    }, [
        shouldClear
    ]);
    const searchErrors = {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OrdersIndexSearchInputWrapper, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            childGap: "0.25rem",
            justify: "space-around",
            align: "center",
            minHeight: "100%",
            minWidth: "100%",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    extraStyles: `overflow: visible;`,
                    align: "center",
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0px 12px 0px 0px",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchIcons.SearchIcon), {
                                color: (0, _components.constants).colors.LUCKY_POINT
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                            placeholder: "Search by order number",
                            themeValues: {
                                lineHeight: 0
                            },
                            "data-testid": "order-number-input",
                            className: "searchOrderNumberInput",
                            errorMessages: searchErrors,
                            field: fields.orderNumber,
                            errors: fields.orderNumber.errors,
                            fieldActions: actions.fields.orderNumber,
                            labelTextVariant: "p",
                            errorTextVariant: "p"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    variant: "smallGhost",
                    type: "reset",
                    text: "Clear Search",
                    "data-testid": "orders-clear-search",
                    action: ()=>{
                        clear();
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    type: "submit",
                    minWidth: "0",
                    width: "3rem",
                    padding: ".5rem",
                    minHeight: "0",
                    extraStyles: `line-height: 1;`,
                    "data-testid": "orders-submit-filters",
                    variant: "primary",
                    contentOverride: true,
                    action: handleSubmit,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchIcons.SearchIcon), {
                        color: (0, _components.constants).colors.WHITE,
                        className: "searchOrderNumberSearchIcon"
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../components/search-icons":"9k6tm","styled-components":"bkusY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9k6tm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchIcon", ()=>(0, _searchIcon.SearchIcon));
var _searchIcon = require("./SearchIcon");

},{"./SearchIcon":"4AW29","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4AW29":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchIcon", ()=>SearchIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _components = require("@thecb/components");
var _react = require("react");
const SearchIcon = ({ color = (0, _components.constants).colors.MATISSE_BLUE })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 23,
        height: 23,
        viewBox: "0 0 23 23",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "Icons / Small / Search / Search - M 24px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11.096 1.404a6 6 0 01.924 11.93v6.954a.5.5 0 01-.5.5h-.847a.5.5 0 01-.5-.5v-6.955a6.001 6.001 0 01.923-11.93zm0 1.846a4.154 4.154 0 100 8.308 4.154 4.154 0 000-8.308z",
                    id: "prefix__a"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("use", {
                fill: color,
                transform: "rotate(-45 11.45 10.642)",
                xlinkHref: "#prefix__a",
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","@thecb/components":"g98ma","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ishX5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
const ordersIndexFiltersFormConfig = {
    orderNumber: {
        validators: [
            (0, _reduxFreeform.onlyNaturals)()
        ],
        constraints: [
            (0, _reduxFreeform.onlyNaturals)()
        ]
    },
    startDate: {
        constraints: [
            (0, _reduxFreeform.hasLength)(0, 8)
        ],
        validators: [
            (0, _reduxFreeform.hasLength)(8, 8)
        ]
    },
    endDate: {
        constraints: [
            (0, _reduxFreeform.hasLength)(0, 8)
        ],
        validators: [
            (0, _reduxFreeform.hasLength)(8, 8)
        ]
    },
    maxAmount: {
        constraints: [
            (0, _reduxFreeform.hasNumber)()
        ],
        validators: [
            (0, _reduxFreeform.hasNumber)()
        ]
    },
    minAmount: {
        constraints: [
            (0, _reduxFreeform.hasNumber)()
        ],
        validators: [
            (0, _reduxFreeform.hasNumber)()
        ]
    },
    agency: {},
    paymentMethod: {},
    status: {},
    batch: {},
    user: {},
    location: {
        defaultValue: "all"
    },
    terminal: {
        defaultValue: "all"
    }
};
const { reducer, mapStateToProps, mapDispatchToProps } = (0, _reduxFreeform.createFormState)(ordersIndexFiltersFormConfig);

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"d4FVh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FETCH_DRAWER_HISTORIES_REQUEST", ()=>FETCH_DRAWER_HISTORIES_REQUEST);
parcelHelpers.export(exports, "fetchDrawerHistoriesRequest", ()=>fetchDrawerHistoriesRequest);
parcelHelpers.export(exports, "FETCH_DRAWER_HISTORIES_SUCCESS", ()=>FETCH_DRAWER_HISTORIES_SUCCESS);
parcelHelpers.export(exports, "fetchDrawerHistoriesSuccess", ()=>fetchDrawerHistoriesSuccess);
parcelHelpers.export(exports, "FETCH_DRAWER_HISTORIES_ERROR", ()=>FETCH_DRAWER_HISTORIES_ERROR);
parcelHelpers.export(exports, "fetchDrawerHistoriesError", ()=>fetchDrawerHistoriesError);
parcelHelpers.export(exports, "FETCH_USERS_REQUEST", ()=>FETCH_USERS_REQUEST);
parcelHelpers.export(exports, "fetchUsersRequest", ()=>fetchUsersRequest);
parcelHelpers.export(exports, "FETCH_USERS_SUCCESS", ()=>FETCH_USERS_SUCCESS);
parcelHelpers.export(exports, "fetchUsersSuccess", ()=>fetchUsersSuccess);
parcelHelpers.export(exports, "FETCH_USERS_ERROR", ()=>FETCH_USERS_ERROR);
parcelHelpers.export(exports, "fetchUsersError", ()=>fetchUsersError);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "drawerHistoryIndexAlertBarAction", ()=>drawerHistoryIndexAlertBarAction);
parcelHelpers.export(exports, "DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION", ()=>DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION);
parcelHelpers.export(exports, "drawerHistoryIndexFiltersFormAction", ()=>drawerHistoryIndexFiltersFormAction);
parcelHelpers.export(exports, "CLEAR_SEARCH_FIELD_ACTION", ()=>CLEAR_SEARCH_FIELD_ACTION);
parcelHelpers.export(exports, "clearSearchFieldAction", ()=>clearSearchFieldAction);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
var _drawerHistoryFiltersForm = require("./DrawerHistoryFiltersForm");
// Default State
const initialState = {
    data: null,
    isLoadingDrawerHistory: true,
    error: false,
    meta: {},
    pageSize: 15,
    currentPage: 1
};
const FETCH_DRAWER_HISTORIES_REQUEST = "FETCH_DRAWER_HISTORIES_REQUEST";
const fetchDrawerHistoriesRequest = (payload)=>({
        type: FETCH_DRAWER_HISTORIES_REQUEST,
        payload
    });
const FETCH_DRAWER_HISTORIES_SUCCESS = "FETCH_DRAWER_HISTORIES_SUCCESS";
const fetchDrawerHistoriesSuccess = (payload)=>({
        type: FETCH_DRAWER_HISTORIES_SUCCESS,
        payload
    });
const FETCH_DRAWER_HISTORIES_ERROR = "FETCH_DRAWER_HISTORIES_ERROR";
const fetchDrawerHistoriesError = (payload)=>({
        type: FETCH_DRAWER_HISTORIES_ERROR,
        payload
    });
const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
const fetchUsersRequest = (payload)=>({
        type: FETCH_USERS_REQUEST,
        payload: payload
    });
const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
const fetchUsersSuccess = (payload)=>({
        type: FETCH_USERS_SUCCESS,
        payload
    });
const FETCH_USERS_ERROR = "FETCH_USERS_ERROR";
const fetchUsersError = (payload)=>({
        type: FETCH_USERS_ERROR,
        payload
    });
const ALERT_BAR_ACTION = "drawerHistoryIndex/ALERT_BAR_ACTION";
const drawerHistoryIndexAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION = "drawerHistory/DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION";
const drawerHistoryIndexFiltersFormAction = _nested.nestedAction(DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION);
const CLEAR_SEARCH_FIELD_ACTION = "search/CLEAR_SEARCH_FIELD_ACTION";
const clearSearchFieldAction = _nested.nestedAction(CLEAR_SEARCH_FIELD_ACTION);
const _reducer = (state = initialState, { type, payload })=>{
    switch(type){
        case FETCH_DRAWER_HISTORIES_REQUEST:
            return {
                ...state,
                data: initialState.data,
                currentPage: payload.pageIndex,
                isLoadingDrawerHistory: true
            };
        case FETCH_DRAWER_HISTORIES_SUCCESS:
            return {
                ...state,
                data: payload.data,
                meta: payload.meta,
                isLoadingDrawerHistory: false
            };
        case FETCH_DRAWER_HISTORIES_ERROR:
            return {
                ...state,
                isLoadingDrawerHistory: false
            };
        case FETCH_USERS_REQUEST:
        case FETCH_USERS_SUCCESS:
            return {
                ...state,
                users: payload
            };
        case FETCH_USERS_ERROR:
        case DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION:
            return {
                ...state,
                shouldClear: false
            };
        case CLEAR_SEARCH_FIELD_ACTION:
            return {
                ...state,
                shouldClear: true
            };
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>({
        ...state.drawerHistoryIndex
    });
const _mapDispatchToProps = (dispatch)=>({
        fetchData: (params)=>dispatch(fetchDrawerHistoriesRequest(params)),
        clearSearchField: ()=>dispatch(clearSearchFieldAction())
    });
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    alertBars: {
        drawerHistoryIndexAlertBars: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    },
    forms: {
        drawerHistoryFiltersForm: {
            ...(0, _drawerHistoryFiltersForm.DrawerHistoryFiltersForm),
            actionType: DRAWER_HISTORY_INDEX_FILTER_FORM_ACTION
        }
    }
}, "drawerHistoryIndex");
// Nested Reducer
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","./DrawerHistoryFiltersForm":"k5bcW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k5bcW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DrawerHistoryFiltersForm", ()=>DrawerHistoryFiltersForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _drawerHistoryFiltersFormState = require("./DrawerHistoryFiltersForm.state");
var _filterFormsHelpers = require("../../utils/filterFormsHelpers");
var _drawerHistorySearchInput = require("./DrawerHistorySearchInput");
var _styled = require("../../components/styled");
var _datePicker = require("../../components/date-picker");
var _datePickerDefault = parcelHelpers.interopDefault(_datePicker);
let DrawerHistoryFiltersForm = ({ actions, fields, forms, showErrors, fetchData, terminalOptions = [], locationOptions = [], agencyOptions = [], userOptions = [], clear, shouldClear, loading })=>{
    const [, handleErrors] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        fetchData({
            pageIndex: 1
        });
    }, [
        fields.user.rawValue,
        fields.terminal.rawValue,
        fields.location.rawValue,
        fields.agency.rawValue
    ]);
    const oneOrMoreActiveFilters = Object.entries(fields).some(([_, { rawValue }])=>Boolean(rawValue));
    const clearFilterForm = ()=>{
        actions.form.clear();
    };
    const handleFiltersSubmit = (0, _components.util).general.generateClickHandler(forms.drawerHistoryFiltersForm, ()=>handleErrors(true), ()=>fetchData({
            pageIndex: 1
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        as: "form",
        onSubmit: handleFiltersSubmit,
        children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Loading), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerHistorySearchInput.DrawerHistorySearchInput), {
                    actions: actions,
                    fields: fields,
                    searchErrors: showErrors,
                    fetchData: fetchData,
                    handleSubmit: handleFiltersSubmit,
                    shouldClear: shouldClear,
                    clear: clear
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                    background: (0, _components.constants).colors.ATHENS_GREY,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            childGap: "1rem",
                            align: "center",
                            overflow: "visible",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.AmtFilterContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                        "data-testid": "Min Amount Test",
                                        labelTextWhenNoError: "Min Amount",
                                        errorMessages: (0, _filterFormsHelpers.minAmountErrorsMessage),
                                        field: fields.minAmount,
                                        errors: fields.errors,
                                        fieldActions: actions.fields.minAmount,
                                        type: "number",
                                        labelTextVariant: "p",
                                        errorTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.AmtFilterContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                                        "data-testid": "Max Amount Test",
                                        labelTextWhenNoError: "Max Amount",
                                        errorMessages: (0, _filterFormsHelpers.maxAmountErrorsMessage),
                                        field: fields.maxAmount,
                                        errors: fields.errors,
                                        fieldActions: actions.fields.maxAmount,
                                        type: "number",
                                        labelTextVariant: "p",
                                        errorTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDefault.default), {
                                    label: "Start Date (mm/dd/yyyy)",
                                    id: "drawer-history-start-date",
                                    field: fields.startDate,
                                    fieldActions: actions.fields.startDate
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDefault.default), {
                                    label: "End Date (mm/dd/yyyy)",
                                    id: "drawer-history-end-date",
                                    field: fields.endDate,
                                    fieldActions: actions.fields.endDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            childGap: "1rem",
                            align: "center",
                            overflow: "visible",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "Agency Test",
                                        labelTextWhenNoError: "Agency",
                                        options: agencyOptions,
                                        fieldActions: actions.fields.agency,
                                        showErrors: fields.errors,
                                        field: fields.agency,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "Location Test",
                                        labelTextWhenNoError: "Location",
                                        options: locationOptions,
                                        fieldActions: actions.fields.location,
                                        showErrors: fields.errors,
                                        field: fields.location,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "Terminal Test",
                                        labelTextWhenNoError: "Terminal",
                                        options: terminalOptions,
                                        fieldActions: actions.fields.terminal,
                                        showErrors: fields.errors,
                                        field: fields.terminal,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styled.SelectContainer), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormSelect), {
                                        hasTitles: true,
                                        dropdownMaxHeight: "200px",
                                        "data-testid": "User Test",
                                        labelTextWhenNoError: "User",
                                        options: userOptions,
                                        fieldActions: actions.fields.user,
                                        showErrors: fields.errors,
                                        field: fields.user,
                                        widthFitOptions: true,
                                        labelTextVariant: "p",
                                        errorLabelTextVariant: "p"
                                    })
                                })
                            ]
                        }),
                        oneOrMoreActiveFilters && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            type: "reset",
                            padding: "0",
                            margin: "0",
                            variant: "smallGhost",
                            action: clearFilterForm,
                            text: "Clear filters"
                        })
                    ]
                })
            ]
        })
    });
};
DrawerHistoryFiltersForm.reducer = (0, _drawerHistoryFiltersFormState.reducer);
DrawerHistoryFiltersForm.mapStateToProps = (0, _drawerHistoryFiltersFormState.mapStateToProps);
DrawerHistoryFiltersForm.mapDispatchToProps = (0, _drawerHistoryFiltersFormState.mapDispatchToProps);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","./DrawerHistoryFiltersForm.state":"ld1Dw","../../utils/filterFormsHelpers":"iHHYA","./DrawerHistorySearchInput":"7B6PH","../../components/styled":"uxYqN","../../components/date-picker":"2lTFu","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ld1Dw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
var _reduxFreeform = require("redux-freeform");
const drawerHistoryIndexFiltersFormConfig = {
    id: {},
    startDate: {
        constraints: [
            (0, _reduxFreeform.hasLength)(0, 8)
        ],
        validators: [
            (0, _reduxFreeform.hasLength)(8, 8)
        ]
    },
    endDate: {
        constraints: [
            (0, _reduxFreeform.hasLength)(0, 8)
        ],
        validators: [
            (0, _reduxFreeform.hasLength)(8, 8)
        ]
    },
    maxAmount: {
        constraints: [
            (0, _reduxFreeform.hasNumber)()
        ],
        validators: [
            (0, _reduxFreeform.hasNumber)(),
            (0, _reduxFreeform.numberGreaterThan)(0)
        ]
    },
    minAmount: {
        constraints: [
            (0, _reduxFreeform.hasNumber)()
        ],
        validators: [
            (0, _reduxFreeform.hasNumber)(),
            (0, _reduxFreeform.numberGreaterThanOrEqualTo)(0)
        ]
    },
    agency: {},
    type: {},
    location: {
        defaultValue: "all"
    },
    terminal: {
        defaultValue: "all"
    },
    user: {}
};
const { reducer, mapStateToProps, mapDispatchToProps } = (0, _reduxFreeform.createFormState)(drawerHistoryIndexFiltersFormConfig);

},{"redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iHHYA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateFormInputFormatter", ()=>dateFormInputFormatter);
parcelHelpers.export(exports, "getDefaultFormSelectOption", ()=>getDefaultFormSelectOption);
parcelHelpers.export(exports, "dateFilterErrors", ()=>dateFilterErrors);
parcelHelpers.export(exports, "dateFilterErrorMessage", ()=>dateFilterErrorMessage);
parcelHelpers.export(exports, "amountErrors", ()=>amountErrors);
parcelHelpers.export(exports, "minAmountErrorsMessage", ()=>minAmountErrorsMessage);
parcelHelpers.export(exports, "maxAmountErrorsMessage", ()=>maxAmountErrorsMessage);
parcelHelpers.export(exports, "requireErrors", ()=>requireErrors);
var _formattedInput = require("formatted-input");
var _reduxFreeform = require("redux-freeform");
const formatDelimiter = "_";
const dateFormats = [
    "",
    "_",
    "__/",
    "__/_",
    "__/__/",
    "__/__/_",
    "__/__/__",
    "__/__/___",
    "__/__/____"
];
const dateFormInputFormatter = (0, _formattedInput.createFormat)(dateFormats, formatDelimiter);
const getDefaultFormSelectOption = (key)=>({
        text: `All ${key}`,
        value: "all"
    });
const dateFilterErrors = (errorText)=>({
        [(0, _reduxFreeform.dateBeforeToday).error]: errorText,
        [(0, _reduxFreeform.hasLength).error]: errorText
    });
const dateFilterErrorMessage = dateFilterErrors("Invalid date format");
const amountErrors = (errorText)=>({
        [(0, _reduxFreeform.hasNumber).error]: errorText,
        [(0, _reduxFreeform.numberGreaterThan).error]: errorText,
        [(0, _reduxFreeform.numberGreaterThanOrEqualTo).error]: errorText
    });
const minAmountErrorsMessage = amountErrors("Min must be at least $0");
const maxAmountErrorsMessage = amountErrors("Max must be greater than $0");
const requireErrors = (error_text)=>({
        [(0, _reduxFreeform.required).error]: error_text
    });

},{"formatted-input":"7KwKx","redux-freeform":"1Yc5v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7KwKx":[function(require,module,exports) {
(function(global, factory) {
    factory(exports, require("be837f56ef67647a"));
})(this, function(exports1, React) {
    "use strict";
    var React__default = "default" in React ? React["default"] : React;
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(source, true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(source).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        }
    }
    function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    var getUniqueFormatDelimiters = function getUniqueFormatDelimiters(formats, formatChar) {
        return _toConsumableArray(new Set(formats.join("").split(formatChar).join("").split("")));
    };
    var format = function format(formatter) {
        return function(value) {
            var usedFormat = formatter.formats[value.length];
            if (!usedFormat) return value;
            var formatPieces = usedFormat.split(formatter.formatChar);
            var valuePieces = value.split("");
            var zipped = formatPieces.map(function(v, i) {
                return v + (valuePieces[i] || "");
            });
            return zipped.join("");
        };
    };
    var countDelims = function countDelims(formatter, index) {
        var count = 0;
        var format = formatter.formats[index];
        if (!format) return 0;
        formatter.uniqueDelimiters.forEach(function(delim) {
            return count += format.split(delim).length - 1;
        });
        return count;
    };
    var unformat = function unformat(formatter) {
        return function(formattedValue, formatIndex) {
            if (formatIndex >= formatter.formats.length) return formattedValue;
            var format = formatter.formats[formatIndex];
            return formattedValue.split("").filter(function(_, i) {
                return !(format[i] != formatter.formatChar);
            }).join("");
        };
    };
    var inject = function inject(baseString) {
        return function(start, end, newString) {
            return baseString.substring(0, start) + newString + baseString.substring(end);
        };
    };
    var formattedToUnformattedIndex = function formattedToUnformattedIndex(formattedIndex, rawValue, formatter) {
        var maxFormatExceeded = rawValue.length >= formatter.formats.length;
        if (maxFormatExceeded) return formattedIndex;
        else {
            var formatString = formatter.formats[rawValue.length];
            var beforeString = formatString.slice(0, formattedIndex);
            return beforeString.split("").filter(function(c) {
                return c === formatter.formatChar;
            }).length;
        }
    };
    var unformattedToFormattedIndex = function unformattedToFormattedIndex(rawIndex, rawValue, formatter, del) {
        var maxFormatExceeded = rawValue.length >= formatter.formats.length; // If forced to stay formatted, offset by delims - 1
        // This is done so the component doesn't assume that any added chars will be kept
        // (i.e. if an external constraint is applied)
        if (maxFormatExceeded) {
            var delims = countDelims(formatter, rawValue.length - 1);
            return delims > 0 && !del ? rawIndex + delims - 1 : rawIndex;
        } else return formatter.formats[rawValue.length].split(formatter.formatChar).slice(0, rawIndex).reduce(function(acc, curr) {
            return curr.length + acc;
        }, 0) + rawIndex;
    };
    var createFormat = function createFormat(formats, formatChar) {
        return {
            uniqueDelimiters: getUniqueFormatDelimiters(formats, formatChar),
            formats: formats,
            formatChar: formatChar
        };
    };
    var FormattedInput = function FormattedInput(_ref) {
        var value = _ref.value, formatter = _ref.formatter, onChange = _ref.onChange, props = _objectWithoutProperties(_ref, [
            "value",
            "formatter",
            "onChange"
        ]);
        var inputEl = React.useRef(null);
        var stateRefs = React.useRef({
            selectionStart: 0,
            selectionEnd: 0,
            isDelete: false,
            rawValue: ""
        });
        React.useLayoutEffect(function() {
            // A lot of the work here is cursor manipulation
            if (inputEl.current && inputEl.current === document.activeElement) inputEl.current.setSelectionRange(stateRefs.current.selectionStart, stateRefs.current.selectionEnd);
        }, [
            stateRefs
        ]);
        var handleChange = function handleChange(event) {
            var deleteKeyPressed = stateRefs.current.isDelete;
            var maxFormatExceeded = stateRefs.current.rawValue.length >= formatter.formats.length - 1;
            if (maxFormatExceeded && !deleteKeyPressed) return;
            /* At the beginning of onChange, event.target.value is a concat of the previous formatted value
      * and an unformatted injection at the start, end, or in the middle (maybe a deletion). To prepare 
      * the unformatted value for the user's onChange, the formatted string and unformatted injection need
      * to be separated, then unformat the formatted string, then insert (or delete) the injection from the
      * old unformatted value.
      */ // Derive the previous formatted value directly from the value prop (last
            // render's closure). This is always correct — it can never diverge even
            // when external onChange rejects or filters the typed character.
            var prevFormattedValue = format(formatter)(stateRefs.current.rawValue);
            var injectionLength = event.target.value.length - prevFormattedValue.length;
            var end = stateRefs.current.selectionStart === stateRefs.current.selectionEnd ? stateRefs.current.selectionStart + injectionLength : stateRefs.current.selectionEnd - 1;
            var injection = event.target.value.substring(stateRefs.current.selectionStart, end); // Injection is the new unformatted piece of the input
            // Need to find where to put it
            var rawInjectionPointStart = formattedToUnformattedIndex(stateRefs.current.selectionStart, stateRefs.current.rawValue, formatter);
            var rawInjectionPointEnd = formattedToUnformattedIndex(stateRefs.current.selectionEnd, stateRefs.current.rawValue, formatter); // Unformat the previous formatted value for injection
            // Using the relevant format string, strips away chars not marked with the formatChar
            var unformattedOldValue = unformat(formatter)(prevFormattedValue, stateRefs.current.rawValue.length); // Edit the previous unformatted value (either add, update or delete)
            var injectIntoOldValue = inject(unformattedOldValue);
            var unformattedNewValue = deleteKeyPressed ? rawInjectionPointStart === rawInjectionPointEnd ? injectIntoOldValue(rawInjectionPointStart - 1, rawInjectionPointStart, "") : injectIntoOldValue(rawInjectionPointStart, rawInjectionPointEnd, "") : injectIntoOldValue(rawInjectionPointStart, rawInjectionPointEnd, injection);
            var lengthDifference = unformattedNewValue.length - stateRefs.current.rawValue.length;
            var rawIndex = formattedToUnformattedIndex(stateRefs.current.selectionStart, stateRefs.current.rawValue, formatter) + lengthDifference; // Find the new cursor position for the potential formatted value
            // Applied by useLayoutEffect
            var newFormattedCursorPosition = stateRefs.current.selectionStart === stateRefs.current.selectionEnd ? unformattedToFormattedIndex(rawIndex, unformattedNewValue, formatter, deleteKeyPressed) : deleteKeyPressed ? stateRefs.current.selectionStart : stateRefs.current.selectionEnd;
            stateRefs.current = _objectSpread2({}, stateRefs.current, {
                selectionStart: newFormattedCursorPosition,
                selectionEnd: newFormattedCursorPosition
            }); // Apply the external onChange function to the raw underlying string
            // This is where the user generally updates the input value
            if (onChange) onChange(unformattedNewValue);
        };
        return React__default.createElement("input", _extends({}, props, {
            ref: inputEl,
            value: format(formatter)(value),
            onKeyDown: function onKeyDown(event) {
                // Keep track of the state of the input before onChange
                stateRefs.current = {
                    isDelete: event.key === "Backspace" || event.key === "Delete",
                    selectionStart: event.target.selectionStart,
                    selectionEnd: event.target.selectionEnd,
                    rawValue: value
                };
            },
            onChange: handleChange
        }));
    };
    exports1.FormattedInput = FormattedInput;
    exports1.createFormat = createFormat;
    exports1.format = format;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

},{"be837f56ef67647a":"d8NEQ"}],"7B6PH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DrawerHistorySearchInput", ()=>DrawerHistorySearchInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _searchIcons = require("../../components/search-icons");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const DrawerHistorySearchInputWrapper = (0, _styledComponentsDefault.default).div`
  .searchDrawerHistoryIDSearchIcon {
    width: 2rem;
  }

  .searchDrawerHistoryIDInput {
    border: 0;
    width: 860px;
    margin-top: 0.25rem;
  }
`;
const DrawerHistorySearchInput = ({ fields, actions, clear, shouldClear, fetchData, handleSubmit })=>{
    (0, _react.useEffect)(()=>{
        if (shouldClear) {
            actions.fields.id.set("");
            fetchData({
                pageIndex: 1
            });
        }
    }, [
        shouldClear
    ]);
    const searchErrors = {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DrawerHistorySearchInputWrapper, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            childGap: "0.25rem",
            justify: "space-around",
            align: "center",
            minHeight: "100%",
            minWidth: "100%",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    extraStyles: `overflow: visible;`,
                    align: "center",
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0px 12px 0px 0px",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchIcons.SearchIcon), {
                                color: (0, _components.constants).colors.LUCKY_POINT
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FormInput), {
                            placeholder: "Enter Batch Number or Cash Action ID to search",
                            themeValues: {
                                lineHeight: 0
                            },
                            "data-testid": "drawer-history-ID",
                            className: "searchDrawerHistoryIDInput",
                            errorMessages: searchErrors,
                            field: fields.id,
                            errors: fields.id.errors,
                            fieldActions: actions.fields.id,
                            labelTextVariant: "p",
                            errorTextVariant: "p"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    type: "reset",
                    variant: "smallGhost",
                    text: "Clear Search",
                    "data-testid": "drawerHistoryIDClearSearch",
                    action: ()=>{
                        clear();
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    type: "submit",
                    minWidth: "0",
                    width: "3rem",
                    padding: ".5rem",
                    minHeight: "0",
                    extraStyles: `line-height: 1;`,
                    "data-testid": "drawer-history-submit-filters",
                    variant: "primary",
                    contentOverride: true,
                    action: handleSubmit,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchIcons.SearchIcon), {
                        color: (0, _components.constants).colors.WHITE,
                        className: "searchDrawerHistoryIDSearchIcon"
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../components/search-icons":"9k6tm","styled-components":"bkusY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6xsNt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VISIT_EXPIRATION_WARNING_THRESHOLD_SECONDS", ()=>VISIT_EXPIRATION_WARNING_THRESHOLD_SECONDS);
parcelHelpers.export(exports, "SET_VISIT_EXPIRES_AT", ()=>SET_VISIT_EXPIRES_AT);
parcelHelpers.export(exports, "VISIT_EXPIRATION_WARNING", ()=>VISIT_EXPIRATION_WARNING);
parcelHelpers.export(exports, "VISIT_EXPIRATION_TICK", ()=>VISIT_EXPIRATION_TICK);
parcelHelpers.export(exports, "VISIT_EXPIRED", ()=>VISIT_EXPIRED);
parcelHelpers.export(exports, "CLEAR_VISIT_EXPIRATION", ()=>CLEAR_VISIT_EXPIRATION);
parcelHelpers.export(exports, "DISMISS_VISIT_EXPIRATION_WARNING", ()=>DISMISS_VISIT_EXPIRATION_WARNING);
parcelHelpers.export(exports, "setVisitExpiresAt", ()=>setVisitExpiresAt);
parcelHelpers.export(exports, "visitExpirationWarning", ()=>visitExpirationWarning);
parcelHelpers.export(exports, "visitExpirationTick", ()=>visitExpirationTick);
parcelHelpers.export(exports, "visitExpired", ()=>visitExpired);
parcelHelpers.export(exports, "clearVisitExpiration", ()=>clearVisitExpiration);
parcelHelpers.export(exports, "dismissVisitExpirationWarning", ()=>dismissVisitExpirationWarning);
parcelHelpers.export(exports, "reducer", ()=>reducer);
const VISIT_EXPIRATION_WARNING_THRESHOLD_SECONDS = 180;
const SET_VISIT_EXPIRES_AT = "SET_VISIT_EXPIRES_AT";
const VISIT_EXPIRATION_WARNING = "VISIT_EXPIRATION_WARNING";
const VISIT_EXPIRATION_TICK = "VISIT_EXPIRATION_TICK";
const VISIT_EXPIRED = "VISIT_EXPIRED";
const CLEAR_VISIT_EXPIRATION = "CLEAR_VISIT_EXPIRATION";
const DISMISS_VISIT_EXPIRATION_WARNING = "DISMISS_VISIT_EXPIRATION_WARNING";
const setVisitExpiresAt = (expiresAt)=>({
        type: SET_VISIT_EXPIRES_AT,
        payload: expiresAt
    });
const visitExpirationWarning = (secondsRemaining)=>({
        type: VISIT_EXPIRATION_WARNING,
        payload: secondsRemaining
    });
const visitExpirationTick = (secondsRemaining)=>({
        type: VISIT_EXPIRATION_TICK,
        payload: secondsRemaining
    });
const visitExpired = ()=>({
        type: VISIT_EXPIRED
    });
const clearVisitExpiration = ()=>({
        type: CLEAR_VISIT_EXPIRATION
    });
const dismissVisitExpirationWarning = ()=>({
        type: DISMISS_VISIT_EXPIRATION_WARNING
    });
const initialState = {
    visitExpiresAt: null,
    isWarningVisible: false,
    secondsRemaining: 0
};
const reducer = (state = initialState, { type, payload } = {})=>{
    switch(type){
        case SET_VISIT_EXPIRES_AT:
            return {
                ...state,
                visitExpiresAt: payload,
                isWarningVisible: false,
                secondsRemaining: 0
            };
        case VISIT_EXPIRATION_WARNING:
            return {
                ...state,
                isWarningVisible: true,
                secondsRemaining: payload
            };
        case VISIT_EXPIRATION_TICK:
            return {
                ...state,
                secondsRemaining: payload
            };
        case VISIT_EXPIRED:
            return {
                ...state,
                visitExpiresAt: null,
                isWarningVisible: false,
                secondsRemaining: 0
            };
        // Intentionally only hides the modal without stopping the countdown.
        // The countdown continues in the background so that when it reaches zero,
        // visitExpiredActionEpic fires and shows an alert requiring manual intervention
        // (void payments and cancel). This only applies to the split-tender case.
        case DISMISS_VISIT_EXPIRATION_WARNING:
            return {
                ...state,
                isWarningVisible: false
            };
        case CLEAR_VISIT_EXPIRATION:
            return initialState;
        default:
            return state;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5xRzg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL", ()=>REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL);
parcelHelpers.export(exports, "requestPeriscopeDashboardIframe", ()=>requestPeriscopeDashboardIframe);
parcelHelpers.export(exports, "GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED", ()=>GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED);
parcelHelpers.export(exports, "getPeriscopeDashboardIFrameUrlFailed", ()=>getPeriscopeDashboardIFrameUrlFailed);
parcelHelpers.export(exports, "GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED", ()=>GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED);
parcelHelpers.export(exports, "getPeriscopeDashboardIFrameUrlSucceeded", ()=>getPeriscopeDashboardIFrameUrlSucceeded);
parcelHelpers.export(exports, "PERISCOPE_DATA_SUCCESS", ()=>PERISCOPE_DATA_SUCCESS);
parcelHelpers.export(exports, "periscopeDataRequestSuccess", ()=>periscopeDataRequestSuccess);
parcelHelpers.export(exports, "PERISCOPE_DATA_FAILURE", ()=>PERISCOPE_DATA_FAILURE);
parcelHelpers.export(exports, "periscopeDataRequestFailure", ()=>periscopeDataRequestFailure);
parcelHelpers.export(exports, "CLEAR_PERISCOPE_STATE", ()=>CLEAR_PERISCOPE_STATE);
parcelHelpers.export(exports, "clearPeriscopeState", ()=>clearPeriscopeState);
parcelHelpers.export(exports, "ALERT_BAR_ACTION", ()=>ALERT_BAR_ACTION);
parcelHelpers.export(exports, "reportingAlertBarAction", ()=>reportingAlertBarAction);
parcelHelpers.export(exports, "_reducer", ()=>_reducer);
parcelHelpers.export(exports, "_mapStateToProps", ()=>_mapStateToProps);
parcelHelpers.export(exports, "_mapDispatchToProps", ()=>_mapDispatchToProps);
parcelHelpers.export(exports, "reducer", ()=>reducer);
parcelHelpers.export(exports, "mapStateToProps", ()=>mapStateToProps);
parcelHelpers.export(exports, "mapDispatchToProps", ()=>mapDispatchToProps);
parcelHelpers.export(exports, "actions", ()=>actions);
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _nested = require("../../utils/Nested");
const REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL = "periscopeDashboardIframe/REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL";
const requestPeriscopeDashboardIframe = ()=>({
        type: REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL
    });
const GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED = "periscopeDashboardIframe/GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED";
const getPeriscopeDashboardIFrameUrlFailed = ({ error })=>({
        type: GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED,
        error: true,
        payload: error
    });
const GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED = "periscopeDashboardIframe/GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED";
const getPeriscopeDashboardIFrameUrlSucceeded = ({ url })=>({
        type: GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED,
        payload: {
            url
        }
    });
const PERISCOPE_DATA_SUCCESS = "periscopeDashboardIframe/PERISCOPE_DATA_SUCCESS";
const periscopeDataRequestSuccess = ()=>({
        type: PERISCOPE_DATA_SUCCESS
    });
const PERISCOPE_DATA_FAILURE = "periscopeDashboardIframe/PERISCOPE_DATA_FAILURE";
const periscopeDataRequestFailure = ()=>({
        type: PERISCOPE_DATA_FAILURE
    });
const CLEAR_PERISCOPE_STATE = "periscopeDashboardIframe/CLEAR_PERISCOPE_STATE";
const clearPeriscopeState = ()=>({
        type: CLEAR_PERISCOPE_STATE
    });
const ALERT_BAR_ACTION = "reporting/ALERT_BAR_ACTION";
const reportingAlertBarAction = _nested.nestedAction(ALERT_BAR_ACTION);
const INITIAL_STATE = {
    url: "",
    dashboardUrlRequestPending: false,
    dasboardUrlRequestError: "",
    periscopeDataPending: false,
    periscopeDataSuccess: false,
    periscopeDataFailure: false
};
const _reducer = (state = INITIAL_STATE, action = {})=>{
    const { type, payload } = action;
    switch(type){
        case REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL:
            return {
                ...state,
                dashboardUrlRequestPending: true,
                periscopeDataPending: true,
                periscopeDataSuccess: false,
                periscopeDataFailure: false
            };
        case GET_PERISCOPE_DASHBOARD_IFRAME_URL_SUCCEEDED:
            return {
                ...state,
                dashboardUrlRequestPending: false,
                dashboardUrlRequestError: "",
                url: payload.url
            };
        case GET_PERISCOPE_DASHBOARD_IFRAME_URL_FAILED:
            return {
                ...state,
                dashboardUrlRequestPending: false,
                dashboardUrlRequestError: payload
            };
        case PERISCOPE_DATA_SUCCESS:
            return {
                ...state,
                periscopeDataPending: false,
                periscopeDataSuccess: true
            };
        case PERISCOPE_DATA_FAILURE:
            return {
                ...state,
                periscopeDataPending: false,
                periscopeDataFailure: true
            };
        case CLEAR_PERISCOPE_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};
const _mapStateToProps = (state)=>({
        ...state.reporting
    });
const _mapDispatchToProps = ()=>{};
// Nested Redux Maps
const { reducer: nestedReducer, mapStateToProps, mapDispatchToProps, actions } = _nested.nestStates({
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps
}, {
    alertBars: {
        reportingAlertBars: {
            ..._alertBarState,
            actionType: ALERT_BAR_ACTION
        }
    }
}, "reporting");
// Nested Reducer
const reducer = (state, action)=>nestedReducer(state, action);

},{"../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/Nested":"gDQL4","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dChnr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>airbrakeMiddleware);
function airbrakeMiddleware(airbrake, { sendState = false, sendLastAction = false, noticeAnnotations = {} } = {}) {
    if (!airbrake || !airbrake.notify) {
        console.error("A valid Airbrake instance must be provided for redux-airbrake.");
        return (_store)=>(next)=>(action)=>{
                    next(action);
                };
    }
    const airbrakeNotify = async (notice)=>await airbrake.notify({
            ...noticeAnnotations,
            ...notice,
            params: {
                ...noticeAnnotations.params || {},
                ...notice.params
            }
        });
    return (store)=>(next)=>(action)=>{
                try {
                    return next(action);
                } catch (error) {
                    console.error(error);
                    const params = {};
                    if (sendState) params.state = store.getState();
                    if (sendLastAction) params.action = action;
                    airbrakeNotify({
                        error,
                        params
                    });
                    return error;
                }
            };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1PiFF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logoutEpic", ()=>logoutEpic);
parcelHelpers.export(exports, "idpUserParams", ()=>idpUserParams);
parcelHelpers.export(exports, "logInOktaUserEpic", ()=>logInOktaUserEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _loginState = require("./Login.state");
var _reducer = require("../../state/reducer");
var _oktaAuthJs = require("@okta/okta-auth-js");
const logoutEpic = (action$, _)=>action$.ofType((0, _reducer.LOGOUT)).pipe(_operators.flatMap((action)=>{
        action.payload.navigate("/logout");
        return _rxjs.of({
            type: "LOGOUT_REDIRECT"
        });
    }));
const idpUserParams = (state)=>({
        username: state.login.forms.loginForm.email.rawValue?.toLowerCase(),
        oidc: state.config.oidc
    });
// This flow for Okta login with an external Identity Provider
// is based on the code for the Okta Signin Widget
// https://github.com/okta/okta-signin-widget/blob/27625d50ecd2fcddb6fb6b86ad503a218eb90bd8/src/models/IDPDiscovery.js#L53
const buildInputForParameter = (name, value)=>{
    const input = document.createElement("input");
    input.name = name;
    input.value = decodeURIComponent(value);
    input.type = "hidden";
    return input;
};
const idpLoginFlow = (oktaAuth, username)=>oktaAuth.webfinger({
        resource: `acct:${username}`,
        rel: "okta:idp",
        requestContext: window.location.href
    }).then((res)=>{
        if (res?.links?.[0]?.href) {
            const url = new URL(res.links[0].href);
            const fragment = url.hash.substring(1);
            const query = url.search.substring(1);
            let targetUrl = url.origin + url.pathname;
            if (fragment) targetUrl += "#" + fragment;
            const form = document.createElement(`form`);
            form.method = "get";
            form.setAttribute("style", "display: none;");
            form.action = encodeURI(targetUrl);
            if (query && query.length) {
                const queryParts = query.split("&");
                queryParts.forEach((queryPart)=>{
                    const parameterParts = queryPart.split("=");
                    const input = buildInputForParameter(parameterParts[0], parameterParts[1]);
                    form.appendChild(input);
                });
            }
            document.body.appendChild(form);
            form.submit();
        }
    }).catch((err)=>console.warn(`Warning: Webfinger error:`, err));
const logInOktaUserEpic = (action$, state$)=>action$.ofType((0, _loginState.SUBMIT_LOGIN_FORM)).pipe(_operators.mergeMap(()=>{
        const { username, oidc } = idpUserParams(state$.value);
        const oktaAuth = new (0, _oktaAuthJs.OktaAuth)(oidc);
        idpLoginFlow(oktaAuth, username);
        return _rxjs.of({
            type: "LOGIN_SUCCESS"
        });
    }));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","./Login.state":"eq6dI","../../state/reducer":"aTwKq","@okta/okta-auth-js":"boELZ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bl4Aq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "caughtTerminalLoginErrorCallback", ()=>caughtTerminalLoginErrorCallback);
parcelHelpers.export(exports, "submitTerminalLoginFormEpic", ()=>submitTerminalLoginFormEpic);
parcelHelpers.export(exports, "fetchLocationsEpic", ()=>fetchLocationsEpic);
parcelHelpers.export(exports, "fetchTerminalsEpic", ()=>fetchTerminalsEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _terminalLoginState = require("./TerminalLogin.state");
var _client = require("../../utils/api/client");
var _state = require("../../utils/state");
var _errorHandler = require("../../utils/api/errorHandler");
const caughtTerminalLoginErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _terminalLoginState.terminalLoginAlertBarAction), "Terminal Login Error:", state);
const terminalLoginParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        terminal_id: state.terminalLogin.forms.terminalLoginForm.terminal.rawValue,
        token: (0, _state.getAccessToken)(state)
    });
const transferTerminalParams = (state, email, terminal_session_id)=>({
        url: (0, _state.getPosApiUrl)(state),
        email,
        terminal_id: state.terminalLogin.forms.terminalLoginForm.terminal.rawValue,
        terminal_session_id,
        token: (0, _state.getAccessToken)(state),
        method: "PUT"
    });
const submitTerminalLoginFormEpic = (action$, state$)=>action$.ofType((0, _terminalLoginState.SUBMIT_TERMINAL_LOGIN_FORM)).pipe(_operators.flatMap((action)=>{
        const { isSessionTransfer, email, terminal_session_id } = action.payload;
        if (isSessionTransfer) return _rxjs.from((0, _client.transferTerminal)(transferTerminalParams(state$.value, email, terminal_session_id))).pipe(_operators.flatMap((response)=>{
            action.payload.navigate("/pos/products");
            return _rxjs.of((0, _terminalLoginState.terminalLoginSuccess)(response.data));
        }), _operators.catchError((err)=>caughtTerminalLoginErrorCallback(state$.value)(err, (0, _terminalLoginState.terminalLoginFailure)(err.message))));
        else return _rxjs.from((0, _client.loginTerminal)(terminalLoginParams(state$.value))).pipe(_operators.flatMap((response)=>{
            action.payload.navigate("/pos/products");
            return _rxjs.of((0, _terminalLoginState.terminalLoginSuccess)(response.data));
        }), _operators.catchError((err)=>caughtTerminalLoginErrorCallback(state$.value)(err, (0, _terminalLoginState.terminalLoginFailure)(err.message))));
    }));
const fetchLocationsParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const fetchLocationsEpic = (action$, state$)=>action$.ofType((0, _terminalLoginState.FETCH_LOCATIONS)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchLocationsRequest)(fetchLocationsParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _terminalLoginState.fetchLocationsSuccess)(response))), _operators.catchError((err)=>caughtTerminalLoginErrorCallback(state$.value)(err, (0, _terminalLoginState.fetchLocationsFailure)({
                err: err.message,
                navigate: action.payload.navigate
            }))))));
const fetchTerminalsParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        locationId: action.payload,
        token: (0, _state.getAccessToken)(state)
    });
const fetchTerminalsEpic = (action$, state$)=>action$.ofType((0, _terminalLoginState.FETCH_TERMINALS)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchTerminalsRequest)(fetchTerminalsParams(state$.value, action))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _terminalLoginState.fetchTerminalsSuccess)(response))), _operators.catchError((err)=>caughtTerminalLoginErrorCallback(state$.value)(err, (0, _terminalLoginState.fetchTerminalsFailure)(err.message), state$.value)))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","./TerminalLogin.state":"7GhEX","../../utils/api/client":"27HsT","../../utils/state":"8UPqD","../../utils/api/errorHandler":"jWFhB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"27HsT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loginTerminal", ()=>loginTerminal);
parcelHelpers.export(exports, "transferTerminal", ()=>transferTerminal);
parcelHelpers.export(exports, "fetchClientConfig", ()=>fetchClientConfig);
parcelHelpers.export(exports, "fetchCurrentAbilities", ()=>fetchCurrentAbilities);
parcelHelpers.export(exports, "fetchLocationsRequest", ()=>fetchLocationsRequest);
parcelHelpers.export(exports, "fetchTerminalsRequest", ()=>fetchTerminalsRequest);
parcelHelpers.export(exports, "fetchProductsRequest", ()=>fetchProductsRequest);
parcelHelpers.export(exports, "fetchAgenciesRequest", ()=>fetchAgenciesRequest);
parcelHelpers.export(exports, "fetchLookupByIdRequest", ()=>fetchLookupByIdRequest);
parcelHelpers.export(exports, "voidOrderById", ()=>voidOrderById);
parcelHelpers.export(exports, "reopenOrderById", ()=>reopenOrderById);
parcelHelpers.export(exports, "returnOrderById", ()=>returnOrderById);
parcelHelpers.export(exports, "makePayment", ()=>makePayment);
parcelHelpers.export(exports, "getPaymentById", ()=>getPaymentById);
parcelHelpers.export(exports, "pollByPaymentIdentifier", ()=>pollByPaymentIdentifier);
parcelHelpers.export(exports, "fetchServiceFeeRequest", ()=>fetchServiceFeeRequest);
parcelHelpers.export(exports, "fetchConvenienceFeeRequest", ()=>fetchConvenienceFeeRequest);
parcelHelpers.export(exports, "fetchSearchByIdRequest", ()=>fetchSearchByIdRequest);
parcelHelpers.export(exports, "addToCart", ()=>addToCart);
parcelHelpers.export(exports, "getOrder", ()=>getOrder);
parcelHelpers.export(exports, "searchForItem", ()=>searchForItem);
parcelHelpers.export(exports, "cancelOrderById", ()=>cancelOrderById);
parcelHelpers.export(exports, "holdOrder", ()=>holdOrder);
parcelHelpers.export(exports, "removeOrderItem", ()=>removeOrderItem);
parcelHelpers.export(exports, "fetchOrderDetails", ()=>fetchOrderDetails);
parcelHelpers.export(exports, "postOrderReceipt", ()=>postOrderReceipt);
parcelHelpers.export(exports, "fetchOrders", ()=>fetchOrders);
parcelHelpers.export(exports, "fetchDrawerHistories", ()=>fetchDrawerHistories);
parcelHelpers.export(exports, "fetchDrawerHistoryFilterOptions", ()=>fetchDrawerHistoryFilterOptions);
parcelHelpers.export(exports, "fetchOrdersFilterOptions", ()=>fetchOrdersFilterOptions);
parcelHelpers.export(exports, "fetchUsers", ()=>fetchUsers);
parcelHelpers.export(exports, "fetchBatches", ()=>fetchBatches);
parcelHelpers.export(exports, "openCashDrawer", ()=>openCashDrawer);
parcelHelpers.export(exports, "createCloseout", ()=>createCloseout);
parcelHelpers.export(exports, "fetchCloseoutReport", ()=>fetchCloseoutReport);
parcelHelpers.export(exports, "reprintCloseoutReports", ()=>reprintCloseoutReports);
parcelHelpers.export(exports, "fetchCurrentBatch", ()=>fetchCurrentBatch);
parcelHelpers.export(exports, "postCashDrop", ()=>postCashDrop);
parcelHelpers.export(exports, "fetchCashAction", ()=>fetchCashAction);
parcelHelpers.export(exports, "fetchCloseoutDetails", ()=>fetchCloseoutDetails);
parcelHelpers.export(exports, "cancelTransaction", ()=>cancelTransaction);
parcelHelpers.export(exports, "cashActionReceipt", ()=>cashActionReceipt);
parcelHelpers.export(exports, "fetchDenominations", ()=>fetchDenominations);
parcelHelpers.export(exports, "voidTransactionById", ()=>voidTransactionById);
parcelHelpers.export(exports, "fetchPeriscopeDashboardIFrameUrl", ()=>fetchPeriscopeDashboardIFrameUrl);
parcelHelpers.export(exports, "cancelPaylinkById", ()=>cancelPaylinkById);
parcelHelpers.export(exports, "resetPinPad", ()=>resetPinPad);
parcelHelpers.export(exports, "postVisitId", ()=>postVisitId);
var _constants = require("../constants");
var _state = require("../state");
var _errorHandler = require("./errorHandler");
// Borrowed from https://github.com/kentcdodds/react-testing-library-course/blob/master/src/api.js
var _uuid = require("uuid");
async function client(endpoint, url, { data, token, headers: customHeaders, ...customConfig } = {}) {
    if (!token) console.warn("%cWarning: Access token not passed.", `background-color: ${(0, _constants.consoleWarningStyle)}`);
    if (token && (0, _state.isTokenExpired)()) console.warn("%cWarning: Access token expired.", `background-color: ${(0, _constants.consoleWarningStyle)}`);
    const loggingRequestId = (0, _uuid.v4)();
    const config = {
        method: data ? data.method || "POST" : "GET",
        body: data ? JSON.stringify({
            ...data,
            terminal_session_id: data?.terminal_session_id ?? (0, _state.getTerminalSessionId)()
        }) : undefined,
        headers: {
            "X-Request-Id": loggingRequestId,
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": data ? "application/json" : "application/json",
            ...customHeaders
        },
        ...customConfig
    };
    const path = url + endpoint;
    const response = await window.fetch(path, config);
    const responseData = await response.json();
    if (response.ok) return responseData;
    else return (0, _errorHandler.errorHandler)({
        code: response.status,
        status: response.statusText,
        message: responseData.message
    });
}
const loginTerminal = ({ url, token, ...data })=>client("/terminal_sessions", url, {
        token,
        data
    });
const transferTerminal = ({ url, token, ...data })=>client(`/terminal_sessions/${data.terminal_session_id}`, url, {
        token,
        data
    });
const fetchClientConfig = ({ url, token, ...data })=>client(`/clients/${data.clientId}`, url, {
        token
    });
const fetchCurrentAbilities = ({ url, token })=>client("/current_abilities", url, {
        token
    });
const fetchLocationsRequest = ({ url, token })=>client(`/locations`, url, {
        token
    });
const fetchTerminalsRequest = ({ url, token, ...data })=>client(`/locations/${data.locationId}/terminals`, url, {
        token
    });
const fetchProductsRequest = ({ url, token })=>client(`/products?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const fetchAgenciesRequest = ({ url, token })=>client(`/agencies?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const fetchLookupByIdRequest = ({ url, token, ...data })=>client(`/products/${data.id}/lookup?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const voidOrderById = ({ url, token, ...data })=>client(`/orders/${data.id}/void`, url, {
        token,
        data
    });
const reopenOrderById = ({ url, token, ...data })=>client(`/orders/${data.id}/reopen`, url, {
        token,
        data
    });
const returnOrderById = ({ url, token, ...data })=>client(`/orders/${data.id}/return`, url, {
        token,
        data
    });
const makePayment = ({ url, token, ...data })=>client(`/payments`, url, {
        token,
        data
    });
const getPaymentById = ({ url, token, ...data })=>{
    return client(`/payments/${data.id}`, url, {
        token
    });
};
const pollByPaymentIdentifier = ({ url, token, paymentAttemptUniqueId })=>{
    return client(`/payments/poll?payment_attempt_unique_identifier=${paymentAttemptUniqueId}`, url, {
        token
    });
};
const fetchServiceFeeRequest = ({ url, token, ...data })=>client(`/payments/calculate_service_fee?amount=${data.amount}&terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const fetchConvenienceFeeRequest = ({ url, token, ...data })=>client(`/payments/convenience_fee?agency_id=${data.agency_id}&terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const fetchSearchByIdRequest = ({ url, token, ...data })=>client(`/products/${data.id}/search?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const addToCart = ({ url, token, ...data })=>client(`/orders/update`, url, {
        token,
        data
    });
const getOrder = ({ url, token })=>client(`/orders/current?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const searchForItem = ({ url, token, ...data })=>client(`/lookups?item_id=${data.id}&lookup_key=${data.key}&lookup_value=${data.value}&terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const cancelOrderById = ({ url, token, ...data })=>client(`/orders/${data.id}/cancel`, url, {
        token,
        data
    });
const holdOrder = ({ url, token })=>client(`/orders/hold?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const removeOrderItem = ({ url, token, ...data })=>client(`/orders/remove_item`, url, {
        token,
        data
    });
const fetchOrderDetails = ({ url, token, ...data })=>client(`/orders/order_details?id=${data.id}&terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const postOrderReceipt = ({ url, token, ...data })=>client(`/orders/${data.id}/receipt`, url, {
        token,
        data
    });
const fetchOrders = ({ url, token, ...data })=>client(`/orders?${data.filters}&page=${data.pageIndex}&per_page=${data.pageSize}&terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const fetchDrawerHistories = ({ url, token, ...data })=>client(`/drawer_histories?${data.filters}&page=${data.pageIndex}&per_page=${data.pageSize}&terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const fetchDrawerHistoryFilterOptions = ({ url, token, ...data })=>client(`/drawer_histories/filter_options?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token,
        ...data
    });
const fetchOrdersFilterOptions = ({ url, token, ...data })=>client(`/orders/filter_options?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token,
        ...data
    });
const fetchUsers = ({ url, token, ...data })=>client(`/cashiers`, url, {
        token,
        ...data
    });
const fetchBatches = ({ url, token, ...data })=>client(`/terminal_sessions`, url, {
        token,
        ...data
    });
const openCashDrawer = ({ url, token })=>client(`/peripherals/open_cash_drawer?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const createCloseout = ({ url, token, ...data })=>client("/batches/current/close", url, {
        token,
        data
    });
const fetchCloseoutReport = ({ url, token })=>client(`/batches/report/current?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const reprintCloseoutReports = ({ url, token, ...data })=>client(`/batches/${data.id}/report`, url, {
        token
    });
const fetchCurrentBatch = ({ url, token })=>client(`/batches/current?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const postCashDrop = ({ url, token, ...data })=>client(`/terminal_sessions/cash_actions`, url, {
        token,
        ...data
    });
const fetchCashAction = ({ url, token, ...data })=>client(`/cash_actions/${data.id}`, url, {
        token
    });
const fetchCloseoutDetails = ({ url, token, ...data })=>client(`/batches/${data.id}/closeout_details`, url, {
        token
    });
const cancelTransaction = ({ url, token, ...data })=>client(`/peripherals/cancel`, url, {
        token,
        ...data
    });
const cashActionReceipt = ({ url, token, ...data })=>client(`/cash_actions/${data.id}/receipt`, url, {
        token
    });
const fetchDenominations = ({ url, token })=>client(`/denominations`, url, {
        token
    });
const voidTransactionById = ({ url, token, ...data })=>client(`/payments/${data.id}/void`, url, {
        token,
        data
    });
const fetchPeriscopeDashboardIFrameUrl = ({ url, token })=>client(`/periscope_dashboard?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token
    });
const cancelPaylinkById = ({ url, token, ...data })=>client(`/payments/paylink/${data.id}/cancel`, url, {
        token,
        data
    });
const resetPinPad = ({ url, token, ...data })=>client(`/terminals/${data.terminalId}/reset_pin_pad?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token,
        ...data
    });
const postVisitId = ({ url, token, order_id, ...data })=>client(`/orders/${order_id}/visits?terminal_session_id=${(0, _state.getTerminalSessionId)()}`, url, {
        token,
        data
    });

},{"../constants":"f3A1R","../state":"8UPqD","./errorHandler":"jWFhB","uuid":"4vdp3","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jWFhB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorHandler", ()=>errorHandler);
parcelHelpers.export(exports, "caughtError", ()=>caughtError);
var _oktaAuthJs = require("@okta/okta-auth-js");
var _rxjs = require("rxjs");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _constants = require("../constants");
var _state = require("../state");
const errorHandler = ({ code, status, message })=>{
    switch(code){
        case 400:
        case 403:
            return Promise.reject({
                code,
                status,
                message,
                shouldRetry: false,
                alertType: "error"
            });
        case 401:
            return Promise.reject({
                code,
                status,
                message,
                shouldRetry: false,
                alertType: "warn"
            });
        case 404:
            return Promise.reject({
                code,
                status,
                message,
                shouldRetry: false,
                alertType: "warn"
            });
        case 500:
            return Promise.reject({
                code,
                status,
                message,
                shouldRetry: true,
                alertType: "error"
            });
        default:
            return Promise.reject({
                code: 500,
                status: status || "General Error",
                message: message || "Something went wrong",
                shouldRetry: false,
                alertType: "info"
            });
    }
};
const caughtError = (alertBar, heading, state, noAlert = false, errorMessageOnly = false)=>(error, ...otherActions)=>{
        if (noAlert) return _rxjs.of(...otherActions);
        const { status, name, message, alertType = "error" } = error;
        const oktaAuth = new (0, _oktaAuthJs.OktaAuth)(state.config.oidc);
        const is401 = error.code === 401;
        const isTerminalNotFound = error.message === (0, _constants.LOGOUT_REASONS).TERMINAL_SESSION_NOT_FOUND.value;
        const shouldLogout = is401 || isTerminalNotFound;
        if (shouldLogout) {
            if (is401) localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), (0, _state.isTokenExpired)() ? (0, _constants.LOGOUT_REASONS).EXPIRED.name : (0, _constants.LOGOUT_REASONS).UNAUTHORIZED.name);
            if (isTerminalNotFound) localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), (0, _constants.LOGOUT_REASONS).TERMINAL_SESSION_NOT_FOUND.name);
            oktaAuth.signOut({
                postLogoutRedirectUri: window.location.origin
            });
            (0, _state.clearLocalStorageSession)();
        }
        const alertAction = alertBar((0, _alertBarState.replaceAlerts)({
            heading: errorMessageOnly ? message : `${heading} ${status || name}`,
            text: errorMessageOnly ? "" : message,
            variant: alertType
        }));
        return _rxjs.of(alertAction, ...otherActions);
    };

},{"@okta/okta-auth-js":"boELZ","rxjs":"kbxjh","../../components/alert-bar/AlertBar.state":"HHSfQ","../constants":"f3A1R","../state":"8UPqD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ciyUa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "postVisitIdEpic", ()=>postVisitIdEpic);
parcelHelpers.export(exports, "retryPostVisitIdEpic", ()=>retryPostVisitIdEpic);
parcelHelpers.export(exports, "orderStatusResponseEpic", ()=>orderStatusResponseEpic);
parcelHelpers.export(exports, "sendPayLinkEpic", ()=>sendPayLinkEpic);
parcelHelpers.export(exports, "makePaymentEpic", ()=>makePaymentEpic);
parcelHelpers.export(exports, "scanCheckEpic", ()=>scanCheckEpic);
parcelHelpers.export(exports, "checkScanPollingEpic", ()=>checkScanPollingEpic);
parcelHelpers.export(exports, "awaitCustomerCreditCardEpic", ()=>awaitCustomerCreditCardEpic);
parcelHelpers.export(exports, "creditCardCountdownEpic", ()=>creditCardCountdownEpic);
parcelHelpers.export(exports, "cancelTransactionEpic", ()=>cancelTransactionEpic);
parcelHelpers.export(exports, "getServiceFeeEpic", ()=>getServiceFeeEpic);
parcelHelpers.export(exports, "getConvenienceFeeEpic", ()=>getConvenienceFeeEpic);
parcelHelpers.export(exports, "creditCardReadPollingEpic", ()=>creditCardReadPollingEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _state = require("../../utils/state");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _client = require("../../utils/api/client");
var _orderDetailsState = require("../order-details/OrderDetails.state");
var _checkoutState = require("./Checkout.state");
var _errorHandler = require("../../utils/api/errorHandler");
var _modalState = require("../../components/modal/Modal.state");
var _helpers = require("../../utils/helpers");
var _cartState = require("../cart/Cart.state");
var _constants = require("../../utils/constants");
var _state1 = require("../../state");
var _shared = require("../../state/shared");
var _traceNumber = require("../../utils/traceNumber");
const PAYLINK_SENT_STATUS = "paylink_sent";
const CHECKOUT_SCREEN_PATH = "/pos/checkout";
const caughtCheckoutError = (state)=>(0, _errorHandler.caughtError)((0, _checkoutState.checkoutAlertBarAction), "Checkout Error:", state);
const caughtCancelError = (state)=>(0, _errorHandler.caughtError)((0, _checkoutState.checkoutAlertBarAction), "Cancel Transaction Error:", state);
const makePaymentParams = (state, { payload })=>{
    const isPayerNameRequired = payload.hasOwnProperty("first_name") && payload.hasOwnProperty("last_name");
    let paymentParams;
    switch(payload.payment_tender_type){
        case 0, _constants.CASH:
            paymentParams = {
                ...isPayerNameRequired && {
                    first_name: payload.first_name,
                    last_name: payload.last_name
                },
                payment_tender_type: payload.payment_tender_type,
                amount_given: payload.amount_given,
                change_due: payload.change_due,
                payment_delivery_type: payload.payment_delivery_type
            };
            break;
        case 0, _constants.CARD:
            if (payload.manual_entry) paymentParams = {
                amount_given: payload.amount_given,
                service_fee: payload.service_fee,
                convenience_fee: payload.convenience_fee,
                payment_tender_type: payload.payment_tender_type,
                credit_card: {
                    first_name: payload.first_name,
                    last_name: payload.last_name,
                    number: payload.number,
                    month: payload.month,
                    year: payload.year,
                    cvv: payload.cvv,
                    zipcode: payload.zip_code,
                    manual_entry: payload.manual_entry
                },
                visit_id: payload.visit_id
            };
            else paymentParams = {
                ...isPayerNameRequired && {
                    first_name: payload.first_name,
                    last_name: payload.last_name
                },
                acct_no: payload.acct_no,
                payment_tender_type: payload.payment_tender_type,
                amount_given: payload.amount_given,
                service_fee: payload.service_fee,
                convenience_fee: payload.convenience_fee,
                ...payload.hasOwnProperty("full_track_data") && {
                    full_track_data: payload.full_track_data
                },
                visit_id: payload.visit_id
            };
            // Generate or retrieve trace number for card payments
            // Extract card last four for trace number comparison (legacy path card-swap detection)
            const cardLastFour = paymentParams.credit_card?.number?.slice(-4) ?? (0, _traceNumber.extractLastFourFromTrack)(paymentParams.full_track_data);
            // Extract comparable payment parameters for trace number logic
            const comparableParams = {
                payment_tender_type: paymentParams.payment_tender_type,
                amount_given: paymentParams.amount_given,
                acct_no: paymentParams.acct_no,
                visit_id: paymentParams.visit_id,
                service_fee: paymentParams.service_fee,
                convenience_fee: paymentParams.convenience_fee,
                card_last_four: cardLastFour
            };
            paymentParams.trace_number = (0, _traceNumber.getOrCreateTraceNumber)(comparableParams);
            break;
        case 0, _constants.CHECK:
            paymentParams = {
                payment_tender_type: payload.payment_tender_type,
                amount_given: payload.amount_given,
                submission_type: payload.submission_type,
                check: {
                    first_name: payload.first_name,
                    last_name: payload.last_name,
                    check_type: payload.check_type,
                    bank_account_type: payload.account_type,
                    ...payload.hasOwnProperty("company_name") && {
                        company_name: payload.company_name
                    },
                    ...payload.hasOwnProperty("isManualEntry") && {
                        check_number: payload.check_number,
                        bank_routing_number: payload.routing_number,
                        bank_account_number: payload.account_number
                    }
                }
            };
            break;
        case 0, _constants.PAYLINK:
            paymentParams = {
                amount_given: payload.amount_given,
                payment_tender_type: payload.payment_tender_type,
                invoice_types: payload.invoice_types,
                phone: payload.phone,
                email: payload.email
            };
            break;
        case 0, _constants.WIRE:
            paymentParams = {
                payment_tender_type: payload.payment_tender_type,
                amount_given: payload.amount_given,
                wire_payment: {
                    name: payload.name,
                    description: payload.description,
                    effective_date: payload.effective_date
                }
            };
            break;
    }
    return {
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        method: "POST",
        payment: paymentParams
    };
};
const getPaymentByIdParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: action.payload.data.id,
        method: "GET"
    });
const postVisitIdParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        order_id: action.payload,
        method: "POST"
    });
const pollByPaymentIdentifierParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        paymentAttemptUniqueId: state.checkout.paymentAttemptUniqueId,
        method: "GET"
    });
const postVisitIdEpic = (action$, state$)=>action$.ofType((0, _checkoutState.INITIATE_POST_VISIT)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.postVisitId)(postVisitIdParams(state$.value, action))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _checkoutState.postVisitIdSuccess)(response.data))), _operators.catchError(()=>_rxjs.of((0, _checkoutState.retryInitiatePostVisitId)({
                order_id: action.payload,
                retryNumber: 1
            }))))));
const retryPostVisitIdEpic = (action$, state$)=>action$.ofType((0, _checkoutState.RETRY_INITIATE_POST_VISIT)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.postVisitId)(postVisitIdParams(state$.value, {
            ...action,
            payload: action.payload.order_id
        }))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _checkoutState.postVisitIdSuccess)(response.data))), _operators.catchError((err)=>{
            const numberOfRetries = action?.payload?.retryNumber;
            if (numberOfRetries && numberOfRetries < 3) return _rxjs.of((0, _checkoutState.retryInitiatePostVisitId)({
                order_id: action.payload.order_id,
                retryNumber: numberOfRetries + 1
            }));
            else return _rxjs.of((0, _checkoutState.postVisitIdError)(err.message));
        }))));
const orderStatusResponseEpic = (action$, state$)=>action$.ofType((0, _cartState.GET_UPDATED_CART_SUCCESS)).pipe(_operators.flatMap((action)=>{
        const isOnCheckoutScreen = action.payload.location?.pathname === CHECKOUT_SCREEN_PATH;
        const isComplete = state$.value.cart.order.status === (0, _constants.ORDER_STATUS).COMPLETED;
        const isPayLinkSent = state$.value.cart.order.status === PAYLINK_SENT_STATUS;
        if (isOnCheckoutScreen && (isComplete || isPayLinkSent)) {
            action.payload.navigate(`/pos/order/${state$.value.cart.order.order_id}`); // redirect to completed order details page
            // Clear any stale trace state (trace_number, tombstones, pendingPAUI)
            // so the next order starts fresh. Without this, a pendingPAUI from a
            // timed-out DPS attempt could persist if the order was completed via
            // a non-card payment (cash, check), causing a spurious resume-poll
            // on the next order's first card payment.
            (0, _traceNumber.clearTraceStateFromStorage)();
            return _rxjs.of((0, _checkoutState.checkoutModalAction)((0, _modalState.closeModal)()), /*
          clear cart because the user fully paid for their order and it is now of status 'completed'.
          at the time the cart is cleared the user will be on the completed order details page from the redirect above,
          so they still have information about the order they just paid for.
          */ (0, _cartState.clearCart)(), state$.value.checkout?.isAwaitingCreditCard ? (0, _checkoutState.stopAwaitingCreditCard)() : (0, _state1.EMPTY_ACTION), state$.value.checkout?.isPollingForCCResponse ? (0, _checkoutState.stopPollingForCCResponse)() : (0, _state1.EMPTY_ACTION));
        } else return _rxjs.of((0, _checkoutState.checkoutModalAction)((0, _modalState.closeModal)()));
    }));
const sendPayLinkEpic = (action$, state$)=>action$.ofType((0, _checkoutState.INITIATE_PAYLINK)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.makePayment)(makePaymentParams(state$.value, action))).pipe(_operators.flatMap((response)=>{
            const { status } = response;
            return _rxjs.of(status === "success" ? (0, _checkoutState.paylinkSuccess)(response) : (0, _checkoutState.paylinkError)(new Error("PayLink Error")), (0, _cartState.getUpdatedCartRequest)({
                id: state$.value.cart.order.order_id,
                navigate: action.payload.navigate,
                location: action.payload.location
            }));
        }), _operators.catchError((err)=>caughtCheckoutError(state$.value)(err, (0, _checkoutState.paylinkError)(err.message), (0, _cartState.getUpdatedCartRequest)({
                id: state$.value.cart.order.order_id,
                navigate: action.payload.navigate,
                location: action.payload.location
            }))))));
// DPS: PAUI returned with success status — start polling.
const handleDpsPollStart = (identifier, action)=>_rxjs.of((0, _checkoutState.setPaymentUniqueIdentifier)({
        paymentAttemptUniqueId: identifier
    }), (0, _checkoutState.startPollingForCCResponse)({
        navigate: action.payload.navigate,
        location: action.payload.location
    }));
// DPS: PAUI returned with non-success — write tombstone and show error.
const handleDpsNonSuccess = (identifier, response, action, state$)=>{
    if (identifier.length > 0) (0, _traceNumber.markResponseReceived)({
        lastSeenPAUI: identifier
    });
    return _rxjs.of((0, _checkoutState.paymentError)(response.message), (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
        heading: "Payment Status:",
        text: response.message,
        variant: "error"
    })), (0, _cartState.getUpdatedCartRequest)({
        id: state$.value.cart.order.order_id,
        navigate: action.payload.navigate,
        location: action.payload.location
    }));
};
// Legacy / synchronous: completed payment result (no PAUI).
const handleSynchronousPaymentResponse = (response, action, state$, isDatacap)=>{
    if (!response.data) return _rxjs.of((0, _checkoutState.paymentError)("Unexpected payment response: no data returned"));
    const { status, payment_type, amount_given, amount_processed, change_due } = response.data;
    let variant = status === "successful" ? "success" : "error";
    let alertMessage = `${payment_type} ${status}`;
    // Clear all trace state on successful card payment.
    // This enables split tender scenarios (new trace number for next payment).
    if (status === "successful" && payment_type === (0, _constants.PAYMENT_TYPE).CARD_PAYMENT) (0, _traceNumber.clearTraceStateFromStorage)();
    if (payment_type !== (0, _constants.PAYMENT_TYPE).CASH_PAYMENT && amount_given !== amount_processed) {
        variant = "warn";
        alertMessage = `${alertMessage}, however only ${(0, _helpers.formatPrice)(amount_processed)} was authorized for the payment.`;
    }
    return _rxjs.of((0, _checkoutState.paymentSuccess)(response), payment_type !== (0, _constants.PAYMENT_TYPE).CASH_PAYMENT && amount_given !== amount_processed ? (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
        heading: `Payment Status:`,
        text: alertMessage,
        variant: variant
    })) : (0, _state1.EMPTY_ACTION), isDatacap ? (0, _shared.resetPinPadRequest)(state$.value.terminalLogin.terminalSession.terminal_id) : (0, _state1.EMPTY_ACTION), (0, _cartState.getUpdatedCartRequest)({
        id: state$.value.cart.order.order_id,
        navigate: action.payload.navigate,
        location: action.payload.location
    }), change_due ? (0, _orderDetailsState.changeDueModal)((0, _orderDetailsState.OPEN_CHANGE_DUE_MODAL)) : (0, _state1.EMPTY_ACTION), state$.value.checkout?.isAwaitingCreditCard ? (0, _checkoutState.stopAwaitingCreditCard)() : (0, _state1.EMPTY_ACTION));
};
// Routes a makePayment response to the appropriate handler.
const handleMakePaymentResponse = (response, action, state$, isDatacap)=>{
    const identifier = response?.data?.payment_attempt_unique_identifier;
    if (identifier) {
        if (identifier.length > 0 && identifier !== state$.value.checkout.paymentAttemptUniqueId && response.status === "success") return handleDpsPollStart(identifier, action);
        else return handleDpsNonSuccess(identifier, response, action, state$);
    } else return handleSynchronousPaymentResponse(response, action, state$, isDatacap);
};
const handleMakePaymentError = (err, action, state$, isDatacap)=>caughtCheckoutError(state$.value)(err, (0, _checkoutState.paymentError)(err.message), state$.value.checkout?.isAwaitingCreditCard ? (0, _checkoutState.stopAwaitingCreditCard)() : (0, _state1.EMPTY_ACTION), state$.value.checkout?.isPollingForCCResponse ? (0, _checkoutState.stopPollingForCCResponse)() : (0, _state1.EMPTY_ACTION), isDatacap ? (0, _shared.resetPinPadRequest)(state$.value.terminalLogin.terminalSession.terminal_id) : (0, _state1.EMPTY_ACTION), (0, _cartState.getUpdatedCartRequest)({
        id: state$.value.cart.order.order_id,
        navigate: action.payload.navigate,
        location: action.payload.location
    }));
const makePaymentEpic = (action$, state$)=>action$.ofType((0, _checkoutState.INITIATE_PAYMENT)).pipe(_operators.flatMap((action)=>{
        const isDatacap = (0, _helpers.isDatacapTransaction)(action.payload.payment_tender_type, action.payload?.cc_reader_type);
        // Resume polling: if a previous DPS attempt timed out (indeterminate),
        // check its status before starting a new payment to avoid duplicates.
        const pendingPAUI = (0, _traceNumber.getPendingPAUI)();
        if (pendingPAUI && isDatacap) {
            const proceedWithNewPayment = ()=>{
                // Tombstone the attempt (forces fresh trace), then clear the
                // indeterminate flag. Both touch disjoint localStorage fields
                // so order is safe, but the sequence reflects intent:
                // resolve first, then clean up.
                (0, _traceNumber.markResponseReceived)({
                    lastSeenPAUI: pendingPAUI
                });
                (0, _traceNumber.clearPendingPAUI)();
                return _rxjs.from((0, _client.makePayment)(makePaymentParams(state$.value, action))).pipe(_operators.flatMap((newResponse)=>handleMakePaymentResponse(newResponse, action, state$, isDatacap)), _operators.catchError((err)=>handleMakePaymentError(err, action, state$, isDatacap)));
            };
            return _rxjs.from((0, _client.pollByPaymentIdentifier)({
                url: (0, _state.getPosApiUrl)(state$.value),
                token: (0, _state.getAccessToken)(state$.value),
                paymentAttemptUniqueId: pendingPAUI,
                method: "GET"
            })).pipe(_operators.flatMap((response)=>{
                if (response.data?.status === "successful") {
                    // Previous attempt succeeded — show result and clear all
                    // trace state (including pendingPAUI) via full wipe.
                    (0, _traceNumber.clearTraceStateFromStorage)();
                    return _rxjs.of((0, _checkoutState.paymentSuccess)(response), (0, _checkoutState.getPaymentByIdSuccess)(response), (0, _shared.resetPinPadRequest)(state$.value.terminalLogin.terminalSession.terminal_id), (0, _cartState.getUpdatedCartRequest)({
                        id: state$.value.cart.order.order_id,
                        navigate: action.payload.navigate,
                        location: action.payload.location
                    }), (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
                        heading: "Payment Status:",
                        text: "A previous card payment completed successfully.",
                        variant: "success"
                    })));
                } else if (response.data?.status === "failed") // Previous attempt failed — write tombstone and proceed
                return proceedWithNewPayment();
                else {
                    // Still pending — warn cashier, do not start a new payment
                    console.warn(`Resume-poll: previous DPS attempt ${pendingPAUI} still pending. Next retry will skip resume-poll.`);
                    (0, _traceNumber.clearPendingPAUI)();
                    return _rxjs.of((0, _checkoutState.checkoutModalAction)((0, _modalState.closeModal)()), (0, _checkoutState.paymentError)("A previous card payment is still being processed. Please wait before retrying."), (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
                        heading: "Payment Status:",
                        text: "A previous card payment is still being processed. Please wait before retrying.",
                        variant: "warn"
                    })));
                }
            }), // Poll failed (404, network error) — old attempt is gone, proceed
            _operators.catchError(()=>proceedWithNewPayment()));
        }
        return _rxjs.from((0, _client.makePayment)(makePaymentParams(state$.value, action))).pipe(_operators.flatMap((response)=>handleMakePaymentResponse(response, action, state$, isDatacap)), _operators.catchError((err)=>handleMakePaymentError(err, action, state$, isDatacap)));
    }));
/*
  Due to limitations of the pos-bridge and KD that won't be resolved until DAL,
  we must poll the getPaymentById endpoint to get the response from the check reader.

  This process is initiated by the INITIATE_CHECK_SCAN action, which triggers the scanCheckEpic:
  - the scanCheckEpic does the POST request to make a payment of payment_tender_type: "check"
  - a 200 response means that the websocket was opened in the bridge to listen for the physical check insertion
  - upon response, the countdown timer that is displayed in the Checkout modal is initiated with the maxAttempts (currently 30 second timer)

  A successful scanCheckEpic dispatches the IS_POLLING_FOR_CHECK_RESPONSE action, which triggers the checkScanPollingEpic that does the following:
  - Starts making requests to /api/v2/payments/{id} at a configurable polling interval, decrementing the 30 second timer each request
  - It will keep going at that interval until one of 3 things happen:
    a) the configurable maxAttempts is reached -> modal will close and a timeout error is displayed by the FE in an alert bar
    b) the status of the payment changes to 'successful' -> modal will close and the payment will process successfully
    c) the status of the payment changes to 'errored' -> modal will close and a payment error is displayed by the FE in an alert bar
*/ const oneSecond = 1000;
const maxAttempts = (0, _checkoutState.checkScanMaxAttempts); // poll for max of 30 seconds
const ADDITIONAL_CHECK_PROCESSING_ATTEMPTS = 15;
const scanCheckEpic = (action$, state$)=>action$.ofType((0, _checkoutState.INITIATE_CHECK_SCAN)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.makePayment)(makePaymentParams(state$.value, action))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _checkoutState.isPollingForCheckResponse)({
                ...response,
                isPollingForCheckResponse: true,
                navigate: action.payload.navigate,
                location: action.payload.location
            }), (0, _checkoutState.setInsertCheckTimeRemaining)((0, _checkoutState.checkScanMaxAttempts)))), _operators.catchError((err)=>caughtCheckoutError(state$.value)(err, (0, _checkoutState.makeCheckPaymentError)(err.message), (0, _cartState.getUpdatedCartRequest)({
                id: state$.value.cart.order.order_id,
                navigate: action.payload.navigate,
                location: action.payload.location
            }))))));
const checkScanPollingEpic = (action$, state$)=>action$.ofType((0, _checkoutState.IS_POLLING_FOR_CHECK_RESPONSE)).pipe(_operators.switchMap((action)=>_rxjs.timer(oneSecond, oneSecond).pipe(// fire once a second after a one second delay
        _operators.takeUntil(action$.ofType((0, _checkoutState.STOP_CHECK_SCAN_POLL))), _operators.exhaustMap((attempts)=>{
            attempts++;
            if (attempts > maxAttempts && action.payload.data.status === (0, _constants.TRANSACTION_STATUS).PENDING && !state$.value.checkout.isPollingTimeExtended) return _rxjs.of((0, _checkoutState.isPollingTimeExtended)(true), (0, _checkoutState.setInsertCheckTimeRemaining)(ADDITIONAL_CHECK_PROCESSING_ATTEMPTS));
            if (state$.value.checkout.timeRemainingToInsertCheck === 0) return _rxjs.of((0, _checkoutState.setCheckScanFeedback)(null), (0, _checkoutState.stopCheckScanPoll)(), (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: `Payment Status:`,
                text: "Check Payment Error: Check read attempt timed out",
                variant: "error"
            })));
            return _rxjs.from((0, _client.getPaymentById)(getPaymentByIdParams(state$.value, action))).pipe(_operators.flatMap((response)=>{
                let variant = response.data.status === (0, _constants.TRANSACTION_STATUS).SUCCESSFUL ? "success" : "error";
                let alertMessage = `${response.data.payment_type} ${response.data.status}`;
                if (response.data.status === (0, _constants.TRANSACTION_STATUS).SUCCESSFUL) {
                    if (response.data.keep_polling === true) return _rxjs.of(!state$.value.checkout.isCheckProcessing ? (0, _checkoutState.isCheckProcessing)(true) : (0, _state1.EMPTY_ACTION));
                    else return _rxjs.of((0, _checkoutState.isCheckProcessing)(false), (0, _checkoutState.setCheckScanFeedback)(null), (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.clearAlerts)()), (0, _checkoutState.getPaymentByIdSuccess)(response), (0, _checkoutState.paymentSuccess)(response), (0, _checkoutState.stopCheckScanPoll)(), (0, _cartState.getUpdatedCartRequest)({
                        id: state$.value.cart.order.order_id,
                        navigate: action.payload.navigate,
                        location: action.payload.location
                    }));
                } else if (response.data.status === (0, _constants.TRANSACTION_STATUS).ERRORED) return _rxjs.of((0, _checkoutState.getPaymentByIdError)(response), (0, _checkoutState.setCheckScanFeedback)(null), (0, _checkoutState.stopCheckScanPoll)(), (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
                    heading: `Payment Status:`,
                    text: response.data.payment_response || alertMessage,
                    variant
                })));
                else // continue polling for a status update
                return _rxjs.of((0, _checkoutState.getPaymentByIdSuccess)(response), (0, _checkoutState.setCheckScanFeedback)(response.data.check_scan_feedback), (0, _checkoutState.setInsertCheckTimeRemaining)(maxAttempts - attempts));
            }), _operators.catchError((err)=>caughtCheckoutError(state$.value)(err, (0, _checkoutState.getPaymentByIdError)(err.message), (0, _cartState.getUpdatedCartRequest)({
                    id: state$.value.cart.order.order_id,
                    navigate: action.payload.navigate,
                    location: action.payload.location
                }))));
        }))));
const awaitCustomerCreditCardEpic = (action$, state$)=>action$.ofType((0, _checkoutState.IS_AWAITING_CREDIT_CARD)).pipe(_operators.switchMap(()=>_rxjs.timer(oneSecond, oneSecond).pipe(// fire once a second after a one second delay
        _operators.takeUntil(action$.ofType((0, _checkoutState.STOP_AWAITING_CREDIT_CARD))), _operators.exhaustMap((secondsElapsed)=>{
            secondsElapsed++;
            if (secondsElapsed <= (0, _checkoutState.maxSecondsToInsertCard)) return _rxjs.of((0, _checkoutState.setAwaitCreditCardTimeRemaining)((0, _checkoutState.maxSecondsToInsertCard) - secondsElapsed));
            else return _rxjs.of((0, _checkoutState.checkoutModalAction)((0, _modalState.closeModal)()), (0, _checkoutState.stopAwaitingCreditCard)(), (0, _checkoutState.cancelTransactionRequest)(cancelTransactionParams(state$.value)));
        }))));
const creditCardCountdownEpic = (action$, _state$)=>action$.ofType((0, _checkoutState.START_POLLING_FOR_CC_RESPONSE)).pipe(_operators.switchMap(()=>_rxjs.timer(0, oneSecond).pipe(_operators.takeUntil(action$.ofType((0, _checkoutState.STOP_POLLING_FOR_CC_RESPONSE))), _operators.exhaustMap((secondsElapsed)=>{
            secondsElapsed++;
            if (secondsElapsed <= (0, _checkoutState.maxSecondsToInsertCardDps)) return _rxjs.of((0, _checkoutState.setAwaitCreditCardTimeRemaining)((0, _checkoutState.maxSecondsToInsertCardDps) - secondsElapsed));
            else return _rxjs.of((0, _state1.EMPTY_ACTION));
        }))));
const cancelTransactionParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        method: "POST",
        // This is hardcoded to fix the credit card cancel button on the
        // processing modal. This functionality is needed for Datacap/Trancloud
        // Certification.  There are other stores to fix the check reader
        // cancel button on the processing modal that should make this dynamic.
        data: {
            payment_type: "credit_card",
            payment_attempt_unique_identifier: state?.checkout?.paymentAttemptUniqueId
        }
    });
const cancelTransactionEpic = (action$, state$)=>action$.ofType((0, _checkoutState.CANCEL_TRANSACTION_REQUEST)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.cancelTransaction)(cancelTransactionParams(state$.value))).pipe(_operators.flatMap((response)=>{
            const paymentAttemptUniqueId = state$.value.checkout?.paymentAttemptUniqueId;
            if (!paymentAttemptUniqueId) {
                const responseStatus = response.status;
                const variant = responseStatus === "successful" ? "info" : "error";
                return _rxjs.of((0, _checkoutState.cancelTransactionSuccess)(), state$.value.checkout?.isAwaitingCreditCard ? (0, _checkoutState.stopAwaitingCreditCard)() : (0, _state1.EMPTY_ACTION), (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
                    heading: `Cancel Transaction Status:`,
                    text: `${responseStatus}`,
                    variant: variant
                })));
            } else // for datacap payments, we'll use the polling response to confirm cancellation
            return _rxjs.of((0, _state1.EMPTY_ACTION));
        }), _operators.catchError((err)=>caughtCancelError(state$.value)(err, (0, _checkoutState.cancelTransactionFailure)())))));
const getServiceFeeParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        amount: payload.amount
    });
const getServiceFeeEpic = (action$, state$)=>action$.ofType((0, _checkoutState.GET_SERVICE_FEE)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchServiceFeeRequest)(getServiceFeeParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _checkoutState.getServiceFeeSuccess)(response.data))), _operators.catchError((err)=>caughtCheckoutError(state$.value)(err, (0, _checkoutState.getServiceFeeError)(err.message))))));
const getConvenienceFeeParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        agency_id: payload.agency_id
    });
const getConvenienceFeeEpic = (action$, state$)=>action$.ofType((0, _checkoutState.GET_CONVENIENCE_FEE)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchConvenienceFeeRequest)(getConvenienceFeeParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _checkoutState.getConvenienceFeeSuccess)(response.data))), _operators.catchError((err)=>caughtCheckoutError(state$.value)(err, (0, _checkoutState.getConvenienceFeeError)(err.message))))));
const MS_CC_POLLING_INTERVAL = 2000;
const creditCardReadPollingEpic = (action$, state$)=>action$.ofType((0, _checkoutState.START_POLLING_FOR_CC_RESPONSE)).pipe(_operators.switchMap((action)=>_rxjs.timer(0, MS_CC_POLLING_INTERVAL).pipe(_operators.takeUntil(action$.ofType((0, _checkoutState.STOP_POLLING_FOR_CC_RESPONSE))), _operators.scan((acc)=>acc + MS_CC_POLLING_INTERVAL, 0), _operators.exhaustMap((elapsedTime)=>{
            if (elapsedTime >= (0, _checkoutState.maxSecondsToInsertCardDps) * 1000) {
                // Mark the attempt as indeterminate so the next payment attempt
                // can resume polling for this PAUI before starting a new payment.
                const paui = state$.value.checkout.paymentAttemptUniqueId;
                if (paui) (0, _traceNumber.markAttemptIndeterminate)({
                    pendingPAUI: paui
                });
                else console.warn("creditCardReadPollingEpic: timeout but paymentAttemptUniqueId is null; cannot mark indeterminate");
                return _rxjs.of((0, _checkoutState.checkoutModalAction)((0, _modalState.closeModal)()), (0, _checkoutState.cancelTransactionRequest)(cancelTransactionParams(state$.value)), (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
                    heading: "Payment Status:",
                    text: "Card Payment Error: Card Payment attempt timed out",
                    variant: "error"
                })), (0, _checkoutState.stopPollingForCCResponse)());
            } else return _rxjs.from((0, _client.pollByPaymentIdentifier)(pollByPaymentIdentifierParams(state$.value))).pipe(_operators.flatMap((response)=>{
                if (response.data?.status === "successful") {
                    // Clear all trace state on DPS success (mirrors legacy-path cleanup)
                    (0, _traceNumber.clearTraceStateFromStorage)();
                    return _rxjs.of((0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.clearAlerts)()), (0, _checkoutState.pollingCCSuccess)(), (0, _checkoutState.paymentSuccess)(response), (0, _checkoutState.getPaymentByIdSuccess)(response), (0, _checkoutState.stopPollingForCCResponse)(), (0, _shared.resetPinPadRequest)(state$.value.terminalLogin.terminalSession.terminal_id), (0, _cartState.getUpdatedCartRequest)({
                        id: state$.value.cart.order.order_id,
                        navigate: action.payload?.navigate,
                        location: action.payload?.location
                    }));
                } else if (response.data?.status === "failed") {
                    // DPS tombstone: record that polling received a failure response
                    (0, _traceNumber.markResponseReceived)({
                        lastSeenPAUI: state$.value.checkout.paymentAttemptUniqueId
                    });
                    return _rxjs.of((0, _checkoutState.checkoutModalAction)((0, _modalState.closeModal)()), (0, _checkoutState.pollingCCError)(), (0, _checkoutState.paymentError)(response.data?.payment_response || "Error"), (0, _checkoutState.stopPollingForCCResponse)(), (0, _shared.resetPinPadRequest)(state$.value.terminalLogin.terminalSession.terminal_id), (0, _checkoutState.checkoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
                        heading: "Payment Status:",
                        text: `Card Payment: ${response.data?.payment_response ?? "Error"}`,
                        variant: "error"
                    })));
                } else return _rxjs.of((0, _state1.EMPTY_ACTION));
            }), _operators.catchError((err)=>caughtCheckoutError(state$.value)(err, (0, _checkoutState.stopPollingForCCResponse)(), (0, _checkoutState.pollingCCError)(), (0, _checkoutState.paymentError)(err.message), (0, _shared.resetPinPadRequest)(state$.value.terminalLogin.terminalSession.terminal_id), (0, _cartState.getUpdatedCartRequest)({
                    id: state$.value.cart.order.order_id,
                    navigate: action.payload.navigate,
                    location: action.payload.location
                }))));
        }))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/state":"8UPqD","../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/api/client":"27HsT","../order-details/OrderDetails.state":"3yj5u","./Checkout.state":"4E8nR","../../utils/api/errorHandler":"jWFhB","../../components/modal/Modal.state":"34xap","../../utils/helpers":"epomp","../cart/Cart.state":"bgoZn","../../utils/constants":"f3A1R","../../state":"dFzXj","../../state/shared":"h0jLC","../../utils/traceNumber":"5Gb8q","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5Gb8q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateTraceNumber", ()=>generateTraceNumber);
parcelHelpers.export(exports, "getTraceStateFromStorage", ()=>getTraceStateFromStorage);
parcelHelpers.export(exports, "saveTraceStateToStorage", ()=>saveTraceStateToStorage);
parcelHelpers.export(exports, "clearTraceStateFromStorage", ()=>clearTraceStateFromStorage);
parcelHelpers.export(exports, "extractLastFourFromTrack", ()=>extractLastFourFromTrack);
parcelHelpers.export(exports, "markResponseReceived", ()=>markResponseReceived);
parcelHelpers.export(exports, "markAttemptIndeterminate", ()=>markAttemptIndeterminate);
parcelHelpers.export(exports, "getPendingPAUI", ()=>getPendingPAUI);
parcelHelpers.export(exports, "clearPendingPAUI", ()=>clearPendingPAUI);
parcelHelpers.export(exports, "shouldReuseTraceNumber", ()=>shouldReuseTraceNumber);
parcelHelpers.export(exports, "getOrCreateTraceNumber", ()=>getOrCreateTraceNumber);
var _uuid = require("uuid");
const STORAGE_KEY = "pos_payment_trace_number";
const generateTraceNumber = ()=>{
    return (0, _uuid.v4)();
};
const getTraceStateFromStorage = ()=>{
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) return null;
        return JSON.parse(stored);
    } catch (error) {
        console.error("Error reading trace state from localStorage:", error.message);
        return null;
    }
};
const saveTraceStateToStorage = (traceNumber, paymentParams)=>{
    try {
        const data = {
            trace_number: traceNumber,
            lastPaymentParams: paymentParams
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
        console.error("Error saving trace state to localStorage:", error.message);
    }
};
const clearTraceStateFromStorage = ()=>{
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        console.error("Error clearing trace state from localStorage:", error.message);
    }
};
const extractLastFourFromTrack = (trackData)=>{
    const match = trackData?.match(/%B(\d{1,19})\^/);
    return match?.[1]?.slice(-4);
};
/**
 * Merges a single field into the stored trace state's lastPaymentParams
 * without changing the stored trace itself. No-ops if nothing is stored.
 *
 * @param {string} fieldName - The param field to set (e.g. 'lastSeenPAUI', 'pendingPAUI')
 * @param {*} value - The value to store
 */ const updateTraceStateField = (fieldName, value)=>{
    try {
        const stored = getTraceStateFromStorage();
        if (!stored) return;
        saveTraceStateToStorage(stored.trace_number, {
            ...stored.lastPaymentParams,
            [fieldName]: value
        });
    } catch (error) {
        console.error(`Error updating trace state field '${fieldName}':`, error.message);
    }
};
const markResponseReceived = ({ lastSeenPAUI })=>updateTraceStateField("lastSeenPAUI", lastSeenPAUI);
const markAttemptIndeterminate = ({ pendingPAUI })=>updateTraceStateField("pendingPAUI", pendingPAUI);
const getPendingPAUI = ()=>{
    try {
        const stored = getTraceStateFromStorage();
        return stored?.lastPaymentParams?.pendingPAUI ?? null;
    } catch (error) {
        console.error("Error reading pending PAUI:", error.message);
        return null;
    }
};
const clearPendingPAUI = ()=>{
    try {
        const stored = getTraceStateFromStorage();
        if (!stored || !stored.lastPaymentParams?.pendingPAUI) return;
        const params = {
            ...stored.lastPaymentParams
        };
        delete params.pendingPAUI;
        saveTraceStateToStorage(stored.trace_number, params);
    } catch (error) {
        console.error("Error clearing pending PAUI:", error.message);
    }
};
const shouldReuseTraceNumber = (currentParams, storedParams)=>{
    if (!currentParams || !storedParams) return false;
    // DPS tombstone: a prior DPS attempt produced a PAUI in its response, so
    // the FE has observed the outcome. This attempt is therefore new — not a
    // timeout retry. Tombstone is only written on the DPS path; on
    // the legacy path card-swap detection is handled by card_last_four below.
    if (storedParams.lastSeenPAUI) return false;
    // Compare key payment parameters
    const fieldsToCompare = [
        "payment_tender_type",
        "amount_given",
        "acct_no",
        "visit_id",
        "service_fee",
        "convenience_fee",
        "card_last_four"
    ];
    return fieldsToCompare.every((field)=>{
        // Handle optional fields (like acct_no which may not be present)
        if (currentParams[field] === undefined && storedParams[field] === undefined) return true;
        return currentParams[field] === storedParams[field];
    });
};
const getOrCreateTraceNumber = (paymentParams)=>{
    const stored = getTraceStateFromStorage();
    // If we have stored data and parameters match (retry scenario), reuse trace number
    if (stored && shouldReuseTraceNumber(paymentParams, stored.lastPaymentParams)) return stored.trace_number;
    // Otherwise, generate a new trace number
    const newTraceNumber = generateTraceNumber();
    saveTraceStateToStorage(newTraceNumber, paymentParams);
    return newTraceNumber;
};

},{"uuid":"4vdp3","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lyYeG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchLookupByIdEpic", ()=>fetchLookupByIdEpic);
parcelHelpers.export(exports, "fetchSearchByIdEpic", ()=>fetchSearchByIdEpic);
parcelHelpers.export(exports, "fetchProductsEpic", ()=>fetchProductsEpic);
parcelHelpers.export(exports, "fetchAgenciesEpic", ()=>fetchAgenciesEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _state = require("../../utils/state");
var _searchState = require("../search/Search.state");
var _lookupState = require("../lookup/Lookup.state");
var _productsState = require("./Products.state");
var _client = require("../../utils/api/client");
var _errorHandler = require("../../utils/api/errorHandler");
const caughtFetchLookupErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _lookupState.lookupAlertBarAction), "Search Error:", state);
const caughtFetchSearchErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _searchState.searchAlertBarAction), "Search Error:", state);
const fetchLookupByIdParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: action.payload
    });
const fetchSearchByIdParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: action.payload
    });
const fetchLookupByIdEpic = (action$, state$)=>action$.ofType((0, _productsState.FETCH_LOOKUP_BY_ID)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchLookupByIdRequest)(fetchLookupByIdParams(state$.value, action))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _productsState.fetchLookupByIdSuccess)(response))), _operators.catchError((err)=>caughtFetchLookupErrorCallback(state$.value)(err, (0, _productsState.fetchLookupByIdFailure)(err.message))))));
const fetchSearchByIdEpic = (action$, state$)=>action$.ofType((0, _productsState.FETCH_SEARCH_BY_ID)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchSearchByIdRequest)(fetchSearchByIdParams(state$.value, action))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _productsState.fetchSearchByIdSuccess)(response))), _operators.catchError((err)=>caughtFetchSearchErrorCallback(state$.value)(err, (0, _productsState.fetchSearchByIdFailure)(err.message))))));
const caughtProductsPageErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _productsState.productsAlertBarAction), "Products Page Error:", state);
const fetchProductsParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const fetchProductsEpic = (action$, state$)=>action$.ofType((0, _productsState.FETCH_PRODUCTS)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchProductsRequest)(fetchProductsParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _productsState.fetchProductsSuccess)(response))), _operators.catchError((err)=>caughtProductsPageErrorCallback(state$.value)(err, (0, _productsState.fetchProductsFailure)(err.message))))));
const fetchAgenciesParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const fetchAgenciesEpic = (action$, state$)=>action$.ofType((0, _productsState.FETCH_AGENCIES)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchAgenciesRequest)(fetchAgenciesParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _productsState.fetchAgenciesSuccess)(response))), _operators.catchError((err)=>caughtProductsPageErrorCallback(state$.value)(err, (0, _productsState.fetchAgenciesFailure)(err.message))))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/state":"8UPqD","../search/Search.state":"lcTto","../lookup/Lookup.state":"bEN0h","./Products.state":"9SdM7","../../utils/api/client":"27HsT","../../utils/api/errorHandler":"jWFhB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eIg9g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "caughtOrderDetailsErrorCallback", ()=>caughtOrderDetailsErrorCallback);
parcelHelpers.export(exports, "getOrderDetailsParams", ()=>getOrderDetailsParams);
parcelHelpers.export(exports, "voidByIdEpic", ()=>voidByIdEpic);
parcelHelpers.export(exports, "returnByIdEpic", ()=>returnByIdEpic);
parcelHelpers.export(exports, "reopenByIdEpic", ()=>reopenByIdEpic);
parcelHelpers.export(exports, "getOrderDetailsEpic", ()=>getOrderDetailsEpic);
parcelHelpers.export(exports, "sendReceiptEpic", ()=>sendReceiptEpic);
parcelHelpers.export(exports, "printReceiptEpic", ()=>printReceiptEpic);
parcelHelpers.export(exports, "cancelPaylinkByIdEpic", ()=>cancelPaylinkByIdEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _client = require("../../utils/api/client");
var _state = require("../../utils/state");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _constants = require("../../utils/constants");
var _dpsVoidPolling = require("../../utils/dpsVoidPolling");
var _orderDetailsState = require("./OrderDetails.state");
var _errorHandler = require("../../utils/api/errorHandler");
var _cartState = require("../cart/Cart.state");
const caughtOrderDetailsErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _orderDetailsState.orderDetailsAlertBarAction), "Order Details Error:", state);
const voidOrderByIdParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: action.payload.id,
        notes: action.payload.notes,
        method: "PUT"
    });
const returnOrderByIdParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: action.payload.id,
        notes: action.payload.notes,
        method: "PUT"
    });
const reopenOrderByIdParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: action.payload.id,
        method: "PUT"
    });
const getOrderDetailsParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: payload.id
    });
const cancelPaylinkByIdParams = (state, action)=>{
    const baseUrl = (0, _state.getPosApiUrl)(state);
    const webhookUrl = baseUrl.replace("/api/v2", "/webhooks/v1");
    return {
        url: webhookUrl,
        token: (0, _state.getAccessToken)(state),
        id: action.payload.id,
        method: "PATCH"
    };
};
const ORDER_VOID_INITIATION_OUTCOME = {
    PROCESSING: (0, _constants.ORDER_STATUS).VOID_PENDING,
    VOIDED: (0, _constants.ORDER_STATUS).VOIDED,
    UNEXPECTED: "unexpected"
};
const classifyOrderVoidInitiationOutcome = (response)=>{
    const orderStatus = response.data?.status;
    if (orderStatus === (0, _constants.ORDER_STATUS).VOID_PENDING) return ORDER_VOID_INITIATION_OUTCOME.PROCESSING;
    if (orderStatus === (0, _constants.ORDER_STATUS).VOIDED && !response.data?.payment_cancellation_status) return ORDER_VOID_INITIATION_OUTCOME.VOIDED;
    return ORDER_VOID_INITIATION_OUTCOME.UNEXPECTED;
};
const ORDER_VOID_POLL_OUTCOME = {
    ASSISTANCE_REQUIRED: (0, _constants.PAYMENT_CANCELLATION_STATUS).ASSISTANCE_REQUIRED,
    VOIDED: (0, _constants.ORDER_STATUS).VOIDED,
    UNEXPECTED_TERMINAL: "unexpected_terminal"
};
const classifyOrderVoidPollOutcome = (pollResponse)=>{
    const order = pollResponse.data?.order;
    const cancellationStatus = order?.payment_cancellation_status;
    if (order?.status === (0, _constants.ORDER_STATUS).VOID_PENDING && cancellationStatus === (0, _constants.PAYMENT_CANCELLATION_STATUS).ASSISTANCE_REQUIRED) return ORDER_VOID_POLL_OUTCOME.ASSISTANCE_REQUIRED;
    if (order?.status && order.status !== (0, _constants.ORDER_STATUS).VOID_PENDING && cancellationStatus) return ORDER_VOID_POLL_OUTCOME.UNEXPECTED_TERMINAL;
    if (order?.status === (0, _constants.ORDER_STATUS).VOIDED) return ORDER_VOID_POLL_OUTCOME.VOIDED;
    if (order?.status && order.status !== (0, _constants.ORDER_STATUS).VOID_PENDING) return ORDER_VOID_POLL_OUTCOME.UNEXPECTED_TERMINAL;
    return null;
};
const voidByIdEpic = (action$, state$)=>action$.ofType((0, _orderDetailsState.INITIATE_VOID)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.voidOrderById)(voidOrderByIdParams(state$.value, action))).pipe(_operators.flatMap((response)=>{
            const initiationOutcome = classifyOrderVoidInitiationOutcome(response);
            if (initiationOutcome === ORDER_VOID_INITIATION_OUTCOME.PROCESSING) return _rxjs.concat(_rxjs.of((0, _orderDetailsState.voidSuccess)(response), (0, _orderDetailsState.voidModal)((0, _orderDetailsState.CLOSE_VOID_MODAL)), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Void Processing",
                text: "Card payment void is processing...",
                variant: "info"
            }))), (0, _dpsVoidPolling.createDpsVoidPolling)({
                pollFn: ()=>_rxjs.from((0, _client.fetchOrderDetails)(getOrderDetailsParams(state$.value, {
                        id: response.data.order.id
                    }))),
                isDone: (pollResponse)=>Boolean(classifyOrderVoidPollOutcome(pollResponse)),
                onSuccess: (pollResponse)=>{
                    switch(classifyOrderVoidPollOutcome(pollResponse)){
                        case ORDER_VOID_POLL_OUTCOME.ASSISTANCE_REQUIRED:
                            return _rxjs.of((0, _orderDetailsState.getOrderDetailsSuccess)(pollResponse.data), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                                heading: "Void Assistance Required",
                                text: "This void could not be completed automatically. You may begin a new order. This order requires assistance.",
                                variant: "error"
                            })), (0, _orderDetailsState.stopVoidOrderPolling)());
                        case ORDER_VOID_POLL_OUTCOME.VOIDED:
                            return _rxjs.of((0, _orderDetailsState.getOrderDetailsSuccess)(pollResponse.data), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                                heading: "Order Voided",
                                text: "All payments have been successfully voided and the order is now voided.",
                                variant: "success"
                            })), (0, _orderDetailsState.stopVoidOrderPolling)());
                        default:
                            return _rxjs.of((0, _orderDetailsState.getOrderDetailsSuccess)(pollResponse.data), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                                heading: "Void Error",
                                text: "Void failed. Please check the order status.",
                                variant: "error"
                            })), (0, _orderDetailsState.stopVoidOrderPolling)());
                    }
                },
                onTimeout: ()=>_rxjs.concat(_rxjs.from((0, _client.fetchOrderDetails)(getOrderDetailsParams(state$.value, {
                        id: response.data.order.id
                    }))).pipe(_operators.flatMap((pollResponse)=>_rxjs.of((0, _orderDetailsState.getOrderDetailsSuccess)(pollResponse.data))), _operators.catchError(()=>_rxjs.EMPTY)), _rxjs.of((0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                        heading: "Void Status",
                        text: "Void is still processing. Please refresh the page to check the latest status.",
                        variant: "warn"
                    })), (0, _orderDetailsState.stopVoidOrderPolling)())),
                onError: (err)=>{
                    console.error("[voidByIdEpic] Poll fetchOrderDetails failed:", err?.message ?? "unknown error");
                    return _rxjs.of((0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                        heading: "Void Status Unknown",
                        text: "Could not verify void status. Please refresh the page.",
                        variant: "error"
                    })), (0, _orderDetailsState.stopVoidOrderPolling)());
                },
                stopSignal$: action$.ofType((0, _orderDetailsState.STOP_VOID_ORDER_POLLING))
            }));
            if (initiationOutcome === ORDER_VOID_INITIATION_OUTCOME.VOIDED) return _rxjs.of((0, _orderDetailsState.voidSuccess)(response), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Order Voided",
                text: "All payments have been successfully voided and the order is now voided.",
                variant: "success"
            })), (0, _orderDetailsState.voidModal)((0, _orderDetailsState.CLOSE_VOID_MODAL)));
            return _rxjs.of((0, _orderDetailsState.voidError)("Unexpected void response status"), (0, _orderDetailsState.voidModal)((0, _orderDetailsState.CLOSE_VOID_MODAL)), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Void Error",
                text: "Void failed. Please check the order status.",
                variant: "error"
            })));
        }), _operators.catchError((err)=>caughtOrderDetailsErrorCallback(state$.value)(err, (0, _orderDetailsState.voidError)(err.message), (0, _orderDetailsState.voidModal)((0, _orderDetailsState.CLOSE_VOID_MODAL)))))));
const returnByIdEpic = (action$, state$)=>action$.ofType((0, _orderDetailsState.INITIATE_RETURN)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.returnOrderById)(returnOrderByIdParams(state$.value, action))).pipe(_operators.flatMap((response)=>{
            action.payload.navigate(`/pos/order/${response.data.order_id}`);
            return _rxjs.of((0, _orderDetailsState.returnSuccess)(response), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Order Refunded",
                text: `Order ${action.payload.id} has been successfully refunded`,
                variant: "success"
            })), (0, _orderDetailsState.returnModal)((0, _orderDetailsState.CLOSE_RETURN_MODAL)));
        }), _operators.catchError((err)=>caughtOrderDetailsErrorCallback(state$.value)(err, (0, _orderDetailsState.returnError)(err.message), (0, _orderDetailsState.returnModal)((0, _orderDetailsState.CLOSE_RETURN_MODAL)))))));
const reopenByIdEpic = (action$, state$)=>action$.ofType((0, _orderDetailsState.INITIATE_REOPEN)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.reopenOrderById)(reopenOrderByIdParams(state$.value, action))).pipe(_operators.flatMap((response)=>{
            action.payload.navigate(`/pos/cart`);
            return _rxjs.of((0, _orderDetailsState.reopenSuccess)(response), (0, _cartState.cartAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Order re-opened",
                text: `Order ${response.data.order_id} has been successfully re-opened`,
                variant: "success"
            })));
        }), _operators.catchError((err)=>caughtOrderDetailsErrorCallback(state$.value)(err, (0, _orderDetailsState.reopenError)(err.message))))));
const getOrderDetailsEpic = (action$, state$)=>action$.ofType((0, _orderDetailsState.GET_ORDER_DETAILS_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchOrderDetails)(getOrderDetailsParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _orderDetailsState.getOrderDetailsSuccess)(response.data))), _operators.catchError((err)=>caughtOrderDetailsErrorCallback(state$.value)(err)))));
const caughtOrderReceiptErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _orderDetailsState.orderDetailsAlertBarAction), "Order Receipt Error:", state);
const getReceiptFormInputs = (state)=>{
    const receiptTypes = [];
    if (state.orderDetails.forms.receiptForm.emailReceipt.rawValue) receiptTypes.push("email");
    if (state.orderDetails.forms.receiptForm.textReceipt.rawValue) receiptTypes.push("sms");
    return {
        receipt_types: receiptTypes,
        id: state.orderDetails.data.order.id,
        email: state.orderDetails.forms.receiptForm.emailAddress.rawValue,
        phone: state.orderDetails.forms.receiptForm.phoneNumber.rawValue
    };
};
const sendReceiptParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        duplicate: true,
        type: "send",
        ...getReceiptFormInputs(state)
    });
const sendReceiptEpic = (action$, state$)=>action$.ofType((0, _orderDetailsState.SUBMIT_SEND_RECEIPT)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.postOrderReceipt)(sendReceiptParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _orderDetailsState.sendReceiptSuccess)(response.data), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Receipt Sent",
                text: "Receipt has been successfully sent.",
                variant: "success"
            })))), _operators.catchError((err)=>caughtOrderReceiptErrorCallback(state$.value)(err, (0, _orderDetailsState.sendReceiptError)())))));
const printReceiptParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        receipt_types: [
            "print"
        ],
        type: "print",
        duplicate: true,
        id: state.orderDetails.data.order.id
    });
const printReceiptEpic = (action$, state$)=>action$.ofType((0, _orderDetailsState.SUBMIT_PRINT_RECEIPT)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.postOrderReceipt)(printReceiptParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _orderDetailsState.printReceiptSuccess)(response.data), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Receipt Printed",
                text: `Receipt for order: ${response.data.order.id} has been successfully printed.`,
                variant: "success"
            })))), _operators.catchError((err)=>caughtOrderReceiptErrorCallback(state$.value)(err, (0, _orderDetailsState.printReceiptError)())))));
const cancelPaylinkByIdEpic = (action$, state$)=>action$.ofType((0, _orderDetailsState.INITIATE_CANCEL_PAYLINK)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.cancelPaylinkById)(cancelPaylinkByIdParams(state$.value, action))).pipe(_operators.flatMap((response)=>{
            return _rxjs.of((0, _orderDetailsState.cancelPaylinkSuccess)(response), (0, _orderDetailsState.orderDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Paylink Cancelled",
                text: `Paylink Invoice for ${action.payload.order_id} has been successfully cancelled`,
                variant: "success"
            })));
        }), _operators.catchError((err)=>caughtOrderDetailsErrorCallback(state$.value)(err, (0, _orderDetailsState.cancelPaylinkError)(err.message))))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/api/client":"27HsT","../../utils/state":"8UPqD","../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/constants":"f3A1R","../../utils/dpsVoidPolling":"6RGim","./OrderDetails.state":"3yj5u","../../utils/api/errorHandler":"jWFhB","../cart/Cart.state":"bgoZn","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6RGim":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DPS_VOID_POLLING_INTERVAL_MS", ()=>DPS_VOID_POLLING_INTERVAL_MS);
parcelHelpers.export(exports, "DPS_VOID_POLLING_TIMEOUT_MS", ()=>DPS_VOID_POLLING_TIMEOUT_MS);
parcelHelpers.export(exports, "createDpsVoidPolling", ()=>createDpsVoidPolling);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
const DPS_VOID_POLLING_INTERVAL_MS = 2000;
const DPS_VOID_POLLING_TIMEOUT_MS = 60000;
const createDpsVoidPolling = ({ pollFn, isDone, onSuccess, onTimeout, onError, stopSignal$ })=>_rxjs.timer(0, DPS_VOID_POLLING_INTERVAL_MS).pipe(_operators.scan((_acc, _val, index)=>index * DPS_VOID_POLLING_INTERVAL_MS, 0), _operators.takeWhile((elapsed)=>elapsed < DPS_VOID_POLLING_TIMEOUT_MS, true), _operators.exhaustMap((elapsedTime)=>{
        if (elapsedTime >= DPS_VOID_POLLING_TIMEOUT_MS) return onTimeout();
        return pollFn().pipe(_operators.flatMap((pollResponse)=>{
            if (isDone(pollResponse)) return onSuccess(pollResponse);
            return _rxjs.EMPTY;
        }), _operators.catchError((err)=>onError(err)));
    }), _operators.takeUntil(stopSignal$));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"buY4p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addToCartEpic", ()=>addToCartEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _client = require("../../utils/api/client");
var _state = require("../../utils/state");
var _lookupState = require("./Lookup.state");
var _errorHandler = require("../../utils/api/errorHandler");
const caughtLookupErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _lookupState.lookupAlertBarAction), "", state, false, true);
const addToCartParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        receivables: payload.receivables
    });
const addToCartEpic = (action$, state$)=>action$.ofType((0, _lookupState.ADD_TO_CART_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.addToCart)(addToCartParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>{
            action.payload.navigate("/pos/cart");
            return _rxjs.of((0, _lookupState.addToCartSuccess)(response.data));
        }), _operators.catchError((err)=>caughtLookupErrorCallback(state$.value)(err, (0, _lookupState.addToCartError)(err.message))))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/api/client":"27HsT","../../utils/state":"8UPqD","./Lookup.state":"bEN0h","../../utils/api/errorHandler":"jWFhB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gIEOn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCurrentOrderEpic", ()=>getCurrentOrderEpic);
parcelHelpers.export(exports, "getUpdatedCartEpic", ()=>getUpdatedCartEpic);
parcelHelpers.export(exports, "holdOrderEpic", ()=>holdOrderEpic);
parcelHelpers.export(exports, "cancelOrderByIdEpic", ()=>cancelOrderByIdEpic);
parcelHelpers.export(exports, "removeItemEpic", ()=>removeItemEpic);
parcelHelpers.export(exports, "voidTransactionByIdEpic", ()=>voidTransactionByIdEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _state = require("../../utils/state");
var _client = require("../../utils/api/client");
var _cartState = require("./Cart.state");
var _shared = require("../../state/shared");
var _errorHandler = require("../../utils/api/errorHandler");
var _modalState = require("../../components/modal/Modal.state");
var _orderDetailsEpic = require("../order-details/OrderDetails.epic");
var _constants = require("../../utils/constants");
var _dpsVoidPolling = require("../../utils/dpsVoidPolling");
var _state1 = require("../../state");
var _orderCancellation = require("./orderCancellation");
const caughtCartErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _cartState.cartAlertBarAction), "Cart Page Error:", state);
const getOrderParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const getCurrentOrderEpic = (action$, state$)=>action$.ofType((0, _cartState.GET_ORDER_REQUEST)).pipe(_operators.exhaustMap(()=>_rxjs.from((0, _client.getOrder)(getOrderParams(state$.value))).pipe(_operators.flatMap((orderResponse)=>_rxjs.of((0, _cartState.getOrderSuccess)(orderResponse.data))), _operators.catchError((err)=>caughtCartErrorCallback(state$.value)(err, (0, _cartState.getOrderError)(err.message))))));
const getUpdatedCartEpic = (action$, state$)=>action$.ofType((0, _cartState.GET_UPDATED_CART_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchOrderDetails)((0, _orderDetailsEpic.getOrderDetailsParams)(state$.value, action.payload))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _cartState.getUpdatedCartSuccess)({
                id: response.data,
                navigate: action.payload.navigate,
                location: action.payload.location,
                data: response.data
            }))), _operators.catchError((err)=>caughtCartErrorCallback(state$.value)(err)))));
const holdOrderParams = getOrderParams;
const holdOrderEpic = (action$, state$)=>action$.ofType((0, _cartState.HOLD_ORDER_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.holdOrder)(holdOrderParams(state$.value))).pipe(_operators.flatMap((orderResponse)=>{
            action.payload.navigate("/pos/products");
            return _rxjs.of((0, _cartState.holdOrderSuccess)(orderResponse.data));
        }), _operators.catchError((err)=>caughtCartErrorCallback(state$.value)(err)))));
const cancelOrderByIdParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        note: `${state.cart.forms.cancelOrderForm.reason} ${state.cart.forms.cancelOrderForm.note}`,
        id: action.payload.id
    });
const cancellationAssistanceAlert = (orderId)=>(0, _shared.replaceSharedAlerts)({
        heading: "Order Cancellation Assistance Required",
        text: `Order ${orderId} could not be cancelled automatically and requires assistance. You may begin a new order and view this order in the order history page.`,
        variant: "error"
    });
const cancelOrderByIdEpic = (action$, state$)=>action$.ofType((0, _cartState.SUBMIT_CANCEL_ORDER_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.cancelOrderById)(cancelOrderByIdParams(state$.value, action))).pipe(_operators.flatMap((cancelOrderResponse)=>{
            action.payload.navigate("/pos/products");
            const actions = [
                (0, _cartState.cancelOrderSuccess)(cancelOrderResponse),
                (0, _cartState.cartModalAction)((0, _modalState.closeModal)())
            ];
            if ((0, _orderCancellation.cartCancellationRequiresAssistance)(cancelOrderResponse)) actions.push(cancellationAssistanceAlert(action.payload.id));
            return _rxjs.from(actions);
        }), _operators.catchError((err)=>_rxjs.of((0, _cartState.cancelOrderError)(err.message), (0, _shared.replaceSharedAlerts)((0, _shared.genericErrorMessage)(err, "Order Cancellation Error")))))));
const removeItemParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        item_id: payload
    });
const removeItemEpic = (action$, state$)=>action$.ofType((0, _cartState.REMOVE_ORDER_ITEM_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.removeOrderItem)(removeItemParams(state$.value, action.payload))).pipe(_operators.flatMap((orderResponse)=>_rxjs.of((0, _cartState.removeOrderItemSuccess)(orderResponse.data))), _operators.catchError((err)=>caughtCartErrorCallback(state$.value)(err, (0, _cartState.removeOrderItemError)())))));
const voidTransactionByIdParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: action.payload.id,
        method: "PUT",
        payment_attempt_unique_identifier: action.payload?.payment_attempt_unique_identifier
    });
const VOID_POLL_OUTCOME = {
    CANCELLED: "cancelled",
    RESTORED: "restored"
};
const classifyVoidPollOutcome = (pollResponse)=>{
    switch(pollResponse.data?.status){
        case (0, _constants.TRANSACTION_STATUS).CANCELLED:
            return VOID_POLL_OUTCOME.CANCELLED;
        case (0, _constants.TRANSACTION_STATUS).SUCCESSFUL:
            return VOID_POLL_OUTCOME.RESTORED;
        default:
            return null;
    }
};
const voidTransactionByIdEpic = (action$, state$)=>action$.ofType((0, _cartState.INITIATE_VOID_TRANSACTION)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.voidTransactionById)(voidTransactionByIdParams(state$.value, action))).pipe(_operators.flatMap((response)=>{
            // For DPS (Datacap) card voids, the backend sets the payment to
            // cancel_pending. Poll until it is cancelled or restored.
            if (action.payload.isDatacapTransaction && action.payload.payment_attempt_unique_identifier) {
                const terminalId = state$.value.terminalLogin.terminalSession.terminal_id;
                return (0, _dpsVoidPolling.createDpsVoidPolling)({
                    pollFn: ()=>_rxjs.from((0, _client.pollByPaymentIdentifier)({
                            url: (0, _state.getPosApiUrl)(state$.value),
                            token: (0, _state.getAccessToken)(state$.value),
                            paymentAttemptUniqueId: action.payload.payment_attempt_unique_identifier
                        })),
                    isDone: (pollResponse)=>Boolean(classifyVoidPollOutcome(pollResponse)),
                    onSuccess: (pollResponse)=>{
                        switch(classifyVoidPollOutcome(pollResponse)){
                            case VOID_POLL_OUTCOME.RESTORED:
                                return _rxjs.of((0, _cartState.voidTransactionError)("Void unsuccessful"), (0, _shared.resetPinPadRequest)(terminalId), (0, _shared.replaceSharedAlerts)({
                                    heading: "Void Unsuccessful",
                                    text: "The payment was restored and remains in the cart.",
                                    variant: "error"
                                }), (0, _cartState.getOrderRequest)(), (0, _cartState.stopVoidTransactionPolling)());
                            case VOID_POLL_OUTCOME.CANCELLED:
                                return _rxjs.of((0, _cartState.voidTransactionSuccess)({
                                    ...response,
                                    id: action.payload.id
                                }), (0, _shared.resetPinPadRequest)(terminalId), (0, _shared.replaceSharedAlerts)({
                                    heading: "Transaction Voided",
                                    text: "The card payment has been successfully voided.",
                                    variant: "success"
                                }), (0, _cartState.stopVoidTransactionPolling)());
                            default:
                                return _rxjs.EMPTY;
                        }
                    },
                    onTimeout: ()=>_rxjs.of((0, _cartState.voidTransactionError)("Void timed out"), (0, _shared.resetPinPadRequest)(terminalId), (0, _shared.replaceSharedAlerts)({
                            heading: "Void Status",
                            text: "Void is still processing. Please refresh the page to check the latest status.",
                            variant: "warn"
                        }), (0, _cartState.getOrderRequest)(), (0, _cartState.stopVoidTransactionPolling)()),
                    onError: (pollErr)=>{
                        console.error("[voidTransactionByIdEpic] Poll failed:", pollErr?.message ?? "unknown error");
                        return _rxjs.of((0, _cartState.voidTransactionError)(pollErr?.message ?? "unknown error"), (0, _shared.resetPinPadRequest)(terminalId), (0, _shared.replaceSharedAlerts)({
                            heading: "Void Error",
                            text: "Void failed. Please check the transaction status.",
                            variant: "error"
                        }), (0, _cartState.getOrderRequest)(), (0, _cartState.stopVoidTransactionPolling)());
                    },
                    stopSignal$: action$.ofType((0, _cartState.STOP_VOID_TRANSACTION_POLLING))
                });
            }
            // Non-DPS voids complete synchronously
            return _rxjs.of((0, _cartState.voidTransactionSuccess)({
                ...response,
                id: action.payload.id
            }), (0, _shared.replaceSharedAlerts)({
                heading: "Transaction Voided",
                text: "The payment has been successfully voided.",
                variant: "success"
            }));
        }), _operators.catchError((err)=>_rxjs.of((0, _cartState.voidTransactionError)(err?.message ?? "unknown error"), action.payload.isDatacapTransaction ? (0, _shared.resetPinPadRequest)(state$.value.terminalLogin.terminalSession.terminal_id) : (0, _state1.EMPTY_ACTION), (0, _shared.replaceSharedAlerts)((0, _shared.genericErrorMessage)(err)))))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/state":"8UPqD","../../utils/api/client":"27HsT","./Cart.state":"bgoZn","../../state/shared":"h0jLC","../../utils/api/errorHandler":"jWFhB","../../components/modal/Modal.state":"34xap","../order-details/OrderDetails.epic":"eIg9g","../../utils/constants":"f3A1R","../../utils/dpsVoidPolling":"6RGim","../../state":"dFzXj","./orderCancellation":"ZAFa7","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ZAFa7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cartCancellationRequiresAssistance", ()=>cartCancellationRequiresAssistance);
var _constants = require("../../utils/constants");
const cartCancellationRequiresAssistance = (response)=>response?.order_status === (0, _constants.ORDER_STATUS).VOID_PENDING && response?.payment_cancellation_status === (0, _constants.PAYMENT_CANCELLATION_STATUS).ASSISTANCE_REQUIRED;

},{"../../utils/constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c1ZL3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trackVisitExpiresAtEpic", ()=>trackVisitExpiresAtEpic);
parcelHelpers.export(exports, "visitExpirationWarningTimerEpic", ()=>visitExpirationWarningTimerEpic);
parcelHelpers.export(exports, "visitExpirationCountdownEpic", ()=>visitExpirationCountdownEpic);
parcelHelpers.export(exports, "visitExpiredActionEpic", ()=>visitExpiredActionEpic);
parcelHelpers.export(exports, "clearVisitExpirationOnCartClearEpic", ()=>clearVisitExpirationOnCartClearEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _state = require("../../utils/state");
var _client = require("../../utils/api/client");
var _visitExpirationState = require("./VisitExpiration.state");
var _cartState = require("./Cart.state");
var _checkoutState = require("../checkout/Checkout.state");
var _shared = require("../../state/shared");
var _state1 = require("../../state");
var _orderCancellation = require("./orderCancellation");
const CANCELLATION_ACTIONS = [
    (0, _visitExpirationState.CLEAR_VISIT_EXPIRATION),
    (0, _cartState.HOLD_ORDER_SUCCESS),
    (0, _cartState.CANCEL_ORDER_SUCCESS),
    (0, _cartState.CLEAR_CART)
];
const trackVisitExpiresAtEpic = (action$)=>action$.ofType((0, _cartState.GET_ORDER_SUCCESS), (0, _checkoutState.POST_VISIT_SUCCESS)).pipe(_operators.map((action)=>{
        const visitExpiresAt = action.payload?.visit_expires_at || action.payload?.data?.visit_expires_at;
        if (visitExpiresAt) return (0, _visitExpirationState.setVisitExpiresAt)(visitExpiresAt);
        return 0, _state1.EMPTY_ACTION;
    }));
const visitExpirationWarningTimerEpic = (action$)=>action$.ofType((0, _visitExpirationState.SET_VISIT_EXPIRES_AT)).pipe(_operators.switchMap((action)=>{
        const expiresAt = new Date(action.payload).getTime();
        const now = Date.now();
        const msUntilWarning = expiresAt - now - (0, _visitExpirationState.VISIT_EXPIRATION_WARNING_THRESHOLD_SECONDS) * 1000;
        if (msUntilWarning <= 0) {
            // Already past warning threshold — show warning immediately with remaining time
            const secondsLeft = Math.max(0, Math.round((expiresAt - now) / 1000));
            if (secondsLeft <= 0) return _rxjs.of((0, _visitExpirationState.visitExpired)());
            return _rxjs.of((0, _visitExpirationState.visitExpirationWarning)(secondsLeft));
        }
        return _rxjs.timer(msUntilWarning).pipe(_operators.map(()=>{
            const remaining = Math.max(0, Math.round((expiresAt - Date.now()) / 1000));
            return (0, _visitExpirationState.visitExpirationWarning)(remaining);
        }), _operators.takeUntil(action$.ofType(...CANCELLATION_ACTIONS)));
    }));
const visitExpirationCountdownEpic = (action$)=>action$.ofType((0, _visitExpirationState.VISIT_EXPIRATION_WARNING)).pipe(_operators.switchMap((action)=>{
        const startSeconds = action.payload;
        return _rxjs.timer(1000, 1000).pipe(_operators.map((tick)=>{
            const remaining = startSeconds - (tick + 1);
            if (remaining <= 0) return (0, _visitExpirationState.visitExpired)();
            return (0, _visitExpirationState.visitExpirationTick)(remaining);
        }), _operators.takeWhile((action)=>action.type !== (0, _visitExpirationState.VISIT_EXPIRED), true), _operators.takeUntil(action$.ofType(...CANCELLATION_ACTIONS)));
    }));
const visitExpiredActionEpic = (action$, state$)=>action$.ofType((0, _visitExpirationState.VISIT_EXPIRED)).pipe(_operators.mergeMap(()=>{
        const order = state$.value.cart?.order;
        const orderId = order?.order_id;
        if (!orderId) return _rxjs.of((0, _visitExpirationState.clearVisitExpiration)());
        const hasSuccessfulPayments = (0, _cartState.selectHasSuccessfulPayments)(state$.value);
        if (hasSuccessfulPayments) // Split-tender: require manual intervention
        return _rxjs.of((0, _visitExpirationState.clearVisitExpiration)(), (0, _shared.replaceSharedAlerts)({
            heading: "Order Expired",
            text: `Order ${orderId} expired. Please manually void the payments and cancel the order.`,
            variant: "error"
        }));
        // No successful payments: auto-cancel
        const apiParams = {
            url: (0, _state.getPosApiUrl)(state$.value),
            token: (0, _state.getAccessToken)(state$.value)
        };
        return _rxjs.defer(()=>(0, _client.cancelOrderById)({
                ...apiParams,
                id: orderId,
                note: "Order automatically cancelled: visit session expired"
            })).pipe(_operators.mergeMap((cancelOrderResponse)=>_rxjs.of((0, _visitExpirationState.clearVisitExpiration)(), (0, _cartState.clearCart)(), (0, _shared.replaceSharedAlerts)((0, _orderCancellation.cartCancellationRequiresAssistance)(cancelOrderResponse) ? {
                heading: "Order Expired",
                text: `Order ${orderId} expired, and its cancellation requires assistance. You may begin a new order and view this order in the order history page.`,
                variant: "error"
            } : {
                heading: "Order Expired",
                text: `Order ${orderId} expired. You can view the order in the order history page.`,
                variant: "info"
            }))), _operators.catchError(()=>{
            return _rxjs.of((0, _visitExpirationState.clearVisitExpiration)(), (0, _shared.replaceSharedAlerts)({
                heading: "Order Expiration Error",
                text: `Order ${orderId} expired but could not be cancelled automatically. Please cancel manually.`,
                variant: "error"
            }));
        }));
    }));
const clearVisitExpirationOnCartClearEpic = (action$)=>action$.ofType((0, _cartState.HOLD_ORDER_SUCCESS), (0, _cartState.CANCEL_ORDER_SUCCESS), (0, _cartState.CLEAR_CART)).pipe(_operators.map(()=>(0, _visitExpirationState.clearVisitExpiration)()));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/state":"8UPqD","../../utils/api/client":"27HsT","./VisitExpiration.state":"6xsNt","./Cart.state":"bgoZn","../checkout/Checkout.state":"4E8nR","../../state/shared":"h0jLC","../../state":"dFzXj","./orderCancellation":"ZAFa7","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2HZvf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchForItemEpic", ()=>searchForItemEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _client = require("../../utils/api/client");
var _state = require("../../utils/state");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _searchState = require("./Search.state");
const onErrorEpic = ({ errorMessage })=>_rxjs.of((0, _searchState.searchError)(errorMessage), (0, _searchState.searchAlertBarAction)((0, _alertBarState.replaceAlerts)({
        heading: "Search Failed",
        text: errorMessage,
        variant: "error"
    })));
const searchRequestParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: payload.id,
        key: payload.key,
        value: payload.value
    });
const searchForItemEpic = (action$, state$)=>action$.ofType((0, _searchState.SEND_SEARCH_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.searchForItem)(searchRequestParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>{
            if (!response.data.receivables.length) return _rxjs.of((0, _searchState.searchRequestSuccess)(response.data), (0, _searchState.searchAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "No Payment Available",
                text: "Your search was successful, but a payment is not available.",
                variant: "info"
            })));
            else {
                action.payload.navigate("/pos/results");
                return _rxjs.of((0, _searchState.searchRequestSuccess)(response.data));
            }
        }), _operators.catchError((err)=>onErrorEpic({
                errorMessage: err.message
            })))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/api/client":"27HsT","../../utils/state":"8UPqD","../../components/alert-bar/AlertBar.state":"HHSfQ","./Search.state":"lcTto","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3sr26":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchOrdersEpic", ()=>fetchOrdersEpic);
parcelHelpers.export(exports, "fetchBatchesEpic", ()=>fetchBatchesEpic);
parcelHelpers.export(exports, "fetchUsersEpic", ()=>fetchUsersEpic);
parcelHelpers.export(exports, "fetchOrdersFilterOptionsEpic", ()=>fetchOrdersFilterOptionsEpic);
var _ramda = require("ramda");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _client = require("../../utils/api/client");
var _state = require("../../utils/state");
var _ordersIndexState = require("./OrdersIndex.state");
var _helpers = require("../../utils/helpers");
var _errorHandler = require("../../utils/api/errorHandler");
var _shared = require("../../state/shared");
const caughtOrdersIndexErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _ordersIndexState.ordersIndexAlertBarAction), "Orders Index Error:", state);
const getOrdersIndexFiltersParam = (state)=>{
    const filterFields = _ramda.pathOr([], [
        "ordersIndex",
        "forms",
        "ordersIndexFiltersForm"
    ], state);
    return (0, _helpers.getFiltersFromFields)(filterFields);
};
const fetchOrdersParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        pageIndex: state.ordersIndex.currentPage,
        pageSize: state.ordersIndex.pageSize,
        filters: getOrdersIndexFiltersParam(state)
    });
const fetchOrdersEpic = (action$, state$)=>action$.ofType((0, _ordersIndexState.FETCH_ORDERS_REQUEST)).pipe(_operators.switchMap(()=>_rxjs.from((0, _client.fetchOrders)(fetchOrdersParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _ordersIndexState.fetchOrdersSuccess)({
                data: response.data,
                pageCount: response.data.pagesTotal,
                totalOrders: response.data.recordsTotal
            }))), _operators.catchError((err)=>caughtOrdersIndexErrorCallback(state$.value)(err, (0, _ordersIndexState.fetchOrdersError)(err.message))))));
const fetchBatchesParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const fetchBatchesEpic = (action$, state$)=>action$.ofType((0, _ordersIndexState.FETCH_BATCHES_REQUEST)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchBatches)(fetchBatchesParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _ordersIndexState.fetchBatchesSuccess)(response))), _operators.catchError((err)=>caughtOrdersIndexErrorCallback(state$.value)(err)))));
const fetchUsersParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const fetchUsersEpic = (action$, state$)=>action$.ofType((0, _ordersIndexState.FETCH_USERS_REQUEST)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchUsers)(fetchUsersParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _ordersIndexState.fetchUsersSuccess)(response))), _operators.catchError((err)=>caughtOrdersIndexErrorCallback(state$.value)(err)))));
const fetchOrdersFilterOptionsParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const fetchOrdersFilterOptionsEpic = (action$, state$)=>action$.ofType((0, _shared.FETCH_ORDERS_FILTER_OPTIONS)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchOrdersFilterOptions)(fetchOrdersFilterOptionsParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _shared.fetchOrdersFilterOptionsSuccess)(response))), _operators.catchError((err)=>caughtOrdersIndexErrorCallback(state$.value)(err, (0, _shared.fetchOrdersFilterOptionsError)(err.message))))));

},{"ramda":"JPp0Z","rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/api/client":"27HsT","../../utils/state":"8UPqD","./OrdersIndex.state":"cB6HN","../../utils/helpers":"epomp","../../utils/api/errorHandler":"jWFhB","../../state/shared":"h0jLC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7XoGt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closeoutErrorEpic", ()=>closeoutErrorEpic);
parcelHelpers.export(exports, "createCloseoutEpic", ()=>createCloseoutEpic);
parcelHelpers.export(exports, "fetchCurrentBatchEpic", ()=>fetchCurrentBatchEpic);
parcelHelpers.export(exports, "fetchCloseoutReportEpic", ()=>fetchCloseoutReportEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _state = require("../../utils/state");
var _client = require("../../utils/api/client");
var _closeoutState = require("./Closeout.state");
var _errorHandler = require("../../utils/api/errorHandler");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _modalState = require("../../components/modal/Modal.state");
const caughtCloseoutErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _closeoutState.closeoutAlertBarAction), "Closeout Page Error:", state);
const createCloseoutParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        method: "POST",
        batch: payload
    });
const closeoutErrorEpic = ({ errorMessage })=>_rxjs.of((0, _closeoutState.closeoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
        heading: "Closeout Page Error",
        text: errorMessage,
        variant: "error"
    })));
const createCloseoutEpic = (action$, state$)=>action$.ofType((0, _closeoutState.SUBMIT_CLOSEOUT_FORM)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.createCloseout)(createCloseoutParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _closeoutState.createCloseoutSuccess)(response.data), (0, _closeoutState.fetchCloseoutReportRequest)(response.data))), _operators.catchError((err)=>caughtCloseoutErrorCallback(state$.value)(err)))));
const fetchBatchParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const fetchCurrentBatchEpic = (action$, state$)=>action$.ofType((0, _closeoutState.FETCH_CURRENT_BATCH_REQUEST)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchCurrentBatch)(fetchBatchParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _closeoutState.fetchCurrentBatchSuccess)(response.data))), _operators.catchError((err)=>caughtCloseoutErrorCallback(state$.value)(err)))));
const fetchCloseoutReportParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const fetchCloseoutReportEpic = (action$, state$)=>action$.ofType((0, _closeoutState.FETCH_CLOSEOUT_REPORT_REQUEST)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchCloseoutReport)(fetchCloseoutReportParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _closeoutState.closeoutModalAction)((0, _modalState.closeModal)()), (0, _closeoutState.fetchCloseoutReportSuccess)(response.data))), _operators.catchError((err)=>caughtCloseoutErrorCallback(state$.value)(err)))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/state":"8UPqD","../../utils/api/client":"27HsT","./Closeout.state":"eCCPO","../../utils/api/errorHandler":"jWFhB","../../components/alert-bar/AlertBar.state":"HHSfQ","../../components/modal/Modal.state":"34xap","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lvaMo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCashActionDetailsEpic", ()=>getCashActionDetailsEpic);
parcelHelpers.export(exports, "printReceiptEpic", ()=>printReceiptEpic);
parcelHelpers.export(exports, "getCloseoutDetailsEpic", ()=>getCloseoutDetailsEpic);
parcelHelpers.export(exports, "reprintCloseoutDetailsEpic", ()=>reprintCloseoutDetailsEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _client = require("../../utils/api/client");
var _state = require("../../utils/state");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _cashActionDetailsState = require("./CashActionDetails.state");
var _errorHandler = require("../../utils/api/errorHandler");
const caughtCashActionDetailsError = (state)=>(0, _errorHandler.caughtError)((0, _cashActionDetailsState.cashActionDetailsAlertBarAction), "Cash Action Details Page Error:", state);
const getCashActionParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: payload
    });
const getCashActionDetailsEpic = (action$, state$)=>action$.ofType((0, _cashActionDetailsState.GET_CASH_ACTION_DETAILS_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchCashAction)(getCashActionParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _cashActionDetailsState.getCashActionDetailsSuccess)(response.data))), _operators.catchError((err)=>caughtCashActionDetailsError(state$.value)(err, (0, _cashActionDetailsState.getCashActionDetailsError)(err.message))))));
const caughtCashActionReceiptError = (state)=>(0, _errorHandler.caughtError)((0, _cashActionDetailsState.cashActionDetailsAlertBarAction), "Receipt Error:", state);
const printReceiptParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        type: "print",
        id: state.cashActionDetails.data.id
    });
const printReceiptEpic = (action$, state$)=>action$.ofType((0, _cashActionDetailsState.SUBMIT_PRINT_RECEIPT)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.cashActionReceipt)(printReceiptParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _cashActionDetailsState.postReceiptSuccess)(response?.data), (0, _cashActionDetailsState.cashActionDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Receipt Printed",
                text: `Receipt for cashAction: ${state$.value.cashActionDetails.data.id} has been successfully printed.`,
                variant: "success"
            })))), _operators.catchError((err)=>caughtCashActionReceiptError(state$.value)(err)))));
const getCloseoutDetailsParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: payload
    });
const getCloseoutDetailsEpic = (action$, state$)=>action$.ofType((0, _cashActionDetailsState.GET_CLOSEOUT_DETAILS_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchCloseoutDetails)(getCloseoutDetailsParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _cashActionDetailsState.getCloseoutDetailsSuccess)(response.data))), _operators.catchError((err)=>caughtCashActionDetailsError(state$.value)(err, (0, _cashActionDetailsState.getCashActionDetailsError)(err.message))))));
const reprintReportsDetailsParams = (state, payload)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        id: payload
    });
const reprintCloseoutDetailsEpic = (action$, state$)=>action$.ofType((0, _cashActionDetailsState.REPRINT_CLOSEOUT_REPORTS_REQUEST)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.reprintCloseoutReports)(reprintReportsDetailsParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _cashActionDetailsState.reprintCloseoutReportsSuccess)(response.data), (0, _cashActionDetailsState.cashActionDetailsAlertBarAction)((0, _alertBarState.replaceAlerts)({
                heading: "Reports Generated",
                text: "Report generated successfully",
                variant: "success"
            })))), _operators.catchError((err)=>caughtCashActionReceiptError(state$.value)(err)))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/api/client":"27HsT","../../utils/state":"8UPqD","../../components/alert-bar/AlertBar.state":"HHSfQ","./CashActionDetails.state":"dI29X","../../utils/api/errorHandler":"jWFhB","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7mcKd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cashDropErrorEpic", ()=>cashDropErrorEpic);
parcelHelpers.export(exports, "postCashDropEpic", ()=>postCashDropEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _state = require("../../utils/state");
var _cashDropState = require("./CashDrop.state");
var _client = require("../../utils/api/client");
var _errorHandler = require("../../utils/api/errorHandler");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
const caughtCashDropErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _cashDropState.cashDropAlertBarAction), "Cash Drop Page Error:", state);
const cashDropErrorEpic = ({ errorMessage })=>_rxjs.of((0, _cashDropState.cashDropAlertBarAction)((0, _alertBarState.replaceAlerts)({
        heading: "Cash Drop Error",
        text: errorMessage,
        variant: "error"
    })));
const postCashDropParams = (state, payload)=>{
    return {
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        data: {
            cash_action: payload
        }
    };
};
const postCashDropEpic = (action$, state$)=>action$.ofType((0, _cashDropState.SUBMIT_CASH_DROP_FORM)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.postCashDrop)(postCashDropParams(state$.value, action.payload))).pipe(_operators.flatMap((response)=>{
            action.payload.navigate(`/pos/cashaction/${response.data.id}`);
            return _rxjs.of((0, _cashDropState.postCashDropSuccess)(response.data));
        }), _operators.catchError((err)=>caughtCashDropErrorCallback(state$.value)(err)))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/state":"8UPqD","./CashDrop.state":"esqw8","../../utils/api/client":"27HsT","../../utils/api/errorHandler":"jWFhB","../../components/alert-bar/AlertBar.state":"HHSfQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lDOOq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "openCashDrawerEpic", ()=>openCashDrawerEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _state = require("../../utils/state");
var _alertBarState = require("../../components/alert-bar/AlertBar.state");
var _client = require("../../utils/api/client");
var _closeoutEpic = require("../../pages/closeout/Closeout.epic");
var _closeoutState = require("../../pages/closeout/Closeout.state");
var _cashDropState = require("../../pages/cash-drop/CashDrop.state");
var _peripheralDevices = require("../peripheralDevices");
var _cashDropEpics = require("../../pages/cash-drop/CashDrop.epics");
var _ = require("..");
const peripheralAlertBarAction = (currentPathname)=>{
    if (currentPathname.includes("closeout")) return _rxjs.of((0, _closeoutState.closeoutAlertBarAction)((0, _alertBarState.replaceAlerts)({
        heading: "Cash Drawer Opened",
        variant: "info"
    })));
    else if (currentPathname.includes("cashdrop")) return _rxjs.of((0, _cashDropState.cashDropAlertBarAction)((0, _alertBarState.replaceAlerts)({
        heading: "Cash Drawer Opened",
        variant: "info"
    })));
    else return _rxjs.of((0, _.EMPTY_ACTION));
};
const cashDrawerOpenError = (currentPathname, err)=>{
    if (currentPathname.includes("closeout")) return (0, _closeoutEpic.closeoutErrorEpic)({
        errorMessage: err.message
    });
    else if (currentPathname.includes("cashdrop")) return (0, _cashDropEpics.cashDropErrorEpic)({
        errorMessage: err.message
    });
    else return _rxjs.of((0, _.EMPTY_ACTION));
};
const openCashDrawerParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const openCashDrawerEpic = (action$, state$)=>action$.ofType((0, _peripheralDevices.OPEN_CASH_DRAWER)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.openCashDrawer)(openCashDrawerParams(state$.value))).pipe(_operators.flatMap(()=>{
            return peripheralAlertBarAction(action.payload.location.pathname);
        }), _operators.catchError((err)=>{
            return cashDrawerOpenError(action.payload.location.pathname, err);
        }))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/state":"8UPqD","../../components/alert-bar/AlertBar.state":"HHSfQ","../../utils/api/client":"27HsT","../../pages/closeout/Closeout.epic":"7XoGt","../../pages/closeout/Closeout.state":"eCCPO","../../pages/cash-drop/CashDrop.state":"esqw8","../peripheralDevices":"3U6I5","../../pages/cash-drop/CashDrop.epics":"7mcKd","..":"dFzXj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bcm5d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchDrawerHistoriesEpic", ()=>fetchDrawerHistoriesEpic);
parcelHelpers.export(exports, "fetchDrawerHistoriesFilterOptionsEpic", ()=>fetchDrawerHistoriesFilterOptionsEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _ramda = require("ramda");
var _client = require("../../utils/api/client");
var _state = require("../../utils/state");
var _helpers = require("../../utils/helpers");
var _drawerHistoryIndexState = require("./DrawerHistoryIndex.state");
var _errorHandler = require("../../utils/api/errorHandler");
var _shared = require("../../state/shared");
const caughtDrawerHistoryErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _drawerHistoryIndexState.drawerHistoryIndexAlertBarAction), "Drawer History Page Error:", state);
const getDrawerHistoryIndexFiltersParam = (state)=>{
    const filterFields = _ramda.pathOr([], [
        "drawerHistoryIndex",
        "forms",
        "drawerHistoryFiltersForm"
    ], state);
    return (0, _helpers.getFiltersFromFields)(filterFields);
};
const fetchDrawerHistoriesParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        pageIndex: state.drawerHistoryIndex.currentPage,
        pageSize: state.drawerHistoryIndex.pageSize,
        filters: getDrawerHistoryIndexFiltersParam(state)
    });
const fetchDrawerHistoriesEpic = (action$, state$)=>action$.ofType((0, _drawerHistoryIndexState.FETCH_DRAWER_HISTORIES_REQUEST)).pipe(_operators.switchMap(()=>_rxjs.from((0, _client.fetchDrawerHistories)(fetchDrawerHistoriesParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _drawerHistoryIndexState.fetchDrawerHistoriesSuccess)(response))), _operators.catchError((err)=>caughtDrawerHistoryErrorCallback(state$.value)(err, (0, _drawerHistoryIndexState.fetchDrawerHistoriesError)(err.message))))));
const fetchDrawerHistoriesFilterOptionsEpic = (action$, state$)=>action$.ofType((0, _shared.FETCH_DRAWER_HISTORIES_FILTER_OPTIONS)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchDrawerHistoryFilterOptions)(fetchDrawerHistoriesParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _shared.fetchDrawerHistoriesFilterOptionsSuccess)(response))), _operators.catchError((err)=>caughtDrawerHistoryErrorCallback(state$.value)(err, (0, _shared.fetchDrawerHistoriesFilterOptionsError)(err.message))))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","ramda":"JPp0Z","../../utils/api/client":"27HsT","../../utils/state":"8UPqD","../../utils/helpers":"epomp","./DrawerHistoryIndex.state":"d4FVh","../../utils/api/errorHandler":"jWFhB","../../state/shared":"h0jLC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jPMG4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchClientConfigEpic", ()=>fetchClientConfigEpic);
parcelHelpers.export(exports, "fetchCurrentAbilitiesEpic", ()=>fetchCurrentAbilitiesEpic);
parcelHelpers.export(exports, "fetchDenominationsEpic", ()=>fetchDenominationsEpic);
parcelHelpers.export(exports, "resetPinPadEpic", ()=>resetPinPadEpic);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _client = require("../../utils/api/client");
var _state = require("../../utils/state");
var _shared = require("../shared");
const fetchDenominationsParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const fetchClientConfigParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        clientId: action.payload,
        token: (0, _state.getAccessToken)(state)
    });
const fetchCurrentAbilitiesParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state)
    });
const resetPinPadParams = (state, action)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        terminalId: action.payload.terminalId,
        method: "POST"
    });
const fetchClientConfigEpic = (action$, state$)=>action$.ofType((0, _shared.FETCH_CLIENT_CONFIG)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.fetchClientConfig)(fetchClientConfigParams(state$.value, action))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _shared.fetchClientConfigSuccess)(response.data))), _operators.catchError((err)=>_rxjs.of((0, _shared.fetchClientConfigError)(err.message), (0, _shared.replaceSharedAlerts)((0, _shared.genericErrorMessage)(err, "Fetch Client Configuration Error")))))));
const fetchCurrentAbilitiesEpic = (action$, state$)=>action$.ofType((0, _shared.FETCH_CURRENT_ABILITIES)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchCurrentAbilities)(fetchCurrentAbilitiesParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _shared.fetchCurrentAbilitiesSuccess)(response.data))), _operators.catchError((err)=>_rxjs.of((0, _shared.fetchCurrentAbilitiesError)(err.message), (0, _shared.replaceSharedAlerts)((0, _shared.genericErrorMessage)(err, "Fetch Abilities Error")))))));
const fetchDenominationsEpic = (action$, state$)=>action$.ofType((0, _shared.FETCH_DENOMINATIONS)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchDenominations)(fetchDenominationsParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _shared.fetchDenominationsSuccess)(response.data))), _operators.catchError((err)=>_rxjs.of((0, _shared.fetchDenominationsError)(err.message), (0, _shared.replaceSharedAlerts)((0, _shared.genericErrorMessage)(err, "Fetch Denominations Error")))))));
const resetPinPadEpic = (action$, state$)=>action$.ofType((0, _shared.RESET_PIN_PAD)).pipe(_operators.flatMap((action)=>_rxjs.from((0, _client.resetPinPad)(resetPinPadParams(state$.value, action))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _shared.resetPinPadSuccess)(response.data))), _operators.catchError((err)=>_rxjs.of((0, _shared.resetPinPadError)(err))))));

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/api/client":"27HsT","../../utils/state":"8UPqD","../shared":"h0jLC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"efPi9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "caughtReportingErrorCallback", ()=>caughtReportingErrorCallback);
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _client = require("../../utils/api/client");
var _errorHandler = require("../../utils/api/errorHandler");
var _state = require("../../utils/state");
var _reportingState = require("./Reporting.state");
const caughtReportingErrorCallback = (state)=>(0, _errorHandler.caughtError)((0, _reportingState.reportingAlertBarAction), "Reporting Error:", state);
const fetchPeriscopeDashboardIFrameUrlParams = (state)=>({
        url: (0, _state.getPosApiUrl)(state),
        token: (0, _state.getAccessToken)(state),
        method: "GET"
    });
const requestPeriscopeDashboardEpic = (action$, state$)=>action$.ofType((0, _reportingState.REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL)).pipe(_operators.flatMap(()=>_rxjs.from((0, _client.fetchPeriscopeDashboardIFrameUrl)(fetchPeriscopeDashboardIFrameUrlParams(state$.value))).pipe(_operators.flatMap((response)=>_rxjs.of((0, _reportingState.getPeriscopeDashboardIFrameUrlSucceeded)({
                url: response.data
            }))), _operators.catchError((err)=>caughtReportingErrorCallback(state$.value)(err, (0, _reportingState.getPeriscopeDashboardIFrameUrlFailed)(err.message))))));
exports.default = requestPeriscopeDashboardEpic;

},{"rxjs":"kbxjh","rxjs/operators":"4sw1o","../../utils/api/client":"27HsT","../../utils/api/errorHandler":"jWFhB","../../utils/state":"8UPqD","./Reporting.state":"5xRzg","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1cMw2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notifier", ()=>(0, _notifier.Notifier));
parcelHelpers.export(exports, "BaseNotifier", ()=>(0, _baseNotifier.BaseNotifier));
parcelHelpers.export(exports, "QueryInfo", ()=>(0, _queries.QueryInfo));
parcelHelpers.export(exports, "Scope", ()=>(0, _scope.Scope));
var _notifier = require("./notifier");
var _baseNotifier = require("./base_notifier");
var _queries = require("./queries");
var _scope = require("./scope");

},{"./notifier":"h5Ta6","./base_notifier":"k7LsQ","./queries":"lcUNg","./scope":"ecK5Z","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h5Ta6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notifier", ()=>Notifier);
var _promisePolyfill = require("promise-polyfill");
var _promisePolyfillDefault = parcelHelpers.interopDefault(_promisePolyfill);
var _baseNotifier = require("./base_notifier");
var _window = require("./filter/window");
var _console = require("./instrumentation/console");
var _dom = require("./instrumentation/dom");
var _fetch = require("./instrumentation/fetch");
var _location = require("./instrumentation/location");
var _xhr = require("./instrumentation/xhr");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Notifier = /** @class */ function(_super) {
    __extends(Notifier, _super);
    function Notifier(opt) {
        var _this = _super.call(this, opt) || this;
        _this.offline = false;
        _this.todo = [];
        _this._ignoreWindowError = 0;
        _this._ignoreNextXHR = 0;
        if (typeof window === "undefined") return _this;
        _this.addFilter((0, _window.windowFilter));
        if (window.addEventListener) {
            _this.onOnline = _this.onOnline.bind(_this);
            window.addEventListener("online", _this.onOnline);
            _this.onOffline = _this.onOffline.bind(_this);
            window.addEventListener("offline", _this.onOffline);
            _this.onUnhandledrejection = _this.onUnhandledrejection.bind(_this);
            window.addEventListener("unhandledrejection", _this.onUnhandledrejection);
            _this._onClose.push(function() {
                window.removeEventListener("online", _this.onOnline);
                window.removeEventListener("offline", _this.onOffline);
                window.removeEventListener("unhandledrejection", _this.onUnhandledrejection);
            });
        }
        _this._instrument(opt.instrumentation);
        return _this;
    }
    Notifier.prototype._instrument = function(opt) {
        if (opt === void 0) opt = {};
        if (opt.console === undefined) opt.console = !isDevEnv(this._opt.environment);
        if (enabled(opt.onerror)) {
            // tslint:disable-next-line:no-this-assignment
            var self_1 = this;
            var oldHandler_1 = window.onerror;
            window.onerror = function abOnerror() {
                if (oldHandler_1) oldHandler_1.apply(this, arguments);
                self_1.onerror.apply(self_1, arguments);
            };
        }
        (0, _dom.instrumentDOM)(this);
        if (enabled(opt.fetch) && typeof fetch === "function") (0, _fetch.instrumentFetch)(this);
        if (enabled(opt.history) && typeof history === "object") (0, _location.instrumentLocation)(this);
        if (enabled(opt.console) && typeof console === "object") (0, _console.instrumentConsole)(this);
        if (enabled(opt.xhr) && typeof XMLHttpRequest !== "undefined") (0, _xhr.instrumentXHR)(this);
    };
    Notifier.prototype.notify = function(err) {
        var _this = this;
        if (this.offline) return new (0, _promisePolyfillDefault.default)(function(resolve, reject) {
            _this.todo.push({
                err: err,
                resolve: resolve,
                reject: reject
            });
            while(_this.todo.length > 100){
                var j = _this.todo.shift();
                if (j === undefined) break;
                j.resolve({
                    error: new Error("airbrake: offline queue is too large")
                });
            }
        });
        return _super.prototype.notify.call(this, err);
    };
    Notifier.prototype.onOnline = function() {
        this.offline = false;
        var _loop_1 = function(j) {
            this_1.notify(j.err).then(function(notice) {
                j.resolve(notice);
            });
        };
        var this_1 = this;
        for(var _i = 0, _a = this.todo; _i < _a.length; _i++){
            var j = _a[_i];
            _loop_1(j);
        }
        this.todo = [];
    };
    Notifier.prototype.onOffline = function() {
        this.offline = true;
    };
    Notifier.prototype.onUnhandledrejection = function(e) {
        // Handle native or bluebird Promise rejections
        // https://developer.mozilla.org/en-US/docs/Web/Events/unhandledrejection
        // http://bluebirdjs.com/docs/api/error-management-configuration.html
        var reason = e.reason || e.detail && e.detail.reason;
        if (!reason) return;
        var msg = reason.message || String(reason);
        if (msg.indexOf && msg.indexOf("airbrake: ") === 0) return;
        if (typeof reason !== "object" || reason.error === undefined) {
            this.notify({
                error: reason,
                context: {
                    unhandledRejection: true
                }
            });
            return;
        }
        this.notify(__assign(__assign({}, reason), {
            context: {
                unhandledRejection: true
            }
        }));
    };
    Notifier.prototype.onerror = function(message, filename, line, column, err) {
        if (this._ignoreWindowError > 0) return;
        if (err) {
            this.notify({
                error: err,
                context: {
                    windowError: true
                }
            });
            return;
        }
        // Ignore errors without file or line.
        if (!filename || !line) return;
        this.notify({
            error: {
                message: message,
                fileName: filename,
                lineNumber: line,
                columnNumber: column,
                noStack: true
            },
            context: {
                windowError: true
            }
        });
    };
    Notifier.prototype._ignoreNextWindowError = function() {
        var _this = this;
        this._ignoreWindowError++;
        setTimeout(function() {
            return _this._ignoreWindowError--;
        });
    };
    return Notifier;
}((0, _baseNotifier.BaseNotifier));
function isDevEnv(env) {
    return env && env.startsWith && env.startsWith("dev");
}
function enabled(v) {
    return v === undefined || v === true;
}

},{"promise-polyfill":"h2t0f","./base_notifier":"k7LsQ","./filter/window":"8MGJs","./instrumentation/console":"fdjx3","./instrumentation/dom":"jDK3S","./instrumentation/fetch":"djUvn","./instrumentation/location":"8CHdv","./instrumentation/xhr":"jy5DG","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"h2t0f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _finally = require("./finally");
var _finallyDefault = parcelHelpers.interopDefault(_finally);
var _allSettled = require("./allSettled");
var _allSettledDefault = parcelHelpers.interopDefault(_allSettled);
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;
function isArray(x) {
    return Boolean(x && typeof x.length !== "undefined");
}
function noop() {}
// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function Promise(fn) {
    if (!(this instanceof Promise)) throw new TypeError("Promises must be constructed via new");
    if (typeof fn !== "function") throw new TypeError("not a function");
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    doResolve(fn, this);
}
function handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            reject(deferred.promise, e);
            return;
        }
        resolve(deferred.promise, ret);
    });
}
function resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError("A promise cannot be resolved with itself.");
        if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
            var then = newValue.then;
            if (newValue instanceof Promise) {
                self._state = 3;
                self._value = newValue;
                finale(self);
                return;
            } else if (typeof then === "function") {
                doResolve(bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        finale(self);
    } catch (e) {
        reject(self, e);
    }
}
function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
}
function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) Promise._immediateFn(function() {
        if (!self._handled) Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        reject(self, ex);
    }
}
Promise.prototype["catch"] = function(onRejected) {
    return this.then(null, onRejected);
};
Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor(noop);
    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
};
Promise.prototype["finally"] = (0, _finallyDefault.default);
Promise.all = function(arr) {
    return new Promise(function(resolve, reject) {
        if (!isArray(arr)) return reject(new TypeError("Promise.all accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === "object" || typeof val === "function")) {
                    var then = val.then;
                    if (typeof then === "function") {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
Promise.allSettled = (0, _allSettledDefault.default);
Promise.resolve = function(value) {
    if (value && typeof value === "object" && value.constructor === Promise) return value;
    return new Promise(function(resolve) {
        resolve(value);
    });
};
Promise.reject = function(value) {
    return new Promise(function(resolve, reject) {
        reject(value);
    });
};
Promise.race = function(arr) {
    return new Promise(function(resolve, reject) {
        if (!isArray(arr)) return reject(new TypeError("Promise.race accepts an array"));
        for(var i = 0, len = arr.length; i < len; i++)Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
Promise._immediateFn = // @ts-ignore
typeof setImmediate === "function" && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    setTimeoutFunc(fn, 0);
};
Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== "undefined" && console) console.warn("Possible Unhandled Promise Rejection:", err); // eslint-disable-line no-console
};
exports.default = Promise;

},{"./finally":"9O2se","./allSettled":"4LCuP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9O2se":[function(require,module,exports) {
/**
 * @this {Promise}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
exports.default = finallyConstructor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4LCuP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError(typeof arr + " " + arr + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === "object" || typeof val === "function")) {
                var then = val.then;
                if (typeof then === "function") {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: "rejected",
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: "fulfilled",
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
exports.default = allSettled;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k7LsQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseNotifier", ()=>BaseNotifier);
var _promisePolyfill = require("promise-polyfill");
var _promisePolyfillDefault = parcelHelpers.interopDefault(_promisePolyfill);
var _jsonifyNotice = require("./jsonify_notice");
var _scope = require("./scope");
var _esp = require("./processor/esp");
var _angularMessage = require("./filter/angular_message");
var _debounce = require("./filter/debounce");
var _ignoreNoise = require("./filter/ignore_noise");
var _uncaughtMessage = require("./filter/uncaught_message");
var _httpReq = require("./http_req");
var _queries = require("./queries");
var _queues = require("./queues");
var _routes = require("./routes");
var _version = require("./version");
var _remoteSettings = require("./remote_settings");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var BaseNotifier = /** @class */ function() {
    function BaseNotifier(opt) {
        var _this = this;
        this._filters = [];
        this._performanceFilters = [];
        this._scope = new (0, _scope.Scope)();
        this._onClose = [];
        if (!opt.projectId || !opt.projectKey) throw new Error("airbrake: projectId and projectKey are required");
        this._opt = opt;
        this._opt.host = this._opt.host || "https://api.airbrake.io";
        this._opt.remoteConfigHost = this._opt.remoteConfigHost || "https://notifier-configs.airbrake.io";
        this._opt.apmHost = this._opt.apmHost || "https://api.airbrake.io";
        this._opt.timeout = this._opt.timeout || 10000;
        this._opt.keysBlocklist = this._opt.keysBlocklist || [
            /password/,
            /secret/
        ];
        this._url = "".concat(this._opt.host, "/api/v3/projects/").concat(this._opt.projectId, "/notices?key=").concat(this._opt.projectKey);
        this._opt.errorNotifications = this._opt.errorNotifications !== false;
        this._opt.performanceStats = this._opt.performanceStats !== false;
        this._opt.queryStats = this._opt.queryStats !== false;
        this._opt.queueStats = this._opt.queueStats !== false;
        this._opt.remoteConfig = this._opt.remoteConfig !== false;
        this._processor = this._opt.processor || (0, _esp.espProcessor);
        this._requester = (0, _httpReq.makeRequester)(this._opt);
        this.addFilter((0, _ignoreNoise.ignoreNoiseFilter));
        this.addFilter((0, _debounce.makeDebounceFilter)());
        this.addFilter((0, _uncaughtMessage.uncaughtMessageFilter));
        this.addFilter((0, _angularMessage.angularMessageFilter));
        this.addFilter(function(notice) {
            notice.context.notifier = {
                name: (0, _version.NOTIFIER_NAME),
                version: (0, _version.NOTIFIER_VERSION),
                url: (0, _version.NOTIFIER_URL)
            };
            if (_this._opt.environment) notice.context.environment = _this._opt.environment;
            return notice;
        });
        this.routes = new Routes(this);
        this.queues = new Queues(this);
        this.queries = new (0, _queries.QueriesStats)(this._opt);
        if (this._opt.remoteConfig) {
            var pollerId_1 = new (0, _remoteSettings.RemoteSettings)(this._opt).poll();
            this._onClose.push(function() {
                return clearInterval(pollerId_1);
            });
        }
    }
    BaseNotifier.prototype.close = function() {
        for(var _i = 0, _a = this._onClose; _i < _a.length; _i++){
            var fn = _a[_i];
            fn();
        }
    };
    BaseNotifier.prototype.scope = function() {
        return this._scope;
    };
    BaseNotifier.prototype.setActiveScope = function(scope) {
        this._scope = scope;
    };
    BaseNotifier.prototype.addFilter = function(filter) {
        this._filters.push(filter);
    };
    BaseNotifier.prototype.addPerformanceFilter = function(performanceFilter) {
        this._performanceFilters.push(performanceFilter);
    };
    BaseNotifier.prototype.notify = function(err) {
        var notice = {
            errors: [],
            context: __assign(__assign({
                severity: "error"
            }, this.scope().context()), err.context),
            params: err.params || {},
            environment: err.environment || {},
            session: err.session || {}
        };
        if (typeof err !== "object" || err.error === undefined) err = {
            error: err
        };
        if (!this._opt.errorNotifications) {
            notice.error = new Error("airbrake: not sending this error, errorNotifications is disabled err=".concat(JSON.stringify(err.error)));
            return (0, _promisePolyfillDefault.default).resolve(notice);
        }
        if (!err.error) {
            notice.error = new Error("airbrake: got err=".concat(JSON.stringify(err.error), ", wanted an Error"));
            return (0, _promisePolyfillDefault.default).resolve(notice);
        }
        var error = this._processor(err.error);
        notice.errors.push(error);
        for(var _i = 0, _a = this._filters; _i < _a.length; _i++){
            var filter = _a[_i];
            var r = filter(notice);
            if (r === null) {
                notice.error = new Error("airbrake: error is filtered");
                return (0, _promisePolyfillDefault.default).resolve(notice);
            }
            notice = r;
        }
        if (!notice.context) notice.context = {};
        notice.context.language = "JavaScript";
        return this._sendNotice(notice);
    };
    BaseNotifier.prototype._sendNotice = function(notice) {
        var body = (0, _jsonifyNotice.jsonifyNotice)(notice, {
            keysBlocklist: this._opt.keysBlocklist
        });
        if (this._opt.reporter) {
            if (typeof this._opt.reporter === "function") return this._opt.reporter(notice);
            else console.warn("airbrake: options.reporter must be a function");
        }
        var req = {
            method: "POST",
            url: this._url,
            body: body
        };
        return this._requester(req).then(function(resp) {
            notice.id = resp.json.id;
            notice.url = resp.json.url;
            return notice;
        }).catch(function(err) {
            notice.error = err;
            return notice;
        });
    };
    BaseNotifier.prototype.wrap = function(fn, props) {
        if (props === void 0) props = [];
        if (fn._airbrake) return fn;
        // tslint:disable-next-line:no-this-assignment
        var client = this;
        var airbrakeWrapper = function() {
            var fnArgs = Array.prototype.slice.call(arguments);
            var wrappedArgs = client._wrapArguments(fnArgs);
            try {
                return fn.apply(this, wrappedArgs);
            } catch (err) {
                client.notify({
                    error: err,
                    params: {
                        arguments: fnArgs
                    }
                });
                client._ignoreNextWindowError();
                throw err;
            }
        };
        for(var prop in fn)if (fn.hasOwnProperty(prop)) airbrakeWrapper[prop] = fn[prop];
        for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
            var prop = props_1[_i];
            if (fn.hasOwnProperty(prop)) airbrakeWrapper[prop] = fn[prop];
        }
        airbrakeWrapper._airbrake = true;
        airbrakeWrapper.inner = fn;
        return airbrakeWrapper;
    };
    BaseNotifier.prototype._wrapArguments = function(args) {
        for(var i = 0; i < args.length; i++){
            var arg = args[i];
            if (typeof arg === "function") args[i] = this.wrap(arg);
        }
        return args;
    };
    BaseNotifier.prototype._ignoreNextWindowError = function() {};
    BaseNotifier.prototype.call = function(fn) {
        var _args = [];
        for(var _i = 1; _i < arguments.length; _i++)_args[_i - 1] = arguments[_i];
        var wrapper = this.wrap(fn);
        return wrapper.apply(this, Array.prototype.slice.call(arguments, 1));
    };
    return BaseNotifier;
}();
var Routes = /** @class */ function() {
    function Routes(notifier) {
        this._notifier = notifier;
        this._routes = new (0, _routes.RoutesStats)(notifier._opt);
        this._breakdowns = new (0, _routes.RoutesBreakdowns)(notifier._opt);
        this._opt = notifier._opt;
    }
    Routes.prototype.start = function(method, route, statusCode, contentType) {
        if (method === void 0) method = "";
        if (route === void 0) route = "";
        if (statusCode === void 0) statusCode = 0;
        if (contentType === void 0) contentType = "";
        var metric = new (0, _routes.RouteMetric)(method, route, statusCode, contentType);
        if (!this._opt.performanceStats) return metric;
        var scope = this._notifier.scope().clone();
        scope.setContext({
            httpMethod: method,
            route: route
        });
        scope.setRouteMetric(metric);
        this._notifier.setActiveScope(scope);
        return metric;
    };
    Routes.prototype.notify = function(req) {
        if (!this._opt.performanceStats) return;
        req.end();
        for(var _i = 0, _a = this._notifier._performanceFilters; _i < _a.length; _i++){
            var performanceFilter = _a[_i];
            if (performanceFilter(req) === null) return;
        }
        this._routes.notify(req);
        this._breakdowns.notify(req);
    };
    return Routes;
}();
var Queues = /** @class */ function() {
    function Queues(notifier) {
        this._notifier = notifier;
        this._queues = new (0, _queues.QueuesStats)(notifier._opt);
        this._opt = notifier._opt;
    }
    Queues.prototype.start = function(queue) {
        var metric = new (0, _queues.QueueMetric)(queue);
        if (!this._opt.performanceStats) return metric;
        var scope = this._notifier.scope().clone();
        scope.setContext({
            queue: queue
        });
        scope.setQueueMetric(metric);
        this._notifier.setActiveScope(scope);
        return metric;
    };
    Queues.prototype.notify = function(q) {
        if (!this._opt.performanceStats) return;
        q.end();
        this._queues.notify(q);
    };
    return Queues;
}();

},{"promise-polyfill":"h2t0f","./jsonify_notice":"gkQv3","./scope":"ecK5Z","./processor/esp":"6VZw4","./filter/angular_message":"7E9Vw","./filter/debounce":"4iPlx","./filter/ignore_noise":"gcm5E","./filter/uncaught_message":"dQzee","./http_req":"iSmNh","./queries":"lcUNg","./queues":"cG3Gj","./routes":"40G78","./version":"dSb92","./remote_settings":"2o528","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gkQv3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// jsonifyNotice serializes notice to JSON and truncates params,
// environment and session keys.
parcelHelpers.export(exports, "jsonifyNotice", ()=>jsonifyNotice);
parcelHelpers.export(exports, "truncate", ()=>truncate);
var FILTERED = "[Filtered]";
var MAX_OBJ_LENGTH = 128;
function jsonifyNotice(notice, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.maxLength, maxLength = _c === void 0 ? 64000 : _c, _d = _b.keysBlocklist, keysBlocklist = _d === void 0 ? [] : _d;
    if (notice.errors) for(var i = 0; i < notice.errors.length; i++){
        var t = new Truncator({
            keysBlocklist: keysBlocklist
        });
        notice.errors[i] = t.truncate(notice.errors[i]);
    }
    var s = "";
    var keys = [
        "params",
        "environment",
        "session"
    ];
    for(var level = 0; level < 8; level++){
        var opts = {
            level: level,
            keysBlocklist: keysBlocklist
        };
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            var obj = notice[key];
            if (obj) notice[key] = truncate(obj, opts);
        }
        s = JSON.stringify(notice);
        if (s.length < maxLength) return s;
    }
    var params = {
        json: s.slice(0, Math.floor(maxLength / 2)) + "..."
    };
    keys.push("errors");
    for(var _e = 0, keys_2 = keys; _e < keys_2.length; _e++){
        var key = keys_2[_e];
        var obj = notice[key];
        if (!obj) continue;
        s = JSON.stringify(obj);
        params[key] = s.length;
    }
    var err = new Error("airbrake: notice exceeds max length and can't be truncated");
    err.params = params;
    throw err;
}
function scale(num, level) {
    return num >> level || 1;
}
var Truncator = /** @class */ function() {
    function Truncator(opts) {
        this.maxStringLength = 1024;
        this.maxObjectLength = MAX_OBJ_LENGTH;
        this.maxArrayLength = MAX_OBJ_LENGTH;
        this.maxDepth = 8;
        this.keys = [];
        this.keysBlocklist = [];
        this.seen = [];
        var level = opts.level || 0;
        this.keysBlocklist = opts.keysBlocklist || [];
        this.maxStringLength = scale(this.maxStringLength, level);
        this.maxObjectLength = scale(this.maxObjectLength, level);
        this.maxArrayLength = scale(this.maxArrayLength, level);
        this.maxDepth = scale(this.maxDepth, level);
    }
    Truncator.prototype.truncate = function(value, key, depth) {
        if (key === void 0) key = "";
        if (depth === void 0) depth = 0;
        if (value === null || value === undefined) return value;
        switch(typeof value){
            case "boolean":
            case "number":
            case "function":
                return value;
            case "string":
                return this.truncateString(value);
            case "object":
                break;
            default:
                return this.truncateString(String(value));
        }
        if (value instanceof String) return this.truncateString(value.toString());
        if (value instanceof Boolean || value instanceof Number || value instanceof Date || value instanceof RegExp) return value;
        if (value instanceof Error) return this.truncateString(value.toString());
        if (this.seen.indexOf(value) >= 0) return "[Circular ".concat(this.getPath(value), "]");
        var type = objectType(value);
        depth++;
        if (depth > this.maxDepth) return "[Truncated ".concat(type, "]");
        this.keys.push(key);
        this.seen.push(value);
        switch(type){
            case "Array":
                return this.truncateArray(value, depth);
            case "Object":
                return this.truncateObject(value, depth);
            default:
                var saved = this.maxDepth;
                this.maxDepth = 0;
                var obj = this.truncateObject(value, depth);
                obj.__type = type;
                this.maxDepth = saved;
                return obj;
        }
    };
    Truncator.prototype.getPath = function(value) {
        var index = this.seen.indexOf(value);
        var path = [
            this.keys[index]
        ];
        for(var i = index; i >= 0; i--){
            var sub = this.seen[i];
            if (sub && getAttr(sub, path[0]) === value) {
                value = sub;
                path.unshift(this.keys[i]);
            }
        }
        return "~" + path.join(".");
    };
    Truncator.prototype.truncateString = function(s) {
        if (s.length > this.maxStringLength) return s.slice(0, this.maxStringLength) + "...";
        return s;
    };
    Truncator.prototype.truncateArray = function(arr, depth) {
        if (depth === void 0) depth = 0;
        var length = 0;
        var dst = [];
        for(var i = 0; i < arr.length; i++){
            var el = arr[i];
            dst.push(this.truncate(el, i.toString(), depth));
            length++;
            if (length >= this.maxArrayLength) break;
        }
        return dst;
    };
    Truncator.prototype.truncateObject = function(obj, depth) {
        if (depth === void 0) depth = 0;
        var length = 0;
        var dst = {};
        for(var key in obj){
            if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
            if (isBlocklisted(key, this.keysBlocklist)) {
                dst[key] = FILTERED;
                continue;
            }
            var value = getAttr(obj, key);
            if (value === undefined || typeof value === "function") continue;
            dst[key] = this.truncate(value, key, depth);
            length++;
            if (length >= this.maxObjectLength) break;
        }
        return dst;
    };
    return Truncator;
}();
function truncate(value, opts) {
    if (opts === void 0) opts = {};
    var t = new Truncator(opts);
    return t.truncate(value);
}
function getAttr(obj, attr) {
    // Ignore browser specific exception trying to read an attribute (#79).
    try {
        return obj[attr];
    } catch (_) {
        return;
    }
}
function objectType(obj) {
    var s = Object.prototype.toString.apply(obj);
    return s.slice(8, -1);
}
function isBlocklisted(key, keysBlocklist) {
    for(var _i = 0, keysBlocklist_1 = keysBlocklist; _i < keysBlocklist_1.length; _i++){
        var v = keysBlocklist_1[_i];
        if (v === key) return true;
        if (v instanceof RegExp) {
            if (key.match(v)) return true;
        }
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ecK5Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scope", ()=>Scope);
var _metrics = require("./metrics");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Scope = /** @class */ function() {
    function Scope() {
        this._noopMetric = new (0, _metrics.NoopMetric)();
        this._context = {};
        this._historyMaxLen = 20;
        this._history = [];
    }
    Scope.prototype.clone = function() {
        var clone = new Scope();
        clone._context = __assign({}, this._context);
        clone._history = this._history.slice();
        return clone;
    };
    Scope.prototype.setContext = function(context) {
        this._context = __assign(__assign({}, this._context), context);
    };
    Scope.prototype.context = function() {
        var ctx = __assign({}, this._context);
        if (this._history.length > 0) ctx.history = this._history.slice();
        return ctx;
    };
    Scope.prototype.pushHistory = function(state) {
        if (this._isDupState(state)) {
            if (this._lastRecord.num) this._lastRecord.num++;
            else this._lastRecord.num = 2;
            return;
        }
        if (!state.date) state.date = new Date();
        this._history.push(state);
        this._lastRecord = state;
        if (this._history.length > this._historyMaxLen) this._history = this._history.slice(-this._historyMaxLen);
    };
    Scope.prototype._isDupState = function(state) {
        if (!this._lastRecord) return false;
        for(var key in state){
            if (!state.hasOwnProperty(key) || key === "date") continue;
            if (state[key] !== this._lastRecord[key]) return false;
        }
        return true;
    };
    Scope.prototype.routeMetric = function() {
        return this._routeMetric || this._noopMetric;
    };
    Scope.prototype.setRouteMetric = function(metric) {
        this._routeMetric = metric;
    };
    Scope.prototype.queueMetric = function() {
        return this._queueMetric || this._noopMetric;
    };
    Scope.prototype.setQueueMetric = function(metric) {
        this._queueMetric = metric;
    };
    return Scope;
}();

},{"./metrics":"OnGyW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"OnGyW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Span", ()=>Span);
parcelHelpers.export(exports, "BaseMetric", ()=>BaseMetric);
parcelHelpers.export(exports, "NoopMetric", ()=>NoopMetric);
var Span = /** @class */ function() {
    function Span(metric, name, startTime) {
        this._dur = 0;
        this._level = 0;
        this._metric = metric;
        this.name = name;
        this.startTime = startTime || new Date();
    }
    Span.prototype.end = function(endTime) {
        this.endTime = endTime ? endTime : new Date();
        this._dur += this.endTime.getTime() - this.startTime.getTime();
        this._metric._incGroup(this.name, this._dur);
        this._metric = null;
    };
    Span.prototype._pause = function() {
        if (this._paused()) return;
        var now = new Date();
        this._dur += now.getTime() - this.startTime.getTime();
        this.startTime = null;
    };
    Span.prototype._resume = function() {
        if (!this._paused()) return;
        this.startTime = new Date();
    };
    Span.prototype._paused = function() {
        return this.startTime == null;
    };
    return Span;
}();
var BaseMetric = /** @class */ function() {
    function BaseMetric() {
        this._spans = {};
        this._groups = {};
        this.startTime = new Date();
    }
    BaseMetric.prototype.end = function(endTime) {
        if (!this.endTime) this.endTime = endTime || new Date();
    };
    BaseMetric.prototype.isRecording = function() {
        return true;
    };
    BaseMetric.prototype.startSpan = function(name, startTime) {
        var span = this._spans[name];
        if (span) span._level++;
        else {
            span = new Span(this, name, startTime);
            this._spans[name] = span;
        }
    };
    BaseMetric.prototype.endSpan = function(name, endTime) {
        var span = this._spans[name];
        if (!span) {
            console.error("airbrake: span=%s does not exist", name);
            return;
        }
        if (span._level > 0) span._level--;
        else {
            span.end(endTime);
            delete this._spans[span.name];
        }
    };
    BaseMetric.prototype._incGroup = function(name, ms) {
        this._groups[name] = (this._groups[name] || 0) + ms;
    };
    BaseMetric.prototype._duration = function() {
        if (!this.endTime) this.endTime = new Date();
        return this.endTime.getTime() - this.startTime.getTime();
    };
    return BaseMetric;
}();
var NoopMetric = /** @class */ function() {
    function NoopMetric() {}
    NoopMetric.prototype.isRecording = function() {
        return false;
    };
    NoopMetric.prototype.startSpan = function(_name, _startTime) {};
    NoopMetric.prototype.endSpan = function(_name, _startTime) {};
    NoopMetric.prototype._incGroup = function(_name, _ms) {};
    return NoopMetric;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6VZw4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "espProcessor", ()=>espProcessor);
var _errorStackParser = require("error-stack-parser");
var _errorStackParserDefault = parcelHelpers.interopDefault(_errorStackParser);
var hasConsole = typeof console === "object" && console.warn;
function parse(err) {
    try {
        return (0, _errorStackParserDefault.default).parse(err);
    } catch (parseErr) {
        if (hasConsole && err.stack) console.warn("ErrorStackParser:", parseErr.toString(), err.stack);
    }
    if (err.fileName) return [
        err
    ];
    return [];
}
function espProcessor(err) {
    var backtrace = [];
    if (err.noStack) backtrace.push({
        function: err.functionName || "",
        file: err.fileName || "",
        line: err.lineNumber || 0,
        column: err.columnNumber || 0
    });
    else {
        var frames_2 = parse(err);
        if (frames_2.length === 0) try {
            throw new Error("fake");
        } catch (fakeErr) {
            frames_2 = parse(fakeErr);
            frames_2.shift();
            frames_2.shift();
        }
        for(var _i = 0, frames_1 = frames_2; _i < frames_1.length; _i++){
            var frame = frames_1[_i];
            backtrace.push({
                function: frame.functionName || "",
                file: frame.fileName || "",
                line: frame.lineNumber || 0,
                column: frame.columnNumber || 0
            });
        }
    }
    var type = err.name ? err.name : "";
    var msg = err.message ? String(err.message) : String(err);
    return {
        type: type,
        message: msg,
        backtrace: backtrace
    };
}

},{"error-stack-parser":"6uwcG","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6uwcG":[function(require,module,exports) {
(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("error-stack-parser", [
        "stackframe"
    ], factory);
    else module.exports = factory(require("50a0e74cd31b7b9f"));
})(this, function ErrorStackParser(StackFrame) {
    "use strict";
    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */ parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
            else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
            else if (error.stack) return this.parseFFOrSafari(error);
            else throw new Error("Cannot parse given Error object");
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(":") === -1) return [
                urlLike
            ];
            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ""));
            return [
                parts[1],
                parts[2] || undefined,
                parts[3] || undefined
            ];
        },
        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);
            return filtered.map(function(line) {
                if (line.indexOf("(eval ") > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, "");
                var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, "");
                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\(.+\)$)/);
                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
                // if a location was matched, pass it to extractLocation() otherwise pass all sanitizedLine
                // because this line doesn't have function name
                var locationParts = this.extractLocation(location ? location[1] : sanitizedLine);
                var functionName = location && sanitizedLine || undefined;
                var fileName = [
                    "eval",
                    "<anonymous>"
                ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },
        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);
            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1");
                if (line.indexOf("@") === -1 && line.indexOf(":") === -1) // Safari eval frames only have function names and nothing else
                return new StackFrame({
                    functionName: line
                });
                else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },
        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
            else if (!e.stack) return this.parseOpera10(e);
            else return this.parseOpera11(e);
        },
        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split("\n");
            var result = [];
            for(var i = 2, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split("\n");
            var result = [];
            for(var i = 0, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    functionName: match[3] || undefined,
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);
            return filtered.map(function(line) {
                var tokens = line.split("@");
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = tokens.shift() || "";
                var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, "$1");
                var args = argsRaw === undefined || argsRaw === "[arguments not available]" ? undefined : argsRaw.split(",");
                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
});

},{"50a0e74cd31b7b9f":"ioIlf"}],"ioIlf":[function(require,module,exports) {
(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stackframe", [], factory);
    else module.exports = factory();
})(this, function() {
    "use strict";
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }
    function _getter(p) {
        return function() {
            return this[p];
        };
    }
    var booleanProps = [
        "isConstructor",
        "isEval",
        "isNative",
        "isToplevel"
    ];
    var numericProps = [
        "columnNumber",
        "lineNumber"
    ];
    var stringProps = [
        "fileName",
        "functionName",
        "source"
    ];
    var arrayProps = [
        "args"
    ];
    var objectProps = [
        "evalOrigin"
    ];
    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
    function StackFrame(obj) {
        if (!obj) return;
        for(var i = 0; i < props.length; i++)if (obj[props[i]] !== undefined) this["set" + _capitalize(props[i])](obj[props[i]]);
    }
    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== "[object Array]") throw new TypeError("Args must be an Array");
            this.args = v;
        },
        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) this.evalOrigin = v;
            else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
            else throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
            var fileName = this.getFileName() || "";
            var lineNumber = this.getLineNumber() || "";
            var columnNumber = this.getColumnNumber() || "";
            var functionName = this.getFunctionName() || "";
            if (this.getIsEval()) {
                if (fileName) return "[eval] (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
                return "[eval]:" + lineNumber + ":" + columnNumber;
            }
            if (functionName) return functionName + " (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
            return fileName + ":" + lineNumber + ":" + columnNumber;
        }
    };
    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf("(");
        var argsEndIndex = str.lastIndexOf(")");
        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(",");
        var locationString = str.substring(argsEndIndex + 1);
        if (locationString.indexOf("@") === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, "");
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }
        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };
    for(var i = 0; i < booleanProps.length; i++){
        StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype["set" + _capitalize(booleanProps[i])] = function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        }(booleanProps[i]);
    }
    for(var j = 0; j < numericProps.length; j++){
        StackFrame.prototype["get" + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype["set" + _capitalize(numericProps[j])] = function(p) {
            return function(v) {
                if (!_isNumber(v)) throw new TypeError(p + " must be a Number");
                this[p] = Number(v);
            };
        }(numericProps[j]);
    }
    for(var k = 0; k < stringProps.length; k++){
        StackFrame.prototype["get" + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype["set" + _capitalize(stringProps[k])] = function(p) {
            return function(v) {
                this[p] = String(v);
            };
        }(stringProps[k]);
    }
    return StackFrame;
});

},{}],"7E9Vw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "angularMessageFilter", ()=>angularMessageFilter);
var re = new RegExp([
    "^",
    "\\[(\\$.+)\\]",
    "\\s",
    "([\\s\\S]+)",
    "$"
].join(""));
function angularMessageFilter(notice) {
    var err = notice.errors[0];
    if (err.type !== "" && err.type !== "Error") return notice;
    var m = err.message.match(re);
    if (m !== null) {
        err.type = m[1];
        err.message = m[2];
    }
    return notice;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4iPlx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeDebounceFilter", ()=>makeDebounceFilter);
function makeDebounceFilter() {
    var lastNoticeJSON;
    var timeout;
    return function(notice) {
        var s = JSON.stringify(notice.errors);
        if (s === lastNoticeJSON) return null;
        if (timeout) clearTimeout(timeout);
        lastNoticeJSON = s;
        timeout = setTimeout(function() {
            lastNoticeJSON = "";
        }, 1000);
        return notice;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gcm5E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ignoreNoiseFilter", ()=>ignoreNoiseFilter);
var IGNORED_MESSAGES = [
    "Script error",
    "Script error.",
    "InvalidAccessError"
];
function ignoreNoiseFilter(notice) {
    var err = notice.errors[0];
    if (err.type === "" && IGNORED_MESSAGES.indexOf(err.message) !== -1) return null;
    if (err.backtrace && err.backtrace.length > 0) {
        var frame = err.backtrace[0];
        if (frame.file === "<anonymous>") return null;
    }
    return notice;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dQzee":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uncaughtMessageFilter", ()=>uncaughtMessageFilter);
var re = new RegExp([
    "^",
    "Uncaught\\s",
    "(.+?)",
    ":\\s",
    "(.+)",
    "$"
].join(""));
function uncaughtMessageFilter(notice) {
    var err = notice.errors[0];
    if (err.type !== "" && err.type !== "Error") return notice;
    var m = err.message.match(re);
    if (m !== null) {
        err.type = m[1];
        err.message = m[2];
    }
    return notice;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iSmNh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeRequester", ()=>makeRequester);
var _fetch = require("./fetch");
var _node = require("./node");
function makeRequester(opts) {
    if (opts.request) return (0, _node.makeRequester)(opts.request);
    return 0, _fetch.request;
}

},{"./fetch":"E2VDu","./node":"lGIsj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"E2VDu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "request", ()=>request);
var _crossFetch = require("cross-fetch");
var _crossFetchDefault = parcelHelpers.interopDefault(_crossFetch);
var _promisePolyfill = require("promise-polyfill");
var _promisePolyfillDefault = parcelHelpers.interopDefault(_promisePolyfill);
var _api = require("./api");
var rateLimitReset = 0;
function request(req) {
    var utime = Date.now() / 1000;
    if (utime < rateLimitReset) return (0, _promisePolyfillDefault.default).reject((0, _api.errors).ipRateLimited);
    var opt = {
        method: req.method,
        body: req.body,
        headers: req.headers
    };
    return (0, _crossFetchDefault.default)(req.url, opt).then(function(resp) {
        if (resp.status === 401) throw (0, _api.errors).unauthorized;
        if (resp.status === 429) {
            var s = resp.headers.get("X-RateLimit-Delay");
            if (!s) throw (0, _api.errors).ipRateLimited;
            var n = parseInt(s, 10);
            if (n > 0) rateLimitReset = Date.now() / 1000 + n;
            throw (0, _api.errors).ipRateLimited;
        }
        if (resp.status === 204) return {
            json: null
        };
        if (resp.status === 404) throw new Error("404 Not Found");
        if (resp.status >= 200 && resp.status < 300) return resp.json().then(function(json) {
            return {
                json: json
            };
        });
        if (resp.status >= 400 && resp.status < 500) return resp.json().then(function(json) {
            var err = new Error(json.message);
            throw err;
        });
        return resp.text().then(function(body) {
            var err = new Error("airbrake: fetch: unexpected response: code=".concat(resp.status, " body='").concat(body, "'"));
            throw err;
        });
    });
}

},{"cross-fetch":"er2sO","promise-polyfill":"h2t0f","./api":"lcFs0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lcFs0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errors", ()=>errors);
var errors = {
    unauthorized: new Error("airbrake: unauthorized: project id or key are wrong"),
    ipRateLimited: new Error("airbrake: IP is rate limited")
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lGIsj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeRequester", ()=>makeRequester);
var _promisePolyfill = require("promise-polyfill");
var _promisePolyfillDefault = parcelHelpers.interopDefault(_promisePolyfill);
var _api = require("./api");
function makeRequester(api) {
    return function(req) {
        return request(req, api);
    };
}
var rateLimitReset = 0;
function request(req, api) {
    var utime = Date.now() / 1000;
    if (utime < rateLimitReset) return (0, _promisePolyfillDefault.default).reject((0, _api.errors).ipRateLimited);
    return new (0, _promisePolyfillDefault.default)(function(resolve, reject) {
        api({
            url: req.url,
            method: req.method,
            body: req.body,
            headers: {
                "content-type": "application/json"
            },
            timeout: req.timeout
        }, function(error, resp, body) {
            if (error) {
                reject(error);
                return;
            }
            if (!resp.statusCode) {
                error = new Error("airbrake: request: response statusCode is ".concat(resp.statusCode));
                reject(error);
                return;
            }
            if (resp.statusCode === 401) {
                reject((0, _api.errors).unauthorized);
                return;
            }
            if (resp.statusCode === 429) {
                reject((0, _api.errors).ipRateLimited);
                var h = resp.headers["x-ratelimit-delay"];
                if (!h) return;
                var s = void 0;
                if (typeof h === "string") s = h;
                else if (h instanceof Array) s = h[0];
                else return;
                var n = parseInt(s, 10);
                if (n > 0) rateLimitReset = Date.now() / 1000 + n;
                return;
            }
            if (resp.statusCode === 204) {
                resolve({
                    json: null
                });
                return;
            }
            if (resp.statusCode >= 200 && resp.statusCode < 300) {
                var json = void 0;
                try {
                    json = JSON.parse(body);
                } catch (err) {
                    reject(err);
                    return;
                }
                resolve(json);
                return;
            }
            if (resp.statusCode >= 400 && resp.statusCode < 500) {
                var json = void 0;
                try {
                    json = JSON.parse(body);
                } catch (err) {
                    reject(err);
                    return;
                }
                error = new Error(json.message);
                reject(error);
                return;
            }
            body = body.trim();
            error = new Error("airbrake: node: unexpected response: code=".concat(resp.statusCode, " body='").concat(body, "'"));
            reject(error);
        });
    });
}

},{"promise-polyfill":"h2t0f","./api":"lcFs0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lcUNg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryInfo", ()=>QueryInfo);
parcelHelpers.export(exports, "QueriesStats", ()=>QueriesStats);
var _httpReq = require("./http_req");
var _tdshared = require("./tdshared");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var FLUSH_INTERVAL = 15000; // 15 seconds
var QueryInfo = /** @class */ function() {
    function QueryInfo(query) {
        if (query === void 0) query = "";
        this.method = "";
        this.route = "";
        this.query = "";
        this.func = "";
        this.file = "";
        this.line = 0;
        this.startTime = new Date();
        this.query = query;
    }
    QueryInfo.prototype._duration = function() {
        if (!this.endTime) this.endTime = new Date();
        return this.endTime.getTime() - this.startTime.getTime();
    };
    return QueryInfo;
}();
var QueriesStats = /** @class */ function() {
    function QueriesStats(opt) {
        this._m = {};
        this._opt = opt;
        this._url = "".concat(opt.host, "/api/v5/projects/").concat(opt.projectId, "/queries-stats?key=").concat(opt.projectKey);
        this._requester = (0, _httpReq.makeRequester)(opt);
    }
    QueriesStats.prototype.start = function(query) {
        if (query === void 0) query = "";
        return new QueryInfo(query);
    };
    QueriesStats.prototype.notify = function(q) {
        var _this = this;
        if (!(0, _tdshared.hasTdigest)) return;
        if (!this._opt.performanceStats) return;
        if (!this._opt.queryStats) return;
        var ms = q._duration();
        var minute = 60000;
        var startTime = new Date(Math.floor(q.startTime.getTime() / minute) * minute);
        var key = {
            method: q.method,
            route: q.route,
            query: q.query,
            func: q.func,
            file: q.file,
            line: q.line,
            time: startTime
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new (0, _tdshared.TDigestStat)();
            this._m[keyStr] = stat;
        }
        stat.add(ms);
        if (this._timer) return;
        this._timer = setTimeout(function() {
            _this._flush();
        }, FLUSH_INTERVAL);
    };
    QueriesStats.prototype._flush = function() {
        var queries = [];
        for(var keyStr in this._m){
            if (!this._m.hasOwnProperty(keyStr)) continue;
            var key = JSON.parse(keyStr);
            var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
            queries.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            queries: queries
        });
        var req = {
            method: "POST",
            url: this._url,
            body: outJSON
        };
        this._requester(req).then(function(_resp) {
        // nothing
        }).catch(function(err) {
            if (console.error) console.error("can not report queries stats", err);
        });
    };
    return QueriesStats;
}();

},{"./http_req":"iSmNh","./tdshared":"gRwew","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gRwew":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasTdigest", ()=>hasTdigest);
parcelHelpers.export(exports, "TDigestStat", ()=>TDigestStat);
parcelHelpers.export(exports, "TDigestStatGroups", ()=>TDigestStatGroups);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var tdigest;
var hasTdigest = false;
try {
    tdigest = require("670940a545b1c57a");
    hasTdigest = true;
} catch (err) {}
var TDigestStat = /** @class */ function() {
    function TDigestStat() {
        this.count = 0;
        this.sum = 0;
        this.sumsq = 0;
        this._td = new tdigest.Digest();
    }
    TDigestStat.prototype.add = function(ms) {
        if (ms === 0) ms = 0.00001;
        this.count += 1;
        this.sum += ms;
        this.sumsq += ms * ms;
        if (this._td) this._td.push(ms);
    };
    TDigestStat.prototype.toJSON = function() {
        return {
            count: this.count,
            sum: this.sum,
            sumsq: this.sumsq,
            tdigestCentroids: tdigestCentroids(this._td)
        };
    };
    return TDigestStat;
}();
var TDigestStatGroups = /** @class */ function(_super) {
    __extends(TDigestStatGroups, _super);
    function TDigestStatGroups() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.groups = {};
        return _this;
    }
    TDigestStatGroups.prototype.addGroups = function(totalMs, groups) {
        this.add(totalMs);
        for(var name_1 in groups)if (groups.hasOwnProperty(name_1)) this.addGroup(name_1, groups[name_1]);
    };
    TDigestStatGroups.prototype.addGroup = function(name, ms) {
        var stat = this.groups[name];
        if (!stat) {
            stat = new TDigestStat();
            this.groups[name] = stat;
        }
        stat.add(ms);
    };
    TDigestStatGroups.prototype.toJSON = function() {
        return {
            count: this.count,
            sum: this.sum,
            sumsq: this.sumsq,
            tdigestCentroids: tdigestCentroids(this._td),
            groups: this.groups
        };
    };
    return TDigestStatGroups;
}(TDigestStat);
function tdigestCentroids(td) {
    var means = [];
    var counts = [];
    td.centroids.each(function(c) {
        means.push(c.mean);
        counts.push(c.n);
    });
    return {
        mean: means,
        count: counts
    };
}

},{"670940a545b1c57a":"76H0g","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"76H0g":[function(require,module,exports) {
//
// TDigest:
//
// approximate distribution percentiles from a stream of reals
//
var RBTree = require("8928cb4425bcfbb5").RBTree;
function TDigest(delta, K, CX) {
    // allocate a TDigest structure.
    //
    // delta is the compression factor, the max fraction of mass that
    // can be owned by one centroid (bigger, up to 1.0, means more
    // compression). delta=false switches off TDigest behavior and treats
    // the distribution as discrete, with no merging and exact values
    // reported.
    //
    // K is a size threshold that triggers recompression as the TDigest
    // grows during input.  (Set it to 0 to disable automatic recompression)
    //
    // CX specifies how often to update cached cumulative totals used
    // for quantile estimation during ingest (see cumulate()).  Set to
    // 0 to use exact quantiles for each new point.
    //
    this.discrete = delta === false;
    this.delta = delta || 0.01;
    this.K = K === undefined ? 25 : K;
    this.CX = CX === undefined ? 1.1 : CX;
    this.centroids = new RBTree(compare_centroid_means);
    this.nreset = 0;
    this.reset();
}
TDigest.prototype.reset = function() {
    // prepare to digest new points.
    //
    this.centroids.clear();
    this.n = 0;
    this.nreset += 1;
    this.last_cumulate = 0;
};
TDigest.prototype.size = function() {
    return this.centroids.size;
};
TDigest.prototype.toArray = function(everything) {
    // return {mean,n} of centroids as an array ordered by mean.
    //
    var result = [];
    if (everything) {
        this._cumulate(true); // be sure cumns are exact
        this.centroids.each(function(c) {
            result.push(c);
        });
    } else this.centroids.each(function(c) {
        result.push({
            mean: c.mean,
            n: c.n
        });
    });
    return result;
};
TDigest.prototype.summary = function() {
    var approx = this.discrete ? "exact " : "approximating ";
    var s = [
        approx + this.n + " samples using " + this.size() + " centroids",
        "min = " + this.percentile(0),
        "Q1  = " + this.percentile(0.25),
        "Q2  = " + this.percentile(0.5),
        "Q3  = " + this.percentile(0.75),
        "max = " + this.percentile(1.0)
    ];
    return s.join("\n");
};
function compare_centroid_means(a, b) {
    // order two centroids by mean.
    //
    return a.mean > b.mean ? 1 : a.mean < b.mean ? -1 : 0;
}
function compare_centroid_mean_cumns(a, b) {
    // order two centroids by mean_cumn.
    //
    return a.mean_cumn - b.mean_cumn;
}
TDigest.prototype.push = function(x, n) {
    // incorporate value or array of values x, having count n into the
    // TDigest. n defaults to 1.
    //
    n = n || 1;
    x = Array.isArray(x) ? x : [
        x
    ];
    for(var i = 0; i < x.length; i++)this._digest(x[i], n);
};
TDigest.prototype.push_centroid = function(c) {
    // incorporate centroid or array of centroids c
    //
    c = Array.isArray(c) ? c : [
        c
    ];
    for(var i = 0; i < c.length; i++)this._digest(c[i].mean, c[i].n);
};
TDigest.prototype._cumulate = function(exact) {
    // update cumulative counts for each centroid
    //
    // exact: falsey means only cumulate after sufficient
    // growth. During ingest, these counts are used as quantile
    // estimates, and they work well even when somewhat out of
    // date. (this is a departure from the publication, you may set CX
    // to 0 to disable).
    //
    if (this.n === this.last_cumulate || !exact && this.CX && this.CX > this.n / this.last_cumulate) return;
    var cumn = 0;
    this.centroids.each(function(c) {
        c.mean_cumn = cumn + c.n / 2; // half of n at the mean
        cumn = c.cumn = cumn + c.n;
    });
    this.n = this.last_cumulate = cumn;
};
TDigest.prototype.find_nearest = function(x) {
    // find the centroid closest to x. The assumption of
    // unique means and a unique nearest centroid departs from the
    // paper, see _digest() below
    //
    if (this.size() === 0) return null;
    var iter = this.centroids.lowerBound({
        mean: x
    }); // x <= iter || iter==null
    var c = iter.data() === null ? iter.prev() : iter.data();
    if (c.mean === x || this.discrete) return c; // c is either x or a neighbor (discrete: no distance func)
    var prev = iter.prev();
    if (prev && Math.abs(prev.mean - x) < Math.abs(c.mean - x)) return prev;
    else return c;
};
TDigest.prototype._new_centroid = function(x, n, cumn) {
    // create and insert a new centroid into the digest (don't update
    // cumulatives).
    //
    var c = {
        mean: x,
        n: n,
        cumn: cumn
    };
    this.centroids.insert(c);
    this.n += n;
    return c;
};
TDigest.prototype._addweight = function(nearest, x, n) {
    // add weight at location x to nearest centroid.  adding x to
    // nearest will not shift its relative position in the tree and
    // require reinsertion.
    //
    if (x !== nearest.mean) nearest.mean += n * (x - nearest.mean) / (nearest.n + n);
    nearest.cumn += n;
    nearest.mean_cumn += n / 2;
    nearest.n += n;
    this.n += n;
};
TDigest.prototype._digest = function(x, n) {
    // incorporate value x, having count n into the TDigest.
    //
    var min = this.centroids.min();
    var max = this.centroids.max();
    var nearest = this.find_nearest(x);
    if (nearest && nearest.mean === x) // accumulate exact matches into the centroid without
    // limit. this is a departure from the paper, made so
    // centroids remain unique and code can be simple.
    this._addweight(nearest, x, n);
    else if (nearest === min) this._new_centroid(x, n, 0); // new point around min boundary
    else if (nearest === max) this._new_centroid(x, n, this.n); // new point around max boundary
    else if (this.discrete) this._new_centroid(x, n, nearest.cumn); // never merge
    else {
        // conider a merge based on nearest centroid's capacity. if
        // there's not room for all of n, don't bother merging any of
        // it into nearest, as we'll have to make a new centroid
        // anyway for the remainder (departure from the paper).
        var p = nearest.mean_cumn / this.n;
        var max_n = Math.floor(4 * this.n * this.delta * p * (1 - p));
        if (max_n - nearest.n >= n) this._addweight(nearest, x, n);
        else this._new_centroid(x, n, nearest.cumn);
    }
    this._cumulate(false);
    if (!this.discrete && this.K && this.size() > this.K / this.delta) // re-process the centroids and hope for some compression.
    this.compress();
};
TDigest.prototype.bound_mean = function(x) {
    // find centroids lower and upper such that lower.mean < x <
    // upper.mean or lower.mean === x === upper.mean. Don't call
    // this for x out of bounds.
    //
    var iter = this.centroids.upperBound({
        mean: x
    }); // x < iter
    var lower = iter.prev(); // lower <= x
    var upper = lower.mean === x ? lower : iter.next();
    return [
        lower,
        upper
    ];
};
TDigest.prototype.p_rank = function(x_or_xlist) {
    // return approximate percentile-ranks (0..1) for data value x.
    // or list of x.  calculated according to
    // https://en.wikipedia.org/wiki/Percentile_rank
    //
    // (Note that in continuous mode, boundary sample values will
    // report half their centroid weight inward from 0/1 as the
    // percentile-rank. X values outside the observed range return
    // 0/1)
    //
    // this triggers cumulate() if cumn's are out of date.
    //
    var xs = Array.isArray(x_or_xlist) ? x_or_xlist : [
        x_or_xlist
    ];
    var ps = xs.map(this._p_rank, this);
    return Array.isArray(x_or_xlist) ? ps : ps[0];
};
TDigest.prototype._p_rank = function(x) {
    if (this.size() === 0) return undefined;
    else if (x < this.centroids.min().mean) return 0.0;
    else if (x > this.centroids.max().mean) return 1.0;
    // find centroids that bracket x and interpolate x's cumn from
    // their cumn's.
    this._cumulate(true); // be sure cumns are exact
    var bound = this.bound_mean(x);
    var lower = bound[0], upper = bound[1];
    if (this.discrete) return lower.cumn / this.n;
    else {
        var cumn = lower.mean_cumn;
        if (lower !== upper) cumn += (x - lower.mean) * (upper.mean_cumn - lower.mean_cumn) / (upper.mean - lower.mean);
        return cumn / this.n;
    }
};
TDigest.prototype.bound_mean_cumn = function(cumn) {
    // find centroids lower and upper such that lower.mean_cumn < x <
    // upper.mean_cumn or lower.mean_cumn === x === upper.mean_cumn. Don't call
    // this for cumn out of bounds.
    //
    // XXX because mean and mean_cumn give rise to the same sort order
    // (up to identical means), use the mean rbtree for our search.
    this.centroids._comparator = compare_centroid_mean_cumns;
    var iter = this.centroids.upperBound({
        mean_cumn: cumn
    }); // cumn < iter
    this.centroids._comparator = compare_centroid_means;
    var lower = iter.prev(); // lower <= cumn
    var upper = lower && lower.mean_cumn === cumn ? lower : iter.next();
    return [
        lower,
        upper
    ];
};
TDigest.prototype.percentile = function(p_or_plist) {
    // for percentage p (0..1), or for each p in a list of ps, return
    // the smallest data value q at which at least p percent of the
    // observations <= q.
    //
    // for discrete distributions, this selects q using the Nearest
    // Rank Method
    // (https://en.wikipedia.org/wiki/Percentile#The_Nearest_Rank_method)
    // (in scipy, same as percentile(...., interpolation='higher')
    //
    // for continuous distributions, interpolates data values between
    // count-weighted bracketing means.
    //
    // this triggers cumulate() if cumn's are out of date.
    //
    var ps = Array.isArray(p_or_plist) ? p_or_plist : [
        p_or_plist
    ];
    var qs = ps.map(this._percentile, this);
    return Array.isArray(p_or_plist) ? qs : qs[0];
};
TDigest.prototype._percentile = function(p) {
    if (this.size() === 0) return undefined;
    this._cumulate(true); // be sure cumns are exact
    var h = this.n * p;
    var bound = this.bound_mean_cumn(h);
    var lower = bound[0], upper = bound[1];
    if (upper === lower || lower === null || upper === null) return (lower || upper).mean;
    else if (!this.discrete) return lower.mean + (h - lower.mean_cumn) * (upper.mean - lower.mean) / (upper.mean_cumn - lower.mean_cumn);
    else if (h <= lower.cumn) return lower.mean;
    else return upper.mean;
};
function pop_random(choices) {
    // remove and return an item randomly chosen from the array of choices
    // (mutates choices)
    //
    var idx = Math.floor(Math.random() * choices.length);
    return choices.splice(idx, 1)[0];
}
TDigest.prototype.compress = function() {
    // TDigests experience worst case compression (none) when input
    // increases monotonically.  Improve on any bad luck by
    // reconsuming digest centroids as if they were weighted points
    // while shuffling their order (and hope for the best).
    //
    if (this.compressing) return;
    var points = this.toArray();
    this.reset();
    this.compressing = true;
    while(points.length > 0)this.push_centroid(pop_random(points));
    this._cumulate(true);
    this.compressing = false;
};
function Digest(config) {
    // allocate a distribution digest structure. This is an extension
    // of a TDigest structure that starts in exact histogram (discrete)
    // mode, and automatically switches to TDigest mode for large
    // samples that appear to be from a continuous distribution.
    //
    this.config = config || {};
    this.mode = this.config.mode || "auto"; // disc, cont, auto
    TDigest.call(this, this.mode === "cont" ? config.delta : false);
    this.digest_ratio = this.config.ratio || 0.9;
    this.digest_thresh = this.config.thresh || 1000;
    this.n_unique = 0;
}
Digest.prototype = Object.create(TDigest.prototype);
Digest.prototype.constructor = Digest;
Digest.prototype.push = function(x_or_xlist) {
    TDigest.prototype.push.call(this, x_or_xlist);
    this.check_continuous();
};
Digest.prototype._new_centroid = function(x, n, cumn) {
    this.n_unique += 1;
    TDigest.prototype._new_centroid.call(this, x, n, cumn);
};
Digest.prototype._addweight = function(nearest, x, n) {
    if (nearest.n === 1) this.n_unique -= 1;
    TDigest.prototype._addweight.call(this, nearest, x, n);
};
Digest.prototype.check_continuous = function() {
    // while in 'auto' mode, if there are many unique elements, assume
    // they are from a continuous distribution and switch to 'cont'
    // mode (tdigest behavior). Return true on transition from
    // disctete to continuous.
    if (this.mode !== "auto" || this.size() < this.digest_thresh) return false;
    if (this.n_unique / this.size() > this.digest_ratio) {
        this.mode = "cont";
        this.discrete = false;
        this.delta = this.config.delta || 0.01;
        this.compress();
        return true;
    }
    return false;
};
module.exports = {
    "TDigest": TDigest,
    "Digest": Digest
};

},{"8928cb4425bcfbb5":"gSHee"}],"gSHee":[function(require,module,exports) {
module.exports = {
    RBTree: require("8080d36ef4e0c753"),
    BinTree: require("660c39756ec2ceb9")
};

},{"8080d36ef4e0c753":"8ZWxP","660c39756ec2ceb9":"1GUSf"}],"8ZWxP":[function(require,module,exports) {
var TreeBase = require("b9437def80af5441");
function Node(data) {
    this.data = data;
    this.left = null;
    this.right = null;
    this.red = true;
}
Node.prototype.get_child = function(dir) {
    return dir ? this.right : this.left;
};
Node.prototype.set_child = function(dir, val) {
    if (dir) this.right = val;
    else this.left = val;
};
function RBTree(comparator) {
    this._root = null;
    this._comparator = comparator;
    this.size = 0;
}
RBTree.prototype = new TreeBase();
// returns true if inserted, false if duplicate
RBTree.prototype.insert = function(data) {
    var ret = false;
    if (this._root === null) {
        // empty tree
        this._root = new Node(data);
        ret = true;
        this.size++;
    } else {
        var head = new Node(undefined); // fake tree root
        var dir = 0;
        var last = 0;
        // setup
        var gp = null; // grandparent
        var ggp = head; // grand-grand-parent
        var p = null; // parent
        var node = this._root;
        ggp.right = this._root;
        // search down
        while(true){
            if (node === null) {
                // insert new node at the bottom
                node = new Node(data);
                p.set_child(dir, node);
                ret = true;
                this.size++;
            } else if (is_red(node.left) && is_red(node.right)) {
                // color flip
                node.red = true;
                node.left.red = false;
                node.right.red = false;
            }
            // fix red violation
            if (is_red(node) && is_red(p)) {
                var dir2 = ggp.right === gp;
                if (node === p.get_child(last)) ggp.set_child(dir2, single_rotate(gp, !last));
                else ggp.set_child(dir2, double_rotate(gp, !last));
            }
            var cmp = this._comparator(node.data, data);
            // stop if found
            if (cmp === 0) break;
            last = dir;
            dir = cmp < 0;
            // update helpers
            if (gp !== null) ggp = gp;
            gp = p;
            p = node;
            node = node.get_child(dir);
        }
        // update root
        this._root = head.right;
    }
    // make root black
    this._root.red = false;
    return ret;
};
// returns true if removed, false if not found
RBTree.prototype.remove = function(data) {
    if (this._root === null) return false;
    var head = new Node(undefined); // fake tree root
    var node = head;
    node.right = this._root;
    var p = null; // parent
    var gp = null; // grand parent
    var found = null; // found item
    var dir = 1;
    while(node.get_child(dir) !== null){
        var last = dir;
        // update helpers
        gp = p;
        p = node;
        node = node.get_child(dir);
        var cmp = this._comparator(data, node.data);
        dir = cmp > 0;
        // save found node
        if (cmp === 0) found = node;
        // push the red node down
        if (!is_red(node) && !is_red(node.get_child(dir))) {
            if (is_red(node.get_child(!dir))) {
                var sr = single_rotate(node, dir);
                p.set_child(last, sr);
                p = sr;
            } else if (!is_red(node.get_child(!dir))) {
                var sibling = p.get_child(!last);
                if (sibling !== null) {
                    if (!is_red(sibling.get_child(!last)) && !is_red(sibling.get_child(last))) {
                        // color flip
                        p.red = false;
                        sibling.red = true;
                        node.red = true;
                    } else {
                        var dir2 = gp.right === p;
                        if (is_red(sibling.get_child(last))) gp.set_child(dir2, double_rotate(p, last));
                        else if (is_red(sibling.get_child(!last))) gp.set_child(dir2, single_rotate(p, last));
                        // ensure correct coloring
                        var gpc = gp.get_child(dir2);
                        gpc.red = true;
                        node.red = true;
                        gpc.left.red = false;
                        gpc.right.red = false;
                    }
                }
            }
        }
    }
    // replace and remove if found
    if (found !== null) {
        found.data = node.data;
        p.set_child(p.right === node, node.get_child(node.left === null));
        this.size--;
    }
    // update root and make it black
    this._root = head.right;
    if (this._root !== null) this._root.red = false;
    return found !== null;
};
function is_red(node) {
    return node !== null && node.red;
}
function single_rotate(root, dir) {
    var save = root.get_child(!dir);
    root.set_child(!dir, save.get_child(dir));
    save.set_child(dir, root);
    root.red = true;
    save.red = false;
    return save;
}
function double_rotate(root, dir) {
    root.set_child(!dir, single_rotate(root.get_child(!dir), !dir));
    return single_rotate(root, dir);
}
module.exports = RBTree;

},{"b9437def80af5441":"l4Jeo"}],"l4Jeo":[function(require,module,exports) {
function TreeBase() {}
// removes all nodes from the tree
TreeBase.prototype.clear = function() {
    this._root = null;
    this.size = 0;
};
// returns node data if found, null otherwise
TreeBase.prototype.find = function(data) {
    var res = this._root;
    while(res !== null){
        var c = this._comparator(data, res.data);
        if (c === 0) return res.data;
        else res = res.get_child(c > 0);
    }
    return null;
};
// returns iterator to node if found, null otherwise
TreeBase.prototype.findIter = function(data) {
    var res = this._root;
    var iter = this.iterator();
    while(res !== null){
        var c = this._comparator(data, res.data);
        if (c === 0) {
            iter._cursor = res;
            return iter;
        } else {
            iter._ancestors.push(res);
            res = res.get_child(c > 0);
        }
    }
    return null;
};
// Returns an iterator to the tree node at or immediately after the item
TreeBase.prototype.lowerBound = function(item) {
    var cur = this._root;
    var iter = this.iterator();
    var cmp = this._comparator;
    while(cur !== null){
        var c = cmp(item, cur.data);
        if (c === 0) {
            iter._cursor = cur;
            return iter;
        }
        iter._ancestors.push(cur);
        cur = cur.get_child(c > 0);
    }
    for(var i = iter._ancestors.length - 1; i >= 0; --i){
        cur = iter._ancestors[i];
        if (cmp(item, cur.data) < 0) {
            iter._cursor = cur;
            iter._ancestors.length = i;
            return iter;
        }
    }
    iter._ancestors.length = 0;
    return iter;
};
// Returns an iterator to the tree node immediately after the item
TreeBase.prototype.upperBound = function(item) {
    var iter = this.lowerBound(item);
    var cmp = this._comparator;
    while(iter.data() !== null && cmp(iter.data(), item) === 0)iter.next();
    return iter;
};
// returns null if tree is empty
TreeBase.prototype.min = function() {
    var res = this._root;
    if (res === null) return null;
    while(res.left !== null)res = res.left;
    return res.data;
};
// returns null if tree is empty
TreeBase.prototype.max = function() {
    var res = this._root;
    if (res === null) return null;
    while(res.right !== null)res = res.right;
    return res.data;
};
// returns a null iterator
// call next() or prev() to point to an element
TreeBase.prototype.iterator = function() {
    return new Iterator(this);
};
// calls cb on each node's data, in order
TreeBase.prototype.each = function(cb) {
    var it = this.iterator(), data;
    while((data = it.next()) !== null){
        if (cb(data) === false) return;
    }
};
// calls cb on each node's data, in reverse order
TreeBase.prototype.reach = function(cb) {
    var it = this.iterator(), data;
    while((data = it.prev()) !== null){
        if (cb(data) === false) return;
    }
};
function Iterator(tree) {
    this._tree = tree;
    this._ancestors = [];
    this._cursor = null;
}
Iterator.prototype.data = function() {
    return this._cursor !== null ? this._cursor.data : null;
};
// if null-iterator, returns first node
// otherwise, returns next node
Iterator.prototype.next = function() {
    if (this._cursor === null) {
        var root = this._tree._root;
        if (root !== null) this._minNode(root);
    } else if (this._cursor.right === null) {
        // no greater node in subtree, go up to parent
        // if coming from a right child, continue up the stack
        var save;
        do {
            save = this._cursor;
            if (this._ancestors.length) this._cursor = this._ancestors.pop();
            else {
                this._cursor = null;
                break;
            }
        }while (this._cursor.right === save);
    } else {
        // get the next node from the subtree
        this._ancestors.push(this._cursor);
        this._minNode(this._cursor.right);
    }
    return this._cursor !== null ? this._cursor.data : null;
};
// if null-iterator, returns last node
// otherwise, returns previous node
Iterator.prototype.prev = function() {
    if (this._cursor === null) {
        var root = this._tree._root;
        if (root !== null) this._maxNode(root);
    } else if (this._cursor.left === null) {
        var save;
        do {
            save = this._cursor;
            if (this._ancestors.length) this._cursor = this._ancestors.pop();
            else {
                this._cursor = null;
                break;
            }
        }while (this._cursor.left === save);
    } else {
        this._ancestors.push(this._cursor);
        this._maxNode(this._cursor.left);
    }
    return this._cursor !== null ? this._cursor.data : null;
};
Iterator.prototype._minNode = function(start) {
    while(start.left !== null){
        this._ancestors.push(start);
        start = start.left;
    }
    this._cursor = start;
};
Iterator.prototype._maxNode = function(start) {
    while(start.right !== null){
        this._ancestors.push(start);
        start = start.right;
    }
    this._cursor = start;
};
module.exports = TreeBase;

},{}],"1GUSf":[function(require,module,exports) {
var TreeBase = require("691cb56b93b68383");
function Node(data) {
    this.data = data;
    this.left = null;
    this.right = null;
}
Node.prototype.get_child = function(dir) {
    return dir ? this.right : this.left;
};
Node.prototype.set_child = function(dir, val) {
    if (dir) this.right = val;
    else this.left = val;
};
function BinTree(comparator) {
    this._root = null;
    this._comparator = comparator;
    this.size = 0;
}
BinTree.prototype = new TreeBase();
// returns true if inserted, false if duplicate
BinTree.prototype.insert = function(data) {
    if (this._root === null) {
        // empty tree
        this._root = new Node(data);
        this.size++;
        return true;
    }
    var dir = 0;
    // setup
    var p = null; // parent
    var node = this._root;
    // search down
    while(true){
        if (node === null) {
            // insert new node at the bottom
            node = new Node(data);
            p.set_child(dir, node);
            ret = true;
            this.size++;
            return true;
        }
        // stop if found
        if (this._comparator(node.data, data) === 0) return false;
        dir = this._comparator(node.data, data) < 0;
        // update helpers
        p = node;
        node = node.get_child(dir);
    }
};
// returns true if removed, false if not found
BinTree.prototype.remove = function(data) {
    if (this._root === null) return false;
    var head = new Node(undefined); // fake tree root
    var node = head;
    node.right = this._root;
    var p = null; // parent
    var found = null; // found item
    var dir = 1;
    while(node.get_child(dir) !== null){
        p = node;
        node = node.get_child(dir);
        var cmp = this._comparator(data, node.data);
        dir = cmp > 0;
        if (cmp === 0) found = node;
    }
    if (found !== null) {
        found.data = node.data;
        p.set_child(p.right === node, node.get_child(node.left === null));
        this._root = head.right;
        this.size--;
        return true;
    } else return false;
};
module.exports = BinTree;

},{"691cb56b93b68383":"l4Jeo"}],"cG3Gj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueMetric", ()=>QueueMetric);
parcelHelpers.export(exports, "QueuesStats", ()=>QueuesStats);
var _httpReq = require("./http_req");
var _metrics = require("./metrics");
var _tdshared = require("./tdshared");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var FLUSH_INTERVAL = 15000; // 15 seconds
var QueueMetric = /** @class */ function(_super) {
    __extends(QueueMetric, _super);
    function QueueMetric(queue) {
        var _this = _super.call(this) || this;
        _this.queue = queue;
        _this.startTime = new Date();
        return _this;
    }
    return QueueMetric;
}((0, _metrics.BaseMetric));
var QueuesStats = /** @class */ function() {
    function QueuesStats(opt) {
        this._m = {};
        this._opt = opt;
        this._url = "".concat(opt.host, "/api/v5/projects/").concat(opt.projectId, "/queues-stats?key=").concat(opt.projectKey);
        this._requester = (0, _httpReq.makeRequester)(opt);
    }
    QueuesStats.prototype.notify = function(q) {
        var _this = this;
        if (!(0, _tdshared.hasTdigest)) return;
        if (!this._opt.performanceStats) return;
        if (!this._opt.queueStats) return;
        var ms = q._duration();
        if (ms === 0) ms = 0.00001;
        var minute = 60000;
        var startTime = new Date(Math.floor(q.startTime.getTime() / minute) * minute);
        var key = {
            queue: q.queue,
            time: startTime
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new (0, _tdshared.TDigestStatGroups)();
            this._m[keyStr] = stat;
        }
        stat.addGroups(ms, q._groups);
        if (this._timer) return;
        this._timer = setTimeout(function() {
            _this._flush();
        }, FLUSH_INTERVAL);
    };
    QueuesStats.prototype._flush = function() {
        var queues = [];
        for(var keyStr in this._m){
            if (!this._m.hasOwnProperty(keyStr)) continue;
            var key = JSON.parse(keyStr);
            var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
            queues.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            queues: queues
        });
        var req = {
            method: "POST",
            url: this._url,
            body: outJSON
        };
        this._requester(req).then(function(_resp) {
        // nothing
        }).catch(function(err) {
            if (console.error) console.error("can not report queues breakdowns", err);
        });
    };
    return QueuesStats;
}();

},{"./http_req":"iSmNh","./metrics":"OnGyW","./tdshared":"gRwew","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"40G78":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RouteMetric", ()=>RouteMetric);
parcelHelpers.export(exports, "RoutesStats", ()=>RoutesStats);
parcelHelpers.export(exports, "RoutesBreakdowns", ()=>RoutesBreakdowns);
var _httpReq = require("./http_req");
var _metrics = require("./metrics");
var _tdshared = require("./tdshared");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var FLUSH_INTERVAL = 15000; // 15 seconds
var RouteMetric = /** @class */ function(_super) {
    __extends(RouteMetric, _super);
    function RouteMetric(method, route, statusCode, contentType) {
        if (method === void 0) method = "";
        if (route === void 0) route = "";
        if (statusCode === void 0) statusCode = 0;
        if (contentType === void 0) contentType = "";
        var _this = _super.call(this) || this;
        _this.method = method;
        _this.route = route;
        _this.statusCode = statusCode;
        _this.contentType = contentType;
        _this.startTime = new Date();
        return _this;
    }
    return RouteMetric;
}((0, _metrics.BaseMetric));
var RoutesStats = /** @class */ function() {
    function RoutesStats(opt) {
        this._m = {};
        this._opt = opt;
        this._url = "".concat(opt.host, "/api/v5/projects/").concat(opt.projectId, "/routes-stats?key=").concat(opt.projectKey);
        this._requester = (0, _httpReq.makeRequester)(opt);
    }
    RoutesStats.prototype.notify = function(req) {
        var _this = this;
        if (!(0, _tdshared.hasTdigest)) return;
        if (!this._opt.performanceStats) return;
        var ms = req._duration();
        var minute = 60000;
        var startTime = new Date(Math.floor(req.startTime.getTime() / minute) * minute);
        var key = {
            method: req.method,
            route: req.route,
            statusCode: req.statusCode,
            time: startTime
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new (0, _tdshared.TDigestStat)();
            this._m[keyStr] = stat;
        }
        stat.add(ms);
        if (this._timer) return;
        this._timer = setTimeout(function() {
            _this._flush();
        }, FLUSH_INTERVAL);
    };
    RoutesStats.prototype._flush = function() {
        var routes = [];
        for(var keyStr in this._m){
            if (!this._m.hasOwnProperty(keyStr)) continue;
            var key = JSON.parse(keyStr);
            var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
            routes.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            routes: routes
        });
        var req = {
            method: "POST",
            url: this._url,
            body: outJSON
        };
        this._requester(req).then(function(_resp) {
        // nothing
        }).catch(function(err) {
            if (console.error) console.error("can not report routes stats", err);
        });
    };
    return RoutesStats;
}();
var RoutesBreakdowns = /** @class */ function() {
    function RoutesBreakdowns(opt) {
        this._m = {};
        this._opt = opt;
        this._url = "".concat(opt.host, "/api/v5/projects/").concat(opt.projectId, "/routes-breakdowns?key=").concat(opt.projectKey);
        this._requester = (0, _httpReq.makeRequester)(opt);
    }
    RoutesBreakdowns.prototype.notify = function(req) {
        var _this = this;
        if (!(0, _tdshared.hasTdigest)) return;
        if (!this._opt.performanceStats) return;
        if (req.statusCode < 200 || req.statusCode >= 300 && req.statusCode < 400 || req.statusCode === 404 || Object.keys(req._groups).length === 0) return;
        var ms = req._duration();
        if (ms === 0) ms = 0.00001;
        var minute = 60000;
        var startTime = new Date(Math.floor(req.startTime.getTime() / minute) * minute);
        var key = {
            method: req.method,
            route: req.route,
            responseType: this._responseType(req),
            time: startTime
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new (0, _tdshared.TDigestStatGroups)();
            this._m[keyStr] = stat;
        }
        stat.addGroups(ms, req._groups);
        if (this._timer) return;
        this._timer = setTimeout(function() {
            _this._flush();
        }, FLUSH_INTERVAL);
    };
    RoutesBreakdowns.prototype._flush = function() {
        var routes = [];
        for(var keyStr in this._m){
            if (!this._m.hasOwnProperty(keyStr)) continue;
            var key = JSON.parse(keyStr);
            var v = __assign(__assign({}, key), this._m[keyStr].toJSON());
            routes.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            routes: routes
        });
        var req = {
            method: "POST",
            url: this._url,
            body: outJSON
        };
        this._requester(req).then(function(_resp) {
        // nothing
        }).catch(function(err) {
            if (console.error) console.error("can not report routes breakdowns", err);
        });
    };
    RoutesBreakdowns.prototype._responseType = function(req) {
        if (req.statusCode >= 500) return "5xx";
        if (req.statusCode >= 400) return "4xx";
        if (!req.contentType) return "";
        var s = req.contentType.split(";")[0].split("/");
        return s[s.length - 1];
    };
    return RoutesBreakdowns;
}();

},{"./http_req":"iSmNh","./metrics":"OnGyW","./tdshared":"gRwew","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dSb92":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NOTIFIER_NAME", ()=>NOTIFIER_NAME);
parcelHelpers.export(exports, "NOTIFIER_VERSION", ()=>NOTIFIER_VERSION);
parcelHelpers.export(exports, "NOTIFIER_URL", ()=>NOTIFIER_URL);
var NOTIFIER_NAME = "airbrake-js/browser";
var NOTIFIER_VERSION = "2.1.8";
var NOTIFIER_URL = "https://github.com/airbrake/airbrake-js/tree/master/packages/browser";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2o528":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoteSettings", ()=>RemoteSettings);
parcelHelpers.export(exports, "SettingsData", ()=>SettingsData);
var _httpReq = require("./http_req");
var _version = require("./version");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// API version to poll.
var API_VER = "2020-06-18";
// How frequently we should poll the config API.
var DEFAULT_INTERVAL = 600000; // 10 minutes
var NOTIFIER_INFO = {
    notifier_name: (0, _version.NOTIFIER_NAME),
    notifier_version: (0, _version.NOTIFIER_VERSION),
    os: typeof window !== "undefined" && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : undefined,
    language: "JavaScript"
};
// Remote config settings.
var ERROR_SETTING = "errors";
var APM_SETTING = "apm";
var RemoteSettings = /** @class */ function() {
    function RemoteSettings(opt) {
        this._opt = opt;
        this._requester = (0, _httpReq.makeRequester)(opt);
        this._data = new SettingsData(opt.projectId, {
            project_id: null,
            poll_sec: 0,
            updated_at: 0,
            config_route: "",
            settings: []
        });
        this._origErrorNotifications = opt.errorNotifications;
        this._origPerformanceStats = opt.performanceStats;
    }
    RemoteSettings.prototype.poll = function() {
        var _this = this;
        // First request is immediate. When it's done, we cancel it since we want to
        // change interval time to the default value.
        var pollerId = setInterval(function() {
            _this._doRequest();
            clearInterval(pollerId);
        }, 0);
        // Second fetch is what always runs in background.
        return setInterval(this._doRequest.bind(this), DEFAULT_INTERVAL);
    };
    RemoteSettings.prototype._doRequest = function() {
        var _this = this;
        this._requester(this._requestParams(this._opt)).then(function(resp) {
            _this._data.merge(resp.json);
            _this._opt.host = _this._data.errorHost();
            _this._opt.apmHost = _this._data.apmHost();
            _this._processErrorNotifications(_this._data);
            _this._processPerformanceStats(_this._data);
        }).catch(function(_) {
            return;
        });
    };
    RemoteSettings.prototype._requestParams = function(opt) {
        return {
            method: "GET",
            url: this._pollUrl(opt),
            headers: {
                Accept: "application/json",
                "Cache-Control": "no-cache,no-store"
            }
        };
    };
    RemoteSettings.prototype._pollUrl = function(opt) {
        var url = this._data.configRoute(opt.remoteConfigHost);
        var queryParams = "?";
        for(var _i = 0, _a = this._entries(NOTIFIER_INFO); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            queryParams += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
        }
        return url + queryParams;
    };
    RemoteSettings.prototype._processErrorNotifications = function(data) {
        if (!this._origErrorNotifications) return;
        this._opt.errorNotifications = data.errorNotifications();
    };
    RemoteSettings.prototype._processPerformanceStats = function(data) {
        if (!this._origPerformanceStats) return;
        this._opt.performanceStats = data.performanceStats();
    };
    // Polyfill from:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#polyfill
    RemoteSettings.prototype._entries = function(obj) {
        var ownProps = Object.keys(obj);
        var i = ownProps.length;
        var resArray = new Array(i);
        while(i--)resArray[i] = [
            ownProps[i],
            obj[ownProps[i]]
        ];
        return resArray;
    };
    return RemoteSettings;
}();
var SettingsData = /** @class */ function() {
    function SettingsData(projectId, data) {
        this._projectId = projectId;
        this._data = data;
    }
    SettingsData.prototype.merge = function(other) {
        this._data = __assign(__assign({}, this._data), other);
    };
    SettingsData.prototype.configRoute = function(remoteConfigHost) {
        var host = remoteConfigHost.replace(/\/$/, "");
        var configRoute = this._data.config_route;
        if (configRoute === null || configRoute === undefined || configRoute === "") return "".concat(host, "/").concat(API_VER, "/config/").concat(this._projectId, "/config.json");
        else return "".concat(host, "/").concat(configRoute);
    };
    SettingsData.prototype.errorNotifications = function() {
        var s = this._findSetting(ERROR_SETTING);
        if (s === null) return true;
        return s.enabled;
    };
    SettingsData.prototype.performanceStats = function() {
        var s = this._findSetting(APM_SETTING);
        if (s === null) return true;
        return s.enabled;
    };
    SettingsData.prototype.errorHost = function() {
        var s = this._findSetting(ERROR_SETTING);
        if (s === null) return null;
        return s.endpoint;
    };
    SettingsData.prototype.apmHost = function() {
        var s = this._findSetting(APM_SETTING);
        if (s === null) return null;
        return s.endpoint;
    };
    SettingsData.prototype._findSetting = function(name) {
        var settings = this._data.settings;
        if (settings === null || settings === undefined) return null;
        var setting = settings.find(function(s) {
            return s.name === name;
        });
        if (setting === undefined) return null;
        return setting;
    };
    return SettingsData;
}();

},{"./http_req":"iSmNh","./version":"dSb92","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8MGJs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowFilter", ()=>windowFilter);
function windowFilter(notice) {
    if (window.navigator && window.navigator.userAgent) notice.context.userAgent = window.navigator.userAgent;
    if (window.location) {
        notice.context.url = String(window.location);
        // Set root directory to group errors on different subdomains together.
        notice.context.rootDirectory = window.location.protocol + "//" + window.location.host;
    }
    return notice;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fdjx3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentConsole", ()=>instrumentConsole);
var CONSOLE_METHODS = [
    "debug",
    "log",
    "info",
    "warn",
    "error"
];
function instrumentConsole(notifier) {
    var _loop_1 = function(m) {
        if (!(m in console)) return "continue";
        var oldFn = console[m];
        var newFn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            oldFn.apply(console, args);
            notifier.scope().pushHistory({
                type: "log",
                severity: m,
                arguments: args
            });
        };
        newFn.inner = oldFn;
        console[m] = newFn;
    };
    // tslint:disable-next-line:no-this-assignment
    for(var _i = 0, CONSOLE_METHODS_1 = CONSOLE_METHODS; _i < CONSOLE_METHODS_1.length; _i++){
        var m = CONSOLE_METHODS_1[_i];
        _loop_1(m);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jDK3S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentDOM", ()=>instrumentDOM);
var elemAttrs = [
    "type",
    "name",
    "src"
];
function instrumentDOM(notifier) {
    var handler = makeEventHandler(notifier);
    if (window.addEventListener) {
        window.addEventListener("load", handler);
        window.addEventListener("error", function(event) {
            if (getProp(event, "error")) return;
            handler(event);
        }, true);
    }
    if (typeof document === "object" && document.addEventListener) {
        document.addEventListener("DOMContentLoaded", handler);
        document.addEventListener("click", handler);
        document.addEventListener("keypress", handler);
    }
}
function makeEventHandler(notifier) {
    return function(event) {
        var target = getProp(event, "target");
        if (!target) return;
        var state = {
            type: event.type
        };
        try {
            state.target = elemPath(target);
        } catch (err) {
            state.target = "<".concat(String(err), ">");
        }
        notifier.scope().pushHistory(state);
    };
}
function elemName(elem) {
    if (!elem) return "";
    var s = [];
    if (elem.tagName) s.push(elem.tagName.toLowerCase());
    if (elem.id) {
        s.push("#");
        s.push(elem.id);
    }
    if (elem.classList && Array.from) {
        s.push(".");
        s.push(Array.from(elem.classList).join("."));
    } else if (elem.className) {
        var str = classNameString(elem.className);
        if (str !== "") {
            s.push(".");
            s.push(str);
        }
    }
    if (elem.getAttribute) for(var _i = 0, elemAttrs_1 = elemAttrs; _i < elemAttrs_1.length; _i++){
        var attr = elemAttrs_1[_i];
        var value = elem.getAttribute(attr);
        if (value) s.push("[".concat(attr, '="').concat(value, '"]'));
    }
    return s.join("");
}
function classNameString(name) {
    if (name.split) return name.split(" ").join(".");
    if (name.baseVal && name.baseVal.split) // SVGAnimatedString
    return name.baseVal.split(" ").join(".");
    console.error("unsupported HTMLElement.className type", typeof name);
    return "";
}
function elemPath(elem) {
    var maxLen = 10;
    var path = [];
    var parent = elem;
    while(parent){
        var name_1 = elemName(parent);
        if (name_1 !== "") {
            path.push(name_1);
            if (path.length > maxLen) break;
        }
        parent = parent.parentNode;
    }
    if (path.length === 0) return String(elem);
    return path.reverse().join(" > ");
}
function getProp(obj, prop) {
    try {
        return obj[prop];
    } catch (_) {
        // Permission denied to access property
        return null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"djUvn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentFetch", ()=>instrumentFetch);
function instrumentFetch(notifier) {
    // tslint:disable-next-line:no-this-assignment
    var oldFetch = window.fetch;
    window.fetch = function(req, options) {
        var state = {
            type: "xhr",
            date: new Date()
        };
        state.method = options && options.method ? options.method : "GET";
        if (typeof req === "string") state.url = req;
        else {
            state.method = req.method;
            state.url = req.url;
        }
        // Some platforms (e.g. react-native) implement fetch via XHR.
        notifier._ignoreNextXHR++;
        setTimeout(function() {
            return notifier._ignoreNextXHR--;
        });
        return oldFetch.apply(this, arguments).then(function(resp) {
            state.statusCode = resp.status;
            state.duration = new Date().getTime() - state.date.getTime();
            notifier.scope().pushHistory(state);
            return resp;
        }).catch(function(err) {
            state.error = err;
            state.duration = new Date().getTime() - state.date.getTime();
            notifier.scope().pushHistory(state);
            throw err;
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8CHdv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentLocation", ()=>instrumentLocation);
var lastLocation = "";
// In some environments (i.e. Cypress) document.location may sometimes be null
function getCurrentLocation() {
    return document.location && document.location.pathname;
}
function instrumentLocation(notifier) {
    lastLocation = getCurrentLocation();
    var oldFn = window.onpopstate;
    window.onpopstate = function abOnpopstate(_event) {
        var url = getCurrentLocation();
        if (url) recordLocation(notifier, url);
        if (oldFn) return oldFn.apply(this, arguments);
    };
    var oldPushState = history.pushState;
    history.pushState = function abPushState(_state, _title, url) {
        if (url) recordLocation(notifier, url.toString());
        oldPushState.apply(this, arguments);
    };
}
function recordLocation(notifier, url) {
    var index = url.indexOf("://");
    if (index >= 0) {
        url = url.slice(index + 3);
        index = url.indexOf("/");
        url = index >= 0 ? url.slice(index) : "/";
    } else if (url.charAt(0) !== "/") url = "/" + url;
    notifier.scope().pushHistory({
        type: "location",
        from: lastLocation,
        to: url
    });
    lastLocation = url;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jy5DG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentXHR", ()=>instrumentXHR);
function instrumentXHR(notifier) {
    function recordReq(req) {
        var state = req.__state;
        state.statusCode = req.status;
        state.duration = new Date().getTime() - state.date.getTime();
        notifier.scope().pushHistory(state);
    }
    var oldOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function abOpen(method, url, _async, _user, _password) {
        if (notifier._ignoreNextXHR === 0) this.__state = {
            type: "xhr",
            method: method,
            url: url
        };
        oldOpen.apply(this, arguments);
    };
    var oldSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function abSend(_data) {
        var oldFn = this.onreadystatechange;
        this.onreadystatechange = function(_ev) {
            if (this.readyState === 4 && this.__state) recordReq(this);
            if (oldFn) return oldFn.apply(this, arguments);
        };
        if (this.__state) this.__state.date = new Date();
        return oldSend.apply(this, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3zOiI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _routes = require("./Routes");
var _routesDefault = parcelHelpers.interopDefault(_routes);
exports.default = (0, _routesDefault.default);

},{"./Routes":"lLJZ3","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lLJZ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
// Import all full pages from /src/pages directory
var _loading = require("../../pages/loading");
var _loadingDefault = parcelHelpers.interopDefault(_loading);
var _login = require("../../pages/login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _terminalLogin = require("../../pages/terminal-login");
var _terminalLoginDefault = parcelHelpers.interopDefault(_terminalLogin);
var _notFound = require("../../pages/not-found");
var _notFoundDefault = parcelHelpers.interopDefault(_notFound);
var _products = require("../../pages/products");
var _productsDefault = parcelHelpers.interopDefault(_products);
var _lookup = require("../../pages/lookup");
var _lookupDefault = parcelHelpers.interopDefault(_lookup);
var _search = require("../../pages/search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _searchResults = require("../../pages/search-results");
var _searchResultsDefault = parcelHelpers.interopDefault(_searchResults);
var _layout = require("../layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _cart = require("../../pages/cart");
var _cartDefault = parcelHelpers.interopDefault(_cart);
var _checkout = require("../../pages/checkout");
var _checkoutDefault = parcelHelpers.interopDefault(_checkout);
var _orderDetails = require("../../pages/order-details");
var _orderDetailsDefault = parcelHelpers.interopDefault(_orderDetails);
var _ordersIndex = require("../../pages/orders-index");
var _ordersIndexDefault = parcelHelpers.interopDefault(_ordersIndex);
var _closeout = require("../../pages/closeout");
var _closeoutDefault = parcelHelpers.interopDefault(_closeout);
var _cashDrop = require("../../pages/cash-drop");
var _cashDropDefault = parcelHelpers.interopDefault(_cashDrop);
var _drawerHistoryIndex = require("../../pages/drawer-history-index");
var _drawerHistoryIndexDefault = parcelHelpers.interopDefault(_drawerHistoryIndex);
var _cashActionDetails = require("../../pages/cash-action-details");
var _cashActionDetailsDefault = parcelHelpers.interopDefault(_cashActionDetails);
var _reporting = require("../../pages/reporting");
var _reportingDefault = parcelHelpers.interopDefault(_reporting);
var _oktaReact = require("@okta/okta-react");
var _oktaAuthJs = require("@okta/okta-auth-js");
var _reactRedux = require("react-redux");
var _loginState = require("../../pages/login/Login.state");
var _state = require("../../utils/state");
var _constants = require("../../utils/constants");
var _logout = require("../../pages/logout/Logout");
var _logoutDefault = parcelHelpers.interopDefault(_logout);
var _reducer = require("../../state/reducer");
const AllRoutes = ({ hasTerminalSession })=>{
    const config = (0, _reactRedux.useSelector)((state)=>state.config);
    const oktaAuth = new (0, _oktaAuthJs.OktaAuth)(config.oidc);
    const isLoggedIn = Boolean((0, _state.getRefreshToken)()) && Boolean((0, _state.getAccessToken)());
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        if (isLoggedIn) {
            const { first_name, last_name, email } = (0, _state.getDecodedAccessToken)();
            dispatch((0, _loginState.loginSuccess)({
                cashier: {
                    first_name,
                    last_name,
                    email
                }
            }));
        }
    }, [
        isLoggedIn
    ]);
    (0, _react.useEffect)(()=>{
        if (location.pathname === config.oidc.redirectUri && location.search.includes((0, _constants.OKTA_OAUTH_ERROR).queryStr)) dispatch((0, _reducer.logout)({
            navigate
        }));
    }, [
        location.pathname
    ]);
    const restoreOriginalUri = (_oktaAuth, originalUri)=>navigate((0, _oktaAuthJs.toRelativeUrl)(originalUri || "/", window.location.origin));
    const routes = (0, _reactRouterDom.useRoutes)([
        {
            path: "/pos",
            element: isLoggedIn && hasTerminalSession ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layoutDefault.default), {
                isLoggedIn: isLoggedIn,
                hasTerminalSession: hasTerminalSession
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                to: "/login"
            }),
            children: [
                {
                    path: "/pos/cashdrop",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cashDropDefault.default), {})
                },
                {
                    path: "/pos/closeout",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeoutDefault.default), {})
                },
                {
                    path: "/pos/results",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsDefault.default), {})
                },
                {
                    path: "/pos/lookup/:id",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lookupDefault.default), {})
                },
                {
                    path: "/pos/search/:id",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {})
                },
                {
                    path: "/pos/products",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _productsDefault.default), {})
                },
                {
                    path: "/pos/cart",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartDefault.default), {})
                },
                {
                    path: "/pos/checkout",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkoutDefault.default), {})
                },
                {
                    path: "/pos/order/:id",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDetailsDefault.default), {})
                },
                {
                    path: "/pos/cashaction/:id",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cashActionDetailsDefault.default), {})
                },
                {
                    path: "/pos/closeout/:id",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cashActionDetailsDefault.default), {})
                },
                {
                    path: "/pos/orders",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ordersIndexDefault.default), {})
                },
                {
                    path: "/pos/reporting",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportingDefault.default), {})
                },
                {
                    path: "/pos/drawer-history",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerHistoryIndexDefault.default), {})
                },
                {
                    path: "/pos",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                        to: "/pos/products"
                    })
                },
                {
                    path: "/pos/loading",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingDefault.default), {})
                },
                {
                    path: "/pos/not-found",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFoundDefault.default), {})
                }
            ]
        },
        {
            path: "/login/callback",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _oktaReact.LoginCallback), {
                oktaAuth: oktaAuth,
                loadingElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingDefault.default), {})
            })
        },
        {
            path: "/login",
            element: !isLoggedIn || !hasTerminalSession ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layoutDefault.default), {
                isLoggedIn: isLoggedIn
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                to: "/pos"
            }),
            children: [
                {
                    path: "/login/user",
                    element: isLoggedIn && !hasTerminalSession ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                        to: "/login/terminal"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginDefault.default), {})
                },
                {
                    path: "/login/terminal",
                    element: isLoggedIn ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _terminalLoginDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                        to: `/login/user`
                    })
                },
                {
                    path: "/login",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                        to: `/login/user`
                    })
                }
            ]
        },
        {
            path: "/logout",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoutDefault.default), {})
        },
        {
            path: "/",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                to: "/login"
            })
        }
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _oktaReact.Security), {
        oktaAuth: oktaAuth,
        restoreOriginalUri: restoreOriginalUri,
        children: routes
    });
};
exports.default = AllRoutes;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-router-dom":"hNarb","../../pages/loading":"frad1","../../pages/login":"kE849","../../pages/terminal-login":"dJGRm","../../pages/not-found":"kRKNi","../../pages/products":"cU7NH","../../pages/lookup":"2Bvl5","../../pages/search":"cjVpo","../../pages/search-results":"2ksg6","../layout":"cNjw2","../../pages/cart":"3im45","../../pages/checkout":"3I3s4","../../pages/order-details":"38tJn","../../pages/orders-index":"k6Czs","../../pages/closeout":"LMC8m","../../pages/cash-drop":"dfJIk","../../pages/drawer-history-index":"j7yqE","../../pages/cash-action-details":"3x6DF","../../pages/reporting":"fdUs1","@okta/okta-react":"3286W","@okta/okta-auth-js":"boELZ","react-redux":"k6jol","../../pages/login/Login.state":"eq6dI","../../utils/state":"8UPqD","../../utils/constants":"f3A1R","../../pages/logout/Logout":"9txSJ","../../state/reducer":"aTwKq","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"frad1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loading = require("./Loading");
var _loadingDefault = parcelHelpers.interopDefault(_loading);
exports.default = (0, _loadingDefault.default);

},{"./Loading":"bMvt6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bMvt6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loadingStyled = require("./Loading.styled");
var _components = require("@thecb/components");
const Loading = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingStyled.LoadingContainer), {
        "data-testid": "loading",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cover), {
            singleChild: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cover), {
                    minHeight: "100%",
                    singleChild: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                        intrinsic: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                                size: "100"
                            })
                        })
                    })
                })
            })
        })
    });
exports.default = Loading;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","./Loading.styled":"ctvce","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ctvce":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingContainer", ()=>LoadingContainer);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const LoadingContainer = (0, _styledComponentsDefault.default).div`
  height: 100%;
`;

},{"styled-components":"bkusY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kE849":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _login = require("./Login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _loginState = require("./Login.state");
exports.default = (0, _reactRedux.connect)((0, _loginState.mapStateToProps), (0, _loginState.mapDispatchToProps))((0, _loginDefault.default));

},{"react-redux":"k6jol","./Login":"kDpB6","./Login.state":"eq6dI","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dJGRm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _terminalLogin = require("./TerminalLogin");
var _terminalLoginDefault = parcelHelpers.interopDefault(_terminalLogin);
var _terminalLoginState = require("./TerminalLogin.state");
exports.default = (0, _reactRedux.connect)((0, _terminalLoginState.mapStateToProps), (0, _terminalLoginState.mapDispatchToProps))((0, _terminalLoginDefault.default));

},{"react-redux":"k6jol","./TerminalLogin":"8dAui","./TerminalLogin.state":"7GhEX","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8dAui":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _terminalLoginForm = require("./TerminalLoginForm");
var _components = require("@thecb/components");
var _welcomeHeader = require("../../components/welcome-header");
var _welcomeHeaderDefault = parcelHelpers.interopDefault(_welcomeHeader);
var _oktaReact = require("@okta/okta-react");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _reactRedux = require("react-redux");
var _helpers = require("../../utils/helpers");
var _terminalLoginState = require("./TerminalLogin.state");
var _reactRouterDom = require("react-router-dom");
const SUBMIT_ACTIONS = {
    SESSION_NEW: {
        key: "SESSION_NEW",
        label: "Start New Session"
    },
    SESSION_CONTINUE: {
        key: "SESSION_CONTINUE",
        label: "Continue Session"
    },
    SESSION_TRANSFER: {
        key: "SESSION_TRANSFER",
        label: "Transfer Session"
    }
};
const TerminalLoginFormBody = ({ forms, actions, showErrors, submitting, handleSubmit, locations, terminals, submitBtnText, setSelectedTerminalSession })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        width: "576px",
        borderRadius: "0 0 8px 8px",
        boxShadow: "0px 2px 14px 0px rgb(246, 246, 249), 0px 3px 8px 0px rgb(202, 206, 216)",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
            padding: "24px",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _terminalLoginForm.TerminalLoginForm), {
                    ...forms.terminalLoginForm,
                    ...actions.forms.terminalLoginForm,
                    showErrors: showErrors,
                    locations: locations,
                    terminals: terminals,
                    setSelectedTerminalSession: setSelectedTerminalSession
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "1rem 0 0 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
                        justify: "center",
                        align: "center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            text: submitBtnText,
                            isLoading: submitting,
                            variant: "primary",
                            action: handleSubmit,
                            extraStyles: "width: 100%; margin: 0px;",
                            dataQa: "Submit",
                            textExtraStyles: "font-size: 1rem;"
                        })
                    })
                })
            ]
        })
    }, "item2");
const TerminalLogin = ({ forms, actions, submitting, fetchLocations, locations, terminals, alertBars })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [errors, handleErrors] = (0, _react.useState)(false);
    const [selectedTerminalSession, setSelectedTerminalSession] = (0, _react.useState)(null);
    const { isSessionTransferModalOpen } = (0, _reactRedux.useSelector)((state)=>state.terminalLogin);
    const { oktaAuth } = (0, _oktaReact.useOktaAuth)();
    const handleFetchLocations = async ()=>{
        try {
            let exists = await oktaAuth.session.exists();
            let isAuthenticated = await oktaAuth.isAuthenticated();
            if (exists && isAuthenticated) fetchLocations({
                navigate
            });
        } catch (err) {
            console.warn(`%cWarning: Error checking Okta session before fetching locations: ${err}`, `background-color: ${consoleWarningStyle}`);
        }
    };
    (0, _react.useEffect)(()=>{
        handleFetchLocations();
    }, []);
    const { currentAbilities } = (0, _reactRedux.useSelector)((state)=>state.shared);
    const { cashier: loggedInCashier } = (0, _reactRedux.useSelector)((state)=>state.login);
    const getSubmitAction = ()=>{
        const hasActiveSession = selectedTerminalSession?.terminal_session.cashier["active?"];
        if (hasActiveSession) {
            const isSelectedTerminalSessionTheCurrentUsers = selectedTerminalSession.terminal_session.cashier?.email === loggedInCashier?.email;
            if (isSelectedTerminalSessionTheCurrentUsers) return SUBMIT_ACTIONS.SESSION_CONTINUE.key;
            else return (0, _helpers.can)("transfer_session", "TerminalSession", currentAbilities) ? SUBMIT_ACTIONS.SESSION_TRANSFER.key : SUBMIT_ACTIONS.SESSION_CONTINUE.key;
        } else return SUBMIT_ACTIONS.SESSION_NEW.key;
    };
    const submitAction = getSubmitAction();
    const handleSubmit = (0, _components.util).general.generateClickHandler(forms.terminalLoginForm, ()=>handleErrors(true), ()=>dispatch((0, _terminalLoginState.submitTerminalLoginForm)({
            isSessionTransfer: submitAction === SUBMIT_ACTIONS.SESSION_TRANSFER.key ? true : false,
            email: selectedTerminalSession.terminal_session.cashier.email,
            id: selectedTerminalSession.id,
            terminal_session_id: selectedTerminalSession.terminal_session.terminal_session_id,
            navigate
        })));
    const modalHeaderText = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
        variant: "large",
        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
        color: (0, _components.constants).colors.WHITE,
        children: "Session Transfer"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CenterStack), {
        content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
            padding: "32px 0 64px",
            children: [
                alertBars.terminalLoginAlertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBars.terminalLoginAlertBar,
                        ...actions.alertBars.terminalLoginAlertBar
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                    padding: "0",
                    borderRadius: "8px",
                    boxShadow: "0px 1px 2px 0px rgba(41, 42, 51, 0.1), 0px 2px 6px 0px rgba(41, 42, 51, 0.2), 0px 1px 0px 0px rgba(41, 42, 51, 0.1) inset",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _welcomeHeaderDefault.default), {
                            actionText: "Please select your location"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(TerminalLoginFormBody, {
                            submitBtnText: SUBMIT_ACTIONS[submitAction].label,
                            setSelectedTerminalSession: setSelectedTerminalSession,
                            forms: forms,
                            actions: actions,
                            showErrors: errors,
                            submitting: submitting,
                            handleSubmit: (e)=>{
                                submitAction === SUBMIT_ACTIONS.SESSION_TRANSFER.key ? dispatch((0, _terminalLoginState.sessionTransferModal)((0, _terminalLoginState.OPEN_SESSION_TRANSFER_MODAL))) : handleSubmit(e);
                            },
                            locations: locations,
                            terminals: terminals
                        })
                    ]
                }),
                selectedTerminalSession && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
                    modalHeaderBg: (0, _components.constants).colors.ERROR_COLOR,
                    modalHeaderText: modalHeaderText,
                    noBorder: true,
                    defaultWrapper: false,
                    hideModal: ()=>{
                        dispatch((0, _terminalLoginState.sessionTransferModal)((0, _terminalLoginState.CLOSE_SESSION_TRANSFER_MODAL)));
                    },
                    continueAction: handleSubmit,
                    continueButtonText: SUBMIT_ACTIONS.SESSION_TRANSFER.label,
                    modalOpen: isSessionTransferModalOpen,
                    modalBodyText: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                children: `This terminal has an open session that belongs to ${selectedTerminalSession.terminal_session.cashier.full_name}. `
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                children: "Continuing will log this user out and transfer this session to you."
                            })
                        ]
                    })
                })
            ]
        })
    });
};
exports.default = (0, _components.withWindowSize)(TerminalLogin);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","./TerminalLoginForm":"eGc1m","@thecb/components":"g98ma","../../components/welcome-header":"iyfz3","@okta/okta-react":"3286W","../../components/alert-bar":"aD416","react-redux":"k6jol","../../utils/helpers":"epomp","./TerminalLogin.state":"7GhEX","react-router-dom":"hNarb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kRKNi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _notFound = require("./NotFound");
var _notFoundDefault = parcelHelpers.interopDefault(_notFound);
exports.default = (0, _notFoundDefault.default);

},{"./NotFound":"6RGIR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6RGIR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _reactRouterDom = require("react-router-dom");
var _components = require("@thecb/components");
const NotFound = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { isMobile } = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
        justify: "center",
        align: "center",
        style: {
            height: "100%"
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: "/img/404.svg",
                            width: isMobile ? "100%" : "460px",
                            height: "auto"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                        padding: "0",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                                textAlign: "center",
                                children: "Oops!"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                                as: "h5",
                                textAlign: "center",
                                children: "Where did we go?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                        singleChild: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                            padding: "0",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                    textAlign: "center",
                                    children: "The requested url was not found."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                    textAlign: "center",
                                    children: "Please return to the home page."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                        singleChild: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "1rem 0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                text: "Go Back",
                                action: ()=>navigate("/")
                            })
                        })
                    })
                ]
            })
        })
    });
};
exports.default = (0, _components.withWindowSize)(NotFound);

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","styled-components":"bkusY","react-router-dom":"hNarb","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cU7NH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _products = require("./Products");
var _productsDefault = parcelHelpers.interopDefault(_products);
var _productsState = require("./Products.state");
exports.default = (0, _reactRedux.connect)((0, _productsState.mapStateToProps), (0, _productsState.mapDispatchToProps))((0, _productsDefault.default));

},{"react-redux":"k6jol","./Products":"eXURr","./Products.state":"9SdM7","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eXURr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reactRouterHashLink = require("react-router-hash-link");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _cartSidebar = require("../../components/cart-sidebar");
var _cartSidebarDefault = parcelHelpers.interopDefault(_cartSidebar);
var _productsSection = require("./ProductsSection");
var _productsSectionDefault = parcelHelpers.interopDefault(_productsSection);
var _productsStyled = require("./Products.styled");
var _reactRedux = require("react-redux");
var _sharedAlertBar = require("../../components/alert-bar/SharedAlertBar");
var _sharedAlertBarDefault = parcelHelpers.interopDefault(_sharedAlertBar);
const Header = ({ alertBar, alertBarActions })=>{
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                sharedAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharedAlertBarDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Search"
                })
            ]
        })
    });
};
const AgencyTile = ({ text, id })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _productsStyled.AgencyTileWrapper), {
        rebrand: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterHashLink.HashLink), {
            smooth: true,
            to: `#agency-${id}`,
            children: text
        })
    });
};
const Products = ({ fetchProducts, fetchAgencies, clearCurrentProduct, currentProduct, products, agencies, currentAgencyInCart, alertBars, actions })=>{
    const [searchValue, setSearchValue] = (0, _react.useState)("");
    const [filteredProducts, setFilteredProducts] = (0, _react.useState)(products.data);
    const [filteredAgencies, setFilteredAgencies] = (0, _react.useState)(agencies.data);
    const COLLAPSED_ALL = "COLLAPSED_ALL";
    const EXPANDED_ALL = "EXPANDED_ALL";
    const [expandCollapseState, setExpandCollapseState] = (0, _react.useState)({
        lastEvent: EXPANDED_ALL
    });
    (0, _react.useEffect)(()=>{
        if (!products.data.length) {
            fetchProducts();
            fetchAgencies();
        }
    }, []);
    (0, _react.useEffect)(()=>{
        if (Object.keys(currentProduct.form_data).length) clearCurrentProduct();
    }, []);
    (0, _react.useEffect)(()=>{
        const nextFilteredProducts = products.data.filter((product)=>product.name.match(new RegExp(searchValue, "i")));
        const nextFilteredAgencies = agencies.data.filter((agency)=>nextFilteredProducts.some((product)=>product.agency_id === agency.id));
        const cartFilteredAgencies = currentAgencyInCart ? nextFilteredAgencies.filter((agency)=>agency.id === currentAgencyInCart) : nextFilteredAgencies;
        setFilteredAgencies(cartFilteredAgencies);
        setFilteredProducts(nextFilteredProducts);
    }, [
        searchValue,
        agencies,
        products,
        currentAgencyInCart
    ]);
    const agenciesSection = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                padding: "1rem 0",
                id: "agency_links",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                        variant: "h6",
                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                        extraStyles: `padding-bottom: .5rem; font-size: 1rem;`,
                        // color={themeValues.titleColor}
                        as: "h6",
                        children: "Scroll to Agency"
                    }),
                    agencies.fetching ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                        size: "100"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
                        justify: "flex-start",
                        align: "stretch",
                        childGap: "7px",
                        extraStyles: "padding: 1rem 0;",
                        children: filteredAgencies.map((agency)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(AgencyTile, {
                                text: agency.description,
                                id: agency.id
                            }, agency.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {})
        ]
    });
    const handleTypeaheadChange = (value)=>setSearchValue(value);
    const searchInput = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0 0 1rem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.TypeaheadInput), {
            handleChange: handleTypeaheadChange,
            labelText: "Products search",
            placeholder: "Search...",
            id: "products-search"
        })
    });
    const expandCollapseAllSection = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "1rem 0",
                id: "agency_links",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    justify: "space-between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            // color={themeValues.titleColor}
                            as: "h6",
                            extraStyles: "font-size: 1.125rem",
                            children: "All Tiles"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                    variant: "ghost",
                                    action: ()=>{
                                        setExpandCollapseState({
                                            lastEvent: EXPANDED_ALL
                                        });
                                    },
                                    text: "Expand All",
                                    extraStyles: "min-width: 100px;",
                                    textExtraStyles: "font-weight: 200; font-size: 1rem"
                                }),
                                "|",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                    variant: "ghost",
                                    action: ()=>{
                                        setExpandCollapseState({
                                            lastEvent: COLLAPSED_ALL
                                        });
                                    },
                                    text: "Collapse All",
                                    extraStyles: "min-width: 100px;",
                                    textExtraStyles: "font-weight: 200; font-size: 1rem"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {})
        ]
    });
    const isFetchingProductsOrAgencies = agencies.fetching || products.fetching;
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: ".5rem 0 1.5rem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
            background: (0, _components.constants).colors.WHITE,
            variant: "baseStandard",
            padding: "1.5rem",
            borderRadius: "0.25rem",
            children: [
                searchInput,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                agenciesSection,
                expandCollapseAllSection,
                isFetchingProductsOrAgencies ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                    size: "100"
                }) : filteredAgencies.map((agency)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _productsSectionDefault.default), {
                        universalExpandCollapseState: expandCollapseState,
                        id: agency.id,
                        title: agency.description,
                        products: filteredProducts.filter((product)=>product.agency_id === agency.id)
                    }, agency.id)),
                !isFetchingProductsOrAgencies && !filteredAgencies.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        color: (0, _components.constants).colors.GREY_CHATEAU,
                        children: "No Data"
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SidebarSingleContent), {
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.productsAlertBar,
            alertBarActions: actions.alertBars.productsAlertBar
        }, "ProductsHeader"),
        mainContent: content,
        sidebarContent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartSidebarDefault.default), {}),
        sidebarTargetWidth: "27.429rem",
        sidebarWrapperMaxWidth: "85.714rem",
        sidebarOnRight: true,
        childGap: "0.5rem"
    });
};
exports.default = Products;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","react-router-hash-link":"12dZL","../../components/alert-bar":"aD416","../../components/cart-sidebar":"l8jjH","./ProductsSection":"2SppC","./Products.styled":"4f3cS","react-redux":"k6jol","../../components/alert-bar/SharedAlertBar":"gk2Ni","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"12dZL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HashLink", ()=>HashLink);
parcelHelpers.export(exports, "NavHashLink", ()=>NavHashLink);
parcelHelpers.export(exports, "genericHashLink", ()=>genericHashLink);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactRouterDom = require("react-router-dom");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var hashFragment = "";
var observer = null;
var asyncTimerId = null;
var scrollFunction = null;
function reset() {
    hashFragment = "";
    if (observer !== null) observer.disconnect();
    if (asyncTimerId !== null) {
        window.clearTimeout(asyncTimerId);
        asyncTimerId = null;
    }
}
function isInteractiveElement(element) {
    var formTags = [
        "BUTTON",
        "INPUT",
        "SELECT",
        "TEXTAREA"
    ];
    var linkTags = [
        "A",
        "AREA"
    ];
    return formTags.includes(element.tagName) && !element.hasAttribute("disabled") || linkTags.includes(element.tagName) && element.hasAttribute("href");
}
function getElAndScroll() {
    var element = null;
    if (hashFragment === "#") // use document.body instead of document.documentElement because of a bug in smoothscroll-polyfill in safari
    // see https://github.com/iamdustan/smoothscroll/issues/138
    // while smoothscroll-polyfill is not included, it is the recommended way to implement smoothscroll
    // in browsers that don't natively support el.scrollIntoView({ behavior: 'smooth' })
    element = document.body;
    else {
        // check for element with matching id before assume '#top' is the top of the document
        // see https://html.spec.whatwg.org/multipage/browsing-the-web.html#target-element
        var id = hashFragment.replace("#", "");
        element = document.getElementById(id);
        if (element === null && hashFragment === "#top") // see above comment for why document.body instead of document.documentElement
        element = document.body;
    }
    if (element !== null) {
        scrollFunction(element);
        // update focus to where the page is scrolled to
        // unfortunately this doesn't work in safari (desktop and iOS) when blur() is called
        var originalTabIndex = element.getAttribute("tabindex");
        if (originalTabIndex === null && !isInteractiveElement(element)) element.setAttribute("tabindex", -1);
        element.focus({
            preventScroll: true
        });
        if (originalTabIndex === null && !isInteractiveElement(element)) {
            // for some reason calling blur() in safari resets the focus region to where it was previously,
            // if blur() is not called it works in safari, but then are stuck with default focus styles
            // on an element that otherwise might never had focus styles applied, so not an option
            element.blur();
            element.removeAttribute("tabindex");
        }
        reset();
        return true;
    }
    return false;
}
function hashLinkScroll(timeout) {
    // Push onto callback queue so it runs after the DOM is updated
    window.setTimeout(function() {
        if (getElAndScroll() === false) {
            if (observer === null) observer = new MutationObserver(getElAndScroll);
            observer.observe(document, {
                attributes: true,
                childList: true,
                subtree: true
            });
            // if the element doesn't show up in specified timeout or 10 seconds, stop checking
            asyncTimerId = window.setTimeout(function() {
                reset();
            }, timeout || 10000);
        }
    }, 0);
}
function genericHashLink(As) {
    return (0, _reactDefault.default).forwardRef(function(props, ref) {
        var linkHash = "";
        if (typeof props.to === "string" && props.to.includes("#")) linkHash = "#" + props.to.split("#").slice(1).join("#");
        else if (typeof props.to === "object" && typeof props.to.hash === "string") linkHash = props.to.hash;
        var passDownProps = {};
        if (As === (0, _reactRouterDom.NavLink)) passDownProps.isActive = function(match, location) {
            return match && match.isExact && location.hash === linkHash;
        };
        function handleClick(e) {
            reset();
            hashFragment = props.elementId ? "#" + props.elementId : linkHash;
            if (props.onClick) props.onClick(e);
            if (hashFragment !== "" && // ignore non-vanilla click events, same as react-router
            // below logic adapted from react-router: https://github.com/ReactTraining/react-router/blob/fc91700e08df8147bd2bb1be19a299cbb14dbcaa/packages/react-router-dom/modules/Link.js#L43-L48
            !e.defaultPrevented && // onClick prevented default
            e.button === 0 && // ignore everything but left clicks
            (!props.target || props.target === "_self") && // let browser handle "target=_blank" etc
            !(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey // ignore clicks with modifier keys
            )) {
                scrollFunction = props.scroll || function(el) {
                    return props.smooth ? el.scrollIntoView({
                        behavior: "smooth"
                    }) : el.scrollIntoView();
                };
                hashLinkScroll(props.timeout);
            }
        }
        var filteredProps = __rest(props, [
            "scroll",
            "smooth",
            "timeout",
            "elementId"
        ]);
        return (0, _reactDefault.default).createElement(As, __assign({}, passDownProps, filteredProps, {
            onClick: handleClick,
            ref: ref
        }), props.children);
    });
}
var HashLink = genericHashLink((0, _reactRouterDom.Link));
var NavHashLink = genericHashLink((0, _reactRouterDom.NavLink));
var propTypes;

},{"react":"d8NEQ","prop-types":"jEkrD","react-router-dom":"hNarb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2SppC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _productTile = require("./ProductTile");
var _productTileDefault = parcelHelpers.interopDefault(_productTile);
const ProductsSection = ({ title, products, id, universalExpandCollapseState })=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(true);
    (0, _react.useEffect)(()=>{
        if (universalExpandCollapseState.lastEvent === "COLLAPSED_ALL" && isOpen) setIsOpen(false);
        if (universalExpandCollapseState.lastEvent === "EXPANDED_ALL" && !isOpen) setIsOpen(true);
    }, [
        universalExpandCollapseState
    ]);
    if (!products.length) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                id: `agency-${id}`,
                padding: "16px 0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CollapsibleSection), {
                    supportsTouch: false,
                    isOpen: isOpen,
                    title: title,
                    initiallyOpen: true,
                    toggleSection: ()=>setIsOpen(!isOpen),
                    customTitle: false,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Motion), {
                        variants: {
                            open: {
                                opacity: 1
                            },
                            closed: {
                                opacity: 0
                            }
                        },
                        initial: "open",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
                            justify: "flex-start",
                            align: "stretch",
                            childGap: "7px",
                            extraStyles: "padding: 1rem 0;",
                            children: products.map((product)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _productTileDefault.default), {
                                    id: product.id,
                                    text: product.name,
                                    validated: product.validated
                                }, product.id))
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {})
        ]
    });
};
exports.default = ProductsSection;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","./ProductTile":"8sDN7","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8sDN7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _productsStyled = require("./Products.styled");
var _reactRouterHashLink = require("react-router-hash-link");
const ProductTile = ({ text, id, validated })=>{
    const url = validated ? `/pos/search/${id}` : `/pos/lookup/${id}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _productsStyled.ProductTileWrapper), {
        rebrand: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterHashLink.HashLink), {
            to: url,
            children: text
        })
    });
};
exports.default = ProductTile;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","./Products.styled":"4f3cS","react-router-hash-link":"12dZL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4f3cS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AgencyTileWrapper", ()=>AgencyTileWrapper);
parcelHelpers.export(exports, "ProductTileWrapper", ()=>ProductTileWrapper);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _components = require("@thecb/components");
const AgencyTileWrapper = (0, _styledComponentsDefault.default).div`
  flex-grow: 1;
  display: flex;
  max-width: calc(33% - 5px);
  font-size: 1rem;

  a {
    flex-grow: 1;
    text-align: center;
    text-decoration: none;
    color: ${(0, _components.constants).colors.WHITE};
    position: relative;
    box-sizing: border-box;
    padding: 1rem 1.25rem;
    min-height: 4rem;
    background-color: ${(props)=>props.rebrand ? (0, _components.constants).colors.LUCKY_POINT : (0, _components.constants).colors.MATISSE_BLUE};
    border: 2px solid
      ${(props)=>props.rebrand ? (0, _components.constants).colors.LUCKY_POINT : (0, _components.constants).colors.MATISSE_BLUE};
    min-width: 250px;
    border-radius: 4px;
    transition: all 0.2s linear;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 1rem;
    font-weight: 600;

    &:hover {
      background: ${(props)=>props.rebrand ? (0, _components.constants).colors.LUCKY_POINT_DARK : "#0f5370"};
      border-color: ${(props)=>props.rebrand ? (0, _components.constants).colors.LUCKY_POINT_DARK : "#0f5370"};
    }
  }
`;
const ProductTileWrapper = (0, _styledComponentsDefault.default).div`
  flex-grow: 1;
  display: flex;
  max-width: calc(33% - 5px);
  font-size: 1rem;

  a {
    flex-grow: 1;
    text-align: center;
    text-decoration: none;
    color: ${(props)=>props.rebrand ? (0, _components.constants).colors.LUCKY_POINT : (0, _components.constants).colors.MATISSE_BLUE};
    position: relative;
    box-sizing: border-box;
    padding: 1rem 1.25rem;
    min-height: 4rem;
    background-color: ${(0, _components.constants).colors.WHITE};
    border: 2px solid
      ${(props)=>props.rebrand ? (0, _components.constants).colors.LUCKY_POINT : (0, _components.constants).colors.MATISSE_BLUE};
    min-width: 250px;
    border-radius: 4px;
    transition: all 0.2s linear;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 1rem;
    font-weight: 600;

    &:hover {
      background: ${(props)=>props.rebrand ? (0, _components.constants).colors.HAWKES_BLUE : "#dbeaf0"};
      border-color: ${(props)=>props.rebrand ? (0, _components.constants).colors.LUCKY_POINT : "#0f5370"};
    }
  }
`;

},{"styled-components":"bkusY","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2Bvl5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lookup = require("./Lookup");
var _lookupDefault = parcelHelpers.interopDefault(_lookup);
var _reactRedux = require("react-redux");
var _lookupState = require("./Lookup.state");
exports.default = (0, _reactRedux.connect)((0, _lookupState.mapStateToProps), (0, _lookupState.mapDispatchToProps))((0, _lookupDefault.default));

},{"./Lookup":"bWFhK","react-redux":"k6jol","./Lookup.state":"bEN0h","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bWFhK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _components = require("@thecb/components");
var _helpers = require("../../utils/helpers");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _formBlocks = require("../../components/form-blocks");
var _cartSidebar = require("../../components/cart-sidebar");
var _cartSidebarDefault = parcelHelpers.interopDefault(_cartSidebar);
var _reactRedux = require("react-redux");
var _sharedAlertBar = require("../../components/alert-bar/SharedAlertBar");
var _sharedAlertBarDefault = parcelHelpers.interopDefault(_sharedAlertBar);
var _lookupState = require("./Lookup.state");
const Header = ({ alertBar, alertBarActions })=>{
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                sharedAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharedAlertBarDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Add"
                })
            ]
        })
    });
};
const Lookup = ({ fetchLookupById, alertBars, actions })=>{
    const { id } = (0, _reactRouterDom.useParams)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const { isLoading: isLoadingLookup } = (0, _reactRedux.useSelector)((state)=>state.lookup);
    const { error: hasErrors, currentProduct: { status, fetching: isLoadingProduct, form_data, product_data, transforms, required_fields } } = (0, _reactRedux.useSelector)((state)=>state.products);
    const canRenderForm = !isLoadingProduct && !hasErrors && status === "success" && !!form_data && !!product_data;
    const initialFormData = (0, _reactRedux.useSelector)((state)=>state.formData);
    const [formData, setFormData] = (0, _react.useState)({
        inputValue: initialFormData
    });
    (0, _react.useEffect)(()=>{
        fetchLookupById(id);
    }, []);
    const onChange = (args, changedField)=>{
        if (!!transforms && transforms?.hasOwnProperty("replace")) {
            const newFormData = (0, _helpers.transformReplaceFormData)(args.formData, changedField, transforms);
            setFormData(newFormData);
        } else setFormData(args.formData);
    };
    const handleSubmit = (formData)=>{
        if (isLoadingLookup || !isFormAmountValid) return;
        const { amount, quantity, ...externalAttributes } = formData;
        dispatch((0, _lookupState.addToCartRequest)({
            receivables: [
                {
                    recorded_price: amount,
                    item_id: id,
                    artifact_items: {},
                    validated: product_data.validated,
                    accepts_underpayment: product_data.accepts_underpayment,
                    accepts_overpayment: product_data.accepts_overpayment,
                    receivable_category: product_data.receivable_category,
                    external_attributes: externalAttributes,
                    quantity
                }
            ],
            navigate,
            location
        }));
    };
    const isFormAmountValid = (0, _react.useMemo)(()=>{
        const amount = parseFloat(formData.amount);
        const isDiscountAllowed = form_data?.amount?.discount_allowed === true;
        if (isNaN(amount)) return false;
        return amount > 0 || isDiscountAllowed && amount !== 0;
    }, [
        formData.amount,
        form_data?.amount?.discount_allowed
    ]);
    const formActions = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "1rem 0 0 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            justify: "flex-end",
            align: "center",
            childGap: "1rem",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                    text: "Cancel",
                    type: "button",
                    url: "/pos/products",
                    isLoading: false,
                    variant: "secondary",
                    dataQa: "Cancel",
                    textExtraStyles: "font-size: 1rem;"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    type: "submit",
                    text: "Submit",
                    variant: "primary",
                    dataQa: "Submit",
                    disabled: isLoadingLookup || !isFormAmountValid,
                    isLoading: isLoadingLookup,
                    textExtraStyles: "font-size: 1rem;"
                })
            ]
        })
    });
    /* TODO
   ** abstract to a <Breadcrumbs /> component
   **/ const breadcrumbs = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0 0 1rem 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            direction: "row",
            justify: "flex-start",
            align: "center",
            childGap: "1rem",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                    extraStyles: "min-width: 0; margin: 0;",
                    url: "/pos/products",
                    text: product_data?.receivable_category,
                    variant: "smallGhost",
                    isLoading: false,
                    textExtraStyles: "font-size: 1rem;"
                }),
                ">",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                    children: product_data?.name
                })
            ]
        })
    });
    const lookupAttributes = form_data;
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.DisplayBox), {
        padding: "1rem 0",
        children: [
            isLoadingProduct && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                size: "100"
            }),
            canRenderForm && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    breadcrumbs,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formBlocks.DynamicLookupFieldGroup), {
                        attributes: lookupAttributes,
                        attributesGroupName: product_data.name,
                        requiredFields: required_fields,
                        submitForm: handleSubmit,
                        onChange: onChange,
                        formActions: formActions,
                        formData: formData,
                        setFormData: setFormData,
                        overrides: transforms
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SidebarSingleContent), {
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.lookupAlertBars,
            alertBarActions: actions.alertBars.lookupAlertBars
        }, "LookupHeader"),
        mainContent: content,
        sidebarContent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartSidebarDefault.default), {}),
        sidebarTargetWidth: "27.429rem",
        sidebarWrapperMaxWidth: "85.714rem",
        sidebarOnRight: true,
        childGap: "0.5rem"
    });
};
exports.default = Lookup;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-router-dom":"hNarb","@thecb/components":"g98ma","../../utils/helpers":"epomp","../../components/alert-bar":"aD416","../../components/form-blocks":"b6ROU","../../components/cart-sidebar":"l8jjH","react-redux":"k6jol","../../components/alert-bar/SharedAlertBar":"gk2Ni","./Lookup.state":"bEN0h","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cjVpo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _search = require("./Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _reactRedux = require("react-redux");
var _searchState = require("./Search.state");
exports.default = (0, _reactRedux.connect)((0, _searchState.mapStateToProps), (0, _searchState.mapDispatchToProps))((0, _searchDefault.default));

},{"./Search":"boPVm","react-redux":"k6jol","./Search.state":"lcTto","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"boPVm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _components = require("@thecb/components");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _cartSidebar = require("../../components/cart-sidebar");
var _cartSidebarDefault = parcelHelpers.interopDefault(_cartSidebar);
var _formBlocks = require("../../components/form-blocks");
var _reactRedux = require("react-redux");
var _sharedAlertBar = require("../../components/alert-bar/SharedAlertBar");
var _sharedAlertBarDefault = parcelHelpers.interopDefault(_sharedAlertBar);
const Header = ({ alertBar, alertBarActions })=>{
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                sharedAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharedAlertBarDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Search"
                })
            ]
        })
    });
};
const Search = ({ fetchSearchById, sendSearchRequest, alertBars, actions })=>{
    const { id } = (0, _reactRouterDom.useParams)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { isLoading: isLoadingSearch } = (0, _reactRedux.useSelector)((state)=>state.search);
    const { error: hasErrors, currentProduct: { status, fetching: isLoadingProduct, form_data: searchCriteria, product_data } } = (0, _reactRedux.useSelector)((state)=>state.products);
    const canRenderForm = !isLoadingProduct && !hasErrors && status === "success" && !!searchCriteria && !!product_data;
    (0, _react.useEffect)(()=>{
        fetchSearchById(id);
    }, []);
    const submitSearch = (formData)=>{
        sendSearchRequest({
            ...formData,
            id,
            navigate
        });
    };
    const formActions = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "1rem 0 0 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            justify: "flex-end",
            align: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                    text: "Cancel",
                    type: "button",
                    url: `/pos/products`,
                    isLoading: false,
                    variant: "secondary",
                    dataQa: "Cancel",
                    textExtraStyles: "font-size: 1rem;"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    type: "submit",
                    text: "Submit",
                    variant: "primary",
                    dataQa: "Submit",
                    disabled: isLoadingSearch,
                    isLoading: isLoadingSearch,
                    textExtraStyles: "font-size: 1rem;"
                })
            ]
        })
    });
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DisplayBox), {
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                isLoadingProduct && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                    size: "100"
                }),
                canRenderForm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formBlocks.InputByCriteria), {
                    submitForm: submitSearch,
                    criteria: searchCriteria,
                    criteriaGroupName: product_data?.name,
                    formActions: formActions
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SidebarSingleContent), {
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.searchAlertBars,
            alertBarActions: actions.alertBars.searchAlertBars
        }, "SearchHeader"),
        mainContent: content,
        sidebarContent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartSidebarDefault.default), {}),
        sidebarTargetWidth: "27.429rem",
        sidebarWrapperMaxWidth: "85.714rem",
        sidebarOnRight: true,
        childGap: "0.5rem"
    });
};
exports.default = Search;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-router-dom":"hNarb","@thecb/components":"g98ma","../../components/alert-bar":"aD416","../../components/cart-sidebar":"l8jjH","../../components/form-blocks":"b6ROU","react-redux":"k6jol","../../components/alert-bar/SharedAlertBar":"gk2Ni","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2ksg6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _searchResults = require("./SearchResults");
var _searchResultsDefault = parcelHelpers.interopDefault(_searchResults);
var _reactRedux = require("react-redux");
var _searchResultsState = require("./SearchResults.state");
exports.default = (0, _reactRedux.connect)((0, _searchResultsState.mapStateToProps), (0, _searchResultsState.mapDispatchToProps))((0, _searchResultsDefault.default));

},{"./SearchResults":"3FqcI","react-redux":"k6jol","./SearchResults.state":"04CNM","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3FqcI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _cartSidebar = require("../../components/cart-sidebar");
var _cartSidebarDefault = parcelHelpers.interopDefault(_cartSidebar);
var _searchResultsTable = require("./SearchResultsTable");
var _helpers = require("../../utils/helpers");
var _lookupState = require("../lookup/Lookup.state");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
const Header = ({ alertBar, alertBarActions })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Add Items"
                })
            ]
        })
    });
const SearchResults = ({ alertBars, actions, searchResults, selectedResults, selectedResultsTotal, accountData, updateResultAmount, updateResultAnnotation, toggleResultSelect, toggleSelectAll })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const currentProduct = (0, _reactRedux.useSelector)((state)=>state.products.currentProduct);
    const { annotation_allowed } = currentProduct.product_data;
    const annotationFields = annotation_allowed ? currentProduct.annotation_fields || [] : [];
    const requiredAnnotationFields = annotationFields.filter((f)=>f.required);
    const hasIncompleteAnnotations = requiredAnnotationFields.length > 0 && selectedResults.some((result)=>requiredAnnotationFields.some((field)=>!result.annotations?.[field.name]?.trim()));
    if (searchResults.length < 1) return null;
    const handleAddToCartClick = ()=>{
        const receivables = selectedResults.map((result)=>({
                description: result.description,
                recorded_subtotal: result.amount,
                recorded_price: result.recorded_price || result.amount,
                item_id: result.item_id,
                artifact_items: {},
                external_attributes: {
                    ...result.annotations,
                    ...result.external_attributes
                },
                external_uid: result.external_uid,
                validated: result.validated,
                accepts_underpayment: result.accepts_underpayment,
                accepts_overpayment: result.accepts_overpayment,
                receivable_category: result.receivable_category
            }));
        dispatch((0, _lookupState.addToCartRequest)({
            receivables,
            navigate,
            location
        }));
    };
    const accountInfo = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: accountData && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
            padding: "0.5rem",
            background: "#eee",
            "data-testid": "search-results-account-info",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    as: "h3",
                    variant: "small",
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Personal Information"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "0px 0px 0px 4px",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Stack), {
                        direction: "column",
                        childGap: "0",
                        width: "50%",
                        children: Object.entries(accountData).map(([key, value])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                        width: "8rem",
                                        padding: "0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Paragraph), {
                                            children: [
                                                key,
                                                ":"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                        padding: "0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                            children: value
                                        })
                                    })
                                ]
                            }, key))
                    })
                })
            ]
        })
    });
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.DisplayBox), {
        padding: "16px 0",
        children: [
            accountInfo,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                padding: "1rem 0",
                id: "search-results-body",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultsTable.SearchResultsTable), {
                        actions: {
                            toggleSelectAll,
                            toggleResultSelect,
                            updateResultAmount,
                            updateResultAnnotation
                        },
                        selectedTotal: selectedResultsTotal,
                        data: searchResults,
                        selected: selectedResults
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "1rem 0 0 0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    justify: "space-between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Paragraph), {
                            children: [
                                "Selected Total: ",
                                (0, _helpers.formatPrice)(selectedResultsTotal)
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                            justify: "flex-end",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                                    extraStyles: "border-radius: 4px;",
                                    url: "/pos",
                                    text: "Back",
                                    variant: "secondary",
                                    textExtraStyles: "font-size: 1rem;"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                    extraStyles: `
                border-radius: 4px;
                display: border-box;
              `,
                                    text: "Add To Cart",
                                    variant: "primary",
                                    disabled: selectedResults.length === 0 || hasIncompleteAnnotations,
                                    action: handleAddToCartClick,
                                    dataQa: "add-to-cart",
                                    textExtraStyles: "font-size: 1rem;"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SidebarSingleContent), {
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.searchResultsAlertBars,
            alertBarActions: actions.alertBars.searchResultsAlertBars
        }, "SearchResultsHeader"),
        mainContent: content,
        sidebarContent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartSidebarDefault.default), {}),
        sidebarTargetWidth: "27.429rem",
        sidebarWrapperMaxWidth: "85.714rem",
        sidebarOnRight: true,
        childGap: "0.5rem"
    });
};
exports.default = SearchResults;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../components/alert-bar":"aD416","../../components/cart-sidebar":"l8jjH","./SearchResultsTable":"VZevR","../../utils/helpers":"epomp","../lookup/Lookup.state":"bEN0h","react-redux":"k6jol","react-router-dom":"hNarb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"VZevR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchResultsTable", ()=>SearchResultsTable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _searchResultItem = require("./SearchResultItem");
var _reactRedux = require("react-redux");
const SearchResultsTable = ({ selected, data = [], actions })=>{
    const items = data;
    const { tableHeaders } = (0, _reactRedux.useSelector)((state)=>state.searchResults.data);
    const currentProduct = (0, _reactRedux.useSelector)((state)=>state.products.currentProduct);
    const { accepts_overpayment, accepts_underpayment, annotation_allowed } = currentProduct.product_data;
    const annotationFields = annotation_allowed ? currentProduct.annotation_fields || [] : [];
    const renderColumnHeaders = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
            padding: ".25rem",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                direction: "row",
                justify: "space-between",
                align: "center",
                nowrap: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "8px 0px 0px 8px",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                            id: "select-all",
                            name: "select-all",
                            checked: selected.length === items.length,
                            onChange: actions.toggleSelectAll
                        })
                    }),
                    tableHeaders.map((th, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            width: "115px",
                            padding: "0 8px 0 0",
                            extraStyles: "overflow-wrap: break-word; overflow: hidden;",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                variant: "p",
                                children: th
                            })
                        }, `${th}-${idx}`)),
                    annotationFields.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0 8px 0 0",
                            width: "200px",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                variant: "p",
                                children: field.display_name
                            })
                        }, field.name)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        width: "95px",
                        padding: "0",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            variant: "p",
                            children: "Amount"
                        })
                    }),
                    (accepts_overpayment || accepts_underpayment) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0",
                        width: "70px",
                        id: "edit-amount-column-header"
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
        padding: "1rem 0",
        children: [
            renderColumnHeaders(),
            items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchResultItem.SearchResultItem), {
                    item: item,
                    checked: Boolean(item.selected),
                    onCheckBoxClick: ()=>actions.toggleResultSelect(item.uniqueId),
                    handleAmountUpdate: actions.updateResultAmount,
                    handleAnnotationUpdate: actions.updateResultAnnotation,
                    annotationFields: annotationFields
                }, item.uniqueId))
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","./SearchResultItem":"11tce","react-redux":"k6jol","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"11tce":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchResultItem", ()=>SearchResultItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _rxjs = require("rxjs");
var _reactRedux = require("react-redux");
var _helpers = require("../../utils/helpers");
const SearchResultItem = ({ item, checked, onCheckBoxClick = (0, _rxjs.noop), handleAmountUpdate = (0, _rxjs.noop), handleAnnotationUpdate = (0, _rxjs.noop), annotationFields = [] })=>{
    const originalItemAmt = (0, _react.useRef)(item.amount); // cached for comparison by isAmountValid -> the searchResults redux state changes on submit and handles which amount is added to the cart
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [inlineAmount, setInlineAmount] = (0, _react.useState)(item.amount);
    const [inlineAmountError, setInlineAmountError] = (0, _react.useState)(false);
    const { currentProduct: { product_data: { accepts_overpayment, accepts_underpayment } } } = (0, _reactRedux.useSelector)((state)=>state.products);
    const isAmountValid = (amount)=>{
        const numericAmount = Number(amount);
        if (isNaN(numericAmount) || amount === "" || amount === null || amount === undefined || numericAmount === 0) return false;
        if (numericAmount < 0 && !item.discount_allowed) return false;
        else if (numericAmount > originalItemAmt.current && !accepts_overpayment) return false;
        else if (numericAmount < originalItemAmt.current && !accepts_underpayment) return false;
        else return true;
    };
    const renderEditAmountButton = ()=>/* if both accepts over/under payment are false, we don't need to show the button at all because the user can't modify the data with the edit form */ accepts_overpayment || accepts_underpayment ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
            minWidth: 0,
            variant: "smallGhost",
            action: ()=>setIsEditing(true),
            text: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PencilIcon), {
                ariaLabel: "Edit Amount"
            })
        }) : "";
    const renderIsEditingAmountButtons = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
            padding: "0",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    extraStyles: `min-width: 0; margin: 0.5rem 0;`,
                    extraDisabledStyles: `background-color: transparent; color: ${(0, _components.constants).colors.TROUT_GREY}; &:hover { text-decoration: none }`,
                    variant: "smallGhost",
                    action: ()=>{
                        handleAmountUpdate(item.uniqueId, inlineAmount);
                        setIsEditing(false);
                    },
                    disabled: inlineAmountError,
                    text: "Submit",
                    textExtraStyles: "font-size: 1rem;"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    extraStyles: `min-width: 0; margin: 0.5rem 0;`,
                    variant: "smallGhost",
                    action: ()=>{
                        // reset to given item amount and initial non-error state
                        setIsEditing(false);
                        setInlineAmount(item.amount);
                        setInlineAmountError(false);
                    },
                    text: "Cancel",
                    textExtraStyles: "font-size: 1rem;"
                })
            ]
        });
    const renderStaticAmountText = (item)=>{
        const formattedAmount = `$${(0, _helpers.removeLeadingMinus)((0, _helpers.formatCurrency)(item.amount))}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
            variant: "p",
            children: item.is_negative_amount || item.amount < 0 ? (0, _helpers.formatWithParentheses)(formattedAmount) : formattedAmount
        });
    };
    const renderEditAmountInput = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
            "data-testid": "search-edit-amount-input",
            type: "number",
            value: inlineAmount,
            onChange: (event)=>{
                const amount = event.currentTarget.value;
                setInlineAmount(amount);
                isAmountValid(amount) ? setInlineAmountError(false) : setInlineAmountError(true);
            }
        });
    const renderAmountError = (amount)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
            "data-testid": `search-item-amount-error`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Text), {
                color: (0, _components.constants).colors.THUNDERBIRD_RED,
                children: [
                    "$",
                    amount,
                    " is not a valid amount"
                ]
            })
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchResultItemWrapper, {
        "data-testid": "search-result-row",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
            padding: ".25rem",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    justify: "space-between",
                    align: "center",
                    nowrap: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "8px 0px 0px 8px",
                            "data-testid": "search-result-column",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Checkbox), {
                                name: item.external_uid?.toString(),
                                checked: checked,
                                error: item.error,
                                disabled: item.disabled,
                                focused: item.focused,
                                onChange: onCheckBoxClick
                            })
                        }),
                        item.table_values.map((value, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                padding: "0 8px 0 0",
                                width: "115px",
                                "data-testid": "search-result-column",
                                extraStyles: "overflow-wrap: break-word; overflow: hidden;",
                                children: value
                            }, `${value}-${idx}`)),
                        annotationFields.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                padding: "0 8px 0 0",
                                width: "200px",
                                "data-testid": "search-result-column",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnnotationInput, {
                                    "data-testid": `search-result-annotation-${field.name}`,
                                    type: "text",
                                    placeholder: field.required ? "Required" : "Optional",
                                    value: item.annotations?.[field.name] || "",
                                    onChange: (e)=>handleAnnotationUpdate(item.uniqueId, field.name, e.target.value),
                                    onBlur: (e)=>handleAnnotationUpdate(item.uniqueId, field.name, e.target.value.trim())
                                })
                            }, field.name)),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            width: "95px",
                            padding: "0",
                            "data-testid": "search-result-column",
                            children: isEditing ? renderEditAmountInput(item) : renderStaticAmountText(item)
                        }),
                        (accepts_overpayment || accepts_underpayment) && // If both accepts over/under payment are false, dont show the Edit Amount column at all because the user cant modify the data
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0",
                            width: "70px",
                            "data-testid": "search-result-column",
                            children: isEditing ? renderIsEditingAmountButtons() : renderEditAmountButton()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
                    justify: "flex-end",
                    align: "center",
                    children: inlineAmountError ? renderAmountError(inlineAmount) : (0, _rxjs.noop)()
                })
            ]
        })
    });
};
const SearchResultItemWrapper = (0, _styledComponentsDefault.default).div`
  &:nth-child(even) {
    background: #eee;
  }

  input[type='number'] {
    width: 80px;
  }
`;
const AnnotationInput = (0, _styledComponentsDefault.default).input`
  width: 100%;
  padding: 4px 8px;
  border: 1px solid ${(0, _components.constants).colors.TROUT_GREY};
  border-radius: 4px;
  font-size: 0.875rem;
  box-sizing: border-box;
`;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","styled-components":"bkusY","rxjs":"kbxjh","react-redux":"k6jol","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cNjw2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _layout = require("./Layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
exports.default = (0, _layoutDefault.default);

},{"./Layout":"8NYtv","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8NYtv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _header = require("../header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("../footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _errorBoundary = require("../error-boundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
var _reactIdleTimer = require("react-idle-timer");
var _constants = require("../../utils/constants");
var _reactRedux = require("react-redux");
var _idleModal = require("../idle-modal");
var _idleModalDefault = parcelHelpers.interopDefault(_idleModal);
var _visitExpirationModal = require("../visit-expiration-modal");
var _visitExpirationModalDefault = parcelHelpers.interopDefault(_visitExpirationModal);
var _visitExpirationState = require("../../pages/cart/VisitExpiration.state");
var _oktaReact = require("@okta/okta-react");
var _useLogoutTimers = require("../../utils/hooks/useLogoutTimers");
var _useLogoutTimersDefault = parcelHelpers.interopDefault(_useLogoutTimers);
var _state = require("../../utils/state");
const Layout = ({ isLoggedIn, hasTerminalSession })=>{
    const { oktaAuth } = (0, _oktaReact.useOktaAuth)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const initialTimeLeftToLogoutSeconds = 30;
    const [idleModalOpen, toggleIdleModal] = (0, _react.useState)(false);
    const [logoutTimerOn, toggleLogoutTimer] = (0, _react.useState)(false);
    const [timeLeftToLogout, setTimeLeft] = (0, _react.useState)(initialTimeLeftToLogoutSeconds);
    const config = (0, _reactRedux.useSelector)((state)=>state.config);
    const idleLogout = async ()=>{
        window.clearInterval(logoutTimers.interval);
        dispatch((0, _visitExpirationState.clearVisitExpiration)());
        toggleIdleModal(false);
        toggleLogoutTimer(false);
        localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), (0, _constants.LOGOUT_REASONS).INACTIVITY.name);
        setTimeLeft(initialTimeLeftToLogoutSeconds);
        navigate("/logout");
        await oktaAuth.signOut({
            postLogoutRedirectUri: window.location.origin
        });
        oktaAuth.tokenManager.clear();
        (0, _state.clearLocalStorageSession)();
    };
    const handleOnIdle = ()=>{
        if (!isLoggedIn) return;
        toggleIdleModal(true);
        toggleLogoutTimer(true);
    };
    (0, _reactIdleTimer.useIdleTimer)({
        timeout: 870000,
        onIdle: handleOnIdle,
        debounce: 500
    });
    const logoutTimers = (0, _useLogoutTimersDefault.default)({
        logoutTimerOn,
        action: idleLogout,
        timeLeftToLogout,
        handleSetTimeLeft: setTimeLeft,
        initialTimeLeftToLogoutSeconds
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {
                isLoggedIn: isLoggedIn,
                hasTerminalSession: hasTerminalSession
            }, "main-header"),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _errorBoundaryDefault.default), {
                config: config,
                navigate: navigate,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visitExpirationModalDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _idleModalDefault.default), {
                        modalOpen: idleModalOpen,
                        toggleModal: toggleIdleModal,
                        timeLeftToLogout: timeLeftToLogout,
                        totalLogoutTime: initialTimeLeftToLogoutSeconds,
                        logout: idleLogout,
                        cancelLogout: ()=>{
                            window.clearInterval(logoutTimers.interval);
                            window.clearTimeout(logoutTimers.timer);
                            setTimeLeft(initialTimeLeftToLogoutSeconds);
                            toggleIdleModal(false);
                            toggleLogoutTimer(false);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {}, "main-footer")
        ]
    });
};
exports.default = Layout;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-router-dom":"hNarb","../header":"cLmrh","../footer":"elljW","../error-boundary":"eGpUX","react-idle-timer":"5k0wL","../../utils/constants":"f3A1R","react-redux":"k6jol","../idle-modal":"bJiGL","../visit-expiration-modal":"8il5Y","../../pages/cart/VisitExpiration.state":"6xsNt","@okta/okta-react":"3286W","../../utils/hooks/useLogoutTimers":"ddX7o","../../utils/state":"8UPqD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cLmrh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _header = require("./Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
exports.default = (0, _headerDefault.default);

},{"./Header":"akrP5","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"akrP5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reactRedux = require("react-redux");
var _eunaCashieringSvg = require("../../static/img/euna-cashiering.svg");
var _eunaCashieringSvgDefault = parcelHelpers.interopDefault(_eunaCashieringSvg);
var _peripheralDevices = require("../../state/peripheralDevices");
var _headerTheme = require("./Header.theme");
var _constants = require("../../utils/constants");
var _reducer = require("../../state/reducer");
var _helpersJs = require("../../utils/helpers.js");
var _shared = require("../../state/shared");
var _reactRouterDom = require("react-router-dom");
const { theme: { themeComponent } } = (0, _components.util);
/**
 * TODO:
 * Update this entire component with dynamic POS specific user data.
 * It still contains references such values as firstname, lastname, email, etc.
 * Instead, it should have POS references such as cashier role, location, terminal.
 */ const CashierToolsMenu = ({ themeValues = {}, navMenuOpen, setNavMenuOpen })=>{
    let menuTimeoutID;
    const location = (0, _reactRouterDom.useLocation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const cashierToolsButton = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        onMouseEnter: ()=>{
            if (menuTimeoutID) clearTimeout(menuTimeoutID);
            setNavMenuOpen(true);
        },
        onMouseLeave: ()=>{
            menuTimeoutID = setTimeout(()=>setNavMenuOpen(false), 400);
        },
        onClick: ()=>{
            setNavMenuOpen(!navMenuOpen);
        },
        ariaControls: "navigation",
        ariaLabel: "Menu",
        type: "button",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
            variant: "tertiary",
            contentOverride: true,
            extraStyles: `margin: 0; line-height: 0.5;`,
            textExtraStyles: "line-height: 0.5;",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                    variant: "p",
                    color: themeValues.linkColor,
                    extraStyles: `display: inline-block; vertical-align: super;`,
                    children: "Cashier Tools"
                })
            })
        })
    });
    const menuContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
        padding: "0",
        childGap: "0",
        bottomItem: ``,
        role: "navigation",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "0.5rem",
                hoverStyles: `background-color: ${(0, _components.constants).colors.LUCKY_POINT_DARK}`,
                minWidth: "100%",
                onBlur: ()=>menuTimeoutID = setTimeout(()=>setNavMenuOpen(false), 200),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.InternalLink), {
                    to: "/pos/cashdrop",
                    variant: "whitePrimary",
                    extraStyles: `&:hover { text-decoration: none }; text-decoration: none`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        variant: "p",
                        color: themeValues.linkColor,
                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                        extraStyles: `margin-left: 1rem; text-decoration: none`,
                        children: "Cash Drop"
                    })
                })
            }, "cashdrop"),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "0.5rem",
                hoverStyles: `background-color: ${(0, _components.constants).colors.LUCKY_POINT_DARK}`,
                minWidth: "100%",
                onBlur: ()=>menuTimeoutID = setTimeout(()=>setNavMenuOpen(false), 400),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.InternalLink), {
                    to: "/pos/closeout",
                    variant: "whitePrimary",
                    extraStyles: `&:hover { text-decoration: none }; text-decoration: none`,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        variant: "p",
                        color: themeValues.linkColor,
                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                        extraStyles: `margin-left: 1rem; text-decoration: none`,
                        children: "Closeout"
                    })
                })
            }, "closeout"),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "0.5rem 0.5rem 0.5rem 0",
                hoverStyles: `background-color: ${(0, _components.constants).colors.LUCKY_POINT_DARK}`,
                onBlur: ()=>menuTimeoutID = setTimeout(()=>setNavMenuOpen(false), 400),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    padding: "0",
                    extraStyles: `margin: 0; background-color: transparent;`,
                    textExtraStyles: `font-size: 1rem;`,
                    variant: "tertiary",
                    text: "Open Drawer",
                    action: ()=>dispatch((0, _peripheralDevices.openCashDrawer)({
                            location
                        }))
                })
            }, "open-drawer")
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
        padding: "0",
        extraStyles: `position: relative; z-index: 100;`,
        children: [
            cashierToolsButton,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.NavMenuDesktop), {
                top: "100%",
                left: "-100%",
                menuContent: menuContent,
                visible: navMenuOpen,
                onMouseLeave: ()=>menuTimeoutID = setTimeout(()=>setNavMenuOpen(false), 400),
                onMouseEnter: ()=>clearTimeout(menuTimeoutID),
                onFocus: ()=>clearTimeout(menuTimeoutID)
            })
        ]
    });
};
const Header = ({ themeValues = {}, isLoggedIn, userFirstName = "", userLastName = "", terminal, location, batchNumber, routing, hasTerminalSession })=>{
    const { currentAbilities } = (0, _reactRedux.useSelector)((state)=>state.shared);
    const { clientId } = (0, _reactRedux.useSelector)((state)=>state.terminalLogin);
    const [navMenuOpen, setNavMenuOpen] = (0, _react.useState)(false);
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(()=>{
        if (clientId) dispatch((0, _shared.fetchClientConfigRequest)(clientId));
    }, [
        clientId
    ]);
    (0, _react.useEffect)(()=>{
        if (isLoggedIn) dispatch((0, _shared.fetchCurrentAbilitiesRequest)());
    }, [
        isLoggedIn
    ]);
    const headerLogo = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        minHeight: "100%",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cover), {
            minHeight: "100%",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: (0, _eunaCashieringSvgDefault.default),
                width: "228px",
                height: "40px",
                alt: "Euna Cashiering"
            })
        })
    });
    const mainNavContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Cluster), {
        align: "center",
        direction: "row",
        overflow: "true",
        children: isLoggedIn && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                hasTerminalSession && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0.5rem",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.InternalLink), {
                                to: "/pos",
                                variant: "whitePrimary",
                                extraStyles: `&:hover { text-decoration: none }; text-decoration-color: ${themeValues.linkColor}; text-decoration: none `,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                    variant: "p",
                                    color: themeValues.linkColor,
                                    extraStyles: `margin-left: 1rem; text-decoration: none`,
                                    children: "Home"
                                })
                            })
                        }, "home"),
                        (0, _helpersJs.can)("show", "reporting_navigation_link", currentAbilities) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0.5rem",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.InternalLink), {
                                to: "/pos/reporting",
                                variant: "whitePrimary",
                                extraStyles: `&:hover { text-decoration: none }; text-decoration-color: ${themeValues.linkColor}; text-decoration: none `,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                    variant: "p",
                                    color: themeValues.linkColor,
                                    extraStyles: `margin-left: 1rem; text-decoration: none`,
                                    children: "Reporting"
                                })
                            })
                        }, "reports"),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0.5rem",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.InternalLink), {
                                to: "/pos/orders",
                                variant: "whitePrimary",
                                extraStyles: `&:hover { text-decoration: none }; text-decoration-color: ${themeValues.linkColor}; text-decoration: none `,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                    variant: "p",
                                    color: themeValues.linkColor,
                                    extraStyles: `margin-left: 1rem; text-decoration: none`,
                                    children: "Orders"
                                })
                            })
                        }, "orders"),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0.5rem",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.InternalLink), {
                                to: "/pos/drawer-history",
                                variant: "whitePrimary",
                                extraStyles: `&:hover { text-decoration: none }; text-decoration-color: ${themeValues.linkColor}; text-decoration: none`,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                    variant: "p",
                                    color: themeValues.linkColor,
                                    extraStyles: `margin-left: 1rem; text-decoration: none `,
                                    children: "Drawer History"
                                })
                            })
                        }, "drawer-history"),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(CashierToolsMenu, {
                            themeValues: themeValues,
                            routing: routing,
                            navMenuOpen: navMenuOpen,
                            setNavMenuOpen: setNavMenuOpen
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                            color: themeValues.linkColor,
                            children: " | "
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "0.5rem 0",
                    minWidth: "0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        minWidth: "0",
                        variant: "tertiary",
                        text: "Log Out",
                        textExtraStyles: `
            font-size: 1rem;
            font-weight: normal;
          `,
                        action: ()=>{
                            setNavMenuOpen(false);
                            localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), (0, _constants.LOGOUT_REASONS).USER_INITIATED.name);
                            dispatch((0, _reducer.logout)({
                                navigate
                            }));
                        }
                    })
                }, "logout")
            ]
        })
    });
    const subHeaderLeftContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
        align: "center",
        childGap: "0.5rem",
        overflow: "visible",
        margin: "0",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                extraStyles: `font-size: 1rem;`,
                children: "Cashier:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Detail), {
                margin: "none",
                extraStyles: `font-size: 1rem;`,
                weight: "700",
                children: [
                    userFirstName,
                    " ",
                    userLastName
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                children: "|"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                extraStyles: `font-size: 1rem;`,
                children: "Location:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                extraStyles: `font-size: 1rem;`,
                weight: "700",
                children: location
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                children: "|"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                extraStyles: `font-size: 1rem;`,
                children: "Terminal:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                extraStyles: `font-size: 1rem;`,
                weight: "700",
                children: terminal
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                children: "|"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                extraStyles: `font-size: 1rem;`,
                children: "Batch No:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                margin: "none",
                extraStyles: `font-size: 1rem;`,
                weight: "700",
                children: batchNumber
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
            padding: "0",
            role: "banner",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.NavHeader), {
                    headerHeight: "104px",
                    backgroundColor: themeValues.backgroundColor,
                    leftContent: headerLogo,
                    rightContent: mainNavContent,
                    extraStyles: `z-index: 0.5`,
                    headerWidth: "85.714rem"
                }, "header"),
                isLoggedIn && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.NavHeader), {
                    leftContent: subHeaderLeftContent,
                    backgroundColor: themeValues.linkColor,
                    role: "contentinfo",
                    "aria-label": "subheader",
                    headerHeight: "54px",
                    headerWidth: "85.714rem",
                    extraStyles: `z-index: 1; box-shadow: 0px 1px 2px -2px #292A331A, 0px 3px 6px -1px #292A3354, 0px 1px 0px 0px #E5E7EC inset;
            `
                }, "sub-header")
            ]
        })
    });
};
const mapStateToProps = (state)=>{
    return {
        userFirstName: state?.login?.cashier?.first_name ?? "",
        userLastName: state?.login?.cashier?.last_name ?? "",
        userRole: state?.login?.cashier?.role ?? "",
        terminal: state?.terminalLogin?.terminalSession?.terminal ?? "",
        location: state?.terminalLogin?.terminalSession?.location ?? "",
        batchNumber: state?.terminalLogin?.terminalSession?.uuid ?? ""
    };
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _components.withWindowSize)(/*#__PURE__*/ (0, _react.memo)(themeComponent(Header, "Header", (0, _headerTheme.fallbackValues)))));

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","react-redux":"k6jol","../../static/img/euna-cashiering.svg":"16pAn","../../state/peripheralDevices":"3U6I5","./Header.theme":"9yNx6","../../utils/constants":"f3A1R","../../state/reducer":"aTwKq","../../utils/helpers.js":"epomp","../../state/shared":"h0jLC","react-router-dom":"hNarb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"16pAn":[function(require,module,exports) {
module.exports = require("ea3516dfdf5bf944").getBundleURL("jLXBE") + "euna-cashiering.35144e48.svg";

},{"ea3516dfdf5bf944":"gJ0PF"}],"9yNx6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fallbackValuesLegacy", ()=>fallbackValuesLegacy);
parcelHelpers.export(exports, "fallbackValues", ()=>fallbackValues);
const backgroundColor = "#281978";
const linkColor = "#ffffff";
const fallbackValuesLegacy = {
    backgroundColor: "#3b414d",
    linkColor: "#ffffff"
};
const fallbackValues = {
    backgroundColor,
    linkColor
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"elljW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _footer = require("./Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
exports.default = (0, _footerDefault.default);

},{"./Footer":"kKX0s","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kKX0s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _eunaLogoSvg = require("../../static/img/euna-logo.svg");
var _eunaLogoSvgDefault = parcelHelpers.interopDefault(_eunaLogoSvg);
var _footerTheme = require("./Footer.theme");
var _launchdarklyReactClientSdk = require("launchdarkly-react-client-sdk");
const { theme: { themeComponent } } = (0, _components.util);
const Footer = ({ themeValues = {} })=>{
    const flags = (0, _launchdarklyReactClientSdk.useFlags)();
    const footerRightContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
            as: "p",
            size: "1rem",
            color: themeValues.linkColor,
            title: flags["pay-with-device-payment-service"] ? "DPS" : "",
            children: "Cashiering"
        })
    });
    const footerLeftContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Stack), {
        justify: "center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _eunaLogoSvgDefault.default),
            width: "70px",
            height: "28px",
            alt: "Euna Solutions"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Stack), {
        childGap: "0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.NavFooter), {
            leftContent: footerLeftContent,
            rightContent: footerRightContent,
            backgroundColor: themeValues.backgroundColor,
            role: "contentinfo",
            "aria-label": "footer"
        }, "main-footer")
    });
};
exports.default = (0, _components.withWindowSize)(/*#__PURE__*/ (0, _react.memo)(themeComponent(Footer, "Footer", (0, _footerTheme.fallbackValues))));

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../static/img/euna-logo.svg":"HlX61","./Footer.theme":"6qYUF","launchdarkly-react-client-sdk":"3xmjG","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"HlX61":[function(require,module,exports) {
module.exports = require("dae4e5a49f6e72c9").getBundleURL("jLXBE") + "euna-logo.69d122b9.svg";

},{"dae4e5a49f6e72c9":"gJ0PF"}],"6qYUF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fallbackValues", ()=>fallbackValues);
parcelHelpers.export(exports, "fallbackValuesLegacy", ()=>fallbackValuesLegacy);
const backgroundColor = "#281978";
const linkColor = "#ffffff";
const fallbackValues = {
    backgroundColor,
    linkColor
};
const fallbackValuesLegacy = {
    backgroundColor: "#3b414d",
    linkColor
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eGpUX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errorBoundary = require("./ErrorBoundary");
var _errorBoundaryDefault = parcelHelpers.interopDefault(_errorBoundary);
exports.default = (0, _errorBoundaryDefault.default);

},{"./ErrorBoundary":"xbXcV","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"xbXcV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// import { connect } from 'react-redux';
var _components = require("@thecb/components");
var _errorBoundaryStyled = require("./ErrorBoundary.styled");
var _browser = require("@airbrake/browser");
var _constants = require("../../utils/constants");
class ErrorBoundary extends (0, _reactDefault.default).Component {
    constructor(props1){
        super(props1);
        this.handleContinue = this.handleContinue.bind(this);
        this.state = {
            hasError: false
        };
        if (this.props.config && this.props.config.environment !== (0, _constants.ENVIRONMENTS).LOCAL) this.airbrake = new (0, _browser.Notifier)({
            projectId: props1.config.airbrakeProjectId,
            projectKey: props1.config.airbrakeProjectKey,
            environment: props1.config.environment
        });
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    /*
   * error: string
   * info: object { componentStack: string }
   */ componentDidCatch(error, info) {
        // The JS error and relevant information from the app bubble up
        // and are caught here. They do not crash they app, but are logged and sent to reporting
        const errorLogText = `
      Error Boundary Log
      ==================
      Error: ${error.stack}
      ==================
      Info: ${info.componentStack}
    `;
        console.log(errorLogText);
        this.airbrake?.notify({
            error: error,
            params: {
                info: info
            }
        });
    }
    handleContinue() {
        /**
     * How should POS handle app level errors?
     * - Static page with error info and force user to refresh
     * - Static page with error info and timeout -> automatic navigate to /index or /logout
     * - Page with button to return to go back/to home? GOING WITH THIS FOR NOW
     */ this.setState({
            hasError: false
        });
        props.navigate("/");
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _errorBoundaryStyled.ContentWrapper), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    as: "h2",
                    children: "The Cashiering web app has encountered an error."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    onClick: this.handleContinue,
                    children: "Home"
                })
            ]
        });
        return this.props.children;
    }
}
/**
 * TODO:
 * Determine whether this component should be integrated with redux so
 * If so, utilize mapping and connect functions here. Will effect testing.
 */ // const mapStateToProps = (state) => ({});
// const mapDispatchToProps = {};
// export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
exports.default = ErrorBoundary;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","./ErrorBoundary.styled":"8JBM3","@airbrake/browser":"1cMw2","../../utils/constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8JBM3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContentWrapper", ()=>ContentWrapper);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const ContentWrapper = (0, _styledComponentsDefault.default).div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

},{"styled-components":"bkusY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5k0wL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_EVENTS", ()=>ge);
parcelHelpers.export(exports, "IdleTimerConsumer", ()=>St);
parcelHelpers.export(exports, "IdleTimerContext", ()=>ue);
parcelHelpers.export(exports, "IdleTimerProvider", ()=>Pt);
parcelHelpers.export(exports, "createMocks", ()=>wt);
parcelHelpers.export(exports, "useIdleTimer", ()=>$);
parcelHelpers.export(exports, "useIdleTimerContext", ()=>At);
parcelHelpers.export(exports, "withIdleTimer", ()=>gt);
parcelHelpers.export(exports, "workerTimers", ()=>Z);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ct = Object.create, Ie = Object.defineProperty;
var mt = Object.getOwnPropertyDescriptor;
var dt = Object.getOwnPropertyNames;
var pt = Object.getPrototypeOf, ft = Object.prototype.hasOwnProperty;
var ht = (t)=>Ie(t, "__esModule", {
        value: !0
    });
var vt = (t, e)=>()=>(e || t((e = {
            exports: {}
        }).exports, e), e.exports);
var Tt = (t, e, n)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let r of dt(e))!ft.call(t, r) && r !== "default" && Ie(t, r, {
        get: ()=>e[r],
        enumerable: !(n = mt(e, r)) || n.enumerable
    });
    return t;
}, It = (t)=>Tt(ht(Ie(t != null ? ct(pt(t)) : {}, "default", t && t.__esModule && "default" in t ? {
        get: ()=>t.default,
        enumerable: !0
    } : {
        value: t,
        enumerable: !0
    })), t);
var Ue = vt((ie, Fe)=>{
    (function(t, e) {
        typeof ie == "object" && typeof Fe != "undefined" ? e(ie) : typeof define == "function" && define.amd ? define([
            "exports"
        ], e) : (t = typeof globalThis != "undefined" ? globalThis : t || self, e(t.fastUniqueNumbers = {}));
    })(ie, function(t) {
        "use strict";
        var e = function(p) {
            return function(h) {
                var o = p(h);
                return h.add(o), o;
            };
        }, n = function(p) {
            return function(h, o) {
                return p.set(h, o), o;
            };
        }, r = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, a = 536870912, u = a * 2, b = function(p, h) {
            return function(o) {
                var x = h.get(o), M = x === void 0 ? o.size : x < u ? x + 1 : 0;
                if (!o.has(M)) return p(o, M);
                if (o.size < a) {
                    for(; o.has(M);)M = Math.floor(Math.random() * u);
                    return p(o, M);
                }
                if (o.size > r) throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
                for(; o.has(M);)M = Math.floor(Math.random() * r);
                return p(o, M);
            };
        }, W = new WeakMap, ee = n(W), m = b(ee, W), c = e(m);
        t.addUniqueNumber = c, t.generateUniqueNumber = m, Object.defineProperty(t, "__esModule", {
            value: !0
        });
    });
});
function gt(t) {
    return (0, _react.forwardRef)(function(n, r) {
        let a = {
            ...n
        };
        !a.onPrompt && t.prototype.onPrompt && (a.onPrompt = ()=>{
            t.prototype.onPrompt();
        }), !a.onIdle && t.prototype.onIdle && (a.onIdle = ()=>{
            t.prototype.onIdle();
        }), !a.onActive && t.prototype.onActive && (a.onActive = (b)=>{
            t.prototype.onActive(b);
        }), !a.onAction && t.prototype.onAction && (a.onAction = (b)=>{
            t.prototype.onAction(b);
        });
        let u = $(a);
        return typeof r == "function" ? r(u) : r && (r.current = u), (0, _reactDefault.default).createElement(t, {
            ...n,
            ...u
        });
    });
}
var K = It(Ue());
var We = (t)=>t.method !== void 0 && t.method === "call";
var Be = (t)=>t.error === null && typeof t.id == "number";
var Ve = (t)=>{
    let e = new Map([
        [
            0,
            ()=>{}
        ]
    ]), n = new Map([
        [
            0,
            ()=>{}
        ]
    ]), r = new Map, a = new Worker(t);
    return a.addEventListener("message", ({ data: m })=>{
        if (We(m)) {
            let { params: { timerId: c, timerType: d } } = m;
            if (d === "interval") {
                let p = e.get(c);
                if (typeof p == "number") {
                    let h = r.get(p);
                    if (h === void 0 || h.timerId !== c || h.timerType !== d) throw new Error("The timer is in an undefined state.");
                } else if (typeof p != "undefined") p();
                else throw new Error("The timer is in an undefined state.");
            } else if (d === "timeout") {
                let p = n.get(c);
                if (typeof p == "number") {
                    let h = r.get(p);
                    if (h === void 0 || h.timerId !== c || h.timerType !== d) throw new Error("The timer is in an undefined state.");
                } else if (typeof p != "undefined") p(), n.delete(c);
                else throw new Error("The timer is in an undefined state.");
            }
        } else if (Be(m)) {
            let { id: c } = m, d = r.get(c);
            if (d === void 0) throw new Error("The timer is in an undefined state.");
            let { timerId: p, timerType: h } = d;
            r.delete(c), h === "interval" ? e.delete(p) : n.delete(p);
        } else {
            let { error: { message: c } } = m;
            throw new Error(c);
        }
    }), {
        clearInterval: (m)=>{
            let c = (0, K.generateUniqueNumber)(r);
            r.set(c, {
                timerId: m,
                timerType: "interval"
            }), e.set(m, c), a.postMessage({
                id: c,
                method: "clear",
                params: {
                    timerId: m,
                    timerType: "interval"
                }
            });
        },
        clearTimeout: (m)=>{
            let c = (0, K.generateUniqueNumber)(r);
            r.set(c, {
                timerId: m,
                timerType: "timeout"
            }), n.set(m, c), a.postMessage({
                id: c,
                method: "clear",
                params: {
                    timerId: m,
                    timerType: "timeout"
                }
            });
        },
        setInterval: (m, c)=>{
            let d = (0, K.generateUniqueNumber)(e);
            return e.set(d, ()=>{
                m(), typeof e.get(d) == "function" && a.postMessage({
                    id: null,
                    method: "set",
                    params: {
                        delay: c,
                        now: performance.now(),
                        timerId: d,
                        timerType: "interval"
                    }
                });
            }), a.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: c,
                    now: performance.now(),
                    timerId: d,
                    timerType: "interval"
                }
            }), d;
        },
        setTimeout: (m, c)=>{
            let d = (0, K.generateUniqueNumber)(n);
            return n.set(d, m), a.postMessage({
                id: null,
                method: "set",
                params: {
                    delay: c,
                    now: performance.now(),
                    timerId: d,
                    timerType: "timeout"
                }
            }), d;
        }
    };
};
var Q = null, He = (t, e)=>()=>{
        if (Q !== null) return Q;
        let n = new Blob([
            e
        ], {
            type: "application/javascript; charset=utf-8"
        }), r = URL.createObjectURL(n);
        return Q = t(r), Q.setTimeout(()=>URL.revokeObjectURL(r), 0), Q;
    };
var Ge = `(()=>{"use strict";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:"call",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener("message",(i=>{let{data:s}=i;try{if("clear"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if("interval"===i)(t=>{const r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id "'.concat(t,'".'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if("timeout"!==i)throw new Error('The given type "'.concat(i,'" is not supported'));(e=>{const r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if("set"!==s.method)throw new Error('The given method "'.concat(s.method,'" is not supported'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if("interval"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,"interval"))})(i,a,n);else{if("timeout"!==d)throw new Error('The given type "'.concat(d,'" is not supported'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,"timeout"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();`;
var se = He(Ve, Ge), qe = (t)=>se().clearInterval(t), je = (t)=>se().clearTimeout(t), Ye = (t, e)=>se().setInterval(t, e), Je = (t, e)=>se().setTimeout(t, e);
var w = (typeof window == "undefined" ? "undefined" : typeof window) == "object";
var T = {
    setTimeout: w ? setTimeout.bind(window) : setTimeout,
    clearTimeout: w ? clearTimeout.bind(window) : clearTimeout,
    setInterval: w ? setInterval.bind(window) : setInterval,
    clearInterval: w ? clearInterval.bind(window) : clearInterval
}, Z = {
    setTimeout: Je,
    clearTimeout: je,
    setInterval: Ye,
    clearInterval: qe
};
function wt() {
    T.setTimeout = setTimeout, T.clearTimeout = clearTimeout, T.setInterval = setInterval, T.clearInterval = clearInterval, Z.setTimeout = setTimeout, Z.clearTimeout = clearTimeout, Z.setInterval = setInterval, Z.clearInterval = clearInterval;
}
function ze(t) {
    T.setTimeout = t.setTimeout, T.clearTimeout = t.clearTimeout, T.setInterval = t.setInterval, T.clearInterval = t.clearInterval;
}
var Y = {}, Xe = class {
    constructor(e){
        this.closed = !1;
        this.mc = new MessageChannel;
        this.name = e, Y[e] = Y[e] || [], Y[e].push(this), this.mc.port1.start(), this.mc.port2.start(), this.onStorage = this.onStorage.bind(this), window.addEventListener("storage", this.onStorage);
    }
    onStorage(e) {
        if (e.storageArea !== window.localStorage || e.key.substring(0, this.name.length) !== this.name || e.newValue === null) return;
        let n = JSON.parse(e.newValue);
        this.mc.port2.postMessage(n);
    }
    postMessage(e) {
        if (this.closed) throw new Error("InvalidStateError");
        let n = JSON.stringify(e), r = `${this.name}:${String(Date.now())}${String(Math.random())}`;
        window.localStorage.setItem(r, n), T.setTimeout(()=>{
            window.localStorage.removeItem(r);
        }, 500), Y[this.name].forEach((a)=>{
            a !== this && a.mc.port2.postMessage(JSON.parse(n));
        });
    }
    close() {
        if (this.closed) return;
        this.closed = !0, this.mc.port1.close(), this.mc.port2.close(), window.removeEventListener("storage", this.onStorage);
        let e = Y[this.name].indexOf(this);
        Y[this.name].splice(e, 1);
    }
    get onmessage() {
        return this.mc.port1.onmessage;
    }
    set onmessage(e) {
        this.mc.port1.onmessage = e;
    }
    get onmessageerror() {
        return this.mc.port1.onmessageerror;
    }
    set onmessageerror(e) {
        this.mc.port1.onmessageerror = e;
    }
    addEventListener(e, n) {
        return this.mc.port1.addEventListener(e, n);
    }
    removeEventListener(e, n) {
        return this.mc.port1.removeEventListener(e, n);
    }
    dispatchEvent(e) {
        return this.mc.port1.dispatchEvent(e);
    }
}, $e = typeof window == "undefined" ? void 0 : typeof window.BroadcastChannel == "function" ? window.BroadcastChannel : Xe;
function Ke(t = 0) {
    return new Promise((e)=>T.setTimeout(e, t));
}
function ae() {
    return Math.random().toString(36).substring(2);
}
var l;
(function(o) {
    o[o.APPLY = 0] = "APPLY", o[o.TELL = 1] = "TELL", o[o.CLOSE = 2] = "CLOSE", o[o.REGISTER = 3] = "REGISTER", o[o.DEREGISTER = 4] = "DEREGISTER", o[o.IDLE = 5] = "IDLE", o[o.ACTIVE = 6] = "ACTIVE", o[o.PROMPT = 7] = "PROMPT", o[o.START = 8] = "START", o[o.RESET = 9] = "RESET", o[o.ACTIVATE = 10] = "ACTIVATE", o[o.PAUSE = 11] = "PAUSE", o[o.RESUME = 12] = "RESUME", o[o.MESSAGE = 13] = "MESSAGE";
})(l || (l = {}));
var Ee = class {
    constructor(e, n){
        this.token = ae();
        this.isLeader = !1;
        this.isDead = !1;
        this.isApplying = !1;
        this.reApply = !1;
        this.intervals = [];
        this.listeners = [];
        this.channel = e, this.options = n, this.apply = this.apply.bind(this), this.awaitLeadership = this.awaitLeadership.bind(this), this.sendAction = this.sendAction.bind(this);
    }
    async apply() {
        if (this.isLeader || this.isDead) return !1;
        if (this.isApplying) return this.reApply = !0, !1;
        this.isApplying = !0;
        let e = !1, n = (r)=>{
            let { token: a, action: u } = r.data;
            a !== this.token && (u === l.APPLY && a > this.token && (e = !0), u === l.TELL && (e = !0));
        };
        this.channel.addEventListener("message", n);
        try {
            return this.sendAction(l.APPLY), await Ke(this.options.responseTime), this.channel.removeEventListener("message", n), this.isApplying = !1, e ? this.reApply ? this.apply() : !1 : (this.assumeLead(), !0);
        } catch  {
            return !1;
        }
    }
    awaitLeadership() {
        if (this.isLeader) return Promise.resolve();
        let e = !1, n = null;
        return new Promise((r)=>{
            let a = ()=>{
                if (e) return;
                e = !0, T.clearInterval(n);
                let b = this.intervals.indexOf(n);
                this.intervals.splice(b, 1), this.channel.removeEventListener("message", u), r();
            };
            n = T.setInterval(()=>{
                this.apply().then(()=>{
                    this.isLeader && a();
                });
            }, this.options.fallbackInterval), this.intervals.push(n);
            let u = (b)=>{
                let { action: W } = b.data;
                W === l.CLOSE && this.apply().then(()=>{
                    this.isLeader && a();
                });
            };
            this.channel.addEventListener("message", u);
        });
    }
    sendAction(e) {
        this.channel.postMessage({
            action: e,
            token: this.token
        });
    }
    assumeLead() {
        this.isLeader = !0;
        let e = (n)=>{
            let { action: r } = n.data;
            r === l.APPLY && this.sendAction(l.TELL);
        };
        return this.channel.addEventListener("message", e), this.listeners.push(e), this.sendAction(l.TELL);
    }
    waitForLeadership() {
        return this.deferred ? this.deferred : (this.deferred = this.awaitLeadership(), this.deferred);
    }
    close() {
        this.isDead || (this.isDead = !0, this.isLeader = !1, this.sendAction(l.CLOSE), this.listeners.forEach((e)=>this.channel.removeEventListener("message", e)), this.intervals.forEach((e)=>T.clearInterval(e)));
    }
};
var k;
(function(r) {
    r[r.PROMPTED = 0] = "PROMPTED", r[r.ACTIVE = 1] = "ACTIVE", r[r.IDLE = 2] = "IDLE";
})(k || (k = {}));
var be = class {
    constructor(e){
        this.token = ae();
        this.registry = new Map;
        this.allIdle = !1;
        let { channelName: n } = e;
        if (this.options = e, this.channel = new $e(n), this.registry.set(this.token, 1), e.leaderElection) {
            let r = {
                fallbackInterval: 2e3,
                responseTime: 100
            };
            this.elector = new Ee(this.channel, r), this.elector.waitForLeadership();
        }
        this.channel.addEventListener("message", (r)=>{
            let { action: a, token: u, data: b } = r.data;
            switch(a){
                case l.REGISTER:
                    this.registry.set(u, 2);
                    break;
                case l.DEREGISTER:
                    this.registry.delete(u);
                    break;
                case l.IDLE:
                    this.idle(u);
                    break;
                case l.ACTIVE:
                    this.active(u);
                    break;
                case l.PROMPT:
                    this.prompt(u);
                    break;
                case l.START:
                    this.start(u);
                    break;
                case l.RESET:
                    this.reset(u);
                    break;
                case l.ACTIVATE:
                    this.activate(u);
                    break;
                case l.PAUSE:
                    this.pause(u);
                    break;
                case l.RESUME:
                    this.resume(u);
                    break;
                case l.MESSAGE:
                    this.options.onMessage(b);
                    break;
            }
        }), this.send(l.REGISTER);
    }
    get isLeader() {
        if (!this.elector) throw new Error('\u274C Leader election is not enabled. To Enable it set the "leaderElection" property to true.');
        return this.elector.isLeader;
    }
    prompt(e = this.token) {
        this.registry.set(e, 0);
        let n = [
            ...this.registry.values()
        ].every((r)=>r === 0);
        e === this.token && this.send(l.PROMPT), n && this.options.onPrompt();
    }
    idle(e = this.token) {
        this.registry.set(e, 2);
        let n = [
            ...this.registry.values()
        ].every((r)=>r === 2);
        e === this.token && this.send(l.IDLE), !this.allIdle && n && (this.allIdle = !0, this.options.onIdle());
    }
    active(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1);
        let n = [
            ...this.registry.values()
        ].some((r)=>r === 1);
        e === this.token && this.send(l.ACTIVE), n && this.options.onActive();
    }
    start(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.START) : this.options.start(!0);
    }
    reset(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.RESET) : this.options.reset(!0);
    }
    activate(e = this.token) {
        this.allIdle = !1, this.registry.set(e, 1), e === this.token ? this.send(l.ACTIVATE) : this.options.activate(!0);
    }
    pause(e = this.token) {
        e === this.token ? this.send(l.PAUSE) : this.options.pause(!0);
    }
    resume(e = this.token) {
        e === this.token ? this.send(l.RESUME) : this.options.resume(!0);
    }
    message(e) {
        try {
            this.channel.postMessage({
                action: l.MESSAGE,
                token: this.token,
                data: e
            });
        } catch  {}
    }
    send(e) {
        try {
            this.channel.postMessage({
                action: e,
                token: this.token
            });
        } catch  {}
    }
    close() {
        this.options.leaderElection && this.elector.close(), this.send(l.DEREGISTER), this.channel.close();
    }
};
var Qe = w ? document : null, ge = [
    "mousemove",
    "keydown",
    "wheel",
    "DOMMouseScroll",
    "mousewheel",
    "mousedown",
    "touchstart",
    "touchmove",
    "MSPointerDown",
    "MSPointerMove",
    "visibilitychange"
];
function F(t) {
    let e = (0, _react.useRef)(t);
    return (0, _react.useEffect)(()=>{
        e.current = t;
    }, [
        t
    ]), e;
}
function Ze(t, e) {
    let n;
    function r(...a) {
        n && clearTimeout(n), n = setTimeout(()=>{
            t(...a), n = null;
        }, e);
    }
    return r.cancel = function() {
        clearTimeout(n);
    }, r;
}
function le(t, e) {
    let n = 0;
    return function(...r) {
        let a = new Date().getTime();
        if (!(a - n < e)) return n = a, t(...r);
    };
}
var E = ()=>w ? performance.now() : Date.now();
function $({ timeout: t = 1200000, promptTimeout: e = 0, element: n = Qe, events: r = ge, timers: a, immediateEvents: u = [], onPrompt: b = ()=>{}, onIdle: W = ()=>{}, onActive: ee = ()=>{}, onAction: m = ()=>{}, onMessage: c = ()=>{}, debounce: d = 0, throttle: p = 0, eventsThrottle: h = 200, startOnMount: o = !0, startManually: x = !1, stopOnIdle: M = !1, crossTab: G = !1, name: we = "idle-timer", syncTimers: J = 0, leaderElection: ye = !1 } = {}) {
    let q = (0, _react.useRef)(E()), Le = (0, _react.useRef)(Date.now()), te = (0, _react.useRef)(E()), D = (0, _react.useRef)(null), N = (0, _react.useRef)(null), z = (0, _react.useRef)(0), v = (0, _react.useRef)(!0), A = (0, _react.useRef)(!1), B = (0, _react.useRef)(!0), X = (0, _react.useRef)(!1), g = (0, _react.useRef)(!1), y = (0, _react.useRef)(0), R = (0, _react.useRef)(0), O = (0, _react.useRef)(null), s = (0, _react.useRef)(null), C = F(t), re = F(e), et = F(M), ke = (0, _react.useRef)(u), ce = (0, _react.useRef)(n), me = (0, _react.useRef)([
        ...new Set([
            ...r,
            ...u
        ]).values()
    ]), xe = F(W), de = F(ee), Me = F(b), ne = F(c), L = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        L.current && L.current.cancel && L.current.cancel(), d > 0 ? L.current = Ze(m, d) : p > 0 ? L.current = le(m, p) : L.current = m;
    }, [
        m,
        p,
        d
    ]);
    let Pe = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        G && J && (Pe.current = le(()=>{
            s.current.active();
        }, J));
    }, [
        G,
        J
    ]);
    let P = ()=>{
        O.current !== null && (T.clearTimeout(O.current), O.current = null);
    }, V = (i, S = !0)=>{
        P(), O.current = T.setTimeout(fe, i || C.current), S && (N.current = E());
    }, Se = (i)=>{
        y.current = 0, R.current = E(), g.current = !0, V(re.current, !1), Me.current(i);
    }, Ae = ()=>{
        P(), v.current = !0, D.current = E(), et.current ? H() : g.current && (R.current = 0, g.current = !1), xe.current();
    }, pe = (i)=>{
        P(), g.current = !1, R.current = 0, v.current = !1, z.current += E() - D.current, _(), V(), de.current(i);
    }, fe = (i)=>{
        if (!v.current) {
            if (L.current.cancel && L.current.cancel(), re.current > 0 && !g.current) {
                s.current ? s.current.prompt() : Se(i);
                return;
            }
            s.current ? s.current.idle() : Ae();
            return;
        }
        s.current ? s.current.active() : pe(i);
    }, Re = (i)=>{
        if (L.current(i), g.current) return;
        if (P(), !v.current && ke.current.includes(i.type)) {
            fe(i);
            return;
        }
        let S = E() - N.current;
        if (v.current && !M || !v.current && S > C.current) {
            fe(i);
            return;
        }
        A.current = !1, y.current = 0, R.current = 0, V(), G && J && Pe.current();
    }, oe = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        let i = X.current;
        i && H(), h > 0 ? oe.current = le(Re, h) : oe.current = Re, i && _();
    }, [
        h,
        G,
        J
    ]);
    let _ = ()=>{
        !w || X.current || (me.current.forEach((i)=>{
            ce.current.addEventListener(i, oe.current, {
                capture: !0,
                passive: !0
            });
        }), X.current = !0);
    }, H = (i = !1)=>{
        !w || (X.current || i) && (me.current.forEach((S)=>{
            ce.current.removeEventListener(S, oe.current, {
                capture: !0
            });
        }), X.current = !1);
    }, j = (0, _react.useCallback)((i)=>{
        P(), _(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, s.current && !i && s.current.start(), V();
    }, [
        O,
        v,
        C,
        s
    ]), he = (0, _react.useCallback)((i)=>{
        P(), _(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, q.current = E(), te.current = E(), s.current && !i && s.current.reset(), x || V();
    }, [
        O,
        v,
        C,
        x,
        s
    ]), Oe = (0, _react.useCallback)((i)=>{
        P(), _(), (v.current || g.current) && pe(), v.current = !1, g.current = !1, A.current = !1, y.current = 0, R.current = 0, te.current = E(), s.current && !i && s.current.activate(), V();
    }, [
        O,
        v,
        C,
        s
    ]), ve = (0, _react.useCallback)((i = !1)=>A.current ? !1 : (y.current = Ce(), A.current = !0, H(), P(), s.current && !i && s.current.pause(), !0), [
        O,
        s
    ]), Te = (0, _react.useCallback)((i = !1)=>A.current ? (A.current = !1, g.current || _(), v.current || V(y.current), R.current && (R.current = E()), s.current && !i && s.current.resume(), !0) : !1, [
        O,
        C,
        y,
        s
    ]), tt = (0, _react.useCallback)((i, S)=>{
        s.current ? (S && ne.current(i), s.current.message(i)) : S && ne.current(i);
    }, [
        c
    ]), rt = (0, _react.useCallback)(()=>v.current, [
        v
    ]), nt = (0, _react.useCallback)(()=>g.current, [
        g
    ]), ot = (0, _react.useCallback)(()=>{
        if (!s.current) throw new Error('\u274C Cross Tab feature is not enabled. To enable it set the "crossTab" property to true.');
        return s.current.isLeader;
    }, [
        s
    ]), it = (0, _react.useCallback)(()=>{
        if (!s.current) throw new Error('\u274C Cross Tab feature is not enabled. To enable it set the "crossTab" property to true.');
        return s.current.token;
    }, [
        s
    ]), Ce = (0, _react.useCallback)(()=>{
        if (A.current) return y.current;
        let i = y.current ? y.current : re.current + C.current, S = N.current ? E() - N.current : 0, _e = Math.ceil(i - S);
        return _e < 0 ? 0 : Math.abs(_e);
    }, [
        C,
        re,
        g,
        y,
        N
    ]), st = (0, _react.useCallback)(()=>Math.round(E() - te.current), [
        te
    ]), De = (0, _react.useCallback)(()=>Math.round(E() - q.current), [
        q
    ]), at = (0, _react.useCallback)(()=>D.current ? new Date(Le.current - q.current + D.current) : null, [
        D
    ]), lt = (0, _react.useCallback)(()=>N.current ? new Date(Le.current - q.current + N.current) : null, [
        N
    ]), Ne = (0, _react.useCallback)(()=>v.current ? Math.round(E() - D.current + z.current) : Math.round(z.current), [
        D,
        z
    ]), ut = (0, _react.useCallback)(()=>{
        let i = Math.round(De() - Ne());
        return i >= 0 ? i : 0;
    }, [
        q,
        D,
        z
    ]);
    return (0, _react.useEffect)(()=>{
        if (d > 0 && p > 0) throw new Error("\u274C onAction can either be throttled or debounced, not both.");
        a && ze(a);
        let i = ()=>{
            s.current && s.current.close(), L.current.cancel && L.current.cancel(), P(), H(!0);
        };
        return w && window.addEventListener("beforeunload", i), ()=>{
            w && window.removeEventListener("beforeunload", i), s.current && s.current.close(), L.current.cancel && L.current.cancel(), P(), H(!0);
        };
    }, []), (0, _react.useEffect)(()=>{
        s.current && s.current.close(), G ? s.current = new be({
            channelName: we,
            leaderElection: ye,
            onPrompt: ()=>{
                Se();
            },
            onIdle: ()=>{
                Ae();
            },
            onActive: ()=>{
                pe();
            },
            onMessage: ne.current,
            start: j,
            reset: he,
            activate: Oe,
            pause: ve,
            resume: Te
        }) : s.current = null;
    }, [
        G,
        we,
        ye,
        Me,
        xe,
        de,
        ne,
        j,
        he,
        ve,
        Te
    ]), (0, _react.useEffect)(()=>{
        P(), H(!0), B.current || (A.current = !0, v.current = !0, y.current = 0), !x && (o ? j() : _());
    }, [
        x,
        o,
        B
    ]), (0, _react.useEffect)(()=>{
        if (!B.current) {
            let i = [
                ...new Set([
                    ...r,
                    ...u
                ]).values()
            ];
            if (H(), me.current = i, ce.current = n, ke.current = u, x) return;
            o ? j() : _();
        }
    }, [
        n,
        JSON.stringify(r),
        JSON.stringify(u),
        B,
        x,
        o
    ]), (0, _react.useEffect)(()=>{
        if (B.current) B.current = !1;
        else {
            if (C.current = t, x) return;
            v.current && (de.current(), s.current && s.current.active()), j();
        }
    }, [
        t,
        s,
        x,
        B,
        v
    ]), {
        message: tt,
        start: j,
        reset: he,
        activate: Oe,
        pause: ve,
        resume: Te,
        isIdle: rt,
        isPrompted: nt,
        isLeader: ot,
        getTabId: it,
        getRemainingTime: Ce,
        getElapsedTime: st,
        getTotalElapsedTime: De,
        getLastIdleTime: at,
        getLastActiveTime: lt,
        getTotalIdleTime: Ne,
        getTotalActiveTime: ut
    };
}
var ue = (0, _react.createContext)(null);
function Pt(t) {
    let e = $(t);
    return (0, _reactDefault.default).createElement(ue.Provider, {
        value: e
    }, t.children);
}
var St = ue.Consumer;
function At() {
    return (0, _react.useContext)(ue);
}

},{"react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bJiGL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _idleModal = require("./IdleModal");
var _idleModalDefault = parcelHelpers.interopDefault(_idleModal);
exports.default = (0, _idleModalDefault.default);

},{"./IdleModal":"9NggC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9NggC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reactRouterDom = require("react-router-dom");
const IdleModal = ({ modalOpen, toggleModal, timeLeftToLogout = 0, totalLogoutTime = 30, logout, cancelLogout })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const percent = (totalLogoutTime - timeLeftToLogout) * (100 / totalLogoutTime);
    const transition = {
        ease: "easeInOut",
        duration: totalLogoutTime
    };
    const variants = {
        enter: {
            x: "-100%",
            backgroundColor: "#317D4F"
        },
        animate: {
            x: [
                "-100%",
                `${percent}%`
            ],
            backgroundColor: [
                "#317D4F",
                "#93A441",
                "#F4CB32",
                "#E36E43",
                "#D11053"
            ],
            times: [
                0,
                0.4,
                0.5,
                0.6,
                0.8
            ],
            transition
        }
    };
    const seconds = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
        weight: "600",
        children: `${timeLeftToLogout} seconds`
    });
    const modalBody = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Paragraph), {
                    children: [
                        "Are you still there? You will be logged out in ",
                        seconds,
                        " for your security."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Motion), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0",
                        minHeight: "10px",
                        width: "100%",
                        borderRadius: "6px",
                        extraStyles: "position: relative; overflow: hidden;",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Motion), {
                            padding: "0",
                            height: "10px",
                            width: "100%",
                            borderRadius: "6px",
                            extraStyles: "position: relative;",
                            variants: variants,
                            initial: "enter",
                            animate: modalOpen ? "animate" : "enter",
                            exit: "enter"
                        })
                    })
                })
            ]
        })
    });
    const modalExtraProps = {
        ModalLink: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "0"
            }),
        modalHeaderText: "Your session is about to expire!",
        modalBodyText: modalBody,
        continueButtonText: "Stay Logged In",
        cancelButtonText: "Log Out",
        continueAction: ()=>{
            cancelLogout();
            toggleModal(false);
        },
        cancelAction: ()=>{
            logout({
                navigate
            });
            toggleModal(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
        showModal: ()=>toggleModal(true),
        hideModal: ()=>{
            cancelLogout();
            toggleModal(false);
        },
        modalOpen: modalOpen,
        defaultWrapper: false,
        underlayClickExits: false,
        ...modalExtraProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
            padding: "0"
        })
    });
};
exports.default = IdleModal;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","react-router-dom":"hNarb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8il5Y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _visitExpirationModalDefault.default));
var _visitExpirationModal = require("./VisitExpirationModal");
var _visitExpirationModalDefault = parcelHelpers.interopDefault(_visitExpirationModal);

},{"./VisitExpirationModal":"RYwOJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"RYwOJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _cartState = require("../../pages/cart/Cart.state");
var _visitExpirationState = require("../../pages/cart/VisitExpiration.state");
const EmptyBox = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0"
    });
const noop = ()=>{};
const VisitExpirationModal = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { isWarningVisible, secondsRemaining } = (0, _reactRedux.useSelector)((state)=>state.visitExpiration);
    const orderId = (0, _reactRedux.useSelector)((state)=>state.cart?.order?.order_id);
    const hasSuccessfulPayments = (0, _reactRedux.useSelector)((0, _cartState.selectHasSuccessfulPayments));
    if (!isWarningVisible) return null;
    const handleHoldOrder = ()=>{
        dispatch((0, _visitExpirationState.dismissVisitExpirationWarning)());
        dispatch((0, _cartState.holdOrderRequest)({
            navigate
        }));
    };
    const handleCancelOrder = ()=>{
        dispatch((0, _visitExpirationState.visitExpired)());
    };
    const handleDismiss = ()=>{
        dispatch((0, _visitExpirationState.dismissVisitExpirationWarning)());
    };
    const seconds = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
        weight: "600",
        children: `${secondsRemaining} ${secondsRemaining === 1 ? "second" : "seconds"}`
    });
    const modalBody = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Stack), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Paragraph), {
                children: [
                    "Order ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        weight: "600",
                        children: orderId
                    }),
                    " will expire in ",
                    seconds,
                    ".",
                    hasSuccessfulPayments ? " Please complete the order or void the payments and cancel the order." : " You can put the order on hold to retain the order or cancel the order."
                ]
            })
        })
    });
    const modalExtraProps = {
        ModalLink: EmptyBox,
        modalHeaderText: "Your order is about to expire!",
        modalBodyText: modalBody,
        ...hasSuccessfulPayments ? {
            onlyCloseButton: true,
            closeButtonText: "Dismiss",
            hideModal: handleDismiss
        } : {
            continueButtonText: "Cancel Order",
            cancelButtonText: "Place Order on Hold",
            continueAction: handleCancelOrder,
            cancelAction: handleHoldOrder
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
        showModal: noop,
        hideModal: noop,
        modalOpen: isWarningVisible,
        defaultWrapper: false,
        underlayClickExits: false,
        ...modalExtraProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(EmptyBox, {})
    });
};
exports.default = VisitExpirationModal;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","react-redux":"k6jol","react-router-dom":"hNarb","../../pages/cart/Cart.state":"bgoZn","../../pages/cart/VisitExpiration.state":"6xsNt","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ddX7o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useLogoutTimers = ({ logoutTimerOn = false, action, timeLeftToLogout, handleSetTimeLeft, initialTimeLeftToLogoutSeconds = 30 })=>{
    let timers = {
        timer: null,
        interval: null
    };
    let timeLeft = timeLeftToLogout;
    (0, _react.useEffect)(()=>{
        if (logoutTimerOn) timers.timer = window.setTimeout(()=>{
            action();
            handleSetTimeLeft(initialTimeLeftToLogoutSeconds);
        }, initialTimeLeftToLogoutSeconds * 1000);
        return ()=>clearTimeout(timers.timer);
    }, [
        logoutTimerOn
    ]);
    (0, _react.useEffect)(()=>{
        if (logoutTimerOn) timers.interval = window.setInterval(()=>{
            timeLeft--;
            handleSetTimeLeft(timeLeft);
        }, 1000);
        return ()=>clearInterval(timers.interval);
    }, [
        logoutTimerOn
    ]);
    return timers;
};
exports.default = useLogoutTimers;

},{"react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3im45":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cart = require("./Cart");
var _cartDefault = parcelHelpers.interopDefault(_cart);
var _reactRedux = require("react-redux");
var _cartState = require("./Cart.state");
exports.default = (0, _reactRedux.connect)((0, _cartState.mapStateToProps), (0, _cartState.mapDispatchToProps))((0, _cartDefault.default));

},{"./Cart":"jgoFO","react-redux":"k6jol","./Cart.state":"bgoZn","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jgoFO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _components = require("@thecb/components");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _cartSidebar = require("../../components/cart-sidebar");
var _cartSidebarDefault = parcelHelpers.interopDefault(_cartSidebar);
var _cartItem = require("./CartItem");
var _cartModals = require("./CartModals");
var _reactRedux = require("react-redux");
var _cartState = require("../../pages/cart/Cart.state");
var _sharedAlertBar = require("../../components/alert-bar/SharedAlertBar");
var _sharedAlertBarDefault = parcelHelpers.interopDefault(_sharedAlertBar);
const Header = ({ alertBar, alertBarActions })=>{
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                sharedAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharedAlertBarDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    id: "cart-title",
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Cart"
                })
            ]
        })
    });
};
const Cart = ({ forms, actions, alertBars, modals, order, getOrder, removeOrderItemRequest, displayAddItemsAlert })=>{
    const [errors, handleErrors] = (0, _react.useState)(false);
    const [itemToRemove, setItemToRemove] = (0, _react.useState)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(()=>{
        if (!order.order_id) getOrder();
    }, []);
    const handleCancelOrderSubmit = (0, _components.util).general.generateClickHandler(forms.cancelOrderForm, ()=>handleErrors(true), ()=>dispatch((0, _cartState.submitCancelOrderRequest)({
            id: order.order_id,
            navigate
        })));
    const handleRemoveItemClick = (item_id)=>{
        const item = order.order_items.find((order_item)=>order_item.id === item_id);
        setItemToRemove(item);
        actions.modals.cartModal.openModal((0, _cartModals.REMOVE_ITEM_MODAL));
    };
    const handleRemoveItemSubmit = ()=>{
        removeOrderItemRequest(itemToRemove.id);
        actions.modals.cartModal.toggleModal();
    };
    const removeItemModal = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartModals.RemoveItemModal), {
        modals: modals,
        submit: handleRemoveItemSubmit,
        toggle: actions.modals.cartModal.toggleModal,
        item: itemToRemove
    });
    const cancelOrderModal = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartModals.CancelOrderFormModal), {
        ...forms.cancelOrderForm,
        ...actions.forms.cancelOrderForm,
        showErrors: errors,
        modals: modals,
        submit: handleCancelOrderSubmit,
        toggle: actions.modals.cartModal.toggleModal
    });
    const content = Boolean(order.order_items && order.order_items.length) ? order.order_items.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartItem.CartItem), {
            remove: handleRemoveItemClick,
            id: item.id,
            name: item.receivable_category,
            subtotal: item.recorded_subtotal,
            total: item.recorded_price || item.recorded_subtotal,
            isNegativeAmount: item.is_negative_amount,
            externalAttributes: item.external_attributes_to_display
        }, `${item.receivable_category}-${index}`)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
        children: "Your cart is empty"
    });
    const body = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: ".5rem 0 1.5rem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
            background: (0, _components.constants).colors.WHITE,
            variant: "baseStandard",
            padding: "1.5rem",
            borderRadius: "0.25rem",
            children: [
                removeItemModal,
                cancelOrderModal,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "0 0 1rem 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        justify: "flex-start",
                        childGap: "1rem",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                text: "Cancel order",
                                isLoading: false,
                                variant: "secondary",
                                action: ()=>dispatch((0, _cartState.submitCancelOrderRequest)({
                                        id: order.order_id,
                                        navigate
                                    })),
                                dataQa: "Cancel order",
                                textExtraStyles: "font-size: 1rem;"
                            }),
                            (order.status !== "incomplete" || order?.transaction_details?.every((detail)=>detail.status === "cancelled")) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                text: "Place on hold",
                                isLoading: false,
                                variant: "secondary",
                                action: ()=>{
                                    dispatch((0, _cartState.holdOrderRequest)({
                                        navigate
                                    }));
                                },
                                dataQa: "Place on hold",
                                textExtraStyles: "font-size: 1rem;"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    id: "cart-content",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Stack), {
                        children: content
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                extraStyles: "margin: 0;",
                                textExtraStyles: "font-size: 1rem;",
                                text: "Add more items",
                                isLoading: false,
                                variant: "secondary",
                                action: ()=>{
                                    if (order.status !== "incomplete") navigate("/pos/products");
                                    else displayAddItemsAlert();
                                },
                                dataQa: "Add more items"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                extraStyles: "margin: 0;",
                                text: "Checkout",
                                isLoading: false,
                                variant: "primary",
                                action: ()=>navigate("/pos/checkout"),
                                dataQa: "Checkout",
                                textExtraStyles: "font-size: 1rem;"
                            })
                        ]
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SidebarSingleContent), {
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.cartAlertBars,
            alertBarActions: actions.alertBars.cartAlertBars
        }, "CartHeader"),
        mainContent: body,
        sidebarContent: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartSidebarDefault.default), {}),
        sidebarTargetWidth: "27.4289rem",
        sidebarWrapperMaxWidth: "85.714rem",
        sidebarOnRight: true,
        childGap: "0.5rem"
    });
};
exports.default = Cart;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-router-dom":"hNarb","@thecb/components":"g98ma","../../components/alert-bar":"aD416","../../components/cart-sidebar":"l8jjH","./CartItem":"dicwa","./CartModals":"5pwyS","react-redux":"k6jol","../../pages/cart/Cart.state":"bgoZn","../../components/alert-bar/SharedAlertBar":"gk2Ni","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dicwa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartItem", ()=>CartItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _helpers = require("../../utils/helpers");
const CartItem = ({ id, name, subtotal, total, isNegativeAmount, externalAttributes, remove })=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const handleRemoveItemClick = (event)=>{
        event.stopPropagation();
        remove(id);
    };
    const formattedSubtotal = isNegativeAmount ? (0, _helpers.formatWithParentheses)((0, _helpers.formatPrice)(subtotal)) : (0, _helpers.formatPrice)(subtotal);
    const formattedTotal = isNegativeAmount ? (0, _helpers.formatWithParentheses)((0, _helpers.formatPrice)(total)) : (0, _helpers.formatPrice)(total);
    const showFullAmount = subtotal !== total;
    const titleSection = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
        justify: "space-between",
        align: "center",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                justify: "flex-end",
                align: "center",
                childGap: "1rem",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0",
                        width: "12rem",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
                            childGap: ".25rem",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                    weight: "600",
                                    children: formattedSubtotal
                                }),
                                showFullAmount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Text), {
                                    children: [
                                        "Full Amount: ",
                                        formattedTotal
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        text: "Remove Item",
                        variant: "warning",
                        action: handleRemoveItemClick,
                        dataQa: "Remove Item",
                        textExtraStyles: "font-size: 1rem;"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CollapsibleSection), {
                    supportsTouch: false,
                    isOpen: isOpen,
                    title: titleSection,
                    initiallyOpen: false,
                    toggleSection: ()=>setIsOpen(!isOpen),
                    customTitle: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Motion), {
                        variants: {
                            open: {
                                opacity: 1
                            },
                            closed: {
                                opacity: 0
                            }
                        },
                        initial: "open",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                            padding: ".5rem",
                            background: "#eee",
                            "data-testid": "cart-item-attributes",
                            children: [
                                "Item Attributes:",
                                externalAttributes && Object.entries(externalAttributes).map(([key, value])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Detail), {
                                        margin: "0px 0px 0px 20px",
                                        children: [
                                            (0, _helpers.titleCase)(key),
                                            ": ",
                                            value
                                        ]
                                    }, key))
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {})
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3I3s4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkout = require("./Checkout");
var _checkoutDefault = parcelHelpers.interopDefault(_checkout);
var _reactRedux = require("react-redux");
var _checkoutState = require("./Checkout.state");
exports.default = (0, _reactRedux.connect)((0, _checkoutState.mapStateToProps), (0, _checkoutState.mapDispatchToProps))((0, _checkoutDefault.default));

},{"./Checkout":"tL9YH","react-redux":"k6jol","./Checkout.state":"4E8nR","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"38tJn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _orderDetails = require("./OrderDetails");
var _orderDetailsDefault = parcelHelpers.interopDefault(_orderDetails);
var _reactRedux = require("react-redux");
var _orderDetailsState = require("./OrderDetails.state");
exports.default = (0, _reactRedux.connect)((0, _orderDetailsState.mapStateToProps), (0, _orderDetailsState.mapDispatchToProps))((0, _orderDetailsDefault.default));

},{"./OrderDetails":"Vnnfk","react-redux":"k6jol","./OrderDetails.state":"3yj5u","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"Vnnfk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _components = require("@thecb/components");
var _orderDetailsPaymentItem = require("./OrderDetailsPaymentItem");
var _orderDetailsDebtItem = require("./OrderDetailsDebtItem");
var _helpers = require("../../utils/helpers");
var _receiptFormModule = require("../../components/receipt-form-module");
var _statusModule = require("../../components/status-module/StatusModule");
var _reactRedux = require("react-redux");
var _orderDetailsState = require("./OrderDetails.state");
var _constants = require("../../utils/constants");
var _tooltip = require("../../components/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _cartState = require("../cart/Cart.state");
var _sharedAlertBar = require("../../components/alert-bar/SharedAlertBar");
var _sharedAlertBarDefault = parcelHelpers.interopDefault(_sharedAlertBar);
var _orderDetailsVoidModal = require("./OrderDetailsVoidModal");
var _orderDetailsReturnModal = require("./OrderDetailsReturnModal");
var _formattedInput = require("formatted-input");
const Header = ({ alertBar, alertBarActions })=>{
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        isToast: true,
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                sharedAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharedAlertBarDefault.default), {
                        isToast: true
                    })
                })
            ]
        })
    });
};
const OrderDetails = ({ fetching, alertBars, changeDue, actions, modals, forms, getOrderDetails, error, errorText, submitSendReceipt, submitPrintReceipt })=>{
    const { data: selectedOrder, isLoading, isVoidModalOpen, isReturnModalOpen, isChangeDueModalOpen } = (0, _reactRedux.useSelector)((state)=>state.orderDetails);
    const { order: cartOrder } = (0, _reactRedux.useSelector)((state)=>state.cart);
    const { order_items, // pushed activity log feature to V2
    // activity_log: activityLog,
    transaction_details: transactionDetails } = selectedOrder;
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const voidFormActions = actions.forms.voidForm.actions;
    const voidFormFields = forms.voidForm.fields;
    const returnFormActions = actions.forms.returnForm.actions;
    const returnFormFields = forms.returnForm.fields;
    const dispatch = (0, _reactRedux.useDispatch)();
    const { id } = (0, _reactRouterDom.useParams)();
    // Receipt form error handler
    const [errors, handleErrors] = (0, _react.useState)(false);
    const [showReceiptSubsection, setShowReceiptSubsection] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        getOrderDetails({
            id
        });
    }, [
        location
    ]);
    const orderContainsCashPayments = (0, _react.useMemo)(()=>transactionDetails?.some((transaction)=>transaction?.payment_type === (0, _constants.PAYMENT_TYPE).CASH_PAYMENT && transaction?.status === (0, _constants.TRANSACTION_STATUS).SUCCESSFUL), [
        transactionDetails
    ]);
    const voidText = "Void";
    const returnText = "Refund";
    const getVoidButtonText = ()=>orderContainsCashPayments ? "Return Cash and Void" : "Void";
    const disableReopenButton = !selectedOrder?.order?.cashier_can_reopen || cartOrder?.order_items?.length;
    const disableReopenButtonText = cartOrder?.order_items?.length ? "Cannot re-open held order if items are already in your cart. Please clear cart." : selectedOrder?.order?.cashier_can_reopen_message;
    const ShowTooltip = ({ show, text, children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
            children: show ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                width: "275px",
                height: "95%",
                variant: "error",
                left: true,
                noIcon: true,
                text: text,
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                children: children
            })
        });
    const isRefund = !!selectedOrder.order?.parent_id;
    const isVoidable = selectedOrder?.order?.order_settings?.voidable;
    const isReturnable = selectedOrder?.order?.order_settings?.returnable;
    const isVoidedOrder = Boolean(selectedOrder?.order?.voided_at);
    const orderStatus = (0, _reactRedux.useSelector)((state)=>state.orderDetails.data.order?.status);
    const isPaylinkSent = selectedOrder?.order?.status === (0, _constants.ORDER_STATUS).PAYLINK_SENT;
    /*The isPaylinkCancelled is a boolean value in the state, 
  from the Cancel webhook being successful or failing. 
  This helps rerenders the component so the button is no longer visible. 
  The paylinkCancelledAt is the time stamp for fresh loads, 
  to control the button being visible.
  */ const isPaylinkCancelled = (0, _reactRedux.useSelector)((state)=>state.orderDetails.isPaylinkCancelled);
    const paylinkCancelledAt = Boolean(selectedOrder?.order?.paylink_cancelled_at);
    (0, _react.useEffect)(()=>{
        if (isPaylinkCancelled) dispatch(getOrderDetails({
            id
        }));
    }, [
        isPaylinkCancelled,
        id
    ]);
    (0, _react.useEffect)(()=>{
        if (orderStatus === (0, _constants.ORDER_STATUS).VOIDED || isPaylinkCancelled) dispatch(getOrderDetails({
            id
        }));
    }, [
        orderStatus
    ]);
    const total = (0, _helpers.formatPrice)(selectedOrder.order?.total, isRefund);
    const subtotal = (0, _helpers.formatPrice)(selectedOrder.order?.subtotal, isRefund);
    const paylinkRecipientEmail = selectedOrder.order?.paylink_recipient_email;
    const formatPhone = (0, _formattedInput.format)((0, _components.util).formats.phoneFormat);
    const formatPaylinkRecipientPhoneNumber = (phoneNumber)=>{
        if (!phoneNumber) return;
        const paylinkRecipientPhoneNumberWithoutCountryCode = (0, _helpers.phoneNumberWithoutCountryCode)(phoneNumber);
        return formatPhone(paylinkRecipientPhoneNumberWithoutCountryCode);
    };
    const paylinkRecipientPhoneNumber = formatPaylinkRecipientPhoneNumber(selectedOrder.order?.paylink_recipient_phone_number);
    const paylinkRecipientInfo = paylinkRecipientEmail || paylinkRecipientPhoneNumber;
    const orderDetailsModals = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
                    noBorder: true,
                    modalHeaderText: "Change Due",
                    defaultWrapper: false,
                    onlyCloseButton: true,
                    hideModal: ()=>dispatch((0, _orderDetailsState.changeDueModal)((0, _orderDetailsState.CLOSE_CHANGE_DUE_MODAL))),
                    modalOpen: isChangeDueModalOpen,
                    modalBodyText: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
                        intrinsic: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                variant: "p",
                                children: "There is change due in the amount of:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                                as: "h3",
                                margin: "8px 0px 0px 0px",
                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                children: (0, _helpers.formatPrice)(changeDue)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
                    modalHeaderText: "Processing",
                    defaultWrapper: false,
                    onlyCloseButton: true,
                    modalOpen: modals.loadingModal.modalIsOpen && modals.loadingModal.modalId === LOADING_MODAL,
                    hideModal: actions.modals.loadingModal.toggleModal,
                    modalBodyText: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                        intrinsic: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Spinner), {
                                size: "100"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
                    modalHeaderText: `${voidText} Order`,
                    defaultWrapper: false,
                    continueAction: ()=>{
                        const payload = {
                            notes: voidFormFields.notes.rawValue,
                            id: selectedOrder.order.id
                        };
                        dispatch((0, _orderDetailsState.initiateVoidOrderById)(payload));
                    },
                    isLoading: isLoading,
                    isContinueActionDisabled: isLoading || forms.voidForm.fields.notes.hasErrors,
                    continueButtonText: getVoidButtonText(),
                    modalOpen: isVoidModalOpen,
                    hideModal: ()=>dispatch((0, _orderDetailsState.voidModal)((0, _orderDetailsState.CLOSE_VOID_MODAL))),
                    modalBodyText: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDetailsVoidModal.VoidForm), {
                            fields: voidFormFields,
                            actions: voidFormActions,
                            transactionsForOrder: transactionDetails,
                            orderContainsCashPayments: orderContainsCashPayments
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Modal), {
                    modalHeaderText: `${returnText} Order`,
                    defaultWrapper: false,
                    continueAction: ()=>{
                        const payload = {
                            notes: returnFormFields.notes.rawValue,
                            id: selectedOrder.order.id,
                            navigate
                        };
                        dispatch((0, _orderDetailsState.initiateReturnOrderById)(payload));
                    },
                    isLoading: isLoading,
                    isContinueActionDisabled: isLoading || forms.returnForm.fields.notes.hasErrors,
                    continueButtonText: returnText,
                    modalOpen: isReturnModalOpen,
                    hideModal: ()=>dispatch((0, _orderDetailsState.returnModal)((0, _orderDetailsState.CLOSE_RETURN_MODAL))),
                    modalBodyText: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDetailsReturnModal.ReturnForm), {
                            fields: returnFormFields,
                            actions: returnFormActions
                        })
                    })
                })
            ]
        });
    const buttonStyle = `
    border-radius: 4px;
    font-size: 1rem;
  `;
    const disabledBtnContainerStyle = `
    cursor: not-allowed;
    margin-left: -8px;
  `;
    const disabledBtnStyle = `
    pointer-events: none;
    border-color: ${(0, _components.constants).colors.GREY_CHATEAU} !important;
    color: ${(0, _components.constants).colors.GREY_CHATEAU} !important;
    background-color: ${(0, _components.constants).colors.ALABASTER_WHITE} !important;
  `;
    const disabledBtnTextStyle = `
    color: ${(0, _components.constants).colors.STORM_GREY} !important; 
    background-color: ${(0, _components.constants).colors.ALABASTER_WHITE} !important;
    font-size: 1rem;
  `;
    const orderActions = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            align: "center",
            overflow: "visible",
            children: [
                selectedOrder?.order?.status === (0, _constants.ORDER_STATUS).HOLD && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ShowTooltip, {
                    show: disableReopenButton,
                    text: disableReopenButtonText,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0",
                        extraStyles: disableReopenButton && disabledBtnContainerStyle,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                            "data-testid": "Re-open Button",
                            text: "Re-open order",
                            isLoading: false,
                            variant: "secondary",
                            action: ()=>dispatch((0, _orderDetailsState.initiateReopenOrderById)({
                                    id,
                                    navigate
                                })),
                            disabled: disableReopenButton,
                            extraStyles: `${buttonStyle};
                ${disableReopenButton && disabledBtnStyle}
                `,
                            textExtraStyles: disableReopenButton ? disabledBtnTextStyle : `font-size: 1rem;`
                        })
                    })
                }),
                (selectedOrder.order.status === (0, _constants.ORDER_STATUS).COMPLETED || selectedOrder.order.status === (0, _constants.ORDER_STATUS).VOIDED || selectedOrder.order.status === (0, _constants.ORDER_STATUS).VOID_PENDING || selectedOrder.order.completed_at) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    id: "receipt-btn",
                    disabled: showReceiptSubsection,
                    extraStyles: buttonStyle,
                    text: "Receipt",
                    isLoading: false,
                    action: ()=>setShowReceiptSubsection(!showReceiptSubsection),
                    textExtraStyles: "font-size: 1rem;"
                }),
                !isRefund && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        isVoidable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                extraStyles: buttonStyle,
                                "data-testid": `${voidText} Button`,
                                text: voidText,
                                isLoading: false,
                                variant: "secondary",
                                textExtraStyles: "font-size: 1rem;",
                                action: ()=>dispatch((0, _orderDetailsState.voidModal)((0, _orderDetailsState.OPEN_VOID_MODAL)))
                            })
                        }),
                        isReturnable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                extraStyles: buttonStyle,
                                "data-testid": `${returnText} Button`,
                                text: returnText,
                                isLoading: false,
                                variant: "secondary",
                                textExtraStyles: "font-size: 1rem;",
                                action: ()=>dispatch((0, _orderDetailsState.returnModal)((0, _orderDetailsState.OPEN_RETURN_MODAL)))
                            })
                        })
                    ]
                }),
                isPaylinkSent && !paylinkCancelledAt && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    id: "cancel-paylink-btn",
                    extraStyles: buttonStyle,
                    text: "Cancel Paylink",
                    isLoading: false,
                    variant: "secondary",
                    textExtraStyles: "font-size: 1rem;",
                    action: ()=>{
                        dispatch((0, _orderDetailsState.initiateCancelPaylink)({
                            id: selectedOrder.order.paylink_id,
                            order_id: id
                        }));
                    }
                }),
                selectedOrder.order.items_with_artifacts && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    extraStyles: buttonStyle,
                    text: "Re-Print Artifact",
                    isLoading: false,
                    variant: "secondary",
                    textExtraStyles: "font-size: 1rem;"
                }),
                [
                    (0, _constants.ORDER_STATUS).OPENED,
                    (0, _constants.ORDER_STATUS).INCOMPLETE
                ].includes(selectedOrder.order.status) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                    extraStyles: buttonStyle,
                    url: "/pos/cart",
                    text: "Go to cart",
                    isLoading: false,
                    variant: "secondary",
                    textExtraStyles: "font-size: 1rem;"
                }),
                [
                    (0, _constants.ORDER_STATUS).OPENED,
                    (0, _constants.ORDER_STATUS).HOLD
                ].includes(selectedOrder.order.status) && (transactionDetails.length === 0 || transactionDetails.every((detail)=>detail.status === (0, _constants.TRANSACTION_STATUS).CANCELLED)) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    extraStyles: buttonStyle,
                    textExtraStyles: "font-size: 1rem;",
                    text: "Cancel order",
                    isLoading: false,
                    variant: "secondary",
                    action: ()=>dispatch((0, _cartState.submitCancelOrderRequest)({
                            id: selectedOrder.order.id,
                            navigate
                        }))
                })
            ]
        });
    const body = error || Boolean(!selectedOrder.order) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                children: "Error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Paragraph), {
                children: [
                    "Sorry, ",
                    errorText
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            orderDetailsModals(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "1rem 0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                    variant: "baseStandard",
                    padding: "0",
                    borderRadius: ".25rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            background: (0, _components.constants).colors.ATHENS_GREY,
                            borderRadius: ".25rem",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                justify: "space-between",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Title), {
                                        as: "h4",
                                        variant: "small",
                                        color: (0, _components.constants).colors.CHARADE_GREY,
                                        weight: "600",
                                        children: [
                                            "Order Number:",
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                                fontSize: "20px",
                                                children: selectedOrder.order.id
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                        fontSize: "20px",
                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                        id: "order-total",
                                        children: total
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            background: (0, _components.constants).colors.WHITE,
                            borderRadius: ".25rem",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                justify: "space-between",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusModule.StatusModule), {
                                        label: "Order",
                                        status: selectedOrder.order.status
                                    }),
                                    orderActions()
                                ]
                            })
                        }),
                        showReceiptSubsection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _receiptFormModule.ReceiptFormModule), {
                            forms: forms,
                            actions: actions,
                            buttonStyle: buttonStyle,
                            handleErrors: handleErrors,
                            showErrors: errors,
                            submitSendReceipt: submitSendReceipt,
                            submitPrintReceipt: submitPrintReceipt,
                            cancelAction: ()=>setShowReceiptSubsection(false)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                padding: "1rem 0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                        as: "h4",
                        variant: "small",
                        color: (0, _components.constants).colors.CHARADE_GREY,
                        weight: "600",
                        extraStyles: `margin-bottom: 0.5rem;`,
                        children: "Order Details"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                        variant: "baseStandard",
                        padding: "0",
                        background: (0, _components.constants).colors.WHITE,
                        borderRadius: ".25rem",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                                padding: "1.5rem",
                                width: "550px",
                                borderRadius: ".25rem",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        extraStyles: `text-align:left`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:30%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                    children: "Order creation:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:50%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    id: "formatted-created-at",
                                                    children: (0, _dayjsDefault.default)(selectedOrder.order.created_at).format("MM/DD/YYYY hh:mmA")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        extraStyles: `text-align:left`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:30%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                    children: "Order completion:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:50%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    id: "formatted-completed-at",
                                                    children: selectedOrder.order.completed_at ? (0, _dayjsDefault.default)(selectedOrder.order.completed_at).format("MM/DD/YYYY hh:mmA") : "Incomplete"
                                                })
                                            })
                                        ]
                                    }),
                                    isVoidedOrder && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        extraStyles: `text-align:left`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:30%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                    children: "Order voided:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:50%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    id: "formatted-voided-at",
                                                    children: (0, _dayjsDefault.default)(selectedOrder.order.voided_at).format("MM/DD/YYYY hh:mmA")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        extraStyles: `text-align:left`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:30%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                    children: "Cashier:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:50%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    extraStyles: `text-align:left`,
                                                    id: "cashier",
                                                    children: selectedOrder.order.cashier
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        extraStyles: `text-align:left`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:30%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                    children: "Location:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:50%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    id: "location",
                                                    children: selectedOrder.order.location
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        extraStyles: `text-align:left`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:30%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                    children: "Terminal:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:50%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    id: "terminal",
                                                    children: selectedOrder.order.terminal
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        extraStyles: `text-align:left;`,
                                        overflow: true,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:30%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                    children: "Batch Number:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:50%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    id: "batch-number",
                                                    children: selectedOrder.order.batch_number
                                                })
                                            })
                                        ]
                                    }),
                                    paylinkRecipientInfo && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        extraStyles: `text-align:left;`,
                                        overflow: true,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:30%`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                    children: "PayLink Recipient:"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    id: "paylink-recipient-info",
                                                    children: paylinkRecipientEmail && paylinkRecipientPhoneNumber ? `${paylinkRecipientEmail}, ${paylinkRecipientPhoneNumber}` : `${paylinkRecipientInfo}`
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                                background: (0, _components.constants).colors.ATHENS_GREY,
                                padding: "0 1.5rem",
                                borderRadius: ".25rem",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                                        padding: "1.5rem 0",
                                        children: [
                                            parseFloat(selectedOrder.order.total_service_fees) > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                                justify: "space-between",
                                                extraStyles: `margin-bottom: 0.5rem;`,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                        fontSize: "1rem",
                                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                                        children: "Service Fees"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                        fontSize: "1rem",
                                                        id: "order-details-total-service-fees",
                                                        children: (0, _helpers.formatPrice)(selectedOrder.order.total_service_fees)
                                                    })
                                                ]
                                            }),
                                            parseFloat(selectedOrder.order.total_convenience_fees) > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                                justify: "space-between",
                                                extraStyles: `margin-bottom: 0.5rem;`,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                        fontSize: "1rem",
                                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                                        children: "Transaction Fee"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                        fontSize: "1rem",
                                                        id: "order-details-total-convenience-fees",
                                                        children: (0, _helpers.formatPrice)(selectedOrder.order.total_convenience_fees)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                                justify: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                        fontSize: "1rem",
                                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                                        children: "Subtotal"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                        fontSize: "1rem",
                                                        id: "order-details-subtotal",
                                                        children: subtotal
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                        padding: "1.5rem 0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                            justify: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                                    children: "Total"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1.125rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                                    id: "order-details-total",
                                                    children: total
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Module), {
                heading: "Debt Details",
                variant: "small",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "1.5rem",
                    background: (0, _components.constants).colors.WHITE,
                    borderRadius: ".25rem",
                    children: order_items && order_items.map((order_item, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDetailsDebtItem.OrderDetailsDebtItem), {
                            index: key,
                            header: order_item.category,
                            subheader: order_item.description,
                            paid: order_item.amount,
                            isNegativeAmount: order_item.is_negative_amount,
                            isRefund: isRefund,
                            fullAmount: order_item.total,
                            externalAttributes: order_item.receipt_visible_attributes,
                            quantity: order_item.quantity,
                            recordedPrice: order_item.recorded_price
                        }, `${order_item.category}-${key}`))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Module), {
                heading: "Payment Method Details",
                variant: "small",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "0",
                    background: (0, _components.constants).colors.WHITE,
                    borderRadius: ".25rem",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                        background: (0, _components.constants).colors.WHITE,
                        padding: "0",
                        borderRadius: ".25rem",
                        id: "payment-method-details-container",
                        children: [
                            (!Boolean(transactionDetails) || transactionDetails.length === 0) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                    fontSize: "1rem",
                                    children: "No payments to display."
                                })
                            }),
                            transactionDetails.map((transaction, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                    children: [
                                        index >= 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _orderDetailsPaymentItem.OrderDetailsPaymentItem), {
                                            transactionData: transaction,
                                            index: index,
                                            isRefund: isRefund
                                        })
                                    ]
                                }, transaction.id))
                        ]
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DefaultPageTemplate), {
        maxWidth: "85.714rem",
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.orderDetailsAlertBars,
            alertBarActions: actions.alertBars.orderDetailsAlertBars
        }, "OrderDetailsHeader"),
        gutters: "0",
        content: fetching ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Loading), {}) : body
    });
};
exports.default = OrderDetails;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-router-dom":"hNarb","../../components/alert-bar":"aD416","dayjs":"4CsUp","@thecb/components":"g98ma","./OrderDetailsPaymentItem":"7pY1G","./OrderDetailsDebtItem":"jdDhB","../../utils/helpers":"epomp","../../components/receipt-form-module":"h3Gar","../../components/status-module/StatusModule":"g1MR4","react-redux":"k6jol","./OrderDetails.state":"3yj5u","../../utils/constants":"f3A1R","../../components/tooltip":"a8IOS","../cart/Cart.state":"bgoZn","../../components/alert-bar/SharedAlertBar":"gk2Ni","./OrderDetailsVoidModal":"cJFC9","./OrderDetailsReturnModal":"dMVt7","formatted-input":"7KwKx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7pY1G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrderDetailsPaymentItem", ()=>OrderDetailsPaymentItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _helpers = require("../../utils/helpers");
const OrderDetailsPaymentItem = ({ transactionData = {}, index, isRefund })=>{
    const { amount_processed, gateway_payment_id: payment_id, status, change_due, payment_type = "", bank_account = {}, credit_card = {} } = transactionData;
    const BankPayment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
        align: "center",
        childGap: "1rem",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.BankIcon), {}),
            `Bank account ending in ${bank_account?.account_number_last_four ?? "****"}`
        ]
    });
    const CardPayment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
        align: "center",
        childGap: "1rem",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.GenericCard), {}),
            `Card ending in ${credit_card?.last_four ?? "****"}`
        ]
    });
    const CashPayment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
        align: "center",
        childGap: "1rem",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CashIcon), {}),
            `Cash`
        ]
    });
    const WirePayment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
        align: "center",
        childGap: "1rem",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CheckIcon), {}),
            `Wire Transfer`
        ]
    });
    const PaymentType = ()=>{
        switch(payment_type){
            case "Check Payment":
                return BankPayment;
            case "Card Payment":
                return CardPayment;
            // Need new icons for the other two types
            case "Advice of Credit":
                return BankPayment;
            case "Cash Payment":
                return CashPayment;
            case "Wire Payment":
                return WirePayment;
            default:
                return BankPayment;
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "1.5rem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
            childGap: ".5rem",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: "Payment ID"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 1;`,
                            children: payment_id
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: "Payment Method"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 1;`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentType, {})
                        })
                    ]
                }),
                transactionData.payer_name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: "Payer Name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            themeValues: {
                                fontSize: "1rem"
                            },
                            extraStyles: `flex-grow: 1;`,
                            children: transactionData.payer_name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            themeValues: {
                                fontSize: "1rem"
                            },
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: payment_type === "Cash" ? "Amount Given" : "Amount"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 1;`,
                            id: `payment-details-${index}-amount-processed`,
                            children: (0, _helpers.formatPrice)(amount_processed, isRefund)
                        })
                    ]
                }),
                !!change_due && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: "Change Given"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 1;`,
                            id: `payment-details-${index}-change-given`,
                            children: (0, _helpers.formatPrice)(change_due)
                        })
                    ]
                }),
                !!transactionData.service_fee && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            themeValues: {
                                fontSize: "1rem"
                            },
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: "Service Fee"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 1;`,
                            children: (0, _helpers.formatPrice)(transactionData.service_fee)
                        })
                    ]
                }),
                !!transactionData.convenience_fee && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            themeValues: {
                                fontSize: "1rem"
                            },
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: "Transaction Fee"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 1;`,
                            children: (0, _helpers.formatPrice)(transactionData.convenience_fee)
                        })
                    ]
                }),
                !!transactionData.wire_payment?.name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            themeValues: {
                                fontSize: "1rem"
                            },
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 1;`,
                            children: transactionData?.wire_payment?.name
                        })
                    ]
                }),
                !!transactionData.wire_payment?.effective_date && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            themeValues: {
                                fontSize: "1rem"
                            },
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: "Effective Date"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 1;`,
                            children: (()=>{
                                const [year, month, day] = transactionData.wire_payment.effective_date.split("-");
                                return `${month}/${day}/${year}`;
                            })()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem;`,
                            children: "Status"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 1;`,
                            id: `payment-details-${index}-status`,
                            children: (0, _helpers.titleCase)(status)
                        })
                    ]
                }),
                !!transactionData.wire_payment?.description && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    direction: "row",
                    childGap: "2rem",
                    nowrap: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            themeValues: {
                                fontSize: "1rem"
                            },
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            extraStyles: `width: 17.143rem; flex-shrink: 0;`,
                            children: "Description"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            extraStyles: `flex-grow: 0;`,
                            children: transactionData?.wire_payment?.description
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jdDhB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrderDetailsDebtItem", ()=>OrderDetailsDebtItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _helpers = require("../../utils/helpers");
const OrderDetailsDebtItem = ({ index, header, subheader, paid, isNegativeAmount, isRefund, fullAmount, externalAttributes, quantity, recordedPrice })=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const amountPaid = paid || "0.00";
    const titleSection = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            justify: "space-between",
            align: "center",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
                    childGap: ".25rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                            fontSize: "1.125rem",
                            children: header
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            themeValues: {
                                fontSize: "pL"
                            },
                            color: (0, _components.constants).colors.CHARADE_GREY,
                            children: subheader
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                    children: [
                        quantity > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Stack), {
                            justify: "center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                id: `quantity-at-recorded-price-${index}`,
                                extraStyles: `text-align: right;`,
                                children: `${(0, _helpers.formatPrice)(recordedPrice)} per x ${quantity}`
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "0",
                            extraStyles: `min-width: 10rem;`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
                                childGap: ".25rem",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                                        extraStyles: `text-align: right; margin-left: 4rem;`,
                                        id: `debt-item-${index}-total`,
                                        children: isNegativeAmount ? (0, _helpers.formatWithParentheses)((0, _helpers.formatPrice)(amountPaid, isRefund)) : (0, _helpers.formatPrice)(amountPaid, isRefund)
                                    }),
                                    fullAmount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Text), {
                                        extraStyles: `text-align: right;`,
                                        fontSize: "1rem",
                                        color: (0, _components.constants).colors.CHARADE_GREY,
                                        children: [
                                            "Full Amount: $",
                                            fullAmount
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0 0 1rem",
        extraStyles: `:last-child { padding: 0px; }`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.BoxWithShadow), {
            variant: "baseStandard",
            padding: "0",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CollapsibleSection), {
                    supportsTouch: false,
                    isOpen: isOpen,
                    title: titleSection,
                    initiallyOpen: false,
                    toggleSection: ()=>setIsOpen(!isOpen),
                    customTitle: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Motion), {
                        variants: {
                            open: {
                                opacity: 1
                            },
                            closed: {
                                opacity: 0
                            }
                        },
                        initial: "open",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            padding: "1rem",
                            background: "#eee",
                            id: "debt-item-attributes",
                            children: externalAttributes && Object.entries(externalAttributes).map(([key, value])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                    padding: "0rem",
                                    borderRadius: ".25rem",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        extraStyles: `text-align:left`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width:168px;`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                    children: [
                                                        (0, _helpers.titleCase)(key),
                                                        ":"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                                padding: "0",
                                                extraStyles: `width: calc(100% - 168px);`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Paragraph), {
                                                    fontSize: "1rem",
                                                    children: value
                                                })
                                            })
                                        ]
                                    })
                                }, `${key}-${value}`))
                        })
                    })
                })
            })
        })
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../utils/helpers":"epomp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g1MR4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusModule", ()=>StatusModule);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _statusIcons = require("../status-icons");
var _refundedIcon = require("../status-icons/RefundedIcon");
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
var _orderDetailsState = require("../../pages/order-details/OrderDetails.state");
var _uuid = require("uuid");
var _constants = require("../../utils/constants");
const INCOMPLETE_STATUS_TEXT = "Order Incomplete";
const VOIDED_STATUS_TEXT = "Order Voided";
const VOID_PENDING_STATUS_TEXT = "Void in Progress";
const CANCELED_STATUS_TEXT = "Order Cancelled";
const COMPLETED_STATUS_TEXT = "Successful";
const REFUNDED_ORDER_TEXT = "Refunded order";
const ORIGINAL_ORDER_TEXT = "Original order";
const OPENED_STATUS_TEXT = "Order Opened";
const HOLD_STATUS_TEXT = "Order on Hold";
const PAYLINK_SENT_STATUS_TEXT = "PayLink Sent";
const PAYLINK_COMPLETED_STATUS_TEXT = "PayLink Completed";
const DEFAULT_STATUS_TEXT = "N/A";
const StatusModule = ({ status = "", label })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const { parent_id = null, child_ids = [] } = {
        ...(0, _reactRedux.useSelector)((state)=>state.orderDetails.data.order)
    };
    const relatedOrderIdsArr = parent_id ? [
        parent_id
    ] : child_ids;
    const getOrderAction = (id, getOrderDetails = false)=>()=>{
            if (getOrderDetails) dispatch((0, _orderDetailsState.getOrderDetailsRequest)({
                id
            }));
            navigate(`/pos/order/${id}`);
        };
    const getCompletedLabelText = ()=>{
        if (parent_id) return `${REFUNDED_ORDER_TEXT} | ${ORIGINAL_ORDER_TEXT}:`;
        else return child_ids?.length ? `${label} ${COMPLETED_STATUS_TEXT} | ${REFUNDED_ORDER_TEXT}${child_ids.length > 1 ? "s" : ""}:` : `${label} ${COMPLETED_STATUS_TEXT}`;
    };
    let icon = "";
    let orderInfo = "";
    switch(status){
        case (0, _constants.ORDER_STATUS).INCOMPLETE:
            orderInfo = INCOMPLETE_STATUS_TEXT;
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcons.IncompleteIcon), {});
            break;
        case (0, _constants.ORDER_STATUS).VOIDED:
            orderInfo = VOIDED_STATUS_TEXT;
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcons.VoidedIcon), {});
            break;
        case (0, _constants.ORDER_STATUS).VOID_PENDING:
            orderInfo = VOID_PENDING_STATUS_TEXT;
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PendingIcon), {
                fill: (0, _components.constants).colors.LUCKY_POINT
            });
            break;
        case (0, _constants.ORDER_STATUS).CANCELLED:
            orderInfo = CANCELED_STATUS_TEXT;
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcons.CancelledIcon), {});
            break;
        case (0, _constants.ORDER_STATUS).COMPLETED:
            icon = parent_id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _refundedIcon.RefundedIcon), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcons.SuccessfulIcon), {});
            orderInfo = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                align: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0px",
                        children: getCompletedLabelText()
                    }),
                    relatedOrderIdsArr && relatedOrderIdsArr.map((id, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                            padding: "0",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                                    text: id,
                                    variant: "smallGhost",
                                    action: getOrderAction(id, !!parent_id),
                                    extraStyles: `min-width: 0px; margin: 0rem 0.25rem;`,
                                    textExtraStyles: "font-size: 1rem;"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                    children: index < relatedOrderIdsArr.length - 1 && ", "
                                })
                            ]
                        }, `${id}-${(0, _uuid.v4)()}`))
                ]
            });
            break;
        case (0, _constants.ORDER_STATUS).OPENED:
            orderInfo = OPENED_STATUS_TEXT;
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcons.OpenedIcon), {});
            break;
        case (0, _constants.ORDER_STATUS).HOLD:
            orderInfo = HOLD_STATUS_TEXT;
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcons.OnHoldIcon), {});
            break;
        case (0, _constants.ORDER_STATUS).PAYLINK_SENT:
            orderInfo = PAYLINK_SENT_STATUS_TEXT;
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PendingIcon), {
                fill: (0, _components.constants).colors.LUCKY_POINT
            });
            break;
        case (0, _constants.ORDER_STATUS).PAYLINK_COMPLETED:
            orderInfo = PAYLINK_COMPLETED_STATUS_TEXT;
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIcons.SuccessfulIcon), {});
            break;
        default:
            orderInfo = DEFAULT_STATUS_TEXT;
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PendingIcon), {});
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0",
        id: "order-status-module",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            align: "center",
            children: [
                icon,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "0px 0px 0px .75rem;",
                    children: orderInfo
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../status-icons":"bW6ID","../status-icons/RefundedIcon":"aFum0","react-router-dom":"hNarb","react-redux":"k6jol","../../pages/order-details/OrderDetails.state":"3yj5u","uuid":"4vdp3","../../utils/constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bW6ID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledIcon", ()=>(0, _cancelledIcon.CancelledIcon));
parcelHelpers.export(exports, "IncompleteIcon", ()=>(0, _incompleteIcon.IncompleteIcon));
parcelHelpers.export(exports, "OnHoldIcon", ()=>(0, _onHoldIcon.OnHoldIcon));
parcelHelpers.export(exports, "OpenedIcon", ()=>(0, _openedIcon.OpenedIcon));
parcelHelpers.export(exports, "SuccessfulIcon", ()=>(0, _successfulIcon.SuccessfulIcon));
parcelHelpers.export(exports, "VoidedIcon", ()=>(0, _voidedIcon.VoidedIcon));
var _cancelledIcon = require("./CancelledIcon");
var _incompleteIcon = require("./IncompleteIcon");
var _onHoldIcon = require("./OnHoldIcon");
var _openedIcon = require("./OpenedIcon");
var _successfulIcon = require("./SuccessfulIcon");
var _voidedIcon = require("./VoidedIcon");

},{"./CancelledIcon":"cZv5G","./IncompleteIcon":"2ZBZV","./OnHoldIcon":"9SI8n","./OpenedIcon":"eUlnu","./SuccessfulIcon":"hVg5h","./VoidedIcon":"1Plcs","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cZv5G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledIcon", ()=>CancelledIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const CancelledIcon = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "2D83D394-2F8A-46D5-A2D8-E68D3FD69DFD@1x"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm7 8H9a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V9a1 1 0 00-1-1zm-.5 2.56V22.5H10.56L22.5 10.56zM21.438 9.5L9.5 21.438V9.5h11.938z",
                fill: "#D11053",
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2ZBZV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IncompleteIcon", ()=>IncompleteIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const IncompleteIcon = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "5668D5CF-CF08-4632-9991-98C5B65E1837@1x"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm7 8H9a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V9a1 1 0 00-1-1zm-1.562 1.5l-2.272 2.273 1.061 1.06L22.5 10.56V22.5H10.56l2.203-2.202-1.061-1.06-2.202 2.2V9.5h11.938zm-4.443 4.445l-2.829 2.828 1.061 1.06 2.828-2.828-1.06-1.06z",
                fill: "#6D717E",
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9SI8n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnHoldIcon", ()=>OnHoldIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const OnHoldIcon = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "2A1EB2BD-2F2A-4952-A46C-46D7948B14AA@1x"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm7 8H9a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V9a1 1 0 00-1-1zm-.5 1.5v13h-13v-13h13zM13 15a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2z",
                fill: "#6D717E",
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eUlnu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenedIcon", ()=>OpenedIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _components = require("@thecb/components");
const OpenedIcon = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "8F2BBA62-927B-4722-8677-5D29EB99E767@1x"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm6 9H10a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V10a1 1 0 00-1-1zm-.5 1.5v11h-11v-11h11z",
                fill: (0, _components.constants).colors.LUCKY_POINT,
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hVg5h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SuccessfulIcon", ()=>SuccessfulIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SuccessfulIcon = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "C1F6149D-4E7F-44F6-BDE2-F0AE4AE8C367@1x"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm9.692-21.536a.5.5 0 010 .708L14.386 22.478a.506.506 0 01-.007.007l-.707.707a.5.5 0 01-.708 0l-.707-.707-.007-.008-4.942-4.941a.5.5 0 010-.708l.707-.707a.5.5 0 01.707 0l4.596 4.595 10.96-10.959a.5.5 0 01.707 0l.707.707z",
                fill: "#317D4F",
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1Plcs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VoidedIcon", ()=>VoidedIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const VoidedIcon = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "498706F8-783F-4FF3-BBAD-19469DB2C3DE@1x"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zM11.404 9.99L16 14.586l4.596-4.596a.5.5 0 01.707 0l.707.707a.5.5 0 010 .707L17.414 16l4.596 4.596a.5.5 0 010 .707l-.707.707a.5.5 0 01-.707 0L16 17.414l-4.596 4.596a.5.5 0 01-.707 0l-.707-.707a.5.5 0 010-.707L14.586 16 9.99 11.404a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0z",
                fill: "#317D4F",
                fillRule: "evenodd"
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aFum0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RefundedIcon", ()=>RefundedIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const RefundedIcon = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "12",
                fill: "#317D4F"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0975 16.8351V18H13.4122V16.8416C11.5797 16.6399 10.396 15.7549 10.2154 14.1085L12.2485 14.0694C12.4558 14.9284 13.2049 15.3839 14.2749 15.3839C15.2379 15.3839 15.9268 14.8829 15.9268 14.2126C15.9268 13.5163 15.4787 13.2299 14.5357 13.0217L12.9507 12.6898C11.4727 12.397 10.523 11.5575 10.503 10.1128C10.4896 8.57701 11.7202 7.5423 13.4456 7.2885V6H15.1376V7.29501C16.823 7.58134 17.8462 8.70065 17.8261 10.0477L15.8532 10.0803C15.7328 9.24729 15.345 8.7397 14.315 8.7397C13.2517 8.7397 12.5963 9.20824 12.5963 9.89154C12.5963 10.4382 12.9039 10.7115 13.9539 10.9783L15.5121 11.3492C17.271 11.7592 18 12.7874 18 14.1996C18 15.6182 16.8831 16.6074 15.0975 16.8351ZM9.00001 13.8125C9.00001 14.2245 8.52963 14.4597 8.20001 14.2125L5.53334 12.2125C5.26668 12.0125 5.26668 11.6125 5.53334 11.4125L8.20001 9.4125C8.52963 9.16529 9.00001 9.40048 9.00001 9.8125V13.8125Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                id: "mask0_881_9198",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "5",
                y: "6",
                width: "13",
                height: "12",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15.0975 16.8351V18H13.4122V16.8416C11.5797 16.6399 10.396 15.7549 10.2154 14.1085L12.2485 14.0694C12.4558 14.9284 13.2049 15.3839 14.2749 15.3839C15.2379 15.3839 15.9268 14.8829 15.9268 14.2126C15.9268 13.5163 15.4787 13.2299 14.5357 13.0217L12.9507 12.6898C11.4727 12.397 10.523 11.5575 10.503 10.1128C10.4896 8.57701 11.7202 7.5423 13.4456 7.2885V6H15.1376V7.29501C16.823 7.58134 17.8462 8.70065 17.8261 10.0477L15.8532 10.0803C15.7328 9.24729 15.345 8.7397 14.315 8.7397C13.2517 8.7397 12.5963 9.20824 12.5963 9.89154C12.5963 10.4382 12.9039 10.7115 13.9539 10.9783L15.5121 11.3492C17.271 11.7592 18 12.7874 18 14.1996C18 15.6182 16.8831 16.6074 15.0975 16.8351ZM9.00001 13.8125C9.00001 14.2245 8.52963 14.4597 8.20001 14.2125L5.53334 12.2125C5.26668 12.0125 5.26668 11.6125 5.53334 11.4125L8.20001 9.4125C8.52963 9.16529 9.00001 9.40048 9.00001 9.8125V13.8125Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                mask: "url(#mask0_881_9198)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    x: "3",
                    y: "3",
                    width: "18",
                    height: "18",
                    fill: "white"
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k6Czs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _ordersIndex = require("./OrdersIndex");
var _ordersIndexDefault = parcelHelpers.interopDefault(_ordersIndex);
var _ordersIndexState = require("./OrdersIndex.state");
exports.default = (0, _reactRedux.connect)((0, _ordersIndexState.mapStateToProps), (0, _ordersIndexState.mapDispatchToProps))((0, _ordersIndexDefault.default));

},{"react-redux":"k6jol","./OrdersIndex":"hab8t","./OrdersIndex.state":"cB6HN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hab8t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _table = require("../../components/table");
var _helpers = require("../../utils/helpers");
var _ordersIndexFiltersForm = require("./OrdersIndexFiltersForm");
var _constants = require("../../utils/constants");
var _reactRedux = require("react-redux");
var _shared = require("../../state/shared");
var _filterFormsHelpers = require("../../utils/filterFormsHelpers");
const Header = ({ alertBar, alertBarActions })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "1rem 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "1rem 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Orders"
                })
            ]
        })
    });
const renderIcon = (value)=>{
    const paymentType = value?.[0];
    switch(paymentType){
        case 0, _constants.CHECK:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.BankIcon), {});
        case 0, _constants.WIRE:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CheckIcon), {});
        case 0, _constants.CASH:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.CashIcon), {});
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.GenericCard), {});
    }
};
const PaymentMethodCell = ({ value })=>{
    if (!value) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
        fontSize: "1rem",
        extraStyles: `font-style: italic;`,
        children: "Not taken"
    });
    switch(value.length){
        case 0:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                fontSize: "1rem",
                extraStyles: `font-style: italic;`,
                children: "Not taken"
            });
        case 1:
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                justify: "start",
                align: "center",
                children: [
                    renderIcon(value),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                        padding: "0 0.5rem",
                        children: value[0] === "wire_payment" ? "Wire Transfer" : (0, _helpers.capitalize)(value[0])
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                fontSize: "1rem",
                children: "Multi-tender"
            });
    }
};
const OrdersIndex = ({ alertBars, actions, fetching, fetchData, forms, data, pageCount, totalOrders, clearSearchForm, shouldClear, errors })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { agencies, batches, order_statuses, payment_methods, locations, terminals, users } = (0, _reactRedux.useSelector)((state)=>state.shared.tableFilterOptions);
    const { isLoadingOrders } = (0, _reactRedux.useSelector)((state)=>state.ordersIndex);
    (0, _react.useEffect)(()=>{
        dispatch((0, _shared.fetchOrdersFilterOptionsRequest)());
    }, []);
    const columns = (0, _react.useMemo)(()=>[
            {
                Header: "Order Number",
                accessor: "order_number",
                Cell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                        url: `/pos/order/${value}`,
                        variant: "smallGhost",
                        text: value,
                        extraStyles: `margin: 0.5rem 0; text-align: left; min-width: 0px;`,
                        textExtraStyles: "font-size: 1rem;",
                        contentOverride: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                            fontSize: "1rem",
                            color: (0, _components.constants).colors.LUCKY_POINT,
                            children: value
                        })
                    }),
                width: 80
            },
            {
                Header: "Batch Number",
                accessor: "batch_number",
                width: 160
            },
            {
                Header: "Services",
                accessor: "services",
                width: 200,
                Cell: ({ value: services })=>services.join(", ")
            },
            {
                Header: "Date",
                accessor: "date",
                width: 160,
                Cell: ({ value })=>(0, _helpers.formatDate)(value)
            },
            {
                Header: "Payment Method",
                accessor: "payment_methods",
                width: 130,
                Cell: PaymentMethodCell
            },
            {
                Header: "Status",
                accessor: "status",
                width: 80,
                Cell: ({ value, row })=>row.original.parent_id ? (0, _helpers.titleCase)((0, _constants.ORDER_STATUS).REFUNDED) : (0, _helpers.titleCase)(value)
            },
            {
                Header: "Amount",
                accessor: "amount",
                Cell: ({ value, row })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        fontSize: "1rem",
                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                        children: (0, _helpers.formatPrice)(value, !!row.original.parent_id)
                    }),
                width: 50
            }
        ], []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DefaultPageTemplate), {
        maxWidth: "85.714rem",
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.ordersIndexAlertBars,
            alertBarActions: actions.alertBars.ordersIndexAlertBars
        }, "OrdersIndexHeader"),
        gutters: "0",
        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
            errors: errors,
            totalItems: totalOrders,
            columns: columns,
            data: data?.orders || [],
            loading: isLoadingOrders,
            pageCount: pageCount,
            fetchData: fetchData,
            labelForTotal: "Orders",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ordersIndexFiltersForm.OrdersIndexFiltersForm), {
                ...forms.ordersIndexFiltersForm,
                ...actions.forms.ordersIndexFiltersForm,
                showErrors: errors,
                agencyOptions: [
                    (0, _filterFormsHelpers.getDefaultFormSelectOption)("agencies"),
                    ...agencies
                ],
                locationOptions: [
                    (0, _filterFormsHelpers.getDefaultFormSelectOption)("locations"),
                    ...locations
                ],
                orderStatusOptions: [
                    (0, _filterFormsHelpers.getDefaultFormSelectOption)("statuses"),
                    ...order_statuses
                ],
                paymentMethodOptions: [
                    (0, _filterFormsHelpers.getDefaultFormSelectOption)("methods"),
                    ...payment_methods
                ],
                terminalOptions: [
                    (0, _filterFormsHelpers.getDefaultFormSelectOption)("terminals"),
                    ...terminals
                ],
                userOptions: [
                    (0, _filterFormsHelpers.getDefaultFormSelectOption)("users"),
                    ...users
                ],
                batchOptions: [
                    (0, _filterFormsHelpers.getDefaultFormSelectOption)("batches"),
                    ...batches
                ],
                clear: clearSearchForm,
                shouldClear: shouldClear,
                fetchData: fetchData,
                loading: fetching,
                forms: forms
            })
        })
    });
};
exports.default = OrdersIndex;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../components/alert-bar":"aD416","../../components/table":"4QErL","../../utils/helpers":"epomp","./OrdersIndexFiltersForm":"aKM2X","../../utils/constants":"f3A1R","react-redux":"k6jol","../../state/shared":"h0jLC","../../utils/filterFormsHelpers":"iHHYA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4QErL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>(0, _table.Table));
parcelHelpers.export(exports, "TableCell", ()=>(0, _tableCell.TableCell));
parcelHelpers.export(exports, "TableRow", ()=>(0, _tableRow.TableRow));
var _table = require("./Table");
var _tableCell = require("./TableCell");
var _tableRow = require("./TableRow");

},{"./Table":"evyS4","./TableCell":"lNuiy","./TableRow":"1pLAa","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"evyS4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTable = require("react-table");
var _ramda = require("ramda");
var _components = require("@thecb/components");
var _tableStyled = require("./Table.styled");
var _rxjs = require("rxjs");
var _nextPageIcon = require("../status-icons/NextPageIcon");
var _prevPageIcon = require("../status-icons/PrevPageIcon");
var _images = require("../images");
var _uuid = require("uuid");
var _useDelayMount = require("../../utils/hooks/useDelayMount");
var _useDelayMountDefault = parcelHelpers.interopDefault(_useDelayMount);
var _constants = require("../../utils/constants");
const Table = ({ columns, data, fetchData, loading, pageCount: controlledPageCount, children: filters, totalItems, labelForTotal = "" })=>{
    const [isLoadingDelayComplete, setIsLoadingDelayComplete] = (0, _useDelayMountDefault.default)((0, _constants.TABLE_MIN_LOADTIME_MS));
    const LoadingRow = (0, _react.useMemo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyled.TableRowWrapper), {
            children: columns.map((c, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyled.TableCellWrapper), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.LoadingLine), {
                        margin: "12px 0px",
                        exactWidth: c.width
                    })
                }, `${idx}-${(0, _uuid.v4)()}`))
        }), [
        columns
    ]);
    const { getTableProps, getTableBodyProps, headers, prepareRow, page, // which has only the rows for the active page
    canPreviousPage, canNextPage, // pageOptions,
    pageCount, gotoPage, nextPage, previousPage, state: { pageIndex, pageSize } } = (0, _reactTable.useTable)({
        pageSize: 15,
        columns,
        data,
        initialState: {
            // Pass our hoisted table state
            pageIndex: 0,
            pageSize: 15
        },
        manualPagination: true,
        // hook that we'll handle our own data fetching
        // This means we'll also have to provide our own
        // pageCount.
        pageCount: controlledPageCount
    }, (0, _reactTable.usePagination));
    const wrappedGoToPage = (page)=>{
        if (page || page === 0) {
            setIsLoadingDelayComplete(false);
            gotoPage(page);
        } else (0, _rxjs.noop)();
    };
    (0, _react.useEffect)(()=>{
        fetchData({
            pageIndex: pageIndex + 1
        }); // api uses page 1 as first page
    }, [
        pageIndex
    ]);
    const Pagination = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyled.PaginationWrapper), {
            className: "pagination",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                childGap: ".5rem",
                justify: "center",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        contentOverride: true,
                        disabled: !canPreviousPage,
                        variant: "primary",
                        action: ()=>{
                            setIsLoadingDelayComplete(false);
                            previousPage();
                        },
                        textExtraStyles: "font-size: 1rem;",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prevPageIcon.PrevPageIcon), {})
                    }),
                    pageIndex > 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        variant: "ghost",
                        action: ()=>wrappedGoToPage(0),
                        text: "1",
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    pageIndex > 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        children: "..."
                    }),
                    pageIndex > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        variant: "ghost",
                        action: ()=>wrappedGoToPage(pageIndex - 2),
                        text: pageIndex - 1,
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    pageIndex > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        variant: "ghost",
                        action: ()=>wrappedGoToPage(pageIndex - 1),
                        text: pageIndex,
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        text: pageIndex + 1,
                        variant: "secondary",
                        action: ()=>(0, _rxjs.noop)(),
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    pageIndex + 1 < pageCount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        text: pageIndex + 2,
                        variant: "ghost",
                        action: ()=>wrappedGoToPage(pageIndex + 1),
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    pageIndex + 2 < pageCount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        text: pageIndex + 3,
                        variant: "ghost",
                        action: ()=>wrappedGoToPage(pageIndex + 2),
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    pageIndex + 3 < pageCount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Text), {
                        children: "..."
                    }),
                    pageIndex + 3 < pageCount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        text: pageCount,
                        variant: "ghost",
                        action: ()=>wrappedGoToPage(pageCount - 1),
                        textExtraStyles: "font-size: 1rem;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                        contentOverride: true,
                        disabled: !canNextPage,
                        variant: "primary",
                        action: ()=>{
                            setIsLoadingDelayComplete(false);
                            nextPage();
                        },
                        textExtraStyles: "font-size: 1rem;",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nextPageIcon.NextPageIcon), {})
                    })
                ]
            })
        });
    const isLastPage = pageIndex === pageCount - 1;
    const remainingRecords = (0, _react.useMemo)(()=>isLastPage ? totalItems - pageSize * pageIndex : null, [
        isLastPage
    ]);
    const loadingRowsArr = _ramda.range(0, remainingRecords || pageSize);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.BoxWithShadow), {
                background: (0, _components.constants).colors.WHITE,
                variant: "baseStandard",
                padding: "0",
                borderRadius: ".25rem",
                children: filters
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "1.25rem 0 0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Title), {
                    variant: "small",
                    as: "h3",
                    children: [
                        (loading || !isLoadingDelayComplete) && "Pending...",
                        !loading && isLoadingDelayComplete && totalItems > 0 && totalItems + ` ${labelForTotal}`
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableStyled.TableWrapper), {
                ...getTableProps(),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyled.TableHeaderWrapper), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyled.TableRowWrapper), {
                            children: headers.map((column)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyled.TableHeaderCellWrapper), {
                                    ...column.getHeaderProps(),
                                    children: column.render("Header")
                                }, column.slug))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableStyled.TableBody), {
                        ...getTableBodyProps(),
                        "data-testid": "table-body",
                        children: [
                            (loading || !isLoadingDelayComplete) && loadingRowsArr.map((idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                                    children: LoadingRow
                                }, idx)),
                            !loading && isLoadingDelayComplete && page.map((row)=>{
                                prepareRow(row);
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyled.TableRowWrapper), {
                                    ...row.getRowProps(),
                                    children: row.cells.map((cell)=>{
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyled.TableCellWrapper), {
                                            ...cell.getCellProps({
                                                style: {
                                                    width: cell.column.width
                                                }
                                            }),
                                            children: cell.render("Cell")
                                        }, cell.slug);
                                    })
                                }, row.slug);
                            })
                        ]
                    })
                ]
            }),
            !loading && !totalItems && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "4rem",
                background: (0, _components.constants).colors.WHITE,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                    intrinsic: "true",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Stack), {
                        direction: "column",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                                intrinsic: "true",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _images.NoResultsImage), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                                intrinsic: "true",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                                    variant: "large",
                                    as: "p",
                                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                    children: "No Results Found"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                                intrinsic: "true",
                                maxWidth: "26rem",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    as: "p",
                                    children: "We couldn\u2019t find anything that matched your search."
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Center), {
                                intrinsic: "true",
                                maxWidth: "26rem",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                    as: "p",
                                    children: "Please edit your search again and try again."
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pagination, {})
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-table":"eJ6wp","ramda":"JPp0Z","@thecb/components":"g98ma","./Table.styled":"fOGsv","rxjs":"kbxjh","../status-icons/NextPageIcon":"5b6en","../status-icons/PrevPageIcon":"bOAyc","../images":"fAggk","uuid":"4vdp3","../../utils/hooks/useDelayMount":"5TzpP","../../utils/constants":"f3A1R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eJ6wp":[function(require,module,exports) {
module.exports = require("9221076d1c9660f1");

},{"9221076d1c9660f1":"1FnzI"}],"1FnzI":[function(require,module,exports) {
!function(e, t) {
    t(exports, require("3b97acdd01f16919"));
}(this, function(e, t) {
    "use strict";
    function n(e, t, n, o, r, i, u) {
        try {
            var l = e[i](u), s = l.value;
        } catch (e) {
            return void n(e);
        }
        l.done ? t(s) : Promise.resolve(s).then(o, r);
    }
    function o(e) {
        return function() {
            var t = this, o = arguments;
            return new Promise(function(r, i) {
                var u = e.apply(t, o);
                function l(e) {
                    n(u, r, i, l, s, "next", e);
                }
                function s(e) {
                    n(u, r, i, l, s, "throw", e);
                }
                l(void 0);
            });
        };
    }
    function r() {
        return (r = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
        }).apply(this, arguments);
    }
    function i(e, t) {
        if (null == e) return {};
        var n, o, r = {}, i = Object.keys(e);
        for(o = 0; o < i.length; o++)n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
        return r;
    }
    function u(e) {
        var t = function(e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var o = n.call(e, t || "default");
                if ("object" != typeof o) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : String(t);
    }
    t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    var l = {
        init: "init"
    }, s = function(e) {
        var t = e.value;
        return void 0 === t ? "" : t;
    }, a = function() {
        return t.createElement(t.Fragment, null, "\xa0");
    }, c = {
        Cell: s,
        width: 150,
        minWidth: 0,
        maxWidth: Number.MAX_SAFE_INTEGER
    };
    function d() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        return t.reduce(function(e, t) {
            var n = t.style, o = t.className;
            return e = r({}, e, {}, i(t, [
                "style",
                "className"
            ])), n && (e.style = e.style ? r({}, e.style || {}, {}, n || {}) : n), o && (e.className = e.className ? e.className + " " + o : o), "" === e.className && delete e.className, e;
        }, {});
    }
    var f = function(e, t) {
        return void 0 === t && (t = {}), function(n) {
            return void 0 === n && (n = {}), [].concat(e, [
                n
            ]).reduce(function(e, o) {
                return function e(t, n, o) {
                    return "function" == typeof n ? e({}, n(t, o)) : Array.isArray(n) ? d.apply(void 0, [
                        t
                    ].concat(n)) : d(t, n);
                }(e, o, r({}, t, {
                    userProps: n
                }));
            }, {});
        };
    }, p = function(e, t, n, o) {
        return void 0 === n && (n = {}), e.reduce(function(e, t) {
            return t(e, n);
        }, t);
    }, g = function(e, t, n) {
        return void 0 === n && (n = {}), e.forEach(function(e) {
            e(t, n);
        });
    };
    function v(e, t, n, o) {
        e.findIndex(function(e) {
            return e.pluginName === n;
        });
        t.forEach(function(t) {
            e.findIndex(function(e) {
                return e.pluginName === t;
            });
        });
    }
    function m(e, t) {
        return "function" == typeof e ? e(t) : e;
    }
    function h(e) {
        var n = t.useRef();
        return n.current = e, t.useCallback(function() {
            return n.current;
        }, []);
    }
    var y = "undefined" != typeof document ? t.useLayoutEffect : t.useEffect;
    function w(e, n) {
        var o = t.useRef(!1);
        y(function() {
            o.current && e(), o.current = !0;
        }, n);
    }
    function R(e, t, n) {
        return void 0 === n && (n = {}), function(o, i) {
            void 0 === i && (i = {});
            var u = "string" == typeof o ? t[o] : o;
            if (void 0 === u) throw console.info(t), new Error("Renderer Error \u261D\uFE0F");
            return b(u, r({}, e, {
                column: t
            }, n, {}, i));
        };
    }
    function b(e, n) {
        var o;
        return function(e) {
            var t;
            return "function" == typeof e && (t = Object.getPrototypeOf(e)).prototype && t.prototype.isReactComponent;
        }(o = e) || "function" == typeof o || function(e) {
            return "object" == typeof e && "symbol" == typeof e.$$typeof && [
                "react.memo",
                "react.forward_ref"
            ].includes(e.$$typeof.description);
        }(o) ? t.createElement(e, n) : e;
    }
    function S(e, t, n) {
        return void 0 === n && (n = 0), e.map(function(e) {
            return x(e = r({}, e, {
                parent: t,
                depth: n
            })), e.columns && (e.columns = S(e.columns, e, n + 1)), e;
        });
    }
    function C(e) {
        return G(e, "columns");
    }
    function x(e) {
        var t = e.id, n = e.accessor, o = e.Header;
        if ("string" == typeof n) {
            t = t || n;
            var r = n.split(".");
            n = function(e) {
                return function(e, t, n) {
                    if (!t) return e;
                    var o, r = "function" == typeof t ? t : JSON.stringify(t), i = E.get(r) || function() {
                        var e = function(e) {
                            return (function e(t, n) {
                                void 0 === n && (n = []);
                                if (Array.isArray(t)) for(var o = 0; o < t.length; o += 1)e(t[o], n);
                                else n.push(t);
                                return n;
                            })(e).map(function(e) {
                                return String(e).replace(".", "_");
                            }).join(".").replace(W, ".").replace(O, "").split(".");
                        }(t);
                        return E.set(r, e), e;
                    }();
                    try {
                        o = i.reduce(function(e, t) {
                            return e[t];
                        }, e);
                    } catch (e) {}
                    return void 0 !== o ? o : n;
                }(e, r);
            };
        }
        if (!t && "string" == typeof o && o && (t = o), !t && e.columns) throw console.error(e), new Error('A column ID (or unique "Header" value) is required!');
        if (!t) throw console.error(e), new Error("A column ID (or string accessor) is required!");
        return Object.assign(e, {
            id: t,
            accessor: n
        }), e;
    }
    function P(e, t) {
        if (!t) throw new Error;
        return Object.assign(e, r({
            Header: a,
            Footer: a
        }, c, {}, t, {}, e)), Object.assign(e, {
            originalWidth: e.width
        }), e;
    }
    function B(e, t, n) {
        void 0 === n && (n = function() {
            return {};
        });
        for(var o = [], i = e, u = 0, l = function() {
            return u++;
        }, s = function() {
            var e = {
                headers: []
            }, u = [], s = i.some(function(e) {
                return e.parent;
            });
            i.forEach(function(o) {
                var i, a = [].concat(u).reverse()[0];
                if (s) {
                    if (o.parent) i = r({}, o.parent, {
                        originalId: o.parent.id,
                        id: o.parent.id + "_" + l(),
                        headers: [
                            o
                        ]
                    }, n(o));
                    else i = P(r({
                        originalId: o.id + "_placeholder",
                        id: o.id + "_placeholder_" + l(),
                        placeholderOf: o,
                        headers: [
                            o
                        ]
                    }, n(o)), t);
                    a && a.originalId === i.originalId ? a.headers.push(o) : u.push(i);
                }
                e.headers.push(o);
            }), o.push(e), i = u;
        }; i.length;)s();
        return o.reverse();
    }
    var E = new Map;
    function I() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        for(var o = 0; o < t.length; o += 1)if (void 0 !== t[o]) return t[o];
    }
    function F(e) {
        if ("function" == typeof e) return e;
    }
    function G(e, t) {
        var n = [];
        return function e(o) {
            o.forEach(function(o) {
                o[t] ? e(o[t]) : n.push(o);
            });
        }(e), n;
    }
    function A(e, t) {
        var n = t.manualExpandedKey, o = t.expanded, r = t.expandSubRows, i = void 0 === r || r, u = [];
        return e.forEach(function(e) {
            return function e(t, r) {
                void 0 === r && (r = !0), t.isExpanded = t.original && t.original[n] || o[t.id], t.canExpand = t.subRows && !!t.subRows.length, r && u.push(t), t.subRows && t.subRows.length && t.isExpanded && t.subRows.forEach(function(t) {
                    return e(t, i);
                });
            }(e);
        }), u;
    }
    function k(e, t, n) {
        return F(e) || t[e] || n[e] || n.text;
    }
    function H(e, t, n) {
        return e ? e(t, n) : void 0 === t;
    }
    function T() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var z = null;
    var W = /\[/g, O = /\]/g;
    var M = function(e) {
        return r({
            role: "table"
        }, e);
    }, j = function(e) {
        return r({
            role: "rowgroup"
        }, e);
    }, N = function(e, t) {
        var n = t.column;
        return r({
            key: "header_" + n.id,
            colSpan: n.totalVisibleHeaderCount,
            role: "columnheader"
        }, e);
    }, L = function(e, t) {
        var n = t.column;
        return r({
            key: "footer_" + n.id,
            colSpan: n.totalVisibleHeaderCount
        }, e);
    }, D = function(e, t) {
        return r({
            key: "headerGroup_" + t.index,
            role: "row"
        }, e);
    }, V = function(e, t) {
        return r({
            key: "footerGroup_" + t.index
        }, e);
    }, _ = function(e, t) {
        return r({
            key: "row_" + t.row.id,
            role: "row"
        }, e);
    }, X = function(e, t) {
        var n = t.cell;
        return r({
            key: "cell_" + n.row.id + "_" + n.column.id,
            role: "cell"
        }, e);
    };
    function q() {
        return {
            useOptions: [],
            stateReducers: [],
            useControlledState: [],
            columns: [],
            columnsDeps: [],
            allColumns: [],
            allColumnsDeps: [],
            accessValue: [],
            materializedColumns: [],
            materializedColumnsDeps: [],
            useInstanceAfterData: [],
            visibleColumns: [],
            visibleColumnsDeps: [],
            headerGroups: [],
            headerGroupsDeps: [],
            useInstanceBeforeDimensions: [],
            useInstance: [],
            prepareRow: [],
            getTableProps: [
                M
            ],
            getTableBodyProps: [
                j
            ],
            getHeaderGroupProps: [
                D
            ],
            getFooterGroupProps: [
                V
            ],
            getHeaderProps: [
                N
            ],
            getFooterProps: [
                L
            ],
            getRowProps: [
                _
            ],
            getCellProps: [
                X
            ],
            useFinalInstance: []
        };
    }
    l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";
    var K = function(e) {
        e.getToggleHiddenProps = [
            U
        ], e.getToggleHideAllColumnsProps = [
            $
        ], e.stateReducers.push(J), e.useInstanceBeforeDimensions.push(Y), e.headerGroupsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.hiddenColumns
            ]);
        }), e.useInstance.push(Q);
    };
    K.pluginName = "useColumnVisibility";
    var U = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHidden(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isVisible,
                title: "Toggle Column Visible"
            }
        ];
    }, $ = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHideAllColumns(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !n.allColumnsHidden && !n.state.hiddenColumns.length,
                title: "Toggle All Columns Hidden",
                indeterminate: !n.allColumnsHidden && n.state.hiddenColumns.length
            }
        ];
    };
    function J(e, t, n, o) {
        if (t.type === l.init) return r({
            hiddenColumns: []
        }, e);
        if (t.type === l.resetHiddenColumns) return r({}, e, {
            hiddenColumns: o.initialState.hiddenColumns || []
        });
        if (t.type === l.toggleHideColumn) {
            var i = (void 0 !== t.value ? t.value : !e.hiddenColumns.includes(t.columnId)) ? [].concat(e.hiddenColumns, [
                t.columnId
            ]) : e.hiddenColumns.filter(function(e) {
                return e !== t.columnId;
            });
            return r({}, e, {
                hiddenColumns: i
            });
        }
        return t.type === l.setHiddenColumns ? r({}, e, {
            hiddenColumns: m(t.value, e.hiddenColumns)
        }) : t.type === l.toggleHideAllColumns ? r({}, e, {
            hiddenColumns: (void 0 !== t.value ? t.value : !e.hiddenColumns.length) ? o.allColumns.map(function(e) {
                return e.id;
            }) : []
        }) : void 0;
    }
    function Y(e) {
        var n = e.headers, o = e.state.hiddenColumns;
        t.useRef(!1).current;
        var r = 0;
        n.forEach(function(e) {
            return r += function e(t, n) {
                t.isVisible = n && !o.includes(t.id);
                var r = 0;
                return t.headers && t.headers.length ? t.headers.forEach(function(n) {
                    return r += e(n, t.isVisible);
                }) : r = t.isVisible ? 1 : 0, t.totalVisibleHeaderCount = r, r;
            }(e, !0);
        });
    }
    function Q(e) {
        var n = e.columns, o = e.flatHeaders, r = e.dispatch, i = e.allColumns, u = e.getHooks, s = e.state.hiddenColumns, a = e.autoResetHiddenColumns, c = void 0 === a || a, d = h(e), p = i.length === s.length, g = t.useCallback(function(e, t) {
            return r({
                type: l.toggleHideColumn,
                columnId: e,
                value: t
            });
        }, [
            r
        ]), v = t.useCallback(function(e) {
            return r({
                type: l.setHiddenColumns,
                value: e
            });
        }, [
            r
        ]), m = t.useCallback(function(e) {
            return r({
                type: l.toggleHideAllColumns,
                value: e
            });
        }, [
            r
        ]), y = f(u().getToggleHideAllColumnsProps, {
            instance: d()
        });
        o.forEach(function(e) {
            e.toggleHidden = function(t) {
                r({
                    type: l.toggleHideColumn,
                    columnId: e.id,
                    value: t
                });
            }, e.getToggleHiddenProps = f(u().getToggleHiddenProps, {
                instance: d(),
                column: e
            });
        });
        var R = h(c);
        w(function() {
            R() && r({
                type: l.resetHiddenColumns
            });
        }, [
            r,
            n
        ]), Object.assign(e, {
            allColumnsHidden: p,
            toggleHideColumn: g,
            setHiddenColumns: v,
            toggleHideAllColumns: m,
            getToggleHideAllColumnsProps: y
        });
    }
    var Z = {}, ee = {}, te = function(e, t, n) {
        return e;
    }, ne = function(e, t) {
        return e.subRows || [];
    }, oe = function(e, t, n) {
        return "" + (n ? [
            n.id,
            t
        ].join(".") : t);
    }, re = function(e) {
        return e;
    };
    function ie(e) {
        var t = e.initialState, n = void 0 === t ? Z : t, o = e.defaultColumn, u = void 0 === o ? ee : o, l = e.getSubRows, s = void 0 === l ? ne : l, a = e.getRowId, c = void 0 === a ? oe : a, d = e.stateReducer, f = void 0 === d ? te : d, p = e.useControlledState, g = void 0 === p ? re : p;
        return r({}, i(e, [
            "initialState",
            "defaultColumn",
            "getSubRows",
            "getRowId",
            "stateReducer",
            "useControlledState"
        ]), {
            initialState: n,
            defaultColumn: u,
            getSubRows: s,
            getRowId: c,
            stateReducer: f,
            useControlledState: g
        });
    }
    function ue(e, t) {
        void 0 === t && (t = 0);
        var n = 0, o = 0, r = 0, i = 0;
        return e.forEach(function(e) {
            var u = e.headers;
            if (e.totalLeft = t, u && u.length) {
                var l = ue(u, t), s = l[0], a = l[1], c = l[2], d = l[3];
                e.totalMinWidth = s, e.totalWidth = a, e.totalMaxWidth = c, e.totalFlexWidth = d;
            } else e.totalMinWidth = e.minWidth, e.totalWidth = Math.min(Math.max(e.minWidth, e.width), e.maxWidth), e.totalMaxWidth = e.maxWidth, e.totalFlexWidth = e.canResize ? e.totalWidth : 0;
            e.isVisible && (t += e.totalWidth, n += e.totalMinWidth, o += e.totalWidth, r += e.totalMaxWidth, i += e.totalFlexWidth);
        }), [
            n,
            o,
            r,
            i
        ];
    }
    function le(e) {
        var t = e.data, n = e.rows, o = e.flatRows, r = e.rowsById, i = e.column, u = e.getRowId, l = e.getSubRows, s = e.accessValueHooks, a = e.getInstance;
        t.forEach(function(e, c) {
            return function e(n, c, d, f, g) {
                void 0 === d && (d = 0);
                var v = n, m = u(n, c, f), h = r[m];
                if (h) h.subRows && h.originalSubRows.forEach(function(t, n) {
                    return e(t, n, d + 1, h);
                });
                else if ((h = {
                    id: m,
                    original: v,
                    index: c,
                    depth: d,
                    cells: [
                        {}
                    ]
                }).cells.map = T, h.cells.filter = T, h.cells.forEach = T, h.cells[0].getCellProps = T, h.values = {}, g.push(h), o.push(h), r[m] = h, h.originalSubRows = l(n, c), h.originalSubRows) {
                    var y = [];
                    h.originalSubRows.forEach(function(t, n) {
                        return e(t, n, d + 1, h, y);
                    }), h.subRows = y;
                }
                i.accessor && (h.values[i.id] = i.accessor(n, c, h, g, t)), h.values[i.id] = p(s, h.values[i.id], {
                    row: h,
                    column: i,
                    instance: a()
                });
            }(e, c, 0, void 0, n);
        });
    }
    l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var se = function(e) {
        e.getToggleAllRowsExpandedProps = [
            ae
        ], e.getToggleRowExpandedProps = [
            ce
        ], e.stateReducers.push(de), e.useInstance.push(fe), e.prepareRow.push(pe);
    };
    se.pluginName = "useExpanded";
    var ae = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onClick: function(e) {
                    n.toggleAllRowsExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle All Rows Expanded"
            }
        ];
    }, ce = function(e, t) {
        var n = t.row;
        return [
            e,
            {
                onClick: function() {
                    n.toggleRowExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle Row Expanded"
            }
        ];
    };
    function de(e, t, n, o) {
        if (t.type === l.init) return r({
            expanded: {}
        }, e);
        if (t.type === l.resetExpanded) return r({}, e, {
            expanded: o.initialState.expanded || {}
        });
        if (t.type === l.toggleAllRowsExpanded) {
            var s = t.value, a = o.isAllRowsExpanded, c = o.rowsById;
            if (void 0 !== s ? s : !a) {
                var d = {};
                return Object.keys(c).forEach(function(e) {
                    d[e] = !0;
                }), r({}, e, {
                    expanded: d
                });
            }
            return r({}, e, {
                expanded: {}
            });
        }
        if (t.type === l.toggleRowExpanded) {
            var f, p = t.id, g = t.value, v = e.expanded[p], m = void 0 !== g ? g : !v;
            if (!v && m) return r({}, e, {
                expanded: r({}, e.expanded, (f = {}, f[p] = !0, f))
            });
            if (v && !m) {
                var h = e.expanded;
                h[p];
                return r({}, e, {
                    expanded: i(h, [
                        p
                    ].map(u))
                });
            }
            return e;
        }
    }
    function fe(e) {
        var n = e.data, o = e.rows, r = e.rowsById, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.paginateExpandedRows, a = void 0 === s || s, c = e.expandSubRows, d = void 0 === c || c, p = e.autoResetExpanded, g = void 0 === p || p, m = e.getHooks, y = e.plugins, R = e.state.expanded, b = e.dispatch;
        v(y, [
            "useSortBy",
            "useGroupBy",
            "usePivotColumns",
            "useGlobalFilter"
        ], "useExpanded");
        var S = h(g), C = Boolean(Object.keys(r).length && Object.keys(R).length);
        C && Object.keys(r).some(function(e) {
            return !R[e];
        }) && (C = !1), w(function() {
            S() && b({
                type: l.resetExpanded
            });
        }, [
            b,
            n
        ]);
        var x = t.useCallback(function(e, t) {
            b({
                type: l.toggleRowExpanded,
                id: e,
                value: t
            });
        }, [
            b
        ]), P = t.useCallback(function(e) {
            return b({
                type: l.toggleAllRowsExpanded,
                value: e
            });
        }, [
            b
        ]), B = t.useMemo(function() {
            return a ? A(o, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: d
            }) : o;
        }, [
            a,
            o,
            u,
            R,
            d
        ]), E = t.useMemo(function() {
            return function(e) {
                var t = 0;
                return Object.keys(e).forEach(function(e) {
                    var n = e.split(".");
                    t = Math.max(t, n.length);
                }), t;
            }(R);
        }, [
            R
        ]), I = h(e), F = f(m().getToggleAllRowsExpandedProps, {
            instance: I()
        });
        Object.assign(e, {
            preExpandedRows: o,
            expandedRows: B,
            rows: B,
            expandedDepth: E,
            isAllRowsExpanded: C,
            toggleRowExpanded: x,
            toggleAllRowsExpanded: P,
            getToggleAllRowsExpandedProps: F
        });
    }
    function pe(e, t) {
        var n = t.instance.getHooks, o = t.instance;
        e.toggleRowExpanded = function(t) {
            return o.toggleRowExpanded(e.id, t);
        }, e.getToggleRowExpandedProps = f(n().getToggleRowExpandedProps, {
            instance: o,
            row: e
        });
    }
    var ge = function(e, t, n) {
        return e = e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return String(o).toLowerCase().includes(String(n).toLowerCase());
            });
        });
    };
    ge.autoRemove = function(e) {
        return !e;
    };
    var ve = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o).toLowerCase() === String(n).toLowerCase();
            });
        });
    };
    ve.autoRemove = function(e) {
        return !e;
    };
    var me = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o) === String(n);
            });
        });
    };
    me.autoRemove = function(e) {
        return !e;
    };
    var he = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t].includes(n);
            });
        });
    };
    he.autoRemove = function(e) {
        return !e || !e.length;
    };
    var ye = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.every(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    ye.autoRemove = function(e) {
        return !e || !e.length;
    };
    var we = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.some(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    we.autoRemove = function(e) {
        return !e || !e.length;
    };
    var Re = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return n.includes(o);
            });
        });
    };
    Re.autoRemove = function(e) {
        return !e || !e.length;
    };
    var be = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] === n;
            });
        });
    };
    be.autoRemove = function(e) {
        return void 0 === e;
    };
    var Se = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] == n;
            });
        });
    };
    Se.autoRemove = function(e) {
        return null == e;
    };
    var Ce = function(e, t, n) {
        var o = n || [], r = o[0], i = o[1];
        if ((r = "number" == typeof r ? r : -1 / 0) > (i = "number" == typeof i ? i : 1 / 0)) {
            var u = r;
            r = i, i = u;
        }
        return e.filter(function(e) {
            return t.some(function(t) {
                var n = e.values[t];
                return n >= r && n <= i;
            });
        });
    };
    Ce.autoRemove = function(e) {
        return !e || "number" != typeof e[0] && "number" != typeof e[1];
    };
    var xe = Object.freeze({
        __proto__: null,
        text: ge,
        exactText: ve,
        exactTextCase: me,
        includes: he,
        includesAll: ye,
        includesSome: we,
        includesValue: Re,
        exact: be,
        equals: Se,
        between: Ce
    });
    l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";
    var Pe = function(e) {
        e.stateReducers.push(Be), e.useInstance.push(Ee);
    };
    function Be(e, t, n, o) {
        if (t.type === l.init) return r({
            filters: []
        }, e);
        if (t.type === l.resetFilters) return r({}, e, {
            filters: o.initialState.filters || []
        });
        if (t.type === l.setFilter) {
            var i = t.columnId, u = t.filterValue, s = o.allColumns, a = o.filterTypes, c = s.find(function(e) {
                return e.id === i;
            });
            if (!c) throw new Error("React-Table: Could not find a column with id: " + i);
            var d = k(c.filter, a || {}, xe), f = e.filters.find(function(e) {
                return e.id === i;
            }), p = m(u, f && f.value);
            return H(d.autoRemove, p, c) ? r({}, e, {
                filters: e.filters.filter(function(e) {
                    return e.id !== i;
                })
            }) : r({}, e, f ? {
                filters: e.filters.map(function(e) {
                    return e.id === i ? {
                        id: i,
                        value: p
                    } : e;
                })
            } : {
                filters: [].concat(e.filters, [
                    {
                        id: i,
                        value: p
                    }
                ])
            });
        }
        if (t.type === l.setAllFilters) {
            var g = t.filters, v = o.allColumns, h = o.filterTypes;
            return r({}, e, {
                filters: m(g, e.filters).filter(function(e) {
                    var t = v.find(function(t) {
                        return t.id === e.id;
                    });
                    return !H(k(t.filter, h || {}, xe).autoRemove, e.value, t);
                })
            });
        }
    }
    function Ee(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.manualFilters, c = e.defaultCanFilter, d = void 0 !== c && c, f = e.disableFilters, p = e.state.filters, g = e.dispatch, v = e.autoResetFilters, m = void 0 === v || v, y = t.useCallback(function(e, t) {
            g({
                type: l.setFilter,
                columnId: e,
                filterValue: t
            });
        }, [
            g
        ]), R = t.useCallback(function(e) {
            g({
                type: l.setAllFilters,
                filters: e
            });
        }, [
            g
        ]);
        u.forEach(function(e) {
            var t = e.id, n = e.accessor, o = e.defaultCanFilter, r = e.disableFilters;
            e.canFilter = n ? I(!0 !== r && void 0, !0 !== f && void 0, !0) : I(o, d, !1), e.setFilter = function(t) {
                return y(e.id, t);
            };
            var i = p.find(function(e) {
                return e.id === t;
            });
            e.filterValue = i && i.value;
        });
        var b = t.useMemo(function() {
            if (a || !p.length) return [
                o,
                r,
                i
            ];
            var e = [], t = {};
            return [
                function n(o, r) {
                    void 0 === r && (r = 0);
                    var i = o;
                    return (i = p.reduce(function(e, t) {
                        var n = t.id, o = t.value, i = u.find(function(e) {
                            return e.id === n;
                        });
                        if (!i) return e;
                        0 === r && (i.preFilteredRows = e);
                        var l = k(i.filter, s || {}, xe);
                        return l ? (i.filteredRows = l(e, [
                            n
                        ], o), i.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i.id + "."), e);
                    }, o)).forEach(function(o) {
                        e.push(o), t[o.id] = o, o.subRows && (o.subRows = o.subRows && o.subRows.length > 0 ? n(o.subRows, r + 1) : o.subRows);
                    }), i;
                }(o),
                e,
                t
            ];
        }, [
            a,
            p,
            o,
            r,
            i,
            u,
            s
        ]), S = b[0], C = b[1], x = b[2];
        t.useMemo(function() {
            u.filter(function(e) {
                return !p.find(function(t) {
                    return t.id === e.id;
                });
            }).forEach(function(e) {
                e.preFilteredRows = S, e.filteredRows = S;
            });
        }, [
            S,
            p,
            u
        ]);
        var P = h(m);
        w(function() {
            P() && g({
                type: l.resetFilters
            });
        }, [
            g,
            a ? null : n
        ]), Object.assign(e, {
            preFilteredRows: o,
            preFilteredFlatRows: r,
            preFilteredRowsById: i,
            filteredRows: S,
            filteredFlatRows: C,
            filteredRowsById: x,
            rows: S,
            flatRows: C,
            rowsById: x,
            setFilter: y,
            setAllFilters: R
        });
    }
    Pe.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";
    var Ie = function(e) {
        e.stateReducers.push(Fe), e.useInstance.push(Ge);
    };
    function Fe(e, t, n, o) {
        if (t.type === l.resetGlobalFilter) return r({}, e, {
            globalFilter: o.initialState.globalFilter || void 0
        });
        if (t.type === l.setGlobalFilter) {
            var u = t.filterValue, s = o.userFilterTypes, a = k(o.globalFilter, s || {}, xe), c = m(u, e.globalFilter);
            if (H(a.autoRemove, c)) {
                e.globalFilter;
                return i(e, [
                    "globalFilter"
                ]);
            }
            return r({}, e, {
                globalFilter: c
            });
        }
    }
    function Ge(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.globalFilter, c = e.manualGlobalFilter, d = e.state.globalFilter, f = e.dispatch, p = e.autoResetGlobalFilter, g = void 0 === p || p, v = e.disableGlobalFilter, m = t.useCallback(function(e) {
            f({
                type: l.setGlobalFilter,
                filterValue: e
            });
        }, [
            f
        ]), y = t.useMemo(function() {
            if (c || void 0 === d) return [
                o,
                r,
                i
            ];
            var e = [], t = {}, n = k(a, s || {}, xe);
            if (!n) return console.warn("Could not find a valid 'globalFilter' option."), o;
            u.forEach(function(e) {
                var t = e.disableGlobalFilter;
                e.canFilter = I(!0 !== t && void 0, !0 !== v && void 0, !0);
            });
            var l = u.filter(function(e) {
                return !0 === e.canFilter;
            });
            return [
                function o(r) {
                    return (r = n(r, l.map(function(e) {
                        return e.id;
                    }), d)).forEach(function(n) {
                        e.push(n), t[n.id] = n, n.subRows = n.subRows && n.subRows.length ? o(n.subRows) : n.subRows;
                    }), r;
                }(o),
                e,
                t
            ];
        }, [
            c,
            d,
            a,
            s,
            u,
            o,
            r,
            i,
            v
        ]), R = y[0], b = y[1], S = y[2], C = h(g);
        w(function() {
            C() && f({
                type: l.resetGlobalFilter
            });
        }, [
            f,
            c ? null : n
        ]), Object.assign(e, {
            preGlobalFilteredRows: o,
            preGlobalFilteredFlatRows: r,
            preGlobalFilteredRowsById: i,
            globalFilteredRows: R,
            globalFilteredFlatRows: b,
            globalFilteredRowsById: S,
            rows: R,
            flatRows: b,
            rowsById: S,
            setGlobalFilter: m,
            disableGlobalFilter: v
        });
    }
    function Ae(e, t) {
        return t.reduce(function(e, t) {
            return e + ("number" == typeof t ? t : 0);
        }, 0);
    }
    Ie.pluginName = "useGlobalFilter";
    var ke = Object.freeze({
        __proto__: null,
        sum: Ae,
        min: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e));
            }), t;
        },
        max: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.max(t, e));
            }), t;
        },
        minMax: function(e) {
            var t = e[0] || 0, n = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
            }), t + ".." + n;
        },
        average: function(e) {
            return Ae(0, e) / e.length;
        },
        median: function(e) {
            if (!e.length) return null;
            var t = Math.floor(e.length / 2), n = [].concat(e).sort(function(e, t) {
                return e - t;
            });
            return e.length % 2 != 0 ? n[t] : (n[t - 1] + n[t]) / 2;
        },
        unique: function(e) {
            return Array.from(new Set(e).values());
        },
        uniqueCount: function(e) {
            return new Set(e).size;
        },
        count: function(e) {
            return e.length;
        }
    }), He = [], Te = {};
    l.resetGroupBy = "resetGroupBy", l.setGroupBy = "setGroupBy", l.toggleGroupBy = "toggleGroupBy";
    var ze = function(e) {
        e.getGroupByToggleProps = [
            We
        ], e.stateReducers.push(Oe), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.groupBy
            ]);
        }), e.visibleColumns.push(Me), e.useInstance.push(Ne), e.prepareRow.push(Le);
    };
    ze.pluginName = "useGroupBy";
    var We = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canGroupBy ? function(e) {
                    e.persist(), n.toggleGroupBy();
                } : void 0,
                style: {
                    cursor: n.canGroupBy ? "pointer" : void 0
                },
                title: "Toggle GroupBy"
            }
        ];
    };
    function Oe(e, t, n, o) {
        if (t.type === l.init) return r({
            groupBy: []
        }, e);
        if (t.type === l.resetGroupBy) return r({}, e, {
            groupBy: o.initialState.groupBy || []
        });
        if (t.type === l.setGroupBy) return r({}, e, {
            groupBy: t.value
        });
        if (t.type === l.toggleGroupBy) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.groupBy.includes(i);
            return r({}, e, s ? {
                groupBy: [].concat(e.groupBy, [
                    i
                ])
            } : {
                groupBy: e.groupBy.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function Me(e, t) {
        var n = t.instance.state.groupBy, o = n.map(function(t) {
            return e.find(function(e) {
                return e.id === t;
            });
        }).filter(Boolean), r = e.filter(function(e) {
            return !n.includes(e.id);
        });
        return (e = [].concat(o, r)).forEach(function(e) {
            e.isGrouped = n.includes(e.id), e.groupedIndex = n.indexOf(e.id);
        }), e;
    }
    var je = {};
    function Ne(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.flatHeaders, a = e.groupByFn, c = void 0 === a ? De : a, d = e.manualGroupBy, p = e.aggregations, g = void 0 === p ? je : p, m = e.plugins, y = e.state.groupBy, R = e.dispatch, b = e.autoResetGroupBy, S = void 0 === b || b, C = e.disableGroupBy, x = e.defaultCanGroupBy, P = e.getHooks;
        v(m, [
            "useColumnOrder",
            "useFilters"
        ], "useGroupBy");
        var B = h(e);
        u.forEach(function(t) {
            var n = t.accessor, o = t.defaultGroupBy, r = t.disableGroupBy;
            t.canGroupBy = n ? I(t.canGroupBy, !0 !== r && void 0, !0 !== C && void 0, !0) : I(t.canGroupBy, o, x, !1), t.canGroupBy && (t.toggleGroupBy = function() {
                return e.toggleGroupBy(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        var E = t.useCallback(function(e, t) {
            R({
                type: l.toggleGroupBy,
                columnId: e,
                value: t
            });
        }, [
            R
        ]), F = t.useCallback(function(e) {
            R({
                type: l.setGroupBy,
                value: e
            });
        }, [
            R
        ]);
        s.forEach(function(e) {
            e.getGroupByToggleProps = f(P().getGroupByToggleProps, {
                instance: B(),
                header: e
            });
        });
        var A = t.useMemo(function() {
            if (d || !y.length) return [
                o,
                r,
                i,
                He,
                Te,
                r,
                i
            ];
            var e = y.filter(function(e) {
                return u.find(function(t) {
                    return t.id === e;
                });
            }), t = [], n = {}, l = [], s = {}, a = [], f = {}, p = function o(r, i, d) {
                if (void 0 === i && (i = 0), i === e.length) return r;
                var p = e[i], v = c(r, p);
                return Object.entries(v).map(function(r, c) {
                    var v = r[0], m = r[1], h = p + ":" + v, y = o(m, i + 1, h = d ? d + ">" + h : h), w = i ? G(m, "leafRows") : m, R = function(t, n, o) {
                        var r = {};
                        return u.forEach(function(i) {
                            if (e.includes(i.id)) r[i.id] = n[0] ? n[0].values[i.id] : null;
                            else {
                                var u = "function" == typeof i.aggregate ? i.aggregate : g[i.aggregate] || ke[i.aggregate];
                                if (u) {
                                    var l = n.map(function(e) {
                                        return e.values[i.id];
                                    }), s = t.map(function(e) {
                                        var t = e.values[i.id];
                                        if (!o && i.aggregateValue) {
                                            var n = "function" == typeof i.aggregateValue ? i.aggregateValue : g[i.aggregateValue] || ke[i.aggregateValue];
                                            if (!n) throw console.info({
                                                column: i
                                            }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                                            t = n(t, e, i);
                                        }
                                        return t;
                                    });
                                    r[i.id] = u(s, l);
                                } else {
                                    if (i.aggregate) throw console.info({
                                        column: i
                                    }), new Error("React Table: Invalid column.aggregate option for column listed above");
                                    r[i.id] = null;
                                }
                            }
                        }), r;
                    }(w, m, i), b = {
                        id: h,
                        isGrouped: !0,
                        groupByID: p,
                        groupByVal: v,
                        values: R,
                        subRows: y,
                        leafRows: w,
                        depth: i,
                        index: c
                    };
                    return y.forEach(function(e) {
                        t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), s[e.id] = e) : (a.push(e), f[e.id] = e);
                    }), b;
                });
            }(o);
            return p.forEach(function(e) {
                t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), s[e.id] = e) : (a.push(e), f[e.id] = e);
            }), [
                p,
                t,
                n,
                l,
                s,
                a,
                f
            ];
        }, [
            d,
            y,
            o,
            r,
            i,
            u,
            g,
            c
        ]), k = A[0], H = A[1], T = A[2], z = A[3], W = A[4], O = A[5], M = A[6], j = h(S);
        w(function() {
            j() && R({
                type: l.resetGroupBy
            });
        }, [
            R,
            d ? null : n
        ]), Object.assign(e, {
            preGroupedRows: o,
            preGroupedFlatRow: r,
            preGroupedRowsById: i,
            groupedRows: k,
            groupedFlatRows: H,
            groupedRowsById: T,
            onlyGroupedFlatRows: z,
            onlyGroupedRowsById: W,
            nonGroupedFlatRows: O,
            nonGroupedRowsById: M,
            rows: k,
            flatRows: H,
            rowsById: T,
            toggleGroupBy: E,
            setGroupBy: F
        });
    }
    function Le(e) {
        e.allCells.forEach(function(t) {
            var n;
            t.isGrouped = t.column.isGrouped && t.column.id === e.groupByID, t.isPlaceholder = !t.isGrouped && t.column.isGrouped, t.isAggregated = !t.isGrouped && !t.isPlaceholder && (null == (n = e.subRows) ? void 0 : n.length);
        });
    }
    function De(e, t) {
        return e.reduce(function(e, n, o) {
            var r = "" + n.values[t];
            return e[r] = Array.isArray(e[r]) ? e[r] : [], e[r].push(n), e;
        }, {});
    }
    var Ve = /([0-9]+)/gm;
    function _e(e, t) {
        return e === t ? 0 : e > t ? 1 : -1;
    }
    function Xe(e, t, n) {
        return [
            e.values[n],
            t.values[n]
        ];
    }
    function qe(e) {
        return "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : "string" == typeof e ? e : "";
    }
    var Ke = Object.freeze({
        __proto__: null,
        alphanumeric: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            for(r = qe(r), i = qe(i), r = r.split(Ve).filter(Boolean), i = i.split(Ve).filter(Boolean); r.length && i.length;){
                var u = r.shift(), l = i.shift(), s = parseInt(u, 10), a = parseInt(l, 10), c = [
                    s,
                    a
                ].sort();
                if (isNaN(c[0])) {
                    if (u > l) return 1;
                    if (l > u) return -1;
                } else {
                    if (isNaN(c[1])) return isNaN(s) ? -1 : 1;
                    if (s > a) return 1;
                    if (a > s) return -1;
                }
            }
            return r.length - i.length;
        },
        datetime: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            return _e(r = r.getTime(), i = i.getTime());
        },
        basic: function(e, t, n) {
            var o = Xe(e, t, n);
            return _e(o[0], o[1]);
        },
        string: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            for(r = r.split("").filter(Boolean), i = i.split("").filter(Boolean); r.length && i.length;){
                var u = r.shift(), l = i.shift(), s = u.toLowerCase(), a = l.toLowerCase();
                if (s > a) return 1;
                if (a > s) return -1;
                if (u > l) return 1;
                if (l > u) return -1;
            }
            return r.length - i.length;
        },
        number: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1], u = /[^0-9.]/gi;
            return _e(r = Number(String(r).replace(u, "")), i = Number(String(i).replace(u, "")));
        }
    });
    l.resetSortBy = "resetSortBy", l.setSortBy = "setSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", c.sortType = "alphanumeric", c.sortDescFirst = !1;
    var Ue = function(e) {
        e.getSortByToggleProps = [
            $e
        ], e.stateReducers.push(Je), e.useInstance.push(Ye);
    };
    Ue.pluginName = "useSortBy";
    var $e = function(e, t) {
        var n = t.instance, o = t.column, r = n.isMultiSortEvent, i = void 0 === r ? function(e) {
            return e.shiftKey;
        } : r;
        return [
            e,
            {
                onClick: o.canSort ? function(e) {
                    e.persist(), o.toggleSortBy(void 0, !n.disableMultiSort && i(e));
                } : void 0,
                style: {
                    cursor: o.canSort ? "pointer" : void 0
                },
                title: o.canSort ? "Toggle SortBy" : void 0
            }
        ];
    };
    function Je(e, t, n, o) {
        if (t.type === l.init) return r({
            sortBy: []
        }, e);
        if (t.type === l.resetSortBy) return r({}, e, {
            sortBy: o.initialState.sortBy || []
        });
        if (t.type === l.clearSortBy) return r({}, e, {
            sortBy: e.sortBy.filter(function(e) {
                return e.id !== t.columnId;
            })
        });
        if (t.type === l.setSortBy) return r({}, e, {
            sortBy: t.sortBy
        });
        if (t.type === l.toggleSortBy) {
            var i, u = t.columnId, s = t.desc, a = t.multi, c = o.allColumns, d = o.disableMultiSort, f = o.disableSortRemove, p = o.disableMultiRemove, g = o.maxMultiSortColCount, v = void 0 === g ? Number.MAX_SAFE_INTEGER : g, m = e.sortBy, h = c.find(function(e) {
                return e.id === u;
            }).sortDescFirst, y = m.find(function(e) {
                return e.id === u;
            }), w = m.findIndex(function(e) {
                return e.id === u;
            }), R = null != s, b = [];
            return "toggle" !== (i = !d && a ? y ? "toggle" : "add" : w !== m.length - 1 || 1 !== m.length ? "replace" : y ? "toggle" : "replace") || f || R || a && p || !(y && y.desc && !h || !y.desc && h) || (i = "remove"), "replace" === i ? b = [
                {
                    id: u,
                    desc: R ? s : h
                }
            ] : "add" === i ? (b = [].concat(m, [
                {
                    id: u,
                    desc: R ? s : h
                }
            ])).splice(0, b.length - v) : "toggle" === i ? b = m.map(function(e) {
                return e.id === u ? r({}, e, {
                    desc: R ? s : !y.desc
                }) : e;
            }) : "remove" === i && (b = m.filter(function(e) {
                return e.id !== u;
            })), r({}, e, {
                sortBy: b
            });
        }
    }
    function Ye(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.allColumns, u = e.orderByFn, s = void 0 === u ? Qe : u, a = e.sortTypes, c = e.manualSortBy, d = e.defaultCanSort, p = e.disableSortBy, g = e.flatHeaders, m = e.state.sortBy, y = e.dispatch, R = e.plugins, b = e.getHooks, S = e.autoResetSortBy, C = void 0 === S || S;
        v(R, [
            "useFilters",
            "useGlobalFilter",
            "useGroupBy",
            "usePivotColumns"
        ], "useSortBy");
        var x = t.useCallback(function(e) {
            y({
                type: l.setSortBy,
                sortBy: e
            });
        }, [
            y
        ]), P = t.useCallback(function(e, t, n) {
            y({
                type: l.toggleSortBy,
                columnId: e,
                desc: t,
                multi: n
            });
        }, [
            y
        ]), B = h(e);
        g.forEach(function(e) {
            var t = e.accessor, n = e.canSort, o = e.disableSortBy, r = e.id, i = t ? I(!0 !== o && void 0, !0 !== p && void 0, !0) : I(d, n, !1);
            e.canSort = i, e.canSort && (e.toggleSortBy = function(t, n) {
                return P(e.id, t, n);
            }, e.clearSortBy = function() {
                y({
                    type: l.clearSortBy,
                    columnId: e.id
                });
            }), e.getSortByToggleProps = f(b().getSortByToggleProps, {
                instance: B(),
                column: e
            });
            var u = m.find(function(e) {
                return e.id === r;
            });
            e.isSorted = !!u, e.sortedIndex = m.findIndex(function(e) {
                return e.id === r;
            }), e.isSortedDesc = e.isSorted ? u.desc : void 0;
        });
        var E = t.useMemo(function() {
            if (c || !m.length) return [
                o,
                r
            ];
            var e = [], t = m.filter(function(e) {
                return i.find(function(t) {
                    return t.id === e.id;
                });
            });
            return [
                function n(o) {
                    var r = s(o, t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        if (!t) throw new Error("React-Table: Could not find a column with id: " + e.id + " while sorting");
                        var n = t.sortType, o = F(n) || (a || {})[n] || Ke[n];
                        if (!o) throw new Error("React-Table: Could not find a valid sortType of '" + n + "' for column '" + e.id + "'.");
                        return function(t, n) {
                            return o(t, n, e.id, e.desc);
                        };
                    }), t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        return t && t.sortInverted ? e.desc : !e.desc;
                    }));
                    return r.forEach(function(t) {
                        e.push(t), t.subRows && 0 !== t.subRows.length && (t.subRows = n(t.subRows));
                    }), r;
                }(o),
                e
            ];
        }, [
            c,
            m,
            o,
            r,
            i,
            s,
            a
        ]), G = E[0], A = E[1], k = h(C);
        w(function() {
            k() && y({
                type: l.resetSortBy
            });
        }, [
            c ? null : n
        ]), Object.assign(e, {
            preSortedRows: o,
            preSortedFlatRows: r,
            sortedRows: G,
            sortedFlatRows: A,
            rows: G,
            flatRows: A,
            setSortBy: x,
            toggleSortBy: P
        });
    }
    function Qe(e, t, n) {
        return [].concat(e).sort(function(e, o) {
            for(var r = 0; r < t.length; r += 1){
                var i = t[r], u = !1 === n[r] || "desc" === n[r], l = i(e, o);
                if (0 !== l) return u ? -l : l;
            }
            return n[0] ? e.index - o.index : o.index - e.index;
        });
    }
    l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";
    var Ze = function(e) {
        e.stateReducers.push(et), e.useInstance.push(tt);
    };
    function et(e, t, n, o) {
        if (t.type === l.init) return r({
            pageSize: 10,
            pageIndex: 0
        }, e);
        if (t.type === l.resetPage) return r({}, e, {
            pageIndex: o.initialState.pageIndex || 0
        });
        if (t.type === l.gotoPage) {
            var i = o.pageCount, u = o.page, s = m(t.pageIndex, e.pageIndex), a = !1;
            return s > e.pageIndex ? a = -1 === i ? u.length >= e.pageSize : s < i : s < e.pageIndex && (a = s > -1), a ? r({}, e, {
                pageIndex: s
            }) : e;
        }
        if (t.type === l.setPageSize) {
            var c = t.pageSize, d = e.pageSize * e.pageIndex;
            return r({}, e, {
                pageIndex: Math.floor(d / c),
                pageSize: c
            });
        }
    }
    function tt(e) {
        var n = e.rows, o = e.autoResetPage, r = void 0 === o || o, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.plugins, a = e.pageCount, c = e.paginateExpandedRows, d = void 0 === c || c, f = e.expandSubRows, p = void 0 === f || f, g = e.state, m = g.pageSize, y = g.pageIndex, R = g.expanded, b = g.globalFilter, S = g.filters, C = g.groupBy, x = g.sortBy, P = e.dispatch, B = e.data, E = e.manualPagination;
        v(s, [
            "useGlobalFilter",
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded"
        ], "usePagination");
        var I = h(r);
        w(function() {
            I() && P({
                type: l.resetPage
            });
        }, [
            P,
            E ? null : B,
            b,
            S,
            C,
            x
        ]);
        var F = E ? a : Math.ceil(n.length / m), G = t.useMemo(function() {
            return F > 0 ? [].concat(new Array(F)).fill(null).map(function(e, t) {
                return t;
            }) : [];
        }, [
            F
        ]), k = t.useMemo(function() {
            var e;
            if (E) e = n;
            else {
                var t = m * y, o = t + m;
                e = n.slice(t, o);
            }
            return d ? e : A(e, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: p
            });
        }, [
            p,
            R,
            u,
            E,
            y,
            m,
            d,
            n
        ]), H = y > 0, T = -1 === F ? k.length >= m : y < F - 1, z = t.useCallback(function(e) {
            P({
                type: l.gotoPage,
                pageIndex: e
            });
        }, [
            P
        ]), W = t.useCallback(function() {
            return z(function(e) {
                return e - 1;
            });
        }, [
            z
        ]), O = t.useCallback(function() {
            return z(function(e) {
                return e + 1;
            });
        }, [
            z
        ]), M = t.useCallback(function(e) {
            P({
                type: l.setPageSize,
                pageSize: e
            });
        }, [
            P
        ]);
        Object.assign(e, {
            pageOptions: G,
            pageCount: F,
            page: k,
            canPreviousPage: H,
            canNextPage: T,
            gotoPage: z,
            previousPage: W,
            nextPage: O,
            setPageSize: M
        });
    }
    Ze.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";
    var nt = function(e) {
        e.getPivotToggleProps = [
            rt
        ], e.stateReducers.push(it), e.useInstanceAfterData.push(ut), e.allColumns.push(lt), e.accessValue.push(st), e.materializedColumns.push(at), e.materializedColumnsDeps.push(ct), e.visibleColumns.push(dt), e.visibleColumnsDeps.push(ft), e.useInstance.push(pt), e.prepareRow.push(gt);
    };
    nt.pluginName = "usePivotColumns";
    var ot = [], rt = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canPivot ? function(e) {
                    e.persist(), n.togglePivot();
                } : void 0,
                style: {
                    cursor: n.canPivot ? "pointer" : void 0
                },
                title: "Toggle Pivot"
            }
        ];
    };
    function it(e, t, n, o) {
        if (t.type === l.init) return r({
            pivotColumns: ot
        }, e);
        if (t.type === l.resetPivot) return r({}, e, {
            pivotColumns: o.initialState.pivotColumns || ot
        });
        if (t.type === l.togglePivot) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.pivotColumns.includes(i);
            return r({}, e, s ? {
                pivotColumns: [].concat(e.pivotColumns, [
                    i
                ])
            } : {
                pivotColumns: e.pivotColumns.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function ut(e) {
        e.allColumns.forEach(function(t) {
            t.isPivotSource = e.state.pivotColumns.includes(t.id);
        });
    }
    function lt(e, t) {
        var n = t.instance;
        return e.forEach(function(e) {
            e.isPivotSource = n.state.pivotColumns.includes(e.id), e.uniqueValues = new Set;
        }), e;
    }
    function st(e, t) {
        var n = t.column;
        return n.uniqueValues && void 0 !== e && n.uniqueValues.add(e), e;
    }
    function at(e, t) {
        var n = t.instance, o = n.allColumns, i = n.state;
        if (!i.pivotColumns.length || !i.groupBy || !i.groupBy.length) return e;
        var u = i.pivotColumns.map(function(e) {
            return o.find(function(t) {
                return t.id === e;
            });
        }).filter(Boolean), l = o.filter(function(e) {
            return !e.isPivotSource && !i.groupBy.includes(e.id) && !i.pivotColumns.includes(e.id);
        }), s = C(function e(t, n, o) {
            void 0 === t && (t = 0), void 0 === o && (o = []);
            var i = u[t];
            return i ? Array.from(i.uniqueValues).sort().map(function(u) {
                var l = r({}, i, {
                    Header: i.PivotHeader || "string" == typeof i.header ? i.Header + ": " + u : u,
                    isPivotGroup: !0,
                    parent: n,
                    depth: t,
                    id: n ? n.id + "." + i.id + "." + u : i.id + "." + u,
                    pivotValue: u
                });
                return l.columns = e(t + 1, l, [].concat(o, [
                    function(e) {
                        return e.values[i.id] === u;
                    }
                ])), l;
            }) : l.map(function(e) {
                return r({}, e, {
                    canPivot: !1,
                    isPivoted: !0,
                    parent: n,
                    depth: t,
                    id: "" + (n ? n.id + "." + e.id : e.id),
                    accessor: function(t, n, r) {
                        if (o.every(function(e) {
                            return e(r);
                        })) return r.values[e.id];
                    }
                });
            });
        }());
        return [].concat(e, s);
    }
    function ct(e, t) {
        var n = t.instance.state, o = n.pivotColumns, r = n.groupBy;
        return [].concat(e, [
            o,
            r
        ]);
    }
    function dt(e, t) {
        var n = t.instance.state;
        return e = e.filter(function(e) {
            return !e.isPivotSource;
        }), n.pivotColumns.length && n.groupBy && n.groupBy.length && (e = e.filter(function(e) {
            return e.isGrouped || e.isPivoted;
        })), e;
    }
    function ft(e, t) {
        var n = t.instance;
        return [].concat(e, [
            n.state.pivotColumns,
            n.state.groupBy
        ]);
    }
    function pt(e) {
        var t = e.columns, n = e.allColumns, o = e.flatHeaders, r = e.getHooks, i = e.plugins, u = e.dispatch, s = e.autoResetPivot, a = void 0 === s || s, c = e.manaulPivot, d = e.disablePivot, p = e.defaultCanPivot;
        v(i, [
            "useGroupBy"
        ], "usePivotColumns");
        var g = h(e);
        n.forEach(function(t) {
            var n = t.accessor, o = t.defaultPivot, r = t.disablePivot;
            t.canPivot = n ? I(t.canPivot, !0 !== r && void 0, !0 !== d && void 0, !0) : I(t.canPivot, o, p, !1), t.canPivot && (t.togglePivot = function() {
                return e.togglePivot(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        o.forEach(function(e) {
            e.getPivotToggleProps = f(r().getPivotToggleProps, {
                instance: g(),
                header: e
            });
        });
        var m = h(a);
        w(function() {
            m() && u({
                type: l.resetPivot
            });
        }, [
            u,
            c ? null : t
        ]), Object.assign(e, {
            togglePivot: function(e, t) {
                u({
                    type: l.togglePivot,
                    columnId: e,
                    value: t
                });
            }
        });
    }
    function gt(e) {
        e.allCells.forEach(function(e) {
            e.isPivoted = e.column.isPivoted;
        });
    }
    l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected", l.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
    var vt = function(e) {
        e.getToggleRowSelectedProps = [
            mt
        ], e.getToggleAllRowsSelectedProps = [
            ht
        ], e.getToggleAllPageRowsSelectedProps = [
            yt
        ], e.stateReducers.push(wt), e.useInstance.push(Rt), e.prepareRow.push(bt);
    };
    vt.pluginName = "useRowSelect";
    var mt = function(e, t) {
        var n = t.instance, o = t.row, r = n.manualRowSelectedKey, i = void 0 === r ? "isSelected" : r;
        return [
            e,
            {
                onChange: function(e) {
                    o.toggleRowSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !(!o.original || !o.original[i]) || o.isSelected,
                title: "Toggle Row Selected",
                indeterminate: o.isSomeSelected
            }
        ];
    }, ht = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllRowsSelected,
                title: "Toggle All Rows Selected",
                indeterminate: Boolean(!n.isAllRowsSelected && Object.keys(n.state.selectedRowIds).length)
            }
        ];
    }, yt = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllPageRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllPageRowsSelected,
                title: "Toggle All Current Page Rows Selected",
                indeterminate: Boolean(!n.isAllPageRowsSelected && n.page.some(function(e) {
                    var t = e.id;
                    return n.state.selectedRowIds[t];
                }))
            }
        ];
    };
    function wt(e, t, n, o) {
        if (t.type === l.init) return r({
            selectedRowIds: {}
        }, e);
        if (t.type === l.resetSelectedRows) return r({}, e, {
            selectedRowIds: o.initialState.selectedRowIds || {}
        });
        if (t.type === l.toggleAllRowsSelected) {
            var i = t.value, u = o.isAllRowsSelected, s = o.rowsById, a = o.nonGroupedRowsById, c = void 0 === a ? s : a, d = void 0 !== i ? i : !u, f = Object.assign({}, e.selectedRowIds);
            return d ? Object.keys(c).forEach(function(e) {
                f[e] = !0;
            }) : Object.keys(c).forEach(function(e) {
                delete f[e];
            }), r({}, e, {
                selectedRowIds: f
            });
        }
        if (t.type === l.toggleRowSelected) {
            var p = t.id, g = t.value, v = o.rowsById, m = o.selectSubRows, h = void 0 === m || m, y = o.getSubRows, w = e.selectedRowIds[p], R = void 0 !== g ? g : !w;
            if (w === R) return e;
            var b = r({}, e.selectedRowIds);
            return function e(t) {
                var n = v[t];
                if (n.isGrouped || (R ? b[t] = !0 : delete b[t]), h && y(n)) return y(n).forEach(function(t) {
                    return e(t.id);
                });
            }(p), r({}, e, {
                selectedRowIds: b
            });
        }
        if (t.type === l.toggleAllPageRowsSelected) {
            var S = t.value, C = o.page, x = o.rowsById, P = o.selectSubRows, B = void 0 === P || P, E = o.isAllPageRowsSelected, I = o.getSubRows, F = void 0 !== S ? S : !E, G = r({}, e.selectedRowIds);
            return C.forEach(function(e) {
                return function e(t) {
                    var n = x[t];
                    if (n.isGrouped || (F ? G[t] = !0 : delete G[t]), B && I(n)) return I(n).forEach(function(t) {
                        return e(t.id);
                    });
                }(e.id);
            }), r({}, e, {
                selectedRowIds: G
            });
        }
        return e;
    }
    function Rt(e) {
        var n = e.data, o = e.rows, r = e.getHooks, i = e.plugins, u = e.rowsById, s = e.nonGroupedRowsById, a = void 0 === s ? u : s, c = e.autoResetSelectedRows, d = void 0 === c || c, p = e.state.selectedRowIds, g = e.selectSubRows, m = void 0 === g || g, y = e.dispatch, R = e.page, b = e.getSubRows;
        v(i, [
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded",
            "usePagination"
        ], "useRowSelect");
        var S = t.useMemo(function() {
            var e = [];
            return o.forEach(function(t) {
                var n = m ? function e(t, n, o) {
                    if (n[t.id]) return !0;
                    var r = o(t);
                    if (r && r.length) {
                        var i = !0, u = !1;
                        return r.forEach(function(t) {
                            u && !i || (e(t, n, o) ? u = !0 : i = !1);
                        }), !!i || !!u && null;
                    }
                    return !1;
                }(t, p, b) : !!p[t.id];
                t.isSelected = !!n, t.isSomeSelected = null === n, n && e.push(t);
            }), e;
        }, [
            o,
            m,
            p,
            b
        ]), C = Boolean(Object.keys(a).length && Object.keys(p).length), x = C;
        C && Object.keys(a).some(function(e) {
            return !p[e];
        }) && (C = !1), C || R && R.length && R.some(function(e) {
            var t = e.id;
            return !p[t];
        }) && (x = !1);
        var P = h(d);
        w(function() {
            P() && y({
                type: l.resetSelectedRows
            });
        }, [
            y,
            n
        ]);
        var B = t.useCallback(function(e) {
            return y({
                type: l.toggleAllRowsSelected,
                value: e
            });
        }, [
            y
        ]), E = t.useCallback(function(e) {
            return y({
                type: l.toggleAllPageRowsSelected,
                value: e
            });
        }, [
            y
        ]), I = t.useCallback(function(e, t) {
            return y({
                type: l.toggleRowSelected,
                id: e,
                value: t
            });
        }, [
            y
        ]), F = h(e), G = f(r().getToggleAllRowsSelectedProps, {
            instance: F()
        }), A = f(r().getToggleAllPageRowsSelectedProps, {
            instance: F()
        });
        Object.assign(e, {
            selectedFlatRows: S,
            isAllRowsSelected: C,
            isAllPageRowsSelected: x,
            toggleRowSelected: I,
            toggleAllRowsSelected: B,
            getToggleAllRowsSelectedProps: G,
            getToggleAllPageRowsSelectedProps: A,
            toggleAllPageRowsSelected: E
        });
    }
    function bt(e, t) {
        var n = t.instance;
        e.toggleRowSelected = function(t) {
            return n.toggleRowSelected(e.id, t);
        }, e.getToggleRowSelectedProps = f(n.getHooks().getToggleRowSelectedProps, {
            instance: n,
            row: e
        });
    }
    var St = function(e) {
        return {};
    }, Ct = function(e) {
        return {};
    };
    l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";
    var xt = function(e) {
        e.stateReducers.push(Pt), e.useInstance.push(Bt), e.prepareRow.push(Et);
    };
    function Pt(e, t, n, o) {
        var i = o.initialRowStateAccessor, u = void 0 === i ? St : i, s = o.initialCellStateAccessor, a = void 0 === s ? Ct : s, c = o.rowsById;
        if (t.type === l.init) return r({
            rowState: {}
        }, e);
        if (t.type === l.resetRowState) return r({}, e, {
            rowState: o.initialState.rowState || {}
        });
        if (t.type === l.setRowState) {
            var d, f = t.rowId, p = t.value, g = void 0 !== e.rowState[f] ? e.rowState[f] : u(c[f]);
            return r({}, e, {
                rowState: r({}, e.rowState, (d = {}, d[f] = m(p, g), d))
            });
        }
        if (t.type === l.setCellState) {
            var v, h, y, w, R, b = t.rowId, S = t.columnId, C = t.value, x = void 0 !== e.rowState[b] ? e.rowState[b] : u(c[b]), P = void 0 !== (null == x ? void 0 : null == (v = x.cellState) ? void 0 : v[S]) ? x.cellState[S] : a(null == (h = c[b]) ? void 0 : null == (y = h.cells) ? void 0 : y.find(function(e) {
                return e.column.id === S;
            }));
            return r({}, e, {
                rowState: r({}, e.rowState, (R = {}, R[b] = r({}, x, {
                    cellState: r({}, x.cellState || {}, (w = {}, w[S] = m(C, P), w))
                }), R))
            });
        }
    }
    function Bt(e) {
        var n = e.autoResetRowState, o = void 0 === n || n, r = e.data, i = e.dispatch, u = t.useCallback(function(e, t) {
            return i({
                type: l.setRowState,
                rowId: e,
                value: t
            });
        }, [
            i
        ]), s = t.useCallback(function(e, t, n) {
            return i({
                type: l.setCellState,
                rowId: e,
                columnId: t,
                value: n
            });
        }, [
            i
        ]), a = h(o);
        w(function() {
            a() && i({
                type: l.resetRowState
            });
        }, [
            r
        ]), Object.assign(e, {
            setRowState: u,
            setCellState: s
        });
    }
    function Et(e, t) {
        var n = t.instance, o = n.initialRowStateAccessor, r = void 0 === o ? St : o, i = n.initialCellStateAccessor, u = void 0 === i ? Ct : i, l = n.state.rowState;
        e && (e.state = void 0 !== l[e.id] ? l[e.id] : r(e), e.setState = function(t) {
            return n.setRowState(e.id, t);
        }, e.cells.forEach(function(t) {
            e.state.cellState || (e.state.cellState = {}), t.state = void 0 !== e.state.cellState[t.column.id] ? e.state.cellState[t.column.id] : u(t), t.setState = function(o) {
                return n.setCellState(e.id, t.column.id, o);
            };
        }));
    }
    xt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";
    var It = function(e) {
        e.stateReducers.push(Ft), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.columnOrder
            ]);
        }), e.visibleColumns.push(Gt), e.useInstance.push(At);
    };
    function Ft(e, t, n, o) {
        return t.type === l.init ? r({
            columnOrder: []
        }, e) : t.type === l.resetColumnOrder ? r({}, e, {
            columnOrder: o.initialState.columnOrder || []
        }) : t.type === l.setColumnOrder ? r({}, e, {
            columnOrder: m(t.columnOrder, e.columnOrder)
        }) : void 0;
    }
    function Gt(e, t) {
        var n = t.instance.state.columnOrder;
        if (!n || !n.length) return e;
        for(var o = [].concat(n), r = [].concat(e), i = [], u = function() {
            var e = o.shift(), t = r.findIndex(function(t) {
                return t.id === e;
            });
            t > -1 && i.push(r.splice(t, 1)[0]);
        }; r.length && o.length;)u();
        return [].concat(i, r);
    }
    function At(e) {
        var n = e.dispatch;
        e.setColumnOrder = t.useCallback(function(e) {
            return n({
                type: l.setColumnOrder,
                columnOrder: e
            });
        }, [
            n
        ]);
    }
    It.pluginName = "useColumnOrder", c.canResize = !0, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize";
    var kt = function(e) {
        e.getResizerProps = [
            Ht
        ], e.getHeaderProps.push({
            style: {
                position: "relative"
            }
        }), e.stateReducers.push(Tt), e.useInstance.push(Wt), e.useInstanceBeforeDimensions.push(zt);
    }, Ht = function(e, t) {
        var n = t.instance, o = t.header, r = n.dispatch, i = function(e, t) {
            var n = !1;
            if ("touchstart" === e.type) {
                if (e.touches && e.touches.length > 1) return;
                n = !0;
            }
            var o = (function(e) {
                var t = [];
                return function e(n) {
                    n.columns && n.columns.length && n.columns.map(e);
                    t.push(n);
                }(e), t;
            })(t).map(function(e) {
                return [
                    e.id,
                    e.totalWidth
                ];
            }), i = n ? Math.round(e.touches[0].clientX) : e.clientX, u = function(e) {
                r({
                    type: l.columnResizing,
                    clientX: e
                });
            }, s = function() {
                return r({
                    type: l.columnDoneResizing
                });
            }, a = {
                mouse: {
                    moveEvent: "mousemove",
                    moveHandler: function(e) {
                        return u(e.clientX);
                    },
                    upEvent: "mouseup",
                    upHandler: function(e) {
                        document.removeEventListener("mousemove", a.mouse.moveHandler), document.removeEventListener("mouseup", a.mouse.upHandler), s();
                    }
                },
                touch: {
                    moveEvent: "touchmove",
                    moveHandler: function(e) {
                        return e.cancelable && (e.preventDefault(), e.stopPropagation()), u(e.touches[0].clientX), !1;
                    },
                    upEvent: "touchend",
                    upHandler: function(e) {
                        document.removeEventListener(a.touch.moveEvent, a.touch.moveHandler), document.removeEventListener(a.touch.upEvent, a.touch.moveHandler), s();
                    }
                }
            }, c = n ? a.touch : a.mouse, d = !!function() {
                if ("boolean" == typeof z) return z;
                var e = !1;
                try {
                    var t = {
                        get passive () {
                            return e = !0, !1;
                        }
                    };
                    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
                } catch (t) {
                    e = !1;
                }
                return z = e;
            }() && {
                passive: !1
            };
            document.addEventListener(c.moveEvent, c.moveHandler, d), document.addEventListener(c.upEvent, c.upHandler, d), r({
                type: l.columnStartResizing,
                columnId: t.id,
                columnWidth: t.totalWidth,
                headerIdWidths: o,
                clientX: i
            });
        };
        return [
            e,
            {
                onMouseDown: function(e) {
                    return e.persist() || i(e, o);
                },
                onTouchStart: function(e) {
                    return e.persist() || i(e, o);
                },
                style: {
                    cursor: "col-resize"
                },
                draggable: !1,
                role: "separator"
            }
        ];
    };
    function Tt(e, t) {
        if (t.type === l.init) return r({
            columnResizing: {
                columnWidths: {}
            }
        }, e);
        if (t.type === l.resetResize) return r({}, e, {
            columnResizing: {
                columnWidths: {}
            }
        });
        if (t.type === l.columnStartResizing) {
            var n = t.clientX, o = t.columnId, i = t.columnWidth, u = t.headerIdWidths;
            return r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    startX: n,
                    headerIdWidths: u,
                    columnWidth: i,
                    isResizingColumn: o
                })
            });
        }
        if (t.type === l.columnResizing) {
            var s = t.clientX, a = e.columnResizing, c = a.startX, d = a.columnWidth, f = a.headerIdWidths, p = (s - c) / d, g = {};
            return (void 0 === f ? [] : f).forEach(function(e) {
                var t = e[0], n = e[1];
                g[t] = Math.max(n + n * p, 0);
            }), r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    columnWidths: r({}, e.columnResizing.columnWidths, {}, g)
                })
            });
        }
        return t.type === l.columnDoneResizing ? r({}, e, {
            columnResizing: r({}, e.columnResizing, {
                startX: null,
                isResizingColumn: null
            })
        }) : void 0;
    }
    kt.pluginName = "useResizeColumns";
    var zt = function(e) {
        var t = e.flatHeaders, n = e.disableResizing, o = e.getHooks, r = e.state.columnResizing, i = h(e);
        t.forEach(function(e) {
            var t = I(!0 !== e.disableResizing && void 0, !0 !== n && void 0, !0);
            e.canResize = t, e.width = r.columnWidths[e.id] || e.originalWidth || e.width, e.isResizing = r.isResizingColumn === e.id, t && (e.getResizerProps = f(o().getResizerProps, {
                instance: i(),
                header: e
            }));
        });
    };
    function Wt(e) {
        var n = e.plugins, o = e.dispatch, r = e.autoResetResize, i = void 0 === r || r, u = e.columns;
        v(n, [
            "useAbsoluteLayout"
        ], "useResizeColumns");
        var s = h(i);
        w(function() {
            s() && o({
                type: l.resetResize
            });
        }, [
            u
        ]);
        var a = t.useCallback(function() {
            return o({
                type: l.resetResize
            });
        }, [
            o
        ]);
        Object.assign(e, {
            resetResizing: a
        });
    }
    var Ot = {
        position: "absolute",
        top: 0
    }, Mt = function(e) {
        e.getTableBodyProps.push(jt), e.getRowProps.push(jt), e.getHeaderGroupProps.push(jt), e.getFooterGroupProps.push(jt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.column.totalLeft + "px",
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    Mt.pluginName = "useAbsoluteLayout";
    var jt = function(e, t) {
        return [
            e,
            {
                style: {
                    position: "relative",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Nt = {
        display: "inline-block",
        boxSizing: "border-box"
    }, Lt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Dt = function(e) {
        e.getRowProps.push(Lt), e.getHeaderGroupProps.push(Lt), e.getFooterGroupProps.push(Lt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Nt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Nt, {
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Nt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    function Vt(e) {
        e.getTableProps.push(_t), e.getRowProps.push(Xt), e.getHeaderGroupProps.push(Xt), e.getFooterGroupProps.push(Xt), e.getHeaderProps.push(qt), e.getCellProps.push(Kt), e.getFooterProps.push(Ut);
    }
    Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
    var _t = function(e, t) {
        return [
            e,
            {
                style: {
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, Xt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    flex: "1 0 auto",
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, qt = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    }, Kt = function(e, t) {
        var n = t.cell;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.column.totalFlexWidth + " 0 auto",
                    minWidth: n.column.totalMinWidth + "px",
                    width: n.column.totalWidth + "px"
                }
            }
        ];
    }, Ut = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    };
    function $t(e) {
        e.stateReducers.push(Qt), e.getTableProps.push(Jt), e.getHeaderProps.push(Yt);
    }
    $t.pluginName = "useGridLayout";
    var Jt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "grid",
                    gridTemplateColumns: t.instance.state.gridLayout.columnWidths.map(function(e) {
                        return e;
                    }).join(" ")
                }
            }
        ];
    }, Yt = function(e, t) {
        return [
            e,
            {
                id: "header-cell-" + t.column.id,
                style: {
                    position: "sticky"
                }
            }
        ];
    };
    function Qt(e, t, n, o) {
        if ("init" === t.type) return r({
            gridLayout: {
                columnWidths: o.columns.map(function() {
                    return "auto";
                })
            }
        }, e);
        if ("columnStartResizing" === t.type) {
            var i = t.columnId, u = o.visibleColumns.findIndex(function(e) {
                return e.id === i;
            }), l = function(e) {
                var t, n = null == (t = document.getElementById("header-cell-" + e)) ? void 0 : t.offsetWidth;
                if (void 0 !== n) return n;
            }(i);
            return void 0 !== l ? r({}, e, {
                gridLayout: r({}, e.gridLayout, {
                    columnId: i,
                    columnIndex: u,
                    startingWidth: l
                })
            }) : e;
        }
        if ("columnResizing" === t.type) {
            var s = e.gridLayout, a = s.columnIndex, c = s.startingWidth, d = s.columnWidths, f = c - (e.columnResizing.startX - t.clientX), p = [].concat(d);
            return p[a] = f + "px", r({}, e, {
                gridLayout: r({}, e.gridLayout, {
                    columnWidths: p
                })
            });
        }
    }
    e._UNSTABLE_usePivotColumns = nt, e.actions = l, e.defaultColumn = c, e.defaultGroupByFn = De, e.defaultOrderByFn = Qe, e.defaultRenderer = s, e.emptyRenderer = a, e.ensurePluginOrder = v, e.flexRender = b, e.functionalUpdate = m, e.loopHooks = g, e.makePropGetter = f, e.makeRenderer = R, e.reduceHooks = p, e.safeUseLayoutEffect = y, e.useAbsoluteLayout = Mt, e.useAsyncDebounce = function(e, n) {
        void 0 === n && (n = 0);
        var r = t.useRef({}), i = h(e), u = h(n);
        return t.useCallback(function() {
            var e = o(regeneratorRuntime.mark(function e() {
                var t, n, l, s = arguments;
                return regeneratorRuntime.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            for(t = s.length, n = new Array(t), l = 0; l < t; l++)n[l] = s[l];
                            return r.current.promise || (r.current.promise = new Promise(function(e, t) {
                                r.current.resolve = e, r.current.reject = t;
                            })), r.current.timeout && clearTimeout(r.current.timeout), r.current.timeout = setTimeout(o(regeneratorRuntime.mark(function e() {
                                return regeneratorRuntime.wrap(function(e) {
                                    for(;;)switch(e.prev = e.next){
                                        case 0:
                                            return delete r.current.timeout, e.prev = 1, e.t0 = r.current, e.next = 5, i().apply(void 0, n);
                                        case 5:
                                            e.t1 = e.sent, e.t0.resolve.call(e.t0, e.t1), e.next = 12;
                                            break;
                                        case 9:
                                            e.prev = 9, e.t2 = e.catch(1), r.current.reject(e.t2);
                                        case 12:
                                            return e.prev = 12, delete r.current.promise, e.finish(12);
                                        case 15:
                                        case "end":
                                            return e.stop();
                                    }
                                }, e, null, [
                                    [
                                        1,
                                        9,
                                        12,
                                        15
                                    ]
                                ]);
                            })), u()), e.abrupt("return", r.current.promise);
                        case 5:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function() {
                return e.apply(this, arguments);
            };
        }(), [
            i,
            u
        ]);
    }, e.useBlockLayout = Dt, e.useColumnOrder = It, e.useExpanded = se, e.useFilters = Pe, e.useFlexLayout = Vt, e.useGetLatest = h, e.useGlobalFilter = Ie, e.useGridLayout = $t, e.useGroupBy = ze, e.useMountedLayoutEffect = w, e.usePagination = Ze, e.useResizeColumns = kt, e.useRowSelect = vt, e.useRowState = xt, e.useSortBy = Ue, e.useTable = function(e) {
        for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)o[i - 1] = arguments[i];
        e = ie(e), o = [
            K
        ].concat(o);
        var u = t.useRef({}), s = h(u.current);
        Object.assign(s(), r({}, e, {
            plugins: o,
            hooks: q()
        })), o.filter(Boolean).forEach(function(e) {
            e(s().hooks);
        });
        var a = h(s().hooks);
        s().getHooks = a, delete s().hooks, Object.assign(s(), p(a().useOptions, ie(e)));
        var c = s(), d = c.data, v = c.columns, m = c.initialState, y = c.defaultColumn, w = c.getSubRows, b = c.getRowId, E = c.stateReducer, I = c.useControlledState, F = h(E), G = t.useCallback(function(e, t) {
            if (!t.type) throw console.info({
                action: t
            }), new Error("Unknown Action \uD83D\uDC46");
            return [].concat(a().stateReducers, Array.isArray(F()) ? F() : [
                F()
            ]).reduce(function(n, o) {
                return o(n, t, e, s()) || n;
            }, e);
        }, [
            a,
            F,
            s
        ]), A = t.useReducer(G, void 0, function() {
            return G(m, {
                type: l.init
            });
        }), k = A[0], H = A[1], T = p([].concat(a().useControlledState, [
            I
        ]), k, {
            instance: s()
        });
        Object.assign(s(), {
            state: T,
            dispatch: H
        });
        var z = t.useMemo(function() {
            return S(p(a().columns, v, {
                instance: s()
            }));
        }, [
            a,
            s,
            v
        ].concat(p(a().columnsDeps, [], {
            instance: s()
        })));
        s().columns = z;
        var W = t.useMemo(function() {
            return p(a().allColumns, C(z), {
                instance: s()
            }).map(x);
        }, [
            z,
            a,
            s
        ].concat(p(a().allColumnsDeps, [], {
            instance: s()
        })));
        s().allColumns = W;
        var O = t.useMemo(function() {
            for(var e = [], t = [], n = {}, o = [].concat(W); o.length;){
                var r = o.shift();
                le({
                    data: d,
                    rows: e,
                    flatRows: t,
                    rowsById: n,
                    column: r,
                    getRowId: b,
                    getSubRows: w,
                    accessValueHooks: a().accessValue,
                    getInstance: s
                });
            }
            return [
                e,
                t,
                n
            ];
        }, [
            W,
            d,
            b,
            w,
            a,
            s
        ]), M = O[0], j = O[1], N = O[2];
        Object.assign(s(), {
            rows: M,
            initialRows: [].concat(M),
            flatRows: j,
            rowsById: N
        }), g(a().useInstanceAfterData, s());
        var L = t.useMemo(function() {
            return p(a().visibleColumns, W, {
                instance: s()
            }).map(function(e) {
                return P(e, y);
            });
        }, [
            a,
            W,
            s,
            y
        ].concat(p(a().visibleColumnsDeps, [], {
            instance: s()
        })));
        W = t.useMemo(function() {
            var e = [].concat(L);
            return W.forEach(function(t) {
                e.find(function(e) {
                    return e.id === t.id;
                }) || e.push(t);
            }), e;
        }, [
            W,
            L
        ]), s().allColumns = W;
        var D = t.useMemo(function() {
            return p(a().headerGroups, B(L, y), s());
        }, [
            a,
            L,
            y,
            s
        ].concat(p(a().headerGroupsDeps, [], {
            instance: s()
        })));
        s().headerGroups = D;
        var V = t.useMemo(function() {
            return D.length ? D[0].headers : [];
        }, [
            D
        ]);
        s().headers = V, s().flatHeaders = D.reduce(function(e, t) {
            return [].concat(e, t.headers);
        }, []), g(a().useInstanceBeforeDimensions, s());
        var _ = L.filter(function(e) {
            return e.isVisible;
        }).map(function(e) {
            return e.id;
        }).sort().join("_");
        L = t.useMemo(function() {
            return L.filter(function(e) {
                return e.isVisible;
            });
        }, [
            L,
            _
        ]), s().visibleColumns = L;
        var X = ue(V), U = X[0], $ = X[1], J = X[2];
        return s().totalColumnsMinWidth = U, s().totalColumnsWidth = $, s().totalColumnsMaxWidth = J, g(a().useInstance, s()), [].concat(s().flatHeaders, s().allColumns).forEach(function(e) {
            e.render = R(s(), e), e.getHeaderProps = f(a().getHeaderProps, {
                instance: s(),
                column: e
            }), e.getFooterProps = f(a().getFooterProps, {
                instance: s(),
                column: e
            });
        }), s().headerGroups = t.useMemo(function() {
            return D.filter(function(e, t) {
                return e.headers = e.headers.filter(function(e) {
                    return e.headers ? function e(t) {
                        return t.filter(function(t) {
                            return t.headers ? e(t.headers) : t.isVisible;
                        }).length;
                    }(e.headers) : e.isVisible;
                }), !!e.headers.length && (e.getHeaderGroupProps = f(a().getHeaderGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), e.getFooterGroupProps = f(a().getFooterGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), !0);
            });
        }, [
            D,
            s,
            a
        ]), s().footerGroups = [].concat(s().headerGroups).reverse(), s().prepareRow = t.useCallback(function(e) {
            e.getRowProps = f(a().getRowProps, {
                instance: s(),
                row: e
            }), e.allCells = W.map(function(t) {
                var n = e.values[t.id], o = {
                    column: t,
                    row: e,
                    value: n
                };
                return o.getCellProps = f(a().getCellProps, {
                    instance: s(),
                    cell: o
                }), o.render = R(s(), t, {
                    row: e,
                    cell: o,
                    value: n
                }), o;
            }), e.cells = L.map(function(t) {
                return e.allCells.find(function(e) {
                    return e.column.id === t.id;
                });
            }), g(a().prepareRow, e, {
                instance: s()
            });
        }, [
            a,
            s,
            W,
            L
        ]), s().getTableProps = f(a().getTableProps, {
            instance: s()
        }), s().getTableBodyProps = f(a().getTableBodyProps, {
            instance: s()
        }), g(a().useFinalInstance, s()), s();
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

},{"3b97acdd01f16919":"d8NEQ"}],"fOGsv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableWrapper", ()=>TableWrapper);
parcelHelpers.export(exports, "TableHeaderWrapper", ()=>TableHeaderWrapper);
parcelHelpers.export(exports, "TableHeaderCellWrapper", ()=>TableHeaderCellWrapper);
parcelHelpers.export(exports, "TableCellWrapper", ()=>TableCellWrapper);
parcelHelpers.export(exports, "TableRowWrapper", ()=>TableRowWrapper);
parcelHelpers.export(exports, "TableBody", ()=>TableBody);
parcelHelpers.export(exports, "PaginationWrapper", ()=>PaginationWrapper);
parcelHelpers.export(exports, "FiltersWrapper", ()=>FiltersWrapper);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _components = require("@thecb/components");
const TableWrapper = (0, _styledComponentsDefault.default).table`
  background: ${(0, _components.constants).colors.WHITE};
  width: 100%;
  border-spacing: 0;
  box-shadow:
    0px 1px 4px 2px rgba(0, 0, 0, 0.1),
    0px 2px 1px 0px rgba(0, 0, 0, 0.15);
  margin-top: 1rem;
  color: ${(0, _components.constants).colors.CHARADE_GREY};
  font-size: 1rem;
`;
const TableHeaderWrapper = (0, _styledComponentsDefault.default).thead``;
const TableHeaderCellWrapper = (0, _styledComponentsDefault.default).th`
  background: ${(0, _components.constants).colors.ATHENS_GREY};
  margin: 0;
  padding: 1.5rem 1rem;
  border-bottom: 1px solid ${(0, _components.constants).colors.GREY_CHATEAU};
  text-align: left;
  font-weight: ${(0, _components.constants).fontWeights.FONT_WEIGHT_BOLD};

  :last-child {
    padding-right: 0;
    border-right: 0;
  }
`;
const TableCellWrapper = (0, _styledComponentsDefault.default).td`
  margin: 0;
  padding: 1.5rem 1rem;
  border-bottom: 1px solid ${(0, _components.constants).colors.GREY_CHATEAU};
  text-align: left;

  :last-child {
    border-right: 0;
    padding-right: 0;
  }
`;
const TableRowWrapper = (0, _styledComponentsDefault.default).tr`
  :last-child {
    td {
      border-bottom: 0;
    }
  }
`;
const TableBody = (0, _styledComponentsDefault.default).tbody``;
const PaginationWrapper = (0, _styledComponentsDefault.default).div`
  background: ${(0, _components.constants).colors.WHITE};
  width: 100%;
  margin: 0 auto;
  margin-top: 1rem;
  padding: 1.5rem;
  box-shadow:
    0px 1px 4px 2px rgba(0, 0, 0, 0.1),
    0px 2px 1px 0px rgba(0, 0, 0, 0.15);

  font-size: 1rem;

  button {
    min-width: 2.5rem;
  }

  button:last-child,
  button:first-child {
    line-height: 1rem;
  }
`;
const FiltersWrapper = (0, _styledComponentsDefault.default).div``;

},{"styled-components":"bkusY","@thecb/components":"g98ma","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5b6en":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NextPageIcon", ()=>NextPageIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const NextPageIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "10px",
        height: "15px",
        viewBox: "0 0 10 15",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                transform: "translate(-883.000000, -2442.000000)",
                fill: "#FFFFFF",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    transform: "translate(132.000000, 2405.000000)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        transform: "translate(268.000000, 24.000000)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            transform: "translate(468.000000, 0.000000)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                                transform: "translate(20.000000, 20.500000) rotate(-90.000000) translate(-20.000000, -20.500000) ",
                                points: "20.0011667 21.5615385 14.6473333 16 13 17.711336 20.0011667 25 27 17.711336 25.3561667 16"
                            })
                        })
                    })
                })
            })
        })
    });

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bOAyc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrevPageIcon", ()=>PrevPageIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const PrevPageIcon = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "10px",
        height: "15px",
        viewBox: "0 0 10 15",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                transform: "translate(-415.000000, -2441.000000)",
                fill: "#FFFFFF",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    transform: "translate(132.000000, 2405.000000)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        transform: "translate(268.000000, 24.000000)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            transform: "translate(20.000000, 20.000000) rotate(180.000000) translate(-20.000000, -20.000000) ",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                                transform: "translate(20.000000, 20.500000) rotate(-90.000000) translate(-20.000000, -20.500000) ",
                                points: "20.0011667 21.5615385 14.6473333 16 13 17.711336 20.0011667 25 27 17.711336 25.3561667 16"
                            })
                        })
                    })
                })
            })
        })
    });

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fAggk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoResultsImage", ()=>(0, _noResultsImage.NoResultsImage));
var _noResultsImage = require("./NoResultsImage");

},{"./NoResultsImage":"gbUHW","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gbUHW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoResultsImage", ()=>NoResultsImage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const NoResultsImage = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: "366px",
        height: "209px",
        viewBox: "0 0 366 209",
        version: "1.1",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "9401A2F7-7EA7-435C-BA7D-6BFF4918828A@1x"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                id: "STOR-3650---Update-Empty-Search-Results",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    id: "Orders---No-Results",
                    transform: "translate(-537.000000, -466.000000)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        id: "orders-table",
                        transform: "translate(132.000000, 332.000000)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            id: "illustration",
                            transform: "translate(405.000000, 134.000000)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M73,25 L297,25 L297,169.75 C297,170.992641 295.992641,172 294.75,172 L75.25,172 C74.0073593,172 73,170.992641 73,169.75 L73,25 L73,25 Z",
                                    id: "Page-Background---White",
                                    fill: "#FFFFFF"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M220.000457,47.5 C234.084028,47.5 245.5,58.9159716 245.5,72.9995426 C245.5,87.0831136 234.084028,98.5 220.000457,98.5 C205.915972,98.5 194.5,87.0831136 194.5,72.9995426 C194.5,58.9159716 205.915972,47.5 220.000457,47.5 Z M150.000457,47.5 C164.084028,47.5 175.5,58.9159716 175.5,72.9995426 C175.5,87.0831136 164.084028,98.5 150.000457,98.5 C135.916886,98.5 124.5,87.0831136 124.5,72.9995426 C124.5,58.9159716 135.916886,47.5 150.000457,47.5 Z M220.001186,68 C215.794553,68 212.097911,70.6889304 210.652708,74.6414959 C210.17857,75.9382448 210.845427,77.3738329 212.142176,77.8479716 C213.387055,78.3031448 214.759888,77.706776 215.28721,76.5110578 L215.348652,76.3585041 L215.431801,76.1452019 C216.217647,74.2491643 218.006201,73 220.001186,73 C221.99587,73 223.783657,74.2488739 224.56955,76.1451708 L224.652708,76.3585041 L224.71415,76.5110578 C225.241472,77.706776 226.614305,78.3031448 227.859184,77.8479716 C229.155933,77.3738329 229.82279,75.9382448 229.348652,74.6414959 C227.903399,70.6887931 224.207715,68 220.001186,68 Z M149.999495,68 C145.793062,68 142.096774,70.6852797 140.653086,74.632052 C140.177356,75.9326072 140.847452,77.3720437 142.149786,77.8471234 C143.400027,78.3032 144.778436,77.7047267 145.307603,76.5054711 L145.369255,76.3524679 L145.451943,76.1404551 C146.233483,74.2558745 148.013686,73.0141161 149.999495,73.0141161 C151.985328,73.0141161 153.765835,74.2559657 154.548224,76.1411104 L154.631008,76.3531878 L154.692707,76.5061722 C155.222242,77.7052661 156.600834,78.3033186 157.850935,77.8468603 C159.153124,77.371383 159.822779,75.9317419 159.346651,74.631332 C157.901704,70.6848627 154.205605,68 149.999495,68 Z",
                                    id: "Light-Blue",
                                    fill: "#E4F4FD"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M237,197 C237,203.627296 213.71874,209 185,209 C156.282251,209 133,203.627296 133,197 C133,190.372704 156.282251,185 185,185 C213.71874,185 237,190.372704 237,197",
                                    id: "Light-Green",
                                    fill: "#E8FFEF"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M294.625126,0 C298.145654,0 301,2.85476145 301,6.37705419 L301,157 L320,157 C321.656854,157 323,158.343146 323,160 C323,161.597681 321.75108,162.903661 320.176273,162.994907 L320,163 L301,163 L301,169.622946 C301,173.145239 298.145654,176 294.625126,176 L75.3738604,176 C71.8533317,176 69,173.145239 69,169.622946 L69,163 L33,163 C31.3431458,163 30,161.656854 30,160 C30,158.402319 31.24892,157.096339 32.8237272,157.005093 L33,157 L69,157 L69,6.37705419 C69,2.85476145 71.8533317,0 75.3738604,0 L294.625126,0 Z M297,25 L73,25 L73,169.622946 C73,170.881815 73.9761881,171.910945 75.2113435,171.99452 L75.3738604,172 L294.625126,172 C295.881818,172 296.910941,171.022964 296.99452,169.78574 L297,169.622946 L297,25 Z M336.953422,157 L363.065079,157.082452 C364.691092,157.087586 366.005094,158.416437 366,160.050522 C365.995059,161.626248 364.76536,162.910411 363.219585,162.995524 L363.046578,163 L336.934921,162.917548 C335.308908,162.912414 333.994906,161.583563 334,159.949478 C334.004941,158.373752 335.23464,157.089589 336.780415,157.004476 L336.953422,157 Z M17,157 C18.6568542,157 20,158.343146 20,160 C20,161.597681 18.75108,162.903661 17.1762728,162.994907 L17,163 L3,163 C1.34314575,163 0,161.656854 0,160 C0,158.402319 1.24891996,157.096339 2.82372721,157.005093 L3,157 L17,157 Z M196.832345,115 L197.092173,115.003747 C201.752752,115.138336 205.5145,118.881656 205.5145,123.5145 C205.5145,124.90322 204.38872,126.029 203,126.029 C201.666829,126.029 200.575983,124.991481 200.490849,123.679829 L200.4855,123.5145 L200.480483,123.330785 C200.383992,121.56785 198.90704,120.131202 197.034449,120.034219 L196.832345,120.029 L173.167655,120.029 L172.972241,120.033878 C171.098709,120.12767 169.619644,121.562334 169.519868,123.324491 L169.5145,123.5145 L169.509151,123.679829 C169.424017,124.991481 168.333171,126.029 167,126.029 C165.61128,126.029 164.4855,124.90322 164.4855,123.5145 C164.4855,118.881656 168.247248,115.138336 172.907827,115.003747 L173.167655,115 L196.832345,115 Z M220.000502,42.5 C236.845527,42.5 250.5,56.1544726 250.5,72.9994977 C250.5,89.8446868 236.845364,103.5 220.000502,103.5 C203.154806,103.5 189.5,89.844856 189.5,72.9994977 C189.5,72.6649381 189.505386,72.3316372 189.516076,71.9996768 L180.483924,71.9996865 L180.495971,72.4986175 L180.5,72.9994977 C180.5,89.8446868 166.845364,103.5 150.000502,103.5 C133.155477,103.5 119.5,89.8445229 119.5,72.9994977 C119.5,56.1546365 133.155313,42.5 150.000502,42.5 C160.220702,42.5 169.266433,47.5263225 174.800702,55.2419738 C178.529415,53.7469717 182.025884,53 185.2911,53 C188.594521,53 191.884404,53.7653162 195.160747,55.2964908 C200.690764,47.5502067 209.755478,42.5 220.000502,42.5 Z M220.000502,47.5 C205.916038,47.5 194.5,58.9157549 194.5,72.9994977 C194.5,87.0834599 205.916257,98.5 220.000502,98.5 C234.083884,98.5 245.5,87.0833185 245.5,72.9994977 C245.5,58.9158964 234.084104,47.5 220.000502,47.5 Z M150.000502,47.5 C135.916682,47.5 124.5,58.9161157 124.5,72.9994977 C124.5,87.0830991 135.916901,98.5 150.000502,98.5 C164.083884,98.5 175.5,87.0833185 175.5,72.9994977 C175.5,58.9158964 164.084104,47.5 150.000502,47.5 Z M185.001733,59 C183.344763,59 182.0006,60.3430298 182.0006,62 C182.0006,63.6569702 183.344763,65 185.001733,65 C186.65757,65 188.0006,63.6569702 188.0006,62 C188.0006,60.3430298 186.65757,59 185.001733,59 Z M294.625126,4 L75.3738604,4 C74.1175419,4 73.0890072,4.97667728 73.0054771,6.21421561 L73,6.37705419 L73,21 L297,21 L297,6.37705419 C297,5.11855935 296.023239,4.08908645 294.787692,4.00548193 L294.625126,4 Z M81.5,10 C82.8807119,10 84,11.1192881 84,12.5 C84,13.8807119 82.8807119,15 81.5,15 C80.1192881,15 79,13.8807119 79,12.5 C79,11.1192881 80.1192881,10 81.5,10 Z M89.5,10 C90.8807119,10 92,11.1192881 92,12.5 C92,13.8807119 90.8807119,15 89.5,15 C88.1192881,15 87,13.8807119 87,12.5 C87,11.1192881 88.1192881,10 89.5,10 Z M97.5,10 C98.8807119,10 100,11.1192881 100,12.5 C100,13.8807119 98.8807119,15 97.5,15 C96.1192881,15 95,13.8807119 95,12.5 C95,11.1192881 96.1192881,10 97.5,10 Z",
                                    id: "Black",
                                    fill: "#292A33",
                                    fillRule: "nonzero"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M220.001186,68 C224.207715,68 227.903399,70.6887931 229.348652,74.6414959 C229.82279,75.9382448 229.155933,77.3738329 227.859184,77.8479716 C226.614305,78.3031448 225.241472,77.706776 224.71415,76.5110578 L224.652708,76.3585041 C223.915802,74.3430962 222.069747,73 220.001186,73 C218.006201,73 216.217647,74.2491643 215.431801,76.1452019 L215.348652,76.3585041 C214.874513,77.6552531 213.438925,78.3221103 212.142176,77.8479716 C210.845427,77.3738329 210.17857,75.9382448 210.652708,74.6414959 C212.097911,70.6889304 215.794553,68 220.001186,68 Z M149.999495,68 C154.205605,68 157.901704,70.6848627 159.346651,74.631332 C159.822779,75.9317419 159.153124,77.371383 157.850935,77.8468603 C156.600834,78.3033186 155.222242,77.7052661 154.692707,76.5061722 L154.631008,76.3531878 C153.897443,74.3496581 152.058877,73.0141161 149.999495,73.0141161 C148.013686,73.0141161 146.233483,74.2558745 145.451943,76.1404551 L145.369255,76.3524679 C144.893526,77.6530231 143.45212,78.3222032 142.149786,77.8471234 C140.847452,77.3720437 140.177356,75.9326072 140.653086,74.632052 C142.096774,70.6852797 145.793062,68 149.999495,68 Z",
                                    id: "Dark-Gray",
                                    fill: "#959CA8",
                                    fillRule: "nonzero"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M294.75,4 C295.992641,4 297,5.00735931 297,6.25 L297,6.25 L297,21 L73,21 L73,6.25 C73,5.00735931 74.0073593,4 75.25,4 L75.25,4 Z M81.5,10 C80.1192881,10 79,11.1192881 79,12.5 C79,13.8807119 80.1192881,15 81.5,15 C82.8807119,15 84,13.8807119 84,12.5 C84,11.1192881 82.8807119,10 81.5,10 Z M89.5,10 C88.1192881,10 87,11.1192881 87,12.5 C87,13.8807119 88.1192881,15 89.5,15 C90.8807119,15 92,13.8807119 92,12.5 C92,11.1192881 90.8807119,10 89.5,10 Z M97.5,10 C96.1192881,10 95,11.1192881 95,12.5 C95,13.8807119 96.1192881,15 97.5,15 C98.8807119,15 100,13.8807119 100,12.5 C100,11.1192881 98.8807119,10 97.5,10 Z",
                                    id: "Light-Gray",
                                    fill: "#E4E6EB"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M182,176 L182,196 C182,198.142195 180.316032,199.891079 178.19964,199.995105 L178,200 L164,200 C161.790861,200 160,198.209139 160,196 C160,193.857805 161.683968,192.108921 163.80036,192.004895 L164,192 L174,192 L174,176 L182,176 Z M196,176 L196,192 L206,192 C208.142195,192 209.891079,193.683968 209.995105,195.80036 L210,196 C210,198.142195 208.316032,199.891079 206.19964,199.995105 L206,200 L192,200 C189.857805,200 188.108921,198.316032 188.004895,196.19964 L188,196 L188,176 L196,176 Z M69,128.5 L69,137.5 L61.125,141.929 L94.0012592,148.882409 C95.8102512,144.82688 99.8775753,142 104.605,142 C106.814139,142 108.605,143.790861 108.605,146 C108.605,148.142195 106.921032,149.891079 104.80464,149.995105 L104.605,150 C102.618174,150 101.006544,151.607603 101.00002,153.5929 C101.000833,153.604248 101.000808,153.615986 101.00073,153.627732 L101,153.605 C101,155.532536 102.511612,157.106464 104.413547,157.206002 L104.605,157.211 L111.249,157.211 C113.458139,157.211 115.249,159.001861 115.249,161.211 C115.249,163.353195 113.565032,165.102079 111.44864,165.206105 L111.249,165.211 L104.605,165.211 C99.3591731,165.211 94.9264122,161.730242 93.4898615,156.952099 L48.7822611,147.495319 C45.2023864,146.738129 44.4595098,142.001521 47.5400069,140.158581 L47.7150855,140.059217 L69,128.5 Z M262.321128,66.271643 C262.794872,68.8298593 263.035,71.4389393 263.035,74.077 C263.035,74.3803634 263.031823,74.6833044 263.025482,74.9857856 L316.044232,112.72143 C317.998947,114.112656 318.286935,116.88435 316.706495,118.646896 L316.557666,118.804281 L301,134.5 L301,123 L307.557,116.5 L261.876181,83.9870944 C261.331752,86.2731924 260.598762,88.5069364 259.684166,90.6698577 C258.823785,92.7045664 256.476851,93.6565471 254.442142,92.796166 C252.407434,91.935785 251.455453,89.588851 252.315834,87.5541423 C254.102413,83.329074 255.035,78.7712722 255.035,74.077 C255.035,71.9281711 254.839748,69.8066877 254.454872,67.728357 C254.052611,65.5561504 255.487436,63.4691325 257.659643,63.066872 C259.83185,62.6646115 261.918868,64.0994363 262.321128,66.271643 Z",
                                    id: "Dark-Blue",
                                    fill: "#317D4F",
                                    fillRule: "nonzero"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5TzpP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useDelayMount = (delay = 0)=>{
    const [mounted, setMounted] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const delayedMount = setTimeout(()=>{
            !mounted && setMounted(true);
        }, delay);
        return ()=>clearTimeout(delayedMount);
    }, [
        delay,
        mounted
    ]);
    return [
        mounted,
        setMounted
    ];
};
exports.default = useDelayMount;

},{"react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lNuiy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableCell", ()=>TableCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TableCell = ({ variant = "d", children })=>{
    if (variant === "h") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
        children: children
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
        children: children
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1pLAa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TableRow", ()=>TableRow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TableRow = ({ children })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
        children: children
    });
};

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"LMC8m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _closeout = require("./Closeout");
var _closeoutDefault = parcelHelpers.interopDefault(_closeout);
var _reactRedux = require("react-redux");
var _closeoutState = require("./Closeout.state");
exports.default = (0, _reactRedux.connect)((0, _closeoutState.mapStateToProps), (0, _closeoutState.mapDispatchToProps))((0, _closeoutDefault.default));

},{"./Closeout":"4PoaQ","react-redux":"k6jol","./Closeout.state":"eCCPO","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4PoaQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _closeoutForm = require("./CloseoutForm");
var _reactRedux = require("react-redux");
var _sharedAlertBar = require("../../components/alert-bar/SharedAlertBar");
var _sharedAlertBarDefault = parcelHelpers.interopDefault(_sharedAlertBar);
const Header = ({ alertBar, alertBarActions })=>{
    const { alerts: sharedAlerts } = (0, _reactRedux.useSelector)((state)=>state.shared);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "55.429rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                sharedAlerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sharedAlertBarDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Closeout"
                })
            ]
        })
    });
};
const Closeout = ({ alertBars, actions, forms, modals, submitCloseoutForm, fetchCurrentBatch, displayCartAlert })=>{
    const { order } = (0, _reactRedux.useSelector)((state)=>state.cart);
    (0, _react.useEffect)(()=>{
        fetchCurrentBatch();
    }, []);
    if (order && order.order_items?.length > 0 && !alertBars.closeoutAlertBars.alerts.length > 0) displayCartAlert();
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0 0 2rem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeoutForm.CloseoutForm), {
            modals: modals,
            forms: forms,
            ...actions.forms.closeoutForm,
            ...actions.modals.closeout,
            ...forms.closeoutForm,
            submitCloseoutForm: submitCloseoutForm
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DefaultPageTemplate), {
        maxWidth: "55.429rem",
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.closeoutAlertBars,
            alertBarActions: actions.alertBars.closeoutAlertBars
        }, "CloseoutHeader"),
        content: content,
        gutters: "0"
    });
};
exports.default = Closeout;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../components/alert-bar":"aD416","./CloseoutForm":"fSO1r","react-redux":"k6jol","../../components/alert-bar/SharedAlertBar":"gk2Ni","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dfJIk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cashDrop = require("./CashDrop");
var _cashDropDefault = parcelHelpers.interopDefault(_cashDrop);
var _reactRedux = require("react-redux");
var _cashDropState = require("./CashDrop.state");
exports.default = (0, _reactRedux.connect)((0, _cashDropState.mapStateToProps), (0, _cashDropState.mapDispatchToProps))((0, _cashDropDefault.default));

},{"./CashDrop":"bRvcA","react-redux":"k6jol","./CashDrop.state":"esqw8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bRvcA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _cashDropForm = require("./CashDropForm");
const Header = ({ alertBar, alertBarActions })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "55.429rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Cash Drop"
                })
            ]
        })
    });
const CashDrop = ({ alertBars, actions, forms, submitCashDropForm, terminalSession })=>{
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "0 0 2rem",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cashDropForm.CashDropForm), {
            forms: forms,
            ...actions.forms.cashDropForm,
            ...forms.cashDropForm,
            submitCashDropForm: submitCashDropForm,
            terminalSession: terminalSession
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DefaultPageTemplate), {
        maxWidth: "55.429rem",
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.cashDropAlertBars,
            alertBarActions: actions.alertBars.cashDropAlertBars
        }, "CashDropHeader"),
        content: content,
        gutters: "0"
    });
};
exports.default = CashDrop;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../components/alert-bar":"aD416","./CashDropForm":"gUrPx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"j7yqE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _drawerHistoryIndex = require("./DrawerHistoryIndex");
var _drawerHistoryIndexDefault = parcelHelpers.interopDefault(_drawerHistoryIndex);
var _reactRedux = require("react-redux");
var _drawerHistoryIndexState = require("./DrawerHistoryIndex.state");
exports.default = (0, _reactRedux.connect)((0, _drawerHistoryIndexState.mapStateToProps), (0, _drawerHistoryIndexState.mapDispatchToProps))((0, _drawerHistoryIndexDefault.default));

},{"./DrawerHistoryIndex":"hs8uA","react-redux":"k6jol","./DrawerHistoryIndex.state":"d4FVh","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hs8uA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _table = require("../../components/table");
var _helpers = require("../../utils/helpers");
var _drawerHistoryFiltersForm = require("./DrawerHistoryFiltersForm");
var _reactRedux = require("react-redux");
var _shared = require("../../state/shared");
var _filterFormsHelpers = require("../../utils/filterFormsHelpers");
const Header = ({ alertBar, alertBarActions })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "1rem 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "1rem 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Drawer History"
                })
            ]
        })
    });
const DrawerHistoryIndex = ({ alertBars, actions, data, meta, forms, errors, clearSearchField, shouldClear, fetching, fetchData })=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const { isLoadingDrawerHistory } = (0, _reactRedux.useSelector)((state)=>state.drawerHistoryIndex);
    const { agencies, locations, terminals, users } = (0, _reactRedux.useSelector)((state)=>state.shared.tableFilterOptions);
    (0, _react.useEffect)(()=>{
        dispatch((0, _shared.fetchDrawerHistoriesFilterOptionsRequest)());
    }, []);
    const columns = (0, _react.useMemo)(()=>[
            {
                Header: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                    variant: "small",
                    "data-testid": "table-header-column--id",
                    fontSize: "1rem",
                    children: "Cash Action ID"
                }),
                accessor: "id",
                Cell: ({ value, row: { original: { type } } })=>{
                    const pathname = type === "closeout" ? "closeout" : "cashaction";
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithLink), {
                        url: `/pos/${pathname}/${value}`,
                        variant: "smallGhost",
                        text: value,
                        extraStyles: `margin: 0.5rem 0; text-align: left; min-width: 0px;`,
                        textExtraStyles: "font-size: 1rem;",
                        contentOverride: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                            fontSize: "1rem",
                            color: (0, _components.constants).colors.LUCKY_POINT,
                            children: value
                        })
                    });
                },
                width: 100
            },
            {
                Header: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                    variant: "small",
                    "data-testid": "table-header-column--batch-number",
                    fontSize: "1rem",
                    children: "Batch Number"
                }),
                accessor: "batch",
                Cell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                        fontSize: "1rem",
                        children: value
                    }),
                width: 175
            },
            {
                Header: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                    variant: "small",
                    "data-testid": "table-header-column--report-type",
                    fontSize: "1rem",
                    children: "Report Type"
                }),
                accessor: "type",
                width: 100,
                Cell: ({ value })=>(0, _helpers.capitalize)(value)
            },
            {
                Header: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                    variant: "small",
                    "data-testid": "table-header-column--location",
                    fontSize: "1rem",
                    children: "Location"
                }),
                accessor: "location",
                width: 100
            },
            {
                Header: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                    variant: "small",
                    "data-testid": "table-header-column--user",
                    fontSize: "1rem",
                    children: "User"
                }),
                accessor: "cashier",
                width: 150
            },
            {
                Header: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                    variant: "small",
                    "data-testid": "table-header-column--date-processed",
                    fontSize: "1rem",
                    children: "Date Processed"
                }),
                accessor: "processed_date",
                width: 150,
                Cell: ({ value })=>(0, _helpers.formatDate)(value)
            },
            {
                Header: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                    variant: "small",
                    "data-testid": "table-header-column--amount",
                    fontSize: "1rem",
                    children: "Amount"
                }),
                accessor: "amount",
                Cell: ({ value })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                        fontSize: "1rem",
                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                        children: (0, _helpers.formatPrice)(value)
                    }),
                width: 50
            }
        ], []);
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Table), {
        errors: errors,
        columns: columns,
        data: data ?? [],
        loading: isLoadingDrawerHistory,
        pageCount: meta.pagesTotal,
        totalItems: meta.recordsTotal,
        fetchData: fetchData,
        labelForTotal: "Records",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerHistoryFiltersForm.DrawerHistoryFiltersForm), {
            ...forms.drawerHistoryFiltersForm,
            ...actions.forms.drawerHistoryFiltersForm,
            forms: forms,
            agencyOptions: [
                (0, _filterFormsHelpers.getDefaultFormSelectOption)("agencies"),
                ...agencies
            ],
            locationOptions: [
                (0, _filterFormsHelpers.getDefaultFormSelectOption)("locations"),
                ...locations
            ],
            terminalOptions: [
                (0, _filterFormsHelpers.getDefaultFormSelectOption)("terminals"),
                ...terminals
            ],
            userOptions: [
                (0, _filterFormsHelpers.getDefaultFormSelectOption)("users"),
                ...users
            ],
            showErrors: errors,
            shouldClear: shouldClear,
            clear: clearSearchField,
            fetchData: fetchData,
            loading: fetching
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DefaultPageTemplate), {
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.drawerHistoryIndexAlertBars,
            alertBarActions: actions.alertBars.drawerHistoryIndexAlertBars
        }, "DrawerHistoryIndexHeader"),
        gutters: "0",
        content: content,
        maxWidth: "85.714rem"
    });
};
exports.default = DrawerHistoryIndex;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../components/alert-bar":"aD416","../../components/table":"4QErL","../../utils/helpers":"epomp","./DrawerHistoryFiltersForm":"k5bcW","react-redux":"k6jol","../../state/shared":"h0jLC","../../utils/filterFormsHelpers":"iHHYA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3x6DF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRedux = require("react-redux");
var _cashActionDetails = require("./CashActionDetails");
var _cashActionDetailsDefault = parcelHelpers.interopDefault(_cashActionDetails);
var _cashActionDetailsState = require("./CashActionDetails.state");
exports.default = (0, _reactRedux.connect)((0, _cashActionDetailsState.mapStateToProps), (0, _cashActionDetailsState.mapDispatchToProps))((0, _cashActionDetailsDefault.default));

},{"react-redux":"k6jol","./CashActionDetails":"5Brbe","./CashActionDetails.state":"dI29X","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5Brbe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _components = require("@thecb/components");
var _constants = require("../../utils/constants");
var _helpers = require("../../utils/helpers");
var _statusModule = require("../../components/status-module");
var _pdfReports = require("../../components/pdf-reports");
const Header = ({ alertBar, alertBarActions })=>alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
            ...alertBar,
            ...alertBarActions,
            isToast: true
        })
    });
const CashActionDetails = ({ data: cashAction, fetching, alertBars, actions, getCashActionDetails, getCloseoutDetails, error, errorText, submitPrintReceipt, submitReprintReport, typeDisplay, reports })=>{
    // this type value will be used to influence UI rendering
    // should either be cashDrop or closeout (cashAdd in the future)
    const { type, cashier, total } = cashAction;
    const { id } = (0, _reactRouterDom.useParams)();
    const { pathname } = (0, _reactRouterDom.useLocation)();
    const closeoutDetailsVariant = type === (0, _constants.CASH_ACTION_TYPES).CLOSEOUT;
    const cashActionDetailsVariant = type !== (0, _constants.CASH_ACTION_TYPES).CLOSEOUT;
    (0, _react.useEffect)(()=>{
        if (pathname.includes((0, _constants.CASH_ACTION_TYPES).CLOSEOUT)) getCloseoutDetails(id);
        else getCashActionDetails(id);
    }, [
        pathname
    ]);
    (0, _pdfReports.useCloseoutReportDownloader)(reports);
    const buttonStyle = `
    border-radius: 4px;
    font-size: 14px;
  `;
    const handleReprintClick = (e)=>{
        e.preventDefault();
        submitReprintReport(id);
    };
    const handleSubmitPrintReceipt = (e)=>{
        e.preventDefault();
        submitPrintReceipt(id);
    };
    const cashActionActions = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
            align: "center",
            children: [
                cashActionDetailsVariant && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    extraStyles: buttonStyle,
                    text: "Print Receipt",
                    isLoading: false,
                    variant: "secondary",
                    action: handleSubmitPrintReceipt,
                    textExtraStyles: "font-size: 1rem;"
                }),
                closeoutDetailsVariant && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.ButtonWithAction), {
                    extraStyles: buttonStyle,
                    text: "Reprint reports",
                    isLoading: false,
                    variant: "secondary",
                    action: handleReprintClick,
                    textExtraStyles: "font-size: 1rem;"
                })
            ]
        });
    const dateCluster = cashActionDetailsVariant ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
        justify: "space-between",
        extraStyles: `margin-bottom: 0.5rem;`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                variant: "small",
                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                children: "Date"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                variant: "small",
                children: (0, _dayjsDefault.default)(cashAction.date).format("MM/DD/YYYY hh:mmA")
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                justify: "space-between",
                extraStyles: `margin-bottom: 0.5rem;`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                        variant: "small",
                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                        children: "Opened Date"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                        variant: "small",
                        children: (0, _dayjsDefault.default)(cashAction?.terminal_session?.created_at).format("MM/DD/YYYY hh:mmA")
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                justify: "space-between",
                extraStyles: `margin-bottom: 0.5rem;`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                        variant: "small",
                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                        children: "Closed Date"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                        variant: "small",
                        children: (0, _dayjsDefault.default)(cashAction?.terminal_session?.closeout_at).format("MM/DD/YYYY hh:mmA")
                    })
                ]
            })
        ]
    });
    const body = error || Boolean(!cashAction) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                children: "Error"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Detail), {
                children: [
                    "Sorry, ",
                    errorText
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                padding: "1rem 0",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                    variant: "baseStandard",
                    padding: "0",
                    borderRadius: ".25rem",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            background: (0, _components.constants).colors.ATHENS_GREY,
                            borderRadius: ".25rem",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                justify: "space-between",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Title), {
                                        id: "cash-action-title",
                                        variant: "small",
                                        as: "h4",
                                        color: (0, _components.constants).colors.CHARADE_GREY,
                                        weight: "600",
                                        children: [
                                            "Cash Action ID: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Detail), {
                                                as: "span",
                                                variant: "large",
                                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                                extraStyles: `margin-left: 0.25rem; font-size: 1.25rem;`,
                                                children: [
                                                    closeoutDetailsVariant && cashAction?.closeout?.id,
                                                    cashActionDetailsVariant && cashAction?.id
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                        fontSize: "20px",
                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                        id: "cash-action-total-1",
                                        children: (0, _helpers.formatPrice)(total)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                            background: (0, _components.constants).colors.WHITE,
                            borderRadius: ".25rem",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                justify: "space-between",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                        padding: "0",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusModule.StatusModule), {
                                            label: typeDisplay,
                                            status: "completed"
                                        })
                                    }),
                                    cashActionActions()
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                padding: "1rem 0",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Title), {
                        as: "h4",
                        variant: "small",
                        color: (0, _components.constants).colors.CHARADE_GREY,
                        weight: "600",
                        children: [
                            typeDisplay,
                            " Details"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.BoxWithShadow), {
                        variant: "baseStandard",
                        padding: "0",
                        background: (0, _components.constants).colors.WHITE,
                        borderRadius: ".25rem",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Box), {
                                padding: "1.5rem",
                                width: "384px",
                                borderRadius: ".25rem",
                                children: [
                                    dateCluster,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        justify: "space-between",
                                        extraStyles: `margin-bottom: 0.5rem;`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                                variant: "small",
                                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                children: "User"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                                variant: "small",
                                                children: cashier
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        justify: "space-between",
                                        extraStyles: `margin-bottom: 0.5rem;`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                                variant: "small",
                                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                children: "Terminal"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                                variant: "small",
                                                children: cashAction.terminal
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                        justify: "space-between",
                                        extraStyles: `margin-bottom: 0.5rem;`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                                variant: "small",
                                                weight: (0, _components.constants).fontWeights.FONT_WEIGHT_SEMIBOLD,
                                                children: "Batch Number"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                                variant: "small",
                                                children: cashAction.batchNumber
                                            })
                                        ]
                                    })
                                ]
                            }),
                            cashActionDetailsVariant && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.SolidDivider), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                        background: (0, _components.constants).colors.ATHENS_GREY,
                                        padding: "0 1.5rem",
                                        borderRadius: ".25rem",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                                            padding: "1.5rem 0",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Cluster), {
                                                justify: "space-between",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Detail), {
                                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                                        children: [
                                                            typeDisplay,
                                                            " Total"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Detail), {
                                                        variant: "large",
                                                        weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                                                        id: "cash-action-total-2",
                                                        children: (0, _helpers.formatPrice)(total)
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DefaultPageTemplate), {
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.cashActionDetailsAlertBars,
            alertBarActions: actions.alertBars.cashActionDetailsAlertBars
        }, "CashActionDetailsHeader"),
        gutters: "0",
        content: fetching ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Loading), {}) : body,
        maxWidth: "85.714rem"
    });
};
exports.default = CashActionDetails;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","react-router-dom":"hNarb","../../components/alert-bar":"aD416","dayjs":"4CsUp","@thecb/components":"g98ma","../../utils/constants":"f3A1R","../../utils/helpers":"epomp","../../components/status-module":"jPWTe","../../components/pdf-reports":"5TB3o","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jPWTe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusModule", ()=>(0, _statusModule.StatusModule));
var _statusModule = require("./StatusModule");

},{"./StatusModule":"g1MR4","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fdUs1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reporting = require("./Reporting");
var _reportingDefault = parcelHelpers.interopDefault(_reporting);
var _reportingState = require("./Reporting.state");
var _reactRedux = require("react-redux");
exports.default = (0, _reactRedux.connect)((0, _reportingState.mapStateToProps), (0, _reportingState.mapDispatchToProps))((0, _reportingDefault.default));

},{"./Reporting":"7PZA8","./Reporting.state":"5xRzg","react-redux":"k6jol","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7PZA8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@thecb/components");
var _alertBar = require("../../components/alert-bar");
var _alertBarDefault = parcelHelpers.interopDefault(_alertBar);
var _reactRedux = require("react-redux");
var _reportingState = require("./Reporting.state");
const Header = ({ alertBar, alertBarActions })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
        width: "100%",
        padding: "16px 0",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _components.Center), {
            maxWidth: "85.714rem",
            children: [
                alertBar.alerts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Box), {
                    padding: "16px 0",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBarDefault.default), {
                        ...alertBar,
                        ...alertBarActions
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Title), {
                    color: (0, _components.constants).colors.CHARADE_GREY,
                    weight: (0, _components.constants).fontWeights.FONT_WEIGHT_BOLD,
                    children: "Reporting"
                })
            ]
        })
    });
const Reporting = ({ actions })=>{
    const { url, periscopeDataPending, periscopeDataSuccess, periscopeDataFailure, alertBars } = (0, _reactRedux.useSelector)((state)=>state.reporting);
    const dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _reportingState.requestPeriscopeDashboardIframe)());
    }, []);
    const content = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.PeriscopeDashboardIframe), {
        url: url,
        requestDashboardUrl: ()=>(0, _components.util).general.noop,
        periscopeDataPending: periscopeDataPending,
        periscopeDataSuccess: periscopeDataSuccess,
        periscopeDataFailure: periscopeDataFailure,
        periscopeDataRequestSuccess: ()=>dispatch((0, _reportingState.periscopeDataRequestSuccess)()),
        periscopeDataRequestFailure: ()=>dispatch((0, _reportingState.periscopeDataRequestFailure)())
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.DefaultPageTemplate), {
        header: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
            alertBar: alertBars.reportingAlertBars,
            alertBarActions: actions.alertBars.reportingAlertBars
        }, "ReportingHeader"),
        content: content,
        gutters: "0",
        maxWidth: "85.714rem"
    });
};
exports.default = Reporting;

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@thecb/components":"g98ma","../../components/alert-bar":"aD416","react-redux":"k6jol","./Reporting.state":"5xRzg","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9txSJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Logout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _oktaReact = require("@okta/okta-react");
var _reactRouterDom = require("react-router-dom");
var _constants = require("../../utils/constants");
var _components = require("@thecb/components");
var _reactRedux = require("react-redux");
var _loginState = require("../login/Login.state");
var _state = require("../../utils/state");
function Logout() {
    const { oktaAuth } = (0, _oktaReact.useOktaAuth)();
    const location = (0, _reactRouterDom.useLocation)();
    const { isLoggingOut } = (0, _reactRedux.useSelector)((state)=>state.login);
    const dispatch = (0, _reactRedux.useDispatch)();
    const hasOktaOAuthError = ()=>location.search.includes((0, _constants.OKTA_OAUTH_ERROR).queryStr);
    const handleOktaLogout = async ()=>{
        const logoutReason = localStorage.getItem((0, _constants.OKTA_LOGOUT_REASON_KEY));
        if (!logoutReason) localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), (0, _constants.LOGOUT_REASONS).USER_INITIATED.name);
        try {
            if (hasOktaOAuthError()) {
                await oktaAuth.signOut({
                    postLogoutRedirectUri: window.location.origin
                });
                localStorage.setItem((0, _constants.OKTA_LOGOUT_REASON_KEY), (0, _constants.OKTA_OAUTH_ERROR).alertBarMsg);
            } else await oktaAuth.signOut({
                postLogoutRedirectUri: window.location.origin
            });
            oktaAuth.tokenManager.clear();
            (0, _state.clearLocalStorageSession)();
        } catch (err) {
            console.warn(`%cWarning: Okta sign out error: ${err}`, `background-color: ${(0, _constants.consoleWarningStyle)}`);
        }
        dispatch((0, _loginState.setIsLoggingOut)(false));
    };
    (0, _react.useEffect)(()=>{
        handleOktaLogout();
    }, [
        isLoggingOut
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.Loading), {});
}

},{"react/jsx-runtime":"gHQIF","react":"d8NEQ","@okta/okta-react":"3286W","react-router-dom":"hNarb","../../utils/constants":"f3A1R","@thecb/components":"g98ma","react-redux":"k6jol","../login/Login.state":"eq6dI","../../utils/state":"8UPqD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"imHyE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACE_PROPAGATION_URL_PATTERNS", ()=>TRACE_PROPAGATION_URL_PATTERNS);
parcelHelpers.export(exports, "OTEL_LD_FLAG", ()=>OTEL_LD_FLAG);
/**
 * Initializes OpenTelemetry browser instrumentation.
 *
 * - Patches global fetch() and XMLHttpRequest to generate trace spans
 * - Exports traces via OTLP/HTTP to the same-origin /otlp proxy
 * - Idempotent once global registration has run (complete or partial)
 * - Failures are swallowed so the cashiering UI still boots
 *
 * Call only after LaunchDarkly has evaluated {@link OTEL_LD_FLAG} as true
 * (see {@link OpenTelemetryGate}). Live flag toggles require a hard refresh;
 * this does not tear down instrumentation when the flag turns off mid-session.
 */ parcelHelpers.export(exports, "initOpenTelemetry", ()=>initOpenTelemetry);
/**
 * Blocks app mount until LaunchDarkly is ready, then optionally starts OTel
 * before children (and their HTTP traffic) render. Must sit under LDProvider.
 *
 * When enable-otel-tracing is on, init runs before children so early HTTP is
 * instrumented. Live flag toggles need a hard refresh; this gate does not tear
 * down instrumentation if the flag turns off mid-session.
 *
 * Status chatter (init/skip/LD reason) is intentionally not console.log'd so
 * cashiers never see it; only real failures warn/error.
 */ parcelHelpers.export(exports, "OpenTelemetryGate", ()=>OpenTelemetryGate);
var _react = require("react");
var _launchdarklyReactClientSdk = require("launchdarkly-react-client-sdk");
var _sdkTraceWeb = require("@opentelemetry/sdk-trace-web");
var _sdkTraceBase = require("@opentelemetry/sdk-trace-base");
var _exporterTraceOtlpHttp = require("@opentelemetry/exporter-trace-otlp-http");
var _resources = require("@opentelemetry/resources");
var _instrumentation = require("@opentelemetry/instrumentation");
var _instrumentationFetch = require("@opentelemetry/instrumentation-fetch");
var _instrumentationXmlHttpRequest = require("@opentelemetry/instrumentation-xml-http-request");
var process = require("3e8bfa4e22211294");
// Same-origin OTLP/HTTP path. In cluster, Emissary/Ambassador maps /otlp/* to
// the Coralogix agent OTLP HTTP receiver (:4318) — see app-state pos-frontend
// mapping (POS-2328). Browsers cannot use in-cluster NODE_IP/hostPort like
// backend SDKs (cb-pos, edge-manager); kiosk-interface uses the same URL shape
// with an on-device collector instead.
const OTLP_TRACES_URL = "/otlp/v1/traces";
const TRACE_PROPAGATION_URL_PATTERNS = [
    // UAT/prod Citybase hosts (cb-pos-*, frontend-config, pos-frontend APIs, etc.)
    /^https?:\/\/([\w.-]+\.)?cityba\.se(?::\d+)?\//i,
    // Prod vanity / legacy Citybase hosts
    /^https?:\/\/([\w.-]+\.)?thecitybase\.com(?::\d+)?\//i,
    // Local cb-pos + frontend-configuration-service (see src/static/config.json)
    /^https?:\/\/localhost(?::\d+)?\//i,
    /^https?:\/\/127\.0\.0\.1(?::\d+)?\//i
];
const OTEL_LD_FLAG = "enable-otel-tracing";
/**
 * Initialization lifecycle for {@link initOpenTelemetry}.
 *
 * - not_started: never ran (or failed before provider.register()); safe to retry full init
 * - global_registered: provider.register() mutated global OTel API; do not construct/register again
 * - complete: register + instrumentations finished successfully
 *
 * provider.register() commits global tracer/context/propagator state. A later throw would leave
 * otelInitialized=false under a boolean guard and retries would rebuild a dead provider and
 * re-patch fetch. Tracking states avoids that ambiguity without blocking retries of pure
 * construction failures.
 */ const OTEL_INIT_STATE = {
    NOT_STARTED: "not_started",
    GLOBAL_REGISTERED: "global_registered",
    COMPLETE: "complete"
};
let otelInitState = OTEL_INIT_STATE.NOT_STARTED;
function initOpenTelemetry() {
    // Already finished, or register() already took the global OTel slot — do not retry.
    if (otelInitState === OTEL_INIT_STATE.COMPLETE || otelInitState === OTEL_INIT_STATE.GLOBAL_REGISTERED) return;
    try {
        const resource = new (0, _resources.Resource)({
            // Keep service.name stable for Coralogix filters / emissary drop allowlist.
            "service.name": "pos-frontend-traces",
            // Build-time SHA (Docker ARG/ENV COMMIT_SHA → Parcel process.env). Matches
            // kiosk-interface. Local/dev without ARG is 'unknown'. Searchable on spans
            // as resource service.version (see Coralogix process/resource tags).
            "service.version": typeof process !== "undefined" && process.env && "5223b019d9143462d282b5516469a3abdb64b4d2" || "unknown"
        });
        const exporter = new (0, _exporterTraceOtlpHttp.OTLPTraceExporter)({
            url: OTLP_TRACES_URL
        });
        const provider = new (0, _sdkTraceWeb.WebTracerProvider)({
            resource
        });
        provider.addSpanProcessor(new (0, _sdkTraceBase.BatchSpanProcessor)(exporter));
        // Global mutation boundary: after this, retries must not call register() again.
        provider.register();
        otelInitState = OTEL_INIT_STATE.GLOBAL_REGISTERED;
        (0, _instrumentation.registerInstrumentations)({
            instrumentations: [
                new (0, _instrumentationFetch.FetchInstrumentation)({
                    propagateTraceHeaderCorsUrls: TRACE_PROPAGATION_URL_PATTERNS
                }),
                new (0, _instrumentationXmlHttpRequest.XMLHttpRequestInstrumentation)({
                    propagateTraceHeaderCorsUrls: TRACE_PROPAGATION_URL_PATTERNS
                })
            ]
        });
        otelInitState = OTEL_INIT_STATE.COMPLETE;
    // No success console.log — avoid kiosk/prod DevTools noise. Spans in
    // Coralogix are the signal that init worked.
    } catch (error) {
        // not_started → allow a later full retry (e.g. construction failed before register).
        // global_registered → leave as-is so we never double-register the global API.
        console.error("[OpenTelemetry] Failed to initialize instrumentation:", error);
    }
}
function OpenTelemetryGate({ children }) {
    const ldClient = (0, _launchdarklyReactClientSdk.useLDClient)();
    const [ready, setReady] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (!ldClient) return;
        let enabled = false;
        try {
            // variationDetail (rather than plain variation) also returns the
            // evaluation reason (e.g. RULE_MATCH, FALLTHROUGH, OFF, or ERROR).
            const detail = ldClient.variationDetail(OTEL_LD_FLAG, false);
            enabled = Boolean(detail.value);
        } catch (error) {
            console.warn(`[OpenTelemetry] LD flag '${OTEL_LD_FLAG}' evaluation failed; skipping instrumentation`, error);
            enabled = false;
        }
        if (enabled) initOpenTelemetry();
        setReady(true);
    }, [
        ldClient
    ]);
    if (!ready) return null;
    return children;
}

},{"3e8bfa4e22211294":"h0XoY","react":"d8NEQ","launchdarkly-react-client-sdk":"3xmjG","@opentelemetry/sdk-trace-web":"c1wmU","@opentelemetry/sdk-trace-base":"jBq8v","@opentelemetry/exporter-trace-otlp-http":"bDWf4","@opentelemetry/resources":"8PpPi","@opentelemetry/instrumentation":"7NsZS","@opentelemetry/instrumentation-fetch":"2wiMH","@opentelemetry/instrumentation-xml-http-request":"759Vk","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c1wmU":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _webTracerProvider = require("./WebTracerProvider");
parcelHelpers.exportAll(_webTracerProvider, exports);
var _stackContextManager = require("./StackContextManager");
parcelHelpers.exportAll(_stackContextManager, exports);
var _performanceTimingNames = require("./enums/PerformanceTimingNames");
parcelHelpers.exportAll(_performanceTimingNames, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);
var _sdkTraceBase = require("@opentelemetry/sdk-trace-base");
parcelHelpers.exportAll(_sdkTraceBase, exports);

},{"./WebTracerProvider":"4nxdE","./StackContextManager":"3sfrI","./enums/PerformanceTimingNames":"aK78g","./types":"6Wh45","./utils":"k6Gwi","@opentelemetry/sdk-trace-base":"jBq8v","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4nxdE":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WebTracerProvider", ()=>WebTracerProvider);
var _sdkTraceBase = require("@opentelemetry/sdk-trace-base");
var _stackContextManager = require("./StackContextManager");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This class represents a web tracer with {@link StackContextManager}
 */ var WebTracerProvider = /** @class */ function(_super) {
    __extends(WebTracerProvider, _super);
    /**
     * Constructs a new Tracer instance.
     * @param config Web Tracer config
     */ function WebTracerProvider(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, config) || this;
        if (config.contextManager) throw "contextManager should be defined in register method not in constructor";
        if (config.propagator) throw "propagator should be defined in register method not in constructor";
        return _this;
    }
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ WebTracerProvider.prototype.register = function(config) {
        if (config === void 0) config = {};
        if (config.contextManager === undefined) config.contextManager = new (0, _stackContextManager.StackContextManager)();
        if (config.contextManager) config.contextManager.enable();
        _super.prototype.register.call(this, config);
    };
    return WebTracerProvider;
}((0, _sdkTraceBase.BasicTracerProvider));

},{"@opentelemetry/sdk-trace-base":"jBq8v","./StackContextManager":"3sfrI","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jBq8v":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tracer = require("./Tracer");
parcelHelpers.exportAll(_tracer, exports);
var _basicTracerProvider = require("./BasicTracerProvider");
parcelHelpers.exportAll(_basicTracerProvider, exports);
var _platform = require("./platform");
parcelHelpers.exportAll(_platform, exports);
var _consoleSpanExporter = require("./export/ConsoleSpanExporter");
parcelHelpers.exportAll(_consoleSpanExporter, exports);
var _inMemorySpanExporter = require("./export/InMemorySpanExporter");
parcelHelpers.exportAll(_inMemorySpanExporter, exports);
var _readableSpan = require("./export/ReadableSpan");
parcelHelpers.exportAll(_readableSpan, exports);
var _simpleSpanProcessor = require("./export/SimpleSpanProcessor");
parcelHelpers.exportAll(_simpleSpanProcessor, exports);
var _spanExporter = require("./export/SpanExporter");
parcelHelpers.exportAll(_spanExporter, exports);
var _noopSpanProcessor = require("./export/NoopSpanProcessor");
parcelHelpers.exportAll(_noopSpanProcessor, exports);
var _alwaysOffSampler = require("./sampler/AlwaysOffSampler");
parcelHelpers.exportAll(_alwaysOffSampler, exports);
var _alwaysOnSampler = require("./sampler/AlwaysOnSampler");
parcelHelpers.exportAll(_alwaysOnSampler, exports);
var _parentBasedSampler = require("./sampler/ParentBasedSampler");
parcelHelpers.exportAll(_parentBasedSampler, exports);
var _traceIdRatioBasedSampler = require("./sampler/TraceIdRatioBasedSampler");
parcelHelpers.exportAll(_traceIdRatioBasedSampler, exports);
var _sampler = require("./Sampler");
parcelHelpers.exportAll(_sampler, exports);
var _span = require("./Span");
parcelHelpers.exportAll(_span, exports);
var _spanProcessor = require("./SpanProcessor");
parcelHelpers.exportAll(_spanProcessor, exports);
var _timedEvent = require("./TimedEvent");
parcelHelpers.exportAll(_timedEvent, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _idGenerator = require("./IdGenerator");
parcelHelpers.exportAll(_idGenerator, exports);

},{"./Tracer":"kp9iu","./BasicTracerProvider":"lTXka","./platform":"6Ax2I","./export/ConsoleSpanExporter":"fWnSF","./export/InMemorySpanExporter":"3cglR","./export/ReadableSpan":"1DDuF","./export/SimpleSpanProcessor":"7Qw05","./export/SpanExporter":"5YEvj","./export/NoopSpanProcessor":"aerQY","./sampler/AlwaysOffSampler":"fQowp","./sampler/AlwaysOnSampler":"4sQG9","./sampler/ParentBasedSampler":"l4WJN","./sampler/TraceIdRatioBasedSampler":"lP9gS","./Sampler":"b9cF9","./Span":"7NQb2","./SpanProcessor":"4Tt7O","./TimedEvent":"33oAK","./types":"6s8Za","./IdGenerator":"7tUsL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kp9iu":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tracer", ()=>Tracer);
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
var _span = require("./Span");
var _utility = require("./utility");
var _platform = require("./platform");
/**
 * This class represents a basic tracer.
 */ var Tracer = /** @class */ function() {
    /**
     * Constructs a new Tracer instance.
     */ function Tracer(instrumentationLibrary, config, _tracerProvider) {
        this._tracerProvider = _tracerProvider;
        var localConfig = (0, _utility.mergeConfig)(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new (0, _platform.RandomIdGenerator)();
        this.resource = _tracerProvider.resource;
        this.instrumentationLibrary = instrumentationLibrary;
    }
    /**
     * Starts a new Span or returns the default NoopSpan based on the sampling
     * decision.
     */ Tracer.prototype.startSpan = function(name, options, context) {
        var _a, _b, _c;
        if (options === void 0) options = {};
        if (context === void 0) context = _api.context.active();
        // remove span from context in case a root span is requested via options
        if (options.root) context = _api.trace.deleteSpan(context);
        var parentSpan = _api.trace.getSpan(context);
        if ((0, _core.isTracingSuppressed)(context)) {
            _api.diag.debug("Instrumentation suppressed, returning Noop Span");
            var nonRecordingSpan = _api.trace.wrapSpanContext(_api.INVALID_SPAN_CONTEXT);
            return nonRecordingSpan;
        }
        var parentSpanContext = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext();
        var spanId = this._idGenerator.generateSpanId();
        var traceId;
        var traceState;
        var parentSpanId;
        if (!parentSpanContext || !_api.trace.isSpanContextValid(parentSpanContext)) // New root span.
        traceId = this._idGenerator.generateTraceId();
        else {
            // New child span.
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            parentSpanId = parentSpanContext.spanId;
        }
        var spanKind = (_a = options.kind) !== null && _a !== void 0 ? _a : _api.SpanKind.INTERNAL;
        var links = ((_b = options.links) !== null && _b !== void 0 ? _b : []).map(function(link) {
            return {
                context: link.context,
                attributes: (0, _core.sanitizeAttributes)(link.attributes)
            };
        });
        var attributes = (0, _core.sanitizeAttributes)(options.attributes);
        // make sampling decision
        var samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        traceState = (_c = samplingResult.traceState) !== null && _c !== void 0 ? _c : traceState;
        var traceFlags = samplingResult.decision === _api.SamplingDecision.RECORD_AND_SAMPLED ? _api.TraceFlags.SAMPLED : _api.TraceFlags.NONE;
        var spanContext = {
            traceId: traceId,
            spanId: spanId,
            traceFlags: traceFlags,
            traceState: traceState
        };
        if (samplingResult.decision === _api.SamplingDecision.NOT_RECORD) {
            _api.diag.debug("Recording is off, propagating context in a non-recording span");
            var nonRecordingSpan = _api.trace.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        // Set initial span attributes. The attributes object may have been mutated
        // by the sampler, so we sanitize the merged attributes before setting them.
        var initAttributes = (0, _core.sanitizeAttributes)(Object.assign(attributes, samplingResult.attributes));
        var span = new (0, _span.Span)(this, context, name, spanContext, spanKind, parentSpanId, links, options.startTime, undefined, initAttributes);
        return span;
    };
    Tracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : _api.context.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = _api.trace.setSpan(parentContext, span);
        return _api.context.with(contextWithSpanSet, fn, undefined, span);
    };
    /** Returns the active {@link GeneralLimits}. */ Tracer.prototype.getGeneralLimits = function() {
        return this._generalLimits;
    };
    /** Returns the active {@link SpanLimits}. */ Tracer.prototype.getSpanLimits = function() {
        return this._spanLimits;
    };
    Tracer.prototype.getActiveSpanProcessor = function() {
        return this._tracerProvider.getActiveSpanProcessor();
    };
    return Tracer;
}();

},{"@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","./Span":"7NQb2","./utility":"k2KV8","./platform":"6Ax2I","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4682l":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baggageEntryMetadataFromString", ()=>(0, _utils.baggageEntryMetadataFromString));
// Context APIs
parcelHelpers.export(exports, "createContextKey", ()=>(0, _context.createContextKey));
parcelHelpers.export(exports, "ROOT_CONTEXT", ()=>(0, _context.ROOT_CONTEXT));
// Diag APIs
parcelHelpers.export(exports, "DiagConsoleLogger", ()=>(0, _consoleLogger.DiagConsoleLogger));
parcelHelpers.export(exports, "DiagLogLevel", ()=>(0, _types.DiagLogLevel));
// Metrics APIs
parcelHelpers.export(exports, "createNoopMeter", ()=>(0, _noopMeter.createNoopMeter));
parcelHelpers.export(exports, "ValueType", ()=>(0, _metric.ValueType));
// Propagation APIs
parcelHelpers.export(exports, "defaultTextMapGetter", ()=>(0, _textMapPropagator.defaultTextMapGetter));
parcelHelpers.export(exports, "defaultTextMapSetter", ()=>(0, _textMapPropagator.defaultTextMapSetter));
parcelHelpers.export(exports, "ProxyTracer", ()=>(0, _proxyTracer.ProxyTracer));
parcelHelpers.export(exports, "ProxyTracerProvider", ()=>(0, _proxyTracerProvider.ProxyTracerProvider));
parcelHelpers.export(exports, "SamplingDecision", ()=>(0, _samplingResult.SamplingDecision));
parcelHelpers.export(exports, "SpanKind", ()=>(0, _spanKind.SpanKind));
parcelHelpers.export(exports, "SpanStatusCode", ()=>(0, _status.SpanStatusCode));
parcelHelpers.export(exports, "TraceFlags", ()=>(0, _traceFlags.TraceFlags));
parcelHelpers.export(exports, "createTraceState", ()=>(0, _utils1.createTraceState));
parcelHelpers.export(exports, "isSpanContextValid", ()=>(0, _spancontextUtils.isSpanContextValid));
parcelHelpers.export(exports, "isValidTraceId", ()=>(0, _spancontextUtils.isValidTraceId));
parcelHelpers.export(exports, "isValidSpanId", ()=>(0, _spancontextUtils.isValidSpanId));
parcelHelpers.export(exports, "INVALID_SPANID", ()=>(0, _invalidSpanConstants.INVALID_SPANID));
parcelHelpers.export(exports, "INVALID_TRACEID", ()=>(0, _invalidSpanConstants.INVALID_TRACEID));
parcelHelpers.export(exports, "INVALID_SPAN_CONTEXT", ()=>(0, _invalidSpanConstants.INVALID_SPAN_CONTEXT));
// Named export.
parcelHelpers.export(exports, "context", ()=>(0, _contextApi.context));
parcelHelpers.export(exports, "diag", ()=>(0, _diagApi.diag));
parcelHelpers.export(exports, "metrics", ()=>(0, _metricsApi.metrics));
parcelHelpers.export(exports, "propagation", ()=>(0, _propagationApi.propagation));
parcelHelpers.export(exports, "trace", ()=>(0, _traceApi.trace));
var _utils = require("./baggage/utils");
var _context = require("./context/context");
var _consoleLogger = require("./diag/consoleLogger");
var _types = require("./diag/types");
var _noopMeter = require("./metrics/NoopMeter");
var _metric = require("./metrics/Metric");
var _textMapPropagator = require("./propagation/TextMapPropagator");
var _proxyTracer = require("./trace/ProxyTracer");
var _proxyTracerProvider = require("./trace/ProxyTracerProvider");
var _samplingResult = require("./trace/SamplingResult");
var _spanKind = require("./trace/span_kind");
var _status = require("./trace/status");
var _traceFlags = require("./trace/trace_flags");
var _utils1 = require("./trace/internal/utils");
var _spancontextUtils = require("./trace/spancontext-utils");
var _invalidSpanConstants = require("./trace/invalid-span-constants");
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var _contextApi = require("./context-api");
var _diagApi = require("./diag-api");
var _metricsApi = require("./metrics-api");
var _propagationApi = require("./propagation-api");
var _traceApi = require("./trace-api");
// Default export.
exports.default = {
    context: (0, _contextApi.context),
    diag: (0, _diagApi.diag),
    metrics: (0, _metricsApi.metrics),
    propagation: (0, _propagationApi.propagation),
    trace: (0, _traceApi.trace)
};

},{"./baggage/utils":"bQQ2B","./context/context":"vp7V0","./diag/consoleLogger":"blfS8","./diag/types":"43EO1","./metrics/NoopMeter":"hwZgL","./metrics/Metric":"56Bjk","./propagation/TextMapPropagator":"JsfTB","./trace/ProxyTracer":"a3ucp","./trace/ProxyTracerProvider":"bgNxK","./trace/SamplingResult":"2XpyN","./trace/span_kind":"02klq","./trace/status":"adoa4","./trace/trace_flags":"a8FmI","./trace/internal/utils":"FAAwU","./trace/spancontext-utils":"57HG4","./trace/invalid-span-constants":"dEbfg","./context-api":"dU9C3","./diag-api":"knWjU","./metrics-api":"dtAjq","./propagation-api":"g28Sy","./trace-api":"4ESbE","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bQQ2B":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a new Baggage with optional entries
 *
 * @param entries An array of baggage entries the new baggage should contain
 */ parcelHelpers.export(exports, "createBaggage", ()=>createBaggage);
/**
 * Create a serializable BaggageEntryMetadata object from a string.
 *
 * @param str string metadata. Format is currently not defined by the spec and has no special meaning.
 *
 */ parcelHelpers.export(exports, "baggageEntryMetadataFromString", ()=>baggageEntryMetadataFromString);
var _diag = require("../api/diag");
var _baggageImpl = require("./internal/baggage-impl");
var _symbol = require("./internal/symbol");
var diag = (0, _diag.DiagAPI).instance();
function createBaggage(entries) {
    if (entries === void 0) entries = {};
    return new (0, _baggageImpl.BaggageImpl)(new Map(Object.entries(entries)));
}
function baggageEntryMetadataFromString(str) {
    if (typeof str !== "string") {
        diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = "";
    }
    return {
        __TYPE__: (0, _symbol.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

},{"../api/diag":"jJ4Ef","./internal/baggage-impl":"4rXZE","./internal/symbol":"95ucJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jJ4Ef":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagAPI", ()=>DiagAPI);
var _componentLogger = require("../diag/ComponentLogger");
var _logLevelLogger = require("../diag/internal/logLevelLogger");
var _types = require("../diag/types");
var _globalUtils = require("../internal/global-utils");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME = "diag";
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var DiagAPI = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, _globalUtils.getGlobal)("diag");
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, __spreadArray([], __read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, _types.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, _globalUtils.getGlobal)("diag");
            var newLogger = (0, _logLevelLogger.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, _types.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, _globalUtils.registerGlobal)("diag", newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, _globalUtils.unregisterGlobal)(API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, _componentLogger.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy("verbose");
        self.debug = _logProxy("debug");
        self.info = _logProxy("info");
        self.warn = _logProxy("warn");
        self.error = _logProxy("error");
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

},{"../diag/ComponentLogger":"kSjWD","../diag/internal/logLevelLogger":"53nsg","../diag/types":"43EO1","../internal/global-utils":"e9fOf","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kSjWD":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagComponentLogger", ()=>DiagComponentLogger);
var _globalUtils = require("../internal/global-utils");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var DiagComponentLogger = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || "DiagComponentLogger";
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy("debug", this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy("error", this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy("info", this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy("warn", this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return logProxy("verbose", this._namespace, args);
    };
    return DiagComponentLogger;
}();
function logProxy(funcName, namespace, args) {
    var logger = (0, _globalUtils.getGlobal)("diag");
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, __spreadArray([], __read(args), false));
}

},{"../internal/global-utils":"e9fOf","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"e9fOf":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerGlobal", ()=>registerGlobal);
parcelHelpers.export(exports, "getGlobal", ()=>getGlobal);
parcelHelpers.export(exports, "unregisterGlobal", ()=>unregisterGlobal);
var _platform = require("../platform");
var _version = require("../version");
var _semver = require("./semver");
var major = (0, _version.VERSION).split(".")[0];
var GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + major);
var _global = (0, _platform._globalThis);
function registerGlobal(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = _global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, _version.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, _version.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, _version.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, _version.VERSION) + ".");
    return true;
}
function getGlobal(type) {
    var _a, _b;
    var globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, _semver.isCompatible)(globalVersion)) return;
    return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, _version.VERSION) + ".");
    var api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

},{"../platform":"lTaFm","../version":"km0az","./semver":"LVlZo","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lTaFm":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _globalThis = require("./globalThis");
parcelHelpers.exportAll(_globalThis, exports);

},{"./globalThis":"36khD","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"36khD":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_globalThis", ()=>_globalThis);
var global = arguments[3];
var _globalThis = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof global === "object" ? global : {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"km0az":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
var VERSION = "1.9.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"LVlZo":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Create a function to test an API version to see if it is compatible with the provided ownVersion.
 *
 * The returned function has the following semantics:
 * - Exact match is always compatible
 * - Major versions must match exactly
 *    - 1.x package cannot use global 2.x package
 *    - 2.x package cannot use global 1.x package
 * - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
 *    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
 *    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
 * - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
 * - Patch and build tag differences are not considered at this time
 *
 * @param ownVersion version which should be checked against
 */ parcelHelpers.export(exports, "_makeCompatibilityCheck", ()=>_makeCompatibilityCheck);
parcelHelpers.export(exports, "isCompatible", ()=>isCompatible);
var _version = require("../version");
var re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function _makeCompatibilityCheck(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match(re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match(re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var isCompatible = _makeCompatibilityCheck((0, _version.VERSION));

},{"../version":"km0az","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"53nsg":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createLogLevelDiagLogger", ()=>createLogLevelDiagLogger);
var _types = require("../types");
function createLogLevelDiagLogger(maxLevel, logger) {
    if (maxLevel < (0, _types.DiagLogLevel).NONE) maxLevel = (0, _types.DiagLogLevel).NONE;
    else if (maxLevel > (0, _types.DiagLogLevel).ALL) maxLevel = (0, _types.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc("error", (0, _types.DiagLogLevel).ERROR),
        warn: _filterFunc("warn", (0, _types.DiagLogLevel).WARN),
        info: _filterFunc("info", (0, _types.DiagLogLevel).INFO),
        debug: _filterFunc("debug", (0, _types.DiagLogLevel).DEBUG),
        verbose: _filterFunc("verbose", (0, _types.DiagLogLevel).VERBOSE)
    };
}

},{"../types":"43EO1","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"43EO1":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagLogLevel", ()=>DiagLogLevel);
var DiagLogLevel;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel || (DiagLogLevel = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4rXZE":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaggageImpl", ()=>BaggageImpl);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var BaggageImpl = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"95ucJ":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baggageEntryMetadataSymbol", ()=>baggageEntryMetadataSymbol);
var baggageEntryMetadataSymbol = Symbol("BaggageEntryMetadata");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"vp7V0":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createContextKey", ()=>createContextKey);
parcelHelpers.export(exports, "ROOT_CONTEXT", ()=>ROOT_CONTEXT);
function createContextKey(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var ROOT_CONTEXT = new BaseContext();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"blfS8":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DiagConsoleLogger", ()=>DiagConsoleLogger);
var consoleMap = [
    {
        n: "error",
        c: "error"
    },
    {
        n: "warn",
        c: "warn"
    },
    {
        n: "info",
        c: "info"
    },
    {
        n: "debug",
        c: "debug"
    },
    {
        n: "verbose",
        c: "trace"
    }
];
/**
 * A simple Immutable Console based diagnostic logger which will output any messages to the Console.
 * If you want to limit the amount of logging to a specific level or lower use the
 * {@link createLogLevelDiagLogger}
 */ var DiagConsoleLogger = /** @class */ function() {
    function DiagConsoleLogger() {
        function _consoleFunc(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                if (console) {
                    // Some environments only expose the console when the F12 developer console is open
                    // eslint-disable-next-line no-console
                    var theFunc = console[funcName];
                    if (typeof theFunc !== "function") // Not all environments support all functions
                    // eslint-disable-next-line no-console
                    theFunc = console.log;
                    // One last final check
                    if (typeof theFunc === "function") return theFunc.apply(console, args);
                }
            };
        }
        for(var i = 0; i < consoleMap.length; i++)this[consoleMap[i].n] = _consoleFunc(consoleMap[i].c);
    }
    return DiagConsoleLogger;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hwZgL":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopMeter", ()=>NoopMeter);
parcelHelpers.export(exports, "NoopMetric", ()=>NoopMetric);
parcelHelpers.export(exports, "NoopCounterMetric", ()=>NoopCounterMetric);
parcelHelpers.export(exports, "NoopUpDownCounterMetric", ()=>NoopUpDownCounterMetric);
parcelHelpers.export(exports, "NoopGaugeMetric", ()=>NoopGaugeMetric);
parcelHelpers.export(exports, "NoopHistogramMetric", ()=>NoopHistogramMetric);
parcelHelpers.export(exports, "NoopObservableMetric", ()=>NoopObservableMetric);
parcelHelpers.export(exports, "NoopObservableCounterMetric", ()=>NoopObservableCounterMetric);
parcelHelpers.export(exports, "NoopObservableGaugeMetric", ()=>NoopObservableGaugeMetric);
parcelHelpers.export(exports, "NoopObservableUpDownCounterMetric", ()=>NoopObservableUpDownCounterMetric);
parcelHelpers.export(exports, "NOOP_METER", ()=>NOOP_METER);
parcelHelpers.export(exports, "NOOP_COUNTER_METRIC", ()=>NOOP_COUNTER_METRIC);
parcelHelpers.export(exports, "NOOP_GAUGE_METRIC", ()=>NOOP_GAUGE_METRIC);
parcelHelpers.export(exports, "NOOP_HISTOGRAM_METRIC", ()=>NOOP_HISTOGRAM_METRIC);
parcelHelpers.export(exports, "NOOP_UP_DOWN_COUNTER_METRIC", ()=>NOOP_UP_DOWN_COUNTER_METRIC);
parcelHelpers.export(exports, "NOOP_OBSERVABLE_COUNTER_METRIC", ()=>NOOP_OBSERVABLE_COUNTER_METRIC);
parcelHelpers.export(exports, "NOOP_OBSERVABLE_GAUGE_METRIC", ()=>NOOP_OBSERVABLE_GAUGE_METRIC);
parcelHelpers.export(exports, "NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC", ()=>NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC);
/**
 * Create a no-op Meter
 */ parcelHelpers.export(exports, "createNoopMeter", ()=>createNoopMeter);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var NoopMeter = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return NOOP_GAUGE_METRIC;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return NOOP_HISTOGRAM_METRIC;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return NOOP_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return NOOP_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return NOOP_OBSERVABLE_GAUGE_METRIC;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return NOOP_OBSERVABLE_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var NoopMetric = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var NoopCounterMetric = /** @class */ function(_super) {
    __extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}(NoopMetric);
var NoopUpDownCounterMetric = /** @class */ function(_super) {
    __extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}(NoopMetric);
var NoopGaugeMetric = /** @class */ function(_super) {
    __extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}(NoopMetric);
var NoopHistogramMetric = /** @class */ function(_super) {
    __extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}(NoopMetric);
var NoopObservableMetric = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var NoopObservableCounterMetric = /** @class */ function(_super) {
    __extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}(NoopObservableMetric);
var NoopObservableGaugeMetric = /** @class */ function(_super) {
    __extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}(NoopObservableMetric);
var NoopObservableUpDownCounterMetric = /** @class */ function(_super) {
    __extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}(NoopObservableMetric);
var NOOP_METER = new NoopMeter();
var NOOP_COUNTER_METRIC = new NoopCounterMetric();
var NOOP_GAUGE_METRIC = new NoopGaugeMetric();
var NOOP_HISTOGRAM_METRIC = new NoopHistogramMetric();
var NOOP_UP_DOWN_COUNTER_METRIC = new NoopUpDownCounterMetric();
var NOOP_OBSERVABLE_COUNTER_METRIC = new NoopObservableCounterMetric();
var NOOP_OBSERVABLE_GAUGE_METRIC = new NoopObservableGaugeMetric();
var NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC = new NoopObservableUpDownCounterMetric();
function createNoopMeter() {
    return NOOP_METER;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"56Bjk":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Type of value. It describes how the data is reported. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValueType", ()=>ValueType);
var ValueType;
(function(ValueType) {
    ValueType[ValueType["INT"] = 0] = "INT";
    ValueType[ValueType["DOUBLE"] = 1] = "DOUBLE";
})(ValueType || (ValueType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"JsfTB":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTextMapGetter", ()=>defaultTextMapGetter);
parcelHelpers.export(exports, "defaultTextMapSetter", ()=>defaultTextMapSetter);
var defaultTextMapGetter = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var defaultTextMapSetter = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a3ucp":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProxyTracer", ()=>ProxyTracer);
var _noopTracer = require("./NoopTracer");
var NOOP_TRACER = new (0, _noopTracer.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var ProxyTracer = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

},{"./NoopTracer":"6EFti","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6EFti":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTracer", ()=>NoopTracer);
var _context = require("../api/context");
var _contextUtils = require("../trace/context-utils");
var _nonRecordingSpan = require("./NonRecordingSpan");
var _spancontextUtils = require("./spancontext-utils");
var contextApi = (0, _context.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var NoopTracer = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, _nonRecordingSpan.NonRecordingSpan)();
        var parentFromContext = context && (0, _contextUtils.getSpanContext)(context);
        if (isSpanContext(parentFromContext) && (0, _spancontextUtils.isSpanContextValid)(parentFromContext)) return new (0, _nonRecordingSpan.NonRecordingSpan)(parentFromContext);
        else return new (0, _nonRecordingSpan.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, _contextUtils.setSpan)(parentContext, span);
        return contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function isSpanContext(spanContext) {
    return typeof spanContext === "object" && typeof spanContext["spanId"] === "string" && typeof spanContext["traceId"] === "string" && typeof spanContext["traceFlags"] === "number";
}

},{"../api/context":"3fcgE","../trace/context-utils":"ct7bR","./NonRecordingSpan":"YqwzE","./spancontext-utils":"57HG4","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3fcgE":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextAPI", ()=>ContextAPI);
var _noopContextManager = require("../context/NoopContextManager");
var _globalUtils = require("../internal/global-utils");
var _diag = require("./diag");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME = "context";
var NOOP_CONTEXT_MANAGER = new (0, _noopContextManager.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var ContextAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, _globalUtils.registerGlobal)(API_NAME, contextManager, (0, _diag.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, __spreadArray([
            context,
            fn,
            thisArg
        ], __read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
    };
    return ContextAPI;
}();

},{"../context/NoopContextManager":"7p7Lp","../internal/global-utils":"e9fOf","./diag":"jJ4Ef","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7p7Lp":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopContextManager", ()=>NoopContextManager);
var _context = require("./context");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var NoopContextManager = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, _context.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, __spreadArray([
            thisArg
        ], __read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

},{"./context":"vp7V0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ct7bR":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return the span if one exists
 *
 * @param context context to get span from
 */ parcelHelpers.export(exports, "getSpan", ()=>getSpan);
/**
 * Gets the span from the current context, if one exists.
 */ parcelHelpers.export(exports, "getActiveSpan", ()=>getActiveSpan);
/**
 * Set the span on a context
 *
 * @param context context to use as parent
 * @param span span to set active
 */ parcelHelpers.export(exports, "setSpan", ()=>setSpan);
/**
 * Remove current span stored in the context
 *
 * @param context context to delete span from
 */ parcelHelpers.export(exports, "deleteSpan", ()=>deleteSpan);
/**
 * Wrap span context in a NoopSpan and set as span in a new
 * context
 *
 * @param context context to set active span on
 * @param spanContext span context to be wrapped
 */ parcelHelpers.export(exports, "setSpanContext", ()=>setSpanContext);
/**
 * Get the span context of the span if it exists.
 *
 * @param context context to get values from
 */ parcelHelpers.export(exports, "getSpanContext", ()=>getSpanContext);
var _context = require("../context/context");
var _nonRecordingSpan = require("./NonRecordingSpan");
var _context1 = require("../api/context");
/**
 * span key
 */ var SPAN_KEY = (0, _context.createContextKey)("OpenTelemetry Context Key SPAN");
function getSpan(context) {
    return context.getValue(SPAN_KEY) || undefined;
}
function getActiveSpan() {
    return getSpan((0, _context1.ContextAPI).getInstance().active());
}
function setSpan(context, span) {
    return context.setValue(SPAN_KEY, span);
}
function deleteSpan(context) {
    return context.deleteValue(SPAN_KEY);
}
function setSpanContext(context, spanContext) {
    return setSpan(context, new (0, _nonRecordingSpan.NonRecordingSpan)(spanContext));
}
function getSpanContext(context) {
    var _a;
    return (_a = getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

},{"../context/context":"vp7V0","./NonRecordingSpan":"YqwzE","../api/context":"3fcgE","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"YqwzE":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NonRecordingSpan", ()=>NonRecordingSpan);
var _invalidSpanConstants = require("./invalid-span-constants");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var NonRecordingSpan = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, _invalidSpanConstants.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

},{"./invalid-span-constants":"dEbfg","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dEbfg":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INVALID_SPANID", ()=>INVALID_SPANID);
parcelHelpers.export(exports, "INVALID_TRACEID", ()=>INVALID_TRACEID);
parcelHelpers.export(exports, "INVALID_SPAN_CONTEXT", ()=>INVALID_SPAN_CONTEXT);
var _traceFlags = require("./trace_flags");
var INVALID_SPANID = "0000000000000000";
var INVALID_TRACEID = "00000000000000000000000000000000";
var INVALID_SPAN_CONTEXT = {
    traceId: INVALID_TRACEID,
    spanId: INVALID_SPANID,
    traceFlags: (0, _traceFlags.TraceFlags).NONE
};

},{"./trace_flags":"a8FmI","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a8FmI":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceFlags", ()=>TraceFlags);
var TraceFlags;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags || (TraceFlags = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"57HG4":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidTraceId", ()=>isValidTraceId);
parcelHelpers.export(exports, "isValidSpanId", ()=>isValidSpanId);
/**
 * Returns true if this {@link SpanContext} is valid.
 * @return true if this {@link SpanContext} is valid.
 */ parcelHelpers.export(exports, "isSpanContextValid", ()=>isSpanContextValid);
/**
 * Wrap the given {@link SpanContext} in a new non-recording {@link Span}
 *
 * @param spanContext span context to be wrapped
 * @returns a new non-recording {@link Span} with the provided context
 */ parcelHelpers.export(exports, "wrapSpanContext", ()=>wrapSpanContext);
var _invalidSpanConstants = require("./invalid-span-constants");
var _nonRecordingSpan = require("./NonRecordingSpan");
var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function isValidTraceId(traceId) {
    return VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, _invalidSpanConstants.INVALID_TRACEID);
}
function isValidSpanId(spanId) {
    return VALID_SPANID_REGEX.test(spanId) && spanId !== (0, _invalidSpanConstants.INVALID_SPANID);
}
function isSpanContextValid(spanContext) {
    return isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId);
}
function wrapSpanContext(spanContext) {
    return new (0, _nonRecordingSpan.NonRecordingSpan)(spanContext);
}

},{"./invalid-span-constants":"dEbfg","./NonRecordingSpan":"YqwzE","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bgNxK":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProxyTracerProvider", ()=>ProxyTracerProvider);
var _proxyTracer = require("./ProxyTracer");
var _noopTracerProvider = require("./NoopTracerProvider");
var NOOP_TRACER_PROVIDER = new (0, _noopTracerProvider.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var ProxyTracerProvider = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, _proxyTracer.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

},{"./ProxyTracer":"a3ucp","./NoopTracerProvider":"eFu11","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eFu11":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTracerProvider", ()=>NoopTracerProvider);
var _noopTracer = require("./NoopTracer");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var NoopTracerProvider = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, _noopTracer.NoopTracer)();
    };
    return NoopTracerProvider;
}();

},{"./NoopTracer":"6EFti","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2XpyN":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @deprecated use the one declared in @opentelemetry/sdk-trace-base instead.
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SamplingDecision", ()=>SamplingDecision);
var SamplingDecision;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})(SamplingDecision || (SamplingDecision = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"02klq":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpanKind", ()=>SpanKind);
var SpanKind;
(function(SpanKind) {
    /** Default value. Indicates that the span is used internally. */ SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Indicates that the span covers server-side handling of an RPC or other
     * remote request.
     */ SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    /**
     * Indicates that the span covers the client-side wrapper around an RPC or
     * other remote request.
     */ SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    /**
     * Indicates that the span describes producer sending a message to a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    /**
     * Indicates that the span describes consumer receiving a message from a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})(SpanKind || (SpanKind = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"adoa4":[function(require,module,exports) {
/**
 * An enumeration of status codes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpanStatusCode", ()=>SpanStatusCode);
var SpanStatusCode;
(function(SpanStatusCode) {
    /**
     * The default status.
     */ SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */ SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */ SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})(SpanStatusCode || (SpanStatusCode = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"FAAwU":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createTraceState", ()=>createTraceState);
var _tracestateImpl = require("./tracestate-impl");
function createTraceState(rawTraceState) {
    return new (0, _tracestateImpl.TraceStateImpl)(rawTraceState);
}

},{"./tracestate-impl":"eQWLN","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eQWLN":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceStateImpl", ()=>TraceStateImpl);
var _tracestateValidators = require("./tracestate-validators");
var MAX_TRACE_STATE_ITEMS = 32;
var MAX_TRACE_STATE_LEN = 512;
var LIST_MEMBERS_SEPARATOR = ",";
var LIST_MEMBER_KEY_VALUE_SPLITTER = "=";
/**
 * TraceState must be a class and not a simple object type because of the spec
 * requirement (https://www.w3.org/TR/trace-context/#tracestate-field).
 *
 * Here is the list of allowed mutations:
 * - New key-value pair should be added into the beginning of the list
 * - The value of any key can be updated. Modified keys MUST be moved to the
 * beginning of the list.
 */ var TraceStateImpl = /** @class */ function() {
    function TraceStateImpl(rawTraceState) {
        this._internalState = new Map();
        if (rawTraceState) this._parse(rawTraceState);
    }
    TraceStateImpl.prototype.set = function(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        var traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    };
    TraceStateImpl.prototype.unset = function(key) {
        var traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    };
    TraceStateImpl.prototype.get = function(key) {
        return this._internalState.get(key);
    };
    TraceStateImpl.prototype.serialize = function() {
        var _this = this;
        return this._keys().reduce(function(agg, key) {
            agg.push(key + LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
            return agg;
        }, []).join(LIST_MEMBERS_SEPARATOR);
    };
    TraceStateImpl.prototype._parse = function(rawTraceState) {
        if (rawTraceState.length > MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split(LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce(function(agg, part) {
            var listMember = part.trim(); // Optional Whitespace (OWS) handling
            var i = listMember.indexOf(LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if ((0, _tracestateValidators.validateKey)(key) && (0, _tracestateValidators.validateValue)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, MAX_TRACE_STATE_ITEMS));
    };
    TraceStateImpl.prototype._keys = function() {
        return Array.from(this._internalState.keys()).reverse();
    };
    TraceStateImpl.prototype._clone = function() {
        var traceState = new TraceStateImpl();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    };
    return TraceStateImpl;
}();

},{"./tracestate-validators":"ak06A","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ak06A":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Key is opaque string up to 256 characters printable. It MUST begin with a
 * lowercase letter, and can only contain lowercase letters a-z, digits 0-9,
 * underscores _, dashes -, asterisks *, and forward slashes /.
 * For multi-tenant vendor scenarios, an at sign (@) can be used to prefix the
 * vendor name. Vendors SHOULD set the tenant ID at the beginning of the key.
 * see https://www.w3.org/TR/trace-context/#key
 */ parcelHelpers.export(exports, "validateKey", ()=>validateKey);
/**
 * Value is opaque string up to 256 characters printable ASCII RFC0020
 * characters (i.e., the range 0x20 to 0x7E) except comma , and =.
 */ parcelHelpers.export(exports, "validateValue", ()=>validateValue);
var VALID_KEY_CHAR_RANGE = "[_0-9a-z-*/]";
var VALID_KEY = "[a-z]" + VALID_KEY_CHAR_RANGE + "{0,255}";
var VALID_VENDOR_KEY = "[a-z0-9]" + VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + VALID_KEY_CHAR_RANGE + "{0,13}";
var VALID_KEY_REGEX = new RegExp("^(?:" + VALID_KEY + "|" + VALID_VENDOR_KEY + ")$");
var VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
var INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function validateKey(key) {
    return VALID_KEY_REGEX.test(key);
}
function validateValue(value) {
    return VALID_VALUE_BASE_REGEX.test(value) && !INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dU9C3":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "context", ()=>context);
var _context = require("./api/context");
var context = (0, _context.ContextAPI).getInstance();

},{"./api/context":"3fcgE","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"knWjU":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "diag", ()=>diag);
var _diag = require("./api/diag");
var diag = (0, _diag.DiagAPI).instance();

},{"./api/diag":"jJ4Ef","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dtAjq":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "metrics", ()=>metrics);
var _metrics = require("./api/metrics");
var metrics = (0, _metrics.MetricsAPI).getInstance();

},{"./api/metrics":"33d1h","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"33d1h":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetricsAPI", ()=>MetricsAPI);
var _noopMeterProvider = require("../metrics/NoopMeterProvider");
var _globalUtils = require("../internal/global-utils");
var _diag = require("./diag");
var API_NAME = "metrics";
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var MetricsAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, _globalUtils.registerGlobal)(API_NAME, provider, (0, _diag.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || (0, _noopMeterProvider.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
    };
    return MetricsAPI;
}();

},{"../metrics/NoopMeterProvider":"5mTi9","../internal/global-utils":"e9fOf","./diag":"jJ4Ef","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5mTi9":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopMeterProvider", ()=>NoopMeterProvider);
parcelHelpers.export(exports, "NOOP_METER_PROVIDER", ()=>NOOP_METER_PROVIDER);
var _noopMeter = require("./NoopMeter");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var NoopMeterProvider = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, _noopMeter.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var NOOP_METER_PROVIDER = new NoopMeterProvider();

},{"./NoopMeter":"hwZgL","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g28Sy":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propagation", ()=>propagation);
var _propagation = require("./api/propagation");
var propagation = (0, _propagation.PropagationAPI).getInstance();

},{"./api/propagation":"4YGHY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4YGHY":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PropagationAPI", ()=>PropagationAPI);
var _globalUtils = require("../internal/global-utils");
var _noopTextMapPropagator = require("../propagation/NoopTextMapPropagator");
var _textMapPropagator = require("../propagation/TextMapPropagator");
var _contextHelpers = require("../baggage/context-helpers");
var _utils = require("../baggage/utils");
var _diag = require("./diag");
var API_NAME = "propagation";
var NOOP_TEXT_MAP_PROPAGATOR = new (0, _noopTextMapPropagator.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var PropagationAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, _utils.createBaggage);
        this.getBaggage = (0, _contextHelpers.getBaggage);
        this.getActiveBaggage = (0, _contextHelpers.getActiveBaggage);
        this.setBaggage = (0, _contextHelpers.setBaggage);
        this.deleteBaggage = (0, _contextHelpers.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, _globalUtils.registerGlobal)(API_NAME, propagator, (0, _diag.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, _textMapPropagator.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, _textMapPropagator.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

},{"../internal/global-utils":"e9fOf","../propagation/NoopTextMapPropagator":"lkS7y","../propagation/TextMapPropagator":"JsfTB","../baggage/context-helpers":"apItu","../baggage/utils":"bQQ2B","./diag":"jJ4Ef","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lkS7y":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopTextMapPropagator", ()=>NoopTextMapPropagator);
var NoopTextMapPropagator = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"apItu":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Retrieve the current baggage from the given context
 *
 * @param {Context} Context that manage all context values
 * @returns {Baggage} Extracted baggage from the context
 */ parcelHelpers.export(exports, "getBaggage", ()=>getBaggage);
/**
 * Retrieve the current baggage from the active/current context
 *
 * @returns {Baggage} Extracted baggage from the context
 */ parcelHelpers.export(exports, "getActiveBaggage", ()=>getActiveBaggage);
/**
 * Store a baggage in the given context
 *
 * @param {Context} Context that manage all context values
 * @param {Baggage} baggage that will be set in the actual context
 */ parcelHelpers.export(exports, "setBaggage", ()=>setBaggage);
/**
 * Delete the baggage stored in the given context
 *
 * @param {Context} Context that manage all context values
 */ parcelHelpers.export(exports, "deleteBaggage", ()=>deleteBaggage);
var _context = require("../api/context");
var _context1 = require("../context/context");
/**
 * Baggage key
 */ var BAGGAGE_KEY = (0, _context1.createContextKey)("OpenTelemetry Baggage Key");
function getBaggage(context) {
    return context.getValue(BAGGAGE_KEY) || undefined;
}
function getActiveBaggage() {
    return getBaggage((0, _context.ContextAPI).getInstance().active());
}
function setBaggage(context, baggage) {
    return context.setValue(BAGGAGE_KEY, baggage);
}
function deleteBaggage(context) {
    return context.deleteValue(BAGGAGE_KEY);
}

},{"../api/context":"3fcgE","../context/context":"vp7V0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4ESbE":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trace", ()=>trace);
var _trace = require("./api/trace");
var trace = (0, _trace.TraceAPI).getInstance();

},{"./api/trace":"6l4PE","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6l4PE":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceAPI", ()=>TraceAPI);
var _globalUtils = require("../internal/global-utils");
var _proxyTracerProvider = require("../trace/ProxyTracerProvider");
var _spancontextUtils = require("../trace/spancontext-utils");
var _contextUtils = require("../trace/context-utils");
var _diag = require("./diag");
var API_NAME = "trace";
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var TraceAPI = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, _proxyTracerProvider.ProxyTracerProvider)();
        this.wrapSpanContext = (0, _spancontextUtils.wrapSpanContext);
        this.isSpanContextValid = (0, _spancontextUtils.isSpanContextValid);
        this.deleteSpan = (0, _contextUtils.deleteSpan);
        this.getSpan = (0, _contextUtils.getSpan);
        this.getActiveSpan = (0, _contextUtils.getActiveSpan);
        this.getSpanContext = (0, _contextUtils.getSpanContext);
        this.setSpan = (0, _contextUtils.setSpan);
        this.setSpanContext = (0, _contextUtils.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, _globalUtils.registerGlobal)(API_NAME, this._proxyTracerProvider, (0, _diag.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, _globalUtils.getGlobal)(API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, _globalUtils.unregisterGlobal)(API_NAME, (0, _diag.DiagAPI).instance());
        this._proxyTracerProvider = new (0, _proxyTracerProvider.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

},{"../internal/global-utils":"e9fOf","../trace/ProxyTracerProvider":"bgNxK","../trace/spancontext-utils":"57HG4","../trace/context-utils":"ct7bR","./diag":"jJ4Ef","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6xVk8":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "baggageUtils", ()=>_utils);
parcelHelpers.export(exports, "internal", ()=>internal);
var _w3CbaggagePropagator = require("./baggage/propagation/W3CBaggagePropagator");
parcelHelpers.exportAll(_w3CbaggagePropagator, exports);
var _anchoredClock = require("./common/anchored-clock");
parcelHelpers.exportAll(_anchoredClock, exports);
var _attributes = require("./common/attributes");
parcelHelpers.exportAll(_attributes, exports);
var _globalErrorHandler = require("./common/global-error-handler");
parcelHelpers.exportAll(_globalErrorHandler, exports);
var _loggingErrorHandler = require("./common/logging-error-handler");
parcelHelpers.exportAll(_loggingErrorHandler, exports);
var _time = require("./common/time");
parcelHelpers.exportAll(_time, exports);
var _types = require("./common/types");
parcelHelpers.exportAll(_types, exports);
var _hexToBinary = require("./common/hex-to-binary");
parcelHelpers.exportAll(_hexToBinary, exports);
var _exportResult = require("./ExportResult");
parcelHelpers.exportAll(_exportResult, exports);
var _utils = require("./baggage/utils");
var _platform = require("./platform");
parcelHelpers.exportAll(_platform, exports);
var _composite = require("./propagation/composite");
parcelHelpers.exportAll(_composite, exports);
var _w3CtraceContextPropagator = require("./trace/W3CTraceContextPropagator");
parcelHelpers.exportAll(_w3CtraceContextPropagator, exports);
var _idGenerator = require("./trace/IdGenerator");
parcelHelpers.exportAll(_idGenerator, exports);
var _rpcMetadata = require("./trace/rpc-metadata");
parcelHelpers.exportAll(_rpcMetadata, exports);
var _alwaysOffSampler = require("./trace/sampler/AlwaysOffSampler");
parcelHelpers.exportAll(_alwaysOffSampler, exports);
var _alwaysOnSampler = require("./trace/sampler/AlwaysOnSampler");
parcelHelpers.exportAll(_alwaysOnSampler, exports);
var _parentBasedSampler = require("./trace/sampler/ParentBasedSampler");
parcelHelpers.exportAll(_parentBasedSampler, exports);
var _traceIdRatioBasedSampler = require("./trace/sampler/TraceIdRatioBasedSampler");
parcelHelpers.exportAll(_traceIdRatioBasedSampler, exports);
var _suppressTracing = require("./trace/suppress-tracing");
parcelHelpers.exportAll(_suppressTracing, exports);
var _traceState = require("./trace/TraceState");
parcelHelpers.exportAll(_traceState, exports);
var _environment = require("./utils/environment");
parcelHelpers.exportAll(_environment, exports);
var _merge = require("./utils/merge");
parcelHelpers.exportAll(_merge, exports);
var _sampling = require("./utils/sampling");
parcelHelpers.exportAll(_sampling, exports);
var _timeout = require("./utils/timeout");
parcelHelpers.exportAll(_timeout, exports);
var _url = require("./utils/url");
parcelHelpers.exportAll(_url, exports);
var _wrap = require("./utils/wrap");
parcelHelpers.exportAll(_wrap, exports);
var _callback = require("./utils/callback");
parcelHelpers.exportAll(_callback, exports);
var _version = require("./version");
parcelHelpers.exportAll(_version, exports);
var _exporter = require("./internal/exporter");
var internal = {
    _export: (0, _exporter._export)
};

},{"./baggage/propagation/W3CBaggagePropagator":"fQTkT","./common/anchored-clock":"kBCgP","./common/attributes":"uRw60","./common/global-error-handler":"8Z2x3","./common/logging-error-handler":"211m6","./common/time":"b3p0h","./common/types":"kwXBf","./common/hex-to-binary":"4VG0B","./ExportResult":"3D2xL","./baggage/utils":"gKpXx","./platform":"dsAkU","./propagation/composite":"5JKPh","./trace/W3CTraceContextPropagator":"llidR","./trace/IdGenerator":"bF2f1","./trace/rpc-metadata":"S6jok","./trace/sampler/AlwaysOffSampler":"9zDpZ","./trace/sampler/AlwaysOnSampler":"eqc9R","./trace/sampler/ParentBasedSampler":"g5ZVj","./trace/sampler/TraceIdRatioBasedSampler":"50jG1","./trace/suppress-tracing":"7QbzJ","./trace/TraceState":"bV3YT","./utils/environment":"2VKOE","./utils/merge":"8lAwC","./utils/sampling":"1MYNP","./utils/timeout":"1pUZO","./utils/url":"6pR04","./utils/wrap":"csOqU","./utils/callback":"ivfjj","./version":"4DXLG","./internal/exporter":"8nXNE","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fQTkT":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "W3CBaggagePropagator", ()=>W3CBaggagePropagator);
var _api = require("@opentelemetry/api");
var _suppressTracing = require("../../trace/suppress-tracing");
var _constants = require("../constants");
var _utils = require("../utils");
/**
 * Propagates {@link Baggage} through Context format propagation.
 *
 * Based on the Baggage specification:
 * https://w3c.github.io/baggage/
 */ var W3CBaggagePropagator = /** @class */ function() {
    function W3CBaggagePropagator() {}
    W3CBaggagePropagator.prototype.inject = function(context, carrier, setter) {
        var baggage = (0, _api.propagation).getBaggage(context);
        if (!baggage || (0, _suppressTracing.isTracingSuppressed)(context)) return;
        var keyPairs = (0, _utils.getKeyPairs)(baggage).filter(function(pair) {
            return pair.length <= (0, _constants.BAGGAGE_MAX_PER_NAME_VALUE_PAIRS);
        }).slice(0, (0, _constants.BAGGAGE_MAX_NAME_VALUE_PAIRS));
        var headerValue = (0, _utils.serializeKeyPairs)(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, (0, _constants.BAGGAGE_HEADER), headerValue);
    };
    W3CBaggagePropagator.prototype.extract = function(context, carrier, getter) {
        var headerValue = getter.get(carrier, (0, _constants.BAGGAGE_HEADER));
        var baggageString = Array.isArray(headerValue) ? headerValue.join((0, _constants.BAGGAGE_ITEMS_SEPARATOR)) : headerValue;
        if (!baggageString) return context;
        var baggage = {};
        if (baggageString.length === 0) return context;
        var pairs = baggageString.split((0, _constants.BAGGAGE_ITEMS_SEPARATOR));
        pairs.forEach(function(entry) {
            var keyPair = (0, _utils.parsePairKeyValue)(entry);
            if (keyPair) {
                var baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context;
        return (0, _api.propagation).setBaggage(context, (0, _api.propagation).createBaggage(baggage));
    };
    W3CBaggagePropagator.prototype.fields = function() {
        return [
            (0, _constants.BAGGAGE_HEADER)
        ];
    };
    return W3CBaggagePropagator;
}();

},{"@opentelemetry/api":"4682l","../../trace/suppress-tracing":"7QbzJ","../constants":"hQ55e","../utils":"gKpXx","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7QbzJ":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "suppressTracing", ()=>suppressTracing);
parcelHelpers.export(exports, "unsuppressTracing", ()=>unsuppressTracing);
parcelHelpers.export(exports, "isTracingSuppressed", ()=>isTracingSuppressed);
var _api = require("@opentelemetry/api");
var SUPPRESS_TRACING_KEY = (0, _api.createContextKey)("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function suppressTracing(context) {
    return context.setValue(SUPPRESS_TRACING_KEY, true);
}
function unsuppressTracing(context) {
    return context.deleteValue(SUPPRESS_TRACING_KEY);
}
function isTracingSuppressed(context) {
    return context.getValue(SUPPRESS_TRACING_KEY) === true;
}

},{"@opentelemetry/api":"4682l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hQ55e":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BAGGAGE_KEY_PAIR_SEPARATOR", ()=>BAGGAGE_KEY_PAIR_SEPARATOR);
parcelHelpers.export(exports, "BAGGAGE_PROPERTIES_SEPARATOR", ()=>BAGGAGE_PROPERTIES_SEPARATOR);
parcelHelpers.export(exports, "BAGGAGE_ITEMS_SEPARATOR", ()=>BAGGAGE_ITEMS_SEPARATOR);
parcelHelpers.export(exports, "BAGGAGE_HEADER", ()=>BAGGAGE_HEADER);
parcelHelpers.export(exports, "BAGGAGE_MAX_NAME_VALUE_PAIRS", ()=>BAGGAGE_MAX_NAME_VALUE_PAIRS);
parcelHelpers.export(exports, "BAGGAGE_MAX_PER_NAME_VALUE_PAIRS", ()=>BAGGAGE_MAX_PER_NAME_VALUE_PAIRS);
parcelHelpers.export(exports, "BAGGAGE_MAX_TOTAL_LENGTH", ()=>BAGGAGE_MAX_TOTAL_LENGTH);
var BAGGAGE_KEY_PAIR_SEPARATOR = "=";
var BAGGAGE_PROPERTIES_SEPARATOR = ";";
var BAGGAGE_ITEMS_SEPARATOR = ",";
var BAGGAGE_HEADER = "baggage";
var BAGGAGE_MAX_NAME_VALUE_PAIRS = 180;
var BAGGAGE_MAX_PER_NAME_VALUE_PAIRS = 4096;
var BAGGAGE_MAX_TOTAL_LENGTH = 8192;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gKpXx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeKeyPairs", ()=>serializeKeyPairs);
parcelHelpers.export(exports, "getKeyPairs", ()=>getKeyPairs);
parcelHelpers.export(exports, "parsePairKeyValue", ()=>parsePairKeyValue);
/**
 * Parse a string serialized in the baggage HTTP Format (without metadata):
 * https://github.com/w3c/baggage/blob/master/baggage/HTTP_HEADER_FORMAT.md
 */ parcelHelpers.export(exports, "parseKeyPairsIntoRecord", ()=>parseKeyPairsIntoRecord);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var _api = require("@opentelemetry/api");
var _constants = require("./constants");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function serializeKeyPairs(keyPairs) {
    return keyPairs.reduce(function(hValue, current) {
        var value = "" + hValue + (hValue !== "" ? (0, _constants.BAGGAGE_ITEMS_SEPARATOR) : "") + current;
        return value.length > (0, _constants.BAGGAGE_MAX_TOTAL_LENGTH) ? hValue : value;
    }, "");
}
function getKeyPairs(baggage) {
    return baggage.getAllEntries().map(function(_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        var entry = encodeURIComponent(key) + "=" + encodeURIComponent(value.value);
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) entry += (0, _constants.BAGGAGE_PROPERTIES_SEPARATOR) + value.metadata.toString();
        return entry;
    });
}
function parsePairKeyValue(entry) {
    var valueProps = entry.split((0, _constants.BAGGAGE_PROPERTIES_SEPARATOR));
    if (valueProps.length <= 0) return;
    var keyPairPart = valueProps.shift();
    if (!keyPairPart) return;
    var separatorIndex = keyPairPart.indexOf((0, _constants.BAGGAGE_KEY_PAIR_SEPARATOR));
    if (separatorIndex <= 0) return;
    var key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    var value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    var metadata;
    if (valueProps.length > 0) metadata = (0, _api.baggageEntryMetadataFromString)(valueProps.join((0, _constants.BAGGAGE_PROPERTIES_SEPARATOR)));
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
function parseKeyPairsIntoRecord(value) {
    if (typeof value !== "string" || value.length === 0) return {};
    return value.split((0, _constants.BAGGAGE_ITEMS_SEPARATOR)).map(function(entry) {
        return parsePairKeyValue(entry);
    }).filter(function(keyPair) {
        return keyPair !== undefined && keyPair.value.length > 0;
    }).reduce(function(headers, keyPair) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        headers[keyPair.key] = keyPair.value;
        return headers;
    }, {});
}

},{"@opentelemetry/api":"4682l","./constants":"hQ55e","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kBCgP":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility for returning wall times anchored to a given point in time. Wall time measurements will
 * not be taken from the system, but instead are computed by adding a monotonic clock time
 * to the anchor point.
 *
 * This is needed because the system time can change and result in unexpected situations like
 * spans ending before they are started. Creating an anchored clock for each local root span
 * ensures that span timings and durations are accurate while preventing span times from drifting
 * too far from the system clock.
 *
 * Only creating an anchored clock once per local trace ensures span times are correct relative
 * to each other. For example, a child span will never have a start time before its parent even
 * if the system clock is corrected during the local trace.
 *
 * Heavily inspired by the OTel Java anchored clock
 * https://github.com/open-telemetry/opentelemetry-java/blob/main/sdk/trace/src/main/java/io/opentelemetry/sdk/trace/AnchoredClock.java
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnchoredClock", ()=>AnchoredClock);
var AnchoredClock = /** @class */ function() {
    /**
     * Create a new AnchoredClock anchored to the current time returned by systemClock.
     *
     * @param systemClock should be a clock that returns the number of milliseconds since January 1 1970 such as Date
     * @param monotonicClock should be a clock that counts milliseconds monotonically such as window.performance or perf_hooks.performance
     */ function AnchoredClock(systemClock, monotonicClock) {
        this._monotonicClock = monotonicClock;
        this._epochMillis = systemClock.now();
        this._performanceMillis = monotonicClock.now();
    }
    /**
     * Returns the current time by adding the number of milliseconds since the
     * AnchoredClock was created to the creation epoch time
     */ AnchoredClock.prototype.now = function() {
        var delta = this._monotonicClock.now() - this._performanceMillis;
        return this._epochMillis + delta;
    };
    return AnchoredClock;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"uRw60":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeAttributes", ()=>sanitizeAttributes);
parcelHelpers.export(exports, "isAttributeKey", ()=>isAttributeKey);
parcelHelpers.export(exports, "isAttributeValue", ()=>isAttributeValue);
var _api = require("@opentelemetry/api");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function sanitizeAttributes(attributes) {
    var e_1, _a;
    var out = {};
    if (typeof attributes !== "object" || attributes == null) return out;
    try {
        for(var _b = __values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = __read(_c.value, 2), key = _d[0], val = _d[1];
            if (!isAttributeKey(key)) {
                (0, _api.diag).warn("Invalid attribute key: " + key);
                continue;
            }
            if (!isAttributeValue(val)) {
                (0, _api.diag).warn("Invalid attribute value set for key: " + key);
                continue;
            }
            if (Array.isArray(val)) out[key] = val.slice();
            else out[key] = val;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return out;
}
function isAttributeKey(key) {
    return typeof key === "string" && key.length > 0;
}
function isAttributeValue(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return isHomogeneousAttributeValueArray(val);
    return isValidPrimitiveAttributeValue(val);
}
function isHomogeneousAttributeValueArray(arr) {
    var e_2, _a;
    var type;
    try {
        for(var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()){
            var element = arr_1_1.value;
            // null/undefined elements are allowed
            if (element == null) continue;
            if (!type) {
                if (isValidPrimitiveAttributeValue(element)) {
                    type = typeof element;
                    continue;
                }
                // encountered an invalid primitive
                return false;
            }
            if (typeof element === type) continue;
            return false;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return true;
}
function isValidPrimitiveAttributeValue(val) {
    switch(typeof val){
        case "number":
        case "boolean":
        case "string":
            return true;
    }
    return false;
}

},{"@opentelemetry/api":"4682l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8Z2x3":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Set the global error handler
 * @param {ErrorHandler} handler
 */ parcelHelpers.export(exports, "setGlobalErrorHandler", ()=>setGlobalErrorHandler);
/**
 * Return the global error handler
 * @param {Exception} ex
 */ parcelHelpers.export(exports, "globalErrorHandler", ()=>globalErrorHandler);
var _loggingErrorHandler = require("./logging-error-handler");
/** The global error handler delegate */ var delegateHandler = (0, _loggingErrorHandler.loggingErrorHandler)();
function setGlobalErrorHandler(handler) {
    delegateHandler = handler;
}
function globalErrorHandler(ex) {
    try {
        delegateHandler(ex);
    } catch (_a) {} // eslint-disable-line no-empty
}

},{"./logging-error-handler":"211m6","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"211m6":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a function that logs an error using the provided logger, or a
 * console logger if one was not provided.
 */ parcelHelpers.export(exports, "loggingErrorHandler", ()=>loggingErrorHandler);
var _api = require("@opentelemetry/api");
function loggingErrorHandler() {
    return function(ex) {
        (0, _api.diag).error(stringifyException(ex));
    };
}
/**
 * Converts an exception into a string representation
 * @param {Exception} ex
 */ function stringifyException(ex) {
    if (typeof ex === "string") return ex;
    else return JSON.stringify(flattenException(ex));
}
/**
 * Flattens an exception into key-value pairs by traversing the prototype chain
 * and coercing values to strings. Duplicate properties will not be overwritten;
 * the first insert wins.
 */ function flattenException(ex) {
    var result = {};
    var current = ex;
    while(current !== null){
        Object.getOwnPropertyNames(current).forEach(function(propertyName) {
            if (result[propertyName]) return;
            var value = current[propertyName];
            if (value) result[propertyName] = String(value);
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}

},{"@opentelemetry/api":"4682l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"b3p0h":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a number of milliseconds from epoch to HrTime([seconds, remainder in nanoseconds]).
 * @param epochMillis
 */ parcelHelpers.export(exports, "millisToHrTime", ()=>millisToHrTime);
parcelHelpers.export(exports, "getTimeOrigin", ()=>getTimeOrigin);
/**
 * Returns an hrtime calculated via performance component.
 * @param performanceNow
 */ parcelHelpers.export(exports, "hrTime", ()=>hrTime);
/**
 *
 * Converts a TimeInput to an HrTime, defaults to _hrtime().
 * @param time
 */ parcelHelpers.export(exports, "timeInputToHrTime", ()=>timeInputToHrTime);
/**
 * Returns a duration of two hrTime.
 * @param startTime
 * @param endTime
 */ parcelHelpers.export(exports, "hrTimeDuration", ()=>hrTimeDuration);
/**
 * Convert hrTime to timestamp, for example "2019-05-14T17:00:00.000123456Z"
 * @param time
 */ parcelHelpers.export(exports, "hrTimeToTimeStamp", ()=>hrTimeToTimeStamp);
/**
 * Convert hrTime to nanoseconds.
 * @param time
 */ parcelHelpers.export(exports, "hrTimeToNanoseconds", ()=>hrTimeToNanoseconds);
/**
 * Convert hrTime to milliseconds.
 * @param time
 */ parcelHelpers.export(exports, "hrTimeToMilliseconds", ()=>hrTimeToMilliseconds);
/**
 * Convert hrTime to microseconds.
 * @param time
 */ parcelHelpers.export(exports, "hrTimeToMicroseconds", ()=>hrTimeToMicroseconds);
/**
 * check if time is HrTime
 * @param value
 */ parcelHelpers.export(exports, "isTimeInputHrTime", ()=>isTimeInputHrTime);
/**
 * check if input value is a correct types.TimeInput
 * @param value
 */ parcelHelpers.export(exports, "isTimeInput", ()=>isTimeInput);
/**
 * Given 2 HrTime formatted times, return their sum as an HrTime.
 */ parcelHelpers.export(exports, "addHrTimes", ()=>addHrTimes);
var _platform = require("../platform");
var NANOSECOND_DIGITS = 9;
var NANOSECOND_DIGITS_IN_MILLIS = 6;
var MILLISECONDS_TO_NANOSECONDS = Math.pow(10, NANOSECOND_DIGITS_IN_MILLIS);
var SECOND_TO_NANOSECONDS = Math.pow(10, NANOSECOND_DIGITS);
function millisToHrTime(epochMillis) {
    var epochSeconds = epochMillis / 1000;
    // Decimals only.
    var seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    var nanos = Math.round(epochMillis % 1000 * MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function getTimeOrigin() {
    var timeOrigin = (0, _platform.otperformance).timeOrigin;
    if (typeof timeOrigin !== "number") {
        var perf = (0, _platform.otperformance);
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function hrTime(performanceNow) {
    var timeOrigin = millisToHrTime(getTimeOrigin());
    var now = millisToHrTime(typeof performanceNow === "number" ? performanceNow : (0, _platform.otperformance).now());
    return addHrTimes(timeOrigin, now);
}
function timeInputToHrTime(time) {
    // process.hrtime
    if (isTimeInputHrTime(time)) return time;
    else if (typeof time === "number") {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < getTimeOrigin()) return hrTime(time);
        else // epoch milliseconds or performance.timeOrigin
        return millisToHrTime(time);
    } else if (time instanceof Date) return millisToHrTime(time.getTime());
    else throw TypeError("Invalid input type");
}
function hrTimeDuration(startTime, endTime) {
    var seconds = endTime[0] - startTime[0];
    var nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function hrTimeToTimeStamp(time) {
    var precision = NANOSECOND_DIGITS;
    var tmp = "" + "0".repeat(precision) + time[1] + "Z";
    var nanoString = tmp.substr(tmp.length - precision - 1);
    var date = new Date(time[0] * 1000).toISOString();
    return date.replace("000Z", nanoString);
}
function hrTimeToNanoseconds(time) {
    return time[0] * SECOND_TO_NANOSECONDS + time[1];
}
function hrTimeToMilliseconds(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function hrTimeToMicroseconds(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function isTimeInputHrTime(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === "number" && typeof value[1] === "number";
}
function isTimeInput(value) {
    return isTimeInputHrTime(value) || typeof value === "number" || value instanceof Date;
}
function addHrTimes(time1, time2) {
    var out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= SECOND_TO_NANOSECONDS) {
        out[1] -= SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}

},{"../platform":"dsAkU","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dsAkU":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEnvWithoutDefaults", ()=>(0, _environment.getEnvWithoutDefaults));
parcelHelpers.export(exports, "getEnv", ()=>(0, _environment.getEnv));
var _environment = require("./environment");
var _globalThis = require("./globalThis");
parcelHelpers.exportAll(_globalThis, exports);
var _hexToBase64 = require("./hex-to-base64");
parcelHelpers.exportAll(_hexToBase64, exports);
var _randomIdGenerator = require("./RandomIdGenerator");
parcelHelpers.exportAll(_randomIdGenerator, exports);
var _performance = require("./performance");
parcelHelpers.exportAll(_performance, exports);
var _sdkInfo = require("./sdk-info");
parcelHelpers.exportAll(_sdkInfo, exports);
var _timerUtil = require("./timer-util");
parcelHelpers.exportAll(_timerUtil, exports);

},{"./environment":"gNsgp","./globalThis":"cMviS","./hex-to-base64":"667PG","./RandomIdGenerator":"kCcVF","./performance":"4jxed","./sdk-info":"2RSEC","./timer-util":"3dAF0","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gNsgp":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets the environment variables
 */ parcelHelpers.export(exports, "getEnv", ()=>getEnv);
parcelHelpers.export(exports, "getEnvWithoutDefaults", ()=>getEnvWithoutDefaults);
var _environment = require("../../utils/environment");
var _globalThis = require("./globalThis");
function getEnv() {
    var globalEnv = (0, _environment.parseEnvironment)((0, _globalThis._globalThis));
    return Object.assign({}, (0, _environment.DEFAULT_ENVIRONMENT), globalEnv);
}
function getEnvWithoutDefaults() {
    return (0, _environment.parseEnvironment)((0, _globalThis._globalThis));
}

},{"../../utils/environment":"2VKOE","./globalThis":"cMviS","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2VKOE":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT", ()=>DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT);
parcelHelpers.export(exports, "DEFAULT_ATTRIBUTE_COUNT_LIMIT", ()=>DEFAULT_ATTRIBUTE_COUNT_LIMIT);
parcelHelpers.export(exports, "DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT", ()=>DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT);
parcelHelpers.export(exports, "DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT", ()=>DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT);
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", ()=>DEFAULT_ENVIRONMENT);
/**
 * Parses environment values
 * @param values
 */ parcelHelpers.export(exports, "parseEnvironment", ()=>parseEnvironment);
var _api = require("@opentelemetry/api");
var _sampling = require("./sampling");
var DEFAULT_LIST_SEPARATOR = ",";
/**
 * Environment interface to define all names
 */ var ENVIRONMENT_BOOLEAN_KEYS = [
    "OTEL_SDK_DISABLED"
];
function isEnvVarABoolean(key) {
    return ENVIRONMENT_BOOLEAN_KEYS.indexOf(key) > -1;
}
var ENVIRONMENT_NUMBERS_KEYS = [
    "OTEL_BSP_EXPORT_TIMEOUT",
    "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BSP_MAX_QUEUE_SIZE",
    "OTEL_BSP_SCHEDULE_DELAY",
    "OTEL_BLRP_EXPORT_TIMEOUT",
    "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BLRP_MAX_QUEUE_SIZE",
    "OTEL_BLRP_SCHEDULE_DELAY",
    "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_LINK_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
    "OTEL_EXPORTER_OTLP_TIMEOUT",
    "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
    "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
    "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
    "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function isEnvVarANumber(key) {
    return ENVIRONMENT_NUMBERS_KEYS.indexOf(key) > -1;
}
var ENVIRONMENT_LISTS_KEYS = [
    "OTEL_NO_PATCH_MODULES",
    "OTEL_PROPAGATORS"
];
function isEnvVarAList(key) {
    return ENVIRONMENT_LISTS_KEYS.indexOf(key) > -1;
}
var DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT = Infinity;
var DEFAULT_ATTRIBUTE_COUNT_LIMIT = 128;
var DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT = 128;
var DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT = 128;
var DEFAULT_ENVIRONMENT = {
    OTEL_SDK_DISABLED: false,
    CONTAINER_NAME: "",
    ECS_CONTAINER_METADATA_URI_V4: "",
    ECS_CONTAINER_METADATA_URI: "",
    HOSTNAME: "",
    KUBERNETES_SERVICE_HOST: "",
    NAMESPACE: "",
    OTEL_BSP_EXPORT_TIMEOUT: 30000,
    OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BSP_MAX_QUEUE_SIZE: 2048,
    OTEL_BSP_SCHEDULE_DELAY: 5000,
    OTEL_BLRP_EXPORT_TIMEOUT: 30000,
    OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
    OTEL_BLRP_SCHEDULE_DELAY: 5000,
    OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
    OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
    OTEL_EXPORTER_JAEGER_ENDPOINT: "",
    OTEL_EXPORTER_JAEGER_PASSWORD: "",
    OTEL_EXPORTER_JAEGER_USER: "",
    OTEL_EXPORTER_OTLP_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_HEADERS: "",
    OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
    OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
    OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
    OTEL_EXPORTER_OTLP_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 10000,
    OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
    OTEL_LOG_LEVEL: (0, _api.DiagLogLevel).INFO,
    OTEL_NO_PATCH_MODULES: [],
    OTEL_PROPAGATORS: [
        "tracecontext",
        "baggage"
    ],
    OTEL_RESOURCE_ATTRIBUTES: "",
    OTEL_SERVICE_NAME: "",
    OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
    OTEL_ATTRIBUTE_COUNT_LIMIT: DEFAULT_ATTRIBUTE_COUNT_LIMIT,
    OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
    OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: DEFAULT_ATTRIBUTE_COUNT_LIMIT,
    OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
    OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: DEFAULT_ATTRIBUTE_COUNT_LIMIT,
    OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_LINK_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
    OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT,
    OTEL_TRACES_EXPORTER: "",
    OTEL_TRACES_SAMPLER: (0, _sampling.TracesSamplerValues).ParentBasedAlwaysOn,
    OTEL_TRACES_SAMPLER_ARG: "",
    OTEL_LOGS_EXPORTER: "",
    OTEL_EXPORTER_OTLP_INSECURE: "",
    OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
    OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
    OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
    OTEL_EXPORTER_OTLP_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative"
};
/**
 * @param key
 * @param environment
 * @param values
 */ function parseBoolean(key, environment, values) {
    if (typeof values[key] === "undefined") return;
    var value = String(values[key]);
    // support case-insensitive "true"
    environment[key] = value.toLowerCase() === "true";
}
/**
 * Parses a variable as number with number validation
 * @param name
 * @param environment
 * @param values
 * @param min
 * @param max
 */ function parseNumber(name, environment, values, min, max) {
    if (min === void 0) min = -Infinity;
    if (max === void 0) max = Infinity;
    if (typeof values[name] !== "undefined") {
        var value = Number(values[name]);
        if (!isNaN(value)) {
            if (value < min) environment[name] = min;
            else if (value > max) environment[name] = max;
            else environment[name] = value;
        }
    }
}
/**
 * Parses list-like strings from input into output.
 * @param name
 * @param environment
 * @param values
 * @param separator
 */ function parseStringList(name, output, input, separator) {
    if (separator === void 0) separator = DEFAULT_LIST_SEPARATOR;
    var givenValue = input[name];
    if (typeof givenValue === "string") output[name] = givenValue.split(separator).map(function(v) {
        return v.trim();
    });
}
// The support string -> DiagLogLevel mappings
var logLevelMap = {
    ALL: (0, _api.DiagLogLevel).ALL,
    VERBOSE: (0, _api.DiagLogLevel).VERBOSE,
    DEBUG: (0, _api.DiagLogLevel).DEBUG,
    INFO: (0, _api.DiagLogLevel).INFO,
    WARN: (0, _api.DiagLogLevel).WARN,
    ERROR: (0, _api.DiagLogLevel).ERROR,
    NONE: (0, _api.DiagLogLevel).NONE
};
/**
 * Environmentally sets log level if valid log level string is provided
 * @param key
 * @param environment
 * @param values
 */ function setLogLevelFromEnv(key, environment, values) {
    var value = values[key];
    if (typeof value === "string") {
        var theLevel = logLevelMap[value.toUpperCase()];
        if (theLevel != null) environment[key] = theLevel;
    }
}
function parseEnvironment(values) {
    var environment = {};
    for(var env in DEFAULT_ENVIRONMENT){
        var key = env;
        switch(key){
            case "OTEL_LOG_LEVEL":
                setLogLevelFromEnv(key, environment, values);
                break;
            default:
                if (isEnvVarABoolean(key)) parseBoolean(key, environment, values);
                else if (isEnvVarANumber(key)) parseNumber(key, environment, values);
                else if (isEnvVarAList(key)) parseStringList(key, environment, values);
                else {
                    var value = values[key];
                    if (typeof value !== "undefined" && value !== null) environment[key] = String(value);
                }
        }
    }
    return environment;
}

},{"@opentelemetry/api":"4682l","./sampling":"1MYNP","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1MYNP":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TracesSamplerValues", ()=>TracesSamplerValues);
var TracesSamplerValues;
(function(TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})(TracesSamplerValues || (TracesSamplerValues = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cMviS":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_globalThis", ()=>_globalThis);
var global = arguments[3];
var _globalThis = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof global === "object" ? global : {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"667PG":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hexToBase64", ()=>hexToBase64);
var _hexToBinary = require("../../common/hex-to-binary");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function hexToBase64(hexStr) {
    return btoa(String.fromCharCode.apply(String, __spreadArray([], __read((0, _hexToBinary.hexToBinary)(hexStr)), false)));
}

},{"../../common/hex-to-binary":"4VG0B","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4VG0B":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hexToBinary", ()=>hexToBinary);
function intValue(charCode) {
    // 0-9
    if (charCode >= 48 && charCode <= 57) return charCode - 48;
    // a-f
    if (charCode >= 97 && charCode <= 102) return charCode - 87;
    // A-F
    return charCode - 55;
}
function hexToBinary(hexStr) {
    var buf = new Uint8Array(hexStr.length / 2);
    var offset = 0;
    for(var i = 0; i < hexStr.length; i += 2){
        var hi = intValue(hexStr.charCodeAt(i));
        var lo = intValue(hexStr.charCodeAt(i + 1));
        buf[offset++] = hi << 4 | lo;
    }
    return buf;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kCcVF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RandomIdGenerator", ()=>RandomIdGenerator);
var SPAN_ID_BYTES = 8;
var TRACE_ID_BYTES = 16;
/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 */ var RandomIdGenerator = /** @class */ function() {
    function RandomIdGenerator() {
        /**
         * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
         * characters corresponding to 128 bits.
         */ this.generateTraceId = getIdGenerator(TRACE_ID_BYTES);
        /**
         * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
         * characters corresponding to 64 bits.
         */ this.generateSpanId = getIdGenerator(SPAN_ID_BYTES);
    }
    return RandomIdGenerator;
}();
var SHARED_CHAR_CODES_ARRAY = Array(32);
function getIdGenerator(bytes) {
    return function generateId() {
        for(var i = 0; i < bytes * 2; i++){
            SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if (SHARED_CHAR_CODES_ARRAY[i] >= 58) SHARED_CHAR_CODES_ARRAY[i] += 39;
        }
        return String.fromCharCode.apply(null, SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4jxed":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "otperformance", ()=>otperformance);
var otperformance = performance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2RSEC":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDK_INFO", ()=>SDK_INFO);
var _version = require("../../version");
var _semanticConventions = require("@opentelemetry/semantic-conventions");
var _a;
var SDK_INFO = (_a = {}, _a[0, _semanticConventions.SEMRESATTRS_TELEMETRY_SDK_NAME] = "opentelemetry", _a[0, _semanticConventions.SEMRESATTRS_PROCESS_RUNTIME_NAME] = "browser", _a[0, _semanticConventions.SEMRESATTRS_TELEMETRY_SDK_LANGUAGE] = (0, _semanticConventions.TELEMETRYSDKLANGUAGEVALUES_WEBJS), _a[0, _semanticConventions.SEMRESATTRS_TELEMETRY_SDK_VERSION] = (0, _version.VERSION), _a);

},{"../../version":"4DXLG","@opentelemetry/semantic-conventions":"1OyVc","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4DXLG":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
var VERSION = "1.25.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1OyVc":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trace = require("./trace");
parcelHelpers.exportAll(_trace, exports);
var _resource = require("./resource");
parcelHelpers.exportAll(_resource, exports);

},{"./trace":"63mI6","./resource":"fauSj","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"63mI6":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _semanticAttributes = require("./SemanticAttributes");
parcelHelpers.exportAll(_semanticAttributes, exports);

},{"./SemanticAttributes":"30FcA","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"30FcA":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEMATTRS_AWS_LAMBDA_INVOKED_ARN", ()=>SEMATTRS_AWS_LAMBDA_INVOKED_ARN);
parcelHelpers.export(exports, "SEMATTRS_DB_SYSTEM", ()=>SEMATTRS_DB_SYSTEM);
parcelHelpers.export(exports, "SEMATTRS_DB_CONNECTION_STRING", ()=>SEMATTRS_DB_CONNECTION_STRING);
parcelHelpers.export(exports, "SEMATTRS_DB_USER", ()=>SEMATTRS_DB_USER);
parcelHelpers.export(exports, "SEMATTRS_DB_JDBC_DRIVER_CLASSNAME", ()=>SEMATTRS_DB_JDBC_DRIVER_CLASSNAME);
parcelHelpers.export(exports, "SEMATTRS_DB_NAME", ()=>SEMATTRS_DB_NAME);
parcelHelpers.export(exports, "SEMATTRS_DB_STATEMENT", ()=>SEMATTRS_DB_STATEMENT);
parcelHelpers.export(exports, "SEMATTRS_DB_OPERATION", ()=>SEMATTRS_DB_OPERATION);
parcelHelpers.export(exports, "SEMATTRS_DB_MSSQL_INSTANCE_NAME", ()=>SEMATTRS_DB_MSSQL_INSTANCE_NAME);
parcelHelpers.export(exports, "SEMATTRS_DB_CASSANDRA_KEYSPACE", ()=>SEMATTRS_DB_CASSANDRA_KEYSPACE);
parcelHelpers.export(exports, "SEMATTRS_DB_CASSANDRA_PAGE_SIZE", ()=>SEMATTRS_DB_CASSANDRA_PAGE_SIZE);
parcelHelpers.export(exports, "SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL", ()=>SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL);
parcelHelpers.export(exports, "SEMATTRS_DB_CASSANDRA_TABLE", ()=>SEMATTRS_DB_CASSANDRA_TABLE);
parcelHelpers.export(exports, "SEMATTRS_DB_CASSANDRA_IDEMPOTENCE", ()=>SEMATTRS_DB_CASSANDRA_IDEMPOTENCE);
parcelHelpers.export(exports, "SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT", ()=>SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT);
parcelHelpers.export(exports, "SEMATTRS_DB_CASSANDRA_COORDINATOR_ID", ()=>SEMATTRS_DB_CASSANDRA_COORDINATOR_ID);
parcelHelpers.export(exports, "SEMATTRS_DB_CASSANDRA_COORDINATOR_DC", ()=>SEMATTRS_DB_CASSANDRA_COORDINATOR_DC);
parcelHelpers.export(exports, "SEMATTRS_DB_HBASE_NAMESPACE", ()=>SEMATTRS_DB_HBASE_NAMESPACE);
parcelHelpers.export(exports, "SEMATTRS_DB_REDIS_DATABASE_INDEX", ()=>SEMATTRS_DB_REDIS_DATABASE_INDEX);
parcelHelpers.export(exports, "SEMATTRS_DB_MONGODB_COLLECTION", ()=>SEMATTRS_DB_MONGODB_COLLECTION);
parcelHelpers.export(exports, "SEMATTRS_DB_SQL_TABLE", ()=>SEMATTRS_DB_SQL_TABLE);
parcelHelpers.export(exports, "SEMATTRS_EXCEPTION_TYPE", ()=>SEMATTRS_EXCEPTION_TYPE);
parcelHelpers.export(exports, "SEMATTRS_EXCEPTION_MESSAGE", ()=>SEMATTRS_EXCEPTION_MESSAGE);
parcelHelpers.export(exports, "SEMATTRS_EXCEPTION_STACKTRACE", ()=>SEMATTRS_EXCEPTION_STACKTRACE);
parcelHelpers.export(exports, "SEMATTRS_EXCEPTION_ESCAPED", ()=>SEMATTRS_EXCEPTION_ESCAPED);
parcelHelpers.export(exports, "SEMATTRS_FAAS_TRIGGER", ()=>SEMATTRS_FAAS_TRIGGER);
parcelHelpers.export(exports, "SEMATTRS_FAAS_EXECUTION", ()=>SEMATTRS_FAAS_EXECUTION);
parcelHelpers.export(exports, "SEMATTRS_FAAS_DOCUMENT_COLLECTION", ()=>SEMATTRS_FAAS_DOCUMENT_COLLECTION);
parcelHelpers.export(exports, "SEMATTRS_FAAS_DOCUMENT_OPERATION", ()=>SEMATTRS_FAAS_DOCUMENT_OPERATION);
parcelHelpers.export(exports, "SEMATTRS_FAAS_DOCUMENT_TIME", ()=>SEMATTRS_FAAS_DOCUMENT_TIME);
parcelHelpers.export(exports, "SEMATTRS_FAAS_DOCUMENT_NAME", ()=>SEMATTRS_FAAS_DOCUMENT_NAME);
parcelHelpers.export(exports, "SEMATTRS_FAAS_TIME", ()=>SEMATTRS_FAAS_TIME);
parcelHelpers.export(exports, "SEMATTRS_FAAS_CRON", ()=>SEMATTRS_FAAS_CRON);
parcelHelpers.export(exports, "SEMATTRS_FAAS_COLDSTART", ()=>SEMATTRS_FAAS_COLDSTART);
parcelHelpers.export(exports, "SEMATTRS_FAAS_INVOKED_NAME", ()=>SEMATTRS_FAAS_INVOKED_NAME);
parcelHelpers.export(exports, "SEMATTRS_FAAS_INVOKED_PROVIDER", ()=>SEMATTRS_FAAS_INVOKED_PROVIDER);
parcelHelpers.export(exports, "SEMATTRS_FAAS_INVOKED_REGION", ()=>SEMATTRS_FAAS_INVOKED_REGION);
parcelHelpers.export(exports, "SEMATTRS_NET_TRANSPORT", ()=>SEMATTRS_NET_TRANSPORT);
parcelHelpers.export(exports, "SEMATTRS_NET_PEER_IP", ()=>SEMATTRS_NET_PEER_IP);
parcelHelpers.export(exports, "SEMATTRS_NET_PEER_PORT", ()=>SEMATTRS_NET_PEER_PORT);
parcelHelpers.export(exports, "SEMATTRS_NET_PEER_NAME", ()=>SEMATTRS_NET_PEER_NAME);
parcelHelpers.export(exports, "SEMATTRS_NET_HOST_IP", ()=>SEMATTRS_NET_HOST_IP);
parcelHelpers.export(exports, "SEMATTRS_NET_HOST_PORT", ()=>SEMATTRS_NET_HOST_PORT);
parcelHelpers.export(exports, "SEMATTRS_NET_HOST_NAME", ()=>SEMATTRS_NET_HOST_NAME);
parcelHelpers.export(exports, "SEMATTRS_NET_HOST_CONNECTION_TYPE", ()=>SEMATTRS_NET_HOST_CONNECTION_TYPE);
parcelHelpers.export(exports, "SEMATTRS_NET_HOST_CONNECTION_SUBTYPE", ()=>SEMATTRS_NET_HOST_CONNECTION_SUBTYPE);
parcelHelpers.export(exports, "SEMATTRS_NET_HOST_CARRIER_NAME", ()=>SEMATTRS_NET_HOST_CARRIER_NAME);
parcelHelpers.export(exports, "SEMATTRS_NET_HOST_CARRIER_MCC", ()=>SEMATTRS_NET_HOST_CARRIER_MCC);
parcelHelpers.export(exports, "SEMATTRS_NET_HOST_CARRIER_MNC", ()=>SEMATTRS_NET_HOST_CARRIER_MNC);
parcelHelpers.export(exports, "SEMATTRS_NET_HOST_CARRIER_ICC", ()=>SEMATTRS_NET_HOST_CARRIER_ICC);
parcelHelpers.export(exports, "SEMATTRS_PEER_SERVICE", ()=>SEMATTRS_PEER_SERVICE);
parcelHelpers.export(exports, "SEMATTRS_ENDUSER_ID", ()=>SEMATTRS_ENDUSER_ID);
parcelHelpers.export(exports, "SEMATTRS_ENDUSER_ROLE", ()=>SEMATTRS_ENDUSER_ROLE);
parcelHelpers.export(exports, "SEMATTRS_ENDUSER_SCOPE", ()=>SEMATTRS_ENDUSER_SCOPE);
parcelHelpers.export(exports, "SEMATTRS_THREAD_ID", ()=>SEMATTRS_THREAD_ID);
parcelHelpers.export(exports, "SEMATTRS_THREAD_NAME", ()=>SEMATTRS_THREAD_NAME);
parcelHelpers.export(exports, "SEMATTRS_CODE_FUNCTION", ()=>SEMATTRS_CODE_FUNCTION);
parcelHelpers.export(exports, "SEMATTRS_CODE_NAMESPACE", ()=>SEMATTRS_CODE_NAMESPACE);
parcelHelpers.export(exports, "SEMATTRS_CODE_FILEPATH", ()=>SEMATTRS_CODE_FILEPATH);
parcelHelpers.export(exports, "SEMATTRS_CODE_LINENO", ()=>SEMATTRS_CODE_LINENO);
parcelHelpers.export(exports, "SEMATTRS_HTTP_METHOD", ()=>SEMATTRS_HTTP_METHOD);
parcelHelpers.export(exports, "SEMATTRS_HTTP_URL", ()=>SEMATTRS_HTTP_URL);
parcelHelpers.export(exports, "SEMATTRS_HTTP_TARGET", ()=>SEMATTRS_HTTP_TARGET);
parcelHelpers.export(exports, "SEMATTRS_HTTP_HOST", ()=>SEMATTRS_HTTP_HOST);
parcelHelpers.export(exports, "SEMATTRS_HTTP_SCHEME", ()=>SEMATTRS_HTTP_SCHEME);
parcelHelpers.export(exports, "SEMATTRS_HTTP_STATUS_CODE", ()=>SEMATTRS_HTTP_STATUS_CODE);
parcelHelpers.export(exports, "SEMATTRS_HTTP_FLAVOR", ()=>SEMATTRS_HTTP_FLAVOR);
parcelHelpers.export(exports, "SEMATTRS_HTTP_USER_AGENT", ()=>SEMATTRS_HTTP_USER_AGENT);
parcelHelpers.export(exports, "SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH", ()=>SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH);
parcelHelpers.export(exports, "SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED", ()=>SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED);
parcelHelpers.export(exports, "SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH", ()=>SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH);
parcelHelpers.export(exports, "SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED", ()=>SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED);
parcelHelpers.export(exports, "SEMATTRS_HTTP_SERVER_NAME", ()=>SEMATTRS_HTTP_SERVER_NAME);
parcelHelpers.export(exports, "SEMATTRS_HTTP_ROUTE", ()=>SEMATTRS_HTTP_ROUTE);
parcelHelpers.export(exports, "SEMATTRS_HTTP_CLIENT_IP", ()=>SEMATTRS_HTTP_CLIENT_IP);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_TABLE_NAMES", ()=>SEMATTRS_AWS_DYNAMODB_TABLE_NAMES);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY", ()=>SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS", ()=>SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY", ()=>SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY", ()=>SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ", ()=>SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_PROJECTION", ()=>SEMATTRS_AWS_DYNAMODB_PROJECTION);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_LIMIT", ()=>SEMATTRS_AWS_DYNAMODB_LIMIT);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET", ()=>SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_INDEX_NAME", ()=>SEMATTRS_AWS_DYNAMODB_INDEX_NAME);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_SELECT", ()=>SEMATTRS_AWS_DYNAMODB_SELECT);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES", ()=>SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES", ()=>SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE", ()=>SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_TABLE_COUNT", ()=>SEMATTRS_AWS_DYNAMODB_TABLE_COUNT);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD", ()=>SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_SEGMENT", ()=>SEMATTRS_AWS_DYNAMODB_SEGMENT);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS", ()=>SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_COUNT", ()=>SEMATTRS_AWS_DYNAMODB_COUNT);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT", ()=>SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS", ()=>SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS);
parcelHelpers.export(exports, "SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES", ()=>SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_SYSTEM", ()=>SEMATTRS_MESSAGING_SYSTEM);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_DESTINATION", ()=>SEMATTRS_MESSAGING_DESTINATION);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_DESTINATION_KIND", ()=>SEMATTRS_MESSAGING_DESTINATION_KIND);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_TEMP_DESTINATION", ()=>SEMATTRS_MESSAGING_TEMP_DESTINATION);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_PROTOCOL", ()=>SEMATTRS_MESSAGING_PROTOCOL);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_PROTOCOL_VERSION", ()=>SEMATTRS_MESSAGING_PROTOCOL_VERSION);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_URL", ()=>SEMATTRS_MESSAGING_URL);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_MESSAGE_ID", ()=>SEMATTRS_MESSAGING_MESSAGE_ID);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_CONVERSATION_ID", ()=>SEMATTRS_MESSAGING_CONVERSATION_ID);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES", ()=>SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES", ()=>SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_OPERATION", ()=>SEMATTRS_MESSAGING_OPERATION);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_CONSUMER_ID", ()=>SEMATTRS_MESSAGING_CONSUMER_ID);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY", ()=>SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY", ()=>SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP", ()=>SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_KAFKA_CLIENT_ID", ()=>SEMATTRS_MESSAGING_KAFKA_CLIENT_ID);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_KAFKA_PARTITION", ()=>SEMATTRS_MESSAGING_KAFKA_PARTITION);
parcelHelpers.export(exports, "SEMATTRS_MESSAGING_KAFKA_TOMBSTONE", ()=>SEMATTRS_MESSAGING_KAFKA_TOMBSTONE);
parcelHelpers.export(exports, "SEMATTRS_RPC_SYSTEM", ()=>SEMATTRS_RPC_SYSTEM);
parcelHelpers.export(exports, "SEMATTRS_RPC_SERVICE", ()=>SEMATTRS_RPC_SERVICE);
parcelHelpers.export(exports, "SEMATTRS_RPC_METHOD", ()=>SEMATTRS_RPC_METHOD);
parcelHelpers.export(exports, "SEMATTRS_RPC_GRPC_STATUS_CODE", ()=>SEMATTRS_RPC_GRPC_STATUS_CODE);
parcelHelpers.export(exports, "SEMATTRS_RPC_JSONRPC_VERSION", ()=>SEMATTRS_RPC_JSONRPC_VERSION);
parcelHelpers.export(exports, "SEMATTRS_RPC_JSONRPC_REQUEST_ID", ()=>SEMATTRS_RPC_JSONRPC_REQUEST_ID);
parcelHelpers.export(exports, "SEMATTRS_RPC_JSONRPC_ERROR_CODE", ()=>SEMATTRS_RPC_JSONRPC_ERROR_CODE);
parcelHelpers.export(exports, "SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE", ()=>SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE);
parcelHelpers.export(exports, "SEMATTRS_MESSAGE_TYPE", ()=>SEMATTRS_MESSAGE_TYPE);
parcelHelpers.export(exports, "SEMATTRS_MESSAGE_ID", ()=>SEMATTRS_MESSAGE_ID);
parcelHelpers.export(exports, "SEMATTRS_MESSAGE_COMPRESSED_SIZE", ()=>SEMATTRS_MESSAGE_COMPRESSED_SIZE);
parcelHelpers.export(exports, "SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE", ()=>SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE);
parcelHelpers.export(exports, "SemanticAttributes", ()=>SemanticAttributes);
parcelHelpers.export(exports, "DBSYSTEMVALUES_OTHER_SQL", ()=>DBSYSTEMVALUES_OTHER_SQL);
parcelHelpers.export(exports, "DBSYSTEMVALUES_MSSQL", ()=>DBSYSTEMVALUES_MSSQL);
parcelHelpers.export(exports, "DBSYSTEMVALUES_MYSQL", ()=>DBSYSTEMVALUES_MYSQL);
parcelHelpers.export(exports, "DBSYSTEMVALUES_ORACLE", ()=>DBSYSTEMVALUES_ORACLE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_DB2", ()=>DBSYSTEMVALUES_DB2);
parcelHelpers.export(exports, "DBSYSTEMVALUES_POSTGRESQL", ()=>DBSYSTEMVALUES_POSTGRESQL);
parcelHelpers.export(exports, "DBSYSTEMVALUES_REDSHIFT", ()=>DBSYSTEMVALUES_REDSHIFT);
parcelHelpers.export(exports, "DBSYSTEMVALUES_HIVE", ()=>DBSYSTEMVALUES_HIVE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_CLOUDSCAPE", ()=>DBSYSTEMVALUES_CLOUDSCAPE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_HSQLDB", ()=>DBSYSTEMVALUES_HSQLDB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_PROGRESS", ()=>DBSYSTEMVALUES_PROGRESS);
parcelHelpers.export(exports, "DBSYSTEMVALUES_MAXDB", ()=>DBSYSTEMVALUES_MAXDB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_HANADB", ()=>DBSYSTEMVALUES_HANADB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_INGRES", ()=>DBSYSTEMVALUES_INGRES);
parcelHelpers.export(exports, "DBSYSTEMVALUES_FIRSTSQL", ()=>DBSYSTEMVALUES_FIRSTSQL);
parcelHelpers.export(exports, "DBSYSTEMVALUES_EDB", ()=>DBSYSTEMVALUES_EDB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_CACHE", ()=>DBSYSTEMVALUES_CACHE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_ADABAS", ()=>DBSYSTEMVALUES_ADABAS);
parcelHelpers.export(exports, "DBSYSTEMVALUES_FIREBIRD", ()=>DBSYSTEMVALUES_FIREBIRD);
parcelHelpers.export(exports, "DBSYSTEMVALUES_DERBY", ()=>DBSYSTEMVALUES_DERBY);
parcelHelpers.export(exports, "DBSYSTEMVALUES_FILEMAKER", ()=>DBSYSTEMVALUES_FILEMAKER);
parcelHelpers.export(exports, "DBSYSTEMVALUES_INFORMIX", ()=>DBSYSTEMVALUES_INFORMIX);
parcelHelpers.export(exports, "DBSYSTEMVALUES_INSTANTDB", ()=>DBSYSTEMVALUES_INSTANTDB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_INTERBASE", ()=>DBSYSTEMVALUES_INTERBASE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_MARIADB", ()=>DBSYSTEMVALUES_MARIADB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_NETEZZA", ()=>DBSYSTEMVALUES_NETEZZA);
parcelHelpers.export(exports, "DBSYSTEMVALUES_PERVASIVE", ()=>DBSYSTEMVALUES_PERVASIVE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_POINTBASE", ()=>DBSYSTEMVALUES_POINTBASE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_SQLITE", ()=>DBSYSTEMVALUES_SQLITE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_SYBASE", ()=>DBSYSTEMVALUES_SYBASE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_TERADATA", ()=>DBSYSTEMVALUES_TERADATA);
parcelHelpers.export(exports, "DBSYSTEMVALUES_VERTICA", ()=>DBSYSTEMVALUES_VERTICA);
parcelHelpers.export(exports, "DBSYSTEMVALUES_H2", ()=>DBSYSTEMVALUES_H2);
parcelHelpers.export(exports, "DBSYSTEMVALUES_COLDFUSION", ()=>DBSYSTEMVALUES_COLDFUSION);
parcelHelpers.export(exports, "DBSYSTEMVALUES_CASSANDRA", ()=>DBSYSTEMVALUES_CASSANDRA);
parcelHelpers.export(exports, "DBSYSTEMVALUES_HBASE", ()=>DBSYSTEMVALUES_HBASE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_MONGODB", ()=>DBSYSTEMVALUES_MONGODB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_REDIS", ()=>DBSYSTEMVALUES_REDIS);
parcelHelpers.export(exports, "DBSYSTEMVALUES_COUCHBASE", ()=>DBSYSTEMVALUES_COUCHBASE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_COUCHDB", ()=>DBSYSTEMVALUES_COUCHDB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_COSMOSDB", ()=>DBSYSTEMVALUES_COSMOSDB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_DYNAMODB", ()=>DBSYSTEMVALUES_DYNAMODB);
parcelHelpers.export(exports, "DBSYSTEMVALUES_NEO4J", ()=>DBSYSTEMVALUES_NEO4J);
parcelHelpers.export(exports, "DBSYSTEMVALUES_GEODE", ()=>DBSYSTEMVALUES_GEODE);
parcelHelpers.export(exports, "DBSYSTEMVALUES_ELASTICSEARCH", ()=>DBSYSTEMVALUES_ELASTICSEARCH);
parcelHelpers.export(exports, "DBSYSTEMVALUES_MEMCACHED", ()=>DBSYSTEMVALUES_MEMCACHED);
parcelHelpers.export(exports, "DBSYSTEMVALUES_COCKROACHDB", ()=>DBSYSTEMVALUES_COCKROACHDB);
parcelHelpers.export(exports, "DbSystemValues", ()=>DbSystemValues);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_ALL", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_ALL);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_ONE", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_ONE);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_TWO", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_TWO);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_THREE", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_THREE);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_ANY", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_ANY);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL);
parcelHelpers.export(exports, "DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL", ()=>DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL);
parcelHelpers.export(exports, "DbCassandraConsistencyLevelValues", ()=>DbCassandraConsistencyLevelValues);
parcelHelpers.export(exports, "FAASTRIGGERVALUES_DATASOURCE", ()=>FAASTRIGGERVALUES_DATASOURCE);
parcelHelpers.export(exports, "FAASTRIGGERVALUES_HTTP", ()=>FAASTRIGGERVALUES_HTTP);
parcelHelpers.export(exports, "FAASTRIGGERVALUES_PUBSUB", ()=>FAASTRIGGERVALUES_PUBSUB);
parcelHelpers.export(exports, "FAASTRIGGERVALUES_TIMER", ()=>FAASTRIGGERVALUES_TIMER);
parcelHelpers.export(exports, "FAASTRIGGERVALUES_OTHER", ()=>FAASTRIGGERVALUES_OTHER);
parcelHelpers.export(exports, "FaasTriggerValues", ()=>FaasTriggerValues);
parcelHelpers.export(exports, "FAASDOCUMENTOPERATIONVALUES_INSERT", ()=>FAASDOCUMENTOPERATIONVALUES_INSERT);
parcelHelpers.export(exports, "FAASDOCUMENTOPERATIONVALUES_EDIT", ()=>FAASDOCUMENTOPERATIONVALUES_EDIT);
parcelHelpers.export(exports, "FAASDOCUMENTOPERATIONVALUES_DELETE", ()=>FAASDOCUMENTOPERATIONVALUES_DELETE);
parcelHelpers.export(exports, "FaasDocumentOperationValues", ()=>FaasDocumentOperationValues);
parcelHelpers.export(exports, "FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD", ()=>FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD);
parcelHelpers.export(exports, "FAASINVOKEDPROVIDERVALUES_AWS", ()=>FAASINVOKEDPROVIDERVALUES_AWS);
parcelHelpers.export(exports, "FAASINVOKEDPROVIDERVALUES_AZURE", ()=>FAASINVOKEDPROVIDERVALUES_AZURE);
parcelHelpers.export(exports, "FAASINVOKEDPROVIDERVALUES_GCP", ()=>FAASINVOKEDPROVIDERVALUES_GCP);
parcelHelpers.export(exports, "FaasInvokedProviderValues", ()=>FaasInvokedProviderValues);
parcelHelpers.export(exports, "NETTRANSPORTVALUES_IP_TCP", ()=>NETTRANSPORTVALUES_IP_TCP);
parcelHelpers.export(exports, "NETTRANSPORTVALUES_IP_UDP", ()=>NETTRANSPORTVALUES_IP_UDP);
parcelHelpers.export(exports, "NETTRANSPORTVALUES_IP", ()=>NETTRANSPORTVALUES_IP);
parcelHelpers.export(exports, "NETTRANSPORTVALUES_UNIX", ()=>NETTRANSPORTVALUES_UNIX);
parcelHelpers.export(exports, "NETTRANSPORTVALUES_PIPE", ()=>NETTRANSPORTVALUES_PIPE);
parcelHelpers.export(exports, "NETTRANSPORTVALUES_INPROC", ()=>NETTRANSPORTVALUES_INPROC);
parcelHelpers.export(exports, "NETTRANSPORTVALUES_OTHER", ()=>NETTRANSPORTVALUES_OTHER);
parcelHelpers.export(exports, "NetTransportValues", ()=>NetTransportValues);
parcelHelpers.export(exports, "NETHOSTCONNECTIONTYPEVALUES_WIFI", ()=>NETHOSTCONNECTIONTYPEVALUES_WIFI);
parcelHelpers.export(exports, "NETHOSTCONNECTIONTYPEVALUES_WIRED", ()=>NETHOSTCONNECTIONTYPEVALUES_WIRED);
parcelHelpers.export(exports, "NETHOSTCONNECTIONTYPEVALUES_CELL", ()=>NETHOSTCONNECTIONTYPEVALUES_CELL);
parcelHelpers.export(exports, "NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE", ()=>NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE);
parcelHelpers.export(exports, "NETHOSTCONNECTIONTYPEVALUES_UNKNOWN", ()=>NETHOSTCONNECTIONTYPEVALUES_UNKNOWN);
parcelHelpers.export(exports, "NetHostConnectionTypeValues", ()=>NetHostConnectionTypeValues);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_GPRS", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_GPRS);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_EDGE", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_EDGE);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_UMTS", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_UMTS);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_CDMA", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_CDMA);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_HSPA", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_HSPA);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_IDEN", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_IDEN);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_LTE", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_LTE);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_GSM", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_GSM);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_NR", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_NR);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA);
parcelHelpers.export(exports, "NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA", ()=>NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA);
parcelHelpers.export(exports, "NetHostConnectionSubtypeValues", ()=>NetHostConnectionSubtypeValues);
parcelHelpers.export(exports, "HTTPFLAVORVALUES_HTTP_1_0", ()=>HTTPFLAVORVALUES_HTTP_1_0);
parcelHelpers.export(exports, "HTTPFLAVORVALUES_HTTP_1_1", ()=>HTTPFLAVORVALUES_HTTP_1_1);
parcelHelpers.export(exports, "HTTPFLAVORVALUES_HTTP_2_0", ()=>HTTPFLAVORVALUES_HTTP_2_0);
parcelHelpers.export(exports, "HTTPFLAVORVALUES_SPDY", ()=>HTTPFLAVORVALUES_SPDY);
parcelHelpers.export(exports, "HTTPFLAVORVALUES_QUIC", ()=>HTTPFLAVORVALUES_QUIC);
parcelHelpers.export(exports, "HttpFlavorValues", ()=>HttpFlavorValues);
parcelHelpers.export(exports, "MESSAGINGDESTINATIONKINDVALUES_QUEUE", ()=>MESSAGINGDESTINATIONKINDVALUES_QUEUE);
parcelHelpers.export(exports, "MESSAGINGDESTINATIONKINDVALUES_TOPIC", ()=>MESSAGINGDESTINATIONKINDVALUES_TOPIC);
parcelHelpers.export(exports, "MessagingDestinationKindValues", ()=>MessagingDestinationKindValues);
parcelHelpers.export(exports, "MESSAGINGOPERATIONVALUES_RECEIVE", ()=>MESSAGINGOPERATIONVALUES_RECEIVE);
parcelHelpers.export(exports, "MESSAGINGOPERATIONVALUES_PROCESS", ()=>MESSAGINGOPERATIONVALUES_PROCESS);
parcelHelpers.export(exports, "MessagingOperationValues", ()=>MessagingOperationValues);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_OK", ()=>RPCGRPCSTATUSCODEVALUES_OK);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_CANCELLED", ()=>RPCGRPCSTATUSCODEVALUES_CANCELLED);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_UNKNOWN", ()=>RPCGRPCSTATUSCODEVALUES_UNKNOWN);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT", ()=>RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED", ()=>RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_NOT_FOUND", ()=>RPCGRPCSTATUSCODEVALUES_NOT_FOUND);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS", ()=>RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED", ()=>RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED", ()=>RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION", ()=>RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_ABORTED", ()=>RPCGRPCSTATUSCODEVALUES_ABORTED);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE", ()=>RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED", ()=>RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_INTERNAL", ()=>RPCGRPCSTATUSCODEVALUES_INTERNAL);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_UNAVAILABLE", ()=>RPCGRPCSTATUSCODEVALUES_UNAVAILABLE);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_DATA_LOSS", ()=>RPCGRPCSTATUSCODEVALUES_DATA_LOSS);
parcelHelpers.export(exports, "RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED", ()=>RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED);
parcelHelpers.export(exports, "RpcGrpcStatusCodeValues", ()=>RpcGrpcStatusCodeValues);
parcelHelpers.export(exports, "MESSAGETYPEVALUES_SENT", ()=>MESSAGETYPEVALUES_SENT);
parcelHelpers.export(exports, "MESSAGETYPEVALUES_RECEIVED", ()=>MESSAGETYPEVALUES_RECEIVED);
parcelHelpers.export(exports, "MessageTypeValues", ()=>MessageTypeValues);
var _utils = require("../internal/utils");
//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_AWS_LAMBDA_INVOKED_ARN = "aws.lambda.invoked_arn";
var TMP_DB_SYSTEM = "db.system";
var TMP_DB_CONNECTION_STRING = "db.connection_string";
var TMP_DB_USER = "db.user";
var TMP_DB_JDBC_DRIVER_CLASSNAME = "db.jdbc.driver_classname";
var TMP_DB_NAME = "db.name";
var TMP_DB_STATEMENT = "db.statement";
var TMP_DB_OPERATION = "db.operation";
var TMP_DB_MSSQL_INSTANCE_NAME = "db.mssql.instance_name";
var TMP_DB_CASSANDRA_KEYSPACE = "db.cassandra.keyspace";
var TMP_DB_CASSANDRA_PAGE_SIZE = "db.cassandra.page_size";
var TMP_DB_CASSANDRA_CONSISTENCY_LEVEL = "db.cassandra.consistency_level";
var TMP_DB_CASSANDRA_TABLE = "db.cassandra.table";
var TMP_DB_CASSANDRA_IDEMPOTENCE = "db.cassandra.idempotence";
var TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = "db.cassandra.speculative_execution_count";
var TMP_DB_CASSANDRA_COORDINATOR_ID = "db.cassandra.coordinator.id";
var TMP_DB_CASSANDRA_COORDINATOR_DC = "db.cassandra.coordinator.dc";
var TMP_DB_HBASE_NAMESPACE = "db.hbase.namespace";
var TMP_DB_REDIS_DATABASE_INDEX = "db.redis.database_index";
var TMP_DB_MONGODB_COLLECTION = "db.mongodb.collection";
var TMP_DB_SQL_TABLE = "db.sql.table";
var TMP_EXCEPTION_TYPE = "exception.type";
var TMP_EXCEPTION_MESSAGE = "exception.message";
var TMP_EXCEPTION_STACKTRACE = "exception.stacktrace";
var TMP_EXCEPTION_ESCAPED = "exception.escaped";
var TMP_FAAS_TRIGGER = "faas.trigger";
var TMP_FAAS_EXECUTION = "faas.execution";
var TMP_FAAS_DOCUMENT_COLLECTION = "faas.document.collection";
var TMP_FAAS_DOCUMENT_OPERATION = "faas.document.operation";
var TMP_FAAS_DOCUMENT_TIME = "faas.document.time";
var TMP_FAAS_DOCUMENT_NAME = "faas.document.name";
var TMP_FAAS_TIME = "faas.time";
var TMP_FAAS_CRON = "faas.cron";
var TMP_FAAS_COLDSTART = "faas.coldstart";
var TMP_FAAS_INVOKED_NAME = "faas.invoked_name";
var TMP_FAAS_INVOKED_PROVIDER = "faas.invoked_provider";
var TMP_FAAS_INVOKED_REGION = "faas.invoked_region";
var TMP_NET_TRANSPORT = "net.transport";
var TMP_NET_PEER_IP = "net.peer.ip";
var TMP_NET_PEER_PORT = "net.peer.port";
var TMP_NET_PEER_NAME = "net.peer.name";
var TMP_NET_HOST_IP = "net.host.ip";
var TMP_NET_HOST_PORT = "net.host.port";
var TMP_NET_HOST_NAME = "net.host.name";
var TMP_NET_HOST_CONNECTION_TYPE = "net.host.connection.type";
var TMP_NET_HOST_CONNECTION_SUBTYPE = "net.host.connection.subtype";
var TMP_NET_HOST_CARRIER_NAME = "net.host.carrier.name";
var TMP_NET_HOST_CARRIER_MCC = "net.host.carrier.mcc";
var TMP_NET_HOST_CARRIER_MNC = "net.host.carrier.mnc";
var TMP_NET_HOST_CARRIER_ICC = "net.host.carrier.icc";
var TMP_PEER_SERVICE = "peer.service";
var TMP_ENDUSER_ID = "enduser.id";
var TMP_ENDUSER_ROLE = "enduser.role";
var TMP_ENDUSER_SCOPE = "enduser.scope";
var TMP_THREAD_ID = "thread.id";
var TMP_THREAD_NAME = "thread.name";
var TMP_CODE_FUNCTION = "code.function";
var TMP_CODE_NAMESPACE = "code.namespace";
var TMP_CODE_FILEPATH = "code.filepath";
var TMP_CODE_LINENO = "code.lineno";
var TMP_HTTP_METHOD = "http.method";
var TMP_HTTP_URL = "http.url";
var TMP_HTTP_TARGET = "http.target";
var TMP_HTTP_HOST = "http.host";
var TMP_HTTP_SCHEME = "http.scheme";
var TMP_HTTP_STATUS_CODE = "http.status_code";
var TMP_HTTP_FLAVOR = "http.flavor";
var TMP_HTTP_USER_AGENT = "http.user_agent";
var TMP_HTTP_REQUEST_CONTENT_LENGTH = "http.request_content_length";
var TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = "http.request_content_length_uncompressed";
var TMP_HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length";
var TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = "http.response_content_length_uncompressed";
var TMP_HTTP_SERVER_NAME = "http.server_name";
var TMP_HTTP_ROUTE = "http.route";
var TMP_HTTP_CLIENT_IP = "http.client_ip";
var TMP_AWS_DYNAMODB_TABLE_NAMES = "aws.dynamodb.table_names";
var TMP_AWS_DYNAMODB_CONSUMED_CAPACITY = "aws.dynamodb.consumed_capacity";
var TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = "aws.dynamodb.item_collection_metrics";
var TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = "aws.dynamodb.provisioned_read_capacity";
var TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = "aws.dynamodb.provisioned_write_capacity";
var TMP_AWS_DYNAMODB_CONSISTENT_READ = "aws.dynamodb.consistent_read";
var TMP_AWS_DYNAMODB_PROJECTION = "aws.dynamodb.projection";
var TMP_AWS_DYNAMODB_LIMIT = "aws.dynamodb.limit";
var TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET = "aws.dynamodb.attributes_to_get";
var TMP_AWS_DYNAMODB_INDEX_NAME = "aws.dynamodb.index_name";
var TMP_AWS_DYNAMODB_SELECT = "aws.dynamodb.select";
var TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = "aws.dynamodb.global_secondary_indexes";
var TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = "aws.dynamodb.local_secondary_indexes";
var TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = "aws.dynamodb.exclusive_start_table";
var TMP_AWS_DYNAMODB_TABLE_COUNT = "aws.dynamodb.table_count";
var TMP_AWS_DYNAMODB_SCAN_FORWARD = "aws.dynamodb.scan_forward";
var TMP_AWS_DYNAMODB_SEGMENT = "aws.dynamodb.segment";
var TMP_AWS_DYNAMODB_TOTAL_SEGMENTS = "aws.dynamodb.total_segments";
var TMP_AWS_DYNAMODB_COUNT = "aws.dynamodb.count";
var TMP_AWS_DYNAMODB_SCANNED_COUNT = "aws.dynamodb.scanned_count";
var TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = "aws.dynamodb.attribute_definitions";
var TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = "aws.dynamodb.global_secondary_index_updates";
var TMP_MESSAGING_SYSTEM = "messaging.system";
var TMP_MESSAGING_DESTINATION = "messaging.destination";
var TMP_MESSAGING_DESTINATION_KIND = "messaging.destination_kind";
var TMP_MESSAGING_TEMP_DESTINATION = "messaging.temp_destination";
var TMP_MESSAGING_PROTOCOL = "messaging.protocol";
var TMP_MESSAGING_PROTOCOL_VERSION = "messaging.protocol_version";
var TMP_MESSAGING_URL = "messaging.url";
var TMP_MESSAGING_MESSAGE_ID = "messaging.message_id";
var TMP_MESSAGING_CONVERSATION_ID = "messaging.conversation_id";
var TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = "messaging.message_payload_size_bytes";
var TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = "messaging.message_payload_compressed_size_bytes";
var TMP_MESSAGING_OPERATION = "messaging.operation";
var TMP_MESSAGING_CONSUMER_ID = "messaging.consumer_id";
var TMP_MESSAGING_RABBITMQ_ROUTING_KEY = "messaging.rabbitmq.routing_key";
var TMP_MESSAGING_KAFKA_MESSAGE_KEY = "messaging.kafka.message_key";
var TMP_MESSAGING_KAFKA_CONSUMER_GROUP = "messaging.kafka.consumer_group";
var TMP_MESSAGING_KAFKA_CLIENT_ID = "messaging.kafka.client_id";
var TMP_MESSAGING_KAFKA_PARTITION = "messaging.kafka.partition";
var TMP_MESSAGING_KAFKA_TOMBSTONE = "messaging.kafka.tombstone";
var TMP_RPC_SYSTEM = "rpc.system";
var TMP_RPC_SERVICE = "rpc.service";
var TMP_RPC_METHOD = "rpc.method";
var TMP_RPC_GRPC_STATUS_CODE = "rpc.grpc.status_code";
var TMP_RPC_JSONRPC_VERSION = "rpc.jsonrpc.version";
var TMP_RPC_JSONRPC_REQUEST_ID = "rpc.jsonrpc.request_id";
var TMP_RPC_JSONRPC_ERROR_CODE = "rpc.jsonrpc.error_code";
var TMP_RPC_JSONRPC_ERROR_MESSAGE = "rpc.jsonrpc.error_message";
var TMP_MESSAGE_TYPE = "message.type";
var TMP_MESSAGE_ID = "message.id";
var TMP_MESSAGE_COMPRESSED_SIZE = "message.compressed_size";
var TMP_MESSAGE_UNCOMPRESSED_SIZE = "message.uncompressed_size";
var SEMATTRS_AWS_LAMBDA_INVOKED_ARN = TMP_AWS_LAMBDA_INVOKED_ARN;
var SEMATTRS_DB_SYSTEM = TMP_DB_SYSTEM;
var SEMATTRS_DB_CONNECTION_STRING = TMP_DB_CONNECTION_STRING;
var SEMATTRS_DB_USER = TMP_DB_USER;
var SEMATTRS_DB_JDBC_DRIVER_CLASSNAME = TMP_DB_JDBC_DRIVER_CLASSNAME;
var SEMATTRS_DB_NAME = TMP_DB_NAME;
var SEMATTRS_DB_STATEMENT = TMP_DB_STATEMENT;
var SEMATTRS_DB_OPERATION = TMP_DB_OPERATION;
var SEMATTRS_DB_MSSQL_INSTANCE_NAME = TMP_DB_MSSQL_INSTANCE_NAME;
var SEMATTRS_DB_CASSANDRA_KEYSPACE = TMP_DB_CASSANDRA_KEYSPACE;
var SEMATTRS_DB_CASSANDRA_PAGE_SIZE = TMP_DB_CASSANDRA_PAGE_SIZE;
var SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL = TMP_DB_CASSANDRA_CONSISTENCY_LEVEL;
var SEMATTRS_DB_CASSANDRA_TABLE = TMP_DB_CASSANDRA_TABLE;
var SEMATTRS_DB_CASSANDRA_IDEMPOTENCE = TMP_DB_CASSANDRA_IDEMPOTENCE;
var SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT;
var SEMATTRS_DB_CASSANDRA_COORDINATOR_ID = TMP_DB_CASSANDRA_COORDINATOR_ID;
var SEMATTRS_DB_CASSANDRA_COORDINATOR_DC = TMP_DB_CASSANDRA_COORDINATOR_DC;
var SEMATTRS_DB_HBASE_NAMESPACE = TMP_DB_HBASE_NAMESPACE;
var SEMATTRS_DB_REDIS_DATABASE_INDEX = TMP_DB_REDIS_DATABASE_INDEX;
var SEMATTRS_DB_MONGODB_COLLECTION = TMP_DB_MONGODB_COLLECTION;
var SEMATTRS_DB_SQL_TABLE = TMP_DB_SQL_TABLE;
var SEMATTRS_EXCEPTION_TYPE = TMP_EXCEPTION_TYPE;
var SEMATTRS_EXCEPTION_MESSAGE = TMP_EXCEPTION_MESSAGE;
var SEMATTRS_EXCEPTION_STACKTRACE = TMP_EXCEPTION_STACKTRACE;
var SEMATTRS_EXCEPTION_ESCAPED = TMP_EXCEPTION_ESCAPED;
var SEMATTRS_FAAS_TRIGGER = TMP_FAAS_TRIGGER;
var SEMATTRS_FAAS_EXECUTION = TMP_FAAS_EXECUTION;
var SEMATTRS_FAAS_DOCUMENT_COLLECTION = TMP_FAAS_DOCUMENT_COLLECTION;
var SEMATTRS_FAAS_DOCUMENT_OPERATION = TMP_FAAS_DOCUMENT_OPERATION;
var SEMATTRS_FAAS_DOCUMENT_TIME = TMP_FAAS_DOCUMENT_TIME;
var SEMATTRS_FAAS_DOCUMENT_NAME = TMP_FAAS_DOCUMENT_NAME;
var SEMATTRS_FAAS_TIME = TMP_FAAS_TIME;
var SEMATTRS_FAAS_CRON = TMP_FAAS_CRON;
var SEMATTRS_FAAS_COLDSTART = TMP_FAAS_COLDSTART;
var SEMATTRS_FAAS_INVOKED_NAME = TMP_FAAS_INVOKED_NAME;
var SEMATTRS_FAAS_INVOKED_PROVIDER = TMP_FAAS_INVOKED_PROVIDER;
var SEMATTRS_FAAS_INVOKED_REGION = TMP_FAAS_INVOKED_REGION;
var SEMATTRS_NET_TRANSPORT = TMP_NET_TRANSPORT;
var SEMATTRS_NET_PEER_IP = TMP_NET_PEER_IP;
var SEMATTRS_NET_PEER_PORT = TMP_NET_PEER_PORT;
var SEMATTRS_NET_PEER_NAME = TMP_NET_PEER_NAME;
var SEMATTRS_NET_HOST_IP = TMP_NET_HOST_IP;
var SEMATTRS_NET_HOST_PORT = TMP_NET_HOST_PORT;
var SEMATTRS_NET_HOST_NAME = TMP_NET_HOST_NAME;
var SEMATTRS_NET_HOST_CONNECTION_TYPE = TMP_NET_HOST_CONNECTION_TYPE;
var SEMATTRS_NET_HOST_CONNECTION_SUBTYPE = TMP_NET_HOST_CONNECTION_SUBTYPE;
var SEMATTRS_NET_HOST_CARRIER_NAME = TMP_NET_HOST_CARRIER_NAME;
var SEMATTRS_NET_HOST_CARRIER_MCC = TMP_NET_HOST_CARRIER_MCC;
var SEMATTRS_NET_HOST_CARRIER_MNC = TMP_NET_HOST_CARRIER_MNC;
var SEMATTRS_NET_HOST_CARRIER_ICC = TMP_NET_HOST_CARRIER_ICC;
var SEMATTRS_PEER_SERVICE = TMP_PEER_SERVICE;
var SEMATTRS_ENDUSER_ID = TMP_ENDUSER_ID;
var SEMATTRS_ENDUSER_ROLE = TMP_ENDUSER_ROLE;
var SEMATTRS_ENDUSER_SCOPE = TMP_ENDUSER_SCOPE;
var SEMATTRS_THREAD_ID = TMP_THREAD_ID;
var SEMATTRS_THREAD_NAME = TMP_THREAD_NAME;
var SEMATTRS_CODE_FUNCTION = TMP_CODE_FUNCTION;
var SEMATTRS_CODE_NAMESPACE = TMP_CODE_NAMESPACE;
var SEMATTRS_CODE_FILEPATH = TMP_CODE_FILEPATH;
var SEMATTRS_CODE_LINENO = TMP_CODE_LINENO;
var SEMATTRS_HTTP_METHOD = TMP_HTTP_METHOD;
var SEMATTRS_HTTP_URL = TMP_HTTP_URL;
var SEMATTRS_HTTP_TARGET = TMP_HTTP_TARGET;
var SEMATTRS_HTTP_HOST = TMP_HTTP_HOST;
var SEMATTRS_HTTP_SCHEME = TMP_HTTP_SCHEME;
var SEMATTRS_HTTP_STATUS_CODE = TMP_HTTP_STATUS_CODE;
var SEMATTRS_HTTP_FLAVOR = TMP_HTTP_FLAVOR;
var SEMATTRS_HTTP_USER_AGENT = TMP_HTTP_USER_AGENT;
var SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH = TMP_HTTP_REQUEST_CONTENT_LENGTH;
var SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED;
var SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH = TMP_HTTP_RESPONSE_CONTENT_LENGTH;
var SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED;
var SEMATTRS_HTTP_SERVER_NAME = TMP_HTTP_SERVER_NAME;
var SEMATTRS_HTTP_ROUTE = TMP_HTTP_ROUTE;
var SEMATTRS_HTTP_CLIENT_IP = TMP_HTTP_CLIENT_IP;
var SEMATTRS_AWS_DYNAMODB_TABLE_NAMES = TMP_AWS_DYNAMODB_TABLE_NAMES;
var SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY = TMP_AWS_DYNAMODB_CONSUMED_CAPACITY;
var SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS;
var SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY;
var SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY;
var SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ = TMP_AWS_DYNAMODB_CONSISTENT_READ;
var SEMATTRS_AWS_DYNAMODB_PROJECTION = TMP_AWS_DYNAMODB_PROJECTION;
var SEMATTRS_AWS_DYNAMODB_LIMIT = TMP_AWS_DYNAMODB_LIMIT;
var SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET = TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET;
var SEMATTRS_AWS_DYNAMODB_INDEX_NAME = TMP_AWS_DYNAMODB_INDEX_NAME;
var SEMATTRS_AWS_DYNAMODB_SELECT = TMP_AWS_DYNAMODB_SELECT;
var SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES;
var SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES;
var SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE;
var SEMATTRS_AWS_DYNAMODB_TABLE_COUNT = TMP_AWS_DYNAMODB_TABLE_COUNT;
var SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD = TMP_AWS_DYNAMODB_SCAN_FORWARD;
var SEMATTRS_AWS_DYNAMODB_SEGMENT = TMP_AWS_DYNAMODB_SEGMENT;
var SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS = TMP_AWS_DYNAMODB_TOTAL_SEGMENTS;
var SEMATTRS_AWS_DYNAMODB_COUNT = TMP_AWS_DYNAMODB_COUNT;
var SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT = TMP_AWS_DYNAMODB_SCANNED_COUNT;
var SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS;
var SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES;
var SEMATTRS_MESSAGING_SYSTEM = TMP_MESSAGING_SYSTEM;
var SEMATTRS_MESSAGING_DESTINATION = TMP_MESSAGING_DESTINATION;
var SEMATTRS_MESSAGING_DESTINATION_KIND = TMP_MESSAGING_DESTINATION_KIND;
var SEMATTRS_MESSAGING_TEMP_DESTINATION = TMP_MESSAGING_TEMP_DESTINATION;
var SEMATTRS_MESSAGING_PROTOCOL = TMP_MESSAGING_PROTOCOL;
var SEMATTRS_MESSAGING_PROTOCOL_VERSION = TMP_MESSAGING_PROTOCOL_VERSION;
var SEMATTRS_MESSAGING_URL = TMP_MESSAGING_URL;
var SEMATTRS_MESSAGING_MESSAGE_ID = TMP_MESSAGING_MESSAGE_ID;
var SEMATTRS_MESSAGING_CONVERSATION_ID = TMP_MESSAGING_CONVERSATION_ID;
var SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES;
var SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES;
var SEMATTRS_MESSAGING_OPERATION = TMP_MESSAGING_OPERATION;
var SEMATTRS_MESSAGING_CONSUMER_ID = TMP_MESSAGING_CONSUMER_ID;
var SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY = TMP_MESSAGING_RABBITMQ_ROUTING_KEY;
var SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY = TMP_MESSAGING_KAFKA_MESSAGE_KEY;
var SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP = TMP_MESSAGING_KAFKA_CONSUMER_GROUP;
var SEMATTRS_MESSAGING_KAFKA_CLIENT_ID = TMP_MESSAGING_KAFKA_CLIENT_ID;
var SEMATTRS_MESSAGING_KAFKA_PARTITION = TMP_MESSAGING_KAFKA_PARTITION;
var SEMATTRS_MESSAGING_KAFKA_TOMBSTONE = TMP_MESSAGING_KAFKA_TOMBSTONE;
var SEMATTRS_RPC_SYSTEM = TMP_RPC_SYSTEM;
var SEMATTRS_RPC_SERVICE = TMP_RPC_SERVICE;
var SEMATTRS_RPC_METHOD = TMP_RPC_METHOD;
var SEMATTRS_RPC_GRPC_STATUS_CODE = TMP_RPC_GRPC_STATUS_CODE;
var SEMATTRS_RPC_JSONRPC_VERSION = TMP_RPC_JSONRPC_VERSION;
var SEMATTRS_RPC_JSONRPC_REQUEST_ID = TMP_RPC_JSONRPC_REQUEST_ID;
var SEMATTRS_RPC_JSONRPC_ERROR_CODE = TMP_RPC_JSONRPC_ERROR_CODE;
var SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE = TMP_RPC_JSONRPC_ERROR_MESSAGE;
var SEMATTRS_MESSAGE_TYPE = TMP_MESSAGE_TYPE;
var SEMATTRS_MESSAGE_ID = TMP_MESSAGE_ID;
var SEMATTRS_MESSAGE_COMPRESSED_SIZE = TMP_MESSAGE_COMPRESSED_SIZE;
var SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE = TMP_MESSAGE_UNCOMPRESSED_SIZE;
var SemanticAttributes = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_AWS_LAMBDA_INVOKED_ARN,
    TMP_DB_SYSTEM,
    TMP_DB_CONNECTION_STRING,
    TMP_DB_USER,
    TMP_DB_JDBC_DRIVER_CLASSNAME,
    TMP_DB_NAME,
    TMP_DB_STATEMENT,
    TMP_DB_OPERATION,
    TMP_DB_MSSQL_INSTANCE_NAME,
    TMP_DB_CASSANDRA_KEYSPACE,
    TMP_DB_CASSANDRA_PAGE_SIZE,
    TMP_DB_CASSANDRA_CONSISTENCY_LEVEL,
    TMP_DB_CASSANDRA_TABLE,
    TMP_DB_CASSANDRA_IDEMPOTENCE,
    TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
    TMP_DB_CASSANDRA_COORDINATOR_ID,
    TMP_DB_CASSANDRA_COORDINATOR_DC,
    TMP_DB_HBASE_NAMESPACE,
    TMP_DB_REDIS_DATABASE_INDEX,
    TMP_DB_MONGODB_COLLECTION,
    TMP_DB_SQL_TABLE,
    TMP_EXCEPTION_TYPE,
    TMP_EXCEPTION_MESSAGE,
    TMP_EXCEPTION_STACKTRACE,
    TMP_EXCEPTION_ESCAPED,
    TMP_FAAS_TRIGGER,
    TMP_FAAS_EXECUTION,
    TMP_FAAS_DOCUMENT_COLLECTION,
    TMP_FAAS_DOCUMENT_OPERATION,
    TMP_FAAS_DOCUMENT_TIME,
    TMP_FAAS_DOCUMENT_NAME,
    TMP_FAAS_TIME,
    TMP_FAAS_CRON,
    TMP_FAAS_COLDSTART,
    TMP_FAAS_INVOKED_NAME,
    TMP_FAAS_INVOKED_PROVIDER,
    TMP_FAAS_INVOKED_REGION,
    TMP_NET_TRANSPORT,
    TMP_NET_PEER_IP,
    TMP_NET_PEER_PORT,
    TMP_NET_PEER_NAME,
    TMP_NET_HOST_IP,
    TMP_NET_HOST_PORT,
    TMP_NET_HOST_NAME,
    TMP_NET_HOST_CONNECTION_TYPE,
    TMP_NET_HOST_CONNECTION_SUBTYPE,
    TMP_NET_HOST_CARRIER_NAME,
    TMP_NET_HOST_CARRIER_MCC,
    TMP_NET_HOST_CARRIER_MNC,
    TMP_NET_HOST_CARRIER_ICC,
    TMP_PEER_SERVICE,
    TMP_ENDUSER_ID,
    TMP_ENDUSER_ROLE,
    TMP_ENDUSER_SCOPE,
    TMP_THREAD_ID,
    TMP_THREAD_NAME,
    TMP_CODE_FUNCTION,
    TMP_CODE_NAMESPACE,
    TMP_CODE_FILEPATH,
    TMP_CODE_LINENO,
    TMP_HTTP_METHOD,
    TMP_HTTP_URL,
    TMP_HTTP_TARGET,
    TMP_HTTP_HOST,
    TMP_HTTP_SCHEME,
    TMP_HTTP_STATUS_CODE,
    TMP_HTTP_FLAVOR,
    TMP_HTTP_USER_AGENT,
    TMP_HTTP_REQUEST_CONTENT_LENGTH,
    TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
    TMP_HTTP_RESPONSE_CONTENT_LENGTH,
    TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
    TMP_HTTP_SERVER_NAME,
    TMP_HTTP_ROUTE,
    TMP_HTTP_CLIENT_IP,
    TMP_AWS_DYNAMODB_TABLE_NAMES,
    TMP_AWS_DYNAMODB_CONSUMED_CAPACITY,
    TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
    TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
    TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
    TMP_AWS_DYNAMODB_CONSISTENT_READ,
    TMP_AWS_DYNAMODB_PROJECTION,
    TMP_AWS_DYNAMODB_LIMIT,
    TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
    TMP_AWS_DYNAMODB_INDEX_NAME,
    TMP_AWS_DYNAMODB_SELECT,
    TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
    TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
    TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
    TMP_AWS_DYNAMODB_TABLE_COUNT,
    TMP_AWS_DYNAMODB_SCAN_FORWARD,
    TMP_AWS_DYNAMODB_SEGMENT,
    TMP_AWS_DYNAMODB_TOTAL_SEGMENTS,
    TMP_AWS_DYNAMODB_COUNT,
    TMP_AWS_DYNAMODB_SCANNED_COUNT,
    TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
    TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
    TMP_MESSAGING_SYSTEM,
    TMP_MESSAGING_DESTINATION,
    TMP_MESSAGING_DESTINATION_KIND,
    TMP_MESSAGING_TEMP_DESTINATION,
    TMP_MESSAGING_PROTOCOL,
    TMP_MESSAGING_PROTOCOL_VERSION,
    TMP_MESSAGING_URL,
    TMP_MESSAGING_MESSAGE_ID,
    TMP_MESSAGING_CONVERSATION_ID,
    TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
    TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
    TMP_MESSAGING_OPERATION,
    TMP_MESSAGING_CONSUMER_ID,
    TMP_MESSAGING_RABBITMQ_ROUTING_KEY,
    TMP_MESSAGING_KAFKA_MESSAGE_KEY,
    TMP_MESSAGING_KAFKA_CONSUMER_GROUP,
    TMP_MESSAGING_KAFKA_CLIENT_ID,
    TMP_MESSAGING_KAFKA_PARTITION,
    TMP_MESSAGING_KAFKA_TOMBSTONE,
    TMP_RPC_SYSTEM,
    TMP_RPC_SERVICE,
    TMP_RPC_METHOD,
    TMP_RPC_GRPC_STATUS_CODE,
    TMP_RPC_JSONRPC_VERSION,
    TMP_RPC_JSONRPC_REQUEST_ID,
    TMP_RPC_JSONRPC_ERROR_CODE,
    TMP_RPC_JSONRPC_ERROR_MESSAGE,
    TMP_MESSAGE_TYPE,
    TMP_MESSAGE_ID,
    TMP_MESSAGE_COMPRESSED_SIZE,
    TMP_MESSAGE_UNCOMPRESSED_SIZE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbSystemValues enum definition
 *
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_DBSYSTEMVALUES_OTHER_SQL = "other_sql";
var TMP_DBSYSTEMVALUES_MSSQL = "mssql";
var TMP_DBSYSTEMVALUES_MYSQL = "mysql";
var TMP_DBSYSTEMVALUES_ORACLE = "oracle";
var TMP_DBSYSTEMVALUES_DB2 = "db2";
var TMP_DBSYSTEMVALUES_POSTGRESQL = "postgresql";
var TMP_DBSYSTEMVALUES_REDSHIFT = "redshift";
var TMP_DBSYSTEMVALUES_HIVE = "hive";
var TMP_DBSYSTEMVALUES_CLOUDSCAPE = "cloudscape";
var TMP_DBSYSTEMVALUES_HSQLDB = "hsqldb";
var TMP_DBSYSTEMVALUES_PROGRESS = "progress";
var TMP_DBSYSTEMVALUES_MAXDB = "maxdb";
var TMP_DBSYSTEMVALUES_HANADB = "hanadb";
var TMP_DBSYSTEMVALUES_INGRES = "ingres";
var TMP_DBSYSTEMVALUES_FIRSTSQL = "firstsql";
var TMP_DBSYSTEMVALUES_EDB = "edb";
var TMP_DBSYSTEMVALUES_CACHE = "cache";
var TMP_DBSYSTEMVALUES_ADABAS = "adabas";
var TMP_DBSYSTEMVALUES_FIREBIRD = "firebird";
var TMP_DBSYSTEMVALUES_DERBY = "derby";
var TMP_DBSYSTEMVALUES_FILEMAKER = "filemaker";
var TMP_DBSYSTEMVALUES_INFORMIX = "informix";
var TMP_DBSYSTEMVALUES_INSTANTDB = "instantdb";
var TMP_DBSYSTEMVALUES_INTERBASE = "interbase";
var TMP_DBSYSTEMVALUES_MARIADB = "mariadb";
var TMP_DBSYSTEMVALUES_NETEZZA = "netezza";
var TMP_DBSYSTEMVALUES_PERVASIVE = "pervasive";
var TMP_DBSYSTEMVALUES_POINTBASE = "pointbase";
var TMP_DBSYSTEMVALUES_SQLITE = "sqlite";
var TMP_DBSYSTEMVALUES_SYBASE = "sybase";
var TMP_DBSYSTEMVALUES_TERADATA = "teradata";
var TMP_DBSYSTEMVALUES_VERTICA = "vertica";
var TMP_DBSYSTEMVALUES_H2 = "h2";
var TMP_DBSYSTEMVALUES_COLDFUSION = "coldfusion";
var TMP_DBSYSTEMVALUES_CASSANDRA = "cassandra";
var TMP_DBSYSTEMVALUES_HBASE = "hbase";
var TMP_DBSYSTEMVALUES_MONGODB = "mongodb";
var TMP_DBSYSTEMVALUES_REDIS = "redis";
var TMP_DBSYSTEMVALUES_COUCHBASE = "couchbase";
var TMP_DBSYSTEMVALUES_COUCHDB = "couchdb";
var TMP_DBSYSTEMVALUES_COSMOSDB = "cosmosdb";
var TMP_DBSYSTEMVALUES_DYNAMODB = "dynamodb";
var TMP_DBSYSTEMVALUES_NEO4J = "neo4j";
var TMP_DBSYSTEMVALUES_GEODE = "geode";
var TMP_DBSYSTEMVALUES_ELASTICSEARCH = "elasticsearch";
var TMP_DBSYSTEMVALUES_MEMCACHED = "memcached";
var TMP_DBSYSTEMVALUES_COCKROACHDB = "cockroachdb";
var DBSYSTEMVALUES_OTHER_SQL = TMP_DBSYSTEMVALUES_OTHER_SQL;
var DBSYSTEMVALUES_MSSQL = TMP_DBSYSTEMVALUES_MSSQL;
var DBSYSTEMVALUES_MYSQL = TMP_DBSYSTEMVALUES_MYSQL;
var DBSYSTEMVALUES_ORACLE = TMP_DBSYSTEMVALUES_ORACLE;
var DBSYSTEMVALUES_DB2 = TMP_DBSYSTEMVALUES_DB2;
var DBSYSTEMVALUES_POSTGRESQL = TMP_DBSYSTEMVALUES_POSTGRESQL;
var DBSYSTEMVALUES_REDSHIFT = TMP_DBSYSTEMVALUES_REDSHIFT;
var DBSYSTEMVALUES_HIVE = TMP_DBSYSTEMVALUES_HIVE;
var DBSYSTEMVALUES_CLOUDSCAPE = TMP_DBSYSTEMVALUES_CLOUDSCAPE;
var DBSYSTEMVALUES_HSQLDB = TMP_DBSYSTEMVALUES_HSQLDB;
var DBSYSTEMVALUES_PROGRESS = TMP_DBSYSTEMVALUES_PROGRESS;
var DBSYSTEMVALUES_MAXDB = TMP_DBSYSTEMVALUES_MAXDB;
var DBSYSTEMVALUES_HANADB = TMP_DBSYSTEMVALUES_HANADB;
var DBSYSTEMVALUES_INGRES = TMP_DBSYSTEMVALUES_INGRES;
var DBSYSTEMVALUES_FIRSTSQL = TMP_DBSYSTEMVALUES_FIRSTSQL;
var DBSYSTEMVALUES_EDB = TMP_DBSYSTEMVALUES_EDB;
var DBSYSTEMVALUES_CACHE = TMP_DBSYSTEMVALUES_CACHE;
var DBSYSTEMVALUES_ADABAS = TMP_DBSYSTEMVALUES_ADABAS;
var DBSYSTEMVALUES_FIREBIRD = TMP_DBSYSTEMVALUES_FIREBIRD;
var DBSYSTEMVALUES_DERBY = TMP_DBSYSTEMVALUES_DERBY;
var DBSYSTEMVALUES_FILEMAKER = TMP_DBSYSTEMVALUES_FILEMAKER;
var DBSYSTEMVALUES_INFORMIX = TMP_DBSYSTEMVALUES_INFORMIX;
var DBSYSTEMVALUES_INSTANTDB = TMP_DBSYSTEMVALUES_INSTANTDB;
var DBSYSTEMVALUES_INTERBASE = TMP_DBSYSTEMVALUES_INTERBASE;
var DBSYSTEMVALUES_MARIADB = TMP_DBSYSTEMVALUES_MARIADB;
var DBSYSTEMVALUES_NETEZZA = TMP_DBSYSTEMVALUES_NETEZZA;
var DBSYSTEMVALUES_PERVASIVE = TMP_DBSYSTEMVALUES_PERVASIVE;
var DBSYSTEMVALUES_POINTBASE = TMP_DBSYSTEMVALUES_POINTBASE;
var DBSYSTEMVALUES_SQLITE = TMP_DBSYSTEMVALUES_SQLITE;
var DBSYSTEMVALUES_SYBASE = TMP_DBSYSTEMVALUES_SYBASE;
var DBSYSTEMVALUES_TERADATA = TMP_DBSYSTEMVALUES_TERADATA;
var DBSYSTEMVALUES_VERTICA = TMP_DBSYSTEMVALUES_VERTICA;
var DBSYSTEMVALUES_H2 = TMP_DBSYSTEMVALUES_H2;
var DBSYSTEMVALUES_COLDFUSION = TMP_DBSYSTEMVALUES_COLDFUSION;
var DBSYSTEMVALUES_CASSANDRA = TMP_DBSYSTEMVALUES_CASSANDRA;
var DBSYSTEMVALUES_HBASE = TMP_DBSYSTEMVALUES_HBASE;
var DBSYSTEMVALUES_MONGODB = TMP_DBSYSTEMVALUES_MONGODB;
var DBSYSTEMVALUES_REDIS = TMP_DBSYSTEMVALUES_REDIS;
var DBSYSTEMVALUES_COUCHBASE = TMP_DBSYSTEMVALUES_COUCHBASE;
var DBSYSTEMVALUES_COUCHDB = TMP_DBSYSTEMVALUES_COUCHDB;
var DBSYSTEMVALUES_COSMOSDB = TMP_DBSYSTEMVALUES_COSMOSDB;
var DBSYSTEMVALUES_DYNAMODB = TMP_DBSYSTEMVALUES_DYNAMODB;
var DBSYSTEMVALUES_NEO4J = TMP_DBSYSTEMVALUES_NEO4J;
var DBSYSTEMVALUES_GEODE = TMP_DBSYSTEMVALUES_GEODE;
var DBSYSTEMVALUES_ELASTICSEARCH = TMP_DBSYSTEMVALUES_ELASTICSEARCH;
var DBSYSTEMVALUES_MEMCACHED = TMP_DBSYSTEMVALUES_MEMCACHED;
var DBSYSTEMVALUES_COCKROACHDB = TMP_DBSYSTEMVALUES_COCKROACHDB;
var DbSystemValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_DBSYSTEMVALUES_OTHER_SQL,
    TMP_DBSYSTEMVALUES_MSSQL,
    TMP_DBSYSTEMVALUES_MYSQL,
    TMP_DBSYSTEMVALUES_ORACLE,
    TMP_DBSYSTEMVALUES_DB2,
    TMP_DBSYSTEMVALUES_POSTGRESQL,
    TMP_DBSYSTEMVALUES_REDSHIFT,
    TMP_DBSYSTEMVALUES_HIVE,
    TMP_DBSYSTEMVALUES_CLOUDSCAPE,
    TMP_DBSYSTEMVALUES_HSQLDB,
    TMP_DBSYSTEMVALUES_PROGRESS,
    TMP_DBSYSTEMVALUES_MAXDB,
    TMP_DBSYSTEMVALUES_HANADB,
    TMP_DBSYSTEMVALUES_INGRES,
    TMP_DBSYSTEMVALUES_FIRSTSQL,
    TMP_DBSYSTEMVALUES_EDB,
    TMP_DBSYSTEMVALUES_CACHE,
    TMP_DBSYSTEMVALUES_ADABAS,
    TMP_DBSYSTEMVALUES_FIREBIRD,
    TMP_DBSYSTEMVALUES_DERBY,
    TMP_DBSYSTEMVALUES_FILEMAKER,
    TMP_DBSYSTEMVALUES_INFORMIX,
    TMP_DBSYSTEMVALUES_INSTANTDB,
    TMP_DBSYSTEMVALUES_INTERBASE,
    TMP_DBSYSTEMVALUES_MARIADB,
    TMP_DBSYSTEMVALUES_NETEZZA,
    TMP_DBSYSTEMVALUES_PERVASIVE,
    TMP_DBSYSTEMVALUES_POINTBASE,
    TMP_DBSYSTEMVALUES_SQLITE,
    TMP_DBSYSTEMVALUES_SYBASE,
    TMP_DBSYSTEMVALUES_TERADATA,
    TMP_DBSYSTEMVALUES_VERTICA,
    TMP_DBSYSTEMVALUES_H2,
    TMP_DBSYSTEMVALUES_COLDFUSION,
    TMP_DBSYSTEMVALUES_CASSANDRA,
    TMP_DBSYSTEMVALUES_HBASE,
    TMP_DBSYSTEMVALUES_MONGODB,
    TMP_DBSYSTEMVALUES_REDIS,
    TMP_DBSYSTEMVALUES_COUCHBASE,
    TMP_DBSYSTEMVALUES_COUCHDB,
    TMP_DBSYSTEMVALUES_COSMOSDB,
    TMP_DBSYSTEMVALUES_DYNAMODB,
    TMP_DBSYSTEMVALUES_NEO4J,
    TMP_DBSYSTEMVALUES_GEODE,
    TMP_DBSYSTEMVALUES_ELASTICSEARCH,
    TMP_DBSYSTEMVALUES_MEMCACHED,
    TMP_DBSYSTEMVALUES_COCKROACHDB
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbCassandraConsistencyLevelValues enum definition
 *
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL = "all";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = "each_quorum";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = "quorum";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = "local_quorum";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE = "one";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO = "two";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE = "three";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = "local_one";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY = "any";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = "serial";
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = "local_serial";
var DBCASSANDRACONSISTENCYLEVELVALUES_ALL = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL;
var DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM;
var DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM;
var DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM;
var DBCASSANDRACONSISTENCYLEVELVALUES_ONE = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE;
var DBCASSANDRACONSISTENCYLEVELVALUES_TWO = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO;
var DBCASSANDRACONSISTENCYLEVELVALUES_THREE = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE;
var DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE;
var DBCASSANDRACONSISTENCYLEVELVALUES_ANY = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY;
var DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL;
var DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL;
var DbCassandraConsistencyLevelValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasTriggerValues enum definition
 *
 * Type of the trigger on which the function is executed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_FAASTRIGGERVALUES_DATASOURCE = "datasource";
var TMP_FAASTRIGGERVALUES_HTTP = "http";
var TMP_FAASTRIGGERVALUES_PUBSUB = "pubsub";
var TMP_FAASTRIGGERVALUES_TIMER = "timer";
var TMP_FAASTRIGGERVALUES_OTHER = "other";
var FAASTRIGGERVALUES_DATASOURCE = TMP_FAASTRIGGERVALUES_DATASOURCE;
var FAASTRIGGERVALUES_HTTP = TMP_FAASTRIGGERVALUES_HTTP;
var FAASTRIGGERVALUES_PUBSUB = TMP_FAASTRIGGERVALUES_PUBSUB;
var FAASTRIGGERVALUES_TIMER = TMP_FAASTRIGGERVALUES_TIMER;
var FAASTRIGGERVALUES_OTHER = TMP_FAASTRIGGERVALUES_OTHER;
var FaasTriggerValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_FAASTRIGGERVALUES_DATASOURCE,
    TMP_FAASTRIGGERVALUES_HTTP,
    TMP_FAASTRIGGERVALUES_PUBSUB,
    TMP_FAASTRIGGERVALUES_TIMER,
    TMP_FAASTRIGGERVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasDocumentOperationValues enum definition
 *
 * Describes the type of the operation that was performed on the data.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_FAASDOCUMENTOPERATIONVALUES_INSERT = "insert";
var TMP_FAASDOCUMENTOPERATIONVALUES_EDIT = "edit";
var TMP_FAASDOCUMENTOPERATIONVALUES_DELETE = "delete";
var FAASDOCUMENTOPERATIONVALUES_INSERT = TMP_FAASDOCUMENTOPERATIONVALUES_INSERT;
var FAASDOCUMENTOPERATIONVALUES_EDIT = TMP_FAASDOCUMENTOPERATIONVALUES_EDIT;
var FAASDOCUMENTOPERATIONVALUES_DELETE = TMP_FAASDOCUMENTOPERATIONVALUES_DELETE;
var FaasDocumentOperationValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_FAASDOCUMENTOPERATIONVALUES_INSERT,
    TMP_FAASDOCUMENTOPERATIONVALUES_EDIT,
    TMP_FAASDOCUMENTOPERATIONVALUES_DELETE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasInvokedProviderValues enum definition
 *
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = "alibaba_cloud";
var TMP_FAASINVOKEDPROVIDERVALUES_AWS = "aws";
var TMP_FAASINVOKEDPROVIDERVALUES_AZURE = "azure";
var TMP_FAASINVOKEDPROVIDERVALUES_GCP = "gcp";
var FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD;
var FAASINVOKEDPROVIDERVALUES_AWS = TMP_FAASINVOKEDPROVIDERVALUES_AWS;
var FAASINVOKEDPROVIDERVALUES_AZURE = TMP_FAASINVOKEDPROVIDERVALUES_AZURE;
var FAASINVOKEDPROVIDERVALUES_GCP = TMP_FAASINVOKEDPROVIDERVALUES_GCP;
var FaasInvokedProviderValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
    TMP_FAASINVOKEDPROVIDERVALUES_AWS,
    TMP_FAASINVOKEDPROVIDERVALUES_AZURE,
    TMP_FAASINVOKEDPROVIDERVALUES_GCP
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetTransportValues enum definition
 *
 * Transport protocol used. See note below.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_NETTRANSPORTVALUES_IP_TCP = "ip_tcp";
var TMP_NETTRANSPORTVALUES_IP_UDP = "ip_udp";
var TMP_NETTRANSPORTVALUES_IP = "ip";
var TMP_NETTRANSPORTVALUES_UNIX = "unix";
var TMP_NETTRANSPORTVALUES_PIPE = "pipe";
var TMP_NETTRANSPORTVALUES_INPROC = "inproc";
var TMP_NETTRANSPORTVALUES_OTHER = "other";
var NETTRANSPORTVALUES_IP_TCP = TMP_NETTRANSPORTVALUES_IP_TCP;
var NETTRANSPORTVALUES_IP_UDP = TMP_NETTRANSPORTVALUES_IP_UDP;
var NETTRANSPORTVALUES_IP = TMP_NETTRANSPORTVALUES_IP;
var NETTRANSPORTVALUES_UNIX = TMP_NETTRANSPORTVALUES_UNIX;
var NETTRANSPORTVALUES_PIPE = TMP_NETTRANSPORTVALUES_PIPE;
var NETTRANSPORTVALUES_INPROC = TMP_NETTRANSPORTVALUES_INPROC;
var NETTRANSPORTVALUES_OTHER = TMP_NETTRANSPORTVALUES_OTHER;
var NetTransportValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_NETTRANSPORTVALUES_IP_TCP,
    TMP_NETTRANSPORTVALUES_IP_UDP,
    TMP_NETTRANSPORTVALUES_IP,
    TMP_NETTRANSPORTVALUES_UNIX,
    TMP_NETTRANSPORTVALUES_PIPE,
    TMP_NETTRANSPORTVALUES_INPROC,
    TMP_NETTRANSPORTVALUES_OTHER
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionTypeValues enum definition
 *
 * The internet connection type currently being used by the host.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI = "wifi";
var TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED = "wired";
var TMP_NETHOSTCONNECTIONTYPEVALUES_CELL = "cell";
var TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = "unavailable";
var TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = "unknown";
var NETHOSTCONNECTIONTYPEVALUES_WIFI = TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI;
var NETHOSTCONNECTIONTYPEVALUES_WIRED = TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED;
var NETHOSTCONNECTIONTYPEVALUES_CELL = TMP_NETHOSTCONNECTIONTYPEVALUES_CELL;
var NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE;
var NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN;
var NetHostConnectionTypeValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI,
    TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED,
    TMP_NETHOSTCONNECTIONTYPEVALUES_CELL,
    TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
    TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionSubtypeValues enum definition
 *
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = "gprs";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = "edge";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = "umts";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = "cdma";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = "evdo_0";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = "evdo_a";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = "cdma2000_1xrtt";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = "hsdpa";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = "hsupa";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = "hspa";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = "iden";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = "evdo_b";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE = "lte";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = "ehrpd";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = "hspap";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM = "gsm";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = "td_scdma";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = "iwlan";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR = "nr";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = "nrnsa";
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = "lte_ca";
var NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS;
var NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE;
var NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS;
var NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA;
var NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0;
var NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A;
var NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT;
var NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA;
var NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA;
var NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA;
var NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN;
var NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B;
var NETHOSTCONNECTIONSUBTYPEVALUES_LTE = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE;
var NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD;
var NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP;
var NETHOSTCONNECTIONSUBTYPEVALUES_GSM = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM;
var NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA;
var NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN;
var NETHOSTCONNECTIONSUBTYPEVALUES_NR = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR;
var NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA;
var NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA;
var NetHostConnectionSubtypeValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HttpFlavorValues enum definition
 *
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_HTTPFLAVORVALUES_HTTP_1_0 = "1.0";
var TMP_HTTPFLAVORVALUES_HTTP_1_1 = "1.1";
var TMP_HTTPFLAVORVALUES_HTTP_2_0 = "2.0";
var TMP_HTTPFLAVORVALUES_SPDY = "SPDY";
var TMP_HTTPFLAVORVALUES_QUIC = "QUIC";
var HTTPFLAVORVALUES_HTTP_1_0 = TMP_HTTPFLAVORVALUES_HTTP_1_0;
var HTTPFLAVORVALUES_HTTP_1_1 = TMP_HTTPFLAVORVALUES_HTTP_1_1;
var HTTPFLAVORVALUES_HTTP_2_0 = TMP_HTTPFLAVORVALUES_HTTP_2_0;
var HTTPFLAVORVALUES_SPDY = TMP_HTTPFLAVORVALUES_SPDY;
var HTTPFLAVORVALUES_QUIC = TMP_HTTPFLAVORVALUES_QUIC;
var HttpFlavorValues = {
    HTTP_1_0: TMP_HTTPFLAVORVALUES_HTTP_1_0,
    HTTP_1_1: TMP_HTTPFLAVORVALUES_HTTP_1_1,
    HTTP_2_0: TMP_HTTPFLAVORVALUES_HTTP_2_0,
    SPDY: TMP_HTTPFLAVORVALUES_SPDY,
    QUIC: TMP_HTTPFLAVORVALUES_QUIC
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingDestinationKindValues enum definition
 *
 * The kind of message destination.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE = "queue";
var TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC = "topic";
var MESSAGINGDESTINATIONKINDVALUES_QUEUE = TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE;
var MESSAGINGDESTINATIONKINDVALUES_TOPIC = TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC;
var MessagingDestinationKindValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE,
    TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingOperationValues enum definition
 *
 * A string identifying the kind of message consumption as defined in the [Operation names](#operation-names) section above. If the operation is &#34;send&#34;, this attribute MUST NOT be set, since the operation can be inferred from the span kind in that case.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_MESSAGINGOPERATIONVALUES_RECEIVE = "receive";
var TMP_MESSAGINGOPERATIONVALUES_PROCESS = "process";
var MESSAGINGOPERATIONVALUES_RECEIVE = TMP_MESSAGINGOPERATIONVALUES_RECEIVE;
var MESSAGINGOPERATIONVALUES_PROCESS = TMP_MESSAGINGOPERATIONVALUES_PROCESS;
var MessagingOperationValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_MESSAGINGOPERATIONVALUES_RECEIVE,
    TMP_MESSAGINGOPERATIONVALUES_PROCESS
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for RpcGrpcStatusCodeValues enum definition
 *
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_RPCGRPCSTATUSCODEVALUES_OK = 0;
var TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED = 1;
var TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN = 2;
var TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = 3;
var TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = 4;
var TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND = 5;
var TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = 6;
var TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = 7;
var TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = 8;
var TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = 9;
var TMP_RPCGRPCSTATUSCODEVALUES_ABORTED = 10;
var TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = 11;
var TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = 12;
var TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL = 13;
var TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = 14;
var TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS = 15;
var TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = 16;
var RPCGRPCSTATUSCODEVALUES_OK = TMP_RPCGRPCSTATUSCODEVALUES_OK;
var RPCGRPCSTATUSCODEVALUES_CANCELLED = TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED;
var RPCGRPCSTATUSCODEVALUES_UNKNOWN = TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN;
var RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT;
var RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED;
var RPCGRPCSTATUSCODEVALUES_NOT_FOUND = TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND;
var RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS;
var RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED;
var RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED;
var RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION;
var RPCGRPCSTATUSCODEVALUES_ABORTED = TMP_RPCGRPCSTATUSCODEVALUES_ABORTED;
var RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE;
var RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED;
var RPCGRPCSTATUSCODEVALUES_INTERNAL = TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL;
var RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE;
var RPCGRPCSTATUSCODEVALUES_DATA_LOSS = TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS;
var RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED;
var RpcGrpcStatusCodeValues = {
    OK: TMP_RPCGRPCSTATUSCODEVALUES_OK,
    CANCELLED: TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED,
    UNKNOWN: TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN,
    INVALID_ARGUMENT: TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
    DEADLINE_EXCEEDED: TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
    NOT_FOUND: TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
    ALREADY_EXISTS: TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
    PERMISSION_DENIED: TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
    RESOURCE_EXHAUSTED: TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
    FAILED_PRECONDITION: TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
    ABORTED: TMP_RPCGRPCSTATUSCODEVALUES_ABORTED,
    OUT_OF_RANGE: TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
    UNIMPLEMENTED: TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
    INTERNAL: TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL,
    UNAVAILABLE: TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
    DATA_LOSS: TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
    UNAUTHENTICATED: TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessageTypeValues enum definition
 *
 * Whether this is a received or sent message.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_MESSAGETYPEVALUES_SENT = "SENT";
var TMP_MESSAGETYPEVALUES_RECEIVED = "RECEIVED";
var MESSAGETYPEVALUES_SENT = TMP_MESSAGETYPEVALUES_SENT;
var MESSAGETYPEVALUES_RECEIVED = TMP_MESSAGETYPEVALUES_RECEIVED;
var MessageTypeValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_MESSAGETYPEVALUES_SENT,
    TMP_MESSAGETYPEVALUES_RECEIVED
]);

},{"../internal/utils":"dhcCY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"dhcCY":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a const map from the given values
 * @param values - An array of values to be used as keys and values in the map.
 * @returns A populated version of the map with the values and keys derived from the values.
 */ /*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createConstMap", ()=>createConstMap);
function createConstMap(values) {
    // eslint-disable-next-line prefer-const, @typescript-eslint/no-explicit-any
    var res = {};
    var len = values.length;
    for(var lp = 0; lp < len; lp++){
        var val = values[lp];
        if (val) res[String(val).toUpperCase().replace(/[-.]/g, "_")] = val;
    }
    return res;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fauSj":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _semanticResourceAttributes = require("./SemanticResourceAttributes");
parcelHelpers.exportAll(_semanticResourceAttributes, exports);

},{"./SemanticResourceAttributes":"5riod","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5riod":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEMRESATTRS_CLOUD_PROVIDER", ()=>SEMRESATTRS_CLOUD_PROVIDER);
parcelHelpers.export(exports, "SEMRESATTRS_CLOUD_ACCOUNT_ID", ()=>SEMRESATTRS_CLOUD_ACCOUNT_ID);
parcelHelpers.export(exports, "SEMRESATTRS_CLOUD_REGION", ()=>SEMRESATTRS_CLOUD_REGION);
parcelHelpers.export(exports, "SEMRESATTRS_CLOUD_AVAILABILITY_ZONE", ()=>SEMRESATTRS_CLOUD_AVAILABILITY_ZONE);
parcelHelpers.export(exports, "SEMRESATTRS_CLOUD_PLATFORM", ()=>SEMRESATTRS_CLOUD_PLATFORM);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_ECS_CONTAINER_ARN", ()=>SEMRESATTRS_AWS_ECS_CONTAINER_ARN);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_ECS_CLUSTER_ARN", ()=>SEMRESATTRS_AWS_ECS_CLUSTER_ARN);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_ECS_LAUNCHTYPE", ()=>SEMRESATTRS_AWS_ECS_LAUNCHTYPE);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_ECS_TASK_ARN", ()=>SEMRESATTRS_AWS_ECS_TASK_ARN);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_ECS_TASK_FAMILY", ()=>SEMRESATTRS_AWS_ECS_TASK_FAMILY);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_ECS_TASK_REVISION", ()=>SEMRESATTRS_AWS_ECS_TASK_REVISION);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_EKS_CLUSTER_ARN", ()=>SEMRESATTRS_AWS_EKS_CLUSTER_ARN);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_LOG_GROUP_NAMES", ()=>SEMRESATTRS_AWS_LOG_GROUP_NAMES);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_LOG_GROUP_ARNS", ()=>SEMRESATTRS_AWS_LOG_GROUP_ARNS);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_LOG_STREAM_NAMES", ()=>SEMRESATTRS_AWS_LOG_STREAM_NAMES);
parcelHelpers.export(exports, "SEMRESATTRS_AWS_LOG_STREAM_ARNS", ()=>SEMRESATTRS_AWS_LOG_STREAM_ARNS);
parcelHelpers.export(exports, "SEMRESATTRS_CONTAINER_NAME", ()=>SEMRESATTRS_CONTAINER_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_CONTAINER_ID", ()=>SEMRESATTRS_CONTAINER_ID);
parcelHelpers.export(exports, "SEMRESATTRS_CONTAINER_RUNTIME", ()=>SEMRESATTRS_CONTAINER_RUNTIME);
parcelHelpers.export(exports, "SEMRESATTRS_CONTAINER_IMAGE_NAME", ()=>SEMRESATTRS_CONTAINER_IMAGE_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_CONTAINER_IMAGE_TAG", ()=>SEMRESATTRS_CONTAINER_IMAGE_TAG);
parcelHelpers.export(exports, "SEMRESATTRS_DEPLOYMENT_ENVIRONMENT", ()=>SEMRESATTRS_DEPLOYMENT_ENVIRONMENT);
parcelHelpers.export(exports, "SEMRESATTRS_DEVICE_ID", ()=>SEMRESATTRS_DEVICE_ID);
parcelHelpers.export(exports, "SEMRESATTRS_DEVICE_MODEL_IDENTIFIER", ()=>SEMRESATTRS_DEVICE_MODEL_IDENTIFIER);
parcelHelpers.export(exports, "SEMRESATTRS_DEVICE_MODEL_NAME", ()=>SEMRESATTRS_DEVICE_MODEL_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_FAAS_NAME", ()=>SEMRESATTRS_FAAS_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_FAAS_ID", ()=>SEMRESATTRS_FAAS_ID);
parcelHelpers.export(exports, "SEMRESATTRS_FAAS_VERSION", ()=>SEMRESATTRS_FAAS_VERSION);
parcelHelpers.export(exports, "SEMRESATTRS_FAAS_INSTANCE", ()=>SEMRESATTRS_FAAS_INSTANCE);
parcelHelpers.export(exports, "SEMRESATTRS_FAAS_MAX_MEMORY", ()=>SEMRESATTRS_FAAS_MAX_MEMORY);
parcelHelpers.export(exports, "SEMRESATTRS_HOST_ID", ()=>SEMRESATTRS_HOST_ID);
parcelHelpers.export(exports, "SEMRESATTRS_HOST_NAME", ()=>SEMRESATTRS_HOST_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_HOST_TYPE", ()=>SEMRESATTRS_HOST_TYPE);
parcelHelpers.export(exports, "SEMRESATTRS_HOST_ARCH", ()=>SEMRESATTRS_HOST_ARCH);
parcelHelpers.export(exports, "SEMRESATTRS_HOST_IMAGE_NAME", ()=>SEMRESATTRS_HOST_IMAGE_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_HOST_IMAGE_ID", ()=>SEMRESATTRS_HOST_IMAGE_ID);
parcelHelpers.export(exports, "SEMRESATTRS_HOST_IMAGE_VERSION", ()=>SEMRESATTRS_HOST_IMAGE_VERSION);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_CLUSTER_NAME", ()=>SEMRESATTRS_K8S_CLUSTER_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_NODE_NAME", ()=>SEMRESATTRS_K8S_NODE_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_NODE_UID", ()=>SEMRESATTRS_K8S_NODE_UID);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_NAMESPACE_NAME", ()=>SEMRESATTRS_K8S_NAMESPACE_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_POD_UID", ()=>SEMRESATTRS_K8S_POD_UID);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_POD_NAME", ()=>SEMRESATTRS_K8S_POD_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_CONTAINER_NAME", ()=>SEMRESATTRS_K8S_CONTAINER_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_REPLICASET_UID", ()=>SEMRESATTRS_K8S_REPLICASET_UID);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_REPLICASET_NAME", ()=>SEMRESATTRS_K8S_REPLICASET_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_DEPLOYMENT_UID", ()=>SEMRESATTRS_K8S_DEPLOYMENT_UID);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_DEPLOYMENT_NAME", ()=>SEMRESATTRS_K8S_DEPLOYMENT_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_STATEFULSET_UID", ()=>SEMRESATTRS_K8S_STATEFULSET_UID);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_STATEFULSET_NAME", ()=>SEMRESATTRS_K8S_STATEFULSET_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_DAEMONSET_UID", ()=>SEMRESATTRS_K8S_DAEMONSET_UID);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_DAEMONSET_NAME", ()=>SEMRESATTRS_K8S_DAEMONSET_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_JOB_UID", ()=>SEMRESATTRS_K8S_JOB_UID);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_JOB_NAME", ()=>SEMRESATTRS_K8S_JOB_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_CRONJOB_UID", ()=>SEMRESATTRS_K8S_CRONJOB_UID);
parcelHelpers.export(exports, "SEMRESATTRS_K8S_CRONJOB_NAME", ()=>SEMRESATTRS_K8S_CRONJOB_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_OS_TYPE", ()=>SEMRESATTRS_OS_TYPE);
parcelHelpers.export(exports, "SEMRESATTRS_OS_DESCRIPTION", ()=>SEMRESATTRS_OS_DESCRIPTION);
parcelHelpers.export(exports, "SEMRESATTRS_OS_NAME", ()=>SEMRESATTRS_OS_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_OS_VERSION", ()=>SEMRESATTRS_OS_VERSION);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_PID", ()=>SEMRESATTRS_PROCESS_PID);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_EXECUTABLE_NAME", ()=>SEMRESATTRS_PROCESS_EXECUTABLE_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_EXECUTABLE_PATH", ()=>SEMRESATTRS_PROCESS_EXECUTABLE_PATH);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_COMMAND", ()=>SEMRESATTRS_PROCESS_COMMAND);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_COMMAND_LINE", ()=>SEMRESATTRS_PROCESS_COMMAND_LINE);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_COMMAND_ARGS", ()=>SEMRESATTRS_PROCESS_COMMAND_ARGS);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_OWNER", ()=>SEMRESATTRS_PROCESS_OWNER);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_RUNTIME_NAME", ()=>SEMRESATTRS_PROCESS_RUNTIME_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_RUNTIME_VERSION", ()=>SEMRESATTRS_PROCESS_RUNTIME_VERSION);
parcelHelpers.export(exports, "SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION", ()=>SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION);
parcelHelpers.export(exports, "SEMRESATTRS_SERVICE_NAME", ()=>SEMRESATTRS_SERVICE_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_SERVICE_NAMESPACE", ()=>SEMRESATTRS_SERVICE_NAMESPACE);
parcelHelpers.export(exports, "SEMRESATTRS_SERVICE_INSTANCE_ID", ()=>SEMRESATTRS_SERVICE_INSTANCE_ID);
parcelHelpers.export(exports, "SEMRESATTRS_SERVICE_VERSION", ()=>SEMRESATTRS_SERVICE_VERSION);
parcelHelpers.export(exports, "SEMRESATTRS_TELEMETRY_SDK_NAME", ()=>SEMRESATTRS_TELEMETRY_SDK_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_TELEMETRY_SDK_LANGUAGE", ()=>SEMRESATTRS_TELEMETRY_SDK_LANGUAGE);
parcelHelpers.export(exports, "SEMRESATTRS_TELEMETRY_SDK_VERSION", ()=>SEMRESATTRS_TELEMETRY_SDK_VERSION);
parcelHelpers.export(exports, "SEMRESATTRS_TELEMETRY_AUTO_VERSION", ()=>SEMRESATTRS_TELEMETRY_AUTO_VERSION);
parcelHelpers.export(exports, "SEMRESATTRS_WEBENGINE_NAME", ()=>SEMRESATTRS_WEBENGINE_NAME);
parcelHelpers.export(exports, "SEMRESATTRS_WEBENGINE_VERSION", ()=>SEMRESATTRS_WEBENGINE_VERSION);
parcelHelpers.export(exports, "SEMRESATTRS_WEBENGINE_DESCRIPTION", ()=>SEMRESATTRS_WEBENGINE_DESCRIPTION);
parcelHelpers.export(exports, "SemanticResourceAttributes", ()=>SemanticResourceAttributes);
parcelHelpers.export(exports, "CLOUDPROVIDERVALUES_ALIBABA_CLOUD", ()=>CLOUDPROVIDERVALUES_ALIBABA_CLOUD);
parcelHelpers.export(exports, "CLOUDPROVIDERVALUES_AWS", ()=>CLOUDPROVIDERVALUES_AWS);
parcelHelpers.export(exports, "CLOUDPROVIDERVALUES_AZURE", ()=>CLOUDPROVIDERVALUES_AZURE);
parcelHelpers.export(exports, "CLOUDPROVIDERVALUES_GCP", ()=>CLOUDPROVIDERVALUES_GCP);
parcelHelpers.export(exports, "CloudProviderValues", ()=>CloudProviderValues);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS", ()=>CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC", ()=>CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AWS_EC2", ()=>CLOUDPLATFORMVALUES_AWS_EC2);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AWS_ECS", ()=>CLOUDPLATFORMVALUES_AWS_ECS);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AWS_EKS", ()=>CLOUDPLATFORMVALUES_AWS_EKS);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AWS_LAMBDA", ()=>CLOUDPLATFORMVALUES_AWS_LAMBDA);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK", ()=>CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AZURE_VM", ()=>CLOUDPLATFORMVALUES_AZURE_VM);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES", ()=>CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AZURE_AKS", ()=>CLOUDPLATFORMVALUES_AZURE_AKS);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AZURE_FUNCTIONS", ()=>CLOUDPLATFORMVALUES_AZURE_FUNCTIONS);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_AZURE_APP_SERVICE", ()=>CLOUDPLATFORMVALUES_AZURE_APP_SERVICE);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE", ()=>CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_GCP_CLOUD_RUN", ()=>CLOUDPLATFORMVALUES_GCP_CLOUD_RUN);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE", ()=>CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS", ()=>CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS);
parcelHelpers.export(exports, "CLOUDPLATFORMVALUES_GCP_APP_ENGINE", ()=>CLOUDPLATFORMVALUES_GCP_APP_ENGINE);
parcelHelpers.export(exports, "CloudPlatformValues", ()=>CloudPlatformValues);
parcelHelpers.export(exports, "AWSECSLAUNCHTYPEVALUES_EC2", ()=>AWSECSLAUNCHTYPEVALUES_EC2);
parcelHelpers.export(exports, "AWSECSLAUNCHTYPEVALUES_FARGATE", ()=>AWSECSLAUNCHTYPEVALUES_FARGATE);
parcelHelpers.export(exports, "AwsEcsLaunchtypeValues", ()=>AwsEcsLaunchtypeValues);
parcelHelpers.export(exports, "HOSTARCHVALUES_AMD64", ()=>HOSTARCHVALUES_AMD64);
parcelHelpers.export(exports, "HOSTARCHVALUES_ARM32", ()=>HOSTARCHVALUES_ARM32);
parcelHelpers.export(exports, "HOSTARCHVALUES_ARM64", ()=>HOSTARCHVALUES_ARM64);
parcelHelpers.export(exports, "HOSTARCHVALUES_IA64", ()=>HOSTARCHVALUES_IA64);
parcelHelpers.export(exports, "HOSTARCHVALUES_PPC32", ()=>HOSTARCHVALUES_PPC32);
parcelHelpers.export(exports, "HOSTARCHVALUES_PPC64", ()=>HOSTARCHVALUES_PPC64);
parcelHelpers.export(exports, "HOSTARCHVALUES_X86", ()=>HOSTARCHVALUES_X86);
parcelHelpers.export(exports, "HostArchValues", ()=>HostArchValues);
parcelHelpers.export(exports, "OSTYPEVALUES_WINDOWS", ()=>OSTYPEVALUES_WINDOWS);
parcelHelpers.export(exports, "OSTYPEVALUES_LINUX", ()=>OSTYPEVALUES_LINUX);
parcelHelpers.export(exports, "OSTYPEVALUES_DARWIN", ()=>OSTYPEVALUES_DARWIN);
parcelHelpers.export(exports, "OSTYPEVALUES_FREEBSD", ()=>OSTYPEVALUES_FREEBSD);
parcelHelpers.export(exports, "OSTYPEVALUES_NETBSD", ()=>OSTYPEVALUES_NETBSD);
parcelHelpers.export(exports, "OSTYPEVALUES_OPENBSD", ()=>OSTYPEVALUES_OPENBSD);
parcelHelpers.export(exports, "OSTYPEVALUES_DRAGONFLYBSD", ()=>OSTYPEVALUES_DRAGONFLYBSD);
parcelHelpers.export(exports, "OSTYPEVALUES_HPUX", ()=>OSTYPEVALUES_HPUX);
parcelHelpers.export(exports, "OSTYPEVALUES_AIX", ()=>OSTYPEVALUES_AIX);
parcelHelpers.export(exports, "OSTYPEVALUES_SOLARIS", ()=>OSTYPEVALUES_SOLARIS);
parcelHelpers.export(exports, "OSTYPEVALUES_Z_OS", ()=>OSTYPEVALUES_Z_OS);
parcelHelpers.export(exports, "OsTypeValues", ()=>OsTypeValues);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_CPP", ()=>TELEMETRYSDKLANGUAGEVALUES_CPP);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_DOTNET", ()=>TELEMETRYSDKLANGUAGEVALUES_DOTNET);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_ERLANG", ()=>TELEMETRYSDKLANGUAGEVALUES_ERLANG);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_GO", ()=>TELEMETRYSDKLANGUAGEVALUES_GO);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_JAVA", ()=>TELEMETRYSDKLANGUAGEVALUES_JAVA);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_NODEJS", ()=>TELEMETRYSDKLANGUAGEVALUES_NODEJS);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_PHP", ()=>TELEMETRYSDKLANGUAGEVALUES_PHP);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_PYTHON", ()=>TELEMETRYSDKLANGUAGEVALUES_PYTHON);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_RUBY", ()=>TELEMETRYSDKLANGUAGEVALUES_RUBY);
parcelHelpers.export(exports, "TELEMETRYSDKLANGUAGEVALUES_WEBJS", ()=>TELEMETRYSDKLANGUAGEVALUES_WEBJS);
parcelHelpers.export(exports, "TelemetrySdkLanguageValues", ()=>TelemetrySdkLanguageValues);
var _utils = require("../internal/utils");
//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticResourceAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_CLOUD_PROVIDER = "cloud.provider";
var TMP_CLOUD_ACCOUNT_ID = "cloud.account.id";
var TMP_CLOUD_REGION = "cloud.region";
var TMP_CLOUD_AVAILABILITY_ZONE = "cloud.availability_zone";
var TMP_CLOUD_PLATFORM = "cloud.platform";
var TMP_AWS_ECS_CONTAINER_ARN = "aws.ecs.container.arn";
var TMP_AWS_ECS_CLUSTER_ARN = "aws.ecs.cluster.arn";
var TMP_AWS_ECS_LAUNCHTYPE = "aws.ecs.launchtype";
var TMP_AWS_ECS_TASK_ARN = "aws.ecs.task.arn";
var TMP_AWS_ECS_TASK_FAMILY = "aws.ecs.task.family";
var TMP_AWS_ECS_TASK_REVISION = "aws.ecs.task.revision";
var TMP_AWS_EKS_CLUSTER_ARN = "aws.eks.cluster.arn";
var TMP_AWS_LOG_GROUP_NAMES = "aws.log.group.names";
var TMP_AWS_LOG_GROUP_ARNS = "aws.log.group.arns";
var TMP_AWS_LOG_STREAM_NAMES = "aws.log.stream.names";
var TMP_AWS_LOG_STREAM_ARNS = "aws.log.stream.arns";
var TMP_CONTAINER_NAME = "container.name";
var TMP_CONTAINER_ID = "container.id";
var TMP_CONTAINER_RUNTIME = "container.runtime";
var TMP_CONTAINER_IMAGE_NAME = "container.image.name";
var TMP_CONTAINER_IMAGE_TAG = "container.image.tag";
var TMP_DEPLOYMENT_ENVIRONMENT = "deployment.environment";
var TMP_DEVICE_ID = "device.id";
var TMP_DEVICE_MODEL_IDENTIFIER = "device.model.identifier";
var TMP_DEVICE_MODEL_NAME = "device.model.name";
var TMP_FAAS_NAME = "faas.name";
var TMP_FAAS_ID = "faas.id";
var TMP_FAAS_VERSION = "faas.version";
var TMP_FAAS_INSTANCE = "faas.instance";
var TMP_FAAS_MAX_MEMORY = "faas.max_memory";
var TMP_HOST_ID = "host.id";
var TMP_HOST_NAME = "host.name";
var TMP_HOST_TYPE = "host.type";
var TMP_HOST_ARCH = "host.arch";
var TMP_HOST_IMAGE_NAME = "host.image.name";
var TMP_HOST_IMAGE_ID = "host.image.id";
var TMP_HOST_IMAGE_VERSION = "host.image.version";
var TMP_K8S_CLUSTER_NAME = "k8s.cluster.name";
var TMP_K8S_NODE_NAME = "k8s.node.name";
var TMP_K8S_NODE_UID = "k8s.node.uid";
var TMP_K8S_NAMESPACE_NAME = "k8s.namespace.name";
var TMP_K8S_POD_UID = "k8s.pod.uid";
var TMP_K8S_POD_NAME = "k8s.pod.name";
var TMP_K8S_CONTAINER_NAME = "k8s.container.name";
var TMP_K8S_REPLICASET_UID = "k8s.replicaset.uid";
var TMP_K8S_REPLICASET_NAME = "k8s.replicaset.name";
var TMP_K8S_DEPLOYMENT_UID = "k8s.deployment.uid";
var TMP_K8S_DEPLOYMENT_NAME = "k8s.deployment.name";
var TMP_K8S_STATEFULSET_UID = "k8s.statefulset.uid";
var TMP_K8S_STATEFULSET_NAME = "k8s.statefulset.name";
var TMP_K8S_DAEMONSET_UID = "k8s.daemonset.uid";
var TMP_K8S_DAEMONSET_NAME = "k8s.daemonset.name";
var TMP_K8S_JOB_UID = "k8s.job.uid";
var TMP_K8S_JOB_NAME = "k8s.job.name";
var TMP_K8S_CRONJOB_UID = "k8s.cronjob.uid";
var TMP_K8S_CRONJOB_NAME = "k8s.cronjob.name";
var TMP_OS_TYPE = "os.type";
var TMP_OS_DESCRIPTION = "os.description";
var TMP_OS_NAME = "os.name";
var TMP_OS_VERSION = "os.version";
var TMP_PROCESS_PID = "process.pid";
var TMP_PROCESS_EXECUTABLE_NAME = "process.executable.name";
var TMP_PROCESS_EXECUTABLE_PATH = "process.executable.path";
var TMP_PROCESS_COMMAND = "process.command";
var TMP_PROCESS_COMMAND_LINE = "process.command_line";
var TMP_PROCESS_COMMAND_ARGS = "process.command_args";
var TMP_PROCESS_OWNER = "process.owner";
var TMP_PROCESS_RUNTIME_NAME = "process.runtime.name";
var TMP_PROCESS_RUNTIME_VERSION = "process.runtime.version";
var TMP_PROCESS_RUNTIME_DESCRIPTION = "process.runtime.description";
var TMP_SERVICE_NAME = "service.name";
var TMP_SERVICE_NAMESPACE = "service.namespace";
var TMP_SERVICE_INSTANCE_ID = "service.instance.id";
var TMP_SERVICE_VERSION = "service.version";
var TMP_TELEMETRY_SDK_NAME = "telemetry.sdk.name";
var TMP_TELEMETRY_SDK_LANGUAGE = "telemetry.sdk.language";
var TMP_TELEMETRY_SDK_VERSION = "telemetry.sdk.version";
var TMP_TELEMETRY_AUTO_VERSION = "telemetry.auto.version";
var TMP_WEBENGINE_NAME = "webengine.name";
var TMP_WEBENGINE_VERSION = "webengine.version";
var TMP_WEBENGINE_DESCRIPTION = "webengine.description";
var SEMRESATTRS_CLOUD_PROVIDER = TMP_CLOUD_PROVIDER;
var SEMRESATTRS_CLOUD_ACCOUNT_ID = TMP_CLOUD_ACCOUNT_ID;
var SEMRESATTRS_CLOUD_REGION = TMP_CLOUD_REGION;
var SEMRESATTRS_CLOUD_AVAILABILITY_ZONE = TMP_CLOUD_AVAILABILITY_ZONE;
var SEMRESATTRS_CLOUD_PLATFORM = TMP_CLOUD_PLATFORM;
var SEMRESATTRS_AWS_ECS_CONTAINER_ARN = TMP_AWS_ECS_CONTAINER_ARN;
var SEMRESATTRS_AWS_ECS_CLUSTER_ARN = TMP_AWS_ECS_CLUSTER_ARN;
var SEMRESATTRS_AWS_ECS_LAUNCHTYPE = TMP_AWS_ECS_LAUNCHTYPE;
var SEMRESATTRS_AWS_ECS_TASK_ARN = TMP_AWS_ECS_TASK_ARN;
var SEMRESATTRS_AWS_ECS_TASK_FAMILY = TMP_AWS_ECS_TASK_FAMILY;
var SEMRESATTRS_AWS_ECS_TASK_REVISION = TMP_AWS_ECS_TASK_REVISION;
var SEMRESATTRS_AWS_EKS_CLUSTER_ARN = TMP_AWS_EKS_CLUSTER_ARN;
var SEMRESATTRS_AWS_LOG_GROUP_NAMES = TMP_AWS_LOG_GROUP_NAMES;
var SEMRESATTRS_AWS_LOG_GROUP_ARNS = TMP_AWS_LOG_GROUP_ARNS;
var SEMRESATTRS_AWS_LOG_STREAM_NAMES = TMP_AWS_LOG_STREAM_NAMES;
var SEMRESATTRS_AWS_LOG_STREAM_ARNS = TMP_AWS_LOG_STREAM_ARNS;
var SEMRESATTRS_CONTAINER_NAME = TMP_CONTAINER_NAME;
var SEMRESATTRS_CONTAINER_ID = TMP_CONTAINER_ID;
var SEMRESATTRS_CONTAINER_RUNTIME = TMP_CONTAINER_RUNTIME;
var SEMRESATTRS_CONTAINER_IMAGE_NAME = TMP_CONTAINER_IMAGE_NAME;
var SEMRESATTRS_CONTAINER_IMAGE_TAG = TMP_CONTAINER_IMAGE_TAG;
var SEMRESATTRS_DEPLOYMENT_ENVIRONMENT = TMP_DEPLOYMENT_ENVIRONMENT;
var SEMRESATTRS_DEVICE_ID = TMP_DEVICE_ID;
var SEMRESATTRS_DEVICE_MODEL_IDENTIFIER = TMP_DEVICE_MODEL_IDENTIFIER;
var SEMRESATTRS_DEVICE_MODEL_NAME = TMP_DEVICE_MODEL_NAME;
var SEMRESATTRS_FAAS_NAME = TMP_FAAS_NAME;
var SEMRESATTRS_FAAS_ID = TMP_FAAS_ID;
var SEMRESATTRS_FAAS_VERSION = TMP_FAAS_VERSION;
var SEMRESATTRS_FAAS_INSTANCE = TMP_FAAS_INSTANCE;
var SEMRESATTRS_FAAS_MAX_MEMORY = TMP_FAAS_MAX_MEMORY;
var SEMRESATTRS_HOST_ID = TMP_HOST_ID;
var SEMRESATTRS_HOST_NAME = TMP_HOST_NAME;
var SEMRESATTRS_HOST_TYPE = TMP_HOST_TYPE;
var SEMRESATTRS_HOST_ARCH = TMP_HOST_ARCH;
var SEMRESATTRS_HOST_IMAGE_NAME = TMP_HOST_IMAGE_NAME;
var SEMRESATTRS_HOST_IMAGE_ID = TMP_HOST_IMAGE_ID;
var SEMRESATTRS_HOST_IMAGE_VERSION = TMP_HOST_IMAGE_VERSION;
var SEMRESATTRS_K8S_CLUSTER_NAME = TMP_K8S_CLUSTER_NAME;
var SEMRESATTRS_K8S_NODE_NAME = TMP_K8S_NODE_NAME;
var SEMRESATTRS_K8S_NODE_UID = TMP_K8S_NODE_UID;
var SEMRESATTRS_K8S_NAMESPACE_NAME = TMP_K8S_NAMESPACE_NAME;
var SEMRESATTRS_K8S_POD_UID = TMP_K8S_POD_UID;
var SEMRESATTRS_K8S_POD_NAME = TMP_K8S_POD_NAME;
var SEMRESATTRS_K8S_CONTAINER_NAME = TMP_K8S_CONTAINER_NAME;
var SEMRESATTRS_K8S_REPLICASET_UID = TMP_K8S_REPLICASET_UID;
var SEMRESATTRS_K8S_REPLICASET_NAME = TMP_K8S_REPLICASET_NAME;
var SEMRESATTRS_K8S_DEPLOYMENT_UID = TMP_K8S_DEPLOYMENT_UID;
var SEMRESATTRS_K8S_DEPLOYMENT_NAME = TMP_K8S_DEPLOYMENT_NAME;
var SEMRESATTRS_K8S_STATEFULSET_UID = TMP_K8S_STATEFULSET_UID;
var SEMRESATTRS_K8S_STATEFULSET_NAME = TMP_K8S_STATEFULSET_NAME;
var SEMRESATTRS_K8S_DAEMONSET_UID = TMP_K8S_DAEMONSET_UID;
var SEMRESATTRS_K8S_DAEMONSET_NAME = TMP_K8S_DAEMONSET_NAME;
var SEMRESATTRS_K8S_JOB_UID = TMP_K8S_JOB_UID;
var SEMRESATTRS_K8S_JOB_NAME = TMP_K8S_JOB_NAME;
var SEMRESATTRS_K8S_CRONJOB_UID = TMP_K8S_CRONJOB_UID;
var SEMRESATTRS_K8S_CRONJOB_NAME = TMP_K8S_CRONJOB_NAME;
var SEMRESATTRS_OS_TYPE = TMP_OS_TYPE;
var SEMRESATTRS_OS_DESCRIPTION = TMP_OS_DESCRIPTION;
var SEMRESATTRS_OS_NAME = TMP_OS_NAME;
var SEMRESATTRS_OS_VERSION = TMP_OS_VERSION;
var SEMRESATTRS_PROCESS_PID = TMP_PROCESS_PID;
var SEMRESATTRS_PROCESS_EXECUTABLE_NAME = TMP_PROCESS_EXECUTABLE_NAME;
var SEMRESATTRS_PROCESS_EXECUTABLE_PATH = TMP_PROCESS_EXECUTABLE_PATH;
var SEMRESATTRS_PROCESS_COMMAND = TMP_PROCESS_COMMAND;
var SEMRESATTRS_PROCESS_COMMAND_LINE = TMP_PROCESS_COMMAND_LINE;
var SEMRESATTRS_PROCESS_COMMAND_ARGS = TMP_PROCESS_COMMAND_ARGS;
var SEMRESATTRS_PROCESS_OWNER = TMP_PROCESS_OWNER;
var SEMRESATTRS_PROCESS_RUNTIME_NAME = TMP_PROCESS_RUNTIME_NAME;
var SEMRESATTRS_PROCESS_RUNTIME_VERSION = TMP_PROCESS_RUNTIME_VERSION;
var SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION = TMP_PROCESS_RUNTIME_DESCRIPTION;
var SEMRESATTRS_SERVICE_NAME = TMP_SERVICE_NAME;
var SEMRESATTRS_SERVICE_NAMESPACE = TMP_SERVICE_NAMESPACE;
var SEMRESATTRS_SERVICE_INSTANCE_ID = TMP_SERVICE_INSTANCE_ID;
var SEMRESATTRS_SERVICE_VERSION = TMP_SERVICE_VERSION;
var SEMRESATTRS_TELEMETRY_SDK_NAME = TMP_TELEMETRY_SDK_NAME;
var SEMRESATTRS_TELEMETRY_SDK_LANGUAGE = TMP_TELEMETRY_SDK_LANGUAGE;
var SEMRESATTRS_TELEMETRY_SDK_VERSION = TMP_TELEMETRY_SDK_VERSION;
var SEMRESATTRS_TELEMETRY_AUTO_VERSION = TMP_TELEMETRY_AUTO_VERSION;
var SEMRESATTRS_WEBENGINE_NAME = TMP_WEBENGINE_NAME;
var SEMRESATTRS_WEBENGINE_VERSION = TMP_WEBENGINE_VERSION;
var SEMRESATTRS_WEBENGINE_DESCRIPTION = TMP_WEBENGINE_DESCRIPTION;
var SemanticResourceAttributes = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_CLOUD_PROVIDER,
    TMP_CLOUD_ACCOUNT_ID,
    TMP_CLOUD_REGION,
    TMP_CLOUD_AVAILABILITY_ZONE,
    TMP_CLOUD_PLATFORM,
    TMP_AWS_ECS_CONTAINER_ARN,
    TMP_AWS_ECS_CLUSTER_ARN,
    TMP_AWS_ECS_LAUNCHTYPE,
    TMP_AWS_ECS_TASK_ARN,
    TMP_AWS_ECS_TASK_FAMILY,
    TMP_AWS_ECS_TASK_REVISION,
    TMP_AWS_EKS_CLUSTER_ARN,
    TMP_AWS_LOG_GROUP_NAMES,
    TMP_AWS_LOG_GROUP_ARNS,
    TMP_AWS_LOG_STREAM_NAMES,
    TMP_AWS_LOG_STREAM_ARNS,
    TMP_CONTAINER_NAME,
    TMP_CONTAINER_ID,
    TMP_CONTAINER_RUNTIME,
    TMP_CONTAINER_IMAGE_NAME,
    TMP_CONTAINER_IMAGE_TAG,
    TMP_DEPLOYMENT_ENVIRONMENT,
    TMP_DEVICE_ID,
    TMP_DEVICE_MODEL_IDENTIFIER,
    TMP_DEVICE_MODEL_NAME,
    TMP_FAAS_NAME,
    TMP_FAAS_ID,
    TMP_FAAS_VERSION,
    TMP_FAAS_INSTANCE,
    TMP_FAAS_MAX_MEMORY,
    TMP_HOST_ID,
    TMP_HOST_NAME,
    TMP_HOST_TYPE,
    TMP_HOST_ARCH,
    TMP_HOST_IMAGE_NAME,
    TMP_HOST_IMAGE_ID,
    TMP_HOST_IMAGE_VERSION,
    TMP_K8S_CLUSTER_NAME,
    TMP_K8S_NODE_NAME,
    TMP_K8S_NODE_UID,
    TMP_K8S_NAMESPACE_NAME,
    TMP_K8S_POD_UID,
    TMP_K8S_POD_NAME,
    TMP_K8S_CONTAINER_NAME,
    TMP_K8S_REPLICASET_UID,
    TMP_K8S_REPLICASET_NAME,
    TMP_K8S_DEPLOYMENT_UID,
    TMP_K8S_DEPLOYMENT_NAME,
    TMP_K8S_STATEFULSET_UID,
    TMP_K8S_STATEFULSET_NAME,
    TMP_K8S_DAEMONSET_UID,
    TMP_K8S_DAEMONSET_NAME,
    TMP_K8S_JOB_UID,
    TMP_K8S_JOB_NAME,
    TMP_K8S_CRONJOB_UID,
    TMP_K8S_CRONJOB_NAME,
    TMP_OS_TYPE,
    TMP_OS_DESCRIPTION,
    TMP_OS_NAME,
    TMP_OS_VERSION,
    TMP_PROCESS_PID,
    TMP_PROCESS_EXECUTABLE_NAME,
    TMP_PROCESS_EXECUTABLE_PATH,
    TMP_PROCESS_COMMAND,
    TMP_PROCESS_COMMAND_LINE,
    TMP_PROCESS_COMMAND_ARGS,
    TMP_PROCESS_OWNER,
    TMP_PROCESS_RUNTIME_NAME,
    TMP_PROCESS_RUNTIME_VERSION,
    TMP_PROCESS_RUNTIME_DESCRIPTION,
    TMP_SERVICE_NAME,
    TMP_SERVICE_NAMESPACE,
    TMP_SERVICE_INSTANCE_ID,
    TMP_SERVICE_VERSION,
    TMP_TELEMETRY_SDK_NAME,
    TMP_TELEMETRY_SDK_LANGUAGE,
    TMP_TELEMETRY_SDK_VERSION,
    TMP_TELEMETRY_AUTO_VERSION,
    TMP_WEBENGINE_NAME,
    TMP_WEBENGINE_VERSION,
    TMP_WEBENGINE_DESCRIPTION
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudProviderValues enum definition
 *
 * Name of the cloud provider.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD = "alibaba_cloud";
var TMP_CLOUDPROVIDERVALUES_AWS = "aws";
var TMP_CLOUDPROVIDERVALUES_AZURE = "azure";
var TMP_CLOUDPROVIDERVALUES_GCP = "gcp";
var CLOUDPROVIDERVALUES_ALIBABA_CLOUD = TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD;
var CLOUDPROVIDERVALUES_AWS = TMP_CLOUDPROVIDERVALUES_AWS;
var CLOUDPROVIDERVALUES_AZURE = TMP_CLOUDPROVIDERVALUES_AZURE;
var CLOUDPROVIDERVALUES_GCP = TMP_CLOUDPROVIDERVALUES_GCP;
var CloudProviderValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD,
    TMP_CLOUDPROVIDERVALUES_AWS,
    TMP_CLOUDPROVIDERVALUES_AZURE,
    TMP_CLOUDPROVIDERVALUES_GCP
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudPlatformValues enum definition
 *
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = "alibaba_cloud_ecs";
var TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = "alibaba_cloud_fc";
var TMP_CLOUDPLATFORMVALUES_AWS_EC2 = "aws_ec2";
var TMP_CLOUDPLATFORMVALUES_AWS_ECS = "aws_ecs";
var TMP_CLOUDPLATFORMVALUES_AWS_EKS = "aws_eks";
var TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA = "aws_lambda";
var TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = "aws_elastic_beanstalk";
var TMP_CLOUDPLATFORMVALUES_AZURE_VM = "azure_vm";
var TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = "azure_container_instances";
var TMP_CLOUDPLATFORMVALUES_AZURE_AKS = "azure_aks";
var TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = "azure_functions";
var TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = "azure_app_service";
var TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = "gcp_compute_engine";
var TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = "gcp_cloud_run";
var TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = "gcp_kubernetes_engine";
var TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = "gcp_cloud_functions";
var TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE = "gcp_app_engine";
var CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS;
var CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC;
var CLOUDPLATFORMVALUES_AWS_EC2 = TMP_CLOUDPLATFORMVALUES_AWS_EC2;
var CLOUDPLATFORMVALUES_AWS_ECS = TMP_CLOUDPLATFORMVALUES_AWS_ECS;
var CLOUDPLATFORMVALUES_AWS_EKS = TMP_CLOUDPLATFORMVALUES_AWS_EKS;
var CLOUDPLATFORMVALUES_AWS_LAMBDA = TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA;
var CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK;
var CLOUDPLATFORMVALUES_AZURE_VM = TMP_CLOUDPLATFORMVALUES_AZURE_VM;
var CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES;
var CLOUDPLATFORMVALUES_AZURE_AKS = TMP_CLOUDPLATFORMVALUES_AZURE_AKS;
var CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS;
var CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE;
var CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE;
var CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN;
var CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE;
var CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS;
var CLOUDPLATFORMVALUES_GCP_APP_ENGINE = TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE;
var CloudPlatformValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS,
    TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC,
    TMP_CLOUDPLATFORMVALUES_AWS_EC2,
    TMP_CLOUDPLATFORMVALUES_AWS_ECS,
    TMP_CLOUDPLATFORMVALUES_AWS_EKS,
    TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA,
    TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK,
    TMP_CLOUDPLATFORMVALUES_AZURE_VM,
    TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES,
    TMP_CLOUDPLATFORMVALUES_AZURE_AKS,
    TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS,
    TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE,
    TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE,
    TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN,
    TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE,
    TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS,
    TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for AwsEcsLaunchtypeValues enum definition
 *
 * The [launch type](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/launch_types.html) for an ECS task.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_AWSECSLAUNCHTYPEVALUES_EC2 = "ec2";
var TMP_AWSECSLAUNCHTYPEVALUES_FARGATE = "fargate";
var AWSECSLAUNCHTYPEVALUES_EC2 = TMP_AWSECSLAUNCHTYPEVALUES_EC2;
var AWSECSLAUNCHTYPEVALUES_FARGATE = TMP_AWSECSLAUNCHTYPEVALUES_FARGATE;
var AwsEcsLaunchtypeValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_AWSECSLAUNCHTYPEVALUES_EC2,
    TMP_AWSECSLAUNCHTYPEVALUES_FARGATE
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HostArchValues enum definition
 *
 * The CPU architecture the host system is running on.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_HOSTARCHVALUES_AMD64 = "amd64";
var TMP_HOSTARCHVALUES_ARM32 = "arm32";
var TMP_HOSTARCHVALUES_ARM64 = "arm64";
var TMP_HOSTARCHVALUES_IA64 = "ia64";
var TMP_HOSTARCHVALUES_PPC32 = "ppc32";
var TMP_HOSTARCHVALUES_PPC64 = "ppc64";
var TMP_HOSTARCHVALUES_X86 = "x86";
var HOSTARCHVALUES_AMD64 = TMP_HOSTARCHVALUES_AMD64;
var HOSTARCHVALUES_ARM32 = TMP_HOSTARCHVALUES_ARM32;
var HOSTARCHVALUES_ARM64 = TMP_HOSTARCHVALUES_ARM64;
var HOSTARCHVALUES_IA64 = TMP_HOSTARCHVALUES_IA64;
var HOSTARCHVALUES_PPC32 = TMP_HOSTARCHVALUES_PPC32;
var HOSTARCHVALUES_PPC64 = TMP_HOSTARCHVALUES_PPC64;
var HOSTARCHVALUES_X86 = TMP_HOSTARCHVALUES_X86;
var HostArchValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_HOSTARCHVALUES_AMD64,
    TMP_HOSTARCHVALUES_ARM32,
    TMP_HOSTARCHVALUES_ARM64,
    TMP_HOSTARCHVALUES_IA64,
    TMP_HOSTARCHVALUES_PPC32,
    TMP_HOSTARCHVALUES_PPC64,
    TMP_HOSTARCHVALUES_X86
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for OsTypeValues enum definition
 *
 * The operating system type.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_OSTYPEVALUES_WINDOWS = "windows";
var TMP_OSTYPEVALUES_LINUX = "linux";
var TMP_OSTYPEVALUES_DARWIN = "darwin";
var TMP_OSTYPEVALUES_FREEBSD = "freebsd";
var TMP_OSTYPEVALUES_NETBSD = "netbsd";
var TMP_OSTYPEVALUES_OPENBSD = "openbsd";
var TMP_OSTYPEVALUES_DRAGONFLYBSD = "dragonflybsd";
var TMP_OSTYPEVALUES_HPUX = "hpux";
var TMP_OSTYPEVALUES_AIX = "aix";
var TMP_OSTYPEVALUES_SOLARIS = "solaris";
var TMP_OSTYPEVALUES_Z_OS = "z_os";
var OSTYPEVALUES_WINDOWS = TMP_OSTYPEVALUES_WINDOWS;
var OSTYPEVALUES_LINUX = TMP_OSTYPEVALUES_LINUX;
var OSTYPEVALUES_DARWIN = TMP_OSTYPEVALUES_DARWIN;
var OSTYPEVALUES_FREEBSD = TMP_OSTYPEVALUES_FREEBSD;
var OSTYPEVALUES_NETBSD = TMP_OSTYPEVALUES_NETBSD;
var OSTYPEVALUES_OPENBSD = TMP_OSTYPEVALUES_OPENBSD;
var OSTYPEVALUES_DRAGONFLYBSD = TMP_OSTYPEVALUES_DRAGONFLYBSD;
var OSTYPEVALUES_HPUX = TMP_OSTYPEVALUES_HPUX;
var OSTYPEVALUES_AIX = TMP_OSTYPEVALUES_AIX;
var OSTYPEVALUES_SOLARIS = TMP_OSTYPEVALUES_SOLARIS;
var OSTYPEVALUES_Z_OS = TMP_OSTYPEVALUES_Z_OS;
var OsTypeValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_OSTYPEVALUES_WINDOWS,
    TMP_OSTYPEVALUES_LINUX,
    TMP_OSTYPEVALUES_DARWIN,
    TMP_OSTYPEVALUES_FREEBSD,
    TMP_OSTYPEVALUES_NETBSD,
    TMP_OSTYPEVALUES_OPENBSD,
    TMP_OSTYPEVALUES_DRAGONFLYBSD,
    TMP_OSTYPEVALUES_HPUX,
    TMP_OSTYPEVALUES_AIX,
    TMP_OSTYPEVALUES_SOLARIS,
    TMP_OSTYPEVALUES_Z_OS
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for TelemetrySdkLanguageValues enum definition
 *
 * The language of the telemetry SDK.
 * ---------------------------------------------------------------------------------------------------------- */ // Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifable export names for some package types
var TMP_TELEMETRYSDKLANGUAGEVALUES_CPP = "cpp";
var TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET = "dotnet";
var TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG = "erlang";
var TMP_TELEMETRYSDKLANGUAGEVALUES_GO = "go";
var TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA = "java";
var TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS = "nodejs";
var TMP_TELEMETRYSDKLANGUAGEVALUES_PHP = "php";
var TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON = "python";
var TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY = "ruby";
var TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS = "webjs";
var TELEMETRYSDKLANGUAGEVALUES_CPP = TMP_TELEMETRYSDKLANGUAGEVALUES_CPP;
var TELEMETRYSDKLANGUAGEVALUES_DOTNET = TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET;
var TELEMETRYSDKLANGUAGEVALUES_ERLANG = TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG;
var TELEMETRYSDKLANGUAGEVALUES_GO = TMP_TELEMETRYSDKLANGUAGEVALUES_GO;
var TELEMETRYSDKLANGUAGEVALUES_JAVA = TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA;
var TELEMETRYSDKLANGUAGEVALUES_NODEJS = TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS;
var TELEMETRYSDKLANGUAGEVALUES_PHP = TMP_TELEMETRYSDKLANGUAGEVALUES_PHP;
var TELEMETRYSDKLANGUAGEVALUES_PYTHON = TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON;
var TELEMETRYSDKLANGUAGEVALUES_RUBY = TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY;
var TELEMETRYSDKLANGUAGEVALUES_WEBJS = TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS;
var TelemetrySdkLanguageValues = /*#__PURE__*/ (0, _utils.createConstMap)([
    TMP_TELEMETRYSDKLANGUAGEVALUES_CPP,
    TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET,
    TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG,
    TMP_TELEMETRYSDKLANGUAGEVALUES_GO,
    TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA,
    TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS,
    TMP_TELEMETRYSDKLANGUAGEVALUES_PHP,
    TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON,
    TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY,
    TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS
]);

},{"../internal/utils":"dhcCY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3dAF0":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unrefTimer", ()=>unrefTimer);
function unrefTimer(_timer) {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"kwXBf":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3D2xL":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExportResultCode", ()=>ExportResultCode);
var ExportResultCode;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})(ExportResultCode || (ExportResultCode = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5JKPh":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompositePropagator", ()=>CompositePropagator);
var _api = require("@opentelemetry/api");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/** Combines multiple propagators into a single propagator. */ var CompositePropagator = /** @class */ function() {
    /**
     * Construct a composite propagator from a list of propagators.
     *
     * @param [config] Configuration object for composite propagator
     */ function CompositePropagator(config) {
        if (config === void 0) config = {};
        var _a;
        this._propagators = (_a = config.propagators) !== null && _a !== void 0 ? _a : [];
        this._fields = Array.from(new Set(this._propagators// older propagators may not have fields function, null check to be sure
        .map(function(p) {
            return typeof p.fields === "function" ? p.fields() : [];
        }).reduce(function(x, y) {
            return x.concat(y);
        }, [])));
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same carrier key, the propagator later in the list
     * will "win".
     *
     * @param context Context to inject
     * @param carrier Carrier into which context will be injected
     */ CompositePropagator.prototype.inject = function(context, carrier, setter) {
        var e_1, _a;
        try {
            for(var _b = __values(this._propagators), _c = _b.next(); !_c.done; _c = _b.next()){
                var propagator = _c.value;
                try {
                    propagator.inject(context, carrier, setter);
                } catch (err) {
                    (0, _api.diag).warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same context key, the propagator later in the list
     * will "win".
     *
     * @param context Context to add values to
     * @param carrier Carrier from which to extract context
     */ CompositePropagator.prototype.extract = function(context, carrier, getter) {
        return this._propagators.reduce(function(ctx, propagator) {
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                (0, _api.diag).warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
            }
            return ctx;
        }, context);
    };
    CompositePropagator.prototype.fields = function() {
        // return a new array so our fields cannot be modified
        return this._fields.slice();
    };
    return CompositePropagator;
}();

},{"@opentelemetry/api":"4682l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"llidR":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACE_PARENT_HEADER", ()=>TRACE_PARENT_HEADER);
parcelHelpers.export(exports, "TRACE_STATE_HEADER", ()=>TRACE_STATE_HEADER);
/**
 * Parses information from the [traceparent] span tag and converts it into {@link SpanContext}
 * @param traceParent - A meta property that comes from server.
 *     It should be dynamically generated server side to have the server's request trace Id,
 *     a parent span Id that was set on the server's request span,
 *     and the trace flags to indicate the server's sampling decision
 *     (01 = sampled, 00 = not sampled).
 *     for example: '{version}-{traceId}-{spanId}-{sampleDecision}'
 *     For more information see {@link https://www.w3.org/TR/trace-context/}
 */ parcelHelpers.export(exports, "parseTraceParent", ()=>parseTraceParent);
parcelHelpers.export(exports, "W3CTraceContextPropagator", ()=>W3CTraceContextPropagator);
var _api = require("@opentelemetry/api");
var _suppressTracing = require("./suppress-tracing");
var _traceState = require("./TraceState");
var TRACE_PARENT_HEADER = "traceparent";
var TRACE_STATE_HEADER = "tracestate";
var VERSION = "00";
var VERSION_PART = "(?!ff)[\\da-f]{2}";
var TRACE_ID_PART = "(?![0]{32})[\\da-f]{32}";
var PARENT_ID_PART = "(?![0]{16})[\\da-f]{16}";
var FLAGS_PART = "[\\da-f]{2}";
var TRACE_PARENT_REGEX = new RegExp("^\\s?(" + VERSION_PART + ")-(" + TRACE_ID_PART + ")-(" + PARENT_ID_PART + ")-(" + FLAGS_PART + ")(-.*)?\\s?$");
function parseTraceParent(traceParent) {
    var match = TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === "00" && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
/**
 * Propagates {@link SpanContext} through Trace Context format propagation.
 *
 * Based on the Trace Context specification:
 * https://www.w3.org/TR/trace-context/
 */ var W3CTraceContextPropagator = /** @class */ function() {
    function W3CTraceContextPropagator() {}
    W3CTraceContextPropagator.prototype.inject = function(context, carrier, setter) {
        var spanContext = (0, _api.trace).getSpanContext(context);
        if (!spanContext || (0, _suppressTracing.isTracingSuppressed)(context) || !(0, _api.isSpanContextValid)(spanContext)) return;
        var traceParent = VERSION + "-" + spanContext.traceId + "-" + spanContext.spanId + "-0" + Number(spanContext.traceFlags || (0, _api.TraceFlags).NONE).toString(16);
        setter.set(carrier, TRACE_PARENT_HEADER, traceParent);
        if (spanContext.traceState) setter.set(carrier, TRACE_STATE_HEADER, spanContext.traceState.serialize());
    };
    W3CTraceContextPropagator.prototype.extract = function(context, carrier, getter) {
        var traceParentHeader = getter.get(carrier, TRACE_PARENT_HEADER);
        if (!traceParentHeader) return context;
        var traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== "string") return context;
        var spanContext = parseTraceParent(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        var traceStateHeader = getter.get(carrier, TRACE_STATE_HEADER);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            var state = Array.isArray(traceStateHeader) ? traceStateHeader.join(",") : traceStateHeader;
            spanContext.traceState = new (0, _traceState.TraceState)(typeof state === "string" ? state : undefined);
        }
        return (0, _api.trace).setSpanContext(context, spanContext);
    };
    W3CTraceContextPropagator.prototype.fields = function() {
        return [
            TRACE_PARENT_HEADER,
            TRACE_STATE_HEADER
        ];
    };
    return W3CTraceContextPropagator;
}();

},{"@opentelemetry/api":"4682l","./suppress-tracing":"7QbzJ","./TraceState":"bV3YT","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bV3YT":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceState", ()=>TraceState);
var _validators = require("../internal/validators");
var MAX_TRACE_STATE_ITEMS = 32;
var MAX_TRACE_STATE_LEN = 512;
var LIST_MEMBERS_SEPARATOR = ",";
var LIST_MEMBER_KEY_VALUE_SPLITTER = "=";
/**
 * TraceState must be a class and not a simple object type because of the spec
 * requirement (https://www.w3.org/TR/trace-context/#tracestate-field).
 *
 * Here is the list of allowed mutations:
 * - New key-value pair should be added into the beginning of the list
 * - The value of any key can be updated. Modified keys MUST be moved to the
 * beginning of the list.
 */ var TraceState = /** @class */ function() {
    function TraceState(rawTraceState) {
        this._internalState = new Map();
        if (rawTraceState) this._parse(rawTraceState);
    }
    TraceState.prototype.set = function(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        var traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    };
    TraceState.prototype.unset = function(key) {
        var traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    };
    TraceState.prototype.get = function(key) {
        return this._internalState.get(key);
    };
    TraceState.prototype.serialize = function() {
        var _this = this;
        return this._keys().reduce(function(agg, key) {
            agg.push(key + LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
            return agg;
        }, []).join(LIST_MEMBERS_SEPARATOR);
    };
    TraceState.prototype._parse = function(rawTraceState) {
        if (rawTraceState.length > MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split(LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce(function(agg, part) {
            var listMember = part.trim(); // Optional Whitespace (OWS) handling
            var i = listMember.indexOf(LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if ((0, _validators.validateKey)(key) && (0, _validators.validateValue)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, MAX_TRACE_STATE_ITEMS));
    };
    TraceState.prototype._keys = function() {
        return Array.from(this._internalState.keys()).reverse();
    };
    TraceState.prototype._clone = function() {
        var traceState = new TraceState();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    };
    return TraceState;
}();

},{"../internal/validators":"5MEtO","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5MEtO":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Key is opaque string up to 256 characters printable. It MUST begin with a
 * lowercase letter, and can only contain lowercase letters a-z, digits 0-9,
 * underscores _, dashes -, asterisks *, and forward slashes /.
 * For multi-tenant vendor scenarios, an at sign (@) can be used to prefix the
 * vendor name. Vendors SHOULD set the tenant ID at the beginning of the key.
 * see https://www.w3.org/TR/trace-context/#key
 */ parcelHelpers.export(exports, "validateKey", ()=>validateKey);
/**
 * Value is opaque string up to 256 characters printable ASCII RFC0020
 * characters (i.e., the range 0x20 to 0x7E) except comma , and =.
 */ parcelHelpers.export(exports, "validateValue", ()=>validateValue);
var VALID_KEY_CHAR_RANGE = "[_0-9a-z-*/]";
var VALID_KEY = "[a-z]" + VALID_KEY_CHAR_RANGE + "{0,255}";
var VALID_VENDOR_KEY = "[a-z0-9]" + VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + VALID_KEY_CHAR_RANGE + "{0,13}";
var VALID_KEY_REGEX = new RegExp("^(?:" + VALID_KEY + "|" + VALID_VENDOR_KEY + ")$");
var VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
var INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function validateKey(key) {
    return VALID_KEY_REGEX.test(key);
}
function validateValue(value) {
    return VALID_VALUE_BASE_REGEX.test(value) && !INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bF2f1":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"S6jok":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RPCType", ()=>RPCType);
parcelHelpers.export(exports, "setRPCMetadata", ()=>setRPCMetadata);
parcelHelpers.export(exports, "deleteRPCMetadata", ()=>deleteRPCMetadata);
parcelHelpers.export(exports, "getRPCMetadata", ()=>getRPCMetadata);
var _api = require("@opentelemetry/api");
var RPC_METADATA_KEY = (0, _api.createContextKey)("OpenTelemetry SDK Context Key RPC_METADATA");
var RPCType;
(function(RPCType) {
    RPCType["HTTP"] = "http";
})(RPCType || (RPCType = {}));
function setRPCMetadata(context, meta) {
    return context.setValue(RPC_METADATA_KEY, meta);
}
function deleteRPCMetadata(context) {
    return context.deleteValue(RPC_METADATA_KEY);
}
function getRPCMetadata(context) {
    return context.getValue(RPC_METADATA_KEY);
}

},{"@opentelemetry/api":"4682l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9zDpZ":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlwaysOffSampler", ()=>AlwaysOffSampler);
var _api = require("@opentelemetry/api");
/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 * Sampler that samples no traces.
 */ var AlwaysOffSampler = /** @class */ function() {
    function AlwaysOffSampler() {}
    AlwaysOffSampler.prototype.shouldSample = function() {
        return {
            decision: (0, _api.SamplingDecision).NOT_RECORD
        };
    };
    AlwaysOffSampler.prototype.toString = function() {
        return "AlwaysOffSampler";
    };
    return AlwaysOffSampler;
}();

},{"@opentelemetry/api":"4682l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eqc9R":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlwaysOnSampler", ()=>AlwaysOnSampler);
var _api = require("@opentelemetry/api");
/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 * Sampler that samples all traces.
 */ var AlwaysOnSampler = /** @class */ function() {
    function AlwaysOnSampler() {}
    AlwaysOnSampler.prototype.shouldSample = function() {
        return {
            decision: (0, _api.SamplingDecision).RECORD_AND_SAMPLED
        };
    };
    AlwaysOnSampler.prototype.toString = function() {
        return "AlwaysOnSampler";
    };
    return AlwaysOnSampler;
}();

},{"@opentelemetry/api":"4682l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"g5ZVj":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParentBasedSampler", ()=>ParentBasedSampler);
var _api = require("@opentelemetry/api");
var _globalErrorHandler = require("../../common/global-error-handler");
var _alwaysOffSampler = require("./AlwaysOffSampler");
var _alwaysOnSampler = require("./AlwaysOnSampler");
/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 * A composite sampler that either respects the parent span's sampling decision
 * or delegates to `delegateSampler` for root spans.
 */ var ParentBasedSampler = /** @class */ function() {
    function ParentBasedSampler(config) {
        var _a, _b, _c, _d;
        this._root = config.root;
        if (!this._root) {
            (0, _globalErrorHandler.globalErrorHandler)(new Error("ParentBasedSampler must have a root sampler configured"));
            this._root = new (0, _alwaysOnSampler.AlwaysOnSampler)();
        }
        this._remoteParentSampled = (_a = config.remoteParentSampled) !== null && _a !== void 0 ? _a : new (0, _alwaysOnSampler.AlwaysOnSampler)();
        this._remoteParentNotSampled = (_b = config.remoteParentNotSampled) !== null && _b !== void 0 ? _b : new (0, _alwaysOffSampler.AlwaysOffSampler)();
        this._localParentSampled = (_c = config.localParentSampled) !== null && _c !== void 0 ? _c : new (0, _alwaysOnSampler.AlwaysOnSampler)();
        this._localParentNotSampled = (_d = config.localParentNotSampled) !== null && _d !== void 0 ? _d : new (0, _alwaysOffSampler.AlwaysOffSampler)();
    }
    ParentBasedSampler.prototype.shouldSample = function(context, traceId, spanName, spanKind, attributes, links) {
        var parentContext = (0, _api.trace).getSpanContext(context);
        if (!parentContext || !(0, _api.isSpanContextValid)(parentContext)) return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & (0, _api.TraceFlags).SAMPLED) return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & (0, _api.TraceFlags).SAMPLED) return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    };
    ParentBasedSampler.prototype.toString = function() {
        return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    };
    return ParentBasedSampler;
}();

},{"@opentelemetry/api":"4682l","../../common/global-error-handler":"8Z2x3","./AlwaysOffSampler":"9zDpZ","./AlwaysOnSampler":"eqc9R","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"50jG1":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceIdRatioBasedSampler", ()=>TraceIdRatioBasedSampler);
var _api = require("@opentelemetry/api");
/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 * Sampler that samples a given fraction of traces based of trace id deterministically.
 */ var TraceIdRatioBasedSampler = /** @class */ function() {
    function TraceIdRatioBasedSampler(_ratio) {
        if (_ratio === void 0) _ratio = 0;
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    TraceIdRatioBasedSampler.prototype.shouldSample = function(context, traceId) {
        return {
            decision: (0, _api.isValidTraceId)(traceId) && this._accumulate(traceId) < this._upperBound ? (0, _api.SamplingDecision).RECORD_AND_SAMPLED : (0, _api.SamplingDecision).NOT_RECORD
        };
    };
    TraceIdRatioBasedSampler.prototype.toString = function() {
        return "TraceIdRatioBased{" + this._ratio + "}";
    };
    TraceIdRatioBasedSampler.prototype._normalize = function(ratio) {
        if (typeof ratio !== "number" || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    };
    TraceIdRatioBasedSampler.prototype._accumulate = function(traceId) {
        var accumulation = 0;
        for(var i = 0; i < traceId.length / 8; i++){
            var pos = i * 8;
            var part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    };
    return TraceIdRatioBasedSampler;
}();

},{"@opentelemetry/api":"4682l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8lAwC":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges objects together
 * @param args - objects / values to be merged
 */ parcelHelpers.export(exports, "merge", ()=>merge);
var _lodashMerge = require("./lodash.merge");
var MAX_LEVEL = 20;
function merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var result = args.shift();
    var objects = new WeakMap();
    while(args.length > 0)result = mergeTwoObjects(result, args.shift(), 0, objects);
    return result;
}
function takeValue(value) {
    if (isArray(value)) return value.slice();
    return value;
}
/**
 * Merges two objects
 * @param one - first object
 * @param two - second object
 * @param level - current deep level
 * @param objects - objects holder that has been already referenced - to prevent
 * cyclic dependency
 */ function mergeTwoObjects(one, two, level, objects) {
    if (level === void 0) level = 0;
    var result;
    if (level > MAX_LEVEL) return undefined;
    level++;
    if (isPrimitive(one) || isPrimitive(two) || isFunction(two)) result = takeValue(two);
    else if (isArray(one)) {
        result = one.slice();
        if (isArray(two)) for(var i = 0, j = two.length; i < j; i++)result.push(takeValue(two[i]));
        else if (isObject(two)) {
            var keys = Object.keys(two);
            for(var i = 0, j = keys.length; i < j; i++){
                var key = keys[i];
                result[key] = takeValue(two[key]);
            }
        }
    } else if (isObject(one)) {
        if (isObject(two)) {
            if (!shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            var keys = Object.keys(two);
            for(var i = 0, j = keys.length; i < j; i++){
                var key = keys[i];
                var twoValue = two[key];
                if (isPrimitive(twoValue)) {
                    if (typeof twoValue === "undefined") delete result[key];
                    else // result[key] = takeValue(twoValue);
                    result[key] = twoValue;
                } else {
                    var obj1 = result[key];
                    var obj2 = twoValue;
                    if (wasObjectReferenced(one, key, objects) || wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if (isObject(obj1) && isObject(obj2)) {
                            var arr1 = objects.get(obj1) || [];
                            var arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
/**
 * Function to check if object has been already reference
 * @param obj
 * @param key
 * @param objects
 */ function wasObjectReferenced(obj, key, objects) {
    var arr = objects.get(obj[key]) || [];
    for(var i = 0, j = arr.length; i < j; i++){
        var info = arr[i];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function isArray(value) {
    return Array.isArray(value);
}
function isFunction(value) {
    return typeof value === "function";
}
function isObject(value) {
    return !isPrimitive(value) && !isArray(value) && !isFunction(value) && typeof value === "object";
}
function isPrimitive(value) {
    return typeof value === "string" || typeof value === "number" || typeof value === "boolean" || typeof value === "undefined" || value instanceof Date || value instanceof RegExp || value === null;
}
function shouldMerge(one, two) {
    if (!(0, _lodashMerge.isPlainObject)(one) || !(0, _lodashMerge.isPlainObject)(two)) return false;
    return true;
}

},{"./lodash.merge":"c2vLy","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"c2vLy":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * based on lodash in order to support esm builds without esModuleInterop.
 * lodash is using MIT License.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
var objectTag = "[object Object]";
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var funcProto = Function.prototype;
var funcToString = funcProto.toString;
var objectCtorString = funcToString.call(Object);
var getPrototype = overArg(Object.getPrototypeOf, Object);
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var nativeObjectToString = objectProto.toString;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) !== objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) === objectCtorString;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    var unmasked = false;
    try {
        value[symToStringTag] = undefined;
        unmasked = true;
    } catch (e) {
    // silence
    }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1pUZO":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutError", ()=>TimeoutError);
/**
 * Adds a timeout to a promise and rejects if the specified timeout has elapsed. Also rejects if the specified promise
 * rejects, and resolves if the specified promise resolves.
 *
 * <p> NOTE: this operation will continue even after it throws a {@link TimeoutError}.
 *
 * @param promise promise to use with timeout.
 * @param timeout the timeout in milliseconds until the returned promise is rejected.
 */ parcelHelpers.export(exports, "callWithTimeout", ()=>callWithTimeout);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Error that is thrown on timeouts.
 */ var TimeoutError = /** @class */ function(_super) {
    __extends(TimeoutError, _super);
    function TimeoutError(message) {
        var _this = _super.call(this, message) || this;
        // manually adjust prototype to retain `instanceof` functionality when targeting ES5, see:
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, TimeoutError.prototype);
        return _this;
    }
    return TimeoutError;
}(Error);
function callWithTimeout(promise, timeout) {
    var timeoutHandle;
    var timeoutPromise = new Promise(function timeoutFunction(_resolve, reject) {
        timeoutHandle = setTimeout(function timeoutHandler() {
            reject(new TimeoutError("Operation timed out."));
        }, timeout);
    });
    return Promise.race([
        promise,
        timeoutPromise
    ]).then(function(result) {
        clearTimeout(timeoutHandle);
        return result;
    }, function(reason) {
        clearTimeout(timeoutHandle);
        throw reason;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6pR04":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelHelpers.export(exports, "urlMatches", ()=>urlMatches);
/**
 * Check if {@param url} should be ignored when comparing against {@param ignoredUrls}
 * @param url
 * @param ignoredUrls
 */ parcelHelpers.export(exports, "isUrlIgnored", ()=>isUrlIgnored);
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function urlMatches(url, urlToMatch) {
    if (typeof urlToMatch === "string") return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function isUrlIgnored(url, ignoredUrls) {
    var e_1, _a;
    if (!ignoredUrls) return false;
    try {
        for(var ignoredUrls_1 = __values(ignoredUrls), ignoredUrls_1_1 = ignoredUrls_1.next(); !ignoredUrls_1_1.done; ignoredUrls_1_1 = ignoredUrls_1.next()){
            var ignoreUrl = ignoredUrls_1_1.value;
            if (urlMatches(url, ignoreUrl)) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (ignoredUrls_1_1 && !ignoredUrls_1_1.done && (_a = ignoredUrls_1.return)) _a.call(ignoredUrls_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"csOqU":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks if certain function has been already wrapped
 * @param func
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWrapped", ()=>isWrapped);
function isWrapped(func) {
    return typeof func === "function" && typeof func.__original === "function" && typeof func.__unwrap === "function" && func.__wrapped === true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ivfjj":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BindOnceFuture", ()=>BindOnceFuture);
var _promise = require("./promise");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Bind the callback and only invoke the callback once regardless how many times `BindOnceFuture.call` is invoked.
 */ var BindOnceFuture = /** @class */ function() {
    function BindOnceFuture(_callback, _that) {
        this._callback = _callback;
        this._that = _that;
        this._isCalled = false;
        this._deferred = new (0, _promise.Deferred)();
    }
    Object.defineProperty(BindOnceFuture.prototype, "isCalled", {
        get: function() {
            return this._isCalled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindOnceFuture.prototype, "promise", {
        get: function() {
            return this._deferred.promise;
        },
        enumerable: false,
        configurable: true
    });
    BindOnceFuture.prototype.call = function() {
        var _a;
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve((_a = this._callback).call.apply(_a, __spreadArray([
                    this._that
                ], __read(args), false))).then(function(val) {
                    return _this._deferred.resolve(val);
                }, function(err) {
                    return _this._deferred.reject(err);
                });
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    };
    return BindOnceFuture;
}();

},{"./promise":"gDSRU","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gDSRU":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Deferred", ()=>Deferred);
var Deferred = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this._promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    Deferred.prototype.resolve = function(val) {
        this._resolve(val);
    };
    Deferred.prototype.reject = function(err) {
        this._reject(err);
    };
    return Deferred;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8nXNE":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @internal
 * Shared functionality used by Exporters while exporting data, including suppression of Traces.
 */ parcelHelpers.export(exports, "_export", ()=>_export);
var _api = require("@opentelemetry/api");
var _suppressTracing = require("../trace/suppress-tracing");
function _export(exporter, arg) {
    return new Promise(function(resolve) {
        // prevent downstream exporter calls from generating spans
        (0, _api.context).with((0, _suppressTracing.suppressTracing)((0, _api.context).active()), function() {
            exporter.export(arg, function(result) {
                resolve(result);
            });
        });
    });
}

},{"@opentelemetry/api":"4682l","../trace/suppress-tracing":"7QbzJ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7NQb2":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Span", ()=>Span);
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
var _semanticConventions = require("@opentelemetry/semantic-conventions");
var _enums = require("./enums");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * This class represents a span.
 */ var Span = /** @class */ function() {
    /**
     * Constructs a new Span instance.
     *
     * @deprecated calling Span constructor directly is not supported. Please use tracer.startSpan.
     * */ function Span(parentTracer, context, spanName, spanContext, kind, parentSpanId, links, startTime, _deprecatedClock, attributes) {
        if (links === void 0) links = [];
        this.attributes = {};
        this.links = [];
        this.events = [];
        this._droppedAttributesCount = 0;
        this._droppedEventsCount = 0;
        this._droppedLinksCount = 0;
        this.status = {
            code: (0, _api.SpanStatusCode).UNSET
        };
        this.endTime = [
            0,
            0
        ];
        this._ended = false;
        this._duration = [
            -1,
            -1
        ];
        this.name = spanName;
        this._spanContext = spanContext;
        this.parentSpanId = parentSpanId;
        this.kind = kind;
        this.links = links;
        var now = Date.now();
        this._performanceStartTime = (0, _core.otperformance).now();
        this._performanceOffset = now - (this._performanceStartTime + (0, _core.getTimeOrigin)());
        this._startTimeProvided = startTime != null;
        this.startTime = this._getTime(startTime !== null && startTime !== void 0 ? startTime : now);
        this.resource = parentTracer.resource;
        this.instrumentationLibrary = parentTracer.instrumentationLibrary;
        this._spanLimits = parentTracer.getSpanLimits();
        this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0;
        if (attributes != null) this.setAttributes(attributes);
        this._spanProcessor = parentTracer.getActiveSpanProcessor();
        this._spanProcessor.onStart(this, context);
    }
    Span.prototype.spanContext = function() {
        return this._spanContext;
    };
    Span.prototype.setAttribute = function(key, value) {
        if (value == null || this._isSpanEnded()) return this;
        if (key.length === 0) {
            (0, _api.diag).warn("Invalid attribute key: " + key);
            return this;
        }
        if (!(0, _core.isAttributeValue)(value)) {
            (0, _api.diag).warn("Invalid attribute value set for key: " + key);
            return this;
        }
        if (Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    };
    Span.prototype.setAttributes = function(attributes) {
        var e_1, _a;
        try {
            for(var _b = __values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = __read(_c.value, 2), k = _d[0], v = _d[1];
                this.setAttribute(k, v);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    /**
     *
     * @param name Span Name
     * @param [attributesOrStartTime] Span attributes or start time
     *     if type is {@type TimeInput} and 3rd param is undefined
     * @param [timeStamp] Specified time stamp for the event
     */ Span.prototype.addEvent = function(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded()) return this;
        if (this._spanLimits.eventCountLimit === 0) {
            (0, _api.diag).warn("No events allowed.");
            this._droppedEventsCount++;
            return this;
        }
        if (this.events.length >= this._spanLimits.eventCountLimit) {
            if (this._droppedEventsCount === 0) (0, _api.diag).debug("Dropping extra events.");
            this.events.shift();
            this._droppedEventsCount++;
        }
        if ((0, _core.isTimeInput)(attributesOrStartTime)) {
            if (!(0, _core.isTimeInput)(timeStamp)) timeStamp = attributesOrStartTime;
            attributesOrStartTime = undefined;
        }
        var attributes = (0, _core.sanitizeAttributes)(attributesOrStartTime);
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0
        });
        return this;
    };
    Span.prototype.addLink = function(link) {
        this.links.push(link);
        return this;
    };
    Span.prototype.addLinks = function(links) {
        var _a;
        (_a = this.links).push.apply(_a, __spreadArray([], __read(links), false));
        return this;
    };
    Span.prototype.setStatus = function(status) {
        if (this._isSpanEnded()) return this;
        this.status = status;
        return this;
    };
    Span.prototype.updateName = function(name) {
        if (this._isSpanEnded()) return this;
        this.name = name;
        return this;
    };
    Span.prototype.end = function(endTime) {
        if (this._isSpanEnded()) {
            (0, _api.diag).error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
            return;
        }
        this._ended = true;
        this.endTime = this._getTime(endTime);
        this._duration = (0, _core.hrTimeDuration)(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            (0, _api.diag).warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [
                0,
                0
            ];
        }
        if (this._droppedEventsCount > 0) (0, _api.diag).warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached");
        this._spanProcessor.onEnd(this);
    };
    Span.prototype._getTime = function(inp) {
        if (typeof inp === "number" && inp < (0, _core.otperformance).now()) // must be a performance timestamp
        // apply correction and convert to hrtime
        return (0, _core.hrTime)(inp + this._performanceOffset);
        if (typeof inp === "number") return (0, _core.millisToHrTime)(inp);
        if (inp instanceof Date) return (0, _core.millisToHrTime)(inp.getTime());
        if ((0, _core.isTimeInputHrTime)(inp)) return inp;
        if (this._startTimeProvided) // if user provided a time for the start manually
        // we can't use duration to calculate event/end times
        return (0, _core.millisToHrTime)(Date.now());
        var msDuration = (0, _core.otperformance).now() - this._performanceStartTime;
        return (0, _core.addHrTimes)(this.startTime, (0, _core.millisToHrTime)(msDuration));
    };
    Span.prototype.isRecording = function() {
        return this._ended === false;
    };
    Span.prototype.recordException = function(exception, time) {
        var attributes = {};
        if (typeof exception === "string") attributes[0, _semanticConventions.SEMATTRS_EXCEPTION_MESSAGE] = exception;
        else if (exception) {
            if (exception.code) attributes[0, _semanticConventions.SEMATTRS_EXCEPTION_TYPE] = exception.code.toString();
            else if (exception.name) attributes[0, _semanticConventions.SEMATTRS_EXCEPTION_TYPE] = exception.name;
            if (exception.message) attributes[0, _semanticConventions.SEMATTRS_EXCEPTION_MESSAGE] = exception.message;
            if (exception.stack) attributes[0, _semanticConventions.SEMATTRS_EXCEPTION_STACKTRACE] = exception.stack;
        }
        // these are minimum requirements from spec
        if (attributes[0, _semanticConventions.SEMATTRS_EXCEPTION_TYPE] || attributes[0, _semanticConventions.SEMATTRS_EXCEPTION_MESSAGE]) this.addEvent((0, _enums.ExceptionEventName), attributes, time);
        else (0, _api.diag).warn("Failed to record an exception " + exception);
    };
    Object.defineProperty(Span.prototype, "duration", {
        get: function() {
            return this._duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "ended", {
        get: function() {
            return this._ended;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedAttributesCount", {
        get: function() {
            return this._droppedAttributesCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedEventsCount", {
        get: function() {
            return this._droppedEventsCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedLinksCount", {
        get: function() {
            return this._droppedLinksCount;
        },
        enumerable: false,
        configurable: true
    });
    Span.prototype._isSpanEnded = function() {
        if (this._ended) (0, _api.diag).warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}");
        return this._ended;
    };
    // Utility function to truncate given value within size
    // for value type of string, will truncate to given limit
    // for type of non-string, will return same value
    Span.prototype._truncateToLimitUtil = function(value, limit) {
        if (value.length <= limit) return value;
        return value.substr(0, limit);
    };
    /**
     * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
     * return string with truncated to {@code attributeValueLengthLimit} characters
     *
     * If the given attribute value is array of strings then
     * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
     *
     * Otherwise return same Attribute {@code value}
     *
     * @param value Attribute value
     * @returns truncated attribute value if required, otherwise same value
     */ Span.prototype._truncateToSize = function(value) {
        var _this = this;
        var limit = this._attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            (0, _api.diag).warn("Attribute value limit must be positive, got " + limit);
            return value;
        }
        // String
        if (typeof value === "string") return this._truncateToLimitUtil(value, limit);
        // Array of strings
        if (Array.isArray(value)) return value.map(function(val) {
            return typeof val === "string" ? _this._truncateToLimitUtil(val, limit) : val;
        });
        // Other types, no need to apply value length limit
        return value;
    };
    return Span;
}();

},{"@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","@opentelemetry/semantic-conventions":"1OyVc","./enums":"8qpXp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8qpXp":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Event name definitions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExceptionEventName", ()=>ExceptionEventName);
var ExceptionEventName = "exception";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k2KV8":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Function to merge Default configuration (as specified in './config') with
 * user provided configurations.
 */ parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
/**
 * When general limits are provided and model specific limits are not,
 * configures the model specific limits by using the values from the general ones.
 * @param userConfig User provided tracer configuration
 */ parcelHelpers.export(exports, "reconfigureLimits", ()=>reconfigureLimits);
var _config = require("./config");
var _core = require("@opentelemetry/core");
function mergeConfig(userConfig) {
    var perInstanceDefaults = {
        sampler: (0, _config.buildSamplerFromEnv)()
    };
    var DEFAULT_CONFIG = (0, _config.loadDefaultConfig)();
    var target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function reconfigureLimits(userConfig) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var spanLimits = Object.assign({}, userConfig.spanLimits);
    var parsedEnvConfig = (0, _core.getEnvWithoutDefaults)();
    /**
     * Reassign span attribute count limit to use first non null value defined by user or use default value
     */ spanLimits.attributeCountLimit = (_f = (_e = (_d = (_b = (_a = userConfig.spanLimits) === null || _a === void 0 ? void 0 : _a.attributeCountLimit) !== null && _b !== void 0 ? _b : (_c = userConfig.generalLimits) === null || _c === void 0 ? void 0 : _c.attributeCountLimit) !== null && _d !== void 0 ? _d : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && _e !== void 0 ? _e : parsedEnvConfig.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && _f !== void 0 ? _f : (0, _core.DEFAULT_ATTRIBUTE_COUNT_LIMIT);
    /**
     * Reassign span attribute value length limit to use first non null value defined by user or use default value
     */ spanLimits.attributeValueLengthLimit = (_m = (_l = (_k = (_h = (_g = userConfig.spanLimits) === null || _g === void 0 ? void 0 : _g.attributeValueLengthLimit) !== null && _h !== void 0 ? _h : (_j = userConfig.generalLimits) === null || _j === void 0 ? void 0 : _j.attributeValueLengthLimit) !== null && _k !== void 0 ? _k : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _l !== void 0 ? _l : parsedEnvConfig.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _m !== void 0 ? _m : (0, _core.DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT);
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}

},{"./config":"5QvbE","@opentelemetry/core":"6xVk8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5QvbE":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Load default configuration. For fields with primitive values, any user-provided
 * value will override the corresponding default value. For fields with
 * non-primitive values (like `spanLimits`), the user-provided value will be
 * used to extend the default value.
 */ // object needs to be wrapped in this function and called when needed otherwise
// envs are parsed before tests are ran - causes tests using these envs to fail
parcelHelpers.export(exports, "loadDefaultConfig", ()=>loadDefaultConfig);
/**
 * Based on environment, builds a sampler, complies with specification.
 * @param environment optional, by default uses getEnv(), but allows passing a value to reuse parsed environment
 */ parcelHelpers.export(exports, "buildSamplerFromEnv", ()=>buildSamplerFromEnv);
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
var _alwaysOffSampler = require("./sampler/AlwaysOffSampler");
var _alwaysOnSampler = require("./sampler/AlwaysOnSampler");
var _parentBasedSampler = require("./sampler/ParentBasedSampler");
var _traceIdRatioBasedSampler = require("./sampler/TraceIdRatioBasedSampler");
var env = (0, _core.getEnv)();
var FALLBACK_OTEL_TRACES_SAMPLER = (0, _core.TracesSamplerValues).AlwaysOn;
var DEFAULT_RATIO = 1;
function loadDefaultConfig() {
    return {
        sampler: buildSamplerFromEnv(env),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: (0, _core.getEnv)().OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: (0, _core.getEnv)().OTEL_ATTRIBUTE_COUNT_LIMIT
        },
        spanLimits: {
            attributeValueLengthLimit: (0, _core.getEnv)().OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: (0, _core.getEnv)().OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
            linkCountLimit: (0, _core.getEnv)().OTEL_SPAN_LINK_COUNT_LIMIT,
            eventCountLimit: (0, _core.getEnv)().OTEL_SPAN_EVENT_COUNT_LIMIT,
            attributePerEventCountLimit: (0, _core.getEnv)().OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
            attributePerLinkCountLimit: (0, _core.getEnv)().OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
        }
    };
}
function buildSamplerFromEnv(environment) {
    if (environment === void 0) environment = (0, _core.getEnv)();
    switch(environment.OTEL_TRACES_SAMPLER){
        case (0, _core.TracesSamplerValues).AlwaysOn:
            return new (0, _alwaysOnSampler.AlwaysOnSampler)();
        case (0, _core.TracesSamplerValues).AlwaysOff:
            return new (0, _alwaysOffSampler.AlwaysOffSampler)();
        case (0, _core.TracesSamplerValues).ParentBasedAlwaysOn:
            return new (0, _parentBasedSampler.ParentBasedSampler)({
                root: new (0, _alwaysOnSampler.AlwaysOnSampler)()
            });
        case (0, _core.TracesSamplerValues).ParentBasedAlwaysOff:
            return new (0, _parentBasedSampler.ParentBasedSampler)({
                root: new (0, _alwaysOffSampler.AlwaysOffSampler)()
            });
        case (0, _core.TracesSamplerValues).TraceIdRatio:
            return new (0, _traceIdRatioBasedSampler.TraceIdRatioBasedSampler)(getSamplerProbabilityFromEnv(environment));
        case (0, _core.TracesSamplerValues).ParentBasedTraceIdRatio:
            return new (0, _parentBasedSampler.ParentBasedSampler)({
                root: new (0, _traceIdRatioBasedSampler.TraceIdRatioBasedSampler)(getSamplerProbabilityFromEnv(environment))
            });
        default:
            (0, _api.diag).error('OTEL_TRACES_SAMPLER value "' + environment.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + FALLBACK_OTEL_TRACES_SAMPLER + '".');
            return new (0, _alwaysOnSampler.AlwaysOnSampler)();
    }
}
function getSamplerProbabilityFromEnv(environment) {
    if (environment.OTEL_TRACES_SAMPLER_ARG === undefined || environment.OTEL_TRACES_SAMPLER_ARG === "") {
        (0, _api.diag).error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + DEFAULT_RATIO + ".");
        return DEFAULT_RATIO;
    }
    var probability = Number(environment.OTEL_TRACES_SAMPLER_ARG);
    if (isNaN(probability)) {
        (0, _api.diag).error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + DEFAULT_RATIO + ".");
        return DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        (0, _api.diag).error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + DEFAULT_RATIO + ".");
        return DEFAULT_RATIO;
    }
    return probability;
}

},{"@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","./sampler/AlwaysOffSampler":"fQowp","./sampler/AlwaysOnSampler":"4sQG9","./sampler/ParentBasedSampler":"l4WJN","./sampler/TraceIdRatioBasedSampler":"lP9gS","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fQowp":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlwaysOffSampler", ()=>AlwaysOffSampler);
var _sampler = require("../Sampler");
/** Sampler that samples no traces. */ var AlwaysOffSampler = /** @class */ function() {
    function AlwaysOffSampler() {}
    AlwaysOffSampler.prototype.shouldSample = function() {
        return {
            decision: (0, _sampler.SamplingDecision).NOT_RECORD
        };
    };
    AlwaysOffSampler.prototype.toString = function() {
        return "AlwaysOffSampler";
    };
    return AlwaysOffSampler;
}();

},{"../Sampler":"b9cF9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"b9cF9":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SamplingDecision", ()=>SamplingDecision);
var SamplingDecision;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})(SamplingDecision || (SamplingDecision = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4sQG9":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlwaysOnSampler", ()=>AlwaysOnSampler);
var _sampler = require("../Sampler");
/** Sampler that samples all traces. */ var AlwaysOnSampler = /** @class */ function() {
    function AlwaysOnSampler() {}
    AlwaysOnSampler.prototype.shouldSample = function() {
        return {
            decision: (0, _sampler.SamplingDecision).RECORD_AND_SAMPLED
        };
    };
    AlwaysOnSampler.prototype.toString = function() {
        return "AlwaysOnSampler";
    };
    return AlwaysOnSampler;
}();

},{"../Sampler":"b9cF9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"l4WJN":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParentBasedSampler", ()=>ParentBasedSampler);
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
var _alwaysOffSampler = require("./AlwaysOffSampler");
var _alwaysOnSampler = require("./AlwaysOnSampler");
/**
 * A composite sampler that either respects the parent span's sampling decision
 * or delegates to `delegateSampler` for root spans.
 */ var ParentBasedSampler = /** @class */ function() {
    function ParentBasedSampler(config) {
        var _a, _b, _c, _d;
        this._root = config.root;
        if (!this._root) {
            (0, _core.globalErrorHandler)(new Error("ParentBasedSampler must have a root sampler configured"));
            this._root = new (0, _alwaysOnSampler.AlwaysOnSampler)();
        }
        this._remoteParentSampled = (_a = config.remoteParentSampled) !== null && _a !== void 0 ? _a : new (0, _alwaysOnSampler.AlwaysOnSampler)();
        this._remoteParentNotSampled = (_b = config.remoteParentNotSampled) !== null && _b !== void 0 ? _b : new (0, _alwaysOffSampler.AlwaysOffSampler)();
        this._localParentSampled = (_c = config.localParentSampled) !== null && _c !== void 0 ? _c : new (0, _alwaysOnSampler.AlwaysOnSampler)();
        this._localParentNotSampled = (_d = config.localParentNotSampled) !== null && _d !== void 0 ? _d : new (0, _alwaysOffSampler.AlwaysOffSampler)();
    }
    ParentBasedSampler.prototype.shouldSample = function(context, traceId, spanName, spanKind, attributes, links) {
        var parentContext = (0, _api.trace).getSpanContext(context);
        if (!parentContext || !(0, _api.isSpanContextValid)(parentContext)) return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & (0, _api.TraceFlags).SAMPLED) return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & (0, _api.TraceFlags).SAMPLED) return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    };
    ParentBasedSampler.prototype.toString = function() {
        return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    };
    return ParentBasedSampler;
}();

},{"@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","./AlwaysOffSampler":"fQowp","./AlwaysOnSampler":"4sQG9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lP9gS":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TraceIdRatioBasedSampler", ()=>TraceIdRatioBasedSampler);
var _api = require("@opentelemetry/api");
var _sampler = require("../Sampler");
/** Sampler that samples a given fraction of traces based of trace id deterministically. */ var TraceIdRatioBasedSampler = /** @class */ function() {
    function TraceIdRatioBasedSampler(_ratio) {
        if (_ratio === void 0) _ratio = 0;
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    TraceIdRatioBasedSampler.prototype.shouldSample = function(context, traceId) {
        return {
            decision: (0, _api.isValidTraceId)(traceId) && this._accumulate(traceId) < this._upperBound ? (0, _sampler.SamplingDecision).RECORD_AND_SAMPLED : (0, _sampler.SamplingDecision).NOT_RECORD
        };
    };
    TraceIdRatioBasedSampler.prototype.toString = function() {
        return "TraceIdRatioBased{" + this._ratio + "}";
    };
    TraceIdRatioBasedSampler.prototype._normalize = function(ratio) {
        if (typeof ratio !== "number" || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    };
    TraceIdRatioBasedSampler.prototype._accumulate = function(traceId) {
        var accumulation = 0;
        for(var i = 0; i < traceId.length / 8; i++){
            var pos = i * 8;
            var part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    };
    return TraceIdRatioBasedSampler;
}();

},{"@opentelemetry/api":"4682l","../Sampler":"b9cF9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6Ax2I":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _batchSpanProcessor = require("./export/BatchSpanProcessor");
parcelHelpers.exportAll(_batchSpanProcessor, exports);
var _randomIdGenerator = require("./RandomIdGenerator");
parcelHelpers.exportAll(_randomIdGenerator, exports);

},{"./export/BatchSpanProcessor":"7mvrP","./RandomIdGenerator":"hXU7c","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7mvrP":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchSpanProcessor", ()=>BatchSpanProcessor);
var _batchSpanProcessorBase = require("../../../export/BatchSpanProcessorBase");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var BatchSpanProcessor = /** @class */ function(_super) {
    __extends(BatchSpanProcessor, _super);
    function BatchSpanProcessor(_exporter, config) {
        var _this = _super.call(this, _exporter, config) || this;
        _this.onInit(config);
        return _this;
    }
    BatchSpanProcessor.prototype.onInit = function(config) {
        var _this = this;
        if ((config === null || config === void 0 ? void 0 : config.disableAutoFlushOnDocumentHide) !== true && typeof document !== "undefined") {
            this._visibilityChangeListener = function() {
                if (document.visibilityState === "hidden") _this.forceFlush();
            };
            this._pageHideListener = function() {
                _this.forceFlush();
            };
            document.addEventListener("visibilitychange", this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener("pagehide", this._pageHideListener);
        }
    };
    BatchSpanProcessor.prototype.onShutdown = function() {
        if (typeof document !== "undefined") {
            if (this._visibilityChangeListener) document.removeEventListener("visibilitychange", this._visibilityChangeListener);
            if (this._pageHideListener) document.removeEventListener("pagehide", this._pageHideListener);
        }
    };
    return BatchSpanProcessor;
}((0, _batchSpanProcessorBase.BatchSpanProcessorBase));

},{"../../../export/BatchSpanProcessorBase":"fSXla","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fSXla":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BatchSpanProcessorBase", ()=>BatchSpanProcessorBase);
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
/**
 * Implementation of the {@link SpanProcessor} that batches spans exported by
 * the SDK then pushes them to the exporter pipeline.
 */ var BatchSpanProcessorBase = /** @class */ function() {
    function BatchSpanProcessorBase(_exporter, config) {
        this._exporter = _exporter;
        this._isExporting = false;
        this._finishedSpans = [];
        this._droppedSpansCount = 0;
        var env = (0, _core.getEnv)();
        this._maxExportBatchSize = typeof (config === null || config === void 0 ? void 0 : config.maxExportBatchSize) === "number" ? config.maxExportBatchSize : env.OTEL_BSP_MAX_EXPORT_BATCH_SIZE;
        this._maxQueueSize = typeof (config === null || config === void 0 ? void 0 : config.maxQueueSize) === "number" ? config.maxQueueSize : env.OTEL_BSP_MAX_QUEUE_SIZE;
        this._scheduledDelayMillis = typeof (config === null || config === void 0 ? void 0 : config.scheduledDelayMillis) === "number" ? config.scheduledDelayMillis : env.OTEL_BSP_SCHEDULE_DELAY;
        this._exportTimeoutMillis = typeof (config === null || config === void 0 ? void 0 : config.exportTimeoutMillis) === "number" ? config.exportTimeoutMillis : env.OTEL_BSP_EXPORT_TIMEOUT;
        this._shutdownOnce = new (0, _core.BindOnceFuture)(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            (0, _api.diag).warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize");
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    BatchSpanProcessorBase.prototype.forceFlush = function() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    };
    // does nothing.
    BatchSpanProcessorBase.prototype.onStart = function(_span, _parentContext) {};
    BatchSpanProcessorBase.prototype.onEnd = function(span) {
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & (0, _api.TraceFlags).SAMPLED) === 0) return;
        this._addToBuffer(span);
    };
    BatchSpanProcessorBase.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    };
    BatchSpanProcessorBase.prototype._shutdown = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.onShutdown();
        }).then(function() {
            return _this._flushAll();
        }).then(function() {
            return _this._exporter.shutdown();
        });
    };
    /** Add a span in the buffer. */ BatchSpanProcessorBase.prototype._addToBuffer = function(span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            // limit reached, drop span
            if (this._droppedSpansCount === 0) (0, _api.diag).debug("maxQueueSize reached, dropping spans");
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            // some spans were dropped, log once with count of spans dropped
            (0, _api.diag).warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached");
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    };
    /**
     * Send all spans to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */ BatchSpanProcessorBase.prototype._flushAll = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var promises = [];
            // calculate number of batches
            var count = Math.ceil(_this._finishedSpans.length / _this._maxExportBatchSize);
            for(var i = 0, j = count; i < j; i++)promises.push(_this._flushOneBatch());
            Promise.all(promises).then(function() {
                resolve();
            }).catch(reject);
        });
    };
    BatchSpanProcessorBase.prototype._flushOneBatch = function() {
        var _this = this;
        this._clearTimer();
        if (this._finishedSpans.length === 0) return Promise.resolve();
        return new Promise(function(resolve, reject) {
            var timer = setTimeout(function() {
                // don't wait anymore for export, this way the next batch can start
                reject(new Error("Timeout"));
            }, _this._exportTimeoutMillis);
            // prevent downstream exporter calls from generating spans
            (0, _api.context).with((0, _core.suppressTracing)((0, _api.context).active()), function() {
                // Reset the finished spans buffer here because the next invocations of the _flush method
                // could pass the same finished spans to the exporter if the buffer is cleared
                // outside the execution of this callback.
                var spans;
                if (_this._finishedSpans.length <= _this._maxExportBatchSize) {
                    spans = _this._finishedSpans;
                    _this._finishedSpans = [];
                } else spans = _this._finishedSpans.splice(0, _this._maxExportBatchSize);
                var doExport = function() {
                    return _this._exporter.export(spans, function(result) {
                        var _a;
                        clearTimeout(timer);
                        if (result.code === (0, _core.ExportResultCode).SUCCESS) resolve();
                        else reject((_a = result.error) !== null && _a !== void 0 ? _a : new Error("BatchSpanProcessor: span export failed"));
                    });
                };
                var pendingResources = null;
                for(var i = 0, len = spans.length; i < len; i++){
                    var span = spans[i];
                    if (span.resource.asyncAttributesPending && span.resource.waitForAsyncAttributes) {
                        pendingResources !== null && pendingResources !== void 0 ? pendingResources : pendingResources = [];
                        pendingResources.push(span.resource.waitForAsyncAttributes());
                    }
                }
                // Avoid scheduling a promise to make the behavior more predictable and easier to test
                if (pendingResources === null) doExport();
                else Promise.all(pendingResources).then(doExport, function(err) {
                    (0, _core.globalErrorHandler)(err);
                    reject(err);
                });
            });
        });
    };
    BatchSpanProcessorBase.prototype._maybeStartTimer = function() {
        var _this = this;
        if (this._isExporting) return;
        var flush = function() {
            _this._isExporting = true;
            _this._flushOneBatch().finally(function() {
                _this._isExporting = false;
                if (_this._finishedSpans.length > 0) {
                    _this._clearTimer();
                    _this._maybeStartTimer();
                }
            }).catch(function(e) {
                _this._isExporting = false;
                (0, _core.globalErrorHandler)(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== undefined) return;
        this._timer = setTimeout(function() {
            return flush();
        }, this._scheduledDelayMillis);
        (0, _core.unrefTimer)(this._timer);
    };
    BatchSpanProcessorBase.prototype._clearTimer = function() {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    };
    return BatchSpanProcessorBase;
}();

},{"@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hXU7c":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RandomIdGenerator", ()=>RandomIdGenerator);
var SPAN_ID_BYTES = 8;
var TRACE_ID_BYTES = 16;
var RandomIdGenerator = /** @class */ function() {
    function RandomIdGenerator() {
        /**
         * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
         * characters corresponding to 128 bits.
         */ this.generateTraceId = getIdGenerator(TRACE_ID_BYTES);
        /**
         * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
         * characters corresponding to 64 bits.
         */ this.generateSpanId = getIdGenerator(SPAN_ID_BYTES);
    }
    return RandomIdGenerator;
}();
var SHARED_CHAR_CODES_ARRAY = Array(32);
function getIdGenerator(bytes) {
    return function generateId() {
        for(var i = 0; i < bytes * 2; i++){
            SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if (SHARED_CHAR_CODES_ARRAY[i] >= 58) SHARED_CHAR_CODES_ARRAY[i] += 39;
        }
        return String.fromCharCode.apply(null, SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"lTXka":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ForceFlushState", ()=>ForceFlushState);
parcelHelpers.export(exports, "BasicTracerProvider", ()=>BasicTracerProvider);
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
var _resources = require("@opentelemetry/resources");
var _ = require(".");
var _config = require("./config");
var _multiSpanProcessor = require("./MultiSpanProcessor");
var _noopSpanProcessor = require("./export/NoopSpanProcessor");
var _platform = require("./platform");
var _utility = require("./utility");
var ForceFlushState;
(function(ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})(ForceFlushState || (ForceFlushState = {}));
/**
 * This class represents a basic tracer provider which platform libraries can extend
 */ var BasicTracerProvider = /** @class */ function() {
    function BasicTracerProvider(config) {
        if (config === void 0) config = {};
        var _a;
        this._registeredSpanProcessors = [];
        this._tracers = new Map();
        var mergedConfig = (0, _core.merge)({}, (0, _config.loadDefaultConfig)(), (0, _utility.reconfigureLimits)(config));
        this.resource = (_a = mergedConfig.resource) !== null && _a !== void 0 ? _a : (0, _resources.Resource).empty();
        this.resource = (0, _resources.Resource).default().merge(this.resource);
        this._config = Object.assign({}, mergedConfig, {
            resource: this.resource
        });
        var defaultExporter = this._buildExporterFromEnv();
        if (defaultExporter !== undefined) {
            var batchProcessor = new (0, _platform.BatchSpanProcessor)(defaultExporter);
            this.activeSpanProcessor = batchProcessor;
        } else this.activeSpanProcessor = new (0, _noopSpanProcessor.NoopSpanProcessor)();
    }
    BasicTracerProvider.prototype.getTracer = function(name, version, options) {
        var key = name + "@" + (version || "") + ":" + ((options === null || options === void 0 ? void 0 : options.schemaUrl) || "");
        if (!this._tracers.has(key)) this._tracers.set(key, new (0, _.Tracer)({
            name: name,
            version: version,
            schemaUrl: options === null || options === void 0 ? void 0 : options.schemaUrl
        }, this._config, this));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tracers.get(key);
    };
    /**
     * Adds a new {@link SpanProcessor} to this tracer.
     * @param spanProcessor the new SpanProcessor to be added.
     */ BasicTracerProvider.prototype.addSpanProcessor = function(spanProcessor) {
        if (this._registeredSpanProcessors.length === 0) // since we might have enabled by default a batchProcessor, we disable it
        // before adding the new one
        this.activeSpanProcessor.shutdown().catch(function(err) {
            return (0, _api.diag).error("Error while trying to shutdown current span processor", err);
        });
        this._registeredSpanProcessors.push(spanProcessor);
        this.activeSpanProcessor = new (0, _multiSpanProcessor.MultiSpanProcessor)(this._registeredSpanProcessors);
    };
    BasicTracerProvider.prototype.getActiveSpanProcessor = function() {
        return this.activeSpanProcessor;
    };
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ BasicTracerProvider.prototype.register = function(config) {
        if (config === void 0) config = {};
        (0, _api.trace).setGlobalTracerProvider(this);
        if (config.propagator === undefined) config.propagator = this._buildPropagatorFromEnv();
        if (config.contextManager) (0, _api.context).setGlobalContextManager(config.contextManager);
        if (config.propagator) (0, _api.propagation).setGlobalPropagator(config.propagator);
    };
    BasicTracerProvider.prototype.forceFlush = function() {
        var timeout = this._config.forceFlushTimeoutMillis;
        var promises = this._registeredSpanProcessors.map(function(spanProcessor) {
            return new Promise(function(resolve) {
                var state;
                var timeoutInterval = setTimeout(function() {
                    resolve(new Error("Span processor did not completed within timeout period of " + timeout + " ms"));
                    state = ForceFlushState.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(function() {
                    clearTimeout(timeoutInterval);
                    if (state !== ForceFlushState.timeout) {
                        state = ForceFlushState.resolved;
                        resolve(state);
                    }
                }).catch(function(error) {
                    clearTimeout(timeoutInterval);
                    state = ForceFlushState.error;
                    resolve(error);
                });
            });
        });
        return new Promise(function(resolve, reject) {
            Promise.all(promises).then(function(results) {
                var errors = results.filter(function(result) {
                    return result !== ForceFlushState.resolved;
                });
                if (errors.length > 0) reject(errors);
                else resolve();
            }).catch(function(error) {
                return reject([
                    error
                ]);
            });
        });
    };
    BasicTracerProvider.prototype.shutdown = function() {
        return this.activeSpanProcessor.shutdown();
    };
    /**
     * TS cannot yet infer the type of this.constructor:
     * https://github.com/Microsoft/TypeScript/issues/3841#issuecomment-337560146
     * There is no need to override either of the getters in your child class.
     * The type of the registered component maps should be the same across all
     * classes in the inheritance tree.
     */ BasicTracerProvider.prototype._getPropagator = function(name) {
        var _a;
        return (_a = this.constructor._registeredPropagators.get(name)) === null || _a === void 0 ? void 0 : _a();
    };
    BasicTracerProvider.prototype._getSpanExporter = function(name) {
        var _a;
        return (_a = this.constructor._registeredExporters.get(name)) === null || _a === void 0 ? void 0 : _a();
    };
    BasicTracerProvider.prototype._buildPropagatorFromEnv = function() {
        var _this = this;
        // per spec, propagators from env must be deduplicated
        var uniquePropagatorNames = Array.from(new Set((0, _core.getEnv)().OTEL_PROPAGATORS));
        var propagators = uniquePropagatorNames.map(function(name) {
            var propagator = _this._getPropagator(name);
            if (!propagator) (0, _api.diag).warn('Propagator "' + name + '" requested through environment variable is unavailable.');
            return propagator;
        });
        var validPropagators = propagators.reduce(function(list, item) {
            if (item) list.push(item);
            return list;
        }, []);
        if (validPropagators.length === 0) return;
        else if (uniquePropagatorNames.length === 1) return validPropagators[0];
        else return new (0, _core.CompositePropagator)({
            propagators: validPropagators
        });
    };
    BasicTracerProvider.prototype._buildExporterFromEnv = function() {
        var exporterName = (0, _core.getEnv)().OTEL_TRACES_EXPORTER;
        if (exporterName === "none" || exporterName === "") return;
        var exporter = this._getSpanExporter(exporterName);
        if (!exporter) (0, _api.diag).error('Exporter "' + exporterName + '" requested through environment variable is unavailable.');
        return exporter;
    };
    BasicTracerProvider._registeredPropagators = new Map([
        [
            "tracecontext",
            function() {
                return new (0, _core.W3CTraceContextPropagator)();
            }
        ],
        [
            "baggage",
            function() {
                return new (0, _core.W3CBaggagePropagator)();
            }
        ]
    ]);
    BasicTracerProvider._registeredExporters = new Map();
    return BasicTracerProvider;
}();

},{"@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","@opentelemetry/resources":"8PpPi",".":"jBq8v","./config":"5QvbE","./MultiSpanProcessor":"9if83","./export/NoopSpanProcessor":"aerQY","./platform":"6Ax2I","./utility":"k2KV8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8PpPi":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Resource", ()=>(0, _resource.Resource));
parcelHelpers.export(exports, "defaultServiceName", ()=>(0, _platform.defaultServiceName));
parcelHelpers.export(exports, "browserDetector", ()=>(0, _detectors.browserDetector));
parcelHelpers.export(exports, "browserDetectorSync", ()=>(0, _detectors.browserDetectorSync));
parcelHelpers.export(exports, "envDetector", ()=>(0, _detectors.envDetector));
parcelHelpers.export(exports, "envDetectorSync", ()=>(0, _detectors.envDetectorSync));
parcelHelpers.export(exports, "hostDetector", ()=>(0, _detectors.hostDetector));
parcelHelpers.export(exports, "hostDetectorSync", ()=>(0, _detectors.hostDetectorSync));
parcelHelpers.export(exports, "osDetector", ()=>(0, _detectors.osDetector));
parcelHelpers.export(exports, "osDetectorSync", ()=>(0, _detectors.osDetectorSync));
parcelHelpers.export(exports, "processDetector", ()=>(0, _detectors.processDetector));
parcelHelpers.export(exports, "processDetectorSync", ()=>(0, _detectors.processDetectorSync));
parcelHelpers.export(exports, "serviceInstanceIdDetectorSync", ()=>(0, _detectors.serviceInstanceIdDetectorSync));
parcelHelpers.export(exports, "detectResourcesSync", ()=>(0, _detectResources.detectResourcesSync));
parcelHelpers.export(exports, "detectResources", ()=>(0, _detectResources.detectResources));
var _resource = require("./Resource");
var _platform = require("./platform");
var _detectors = require("./detectors");
var _detectResources = require("./detect-resources");

},{"./Resource":"7nFSL","./platform":false,"./detectors":false,"./detect-resources":false,"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7nFSL":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Resource", ()=>Resource);
var _api = require("@opentelemetry/api");
var _semanticConventions = require("@opentelemetry/semantic-conventions");
var _core = require("@opentelemetry/core");
var _platform = require("./platform");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
/**
 * A Resource describes the entity for which a signals (metrics or trace) are
 * collected.
 */ var Resource = /** @class */ function() {
    function Resource(/**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */ attributes, asyncAttributesPromise) {
        var _this = this;
        var _a;
        this._attributes = attributes;
        this.asyncAttributesPending = asyncAttributesPromise != null;
        this._syncAttributes = (_a = this._attributes) !== null && _a !== void 0 ? _a : {};
        this._asyncAttributesPromise = asyncAttributesPromise === null || asyncAttributesPromise === void 0 ? void 0 : asyncAttributesPromise.then(function(asyncAttributes) {
            _this._attributes = Object.assign({}, _this._attributes, asyncAttributes);
            _this.asyncAttributesPending = false;
            return asyncAttributes;
        }, function(err) {
            (0, _api.diag).debug("a resource's async attributes promise rejected: %s", err);
            _this.asyncAttributesPending = false;
            return {};
        });
    }
    /**
     * Returns an empty Resource
     */ Resource.empty = function() {
        return Resource.EMPTY;
    };
    /**
     * Returns a Resource that identifies the SDK in use.
     */ Resource.default = function() {
        var _a;
        return new Resource((_a = {}, _a[0, _semanticConventions.SEMRESATTRS_SERVICE_NAME] = (0, _platform.defaultServiceName)(), _a[0, _semanticConventions.SEMRESATTRS_TELEMETRY_SDK_LANGUAGE] = (0, _core.SDK_INFO)[0, _semanticConventions.SEMRESATTRS_TELEMETRY_SDK_LANGUAGE], _a[0, _semanticConventions.SEMRESATTRS_TELEMETRY_SDK_NAME] = (0, _core.SDK_INFO)[0, _semanticConventions.SEMRESATTRS_TELEMETRY_SDK_NAME], _a[0, _semanticConventions.SEMRESATTRS_TELEMETRY_SDK_VERSION] = (0, _core.SDK_INFO)[0, _semanticConventions.SEMRESATTRS_TELEMETRY_SDK_VERSION], _a));
    };
    Object.defineProperty(Resource.prototype, "attributes", {
        get: function() {
            var _a;
            if (this.asyncAttributesPending) (0, _api.diag).error("Accessing resource attributes before async attributes settled");
            return (_a = this._attributes) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a promise that will never be rejected. Resolves when all async attributes have finished being added to
     * this Resource's attributes. This is useful in exporters to block until resource detection
     * has finished.
     */ Resource.prototype.waitForAsyncAttributes = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.asyncAttributesPending) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._asyncAttributesPromise
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Returns a new, merged {@link Resource} by merging the current Resource
     * with the other Resource. In case of a collision, other Resource takes
     * precedence.
     *
     * @param other the Resource that will be merged with this.
     * @returns the newly merged Resource.
     */ Resource.prototype.merge = function(other) {
        var _this = this;
        var _a;
        if (!other) return this;
        // SpanAttributes from other resource overwrite attributes from this resource.
        var mergedSyncAttributes = __assign(__assign({}, this._syncAttributes), (_a = other._syncAttributes) !== null && _a !== void 0 ? _a : other.attributes);
        if (!this._asyncAttributesPromise && !other._asyncAttributesPromise) return new Resource(mergedSyncAttributes);
        var mergedAttributesPromise = Promise.all([
            this._asyncAttributesPromise,
            other._asyncAttributesPromise
        ]).then(function(_a) {
            var _b;
            var _c = __read(_a, 2), thisAsyncAttributes = _c[0], otherAsyncAttributes = _c[1];
            return __assign(__assign(__assign(__assign({}, _this._syncAttributes), thisAsyncAttributes), (_b = other._syncAttributes) !== null && _b !== void 0 ? _b : other.attributes), otherAsyncAttributes);
        });
        return new Resource(mergedSyncAttributes, mergedAttributesPromise);
    };
    Resource.EMPTY = new Resource({});
    return Resource;
}();

},{"@opentelemetry/api":"4682l","@opentelemetry/semantic-conventions":"1OyVc","@opentelemetry/core":"6xVk8","./platform":"16j2P","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"16j2P":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultServiceName", ()=>(0, _defaultServiceName.defaultServiceName));
var _defaultServiceName = require("./default-service-name");

},{"./default-service-name":"6IfG8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6IfG8":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultServiceName", ()=>defaultServiceName);
function defaultServiceName() {
    return "unknown_service";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9if83":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiSpanProcessor", ()=>MultiSpanProcessor);
var _core = require("@opentelemetry/core");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Implementation of the {@link SpanProcessor} that simply forwards all
 * received events to a list of {@link SpanProcessor}s.
 */ var MultiSpanProcessor = /** @class */ function() {
    function MultiSpanProcessor(_spanProcessors) {
        this._spanProcessors = _spanProcessors;
    }
    MultiSpanProcessor.prototype.forceFlush = function() {
        var e_1, _a;
        var promises = [];
        try {
            for(var _b = __values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                promises.push(spanProcessor.forceFlush());
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return new Promise(function(resolve) {
            Promise.all(promises).then(function() {
                resolve();
            }).catch(function(error) {
                (0, _core.globalErrorHandler)(error || new Error("MultiSpanProcessor: forceFlush failed"));
                resolve();
            });
        });
    };
    MultiSpanProcessor.prototype.onStart = function(span, context) {
        var e_2, _a;
        try {
            for(var _b = __values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                spanProcessor.onStart(span, context);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    MultiSpanProcessor.prototype.onEnd = function(span) {
        var e_3, _a;
        try {
            for(var _b = __values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                spanProcessor.onEnd(span);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    MultiSpanProcessor.prototype.shutdown = function() {
        var e_4, _a;
        var promises = [];
        try {
            for(var _b = __values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                promises.push(spanProcessor.shutdown());
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return new Promise(function(resolve, reject) {
            Promise.all(promises).then(function() {
                resolve();
            }, reject);
        });
    };
    return MultiSpanProcessor;
}();

},{"@opentelemetry/core":"6xVk8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aerQY":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** No-op implementation of SpanProcessor */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopSpanProcessor", ()=>NoopSpanProcessor);
var NoopSpanProcessor = /** @class */ function() {
    function NoopSpanProcessor() {}
    NoopSpanProcessor.prototype.onStart = function(_span, _context) {};
    NoopSpanProcessor.prototype.onEnd = function(_span) {};
    NoopSpanProcessor.prototype.shutdown = function() {
        return Promise.resolve();
    };
    NoopSpanProcessor.prototype.forceFlush = function() {
        return Promise.resolve();
    };
    return NoopSpanProcessor;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fWnSF":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsoleSpanExporter", ()=>ConsoleSpanExporter);
var _core = require("@opentelemetry/core");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * This is implementation of {@link SpanExporter} that prints spans to the
 * console. This class can be used for diagnostic purposes.
 */ /* eslint-disable no-console */ var ConsoleSpanExporter = /** @class */ function() {
    function ConsoleSpanExporter() {}
    /**
     * Export spans.
     * @param spans
     * @param resultCallback
     */ ConsoleSpanExporter.prototype.export = function(spans, resultCallback) {
        return this._sendSpans(spans, resultCallback);
    };
    /**
     * Shutdown the exporter.
     */ ConsoleSpanExporter.prototype.shutdown = function() {
        this._sendSpans([]);
        return this.forceFlush();
    };
    /**
     * Exports any pending spans in exporter
     */ ConsoleSpanExporter.prototype.forceFlush = function() {
        return Promise.resolve();
    };
    /**
     * converts span info into more readable format
     * @param span
     */ ConsoleSpanExporter.prototype._exportInfo = function(span) {
        var _a;
        return {
            resource: {
                attributes: span.resource.attributes
            },
            traceId: span.spanContext().traceId,
            parentId: span.parentSpanId,
            traceState: (_a = span.spanContext().traceState) === null || _a === void 0 ? void 0 : _a.serialize(),
            name: span.name,
            id: span.spanContext().spanId,
            kind: span.kind,
            timestamp: (0, _core.hrTimeToMicroseconds)(span.startTime),
            duration: (0, _core.hrTimeToMicroseconds)(span.duration),
            attributes: span.attributes,
            status: span.status,
            events: span.events,
            links: span.links
        };
    };
    /**
     * Showing spans in console
     * @param spans
     * @param done
     */ ConsoleSpanExporter.prototype._sendSpans = function(spans, done) {
        var e_1, _a;
        try {
            for(var spans_1 = __values(spans), spans_1_1 = spans_1.next(); !spans_1_1.done; spans_1_1 = spans_1.next()){
                var span = spans_1_1.value;
                console.dir(this._exportInfo(span), {
                    depth: 3
                });
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (spans_1_1 && !spans_1_1.done && (_a = spans_1.return)) _a.call(spans_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (done) return done({
            code: (0, _core.ExportResultCode).SUCCESS
        });
    };
    return ConsoleSpanExporter;
}();

},{"@opentelemetry/core":"6xVk8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3cglR":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InMemorySpanExporter", ()=>InMemorySpanExporter);
var _core = require("@opentelemetry/core");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * This class can be used for testing purposes. It stores the exported spans
 * in a list in memory that can be retrieved using the `getFinishedSpans()`
 * method.
 */ var InMemorySpanExporter = /** @class */ function() {
    function InMemorySpanExporter() {
        this._finishedSpans = [];
        /**
         * Indicates if the exporter has been "shutdown."
         * When false, exported spans will not be stored in-memory.
         */ this._stopped = false;
    }
    InMemorySpanExporter.prototype.export = function(spans, resultCallback) {
        var _a;
        if (this._stopped) return resultCallback({
            code: (0, _core.ExportResultCode).FAILED,
            error: new Error("Exporter has been stopped")
        });
        (_a = this._finishedSpans).push.apply(_a, __spreadArray([], __read(spans), false));
        setTimeout(function() {
            return resultCallback({
                code: (0, _core.ExportResultCode).SUCCESS
            });
        }, 0);
    };
    InMemorySpanExporter.prototype.shutdown = function() {
        this._stopped = true;
        this._finishedSpans = [];
        return this.forceFlush();
    };
    /**
     * Exports any pending spans in the exporter
     */ InMemorySpanExporter.prototype.forceFlush = function() {
        return Promise.resolve();
    };
    InMemorySpanExporter.prototype.reset = function() {
        this._finishedSpans = [];
    };
    InMemorySpanExporter.prototype.getFinishedSpans = function() {
        return this._finishedSpans;
    };
    return InMemorySpanExporter;
}();

},{"@opentelemetry/core":"6xVk8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1DDuF":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7Qw05":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SimpleSpanProcessor", ()=>SimpleSpanProcessor);
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
/**
 * An implementation of the {@link SpanProcessor} that converts the {@link Span}
 * to {@link ReadableSpan} and passes it to the configured exporter.
 *
 * Only spans that are sampled are converted.
 */ var SimpleSpanProcessor = /** @class */ function() {
    function SimpleSpanProcessor(_exporter) {
        this._exporter = _exporter;
        this._shutdownOnce = new (0, _core.BindOnceFuture)(this._shutdown, this);
        this._unresolvedExports = new Set();
    }
    SimpleSpanProcessor.prototype.forceFlush = function() {
        return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // await unresolved resources before resolving
                        return [
                            4 /*yield*/ ,
                            Promise.all(Array.from(this._unresolvedExports))
                        ];
                    case 1:
                        // await unresolved resources before resolving
                        _a.sent();
                        if (!this._exporter.forceFlush) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this._exporter.forceFlush()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    SimpleSpanProcessor.prototype.onStart = function(_span, _parentContext) {};
    SimpleSpanProcessor.prototype.onEnd = function(span) {
        var _this = this;
        var _a, _b;
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & (0, _api.TraceFlags).SAMPLED) === 0) return;
        var doExport = function() {
            return (0, _core.internal)._export(_this._exporter, [
                span
            ]).then(function(result) {
                var _a;
                if (result.code !== (0, _core.ExportResultCode).SUCCESS) (0, _core.globalErrorHandler)((_a = result.error) !== null && _a !== void 0 ? _a : new Error("SimpleSpanProcessor: span export failed (status " + result + ")"));
            }).catch(function(error) {
                (0, _core.globalErrorHandler)(error);
            });
        };
        // Avoid scheduling a promise to make the behavior more predictable and easier to test
        if (span.resource.asyncAttributesPending) {
            var exportPromise_1 = (_b = (_a = span.resource).waitForAsyncAttributes) === null || _b === void 0 ? void 0 : _b.call(_a).then(function() {
                if (exportPromise_1 != null) _this._unresolvedExports.delete(exportPromise_1);
                return doExport();
            }, function(err) {
                return (0, _core.globalErrorHandler)(err);
            });
            // store the unresolved exports
            if (exportPromise_1 != null) this._unresolvedExports.add(exportPromise_1);
        } else doExport();
    };
    SimpleSpanProcessor.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    };
    SimpleSpanProcessor.prototype._shutdown = function() {
        return this._exporter.shutdown();
    };
    return SimpleSpanProcessor;
}();

},{"@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5YEvj":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"4Tt7O":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"33oAK":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6s8Za":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7tUsL":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3sfrI":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StackContextManager", ()=>StackContextManager);
var _api = require("@opentelemetry/api");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Stack Context Manager for managing the state in web
 * it doesn't fully support the async calls though
 */ var StackContextManager = /** @class */ function() {
    function StackContextManager() {
        /**
         * whether the context manager is enabled or not
         */ this._enabled = false;
        /**
         * Keeps the reference to current context
         */ this._currentContext = (0, _api.ROOT_CONTEXT);
    }
    /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/ban-types
    StackContextManager.prototype._bindFunction = function(context, target) {
        if (context === void 0) context = (0, _api.ROOT_CONTEXT);
        var manager = this;
        var contextWrapper = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.with(context, function() {
                return target.apply(_this, args);
            });
        };
        Object.defineProperty(contextWrapper, "length", {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    };
    /**
     * Returns the active context
     */ StackContextManager.prototype.active = function() {
        return this._currentContext;
    };
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ StackContextManager.prototype.bind = function(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === "function") return this._bindFunction(context, target);
        return target;
    };
    /**
     * Disable the context manager (clears the current context)
     */ StackContextManager.prototype.disable = function() {
        this._currentContext = (0, _api.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    };
    /**
     * Enables the context manager and creates a default(root) context
     */ StackContextManager.prototype.enable = function() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, _api.ROOT_CONTEXT);
        return this;
    };
    /**
     * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
     * The context will be set as active
     * @param context
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ StackContextManager.prototype.with = function(context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        var previousContext = this._currentContext;
        this._currentContext = context || (0, _api.ROOT_CONTEXT);
        try {
            return fn.call.apply(fn, __spreadArray([
                thisArg
            ], __read(args), false));
        } finally{
            this._currentContext = previousContext;
        }
    };
    return StackContextManager;
}();

},{"@opentelemetry/api":"4682l","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aK78g":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PerformanceTimingNames", ()=>PerformanceTimingNames);
var PerformanceTimingNames;
(function(PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})(PerformanceTimingNames || (PerformanceTimingNames = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6Wh45":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var _performanceTimingNames = require("./enums/PerformanceTimingNames");

},{"./enums/PerformanceTimingNames":"aK78g"}],"k6Gwi":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Helper function to be able to use enum as typed key in type and in interface when using forEach
 * @param obj
 * @param key
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "hasKey", ()=>hasKey);
/**
 * Helper function for starting an event on span based on {@link PerformanceEntries}
 * @param span
 * @param performanceName name of performance entry for time start
 * @param entries
 * @param refPerfName name of performance entry to use for reference
 */ parcelHelpers.export(exports, "addSpanNetworkEvent", ()=>addSpanNetworkEvent);
/**
 * Helper function for adding network events
 * @param span
 * @param resource
 */ parcelHelpers.export(exports, "addSpanNetworkEvents", ()=>addSpanNetworkEvents);
/**
 * sort resources by startTime
 * @param filteredResources
 */ parcelHelpers.export(exports, "sortResources", ()=>sortResources);
/**
 * Get closest performance resource ignoring the resources that have been
 * already used.
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 * @param initiatorType
 */ parcelHelpers.export(exports, "getResource", ()=>getResource);
/**
 * Parses url using URL constructor or fallback to anchor element.
 * @param url
 */ parcelHelpers.export(exports, "parseUrl", ()=>parseUrl);
/**
 * Parses url using URL constructor or fallback to anchor element and serialize
 * it to a string.
 *
 * Performs the steps described in https://html.spec.whatwg.org/multipage/urls-and-fetching.html#parse-a-url
 *
 * @param url
 */ parcelHelpers.export(exports, "normalizeUrl", ()=>normalizeUrl);
/**
 * Get element XPath
 * @param target - target element
 * @param optimised - when id attribute of element is present the xpath can be
 * simplified to contain id
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "getElementXPath", ()=>getElementXPath);
/**
 * Checks if trace headers should be propagated
 * @param spanUrl
 * @private
 */ parcelHelpers.export(exports, "shouldPropagateTraceHeaders", ()=>shouldPropagateTraceHeaders);
var _performanceTimingNames = require("./enums/PerformanceTimingNames");
var _core = require("@opentelemetry/core");
var _semanticConventions = require("@opentelemetry/semantic-conventions");
// Used to normalize relative URLs
var urlNormalizingAnchor;
function getUrlNormalizingAnchor() {
    if (!urlNormalizingAnchor) urlNormalizingAnchor = document.createElement("a");
    return urlNormalizingAnchor;
}
function hasKey(obj, key) {
    return key in obj;
}
function addSpanNetworkEvent(span, performanceName, entries, refPerfName) {
    var perfTime = undefined;
    var refTime = undefined;
    if (hasKey(entries, performanceName) && typeof entries[performanceName] === "number") perfTime = entries[performanceName];
    var refName = refPerfName || (0, _performanceTimingNames.PerformanceTimingNames).FETCH_START;
    // Use a reference time which is the earliest possible value so that the performance timings that are earlier should not be added
    // using FETCH START time in case no reference is provided
    if (hasKey(entries, refName) && typeof entries[refName] === "number") refTime = entries[refName];
    if (perfTime !== undefined && refTime !== undefined && perfTime >= refTime) {
        span.addEvent(performanceName, perfTime);
        return span;
    }
    return undefined;
}
function addSpanNetworkEvents(span, resource) {
    addSpanNetworkEvent(span, (0, _performanceTimingNames.PerformanceTimingNames).FETCH_START, resource);
    addSpanNetworkEvent(span, (0, _performanceTimingNames.PerformanceTimingNames).DOMAIN_LOOKUP_START, resource);
    addSpanNetworkEvent(span, (0, _performanceTimingNames.PerformanceTimingNames).DOMAIN_LOOKUP_END, resource);
    addSpanNetworkEvent(span, (0, _performanceTimingNames.PerformanceTimingNames).CONNECT_START, resource);
    if (hasKey(resource, "name") && resource["name"].startsWith("https:")) addSpanNetworkEvent(span, (0, _performanceTimingNames.PerformanceTimingNames).SECURE_CONNECTION_START, resource);
    addSpanNetworkEvent(span, (0, _performanceTimingNames.PerformanceTimingNames).CONNECT_END, resource);
    addSpanNetworkEvent(span, (0, _performanceTimingNames.PerformanceTimingNames).REQUEST_START, resource);
    addSpanNetworkEvent(span, (0, _performanceTimingNames.PerformanceTimingNames).RESPONSE_START, resource);
    addSpanNetworkEvent(span, (0, _performanceTimingNames.PerformanceTimingNames).RESPONSE_END, resource);
    var encodedLength = resource[(0, _performanceTimingNames.PerformanceTimingNames).ENCODED_BODY_SIZE];
    if (encodedLength !== undefined) span.setAttribute((0, _semanticConventions.SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH), encodedLength);
    var decodedLength = resource[(0, _performanceTimingNames.PerformanceTimingNames).DECODED_BODY_SIZE];
    // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
    if (decodedLength !== undefined && encodedLength !== decodedLength) span.setAttribute((0, _semanticConventions.SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED), decodedLength);
}
function sortResources(filteredResources) {
    return filteredResources.slice().sort(function(a, b) {
        var valueA = a[(0, _performanceTimingNames.PerformanceTimingNames).FETCH_START];
        var valueB = b[(0, _performanceTimingNames.PerformanceTimingNames).FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */ function getOrigin() {
    return typeof location !== "undefined" ? location.origin : undefined;
}
function getResource(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    if (ignoredResources === void 0) ignoredResources = new WeakSet();
    // de-relativize the URL before usage (does no harm to absolute URLs)
    var parsedSpanUrl = parseUrl(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    var filteredResources = filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: undefined
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    var sorted = sortResources(filteredResources);
    if (parsedSpanUrl.origin !== getOrigin() && sorted.length > 1) {
        var corsPreFlightRequest = sorted[0];
        var mainRequest = findMainRequest(sorted, corsPreFlightRequest[(0, _performanceTimingNames.PerformanceTimingNames).RESPONSE_END], endTimeHR);
        var responseEnd = corsPreFlightRequest[(0, _performanceTimingNames.PerformanceTimingNames).RESPONSE_END];
        var fetchStart = mainRequest[(0, _performanceTimingNames.PerformanceTimingNames).FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */ function findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    var spanEndTime = (0, _core.hrTimeToNanoseconds)(spanEndTimeHR);
    var minTime = (0, _core.hrTimeToNanoseconds)((0, _core.timeInputToHrTime)(corsPreFlightRequestEndTime));
    var mainRequest = resources[1];
    var bestGap;
    var length = resources.length;
    for(var i = 1; i < length; i++){
        var resource = resources[i];
        var resourceStartTime = (0, _core.hrTimeToNanoseconds)((0, _core.timeInputToHrTime)(resource[(0, _performanceTimingNames.PerformanceTimingNames).FETCH_START]));
        var resourceEndTime = (0, _core.hrTimeToNanoseconds)((0, _core.timeInputToHrTime)(resource[(0, _performanceTimingNames.PerformanceTimingNames).RESPONSE_END]));
        var currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */ function filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    var startTime = (0, _core.hrTimeToNanoseconds)(startTimeHR);
    var endTime = (0, _core.hrTimeToNanoseconds)(endTimeHR);
    var filteredResources = resources.filter(function(resource) {
        var resourceStartTime = (0, _core.hrTimeToNanoseconds)((0, _core.timeInputToHrTime)(resource[(0, _performanceTimingNames.PerformanceTimingNames).FETCH_START]));
        var resourceEndTime = (0, _core.hrTimeToNanoseconds)((0, _core.timeInputToHrTime)(resource[(0, _performanceTimingNames.PerformanceTimingNames).RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || "xmlhttprequest") && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter(function(resource) {
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function parseUrl(url) {
    if (typeof URL === "function") return new URL(url, typeof document !== "undefined" ? document.baseURI : typeof location !== "undefined" // Some JS runtimes (e.g. Deno) don't define this
     ? location.href : undefined);
    var element = getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function normalizeUrl(url) {
    var urlLike = parseUrl(url);
    return urlLike.href;
}
function getElementXPath(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return "/";
    var targetValue = getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf("@id") > 0) return targetValue;
    var xpath = "";
    if (target.parentNode) xpath += getElementXPath(target.parentNode, false);
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */ function getNodeIndex(target) {
    if (!target.parentNode) return 0;
    var allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    var elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter(function(element) {
        var localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1; // xpath starts from 1
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */ function getNodeValue(target, optimised) {
    var nodeType = target.nodeType;
    var index = getNodeIndex(target);
    var nodeValue = "";
    if (nodeType === Node.ELEMENT_NODE) {
        var id = target.getAttribute("id");
        if (optimised && id) return '//*[@id="' + id + '"]';
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = "text()";
    else if (nodeType === Node.COMMENT_NODE) nodeValue = "comment()";
    else return "";
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) return "/" + nodeValue + "[" + index + "]";
    return "/" + nodeValue;
}
function shouldPropagateTraceHeaders(spanUrl, propagateTraceHeaderCorsUrls) {
    var propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === "string" || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    var parsedSpanUrl = parseUrl(spanUrl);
    if (parsedSpanUrl.origin === getOrigin()) return true;
    else return propagateTraceHeaderUrls.some(function(propagateTraceHeaderUrl) {
        return (0, _core.urlMatches)(spanUrl, propagateTraceHeaderUrl);
    });
}

},{"./enums/PerformanceTimingNames":"aK78g","@opentelemetry/core":"6xVk8","@opentelemetry/semantic-conventions":"1OyVc","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"bDWf4":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _platform = require("./platform");
parcelHelpers.exportAll(_platform, exports);

},{"./platform":"gNYXb","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gNYXb":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _otlptraceExporter = require("./OTLPTraceExporter");
parcelHelpers.exportAll(_otlptraceExporter, exports);

},{"./OTLPTraceExporter":"atFVd","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"atFVd":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OTLPTraceExporter", ()=>OTLPTraceExporter);
var _core = require("@opentelemetry/core");
var _otlpExporterBase = require("@opentelemetry/otlp-exporter-base");
var _otlpTransformer = require("@opentelemetry/otlp-transformer");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var DEFAULT_COLLECTOR_RESOURCE_PATH = "v1/traces";
var DEFAULT_COLLECTOR_URL = "http://localhost:4318/" + DEFAULT_COLLECTOR_RESOURCE_PATH;
/**
 * Collector Trace Exporter for Web
 */ var OTLPTraceExporter = /** @class */ function(_super) {
    __extends(OTLPTraceExporter, _super);
    function OTLPTraceExporter(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, config, (0, _otlpTransformer.JsonTraceSerializer), "application/json") || this;
        _this._headers = Object.assign(_this._headers, (0, _core.baggageUtils).parseKeyPairsIntoRecord((0, _core.getEnv)().OTEL_EXPORTER_OTLP_TRACES_HEADERS));
        return _this;
    }
    OTLPTraceExporter.prototype.getDefaultUrl = function(config) {
        return typeof config.url === "string" ? config.url : (0, _core.getEnv)().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT.length > 0 ? (0, _otlpExporterBase.appendRootPathToUrlIfNeeded)((0, _core.getEnv)().OTEL_EXPORTER_OTLP_TRACES_ENDPOINT) : (0, _core.getEnv)().OTEL_EXPORTER_OTLP_ENDPOINT.length > 0 ? (0, _otlpExporterBase.appendResourcePathToUrl)((0, _core.getEnv)().OTEL_EXPORTER_OTLP_ENDPOINT, DEFAULT_COLLECTOR_RESOURCE_PATH) : DEFAULT_COLLECTOR_URL;
    };
    return OTLPTraceExporter;
}((0, _otlpExporterBase.OTLPExporterBrowserBase));

},{"@opentelemetry/core":"6xVk8","@opentelemetry/otlp-exporter-base":"iQc7Y","@opentelemetry/otlp-transformer":"eURRs","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"iQc7Y":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OTLPExporterBase", ()=>(0, _otlpexporterBase.OTLPExporterBase));
parcelHelpers.export(exports, "OTLPExporterError", ()=>(0, _types.OTLPExporterError));
parcelHelpers.export(exports, "parseHeaders", ()=>(0, _util.parseHeaders));
parcelHelpers.export(exports, "appendResourcePathToUrl", ()=>(0, _util.appendResourcePathToUrl));
parcelHelpers.export(exports, "appendRootPathToUrlIfNeeded", ()=>(0, _util.appendRootPathToUrlIfNeeded));
parcelHelpers.export(exports, "configureExporterTimeout", ()=>(0, _util.configureExporterTimeout));
parcelHelpers.export(exports, "invalidTimeout", ()=>(0, _util.invalidTimeout));
var _platform = require("./platform");
parcelHelpers.exportAll(_platform, exports);
var _otlpexporterBase = require("./OTLPExporterBase");
var _types = require("./types");
var _util = require("./util");

},{"./platform":"7JFeb","./OTLPExporterBase":false,"./types":false,"./util":"aCeNF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7JFeb":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OTLPExporterBrowserBase", ()=>(0, _otlpexporterBrowserBase.OTLPExporterBrowserBase));
parcelHelpers.export(exports, "sendWithXhr", ()=>(0, _util.sendWithXhr));
var _otlpexporterBrowserBase = require("./OTLPExporterBrowserBase");
var _util = require("./util");

},{"./OTLPExporterBrowserBase":"cU2GJ","./util":false,"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"cU2GJ":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OTLPExporterBrowserBase", ()=>OTLPExporterBrowserBase);
var _otlpexporterBase = require("../../OTLPExporterBase");
var _util = require("../../util");
var _util1 = require("./util");
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Collector Metric Exporter abstract base class
 */ var OTLPExporterBrowserBase = /** @class */ function(_super) {
    __extends(OTLPExporterBrowserBase, _super);
    /**
     * @param config
     * @param serializer
     * @param contentType
     */ function OTLPExporterBrowserBase(config, serializer, contentType) {
        if (config === void 0) config = {};
        var _this = _super.call(this, config) || this;
        _this._useXHR = false;
        _this._serializer = serializer;
        _this._contentType = contentType;
        _this._useXHR = !!config.headers || typeof navigator.sendBeacon !== "function";
        if (_this._useXHR) _this._headers = Object.assign({}, (0, _util.parseHeaders)(config.headers), (0, _core.baggageUtils).parseKeyPairsIntoRecord((0, _core.getEnv)().OTEL_EXPORTER_OTLP_HEADERS));
        else _this._headers = {};
        return _this;
    }
    OTLPExporterBrowserBase.prototype.onInit = function() {};
    OTLPExporterBrowserBase.prototype.onShutdown = function() {};
    OTLPExporterBrowserBase.prototype.send = function(items, onSuccess, onError) {
        var _this = this;
        var _a;
        if (this._shutdownOnce.isCalled) {
            (0, _api.diag).debug("Shutdown already started. Cannot send objects");
            return;
        }
        var body = (_a = this._serializer.serializeRequest(items)) !== null && _a !== void 0 ? _a : new Uint8Array();
        var promise = new Promise(function(resolve, reject) {
            if (_this._useXHR) (0, _util1.sendWithXhr)(body, _this.url, __assign(__assign({}, _this._headers), {
                "Content-Type": _this._contentType
            }), _this.timeoutMillis, resolve, reject);
            else (0, _util1.sendWithBeacon)(body, _this.url, {
                type: _this._contentType
            }, resolve, reject);
        }).then(onSuccess, onError);
        this._sendingPromises.push(promise);
        var popPromise = function() {
            var index = _this._sendingPromises.indexOf(promise);
            _this._sendingPromises.splice(index, 1);
        };
        promise.then(popPromise, popPromise);
    };
    return OTLPExporterBrowserBase;
}((0, _otlpexporterBase.OTLPExporterBase));

},{"../../OTLPExporterBase":"9mSSB","../../util":"aCeNF","./util":"gBWtj","@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9mSSB":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OTLPExporterBase", ()=>OTLPExporterBase);
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
var _util = require("./util");
/**
 * Collector Exporter abstract base class
 */ var OTLPExporterBase = /** @class */ function() {
    /**
     * @param config
     */ function OTLPExporterBase(config) {
        if (config === void 0) config = {};
        this._sendingPromises = [];
        this.url = this.getDefaultUrl(config);
        if (typeof config.hostname === "string") this.hostname = config.hostname;
        this.shutdown = this.shutdown.bind(this);
        this._shutdownOnce = new (0, _core.BindOnceFuture)(this._shutdown, this);
        this._concurrencyLimit = typeof config.concurrencyLimit === "number" ? config.concurrencyLimit : 30;
        this.timeoutMillis = (0, _util.configureExporterTimeout)(config.timeoutMillis);
        // platform dependent
        this.onInit(config);
    }
    /**
     * Export items.
     * @param items
     * @param resultCallback
     */ OTLPExporterBase.prototype.export = function(items, resultCallback) {
        if (this._shutdownOnce.isCalled) {
            resultCallback({
                code: (0, _core.ExportResultCode).FAILED,
                error: new Error("Exporter has been shutdown")
            });
            return;
        }
        if (this._sendingPromises.length >= this._concurrencyLimit) {
            resultCallback({
                code: (0, _core.ExportResultCode).FAILED,
                error: new Error("Concurrent export limit reached")
            });
            return;
        }
        this._export(items).then(function() {
            resultCallback({
                code: (0, _core.ExportResultCode).SUCCESS
            });
        }).catch(function(error) {
            resultCallback({
                code: (0, _core.ExportResultCode).FAILED,
                error: error
            });
        });
    };
    OTLPExporterBase.prototype._export = function(items) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            try {
                (0, _api.diag).debug("items to be sent", items);
                _this.send(items, resolve, reject);
            } catch (e) {
                reject(e);
            }
        });
    };
    /**
     * Shutdown the exporter.
     */ OTLPExporterBase.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    };
    /**
     * Exports any pending spans in the exporter
     */ OTLPExporterBase.prototype.forceFlush = function() {
        return Promise.all(this._sendingPromises).then(function() {
        /** ignore resolved values */ });
    };
    /**
     * Called by _shutdownOnce with BindOnceFuture
     */ OTLPExporterBase.prototype._shutdown = function() {
        (0, _api.diag).debug("shutdown started");
        this.onShutdown();
        return this.forceFlush();
    };
    return OTLPExporterBase;
}();

},{"@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","./util":"aCeNF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aCeNF":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_EXPORT_MAX_ATTEMPTS", ()=>DEFAULT_EXPORT_MAX_ATTEMPTS);
parcelHelpers.export(exports, "DEFAULT_EXPORT_INITIAL_BACKOFF", ()=>DEFAULT_EXPORT_INITIAL_BACKOFF);
parcelHelpers.export(exports, "DEFAULT_EXPORT_MAX_BACKOFF", ()=>DEFAULT_EXPORT_MAX_BACKOFF);
parcelHelpers.export(exports, "DEFAULT_EXPORT_BACKOFF_MULTIPLIER", ()=>DEFAULT_EXPORT_BACKOFF_MULTIPLIER);
/**
 * Parses headers from config leaving only those that have defined values
 * @param partialHeaders
 */ parcelHelpers.export(exports, "parseHeaders", ()=>parseHeaders);
/**
 * Adds path (version + signal) to a no per-signal endpoint
 * @param url
 * @param path
 * @returns url + path
 */ parcelHelpers.export(exports, "appendResourcePathToUrl", ()=>appendResourcePathToUrl);
/**
 * Adds root path to signal specific endpoint when endpoint contains no path part and no root path
 * @param url
 * @returns url
 */ parcelHelpers.export(exports, "appendRootPathToUrlIfNeeded", ()=>appendRootPathToUrlIfNeeded);
/**
 * Configure exporter trace timeout value from passed in value or environment variables
 * @param timeoutMillis
 * @returns timeout value in milliseconds
 */ parcelHelpers.export(exports, "configureExporterTimeout", ()=>configureExporterTimeout);
// OTLP exporter configured timeout - using default value of 10000ms
parcelHelpers.export(exports, "invalidTimeout", ()=>invalidTimeout);
parcelHelpers.export(exports, "isExportRetryable", ()=>isExportRetryable);
parcelHelpers.export(exports, "parseRetryAfterToMills", ()=>parseRetryAfterToMills);
var _api = require("@opentelemetry/api");
var _core = require("@opentelemetry/core");
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var DEFAULT_TRACE_TIMEOUT = 10000;
var DEFAULT_EXPORT_MAX_ATTEMPTS = 5;
var DEFAULT_EXPORT_INITIAL_BACKOFF = 1000;
var DEFAULT_EXPORT_MAX_BACKOFF = 5000;
var DEFAULT_EXPORT_BACKOFF_MULTIPLIER = 1.5;
function parseHeaders(partialHeaders) {
    if (partialHeaders === void 0) partialHeaders = {};
    var headers = {};
    Object.entries(partialHeaders).forEach(function(_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (typeof value !== "undefined") headers[key] = String(value);
        else (0, _api.diag).warn('Header "' + key + '" has invalid value (' + value + ") and will be ignored");
    });
    return headers;
}
function appendResourcePathToUrl(url, path) {
    if (!url.endsWith("/")) url = url + "/";
    return url + path;
}
function appendRootPathToUrlIfNeeded(url) {
    try {
        var parsedUrl = new URL(url);
        if (parsedUrl.pathname === "") parsedUrl.pathname = parsedUrl.pathname + "/";
        return parsedUrl.toString();
    } catch (_a) {
        (0, _api.diag).warn("Could not parse export URL: '" + url + "'");
        return url;
    }
}
function configureExporterTimeout(timeoutMillis) {
    if (typeof timeoutMillis === "number") {
        if (timeoutMillis <= 0) // OTLP exporter configured timeout - using default value of 10000ms
        return invalidTimeout(timeoutMillis, DEFAULT_TRACE_TIMEOUT);
        return timeoutMillis;
    } else return getExporterTimeoutFromEnv();
}
function getExporterTimeoutFromEnv() {
    var _a;
    var definedTimeout = Number((_a = (0, _core.getEnv)().OTEL_EXPORTER_OTLP_TRACES_TIMEOUT) !== null && _a !== void 0 ? _a : (0, _core.getEnv)().OTEL_EXPORTER_OTLP_TIMEOUT);
    if (definedTimeout <= 0) // OTLP exporter configured timeout - using default value of 10000ms
    return invalidTimeout(definedTimeout, DEFAULT_TRACE_TIMEOUT);
    else return definedTimeout;
}
function invalidTimeout(timeout, defaultTimeout) {
    (0, _api.diag).warn("Timeout must be greater than 0", timeout);
    return defaultTimeout;
}
function isExportRetryable(statusCode) {
    var retryCodes = [
        429,
        502,
        503,
        504
    ];
    return retryCodes.includes(statusCode);
}
function parseRetryAfterToMills(retryAfter) {
    if (retryAfter == null) return -1;
    var seconds = Number.parseInt(retryAfter, 10);
    if (Number.isInteger(seconds)) return seconds > 0 ? seconds * 1000 : -1;
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After#directives
    var delay = new Date(retryAfter).getTime() - Date.now();
    if (delay >= 0) return delay;
    return 0;
}

},{"@opentelemetry/api":"4682l","@opentelemetry/core":"6xVk8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gBWtj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Send metrics/spans using browser navigator.sendBeacon
 * @param body
 * @param url
 * @param blobPropertyBag
 * @param onSuccess
 * @param onError
 */ parcelHelpers.export(exports, "sendWithBeacon", ()=>sendWithBeacon);
/**
 * function to send metrics/spans using browser XMLHttpRequest
 *     used when navigator.sendBeacon is not available
 * @param body
 * @param url
 * @param headers
 * @param onSuccess
 * @param onError
 */ parcelHelpers.export(exports, "sendWithXhr", ()=>sendWithXhr);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var _api = require("@opentelemetry/api");
var _types = require("../../types");
var _util = require("../../util");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function sendWithBeacon(body, url, blobPropertyBag, onSuccess, onError) {
    if (navigator.sendBeacon(url, new Blob([
        body
    ], blobPropertyBag))) {
        (0, _api.diag).debug("sendBeacon - can send", body);
        onSuccess();
    } else {
        var error = new (0, _types.OTLPExporterError)("sendBeacon - cannot send " + body);
        onError(error);
    }
}
function sendWithXhr(body, url, headers, exporterTimeout, onSuccess, onError) {
    var retryTimer;
    var xhr;
    var reqIsDestroyed = false;
    var exporterTimer = setTimeout(function() {
        clearTimeout(retryTimer);
        reqIsDestroyed = true;
        if (xhr.readyState === XMLHttpRequest.DONE) {
            var err = new (0, _types.OTLPExporterError)("Request Timeout");
            onError(err);
        } else xhr.abort();
    }, exporterTimeout);
    var sendWithRetry = function(retries, minDelay) {
        if (retries === void 0) retries = (0, _util.DEFAULT_EXPORT_MAX_ATTEMPTS);
        if (minDelay === void 0) minDelay = (0, _util.DEFAULT_EXPORT_INITIAL_BACKOFF);
        xhr = new XMLHttpRequest();
        xhr.open("POST", url);
        var defaultHeaders = {
            Accept: "application/json",
            "Content-Type": "application/json"
        };
        Object.entries(__assign(__assign({}, defaultHeaders), headers)).forEach(function(_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            xhr.setRequestHeader(k, v);
        });
        xhr.send(body);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE && reqIsDestroyed === false) {
                if (xhr.status >= 200 && xhr.status <= 299) {
                    (0, _api.diag).debug("xhr success", body);
                    onSuccess();
                    clearTimeout(exporterTimer);
                    clearTimeout(retryTimer);
                } else if (xhr.status && (0, _util.isExportRetryable)(xhr.status) && retries > 0) {
                    var retryTime = void 0;
                    minDelay = (0, _util.DEFAULT_EXPORT_BACKOFF_MULTIPLIER) * minDelay;
                    // retry after interval specified in Retry-After header
                    if (xhr.getResponseHeader("Retry-After")) retryTime = (0, _util.parseRetryAfterToMills)(xhr.getResponseHeader("Retry-After"));
                    else // exponential backoff with jitter
                    retryTime = Math.round(Math.random() * ((0, _util.DEFAULT_EXPORT_MAX_BACKOFF) - minDelay) + minDelay);
                    retryTimer = setTimeout(function() {
                        sendWithRetry(retries - 1, minDelay);
                    }, retryTime);
                } else {
                    var error = new (0, _types.OTLPExporterError)("Failed to export with XHR (status: " + xhr.status + ")", xhr.status);
                    onError(error);
                    clearTimeout(exporterTimer);
                    clearTimeout(retryTimer);
                }
            }
        };
        xhr.onabort = function() {
            if (reqIsDestroyed) {
                var err = new (0, _types.OTLPExporterError)("Request Timeout");
                onError(err);
            }
            clearTimeout(exporterTimer);
            clearTimeout(retryTimer);
        };
        xhr.onerror = function() {
            if (reqIsDestroyed) {
                var err = new (0, _types.OTLPExporterError)("Request Timeout");
                onError(err);
            }
            clearTimeout(exporterTimer);
            clearTimeout(retryTimer);
        };
    };
    sendWithRetry();
}

},{"@opentelemetry/api":"4682l","../../types":"XYeuP","../../util":"aCeNF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"XYeuP":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OTLPExporterError", ()=>OTLPExporterError);
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Interface for handling error
 */ var OTLPExporterError = /** @class */ function(_super) {
    __extends(OTLPExporterError, _super);
    function OTLPExporterError(message, code, data) {
        var _this = _super.call(this, message) || this;
        _this.name = "OTLPExporterError";
        _this.data = data;
        _this.code = code;
        return _this;
    }
    return OTLPExporterError;
}(Error);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eURRs":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createExportTraceServiceRequest", ()=>(0, _trace.createExportTraceServiceRequest));
parcelHelpers.export(exports, "createExportMetricsServiceRequest", ()=>(0, _metrics.createExportMetricsServiceRequest));
parcelHelpers.export(exports, "createExportLogsServiceRequest", ()=>(0, _logs.createExportLogsServiceRequest));
parcelHelpers.export(exports, "ProtobufLogsSerializer", ()=>(0, _serializers.ProtobufLogsSerializer));
parcelHelpers.export(exports, "ProtobufMetricsSerializer", ()=>(0, _serializers.ProtobufMetricsSerializer));
parcelHelpers.export(exports, "ProtobufTraceSerializer", ()=>(0, _serializers.ProtobufTraceSerializer));
parcelHelpers.export(exports, "JsonTraceSerializer", ()=>(0, _serializers1.JsonTraceSerializer));
parcelHelpers.export(exports, "JsonLogsSerializer", ()=>(0, _serializers1.JsonLogsSerializer));
parcelHelpers.export(exports, "JsonMetricsSerializer", ()=>(0, _serializers1.JsonMetricsSerializer));
var _types = require("./common/types");
parcelHelpers.exportAll(_types, exports);
var _common = require("./common");
parcelHelpers.exportAll(_common, exports);
var _types1 = require("./metrics/types");
parcelHelpers.exportAll(_types1, exports);
var _types2 = require("./resource/types");
parcelHelpers.exportAll(_types2, exports);
var _types3 = require("./trace/types");
parcelHelpers.exportAll(_types3, exports);
var _types4 = require("./logs/types");
parcelHelpers.exportAll(_types4, exports);
var _trace = require("./trace");
var _metrics = require("./metrics");
var _logs = require("./logs");
var _serializers = require("./protobuf/serializers");
var _serializers1 = require("./json/serializers");

},{"./common/types":false,"./common":false,"./metrics/types":false,"./resource/types":false,"./trace/types":false,"./logs/types":false,"./trace":false,"./metrics":false,"./logs":false,"./protobuf/serializers":false,"./json/serializers":"awY17","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"eV3mR":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hrTimeToNanos", ()=>hrTimeToNanos);
parcelHelpers.export(exports, "toLongBits", ()=>toLongBits);
parcelHelpers.export(exports, "encodeAsLongBits", ()=>encodeAsLongBits);
parcelHelpers.export(exports, "encodeAsString", ()=>encodeAsString);
parcelHelpers.export(exports, "getOtlpEncoder", ()=>getOtlpEncoder);
var _core = require("@opentelemetry/core");
function hrTimeToNanos(hrTime) {
    var NANOSECONDS = BigInt(1000000000);
    return BigInt(hrTime[0]) * NANOSECONDS + BigInt(hrTime[1]);
}
function toLongBits(value) {
    var low = Number(BigInt.asUintN(32, value));
    var high = Number(BigInt.asUintN(32, value >> BigInt(32)));
    return {
        low: low,
        high: high
    };
}
function encodeAsLongBits(hrTime) {
    var nanos = hrTimeToNanos(hrTime);
    return toLongBits(nanos);
}
function encodeAsString(hrTime) {
    var nanos = hrTimeToNanos(hrTime);
    return nanos.toString();
}
var encodeTimestamp = typeof BigInt !== "undefined" ? encodeAsString : (0, _core.hrTimeToNanoseconds);
function identity(value) {
    return value;
}
function optionalHexToBinary(str) {
    if (str === undefined) return undefined;
    return (0, _core.hexToBinary)(str);
}
var DEFAULT_ENCODER = {
    encodeHrTime: encodeAsLongBits,
    encodeSpanContext: (0, _core.hexToBinary),
    encodeOptionalSpanContext: optionalHexToBinary
};
function getOtlpEncoder(options) {
    var _a, _b;
    if (options === undefined) return DEFAULT_ENCODER;
    var useLongBits = (_a = options.useLongBits) !== null && _a !== void 0 ? _a : true;
    var useHex = (_b = options.useHex) !== null && _b !== void 0 ? _b : false;
    return {
        encodeHrTime: useLongBits ? encodeAsLongBits : encodeTimestamp,
        encodeSpanContext: useHex ? identity : (0, _core.hexToBinary),
        encodeOptionalSpanContext: useHex ? identity : optionalHexToBinary
    };
}

},{"@opentelemetry/core":"6xVk8","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"aGt3A":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createExportTraceServiceRequest", ()=>createExportTraceServiceRequest);
var _internal = require("./internal");
var _common = require("../common");
var _internal1 = require("../common/internal");
var _internal2 = require("../resource/internal");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function createExportTraceServiceRequest(spans, options) {
    var encoder = (0, _common.getOtlpEncoder)(options);
    return {
        resourceSpans: spanRecordsToResourceSpans(spans, encoder)
    };
}
function createResourceMap(readableSpans) {
    var e_1, _a;
    var resourceMap = new Map();
    try {
        for(var readableSpans_1 = __values(readableSpans), readableSpans_1_1 = readableSpans_1.next(); !readableSpans_1_1.done; readableSpans_1_1 = readableSpans_1.next()){
            var record = readableSpans_1_1.value;
            var ilmMap = resourceMap.get(record.resource);
            if (!ilmMap) {
                ilmMap = new Map();
                resourceMap.set(record.resource, ilmMap);
            }
            // TODO this is duplicated in basic tracer. Consolidate on a common helper in core
            var instrumentationLibraryKey = record.instrumentationLibrary.name + "@" + (record.instrumentationLibrary.version || "") + ":" + (record.instrumentationLibrary.schemaUrl || "");
            var records = ilmMap.get(instrumentationLibraryKey);
            if (!records) {
                records = [];
                ilmMap.set(instrumentationLibraryKey, records);
            }
            records.push(record);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (readableSpans_1_1 && !readableSpans_1_1.done && (_a = readableSpans_1.return)) _a.call(readableSpans_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return resourceMap;
}
function spanRecordsToResourceSpans(readableSpans, encoder) {
    var resourceMap = createResourceMap(readableSpans);
    var out = [];
    var entryIterator = resourceMap.entries();
    var entry = entryIterator.next();
    while(!entry.done){
        var _a = __read(entry.value, 2), resource = _a[0], ilmMap = _a[1];
        var scopeResourceSpans = [];
        var ilmIterator = ilmMap.values();
        var ilmEntry = ilmIterator.next();
        while(!ilmEntry.done){
            var scopeSpans = ilmEntry.value;
            if (scopeSpans.length > 0) {
                var spans = scopeSpans.map(function(readableSpan) {
                    return (0, _internal.sdkSpanToOtlpSpan)(readableSpan, encoder);
                });
                scopeResourceSpans.push({
                    scope: (0, _internal1.createInstrumentationScope)(scopeSpans[0].instrumentationLibrary),
                    spans: spans,
                    schemaUrl: scopeSpans[0].instrumentationLibrary.schemaUrl
                });
            }
            ilmEntry = ilmIterator.next();
        }
        // TODO SDK types don't provide resource schema URL at this time
        var transformedSpans = {
            resource: (0, _internal2.createResource)(resource),
            scopeSpans: scopeResourceSpans,
            schemaUrl: undefined
        };
        out.push(transformedSpans);
        entry = entryIterator.next();
    }
    return out;
}

},{"./internal":"fm86Z","../common":"eV3mR","../common/internal":"jrXSr","../resource/internal":"hqxaC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"fm86Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sdkSpanToOtlpSpan", ()=>sdkSpanToOtlpSpan);
parcelHelpers.export(exports, "toOtlpLink", ()=>toOtlpLink);
parcelHelpers.export(exports, "toOtlpSpanEvent", ()=>toOtlpSpanEvent);
var _internal = require("../common/internal");
function sdkSpanToOtlpSpan(span, encoder) {
    var _a;
    var ctx = span.spanContext();
    var status = span.status;
    return {
        traceId: encoder.encodeSpanContext(ctx.traceId),
        spanId: encoder.encodeSpanContext(ctx.spanId),
        parentSpanId: encoder.encodeOptionalSpanContext(span.parentSpanId),
        traceState: (_a = ctx.traceState) === null || _a === void 0 ? void 0 : _a.serialize(),
        name: span.name,
        // Span kind is offset by 1 because the API does not define a value for unset
        kind: span.kind == null ? 0 : span.kind + 1,
        startTimeUnixNano: encoder.encodeHrTime(span.startTime),
        endTimeUnixNano: encoder.encodeHrTime(span.endTime),
        attributes: (0, _internal.toAttributes)(span.attributes),
        droppedAttributesCount: span.droppedAttributesCount,
        events: span.events.map(function(event) {
            return toOtlpSpanEvent(event, encoder);
        }),
        droppedEventsCount: span.droppedEventsCount,
        status: {
            // API and proto enums share the same values
            code: status.code,
            message: status.message
        },
        links: span.links.map(function(link) {
            return toOtlpLink(link, encoder);
        }),
        droppedLinksCount: span.droppedLinksCount
    };
}
function toOtlpLink(link, encoder) {
    var _a;
    return {
        attributes: link.attributes ? (0, _internal.toAttributes)(link.attributes) : [],
        spanId: encoder.encodeSpanContext(link.context.spanId),
        traceId: encoder.encodeSpanContext(link.context.traceId),
        traceState: (_a = link.context.traceState) === null || _a === void 0 ? void 0 : _a.serialize(),
        droppedAttributesCount: link.droppedAttributesCount || 0
    };
}
function toOtlpSpanEvent(timedEvent, encoder) {
    return {
        attributes: timedEvent.attributes ? (0, _internal.toAttributes)(timedEvent.attributes) : [],
        name: timedEvent.name,
        timeUnixNano: encoder.encodeHrTime(timedEvent.time),
        droppedAttributesCount: timedEvent.droppedAttributesCount || 0
    };
}

},{"../common/internal":"jrXSr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"jrXSr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInstrumentationScope", ()=>createInstrumentationScope);
parcelHelpers.export(exports, "toAttributes", ()=>toAttributes);
parcelHelpers.export(exports, "toKeyValue", ()=>toKeyValue);
parcelHelpers.export(exports, "toAnyValue", ()=>toAnyValue);
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function createInstrumentationScope(scope) {
    return {
        name: scope.name,
        version: scope.version
    };
}
function toAttributes(attributes) {
    return Object.keys(attributes).map(function(key) {
        return toKeyValue(key, attributes[key]);
    });
}
function toKeyValue(key, value) {
    return {
        key: key,
        value: toAnyValue(value)
    };
}
function toAnyValue(value) {
    var t = typeof value;
    if (t === "string") return {
        stringValue: value
    };
    if (t === "number") {
        if (!Number.isInteger(value)) return {
            doubleValue: value
        };
        return {
            intValue: value
        };
    }
    if (t === "boolean") return {
        boolValue: value
    };
    if (value instanceof Uint8Array) return {
        bytesValue: value
    };
    if (Array.isArray(value)) return {
        arrayValue: {
            values: value.map(toAnyValue)
        }
    };
    if (t === "object" && value != null) return {
        kvlistValue: {
            values: Object.entries(value).map(function(_a) {
                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                return toKeyValue(k, v);
            })
        }
    };
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"hqxaC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createResource", ()=>createResource);
var _internal = require("../common/internal");
function createResource(resource) {
    return {
        attributes: (0, _internal.toAttributes)(resource.attributes),
        droppedAttributesCount: 0
    };
}

},{"../common/internal":"jrXSr","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9jCHq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createExportMetricsServiceRequest", ()=>createExportMetricsServiceRequest);
var _internal = require("./internal");
function createExportMetricsServiceRequest(resourceMetrics, options) {
    return {
        resourceMetrics: resourceMetrics.map(function(metrics) {
            return (0, _internal.toResourceMetrics)(metrics, options);
        })
    };
}

},{"./internal":"2eipU","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2eipU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toResourceMetrics", ()=>toResourceMetrics);
parcelHelpers.export(exports, "toScopeMetrics", ()=>toScopeMetrics);
parcelHelpers.export(exports, "toMetric", ()=>toMetric);
var _api = require("@opentelemetry/api");
var _sdkMetrics = require("@opentelemetry/sdk-metrics");
var _common = require("../common");
var _internal = require("../common/internal");
var _internal1 = require("../resource/internal");
function toResourceMetrics(resourceMetrics, options) {
    var encoder = (0, _common.getOtlpEncoder)(options);
    return {
        resource: (0, _internal1.createResource)(resourceMetrics.resource),
        schemaUrl: undefined,
        scopeMetrics: toScopeMetrics(resourceMetrics.scopeMetrics, encoder)
    };
}
function toScopeMetrics(scopeMetrics, encoder) {
    return Array.from(scopeMetrics.map(function(metrics) {
        return {
            scope: (0, _internal.createInstrumentationScope)(metrics.scope),
            metrics: metrics.metrics.map(function(metricData) {
                return toMetric(metricData, encoder);
            }),
            schemaUrl: metrics.scope.schemaUrl
        };
    }));
}
function toMetric(metricData, encoder) {
    var out = {
        name: metricData.descriptor.name,
        description: metricData.descriptor.description,
        unit: metricData.descriptor.unit
    };
    var aggregationTemporality = toAggregationTemporality(metricData.aggregationTemporality);
    switch(metricData.dataPointType){
        case (0, _sdkMetrics.DataPointType).SUM:
            out.sum = {
                aggregationTemporality: aggregationTemporality,
                isMonotonic: metricData.isMonotonic,
                dataPoints: toSingularDataPoints(metricData, encoder)
            };
            break;
        case (0, _sdkMetrics.DataPointType).GAUGE:
            out.gauge = {
                dataPoints: toSingularDataPoints(metricData, encoder)
            };
            break;
        case (0, _sdkMetrics.DataPointType).HISTOGRAM:
            out.histogram = {
                aggregationTemporality: aggregationTemporality,
                dataPoints: toHistogramDataPoints(metricData, encoder)
            };
            break;
        case (0, _sdkMetrics.DataPointType).EXPONENTIAL_HISTOGRAM:
            out.exponentialHistogram = {
                aggregationTemporality: aggregationTemporality,
                dataPoints: toExponentialHistogramDataPoints(metricData, encoder)
            };
            break;
    }
    return out;
}
function toSingularDataPoint(dataPoint, valueType, encoder) {
    var out = {
        attributes: (0, _internal.toAttributes)(dataPoint.attributes),
        startTimeUnixNano: encoder.encodeHrTime(dataPoint.startTime),
        timeUnixNano: encoder.encodeHrTime(dataPoint.endTime)
    };
    switch(valueType){
        case (0, _api.ValueType).INT:
            out.asInt = dataPoint.value;
            break;
        case (0, _api.ValueType).DOUBLE:
            out.asDouble = dataPoint.value;
            break;
    }
    return out;
}
function toSingularDataPoints(metricData, encoder) {
    return metricData.dataPoints.map(function(dataPoint) {
        return toSingularDataPoint(dataPoint, metricData.descriptor.valueType, encoder);
    });
}
function toHistogramDataPoints(metricData, encoder) {
    return metricData.dataPoints.map(function(dataPoint) {
        var histogram = dataPoint.value;
        return {
            attributes: (0, _internal.toAttributes)(dataPoint.attributes),
            bucketCounts: histogram.buckets.counts,
            explicitBounds: histogram.buckets.boundaries,
            count: histogram.count,
            sum: histogram.sum,
            min: histogram.min,
            max: histogram.max,
            startTimeUnixNano: encoder.encodeHrTime(dataPoint.startTime),
            timeUnixNano: encoder.encodeHrTime(dataPoint.endTime)
        };
    });
}
function toExponentialHistogramDataPoints(metricData, encoder) {
    return metricData.dataPoints.map(function(dataPoint) {
        var histogram = dataPoint.value;
        return {
            attributes: (0, _internal.toAttributes)(dataPoint.attributes),
            count: histogram.count,
            min: histogram.min,
            max: histogram.max,
            sum: histogram.sum,
            positive: {
                offset: histogram.positive.offset,
                bucketCounts: histogram.positive.bucketCounts
            },
            negative: {
                offset: histogram.negative.offset,
                bucketCounts: histogram.negative.bucketCounts
            },
            scale: histogram.scale,
            zeroCount: histogram.zeroCount,
            startTimeUnixNano: encoder.encodeHrTime(dataPoint.startTime),
            timeUnixNano: encoder.encodeHrTime(dataPoint.endTime)
        };
    });
}
function toAggregationTemporality(temporality) {
    switch(temporality){
        case (0, _sdkMetrics.AggregationTemporality).DELTA:
            return 1 /* AGGREGATION_TEMPORALITY_DELTA */ ;
        case (0, _sdkMetrics.AggregationTemporality).CUMULATIVE:
            return 2 /* AGGREGATION_TEMPORALITY_CUMULATIVE */ ;
    }
}

},{"@opentelemetry/api":"4682l","@opentelemetry/sdk-metrics":"5siTu","../common":"eV3mR","../common/internal":"jrXSr","../resource/internal":"hqxaC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"5siTu":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AggregationTemporality", ()=>(0, _aggregationTemporality.AggregationTemporality));
parcelHelpers.export(exports, "DataPointType", ()=>(0, _metricData.DataPointType));
parcelHelpers.export(exports, "MetricReader", ()=>(0, _metricReader.MetricReader));
parcelHelpers.export(exports, "PeriodicExportingMetricReader", ()=>(0, _periodicExportingMetricReader.PeriodicExportingMetricReader));
parcelHelpers.export(exports, "InMemoryMetricExporter", ()=>(0, _inMemoryMetricExporter.InMemoryMetricExporter));
parcelHelpers.export(exports, "ConsoleMetricExporter", ()=>(0, _consoleMetricExporter.ConsoleMetricExporter));
parcelHelpers.export(exports, "InstrumentType", ()=>(0, _instrumentDescriptor.InstrumentType));
parcelHelpers.export(exports, "MeterProvider", ()=>(0, _meterProvider.MeterProvider));
parcelHelpers.export(exports, "DefaultAggregation", ()=>(0, _aggregation.DefaultAggregation));
parcelHelpers.export(exports, "ExplicitBucketHistogramAggregation", ()=>(0, _aggregation.ExplicitBucketHistogramAggregation));
parcelHelpers.export(exports, "ExponentialHistogramAggregation", ()=>(0, _aggregation.ExponentialHistogramAggregation));
parcelHelpers.export(exports, "DropAggregation", ()=>(0, _aggregation.DropAggregation));
parcelHelpers.export(exports, "HistogramAggregation", ()=>(0, _aggregation.HistogramAggregation));
parcelHelpers.export(exports, "LastValueAggregation", ()=>(0, _aggregation.LastValueAggregation));
parcelHelpers.export(exports, "SumAggregation", ()=>(0, _aggregation.SumAggregation));
parcelHelpers.export(exports, "Aggregation", ()=>(0, _aggregation.Aggregation));
parcelHelpers.export(exports, "View", ()=>(0, _view.View));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _utils.TimeoutError));
var _aggregationTemporality = require("./export/AggregationTemporality");
var _metricData = require("./export/MetricData");
var _metricReader = require("./export/MetricReader");
var _periodicExportingMetricReader = require("./export/PeriodicExportingMetricReader");
var _inMemoryMetricExporter = require("./export/InMemoryMetricExporter");
var _consoleMetricExporter = require("./export/ConsoleMetricExporter");
var _instrumentDescriptor = require("./InstrumentDescriptor");
var _meterProvider = require("./MeterProvider");
var _aggregation = require("./view/Aggregation");
var _view = require("./view/View");
var _utils = require("./utils");

},{"./export/AggregationTemporality":"knF1p","./export/MetricData":"8qX18","./export/MetricReader":false,"./export/PeriodicExportingMetricReader":false,"./export/InMemoryMetricExporter":false,"./export/ConsoleMetricExporter":false,"./InstrumentDescriptor":false,"./MeterProvider":false,"./view/Aggregation":false,"./view/View":false,"./utils":false,"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"knF1p":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * AggregationTemporality indicates the way additive quantities are expressed.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AggregationTemporality", ()=>AggregationTemporality);
var AggregationTemporality;
(function(AggregationTemporality) {
    AggregationTemporality[AggregationTemporality["DELTA"] = 0] = "DELTA";
    AggregationTemporality[AggregationTemporality["CUMULATIVE"] = 1] = "CUMULATIVE";
})(AggregationTemporality || (AggregationTemporality = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"8qX18":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The aggregated point data type.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataPointType", ()=>DataPointType);
var DataPointType;
(function(DataPointType) {
    /**
     * A histogram data point contains a histogram statistics of collected
     * values with a list of explicit bucket boundaries and statistics such
     * as min, max, count, and sum of all collected values.
     */ DataPointType[DataPointType["HISTOGRAM"] = 0] = "HISTOGRAM";
    /**
     * An exponential histogram data point contains a histogram statistics of
     * collected values where bucket boundaries are automatically calculated
     * using an exponential function, and statistics such as min, max, count,
     * and sum of all collected values.
     */ DataPointType[DataPointType["EXPONENTIAL_HISTOGRAM"] = 1] = "EXPONENTIAL_HISTOGRAM";
    /**
     * A gauge metric data point has only a single numeric value.
     */ DataPointType[DataPointType["GAUGE"] = 2] = "GAUGE";
    /**
     * A sum metric data point has a single numeric value and a
     * monotonicity-indicator.
     */ DataPointType[DataPointType["SUM"] = 3] = "SUM";
})(DataPointType || (DataPointType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7uKTa":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createExportLogsServiceRequest", ()=>createExportLogsServiceRequest);
parcelHelpers.export(exports, "toLogAttributes", ()=>toLogAttributes);
var _common = require("../common");
var _internal = require("../common/internal");
var _internal1 = require("../resource/internal");
var __values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function createExportLogsServiceRequest(logRecords, options) {
    var encoder = (0, _common.getOtlpEncoder)(options);
    return {
        resourceLogs: logRecordsToResourceLogs(logRecords, encoder)
    };
}
function createResourceMap(logRecords) {
    var e_1, _a;
    var resourceMap = new Map();
    try {
        for(var logRecords_1 = __values(logRecords), logRecords_1_1 = logRecords_1.next(); !logRecords_1_1.done; logRecords_1_1 = logRecords_1.next()){
            var record = logRecords_1_1.value;
            var resource = record.resource, _b = record.instrumentationScope, name_1 = _b.name, _c = _b.version, version = _c === void 0 ? "" : _c, _d = _b.schemaUrl, schemaUrl = _d === void 0 ? "" : _d;
            var ismMap = resourceMap.get(resource);
            if (!ismMap) {
                ismMap = new Map();
                resourceMap.set(resource, ismMap);
            }
            var ismKey = name_1 + "@" + version + ":" + schemaUrl;
            var records = ismMap.get(ismKey);
            if (!records) {
                records = [];
                ismMap.set(ismKey, records);
            }
            records.push(record);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (logRecords_1_1 && !logRecords_1_1.done && (_a = logRecords_1.return)) _a.call(logRecords_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return resourceMap;
}
function logRecordsToResourceLogs(logRecords, encoder) {
    var resourceMap = createResourceMap(logRecords);
    return Array.from(resourceMap, function(_a) {
        var _b = __read(_a, 2), resource = _b[0], ismMap = _b[1];
        return {
            resource: (0, _internal1.createResource)(resource),
            scopeLogs: Array.from(ismMap, function(_a) {
                var _b = __read(_a, 2), scopeLogs = _b[1];
                return {
                    scope: (0, _internal.createInstrumentationScope)(scopeLogs[0].instrumentationScope),
                    logRecords: scopeLogs.map(function(log) {
                        return toLogRecord(log, encoder);
                    }),
                    schemaUrl: scopeLogs[0].instrumentationScope.schemaUrl
                };
            }),
            schemaUrl: undefined
        };
    });
}
function toLogRecord(log, encoder) {
    var _a, _b, _c;
    return {
        timeUnixNano: encoder.encodeHrTime(log.hrTime),
        observedTimeUnixNano: encoder.encodeHrTime(log.hrTimeObserved),
        severityNumber: toSeverityNumber(log.severityNumber),
        severityText: log.severityText,
        body: (0, _internal.toAnyValue)(log.body),
        attributes: toLogAttributes(log.attributes),
        droppedAttributesCount: log.droppedAttributesCount,
        flags: (_a = log.spanContext) === null || _a === void 0 ? void 0 : _a.traceFlags,
        traceId: encoder.encodeOptionalSpanContext((_b = log.spanContext) === null || _b === void 0 ? void 0 : _b.traceId),
        spanId: encoder.encodeOptionalSpanContext((_c = log.spanContext) === null || _c === void 0 ? void 0 : _c.spanId)
    };
}
function toSeverityNumber(severityNumber) {
    return severityNumber;
}
function toLogAttributes(attributes) {
    return Object.keys(attributes).map(function(key) {
        return (0, _internal.toKeyValue)(key, attributes[key]);
    });
}

},{"../common":"eV3mR","../common/internal":"jrXSr","../resource/internal":"hqxaC","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"awY17":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JsonTraceSerializer", ()=>JsonTraceSerializer);
parcelHelpers.export(exports, "JsonMetricsSerializer", ()=>JsonMetricsSerializer);
parcelHelpers.export(exports, "JsonLogsSerializer", ()=>JsonLogsSerializer);
var _trace = require("../trace");
var _metrics = require("../metrics");
var _logs = require("../logs");
var JsonTraceSerializer = {
    serializeRequest: function(arg) {
        var request = (0, _trace.createExportTraceServiceRequest)(arg, {
            useHex: true,
            useLongBits: false
        });
        var encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: function(arg) {
        var decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};
var JsonMetricsSerializer = {
    serializeRequest: function(arg) {
        var request = (0, _metrics.createExportMetricsServiceRequest)(arg, {
            useLongBits: false
        });
        var encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: function(arg) {
        var decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};
var JsonLogsSerializer = {
    serializeRequest: function(arg) {
        var request = (0, _logs.createExportLogsServiceRequest)(arg, {
            useHex: true,
            useLongBits: false
        });
        var encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: function(arg) {
        var decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};

},{"../trace":"aGt3A","../metrics":"9jCHq","../logs":"7uKTa","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7NsZS":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerInstrumentations", ()=>(0, _autoLoader.registerInstrumentations));
parcelHelpers.export(exports, "InstrumentationBase", ()=>(0, _index.InstrumentationBase));
parcelHelpers.export(exports, "InstrumentationNodeModuleDefinition", ()=>(0, _instrumentationNodeModuleDefinition.InstrumentationNodeModuleDefinition));
parcelHelpers.export(exports, "InstrumentationNodeModuleFile", ()=>(0, _instrumentationNodeModuleFile.InstrumentationNodeModuleFile));
var _autoLoader = require("./autoLoader");
var _index = require("./platform/index");
var _instrumentationNodeModuleDefinition = require("./instrumentationNodeModuleDefinition");
var _instrumentationNodeModuleFile = require("./instrumentationNodeModuleFile");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
var _typesInternal = require("./types_internal");
parcelHelpers.exportAll(_typesInternal, exports);
var _utils = require("./utils");
parcelHelpers.exportAll(_utils, exports);

},{"./autoLoader":"gf4ZJ","./platform/index":"9FAWm","./instrumentationNodeModuleDefinition":false,"./instrumentationNodeModuleFile":false,"./types":false,"./types_internal":false,"./utils":"1fYwY","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"gf4ZJ":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * It will register instrumentations and plugins
 * @param options
 * @return returns function to unload instrumentation and plugins that were
 *   registered
 */ parcelHelpers.export(exports, "registerInstrumentations", ()=>registerInstrumentations);
var _api = require("@opentelemetry/api");
var _apiLogs = require("@opentelemetry/api-logs");
var _autoLoaderUtils = require("./autoLoaderUtils");
function registerInstrumentations(options) {
    var _a, _b;
    var tracerProvider = options.tracerProvider || (0, _api.trace).getTracerProvider();
    var meterProvider = options.meterProvider || (0, _api.metrics).getMeterProvider();
    var loggerProvider = options.loggerProvider || (0, _apiLogs.logs).getLoggerProvider();
    var instrumentations = (_b = (_a = options.instrumentations) === null || _a === void 0 ? void 0 : _a.flat()) !== null && _b !== void 0 ? _b : [];
    (0, _autoLoaderUtils.enableInstrumentations)(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return function() {
        (0, _autoLoaderUtils.disableInstrumentations)(instrumentations);
    };
}

},{"@opentelemetry/api":"4682l","@opentelemetry/api-logs":"77PKS","./autoLoaderUtils":"171Z2","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"77PKS":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logs", ()=>logs);
var _logger = require("./types/Logger");
parcelHelpers.exportAll(_logger, exports);
var _loggerProvider = require("./types/LoggerProvider");
parcelHelpers.exportAll(_loggerProvider, exports);
var _logRecord = require("./types/LogRecord");
parcelHelpers.exportAll(_logRecord, exports);
var _loggerOptions = require("./types/LoggerOptions");
parcelHelpers.exportAll(_loggerOptions, exports);
var _anyValue = require("./types/AnyValue");
parcelHelpers.exportAll(_anyValue, exports);
var _noopLogger = require("./NoopLogger");
parcelHelpers.exportAll(_noopLogger, exports);
var _noopLoggerProvider = require("./NoopLoggerProvider");
parcelHelpers.exportAll(_noopLoggerProvider, exports);
var _logs = require("./api/logs");
var logs = (0, _logs.LogsAPI).getInstance();

},{"./types/Logger":false,"./types/LoggerProvider":false,"./types/LogRecord":false,"./types/LoggerOptions":false,"./types/AnyValue":false,"./NoopLogger":false,"./NoopLoggerProvider":false,"./api/logs":"7mDuF","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6tEpM":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopLogger", ()=>NoopLogger);
parcelHelpers.export(exports, "NOOP_LOGGER", ()=>NOOP_LOGGER);
var NoopLogger = /** @class */ function() {
    function NoopLogger() {}
    NoopLogger.prototype.emit = function(_logRecord) {};
    return NoopLogger;
}();
var NOOP_LOGGER = new NoopLogger();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"ic3O9":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoopLoggerProvider", ()=>NoopLoggerProvider);
parcelHelpers.export(exports, "NOOP_LOGGER_PROVIDER", ()=>NOOP_LOGGER_PROVIDER);
var _noopLogger = require("./NoopLogger");
var NoopLoggerProvider = /** @class */ function() {
    function NoopLoggerProvider() {}
    NoopLoggerProvider.prototype.getLogger = function(_name, _version, _options) {
        return new (0, _noopLogger.NoopLogger)();
    };
    return NoopLoggerProvider;
}();
var NOOP_LOGGER_PROVIDER = new NoopLoggerProvider();

},{"./NoopLogger":"6tEpM","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"7mDuF":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogsAPI", ()=>LogsAPI);
var _globalUtils = require("../internal/global-utils");
var _noopLoggerProvider = require("../NoopLoggerProvider");
var LogsAPI = /** @class */ function() {
    function LogsAPI() {}
    LogsAPI.getInstance = function() {
        if (!this._instance) this._instance = new LogsAPI();
        return this._instance;
    };
    LogsAPI.prototype.setGlobalLoggerProvider = function(provider) {
        if ((0, _globalUtils._global)[0, _globalUtils.GLOBAL_LOGS_API_KEY]) return this.getLoggerProvider();
        (0, _globalUtils._global)[0, _globalUtils.GLOBAL_LOGS_API_KEY] = (0, _globalUtils.makeGetter)((0, _globalUtils.API_BACKWARDS_COMPATIBILITY_VERSION), provider, (0, _noopLoggerProvider.NOOP_LOGGER_PROVIDER));
        return provider;
    };
    /**
     * Returns the global logger provider.
     *
     * @returns LoggerProvider
     */ LogsAPI.prototype.getLoggerProvider = function() {
        var _a, _b;
        return (_b = (_a = (0, _globalUtils._global)[0, _globalUtils.GLOBAL_LOGS_API_KEY]) === null || _a === void 0 ? void 0 : _a.call((0, _globalUtils._global), (0, _globalUtils.API_BACKWARDS_COMPATIBILITY_VERSION))) !== null && _b !== void 0 ? _b : (0, _noopLoggerProvider.NOOP_LOGGER_PROVIDER);
    };
    /**
     * Returns a logger from the global logger provider.
     *
     * @returns Logger
     */ LogsAPI.prototype.getLogger = function(name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    };
    /** Remove the global logger provider */ LogsAPI.prototype.disable = function() {
        delete (0, _globalUtils._global)[0, _globalUtils.GLOBAL_LOGS_API_KEY];
    };
    return LogsAPI;
}();

},{"../internal/global-utils":"1UcjY","../NoopLoggerProvider":"ic3O9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1UcjY":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_LOGS_API_KEY", ()=>GLOBAL_LOGS_API_KEY);
parcelHelpers.export(exports, "_global", ()=>_global);
/**
 * Make a function which accepts a version integer and returns the instance of an API if the version
 * is compatible, or a fallback version (usually NOOP) if it is not.
 *
 * @param requiredVersion Backwards compatibility version which is required to return the instance
 * @param instance Instance which should be returned if the required version is compatible
 * @param fallback Fallback instance, usually NOOP, which will be returned if the required version is not compatible
 */ parcelHelpers.export(exports, "makeGetter", ()=>makeGetter);
parcelHelpers.export(exports, "API_BACKWARDS_COMPATIBILITY_VERSION", ()=>API_BACKWARDS_COMPATIBILITY_VERSION);
var _platform = require("../platform");
var GLOBAL_LOGS_API_KEY = Symbol.for("io.opentelemetry.js.api.logs");
var _global = (0, _platform._globalThis);
function makeGetter(requiredVersion, instance, fallback) {
    return function(version) {
        return version === requiredVersion ? instance : fallback;
    };
}
var API_BACKWARDS_COMPATIBILITY_VERSION = 1;

},{"../platform":"9Y3JS","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9Y3JS":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _globalThis = require("./globalThis");
parcelHelpers.exportAll(_globalThis, exports);

},{"./globalThis":"a11nQ","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"a11nQ":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/api and
// @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_globalThis", ()=>_globalThis);
var global = arguments[3];
var _globalThis = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof global === "object" ? global : {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"171Z2":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Enable instrumentations
 * @param instrumentations
 * @param tracerProvider
 * @param meterProvider
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enableInstrumentations", ()=>enableInstrumentations);
/**
 * Disable instrumentations
 * @param instrumentations
 */ parcelHelpers.export(exports, "disableInstrumentations", ()=>disableInstrumentations);
function enableInstrumentations(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for(var i = 0, j = instrumentations.length; i < j; i++){
        var instrumentation = instrumentations[i];
        if (tracerProvider) instrumentation.setTracerProvider(tracerProvider);
        if (meterProvider) instrumentation.setMeterProvider(meterProvider);
        if (loggerProvider && instrumentation.setLoggerProvider) instrumentation.setLoggerProvider(loggerProvider);
        // instrumentations have been already enabled during creation
        // so enable only if user prevented that by setting enabled to false
        // this is to prevent double enabling but when calling register all
        // instrumentations should be now enabled
        if (!instrumentation.getConfig().enabled) instrumentation.enable();
    }
}
function disableInstrumentations(instrumentations) {
    instrumentations.forEach(function(instrumentation) {
        return instrumentation.disable();
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9FAWm":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InstrumentationBase", ()=>(0, _instrumentation.InstrumentationBase));
parcelHelpers.export(exports, "normalize", ()=>(0, _noopNormalize.normalize));
var _instrumentation = require("./instrumentation");
var _noopNormalize = require("./noop-normalize");

},{"./instrumentation":"3tCxM","./noop-normalize":false,"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3tCxM":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InstrumentationBase", ()=>InstrumentationBase);
var _instrumentation = require("../../instrumentation");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Base abstract class for instrumenting web plugins
 */ var InstrumentationBase = /** @class */ function(_super) {
    __extends(InstrumentationBase, _super);
    function InstrumentationBase(instrumentationName, instrumentationVersion, config) {
        var _this = _super.call(this, instrumentationName, instrumentationVersion, config) || this;
        if (_this._config.enabled) _this.enable();
        return _this;
    }
    return InstrumentationBase;
}((0, _instrumentation.InstrumentationAbstract));

},{"../../instrumentation":"6w7B9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6w7B9":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InstrumentationAbstract", ()=>InstrumentationAbstract);
var _api = require("@opentelemetry/api");
var _apiLogs = require("@opentelemetry/api-logs");
var _shimmer = require("shimmer");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Base abstract internal class for instrumenting node and web plugins
 */ var InstrumentationAbstract = /** @class */ function() {
    function InstrumentationAbstract(instrumentationName, instrumentationVersion, config) {
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        /* Api to wrap instrumented method */ this._wrap = _shimmer.wrap;
        /* Api to unwrap instrumented methods */ this._unwrap = _shimmer.unwrap;
        /* Api to mass wrap instrumented method */ this._massWrap = _shimmer.massWrap;
        /* Api to mass unwrap instrumented methods */ this._massUnwrap = _shimmer.massUnwrap;
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = __assign({
            enabled: true
        }, config);
        this._diag = (0, _api.diag).createComponentLogger({
            namespace: instrumentationName
        });
        this._tracer = (0, _api.trace).getTracer(instrumentationName, instrumentationVersion);
        this._meter = (0, _api.metrics).getMeter(instrumentationName, instrumentationVersion);
        this._logger = (0, _apiLogs.logs).getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    Object.defineProperty(InstrumentationAbstract.prototype, "meter", {
        /* Returns meter */ get: function() {
            return this._meter;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets MeterProvider to this plugin
     * @param meterProvider
     */ InstrumentationAbstract.prototype.setMeterProvider = function(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    };
    Object.defineProperty(InstrumentationAbstract.prototype, "logger", {
        /* Returns logger */ get: function() {
            return this._logger;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets LoggerProvider to this plugin
     * @param loggerProvider
     */ InstrumentationAbstract.prototype.setLoggerProvider = function(loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    };
    /**
     * @experimental
     *
     * Get module definitions defined by {@link init}.
     * This can be used for experimental compile-time instrumentation.
     *
     * @returns an array of {@link InstrumentationModuleDefinition}
     */ InstrumentationAbstract.prototype.getModuleDefinitions = function() {
        var _a;
        var initResult = (_a = this.init()) !== null && _a !== void 0 ? _a : [];
        if (!Array.isArray(initResult)) return [
            initResult
        ];
        return initResult;
    };
    /**
     * Sets the new metric instruments with the current Meter.
     */ InstrumentationAbstract.prototype._updateMetricInstruments = function() {
        return;
    };
    /* Returns InstrumentationConfig */ InstrumentationAbstract.prototype.getConfig = function() {
        return this._config;
    };
    /**
     * Sets InstrumentationConfig to this plugin
     * @param InstrumentationConfig
     */ InstrumentationAbstract.prototype.setConfig = function(config) {
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = __assign({}, config);
    };
    /**
     * Sets TraceProvider to this plugin
     * @param tracerProvider
     */ InstrumentationAbstract.prototype.setTracerProvider = function(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    };
    Object.defineProperty(InstrumentationAbstract.prototype, "tracer", {
        /* Returns tracer */ get: function() {
            return this._tracer;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Execute span customization hook, if configured, and log any errors.
     * Any semantics of the trigger and info are defined by the specific instrumentation.
     * @param hookHandler The optional hook handler which the user has configured via instrumentation config
     * @param triggerName The name of the trigger for executing the hook for logging purposes
     * @param span The span to which the hook should be applied
     * @param info The info object to be passed to the hook, with useful data the hook may use
     */ InstrumentationAbstract.prototype._runSpanCustomizationHook = function(hookHandler, triggerName, span, info) {
        if (!hookHandler) return;
        try {
            hookHandler(span, info);
        } catch (e) {
            this._diag.error("Error running span customization hook due to exception in handler", {
                triggerName: triggerName
            }, e);
        }
    };
    return InstrumentationAbstract;
}();

},{"@opentelemetry/api":"4682l","@opentelemetry/api-logs":"77PKS","shimmer":"9Gks5","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"9Gks5":[function(require,module,exports) {
"use strict";
function isFunction(funktion) {
    return typeof funktion === "function";
}
// Default to complaining loudly when things don't go according to plan.
var logger = console.error.bind(console);
// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function defineProperty(obj, name, value) {
    var enumerable = !!obj[name] && obj.propertyIsEnumerable(name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
// Keep initialization idempotent.
function shimmer(options) {
    if (options && options.logger) {
        if (!isFunction(options.logger)) logger("new logger isn't a function, not replacing");
        else logger = options.logger;
    }
}
function wrap(nodule, name, wrapper) {
    if (!nodule || !nodule[name]) {
        logger("no original function " + name + " to wrap");
        return;
    }
    if (!wrapper) {
        logger("no wrapper function");
        logger(new Error().stack);
        return;
    }
    if (!isFunction(nodule[name]) || !isFunction(wrapper)) {
        logger("original object and wrapper must be functions");
        return;
    }
    var original = nodule[name];
    var wrapped = wrapper(original, name);
    defineProperty(wrapped, "__original", original);
    defineProperty(wrapped, "__unwrap", function() {
        if (nodule[name] === wrapped) defineProperty(nodule, name, original);
    });
    defineProperty(wrapped, "__wrapped", true);
    defineProperty(nodule, name, wrapped);
    return wrapped;
}
function massWrap(nodules, names, wrapper) {
    if (!nodules) {
        logger("must provide one or more modules to patch");
        logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        logger("must provide one or more functions to wrap on modules");
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            wrap(nodule, name, wrapper);
        });
    });
}
function unwrap(nodule, name) {
    if (!nodule || !nodule[name]) {
        logger("no function to unwrap.");
        logger(new Error().stack);
        return;
    }
    if (!nodule[name].__unwrap) logger("no original to unwrap to -- has " + name + " already been unwrapped?");
    else return nodule[name].__unwrap();
}
function massUnwrap(nodules, names) {
    if (!nodules) {
        logger("must provide one or more modules to patch");
        logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        logger("must provide one or more functions to unwrap on modules");
        return;
    }
    nodules.forEach(function(nodule) {
        names.forEach(function(name) {
            unwrap(nodule, name);
        });
    });
}
shimmer.wrap = wrap;
shimmer.massWrap = massWrap;
shimmer.unwrap = unwrap;
shimmer.massUnwrap = massUnwrap;
module.exports = shimmer;

},{}],"1fYwY":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * function to execute patched function and being able to catch errors
 * @param execute - function to be executed
 * @param onFinish - callback to run when execute finishes
 */ parcelHelpers.export(exports, "safeExecuteInTheMiddle", ()=>safeExecuteInTheMiddle);
/**
 * Async function to execute patched function and being able to catch errors
 * @param execute - function to be executed
 * @param onFinish - callback to run when execute finishes
 */ parcelHelpers.export(exports, "safeExecuteInTheMiddleAsync", ()=>safeExecuteInTheMiddleAsync);
/**
 * Checks if certain function has been already wrapped
 * @param func
 */ parcelHelpers.export(exports, "isWrapped", ()=>isWrapped);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function safeExecuteInTheMiddle(execute, onFinish, preventThrowingError) {
    var error;
    var result;
    try {
        result = execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
function safeExecuteInTheMiddleAsync(execute, onFinish, preventThrowingError) {
    return __awaiter(this, void 0, void 0, function() {
        var error, result, e_1;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        3,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        execute()
                    ];
                case 1:
                    result = _a.sent();
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    e_1 = _a.sent();
                    error = e_1;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 3:
                    onFinish(error, result);
                    if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
                    throw error;
                    // eslint-disable-next-line no-unsafe-finally
                    return [
                        2 /*return*/ ,
                        result
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function isWrapped(func) {
    return typeof func === "function" && typeof func.__original === "function" && typeof func.__unwrap === "function" && func.__wrapped === true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"2wiMH":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetch = require("./fetch");
parcelHelpers.exportAll(_fetch, exports);

},{"./fetch":"1FaSg","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1FaSg":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchInstrumentation", ()=>FetchInstrumentation);
var _api = require("@opentelemetry/api");
var _instrumentation = require("@opentelemetry/instrumentation");
var _core = require("@opentelemetry/core");
var _sdkTraceWeb = require("@opentelemetry/sdk-trace-web");
var _attributeNames = require("./enums/AttributeNames");
var _semanticConventions = require("@opentelemetry/semantic-conventions");
var _version = require("./version");
var process = require("ec4383a7c1392e8d");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var _a;
// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
var OBSERVER_WAIT_TIME_MS = 300;
var isNode = typeof process === "object" && ((_a = process.release) === null || _a === void 0 ? void 0 : _a.name) === "node";
/**
 * This class represents a fetch plugin for auto instrumentation
 */ var FetchInstrumentation = /** @class */ function(_super) {
    __extends(FetchInstrumentation, _super);
    function FetchInstrumentation(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, "@opentelemetry/instrumentation-fetch", (0, _version.VERSION), config) || this;
        _this.component = "fetch";
        _this.version = (0, _version.VERSION);
        _this.moduleName = _this.component;
        _this._usedResources = new WeakSet();
        _this._tasksCount = 0;
        return _this;
    }
    FetchInstrumentation.prototype.init = function() {};
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     */ FetchInstrumentation.prototype._addChildSpan = function(span, corsPreFlightRequest) {
        var childSpan = this.tracer.startSpan("CORS Preflight", {
            startTime: corsPreFlightRequest[_sdkTraceWeb.PerformanceTimingNames.FETCH_START]
        }, _api.trace.setSpan(_api.context.active(), span));
        if (!this.getConfig().ignoreNetworkEvents) _sdkTraceWeb.addSpanNetworkEvents(childSpan, corsPreFlightRequest);
        childSpan.end(corsPreFlightRequest[_sdkTraceWeb.PerformanceTimingNames.RESPONSE_END]);
    };
    /**
     * Adds more attributes to span just before ending it
     * @param span
     * @param response
     */ FetchInstrumentation.prototype._addFinalSpanAttributes = function(span, response) {
        var parsedUrl = _sdkTraceWeb.parseUrl(response.url);
        span.setAttribute((0, _semanticConventions.SemanticAttributes).HTTP_STATUS_CODE, response.status);
        if (response.statusText != null) span.setAttribute((0, _attributeNames.AttributeNames).HTTP_STATUS_TEXT, response.statusText);
        span.setAttribute((0, _semanticConventions.SemanticAttributes).HTTP_HOST, parsedUrl.host);
        span.setAttribute((0, _semanticConventions.SemanticAttributes).HTTP_SCHEME, parsedUrl.protocol.replace(":", ""));
        if (typeof navigator !== "undefined") span.setAttribute((0, _semanticConventions.SemanticAttributes).HTTP_USER_AGENT, navigator.userAgent);
    };
    /**
     * Add headers
     * @param options
     * @param spanUrl
     */ FetchInstrumentation.prototype._addHeaders = function(options, spanUrl) {
        if (!_sdkTraceWeb.shouldPropagateTraceHeaders(spanUrl, this.getConfig().propagateTraceHeaderCorsUrls)) {
            var headers = {};
            _api.propagation.inject(_api.context.active(), headers);
            if (Object.keys(headers).length > 0) this._diag.debug("headers inject skipped due to CORS policy");
            return;
        }
        if (options instanceof Request) _api.propagation.inject(_api.context.active(), options.headers, {
            set: function(h, k, v) {
                return h.set(k, typeof v === "string" ? v : String(v));
            }
        });
        else if (options.headers instanceof Headers) _api.propagation.inject(_api.context.active(), options.headers, {
            set: function(h, k, v) {
                return h.set(k, typeof v === "string" ? v : String(v));
            }
        });
        else if (options.headers instanceof Map) _api.propagation.inject(_api.context.active(), options.headers, {
            set: function(h, k, v) {
                return h.set(k, typeof v === "string" ? v : String(v));
            }
        });
        else {
            var headers = {};
            _api.propagation.inject(_api.context.active(), headers);
            options.headers = Object.assign({}, headers, options.headers || {});
        }
    };
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link FetchPluginConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */ FetchInstrumentation.prototype._clearResources = function() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            performance.clearResourceTimings();
            this._usedResources = new WeakSet();
        }
    };
    /**
     * Creates a new span
     * @param url
     * @param options
     */ FetchInstrumentation.prototype._createSpan = function(url, options) {
        var _a;
        if (options === void 0) options = {};
        if (_core.isUrlIgnored(url, this.getConfig().ignoreUrls)) {
            this._diag.debug("ignoring span as url matches ignored url");
            return;
        }
        var method = (options.method || "GET").toUpperCase();
        var spanName = "HTTP " + method;
        return this.tracer.startSpan(spanName, {
            kind: _api.SpanKind.CLIENT,
            attributes: (_a = {}, _a[(0, _attributeNames.AttributeNames).COMPONENT] = this.moduleName, _a[(0, _semanticConventions.SemanticAttributes).HTTP_METHOD] = method, _a[(0, _semanticConventions.SemanticAttributes).HTTP_URL] = url, _a)
        });
    };
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     * @param resourcesObserver
     * @param endTime
     */ FetchInstrumentation.prototype._findResourceAndAddNetworkEvents = function(span, resourcesObserver, endTime) {
        var resources = resourcesObserver.entries;
        if (!resources.length) {
            if (!performance.getEntriesByType) return;
            // fallback - either Observer is not available or it took longer
            // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
            // information
            resources = performance.getEntriesByType("resource");
        }
        var resource = _sdkTraceWeb.getResource(resourcesObserver.spanUrl, resourcesObserver.startTime, endTime, resources, this._usedResources, "fetch");
        if (resource.mainRequest) {
            var mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            var corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            if (!this.getConfig().ignoreNetworkEvents) _sdkTraceWeb.addSpanNetworkEvents(span, mainRequest);
        }
    };
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     */ FetchInstrumentation.prototype._markResourceAsUsed = function(resource) {
        this._usedResources.add(resource);
    };
    /**
     * Finish span, add attributes, network events etc.
     * @param span
     * @param spanData
     * @param response
     */ FetchInstrumentation.prototype._endSpan = function(span, spanData, response) {
        var _this = this;
        var endTime = _core.millisToHrTime(Date.now());
        var performanceEndTime = _core.hrTime();
        this._addFinalSpanAttributes(span, response);
        setTimeout(function() {
            var _a;
            (_a = spanData.observer) === null || _a === void 0 || _a.disconnect();
            _this._findResourceAndAddNetworkEvents(span, spanData, performanceEndTime);
            _this._tasksCount--;
            _this._clearResources();
            span.end(endTime);
        }, OBSERVER_WAIT_TIME_MS);
    };
    /**
     * Patches the constructor of fetch
     */ FetchInstrumentation.prototype._patchConstructor = function() {
        var _this = this;
        return function(original) {
            var plugin = _this;
            return function patchConstructor() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var self = this;
                var url = _sdkTraceWeb.parseUrl(args[0] instanceof Request ? args[0].url : String(args[0])).href;
                var options = args[0] instanceof Request ? args[0] : args[1] || {};
                var createdSpan = plugin._createSpan(url, options);
                if (!createdSpan) return original.apply(this, args);
                var spanData = plugin._prepareSpanData(url);
                function endSpanOnError(span, error) {
                    plugin._applyAttributesAfterFetch(span, options, error);
                    plugin._endSpan(span, spanData, {
                        status: error.status || 0,
                        statusText: error.message,
                        url: url
                    });
                }
                function endSpanOnSuccess(span, response) {
                    plugin._applyAttributesAfterFetch(span, options, response);
                    if (response.status >= 200 && response.status < 400) plugin._endSpan(span, spanData, response);
                    else plugin._endSpan(span, spanData, {
                        status: response.status,
                        statusText: response.statusText,
                        url: url
                    });
                }
                function onSuccess(span, resolve, response) {
                    try {
                        var resClone = response.clone();
                        var resClone4Hook_1 = response.clone();
                        var body = resClone.body;
                        if (body) {
                            var reader_1 = body.getReader();
                            var read_1 = function() {
                                reader_1.read().then(function(_a) {
                                    var done = _a.done;
                                    if (done) endSpanOnSuccess(span, resClone4Hook_1);
                                    else read_1();
                                }, function(error) {
                                    endSpanOnError(span, error);
                                });
                            };
                            read_1();
                        } else // some older browsers don't have .body implemented
                        endSpanOnSuccess(span, response);
                    } finally{
                        resolve(response);
                    }
                }
                function onError(span, reject, error) {
                    try {
                        endSpanOnError(span, error);
                    } finally{
                        reject(error);
                    }
                }
                return new Promise(function(resolve, reject) {
                    return _api.context.with(_api.trace.setSpan(_api.context.active(), createdSpan), function() {
                        plugin._addHeaders(options, url);
                        plugin._tasksCount++;
                        // TypeScript complains about arrow function captured a this typed as globalThis
                        // ts(7041)
                        return original.apply(self, options instanceof Request ? [
                            options
                        ] : [
                            url,
                            options
                        ]).then(onSuccess.bind(self, createdSpan, resolve), onError.bind(self, createdSpan, reject));
                    });
                });
            };
        };
    };
    FetchInstrumentation.prototype._applyAttributesAfterFetch = function(span, request, result) {
        var _this = this;
        var applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (applyCustomAttributesOnSpan) (0, _instrumentation.safeExecuteInTheMiddle)(function() {
            return applyCustomAttributesOnSpan(span, request, result);
        }, function(error) {
            if (!error) return;
            _this._diag.error("applyCustomAttributesOnSpan", error);
        }, true);
    };
    /**
     * Prepares a span data - needed later for matching appropriate network
     *     resources
     * @param spanUrl
     */ FetchInstrumentation.prototype._prepareSpanData = function(spanUrl) {
        var startTime = _core.hrTime();
        var entries = [];
        if (typeof PerformanceObserver !== "function") return {
            entries: entries,
            startTime: startTime,
            spanUrl: spanUrl
        };
        var observer = new PerformanceObserver(function(list) {
            var perfObsEntries = list.getEntries();
            perfObsEntries.forEach(function(entry) {
                if (entry.initiatorType === "fetch" && entry.name === spanUrl) entries.push(entry);
            });
        });
        observer.observe({
            entryTypes: [
                "resource"
            ]
        });
        return {
            entries: entries,
            observer: observer,
            startTime: startTime,
            spanUrl: spanUrl
        };
    };
    /**
     * implements enable function
     */ FetchInstrumentation.prototype.enable = function() {
        if (isNode) {
            // Node.js v18+ *does* have a global `fetch()`, but this package does not
            // support instrumenting it.
            this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
            return;
        }
        if ((0, _instrumentation.isWrapped)(fetch)) {
            this._unwrap((0, _core._globalThis), "fetch");
            this._diag.debug("removing previous patch for constructor");
        }
        this._wrap((0, _core._globalThis), "fetch", this._patchConstructor());
    };
    /**
     * implements unpatch function
     */ FetchInstrumentation.prototype.disable = function() {
        if (isNode) return;
        this._unwrap((0, _core._globalThis), "fetch");
        this._usedResources = new WeakSet();
    };
    return FetchInstrumentation;
}((0, _instrumentation.InstrumentationBase));

},{"ec4383a7c1392e8d":"h0XoY","@opentelemetry/api":"4682l","@opentelemetry/instrumentation":"7NsZS","@opentelemetry/core":"6xVk8","@opentelemetry/sdk-trace-web":"c1wmU","./enums/AttributeNames":"k48pf","@opentelemetry/semantic-conventions":"1OyVc","./version":"1UKt9","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"k48pf":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AttributeNames", ()=>AttributeNames);
var AttributeNames;
(function(AttributeNames) {
    AttributeNames["COMPONENT"] = "component";
    AttributeNames["HTTP_ERROR_NAME"] = "http.error_name";
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})(AttributeNames || (AttributeNames = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"1UKt9":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
var VERSION = "0.52.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"759Vk":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _xhr = require("./xhr");
parcelHelpers.exportAll(_xhr, exports);

},{"./xhr":"15hEp","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"15hEp":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XMLHttpRequestInstrumentation", ()=>XMLHttpRequestInstrumentation);
var _api = require("@opentelemetry/api");
var _instrumentation = require("@opentelemetry/instrumentation");
var _core = require("@opentelemetry/core");
var _semanticConventions = require("@opentelemetry/semantic-conventions");
var _sdkTraceWeb = require("@opentelemetry/sdk-trace-web");
var _eventNames = require("./enums/EventNames");
var _version = require("./version");
var _attributeNames = require("./enums/AttributeNames");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
var OBSERVER_WAIT_TIME_MS = 300;
/**
 * This class represents a XMLHttpRequest plugin for auto instrumentation
 */ var XMLHttpRequestInstrumentation = /** @class */ function(_super) {
    __extends(XMLHttpRequestInstrumentation, _super);
    function XMLHttpRequestInstrumentation(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, "@opentelemetry/instrumentation-xml-http-request", (0, _version.VERSION), config) || this;
        _this.component = "xml-http-request";
        _this.version = (0, _version.VERSION);
        _this.moduleName = _this.component;
        _this._tasksCount = 0;
        _this._xhrMem = new WeakMap();
        _this._usedResources = new WeakSet();
        return _this;
    }
    XMLHttpRequestInstrumentation.prototype.init = function() {};
    /**
     * Adds custom headers to XMLHttpRequest
     * @param xhr
     * @param spanUrl
     * @private
     */ XMLHttpRequestInstrumentation.prototype._addHeaders = function(xhr, spanUrl) {
        var url = (0, _sdkTraceWeb.parseUrl)(spanUrl).href;
        if (!(0, _sdkTraceWeb.shouldPropagateTraceHeaders)(url, this.getConfig().propagateTraceHeaderCorsUrls)) {
            var headers_1 = {};
            _api.propagation.inject(_api.context.active(), headers_1);
            if (Object.keys(headers_1).length > 0) this._diag.debug("headers inject skipped due to CORS policy");
            return;
        }
        var headers = {};
        _api.propagation.inject(_api.context.active(), headers);
        Object.keys(headers).forEach(function(key) {
            xhr.setRequestHeader(key, String(headers[key]));
        });
    };
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     * @private
     */ XMLHttpRequestInstrumentation.prototype._addChildSpan = function(span, corsPreFlightRequest) {
        var _this = this;
        _api.context.with(_api.trace.setSpan(_api.context.active(), span), function() {
            var childSpan = _this.tracer.startSpan("CORS Preflight", {
                startTime: corsPreFlightRequest[(0, _sdkTraceWeb.PerformanceTimingNames).FETCH_START]
            });
            if (!_this.getConfig().ignoreNetworkEvents) (0, _sdkTraceWeb.addSpanNetworkEvents)(childSpan, corsPreFlightRequest);
            childSpan.end(corsPreFlightRequest[(0, _sdkTraceWeb.PerformanceTimingNames).RESPONSE_END]);
        });
    };
    /**
     * Add attributes when span is going to end
     * @param span
     * @param xhr
     * @param spanUrl
     * @private
     */ XMLHttpRequestInstrumentation.prototype._addFinalSpanAttributes = function(span, xhrMem, spanUrl) {
        if (typeof spanUrl === "string") {
            var parsedUrl = (0, _sdkTraceWeb.parseUrl)(spanUrl);
            if (xhrMem.status !== undefined) span.setAttribute((0, _semanticConventions.SEMATTRS_HTTP_STATUS_CODE), xhrMem.status);
            if (xhrMem.statusText !== undefined) span.setAttribute((0, _attributeNames.AttributeNames).HTTP_STATUS_TEXT, xhrMem.statusText);
            span.setAttribute((0, _semanticConventions.SEMATTRS_HTTP_HOST), parsedUrl.host);
            span.setAttribute((0, _semanticConventions.SEMATTRS_HTTP_SCHEME), parsedUrl.protocol.replace(":", ""));
            // @TODO do we want to collect this or it will be collected earlier once only or
            //    maybe when parent span is not available ?
            span.setAttribute((0, _semanticConventions.SEMATTRS_HTTP_USER_AGENT), navigator.userAgent);
        }
    };
    XMLHttpRequestInstrumentation.prototype._applyAttributesAfterXHR = function(span, xhr) {
        var _this = this;
        var applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (typeof applyCustomAttributesOnSpan === "function") (0, _instrumentation.safeExecuteInTheMiddle)(function() {
            return applyCustomAttributesOnSpan(span, xhr);
        }, function(error) {
            if (!error) return;
            _this._diag.error("applyCustomAttributesOnSpan", error);
        }, true);
    };
    /**
     * will collect information about all resources created
     * between "send" and "end" with additional waiting for main resource
     * @param xhr
     * @param spanUrl
     * @private
     */ XMLHttpRequestInstrumentation.prototype._addResourceObserver = function(xhr, spanUrl) {
        var xhrMem = this._xhrMem.get(xhr);
        if (!xhrMem || typeof PerformanceObserver !== "function" || typeof PerformanceResourceTiming !== "function") return;
        xhrMem.createdResources = {
            observer: new PerformanceObserver(function(list) {
                var entries = list.getEntries();
                var parsedUrl = (0, _sdkTraceWeb.parseUrl)(spanUrl);
                entries.forEach(function(entry) {
                    if (entry.initiatorType === "xmlhttprequest" && entry.name === parsedUrl.href) {
                        if (xhrMem.createdResources) xhrMem.createdResources.entries.push(entry);
                    }
                });
            }),
            entries: []
        };
        xhrMem.createdResources.observer.observe({
            entryTypes: [
                "resource"
            ]
        });
    };
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link XMLHttpRequestInstrumentationConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */ XMLHttpRequestInstrumentation.prototype._clearResources = function() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            (0, _core.otperformance).clearResourceTimings();
            this._xhrMem = new WeakMap();
            this._usedResources = new WeakSet();
        }
    };
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     */ XMLHttpRequestInstrumentation.prototype._findResourceAndAddNetworkEvents = function(xhrMem, span, spanUrl, startTime, endTime) {
        if (!spanUrl || !startTime || !endTime || !xhrMem.createdResources) return;
        var resources = xhrMem.createdResources.entries;
        if (!resources || !resources.length) // fallback - either Observer is not available or it took longer
        // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
        // information
        // ts thinks this is the perf_hooks module, but it is the browser performance api
        resources = (0, _core.otperformance).getEntriesByType("resource");
        var resource = (0, _sdkTraceWeb.getResource)((0, _sdkTraceWeb.parseUrl)(spanUrl).href, startTime, endTime, resources, this._usedResources);
        if (resource.mainRequest) {
            var mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            var corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            if (!this.getConfig().ignoreNetworkEvents) (0, _sdkTraceWeb.addSpanNetworkEvents)(span, mainRequest);
        }
    };
    /**
     * Removes the previous information about span.
     * This might happened when the same xhr is used again.
     * @param xhr
     * @private
     */ XMLHttpRequestInstrumentation.prototype._cleanPreviousSpanInformation = function(xhr) {
        var xhrMem = this._xhrMem.get(xhr);
        if (xhrMem) {
            var callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (callbackToRemoveEvents) callbackToRemoveEvents();
            this._xhrMem.delete(xhr);
        }
    };
    /**
     * Creates a new span when method "open" is called
     * @param xhr
     * @param url
     * @param method
     * @private
     */ XMLHttpRequestInstrumentation.prototype._createSpan = function(xhr, url, method) {
        var _a;
        if ((0, _core.isUrlIgnored)(url, this.getConfig().ignoreUrls)) {
            this._diag.debug("ignoring span as url matches ignored url");
            return;
        }
        var spanName = method.toUpperCase();
        var currentSpan = this.tracer.startSpan(spanName, {
            kind: _api.SpanKind.CLIENT,
            attributes: (_a = {}, _a[0, _semanticConventions.SEMATTRS_HTTP_METHOD] = method, _a[0, _semanticConventions.SEMATTRS_HTTP_URL] = (0, _sdkTraceWeb.parseUrl)(url).toString(), _a)
        });
        currentSpan.addEvent((0, _eventNames.EventNames).METHOD_OPEN);
        this._cleanPreviousSpanInformation(xhr);
        this._xhrMem.set(xhr, {
            span: currentSpan,
            spanUrl: url
        });
        return currentSpan;
    };
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     * @private
     */ XMLHttpRequestInstrumentation.prototype._markResourceAsUsed = function(resource) {
        this._usedResources.add(resource);
    };
    /**
     * Patches the method open
     * @private
     */ XMLHttpRequestInstrumentation.prototype._patchOpen = function() {
        var _this = this;
        return function(original) {
            var plugin = _this;
            return function patchOpen() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var method = args[0];
                var url = args[1];
                plugin._createSpan(this, url, method);
                return original.apply(this, args);
            };
        };
    };
    /**
     * Patches the method send
     * @private
     */ XMLHttpRequestInstrumentation.prototype._patchSend = function() {
        var plugin = this;
        function endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime) {
            var callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (typeof callbackToRemoveEvents === "function") callbackToRemoveEvents();
            var span = xhrMem.span, spanUrl = xhrMem.spanUrl, sendStartTime = xhrMem.sendStartTime;
            if (span) {
                plugin._findResourceAndAddNetworkEvents(xhrMem, span, spanUrl, sendStartTime, performanceEndTime);
                span.addEvent(eventName, endTime);
                plugin._addFinalSpanAttributes(span, xhrMem, spanUrl);
                span.end(endTime);
                plugin._tasksCount--;
            }
            plugin._clearResources();
        }
        function endSpan(eventName, xhr) {
            var xhrMem = plugin._xhrMem.get(xhr);
            if (!xhrMem) return;
            xhrMem.status = xhr.status;
            xhrMem.statusText = xhr.statusText;
            plugin._xhrMem.delete(xhr);
            if (xhrMem.span) plugin._applyAttributesAfterXHR(xhrMem.span, xhr);
            var performanceEndTime = (0, _core.hrTime)();
            var endTime = Date.now();
            // the timeout is needed as observer doesn't have yet information
            // when event "load" is called. Also the time may differ depends on
            // browser and speed of computer
            setTimeout(function() {
                endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime);
            }, OBSERVER_WAIT_TIME_MS);
        }
        function onError() {
            endSpan((0, _eventNames.EventNames).EVENT_ERROR, this);
        }
        function onAbort() {
            endSpan((0, _eventNames.EventNames).EVENT_ABORT, this);
        }
        function onTimeout() {
            endSpan((0, _eventNames.EventNames).EVENT_TIMEOUT, this);
        }
        function onLoad() {
            if (this.status < 299) endSpan((0, _eventNames.EventNames).EVENT_LOAD, this);
            else endSpan((0, _eventNames.EventNames).EVENT_ERROR, this);
        }
        function unregister(xhr) {
            xhr.removeEventListener("abort", onAbort);
            xhr.removeEventListener("error", onError);
            xhr.removeEventListener("load", onLoad);
            xhr.removeEventListener("timeout", onTimeout);
            var xhrMem = plugin._xhrMem.get(xhr);
            if (xhrMem) xhrMem.callbackToRemoveEvents = undefined;
        }
        return function(original) {
            return function patchSend() {
                var _this = this;
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var xhrMem = plugin._xhrMem.get(this);
                if (!xhrMem) return original.apply(this, args);
                var currentSpan = xhrMem.span;
                var spanUrl = xhrMem.spanUrl;
                if (currentSpan && spanUrl) _api.context.with(_api.trace.setSpan(_api.context.active(), currentSpan), function() {
                    plugin._tasksCount++;
                    xhrMem.sendStartTime = (0, _core.hrTime)();
                    currentSpan.addEvent((0, _eventNames.EventNames).METHOD_SEND);
                    _this.addEventListener("abort", onAbort);
                    _this.addEventListener("error", onError);
                    _this.addEventListener("load", onLoad);
                    _this.addEventListener("timeout", onTimeout);
                    xhrMem.callbackToRemoveEvents = function() {
                        unregister(_this);
                        if (xhrMem.createdResources) xhrMem.createdResources.observer.disconnect();
                    };
                    plugin._addHeaders(_this, spanUrl);
                    plugin._addResourceObserver(_this, spanUrl);
                });
                return original.apply(this, args);
            };
        };
    };
    /**
     * implements enable function
     */ XMLHttpRequestInstrumentation.prototype.enable = function() {
        this._diag.debug("applying patch to", this.moduleName, this.version);
        if ((0, _instrumentation.isWrapped)(XMLHttpRequest.prototype.open)) {
            this._unwrap(XMLHttpRequest.prototype, "open");
            this._diag.debug("removing previous patch from method open");
        }
        if ((0, _instrumentation.isWrapped)(XMLHttpRequest.prototype.send)) {
            this._unwrap(XMLHttpRequest.prototype, "send");
            this._diag.debug("removing previous patch from method send");
        }
        this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen());
        this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    };
    /**
     * implements disable function
     */ XMLHttpRequestInstrumentation.prototype.disable = function() {
        this._diag.debug("removing patch from", this.moduleName, this.version);
        this._unwrap(XMLHttpRequest.prototype, "open");
        this._unwrap(XMLHttpRequest.prototype, "send");
        this._tasksCount = 0;
        this._xhrMem = new WeakMap();
        this._usedResources = new WeakSet();
    };
    return XMLHttpRequestInstrumentation;
}((0, _instrumentation.InstrumentationBase));

},{"@opentelemetry/api":"4682l","@opentelemetry/instrumentation":"7NsZS","@opentelemetry/core":"6xVk8","@opentelemetry/semantic-conventions":"1OyVc","@opentelemetry/sdk-trace-web":"c1wmU","./enums/EventNames":"3EhER","./version":"6tmgo","./enums/AttributeNames":"etchn","@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"3EhER":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EventNames", ()=>EventNames);
var EventNames;
(function(EventNames) {
    EventNames["METHOD_OPEN"] = "open";
    EventNames["METHOD_SEND"] = "send";
    EventNames["EVENT_ABORT"] = "abort";
    EventNames["EVENT_ERROR"] = "error";
    EventNames["EVENT_LOAD"] = "loaded";
    EventNames["EVENT_TIMEOUT"] = "timeout";
})(EventNames || (EventNames = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"6tmgo":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
var VERSION = "0.52.0";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"etchn":[function(require,module,exports) {
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AttributeNames", ()=>AttributeNames);
var AttributeNames;
(function(AttributeNames) {
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})(AttributeNames || (AttributeNames = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"f99mC"}],"78RhV":[function(require,module,exports) {
module.exports = JSON.parse('{"airbrakeProjectId":"472774","airbrakeProjectKey":"d5447d911589519dc7d2b85340e622d0","environment":"local","posApiUrl":"http://localhost:5050/api/v2","configThemesEndpoint":"http://localhost:8080/themes","configMetaEndpoint":"http://localhost:8080/metadata","oidc":{"issuer":"https://auth.dev.cityba.se/oauth2/default","clientId":"0oapll2ui0cBoEx7e1d7","scopes":["openid","profile","email","groups","offline_access"],"redirectUri":"/login/callback","pkce":true,"disableHttpsCheck":false,"responseMode":"query","responseType":["token","id_token"]},"launchDarkly":{"clientSideID":"64c9242c67de691386343496"}}');

},{}]},["5PPdg"], "5PPdg", "parcelRequirea7ac")

//# sourceMappingURL=index.2890258b.js.map
